/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1084);
	__webpack_require__(1256);
	__webpack_require__(841);
	module.exports = __webpack_require__(703);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(2122);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 2 */
[2409, 1906],
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(25);
	var core = __webpack_require__(85);
	var hide = __webpack_require__(65);
	var redefine = __webpack_require__(66);
	var ctx = __webpack_require__(86);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * lodash <https://lodash.com/>
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.15.0';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for function metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256,
	      FLIP_FLAG = 512;
	
	  /** Used to compose bitmasks for comparison styles. */
	  var UNORDERED_COMPARE_FLAG = 1,
	      PARTIAL_COMPARE_FLAG = 2;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', ARY_FLAG],
	    ['bind', BIND_FLAG],
	    ['bindKey', BIND_KEY_FLAG],
	    ['curry', CURRY_FLAG],
	    ['curryRight', CURRY_RIGHT_FLAG],
	    ['flip', FLIP_FLAG],
	    ['partial', PARTIAL_FLAG],
	    ['partialRight', PARTIAL_RIGHT_FLAG],
	    ['rearg', REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      reLeadingDot = /^\./,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0x/i;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	      rsComboSymbolsRange = '\\u20d0-\\u20f0',
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
	    rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
	    rsUpper + '+' + rsOptUpperContr,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 'ss'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      return freeProcess && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `map.set` because it's not chainable in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    // Don't return `set.add` because it's not chainable in IE 11.
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array ? array.length : 0;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array ? array.length : 0,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array ? array.length : 0;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array ? array.length : 0,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array ? array.length : 0;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return baseFindIndex(array, baseIsNaN, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array ? array.length : 0;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a cache value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        result++;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Checks if `value` is a host object in IE < 9.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	   */
	  function isHostObject(value) {
	    // Many host objects are `Object` objects that can coerce to strings
	    // despite having improperly defined `toString` methods.
	    var result = false;
	    if (value != null && typeof value.toString != 'function') {
	      try {
	        result = !!(value + '');
	      } catch (e) {}
	    }
	    return result;
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      result++;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Use `context` to stub `Date#getTime` use in `_.now`.
	   * var stubbed = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': stubGetTime };
	   *   }
	   * });
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objectToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        iteratorSymbol = Symbol ? Symbol.iterator : undefined,
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /* Used to set `toString` methods. */
	    var defineProperty = (function() {
	      var func = getNative(Object, 'defineProperty'),
	          name = getNative.name;
	
	      return (name && name.length > 2) ? func : undefined;
	    }());
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
	    var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array of at least `200` elements
	     * and any iteratees accept only one argument. The heuristic for whether a
	     * section qualifies for shortcut fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || arrLength < LARGE_ARRAY_SIZE ||
	          (arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries ? entries.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      return this.has(key) && delete this.__data__[key];
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries ? entries.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries ? entries.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      return getMapData(this, key)['delete'](key);
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      getMapData(this, key).set(key, value);
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values ? values.length : 0;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      this.__data__ = new ListCache(entries);
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      return this.__data__['delete'](key);
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var cache = this.__data__;
	      if (cache instanceof ListCache) {
	        var pairs = cache.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          return this;
	        }
	        cache = this.__data__ = new MapCache(pairs);
	      }
	      cache.set(key, value);
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	      // Safari 9 makes `arguments.length` enumerable in strict mode.
	      var result = (isArray(value) || isArguments(value))
	        ? baseTimes(value.length, String)
	        : [];
	
	      var length = result.length,
	          skipIndexes = !!length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function assignInDefaults(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (typeof key == 'number' && value === undefined && !(key in object))) {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths of elements to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          isNil = object == null,
	          length = paths.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = isNil ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {boolean} [isFull] Specify a clone including symbols.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          if (isHostObject(value)) {
	            return object ? value : {};
	          }
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, baseClone, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (!isArr) {
	        var props = isFull ? getAllKeys(value) : keys(value);
	      }
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    function baseCreate(proto) {
	      return isObject(proto) ? objectCreate(proto) : {};
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      return objectToString.call(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      if (!isKey(path, object)) {
	        path = castPath(path);
	        object = parent(object, path);
	        path = last(path);
	      }
	      var func = object == null ? object : object[toKey(path)];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && objectToString.call(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && objectToString.call(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {boolean} [bitmask] The bitmask of comparison flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - Unordered comparison
	     *     2 - Partial comparison
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, bitmask, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = getTag(object);
	        objTag = objTag == argsTag ? objectTag : objTag;
	      }
	      if (!othIsArr) {
	        othTag = getTag(other);
	        othTag = othTag == argsTag ? objectTag : othTag;
	      }
	      var objIsObj = objTag == objectTag && !isHostObject(object),
	          othIsObj = othTag == objectTag && !isHostObject(other),
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	          : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	      }
	      if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObject(value) && objectToString.call(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      if (!(isArray(source) || isTypedArray(source))) {
	        var props = baseKeysIn(source);
	      }
	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      });
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        newValue = srcValue;
	        if (isArray(srcValue) || isTypedArray(srcValue)) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else {
	            isCommon = false;
	            newValue = baseClone(srcValue, true);
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            isCommon = false;
	            newValue = baseClone(srcValue, true);
	          }
	          else {
	            newValue = objValue;
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property identifiers to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, props) {
	      object = Object(object);
	      return basePickBy(object, props, function(value, key) {
	        return key in object;
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property identifiers to pick from.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, props, predicate) {
	      var index = -1,
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key];
	
	        if (predicate(value, key)) {
	          result[key] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          }
	          else if (!isKey(index, array)) {
	            var path = castPath(index),
	                object = parent(array, path);
	
	            if (object != null) {
	              delete object[toKey(last(path))];
	            }
	          }
	          else {
	            delete array[toKey(index)];
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = array;
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = isKey(path, object) ? [path] : castPath(path);
	      object = parent(object, path);
	
	      var key = toKey(last(path));
	      return !(object != null && hasOwnProperty.call(object, key)) || delete object[key];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var index = -1,
	          length = arrays.length;
	
	      while (++index < length) {
	        var result = result
	          ? arrayPush(
	              baseDifference(result, arrays[index], iteratee, comparator),
	              baseDifference(arrays[index], result, iteratee, comparator)
	            )
	          : arrays[index];
	      }
	      return (result && result.length) ? baseUniq(result, iteratee, comparator) : [];
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value) {
	      return isArray(value) ? value : stringToPath(value);
	    }
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var result = new buffer.constructor(buffer.length);
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	      return arrayReduce(array, addMapEntry, new map.constructor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	      return arrayReduce(array, addSetEntry, new set.constructor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        assignValue(object, key, newValue === undefined ? source[key] : newValue);
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbol properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return baseRest(function(funcs) {
	        funcs = baseFlatten(funcs, 1);
	
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 &&
	              isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
	          isFlip = bitmask & FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return baseRest(function(iteratees) {
	        iteratees = (iteratees.length == 1 && isArray(iteratees[0]))
	          ? arrayMap(iteratees[0], baseUnary(getIteratee()))
	          : arrayMap(baseFlatten(iteratees, 1), baseUnary(getIteratee()));
	
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	      if (!(bitmask & CURRY_BOUND_FLAG)) {
	        bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     *   512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] == null
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!seen.has(othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	                  return seen.add(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, customizer, bitmask, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= UNORDERED_COMPARE_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	          objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbol properties of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
	
	    /**
	     * Creates an array of the own and inherited enumerable symbol properties
	     * of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11,
	    // for data views in Edge < 14, and promises in Node.js.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = objectToString.call(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : undefined;
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var result,
	          index = -1,
	          length = path.length;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result) {
	        return result;
	      }
	      var length = object ? object.length : 0;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, cloneFunc, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object, isDeep, cloneFunc);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object, isDeep, cloneFunc);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length,
	          lastIndex = length - 1;
	
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return !!length &&
	        (typeof value == 'number' || reIsUint.test(value)) &&
	        (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (BIND_FLAG | BIND_KEY_FLAG | ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == ARY_FLAG) && (bitmask == CURRY_FLAG)) ||
	        ((srcBitmask == ARY_FLAG) && (bitmask == REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (ARY_FLAG | REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & BIND_FLAG ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function mergeDefaults(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, mergeDefaults, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;
	
	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    var setWrapToString = !defineProperty ? identity : function(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return defineProperty(wrapper, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)))
	      });
	    };
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoize(function(string) {
	      string = toString(string);
	
	      var result = [];
	      if (reLeadingDot.test(string)) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to process.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array ? array.length : 0;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length,
	          args = Array(length ? length - 1 : 0),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return length
	        ? arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1))
	        : [];
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order of result values is determined by the
	     * order they occur in the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. Result values are chosen from the first array.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. Result values
	     * are chosen from the first array. The comparator is invoked with two arguments:
	     * (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs ? pairs.length : 0,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array ? array.length : 0;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order of result values is determined by the
	     * order they occur in the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. Result values are chosen from the first array.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. Result values are chosen
	     * from the first array. The comparator is invoked with two arguments:
	     * (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (comparator === last(mapped)) {
	        comparator = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array ? nativeJoin.call(array, separator) : '';
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = (
	          index < 0
	            ? nativeMax(length + index, 0)
	            : nativeMin(index, length - 1)
	        ) + 1;
	      }
	      if (value !== value) {
	        return baseFindIndex(array, baseIsNaN, index - 1, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = baseRest(function(array, indexes) {
	      indexes = baseFlatten(indexes, 1);
	
	      var length = array ? array.length : 0,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array ? nativeReverse.call(array) : array;
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array ? array.length : 0;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array ? array.length : 0;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array ? array.length : 0;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each
	     * element is kept.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length)
	        ? baseUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The comparator is invoked with
	     * two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      return (array && array.length)
	        ? baseUniq(array, undefined, comparator)
	        : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The comparator is invoked with
	     * two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths of elements to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = baseRest(function(paths) {
	      paths = baseFlatten(paths, 1);
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _([1, 2]).forEach(function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? apply(func, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var array = isArrayLike(collection) ? collection : values(collection),
	          length = array.length;
	
	      return length > 0 ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      var index = -1,
	          result = toArray(collection),
	          length = result.length,
	          lastIndex = length - 1;
	
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = baseClamp(toInteger(n), 0, length);
	      }
	      while (++index < n) {
	        var rand = baseRandom(index, lastIndex),
	            value = result[rand];
	
	        result[rand] = result[index];
	        result[index] = value;
	      }
	      result.length = n;
	      return result;
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      return sampleSize(collection, MAX_ARRAY_LENGTH);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, function(o) { return o.user; });
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     *
	     * _.sortBy(users, 'user', function(o) {
	     *   return Math.floor(o.age / 10);
	     * });
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            result = wait - timeSinceLastCall;
	
	        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one or more milliseconds.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = baseRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = baseRest(function(func, indexes) {
	      return createWrap(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes, 1));
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return partial(wrapper, value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, false, true);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      return baseClone(value, false, true, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, true, true);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      return baseClone(value, true, true, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	      return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	        (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	    }
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && objectToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' ||
	            typeof value.splice == 'function' || isBuffer(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (nonEnumShadows || isPrototype(value)) {
	        return !nativeKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are **not** supported.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      return (objectToString.call(value) == errorTag) ||
	        (typeof value.message == 'string' && typeof value.name == 'string');
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 8-9 which returns 'object' for typed array and other constructors.
	      var tag = isObject(value) ? objectToString.call(value) : '';
	      return tag == funcTag || tag == genTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return !!value && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error('This method is not supported with core-js. Try https://github.com/es-shims.');
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && objectToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) ||
	          objectToString.call(value) != objectTag || isHostObject(value)) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return (typeof Ctor == 'function' &&
	        Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && objectToString.call(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && objectToString.call(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (iteratorSymbol && value[iteratorSymbol]) {
	        return iteratorToArray(value[iteratorSymbol]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths of elements to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = baseRest(function(object, paths) {
	      return baseAt(object, baseFlatten(paths, 1));
	    });
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(args) {
	      args.push(undefined, assignInDefaults);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, mergeDefaults);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        result[iteratee(value, key, object)] = value;
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        result[key] = iteratee(value, key, object);
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with seven arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable string keyed properties of `object` that are
	     * not omitted.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [props] The property identifiers to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = baseRest(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      props = arrayMap(baseFlatten(props, 1), toKey);
	      return basePick(object, baseDifference(getAllKeysIn(object), props));
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [props] The property identifiers to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = baseRest(function(object, props) {
	      return object == null ? {} : basePick(object, arrayMap(baseFlatten(props, 1), toKey));
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      return object == null ? {} : basePickBy(object, getAllKeysIn(object), getIteratee(predicate));
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        object = undefined;
	        length = 1;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getIteratee(iteratee, 4);
	
	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object ? baseValues(object, keys(object)) : [];
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in IE < 9, they can break out of
	     * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the
	     * [HTML5 Security Cheatsheet](https://html5sec.org/) for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      // Chrome fails to trim leading <BOM> whitespace characters.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=3109 for more details.
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      string = toString(string).replace(reTrim, '');
	      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = baseClamp(toInteger(position), 0, string.length);
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES delimiter as an alternative to the default "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, assignInDefaults);
	
	      var imports = assignInWith({}, options.imports, settings.imports, assignInDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = baseRest(function(object, methodNames) {
	      arrayEach(baseFlatten(methodNames, 1), function(key) {
	        key = toKey(key);
	        object[key] = bind(object[key], object);
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs ? pairs.length : 0,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, true));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(value));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (iteratorSymbol) {
	      lodash.prototype[iteratorSymbol] = wrapperToIterator;
	    }
	    return lodash;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(16)(module)))

/***/ },
/* 5 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.utils = void 0;
	
	var _Accordion2 = _interopRequireDefault(__webpack_require__(1924));
	
	exports.Accordion = _Accordion2.default;
	
	var _Alert2 = _interopRequireDefault(__webpack_require__(867));
	
	exports.Alert = _Alert2.default;
	
	var _Badge2 = _interopRequireDefault(__webpack_require__(1925));
	
	exports.Badge = _Badge2.default;
	
	var _Breadcrumb2 = _interopRequireDefault(__webpack_require__(1926));
	
	exports.Breadcrumb = _Breadcrumb2.default;
	
	var _BreadcrumbItem2 = _interopRequireDefault(__webpack_require__(868));
	
	exports.BreadcrumbItem = _BreadcrumbItem2.default;
	
	var _Button2 = _interopRequireDefault(__webpack_require__(232));
	
	exports.Button = _Button2.default;
	
	var _ButtonGroup2 = _interopRequireDefault(__webpack_require__(502));
	
	exports.ButtonGroup = _ButtonGroup2.default;
	
	var _ButtonToolbar2 = _interopRequireDefault(__webpack_require__(1927));
	
	exports.ButtonToolbar = _ButtonToolbar2.default;
	
	var _Carousel2 = _interopRequireDefault(__webpack_require__(1928));
	
	exports.Carousel = _Carousel2.default;
	
	var _CarouselItem2 = _interopRequireDefault(__webpack_require__(869));
	
	exports.CarouselItem = _CarouselItem2.default;
	
	var _Checkbox2 = _interopRequireDefault(__webpack_require__(1930));
	
	exports.Checkbox = _Checkbox2.default;
	
	var _Clearfix2 = _interopRequireDefault(__webpack_require__(1931));
	
	exports.Clearfix = _Clearfix2.default;
	
	var _CloseButton2 = _interopRequireDefault(__webpack_require__(503));
	
	exports.CloseButton = _CloseButton2.default;
	
	var _ControlLabel2 = _interopRequireDefault(__webpack_require__(870));
	
	exports.ControlLabel = _ControlLabel2.default;
	
	var _Col2 = _interopRequireDefault(__webpack_require__(504));
	
	exports.Col = _Col2.default;
	
	var _Collapse2 = _interopRequireDefault(__webpack_require__(505));
	
	exports.Collapse = _Collapse2.default;
	
	var _Dropdown2 = _interopRequireDefault(__webpack_require__(318));
	
	exports.Dropdown = _Dropdown2.default;
	
	var _DropdownButton2 = _interopRequireDefault(__webpack_require__(871));
	
	exports.DropdownButton = _DropdownButton2.default;
	
	var _Fade2 = _interopRequireDefault(__webpack_require__(319));
	
	exports.Fade = _Fade2.default;
	
	var _Form2 = _interopRequireDefault(__webpack_require__(1933));
	
	exports.Form = _Form2.default;
	
	var _FormControl2 = _interopRequireDefault(__webpack_require__(506));
	
	exports.FormControl = _FormControl2.default;
	
	var _FormGroup2 = _interopRequireDefault(__webpack_require__(873));
	
	exports.FormGroup = _FormGroup2.default;
	
	var _Glyphicon2 = _interopRequireDefault(__webpack_require__(507));
	
	exports.Glyphicon = _Glyphicon2.default;
	
	var _Grid2 = _interopRequireDefault(__webpack_require__(874));
	
	exports.Grid = _Grid2.default;
	
	var _HelpBlock2 = _interopRequireDefault(__webpack_require__(875));
	
	exports.HelpBlock = _HelpBlock2.default;
	
	var _Image2 = _interopRequireDefault(__webpack_require__(1936));
	
	exports.Image = _Image2.default;
	
	var _InputGroup2 = _interopRequireDefault(__webpack_require__(876));
	
	exports.InputGroup = _InputGroup2.default;
	
	var _Jumbotron2 = _interopRequireDefault(__webpack_require__(1939));
	
	exports.Jumbotron = _Jumbotron2.default;
	
	var _Label2 = _interopRequireDefault(__webpack_require__(1940));
	
	exports.Label = _Label2.default;
	
	var _ListGroup2 = _interopRequireDefault(__webpack_require__(1941));
	
	exports.ListGroup = _ListGroup2.default;
	
	var _ListGroupItem2 = _interopRequireDefault(__webpack_require__(877));
	
	exports.ListGroupItem = _ListGroupItem2.default;
	
	var _Media2 = _interopRequireDefault(__webpack_require__(320));
	
	exports.Media = _Media2.default;
	
	var _MenuItem2 = _interopRequireDefault(__webpack_require__(878));
	
	exports.MenuItem = _MenuItem2.default;
	
	var _Modal2 = _interopRequireDefault(__webpack_require__(1948));
	
	exports.Modal = _Modal2.default;
	
	var _ModalBody2 = _interopRequireDefault(__webpack_require__(879));
	
	exports.ModalBody = _ModalBody2.default;
	
	var _ModalDialog2 = _interopRequireDefault(__webpack_require__(880));
	
	exports.ModalDialog = _ModalDialog2.default;
	
	var _ModalFooter2 = _interopRequireDefault(__webpack_require__(881));
	
	exports.ModalFooter = _ModalFooter2.default;
	
	var _ModalHeader2 = _interopRequireDefault(__webpack_require__(882));
	
	exports.ModalHeader = _ModalHeader2.default;
	
	var _ModalTitle2 = _interopRequireDefault(__webpack_require__(883));
	
	exports.ModalTitle = _ModalTitle2.default;
	
	var _Nav2 = _interopRequireDefault(__webpack_require__(884));
	
	exports.Nav = _Nav2.default;
	
	var _Navbar2 = _interopRequireDefault(__webpack_require__(1950));
	
	exports.Navbar = _Navbar2.default;
	
	var _NavbarBrand2 = _interopRequireDefault(__webpack_require__(886));
	
	exports.NavbarBrand = _NavbarBrand2.default;
	
	var _NavDropdown2 = _interopRequireDefault(__webpack_require__(1949));
	
	exports.NavDropdown = _NavDropdown2.default;
	
	var _NavItem2 = _interopRequireDefault(__webpack_require__(885));
	
	exports.NavItem = _NavItem2.default;
	
	var _Overlay2 = _interopRequireDefault(__webpack_require__(887));
	
	exports.Overlay = _Overlay2.default;
	
	var _OverlayTrigger2 = _interopRequireDefault(__webpack_require__(1954));
	
	exports.OverlayTrigger = _OverlayTrigger2.default;
	
	var _PageHeader2 = _interopRequireDefault(__webpack_require__(1955));
	
	exports.PageHeader = _PageHeader2.default;
	
	var _PageItem2 = _interopRequireDefault(__webpack_require__(1956));
	
	exports.PageItem = _PageItem2.default;
	
	var _Pager2 = _interopRequireDefault(__webpack_require__(1957));
	
	exports.Pager = _Pager2.default;
	
	var _Pagination2 = _interopRequireDefault(__webpack_require__(1958));
	
	exports.Pagination = _Pagination2.default;
	
	var _Panel2 = _interopRequireDefault(__webpack_require__(1960));
	
	exports.Panel = _Panel2.default;
	
	var _PanelGroup2 = _interopRequireDefault(__webpack_require__(890));
	
	exports.PanelGroup = _PanelGroup2.default;
	
	var _Popover2 = _interopRequireDefault(__webpack_require__(1965));
	
	exports.Popover = _Popover2.default;
	
	var _ProgressBar2 = _interopRequireDefault(__webpack_require__(1966));
	
	exports.ProgressBar = _ProgressBar2.default;
	
	var _Radio2 = _interopRequireDefault(__webpack_require__(892));
	
	exports.Radio = _Radio2.default;
	
	var _ResponsiveEmbed2 = _interopRequireDefault(__webpack_require__(1967));
	
	exports.ResponsiveEmbed = _ResponsiveEmbed2.default;
	
	var _Row2 = _interopRequireDefault(__webpack_require__(893));
	
	exports.Row = _Row2.default;
	
	var _SafeAnchor2 = _interopRequireDefault(__webpack_require__(90));
	
	exports.SafeAnchor = _SafeAnchor2.default;
	
	var _SplitButton2 = _interopRequireDefault(__webpack_require__(1968));
	
	exports.SplitButton = _SplitButton2.default;
	
	var _Tab2 = _interopRequireDefault(__webpack_require__(1970));
	
	exports.Tab = _Tab2.default;
	
	var _TabContainer2 = _interopRequireDefault(__webpack_require__(508));
	
	exports.TabContainer = _TabContainer2.default;
	
	var _TabContent2 = _interopRequireDefault(__webpack_require__(509));
	
	exports.TabContent = _TabContent2.default;
	
	var _Table2 = _interopRequireDefault(__webpack_require__(1971));
	
	exports.Table = _Table2.default;
	
	var _TabPane2 = _interopRequireDefault(__webpack_require__(894));
	
	exports.TabPane = _TabPane2.default;
	
	var _Tabs2 = _interopRequireDefault(__webpack_require__(1972));
	
	exports.Tabs = _Tabs2.default;
	
	var _Thumbnail2 = _interopRequireDefault(__webpack_require__(1973));
	
	exports.Thumbnail = _Thumbnail2.default;
	
	var _ToggleButton2 = _interopRequireDefault(__webpack_require__(895));
	
	exports.ToggleButton = _ToggleButton2.default;
	
	var _ToggleButtonGroup2 = _interopRequireDefault(__webpack_require__(1974));
	
	exports.ToggleButtonGroup = _ToggleButtonGroup2.default;
	
	var _Tooltip2 = _interopRequireDefault(__webpack_require__(1975));
	
	exports.Tooltip = _Tooltip2.default;
	
	var _Well2 = _interopRequireDefault(__webpack_require__(1976));
	
	exports.Well = _Well2.default;
	
	var _utils = _interopRequireWildcard(__webpack_require__(1978));
	
	exports.utils = _utils;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var _Object$create = __webpack_require__(968);
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = _Object$create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	module.exports = _inheritsLoose;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var _Object$assign = __webpack_require__(533);
	
	function _extends() {
	  module.exports = _extends = _Object$assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var _Object$keys = __webpack_require__(971);
	
	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	
	  var sourceKeys = _Object$keys(source);
	
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;

/***/ },
/* 11 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.connectAdvanced = exports.createProvider = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(2044);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connectAdvanced = __webpack_require__(912);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _connect = __webpack_require__(2045);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.createProvider = _Provider.createProvider;
	exports.connectAdvanced = _connectAdvanced2.default;
	exports.connect = _connect2.default;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.prefix = prefix;
	exports.getClassSet = getClassSet;
	exports.splitBsProps = splitBsProps;
	exports.splitBsPropsAndOmit = splitBsPropsAndOmit;
	exports.addStyle = addStyle;
	exports._curry = exports.bsSizes = exports.bsStyles = exports.bsClass = void 0;
	
	var _entries = _interopRequireDefault(__webpack_require__(534));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _invariant = _interopRequireDefault(__webpack_require__(68));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _StyleConfig = __webpack_require__(51);
	
	// TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.
	function curry(fn) {
	  return function () {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var last = args[args.length - 1];
	
	    if (typeof last === 'function') {
	      return fn.apply(void 0, args);
	    }
	
	    return function (Component) {
	      return fn.apply(void 0, args.concat([Component]));
	    };
	  };
	}
	
	function prefix(props, variant) {
	  var bsClass = (props.bsClass || '').trim();
	  !(bsClass != null) ?  false ? (0, _invariant.default)(false, 'A `bsClass` prop is required for this component') : invariant(false) : void 0;
	  return bsClass + (variant ? "-" + variant : '');
	}
	
	var bsClass = curry(function (defaultClass, Component) {
	  var propTypes = Component.propTypes || (Component.propTypes = {});
	  var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	  propTypes.bsClass = _propTypes.default.string;
	  defaultProps.bsClass = defaultClass;
	  return Component;
	});
	exports.bsClass = bsClass;
	var bsStyles = curry(function (styles, defaultStyle, Component) {
	  if (typeof defaultStyle !== 'string') {
	    Component = defaultStyle;
	    defaultStyle = undefined;
	  }
	
	  var existing = Component.STYLES || [];
	  var propTypes = Component.propTypes || {};
	  styles.forEach(function (style) {
	    if (existing.indexOf(style) === -1) {
	      existing.push(style);
	    }
	  });
	
	  var propType = _propTypes.default.oneOf(existing); // expose the values on the propType function for documentation
	
	
	  Component.STYLES = existing;
	  propType._values = existing;
	  Component.propTypes = (0, _extends2.default)({}, propTypes, {
	    bsStyle: propType
	  });
	
	  if (defaultStyle !== undefined) {
	    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	    defaultProps.bsStyle = defaultStyle;
	  }
	
	  return Component;
	});
	exports.bsStyles = bsStyles;
	var bsSizes = curry(function (sizes, defaultSize, Component) {
	  if (typeof defaultSize !== 'string') {
	    Component = defaultSize;
	    defaultSize = undefined;
	  }
	
	  var existing = Component.SIZES || [];
	  var propTypes = Component.propTypes || {};
	  sizes.forEach(function (size) {
	    if (existing.indexOf(size) === -1) {
	      existing.push(size);
	    }
	  });
	  var values = [];
	  existing.forEach(function (size) {
	    var mappedSize = _StyleConfig.SIZE_MAP[size];
	
	    if (mappedSize && mappedSize !== size) {
	      values.push(mappedSize);
	    }
	
	    values.push(size);
	  });
	
	  var propType = _propTypes.default.oneOf(values);
	
	  propType._values = values; // expose the values on the propType function for documentation
	
	  Component.SIZES = existing;
	  Component.propTypes = (0, _extends2.default)({}, propTypes, {
	    bsSize: propType
	  });
	
	  if (defaultSize !== undefined) {
	    if (!Component.defaultProps) {
	      Component.defaultProps = {};
	    }
	
	    Component.defaultProps.bsSize = defaultSize;
	  }
	
	  return Component;
	});
	exports.bsSizes = bsSizes;
	
	function getClassSet(props) {
	  var _classes;
	
	  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);
	
	  if (props.bsSize) {
	    var bsSize = _StyleConfig.SIZE_MAP[props.bsSize] || props.bsSize;
	    classes[prefix(props, bsSize)] = true;
	  }
	
	  if (props.bsStyle) {
	    classes[prefix(props, props.bsStyle)] = true;
	  }
	
	  return classes;
	}
	
	function getBsProps(props) {
	  return {
	    bsClass: props.bsClass,
	    bsSize: props.bsSize,
	    bsStyle: props.bsStyle,
	    bsRole: props.bsRole
	  };
	}
	
	function isBsProp(propName) {
	  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
	}
	
	function splitBsProps(props) {
	  var elementProps = {};
	  (0, _entries.default)(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (!isBsProp(propName)) {
	      elementProps[propName] = propValue;
	    }
	  });
	  return [getBsProps(props), elementProps];
	}
	
	function splitBsPropsAndOmit(props, omittedPropNames) {
	  var isOmittedProp = {};
	  omittedPropNames.forEach(function (propName) {
	    isOmittedProp[propName] = true;
	  });
	  var elementProps = {};
	  (0, _entries.default)(props).forEach(function (_ref2) {
	    var propName = _ref2[0],
	        propValue = _ref2[1];
	
	    if (!isBsProp(propName) && !isOmittedProp[propName]) {
	      elementProps[propName] = propValue;
	    }
	  });
	  return [getBsProps(props), elementProps];
	}
	/**
	 * Add a style variant to a Component. Mutates the propTypes of the component
	 * in order to validate the new variant.
	 */
	
	
	function addStyle(Component) {
	  for (var _len2 = arguments.length, styleVariant = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    styleVariant[_key2 - 1] = arguments[_key2];
	  }
	
	  bsStyles(styleVariant, Component);
	}
	
	var _curry = curry;
	exports._curry = _curry;

/***/ },
/* 15 */
[2243, 1979],
/* 16 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _extends = __webpack_require__(2010);
	var _objectWithoutPropertiesLoose = __webpack_require__(2011);
	var React = __webpack_require__(1);
	var finalForm = __webpack_require__(124);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	function _interopNamespace(e) {
	  if (e && e.__esModule) return e;
	  var n = Object.create(null);
	  if (e) {
	    Object.keys(e).forEach(function (k) {
	      if (k !== 'default') {
	        var d = Object.getOwnPropertyDescriptor(e, k);
	        Object.defineProperty(n, k, d.get ? d : {
	          enumerable: true,
	          get: function () { return e[k]; }
	        });
	      }
	    });
	  }
	  n["default"] = e;
	  return Object.freeze(n);
	}
	
	var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
	var _objectWithoutPropertiesLoose__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutPropertiesLoose);
	var React__namespace = /*#__PURE__*/_interopNamespace(React);
	var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
	
	var _excluded$3 = ["render", "children", "component"];
	// shared logic between components that use either render prop,
	// children render function, or component prop
	function renderComponent(props, lazyProps, name) {
	  var render = props.render,
	      children = props.children,
	      component = props.component,
	      rest = _objectWithoutPropertiesLoose__default["default"](props, _excluded$3);
	
	  if (component) {
	    return /*#__PURE__*/React__namespace.createElement(component, Object.assign(lazyProps, rest, {
	      children: children,
	      render: render
	    }));
	  }
	
	  if (render) {
	    return render(children === undefined ? Object.assign(lazyProps, rest) : // inject children back in
	    Object.assign(lazyProps, rest, {
	      children: children
	    }));
	  }
	
	  if (typeof children !== "function") {
	    throw new Error("Must specify either a render prop, a render function as children, or a component prop to " + name);
	  }
	
	  return children(Object.assign(lazyProps, rest));
	}
	
	function useWhenValueChanges(value, callback, isEqual) {
	  if (isEqual === void 0) {
	    isEqual = function isEqual(a, b) {
	      return a === b;
	    };
	  }
	
	  var previous = React__default["default"].useRef(value);
	  React__default["default"].useEffect(function () {
	    if (!isEqual(value, previous.current)) {
	      callback();
	      previous.current = value;
	    }
	  });
	}
	
	/**
	 * A simple hook to create a constant value that lives for
	 * the lifetime of the component.
	 *
	 * Plagiarized from https://github.com/Andarist/use-constant
	 *
	 * Do NOT reuse this code unless you know what you're doing.
	 * Use Andarist's hook; it's more fault tolerant to things like
	 * falsy values.
	 *
	 * @param {Function} init - A function to generate the value
	 */
	
	function useConstant(init) {
	  var ref = React__default["default"].useRef();
	
	  if (!ref.current) {
	    ref.current = init();
	  }
	
	  return ref.current;
	}
	
	var shallowEqual = function shallowEqual(a, b) {
	  if (a === b) {
	    return true;
	  }
	
	  if (typeof a !== "object" || !a || typeof b !== "object" || !b) {
	    return false;
	  }
	
	  var keysA = Object.keys(a);
	  var keysB = Object.keys(b);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
	
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key) || a[key] !== b[key]) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	var isSyntheticEvent = function isSyntheticEvent(candidate) {
	  return !!(candidate && typeof candidate.stopPropagation === "function");
	};
	
	var ReactFinalFormContext = /*#__PURE__*/React__namespace.createContext();
	
	function useLatest(value) {
	  var ref = React__default["default"].useRef(value);
	  React__default["default"].useEffect(function () {
	    ref.current = value;
	  });
	  return ref;
	}
	
	var version = "6.5.7";
	
	var addLazyState = function addLazyState(dest, state, keys) {
	  keys.forEach(function (key) {
	    Object.defineProperty(dest, key, {
	      get: function get() {
	        return state[key];
	      },
	      enumerable: true
	    });
	  });
	};
	
	var addLazyFormState = function addLazyFormState(dest, state) {
	  return addLazyState(dest, state, ["active", "dirty", "dirtyFields", "dirtySinceLastSubmit", "dirtyFieldsSinceLastSubmit", "error", "errors", "hasSubmitErrors", "hasValidationErrors", "initialValues", "invalid", "modified", "modifiedSinceLastSubmit", "pristine", "submitError", "submitErrors", "submitFailed", "submitSucceeded", "submitting", "touched", "valid", "validating", "values", "visited"]);
	};
	var addLazyFieldMetaState = function addLazyFieldMetaState(dest, state) {
	  return addLazyState(dest, state, ["active", "data", "dirty", "dirtySinceLastSubmit", "error", "initial", "invalid", "length", "modified", "modifiedSinceLastSubmit", "pristine", "submitError", "submitFailed", "submitSucceeded", "submitting", "touched", "valid", "validating", "visited"]);
	};
	
	var _excluded$2 = ["debug", "decorators", "destroyOnUnregister", "form", "initialValues", "initialValuesEqual", "keepDirtyOnReinitialize", "mutators", "onSubmit", "subscription", "validate", "validateOnBlur"];
	var versions = {
	  "final-form": finalForm.version,
	  "react-final-form": version
	};
	var all$1 = finalForm.formSubscriptionItems.reduce(function (result, key) {
	  result[key] = true;
	  return result;
	}, {});
	
	function ReactFinalForm(_ref) {
	  var debug = _ref.debug,
	      _ref$decorators = _ref.decorators,
	      decorators = _ref$decorators === void 0 ? [] : _ref$decorators,
	      destroyOnUnregister = _ref.destroyOnUnregister,
	      alternateFormApi = _ref.form,
	      initialValues = _ref.initialValues,
	      initialValuesEqual = _ref.initialValuesEqual,
	      keepDirtyOnReinitialize = _ref.keepDirtyOnReinitialize,
	      mutators = _ref.mutators,
	      onSubmit = _ref.onSubmit,
	      _ref$subscription = _ref.subscription,
	      subscription = _ref$subscription === void 0 ? all$1 : _ref$subscription,
	      validate = _ref.validate,
	      validateOnBlur = _ref.validateOnBlur,
	      rest = _objectWithoutPropertiesLoose__default["default"](_ref, _excluded$2);
	
	  var config = {
	    debug: debug,
	    destroyOnUnregister: destroyOnUnregister,
	    initialValues: initialValues,
	    keepDirtyOnReinitialize: keepDirtyOnReinitialize,
	    mutators: mutators,
	    onSubmit: onSubmit,
	    validate: validate,
	    validateOnBlur: validateOnBlur
	  };
	  var form = useConstant(function () {
	    var f = alternateFormApi || finalForm.createForm(config); // pause validation until children register all fields on first render (unpaused in useEffect() below)
	
	    f.pauseValidation();
	    return f;
	  }); // synchronously register and unregister to query form state for our subscription on first render
	
	  var _React$useState = React__namespace.useState(function () {
	    var initialState = {};
	    form.subscribe(function (state) {
	      initialState = state;
	    }, subscription)();
	    return initialState;
	  }),
	      state = _React$useState[0],
	      setState = _React$useState[1]; // save a copy of state that can break through the closure
	  // on the shallowEqual() line below.
	
	
	  var stateRef = useLatest(state);
	  React__namespace.useEffect(function () {
	    // We have rendered, so all fields are now registered, so we can unpause validation
	    form.isValidationPaused() && form.resumeValidation();
	    var unsubscriptions = [form.subscribe(function (s) {
	      if (!shallowEqual(s, stateRef.current)) {
	        setState(s);
	      }
	    }, subscription)].concat(decorators ? decorators.map(function (decorator) {
	      return (// this noop ternary is to appease the flow gods
	        // istanbul ignore next
	        decorator(form)
	      );
	    }) : []);
	    return function () {
	      form.pauseValidation(); // pause validation so we don't revalidate on every field deregistration
	
	      unsubscriptions.reverse().forEach(function (unsubscribe) {
	        return unsubscribe();
	      }); // don't need to resume validation here; either unmounting, or will re-run this hook with new deps
	    }; // eslint-disable-next-line react-hooks/exhaustive-deps
	  }, decorators); // warn about decorator changes
	  // istanbul ignore next
	
	  if (false) {
	    // You're never supposed to use hooks inside a conditional, but in this
	    // case we can be certain that you're not going to be changing your
	    // NODE_ENV between renders, so this is safe.
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    useWhenValueChanges(decorators, function () {
	      console.error("Form decorators should not change from one render to the next as new values will be ignored");
	    }, shallowEqual);
	  } // allow updatable config
	
	
	  useWhenValueChanges(debug, function () {
	    form.setConfig("debug", debug);
	  });
	  useWhenValueChanges(destroyOnUnregister, function () {
	    form.destroyOnUnregister = !!destroyOnUnregister;
	  });
	  useWhenValueChanges(keepDirtyOnReinitialize, function () {
	    form.setConfig("keepDirtyOnReinitialize", keepDirtyOnReinitialize);
	  });
	  useWhenValueChanges(initialValues, function () {
	    form.setConfig("initialValues", initialValues);
	  }, initialValuesEqual || shallowEqual);
	  useWhenValueChanges(mutators, function () {
	    form.setConfig("mutators", mutators);
	  });
	  useWhenValueChanges(onSubmit, function () {
	    form.setConfig("onSubmit", onSubmit);
	  });
	  useWhenValueChanges(validate, function () {
	    form.setConfig("validate", validate);
	  });
	  useWhenValueChanges(validateOnBlur, function () {
	    form.setConfig("validateOnBlur", validateOnBlur);
	  });
	
	  var handleSubmit = function handleSubmit(event) {
	    if (event) {
	      // sometimes not true, e.g. React Native
	      if (typeof event.preventDefault === "function") {
	        event.preventDefault();
	      }
	
	      if (typeof event.stopPropagation === "function") {
	        // prevent any outer forms from receiving the event too
	        event.stopPropagation();
	      }
	    }
	
	    return form.submit();
	  };
	
	  var renderProps = {
	    form: _extends__default["default"]({}, form, {
	      reset: function reset(eventOrValues) {
	        if (isSyntheticEvent(eventOrValues)) {
	          // it's a React SyntheticEvent, call reset with no arguments
	          form.reset();
	        } else {
	          form.reset(eventOrValues);
	        }
	      }
	    }),
	    handleSubmit: handleSubmit
	  };
	  addLazyFormState(renderProps, state);
	  return /*#__PURE__*/React__namespace.createElement(ReactFinalFormContext.Provider, {
	    value: form
	  }, renderComponent(_extends__default["default"]({}, rest, {
	    __versions: versions
	  }), renderProps, "ReactFinalForm"));
	}
	
	function useForm(componentName) {
	  var form = React__namespace.useContext(ReactFinalFormContext);
	
	  if (!form) {
	    throw new Error((componentName || "useForm") + " must be used inside of a <Form> component");
	  }
	
	  return form;
	}
	
	function useFormState(_temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      onChange = _ref.onChange,
	      _ref$subscription = _ref.subscription,
	      subscription = _ref$subscription === void 0 ? all$1 : _ref$subscription;
	
	  var form = useForm("useFormState");
	  var firstRender = React__namespace.useRef(true);
	  var onChangeRef = React__namespace.useRef(onChange);
	  onChangeRef.current = onChange; // synchronously register and unregister to query field state for our subscription on first render
	
	  var _React$useState = React__namespace.useState(function () {
	    var initialState = {};
	    form.subscribe(function (state) {
	      initialState = state;
	    }, subscription)();
	
	    if (onChange) {
	      onChange(initialState);
	    }
	
	    return initialState;
	  }),
	      state = _React$useState[0],
	      setState = _React$useState[1];
	
	  React__namespace.useEffect(function () {
	    return form.subscribe(function (newState) {
	      if (firstRender.current) {
	        firstRender.current = false;
	      } else {
	        setState(newState);
	
	        if (onChangeRef.current) {
	          onChangeRef.current(newState);
	        }
	      }
	    }, subscription);
	  }, // eslint-disable-next-line react-hooks/exhaustive-deps
	  []);
	  var lazyState = {};
	  addLazyFormState(lazyState, state);
	  return lazyState;
	}
	
	var _excluded$1 = ["onChange", "subscription"];
	
	function FormSpy(_ref) {
	  var onChange = _ref.onChange,
	      subscription = _ref.subscription,
	      rest = _objectWithoutPropertiesLoose__default["default"](_ref, _excluded$1);
	
	  var reactFinalForm = useForm("FormSpy");
	  var state = useFormState({
	    onChange: onChange,
	    subscription: subscription
	  });
	
	  if (onChange) {
	    return null;
	  }
	
	  var renderProps = {
	    form: _extends__default["default"]({}, reactFinalForm, {
	      reset: function reset(eventOrValues) {
	        if (isSyntheticEvent(eventOrValues)) {
	          // it's a React SyntheticEvent, call reset with no arguments
	          reactFinalForm.reset();
	        } else {
	          reactFinalForm.reset(eventOrValues);
	        }
	      }
	    })
	  };
	  return renderComponent(_extends__default["default"]({}, rest, renderProps), state, "FormSpy");
	}
	
	var isReactNative = typeof window !== "undefined" && window.navigator && window.navigator.product && window.navigator.product === "ReactNative";
	
	var getSelectedValues = function getSelectedValues(options) {
	  var result = [];
	
	  if (options) {
	    for (var index = 0; index < options.length; index++) {
	      var option = options[index];
	
	      if (option.selected) {
	        result.push(option.value);
	      }
	    }
	  }
	
	  return result;
	};
	
	var getValue = function getValue(event, currentValue, valueProp, isReactNative) {
	  if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
	    return event.nativeEvent.text;
	  }
	
	  if (isReactNative && event.nativeEvent) {
	    return event.nativeEvent.text;
	  }
	
	  var detypedEvent = event;
	  var _detypedEvent$target = detypedEvent.target,
	      type = _detypedEvent$target.type,
	      value = _detypedEvent$target.value,
	      checked = _detypedEvent$target.checked;
	
	  switch (type) {
	    case "checkbox":
	      if (valueProp !== undefined) {
	        // we are maintaining an array, not just a boolean
	        if (checked) {
	          // add value to current array value
	          return Array.isArray(currentValue) ? currentValue.concat(valueProp) : [valueProp];
	        } else {
	          // remove value from current array value
	          if (!Array.isArray(currentValue)) {
	            return currentValue;
	          }
	
	          var index = currentValue.indexOf(valueProp);
	
	          if (index < 0) {
	            return currentValue;
	          } else {
	            return currentValue.slice(0, index).concat(currentValue.slice(index + 1));
	          }
	        }
	      } else {
	        // it's just a boolean
	        return !!checked;
	      }
	
	    case "select-multiple":
	      return getSelectedValues(event.target.options);
	
	    default:
	      return value;
	  }
	};
	
	/**
	 * Creates a callback, even with closures, that will be
	 * instance === for the lifetime of the component, always
	 * calling the most recent version of the function and its
	 * closures.
	 */
	
	function useConstantCallback(callback) {
	  var ref = React__namespace.useRef(callback);
	  React__namespace.useEffect(function () {
	    ref.current = callback;
	  });
	  return React__namespace.useCallback(function () {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return ref.current.apply(null, args);
	  }, []);
	}
	
	var all = finalForm.fieldSubscriptionItems.reduce(function (result, key) {
	  result[key] = true;
	  return result;
	}, {});
	
	var defaultFormat = function defaultFormat(value, name) {
	  return value === undefined ? "" : value;
	};
	
	var defaultParse = function defaultParse(value, name) {
	  return value === "" ? undefined : value;
	};
	
	var defaultIsEqual = function defaultIsEqual(a, b) {
	  return a === b;
	};
	
	function useField(name, config) {
	  if (config === void 0) {
	    config = {};
	  }
	
	  var _config = config,
	      afterSubmit = _config.afterSubmit,
	      allowNull = _config.allowNull,
	      component = _config.component,
	      data = _config.data,
	      defaultValue = _config.defaultValue,
	      _config$format = _config.format,
	      format = _config$format === void 0 ? defaultFormat : _config$format,
	      formatOnBlur = _config.formatOnBlur,
	      initialValue = _config.initialValue,
	      multiple = _config.multiple,
	      _config$parse = _config.parse,
	      parse = _config$parse === void 0 ? defaultParse : _config$parse,
	      _config$subscription = _config.subscription,
	      subscription = _config$subscription === void 0 ? all : _config$subscription,
	      type = _config.type,
	      validateFields = _config.validateFields,
	      _value = _config.value;
	  var form = useForm("useField");
	  var configRef = useLatest(config);
	
	  var register = function register(callback, silent) {
	    return (// avoid using `state` const in any closures created inside `register`
	      // because they would refer `state` from current execution context
	      // whereas actual `state` would defined in the subsequent `useField` hook
	      // execution
	      // (that would be caused by `setState` call performed in `register` callback)
	      form.registerField(name, callback, subscription, {
	        afterSubmit: afterSubmit,
	        beforeSubmit: function beforeSubmit() {
	          var _configRef$current = configRef.current,
	              beforeSubmit = _configRef$current.beforeSubmit,
	              formatOnBlur = _configRef$current.formatOnBlur,
	              _configRef$current$fo = _configRef$current.format,
	              format = _configRef$current$fo === void 0 ? defaultFormat : _configRef$current$fo;
	
	          if (formatOnBlur) {
	            var _ref = form.getFieldState(name),
	                value = _ref.value;
	
	            var formatted = format(value, name);
	
	            if (formatted !== value) {
	              form.change(name, formatted);
	            }
	          }
	
	          return beforeSubmit && beforeSubmit();
	        },
	        data: data,
	        defaultValue: defaultValue,
	        getValidator: function getValidator() {
	          return configRef.current.validate;
	        },
	        initialValue: initialValue,
	        isEqual: function isEqual(a, b) {
	          return (configRef.current.isEqual || defaultIsEqual)(a, b);
	        },
	        silent: silent,
	        validateFields: validateFields
	      })
	    );
	  };
	
	  var firstRender = React__namespace.useRef(true); // synchronously register and unregister to query field state for our subscription on first render
	
	  var _React$useState = React__namespace.useState(function () {
	    var initialState = {}; // temporarily disable destroyOnUnregister
	
	    // temporarily disable destroyOnUnregister
	    var destroyOnUnregister = form.destroyOnUnregister;
	    form.destroyOnUnregister = false;
	    register(function (state) {
	      initialState = state;
	    }, true)(); // return destroyOnUnregister to its original value
	
	    // return destroyOnUnregister to its original value
	    form.destroyOnUnregister = destroyOnUnregister;
	    return initialState;
	  }),
	      state = _React$useState[0],
	      setState = _React$useState[1];
	
	  React__namespace.useEffect(function () {
	    return register(function (state) {
	      if (firstRender.current) {
	        firstRender.current = false;
	      } else {
	        setState(state);
	      }
	    }, false);
	  }, // eslint-disable-next-line react-hooks/exhaustive-deps
	  [name, data, defaultValue, // If we want to allow inline fat-arrow field-level validation functions, we
	  // cannot reregister field every time validate function !==.
	  // validate,
	  initialValue // The validateFields array is often passed as validateFields={[]}, creating
	  // a !== new array every time. If it needs to be changed, a rerender/reregister
	  // can be forced by changing the key prop
	  // validateFields
	  ]);
	  var meta = {};
	  addLazyFieldMetaState(meta, state);
	  var input = {
	    name: name,
	
	    get value() {
	      var value = state.value;
	
	      if (formatOnBlur) {
	        if (component === "input") {
	          value = defaultFormat(value);
	        }
	      } else {
	        value = format(value, name);
	      }
	
	      if (value === null && !allowNull) {
	        value = "";
	      }
	
	      if (type === "checkbox" || type === "radio") {
	        return _value;
	      } else if (component === "select" && multiple) {
	        return value || [];
	      }
	
	      return value;
	    },
	
	    get checked() {
	      var value = state.value;
	
	      if (type === "checkbox") {
	        value = format(value, name);
	
	        if (_value === undefined) {
	          return !!value;
	        } else {
	          return !!(Array.isArray(value) && ~value.indexOf(_value));
	        }
	      } else if (type === "radio") {
	        return format(value, name) === _value;
	      }
	
	      return undefined;
	    },
	
	    onBlur: useConstantCallback(function (event) {
	      state.blur();
	
	      if (formatOnBlur) {
	        /**
	         * Here we must fetch the value directly from Final Form because we cannot
	         * trust that our `state` closure has the most recent value. This is a problem
	         * if-and-only-if the library consumer has called `onChange()` immediately
	         * before calling `onBlur()`, but before the field has had a chance to receive
	         * the value update from Final Form.
	         */
	        var fieldState = form.getFieldState(state.name);
	        state.change(format(fieldState.value, state.name));
	      }
	    }),
	    onChange: useConstantCallback(function (event) {
	      // istanbul ignore next
	      if (false) {
	        var targetType = event.target.type;
	        var unknown = ~["checkbox", "radio", "select-multiple"].indexOf(targetType) && !type && component !== "select";
	
	        var _value2 = targetType === "select-multiple" ? state.value : _value;
	
	        if (unknown) {
	          console.error("You must pass `type=\"" + (targetType === "select-multiple" ? "select" : targetType) + "\"` prop to your Field(" + name + ") component.\n" + ("Without it we don't know how to unpack your `value` prop - " + (Array.isArray(_value2) ? "[" + _value2 + "]" : "\"" + _value2 + "\"") + "."));
	        }
	      }
	
	      var value = event && event.target ? getValue(event, state.value, _value, isReactNative) : event;
	      state.change(parse(value, name));
	    }),
	    onFocus: useConstantCallback(function (event) {
	      return state.focus();
	    })
	  };
	
	  if (multiple) {
	    input.multiple = multiple;
	  }
	
	  if (type !== undefined) {
	    input.type = type;
	  }
	
	  var renderProps = {
	    input: input,
	    meta: meta
	  }; // assign to force Flow check
	
	  return renderProps;
	}
	
	var _excluded = ["afterSubmit", "allowNull", "beforeSubmit", "children", "component", "data", "defaultValue", "format", "formatOnBlur", "initialValue", "isEqual", "multiple", "name", "parse", "subscription", "type", "validate", "validateFields", "value"];
	var Field = /*#__PURE__*/React__namespace.forwardRef(function Field(_ref, ref) {
	  var afterSubmit = _ref.afterSubmit,
	      allowNull = _ref.allowNull,
	      beforeSubmit = _ref.beforeSubmit,
	      children = _ref.children,
	      component = _ref.component,
	      data = _ref.data,
	      defaultValue = _ref.defaultValue,
	      format = _ref.format,
	      formatOnBlur = _ref.formatOnBlur,
	      initialValue = _ref.initialValue,
	      isEqual = _ref.isEqual,
	      multiple = _ref.multiple,
	      name = _ref.name,
	      parse = _ref.parse,
	      subscription = _ref.subscription,
	      type = _ref.type,
	      validate = _ref.validate,
	      validateFields = _ref.validateFields,
	      value = _ref.value,
	      rest = _objectWithoutPropertiesLoose__default["default"](_ref, _excluded);
	
	  var field = useField(name, {
	    afterSubmit: afterSubmit,
	    allowNull: allowNull,
	    beforeSubmit: beforeSubmit,
	    children: children,
	    component: component,
	    data: data,
	    defaultValue: defaultValue,
	    format: format,
	    formatOnBlur: formatOnBlur,
	    initialValue: initialValue,
	    isEqual: isEqual,
	    multiple: multiple,
	    parse: parse,
	    subscription: subscription,
	    type: type,
	    validate: validate,
	    validateFields: validateFields,
	    value: value
	  });
	
	  if (typeof children === "function") {
	    return children(_extends__default["default"]({}, field, rest));
	  }
	
	  if (typeof component === "string") {
	    // ignore meta, combine input with any other props
	    return /*#__PURE__*/React__namespace.createElement(component, _extends__default["default"]({}, field.input, {
	      children: children,
	      ref: ref
	    }, rest));
	  }
	
	  if (!name) {
	    throw new Error("prop name cannot be undefined in <Field> component");
	  }
	
	  return renderComponent(_extends__default["default"]({
	    children: children,
	    component: component,
	    ref: ref
	  }, rest), field, "Field(" + name + ")");
	});
	
	function withTypes() {
	  return {
	    Form: ReactFinalForm,
	    FormSpy: FormSpy
	  };
	}
	
	exports.Field = Field;
	exports.Form = ReactFinalForm;
	exports.FormSpy = FormSpy;
	exports.useField = useField;
	exports.useForm = useForm;
	exports.useFormState = useFormState;
	exports.version = version;
	exports.withTypes = withTypes;


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.linkTo = exports.action = exports.forceReRender = exports.getStorybook = exports.configure = exports.addDecorator = exports.setAddon = exports.storiesOf = undefined;
	
	var _preview = __webpack_require__(1042);
	
	Object.defineProperty(exports, 'storiesOf', {
	  enumerable: true,
	  get: function get() {
	    return _preview.storiesOf;
	  }
	});
	Object.defineProperty(exports, 'setAddon', {
	  enumerable: true,
	  get: function get() {
	    return _preview.setAddon;
	  }
	});
	Object.defineProperty(exports, 'addDecorator', {
	  enumerable: true,
	  get: function get() {
	    return _preview.addDecorator;
	  }
	});
	Object.defineProperty(exports, 'configure', {
	  enumerable: true,
	  get: function get() {
	    return _preview.configure;
	  }
	});
	Object.defineProperty(exports, 'getStorybook', {
	  enumerable: true,
	  get: function get() {
	    return _preview.getStorybook;
	  }
	});
	Object.defineProperty(exports, 'forceReRender', {
	  enumerable: true,
	  get: function get() {
	    return _preview.forceReRender;
	  }
	});
	
	var _utilDeprecate = __webpack_require__(2237);
	
	var _utilDeprecate2 = _interopRequireDefault(_utilDeprecate);
	
	var _addonActions = __webpack_require__(21);
	
	var _addonLinks = __webpack_require__(168);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var action = exports.action = (0, _utilDeprecate2.default)(_addonActions.action, '@storybook/react action is deprecated. See: https://github.com/storybooks/storybook/tree/master/addons/actions');
	
	var linkTo = exports.linkTo = (0, _utilDeprecate2.default)(_addonLinks.linkTo, '@storybook/react linkTo is deprecated. See: https://github.com/storybooks/storybook/tree/master/addons/links');

/***/ },
/* 19 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toDate;
	
	/**
	 * @name toDate
	 * @category Common Helpers
	 * @summary Convert the given argument to an instance of Date.
	 *
	 * @description
	 * Convert the given argument to an instance of Date.
	 *
	 * If the argument is an instance of Date, the function returns its clone.
	 *
	 * If the argument is a number, it is treated as a timestamp.
	 *
	 * If the argument is none of the above, the function returns Invalid Date.
	 *
	 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
	 *
	 * @param {Date|Number} argument - the value to convert
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Clone the date:
	 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert the timestamp to date:
	 * const result = toDate(1392098430000)
	 * //=> Tue Feb 11 2014 11:30:30
	 */
	function toDate(argument) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var argStr = Object.prototype.toString.call(argument); // Clone the date
	
	  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
	    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
	    return new Date(argument.getTime());
	  } else if (typeof argument === 'number' || argStr === '[object Number]') {
	    return new Date(argument);
	  } else {
	    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
	      // eslint-disable-next-line no-console
	      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
	
	      console.warn(new Error().stack);
	    }
	
	    return new Date(NaN);
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Root reference for iframes.
	 */
	
	var root;
	if (typeof window !== 'undefined') { // Browser window
	  root = window;
	} else if (typeof self !== 'undefined') { // Web Worker
	  root = self;
	} else { // Other environments
	  console.warn("Using browser-only version of superagent in non-browser environment");
	  root = this;
	}
	
	var Emitter = __webpack_require__(1315);
	var RequestBase = __webpack_require__(2211);
	var isObject = __webpack_require__(531);
	var isFunction = __webpack_require__(2210);
	var ResponseBase = __webpack_require__(2212);
	
	/**
	 * Noop.
	 */
	
	function noop(){};
	
	/**
	 * Expose `request`.
	 */
	
	var request = exports = module.exports = function(method, url) {
	  // callback
	  if ('function' == typeof url) {
	    return new exports.Request('GET', method).end(url);
	  }
	
	  // url first
	  if (1 == arguments.length) {
	    return new exports.Request('GET', method);
	  }
	
	  return new exports.Request(method, url);
	}
	
	exports.Request = Request;
	
	/**
	 * Determine XHR.
	 */
	
	request.getXHR = function () {
	  if (root.XMLHttpRequest
	      && (!root.location || 'file:' != root.location.protocol
	          || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  throw Error("Browser-only verison of superagent could not find XHR");
	};
	
	/**
	 * Removes leading and trailing whitespace, added to support IE.
	 *
	 * @param {String} s
	 * @return {String}
	 * @api private
	 */
	
	var trim = ''.trim
	  ? function(s) { return s.trim(); }
	  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };
	
	/**
	 * Serialize the given `obj`.
	 *
	 * @param {Object} obj
	 * @return {String}
	 * @api private
	 */
	
	function serialize(obj) {
	  if (!isObject(obj)) return obj;
	  var pairs = [];
	  for (var key in obj) {
	    pushEncodedKeyValuePair(pairs, key, obj[key]);
	  }
	  return pairs.join('&');
	}
	
	/**
	 * Helps 'serialize' with serializing arrays.
	 * Mutates the pairs array.
	 *
	 * @param {Array} pairs
	 * @param {String} key
	 * @param {Mixed} val
	 */
	
	function pushEncodedKeyValuePair(pairs, key, val) {
	  if (val != null) {
	    if (Array.isArray(val)) {
	      val.forEach(function(v) {
	        pushEncodedKeyValuePair(pairs, key, v);
	      });
	    } else if (isObject(val)) {
	      for(var subkey in val) {
	        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
	      }
	    } else {
	      pairs.push(encodeURIComponent(key)
	        + '=' + encodeURIComponent(val));
	    }
	  } else if (val === null) {
	    pairs.push(encodeURIComponent(key));
	  }
	}
	
	/**
	 * Expose serialization method.
	 */
	
	 request.serializeObject = serialize;
	
	 /**
	  * Parse the given x-www-form-urlencoded `str`.
	  *
	  * @param {String} str
	  * @return {Object}
	  * @api private
	  */
	
	function parseString(str) {
	  var obj = {};
	  var pairs = str.split('&');
	  var pair;
	  var pos;
	
	  for (var i = 0, len = pairs.length; i < len; ++i) {
	    pair = pairs[i];
	    pos = pair.indexOf('=');
	    if (pos == -1) {
	      obj[decodeURIComponent(pair)] = '';
	    } else {
	      obj[decodeURIComponent(pair.slice(0, pos))] =
	        decodeURIComponent(pair.slice(pos + 1));
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Expose parser.
	 */
	
	request.parseString = parseString;
	
	/**
	 * Default MIME type map.
	 *
	 *     superagent.types.xml = 'application/xml';
	 *
	 */
	
	request.types = {
	  html: 'text/html',
	  json: 'application/json',
	  xml: 'application/xml',
	  urlencoded: 'application/x-www-form-urlencoded',
	  'form': 'application/x-www-form-urlencoded',
	  'form-data': 'application/x-www-form-urlencoded'
	};
	
	/**
	 * Default serialization map.
	 *
	 *     superagent.serialize['application/xml'] = function(obj){
	 *       return 'generated xml here';
	 *     };
	 *
	 */
	
	 request.serialize = {
	   'application/x-www-form-urlencoded': serialize,
	   'application/json': JSON.stringify
	 };
	
	 /**
	  * Default parsers.
	  *
	  *     superagent.parse['application/xml'] = function(str){
	  *       return { object parsed from str };
	  *     };
	  *
	  */
	
	request.parse = {
	  'application/x-www-form-urlencoded': parseString,
	  'application/json': JSON.parse
	};
	
	/**
	 * Parse the given header `str` into
	 * an object containing the mapped fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function parseHeader(str) {
	  var lines = str.split(/\r?\n/);
	  var fields = {};
	  var index;
	  var line;
	  var field;
	  var val;
	
	  lines.pop(); // trailing CRLF
	
	  for (var i = 0, len = lines.length; i < len; ++i) {
	    line = lines[i];
	    index = line.indexOf(':');
	    field = line.slice(0, index).toLowerCase();
	    val = trim(line.slice(index + 1));
	    fields[field] = val;
	  }
	
	  return fields;
	}
	
	/**
	 * Check if `mime` is json or has +json structured syntax suffix.
	 *
	 * @param {String} mime
	 * @return {Boolean}
	 * @api private
	 */
	
	function isJSON(mime) {
	  return /[\/+]json\b/.test(mime);
	}
	
	/**
	 * Initialize a new `Response` with the given `xhr`.
	 *
	 *  - set flags (.ok, .error, etc)
	 *  - parse header
	 *
	 * Examples:
	 *
	 *  Aliasing `superagent` as `request` is nice:
	 *
	 *      request = superagent;
	 *
	 *  We can use the promise-like API, or pass callbacks:
	 *
	 *      request.get('/').end(function(res){});
	 *      request.get('/', function(res){});
	 *
	 *  Sending data can be chained:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' })
	 *        .end(function(res){});
	 *
	 *  Or passed to `.send()`:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' }, function(res){});
	 *
	 *  Or passed to `.post()`:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' })
	 *        .end(function(res){});
	 *
	 * Or further reduced to a single call for simple cases:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' }, function(res){});
	 *
	 * @param {XMLHTTPRequest} xhr
	 * @param {Object} options
	 * @api private
	 */
	
	function Response(req, options) {
	  options = options || {};
	  this.req = req;
	  this.xhr = this.req.xhr;
	  // responseText is accessible only if responseType is '' or 'text' and on older browsers
	  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
	     ? this.xhr.responseText
	     : null;
	  this.statusText = this.req.xhr.statusText;
	  var status = this.xhr.status;
	  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	  if (status === 1223) {
	      status = 204;
	  }
	  this._setStatusProperties(status);
	  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
	  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
	  // getResponseHeader still works. so we get content-type even if getting
	  // other headers fails.
	  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
	  this._setHeaderProperties(this.header);
	
	  if (null === this.text && req._responseType) {
	    this.body = this.xhr.response;
	  } else {
	    this.body = this.req.method != 'HEAD'
	      ? this._parseBody(this.text ? this.text : this.xhr.response)
	      : null;
	  }
	}
	
	ResponseBase(Response.prototype);
	
	/**
	 * Parse the given body `str`.
	 *
	 * Used for auto-parsing of bodies. Parsers
	 * are defined on the `superagent.parse` object.
	 *
	 * @param {String} str
	 * @return {Mixed}
	 * @api private
	 */
	
	Response.prototype._parseBody = function(str){
	  var parse = request.parse[this.type];
	  if(this.req._parser) {
	    return this.req._parser(this, str);
	  }
	  if (!parse && isJSON(this.type)) {
	    parse = request.parse['application/json'];
	  }
	  return parse && str && (str.length || str instanceof Object)
	    ? parse(str)
	    : null;
	};
	
	/**
	 * Return an `Error` representative of this response.
	 *
	 * @return {Error}
	 * @api public
	 */
	
	Response.prototype.toError = function(){
	  var req = this.req;
	  var method = req.method;
	  var url = req.url;
	
	  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
	  var err = new Error(msg);
	  err.status = this.status;
	  err.method = method;
	  err.url = url;
	
	  return err;
	};
	
	/**
	 * Expose `Response`.
	 */
	
	request.Response = Response;
	
	/**
	 * Initialize a new `Request` with the given `method` and `url`.
	 *
	 * @param {String} method
	 * @param {String} url
	 * @api public
	 */
	
	function Request(method, url) {
	  var self = this;
	  this._query = this._query || [];
	  this.method = method;
	  this.url = url;
	  this.header = {}; // preserves header name case
	  this._header = {}; // coerces header names to lowercase
	  this.on('end', function(){
	    var err = null;
	    var res = null;
	
	    try {
	      res = new Response(self);
	    } catch(e) {
	      err = new Error('Parser is unable to parse the response');
	      err.parse = true;
	      err.original = e;
	      // issue #675: return the raw response if the response parsing fails
	      if (self.xhr) {
	        // ie9 doesn't have 'response' property
	        err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response;
	        // issue #876: return the http status code if the response parsing fails
	        err.status = self.xhr.status ? self.xhr.status : null;
	        err.statusCode = err.status; // backwards-compat only
	      } else {
	        err.rawResponse = null;
	        err.status = null;
	      }
	
	      return self.callback(err);
	    }
	
	    self.emit('response', res);
	
	    var new_err;
	    try {
	      if (!self._isResponseOK(res)) {
	        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
	        new_err.original = err;
	        new_err.response = res;
	        new_err.status = res.status;
	      }
	    } catch(e) {
	      new_err = e; // #985 touching res may cause INVALID_STATE_ERR on old Android
	    }
	
	    // #1000 don't catch errors from the callback to avoid double calling it
	    if (new_err) {
	      self.callback(new_err, res);
	    } else {
	      self.callback(null, res);
	    }
	  });
	}
	
	/**
	 * Mixin `Emitter` and `RequestBase`.
	 */
	
	Emitter(Request.prototype);
	RequestBase(Request.prototype);
	
	/**
	 * Set Content-Type to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.xml = 'application/xml';
	 *
	 *      request.post('/')
	 *        .type('xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 *      request.post('/')
	 *        .type('application/xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 * @param {String} type
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.type = function(type){
	  this.set('Content-Type', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Accept to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.json = 'application/json';
	 *
	 *      request.get('/agent')
	 *        .accept('json')
	 *        .end(callback);
	 *
	 *      request.get('/agent')
	 *        .accept('application/json')
	 *        .end(callback);
	 *
	 * @param {String} accept
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.accept = function(type){
	  this.set('Accept', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Authorization field value with `user` and `pass`.
	 *
	 * @param {String} user
	 * @param {String} pass
	 * @param {Object} options with 'type' property 'auto' or 'basic' (default 'basic')
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.auth = function(user, pass, options){
	  if (!options) {
	    options = {
	      type: 'function' === typeof btoa ? 'basic' : 'auto',
	    }
	  }
	
	  switch (options.type) {
	    case 'basic':
	      this.set('Authorization', 'Basic ' + btoa(user + ':' + pass));
	    break;
	
	    case 'auto':
	      this.username = user;
	      this.password = pass;
	    break;
	  }
	  return this;
	};
	
	/**
	* Add query-string `val`.
	*
	* Examples:
	*
	*   request.get('/shoes')
	*     .query('size=10')
	*     .query({ color: 'blue' })
	*
	* @param {Object|String} val
	* @return {Request} for chaining
	* @api public
	*/
	
	Request.prototype.query = function(val){
	  if ('string' != typeof val) val = serialize(val);
	  if (val) this._query.push(val);
	  return this;
	};
	
	/**
	 * Queue the given `file` as an attachment to the specified `field`,
	 * with optional `options` (or filename).
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} field
	 * @param {Blob|File} file
	 * @param {String|Object} options
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.attach = function(field, file, options){
	  if (this._data) {
	    throw Error("superagent can't mix .send() and .attach()");
	  }
	
	  this._getFormData().append(field, file, options || file.name);
	  return this;
	};
	
	Request.prototype._getFormData = function(){
	  if (!this._formData) {
	    this._formData = new root.FormData();
	  }
	  return this._formData;
	};
	
	/**
	 * Invoke the callback with `err` and `res`
	 * and handle arity check.
	 *
	 * @param {Error} err
	 * @param {Response} res
	 * @api private
	 */
	
	Request.prototype.callback = function(err, res){
	  var fn = this._callback;
	  this.clearTimeout();
	
	  if (err) {
	    this.emit('error', err);
	  }
	
	  fn(err, res);
	};
	
	/**
	 * Invoke callback with x-domain error.
	 *
	 * @api private
	 */
	
	Request.prototype.crossDomainError = function(){
	  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
	  err.crossDomain = true;
	
	  err.status = this.status;
	  err.method = this.method;
	  err.url = this.url;
	
	  this.callback(err);
	};
	
	// This only warns, because the request is still likely to work
	Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function(){
	  console.warn("This is not supported in browser version of superagent");
	  return this;
	};
	
	// This throws, because it can't send/receive data as expected
	Request.prototype.pipe = Request.prototype.write = function(){
	  throw Error("Streaming is not supported in browser version of superagent");
	};
	
	/**
	 * Compose querystring to append to req.url
	 *
	 * @api private
	 */
	
	Request.prototype._appendQueryString = function(){
	  var query = this._query.join('&');
	  if (query) {
	    this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
	  }
	
	  if (this._sort) {
	    var index = this.url.indexOf('?');
	    if (index >= 0) {
	      var queryArr = this.url.substring(index + 1).split('&');
	      if (isFunction(this._sort)) {
	        queryArr.sort(this._sort);
	      } else {
	        queryArr.sort();
	      }
	      this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
	    }
	  }
	};
	
	/**
	 * Check if `obj` is a host object,
	 * we don't want to serialize these :)
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	Request.prototype._isHost = function _isHost(obj) {
	  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
	  return obj && 'object' === typeof obj && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
	}
	
	/**
	 * Initiate request, invoking callback `fn(res)`
	 * with an instanceof `Response`.
	 *
	 * @param {Function} fn
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.end = function(fn){
	  var self = this;
	  var xhr = this.xhr = request.getXHR();
	  var data = this._formData || this._data;
	
	  if (this._endCalled) {
	    console.warn("Warning: .end() was called twice. This is not supported in superagent");
	  }
	  this._endCalled = true;
	
	  // store callback
	  this._callback = fn || noop;
	
	  // state change
	  xhr.onreadystatechange = function(){
	    var readyState = xhr.readyState;
	    if (readyState >= 2 && self._responseTimeoutTimer) {
	      clearTimeout(self._responseTimeoutTimer);
	    }
	    if (4 != readyState) {
	      return;
	    }
	
	    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
	    // result in the error "Could not complete the operation due to error c00c023f"
	    var status;
	    try { status = xhr.status } catch(e) { status = 0; }
	
	    if (!status) {
	      if (self.timedout || self._aborted) return;
	      return self.crossDomainError();
	    }
	    self.emit('end');
	  };
	
	  // progress
	  var handleProgress = function(direction, e) {
	    if (e.total > 0) {
	      e.percent = e.loaded / e.total * 100;
	    }
	    e.direction = direction;
	    self.emit('progress', e);
	  }
	  if (this.hasListeners('progress')) {
	    try {
	      xhr.onprogress = handleProgress.bind(null, 'download');
	      if (xhr.upload) {
	        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
	      }
	    } catch(e) {
	      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
	      // Reported here:
	      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
	    }
	  }
	
	  // querystring
	  this._appendQueryString();
	
	  this._setTimeouts();
	
	  // initiate request
	  try {
	    if (this.username && this.password) {
	      xhr.open(this.method, this.url, true, this.username, this.password);
	    } else {
	      xhr.open(this.method, this.url, true);
	    }
	  } catch (err) {
	    // see #1149
	    return this.callback(err);
	  }
	
	  // CORS
	  if (this._withCredentials) xhr.withCredentials = true;
	
	  // body
	  if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
	    // serialize stuff
	    var contentType = this._header['content-type'];
	    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
	    if (!serialize && isJSON(contentType)) {
	      serialize = request.serialize['application/json'];
	    }
	    if (serialize) data = serialize(data);
	  }
	
	  // set header fields
	  for (var field in this.header) {
	    if (null == this.header[field]) continue;
	    xhr.setRequestHeader(field, this.header[field]);
	  }
	
	  if (this._responseType) {
	    xhr.responseType = this._responseType;
	  }
	
	  // send stuff
	  this.emit('request', this);
	
	  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
	  // We need null here if data is undefined
	  xhr.send(typeof data !== 'undefined' ? data : null);
	  return this;
	};
	
	/**
	 * GET `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.get = function(url, data, fn){
	  var req = request('GET', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * HEAD `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.head = function(url, data, fn){
	  var req = request('HEAD', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * OPTIONS query to `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.options = function(url, data, fn){
	  var req = request('OPTIONS', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * DELETE `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	function del(url, fn){
	  var req = request('DELETE', url);
	  if (fn) req.end(fn);
	  return req;
	};
	
	request['del'] = del;
	request['delete'] = del;
	
	/**
	 * PATCH `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.patch = function(url, data, fn){
	  var req = request('PATCH', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * POST `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.post = function(url, data, fn){
	  var req = request('POST', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PUT `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.put = function(url, data, fn){
	  var req = request('PUT', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.decorateAction = exports.configureActions = exports.action = exports.EVENT_ID = exports.PANEL_ID = exports.ADDON_ID = undefined;
	
	var _preview = __webpack_require__(542);
	
	// addons, panels and events get unique names using a prefix
	var ADDON_ID = exports.ADDON_ID = 'storybook/actions';
	var PANEL_ID = exports.PANEL_ID = ADDON_ID + '/actions-panel';
	var EVENT_ID = exports.EVENT_ID = ADDON_ID + '/action-event';
	
	exports.action = _preview.action;
	exports.configureActions = _preview.configureActions;
	exports.decorateAction = _preview.decorateAction;

/***/ },
/* 22 */
[2252, 29],
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.defaultFilterOptions = exports.defaultClearRenderer = exports.defaultArrowRenderer = exports.defaultMenuRenderer = exports.Option = exports.Value = exports.Creatable = exports.AsyncCreatable = exports.Async = undefined;
	
	var _Select = __webpack_require__(327);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Async = __webpack_require__(926);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _AsyncCreatable = __webpack_require__(2096);
	
	var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);
	
	var _Creatable = __webpack_require__(927);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Value = __webpack_require__(929);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	var _Option = __webpack_require__(928);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _defaultMenuRenderer = __webpack_require__(524);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _defaultArrowRenderer = __webpack_require__(930);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(931);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(523);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_Select2.default.Async = _Async2.default;
	_Select2.default.AsyncCreatable = _AsyncCreatable2.default;
	_Select2.default.Creatable = _Creatable2.default;
	_Select2.default.Value = _Value2.default;
	_Select2.default.Option = _Option2.default;
	
	exports.default = _Select2.default;
	exports.Async = _Async2.default;
	exports.AsyncCreatable = _AsyncCreatable2.default;
	exports.Creatable = _Creatable2.default;
	exports.Value = _Value2.default;
	exports.Option = _Option2.default;
	exports.defaultMenuRenderer = _defaultMenuRenderer2.default;
	exports.defaultArrowRenderer = _defaultArrowRenderer2.default;
	exports.defaultClearRenderer = _defaultClearRenderer2.default;
	exports.defaultFilterOptions = _defaultFilterOptions2.default;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _Notification = __webpack_require__(40);
	
	Object.keys(_Notification).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Notification[key];
	    }
	  });
	});
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Notification2.default;

/***/ },
/* 25 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 26 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toInteger;
	
	function toInteger(dirtyNumber) {
	  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
	    return NaN;
	  }
	
	  var number = Number(dirtyNumber);
	
	  if (isNaN(number)) {
	    return number;
	  }
	
	  return number < 0 ? Math.ceil(number) : Math.floor(number);
	}
	
	module.exports = exports.default;

/***/ },
/* 27 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 28 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.6.9' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 29 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Immutable = factory());
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      if (o !== o || o === Infinity) {
	        return 0;
	      }
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
	      return emptyMap().withMutations(function(map ) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      if (end === Infinity) {
	        end = originalSize;
	      } else {
	        end = end | 0;
	      }
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      if (this._map && !this._map.has(k)) {
	        var defaultVal = this._defaultValues[k];
	        if (v === defaultVal) {
	          return this;
	        }
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findEntry: function(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    findLastEntry: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    keySeq: function() {
	      return Range(0, this.size);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : String(value);
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(1997);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.14.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, function () { 'use strict';
	
	    var hookCallback;
	
	    function utils_hooks__hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        return Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        var k;
	        for (k in obj) {
	            // even if its not own property I'd still call it non-empty
	            return false;
	        }
	        return true;
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function create_utc__createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function valid__isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            m._isValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                m._isValid = m._isValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	        }
	        return m._isValid;
	    }
	
	    function valid__createInvalid (flags) {
	        var m = create_utc__createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = utils_hooks__hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i in momentProperties) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            utils_hooks__hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (utils_hooks__hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (utils_hooks__hooks.deprecationHandler != null) {
	                utils_hooks__hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(arguments).join(', ') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (utils_hooks__hooks.deprecationHandler != null) {
	            utils_hooks__hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    utils_hooks__hooks.suppressDeprecationWarnings = false;
	    utils_hooks__hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function locale_set__set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _ordinalParseLenient.
	        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function locale_calendar__calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relative__relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                get_set__set(this, unit, value);
	                utils_hooks__hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get_set__get(this, unit);
	            }
	        };
	    }
	
	    function get_set__get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function get_set__set (mom, unit, value) {
	        if (mom.isValid()) {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (typeof callback === 'number') {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function units_month__handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = create_utc__createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return units_month__handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (typeof value !== 'number') {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            utils_hooks__hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get_set__get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    utils_hooks__hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        //can't just apply() to create a date:
	        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
	        var date = new Date(y, m, d, h, M, s, ms);
	
	        //the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	            date.setFullYear(y);
	        }
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date = new Date(Date.UTC.apply(null, arguments));
	
	        //the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	            date.setUTCFullYear(y);
	        }
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        return isArray(this._weekdays) ? this._weekdays[m.day()] :
	            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return this._weekdaysShort[m.day()];
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return this._weekdaysMin[m.day()];
	    }
	
	    function day_of_week__handleStrictParse(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = create_utc__createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return day_of_week__handleStrictParse.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = create_utc__createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour he wants. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        ordinalParse: defaultOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
	                // because defineLocale currently also sets the global locale, we
	                // want to undo that for lazy loaded locales
	                locale_locales__getSetGlobalLocale(oldLocale);
	            } catch (e) { }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function locale_locales__getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = locale_locales__getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    // treat as if there is no base config
	                    deprecateSimple('parentLocaleUndefined',
	                            'specified parentLocale is not defined yet. See http://momentjs.com/guides/#/warnings/parent-locale/');
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            // backwards compat for now: also set the locale
	            locale_locales__getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, parentConfig = baseConfig;
	            // MERGE
	            if (locales[name] != null) {
	                parentConfig = locales[name]._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            locale_locales__getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function locale_locales__getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function locale_locales__listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    utils_hooks__hooks.createFromInputFallback = deprecate(
	        'moment construction falls back to js Date. This is ' +
	        'discouraged and will be removed in upcoming major ' +
	        'release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(utils_hooks__hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse)) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
	            week = defaults(w.w, 1);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from begining of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to begining of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    utils_hooks__hooks.ISO_8601 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === utils_hooks__hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!valid__isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || locale_locales__getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return valid__createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!valid__isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (input === undefined) {
	            config._d = new Date(utils_hooks__hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (typeof(input) === 'object') {
	            configFromObject(config);
	        } else if (typeof(input) === 'number') {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (typeof(locale) === 'boolean') {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function local__createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = local__createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return valid__createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = local__createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return valid__createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return local__createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = locale_locales__getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = ((string || '').match(matcher) || []);
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : local__createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            utils_hooks__hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return local__createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    utils_hooks__hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	            } else if (Math.abs(input) < 16) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    utils_hooks__hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm) {
	            this.utcOffset(this._tzm);
	        } else if (typeof this._i === 'string') {
	            this.utcOffset(offsetFromString(matchOffset, this._i));
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? local__createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?\d*)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	    function create__createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (typeof input === 'number') {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])        * sign,
	                h  : toInt(match[HOUR])        * sign,
	                m  : toInt(match[MINUTE])      * sign,
	                s  : toInt(match[SECOND])      * sign,
	                ms : toInt(match[MILLISECOND]) * sign
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    create__createDuration.fn = Duration.prototype;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {milliseconds: 0, months: 0};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = create__createDuration(val, period);
	            add_subtract__addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function add_subtract__addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (days) {
	            get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
	        }
	        if (months) {
	            setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
	        }
	        if (updateOffset) {
	            utils_hooks__hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add_subtract__add      = createAdder(1, 'add');
	    var add_subtract__subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function moment_calendar__calendar (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || local__createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = utils_hooks__hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, local__createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units || 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input,units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input,units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            delta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        if (units === 'year' || units === 'month' || units === 'quarter') {
	            output = monthDiff(this, that);
	            if (units === 'quarter') {
	                output = output / 3;
	            } else if (units === 'year') {
	                output = output / 12;
	            }
	        } else {
	            delta = this - that;
	            output = units === 'second' ? delta / 1e3 : // 1000
	                units === 'minute' ? delta / 6e4 : // 1000 * 60
	                units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	                units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	                units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	                delta;
	        }
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    utils_hooks__hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function moment_format__toISOString () {
	        var m = this.clone().utc();
	        if (0 < m.year() && m.year() <= 9999) {
	            if (isFunction(Date.prototype.toISOString)) {
	                // native implementation is ~50x faster, use it when we can
	                return this.toDate().toISOString();
	            } else {
	                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	            }
	        } else {
	            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	        }
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? utils_hooks__hooks.defaultFormatUtc : utils_hooks__hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 local__createLocal(time).isValid())) {
	            return create__createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(local__createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 local__createLocal(time).isValid())) {
	            return create__createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(local__createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = locale_locales__getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    function startOf (units) {
	        units = normalizeUnits(units);
	        // the following switch intentionally omits break keywords
	        // to utilize falling through the cases.
	        switch (units) {
	            case 'year':
	                this.month(0);
	                /* falls through */
	            case 'quarter':
	            case 'month':
	                this.date(1);
	                /* falls through */
	            case 'week':
	            case 'isoWeek':
	            case 'day':
	            case 'date':
	                this.hours(0);
	                /* falls through */
	            case 'hour':
	                this.minutes(0);
	                /* falls through */
	            case 'minute':
	                this.seconds(0);
	                /* falls through */
	            case 'second':
	                this.milliseconds(0);
	        }
	
	        // weeks are a special case
	        if (units === 'week') {
	            this.weekday(0);
	        }
	        if (units === 'isoWeek') {
	            this.isoWeekday(1);
	        }
	
	        // quarters are also special
	        if (units === 'quarter') {
	            this.month(Math.floor(this.month() / 3) * 3);
	        }
	
	        return this;
	    }
	
	    function endOf (units) {
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond') {
	            return this;
	        }
	
	        // 'date' is an alias for 'day', so it should be considered as such.
	        if (units === 'date') {
	            units = 'day';
	        }
	
	        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	    }
	
	    function to_type__valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function moment_valid__isValid () {
	        return valid__isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIOROITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0], 10);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var momentPrototype__proto = Moment.prototype;
	
	    momentPrototype__proto.add               = add_subtract__add;
	    momentPrototype__proto.calendar          = moment_calendar__calendar;
	    momentPrototype__proto.clone             = clone;
	    momentPrototype__proto.diff              = diff;
	    momentPrototype__proto.endOf             = endOf;
	    momentPrototype__proto.format            = format;
	    momentPrototype__proto.from              = from;
	    momentPrototype__proto.fromNow           = fromNow;
	    momentPrototype__proto.to                = to;
	    momentPrototype__proto.toNow             = toNow;
	    momentPrototype__proto.get               = stringGet;
	    momentPrototype__proto.invalidAt         = invalidAt;
	    momentPrototype__proto.isAfter           = isAfter;
	    momentPrototype__proto.isBefore          = isBefore;
	    momentPrototype__proto.isBetween         = isBetween;
	    momentPrototype__proto.isSame            = isSame;
	    momentPrototype__proto.isSameOrAfter     = isSameOrAfter;
	    momentPrototype__proto.isSameOrBefore    = isSameOrBefore;
	    momentPrototype__proto.isValid           = moment_valid__isValid;
	    momentPrototype__proto.lang              = lang;
	    momentPrototype__proto.locale            = locale;
	    momentPrototype__proto.localeData        = localeData;
	    momentPrototype__proto.max               = prototypeMax;
	    momentPrototype__proto.min               = prototypeMin;
	    momentPrototype__proto.parsingFlags      = parsingFlags;
	    momentPrototype__proto.set               = stringSet;
	    momentPrototype__proto.startOf           = startOf;
	    momentPrototype__proto.subtract          = add_subtract__subtract;
	    momentPrototype__proto.toArray           = toArray;
	    momentPrototype__proto.toObject          = toObject;
	    momentPrototype__proto.toDate            = toDate;
	    momentPrototype__proto.toISOString       = moment_format__toISOString;
	    momentPrototype__proto.toJSON            = toJSON;
	    momentPrototype__proto.toString          = toString;
	    momentPrototype__proto.unix              = unix;
	    momentPrototype__proto.valueOf           = to_type__valueOf;
	    momentPrototype__proto.creationData      = creationData;
	
	    // Year
	    momentPrototype__proto.year       = getSetYear;
	    momentPrototype__proto.isLeapYear = getIsLeapYear;
	
	    // Week Year
	    momentPrototype__proto.weekYear    = getSetWeekYear;
	    momentPrototype__proto.isoWeekYear = getSetISOWeekYear;
	
	    // Quarter
	    momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;
	
	    // Month
	    momentPrototype__proto.month       = getSetMonth;
	    momentPrototype__proto.daysInMonth = getDaysInMonth;
	
	    // Week
	    momentPrototype__proto.week           = momentPrototype__proto.weeks        = getSetWeek;
	    momentPrototype__proto.isoWeek        = momentPrototype__proto.isoWeeks     = getSetISOWeek;
	    momentPrototype__proto.weeksInYear    = getWeeksInYear;
	    momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;
	
	    // Day
	    momentPrototype__proto.date       = getSetDayOfMonth;
	    momentPrototype__proto.day        = momentPrototype__proto.days             = getSetDayOfWeek;
	    momentPrototype__proto.weekday    = getSetLocaleDayOfWeek;
	    momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
	    momentPrototype__proto.dayOfYear  = getSetDayOfYear;
	
	    // Hour
	    momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;
	
	    // Minute
	    momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;
	
	    // Second
	    momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;
	
	    // Millisecond
	    momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;
	
	    // Offset
	    momentPrototype__proto.utcOffset            = getSetOffset;
	    momentPrototype__proto.utc                  = setOffsetToUTC;
	    momentPrototype__proto.local                = setOffsetToLocal;
	    momentPrototype__proto.parseZone            = setOffsetToParsedOffset;
	    momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    momentPrototype__proto.isDST                = isDaylightSavingTime;
	    momentPrototype__proto.isLocal              = isLocal;
	    momentPrototype__proto.isUtcOffset          = isUtcOffset;
	    momentPrototype__proto.isUtc                = isUtc;
	    momentPrototype__proto.isUTC                = isUtc;
	
	    // Timezone
	    momentPrototype__proto.zoneAbbr = getZoneAbbr;
	    momentPrototype__proto.zoneName = getZoneName;
	
	    // Deprecations
	    momentPrototype__proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    momentPrototype__proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    momentPrototype__proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    momentPrototype__proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    var momentPrototype = momentPrototype__proto;
	
	    function moment__createUnix (input) {
	        return local__createLocal(input * 1000);
	    }
	
	    function moment__createInZone () {
	        return local__createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var prototype__proto = Locale.prototype;
	
	    prototype__proto.calendar        = locale_calendar__calendar;
	    prototype__proto.longDateFormat  = longDateFormat;
	    prototype__proto.invalidDate     = invalidDate;
	    prototype__proto.ordinal         = ordinal;
	    prototype__proto.preparse        = preParsePostFormat;
	    prototype__proto.postformat      = preParsePostFormat;
	    prototype__proto.relativeTime    = relative__relativeTime;
	    prototype__proto.pastFuture      = pastFuture;
	    prototype__proto.set             = locale_set__set;
	
	    // Month
	    prototype__proto.months            =        localeMonths;
	    prototype__proto.monthsShort       =        localeMonthsShort;
	    prototype__proto.monthsParse       =        localeMonthsParse;
	    prototype__proto.monthsRegex       = monthsRegex;
	    prototype__proto.monthsShortRegex  = monthsShortRegex;
	
	    // Week
	    prototype__proto.week = localeWeek;
	    prototype__proto.firstDayOfYear = localeFirstDayOfYear;
	    prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;
	
	    // Day of Week
	    prototype__proto.weekdays       =        localeWeekdays;
	    prototype__proto.weekdaysMin    =        localeWeekdaysMin;
	    prototype__proto.weekdaysShort  =        localeWeekdaysShort;
	    prototype__proto.weekdaysParse  =        localeWeekdaysParse;
	
	    prototype__proto.weekdaysRegex       =        weekdaysRegex;
	    prototype__proto.weekdaysShortRegex  =        weekdaysShortRegex;
	    prototype__proto.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    // Hours
	    prototype__proto.isPM = localeIsPM;
	    prototype__proto.meridiem = localeMeridiem;
	
	    function lists__get (format, index, field, setter) {
	        var locale = locale_locales__getLocale();
	        var utc = create_utc__createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (typeof format === 'number') {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return lists__get(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = lists__get(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (typeof format === 'number') {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (typeof format === 'number') {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = locale_locales__getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return lists__get(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = lists__get(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function lists__listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function lists__listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function lists__listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function lists__listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function lists__listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    locale_locales__getSetGlobalLocale('en', {
	        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	    utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
	    utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);
	
	    var mathAbs = Math.abs;
	
	    function duration_abs__abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function duration_add_subtract__addSubtract (duration, input, value, direction) {
	        var other = create__createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function duration_add_subtract__add (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function duration_add_subtract__subtract (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'year') {
	            days   = this._days   + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            return units === 'month' ? months : months / 12;
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function duration_as__valueOf () {
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asYears        = makeAs('y');
	
	    function duration_get__get (units) {
	        units = normalizeUnits(units);
	        return this[units + 's']();
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this._data[name];
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        s: 45,  // seconds to minute
	        m: 45,  // minutes to hour
	        h: 22,  // hours to day
	        d: 26,  // days to month
	        M: 11   // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function duration_humanize__relativeTime (posNegDuration, withoutSuffix, locale) {
	        var duration = create__createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds < thresholds.s && ['s', seconds]  ||
	                minutes <= 1           && ['m']           ||
	                minutes < thresholds.m && ['mm', minutes] ||
	                hours   <= 1           && ['h']           ||
	                hours   < thresholds.h && ['hh', hours]   ||
	                days    <= 1           && ['d']           ||
	                days    < thresholds.d && ['dd', days]    ||
	                months  <= 1           && ['M']           ||
	                months  < thresholds.M && ['MM', months]  ||
	                years   <= 1           && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function duration_humanize__getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function duration_humanize__getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        var locale = this.localeData();
	        var output = duration_humanize__relativeTime(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var iso_string__abs = Math.abs;
	
	    function iso_string__toISOString() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        var seconds = iso_string__abs(this._milliseconds) / 1000;
	        var days         = iso_string__abs(this._days);
	        var months       = iso_string__abs(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds;
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        return (total < 0 ? '-' : '') +
	            'P' +
	            (Y ? Y + 'Y' : '') +
	            (M ? M + 'M' : '') +
	            (D ? D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? h + 'H' : '') +
	            (m ? m + 'M' : '') +
	            (s ? s + 'S' : '');
	    }
	
	    var duration_prototype__proto = Duration.prototype;
	
	    duration_prototype__proto.abs            = duration_abs__abs;
	    duration_prototype__proto.add            = duration_add_subtract__add;
	    duration_prototype__proto.subtract       = duration_add_subtract__subtract;
	    duration_prototype__proto.as             = as;
	    duration_prototype__proto.asMilliseconds = asMilliseconds;
	    duration_prototype__proto.asSeconds      = asSeconds;
	    duration_prototype__proto.asMinutes      = asMinutes;
	    duration_prototype__proto.asHours        = asHours;
	    duration_prototype__proto.asDays         = asDays;
	    duration_prototype__proto.asWeeks        = asWeeks;
	    duration_prototype__proto.asMonths       = asMonths;
	    duration_prototype__proto.asYears        = asYears;
	    duration_prototype__proto.valueOf        = duration_as__valueOf;
	    duration_prototype__proto._bubble        = bubble;
	    duration_prototype__proto.get            = duration_get__get;
	    duration_prototype__proto.milliseconds   = milliseconds;
	    duration_prototype__proto.seconds        = seconds;
	    duration_prototype__proto.minutes        = minutes;
	    duration_prototype__proto.hours          = hours;
	    duration_prototype__proto.days           = days;
	    duration_prototype__proto.weeks          = weeks;
	    duration_prototype__proto.months         = months;
	    duration_prototype__proto.years          = years;
	    duration_prototype__proto.humanize       = humanize;
	    duration_prototype__proto.toISOString    = iso_string__toISOString;
	    duration_prototype__proto.toString       = iso_string__toISOString;
	    duration_prototype__proto.toJSON         = iso_string__toISOString;
	    duration_prototype__proto.locale         = locale;
	    duration_prototype__proto.localeData     = localeData;
	
	    // Deprecations
	    duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
	    duration_prototype__proto.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    utils_hooks__hooks.version = '2.14.1';
	
	    setHookCallback(local__createLocal);
	
	    utils_hooks__hooks.fn                    = momentPrototype;
	    utils_hooks__hooks.min                   = min;
	    utils_hooks__hooks.max                   = max;
	    utils_hooks__hooks.now                   = now;
	    utils_hooks__hooks.utc                   = create_utc__createUTC;
	    utils_hooks__hooks.unix                  = moment__createUnix;
	    utils_hooks__hooks.months                = lists__listMonths;
	    utils_hooks__hooks.isDate                = isDate;
	    utils_hooks__hooks.locale                = locale_locales__getSetGlobalLocale;
	    utils_hooks__hooks.invalid               = valid__createInvalid;
	    utils_hooks__hooks.duration              = create__createDuration;
	    utils_hooks__hooks.isMoment              = isMoment;
	    utils_hooks__hooks.weekdays              = lists__listWeekdays;
	    utils_hooks__hooks.parseZone             = moment__createInZone;
	    utils_hooks__hooks.localeData            = locale_locales__getLocale;
	    utils_hooks__hooks.isDuration            = isDuration;
	    utils_hooks__hooks.monthsShort           = lists__listMonthsShort;
	    utils_hooks__hooks.weekdaysMin           = lists__listWeekdaysMin;
	    utils_hooks__hooks.defineLocale          = defineLocale;
	    utils_hooks__hooks.updateLocale          = updateLocale;
	    utils_hooks__hooks.locales               = locale_locales__listLocales;
	    utils_hooks__hooks.weekdaysShort         = lists__listWeekdaysShort;
	    utils_hooks__hooks.normalizeUnits        = normalizeUnits;
	    utils_hooks__hooks.relativeTimeRounding = duration_humanize__getSetRelativeTimeRounding;
	    utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;
	    utils_hooks__hooks.calendarFormat        = getCalendarFormat;
	    utils_hooks__hooks.prototype             = momentPrototype;
	
	    var _moment = utils_hooks__hooks;
	
	    return _moment;
	
	}));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 33 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var asyncTypes = ['REQUEST', 'SUCCESS', 'ERROR'];
	
	var createAsyncTypes = exports.createAsyncTypes = function createAsyncTypes(actionString) {
	  return asyncTypes.reduce(function (result, asyncType) {
	    result[asyncType] = actionString + '_' + asyncType;
	    return result;
	  }, {});
	};
	
	var createReducer = exports.createReducer = function createReducer(initialState, handlers) {
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    var handler = handlers[action.type];
	
	    return handler ? handler(state, action) : state;
	  };
	};

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIs = __webpack_require__(2022);
	
	var _createChainableTypeChecker = __webpack_require__(317);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function elementType(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`,expected an element type (a string ') + ', component class, or function component).');
	  }
	
	  if (!(0, _reactIs.isValidElementType)(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + ', component class, or function component).');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(elementType);
	module.exports = exports['default'];

/***/ },
/* 35 */
5,
/* 36 */
[2311, 222, 152, 25],
/* 37 */
[2304, 88],
/* 38 */
[2261, 27],
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(44);
	var core = __webpack_require__(28);
	var ctx = __webpack_require__(115);
	var hide = __webpack_require__(118);
	var has = __webpack_require__(117);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.notify = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactToastify = __webpack_require__(2113);
	
	__webpack_require__(2176);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Notification = function Notification() {
	  return _react2.default.createElement(_reactToastify.ToastContainer, { position: 'top-center', autoClose: 3500, newestOnTop: true, draggable: false });
	};
	
	var notify = exports.notify = Object.assign(function (content, options) {
	  return (0, _reactToastify.toast)(content, options);
	}, _extends({}, _reactToastify.toast));
	
	notify.success = function (content, options) {
	  return _reactToastify.toast.success(content, _extends({
	    position: 'bottom-left',
	    className: 'notify-toast'
	  }, options));
	};
	
	notify.info = function (content, options) {
	  return _reactToastify.toast.info(content, _extends({
	    position: 'bottom-left',
	    className: 'notify-toast'
	  }, options));
	};
	
	notify.error = function (content, options) {
	  return _reactToastify.toast.error(content, _extends({
	    autoClose: false,
	    hideProgressBar: true,
	    className: 'notify-toast'
	  }, options));
	};
	
	notify.warn = function (content, options) {
	  return _reactToastify.toast.warn(content, _extends({
	    autoClose: false,
	    hideProgressBar: true,
	    className: 'notify-toast'
	  }, options));
	};
	
	exports.default = Notification;

/***/ },
/* 41 */
[2280, 22, 784, 99, 38],
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.deleteAndRepurchase = exports.updateRedact = exports.filterDocketEntries = exports.buyPdf = exports.sendEmail = exports.getDocketHeader = exports.getDocketParts = exports.emailPartsPdfCombined = exports.emailPartsZip = exports.previewPdf = exports.downloadPdfCombined = exports.downloadPdfCombinedZipped = exports.downloadPdfZip = exports.buyAllParts = exports.updateFavoriteEmails = exports.loadLastFavoriteEmails = exports.loadFavoriteEmails = exports.togglePopup = exports.updatePopup = exports.updateDocketParts = exports.resetDocketParts = exports.purchaseDockets = exports.orderPdf = exports.getDocuments = exports.getDockets = exports.getPartsPurchaseInfo = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.onFailure = onFailure;
	exports.getDocketsFromResp = getDocketsFromResp;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _moment = __webpack_require__(32);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _irSearchActionTypes = __webpack_require__(138);
	
	var types = _interopRequireWildcard(_irSearchActionTypes);
	
	var _docketsActionTypes = __webpack_require__(177);
	
	var docketActionTypes = _interopRequireWildcard(_docketsActionTypes);
	
	var _irSearchActions = __webpack_require__(71);
	
	var _Notification = __webpack_require__(24);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function onFailure(responseError) {
	  return function (dispatch) {
	    console.error(responseError);
	
	    var bodyError = _lodash2.default.get(responseError, ['response', 'body', 'error']) || [];
	    var request_id = _lodash2.default.get(responseError, ['response', 'body', 'request_id']);
	    var errorMessageExtra = request_id ? 'When contacting support, please quote Request ID \'' + request_id + '\'' : '';
	
	    // looks like status 400 is for validation errors and we show it 'as is' to the user
	    if (bodyError.status === 400 && bodyError.detail) {
	      return _Notification.notify.error(bodyError.detail);
	    }
	
	    var errorMessages = {
	      // We want to hide real messages from user since traces are confusing to them
	      messages: ['Application is experiencing some issues. Please try again in a few minutes.', errorMessageExtra],
	      // but we include the real message in the details so we receive it in the sentry report
	      details: bodyError.detail ? [bodyError.detail] : [bodyError]
	    };
	
	    return dispatch({ type: types.SERVICE_ERROR, errors: errorMessages });
	  };
	}
	
	function getDocketsFromResp(response) {
	  var dockets = response.body;
	
	  var showMissingDockets = false;
	
	  // if there are any missing dockets for the case, show the missing dockets panel
	  if (dockets.docket_gaps && dockets.docket_gaps.length > 0) {
	    showMissingDockets = true;
	  }
	
	  var content = [];
	
	  // mark all items as visible when first pulled from service
	  if (dockets.entries && dockets.entries.content) {
	    content = dockets.entries.content.reduce(function (accum, next) {
	      accum.push(_extends({}, next, { isVisible: true }));
	
	      // check if the next entry is a missing docket
	      var missing = dockets.docket_gaps.find(function (d) {
	        return d.gap_end + 1 === next.docket_no;
	      });
	      if (missing) {
	        accum.push({ missing: missing });
	      }
	
	      return accum;
	    }, []);
	  }
	
	  delete dockets.entries.content;
	
	  dockets.entries.data = content;
	  dockets.entries.showMissingDockets = showMissingDockets;
	
	  return dockets;
	}
	
	function hasMoreRecentFilingsDate(header) {
	  var latest_known_date_filed = header.latest_known_date_filed,
	      latest_known_history_date_filed = header.latest_known_history_date_filed,
	      latest_docket_number = header.latest_docket_number,
	      latest_history_number = header.latest_history_number;
	
	  return (0, _moment2.default)(latest_known_history_date_filed, 'MM/DD/YYYY') > (0, _moment2.default)(latest_known_date_filed, 'MM/DD/YYYY') || parseInt(latest_docket_number, 10) < parseInt(latest_history_number, 10);
	}
	
	var getPartsPurchaseInfo = exports.getPartsPurchaseInfo = function getPartsPurchaseInfo(params) {
	  return function (dispatch, getState) {
	    function onSuccess(response) {
	      if (!_lodash2.default.isEmpty(response.body.error)) {
	        return dispatch(onFailure({ response: response }));
	      }
	
	      var _getState$get$toJS = getState().get('dockets').toJS(),
	          entries = _getState$get$toJS.entries;
	
	      var updatedEntriesData = entries.data.map(function (docket) {
	        if (params.case_docket_sequence_numbers[0].sequence_numbers.includes(docket.docket_seq)) {
	          // default to in-pacer
	          docket.colorCode = 'in-pacer';
	
	          var docket_seq = docket.docket_seq;
	
	          var responseEntry = _lodash2.default.find(response.body, { sequence_number: docket_seq });
	
	          if (responseEntry) {
	            if (responseEntry.has_user_purchased_any_document) {
	              docket.colorCode = 'purchased';
	            } else {
	              docket.colorCode = 'in-inforuptcy';
	            }
	          }
	        }
	        return docket;
	      });
	
	      dispatch({
	        type: docketActionTypes.UPDATE_DOCKETS,
	        entries: _extends({}, entries, { status: 'done', data: updatedEntriesData })
	      });
	
	      return Promise.resolve(response.body);
	    }
	
	    return _superagent2.default.post('/rpc/dockets/purchase_info').set('Accept', 'application/json').send(params).then(onSuccess, function (responseError) {
	      return dispatch(onFailure(responseError));
	    });
	  };
	};
	
	var getDockets = function getDockets(_ref) {
	  var receipt = _ref.receipt,
	      params = _objectWithoutProperties(_ref, ['receipt']);
	
	  return function (dispatch, getState) {
	    dispatch({
	      type: types.RESET_SERVICE_ERROR
	    });
	
	    dispatch({
	      type: docketActionTypes.UPDATE_DOCKETS,
	      header: { status: 'loading' },
	      entries: { status: 'loading' }
	    });
	
	    dispatch({
	      type: docketActionTypes.SET_RECEIPT,
	      receipt: receipt || {}
	    });
	
	    dispatch({
	      type: docketActionTypes.UPDATE_SELECTED_DOCKET,
	      selectedDocket: {
	        status: 'done',
	        docket_no: null,
	        docket_seq: null,
	        binder: {}
	      }
	    });
	
	    var queryString = _extends({
	      sort_order: 'desc',
	      sort_column: 'date_filed',
	      include_gaps: true,
	      include_binders: false
	    }, params);
	
	    // remove empty properties from params
	    // service for whatever reason throws error if sending null param values
	    var queryStringNullRemoved = _lodash2.default.omitBy(queryString, _lodash2.default.isNil);
	    var case_number = params.case_number,
	        court_code = params.court_code;
	
	
	    return _superagent2.default.get('/rpc/capi/cases/pacer/' + court_code + '/' + case_number + '/dockets').query(queryStringNullRemoved).then(function (response) {
	      if (!_lodash2.default.isEmpty(response.body.error)) {
	        dispatch({
	          type: docketActionTypes.UPDATE_DOCKETS,
	          header: { status: '' },
	          entries: { status: '' }
	        });
	
	        return dispatch(onFailure({ response: response }));
	      }
	
	      var dockets = getDocketsFromResp(response);
	
	      if (dockets.header) {
	        dockets.header.hasMoreRecentFilingsDate = hasMoreRecentFilingsDate(dockets.header);
	      }
	
	      var entries = dockets.entries,
	          header = dockets.header,
	          links = dockets.links;
	
	      // using existing of header data to determine if it's actually done and ready to display
	
	      var headerStatus = header.html ? 'done' : '';
	
	      dispatch({
	        type: docketActionTypes.UPDATE_DOCKETS,
	        entries: _extends({ status: 'done' }, entries),
	        header: _extends({ status: headerStatus }, header),
	        links: links
	      });
	
	      // if contains entries, then refresh the purchseInfo so we can color the docket numbers
	      if (entries.data && entries.data.length > 0) {
	        var seqNumbers = _lodash2.default.get(entries, 'data').reduce(function (accum, next) {
	          if (next.docket_seq) {
	            accum.push(next.docket_seq);
	          }
	          return accum;
	        }, []);
	
	        var purchaseInfoParams = {
	          case_docket_sequence_numbers: [{
	            court_code: court_code,
	            case_number: case_number,
	            sequence_numbers: seqNumbers
	          }]
	        };
	        return getPartsPurchaseInfo(purchaseInfoParams)(dispatch, getState);
	      }
	
	      return Promise.resolve(response.body);
	    }, function (responseError) {
	      dispatch({
	        type: docketActionTypes.UPDATE_DOCKETS,
	        header: { status: 'done' },
	        entries: { status: 'done' }
	      });
	      return dispatch(onFailure(responseError));
	    });
	  };
	};
	
	/*
	function getDocumentsFromDockets(docketEntriesData, docket_no) {
	  return _.chain(docketEntriesData)
	    .filter(docket => docket.docket_no === docket_no)
	    .map(docket => docket.binder.documents)
	    .flatten()
	    .value();
	}
	*/
	
	exports.getDockets = getDockets;
	var getDocumentsFromPacer = function getDocumentsFromPacer(_ref2) {
	  var court_code = _ref2.court_code,
	      case_number = _ref2.case_number,
	      docket_no = _ref2.docket_no,
	      docket_seq = _ref2.docket_seq;
	  return function (dispatch) {
	    dispatch({
	      type: types.RESET_SERVICE_ERROR
	    });
	
	    dispatch({
	      type: docketActionTypes.FETCH_DOCUMENTS.REQUEST,
	      selectedDocket: {
	        status: 'loading',
	        docket_no: docket_no,
	        docket_seq: docket_seq
	      }
	    });
	
	    function onError(responseError) {
	      dispatch({
	        type: docketActionTypes.FETCH_DOCUMENTS.ERROR,
	        selectedDocket: {
	          status: 'done',
	          docket_no: docket_no,
	          docket_seq: docket_seq,
	          binder: {}
	        }
	      });
	
	      return dispatch(onFailure(responseError));
	    }
	
	    function onSuccess(response) {
	      if (response.body && !_lodash2.default.isEmpty(response.body.error)) {
	        return onError({ response: response });
	      }
	
	      dispatch({
	        type: docketActionTypes.FETCH_DOCUMENTS.SUCCESS,
	        selectedDocket: {
	          status: 'done',
	          docket_no: docket_no,
	          docket_seq: docket_seq,
	          binder: response.body
	        }
	      });
	
	      var purchaseInfoParams = {
	        case_docket_sequence_numbers: [{
	          court_code: court_code,
	          case_number: case_number,
	          sequence_numbers: [docket_seq]
	        }]
	      };
	      dispatch(getPartsPurchaseInfo(purchaseInfoParams));
	    }
	
	    var docketSeq = parseFloat(docket_seq) > 0 ? docket_seq : null;
	    var docketNumber = parseInt(docket_no, 10) > 0 ? docket_no : docketSeq;
	    if (!docketNumber) return onError();
	
	    return _superagent2.default.post('/rpc/capi/cases/pacer/' + court_code + '/' + case_number + '/dockets/' + docketNumber + '/documents').then(onSuccess, onError);
	  };
	};
	
	var getDocumentsFromLocalDB = function getDocumentsFromLocalDB(_ref3) {
	  var court_code = _ref3.court_code,
	      case_number = _ref3.case_number,
	      docket_no = _ref3.docket_no,
	      docket_seq = _ref3.docket_seq;
	  return function (dispatch) {
	    dispatch({
	      type: types.RESET_SERVICE_ERROR
	    });
	
	    dispatch({
	      type: docketActionTypes.FETCH_DOCUMENTS.REQUEST,
	      selectedDocket: {
	        status: 'loading',
	        docket_no: docket_no,
	        docket_seq: docket_seq
	      }
	    });
	
	    function onError(responseError) {
	      dispatch({
	        type: docketActionTypes.FETCH_DOCUMENTS.ERROR,
	        selectedDocket: {
	          status: 'done',
	          docket_no: docket_no,
	          docket_seq: docket_seq,
	          binder: {}
	        }
	      });
	
	      return dispatch(onFailure(responseError));
	    }
	
	    function onSuccess(response) {
	      if (response.body && !_lodash2.default.isEmpty(response.body.error)) {
	        return onError({ response: response });
	      }
	
	      if (response.body.documents && response.body.documents.length === 0) {
	        return dispatch(getDocumentsFromPacer({ court_code: court_code, case_number: case_number, docket_no: docket_no, docket_seq: docket_seq }));
	      }
	
	      dispatch({
	        type: docketActionTypes.FETCH_DOCUMENTS.SUCCESS,
	        selectedDocket: {
	          status: 'done',
	          docket_no: docket_no,
	          docket_seq: docket_seq,
	          binder: response.body
	        }
	      });
	
	      var purchaseInfoParams = {
	        case_docket_sequence_numbers: [{
	          court_code: court_code,
	          case_number: case_number,
	          sequence_numbers: [docket_seq]
	        }]
	      };
	      dispatch(getPartsPurchaseInfo(purchaseInfoParams));
	    }
	
	    var docketNumber = parseInt(docket_no, 10) ? docket_no : docket_seq;
	
	    return _superagent2.default.get('/rpc/capi/cases/pacer/' + court_code + '/' + case_number + '/dockets/' + docketNumber + '/documents').then(onSuccess, onError);
	  };
	};
	
	var getDocuments = exports.getDocuments = function getDocuments(_ref4) {
	  var court_code = _ref4.court_code,
	      case_number = _ref4.case_number,
	      docket_no = _ref4.docket_no,
	      docket_seq = _ref4.docket_seq;
	  return function (dispatch, getState) {
	    if (!docket_seq) {
	      return;
	    }
	
	    // check for documents in existing entries
	    var cachedDocket = getState().getIn(['dockets', 'entries', 'data']).find(function (docket) {
	      return docket.get('docket_seq') === docket_seq;
	    });
	
	    if (cachedDocket && cachedDocket.getIn(['binder', 'documents', 0])) {
	      return dispatch({
	        type: docketActionTypes.UPDATE_SELECTED_DOCKET,
	        selectedDocket: _extends({
	          status: 'done',
	          docket_no: docket_no
	        }, cachedDocket.toJS())
	      });
	    }
	
	    // retrieve from pacer
	    return dispatch(getDocumentsFromLocalDB({ court_code: court_code, case_number: case_number, docket_no: docket_no, docket_seq: docket_seq }));
	  };
	};
	
	// this is basically just a passthrough from the document response, located in links.order_pdf
	// adding it here so we can update the state of the documents to inlcude the download links
	var orderPdf = exports.orderPdf = function orderPdf(document, seqNum) {
	  return function (dispatch) {
	    var url = document.links.order_pdf.href;
	    var rpcLinkSegment = '/rpc/' + url.split('/rpc/')[1];
	
	    dispatch({
	      type: docketActionTypes.UPDATE_DOCUMENT,
	      seqNum: seqNum,
	      document: _extends({}, document, { isLoading: true })
	    });
	
	    function onSuccess(response) {
	      if (response.body && !_lodash2.default.isEmpty(response.body.error)) {
	        return dispatch(onFailure({ response: response }));
	      }
	
	      var updatedDocument = response.body.document;
	
	
	      dispatch({
	        type: docketActionTypes.UPDATE_DOCUMENT,
	        seqNum: updatedDocument.docket_no,
	        document: _extends({}, updatedDocument, { isLoading: false })
	      });
	
	      return Promise.resolve(updatedDocument);
	    }
	
	    return (0, _superagent2.default)(rpcLinkSegment).then(onSuccess, function (responseError) {
	      return dispatch(onFailure(responseError));
	    });
	  };
	};
	
	var purchaseDockets = exports.purchaseDockets = function purchaseDockets(params) {
	  return function (dispatch, getState) {
	    var court_code = params.court_code,
	        case_number = params.case_number;
	
	
	    dispatch({
	      type: docketActionTypes.UPDATE_DOCKETS,
	      header: { status: 'loading' },
	      entries: { status: 'loading' }
	    });
	
	    var currentState = getState().toJS();
	    var clientCode = currentState.clientCodeReducer.sessionClientCode;
	    var pacer_client = _lodash2.default.isEmpty(clientCode) ? window.Drupal.settings.clientCode : clientCode;
	
	    function onSuccess(response) {
	      if (!_lodash2.default.isEmpty(response.body.error)) {
	        return dispatch(onFailure({ response: response }));
	      }
	
	      var receipt = _lodash2.default.get(response.body, 'receipts', {});
	      receipt.screenshot = _lodash2.default.get(response.body, 'links.screenshot', {});
	
	      dispatch({
	        type: docketActionTypes.SET_RECEIPT,
	        receipt: receipt
	      });
	
	      return Promise.resolve(receipt);
	    }
	
	    var paramsStringNullRemoved = _lodash2.default.omitBy(_extends({}, params, { pacer_client: pacer_client }), _lodash2.default.isNil);
	
	    return _superagent2.default.post('/rpc/capi/cases/pacer/' + court_code + '/' + case_number + '/dockets/update').type('form').send(paramsStringNullRemoved)
	    // .set('Accept', 'application/json')
	    .then(onSuccess, function (responseError) {
	      return dispatch(onFailure(responseError));
	    });
	  };
	};
	
	var resetDocketParts = exports.resetDocketParts = function resetDocketParts() {
	  return function (dispatch) {
	    return dispatch({ type: docketActionTypes.RESET_DOCKETS_PARTS });
	  };
	};
	
	var updateDocketParts = exports.updateDocketParts = function updateDocketParts(docketParts) {
	  return function (dispatch) {
	    return dispatch({
	      type: docketActionTypes.UPDATE_DOCKETS_PARTS,
	      docketParts: docketParts
	    });
	  };
	};
	
	var updatePopup = exports.updatePopup = function updatePopup(popup) {
	  return function (dispatch) {
	    return dispatch({
	      type: docketActionTypes.DOCKETS_POPUP,
	      popup: popup
	    });
	  };
	};
	
	var togglePopup = exports.togglePopup = function togglePopup() {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function (dispatch) {
	    dispatch(resetDocketParts());
	
	    var popup = params.show ? _extends({}, params) : { show: false };
	    dispatch(updatePopup(popup));
	  };
	};
	
	var loadFavoriteEmails = exports.loadFavoriteEmails = function loadFavoriteEmails() {
	  return function (dispatch, getState) {
	    var m = getState();
	
	    dispatch({
	      type: docketActionTypes.DOCKETS_FAVORITE_EMAILS,
	      favoriteEmails: { emails: [], status: 'loading' }
	    });
	
	    return _superagent2.default.get('/rpc/session/user/docket/emails?sort=popular').set('Accept', 'application/json').then(function (response) {
	      var _m$toJS$irSearch = m.toJS().irSearch,
	          data = _m$toJS$irSearch.data,
	          lastUpdated = _m$toJS$irSearch.lastUpdated,
	          receipt = _m$toJS$irSearch.receipt;
	
	      data.push(['favoriteEmails', response.body]);
	
	      // TODO: do we still need this?
	      dispatch({
	        type: types.RECEIVE_CASE_DATA,
	        data_type: 'dockets',
	        data: data,
	        lastUpdated: lastUpdated,
	        receipt: receipt
	      });
	
	      dispatch({
	        type: docketActionTypes.DOCKETS_FAVORITE_EMAILS,
	        favoriteEmails: { emails: response.body, status: 'done' }
	      });
	    }, function (responseError) {
	      dispatch(onFailure(responseError));
	      dispatch({
	        type: docketActionTypes.DOCKETS_FAVORITE_EMAILS,
	        favoriteEmails: { emails: [], status: 'done' }
	      });
	    });
	  };
	};
	
	var loadLastFavoriteEmails = exports.loadLastFavoriteEmails = function loadLastFavoriteEmails() {
	  return function (dispatch) {
	    dispatch({
	      type: docketActionTypes.DOCKETS_FAVORITE_EMAILS,
	      favoriteEmails: { lastRecipients: [], status: 'loading' }
	    });
	
	    return _superagent2.default.get('/rpc/session/user/docket/emails/last_recipients').set('Accept', 'application/json').then(function (response) {
	      dispatch({
	        type: docketActionTypes.DOCKETS_FAVORITE_EMAILS,
	        favoriteEmails: { lastRecipients: response.body, status: 'done' }
	      });
	    }, function (responseError) {
	      dispatch(onFailure(responseError));
	      dispatch({
	        type: docketActionTypes.DOCKETS_FAVORITE_EMAILS,
	        favoriteEmails: { lastRecipients: [], status: 'done' }
	      });
	    });
	  };
	};
	
	var updateFavoriteEmails = exports.updateFavoriteEmails = function updateFavoriteEmails(_ref5) {
	  var email_addresses = _ref5.email_addresses;
	  return function (dispatch) {
	    dispatch({
	      type: docketActionTypes.DOCKETS_FAVORITE_EMAILS,
	      favoriteEmails: { status: 'loading' }
	    });
	
	    return _superagent2.default.post('/rpc/session/user/docket/emails').send({ email_addresses: email_addresses }).then(function () {
	      dispatch({
	        type: docketActionTypes.DOCKETS_FAVORITE_EMAILS,
	        favoriteEmails: {
	          lastRecipients: email_addresses,
	          status: 'done'
	        }
	      });
	    }).catch(function (responseError) {
	      dispatch(onFailure(responseError));
	      dispatch({
	        type: docketActionTypes.DOCKETS_FAVORITE_EMAILS,
	        favoriteEmails: {
	          lastRecipients: email_addresses,
	          status: 'done'
	        }
	      });
	    });
	  };
	};
	
	// Taken from https://gist.github.com/joepie91/2664c85a744e6bd0629c#gistcomment-1787629
	var wait = function wait(ms) {
	  return new Promise(function (resolve) {
	    return setTimeout(resolve, ms);
	  });
	};
	
	function rpcProgress(url, dispatch, getState) {
	  return _superagent2.default.get(url).set('Accept', 'application/json').then(function (response) {
	    if (response.accepted) {
	      // still processing, update percentage so progress bar updates.
	      var percentage = Math.floor(response.body.task_progress);
	
	      var state = getState().toJS();
	
	      var docketParts = _extends({}, state.dockets.docketParts, {
	        percentage: percentage
	      });
	
	      dispatch({
	        type: docketActionTypes.UPDATE_DOCKETS_PARTS,
	        docketParts: docketParts
	      });
	
	      // wait 0.5s and then update progress again
	      return wait(500).then(function () {
	        return rpcProgress(url, dispatch, getState);
	      });
	    }
	
	    // when progress finishes, it returns a 302 response to the actual results, but it appears that  superagent
	    // follows that redirect for us, so we should have a 200 response here
	    if (response.status !== 200) {
	      return dispatch(onFailure({ response: response }));
	    }
	
	    return Promise.resolve(response.body);
	  }, function (responseError) {
	    return dispatch(onFailure(responseError));
	  });
	}
	
	var buyAllParts = exports.buyAllParts = function buyAllParts(params) {
	  return function (dispatch, getState) {
	    var currentState = getState().toJS();
	    var prevDocketParts = currentState.dockets.docketParts;
	    var clientCode = currentState.clientCodeReducer.sessionClientCode;
	    var pacer_client = _lodash2.default.isEmpty(clientCode) ? window.Drupal.settings.clientCode : clientCode;
	
	    params = _extends({}, params, { pacer_client: pacer_client });
	
	    dispatch({
	      type: docketActionTypes.UPDATE_DOCKETS_PARTS,
	      docketParts: _extends({}, prevDocketParts, {
	        status: 'loading',
	        step: 2,
	        percentage: 0
	      })
	    });
	
	    var purchaseParams = {
	      documents: params.documents,
	      pacer_client: pacer_client
	    };
	
	    return _superagent2.default.post('/rpc/dockets/documents/purchase').type('json').send(purchaseParams).then(function (response) {
	      if (!response.accepted || _lodash2.default.isEmpty(response.header.location)) {
	        return dispatch(onFailure({ response: response }));
	      }
	
	      return rpcProgress(response.header.location, dispatch, getState);
	    }, function (responseError) {
	      return dispatch(onFailure(responseError));
	    }).then(function (purchaseResponse) {
	      if (purchaseResponse.errors.length > 0) {
	        var errors = _lodash2.default.uniq(purchaseResponse.errors.map(function (_ref6) {
	          var error = _ref6.error;
	          return error;
	        }));
	        dispatch({
	          type: docketActionTypes.UPDATE_DOCKETS_PARTS,
	          docketParts: {
	            purchased: purchaseResponse.purchased,
	            step: 2,
	            percentage: 0,
	            status: 'done',
	            errors: errors,
	            alreadyPurchased: true
	          }
	        });
	
	        return Promise.reject(purchaseResponse);
	      }
	
	      dispatch({
	        type: docketActionTypes.UPDATE_DOCKETS_PARTS,
	        docketParts: {
	          purchased: purchaseResponse.purchased,
	          step: 2,
	          percentage: 0,
	          errors: null,
	          status: 'done'
	        }
	      });
	
	      return Promise.resolve(purchaseResponse);
	    }, function (responseError) {
	      return dispatch(onFailure(responseError));
	    });
	  };
	};
	
	function downloadDocuments(params, dispatch, getState, type, combine_binders) {
	  var printPreview = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
	
	  var prevDocketParts = getState().toJS().dockets.docketParts;
	  var prevPopup = getState().toJS().dockets.popup;
	
	  dispatch({
	    type: docketActionTypes.UPDATE_DOCKETS_PARTS,
	    docketParts: _extends({}, prevDocketParts, {
	      status: 'loading',
	      step: 3
	    })
	  });
	
	  var deliverParams = {
	    delivery_method: 'download',
	    documents: params.documents,
	    type: type,
	    combine_binders: combine_binders
	  };
	
	  return _superagent2.default.post('/rpc/dockets/documents/deliver').type('json').send(deliverParams).then(function (response) {
	    if (!response.accepted || _lodash2.default.isEmpty(response.header.location)) {
	      return dispatch(onFailure({ response: response }));
	    }
	    return rpcProgress(response.header.location, dispatch, getState);
	  }, function (responseError) {
	    return dispatch(onFailure(responseError));
	  }).then(function (deliverResponse) {
	    // what we get here is
	    // delivery_method: "download"
	    // download_url: "http://..."
	    // print_url: "http://..."
	    // filename: "..."
	    var link = printPreview ? deliverResponse.print_url : deliverResponse.download_url;
	    var pretty_name = deliverResponse.filename;
	
	    dispatch({
	      type: docketActionTypes.UPDATE_DOCKETS_PARTS,
	      docketParts: _extends({}, prevDocketParts, {
	        email_address: params.email_address,
	        step: 3,
	        link: link,
	        pretty_name: pretty_name
	      })
	    });
	
	    dispatch(updatePopup(_extends({}, prevPopup, { data: {} })));
	
	    window.open(link);
	
	    // TODO this is probably broken.  we dont have docket_numbers in params any longer.
	    // I don't get what this is supposed to be doing
	    if (params.docket_numbers && params.docket_numbers.length === 1) {
	      return dispatch(getDocuments({
	        court_code: params.court_code,
	        case_number: params.case_number,
	        docket_seq: params.docket_numbers[0],
	        docket_no: parseInt(params.docket_numbers[0], 10)
	      }));
	    }
	
	    return Promise.resolve(deliverResponse);
	  }, function (responseError) {
	    return dispatch(onFailure(responseError));
	  });
	}
	
	function emailParts(params, dispatch, getState, type, combine_binders) {
	  var _getState$toJS = getState().toJS(),
	      dockets = _getState$toJS.dockets;
	
	  dispatch({
	    type: docketActionTypes.UPDATE_DOCKETS_PARTS,
	    docketParts: _extends({}, dockets.docketParts, {
	      status: 'loading',
	      step: 3
	    })
	  });
	
	  dispatch({
	    type: docketActionTypes.DOCKETS_POPUP,
	    popup: _extends({}, dockets.popup, {
	      isEmailSending: true
	    })
	  });
	
	  var documents = params.documents,
	      email_message = params.email_message,
	      email_addresses = params.email_addresses;
	
	
	  var deliverParams = {
	    combine_binders: combine_binders,
	    type: type,
	    documents: documents,
	    email_message: email_message,
	    email_addresses: email_addresses,
	    delivery_method: 'email'
	  };
	
	  return _superagent2.default.post('/rpc/dockets/documents/deliver').type('json').send(deliverParams).then(function (response) {
	    if (!response.accepted || _lodash2.default.isEmpty(response.header.location)) {
	      return dispatch(onFailure({ response: response }));
	    }
	    return rpcProgress(response.header.location, dispatch, getState);
	  }, function (responseError) {
	    return dispatch(onFailure(responseError));
	  }).then(function (deliverResponse) {
	    var email_addresses = deliverResponse.email_addresses,
	        success = deliverResponse.success,
	        filename = deliverResponse.filename,
	        download_url = deliverResponse.download_url;
	
	
	    dispatch({
	      type: docketActionTypes.UPDATE_DOCKETS_PARTS,
	      docketParts: _extends({}, dockets.docketParts, {
	        email_address: email_addresses.join(', '),
	        step: 3,
	        success: success,
	        alreadyPurchased: true
	      })
	    });
	
	    dispatch({
	      type: docketActionTypes.DOCKETS_POPUP,
	      popup: _extends({}, dockets.popup, {
	        isEmailSending: false
	      })
	    });
	
	    var updatedEntriesData = dockets.entries.data.map(function (docket) {
	      var _extends2;
	
	      return docket.docket_seq === dockets.selectedDocket.docket_seq ? _extends({}, docket, (_extends2 = {}, _extends2[type + '_filename'] = filename, _extends2[type + '_download_url'] = download_url, _extends2)) : docket;
	    });
	
	    dispatch({
	      type: docketActionTypes.UPDATE_DOCKETS,
	      entries: _extends({}, dockets.entries, { data: updatedEntriesData })
	    });
	
	    _Notification.notify.success('The filing has been mailed to ' + params.email_addresses.join(', '));
	
	    dispatch(updateFavoriteEmails({ email_addresses: email_addresses }));
	
	    if (params.docket_numbers && params.docket_numbers.length === 1) {
	      return dispatch(getDocumentsFromLocalDB({
	        court_code: params.court_code,
	        case_number: params.case_number,
	        docket_seq: params.docket_numbers[0],
	        docket_no: parseInt(params.docket_numbers[0], 10)
	      }));
	    }
	
	    return Promise.resolve('success');
	  }, function (responseError) {
	    return dispatch(onFailure(responseError));
	  });
	}
	
	var downloadPdfZip = exports.downloadPdfZip = function downloadPdfZip(params) {
	  return function (dispatch, getState) {
	    return downloadDocuments(params, dispatch, getState, 'zip', false);
	  };
	};
	
	var downloadPdfCombinedZipped = exports.downloadPdfCombinedZipped = function downloadPdfCombinedZipped(params) {
	  return function (dispatch, getState) {
	    return downloadDocuments(params, dispatch, getState, 'zip', true);
	  };
	};
	
	var downloadPdfCombined = exports.downloadPdfCombined = function downloadPdfCombined(params) {
	  return function (dispatch, getState) {
	    return downloadDocuments(params, dispatch, getState, 'pdf', false);
	  };
	};
	
	var previewPdf = exports.previewPdf = function previewPdf(params) {
	  return function (dispatch, getState) {
	    return downloadDocuments(params, dispatch, getState, 'pdf', false, true);
	  };
	};
	
	var emailPartsZip = exports.emailPartsZip = function emailPartsZip(params) {
	  return function (dispatch, getState) {
	    return emailParts(params, dispatch, getState, 'zip', false);
	  };
	};
	
	var emailPartsPdfCombined = exports.emailPartsPdfCombined = function emailPartsPdfCombined(params) {
	  return function (dispatch, getState) {
	    return emailParts(params, dispatch, getState, 'pdf', true);
	  };
	};
	
	var getDocketParts = exports.getDocketParts = function getDocketParts(params) {
	  return function (dispatch, getState) {
	    dispatch({
	      type: docketActionTypes.UPDATE_DOCKETS_PARTS,
	      docketParts: {
	        step: 1,
	        status: 'loading',
	        totalParts: 0
	      }
	    });
	
	    return _superagent2.default.post('/rpc/dockets/documents/cost').type('json').send(params).then(function (response) {
	      if (!response.accepted || _lodash2.default.isEmpty(response.header.location)) {
	        return dispatch(onFailure({ response: response }));
	      }
	
	      return rpcProgress(response.header.location, dispatch, getState);
	    }, function (responseError) {
	      return dispatch(onFailure(responseError));
	    }).then(function (costResponse) {
	      var totalCost = parseFloat(costResponse.total.cost);
	
	      var docketParts = {
	        partsToPurchase: costResponse.pacer.documents,
	        totalParts: costResponse.total.documents,
	        totalCost: totalCost,
	        step: 1,
	        status: 'done'
	      };
	
	      // if no docs need to be purchased from pacer, move to step 2
	      if (costResponse.pacer.documents === 0) {
	        docketParts.step = 2;
	        docketParts.alreadyPurchased = true;
	      }
	
	      dispatch({
	        type: docketActionTypes.UPDATE_DOCKETS_PARTS,
	        docketParts: docketParts
	      });
	    }, function (responseError) {
	      return dispatch(onFailure(responseError));
	    });
	  };
	};
	
	var getDocketHeader = exports.getDocketHeader = function getDocketHeader(params) {
	  var court_code = params.court_code,
	      case_number = params.case_number;
	
	  return (0, _superagent2.default)().get('/rpc/capi/cases/pacer/' + court_code + '/' + case_number + '/dockets/header');
	};
	
	var sendEmail = exports.sendEmail = function sendEmail(params) {
	  return function (dispatch, getState) {
	    var oldState = getState().toJS();
	
	    var email_address = params.email_address,
	        email_message = params.email_message;
	
	
	    var email_addresses = email_address.split(/[, ]+/);
	
	    var reqParams = _extends({}, params, oldState.dockets.popup.data, {
	      to: email_addresses,
	      message: email_message || ''
	    });
	
	    dispatch({
	      type: docketActionTypes.DOCKETS_POPUP,
	      popup: _extends({}, oldState.dockets.popup, {
	        isEmailSending: true
	      })
	    });
	
	    return _superagent2.default.post('/rpc/dockets/documents/email').type('json').send(reqParams).then(function (response) {
	      if (typeof response === 'undefined' || response.status !== 200) {
	        return dispatch(onFailure({ response: response }));
	      }
	      dispatch({
	        type: docketActionTypes.DOCKETS_POPUP,
	        popup: _extends({}, oldState.dockets.popup, {
	          isEmailSending: false
	        })
	      });
	
	      dispatch({
	        type: docketActionTypes.UPDATE_DOCKETS_PARTS,
	        docketParts: _extends({}, oldState.dockets.docketParts, {
	          email_address: params.email_address
	          // showFlash: true,
	        })
	      });
	
	      _Notification.notify.success('The filing has been mailed to ' + params.email_address);
	    }, function (responseError) {
	      return dispatch(onFailure(responseError));
	    }).then(function () {
	      return dispatch(updateFavoriteEmails({ email_addresses: email_addresses }));
	    });
	  };
	};
	
	var buyPdf = exports.buyPdf = function buyPdf(params) {
	  return function (dispatch) {
	    var case_no = params.case_no,
	        seqNum = params.seqNum,
	        documentNumber = params.number,
	        court_code = params.court_code;
	
	
	    dispatch({
	      type: docketActionTypes.UPDATE_DOCUMENT,
	      seqNum: seqNum,
	      document: { number: documentNumber, isLoading: true }
	    });
	
	    function onError(responseError) {
	      dispatch({
	        type: docketActionTypes.UPDATE_DOCUMENT,
	        seqNum: seqNum,
	        document: { number: documentNumber, isLoading: false }
	      });
	
	      return dispatch(onFailure(responseError));
	    }
	
	    function onSuccess(response) {
	      var body = response.body;
	
	      if (!_lodash2.default.isEmpty(body.error)) {
	        return onError({ response: response });
	      }
	
	      var document = body.document,
	          links = body.links;
	
	
	      dispatch({
	        type: docketActionTypes.UPDATE_DOCUMENT,
	        seqNum: seqNum,
	        document: _extends({}, document, { links: links, isLoading: false })
	      });
	
	      return Promise.resolve(body);
	    }
	
	    return _superagent2.default.post('/rpc/capi/cases/pacer/' + court_code + '/' + case_no + '/dockets/' + seqNum + '/documents/' + documentNumber).set('Accept', 'application/json').then(onSuccess, onError);
	  };
	};
	
	var filterDocketEntries = exports.filterDocketEntries = function filterDocketEntries(filter) {
	  return function (dispatch, getState) {
	    (0, _irSearchActions.requestCaseData)({}, dispatch);
	
	    var state = getState();
	
	    var _filter$keyword = filter.keyword,
	        keyword = _filter$keyword === undefined ? '' : _filter$keyword;
	
	    var searchWords = keyword.toLowerCase().split(' ').filter(function (p) {
	      return p !== '';
	    }).reverse();
	
	    var data = state.toJS().irSearch.data.map(function (next) {
	      var key = next[0];
	      var value = next[1];
	
	      if (key === 'entries') {
	        var values = value.map(function (docketEntry) {
	          var docketText = _lodash2.default.get(docketEntry, ['text', 'docket_text'], '');
	          var isVisible = _lodash2.default.isEmpty(searchWords) || _lodash2.default.every(searchWords, function (word) {
	            return docketText.toLowerCase().indexOf(word) > -1;
	          });
	          return _extends({}, docketEntry, { isVisible: isVisible });
	        });
	        return [key, values];
	      }
	      return next;
	    });
	
	    return dispatch({
	      type: types.RECEIVE_CASE_DATA,
	      data_type: 'dockets',
	      data: data
	    });
	  };
	};
	
	var updateRedact = exports.updateRedact = function updateRedact(updatedRedact) {
	  return function (dispatch, getState) {
	    var _getState$get$toJS2 = getState().get('dockets').toJS(),
	        redact = _getState$get$toJS2.redact;
	
	    return dispatch({
	      type: docketActionTypes.UPDATE_REDACT,
	      redact: _extends({}, redact, updatedRedact)
	    });
	  };
	};
	
	var deleteAndRepurchase = exports.deleteAndRepurchase = function deleteAndRepurchase(params) {
	  return function (dispatch, getState) {
	    var redactSeqNum = params.redactSeqNum,
	        doc_range = params.doc_range,
	        court_code = params.court_code,
	        case_number = params.case_number;
	
	
	    var currentState = getState().toJS();
	    var clientCode = currentState.clientCodeReducer.sessionClientCode;
	    var client_code = _lodash2.default.isEmpty(clientCode) ? window.Drupal.settings.clientCode : clientCode;
	    var repurchaseParams = {
	      sequence_number: redactSeqNum,
	      client_code: client_code
	    };
	
	    return _superagent2.default.post('/rpc/cases/' + court_code + '/' + case_number + '/docket/entry/delete_and_repurchase').send(repurchaseParams).then(function (response) {
	      if (!_lodash2.default.isEmpty(response.body.error)) {
	        return dispatch(onFailure({ response: response }));
	      }
	
	      var receipt = _lodash2.default.get(response.body, 'items.receipts[0].text', {});
	      receipt.source_data_id = _lodash2.default.get(response.body, 'source_data_id', {});
	
	      dispatch({
	        type: docketActionTypes.SET_RECEIPT,
	        receipt: receipt
	      });
	
	      var getDocketsParams = _extends({}, params, {
	        receipt: receipt,
	        docket_number_range: _lodash2.default.isEmpty(doc_range) ? null : doc_range
	      });
	
	      return dispatch(getDockets(getDocketsParams));
	    }, function (responseError) {
	      return dispatch(onFailure(responseError));
	    });
	  };
	};

/***/ },
/* 43 */
[2305, 97],
/* 44 */
25,
/* 45 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.filter(function (f) {
	    return f != null;
	  }).reduce(function (acc, f) {
	    if (typeof f !== 'function') {
	      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
	    }
	
	    if (acc === null) {
	      return f;
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      f.apply(this, args);
	    };
	  }, null);
	}
	
	var _default = createChainedFunction;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getConnections = exports.deleteFilenameTemplates = exports.saveFilenameTemplates = exports.getFilenameTemplates = exports.updateConnection = exports.updateFilenameTemplate = exports.connections = exports.disconnectIntegration = exports.connectIntegration = exports.authenticate = exports.actionTypes = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _filenameTemplateFields = __webpack_require__(169);
	
	var _filenameTemplateFields2 = _interopRequireDefault(_filenameTemplateFields);
	
	var _Notification = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionTypes = exports.actionTypes = {
	  REQUEST_CONNECTION: 'REQUEST_CONNECTION',
	  RECEIVE_CONNECTION: 'RECEIVE_CONNECTION',
	  REQUEST_DISCONNECTION: 'REQUEST_DISCONNECTION',
	  RECEIVE_DISCONNECTION: 'RECEIVE_DISCONNECTION',
	  REQUEST_CONNECTIONS: 'REQUEST_CONNECTIONS',
	  RECEIVE_CONNECTIONS: 'RECEIVE_CONNECTIONS',
	  UPDATE_CONNECTION: 'UPDATE_CONNECTION',
	  SERVICE_ERROR: 'SERVICE_ERROR',
	  UPDATE_AUTH: 'UPDATE_AUTH',
	  UPDATE_PRICING: 'UPDATE_PRICING',
	  REQUEST_FILENAME_TEMPLATE: 'REQUEST_FILENAME_TEMPLATE',
	  RECEIVE_FILENAME_TEMPLATE: 'RECEIVE_FILENAME_TEMPLATE',
	  FILENAME_TEMPLATE_ERROR: 'FILENAME_TEMPLATE_ERROR'
	};
	
	var authenticate = exports.authenticate = function authenticate(params) {
	  return function (dispatch) {
	    window.Kloudless.authenticator(null, params, function (auth) {
	      dispatch({
	        type: actionTypes.UPDATE_AUTH,
	        auth: auth
	      });
	    });
	
	    return dispatch({ type: actionTypes.REQUEST_DISCONNECTION });
	  };
	};
	
	var connectIntegration = exports.connectIntegration = function connectIntegration(svcType, svcName, connectionDetails) {
	  return function (dispatch) {
	    dispatch({ type: actionTypes.REQUEST_CONNECTION });
	
	    function onFailure(errorMessage) {
	      dispatch({
	        type: actionTypes.RECEIVE_CONNECTION,
	        results: errorMessage
	      });
	    }
	
	    function onSuccess(response) {
	      if (response.status !== 201) {
	        return onFailure(response.message || 'service error');
	      }
	
	      var connection = convertConnectionToRedux(response.body.integration);
	
	      dispatch({
	        type: actionTypes.RECEIVE_CONNECTION,
	        results: [connection]
	      });
	    }
	
	    return _superagent2.default.post('/rpc/integrations/connections').send(_extends({
	      integration_type: svcType,
	      service: svcName
	    }, connectionDetails && { connection_details: connectionDetails })).then(onSuccess, onFailure);
	  };
	};
	
	var disconnectIntegration = exports.disconnectIntegration = function disconnectIntegration(connectionId) {
	  return function (dispatch) {
	    dispatch({ type: actionTypes.REQUEST_DISCONNECTION });
	
	    function onSuccess() {
	      dispatch({
	        type: actionTypes.RECEIVE_DISCONNECTION,
	        connectionId: connectionId
	      });
	    }
	
	    function onFailure(errorMessage) {
	      dispatch({
	        type: actionTypes.RECEIVE_DISCONNECTION,
	        errorMessage: errorMessage
	      });
	    }
	
	    return _superagent2.default.delete('/rpc/integrations/connections/' + connectionId).then(onSuccess, onFailure);
	  };
	};
	
	var connections = exports.connections = function connections() {
	  return function (dispatch) {
	    dispatch({ type: actionTypes.REQUEST_CONNECTIONS });
	
	    function onFailure(errorMessage) {
	      dispatch({
	        type: actionTypes.RECEIVE_CONNECTIONS,
	        errorMessage: errorMessage
	      });
	    }
	
	    function onSuccess(response) {
	      if (response.status !== 200) {
	        return onFailure(response.message || 'service error');
	      }
	
	      var _response$body$integr = response.body.integrations,
	          integrations = _response$body$integr === undefined ? [] : _response$body$integr;
	
	      var connections = integrations.map(function (connection) {
	        return convertConnectionToRedux(connection);
	      });
	
	      dispatch({
	        type: actionTypes.RECEIVE_CONNECTIONS,
	        results: connections
	      });
	
	      dispatch({
	        type: actionTypes.UPDATE_PRICING,
	        agreedToPricing: integrations.length > 0
	      });
	    }
	
	    return _superagent2.default.get('/rpc/integrations/connections').then(onSuccess, onFailure);
	  };
	};
	
	var updateFilenameTemplate = exports.updateFilenameTemplate = function updateFilenameTemplate(connectionId, updates) {
	  return function (dispatch) {
	    return dispatch({
	      type: actionTypes.RECEIVE_FILENAME_TEMPLATE,
	      updates: updates,
	      connectionId: connectionId
	    });
	  };
	};
	
	var updateConnection = exports.updateConnection = function updateConnection(connectionId, updates) {
	  return function (dispatch) {
	    dispatch({
	      type: actionTypes.UPDATE_CONNECTION,
	      updates: convertConnectionToRedux(updates),
	      connectionId: connectionId
	    });
	  };
	};
	
	function splitFilenameTemplateToArray(template) {
	  var separators = _filenameTemplateFields2.default.filter(function (x) {
	    return x.type === 'separator';
	  }).map(function (f) {
	    return f.name;
	  }).concat(['{', '}', '{{', '}}', '\\/']);
	
	  var splitted = template.split(new RegExp('([' + separators.join('') + '])', 'g'));
	  var filtered = splitted.filter(function (segment) {
	    return segment !== '';
	  });
	  // TODO - cleanup the code below
	  // Low on sleep - this is horribly hacked together but I can't think of a better way for now
	  var rejoined = filtered.reduce(function (accum, n, idx) {
	    if (idx === 0 || separators.includes(n) && n !== '_') {
	      accum.push(n);
	      return accum;
	    }
	    if (!separators.includes(n) || n === '_') {
	      var prev = accum[accum.length - 1];
	      // if previous is a separator char, make a new string
	      // else append it to the existing string
	      if (separators.includes(prev) || prev[prev.length - 1] === '}') {
	        accum.push(n);
	        return accum;
	      } else {
	        accum[accum.length - 1] = prev + n;
	        return accum;
	      }
	    }
	    return accum;
	  }, []);
	
	  return rejoined.filter(function (x) {
	    return x !== '{' && x !== '}';
	  });
	}
	
	function parseFilenameTemplate(template) {
	  if (!template) return;
	
	  var filenameTemplateArray = splitFilenameTemplateToArray(template);
	  console.log("MJS Split filename template ", filenameTemplateArray);
	
	  var _splitFilenameTemplat = splitFilenameTemplates(filenameTemplateArray),
	      folderPathFields = _splitFilenameTemplat[0],
	      fileFormatFields = _splitFilenameTemplat[1];
	
	  console.log("MJS folder path fields: ", folderPathFields);
	  console.log("MJS file format fields: ", fileFormatFields);
	
	  return { fileFormatFields: fileFormatFields, folderPathFields: folderPathFields };
	}
	
	var convertFileNameSettingsToRedux = function convertFileNameSettingsToRedux(filenameSettings) {
	  if (!filenameSettings) return null;
	
	  var created = filenameSettings.created,
	      date_format = filenameSettings.date_format,
	      description_max_words = filenameSettings.description_max_words,
	      filename_template = filenameSettings.filename_template,
	      modified = filenameSettings.modified,
	      root_folder = filenameSettings.root_folder;
	
	  // TODO seems nasty having this here.  Not sure if there's a better option.
	
	  var initialFilenameTemplateState = {
	    isVisible: false,
	    isLoading: false,
	    created: null,
	    modified: null,
	    selectedFolderPathFields: [],
	    selectedFileFormatFields: [],
	    savedRootFolder: '',
	    savedFolderPathFields: [],
	    savedFileFormatFields: [],
	    selectedFields: [],
	    savedFormatFields: [],
	    errorMessage: null,
	    date_format: 'YYYY-MM-DD',
	    description_max_words: 6,
	    root_folder: null
	  };
	
	  var parsedTemplate = parseFilenameTemplate(filename_template);
	
	  return {
	    template: filename_template,
	    dateFormat: filenameSettings.date_format,
	    descMaxWords: filenameSettings.description_max_words,
	    created: created,
	    modified: modified,
	    filenameTemplate: _extends({}, initialFilenameTemplateState, {
	
	      isVisible: true,
	
	      selectedFileFormatFields: parsedTemplate.fileFormatFields,
	      selectedFolderPathFields: parsedTemplate.folderPathFields,
	
	      savedFileFormatFields: parsedTemplate.fileFormatFields,
	      savedFolderPathFields: parsedTemplate.folderPathFields,
	
	      created: created,
	      modified: modified,
	      date_format: date_format,
	      description_max_words: description_max_words,
	      root_folder: root_folder
	    })
	  };
	};
	
	var convertConnectionToRedux = function convertConnectionToRedux(connection) {
	  // services that use matter folders
	  var matterFolderServices = ['imanage', 'netdocuments', 'clio', 'rocketmatter'];
	
	  // services that have option to use an "app folder"
	  var appFolderServices = ['dropbox', 'onedrive'];
	
	  return {
	    connectionId: connection.connection_id,
	    integration_type: connection.integration_type,
	    service: connection.service,
	    sync_type: connection.sync_type,
	    combine_pdfs: _lodash2.default.get(connection, 'file_settings.combine_pdfs', false),
	    sync_from: new Date(connection.sync_from),
	    sync_mode: _lodash2.default.get(connection, 'file_settings.sync_mode'),
	    folder_config: _lodash2.default.get(connection, 'file_settings.folder_config', 'none'),
	    hasMatterFolders: matterFolderServices.indexOf(connection.service) !== -1,
	    hasAppFolder: appFolderServices.indexOf(connection.service) !== -1,
	    filenameSettings: convertFileNameSettingsToRedux(connection.filename_settings)
	  };
	};
	
	function warnNotConnected(dispatch) {
	  _Notification.notify.error('Warning!  You must connect a service to update the filename templates', { position: 'top-center' });
	  // send empty contents to clear the loading spinner
	  dispatch({
	    type: actionTypes.RECEIVE_FILENAME_TEMPLATE,
	    results: {}
	  });
	}
	
	function splitFilenameTemplates(fields) {
	  var pathIdx = fields.lastIndexOf('/');
	  // only filename?
	  if (pathIdx === -1) return [[], fields];
	
	  var foldPathFields = fields.slice(0, pathIdx + 1);
	  var fileFormatFields = fields.slice(pathIdx + 1);
	  return [foldPathFields, fileFormatFields];
	}
	
	var getFilenameTemplates = exports.getFilenameTemplates = function getFilenameTemplates(id) {
	  return function (dispatch) {
	    function onSuccess(response) {
	      var _response$body = response.body,
	          created = _response$body.created,
	          modified = _response$body.modified,
	          date_format = _response$body.date_format,
	          _response$body$templa = _response$body.template,
	          template = _response$body$templa === undefined ? '' : _response$body$templa,
	          _response$body$descri = _response$body.description_max_words,
	          description_max_words = _response$body$descri === undefined ? 6 : _response$body$descri;
	
	
	      var parsedTemplate = parseFilenameTemplate(template);
	
	      dispatch({
	        type: actionTypes.RECEIVE_FILENAME_TEMPLATE,
	        results: {
	          isVisible: true,
	          created: created,
	          modified: modified,
	          date_format: date_format,
	          selectedFileFormatFields: parsedTemplate.fileFormatFields,
	          selectedFolderPathFields: parsedTemplate.folderPathFields,
	
	          savedFileFormatFields: parsedTemplate.fileFormatFields,
	          savedFolderPathFields: parsedTemplate.folderPathFields,
	
	          // selectedFields: fields,
	          // savedFormatFields: fields,
	          description_max_words: description_max_words
	        }
	      });
	    }
	
	    function onFailure(errorMessage) {
	      if (errorMessage.status === 404) {
	        return dispatch({
	          type: actionTypes.RECEIVE_FILENAME_TEMPLATE,
	          results: {}
	        });
	      }
	
	      var msg = _lodash2.default.get(errorMessage, 'response.body.error', errorMessage);
	      _Notification.notify.error('Error! ' + msg, { position: 'top-center' });
	      dispatch({
	        type: actionTypes.FILENAME_TEMPLATE_ERROR,
	        errorMessage: msg
	      });
	    }
	
	    return _superagent2.default.get('/rpc/integrations/connections/' + id + '/filename_template').then(onSuccess, onFailure);
	  };
	};
	
	var saveFilenameTemplates = exports.saveFilenameTemplates = function saveFilenameTemplates(_ref) {
	  var id = _ref.id,
	      template = _ref.template,
	      date_format = _ref.date_format,
	      description_max_words = _ref.description_max_words,
	      root_folder = _ref.root_folder;
	  return function (dispatch) {
	    if (id == null) {
	      warnNotConnected(dispatch);
	      return;
	    }
	
	    dispatch({
	      type: actionTypes.REQUEST_FILENAME_TEMPLATE
	    });
	
	    function onSuccess(filenameResp) {
	      _Notification.notify.success('Success!  Filename Template Updated', { position: 'top-center' });
	
	      var filenameTemplate = filenameResp.body.template;
	
	      var newRootFolder = filenameResp.body.root_folder;
	
	      var _parseFilenameTemplat = parseFilenameTemplate(filenameTemplate),
	          fileFormatFields = _parseFilenameTemplat.fileFormatFields,
	          folderPathFields = _parseFilenameTemplat.folderPathFields;
	
	      return updateFilenameTemplate(id, {
	        savedFileFormatFields: fileFormatFields,
	        savedFolderPathFields: folderPathFields,
	        savedRootFolder: newRootFolder || '',
	        root_folder: newRootFolder || ''
	      })(dispatch);
	    }
	
	    function onFailure(errorMessage) {
	      var msg = _lodash2.default.get(errorMessage, 'response.body.error', errorMessage);
	      _Notification.notify.error('Error! ' + msg, { position: 'top-center' });
	
	      dispatch({
	        type: actionTypes.FILENAME_TEMPLATE_ERROR,
	        errorMessage: msg
	      });
	    }
	
	    var filenameTemplateReq = _superagent2.default.post('/rpc/integrations/connections/' + id + '/filename_template').set('Accept', 'application/json').send({ template: template, date_format: date_format, description_max_words: description_max_words, root_folder: root_folder });
	
	    return filenameTemplateReq.then(onSuccess, onFailure);
	  };
	};
	
	var deleteFilenameTemplates = exports.deleteFilenameTemplates = function deleteFilenameTemplates(_ref2) {
	  var id = _ref2.id;
	  return function (dispatch) {
	    if (id == null) {
	      warnNotConnected(dispatch);
	      return;
	    }
	
	    dispatch({
	      type: actionTypes.REQUEST_FILENAME_TEMPLATE
	    });
	
	    function onSuccess() {
	      _Notification.notify.success('Success!  Filename Template Updated', { position: 'top-center' });
	      return updateFilenameTemplate(id, { savedFormatFields: [] })(dispatch);
	    }
	
	    function onFailure(errorMessage) {
	      var msg = _lodash2.default.get(errorMessage, 'response.body.error', errorMessage);
	      _Notification.notify.error('Error! ' + msg, { position: 'top-center' });
	
	      dispatch({
	        type: actionTypes.FILENAME_TEMPLATE_ERROR,
	        errorMessage: msg
	      });
	    }
	
	    return _superagent2.default.del('/rpc/integrations/connections/' + id + '/filename_template').set('Accept', 'application/json').then(onSuccess, onFailure);
	  };
	};
	
	// XXX this is clearly wrong
	var getConnections = exports.getConnections = function getConnections() {
	  return function (dispatch) {
	    return connections()(dispatch);
	  };
	};

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	var _Object$getOwnPropertyDescriptor = __webpack_require__(970);
	
	var _Object$defineProperty = __webpack_require__(969);
	
	var _WeakMap = __webpack_require__(973);
	
	function _getRequireWildcardCache() {
	  if (typeof _WeakMap !== "function") return null;
	  var cache = new _WeakMap();
	
	  _getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };
	
	  return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }
	
	  var cache = _getRequireWildcardCache();
	
	  if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }
	
	  var newObj = {};
	
	  if (obj != null) {
	    var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor;
	
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null;
	
	        if (desc && (desc.get || desc.set)) {
	          _Object$defineProperty(newObj, key, desc);
	        } else {
	          newObj[key] = obj[key];
	        }
	      }
	    }
	  }
	
	  newObj["default"] = obj;
	
	  if (cache) {
	    cache.set(obj, newObj);
	  }
	
	  return newObj;
	}
	
	module.exports = _interopRequireWildcard;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.assetsLiabilitiesSelectOptions = exports.industrySelectOptions = exports.regionSelectOptions = exports.querySelectOptions = exports.caseTypeSelectOptions = exports.chapterSelectOptions = exports.casefoldersSelectOptions = exports.limitSelectOptions = exports.scheduleCategorySelectOptions = exports.scheduleSelectOptions = exports.formDefaults = undefined;
	
	var _moment = __webpack_require__(32);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formDefaults = exports.formDefaults = {
	  all: {
	    general: {
	      mustHave: {
	        grouped: false
	      },
	      default: {
	        search_pdfs: 'include',
	        my_cases: '',
	        case_titles: 'include'
	      },
	      omit: {
	        party_name: null,
	        nature_of_suit: null,
	        chapter: null,
	        case_type: null,
	        business_cases: null,
	        industry: null,
	        assets: null,
	        liabilities: null
	      }
	    },
	    cases: {
	      mustHave: {
	        grouped: true,
	        search_pdfs: 'exclude',
	        query: null
	      },
	      default: {
	        my_cases: '',
	        case_titles: 'include',
	        party_name: 'include'
	      },
	      omit: {
	        nature_of_suit: null,
	        chapter: null,
	        case_type: null,
	        business_cases: null,
	        industry: null,
	        assets: null,
	        liabilities: null,
	        date_doc_filed_from: null,
	        date_doc_filed_to: null
	      }
	    },
	    'case-activity': {
	      mustHave: {
	        grouped: false,
	        search_pdfs: 'exclude',
	        my_cases: 'firm',
	        query: ['dockets', 'claims'],
	        date_doc_filed_from: (0, _moment2.default)()
	      },
	      default: {
	        case_titles: 'include'
	      },
	      omit: {
	        party_name: null,
	        nature_of_suit: null,
	        chapter: null,
	        case_type: null,
	        business_cases: null,
	        industry: null,
	        assets: null,
	        liabilities: null
	      }
	    }
	  },
	  bankruptcy: {
	    general: {
	      mustHave: {
	        grouped: false
	      },
	      default: {
	        search_pdfs: 'include',
	        my_cases: '',
	        case_titles: 'include',
	        business_cases: 'include'
	      },
	      omit: {
	        party_name: null,
	        nature_of_suit: null
	      }
	    },
	    cases: {
	      mustHave: {
	        grouped: true,
	        search_pdfs: 'exclude',
	        query: null
	      },
	      default: {
	        my_cases: '',
	        case_titles: 'include',
	        business_cases: 'include',
	        party_name: 'include'
	      },
	      omit: {
	        nature_of_suit: null,
	        date_doc_filed_from: null,
	        date_doc_filed_to: null
	      }
	    },
	    petitions: {
	      mustHave: {
	        grouped: false,
	        search_pdfs: 'exclude',
	        query: ['docket_headers'],
	        business_cases: 'limit'
	      },
	      default: {
	        my_cases: '',
	        case_titles: 'include'
	      },
	      omit: {
	        party_name: null,
	        nature_of_suit: null,
	        date_closed_from: null,
	        date_closed_to: null,
	        date_dismissed_from: null,
	        date_dismissed_to: null,
	        date_discharged_from: null,
	        date_discharged_to: null,
	        date_doc_filed_from: null,
	        date_doc_filed_to: null
	      }
	    },
	    schedules: {
	      mustHave: {
	        // grouped: false,
	        query: null,
	        business_cases: 'limit'
	      },
	      default: {
	        search_pdfs: 'include',
	        my_cases: '',
	        case_titles: 'include'
	      },
	      omit: {
	        party_name: null,
	        nature_of_suit: null,
	        date_closed_from: null,
	        date_closed_to: null,
	        date_dismissed_from: null,
	        date_dismissed_to: null,
	        date_discharged_from: null,
	        date_discharged_to: null,
	        date_doc_filed_from: null,
	        date_doc_filed_to: null
	      }
	    }
	  },
	  civil: {
	    general: {
	      mustHave: {
	        grouped: false
	      },
	      default: {
	        search_pdfs: 'include',
	        my_cases: '',
	        case_titles: 'include'
	      },
	      omit: {
	        party_name: null,
	        chapter: null,
	        case_type: null,
	        business_cases: null,
	        industry: null,
	        assets: null,
	        liabilities: null,
	        date_dismissed_from: null,
	        date_dismissed_to: null,
	        date_discharged_from: null,
	        date_discharged_to: null
	      }
	    },
	    cases: {
	      mustHave: {
	        grouped: true,
	        search_pdfs: 'exclude',
	        query: null
	      },
	      default: {
	        my_cases: '',
	        case_titles: 'include',
	        party_name: 'include'
	      },
	      omit: {
	        chapter: null,
	        case_type: null,
	        business_cases: null,
	        industry: null,
	        assets: null,
	        liabilities: null,
	        date_dismissed_from: null,
	        date_dismissed_to: null,
	        date_discharged_from: null,
	        date_discharged_to: null,
	        date_doc_filed_from: null,
	        date_doc_filed_to: null
	      }
	    }
	  },
	  criminal: {
	    general: {
	      mustHave: {
	        grouped: false
	      },
	      default: {
	        search_pdfs: 'include',
	        my_cases: '',
	        case_titles: 'include'
	      },
	      omit: {
	        party_name: null,
	        nature_of_suit: null,
	        chapter: null,
	        case_type: null,
	        business_cases: null,
	        industry: null,
	        assets: null,
	        liabilities: null,
	        date_dismissed_from: null,
	        date_dismissed_to: null,
	        date_discharged_from: null,
	        date_discharged_to: null
	      }
	    },
	    cases: {
	      mustHave: {
	        grouped: true,
	        search_pdfs: 'exclude',
	        query: null
	      },
	      default: {
	        my_cases: '',
	        case_titles: 'include',
	        party_name: 'include'
	      },
	      omit: {
	        nature_of_suit: null,
	        chapter: null,
	        case_type: null,
	        business_cases: null,
	        industry: null,
	        assets: null,
	        liabilities: null,
	        date_dismissed_from: null,
	        date_dismissed_to: null,
	        date_discharged_from: null,
	        date_discharged_to: null,
	        date_doc_filed_from: null,
	        date_doc_filed_to: null
	      }
	    }
	  },
	  appellate: {
	    general: {
	      mustHave: {
	        grouped: false
	      },
	      default: {
	        search_pdfs: 'include',
	        my_cases: '',
	        case_titles: 'include'
	      },
	      omit: {
	        party_name: null,
	        nature_of_suit: null,
	        chapter: null,
	        case_type: null,
	        business_cases: null,
	        industry: null,
	        assets: null,
	        liabilities: null
	      }
	    },
	    cases: {
	      mustHave: {
	        grouped: true,
	        search_pdfs: 'exclude',
	        query: null
	      },
	      default: {
	        my_cases: '',
	        case_titles: 'include',
	        party_name: 'include'
	      },
	      omit: {
	        nature_of_suit: null,
	        chapter: null,
	        case_type: null,
	        business_cases: null,
	        industry: null,
	        assets: null,
	        liabilities: null,
	        date_doc_filed_from: null,
	        date_doc_filed_to: null
	      }
	    }
	  }
	};
	
	var scheduleSelectOptions = exports.scheduleSelectOptions = [{ value: '', label: 'Select Schedule …' }, { value: 'schedule_ab', label: 'Schedule A/B' }, { value: 'schedule_d', label: 'Schedule D' }, { value: 'schedule_ef', label: 'Schedule E/F' }, { value: 'top20', label: 'Top Twenty' }];
	
	var scheduleCategorySelectOptions = exports.scheduleCategorySelectOptions = [{ value: '', label: 'Select Category …' }, { value: 'cash', label: 'Cash, cash equivalents, and financial assets' }, { value: 'deposits', label: 'Deposits and prepayments' }, { value: 'acct_rcpt', label: 'Accounts receivable' }, { value: 'investments', label: 'Investments' }, { value: 'inventory', label: 'Inventory' }, { value: 'farming', label: 'Farming and fishing-related assets' }, { value: 'office', label: 'Office furniture, fixtures, and equipment; and collectibles' }, { value: 'machinery', label: 'Machinery, equipment, and vehicles' }, { value: 'property', label: 'Real Property' }, { value: 'intangibles', label: 'Intangibles and intellectual property' }, { value: 'others', label: 'All other assets' }, { value: 'personal_total', label: 'Personal total' }, { value: 'real_total', label: 'Real total' }, { value: 'total', label: 'Total of all property on Schedule A/B' }];
	
	var limitSelectOptions = exports.limitSelectOptions = [{ value: 'include', label: 'Include' }, { value: 'exclude', label: 'Exclude' }, { value: 'limit', label: 'Limit search to' }];
	
	var casefoldersSelectOptions = exports.casefoldersSelectOptions = [{ value: '', label: 'Entire Database' }, { value: 'user', label: 'My Casefolders' }, { value: 'firm', label: 'Firm Casefolders' }];
	
	var chapterSelectOptions = exports.chapterSelectOptions = [{ value: '7', label: '7' }, { value: '9', label: '9' }, { value: '11', label: '11' }, { value: '12', label: '12' }, { value: '13', label: '13' }, { value: '15', label: '15' }, { value: '304', label: '304' }];
	
	var caseTypeSelectOptions = exports.caseTypeSelectOptions = [{ value: 'bk', label: 'Bankruptcy' }, { value: 'ap', label: 'Adversary' }, { value: 'mp', label: 'Miscellaneous' }];
	
	var querySelectOptions = exports.querySelectOptions = [{ value: 'dockets', label: 'Docket' }, { value: 'claims', label: 'Claims' }, { value: 'creditors', label: 'Creditors' }, { value: 'attorneys', label: 'Attorneys' }, { value: 'history', label: 'Events' }, { value: 'alias', label: 'Aliases' }, { value: 'associated_cases', label: 'Associated Cases' }, { value: 'case_summary', label: 'Summary' }, { value: 'docket_headers', label: 'Docket Headers' }, { value: 'claim_headers', label: 'Claim Headers' }, { value: 'case_headers', label: 'Case Headers' }, { value: 'creditor_mailing', label: 'Matrix' }, { value: 'schedule', label: 'Deadlines' }, { value: 'filers', label: 'Filers' }, { value: 'notice', label: 'Notice' }, { value: 'parties', label: 'Parties' }, { value: 'related_transactions', label: 'Related' }, { value: 'status_pending', label: 'Status' }, { value: 'written_opinions', label: 'Written Opinions' }];
	
	var regionSelectOptions = exports.regionSelectOptions = [{ value: '01', label: 'First Circuit' }, { value: '02', label: 'Second Circuit' }, { value: '03', label: 'Third Circuit' }, { value: '04', label: 'Fourth Circuit' }, { value: '05', label: 'Fifth Circuit' }, { value: '06', label: 'Sixth Circuit' }, { value: '07', label: 'Seventh Circuit' }, { value: '08', label: 'Eighth Circuit' }, { value: '09', label: 'Ninth Circuit' }, { value: '10', label: 'Tenth Circuit' }, { value: '11', label: 'Eleventh Circuit' }, { value: 'cafc', label: 'Federal Circuit' }, { value: 'alm', label: 'Alabama Middle' }, { value: 'aln', label: 'Alabama Northern' }, { value: 'als', label: 'Alabama Southern' }, { value: 'ak', label: 'Alaska' }, { value: 'az', label: 'Arizona' }, { value: 'are', label: 'Arkansas Eastern' }, { value: 'arw', label: 'Arkansas Western' }, { value: 'cac', label: 'California Central' }, { value: 'cae', label: 'California Eastern' }, { value: 'can', label: 'California Northern' }, { value: 'cas', label: 'California Southern' }, { value: 'co', label: 'Colorado' }, { value: 'ct', label: 'Connecticut' }, { value: 'dc', label: 'District of Columbia' }, { value: 'de', label: 'Delaware' }, { value: 'flm', label: 'Florida Middle' }, { value: 'fln', label: 'Florida Northern' }, { value: 'fls', label: 'Florida Southern' }, { value: 'gam', label: 'Georgia Middle' }, { value: 'gan', label: 'Georgia Northern' }, { value: 'gas', label: 'Georgia Southern' }, { value: 'gu', label: 'Guam' }, { value: 'hi', label: 'Hawaii' }, { value: 'id', label: 'Idaho' }, { value: 'ilc', label: 'Illinois Central' }, { value: 'iln', label: 'Illinois Northern' }, { value: 'ils', label: 'Illinois Southern' }, { value: 'inn', label: 'Indiana Northern' }, { value: 'ins', label: 'Indiana Southern' }, { value: 'ian', label: 'Iowa Northern' }, { value: 'ias', label: 'Iowa Southern' }, { value: 'ks', label: 'Kansas' }, { value: 'kye', label: 'Kentucky Eastern' }, { value: 'kyw', label: 'Kentucky Western' }, { value: 'lae', label: 'Louisiana Eastern' }, { value: 'lam', label: 'Louisiana Middle' }, { value: 'law', label: 'Louisiana Western' }, { value: 'me', label: 'Maine' }, { value: 'md', label: 'Maryland' }, { value: 'ma', label: 'Massachusetts' }, { value: 'mie', label: 'Michigan Eastern' }, { value: 'miw', label: 'Michigan Western' }, { value: 'mn', label: 'Minnesota' }, { value: 'msn', label: 'Mississippi Northern' }, { value: 'mss', label: 'Mississippi Southern' }, { value: 'moe', label: 'Missouri Eastern' }, { value: 'mow', label: 'Missouri Western' }, { value: 'mt', label: 'Montana' }, { value: 'ne', label: 'Nebraska' }, { value: 'nv', label: 'Nevada' }, { value: 'nh', label: 'New Hampshire' }, { value: 'nj', label: 'New Jersey' }, { value: 'nm', label: 'New Mexico' }, { value: 'nye', label: 'New York Eastern' }, { value: 'nyn', label: 'New York Northern' }, { value: 'nys', label: 'New York Southern' }, { value: 'nyw', label: 'New York Western' }, { value: 'nce', label: 'North Carolina Eastern' }, { value: 'ncm', label: 'North Carolina Middle' }, { value: 'ncw', label: 'North Carolina Western' }, { value: 'nd', label: 'North Dakota' }, { value: 'nmi', label: 'Northern Mariana Islands' }, { value: 'ohn', label: 'Ohio Northern' }, { value: 'ohs', label: 'Ohio Southern' }, { value: 'oke', label: 'Oklahoma Eastern' }, { value: 'okn', label: 'Oklahoma Northern' }, { value: 'okw', label: 'Oklahoma Western' }, { value: 'or', label: 'Oregon' }, { value: 'pae', label: 'Pennsylvania Eastern' }, { value: 'pam', label: 'Pennsylvania Middle' }, { value: 'paw', label: 'Pennsylvania Western' }, { value: 'pr', label: 'Puerto Rico' }, { value: 'ri', label: 'Rhode Island' }, { value: 'sc', label: 'South Carolina' }, { value: 'sd', label: 'South Dakota' }, { value: 'tne', label: 'Tennessee Eastern' }, { value: 'tnm', label: 'Tennessee Middle' }, { value: 'tnw', label: 'Tennessee Western' }, { value: 'txe', label: 'Texas Eastern' }, { value: 'txn', label: 'Texas Northern' }, { value: 'txs', label: 'Texas Southern' }, { value: 'txw', label: 'Texas Western' }, { value: 'ut', label: 'Utah' }, { value: 'vt', label: 'Vermont' }, { value: 'vi', label: 'Virgin Islands' }, { value: 'vae', label: 'Virginia Eastern' }, { value: 'vaw', label: 'Virginia Western' }, { value: 'wae', label: 'Washington Eastern' }, { value: 'waw', label: 'Washington Western' }, { value: 'wvn', label: 'West Virginia Northern' }, { value: 'wvs', label: 'West Virginia Southern' }, { value: 'wie', label: 'Wisconsin Eastern' }, { value: 'wiw', label: 'Wisconsin Western' }, { value: 'wy', label: 'Wyoming' }];
	
	var industrySelectOptions = exports.industrySelectOptions = [{ value: '11', label: '11 Agriculture, Forestry, Fishing and Hunting' }, { value: '111', label: '- 111 Crop Production' }, { value: '1112', label: '- - 1112 Vegetable and Melon Farming' }, { value: '1113', label: '- - 1113 Fruit and Tree Nut Farming' }, { value: '1114', label: '- - 1114 Greenhouse, Nursery, and Floriculture Production' }, { value: '1119', label: '- - 1119 Other Crop Farming' }, { value: '112', label: '- 112 Animal Production and Aquaculture' }, { value: '1121', label: '- - 1121 Cattle Ranching and Farming' }, { value: '1122', label: '- - 1122 Hog and Pig Farming' }, { value: '1123', label: '- - 1123 Poultry and Egg Production' }, { value: '1124', label: '- - 1124 Sheep and Goat Farming' }, { value: '1125', label: '- - 1125 Aquaculture' }, { value: '1129', label: '- - 1129 Other Animal Production' }, { value: '113', label: '- 113 Forestry and Logging' }, { value: '1131', label: '- - 1131 Timber Tract Operations' }, { value: '1132', label: '- - 1132 Forest Nurseries and Gathering of Forest Products' }, { value: '1133', label: '- - 1133 Logging' }, { value: '114', label: '- 114 Fishing, Hunting and Trapping' }, { value: '1141', label: '- - 1141 Fishing' }, { value: '1142', label: '- - 1142 Hunting and Trapping' }, { value: '115', label: '- 115 Support Activities for Agriculture and Forestry' }, { value: '1151', label: '- - 1151 Support Activities for Crop Production' }, { value: '1152', label: '- - 1152 Support Activities for Animal Production' }, { value: '1153', label: '- - 1153 Support Activities for Forestry' }, { value: '21', label: '21 Mining, Quarrying, and Oil and Gas Extraction' }, { value: '211', label: '- 211 Oil and Gas Extraction' }, { value: '2111', label: '- - 2111 Oil and Gas Extraction' }, { value: '212', label: '- 212 Mining (except Oil and Gas)' }, { value: '2121', label: '- - 2121 Coal Mining' }, { value: '2122', label: '- - 2122 Metal Ore Mining' }, { value: '2123', label: '- - 2123 Nonmetallic Mineral Mining and Quarrying' }, { value: '213', label: '- 213 Support Activities for Mining' }, { value: '2131', label: '- - 2131 Support Activities for Mining' }, { value: '22', label: '22 Utilities' }, { value: '221', label: '- 221 Utilities' }, { value: '2211', label: '- - 2211 Electric Power Generation, Transmission and Distribution' }, { value: '2212', label: '- - 2212 Natural Gas Distribution' }, { value: '2213', label: '- - 2213 Water, Sewage and Other Systems' }, { value: '23', label: '23 Construction' }, { value: '236', label: '- 236 Construction of Buildings' }, { value: '2361', label: '- - 2361 Residential Building Construction' }, { value: '2362', label: '- - 2362 Nonresidential Building Construction' }, { value: '237', label: '- 237 Heavy and Civil Engineering Construction' }, { value: '2371', label: '- - 2371 Utility System Construction' }, { value: '2372', label: '- - 2372 Land Subdivision' }, { value: '2373', label: '- - 2373 Highway, Street, and Bridge Construction' }, { value: '2379', label: '- - 2379 Other Heavy and Civil Engineering Construction' }, { value: '238', label: '- 238 Specialty Trade Contractors' }, { value: '2381', label: '- - 2381 Foundation, Structure, and Building Exterior Contractors' }, { value: '2382', label: '- - 2382 Building Equipment Contractors' }, { value: '2383', label: '- - 2383 Building Finishing Contractors' }, { value: '2389', label: '- - 2389 Other Specialty Trade Contractors' }, { value: '31', label: '31 Construction' }, { value: '311', label: '- 311 Food Manufacturing' }, { value: '3111', label: '- - 3111 Animal Food Manufacturing' }, { value: '3112', label: '- - 3112 Grain and Oilseed Milling' }, { value: '3113', label: '- - 3113 Sugar and Confectionery Product Manufacturing' }, { value: '3114', label: '- - 3114 Fruit and Vegetable Preserving and Specialty Food Manufacturing' }, { value: '3115', label: '- - 3115 Dairy Product Manufacturing' }, { value: '3116', label: '- - 3116 Animal Slaughtering and Processing' }, { value: '3117', label: '- - 3117 Seafood Product Preparation and Packaging' }, { value: '3118', label: '- - 3118 Bakeries and Tortilla Manufacturing' }, { value: '3119', label: '- - 3119 Other Food Manufacturing' }, { value: '312', label: '- 312 Beverage and Tobacco Product Manufacturing' }, { value: '3121', label: '- - 3121 Beverage Manufacturing' }, { value: '3122', label: '- - 3122 Tobacco Manufacturing' }, { value: '313', label: '- 313 Textile Mills' }, { value: '3131', label: '- - 3131 Fiber, Yarn, and Thread Mills' }, { value: '3132', label: '- - 3132 Fabric Mills' }, { value: '3133', label: '- - 3133 Textile and Fabric Finishing and Fabric Coating Mills' }, { value: '314', label: '- 314 Textile Product Mills' }, { value: '3141', label: '- - 3141 Textile Furnishings Mills' }, { value: '3149', label: '- - 3149 Other Textile Product Mills' }, { value: '315', label: '- 315 Apparel Manufacturing' }, { value: '3151', label: '- - 3151 Apparel Knitting Mills' }, { value: '3152', label: '- - 3152 Cut and Sew Apparel Manufacturing' }, { value: '3159', label: '- - 3159 Apparel Accessories and Other Apparel Manufacturing' }, { value: '316', label: '- 316 Leather and Allied Product Manufacturing' }, { value: '3161', label: '- - 3161 Leather and Hide Tanning and Finishing' }, { value: '3162', label: '- - 3162 Footwear Manufacturing' }, { value: '3169', label: '- - 3169 Other Leather and Allied Product Manufacturing' }, { value: '32', label: '32 Construction' }, { value: '321', label: '- 321 Wood Product Manufacturing' }, { value: '3211', label: '- - 3211 Sawmills and Wood Preservation' }, { value: '3212', label: '- - 3212 Veneer, Plywood, and Engineered Wood Product Manufacturing' }, { value: '3219', label: '- - 3219 Other Wood Product Manufacturing' }, { value: '322', label: '- 322 Paper Manufacturing' }, { value: '3221', label: '- - 3221 Pulp, Paper, and Paperboard Mills' }, { value: '3222', label: '- - 3222 Converted Paper Product Manufacturing' }, { value: '323', label: '- 323 Printing and Related Support Activities' }, { value: '3231', label: '- - 3231 Printing and Related Support Activities' }, { value: '324', label: '- 324 Petroleum and Coal Products Manufacturing' }, { value: '3241', label: '- - 3241 Petroleum and Coal Products Manufacturing' }, { value: '325', label: '- 325 Chemical Manufacturing' }, { value: '3251', label: '- - 3251 Basic Chemical Manufacturing' }, {
	  value: '3252',
	  label: '- - 3252 Resin, Synthetic Rubber, and Artificial Synthetic Fibers and Filaments Manufacturing'
	}, { value: '3253', label: '- - 3253 Pesticide, Fertilizer, and Other Agricultural Chemical Manufacturing' }, { value: '3254', label: '- - 3254 Pharmaceutical and Medicine Manufacturing' }, { value: '3255', label: '- - 3255 Paint, Coating, and Adhesive Manufacturing' }, { value: '3256', label: '- - 3256 Soap, Cleaning Compound, and Toilet Preparation Manufacturing' }, { value: '3259', label: '- - 3259 Other Chemical Product and Preparation Manufacturing' }, { value: '326', label: '- 326 Plastics and Rubber Products Manufacturing' }, { value: '3261', label: '- - 3261 Plastics Product Manufacturing' }, { value: '3262', label: '- - 3262 Rubber Product Manufacturing' }, { value: '327', label: '- 327 Nonmetallic Mineral Product Manufacturing' }, { value: '3271', label: '- - 3271 Clay Product and Refractory Manufacturing' }, { value: '3272', label: '- - 3272 Glass and Glass Product Manufacturing' }, { value: '3273', label: '- - 3273 Cement and Concrete Product Manufacturing' }, { value: '3274', label: '- - 3274 Lime and Gypsum Product Manufacturing' }, { value: '3279', label: '- - 3279 Other Nonmetallic Mineral Product Manufacturing' }, { value: '33', label: '33 Construction' }, { value: '331', label: '- 331 Primary Metal Manufacturing' }, { value: '3311', label: '- - 3311 Iron and Steel Mills and Ferroalloy Manufacturing' }, { value: '3312', label: '- - 3312 Steel Product Manufacturing from Purchased Steel' }, { value: '3313', label: '- - 3313 Alumina and Aluminum Production and Processing' }, { value: '3314', label: '- - 3314 Nonferrous Metal (except Aluminum) Production and Processing' }, { value: '3315', label: '- - 3315 Foundries' }, { value: '332', label: '- 332 Fabricated Metal Product Manufacturing' }, { value: '3321', label: '- - 3321 Forging and Stamping' }, { value: '3322', label: '- - 3322 Cutlery and Handtool Manufacturing' }, { value: '3323', label: '- - 3323 Architectural and Structural Metals Manufacturing' }, { value: '3324', label: '- - 3324 Boiler, Tank, and Shipping Container Manufacturing' }, { value: '3325', label: '- - 3325 Hardware Manufacturing' }, { value: '3326', label: '- - 3326 Spring and Wire Product Manufacturing' }, { value: '3327', label: '- - 3327 Machine Shops; Turned Product; and Screw, Nut, and Bolt Manufacturing' }, { value: '3328', label: '- - 3328 Coating, Engraving, Heat Treating, and Allied Activities' }, { value: '3329', label: '- - 3329 Other Fabricated Metal Product Manufacturing' }, { value: '333', label: '- 333 Machinery Manufacturing' }, { value: '3331', label: '- - 3331 Agriculture, Construction, and Mining Machinery Manufacturing' }, { value: '3332', label: '- - 3332 Industrial Machinery Manufacturing' }, { value: '3333', label: '- - 3333 Commercial and Service Industry Machinery Manufacturing' }, {
	  value: '3334',
	  label: '- - 3334 Ventilation, Heating, Air-Conditioning, and Commercial Refrigeration Equipment Manufacturing'
	}, { value: '3335', label: '- - 3335 Metalworking Machinery Manufacturing' }, { value: '3336', label: '- - 3336 Engine, Turbine, and Power Transmission Equipment Manufacturing' }, { value: '3339', label: '- - 3339 Other General Purpose Machinery Manufacturing' }, { value: '334', label: '- 334 Computer and Electronic Product Manufacturing' }, { value: '3341', label: '- - 3341 Computer and Peripheral Equipment Manufacturing' }, { value: '3342', label: '- - 3342 Communications Equipment Manufacturing' }, { value: '3343', label: '- - 3343 Audio and Video Equipment Manufacturing' }, { value: '3344', label: '- - 3344 Semiconductor and Other Electronic Component Manufacturing' }, { value: '3345', label: '- - 3345 Navigational, Measuring, Electromedical, and Control Instruments Manufacturing' }, { value: '3346', label: '- - 3346 Manufacturing and Reproducing Magnetic and Optical Media' }, { value: '335', label: '- 335 Electrical Equipment, Appliance, and Component Manufacturing' }, { value: '3351', label: '- - 3351 Electric Lighting Equipment Manufacturing' }, { value: '3352', label: '- - 3352 Household Appliance Manufacturing' }, { value: '3353', label: '- - 3353 Electrical Equipment Manufacturing' }, { value: '3359', label: '- - 3359 Other Electrical Equipment and Component Manufacturing' }, { value: '336', label: '- 336 Transportation Equipment Manufacturing' }, { value: '3361', label: '- - 3361 Motor Vehicle Manufacturing' }, { value: '3362', label: '- - 3362 Motor Vehicle Body and Trailer Manufacturing' }, { value: '3363', label: '- - 3363 Motor Vehicle Parts Manufacturing' }, { value: '3364', label: '- - 3364 Aerospace Product and Parts Manufacturing' }, { value: '3365', label: '- - 3365 Railroad Rolling Stock Manufacturing' }, { value: '3366', label: '- - 3366 Ship and Boat Building' }, { value: '3369', label: '- - 3369 Other Transportation Equipment Manufacturing' }, { value: '337', label: '- 337 Furniture and Related Product Manufacturing' }, { value: '3371', label: '- - 3371 Household and Institutional Furniture and Kitchen Cabinet Manufacturing' }, { value: '3372', label: '- - 3372 Office Furniture (including Fixtures) Manufacturing' }, { value: '3379', label: '- - 3379 Other Furniture Related Product Manufacturing' }, { value: '339', label: '- 339 Miscellaneous Manufacturing' }, { value: '3391', label: '- - 3391 Medical Equipment and Supplies Manufacturing' }, { value: '3399', label: '- - 3399 Other Miscellaneous Manufacturing' }, { value: '42', label: '42 Wholesale Trade' }, { value: '423', label: '- 423 Merchant Wholesalers, Durable Goods' }, { value: '4231', label: '- - 4231 Motor Vehicle and Motor Vehicle Parts and Supplies Merchant Wholesalers' }, { value: '4232', label: '- - 4232 Furniture and Home Furnishing Merchant Wholesalers' }, { value: '4233', label: '- - 4233 Lumber and Other Construction Materials Merchant Wholesalers' }, { value: '4234', label: '- - 4234 Professional and Commercial Equipment and Supplies Merchant Wholesalers' }, { value: '4235', label: '- - 4235 Metal and Mineral (except Petroleum) Merchant Wholesalers' }, { value: '4236', label: '- - 4236 Household Appliances and Electrical and Electronic Goods Merchant Wholesalers' }, { value: '4237', label: '- - 4237 Hardware, and Plumbing and Heating Equipment and Supplies Merchant Wholesalers' }, { value: '4238', label: '- - 4238 Machinery, Equipment, and Supplies Merchant Wholesalers' }, { value: '4239', label: '- - 4239 Miscellaneous Durable Goods Merchant Wholesalers' }, { value: '424', label: '- 424 Merchant Wholesalers, Nondurable Goods' }, { value: '4241', label: '- - 4241 Paper and Paper Product Merchant Wholesalers' }, { value: '4242', label: "- - 4242 Drugs and Druggists' Sundries Merchant Wholesalers" }, { value: '4243', label: '- - 4243 Apparel, Piece Goods, and Notions Merchant Wholesalers' }, { value: '4244', label: '- - 4244 Grocery and Related Product Merchant Wholesalers' }, { value: '4245', label: '- - 4245 Farm Product Raw Material Merchant Wholesalers' }, { value: '4246', label: '- - 4246 Chemical and Allied Products Merchant Wholesalers' }, { value: '4247', label: '- - 4247 Petroleum and Petroleum Products Merchant Wholesalers' }, { value: '4248', label: '- - 4248 Beer, Wine, and Distilled Alcoholic Beverage Merchant Wholesalers' }, { value: '4249', label: '- - 4249 Miscellaneous Nondurable Goods Merchant Wholesalers' }, { value: '425', label: '- 425 Wholesale Electronic Markets and Agents and Brokers' }, { value: '4251', label: '- - 4251 Wholesale Electronic Markets and Agents and Brokers' }, { value: '44', label: '44 Wholesale Trade' }, { value: '441', label: '- 441 Motor Vehicle and Parts Dealers' }, { value: '4411', label: '- - 4411 Automobile Dealers' }, { value: '4412', label: '- - 4412 Other Motor Vehicle Dealers' }, { value: '4413', label: '- - 4413 Automotive Parts, Accessories, and Tire Stores' }, { value: '442', label: '- 442 Furniture and Home Furnishings Stores' }, { value: '4421', label: '- - 4421 Furniture Stores' }, { value: '4422', label: '- - 4422 Home Furnishings Stores' }, { value: '443', label: '- 443 Electronics and Appliance Stores' }, { value: '4431', label: '- - 4431 Electronics and Appliance Stores' }, { value: '444', label: '- 444 Building Material and Garden Equipment and Supplies Dealers' }, { value: '4441', label: '- - 4441 Building Material and Supplies Dealers' }, { value: '4442', label: '- - 4442 Lawn and Garden Equipment and Supplies Stores' }, { value: '445', label: '- 445 Food and Beverage Stores' }, { value: '4451', label: '- - 4451 Grocery Stores' }, { value: '4452', label: '- - 4452 Specialty Food Stores' }, { value: '4453', label: '- - 4453 Beer, Wine, and Liquor Stores' }, { value: '446', label: '- 446 Health and Personal Care Stores' }, { value: '4461', label: '- - 4461 Health and Personal Care Stores' }, { value: '447', label: '- 447 Gasoline Stations' }, { value: '4471', label: '- - 4471 Gasoline Stations' }, { value: '448', label: '- 448 Clothing and Clothing Accessories Stores' }, { value: '4481', label: '- - 4481 Clothing Stores' }, { value: '4482', label: '- - 4482 Shoe Stores' }, { value: '4483', label: '- - 4483 Jewelry, Luggage, and Leather Goods Stores' }, { value: '45', label: '45 Wholesale Trade' }, { value: '451', label: '- 451 Sporting Goods, Hobby, Musical Instrument, and Book Stores' }, { value: '4511', label: '- - 4511 Sporting Goods, Hobby, and Musical Instrument Stores' }, { value: '4512', label: '- - 4512 Book Stores and News Dealers' }, { value: '452', label: '- 452 General Merchandise Stores' }, { value: '4521', label: '- - 4521 Department Stores' }, { value: '4529', label: '- - 4529 Other General Merchandise Stores' }, { value: '453', label: '- 453 Miscellaneous Store Retailers' }, { value: '4531', label: '- - 4531 Florists' }, { value: '4532', label: '- - 4532 Office Supplies, Stationery, and Gift Stores' }, { value: '4533', label: '- - 4533 Used Merchandise Stores' }, { value: '4539', label: '- - 4539 Other Miscellaneous Store Retailers' }, { value: '454', label: '- 454 Nonstore Retailers' }, { value: '4541', label: '- - 4541 Electronic Shopping and Mail-Order Houses' }, { value: '4542', label: '- - 4542 Vending Machine Operators' }, { value: '4543', label: '- - 4543 Direct Selling Establishments' }, { value: '48', label: '48 Wholesale Trade' }, { value: '481', label: '- 481 Air Transportation' }, { value: '4811', label: '- - 4811 Scheduled Air Transportation' }, { value: '4812', label: '- - 4812 Nonscheduled Air Transportation' }, { value: '482', label: '- 482 Rail Transportation' }, { value: '4821', label: '- - 4821 Rail Transportation' }, { value: '483', label: '- 483 Water Transportation' }, { value: '4831', label: '- - 4831 Deep Sea, Coastal, and Great Lakes Water Transportation' }, { value: '4832', label: '- - 4832 Inland Water Transportation' }, { value: '484', label: '- 484 Truck Transportation' }, { value: '4841', label: '- - 4841 General Freight Trucking' }, { value: '4842', label: '- - 4842 Specialized Freight Trucking' }, { value: '485', label: '- 485 Transit and Ground Passenger Transportation' }, { value: '4851', label: '- - 4851 Urban Transit Systems' }, { value: '4852', label: '- - 4852 Interurban and Rural Bus Transportation' }, { value: '4853', label: '- - 4853 Taxi and Limousine Service' }, { value: '4854', label: '- - 4854 School and Employee Bus Transportation' }, { value: '4855', label: '- - 4855 Charter Bus Industry' }, { value: '4859', label: '- - 4859 Other Transit and Ground Passenger Transportation' }, { value: '486', label: '- 486 Pipeline Transportation' }, { value: '4861', label: '- - 4861 Pipeline Transportation of Crude Oil' }, { value: '4862', label: '- - 4862 Pipeline Transportation of Natural Gas' }, { value: '4869', label: '- - 4869 Other Pipeline Transportation' }, { value: '487', label: '- 487 Scenic and Sightseeing Transportation' }, { value: '4871', label: '- - 4871 Scenic and Sightseeing Transportation, Land' }, { value: '4872', label: '- - 4872 Scenic and Sightseeing Transportation, Water' }, { value: '4879', label: '- - 4879 Scenic and Sightseeing Transportation, Other' }, { value: '488', label: '- 488 Support Activities for Transportation' }, { value: '4881', label: '- - 4881 Support Activities for Air Transportation' }, { value: '4882', label: '- - 4882 Support Activities for Rail Transportation' }, { value: '4883', label: '- - 4883 Support Activities for Water Transportation' }, { value: '4884', label: '- - 4884 Support Activities for Road Transportation' }, { value: '4885', label: '- - 4885 Freight Transportation Arrangement' }, { value: '4889', label: '- - 4889 Other Support Activities for Transportation' }, { value: '49', label: '49 Wholesale Trade' }, { value: '491', label: '- 491 Postal Service' }, { value: '4911', label: '- - 4911 Postal Service' }, { value: '492', label: '- 492 Couriers and Messengers' }, { value: '4921', label: '- - 4921 Couriers and Express Delivery Services' }, { value: '4922', label: '- - 4922 Local Messengers and Local Delivery' }, { value: '493', label: '- 493 Warehousing and Storage' }, { value: '4931', label: '- - 4931 Warehousing and Storage' }, { value: '51', label: '51 Information' }, { value: '511', label: '- 511 Publishing Industries (except Internet)' }, { value: '5111', label: '- - 5111 Newspaper, Periodical, Book, and Directory Publishers' }, { value: '5112', label: '- - 5112 Software Publishers' }, { value: '512', label: '- 512 Motion Picture and Sound Recording Industries' }, { value: '5121', label: '- - 5121 Motion Picture and Video Industries' }, { value: '5122', label: '- - 5122 Sound Recording Industries' }, { value: '515', label: '- 515 Broadcasting (except Internet)' }, { value: '5151', label: '- - 5151 Radio and Television Broadcasting' }, { value: '5152', label: '- - 5152 Cable and Other Subscription Programming' }, { value: '517', label: '- 517 Telecommunications' }, { value: '5171', label: '- - 5171 Wired Telecommunications Carriers' }, { value: '5172', label: '- - 5172 Wireless Telecommunications Carriers (except Satellite)' }, { value: '5174', label: '- - 5174 Satellite Telecommunications' }, { value: '5179', label: '- - 5179 Other Telecommunications' }, { value: '518', label: '- 518 Data Processing, Hosting, and Related Services' }, { value: '5182', label: '- - 5182 Data Processing, Hosting, and Related Services' }, { value: '519', label: '- 519 Other Information Services' }, { value: '5191', label: '- - 5191 Other Information Services' }, { value: '52', label: '52 Finance and Insurance' }, { value: '521', label: '- 521 Monetary Authorities-Central Bank' }, { value: '5211', label: '- - 5211 Monetary Authorities-Central Bank' }, { value: '522', label: '- 522 Credit Intermediation and Related Activities' }, { value: '5221', label: '- - 5221 Depository Credit Intermediation' }, { value: '5222', label: '- - 5222 Nondepository Credit Intermediation' }, { value: '5223', label: '- - 5223 Activities Related to Credit Intermediation' }, {
	  value: '523',
	  label: '- 523 Securities, Commodity Contracts, and Other Financial Investments and Related Activities'
	}, { value: '5231', label: '- - 5231 Securities and Commodity Contracts Intermediation and Brokerage' }, { value: '5232', label: '- - 5232 Securities and Commodity Exchanges' }, { value: '5239', label: '- - 5239 Other Financial Investment Activities' }, { value: '524', label: '- 524 Insurance Carriers and Related Activities' }, { value: '5241', label: '- - 5241 Insurance Carriers' }, { value: '5242', label: '- - 5242 Agencies, Brokerages, and Other Insurance Related Activities' }, { value: '525', label: '- 525 Funds, Trusts, and Other Financial Vehicles' }, { value: '5251', label: '- - 5251 Insurance and Employee Benefit Funds' }, { value: '5259', label: '- - 5259 Other Investment Pools and Funds' }, { value: '53', label: '53 Real Estate and Rental and Leasing' }, { value: '531', label: '- 531 Real Estate' }, { value: '5311', label: '- - 5311 Lessors of Real Estate' }, { value: '5312', label: '- - 5312 Offices of Real Estate Agents and Brokers' }, { value: '5313', label: '- - 5313 Activities Related to Real Estate' }, { value: '532', label: '- 532 Rental and Leasing Services' }, { value: '5321', label: '- - 5321 Automotive Equipment Rental and Leasing' }, { value: '5322', label: '- - 5322 Consumer Goods Rental' }, { value: '5323', label: '- - 5323 General Rental Centers' }, { value: '5324', label: '- - 5324 Commercial and Industrial Machinery and Equipment Rental and Leasing' }, { value: '533', label: '- 533 Lessors of Nonfinancial Intangible Assets (except Copyrighted Works)' }, { value: '5331', label: '- - 5331 Lessors of Nonfinancial Intangible Assets (except Copyrighted Works)' }, { value: '54', label: '54 Professional, Scientific, and Technical Services' }, { value: '541', label: '- 541 Professional, Scientific, and Technical Services' }, { value: '5411', label: '- - 5411 Legal Services' }, { value: '5412', label: '- - 5412 Accounting, Tax Preparation, Bookkeeping, and Payroll Services' }, { value: '5413', label: '- - 5413 Architectural, Engineering, and Related Services' }, { value: '5414', label: '- - 5414 Specialized Design Services' }, { value: '5415', label: '- - 5415 Computer Systems Design and Related Services' }, { value: '5416', label: '- - 5416 Management, Scientific, and Technical Consulting Services' }, { value: '5417', label: '- - 5417 Scientific Research and Development Services' }, { value: '5418', label: '- - 5418 Advertising, Public Relations, and Related Services' }, { value: '5419', label: '- - 5419 Other Professional, Scientific, and Technical Services' }, { value: '55', label: '55 Management of Companies and Enterprises' }, { value: '551', label: '- 551 Management of Companies and Enterprises' }, { value: '5511', label: '- - 5511 Management of Companies and Enterprises' }, { value: '56', label: '56 Administrative and Support and Waste Management and Remediation Services' }, { value: '561', label: '- 561 Administrative and Support Services' }, { value: '5611', label: '- - 5611 Office Administrative Services' }, { value: '5612', label: '- - 5612 Facilities Support Services' }, { value: '5613', label: '- - 5613 Employment Services' }, { value: '5614', label: '- - 5614 Business Support Services' }, { value: '5615', label: '- - 5615 Travel Arrangement and Reservation Services' }, { value: '5616', label: '- - 5616 Investigation and Security Services' }, { value: '5617', label: '- - 5617 Services to Buildings and Dwellings' }, { value: '5619', label: '- - 5619 Other Support Services' }, { value: '562', label: '- 562 Waste Management and Remediation Services' }, { value: '5621', label: '- - 5621 Waste Collection' }, { value: '5622', label: '- - 5622 Waste Treatment and Disposal' }, { value: '5629', label: '- - 5629 Remediation and Other Waste Management Services' }, { value: '61', label: '61 Educational Services' }, { value: '611', label: '- 611 Educational Services' }, { value: '6111', label: '- - 6111 Elementary and Secondary Schools' }, { value: '6112', label: '- - 6112 Junior Colleges' }, { value: '6113', label: '- - 6113 Colleges, Universities, and Professional Schools' }, { value: '6114', label: '- - 6114 Business Schools and Computer and Management Training' }, { value: '6115', label: '- - 6115 Technical and Trade Schools' }, { value: '6116', label: '- - 6116 Other Schools and Instruction' }, { value: '6117', label: '- - 6117 Educational Support Services' }, { value: '62', label: '62 Health Care and Social Assistance' }, { value: '621', label: '- 621 Ambulatory Health Care Services' }, { value: '6211', label: '- - 6211 Offices of Physicians' }, { value: '6212', label: '- - 6212 Offices of Dentists' }, { value: '6213', label: '- - 6213 Offices of Other Health Practitioners' }, { value: '6214', label: '- - 6214 Outpatient Care Centers' }, { value: '6215', label: '- - 6215 Medical and Diagnostic Laboratories' }, { value: '6216', label: '- - 6216 Home Health Care Services' }, { value: '6219', label: '- - 6219 Other Ambulatory Health Care Services' }, { value: '622', label: '- 622 Hospitals' }, { value: '6221', label: '- - 6221 General Medical and Surgical Hospitals' }, { value: '6222', label: '- - 6222 Psychiatric and Substance Abuse Hospitals' }, { value: '6223', label: '- - 6223 Specialty (except Psychiatric and Substance Abuse) Hospitals' }, { value: '623', label: '- 623 Nursing and Residential Care Facilities' }, { value: '6231', label: '- - 6231 Nursing Care Facilities (Skilled Nursing Facilities)' }, {
	  value: '6232',
	  label: '- - 6232 Residential Intellectual and Developmental Disability, Mental Health, and Substance Abuse Facilities'
	}, {
	  value: '6233',
	  label: '- - 6233 Continuing Care Retirement Communities and Assisted Living Facilities for the Elderly'
	}, { value: '6239', label: '- - 6239 Other Residential Care Facilities' }, { value: '624', label: '- 624 Social Assistance' }, { value: '6241', label: '- - 6241 Individual and Family Services' }, { value: '6242', label: '- - 6242 Community Food and Housing, and Emergency and Other Relief Services' }, { value: '6243', label: '- - 6243 Vocational Rehabilitation Services' }, { value: '6244', label: '- - 6244 Child Day Care Services' }, { value: '71', label: '71 Arts, Entertainment, and Recreation' }, { value: '711', label: '- 711 Performing Arts, Spectator Sports, and Related Industries' }, { value: '7111', label: '- - 7111 Performing Arts Companies' }, { value: '7112', label: '- - 7112 Spectator Sports' }, { value: '7113', label: '- - 7113 Promoters of Performing Arts, Sports, and Similar Events' }, {
	  value: '7114',
	  label: '- - 7114 Agents and Managers for Artists, Athletes, Entertainers, and Other Public Figures'
	}, { value: '7115', label: '- - 7115 Independent Artists, Writers, and Performers' }, { value: '712', label: '- 712 Museums, Historical Sites, and Similar Institutions' }, { value: '7121', label: '- - 7121 Museums, Historical Sites, and Similar Institutions' }, { value: '713', label: '- 713 Amusement, Gambling, and Recreation Industries' }, { value: '7131', label: '- - 7131 Amusement Parks and Arcades' }, { value: '7132', label: '- - 7132 Gambling Industries' }, { value: '7139', label: '- - 7139 Other Amusement and Recreation Industries' }, { value: '72', label: '72 Accommodation and Food Services' }, { value: '721', label: '- 721 Accommodation' }, { value: '7211', label: '- - 7211 Traveler Accommodation' }, { value: '7212', label: '- - 7212 RV (Recreational Vehicle) Parks and Recreational Camps' }, { value: '7213', label: '- - 7213 Rooming and Boarding Houses' }, { value: '722', label: '- 722 Food Services and Drinking Places' }, { value: '7223', label: '- - 7223 Special Food Services' }, { value: '7224', label: '- - 7224 Drinking Places (Alcoholic Beverages)' }, { value: '7225', label: '- - 7225 Restaurants and Other Eating Places' }, { value: '81', label: '81 Other Services (except Public Administration)' }, { value: '811', label: '- 811 Repair and Maintenance' }, { value: '8111', label: '- - 8111 Automotive Repair and Maintenance' }, { value: '8112', label: '- - 8112 Electronic and Precision Equipment Repair and Maintenance' }, {
	  value: '8113',
	  label: '- - 8113 Commercial and Industrial Machinery and Equipment (except Automotive and Electronic) Repair and Maintenance'
	}, { value: '8114', label: '- - 8114 Personal and Household Goods Repair and Maintenance' }, { value: '812', label: '- 812 Personal and Laundry Services' }, { value: '8121', label: '- - 8121 Personal Care Services' }, { value: '8122', label: '- - 8122 Death Care Services' }, { value: '8123', label: '- - 8123 Drycleaning and Laundry Services' }, { value: '8129', label: '- - 8129 Other Personal Services' }, { value: '813', label: '- 813 Religious, Grantmaking, Civic, Professional, and Similar Organizations' }, { value: '8131', label: '- - 8131 Religious Organizations' }, { value: '8132', label: '- - 8132 Grantmaking and Giving Services' }, { value: '8133', label: '- - 8133 Social Advocacy Organizations' }, { value: '8134', label: '- - 8134 Civic and Social Organizations' }, { value: '8139', label: '- - 8139 Business, Professional, Labor, Political, and Similar Organizations' }, { value: '814', label: '- 814 Private Households' }, { value: '8141', label: '- - 8141 Private Households' }, { value: '92', label: '92 Public Administration' }, { value: '921', label: '- 921 Executive, Legislative, and Other General Government Support' }, { value: '9211', label: '- - 9211 Executive, Legislative, and Other General Government Support' }, { value: '922', label: '- 922 Justice, Public Order, and Safety Activities' }, { value: '9221', label: '- - 9221 Justice, Public Order, and Safety Activities' }, { value: '923', label: '- 923 Administration of Human Resource Programs' }, { value: '9231', label: '- - 9231 Administration of Human Resource Programs' }, { value: '924', label: '- 924 Administration of Environmental Quality Programs' }, { value: '9241', label: '- - 9241 Administration of Environmental Quality Programs' }, { value: '925', label: '- 925 Administration of Housing Programs, Urban Planning, and Community Development' }, { value: '9251', label: '- - 9251 Administration of Housing Programs, Urban Planning, and Community Development' }, { value: '926', label: '- 926 Administration of Economic Programs' }, { value: '9261', label: '- - 9261 Administration of Economic Programs' }, { value: '927', label: '- 927 Space Research and Technology' }, { value: '9271', label: '- - 9271 Space Research and Technology' }, { value: '928', label: '- 928 National Security and International Affairs' }, { value: '9281', label: '- - 9281 National Security and International Affairs' }];
	
	var assetsLiabilitiesSelectOptions = exports.assetsLiabilitiesSelectOptions = [{ value: 'Unknown', label: 'Unknown' }, { value: '$0 to $50,000', label: '$0 to $50,000' }, { value: '$50,001 to $100,000', label: '$50,001 to $100,000' }, { value: '$100,001 to $500,000', label: '$100,001 to $500,000' }, { value: '$500,001 to $1 million', label: '$500,001 to $1 million' }, { value: '$1,000,001 to $10 million', label: '$1,000,001 to $10 million' }, { value: '$10,000,001 to $50 million', label: '$10,000,001 to $50 million' }, { value: '$50,000,001 to $100 million', label: '$50,000,001 to $100 million' }, { value: '$100,000,001 to $500 million', label: '$100,000,001 to $500 million' }, { value: '$500,000,001 to $1 billion', label: '$500,000,001 to $1 billion' }, { value: 'More than $1 billion', label: 'More than $1 billion' }, { value: '$1,000,000,001 to $10 billion', label: '$1,000,000,001 to $10 billion' }, { value: '$10,000,000,001 to $50 billion', label: '$10,000,000,001 to $50 billion' }, { value: 'More than $50 billion', label: 'More than $50 billion' }];

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRedux = __webpack_require__(13);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(30);
	
	__webpack_require__(2189);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlertError = function (_Component) {
	  _inherits(AlertError, _Component);
	
	  function AlertError() {
	    _classCallCheck(this, AlertError);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  AlertError.prototype.render = function render() {
	    if (!this.props.errors) return null;
	    var messages = this.props.messages || this.props.errors.get('messages').map(function (msg, index) {
	      return _react2.default.createElement(
	        'div',
	        { key: index },
	        msg
	      );
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'alert alert-danger' },
	      messages
	    );
	  };
	
	  return AlertError;
	}(_react.Component);
	
	//TODO this looks kind of wonky but will be refactored out when the service is updated
	//will need to move this logic outside of component and into some mapper in the action
	
	
	function mapStateToProps(state) {
	  var messages = null;
	  if (state.get('searchErrors')) {
	    var credentialsErrorMessages = state.getIn(['searchErrors', 'messages'], (0, _immutable.List)()).some(function (str) {
	      return str.toString().match(/PACER login rejected|Unable to decrypt supplied password|Username supplied without password/i);
	    });
	    var credentialsErrorDetails = state.getIn(['searchErrors', 'details'], (0, _immutable.List)()).some(function (str) {
	      return str.toString().match(/PACER login rejected|Unable to decrypt supplied password|Username supplied without password/i);
	    });
	
	    if (credentialsErrorMessages || credentialsErrorDetails) messages = state.getIn(['user', 'settings', 'firmMember']) ? _react2.default.createElement(
	      'div',
	      null,
	      'Your firm\'s PACER credentials are not working. Please make sure to contact ',
	      state.getIn(['user', 'settings', 'firmMaster']),
	      ' to update your firm\'s PACER credentials so everything works properly.'
	    ) : _react2.default.createElement(
	      'div',
	      null,
	      'Your PACER credentials are no longer working. If you have recently updated your PACER account or password,',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'a',
	        { target: '_blank', href: '/user/' + state.getIn(['user', 'settings', 'currentUser']) + '/edit' },
	        'please update the same on our site here'
	      ),
	      '.'
	    );
	  }
	
	  return {
	    errors: state.get('validationErrors') || state.get('searchErrors'),
	    messages: messages
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(AlertError);

/***/ },
/* 51 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.Style = exports.State = exports.DEVICE_SIZES = exports.SIZE_MAP = exports.Size = void 0;
	var Size = {
	  LARGE: 'large',
	  SMALL: 'small',
	  XSMALL: 'xsmall'
	};
	exports.Size = Size;
	var SIZE_MAP = {
	  large: 'lg',
	  medium: 'md',
	  small: 'sm',
	  xsmall: 'xs',
	  lg: 'lg',
	  md: 'md',
	  sm: 'sm',
	  xs: 'xs'
	};
	exports.SIZE_MAP = SIZE_MAP;
	var DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];
	exports.DEVICE_SIZES = DEVICE_SIZES;
	var State = {
	  SUCCESS: 'success',
	  WARNING: 'warning',
	  DANGER: 'danger',
	  INFO: 'info'
	};
	exports.State = State;
	var Style = {
	  DEFAULT: 'default',
	  PRIMARY: 'primary',
	  LINK: 'link',
	  INVERSE: 'inverse'
	};
	exports.Style = Style;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1606);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./AdvancedSearch.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./AdvancedSearch.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.InputField = exports.LiabilitiesField = exports.AssetsField = exports.IndustryField = exports.BusinessOnlyField = exports.DatePickerField = exports.NatureOfSuit = exports.TypeField = exports.ChapterField = exports.PartyNameField = exports.CaseTitlesField = exports.QueryField = exports.RegionField = exports.CasesField = exports.SearchPDFsField = undefined;
	
	var _SearchPDFsField = __webpack_require__(628);
	
	var _SearchPDFsField2 = _interopRequireDefault(_SearchPDFsField);
	
	var _CasesField = __webpack_require__(618);
	
	var _CasesField2 = _interopRequireDefault(_CasesField);
	
	var _RegionField = __webpack_require__(627);
	
	var _RegionField2 = _interopRequireDefault(_RegionField);
	
	var _QueryField = __webpack_require__(626);
	
	var _QueryField2 = _interopRequireDefault(_QueryField);
	
	var _CaseTitlesField = __webpack_require__(617);
	
	var _CaseTitlesField2 = _interopRequireDefault(_CaseTitlesField);
	
	var _PartyNameField = __webpack_require__(625);
	
	var _PartyNameField2 = _interopRequireDefault(_PartyNameField);
	
	var _ChapterField = __webpack_require__(619);
	
	var _ChapterField2 = _interopRequireDefault(_ChapterField);
	
	var _TypeField = __webpack_require__(629);
	
	var _TypeField2 = _interopRequireDefault(_TypeField);
	
	var _NatureOfSuit = __webpack_require__(624);
	
	var _NatureOfSuit2 = _interopRequireDefault(_NatureOfSuit);
	
	var _DatePickerField = __webpack_require__(620);
	
	var _DatePickerField2 = _interopRequireDefault(_DatePickerField);
	
	var _BusinessOnlyField = __webpack_require__(616);
	
	var _BusinessOnlyField2 = _interopRequireDefault(_BusinessOnlyField);
	
	var _IndustryField = __webpack_require__(621);
	
	var _IndustryField2 = _interopRequireDefault(_IndustryField);
	
	var _AssetsField = __webpack_require__(615);
	
	var _AssetsField2 = _interopRequireDefault(_AssetsField);
	
	var _LiabilitiesField = __webpack_require__(623);
	
	var _LiabilitiesField2 = _interopRequireDefault(_LiabilitiesField);
	
	var _InputField = __webpack_require__(622);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.SearchPDFsField = _SearchPDFsField2.default;
	exports.CasesField = _CasesField2.default;
	exports.RegionField = _RegionField2.default;
	exports.QueryField = _QueryField2.default;
	exports.CaseTitlesField = _CaseTitlesField2.default;
	exports.PartyNameField = _PartyNameField2.default;
	exports.ChapterField = _ChapterField2.default;
	exports.TypeField = _TypeField2.default;
	exports.NatureOfSuit = _NatureOfSuit2.default;
	exports.DatePickerField = _DatePickerField2.default;
	exports.BusinessOnlyField = _BusinessOnlyField2.default;
	exports.IndustryField = _IndustryField2.default;
	exports.AssetsField = _AssetsField2.default;
	exports.LiabilitiesField = _LiabilitiesField2.default;
	exports.InputField = _InputField2.default;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TemplateTag = __webpack_require__(1275);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TemplateTag2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9UZW1wbGF0ZVRhZy9pbmRleC5qcyJdLCJuYW1lcyI6WyJkZWZhdWx0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O1FBQU9BLE8iLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmcm9tICcuL1RlbXBsYXRlVGFnJztcbiJdfQ==

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _trimResultTransformer = __webpack_require__(1314);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _trimResultTransformer2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90cmltUmVzdWx0VHJhbnNmb3JtZXIvaW5kZXguanMiXSwibmFtZXMiOlsiZGVmYXVsdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztRQUFPQSxPIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnJvbSAnLi90cmltUmVzdWx0VHJhbnNmb3JtZXInO1xuIl19

/***/ },
/* 56 */
[2311, 445, 285, 44],
/* 57 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 58 */
/***/ function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.isCourtDrive = isCourtDrive;
	exports.isProd = isProd;
	exports.drupalPermsInclude = drupalPermsInclude;
	exports.getCourtCodeAndCaseNumFromUrl = getCourtCodeAndCaseNumFromUrl;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isCourtDrive() {
	  return (/courtdrive/i.test(window.location.hostname)
	  );
	}
	
	function isProd() {
	  return !/dev.azk.io/i.test(window.location.hostname);
	}
	
	function drupalPermsInclude(permission) {
	  return _lodash2.default.some(window.Drupal.settings.PERMS, function (p) {
	    return _lodash2.default.lowerCase(p).includes(_lodash2.default.lowerCase(permission));
	  });
	}
	
	function getCourtCodeAndCaseNumFromUrl() {
	  var urlPathsegments = window.location.href.split('/');
	  var lastPathSegment = urlPathsegments[urlPathsegments.length - 1];
	  var caseUUIDSegments = lastPathSegment.split('-').splice(0, 4);
	  var case_uuid = caseUUIDSegments[1] + ':' + caseUUIDSegments[2] + '-' + caseUUIDSegments[3] + '-' + caseUUIDSegments[4];
	  var court_code = caseUUIDSegments[0];
	  return { case_uuid: case_uuid, court_code: court_code };
	}

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useDataApi;
	
	var _react = __webpack_require__(1);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Data API allows for immediate fetch of resources
	
	
	function useDataApi(defaultUrl, initialData, defaultWhenNotFound) {
	  var _this = this;
	
	  var _useState = (0, _react.useState)(initialData),
	      data = _useState[0],
	      setData = _useState[1];
	
	  var _useState2 = (0, _react.useState)(initialData),
	      response = _useState2[0],
	      setResponse = _useState2[1];
	  // const [url, setUrl] = useState(initialUrl);
	
	
	  var _useState3 = (0, _react.useState)(true),
	      isLoading = _useState3[0],
	      setIsLoading = _useState3[1];
	
	  var _useState4 = (0, _react.useState)(false),
	      isError = _useState4[0],
	      setIsError = _useState4[1];
	
	  var fetchData = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url) {
	      var result;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              setIsError(false);
	              setIsLoading(true);
	              _context.prev = 2;
	              _context.next = 5;
	              return (0, _superagent2.default)(url);
	
	            case 5:
	              result = _context.sent;
	
	              setData(result.body);
	              setResponse(result);
	              _context.next = 13;
	              break;
	
	            case 10:
	              _context.prev = 10;
	              _context.t0 = _context['catch'](2);
	
	              if (_context.t0.response.notFound && defaultWhenNotFound) {
	                setData(defaultWhenNotFound);
	                setIsError(false);
	              } else {
	                setIsError(_context.t0);
	                setResponse(_context.t0.response);
	              }
	
	            case 13:
	              setIsLoading(false);
	
	            case 14:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this, [[2, 10]]);
	    }));
	
	    return function fetchData(_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  (0, _react.useEffect)(function () {
	    fetchData(defaultUrl);
	  }, [defaultUrl]);
	
	  var triggerRefresh = function triggerRefresh() {
	    fetchData(defaultUrl);
	  };
	
	  return [{ data: data, isLoading: isLoading, isError: isError, response: response }, { setData: setData, fetchData: fetchData, triggerRefresh: triggerRefresh }];
	}

/***/ },
/* 61 */
29,
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	// TODO: This module should be ElementChildren, and should use named exports.
	
	/**
	 * Iterates through children that are typically specified as `props.children`,
	 * but only maps over children that are "valid components".
	 *
	 * The mapFunction provided index will be normalised to the components mapped,
	 * so an invalid component would not increase the index.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @return {object} Object containing the ordered map of results.
	 */
	function map(children, func, context) {
	  var index = 0;
	  return _react.default.Children.map(children, function (child) {
	    if (!_react.default.isValidElement(child)) {
	      return child;
	    }
	
	    return func.call(context, child, index++);
	  });
	}
	/**
	 * Iterates through children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for context.
	 */
	
	
	function forEach(children, func, context) {
	  var index = 0;
	
	  _react.default.Children.forEach(children, function (child) {
	    if (!_react.default.isValidElement(child)) {
	      return;
	    }
	
	    func.call(context, child, index++);
	  });
	}
	/**
	 * Count the number of "valid components" in the Children container.
	 *
	 * @param {?*} children Children tree container.
	 * @returns {number}
	 */
	
	
	function count(children) {
	  var result = 0;
	
	  _react.default.Children.forEach(children, function (child) {
	    if (!_react.default.isValidElement(child)) {
	      return;
	    }
	
	    ++result;
	  });
	
	  return result;
	}
	/**
	 * Finds children that are typically specified as `props.children`,
	 * but only iterates over children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @returns {array} of children that meet the func return statement
	 */
	
	
	function filter(children, func, context) {
	  var index = 0;
	  var result = [];
	
	  _react.default.Children.forEach(children, function (child) {
	    if (!_react.default.isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result.push(child);
	    }
	  });
	
	  return result;
	}
	
	function find(children, func, context) {
	  var index = 0;
	  var result;
	
	  _react.default.Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	
	    if (!_react.default.isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = child;
	    }
	  });
	
	  return result;
	}
	
	function every(children, func, context) {
	  var index = 0;
	  var result = true;
	
	  _react.default.Children.forEach(children, function (child) {
	    if (!result) {
	      return;
	    }
	
	    if (!_react.default.isValidElement(child)) {
	      return;
	    }
	
	    if (!func.call(context, child, index++)) {
	      result = false;
	    }
	  });
	
	  return result;
	}
	
	function some(children, func, context) {
	  var index = 0;
	  var result = false;
	
	  _react.default.Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	
	    if (!_react.default.isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = true;
	    }
	  });
	
	  return result;
	}
	
	function toArray(children) {
	  var result = [];
	
	  _react.default.Children.forEach(children, function (child) {
	    if (!_react.default.isValidElement(child)) {
	      return;
	    }
	
	    result.push(child);
	  });
	
	  return result;
	}
	
	var _default = {
	  map: map,
	  forEach: forEach,
	  count: count,
	  find: find,
	  filter: filter,
	  every: every,
	  some: some,
	  toArray: toArray
	};
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _FieldSet = __webpack_require__(1097);
	
	var _FieldSet2 = _interopRequireDefault(_FieldSet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FieldSet2.default;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.hasValidClientCode = exports.setClientCode = exports.getClientCodes = undefined;
	exports.savedCodes = savedCodes;
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _url = __webpack_require__(180);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _clientCodeActionTypes = __webpack_require__(716);
	
	var actionTypes = _interopRequireWildcard(_clientCodeActionTypes);
	
	var _Notification = __webpack_require__(24);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getClientCodes = exports.getClientCodes = function getClientCodes() {
	  var searchStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  return function (dispatch) {
	    var query_str = 'query=' + searchStr + '&page=1';
	
	    dispatch({
	      type: actionTypes.CLIENT_CODE_LIST.REQUEST
	    });
	
	    var onSuccess = function onSuccess(response) {
	      return dispatch({
	        type: actionTypes.CLIENT_CODE_LIST.SUCCESS,
	        resBody: response.body.data,
	        hasMadeRequest: false
	      });
	    };
	
	    var onFail = function onFail() {
	      return dispatch({
	        type: actionTypes.CLIENT_CODE_LIST.ERROR
	      });
	    };
	
	    return _superagent2.default.get((0, _url2.default)('/clientcode/get-codes?' + query_str)).set('Content-Type', 'application/json').then(onSuccess, onFail);
	  };
	};
	
	function savedCodes(response, param) {
	  // Nothing returned here
	  return {
	    type: actionTypes.CLIENT_CODE_SET.SUCCESS,
	    code: param
	  };
	}
	
	var setClientCode = exports.setClientCode = function setClientCode(params) {
	  return function (dispatch) {
	    dispatch({
	      type: actionTypes.CLIENT_CODE_SET.REQUEST
	    });
	
	    var onFailure = function onFailure() {
	      return dispatch({
	        type: actionTypes.CLIENT_CODE_SET.ERROR
	      });
	    };
	
	    return _superagent2.default.post((0, _url2.default)('/clientcode/set')).type('form').send({ code: params }).then(function (response) {
	      window.Drupal.settings.clientCode = params || '';
	      dispatch(savedCodes(response, params));
	    }, onFailure);
	  };
	};
	
	var hasValidClientCode = exports.hasValidClientCode = function hasValidClientCode() {
	  return function (dispatch) {
	    if (window.client_code_is_valid && !window.client_code_is_valid()) {
	      _Notification.notify.error('Please set a valid Client Code');
	
	      dispatch({ type: actionTypes.CLIENT_CODE_VALIDATION_ERROR });
	      return false;
	    }
	
	    dispatch({ type: actionTypes.CLIENT_CODE_VALIDATION_SUCCESS });
	    return true;
	  };
	};

/***/ },
/* 65 */
[2265, 41, 148, 38],
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(25);
	var hide = __webpack_require__(65);
	var has = __webpack_require__(74);
	var SRC = __webpack_require__(152)('src');
	var $toString = __webpack_require__(1387);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(85).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var fails = __webpack_require__(27);
	var defined = __webpack_require__(97);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(2193);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Popup = function Popup(_ref) {
	  var show = _ref.show,
	      topBarTitle = _ref.topBarTitle,
	      clsName = _ref.clsName,
	      children = _ref.children,
	      onClose = _ref.onClose;
	  return _react2.default.createElement(
	    'div',
	    { className: 'popup ' + (show ? 'show' : 'hide') + ' ' + clsName },
	    _react2.default.createElement(
	      'div',
	      { className: 'popup-inner' },
	      _react2.default.createElement(
	        'div',
	        { className: 'top-bar' },
	        _react2.default.createElement(
	          'div',
	          null,
	          topBarTitle
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ui-dialog-titlebar-close ui-corner-all', onClick: onClose },
	          _react2.default.createElement(
	            'span',
	            { className: 'ui-icon ui-icon-closethick' },
	            'close'
	          )
	        )
	      ),
	      children
	    )
	  );
	};
	
	Popup.defaultProps = {
	  show: false,
	  clsName: '',
	  topBarTitle: '',
	  children: null
	};
	
	Popup.propTypes = {
	  onClose: _propTypes2.default.func.isRequired,
	  show: _propTypes2.default.bool,
	  clsName: _propTypes2.default.string,
	  topBarTitle: _propTypes2.default.string,
	  children: _propTypes2.default.any
	};
	
	exports.default = Popup;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(32);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UpdateFromPacer = function (_Component) {
	    _inherits(UpdateFromPacer, _Component);
	
	    function UpdateFromPacer() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, UpdateFromPacer);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPacerUpdateReceipt = function (params) {
	            var datetime = params.datetime,
	                user_id = params.user_id,
	                client_code = params.client_code,
	                description = params.description,
	                criteria = params.criteria,
	                pages = params.pages,
	                cost = params.cost;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'ir-search-receipt' },
	                _react2.default.createElement(
	                    'table',
	                    null,
	                    _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '2' },
	                                'PACER Service Center'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Receipt:'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                datetime
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'User:'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                user_id
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Client:'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                client_code
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description:'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                description
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                criteria
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Pages:'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                pages,
	                                '\xA0($',
	                                cost,
	                                ')'
	                            )
	                        )
	                    )
	                )
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    UpdateFromPacer.prototype.render = function render() {
	        var pacerReceiptMarkup = void 0;
	        var _props = this.props,
	            pacerUpdateHandler = _props.pacerUpdateHandler,
	            pacerReceipt = _props.pacerReceipt,
	            lastUpdated = _props.lastUpdated;
	
	
	        if (pacerReceipt) pacerReceiptMarkup = this.getPacerUpdateReceipt(pacerReceipt);
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            pacerReceiptMarkup,
	            _react2.default.createElement(
	                'div',
	                { className: 'ir-search-refresh' },
	                _react2.default.createElement(
	                    'table',
	                    null,
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'ir-search-refresh-link' },
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: '#', className: 'form-submit green', onClick: pacerUpdateHandler },
	                                        'Update\xA0from\xA0PACER'
	                                    ),
	                                    '\xA0',
	                                    _react2.default.createElement(
	                                        'abbr',
	                                        { title: 'Please note you will be charged 10 cents per page' },
	                                        '10\xA2/page'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'ir-search-refresh-date' },
	                                    'Last updated: ',
	                                    lastUpdated ? (0, _moment2.default)(parseInt(lastUpdated * 1000)).format("M/D/YYYY h:mm A") : 'n/a'
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return UpdateFromPacer;
	}(_react.Component);
	
	exports.default = UpdateFromPacer;

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.purchaseCaseData = exports.getCaseData = undefined;
	exports.requestCaseData = requestCaseData;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _irSearchActionTypes = __webpack_require__(138);
	
	var types = _interopRequireWildcard(_irSearchActionTypes);
	
	var _docketsActionTypes = __webpack_require__(177);
	
	var docketsTypes = _interopRequireWildcard(_docketsActionTypes);
	
	var _drupalDocketActions = __webpack_require__(726);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapResponseErrorsToMessage(err) {
	  var request_id = _lodash2.default.get(err, ['response', 'body', 'error', 'request_id']);
	  var errorMessageExtra = request_id ? 'When contacting support, please quote Request ID \'' + request_id + '\'' : '';
	
	  return {
	    // We want to hide real messages from user since traces are confusing to them
	    // TODO: coordinate with API to surface proper errors such as field validation?
	    messages: ['PACER is experiencing some issues. Please try again in a few minutes.', errorMessageExtra],
	    // but we include the real message in the details so we receive it in the sentry report
	    details: _lodash2.default.get(err, ['response', 'body', 'error']) || []
	  };
	}
	
	function mapResponseToData(response, filters, searchType) {
	  // todo check if other case menus return multiple types back like assoc cases
	  var data = {};
	
	  if (filters.type === 'associated_cases') {
	    data = Array.isArray(response.body.queries) ? _lodash2.default.get(response.body, 'queries[0]', []) : _lodash2.default.get(response.body, 'queries', []);
	
	    data = Object.keys(data).reduce(function (accum, next) {
	      accum.push([next, data[next][0].text]);
	      return accum;
	    }, []);
	  } else {
	    var type = searchType || filters.type;
	
	    data = Array.isArray(response.body.queries) ? _lodash2.default.get(response.body, 'queries[0].' + type + '[0].text', []) : _lodash2.default.get(response.body, 'queries.' + type + '[0].text', []);
	  }
	  return data;
	}
	
	function receiveError(err) {
	  var msg = mapResponseErrorsToMessage(err);
	  return {
	    type: types.SERVICE_ERROR,
	    error: msg,
	    errors: msg
	  };
	}
	
	function receiveCaseDataLocal(response, filters) {
	  var data = mapResponseToData(response, filters);
	
	  return {
	    type: types.RECEIVE_CASE_DATA,
	    data_type: filters.type,
	    data: data,
	    // data: _.get(response.body, `${filters.type}.text`, []),
	    lastUpdated: _lodash2.default.get(response.body, 'queries[0].' + filters.type + '[0].meta.timestamp'),
	    receipt: null
	  };
	}
	
	function receiveCaseDataPurchased(response, filters) {
	  var data = mapResponseToData(response, filters);
	
	  return {
	    type: types.RECEIVE_CASE_DATA,
	    data_type: filters.type,
	    data: data,
	    // data: _.get(response.body, `${filters.type}.text`, []), // old
	    lastUpdated: _lodash2.default.get(response.body, 'items.receipts[0].meta.timestamp'),
	    receipt: _lodash2.default.get(response.body, 'items.receipts[0].text')
	  };
	}
	
	function requestCaseData(params, dispatch) {
	  dispatch({
	    type: types.REQUEST_CASE_DATA,
	    params: params
	  });
	
	  dispatch({
	    type: types.RESET_SERVICE_ERROR
	  });
	}
	
	var getCaseData = exports.getCaseData = function getCaseData(params) {
	  return function (dispatch) {
	    requestCaseData(params, dispatch);
	    dispatch({
	      type: docketsTypes.UPDATE_DOCKET_HEADER,
	      docketHeader: { hasMoreRecentFilingsDate: null }
	    });
	
	    return _superagent2.default.post('/ir-search/query-json').query({
	      query: params.type,
	      case_uuid: params.case_uuid
	    }).set('Accept', 'application/json').then(function (response) {
	      dispatch((0, _drupalDocketActions.updateHasMoreRecentFilingDate)(response));
	      dispatch(receiveCaseDataLocal(response, params));
	    }, function (err) {
	      return dispatch(receiveError(err));
	    });
	  };
	};
	
	var purchaseCaseData = exports.purchaseCaseData = function purchaseCaseData(params) {
	  return function (dispatch) {
	    requestCaseData(params, dispatch);
	
	    return _superagent2.default.post('/ir-search/pacer-query-json').query({
	      query: params.type,
	      case_uuid: params.case_uuid
	    }).set('Accept', 'application/json').then(function (response) {
	      window.refresh_menu(params.case_uuid);
	
	      if (!_lodash2.default.isEmpty(response.body.error) || _lodash2.default.isEmpty(response.body.queries)) {
	        return dispatch(receiveError(response));
	      }
	
	      return dispatch(receiveCaseDataPurchased(response, params));
	    }, function (err) {
	      return dispatch(receiveError(err));
	    });
	  };
	};

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _currency = __webpack_require__(1668);
	
	var _currency2 = _interopRequireDefault(_currency);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var toCents = function toCents(num) {
	  return (num ? Math.round((0, _currency2.default)(num) * 100) : 0) || 0;
	};
	
	var toCentsOrStr = function toCentsOrStr(num) {
	  if (num === '' || num === undefined || num === null) return '';
	  if (num === '0') return 0;
	  if (+(0, _currency2.default)(num) === 0) return num;
	
	  return Math.round((0, _currency2.default)(num) * 100);
	};
	
	var toDollars = function toDollars(num) {
	  return (num ? num / 100 : 0) || 0;
	};
	
	var toDollarsOrStr = function toDollarsOrStr(num) {
	  return num === '' || num === undefined ? '' : isNaN(parseInt(num, 10)) ? num : num / 100;
	};
	
	exports.default = { toCents: toCents, toDollars: toDollars, toCentsOrStr: toCentsOrStr, toDollarsOrStr: toDollarsOrStr };

/***/ },
/* 73 */
[2261, 116],
/* 74 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 75 */
[2282, 221, 148, 77, 99, 74, 784, 38],
/* 76 */
[2285, 74, 43, 471],
/* 77 */
[2303, 220, 97],
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(1),__webpack_require__(1987),__webpack_require__(1986)):"function"==typeof define&&define.amd?define(["react","react-onclickoutside","moment"],t):"object"==typeof exports?exports.DatePicker=t(require("react"),require("react-onclickoutside"),require("moment")):e.DatePicker=t(e.React,e.onClickOutside,e.moment)}(this,function(e,t,n){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={exports:{},id:r,loaded:!1};return e[r].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var p=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(1),c=r(u),l=n(3),f=r(l),d=n(4),h=(r(d),n(21)),m=r(h),y=n(10),v=r(y),g=n(12),b=n(11),w=r(b),_="react-datepicker-ignore-onclickoutside",D=(0,w.default)(c.default),k=function(e){function t(e){a(this,t);var n=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.getPreSelection=function(){return n.props.openToDate?(0,g.newDate)(n.props.openToDate):n.props.selectsEnd&&n.props.startDate?(0,g.newDate)(n.props.startDate):n.props.selectsStart&&n.props.endDate?(0,g.newDate)(n.props.endDate):(0,g.now)(n.props.utcOffset)},n.calcInitialState=function(){var e=n.getPreSelection(),t=(0,g.getEffectiveMinDate)(n.props),r=(0,g.getEffectiveMaxDate)(n.props),o=t&&(0,g.isBefore)(e,t)?t:r&&(0,g.isAfter)(e,r)?r:e;return{open:n.props.startOpen||!1,preventFocus:!1,preSelection:n.props.selected?(0,g.newDate)(n.props.selected):o}},n.clearPreventFocusTimeout=function(){n.preventFocusTimeout&&clearTimeout(n.preventFocusTimeout)},n.setFocus=function(){n.input.focus()},n.setOpen=function(e){n.setState({open:e,preSelection:e&&n.state.open?n.state.preSelection:n.calcInitialState().preSelection})},n.handleFocus=function(e){n.state.preventFocus||(n.props.onFocus(e),n.setOpen(!0))},n.cancelFocusInput=function(){clearTimeout(n.inputFocusTimeout),n.inputFocusTimeout=null},n.deferFocusInput=function(){n.cancelFocusInput(),n.inputFocusTimeout=setTimeout(function(){return n.setFocus()},1)},n.handleDropdownFocus=function(){n.cancelFocusInput()},n.handleBlur=function(e){n.state.open?n.deferFocusInput():n.props.onBlur(e)},n.handleCalendarClickOutside=function(e){n.props.inline||n.setOpen(!1),n.props.onClickOutside(e),n.props.withPortal&&e.preventDefault()},n.handleChange=function(e){if(!n.props.onChangeRaw||(n.props.onChangeRaw(e),!e.isDefaultPrevented())){n.setState({inputValue:e.target.value});var t=(0,g.parseDate)(e.target.value,n.props);!t&&e.target.value||n.setSelected(t,e,!0)}},n.handleSelect=function(e,t){n.setState({preventFocus:!0},function(){return n.preventFocusTimeout=setTimeout(function(){return n.setState({preventFocus:!1})},50),n.preventFocusTimeout}),n.setSelected(e,t),n.props.shouldCloseOnSelect?n.props.inline||n.setOpen(!1):n.setPreSelection(e)},n.setSelected=function(e,t,r){var o=e;null!==o&&(0,g.isDayDisabled)(o,n.props)||((0,g.isSameDay)(n.props.selected,o)&&!n.props.allowSameDay||(null!==o&&(n.props.selected&&(o=(0,g.setTime)((0,g.newDate)(o),{hour:(0,g.getHour)(n.props.selected),minute:(0,g.getMinute)(n.props.selected),second:(0,g.getSecond)(n.props.selected)})),n.setState({preSelection:o})),n.props.onChange(o,t)),n.props.onSelect(o,t),r||n.setState({inputValue:null}))},n.setPreSelection=function(e){var t="undefined"!=typeof n.props.minDate&&"undefined"!=typeof n.props.maxDate,r=!t||!e||(0,g.isDayInRange)(e,n.props.minDate,n.props.maxDate);r&&n.setState({preSelection:e})},n.handleTimeChange=function(e){var t=n.props.selected?n.props.selected:n.getPreSelection(),r=(0,g.setTime)((0,g.cloneDate)(t),{hour:(0,g.getHour)(e),minute:(0,g.getMinute)(e)});n.setState({preSelection:r}),n.props.onChange(r)},n.onInputClick=function(){n.props.disabled||n.setOpen(!0)},n.onInputKeyDown=function(e){n.props.onKeyDown(e);var t=e.key;if(!n.state.open&&!n.props.inline)return void("Enter"!==t&&"Escape"!==t&&"Tab"!==t&&n.onInputClick());var r=(0,g.newDate)(n.state.preSelection);if("Enter"===t)e.preventDefault(),(0,g.isMoment)(n.state.preSelection)||(0,g.isDate)(n.state.preSelection)?(n.handleSelect(r,e),!n.props.shouldCloseOnSelect&&n.setPreSelection(r)):n.setOpen(!1);else if("Escape"===t)e.preventDefault(),n.setOpen(!1);else if("Tab"===t)n.setOpen(!1);else if(!n.props.disabledKeyboardNavigation){var o=void 0;switch(t){case"ArrowLeft":e.preventDefault(),o=(0,g.subtractDays)(r,1);break;case"ArrowRight":e.preventDefault(),o=(0,g.addDays)(r,1);break;case"ArrowUp":e.preventDefault(),o=(0,g.subtractWeeks)(r,1);break;case"ArrowDown":e.preventDefault(),o=(0,g.addWeeks)(r,1);break;case"PageUp":e.preventDefault(),o=(0,g.subtractMonths)(r,1);break;case"PageDown":e.preventDefault(),o=(0,g.addMonths)(r,1);break;case"Home":e.preventDefault(),o=(0,g.subtractYears)(r,1);break;case"End":e.preventDefault(),o=(0,g.addYears)(r,1)}n.setPreSelection(o)}},n.onClearClick=function(e){e.preventDefault(),n.props.onChange(null,e),n.setState({inputValue:null})},n.renderCalendar=function(){return n.props.inline||n.state.open&&!n.props.disabled?f.default.createElement(D,{ref:function(e){n.calendar=e},locale:n.props.locale,dateFormat:n.props.dateFormatCalendar,useWeekdaysShort:n.props.useWeekdaysShort,dropdownMode:n.props.dropdownMode,selected:n.props.selected,preSelection:n.state.preSelection,onSelect:n.handleSelect,onWeekSelect:n.props.onWeekSelect,openToDate:n.props.openToDate,minDate:n.props.minDate,maxDate:n.props.maxDate,selectsStart:n.props.selectsStart,selectsEnd:n.props.selectsEnd,startDate:n.props.startDate,endDate:n.props.endDate,excludeDates:n.props.excludeDates,filterDate:n.props.filterDate,onClickOutside:n.handleCalendarClickOutside,formatWeekNumber:n.props.formatWeekNumber,highlightDates:n.props.highlightDates,includeDates:n.props.includeDates,inline:n.props.inline,peekNextMonth:n.props.peekNextMonth,showMonthDropdown:n.props.showMonthDropdown,showWeekNumbers:n.props.showWeekNumbers,showYearDropdown:n.props.showYearDropdown,withPortal:n.props.withPortal,forceShowMonthNavigation:n.props.forceShowMonthNavigation,scrollableYearDropdown:n.props.scrollableYearDropdown,todayButton:n.props.todayButton,weekLabel:n.props.weekLabel,utcOffset:n.props.utcOffset,outsideClickIgnoreClass:_,fixedHeight:n.props.fixedHeight,monthsShown:n.props.monthsShown,onDropdownFocus:n.handleDropdownFocus,onMonthChange:n.props.onMonthChange,dayClassName:n.props.dayClassName,showTimeSelect:n.props.showTimeSelect,onTimeChange:n.handleTimeChange,timeFormat:n.props.timeFormat,timeIntervals:n.props.timeIntervals,minTime:n.props.minTime,maxTime:n.props.maxTime,excludeTimes:n.props.excludeTimes,className:n.props.calendarClassName,yearDropdownItemNumber:n.props.yearDropdownItemNumber},n.props.children):null},n.renderDateInput=function(){var e=(0,v.default)(n.props.className,o({},_,n.state.open)),t=n.props.customInput||f.default.createElement("input",{type:"text"}),r="string"==typeof n.props.value?n.props.value:"string"==typeof n.state.inputValue?n.state.inputValue:(0,g.safeDateFormat)(n.props.selected,n.props);return f.default.cloneElement(t,{ref:function(e){n.input=e},value:r,onBlur:n.handleBlur,onChange:n.handleChange,onClick:n.onInputClick,onFocus:n.handleFocus,onKeyDown:n.onInputKeyDown,id:n.props.id,name:n.props.name,autoFocus:n.props.autoFocus,placeholder:n.props.placeholderText,disabled:n.props.disabled,autoComplete:n.props.autoComplete,className:e,title:n.props.title,readOnly:n.props.readOnly,required:n.props.required,tabIndex:n.props.tabIndex})},n.renderClearButton=function(){return n.props.isClearable&&null!=n.props.selected?f.default.createElement("a",{className:"react-datepicker__close-icon",href:"#",onClick:n.onClearClick}):null},n.state=n.calcInitialState(),n}return s(t,e),p(t,null,[{key:"defaultProps",get:function(){return{allowSameDay:!1,dateFormat:"L",dateFormatCalendar:"MMMM YYYY",onChange:function(){},disabled:!1,disabledKeyboardNavigation:!1,dropdownMode:"scroll",onFocus:function(){},onBlur:function(){},onKeyDown:function(){},onSelect:function(){},onClickOutside:function(){},onMonthChange:function(){},monthsShown:1,withPortal:!1,shouldCloseOnSelect:!0,showTimeSelect:!1,timeIntervals:30}}}]),p(t,[{key:"componentWillReceiveProps",value:function(e){var t=this.props.selected&&(0,g.getMonth)(this.props.selected),n=e.selected&&(0,g.getMonth)(e.selected);this.props.inline&&t!==n&&this.setPreSelection(e.selected)}},{key:"componentWillUnmount",value:function(){this.clearPreventFocusTimeout()}},{key:"render",value:function(){var e=this.renderCalendar();return this.props.inline&&!this.props.withPortal?e:this.props.withPortal?f.default.createElement("div",null,this.props.inline?null:f.default.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),this.state.open||this.props.inline?f.default.createElement("div",{className:"react-datepicker__portal"},e):null):f.default.createElement(m.default,{className:this.props.popperClassName,hidePopper:!this.state.open||this.props.disabled,popperModifiers:this.props.popperModifiers,targetComponent:f.default.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),popperContainer:this.props.popperContainer,popperComponent:e,popperPlacement:this.props.popperPlacement})}}]),t}(f.default.Component);t.default=k},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(2),u=r(p),c=n(14),l=r(c),f=n(16),d=r(f),h=n(20),m=r(h),y=n(3),v=r(y),g=n(4),b=(r(g),n(10)),w=r(b),_=n(12),D=["react-datepicker__year-select","react-datepicker__month-select"],k=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=(e.className||"").split(/\s+/);return D.some(function(e){return t.indexOf(e)>=0})},O=function(e){function t(e){o(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.handleClickOutside=function(e){n.props.onClickOutside(e)},n.handleDropdownFocus=function(e){k(e.target)&&n.props.onDropdownFocus()},n.getDateInView=function(){var e=n.props,t=e.preSelection,r=e.selected,o=e.openToDate,a=e.utcOffset,i=(0,_.getEffectiveMinDate)(n.props),s=(0,_.getEffectiveMaxDate)(n.props),p=(0,_.now)(a),u=o||r||t;return u?u:i&&(0,_.isBefore)(p,i)?i:s&&(0,_.isAfter)(p,s)?s:p},n.localizeDate=function(e){return(0,_.localizeDate)(e,n.props.locale)},n.increaseMonth=function(){n.setState({date:(0,_.addMonths)((0,_.cloneDate)(n.state.date),1)},function(){return n.handleMonthChange(n.state.date)})},n.decreaseMonth=function(){n.setState({date:(0,_.subtractMonths)((0,_.cloneDate)(n.state.date),1)},function(){return n.handleMonthChange(n.state.date)})},n.handleDayClick=function(e,t){return n.props.onSelect(e,t)},n.handleDayMouseEnter=function(e){return n.setState({selectingDate:e})},n.handleMonthMouseLeave=function(){return n.setState({selectingDate:null})},n.handleMonthChange=function(e){n.props.onMonthChange&&n.props.onMonthChange(e)},n.changeYear=function(e){n.setState({date:(0,_.setYear)((0,_.cloneDate)(n.state.date),e)})},n.changeMonth=function(e){n.setState({date:(0,_.setMonth)((0,_.cloneDate)(n.state.date),e)},function(){return n.handleMonthChange(n.state.date)})},n.header=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:n.state.date,t=(0,_.getStartOfWeek)((0,_.cloneDate)(e)),r=[];return n.props.showWeekNumbers&&r.push(v.default.createElement("div",{key:"W",className:"react-datepicker__day-name"},n.props.weekLabel||"#")),r.concat([0,1,2,3,4,5,6].map(function(e){var r=(0,_.addDays)((0,_.cloneDate)(t),e),o=(0,_.getLocaleData)(r),a=n.props.useWeekdaysShort?(0,_.getWeekdayShortInLocale)(o,r):(0,_.getWeekdayMinInLocale)(o,r);return v.default.createElement("div",{key:e,className:"react-datepicker__day-name"},a)}))},n.renderPreviousMonthButton=function(){if(n.props.forceShowMonthNavigation||!(0,_.allDaysDisabledBefore)(n.state.date,"month",n.props))return v.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--previous",onClick:n.decreaseMonth})},n.renderNextMonthButton=function(){if(n.props.forceShowMonthNavigation||!(0,_.allDaysDisabledAfter)(n.state.date,"month",n.props)){var e=["react-datepicker__navigation","react-datepicker__navigation--next"];return n.props.showTimeSelect&&e.push("react-datepicker__navigation--next--with-time"),n.props.todayButton&&e.push("react-datepicker__navigation--next--with-today-button"),v.default.createElement("a",{className:e.join(" "),onClick:n.increaseMonth})}},n.renderCurrentMonth=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:n.state.date,t=["react-datepicker__current-month"];return n.props.showYearDropdown&&t.push("react-datepicker__current-month--hasYearDropdown"),n.props.showMonthDropdown&&t.push("react-datepicker__current-month--hasMonthDropdown"),v.default.createElement("div",{className:t.join(" ")},(0,_.formatDate)(e,n.props.dateFormat))},n.renderYearDropdown=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(n.props.showYearDropdown&&!e)return v.default.createElement(u.default,{dropdownMode:n.props.dropdownMode,onChange:n.changeYear,minDate:n.props.minDate,maxDate:n.props.maxDate,year:(0,_.getYear)(n.state.date),scrollableYearDropdown:n.props.scrollableYearDropdown,yearDropdownItemNumber:n.props.yearDropdownItemNumber})},n.renderMonthDropdown=function(){arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(n.props.showMonthDropdown)return v.default.createElement(l.default,{dropdownMode:n.props.dropdownMode,locale:n.props.locale,dateFormat:n.props.dateFormat,onChange:n.changeMonth,month:(0,_.getMonth)(n.state.date)})},n.renderTodayButton=function(){if(n.props.todayButton)return v.default.createElement("div",{className:"react-datepicker__today-button",onClick:function(e){return n.props.onSelect((0,_.getStartOfDate)((0,_.now)(n.props.utcOffset)),e)}},n.props.todayButton)},n.renderMonths=function(){for(var e=[],t=0;t<n.props.monthsShown;++t){var r=(0,_.addMonths)((0,_.cloneDate)(n.state.date),t),o="month-"+t;e.push(v.default.createElement("div",{key:o,ref:function(e){n.monthContainer=e},className:"react-datepicker__month-container"},v.default.createElement("div",{className:"react-datepicker__header"},n.renderCurrentMonth(r),v.default.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--"+n.props.dropdownMode,onFocus:n.handleDropdownFocus},n.renderMonthDropdown(0!==t),n.renderYearDropdown(0!==t)),v.default.createElement("div",{className:"react-datepicker__day-names"},n.header(r))),v.default.createElement(d.default,{day:r,dayClassName:n.props.dayClassName,onDayClick:n.handleDayClick,onDayMouseEnter:n.handleDayMouseEnter,onMouseLeave:n.handleMonthMouseLeave,onWeekSelect:n.props.onWeekSelect,formatWeekNumber:n.props.formatWeekNumber,minDate:n.props.minDate,maxDate:n.props.maxDate,excludeDates:n.props.excludeDates,highlightDates:n.props.highlightDates,selectingDate:n.state.selectingDate,includeDates:n.props.includeDates,inline:n.props.inline,fixedHeight:n.props.fixedHeight,filterDate:n.props.filterDate,preSelection:n.props.preSelection,selected:n.props.selected,selectsStart:n.props.selectsStart,selectsEnd:n.props.selectsEnd,showWeekNumbers:n.props.showWeekNumbers,startDate:n.props.startDate,endDate:n.props.endDate,peekNextMonth:n.props.peekNextMonth,utcOffset:n.props.utcOffset})))}return e},n.renderTimeSection=function(){return n.props.showTimeSelect?v.default.createElement(m.default,{selected:n.props.selected,onChange:n.props.onTimeChange,format:n.props.timeFormat,intervals:n.props.timeIntervals,minTime:n.props.minTime,maxTime:n.props.maxTime,excludeTimes:n.props.excludeTimes,todayButton:n.props.todayButton,showMonthDropdown:n.props.showMonthDropdown,showYearDropdown:n.props.showYearDropdown,withPortal:n.props.withPortal,monthRef:n.state.monthContainer}):void 0},n.state={date:n.localizeDate(n.getDateInView()),selectingDate:null,monthContainer:n.monthContainer},n}return i(t,e),s(t,null,[{key:"defaultProps",get:function(){return{onDropdownFocus:function(){},monthsShown:1,forceShowMonthNavigation:!1}}}]),s(t,[{key:"componentDidMount",value:function(){var e=this;this.props.showTimeSelect&&(this.assignMonthContainer=function(){e.setState({monthContainer:e.monthContainer})}())}},{key:"componentWillReceiveProps",value:function(e){e.preSelection&&!(0,_.isSameDay)(e.preSelection,this.props.preSelection)?this.setState({date:this.localizeDate(e.preSelection)}):e.openToDate&&!(0,_.isSameDay)(e.openToDate,this.props.openToDate)&&this.setState({date:this.localizeDate(e.openToDate)})}},{key:"render",value:function(){return v.default.createElement("div",{className:(0,w.default)("react-datepicker",this.props.className)},v.default.createElement("div",{className:"react-datepicker__triangle"}),this.renderPreviousMonthButton(),this.renderNextMonthButton(),this.renderMonths(),this.renderTodayButton(),this.renderTimeSection(),this.props.children)}}]),t}(v.default.Component);t.default=O},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(3),u=r(p),c=n(4),l=(r(c),n(9)),f=r(l),d=n(11),h=r(d),m=n(12),y=(0,h.default)(f.default),v=function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),c=0;c<s;c++)p[c]=arguments[c];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.state={dropdownVisible:!1},r.renderSelectOptions=function(){for(var e=r.props.minDate?(0,m.getYear)(r.props.minDate):1900,t=r.props.maxDate?(0,m.getYear)(r.props.maxDate):2100,n=[],o=e;o<=t;o++)n.push(u.default.createElement("option",{key:o,value:o},o));return n},r.onSelectChange=function(e){r.onChange(e.target.value)},r.renderSelectMode=function(){return u.default.createElement("select",{value:r.props.year,className:"react-datepicker__year-select",onChange:r.onSelectChange},r.renderSelectOptions())},r.renderReadView=function(e){return u.default.createElement("div",{key:"read",style:{visibility:e?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:r.toggleDropdown},u.default.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),u.default.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},r.props.year))},r.renderDropdown=function(){return u.default.createElement(y,{key:"dropdown",ref:"options",year:r.props.year,onChange:r.onChange,onCancel:r.toggleDropdown,minDate:r.props.minDate,maxDate:r.props.maxDate,scrollableYearDropdown:r.props.scrollableYearDropdown,yearDropdownItemNumber:r.props.yearDropdownItemNumber})},r.renderScrollMode=function(){var e=r.state.dropdownVisible,t=[r.renderReadView(!e)];return e&&t.unshift(r.renderDropdown()),t},r.onChange=function(e){r.toggleDropdown(),e!==r.props.year&&r.props.onChange(e)},r.toggleDropdown=function(){r.setState({dropdownVisible:!r.state.dropdownVisible})},i=n,a(r,i)}return i(t,e),s(t,[{key:"render",value:function(){var e=void 0;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return u.default.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--"+this.props.dropdownMode},e)}}]),t}(u.default.Component);t.default=v},function(t,n){t.exports=e},function(e,t,n){e.exports=n(5)()},function(e,t,n){"use strict";var r=n(6),o=n(7),a=n(8);e.exports=function(){function e(e,t,n,r,i,s){s!==a&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t};return n.checkPropTypes=r,n.PropTypes=n,n}},function(e,t){"use strict";function n(e){return function(){return e}}var r=function(){};r.thatReturns=n,r.thatReturnsFalse=n(!1),r.thatReturnsTrue=n(!0),r.thatReturnsNull=n(null),r.thatReturnsThis=function(){return this},r.thatReturnsArgument=function(e){return e},e.exports=r},function(e,t,n){"use strict";function r(e,t,n,r,a,i,s,p){if(o(t),!e){var u;if(void 0===t)u=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var c=[n,r,a,i,s,p],l=0;u=new Error(t.replace(/%s/g,function(){return c[l++]})),u.name="Invariant Violation"}throw u.framesToPop=1,u}}var o=function(e){};e.exports=r},function(e,t){"use strict";var n="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=n},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function s(e,t,n,r){for(var o=[],a=0;a<2*t+1;a++){var i=e+t-a,s=!0;n&&(s=n.year()<=i),r&&s&&(s=r.year()>=i),s&&o.push(i)}return o}Object.defineProperty(t,"__esModule",{value:!0});var p=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(3),c=r(u),l=n(4),f=(r(l),n(10)),d=r(f),h=function(e){function t(e){o(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));n.renderOptions=function(){var e=n.props.year,t=n.state.yearsList.map(function(t){return c.default.createElement("div",{className:"react-datepicker__year-option",key:t,ref:t,onClick:n.onChange.bind(n,t)},e===t?c.default.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",t)}),r=n.props.minDate?n.props.minDate.year():null,o=n.props.maxDate?n.props.maxDate.year():null;return o&&n.state.yearsList.find(function(e){return e===o})||t.unshift(c.default.createElement("div",{className:"react-datepicker__year-option",ref:"upcoming",key:"upcoming",onClick:n.incrementYears},c.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),r&&n.state.yearsList.find(function(e){return e===r})||t.push(c.default.createElement("div",{className:"react-datepicker__year-option",ref:"previous",key:"previous",onClick:n.decrementYears},c.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),t},n.onChange=function(e){n.props.onChange(e)},n.handleClickOutside=function(){n.props.onCancel()},n.shiftYears=function(e){var t=n.state.yearsList.map(function(t){return t+e});n.setState({yearsList:t})},n.incrementYears=function(){return n.shiftYears(1)},n.decrementYears=function(){return n.shiftYears(-1)};var r=e.yearDropdownItemNumber,i=e.scrollableYearDropdown,p=r||(i?10:5);return n.state={yearsList:s(n.props.year,p,n.props.minDate,n.props.maxDate)},n}return i(t,e),p(t,[{key:"render",value:function(){var e=(0,d.default)({"react-datepicker__year-dropdown":!0,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return c.default.createElement("div",{className:e},this.renderOptions())}}]),t}(c.default.Component);t.default=h},function(e,t,n){var r,o;/*!
		  Copyright (c) 2016 Jed Watson.
		  Licensed under the MIT License (MIT), see
		  http://jedwatson.github.io/classnames
		*/
	!function(){"use strict";function n(){for(var e=[],t=0;t<arguments.length;t++){var r=arguments[t];if(r){var o=typeof r;if("string"===o||"number"===o)e.push(r);else if(Array.isArray(r))e.push(n.apply(null,r));else if("object"===o)for(var i in r)a.call(r,i)&&r[i]&&e.push(i)}}return e.join(" ")}var a={}.hasOwnProperty;"undefined"!=typeof e&&e.exports?e.exports=n:(r=[],o=function(){return n}.apply(t,r),!(void 0!==o&&(e.exports=o)))}()},function(e,n){e.exports=t},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){return e.set(t,n)}function a(e,t,n){return e.add(t,n)}function i(e,t,n){return e.subtract(t,n)}function s(e,t){return e.get(t)}function p(e,t){return e.startOf(t)}function u(e,t){return e.endOf(t)}function c(e,t,n){return e.diff(t,n)}function l(e,t,n){return e.isSame(t,n)}function f(e){return(0,_e.default)(e)}function d(e){return(0,_e.default)().utc().utcOffset(e)}function h(e){return null==e?f():d(e)}function m(e){return e.clone()}function y(e,t){var n=t.dateFormat,r=t.locale,o=(0,_e.default)(e,n,r||_e.default.locale(),!0);return o.isValid()?o:null}function v(e){return _e.default.isMoment(e)}function g(e){return _e.default.isDate(e)}function b(e,t){return e.format(t)}function w(e,t){var n=t.dateFormat,r=t.locale;return e&&e.clone().locale(r||_e.default.locale()).format(Array.isArray(n)?n[0]:n)||""}function _(e,t){var n=t.hour,r=t.minute,o=t.second;return e.set({hour:n,minute:r,second:o}),e}function D(e,t){return o(e,"month",t)}function k(e,t){return o(e,"year",t)}function O(e,t){return e.utcOffset(t)}function S(e){return s(e,"second")}function E(e){return s(e,"minute")}function C(e){return s(e,"hour")}function M(e){return s(e,"day")}function P(e){return s(e,"week")}function T(e){return s(e,"month")}function x(e){return s(e,"year")}function N(e){return s(e,"date")}function j(){return(0,_e.default)().utcOffset()}function R(e){return De[e.isoWeekday()]}function W(e){return p(e,"day")}function L(e){return p(e,"week")}function I(e){return p(e,"month")}function F(e){return p(e,"date")}function A(e){return u(e,"week")}function B(e){return u(e,"month")}function Y(e,t){return a(e,t,"minutes")}function H(e,t){return a(e,t,"days")}function U(e,t){return a(e,t,"weeks")}function V(e,t){return a(e,t,"months")}function q(e,t){return a(e,t,"years")}function K(e,t){return i(e,t,"days")}function z(e,t){return i(e,t,"weeks")}function G(e,t){return i(e,t,"months")}function J(e,t){return i(e,t,"years")}function X(e,t){return e.isBefore(t)}function Q(e,t){return e.isAfter(t)}function Z(e,t){return e.isSame(t)}function $(e,t){return l(e,t,"month")}function ee(e,t){return e&&t?e.isSame(t,"day"):!e&&!t}function te(e,t){return e&&t?e.utcOffset()===t.utcOffset():!e&&!t}function ne(e,t,n){var r=t.clone().startOf("day").subtract(1,"seconds"),o=n.clone().startOf("day").add(1,"seconds");return e.clone().startOf("day").isBetween(r,o)}function re(e,t){return c(e,t,"days")}function oe(e,t){return e.clone().locale(t||_e.default.locale())}function ae(){return _e.default.locale()}function ie(){return _e.default.localeData()}function se(e,t){_e.default.defineLocale(e,t)}function pe(e){return e.localeData()}function ue(e){return _e.default.localeData(e)}function ce(e,t){return e.weekdaysMin(t)}function le(e,t){return e.weekdaysShort(t)}function fe(e,t,n){return e.months(t,n)}function de(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.minDate,r=t.maxDate,o=t.excludeDates,a=t.includeDates,i=t.filterDate;return n&&e.isBefore(n,"day")||r&&e.isAfter(r,"day")||o&&o.some(function(t){return ee(e,t)})||a&&!a.some(function(t){return ee(e,t)})||i&&!i(e.clone())||!1}function he(e,t){for(var n=t.length,r=0;r<n;r++)if(t[r].get("hours")===e.get("hours")&&t[r].get("minutes")===e.get("minutes"))return!0;return!1}function me(e,t){var n=t.minTime,r=t.maxTime;if(!n||!r)throw new Error("Both minTime and maxTime props required");var o=(0,_e.default)().hours(0).minutes(0).seconds(0),a=o.clone().hours(e.get("hours")).minutes(e.get("minutes")),i=o.clone().hours(n.get("hours")).minutes(n.get("minutes")),s=o.clone().hours(r.get("hours")).minutes(r.get("minutes"));return!(a.isSameOrAfter(i)&&a.isSameOrBefore(s))}function ye(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=n.minDate,o=n.includeDates,a=e.clone().subtract(1,t);return r&&a.isBefore(r,t)||o&&o.every(function(e){return a.isBefore(e,t)})||!1}function ve(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=n.maxDate,o=n.includeDates,a=e.clone().add(1,t);return r&&a.isAfter(r,t)||o&&o.every(function(e){return a.isAfter(e,t)})||!1}function ge(e){var t=e.minDate,n=e.includeDates;return n&&t?_e.default.min(n.filter(function(e){return t.isSameOrBefore(e,"day")})):n?_e.default.min(n):t}function be(e){var t=e.maxDate,n=e.includeDates;return n&&t?_e.default.max(n.filter(function(e){return t.isSameOrAfter(e,"day")})):n?_e.default.max(n):t}Object.defineProperty(t,"__esModule",{value:!0}),t.newDate=f,t.newDateWithOffset=d,t.now=h,t.cloneDate=m,t.parseDate=y,t.isMoment=v,t.isDate=g,t.formatDate=b,t.safeDateFormat=w,t.setTime=_,t.setMonth=D,t.setYear=k,t.setUTCOffset=O,t.getSecond=S,t.getMinute=E,t.getHour=C,t.getDay=M,t.getWeek=P,t.getMonth=T,t.getYear=x,t.getDate=N,t.getUTCOffset=j,t.getDayOfWeekCode=R,t.getStartOfDay=W,t.getStartOfWeek=L,t.getStartOfMonth=I,t.getStartOfDate=F,t.getEndOfWeek=A,t.getEndOfMonth=B,t.addMinutes=Y,t.addDays=H,t.addWeeks=U,t.addMonths=V,t.addYears=q,t.subtractDays=K,t.subtractWeeks=z,t.subtractMonths=G,t.subtractYears=J,t.isBefore=X,t.isAfter=Q,t.equals=Z,t.isSameMonth=$,t.isSameDay=ee,t.isSameUtcOffset=te,t.isDayInRange=ne,t.getDaysDiff=re,t.localizeDate=oe,t.getDefaultLocale=ae,t.getDefaultLocaleData=ie,t.registerLocale=se,t.getLocaleData=pe,t.getLocaleDataForLocale=ue,t.getWeekdayMinInLocale=ce,t.getWeekdayShortInLocale=le,t.getMonthInLocale=fe,t.isDayDisabled=de,t.isTimeDisabled=he,t.isTimeInDisabledRange=me,t.allDaysDisabledBefore=ye,t.allDaysDisabledAfter=ve,t.getEffectiveMinDate=ge,t.getEffectiveMaxDate=be;var we=n(13),_e=r(we),De={1:"mon",2:"tue",3:"wed",4:"thu",5:"fri",6:"sat",7:"sun"}},function(e,t){e.exports=n},function(e,t,n){"use strict";function r(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}function o(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var p=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(3),c=o(u),l=n(4),f=(o(l),n(15)),d=o(f),h=n(11),m=o(h),y=n(12),v=r(y),g=(0,m.default)(d.default),b=function(e){function t(){var e,n,r,o;a(this,t);for(var s=arguments.length,p=Array(s),u=0;u<s;u++)p[u]=arguments[u];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.state={dropdownVisible:!1},r.renderSelectOptions=function(e){return e.map(function(e,t){return c.default.createElement("option",{key:t,value:t},e)})},r.renderSelectMode=function(e){return c.default.createElement("select",{value:r.props.month,className:"react-datepicker__month-select",onChange:function(e){return r.onChange(e.target.value)}},r.renderSelectOptions(e))},r.renderReadView=function(e,t){return c.default.createElement("div",{key:"read",style:{visibility:e?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:r.toggleDropdown},c.default.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},t[r.props.month]),c.default.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}))},r.renderDropdown=function(e){return c.default.createElement(g,{key:"dropdown",ref:"options",month:r.props.month,monthNames:e,onChange:r.onChange,onCancel:r.toggleDropdown})},r.renderScrollMode=function(e){var t=r.state.dropdownVisible,n=[r.renderReadView(!t,e)];return t&&n.unshift(r.renderDropdown(e)),n},r.onChange=function(e){r.toggleDropdown(),e!==r.props.month&&r.props.onChange(e)},r.toggleDropdown=function(){return r.setState({dropdownVisible:!r.state.dropdownVisible})},o=n,i(r,o)}return s(t,e),p(t,[{key:"render",value:function(){var e=this,t=v.getLocaleDataForLocale(this.props.locale),n=[0,1,2,3,4,5,6,7,8,9,10,11].map(function(n){return v.getMonthInLocale(t,v.newDate({M:n}),e.props.dateFormat)}),r=void 0;switch(this.props.dropdownMode){case"scroll":r=this.renderScrollMode(n);break;case"select":r=this.renderSelectMode(n)}return c.default.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--"+this.props.dropdownMode},r)}}]),t}(c.default.Component);t.default=b},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(3),u=r(p),c=n(4),l=(r(c),function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),c=0;c<s;c++)p[c]=arguments[c];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.renderOptions=function(){return r.props.monthNames.map(function(e,t){return u.default.createElement("div",{className:"react-datepicker__month-option",key:e,ref:e,onClick:r.onChange.bind(r,t)},r.props.month===t?u.default.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",e)})},r.onChange=function(e){return r.props.onChange(e)},r.handleClickOutside=function(){return r.props.onCancel()},i=n,a(r,i)}return i(t,e),s(t,[{key:"render",value:function(){return u.default.createElement("div",{className:"react-datepicker__month-dropdown"},this.renderOptions())}}]),t}(u.default.Component));t.default=l},function(e,t,n){"use strict";function r(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}function o(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var p=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(3),c=o(u),l=n(4),f=(o(l),n(10)),d=o(f),h=n(17),m=o(h),y=n(12),v=r(y),g=6,b=function(e){function t(){var e,n,r,o;a(this,t);for(var s=arguments.length,p=Array(s),u=0;u<s;u++)p[u]=arguments[u];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.handleDayClick=function(e,t){r.props.onDayClick&&r.props.onDayClick(e,t)},r.handleDayMouseEnter=function(e){r.props.onDayMouseEnter&&r.props.onDayMouseEnter(e)},r.handleMouseLeave=function(){r.props.onMouseLeave&&r.props.onMouseLeave()},r.isWeekInMonth=function(e){var t=r.props.day,n=v.addDays(v.cloneDate(e),6);return v.isSameMonth(e,t)||v.isSameMonth(n,t)},r.renderWeeks=function(){for(var e=[],t=r.props.fixedHeight,n=v.getStartOfWeek(v.getStartOfMonth(v.cloneDate(r.props.day))),o=0,a=!1;;){if(e.push(c.default.createElement(m.default,{key:o,day:n,month:v.getMonth(r.props.day),onDayClick:r.handleDayClick,onDayMouseEnter:r.handleDayMouseEnter,onWeekSelect:r.props.onWeekSelect,formatWeekNumber:r.props.formatWeekNumber,minDate:r.props.minDate,maxDate:r.props.maxDate,excludeDates:r.props.excludeDates,includeDates:r.props.includeDates,inline:r.props.inline,highlightDates:r.props.highlightDates,selectingDate:r.props.selectingDate,filterDate:r.props.filterDate,preSelection:r.props.preSelection,selected:r.props.selected,selectsStart:r.props.selectsStart,selectsEnd:r.props.selectsEnd,showWeekNumber:r.props.showWeekNumbers,startDate:r.props.startDate,endDate:r.props.endDate,dayClassName:r.props.dayClassName,utcOffset:r.props.utcOffset})),a)break;o++,n=v.addWeeks(v.cloneDate(n),1);var i=t&&o>=g,s=!t&&!r.isWeekInMonth(n);if(i||s){if(!r.props.peekNextMonth)break;a=!0}}return e},r.getClassNames=function(){var e=r.props,t=e.selectingDate,n=e.selectsStart,o=e.selectsEnd;return(0,d.default)("react-datepicker__month",{"react-datepicker__month--selecting-range":t&&(n||o)})},o=n,i(r,o)}return s(t,e),p(t,[{key:"render",value:function(){return c.default.createElement("div",{className:this.getClassNames(),onMouseLeave:this.handleMouseLeave,role:"listbox"},this.renderWeeks())}}]),t}(c.default.Component);t.default=b},function(e,t,n){"use strict";function r(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}function o(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var p=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(3),c=o(u),l=n(4),f=(o(l),n(18)),d=o(f),h=n(19),m=o(h),y=n(12),v=r(y),g=function(e){function t(){var e,n,r,o;a(this,t);for(var s=arguments.length,p=Array(s),u=0;u<s;u++)p[u]=arguments[u];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.handleDayClick=function(e,t){r.props.onDayClick&&r.props.onDayClick(e,t)},r.handleDayMouseEnter=function(e){r.props.onDayMouseEnter&&r.props.onDayMouseEnter(e)},r.handleWeekClick=function(e,t,n){"function"==typeof r.props.onWeekSelect&&r.props.onWeekSelect(e,t,n)},r.formatWeekNumber=function(e){return r.props.formatWeekNumber?r.props.formatWeekNumber(e):v.getWeek(e)},r.renderDays=function(){var e=v.getStartOfWeek(v.cloneDate(r.props.day)),t=[],n=r.formatWeekNumber(e);if(r.props.showWeekNumber){var o=r.props.onWeekSelect?r.handleWeekClick.bind(r,e,n):void 0;t.push(c.default.createElement(m.default,{key:"W",weekNumber:n,onClick:o}))}return t.concat([0,1,2,3,4,5,6].map(function(t){var n=v.addDays(v.cloneDate(e),t);return c.default.createElement(d.default,{key:t,day:n,month:r.props.month,onClick:r.handleDayClick.bind(r,n),onMouseEnter:r.handleDayMouseEnter.bind(r,n),minDate:r.props.minDate,maxDate:r.props.maxDate,excludeDates:r.props.excludeDates,includeDates:r.props.includeDates,inline:r.props.inline,highlightDates:r.props.highlightDates,selectingDate:r.props.selectingDate,filterDate:r.props.filterDate,preSelection:r.props.preSelection,selected:r.props.selected,selectsStart:r.props.selectsStart,selectsEnd:r.props.selectsEnd,startDate:r.props.startDate,endDate:r.props.endDate,dayClassName:r.props.dayClassName,utcOffset:r.props.utcOffset})}))},o=n,i(r,o)}return s(t,e),p(t,[{key:"render",value:function(){return c.default.createElement("div",{className:"react-datepicker__week"},this.renderDays())}}]),t}(c.default.Component);t.default=g},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var p="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(3),l=r(c),f=n(4),d=(r(f),n(10)),h=r(d),m=n(12),y=function(e){function t(){var e,n,r,s;a(this,t);for(var u=arguments.length,c=Array(u),l=0;l<u;l++)c[l]=arguments[l];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(c))),r.handleClick=function(e){!r.isDisabled()&&r.props.onClick&&r.props.onClick(e)},r.handleMouseEnter=function(e){!r.isDisabled()&&r.props.onMouseEnter&&r.props.onMouseEnter(e)},r.isSameDay=function(e){return(0,m.isSameDay)(r.props.day,e)},r.isKeyboardSelected=function(){return!r.props.inline&&!r.isSameDay(r.props.selected)&&r.isSameDay(r.props.preSelection)},r.isDisabled=function(){return(0,m.isDayDisabled)(r.props.day,r.props)},r.getHighLightedClass=function(e){var t=r.props,n=t.day,a=t.highlightDates;if(!a)return o({},e,!1);for(var i={},s=0,u=a.length;s<u;s++){var c=a[s];if((0,m.isMoment)(c))(0,m.isSameDay)(n,c)&&(i[e]=!0);else if("object"===("undefined"==typeof c?"undefined":p(c))){var l=Object.keys(c),f=c[l[0]];if("string"==typeof l[0]&&f.constructor===Array)for(var d=0,h=f.length;d<h;d++)(0,m.isSameDay)(n,f[d])&&(i[l[0]]=!0)}}return i},r.isInRange=function(){var e=r.props,t=e.day,n=e.startDate,o=e.endDate;return!(!n||!o)&&(0,m.isDayInRange)(t,n,o)},r.isInSelectingRange=function(){var e=r.props,t=e.day,n=e.selectsStart,o=e.selectsEnd,a=e.selectingDate,i=e.startDate,s=e.endDate;return!(!n&&!o||!a||r.isDisabled())&&(n&&s&&a.isSameOrBefore(s)?(0,m.isDayInRange)(t,a,s):!!(o&&i&&a.isSameOrAfter(i))&&(0,m.isDayInRange)(t,i,a))},r.isSelectingRangeStart=function(){if(!r.isInSelectingRange())return!1;var e=r.props,t=e.day,n=e.selectingDate,o=e.startDate,a=e.selectsStart;return a?(0,m.isSameDay)(t,n):(0,m.isSameDay)(t,o)},r.isSelectingRangeEnd=function(){if(!r.isInSelectingRange())return!1;var e=r.props,t=e.day,n=e.selectingDate,o=e.endDate,a=e.selectsEnd;return a?(0,m.isSameDay)(t,n):(0,m.isSameDay)(t,o)},r.isRangeStart=function(){var e=r.props,t=e.day,n=e.startDate,o=e.endDate;return!(!n||!o)&&(0,m.isSameDay)(n,t)},r.isRangeEnd=function(){var e=r.props,t=e.day,n=e.startDate,o=e.endDate;return!(!n||!o)&&(0,m.isSameDay)(o,t)},r.isWeekend=function(){var e=(0,m.getDay)(r.props.day);return 0===e||6===e},r.isOutsideMonth=function(){return void 0!==r.props.month&&r.props.month!==(0,m.getMonth)(r.props.day)},r.getClassNames=function(e){var t=r.props.dayClassName?r.props.dayClassName(e):void 0;return(0,h.default)("react-datepicker__day",t,"react-datepicker__day--"+(0,m.getDayOfWeekCode)(r.props.day),{"react-datepicker__day--disabled":r.isDisabled(),"react-datepicker__day--selected":r.isSameDay(r.props.selected),"react-datepicker__day--keyboard-selected":r.isKeyboardSelected(),"react-datepicker__day--range-start":r.isRangeStart(),"react-datepicker__day--range-end":r.isRangeEnd(),"react-datepicker__day--in-range":r.isInRange(),"react-datepicker__day--in-selecting-range":r.isInSelectingRange(),"react-datepicker__day--selecting-range-start":r.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":r.isSelectingRangeEnd(),"react-datepicker__day--today":r.isSameDay((0,m.now)(r.props.utcOffset)),"react-datepicker__day--weekend":r.isWeekend(),"react-datepicker__day--outside-month":r.isOutsideMonth()},r.getHighLightedClass("react-datepicker__day--highlighted"))},s=n,i(r,s)}return s(t,e),u(t,[{key:"render",value:function(){return l.default.createElement("div",{className:this.getClassNames(this.props.day),onClick:this.handleClick,onMouseEnter:this.handleMouseEnter,"aria-label":"day-"+(0,m.getDate)(this.props.day),role:"option"},(0,m.getDate)(this.props.day))}}]),t}(l.default.Component);t.default=y},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(3),u=r(p),c=n(4),l=(r(c),n(10)),f=r(l),d=function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),u=0;u<s;u++)p[u]=arguments[u];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.handleClick=function(e){r.props.onClick&&r.props.onClick(e)},i=n,a(r,i)}return i(t,e),s(t,[{key:"render",value:function(){var e={"react-datepicker__week-number":!0,"react-datepicker__week-number--clickable":!!this.props.onClick};return u.default.createElement("div",{className:(0,f.default)(e),"aria-label":"week-"+this.props.weekNumber,onClick:this.handleClick},this.props.weekNumber)}}]),t}(u.default.Component);t.default=d},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(3),u=r(p),c=n(4),l=(r(c),n(12)),f=function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),c=0;c<s;c++)p[c]=arguments[c];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.handleClick=function(e){(r.props.minTime||r.props.maxTime)&&(0,l.isTimeInDisabledRange)(e,r.props)||r.props.excludeTimes&&(0,l.isTimeDisabled)(e,r.props.excludeTimes)||r.props.onChange(e)},r.liClasses=function(e,t,n){var o=["react-datepicker__time-list-item"];return t===(0,l.getHour)(e)&&n===(0,l.getMinute)(e)&&o.push("react-datepicker__time-list-item--selected"),((r.props.minTime||r.props.maxTime)&&(0,l.isTimeInDisabledRange)(e,r.props)||r.props.excludeTimes&&(0,l.isTimeDisabled)(e,r.props.excludeTimes))&&o.push("react-datepicker__time-list-item--disabled"),o.join(" ")},r.renderTimes=function(){for(var e=[],t=r.props.format?r.props.format:"hh:mm A",n=r.props.intervals,o=r.props.selected?r.props.selected:(0,l.newDate)(),a=(0,l.getHour)(o),i=(0,l.getMinute)(o),s=(0,l.getStartOfDay)((0,l.newDate)()),p=1440/n,c=0;c<p;c++)e.push((0,l.addMinutes)((0,l.cloneDate)(s),c*n));return e.map(function(e,n){return u.default.createElement("li",{key:n,onClick:r.handleClick.bind(r,e),className:r.liClasses(e,a,i)},(0,l.formatDate)(e,t))})},i=n,a(r,i)}return i(t,e),s(t,[{key:"componentDidMount",value:function(){var e=60/this.props.intervals,t=this.props.selected?(0,l.getHour)(this.props.selected):(0,l.getHour)((0,l.newDate)());this.list.scrollTop=30*(e*t)}},{key:"render",value:function(){var e=this,t=null;return this.props.monthRef&&(t=this.props.monthRef.clientHeight-39),u.default.createElement("div",{className:"react-datepicker__time-container "+(this.props.todayButton?"react-datepicker__time-container--with-today-button":"")},u.default.createElement("div",{className:"react-datepicker__header react-datepicker__header--time"},u.default.createElement("div",{className:"react-datepicker-time__header"},"Time")),u.default.createElement("div",{className:"react-datepicker__time"},u.default.createElement("div",{className:"react-datepicker__time-box"},u.default.createElement("ul",{className:"react-datepicker__time-list",ref:function(t){e.list=t},style:t?{height:t}:{}},this.renderTimes.bind(this)()))))}}],[{key:"defaultProps",get:function(){return{intervals:30,onTimeChange:function(){},todayButton:null}}}]),t}(u.default.Component);t.default=f},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.popperPlacementPositions=void 0;var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(10),u=r(p),c=n(3),l=r(c),f=n(4),d=(r(f),n(22)),h=(t.popperPlacementPositions=["auto","auto-left","auto-right","bottom","bottom-end","bottom-start","left","left-end","left-start","right","right-end","right-start","top","top-end","top-start"],function(e){function t(){return o(this,t),a(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),s(t,[{key:"render",value:function(){var e=this.props,t=e.className,n=e.hidePopper,r=e.popperComponent,o=e.popperModifiers,a=e.popperPlacement,i=e.targetComponent,s=void 0;if(!n){var p=(0,u.default)("react-datepicker-popper",t);s=l.default.createElement(d.Popper,{className:p,modifiers:o,placement:a},r)}return this.props.popperContainer&&(s=l.default.createElement(this.props.popperContainer,{},s)),l.default.createElement(d.Manager,null,l.default.createElement(d.Target,{className:"react-datepicker-wrapper"},i),s)}}],[{key:"defaultProps",get:function(){return{hidePopper:!0,popperModifiers:{preventOverflow:{enabled:!0,escapeWithReference:!0,boundariesElement:"viewport"}},popperPlacement:"bottom-start"}}}]),t}(l.default.Component));t.default=h},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.Arrow=t.Popper=t.Target=t.Manager=void 0;var o=n(23),a=r(o),i=n(24),s=r(i),p=n(25),u=r(p),c=n(27),l=r(c);t.Manager=a.default,t.Target=s.default,t.Popper=u.default,t.Arrow=l.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var p=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(3),c=(r(u),n(4)),l=r(c),f=function(e){function t(){var e,n,r,o;a(this,t);for(var s=arguments.length,p=Array(s),u=0;u<s;u++)p[u]=arguments[u];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r._setTargetNode=function(e){r._targetNode=e},r._getTargetNode=function(){return r._targetNode},o=n,i(r,o)}return s(t,e),p(t,[{key:"getChildContext",value:function(){return{popperManager:{setTargetNode:this._setTargetNode,getTargetNode:this._getTargetNode}}}},{key:"render",value:function(){var e=this.props,t=e.tag,n=e.children,r=o(e,["tag","children"]);return t!==!1?(0,u.createElement)(t,r,n):n}}]),t}(u.Component);f.childContextTypes={popperManager:l.default.object.isRequired},f.propTypes={tag:l.default.oneOfType([l.default.string,l.default.bool])},f.defaultProps={tag:"div"},t.default=f},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}Object.defineProperty(t,"__esModule",{value:!0});var a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(3),s=(r(i),n(4)),p=r(s),u=function(e,t){
	var n=e.component,r=void 0===n?"div":n,s=e.innerRef,p=e.children,u=o(e,["component","innerRef","children"]),c=t.popperManager,l=function(e){c.setTargetNode(e),"function"==typeof s&&s(e)};if("function"==typeof p){var f={ref:l};return p({targetProps:f,restProps:u})}var d=a({},u);return"string"==typeof r?d.ref=l:d.innerRef=l,(0,i.createElement)(r,d,p)};u.contextTypes={popperManager:p.default.object.isRequired},u.propTypes={component:p.default.oneOfType([p.default.node,p.default.func]),innerRef:p.default.func,children:p.default.oneOfType([p.default.node,p.default.func])},t.default=u},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function a(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function s(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function p(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},c=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(3),f=(r(l),n(4)),d=r(f),h=n(26),m=r(h),y=function(e){function t(){var e,n,r,o;i(this,t);for(var a=arguments.length,p=Array(a),c=0;c<a;c++)p[c]=arguments[c];return n=r=s(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.state={},r._setArrowNode=function(e){r._arrowNode=e},r._getTargetNode=function(){return r.context.popperManager.getTargetNode()},r._getOffsets=function(e){return Object.keys(e.offsets).map(function(t){return e.offsets[t]})},r._isDataDirty=function(e){return!r.state.data||JSON.stringify(r._getOffsets(r.state.data))!==JSON.stringify(r._getOffsets(e))},r._updateStateModifier={enabled:!0,order:900,fn:function(e){return r._isDataDirty(e)&&r.setState({data:e}),e}},r._getPopperStyle=function(){var e=r.state.data;if(!r._popper||!e)return{position:"absolute",pointerEvents:"none",opacity:0};var t=e.offsets.popper,n=(t.top,t.left,t.position);return u({position:n},e.styles)},r._getPopperPlacement=function(){return r.state.data?r.state.data.placement:void 0},r._getPopperHide=function(){return r.state.data&&r.state.data.hide?"":void 0},r._getArrowStyle=function(){if(r.state.data&&r.state.data.offsets.arrow){var e=r.state.data.offsets.arrow,t=e.top,n=e.left;return{top:t,left:n}}return{}},o=n,s(r,o)}return p(t,e),c(t,[{key:"getChildContext",value:function(){return{popper:{setArrowNode:this._setArrowNode,getArrowStyle:this._getArrowStyle}}}},{key:"componentDidMount",value:function(){this._updatePopper()}},{key:"componentDidUpdate",value:function(e){e.placement===this.props.placement&&e.eventsEnabled===this.props.eventsEnabled||this._updatePopper(),this._popper&&e.children!==this.props.children&&this._popper.scheduleUpdate()}},{key:"componentWillUnmount",value:function(){this._destroyPopper()}},{key:"_updatePopper",value:function(){this._destroyPopper(),this._node&&this._createPopper()}},{key:"_createPopper",value:function(){var e=this.props,t=e.placement,n=e.eventsEnabled,r=u({},this.props.modifiers,{applyStyle:{enabled:!1},updateState:this._updateStateModifier});this._arrowNode&&(r.arrow={element:this._arrowNode}),this._popper=new m.default(this._getTargetNode(),this._node,{placement:t,eventsEnabled:n,modifiers:r}),this._popper.scheduleUpdate()}},{key:"_destroyPopper",value:function(){this._popper&&this._popper.destroy()}},{key:"render",value:function(){var e=this,t=this.props,n=t.component,r=t.innerRef,i=(t.placement,t.eventsEnabled,t.modifiers,t.children),s=a(t,["component","innerRef","placement","eventsEnabled","modifiers","children"]),p=function(t){e._node=t,"function"==typeof r&&r(t)},c=this._getPopperStyle(),f=this._getPopperPlacement(),d=this._getPopperHide();if("function"==typeof i){var h,m=(h={ref:p,style:c},o(h,"data-placement",f),o(h,"data-x-out-of-boundaries",d),h);return i({popperProps:m,restProps:s,scheduleUpdate:this._popper&&this._popper.scheduleUpdate})}var y=u({},s,{style:u({},s.style,c),"data-placement":f,"data-x-out-of-boundaries":d});return"string"==typeof n?y.ref=p:y.innerRef=p,(0,l.createElement)(n,y,i)}}]),t}(l.Component);y.contextTypes={popperManager:d.default.object.isRequired},y.childContextTypes={popper:d.default.object.isRequired},y.propTypes={component:d.default.oneOfType([d.default.node,d.default.func]),innerRef:d.default.func,placement:d.default.oneOf(m.default.placements),eventsEnabled:d.default.bool,modifiers:d.default.object,children:d.default.oneOfType([d.default.node,d.default.func])},y.defaultProps={component:"div",placement:"bottom",eventsEnabled:!0,modifiers:{}},t.default=y},function(e,t,n){(function(t){/**!
		 * @fileOverview Kickass library to create and place poppers near their reference elements.
		 * @version 1.12.6
		 * @license
		 * Copyright (c) 2016 Federico Zivolo and contributors
		 *
		 * Permission is hereby granted, free of charge, to any person obtaining a copy
		 * of this software and associated documentation files (the "Software"), to deal
		 * in the Software without restriction, including without limitation the rights
		 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
		 * copies of the Software, and to permit persons to whom the Software is
		 * furnished to do so, subject to the following conditions:
		 *
		 * The above copyright notice and this permission notice shall be included in all
		 * copies or substantial portions of the Software.
		 *
		 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
		 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
		 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
		 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
		 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
		 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
		 * SOFTWARE.
		 */
	!function(t,n){e.exports=n()}(this,function(){"use strict";function e(e){var t=!1;return function(){t||(t=!0,Promise.resolve().then(function(){t=!1,e()}))}}function n(e){var t=!1;return function(){t||(t=!0,setTimeout(function(){t=!1,e()},pe))}}function r(e){var t={};return e&&"[object Function]"===t.toString.call(e)}function o(e,t){if(1!==e.nodeType)return[];var n=window.getComputedStyle(e,null);return t?n[t]:n}function a(e){return"HTML"===e.nodeName?e:e.parentNode||e.host}function i(e){if(!e)return window.document.body;switch(e.nodeName){case"HTML":case"BODY":return e.ownerDocument.body;case"#document":return e.body}var t=o(e),n=t.overflow,r=t.overflowX,s=t.overflowY;return/(auto|scroll)/.test(n+s+r)?e:i(a(e))}function s(e){var t=e&&e.offsetParent,n=t&&t.nodeName;return n&&"BODY"!==n&&"HTML"!==n?["TD","TABLE"].indexOf(t.nodeName)!==-1&&"static"===o(t,"position")?s(t):t:e?e.ownerDocument.documentElement:window.document.documentElement}function p(e){var t=e.nodeName;return"BODY"!==t&&("HTML"===t||s(e.firstElementChild)===e)}function u(e){return null!==e.parentNode?u(e.parentNode):e}function c(e,t){if(!(e&&e.nodeType&&t&&t.nodeType))return window.document.documentElement;var n=e.compareDocumentPosition(t)&Node.DOCUMENT_POSITION_FOLLOWING,r=n?e:t,o=n?t:e,a=document.createRange();a.setStart(r,0),a.setEnd(o,0);var i=a.commonAncestorContainer;if(e!==i&&t!==i||r.contains(o))return p(i)?i:s(i);var l=u(e);return l.host?c(l.host,t):c(e,u(t).host)}function l(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"top",n="top"===t?"scrollTop":"scrollLeft",r=e.nodeName;if("BODY"===r||"HTML"===r){var o=e.ownerDocument.documentElement,a=e.ownerDocument.scrollingElement||o;return a[n]}return e[n]}function f(e,t){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],r=l(t,"top"),o=l(t,"left"),a=n?-1:1;return e.top+=r*a,e.bottom+=r*a,e.left+=o*a,e.right+=o*a,e}function d(e,t){var n="x"===t?"Left":"Top",r="Left"===n?"Right":"Bottom";return+e["border"+n+"Width"].split("px")[0]+ +e["border"+r+"Width"].split("px")[0]}function h(e,t,n,r){return Math.max(t["offset"+e],t["scroll"+e],n["client"+e],n["offset"+e],n["scroll"+e],de()?n["offset"+e]+r["margin"+("Height"===e?"Top":"Left")]+r["margin"+("Height"===e?"Bottom":"Right")]:0)}function m(){var e=window.document.body,t=window.document.documentElement,n=de()&&window.getComputedStyle(t);return{height:h("Height",e,t,n),width:h("Width",e,t,n)}}function y(e){return ve({},e,{right:e.left+e.width,bottom:e.top+e.height})}function v(e){var t={};if(de())try{t=e.getBoundingClientRect();var n=l(e,"top"),r=l(e,"left");t.top+=n,t.left+=r,t.bottom+=n,t.right+=r}catch(e){}else t=e.getBoundingClientRect();var a={left:t.left,top:t.top,width:t.right-t.left,height:t.bottom-t.top},i="HTML"===e.nodeName?m():{},s=i.width||e.clientWidth||a.right-a.left,p=i.height||e.clientHeight||a.bottom-a.top,u=e.offsetWidth-s,c=e.offsetHeight-p;if(u||c){var f=o(e);u-=d(f,"x"),c-=d(f,"y"),a.width-=u,a.height-=c}return y(a)}function g(e,t){var n=de(),r="HTML"===t.nodeName,a=v(e),s=v(t),p=i(e),u=o(t),c=+u.borderTopWidth.split("px")[0],l=+u.borderLeftWidth.split("px")[0],d=y({top:a.top-s.top-c,left:a.left-s.left-l,width:a.width,height:a.height});if(d.marginTop=0,d.marginLeft=0,!n&&r){var h=+u.marginTop.split("px")[0],m=+u.marginLeft.split("px")[0];d.top-=c-h,d.bottom-=c-h,d.left-=l-m,d.right-=l-m,d.marginTop=h,d.marginLeft=m}return(n?t.contains(p):t===p&&"BODY"!==p.nodeName)&&(d=f(d,t)),d}function b(e){var t=e.ownerDocument.documentElement,n=g(e,t),r=Math.max(t.clientWidth,window.innerWidth||0),o=Math.max(t.clientHeight,window.innerHeight||0),a=l(t),i=l(t,"left"),s={top:a-n.top+n.marginTop,left:i-n.left+n.marginLeft,width:r,height:o};return y(s)}function w(e){var t=e.nodeName;return"BODY"!==t&&"HTML"!==t&&("fixed"===o(e,"position")||w(a(e)))}function _(e,t,n,r){var o={top:0,left:0},s=c(e,t);if("viewport"===r)o=b(s);else{var p=void 0;"scrollParent"===r?(p=i(a(e)),"BODY"===p.nodeName&&(p=e.ownerDocument.documentElement)):p="window"===r?e.ownerDocument.documentElement:r;var u=g(p,s);if("HTML"!==p.nodeName||w(s))o=u;else{var l=m(),f=l.height,d=l.width;o.top+=u.top-u.marginTop,o.bottom=f+u.top,o.left+=u.left-u.marginLeft,o.right=d+u.left}}return o.left+=n,o.top+=n,o.right-=n,o.bottom-=n,o}function D(e){var t=e.width,n=e.height;return t*n}function k(e,t,n,r,o){var a=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0;if(e.indexOf("auto")===-1)return e;var i=_(n,r,a,o),s={top:{width:i.width,height:t.top-i.top},right:{width:i.right-t.right,height:i.height},bottom:{width:i.width,height:i.bottom-t.bottom},left:{width:t.left-i.left,height:i.height}},p=Object.keys(s).map(function(e){return ve({key:e},s[e],{area:D(s[e])})}).sort(function(e,t){return t.area-e.area}),u=p.filter(function(e){var t=e.width,r=e.height;return t>=n.clientWidth&&r>=n.clientHeight}),c=u.length>0?u[0].key:p[0].key,l=e.split("-")[1];return c+(l?"-"+l:"")}function O(e,t,n){var r=c(t,n);return g(n,r)}function S(e){var t=window.getComputedStyle(e),n=parseFloat(t.marginTop)+parseFloat(t.marginBottom),r=parseFloat(t.marginLeft)+parseFloat(t.marginRight),o={width:e.offsetWidth+r,height:e.offsetHeight+n};return o}function E(e){var t={left:"right",right:"left",bottom:"top",top:"bottom"};return e.replace(/left|right|bottom|top/g,function(e){return t[e]})}function C(e,t,n){n=n.split("-")[0];var r=S(e),o={width:r.width,height:r.height},a=["right","left"].indexOf(n)!==-1,i=a?"top":"left",s=a?"left":"top",p=a?"height":"width",u=a?"width":"height";return o[i]=t[i]+t[p]/2-r[p]/2,n===s?o[s]=t[s]-r[u]:o[s]=t[E(s)],o}function M(e,t){return Array.prototype.find?e.find(t):e.filter(t)[0]}function P(e,t,n){if(Array.prototype.findIndex)return e.findIndex(function(e){return e[t]===n});var r=M(e,function(e){return e[t]===n});return e.indexOf(r)}function T(e,t,n){var o=void 0===n?e:e.slice(0,P(e,"name",n));return o.forEach(function(e){e.function&&console.warn("`modifier.function` is deprecated, use `modifier.fn`!");var n=e.function||e.fn;e.enabled&&r(n)&&(t.offsets.popper=y(t.offsets.popper),t.offsets.reference=y(t.offsets.reference),t=n(t,e))}),t}function x(){if(!this.state.isDestroyed){var e={instance:this,styles:{},arrowStyles:{},attributes:{},flipped:!1,offsets:{}};e.offsets.reference=O(this.state,this.popper,this.reference),e.placement=k(this.options.placement,e.offsets.reference,this.popper,this.reference,this.options.modifiers.flip.boundariesElement,this.options.modifiers.flip.padding),e.originalPlacement=e.placement,e.offsets.popper=C(this.popper,e.offsets.reference,e.placement),e.offsets.popper.position="absolute",e=T(this.modifiers,e),this.state.isCreated?this.options.onUpdate(e):(this.state.isCreated=!0,this.options.onCreate(e))}}function N(e,t){return e.some(function(e){var n=e.name,r=e.enabled;return r&&n===t})}function j(e){for(var t=[!1,"ms","Webkit","Moz","O"],n=e.charAt(0).toUpperCase()+e.slice(1),r=0;r<t.length-1;r++){var o=t[r],a=o?""+o+n:e;if("undefined"!=typeof window.document.body.style[a])return a}return null}function R(){return this.state.isDestroyed=!0,N(this.modifiers,"applyStyle")&&(this.popper.removeAttribute("x-placement"),this.popper.style.left="",this.popper.style.position="",this.popper.style.top="",this.popper.style[j("transform")]=""),this.disableEventListeners(),this.options.removeOnDestroy&&this.popper.parentNode.removeChild(this.popper),this}function W(e){var t=e.ownerDocument;return t?t.defaultView:window}function L(e,t,n,r){var o="BODY"===e.nodeName,a=o?e.ownerDocument.defaultView:e;a.addEventListener(t,n,{passive:!0}),o||L(i(a.parentNode),t,n,r),r.push(a)}function I(e,t,n,r){n.updateBound=r,W(e).addEventListener("resize",n.updateBound,{passive:!0});var o=i(e);return L(o,"scroll",n.updateBound,n.scrollParents),n.scrollElement=o,n.eventsEnabled=!0,n}function F(){this.state.eventsEnabled||(this.state=I(this.reference,this.options,this.state,this.scheduleUpdate))}function A(e,t){return W(e).removeEventListener("resize",t.updateBound),t.scrollParents.forEach(function(e){e.removeEventListener("scroll",t.updateBound)}),t.updateBound=null,t.scrollParents=[],t.scrollElement=null,t.eventsEnabled=!1,t}function B(){this.state.eventsEnabled&&(window.cancelAnimationFrame(this.scheduleUpdate),this.state=A(this.reference,this.state))}function Y(e){return""!==e&&!isNaN(parseFloat(e))&&isFinite(e)}function H(e,t){Object.keys(t).forEach(function(n){var r="";["width","height","top","right","bottom","left"].indexOf(n)!==-1&&Y(t[n])&&(r="px"),e.style[n]=t[n]+r})}function U(e,t){Object.keys(t).forEach(function(n){var r=t[n];r!==!1?e.setAttribute(n,t[n]):e.removeAttribute(n)})}function V(e){return H(e.instance.popper,e.styles),U(e.instance.popper,e.attributes),e.arrowElement&&Object.keys(e.arrowStyles).length&&H(e.arrowElement,e.arrowStyles),e}function q(e,t,n,r,o){var a=O(o,t,e),i=k(n.placement,a,t,e,n.modifiers.flip.boundariesElement,n.modifiers.flip.padding);return t.setAttribute("x-placement",i),H(t,{position:"absolute"}),n}function K(e,t){var n=t.x,r=t.y,o=e.offsets.popper,a=M(e.instance.modifiers,function(e){return"applyStyle"===e.name}).gpuAcceleration;void 0!==a&&console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");var i=void 0!==a?a:t.gpuAcceleration,p=s(e.instance.popper),u=v(p),c={position:o.position},l={left:Math.floor(o.left),top:Math.floor(o.top),bottom:Math.floor(o.bottom),right:Math.floor(o.right)},f="bottom"===n?"top":"bottom",d="right"===r?"left":"right",h=j("transform"),m=void 0,y=void 0;if(y="bottom"===f?-u.height+l.bottom:l.top,m="right"===d?-u.width+l.right:l.left,i&&h)c[h]="translate3d("+m+"px, "+y+"px, 0)",c[f]=0,c[d]=0,c.willChange="transform";else{var g="bottom"===f?-1:1,b="right"===d?-1:1;c[f]=y*g,c[d]=m*b,c.willChange=f+", "+d}var w={"x-placement":e.placement};return e.attributes=ve({},w,e.attributes),e.styles=ve({},c,e.styles),e.arrowStyles=ve({},e.offsets.arrow,e.arrowStyles),e}function z(e,t,n){var r=M(e,function(e){var n=e.name;return n===t}),o=!!r&&e.some(function(e){return e.name===n&&e.enabled&&e.order<r.order});if(!o){var a="`"+t+"`",i="`"+n+"`";console.warn(i+" modifier is required by "+a+" modifier in order to work, be sure to include it before "+a+"!")}return o}function G(e,t){if(!z(e.instance.modifiers,"arrow","keepTogether"))return e;var n=t.element;if("string"==typeof n){if(n=e.instance.popper.querySelector(n),!n)return e}else if(!e.instance.popper.contains(n))return console.warn("WARNING: `arrow.element` must be child of its popper element!"),e;var r=e.placement.split("-")[0],a=e.offsets,i=a.popper,s=a.reference,p=["left","right"].indexOf(r)!==-1,u=p?"height":"width",c=p?"Top":"Left",l=c.toLowerCase(),f=p?"left":"top",d=p?"bottom":"right",h=S(n)[u];s[d]-h<i[l]&&(e.offsets.popper[l]-=i[l]-(s[d]-h)),s[l]+h>i[d]&&(e.offsets.popper[l]+=s[l]+h-i[d]);var m=s[l]+s[u]/2-h/2,v=o(e.instance.popper,"margin"+c).replace("px",""),g=m-y(e.offsets.popper)[l]-v;return g=Math.max(Math.min(i[u]-h,g),0),e.arrowElement=n,e.offsets.arrow={},e.offsets.arrow[l]=Math.round(g),e.offsets.arrow[f]="",e}function J(e){return"end"===e?"start":"start"===e?"end":e}function X(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=be.indexOf(e),r=be.slice(n+1).concat(be.slice(0,n));return t?r.reverse():r}function Q(e,t){if(N(e.instance.modifiers,"inner"))return e;if(e.flipped&&e.placement===e.originalPlacement)return e;var n=_(e.instance.popper,e.instance.reference,t.padding,t.boundariesElement),r=e.placement.split("-")[0],o=E(r),a=e.placement.split("-")[1]||"",i=[];switch(t.behavior){case we.FLIP:i=[r,o];break;case we.CLOCKWISE:i=X(r);break;case we.COUNTERCLOCKWISE:i=X(r,!0);break;default:i=t.behavior}return i.forEach(function(s,p){if(r!==s||i.length===p+1)return e;r=e.placement.split("-")[0],o=E(r);var u=e.offsets.popper,c=e.offsets.reference,l=Math.floor,f="left"===r&&l(u.right)>l(c.left)||"right"===r&&l(u.left)<l(c.right)||"top"===r&&l(u.bottom)>l(c.top)||"bottom"===r&&l(u.top)<l(c.bottom),d=l(u.left)<l(n.left),h=l(u.right)>l(n.right),m=l(u.top)<l(n.top),y=l(u.bottom)>l(n.bottom),v="left"===r&&d||"right"===r&&h||"top"===r&&m||"bottom"===r&&y,g=["top","bottom"].indexOf(r)!==-1,b=!!t.flipVariations&&(g&&"start"===a&&d||g&&"end"===a&&h||!g&&"start"===a&&m||!g&&"end"===a&&y);(f||v||b)&&(e.flipped=!0,(f||v)&&(r=i[p+1]),b&&(a=J(a)),e.placement=r+(a?"-"+a:""),e.offsets.popper=ve({},e.offsets.popper,C(e.instance.popper,e.offsets.reference,e.placement)),e=T(e.instance.modifiers,e,"flip"))}),e}function Z(e){var t=e.offsets,n=t.popper,r=t.reference,o=e.placement.split("-")[0],a=Math.floor,i=["top","bottom"].indexOf(o)!==-1,s=i?"right":"bottom",p=i?"left":"top",u=i?"width":"height";return n[s]<a(r[p])&&(e.offsets.popper[p]=a(r[p])-n[u]),n[p]>a(r[s])&&(e.offsets.popper[p]=a(r[s])),e}function $(e,t,n,r){var o=e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),a=+o[1],i=o[2];if(!a)return e;if(0===i.indexOf("%")){var s=void 0;switch(i){case"%p":s=n;break;case"%":case"%r":default:s=r}var p=y(s);return p[t]/100*a}if("vh"===i||"vw"===i){var u=void 0;return u="vh"===i?Math.max(document.documentElement.clientHeight,window.innerHeight||0):Math.max(document.documentElement.clientWidth,window.innerWidth||0),u/100*a}return a}function ee(e,t,n,r){var o=[0,0],a=["right","left"].indexOf(r)!==-1,i=e.split(/(\+|\-)/).map(function(e){return e.trim()}),s=i.indexOf(M(i,function(e){return e.search(/,|\s/)!==-1}));i[s]&&i[s].indexOf(",")===-1&&console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");var p=/\s*,\s*|\s+/,u=s!==-1?[i.slice(0,s).concat([i[s].split(p)[0]]),[i[s].split(p)[1]].concat(i.slice(s+1))]:[i];return u=u.map(function(e,r){var o=(1===r?!a:a)?"height":"width",i=!1;return e.reduce(function(e,t){return""===e[e.length-1]&&["+","-"].indexOf(t)!==-1?(e[e.length-1]=t,i=!0,e):i?(e[e.length-1]+=t,i=!1,e):e.concat(t)},[]).map(function(e){return $(e,o,t,n)})}),u.forEach(function(e,t){e.forEach(function(n,r){Y(n)&&(o[t]+=n*("-"===e[r-1]?-1:1))})}),o}function te(e,t){var n=t.offset,r=e.placement,o=e.offsets,a=o.popper,i=o.reference,s=r.split("-")[0],p=void 0;return p=Y(+n)?[+n,0]:ee(n,a,i,s),"left"===s?(a.top+=p[0],a.left-=p[1]):"right"===s?(a.top+=p[0],a.left+=p[1]):"top"===s?(a.left+=p[0],a.top-=p[1]):"bottom"===s&&(a.left+=p[0],a.top+=p[1]),e.popper=a,e}function ne(e,t){var n=t.boundariesElement||s(e.instance.popper);e.instance.reference===n&&(n=s(n));var r=_(e.instance.popper,e.instance.reference,t.padding,n);t.boundaries=r;var o=t.priority,a=e.offsets.popper,i={primary:function(e){var n=a[e];return a[e]<r[e]&&!t.escapeWithReference&&(n=Math.max(a[e],r[e])),ye({},e,n)},secondary:function(e){var n="right"===e?"left":"top",o=a[n];return a[e]>r[e]&&!t.escapeWithReference&&(o=Math.min(a[n],r[e]-("right"===e?a.width:a.height))),ye({},n,o)}};return o.forEach(function(e){var t=["left","top"].indexOf(e)!==-1?"primary":"secondary";a=ve({},a,i[t](e))}),e.offsets.popper=a,e}function re(e){var t=e.placement,n=t.split("-")[0],r=t.split("-")[1];if(r){var o=e.offsets,a=o.reference,i=o.popper,s=["bottom","top"].indexOf(n)!==-1,p=s?"left":"top",u=s?"width":"height",c={start:ye({},p,a[p]),end:ye({},p,a[p]+a[u]-i[u])};e.offsets.popper=ve({},i,c[r])}return e}function oe(e){if(!z(e.instance.modifiers,"hide","preventOverflow"))return e;var t=e.offsets.reference,n=M(e.instance.modifiers,function(e){return"preventOverflow"===e.name}).boundaries;if(t.bottom<n.top||t.left>n.right||t.top>n.bottom||t.right<n.left){if(e.hide===!0)return e;e.hide=!0,e.attributes["x-out-of-boundaries"]=""}else{if(e.hide===!1)return e;e.hide=!1,e.attributes["x-out-of-boundaries"]=!1}return e}function ae(e){var t=e.placement,n=t.split("-")[0],r=e.offsets,o=r.popper,a=r.reference,i=["left","right"].indexOf(n)!==-1,s=["top","left"].indexOf(n)===-1;return o[i?"left":"top"]=a[n]-(s?o[i?"width":"height"]:0),e.placement=E(t),e.offsets.popper=y(o),e}for(var ie="undefined"!=typeof window&&"undefined"!=typeof window.document,se=["Edge","Trident","Firefox"],pe=0,ue=0;ue<se.length;ue+=1)if(ie&&navigator.userAgent.indexOf(se[ue])>=0){pe=1;break}var ce=ie&&window.Promise,le=ce?e:n,fe=void 0,de=function(){return void 0===fe&&(fe=navigator.appVersion.indexOf("MSIE 10")!==-1),fe},he=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},me=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),ye=function(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e},ve=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},ge=["auto-start","auto","auto-end","top-start","top","top-end","right-start","right","right-end","bottom-end","bottom","bottom-start","left-end","left","left-start"],be=ge.slice(3),we={FLIP:"flip",CLOCKWISE:"clockwise",COUNTERCLOCKWISE:"counterclockwise"},_e={shift:{order:100,enabled:!0,fn:re},offset:{order:200,enabled:!0,fn:te,offset:0},preventOverflow:{order:300,enabled:!0,fn:ne,priority:["left","right","top","bottom"],padding:5,boundariesElement:"scrollParent"},keepTogether:{order:400,enabled:!0,fn:Z},arrow:{order:500,enabled:!0,fn:G,element:"[x-arrow]"},flip:{order:600,enabled:!0,fn:Q,behavior:"flip",padding:5,boundariesElement:"viewport"},inner:{order:700,enabled:!1,fn:ae},hide:{order:800,enabled:!0,fn:oe},computeStyle:{order:850,enabled:!0,fn:K,gpuAcceleration:!0,x:"bottom",y:"right"},applyStyle:{order:900,enabled:!0,fn:V,onLoad:q,gpuAcceleration:void 0}},De={placement:"bottom",eventsEnabled:!0,removeOnDestroy:!1,onCreate:function(){},onUpdate:function(){},modifiers:_e},ke=function(){function e(t,n){var o=this,a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};he(this,e),this.scheduleUpdate=function(){return requestAnimationFrame(o.update)},this.update=le(this.update.bind(this)),this.options=ve({},e.Defaults,a),this.state={isDestroyed:!1,isCreated:!1,scrollParents:[]},this.reference=t&&t.jquery?t[0]:t,this.popper=n&&n.jquery?n[0]:n,this.options.modifiers={},Object.keys(ve({},e.Defaults.modifiers,a.modifiers)).forEach(function(t){o.options.modifiers[t]=ve({},e.Defaults.modifiers[t]||{},a.modifiers?a.modifiers[t]:{})}),this.modifiers=Object.keys(this.options.modifiers).map(function(e){return ve({name:e},o.options.modifiers[e])}).sort(function(e,t){return e.order-t.order}),this.modifiers.forEach(function(e){e.enabled&&r(e.onLoad)&&e.onLoad(o.reference,o.popper,o.options,e,o.state)}),this.update();var i=this.options.eventsEnabled;i&&this.enableEventListeners(),this.state.eventsEnabled=i}return me(e,[{key:"update",value:function(){return x.call(this)}},{key:"destroy",value:function(){return R.call(this)}},{key:"enableEventListeners",value:function(){return F.call(this)}},{key:"disableEventListeners",value:function(){return B.call(this)}}]),e}();return ke.Utils=("undefined"!=typeof window?window:t).PopperUtils,ke.placements=ge,ke.Defaults=De,ke})}).call(t,function(){return this}())},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}Object.defineProperty(t,"__esModule",{value:!0});var a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(3),s=(r(i),n(4)),p=r(s),u=function(e,t){var n=e.component,r=void 0===n?"span":n,s=e.innerRef,p=e.children,u=o(e,["component","innerRef","children"]),c=t.popper,l=function(e){c.setArrowNode(e),"function"==typeof s&&s(e)},f=c.getArrowStyle();if("function"==typeof p){var d={ref:l,style:f};return p({arrowProps:d,restProps:u})}var h=a({},u,{style:a({},f,u.style)});return"string"==typeof r?h.ref=l:h.innerRef=l,(0,i.createElement)(r,h,p)};u.contextTypes={popper:p.default.object.isRequired},u.propTypes={component:p.default.oneOfType([p.default.node,p.default.func]),innerRef:p.default.func,children:p.default.oneOfType([p.default.node,p.default.func])},t.default=u}])});

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdvancedSearchHelper = function AdvancedSearchHelper() {
	  return _react2.default.createElement(
	    "div",
	    { className: "advanced-search-helper" },
	    _react2.default.createElement(
	      "div",
	      { className: "help-operators" },
	      _react2.default.createElement(
	        "h4",
	        null,
	        "Help operators"
	      ),
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tbody",
	          null,
	          _react2.default.createElement(
	            "tr",
	            { title: "Find all words, e.g.: motion AND 363" },
	            _react2.default.createElement(
	              "td",
	              null,
	              "AND"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "All Words"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            { title: "Find at least one of the words, e.g.: motion OR 363" },
	            _react2.default.createElement(
	              "td",
	              null,
	              "OR"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "Either Word"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            { title: "Find these words within n words of each other, e.g.: motion /3 363" },
	            _react2.default.createElement(
	              "td",
	              null,
	              "/n"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "Within ",
	              _react2.default.createElement(
	                "var",
	                null,
	                "n"
	              ),
	              " terms of"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            { title: "Find this sequence of words exactly as typed, e.g.: \"order on motion for relief from stay\"" },
	            _react2.default.createElement(
	              "td",
	              null,
	              "\"_\""
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "Phrase"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            { title: "Find results without this word, e.g.: order -relief" },
	            _react2.default.createElement(
	              "td",
	              null,
	              "-word"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "But not"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            { title: "Find words that start or end as specified, e.g.: evid*" },
	            _react2.default.createElement(
	              "td",
	              null,
	              "*"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "Wildcard"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            { title: "Find group of words, e.g.: (order on motion) for (relief from stay)" },
	            _react2.default.createElement(
	              "td",
	              null,
	              "( )"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "Grouping"
	            )
	          )
	        )
	      )
	    )
	  );
	}; /* eslint-disable max-len */
	exports.default = AdvancedSearchHelper;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _FilterTableHeader = __webpack_require__(1149);
	
	var _FilterTableHeader2 = _interopRequireDefault(_FilterTableHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FilterTable = function (_Component) {
	  _inherits(FilterTable, _Component);
	
	  function FilterTable() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FilterTable);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getDowloadExcel = function () {
	      var _this$props$premiumSe = _this.props.premiumSearch,
	          uuid = _this$props$premiumSe.uuid,
	          query = _this$props$premiumSe.query;
	
	      var link = '/party/export-xlsx/' + uuid;
	
	      if (query !== 'parties') {
	        return null;
	      }
	      return _react2.default.createElement(
	        'a',
	        { href: link, className: 'form-submit',
	          style: { float: "right", marginLeft: '4px' } },
	        _react2.default.createElement('i', { className: 'fa  fa-file-excel-o' }),
	        ' Download Excel'
	      );
	    }, _this.getAdvancedSearchLink = function () {
	      var _this$props$premiumSe2 = _this.props.premiumSearch,
	          uuid = _this$props$premiumSe2.uuid,
	          query = _this$props$premiumSe2.query;
	
	      var link = '/advanced-search?case_uuid=' + uuid + '&query=' + query + '&do_search=1';
	
	      return _react2.default.createElement(
	        'a',
	        { href: link, className: 'advanced-search-link processed' },
	        'Premium Search'
	      );
	    }, _this.changeText = function (e) {
	      e.persist();
	      _this.filterTable(e);
	    }, _this.filterTable = _lodash2.default.debounce(function (e) {
	      // TODO see if the TextHighlight component can be used here instead
	      var searchString = _this.props.keyword ? _this.props.keyword.toLowerCase() : _lodash2.default.get(e, 'target.value', '').toLowerCase();
	
	      var words = searchString.split(' ').filter(function (p) {
	        return p !== '';
	      }).reverse();
	
	      window.$('.filter-table tbody tr').removeHighlight();
	
	      window.$('.filter-table tbody tr:not(.no-filter-search)').each(function (index, tableRow) {
	        if (_lodash2.default.every(words, function (p) {
	          return window.$(tableRow).text().toLowerCase().indexOf(p) > -1;
	        })) {
	          tableRow.style.display = '';
	          words.forEach(function (word) {
	            if (window.$(tableRow).text().toLowerCase().indexOf(word) > -1) {
	              window.$(tableRow).highlight(word);
	            }
	          });
	        } else {
	          tableRow.style.display = 'none';
	        }
	      });
	    }, 400), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  FilterTable.prototype.render = function render() {
	    var children = this.props.children;
	
	    var tableRef = 'case-tbody';
	    var advancedSearchLink = this.props.premiumSearch ? this.getAdvancedSearchLink() : null;
	    var getDowloadExcel = this.props.premiumSearch ? this.getDowloadExcel() : null;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'filter-table', ref: tableRef },
	      _react2.default.createElement(_FilterTableHeader2.default, {
	        changeText: this.changeText,
	        advancedSearchLink: advancedSearchLink,
	        getDowloadExcel: getDowloadExcel }),
	      _react2.default.createElement(
	        'div',
	        { className: 'filter-table-children' },
	        children
	      )
	    );
	  };
	
	  return FilterTable;
	}(_react.Component);
	
	FilterTable.defaultProps = {
	  premiumSearch: null,
	  keyword: ''
	};
	
	FilterTable.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  premiumSearch: _propTypes2.default.object,
	  keyword: _propTypes2.default.any
	};
	
	exports.default = FilterTable;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = exports.Loading = undefined;
	
	var _Loading = __webpack_require__(675);
	
	Object.defineProperty(exports, 'Loading', {
	  enumerable: true,
	  get: function get() {
	    return _Loading.Loading;
	  }
	});
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Loading2.default;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _inlineArrayTransformer = __webpack_require__(1285);
	
	var _inlineArrayTransformer2 = _interopRequireDefault(_inlineArrayTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _inlineArrayTransformer2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pbmxpbmVBcnJheVRyYW5zZm9ybWVyL2luZGV4LmpzIl0sIm5hbWVzIjpbImRlZmF1bHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7UUFBT0EsTyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZyb20gJy4vaW5saW5lQXJyYXlUcmFuc2Zvcm1lcic7XG4iXX0=

/***/ },
/* 83 */
[2252, 61],
/* 84 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 85 */
28,
/* 86 */
[2260, 57],
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(27);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ },
/* 88 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 89 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(58));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _elementType = _interopRequireDefault(__webpack_require__(34));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var propTypes = {
	  href: _propTypes.default.string,
	  onClick: _propTypes.default.func,
	  onKeyDown: _propTypes.default.func,
	  disabled: _propTypes.default.bool,
	  role: _propTypes.default.string,
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * this is sort of silly but needed for Button
	   */
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  componentClass: 'a'
	};
	
	function isTrivialHref(href) {
	  return !href || href.trim() === '#';
	}
	/**
	 * There are situations due to browser quirks or Bootstrap CSS where
	 * an anchor tag is needed, when semantically a button tag is the
	 * better choice. SafeAnchor ensures that when an anchor is used like a
	 * button its accessible. It also emulates input `disabled` behavior for
	 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
	 */
	
	
	var SafeAnchor =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(SafeAnchor, _React$Component);
	
	  function SafeAnchor(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    return _this;
	  }
	
	  var _proto = SafeAnchor.prototype;
	
	  _proto.handleClick = function handleClick(event) {
	    var _this$props = this.props,
	        disabled = _this$props.disabled,
	        href = _this$props.href,
	        onClick = _this$props.onClick;
	
	    if (disabled || isTrivialHref(href)) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      event.stopPropagation();
	      return;
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    if (event.key === ' ') {
	      event.preventDefault();
	      this.handleClick(event);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props2 = this.props,
	        Component = _this$props2.componentClass,
	        disabled = _this$props2.disabled,
	        onKeyDown = _this$props2.onKeyDown,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["componentClass", "disabled", "onKeyDown"]);
	
	    if (isTrivialHref(props.href)) {
	      props.role = props.role || 'button'; // we want to make sure there is a href attribute on the node
	      // otherwise, the cursor incorrectly styled (except with role='button')
	
	      props.href = props.href || '#';
	    }
	
	    if (disabled) {
	      props.tabIndex = -1;
	      props.style = (0, _extends2.default)({
	        pointerEvents: 'none'
	      }, props.style);
	    }
	
	    return _react.default.createElement(Component, (0, _extends2.default)({}, props, {
	      onClick: this.handleClick,
	      onKeyDown: (0, _createChainedFunction.default)(this.handleKeyDown, onKeyDown)
	    }));
	  };
	
	  return SafeAnchor;
	}(_react.default.Component);
	
	SafeAnchor.propTypes = propTypes;
	SafeAnchor.defaultProps = defaultProps;
	var _default = SafeAnchor;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _LoadingBar = __webpack_require__(610);
	
	var _LoadingBar2 = _interopRequireDefault(_LoadingBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _LoadingBar2.default;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _loadingAnimation = __webpack_require__(2231);
	
	var _loadingAnimation2 = _interopRequireDefault(_loadingAnimation);
	
	__webpack_require__(943);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoadingBar = function LoadingBar(_ref) {
	  var show = _ref.show,
	      overrideShow = _ref.overrideShow;
	
	  var showOrHide = show || overrideShow ? '' : ' hide';
	  return _react2.default.createElement(
	    'div',
	    { className: 'loading-bar' + showOrHide },
	    _react2.default.createElement('img', { src: _loadingAnimation2.default, alt: '' })
	  );
	};
	
	LoadingBar.defaultProps = {
	  overrideShow: false
	};
	
	LoadingBar.propTypes = {
	  show: _propTypes2.default.bool.isRequired,
	  overrideShow: _propTypes2.default.bool
	};
	
	function mapStateToProps(state) {
	  return { show: state.get('loadingSpinner') };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(LoadingBar);

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.resetFilters = exports.updateFilter = exports.resetSearchResults = exports.searchCriminal = exports.searchCivil = exports.searchAppellates = exports.searchBankruptciesLocal = exports.searchBankruptcies = exports.searchView = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.receiveError = receiveError;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _immutable = __webpack_require__(30);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _pacerSearchActionTypes = __webpack_require__(720);
	
	var types = _interopRequireWildcard(_pacerSearchActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getUrlForEnv(url) {
	  return  false ? "http://localhost" + url : url;
	}
	
	function requestBankruptcySearch(params) {
	  return {
	    type: types.REQUEST_BANKRUPTCY_SEARCH,
	    params: params
	  };
	}
	
	function requestBankruptcyLocalSearch(params) {
	  return {
	    type: types.REQUEST_BANKRUPTCY_LOCAL_SEARCH,
	    params: params
	  };
	}
	
	function requestAppellateSearch(params) {
	  return {
	    type: types.REQUEST_APPELLATE_SEARCH,
	    params: params
	  };
	}
	
	function receiveSearchResults(params, response) {
	  return {
	    type: types.RECEIVE_SEARCH_RESULTS,
	    params: params,
	    searchResults: response.items || {},
	    searchOptions: response.config || {},
	    source_data_id: response.source_data_id
	  };
	}
	
	function requestViewSearch(params) {
	  return {
	    type: types.REQUEST_VIEW_SEARCH,
	    params: params
	  };
	}
	
	function requestCivilSearch(params) {
	  return {
	    type: types.REQUEST_CIVIL_SEARCH,
	    params: params
	  };
	}
	
	function requestCriminalSearch(params) {
	  return {
	    type: types.REQUEST_CRIMINAL_SEARCH,
	    params: params
	  };
	}
	
	function receiveError(type, errors) {
	  return {
	    type: type,
	    errors: errors
	  };
	}
	
	function mapFiltersToParams(f) {
	  //todo clean this up and move to separate file
	  var filters = f.toJS();
	  var serviceParams = { service: 'query', query_type: 'search' };
	  var sortParams = void 0;
	
	  if (_typeof(filters.sort) === 'object') {
	    sortParams = {
	      active: {
	        sort_field: filters.sort.activeField.key,
	        sort_reverse: filters.sort.isReverse
	      }
	    };
	  }
	
	  if (!_lodash2.default.isEmpty(filters.chapter)) {
	    filters.chapter = filters.chapter.split(",");
	  }
	
	  if (_lodash2.default.isEmpty(filters.court_id)) {
	    filters.court_id = '00';
	  }
	
	  // Get MM/DD/YYYY from moment objects
	  ['filed_from', 'filed_to', 'closed_from', 'closed_to', 'dismissed_from', 'dismissed_to', 'discharged_from', 'discharged_to'].forEach(function (date_field) {
	    if (!_lodash2.default.isEmpty(filters[date_field])) filters[date_field] = filters[date_field].format("MM/DD/YYYY");
	  });
	
	  return Object.assign({}, serviceParams, filters, { sort: sortParams });
	}
	
	function removeFalsyValues(obj) {
	  var filters = Object.assign({}, obj.filters, _lodash2.default.pickBy(filters, _lodash2.default.identity));
	  var root = _lodash2.default.pickBy(obj, _lodash2.default.identity);
	  return Object.assign({}, root, filters);
	}
	
	function mapResponseErrorsToMessage(err) {
	  var request_id = _lodash2.default.get(err, ['response', 'body', 'error', 'request_id']);
	  var errorMessageExtra = request_id ? 'When contacting support, please quote Request ID \'' + request_id + '\'' : '';
	
	  if (_lodash2.default.get(err, ['response', 'body', 'error', 'errorMessage'], '') == "Not enough Credits") {
	    window.location = '/prepaid/credits?destination=' + decodeURIComponent(window.location.pathname);
	    return {
	      messages: ['Insufficient credits, opening payment screen...']
	    };
	  }
	
	  return {
	    // We want to hide real messages from user since traces are confusing to them
	    // TODO: coordinate with API to surface proper errors such as field validation?
	    messages: ['PACER is experiencing some issues. Please try again in a few minutes.', errorMessageExtra],
	    // but we include the real message in the details so we receive it in the sentry report
	    details: _lodash2.default.get(err, ['response', 'body', 'error']) || []
	  };
	}
	
	function onSuccess(dispatch, filters) {
	  return function (response) {
	    return dispatch(receiveSearchResults(_immutable2.default.fromJS(filters), response.body));
	  };
	}
	
	function onFailure(dispatch) {
	  return function (err) {
	    return dispatch(receiveError(types.SERVICE_ERROR, mapResponseErrorsToMessage(err)));
	  };
	}
	
	var searchView = exports.searchView = function searchView(filters) {
	  return function (dispatch, getState) {
	    dispatch(requestViewSearch(filters));
	    var body = mapFiltersToParams(filters);
	    var searchParams = removeFalsyValues(body);
	
	    // fix page number if we click sort before paging, probably better suited elsewhere, like receiving results...
	    if (!searchParams.page) searchParams.page = 1;
	
	    var state = getState();
	    var search_id = state.getIn(['pacerSearchResults', 'searchOptions', 'search_id']);
	    var resultset = state.getIn(['pacerSearchResults', 'searchOptions', 'resultset']);
	    var filtersObj = filters.toJS();
	    var url = '/pacer/search/view/' + state.getIn(['pacerSearchResults', 'query_type']);
	
	    return _superagent2.default.post(getUrlForEnv(url)).send({
	      search_id: search_id,
	      resultset: resultset,
	      sort_field: filtersObj.sort.activeField.key,
	      sort_reverse: filtersObj.sort.isReverse,
	      page_no: searchParams.page
	    }).set('Accept', 'application/json').set('Content-Type', 'application/json').then(onSuccess(dispatch, filters), onFailure(dispatch));
	  };
	};
	
	var searchBankruptcies = exports.searchBankruptcies = function searchBankruptcies(filters) {
	  return function (dispatch) {
	    dispatch(requestBankruptcySearch(filters));
	    var params = mapFiltersToParams(filters);
	    var searchParams = removeFalsyValues(params);
	
	    // remove subfilters of party_name, keeping last_name, first_name, middle_name instead
	    searchParams = _lodash2.default.omit(searchParams, ['last_business_name', 'case_type']);
	
	    return _superagent2.default
	    //.get('http://127.0.0.1:8080/data/pacer-search/search_bk_case.json')
	    .post(getUrlForEnv('/pacer/search/bk')).send(searchParams).set('Accept', 'application/json').set('Content-Type', 'application/json').then(onSuccess(dispatch, filters), onFailure(dispatch));
	  };
	};
	
	var searchBankruptciesLocal = exports.searchBankruptciesLocal = function searchBankruptciesLocal(filters) {
	  return function (dispatch) {
	    dispatch(requestBankruptcyLocalSearch(filters));
	    var params = mapFiltersToParams(filters);
	    var searchParams = removeFalsyValues(params);
	
	    //remove filters
	    searchParams = _lodash2.default.omit(searchParams, ['party_name', 'case_type']);
	
	    return _superagent2.default
	    //.get('http://127.0.0.1:8080/data/pacer-search/search_bk_case.json')
	    .post(getUrlForEnv('/pacer/search/bk-localcourts')).send(searchParams).set('Accept', 'application/json').set('Content-Type', 'application/json').then(onSuccess(dispatch, filters), onFailure(dispatch));
	  };
	};
	
	var searchAppellates = exports.searchAppellates = function searchAppellates(filters) {
	  return function (dispatch) {
	    dispatch(requestAppellateSearch(filters));
	    var params = mapFiltersToParams(filters);
	    var searchParams = removeFalsyValues(params);
	
	    // remove subfilters of party_name, keeping last_name, first_name, middle_name instead
	    searchParams = _lodash2.default.omit(searchParams, ['last_business_name', 'case_type']);
	
	    return _superagent2.default
	    //.get('http://127.0.0.1:8080/data/pacer-search/search_bk_case.json')
	    .post(getUrlForEnv('/pacer/search/ap')).send(searchParams).set('Accept', 'application/json').set('Content-Type', 'application/json').then(onSuccess(dispatch, filters), onFailure(dispatch));
	  };
	};
	
	var searchCivil = exports.searchCivil = function searchCivil(filters) {
	  return function (dispatch) {
	    dispatch(requestCivilSearch(filters));
	
	    var params = mapFiltersToParams(filters);
	    var searchParams = removeFalsyValues(params);
	
	    // remove subfilters of party_name, keeping last_name, first_name, middle_name instead
	    searchParams = _lodash2.default.omit(searchParams, ['last_business_name', 'case_type']);
	
	    return _superagent2.default
	    //.get('http://127.0.0.1:8080/data/pacer-search/search_cv_case.json')
	    .post(getUrlForEnv('/pacer/search/cv')).send(searchParams).set('Accept', 'application/json').then(onSuccess(dispatch, filters), onFailure(dispatch));
	  };
	};
	
	var searchCriminal = exports.searchCriminal = function searchCriminal(filters) {
	  return function (dispatch) {
	    dispatch(requestCriminalSearch(filters));
	
	    var params = mapFiltersToParams(filters);
	    var searchParams = removeFalsyValues(params);
	
	    // remove subfilters of party_name, keeping last_name, first_name, middle_name instead
	    searchParams = _lodash2.default.omit(searchParams, ['last_business_name', 'case_type']);
	
	    return _superagent2.default
	    //.get('http://127.0.0.1:8080/data/pacer-search/search_cr_party.json')
	    .post(getUrlForEnv('/pacer/search/cr')).send(searchParams).set('Accept', 'application/json').then(onSuccess(dispatch, filters), onFailure(dispatch));
	  };
	};
	
	var resetSearchResults = exports.resetSearchResults = function resetSearchResults() {
	  return {
	    type: types.RESET_SEARCH_RESULTS
	  };
	};
	
	var updateFilter = exports.updateFilter = function updateFilter(filter) {
	  return {
	    type: types.UPDATE_FILTER,
	    filter: filter
	  };
	};
	
	var resetFilters = exports.resetFilters = function resetFilters() {
	  return {
	    type: types.RESET_FILTERS
	  };
	};

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getPeriodFromNow = exports.getUnixDate = exports.formatUnixDateTime = exports.formatUnixDate = undefined;
	
	var _moment = __webpack_require__(32);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var shortDateFormat = 'MM/DD/YYYY';
	var longDateTimeFormat = 'MMM D YYYY h:mm a ([GMT]Z)';
	
	var dateFormat = function dateFormat(date) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : shortDateFormat;
	
	  return _moment2.default.isMoment(date) ? date.format(format) : (0, _moment2.default)(date).format(format);
	};
	
	var formatUnixDate = exports.formatUnixDate = function formatUnixDate(date) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : shortDateFormat;
	
	  date = parseInt(date, 10);
	
	  return dateFormat(date * 1000, format);
	};
	
	var formatUnixDateTime = exports.formatUnixDateTime = function formatUnixDateTime(date) {
	  return formatUnixDate(date, longDateTimeFormat);
	};
	
	var getUnixDate = exports.getUnixDate = function getUnixDate(unixDate) {
	  var date = parseInt(unixDate * 1000, 10) || unixDate;
	  return (0, _moment2.default)(date);
	};
	
	var getPeriodFromNow = exports.getPeriodFromNow = function getPeriodFromNow(date) {
	  return getUnixDate(date).fromNow();
	};
	
	exports.default = dateFormat;

/***/ },
/* 95 */
[2280, 83, 759, 447, 73],
/* 96 */
[2254, 86, 220, 43, 37, 455],
/* 97 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 98 */
[2288, 3, 85, 27],
/* 99 */
[2306, 29],
/* 100 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.mapValidationFieldsToClassName = mapValidationFieldsToClassName;
	function mapValidationFieldsToClassName(state, field, defaultClassName) {
	    var className = state.getIn(['validationErrors', 'fields'], []).includes(field) ? 'validation-error ' + defaultClassName : '' + defaultClassName;
	
	    return { className: className };
	}

/***/ },
/* 101 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var SERVER_ERROR = exports.SERVER_ERROR = 'SERVER_ERROR';
	var INTERNAL_ERROR = exports.INTERNAL_ERROR = 'INTERNAL_ERROR';
	var VALIDATION_ERROR = exports.VALIDATION_ERROR = 'VALIDATION_ERROR';
	var RESET_VALIDATION_ERROR = exports.RESET_VALIDATION_ERROR = 'RESET_VALIDATION_ERROR';
	var SERVICE_ERROR = exports.SERVICE_ERROR = 'SERVICE_ERROR';

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.browserHistory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.hydrateState = hydrateState;
	
	var _redux = __webpack_require__(240);
	
	var _reduxLogger = __webpack_require__(2128);
	
	var _reduxLogger2 = _interopRequireDefault(_reduxLogger);
	
	var _reduxThunk = __webpack_require__(2129);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _moment = __webpack_require__(32);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _immutable = __webpack_require__(30);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _createBrowserHistory = __webpack_require__(1778);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _reactRouterRedux = __webpack_require__(519);
	
	var _rootReducer = __webpack_require__(1241);
	
	var _rootReducer2 = _interopRequireDefault(_rootReducer);
	
	var _caseLookupSearchReducer = __webpack_require__(272);
	
	var _logger = __webpack_require__(744);
	
	var _globalUtils = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stateTransformer = function stateTransformer(state) {
	  return _immutable.Iterable.isIterable(state) ? state.toJS() : state;
	};
	
	var transformAction = function transformAction(action) {
	  return _lodash2.default.mapValues(action, stateTransformer);
	};
	
	// Create a history of your choosing (we're using a browser history in this case)
	var browserHistory = exports.browserHistory = (0, _createBrowserHistory2.default)();
	
	var routerMiddleware = (0, _reactRouterRedux.routerMiddleware)(browserHistory);
	
	var loggerMiddleware = (0, _reduxLogger2.default)({
	  stateTransformer: stateTransformer,
	  predicate: function predicate(getState, action) {
	    var actionAsJS = transformAction(action);
	    var state = getState().deleteIn(['pacerSearchResults', 'filters', 'ssn4']).deleteIn(['pacerSearchResults', 'filters', 'ssntin']);
	
	    var stateAsJS = stateTransformer(state);
	    (0, _logger.logActionToRaven)(actionAsJS, stateAsJS);
	    // logActionToAWSAnalytics(actionAsJS, stateAsJS)
	
	    return true;
	  }
	});
	
	exports.default = function (initialState) {
	  // eslint-disable-next-line no-underscore-dangle
	  var composeEnhancers = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
	
	  var store = (0, _redux.createStore)(_rootReducer2.default, initialState, composeEnhancers((0, _redux.applyMiddleware)(_reduxThunk2.default, // lets us dispatch() functions
	  loggerMiddleware, // neat middleware that logs actions
	  routerMiddleware // react-router: browser url history
	  )));
	
	  // if (module.hot) {
	  //    // Enable Webpack hot module replacement for reducers
	  //    module.hot.accept('../reducers', () => {
	  //        const nextReducer = require('../reducers').default
	  //        store.replaceReducer(nextReducer)
	  //    })
	  // }
	
	  return store;
	};
	
	function hydrateState(preloadedState) {
	  var initialCaseType = (0, _globalUtils.isCourtDrive)() ? preloadedState.user.settings.pacer_search_default_case_type : 'Bankruptcy';
	
	  var defaultCourts = preloadedState.user.settings.case_lookup_default_courts || {};
	  var regions = Object.values(defaultCourts).reduce(function (accum, next, idx) {
	    if (idx === 0) {
	      return next;
	    }
	    return accum + ',' + next;
	  }, '');
	
	  var region_names = _lodash2.default.isEmpty(regions) ? {} : { region_name: regions };
	
	  var initialFacetCourts = _lodash2.default.isEmpty(defaultCourts) ? {} : { '--': -1 };
	
	  var caseLookupInitState = _caseLookupSearchReducer.initialState.mergeDeep({
	    filters: _extends({
	      case_type: initialCaseType
	    }, region_names),
	    facets: {
	      court_name: initialFacetCourts
	    }
	  });
	
	  var state = {
	    immediateSearch: !_lodash2.default.isEmpty(preloadedState.immediateSearch),
	    pacerSearchResults: {
	      data: [],
	      receipts: [],
	      searchOptions: {},
	      filters: {
	        case_type: initialCaseType,
	        court_id: null,
	        case_no: null,
	        case_title: null,
	        chapter: null,
	        filed_from: null,
	        filed_to: null,
	        closed_from: null,
	        closed_to: null,
	        dismissed_from: null,
	        dismissed_to: null,
	        discharged_from: null,
	        discharged_to: null,
	        ssn4: null,
	        ssntin: null,
	        party_name: null
	      }
	    },
	    caseLookupSearchReducer: caseLookupInitState,
	    user: preloadedState.user
	  };
	
	  if (preloadedState && preloadedState.immediateSearch) {
	    if (!_lodash2.default.isEmpty(preloadedState.immediateSearch.date_filed_from)) {
	      state.pacerSearchResults.filters.filed_from = (0, _moment2.default)(preloadedState.immediateSearch.date_filed_from, 'MM/DD/YYYY');
	    }
	    if (!_lodash2.default.isEmpty(preloadedState.immediateSearch.date_filed_to)) {
	      state.pacerSearchResults.filters.filed_to = (0, _moment2.default)(preloadedState.immediateSearch.date_filed_to, 'MM/DD/YYYY');
	    }
	    if (!_lodash2.default.isEmpty(preloadedState.immediateSearch.party_title)) {
	      state.pacerSearchResults.filters.case_title = preloadedState.immediateSearch.party_title;
	    }
	    if (!_lodash2.default.isEmpty(preloadedState.immediateSearch.case_no)) {
	      state.pacerSearchResults.filters.case_no = preloadedState.immediateSearch.case_no;
	    }
	    if (!_lodash2.default.isEmpty(preloadedState.immediateSearch.search_type)) {
	      state.user = {
	        settings: {
	          pacer_search_default_case_type: preloadedState.immediateSearch.search_type.charAt(0).toUpperCase() + preloadedState.immediateSearch.search_type.slice(1)
	        }
	      };
	    }
	  }
	
	  // eslint-disable-next-line no-console
	  console.log('Hydrated State:', state);
	  return _immutable2.default.fromJS(state);
	}

/***/ },
/* 103 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 104 */
/***/ function(module, exports) {

	/*
	 * classList.js: Cross-browser full element.classList implementation.
	 * 2014-07-23
	 *
	 * By Eli Grey, http://eligrey.com
	 * Public Domain.
	 * NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
	 */
	
	/*global self, document, DOMException */
	
	/*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js*/
	
	/* Copied from MDN:
	 * https://developer.mozilla.org/en-US/docs/Web/API/Element/classList
	 */
	
	if ("document" in window.self) {
	
	  // Full polyfill for browsers with no classList support
	  // Including IE < Edge missing SVGElement.classList
	  if (!("classList" in document.createElement("_"))
	    || document.createElementNS && !("classList" in document.createElementNS("http://www.w3.org/2000/svg","g"))) {
	
	  (function (view) {
	
	    "use strict";
	
	    if (!('Element' in view)) return;
	
	    var
	        classListProp = "classList"
	      , protoProp = "prototype"
	      , elemCtrProto = view.Element[protoProp]
	      , objCtr = Object
	      , strTrim = String[protoProp].trim || function () {
	        return this.replace(/^\s+|\s+$/g, "");
	      }
	      , arrIndexOf = Array[protoProp].indexOf || function (item) {
	        var
	            i = 0
	          , len = this.length
	        ;
	        for (; i < len; i++) {
	          if (i in this && this[i] === item) {
	            return i;
	          }
	        }
	        return -1;
	      }
	      // Vendors: please allow content code to instantiate DOMExceptions
	      , DOMEx = function (type, message) {
	        this.name = type;
	        this.code = DOMException[type];
	        this.message = message;
	      }
	      , checkTokenAndGetIndex = function (classList, token) {
	        if (token === "") {
	          throw new DOMEx(
	              "SYNTAX_ERR"
	            , "An invalid or illegal string was specified"
	          );
	        }
	        if (/\s/.test(token)) {
	          throw new DOMEx(
	              "INVALID_CHARACTER_ERR"
	            , "String contains an invalid character"
	          );
	        }
	        return arrIndexOf.call(classList, token);
	      }
	      , ClassList = function (elem) {
	        var
	            trimmedClasses = strTrim.call(elem.getAttribute("class") || "")
	          , classes = trimmedClasses ? trimmedClasses.split(/\s+/) : []
	          , i = 0
	          , len = classes.length
	        ;
	        for (; i < len; i++) {
	          this.push(classes[i]);
	        }
	        this._updateClassName = function () {
	          elem.setAttribute("class", this.toString());
	        };
	      }
	      , classListProto = ClassList[protoProp] = []
	      , classListGetter = function () {
	        return new ClassList(this);
	      }
	    ;
	    // Most DOMException implementations don't allow calling DOMException's toString()
	    // on non-DOMExceptions. Error's toString() is sufficient here.
	    DOMEx[protoProp] = Error[protoProp];
	    classListProto.item = function (i) {
	      return this[i] || null;
	    };
	    classListProto.contains = function (token) {
	      token += "";
	      return checkTokenAndGetIndex(this, token) !== -1;
	    };
	    classListProto.add = function () {
	      var
	          tokens = arguments
	        , i = 0
	        , l = tokens.length
	        , token
	        , updated = false
	      ;
	      do {
	        token = tokens[i] + "";
	        if (checkTokenAndGetIndex(this, token) === -1) {
	          this.push(token);
	          updated = true;
	        }
	      }
	      while (++i < l);
	
	      if (updated) {
	        this._updateClassName();
	      }
	    };
	    classListProto.remove = function () {
	      var
	          tokens = arguments
	        , i = 0
	        , l = tokens.length
	        , token
	        , updated = false
	        , index
	      ;
	      do {
	        token = tokens[i] + "";
	        index = checkTokenAndGetIndex(this, token);
	        while (index !== -1) {
	          this.splice(index, 1);
	          updated = true;
	          index = checkTokenAndGetIndex(this, token);
	        }
	      }
	      while (++i < l);
	
	      if (updated) {
	        this._updateClassName();
	      }
	    };
	    classListProto.toggle = function (token, force) {
	      token += "";
	
	      var
	          result = this.contains(token)
	        , method = result ?
	          force !== true && "remove"
	        :
	          force !== false && "add"
	      ;
	
	      if (method) {
	        this[method](token);
	      }
	
	      if (force === true || force === false) {
	        return force;
	      } else {
	        return !result;
	      }
	    };
	    classListProto.toString = function () {
	      return this.join(" ");
	    };
	
	    if (objCtr.defineProperty) {
	      var classListPropDesc = {
	          get: classListGetter
	        , enumerable: true
	        , configurable: true
	      };
	      try {
	        objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
	      } catch (ex) { // IE 8 doesn't support enumerable:true
	        if (ex.number === -0x7FF5EC54) {
	          classListPropDesc.enumerable = false;
	          objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
	        }
	      }
	    } else if (objCtr[protoProp].__defineGetter__) {
	      elemCtrProto.__defineGetter__(classListProp, classListGetter);
	    }
	
	    }(window.self));
	
	    } else {
	    // There is full or partial native classList support, so just check if we need
	    // to normalize the add/remove and toggle APIs.
	
	    (function () {
	      "use strict";
	
	      var testElement = document.createElement("_");
	
	      testElement.classList.add("c1", "c2");
	
	      // Polyfill for IE 10/11 and Firefox <26, where classList.add and
	      // classList.remove exist but support only one argument at a time.
	      if (!testElement.classList.contains("c2")) {
	        var createMethod = function(method) {
	          var original = DOMTokenList.prototype[method];
	
	          DOMTokenList.prototype[method] = function(token) {
	            var i, len = arguments.length;
	
	            for (i = 0; i < len; i++) {
	              token = arguments[i];
	              original.call(this, token);
	            }
	          };
	        };
	        createMethod('add');
	        createMethod('remove');
	      }
	
	      testElement.classList.toggle("c3", false);
	
	      // Polyfill for IE 10 and Firefox <24, where classList.toggle does not
	      // support the second argument.
	      if (testElement.classList.contains("c3")) {
	        var _toggle = DOMTokenList.prototype.toggle;
	
	        DOMTokenList.prototype.toggle = function(token, force) {
	          if (1 in arguments && !this.contains(token) === !force) {
	            return force;
	          } else {
	            return _toggle.call(this, token);
	          }
	        };
	
	      }
	
	      testElement = null;
	    }());
	  }
	}


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _stripIndentTransformer = __webpack_require__(1311);
	
	var _stripIndentTransformer2 = _interopRequireDefault(_stripIndentTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _stripIndentTransformer2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdHJpcEluZGVudFRyYW5zZm9ybWVyL2luZGV4LmpzIl0sIm5hbWVzIjpbImRlZmF1bHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7UUFBT0EsTyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZyb20gJy4vc3RyaXBJbmRlbnRUcmFuc2Zvcm1lcic7XG4iXX0=

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(806);
	var $export = __webpack_require__(3);
	var shared = __webpack_require__(222)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(810))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(38)) {
	  var LIBRARY = __webpack_require__(121);
	  var global = __webpack_require__(25);
	  var fails = __webpack_require__(27);
	  var $export = __webpack_require__(3);
	  var $typed = __webpack_require__(298);
	  var $buffer = __webpack_require__(476);
	  var ctx = __webpack_require__(86);
	  var anInstance = __webpack_require__(143);
	  var propertyDesc = __webpack_require__(148);
	  var hide = __webpack_require__(65);
	  var redefineAll = __webpack_require__(149);
	  var toInteger = __webpack_require__(88);
	  var toLength = __webpack_require__(37);
	  var toIndex = __webpack_require__(804);
	  var toAbsoluteIndex = __webpack_require__(151);
	  var toPrimitive = __webpack_require__(99);
	  var has = __webpack_require__(74);
	  var classof = __webpack_require__(183);
	  var isObject = __webpack_require__(29);
	  var toObject = __webpack_require__(43);
	  var isArrayIter = __webpack_require__(462);
	  var create = __webpack_require__(145);
	  var getPrototypeOf = __webpack_require__(76);
	  var gOPN = __webpack_require__(146).f;
	  var getIterFn = __webpack_require__(478);
	  var uid = __webpack_require__(152);
	  var wks = __webpack_require__(36);
	  var createArrayMethod = __webpack_require__(96);
	  var createArrayIncludes = __webpack_require__(286);
	  var speciesConstructor = __webpack_require__(223);
	  var ArrayIterators = __webpack_require__(479);
	  var Iterators = __webpack_require__(184);
	  var $iterDetect = __webpack_require__(291);
	  var setSpecies = __webpack_require__(150);
	  var arrayFill = __webpack_require__(454);
	  var arrayCopyWithin = __webpack_require__(776);
	  var $DP = __webpack_require__(41);
	  var $GOPD = __webpack_require__(75);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResultsPaginator = function (_Component) {
	  _inherits(ResultsPaginator, _Component);
	
	  function ResultsPaginator(props) {
	    _classCallCheck(this, ResultsPaginator);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  ResultsPaginator.prototype.render = function render() {
	    var _props = this.props,
	        totalPages = _props.totalPages,
	        selectedPage = _props.selectedPage,
	        onChangePage = _props.onChangePage;
	
	
	    var numPages = Math.ceil(totalPages || 0);
	    var pageRange = (0, _lodash.range)(numPages);
	    var nextPage = selectedPage + 1;
	    var prevPage = selectedPage - 1;
	    var lastPage = pageRange[pageRange.length - 1] + 1;
	
	    var max = 6;
	
	    var pageIconCount = numPages <= max ? numPages : max;
	
	    var paginatorItems = (0, _lodash.range)(pageIconCount);
	
	    if (selectedPage < max) {
	      // take 1-9 + numPages
	      paginatorItems = paginatorItems.map(function (el, idx) {
	        if (idx === paginatorItems.length - 1) {
	          return numPages;
	        }
	        return idx + 1;
	      });
	    } else if (selectedPage >= numPages - (max + 2)) {
	      // 1 + take currPage - max   (ex: 14)
	      // 1 + take curr Page - max  (ex 10) with 12
	      paginatorItems = paginatorItems.map(function (el, idx) {
	        if (idx === paginatorItems.length - 1) {
	          return 1;
	        }
	        return numPages - idx;
	      }).reverse();
	    } else {
	      // ex case 13
	      // 1.. (1-4 range) currPage (1-4 range)..max
	      // 1,...  9, 10, 11, 12, 13, 14, 15, 16, 17, ..22
	      paginatorItems = paginatorItems.map(function (el, idx) {
	        if (idx === 0) {
	          return 1;
	        }
	        if (idx === paginatorItems.length - 1) {
	          return numPages;
	        }
	        return selectedPage + idx - 3;
	      });
	    }
	
	    paginatorItems = paginatorItems.reduce(function (accum, el, idx) {
	      var key = 'paginator-item' + idx;
	      var item = { page: el, active: selectedPage === el };
	      var clsName = item.active ? 'active item' : 'item';
	
	      if (idx !== 0 && paginatorItems[idx - 1] !== paginatorItems[idx] - 1) {
	        return accum.concat([_react2.default.createElement(
	          'span',
	          {
	            className: 'item',
	            key: key + '-ellipse',
	            title: 'Go to a specific page',
	            onClick: function onClick() {
	              var extraMessage = '';
	              var newPage = selectedPage;
	              do {
	                newPage = prompt(extraMessage + 'Goto which page (1 - ' + lastPage + ')?', newPage);
	                // on cancel, just quit
	                if (!newPage) return;
	
	                if (isNaN(newPage)) extraMessage = '\'' + newPage + '\' is not a number!\n\n';else if (newPage > lastPage) extraMessage = 'Page ' + newPage + ' does not exist!\n\n';else extraMessage = '';
	              } while (extraMessage);
	              onChangePage(newPage - 1);
	            }
	          },
	          '...'
	        ), _react2.default.createElement(
	          'span',
	          {
	            key: key,
	            className: clsName,
	            onClick: function onClick() {
	              onChangePage(el - 1);
	            } },
	          el
	        )]);
	      }
	      return accum.concat([_react2.default.createElement(
	        'span',
	        {
	          key: key,
	          className: clsName,
	          onClick: function onClick() {
	            onChangePage(el - 1);
	          } },
	        el
	      )]);
	    }, []);
	
	    var paginator = paginatorItems;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'docket docket-pagination', style: { textAlign: 'center' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'ui small borderless menu', id: 'docket-toolbar' },
	        _react2.default.createElement(
	          'div',
	          { className: 'item ' + (selectedPage === 1 ? 'disabled' : ''),
	            title: 'Go to previous page',
	            onClick: function onClick() {
	              if (selectedPage !== 1) {
	                onChangePage(prevPage - 1);
	              }
	            } },
	          '\u2190'
	        ),
	        paginator,
	        _react2.default.createElement(
	          'div',
	          { className: 'item ' + (selectedPage === lastPage ? 'disabled' : ''),
	            title: 'Go to next page',
	            onClick: function onClick() {
	              if (selectedPage !== lastPage) {
	                onChangePage(selectedPage);
	              }
	            } },
	          '\u2192'
	        )
	      )
	    );
	  };
	
	  return ResultsPaginator;
	}(_react.Component);
	
	ResultsPaginator.propTypes = {
	  totalPages: _propTypes2.default.number.isRequired,
	  selectedPage: _propTypes2.default.number.isRequired,
	  onChangePage: _propTypes2.default.func.isRequired
	};
	
	exports.default = ResultsPaginator;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ProgressBar = __webpack_require__(266);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	var _FileLinkMessage = __webpack_require__(393);
	
	var _FileLinkMessage2 = _interopRequireDefault(_FileLinkMessage);
	
	var _ClientCode = __webpack_require__(247);
	
	var _ClientCode2 = _interopRequireDefault(_ClientCode);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DocketDetailsPurchaseForm = function (_Component) {
	  _inherits(DocketDetailsPurchaseForm, _Component);
	
	  function DocketDetailsPurchaseForm() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DocketDetailsPurchaseForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderProgress = function (percentage) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_ProgressBar2.default, { percentage: percentage || 5, show: true })
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  DocketDetailsPurchaseForm.prototype.render = function render() {
	    var docketParts = this.props.docketParts;
	    var partsToPurchase = docketParts.partsToPurchase,
	        totalCost = docketParts.totalCost,
	        totalParts = docketParts.totalParts,
	        percentage = docketParts.percentage,
	        errors = docketParts.errors,
	        step = docketParts.step,
	        status = docketParts.status,
	        purchased = docketParts.purchased,
	        alreadyPurchased = docketParts.alreadyPurchased,
	        link = docketParts.link;
	
	
	    var step2 = null;
	
	    if (step === 2 || step === 3) {
	      step2 = alreadyPurchased ? _react2.default.createElement(
	        'div',
	        null,
	        'Already Purchased '
	      ) : _react2.default.createElement(
	        'div',
	        null,
	        step === 2 && status !== 'done' && this.renderProgress(percentage)
	      );
	    }
	
	    var partsOrLoading = (step === 1 || step === 0) && status === 'loading' ? this.renderProgress(percentage) : _react2.default.createElement(
	      'div',
	      { id: 'progress1', className: 'batch-processed' },
	      'Need to purchase ',
	      partsToPurchase,
	      ' / ',
	      totalParts,
	      ' PDFs from PACER.',
	      step === 1 && partsToPurchase > 0 && _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_ClientCode2.default, {
	            initialClientCode: '',
	            isClientCodeLocked: _lodash2.default.get(window, 'Drupal.settings.isClientCodeLocked'),
	            className: 'purchase-popup', ignoreClientCodeAutosetMsg: true
	          })
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'form-submit green next buy-btn', onClick: this.props.buy },
	          'Buy $',
	          (totalCost || 0).toFixed(2)
	        )
	      )
	    );
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'inner-text' },
	      this.props.showXfaWarning && _react2.default.createElement(
	        'div',
	        { className: 'warning' },
	        'PDF combining currently does not support XFA documents.'
	      ),
	
	      // if there are any errors, show them.
	      errors && _react2.default.createElement(
	        'div',
	        { className: 'error' },
	        errors.map(function (error) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            error,
	            _react2.default.createElement('br', null)
	          );
	        })
	      ),
	      _react2.default.createElement(
	        'ol',
	        null,
	        _react2.default.createElement(
	          'li',
	          { className: '' },
	          'Checking price of all dockets',
	          partsOrLoading
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: step === 1 ? 'pending' : '' },
	          'Purchasing dockets',
	          step2,
	          purchased > 0 && _react2.default.createElement(
	            'div',
	            null,
	            'Purchased ',
	            purchased,
	            ' PDFs'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: step === 3 ? '' : this.props.hidePendingSteps ? 'hide' : 'pending' },
	          'Combining',
	          step === 3 && status !== 'done' && this.renderProgress(percentage),
	          link && _react2.default.createElement(_FileLinkMessage2.default, { link: link })
	        )
	      )
	    );
	  };
	
	  return DocketDetailsPurchaseForm;
	}(_react.Component);
	
	DocketDetailsPurchaseForm.defaultProps = {
	  showXfaWarning: false
	};
	
	DocketDetailsPurchaseForm.propTypes = {
	  docketParts: _propTypes2.default.object.isRequired,
	  buy: _propTypes2.default.func.isRequired,
	  showXfaWarning: _propTypes2.default.bool,
	  hidePendingSteps: _propTypes2.default.bool
	};
	
	exports.default = DocketDetailsPurchaseForm;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(2190);
	
	var _menuCollapsed = __webpack_require__(2232);
	
	var _menuCollapsed2 = _interopRequireDefault(_menuCollapsed);
	
	var _menuExpanded = __webpack_require__(2233);
	
	var _menuExpanded2 = _interopRequireDefault(_menuExpanded);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Collapsible = function (_Component) {
	  _inherits(Collapsible, _Component);
	
	  function Collapsible(props) {
	    _classCallCheck(this, Collapsible);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.toggleCollapsed = function () {
	      var collapsed = { isCollapsed: !_this.state.isCollapsed };
	
	      _this.setState(collapsed, function () {
	        if (_this.props.onChange) {
	          _this.props.onChange(collapsed);
	        }
	      });
	    };
	
	    _this.state = {
	      isCollapsed: props.initCollapsed
	    };
	    return _this;
	  }
	
	  Collapsible.prototype.render = function render() {
	    var arrowImg = this.state.isCollapsed ? _menuCollapsed2.default : _menuExpanded2.default;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'date-filters collapsible' },
	      _react2.default.createElement('img', { src: arrowImg, className: 'collapsed-triangle-icon' }),
	      _react2.default.createElement('p', { className: 'date-filter-p',
	        onClick: this.toggleCollapsed,
	        dangerouslySetInnerHTML: { __html: this.props.title } }),
	      _react2.default.createElement(
	        'div',
	        { className: this.state.isCollapsed ? 'hide' : '' },
	        this.props.children
	      )
	    );
	  };
	
	  return Collapsible;
	}(_react.Component);
	
	Collapsible.propTypes = {
	  initCollapsed: _propTypes2.default.bool,
	  onChange: _propTypes2.default.func,
	  children: _propTypes2.default.node.isRequired
	};
	
	Collapsible.defaultProps = {
	  initCollapsed: true,
	  onChange: function onChange() {}
	};
	
	exports.default = Collapsible;

/***/ },
/* 111 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	// AUTOGENERATED, DO NOT EDIT DIRECTLY. RUN generate_court_data.pl to update
	exports.default = [{
	   "circuit": "01",
	   "citation": "1stBapCir.",
	   "code": "01bap",
	   "is_test": false,
	   "name": "U.S. Bankruptcy Appellate Panel - First Circuit",
	   "pcl_api_court_code": "01bap",
	   "region_code": "01",
	   "subdomain": "ecf.ca1.uscourts.gov",
	   "timezone": "America/New_York",
	   "type": "appellate"
	}, {
	   "circuit": "01",
	   "citation": "1stBapCir.TEST.",
	   "code": "01baptest",
	   "is_test": true,
	   "name": "U.S. Test Bankruptcy Appellate Panel - First Circuit",
	   "pcl_api_court_code": null,
	   "region_code": "01",
	   "subdomain": "ecf-test.ca1.uscourts.gov",
	   "timezone": "America/New_York",
	   "type": "appellate"
	}, {
	   "circuit": "01",
	   "citation": "1stCir.",
	   "code": "01cae",
	   "is_test": false,
	   "name": "U.S. Court of Appeals - First Circuit",
	   "pcl_api_court_code": "01ca",
	   "region_code": "01",
	   "subdomain": "ecf.ca1.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "appellate"
	}, {
	   "circuit": "01",
	   "citation": "1stCir.TEST.",
	   "code": "01caetest",
	   "is_test": true,
	   "name": "U.S. Court of Appeals - First Circuit (test)",
	   "pcl_api_court_code": null,
	   "region_code": "01",
	   "subdomain": "ecf-test.ca1.uscourts.gov",
	   "timezone": "America/New_York",
	   "type": "appellate"
	}, {
	   "circuit": "02",
	   "citation": "2ndCir.",
	   "code": "02cae",
	   "is_test": false,
	   "name": "U.S. Court of Appeals - Second Circuit",
	   "pcl_api_court_code": "02ca",
	   "region_code": "02",
	   "subdomain": "ecf.ca2.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "appellate"
	}, {
	   "circuit": "02",
	   "citation": "2ndCir.TEST.",
	   "code": "02caetest",
	   "is_test": true,
	   "name": "U.S. Court of Appeals - Second Circuit (test)",
	   "pcl_api_court_code": null,
	   "region_code": "02",
	   "subdomain": "ecf-test.ca2.uscourts.gov",
	   "timezone": "America/New_York",
	   "type": "appellate"
	}, {
	   "circuit": "03",
	   "citation": "3rdCir.",
	   "code": "03cae",
	   "is_test": false,
	   "name": "U.S. Court of Appeals - Third Circuit",
	   "pcl_api_court_code": "03ca",
	   "region_code": "03",
	   "subdomain": "ecf.ca3.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "appellate"
	}, {
	   "circuit": "03",
	   "citation": "3rdCir.TEST.",
	   "code": "03caetest",
	   "is_test": true,
	   "name": "U.S. Court of Appeals - Third Circuit (test)",
	   "pcl_api_court_code": null,
	   "region_code": "03",
	   "subdomain": "ecf-test.ca3.uscourts.gov",
	   "timezone": "America/New_York",
	   "type": "appellate"
	}, {
	   "circuit": "03",
	   "citation": "3rdCir.TRAIN.",
	   "code": "03caetrain",
	   "is_test": true,
	   "name": "U.S. Court of Appeals - Third Circuit (train)",
	   "pcl_api_court_code": null,
	   "region_code": "03",
	   "subdomain": "ecf-train.ca3.uscourts.gov",
	   "timezone": "America/New_York",
	   "type": "appellate"
	}, {
	   "circuit": "04",
	   "citation": "4thCir.",
	   "code": "04cae",
	   "is_test": false,
	   "name": "U.S. Court of Appeals - Fourth Circuit",
	   "pcl_api_court_code": "04ca",
	   "region_code": "04",
	   "subdomain": "ecf.ca4.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "appellate"
	}, {
	   "circuit": "04",
	   "citation": "4thCir.TEST.",
	   "code": "04caetest",
	   "is_test": true,
	   "name": "U.S. Court of Appeals - Fourth Circuit (test)",
	   "pcl_api_court_code": null,
	   "region_code": "04",
	   "subdomain": "ecf-test.ca4.uscourts.gov",
	   "timezone": "America/New_York",
	   "type": "appellate"
	}, {
	   "circuit": "05",
	   "citation": "5thCir.",
	   "code": "05cae",
	   "is_test": false,
	   "name": "U.S. Court of Appeals - Fifth Circuit",
	   "pcl_api_court_code": "05ca",
	   "region_code": "05",
	   "subdomain": "ecf.ca5.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "appellate"
	}, {
	   "circuit": "05",
	   "citation": "5thCir.TEST.",
	   "code": "05caetest",
	   "is_test": true,
	   "name": "U.S. Court of Appeals - Fifth Circuit (test)",
	   "pcl_api_court_code": null,
	   "region_code": "05",
	   "subdomain": "ecf-test.ca5.uscourts.gov",
	   "timezone": "America/Chicago",
	   "type": "appellate"
	}, {
	   "circuit": "06",
	   "citation": "6thCir.",
	   "code": "06cae",
	   "is_test": false,
	   "name": "U.S. Court of Appeals - Sixth Circuit",
	   "pcl_api_court_code": "06ca",
	   "region_code": "06",
	   "subdomain": "ecf.ca6.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "appellate"
	}, {
	   "circuit": "06",
	   "citation": "6thCir.TEST.",
	   "code": "06caetest",
	   "is_test": true,
	   "name": "U.S. Court of Appeals - Sixth Circuit (test)",
	   "pcl_api_court_code": null,
	   "region_code": "06",
	   "subdomain": "ecf-test.ca6.uscourts.gov",
	   "timezone": "America/New_York",
	   "type": "appellate"
	}, {
	   "circuit": "06",
	   "citation": "6thCir.TRAIN.",
	   "code": "06caetrain",
	   "is_test": true,
	   "name": "U.S. Court of Appeals - Sixth Circuit (train)",
	   "pcl_api_court_code": null,
	   "region_code": "06",
	   "subdomain": "ecf-train.ca6.uscourts.gov",
	   "timezone": "America/New_York",
	   "type": "appellate"
	}, {
	   "circuit": "07",
	   "citation": "7thCir.",
	   "code": "07cae",
	   "is_test": false,
	   "name": "U.S. Court of Appeals - Seventh Circuit",
	   "pcl_api_court_code": "07ca",
	   "region_code": "07",
	   "subdomain": "ecf.ca7.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "appellate"
	}, {
	   "circuit": "08",
	   "citation": "8thCir.",
	   "code": "08cae",
	   "is_test": false,
	   "name": "U.S. Court of Appeals - Eighth Circuit",
	   "pcl_api_court_code": "08ca",
	   "region_code": "08",
	   "subdomain": "ecf.ca8.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "appellate"
	}, {
	   "circuit": "08",
	   "citation": "8thCir.TRAIN.",
	   "code": "08caetrain",
	   "is_test": true,
	   "name": "U.S. Court of Appeals - Eighth Circuit (train)",
	   "pcl_api_court_code": null,
	   "region_code": "08",
	   "subdomain": "ecf-train.ca8.uscourts.gov",
	   "timezone": "America/Chicago",
	   "type": "appellate"
	}, {
	   "circuit": "09",
	   "citation": "9thBapCir.",
	   "code": "09bap",
	   "is_test": false,
	   "name": "U.S. Bankruptcy Appellate Panel - Ninth Circuit",
	   "pcl_api_court_code": "09bap",
	   "region_code": "09",
	   "subdomain": "ecf.ca9.uscourts.gov",
	   "timezone": "America/Los_Angeles",
	   "type": "appellate"
	}, {
	   "circuit": "09",
	   "citation": "9thBapCir.TEST.",
	   "code": "09baptest",
	   "is_test": true,
	   "name": "U.S. Test Bankruptcy Appellate Panel - Ninth Circuit",
	   "pcl_api_court_code": null,
	   "region_code": "09",
	   "subdomain": "ecf-test.ca9.uscourts.gov",
	   "timezone": "America/Los_Angeles",
	   "type": "appellate"
	}, {
	   "circuit": "09",
	   "citation": "9thBapCir.TRAIN.",
	   "code": "09baptrain",
	   "is_test": true,
	   "name": "U.S. Train Bankruptcy Appellate Panel - Ninth Circuit",
	   "pcl_api_court_code": null,
	   "region_code": "09",
	   "subdomain": "ecf-train.ca9.uscourts.gov",
	   "timezone": "America/Los_Angeles",
	   "type": "appellate"
	}, {
	   "circuit": "09",
	   "citation": "9thCir.",
	   "code": "09cae",
	   "is_test": false,
	   "name": "U.S. Court of Appeals - Ninth Circuit",
	   "pcl_api_court_code": "09ca",
	   "region_code": "09",
	   "subdomain": "ecf.ca9.uscourts.gov",
	   "timezone": "US/Pacific",
	   "type": "appellate"
	}, {
	   "circuit": "09",
	   "citation": "9thCir.TEST.",
	   "code": "09caetest",
	   "is_test": true,
	   "name": "U.S. Court of Appeals - Ninth Circuit (test)",
	   "pcl_api_court_code": null,
	   "region_code": "09",
	   "subdomain": "ecf-test.ca9.uscourts.gov",
	   "timezone": "America/Los_Angeles",
	   "type": "appellate"
	}, {
	   "circuit": "09",
	   "citation": "9thCir.TRAIN.",
	   "code": "09caetrain",
	   "is_test": true,
	   "name": "U.S. Court of Appeals - Ninth Circuit (train)",
	   "pcl_api_court_code": null,
	   "region_code": "09",
	   "subdomain": "ecf-train.ca9.uscourts.gov",
	   "timezone": "America/Los_Angeles",
	   "type": "appellate"
	}, {
	   "circuit": "10",
	   "citation": "10thBapCir.",
	   "code": "10bap",
	   "is_test": false,
	   "name": "U.S. Bankruptcy Appellate Panel - Tenth Circuit",
	   "pcl_api_court_code": "10bap",
	   "region_code": "10",
	   "subdomain": "ecf.ca10.uscourts.gov",
	   "timezone": "America/Denver",
	   "type": "appellate"
	}, {
	   "circuit": "10",
	   "citation": "10thBapCir.TEST.",
	   "code": "10baptest",
	   "is_test": true,
	   "name": "U.S. TEST Bankruptcy Appellate Panel - Tenth Circuit",
	   "pcl_api_court_code": null,
	   "region_code": "10",
	   "subdomain": "ecf-test.ca10.uscourts.gov",
	   "timezone": "America/Denver",
	   "type": "appellate"
	}, {
	   "circuit": "10",
	   "citation": "10thBapCir.TRAIN.",
	   "code": "10baptrain",
	   "is_test": true,
	   "name": "U.S. Train Bankruptcy Appellate Panel - Tenth Circuit",
	   "pcl_api_court_code": null,
	   "region_code": "10",
	   "subdomain": "ecf-train.ca10.uscourts.gov",
	   "timezone": "America/Denver",
	   "type": "appellate"
	}, {
	   "circuit": "10",
	   "citation": "10thCir.",
	   "code": "10cae",
	   "is_test": false,
	   "name": "U.S. Court of Appeals - Tenth Circuit",
	   "pcl_api_court_code": "10ca",
	   "region_code": "10",
	   "subdomain": "ecf.ca10.uscourts.gov",
	   "timezone": "US/Mountain",
	   "type": "appellate"
	}, {
	   "circuit": "10",
	   "citation": "10thCir.TEST.",
	   "code": "10caetest",
	   "is_test": true,
	   "name": "U.S. Court of Appeals - Tenth Circuit (test)",
	   "pcl_api_court_code": null,
	   "region_code": "10",
	   "subdomain": "ecf-test.ca10.uscourts.gov",
	   "timezone": "America/Denver",
	   "type": "appellate"
	}, {
	   "circuit": "10",
	   "citation": "10thCir.TRAIN.",
	   "code": "10caetrain",
	   "is_test": true,
	   "name": "U.S. Court of Appeals - Tenth Circuit (train)",
	   "pcl_api_court_code": null,
	   "region_code": "10",
	   "subdomain": "ecf-train.ca10.uscourts.gov",
	   "timezone": "America/Denver",
	   "type": "appellate"
	}, {
	   "circuit": "11",
	   "citation": "11thCir.",
	   "code": "11cae",
	   "is_test": false,
	   "name": "U.S. Court of Appeals - Eleventh Circuit",
	   "pcl_api_court_code": "11ca",
	   "region_code": "11",
	   "subdomain": "ecf.ca11.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "appellate"
	}, {
	   "circuit": null,
	   "citation": "FedCir.",
	   "code": "cafc",
	   "is_test": false,
	   "name": "U.S. Court of Appeals - Federal Circuit",
	   "pcl_api_court_code": "cafc",
	   "region_code": "cafc",
	   "subdomain": "ecf.cafc.uscourts.gov",
	   "timezone": "America/New_York",
	   "type": "appellate"
	}, {
	   "circuit": "dc",
	   "citation": "D.C.Cir.",
	   "code": "dccae",
	   "is_test": false,
	   "name": "U.S. Court of Appeals - District of Columbia Circuit",
	   "pcl_api_court_code": "dcca",
	   "region_code": "dc",
	   "subdomain": "ecf.cadc.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "appellate"
	}, {
	   "circuit": "09",
	   "citation": "Bankr.D.Alaska",
	   "code": "akbke",
	   "is_test": false,
	   "name": "Alaska Bankruptcy Court",
	   "pcl_api_court_code": "akbk",
	   "region_code": "ak",
	   "subdomain": "ecf.akb.uscourts.gov",
	   "timezone": "US/Alaska",
	   "type": "bankruptcy"
	}, {
	   "circuit": "09",
	   "citation": "Bankr.D.Alaska.TEST.",
	   "code": "akbtest",
	   "is_test": true,
	   "name": "Alaska TEST Bankruptcy Court",
	   "pcl_api_court_code": null,
	   "region_code": "ak",
	   "subdomain": "ecf-test.akb.uscourts.gov",
	   "timezone": "America/Anchorage",
	   "type": "bankruptcy"
	}, {
	   "circuit": "09",
	   "citation": "Bankr.D.Alaska.TRAIN.",
	   "code": "akbtrain",
	   "is_test": true,
	   "name": "Alaska TRAIN Bankruptcy Court",
	   "pcl_api_court_code": null,
	   "region_code": "ak",
	   "subdomain": "ecf-train.akb.uscourts.gov",
	   "timezone": "America/Anchorage",
	   "type": "bankruptcy"
	}, {
	   "circuit": "11",
	   "citation": "Bankr.M.D.Ala.",
	   "code": "almbke",
	   "is_test": false,
	   "name": "Alabama Middle Bankruptcy Court",
	   "pcl_api_court_code": "almbk",
	   "region_code": "alm",
	   "subdomain": "ecf.almb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "11",
	   "citation": "Bankr.N.D.Ala.",
	   "code": "alnbke",
	   "is_test": false,
	   "name": "Alabama Northern Bankruptcy Court",
	   "pcl_api_court_code": "alnbk",
	   "region_code": "aln",
	   "subdomain": "ecf.alnb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": null,
	   "citation": "Bankr.N.D.Ala.TEST.",
	   "code": "alnbtest",
	   "is_test": true,
	   "name": "Alabama Northern TEST Bankruptcy Court",
	   "pcl_api_court_code": null,
	   "region_code": "aln",
	   "subdomain": "ecf-test.alnb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": null,
	   "citation": "Bankr.N.D.Ala.TRAIN.",
	   "code": "alnbtrain",
	   "is_test": true,
	   "name": "Alabama Northern TRAIN Bankruptcy Court",
	   "pcl_api_court_code": null,
	   "region_code": "aln",
	   "subdomain": "ecf-train.alnb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "11",
	   "citation": "Bankr.S.D.Ala.",
	   "code": "alsbke",
	   "is_test": false,
	   "name": "Alabama Southern Bankruptcy Court",
	   "pcl_api_court_code": "alsbk",
	   "region_code": "als",
	   "subdomain": "ecf.alsb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "08",
	   "citation": "Bankr.E.D.Ark.",
	   "code": "arebke",
	   "is_test": false,
	   "name": "Arkansas Eastern Bankruptcy Court",
	   "pcl_api_court_code": "arebk",
	   "region_code": "are",
	   "subdomain": "ecf.areb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "08",
	   "citation": "Bankr.W.D.Ark.",
	   "code": "arwbke",
	   "is_test": false,
	   "name": "Arkansas Western Bankruptcy Court",
	   "pcl_api_court_code": "arwbk",
	   "region_code": "arw",
	   "subdomain": "ecf.arwb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "09",
	   "citation": "Bankr.D.Ariz.",
	   "code": "azbke",
	   "is_test": false,
	   "name": "Arizona Bankruptcy Court",
	   "pcl_api_court_code": "azbk",
	   "region_code": "az",
	   "subdomain": "ecf.azb.uscourts.gov",
	   "timezone": "US/Arizona",
	   "type": "bankruptcy"
	}, {
	   "circuit": "09",
	   "citation": "Bankr.D.Ariz.TEST",
	   "code": "azbtest",
	   "is_test": true,
	   "name": "Arizona TEST Bankruptcy Court",
	   "pcl_api_court_code": null,
	   "region_code": "az",
	   "subdomain": "ecf-test.azb.uscourts.gov",
	   "timezone": "US/Arizona",
	   "type": "bankruptcy"
	}, {
	   "circuit": null,
	   "citation": "Bankr.D.Ariz.TRAIN",
	   "code": "azbtrain",
	   "is_test": true,
	   "name": "Arizona TRAIN Bankruptcy Court",
	   "pcl_api_court_code": null,
	   "region_code": "az",
	   "subdomain": "ecf-train.azb.uscourts.gov",
	   "timezone": "US/Mountain",
	   "type": "bankruptcy"
	}, {
	   "circuit": "09",
	   "citation": "Bankr.C.D.Cal.",
	   "code": "cacbke",
	   "is_test": false,
	   "name": "California Central Bankruptcy Court",
	   "pcl_api_court_code": "cacbk",
	   "region_code": "cac",
	   "subdomain": "ecf.cacb.uscourts.gov",
	   "timezone": "US/Pacific",
	   "type": "bankruptcy"
	}, {
	   "circuit": "09",
	   "citation": "Bankr.E.D.Cal.",
	   "code": "caebke",
	   "is_test": false,
	   "name": "California Eastern Bankruptcy Court",
	   "pcl_api_court_code": "caebk",
	   "region_code": "cae",
	   "subdomain": "ecf.caeb.uscourts.gov",
	   "timezone": "US/Pacific",
	   "type": "bankruptcy"
	}, {
	   "circuit": "09",
	   "citation": "Bankr.N.D.Cal.",
	   "code": "canbke",
	   "is_test": false,
	   "name": "California Northern Bankruptcy Court",
	   "pcl_api_court_code": "canbk",
	   "region_code": "can",
	   "subdomain": "ecf.canb.uscourts.gov",
	   "timezone": "US/Pacific",
	   "type": "bankruptcy"
	}, {
	   "circuit": "09",
	   "citation": "Bankr.S.D.Cal.",
	   "code": "casbke",
	   "is_test": false,
	   "name": "California Southern Bankruptcy Court",
	   "pcl_api_court_code": "casbk",
	   "region_code": "cas",
	   "subdomain": "ecf.casb.uscourts.gov",
	   "timezone": "US/Pacific",
	   "type": "bankruptcy"
	}, {
	   "circuit": "09",
	   "citation": "Bankr.S.D.Cal.TEST.",
	   "code": "casbtest",
	   "is_test": true,
	   "name": "California Southern TEST Bankruptcy Court",
	   "pcl_api_court_code": null,
	   "region_code": "cas",
	   "subdomain": "ecf-test.casb.uscourts.gov",
	   "timezone": "America/Los_Angeles",
	   "type": "bankruptcy"
	}, {
	   "circuit": "09",
	   "citation": "Bankr.S.D.Cal.TRAIN.",
	   "code": "casbtrain",
	   "is_test": true,
	   "name": "California Southern TRAIN Bankruptcy Court",
	   "pcl_api_court_code": null,
	   "region_code": "cas",
	   "subdomain": "ecf-train.casb.uscourts.gov",
	   "timezone": "America/Los_Angeles",
	   "type": "bankruptcy"
	}, {
	   "circuit": "10",
	   "citation": "Bankr.D.Colo.",
	   "code": "cobke",
	   "is_test": false,
	   "name": "Colorado Bankruptcy Court",
	   "pcl_api_court_code": "cobk",
	   "region_code": "co",
	   "subdomain": "ecf.cob.uscourts.gov",
	   "timezone": "US/Mountain",
	   "type": "bankruptcy"
	}, {
	   "circuit": "02",
	   "citation": "Bankr.D.Conn.",
	   "code": "ctbke",
	   "is_test": false,
	   "name": "Connecticut Bankruptcy Court",
	   "pcl_api_court_code": "ctbk",
	   "region_code": "ct",
	   "subdomain": "ecf.ctb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "dc",
	   "citation": "Bankr.D.D.C.",
	   "code": "dcbke",
	   "is_test": false,
	   "name": "District Of Columbia Bankruptcy Court",
	   "pcl_api_court_code": "dcbk",
	   "region_code": "dc",
	   "subdomain": "ecf.dcb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "03",
	   "citation": "Bankr.D.Del.",
	   "code": "debke",
	   "is_test": false,
	   "name": "Delaware Bankruptcy Court",
	   "pcl_api_court_code": "debk",
	   "region_code": "de",
	   "subdomain": "ecf.deb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "11",
	   "citation": "Bankr.M.D.Fla.",
	   "code": "flmbke",
	   "is_test": false,
	   "name": "Florida Middle Bankruptcy Court",
	   "pcl_api_court_code": "flmbk",
	   "region_code": "flm",
	   "subdomain": "ecf.flmb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "11",
	   "citation": "Bankr.N.D.Fla.",
	   "code": "flnbke",
	   "is_test": false,
	   "name": "Florida Northern Bankruptcy Court",
	   "pcl_api_court_code": "flnbk",
	   "region_code": "fln",
	   "subdomain": "ecf.flnb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "11",
	   "citation": "Bankr.S.D.Fla.",
	   "code": "flsbke",
	   "is_test": false,
	   "name": "Florida Southern Bankruptcy Court",
	   "pcl_api_court_code": "flsbk",
	   "region_code": "fls",
	   "subdomain": "ecf.flsb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": null,
	   "citation": "Bankr.S.D.Fla.TEST.",
	   "code": "flsbtest",
	   "is_test": true,
	   "name": "Florida Southern TEST Bankruptcy Court",
	   "pcl_api_court_code": null,
	   "region_code": "fls",
	   "subdomain": "ecf-test.flsb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "11",
	   "citation": "Bankr.M.D.Ga.",
	   "code": "gambke",
	   "is_test": false,
	   "name": "Georgia Middle Bankruptcy Court",
	   "pcl_api_court_code": "gambk",
	   "region_code": "gam",
	   "subdomain": "ecf.gamb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "11",
	   "citation": "Bankr.N.D.Ga.",
	   "code": "ganbke",
	   "is_test": false,
	   "name": "Georgia Northern Bankruptcy Court",
	   "pcl_api_court_code": "ganbk",
	   "region_code": "gan",
	   "subdomain": "ecf.ganb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "11",
	   "citation": "Bankr.N.D.Ga.TEST",
	   "code": "ganbtrain",
	   "is_test": true,
	   "name": "Georgia Northern TEST Bankruptcy Court",
	   "pcl_api_court_code": null,
	   "region_code": "gan",
	   "subdomain": "ecf-train.ganb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "11",
	   "citation": "Bankr.S.D.Ga.",
	   "code": "gasbke",
	   "is_test": false,
	   "name": "Georgia Southern Bankruptcy Court",
	   "pcl_api_court_code": "gasbk",
	   "region_code": "gas",
	   "subdomain": "ecf.gasb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "09",
	   "citation": "Bankr.D.Guam",
	   "code": "gubke",
	   "is_test": false,
	   "name": "Guam Bankruptcy Court",
	   "pcl_api_court_code": "gubk",
	   "region_code": "gu",
	   "subdomain": "ecf.gub.uscourts.gov",
	   "timezone": "Pacific/Guam",
	   "type": "bankruptcy"
	}, {
	   "circuit": "09",
	   "citation": "Bankr.D.Hawaii",
	   "code": "hibke",
	   "is_test": false,
	   "name": "Hawaii Bankruptcy Court",
	   "pcl_api_court_code": "hibk",
	   "region_code": "hi",
	   "subdomain": "ecf.hib.uscourts.gov",
	   "timezone": "US/Hawaii",
	   "type": "bankruptcy"
	}, {
	   "circuit": "08",
	   "citation": "Bankr.N.D.Iowa",
	   "code": "ianbke",
	   "is_test": false,
	   "name": "Iowa Northern Bankruptcy Court",
	   "pcl_api_court_code": "ianbk",
	   "region_code": "ian",
	   "subdomain": "ecf.ianb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "08",
	   "citation": "Bankr.S.D.Iowa",
	   "code": "iasbke",
	   "is_test": false,
	   "name": "Iowa Southern Bankruptcy Court",
	   "pcl_api_court_code": "iasbk",
	   "region_code": "ias",
	   "subdomain": "ecf.iasb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "09",
	   "citation": "Bankr.D.Idaho",
	   "code": "idbke",
	   "is_test": false,
	   "name": "Idaho Bankruptcy Court",
	   "pcl_api_court_code": "idbk",
	   "region_code": "id",
	   "subdomain": "ecf.idb.uscourts.gov",
	   "timezone": "US/Mountain",
	   "type": "bankruptcy"
	}, {
	   "circuit": "07",
	   "citation": "Bankr.C.D.Ill.",
	   "code": "ilcbke",
	   "is_test": false,
	   "name": "Illinois Central Bankruptcy Court",
	   "pcl_api_court_code": "ilcbk",
	   "region_code": "ilc",
	   "subdomain": "ecf.ilcb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "07",
	   "citation": "Bankr.N.D.Ill.",
	   "code": "ilnbke",
	   "is_test": false,
	   "name": "Illinois Northern Bankruptcy Court",
	   "pcl_api_court_code": "ilnbk",
	   "region_code": "iln",
	   "subdomain": "ecf.ilnb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "07",
	   "citation": "Bankr.S.D.Ill.",
	   "code": "ilsbke",
	   "is_test": false,
	   "name": "Illinois Southern Bankruptcy Court",
	   "pcl_api_court_code": "ilsbk",
	   "region_code": "ils",
	   "subdomain": "ecf.ilsb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "07",
	   "citation": "Bankr.N.D.Ind.",
	   "code": "innbke",
	   "is_test": false,
	   "name": "Indiana Northern Bankruptcy Court",
	   "pcl_api_court_code": "innbk",
	   "region_code": "inn",
	   "subdomain": "ecf.innb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "07",
	   "citation": "Bankr.S.D.Ind.",
	   "code": "insbke",
	   "is_test": false,
	   "name": "Indiana Southern Bankruptcy Court",
	   "pcl_api_court_code": "insbk",
	   "region_code": "ins",
	   "subdomain": "ecf.insb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "10",
	   "citation": "Bankr.D.Kan.",
	   "code": "ksbke",
	   "is_test": false,
	   "name": "Kansas Bankruptcy Court",
	   "pcl_api_court_code": "ksbk",
	   "region_code": "ks",
	   "subdomain": "ecf.ksb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "06",
	   "citation": "Bankr.E.D.Ky.",
	   "code": "kyebke",
	   "is_test": false,
	   "name": "Kentucky Eastern Bankruptcy Court",
	   "pcl_api_court_code": "kyebk",
	   "region_code": "kye",
	   "subdomain": "ecf.kyeb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "06",
	   "citation": "Bankr.W.D.Ky.",
	   "code": "kywbke",
	   "is_test": false,
	   "name": "Kentucky Western Bankruptcy Court",
	   "pcl_api_court_code": "kywbk",
	   "region_code": "kyw",
	   "subdomain": "ecf.kywb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "05",
	   "citation": "Bankr.E.D.La.",
	   "code": "laebke",
	   "is_test": false,
	   "name": "Louisiana Eastern Bankruptcy Court",
	   "pcl_api_court_code": "laebk",
	   "region_code": "lae",
	   "subdomain": "ecf.laeb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "05",
	   "citation": "Bankr.M.D.La.",
	   "code": "lambke",
	   "is_test": false,
	   "name": "Louisiana Middle Bankruptcy Court",
	   "pcl_api_court_code": "lambk",
	   "region_code": "lam",
	   "subdomain": "ecf.lamb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "05",
	   "citation": "Bankr.W.D.La.",
	   "code": "lawbke",
	   "is_test": false,
	   "name": "Louisiana Western Bankruptcy Court",
	   "pcl_api_court_code": "lawbk",
	   "region_code": "law",
	   "subdomain": "ecf.lawb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "01",
	   "citation": "Bankr.D.Mass.",
	   "code": "mabke",
	   "is_test": false,
	   "name": "Massachusetts Bankruptcy Court",
	   "pcl_api_court_code": "mabk",
	   "region_code": "ma",
	   "subdomain": "ecf.mab.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "04",
	   "citation": "Bankr.D.Md.",
	   "code": "mdbke",
	   "is_test": false,
	   "name": "Maryland Bankruptcy Court",
	   "pcl_api_court_code": "mdbk",
	   "region_code": "md",
	   "subdomain": "ecf.mdb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "01",
	   "citation": "Bankr.D.Me.",
	   "code": "mebke",
	   "is_test": false,
	   "name": "Maine Bankruptcy Court",
	   "pcl_api_court_code": "mebk",
	   "region_code": "me",
	   "subdomain": "ecf.meb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "06",
	   "citation": "Bankr.E.D.Mich.",
	   "code": "miebke",
	   "is_test": false,
	   "name": "Michigan Eastern Bankruptcy Court",
	   "pcl_api_court_code": "miebk",
	   "region_code": "mie",
	   "subdomain": "ecf.mieb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "06",
	   "citation": "Bankr.W.D.Mich.",
	   "code": "miwbke",
	   "is_test": false,
	   "name": "Michigan Western Bankruptcy Court",
	   "pcl_api_court_code": "miwbk",
	   "region_code": "miw",
	   "subdomain": "ecf.miwb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "08",
	   "citation": "Bankr.D.Minn.",
	   "code": "mnbke",
	   "is_test": false,
	   "name": "Minnesota Bankruptcy Court",
	   "pcl_api_court_code": "mnbk",
	   "region_code": "mn",
	   "subdomain": "ecf.mnb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "08",
	   "citation": "Bankr.E.D.Mo.",
	   "code": "moebke",
	   "is_test": false,
	   "name": "Missouri Eastern Bankruptcy Court",
	   "pcl_api_court_code": "moebk",
	   "region_code": "moe",
	   "subdomain": "ecf.moeb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "08",
	   "citation": "Bankr.W.D.Mo.",
	   "code": "mowbke",
	   "is_test": false,
	   "name": "Missouri Western Bankruptcy Court",
	   "pcl_api_court_code": "mowbk",
	   "region_code": "mow",
	   "subdomain": "ecf.mowb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "05",
	   "citation": "Bankr.N.D.Miss",
	   "code": "msnbke",
	   "is_test": false,
	   "name": "Mississippi Northern Bankruptcy Court",
	   "pcl_api_court_code": "msnbk",
	   "region_code": "msn",
	   "subdomain": "ecf.msnb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "05",
	   "citation": "Bankr.S.D.Miss.",
	   "code": "mssbke",
	   "is_test": false,
	   "name": "Mississippi Southern Bankruptcy Court",
	   "pcl_api_court_code": "mssbk",
	   "region_code": "mss",
	   "subdomain": "ecf.mssb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "09",
	   "citation": "Bankr.D.Mont.",
	   "code": "mtbke",
	   "is_test": false,
	   "name": "Montana Bankruptcy Court",
	   "pcl_api_court_code": "mtbk",
	   "region_code": "mt",
	   "subdomain": "ecf.mtb.uscourts.gov",
	   "timezone": "US/Mountain",
	   "type": "bankruptcy"
	}, {
	   "circuit": "04",
	   "citation": "Bankr.E.D.N.C.",
	   "code": "ncebke",
	   "is_test": false,
	   "name": "North Carolina Eastern Bankruptcy Court",
	   "pcl_api_court_code": "ncebk",
	   "region_code": "nce",
	   "subdomain": "ecf.nceb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "04",
	   "citation": "Bankr.M.D.N.C.",
	   "code": "ncmbke",
	   "is_test": false,
	   "name": "North Carolina Middle Bankruptcy Court",
	   "pcl_api_court_code": "ncmbk",
	   "region_code": "ncm",
	   "subdomain": "ecf.ncmb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "04",
	   "citation": "Bankr.W.D.N.C.",
	   "code": "ncwbke",
	   "is_test": false,
	   "name": "North Carolina Western Bankruptcy Court",
	   "pcl_api_court_code": "ncwbk",
	   "region_code": "ncw",
	   "subdomain": "ecf.ncwb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "08",
	   "citation": "Bankr.D.N.D.",
	   "code": "ndbke",
	   "is_test": false,
	   "name": "North Dakota Bankruptcy Court",
	   "pcl_api_court_code": "ndbk",
	   "region_code": "nd",
	   "subdomain": "ecf.ndb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "08",
	   "citation": "Bankr.D.Neb.",
	   "code": "nebke",
	   "is_test": false,
	   "name": "Nebraska Bankruptcy Court",
	   "pcl_api_court_code": "nebk",
	   "region_code": "ne",
	   "subdomain": "ecf.neb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "01",
	   "citation": "Bankr.D.N.H.",
	   "code": "nhbke",
	   "is_test": false,
	   "name": "New Hampshire Bankruptcy Court",
	   "pcl_api_court_code": "nhbk",
	   "region_code": "nh",
	   "subdomain": "ecf.nhb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "03",
	   "citation": "Bankr.D.N.J.",
	   "code": "njbke",
	   "is_test": false,
	   "name": "New Jersey Bankruptcy Court",
	   "pcl_api_court_code": "njbk",
	   "region_code": "nj",
	   "subdomain": "ecf.njb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "03",
	   "citation": "Bankr.D.N.J.TEST.",
	   "code": "njbtest",
	   "is_test": true,
	   "name": "New Jersey TEST Bankruptcy Court",
	   "pcl_api_court_code": null,
	   "region_code": "nj",
	   "subdomain": "ecf-test.njb.uscourts.gov",
	   "timezone": "America/New_York",
	   "type": "bankruptcy"
	}, {
	   "circuit": "03",
	   "citation": "Bankr.D.N.J.TRAIN.",
	   "code": "njbtrain",
	   "is_test": true,
	   "name": "New Jersey TRAIN Bankruptcy Court",
	   "pcl_api_court_code": null,
	   "region_code": "nj",
	   "subdomain": "ecf-train.njb.uscourts.gov",
	   "timezone": "America/New_York",
	   "type": "bankruptcy"
	}, {
	   "circuit": "10",
	   "citation": "Bankr.D.N.M.",
	   "code": "nmbke",
	   "is_test": false,
	   "name": "New Mexico Bankruptcy Court",
	   "pcl_api_court_code": "nmbk",
	   "region_code": "nm",
	   "subdomain": "ecf.nmb.uscourts.gov",
	   "timezone": "US/Mountain",
	   "type": "bankruptcy"
	}, {
	   "circuit": "09",
	   "citation": "Bankr.N.M.ISS.",
	   "code": "nmibke",
	   "is_test": false,
	   "name": "Northern Mariana Islands Bankruptcy Court",
	   "pcl_api_court_code": "nmibk",
	   "region_code": "nmi",
	   "subdomain": "ecf.nmib.uscourts.gov",
	   "timezone": "Pacific/Guam",
	   "type": "bankruptcy"
	}, {
	   "circuit": "09",
	   "citation": "Bankr.D.Nev.",
	   "code": "nvbke",
	   "is_test": false,
	   "name": "Nevada Bankruptcy Court",
	   "pcl_api_court_code": "nvbk",
	   "region_code": "nv",
	   "subdomain": "ecf.nvb.uscourts.gov",
	   "timezone": "US/Pacific",
	   "type": "bankruptcy"
	}, {
	   "circuit": "02",
	   "citation": "Bankr.E.D.N.Y.",
	   "code": "nyebke",
	   "is_test": false,
	   "name": "New York Eastern Bankruptcy Court",
	   "pcl_api_court_code": "nyebk",
	   "region_code": "nye",
	   "subdomain": "ecf.nyeb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "02",
	   "citation": "Bankr.N.D.N.Y.",
	   "code": "nynbke",
	   "is_test": false,
	   "name": "New York Northern Bankruptcy Court",
	   "pcl_api_court_code": "nynbk",
	   "region_code": "nyn",
	   "subdomain": "ecf.nynb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "02",
	   "citation": "Bankr.S.D.N.Y.",
	   "code": "nysbke",
	   "is_test": false,
	   "name": "New York Southern Bankruptcy Court",
	   "pcl_api_court_code": "nysbk",
	   "region_code": "nys",
	   "subdomain": "ecf.nysb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": null,
	   "citation": "Bankr.S.D.N.Y.TEST.",
	   "code": "nysbtest",
	   "is_test": true,
	   "name": "New York Southern TEST Bankruptcy Court",
	   "pcl_api_court_code": null,
	   "region_code": "nys",
	   "subdomain": "ecf-test.nysb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": null,
	   "citation": "Bankr.S.D.N.Y.TRAIN.",
	   "code": "nysbtrain",
	   "is_test": true,
	   "name": "New York Southern TRAIN Bankruptcy Court",
	   "pcl_api_court_code": null,
	   "region_code": "nys",
	   "subdomain": "ecf-train.nysb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "02",
	   "citation": "Bankr.W.D.N.Y.",
	   "code": "nywbke",
	   "is_test": false,
	   "name": "New York Western Bankruptcy Court",
	   "pcl_api_court_code": "nywbk",
	   "region_code": "nyw",
	   "subdomain": "ecf.nywb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "06",
	   "citation": "Bankr.N.D.Ohio",
	   "code": "ohnbke",
	   "is_test": false,
	   "name": "Ohio Northern Bankruptcy Court",
	   "pcl_api_court_code": "ohnbk",
	   "region_code": "ohn",
	   "subdomain": "ecf.ohnb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "06",
	   "citation": "Bankr.S.D.Ohio",
	   "code": "ohsbke",
	   "is_test": false,
	   "name": "Ohio Southern Bankruptcy Court",
	   "pcl_api_court_code": "ohsbk",
	   "region_code": "ohs",
	   "subdomain": "ecf.ohsb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "10",
	   "citation": "Bankr.E.D.Okla.",
	   "code": "okebke",
	   "is_test": false,
	   "name": "Oklahoma Eastern Bankruptcy Court",
	   "pcl_api_court_code": "okebk",
	   "region_code": "oke",
	   "subdomain": "ecf.okeb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "10",
	   "citation": "Bankr.N.D.Okla.",
	   "code": "oknbke",
	   "is_test": false,
	   "name": "Oklahoma Northern Bankruptcy Court",
	   "pcl_api_court_code": "oknbk",
	   "region_code": "okn",
	   "subdomain": "ecf.oknb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "10",
	   "citation": "Bankr.W.D.Okla.",
	   "code": "okwbke",
	   "is_test": false,
	   "name": "Oklahoma Western Bankruptcy Court",
	   "pcl_api_court_code": "okwbk",
	   "region_code": "okw",
	   "subdomain": "ecf.okwb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "09",
	   "citation": "Bankr.D.Or.",
	   "code": "orbke",
	   "is_test": false,
	   "name": "Oregon Bankruptcy Court",
	   "pcl_api_court_code": "orbk",
	   "region_code": "or",
	   "subdomain": "ecf.orb.uscourts.gov",
	   "timezone": "US/Pacific",
	   "type": "bankruptcy"
	}, {
	   "circuit": "09",
	   "citation": "Bankr.D.Or.TEST.",
	   "code": "orbtest",
	   "is_test": true,
	   "name": "Oregon TEST Bankruptcy Court",
	   "pcl_api_court_code": null,
	   "region_code": "or",
	   "subdomain": "ecf-test.orb.uscourts.gov",
	   "timezone": "America/Los_Angeles",
	   "type": "bankruptcy"
	}, {
	   "circuit": "09",
	   "citation": "Bankr.D.Or.TRAIN.",
	   "code": "orbtrain",
	   "is_test": true,
	   "name": "Oregon TRAIN Bankruptcy Court",
	   "pcl_api_court_code": null,
	   "region_code": "or",
	   "subdomain": "ecf-train.orb.uscourts.gov",
	   "timezone": "America/Los_Angeles",
	   "type": "bankruptcy"
	}, {
	   "circuit": "03",
	   "citation": "Bankr.E.D.Pa.",
	   "code": "paebke",
	   "is_test": false,
	   "name": "Pennsylvania Eastern Bankruptcy Court",
	   "pcl_api_court_code": "paebk",
	   "region_code": "pae",
	   "subdomain": "ecf.paeb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "03",
	   "citation": "Bankr.M.D.Pa.",
	   "code": "pambke",
	   "is_test": false,
	   "name": "Pennsylvania Middle Bankruptcy Court",
	   "pcl_api_court_code": "pambk",
	   "region_code": "pam",
	   "subdomain": "ecf.pamb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "03",
	   "citation": "Bankr.W.D.Pa.",
	   "code": "pawbke",
	   "is_test": false,
	   "name": "Pennsylvania Western Bankruptcy Court",
	   "pcl_api_court_code": "pawbk",
	   "region_code": "paw",
	   "subdomain": "ecf.pawb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "01",
	   "citation": "Bankr.D.P.R.",
	   "code": "prbke",
	   "is_test": false,
	   "name": "Puerto Rico Bankruptcy Court",
	   "pcl_api_court_code": "prbk",
	   "region_code": "pr",
	   "subdomain": "ecf.prb.uscourts.gov",
	   "timezone": "America/Puerto_Rico",
	   "type": "bankruptcy"
	}, {
	   "circuit": "01",
	   "citation": "Bankr.D.R.I.",
	   "code": "ribke",
	   "is_test": false,
	   "name": "Rhode Island Bankruptcy Court",
	   "pcl_api_court_code": "ribk",
	   "region_code": "ri",
	   "subdomain": "ecf.rib.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "04",
	   "citation": "Bankr.D.S.C.",
	   "code": "scbke",
	   "is_test": false,
	   "name": "South Carolina Bankruptcy Court",
	   "pcl_api_court_code": "scbk",
	   "region_code": "sc",
	   "subdomain": "ecf.scb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": null,
	   "citation": "Bankr.D.S.C.TEST.",
	   "code": "scbtest",
	   "is_test": true,
	   "name": "South Carolina TEST Bankruptcy Court",
	   "pcl_api_court_code": null,
	   "region_code": "sc",
	   "subdomain": "ecf-test.scb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "08",
	   "citation": "Bankr.D.S.D.",
	   "code": "sdbke",
	   "is_test": false,
	   "name": "South Dakota Bankruptcy Court",
	   "pcl_api_court_code": "sdbk",
	   "region_code": "sd",
	   "subdomain": "ecf.sdb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "06",
	   "citation": "Bankr.E.D.Tenn.",
	   "code": "tnebke",
	   "is_test": false,
	   "name": "Tennessee Eastern Bankruptcy Court",
	   "pcl_api_court_code": "tnebk",
	   "region_code": "tne",
	   "subdomain": "ecf.tneb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "06",
	   "citation": "Bankr.M.D.Tenn.",
	   "code": "tnmbke",
	   "is_test": false,
	   "name": "Tennessee Middle Bankruptcy Court",
	   "pcl_api_court_code": "tnmbk",
	   "region_code": "tnm",
	   "subdomain": "ecf.tnmb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "06",
	   "citation": "Bankr.W.D.Tenn.",
	   "code": "tnwbke",
	   "is_test": false,
	   "name": "Tennessee Western Bankruptcy Court",
	   "pcl_api_court_code": "tnwbk",
	   "region_code": "tnw",
	   "subdomain": "ecf.tnwb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "05",
	   "citation": "Bankr.E.D.Tex.",
	   "code": "txebke",
	   "is_test": false,
	   "name": "Texas Eastern Bankruptcy Court",
	   "pcl_api_court_code": "txebk",
	   "region_code": "txe",
	   "subdomain": "ecf.txeb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "05",
	   "citation": "Bankr.N.D.Tex.",
	   "code": "txnbke",
	   "is_test": false,
	   "name": "Texas Northern Bankruptcy Court",
	   "pcl_api_court_code": "txnbk",
	   "region_code": "txn",
	   "subdomain": "ecf.txnb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "05",
	   "citation": "Bankr.S.D.Tex.",
	   "code": "txsbke",
	   "is_test": false,
	   "name": "Texas Southern Bankruptcy Court",
	   "pcl_api_court_code": "txsbk",
	   "region_code": "txs",
	   "subdomain": "ecf.txsb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "05",
	   "citation": "Bankr.W.D.Tex.",
	   "code": "txwbke",
	   "is_test": false,
	   "name": "Texas Western Bankruptcy Court",
	   "pcl_api_court_code": "txwbk",
	   "region_code": "txw",
	   "subdomain": "ecf.txwb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "10",
	   "citation": "Bankr.D.Utah",
	   "code": "utbke",
	   "is_test": false,
	   "name": "Utah Bankruptcy Court",
	   "pcl_api_court_code": "utbk",
	   "region_code": "ut",
	   "subdomain": "ecf.utb.uscourts.gov",
	   "timezone": "US/Mountain",
	   "type": "bankruptcy"
	}, {
	   "circuit": "04",
	   "citation": "Bankr.E.D.Va.",
	   "code": "vaebke",
	   "is_test": false,
	   "name": "Virginia Eastern Bankruptcy Court",
	   "pcl_api_court_code": "vaebk",
	   "region_code": "vae",
	   "subdomain": "ecf.vaeb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "04",
	   "citation": "Bankr.W.D.Va.",
	   "code": "vawbke",
	   "is_test": false,
	   "name": "Virginia Western Bankruptcy Court",
	   "pcl_api_court_code": "vawbk",
	   "region_code": "vaw",
	   "subdomain": "ecf.vawb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "03",
	   "citation": "Bankr.D.VirginIslands",
	   "code": "vibke",
	   "is_test": false,
	   "name": "Virgin Islands Bankruptcy Court",
	   "pcl_api_court_code": "vibk",
	   "region_code": "vi",
	   "subdomain": "ecf.vib.uscourts.gov",
	   "timezone": "America/Virgin",
	   "type": "bankruptcy"
	}, {
	   "circuit": "02",
	   "citation": "Bankr.D.Vt.",
	   "code": "vtbke",
	   "is_test": false,
	   "name": "Vermont Bankruptcy Court",
	   "pcl_api_court_code": "vtbk",
	   "region_code": "vt",
	   "subdomain": "ecf.vtb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "09",
	   "citation": "Bankr.E.D.Wash.",
	   "code": "waebke",
	   "is_test": false,
	   "name": "Washington Eastern Bankruptcy Court",
	   "pcl_api_court_code": "waebk",
	   "region_code": "wae",
	   "subdomain": "ecf.waeb.uscourts.gov",
	   "timezone": "US/Pacific",
	   "type": "bankruptcy"
	}, {
	   "circuit": "09",
	   "citation": "Bankr.W.D.Wash.",
	   "code": "wawbke",
	   "is_test": false,
	   "name": "Washington Western Bankruptcy Court",
	   "pcl_api_court_code": "wawbk",
	   "region_code": "waw",
	   "subdomain": "ecf.wawb.uscourts.gov",
	   "timezone": "US/Pacific",
	   "type": "bankruptcy"
	}, {
	   "circuit": "07",
	   "citation": "Bankr.E.D.Wis.",
	   "code": "wiebke",
	   "is_test": false,
	   "name": "Wisconsin Eastern Bankruptcy Court",
	   "pcl_api_court_code": "wiebk",
	   "region_code": "wie",
	   "subdomain": "ecf.wieb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "07",
	   "citation": "Bankr.E.D.Wis.TEST",
	   "code": "wiebtest",
	   "is_test": true,
	   "name": "Wisconsin Eastern TEST Bankruptcy Court",
	   "pcl_api_court_code": null,
	   "region_code": "wie",
	   "subdomain": "ecf-test.wieb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "07",
	   "citation": "Bankr.W.D.Wis",
	   "code": "wiwbke",
	   "is_test": false,
	   "name": "Wisconsin Western Bankruptcy Court",
	   "pcl_api_court_code": "wiwbk",
	   "region_code": "wiw",
	   "subdomain": "ecf.wiwb.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "bankruptcy"
	}, {
	   "circuit": "04",
	   "citation": "Bankr.N.D.W.Va.",
	   "code": "wvnbke",
	   "is_test": false,
	   "name": "West Virginia Northern Bankruptcy Court",
	   "pcl_api_court_code": "wvnbk",
	   "region_code": "wvn",
	   "subdomain": "ecf.wvnb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "04",
	   "citation": "Bankr.S.D.W.Va.",
	   "code": "wvsbke",
	   "is_test": false,
	   "name": "West Virginia Southern Bankruptcy Court",
	   "pcl_api_court_code": "wvsbk",
	   "region_code": "wvs",
	   "subdomain": "ecf.wvsb.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "bankruptcy"
	}, {
	   "circuit": "10",
	   "citation": "Bankr.D.Wyo.",
	   "code": "wybke",
	   "is_test": false,
	   "name": "Wyoming Bankruptcy Court",
	   "pcl_api_court_code": "wybk",
	   "region_code": "wy",
	   "subdomain": "ecf.wyb.uscourts.gov",
	   "timezone": "US/Mountain",
	   "type": "bankruptcy"
	}, {
	   "circuit": "09",
	   "citation": "Dist.Alaska.",
	   "code": "akdce",
	   "is_test": false,
	   "name": "Alaska District Court",
	   "pcl_api_court_code": "akdc",
	   "region_code": "ak",
	   "subdomain": "ecf.akd.uscourts.gov",
	   "timezone": "US/Alaska",
	   "type": "district"
	}, {
	   "circuit": "11",
	   "citation": "Dist.M.D.Ala.",
	   "code": "almdce",
	   "is_test": false,
	   "name": "Alabama Middle District Court",
	   "pcl_api_court_code": "almdc",
	   "region_code": "alm",
	   "subdomain": "ecf.almd.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "11",
	   "citation": "Dist.N.D.Ala.",
	   "code": "alndce",
	   "is_test": false,
	   "name": "Alabama Northern District Court",
	   "pcl_api_court_code": "alndc",
	   "region_code": "aln",
	   "subdomain": "ecf.alnd.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "11",
	   "citation": "Dist.S.D.Ala.",
	   "code": "alsdce",
	   "is_test": false,
	   "name": "Alabama Southern District Court",
	   "pcl_api_court_code": "alsdc",
	   "region_code": "als",
	   "subdomain": "ecf.alsd.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "08",
	   "citation": "Dist.E.D.Ark.",
	   "code": "aredce",
	   "is_test": false,
	   "name": "Arkansas Eastern District Court",
	   "pcl_api_court_code": "aredc",
	   "region_code": "are",
	   "subdomain": "ecf.ared.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "08",
	   "citation": "Dist.W.D.Ark.",
	   "code": "arwdce",
	   "is_test": false,
	   "name": "Arkansas Western District Court",
	   "pcl_api_court_code": "arwdc",
	   "region_code": "arw",
	   "subdomain": "ecf.arwd.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "09",
	   "citation": "Dist.Ariz.",
	   "code": "azdce",
	   "is_test": false,
	   "name": "Arizona District Court",
	   "pcl_api_court_code": "azdc",
	   "region_code": "az",
	   "subdomain": "ecf.azd.uscourts.gov",
	   "timezone": "US/Arizona",
	   "type": "district"
	}, {
	   "circuit": "09",
	   "citation": "Dist.C.D.Cal.",
	   "code": "cacdce",
	   "is_test": false,
	   "name": "California Central District Court",
	   "pcl_api_court_code": "cacdc",
	   "region_code": "cac",
	   "subdomain": "ecf.cacd.uscourts.gov",
	   "timezone": "US/Pacific",
	   "type": "district"
	}, {
	   "circuit": "09",
	   "citation": "Dist.E.D.Cal.",
	   "code": "caedce",
	   "is_test": false,
	   "name": "California Eastern District Court",
	   "pcl_api_court_code": "caedc",
	   "region_code": "cae",
	   "subdomain": "ecf.caed.uscourts.gov",
	   "timezone": "US/Pacific",
	   "type": "district"
	}, {
	   "circuit": "09",
	   "citation": "Dist.N.D.Cal.",
	   "code": "candce",
	   "is_test": false,
	   "name": "California Northern District Court",
	   "pcl_api_court_code": "candc",
	   "region_code": "can",
	   "subdomain": "ecf.cand.uscourts.gov",
	   "timezone": "US/Pacific",
	   "type": "district"
	}, {
	   "circuit": "09",
	   "citation": "Dist.N.D.Cal.TEST.",
	   "code": "candtest",
	   "is_test": true,
	   "name": "California Northern TEST District Court",
	   "pcl_api_court_code": null,
	   "region_code": "can",
	   "subdomain": "ecf-test.cand.uscourts.gov",
	   "timezone": "US/Pacific",
	   "type": "district"
	}, {
	   "circuit": "09",
	   "citation": "Dist.S.D.Cal.",
	   "code": "casdce",
	   "is_test": false,
	   "name": "California Southern District Court",
	   "pcl_api_court_code": "casdc",
	   "region_code": "cas",
	   "subdomain": "ecf.casd.uscourts.gov",
	   "timezone": "US/Pacific",
	   "type": "district"
	}, {
	   "circuit": "10",
	   "citation": "Dist.Colo.",
	   "code": "codce",
	   "is_test": false,
	   "name": "Colorado District Court",
	   "pcl_api_court_code": "codc",
	   "region_code": "co",
	   "subdomain": "ecf.cod.uscourts.gov",
	   "timezone": "US/Mountain",
	   "type": "district"
	}, {
	   "circuit": "02",
	   "citation": "Dist.Conn.",
	   "code": "ctdce",
	   "is_test": false,
	   "name": "Connecticut District Court",
	   "pcl_api_court_code": "ctdc",
	   "region_code": "ct",
	   "subdomain": "ecf.ctd.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "dc",
	   "citation": "Dist.D.C.",
	   "code": "dcdce",
	   "is_test": false,
	   "name": "District Of Columbia District Court",
	   "pcl_api_court_code": "dcdc",
	   "region_code": "dc",
	   "subdomain": "ecf.dcd.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "dc",
	   "citation": "Dist.TEST",
	   "code": "dctest",
	   "is_test": true,
	   "name": "District TEST Court",
	   "pcl_api_court_code": null,
	   "region_code": "dc",
	   "subdomain": "dcecf.psc.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "03",
	   "citation": "Dist.Del.",
	   "code": "dedce",
	   "is_test": false,
	   "name": "Delaware District Court",
	   "pcl_api_court_code": "dedc",
	   "region_code": "de",
	   "subdomain": "ecf.ded.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "11",
	   "citation": "Dist.M.D.Fla.",
	   "code": "flmdce",
	   "is_test": false,
	   "name": "Florida Middle District Court",
	   "pcl_api_court_code": "flmdc",
	   "region_code": "flm",
	   "subdomain": "ecf.flmd.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "11",
	   "citation": "Dist.N.D.Fla.",
	   "code": "flndce",
	   "is_test": false,
	   "name": "Florida Northern District Court",
	   "pcl_api_court_code": "flndc",
	   "region_code": "fln",
	   "subdomain": "ecf.flnd.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "11",
	   "citation": "Dist.N.D.Fla.TEST.",
	   "code": "flndtest",
	   "is_test": true,
	   "name": "Florida Northern TEST District Court",
	   "pcl_api_court_code": null,
	   "region_code": "fln",
	   "subdomain": "ecf-test.flnd.uscourts.gov",
	   "timezone": "America/New_York",
	   "type": "district"
	}, {
	   "circuit": "11",
	   "citation": "Dist.S.D.Fla.",
	   "code": "flsdce",
	   "is_test": false,
	   "name": "Florida Southern District Court",
	   "pcl_api_court_code": "flsdc",
	   "region_code": "fls",
	   "subdomain": "ecf.flsd.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "11",
	   "citation": "Dist.M.D.Ga.",
	   "code": "gamdce",
	   "is_test": false,
	   "name": "Georgia Middle District Court",
	   "pcl_api_court_code": "gamdc",
	   "region_code": "gam",
	   "subdomain": "ecf.gamd.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "11",
	   "citation": "Dist.N.D.Ga.",
	   "code": "gandce",
	   "is_test": false,
	   "name": "Georgia Northern District Court",
	   "pcl_api_court_code": "gandc",
	   "region_code": "gan",
	   "subdomain": "ecf.gand.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "11",
	   "citation": "Dist.S.D.Ga.",
	   "code": "gasdce",
	   "is_test": false,
	   "name": "Georgia Southern District Court",
	   "pcl_api_court_code": "gasdc",
	   "region_code": "gas",
	   "subdomain": "ecf.gasd.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "09",
	   "citation": "Dist.Guam",
	   "code": "gudce",
	   "is_test": false,
	   "name": "Guam District Court",
	   "pcl_api_court_code": "gudc",
	   "region_code": "gu",
	   "subdomain": "ecf.gud.uscourts.gov",
	   "timezone": "Pacific/Guam",
	   "type": "district"
	}, {
	   "circuit": "09",
	   "citation": "Dist.Hawaii",
	   "code": "hidce",
	   "is_test": false,
	   "name": "Hawaii District Court",
	   "pcl_api_court_code": "hidc",
	   "region_code": "hi",
	   "subdomain": "ecf.hid.uscourts.gov",
	   "timezone": "US/Hawaii",
	   "type": "district"
	}, {
	   "circuit": "08",
	   "citation": "Dist.N.D.Iowa",
	   "code": "iandce",
	   "is_test": false,
	   "name": "Iowa Northern District Court",
	   "pcl_api_court_code": "iandc",
	   "region_code": "ian",
	   "subdomain": "ecf.iand.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "08",
	   "citation": "Dist.S.D.Iowa",
	   "code": "iasdce",
	   "is_test": false,
	   "name": "Iowa Southern District Court",
	   "pcl_api_court_code": "iasdc",
	   "region_code": "ias",
	   "subdomain": "ecf.iasd.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "09",
	   "citation": "Dist.Idaho",
	   "code": "iddce",
	   "is_test": false,
	   "name": "Idaho District Court",
	   "pcl_api_court_code": "iddc",
	   "region_code": "id",
	   "subdomain": "ecf.idd.uscourts.gov",
	   "timezone": "US/Mountain",
	   "type": "district"
	}, {
	   "circuit": "07",
	   "citation": "Dist.C.D.Ill.",
	   "code": "ilcdce",
	   "is_test": false,
	   "name": "Illinois Central District Court",
	   "pcl_api_court_code": "ilcdc",
	   "region_code": "ilc",
	   "subdomain": "ecf.ilcd.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "07",
	   "citation": "Dist.N.D.Ill.",
	   "code": "ilndce",
	   "is_test": false,
	   "name": "Illinois Northern District Court",
	   "pcl_api_court_code": "ilndc",
	   "region_code": "iln",
	   "subdomain": "ecf.ilnd.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "07",
	   "citation": "Dist.S.D.Ill.",
	   "code": "ilsdce",
	   "is_test": false,
	   "name": "Illinois Southern District Court",
	   "pcl_api_court_code": "ilsdc",
	   "region_code": "ils",
	   "subdomain": "ecf.ilsd.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "07",
	   "citation": "Dist.N.D.Ind.",
	   "code": "inndce",
	   "is_test": false,
	   "name": "Indiana Northern District Court",
	   "pcl_api_court_code": "inndc",
	   "region_code": "inn",
	   "subdomain": "ecf.innd.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "07",
	   "citation": "Dist.S.D.Ind.",
	   "code": "insdce",
	   "is_test": false,
	   "name": "Indiana Southern District Court",
	   "pcl_api_court_code": "insdc",
	   "region_code": "ins",
	   "subdomain": "ecf.insd.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "10",
	   "citation": "Dist.Kan.",
	   "code": "ksdce",
	   "is_test": false,
	   "name": "Kansas District Court",
	   "pcl_api_court_code": "ksdc",
	   "region_code": "ks",
	   "subdomain": "ecf.ksd.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "10",
	   "citation": "Dist.D.Kan.TEST.",
	   "code": "ksdtest",
	   "is_test": true,
	   "name": "Kansas TEST District Court",
	   "pcl_api_court_code": null,
	   "region_code": "ks",
	   "subdomain": "ecf-test.ksd.uscourts.gov",
	   "timezone": "America/Chicago",
	   "type": "district"
	}, {
	   "circuit": "06",
	   "citation": "Dist.E.D.Ky.",
	   "code": "kyedce",
	   "is_test": false,
	   "name": "Kentucky Eastern District Court",
	   "pcl_api_court_code": "kyedc",
	   "region_code": "kye",
	   "subdomain": "ecf.kyed.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "06",
	   "citation": "Dist.W.D.Ky.",
	   "code": "kywdce",
	   "is_test": false,
	   "name": "Kentucky Western District Court",
	   "pcl_api_court_code": "kywdc",
	   "region_code": "kyw",
	   "subdomain": "ecf.kywd.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "05",
	   "citation": "Dist.E.D.La.",
	   "code": "laedce",
	   "is_test": false,
	   "name": "Louisiana Eastern District Court",
	   "pcl_api_court_code": "laedc",
	   "region_code": "lae",
	   "subdomain": "ecf.laed.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "05",
	   "citation": "Dist.M.D.La.",
	   "code": "lamdce",
	   "is_test": false,
	   "name": "Louisiana Middle District Court",
	   "pcl_api_court_code": "lamdc",
	   "region_code": "lam",
	   "subdomain": "ecf.lamd.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "05",
	   "citation": "Dist.W.D.La.",
	   "code": "lawdce",
	   "is_test": false,
	   "name": "Louisiana Western District Court",
	   "pcl_api_court_code": "lawdc",
	   "region_code": "law",
	   "subdomain": "ecf.lawd.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "01",
	   "citation": "Dist.Mass.",
	   "code": "madce",
	   "is_test": false,
	   "name": "Massachusetts District Court",
	   "pcl_api_court_code": "madc",
	   "region_code": "ma",
	   "subdomain": "ecf.mad.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "04",
	   "citation": "Dist.Md.",
	   "code": "mddce",
	   "is_test": false,
	   "name": "Maryland District Court",
	   "pcl_api_court_code": "mddc",
	   "region_code": "md",
	   "subdomain": "ecf.mdd.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "01",
	   "citation": "Dist.Me.",
	   "code": "medce",
	   "is_test": false,
	   "name": "Maine District Court",
	   "pcl_api_court_code": "medc",
	   "region_code": "me",
	   "subdomain": "ecf.med.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "06",
	   "citation": "Dist.E.D.Mich.",
	   "code": "miedce",
	   "is_test": false,
	   "name": "Michigan Eastern District Court",
	   "pcl_api_court_code": "miedc",
	   "region_code": "mie",
	   "subdomain": "ecf.mied.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "06",
	   "citation": "Dist.W.D.Mich.",
	   "code": "miwdce",
	   "is_test": false,
	   "name": "Michigan Western District Court",
	   "pcl_api_court_code": "miwdc",
	   "region_code": "miw",
	   "subdomain": "ecf.miwd.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "08",
	   "citation": "Dist.Minn.",
	   "code": "mndce",
	   "is_test": false,
	   "name": "Minnesota District Court",
	   "pcl_api_court_code": "mndc",
	   "region_code": "mn",
	   "subdomain": "ecf.mnd.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "08",
	   "citation": "Dist.Minn.TEST.",
	   "code": "mndtest",
	   "is_test": true,
	   "name": "Minnesota TEST District Court",
	   "pcl_api_court_code": null,
	   "region_code": "mn",
	   "subdomain": "ecf-test.mnd.uscourts.gov",
	   "timezone": "America/Chicago",
	   "type": "district"
	}, {
	   "circuit": "08",
	   "citation": "Dist.Minn.TRAIN.",
	   "code": "mndtrain",
	   "is_test": true,
	   "name": "Minnesota TRAIN District Court",
	   "pcl_api_court_code": null,
	   "region_code": "mn",
	   "subdomain": "ecf-train.mnd.uscourts.gov",
	   "timezone": "America/Chicago",
	   "type": "district"
	}, {
	   "circuit": "08",
	   "citation": "Dist.E.D.Mo.",
	   "code": "moedce",
	   "is_test": false,
	   "name": "Missouri Eastern District Court",
	   "pcl_api_court_code": "moedc",
	   "region_code": "moe",
	   "subdomain": "ecf.moed.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "08",
	   "citation": "Dist.W.D.Mo.",
	   "code": "mowdce",
	   "is_test": false,
	   "name": "Missouri Western District Court",
	   "pcl_api_court_code": "mowdc",
	   "region_code": "mow",
	   "subdomain": "ecf.mowd.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "05",
	   "citation": "Dist.N.D.Miss",
	   "code": "msndce",
	   "is_test": false,
	   "name": "Mississippi Northern District Court",
	   "pcl_api_court_code": "msndc",
	   "region_code": "msn",
	   "subdomain": "ecf.msnd.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "05",
	   "citation": "Dist.S.D.Miss.",
	   "code": "mssdce",
	   "is_test": false,
	   "name": "Mississippi Southern District Court",
	   "pcl_api_court_code": "mssdc",
	   "region_code": "mss",
	   "subdomain": "ecf.mssd.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "09",
	   "citation": "Dist.Mont.",
	   "code": "mtdce",
	   "is_test": false,
	   "name": "Montana District Court",
	   "pcl_api_court_code": "mtdc",
	   "region_code": "mt",
	   "subdomain": "ecf.mtd.uscourts.gov",
	   "timezone": "US/Mountain",
	   "type": "district"
	}, {
	   "circuit": "04",
	   "citation": "Dist.E.D.N.C.",
	   "code": "ncedce",
	   "is_test": false,
	   "name": "North Carolina Eastern District Court",
	   "pcl_api_court_code": "ncedc",
	   "region_code": "nce",
	   "subdomain": "ecf.nced.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "04",
	   "citation": "Dist.M.D.N.C.",
	   "code": "ncmdce",
	   "is_test": false,
	   "name": "North Carolina Middle District Court",
	   "pcl_api_court_code": "ncmdc",
	   "region_code": "ncm",
	   "subdomain": "ecf.ncmd.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "04",
	   "citation": "Dist.W.D.N.C.",
	   "code": "ncwdce",
	   "is_test": false,
	   "name": "North Carolina Western District Court",
	   "pcl_api_court_code": "ncwdc",
	   "region_code": "ncw",
	   "subdomain": "ecf.ncwd.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "08",
	   "citation": "Dist.N.D.",
	   "code": "nddce",
	   "is_test": false,
	   "name": "North Dakota District Court",
	   "pcl_api_court_code": "nddc",
	   "region_code": "nd",
	   "subdomain": "ecf.ndd.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "08",
	   "citation": "Dist.Neb.",
	   "code": "nedce",
	   "is_test": false,
	   "name": "Nebraska District Court",
	   "pcl_api_court_code": "nedc",
	   "region_code": "ne",
	   "subdomain": "ecf.ned.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "01",
	   "citation": "Dist.N.H.",
	   "code": "nhdce",
	   "is_test": false,
	   "name": "New Hampshire District Court",
	   "pcl_api_court_code": "nhdc",
	   "region_code": "nh",
	   "subdomain": "ecf.nhd.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "03",
	   "citation": "Dist.N.J.",
	   "code": "njdce",
	   "is_test": false,
	   "name": "New Jersey District Court",
	   "pcl_api_court_code": "njdc",
	   "region_code": "nj",
	   "subdomain": "ecf.njd.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "10",
	   "citation": "Dist.N.M.",
	   "code": "nmdce",
	   "is_test": false,
	   "name": "New Mexico District Court",
	   "pcl_api_court_code": "nmdc",
	   "region_code": "nm",
	   "subdomain": "ecf.nmd.uscourts.gov",
	   "timezone": "US/Mountain",
	   "type": "district"
	}, {
	   "circuit": "09",
	   "citation": "Dist.N.M.ISS.",
	   "code": "nmidce",
	   "is_test": false,
	   "name": "Northern Mariana Islands District Court",
	   "pcl_api_court_code": "nmidc",
	   "region_code": "nmi",
	   "subdomain": "ecf.nmid.uscourts.gov",
	   "timezone": "Pacific/Guam",
	   "type": "district"
	}, {
	   "circuit": "09",
	   "citation": "Dist.Nev.",
	   "code": "nvdce",
	   "is_test": false,
	   "name": "Nevada District Court",
	   "pcl_api_court_code": "nvdc",
	   "region_code": "nv",
	   "subdomain": "ecf.nvd.uscourts.gov",
	   "timezone": "US/Pacific",
	   "type": "district"
	}, {
	   "circuit": "09",
	   "citation": "Dist.Nev.TEST.",
	   "code": "nvdtest",
	   "is_test": true,
	   "name": "Nevada District TEST Court",
	   "pcl_api_court_code": null,
	   "region_code": "nv",
	   "subdomain": "ecf-test.nvd.uscourts.gov",
	   "timezone": "US/Pacific",
	   "type": "district"
	}, {
	   "circuit": "02",
	   "citation": "Dist.E.D.N.Y.",
	   "code": "nyedce",
	   "is_test": false,
	   "name": "New York Eastern District Court",
	   "pcl_api_court_code": "nyedc",
	   "region_code": "nye",
	   "subdomain": "ecf.nyed.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "02",
	   "citation": "Dist.N.D.N.Y.",
	   "code": "nyndce",
	   "is_test": false,
	   "name": "New York Northern District Court",
	   "pcl_api_court_code": "nyndc",
	   "region_code": "nyn",
	   "subdomain": "ecf.nynd.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "02",
	   "citation": "Dist.S.D.N.Y.",
	   "code": "nysdce",
	   "is_test": false,
	   "name": "New York Southern District Court",
	   "pcl_api_court_code": "nysdc",
	   "region_code": "nys",
	   "subdomain": "ecf.nysd.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "02",
	   "citation": "Dist.W.D.N.Y.",
	   "code": "nywdce",
	   "is_test": false,
	   "name": "New York Western District Court",
	   "pcl_api_court_code": "nywdc",
	   "region_code": "nyw",
	   "subdomain": "ecf.nywd.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "06",
	   "citation": "Dist.N.D.Ohio",
	   "code": "ohndce",
	   "is_test": false,
	   "name": "Ohio Northern District Court",
	   "pcl_api_court_code": "ohndc",
	   "region_code": "ohn",
	   "subdomain": "ecf.ohnd.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "06",
	   "citation": "Dist.N.D.Ohio",
	   "code": "ohndea",
	   "is_test": false,
	   "name": "Ohio Northern District Court(asbestos)",
	   "pcl_api_court_code": "ohnde",
	   "region_code": "ohn",
	   "subdomain": "ecf-asbestos.ohnd.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "06",
	   "citation": "Dist.S.D.Ohio",
	   "code": "ohsdce",
	   "is_test": false,
	   "name": "Ohio Southern District Court",
	   "pcl_api_court_code": "ohsdc",
	   "region_code": "ohs",
	   "subdomain": "ecf.ohsd.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "10",
	   "citation": "Dist.E.D.Okla.",
	   "code": "okedce",
	   "is_test": false,
	   "name": "Oklahoma Eastern District Court",
	   "pcl_api_court_code": "okedc",
	   "region_code": "oke",
	   "subdomain": "ecf.oked.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "10",
	   "citation": "Dist.N.D.Okla.",
	   "code": "okndce",
	   "is_test": false,
	   "name": "Oklahoma Northern District Court",
	   "pcl_api_court_code": "okndc",
	   "region_code": "okn",
	   "subdomain": "ecf.oknd.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "10",
	   "citation": "Dist.W.D.Okla.",
	   "code": "okwdce",
	   "is_test": false,
	   "name": "Oklahoma Western District Court",
	   "pcl_api_court_code": "okwdc",
	   "region_code": "okw",
	   "subdomain": "ecf.okwd.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "09",
	   "citation": "Dist.Or.",
	   "code": "ordce",
	   "is_test": false,
	   "name": "Oregon District Court",
	   "pcl_api_court_code": "ordc",
	   "region_code": "or",
	   "subdomain": "ecf.ord.uscourts.gov",
	   "timezone": "US/Pacific",
	   "type": "district"
	}, {
	   "circuit": "03",
	   "citation": "Dist.E.D.Pa.",
	   "code": "paedce",
	   "is_test": false,
	   "name": "Pennsylvania Eastern District Court",
	   "pcl_api_court_code": "paedc",
	   "region_code": "pae",
	   "subdomain": "ecf.paed.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "03",
	   "citation": "Dist.M.D.Pa.",
	   "code": "pamdce",
	   "is_test": false,
	   "name": "Pennsylvania Middle District Court",
	   "pcl_api_court_code": "pamdc",
	   "region_code": "pam",
	   "subdomain": "ecf.pamd.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "03",
	   "citation": "Dist.W.D.Pa.",
	   "code": "pawdce",
	   "is_test": false,
	   "name": "Pennsylvania Western District Court",
	   "pcl_api_court_code": "pawdc",
	   "region_code": "paw",
	   "subdomain": "ecf.pawd.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "01",
	   "citation": "Dist.P.R.",
	   "code": "prdce",
	   "is_test": false,
	   "name": "Puerto Rico District Court",
	   "pcl_api_court_code": "prdc",
	   "region_code": "pr",
	   "subdomain": "ecf.prd.uscourts.gov",
	   "timezone": "America/Puerto_Rico",
	   "type": "district"
	}, {
	   "circuit": "01",
	   "citation": "Dist.R.I.",
	   "code": "ridce",
	   "is_test": false,
	   "name": "Rhode Island District Court",
	   "pcl_api_court_code": "ridc",
	   "region_code": "ri",
	   "subdomain": "ecf.rid.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "04",
	   "citation": "Dist.S.C.",
	   "code": "scdce",
	   "is_test": false,
	   "name": "South Carolina District Court",
	   "pcl_api_court_code": "scdc",
	   "region_code": "sc",
	   "subdomain": "ecf.scd.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "08",
	   "citation": "Dist.S.D.",
	   "code": "sddce",
	   "is_test": false,
	   "name": "South Dakota District Court",
	   "pcl_api_court_code": "sddc",
	   "region_code": "sd",
	   "subdomain": "ecf.sdd.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "06",
	   "citation": "Dist.E.D.Tenn.",
	   "code": "tnedce",
	   "is_test": false,
	   "name": "Tennessee Eastern District Court",
	   "pcl_api_court_code": "tnedc",
	   "region_code": "tne",
	   "subdomain": "ecf.tned.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "06",
	   "citation": "Dist.M.D.Tenn.",
	   "code": "tnmdce",
	   "is_test": false,
	   "name": "Tennessee Middle District Court",
	   "pcl_api_court_code": "tnmdc",
	   "region_code": "tnm",
	   "subdomain": "ecf.tnmd.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "06",
	   "citation": "Dist.W.D.Tenn.",
	   "code": "tnwdce",
	   "is_test": false,
	   "name": "Tennessee Western District Court",
	   "pcl_api_court_code": "tnwdc",
	   "region_code": "tnw",
	   "subdomain": "ecf.tnwd.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "05",
	   "citation": "Dist.E.D.Tex.",
	   "code": "txedce",
	   "is_test": false,
	   "name": "Texas Eastern District Court",
	   "pcl_api_court_code": "txedc",
	   "region_code": "txe",
	   "subdomain": "ecf.txed.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "05",
	   "citation": "Dist.N.D.Tex.",
	   "code": "txndce",
	   "is_test": false,
	   "name": "Texas Northern District Court",
	   "pcl_api_court_code": "txndc",
	   "region_code": "txn",
	   "subdomain": "ecf.txnd.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "05",
	   "citation": "Dist.S.D.Tex.",
	   "code": "txsdce",
	   "is_test": false,
	   "name": "Texas Southern District Court",
	   "pcl_api_court_code": "txsdc",
	   "region_code": "txs",
	   "subdomain": "ecf.txsd.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "05",
	   "citation": "Dist.W.D.Tex.",
	   "code": "txwdce",
	   "is_test": false,
	   "name": "Texas Western District Court",
	   "pcl_api_court_code": "txwdc",
	   "region_code": "txw",
	   "subdomain": "ecf.txwd.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "10",
	   "citation": "Dist.Utah",
	   "code": "utdce",
	   "is_test": false,
	   "name": "Utah District Court",
	   "pcl_api_court_code": "utdc",
	   "region_code": "ut",
	   "subdomain": "ecf.utd.uscourts.gov",
	   "timezone": "US/Mountain",
	   "type": "district"
	}, {
	   "circuit": "04",
	   "citation": "Dist.E.D.Va.",
	   "code": "vaedce",
	   "is_test": false,
	   "name": "Virginia Eastern District Court",
	   "pcl_api_court_code": "vaedc",
	   "region_code": "vae",
	   "subdomain": "ecf.vaed.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "04",
	   "citation": "Dist.W.D.Va.",
	   "code": "vawdce",
	   "is_test": false,
	   "name": "Virginia Western District Court",
	   "pcl_api_court_code": "vawdc",
	   "region_code": "vaw",
	   "subdomain": "ecf.vawd.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "03",
	   "citation": "Dist.VirginIslands",
	   "code": "vidce",
	   "is_test": false,
	   "name": "Virgin Islands District Court",
	   "pcl_api_court_code": "vidc",
	   "region_code": "vi",
	   "subdomain": "ecf.vid.uscourts.gov",
	   "timezone": "America/Virgin",
	   "type": "district"
	}, {
	   "circuit": "02",
	   "citation": "Dist.Vt.",
	   "code": "vtdce",
	   "is_test": false,
	   "name": "Vermont District Court",
	   "pcl_api_court_code": "vtdc",
	   "region_code": "vt",
	   "subdomain": "ecf.vtd.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "09",
	   "citation": "Dist.E.D.Wash.",
	   "code": "waedce",
	   "is_test": false,
	   "name": "Washington Eastern District Court",
	   "pcl_api_court_code": "waedc",
	   "region_code": "wae",
	   "subdomain": "ecf.waed.uscourts.gov",
	   "timezone": "US/Pacific",
	   "type": "district"
	}, {
	   "circuit": "09",
	   "citation": "Dist.W.D.Wash.",
	   "code": "wawdce",
	   "is_test": false,
	   "name": "Washington Western District Court",
	   "pcl_api_court_code": "wawdc",
	   "region_code": "waw",
	   "subdomain": "ecf.wawd.uscourts.gov",
	   "timezone": "US/Pacific",
	   "type": "district"
	}, {
	   "circuit": "07",
	   "citation": "Dist.E.D.Wis.",
	   "code": "wiedce",
	   "is_test": false,
	   "name": "Wisconsin Eastern District Court",
	   "pcl_api_court_code": "wiedc",
	   "region_code": "wie",
	   "subdomain": "ecf.wied.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "07",
	   "citation": "Dist.W.D.Wis",
	   "code": "wiwdce",
	   "is_test": false,
	   "name": "Wisconsin Western District Court",
	   "pcl_api_court_code": "wiwdc",
	   "region_code": "wiw",
	   "subdomain": "ecf.wiwd.uscourts.gov",
	   "timezone": "US/Central",
	   "type": "district"
	}, {
	   "circuit": "04",
	   "citation": "Dist.N.D.W.Va.",
	   "code": "wvndce",
	   "is_test": false,
	   "name": "West Virginia Northern District Court",
	   "pcl_api_court_code": "wvndc",
	   "region_code": "wvn",
	   "subdomain": "ecf.wvnd.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "04",
	   "citation": "Dist.S.D.W.Va.",
	   "code": "wvsdce",
	   "is_test": false,
	   "name": "West Virginia Southern District Court",
	   "pcl_api_court_code": "wvsdc",
	   "region_code": "wvs",
	   "subdomain": "ecf.wvsd.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "district"
	}, {
	   "circuit": "10",
	   "citation": "Dist.Wyo.",
	   "code": "wydce",
	   "is_test": false,
	   "name": "Wyoming District Court",
	   "pcl_api_court_code": "wydc",
	   "region_code": "wy",
	   "subdomain": "ecf.wyd.uscourts.gov",
	   "timezone": "US/Mountain",
	   "type": "district"
	}, {
	   "circuit": null,
	   "citation": "INT",
	   "code": "citdce",
	   "is_test": false,
	   "name": "U.S. Court of International Trade",
	   "pcl_api_court_code": "citdc",
	   "region_code": "cit",
	   "subdomain": "ecf.cit.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "national"
	}, {
	   "circuit": null,
	   "citation": "INT",
	   "code": "citdtest",
	   "is_test": true,
	   "name": "U.S. Court of International Trade (TEST Database)",
	   "pcl_api_court_code": null,
	   "region_code": "cit",
	   "subdomain": "ecf-test.cit.uscourts.gov",
	   "timezone": null,
	   "type": "national"
	}, {
	   "circuit": null,
	   "citation": "Fed.Claim",
	   "code": "cofce",
	   "is_test": false,
	   "name": "U.S. Court of Federal Claims",
	   "pcl_api_court_code": "cofc",
	   "region_code": "cofc",
	   "subdomain": "ecf.cofc.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "national"
	}, {
	   "circuit": null,
	   "citation": "JPML",
	   "code": "jpml",
	   "is_test": false,
	   "name": "Judicial Panel on Multidistrict Litigation",
	   "pcl_api_court_code": "jpmldc",
	   "region_code": "jpml",
	   "subdomain": "ecf.jpml.uscourts.gov",
	   "timezone": "US/Eastern",
	   "type": "national"
	}];

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(process, setImmediate, module) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*! hellojs v1.18.1 | (c) 2012-2022 Andrew Dodson | MIT https://adodson.com/hello.js/LICENSE */
	// ES5 Object.create
	if (!Object.create) {
	
		// Shim, Object create
		// A shim for Object.create(), it adds a prototype to a new object
		Object.create = function () {
	
			function F() {}
	
			return function (o) {
	
				if (arguments.length != 1) {
					throw new Error('Object.create implementation only accepts one parameter.');
				}
	
				F.prototype = o;
				return new F();
			};
		}();
	}
	
	// ES5 Object.keys
	if (!Object.keys) {
		Object.keys = function (o, k, r) {
			r = [];
			for (k in o) {
				if (r.hasOwnProperty.call(o, k)) r.push(k);
			}
	
			return r;
		};
	}
	
	// ES5 [].indexOf
	if (!Array.prototype.indexOf) {
		Array.prototype.indexOf = function (s) {
	
			for (var j = 0; j < this.length; j++) {
				if (this[j] === s) {
					return j;
				}
			}
	
			return -1;
		};
	}
	
	// ES5 [].forEach
	if (!Array.prototype.forEach) {
		Array.prototype.forEach = function (fun /*, thisArg*/) {
	
			if (this === void 0 || this === null) {
				throw new TypeError();
			}
	
			var t = Object(this);
			var len = t.length >>> 0;
			if (typeof fun !== 'function') {
				throw new TypeError();
			}
	
			var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
			for (var i = 0; i < len; i++) {
				if (i in t) {
					fun.call(thisArg, t[i], i, t);
				}
			}
	
			return this;
		};
	}
	
	// ES5 [].filter
	if (!Array.prototype.filter) {
		Array.prototype.filter = function (fun, thisArg) {
	
			var a = [];
			this.forEach(function (val, i, t) {
				if (fun.call(thisArg || void 0, val, i, t)) {
					a.push(val);
				}
			});
	
			return a;
		};
	}
	
	// Production steps of ECMA-262, Edition 5, 15.4.4.19
	// Reference: http://es5.github.io/#x15.4.4.19
	if (!Array.prototype.map) {
	
		Array.prototype.map = function (fun, thisArg) {
	
			var a = [];
			this.forEach(function (val, i, t) {
				a.push(fun.call(thisArg || void 0, val, i, t));
			});
	
			return a;
		};
	}
	
	// ES5 isArray
	if (!Array.isArray) {
	
		// Function Array.isArray
		Array.isArray = function (o) {
			return Object.prototype.toString.call(o) === '[object Array]';
		};
	}
	
	// Test for location.assign
	if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && _typeof(window.location) === 'object' && !window.location.assign) {
	
		window.location.assign = function (url) {
			window.location = url;
		};
	}
	
	// Test for Function.bind
	if (!Function.prototype.bind) {
	
		// MDN
		// Polyfill IE8, does not support native Function.bind
		Function.prototype.bind = function (b) {
	
			if (typeof this !== 'function') {
				throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
			}
	
			function C() {}
	
			var a = [].slice;
			var f = a.call(arguments, 1);
			var _this = this;
			var D = function D() {
				return _this.apply(this instanceof C ? this : b || window, f.concat(a.call(arguments)));
			};
	
			C.prototype = this.prototype;
			D.prototype = new C();
	
			return D;
		};
	}
	
	/**
	 * @hello.js
	 *
	 * HelloJS is a client side Javascript SDK for making OAuth2 logins and subsequent REST calls.
	 *
	 * @author Andrew Dodson
	 * @website https://adodson.com/hello.js/
	 *
	 * @copyright Andrew Dodson, 2012 - 2015
	 * @license MIT: You are free to use and modify this code for any use, on the condition that this copyright notice remains.
	 */
	
	var hello = function hello(name) {
		return hello.use(name);
	};
	
	hello.utils = {
	
		// Extend the first object with the properties and methods of the second
		extend: function extend(r /*, a[, b[, ...]] */) {
	
			// Get the arguments as an array but ommit the initial item
			Array.prototype.slice.call(arguments, 1).forEach(function (a) {
				if (Array.isArray(r) && Array.isArray(a)) {
					Array.prototype.push.apply(r, a);
				} else if (r && (r instanceof Object || (typeof r === 'undefined' ? 'undefined' : _typeof(r)) === 'object') && a && (a instanceof Object || (typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') && r !== a) {
					for (var x in a) {
						r[x] = hello.utils.extend(r[x], a[x]);
					}
				} else {
	
					if (Array.isArray(a)) {
						// Clone it
						a = a.slice(0);
					}
	
					r = a;
				}
			});
	
			return r;
		}
	};
	
	// Core library
	hello.utils.extend(hello, {
	
		settings: {
	
			// OAuth2 authentication defaults
			redirect_uri: window.location.href.split('#')[0],
			response_type: 'token',
			display: 'popup',
			state: '',
	
			// OAuth1 shim
			// The path to the OAuth1 server for signing user requests
			// Want to recreate your own? Checkout https://github.com/MrSwitch/node-oauth-shim
			oauth_proxy: 'https://auth-server.herokuapp.com/proxy',
	
			// API timeout in milliseconds
			timeout: 20000,
	
			// Popup Options
			popup: {
				resizable: 1,
				scrollbars: 1,
				width: 500,
				height: 550
			},
	
			// Default scope
			// Many services require atleast a profile scope,
			// HelloJS automatially includes the value of provider.scope_map.basic
			// If that's not required it can be removed via hello.settings.scope.length = 0;
			scope: ['basic'],
	
			// Scope Maps
			// This is the default module scope, these are the defaults which each service is mapped too.
			// By including them here it prevents the scope from being applied accidentally
			scope_map: {
				basic: ''
			},
	
			// Default service / network
			default_service: null,
	
			// Force authentication
			// When hello.login is fired.
			// (null): ignore current session expiry and continue with login
			// (true): ignore current session expiry and continue with login, ask for user to reauthenticate
			// (false): if the current session looks good for the request scopes return the current session.
			force: null,
	
			// Page URL
			// When 'display=page' this property defines where the users page should end up after redirect_uri
			// Ths could be problematic if the redirect_uri is indeed the final place,
			// Typically this circumvents the problem of the redirect_url being a dumb relay page.
			page_uri: window.location.href
		},
	
		// Service configuration objects
		services: {},
	
		// Use
		// Define a new instance of the HelloJS library with a default service
		use: function use(service) {
	
			// Create self, which inherits from its parent
			var self = Object.create(this);
	
			// Inherit the prototype from its parent
			self.settings = Object.create(this.settings);
	
			// Define the default service
			if (service) {
				self.settings.default_service = service;
			}
	
			// Create an instance of Events
			self.utils.Event.call(self);
	
			return self;
		},
	
		// Initialize
		// Define the client_ids for the endpoint services
		// @param object o, contains a key value pair, service => clientId
		// @param object opts, contains a key value pair of options used for defining the authentication defaults
		// @param number timeout, timeout in seconds
		init: function init(services, options) {
	
			var utils = this.utils;
	
			if (!services) {
				return this.services;
			}
	
			// Define provider credentials
			// Reformat the ID field
			for (var x in services) {
				if (services.hasOwnProperty(x)) {
					if (_typeof(services[x]) !== 'object') {
						services[x] = { id: services[x] };
					}
				}
			}
	
			// Merge services if there already exists some
			utils.extend(this.services, services);
	
			// Update the default settings with this one.
			if (options) {
				utils.extend(this.settings, options);
	
				// Do this immediatly incase the browser changes the current path.
				if ('redirect_uri' in options) {
					this.settings.redirect_uri = utils.url(options.redirect_uri).href;
				}
			}
	
			return this;
		},
	
		// Login
		// Using the endpoint
		// @param network stringify       name to connect to
		// @param options object    (optional)  {display mode, is either none|popup(default)|page, scope: email,birthday,publish, .. }
		// @param callback  function  (optional)  fired on signin
		login: function login() {
	
			// Create an object which inherits its parent as the prototype and constructs a new event chain.
			var _this = this;
			var utils = _this.utils;
			var error = utils.error;
			var promise = utils.Promise();
	
			// Get parameters
			var p = utils.args({ network: 's', options: 'o', callback: 'f' }, arguments);
	
			// Local vars
			var url;
	
			// Get all the custom options and store to be appended to the querystring
			var qs = utils.diffKey(p.options, _this.settings);
	
			// Merge/override options with app defaults
			var opts = p.options = utils.merge(_this.settings, p.options || {});
	
			// Merge/override options with app defaults
			opts.popup = utils.merge(_this.settings.popup, p.options.popup || {});
	
			// Network
			p.network = p.network || _this.settings.default_service;
	
			// Bind callback to both reject and fulfill states
			promise.proxy.then(p.callback, p.callback);
	
			// Trigger an event on the global listener
			function emit(s, value) {
				hello.emit(s, value);
			}
	
			promise.proxy.then(emit.bind(this, 'auth.login auth'), emit.bind(this, 'auth.failed auth'));
	
			// Is our service valid?
			if (typeof p.network !== 'string' || !(p.network in _this.services)) {
				// Trigger the default login.
				// Ahh we dont have one.
				return promise.reject(error('invalid_network', 'The provided network was not recognized'));
			}
	
			var provider = _this.services[p.network];
	
			// Create a global listener to capture events triggered out of scope
			var callbackId = utils.globalEvent(function (obj) {
	
				// The responseHandler returns a string, lets save this locally
				if (obj) {
					if (typeof obj == 'string') {
						obj = JSON.parse(obj);
					}
				} else {
					obj = error('cancelled', 'The authentication was not completed');
				}
	
				// Handle these response using the local
				// Trigger on the parent
				if (!obj.error) {
	
					// Save on the parent window the new credentials
					// This fixes an IE10 bug i think... atleast it does for me.
					utils.store(obj.network, obj);
	
					// Fulfill a successful login
					promise.fulfill({
						network: obj.network,
						authResponse: obj
					});
				} else {
					// Reject a successful login
					promise.reject(obj);
				}
			});
	
			var redirectUri = utils.url(opts.redirect_uri).href;
	
			// May be a space-delimited list of multiple, complementary types
			var responseType = provider.oauth.response_type || opts.response_type;
	
			// Fallback to token if the module hasn't defined a grant url
			if (/\bcode\b/.test(responseType) && !provider.oauth.grant) {
				responseType = responseType.replace(/\bcode\b/, 'token');
			}
	
			// Query string parameters, we may pass our own arguments to form the querystring
			p.qs = utils.merge(qs, {
				client_id: encodeURIComponent(provider.id),
				response_type: encodeURIComponent(responseType),
				redirect_uri: encodeURIComponent(redirectUri),
				state: {
					client_id: provider.id,
					network: p.network,
					display: opts.display,
					callback: callbackId,
					state: opts.state,
					redirect_uri: redirectUri
				}
			});
	
			// Get current session for merging scopes, and for quick auth response
			var session = utils.store(p.network);
	
			// Scopes (authentication permisions)
			// Ensure this is a string - IE has a problem moving Arrays between windows
			// Append the setup scope
			var SCOPE_SPLIT = /[,\s]+/;
	
			// Include default scope settings (cloned).
			var scope = _this.settings.scope ? [_this.settings.scope.toString()] : [];
	
			// Extend the providers scope list with the default
			var scopeMap = utils.merge(_this.settings.scope_map, provider.scope || {});
	
			// Add user defined scopes...
			if (opts.scope) {
				scope.push(opts.scope.toString());
			}
	
			// Append scopes from a previous session.
			// This helps keep app credentials constant,
			// Avoiding having to keep tabs on what scopes are authorized
			if (session && 'scope' in session && session.scope instanceof String) {
				scope.push(session.scope);
			}
	
			// Join and Split again
			scope = scope.join(',').split(SCOPE_SPLIT);
	
			// Format remove duplicates and empty values
			scope = utils.unique(scope).filter(filterEmpty);
	
			// Save the the scopes to the state with the names that they were requested with.
			p.qs.state.scope = scope.join(',');
	
			// Map scopes to the providers naming convention
			scope = scope.map(function (item) {
				// Does this have a mapping?
				return item in scopeMap ? scopeMap[item] : item;
			});
	
			// Stringify and Arrayify so that double mapped scopes are given the chance to be formatted
			scope = scope.join(',').split(SCOPE_SPLIT);
	
			// Again...
			// Format remove duplicates and empty values
			scope = utils.unique(scope).filter(filterEmpty);
	
			// Join with the expected scope delimiter into a string
			p.qs.scope = scope.join(provider.scope_delim || ',');
	
			// Is the user already signed in with the appropriate scopes, valid access_token?
			if (opts.force === false) {
	
				if (session && 'access_token' in session && session.access_token && 'expires' in session && session.expires > new Date().getTime() / 1e3) {
					// What is different about the scopes in the session vs the scopes in the new login?
					var diff = utils.diff((session.scope || '').split(SCOPE_SPLIT), (p.qs.state.scope || '').split(SCOPE_SPLIT));
					if (diff.length === 0) {
	
						// OK trigger the callback
						promise.fulfill({
							unchanged: true,
							network: p.network,
							authResponse: session
						});
	
						// Nothing has changed
						return promise;
					}
				}
			}
	
			// Page URL
			if (opts.display === 'page' && opts.page_uri) {
				// Add a page location, place to endup after session has authenticated
				p.qs.state.page_uri = utils.url(opts.page_uri).href;
			}
	
			// Bespoke
			// Override login querystrings from auth_options
			if ('login' in provider && typeof provider.login === 'function') {
				// Format the paramaters according to the providers formatting function
				provider.login(p);
			}
	
			// Add OAuth to state
			// Where the service is going to take advantage of the oauth_proxy
			if (!/\btoken\b/.test(responseType) || parseInt(provider.oauth.version, 10) < 2 || opts.display === 'none' && provider.oauth.grant && session && session.refresh_token) {
	
				// Add the oauth endpoints
				p.qs.state.oauth = provider.oauth;
	
				// Add the proxy url
				p.qs.state.oauth_proxy = opts.oauth_proxy;
			}
	
			// Convert state to a string will use Base64 encoding of state_encoding is set to base64
			p.qs.state = provider.oauth && provider.oauth.state_encoding === 'base64' ? btoa(JSON.stringify(p.qs.state)) : encodeURIComponent(JSON.stringify(p.qs.state));
	
			// URL
			if (parseInt(provider.oauth.version, 10) === 1) {
	
				// Turn the request to the OAuth Proxy for 3-legged auth
				url = utils.qs(opts.oauth_proxy, p.qs, encodeFunction);
			}
	
			// Refresh token
			else if (opts.display === 'none' && provider.oauth.grant && session && session.refresh_token) {
	
					// Add the refresh_token to the request
					p.qs.refresh_token = session.refresh_token;
	
					// Define the request path
					url = utils.qs(opts.oauth_proxy, p.qs, encodeFunction);
				} else {
					url = utils.qs(provider.oauth.auth, p.qs, encodeFunction);
				}
	
			// Broadcast this event as an auth:init
			emit('auth.init', p);
	
			// Execute
			// Trigger how we want self displayed
			if (opts.display === 'none') {
				// Sign-in in the background, iframe
				utils.iframe(url, redirectUri);
			}
	
			// Triggering popup?
			else if (opts.display === 'popup') {
	
					var popup = utils.popup(url, redirectUri, opts.popup);
	
					var timer = setInterval(function () {
						if (!popup || popup.closed) {
							clearInterval(timer);
							if (!promise.state) {
	
								var response = error('cancelled', 'Login has been cancelled');
	
								if (!popup) {
									response = error('blocked', 'Popup was blocked');
								}
	
								response.network = p.network;
	
								promise.reject(response);
							}
						}
					}, 100);
				} else {
					window.location = url;
				}
	
			return promise.proxy;
	
			function encodeFunction(s) {
				return s;
			}
	
			function filterEmpty(s) {
				return !!s;
			}
		},
	
		// Remove any data associated with a given service
		// @param string name of the service
		// @param function callback
		logout: function logout() {
	
			var _this = this;
			var utils = _this.utils;
			var error = utils.error;
	
			// Create a new promise
			var promise = utils.Promise();
	
			var p = utils.args({ name: 's', options: 'o', callback: 'f' }, arguments);
	
			p.options = p.options || {};
	
			// Add callback to events
			promise.proxy.then(p.callback, p.callback);
	
			// Trigger an event on the global listener
			function emit(s, value) {
				hello.emit(s, value);
			}
	
			promise.proxy.then(emit.bind(this, 'auth.logout auth'), emit.bind(this, 'error'));
	
			// Network
			p.name = p.name || this.settings.default_service;
			p.authResponse = utils.store(p.name);
	
			if (p.name && !(p.name in _this.services)) {
	
				promise.reject(error('invalid_network', 'The network was unrecognized'));
			} else if (p.name && p.authResponse) {
	
				// Define the callback
				var callback = function callback(opts) {
	
					// Remove from the store
					utils.store(p.name, null);
	
					// Emit events by default
					promise.fulfill(hello.utils.merge({ network: p.name }, opts || {}));
				};
	
				// Run an async operation to remove the users session
				var _opts = {};
				if (p.options.force) {
					var logout = _this.services[p.name].logout;
					if (logout) {
						// Convert logout to URL string,
						// If no string is returned, then this function will handle the logout async style
						if (typeof logout === 'function') {
							logout = logout(callback, p);
						}
	
						// If logout is a string then assume URL and open in iframe.
						if (typeof logout === 'string') {
							utils.iframe(logout);
							_opts.force = null;
							_opts.message = 'Logout success on providers site was indeterminate';
						} else if (logout === undefined) {
							// The callback function will handle the response.
							return promise.proxy;
						}
					}
				}
	
				// Remove local credentials
				callback(_opts);
			} else {
				promise.reject(error('invalid_session', 'There was no session to remove'));
			}
	
			return promise.proxy;
		},
	
		// Returns all the sessions that are subscribed too
		// @param string optional, name of the service to get information about.
		getAuthResponse: function getAuthResponse(service) {
	
			// If the service doesn't exist
			service = service || this.settings.default_service;
	
			if (!service || !(service in this.services)) {
				return null;
			}
	
			return this.utils.store(service) || null;
		},
	
		// Events: placeholder for the events
		events: {}
	});
	
	// Core utilities
	hello.utils.extend(hello.utils, {
	
		// Error
		error: function error(code, message) {
			return {
				error: {
					code: code,
					message: message
				}
			};
		},
	
		// Append the querystring to a url
		// @param string url
		// @param object parameters
		qs: function qs(url, params, formatFunction) {
	
			if (params) {
	
				// Set default formatting function
				formatFunction = formatFunction || encodeURIComponent;
	
				// Override the items in the URL which already exist
				for (var x in params) {
					var str = '([\\?\\&])' + x + '=[^\\&]*';
					var reg = new RegExp(str);
					if (url.match(reg)) {
						url = url.replace(reg, '$1' + x + '=' + formatFunction(params[x]));
						delete params[x];
					}
				}
			}
	
			if (!this.isEmpty(params)) {
				return url + (url.indexOf('?') > -1 ? '&' : '?') + this.param(params, formatFunction);
			}
	
			return url;
		},
	
		// Param
		// Explode/encode the parameters of an URL string/object
		// @param string s, string to decode
		param: function param(s, formatFunction) {
			var b;
			var a = {};
			var m;
	
			if (typeof s === 'string') {
	
				formatFunction = formatFunction || decodeURIComponent;
	
				m = s.replace(/^[\#\?]/, '').match(/([^=\/\&]+)=([^\&]+)/g);
				if (m) {
					for (var i = 0; i < m.length; i++) {
						b = m[i].match(/([^=]+)=(.*)/);
						a[b[1]] = formatFunction(b[2]);
					}
				}
	
				return a;
			} else {
	
				formatFunction = formatFunction || encodeURIComponent;
	
				var o = s;
	
				a = [];
	
				for (var x in o) {
					if (o.hasOwnProperty(x)) {
						if (o.hasOwnProperty(x)) {
							a.push([x, o[x] === '?' ? '?' : formatFunction(o[x])].join('='));
						}
					}
				}
	
				return a.join('&');
			}
		},
	
		// Local storage facade
		store: function () {
	
			var a = ['localStorage', 'sessionStorage'];
			var i = -1;
			var prefix = 'test';
	
			// Set LocalStorage
			var localStorage;
	
			while (a[++i]) {
				try {
					// In Chrome with cookies blocked, calling localStorage throws an error
					localStorage = window[a[i]];
					localStorage.setItem(prefix + i, i);
					localStorage.removeItem(prefix + i);
					break;
				} catch (e) {
					localStorage = null;
				}
			}
	
			if (!localStorage) {
	
				var cache = null;
	
				localStorage = {
					getItem: function getItem(prop) {
						prop = prop + '=';
						var m = document.cookie.split(';');
						for (var i = 0; i < m.length; i++) {
							var _m = m[i].replace(/(^\s+|\s+$)/, '');
							if (_m && _m.indexOf(prop) === 0) {
								return _m.substr(prop.length);
							}
						}
	
						return cache;
					},
	
					setItem: function setItem(prop, value) {
						cache = value;
						document.cookie = prop + '=' + value;
					}
				};
	
				// Fill the cache up
				cache = localStorage.getItem('hello');
			}
	
			function get() {
				var json = {};
				try {
					json = JSON.parse(localStorage.getItem('hello')) || {};
				} catch (e) {}
	
				return json;
			}
	
			function set(json) {
				localStorage.setItem('hello', JSON.stringify(json));
			}
	
			// Check if the browser support local storage
			return function (name, value, days) {
	
				// Local storage
				var json = get();
	
				if (name && value === undefined) {
					return json[name] || null;
				} else if (name && value === null) {
					try {
						delete json[name];
					} catch (e) {
						json[name] = null;
					}
				} else if (name) {
					json[name] = value;
				} else {
					return json;
				}
	
				set(json);
	
				return json || null;
			};
		}(),
	
		// Create and Append new DOM elements
		// @param node string
		// @param attr object literal
		// @param dom/string
		append: function append(node, attr, target) {
	
			var n = typeof node === 'string' ? document.createElement(node) : node;
	
			if ((typeof attr === 'undefined' ? 'undefined' : _typeof(attr)) === 'object') {
				if ('tagName' in attr) {
					target = attr;
				} else {
					for (var x in attr) {
						if (attr.hasOwnProperty(x)) {
							if (_typeof(attr[x]) === 'object') {
								for (var y in attr[x]) {
									if (attr[x].hasOwnProperty(y)) {
										n[x][y] = attr[x][y];
									}
								}
							} else if (x === 'html') {
								n.innerHTML = attr[x];
							}
	
							// IE doesn't like us setting methods with setAttribute
							else if (!/^on/.test(x)) {
									n.setAttribute(x, attr[x]);
								} else {
									n[x] = attr[x];
								}
						}
					}
				}
			}
	
			if (target === 'body') {
				(function self() {
					if (document.body) {
						document.body.appendChild(n);
					} else {
						setTimeout(self, 16);
					}
				})();
			} else if ((typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object') {
				target.appendChild(n);
			} else if (typeof target === 'string') {
				document.getElementsByTagName(target)[0].appendChild(n);
			}
	
			return n;
		},
	
		// An easy way to create a hidden iframe
		// @param string src
		iframe: function iframe(src) {
			this.append('iframe', { src: src, style: { position: 'absolute', left: '-1000px', bottom: 0, height: '1px', width: '1px' } }, 'body');
		},
	
		// Recursive merge two objects into one, second parameter overides the first
		// @param a array
		merge: function merge() /* Args: a, b, c, .. n */{
			var args = Array.prototype.slice.call(arguments);
			args.unshift({});
			return this.extend.apply(null, args);
		},
	
		// Makes it easier to assign parameters, where some are optional
		// @param o object
		// @param a arguments
		args: function args(o, _args) {
	
			var p = {};
			var i = 0;
			var t = null;
			var x = null;
	
			// 'x' is the first key in the list of object parameters
			for (x in o) {
				if (o.hasOwnProperty(x)) {
					break;
				}
			}
	
			// Passing in hash object of arguments?
			// Where the first argument can't be an object
			if (_args.length === 1 && _typeof(_args[0]) === 'object' && o[x] != 'o!') {
	
				// Could this object still belong to a property?
				// Check the object keys if they match any of the property keys
				for (x in _args[0]) {
					if (o.hasOwnProperty(x)) {
						// Does this key exist in the property list?
						if (x in o) {
							// Yes this key does exist so its most likely this function has been invoked with an object parameter
							// Return first argument as the hash of all arguments
							return _args[0];
						}
					}
				}
			}
	
			// Else loop through and account for the missing ones.
			for (x in o) {
				if (o.hasOwnProperty(x)) {
	
					t = _typeof(_args[i]);
	
					if (typeof o[x] === 'function' && o[x].test(_args[i]) || typeof o[x] === 'string' && (o[x].indexOf('s') > -1 && t === 'string' || o[x].indexOf('o') > -1 && t === 'object' || o[x].indexOf('i') > -1 && t === 'number' || o[x].indexOf('a') > -1 && t === 'object' || o[x].indexOf('f') > -1 && t === 'function')) {
						p[x] = _args[i++];
					} else if (typeof o[x] === 'string' && o[x].indexOf('!') > -1) {
						return false;
					}
				}
			}
	
			return p;
		},
	
		// Returns a URL instance
		url: function url(path) {
	
			// If the path is empty
			if (!path) {
				return window.location;
			}
	
			// Chrome and FireFox support new URL() to extract URL objects
			else if (window.URL && URL instanceof Function && URL.length !== 0) {
					return new URL(path, window.location);
				}
	
				// Ugly shim, it works!
				else {
						var a = document.createElement('a');
						a.href = path;
						return a.cloneNode(false);
					}
		},
	
		diff: function diff(a, b) {
			return b.filter(function (item) {
				return a.indexOf(item) === -1;
			});
		},
	
		// Get the different hash of properties unique to `a`, and not in `b`
		diffKey: function diffKey(a, b) {
			if (a || !b) {
				var r = {};
				for (var x in a) {
					// Does the property not exist?
					if (!(x in b)) {
						r[x] = a[x];
					}
				}
	
				return r;
			}
	
			return a;
		},
	
		// Unique
		// Remove duplicate and null values from an array
		// @param a array
		unique: function unique(a) {
			if (!Array.isArray(a)) {
				return [];
			}
	
			return a.filter(function (item, index) {
				// Is this the first location of item
				return a.indexOf(item) === index;
			});
		},
	
		isEmpty: function isEmpty(obj) {
	
			// Scalar
			if (!obj) return true;
	
			// Array
			if (Array.isArray(obj)) {
				return !obj.length;
			} else if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') {
				// Object
				for (var key in obj) {
					if (obj.hasOwnProperty(key)) {
						return false;
					}
				}
			}
	
			return true;
		},
	
		//jscs:disable
	
		/*!
	  **  Thenable -- Embeddable Minimum Strictly-Compliant Promises/A+ 1.1.1 Thenable
	  **  Copyright (c) 2013-2014 Ralf S. Engelschall <http://engelschall.com>
	  **  Licensed under The MIT License <http://opensource.org/licenses/MIT>
	  **  Source-Code distributed on <http://github.com/rse/thenable>
	  */
		Promise: function () {
			/*  promise states [Promises/A+ 2.1]  */
			var STATE_PENDING = 0; /*  [Promises/A+ 2.1.1]  */
			var STATE_FULFILLED = 1; /*  [Promises/A+ 2.1.2]  */
			var STATE_REJECTED = 2; /*  [Promises/A+ 2.1.3]  */
	
			/*  promise object constructor  */
			var api = function api(executor) {
				/*  optionally support non-constructor/plain-function call  */
				if (!(this instanceof api)) return new api(executor);
	
				/*  initialize object  */
				this.id = "Thenable/1.0.6";
				this.state = STATE_PENDING; /*  initial state  */
				this.fulfillValue = undefined; /*  initial value  */ /*  [Promises/A+ 1.3, 2.1.2.2]  */
				this.rejectReason = undefined; /*  initial reason */ /*  [Promises/A+ 1.5, 2.1.3.2]  */
				this.onFulfilled = []; /*  initial handlers  */
				this.onRejected = []; /*  initial handlers  */
	
				/*  provide optional information-hiding proxy  */
				this.proxy = {
					then: this.then.bind(this)
				};
	
				/*  support optional executor function  */
				if (typeof executor === "function") executor.call(this, this.fulfill.bind(this), this.reject.bind(this));
			};
	
			/*  promise API methods  */
			api.prototype = {
				/*  promise resolving methods  */
				fulfill: function fulfill(value) {
					return deliver(this, STATE_FULFILLED, "fulfillValue", value);
				},
				reject: function reject(value) {
					return deliver(this, STATE_REJECTED, "rejectReason", value);
				},
	
				/*  "The then Method" [Promises/A+ 1.1, 1.2, 2.2]  */
				then: function then(onFulfilled, onRejected) {
					var curr = this;
					var next = new api(); /*  [Promises/A+ 2.2.7]  */
					curr.onFulfilled.push(resolver(onFulfilled, next, "fulfill")); /*  [Promises/A+ 2.2.2/2.2.6]  */
					curr.onRejected.push(resolver(onRejected, next, "reject")); /*  [Promises/A+ 2.2.3/2.2.6]  */
					execute(curr);
					return next.proxy; /*  [Promises/A+ 2.2.7, 3.3]  */
				}
			};
	
			/*  deliver an action  */
			var deliver = function deliver(curr, state, name, value) {
				if (curr.state === STATE_PENDING) {
					curr.state = state; /*  [Promises/A+ 2.1.2.1, 2.1.3.1]  */
					curr[name] = value; /*  [Promises/A+ 2.1.2.2, 2.1.3.2]  */
					execute(curr);
				}
				return curr;
			};
	
			/*  execute all handlers  */
			var execute = function execute(curr) {
				if (curr.state === STATE_FULFILLED) execute_handlers(curr, "onFulfilled", curr.fulfillValue);else if (curr.state === STATE_REJECTED) execute_handlers(curr, "onRejected", curr.rejectReason);
			};
	
			/*  execute particular set of handlers  */
			var execute_handlers = function execute_handlers(curr, name, value) {
				/* global process: true */
				/* global setImmediate: true */
				/* global setTimeout: true */
	
				/*  short-circuit processing  */
				if (curr[name].length === 0) return;
	
				/*  iterate over all handlers, exactly once  */
				var handlers = curr[name];
				curr[name] = []; /*  [Promises/A+ 2.2.2.3, 2.2.3.3]  */
				var func = function func() {
					for (var i = 0; i < handlers.length; i++) {
						handlers[i](value);
					} /*  [Promises/A+ 2.2.5]  */
				};
	
				/*  execute procedure asynchronously  */ /*  [Promises/A+ 2.2.4, 3.1]  */
				if ((typeof process === 'undefined' ? 'undefined' : _typeof(process)) === "object" && typeof process.nextTick === "function") process.nextTick(func);else if (typeof setImmediate === "function") setImmediate(func);else setTimeout(func, 0);
			};
	
			/*  generate a resolver function  */
			var resolver = function resolver(cb, next, method) {
				return function (value) {
					if (typeof cb !== "function") /*  [Promises/A+ 2.2.1, 2.2.7.3, 2.2.7.4]  */
						next[method].call(next, value); /*  [Promises/A+ 2.2.7.3, 2.2.7.4]  */
					else {
							var result;
							try {
								result = cb(value);
							} /*  [Promises/A+ 2.2.2.1, 2.2.3.1, 2.2.5, 3.2]  */
							catch (e) {
								next.reject(e); /*  [Promises/A+ 2.2.7.2]  */
								return;
							}
							resolve(next, result); /*  [Promises/A+ 2.2.7.1]  */
						}
				};
			};
	
			/*  "Promise Resolution Procedure"  */ /*  [Promises/A+ 2.3]  */
			var resolve = function resolve(promise, x) {
				/*  sanity check arguments  */ /*  [Promises/A+ 2.3.1]  */
				if (promise === x || promise.proxy === x) {
					promise.reject(new TypeError("cannot resolve promise with itself"));
					return;
				}
	
				/*  surgically check for a "then" method
	   	(mainly to just call the "getter" of "then" only once)  */
				var then;
				if ((typeof x === 'undefined' ? 'undefined' : _typeof(x)) === "object" && x !== null || typeof x === "function") {
					try {
						then = x.then;
					} /*  [Promises/A+ 2.3.3.1, 3.5]  */
					catch (e) {
						promise.reject(e); /*  [Promises/A+ 2.3.3.2]  */
						return;
					}
				}
	
				/*  handle own Thenables    [Promises/A+ 2.3.2]
	   	and similar "thenables" [Promises/A+ 2.3.3]  */
				if (typeof then === "function") {
					var resolved = false;
					try {
						/*  call retrieved "then" method */ /*  [Promises/A+ 2.3.3.3]  */
						then.call(x,
						/*  resolvePromise  */ /*  [Promises/A+ 2.3.3.3.1]  */
						function (y) {
							if (resolved) return;resolved = true; /*  [Promises/A+ 2.3.3.3.3]  */
							if (y === x) /*  [Promises/A+ 3.6]  */
								promise.reject(new TypeError("circular thenable chain"));else resolve(promise, y);
						},
	
						/*  rejectPromise  */ /*  [Promises/A+ 2.3.3.3.2]  */
						function (r) {
							if (resolved) return;resolved = true; /*  [Promises/A+ 2.3.3.3.3]  */
							promise.reject(r);
						});
					} catch (e) {
						if (!resolved) /*  [Promises/A+ 2.3.3.3.3]  */
							promise.reject(e); /*  [Promises/A+ 2.3.3.3.4]  */
					}
					return;
				}
	
				/*  handle other values  */
				promise.fulfill(x); /*  [Promises/A+ 2.3.4, 2.3.3.4]  */
			};
	
			/*  export API  */
			return api;
		}(),
	
		//jscs:enable
	
		// Event
		// A contructor superclass for adding event menthods, on, off, emit.
		Event: function Event() {
	
			var separator = /[\s\,]+/;
	
			// If this doesn't support getPrototype then we can't get prototype.events of the parent
			// So lets get the current instance events, and add those to a parent property
			this.parent = {
				events: this.events,
				findEvents: this.findEvents,
				parent: this.parent,
				utils: this.utils
			};
	
			this.events = {};
	
			// On, subscribe to events
			// @param evt   string
			// @param callback  function
			this.on = function (evt, callback) {
	
				if (callback && typeof callback === 'function') {
					var a = evt.split(separator);
					for (var i = 0; i < a.length; i++) {
	
						// Has this event already been fired on this instance?
						this.events[a[i]] = [callback].concat(this.events[a[i]] || []);
					}
				}
	
				return this;
			};
	
			// Off, unsubscribe to events
			// @param evt   string
			// @param callback  function
			this.off = function (evt, callback) {
	
				this.findEvents(evt, function (name, index) {
					if (!callback || this.events[name][index] === callback) {
						this.events[name][index] = null;
					}
				});
	
				return this;
			};
	
			// Emit
			// Triggers any subscribed events
			this.emit = function (evt /*, data, ... */) {
	
				// Get arguments as an Array, knock off the first one
				var args = Array.prototype.slice.call(arguments, 1);
				args.push(evt);
	
				// Handler
				var handler = function handler(name, index) {
	
					// Replace the last property with the event name
					args[args.length - 1] = name === '*' ? evt : name;
	
					// Trigger
					this.events[name][index].apply(this, args);
				};
	
				// Find the callbacks which match the condition and call
				var _this = this;
				while (_this && _this.findEvents) {
	
					// Find events which match
					_this.findEvents(evt + ',*', handler);
					_this = _this.parent;
				}
	
				return this;
			};
	
			//
			// Easy functions
			this.emitAfter = function () {
				var _this = this;
				var args = arguments;
				setTimeout(function () {
					_this.emit.apply(_this, args);
				}, 0);
	
				return this;
			};
	
			this.findEvents = function (evt, callback) {
	
				var a = evt.split(separator);
	
				for (var name in this.events) {
					if (this.events.hasOwnProperty(name)) {
	
						if (a.indexOf(name) > -1) {
	
							for (var i = 0; i < this.events[name].length; i++) {
	
								// Does the event handler exist?
								if (this.events[name][i]) {
									// Emit on the local instance of this
									callback.call(this, name, i);
								}
							}
						}
					}
				}
			};
	
			return this;
		},
	
		// Global Events
		// Attach the callback to the window object
		// Return its unique reference
		globalEvent: function globalEvent(callback, guid) {
			// If the guid has not been supplied then create a new one.
			guid = guid || '_hellojs_' + parseInt(Math.random() * 1e12, 10).toString(36);
	
			// Define the callback function
			window[guid] = function () {
				// Trigger the callback
				try {
					if (callback.apply(this, arguments)) {
						delete window[guid];
					}
				} catch (e) {
					console.error(e);
				}
			};
	
			return guid;
		},
	
		// Trigger a clientside popup
		// This has been augmented to support PhoneGap
		popup: function popup(url, redirectUri, options) {
	
			var documentElement = document.documentElement;
	
			// Multi Screen Popup Positioning (http://stackoverflow.com/a/16861050)
			// Credit: http://www.xtf.dk/2011/08/center-new-popup-window-even-on.html
			// Fixes dual-screen position                         Most browsers      Firefox
	
			if (options.height && options.top === undefined) {
				var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;
				var height = screen.height || window.innerHeight || documentElement.clientHeight;
				options.top = parseInt((height - options.height) / 2, 10) + dualScreenTop;
			}
	
			if (options.width && options.left === undefined) {
				var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
				var width = screen.width || window.innerWidth || documentElement.clientWidth;
				options.left = parseInt((width - options.width) / 2, 10) + dualScreenLeft;
			}
	
			// Convert options into an array
			var optionsArray = [];
			Object.keys(options).forEach(function (name) {
				var value = options[name];
				optionsArray.push(name + (value !== null ? '=' + value : ''));
			});
	
			// Call the open() function with the initial path
			//
			// OAuth redirect, fixes URI fragments from being lost in Safari
			// (URI Fragments within 302 Location URI are lost over HTTPS)
			// Loading the redirect.html before triggering the OAuth Flow seems to fix it.
			//
			// Firefox  decodes URL fragments when calling location.hash.
			//  - This is bad if the value contains break points which are escaped
			//  - Hence the url must be encoded twice as it contains breakpoints.
			if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
				url = redirectUri + '#oauth_redirect=' + encodeURIComponent(encodeURIComponent(url));
			}
	
			var popup = window.open(url, '_blank', optionsArray.join(','));
	
			if (popup && popup.focus) {
				popup.focus();
			}
	
			return popup;
		},
	
		// OAuth and API response handler
		responseHandler: function responseHandler(window, parent) {
	
			var _this = this;
			var p;
			var location = window.location;
	
			// Is this an auth relay message which needs to call the proxy?
			p = _this.param(location.search);
	
			// OAuth2 or OAuth1 server response?
			if (p && p.state && (p.code || p.oauth_token)) {
	
				// Reverse base64 encoding of state string that we sent to provider.
				if (p.state.substring(0, 3) === 'eyJ') {
					p.state = atob(p.state);
				}
	
				var state = JSON.parse(p.state);
	
				// Add this path as the redirect_uri
				p.redirect_uri = state.redirect_uri || location.href.replace(/[\?\#].*$/, '');
	
				// Redirect to the host
				var path = _this.qs(state.oauth_proxy, p);
	
				location.assign(path);
	
				return;
			}
	
			// Save session, from redirected authentication
			// #access_token has come in?
			//
			// FACEBOOK is returning auth errors within as a query_string... thats a stickler for consistency.
			// SoundCloud is the state in the querystring and the token in the hashtag, so we'll mix the two together
	
			p = _this.merge(_this.param(location.search || ''), _this.param(location.hash || ''));
	
			// If p.state
			if (p && 'state' in p) {
	
				// Remove any addition information
				// E.g. p.state = 'facebook.page';
				try {
					var a = JSON.parse(p.state);
					_this.extend(p, a);
				} catch (e) {
					var stateDecoded = decodeURIComponent(p.state);
					try {
						var b = JSON.parse(stateDecoded);
						_this.extend(p, b);
					} catch (e) {
						console.error('Could not decode state parameter');
					}
				}
	
				// Access_token?
				if ('access_token' in p && p.access_token && p.network) {
	
					if (!p.expires_in || parseInt(p.expires_in, 10) === 0) {
						// If p.expires_in is unset, set to 0
						p.expires_in = 0;
					}
	
					p.expires_in = parseInt(p.expires_in, 10);
					p.expires = new Date().getTime() / 1e3 + (p.expires_in || 60 * 60 * 24 * 365);
	
					// Lets use the "state" to assign it to one of our networks
					authCallback(p, window, parent);
				}
	
				// Error=?
				// &error_description=?
				// &state=?
				else if ('error' in p && p.error && p.network) {
	
						p.error = {
							code: p.error,
							message: p.error_message || p.error_description
						};
	
						// Let the state handler handle it
						authCallback(p, window, parent);
					}
	
					// API call, or a cancelled login
					// Result is serialized JSON string
					else if (p.callback && p.callback in parent) {
	
							// Trigger a function in the parent
							var res = 'result' in p && p.result ? JSON.parse(p.result) : false;
	
							// Trigger the callback on the parent
							callback(parent, p.callback)(res);
							closeWindow();
						}
	
				// If this page is still open
				if (p.page_uri) {
					location.assign(p.page_uri);
				}
			}
	
			// OAuth redirect, fixes URI fragments from being lost in Safari
			// (URI Fragments within 302 Location URI are lost over HTTPS)
			// Loading the redirect.html before triggering the OAuth Flow seems to fix it.
			else if ('oauth_redirect' in p) {
	
					location.assign(decodeURIComponent(p.oauth_redirect));
					return;
				}
	
			// Trigger a callback to authenticate
			function authCallback(obj, window, parent) {
	
				var cb = obj.callback;
				var network = obj.network;
	
				// Trigger the callback on the parent
				_this.store(network, obj);
	
				// If this is a page request it has no parent or opener window to handle callbacks
				if ('display' in obj && obj.display === 'page') {
					return;
				}
	
				// Remove from session object
				if (parent && cb && cb in parent) {
	
					try {
						delete obj.callback;
					} catch (e) {}
	
					// Update store
					_this.store(network, obj);
	
					// Call the globalEvent function on the parent
					// It's safer to pass back a string to the parent,
					// Rather than an object/array (better for IE8)
					var str = JSON.stringify(obj);
	
					try {
						callback(parent, cb)(str);
					} catch (e) {
						// Error thrown whilst executing parent callback
					}
				}
	
				closeWindow();
			}
	
			function callback(parent, callbackID) {
				if (callbackID.indexOf('_hellojs_') !== 0) {
					return function () {
						throw 'Could not execute callback ' + callbackID;
					};
				}
	
				return parent[callbackID];
			}
	
			function closeWindow() {
	
				if (window.frameElement) {
					// Inside an iframe, remove from parent
					parent.document.body.removeChild(window.frameElement);
				} else {
					// Close this current window
					try {
						window.close();
					} catch (e) {}
	
					// IOS bug wont let us close a popup if still loading
					if (window.addEventListener) {
						window.addEventListener('load', function () {
							window.close();
						});
					}
				}
			}
		}
	});
	
	// Events
	// Extend the hello object with its own event instance
	hello.utils.Event.call(hello);
	
	///////////////////////////////////
	// Monitoring session state
	// Check for session changes
	///////////////////////////////////
	
	(function (hello) {
	
		// Monitor for a change in state and fire
		var oldSessions = {};
	
		// Hash of expired tokens
		var expired = {};
	
		// Listen to other triggers to Auth events, use these to update this
		hello.on('auth.login, auth.logout', function (auth) {
			if (auth && (typeof auth === 'undefined' ? 'undefined' : _typeof(auth)) === 'object' && auth.network) {
				oldSessions[auth.network] = hello.utils.store(auth.network) || {};
			}
		});
	
		(function self() {
	
			var CURRENT_TIME = new Date().getTime() / 1e3;
			var emit = function emit(eventName) {
				hello.emit('auth.' + eventName, {
					network: name,
					authResponse: session
				});
			};
	
			// Loop through the services
			for (var name in hello.services) {
				if (hello.services.hasOwnProperty(name)) {
	
					if (!hello.services[name].id) {
						// We haven't attached an ID so dont listen.
						continue;
					}
	
					// Get session
					var session = hello.utils.store(name) || {};
					var provider = hello.services[name];
					var oldSess = oldSessions[name] || {};
	
					// Listen for globalEvents that did not get triggered from the child
					if (session && 'callback' in session) {
	
						// To do remove from session object...
						var cb = session.callback;
						try {
							delete session.callback;
						} catch (e) {}
	
						// Update store
						// Removing the callback
						hello.utils.store(name, session);
	
						// Emit global events
						try {
							window[cb](session);
						} catch (e) {}
					}
	
					// Refresh token
					if (session && 'expires' in session && session.expires < CURRENT_TIME) {
	
						// If auto refresh is possible
						// Either the browser supports
						var refresh = provider.refresh || session.refresh_token;
	
						// Has the refresh been run recently?
						if (refresh && (!(name in expired) || expired[name] < CURRENT_TIME)) {
							// Try to resignin
							hello.emit('notice', name + ' has expired trying to resignin');
							hello.login(name, { display: 'none', force: false });
	
							// Update expired, every 10 minutes
							expired[name] = CURRENT_TIME + 600;
						}
	
						// Does this provider not support refresh
						else if (!refresh && !(name in expired)) {
								// Label the event
								emit('expired');
								expired[name] = true;
							}
	
						// If session has expired then we dont want to store its value until it can be established that its been updated
						continue;
					}
	
					// Has session changed?
					else if (oldSess.access_token === session.access_token && oldSess.expires === session.expires) {
							continue;
						}
	
						// Access_token has been removed
						else if (!session.access_token && oldSess.access_token) {
								emit('logout');
							}
	
							// Access_token has been created
							else if (session.access_token && !oldSess.access_token) {
									emit('login');
								}
	
								// Access_token has been updated
								else if (session.expires !== oldSess.expires) {
										emit('update');
									}
	
					// Updated stored session
					oldSessions[name] = session;
	
					// Remove the expired flags
					if (name in expired) {
						delete expired[name];
					}
				}
			}
	
			// Check error events
			setTimeout(self, 1000);
		})();
	})(hello);
	
	// EOF CORE lib
	//////////////////////////////////
	
	/////////////////////////////////////////
	// API
	// @param path    string
	// @param query   object (optional)
	// @param method  string (optional)
	// @param data    object (optional)
	// @param timeout integer (optional)
	// @param callback  function (optional)
	
	hello.api = function () {
	
		// Shorthand
		var _this = this;
		var utils = _this.utils;
		var error = utils.error;
	
		// Construct a new Promise object
		var promise = utils.Promise();
	
		// Arguments
		var p = utils.args({ path: 's!', query: 'o', method: 's', data: 'o', timeout: 'i', callback: 'f' }, arguments);
	
		// Method
		p.method = (p.method || 'get').toLowerCase();
	
		// Headers
		p.headers = p.headers || {};
	
		// Query
		p.query = p.query || {};
	
		// If get, put all parameters into query
		if (p.method === 'get' || p.method === 'delete') {
			utils.extend(p.query, p.data);
			p.data = {};
		}
	
		var data = p.data = p.data || {};
	
		// Completed event callback
		promise.then(p.callback, p.callback);
	
		// Remove the network from path, e.g. facebook:/me/friends
		// Results in { network : facebook, path : me/friends }
		if (!p.path) {
			return promise.reject(error('invalid_path', 'Missing the path parameter from the request'));
		}
	
		p.path = p.path.replace(/^\/+/, '');
		var a = (p.path.split(/[\/\:]/, 2) || [])[0].toLowerCase();
	
		if (a in _this.services) {
			p.network = a;
			var reg = new RegExp('^' + a + ':?\/?');
			p.path = p.path.replace(reg, '');
		}
	
		// Network & Provider
		// Define the network that this request is made for
		p.network = _this.settings.default_service = p.network || _this.settings.default_service;
		var o = _this.services[p.network];
	
		// INVALID
		// Is there no service by the given network name?
		if (!o) {
			return promise.reject(error('invalid_network', 'Could not match the service requested: ' + p.network));
		}
	
		// PATH
		// As long as the path isn't flagged as unavaiable, e.g. path == false
	
		if (!(!(p.method in o) || !(p.path in o[p.method]) || o[p.method][p.path] !== false)) {
			return promise.reject(error('invalid_path', 'The provided path is not available on the selected network'));
		}
	
		// PROXY
		// OAuth1 calls always need a proxy
	
		if (!p.oauth_proxy) {
			p.oauth_proxy = _this.settings.oauth_proxy;
		}
	
		if (!('proxy' in p)) {
			p.proxy = p.oauth_proxy && o.oauth && parseInt(o.oauth.version, 10) === 1;
		}
	
		// TIMEOUT
		// Adopt timeout from global settings by default
	
		if (!('timeout' in p)) {
			p.timeout = _this.settings.timeout;
		}
	
		// Format response
		// Whether to run the raw response through post processing.
		if (!('formatResponse' in p)) {
			p.formatResponse = true;
		}
	
		// Get the current session
		// Append the access_token to the query
		p.authResponse = _this.getAuthResponse(p.network);
		if (p.authResponse && p.authResponse.access_token) {
			p.query.access_token = p.authResponse.access_token;
		}
	
		var url = p.path;
		var m;
	
		// Store the query as options
		// This is used to populate the request object before the data is augmented by the prewrap handlers.
		p.options = utils.clone(p.query);
	
		// Clone the data object
		// Prevent this script overwriting the data of the incoming object.
		// Ensure that everytime we run an iteration the callbacks haven't removed some data
		p.data = utils.clone(data);
	
		// URL Mapping
		// Is there a map for the given URL?
		var actions = o[{ 'delete': 'del' }[p.method] || p.method] || {};
	
		// Extrapolate the QueryString
		// Provide a clean path
		// Move the querystring into the data
		if (p.method === 'get') {
	
			var query = url.split(/[\?#]/)[1];
			if (query) {
				utils.extend(p.query, utils.param(query));
	
				// Remove the query part from the URL
				url = url.replace(/\?.*?(#|$)/, '$1');
			}
		}
	
		// Is the hash fragment defined
		if (m = url.match(/#(.+)/, '')) {
			url = url.split('#')[0];
			p.path = m[1];
		} else if (url in actions) {
			p.path = url;
			url = actions[url];
		} else if ('default' in actions) {
			url = actions['default'];
		}
	
		// Redirect Handler
		// This defines for the Form+Iframe+Hash hack where to return the results too.
		p.redirect_uri = _this.settings.redirect_uri;
	
		// Define FormatHandler
		// The request can be procesed in a multitude of ways
		// Here's the options - depending on the browser and endpoint
		p.xhr = o.xhr;
		p.jsonp = o.jsonp;
		p.form = o.form;
	
		// Make request
		if (typeof url === 'function') {
			// Does self have its own callback?
			url(p, getPath);
		} else {
			// Else the URL is a string
			getPath(url);
		}
	
		return promise.proxy;
	
		// If url needs a base
		// Wrap everything in
		function getPath(url) {
	
			// Format the string if it needs it
			url = url.replace(/\@\{([a-z\_\-]+)(\|.*?)?\}/gi, function (m, key, defaults) {
				var val = defaults ? defaults.replace(/^\|/, '') : '';
				if (key in p.query) {
					val = p.query[key];
					delete p.query[key];
				} else if (p.data && key in p.data) {
					val = p.data[key];
					delete p.data[key];
				} else if (!defaults) {
					promise.reject(error('missing_attribute', 'The attribute ' + key + ' is missing from the request'));
				}
	
				return val;
			});
	
			// Add base
			if (!url.match(/^https?:\/\//)) {
				url = o.base + url;
			}
	
			// Define the request URL
			p.url = url;
	
			// Make the HTTP request with the curated request object
			// CALLBACK HANDLER
			// @ response object
			// @ statusCode integer if available
			utils.request(p, function (r, headers) {
	
				// Is this a raw response?
				if (!p.formatResponse) {
					// Bad request? error statusCode or otherwise contains an error response vis JSONP?
					if ((typeof headers === 'undefined' ? 'undefined' : _typeof(headers)) === 'object' ? headers.statusCode >= 400 : (typeof r === 'undefined' ? 'undefined' : _typeof(r)) === 'object' && 'error' in r) {
						promise.reject(r);
					} else {
						promise.fulfill(r);
					}
	
					return;
				}
	
				// Should this be an object
				if (r === true) {
					r = { success: true };
				} else if (!r) {
					r = {};
				}
	
				// The delete callback needs a better response
				if (p.method === 'delete') {
					r = !r || utils.isEmpty(r) ? { success: true } : r;
				}
	
				// FORMAT RESPONSE?
				// Does self request have a corresponding formatter
				if (o.wrap && (p.path in o.wrap || 'default' in o.wrap)) {
					var wrap = p.path in o.wrap ? p.path : 'default';
					var time = new Date().getTime();
	
					// FORMAT RESPONSE
					var b = o.wrap[wrap](r, headers, p);
	
					// Has the response been utterly overwritten?
					// Typically self augments the existing object.. but for those rare occassions
					if (b) {
						r = b;
					}
				}
	
				// Is there a next_page defined in the response?
				if (r && 'paging' in r && r.paging.next) {
	
					// Add the relative path if it is missing from the paging/next path
					if (r.paging.next[0] === '?') {
						r.paging.next = p.path + r.paging.next;
					}
	
					// The relative path has been defined, lets markup the handler in the HashFragment
					else {
							r.paging.next += '#' + p.path;
						}
				}
	
				// Dispatch to listeners
				// Emit events which pertain to the formatted response
				if (!r || 'error' in r) {
					promise.reject(r);
				} else {
					promise.fulfill(r);
				}
			});
		}
	};
	
	// API utilities
	hello.utils.extend(hello.utils, {
	
		// Make an HTTP request
		request: function request(p, callback) {
	
			var _this = this;
			var error = _this.error;
	
			// This has to go through a POST request
			if (!_this.isEmpty(p.data) && !('FileList' in window) && _this.hasBinary(p.data)) {
	
				// Disable XHR and JSONP
				p.xhr = false;
				p.jsonp = false;
			}
	
			// Check if the browser and service support CORS
			var cors = this.request_cors(function () {
				// If it does then run this...
				return p.xhr === undefined || p.xhr && (typeof p.xhr !== 'function' || p.xhr(p, p.query));
			});
	
			if (cors) {
	
				formatUrl(p, function (url) {
	
					var x = _this.xhr(p.method, url, p.headers, p.data, callback);
					x.onprogress = p.onprogress || null;
	
					// Windows Phone does not support xhr.upload, see #74
					// Feature detect
					if (x.upload && p.onuploadprogress) {
						x.upload.onprogress = p.onuploadprogress;
					}
				});
	
				return;
			}
	
			// Clone the query object
			// Each request modifies the query object and needs to be tared after each one.
			var _query = p.query;
	
			p.query = _this.clone(p.query);
	
			// Assign a new callbackID
			p.callbackID = _this.globalEvent();
	
			// JSONP
			if (p.jsonp !== false) {
	
				// Clone the query object
				p.query.callback = p.callbackID;
	
				// If the JSONP is a function then run it
				if (typeof p.jsonp === 'function') {
					p.jsonp(p, p.query);
				}
	
				// Lets use JSONP if the method is 'get'
				if (p.method === 'get') {
	
					formatUrl(p, function (url) {
						_this.jsonp(url, callback, p.callbackID, p.timeout);
					});
	
					return;
				} else {
					// It's not compatible reset query
					p.query = _query;
				}
			}
	
			// Otherwise we're on to the old school, iframe hacks and JSONP
			if (p.form !== false) {
	
				// Add some additional query parameters to the URL
				// We're pretty stuffed if the endpoint doesn't like these
				p.query.redirect_uri = p.redirect_uri;
				p.query.state = JSON.stringify({ callback: p.callbackID });
	
				var opts;
	
				if (typeof p.form === 'function') {
	
					// Format the request
					opts = p.form(p, p.query);
				}
	
				if (p.method === 'post' && opts !== false) {
	
					formatUrl(p, function (url) {
						_this.post(url, p.data, opts, callback, p.callbackID, p.timeout);
					});
	
					return;
				}
			}
	
			// None of the methods were successful throw an error
			callback(error('invalid_request', 'There was no mechanism for handling this request'));
	
			return;
	
			// Format URL
			// Constructs the request URL, optionally wraps the URL through a call to a proxy server
			// Returns the formatted URL
			function formatUrl(p, callback) {
	
				// Are we signing the request?
				var sign;
	
				// OAuth1
				// Remove the token from the query before signing
				if (p.authResponse && p.authResponse.oauth && parseInt(p.authResponse.oauth.version, 10) === 1) {
	
					// OAUTH SIGNING PROXY
					sign = p.query.access_token;
	
					// Remove the access_token
					delete p.query.access_token;
	
					// Enfore use of Proxy
					p.proxy = true;
				}
	
				// POST body to querystring
				if (p.data && (p.method === 'get' || p.method === 'delete')) {
					// Attach the p.data to the querystring.
					_this.extend(p.query, p.data);
					p.data = null;
				}
	
				// Construct the path
				var path = _this.qs(p.url, p.query);
	
				// Proxy the request through a server
				// Used for signing OAuth1
				// And circumventing services without Access-Control Headers
				if (p.proxy) {
					// Use the proxy as a path
					path = _this.qs(p.oauth_proxy, {
						path: path,
						access_token: sign || '',
	
						// This will prompt the request to be signed as though it is OAuth1
						then: p.proxy_response_type || (p.method.toLowerCase() === 'get' ? 'redirect' : 'proxy'),
						method: p.method.toLowerCase(),
						suppress_response_codes: true
					});
				}
	
				callback(path);
			}
		},
	
		// Test whether the browser supports the CORS response
		request_cors: function request_cors(callback) {
			return 'withCredentials' in new XMLHttpRequest() && callback();
		},
	
		// Return the type of DOM object
		domInstance: function domInstance(type, data) {
			var test = 'HTML' + (type || '').replace(/^[a-z]/, function (m) {
				return m.toUpperCase();
			}) + 'Element';
	
			if (!data) {
				return false;
			}
	
			if (window[test]) {
				return data instanceof window[test];
			} else if (window.Element) {
				return data instanceof window.Element && (!type || data.tagName && data.tagName.toLowerCase() === type);
			} else {
				return !(data instanceof Object || data instanceof Array || data instanceof String || data instanceof Number) && data.tagName && data.tagName.toLowerCase() === type;
			}
		},
	
		// Create a clone of an object
		clone: function clone(obj) {
			// Does not clone DOM elements, nor Binary data, e.g. Blobs, Filelists
			if (obj === null || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj instanceof Date || 'nodeName' in obj || this.isBinary(obj) || typeof FormData === 'function' && obj instanceof FormData) {
				return obj;
			}
	
			if (Array.isArray(obj)) {
				// Clone each item in the array
				return obj.map(this.clone.bind(this));
			}
	
			// But does clone everything else.
			var clone = {};
			for (var x in obj) {
				clone[x] = this.clone(obj[x]);
			}
	
			return clone;
		},
	
		// XHR: uses CORS to make requests
		xhr: function xhr(method, url, headers, data, callback) {
	
			var r = new XMLHttpRequest();
			var error = this.error;
	
			// Binary?
			var binary = false;
			if (method === 'blob') {
				binary = method;
				method = 'GET';
			}
	
			method = method.toUpperCase();
	
			// Xhr.responseType 'json' is not supported in any of the vendors yet.
			r.onload = function (e) {
				var json = r.response;
				try {
					json = JSON.parse(r.responseText);
				} catch (_e) {
					if (r.status === 401) {
						json = error('access_denied', r.statusText);
					}
				}
	
				var headers = headersToJSON(r.getAllResponseHeaders());
				headers.statusCode = r.status;
	
				callback(json || (method === 'GET' ? error('empty_response', 'Could not get resource') : {}), headers);
			};
	
			r.onerror = function (e) {
				var json = r.responseText;
				try {
					json = JSON.parse(r.responseText);
				} catch (_e) {}
	
				callback(json || error('access_denied', 'Could not get resource'));
			};
	
			var x;
	
			// Should we add the query to the URL?
			if (method === 'GET' || method === 'DELETE') {
				data = null;
			} else if (data && typeof data !== 'string' && !(data instanceof FormData) && !(data instanceof File) && !(data instanceof Blob)) {
				// Loop through and add formData
				var f = new FormData();
				for (x in data) {
					if (data.hasOwnProperty(x)) {
						if (data[x] instanceof HTMLInputElement) {
							if ('files' in data[x] && data[x].files.length > 0) {
								f.append(x, data[x].files[0]);
							}
						} else if (data[x] instanceof Blob) {
							f.append(x, data[x], data.name);
						} else {
							f.append(x, data[x]);
						}
					}
				}data = f;
			}
	
			// Open the path, async
			r.open(method, url, true);
	
			if (binary) {
				if ('responseType' in r) {
					r.responseType = binary;
				} else {
					r.overrideMimeType('text/plain; charset=x-user-defined');
				}
			}
	
			// Set any bespoke headers
			if (headers) {
				for (x in headers) {
					r.setRequestHeader(x, headers[x]);
				}
			}
	
			r.send(data);
	
			return r;
	
			// Headers are returned as a string
			function headersToJSON(s) {
				var r = {};
				var reg = /([a-z\-]+):\s?(.*);?/gi;
				var m;
				while (m = reg.exec(s)) {
					r[m[1]] = m[2];
				}
	
				return r;
			}
		},
	
		// JSONP
		// Injects a script tag into the DOM to be executed and appends a callback function to the window object
		// @param string/function pathFunc either a string of the URL or a callback function pathFunc(querystringhash, continueFunc);
		// @param function callback a function to call on completion;
		jsonp: function jsonp(url, callback, callbackID, timeout) {
	
			var _this = this;
			var error = _this.error;
	
			// Change the name of the callback
			var bool = 0;
			var head = document.getElementsByTagName('head')[0];
			var operaFix;
			var result = error('server_error', 'server_error');
			var cb = function cb() {
				if (!bool++) {
					window.setTimeout(function () {
						callback(result);
						head.removeChild(script);
					}, 0);
				}
			};
	
			// Add callback to the window object
			callbackID = _this.globalEvent(function (json) {
				result = json;
				return true;
	
				// Mark callback as done
			}, callbackID);
	
			// The URL is a function for some cases and as such
			// Determine its value with a callback containing the new parameters of this function.
			url = url.replace(new RegExp('=\\?(&|$)'), '=' + callbackID + '$1');
	
			// Build script tag
			var script = _this.append('script', {
				id: callbackID,
				name: callbackID,
				src: url,
				async: true,
				onload: cb,
				onerror: cb,
				onreadystatechange: function onreadystatechange() {
					if (/loaded|complete/i.test(this.readyState)) {
						cb();
					}
				}
			});
	
			// Opera fix error
			// Problem: If an error occurs with script loading Opera fails to trigger the script.onerror handler we specified
			//
			// Fix:
			// By setting the request to synchronous we can trigger the error handler when all else fails.
			// This action will be ignored if we've already called the callback handler "cb" with a successful onload event
			if (window.navigator.userAgent.toLowerCase().indexOf('opera') > -1) {
				operaFix = _this.append('script', {
					text: 'document.getElementById(\'' + callbackID + '\').onerror();'
				});
				script.async = false;
			}
	
			// Add timeout
			if (timeout) {
				window.setTimeout(function () {
					result = error('timeout', 'timeout');
					cb();
				}, timeout);
			}
	
			// TODO: add fix for IE,
			// However: unable recreate the bug of firing off the onreadystatechange before the script content has been executed and the value of "result" has been defined.
			// Inject script tag into the head element
			head.appendChild(script);
	
			// Append Opera Fix to run after our script
			if (operaFix) {
				head.appendChild(operaFix);
			}
		},
	
		// Post
		// Send information to a remote location using the post mechanism
		// @param string uri path
		// @param object data, key value data to send
		// @param function callback, function to execute in response
		post: function post(url, data, options, callback, callbackID, timeout) {
	
			var _this = this;
			var error = _this.error;
			var doc = document;
	
			// This hack needs a form
			var form = null;
			var reenableAfterSubmit = [];
			var newform;
			var i = 0;
			var x = null;
			var bool = 0;
			var cb = function cb(r) {
				if (!bool++) {
					callback(r);
				}
			};
	
			// What is the name of the callback to contain
			// We'll also use this to name the iframe
			_this.globalEvent(cb, callbackID);
	
			// Build the iframe window
			var win;
			try {
				// IE7 hack, only lets us define the name here, not later.
				win = doc.createElement('<iframe name="' + callbackID + '">');
			} catch (e) {
				win = doc.createElement('iframe');
			}
	
			win.name = callbackID;
			win.id = callbackID;
			win.style.display = 'none';
	
			// Override callback mechanism. Triggger a response onload/onerror
			if (options && options.callbackonload) {
				// Onload is being fired twice
				win.onload = function () {
					cb({
						response: 'posted',
						message: 'Content was posted'
					});
				};
			}
	
			if (timeout) {
				setTimeout(function () {
					cb(error('timeout', 'The post operation timed out'));
				}, timeout);
			}
	
			doc.body.appendChild(win);
	
			// If we are just posting a single item
			if (_this.domInstance('form', data)) {
				// Get the parent form
				form = data.form;
	
				// Loop through and disable all of its siblings
				for (i = 0; i < form.elements.length; i++) {
					if (form.elements[i] !== data) {
						form.elements[i].setAttribute('disabled', true);
					}
				}
	
				// Move the focus to the form
				data = form;
			}
	
			// Posting a form
			if (_this.domInstance('form', data)) {
				// This is a form element
				form = data;
	
				// Does this form need to be a multipart form?
				for (i = 0; i < form.elements.length; i++) {
					if (!form.elements[i].disabled && form.elements[i].type === 'file') {
						form.encoding = form.enctype = 'multipart/form-data';
						form.elements[i].setAttribute('name', 'file');
					}
				}
			} else {
				// Its not a form element,
				// Therefore it must be a JSON object of Key=>Value or Key=>Element
				// If anyone of those values are a input type=file we shall shall insert its siblings into the form for which it belongs.
				for (x in data) {
					if (data.hasOwnProperty(x)) {
						// Is this an input Element?
						if (_this.domInstance('input', data[x]) && data[x].type === 'file') {
							form = data[x].form;
							form.encoding = form.enctype = 'multipart/form-data';
						}
					}
				} // Do If there is no defined form element, lets create one.
				if (!form) {
					// Build form
					form = doc.createElement('form');
					doc.body.appendChild(form);
					newform = form;
				}
	
				var input;
	
				// Add elements to the form if they dont exist
				for (x in data) {
					if (data.hasOwnProperty(x)) {
	
						// Is this an element?
						var el = _this.domInstance('input', data[x]) || _this.domInstance('textArea', data[x]) || _this.domInstance('select', data[x]);
	
						// Is this not an input element, or one that exists outside the form.
						if (!el || data[x].form !== form) {
	
							// Does an element have the same name?
							var inputs = form.elements[x];
							if (input) {
								// Remove it.
								if (!(inputs instanceof NodeList)) {
									inputs = [inputs];
								}
	
								for (i = 0; i < inputs.length; i++) {
									inputs[i].parentNode.removeChild(inputs[i]);
								}
							}
	
							// Create an input element
							input = doc.createElement('input');
							input.setAttribute('type', 'hidden');
							input.setAttribute('name', x);
	
							// Does it have a value attribute?
							if (el) {
								input.value = data[x].value;
							} else if (_this.domInstance(null, data[x])) {
								input.value = data[x].innerHTML || data[x].innerText;
							} else {
								input.value = data[x];
							}
	
							form.appendChild(input);
						}
	
						// It is an element, which exists within the form, but the name is wrong
						else if (el && data[x].name !== x) {
								data[x].setAttribute('name', x);
								data[x].name = x;
							}
					}
				} // Disable elements from within the form if they weren't specified
				for (i = 0; i < form.elements.length; i++) {
	
					input = form.elements[i];
	
					// Does the same name and value exist in the parent
					if (!(input.name in data) && input.getAttribute('disabled') !== true) {
						// Disable
						input.setAttribute('disabled', true);
	
						// Add re-enable to callback
						reenableAfterSubmit.push(input);
					}
				}
			}
	
			// Set the target of the form
			form.setAttribute('method', 'POST');
			form.setAttribute('target', callbackID);
			form.target = callbackID;
	
			// Update the form URL
			form.setAttribute('action', url);
	
			// Submit the form
			// Some reason this needs to be offset from the current window execution
			setTimeout(function () {
				form.submit();
	
				setTimeout(function () {
					try {
						// Remove the iframe from the page.
						//win.parentNode.removeChild(win);
						// Remove the form
						if (newform) {
							newform.parentNode.removeChild(newform);
						}
					} catch (e) {
						try {
							console.error('HelloJS: could not remove iframe');
						} catch (ee) {}
					}
	
					// Reenable the disabled form
					for (var i = 0; i < reenableAfterSubmit.length; i++) {
						if (reenableAfterSubmit[i]) {
							reenableAfterSubmit[i].setAttribute('disabled', false);
							reenableAfterSubmit[i].disabled = false;
						}
					}
				}, 0);
			}, 100);
		},
	
		// Some of the providers require that only multipart is used with non-binary forms.
		// This function checks whether the form contains binary data
		hasBinary: function hasBinary(data) {
			for (var x in data) {
				if (data.hasOwnProperty(x)) {
					if (this.isBinary(data[x])) {
						return true;
					}
				}
			}return false;
		},
	
		// Determines if a variable Either Is or like a FormInput has the value of a Blob
	
		isBinary: function isBinary(data) {
	
			return data instanceof Object && (this.domInstance('input', data) && data.type === 'file' || 'FileList' in window && data instanceof window.FileList || 'File' in window && data instanceof window.File || 'Blob' in window && data instanceof window.Blob);
		},
	
		// Convert Data-URI to Blob string
		toBlob: function toBlob(dataURI) {
			var reg = /^data\:([^;,]+(\;charset=[^;,]+)?)(\;base64)?,/i;
			var m = dataURI.match(reg);
			if (!m) {
				return dataURI;
			}
	
			var binary = atob(dataURI.replace(reg, ''));
			var array = [];
			for (var i = 0; i < binary.length; i++) {
				array.push(binary.charCodeAt(i));
			}
	
			return new Blob([new Uint8Array(array)], { type: m[1] });
		}
	
	});
	
	// EXTRA: Convert FormElement to JSON for POSTing
	// Wrappers to add additional functionality to existing functions
	(function (hello) {
	
		// Copy original function
		var api = hello.api;
		var utils = hello.utils;
	
		utils.extend(utils, {
	
			// DataToJSON
			// This takes a FormElement|NodeList|InputElement|MixedObjects and convers the data object to JSON.
			dataToJSON: function dataToJSON(p) {
	
				var _this = this;
				var w = window;
				var data = p.data;
	
				// Is data a form object
				if (_this.domInstance('form', data)) {
					data = _this.nodeListToJSON(data.elements);
				} else if ('NodeList' in w && data instanceof NodeList) {
					data = _this.nodeListToJSON(data);
				} else if (_this.domInstance('input', data)) {
					data = _this.nodeListToJSON([data]);
				}
	
				// Is data a blob, File, FileList?
				if ('File' in w && data instanceof w.File || 'Blob' in w && data instanceof w.Blob || 'FileList' in w && data instanceof w.FileList) {
					data = { file: data };
				}
	
				// Loop through data if it's not form data it must now be a JSON object
				if (!('FormData' in w && data instanceof w.FormData)) {
	
					for (var x in data) {
						if (data.hasOwnProperty(x)) {
	
							if ('FileList' in w && data[x] instanceof w.FileList) {
								if (data[x].length === 1) {
									data[x] = data[x][0];
								}
							} else if (_this.domInstance('input', data[x]) && data[x].type === 'file') {
								continue;
							} else if (_this.domInstance('input', data[x]) || _this.domInstance('select', data[x]) || _this.domInstance('textArea', data[x])) {
								data[x] = data[x].value;
							} else if (_this.domInstance(null, data[x])) {
								data[x] = data[x].innerHTML || data[x].innerText;
							}
						}
					}
				}
	
				p.data = data;
				return data;
			},
	
			// NodeListToJSON
			// Given a list of elements extrapolate their values and return as a json object
			nodeListToJSON: function nodeListToJSON(nodelist) {
	
				var json = {};
	
				// Create a data string
				for (var i = 0; i < nodelist.length; i++) {
	
					var input = nodelist[i];
	
					// If the name of the input is empty or diabled, dont add it.
					if (input.disabled || !input.name) {
						continue;
					}
	
					// Is this a file, does the browser not support 'files' and 'FormData'?
					if (input.type === 'file') {
						json[input.name] = input;
					} else {
						json[input.name] = input.value || input.innerHTML;
					}
				}
	
				return json;
			}
		});
	
		// Replace it
		hello.api = function () {
	
			// Get arguments
			var p = utils.args({ path: 's!', method: 's', data: 'o', timeout: 'i', callback: 'f' }, arguments);
	
			// Change for into a data object
			if (p.data) {
				utils.dataToJSON(p);
			}
	
			return api.call(this, p);
		};
	})(hello);
	
	/////////////////////////////////////
	//
	// Save any access token that is in the current page URL
	// Handle any response solicited through iframe hash tag following an API request
	//
	/////////////////////////////////////
	
	if (!window.__HELLO_JS_DO_NOT_HANDLE_RESPONSE) {
		hello.utils.responseHandler(window, window.opener || window.parent);
	}
	
	// Script to support ChromeApps
	// This overides the hello.utils.popup method to support chrome.identity.launchWebAuthFlow
	// See https://developer.chrome.com/apps/app_identity#non
	
	// Is this a chrome app?
	
	if ((typeof chrome === 'undefined' ? 'undefined' : _typeof(chrome)) === 'object' && _typeof(chrome.identity) === 'object' && chrome.identity.launchWebAuthFlow) {
	
		(function () {
	
			// Swap the popup method
			hello.utils.popup = function (url) {
	
				return _open(url, true);
			};
	
			// Swap the hidden iframe method
			hello.utils.iframe = function (url) {
	
				_open(url, false);
			};
	
			// Swap the request_cors method
			hello.utils.request_cors = function (callback) {
	
				callback();
	
				// Always run as CORS
	
				return true;
			};
	
			// Swap the storage method
			var _cache = {};
			chrome.storage.local.get('hello', function (r) {
				// Update the cache
				_cache = r.hello || {};
			});
	
			hello.utils.store = function (name, value) {
	
				// Get all
				if (arguments.length === 0) {
					return _cache;
				}
	
				// Get
				if (arguments.length === 1) {
					return _cache[name] || null;
				}
	
				// Set
				if (value) {
					_cache[name] = value;
					chrome.storage.local.set({ hello: _cache });
					return value;
				}
	
				// Delete
				if (value === null) {
					delete _cache[name];
					chrome.storage.local.set({ hello: _cache });
					return null;
				}
			};
	
			// Open function
			function _open(url, interactive) {
	
				// Launch
				var ref = {
					closed: false
				};
	
				// Launch the webAuthFlow
				chrome.identity.launchWebAuthFlow({
					url: url,
					interactive: interactive
				}, function (responseUrl) {
	
					// Did the user cancel this prematurely
					if (responseUrl === undefined) {
						ref.closed = true;
						return;
					}
	
					// Split appart the URL
					var a = hello.utils.url(responseUrl);
	
					// The location can be augmented in to a location object like so...
					// We dont have window operations on the popup so lets create some
					var _popup = {
						location: {
	
							// Change the location of the popup
							assign: function assign(url) {
	
								// If there is a secondary reassign
								// In the case of OAuth1
								// Trigger this in non-interactive mode.
								_open(url, false);
							},
	
							search: a.search,
							hash: a.hash,
							href: a.href
						},
						close: function close() {}
					};
	
					// Then this URL contains information which HelloJS must process
					// URL string
					// Window - any action such as window relocation goes here
					// Opener - the parent window which opened this, aka this script
	
					hello.utils.responseHandler(_popup, window);
				});
	
				// Return the reference
				return ref;
			}
		})();
	}
	
	// Phonegap override for hello.phonegap.js
	(function () {
	
		// Is this a phonegap implementation?
		if (!(/^file:\/{3}[^\/]/.test(window.location.href) && window.cordova)) {
			// Cordova is not included.
			return;
		}
	
		// Augment the hidden iframe method
		hello.utils.iframe = function (url, redirectUri) {
			hello.utils.popup(url, redirectUri, { hidden: 'yes' });
		};
	
		// Augment the popup
		var utilPopup = hello.utils.popup;
	
		// Replace popup
		hello.utils.popup = function (url, redirectUri, options) {
	
			// Run the standard
			var popup = utilPopup.call(this, url, redirectUri, options);
	
			// Create a function for reopening the popup, and assigning events to the new popup object
			// PhoneGap support
			// Add an event listener to listen to the change in the popup windows URL
			// This must appear before popup.focus();
			try {
				if (popup && popup.addEventListener) {
	
					// Get the origin of the redirect URI
	
					var a = hello.utils.url(redirectUri);
					var redirectUriOrigin = a.origin || a.protocol + '//' + a.hostname;
	
					// Listen to changes in the InAppBrowser window
	
					popup.addEventListener('loadstart', function (e) {
	
						var url = e.url;
	
						// Is this the path, as given by the redirectUri?
						// Check the new URL agains the redirectUriOrigin.
						// According to #63 a user could click 'cancel' in some dialog boxes ....
						// The popup redirects to another page with the same origin, yet we still wish it to close.
	
						if (url.indexOf(redirectUriOrigin) !== 0) {
							return;
						}
	
						// Split appart the URL
						var a = hello.utils.url(url);
	
						// We dont have window operations on the popup so lets create some
						// The location can be augmented in to a location object like so...
	
						var _popup = {
							location: {
								// Change the location of the popup
								assign: function assign(location) {
	
									// Unfourtunatly an app is may not change the location of a InAppBrowser window.
									// So to shim this, just open a new one.
									popup.executeScript({ code: 'window.location.href = "' + location + ';"' });
								},
	
								search: a.search,
								hash: a.hash,
								href: a.href
							},
							close: function close() {
								if (popup.close) {
									popup.close();
									try {
										popup.closed = true;
									} catch (_e) {}
								}
							}
						};
	
						// Then this URL contains information which HelloJS must process
						// URL string
						// Window - any action such as window relocation goes here
						// Opener - the parent window which opened this, aka this script
	
						hello.utils.responseHandler(_popup, window);
					});
				}
			} catch (e) {}
	
			return popup;
		};
	})();
	
	(function (hello) {
	
		// OAuth1
		var OAuth1Settings = {
			version: '1.0',
			auth: 'https://www.dropbox.com/1/oauth/authorize',
			request: 'https://api.dropbox.com/1/oauth/request_token',
			token: 'https://api.dropbox.com/1/oauth/access_token'
		};
	
		// OAuth2 Settings
		var OAuth2Settings = {
			version: 2,
			auth: 'https://www.dropbox.com/1/oauth2/authorize',
			grant: 'https://api.dropbox.com/1/oauth2/token'
		};
	
		// Initiate the Dropbox module
		hello.init({
	
			dropbox: {
	
				name: 'Dropbox',
	
				oauth: OAuth2Settings,
	
				login: function login(p) {
					// OAuth2 non-standard adjustments
					p.qs.scope = '';
	
					// Ask for refresh tokens
					p.qs.token_access_type = 'offline';
	
					// Should this be run as OAuth1?
					// If the redirect_uri is is HTTP (non-secure) then its required to revert to the OAuth1 endpoints
					var redirect = decodeURIComponent(p.qs.redirect_uri);
					if (redirect.indexOf('http:') === 0 && redirect.indexOf('http://localhost/') !== 0) {
	
						// Override the dropbox OAuth settings.
						hello.services.dropbox.oauth = OAuth1Settings;
					} else {
						// Override the dropbox OAuth settings.
						hello.services.dropbox.oauth = OAuth2Settings;
					}
	
					// The dropbox login window is a different size
					p.options.popup.width = 1000;
					p.options.popup.height = 1000;
				},
	
				/*
	   	Dropbox does not allow insecure HTTP URI's in the redirect_uri field
	   	...otherwise I'd love to use OAuth2
	   		Follow request https://forums.dropbox.com/topic.php?id=106505
	   		p.qs.response_type = 'code';
	   	oauth: {
	   		version: 2,
	   		auth: 'https://www.dropbox.com/1/oauth2/authorize',
	   		grant: 'https://api.dropbox.com/1/oauth2/token'
	   	}
	   */
	
				// API Base URL
				base: 'https://api.dropbox.com/1/',
	
				// Bespoke setting: this is states whether to use the custom environment of Dropbox or to use their own environment
				// Because it's notoriously difficult for Dropbox too provide access from other webservices, this defaults to Sandbox
				root: 'sandbox',
	
				// Map GET requests
				get: {
					me: 'account/info',
	
					// Https://www.dropbox.com/developers/core/docs#metadata
					'me/files': req('metadata/auto/@{parent|}'),
					'me/folder': req('metadata/auto/@{id}'),
					'me/folders': req('metadata/auto/'),
	
					'default': function _default(p, callback) {
						if (p.path.match('https://api-content.dropbox.com/1/files/')) {
							// This is a file, return binary data
							p.method = 'blob';
						}
	
						callback(p.path);
					}
				},
	
				post: {
					'me/files': function meFiles(p, callback) {
	
						var path = p.data.parent;
						var fileName = p.data.name;
	
						p.data = {
							file: p.data.file
						};
	
						// Does this have a data-uri to upload as a file?
						if (typeof p.data.file === 'string') {
							p.data.file = hello.utils.toBlob(p.data.file);
						}
	
						callback('https://api-content.dropbox.com/1/files_put/auto/' + path + '/' + fileName);
					},
	
					'me/folders': function meFolders(p, callback) {
	
						var name = p.data.name;
						p.data = {};
	
						callback('fileops/create_folder?root=@{root|sandbox}&' + hello.utils.param({
							path: name
						}));
					}
				},
	
				// Map DELETE requests
				del: {
					'me/files': 'fileops/delete?root=@{root|sandbox}&path=@{id}',
					'me/folder': 'fileops/delete?root=@{root|sandbox}&path=@{id}'
				},
	
				wrap: {
					me: function me(o) {
						formatError(o);
						if (!o.uid) {
							return o;
						}
	
						o.name = o.display_name;
						var m = o.name.split(' ');
						o.first_name = m.shift();
						o.last_name = m.join(' ');
						o.id = o.uid;
						delete o.uid;
						delete o.display_name;
						return o;
					},
	
					'default': function _default(o, headers, req) {
						formatError(o);
						if (o.is_dir && o.contents) {
							o.data = o.contents;
							delete o.contents;
	
							o.data.forEach(function (item) {
								item.root = o.root;
								formatFile(item, headers, req);
							});
						}
	
						formatFile(o, headers, req);
	
						if (o.is_deleted) {
							o.success = true;
						}
	
						return o;
					}
				},
	
				// Doesn't return the CORS headers
				xhr: function xhr(p) {
	
					// The proxy supports allow-cross-origin-resource
					// Alas that's the only thing we're using.
					if (p.data && p.data.file) {
						var file = p.data.file;
						if (file) {
							if (file.files) {
								p.data = file.files[0];
							} else {
								p.data = file;
							}
						}
					}
	
					if (p.method === 'delete') {
						p.method = 'post';
					}
	
					return true;
				},
	
				form: function form(p, qs) {
					delete qs.state;
					delete qs.redirect_uri;
				}
			}
		});
	
		function formatError(o) {
			if (o && 'error' in o) {
				o.error = {
					code: 'server_error',
					message: o.error.message || o.error
				};
			}
		}
	
		function formatFile(o, headers, req) {
	
			if ((typeof o === 'undefined' ? 'undefined' : _typeof(o)) !== 'object' || typeof Blob !== 'undefined' && o instanceof Blob || typeof ArrayBuffer !== 'undefined' && o instanceof ArrayBuffer) {
				// This is a file, let it through unformatted
				return;
			}
	
			if ('error' in o) {
				return;
			}
	
			var path = (o.root !== 'app_folder' ? o.root : '') + o.path.replace(/\&/g, '%26');
			path = path.replace(/^\//, '');
			if (o.thumb_exists) {
				o.thumbnail = req.oauth_proxy + '?path=' + encodeURIComponent('https://api-content.dropbox.com/1/thumbnails/auto/' + path + '?format=jpeg&size=m') + '&access_token=' + req.options.access_token;
			}
	
			o.type = o.is_dir ? 'folder' : o.mime_type;
			o.name = o.path.replace(/.*\//g, '');
			if (o.is_dir) {
				o.files = path.replace(/^\//, '');
			} else {
				o.downloadLink = hello.settings.oauth_proxy + '?path=' + encodeURIComponent('https://api-content.dropbox.com/1/files/auto/' + path) + '&access_token=' + req.options.access_token;
				o.file = 'https://api-content.dropbox.com/1/files/auto/' + path;
			}
	
			if (!o.id) {
				o.id = o.path.replace(/^\//, '');
			}
	
			// O.media = 'https://api-content.dropbox.com/1/files/' + path;
		}
	
		function req(str) {
			return function (p, cb) {
				delete p.query.limit;
				cb(str);
			};
		}
	})(hello);
	
	(function (hello) {
		// For APIs, once a version is no longer usable, any calls made to it will be defaulted to the next oldest usable version.
		// So we explicitly state it.
		var version = 'v2.9';
	
		hello.init({
	
			facebook: {
	
				name: 'Facebook',
	
				// SEE https://developers.facebook.com/docs/facebook-login/manually-build-a-login-flow
				oauth: {
					version: 2,
					auth: 'https://www.facebook.com/' + version + '/dialog/oauth/',
					grant: 'https://graph.facebook.com/oauth/access_token'
				},
	
				// Authorization scopes
				scope: {
					basic: 'public_profile',
					email: 'email',
					share: 'user_posts',
					birthday: 'user_birthday',
					events: 'user_events',
					photos: 'user_photos',
					videos: 'user_videos',
					friends: 'user_friends',
					files: 'user_photos,user_videos',
					publish_files: 'user_photos,user_videos,publish_actions',
					publish: 'publish_actions',
	
					// Deprecated in v2.0
					// Create_event	: 'create_event',
	
					offline_access: ''
				},
	
				// Refresh the access_token
				refresh: false,
	
				login: function login(p) {
	
					// Reauthenticate
					// https://developers.facebook.com/docs/facebook-login/reauthentication
					if (p.options.force) {
						p.qs.auth_type = 'reauthenticate';
					}
	
					// Set the display value
					p.qs.display = p.options.display || 'popup';
				},
	
				logout: function logout(callback, options) {
					// Assign callback to a global handler
					var callbackID = hello.utils.globalEvent(callback);
					var redirect = encodeURIComponent(hello.settings.redirect_uri + '?' + hello.utils.param({ callback: callbackID, result: JSON.stringify({ force: true }), state: '{}' }));
					var token = (options.authResponse || {}).access_token;
					hello.utils.iframe('https://www.facebook.com/logout.php?next=' + redirect + '&access_token=' + token);
	
					// Possible responses:
					// String URL	- hello.logout should handle the logout
					// Undefined	- this function will handle the callback
					// True - throw a success, this callback isn't handling the callback
					// False - throw a error
					if (!token) {
						// If there isn't a token, the above wont return a response, so lets trigger a response
						return false;
					}
				},
	
				// API Base URL
				base: 'https://graph.facebook.com/' + version + '/',
	
				// Map GET requests
				get: {
					me: 'me?fields=email,first_name,last_name,name,timezone,verified',
					'me/friends': 'me/friends',
					'me/following': 'me/friends',
					'me/followers': 'me/friends',
					'me/share': 'me/feed',
					'me/like': 'me/likes',
					'me/files': 'me/albums',
					'me/albums': 'me/albums?fields=cover_photo,name',
					'me/album': '@{id}/photos?fields=picture',
					'me/photos': 'me/photos',
					'me/photo': '@{id}',
					'friend/albums': '@{id}/albums',
					'friend/photos': '@{id}/photos'
	
					// Pagination
					// Https://developers.facebook.com/docs/reference/api/pagination/
				},
	
				// Map POST requests
				post: {
					'me/share': 'me/feed',
					'me/photo': '@{id}'
	
					// Https://developers.facebook.com/docs/graph-api/reference/v2.2/object/likes/
				},
	
				wrap: {
					me: formatUser,
					'me/friends': formatFriends,
					'me/following': formatFriends,
					'me/followers': formatFriends,
					'me/albums': format,
					'me/photos': format,
					'me/files': format,
					'default': format
				},
	
				// Special requirements for handling XHR
				xhr: function xhr(p, qs) {
					if (p.method === 'get' || p.method === 'post') {
						qs.suppress_response_codes = true;
					}
	
					// Is this a post with a data-uri?
					if (p.method === 'post' && p.data && typeof p.data.file === 'string') {
						// Convert the Data-URI to a Blob
						p.data.file = hello.utils.toBlob(p.data.file);
					}
	
					return true;
				},
	
				// Special requirements for handling JSONP fallback
				jsonp: function jsonp(p, qs) {
					var m = p.method;
					if (m !== 'get' && !hello.utils.hasBinary(p.data)) {
						p.data.method = m;
						p.method = 'get';
					} else if (p.method === 'delete') {
						qs.method = 'delete';
						p.method = 'post';
					}
				},
	
				// Special requirements for iframe form hack
				form: function form(p) {
					return {
						// Fire the callback onload
						callbackonload: true
					};
				}
			}
		});
	
		var base = 'https://graph.facebook.com/';
	
		function formatUser(o) {
			if (o.id) {
				o.thumbnail = o.picture = 'https://graph.facebook.com/' + o.id + '/picture';
			}
	
			return o;
		}
	
		function formatFriends(o) {
			if ('data' in o) {
				o.data.forEach(formatUser);
			}
	
			return o;
		}
	
		function format(o, headers, req) {
			if (typeof o === 'boolean') {
				o = { success: o };
			}
	
			if (o && 'data' in o) {
				var token = req.query.access_token;
	
				if (!(o.data instanceof Array)) {
					var data = o.data;
					delete o.data;
					o.data = [data];
				}
	
				o.data.forEach(function (d) {
	
					if (d.picture) {
						d.thumbnail = d.picture;
					}
	
					d.pictures = (d.images || []).sort(function (a, b) {
						return a.width - b.width;
					});
	
					if (d.cover_photo && d.cover_photo.id) {
						d.thumbnail = base + d.cover_photo.id + '/picture?access_token=' + token;
					}
	
					if (d.type === 'album') {
						d.files = d.photos = base + d.id + '/photos';
					}
	
					if (d.can_upload) {
						d.upload_location = base + d.id + '/photos';
					}
				});
			}
	
			return o;
		}
	})(hello);
	
	(function (hello) {
	
		hello.init({
	
			flickr: {
	
				name: 'Flickr',
	
				// Ensure that you define an oauth_proxy
				oauth: {
					version: '1.0a',
					auth: 'https://www.flickr.com/services/oauth/authorize?perms=read',
					request: 'https://www.flickr.com/services/oauth/request_token',
					token: 'https://www.flickr.com/services/oauth/access_token'
				},
	
				// API base URL
				base: 'https://api.flickr.com/services/rest',
	
				// Map GET resquests
				get: {
					me: sign('flickr.people.getInfo'),
					'me/friends': sign('flickr.contacts.getList', { per_page: '@{limit|50}' }),
					'me/following': sign('flickr.contacts.getList', { per_page: '@{limit|50}' }),
					'me/followers': sign('flickr.contacts.getList', { per_page: '@{limit|50}' }),
					'me/albums': sign('flickr.photosets.getList', { per_page: '@{limit|50}' }),
					'me/album': sign('flickr.photosets.getPhotos', { photoset_id: '@{id}' }),
					'me/photos': sign('flickr.people.getPhotos', { per_page: '@{limit|50}' })
				},
	
				wrap: {
					me: function me(o) {
						formatError(o);
						o = checkResponse(o, 'person');
						if (o.id) {
							if (o.realname) {
								o.name = o.realname._content;
								var m = o.name.split(' ');
								o.first_name = m.shift();
								o.last_name = m.join(' ');
							}
	
							o.thumbnail = getBuddyIcon(o, 'l');
							o.picture = getBuddyIcon(o, 'l');
						}
	
						return o;
					},
	
					'me/friends': formatFriends,
					'me/followers': formatFriends,
					'me/following': formatFriends,
					'me/albums': function meAlbums(o) {
						formatError(o);
						o = checkResponse(o, 'photosets');
						paging(o);
						if (o.photoset) {
							o.data = o.photoset;
							o.data.forEach(function (item) {
								item.name = item.title._content;
								item.photos = 'https://api.flickr.com/services/rest' + getApiUrl('flickr.photosets.getPhotos', { photoset_id: item.id }, true);
							});
	
							delete o.photoset;
						}
	
						return o;
					},
	
					'me/photos': function mePhotos(o) {
						formatError(o);
						return formatPhotos(o);
					},
	
					'default': function _default(o) {
						formatError(o);
						return formatPhotos(o);
					}
				},
	
				xhr: false,
	
				jsonp: function jsonp(p, qs) {
					if (p.method == 'get') {
						delete qs.callback;
						qs.jsoncallback = p.callbackID;
					}
				}
			}
		});
	
		function getApiUrl(method, extraParams, skipNetwork) {
			var url = (skipNetwork ? '' : 'flickr:') + '?method=' + method + '&api_key=' + hello.services.flickr.id + '&format=json';
			for (var param in extraParams) {
				if (extraParams.hasOwnProperty(param)) {
					url += '&' + param + '=' + extraParams[param];
				}
			}
	
			return url;
		}
	
		// This is not exactly neat but avoid to call
		// The method 'flickr.test.login' for each api call
	
		function withUser(cb) {
			var auth = hello.getAuthResponse('flickr');
			cb(auth && auth.user_nsid ? auth.user_nsid : null);
		}
	
		function sign(url, params) {
			if (!params) {
				params = {};
			}
	
			return function (p, callback) {
				withUser(function (userId) {
					params.user_id = userId;
					callback(getApiUrl(url, params, true));
				});
			};
		}
	
		function getBuddyIcon(profile, size) {
			var url = 'https://www.flickr.com/images/buddyicon.gif';
			if (profile.nsid && profile.iconserver && profile.iconfarm) {
				url = 'https://farm' + profile.iconfarm + '.staticflickr.com/' + profile.iconserver + '/' + 'buddyicons/' + profile.nsid + (size ? '_' + size : '') + '.jpg';
			}
	
			return url;
		}
	
		// See: https://www.flickr.com/services/api/misc.urls.html
		function createPhotoUrl(id, farm, server, secret, size) {
			size = size ? '_' + size : '';
			return 'https://farm' + farm + '.staticflickr.com/' + server + '/' + id + '_' + secret + size + '.jpg';
		}
	
		function formatUser(o) {}
	
		function formatError(o) {
			if (o && o.stat && o.stat.toLowerCase() != 'ok') {
				o.error = {
					code: 'invalid_request',
					message: o.message
				};
			}
		}
	
		function formatPhotos(o) {
			if (o.photoset || o.photos) {
				var set = 'photoset' in o ? 'photoset' : 'photos';
				o = checkResponse(o, set);
				paging(o);
				o.data = o.photo;
				delete o.photo;
				for (var i = 0; i < o.data.length; i++) {
					var photo = o.data[i];
					photo.name = photo.title;
					photo.picture = createPhotoUrl(photo.id, photo.farm, photo.server, photo.secret, '');
					photo.pictures = createPictures(photo.id, photo.farm, photo.server, photo.secret);
					photo.source = createPhotoUrl(photo.id, photo.farm, photo.server, photo.secret, 'b');
					photo.thumbnail = createPhotoUrl(photo.id, photo.farm, photo.server, photo.secret, 'm');
				}
			}
	
			return o;
		}
	
		// See: https://www.flickr.com/services/api/misc.urls.html
		function createPictures(id, farm, server, secret) {
	
			var NO_LIMIT = 2048;
			var sizes = [{ id: 't', max: 100 }, { id: 'm', max: 240 }, { id: 'n', max: 320 }, { id: '', max: 500 }, { id: 'z', max: 640 }, { id: 'c', max: 800 }, { id: 'b', max: 1024 }, { id: 'h', max: 1600 }, { id: 'k', max: 2048 }, { id: 'o', max: NO_LIMIT }];
	
			return sizes.map(function (size) {
				return {
					source: createPhotoUrl(id, farm, server, secret, size.id),
	
					// Note: this is a guess that's almost certain to be wrong (unless square source)
					width: size.max,
					height: size.max
				};
			});
		}
	
		function checkResponse(o, key) {
	
			if (key in o) {
				o = o[key];
			} else if (!('error' in o)) {
				o.error = {
					code: 'invalid_request',
					message: o.message || 'Failed to get data from Flickr'
				};
			}
	
			return o;
		}
	
		function formatFriends(o) {
			formatError(o);
			if (o.contacts) {
				o = checkResponse(o, 'contacts');
				paging(o);
				o.data = o.contact;
				delete o.contact;
				for (var i = 0; i < o.data.length; i++) {
					var item = o.data[i];
					item.id = item.nsid;
					item.name = item.realname || item.username;
					item.thumbnail = getBuddyIcon(item, 'm');
				}
			}
	
			return o;
		}
	
		function paging(res) {
			if (res.page && res.pages && res.page !== res.pages) {
				res.paging = {
					next: '?page=' + ++res.page
				};
			}
		}
	})(hello);
	
	(function (hello) {
	
		hello.init({
	
			foursquare: {
	
				name: 'Foursquare',
	
				oauth: {
					// See: https://developer.foursquare.com/overview/auth
					version: 2,
					auth: 'https://foursquare.com/oauth2/authenticate',
					grant: 'https://foursquare.com/oauth2/access_token'
				},
	
				// Refresh the access_token once expired
				refresh: true,
	
				base: 'https://api.foursquare.com/v2/',
	
				get: {
					me: 'users/self',
					'me/friends': 'users/self/friends',
					'me/followers': 'users/self/friends',
					'me/following': 'users/self/friends'
				},
	
				wrap: {
					me: function me(o) {
						formatError(o);
						if (o && o.response) {
							o = o.response.user;
							formatUser(o);
						}
	
						return o;
					},
	
					'default': function _default(o) {
						formatError(o);
	
						// Format friends
						if (o && 'response' in o && 'friends' in o.response && 'items' in o.response.friends) {
							o.data = o.response.friends.items;
							o.data.forEach(formatUser);
							delete o.response;
						}
	
						return o;
					}
				},
	
				xhr: formatRequest,
				jsonp: formatRequest
			}
		});
	
		function formatError(o) {
			if (o.meta && (o.meta.code === 400 || o.meta.code === 401)) {
				o.error = {
					code: 'access_denied',
					message: o.meta.errorDetail
				};
			}
		}
	
		function formatUser(o) {
			if (o && o.id) {
				o.thumbnail = o.photo.prefix + '100x100' + o.photo.suffix;
				o.name = o.firstName + ' ' + o.lastName;
				o.first_name = o.firstName;
				o.last_name = o.lastName;
				if (o.contact) {
					if (o.contact.email) {
						o.email = o.contact.email;
					}
				}
			}
		}
	
		function formatRequest(p, qs) {
			var token = qs.access_token;
			delete qs.access_token;
			qs.oauth_token = token;
			qs.v = 20121125;
			return true;
		}
	})(hello);
	
	(function (hello) {
	
		hello.init({
	
			github: {
	
				name: 'GitHub',
	
				oauth: {
					version: 2,
					auth: 'https://github.com/login/oauth/authorize',
					grant: 'https://github.com/login/oauth/access_token',
					response_type: 'code'
				},
	
				scope: {
					email: 'user:email'
				},
	
				base: 'https://api.github.com/',
	
				get: {
					me: 'user',
					'me/friends': 'user/following?per_page=@{limit|100}',
					'me/following': 'user/following?per_page=@{limit|100}',
					'me/followers': 'user/followers?per_page=@{limit|100}',
					'me/like': 'user/starred?per_page=@{limit|100}'
				},
	
				wrap: {
					me: function me(o, headers) {
	
						formatError(o, headers);
						formatUser(o);
	
						return o;
					},
	
					'default': function _default(o, headers, req) {
	
						formatError(o, headers);
	
						if (Array.isArray(o)) {
							o = { data: o };
						}
	
						if (o.data) {
							paging(o, headers, req);
							o.data.forEach(formatUser);
						}
	
						return o;
					}
				},
	
				xhr: function xhr(p) {
	
					if (p.method !== 'get' && p.data) {
	
						// Serialize payload as JSON
						p.headers = p.headers || {};
						p.headers['Content-Type'] = 'application/json';
						if (_typeof(p.data) === 'object') {
							p.data = JSON.stringify(p.data);
						}
					}
	
					return true;
				}
			}
		});
	
		function formatError(o, headers) {
			var code = headers ? headers.statusCode : o && 'meta' in o && 'status' in o.meta && o.meta.status;
			if (code === 401 || code === 403) {
				o.error = {
					code: 'access_denied',
					message: o.message || (o.data ? o.data.message : 'Could not get response')
				};
				delete o.message;
			}
		}
	
		function formatUser(o) {
			if (o.id) {
				o.thumbnail = o.picture = o.avatar_url;
				o.name = o.login;
			}
		}
	
		function paging(res, headers, req) {
			if (res.data && res.data.length && headers && headers.Link) {
				var next = headers.Link.match(/<(.*?)>;\s*rel=\"next\"/);
				if (next) {
					res.paging = {
						next: next[1]
					};
				}
			}
		}
	})(hello);
	
	(function (hello) {
	
		var contactsUrl = 'https://www.google.com/m8/feeds/contacts/default/full?v=3.0&alt=json&max-results=@{limit|1000}&start-index=@{start|1}';
	
		hello.init({
	
			google: {
	
				name: 'Google Sign-In',
	
				// See: http://code.google.com/apis/accounts/docs/OAuth2UserAgent.html
				oauth: {
					version: 2,
					auth: 'https://accounts.google.com/o/oauth2/v2/auth',
					grant: 'https://www.googleapis.com/oauth2/v4/token'
				},
	
				// Authorization scopes
				scope: {
					basic: 'openid profile',
					email: 'email',
					birthday: '',
					events: '',
					photos: 'https://picasaweb.google.com/data/',
					videos: 'http://gdata.youtube.com',
					files: 'https://www.googleapis.com/auth/drive.readonly',
					publish: '',
					publish_files: 'https://www.googleapis.com/auth/drive',
					share: '',
					create_event: '',
					offline_access: ''
				},
	
				scope_delim: ' ',
	
				login: function login(p) {
	
					if (p.qs.response_type === 'code') {
	
						// Let's set this to an offline access to return a refresh_token
						p.qs.access_type = 'offline';
					} else if (p.qs.response_type.indexOf('id_token') > -1) {
						p.qs.nonce = parseInt(Math.random() * 1e12, 10).toString(36);
					}
	
					// Reauthenticate
					// https://developers.google.com/identity/protocols/
					if (p.options.force) {
						p.qs.approval_prompt = 'force';
					}
				},
	
				// API base URI
				base: 'https://www.googleapis.com/',
	
				// Map GET requests
				get: {
					me: 'oauth2/v3/userinfo?alt=json',
	
					// Deprecated Sept 1, 2014
					//'me': 'oauth2/v1/userinfo?alt=json',
	
					// See: https://developers.google.com/+/api/latest/people/list
					'me/following': contactsUrl,
					'me/followers': contactsUrl,
					'me/contacts': contactsUrl,
					'me/albums': 'https://picasaweb.google.com/data/feed/api/user/default?alt=json&max-results=@{limit|100}&start-index=@{start|1}',
					'me/album': function meAlbum(p, callback) {
						var key = p.query.id;
						delete p.query.id;
						callback(key.replace('/entry/', '/feed/'));
					},
	
					'me/photos': 'https://picasaweb.google.com/data/feed/api/user/default?alt=json&kind=photo&max-results=@{limit|100}&start-index=@{start|1}',
	
					// See: https://developers.google.com/drive/v2/reference/files/list
					'me/file': 'drive/v2/files/@{id}',
					'me/files': 'drive/v2/files?q=%22@{parent|root}%22+in+parents+and+trashed=false&maxResults=@{limit|100}',
	
					// See: https://developers.google.com/drive/v2/reference/files/list
					'me/folders': 'drive/v2/files?q=%22@{id|root}%22+in+parents+and+mimeType+=+%22application/vnd.google-apps.folder%22+and+trashed=false&maxResults=@{limit|100}',
	
					// See: https://developers.google.com/drive/v2/reference/files/list
					'me/folder': 'drive/v2/files?q=%22@{id|root}%22+in+parents+and+trashed=false&maxResults=@{limit|100}'
				},
	
				// Map POST requests
				post: {
	
					// Google Drive
					'me/files': uploadDrive,
					'me/folders': function meFolders(p, callback) {
						p.data = {
							title: p.data.name,
							parents: [{ id: p.data.parent || 'root' }],
							mimeType: 'application/vnd.google-apps.folder'
						};
						callback('drive/v2/files');
					}
				},
	
				// Map PUT requests
				put: {
					'me/files': uploadDrive
				},
	
				// Map DELETE requests
				del: {
					'me/files': 'drive/v2/files/@{id}',
					'me/folder': 'drive/v2/files/@{id}'
				},
	
				// Map PATCH requests
				patch: {
					'me/file': 'drive/v2/files/@{id}'
				},
	
				wrap: {
					me: function me(o) {
						if (o.sub) {
							o.id = o.sub;
						}
	
						if (o.id) {
							o.last_name = o.family_name || (o.name ? o.name.familyName : null);
							o.first_name = o.given_name || (o.name ? o.name.givenName : null);
	
							if (o.emails && o.emails.length) {
								o.email = o.emails[0].value;
							}
	
							formatPerson(o);
						}
	
						return o;
					},
	
					'me/friends': function meFriends(o) {
						if (o.items) {
							paging(o);
							o.data = o.items;
							o.data.forEach(formatPerson);
							delete o.items;
						}
	
						return o;
					},
	
					'me/contacts': formatFriends,
					'me/followers': formatFriends,
					'me/following': formatFriends,
					'me/share': formatFeed,
					'me/feed': formatFeed,
					'me/albums': gEntry,
					'me/photos': formatPhotos,
					'default': gEntry
				},
	
				xhr: function xhr(p) {
	
					if (p.method === 'post' || p.method === 'put') {
						toJSON(p);
					} else if (p.method === 'patch') {
						hello.utils.extend(p.query, p.data);
						p.data = null;
					}
	
					return true;
				},
	
				// Don't even try submitting via form.
				// This means no POST operations in <=IE9
				form: false
			}
		});
	
		function toInt(s) {
			return parseInt(s, 10);
		}
	
		function formatFeed(o) {
			paging(o);
			o.data = o.items;
			delete o.items;
			return o;
		}
	
		// Format: ensure each record contains a name, id etc.
		function formatItem(o) {
			if (o.error) {
				return;
			}
	
			if (!o.name) {
				o.name = o.title || o.message;
			}
	
			if (!o.picture) {
				o.picture = o.thumbnailLink;
			}
	
			if (!o.thumbnail) {
				o.thumbnail = o.thumbnailLink;
			}
	
			if (o.mimeType === 'application/vnd.google-apps.folder') {
				o.type = 'folder';
				o.files = 'https://www.googleapis.com/drive/v2/files?q=%22' + o.id + '%22+in+parents';
			}
	
			return o;
		}
	
		function formatImage(image) {
			return {
				source: image.url,
				width: image.width,
				height: image.height
			};
		}
	
		function formatPhotos(o) {
			if ('feed' in o) {
				o.data = 'entry' in o.feed ? o.feed.entry.map(formatEntry) : [];
				delete o.feed;
			}
	
			return o;
		}
	
		// Google has a horrible JSON API
		function gEntry(o) {
			paging(o);
	
			if ('feed' in o && 'entry' in o.feed) {
				o.data = o.feed.entry.map(formatEntry);
				delete o.feed;
			}
	
			// Old style: Picasa, etc.
			else if ('entry' in o) {
					return formatEntry(o.entry);
				}
	
				// New style: Google Drive
				else if ('items' in o) {
						o.data = o.items.map(formatItem);
						delete o.items;
					} else {
						formatItem(o);
					}
	
			return o;
		}
	
		function formatPerson(o) {
			o.name = o.displayName || o.name;
			o.picture = o.picture || (o.image ? o.image.url : null);
			o.thumbnail = o.picture;
		}
	
		function formatFriends(o, headers, req) {
			paging(o);
			var r = [];
			if ('feed' in o && 'entry' in o.feed) {
				var token = req.query.access_token;
				for (var i = 0; i < o.feed.entry.length; i++) {
					var a = o.feed.entry[i];
	
					a.id = a.id.$t;
					a.name = a.title.$t;
					delete a.title;
					if (a.gd$email) {
						a.email = a.gd$email && a.gd$email.length > 0 ? a.gd$email[0].address : null;
						a.emails = a.gd$email;
						delete a.gd$email;
					}
	
					if (a.updated) {
						a.updated = a.updated.$t;
					}
	
					if (a.link) {
	
						var pic = a.link.length > 0 ? a.link[0].href : null;
						if (pic && a.link[0].gd$etag) {
							pic += (pic.indexOf('?') > -1 ? '&' : '?') + 'access_token=' + token;
							a.picture = pic;
							a.thumbnail = pic;
						}
	
						delete a.link;
					}
	
					if (a.category) {
						delete a.category;
					}
				}
	
				o.data = o.feed.entry;
				delete o.feed;
			}
	
			return o;
		}
	
		function formatEntry(a) {
	
			var group = a.media$group;
			var photo = group.media$content.length ? group.media$content[0] : {};
			var mediaContent = group.media$content || [];
			var mediaThumbnail = group.media$thumbnail || [];
	
			var pictures = mediaContent.concat(mediaThumbnail).map(formatImage).sort(function (a, b) {
				return a.width - b.width;
			});
	
			var i = 0;
			var _a;
			var p = {
				id: a.id.$t,
				name: a.title.$t,
				description: a.summary.$t,
				updated_time: a.updated.$t,
				created_time: a.published.$t,
				picture: photo ? photo.url : null,
				pictures: pictures,
				images: [],
				thumbnail: photo ? photo.url : null,
				width: photo.width,
				height: photo.height
			};
	
			// Get feed/children
			if ('link' in a) {
				for (i = 0; i < a.link.length; i++) {
					var d = a.link[i];
					if (d.rel.match(/\#feed$/)) {
						p.upload_location = p.files = p.photos = d.href;
						break;
					}
				}
			}
	
			// Get images of different scales
			if ('category' in a && a.category.length) {
				_a = a.category;
				for (i = 0; i < _a.length; i++) {
					if (_a[i].scheme && _a[i].scheme.match(/\#kind$/)) {
						p.type = _a[i].term.replace(/^.*?\#/, '');
					}
				}
			}
	
			// Get images of different scales
			if ('media$thumbnail' in group && group.media$thumbnail.length) {
				_a = group.media$thumbnail;
				p.thumbnail = _a[0].url;
				p.images = _a.map(formatImage);
			}
	
			_a = group.media$content;
	
			if (_a && _a.length) {
				p.images.push(formatImage(_a[0]));
			}
	
			return p;
		}
	
		function paging(res) {
	
			// Contacts V2
			if ('feed' in res && res.feed.openSearch$itemsPerPage) {
				var limit = toInt(res.feed.openSearch$itemsPerPage.$t);
				var start = toInt(res.feed.openSearch$startIndex.$t);
				var total = toInt(res.feed.openSearch$totalResults.$t);
	
				if (start + limit < total) {
					res.paging = {
						next: '?start=' + (start + limit)
					};
				}
			} else if ('nextPageToken' in res) {
				res.paging = {
					next: '?pageToken=' + res.nextPageToken
				};
			}
		}
	
		// Construct a multipart message
		function Multipart() {
	
			// Internal body
			var body = [];
			var boundary = (Math.random() * 1e10).toString(32);
			var counter = 0;
			var lineBreak = '\r\n';
			var delim = lineBreak + '--' + boundary;
			var ready = function ready() {};
	
			var dataUri = /^data\:([^;,]+(\;charset=[^;,]+)?)(\;base64)?,/i;
	
			// Add file
			function addFile(item) {
				var fr = new FileReader();
				fr.onload = function (e) {
					addContent(btoa(e.target.result), item.type + lineBreak + 'Content-Transfer-Encoding: base64');
				};
	
				fr.readAsBinaryString(item);
			}
	
			// Add content
			function addContent(content, type) {
				body.push(lineBreak + 'Content-Type: ' + type + lineBreak + lineBreak + content);
				counter--;
				ready();
			}
	
			// Add new things to the object
			this.append = function (content, type) {
	
				// Does the content have an array
				if (typeof content === 'string' || !('length' in Object(content))) {
					// Converti to multiples
					content = [content];
				}
	
				for (var i = 0; i < content.length; i++) {
	
					counter++;
	
					var item = content[i];
	
					// Is this a file?
					// Files can be either Blobs or File types
					if (typeof File !== 'undefined' && item instanceof File || typeof Blob !== 'undefined' && item instanceof Blob) {
						// Read the file in
						addFile(item);
					}
	
					// Data-URI?
					// Data:[<mime type>][;charset=<charset>][;base64],<encoded data>
					// /^data\:([^;,]+(\;charset=[^;,]+)?)(\;base64)?,/i
					else if (typeof item === 'string' && item.match(dataUri)) {
							var m = item.match(dataUri);
							addContent(item.replace(dataUri, ''), m[1] + lineBreak + 'Content-Transfer-Encoding: base64');
						}
	
						// Regular string
						else {
								addContent(item, type);
							}
				}
			};
	
			this.onready = function (fn) {
				ready = function ready() {
					if (counter === 0) {
						// Trigger ready
						body.unshift('');
						body.push('--');
						fn(body.join(delim), boundary);
						body = [];
					}
				};
	
				ready();
			};
		}
	
		// Upload to Drive
		// If this is PUT then only augment the file uploaded
		// PUT https://developers.google.com/drive/v2/reference/files/update
		// POST https://developers.google.com/drive/manage-uploads
		function uploadDrive(p, callback) {
	
			var data = {};
	
			// Test for DOM element
			if (p.data && typeof HTMLInputElement !== 'undefined' && p.data instanceof HTMLInputElement) {
				p.data = { file: p.data };
			}
	
			if (!p.data.name && Object(Object(p.data.file).files).length && p.method === 'post') {
				p.data.name = p.data.file.files[0].name;
			}
	
			if (p.method === 'post') {
				p.data = {
					title: p.data.name,
					parents: [{ id: p.data.parent || 'root' }],
					file: p.data.file
				};
			} else {
	
				// Make a reference
				data = p.data;
				p.data = {};
	
				// Add the parts to change as required
				if (data.parent) {
					p.data.parents = [{ id: p.data.parent || 'root' }];
				}
	
				if (data.file) {
					p.data.file = data.file;
				}
	
				if (data.name) {
					p.data.title = data.name;
				}
			}
	
			// Extract the file, if it exists from the data object
			// If the File is an INPUT element lets just concern ourselves with the NodeList
			var file;
			if ('file' in p.data) {
				file = p.data.file;
				delete p.data.file;
	
				if ((typeof file === 'undefined' ? 'undefined' : _typeof(file)) === 'object' && 'files' in file) {
					// Assign the NodeList
					file = file.files;
				}
	
				if (!file || !file.length) {
					callback({
						error: {
							code: 'request_invalid',
							message: 'There were no files attached with this request to upload'
						}
					});
					return;
				}
			}
	
			// Set type p.data.mimeType = Object(file[0]).type || 'application/octet-stream';
	
			// Construct a multipart message
			var parts = new Multipart();
			parts.append(JSON.stringify(p.data), 'application/json');
	
			// Read the file into a  base64 string... yep a hassle, i know
			// FormData doesn't let us assign our own Multipart headers and HTTP Content-Type
			// Alas GoogleApi need these in a particular format
			if (file) {
				parts.append(file);
			}
	
			parts.onready(function (body, boundary) {
	
				p.headers['content-type'] = 'multipart/related; boundary="' + boundary + '"';
				p.data = body;
	
				callback('upload/drive/v2/files' + (data.id ? '/' + data.id : '') + '?uploadType=multipart');
			});
		}
	
		function toJSON(p) {
			if (_typeof(p.data) === 'object') {
				// Convert the POST into a javascript object
				try {
					p.data = JSON.stringify(p.data);
					p.headers['content-type'] = 'application/json';
				} catch (e) {}
			}
		}
	})(hello);
	
	(function (hello) {
	
		hello.init({
	
			instagram: {
	
				name: 'Instagram',
	
				oauth: {
					// See: http://instagram.com/developer/authentication/
					version: 2,
					auth: 'https://instagram.com/oauth/authorize/',
					grant: 'https://api.instagram.com/oauth/access_token'
				},
	
				// Refresh the access_token once expired
				refresh: true,
	
				scope: {
					basic: 'basic',
					photos: '',
					friends: 'relationships',
					publish: 'likes comments',
					email: '',
					share: '',
					publish_files: '',
					files: '',
					videos: '',
					offline_access: ''
				},
	
				scope_delim: ' ',
	
				base: 'https://api.instagram.com/v1/',
	
				get: {
					me: 'users/self',
					'me/feed': 'users/self/feed?count=@{limit|100}',
					'me/photos': 'users/self/media/recent?min_id=0&count=@{limit|100}',
					'me/friends': 'users/self/follows?count=@{limit|100}',
					'me/following': 'users/self/follows?count=@{limit|100}',
					'me/followers': 'users/self/followed-by?count=@{limit|100}',
					'friend/photos': 'users/@{id}/media/recent?min_id=0&count=@{limit|100}'
				},
	
				post: {
					'me/like': function meLike(p, callback) {
						var id = p.data.id;
						p.data = {};
						callback('media/' + id + '/likes');
					}
				},
	
				del: {
					'me/like': 'media/@{id}/likes'
				},
	
				wrap: {
					me: function me(o) {
	
						formatError(o);
	
						if ('data' in o) {
							o.id = o.data.id;
							o.thumbnail = o.data.profile_picture;
							o.name = o.data.full_name || o.data.username;
						}
	
						return o;
					},
	
					'me/friends': formatFriends,
					'me/following': formatFriends,
					'me/followers': formatFriends,
					'me/photos': function mePhotos(o) {
	
						formatError(o);
						paging(o);
	
						if ('data' in o) {
							o.data = o.data.filter(function (d) {
								return d.type === 'image';
							});
	
							o.data.forEach(function (d) {
								d.name = d.caption ? d.caption.text : null;
								d.thumbnail = d.images.thumbnail.url;
								d.picture = d.images.standard_resolution.url;
								d.pictures = Object.keys(d.images).map(function (key) {
									var image = d.images[key];
									return formatImage(image);
								}).sort(function (a, b) {
									return a.width - b.width;
								});
							});
						}
	
						return o;
					},
	
					'default': function _default(o) {
						o = formatError(o);
						paging(o);
						return o;
					}
				},
	
				// Instagram does not return any CORS Headers
				// So besides JSONP we're stuck with proxy
				xhr: function xhr(p, qs) {
	
					var method = p.method;
					var proxy = method !== 'get';
	
					if (proxy) {
	
						if ((method === 'post' || method === 'put') && p.query.access_token) {
							p.data.access_token = p.query.access_token;
							delete p.query.access_token;
						}
	
						// No access control headers
						// Use the proxy instead
						p.proxy = proxy;
					}
	
					return proxy;
				},
	
				// No form
				form: false
			}
		});
	
		function formatImage(image) {
			return {
				source: image.url,
				width: image.width,
				height: image.height
			};
		}
	
		function formatError(o) {
			if (typeof o === 'string') {
				return {
					error: {
						code: 'invalid_request',
						message: o
					}
				};
			}
	
			if (o && 'meta' in o && 'error_type' in o.meta) {
				o.error = {
					code: o.meta.error_type,
					message: o.meta.error_message
				};
			}
	
			return o;
		}
	
		function formatFriends(o) {
			paging(o);
			if (o && 'data' in o) {
				o.data.forEach(formatFriend);
			}
	
			return o;
		}
	
		function formatFriend(o) {
			if (o.id) {
				o.thumbnail = o.profile_picture;
				o.name = o.full_name || o.username;
			}
		}
	
		// See: http://instagram.com/developer/endpoints/
		function paging(res) {
			if ('pagination' in res) {
				res.paging = {
					next: res.pagination.next_url
				};
				delete res.pagination;
			}
		}
	})(hello);
	
	(function (hello) {
	
		hello.init({
	
			joinme: {
	
				name: 'join.me',
	
				oauth: {
					version: 2,
					auth: 'https://secure.join.me/api/public/v1/auth/oauth2',
					grant: 'https://secure.join.me/api/public/v1/auth/oauth2'
				},
	
				refresh: false,
	
				scope: {
					basic: 'user_info',
					user: 'user_info',
					scheduler: 'scheduler',
					start: 'start_meeting',
					email: '',
					friends: '',
					share: '',
					publish: '',
					photos: '',
					publish_files: '',
					files: '',
					videos: '',
					offline_access: ''
				},
	
				scope_delim: ' ',
	
				login: function login(p) {
					p.options.popup.width = 400;
					p.options.popup.height = 700;
				},
	
				base: 'https://api.join.me/v1/',
	
				get: {
					me: 'user',
					meetings: 'meetings',
					'meetings/info': 'meetings/@{id}'
				},
	
				post: {
					'meetings/start/adhoc': function meetingsStartAdhoc(p, callback) {
						callback('meetings/start');
					},
	
					'meetings/start/scheduled': function meetingsStartScheduled(p, callback) {
						var meetingId = p.data.meetingId;
						p.data = {};
						callback('meetings/' + meetingId + '/start');
					},
	
					'meetings/schedule': function meetingsSchedule(p, callback) {
						callback('meetings');
					}
				},
	
				patch: {
					'meetings/update': function meetingsUpdate(p, callback) {
						callback('meetings/' + p.data.meetingId);
					}
				},
	
				del: {
					'meetings/delete': 'meetings/@{id}'
				},
	
				wrap: {
					me: function me(o, headers) {
						formatError(o, headers);
	
						if (!o.email) {
							return o;
						}
	
						o.name = o.fullName;
						o.first_name = o.name.split(' ')[0];
						o.last_name = o.name.split(' ')[1];
						o.id = o.email;
	
						return o;
					},
	
					'default': function _default(o, headers) {
						formatError(o, headers);
	
						return o;
					}
				},
	
				xhr: formatRequest
	
			}
		});
	
		function formatError(o, headers) {
			var errorCode;
			var message;
			var details;
	
			if (o && 'Message' in o) {
				message = o.Message;
				delete o.Message;
	
				if ('ErrorCode' in o) {
					errorCode = o.ErrorCode;
					delete o.ErrorCode;
				} else {
					errorCode = getErrorCode(headers);
				}
	
				o.error = {
					code: errorCode,
					message: message,
					details: o
				};
			}
	
			return o;
		}
	
		function formatRequest(p, qs) {
			// Move the access token from the request body to the request header
			var token = qs.access_token;
			delete qs.access_token;
			p.headers.Authorization = 'Bearer ' + token;
	
			// Format non-get requests to indicate json body
			if (p.method !== 'get' && p.data) {
				p.headers['Content-Type'] = 'application/json';
				if (_typeof(p.data) === 'object') {
					p.data = JSON.stringify(p.data);
				}
			}
	
			if (p.method === 'put') {
				p.method = 'patch';
			}
	
			return true;
		}
	
		function getErrorCode(headers) {
			switch (headers.statusCode) {
				case 400:
					return 'invalid_request';
				case 403:
					return 'stale_token';
				case 401:
					return 'invalid_token';
				case 500:
					return 'server_error';
				default:
					return 'server_error';
			}
		}
	})(hello);
	
	(function (hello) {
	
		hello.init({
	
			linkedin: {
	
				oauth: {
					version: 2,
					response_type: 'code',
					auth: 'https://www.linkedin.com/uas/oauth2/authorization',
					grant: 'https://www.linkedin.com/uas/oauth2/accessToken'
				},
	
				// Refresh the access_token once expired
				refresh: true,
	
				scope: {
					basic: 'r_basicprofile',
					email: 'r_emailaddress',
					files: '',
					friends: '',
					photos: '',
					publish: 'w_share',
					publish_files: 'w_share',
					share: '',
					videos: '',
					offline_access: ''
				},
				scope_delim: ' ',
	
				base: 'https://api.linkedin.com/v1/',
	
				get: {
					me: 'people/~:(picture-url,first-name,last-name,id,formatted-name,email-address)',
	
					// See: http://developer.linkedin.com/documents/get-network-updates-and-statistics-api
					'me/share': 'people/~/network/updates?count=@{limit|250}'
				},
	
				post: {
	
					// See: https://developer.linkedin.com/documents/api-requests-json
					'me/share': function meShare(p, callback) {
						var data = {
							visibility: {
								code: 'anyone'
							}
						};
	
						if (p.data.id) {
	
							data.attribution = {
								share: {
									id: p.data.id
								}
							};
						} else {
							data.comment = p.data.message;
							if (p.data.picture && p.data.link) {
								data.content = {
									'submitted-url': p.data.link,
									'submitted-image-url': p.data.picture
								};
							}
						}
	
						p.data = JSON.stringify(data);
	
						callback('people/~/shares?format=json');
					},
	
					'me/like': like
				},
	
				del: {
					'me/like': like
				},
	
				wrap: {
					me: function me(o) {
						formatError(o);
						formatUser(o);
						return o;
					},
	
					'me/friends': formatFriends,
					'me/following': formatFriends,
					'me/followers': formatFriends,
					'me/share': function meShare(o) {
						formatError(o);
						paging(o);
						if (o.values) {
							o.data = o.values.map(formatUser);
							o.data.forEach(function (item) {
								item.message = item.headline;
							});
	
							delete o.values;
						}
	
						return o;
					},
	
					'default': function _default(o, headers) {
						formatError(o);
						empty(o, headers);
						paging(o);
					}
				},
	
				jsonp: function jsonp(p, qs) {
					formatQuery(qs);
					if (p.method === 'get') {
						qs.format = 'jsonp';
						qs['error-callback'] = p.callbackID;
					}
				},
	
				xhr: function xhr(p, qs) {
					if (p.method !== 'get') {
						formatQuery(qs);
						p.headers['Content-Type'] = 'application/json';
	
						// Note: x-li-format ensures error responses are not returned in XML
						p.headers['x-li-format'] = 'json';
						p.proxy = true;
						return true;
					}
	
					return false;
				}
			}
		});
	
		function formatError(o) {
			if (o && 'errorCode' in o) {
				o.error = {
					code: o.status,
					message: o.message
				};
			}
		}
	
		function formatUser(o) {
			if (o.error) {
				return;
			}
	
			o.first_name = o.firstName;
			o.last_name = o.lastName;
			o.name = o.formattedName || o.first_name + ' ' + o.last_name;
			o.thumbnail = o.pictureUrl;
			o.email = o.emailAddress;
			return o;
		}
	
		function formatFriends(o) {
			formatError(o);
			paging(o);
			if (o.values) {
				o.data = o.values.map(formatUser);
				delete o.values;
			}
	
			return o;
		}
	
		function paging(res) {
			if ('_count' in res && '_start' in res && res._count + res._start < res._total) {
				res.paging = {
					next: '?start=' + (res._start + res._count) + '&count=' + res._count
				};
			}
		}
	
		function empty(o, headers) {
			if (JSON.stringify(o) === '{}' && headers.statusCode === 200) {
				o.success = true;
			}
		}
	
		function formatQuery(qs) {
			// LinkedIn signs requests with the parameter 'oauth2_access_token'
			// ... yeah another one who thinks they should be different!
			if (qs.access_token) {
				qs.oauth2_access_token = qs.access_token;
				delete qs.access_token;
			}
		}
	
		function like(p, callback) {
			p.headers['x-li-format'] = 'json';
			var id = p.data.id;
			p.data = (p.method !== 'delete').toString();
			p.method = 'put';
			callback('people/~/network/updates/key=' + id + '/is-liked');
		}
	})(hello);
	
	// See: https://developers.soundcloud.com/docs/api/reference
	(function (hello) {
	
		hello.init({
	
			soundcloud: {
				name: 'SoundCloud',
	
				oauth: {
					version: 2,
					auth: 'https://soundcloud.com/connect',
					grant: 'https://soundcloud.com/oauth2/token'
				},
	
				// Request path translated
				base: 'https://api.soundcloud.com/',
				get: {
					me: 'me.json',
	
					// Http://developers.soundcloud.com/docs/api/reference#me
					'me/friends': 'me/followings.json',
					'me/followers': 'me/followers.json',
					'me/following': 'me/followings.json',
	
					// See: http://developers.soundcloud.com/docs/api/reference#activities
					'default': function _default(p, callback) {
	
						// Include '.json at the end of each request'
						callback(p.path + '.json');
					}
				},
	
				// Response handlers
				wrap: {
					me: function me(o) {
						formatUser(o);
						return o;
					},
	
					'default': function _default(o) {
						if (Array.isArray(o)) {
							o = {
								data: o.map(formatUser)
							};
						}
	
						paging(o);
						return o;
					}
				},
	
				xhr: formatRequest,
				jsonp: formatRequest
			}
		});
	
		function formatRequest(p, qs) {
			// Alter the querystring
			var token = qs.access_token;
			delete qs.access_token;
			qs.oauth_token = token;
			qs['_status_code_map[302]'] = 200;
			return true;
		}
	
		function formatUser(o) {
			if (o.id) {
				o.picture = o.avatar_url;
				o.thumbnail = o.avatar_url;
				o.name = o.username || o.full_name;
			}
	
			return o;
		}
	
		// See: http://developers.soundcloud.com/docs/api/reference#activities
		function paging(res) {
			if ('next_href' in res) {
				res.paging = {
					next: res.next_href
				};
			}
		}
	})(hello);
	
	// See: https://developer.spotify.com/web-api/
	(function (hello) {
	
		hello.init({
	
			spotify: {
				name: 'Spotify',
	
				oauth: {
					version: 2,
					auth: 'https://accounts.spotify.com/authorize',
					grant: 'https://accounts.spotify.com/api/token'
				},
	
				// See: https://developer.spotify.com/web-api/using-scopes/
				scope_delim: ' ',
				scope: {
					basic: '',
					photos: '',
					friends: 'user-follow-read',
					publish: 'user-library-read',
					email: 'user-read-email',
					share: '',
					publish_files: '',
					files: '',
					videos: '',
					offline_access: ''
				},
	
				// Request path translated
				base: 'https://api.spotify.com',
	
				// See: https://developer.spotify.com/web-api/endpoint-reference/
				get: {
					me: '/v1/me',
					'me/following': '/v1/me/following?type=artist', // Only 'artist' is supported
	
					// Because tracks, albums and playlist exist on spotify, the tracks are considered
					// the resource for the 'me/likes' endpoint
					'me/like': '/v1/me/tracks'
				},
	
				// Response handlers
				wrap: {
					me: formatUser,
					'me/following': formatFollowees,
					'me/like': formatTracks
				},
	
				xhr: formatRequest,
				jsonp: false
			}
		});
	
		// Move the access token from the request body to the request header
		function formatRequest(p, qs) {
			var token = qs.access_token;
			delete qs.access_token;
			p.headers.Authorization = 'Bearer ' + token;
	
			return true;
		}
	
		function formatUser(o) {
			if (o.id) {
				o.name = o.display_name;
				o.thumbnail = o.images.length ? o.images[0].url : null;
				o.picture = o.thumbnail;
			}
	
			return o;
		}
	
		function formatFollowees(o) {
			paging(o);
			if (o && 'artists' in o) {
				o.data = o.artists.items.forEach(formatUser);
			}
	
			return o;
		}
	
		function formatTracks(o) {
			paging(o);
			o.data = o.items;
	
			return o;
		}
	
		function paging(res) {
			if (res && 'next' in res) {
				res.paging = {
					next: res.next
				};
				delete res.next;
			}
		}
	})(hello);
	
	(function (hello) {
	
		var base = 'https://api.twitter.com/';
	
		hello.init({
	
			twitter: {
	
				// Ensure that you define an oauth_proxy
				oauth: {
					version: '1.0a',
					auth: base + 'oauth/authenticate',
					request: base + 'oauth/request_token',
					token: base + 'oauth/access_token'
				},
	
				login: function login(p) {
					// Reauthenticate
					// https://dev.twitter.com/oauth/reference/get/oauth/authenticate
					var prefix = '?force_login=true';
					this.oauth.auth = this.oauth.auth.replace(prefix, '') + (p.options.force ? prefix : '');
				},
	
				base: base + '1.1/',
	
				get: {
					me: 'account/verify_credentials.json',
					'me/friends': 'friends/list.json?count=@{limit|200}',
					'me/following': 'friends/list.json?count=@{limit|200}',
					'me/followers': 'followers/list.json?count=@{limit|200}',
	
					// Https://dev.twitter.com/docs/api/1.1/get/statuses/user_timeline
					'me/share': 'statuses/user_timeline.json?count=@{limit|200}',
	
					// Https://dev.twitter.com/rest/reference/get/favorites/list
					'me/like': 'favorites/list.json?count=@{limit|200}'
				},
	
				post: {
					'me/share': function meShare(p, callback) {
	
						var data = p.data;
						p.data = null;
	
						var status = [];
	
						// Change message to status
						if (data.message) {
							status.push(data.message);
							delete data.message;
						}
	
						// If link is given
						if (data.link) {
							status.push(data.link);
							delete data.link;
						}
	
						if (data.picture) {
							status.push(data.picture);
							delete data.picture;
						}
	
						// Compound all the components
						if (status.length) {
							data.status = status.join(' ');
						}
	
						// Tweet media
						if (data.file) {
							data['media[]'] = data.file;
							delete data.file;
							p.data = data;
							callback('statuses/update_with_media.json');
						}
	
						// Retweet?
						else if ('id' in data) {
								callback('statuses/retweet/' + data.id + '.json');
							}
	
							// Tweet
							else {
									// Assign the post body to the query parameters
									hello.utils.extend(p.query, data);
									callback('statuses/update.json?include_entities=1');
								}
					},
	
					// See: https://dev.twitter.com/rest/reference/post/favorites/create
					'me/like': function meLike(p, callback) {
						var id = p.data.id;
						p.data = null;
						callback('favorites/create.json?id=' + id);
					}
				},
	
				del: {
	
					// See: https://dev.twitter.com/rest/reference/post/favorites/destroy
					'me/like': function meLike() {
						p.method = 'post';
						var id = p.data.id;
						p.data = null;
						callback('favorites/destroy.json?id=' + id);
					}
				},
	
				wrap: {
					me: function me(res) {
						formatError(res);
						formatUser(res);
						return res;
					},
	
					'me/friends': formatFriends,
					'me/followers': formatFriends,
					'me/following': formatFriends,
	
					'me/share': function meShare(res) {
						formatError(res);
						paging(res);
						if (!res.error && 'length' in res) {
							return { data: res };
						}
	
						return res;
					},
	
					'default': function _default(res) {
						res = arrayToDataResponse(res);
						paging(res);
						return res;
					}
				},
				xhr: function xhr(p) {
	
					// Rely on the proxy for non-GET requests.
					return p.method !== 'get';
				}
			}
		});
	
		function formatUser(o) {
			if (o.id) {
				if (o.name) {
					var m = o.name.split(' ');
					o.first_name = m.shift();
					o.last_name = m.join(' ');
				}
	
				// See: https://dev.twitter.com/overview/general/user-profile-images-and-banners
				o.thumbnail = o.profile_image_url_https || o.profile_image_url;
			}
	
			return o;
		}
	
		function formatFriends(o) {
			formatError(o);
			paging(o);
			if (o.users) {
				o.data = o.users.map(formatUser);
				delete o.users;
			}
	
			return o;
		}
	
		function formatError(o) {
			if (o.errors) {
				var e = o.errors[0];
				o.error = {
					code: 'request_failed',
					message: e.message
				};
			}
		}
	
		// Take a cursor and add it to the path
		function paging(res) {
			// Does the response include a 'next_cursor_string'
			if ('next_cursor_str' in res) {
				// See: https://dev.twitter.com/docs/misc/cursoring
				res.paging = {
					next: '?cursor=' + res.next_cursor_str
				};
			}
		}
	
		function arrayToDataResponse(res) {
			return Array.isArray(res) ? { data: res } : res;
		}
	
		/**
	 // The documentation says to define user in the request
	 // Although its not actually required.
	 	var user_id;
	 	function withUserId(callback){
	 	if(user_id){
	 		callback(user_id);
	 	}
	 	else{
	 		hello.api('twitter:/me', function(o){
	 			user_id = o.id;
	 			callback(o.id);
	 		});
	 	}
	 }
	 	function sign(url){
	 	return function(p, callback){
	 		withUserId(function(user_id){
	 			callback(url+'?user_id='+user_id);
	 		});
	 	};
	 }
	 */
	})(hello);
	
	// Vkontakte (vk.com)
	(function (hello) {
	
		hello.init({
	
			vk: {
				name: 'Vk',
	
				// See https://vk.com/dev/oauth_dialog
				oauth: {
					version: 2,
					auth: 'https://oauth.vk.com/authorize',
					grant: 'https://oauth.vk.com/access_token'
				},
	
				// Authorization scopes
				// See https://vk.com/dev/permissions
				scope: {
					email: 'email',
					friends: 'friends',
					photos: 'photos',
					videos: 'video',
					share: 'share',
					offline_access: 'offline'
				},
	
				// Refresh the access_token
				refresh: true,
	
				login: function login(p) {
					p.qs.display = window.navigator && window.navigator.userAgent && /ipad|phone|phone|android/.test(window.navigator.userAgent.toLowerCase()) ? 'mobile' : 'popup';
				},
	
				// API Base URL
				base: 'https://api.vk.com/method/',
	
				// Map GET requests
				get: {
					me: function me(p, callback) {
						p.query.fields = 'id,first_name,last_name,photo_max';
						callback('users.get');
					}
				},
	
				wrap: {
					me: function me(res, headers, req) {
						formatError(res);
						return formatUser(res, req);
					}
				},
	
				// No XHR
				xhr: false,
	
				// All requests should be JSONP as of missing CORS headers in https://api.vk.com/method/*
				jsonp: true,
	
				// No form
				form: false
			}
		});
	
		function formatUser(o, req) {
	
			if (o !== null && 'response' in o && o.response !== null && o.response.length) {
				o = o.response[0];
				o.id = o.uid;
				o.thumbnail = o.picture = o.photo_max;
				o.name = o.first_name + ' ' + o.last_name;
	
				if (req.authResponse && req.authResponse.email !== null) o.email = req.authResponse.email;
			}
	
			return o;
		}
	
		function formatError(o) {
	
			if (o.error) {
				var e = o.error;
				o.error = {
					code: e.error_code,
					message: e.error_msg
				};
			}
		}
	})(hello);
	
	(function (hello) {
	
		hello.init({
			windows: {
				name: 'Windows live',
	
				// REF: http://msdn.microsoft.com/en-us/library/hh243641.aspx
				oauth: {
					version: 2,
					auth: 'https://login.live.com/oauth20_authorize.srf',
					grant: 'https://login.live.com/oauth20_token.srf'
				},
	
				// Refresh the access_token once expired
				refresh: true,
	
				logout: function logout() {
					return 'http://login.live.com/oauth20_logout.srf?ts=' + new Date().getTime();
				},
	
				// Authorization scopes
				scope: {
					basic: 'wl.signin,wl.basic',
					email: 'wl.emails',
					birthday: 'wl.birthday',
					events: 'wl.calendars',
					photos: 'wl.photos',
					videos: 'wl.photos',
					friends: 'wl.contacts_emails',
					files: 'wl.skydrive',
					publish: 'wl.share',
					publish_files: 'wl.skydrive_update',
					share: 'wl.share',
					create_event: 'wl.calendars_update,wl.events_create',
					offline_access: 'wl.offline_access'
				},
	
				// API base URL
				base: 'https://apis.live.net/v5.0/',
	
				// Map GET requests
				get: {
	
					// Friends
					me: 'me',
					'me/friends': 'me/friends',
					'me/following': 'me/contacts',
					'me/followers': 'me/friends',
					'me/contacts': 'me/contacts',
	
					'me/albums': 'me/albums',
	
					// Include the data[id] in the path
					'me/album': '@{id}/files',
					'me/photo': '@{id}',
	
					// Files
					'me/files': '@{parent|me/skydrive}/files',
					'me/folders': '@{id|me/skydrive}/files',
					'me/folder': '@{id|me/skydrive}/files'
				},
	
				// Map POST requests
				post: {
					'me/albums': 'me/albums',
					'me/album': '@{id}/files/',
	
					'me/folders': '@{id|me/skydrive/}',
					'me/files': '@{parent|me/skydrive}/files'
				},
	
				// Map DELETE requests
				del: {
					// Include the data[id] in the path
					'me/album': '@{id}',
					'me/photo': '@{id}',
					'me/folder': '@{id}',
					'me/files': '@{id}'
				},
	
				wrap: {
					me: formatUser,
	
					'me/friends': formatFriends,
					'me/contacts': formatFriends,
					'me/followers': formatFriends,
					'me/following': formatFriends,
					'me/albums': formatAlbums,
					'me/photos': formatDefault,
					'default': formatDefault
				},
	
				xhr: function xhr(p) {
					if (p.method !== 'get' && p.method !== 'delete' && !hello.utils.hasBinary(p.data)) {
	
						// Does this have a data-uri to upload as a file?
						if (typeof p.data.file === 'string') {
							p.data.file = hello.utils.toBlob(p.data.file);
						} else {
							p.data = JSON.stringify(p.data);
							p.headers = {
								'Content-Type': 'application/json'
							};
						}
					}
	
					return true;
				},
	
				jsonp: function jsonp(p) {
					if (p.method !== 'get' && !hello.utils.hasBinary(p.data)) {
						p.data.method = p.method;
						p.method = 'get';
					}
				}
			}
		});
	
		function formatDefault(o) {
			if ('data' in o) {
				o.data.forEach(function (d) {
					if (d.picture) {
						d.thumbnail = d.picture;
					}
	
					if (d.images) {
						d.pictures = d.images.map(formatImage).sort(function (a, b) {
							return a.width - b.width;
						});
					}
				});
			}
	
			return o;
		}
	
		function formatImage(image) {
			return {
				width: image.width,
				height: image.height,
				source: image.source
			};
		}
	
		function formatAlbums(o) {
			if ('data' in o) {
				o.data.forEach(function (d) {
					d.photos = d.files = 'https://apis.live.net/v5.0/' + d.id + '/photos';
				});
			}
	
			return o;
		}
	
		function formatUser(o, headers, req) {
			if (o.id) {
				var token = req.query.access_token;
				if (o.emails) {
					o.email = o.emails.preferred;
				}
	
				// If this is not an non-network friend
				if (o.is_friend !== false) {
					// Use the id of the user_id if available
					var id = o.user_id || o.id;
					o.thumbnail = o.picture = 'https://apis.live.net/v5.0/' + id + '/picture?access_token=' + token;
				}
			}
	
			return o;
		}
	
		function formatFriends(o, headers, req) {
			if ('data' in o) {
				o.data.forEach(function (d) {
					formatUser(d, headers, req);
				});
			}
	
			return o;
		}
	})(hello);
	
	(function (hello) {
	
		hello.init({
	
			yahoo: {
	
				// Ensure that you define an oauth_proxy
				oauth: {
					version: '1.0a',
					auth: 'https://api.login.yahoo.com/oauth/v2/request_auth',
					request: 'https://api.login.yahoo.com/oauth/v2/get_request_token',
					token: 'https://api.login.yahoo.com/oauth/v2/get_token'
				},
	
				// Login handler
				login: function login(p) {
					// Change the default popup window to be at least 560
					// Yahoo does dynamically change it on the fly for the signin screen (only, what if your already signed in)
					p.options.popup.width = 560;
	
					// Yahoo throws an parameter error if for whatever reason the state.scope contains a comma, so lets remove scope
					try {
						delete p.qs.state.scope;
					} catch (e) {}
				},
	
				base: 'https://social.yahooapis.com/v1/',
	
				get: {
					me: yql('select * from social.profile(0) where guid=me'),
					'me/friends': yql('select * from social.contacts(0) where guid=me'),
					'me/following': yql('select * from social.contacts(0) where guid=me')
				},
				wrap: {
					me: formatUser,
	
					// Can't get IDs
					// It might be better to loop through the social.relationship table with has unique IDs of users.
					'me/friends': formatFriends,
					'me/following': formatFriends,
					'default': paging
				}
			}
		});
	
		/*
	 	// Auto-refresh fix: bug in Yahoo can't get this to work with node-oauth-shim
	 	login : function(o){
	 		// Is the user already logged in
	 		var auth = hello('yahoo').getAuthResponse();
	 			// Is this a refresh token?
	 		if(o.options.display==='none'&&auth&&auth.access_token&&auth.refresh_token){
	 			// Add the old token and the refresh token, including path to the query
	 			// See http://developer.yahoo.com/oauth/guide/oauth-refreshaccesstoken.html
	 			o.qs.access_token = auth.access_token;
	 			o.qs.refresh_token = auth.refresh_token;
	 			o.qs.token_url = 'https://api.login.yahoo.com/oauth/v2/get_token';
	 		}
	 	},
	 */
	
		function formatError(o) {
			if (o && 'meta' in o && 'error_type' in o.meta) {
				o.error = {
					code: o.meta.error_type,
					message: o.meta.error_message
				};
			}
		}
	
		function formatUser(o) {
	
			formatError(o);
			if (o.query && o.query.results && o.query.results.profile) {
				o = o.query.results.profile;
				o.id = o.guid;
				o.last_name = o.familyName;
				o.first_name = o.givenName || o.nickname;
				var a = [];
				if (o.first_name) {
					a.push(o.first_name);
				}
	
				if (o.last_name) {
					a.push(o.last_name);
				}
	
				o.name = a.join(' ');
				o.email = o.emails && o.emails[0] ? o.emails[0].handle : null;
				o.thumbnail = o.image ? o.image.imageUrl : null;
			}
	
			return o;
		}
	
		function formatFriends(o, headers, request) {
			formatError(o);
			paging(o, headers, request);
			var contact;
			var field;
			if (o.query && o.query.results && o.query.results.contact) {
				o.data = o.query.results.contact;
				delete o.query;
	
				if (!Array.isArray(o.data)) {
					o.data = [o.data];
				}
	
				o.data.forEach(formatFriend);
			}
	
			return o;
		}
	
		function formatFriend(contact) {
			contact.id = null;
	
			// #362: Reports of responses returning a single item, rather than an Array of items.
			// Format the contact.fields to be an array.
			if (contact.fields && !(contact.fields instanceof Array)) {
				contact.fields = [contact.fields];
			}
	
			(contact.fields || []).forEach(function (field) {
				if (field.type === 'email') {
					contact.email = field.value;
				}
	
				if (field.type === 'name') {
					contact.first_name = field.value.givenName;
					contact.last_name = field.value.familyName;
					contact.name = field.value.givenName + ' ' + field.value.familyName;
				}
	
				if (field.type === 'yahooid') {
					contact.id = field.value;
				}
			});
		}
	
		function paging(res, headers, request) {
	
			// See: http://developer.yahoo.com/yql/guide/paging.html#local_limits
			if (res.query && res.query.count && request.options) {
				res.paging = {
					next: '?start=' + (res.query.count + (+request.options.start || 1))
				};
			}
	
			return res;
		}
	
		function yql(q) {
			return 'https://query.yahooapis.com/v1/yql?q=' + (q + ' limit @{limit|100} offset @{start|0}').replace(/\s/g, '%20') + '&format=json';
		}
	})(hello);
	
	// Register as anonymous AMD module
	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return hello;
		}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	// CommonJS module for browserify
	if (( false ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
		module.exports = hello;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(231), __webpack_require__(532).setImmediate, __webpack_require__(16)(module)))

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(426);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(275);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 115 */
[2260, 210],
/* 116 */
27,
/* 117 */
74,
/* 118 */
[2265, 95, 215, 73],
/* 119 */
[2303, 436, 281],
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(36)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(65)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ },
/* 121 */
/***/ function(module, exports) {

	module.exports = false;


/***/ },
/* 122 */
[2275, 152, 29, 74, 41, 27],
/* 123 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _extends = __webpack_require__(1762);
	var _objectWithoutPropertiesLoose = __webpack_require__(1763);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
	var _objectWithoutPropertiesLoose__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutPropertiesLoose);
	
	//      
	var charCodeOfDot = ".".charCodeAt(0);
	var reEscapeChar = /\\(\\)?/g;
	var rePropName = RegExp( // Match anything that isn't a dot or bracket.
	"[^.[\\]]+" + "|" + // Or match property names within brackets.
	"\\[(?:" + // Match a non-string expression.
	"([^\"'][^[]*)" + "|" + // Or match strings (supports escaping characters).
	"([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2" + ")\\]" + "|" + // Or match "" as the space between consecutive dots or empty brackets.
	"(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	
	var stringToPath = function stringToPath(string) {
	  var result = [];
	
	  if (string.charCodeAt(0) === charCodeOfDot) {
	    result.push("");
	  }
	
	  string.replace(rePropName, function (match, expression, quote, subString) {
	    var key = match;
	
	    if (quote) {
	      key = subString.replace(reEscapeChar, "$1");
	    } else if (expression) {
	      key = expression.trim();
	    }
	
	    result.push(key);
	  });
	  return result;
	};
	
	var keysCache = {};
	
	var toPath = function toPath(key) {
	  if (key === null || key === undefined || !key.length) {
	    return [];
	  }
	
	  if (typeof key !== "string") {
	    throw new Error("toPath() expects a string");
	  }
	
	  if (keysCache[key] == null) {
	    keysCache[key] = stringToPath(key);
	  }
	
	  return keysCache[key];
	};
	
	//      
	
	var getIn = function getIn(state, complexKey) {
	  // Intentionally using iteration rather than recursion
	  var path = toPath(complexKey);
	  var current = state;
	
	  for (var i = 0; i < path.length; i++) {
	    var key = path[i];
	
	    if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) {
	      return undefined;
	    }
	
	    current = current[key];
	  }
	
	  return current;
	};
	
	function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
	
	function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
	
	var setInRecursor = function setInRecursor(current, index, path, value, destroyArrays) {
	  if (index >= path.length) {
	    // end of recursion
	    return value;
	  }
	
	  var key = path[index]; // determine type of key
	
	  if (isNaN(key)) {
	    var _extends2;
	
	    // object set
	    if (current === undefined || current === null) {
	      var _ref;
	
	      // recurse
	      var _result2 = setInRecursor(undefined, index + 1, path, value, destroyArrays); // delete or create an object
	
	
	      return _result2 === undefined ? undefined : (_ref = {}, _ref[key] = _result2, _ref);
	    }
	
	    if (Array.isArray(current)) {
	      throw new Error("Cannot set a non-numeric property on an array");
	    } // current exists, so make a copy of all its values, and add/update the new one
	
	
	    var _result = setInRecursor(current[key], index + 1, path, value, destroyArrays);
	
	    if (_result === undefined) {
	      var numKeys = Object.keys(current).length;
	
	      if (current[key] === undefined && numKeys === 0) {
	        // object was already empty
	        return undefined;
	      }
	
	      if (current[key] !== undefined && numKeys <= 1) {
	        // only key we had was the one we are deleting
	        if (!isNaN(path[index - 1]) && !destroyArrays) {
	          // we are in an array, so return an empty object
	          return {};
	        } else {
	          return undefined;
	        }
	      }
	
	      current[key];
	          var _final = _objectWithoutPropertiesLoose__default["default"](current, [key].map(_toPropertyKey));
	
	      return _final;
	    } // set result in key
	
	
	    return _extends__default["default"]({}, current, (_extends2 = {}, _extends2[key] = _result, _extends2));
	  } // array set
	
	
	  var numericKey = Number(key);
	
	  if (current === undefined || current === null) {
	    // recurse
	    var _result3 = setInRecursor(undefined, index + 1, path, value, destroyArrays); // if nothing returned, delete it
	
	
	    if (_result3 === undefined) {
	      return undefined;
	    } // create an array
	
	
	    var _array = [];
	    _array[numericKey] = _result3;
	    return _array;
	  }
	
	  if (!Array.isArray(current)) {
	    throw new Error("Cannot set a numeric property on an object");
	  } // recurse
	
	
	  var existingValue = current[numericKey];
	  var result = setInRecursor(existingValue, index + 1, path, value, destroyArrays); // current exists, so make a copy of all its values, and add/update the new one
	
	  var array = [].concat(current);
	
	  if (destroyArrays && result === undefined) {
	    array.splice(numericKey, 1);
	
	    if (array.length === 0) {
	      return undefined;
	    }
	  } else {
	    array[numericKey] = result;
	  }
	
	  return array;
	};
	
	var setIn = function setIn(state, key, value, destroyArrays) {
	  if (destroyArrays === void 0) {
	    destroyArrays = false;
	  }
	
	  if (state === undefined || state === null) {
	    throw new Error("Cannot call setIn() with " + String(state) + " state");
	  }
	
	  if (key === undefined || key === null) {
	    throw new Error("Cannot call setIn() with " + String(key) + " key");
	  } // Recursive function needs to accept and return State, but public API should
	  // only deal with Objects
	
	
	  return setInRecursor(state, 0, toPath(key), value, destroyArrays);
	};
	
	var FORM_ERROR = "FINAL_FORM/form-error";
	var ARRAY_ERROR = "FINAL_FORM/array-error";
	
	//      
	/**
	 * Converts internal field state to published field state
	 */
	
	function publishFieldState(formState, field) {
	  var errors = formState.errors,
	      initialValues = formState.initialValues,
	      lastSubmittedValues = formState.lastSubmittedValues,
	      submitErrors = formState.submitErrors,
	      submitFailed = formState.submitFailed,
	      submitSucceeded = formState.submitSucceeded,
	      submitting = formState.submitting,
	      values = formState.values;
	  var active = field.active,
	      blur = field.blur,
	      change = field.change,
	      data = field.data,
	      focus = field.focus,
	      modified = field.modified,
	      modifiedSinceLastSubmit = field.modifiedSinceLastSubmit,
	      name = field.name,
	      touched = field.touched,
	      validating = field.validating,
	      visited = field.visited;
	  var value = getIn(values, name);
	  var error = getIn(errors, name);
	
	  if (error && error[ARRAY_ERROR]) {
	    error = error[ARRAY_ERROR];
	  }
	
	  var submitError = submitErrors && getIn(submitErrors, name);
	  var initial = initialValues && getIn(initialValues, name);
	  var pristine = field.isEqual(initial, value);
	  var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual(getIn(lastSubmittedValues, name), value));
	  var valid = !error && !submitError;
	  return {
	    active: active,
	    blur: blur,
	    change: change,
	    data: data,
	    dirty: !pristine,
	    dirtySinceLastSubmit: dirtySinceLastSubmit,
	    error: error,
	    focus: focus,
	    initial: initial,
	    invalid: !valid,
	    length: Array.isArray(value) ? value.length : undefined,
	    modified: modified,
	    modifiedSinceLastSubmit: modifiedSinceLastSubmit,
	    name: name,
	    pristine: pristine,
	    submitError: submitError,
	    submitFailed: submitFailed,
	    submitSucceeded: submitSucceeded,
	    submitting: submitting,
	    touched: touched,
	    valid: valid,
	    value: value,
	    visited: visited,
	    validating: validating
	  };
	}
	
	//      
	var fieldSubscriptionItems = ["active", "data", "dirty", "dirtySinceLastSubmit", "error", "initial", "invalid", "length", "modified", "modifiedSinceLastSubmit", "pristine", "submitError", "submitFailed", "submitSucceeded", "submitting", "touched", "valid", "value", "visited", "validating"];
	
	//      
	var shallowEqual = function shallowEqual(a, b) {
	  if (a === b) {
	    return true;
	  }
	
	  if (typeof a !== "object" || !a || typeof b !== "object" || !b) {
	    return false;
	  }
	
	  var keysA = Object.keys(a);
	  var keysB = Object.keys(b);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
	
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key) || a[key] !== b[key]) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	//      
	function subscriptionFilter (dest, src, previous, subscription, keys, shallowEqualKeys) {
	  var different = false;
	  keys.forEach(function (key) {
	    if (subscription[key]) {
	      dest[key] = src[key];
	
	      if (!previous || (~shallowEqualKeys.indexOf(key) ? !shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) {
	        different = true;
	      }
	    }
	  });
	  return different;
	}
	
	//      
	var shallowEqualKeys$1 = ["data"];
	/**
	 * Filters items in a FieldState based on a FieldSubscription
	 */
	
	var filterFieldState = function filterFieldState(state, previousState, subscription, force) {
	  var result = {
	    blur: state.blur,
	    change: state.change,
	    focus: state.focus,
	    name: state.name
	  };
	  var different = subscriptionFilter(result, state, previousState, subscription, fieldSubscriptionItems, shallowEqualKeys$1) || !previousState;
	  return different || force ? result : undefined;
	};
	
	//      
	var formSubscriptionItems = ["active", "dirty", "dirtyFields", "dirtyFieldsSinceLastSubmit", "dirtySinceLastSubmit", "error", "errors", "hasSubmitErrors", "hasValidationErrors", "initialValues", "invalid", "modified", "modifiedSinceLastSubmit", "pristine", "submitting", "submitError", "submitErrors", "submitFailed", "submitSucceeded", "touched", "valid", "validating", "values", "visited"];
	
	//      
	var shallowEqualKeys = ["touched", "visited"];
	/**
	 * Filters items in a FormState based on a FormSubscription
	 */
	
	function filterFormState(state, previousState, subscription, force) {
	  var result = {};
	  var different = subscriptionFilter(result, state, previousState, subscription, formSubscriptionItems, shallowEqualKeys) || !previousState;
	  return different || force ? result : undefined;
	}
	
	//      
	
	var memoize = function memoize(fn) {
	  var lastArgs;
	  var lastResult;
	  return function () {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (!lastArgs || args.length !== lastArgs.length || args.some(function (arg, index) {
	      return !shallowEqual(lastArgs[index], arg);
	    })) {
	      lastArgs = args;
	      lastResult = fn.apply(void 0, args);
	    }
	
	    return lastResult;
	  };
	};
	
	var isPromise = (function (obj) {
	  return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
	});
	
	var version = "4.20.4";
	
	var configOptions = ["debug", "initialValues", "keepDirtyOnReinitialize", "mutators", "onSubmit", "validate", "validateOnBlur"];
	
	var tripleEquals = function tripleEquals(a, b) {
	  return a === b;
	};
	
	var hasAnyError = function hasAnyError(errors) {
	  return Object.keys(errors).some(function (key) {
	    var value = errors[key];
	
	    if (value && typeof value === "object" && !(value instanceof Error)) {
	      return hasAnyError(value);
	    }
	
	    return typeof value !== "undefined";
	  });
	};
	
	function convertToExternalFormState(_ref) {
	  var active = _ref.active,
	      dirtySinceLastSubmit = _ref.dirtySinceLastSubmit,
	      modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit,
	      error = _ref.error,
	      errors = _ref.errors,
	      initialValues = _ref.initialValues,
	      pristine = _ref.pristine,
	      submitting = _ref.submitting,
	      submitFailed = _ref.submitFailed,
	      submitSucceeded = _ref.submitSucceeded,
	      submitError = _ref.submitError,
	      submitErrors = _ref.submitErrors,
	      valid = _ref.valid,
	      validating = _ref.validating,
	      values = _ref.values;
	  return {
	    active: active,
	    dirty: !pristine,
	    dirtySinceLastSubmit: dirtySinceLastSubmit,
	    modifiedSinceLastSubmit: modifiedSinceLastSubmit,
	    error: error,
	    errors: errors,
	    hasSubmitErrors: !!(submitError || submitErrors && hasAnyError(submitErrors)),
	    hasValidationErrors: !!(error || hasAnyError(errors)),
	    invalid: !valid,
	    initialValues: initialValues,
	    pristine: pristine,
	    submitting: submitting,
	    submitFailed: submitFailed,
	    submitSucceeded: submitSucceeded,
	    submitError: submitError,
	    submitErrors: submitErrors,
	    valid: valid,
	    validating: validating > 0,
	    values: values
	  };
	}
	
	function notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
	  var notification = filter(state, lastState, subscription, force);
	
	  if (notification) {
	    subscriber(notification);
	    return true;
	  }
	
	  return false;
	}
	
	function notify(_ref2, state, lastState, filter, force) {
	  var entries = _ref2.entries;
	  Object.keys(entries).forEach(function (key) {
	    var entry = entries[Number(key)]; // istanbul ignore next
	
	    if (entry) {
	      var subscription = entry.subscription,
	          subscriber = entry.subscriber,
	          notified = entry.notified;
	
	      if (notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) {
	        entry.notified = true;
	      }
	    }
	  });
	}
	
	function createForm(config) {
	  if (!config) {
	    throw new Error("No config specified");
	  }
	
	  var debug = config.debug,
	      destroyOnUnregister = config.destroyOnUnregister,
	      keepDirtyOnReinitialize = config.keepDirtyOnReinitialize,
	      initialValues = config.initialValues,
	      mutators = config.mutators,
	      onSubmit = config.onSubmit,
	      validate = config.validate,
	      validateOnBlur = config.validateOnBlur;
	
	  if (!onSubmit) {
	    throw new Error("No onSubmit function specified");
	  }
	
	  var state = {
	    subscribers: {
	      index: 0,
	      entries: {}
	    },
	    fieldSubscribers: {},
	    fields: {},
	    formState: {
	      dirtySinceLastSubmit: false,
	      modifiedSinceLastSubmit: false,
	      errors: {},
	      initialValues: initialValues && _extends__default["default"]({}, initialValues),
	      invalid: false,
	      pristine: true,
	      submitting: false,
	      submitFailed: false,
	      submitSucceeded: false,
	      resetWhileSubmitting: false,
	      valid: true,
	      validating: 0,
	      values: initialValues ? _extends__default["default"]({}, initialValues) : {}
	    },
	    lastFormState: undefined
	  };
	  var inBatch = 0;
	  var validationPaused = false;
	  var validationBlocked = false;
	  var preventNotificationWhileValidationPaused = false;
	  var nextAsyncValidationKey = 0;
	  var asyncValidationPromises = {};
	
	  var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
	    return function (result) {
	      delete asyncValidationPromises[key];
	      return result;
	    };
	  };
	
	  var changeValue = function changeValue(state, name, mutate) {
	    var before = getIn(state.formState.values, name);
	    var after = mutate(before);
	    state.formState.values = setIn(state.formState.values, name, after) || {};
	  };
	
	  var renameField = function renameField(state, from, to) {
	    if (state.fields[from]) {
	      var _extends2, _extends3;
	
	      state.fields = _extends__default["default"]({}, state.fields, (_extends2 = {}, _extends2[to] = _extends__default["default"]({}, state.fields[from], {
	        name: to,
	        // rebind event handlers
	        blur: function blur() {
	          return api.blur(to);
	        },
	        change: function change(value) {
	          return api.change(to, value);
	        },
	        focus: function focus() {
	          return api.focus(to);
	        },
	        lastFieldState: undefined
	      }), _extends2));
	      delete state.fields[from];
	      state.fieldSubscribers = _extends__default["default"]({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
	      delete state.fieldSubscribers[from];
	      var value = getIn(state.formState.values, from);
	      state.formState.values = setIn(state.formState.values, from, undefined) || {};
	      state.formState.values = setIn(state.formState.values, to, value);
	      delete state.lastFormState;
	    }
	  }; // bind state to mutators
	
	
	  var getMutatorApi = function getMutatorApi(key) {
	    return function () {
	      // istanbul ignore next
	      if (mutators) {
	        // ^^ causes branch coverage warning, but needed to appease the Flow gods
	        var mutatableState = {
	          formState: state.formState,
	          fields: state.fields,
	          fieldSubscribers: state.fieldSubscribers,
	          lastFormState: state.lastFormState
	        };
	
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        var returnValue = mutators[key](args, mutatableState, {
	          changeValue: changeValue,
	          getIn: getIn,
	          renameField: renameField,
	          resetFieldState: api.resetFieldState,
	          setIn: setIn,
	          shallowEqual: shallowEqual
	        });
	        state.formState = mutatableState.formState;
	        state.fields = mutatableState.fields;
	        state.fieldSubscribers = mutatableState.fieldSubscribers;
	        state.lastFormState = mutatableState.lastFormState;
	        runValidation(undefined, function () {
	          notifyFieldListeners();
	          notifyFormListeners();
	        });
	        return returnValue;
	      }
	    };
	  };
	
	  var mutatorsApi = mutators ? Object.keys(mutators).reduce(function (result, key) {
	    result[key] = getMutatorApi(key);
	    return result;
	  }, {}) : {};
	
	  var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
	    var promises = [];
	
	    if (validate) {
	      var errorsOrPromise = validate(_extends__default["default"]({}, state.formState.values)); // clone to avoid writing
	
	      if (isPromise(errorsOrPromise)) {
	        promises.push(errorsOrPromise.then(setErrors));
	      } else {
	        setErrors(errorsOrPromise);
	      }
	    }
	
	    return promises;
	  };
	
	  var getValidators = function getValidators(field) {
	    return Object.keys(field.validators).reduce(function (result, index) {
	      var validator = field.validators[Number(index)]();
	
	      if (validator) {
	        result.push(validator);
	      }
	
	      return result;
	    }, []);
	  };
	
	  var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
	    var promises = [];
	    var validators = getValidators(field);
	
	    if (validators.length) {
	      var error;
	      validators.forEach(function (validator) {
	        var errorOrPromise = validator(getIn(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? publishFieldState(state.formState, state.fields[field.name]) : undefined);
	
	        if (errorOrPromise && isPromise(errorOrPromise)) {
	          field.validating = true;
	          var promise = errorOrPromise.then(function (error) {
	            if (state.fields[field.name]) {
	              state.fields[field.name].validating = false;
	              setError(error);
	            }
	          }); // errors must be resolved, not rejected
	
	          promises.push(promise);
	        } else if (!error) {
	          // first registered validator wins
	          error = errorOrPromise;
	        }
	      });
	      setError(error);
	    }
	
	    return promises;
	  };
	
	  var runValidation = function runValidation(fieldChanged, callback) {
	    if (validationPaused) {
	      validationBlocked = true;
	      callback();
	      return;
	    }
	
	    var fields = state.fields,
	        formState = state.formState;
	
	    var safeFields = _extends__default["default"]({}, fields);
	
	    var fieldKeys = Object.keys(safeFields);
	
	    if (!validate && !fieldKeys.some(function (key) {
	      return getValidators(safeFields[key]).length;
	    })) {
	      callback();
	      return; // no validation rules
	    } // pare down field keys to actually validate
	
	
	    var limitedFieldLevelValidation = false;
	
	    if (fieldChanged) {
	      var changedField = safeFields[fieldChanged];
	
	      if (changedField) {
	        var validateFields = changedField.validateFields;
	
	        if (validateFields) {
	          limitedFieldLevelValidation = true;
	          fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [fieldChanged];
	        }
	      }
	    }
	
	    var recordLevelErrors = {};
	    var fieldLevelErrors = {};
	    var promises = [].concat(runRecordLevelValidation(function (errors) {
	      recordLevelErrors = errors || {};
	    }), fieldKeys.reduce(function (result, name) {
	      return result.concat(runFieldLevelValidation(fields[name], function (error) {
	        fieldLevelErrors[name] = error;
	      }));
	    }, []));
	    var hasAsyncValidations = promises.length > 0;
	    var asyncValidationPromiseKey = ++nextAsyncValidationKey;
	    var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey)); // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
	
	    if (hasAsyncValidations) {
	      asyncValidationPromises[asyncValidationPromiseKey] = promise;
	    }
	
	    var processErrors = function processErrors() {
	      var merged = _extends__default["default"]({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors);
	
	      var forEachError = function forEachError(fn) {
	        fieldKeys.forEach(function (name) {
	          if (fields[name]) {
	            // make sure field is still registered
	            // field-level errors take precedent over record-level errors
	            var recordLevelError = getIn(recordLevelErrors, name);
	            var errorFromParent = getIn(merged, name);
	            var hasFieldLevelValidation = getValidators(safeFields[name]).length;
	            var fieldLevelError = fieldLevelErrors[name];
	            fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
	          }
	        });
	      };
	
	      forEachError(function (name, error) {
	        merged = setIn(merged, name, error) || {};
	      });
	      forEachError(function (name, error) {
	        if (error && error[ARRAY_ERROR]) {
	          var existing = getIn(merged, name);
	          var copy = [].concat(existing);
	          copy[ARRAY_ERROR] = error[ARRAY_ERROR];
	          merged = setIn(merged, name, copy);
	        }
	      });
	
	      if (!shallowEqual(formState.errors, merged)) {
	        formState.errors = merged;
	      }
	
	      formState.error = recordLevelErrors[FORM_ERROR];
	    };
	
	    if (hasAsyncValidations) {
	      // async validations are running, ensure validating is true before notifying
	      state.formState.validating++;
	      callback();
	    } // process sync errors
	
	
	    processErrors(); // sync errors have been set. notify listeners while we wait for others
	
	    callback();
	
	    if (hasAsyncValidations) {
	      var afterPromise = function afterPromise() {
	        state.formState.validating--;
	        callback();
	      };
	
	      promise.then(function () {
	        if (nextAsyncValidationKey > asyncValidationPromiseKey) {
	          // if this async validator has been superseded by another, ignore its results
	          return;
	        }
	
	        processErrors();
	      }).then(afterPromise, afterPromise);
	    }
	  };
	
	  var notifyFieldListeners = function notifyFieldListeners(name) {
	    if (inBatch) {
	      return;
	    }
	
	    var fields = state.fields,
	        fieldSubscribers = state.fieldSubscribers,
	        formState = state.formState;
	
	    var safeFields = _extends__default["default"]({}, fields);
	
	    var notifyField = function notifyField(name) {
	      var field = safeFields[name];
	      var fieldState = publishFieldState(formState, field);
	      var lastFieldState = field.lastFieldState;
	      field.lastFieldState = fieldState;
	      var fieldSubscriber = fieldSubscribers[name];
	
	      if (fieldSubscriber) {
	        notify(fieldSubscriber, fieldState, lastFieldState, filterFieldState, lastFieldState === undefined);
	      }
	    };
	
	    if (name) {
	      notifyField(name);
	    } else {
	      Object.keys(safeFields).forEach(notifyField);
	    }
	  };
	
	  var markAllFieldsTouched = function markAllFieldsTouched() {
	    Object.keys(state.fields).forEach(function (key) {
	      state.fields[key].touched = true;
	    });
	  };
	
	  var hasSyncErrors = function hasSyncErrors() {
	    return !!(state.formState.error || hasAnyError(state.formState.errors));
	  };
	
	  var calculateNextFormState = function calculateNextFormState() {
	    var fields = state.fields,
	        formState = state.formState,
	        lastFormState = state.lastFormState;
	
	    var safeFields = _extends__default["default"]({}, fields);
	
	    var safeFieldKeys = Object.keys(safeFields); // calculate dirty/pristine
	
	    var foundDirty = false;
	    var dirtyFields = safeFieldKeys.reduce(function (result, key) {
	      var dirty = !safeFields[key].isEqual(getIn(formState.values, key), getIn(formState.initialValues || {}, key));
	
	      if (dirty) {
	        foundDirty = true;
	        result[key] = true;
	      }
	
	      return result;
	    }, {});
	    var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function (result, key) {
	      // istanbul ignore next
	      var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
	
	      if (!safeFields[key].isEqual(getIn(formState.values, key), getIn(nonNullLastSubmittedValues, key))) {
	        result[key] = true;
	      }
	
	      return result;
	    }, {});
	    formState.pristine = !foundDirty;
	    formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function (value) {
	      return value;
	    }));
	    formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
	    Object.keys(safeFields).some(function (value) {
	      return safeFields[value].modifiedSinceLastSubmit;
	    }));
	    formState.valid = !formState.error && !formState.submitError && !hasAnyError(formState.errors) && !(formState.submitErrors && hasAnyError(formState.submitErrors));
	    var nextFormState = convertToExternalFormState(formState);
	
	    var _safeFieldKeys$reduce = safeFieldKeys.reduce(function (result, key) {
	      result.modified[key] = safeFields[key].modified;
	      result.touched[key] = safeFields[key].touched;
	      result.visited[key] = safeFields[key].visited;
	      return result;
	    }, {
	      modified: {},
	      touched: {},
	      visited: {}
	    }),
	        modified = _safeFieldKeys$reduce.modified,
	        touched = _safeFieldKeys$reduce.touched,
	        visited = _safeFieldKeys$reduce.visited;
	
	    nextFormState.dirtyFields = lastFormState && shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
	    nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
	    nextFormState.modified = lastFormState && shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
	    nextFormState.touched = lastFormState && shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
	    nextFormState.visited = lastFormState && shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
	    return lastFormState && shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
	  };
	
	  var callDebug = function callDebug() {
	    return debug && ("production") !== "production" && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function (result, key) {
	      result[key] = state.fields[key];
	      return result;
	    }, {}));
	  };
	
	  var notifying = false;
	  var scheduleNotification = false;
	
	  var notifyFormListeners = function notifyFormListeners() {
	    if (notifying) {
	      scheduleNotification = true;
	    } else {
	      notifying = true;
	      callDebug();
	
	      if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
	        var lastFormState = state.lastFormState;
	        var nextFormState = calculateNextFormState();
	
	        if (nextFormState !== lastFormState) {
	          state.lastFormState = nextFormState;
	          notify(state.subscribers, nextFormState, lastFormState, filterFormState);
	        }
	      }
	
	      notifying = false;
	
	      if (scheduleNotification) {
	        scheduleNotification = false;
	        notifyFormListeners();
	      }
	    }
	  };
	
	  var beforeSubmit = function beforeSubmit() {
	    return Object.keys(state.fields).some(function (name) {
	      return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
	    });
	  };
	
	  var afterSubmit = function afterSubmit() {
	    return Object.keys(state.fields).forEach(function (name) {
	      return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
	    });
	  };
	
	  var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
	    return Object.keys(state.fields).forEach(function (key) {
	      return state.fields[key].modifiedSinceLastSubmit = false;
	    });
	  }; // generate initial errors
	
	
	  runValidation(undefined, function () {
	    notifyFormListeners();
	  });
	  var api = {
	    batch: function batch(fn) {
	      inBatch++;
	      fn();
	      inBatch--;
	      notifyFieldListeners();
	      notifyFormListeners();
	    },
	    blur: function blur(name) {
	      var fields = state.fields,
	          formState = state.formState;
	      var previous = fields[name];
	
	      if (previous) {
	        // can only blur registered fields
	        delete formState.active;
	        fields[name] = _extends__default["default"]({}, previous, {
	          active: false,
	          touched: true
	        });
	
	        if (validateOnBlur) {
	          runValidation(name, function () {
	            notifyFieldListeners();
	            notifyFormListeners();
	          });
	        } else {
	          notifyFieldListeners();
	          notifyFormListeners();
	        }
	      }
	    },
	    change: function change(name, value) {
	      var fields = state.fields,
	          formState = state.formState;
	
	      if (getIn(formState.values, name) !== value) {
	        changeValue(state, name, function () {
	          return value;
	        });
	        var previous = fields[name];
	
	        if (previous) {
	          // only track modified for registered fields
	          fields[name] = _extends__default["default"]({}, previous, {
	            modified: true,
	            modifiedSinceLastSubmit: !!formState.lastSubmittedValues
	          });
	        }
	
	        if (validateOnBlur) {
	          notifyFieldListeners();
	          notifyFormListeners();
	        } else {
	          runValidation(name, function () {
	            notifyFieldListeners();
	            notifyFormListeners();
	          });
	        }
	      }
	    },
	
	    get destroyOnUnregister() {
	      return !!destroyOnUnregister;
	    },
	
	    set destroyOnUnregister(value) {
	      destroyOnUnregister = value;
	    },
	
	    focus: function focus(name) {
	      var field = state.fields[name];
	
	      if (field && !field.active) {
	        state.formState.active = name;
	        field.active = true;
	        field.visited = true;
	        notifyFieldListeners();
	        notifyFormListeners();
	      }
	    },
	    mutators: mutatorsApi,
	    getFieldState: function getFieldState(name) {
	      var field = state.fields[name];
	      return field && field.lastFieldState;
	    },
	    getRegisteredFields: function getRegisteredFields() {
	      return Object.keys(state.fields);
	    },
	    getState: function getState() {
	      return calculateNextFormState();
	    },
	    initialize: function initialize(data) {
	      var fields = state.fields,
	          formState = state.formState;
	
	      var safeFields = _extends__default["default"]({}, fields);
	
	      var values = typeof data === "function" ? data(formState.values) : data;
	
	      if (!keepDirtyOnReinitialize) {
	        formState.values = values;
	      }
	      /**
	       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
	       *
	       * The following code is the way it is to allow for non-registered deep
	       * field values to be set via initialize()
	       */
	      // save dirty values
	
	
	      var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function (result, key) {
	        var field = safeFields[key];
	        var pristine = field.isEqual(getIn(formState.values, key), getIn(formState.initialValues || {}, key));
	
	        if (!pristine) {
	          result[key] = getIn(formState.values, key);
	        }
	
	        return result;
	      }, {}) : {}; // update initalValues and values
	
	      formState.initialValues = values;
	      formState.values = values; // restore the dirty values
	
	      Object.keys(savedDirtyValues).forEach(function (key) {
	        formState.values = setIn(formState.values, key, savedDirtyValues[key]);
	      });
	      runValidation(undefined, function () {
	        notifyFieldListeners();
	        notifyFormListeners();
	      });
	    },
	    isValidationPaused: function isValidationPaused() {
	      return validationPaused;
	    },
	    pauseValidation: function pauseValidation(preventNotification) {
	      if (preventNotification === void 0) {
	        preventNotification = true;
	      }
	
	      validationPaused = true;
	      preventNotificationWhileValidationPaused = preventNotification;
	    },
	    registerField: function registerField(name, subscriber, subscription, fieldConfig) {
	      if (subscription === void 0) {
	        subscription = {};
	      }
	
	      if (!state.fieldSubscribers[name]) {
	        state.fieldSubscribers[name] = {
	          index: 0,
	          entries: {}
	        };
	      }
	
	      var index = state.fieldSubscribers[name].index++; // save field subscriber callback
	
	      state.fieldSubscribers[name].entries[index] = {
	        subscriber: memoize(subscriber),
	        subscription: subscription,
	        notified: false
	      };
	
	      if (!state.fields[name]) {
	        // create initial field state
	        state.fields[name] = {
	          active: false,
	          afterSubmit: fieldConfig && fieldConfig.afterSubmit,
	          beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
	          blur: function blur() {
	            return api.blur(name);
	          },
	          change: function change(value) {
	            return api.change(name, value);
	          },
	          data: fieldConfig && fieldConfig.data || {},
	          focus: function focus() {
	            return api.focus(name);
	          },
	          isEqual: fieldConfig && fieldConfig.isEqual || tripleEquals,
	          lastFieldState: undefined,
	          modified: false,
	          modifiedSinceLastSubmit: false,
	          name: name,
	          touched: false,
	          valid: true,
	          validateFields: fieldConfig && fieldConfig.validateFields,
	          validators: {},
	          validating: false,
	          visited: false
	        };
	      }
	
	      var haveValidator = false;
	      var silent = fieldConfig && fieldConfig.silent;
	
	      var notify = function notify() {
	        if (silent) {
	          notifyFieldListeners(name);
	        } else {
	          notifyFormListeners();
	          notifyFieldListeners();
	        }
	      };
	
	      if (fieldConfig) {
	        haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
	
	        if (fieldConfig.getValidator) {
	          state.fields[name].validators[index] = fieldConfig.getValidator;
	        }
	
	        var noValueInFormState = getIn(state.formState.values, name) === undefined;
	
	        if (fieldConfig.initialValue !== undefined && (noValueInFormState || getIn(state.formState.values, name) === getIn(state.formState.initialValues, name)) // only initialize if we don't yet have any value for this field
	        ) {
	          state.formState.initialValues = setIn(state.formState.initialValues || {}, name, fieldConfig.initialValue);
	          state.formState.values = setIn(state.formState.values, name, fieldConfig.initialValue);
	          runValidation(undefined, notify);
	        } // only use defaultValue if we don't yet have any value for this field
	
	
	        if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && getIn(state.formState.initialValues, name) === undefined && noValueInFormState) {
	          state.formState.values = setIn(state.formState.values, name, fieldConfig.defaultValue);
	        }
	      }
	
	      if (haveValidator) {
	        runValidation(undefined, notify);
	      } else {
	        notify();
	      }
	
	      return function () {
	        var validatorRemoved = false; // istanbul ignore next
	
	        if (state.fields[name]) {
	          // state.fields[name] may have been removed by a mutator
	          validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
	          delete state.fields[name].validators[index];
	        }
	
	        var hasFieldSubscribers = !!state.fieldSubscribers[name];
	
	        if (hasFieldSubscribers) {
	          // state.fieldSubscribers[name] may have been removed by a mutator
	          delete state.fieldSubscribers[name].entries[index];
	        }
	
	        var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
	
	        if (lastOne) {
	          delete state.fieldSubscribers[name];
	          delete state.fields[name];
	
	          if (validatorRemoved) {
	            state.formState.errors = setIn(state.formState.errors, name, undefined) || {};
	          }
	
	          if (destroyOnUnregister) {
	            state.formState.values = setIn(state.formState.values, name, undefined, true) || {};
	          }
	        }
	
	        if (!silent) {
	          if (validatorRemoved) {
	            runValidation(undefined, function () {
	              notifyFormListeners();
	              notifyFieldListeners();
	            });
	          } else if (lastOne) {
	            // values or errors may have changed
	            notifyFormListeners();
	          }
	        }
	      };
	    },
	    reset: function reset(initialValues) {
	      if (initialValues === void 0) {
	        initialValues = state.formState.initialValues;
	      }
	
	      if (state.formState.submitting) {
	        state.formState.resetWhileSubmitting = true;
	      }
	
	      state.formState.submitFailed = false;
	      state.formState.submitSucceeded = false;
	      delete state.formState.submitError;
	      delete state.formState.submitErrors;
	      delete state.formState.lastSubmittedValues;
	      api.initialize(initialValues || {});
	    },
	
	    /**
	     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
	     */
	    resetFieldState: function resetFieldState(name) {
	      state.fields[name] = _extends__default["default"]({}, state.fields[name], {
	        active: false,
	        lastFieldState: undefined,
	        modified: false,
	        touched: false,
	        valid: true,
	        validating: false,
	        visited: false
	      });
	      runValidation(undefined, function () {
	        notifyFieldListeners();
	        notifyFormListeners();
	      });
	    },
	
	    /**
	     * Returns the form to a clean slate; that is:
	     * - Clear all values
	     * - Resets all fields to their initial state
	     */
	    restart: function restart(initialValues) {
	      if (initialValues === void 0) {
	        initialValues = state.formState.initialValues;
	      }
	
	      api.batch(function () {
	        for (var name in state.fields) {
	          api.resetFieldState(name);
	          state.fields[name] = _extends__default["default"]({}, state.fields[name], {
	            active: false,
	            lastFieldState: undefined,
	            modified: false,
	            modifiedSinceLastSubmit: false,
	            touched: false,
	            valid: true,
	            validating: false,
	            visited: false
	          });
	        }
	
	        api.reset(initialValues);
	      });
	    },
	    resumeValidation: function resumeValidation() {
	      validationPaused = false;
	      preventNotificationWhileValidationPaused = false;
	
	      if (validationBlocked) {
	        // validation was attempted while it was paused, so run it now
	        runValidation(undefined, function () {
	          notifyFieldListeners();
	          notifyFormListeners();
	        });
	      }
	
	      validationBlocked = false;
	    },
	    setConfig: function setConfig(name, value) {
	      switch (name) {
	        case "debug":
	          debug = value;
	          break;
	
	        case "destroyOnUnregister":
	          destroyOnUnregister = value;
	          break;
	
	        case "initialValues":
	          api.initialize(value);
	          break;
	
	        case "keepDirtyOnReinitialize":
	          keepDirtyOnReinitialize = value;
	          break;
	
	        case "mutators":
	          mutators = value;
	
	          if (value) {
	            Object.keys(mutatorsApi).forEach(function (key) {
	              if (!(key in value)) {
	                delete mutatorsApi[key];
	              }
	            });
	            Object.keys(value).forEach(function (key) {
	              mutatorsApi[key] = getMutatorApi(key);
	            });
	          } else {
	            Object.keys(mutatorsApi).forEach(function (key) {
	              delete mutatorsApi[key];
	            });
	          }
	
	          break;
	
	        case "onSubmit":
	          onSubmit = value;
	          break;
	
	        case "validate":
	          validate = value;
	          runValidation(undefined, function () {
	            notifyFieldListeners();
	            notifyFormListeners();
	          });
	          break;
	
	        case "validateOnBlur":
	          validateOnBlur = value;
	          break;
	
	        default:
	          throw new Error("Unrecognised option " + name);
	      }
	    },
	    submit: function submit() {
	      var formState = state.formState;
	
	      if (formState.submitting) {
	        return;
	      }
	
	      delete formState.submitErrors;
	      delete formState.submitError;
	      formState.lastSubmittedValues = _extends__default["default"]({}, formState.values);
	
	      if (hasSyncErrors()) {
	        markAllFieldsTouched();
	        resetModifiedAfterSubmit();
	        state.formState.submitFailed = true;
	        notifyFormListeners();
	        notifyFieldListeners();
	        return; // no submit for you!!
	      }
	
	      var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
	
	      if (asyncValidationPromisesKeys.length) {
	        // still waiting on async validation to complete...
	        Promise.all(asyncValidationPromisesKeys.map(function (key) {
	          return asyncValidationPromises[Number(key)];
	        })).then(api.submit, console.error);
	        return;
	      }
	
	      var submitIsBlocked = beforeSubmit();
	
	      if (submitIsBlocked) {
	        return;
	      }
	
	      var resolvePromise;
	      var completeCalled = false;
	
	      var complete = function complete(errors) {
	        formState.submitting = false;
	        var resetWhileSubmitting = formState.resetWhileSubmitting;
	
	        if (resetWhileSubmitting) {
	          formState.resetWhileSubmitting = false;
	        }
	
	        if (errors && hasAnyError(errors)) {
	          formState.submitFailed = true;
	          formState.submitSucceeded = false;
	          formState.submitErrors = errors;
	          formState.submitError = errors[FORM_ERROR];
	          markAllFieldsTouched();
	        } else {
	          if (!resetWhileSubmitting) {
	            formState.submitFailed = false;
	            formState.submitSucceeded = true;
	          }
	
	          afterSubmit();
	        }
	
	        notifyFormListeners();
	        notifyFieldListeners();
	        completeCalled = true;
	
	        if (resolvePromise) {
	          resolvePromise(errors);
	        }
	
	        return errors;
	      };
	
	      formState.submitting = true;
	      formState.submitFailed = false;
	      formState.submitSucceeded = false;
	      formState.lastSubmittedValues = _extends__default["default"]({}, formState.values);
	      resetModifiedAfterSubmit(); // onSubmit is either sync, callback or async with a Promise
	
	      var result = onSubmit(formState.values, api, complete);
	
	      if (!completeCalled) {
	        if (result && isPromise(result)) {
	          // onSubmit is async with a Promise
	          notifyFormListeners(); // let everyone know we are submitting
	
	          notifyFieldListeners(); // notify fields also
	
	          return result.then(complete, function (error) {
	            complete();
	            throw error;
	          });
	        } else if (onSubmit.length >= 3) {
	          // must be async, so we should return a Promise
	          notifyFormListeners(); // let everyone know we are submitting
	
	          notifyFieldListeners(); // notify fields also
	
	          return new Promise(function (resolve) {
	            resolvePromise = resolve;
	          });
	        } else {
	          // onSubmit is sync
	          complete(result);
	        }
	      }
	    },
	    subscribe: function subscribe(subscriber, subscription) {
	      if (!subscriber) {
	        throw new Error("No callback given.");
	      }
	
	      if (!subscription) {
	        throw new Error("No subscription provided. What values do you want to listen to?");
	      }
	
	      var memoized = memoize(subscriber);
	      var subscribers = state.subscribers;
	      var index = subscribers.index++;
	      subscribers.entries[index] = {
	        subscriber: memoized,
	        subscription: subscription,
	        notified: false
	      };
	      var nextFormState = calculateNextFormState();
	      notifySubscriber(memoized, subscription, nextFormState, nextFormState, filterFormState, true);
	      return function () {
	        delete subscribers.entries[index];
	      };
	    }
	  };
	  return api;
	}
	
	exports.ARRAY_ERROR = ARRAY_ERROR;
	exports.FORM_ERROR = FORM_ERROR;
	exports.configOptions = configOptions;
	exports.createForm = createForm;
	exports.fieldSubscriptionItems = fieldSubscriptionItems;
	exports.formSubscriptionItems = formSubscriptionItems;
	exports.getIn = getIn;
	exports.setIn = setIn;
	exports.version = version;


/***/ },
/* 125 */
[2250, 852],
/* 126 */
[2243, 2092],
/* 127 */
58,
/* 128 */
/***/ function(module, exports) {

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	module.exports = _defineProperty;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1589);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./connections.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./connections.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 130 */
[2412, 1664],
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var serialize = __webpack_require__(536);
	
	function css() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return serialize.serializeStyles(args);
	}
	
	exports.default = css;


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.RowHeader = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CreditorsResultRow = __webpack_require__(365);
	
	var _CreditorsResultRow2 = _interopRequireDefault(_CreditorsResultRow);
	
	var _FilersResultRow = __webpack_require__(366);
	
	var _FilersResultRow2 = _interopRequireDefault(_FilersResultRow);
	
	var _AttorneysResultRow = __webpack_require__(364);
	
	var _AttorneysResultRow2 = _interopRequireDefault(_AttorneysResultRow);
	
	var _AliasesResultRow = __webpack_require__(363);
	
	var _AliasesResultRow2 = _interopRequireDefault(_AliasesResultRow);
	
	var _HTMLResultRow = __webpack_require__(367);
	
	var _HTMLResultRow2 = _interopRequireDefault(_HTMLResultRow);
	
	var _ScheduleResultRow = __webpack_require__(643);
	
	var _ScheduleResultRow2 = _interopRequireDefault(_ScheduleResultRow);
	
	var _AssociatedCasesResultRow = __webpack_require__(636);
	
	var _AssociatedCasesResultRow2 = _interopRequireDefault(_AssociatedCasesResultRow);
	
	var _TransactionsResultRow = __webpack_require__(645);
	
	var _TransactionsResultRow2 = _interopRequireDefault(_TransactionsResultRow);
	
	var _StatusResultRow = __webpack_require__(644);
	
	var _StatusResultRow2 = _interopRequireDefault(_StatusResultRow);
	
	var _PartiesResultRow = __webpack_require__(642);
	
	var _PartiesResultRow2 = _interopRequireDefault(_PartiesResultRow);
	
	var _DocketsResultRow = __webpack_require__(640);
	
	var _DocketsResultRow2 = _interopRequireDefault(_DocketsResultRow);
	
	var _ClaimsResultRow = __webpack_require__(639);
	
	var _ClaimsResultRow2 = _interopRequireDefault(_ClaimsResultRow);
	
	var _EventsResultRow = __webpack_require__(641);
	
	var _EventsResultRow2 = _interopRequireDefault(_EventsResultRow);
	
	var _DocketPopup = __webpack_require__(259);
	
	var _DocketPopup2 = _interopRequireDefault(_DocketPopup);
	
	var _ResultsPaginator = __webpack_require__(108);
	
	var _ResultsPaginator2 = _interopRequireDefault(_ResultsPaginator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var entryTypes = {
	  dockets: {
	    label: 'Docket Entry',
	    title: 'case docket',
	    tab: 'docket',
	    component: _DocketsResultRow2.default
	  },
	  docket_headers: {
	    label: 'Docket Header',
	    title: 'case docket',
	    tab: 'docket',
	    component: _HTMLResultRow2.default
	  },
	  claims: {
	    label: 'Claim Entry',
	    title: 'case claims',
	    tab: 'claim',
	    component: _ClaimsResultRow2.default
	  },
	  claim_headers: {
	    label: 'Claim Header',
	    title: 'case claims',
	    tab: 'claim',
	    component: _HTMLResultRow2.default
	  },
	  creditors: {
	    label: 'Creditor Entry',
	    title: 'case creditors',
	    component: _CreditorsResultRow2.default
	  },
	  attorneys: {
	    label: 'Attorney',
	    title: 'case attorneys',
	    component: _AttorneysResultRow2.default
	  },
	  history: {
	    label: 'Events Entry',
	    title: 'case events',
	    component: _EventsResultRow2.default
	  },
	  alias: {
	    label: 'Party Alias',
	    title: 'party aliases',
	    component: _AliasesResultRow2.default
	  },
	  associated_cases: {
	    label: 'Associated Case',
	    title: 'associated case listing',
	    component: _AssociatedCasesResultRow2.default
	  },
	  case_summary: {
	    label: 'Case Summary',
	    title: 'case summary',
	    component: _HTMLResultRow2.default
	  },
	  creditor_mailing: {
	    label: 'Creditor Mailing Matrix',
	    title: 'creditor mailing matrix',
	    component: _HTMLResultRow2.default
	  },
	  schedule: {
	    label: 'Schedule Entry',
	    title: 'case schedule',
	    component: _ScheduleResultRow2.default
	  },
	  filers: {
	    label: 'Filer Entry',
	    title: 'case filers',
	    component: _FilersResultRow2.default
	  },
	  notice: {
	    label: 'Notice',
	    title: 'case notice',
	    component: _HTMLResultRow2.default
	  },
	  parties: {
	    label: 'Party Entry',
	    title: 'party entries',
	    component: _PartiesResultRow2.default
	  },
	  related_transactions: {
	    label: 'Related Transaction',
	    title: 'related transaction',
	    component: _TransactionsResultRow2.default
	  },
	  status_pending: {
	    label: 'Status',
	    title: 'case status',
	    component: _StatusResultRow2.default
	  },
	  written_opinions: {
	    label: 'Written Opinions',
	    title: 'case',
	    component: _EventsResultRow2.default
	  },
	  case_headers: {
	    label: 'Case Header',
	    title: 'case',
	    component: function component() {
	      return null;
	    }
	  }
	};
	
	var RowHeader = exports.RowHeader = function RowHeader(_ref) {
	  var row = _ref.row;
	
	  var type = row.query || row.document_type.replace('_part', ''); // row.query.replace('_part', '');
	  var case_url = '/rpc/legacy/case-menu-redirect/' + row.case_court + '/' + row.case_no;
	
	  return _react2.default.createElement(
	    'h3',
	    { className: 'result-item-header' },
	    row.case_title,
	    ' | ',
	    _react2.default.createElement(
	      'a',
	      { href: case_url, title: 'Go to Case Query Menu', target: '_blank' },
	      row.case_no
	    ),
	    ' | ',
	    row.case_court,
	    ' | ',
	    'Chp. ',
	    row.case_chapter,
	    ' | ',
	    row.case.date_filed || row.date_filed || row.case.date_closed || row.date_closed,
	    ' | ',
	    _react2.default.createElement(
	      'a',
	      {
	        href: case_url + '?open_tab=' + (entryTypes[type].tab || type),
	        title: 'Go to ' + entryTypes[type].title,
	        target: '_blank'
	      },
	      entryTypes[type].label
	    )
	  );
	};
	
	RowHeader.propTypes = {
	  row: _propTypes2.default.any.isRequired
	};
	
	var EntriesResults = function EntriesResults(_ref2) {
	  var data = _ref2.data,
	      filter = _ref2.filter,
	      onSearch = _ref2.onSearch;
	  return _react2.default.createElement(
	    'div',
	    { id: 'ir-search-search-premium-results' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Results \u2013 ',
	      data.num_found,
	      ' matches within ',
	      data.num_cases,
	      ' cases',
	      _react2.default.createElement(
	        'span',
	        { className: 'ir-search-premium-reset' },
	        _react2.default.createElement(
	          'a',
	          {
	            href: '',
	            className: 'active',
	            onClick: function onClick(e) {
	              e.preventDefault();
	              onSearch(_extends({}, filter, { grouped: true, page: 0 }));
	            }
	          },
	          'Display Matching Cases Only'
	        )
	      )
	    ),
	    data.results.map(function (row, idx) {
	      var type = row.query || row.document_type.replace('_part', ''); // row.query.replace('_part', '');
	      var RowComponent = entryTypes[type].component;
	
	      return _react2.default.createElement(
	        'div',
	        { key: idx, className: 'result-item result-item-' + type },
	        _react2.default.createElement(RowHeader, { row: row }),
	        _react2.default.createElement(
	          'div',
	          { className: 'result-item-body' },
	          _react2.default.createElement(RowComponent, { row: row, id: idx })
	        )
	      );
	    }),
	    _react2.default.createElement(_ResultsPaginator2.default, {
	      totalPages: data.page_count,
	      selectedPage: filter.page + 1 || 1,
	      onChangePage: function onChangePage(page) {
	        return onSearch(_extends({}, filter, { page: page }));
	      }
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'docket' },
	      _react2.default.createElement(_DocketPopup2.default, null)
	    )
	  );
	};
	
	EntriesResults.propTypes = {
	  data: _propTypes2.default.any.isRequired,
	  filter: _propTypes2.default.any.isRequired,
	  onSearch: _propTypes2.default.any.isRequired
	};
	
	exports.default = EntriesResults;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.AllPartsPrintPreview = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _Popup = __webpack_require__(69);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _docketActions = __webpack_require__(42);
	
	var docketActions = _interopRequireWildcard(_docketActions);
	
	var _clientCodeAction = __webpack_require__(64);
	
	var _ProgressBar = __webpack_require__(266);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	var _DocketDetailsPurchaseForm = __webpack_require__(109);
	
	var _DocketDetailsPurchaseForm2 = _interopRequireDefault(_DocketDetailsPurchaseForm);
	
	var _loadingBar = __webpack_require__(199);
	
	var _loadingBar2 = _interopRequireDefault(_loadingBar);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AllPartsPrintPreview = exports.AllPartsPrintPreview = function (_Component) {
	  _inherits(AllPartsPrintPreview, _Component);
	
	  function AllPartsPrintPreview() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AllPartsPrintPreview);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.buy = function () {
	      if (_this.props.dispatch((0, _clientCodeAction.hasValidClientCode)())) {
	        var _this$props$popup$dat = _this.props.popup.data,
	            documents = _this$props$popup$dat.documents,
	            pacer_client = _this$props$popup$dat.pacer_client;
	
	
	        var params = {
	          documents: documents,
	          pacer_client: pacer_client
	        };
	
	        _this.props.dispatch(docketActions.buyAllParts(params)).then(function () {
	          return _this.downloadPdfCombined();
	        });
	      } else {
	        _this.props.onClose();
	      }
	    }, _this.downloadPdfCombined = function () {
	      var _this$props$popup$dat2 = _this.props.popup.data,
	          documents = _this$props$popup$dat2.documents,
	          case_uuid = _this$props$popup$dat2.case_uuid,
	          court_code = _this$props$popup$dat2.court_code,
	          case_number = _this$props$popup$dat2.case_number;
	
	
	      var params = {
	        case_uuid: case_uuid,
	        court_code: court_code,
	        case_number: case_number,
	        documents: documents
	      };
	
	      _this.props.dispatch(docketActions.previewPdf(params)).then(_this.props.reloadDetails);
	    }, _this.renderProgress = function (percentage) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_ProgressBar2.default, { percentage: percentage || 5, show: true })
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  AllPartsPrintPreview.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (!prevProps.docketParts.alreadyPurchased && this.props.docketParts.alreadyPurchased) {
	      this.downloadPdfCombined();
	    }
	  };
	
	  // showing 10 instead of 0 as default, so it at least appears like it's loading something
	
	
	  AllPartsPrintPreview.prototype.render = function render() {
	    var purchaseFormOrLoading = this.props.docketParts.status === 'loading' ? _react2.default.createElement(
	      'div',
	      { className: 'loading-bar' },
	      _react2.default.createElement('img', { src: _loadingBar2.default })
	    ) : _react2.default.createElement(_DocketDetailsPurchaseForm2.default, { docketParts: this.props.docketParts, buy: this.buy });
	
	    return _react2.default.createElement(
	      _Popup2.default,
	      {
	        show: this.props.popup.show,
	        clsName: 'docket-pdf-zip-popup',
	        topBarTitle: 'Print Preview',
	        onClose: this.props.onClose
	      },
	      purchaseFormOrLoading
	    );
	  };
	
	  return AllPartsPrintPreview;
	}(_react.Component);
	
	AllPartsPrintPreview.propTypes = {
	  onClose: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  docketParts: _propTypes2.default.object.isRequired,
	  popup: _propTypes2.default.object.isRequired,
	  reloadDetails: _propTypes2.default.func.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$get$toJS = state.get('dockets').toJS(),
	      popup = _state$get$toJS.popup,
	      docketParts = _state$get$toJS.docketParts;
	
	  return {
	    popup: popup,
	    docketParts: docketParts
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AllPartsPrintPreview);

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.DownloadZipAllPdfsRangePopup = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _Popup = __webpack_require__(69);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _docketActions = __webpack_require__(42);
	
	var docketActions = _interopRequireWildcard(_docketActions);
	
	var _clientCodeAction = __webpack_require__(64);
	
	var _DocketDetailsPurchaseForm = __webpack_require__(109);
	
	var _DocketDetailsPurchaseForm2 = _interopRequireDefault(_DocketDetailsPurchaseForm);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DownloadZipAllPdfsRangePopup = exports.DownloadZipAllPdfsRangePopup = function (_Component) {
	  _inherits(DownloadZipAllPdfsRangePopup, _Component);
	
	  function DownloadZipAllPdfsRangePopup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DownloadZipAllPdfsRangePopup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.buy = function () {
	      if (_this.props.dispatch((0, _clientCodeAction.hasValidClientCode)())) {
	        _this.props.dispatch(docketActions.buyAllParts(_this.props.popup.data)).then(function () {
	          return _this.downloadPdfZip();
	        }).catch(function (e) {
	          return console.error(e);
	        });
	      } else {
	        _this.props.onClose();
	      }
	    }, _this.downloadPdfZip = function () {
	      _this.props.dispatch(docketActions.downloadPdfZip(_this.props.popup.data)).then(_this.props.reloadDetails);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  DownloadZipAllPdfsRangePopup.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (!prevProps.docketParts.alreadyPurchased && this.props.docketParts.alreadyPurchased) {
	      this.downloadPdfZip();
	    }
	  };
	
	  DownloadZipAllPdfsRangePopup.prototype.render = function render() {
	    var _props = this.props,
	        popup = _props.popup,
	        onClose = _props.onClose,
	        docketParts = _props.docketParts;
	
	
	    return _react2.default.createElement(
	      _Popup2.default,
	      {
	        show: popup.show,
	        clsName: 'docket-pdf-zip-popup',
	        topBarTitle: 'Download PDFs in a Zip File',
	        onClose: onClose
	      },
	      _react2.default.createElement(_DocketDetailsPurchaseForm2.default, { docketParts: docketParts, buy: this.buy })
	    );
	  };
	
	  return DownloadZipAllPdfsRangePopup;
	}(_react.Component);
	
	DownloadZipAllPdfsRangePopup.propTypes = {
	  onClose: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  docketParts: _propTypes2.default.object.isRequired,
	  popup: _propTypes2.default.object.isRequired,
	  reloadDetails: _propTypes2.default.func.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$get$toJS = state.get('dockets').toJS(),
	      popup = _state$get$toJS.popup,
	      docketParts = _state$get$toJS.docketParts,
	      favoriteEmail = _state$get$toJS.favoriteEmail;
	
	  return {
	    popup: popup,
	    docketParts: docketParts,
	    favoriteEmail: favoriteEmail
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DownloadZipAllPdfsRangePopup);

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.DownloadZipWithSubpartsPopup = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _Popup = __webpack_require__(69);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _DocketDetailsPurchaseForm = __webpack_require__(109);
	
	var _DocketDetailsPurchaseForm2 = _interopRequireDefault(_DocketDetailsPurchaseForm);
	
	var _docketActions = __webpack_require__(42);
	
	var _clientCodeAction = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DownloadZipWithSubpartsPopup = exports.DownloadZipWithSubpartsPopup = function (_Component) {
	  _inherits(DownloadZipWithSubpartsPopup, _Component);
	
	  function DownloadZipWithSubpartsPopup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DownloadZipWithSubpartsPopup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.buy = function () {
	      if (_this.props.dispatch((0, _clientCodeAction.hasValidClientCode)())) {
	        _this.props.dispatch((0, _docketActions.buyAllParts)(_this.props.popup.data)).then(function () {
	          return _this.downloadPdfCombinedZipped();
	        });
	      } else {
	        _this.props.onClose();
	      }
	    }, _this.downloadPdfCombinedZipped = function () {
	      _this.props.dispatch((0, _docketActions.downloadPdfCombinedZipped)(_this.props.popup.data));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  DownloadZipWithSubpartsPopup.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (!prevProps.docketParts.alreadyPurchased && this.props.docketParts.alreadyPurchased) {
	      this.downloadPdfCombinedZipped();
	    }
	  };
	
	  DownloadZipWithSubpartsPopup.prototype.render = function render() {
	    var _props = this.props,
	        popup = _props.popup,
	        onClose = _props.onClose,
	        docketParts = _props.docketParts;
	
	
	    return _react2.default.createElement(
	      _Popup2.default,
	      {
	        show: popup.show,
	        clsName: 'docket-pdf-zip-popup',
	        topBarTitle: 'Download Combined PDFs in a Zip File',
	        onClose: onClose
	      },
	      _react2.default.createElement(_DocketDetailsPurchaseForm2.default, { showXfaWarning: true, docketParts: docketParts, buy: this.buy })
	    );
	  };
	
	  return DownloadZipWithSubpartsPopup;
	}(_react.Component);
	
	DownloadZipWithSubpartsPopup.propTypes = {
	  onClose: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  docketParts: _propTypes2.default.object.isRequired,
	  popup: _propTypes2.default.object.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$get$toJS = state.get('dockets').toJS(),
	      popup = _state$get$toJS.popup,
	      docketParts = _state$get$toJS.docketParts,
	      favoriteEmail = _state$get$toJS.favoriteEmail;
	
	  return {
	    popup: popup,
	    docketParts: docketParts,
	    favoriteEmail: favoriteEmail
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DownloadZipWithSubpartsPopup);

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.EmailPartModal = EmailPartModal;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _EmailForm = __webpack_require__(261);
	
	var _EmailForm2 = _interopRequireDefault(_EmailForm);
	
	__webpack_require__(944);
	
	var _docketActions = __webpack_require__(42);
	
	var docketActions = _interopRequireWildcard(_docketActions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EmailPartModal(props) {
	  (0, _react.useEffect)(function () {
	    if (props.selectedDocket.binder && props.selectedDocket.binder.documents) {
	      var currentDocument = props.selectedDocket.binder.documents.find(function (document) {
	        return document.number === props.popup.data.part_number;
	      });
	      if (!currentDocument.download_url) {
	        props.orderPdf(currentDocument, props.selectedDocket.docket_seq);
	      }
	    }
	  }, []);
	
	  var onSubmit = function onSubmit(_ref) {
	    var emails = _ref.emails,
	        message = _ref.message;
	
	    var params = {
	      email_address: emails.join(','),
	      email_message: message
	    };
	    props.onSendEmail(params);
	  };
	
	  var renderDownloadLink = function renderDownloadLink() {
	    if (props.selectedDocket.binder && props.selectedDocket.binder.documents) {
	      var currentDocument = props.selectedDocket.binder.documents.find(function (document) {
	        return document.number === props.popup.data.part_number;
	      });
	      if (currentDocument.filename && currentDocument.download_url) {
	        return _react2.default.createElement(
	          'a',
	          { href: currentDocument.download_url },
	          currentDocument.filename
	        );
	      }
	    }
	  };
	
	  return _react2.default.createElement(
	    _reactBootstrap.Modal,
	    { show: true, onHide: props.onClose, backdrop: 'static', className: 'docket-popup' },
	    _react2.default.createElement(
	      _reactBootstrap.Modal.Header,
	      { closeButton: true },
	      _react2.default.createElement(
	        _reactBootstrap.Modal.Title,
	        null,
	        'Email Part PDF'
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Modal.Body,
	      null,
	      _react2.default.createElement(
	        _EmailForm2.default,
	        {
	          canSend: true,
	          onSendEmail: onSubmit,
	          onCancel: props.onClose,
	          sendButtonHint: 'Fill out destination address and any message and then click `Send`'
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'docket-info-section' },
	          props.popup.data.docket && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              props.popup.data.docket.date_filed + ' | ' + props.popup.data.docket.docket_no + ' | ' + props.popup.data.docket.docket_text
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'docket-number-link' },
	            _react2.default.createElement(
	              'a',
	              { href: '/filings/' + props.popup.data.case_uuid },
	              props.popup.data.case_number
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'label',
	          { style: { marginTop: '8px' } },
	          _react2.default.createElement('i', { className: 'fa fa-paperclip' }),
	          ' Attachment'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'bg-color-grey' },
	          renderDownloadLink(),
	          props.popup.isEmailSending && _react2.default.createElement(
	            'div',
	            { style: { paddingTop: '15px' } },
	            _react2.default.createElement(
	              'div',
	              null,
	              'Sending...'
	            ),
	            _react2.default.createElement(_reactBootstrap.ProgressBar, { now: 100, active: true })
	          )
	        )
	      )
	    )
	  );
	}
	
	EmailPartModal.propTypes = {
	  onClose: _propTypes2.default.func.isRequired,
	  onSendEmail: _propTypes2.default.func.isRequired,
	  popup: _propTypes2.default.object.isRequired,
	  selectedDocket: _propTypes2.default.object.isRequired,
	  orderPdf: _propTypes2.default.func.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$get$toJS = state.get('dockets').toJS(),
	      popup = _state$get$toJS.popup,
	      selectedDocket = _state$get$toJS.selectedDocket;
	
	  return {
	    popup: popup,
	    selectedDocket: selectedDocket
	  };
	};
	
	var mapDispatchToProps = {
	  onSendEmail: docketActions.sendEmail,
	  orderPdf: docketActions.orderPdf
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EmailPartModal);

/***/ },
/* 137 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = {
	    CASE_NUMBER: function CASE_NUMBER(str) {
	        return (
	            // Adapted from https://pcl.uscourts.gov/js/validate.js,
	            // ignoring leading and trailing spaces since our API gets rid of those
	            // keep in sync with CourtAPI::Util::Untaint::as_case_no
	            // this is the same regex as above, but with the \p{Pd} pattern replaced with the explicit character set
	            /^(?:\d:)?(?:\d{2}|\d{4})(?:[\u002D\u058A\u05BE\u1400\u1806\u2010\u2011\u2012\u2013\u2014\u2015\u2E17\u2E1A\u2E3A\u2E3B\u2E40\u301C\u3030\u30A0\uFE31\uFE32\uFE58\uFE63\uFF0D][A-Za-z]{2}[\u002D\u058A\u05BE\u1400\u1806\u2010\u2011\u2012\u2013\u2014\u2015\u2E17\u2E1A\u2E3A\u2E3B\u2E40\u301C\u3030\u30A0\uFE31\uFE32\uFE58\uFE63\uFF0D]|\s[A-Za-z]{2}\s|[A-Za-z]{2}|[\u002D\u058A\u05BE\u1400\u1806\u2010\u2011\u2012\u2013\u2014\u2015\u2E17\u2E1A\u2E3A\u2E3B\u2E40\u301C\u3030\u30A0\uFE31\uFE32\uFE58\uFE63\uFF0D])\d{1,5}$/.test(str)
	        );
	    },
	
	    CASE_NUMBER_WILDCARD: function CASE_NUMBER_WILDCARD(str) {
	        return (
	            // Case lookup form: validation: wildcard.
	            /^\s*((\d{1,4})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D ]+\*|(\d{1,4})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D ]+(\d{1,5})|(\d{1})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D \:]+(\d{1,4})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D ]+(\d{1,5})|(\d{1,4})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D ]*([\w\s]{1,2})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D ]*(\d{1,5})|(\d{1})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D \:](\d{1,4})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D ]*([\w\s]{1,2})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D ]*(\d{1,5}))(-[a-zA-Z]+)?\s*$/.test(str)
	        );
	    },
	
	    SSN_OR_TIN: function SSN_OR_TIN(str) {
	        return (
	            // keep in sync with CGI::Untaint::ssntin
	            /^\s*(\d{3}-\d{2}-\d{4}|\d{2}-\d{7}|\d{9})\s*$/.test(str)
	        );
	    },
	
	    SSN4: function SSN4(str) {
	        return (
	            // keep in sync with CGI::Untaint::ssn4
	            /^\s*(\d{4})\s*$/.test(str)
	        );
	    },
	
	    PARTY_NAME_CASE_TITLE: function PARTY_NAME_CASE_TITLE(str) {
	        return (
	            // keep in sync with CGI::Untaint::text
	            /^\s*([a-z0-9\s\.&\*,'-]+?)\s*$/i.test(str)
	        );
	    }
	
	};

/***/ },
/* 138 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var REQUEST_DOCKET_PARTS = exports.REQUEST_DOCKET_PARTS = 'REQUEST_DOCKET_PARTS';
	var RECEIVE_DOCKET_PARTS = exports.RECEIVE_DOCKET_PARTS = 'RECEIVE_DOCKET_PARTS';
	var REQUEST_CASE_DATA = exports.REQUEST_CASE_DATA = 'REQUEST_CASE_DATA';
	var RECEIVE_CASE_DATA = exports.RECEIVE_CASE_DATA = 'RECEIVE_CASE_DATA';
	var SERVICE_ERROR = exports.SERVICE_ERROR = 'SERVICE_ERROR';
	var RESET_SERVICE_ERROR = exports.RESET_SERVICE_ERROR = 'RESET_SERVICE_ERROR';

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = usePostApi;
	
	var _react = __webpack_require__(1);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // POST API allows for triggering of POST requests
	
	
	// Post API allows for triggering post on demand
	function usePostApi(url) {
	  var _this = this;
	
	  var _useState = (0, _react.useState)(),
	      data = _useState[0],
	      setData = _useState[1];
	
	  var _useState2 = (0, _react.useState)(false),
	      isLoading = _useState2[0],
	      setIsLoading = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      isError = _useState3[0],
	      setIsError = _useState3[1];
	
	  var _useState4 = (0, _react.useState)(null),
	      postData = _useState4[0],
	      setPostData = _useState4[1];
	
	  (0, _react.useEffect)(function () {
	    var fetchData = function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        var result;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                setIsError(false);
	                setIsLoading(true);
	                _context.prev = 2;
	                _context.next = 5;
	                return _superagent2.default.post(url).send(postData);
	
	              case 5:
	                result = _context.sent;
	
	                setData(result.body);
	                _context.next = 12;
	                break;
	
	              case 9:
	                _context.prev = 9;
	                _context.t0 = _context['catch'](2);
	
	                setIsError(_context.t0);
	
	              case 12:
	                setPostData(null);
	                setIsLoading(false);
	
	              case 14:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this, [[2, 9]]);
	      }));
	
	      return function fetchData() {
	        return _ref.apply(this, arguments);
	      };
	    }();
	    // first time, we don't do no fetching
	    if (postData) fetchData();
	  }, [postData]);
	  return [{ data: data, isLoading: isLoading, isError: isError }, setPostData];
	}

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(426);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _replaceResultTransformer = __webpack_require__(1301);
	
	var _replaceResultTransformer2 = _interopRequireDefault(_replaceResultTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _replaceResultTransformer2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZXBsYWNlUmVzdWx0VHJhbnNmb3JtZXIvaW5kZXguanMiXSwibmFtZXMiOlsiZGVmYXVsdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztRQUFPQSxPIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnJvbSAnLi9yZXBsYWNlUmVzdWx0VHJhbnNmb3JtZXInO1xuIl19

/***/ },
/* 142 */
[2305, 281],
/* 143 */
/***/ function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ },
/* 144 */
[2264, 86, 787, 462, 22, 37, 478],
/* 145 */
[2279, 22, 793, 458, 471, 457, 460],
/* 146 */
[2284, 795, 458],
/* 147 */
[2287, 795, 458],
/* 148 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(66);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(25);
	var dP = __webpack_require__(41);
	var DESCRIPTORS = __webpack_require__(38);
	var SPECIES = __webpack_require__(36)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },
/* 151 */
[2302, 88],
/* 152 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 153 */
[2308, 29],
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(1));
	var glamor = __webpack_require__(1770);
	
	var htmlTagNames = [
	  "a",
	  "abbr",
	  "acronym",
	  "address",
	  "applet",
	  "area",
	  "article",
	  "aside",
	  "audio",
	  "b",
	  "base",
	  "basefont",
	  "bdi",
	  "bdo",
	  "bgsound",
	  "big",
	  "blink",
	  "blockquote",
	  "body",
	  "br",
	  "button",
	  "canvas",
	  "caption",
	  "center",
	  "cite",
	  "code",
	  "col",
	  "colgroup",
	  "command",
	  "content",
	  "data",
	  "datalist",
	  "dd",
	  "del",
	  "details",
	  "dfn",
	  "dialog",
	  "dir",
	  "div",
	  "dl",
	  "dt",
	  "element",
	  "em",
	  "embed",
	  "fieldset",
	  "figcaption",
	  "figure",
	  "font",
	  "footer",
	  "form",
	  "frame",
	  "frameset",
	  "h1",
	  "h2",
	  "h3",
	  "h4",
	  "h5",
	  "h6",
	  "head",
	  "header",
	  "hgroup",
	  "hr",
	  "html",
	  "i",
	  "iframe",
	  "image",
	  "img",
	  "input",
	  "ins",
	  "isindex",
	  "kbd",
	  "keygen",
	  "label",
	  "legend",
	  "li",
	  "link",
	  "listing",
	  "main",
	  "map",
	  "mark",
	  "marquee",
	  "math",
	  "menu",
	  "menuitem",
	  "meta",
	  "meter",
	  "multicol",
	  "nav",
	  "nextid",
	  "nobr",
	  "noembed",
	  "noframes",
	  "noscript",
	  "object",
	  "ol",
	  "optgroup",
	  "option",
	  "output",
	  "p",
	  "param",
	  "picture",
	  "plaintext",
	  "pre",
	  "progress",
	  "q",
	  "rb",
	  "rbc",
	  "rp",
	  "rt",
	  "rtc",
	  "ruby",
	  "s",
	  "samp",
	  "script",
	  "section",
	  "select",
	  "shadow",
	  "slot",
	  "small",
	  "source",
	  "spacer",
	  "span",
	  "strike",
	  "strong",
	  "style",
	  "sub",
	  "summary",
	  "sup",
	  "svg",
	  "table",
	  "tbody",
	  "td",
	  "template",
	  "textarea",
	  "tfoot",
	  "th",
	  "thead",
	  "time",
	  "title",
	  "tr",
	  "track",
	  "tt",
	  "u",
	  "ul",
	  "var",
	  "video",
	  "wbr",
	  "xmp"
	]
	;
	
	var svgTagNames = [
	  "a",
	  "altGlyph",
	  "altGlyphDef",
	  "altGlyphItem",
	  "animate",
	  "animateColor",
	  "animateMotion",
	  "animateTransform",
	  "animation",
	  "audio",
	  "canvas",
	  "circle",
	  "clipPath",
	  "color-profile",
	  "cursor",
	  "defs",
	  "desc",
	  "discard",
	  "ellipse",
	  "feBlend",
	  "feColorMatrix",
	  "feComponentTransfer",
	  "feComposite",
	  "feConvolveMatrix",
	  "feDiffuseLighting",
	  "feDisplacementMap",
	  "feDistantLight",
	  "feDropShadow",
	  "feFlood",
	  "feFuncA",
	  "feFuncB",
	  "feFuncG",
	  "feFuncR",
	  "feGaussianBlur",
	  "feImage",
	  "feMerge",
	  "feMergeNode",
	  "feMorphology",
	  "feOffset",
	  "fePointLight",
	  "feSpecularLighting",
	  "feSpotLight",
	  "feTile",
	  "feTurbulence",
	  "filter",
	  "font",
	  "font-face",
	  "font-face-format",
	  "font-face-name",
	  "font-face-src",
	  "font-face-uri",
	  "foreignObject",
	  "g",
	  "glyph",
	  "glyphRef",
	  "handler",
	  "hatch",
	  "hatchpath",
	  "hkern",
	  "iframe",
	  "image",
	  "line",
	  "linearGradient",
	  "listener",
	  "marker",
	  "mask",
	  "mesh",
	  "meshgradient",
	  "meshpatch",
	  "meshrow",
	  "metadata",
	  "missing-glyph",
	  "mpath",
	  "path",
	  "pattern",
	  "polygon",
	  "polyline",
	  "prefetch",
	  "radialGradient",
	  "rect",
	  "script",
	  "set",
	  "solidColor",
	  "solidcolor",
	  "stop",
	  "style",
	  "svg",
	  "switch",
	  "symbol",
	  "tbreak",
	  "text",
	  "textArea",
	  "textPath",
	  "title",
	  "tref",
	  "tspan",
	  "unknown",
	  "use",
	  "video",
	  "view",
	  "vkern"
	]
	;
	
	var domElements = htmlTagNames.concat(svgTagNames).filter(function (tag, index, array) {
	  return array.indexOf(tag) === index;
	});
	
	var CHANNEL = '__glamorous__'; /* istanbul ignore next */
	
	var isPreact = false;
	
	var _PropTypes = void 0;
	
	/* istanbul ignore next */
	if (isPreact) {
	  if (!React.PropTypes) {
	    _PropTypes = function PropTypes() {
	      return _PropTypes;
	    };
	
	    ['array', 'bool', 'func', 'number', 'object', 'string', 'symbol', 'any', 'arrayOf', 'element', 'instanceOf', 'node', 'objectOf', 'oneOf', 'oneOfType', 'shape', 'exact'].forEach(function (type) {
	      _PropTypes[type] = _PropTypes;
	    });
	  }
	  // copied from preact-compat
	  /* eslint-disable no-eq-null, eqeqeq, consistent-return */
	  if (!React.Children) {
	    var Children = {
	      map: function map(children, fn, ctx) {
	        if (children == null) {
	          return null;
	        }
	        children = Children.toArray(children);
	        if (ctx && ctx !== children) {
	          fn = fn.bind(ctx);
	        }
	        return children.map(fn);
	      },
	      forEach: function forEach(children, fn, ctx) {
	        if (children == null) {
	          return null;
	        }
	        children = Children.toArray(children);
	        if (ctx && ctx !== children) {
	          fn = fn.bind(ctx);
	        }
	        children.forEach(fn);
	      },
	      count: function count(children) {
	        return children && children.length || 0;
	      },
	      only: function only(children) {
	        children = Children.toArray(children);
	        if (children.length !== 1) {
	          throw new Error('Children.only() expects only one child.');
	        }
	        return children[0];
	      },
	      toArray: function toArray(children) {
	        if (children == null) {
	          return [];
	        }
	        return [].concat(children);
	      }
	    };
	    React.Children = Children;
	  }
	  /* eslint-enable no-eq-null, eqeqeq, consistent-return */
	} else if (parseFloat(React.version.slice(0, 4)) >= 15.5) {
	  /* istanbul ignore next */
	  try {
	    _PropTypes = __webpack_require__(2);
	    /* istanbul ignore next */
	  } catch (error) {
	    // ignore
	  }
	}
	/* istanbul ignore next */
	_PropTypes = _PropTypes || React.PropTypes;
	
	/*
	eslint
	  import/no-mutable-exports:0,
	  import/prefer-default-export:0,
	  react/no-deprecated:0
	 */
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	function generateWarningMessage(Comp) {
	  var componentName = Comp.displayName || Comp.name || 'FunctionComponent';
	  // eslint-disable-next-line max-len
	  return 'glamorous warning: Expected component called "' + componentName + '" which uses withTheme to be within a ThemeProvider but none was found.';
	}
	
	function withTheme(ComponentToTheme) {
	  var _defaultContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$noWarn = _ref.noWarn,
	      noWarn = _ref$noWarn === undefined ? false : _ref$noWarn,
	      _ref$createElement = _ref.createElement,
	      createElement = _ref$createElement === undefined ? true : _ref$createElement;
	
	  var ThemedComponent = function (_React$Component) {
	    inherits(ThemedComponent, _React$Component);
	
	    function ThemedComponent() {
	      var _temp, _this, _ret;
	
	      classCallCheck(this, ThemedComponent);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.warned = noWarn, _this.state = { theme: {} }, _this.setTheme = function (theme) {
	        return _this.setState({ theme: theme });
	      }, _temp), possibleConstructorReturn(_this, _ret);
	    }
	
	    // eslint-disable-next-line complexity
	    ThemedComponent.prototype.componentWillMount = function componentWillMount() {
	      if (!this.context[CHANNEL]) {
	        if (false) {
	          this.warned = true;
	          // eslint-disable-next-line no-console
	          console.warn(generateWarningMessage(ComponentToTheme));
	        }
	      }
	      var theme = this.props.theme;
	
	      if (this.context[CHANNEL]) {
	        // if a theme is provided via props,
	        // it takes precedence over context
	        this.setTheme(theme ? theme : this.context[CHANNEL].getState());
	      } else {
	        this.setTheme(theme || {});
	      }
	    };
	
	    ThemedComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.theme !== nextProps.theme) {
	        this.setTheme(nextProps.theme);
	      }
	    };
	
	    ThemedComponent.prototype.componentDidMount = function componentDidMount() {
	      if (this.context[CHANNEL] && !this.props.theme) {
	        // subscribe to future theme changes
	        this.subscriptionId = this.context[CHANNEL].subscribe(this.setTheme);
	      }
	    };
	
	    ThemedComponent.prototype.componentWillUnmount = function componentWillUnmount() {
	      // cleanup subscription
	      this.subscriptionId && this.context[CHANNEL].unsubscribe(this.subscriptionId);
	    };
	
	    ThemedComponent.prototype.render = function render() {
	      if (createElement) {
	        return React.createElement(ComponentToTheme, _extends({}, this.props, this.state));
	      } else {
	        // this allows us to effectively use the GlamorousComponent
	        // as our `render` method without going through lifecycle hooks.
	        // Also allows us to forward the context in the scenario where
	        // a user wants to add more context.
	        // eslint-disable-next-line babel/new-cap
	        return ComponentToTheme.call(this, _extends({}, this.props, this.state), this.context);
	      }
	    };
	
	    return ThemedComponent;
	  }(React.Component);
	
	   false ? ThemedComponent.propTypes = {
	    theme: _PropTypes.object
	  } : void 0;
	
	
	  var defaultContextTypes = (_defaultContextTypes = {}, _defaultContextTypes[CHANNEL] = _PropTypes.object, _defaultContextTypes);
	
	  var userDefinedContextTypes = null;
	
	  // configure the contextTypes to be settable by the user,
	  // however also retaining the glamorous channel.
	  Object.defineProperty(ThemedComponent, 'contextTypes', {
	    enumerable: true,
	    configurable: true,
	    set: function set$$1(value) {
	      userDefinedContextTypes = value;
	    },
	    get: function get$$1() {
	      // if the user has provided a contextTypes definition,
	      // merge the default context types with the provided ones.
	      if (userDefinedContextTypes) {
	        return _extends({}, defaultContextTypes, userDefinedContextTypes);
	      }
	      return defaultContextTypes;
	    }
	  });
	
	  return ThemedComponent;
	}
	
	var isFunction_1 = isFunction;
	
	var toString = Object.prototype.toString;
	
	function isFunction (fn) {
	  var string = toString.call(fn);
	  return string === '[object Function]' ||
	    (typeof fn === 'function' && string !== '[object RegExp]') ||
	    (typeof window !== 'undefined' &&
	     // IE8 and below
	     (fn === window.setTimeout ||
	      fn === window.alert ||
	      fn === window.confirm ||
	      fn === window.prompt))
	}
	
	/*!
	 * isobject <https://github.com/jonschlinkert/isobject>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	var isobject = function isObject(val) {
	  return val != null && typeof val === 'object' && Array.isArray(val) === false;
	};
	
	function isObjectObject(o) {
	  return isobject(o) === true
	    && Object.prototype.toString.call(o) === '[object Object]';
	}
	
	var isPlainObject = function isPlainObject(o) {
	  var ctor,prot;
	
	  if (isObjectObject(o) === false) return false;
	
	  // If has modified constructor
	  ctor = o.constructor;
	  if (typeof ctor !== 'function') return false;
	
	  // If has modified prototype
	  prot = ctor.prototype;
	  if (isObjectObject(prot) === false) return false;
	
	  // If constructor does not have an Object-specific method
	  if (prot.hasOwnProperty('isPrototypeOf') === false) {
	    return false;
	  }
	
	  // Most likely a plain Object
	  return true;
	};
	
	function createBroadcast (initialState) {
	  var listeners = {};
	  var id = 1;
	  var _state = initialState;
	
	  function getState () {
	    return _state
	  }
	
	  function setState (state) {
	    _state = state;
	    var keys = Object.keys(listeners);
	    var i = 0;
	    var len = keys.length;
	    for (; i < len; i++) {
	      // if a listener gets unsubscribed during setState we just skip it
	      if (listeners[keys[i]]) { listeners[keys[i]](state); }
	    }
	  }
	
	  // subscribe to changes and return the subscriptionId
	  function subscribe (listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('listener must be a function.')
	    }
	    var currentId = id;
	    listeners[currentId] = listener;
	    id += 1;
	    return currentId
	  }
	
	  // remove subscription by removing the listener function
	  function unsubscribe (id) {
	    listeners[id] = undefined;
	  }
	
	  return { getState: getState, setState: setState, subscribe: subscribe, unsubscribe: unsubscribe }
	}
	
	var _ThemeProvider$childC, _ThemeProvider$contex;
	
	/**
	 * This is a component which will provide a theme to the entire tree
	 * via context and event listener
	 * (because pure components block context updates)
	 * inspired by the styled-components implementation
	 * https://github.com/styled-components/styled-components
	 * @param {Object} theme the theme object..
	 */
	
	var ThemeProvider = function (_React$Component) {
	  inherits(ThemeProvider, _React$Component);
	
	  function ThemeProvider() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, ThemeProvider);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setOuterTheme = function (theme) {
	      _this.outerTheme = theme;
	      if (_this.broadcast !== undefined) {
	        _this.publishTheme();
	      }
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  // create theme, by merging with outer theme, if present
	  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
	    var theme = passedTheme || this.props.theme;
	    if (isFunction_1(theme)) {
	      var mergedTheme = theme(this.outerTheme);
	      if (!isPlainObject(mergedTheme)) {
	        throw new Error('[ThemeProvider] Please return an object from your theme function, ' + 'i.e. theme={() => ({})}!');
	      }
	      return mergedTheme;
	    }
	    return _extends({}, this.outerTheme, theme);
	  };
	
	  ThemeProvider.prototype.getChildContext = function getChildContext() {
	    var _ref;
	
	    return _ref = {}, _ref[CHANNEL] = this.broadcast, _ref;
	  };
	
	  ThemeProvider.prototype.publishTheme = function publishTheme(theme) {
	    this.broadcast.setState(this.getTheme(theme));
	  };
	
	  ThemeProvider.prototype.componentDidMount = function componentDidMount() {
	    // create a new subscription for keeping track of outer theme, if present
	    if (this.context[CHANNEL]) {
	      this.subscriptionId = this.context[CHANNEL].subscribe(this.setOuterTheme);
	    }
	  };
	
	  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
	    // set broadcast state by merging outer theme with own
	    if (this.context[CHANNEL]) {
	      this.setOuterTheme(this.context[CHANNEL].getState());
	    }
	    this.broadcast = createBroadcast(this.getTheme(this.props.theme));
	  };
	
	  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.theme !== nextProps.theme) {
	      this.publishTheme(nextProps.theme);
	    }
	  };
	
	  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.subscriptionId && this.context[CHANNEL].unsubscribe(this.subscriptionId);
	  };
	
	  ThemeProvider.prototype.render = function render() {
	    return this.props.children ? React.Children.only(this.props.children) : null;
	  };
	
	  return ThemeProvider;
	}(React.Component);
	
	ThemeProvider.childContextTypes = (_ThemeProvider$childC = {}, _ThemeProvider$childC[CHANNEL] = _PropTypes.object.isRequired, _ThemeProvider$childC);
	
	ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL] = _PropTypes.object, _ThemeProvider$contex);
	
	 false ? ThemeProvider.propTypes = {
	  theme: _PropTypes.oneOfType([_PropTypes.object, _PropTypes.func]).isRequired,
	  children: _PropTypes.node
	} : void 0;
	
	/**
	 * This function takes a className string and gets all the
	 * associated glamor styles. It's used to merge glamor styles
	 * from a className to make sure that specificity is not
	 * a problem when passing a className to a component.
	 * @param {String} [className=''] the className string
	 * @return {Object} { glamorStyles, glamorlessClassName }
	 *   - glamorStyles is an array of all the glamor styles objects
	 *   - glamorlessClassName is the rest of the className string
	 *     without the glamor classNames
	 */
	function extractGlamorStyles(className) {
	  var glamorlessClassName = [];
	  var glamorStyles = [];
	  className.toString().split(' ').forEach(function (name) {
	    if (glamor.styleSheet.registered[name.substring(4)] === undefined) {
	      glamorlessClassName.push(name);
	    } else {
	      var style = buildGlamorSrcFromClassName(name);
	      glamorStyles.push(style);
	    }
	  });
	
	  return { glamorlessClassName: glamorlessClassName, glamorStyles: glamorStyles };
	}
	
	/** Glamor's css function returns an object with the shape
	 *
	 * {
	 *   [`data-css-${hash}`]: '',
	 *   toString() { return `css-${hash}` }
	 * }
	 *
	 * Whenever glamor's build function encounters an object with
	 * this shape it just pulls the resulting styles from the cache.
	 *
	 * note: the toString method is not needed to qualify the shape
	 **/
	function buildGlamorSrcFromClassName(className) {
	  var _ref;
	
	  return _ref = {}, _ref['data-' + className] = '', _ref;
	}
	
	function getGlamorClassName(_ref2) {
	  var styles = _ref2.styles,
	      props = _ref2.props,
	      cssOverrides = _ref2.cssOverrides,
	      cssProp = _ref2.cssProp,
	      context = _ref2.context,
	      displayName = _ref2.displayName;
	
	  var _handleStyles = handleStyles([].concat(styles, [props.className, cssOverrides, cssProp]), props, context),
	      mappedArgs = _handleStyles.mappedArgs,
	      nonGlamorClassNames = _handleStyles.nonGlamorClassNames;
	  // eslint-disable-next-line max-len
	
	
	  var isDev = ("production") === 'development' || !("production");
	  var devRules = isDev ? { label: displayName } : null;
	  var glamorClassName = glamor.css.apply(undefined, [devRules].concat(mappedArgs)).toString();
	  var extras = nonGlamorClassNames.join(' ').trim();
	  return (glamorClassName + ' ' + extras).trim();
	}
	
	// this next function is on a "hot" code-path
	// so it's pretty complex to make sure it's fast.
	// eslint-disable-next-line complexity
	function handleStyles(styles, props, context) {
	  var current = void 0;
	  var mappedArgs = [];
	  var nonGlamorClassNames = [];
	  for (var i = 0; i < styles.length; i++) {
	    current = styles[i];
	    while (typeof current === 'function') {
	      current = current(props, context);
	    }
	    if (typeof current === 'string') {
	      var _extractGlamorStyles = extractGlamorStyles(current),
	          glamorStyles = _extractGlamorStyles.glamorStyles,
	          glamorlessClassName = _extractGlamorStyles.glamorlessClassName;
	
	      mappedArgs.push.apply(mappedArgs, glamorStyles);
	      nonGlamorClassNames.push.apply(nonGlamorClassNames, glamorlessClassName);
	    } else if (Array.isArray(current)) {
	      var recursed = handleStyles(current, props, context);
	      mappedArgs.push.apply(mappedArgs, recursed.mappedArgs);
	      nonGlamorClassNames.push.apply(nonGlamorClassNames, recursed.nonGlamorClassNames);
	    } else {
	      mappedArgs.push(current);
	    }
	  }
	  return { mappedArgs: mappedArgs, nonGlamorClassNames: nonGlamorClassNames };
	}
	
	/*
	 * This is a relatively small abstraction that's ripe for open sourcing.
	 * Documentation is in the README.md
	 */
	
	function createGlamorous(splitProps) {
	  return glamorous;
	
	  /**
	   * This is the main export and the function that people
	   * interact with most directly.
	   *
	   * It accepts a component which can be a string or
	   * a React Component and returns
	   * a "glamorousComponentFactory"
	   * @param {String|ReactComponent} comp the component to render
	   * @param {Object} options helpful info for the GlamorousComponents
	   * @return {Function} the glamorousComponentFactory
	   */
	  function glamorous(comp) {
	    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var rootEl = config.rootEl,
	        displayName = config.displayName,
	        shouldClassNameUpdate = config.shouldClassNameUpdate,
	        _config$filterProps = config.filterProps,
	        filterProps = _config$filterProps === undefined ? [] : _config$filterProps,
	        _config$forwardProps = config.forwardProps,
	        forwardProps = _config$forwardProps === undefined ? [] : _config$forwardProps,
	        _config$propsAreCssOv = config.propsAreCssOverrides,
	        propsAreCssOverrides = _config$propsAreCssOv === undefined ? comp.propsAreCssOverrides : _config$propsAreCssOv,
	        basePropsToApply = config.withProps;
	
	    Object.assign(glamorousComponentFactory, { withConfig: withConfig });
	    return glamorousComponentFactory;
	
	    function withConfig(newConfig) {
	      return glamorous(comp, _extends({}, config, newConfig));
	    }
	
	    /**
	     * This returns a React Component that renders the comp (closure)
	     * with a className based on the given glamor styles object(s)
	     * @param {...Object|Function} styles the styles to create with glamor.
	     *   If any of these are functions, they are invoked with the component
	     *   props and the return value is used.
	     * @return {ReactComponent} the ReactComponent function
	     */
	    function glamorousComponentFactory() {
	      for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
	        styles[_key] = arguments[_key];
	      }
	
	      /**
	       * This is a component which will render the comp (closure)
	       * with the glamorous styles (closure). Forwards any valid
	       * props to the underlying component.
	       */
	      var GlamorousComponent = withTheme(function (props, context) {
	        props = getPropsToApply(GlamorousComponent.propsToApply, {}, props, context);
	        var updateClassName = shouldUpdate(props, context, this.previous);
	
	        if (shouldClassNameUpdate) {
	          this.previous = { props: props, context: context };
	        }
	
	        var _splitProps = splitProps(props, GlamorousComponent),
	            toForward = _splitProps.toForward,
	            cssOverrides = _splitProps.cssOverrides,
	            cssProp = _splitProps.cssProp;
	
	        // create className to apply
	
	
	        this.className = updateClassName ? getGlamorClassName({
	          styles: GlamorousComponent.styles,
	          props: props,
	          cssOverrides: cssOverrides,
	          cssProp: cssProp,
	          context: context,
	          displayName: GlamorousComponent.displayName
	        }) : this.className;
	
	        return React.createElement(GlamorousComponent.comp, _extends({
	          // if innerRef is forwarded we don't want to apply it here
	          ref: 'innerRef' in toForward ? undefined : props.innerRef
	        }, toForward, {
	          className: this.className
	        }));
	      }, { noWarn: true, createElement: false });
	
	       false ? GlamorousComponent.propTypes = {
	        // className accepts an object due to glamor's css function
	        // returning an object with a toString method that gives the className
	        className: _PropTypes.oneOfType([_PropTypes.string, _PropTypes.object]),
	        cssOverrides: _PropTypes.object,
	        innerRef: _PropTypes.oneOfType([_PropTypes.func, _PropTypes.object]),
	        glam: _PropTypes.object
	      } : void 0;
	
	      function shouldUpdate(props, context, previous) {
	        // exiting early so components which do not use this
	        // optimization are not penalized by hanging onto
	        // references to previous props and context
	        if (!shouldClassNameUpdate) {
	          return true;
	        }
	        var update = true;
	        if (previous) {
	          if (!shouldClassNameUpdate(previous.props, props, previous.context, context)) {
	            update = false;
	          }
	        }
	
	        return update;
	      }
	
	      Object.assign(GlamorousComponent, getGlamorousComponentMetadata({
	        comp: comp,
	        styles: styles,
	        rootEl: rootEl,
	        filterProps: filterProps,
	        forwardProps: forwardProps,
	        displayName: displayName,
	        propsToApply: basePropsToApply
	      }), {
	        isGlamorousComponent: true,
	        propsAreCssOverrides: propsAreCssOverrides,
	        withComponent: function (newComp) {
	          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	          var fwp = GlamorousComponent.forwardProps,
	              flp = GlamorousComponent.filterProps,
	              componentProperties = objectWithoutProperties(GlamorousComponent, ['forwardProps', 'filterProps']);
	
	          return glamorous(_extends({}, componentProperties, {
	            comp: newComp,
	            rootEl: getRootEl(newComp)
	          }), _extends({
	            // allows the forwardProps and filterProps to be overridden
	            forwardProps: fwp,
	            filterProps: flp
	          }, options))();
	        },
	        withProps: function () {
	          for (var _len2 = arguments.length, propsToApply = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            propsToApply[_key2] = arguments[_key2];
	          }
	
	          return glamorous(GlamorousComponent, { withProps: propsToApply })();
	        },
	        withConfig: withConfig
	      });
	      return GlamorousComponent;
	    }
	  }
	
	  function getGlamorousComponentMetadata(_ref) {
	    var comp = _ref.comp,
	        styles = _ref.styles,
	        rootEl = _ref.rootEl,
	        filterProps = _ref.filterProps,
	        forwardProps = _ref.forwardProps,
	        displayName = _ref.displayName,
	        basePropsToApply = _ref.propsToApply;
	
	    var componentsComp = comp.comp ? comp.comp : comp;
	    var propsToApply = comp.propsToApply ? [].concat(comp.propsToApply, arrayify(basePropsToApply)) : arrayify(basePropsToApply);
	    return {
	      // join styles together (for anyone doing: glamorous(glamorous.a({}), {}))
	      styles: when(comp.styles, styles),
	      // keep track of the ultimate rootEl to render (we never
	      // actually render anything but
	      // the base component, even when people wrap a glamorous
	      // component in glamorous
	      comp: componentsComp,
	      rootEl: rootEl || getRootEl(comp),
	      // join forwardProps and filterProps
	      // (for anyone doing: glamorous(glamorous.a({}), {}))
	      forwardProps: when(comp.forwardProps, forwardProps),
	      filterProps: when(comp.filterProps, filterProps),
	      // set the displayName to something that's slightly more
	      // helpful than `GlamorousComponent` :)
	      displayName: displayName || 'glamorous(' + getDisplayName(comp) + ')',
	      // these are props that should be applied to the component at render time
	      propsToApply: propsToApply
	    };
	  }
	}
	
	/**
	 * reduces the propsToApply given to a single props object
	 * @param {Array} propsToApply an array of propsToApply objects:
	 *   - object
	 *   - array of propsToApply items
	 *   - function that accepts the accumulated props and the context
	 * @param {Object} accumulator an object to apply props onto
	 * @param {Object} props the props that should ultimately take precedence
	 * @param {*} context the context object
	 * @return {Object} the reduced props
	 */
	function getPropsToApply(propsToApply, accumulator, props, context) {
	  // using forEach rather than reduce here because the reduce solution
	  // effectively did the same thing because we manipulate the `accumulator`
	  propsToApply.forEach(function (propsToApplyItem) {
	    if (typeof propsToApplyItem === 'function') {
	      return Object.assign(accumulator, propsToApplyItem(Object.assign({}, accumulator, props), context));
	    } else if (Array.isArray(propsToApplyItem)) {
	      return Object.assign(accumulator, getPropsToApply(propsToApplyItem, accumulator, props, context));
	    }
	    return Object.assign(accumulator, propsToApplyItem);
	  });
	  // props wins
	  return Object.assign(accumulator, props);
	}
	
	function arrayify() {
	  var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  return Array.isArray(x) ? x : [x];
	}
	
	function when(comp, prop) {
	  return comp ? comp.concat(prop) : prop;
	}
	
	function getRootEl(comp) {
	  return comp.rootEl ? comp.rootEl : comp.comp || comp;
	}
	
	function getDisplayName(comp) {
	  return typeof comp === 'string' ? comp : comp.displayName || comp.name || 'unknown';
	}
	
	//
	// Main
	//
	
	function memoize (fn, options) {
	  var cache = options && options.cache
	    ? options.cache
	    : cacheDefault;
	
	  var serializer = options && options.serializer
	    ? options.serializer
	    : serializerDefault;
	
	  var strategy = options && options.strategy
	    ? options.strategy
	    : strategyDefault;
	
	  return strategy(fn, {
	    cache: cache,
	    serializer: serializer
	  })
	}
	
	//
	// Strategy
	//
	
	function isPrimitive (value) {
	  return value == null || typeof value === 'number' || typeof value === 'boolean' // || typeof value === "string" 'unsafe' primitive for our needs
	}
	
	function monadic (fn, cache, serializer, arg) {
	  var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
	
	  var computedValue = cache.get(cacheKey);
	  if (typeof computedValue === 'undefined') {
	    computedValue = fn.call(this, arg);
	    cache.set(cacheKey, computedValue);
	  }
	
	  return computedValue
	}
	
	function variadic (fn, cache, serializer) {
	  var args = Array.prototype.slice.call(arguments, 3);
	  var cacheKey = serializer(args);
	
	  var computedValue = cache.get(cacheKey);
	  if (typeof computedValue === 'undefined') {
	    computedValue = fn.apply(this, args);
	    cache.set(cacheKey, computedValue);
	  }
	
	  return computedValue
	}
	
	function assemble (fn, context, strategy, cache, serialize) {
	  return strategy.bind(
	    context,
	    fn,
	    cache,
	    serialize
	  )
	}
	
	function strategyDefault (fn, options) {
	  var strategy = fn.length === 1 ? monadic : variadic;
	
	  return assemble(
	    fn,
	    this,
	    strategy,
	    options.cache.create(),
	    options.serializer
	  )
	}
	
	function strategyVariadic (fn, options) {
	  var strategy = variadic;
	
	  return assemble(
	    fn,
	    this,
	    strategy,
	    options.cache.create(),
	    options.serializer
	  )
	}
	
	function strategyMonadic (fn, options) {
	  var strategy = monadic;
	
	  return assemble(
	    fn,
	    this,
	    strategy,
	    options.cache.create(),
	    options.serializer
	  )
	}
	
	//
	// Serializer
	//
	
	function serializerDefault () {
	  return JSON.stringify(arguments)
	}
	
	//
	// Cache
	//
	
	function ObjectWithoutPrototypeCache () {
	  this.cache = Object.create(null);
	}
	
	ObjectWithoutPrototypeCache.prototype.has = function (key) {
	  return (key in this.cache)
	};
	
	ObjectWithoutPrototypeCache.prototype.get = function (key) {
	  return this.cache[key]
	};
	
	ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
	  this.cache[key] = value;
	};
	
	var cacheDefault = {
	  create: function create () {
	    return new ObjectWithoutPrototypeCache()
	  }
	};
	
	//
	// API
	//
	
	var src = memoize;
	var strategies = {
	  variadic: strategyVariadic,
	  monadic: strategyMonadic
	};
	src.strategies = strategies;
	
	function unwrapExports (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var a = ["coords","download","href","name","rel","shape","target","type"];
	var abbr = ["title"];
	var applet = ["alt","height","name","width"];
	var area = ["alt","coords","download","href","rel","shape","target","type"];
	var audio = ["controls","loop","muted","preload","src"];
	var base = ["href","target"];
	var basefont = ["size"];
	var bdo = ["dir"];
	var blockquote = ["cite"];
	var button = ["disabled","form","name","type","value"];
	var canvas = ["height","width"];
	var col = ["span","width"];
	var colgroup = ["span","width"];
	var data = ["value"];
	var del = ["cite"];
	var details = ["open"];
	var dfn = ["title"];
	var dialog = ["open"];
	var embed = ["height","src","type","width"];
	var fieldset = ["disabled","form","name"];
	var font = ["size"];
	var form = ["accept","action","method","name","target"];
	var frame = ["name","scrolling","src"];
	var frameset = ["cols","rows"];
	var head = ["profile"];
	var hr = ["size","width"];
	var html = ["manifest"];
	var iframe = ["height","name","sandbox","scrolling","src","width"];
	var img = ["alt","height","name","sizes","src","width"];
	var input = ["accept","alt","autoCapitalize","autoCorrect","autoSave","checked","defaultChecked","defaultValue","disabled","form","height","list","max","min","multiple","name","onChange","pattern","placeholder","required","results","size","src","step","title","type","value","width"];
	var ins = ["cite"];
	var keygen = ["challenge","disabled","form","name"];
	var label = ["form"];
	var li = ["type","value"];
	var link = ["color","href","integrity","media","nonce","rel","scope","sizes","target","title","type"];
	var map = ["name"];
	var meta = ["content","name"];
	var meter = ["high","low","max","min","optimum","value"];
	var object = ["data","form","height","name","type","width"];
	var ol = ["reversed","start","type"];
	var optgroup = ["disabled","label"];
	var option = ["disabled","label","selected","value"];
	var output = ["form","name"];
	var param = ["name","type","value"];
	var pre = ["width"];
	var progress = ["max","value"];
	var q = ["cite"];
	var script = ["async","defer","integrity","nonce","src","type"];
	var select = ["defaultValue","disabled","form","multiple","name","onChange","required","size","value"];
	var slot = ["name"];
	var source = ["media","sizes","src","type"];
	var style = ["media","nonce","title","type"];
	var table = ["summary","width"];
	var td = ["headers","height","scope","width"];
	var textarea = ["autoCapitalize","autoCorrect","cols","defaultValue","disabled","form","name","onChange","placeholder","required","rows","value","wrap"];
	var th = ["headers","height","scope","width"];
	var track = ["default","kind","label","src"];
	var ul = ["type"];
	var video = ["controls","height","loop","muted","playsInline","poster","preload","src","width"];
	var svg = ["accentHeight","accumulate","additive","alignmentBaseline","allowReorder","alphabetic","amplitude","arabicForm","ascent","attributeName","attributeType","autoReverse","azimuth","baseFrequency","baseProfile","baselineShift","bbox","begin","bias","by","calcMode","capHeight","clip","clipPath","clipPathUnits","clipRule","color","colorInterpolation","colorInterpolationFilters","colorProfile","colorRendering","contentScriptType","contentStyleType","cursor","cx","cy","d","decelerate","descent","diffuseConstant","direction","display","divisor","dominantBaseline","dur","dx","dy","edgeMode","elevation","enableBackground","end","exponent","externalResourcesRequired","fill","fillOpacity","fillRule","filter","filterRes","filterUnits","floodColor","floodOpacity","focusable","fontFamily","fontSize","fontSizeAdjust","fontStretch","fontStyle","fontVariant","fontWeight","format","from","fx","fy","g1","g2","glyphName","glyphOrientationHorizontal","glyphOrientationVertical","glyphRef","gradientTransform","gradientUnits","hanging","height","horizAdvX","horizOriginX","ideographic","imageRendering","in","in2","intercept","k","k1","k2","k3","k4","kernelMatrix","kernelUnitLength","kerning","keyPoints","keySplines","keyTimes","lengthAdjust","letterSpacing","lightingColor","limitingConeAngle","local","markerEnd","markerHeight","markerMid","markerStart","markerUnits","markerWidth","mask","maskContentUnits","maskUnits","mathematical","mode","numOctaves","offset","opacity","operator","order","orient","orientation","origin","overflow","overlinePosition","overlineThickness","paintOrder","panose1","pathLength","patternContentUnits","patternTransform","patternUnits","pointerEvents","points","pointsAtX","pointsAtY","pointsAtZ","preserveAlpha","preserveAspectRatio","primitiveUnits","r","radius","refX","refY","renderingIntent","repeatCount","repeatDur","requiredExtensions","requiredFeatures","restart","result","rotate","rx","ry","scale","seed","shapeRendering","slope","spacing","specularConstant","specularExponent","speed","spreadMethod","startOffset","stdDeviation","stemh","stemv","stitchTiles","stopColor","stopOpacity","strikethroughPosition","strikethroughThickness","string","stroke","strokeDasharray","strokeDashoffset","strokeLinecap","strokeLinejoin","strokeMiterlimit","strokeOpacity","strokeWidth","surfaceScale","systemLanguage","tableValues","targetX","targetY","textAnchor","textDecoration","textLength","textRendering","to","transform","u1","u2","underlinePosition","underlineThickness","unicode","unicodeBidi","unicodeRange","unitsPerEm","vAlphabetic","vHanging","vIdeographic","vMathematical","values","vectorEffect","version","vertAdvY","vertOriginX","vertOriginY","viewBox","viewTarget","visibility","width","widths","wordSpacing","writingMode","x","x1","x2","xChannelSelector","xHeight","xlinkActuate","xlinkArcrole","xlinkHref","xlinkRole","xlinkShow","xlinkTitle","xlinkType","xmlBase","xmlLang","xmlSpace","xmlns","xmlnsXlink","y","y1","y2","yChannelSelector","z","zoomAndPan"];
	var elements = {"html":["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","math","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rb","rp","rt","rtc","ruby","s","samp","script","section","select","slot","small","source","span","strong","style","sub","summary","sup","svg","table","tbody","td","template","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr"],"svg":["a","altGlyph","altGlyphDef","altGlyphItem","animate","animateColor","animateMotion","animateTransform","circle","clipPath","color-profile","cursor","defs","desc","ellipse","feBlend","feColorMatrix","feComponentTransfer","feComposite","feConvolveMatrix","feDiffuseLighting","feDisplacementMap","feDistantLight","feFlood","feFuncA","feFuncB","feFuncG","feFuncR","feGaussianBlur","feImage","feMerge","feMergeNode","feMorphology","feOffset","fePointLight","feSpecularLighting","feSpotLight","feTile","feTurbulence","filter","font","font-face","font-face-format","font-face-name","font-face-src","font-face-uri","foreignObject","g","glyph","glyphRef","hkern","image","line","linearGradient","marker","mask","metadata","missing-glyph","mpath","path","pattern","polygon","polyline","radialGradient","rect","script","set","stop","style","svg","switch","symbol","text","textPath","title","tref","tspan","use","view","vkern"]};
	var reactHtmlAttributes = {
		a: a,
		abbr: abbr,
		applet: applet,
		area: area,
		audio: audio,
		base: base,
		basefont: basefont,
		bdo: bdo,
		blockquote: blockquote,
		button: button,
		canvas: canvas,
		col: col,
		colgroup: colgroup,
		data: data,
		del: del,
		details: details,
		dfn: dfn,
		dialog: dialog,
		embed: embed,
		fieldset: fieldset,
		font: font,
		form: form,
		frame: frame,
		frameset: frameset,
		head: head,
		hr: hr,
		html: html,
		iframe: iframe,
		img: img,
		input: input,
		ins: ins,
		keygen: keygen,
		label: label,
		li: li,
		link: link,
		map: map,
		meta: meta,
		meter: meter,
		object: object,
		ol: ol,
		optgroup: optgroup,
		option: option,
		output: output,
		param: param,
		pre: pre,
		progress: progress,
		q: q,
		script: script,
		select: select,
		slot: slot,
		source: source,
		style: style,
		table: table,
		td: td,
		textarea: textarea,
		th: th,
		track: track,
		ul: ul,
		video: video,
		svg: svg,
		elements: elements,
		"*": ["about","acceptCharset","accessKey","allowFullScreen","allowTransparency","autoComplete","autoFocus","autoPlay","capture","cellPadding","cellSpacing","charSet","classID","className","colSpan","contentEditable","contextMenu","crossOrigin","dangerouslySetInnerHTML","datatype","dateTime","dir","draggable","encType","formAction","formEncType","formMethod","formNoValidate","formTarget","frameBorder","hidden","hrefLang","htmlFor","httpEquiv","icon","id","inlist","inputMode","is","itemID","itemProp","itemRef","itemScope","itemType","keyParams","keyType","lang","marginHeight","marginWidth","maxLength","mediaGroup","minLength","noValidate","prefix","property","radioGroup","readOnly","resource","role","rowSpan","scoped","seamless","security","spellCheck","srcDoc","srcLang","srcSet","style","suppressContentEditableWarning","tabIndex","title","typeof","unselectable","useMap","vocab","wmode"]
	};
	
	var reactHtmlAttributes$1 = Object.freeze({
		a: a,
		abbr: abbr,
		applet: applet,
		area: area,
		audio: audio,
		base: base,
		basefont: basefont,
		bdo: bdo,
		blockquote: blockquote,
		button: button,
		canvas: canvas,
		col: col,
		colgroup: colgroup,
		data: data,
		del: del,
		details: details,
		dfn: dfn,
		dialog: dialog,
		embed: embed,
		fieldset: fieldset,
		font: font,
		form: form,
		frame: frame,
		frameset: frameset,
		head: head,
		hr: hr,
		html: html,
		iframe: iframe,
		img: img,
		input: input,
		ins: ins,
		keygen: keygen,
		label: label,
		li: li,
		link: link,
		map: map,
		meta: meta,
		meter: meter,
		object: object,
		ol: ol,
		optgroup: optgroup,
		option: option,
		output: output,
		param: param,
		pre: pre,
		progress: progress,
		q: q,
		script: script,
		select: select,
		slot: slot,
		source: source,
		style: style,
		table: table,
		td: td,
		textarea: textarea,
		th: th,
		track: track,
		ul: ul,
		video: video,
		svg: svg,
		elements: elements,
		default: reactHtmlAttributes
	});
	
	var reactHtmlAttributes$2 = ( reactHtmlAttributes$1 && reactHtmlAttributes ) || reactHtmlAttributes$1;
	
	var dist = createCommonjsModule(function (module, exports) {
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	exports.default = reactHtmlAttributes$2;
	
	module.exports = reactHtmlAttributes$2; // for CommonJS compatibility
	});
	
	var reactHTMLAttributes = unwrapExports(dist);
	
	/*
	 * This is used to check if a property name is one of the React-specific
	 * properties and determine if that property should be forwarded
	 * to the React component
	 */
	
	/* Logic copied from ReactDOMUnknownPropertyHook */
	var reactProps = ['children', 'dangerouslySetInnerHTML', 'key', 'ref', 'autoFocus', 'defaultValue', 'valueLink', 'defaultChecked', 'checkedLink', 'innerHTML', 'suppressContentEditableWarning', 'onFocusIn', 'onFocusOut', 'className',
	
	/* List copied from https://facebook.github.io/react/docs/events.html */
	'onCopy', 'onCut', 'onPaste', 'onCompositionEnd', 'onCompositionStart', 'onCompositionUpdate', 'onKeyDown', 'onKeyPress', 'onKeyUp', 'onFocus', 'onBlur', 'onChange', 'onInput', 'onInvalid', 'onSubmit', 'onClick', 'onContextMenu', 'onDoubleClick', 'onDrag', 'onDragEnd', 'onDragEnter', 'onDragExit', 'onDragLeave', 'onDragOver', 'onDragStart', 'onDrop', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp', 'onSelect', 'onTouchCancel', 'onTouchEnd', 'onTouchMove', 'onTouchStart', 'onScroll', 'onWheel', 'onAbort', 'onCanPlay', 'onCanPlayThrough', 'onDurationChange', 'onEmptied', 'onEncrypted', 'onEnded', 'onError', 'onLoadedData', 'onLoadedMetadata', 'onLoadStart', 'onPause', 'onPlay', 'onPlaying', 'onProgress', 'onRateChange', 'onSeeked', 'onSeeking', 'onStalled', 'onSuspend', 'onTimeUpdate', 'onVolumeChange', 'onWaiting', 'onLoad', 'onAnimationStart', 'onAnimationEnd', 'onAnimationIteration', 'onTransitionEnd', 'onCopyCapture', 'onCutCapture', 'onPasteCapture', 'onCompositionEndCapture', 'onCompositionStartCapture', 'onCompositionUpdateCapture', 'onKeyDownCapture', 'onKeyPressCapture', 'onKeyUpCapture', 'onFocusCapture', 'onBlurCapture', 'onChangeCapture', 'onInputCapture', 'onSubmitCapture', 'onClickCapture', 'onContextMenuCapture', 'onDoubleClickCapture', 'onDragCapture', 'onDragEndCapture', 'onDragEnterCapture', 'onDragExitCapture', 'onDragLeaveCapture', 'onDragOverCapture', 'onDragStartCapture', 'onDropCapture', 'onMouseDownCapture', 'onMouseEnterCapture', 'onMouseLeaveCapture', 'onMouseMoveCapture', 'onMouseOutCapture', 'onMouseOverCapture', 'onMouseUpCapture', 'onSelectCapture', 'onTouchCancelCapture', 'onTouchEndCapture', 'onTouchMoveCapture', 'onTouchStartCapture', 'onScrollCapture', 'onWheelCapture', 'onAbortCapture', 'onCanPlayCapture', 'onCanPlayThroughCapture', 'onDurationChangeCapture', 'onEmptiedCapture', 'onEncryptedCapture', 'onEndedCapture', 'onErrorCapture', 'onLoadedDataCapture', 'onLoadedMetadataCapture', 'onLoadStartCapture', 'onPauseCapture', 'onPlayCapture', 'onPlayingCapture', 'onProgressCapture', 'onRateChangeCapture', 'onSeekedCapture', 'onSeekingCapture', 'onStalledCapture', 'onSuspendCapture', 'onTimeUpdateCapture', 'onVolumeChangeCapture', 'onWaitingCapture', 'onLoadCapture', 'onAnimationStartCapture', 'onAnimationEndCapture', 'onAnimationIterationCapture', 'onTransitionEndCapture'];
	
	if (isPreact) {
	  reactProps.push('autocomplete', 'autofocus', 'class', 'for', 'onDblClick', 'onSearch', 'slot', 'srcset');
	}
	
	/* eslint max-lines:0, func-style:0 */
	
	var globalReactHtmlProps = reactHTMLAttributes['*'];
	var supportedSVGTagNames = reactHTMLAttributes.elements.svg;
	var supportedHtmlTagNames = reactHTMLAttributes.elements.html;
	
	// these are valid attributes that have the
	// same name as CSS properties, and is used
	// for css overrides API
	var cssProps = ['color', 'height', 'width'];
	
	/* From DOMProperty */
	var ATTRIBUTE_NAME_START_CHAR =
	// eslint-disable-next-line max-len
	':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	// eslint-disable-next-line max-len
	var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
	var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));
	
	var isSvgTag = function (tagName) {
	  return (
	    // in our context, we only say that SVG tags are SVG
	    // if they are not also HTML.
	    // See https://github.com/paypal/glamorous/issues/245
	    // the svg tag will always be treated as svg for
	    // er... obvious reasons
	    tagName === 'svg' || supportedHtmlTagNames.indexOf(tagName) === -1 && supportedSVGTagNames.indexOf(tagName) !== -1
	  );
	};
	var isHtmlProp = function (name, tagName) {
	  var elementAttributes = void 0;
	
	  if (isSvgTag(tagName)) {
	    // all SVG attributes supported by React are grouped under 'svg'
	    elementAttributes = reactHTMLAttributes.svg;
	  } else {
	    elementAttributes = reactHTMLAttributes[tagName] || [];
	  }
	
	  return globalReactHtmlProps.indexOf(name) !== -1 || elementAttributes.indexOf(name) !== -1;
	};
	var isCssProp = function (name) {
	  return cssProps.indexOf(name) !== -1;
	};
	var isReactProp = function (name) {
	  return reactProps.indexOf(name) !== -1;
	};
	
	// eslint-disable-next-line complexity
	var shouldForwardProperty = function (tagName, name) {
	  return typeof tagName !== 'string' || (isHtmlProp(name, tagName) || isReactProp(name) || isCustomAttribute(name.toLowerCase())) && (!isCssProp(name) || isSvgTag(tagName));
	};
	
	var shouldForwardProperty$1 = src(shouldForwardProperty);
	
	// eslint-disable-next-line complexity
	function splitProps(_ref, _ref2) {
	  var propsAreCssOverrides = _ref2.propsAreCssOverrides,
	      rootEl = _ref2.rootEl,
	      filterProps = _ref2.filterProps,
	      forwardProps = _ref2.forwardProps;
	  var cssProp = _ref.css,
	      innerRef = _ref.innerRef,
	      theme = _ref.theme,
	      className = _ref.className,
	      glam = _ref.glam,
	      rest = objectWithoutProperties(_ref, ['css', 'innerRef', 'theme', 'className', 'glam']);
	
	  // forward innerRef if user wishes to do so
	  if (innerRef !== undefined && forwardProps.indexOf('innerRef') !== -1) {
	    rest.innerRef = innerRef;
	  }
	  var returnValue = { toForward: {}, cssProp: cssProp, cssOverrides: {} };
	  if (!propsAreCssOverrides) {
	    if (typeof rootEl !== 'string' && filterProps.length === 0) {
	      // if it's not a string and filterProps is empty,
	      // then we can forward everything (because it's a component)
	      returnValue.toForward = rest;
	      return returnValue;
	    }
	  }
	  return Object.keys(rest).reduce(function (split, propName) {
	    if (filterProps.indexOf(propName) !== -1) {
	      return split;
	    } else if (forwardProps.indexOf(propName) !== -1 || shouldForwardProperty$1(rootEl, propName)) {
	      split.toForward[propName] = rest[propName];
	    } else if (propsAreCssOverrides) {
	      split.cssOverrides[propName] = rest[propName];
	    }
	    return split;
	  }, returnValue);
	}
	
	var glamorous = createGlamorous(splitProps);
	
	/*
	 * This creates a glamorousComponentFactory for every DOM element so you can
	 * simply do:
	 * const GreenButton = glamorous.button({
	 *   backgroundColor: 'green',
	 *   padding: 20,
	 * })
	 * <GreenButton>Click Me!</GreenButton>
	 */
	Object.assign(glamorous, domElements.reduce(function (getters, tag) {
	  // TODO: next breaking change, let's make
	  // the `displayName` be: `glamorous.${tag}`
	  getters[tag] = glamorous(tag);
	  return getters;
	}, {}));
	
	/*
	 * This creates a glamorous component for each DOM element so you can
	 * simply do:
	 * <glamorous.Div
	 *   color="green"
	 *   marginLeft={20}
	 * >
	 *   I'm green!
	 * </glamorous.Div>
	 */
	Object.assign(glamorous, domElements.reduce(function (comps, tag) {
	  var capitalTag = capitalize(tag);
	  comps[capitalTag] = glamorous[tag]();
	  comps[capitalTag].displayName = 'glamorous.' + capitalTag;
	  comps[capitalTag].propsAreCssOverrides = true;
	  return comps;
	}, {}));
	
	function capitalize(s) {
	  return s.slice(0, 1).toUpperCase() + s.slice(1);
	}
	
	/*
	 * Fix importing in typescript after rollup compilation
	 * https://github.com/rollup/rollup/issues/1156
	 * https://github.com/Microsoft/TypeScript/issues/13017#issuecomment-268657860
	 */
	glamorous.default = glamorous;
	
	
	var glamorousStar = Object.freeze({
		default: glamorous,
		ThemeProvider: ThemeProvider,
		withTheme: withTheme
	});
	
	/* istanbul ignore next */
	
	var glamorous$1 = glamorous;
	
	Object.assign(glamorous$1, Object.keys(glamorousStar).reduce(function (e, prop) {
	  if (prop !== 'default') {
	    // eslint-disable-next-line import/namespace
	    e[prop] = glamorousStar[prop];
	  }
	  return e;
	}, {}));
	
	module.exports = glamorous$1;


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = uncontrollable;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _invariant = _interopRequireDefault(__webpack_require__(68));
	
	var Utils = _interopRequireWildcard(__webpack_require__(1981));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function uncontrollable(Component, controlledValues, methods) {
	  if (methods === void 0) {
	    methods = [];
	  }
	
	  var displayName = Component.displayName || Component.name || 'Component';
	  var isCompositeComponent = Utils.isReactComponent(Component);
	  var controlledProps = Object.keys(controlledValues);
	  var PROPS_TO_OMIT = controlledProps.map(Utils.defaultKey);
	  !(isCompositeComponent || !methods.length) ?  false ? (0, _invariant.default)(false, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', ')) : invariant(false) : void 0;
	
	  var UncontrolledComponent =
	  /*#__PURE__*/
	  function (_React$Component) {
	    _inheritsLoose(UncontrolledComponent, _React$Component);
	
	    function UncontrolledComponent() {
	      var _this;
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	      _this.handlers = Object.create(null);
	      controlledProps.forEach(function (propName) {
	        var handlerName = controlledValues[propName];
	
	        var handleChange = function handleChange(value) {
	          if (_this.props[handlerName]) {
	            var _this$props;
	
	            _this._notifying = true;
	
	            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	              args[_key2 - 1] = arguments[_key2];
	            }
	
	            (_this$props = _this.props)[handlerName].apply(_this$props, [value].concat(args));
	
	            _this._notifying = false;
	          }
	
	          _this._values[propName] = value;
	          if (!_this.unmounted) _this.forceUpdate();
	        };
	
	        _this.handlers[handlerName] = handleChange;
	      });
	      if (isCompositeComponent) _this.attachRef = function (ref) {
	        _this.inner = ref;
	      };
	      return _this;
	    }
	
	    var _proto = UncontrolledComponent.prototype;
	
	    _proto.shouldComponentUpdate = function shouldComponentUpdate() {
	      //let the forceUpdate trigger the update
	      return !this._notifying;
	    };
	
	    _proto.componentWillMount = function componentWillMount() {
	      var _this2 = this;
	
	      var props = this.props;
	      this._values = Object.create(null);
	      controlledProps.forEach(function (key) {
	        _this2._values[key] = props[Utils.defaultKey(key)];
	      });
	    };
	
	    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      var props = this.props;
	      controlledProps.forEach(function (key) {
	        /**
	         * If a prop switches from controlled to Uncontrolled
	         * reset its value to the defaultValue
	         */
	        if (!Utils.isProp(nextProps, key) && Utils.isProp(props, key)) {
	          _this3._values[key] = nextProps[Utils.defaultKey(key)];
	        }
	      });
	    };
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.unmounted = true;
	    };
	
	    _proto.getControlledInstance = function getControlledInstance() {
	      return this.inner;
	    };
	
	    _proto.render = function render() {
	      var _this4 = this;
	
	      var props = _extends({}, this.props);
	
	      PROPS_TO_OMIT.forEach(function (prop) {
	        delete props[prop];
	      });
	      var newProps = {};
	      controlledProps.forEach(function (propName) {
	        var propValue = _this4.props[propName];
	        newProps[propName] = propValue !== undefined ? propValue : _this4._values[propName];
	      });
	      return _react.default.createElement(Component, _extends({}, props, newProps, this.handlers, {
	        ref: this.attachRef
	      }));
	    };
	
	    return UncontrolledComponent;
	  }(_react.default.Component);
	
	  UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
	  UncontrolledComponent.propTypes = Utils.uncontrolledPropTypes(controlledValues, displayName);
	  methods.forEach(function (method) {
	    UncontrolledComponent.prototype[method] = function $proxiedMethod() {
	      var _inner;
	
	      return (_inner = this.inner)[method].apply(_inner, arguments);
	    };
	  });
	  UncontrolledComponent.ControlledComponent = Component;
	  /**
	   * useful when wrapping a Component and you want to control
	   * everything
	   */
	
	  UncontrolledComponent.deferControlTo = function (newComponent, additions, nextMethods) {
	    if (additions === void 0) {
	      additions = {};
	    }
	
	    return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
	  };
	
	  return UncontrolledComponent;
	}
	
	module.exports = exports["default"];

/***/ },
/* 156 */
[2243, 2041],
/* 157 */
[2243, 2098],
/* 158 */
/***/ function(module, exports) {

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	module.exports = _classCallCheck;

/***/ },
/* 159 */
/***/ function(module, exports) {

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	module.exports = _createClass;

/***/ },
/* 160 */
/***/ function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ },
/* 161 */
/***/ function(module, exports) {

	function _getPrototypeOf(o) {
	  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}
	
	module.exports = _getPrototypeOf;

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(2106);
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) setPrototypeOf(subClass, superClass);
	}
	
	module.exports = _inherits;

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	var objectWithoutPropertiesLoose = __webpack_require__(2105);
	
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = objectWithoutPropertiesLoose(source, excluded);
	  var key, i;
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutProperties;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(165);
	
	var assertThisInitialized = __webpack_require__(127);
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }
	
	  return assertThisInitialized(self);
	}
	
	module.exports = _possibleConstructorReturn;

/***/ },
/* 165 */
/***/ function(module, exports) {

	function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }
	
	function _typeof(obj) {
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    module.exports = _typeof = function _typeof(obj) {
	      return _typeof2(obj);
	    };
	  } else {
	    module.exports = _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
	    };
	  }
	
	  return _typeof(obj);
	}
	
	module.exports = _typeof;

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1328);

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _inheritsLoose = _interopDefault(__webpack_require__(975));
	var React = __webpack_require__(1);
	var createCache = _interopDefault(__webpack_require__(535));
	var utils = __webpack_require__(980);
	var serialize = __webpack_require__(536);
	var sheet = __webpack_require__(537);
	var css = _interopDefault(__webpack_require__(131));
	
	var EmotionCacheContext = React.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
	// because this module is primarily intended for the browser and node
	// but it's also required in react native and similar environments sometimes
	// and we could have a special build just for that
	// but this is much easier and the native packages
	// might use a different theme context in the future anyway
	typeof HTMLElement !== 'undefined' ? createCache() : null);
	var ThemeContext = React.createContext({});
	var CacheProvider = EmotionCacheContext.Provider;
	
	exports.withEmotionCache = function withEmotionCache(func) {
	  var render = function render(props, ref) {
	    return React.createElement(EmotionCacheContext.Consumer, null, function (cache) {
	      return func(props, cache, ref);
	    });
	  }; // $FlowFixMe
	
	
	  return React.forwardRef(render);
	};
	
	// thus we only need to replace what is a valid character for JS, but not for CSS
	
	var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
	  return identifier.replace(/\$/g, '-');
	};
	
	var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
	var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var render = function render(cache, props, theme, ref) {
	  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
	  // not passing the registered cache to serializeStyles because it would
	  // make certain babel optimisations not possible
	
	  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
	    cssProp = cache.registered[cssProp];
	  }
	
	  var type = props[typePropName];
	  var registeredStyles = [cssProp];
	  var className = '';
	
	  if (typeof props.className === 'string') {
	    className = utils.getRegisteredStyles(cache.registered, registeredStyles, props.className);
	  } else if (props.className != null) {
	    className = props.className + " ";
	  }
	
	  var serialized = serialize.serializeStyles(registeredStyles);
	
	  if (false) {
	    var labelFromStack = props[labelPropName];
	
	    if (labelFromStack) {
	      serialized = serialize.serializeStyles([serialized, 'label:' + labelFromStack + ';']);
	    }
	  }
	
	  var rules = utils.insertStyles(cache, serialized, typeof type === 'string');
	  className += cache.key + "-" + serialized.name;
	  var newProps = {};
	
	  for (var key in props) {
	    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (("production") === 'production' || key !== labelPropName)) {
	      newProps[key] = props[key];
	    }
	  }
	
	  newProps.ref = ref;
	  newProps.className = className;
	  var ele = React.createElement(type, newProps);
	
	  return ele;
	};
	
	var Emotion =
	/* #__PURE__ */
	exports.withEmotionCache(function (props, cache, ref) {
	  // use Context.read for the theme when it's stable
	  if (typeof props.css === 'function') {
	    return React.createElement(ThemeContext.Consumer, null, function (theme) {
	      return render(cache, props, theme, ref);
	    });
	  }
	
	  return render(cache, props, null, ref);
	});
	
	if (false) {
	  Emotion.displayName = 'EmotionCssPropInternal';
	} // $FlowFixMe
	
	
	var jsx = function jsx(type, props) {
	  var args = arguments;
	
	  if (props == null || !hasOwnProperty.call(props, 'css')) {
	    // $FlowFixMe
	    return React.createElement.apply(undefined, args);
	  }
	
	  if (false) {
	    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + props.css + "`");
	  }
	
	  var argsLength = args.length;
	  var createElementArgArray = new Array(argsLength);
	  createElementArgArray[0] = Emotion;
	  var newProps = {};
	
	  for (var key in props) {
	    if (hasOwnProperty.call(props, key)) {
	      newProps[key] = props[key];
	    }
	  }
	
	  newProps[typePropName] = type;
	
	  if (false) {
	    var error = new Error();
	
	    if (error.stack) {
	      // chrome
	      var match = error.stack.match(/at (?:Object\.|)jsx.*\n\s+at ([A-Z][A-Za-z$]+) /);
	
	      if (!match) {
	        // safari and firefox
	        match = error.stack.match(/^.*\n([A-Z][A-Za-z$]+)@/);
	      }
	
	      if (match) {
	        newProps[labelPropName] = sanitizeIdentifier(match[1]);
	      }
	    }
	  }
	
	  createElementArgArray[1] = newProps;
	
	  for (var i = 2; i < argsLength; i++) {
	    createElementArgArray[i] = args[i];
	  } // $FlowFixMe
	
	
	  return React.createElement.apply(null, createElementArgArray);
	};
	
	var warnedAboutCssPropForGlobal = false;
	var Global =
	/* #__PURE__ */
	exports.withEmotionCache(function (props, cache) {
	  if (false) {
	    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
	    warnedAboutCssPropForGlobal = true;
	  }
	
	  var styles = props.styles;
	
	  if (typeof styles === 'function') {
	    return React.createElement(ThemeContext.Consumer, null, function (theme) {
	      var serialized = serialize.serializeStyles([styles(theme)]);
	      return React.createElement(InnerGlobal, {
	        serialized: serialized,
	        cache: cache
	      });
	    });
	  }
	
	  var serialized = serialize.serializeStyles([styles]);
	  return React.createElement(InnerGlobal, {
	    serialized: serialized,
	    cache: cache
	  });
	});
	
	// maintain place over rerenders.
	// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
	// initial client-side render from SSR, use place of hydrating tag
	var InnerGlobal =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(InnerGlobal, _React$Component);
	
	  function InnerGlobal(props, context, updater) {
	    return _React$Component.call(this, props, context, updater) || this;
	  }
	
	  var _proto = InnerGlobal.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.sheet = new sheet.StyleSheet({
	      key: this.props.cache.key + "-global",
	      nonce: this.props.cache.sheet.nonce,
	      container: this.props.cache.sheet.container
	    }); // $FlowFixMe
	
	    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");
	
	    if (node !== null) {
	      this.sheet.tags.push(node);
	    }
	
	    if (this.props.cache.sheet.tags.length) {
	      this.sheet.before = this.props.cache.sheet.tags[0];
	    }
	
	    this.insertStyles();
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (prevProps.serialized.name !== this.props.serialized.name) {
	      this.insertStyles();
	    }
	  };
	
	  _proto.insertStyles = function insertStyles() {
	    if (this.props.serialized.next !== undefined) {
	      // insert keyframes
	      utils.insertStyles(this.props.cache, this.props.serialized.next, true);
	    }
	
	    if (this.sheet.tags.length) {
	      // if this doesn't exist then it will be null so the style element will be appended
	      var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
	      this.sheet.before = element;
	      this.sheet.flush();
	    }
	
	    this.props.cache.insert("", this.props.serialized, this.sheet, false);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.sheet.flush();
	  };
	
	  _proto.render = function render() {
	
	    return null;
	  };
	
	  return InnerGlobal;
	}(React.Component);
	
	var keyframes = function keyframes() {
	  var insertable = css.apply(void 0, arguments);
	  var name = "animation-" + insertable.name; // $FlowFixMe
	
	  return {
	    name: name,
	    styles: "@keyframes " + name + "{" + insertable.styles + "}",
	    anim: 1,
	    toString: function toString() {
	      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
	    }
	  };
	};
	
	var classnames = function classnames(args) {
	  var len = args.length;
	  var i = 0;
	  var cls = '';
	
	  for (; i < len; i++) {
	    var arg = args[i];
	    if (arg == null) continue;
	    var toAdd = void 0;
	
	    switch (typeof arg) {
	      case 'boolean':
	        break;
	
	      case 'object':
	        {
	          if (Array.isArray(arg)) {
	            toAdd = classnames(arg);
	          } else {
	            toAdd = '';
	
	            for (var k in arg) {
	              if (arg[k] && k) {
	                toAdd && (toAdd += ' ');
	                toAdd += k;
	              }
	            }
	          }
	
	          break;
	        }
	
	      default:
	        {
	          toAdd = arg;
	        }
	    }
	
	    if (toAdd) {
	      cls && (cls += ' ');
	      cls += toAdd;
	    }
	  }
	
	  return cls;
	};
	
	function merge(registered, css, className) {
	  var registeredStyles = [];
	  var rawClassName = utils.getRegisteredStyles(registered, registeredStyles, className);
	
	  if (registeredStyles.length < 2) {
	    return className;
	  }
	
	  return rawClassName + css(registeredStyles);
	}
	
	var ClassNames = exports.withEmotionCache(function (props, context) {
	  return React.createElement(ThemeContext.Consumer, null, function (theme) {
	    var hasRendered = false;
	
	    var css = function css() {
	      if (hasRendered && ("production") !== 'production') {
	        throw new Error('css can only be used during render');
	      }
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var serialized = serialize.serializeStyles(args, context.registered);
	
	      {
	        utils.insertStyles(context, serialized, false);
	      }
	
	      return context.key + "-" + serialized.name;
	    };
	
	    var cx = function cx() {
	      if (hasRendered && ("production") !== 'production') {
	        throw new Error('cx can only be used during render');
	      }
	
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return merge(context.registered, css, classnames(args));
	    };
	
	    var content = {
	      css: css,
	      cx: cx,
	      theme: theme
	    };
	    var ele = props.children(content);
	    hasRendered = true;
	
	    return ele;
	  });
	});
	
	exports.css = css;
	exports.CacheProvider = CacheProvider;
	exports.ClassNames = ClassNames;
	exports.Global = Global;
	exports.ThemeContext = ThemeContext;
	exports.jsx = jsx;
	exports.keyframes = keyframes;


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _preview = __webpack_require__(543);
	
	Object.defineProperty(exports, 'linkTo', {
	  enumerable: true,
	  get: function get() {
	    return _preview.linkTo;
	  }
	});
	Object.defineProperty(exports, 'hrefTo', {
	  enumerable: true,
	  get: function get() {
	    return _preview.hrefTo;
	  }
	});
	exports.LinkTo = LinkTo;
	var ADDON_ID = exports.ADDON_ID = 'storybook/links';
	var EVENT_ID = exports.EVENT_ID = ADDON_ID + '/link-event';
	var REQUEST_HREF_EVENT_ID = exports.REQUEST_HREF_EVENT_ID = ADDON_ID + '/request-href-event';
	var RECEIVE_HREF_EVENT_ID = exports.RECEIVE_HREF_EVENT_ID = ADDON_ID + '/receive-href-event';
	
	var hasWarned = false;
	
	function LinkTo() {
	  if (!hasWarned) {
	    // eslint-disable-next-line no-console
	    console.error('\nLinkTo has moved to addon-links/react:\n\nimport LinkTo from \'@storybook/addon-links/react\';\n    ');
	    hasWarned = true;
	  }
	  return null;
	}

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PopoverOfForm = __webpack_require__(410);
	
	var _PopoverOfForm2 = _interopRequireDefault(_PopoverOfForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{
	  type: 'document',
	  name: 'document_date',
	  value: 'Document Filed Date',
	  preview: function preview(filenameTemplate) {
	    return _lodash2.default.chain(filenameTemplate.date_format).replace('MM', '06').replace('DD', '28').replace('YYYY', '2018').value();
	  },
	  showOnFolderPathEdit: false,
	  showOnFileFormatEdit: true
	}, {
	  type: 'document',
	  name: 'document_description',
	  value: 'Document Description',
	  preview: function preview(filenameTemplate) {
	    // eslint-disable-next-line
	    var text = 'Notice of Lodgment of Order with Service filed by Alan Vanderhoff on behalf of SoCal Eats LLC. related documents [370]';
	    return text.split(' ').slice(0, filenameTemplate.description_max_words).join(' ');
	  },
	  tooltip: function tooltip() {
	    return _react2.default.createElement(
	      _PopoverOfForm2.default,
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'Uses "N" number of words from the start of the docket text to describe the document (max 20)'
	      )
	    );
	  },
	  showOnFolderPathEdit: true,
	  showOnFileFormatEdit: true
	}, {
	  type: 'document',
	  name: 'part_description',
	  value: 'Part Description',
	  preview: function preview() {
	    return 'Main Document';
	  },
	  tooltip: function tooltip() {
	    return _react2.default.createElement(
	      _PopoverOfForm2.default,
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'The generic description assigned by PACER. For example, "main document" or "Exhibit A"'
	      )
	    );
	  },
	  showOnFolderPathEdit: true,
	  showOnFileFormatEdit: true
	}, {
	  type: 'document',
	  name: 'type',
	  value: 'Document Entry Type',
	  preview: function preview() {
	    return 'DE';
	  },
	  tooltip: function tooltip() {
	    return _react2.default.createElement(
	      _PopoverOfForm2.default,
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'Will append the letters "DE" or "CE" depending on whether the entry is a docket or claim'
	      )
	    );
	  },
	  showOnFolderPathEdit: true,
	  showOnFileFormatEdit: true
	}, {
	  type: 'document',
	  name: 'docket_number',
	  value: 'Document Entry Number',
	  preview: function preview() {
	    return '390';
	  },
	  tooltip: function tooltip() {
	    return _react2.default.createElement(
	      _PopoverOfForm2.default,
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'This is the docket entry number or proof of claim number'
	      )
	    );
	  },
	  showOnFolderPathEdit: true,
	  showOnFileFormatEdit: true
	},
	// {
	//   type: 'document',
	//   name: 'document_number',
	//   value: 'Docket Part Number',
	//   preview: () => '1',
	//   tooltip: () => (
	//     <PopoverOfForm>
	//       <p>This is the number assigned by PACER when an entry contain multiple documents</p>
	//     </PopoverOfForm>
	//   ),
	//   showOnFolderPathEdit: true,
	//   showOnFileFormatEdit: true,
	// },
	{
	  type: 'case',
	  name: 'case_title',
	  value: 'Case Title',
	  preview: function preview() {
	    return 'Lehman Brothers Holdings Inc.';
	  }
	}, {
	  type: 'case',
	  name: 'case_date',
	  value: 'Case Date',
	  preview: function preview(filenameTemplate) {
	    return _lodash2.default.chain(filenameTemplate.date_format).replace('MM', '06').replace('DD', '28').replace('YYYY', '2018').value();
	  },
	  showOnFolderPathEdit: false,
	  showOnFileFormatEdit: true
	}, {
	  type: 'case',
	  name: 'case_number',
	  value: 'Case Number',
	  preview: function preview() {
	    return '1:08-bk-13555';
	  },
	  showOnFolderPathEdit: true,
	  showOnFileFormatEdit: true
	}, {
	  type: 'court',
	  name: 'court_code',
	  value: 'Court Code',
	  preview: function preview() {
	    return 'nysbke';
	  },
	  showOnFolderPathEdit: true,
	  showOnFileFormatEdit: true
	}, {
	  type: 'court',
	  name: 'court_name',
	  value: 'Court Name',
	  preview: function preview() {
	    return 'New York Southern Bankruptcy Court';
	  },
	  showOnFolderPathEdit: true,
	  showOnFileFormatEdit: true
	}, {
	  type: 'court',
	  name: 'court_citation',
	  value: 'Court Citation',
	  preview: function preview() {
	    return 'Bankr.S.D.N.Y.';
	  },
	  showOnFolderPathEdit: true,
	  showOnFileFormatEdit: true
	}, {
	  type: 'directory_prefix',
	  name: 'directory_prefix',
	  value: '',
	  preview: function preview() {
	    return '';
	  }
	}, {
	  type: 'separator',
	  name: '-',
	  value: '-',
	  preview: function preview() {
	    return '-';
	  },
	  showOnFolderPathEdit: true,
	  showOnFileFormatEdit: true
	}, {
	  type: 'separator',
	  name: '(',
	  value: '(',
	  preview: function preview() {
	    return '(';
	  },
	  showOnFolderPathEdit: false,
	  showOnFileFormatEdit: true
	}, {
	  type: 'separator',
	  name: ')',
	  value: ')',
	  preview: function preview() {
	    return ')';
	  },
	  showOnFolderPathEdit: false,
	  showOnFileFormatEdit: true
	}, {
	  type: 'separator',
	  name: '.',
	  value: '.',
	  preview: function preview() {
	    return '.';
	  },
	  showOnFolderPathEdit: false,
	  showOnFileFormatEdit: true
	}, {
	  type: 'separator',
	  name: '/',
	  value: '/',
	  preview: function preview() {
	    return '/';
	  },
	  showOnFolderPathEdit: true,
	  showOnFileFormatEdit: false
	}, {
	  type: 'separator',
	  name: '_',
	  value: '_',
	  preview: function preview() {
	    return '_';
	  },
	  showOnFolderPathEdit: true,
	  showOnFileFormatEdit: true
	}, {
	  type: 'separator',
	  name: ' ',
	  value: '[space]',
	  preview: function preview() {
	    return ' ';
	  },
	  showOnFolderPathEdit: false,
	  showOnFileFormatEdit: true
	}];

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LoadingBar = __webpack_require__(92);
	
	var _LoadingBar2 = _interopRequireDefault(_LoadingBar);
	
	var _DocumentsRow = __webpack_require__(258);
	
	var _DocumentsRow2 = _interopRequireDefault(_DocumentsRow);
	
	var _loadingBar = __webpack_require__(199);
	
	var _loadingBar2 = _interopRequireDefault(_loadingBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DocketEntry = function DocketEntry(_ref) {
	  var id = _ref.id,
	      docket = _ref.docket,
	      redact = _ref.redact,
	      showRedactPopup = _ref.showRedactPopup,
	      case_uuid = _ref.case_uuid,
	      onGetDocuments = _ref.onGetDocuments,
	      court_code = _ref.court_code,
	      case_number = _ref.case_number,
	      selectedDocket = _ref.selectedDocket;
	
	  var docketSeq = parseFloat(docket.docket_seq) > 0 ? docket.docket_seq : null;
	  var docketNumber = parseInt(docket.docket_no, 10) > 0 ? docket.docket_no : docketSeq;
	
	  var docketNumLink = !docketNumber || !docket.has_pdf_link_on_pacer ? docket.docket_no || null : _react2.default.createElement(
	    'div',
	    {
	      className: 'view_details ' + docket.colorCode,
	      onClick: function onClick() {
	        return onGetDocuments(docket, court_code, case_number);
	      }
	    },
	    _react2.default.createElement(
	      'strong',
	      null,
	      ' ',
	      docket.docket_no || 'doc',
	      ' '
	    )
	  );
	
	  var loadingOrRedact = redact.seqNum === docket.docket_seq ? _react2.default.createElement(
	    'div',
	    { className: 'loading-bar' },
	    _react2.default.createElement('img', { src: _loadingBar2.default })
	  ) : _react2.default.createElement(
	    'div',
	    { className: 'update-redact faded danger right', onClick: function onClick() {
	        return showRedactPopup(docket.docket_seq);
	      } },
	    'Update/Redact'
	  );
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'tr',
	      { key: 'docket-entry-' + id, className: 'details-visible' },
	      _react2.default.createElement(
	        'td',
	        null,
	        docket.date_filed
	      ),
	      _react2.default.createElement(
	        'td',
	        { style: { textAlign: 'center' } },
	        docketNumLink
	      ),
	      _react2.default.createElement(
	        'td',
	        { colSpan: '2' },
	        _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: docket.docket_text } }),
	        showRedactPopup && loadingOrRedact,
	        docket.status === 'loading' || selectedDocket.docket_no === docket.docket_no && selectedDocket.docket_seq === docket.docket_seq && selectedDocket.status === 'loading' && _react2.default.createElement(_LoadingBar2.default, { overrideShow: true })
	      )
	    ),
	    selectedDocket.docket_no === docket.docket_no && selectedDocket.docket_seq === docket.docket_seq && selectedDocket.status !== 'loading' && _react2.default.createElement(_DocumentsRow2.default, {
	      id: id,
	      binder: selectedDocket.binder,
	      case_uuid: case_uuid,
	      court_code: court_code,
	      case_number: case_number,
	      docket_seq: docket.docket_seq,
	      docket: docket
	    })
	  );
	};
	
	DocketEntry.propTypes = {
	  id: _propTypes2.default.string.isRequired,
	  docket: _propTypes2.default.object.isRequired,
	  selectedDocket: _propTypes2.default.object.isRequired,
	  redact: _propTypes2.default.object.isRequired,
	  showRedactPopup: _propTypes2.default.func.isRequired,
	  case_uuid: _propTypes2.default.string.isRequired,
	  onGetDocuments: _propTypes2.default.func.isRequired,
	  court_code: _propTypes2.default.string.isRequired,
	  case_number: _propTypes2.default.string.isRequired
	};
	
	exports.default = DocketEntry;

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _Popup = __webpack_require__(69);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _docketActions = __webpack_require__(42);
	
	var docketActions = _interopRequireWildcard(_docketActions);
	
	var _clientCodeAction = __webpack_require__(64);
	
	var _DocketDetailsPurchaseForm = __webpack_require__(109);
	
	var _DocketDetailsPurchaseForm2 = _interopRequireDefault(_DocketDetailsPurchaseForm);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DownloadCombineAllPdfInRangePopup = function (_Component) {
	  _inherits(DownloadCombineAllPdfInRangePopup, _Component);
	
	  function DownloadCombineAllPdfInRangePopup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DownloadCombineAllPdfInRangePopup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.buy = function () {
	      if (_this.props.dispatch((0, _clientCodeAction.hasValidClientCode)())) {
	        _this.props.dispatch(docketActions.buyAllParts(_this.props.popup.data)).then(function () {
	          return _this.downloadPdfCombined();
	        }).catch(function (e) {
	          return console.error(e);
	        });
	      } else {
	        _this.props.onClose();
	      }
	    }, _this.downloadPdfCombined = function () {
	      _this.props.dispatch(docketActions.downloadPdfCombined(_this.props.popup.data)).then(_this.props.reloadDetails).catch(function (e) {
	        return console.error(e);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  DownloadCombineAllPdfInRangePopup.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (!prevProps.docketParts.alreadyPurchased && this.props.docketParts.alreadyPurchased) {
	      this.downloadPdfCombined();
	    }
	  };
	
	  DownloadCombineAllPdfInRangePopup.prototype.render = function render() {
	    var _props = this.props,
	        popup = _props.popup,
	        onClose = _props.onClose,
	        docketParts = _props.docketParts;
	
	
	    return _react2.default.createElement(
	      _Popup2.default,
	      { show: popup.show, clsName: 'docket-pdf-zip-popup', topBarTitle: 'Download Combined Pdfs', onClose: onClose },
	      _react2.default.createElement(_DocketDetailsPurchaseForm2.default, { showXfaWarning: true, docketParts: docketParts, buy: this.buy })
	    );
	  };
	
	  return DownloadCombineAllPdfInRangePopup;
	}(_react.Component);
	
	DownloadCombineAllPdfInRangePopup.propTypes = {
	  onClose: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  docketParts: _propTypes2.default.object.isRequired,
	  popup: _propTypes2.default.object.isRequired,
	  reloadDetails: _propTypes2.default.func.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$get$toJS = state.get('dockets').toJS(),
	      popup = _state$get$toJS.popup,
	      docketParts = _state$get$toJS.docketParts,
	      favoriteEmail = _state$get$toJS.favoriteEmail;
	
	  return {
	    popup: popup,
	    docketParts: docketParts,
	    favoriteEmail: favoriteEmail
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DownloadCombineAllPdfInRangePopup);

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = EmailAllPartsZipPopup;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EmailBulkModal = __webpack_require__(202);
	
	var _EmailBulkModal2 = _interopRequireDefault(_EmailBulkModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EmailAllPartsZipPopup(args) {
	  return _react2.default.createElement(_EmailBulkModal2.default, _extends({}, args, { topBarTitle: 'Email ZIP File', emailActionName: 'emailPartsZip' }));
	}

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = EmailCombinedPdfPopup;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EmailBulkModal = __webpack_require__(202);
	
	var _EmailBulkModal2 = _interopRequireDefault(_EmailBulkModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EmailCombinedPdfPopup(args) {
	  return _react2.default.createElement(_EmailBulkModal2.default, _extends({}, args, { topBarTitle: 'Email Combined PDFs', emailActionName: 'emailPartsPdfCombined' }));
	}

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _reactSelect = __webpack_require__(23);
	
	var _Popup = __webpack_require__(69);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _docketActions = __webpack_require__(42);
	
	var docketActions = _interopRequireWildcard(_docketActions);
	
	var _loadingSpinner = __webpack_require__(963);
	
	var _loadingSpinner2 = _interopRequireDefault(_loadingSpinner);
	
	var _ProgressBar = __webpack_require__(266);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var selectStyle = {};
	
	var EmailPartPopup = function (_Component) {
	  _inherits(EmailPartPopup, _Component);
	
	  function EmailPartPopup(props) {
	    _classCallCheck(this, EmailPartPopup);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.onSubmit = function (e) {
	      e.preventDefault();
	      var _this$state = _this.state,
	          selectedEmails = _this$state.selectedEmails,
	          text = _this$state.text;
	
	      var hasInvalidEmail = selectedEmails.find(function (email) {
	        return !/\S+@\S+\.\S+/.test(email.value);
	      });
	
	      if (!!hasInvalidEmail) {
	        _this.setState({ hasInvalidEmail: hasInvalidEmail.value });
	        return;
	      }
	
	      var params = _extends({}, _this.props.popup.data, {
	        email_address: selectedEmails.map(function (e) {
	          return e.value;
	        }).join(','),
	        email_message: text
	      });
	
	      _this.props.dispatch(docketActions.sendEmail(params)).then(_this.props.reloadDetails);
	    };
	
	    _this.handleTextChange = function (e) {
	      e.preventDefault();
	      _this.setState({ text: e.target.value });
	    };
	
	    _this.handleChange = function (selectedEmails) {
	      _this.setState({
	        selectedEmails: selectedEmails,
	        hasInvalidEmail: !(selectedEmails && selectedEmails.length > 0)
	      });
	    };
	
	    _this.renderProgress = function (percentage) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_ProgressBar2.default, { percentage: percentage || 5, show: true })
	      );
	    };
	
	    _this.state = {
	      text: '',
	      selectedEmails: [],
	      hasInvalidEmail: true
	    };
	    return _this;
	  }
	
	  EmailPartPopup.prototype.componentDidMount = function componentDidMount() {
	    this.props.dispatch(docketActions.loadFavoriteEmails());
	    this.props.dispatch(docketActions.loadLastFavoriteEmails());
	  };
	
	  EmailPartPopup.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snapshot) {
	    if (this.props.favoriteEmails.lastRecipients !== prevProps.favoriteEmails.lastRecipients) {
	      this.setState({
	        selectedEmails: this.props.favoriteEmails.lastRecipients.map(function (email) {
	          return { value: email, label: email };
	        }),
	        hasInvalidEmail: this.props.favoriteEmails.lastRecipients.length <= 0
	      });
	    }
	  };
	
	  EmailPartPopup.prototype.render = function render() {
	    var isLoading = this.props.favoriteEmails.status === 'loading';
	    var options = this.props.favoriteEmails.emails.map(function (email) {
	      return { value: email, label: email };
	    });
	    var hasInvalidEmail = this.state.hasInvalidEmail;
	
	
	    return _react2.default.createElement(
	      _Popup2.default,
	      { show: this.props.popup.show,
	        clsName: 'email-popup',
	        topBarTitle: 'Email Combined PDFs',
	        onClose: this.props.onClose },
	      _react2.default.createElement(
	        'div',
	        { className: 'inner-text' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'email' },
	              'Emails'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_reactSelect.Creatable, {
	              name: 'email',
	              style: selectStyle,
	              isLoading: isLoading,
	              multi: true,
	              options: options,
	              value: this.state.selectedEmails,
	              onChange: this.handleChange
	            }),
	            hasInvalidEmail && hasInvalidEmail.length && _react2.default.createElement(
	              'span',
	              { className: 'error' },
	              'Please enter a valid email'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'email' },
	              'Message (optional)'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('textarea', { name: 'message',
	              rows: '5',
	              cols: '50',
	              onChange: this.handleTextChange,
	              value: this.state.text })
	          )
	        ),
	        isLoading && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('img', { src: _loadingSpinner2.default })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'ui-dialog-buttonpane ui-widget-content ui-helper-clearfix' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ui-dialog-buttonset' },
	          _react2.default.createElement(
	            'button',
	            { type: 'button', onClick: this.props.onClose },
	            'Cancel'
	          ),
	          _react2.default.createElement(
	            'button',
	            { type: 'button', onClick: this.onSubmit, disabled: hasInvalidEmail },
	            'Send'
	          )
	        )
	      )
	    );
	  };
	
	  return EmailPartPopup;
	}(_react.Component);
	
	EmailPartPopup.propTypes = {
	  onClose: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  favoriteEmails: _propTypes2.default.object.isRequired,
	  popup: _propTypes2.default.object.isRequired,
	  reloadDetails: _propTypes2.default.func.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$get$toJS = state.get('dockets').toJS(),
	      popup = _state$get$toJS.popup,
	      favoriteEmails = _state$get$toJS.favoriteEmails;
	
	  return {
	    popup: popup,
	    favoriteEmails: favoriteEmails
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EmailPartPopup);

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _Popup = __webpack_require__(69);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _docketActions = __webpack_require__(42);
	
	var docketActions = _interopRequireWildcard(_docketActions);
	
	var _clientCodeAction = __webpack_require__(64);
	
	var _DocketDetailsPurchaseForm = __webpack_require__(109);
	
	var _DocketDetailsPurchaseForm2 = _interopRequireDefault(_DocketDetailsPurchaseForm);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DownloadCombineAllPdfInRangePopup = function (_Component) {
	  _inherits(DownloadCombineAllPdfInRangePopup, _Component);
	
	  function DownloadCombineAllPdfInRangePopup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DownloadCombineAllPdfInRangePopup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.buy = function () {
	      if (_this.props.dispatch((0, _clientCodeAction.hasValidClientCode)())) {
	        _this.props.dispatch(docketActions.buyAllParts(_this.props.popup.data)).then(function () {
	          return _this.downloadPdfCombined();
	        });
	      } else {
	        _this.props.onClose();
	      }
	    }, _this.downloadPdfCombined = function () {
	      _this.props.dispatch(docketActions.downloadPdfCombined(_this.props.popup.data));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  DownloadCombineAllPdfInRangePopup.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (!prevProps.docketParts.alreadyPurchased && this.props.docketParts.alreadyPurchased) {
	      this.downloadPdfCombined();
	    }
	  };
	
	  DownloadCombineAllPdfInRangePopup.prototype.render = function render() {
	    var _props = this.props,
	        popup = _props.popup,
	        onClose = _props.onClose,
	        docketParts = _props.docketParts;
	
	
	    return _react2.default.createElement(
	      _Popup2.default,
	      { show: popup.show, clsName: 'docket-pdf-zip-popup', topBarTitle: 'Print Multiple Dockets', onClose: onClose },
	      _react2.default.createElement(_DocketDetailsPurchaseForm2.default, { showXfaWarning: true, docketParts: docketParts, buy: this.buy })
	    );
	  };
	
	  return DownloadCombineAllPdfInRangePopup;
	}(_react.Component);
	
	DownloadCombineAllPdfInRangePopup.propTypes = {
	  onClose: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  docketParts: _propTypes2.default.object.isRequired,
	  popup: _propTypes2.default.object.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$get$toJS = state.get('dockets').toJS(),
	      popup = _state$get$toJS.popup,
	      docketParts = _state$get$toJS.docketParts,
	      favoriteEmail = _state$get$toJS.favoriteEmail;
	
	  return {
	    popup: popup,
	    docketParts: docketParts,
	    favoriteEmail: favoriteEmail
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DownloadCombineAllPdfInRangePopup);

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _AlertError = __webpack_require__(50);
	
	var _AlertError2 = _interopRequireDefault(_AlertError);
	
	var _Popup = __webpack_require__(69);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _errorActionTypes = __webpack_require__(101);
	
	var types = _interopRequireWildcard(_errorActionTypes);
	
	__webpack_require__(2177);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PopupError = function (_Component) {
	  _inherits(PopupError, _Component);
	
	  function PopupError() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PopupError);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onClose = function () {
	      _this.props.dispatch({
	        type: types.RESET_VALIDATION_ERROR
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  PopupError.prototype.render = function render() {
	    if (this.props.popupErrors) {
	      return _react2.default.createElement(
	        _Popup2.default,
	        { show: true,
	          clsName: 'alias-error',
	          topBarTitle: 'Reminder!',
	          onClose: this.onClose },
	        _react2.default.createElement(
	          'div',
	          { className: 'error-text' },
	          this.props.popupErrors.messages
	        )
	      );
	    }
	    if (this.props.alertErrors) {
	      return _react2.default.createElement(_AlertError2.default, { errors: this.props.errors });
	    }
	    return null;
	  };
	
	  return PopupError;
	}(_react.Component);
	
	PopupError.defaultProps = {
	  errors: null,
	  popupErrors: null,
	  alertErrors: null
	};
	
	PopupError.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  errors: _propTypes2.default.any,
	  popupErrors: _propTypes2.default.any,
	  alertErrors: _propTypes2.default.any
	};
	
	function mapStateToProps(state) {
	  return {
	    popupErrors: state.get('validationErrors') ? state.get('validationErrors').toJS() : null,
	    alertErrors: state.get('searchErrors') ? state.get('searchErrors').toJS() : null
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(PopupError);

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SET_RECEIPT = exports.UPDATE_DOCUMENT = exports.UPDATE_SELECTED_DOCKET = exports.UPDATE_DOCKETS = exports.UPDATE_REDACT = exports.UPDATE_DOCKET_DETAILS = exports.UPDATE_DOCKET_HEADER = exports.DOCKETS_FAVORITE_EMAILS = exports.DOCKETS_FAVORITE_EMAIL = exports.RESET_DOCKETS_PARTS = exports.UPDATE_DOCKETS_PARTS = exports.DOCKETS_POPUP = exports.FETCH_DOCUMENTS = undefined;
	
	var _utils = __webpack_require__(33);
	
	var FETCH_DOCUMENTS = exports.FETCH_DOCUMENTS = (0, _utils.createAsyncTypes)('FETCH_DOCUMENTS');
	var DOCKETS_POPUP = exports.DOCKETS_POPUP = 'DOCKETS_POPUP';
	var UPDATE_DOCKETS_PARTS = exports.UPDATE_DOCKETS_PARTS = 'UPDATE_DOCKETS_PARTS';
	var RESET_DOCKETS_PARTS = exports.RESET_DOCKETS_PARTS = 'RESET_DOCKETS_PARTS';
	var DOCKETS_FAVORITE_EMAIL = exports.DOCKETS_FAVORITE_EMAIL = 'DOCKETS_FAVORITE_EMAIL';
	var DOCKETS_FAVORITE_EMAILS = exports.DOCKETS_FAVORITE_EMAILS = 'DOCKETS_FAVORITE_EMAILS';
	var UPDATE_DOCKET_HEADER = exports.UPDATE_DOCKET_HEADER = 'UPDATE_DOCKET_HEADER';
	var UPDATE_DOCKET_DETAILS = exports.UPDATE_DOCKET_DETAILS = 'UPDATE_DOCKET_DETAILS';
	var UPDATE_REDACT = exports.UPDATE_REDACT = 'UPDATE_REDACT';
	var UPDATE_DOCKETS = exports.UPDATE_DOCKETS = 'UPDATE_DOCKETS';
	var UPDATE_SELECTED_DOCKET = exports.UPDATE_SELECTED_DOCKET = 'UPDATE_SELECTED_DOCKET';
	var UPDATE_DOCUMENT = exports.UPDATE_DOCUMENT = 'UPDATE_DOCUMENT';
	var SET_RECEIPT = exports.SET_RECEIPT = 'SET_RECEIPT';

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getAlert = exports.editAlert = exports.createAlert = exports.setFormFilter = exports.getPetitionPdf = exports.getDocketDocuments = exports.resetAdvancedSearch = exports.searchAdvancedFilings = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.parseQueryStringToObject = parseQueryStringToObject;
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _lodash = __webpack_require__(4);
	
	var _qs = __webpack_require__(1908);
	
	var _moment = __webpack_require__(32);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _url = __webpack_require__(180);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _advancedSearchActionTypes = __webpack_require__(712);
	
	var actionTypes = _interopRequireWildcard(_advancedSearchActionTypes);
	
	var _dateFormat = __webpack_require__(94);
	
	var _dateFormat2 = _interopRequireDefault(_dateFormat);
	
	var _Notification = __webpack_require__(24);
	
	var _docketActions = __webpack_require__(42);
	
	var docketActions = _interopRequireWildcard(_docketActions);
	
	var _docketsActionTypes = __webpack_require__(177);
	
	var docketActionTypes = _interopRequireWildcard(_docketsActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function parseQueryStringToObject(searchParams) {
	  var _parse = (0, _qs.parse)(searchParams, { ignoreQueryPrefix: true }),
	      business_only = _parse.business_only,
	      obj = _objectWithoutProperties(_parse, ['business_only']);
	
	  return _extends({}, obj, obj.page && { page: JSON.parse(obj.page) || 0 }, obj.grouped && { grouped: !!JSON.parse(obj.grouped) }, obj.do_search && { do_search: !!JSON.parse(obj.do_search) }, business_only && {
	    // eslint-disable-next-line no-nested-ternary
	    business_cases: ['0', '1'].includes(business_only) ? JSON.parse(business_only) ? 'limit' : 'include' : business_only
	  }, obj.search_pdfs && {
	    search_pdfs: ['include', 'limit', 'exclude'].includes(obj.search_pdfs) ? obj.search_pdfs : 'include'
	  }, obj.case_titles && {
	    case_titles: ['include', 'limit', 'exclude'].includes(obj.case_titles) ? obj.case_titles : 'include'
	  }, obj.party_name && {
	    party_name: ['include', 'limit', 'exclude'].includes(obj.party_name) ? obj.party_name : 'include'
	  });
	}
	
	var stringifyParams = function stringifyParams(payload) {
	  var tab = payload.tab,
	      court_type = payload.court_type,
	      values = _objectWithoutProperties(payload, ['tab', 'court_type']);
	
	  var params = _extends({}, values, {
	    court_type: court_type === 'all' ? '' : court_type
	  });
	
	  function filterQueryString(prefix, value) {
	    // format Dates
	    if ((prefix.includes('date_') || prefix.includes('open_cases_')) && value) {
	      return _moment2.default.isMoment(value) ? (0, _dateFormat2.default)(value) : value;
	    }
	
	    return value;
	  }
	
	  return (0, _qs.stringify)(params, {
	    arrayFormat: 'brackets',
	    encodeValuesOnly: true,
	    skipNulls: true,
	    filter: filterQueryString
	  });
	};
	
	var updateURLSearchParams = function updateURLSearchParams(payload) {
	  return function (dispatch) {
	    dispatch({
	      type: actionTypes.ADVANCED_SEARCH_URL_PARAMS_UPDATE,
	      payload: payload
	    });
	  };
	};
	
	var getPartsPurchaseInfo = function getPartsPurchaseInfo(params) {
	  return function (dispatch, getState) {
	    function onSuccess(response) {
	      var _getState$get$toJS = getState().get('advancedSearch').toJS(),
	          data = _getState$get$toJS.data;
	
	      var updatedAdvancedSearchResultsData = data.results.map(function (docket) {
	        var updatedDocket = docket;
	
	        if (params.case_docket_sequence_numbers[0].sequence_numbers.includes(docket.docket_seq)) {
	          updatedDocket = _extends({}, docket, { colorCode: 'in-pacer' });
	
	          var docket_seq = docket.docket_seq;
	
	          var responseEntry = (0, _lodash.find)(response.body, { sequence_number: docket_seq });
	
	          if (responseEntry) {
	            if (responseEntry.has_user_purchased_any_document) {
	              updatedDocket = _extends({}, docket, { colorCode: 'purchased' });
	            } else {
	              updatedDocket = _extends({}, docket, { colorCode: 'in-inforuptcy' });
	            }
	          }
	        }
	        return updatedDocket;
	      });
	
	      dispatch({
	        type: actionTypes.ADVANCED_SEARCH_ALL_GENERAL.SUCCESS,
	        data: _extends({}, data, { results: updatedAdvancedSearchResultsData })
	      });
	
	      return Promise.resolve(response.body);
	    }
	
	    return _superagent2.default.post('/rpc/dockets/purchase_info').set('Accept', 'application/json').send(params).then(onSuccess).catch(function (error) {
	      dispatch({
	        type: actionTypes.ADVANCED_SEARCH_ALL_GENERAL.ERROR,
	        error: error
	      });
	      _Notification.notify.error('Failed to update Docket\'s purchase status');
	    });
	  };
	};
	
	var searchAdvancedFilings = exports.searchAdvancedFilings = function searchAdvancedFilings(payload) {
	  return function (dispatch, getState) {
	    var filterParams = _extends({}, payload, { do_search: true });
	    var params = stringifyParams(filterParams);
	
	    dispatch({
	      type: actionTypes.ADVANCED_SEARCH_ALL_GENERAL.REQUEST,
	      payload: filterParams
	    });
	
	    dispatch({
	      type: docketActionTypes.UPDATE_SELECTED_DOCKET,
	      selectedDocket: {
	        status: 'done',
	        docket_no: null,
	        docket_seq: null,
	        binder: {}
	      }
	    });
	
	    // Reset Dockets store
	    dispatch({
	      type: docketActionTypes.UPDATE_DOCKETS,
	      entries: { status: '', data: [] }
	    });
	
	    var onSuccess = function onSuccess(response) {
	      dispatch({
	        type: actionTypes.ADVANCED_SEARCH_ALL_GENERAL.SUCCESS,
	        data: response || {}
	      });
	
	      dispatch(updateURLSearchParams(params));
	
	      if (response.results && response.results.length > 0) {
	        var seqNumbers = response.results.reduce(function (accum, next) {
	          if (next.docket_seq) {
	            accum.push(next.docket_seq);
	          }
	          return accum;
	        }, []);
	
	        if (seqNumbers.length > 0) {
	          var purchaseInfoParams = {
	            case_docket_sequence_numbers: [{
	              court_code: response.results[0].case_court,
	              case_number: response.results[0].case_no,
	              sequence_numbers: seqNumbers
	            }]
	          };
	
	          getPartsPurchaseInfo(purchaseInfoParams)(dispatch, getState);
	        }
	      }
	    };
	
	    var onError = function onError(error) {
	      dispatch({
	        type: actionTypes.ADVANCED_SEARCH_ALL_GENERAL.ERROR,
	        error: error,
	        payload: payload
	      });
	      // TODO: add 'When contacting support, please quote Request ID:' + error.request_id
	      _Notification.notify.error('Failed to return Advanced Search results');
	    };
	
	    return _superagent2.default.get((0, _url2.default)('/rpc/capi/cases/pacer/search-filings')).set('Accept', 'application/json').query(params).then(function (_ref) {
	      var body = _ref.body;
	      return body && !body.error ? onSuccess(body) : onError(body && body.error);
	    }).catch(function (error) {
	      return onError(error);
	    });
	  };
	};
	
	var resetAdvancedSearch = exports.resetAdvancedSearch = function resetAdvancedSearch() {
	  return function (dispatch) {
	    dispatch(updateURLSearchParams(''));
	
	    dispatch({
	      type: actionTypes.ADVANCED_SEARCH_RESET
	    });
	  };
	};
	
	var getDocketDocuments = function getDocketDocuments(payload) {
	  return function (dispatch, getState) {
	    var docket = payload.docket,
	        id = payload.id,
	        params = _objectWithoutProperties(payload, ['docket', 'id']);
	
	    var entries = getState().getIn(['dockets', 'entries']).toJS();
	
	    // Save previous Docket in AdvSearch store
	    if (entries && entries.data && entries.data.length === 1 && entries.data[0].id) {
	      dispatch({
	        type: actionTypes.ADVANCED_SEARCH_RESULT_DOCKET_UPDATE,
	        payload: { docket: _extends({}, entries.data[0], { isExpanded: false }) }
	      });
	    }
	
	    // Set current Docket in store
	    dispatch({
	      type: docketActionTypes.UPDATE_DOCKETS,
	      entries: { status: 'done', data: [_extends({}, docket, { id: id })] }
	    });
	
	    dispatch(docketActions.getDocuments(params));
	  };
	};
	
	exports.getDocketDocuments = getDocketDocuments;
	var getPetitionPdf = exports.getPetitionPdf = function getPetitionPdf(params) {
	  return function (dispatch) {
	    var case_no = params.case_no,
	        court_code = params.court_code;
	
	
	    dispatch({
	      type: actionTypes.ADVANCED_SEARCH_DOCUMENT_FETCH.REQUEST
	    });
	
	    function onSuccess(body) {
	      var document = body.document;
	
	
	      dispatch({
	        type: actionTypes.ADVANCED_SEARCH_DOCUMENT_FETCH.SUCCESS
	      });
	
	      if (document.preview_url) {
	        window.open(document.preview_url);
	      } else {
	        _Notification.notify.error('Failed to open Document');
	      }
	    }
	
	    var onError = function onError(error) {
	      dispatch({
	        type: actionTypes.ADVANCED_SEARCH_DOCUMENT_FETCH.ERROR,
	        error: error
	      });
	
	      _Notification.notify.error('Failed to fetch Document');
	    };
	
	    return _superagent2.default.get('/rpc/capi/cases/pacer/' + court_code + '/' + case_no + '/dockets/1/documents/1').set('Accept', 'application/json').then(function (_ref2) {
	      var body = _ref2.body;
	      return body && !body.error ? onSuccess(body) : onError(body && body.error);
	    }).catch(function (error) {
	      return onError(error);
	    });
	  };
	};
	
	var setFormFilter = exports.setFormFilter = function setFormFilter(payload) {
	  return function (dispatch, getState) {
	    dispatch({
	      type: actionTypes.ADVANCED_SEARCH_FORM_FILTER_SET,
	      payload: payload
	    });
	
	    var state = getState().get('advancedSearch').toJS();
	
	    if (payload.queryParams && payload.queryParams.do_search && !state.showResults) {
	      dispatch(searchAdvancedFilings(state.filter));
	    }
	  };
	};
	
	var createAlert = function createAlert(formAlert, advancedSearchFilter) {
	  return function (dispatch) {
	    dispatch({
	      type: actionTypes.ADVANCED_SEARCH_ALERT.REQUEST,
	      data: formAlert
	    });
	
	    var do_search = advancedSearchFilter.do_search,
	        grouped = advancedSearchFilter.grouped,
	        page = advancedSearchFilter.page,
	        limitedAdvancedSearchFilter = _objectWithoutProperties(advancedSearchFilter, ['do_search', 'grouped', 'page']);
	
	    var queryParams = stringifyParams(limitedAdvancedSearchFilter);
	
	    var onSuccess = function onSuccess(alert) {
	      dispatch({
	        type: actionTypes.ADVANCED_SEARCH_ALERT.SUCCESS,
	        data: alert
	      });
	      _Notification.notify.success('Alert ' + alert.name + ' created successfully');
	    };
	
	    var onError = function onError(error) {
	      dispatch({
	        type: actionTypes.ADVANCED_SEARCH_ALERT.ERROR,
	        error: error
	      });
	
	      _Notification.notify.error('Failed to create alert ' + formAlert.name);
	    };
	
	    var alertType = !advancedSearchFilter.template || ['general', ''].includes(advancedSearchFilter.template) ? 'premium' : advancedSearchFilter.template;
	
	    _superagent2.default.post((0, _url2.default)('/search-alerts/json/add/' + alertType)).send(_extends({}, formAlert, { query: queryParams })).then(function (_ref3) {
	      var body = _ref3.body;
	
	      onSuccess(body.alert);
	    }).catch(function (error) {
	      onError(error);
	    });
	  };
	};
	
	exports.createAlert = createAlert;
	var editAlert = function editAlert(alert, advancedSearchFilter) {
	  return function (dispatch) {
	    dispatch({
	      type: actionTypes.ADVANCED_SEARCH_ALERT.REQUEST,
	      data: alert
	    });
	
	    var do_search = advancedSearchFilter.do_search,
	        grouped = advancedSearchFilter.grouped,
	        page = advancedSearchFilter.page,
	        limitedAdvancedSearchFilter = _objectWithoutProperties(advancedSearchFilter, ['do_search', 'grouped', 'page']);
	
	    var queryParams = stringifyParams(limitedAdvancedSearchFilter);
	
	    var onSuccess = function onSuccess() {
	      dispatch({
	        type: actionTypes.ADVANCED_SEARCH_ALERT.SUCCESS,
	        data: alert
	      });
	      _Notification.notify.success('Alert ' + alert.name + ' edited successfully');
	    };
	
	    var onError = function onError(error) {
	      dispatch({
	        type: actionTypes.ADVANCED_SEARCH_ALERT.ERROR,
	        error: error
	      });
	      _Notification.notify.error('Failed to edit alert ' + alert.name);
	    };
	
	    _superagent2.default.post((0, _url2.default)('/search-alerts/json/edit/' + alert.id)).set('X-Csrf-Token', alert.edit_token).send(_extends({}, alert, { query: queryParams })).then(function () {
	      onSuccess();
	    }).catch(function (error) {
	      onError(error);
	    });
	  };
	};
	
	exports.editAlert = editAlert;
	var getAlert = exports.getAlert = function getAlert(alertId) {
	  return function (dispatch) {
	    dispatch({ type: actionTypes.ADVANCED_SEARCH_ALERT.REQUEST });
	
	    var onSuccess = function onSuccess(alert) {
	      dispatch({
	        type: actionTypes.ADVANCED_SEARCH_ALERT.SUCCESS,
	        data: alert
	      });
	    };
	
	    var onError = function onError(error) {
	      dispatch({
	        type: actionTypes.ADVANCED_SEARCH_ALERT.ERROR,
	        error: error
	      });
	
	      _Notification.notify.error('Failed to retrieve alert');
	    };
	
	    _superagent2.default.get((0, _url2.default)('/search-alerts/json/get/' + alertId)).then(function (_ref4) {
	      var body = _ref4.body;
	      return onSuccess(body);
	    }).catch(function (error) {
	      return onError(error);
	    });
	  };
	};

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = ScheduleVerifyToolbar;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _usePostApi2 = __webpack_require__(139);
	
	var _usePostApi3 = _interopRequireDefault(_usePostApi2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ScheduleVerifyToolbar(_ref) {
	  var schedule = _ref.schedule;
	
	  // don't show anything if nothing to verify
	  if (!schedule.pdf_link && !schedule.data) return null;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'well', key: schedule.modified },
	    schedule.pdf_link && _react2.default.createElement(VerifiedToolItem, { schedule: schedule, type: 'pdf' }),
	    _react2.default.createElement('span', { style: { marginLeft: 32 } }),
	    schedule.data && _react2.default.createElement(VerifiedToolItem, { schedule: schedule, type: 'data' })
	  );
	}
	
	function VerifiedToolItem(_ref2) {
	  var schedule = _ref2.schedule,
	      type = _ref2.type;
	
	  var _usePostApi = (0, _usePostApi3.default)('/scheduleform/set-verified'),
	      _usePostApi$ = _usePostApi[0],
	      data = _usePostApi$.data,
	      isLoading = _usePostApi$.isLoading,
	      isError = _usePostApi$.isError,
	      updateVerifiedStatus = _usePostApi[1];
	
	  var setting_name = 'is_' + type + '_verified';
	
	  var _useState = (0, _react.useState)(schedule[setting_name]),
	      isVerified = _useState[0],
	      setIsVerified = _useState[1];
	
	  function toggleVerified() {
	    console.log('Setting ' + schedule.case_uuid + ' ' + schedule.schedule_type + ' ' + setting_name + ' to ' + (!isVerified ? 'true' : 'false'));
	    updateVerifiedStatus({
	      case_uuid: schedule.case_uuid,
	      type: schedule.schedule_type,
	      verified_field: setting_name,
	      value: !isVerified
	    });
	  }
	
	  (0, _react.useEffect)(function () {
	    if (!data) return;
	    console.log('Got new schedule form data', data);
	    setIsVerified(!isVerified);
	    refresh_menu(schedule.case_uuid);
	  }, [data]);
	
	  (0, _react.useEffect)(function () {
	    if (!isError) return;
	    var message = 'Error setting ' + schedule.case_uuid + ' ' + schedule.schedule_type + ' ' + setting_name + ' to ' + (!isVerified ? 'Yes' : 'No');
	    console.error(message, isError);
	    alert(message + '\n' + isError);
	  }, [isError]);
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'span',
	      { style: { fontSize: 18, verticalAlign: 'middle' } },
	      type.toUpperCase(),
	      ' Verified',
	      ' ',
	      _react2.default.createElement(
	        'span',
	        { style: { color: isVerified ? 'green' : 'red', fontWeight: 'bold' } },
	        isVerified ? 'Yes' : 'No'
	      ),
	      ' '
	    ),
	    _react2.default.createElement(
	      'button',
	      {
	        className: 'btn btn-' + (isVerified ? 'secondary' : 'success'),
	        onClick: toggleVerified,
	        disabled: isLoading
	      },
	      isLoading ? 'Marking ...' : isVerified ? 'Mark Unverified' : 'Mark Verified'
	    )
	  );
	}

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (url) {
	  return  false ? 'http://localhost' + url : url;
	};

/***/ },
/* 181 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 182 */
[2287, 768, 435],
/* 183 */
[2257, 84, 36],
/* 184 */
181,
/* 185 */
[2295, 41, 74, 36],
/* 186 */
[2300, 3, 97, 27, 474],
/* 187 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(35);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(123));
	
	var _default = function () {
	  // HTML DOM and SVG DOM may have different support levels,
	  // so we need to check on context instead of a document root element.
	  return _inDOM.default ? function (context, node) {
	    if (context.contains) {
	      return context.contains(node);
	    } else if (context.compareDocumentPosition) {
	      return context === node || !!(context.compareDocumentPosition(node) & 16);
	    } else {
	      return fallback(context, node);
	    }
	  } : fallback;
	}();
	
	exports.default = _default;
	
	function fallback(context, node) {
	  if (node) do {
	    if (node === context) return true;
	  } while (node = node.parentNode);
	  return false;
	}
	
	module.exports = exports["default"];

/***/ },
/* 189 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var _extends_1 = createCommonjsModule(function (module) {
	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;
	});
	
	//      
	function moveFieldState(state, source, destKey, oldState) {
	  if (oldState === void 0) {
	    oldState = state;
	  }
	
	  delete state.fields[source.name];
	  state.fields[destKey] = _extends_1({}, source, {
	    name: destKey,
	    // prevent functions from being overwritten
	    // if the state.fields[destKey] does not exist, it will be created
	    // when that field gets registered, with its own change/blur/focus callbacks
	    change: oldState.fields[destKey] && oldState.fields[destKey].change,
	    blur: oldState.fields[destKey] && oldState.fields[destKey].blur,
	    focus: oldState.fields[destKey] && oldState.fields[destKey].focus,
	    lastFieldState: undefined // clearing lastFieldState forces renotification
	
	  });
	
	  if (!state.fields[destKey].change) {
	    delete state.fields[destKey].change;
	  }
	
	  if (!state.fields[destKey].blur) {
	    delete state.fields[destKey].blur;
	  }
	
	  if (!state.fields[destKey].focus) {
	    delete state.fields[destKey].focus;
	  }
	}
	
	//      
	// From MDN: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
	var escapeRegexTokens = function escapeRegexTokens(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}; // $& means the whole matched string
	
	var insert = function insert(_ref, state, _ref2) {
	  var name = _ref[0],
	      index = _ref[1],
	      value = _ref[2];
	  var changeValue = _ref2.changeValue,
	      resetFieldState = _ref2.resetFieldState;
	  changeValue(state, name, function (array) {
	    var copy = [].concat(array || []);
	    copy.splice(index, 0, value);
	    return copy;
	  });
	
	  var backup = _extends_1({}, state.fields); // now we have increment any higher indexes
	
	
	  var pattern = new RegExp("^" + escapeRegexTokens(name) + "\\[(\\d+)\\](.*)"); // we need to increment high indices first so
	  // lower indices won't overlap
	
	  Object.keys(state.fields).sort().reverse().forEach(function (key) {
	    var tokens = pattern.exec(key);
	
	    if (tokens) {
	      var fieldIndex = Number(tokens[1]);
	
	      if (fieldIndex >= index) {
	        // inc index one higher
	        var incrementedKey = name + "[" + (fieldIndex + 1) + "]" + tokens[2];
	        moveFieldState(state, backup[key], incrementedKey);
	      }
	    }
	  });
	};
	
	//      
	var concat = function concat(_ref, state, _ref2) {
	  var name = _ref[0],
	      value = _ref[1];
	  var changeValue = _ref2.changeValue;
	  changeValue(state, name, function (array) {
	    return array ? [].concat(array, value) : value;
	  });
	};
	
	//      
	
	function moveFields(name, matchPrefix, destIndex, state) {
	  Object.keys(state.fields).forEach(function (key) {
	    if (key.substring(0, matchPrefix.length) === matchPrefix) {
	      var suffix = key.substring(matchPrefix.length);
	      var destKey = name + "[" + destIndex + "]" + suffix;
	      moveFieldState(state, state.fields[key], destKey);
	    }
	  });
	}
	
	//      
	function restoreFunctions(state, backupState) {
	  Object.keys(state.fields).forEach(function (key) {
	    state.fields[key] = _extends_1({}, state.fields[key], {
	      change: state.fields[key].change || backupState.fields[key] && backupState.fields[key].change,
	      blur: state.fields[key].blur || backupState.fields[key] && backupState.fields[key].blur,
	      focus: state.fields[key].focus || backupState.fields[key] && backupState.fields[key].focus
	    });
	
	    if (!state.fields[key].change) {
	      delete state.fields[key].change;
	    }
	
	    if (!state.fields[key].blur) {
	      delete state.fields[key].blur;
	    }
	
	    if (!state.fields[key].focus) {
	      delete state.fields[key].focus;
	    }
	  });
	}
	
	var TMP = 'tmp';
	
	var move = function move(_ref, state, _ref2) {
	  var name = _ref[0],
	      from = _ref[1],
	      to = _ref[2];
	  var changeValue = _ref2.changeValue;
	
	  if (from === to) {
	    return;
	  }
	
	  changeValue(state, name, function (array) {
	    var copy = [].concat(array || []);
	    var value = copy[from];
	    copy.splice(from, 1);
	    copy.splice(to, 0, value);
	    return copy;
	  }); //make a copy of a state for further functions restore
	
	  var backupState = _extends_1({}, state, {
	    fields: _extends_1({}, state.fields) // move this row to tmp index
	
	  });
	
	  var fromPrefix = name + "[" + from + "]";
	  moveFields(name, fromPrefix, TMP, state);
	
	  if (from < to) {
	    // moving to a higher index
	    // decrement all indices between from and to
	    for (var i = from + 1; i <= to; i++) {
	      var innerFromPrefix = name + "[" + i + "]";
	      moveFields(name, innerFromPrefix, "" + (i - 1), state);
	    }
	  } else {
	    // moving to a lower index
	    // increment all indices between to and from
	    for (var _i = from - 1; _i >= to; _i--) {
	      var _innerFromPrefix = name + "[" + _i + "]";
	
	      moveFields(name, _innerFromPrefix, "" + (_i + 1), state);
	    }
	  } // move from tmp index to destination
	
	
	  var tmpPrefix = name + "[" + TMP + "]";
	  moveFields(name, tmpPrefix, to, state);
	  restoreFunctions(state, backupState);
	};
	
	//      
	
	var pop = function pop(_ref, state, _ref2) {
	  var name = _ref[0];
	  var changeValue = _ref2.changeValue;
	  var result;
	  var removedIndex;
	  changeValue(state, name, function (array) {
	    if (array) {
	      if (!array.length) {
	        return [];
	      }
	
	      removedIndex = array.length - 1;
	      result = array[removedIndex];
	      return array.slice(0, removedIndex);
	    }
	  }); // now we have to remove any subfields for our index,
	
	  if (removedIndex !== undefined) {
	    var pattern = new RegExp("^" + escapeRegexTokens(name) + "\\[" + removedIndex + "].*");
	    Object.keys(state.fields).forEach(function (key) {
	      if (pattern.test(key)) {
	        delete state.fields[key];
	      }
	    });
	  }
	
	  return result;
	};
	
	//      
	var push = function push(_ref, state, _ref2) {
	  var name = _ref[0],
	      value = _ref[1];
	  var changeValue = _ref2.changeValue;
	  changeValue(state, name, function (array) {
	    return array ? [].concat(array, [value]) : [value];
	  });
	};
	
	var remove = function remove(_ref, state, _ref2) {
	  var name = _ref[0],
	      index = _ref[1];
	  var changeValue = _ref2.changeValue,
	      renameField = _ref2.renameField;
	  var returnValue;
	  changeValue(state, name, function (array) {
	    var copy = [].concat(array || []);
	    returnValue = copy[index];
	    copy.splice(index, 1);
	    return copy;
	  }); // now we have to remove any subfields for our index,
	  // and decrement all higher indexes.
	
	  var pattern = new RegExp("^" + escapeRegexTokens(name) + "\\[(\\d+)\\](.*)");
	
	  var backup = _extends_1({}, state, {
	    fields: _extends_1({}, state.fields)
	  });
	
	  Object.keys(state.fields).forEach(function (key) {
	    var tokens = pattern.exec(key);
	
	    if (tokens) {
	      var fieldIndex = Number(tokens[1]);
	
	      if (fieldIndex === index) {
	        // delete any subfields for this array item
	        delete state.fields[key];
	      } else if (fieldIndex > index) {
	        // shift all higher ones down
	        delete state.fields[key];
	        var decrementedKey = name + "[" + (fieldIndex - 1) + "]" + tokens[2];
	
	        if (backup.fields[decrementedKey]) {
	          moveFieldState(state, backup.fields[key], decrementedKey, backup);
	        } else {
	          // take care of setting the correct change, blur, focus, validators on new field
	          renameField(state, key, decrementedKey);
	        }
	      }
	    }
	  });
	  return returnValue;
	};
	
	var countBelow = function countBelow(array, value) {
	  return array.reduce(function (count, item) {
	    return item < value ? count + 1 : count;
	  }, 0);
	};
	
	var removeBatch = function removeBatch(_ref, state, _ref2) {
	  var name = _ref[0],
	      indexes = _ref[1];
	  var changeValue = _ref2.changeValue;
	  var sortedIndexes = [].concat(indexes);
	  sortedIndexes.sort(); // remove duplicates
	
	  for (var i = 0; i < sortedIndexes.length; i++) {
	    if (i > 0 && sortedIndexes[i] === sortedIndexes[i - 1]) {
	      sortedIndexes.splice(i--, 1);
	    }
	  }
	
	  var returnValue = [];
	  changeValue(state, name, function (array) {
	    // use original order of indexes for return value
	    returnValue = indexes.map(function (index) {
	      return array && array[index];
	    });
	
	    if (!array || !sortedIndexes.length) {
	      return array;
	    }
	
	    var copy = [].concat(array);
	    var removed = [];
	    sortedIndexes.forEach(function (index) {
	      copy.splice(index - removed.length, 1);
	      removed.push(array && array[index]);
	    });
	    return copy;
	  }); // now we have to remove any subfields for our indexes,
	  // and decrement all higher indexes.
	
	  var pattern = new RegExp("^" + escapeRegexTokens(name) + "\\[(\\d+)\\](.*)");
	
	  var newState = _extends_1({}, state, {
	    fields: {}
	  });
	
	  Object.keys(state.fields).forEach(function (key) {
	    var tokens = pattern.exec(key);
	
	    if (tokens) {
	      var fieldIndex = Number(tokens[1]);
	
	      if (!~sortedIndexes.indexOf(fieldIndex)) {
	        // not one of the removed indexes
	        // shift all higher ones down
	        var decrementedKey = name + "[" + (fieldIndex - countBelow(sortedIndexes, fieldIndex)) + "]" + tokens[2];
	        moveFieldState(newState, state.fields[key], decrementedKey, state);
	      }
	    } else {
	      newState.fields[key] = state.fields[key];
	    }
	  });
	  state.fields = newState.fields;
	  return returnValue;
	};
	
	//      
	
	var shift = function shift(_ref, state, tools) {
	  var name = _ref[0];
	  return remove([name, 0], state, tools);
	};
	
	var TMP$1 = 'tmp';
	
	var swap = function swap(_ref, state, _ref2) {
	  var name = _ref[0],
	      indexA = _ref[1],
	      indexB = _ref[2];
	  var changeValue = _ref2.changeValue;
	
	  if (indexA === indexB) {
	    return;
	  }
	
	  changeValue(state, name, function (array) {
	    var copy = [].concat(array || []);
	    var a = copy[indexA];
	    copy[indexA] = copy[indexB];
	    copy[indexB] = a;
	    return copy;
	  }); //make a copy of a state for further functions restore
	
	  var backupState = _extends_1({}, state, {
	    fields: _extends_1({}, state.fields) // swap all field state that begin with "name[indexA]" with that under "name[indexB]"
	
	  });
	
	  var aPrefix = name + "[" + indexA + "]";
	  var bPrefix = name + "[" + indexB + "]";
	  var tmpPrefix = name + "[" + TMP$1 + "]";
	  moveFields(name, aPrefix, TMP$1, state);
	  moveFields(name, bPrefix, indexA, state);
	  moveFields(name, tmpPrefix, indexB, state);
	  restoreFunctions(state, backupState);
	};
	
	//      
	
	var unshift = function unshift(_ref, state, tools) {
	  var name = _ref[0],
	      value = _ref[1];
	  return insert([name, 0, value], state, tools);
	};
	
	//      
	var update = function update(_ref, state, _ref2) {
	  var name = _ref[0],
	      index = _ref[1],
	      value = _ref[2];
	  var changeValue = _ref2.changeValue;
	  changeValue(state, name, function (array) {
	    var copy = [].concat(array || []);
	    copy.splice(index, 1, value);
	    return copy;
	  });
	};
	
	//      
	var mutators = {
	  insert: insert,
	  concat: concat,
	  move: move,
	  pop: pop,
	  push: push,
	  remove: remove,
	  removeBatch: removeBatch,
	  shift: shift,
	  swap: swap,
	  unshift: unshift,
	  update: update
	};
	
	exports.default = mutators;


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(1832),
	    getValue = __webpack_require__(1855);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(311),
	    isLength = __webpack_require__(496);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 192 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (componentOrElement) {
	  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
	};
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ownerDocument = __webpack_require__(187);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function() {};
	
	if (__DEV__) {
	  var printWarning = function printWarning(format, args) {
	    var len = arguments.length;
	    args = new Array(len > 1 ? len - 1 : 0);
	    for (var key = 1; key < len; key++) {
	      args[key - 1] = arguments[key];
	    }
	    var argIndex = 0;
	    var message = 'Warning: ' +
	      format.replace(/%s/g, function() {
	        return args[argIndex++];
	      });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  }
	
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	          '`warning(condition, format, ...args)` requires a warning ' +
	          'message argument'
	      );
	    }
	    if (!condition) {
	      printWarning.apply(null, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault(ex) {
	  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var _typeof = _interopDefault(__webpack_require__(165)); // ==============================
	// NO OP
	// ==============================
	
	
	var noop = function noop() {}; // Class Name Prefixer
	// ==============================
	
	/**
	 String representation of component state for styling with class names.
	
	 Expects an array of strings OR a string/object pair:
	 - className(['comp', 'comp-arg', 'comp-arg-2'])
	   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
	 - className('comp', { some: true, state: false })
	   @returns 'react-select__comp react-select__comp--some'
	*/
	
	
	function applyPrefixToName(prefix, name) {
	  if (!name) {
	    return prefix;
	  } else if (name[0] === '-') {
	    return prefix + name;
	  } else {
	    return prefix + '__' + name;
	  }
	}
	
	function classNames(prefix, state, className) {
	  var arr = [className];
	
	  if (state && prefix) {
	    for (var key in state) {
	      if (state.hasOwnProperty(key) && state[key]) {
	        arr.push("".concat(applyPrefixToName(prefix, key)));
	      }
	    }
	  }
	
	  return arr.filter(function (i) {
	    return i;
	  }).map(function (i) {
	    return String(i).trim();
	  }).join(' ');
	} // ==============================
	// Clean Value
	// ==============================
	
	
	var cleanValue = function cleanValue(value) {
	  if (Array.isArray(value)) return value.filter(Boolean);
	  if (_typeof(value) === 'object' && value !== null) return [value];
	  return [];
	}; // ==============================
	// Handle Input Change
	// ==============================
	
	
	function handleInputChange(inputValue, actionMeta, onInputChange) {
	  if (onInputChange) {
	    var newValue = onInputChange(inputValue, actionMeta);
	    if (typeof newValue === 'string') return newValue;
	  }
	
	  return inputValue;
	} // ==============================
	// Scroll Helpers
	// ==============================
	
	
	function isDocumentElement(el) {
	  return [document.documentElement, document.body, window].indexOf(el) > -1;
	} // Normalized Scroll Top
	// ------------------------------
	
	
	function getScrollTop(el) {
	  if (isDocumentElement(el)) {
	    return window.pageYOffset;
	  }
	
	  return el.scrollTop;
	}
	
	function scrollTo(el, top) {
	  // with a scroll distance, we perform scroll on the element
	  if (isDocumentElement(el)) {
	    window.scrollTo(0, top);
	    return;
	  }
	
	  el.scrollTop = top;
	} // Get Scroll Parent
	// ------------------------------
	
	
	function getScrollParent(element) {
	  var style = getComputedStyle(element);
	  var excludeStaticParent = style.position === 'absolute';
	  var overflowRx = /(auto|scroll)/;
	  var docEl = document.documentElement; // suck it, flow...
	
	  if (style.position === 'fixed') return docEl;
	
	  for (var parent = element; parent = parent.parentElement;) {
	    style = getComputedStyle(parent);
	
	    if (excludeStaticParent && style.position === 'static') {
	      continue;
	    }
	
	    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
	      return parent;
	    }
	  }
	
	  return docEl;
	} // Animated Scroll To
	// ------------------------------
	
	/**
	  @param t: time (elapsed)
	  @param b: initial value
	  @param c: amount of change
	  @param d: duration
	*/
	
	
	function easeOutCubic(t, b, c, d) {
	  return c * ((t = t / d - 1) * t * t + 1) + b;
	}
	
	function animatedScrollTo(element, to) {
	  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
	  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
	  var start = getScrollTop(element);
	  var change = to - start;
	  var increment = 10;
	  var currentTime = 0;
	
	  function animateScroll() {
	    currentTime += increment;
	    var val = easeOutCubic(currentTime, start, change, duration);
	    scrollTo(element, val);
	
	    if (currentTime < duration) {
	      window.requestAnimationFrame(animateScroll);
	    } else {
	      callback(element);
	    }
	  }
	
	  animateScroll();
	} // Scroll Into View
	// ------------------------------
	
	
	function scrollIntoView(menuEl, focusedEl) {
	  var menuRect = menuEl.getBoundingClientRect();
	  var focusedRect = focusedEl.getBoundingClientRect();
	  var overScroll = focusedEl.offsetHeight / 3;
	
	  if (focusedRect.bottom + overScroll > menuRect.bottom) {
	    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
	  } else if (focusedRect.top - overScroll < menuRect.top) {
	    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
	  }
	} // ==============================
	// Get bounding client object
	// ==============================
	// cannot get keys using array notation with DOMRect
	
	
	function getBoundingClientObj(element) {
	  var rect = element.getBoundingClientRect();
	  return {
	    bottom: rect.bottom,
	    height: rect.height,
	    left: rect.left,
	    right: rect.right,
	    top: rect.top,
	    width: rect.width
	  };
	} // Touch Capability Detector
	// ==============================
	
	
	function isTouchCapable() {
	  try {
	    document.createEvent('TouchEvent');
	    return true;
	  } catch (e) {
	    return false;
	  }
	} // ==============================
	// Mobile Device Detector
	// ==============================
	
	
	function isMobileDevice() {
	  try {
	    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	  } catch (e) {
	    return false;
	  }
	}
	
	exports.animatedScrollTo = animatedScrollTo;
	exports.classNames = classNames;
	exports.cleanValue = cleanValue;
	exports.getBoundingClientObj = getBoundingClientObj;
	exports.getScrollParent = getScrollParent;
	exports.getScrollTop = getScrollTop;
	exports.handleInputChange = handleInputChange;
	exports.isDocumentElement = isDocumentElement;
	exports.isMobileDevice = isMobileDevice;
	exports.isTouchCapable = isTouchCapable;
	exports.noop = noop;
	exports.scrollIntoView = scrollIntoView;
	exports.scrollTo = scrollTo;


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(128);
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    var ownKeys = Object.keys(source);
	
	    if (typeof Object.getOwnPropertySymbols === 'function') {
	      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
	      }));
	    }
	
	    ownKeys.forEach(function (key) {
	      defineProperty(target, key, source[key]);
	    });
	  }
	
	  return target;
	}
	
	module.exports = _objectSpread;

/***/ },
/* 197 */
[2243, 2107],
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1616);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./Docket.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./Docket.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 199 */
/***/ function(module, exports) {

	module.exports = "data:image/gif;base64,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"

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _reactCollapse = __webpack_require__(1983);
	
	var _dateFormat = __webpack_require__(94);
	
	var _dateFormat2 = _interopRequireDefault(_dateFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DocketHeader(_ref) {
	  var open = _ref.open,
	      data = _ref.data;
	
	  if ((0, _lodash.isEmpty)(data.html)) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    _reactCollapse.UnmountClosed,
	    { isOpened: open },
	    _react2.default.createElement(
	      'div',
	      { id: 'docket-header', className: 'no-filter-search inside-block docket-header', key: 'docket-header' },
	      _react2.default.createElement(
	        'div',
	        { id: 'docket-header-content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'header-timestamp' },
	          'Docket Header Last Updated: ',
	          (0, _dateFormat2.default)(data.modified, 'M/D/YYYY h:mm a')
	        ),
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: data.html } })
	      )
	    )
	  );
	}
	
	DocketHeader.defaultProps = {
	  data: {},
	  // used to identify this specific component when used as React.Child
	  // https://github.com/facebook/react/issues/4915
	  displayName: 'DocketHeader'
	};
	
	DocketHeader.propTypes = {
	  open: _propTypes2.default.bool.isRequired,
	  data: _propTypes2.default.object,
	  // eslint-disable-next-line
	  displayName: _propTypes2.default.string
	};
	
	exports.default = DocketHeader;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _docketActions = __webpack_require__(42);
	
	var docketActions = _interopRequireWildcard(_docketActions);
	
	var _clientCodeAction = __webpack_require__(64);
	
	var _Document = __webpack_require__(391);
	
	var _Document2 = _interopRequireDefault(_Document);
	
	var _AllPartsDocument = __webpack_require__(387);
	
	var _AllPartsDocument2 = _interopRequireDefault(_AllPartsDocument);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Documents = function (_Component) {
	  _inherits(Documents, _Component);
	
	  function Documents() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Documents);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onDownloadZipClick = function () {
	      var _this$props = _this.props,
	          case_uuid = _this$props.case_uuid,
	          court_code = _this$props.court_code,
	          case_number = _this$props.case_number,
	          docket_seq = _this$props.docket_seq;
	
	
	      var documents = createDocumentParam(court_code, case_number, docket_seq);
	
	      var params = {
	        documents: documents
	      };
	
	      _this.props.getDocketParts({ documents: documents });
	
	      _this.props.onPopupClick({
	        name: 'DownloadZipAllPdfsRangePopup',
	        show: true,
	        data: params
	      });
	    }, _this.onDownloadComboPdfClick = function () {
	      var _this$props2 = _this.props,
	          case_uuid = _this$props2.case_uuid,
	          court_code = _this$props2.court_code,
	          case_number = _this$props2.case_number,
	          docket_seq = _this$props2.docket_seq;
	
	
	      var documents = createDocumentParam(court_code, case_number, docket_seq);
	
	      var params = {
	        documents: documents,
	        download_option: 1
	      };
	
	      _this.props.getDocketParts({ documents: documents });
	
	      _this.props.onPopupClick({
	        name: 'DownloadCombineAllPdfInRangePopup',
	        show: true,
	        data: params
	      });
	    }, _this.onDownloadEmailZipClick = function () {
	      var _this$props3 = _this.props,
	          case_uuid = _this$props3.case_uuid,
	          court_code = _this$props3.court_code,
	          case_number = _this$props3.case_number,
	          docket_seq = _this$props3.docket_seq,
	          docket = _this$props3.docket;
	
	
	      var documents = createDocumentParam(court_code, case_number, docket_seq);
	
	      var params = {
	        documents: documents,
	        download_option: 1
	      };
	
	      _this.props.onPopupClick({
	        name: 'EmailAllPartsZipPopup',
	        show: true,
	        data: params
	      });
	    }, _this.onEmailCombinedPdf = function () {
	      var _this$props4 = _this.props,
	          case_uuid = _this$props4.case_uuid,
	          court_code = _this$props4.court_code,
	          case_number = _this$props4.case_number,
	          docket_seq = _this$props4.docket_seq,
	          docket = _this$props4.docket;
	
	
	      var documents = createDocumentParam(court_code, case_number, docket_seq);
	
	      var params = { documents: documents };
	
	      _this.props.onPopupClick({
	        name: 'EmailCombinedPdfPopup',
	        show: true,
	        data: params
	      });
	    }, _this.onAllPartsPrintPreview = function () {
	      var _this$props5 = _this.props,
	          case_uuid = _this$props5.case_uuid,
	          court_code = _this$props5.court_code,
	          case_number = _this$props5.case_number,
	          docket_seq = _this$props5.docket_seq;
	
	
	      var documents = createDocumentParam(court_code, case_number, docket_seq);
	
	      var params = {
	        documents: documents,
	        download_option: 1
	      };
	
	      _this.props.getDocketParts({ documents: documents });
	
	      _this.props.onPopupClick({
	        name: 'AllPartsPrintPreview',
	        show: true,
	        data: params
	      });
	    }, _this.printPreview = function (document) {
	      if (document.preview_url) {
	        var win = window.open(document.preview_url);
	        if (!/Chrome/.test(navigator.userAgent)) {
	          win.print();
	        }
	      } else {
	        // call service to retrieve the preview url
	        _this.props.orderPdf(document, _this.props.docket_seq).then(function (updatedDocument) {
	          window.open(updatedDocument.preview_url);
	        });
	      }
	    }, _this.emailPartPopup = function (friendly_name, sequence_number, part_number) {
	      var _this$props6 = _this.props,
	          case_uuid = _this$props6.case_uuid,
	          court_code = _this$props6.court_code,
	          case_number = _this$props6.case_number;
	
	
	      var params = {
	        name: 'EmailPartPopup',
	        show: true,
	        data: {
	          case_uuid: case_uuid,
	          court_code: court_code,
	          case_number: case_number,
	          friendly_name: friendly_name,
	          sequence_number: sequence_number,
	          part_number: part_number
	        }
	      };
	
	      _this.props.onPopupClick(params);
	    }, _this.emailPartModal = function (friendly_name, sequence_number, part_number) {
	      var _this$props7 = _this.props,
	          case_uuid = _this$props7.case_uuid,
	          court_code = _this$props7.court_code,
	          case_number = _this$props7.case_number,
	          docket = _this$props7.docket;
	
	
	      var params = {
	        name: 'EmailPartModal',
	        show: true,
	        data: {
	          case_uuid: case_uuid,
	          court_code: court_code,
	          case_number: case_number,
	          friendly_name: friendly_name,
	          sequence_number: sequence_number,
	          part_number: part_number,
	          docket: docket
	        }
	      };
	
	      _this.props.onPopupClick(params);
	    }, _this.downloadFile = function (document) {
	      if (document.download_url) {
	        window.open(document.download_url);
	      } else {
	        // call service to retrieve the download_url
	        _this.props.orderPdf(document, _this.props.docket_seq).then(function (updatedDocument) {
	          window.open(updatedDocument.download_url);
	        });
	      }
	    }, _this.ocrDownload = function (document) {
	      if (document.ocr_link) {
	        window.open(document.ocr_link);
	      } else {
	        // call service to retrieve the download_url
	        _this.props.orderPdf(document, _this.props.docket_seq).then(function (updatedDocument) {
	          window.open(updatedDocument.ocr_link);
	        });
	      }
	    }, _this.createBlogPost = function (document) {
	      if (document.blog) {
	        window.open(document.blog);
	      } else {
	        // call service to retrieve the download_url
	        _this.props.orderPdf(document, _this.props.docket_seq).then(function (updatedDocument) {
	          window.open(updatedDocument.blog);
	        });
	      }
	    }, _this.getPartsInfo = function (court_code, case_number, partNumber, sequence_numbers) {
	      var params = { case_docket_sequence_numbers: [{ court_code: court_code, case_number: case_number, sequence_numbers: sequence_numbers }] };
	      _this.props.getPartsPurchaseInfo(params);
	    }, _this.buyPdf = function (docket_no, number) {
	      if (_this.props.hasValidClientCode()) {
	        var _this$props8 = _this.props,
	            court_code = _this$props8.court_code,
	            case_number = _this$props8.case_number,
	            docket_seq = _this$props8.docket_seq;
	
	
	        var params = {
	          case_no: case_number,
	          docket_no: docket_no,
	          number: number,
	          seqNum: docket_seq,
	          court_code: court_code
	        };
	
	        _this.props.buyPdf(params).then(function () {
	          return _this.getPartsInfo(court_code, case_number, number, [docket_seq]);
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Documents.prototype.render = function render() {
	    var _this2 = this;
	
	    var documents = this.props.documents;
	
	
	    var allPartsCount = documents.reduce(function (accum, next) {
	      accum += parseInt(next.pages, 10) || 0;
	      return accum;
	    }, 0);
	
	    var rows = documents.map(function (document, index) {
	      return _react2.default.createElement(_Document2.default, {
	        key: index,
	        document: document,
	        createBlogPost: _this2.createBlogPost,
	        index: index,
	        buyPdf: _this2.buyPdf,
	        ocrDownload: _this2.ocrDownload,
	        downloadFile: _this2.downloadFile,
	        emailPartPopup: _this2.emailPartPopup,
	        emailPartModal: _this2.emailPartModal,
	        printPreview: _this2.printPreview
	      });
	    });
	
	    if (documents.length > 1) {
	      rows.push(_react2.default.createElement(_AllPartsDocument2.default, {
	        key: 'all-parts-doc',
	        allPartsCount: allPartsCount,
	        onDownloadComboPdfClick: this.onDownloadComboPdfClick,
	        onDownloadEmailZipClick: this.onDownloadEmailZipClick,
	        onEmailCombinedPdf: this.onEmailCombinedPdf,
	        onAllPartsPrintPreview: this.onAllPartsPrintPreview,
	        onDownloadZipClick: this.onDownloadZipClick
	      }));
	    }
	    return rows;
	  };
	
	  return Documents;
	}(_react.Component);
	
	function createDocumentParam(court_code, case_number) {
	  for (var _len2 = arguments.length, sequenceNumbers = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	    sequenceNumbers[_key2 - 2] = arguments[_key2];
	  }
	
	  var documents = sequenceNumbers.map(function (x) {
	    return { court_code: court_code, case_number: case_number, sequence_number: x };
	  });
	
	  return documents;
	}
	
	Documents.propTypes = {
	  documents: _propTypes2.default.array.isRequired,
	  onPopupClick: _propTypes2.default.func.isRequired,
	  case_uuid: _propTypes2.default.string.isRequired,
	  docket_seq: _propTypes2.default.any.isRequired,
	  court_code: _propTypes2.default.string.isRequired,
	  case_number: _propTypes2.default.string.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$get$toJS = state.get('dockets').toJS(),
	      popup = _state$get$toJS.popup;
	
	  return {
	    popup: popup
	  };
	};
	
	var mapDispatchToProps = {
	  orderPdf: docketActions.orderPdf,
	  buyPdf: docketActions.buyPdf,
	  getPartsPurchaseInfo: docketActions.getPartsPurchaseInfo,
	  hasValidClientCode: _clientCodeAction.hasValidClientCode,
	  getDocketParts: docketActions.getDocketParts,
	  onPopupClick: docketActions.togglePopup
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Documents);

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.EmailBulkModal = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _docketActions = __webpack_require__(42);
	
	var docketActions = _interopRequireWildcard(_docketActions);
	
	var _clientCodeAction = __webpack_require__(64);
	
	var _EmailAttachmentPurchaseForm = __webpack_require__(260);
	
	var _EmailAttachmentPurchaseForm2 = _interopRequireDefault(_EmailAttachmentPurchaseForm);
	
	var _EmailForm = __webpack_require__(261);
	
	var _EmailForm2 = _interopRequireDefault(_EmailForm);
	
	__webpack_require__(944);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmailBulkModal = exports.EmailBulkModal = function (_Component) {
	  _inherits(EmailBulkModal, _Component);
	
	  function EmailBulkModal(props) {
	    _classCallCheck(this, EmailBulkModal);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.onSendEmail = function (_ref) {
	      var emails = _ref.emails,
	          message = _ref.message;
	
	      _this.setState({
	        canSendEmail: false,
	        email_addresses: emails,
	        email_message: message
	      }, function () {
	        _this.emailPdfsZip();
	      });
	    };
	
	    _this.onClose = function () {
	      _this.setState({ canSendEmail: false });
	      _this.props.onClose();
	    };
	
	    _this.getParams = function () {
	      var _this$state = _this.state,
	          email_addresses = _this$state.email_addresses,
	          email_message = _this$state.email_message;
	
	      return _extends({}, _this.props.popup.data, {
	        email_addresses: email_addresses,
	        email_message: email_message
	      });
	    };
	
	    _this.buy = function () {
	      if (_this.props.dispatch((0, _clientCodeAction.hasValidClientCode)())) {
	        _this.props.dispatch(docketActions.buyAllParts(_this.getParams())).then(function () {
	          return _this.enableEmailForm();
	        });
	      } else {
	        _this.props.onClose();
	      }
	    };
	
	    _this.emailPdfsZip = function () {
	      _this.props.dispatch(docketActions[_this.props.emailActionName](_this.getParams()))
	      // .then(this.props.reloadDetails)
	      .then(function () {
	        _this.setState({ canSendEmail: false });
	      });
	    };
	
	    _this.state = {
	      canSendEmail: false,
	      email_addresses: '',
	      email_message: ''
	    };
	    return _this;
	  }
	
	  EmailBulkModal.prototype.componentDidMount = function componentDidMount() {
	    // On open, begin docket part inspection process
	    this.props.dispatch(docketActions.getDocketParts(this.props.popup.data));
	  };
	
	  EmailBulkModal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    // Nudge along in case no buying necessary
	    // This should really be triggered by action and not state transition
	    if (!prevProps.docketParts.alreadyPurchased && this.props.docketParts.alreadyPurchased) {
	      this.enableEmailForm();
	    }
	  };
	
	  EmailBulkModal.prototype.enableEmailForm = function enableEmailForm() {
	    this.setState({ canSendEmail: true });
	  };
	
	  EmailBulkModal.prototype.render = function render() {
	    var _props = this.props,
	        docketParts = _props.docketParts,
	        selectedDocket = _props.selectedDocket,
	        popup = _props.popup,
	        entries = _props.entries,
	        emailActionName = _props.emailActionName;
	
	
	    return _react2.default.createElement(
	      _reactBootstrap.Modal,
	      { show: true, onHide: this.onClose, backdrop: 'static', className: 'docket-popup' },
	      _react2.default.createElement(
	        _reactBootstrap.Modal.Header,
	        { closeButton: true },
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Title,
	          null,
	          this.props.topBarTitle
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Modal.Body,
	        null,
	        _react2.default.createElement(
	          _EmailForm2.default,
	          {
	            canSend: this.state.canSendEmail,
	            onSendEmail: this.onSendEmail,
	            onCancel: this.onClose,
	            sendButtonHint: 'Purchase documents, fill out destination address and any message and then click `Send`'
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'docket-info-section' },
	            popup.data.docket && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                popup.data.docket.date_filed + ' | ' + popup.data.docket.docket_no + ' | ' + popup.data.docket.docket_text
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'docket-number-link' },
	              _react2.default.createElement(
	                'a',
	                { href: '/filings/' + popup.data.case_uuid },
	                popup.data.case_number
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'label',
	            { style: { marginTop: '8px' } },
	            _react2.default.createElement('i', { className: 'fa fa-paperclip' }),
	            ' Attachment'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'bg-color-grey' },
	            _react2.default.createElement(_EmailAttachmentPurchaseForm2.default, {
	              hidePendingSteps: true,
	              docketParts: docketParts,
	              buy: this.buy,
	              selectedDocket: selectedDocket,
	              entries: entries,
	              emailActionName: emailActionName
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return EmailBulkModal;
	}(_react.Component);
	
	EmailBulkModal.propTypes = {
	  topBarTitle: _propTypes2.default.string.isRequired,
	  emailActionName: _propTypes2.default.string.isRequired,
	  onClose: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  docketParts: _propTypes2.default.object.isRequired,
	  popup: _propTypes2.default.object.isRequired,
	  entries: _propTypes2.default.object.isRequired,
	  selectedDocket: _propTypes2.default.object.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$get$toJS = state.get('dockets').toJS(),
	      popup = _state$get$toJS.popup,
	      docketParts = _state$get$toJS.docketParts,
	      selectedDocket = _state$get$toJS.selectedDocket,
	      entries = _state$get$toJS.entries;
	
	  return {
	    popup: popup,
	    docketParts: docketParts,
	    selectedDocket: selectedDocket,
	    entries: entries
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EmailBulkModal);

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _PopoverOfForm = __webpack_require__(410);
	
	var _PopoverOfForm2 = _interopRequireDefault(_PopoverOfForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _PopoverOfForm2.default;

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _CaseNumberTooltip = __webpack_require__(206);
	
	var _CaseNumberTooltip2 = _interopRequireDefault(_CaseNumberTooltip);
	
	var _inputValidations = __webpack_require__(100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CaseNumberSelector = function (_Component) {
	  _inherits(CaseNumberSelector, _Component);
	
	  function CaseNumberSelector() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CaseNumberSelector);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onChange = function () {
	      var value = _this.refs.case_no.value;
	
	      _this.props.onChange({ case_no: value });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CaseNumberSelector.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    this.refs.case_no.value = nextProps.value || '';
	  };
	
	  CaseNumberSelector.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'form-item' },
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'case-number' },
	        'Case Number: '
	      ),
	      _react2.default.createElement('input', { type: 'text',
	        maxLength: '128',
	        id: 'case-number',
	        size: '60',
	        ref: 'case_no',
	        onChange: this.onChange,
	        className: this.props.className }),
	      _react2.default.createElement(_CaseNumberTooltip2.default, null)
	    );
	  };
	
	  return CaseNumberSelector;
	}(_react.Component);
	
	CaseNumberSelector.defaultProps = {
	  className: '',
	  value: ''
	};
	
	CaseNumberSelector.propTypes = {
	  onChange: _propTypes2.default.func.isRequired,
	  className: _propTypes2.default.any,
	  value: _propTypes2.default.any
	};
	
	function mapStateToProps(state) {
	  return {
	    className: (0, _inputValidations.mapValidationFieldsToClassName)(state, 'case_no', 'input-search').className,
	    value: state.getIn(['pacerSearchResults', 'filters', 'case_no'])
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(CaseNumberSelector);

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _CaseTitleTooltip = __webpack_require__(686);
	
	var _CaseTitleTooltip2 = _interopRequireDefault(_CaseTitleTooltip);
	
	var _inputValidations = __webpack_require__(100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CaseTitleSelector = function (_Component) {
	  _inherits(CaseTitleSelector, _Component);
	
	  function CaseTitleSelector() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CaseTitleSelector);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onChange = function () {
	      var value = _this.refs.case_title.value;
	
	      _this.props.onChange({ case_title: value });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CaseTitleSelector.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    this.refs.case_title.value = nextProps.value || '';
	  };
	
	  CaseTitleSelector.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'form-item' },
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'case-title' },
	        'Case Title: '
	      ),
	      _react2.default.createElement('input', { type: 'text',
	        maxLength: '128',
	        id: 'case-title',
	        size: '60',
	        ref: 'case_title',
	        onChange: this.onChange,
	        className: this.props.className }),
	      _react2.default.createElement(_CaseTitleTooltip2.default, null)
	    );
	  };
	
	  return CaseTitleSelector;
	}(_react.Component);
	
	CaseTitleSelector.defaultProps = {
	  className: '',
	  value: ''
	};
	
	CaseTitleSelector.propTypes = {
	  onChange: _propTypes2.default.func.isRequired,
	  className: _propTypes2.default.any,
	  value: _propTypes2.default.any
	};
	
	function mapStateToProps(state) {
	  return {
	    className: (0, _inputValidations.mapValidationFieldsToClassName)(state, 'case_title', 'input-search').className,
	    value: state.getIn(['pacerSearchResults', 'filters', 'case_title'])
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(CaseTitleSelector);

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PopoverOfForm = __webpack_require__(203);
	
	var _PopoverOfForm2 = _interopRequireDefault(_PopoverOfForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //packages
	
	
	//form elements
	
	
	var CaseNumberTooltip = function (_Component) {
	    _inherits(CaseNumberTooltip, _Component);
	
	    function CaseNumberTooltip() {
	        _classCallCheck(this, CaseNumberTooltip);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    CaseNumberTooltip.prototype.render = function render() {
	        return _react2.default.createElement(
	            _PopoverOfForm2.default,
	            null,
	            _react2.default.createElement(
	                'p',
	                null,
	                'Case numbers can be entered in any of the following formats:'
	            ),
	            _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'yy-nnnnn'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'yy-tp-nnnnn'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'yy tp nnnnn'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'yytpnnnnn'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'o:yy-nnnnn'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'o:yy-tp-nnnnn'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'o:yy tp nnnnn'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'o:yytpnnnnn'
	                )
	            ),
	            _react2.default.createElement(
	                'table',
	                null,
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'o'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            'office where the case was filed (1 digit)'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'yy'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            'case year (2 or 4 digits)'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'tp'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            'case type (up to 2 characters)'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'nnnnn'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            'case number (up to 5 digits)'
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return CaseNumberTooltip;
	}(_react.Component);
	
	exports.default = CaseNumberTooltip;

/***/ },
/* 207 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = [{ value: '110', label: '110 Insurance' }, { value: '120', label: '120 Contract: Marine' }, { value: '130', label: '130 Miller Act' }, { value: '140', label: '140 Negotiable Instrument' }, { value: '150', label: '150 Contract: Recovery/Enforcement' }, { value: '151', label: '151 Contract: Recovery Medicare' }, { value: '152', label: '152 Contract: Recovery Student Loan' }, { value: '153', label: '153 Contract: Recovery Veteran Benefits' }, { value: '160', label: '160 Stockholders Suits' }, { value: '190', label: '190 Contract: Other' }, { value: '195', label: '195 Contract Product Liability' }, { value: '196', label: '196 Contract: Franchise' }, { value: '210', label: '210 Condemnation' }, { value: '220', label: '220 Real Property: Foreclosure' }, { value: '230', label: '230 Rent Lease & Ejectment' }, { value: '240', label: '240 Torts to Land' }, { value: '245', label: '245 Tort Product Liability' }, { value: '290', label: '290 Real Property: Other' }, { value: '310', label: '310 Airplane' }, { value: '315', label: '315 Airplane Product Liability' }, { value: '320', label: '320 Assault Libel & Slander' }, { value: '330', label: "330 Federal Employer's Liability" }, { value: '340', label: '340 Marine' }, { value: '345', label: '345 Marine Product Liability' }, { value: '350', label: '350 Motor Vehicle' }, { value: '355', label: '355 Motor Vehicle Product Liability' }, { value: '360', label: '360 P.I.: Other' }, { value: '362', label: '362 Personal Injury Medical Malpractice' }, { value: '365', label: '365 Personal Injury Product Liability' }, { value: '367', label: '367 TORTS - Personal Injury - Health Care/Pharmaceutical Personal Injury/Product Liability' }, { value: '368', label: '368 P.I. : Asbestos' }, { value: '370', label: '370 Fraud or Truth-In-Lending' }, { value: '371', label: '371 Truth in Lending' }, { value: '375', label: '375 False Claims Act' }, { value: '376', label: '376 Qui Tam' }, { value: '380', label: '380 Personal Property: Other' }, { value: '385', label: '385 Prop. Damage Prod. Liability' }, { value: '400', label: '400 State Reapportionment' }, { value: '410', label: '410 Anti-Trust' }, { value: '422', label: '422 Bankruptcy Appeal (801)' }, { value: '423', label: '423 Bankruptcy Withdrawl' }, { value: '430', label: '430 Banks and Banking' }, { value: '440', label: '440 Civil Rights: Other' }, { value: '441', label: '441 Civil Rights: Voting' }, { value: '442', label: '442 Civil Rights: Jobs' }, { value: '443', label: '443 Civil Rights: Accomodations' }, { value: '444', label: '444 Civil Rights: Welfare' }, { value: '445', label: '445 Civil Rights: Americans with Disabilities - Employment' }, { value: '446', label: '446 Civil Rights: Americans with Disabilities - Other' }, { value: '448', label: '448 Civil Rights: Education' }, { value: '450', label: '450 Commerce ICC Rates, Etc.' }, { value: '460', label: '460 Deportation' }, { value: '462', label: '462 Naturalization Application' }, { value: '463', label: '463 Habeas Corpus - Alien Detainee' }, { value: '465', label: '465 Other Immigration Actions' }, { value: '470', label: '470 Racketeer/Corrupt Organization' }, { value: '480', label: '480 Consumer Credit' }, { value: '485', label: '485 Telephone Consumer Protection Action (TCPA)' }, { value: '490', label: '490 Cable/Satellite TV' }, { value: '510', label: '510 Prisoner: Vacate Sentence' }, { value: '530', label: '530 Habeas Corpus (General)' }, { value: '535', label: '535 Death Penalty - Habeas Corpus' }, { value: '540', label: '540 Mandamus & Other' }, { value: '550', label: '550 Prisoner: Civil Rights' }, { value: '555', label: '555 Habeas Corpus (Prison Condition)' }, { value: '560', label: '560 Prisoner Petitions - Civil Detainee - Conditions of Confinement' }, { value: '610', label: '610 Forfeit/Penalty: Agriculture' }, { value: '620', label: '620 Forfeit/Penalty: Food and Drug' }, { value: '625', label: '625 Drug Related Seizure of Property' }, { value: '630', label: '630 Forfeit/Penalty: Liquor Laws' }, { value: '640', label: '640 Forfeit/Penalty: R.R. & Truck' }, { value: '650', label: '650 Forfeit/Penalty: Airline Regulations' }, { value: '660', label: '660 Forfeit/Penalty: Occupational Safety' }, { value: '690', label: '690 Forfeit/Penalty: Other' }, { value: '710', label: '710 Labor: Fair Standards' }, { value: '720', label: '720 Labor: Labor/Management Relations' }, { value: '730', label: '730 Labor: Reporting/Disclosure' }, { value: '740', label: '740 Labor: Railway Labor Act' }, { value: '751', label: '751 Labor: Family and Medical Leave Act' }, { value: '790', label: '790 Labor: Other' }, { value: '791', label: '791 Labor: E.R.I.S.A.' }, { value: '810', label: '810 Selective Service' }, { value: '820', label: '820 Copyright' }, { value: '830', label: '830 Patent' }, { value: '835', label: '835 Abbreviated New Drug Applications' }, { value: '840', label: '840 Trademark' }, { value: '850', label: '850 Securities/Commodities' }, { value: '861', label: '861 Social Security: HIA' }, { value: '862', label: '862 Social Security: Black Lung' }, { value: '863', label: '863 Social Security: DIWC/DIWW' }, { value: '864', label: '864 Social Security: SSID Tit. XVI' }, { value: '865', label: '865 Social Security: RSI Tax Suits' }, { value: '870', label: '870 Taxes' }, { value: '871', label: '871 Tax Suits: IRS-Third Party' }, { value: '875', label: '875 Taxes: Customer Challenge' }, { value: '880', label: '880 Defend Trade Secrets Act of 2016' }, { value: '890', label: '890 Other Statutory Actions' }, { value: '891', label: '891 Agriculture Acts' }, { value: '892', label: '892 Economic Stabilization Act' }, { value: '893', label: '893 Environmental Matters' }, { value: '894', label: '894 Energy Allocation Act' }, { value: '895', label: '895 Freedom of Information Act' }, { value: '896', label: '896 Other Statues - Arbitration' }, { value: '899', label: '899 Other Statues - Administrative Procedure Act/Review or Appeal of Agency Decision' }, { value: '900', label: '900 Appeal of Fee Determination' }, { value: '950', label: '950 Constitutional - State Statute' }, { value: 'ZZZ', label: 'Other Nature of Suit' }];

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = EditCopyPasteSchedule;
	
	var _copyToClipboard = __webpack_require__(750);
	
	var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EditCopyPasteSchedule(_ref) {
	  var onPastedData = _ref.onPastedData,
	      schedule = _ref.schedule,
	      toggleScheduleForm = _ref.toggleScheduleForm;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'editable' },
	    _react2.default.createElement('input', {
	      className: 'btn',
	      style: { width: 200 },
	      onPaste: function onPaste(event) {
	        event.clipboardData.items[0].getAsString(function (text) {
	          console.log('Got paste:', text);
	          var new_schedule = void 0;
	          try {
	            new_schedule = JSON.parse(text);
	          } catch (e) {
	            alert('Schedule data not found in the clipboard\n' + e);
	            return;
	          }
	          try {
	            if (new_schedule.schedule_type != schedule.schedule_type) {
	              alert('You pasted schedule \'' + new_schedule.schedule_type + '\', but this is schedule \'' + schedule.schedule_type + '\' form');
	              return;
	            }
	            console.log('Parsed Schedule', new_schedule);
	            onPastedData(new_schedule);
	          } catch (e) {
	            console.error('Unable to paste', e);
	            alert('Unable to paste ' + e);
	          }
	        });
	      },
	      placeholder: 'To paste: click here and press Ctrl+V',
	      readOnly: true
	    }),
	    ' ',
	    schedule.data && _react2.default.createElement(
	      'button',
	      {
	        className: 'btn btn-secondary',
	        onClick: function onClick() {
	          try {
	            var serialized = JSON.stringify(schedule);
	            console.log('Copying', serialized);
	            (0, _copyToClipboard2.default)(serialized, {
	              format: 'text/plain',
	              onCopy: function onCopy() {
	                return alert('Schedule ' + schedule.schedule_type + ' copied to clipboard');
	              }
	            }) || alert('Sorry, something went wrong during copying :(');
	          } catch (e) {
	            alert('Error while copying: ' + e);
	          }
	        }
	      },
	      'Copy'
	    ),
	    ' ',
	    _react2.default.createElement(
	      'button',
	      { className: 'btn btn-primary', onClick: toggleScheduleForm },
	      'Edit'
	    )
	  );
	}

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(1268);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(746);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 210 */
57,
/* 211 */
84,
/* 212 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 213 */
[2275, 285, 61, 117, 95, 116],
/* 214 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 215 */
148,
/* 216 */
[2295, 95, 117, 56],
/* 217 */
[2329, 1351, 762],
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1359);
	var global = __webpack_require__(44);
	var hide = __webpack_require__(118);
	var Iterators = __webpack_require__(181);
	var TO_STRING_TAG = __webpack_require__(56)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(22);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ },
/* 220 */
[2268, 84],
/* 221 */
214,
/* 222 */
[2297, 85, 25, 121],
/* 223 */
[2298, 22, 57, 36],
/* 224 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPrefixedValue;
	var regex = /-webkit-|-moz-|-ms-/;
	
	function isPrefixedValue(value) {
	  return typeof value === 'string' && regex.test(value);
	}
	module.exports = exports['default'];

/***/ },
/* 225 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTimezoneOffsetInMilliseconds;
	var MILLISECONDS_IN_MINUTE = 60000;
	/**
	 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
	 * They usually appear for dates that denote time before the timezones were introduced
	 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
	 * and GMT+01:00:00 after that date)
	 *
	 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
	 * which would lead to incorrect calculations.
	 *
	 * This function returns the timezone offset in milliseconds that takes seconds in account.
	 */
	
	function getTimezoneOffsetInMilliseconds(dirtyDate) {
	  var date = new Date(dirtyDate.getTime());
	  var baseTimezoneOffset = Math.ceil(date.getTimezoneOffset());
	  date.setSeconds(0, 0);
	  var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE;
	  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset;
	}
	
	module.exports = exports.default;

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(35);
	
	exports.__esModule = true;
	exports.default = style;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(832));
	
	var _hyphenateStyle = _interopRequireDefault(__webpack_require__(1749));
	
	var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(1742));
	
	var _removeStyle = _interopRequireDefault(__webpack_require__(1743));
	
	var _properties = __webpack_require__(487);
	
	var _isTransform = _interopRequireDefault(__webpack_require__(1746));
	
	function style(node, property, value) {
	  var css = '';
	  var transforms = '';
	  var props = property;
	
	  if (typeof property === 'string') {
	    if (value === undefined) {
	      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
	    } else {
	      (props = {})[property] = value;
	    }
	  }
	
	  Object.keys(props).forEach(function (key) {
	    var value = props[key];
	
	    if (!value && value !== 0) {
	      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
	    } else if ((0, _isTransform.default)(key)) {
	      transforms += key + "(" + value + ") ";
	    } else {
	      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
	    }
	  });
	
	  if (transforms) {
	    css += _properties.transform + ": " + transforms + ";";
	  }
	
	  node.style.cssText += ';' + css;
	}
	
	module.exports = exports["default"];

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(312);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 228 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 229 */
/***/ function(module, exports) {

	'use strict';
	
	function areInputsEqual(newInputs, lastInputs) {
	    if (newInputs.length !== lastInputs.length) {
	        return false;
	    }
	    for (var i = 0; i < newInputs.length; i++) {
	        if (newInputs[i] !== lastInputs[i]) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function memoizeOne(resultFn, isEqual) {
	    if (isEqual === void 0) { isEqual = areInputsEqual; }
	    var lastThis;
	    var lastArgs = [];
	    var lastResult;
	    var calledOnce = false;
	    function memoized() {
	        var newArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            newArgs[_i] = arguments[_i];
	        }
	        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
	            return lastResult;
	        }
	        lastResult = resultFn.apply(this, newArgs);
	        calledOnce = true;
	        lastThis = this;
	        lastArgs = newArgs;
	        return lastResult;
	    }
	    return memoized;
	}
	
	module.exports = memoizeOne;


/***/ },
/* 230 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 231 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _values = _interopRequireDefault(__webpack_require__(166));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(9));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _elementType = _interopRequireDefault(__webpack_require__(34));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _StyleConfig = __webpack_require__(51);
	
	var _SafeAnchor = _interopRequireDefault(__webpack_require__(90));
	
	var propTypes = {
	  active: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  block: _propTypes.default.bool,
	  onClick: _propTypes.default.func,
	  componentClass: _elementType.default,
	  href: _propTypes.default.string,
	
	  /**
	   * Defines HTML button type attribute
	   * @defaultValue 'button'
	   */
	  type: _propTypes.default.oneOf(['button', 'reset', 'submit'])
	};
	var defaultProps = {
	  active: false,
	  block: false,
	  disabled: false
	};
	
	var Button =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Button, _React$Component);
	
	  function Button() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Button.prototype;
	
	  _proto.renderAnchor = function renderAnchor(elementProps, className) {
	    return _react.default.createElement(_SafeAnchor.default, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, elementProps.disabled && 'disabled')
	    }));
	  };
	
	  _proto.renderButton = function renderButton(_ref, className) {
	    var componentClass = _ref.componentClass,
	        elementProps = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["componentClass"]);
	    var Component = componentClass || 'button';
	    return _react.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      type: elementProps.type || 'button',
	      className: className
	    }));
	  };
	
	  _proto.render = function render() {
	    var _extends2;
	
	    var _this$props = this.props,
	        active = _this$props.active,
	        block = _this$props.block,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["active", "block", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'block')] = block, _extends2));
	    var fullClassName = (0, _classnames.default)(className, classes);
	
	    if (elementProps.href) {
	      return this.renderAnchor(elementProps, fullClassName);
	    }
	
	    return this.renderButton(elementProps, fullClassName);
	  };
	
	  return Button;
	}(_react.default.Component);
	
	Button.propTypes = propTypes;
	Button.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('btn', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL, _StyleConfig.Size.XSMALL], (0, _bootstrapUtils.bsStyles)((0, _values.default)(_StyleConfig.State).concat([_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY, _StyleConfig.Style.LINK]), _StyleConfig.Style.DEFAULT, Button)));
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopDefault(ex) {
	  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var _objectWithoutProperties = _interopDefault(__webpack_require__(163));
	
	var _extends = _interopDefault(__webpack_require__(160));
	
	__webpack_require__(237);
	
	__webpack_require__(196);
	
	var _classCallCheck = _interopDefault(__webpack_require__(158));
	
	var _createClass = _interopDefault(__webpack_require__(159));
	
	var _possibleConstructorReturn = _interopDefault(__webpack_require__(164));
	
	var _getPrototypeOf = _interopDefault(__webpack_require__(161));
	
	var _inherits = _interopDefault(__webpack_require__(162));
	
	var _assertThisInitialized = _interopDefault(__webpack_require__(127));
	
	var _defineProperty = _interopDefault(__webpack_require__(128));
	
	var React = __webpack_require__(1);
	
	var React__default = _interopDefault(React);
	
	__webpack_require__(229);
	
	__webpack_require__(167);
	
	__webpack_require__(31);
	
	__webpack_require__(197);
	
	__webpack_require__(165);
	
	var __chunk_1 = __webpack_require__(195);
	
	__webpack_require__(234);
	
	var reactSelect = __webpack_require__(328);
	
	__webpack_require__(131);
	
	__webpack_require__(236);
	
	__webpack_require__(238);
	
	var __chunk_3 = __webpack_require__(329);
	
	var defaultProps = {
	  cacheOptions: false,
	  defaultOptions: false,
	  filterOption: null
	};
	
	var makeAsyncSelect = function makeAsyncSelect(SelectComponent) {
	  var _class, _temp;
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(Async, _Component);
	
	    function Async(props) {
	      var _this;
	
	      _classCallCheck(this, Async);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Async).call(this));
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "select", void 0);
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "lastRequest", void 0);
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "mounted", false);
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "optionsCache", {});
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputChange", function (newValue, actionMeta) {
	        var _this$props = _this.props,
	            cacheOptions = _this$props.cacheOptions,
	            onInputChange = _this$props.onInputChange; // TODO
	
	        var inputValue = __chunk_1.handleInputChange(newValue, actionMeta, onInputChange);
	
	        if (!inputValue) {
	          delete _this.lastRequest;
	
	          _this.setState({
	            inputValue: '',
	            loadedInputValue: '',
	            loadedOptions: [],
	            isLoading: false,
	            passEmptyOptions: false
	          });
	
	          return;
	        }
	
	        if (cacheOptions && _this.optionsCache[inputValue]) {
	          _this.setState({
	            inputValue: inputValue,
	            loadedInputValue: inputValue,
	            loadedOptions: _this.optionsCache[inputValue],
	            isLoading: false,
	            passEmptyOptions: false
	          });
	        } else {
	          var request = _this.lastRequest = {};
	
	          _this.setState({
	            inputValue: inputValue,
	            isLoading: true,
	            passEmptyOptions: !_this.state.loadedInputValue
	          }, function () {
	            _this.loadOptions(inputValue, function (options) {
	              if (!_this.mounted) return;
	
	              if (options) {
	                _this.optionsCache[inputValue] = options;
	              }
	
	              if (request !== _this.lastRequest) return;
	              delete _this.lastRequest;
	
	              _this.setState({
	                isLoading: false,
	                loadedInputValue: inputValue,
	                loadedOptions: options || [],
	                passEmptyOptions: false
	              });
	            });
	          });
	        }
	
	        return inputValue;
	      });
	
	      _this.state = {
	        defaultOptions: Array.isArray(props.defaultOptions) ? props.defaultOptions : undefined,
	        inputValue: typeof props.inputValue !== 'undefined' ? props.inputValue : '',
	        isLoading: props.defaultOptions === true,
	        loadedOptions: [],
	        passEmptyOptions: false
	      };
	      return _this;
	    }
	
	    _createClass(Async, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        var _this2 = this;
	
	        this.mounted = true;
	        var defaultOptions = this.props.defaultOptions;
	        var inputValue = this.state.inputValue;
	
	        if (defaultOptions === true) {
	          this.loadOptions(inputValue, function (options) {
	            if (!_this2.mounted) return;
	            var isLoading = !!_this2.lastRequest;
	
	            _this2.setState({
	              defaultOptions: options || [],
	              isLoading: isLoading
	            });
	          });
	        }
	      }
	    }, {
	      key: "UNSAFE_componentWillReceiveProps",
	      value: function UNSAFE_componentWillReceiveProps(nextProps) {
	        // if the cacheOptions prop changes, clear the cache
	        if (nextProps.cacheOptions !== this.props.cacheOptions) {
	          this.optionsCache = {};
	        }
	
	        if (nextProps.defaultOptions !== this.props.defaultOptions) {
	          this.setState({
	            defaultOptions: Array.isArray(nextProps.defaultOptions) ? nextProps.defaultOptions : undefined
	          });
	        }
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        this.mounted = false;
	      }
	    }, {
	      key: "focus",
	      value: function focus() {
	        this.select.focus();
	      }
	    }, {
	      key: "blur",
	      value: function blur() {
	        this.select.blur();
	      }
	    }, {
	      key: "loadOptions",
	      value: function loadOptions(inputValue, callback) {
	        var loadOptions = this.props.loadOptions;
	        if (!loadOptions) return callback();
	        var loader = loadOptions(inputValue, callback);
	
	        if (loader && typeof loader.then === 'function') {
	          loader.then(callback, function () {
	            return callback();
	          });
	        }
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this3 = this;
	
	        var _this$props2 = this.props,
	            loadOptions = _this$props2.loadOptions,
	            props = _objectWithoutProperties(_this$props2, ["loadOptions"]);
	
	        var _this$state = this.state,
	            defaultOptions = _this$state.defaultOptions,
	            inputValue = _this$state.inputValue,
	            isLoading = _this$state.isLoading,
	            loadedInputValue = _this$state.loadedInputValue,
	            loadedOptions = _this$state.loadedOptions,
	            passEmptyOptions = _this$state.passEmptyOptions;
	        var options = passEmptyOptions ? [] : inputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
	        return React__default.createElement(SelectComponent, _extends({}, props, {
	          ref: function ref(_ref) {
	            _this3.select = _ref;
	          },
	          options: options,
	          isLoading: isLoading,
	          onInputChange: this.handleInputChange
	        }));
	      }
	    }]);
	
	    return Async;
	  }(React.Component), _defineProperty(_class, "defaultProps", defaultProps), _temp;
	};
	
	var SelectState = __chunk_3.manageState(reactSelect.Select);
	
	var Async = makeAsyncSelect(SelectState);
	exports.default = Async;
	exports.defaultProps = defaultProps;
	exports.makeAsyncSelect = makeAsyncSelect;


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault(ex) {
	  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var _objectWithoutProperties = _interopDefault(__webpack_require__(163));
	
	var _extends = _interopDefault(__webpack_require__(160));
	
	var _objectSpread = _interopDefault(__webpack_require__(196));
	
	var _classCallCheck = _interopDefault(__webpack_require__(158));
	
	var _createClass = _interopDefault(__webpack_require__(159));
	
	var _possibleConstructorReturn = _interopDefault(__webpack_require__(164));
	
	var _getPrototypeOf = _interopDefault(__webpack_require__(161));
	
	var _inherits = _interopDefault(__webpack_require__(162));
	
	var _assertThisInitialized = _interopDefault(__webpack_require__(127));
	
	var _defineProperty = _interopDefault(__webpack_require__(128));
	
	var React = __webpack_require__(1);
	
	var React__default = _interopDefault(React);
	
	var core = __webpack_require__(167);
	
	var reactDom = __webpack_require__(31);
	
	var PropTypes = _interopDefault(__webpack_require__(197));
	
	var _typeof = _interopDefault(__webpack_require__(165));
	
	var __chunk_1 = __webpack_require__(195);
	
	var _css = _interopDefault(__webpack_require__(131));
	
	var _taggedTemplateLiteral = _interopDefault(__webpack_require__(236));
	
	var AutosizeInput = _interopDefault(__webpack_require__(238));
	
	function getMenuPlacement(_ref) {
	  var maxHeight = _ref.maxHeight,
	      menuEl = _ref.menuEl,
	      minHeight = _ref.minHeight,
	      placement = _ref.placement,
	      shouldScroll = _ref.shouldScroll,
	      isFixedPosition = _ref.isFixedPosition,
	      theme = _ref.theme;
	  var spacing = theme.spacing;
	
	  var scrollParent = __chunk_1.getScrollParent(menuEl);
	
	  var defaultState = {
	    placement: 'bottom',
	    maxHeight: maxHeight
	  }; // something went wrong, return default state
	
	  if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
	  // the menu is rendered
	
	  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
	      scrollHeight = _scrollParent$getBoun.height;
	
	  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
	      menuBottom = _menuEl$getBoundingCl.bottom,
	      menuHeight = _menuEl$getBoundingCl.height,
	      menuTop = _menuEl$getBoundingCl.top;
	
	  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
	      containerTop = _menuEl$offsetParent$.top;
	
	  var viewHeight = window.innerHeight;
	
	  var scrollTop = __chunk_1.getScrollTop(scrollParent);
	
	  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
	  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
	  var viewSpaceAbove = containerTop - marginTop;
	  var viewSpaceBelow = viewHeight - menuTop;
	  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
	  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
	  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
	  var scrollUp = scrollTop + menuTop - marginTop;
	  var scrollDuration = 160;
	
	  switch (placement) {
	    case 'auto':
	    case 'bottom':
	      // 1: the menu will fit, do nothing
	      if (viewSpaceBelow >= menuHeight) {
	        return {
	          placement: 'bottom',
	          maxHeight: maxHeight
	        };
	      } // 2: the menu will fit, if scrolled
	
	
	      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
	        if (shouldScroll) {
	          __chunk_1.animatedScrollTo(scrollParent, scrollDown, scrollDuration);
	        }
	
	        return {
	          placement: 'bottom',
	          maxHeight: maxHeight
	        };
	      } // 3: the menu will fit, if constrained
	
	
	      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
	        if (shouldScroll) {
	          __chunk_1.animatedScrollTo(scrollParent, scrollDown, scrollDuration);
	        } // we want to provide as much of the menu as possible to the user,
	        // so give them whatever is available below rather than the minHeight.
	
	
	        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
	        return {
	          placement: 'bottom',
	          maxHeight: constrainedHeight
	        };
	      } // 4. Forked beviour when there isn't enough space below
	      // AUTO: flip the menu, render above
	
	
	      if (placement === 'auto' || isFixedPosition) {
	        // may need to be constrained after flipping
	        var _constrainedHeight = maxHeight;
	        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
	
	        if (spaceAbove >= minHeight) {
	          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
	        }
	
	        return {
	          placement: 'top',
	          maxHeight: _constrainedHeight
	        };
	      } // BOTTOM: allow browser to increase scrollable area and immediately set scroll
	
	
	      if (placement === 'bottom') {
	        __chunk_1.scrollTo(scrollParent, scrollDown);
	
	        return {
	          placement: 'bottom',
	          maxHeight: maxHeight
	        };
	      }
	
	      break;
	
	    case 'top':
	      // 1: the menu will fit, do nothing
	      if (viewSpaceAbove >= menuHeight) {
	        return {
	          placement: 'top',
	          maxHeight: maxHeight
	        };
	      } // 2: the menu will fit, if scrolled
	
	
	      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
	        if (shouldScroll) {
	          __chunk_1.animatedScrollTo(scrollParent, scrollUp, scrollDuration);
	        }
	
	        return {
	          placement: 'top',
	          maxHeight: maxHeight
	        };
	      } // 3: the menu will fit, if constrained
	
	
	      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
	        var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
	        // so give them whatever is available below rather than the minHeight.
	
	        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
	          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
	        }
	
	        if (shouldScroll) {
	          __chunk_1.animatedScrollTo(scrollParent, scrollUp, scrollDuration);
	        }
	
	        return {
	          placement: 'top',
	          maxHeight: _constrainedHeight2
	        };
	      } // 4. not enough space, the browser WILL NOT increase scrollable area when
	      // absolutely positioned element rendered above the viewport (only below).
	      // Flip the menu, render below
	
	
	      return {
	        placement: 'bottom',
	        maxHeight: maxHeight
	      };
	
	    default:
	      throw new Error("Invalid placement provided \"".concat(placement, "\"."));
	  } // fulfil contract with flow: implicit return value of undefined
	
	
	  return defaultState;
	} // Menu Component
	// ------------------------------
	
	
	function alignToControl(placement) {
	  var placementToCSSProp = {
	    bottom: 'top',
	    top: 'bottom'
	  };
	  return placement ? placementToCSSProp[placement] : 'bottom';
	}
	
	var coercePlacement = function coercePlacement(p) {
	  return p === 'auto' ? 'bottom' : p;
	};
	
	var menuCSS = function menuCSS(_ref2) {
	  var _ref3;
	
	  var placement = _ref2.placement,
	      _ref2$theme = _ref2.theme,
	      borderRadius = _ref2$theme.borderRadius,
	      spacing = _ref2$theme.spacing,
	      colors = _ref2$theme.colors;
	  return _ref3 = {
	    label: 'menu'
	  }, _defineProperty(_ref3, alignToControl(placement), '100%'), _defineProperty(_ref3, "backgroundColor", colors.neutral0), _defineProperty(_ref3, "borderRadius", borderRadius), _defineProperty(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), _defineProperty(_ref3, "marginBottom", spacing.menuGutter), _defineProperty(_ref3, "marginTop", spacing.menuGutter), _defineProperty(_ref3, "position", 'absolute'), _defineProperty(_ref3, "width", '100%'), _defineProperty(_ref3, "zIndex", 1), _ref3;
	}; // NOTE: internal only
	
	
	var MenuPlacer =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(MenuPlacer, _Component);
	
	  function MenuPlacer() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, MenuPlacer);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MenuPlacer)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
	      maxHeight: _this.props.maxMenuHeight,
	      placement: null
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getPlacement", function (ref) {
	      var _this$props = _this.props,
	          minMenuHeight = _this$props.minMenuHeight,
	          maxMenuHeight = _this$props.maxMenuHeight,
	          menuPlacement = _this$props.menuPlacement,
	          menuPosition = _this$props.menuPosition,
	          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
	          theme = _this$props.theme;
	      var getPortalPlacement = _this.context.getPortalPlacement;
	      if (!ref) return; // DO NOT scroll if position is fixed
	
	      var isFixedPosition = menuPosition === 'fixed';
	      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
	      var state = getMenuPlacement({
	        maxHeight: maxMenuHeight,
	        menuEl: ref,
	        minHeight: minMenuHeight,
	        placement: menuPlacement,
	        shouldScroll: shouldScroll,
	        isFixedPosition: isFixedPosition,
	        theme: theme
	      });
	      if (getPortalPlacement) getPortalPlacement(state);
	
	      _this.setState(state);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getUpdatedProps", function () {
	      var menuPlacement = _this.props.menuPlacement;
	      var placement = _this.state.placement || coercePlacement(menuPlacement);
	      return _objectSpread({}, _this.props, {
	        placement: placement,
	        maxHeight: _this.state.maxHeight
	      });
	    });
	
	    return _this;
	  }
	
	  _createClass(MenuPlacer, [{
	    key: "render",
	    value: function render() {
	      var children = this.props.children;
	      return children({
	        ref: this.getPlacement,
	        placerProps: this.getUpdatedProps()
	      });
	    }
	  }]);
	
	  return MenuPlacer;
	}(React.Component);
	
	_defineProperty(MenuPlacer, "contextTypes", {
	  getPortalPlacement: PropTypes.func
	});
	
	var Menu = function Menu(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerRef = props.innerRef,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends({
	    css: getStyles('menu', props),
	    className: cx({
	      menu: true
	    }, className)
	  }, innerProps, {
	    ref: innerRef
	  }), children);
	}; // Menu List
	// ==============================
	
	
	var menuListCSS = function menuListCSS(_ref4) {
	  var maxHeight = _ref4.maxHeight,
	      baseUnit = _ref4.theme.spacing.baseUnit;
	  return {
	    maxHeight: maxHeight,
	    overflowY: 'auto',
	    paddingBottom: baseUnit,
	    paddingTop: baseUnit,
	    position: 'relative',
	    // required for offset[Height, Top] > keyboard scroll
	    WebkitOverflowScrolling: 'touch'
	  };
	};
	
	var MenuList = function MenuList(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      isMulti = props.isMulti,
	      innerRef = props.innerRef;
	  return core.jsx("div", {
	    css: getStyles('menuList', props),
	    className: cx({
	      'menu-list': true,
	      'menu-list--is-multi': isMulti
	    }, className),
	    ref: innerRef
	  }, children);
	}; // ==============================
	// Menu Notices
	// ==============================
	
	
	var noticeCSS = function noticeCSS(_ref5) {
	  var _ref5$theme = _ref5.theme,
	      baseUnit = _ref5$theme.spacing.baseUnit,
	      colors = _ref5$theme.colors;
	  return {
	    color: colors.neutral40,
	    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
	    textAlign: 'center'
	  };
	};
	
	var noOptionsMessageCSS = noticeCSS;
	var loadingMessageCSS = noticeCSS;
	
	var NoOptionsMessage = function NoOptionsMessage(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends({
	    css: getStyles('noOptionsMessage', props),
	    className: cx({
	      'menu-notice': true,
	      'menu-notice--no-options': true
	    }, className)
	  }, innerProps), children);
	};
	
	NoOptionsMessage.defaultProps = {
	  children: 'No options'
	};
	
	var LoadingMessage = function LoadingMessage(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends({
	    css: getStyles('loadingMessage', props),
	    className: cx({
	      'menu-notice': true,
	      'menu-notice--loading': true
	    }, className)
	  }, innerProps), children);
	};
	
	LoadingMessage.defaultProps = {
	  children: 'Loading...'
	}; // ==============================
	// Menu Portal
	// ==============================
	
	var menuPortalCSS = function menuPortalCSS(_ref6) {
	  var rect = _ref6.rect,
	      offset = _ref6.offset,
	      position = _ref6.position;
	  return {
	    left: rect.left,
	    position: position,
	    top: offset,
	    width: rect.width,
	    zIndex: 1
	  };
	};
	
	var MenuPortal =
	/*#__PURE__*/
	function (_Component2) {
	  _inherits(MenuPortal, _Component2);
	
	  function MenuPortal() {
	    var _getPrototypeOf3;
	
	    var _this2;
	
	    _classCallCheck(this, MenuPortal);
	
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    _this2 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(MenuPortal)).call.apply(_getPrototypeOf3, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "state", {
	      placement: null
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "getPortalPlacement", function (_ref7) {
	      var placement = _ref7.placement;
	      var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed
	
	      if (placement !== initialPlacement) {
	        _this2.setState({
	          placement: placement
	        });
	      }
	    });
	
	    return _this2;
	  }
	
	  _createClass(MenuPortal, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        getPortalPlacement: this.getPortalPlacement
	      };
	    } // callback for occassions where the menu must "flip"
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          appendTo = _this$props2.appendTo,
	          children = _this$props2.children,
	          controlElement = _this$props2.controlElement,
	          menuPlacement = _this$props2.menuPlacement,
	          position = _this$props2.menuPosition,
	          getStyles = _this$props2.getStyles;
	      var isFixed = position === 'fixed'; // bail early if required elements aren't present
	
	      if (!appendTo && !isFixed || !controlElement) {
	        return null;
	      }
	
	      var placement = this.state.placement || coercePlacement(menuPlacement);
	
	      var rect = __chunk_1.getBoundingClientObj(controlElement);
	
	      var scrollDistance = isFixed ? 0 : window.pageYOffset;
	      var offset = rect[placement] + scrollDistance;
	      var state = {
	        offset: offset,
	        position: position,
	        rect: rect
	      }; // same wrapper element whether fixed or portalled
	
	      var menuWrapper = core.jsx("div", {
	        css: getStyles('menuPortal', state)
	      }, children);
	      return appendTo ? reactDom.createPortal(menuWrapper, appendTo) : menuWrapper;
	    }
	  }]);
	
	  return MenuPortal;
	}(React.Component);
	
	_defineProperty(MenuPortal, "childContextTypes", {
	  getPortalPlacement: PropTypes.func
	});
	
	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	
	function equal(a, b) {
	  // fast-deep-equal index.js 2.0.1
	  if (a === b) return true;
	
	  if (a && b && _typeof(a) == 'object' && _typeof(b) == 'object') {
	    var arrA = isArray(a),
	        arrB = isArray(b),
	        i,
	        length,
	        key;
	
	    if (arrA && arrB) {
	      length = a.length;
	      if (length != b.length) return false;
	
	      for (i = length; i-- !== 0;) {
	        if (!equal(a[i], b[i])) return false;
	      }
	
	      return true;
	    }
	
	    if (arrA != arrB) return false;
	    var dateA = a instanceof Date,
	        dateB = b instanceof Date;
	    if (dateA != dateB) return false;
	    if (dateA && dateB) return a.getTime() == b.getTime();
	    var regexpA = a instanceof RegExp,
	        regexpB = b instanceof RegExp;
	    if (regexpA != regexpB) return false;
	    if (regexpA && regexpB) return a.toString() == b.toString();
	    var keys = keyList(a);
	    length = keys.length;
	
	    if (length !== keyList(b).length) {
	      return false;
	    }
	
	    for (i = length; i-- !== 0;) {
	      if (!hasProp.call(b, keys[i])) return false;
	    } // end fast-deep-equal
	    // Custom handling for React
	
	
	    for (i = length; i-- !== 0;) {
	      key = keys[i];
	
	      if (key === '_owner' && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner.
	        //  _owner contains circular references
	        // and is not needed when comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of a react element
	        continue;
	      } else {
	        // all other properties should be traversed as usual
	        if (!equal(a[key], b[key])) return false;
	      }
	    } // fast-deep-equal index.js 2.0.1
	
	
	    return true;
	  }
	
	  return a !== a && b !== b;
	} // end fast-deep-equal
	
	
	function exportedEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if (error.message && error.message.match(/stack|recursion/i)) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
	      return false;
	    } // some other error. we should definitely know about these
	
	
	    throw error;
	  }
	}
	
	var containerCSS = function containerCSS(_ref) {
	  var isDisabled = _ref.isDisabled,
	      isRtl = _ref.isRtl;
	  return {
	    label: 'container',
	    direction: isRtl ? 'rtl' : null,
	    pointerEvents: isDisabled ? 'none' : null,
	    // cancel mouse events when disabled
	    position: 'relative'
	  };
	};
	
	var SelectContainer = function SelectContainer(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps,
	      isDisabled = props.isDisabled,
	      isRtl = props.isRtl;
	  return core.jsx("div", _extends({
	    css: getStyles('container', props),
	    className: cx({
	      '--is-disabled': isDisabled,
	      '--is-rtl': isRtl
	    }, className)
	  }, innerProps), children);
	}; // ==============================
	// Value Container
	// ==============================
	
	
	var valueContainerCSS = function valueContainerCSS(_ref2) {
	  var spacing = _ref2.theme.spacing;
	  return {
	    alignItems: 'center',
	    display: 'flex',
	    flex: 1,
	    flexWrap: 'wrap',
	    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
	    WebkitOverflowScrolling: 'touch',
	    position: 'relative',
	    overflow: 'hidden'
	  };
	};
	
	var ValueContainer =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ValueContainer, _Component);
	
	  function ValueContainer() {
	    _classCallCheck(this, ValueContainer);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ValueContainer).apply(this, arguments));
	  }
	
	  _createClass(ValueContainer, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          className = _this$props.className,
	          cx = _this$props.cx,
	          isMulti = _this$props.isMulti,
	          getStyles = _this$props.getStyles,
	          hasValue = _this$props.hasValue;
	      return core.jsx("div", {
	        css: getStyles('valueContainer', this.props),
	        className: cx({
	          'value-container': true,
	          'value-container--is-multi': isMulti,
	          'value-container--has-value': hasValue
	        }, className)
	      }, children);
	    }
	  }]);
	
	  return ValueContainer;
	}(React.Component); // ==============================
	// Indicator Container
	// ==============================
	
	
	var indicatorsContainerCSS = function indicatorsContainerCSS() {
	  return {
	    alignItems: 'center',
	    alignSelf: 'stretch',
	    display: 'flex',
	    flexShrink: 0
	  };
	};
	
	var IndicatorsContainer = function IndicatorsContainer(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles;
	  return core.jsx("div", {
	    css: getStyles('indicatorsContainer', props),
	    className: cx({
	      indicators: true
	    }, className)
	  }, children);
	};
	
	function _templateObject() {
	  var data = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"]);
	
	  _templateObject = function _templateObject() {
	    return data;
	  };
	
	  return data;
	}
	
	var _ref2 =  true ? {
	  name: "19bqh2r",
	  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;"
	} : {
	  name: "19bqh2r",
	  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;",
	  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"
	}; // ==============================
	// Dropdown & Clear Icons
	// ==============================
	
	
	var Svg = function Svg(_ref) {
	  var size = _ref.size,
	      props = _objectWithoutProperties(_ref, ["size"]);
	
	  return core.jsx("svg", _extends({
	    height: size,
	    width: size,
	    viewBox: "0 0 20 20",
	    "aria-hidden": "true",
	    focusable: "false",
	    css: _ref2
	  }, props));
	};
	
	var CrossIcon = function CrossIcon(props) {
	  return core.jsx(Svg, _extends({
	    size: 20
	  }, props), core.jsx("path", {
	    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
	  }));
	};
	
	var DownChevron = function DownChevron(props) {
	  return core.jsx(Svg, _extends({
	    size: 20
	  }, props), core.jsx("path", {
	    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
	  }));
	}; // ==============================
	// Dropdown & Clear Buttons
	// ==============================
	
	
	var baseCSS = function baseCSS(_ref3) {
	  var isFocused = _ref3.isFocused,
	      _ref3$theme = _ref3.theme,
	      baseUnit = _ref3$theme.spacing.baseUnit,
	      colors = _ref3$theme.colors;
	  return {
	    label: 'indicatorContainer',
	    color: isFocused ? colors.neutral60 : colors.neutral20,
	    display: 'flex',
	    padding: baseUnit * 2,
	    transition: 'color 150ms',
	    ':hover': {
	      color: isFocused ? colors.neutral80 : colors.neutral40
	    }
	  };
	};
	
	var dropdownIndicatorCSS = baseCSS;
	
	var DropdownIndicator = function DropdownIndicator(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends({}, innerProps, {
	    css: getStyles('dropdownIndicator', props),
	    className: cx({
	      indicator: true,
	      'dropdown-indicator': true
	    }, className)
	  }), children || core.jsx(DownChevron, null));
	};
	
	var clearIndicatorCSS = baseCSS;
	
	var ClearIndicator = function ClearIndicator(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends({}, innerProps, {
	    css: getStyles('clearIndicator', props),
	    className: cx({
	      indicator: true,
	      'clear-indicator': true
	    }, className)
	  }), children || core.jsx(CrossIcon, null));
	}; // ==============================
	// Separator
	// ==============================
	
	
	var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4) {
	  var isDisabled = _ref4.isDisabled,
	      _ref4$theme = _ref4.theme,
	      baseUnit = _ref4$theme.spacing.baseUnit,
	      colors = _ref4$theme.colors;
	  return {
	    label: 'indicatorSeparator',
	    alignSelf: 'stretch',
	    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
	    marginBottom: baseUnit * 2,
	    marginTop: baseUnit * 2,
	    width: 1
	  };
	};
	
	var IndicatorSeparator = function IndicatorSeparator(props) {
	  var className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return core.jsx("span", _extends({}, innerProps, {
	    css: getStyles('indicatorSeparator', props),
	    className: cx({
	      'indicator-separator': true
	    }, className)
	  }));
	}; // ==============================
	// Loading
	// ==============================
	
	
	var loadingDotAnimations = core.keyframes(_templateObject());
	
	var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5) {
	  var isFocused = _ref5.isFocused,
	      size = _ref5.size,
	      _ref5$theme = _ref5.theme,
	      colors = _ref5$theme.colors,
	      baseUnit = _ref5$theme.spacing.baseUnit;
	  return {
	    label: 'loadingIndicator',
	    color: isFocused ? colors.neutral60 : colors.neutral20,
	    display: 'flex',
	    padding: baseUnit * 2,
	    transition: 'color 150ms',
	    alignSelf: 'center',
	    fontSize: size,
	    lineHeight: 1,
	    marginRight: size,
	    textAlign: 'center',
	    verticalAlign: 'middle'
	  };
	};
	
	var LoadingDot = function LoadingDot(_ref6) {
	  var delay = _ref6.delay,
	      offset = _ref6.offset;
	  return core.jsx("span", {
	    css:
	    /*#__PURE__*/
	    _css({
	      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
	      backgroundColor: 'currentColor',
	      borderRadius: '1em',
	      display: 'inline-block',
	      marginLeft: offset ? '1em' : null,
	      height: '1em',
	      verticalAlign: 'top',
	      width: '1em'
	    },  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
	  });
	};
	
	var LoadingIndicator = function LoadingIndicator(props) {
	  var className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps,
	      isRtl = props.isRtl;
	  return core.jsx("div", _extends({}, innerProps, {
	    css: getStyles('loadingIndicator', props),
	    className: cx({
	      indicator: true,
	      'loading-indicator': true
	    }, className)
	  }), core.jsx(LoadingDot, {
	    delay: 0,
	    offset: isRtl
	  }), core.jsx(LoadingDot, {
	    delay: 160,
	    offset: true
	  }), core.jsx(LoadingDot, {
	    delay: 320,
	    offset: !isRtl
	  }));
	};
	
	LoadingIndicator.defaultProps = {
	  size: 4
	};
	
	var css = function css(_ref) {
	  var isDisabled = _ref.isDisabled,
	      isFocused = _ref.isFocused,
	      _ref$theme = _ref.theme,
	      colors = _ref$theme.colors,
	      borderRadius = _ref$theme.borderRadius,
	      spacing = _ref$theme.spacing;
	  return {
	    label: 'control',
	    alignItems: 'center',
	    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
	    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
	    borderRadius: borderRadius,
	    borderStyle: 'solid',
	    borderWidth: 1,
	    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : null,
	    cursor: 'default',
	    display: 'flex',
	    flexWrap: 'wrap',
	    justifyContent: 'space-between',
	    minHeight: spacing.controlHeight,
	    outline: '0 !important',
	    position: 'relative',
	    transition: 'all 100ms',
	    '&:hover': {
	      borderColor: isFocused ? colors.primary : colors.neutral30
	    }
	  };
	};
	
	var Control = function Control(props) {
	  var children = props.children,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      className = props.className,
	      isDisabled = props.isDisabled,
	      isFocused = props.isFocused,
	      innerRef = props.innerRef,
	      innerProps = props.innerProps,
	      menuIsOpen = props.menuIsOpen;
	  return core.jsx("div", _extends({
	    ref: innerRef,
	    css: getStyles('control', props),
	    className: cx({
	      control: true,
	      'control--is-disabled': isDisabled,
	      'control--is-focused': isFocused,
	      'control--menu-is-open': menuIsOpen
	    }, className)
	  }, innerProps), children);
	};
	
	var groupCSS = function groupCSS(_ref) {
	  var spacing = _ref.theme.spacing;
	  return {
	    paddingBottom: spacing.baseUnit * 2,
	    paddingTop: spacing.baseUnit * 2
	  };
	};
	
	var Group = function Group(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      Heading = props.Heading,
	      headingProps = props.headingProps,
	      label = props.label,
	      theme = props.theme,
	      selectProps = props.selectProps;
	  return core.jsx("div", {
	    css: getStyles('group', props),
	    className: cx({
	      group: true
	    }, className)
	  }, core.jsx(Heading, _extends({}, headingProps, {
	    selectProps: selectProps,
	    theme: theme,
	    getStyles: getStyles,
	    cx: cx
	  }), label), core.jsx("div", null, children));
	};
	
	var groupHeadingCSS = function groupHeadingCSS(_ref2) {
	  var spacing = _ref2.theme.spacing;
	  return {
	    label: 'group',
	    color: '#999',
	    cursor: 'default',
	    display: 'block',
	    fontSize: '75%',
	    fontWeight: '500',
	    marginBottom: '0.25em',
	    paddingLeft: spacing.baseUnit * 3,
	    paddingRight: spacing.baseUnit * 3,
	    textTransform: 'uppercase'
	  };
	};
	
	var GroupHeading = function GroupHeading(props) {
	  var className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      theme = props.theme,
	      selectProps = props.selectProps,
	      cleanProps = _objectWithoutProperties(props, ["className", "cx", "getStyles", "theme", "selectProps"]);
	
	  return core.jsx("div", _extends({
	    css: getStyles('groupHeading', _objectSpread({
	      theme: theme
	    }, cleanProps)),
	    className: cx({
	      'group-heading': true
	    }, className)
	  }, cleanProps));
	};
	
	var inputCSS = function inputCSS(_ref) {
	  var isDisabled = _ref.isDisabled,
	      _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      colors = _ref$theme.colors;
	  return {
	    margin: spacing.baseUnit / 2,
	    paddingBottom: spacing.baseUnit / 2,
	    paddingTop: spacing.baseUnit / 2,
	    visibility: isDisabled ? 'hidden' : 'visible',
	    color: colors.neutral80
	  };
	};
	
	var inputStyle = function inputStyle(isHidden) {
	  return {
	    label: 'input',
	    background: 0,
	    border: 0,
	    fontSize: 'inherit',
	    opacity: isHidden ? 0 : 1,
	    outline: 0,
	    padding: 0,
	    color: 'inherit'
	  };
	};
	
	var Input = function Input(_ref2) {
	  var className = _ref2.className,
	      cx = _ref2.cx,
	      getStyles = _ref2.getStyles,
	      innerRef = _ref2.innerRef,
	      isHidden = _ref2.isHidden,
	      isDisabled = _ref2.isDisabled,
	      theme = _ref2.theme,
	      selectProps = _ref2.selectProps,
	      props = _objectWithoutProperties(_ref2, ["className", "cx", "getStyles", "innerRef", "isHidden", "isDisabled", "theme", "selectProps"]);
	
	  return core.jsx("div", {
	    css: getStyles('input', _objectSpread({
	      theme: theme
	    }, props))
	  }, core.jsx(AutosizeInput, _extends({
	    className: cx({
	      input: true
	    }, className),
	    inputRef: innerRef,
	    inputStyle: inputStyle(isHidden),
	    disabled: isDisabled
	  }, props)));
	};
	
	var multiValueCSS = function multiValueCSS(_ref) {
	  var _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      borderRadius = _ref$theme.borderRadius,
	      colors = _ref$theme.colors;
	  return {
	    label: 'multiValue',
	    backgroundColor: colors.neutral10,
	    borderRadius: borderRadius / 2,
	    display: 'flex',
	    margin: spacing.baseUnit / 2,
	    minWidth: 0 // resolves flex/text-overflow bug
	
	  };
	};
	
	var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
	  var _ref2$theme = _ref2.theme,
	      borderRadius = _ref2$theme.borderRadius,
	      colors = _ref2$theme.colors,
	      cropWithEllipsis = _ref2.cropWithEllipsis;
	  return {
	    borderRadius: borderRadius / 2,
	    color: colors.neutral80,
	    fontSize: '85%',
	    overflow: 'hidden',
	    padding: 3,
	    paddingLeft: 6,
	    textOverflow: cropWithEllipsis ? 'ellipsis' : null,
	    whiteSpace: 'nowrap'
	  };
	};
	
	var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
	  var _ref3$theme = _ref3.theme,
	      spacing = _ref3$theme.spacing,
	      borderRadius = _ref3$theme.borderRadius,
	      colors = _ref3$theme.colors,
	      isFocused = _ref3.isFocused;
	  return {
	    alignItems: 'center',
	    borderRadius: borderRadius / 2,
	    backgroundColor: isFocused && colors.dangerLight,
	    display: 'flex',
	    paddingLeft: spacing.baseUnit,
	    paddingRight: spacing.baseUnit,
	    ':hover': {
	      backgroundColor: colors.dangerLight,
	      color: colors.danger
	    }
	  };
	};
	
	var MultiValueGeneric = function MultiValueGeneric(_ref4) {
	  var children = _ref4.children,
	      innerProps = _ref4.innerProps;
	  return core.jsx("div", innerProps, children);
	};
	
	var MultiValueContainer = MultiValueGeneric;
	var MultiValueLabel = MultiValueGeneric;
	
	var MultiValueRemove =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(MultiValueRemove, _Component);
	
	  function MultiValueRemove() {
	    _classCallCheck(this, MultiValueRemove);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(MultiValueRemove).apply(this, arguments));
	  }
	
	  _createClass(MultiValueRemove, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          innerProps = _this$props.innerProps;
	      return core.jsx("div", innerProps, children || core.jsx(CrossIcon, {
	        size: 14
	      }));
	    }
	  }]);
	
	  return MultiValueRemove;
	}(React.Component);
	
	var MultiValue =
	/*#__PURE__*/
	function (_Component2) {
	  _inherits(MultiValue, _Component2);
	
	  function MultiValue() {
	    _classCallCheck(this, MultiValue);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(MultiValue).apply(this, arguments));
	  }
	
	  _createClass(MultiValue, [{
	    key: "render",
	    value: function render() {
	      var _this = this;
	
	      var _this$props2 = this.props,
	          children = _this$props2.children,
	          className = _this$props2.className,
	          components = _this$props2.components,
	          cx = _this$props2.cx,
	          data = _this$props2.data,
	          getStyles = _this$props2.getStyles,
	          innerProps = _this$props2.innerProps,
	          isDisabled = _this$props2.isDisabled,
	          removeProps = _this$props2.removeProps,
	          selectProps = _this$props2.selectProps;
	      var Container = components.Container,
	          Label = components.Label,
	          Remove = components.Remove;
	      return core.jsx(core.ClassNames, null, function (_ref5) {
	        var css = _ref5.css,
	            emotionCx = _ref5.cx;
	        return core.jsx(Container, {
	          data: data,
	          innerProps: _objectSpread({}, innerProps, {
	            className: emotionCx(css(getStyles('multiValue', _this.props)), cx({
	              'multi-value': true,
	              'multi-value--is-disabled': isDisabled
	            }, className))
	          }),
	          selectProps: selectProps
	        }, core.jsx(Label, {
	          data: data,
	          innerProps: {
	            className: emotionCx(css(getStyles('multiValueLabel', _this.props)), cx({
	              'multi-value__label': true
	            }, className))
	          },
	          selectProps: selectProps
	        }, children), core.jsx(Remove, {
	          data: data,
	          innerProps: _objectSpread({
	            className: emotionCx(css(getStyles('multiValueRemove', _this.props)), cx({
	              'multi-value__remove': true
	            }, className))
	          }, removeProps),
	          selectProps: selectProps
	        }));
	      });
	    }
	  }]);
	
	  return MultiValue;
	}(React.Component);
	
	_defineProperty(MultiValue, "defaultProps", {
	  cropWithEllipsis: true
	});
	
	var optionCSS = function optionCSS(_ref) {
	  var isDisabled = _ref.isDisabled,
	      isFocused = _ref.isFocused,
	      isSelected = _ref.isSelected,
	      _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      colors = _ref$theme.colors;
	  return {
	    label: 'option',
	    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
	    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
	    cursor: 'default',
	    display: 'block',
	    fontSize: 'inherit',
	    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
	    width: '100%',
	    userSelect: 'none',
	    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
	    // provide some affordance on touch devices
	    ':active': {
	      backgroundColor: !isDisabled && (isSelected ? colors.primary : colors.primary50)
	    }
	  };
	};
	
	var Option = function Option(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      isDisabled = props.isDisabled,
	      isFocused = props.isFocused,
	      isSelected = props.isSelected,
	      innerRef = props.innerRef,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends({
	    css: getStyles('option', props),
	    className: cx({
	      option: true,
	      'option--is-disabled': isDisabled,
	      'option--is-focused': isFocused,
	      'option--is-selected': isSelected
	    }, className),
	    ref: innerRef
	  }, innerProps), children);
	};
	
	var placeholderCSS = function placeholderCSS(_ref) {
	  var _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      colors = _ref$theme.colors;
	  return {
	    label: 'placeholder',
	    color: colors.neutral50,
	    marginLeft: spacing.baseUnit / 2,
	    marginRight: spacing.baseUnit / 2,
	    position: 'absolute',
	    top: '50%',
	    transform: 'translateY(-50%)'
	  };
	};
	
	var Placeholder = function Placeholder(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends({
	    css: getStyles('placeholder', props),
	    className: cx({
	      placeholder: true
	    }, className)
	  }, innerProps), children);
	};
	
	var css$1 = function css(_ref) {
	  var isDisabled = _ref.isDisabled,
	      _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      colors = _ref$theme.colors;
	  return {
	    label: 'singleValue',
	    color: isDisabled ? colors.neutral40 : colors.neutral80,
	    marginLeft: spacing.baseUnit / 2,
	    marginRight: spacing.baseUnit / 2,
	    maxWidth: "calc(100% - ".concat(spacing.baseUnit * 2, "px)"),
	    overflow: 'hidden',
	    position: 'absolute',
	    textOverflow: 'ellipsis',
	    whiteSpace: 'nowrap',
	    top: '50%',
	    transform: 'translateY(-50%)'
	  };
	};
	
	var SingleValue = function SingleValue(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      isDisabled = props.isDisabled,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends({
	    css: getStyles('singleValue', props),
	    className: cx({
	      'single-value': true,
	      'single-value--is-disabled': isDisabled
	    }, className)
	  }, innerProps), children);
	};
	
	var components = {
	  ClearIndicator: ClearIndicator,
	  Control: Control,
	  DropdownIndicator: DropdownIndicator,
	  DownChevron: DownChevron,
	  CrossIcon: CrossIcon,
	  Group: Group,
	  GroupHeading: GroupHeading,
	  IndicatorsContainer: IndicatorsContainer,
	  IndicatorSeparator: IndicatorSeparator,
	  Input: Input,
	  LoadingIndicator: LoadingIndicator,
	  Menu: Menu,
	  MenuList: MenuList,
	  MenuPortal: MenuPortal,
	  LoadingMessage: LoadingMessage,
	  NoOptionsMessage: NoOptionsMessage,
	  MultiValue: MultiValue,
	  MultiValueContainer: MultiValueContainer,
	  MultiValueLabel: MultiValueLabel,
	  MultiValueRemove: MultiValueRemove,
	  Option: Option,
	  Placeholder: Placeholder,
	  SelectContainer: SelectContainer,
	  SingleValue: SingleValue,
	  ValueContainer: ValueContainer
	};
	
	var defaultComponents = function defaultComponents(props) {
	  return _objectSpread({}, components, props.components);
	};
	
	exports.MenuPlacer = MenuPlacer;
	exports.clearIndicatorCSS = clearIndicatorCSS;
	exports.components = components;
	exports.containerCSS = containerCSS;
	exports.css = css;
	exports.css$1 = css$1;
	exports.defaultComponents = defaultComponents;
	exports.dropdownIndicatorCSS = dropdownIndicatorCSS;
	exports.exportedEqual = exportedEqual;
	exports.groupCSS = groupCSS;
	exports.groupHeadingCSS = groupHeadingCSS;
	exports.indicatorSeparatorCSS = indicatorSeparatorCSS;
	exports.indicatorsContainerCSS = indicatorsContainerCSS;
	exports.inputCSS = inputCSS;
	exports.loadingIndicatorCSS = loadingIndicatorCSS;
	exports.loadingMessageCSS = loadingMessageCSS;
	exports.menuCSS = menuCSS;
	exports.menuListCSS = menuListCSS;
	exports.menuPortalCSS = menuPortalCSS;
	exports.multiValueCSS = multiValueCSS;
	exports.multiValueLabelCSS = multiValueLabelCSS;
	exports.multiValueRemoveCSS = multiValueRemoveCSS;
	exports.noOptionsMessageCSS = noOptionsMessageCSS;
	exports.optionCSS = optionCSS;
	exports.placeholderCSS = placeholderCSS;
	exports.valueContainerCSS = valueContainerCSS;


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopDefault(ex) {
	  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	__webpack_require__(163);
	
	__webpack_require__(160);
	
	__webpack_require__(237);
	
	__webpack_require__(196);
	
	var _classCallCheck = _interopDefault(__webpack_require__(158));
	
	var _createClass = _interopDefault(__webpack_require__(159));
	
	var _possibleConstructorReturn = _interopDefault(__webpack_require__(164));
	
	var _getPrototypeOf = _interopDefault(__webpack_require__(161));
	
	var _inherits = _interopDefault(__webpack_require__(162));
	
	var _assertThisInitialized = _interopDefault(__webpack_require__(127));
	
	var _defineProperty = _interopDefault(__webpack_require__(128));
	
	var React = __webpack_require__(1);
	
	var React__default = _interopDefault(React);
	
	var memoizeOne = _interopDefault(__webpack_require__(229));
	
	var core = __webpack_require__(167);
	
	__webpack_require__(31);
	
	__webpack_require__(197);
	
	__webpack_require__(165);
	
	__webpack_require__(195);
	
	var __chunk_2 = __webpack_require__(234);
	
	var reactSelect = __webpack_require__(328);
	
	__webpack_require__(131);
	
	__webpack_require__(236);
	
	__webpack_require__(238);
	
	var __chunk_3 = __webpack_require__(329);
	
	var createCache = _interopDefault(__webpack_require__(535));
	
	var NonceProvider =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(NonceProvider, _Component);
	
	  function NonceProvider(props) {
	    var _this;
	
	    _classCallCheck(this, NonceProvider);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(NonceProvider).call(this, props));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "createEmotionCache", function (nonce) {
	      return createCache({
	        nonce: nonce
	      });
	    });
	
	    _this.createEmotionCache = memoizeOne(_this.createEmotionCache);
	    return _this;
	  }
	
	  _createClass(NonceProvider, [{
	    key: "render",
	    value: function render() {
	      var emotionCache = this.createEmotionCache(this.props.nonce);
	      return React__default.createElement(core.CacheProvider, {
	        value: emotionCache
	      }, this.props.children);
	    }
	  }]);
	
	  return NonceProvider;
	}(React.Component);
	
	var index = __chunk_3.manageState(reactSelect.Select);
	
	exports.components = __chunk_2.components;
	exports.createFilter = reactSelect.createFilter;
	exports.defaultTheme = reactSelect.defaultTheme;
	exports.mergeStyles = reactSelect.mergeStyles;
	exports.NonceProvider = NonceProvider;
	exports.default = index;


/***/ },
/* 236 */
/***/ function(module, exports) {

	function _taggedTemplateLiteral(strings, raw) {
	  if (!raw) {
	    raw = strings.slice(0);
	  }
	
	  return Object.freeze(Object.defineProperties(strings, {
	    raw: {
	      value: Object.freeze(raw)
	    }
	  }));
	}
	
	module.exports = _taggedTemplateLiteral;

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	var arrayWithoutHoles = __webpack_require__(2102);
	
	var iterableToArray = __webpack_require__(2103);
	
	var nonIterableSpread = __webpack_require__(2104);
	
	function _toConsumableArray(arr) {
	  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
	}
	
	module.exports = _toConsumableArray;

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(197);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];
	
	var cleanInputProps = function cleanInputProps(inputProps) {
		INPUT_PROPS_BLACKLIST.forEach(function (field) {
			return delete inputProps[field];
		});
		return inputProps;
	};
	
	var copyStyles = function copyStyles(styles, node) {
		node.style.fontSize = styles.fontSize;
		node.style.fontFamily = styles.fontFamily;
		node.style.fontWeight = styles.fontWeight;
		node.style.fontStyle = styles.fontStyle;
		node.style.letterSpacing = styles.letterSpacing;
		node.style.textTransform = styles.textTransform;
	};
	
	var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
	
	var generateId = function generateId() {
		// we only need an auto-generated ID for stylesheet injection, which is only
		// used for IE. so if the browser is not IE, this should return undefined.
		return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
	};
	
	var AutosizeInput = function (_Component) {
		_inherits(AutosizeInput, _Component);
	
		function AutosizeInput(props) {
			_classCallCheck(this, AutosizeInput);
	
			var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
	
			_this.inputRef = function (el) {
				_this.input = el;
				if (typeof _this.props.inputRef === 'function') {
					_this.props.inputRef(el);
				}
			};
	
			_this.placeHolderSizerRef = function (el) {
				_this.placeHolderSizer = el;
			};
	
			_this.sizerRef = function (el) {
				_this.sizer = el;
			};
	
			_this.state = {
				inputWidth: props.minWidth,
				inputId: props.id || generateId()
			};
			return _this;
		}
	
		_createClass(AutosizeInput, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.mounted = true;
				this.copyInputStyles();
				this.updateInputWidth();
			}
		}, {
			key: 'UNSAFE_componentWillReceiveProps',
			value: function UNSAFE_componentWillReceiveProps(nextProps) {
				var id = nextProps.id;
	
				if (id !== this.props.id) {
					this.setState({ inputId: id || generateId() });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevState.inputWidth !== this.state.inputWidth) {
					if (typeof this.props.onAutosize === 'function') {
						this.props.onAutosize(this.state.inputWidth);
					}
				}
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'copyInputStyles',
			value: function copyInputStyles() {
				if (!this.mounted || !window.getComputedStyle) {
					return;
				}
				var inputStyles = this.input && window.getComputedStyle(this.input);
				if (!inputStyles) {
					return;
				}
				copyStyles(inputStyles, this.sizer);
				if (this.placeHolderSizer) {
					copyStyles(inputStyles, this.placeHolderSizer);
				}
			}
		}, {
			key: 'updateInputWidth',
			value: function updateInputWidth() {
				if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
					return;
				}
				var newInputWidth = void 0;
				if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
					newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
				} else {
					newInputWidth = this.sizer.scrollWidth + 2;
				}
				// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
				var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
				newInputWidth += extraWidth;
				if (newInputWidth < this.props.minWidth) {
					newInputWidth = this.props.minWidth;
				}
				if (newInputWidth !== this.state.inputWidth) {
					this.setState({
						inputWidth: newInputWidth
					});
				}
			}
		}, {
			key: 'getInput',
			value: function getInput() {
				return this.input;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.input.focus();
			}
		}, {
			key: 'blur',
			value: function blur() {
				this.input.blur();
			}
		}, {
			key: 'select',
			value: function select() {
				this.input.select();
			}
		}, {
			key: 'renderStyles',
			value: function renderStyles() {
				// this method injects styles to hide IE's clear indicator, which messes
				// with input size detection. the stylesheet is only injected when the
				// browser is IE, and can also be disabled by the `injectStyles` prop.
				var injectStyles = this.props.injectStyles;
	
				return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
					} }) : null;
			}
		}, {
			key: 'render',
			value: function render() {
				var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
					if (previousValue !== null && previousValue !== undefined) {
						return previousValue;
					}
					return currentValue;
				});
	
				var wrapperStyle = _extends({}, this.props.style);
				if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
	
				var inputStyle = _extends({
					boxSizing: 'content-box',
					width: this.state.inputWidth + 'px'
				}, this.props.inputStyle);
	
				var inputProps = _objectWithoutProperties(this.props, []);
	
				cleanInputProps(inputProps);
				inputProps.className = this.props.inputClassName;
				inputProps.id = this.state.inputId;
				inputProps.style = inputStyle;
	
				return _react2.default.createElement(
					'div',
					{ className: this.props.className, style: wrapperStyle },
					this.renderStyles(),
					_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
					_react2.default.createElement(
						'div',
						{ ref: this.sizerRef, style: sizerStyle },
						sizerValue
					),
					this.props.placeholder ? _react2.default.createElement(
						'div',
						{ ref: this.placeHolderSizerRef, style: sizerStyle },
						this.props.placeholder
					) : null
				);
			}
		}]);
	
		return AutosizeInput;
	}(_react.Component);
	
	AutosizeInput.propTypes = {
		className: _propTypes2.default.string, // className for the outer element
		defaultValue: _propTypes2.default.any, // default field value
		extraWidth: _propTypes2.default.oneOfType([// additional width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
		injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
		inputClassName: _propTypes2.default.string, // className for the input element
		inputRef: _propTypes2.default.func, // ref callback for the input element
		inputStyle: _propTypes2.default.object, // css styles for the input element
		minWidth: _propTypes2.default.oneOfType([// minimum width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
		onChange: _propTypes2.default.func, // onChange handler: function(event) {}
		placeholder: _propTypes2.default.string, // placeholder text
		placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
		style: _propTypes2.default.object, // css styles for the outer element
		value: _propTypes2.default.any // field value
	};
	AutosizeInput.defaultProps = {
		minWidth: 1,
		injectStyles: true
	};
	
	exports.default = AutosizeInput;

/***/ },
/* 239 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.ACTION = exports.TYPE = exports.POSITION = void 0;
	var POSITION = {
	  TOP_LEFT: 'top-left',
	  TOP_RIGHT: 'top-right',
	  TOP_CENTER: 'top-center',
	  BOTTOM_LEFT: 'bottom-left',
	  BOTTOM_RIGHT: 'bottom-right',
	  BOTTOM_CENTER: 'bottom-center'
	};
	exports.POSITION = POSITION;
	var TYPE = {
	  INFO: 'info',
	  SUCCESS: 'success',
	  WARNING: 'warning',
	  ERROR: 'error',
	  DEFAULT: 'default'
	};
	exports.TYPE = TYPE;
	var ACTION = {
	  SHOW: 0,
	  CLEAR: 1,
	  DID_MOUNT: 2,
	  WILL_UNMOUNT: 3,
	  ON_CHANGE: 4
	};
	exports.ACTION = ACTION;

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(938);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(2132);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(2131);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(2130);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(937);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(939);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2["default"])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2["default"];
	exports.combineReducers = _combineReducers2["default"];
	exports.bindActionCreators = _bindActionCreators2["default"];
	exports.applyMiddleware = _applyMiddleware2["default"];
	exports.compose = _compose2["default"];

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1583);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!../../less-loader/index.js!./font-awesome.less", function() {
				var newContent = require("!!../../css-loader/index.js!../../less-loader/index.js!./font-awesome.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1621);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./RelatedTransaction.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./RelatedTransaction.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 243 */
/***/ function(module, exports) {

	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};
	
	    if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
	
	          if (desc.get || desc.set) {
	            Object.defineProperty(newObj, key, desc);
	          } else {
	            newObj[key] = obj[key];
	          }
	        }
	      }
	    }
	
	    newObj["default"] = obj;
	    return newObj;
	  }
	}
	
	module.exports = _interopRequireWildcard;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.omitProperty = exports.typeReplacer = exports.typeReviver = exports.prepareArguments = exports.muteProperty = exports.isObject = exports.getPropertiesList = exports.canConfigureName = undefined;
	
	var _canConfigureName2 = __webpack_require__(540);
	
	var _canConfigureName3 = _interopRequireDefault(_canConfigureName2);
	
	var _getPropertiesList2 = __webpack_require__(1003);
	
	var _getPropertiesList3 = _interopRequireDefault(_getPropertiesList2);
	
	var _isObject2 = __webpack_require__(1004);
	
	var _isObject3 = _interopRequireDefault(_isObject2);
	
	var _muteProperty2 = __webpack_require__(1005);
	
	var _muteProperty3 = _interopRequireDefault(_muteProperty2);
	
	var _prepareArguments2 = __webpack_require__(1007);
	
	var _prepareArguments3 = _interopRequireDefault(_prepareArguments2);
	
	var _typeReviver2 = __webpack_require__(1009);
	
	var _typeReviver3 = _interopRequireDefault(_typeReviver2);
	
	var _typeReplacer2 = __webpack_require__(1008);
	
	var _typeReplacer3 = _interopRequireDefault(_typeReplacer2);
	
	var _omitProperty2 = __webpack_require__(1006);
	
	var _omitProperty3 = _interopRequireDefault(_omitProperty2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.canConfigureName = _canConfigureName3.default;
	exports.getPropertiesList = _getPropertiesList3.default;
	exports.isObject = _isObject3.default;
	exports.muteProperty = _muteProperty3.default;
	exports.prepareArguments = _prepareArguments3.default;
	exports.typeReviver = _typeReviver3.default;
	exports.typeReplacer = _typeReplacer3.default;
	exports.omitProperty = _omitProperty3.default;

/***/ },
/* 245 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setInitialStory = setInitialStory;
	exports.setError = setError;
	exports.clearError = clearError;
	exports.selectStory = selectStory;
	var types = exports.types = {
	  SET_ERROR: 'PREVIEW_SET_ERROR',
	  CLEAR_ERROR: 'PREVIEW_CLEAR_ERROR',
	  SELECT_STORY: 'PREVIEW_SELECT_STORY',
	  SET_INITIAL_STORY: 'PREVIEW_SET_INITIAL_STORY'
	};
	
	function setInitialStory(storyKindList) {
	  return {
	    type: types.SET_INITIAL_STORY,
	    storyKindList: storyKindList
	  };
	}
	
	function setError(error) {
	  return {
	    type: types.SET_ERROR,
	    error: error
	  };
	}
	
	function clearError() {
	  return {
	    type: types.CLEAR_ERROR
	  };
	}
	
	function selectStory(kind, story) {
	  return {
	    type: types.SELECT_STORY,
	    kind: kind,
	    story: story
	  };
	}

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable global-require */
	module.exports = {
	  Welcome: __webpack_require__(1045).default,
	  Button: __webpack_require__(1044).default,
	};


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.PureClientCode = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(13);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _clientCodeAction = __webpack_require__(64);
	
	var clientCodeAction = _interopRequireWildcard(_clientCodeAction);
	
	__webpack_require__(2148);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClientCode = function (_Component) {
	  _inherits(ClientCode, _Component);
	
	  function ClientCode(props) {
	    _classCallCheck(this, ClientCode);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.searchDebounce = _lodash2.default.debounce(function (search_string) {
	      _this.getClientCodes(search_string);
	      _this.setState({ searchedStr: search_string });
	    }, 700);
	
	    _this.getUsedCodeForCase = function () {
	      var clientCodeChanged = _lodash2.default.get(window, 'Drupal.settings.clientCodeChanged', false);
	      var searchedClientCode = _lodash2.default.get(window, 'Drupal.settings.clientCode', '');
	      return { clientCodeChanged: clientCodeChanged, searchedClientCode: searchedClientCode };
	    };
	
	    _this.getClientCodes = function (value) {
	      var _this$props = _this.props,
	          hasMadeRequest = _this$props.hasMadeRequest,
	          dispatch = _this$props.dispatch;
	
	      if (!hasMadeRequest) {
	        dispatch(clientCodeAction.getClientCodes(value));
	      }
	    };
	
	    _this.setClientCode = function (code) {
	      var value = code.value;
	      var dispatch = _this.props.dispatch;
	
	      dispatch(clientCodeAction.setClientCode(value));
	      _this.setState({ searchedStr: value }, function () {
	        _this.refs.clientCodeSelectRef.select.closeMenu();
	      });
	    };
	
	    _this.onClientCodeSelected = function (client_code_string) {
	      // when selected is removed from dropdown
	      if (typeof client_code_string === 'function') {
	        // call valReset case where user saves some value
	        client_code_string();
	      }
	      var val = '';
	      if (client_code_string) {
	        var value = client_code_string.value;
	
	        val = value;
	      }
	      _this.setClientCode({ value: val });
	    };
	
	    _this.loadPreviousClientCode = function () {
	      var loadedPrevClientCodeList = _this.props.loadedPrevClientCodeList;
	
	      if (!loadedPrevClientCodeList) {
	        _this.getClientCodes();
	      }
	    };
	
	    _this.resetValue = function () {
	      var value = '';
	      _this.setClientCode({ value: value });
	      _this.props.dispatch(clientCodeAction.getClientCodes(value));
	    };
	
	    _this.promptTextCreator = function (search_string) {
	      var displayVal = 'New code: ' + search_string + ' ';
	      var hasMadeRequest = _this.props.hasMadeRequest;
	      var searchedStr = _this.state.searchedStr;
	
	      if (hasMadeRequest || searchedStr === search_string) {
	        return displayVal;
	      }
	      _this.searchDebounce(search_string);
	      return displayVal;
	    };
	
	    _this.hideClientCodeMsg = function () {
	      _this.setState({ showClientCodeMsg: false });
	    };
	
	    _this.state = {
	      searchedStr: '',
	      showClientCodeMsg: false // show-hide the msg div
	    };
	    return _this;
	  }
	
	  ClientCode.prototype.componentDidMount = function componentDidMount() {
	    var _props = this.props,
	        initialClientCode = _props.initialClientCode,
	        dispatch = _props.dispatch;
	
	
	    if (initialClientCode) {
	      dispatch(clientCodeAction.savedCodes({}, initialClientCode.value));
	    }
	
	    var _getUsedCodeForCase = this.getUsedCodeForCase(),
	        clientCodeChanged = _getUsedCodeForCase.clientCodeChanged,
	        searchedClientCode = _getUsedCodeForCase.searchedClientCode;
	
	    if (clientCodeChanged && searchedClientCode) {
	      document.addEventListener('mousedown', this.hideClientCodeMsg);
	      if (!this.props.ignoreClientCodeAutosetMsg) {
	        this.setState({ showClientCodeMsg: true });
	      }
	    }
	  };
	
	  ClientCode.prototype.componentWillUnmount = function componentWillUnmount() {
	    var _getUsedCodeForCase2 = this.getUsedCodeForCase(),
	        clientCodeChanged = _getUsedCodeForCase2.clientCodeChanged;
	
	    if (clientCodeChanged) document.removeEventListener('mousedown', this.hideClientCodeMsg);
	  };
	
	  ClientCode.prototype.render = function render() {
	    var _props2 = this.props,
	        clientCodeList = _props2.clientCodeList,
	        sessionClientCode = _props2.sessionClientCode,
	        hasMadeRequest = _props2.hasMadeRequest,
	        placeholder = _props2.placeholder,
	        autoFocus = _props2.autoFocus,
	        ignoreClientCodeAutosetMsg = _props2.ignoreClientCodeAutosetMsg,
	        openOnFocus = _props2.openOnFocus;
	
	
	    var clientCodeMsg = _react2.default.createElement('div', null);
	    var _state = this.state,
	        showClientCodeMsg = _state.showClientCodeMsg,
	        searchedStr = _state.searchedStr;
	
	
	    if (showClientCodeMsg) {
	      clientCodeMsg = _react2.default.createElement(
	        'div',
	        { id: 'clientMsg', className: 'highlight', onClick: this.hideClientCodeMsg },
	        _react2.default.createElement(
	          'div',
	          { id: 'clientMsgCloseBtn' },
	          'X'
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'clientCodeMsg' },
	          'Code Client was automatically set to the last one used on this case'
	        )
	      );
	    }
	
	    var _getUsedCodeForCase3 = this.getUsedCodeForCase(),
	        clientCodeChanged = _getUsedCodeForCase3.clientCodeChanged,
	        searchedClientCode = _getUsedCodeForCase3.searchedClientCode;
	
	    var displayCode = sessionClientCode ? sessionClientCode : searchedClientCode;
	
	    var options = [];
	    if (clientCodeList) {
	      options = clientCodeList.reduce(function (accum, next) {
	        var id = next.id,
	            text = next.text,
	            children = next.children;
	
	        if (children) {
	          accum.push({ value: id, label: text, className: 'client-code-option-parent' });
	          var codes = children.map(function (p) {
	            return { value: p.id, label: p.text, className: 'client-code-option-child' };
	          });
	          accum = accum.concat(codes);
	        } else {
	          accum.push({ value: id, label: text });
	        }
	        return accum;
	      }, []);
	    }
	
	    if (displayCode) {
	      var v = _lodash2.default.get(displayCode, 'value', displayCode);
	      options.push({ value: v, label: v, className: 'hello' });
	      options = _lodash2.default.uniqBy(options, 'label');
	    }
	    var value = searchedStr || displayCode;
	
	    var lockedClientCode = this.props.initialClientCode || displayCode;
	
	    return _react2.default.createElement(
	      'div',
	      { className: this.props.className + ' selector-container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'select-wrapper' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'client_code_select',
	            title: 'Search for code you used previously or enter a new one. Only codes that you make a purchase with will be remembered' },
	          'Client Code'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'select-box-container',
	            onClick: this.props.isClientCodeLocked ? function () {
	              return false;
	            } : this.loadPreviousClientCode,
	            title: this.props.isClientCodeLocked ? 'Locked via "Department Code" in your account settings' : ''
	          },
	          this.props.isClientCodeLocked ? _react2.default.createElement(_reactSelect2.default.Creatable, {
	            disabled: true,
	            name: 'client-code',
	            value: lockedClientCode,
	            options: [{ value: lockedClientCode, label: lockedClientCode }],
	            className: 'react-select-container',
	            ref: 'clientCodeSelectRef'
	          }) : _react2.default.createElement(_reactSelect2.default.Creatable, {
	            placeholder: placeholder,
	            name: 'client-code',
	            options: options,
	            promptTextCreator: this.promptTextCreator,
	            value: value,
	            onNewOptionClick: this.setClientCode,
	            clearable: true,
	            onChange: this.onClientCodeSelected,
	            isLoading: hasMadeRequest,
	            onFocus: this.loadPreviousClientCode,
	            searchable: true,
	            backspaceRemoves: true,
	            deleteRemoves: true,
	            resetValue: this.resetValue,
	            className: 'react-select-container',
	            autoFocus: autoFocus,
	            ref: 'clientCodeSelectRef'
	            // openOnFocus={openOnFocus}
	          })
	        )
	      ),
	      clientCodeMsg
	    );
	  };
	
	  return ClientCode;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  var clientCodeReducer = state.get('clientCodeReducer').toJS();
	  var clientCodeList = clientCodeReducer.clientCodeList,
	      hasMadeRequest = clientCodeReducer.hasMadeRequest,
	      loadedPrevClientCodeList = clientCodeReducer.loadedPrevClientCodeList,
	      sessionClientCode = clientCodeReducer.sessionClientCode;
	
	  return {
	    clientCodeList: clientCodeList,
	    hasMadeRequest: hasMadeRequest,
	    loadedPrevClientCodeList: loadedPrevClientCodeList,
	    sessionClientCode: sessionClientCode
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch
	  };
	}
	
	ClientCode.defaultProps = {
	  // these are only being used for the storybook.
	  // set both to true to display the dropdown
	  sessionClientCode: null,
	  placeholder: 'Enter one or select...',
	  autoFocus: false,
	  openOnFocus: false,
	  ignoreClientCodeAutosetMsg: false,
	  className: ''
	};
	
	ClientCode.propTypes = {
	  initialClientCode: _propTypes2.default.string.isRequired,
	  isClientCodeLocked: _propTypes2.default.bool,
	  sessionClientCode: _propTypes2.default.string,
	  clientCodeList: _propTypes2.default.array.isRequired,
	  hasMadeRequest: _propTypes2.default.bool.isRequired,
	  loadedPrevClientCodeList: _propTypes2.default.bool.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  placeholder: _propTypes2.default.string,
	  autoFocus: _propTypes2.default.bool,
	  openOnFocus: _propTypes2.default.bool,
	  ignoreClientCodeAutosetMsg: _propTypes2.default.bool,
	  className: _propTypes2.default.string
	};
	// for storybook without redux wiring
	exports.PureClientCode = ClientCode;
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ClientCode);

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _Selector = __webpack_require__(1105);
	
	var _Selector2 = _interopRequireDefault(_Selector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Selector2.default;

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CasesForm = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _AdvancedSearchHelper = __webpack_require__(79);
	
	var _AdvancedSearchHelper2 = _interopRequireDefault(_AdvancedSearchHelper);
	
	var _formData = __webpack_require__(49);
	
	var _FieldSet = __webpack_require__(63);
	
	var _FieldSet2 = _interopRequireDefault(_FieldSet);
	
	var _fields = __webpack_require__(53);
	
	__webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CasesForm = exports.CasesForm = function CasesForm(_ref) {
	  var filter = _ref.filter,
	      onSubmit = _ref.onSubmit,
	      onReset = _ref.onReset;
	  return _react2.default.createElement(_reactFinalForm.Form, {
	    onSubmit: onSubmit,
	    initialValues: filter,
	    render: function render(_ref2) {
	      var handleSubmit = _ref2.handleSubmit,
	          form = _ref2.form;
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit, className: 'advanced-search-form' },
	        _react2.default.createElement(_fields.InputField, { placeholder: 'Enter case title, party name or case number' }),
	        _react2.default.createElement(_AdvancedSearchHelper2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'advanced-search-filters' },
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Advanced Filters' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.SearchPDFsField, { limitSelectOptions: _formData.limitSelectOptions, disabled: true })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.CasesField, { casefoldersSelectOptions: _formData.casefoldersSelectOptions })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Case Information' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.RegionField, { regionSelectOptions: _formData.regionSelectOptions })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.QueryField, { querySelectOptions: _formData.querySelectOptions, disabled: true })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.ChapterField, { chapterSelectOptions: _formData.chapterSelectOptions })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.TypeField, { caseTypeSelectOptions: _formData.caseTypeSelectOptions })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.CaseTitlesField, { limitSelectOptions: _formData.limitSelectOptions })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.PartyNameField, { limitSelectOptions: _formData.limitSelectOptions })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Financial Filters' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.BusinessOnlyField, { limitSelectOptions: _formData.limitSelectOptions })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.IndustryField, { industrySelectOptions: _formData.industrySelectOptions })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.AssetsField, { assetsLiabilitiesSelectOptions: _formData.assetsLiabilitiesSelectOptions })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.LiabilitiesField, { assetsLiabilitiesSelectOptions: _formData.assetsLiabilitiesSelectOptions })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Date Filters' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Cases filed'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_filed_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_filed_to', placeholderText: 'Through' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Cases closed'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_closed_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_closed_to', placeholderText: 'Through' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Cases dismissed'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_dismissed_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_dismissed_to', placeholderText: 'Through' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Cases discharged'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_discharged_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_discharged_to', placeholderText: 'Through' })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'action-btn-container' },
	          _react2.default.createElement(
	            'button',
	            { type: 'submit', className: 'btn btn-success btn-search' },
	            'Search'
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: 'btn btn-link',
	              onClick: function onClick() {
	                form.reset();
	                onReset();
	              }
	            },
	            'Clear'
	          )
	        )
	      );
	    }
	  });
	};
	
	CasesForm.propTypes = {
	  filter: _propTypes2.default.any.isRequired,
	  onSubmit: _propTypes2.default.func.isRequired,
	  onReset: _propTypes2.default.func.isRequired
	};
	
	exports.default = CasesForm;

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _AdvancedSearchHelper = __webpack_require__(79);
	
	var _AdvancedSearchHelper2 = _interopRequireDefault(_AdvancedSearchHelper);
	
	var _formData = __webpack_require__(49);
	
	var _FieldSet = __webpack_require__(63);
	
	var _FieldSet2 = _interopRequireDefault(_FieldSet);
	
	var _fields = __webpack_require__(53);
	
	__webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GeneralForm = function GeneralForm(_ref) {
	  var filter = _ref.filter,
	      onSubmit = _ref.onSubmit,
	      onReset = _ref.onReset;
	  return _react2.default.createElement(_reactFinalForm.Form, {
	    onSubmit: onSubmit,
	    initialValues: filter,
	    render: function render(_ref2) {
	      var handleSubmit = _ref2.handleSubmit,
	          form = _ref2.form;
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit, className: 'advanced-search-form' },
	        _react2.default.createElement(_fields.InputField, { placeholder: 'Enter Keywords' }),
	        _react2.default.createElement(_AdvancedSearchHelper2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'advanced-search-filters' },
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Advanced Filters' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.SearchPDFsField, { limitSelectOptions: _formData.limitSelectOptions })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.CasesField, { casefoldersSelectOptions: _formData.casefoldersSelectOptions })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Case Information' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.RegionField, { regionSelectOptions: _formData.regionSelectOptions })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.QueryField, { querySelectOptions: _formData.querySelectOptions })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.ChapterField, { chapterSelectOptions: _formData.chapterSelectOptions })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.TypeField, { caseTypeSelectOptions: _formData.caseTypeSelectOptions })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.CaseTitlesField, { limitSelectOptions: _formData.limitSelectOptions })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Financial Filters' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.BusinessOnlyField, { limitSelectOptions: _formData.limitSelectOptions })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.IndustryField, { industrySelectOptions: _formData.industrySelectOptions })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.AssetsField, { assetsLiabilitiesSelectOptions: _formData.assetsLiabilitiesSelectOptions })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.LiabilitiesField, { assetsLiabilitiesSelectOptions: _formData.assetsLiabilitiesSelectOptions })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Date Filters' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Cases filed'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_filed_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_filed_to', placeholderText: 'Through' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Cases closed'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_closed_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_closed_to', placeholderText: 'Through' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Cases dismissed'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_dismissed_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_dismissed_to', placeholderText: 'Through' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Cases discharged'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_discharged_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_discharged_to', placeholderText: 'Through' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Documents filed'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_doc_filed_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_doc_filed_to', placeholderText: 'Through' })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'action-btn-container' },
	          _react2.default.createElement(
	            'button',
	            { type: 'submit', className: 'btn btn-success btn-search' },
	            'Search'
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: 'btn btn-link',
	              onClick: function onClick() {
	                form.reset();
	                onReset();
	              }
	            },
	            'Clear'
	          )
	        )
	      );
	    }
	  });
	};
	
	GeneralForm.propTypes = {
	  filter: _propTypes2.default.any.isRequired,
	  onSubmit: _propTypes2.default.func.isRequired,
	  onReset: _propTypes2.default.func.isRequired
	};
	
	exports.default = GeneralForm;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _globalUtils = __webpack_require__(59);
	
	var _AdvancedSearchHelper = __webpack_require__(79);
	
	var _AdvancedSearchHelper2 = _interopRequireDefault(_AdvancedSearchHelper);
	
	var _formData = __webpack_require__(49);
	
	var _FieldSet = __webpack_require__(63);
	
	var _FieldSet2 = _interopRequireDefault(_FieldSet);
	
	var _fields = __webpack_require__(53);
	
	__webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PetitionsForm = function PetitionsForm(_ref) {
	  var filter = _ref.filter,
	      onSubmit = _ref.onSubmit,
	      onReset = _ref.onReset;
	  return _react2.default.createElement(_reactFinalForm.Form, {
	    onSubmit: onSubmit,
	    initialValues: filter,
	    render: function render(_ref2) {
	      var handleSubmit = _ref2.handleSubmit,
	          form = _ref2.form;
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit, className: 'advanced-search-form' },
	        _react2.default.createElement(_fields.InputField, { placeholder: 'Enter Keywords' }),
	        _react2.default.createElement(_AdvancedSearchHelper2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'advanced-search-filters' },
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Advanced Filters' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.SearchPDFsField, { limitSelectOptions: _formData.limitSelectOptions, disabled: true })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.CasesField, { casefoldersSelectOptions: _formData.casefoldersSelectOptions })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Case Information' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.RegionField, { regionSelectOptions: _formData.regionSelectOptions })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.QueryField, { querySelectOptions: _formData.querySelectOptions, disabled: true })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.ChapterField, { chapterSelectOptions: _formData.chapterSelectOptions })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.TypeField, { caseTypeSelectOptions: _formData.caseTypeSelectOptions })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.CaseTitlesField, { limitSelectOptions: _formData.limitSelectOptions, disabled: true })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Financial Filters' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.BusinessOnlyField, { limitSelectOptions: _formData.limitSelectOptions, disabled: true })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.IndustryField, { industrySelectOptions: _formData.industrySelectOptions })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.AssetsField, { assetsLiabilitiesSelectOptions: _formData.assetsLiabilitiesSelectOptions })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.LiabilitiesField, { assetsLiabilitiesSelectOptions: _formData.assetsLiabilitiesSelectOptions })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Date Filters' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Cases filed'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_filed_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_filed_to', placeholderText: 'Through' })
	              )
	            ),
	            !(0, _globalUtils.isCourtDrive)() && _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Open cases'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'open_cases_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'open_cases_to', placeholderText: 'Through' })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'action-btn-container' },
	          _react2.default.createElement(
	            'button',
	            { type: 'submit', className: 'btn btn-success btn-search' },
	            'Search'
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: 'btn btn-link',
	              onClick: function onClick() {
	                form.reset();
	                onReset();
	              }
	            },
	            'Clear'
	          )
	        )
	      );
	    }
	  });
	};
	
	PetitionsForm.propTypes = {
	  filter: _propTypes2.default.any.isRequired,
	  onSubmit: _propTypes2.default.func.isRequired,
	  onReset: _propTypes2.default.func.isRequired
	};
	
	exports.default = PetitionsForm;

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Snippet = function (_Component) {
	  _inherits(Snippet, _Component);
	
	  function Snippet(props) {
	    _classCallCheck(this, Snippet);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = { page: 0 };
	    return _this;
	  }
	
	  Snippet.prototype.render = function render() {
	    var _this2 = this;
	
	    var part = this.props.part;
	
	    var snippets = Array.isArray(part.attachment) ? part.attachment : [part.attachment];
	    var page = this.state.page;
	
	    var setTags = function setTags(str) {
	      return str.replace(/\[HIGHLIGHT\]/g, '<span class="highlight">').replace(/\[\/HIGHLIGHT\]/g, '</span>');
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'attachment-matches-wrapper' },
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('img', { src: '/sites/all/modules/custom/ir_search/css/images/pdficon.png', alt: '' }),
	        _react2.default.createElement(
	          'a',
	          { href: '#', className: 'preview-matches' },
	          ' Preview ' + snippets.length + ' ' + (snippets.length === 1 ? 'match' : ' matches') + '\n               within document part ' + part.part_number + ' ' + part.part_description
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'attachment-matches' },
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: setTags(snippets[page]) } }),
	        _react2.default.createElement(
	          'p',
	          { className: 'attachment-pager' },
	          _react2.default.createElement(
	            'a',
	            { href: '#', onClick: function onClick(e) {
	                e.preventDefault();
	                _this2.setState({ page: page === 0 ? page : page - 1 });
	              } },
	            '\xAB'
	          ),
	          'Result ',
	          page + 1,
	          '/',
	          snippets.length,
	          _react2.default.createElement(
	            'a',
	            { href: '#', onClick: function onClick(e) {
	                e.preventDefault();
	                _this2.setState({ page: page === snippets.length - 1 ? page : page + 1 });
	              } },
	            '\xBB'
	          )
	        )
	      )
	    );
	  };
	
	  return Snippet;
	}(_react.Component);
	
	exports.default = Snippet;

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _LoadingBar = __webpack_require__(91);
	
	var _LoadingBar2 = _interopRequireDefault(_LoadingBar);
	
	var _AlertError = __webpack_require__(50);
	
	var _AlertError2 = _interopRequireDefault(_AlertError);
	
	var _UpdateFromPacer = __webpack_require__(70);
	
	var _UpdateFromPacer2 = _interopRequireDefault(_UpdateFromPacer);
	
	var _FilterTable = __webpack_require__(80);
	
	var _FilterTable2 = _interopRequireDefault(_FilterTable);
	
	__webpack_require__(2171);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DeadlineCases = function (_Component) {
	  _inherits(DeadlineCases, _Component);
	
	  function DeadlineCases() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DeadlineCases);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getTableBody = function (data) {
	      if (data.length === 0) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'ir-search-status-message messages warning' },
	            _this.props.noDataFoundMessage
	          )
	        );
	      }
	      if (data.empty) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'ir-search-status-message messages warning' },
	            data.empty
	          )
	        );
	      }
	
	      var rows = data.map(function (item, key) {
	        return _react2.default.createElement(
	          'tr',
	          { key: key },
	          _react2.default.createElement(
	            'td',
	            null,
	            item.doc_no || ''
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            item.event_name || ''
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            item.date_event_filed || ''
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            item.date_due_set || ''
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            item.date_satisfied || ''
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            item.date_terminated || ''
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            item.hearing_judge || ''
	          )
	        );
	      });
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _FilterTable2.default,
	          { premiumSearch: { uuid: _this.props.case_uuid, query: _this.props.type } },
	          _react2.default.createElement(
	            'table',
	            { className: 'sticky-enabled tablesorter' },
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Doc.No'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Deadline/Hearing'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Event Filed'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Due/Set'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Satisfied'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Terminated'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Hearing Judge'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              rows
	            )
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  DeadlineCases.prototype.render = function render() {
	    var _props = this.props,
	        dataReady = _props.dataReady,
	        error = _props.error,
	        deadlines = _props.deadlines;
	
	    if (!dataReady) return _react2.default.createElement(_LoadingBar2.default, null);
	    if (!_lodash2.default.isEmpty(error)) return _react2.default.createElement(_AlertError2.default, { errors: error });
	    var tableData = deadlines || [];
	    var sortedTableData = tableData.empty ? tableData : _lodash2.default.sortBy(tableData, function (deadline) {
	      return new Date(deadline.date_due_set);
	    }).reverse();
	    return _react2.default.createElement(
	      'div',
	      { className: this.props.type },
	      this.getTableBody(sortedTableData),
	      _react2.default.createElement(_UpdateFromPacer2.default, {
	        pacerUpdateHandler: this.props.purchaseData,
	        pacerReceipt: this.props.receipt,
	        lastUpdated: this.props.lastUpdated })
	    );
	  };
	
	  return DeadlineCases;
	}(_react.Component);
	
	;
	
	DeadlineCases.defaultProps = {
	  error: null,
	  receipt: null,
	  type: 'schedule'
	};
	
	DeadlineCases.propTypes = {
	  case_uuid: _propTypes2.default.string.isRequired,
	  dataReady: _propTypes2.default.bool.isRequired,
	  deadlines: _propTypes2.default.any.isRequired,
	  receipt: _propTypes2.default.any,
	  lastUpdated: _propTypes2.default.any.isRequired,
	  type: _propTypes2.default.string,
	  noDataFoundMessage: _propTypes2.default.string.isRequired,
	  error: _propTypes2.default.any,
	  purchaseData: _propTypes2.default.func.isRequired
	};
	
	exports.default = DeadlineCases;

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDatepicker = __webpack_require__(78);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _globalUtils = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(104);
	__webpack_require__(130);
	
	var getAdvancedSearchAllCourtsLink = function getAdvancedSearchAllCourtsLink(keyword, caseUuid) {
	  return '/advanced-search?keys=' + (keyword || '*') + '&court_type=&search_pdfs=include&query[]=dockets&template=general&case_uuid=' + caseUuid + '&do_search=1';
	};
	
	var getAdvancedSearchBankruptcyLink = function getAdvancedSearchBankruptcyLink(keyword, caseUuid) {
	  return '/advanced-search?keys=' + (keyword || '*') + '&court_type=bankruptcy&search_pdfs=include&query[]=dockets&template=general&case_uuid=' + caseUuid + '&do_search=1';
	};
	
	var DocketFilters = function (_Component) {
	  _inherits(DocketFilters, _Component);
	
	  function DocketFilters() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DocketFilters);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.changeText = function (e) {
	      e.persist();
	      _this.props.onChange(e, 'search_keyword');
	    }, _this.keydown = function (e) {
	      // only respond to tabbing through or enter.
	      // Sometimes we need to blur out for other clicks that dont trigger a buy (ie cancel button)
	      if (e.keyCode === 13 || e.keyCode === 9) {
	        _this.props.getFilteredDockets();
	      }
	    }, _this.handleSubmit = function (e) {
	      var getFilteredDockets = _this.props.getFilteredDockets;
	
	      e.preventDefault();
	      getFilteredDockets();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  DocketFilters.prototype.render = function render() {
	    var _props = this.props,
	        keyword = _props.keyword,
	        doc_range = _props.doc_range,
	        date_filed_from = _props.date_filed_from,
	        date_filed_to = _props.date_filed_to,
	        changeDate = _props.changeDate,
	        onChangeDateRaw = _props.onChangeDateRaw,
	        _onChange = _props.onChange,
	        onClear = _props.onClear,
	        caseUuid = _props.caseUuid;
	
	
	    return _react2.default.createElement(
	      'div',
	      { id: 'docket-filters' },
	      _react2.default.createElement(
	        'form',
	        { id: 'parser-docket-form', onSubmit: this.handleSubmit },
	        _react2.default.createElement(
	          'span',
	          { className: 'form-group' },
	          _react2.default.createElement('input', {
	            type: 'text',
	            name: 'keyword',
	            id: 'alfresco-keyword',
	            className: 'form-text',
	            size: '30',
	            value: keyword,
	            onKeyDown: this.keydown,
	            onChange: this.changeText,
	            placeholder: 'Enter Keywords'
	          }),
	          _react2.default.createElement(
	            'a',
	            {
	              href: (0, _globalUtils.isCourtDrive)() ? getAdvancedSearchAllCourtsLink(keyword, caseUuid) : getAdvancedSearchBankruptcyLink(keyword, caseUuid),
	              title: 'Go to Advanced Search'
	            },
	            _react2.default.createElement('i', { className: 'fa fa-search' })
	          )
	        ),
	        _react2.default.createElement('input', {
	          type: 'text',
	          name: 'doc_range',
	          id: 'alfresco-doc-range',
	          size: '20',
	          className: 'form-text valid',
	          value: doc_range,
	          onChange: function onChange(e) {
	            return _onChange(e, 'doc_range');
	          },
	          onKeyDown: this.keydown,
	          placeholder: 'Doc# Ex: 1,3,4-7'
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'date-selector' },
	          _react2.default.createElement(_reactDatepicker2.default, {
	            selected: date_filed_from,
	            onChange: changeDate.bind(null, 'date_filed_from'),
	            dateFormat: 'MM/DD/YYYY',
	            className: '',
	            placeholderText: 'date',
	            onChangeRaw: onChangeDateRaw.bind(null, 'date_filed_from')
	          })
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          '\xA0to\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'date-selector' },
	          _react2.default.createElement(_reactDatepicker2.default, {
	            selected: date_filed_to,
	            onChange: changeDate.bind(null, 'date_filed_to'),
	            dateFormat: 'MM/DD/YYYY',
	            className: '',
	            placeholderText: 'date',
	            onChangeRaw: onChangeDateRaw.bind(null, 'date_filed_to')
	          })
	        ),
	        _react2.default.createElement(
	          'button',
	          { type: 'submit', className: 'form-submit', value: 'Submit' },
	          _react2.default.createElement('span', { className: 'magnifier icon' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'alfresco-clear', className: 'clear-button', onClick: onClear },
	          'clear'
	        )
	      )
	    );
	  };
	
	  return DocketFilters;
	}(_react.Component);
	
	DocketFilters.defaultProps = {
	  date_filed_from: null,
	  date_filed_to: null
	};
	
	DocketFilters.propTypes = {
	  keyword: _propTypes2.default.string.isRequired,
	  doc_range: _propTypes2.default.string.isRequired,
	  changeDate: _propTypes2.default.func.isRequired,
	  onChangeDateRaw: _propTypes2.default.func.isRequired,
	  onChange: _propTypes2.default.func.isRequired,
	  onClear: _propTypes2.default.func.isRequired,
	  getFilteredDockets: _propTypes2.default.func.isRequired,
	  date_filed_from: _propTypes2.default.object,
	  date_filed_to: _propTypes2.default.object
	};
	
	exports.default = DocketFilters;

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ToolbarButtons = __webpack_require__(385);
	
	var _ToolbarButtons2 = _interopRequireDefault(_ToolbarButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DocketsPaginator = function (_Component) {
	  _inherits(DocketsPaginator, _Component);
	
	  function DocketsPaginator(props) {
	    _classCallCheck(this, DocketsPaginator);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  DocketsPaginator.prototype.render = function render() {
	    var _props = this.props,
	        total_pages = _props.total_pages,
	        visibleDocketNums = _props.visibleDocketNums,
	        selectedPageNum = _props.selectedPageNum,
	        changePage = _props.changePage,
	        case_uuid = _props.case_uuid,
	        court_code = _props.court_code,
	        case_number = _props.case_number,
	        hasToolbar = _props.hasToolbar,
	        toggleHeader = _props.toggleHeader,
	        onPopupClick = _props.onPopupClick,
	        getDocketParts = _props.getDocketParts,
	        updateDocketParts = _props.updateDocketParts;
	
	
	    var numPages = Math.ceil(total_pages);
	    var pageRange = _lodash2.default.range(numPages);
	    var nextPage = selectedPageNum + 1;
	    var prevPage = selectedPageNum - 1;
	    var lastPage = pageRange[pageRange.length - 1] + 1;
	
	    var max = 6;
	
	    var pageIconCount = numPages <= max ? numPages : max;
	
	    var paginatorItems = _lodash2.default.range(pageIconCount);
	
	    if (selectedPageNum < max) {
	      // take 1-9 + numPages
	      paginatorItems = paginatorItems.map(function (el, idx) {
	        if (idx === paginatorItems.length - 1) {
	          return numPages;
	        }
	        return idx + 1;
	      });
	    } else if (selectedPageNum >= numPages - (max + 2)) {
	      // 1 + take currPage - max   (ex: 14)
	      // 1 + take curr Page - max  (ex 10) with 12
	      paginatorItems = paginatorItems.map(function (el, idx) {
	        if (idx === paginatorItems.length - 1) {
	          return 1;
	        }
	        return selectedPageNum - idx;
	      }).reverse();
	    } else {
	      // ex case 13
	      // 1.. (1-4 range) currPage (1-4 range)..max
	      // 1,...  9, 10, 11, 12, 13, 14, 15, 16, 17, ..22
	      paginatorItems = paginatorItems.map(function (el, idx) {
	        if (idx === 0) {
	          return 1;
	        }
	        if (idx === paginatorItems.length - 1) {
	          return numPages;
	        }
	        return selectedPageNum + idx - 3;
	      });
	    }
	
	    paginatorItems = paginatorItems.reduce(function (accum, el, idx) {
	      var key = 'paginator-item' + idx;
	      var item = { page: el, active: selectedPageNum === el };
	      var clsName = item.active ? 'active item' : 'item';
	
	      if (idx !== 0 && paginatorItems[idx - 1] !== paginatorItems[idx] - 1) {
	        return accum.concat([_react2.default.createElement(
	          'span',
	          { className: 'item ellipse', key: key + '-ellipse' },
	          '...'
	        ), _react2.default.createElement(
	          'span',
	          {
	            key: key,
	            className: clsName,
	            onClick: function onClick() {
	              changePage({}, { page: el - 1, page_index: el });
	            } },
	          el
	        )]);
	      }
	      return accum.concat([_react2.default.createElement(
	        'span',
	        {
	          key: key,
	          className: clsName,
	          onClick: function onClick() {
	            changePage({}, { page: el - 1, page_index: el });
	          } },
	        el
	      )]);
	    }, []);
	
	    var paginator = paginatorItems;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'docket-pagination' },
	      _react2.default.createElement(
	        'div',
	        { className: 'ui small borderless menu', id: 'docket-toolbar' },
	        hasToolbar && _react2.default.createElement(_ToolbarButtons2.default, {
	          visibleDocketNums: visibleDocketNums,
	          case_uuid: case_uuid,
	          court_code: court_code,
	          case_number: case_number,
	          onPopupClick: onPopupClick,
	          toggleHeader: toggleHeader,
	          updateDocketParts: updateDocketParts,
	          getDocketParts: getDocketParts
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'item ' + (selectedPageNum === 1 ? 'disabled' : ''),
	            title: 'Go to previous page',
	            onClick: function onClick() {
	              if (selectedPageNum !== 1) {
	                changePage({}, { page: prevPage - 1, page_index: prevPage });
	              }
	            } },
	          '\u2190'
	        ),
	        paginator,
	        numPages > 1 && _react2.default.createElement(
	          'div',
	          { className: 'view-all item',
	            onClick: changePage.bind(null, {}, { page_index: 0, page_size: 2500 }) },
	          'View all'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'item ' + (selectedPageNum === lastPage ? 'disabled' : ''),
	            title: 'Go to next page',
	            onClick: function onClick() {
	              if (selectedPageNum !== lastPage) {
	                changePage({}, { page: selectedPageNum, page_index: nextPage });
	              }
	            } },
	          '\u2192'
	        )
	      )
	    );
	  };
	
	  return DocketsPaginator;
	}(_react.Component);
	
	DocketsPaginator.defaultProps = {
	  hasToolbar: false
	};
	
	DocketsPaginator.propTypes = {
	  total_pages: _propTypes2.default.number.isRequired,
	  visibleDocketNums: _propTypes2.default.array.isRequired,
	  case_uuid: _propTypes2.default.string.isRequired,
	  selectedPageNum: _propTypes2.default.number.isRequired,
	  changePage: _propTypes2.default.func.isRequired,
	  toggleHeader: _propTypes2.default.func.isRequired,
	  onPopupClick: _propTypes2.default.func.isRequired,
	  hasToolbar: _propTypes2.default.bool
	};
	
	exports.default = DocketsPaginator;

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(104);
	__webpack_require__(130);
	
	function Flash(_ref) {
	  var show = _ref.show,
	      msg = _ref.msg;
	
	  if (show) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'email-pdf-alert flash-success' },
	      _react2.default.createElement(
	        'div',
	        { className: 'alert alert-success' },
	        msg
	      )
	    );
	  }
	  return null;
	}
	
	Flash.defaultProps = {
	  show: false,
	  msg: ''
	};
	
	Flash.propTypes = {
	  show: _propTypes2.default.bool,
	  msg: _propTypes2.default.string
	};
	
	exports.default = Flash;

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextHighlight = function (_Component) {
	  _inherits(TextHighlight, _Component);
	
	  function TextHighlight() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TextHighlight);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.refreshHighlightedText = function () {
	      var node = _this.props.getParentNode();
	      window.$(node.current).removeHighlight();
	      _this.highlightNode(node);
	    }, _this.highlightNode = _.debounce(function (node) {
	      var searchString = _this.props.searchKeywords.toLowerCase();
	      var words = searchString.split(' ').filter(function (p) {
	        return p !== '';
	      }).reverse();
	
	      words.forEach(function (word) {
	        window.$(node.current).highlight(word);
	      });
	    }, 400), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  TextHighlight.prototype.componentDidMount = function componentDidMount() {
	    this.refreshHighlightedText();
	  };
	
	  TextHighlight.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this.props.searchKeywords !== prevProps.searchKeywords) {
	      this.refreshHighlightedText();
	    }
	  };
	
	  TextHighlight.prototype.render = function render() {
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      this.props.children
	    );
	  };
	
	  return TextHighlight;
	}(_react.Component);
	
	TextHighlight.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  searchKeywords: _propTypes2.default.string.isRequired,
	  getParentNode: _propTypes2.default.func.isRequired
	};
	
	exports.default = TextHighlight;

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Documents = __webpack_require__(201);
	
	var _Documents2 = _interopRequireDefault(_Documents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DocumentsRow = function DocumentsRow(_ref) {
	  var id = _ref.id,
	      binder = _ref.binder,
	      case_uuid = _ref.case_uuid,
	      court_code = _ref.court_code,
	      case_number = _ref.case_number,
	      docket_seq = _ref.docket_seq,
	      docket = _ref.docket;
	
	  if (binder && binder.documents && binder.documents.length > 0) {
	    return _react2.default.createElement(
	      'tr',
	      { key: 'documents-row-' + id, className: 'docket_details dockets-documents-row no-filter-search' },
	      _react2.default.createElement('td', { colSpan: '2' }),
	      _react2.default.createElement(
	        'td',
	        { className: 'here', colSpan: '100%' },
	        _react2.default.createElement(
	          'table',
	          { className: 'sticky-enabled' },
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              { key: 'details-desc-' + id, className: 'no-filter-search' },
	              _react2.default.createElement('th', null),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Part'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Description'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Pages'
	              ),
	              _react2.default.createElement(
	                'th',
	                { width: '40%' },
	                'Action'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            _react2.default.createElement(_Documents2.default, {
	              documents: binder.documents,
	              case_uuid: case_uuid,
	              court_code: court_code,
	              case_number: case_number,
	              docket_seq: docket_seq,
	              docket: docket
	            })
	          )
	        )
	      )
	    );
	  }
	
	  return _react2.default.createElement(
	    'tr',
	    { key: 'documents-row-' + id, className: 'docket_details no-filter-search ' },
	    _react2.default.createElement('td', { colSpan: '2' }),
	    _react2.default.createElement(
	      'td',
	      { className: 'here', colSpan: '100%' },
	      'No Accessible Documents Found'
	    )
	  );
	};
	
	DocumentsRow.propTypes = {
	  id: _propTypes2.default.string.isRequired,
	  binder: _propTypes2.default.object.isRequired,
	  case_uuid: _propTypes2.default.string.isRequired,
	  court_code: _propTypes2.default.string.isRequired,
	  case_number: _propTypes2.default.string.isRequired,
	  docket_seq: _propTypes2.default.string.isRequired
	};
	
	exports.default = DocumentsRow;

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _docketActions = __webpack_require__(42);
	
	var docketActions = _interopRequireWildcard(_docketActions);
	
	var _EmailCombinedPdfPopup = __webpack_require__(173);
	
	var _EmailCombinedPdfPopup2 = _interopRequireDefault(_EmailCombinedPdfPopup);
	
	var _AllPartsPrintPreview = __webpack_require__(133);
	
	var _AllPartsPrintPreview2 = _interopRequireDefault(_AllPartsPrintPreview);
	
	var _DownloadZipAllPdfsRangePopup = __webpack_require__(134);
	
	var _DownloadZipAllPdfsRangePopup2 = _interopRequireDefault(_DownloadZipAllPdfsRangePopup);
	
	var _DownloadZipWithSubpartsPopup = __webpack_require__(135);
	
	var _DownloadZipWithSubpartsPopup2 = _interopRequireDefault(_DownloadZipWithSubpartsPopup);
	
	var _DownloadCombineAllPdfInRangePopup = __webpack_require__(171);
	
	var _DownloadCombineAllPdfInRangePopup2 = _interopRequireDefault(_DownloadCombineAllPdfInRangePopup);
	
	var _PrintAllPdfInRangePopup = __webpack_require__(175);
	
	var _PrintAllPdfInRangePopup2 = _interopRequireDefault(_PrintAllPdfInRangePopup);
	
	var _EmailPartPopup = __webpack_require__(174);
	
	var _EmailPartPopup2 = _interopRequireDefault(_EmailPartPopup);
	
	var _EmailPartModal = __webpack_require__(136);
	
	var _EmailPartModal2 = _interopRequireDefault(_EmailPartModal);
	
	var _EmailAllPartsZipPopup = __webpack_require__(172);
	
	var _EmailAllPartsZipPopup2 = _interopRequireDefault(_EmailAllPartsZipPopup);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DocketPopup = function DocketPopup(_ref) {
	  var onPopupClick = _ref.onPopupClick,
	      popup = _ref.popup,
	      reloadDetails = _ref.reloadDetails;
	
	  var popupForm = {
	    EmailCombinedPdfPopup: _EmailCombinedPdfPopup2.default,
	    AllPartsPrintPreview: _AllPartsPrintPreview2.default,
	    DownloadZipAllPdfsRangePopup: _DownloadZipAllPdfsRangePopup2.default,
	    DownloadZipWithSubpartsPopup: _DownloadZipWithSubpartsPopup2.default,
	    DownloadCombineAllPdfInRangePopup: _DownloadCombineAllPdfInRangePopup2.default,
	    PrintAllPdfInRangePopup: _PrintAllPdfInRangePopup2.default,
	    EmailPartPopup: _EmailPartPopup2.default,
	    EmailPartModal: _EmailPartModal2.default,
	    EmailAllPartsZipPopup: _EmailAllPartsZipPopup2.default
	  };
	  var DocketsPopupComponentType = popup.show && popupForm[popup.name];
	
	  return DocketsPopupComponentType && _react2.default.createElement(DocketsPopupComponentType, { onClose: onPopupClick, info: popup, reloadDetails: reloadDetails });
	};
	
	DocketPopup.propTypes = {
	  popup: _propTypes2.default.object.isRequired,
	  reloadDetails: _propTypes2.default.func
	};
	
	DocketPopup.defaultProps = {
	  reloadDetails: function reloadDetails() {}
	};
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$get$toJS = state.get('dockets').toJS(),
	      popup = _state$get$toJS.popup;
	
	  return {
	    popup: popup
	  };
	};
	
	var mapDispatchToProps = {
	  onPopupClick: docketActions.togglePopup
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DocketPopup);

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _get = __webpack_require__(310);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _ClientCode = __webpack_require__(247);
	
	var _ClientCode2 = _interopRequireDefault(_ClientCode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmailAttachmentPurchaseForm = function (_Component) {
	  _inherits(EmailAttachmentPurchaseForm, _Component);
	
	  function EmailAttachmentPurchaseForm() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EmailAttachmentPurchaseForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderAlreadyPurchased = function () {
	      var _this$props = _this.props,
	          entries = _this$props.entries,
	          selectedDocket = _this$props.selectedDocket,
	          emailActionName = _this$props.emailActionName;
	
	      var _entries$data$find = entries.data.find(function (docket) {
	        return docket.docket_seq === selectedDocket.docket_seq;
	      }),
	          pdf_filename = _entries$data$find.pdf_filename,
	          pdf_download_url = _entries$data$find.pdf_download_url,
	          zip_filename = _entries$data$find.zip_filename,
	          zip_download_url = _entries$data$find.zip_download_url;
	
	      if (emailActionName === 'emailPartsPdfCombined' && pdf_filename && pdf_download_url) {
	        return _react2.default.createElement(
	          'a',
	          { href: pdf_download_url },
	          pdf_filename
	        );
	      }
	      if (emailActionName === 'emailPartsZip' && zip_filename && zip_download_url) {
	        return _react2.default.createElement(
	          'a',
	          { href: zip_download_url },
	          zip_filename
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        'Already Purchased'
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  EmailAttachmentPurchaseForm.prototype.render = function render() {
	    var docketParts = this.props.docketParts;
	    var partsToPurchase = docketParts.partsToPurchase,
	        totalCost = docketParts.totalCost,
	        totalParts = docketParts.totalParts,
	        errors = docketParts.errors,
	        step = docketParts.step,
	        status = docketParts.status,
	        purchased = docketParts.purchased,
	        alreadyPurchased = docketParts.alreadyPurchased;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'inner-text' },
	      this.props.showXfaWarning && _react2.default.createElement(
	        'div',
	        { className: 'warning' },
	        'PDF combining currently does not support XFA documents.'
	      ),
	      errors && _react2.default.createElement(
	        'div',
	        { className: 'error' },
	        errors.map(function (error) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            error,
	            _react2.default.createElement('br', null)
	          );
	        })
	      ),
	      (step === 1 || step === 0) && status === 'loading' && _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          'Checking price of all PDFs...'
	        ),
	        _react2.default.createElement(_reactBootstrap.ProgressBar, { now: 100, active: true })
	      ),
	      step === 1 && partsToPurchase > 0 && _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          'Need to purchase ',
	          partsToPurchase,
	          ' / ',
	          totalParts,
	          ' PDFs from PACER.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'email-bulk-buy-container' },
	          partsToPurchase > 0 && _react2.default.createElement(_ClientCode2.default, {
	            initialClientCode: '',
	            isClientCodeLocked: (0, _get2.default)(window, 'Drupal.settings.isClientCodeLocked'),
	            className: 'bulk-client-code',
	            span: true,
	            ignoreClientCodeAutosetMsg: true
	          }),
	          _react2.default.createElement(
	            'button',
	            { className: 'form-submit green next uy-btn email-bulk-buy-button', onClick: this.props.buy },
	            'Buy $',
	            (totalCost || 0).toFixed(2)
	          )
	        )
	      ),
	      alreadyPurchased && this.renderAlreadyPurchased(),
	      step === 2 && _react2.default.createElement(
	        _react.Fragment,
	        null,
	        purchased > 0 && _react2.default.createElement(
	          'div',
	          null,
	          'Purchased ',
	          purchased,
	          ' PDFs'
	        ),
	        status === 'loading' && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            'Purchasing PDFs...'
	          ),
	          _react2.default.createElement(_reactBootstrap.ProgressBar, { now: 100, active: true })
	        )
	      ),
	      step === 3 && status === 'loading' && _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          'Sending...'
	        ),
	        _react2.default.createElement(_reactBootstrap.ProgressBar, { now: 100, active: true })
	      )
	    );
	  };
	
	  return EmailAttachmentPurchaseForm;
	}(_react.Component);
	
	EmailAttachmentPurchaseForm.defaultProps = {
	  showXfaWarning: false
	};
	
	EmailAttachmentPurchaseForm.propTypes = {
	  docketParts: _propTypes2.default.object.isRequired,
	  selectedDocket: _propTypes2.default.object.isRequired,
	  entries: _propTypes2.default.object.isRequired,
	  buy: _propTypes2.default.func.isRequired,
	  showXfaWarning: _propTypes2.default.bool,
	  emailActionName: _propTypes2.default.string.isRequired
	};
	
	exports.default = EmailAttachmentPurchaseForm;

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactSelect = __webpack_require__(23);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _docketActions = __webpack_require__(42);
	
	var docketActions = _interopRequireWildcard(_docketActions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var hasError = function hasError(meta) {
	  return meta.error && meta.submitFailed;
	};
	
	var EmailForm = function (_Component) {
	  _inherits(EmailForm, _Component);
	
	  function EmailForm() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EmailForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onSubmit = function (_ref) {
	      var emails = _ref.emails,
	          message = _ref.message;
	
	      _this.props.onSendEmail({
	        emails: emails.map(function (e) {
	          return e.value;
	        }),
	        message: message
	      });
	    }, _this.getSubmitButtonContent = function () {
	      if (_this.props.popup.isEmailSending) {
	        return _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _react2.default.createElement('i', { className: 'fa fa-envelope' }),
	          '\xA0 Sending...'
	        );
	      }
	      if (_this.props.popup.isEmailSending === false) {
	        return _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _react2.default.createElement('i', { className: 'fa fa-check' }),
	          '\xA0 Email Sent'
	        );
	      }
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement('i', { className: 'fa fa-envelope' }),
	        '\xA0 Send Email'
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  EmailForm.prototype.componentDidMount = function componentDidMount() {
	    this.props.dispatch(docketActions.loadFavoriteEmails());
	    this.props.dispatch(docketActions.loadLastFavoriteEmails());
	  };
	
	  EmailForm.prototype.render = function render() {
	    var _this2 = this;
	
	    var isLoading = this.props.favoriteEmails.status === 'loading';
	    var options = this.props.favoriteEmails.emails.map(function (email) {
	      return { value: email, label: email };
	    });
	
	    return _react2.default.createElement(_reactFinalForm.Form, {
	      initialValues: {
	        emails: this.props.favoriteEmails.lastRecipients.map(function (email) {
	          return { value: email, label: email };
	        })
	      },
	      validate: function validate(values) {
	        var errors = {};
	        if (values.emails.length === 0) {
	          errors.emails = 'Email To is required';
	        }
	        var invalidEmail = values.emails.find(function (email) {
	          return !/\S+@\S+\.\S+/.test(email.value);
	        });
	
	        if (invalidEmail) {
	          errors.emails = invalidEmail.value + ' doesn\'t look like a valid email';
	        }
	        return errors;
	      },
	      onSubmit: this.onSubmit,
	      render: function render(_ref2) {
	        var handleSubmit = _ref2.handleSubmit;
	        return _react2.default.createElement(
	          'form',
	          { onSubmit: handleSubmit },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _reactFinalForm.Field,
	              { name: 'emails' },
	              function (_ref3) {
	                var input = _ref3.input,
	                    meta = _ref3.meta;
	
	                return _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.ControlLabel,
	                    null,
	                    'Email To (separate with commas)'
	                  ),
	                  _react2.default.createElement(_reactSelect.Creatable, _extends({}, input, {
	                    name: 'emails',
	                    isLoading: isLoading,
	                    multi: true,
	                    options: options,
	                    className: (0, _classnames2.default)({ error: hasError(meta) })
	                  })),
	                  hasError(meta) && _react2.default.createElement(
	                    'span',
	                    { className: 'error description' },
	                    meta.error
	                  )
	                );
	              }
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { paddingRight: '26px' } },
	              _react2.default.createElement(
	                _reactBootstrap.ControlLabel,
	                { htmlFor: 'message' },
	                'Message (optional)'
	              ),
	              _react2.default.createElement(_reactFinalForm.Field, { name: 'message', className: 'form-control', component: 'textarea', rows: '5', cols: '35' })
	            )
	          ),
	          _this2.props.children,
	          _react2.default.createElement(
	            'div',
	            { className: 'bg-color-grey footer-btn' },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { type: 'button', onClick: _this2.props.onCancel },
	              'Cancel'
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                type: 'submit',
	                className: 'pull-right',
	                bsStyle: 'primary',
	                disabled: !_this2.props.canSend || _this2.props.popup.isEmailSending !== undefined,
	                title: _this2.props.sendButtonHint
	              },
	              _this2.getSubmitButtonContent()
	            )
	          )
	        );
	      }
	    });
	  };
	
	  return EmailForm;
	}(_react.Component);
	
	EmailForm.defaultProps = {
	  children: null
	};
	
	EmailForm.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  favoriteEmails: _propTypes2.default.object.isRequired,
	  popup: _propTypes2.default.object.isRequired,
	  onSendEmail: _propTypes2.default.func.isRequired,
	  onCancel: _propTypes2.default.func.isRequired,
	  canSend: _propTypes2.default.bool.isRequired,
	  sendButtonHint: _propTypes2.default.string.isRequired,
	  children: _propTypes2.default.any
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$get$toJS = state.get('dockets').toJS(),
	      favoriteEmails = _state$get$toJS.favoriteEmails,
	      popup = _state$get$toJS.popup,
	      docketParts = _state$get$toJS.docketParts;
	
	  return {
	    favoriteEmails: favoriteEmails,
	    popup: popup,
	    docketParts: docketParts
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EmailForm);

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _LoadingBar = __webpack_require__(91);
	
	var _LoadingBar2 = _interopRequireDefault(_LoadingBar);
	
	var _AlertError = __webpack_require__(50);
	
	var _AlertError2 = _interopRequireDefault(_AlertError);
	
	var _UpdateFromPacer = __webpack_require__(70);
	
	var _UpdateFromPacer2 = _interopRequireDefault(_UpdateFromPacer);
	
	var _FilterTable = __webpack_require__(80);
	
	var _FilterTable2 = _interopRequireDefault(_FilterTable);
	
	__webpack_require__(2172);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FilersCases = function (_Component) {
	  _inherits(FilersCases, _Component);
	
	  function FilersCases() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FilersCases);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getFilersTableBody = function (data) {
	      if (data.length === 0) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'ir-search-status-message messages warning' },
	            _this.props.noDataFoundMessage
	          )
	        );
	      }
	
	      if (data.empty) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'ir-search-status-message messages warning' },
	            data.empty
	          )
	        );
	      }
	
	      var rows = data.map(function (item, key) {
	        return _react2.default.createElement(
	          'tr',
	          { key: key },
	          _react2.default.createElement(
	            'td',
	            null,
	            item.name || ''
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            item.type || ''
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            item.date_added || ''
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            item.date_terminated || ''
	          )
	        );
	      });
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _FilterTable2.default,
	          {
	            premiumSearch: { uuid: _this.props.case_uuid, query: _this.props.type } },
	          _react2.default.createElement(
	            'table',
	            { className: 'sticky-enabled tablesorter' },
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Name'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Type'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Date Added'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Date Terminated'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              rows
	            )
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  FilersCases.prototype.render = function render() {
	    var _props = this.props,
	        dataReady = _props.dataReady,
	        error = _props.error,
	        filers = _props.filers;
	
	    if (!dataReady) return _react2.default.createElement(_LoadingBar2.default, null);
	    if (!_lodash2.default.isEmpty(error)) return _react2.default.createElement(_AlertError2.default, { errors: error });
	    var tableData = filers || [];
	    // optional add sort by data added, commented out because in live its not sorted
	    // const sortedTableData = _.sortBy(tableData, filer => new Date(filer.date_added)).reverse();
	    return _react2.default.createElement(
	      'div',
	      { className: this.props.type },
	      this.getFilersTableBody(tableData),
	      _react2.default.createElement(_UpdateFromPacer2.default, {
	        pacerUpdateHandler: this.props.purchaseData,
	        pacerReceipt: this.props.receipt,
	        lastUpdated: this.props.lastUpdated })
	    );
	  };
	
	  return FilersCases;
	}(_react.Component);
	
	FilersCases.defaultProps = {
	  error: null,
	  receipt: null,
	  type: 'filers'
	};
	
	FilersCases.propTypes = {
	  case_uuid: _propTypes2.default.string.isRequired,
	  dataReady: _propTypes2.default.bool.isRequired,
	  filers: _propTypes2.default.any.isRequired,
	  receipt: _propTypes2.default.any,
	  lastUpdated: _propTypes2.default.any.isRequired,
	  type: _propTypes2.default.string,
	  noDataFoundMessage: _propTypes2.default.string.isRequired,
	  error: _propTypes2.default.any,
	  purchaseData: _propTypes2.default.func.isRequired
	};
	
	exports.default = FilersCases;

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LoadingBar = __webpack_require__(91);
	
	var _LoadingBar2 = _interopRequireDefault(_LoadingBar);
	
	var _AlertError = __webpack_require__(50);
	
	var _AlertError2 = _interopRequireDefault(_AlertError);
	
	var _UpdateFromPacer = __webpack_require__(70);
	
	var _UpdateFromPacer2 = _interopRequireDefault(_UpdateFromPacer);
	
	var _FilterTable = __webpack_require__(80);
	
	var _FilterTable2 = _interopRequireDefault(_FilterTable);
	
	__webpack_require__(2173);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PartiesCases = function (_Component) {
	  _inherits(PartiesCases, _Component);
	
	  function PartiesCases() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PartiesCases);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPartiesTableBody = function (data) {
	      if (data.length === 0) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'ir-search-status-message messages warning' },
	            _this.props.noDataFoundMessage
	          )
	        );
	      }
	
	      if (data.empty) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'ir-search-status-message messages warning' },
	            data.empty
	          )
	        );
	      }
	
	      var rows = data.map(function (item, key) {
	        return _react2.default.createElement(
	          'tr',
	          { key: key },
	          _react2.default.createElement(
	            'td',
	            { valign: 'top' },
	            _this.getCardBody(item.party)
	          ),
	          _react2.default.createElement(
	            'td',
	            { valign: 'top' },
	            'represented by'
	          ),
	          _react2.default.createElement(
	            'td',
	            { valign: 'top' },
	            _this.getAssociatedBody(item.associated)
	          )
	        );
	      });
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _FilterTable2.default,
	          { premiumSearch: { uuid: _this.props.case_uuid, query: _this.props.type } },
	          _react2.default.createElement(
	            'table',
	            { className: 'sticky-enabled tablesorter' },
	            _react2.default.createElement('thead', null),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              rows
	            )
	          )
	        )
	      );
	    }, _this.getAssociatedBody = function (data) {
	      return data.map(function (item, key) {
	        return _this.getCardBody(item, key);
	      });
	    }, _this.getAddress = function (address) {
	      return address.split('\n').map(function (item, key) {
	        return _react2.default.createElement(
	          'span',
	          { key: key },
	          item,
	          _react2.default.createElement('br', null)
	        );
	      });
	    }, _this.getUserEditLinkIfAdmin = function (userId, name) {
	      var link = '/user/' + userId + '/edit';
	      if (_this.props.currentUser === '1' && userId) {
	        return _react2.default.createElement(
	          'b',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: link, target: '_blank' },
	            name
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'b',
	        null,
	        name
	      );
	    }, _this.getCardBody = function (data, key) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ir-search-card', key: key },
	        _this.getUserEditLinkIfAdmin(data.uuid, data.name),
	        _react2.default.createElement('br', null),
	        data.address && _this.getAddress(data.address),
	        data.phone && 't: ' + data.phone,
	        data.phone && _react2.default.createElement('br', null),
	        data.fax && 'f: ' + data.fax,
	        data.fax && _react2.default.createElement('br', null),
	        data.email && data.email,
	        data.email && _react2.default.createElement('br', null),
	        data.ssn && 'SSN: ' + data.ssn,
	        data.ssn && _react2.default.createElement('br', null),
	        data.itin && 'ITIN: ' + data.itin,
	        data.itin && _react2.default.createElement('br', null),
	        data.ein && 'Tax ID / EIN: ' + data.ein,
	        data.ein && _react2.default.createElement('br', null),
	        data.role && _react2.default.createElement(
	          'i',
	          null,
	          '(',
	          data.role,
	          ')'
	        ),
	        data.role && _react2.default.createElement('br', null),
	        data.lead && _react2.default.createElement(
	          'i',
	          null,
	          '(',
	          data.lead,
	          ')'
	        ),
	        data.lead && _react2.default.createElement('br', null),
	        data.added_date && _react2.default.createElement(
	          'i',
	          null,
	          'Added: ',
	          data.added_date
	        ),
	        data.assigned_date && _react2.default.createElement(
	          'i',
	          null,
	          'Assigned: ',
	          data.assigned_date
	        ),
	        data.assigned_date && _react2.default.createElement('br', null)
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  PartiesCases.prototype.render = function render() {
	    if (!this.props.dataReady) return _react2.default.createElement(_LoadingBar2.default, null);
	    var alertError = this.props.error ? _react2.default.createElement(_AlertError2.default, { errors: this.props.error }) : null;
	
	    var tableData = this.props.parties || [];
	    return _react2.default.createElement(
	      'div',
	      { className: this.props.type },
	      alertError,
	      this.getPartiesTableBody(tableData),
	      _react2.default.createElement(_UpdateFromPacer2.default, {
	        pacerUpdateHandler: this.props.purchaseData,
	        pacerReceipt: this.props.receipt,
	        lastUpdated: this.props.lastUpdated })
	    );
	  };
	
	  return PartiesCases;
	}(_react.Component);
	
	PartiesCases.defaultProps = {
	  error: null,
	  receipt: null,
	  type: 'parties'
	};
	
	PartiesCases.propTypes = {
	  case_uuid: _propTypes2.default.string.isRequired,
	  dataReady: _propTypes2.default.bool.isRequired,
	  parties: _propTypes2.default.any.isRequired,
	  receipt: _propTypes2.default.any,
	  lastUpdated: _propTypes2.default.any.isRequired,
	  type: _propTypes2.default.string,
	  currentUser: _propTypes2.default.any,
	  noDataFoundMessage: _propTypes2.default.string.isRequired,
	  error: _propTypes2.default.any,
	  purchaseData: _propTypes2.default.func.isRequired
	};
	
	exports.default = PartiesCases;

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LoadingBar = __webpack_require__(91);
	
	var _LoadingBar2 = _interopRequireDefault(_LoadingBar);
	
	var _AlertError = __webpack_require__(50);
	
	var _AlertError2 = _interopRequireDefault(_AlertError);
	
	var _UpdateFromPacer = __webpack_require__(70);
	
	var _UpdateFromPacer2 = _interopRequireDefault(_UpdateFromPacer);
	
	var _FilterTable = __webpack_require__(80);
	
	var _FilterTable2 = _interopRequireDefault(_FilterTable);
	
	var _RelatedTransactionsFilters = __webpack_require__(405);
	
	var _RelatedTransactionsFilters2 = _interopRequireDefault(_RelatedTransactionsFilters);
	
	var _RelatedTransactionsParser = __webpack_require__(406);
	
	var _RelatedTransactionsParser2 = _interopRequireDefault(_RelatedTransactionsParser);
	
	var _RelatedTransactionEntries = __webpack_require__(403);
	
	var _RelatedTransactionEntries2 = _interopRequireDefault(_RelatedTransactionEntries);
	
	var _RelatedTransactionPaginator = __webpack_require__(404);
	
	var _RelatedTransactionPaginator2 = _interopRequireDefault(_RelatedTransactionPaginator);
	
	var _EmailPopup = __webpack_require__(401);
	
	var _EmailPopup2 = _interopRequireDefault(_EmailPopup);
	
	var _Flash = __webpack_require__(256);
	
	var _Flash2 = _interopRequireDefault(_Flash);
	
	__webpack_require__(242);
	
	var _PublicLinkPopup = __webpack_require__(402);
	
	var _PublicLinkPopup2 = _interopRequireDefault(_PublicLinkPopup);
	
	var _Notification = __webpack_require__(40);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RelatedTransaction = function (_Component) {
	  _inherits(RelatedTransaction, _Component);
	
	  function RelatedTransaction() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RelatedTransaction);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getClassName = function (index) {
	      return index % 2 === 0 ? 'even' : 'odd';
	    }, _this.getPartiesTableBody = function (data) {
	      if (data.length === 0) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'ir-search-status-message messages warning' },
	            _this.props.noDataFoundMessage
	          )
	        );
	      }
	      var rows = data.map(function (item, index) {
	        return _react2.default.createElement(
	          'tbody',
	          null,
	          _react2.default.createElement(
	            'tr',
	            { key: index, className: _this.getClassName(index) + ' heading' },
	            _react2.default.createElement(
	              'td',
	              { align: 'right', colSpan: '1' },
	              _react2.default.createElement(
	                'strong',
	                { className: 'docketNumber' },
	                _react2.default.createElement(
	                  'span',
	                  { onClick: function onClick() {
	                      return _this.props.getDocketData(item.text.docket_no, index);
	                    } },
	                  item.text.docket_no || ''
	                )
	              )
	            ),
	            _react2.default.createElement('td', null),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                item.text.event_name || ''
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              item.text.date_event_filed || ''
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              item.text.date_event_terminated || ''
	            )
	          ),
	          _this.props.dockets && _this.props.visibleDocketRow === item.text.docket_no + '-' + index && _this.subDockets(_this.getClassName(index), item.text.docket_no, index),
	          _this.subTransactions(item.text.related, _this.getClassName(index), index)
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Notification2.default, null),
	        _react2.default.createElement(
	          _FilterTable2.default,
	          { premiumSearch: { uuid: _this.props.case_uuid, query: _this.props.type } },
	          _react2.default.createElement(
	            'table',
	            { className: 'sticky-enabled tablesorter', id: 'ir-search-related-transactions-results' },
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  { colSpan: '2' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '#'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Event Name'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Event Filed'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Event Terminated'
	                  )
	                )
	              )
	            ),
	            rows
	          )
	        )
	      );
	    }, _this.subDockets = function (className, transactionDocketNumber, index) {
	      var rows = _this.props.dockets.data.map(function (item, index) {
	        return _react2.default.createElement(
	          'tbody',
	          null,
	          _react2.default.createElement(
	            'tr',
	            { key: index, className: className },
	            _react2.default.createElement('td', null),
	            item.part && _react2.default.createElement(
	              'td',
	              null,
	              item.part
	            ),
	            item.description && _react2.default.createElement(
	              'td',
	              null,
	              item.description
	            ),
	            item.pages && _react2.default.createElement(
	              'td',
	              null,
	              item.pages
	            ),
	            item.actions && _react2.default.createElement(
	              'td',
	              null,
	              item.actions.download_url && _react2.default.createElement(
	                'a',
	                { href: item.actions.download_url, id: 'download', title: 'Download File' },
	                _react2.default.createElement('span', { className: 'download icon' })
	              ),
	              item.actions.email_docket_pdf && _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this.props.toggleEmailPopup();
	                  }, id: 'email', title: 'Email', style: { cursor: 'pointer' } },
	                _react2.default.createElement('span', { className: 'email icon' })
	              ),
	              item.actions.print_docket_pdf && _react2.default.createElement(
	                'a',
	                { href: item.actions.print_docket_pdf, id: 'print', title: 'Print preview' },
	                _react2.default.createElement('span', { className: 'preview icon' })
	              ),
	              item.actions.public_link_html && _react2.default.createElement(
	                'a',
	                { title: 'Public Download Link', onClick: function onClick() {
	                    return _this.props.togglePublicLinkPopup();
	                  }, style: { cursor: 'pointer' } },
	                _react2.default.createElement('span', { className: 'public link icon' })
	              ),
	              item.actions.blog_post_url && _react2.default.createElement(
	                'a',
	                { href: item.actions.blog_post_url, title: 'Create blog post', target: '_blank' },
	                _react2.default.createElement('span', { className: 'blog-post icon' })
	              ),
	              item.actions.download_ocr_uri && _react2.default.createElement(
	                'a',
	                { href: item.actions.download_ocr_uri, id: 'download-OCR', title: 'Download OCR' },
	                _react2.default.createElement('span', { className: 'download ocr icon' })
	              ),
	              item.actions.purchase_pdf_url_free && _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this.props.buyFromPacer(transactionDocketNumber, item.part);
	                  }, className: 'form-submit free-download', style: { cursor: 'pointer' } },
	                'Free Download'
	              ),
	              item.actions.purchase_pdf_url_buy_alfresco && _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this.props.buyFromAlfresco(transactionDocketNumber, item.part);
	                  }, className: 'form-submit orange', style: { cursor: 'pointer' } },
	                'Buy $',
	                item.cost
	              ),
	              item.actions.purchase_pdf_url_buy_pacer && _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this.props.buyFromPacer(transactionDocketNumber, item.part);
	                  }, className: 'form-submit green', style: { cursor: 'pointer' } },
	                'Buy $',
	                item.cost
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { className: 'even' },
	            _react2.default.createElement(
	              'td',
	              { colSpan: '100%', align: 'right' },
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this.props.getDocketDatafromPacer(transactionDocketNumber, index);
	                  }, className: '', style: { cursor: 'pointer' } },
	                'Refresh Part List from PACER'
	              )
	            )
	          ),
	          _this.props.showEmailPopup ? _react2.default.createElement(_EmailPopup2.default, {
	            friendly_name: item.actions.email_docket_pdf,
	            part_number: item.part,
	            docketNumber: transactionDocketNumber,
	            closePopup: _this.props.toggleEmailPopup,
	            sendDocketViaEmail: _this.props.sendDocketViaEmail,
	            emails: _this.props.emails
	          }) : null,
	          _this.props.showPubliclinkPopup ? _react2.default.createElement(_PublicLinkPopup2.default, {
	            public_link_html: item.actions.public_link_html,
	            public_pdf_link: item.actions.public_pdf_link,
	            friendly_name: item.actions.email_docket_pdf,
	            closePopup: _this.props.togglePublicLinkPopup
	          }) : null,
	          !_this.props.emails.dataReady && _react2.default.createElement(
	            'tr',
	            { className: className },
	            _react2.default.createElement(
	              'td',
	              { colSpan: '5' },
	              _react2.default.createElement(_LoadingBar2.default, null)
	            )
	          ),
	          _this.props.emails.dataReady && _this.props.emails.status && _this.props.showEmailNotification && _react2.default.createElement(
	            'tr',
	            { className: className },
	            _react2.default.createElement(
	              'td',
	              { colSpan: '5' },
	              _react2.default.createElement(
	                'span',
	                { style: { border: '1px solid', padding: '5px' } },
	                _react2.default.createElement('span', { className: 'email icon' }),
	                ' The filing has been emailed to ',
	                _this.props.emails.email,
	                ' ',
	                _react2.default.createElement('i', { onClick: _this.props.closeEmailNotification, className: 'fa fa-times-circle', style: { fontSize: '16px', cursor: 'pointer' } })
	              )
	            )
	          )
	        );
	      });
	      if (!_this.props.dockets.dataReady) {
	        return _react2.default.createElement(
	          'tr',
	          { className: className },
	          _react2.default.createElement(
	            'td',
	            { colSpan: '5' },
	            _react2.default.createElement(_LoadingBar2.default, null)
	          )
	        );
	      } else if (_this.props.dockets.dataReady && _this.props.dockets.data.length >= 1) {
	        return _react2.default.createElement(
	          'tr',
	          { className: className + ' docket_details heading subDocket' },
	          _react2.default.createElement('td', { colSpan: '1' }),
	          _react2.default.createElement(
	            'td',
	            { className: 'here', colSpan: '100%' },
	            _react2.default.createElement(
	              'table',
	              { className: 'sticky-enabled tablesorter' },
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement('th', null),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Part'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Description'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Pages'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { width: '50%' },
	                    'Action'
	                  )
	                )
	              ),
	              rows
	            )
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'tr',
	        { className: className + ' docket_details heading subDocket' },
	        _react2.default.createElement(
	          'td',
	          { colSpan: '5' },
	          'No Accessible Documents Found'
	        )
	      );
	    }, _this.subTransactions = function (data, className, index) {
	      var transactions = data.map(function (item, key) {
	        return _react2.default.createElement(
	          'tbody',
	          null,
	          _react2.default.createElement(
	            'tr',
	            { colSpan: '5', key: key, className: className + ' subDocket' },
	            _react2.default.createElement(
	              'td',
	              { align: 'right', colSpan: '2' },
	              _react2.default.createElement(
	                'strong',
	                { className: 'docketNumber' },
	                _react2.default.createElement(
	                  'span',
	                  { onClick: function onClick() {
	                      return _this.props.getDocketData(item.docket_no, key + '-' + key);
	                    } },
	                  item.docket_no || ''
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              item.event_name || ''
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              item.date_event_filed || ''
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              item.date_event_terminated || ''
	            )
	          ),
	          _this.props.dockets && _this.props.visibleDocketRow === item.docket_no + '-' + index + '-' + key && _this.subDockets(className, item.docket_no, key + '-' + key)
	        );
	      });
	      return _react2.default.createElement(
	        'tr',
	        { className: className + ' docket_details heading subDocket' },
	        _react2.default.createElement('td', { colSpan: '1' }),
	        _react2.default.createElement(
	          'td',
	          { className: 'here', colSpan: '4' },
	          transactions
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  RelatedTransaction.prototype.render = function render() {
	    console.log(this.props);
	    var _props = this.props,
	        RelatedTransactionPopup = _props.RelatedTransactionPopup,
	        relatedTransactionEntriesProps = _props.relatedTransactionEntriesProps,
	        relatedTransactionPaginatorProps = _props.relatedTransactionPaginatorProps,
	        tableSortProps = _props.tableSortProps,
	        docketParts = _props.docketParts;
	
	    if (!this.props.dataReady) return _react2.default.createElement(_LoadingBar2.default, null);
	    var alertError = this.props.error ? _react2.default.createElement(_AlertError2.default, { errors: this.props.error }) : null;
	
	    var tableData = this.props.transactions || [];
	    return _react2.default.createElement(
	      'div',
	      { className: this.props.type },
	      _react2.default.createElement(_Flash2.default, { show: docketParts.showFlash,
	        msg: 'The filing has been mailed to ' + docketParts.email_address }),
	      _react2.default.createElement(_RelatedTransactionsFilters2.default, {
	        onSubmit: this.props.onSubmit,
	        togglePacerFilterSection: this.props.togglePacerFilterSection,
	        showPacerFilterSection: this.props.showPacerFilterSection
	      }),
	      _react2.default.createElement(_RelatedTransactionsParser2.default, {
	        onSubmit: this.props.onSubmitParser,
	        onReset: this.props.resetParser,
	        showPacerFilterSection: this.props.showPacerFilterSection
	      }),
	      _react2.default.createElement(_RelatedTransactionPaginator2.default, relatedTransactionPaginatorProps),
	      alertError,
	      _react2.default.createElement(_RelatedTransactionEntries2.default, _extends({}, relatedTransactionEntriesProps, this.props)),
	      _react2.default.createElement(_RelatedTransactionPaginator2.default, relatedTransactionPaginatorProps),
	      RelatedTransactionPopup && _react2.default.createElement(RelatedTransactionPopup, {
	        onClose: this.props.onPopupClick,
	        info: this.props.popup,
	        reloadDetails: this.reloadDetails })
	    );
	  };
	
	  return RelatedTransaction;
	}(_react.Component);
	
	RelatedTransaction.propTypes = {
	  onSubmit: _propTypes2.default.func
	};
	RelatedTransaction.defaultProps = {
	  onSubmit: function onSubmit() {
	    return null;
	  }
	};
	
	
	RelatedTransaction.defaultProps = {
	  error: null,
	  receipt: null,
	  type: 'related_transactions'
	};
	
	RelatedTransaction.propTypes = {
	  case_uuid: _propTypes2.default.string.isRequired,
	  dataReady: _propTypes2.default.bool.isRequired,
	  transactions: _propTypes2.default.any.isRequired,
	  receipt: _propTypes2.default.any,
	  lastUpdated: _propTypes2.default.any.isRequired,
	  type: _propTypes2.default.string,
	  noDataFoundMessage: _propTypes2.default.string.isRequired,
	  error: _propTypes2.default.any,
	  getDocketData: _propTypes2.default.func.isRequired,
	  purchaseData: _propTypes2.default.func.isRequired,
	  buyFromPacer: _propTypes2.default.func.isRequired,
	  buyFromAlfresco: _propTypes2.default.func.isRequired,
	  toggleEmailPopup: _propTypes2.default.func.isRequired,
	  togglePublicLinkPopup: _propTypes2.default.func.isRequired
	};
	
	exports.default = RelatedTransaction;

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _LoadingBar = __webpack_require__(91);
	
	var _LoadingBar2 = _interopRequireDefault(_LoadingBar);
	
	var _AlertError = __webpack_require__(50);
	
	var _AlertError2 = _interopRequireDefault(_AlertError);
	
	var _UpdateFromPacer = __webpack_require__(70);
	
	var _UpdateFromPacer2 = _interopRequireDefault(_UpdateFromPacer);
	
	var _FilterTable = __webpack_require__(80);
	
	var _FilterTable2 = _interopRequireDefault(_FilterTable);
	
	__webpack_require__(2174);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Status = function (_Component) {
	  _inherits(Status, _Component);
	
	  function Status() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Status);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getTableBody = function (data) {
	      if (data.length === 0) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'ir-search-status-message messages warning' },
	            _this.props.noDataFoundMessage
	          )
	        );
	      }
	      if (data.empty) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'ir-search-status-message messages warning' },
	            data.empty
	          )
	        );
	      }
	
	      var rows = data.map(function (item, key) {
	        return _react2.default.createElement(
	          'tr',
	          { key: key },
	          _react2.default.createElement(
	            'td',
	            null,
	            item.status || ''
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            item.date_status_begin || ''
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            item.time_in_status || ''
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            item.docket_no || ''
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            item.status_set_by || ''
	          )
	        );
	      });
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _FilterTable2.default,
	          { premiumSearch: { uuid: _this.props.case_uuid, query: _this.props.type } },
	          _react2.default.createElement(
	            'table',
	            { className: 'sticky-enabled tablesorter' },
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Status'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Begin Date'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Time in Status'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '#'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Status Set By'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              rows
	            )
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Status.prototype.render = function render() {
	    if (!this.props.dataReady) return _react2.default.createElement(_LoadingBar2.default, null);
	    var alertError = this.props.error ? _react2.default.createElement(_AlertError2.default, { errors: this.props.error }) : null;
	
	    var tableData = this.props.statuses || [];
	    var sortedTableData = tableData.empty ? tableData : _lodash2.default.sortBy(tableData, function (status) {
	      return new Date(status.date_status_begin);
	    });
	    return _react2.default.createElement(
	      'div',
	      { className: this.props.type },
	      alertError,
	      this.getTableBody(sortedTableData),
	      _react2.default.createElement(_UpdateFromPacer2.default, {
	        pacerUpdateHandler: this.props.purchaseData,
	        pacerReceipt: this.props.receipt,
	        lastUpdated: this.props.lastUpdated })
	    );
	  };
	
	  return Status;
	}(_react.Component);
	
	Status.defaultProps = {
	  error: null,
	  receipt: null,
	  type: 'status_pending'
	};
	
	Status.propTypes = {
	  case_uuid: _propTypes2.default.string.isRequired,
	  dataReady: _propTypes2.default.bool.isRequired,
	  statuses: _propTypes2.default.any.isRequired,
	  receipt: _propTypes2.default.any,
	  lastUpdated: _propTypes2.default.any.isRequired,
	  type: _propTypes2.default.string,
	  noDataFoundMessage: _propTypes2.default.string.isRequired,
	  error: _propTypes2.default.any,
	  purchaseData: _propTypes2.default.func.isRequired
	};
	
	exports.default = Status;

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(2178);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProgressBar = function ProgressBar(_ref) {
	  var show = _ref.show,
	      percentage = _ref.percentage,
	      clsName = _ref.clsName;
	
	  var showOrHide = show ? '' : ' hide';
	  return _react2.default.createElement(
	    'div',
	    { className: 'react-progress-bar react-progress-bar-' + showOrHide + ' ' + clsName },
	    _react2.default.createElement('div', { className: 'inner', style: { width: percentage + '%' } })
	  );
	};
	
	ProgressBar.defaultProps = {
	  show: false,
	  clsName: ''
	};
	
	ProgressBar.propTypes = {
	  show: _propTypes2.default.bool,
	  clsName: _propTypes2.default.string,
	  percentage: _propTypes2.default.number.isRequired
	};
	
	exports.default = ProgressBar;

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	__webpack_require__(2183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allowedSearchTypes = ['Bankruptcy'];
	
	var ActionButtons = function (_Component) {
	    _inherits(ActionButtons, _Component);
	
	    function ActionButtons() {
	        _classCallCheck(this, ActionButtons);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    ActionButtons.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'action-btn-container' },
	            _react2.default.createElement('input', { type: 'button',
	                id: 'pacer-search-submit',
	                disabled: !this.props.enabled,
	                value: 'PACER Search',
	                className: 'form-submit green action-btn-search',
	                onClick: this.props.searchClickHandler }),
	            allowedSearchTypes.indexOf(this.props.searchType) !== -1 && _react2.default.createElement('input', {
	                type: 'button',
	                id: 'local-search-submit',
	                value: 'Local Court Search',
	                className: 'form-submit action-btn-search ' + (!this.props.isLocalSearchAllowed || !this.props.enabled ? 'form-button-disabled' : ''),
	                onClick: this.props.localSearchClickHandler
	            }),
	            _react2.default.createElement('input', { type: 'button',
	                id: 'clear-btn',
	                disabled: !this.props.enabled,
	                value: 'Clear',
	                className: 'form-submit',
	                onClick: this.props.resetFilters })
	        );
	    };
	
	    return ActionButtons;
	}(_react.Component);
	
	ActionButtons.defaultProps = {
	    isLocalSearchAllowed: false,
	    searchClickHandler: function searchClickHandler() {
	        return null;
	    },
	    localSearchClickHandler: function localSearchClickHandler() {
	        return null;
	    }
	};
	
	ActionButtons.propTypes = {
	    searchTyp: _propTypes2.default.string,
	    isLocalSearchAllowed: _propTypes2.default.bool,
	    searchClickHandler: _propTypes2.default.func,
	    localSearchClickHandler: _propTypes2.default.func
	};
	
	function mapStateToProps(state) {
	    // TODO: we should also make the searchClickHandler action be ignored when we are in middle of searching
	    //       if say we have some other way of triggering it other than action buttons...
	    return { enabled: !state.get('loadingSpinner') };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ActionButtons);

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDatepicker = __webpack_require__(78);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _reactRedux = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(104);
	__webpack_require__(130);
	
	var DateFilter = function DateFilter(props) {
	  var filterNameFrom = props.name + '_from';
	  var filterNameThrough = props.name + '_to';
	
	  var dateFromClass = props.validationErrorsFields.includes(filterNameFrom) ? 'date-picker validation-error' : 'date-picker';
	
	  var dateThroughClass = props.validationErrorsFields.includes(filterNameThrough) ? 'date-picker validation-error' : 'date-picker';
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'date-picker-container' },
	      _react2.default.createElement(
	        'label',
	        { className: 'date-picker-label' },
	        'Date ',
	        props.name,
	        ' from:'
	      ),
	      _react2.default.createElement(_reactDatepicker2.default, { selected: props.filters.get(filterNameFrom),
	        onChange: function onChange(date) {
	          var _props$onChange;
	
	          return props.onChange((_props$onChange = {}, _props$onChange[filterNameFrom] = date, _props$onChange));
	        },
	        dateFormat: 'MM/DD/YYYY',
	        className: dateFromClass })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'date-picker-container' },
	      _react2.default.createElement(
	        'label',
	        { className: 'date-picker-label' },
	        'through:'
	      ),
	      _react2.default.createElement(_reactDatepicker2.default, { selected: props.filters.get(filterNameThrough),
	        onChange: function onChange(date) {
	          var _props$onChange2;
	
	          return props.onChange((_props$onChange2 = {}, _props$onChange2[filterNameThrough] = date, _props$onChange2));
	        },
	        dateFormat: 'MM/DD/YYYY',
	        className: dateThroughClass })
	    )
	  );
	};
	
	DateFilter.defaultProps = {
	  validationErrorsFields: '',
	  name: ''
	};
	
	DateFilter.propTypes = {
	  validationErrorsFields: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  filters: _propTypes2.default.any.isRequired,
	  onChange: _propTypes2.default.func.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    validationErrorsFields: state.getIn(['validationErrors', 'fields'], [])
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(DateFilter);

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _PartyTooltip = __webpack_require__(1180);
	
	var _PartyTooltip2 = _interopRequireDefault(_PartyTooltip);
	
	var _inputValidations = __webpack_require__(100);
	
	__webpack_require__(2186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PartySelector = function (_Component) {
	  _inherits(PartySelector, _Component);
	
	  function PartySelector() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PartySelector);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onChange = function (ref) {
	      var _this$props$onChange;
	
	      var value = _this.refs[ref].value;
	      _this.props.onChange((_this$props$onChange = {}, _this$props$onChange[ref] = value, _this$props$onChange));
	
	      var _this$refs = _this.refs,
	          last_business_name = _this$refs.last_business_name,
	          middle_name = _this$refs.middle_name,
	          first_name = _this$refs.first_name;
	
	
	      _this.props.onChange({
	        last_name: last_business_name.value,
	        first_name: first_name.value,
	        middle_name: middle_name.value
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  PartySelector.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (!nextProps.last_business_name) {
	      this.refs.last_business_name.value = '';
	    }
	
	    if (!nextProps.first_name) {
	      this.refs.first_name.value = '';
	    }
	
	    if (!nextProps.middle_name) {
	      this.refs.middle_name.value = '';
	    }
	  };
	
	  PartySelector.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'form-item' },
	      _react2.default.createElement(
	        'div',
	        { className: 'party-tooltip-container' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'party-input', className: 'party-inputs-label' },
	          'Party: '
	        ),
	        _react2.default.createElement('input', { type: 'hidden', id: 'party-input' }),
	        _react2.default.createElement(_PartyTooltip2.default, { className: this.props.tooltipClassName || '' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'party-selector-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'party-selector-container-element party-selector-container-element-last' },
	          _react2.default.createElement(
	            'label',
	            null,
	            'Last / Business Name'
	          ),
	          _react2.default.createElement('input', { type: 'text',
	            id: 'party_last_business_name',
	            maxLength: '128',
	            ref: 'last_business_name',
	            onBlur: this.onChange.bind(this, 'last_business_name'),
	            className: this.props.classNameOfLastBusinessName
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'party-selector-container-element party-selector-container-element-first' },
	          _react2.default.createElement(
	            'label',
	            null,
	            'First Name'
	          ),
	          _react2.default.createElement('input', {
	            type: 'text',
	            maxLength: '128',
	            ref: 'first_name',
	            onBlur: this.onChange.bind(this, 'first_name'),
	            className: this.props.classNameFirstName
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'party-selector-container-element party-selector-container-element-middle' },
	          _react2.default.createElement(
	            'label',
	            null,
	            'Middle Name'
	          ),
	          _react2.default.createElement('input', { type: 'text',
	            maxLength: '128',
	            ref: 'middle_name',
	            onBlur: this.onChange.bind(this, 'middle_name'),
	            className: this.props.classNameMiddleName
	          })
	        )
	      )
	    );
	  };
	
	  return PartySelector;
	}(_react.Component);
	
	PartySelector.propTypes = {
	  onChange: _propTypes2.default.func,
	  className: _propTypes2.default.string
	};
	
	PartySelector.defaultProps = {
	  onChange: function onChange() {
	    return null;
	  },
	  className: ''
	};
	
	function mapStateToProps(state) {
	  return {
	    classNameOfLastBusinessName: (0, _inputValidations.mapValidationFieldsToClassName)(state, 'last_name', 'input-search').className,
	    classNameFirstName: (0, _inputValidations.mapValidationFieldsToClassName)(state, 'first_name', 'input-search').className,
	    classNameMiddleName: (0, _inputValidations.mapValidationFieldsToClassName)(state, 'middle_name', 'input-search').className,
	    last_business_name: state.getIn(['pacerSearchResults', 'filters', 'last_business_name']),
	    middle_name: state.getIn(['pacerSearchResults', 'filters', 'middle_name']),
	    first_name: state.getIn(['pacerSearchResults', 'filters', 'first_name'])
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(PartySelector);

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.defaultRegionOptions = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _regionsSorter = __webpack_require__(419);
	
	var _regionsSorter2 = _interopRequireDefault(_regionsSorter);
	
	var _regionOptionsOfBankruptcySearchFormMap = __webpack_require__(702);
	
	var _regionOptionsOfBankruptcySearchFormMap2 = _interopRequireDefault(_regionOptionsOfBankruptcySearchFormMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultRegionOptions = exports.defaultRegionOptions = Object.keys(_regionOptionsOfBankruptcySearchFormMap2.default).map(function (courId) {
	  return {
	    value: courId,
	    label: _regionOptionsOfBankruptcySearchFormMap2.default[courId]
	  };
	});
	
	var RegionSelector = function RegionSelector(props) {
	  var customStyle = props.width ? { width: props.width } : {};
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'region-selector-container', style: { float: 'left' } },
	    _react2.default.createElement(
	      'label',
	      { className: 'region-selector-label', htmlFor: 'region-selector' },
	      'Region: '
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'region-selector' },
	      _react2.default.createElement(_reactSelect2.default, {
	        style: customStyle,
	        name: 'form-field-name',
	        options: (0, _regionsSorter2.default)(props.regionOptions),
	        multi: true,
	        simpleValue: true,
	        value: props.filters.get(props.courtField),
	        placeholder: 'All Courts',
	        onChange: function onChange(court_id) {
	          return props.onChange({ court_id: court_id || '' });
	        } })
	    )
	  );
	};
	
	RegionSelector.defaultProps = {
	  regionOptions: defaultRegionOptions,
	  courtField: 'court_id',
	  width: null
	};
	
	RegionSelector.propTypes = {
	  filters: _propTypes2.default.any.isRequired,
	  onChange: _propTypes2.default.func.isRequired,
	  regionOptions: _propTypes2.default.any,
	  courtField: _propTypes2.default.string,
	  width: _propTypes2.default.string
	};
	
	exports.default = RegionSelector;

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.resetLocalCourtSearch = exports.searchAppellate = exports.searchDistrict = exports.searchBankruptcy = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _immutable = __webpack_require__(30);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _url = __webpack_require__(180);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _localCourtSearchActionTypes = __webpack_require__(719);
	
	var actionTypes = _interopRequireWildcard(_localCourtSearchActionTypes);
	
	var _dateFormat = __webpack_require__(94);
	
	var _dateFormat2 = _interopRequireDefault(_dateFormat);
	
	var _Notification = __webpack_require__(24);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var getParams = function getParams(payload) {
	  var filed_from = payload.filed_from,
	      filed_to = payload.filed_to,
	      values = _objectWithoutProperties(payload, ['filed_from', 'filed_to']);
	
	  return _extends({
	    open_cases: true,
	    closed_cases: true
	  }, values, filed_from && { filed_from: (0, _dateFormat2.default)(filed_from) }, filed_to && { filed_to: (0, _dateFormat2.default)(filed_to) });
	};
	
	var searchBankruptcy = exports.searchBankruptcy = function searchBankruptcy(payload) {
	  return function (dispatch) {
	    dispatch({
	      type: actionTypes.LOCAL_COURT_SEARCH_BANKRUPTCY.REQUEST,
	      payload: payload
	    });
	
	    var onSuccess = function onSuccess(params, response) {
	      return dispatch({
	        type: actionTypes.LOCAL_COURT_SEARCH_BANKRUPTCY.SUCCESS,
	        params: params,
	        searchResults: response || {}
	      });
	    };
	
	    var onError = function onError(error) {
	      dispatch({
	        type: actionTypes.LOCAL_COURT_SEARCH_BANKRUPTCY.ERROR,
	        error: error,
	        payload: payload
	      });
	
	      _Notification.notify.error('Failed to search Bankruptcy Local Court');
	    };
	
	    return _superagent2.default.post((0, _url2.default)('/rpc/capi/courts/pacer/' + payload.court_code + '/cases/search/bankruptcy')).set('Accept', 'application/json').type('form').send(getParams(payload)).then(function (_ref) {
	      var body = _ref.body;
	      return onSuccess(_immutable2.default.fromJS(payload), body);
	    }, function (error) {
	      return onError(error);
	    });
	  };
	};
	
	var searchDistrict = exports.searchDistrict = function searchDistrict(payload) {
	  return function (dispatch) {
	    dispatch({
	      type: actionTypes.LOCAL_COURT_SEARCH_DISTRICT.REQUEST,
	      payload: payload
	    });
	
	    var onSuccess = function onSuccess(params, response) {
	      return dispatch({
	        type: actionTypes.LOCAL_COURT_SEARCH_DISTRICT.SUCCESS,
	        params: params,
	        searchResults: response || {}
	      });
	    };
	
	    var onError = function onError(error) {
	      dispatch({
	        type: actionTypes.LOCAL_COURT_SEARCH_DISTRICT.ERROR,
	        error: error,
	        payload: payload
	      });
	
	      _Notification.notify.error('Failed to search District Local Court');
	    };
	
	    return _superagent2.default.post((0, _url2.default)('/rpc/capi/courts/pacer/' + payload.court_code + '/cases/search/district')).set('Accept', 'application/json').type('form').send(getParams(payload)).then(function (_ref2) {
	      var body = _ref2.body;
	      return onSuccess(_immutable2.default.fromJS(payload), body);
	    }, function (error) {
	      return onError(error);
	    });
	  };
	};
	
	var searchAppellate = exports.searchAppellate = function searchAppellate(payload) {
	  return function (dispatch) {
	    dispatch({
	      type: actionTypes.LOCAL_COURT_SEARCH_APPELLATE.REQUEST,
	      payload: payload
	    });
	
	    var onSuccess = function onSuccess(params, response) {
	      return dispatch({
	        type: actionTypes.LOCAL_COURT_SEARCH_APPELLATE.SUCCESS,
	        params: params,
	        searchResults: response || {}
	      });
	    };
	
	    var onError = function onError(error) {
	      dispatch({
	        type: actionTypes.LOCAL_COURT_SEARCH_APPELLATE.ERROR,
	        error: error,
	        payload: payload
	      });
	
	      _Notification.notify.error('Failed to search Appellate Local Court');
	    };
	
	    return _superagent2.default.post((0, _url2.default)('/rpc/capi/courts/pacer/' + payload.court_code + '/cases/search/appellate')).set('Accept', 'application/json').type('form').send(getParams(payload)).then(function (_ref3) {
	      var body = _ref3.body;
	      return onSuccess(_immutable2.default.fromJS(payload), body);
	    }, function (error) {
	      return onError(error);
	    });
	  };
	};
	
	var resetLocalCourtSearch = exports.resetLocalCourtSearch = function resetLocalCourtSearch() {
	  return function (dispatch) {
	    return dispatch({
	      type: actionTypes.LOCAL_COURT_SEARCH_RESET
	    });
	  };
	};

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.initialState = exports.initialFilters = undefined;
	
	var _createReducer;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _immutable = __webpack_require__(30);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _utils = __webpack_require__(33);
	
	var _caseLookupActionTypes = __webpack_require__(714);
	
	var types = _interopRequireWildcard(_caseLookupActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialFilters = exports.initialFilters = {
	  // form
	  case_no: '',
	  party_title: '',
	  search_type: 'party_title',
	
	  // sorting
	  sort: 'asc',
	  order: 'Case Title',
	
	  // queries
	  case_type: 'Bankruptcy',
	  filed_from: null,
	  filed_to: null,
	
	  // facets
	  year: null,
	  chapter: null,
	  court_name: null,
	
	  // region dropdown
	  region_name: null,
	
	  page: 1
	};
	
	var initialParams = {
	  isReady: false,
	  isError: false,
	  contents: [],
	  facets: {
	    year: {},
	    court_name: {},
	    case_type: {},
	    chapter: {}
	  },
	  pages: {
	    pageindex: 1,
	    pagesize: 1,
	    totalitems: 1
	  }
	};
	
	var initialStateValue = _extends({}, initialParams, {
	  filters: initialFilters
	});
	
	var initialState = exports.initialState = _immutable2.default.fromJS(initialStateValue);
	
	exports.default = (0, _utils.createReducer)(initialState, (_createReducer = {}, _createReducer[types.CLEAR_ALL_FILTERS_OF_CASE_LOOKUP] = function (state) {
	  var oldFilters = state.get('filters');
	  var newFilters = oldFilters.mergeDeep({
	    year: initialFilters.year,
	    chapter: initialFilters.chapter,
	    court_name: initialFilters.court_name,
	    region_name: null,
	    filed_from: oldFilters.get('year') ? initialFilters.filed_from : oldFilters.get('filed_from'),
	    filed_to: oldFilters.get('year') ? initialFilters.filed_to : oldFilters.get('filed_to')
	  });
	
	  return state.mergeDeep({ filters: newFilters });
	}, _createReducer[types.REQUEST_CASE_DATA_OF_CASE_LOOKUP] = function (state) {
	  return state.mergeDeep(initialParams).set('contents', []);
	}, _createReducer[types.RECEIVE_CASE_DATA_OF_CASE_LOOKUP] = function (state, action) {
	  var _action$facets = action.facets,
	      facets = _action$facets === undefined ? initialParams.facets : _action$facets;
	  var _action$pages = action.pages,
	      pages = _action$pages === undefined ? initialParams.pages : _action$pages;
	
	  // :(
	
	  var nextPages = {
	    pageindex: parseInt(pages.pageindex, 10),
	    pagesize: parseInt(pages.pagesize, 10),
	    totalitems: parseInt(pages.totalitems, 10)
	  };
	
	  return state.set('isReady', true).set('contents', action.contents).set('contents', action.contents).set('pages', _immutable2.default.fromJS(nextPages)).set('facets', _immutable2.default.fromJS(facets));
	}, _createReducer[types.RECEIVE_CASE_LOOKUP_ERROR] = function (state) {
	  return state.set('isError', true).set('isReady', true);
	}, _createReducer[types.UPDATE_FILTERS_OF_CASE_DATA_OF_CASE_LOOKUP] = function (state, action) {
	  return state.mergeDeep({ filters: action.filter });
	}, _createReducer));

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (number) {
	  return number !== '' && !isNaN(number) ? '$' + _currencyConversion2.default.toDollars(number).toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,') : number;
	};
	
	var _currencyConversion = __webpack_require__(72);
	
	var _currencyConversion2 = _interopRequireDefault(_currencyConversion);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactBootstrap = __webpack_require__(7);
	
	__webpack_require__(2206);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // packages
	
	
	var InputField = function InputField(_ref) {
	  var input = _ref.input,
	      rest = _objectWithoutProperties(_ref, ['input']);
	
	  return _react2.default.createElement(_reactBootstrap.FormControl, _extends({}, input, rest));
	};
	
	var ScheduleFilters = function ScheduleFilters(_ref2) {
	  var setViewFilters = _ref2.setViewFilters;
	
	  return _react2.default.createElement(_reactFinalForm.Form, {
	    onSubmit: setViewFilters,
	    subscription: {},
	    render: function render(_ref3) {
	      var handleSubmit = _ref3.handleSubmit,
	          form = _ref3.form,
	          submitting = _ref3.submitting;
	      return _react2.default.createElement(
	        _reactBootstrap.Well,
	        null,
	        _react2.default.createElement(
	          'form',
	          {
	            id: 'filter-schedule-form',
	            className: 'form-inline'
	            // trigger filtering on [Enter]
	            , onSubmit: handleSubmit
	          },
	          _react2.default.createElement(_reactFinalForm.FormSpy, {
	            subscription: {
	              values: true
	            },
	            onChange: function onChange(_ref4) {
	              var values = _ref4.values;
	              return setViewFilters(values);
	            }
	          }),
	          _react2.default.createElement(
	            _reactBootstrap.FormGroup,
	            null,
	            _react2.default.createElement(_reactFinalForm.Field, { name: 'keyword', component: InputField, size: '30', placeholder: 'Enter Keywords' }),
	            ' Amount',
	            ' ',
	            _react2.default.createElement(
	              _reactBootstrap.InputGroup,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.InputGroup.Addon,
	                null,
	                '$'
	              ),
	              _react2.default.createElement(_reactFinalForm.Field, {
	                name: 'value_from',
	                component: InputField,
	                step: 0.01,
	                type: 'number',
	                precision: 2,
	                size: '8',
	                placeholder: '0.00'
	              })
	            ),
	            ' to ',
	            _react2.default.createElement(
	              _reactBootstrap.InputGroup,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.InputGroup.Addon,
	                null,
	                '$'
	              ),
	              _react2.default.createElement(_reactFinalForm.Field, {
	                name: 'value_to',
	                component: InputField,
	                type: 'number',
	                step: 0.01,
	                precision: 2,
	                size: '8',
	                placeholder: '0.00'
	              })
	            )
	          ),
	          ' ',
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { type: 'submit', disabled: submitting, bsStyle: 'primary' },
	            _react2.default.createElement('i', { className: 'fa fa-search' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { bsStyle: 'link', disabled: submitting, onClick: function onClick() {
	                return form.reset();
	              } },
	            'clear'
	          )
	        )
	      );
	    }
	  });
	};
	
	ScheduleFilters.defaultProps = {
	  setViewFilters: function setViewFilters() {
	    return null;
	  },
	  viewFilters: {},
	  inputRef: {},
	  input: {}
	};
	
	ScheduleFilters.propTypes = {
	  setViewFilters: _propTypes2.default.func,
	  viewFilters: _propTypes2.default.object,
	  input: _propTypes2.default.object,
	  inputRef: _propTypes2.default.object
	};
	exports.default = ScheduleFilters;

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(752), __esModule: true };

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1326), __esModule: true };

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(756), __esModule: true };

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(1267);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(1263);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(209);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(209);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(1258);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ },
/* 281 */
97,
/* 282 */
[2264, 115, 761, 760, 83, 284, 451],
/* 283 */
[2288, 39, 28, 116],
/* 284 */
[2304, 446],
/* 285 */
152,
/* 286 */
[2253, 77, 37, 151],
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(25);
	var $export = __webpack_require__(3);
	var redefine = __webpack_require__(66);
	var redefineAll = __webpack_require__(149);
	var meta = __webpack_require__(122);
	var forOf = __webpack_require__(144);
	var anInstance = __webpack_require__(143);
	var isObject = __webpack_require__(29);
	var fails = __webpack_require__(27);
	var $iterDetect = __webpack_require__(291);
	var setToStringTag = __webpack_require__(185);
	var inheritIfRequired = __webpack_require__(461);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(807);
	var redefine = __webpack_require__(66);
	var hide = __webpack_require__(65);
	var fails = __webpack_require__(27);
	var defined = __webpack_require__(97);
	var wks = __webpack_require__(36);
	var regexpExec = __webpack_require__(469);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ },
/* 289 */
[2270, 84],
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(29);
	var cof = __webpack_require__(84);
	var MATCH = __webpack_require__(36)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ },
/* 291 */
[2274, 36],
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(121) || !__webpack_require__(27)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(25)[K];
	});


/***/ },
/* 293 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(183);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ },
/* 295 */
[2292, 3, 57, 86, 144],
/* 296 */
[2293, 3],
/* 297 */
[2299, 88, 97],
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(25);
	var hide = __webpack_require__(65);
	var uid = __webpack_require__(152);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ },
/* 299 */
[2307, 25],
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCISOWeek(dirtyDate) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var weekStartsOn = 1;
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getUTCDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setUTCDate(date.getUTCDate() - diff);
	  date.setUTCHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCWeek(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index2.default)(dirtyDate);
	  var day = date.getUTCDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setUTCDate(date.getUTCDate() - diff);
	  date.setUTCHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 302 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getWindow;
	
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	
	module.exports = exports["default"];

/***/ },
/* 303 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {var win;
	
	if (typeof window !== "undefined") {
	    win = window;
	} else if (typeof global !== "undefined") {
	    win = global;
	} else if (typeof self !== "undefined"){
	    win = self;
	} else {
	    win = {};
	}
	
	module.exports = win;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 304 */
/***/ function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	function keyCode(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Compares a keyboard event with a given keyCode or keyName.
	 *
	 * @param {Event} event Keyboard event that should be tested
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Boolean}
	 * @api public
	 */
	keyCode.isEventKey = function isEventKey(event, nameOrCode) {
	  if (event && 'object' === typeof event) {
	    var keyCode = event.which || event.keyCode || event.charCode
	    if (keyCode === null || keyCode === undefined) { return false; }
	    if (typeof nameOrCode === 'string') {
	      // check codes
	      var foundNamedKey = codes[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    
	      // check aliases
	      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    } else if (typeof nameOrCode === 'number') {
	      return nameOrCode === keyCode;
	    }
	    return false;
	  }
	}
	
	exports = module.exports = keyCode;
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'spacebar': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1866),
	    listCacheDelete = __webpack_require__(1867),
	    listCacheGet = __webpack_require__(1868),
	    listCacheHas = __webpack_require__(1869),
	    listCacheSet = __webpack_require__(1870);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(494);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(1863);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(89),
	    isSymbol = __webpack_require__(312);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(190);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(847);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(192);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(228);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(1817),
	    baseKeys = __webpack_require__(1834),
	    isArrayLike = __webpack_require__(191);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = all;
	
	var _createChainableTypeChecker = __webpack_require__(317);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function all() {
	  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
	    validators[_key] = arguments[_key];
	  }
	
	  function allPropTypes() {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var error = null;
	
	    validators.forEach(function (validator) {
	      if (error != null) {
	        return;
	      }
	
	      var result = validator.apply(undefined, args);
	      if (result != null) {
	        error = result;
	      }
	    });
	
	    return error;
	  }
	
	  return (0, _createChainableTypeChecker2.default)(allPropTypes);
	}
	module.exports = exports['default'];

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(317);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validate(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
	  }
	
	  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(validate);
	module.exports = exports['default'];

/***/ },
/* 316 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isRequiredForA11y;
	function isRequiredForA11y(validator) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 317 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	module.exports = exports['default'];

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(58));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _activeElement = _interopRequireDefault(__webpack_require__(828));
	
	var _contains = _interopRequireDefault(__webpack_require__(188));
	
	var _keycode = _interopRequireDefault(__webpack_require__(304));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(31));
	
	var _all = _interopRequireDefault(__webpack_require__(314));
	
	var _elementType = _interopRequireDefault(__webpack_require__(34));
	
	var _isRequiredForA11y = _interopRequireDefault(__webpack_require__(316));
	
	var _uncontrollable = _interopRequireDefault(__webpack_require__(155));
	
	var _warning = _interopRequireDefault(__webpack_require__(47));
	
	var _ButtonGroup = _interopRequireDefault(__webpack_require__(502));
	
	var _DropdownMenu = _interopRequireDefault(__webpack_require__(1932));
	
	var _DropdownToggle = _interopRequireDefault(__webpack_require__(872));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var _PropTypes = __webpack_require__(896);
	
	var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(62));
	
	var TOGGLE_ROLE = _DropdownToggle.default.defaultProps.bsRole;
	var MENU_ROLE = _DropdownMenu.default.defaultProps.bsRole;
	var propTypes = {
	  /**
	   * The menu will open above the dropdown button, instead of below it.
	   */
	  dropup: _propTypes.default.bool,
	
	  /**
	   * An html id attribute, necessary for assistive technologies, such as screen readers.
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y.default)(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),
	  componentClass: _elementType.default,
	
	  /**
	   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
	   * @type {node}
	   */
	  children: (0, _all.default)((0, _PropTypes.requiredRoles)(TOGGLE_ROLE, MENU_ROLE), (0, _PropTypes.exclusiveRoles)(MENU_ROLE)),
	
	  /**
	   * Whether or not component is disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Align the menu to the right side of the Dropdown toggle
	   */
	  pullRight: _propTypes.default.bool,
	
	  /**
	   * Whether or not the Dropdown is visible.
	   *
	   * @controllable onToggle
	   */
	  open: _propTypes.default.bool,
	  defaultOpen: _propTypes.default.bool,
	
	  /**
	   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
	   * `open` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
	   *
	   * ```js
	   * function(Boolean isOpen, Object event, { String source }) {}
	   * ```
	   * @controllable open
	   */
	  onToggle: _propTypes.default.func,
	
	  /**
	   * A callback fired when a menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _propTypes.default.func,
	
	  /**
	   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
	   * a menu button.
	   */
	  role: _propTypes.default.string,
	
	  /**
	   * Which event when fired outside the component will cause it to be closed
	   *
	   * *Note: For custom dropdown components, you will have to pass the
	   * `rootCloseEvent` to `<RootCloseWrapper>` in your custom dropdown menu
	   * component ([similarly to how it is implemented in `<Dropdown.Menu>`](https://github.com/react-bootstrap/react-bootstrap/blob/v0.31.5/src/DropdownMenu.js#L115-L119)).*
	   */
	  rootCloseEvent: _propTypes.default.oneOf(['click', 'mousedown']),
	
	  /**
	   * @private
	   */
	  onMouseEnter: _propTypes.default.func,
	
	  /**
	   * @private
	   */
	  onMouseLeave: _propTypes.default.func
	};
	var defaultProps = {
	  componentClass: _ButtonGroup.default
	};
	
	var Dropdown =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Dropdown, _React$Component);
	
	  function Dropdown(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleClose = _this.handleClose.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this._focusInDropdown = false;
	    _this.lastOpenEventType = null;
	    return _this;
	  }
	
	  var _proto = Dropdown.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.focusNextOnOpen();
	  };
	
	  _proto.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (!nextProps.open && this.props.open) {
	      this._focusInDropdown = (0, _contains.default)(_reactDom.default.findDOMNode(this.menu), (0, _activeElement.default)(document));
	    }
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var open = this.props.open;
	    var prevOpen = prevProps.open;
	
	    if (open && !prevOpen) {
	      this.focusNextOnOpen();
	    }
	
	    if (!open && prevOpen) {
	      // if focus hasn't already moved from the menu let's return it
	      // to the toggle
	      if (this._focusInDropdown) {
	        this._focusInDropdown = false;
	        this.focus();
	      }
	    }
	  };
	
	  _proto.focus = function focus() {
	    var toggle = _reactDom.default.findDOMNode(this.toggle);
	
	    if (toggle && toggle.focus) {
	      toggle.focus();
	    }
	  };
	
	  _proto.focusNextOnOpen = function focusNextOnOpen() {
	    var menu = this.menu;
	
	    if (!menu || !menu.focusNext) {
	      return;
	    }
	
	    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
	      menu.focusNext();
	    }
	  };
	
	  _proto.handleClick = function handleClick(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    this.toggleOpen(event, {
	      source: 'click'
	    });
	  };
	
	  _proto.handleClose = function handleClose(event, eventDetails) {
	    if (!this.props.open) {
	      return;
	    }
	
	    this.toggleOpen(event, eventDetails);
	  };
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    switch (event.keyCode) {
	      case _keycode.default.codes.down:
	        if (!this.props.open) {
	          this.toggleOpen(event, {
	            source: 'keydown'
	          });
	        } else if (this.menu.focusNext) {
	          this.menu.focusNext();
	        }
	
	        event.preventDefault();
	        break;
	
	      case _keycode.default.codes.esc:
	      case _keycode.default.codes.tab:
	        this.handleClose(event, {
	          source: 'keydown'
	        });
	        break;
	
	      default:
	    }
	  };
	
	  _proto.toggleOpen = function toggleOpen(event, eventDetails) {
	    var open = !this.props.open;
	
	    if (open) {
	      this.lastOpenEventType = eventDetails.source;
	    }
	
	    if (this.props.onToggle) {
	      this.props.onToggle(open, event, eventDetails);
	    }
	  };
	
	  _proto.renderMenu = function renderMenu(child, _ref) {
	    var _this2 = this;
	
	    var id = _ref.id,
	        onSelect = _ref.onSelect,
	        rootCloseEvent = _ref.rootCloseEvent,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["id", "onSelect", "rootCloseEvent"]);
	
	    var ref = function ref(c) {
	      _this2.menu = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning.default)(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction.default)(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends2.default)({}, props, {
	      ref: ref,
	      labelledBy: id,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'menu'),
	      onClose: (0, _createChainedFunction.default)(child.props.onClose, this.handleClose),
	      onSelect: (0, _createChainedFunction.default)(child.props.onSelect, onSelect, function (key, event) {
	        return _this2.handleClose(event, {
	          source: 'select'
	        });
	      }),
	      rootCloseEvent: rootCloseEvent
	    }));
	  };
	
	  _proto.renderToggle = function renderToggle(child, props) {
	    var _this3 = this;
	
	    var ref = function ref(c) {
	      _this3.toggle = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning.default)(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction.default)(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends2.default)({}, props, {
	      ref: ref,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'toggle'),
	      onClick: (0, _createChainedFunction.default)(child.props.onClick, this.handleClick),
	      onKeyDown: (0, _createChainedFunction.default)(child.props.onKeyDown, this.handleKeyDown)
	    }));
	  };
	
	  _proto.render = function render() {
	    var _classes,
	        _this4 = this;
	
	    var _this$props = this.props,
	        Component = _this$props.componentClass,
	        id = _this$props.id,
	        dropup = _this$props.dropup,
	        disabled = _this$props.disabled,
	        pullRight = _this$props.pullRight,
	        open = _this$props.open,
	        onSelect = _this$props.onSelect,
	        role = _this$props.role,
	        bsClass = _this$props.bsClass,
	        className = _this$props.className,
	        rootCloseEvent = _this$props.rootCloseEvent,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "id", "dropup", "disabled", "pullRight", "open", "onSelect", "role", "bsClass", "className", "rootCloseEvent", "children"]);
	    delete props.onToggle;
	    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);
	
	    if (dropup) {
	      classes[bsClass] = false;
	      classes.dropup = true;
	    } // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	
	    return _react.default.createElement(Component, (0, _extends2.default)({}, props, {
	      className: (0, _classnames.default)(className, classes)
	    }), _ValidComponentChildren.default.map(children, function (child) {
	      switch (child.props.bsRole) {
	        case TOGGLE_ROLE:
	          return _this4.renderToggle(child, {
	            id: id,
	            disabled: disabled,
	            open: open,
	            role: role,
	            bsClass: bsClass
	          });
	
	        case MENU_ROLE:
	          return _this4.renderMenu(child, {
	            id: id,
	            open: open,
	            pullRight: pullRight,
	            bsClass: bsClass,
	            onSelect: onSelect,
	            rootCloseEvent: rootCloseEvent
	          });
	
	        default:
	          return child;
	      }
	    }));
	  };
	
	  return Dropdown;
	}(_react.default.Component);
	
	Dropdown.propTypes = propTypes;
	Dropdown.defaultProps = defaultProps;
	(0, _bootstrapUtils.bsClass)('dropdown', Dropdown);
	var UncontrolledDropdown = (0, _uncontrollable.default)(Dropdown, {
	  open: 'onToggle'
	});
	UncontrolledDropdown.Toggle = _DropdownToggle.default;
	UncontrolledDropdown.Menu = _DropdownMenu.default;
	var _default = UncontrolledDropdown;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _Transition = _interopRequireWildcard(__webpack_require__(526));
	
	var _fadeStyles;
	
	var propTypes = {
	  /**
	   * Show the component; triggers the fade in or fade out animation
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes.default.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is faded out
	   */
	  unmountOnExit: _propTypes.default.bool,
	
	  /**
	   * Run the fade in animation when the component mounts, if it is initially
	   * shown
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * Duration of the fade animation in milliseconds, to ensure that finishing
	   * callbacks are fired even if the original browser transition end events are
	   * canceled
	   */
	  timeout: _propTypes.default.number,
	
	  /**
	   * Callback fired before the component fades in
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired after the component starts to fade in
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired after the has component faded in
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired before the component fades out
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired after the component starts to fade out
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * Callback fired after the component has faded out
	   */
	  onExited: _propTypes.default.func
	};
	var defaultProps = {
	  in: false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false
	};
	var fadeStyles = (_fadeStyles = {}, _fadeStyles[_Transition.ENTERING] = 'in', _fadeStyles[_Transition.ENTERED] = 'in', _fadeStyles);
	
	var Fade =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Fade, _React$Component);
	
	  function Fade() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Fade.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "children"]);
	    return _react.default.createElement(_Transition.default, props, function (status, innerProps) {
	      return _react.default.cloneElement(children, (0, _extends2.default)({}, innerProps, {
	        className: (0, _classnames.default)('fade', className, children.props.className, fadeStyles[status])
	      }));
	    });
	  };
	
	  return Fade;
	}(_react.default.Component);
	
	Fade.propTypes = propTypes;
	Fade.defaultProps = defaultProps;
	var _default = Fade;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _elementType = _interopRequireDefault(__webpack_require__(34));
	
	var _MediaBody = _interopRequireDefault(__webpack_require__(1942));
	
	var _MediaHeading = _interopRequireDefault(__webpack_require__(1943));
	
	var _MediaLeft = _interopRequireDefault(__webpack_require__(1944));
	
	var _MediaList = _interopRequireDefault(__webpack_require__(1945));
	
	var _MediaListItem = _interopRequireDefault(__webpack_require__(1946));
	
	var _MediaRight = _interopRequireDefault(__webpack_require__(1947));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var propTypes = {
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Media =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Media, _React$Component);
	
	  function Media() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Media.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.componentClass,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return Media;
	}(_react.default.Component);
	
	Media.propTypes = propTypes;
	Media.defaultProps = defaultProps;
	Media.Heading = _MediaHeading.default;
	Media.Body = _MediaBody.default;
	Media.Left = _MediaLeft.default;
	Media.Right = _MediaRight.default;
	Media.List = _MediaList.default;
	Media.ListItem = _MediaListItem.default;
	
	var _default = (0, _bootstrapUtils.bsClass)('media', Media);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = splitComponentProps;
	
	var _entries = _interopRequireDefault(__webpack_require__(534));
	
	function splitComponentProps(props, Component) {
	  var componentPropTypes = Component.propTypes;
	  var parentProps = {};
	  var childProps = {};
	  (0, _entries.default)(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (componentPropTypes[propName]) {
	      parentProps[propName] = propValue;
	    } else {
	      childProps[propName] = propValue;
	    }
	  });
	  return [parentProps, childProps];
	}
	
	module.exports = exports["default"];

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _extends = __webpack_require__(1998);
	var _objectWithoutPropertiesLoose = __webpack_require__(1999);
	var finalForm = __webpack_require__(124);
	var reactFinalForm = __webpack_require__(17);
	var React = __webpack_require__(1);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
	var _objectWithoutPropertiesLoose__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutPropertiesLoose);
	var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
	
	// shared logic between components that use either render prop,
	// children render function, or component prop
	function renderComponent(props, name) {
	  var render = props.render,
	      children = props.children,
	      component = props.component,
	      rest = _objectWithoutPropertiesLoose__default['default'](props, ["render", "children", "component"]);
	
	  if (component) {
	    return /*#__PURE__*/React.createElement(component, _extends__default['default']({}, rest, {
	      children: children,
	      render: render
	    })); // inject children back in
	  }
	
	  if (render) {
	    return render(children === undefined ? rest : _extends__default['default']({}, rest, {
	      children: children
	    })); // inject children back in
	  }
	
	  if (typeof children !== 'function') {
	    throw new Error("Must specify either a render prop, a render function as children, or a component prop to " + name);
	  }
	
	  return children(rest);
	}
	
	var defaultIsEqual = function defaultIsEqual(aArray, bArray) {
	  return aArray === bArray || Array.isArray(aArray) && Array.isArray(bArray) && aArray.length === bArray.length && !aArray.some(function (a, index) {
	    return a !== bArray[index];
	  });
	};
	
	/**
	 * A simple hook to create a constant value that lives for
	 * the lifetime of the component.
	 *
	 * Plagiarized from https://github.com/Andarist/use-constant
	 *
	 * Do NOT reuse this code unless you know what you're doing.
	 * Use Andarist's hook; it's more fault tolerant to things like
	 * falsy values.
	 *
	 * @param {Function} init - A function to generate the value
	 */
	
	function useConstant(init) {
	  var ref = React__default['default'].useRef();
	
	  if (!ref.current) {
	    ref.current = init();
	  }
	
	  return ref.current;
	}
	
	var all = finalForm.fieldSubscriptionItems.reduce(function (result, key) {
	  result[key] = true;
	  return result;
	}, {});
	
	var useFieldArray = function useFieldArray(name, _temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$subscription = _ref.subscription,
	      subscription = _ref$subscription === void 0 ? all : _ref$subscription,
	      defaultValue = _ref.defaultValue,
	      initialValue = _ref.initialValue,
	      _ref$isEqual = _ref.isEqual,
	      isEqual = _ref$isEqual === void 0 ? defaultIsEqual : _ref$isEqual,
	      validateProp = _ref.validate;
	
	  var form = reactFinalForm.useForm('useFieldArray');
	  var formMutators = form.mutators;
	  var hasMutators = !!(formMutators && formMutators.push && formMutators.pop);
	
	  if (!hasMutators) {
	    throw new Error('Array mutators not found. You need to provide the mutators from final-form-arrays to your form');
	  }
	
	  var mutators = useConstant(function () {
	    return (// curry the field name onto all mutator calls
	      Object.keys(formMutators).reduce(function (result, key) {
	        result[key] = function () {
	          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          return formMutators[key].apply(formMutators, [name].concat(args));
	        };
	
	        return result;
	      }, {})
	    );
	  });
	  var validate = useConstant(function () {
	    return function (value, allValues, meta) {
	      if (!validateProp) return undefined;
	      var error = validateProp(value, allValues, meta);
	
	      if (!error || Array.isArray(error)) {
	        return error;
	      } else {
	        var arrayError = [] // gross, but we have to set a string key on the array
	        ;
	        arrayError[finalForm.ARRAY_ERROR] = error;
	        return arrayError;
	      }
	    };
	  });
	
	  var _useField = reactFinalForm.useField(name, {
	    subscription: _extends__default['default']({}, subscription, {
	      length: true
	    }),
	    defaultValue: defaultValue,
	    initialValue: initialValue,
	    isEqual: isEqual,
	    validate: validate,
	    format: function format(v) {
	      return v;
	    }
	  }),
	      _useField$meta = _useField.meta,
	      length = _useField$meta.length,
	      meta = _objectWithoutPropertiesLoose__default['default'](_useField$meta, ["length"]),
	      input = _useField.input,
	      fieldState = _objectWithoutPropertiesLoose__default['default'](_useField, ["meta", "input"]);
	
	  var forEach = function forEach(iterator) {
	    // required || for Flow, but results in uncovered line in Jest/Istanbul
	    // istanbul ignore next
	    var len = length || 0;
	
	    for (var i = 0; i < len; i++) {
	      iterator(name + "[" + i + "]", i);
	    }
	  };
	
	  var map = function map(iterator) {
	    // required || for Flow, but results in uncovered line in Jest/Istanbul
	    // istanbul ignore next
	    var len = length || 0;
	    var results = [];
	
	    for (var i = 0; i < len; i++) {
	      results.push(iterator(name + "[" + i + "]", i));
	    }
	
	    return results;
	  };
	
	  return {
	    fields: _extends__default['default']({
	      name: name,
	      forEach: forEach,
	      length: length || 0,
	      map: map
	    }, mutators, fieldState, {
	      value: input.value
	    }),
	    meta: meta
	  };
	};
	
	var version = "3.1.2";
	
	var versions = {
	  'final-form': finalForm.version,
	  'react-final-form': reactFinalForm.version,
	  'react-final-form-arrays': version
	};
	
	var FieldArray = function FieldArray(_ref) {
	  var name = _ref.name,
	      subscription = _ref.subscription,
	      defaultValue = _ref.defaultValue,
	      initialValue = _ref.initialValue,
	      isEqual = _ref.isEqual,
	      validate = _ref.validate,
	      rest = _objectWithoutPropertiesLoose__default['default'](_ref, ["name", "subscription", "defaultValue", "initialValue", "isEqual", "validate"]);
	
	  var _useFieldArray = useFieldArray(name, {
	    subscription: subscription,
	    defaultValue: defaultValue,
	    initialValue: initialValue,
	    isEqual: isEqual,
	    validate: validate
	  }),
	      fields = _useFieldArray.fields,
	      meta = _useFieldArray.meta;
	
	  return renderComponent(_extends__default['default']({
	    fields: fields,
	    meta: _extends__default['default']({}, meta, {
	      __versions: versions
	    })
	  }, rest), "FieldArray(" + name + ")");
	};
	
	exports.FieldArray = FieldArray;
	exports.useFieldArray = useFieldArray;
	exports.version = version;


/***/ },
/* 323 */
/***/ function(module, exports) {

	
	// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
	// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = stripStyle;
	
	function stripStyle(style) {
	  var ret = {};
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getContainer;
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(container) || defaultContainer;
	}
	module.exports = exports['default'];

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.NavLink = exports.MemoryRouter = exports.Link = exports.HashRouter = exports.BrowserRouter = undefined;
	
	var _BrowserRouter2 = __webpack_require__(2065);
	
	var _BrowserRouter3 = _interopRequireDefault(_BrowserRouter2);
	
	var _HashRouter2 = __webpack_require__(2066);
	
	var _HashRouter3 = _interopRequireDefault(_HashRouter2);
	
	var _Link2 = __webpack_require__(918);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _MemoryRouter2 = __webpack_require__(2067);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _NavLink2 = __webpack_require__(2068);
	
	var _NavLink3 = _interopRequireDefault(_NavLink2);
	
	var _Prompt2 = __webpack_require__(2069);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(2070);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(919);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(518);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(2071);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(2072);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _matchPath2 = __webpack_require__(2073);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(2080);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BrowserRouter = _BrowserRouter3.default;
	exports.HashRouter = _HashRouter3.default;
	exports.Link = _Link3.default;
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.NavLink = _NavLink3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ },
/* 326 */
[2243, 2077],
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(157);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactInputAutosize = __webpack_require__(2017);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _defaultArrowRenderer = __webpack_require__(930);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultFilterOptions = __webpack_require__(523);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(524);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _defaultClearRenderer = __webpack_require__(931);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _Option = __webpack_require__(928);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _Value = __webpack_require__(929);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 Copyright (c) 2017 Jed Watson.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 Licensed under the MIT License (MIT), see
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 http://jedwatson.github.io/react-select
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
	
	
	var stringifyValue = function stringifyValue(value) {
		return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
	};
	
	var stringOrNode = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]);
	var stringOrNumber = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
	
	var instanceId = 1;
	
	var Select = function (_React$Component) {
		_inherits(Select, _React$Component);
	
		function Select(props) {
			_classCallCheck(this, Select);
	
			var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
			['clearValue', 'focusOption', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleRequired', 'handleTouchOutside', 'handleTouchMove', 'handleTouchStart', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleValueClick', 'getOptionLabel', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
				return _this[fn] = _this[fn].bind(_this);
			});
	
			_this.state = {
				inputValue: '',
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false,
				required: false
			};
			return _this;
		}
	
		_createClass(Select, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
				var valueArray = this.getValueArray(this.props.value);
	
				if (this.props.required) {
					this.setState({
						required: this.handleRequired(valueArray[0], this.props.multi)
					});
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
					console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
				}
				if (this.props.autoFocus || this.props.autofocus) {
					this.focus();
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var valueArray = this.getValueArray(nextProps.value, nextProps);
	
				if (nextProps.required) {
					this.setState({
						required: this.handleRequired(valueArray[0], nextProps.multi)
					});
				} else if (this.props.required) {
					// Used to be required but it's not any more
					this.setState({ required: false });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				// focus to the selected option
				if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
					var focusedOptionNode = (0, _reactDom.findDOMNode)(this.focused);
					var menuNode = (0, _reactDom.findDOMNode)(this.menu);
	
					var scrollTop = menuNode.scrollTop;
					var scrollBottom = scrollTop + menuNode.offsetHeight;
					var optionTop = focusedOptionNode.offsetTop;
					var optionBottom = optionTop + focusedOptionNode.offsetHeight;
	
					if (scrollTop > optionTop || scrollBottom < optionBottom) {
						menuNode.scrollTop = focusedOptionNode.offsetTop;
					}
	
					// We still set hasScrolledToOption to true even if we didn't
					// actually need to scroll, as we've still confirmed that the
					// option is in view.
					this.hasScrolledToOption = true;
				} else if (!this.state.isOpen) {
					this.hasScrolledToOption = false;
				}
	
				if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
					this._scrollToFocusedOptionOnUpdate = false;
					var focusedDOM = (0, _reactDom.findDOMNode)(this.focused);
					var menuDOM = (0, _reactDom.findDOMNode)(this.menu);
					var focusedRect = focusedDOM.getBoundingClientRect();
					var menuRect = menuDOM.getBoundingClientRect();
					if (focusedRect.bottom > menuRect.bottom) {
						menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
					} else if (focusedRect.top < menuRect.top) {
						menuDOM.scrollTop = focusedDOM.offsetTop;
					}
				}
				if (this.props.scrollMenuIntoView && this.menuContainer) {
					var menuContainerRect = this.menuContainer.getBoundingClientRect();
					if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
						window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
					}
				}
				if (prevProps.disabled !== this.props.disabled) {
					this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
					this.closeMenu();
				}
				if (prevState.isOpen !== this.state.isOpen) {
					this.toggleTouchOutsideEvent(this.state.isOpen);
					var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
					handler && handler();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.toggleTouchOutsideEvent(false);
			}
		}, {
			key: 'toggleTouchOutsideEvent',
			value: function toggleTouchOutsideEvent(enabled) {
				if (enabled) {
					if (!document.addEventListener && document.attachEvent) {
						document.attachEvent('ontouchstart', this.handleTouchOutside);
					} else {
						document.addEventListener('touchstart', this.handleTouchOutside);
					}
				} else {
					if (!document.removeEventListener && document.detachEvent) {
						document.detachEvent('ontouchstart', this.handleTouchOutside);
					} else {
						document.removeEventListener('touchstart', this.handleTouchOutside);
					}
				}
			}
		}, {
			key: 'handleTouchOutside',
			value: function handleTouchOutside(event) {
				// handle touch outside on ios to dismiss menu
				if (this.wrapper && !this.wrapper.contains(event.target)) {
					this.closeMenu();
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				if (!this.input) return;
				this.input.focus();
			}
		}, {
			key: 'blurInput',
			value: function blurInput() {
				if (!this.input) return;
				this.input.blur();
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove(event) {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart(event) {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchEndClearValue',
			value: function handleTouchEndClearValue(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Clear the value
				this.clearValue(event);
			}
		}, {
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (event.target.tagName === 'INPUT') {
					if (!this.state.isFocused) {
						this._openAfterFocus = this.props.openOnClick;
						this.focus();
					} else if (!this.state.isOpen) {
						this.setState({
							isOpen: true,
							isPseudoFocused: false
						});
					}
					return;
				}
	
				// prevent default event handlers
				event.preventDefault();
	
				// for the non-searchable select, toggle the menu
				if (!this.props.searchable) {
					// TODO: This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
					this.focus();
					return this.setState({
						isOpen: !this.state.isOpen
					});
				}
	
				if (this.state.isFocused) {
					// On iOS, we can get into a state where we think the input is focused but it isn't really,
					// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
					// Call focus() again here to be safe.
					this.focus();
	
					var input = this.input;
					if (typeof input.getInput === 'function') {
						// Get the actual DOM input if the ref is an <AutosizeInput /> component
						input = input.getInput();
					}
	
					// clears the value so that the cursor will be at the end of input when the component re-renders
					input.value = '';
	
					// if the input is focused, ensure the menu is open
					this.setState({
						isOpen: true,
						isPseudoFocused: false
					});
				} else {
					// otherwise, focus the input and open the menu
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
				}
			}
		}, {
			key: 'handleMouseDownOnArrow',
			value: function handleMouseDownOnArrow(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				// If the menu isn't open, let the event bubble to the main handleMouseDown
				if (!this.state.isOpen) {
					this.setState({
						isOpen: true
					});
				}
				// prevent default event handlers
				event.stopPropagation();
				event.preventDefault();
				// close the menu
				if (this.state.isOpen) {
					this.closeMenu();
				}
			}
		}, {
			key: 'handleMouseDownOnMenu',
			value: function handleMouseDownOnMenu(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				event.stopPropagation();
				event.preventDefault();
	
				this._openAfterFocus = true;
				this.focus();
			}
		}, {
			key: 'closeMenu',
			value: function closeMenu() {
				if (this.props.onCloseResetsInput) {
					this.setState({
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi,
						inputValue: this.handleInputValueChange('')
					});
				} else {
					this.setState({
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				}
				this.hasScrolledToOption = false;
			}
		}, {
			key: 'handleInputFocus',
			value: function handleInputFocus(event) {
				if (this.props.disabled) return;
				var isOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
				if (this.props.onFocus) {
					this.props.onFocus(event);
				}
				this.setState({
					isFocused: true,
					isOpen: isOpen
				});
				this._openAfterFocus = false;
			}
		}, {
			key: 'handleInputBlur',
			value: function handleInputBlur(event) {
				// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
				if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
					this.focus();
					return;
				}
	
				if (this.props.onBlur) {
					this.props.onBlur(event);
				}
				var onBlurredState = {
					isFocused: false,
					isOpen: false,
					isPseudoFocused: false
				};
				if (this.props.onBlurResetsInput) {
					onBlurredState.inputValue = this.handleInputValueChange('');
				}
				this.setState(onBlurredState);
			}
		}, {
			key: 'handleInputChange',
			value: function handleInputChange(event) {
				var newInputValue = event.target.value;
	
				if (this.state.inputValue !== event.target.value) {
					newInputValue = this.handleInputValueChange(newInputValue);
				}
	
				this.setState({
					isOpen: true,
					isPseudoFocused: false,
					inputValue: newInputValue
				});
			}
		}, {
			key: 'handleInputValueChange',
			value: function handleInputValueChange(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					// Note: != used deliberately here to catch undefined and null
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				return newValue;
			}
		}, {
			key: 'handleKeyDown',
			value: function handleKeyDown(event) {
				if (this.props.disabled) return;
	
				if (typeof this.props.onInputKeyDown === 'function') {
					this.props.onInputKeyDown(event);
					if (event.defaultPrevented) {
						return;
					}
				}
	
				switch (event.keyCode) {
					case 8:
						// backspace
						if (!this.state.inputValue && this.props.backspaceRemoves) {
							event.preventDefault();
							this.popValue();
						}
						return;
					case 9:
						// tab
						if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
							return;
						}
						event.preventDefault();
						this.selectFocusedOption();
						return;
					case 13:
						// enter
						event.preventDefault();
						event.stopPropagation();
						if (this.state.isOpen) {
							this.selectFocusedOption();
						} else {
							this.focusNextOption();
						}
						return;
						break;
					case 27:
						// escape
						if (this.state.isOpen) {
							this.closeMenu();
							event.stopPropagation();
						} else if (this.props.clearable && this.props.escapeClearsValue) {
							this.clearValue(event);
							event.stopPropagation();
						}
						break;
					case 32:
						// space
						if (this.props.searchable) {
							return;
						}
						event.preventDefault();
						if (!this.state.isOpen) {
							this.focusNextOption();
							return;
						}
						event.stopPropagation();
						this.selectFocusedOption();
						break;
					case 38:
						// up
						this.focusPreviousOption();
						break;
					case 40:
						// down
						this.focusNextOption();
						break;
					case 33:
						// page up
						this.focusPageUpOption();
						break;
					case 34:
						// page down
						this.focusPageDownOption();
						break;
					case 35:
						// end key
						if (event.shiftKey) {
							return;
						}
						this.focusEndOption();
						break;
					case 36:
						// home key
						if (event.shiftKey) {
							return;
						}
						this.focusStartOption();
						break;
					case 46:
						// delete
						if (!this.state.inputValue && this.props.deleteRemoves) {
							event.preventDefault();
							this.popValue();
						}
						return;
					default:
						return;
				}
				event.preventDefault();
			}
		}, {
			key: 'handleValueClick',
			value: function handleValueClick(option, event) {
				if (!this.props.onValueClick) return;
				this.props.onValueClick(option, event);
			}
		}, {
			key: 'handleMenuScroll',
			value: function handleMenuScroll(event) {
				if (!this.props.onMenuScrollToBottom) return;
				var target = event.target;
	
				if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
					this.props.onMenuScrollToBottom();
				}
			}
		}, {
			key: 'handleRequired',
			value: function handleRequired(value, multi) {
				if (!value) return true;
				return multi ? value.length === 0 : Object.keys(value).length === 0;
			}
		}, {
			key: 'getOptionLabel',
			value: function getOptionLabel(op) {
				return op[this.props.labelKey];
			}
	
			/**
	   * Turns a value into an array from the given options
	   * @param	{String|Number|Array}	value		- the value of the select input
	   * @param	{Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
	   * @returns	{Array}	the value of the select represented in an array
	   */
	
		}, {
			key: 'getValueArray',
			value: function getValueArray(value, nextProps) {
				var _this2 = this;
	
				/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
				var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
				if (props.multi) {
					if (typeof value === 'string') {
						value = value.split(props.delimiter);
					}
					if (!Array.isArray(value)) {
						if (value === null || value === undefined) return [];
						value = [value];
					}
					return value.map(function (value) {
						return _this2.expandValue(value, props);
					}).filter(function (i) {
						return i;
					});
				}
				var expandedValue = this.expandValue(value, props);
				return expandedValue ? [expandedValue] : [];
			}
	
			/**
	   * Retrieve a value from the given options and valueKey
	   * @param	{String|Number|Array}	value	- the selected value(s)
	   * @param	{Object}		props	- the Select component's props (or nextProps)
	   */
	
		}, {
			key: 'expandValue',
			value: function expandValue(value, props) {
				var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
				if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
				var options = props.options,
				    valueKey = props.valueKey;
	
				if (!options) return;
				for (var i = 0; i < options.length; i++) {
					if (String(options[i][valueKey]) === String(value)) return options[i];
				}
			}
		}, {
			key: 'setValue',
			value: function setValue(value) {
				var _this3 = this;
	
				if (this.props.autoBlur) {
					this.blurInput();
				}
				if (this.props.required) {
					var required = this.handleRequired(value, this.props.multi);
					this.setState({ required: required });
				}
				if (this.props.onChange) {
					if (this.props.simpleValue && value) {
						value = this.props.multi ? value.map(function (i) {
							return i[_this3.props.valueKey];
						}).join(this.props.delimiter) : value[this.props.valueKey];
					}
					this.props.onChange(value);
				}
			}
		}, {
			key: 'selectValue',
			value: function selectValue(value) {
				var _this4 = this;
	
				// NOTE: we actually add/set the value in a callback to make sure the
				// input value is empty to avoid styling issues in Chrome
				if (this.props.closeOnSelect) {
					this.hasScrolledToOption = false;
				}
				if (this.props.multi) {
					var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
					this.setState({
						focusedIndex: null,
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect
					}, function () {
						var valueArray = _this4.getValueArray(_this4.props.value);
						if (valueArray.some(function (i) {
							return i[_this4.props.valueKey] === value[_this4.props.valueKey];
						})) {
							_this4.removeValue(value);
						} else {
							_this4.addValue(value);
						}
					});
				} else {
					this.setState({
						inputValue: this.handleInputValueChange(''),
						isOpen: !this.props.closeOnSelect,
						isPseudoFocused: this.state.isFocused
					}, function () {
						_this4.setValue(value);
					});
				}
			}
		}, {
			key: 'addValue',
			value: function addValue(value) {
				var valueArray = this.getValueArray(this.props.value);
				var visibleOptions = this._visibleOptions.filter(function (val) {
					return !val.disabled;
				});
				var lastValueIndex = visibleOptions.indexOf(value);
				this.setValue(valueArray.concat(value));
				if (visibleOptions.length - 1 === lastValueIndex) {
					// the last option was selected; focus the second-last one
					this.focusOption(visibleOptions[lastValueIndex - 1]);
				} else if (visibleOptions.length > lastValueIndex) {
					// focus the option below the selected one
					this.focusOption(visibleOptions[lastValueIndex + 1]);
				}
			}
		}, {
			key: 'popValue',
			value: function popValue() {
				var valueArray = this.getValueArray(this.props.value);
				if (!valueArray.length) return;
				if (valueArray[valueArray.length - 1].clearableValue === false) return;
				this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
			}
		}, {
			key: 'removeValue',
			value: function removeValue(value) {
				var _this5 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				this.setValue(valueArray.filter(function (i) {
					return i[_this5.props.valueKey] !== value[_this5.props.valueKey];
				}));
				this.focus();
			}
		}, {
			key: 'clearValue',
			value: function clearValue(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, ignore it.
				if (event && event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				event.preventDefault();
				this.setValue(this.getResetValue());
				this.setState({
					isOpen: false,
					inputValue: this.handleInputValueChange('')
				}, this.focus);
			}
		}, {
			key: 'getResetValue',
			value: function getResetValue() {
				if (this.props.resetValue !== undefined) {
					return this.props.resetValue;
				} else if (this.props.multi) {
					return [];
				} else {
					return null;
				}
			}
		}, {
			key: 'focusOption',
			value: function focusOption(option) {
				this.setState({
					focusedOption: option
				});
			}
		}, {
			key: 'focusNextOption',
			value: function focusNextOption() {
				this.focusAdjacentOption('next');
			}
		}, {
			key: 'focusPreviousOption',
			value: function focusPreviousOption() {
				this.focusAdjacentOption('previous');
			}
		}, {
			key: 'focusPageUpOption',
			value: function focusPageUpOption() {
				this.focusAdjacentOption('page_up');
			}
		}, {
			key: 'focusPageDownOption',
			value: function focusPageDownOption() {
				this.focusAdjacentOption('page_down');
			}
		}, {
			key: 'focusStartOption',
			value: function focusStartOption() {
				this.focusAdjacentOption('start');
			}
		}, {
			key: 'focusEndOption',
			value: function focusEndOption() {
				this.focusAdjacentOption('end');
			}
		}, {
			key: 'focusAdjacentOption',
			value: function focusAdjacentOption(dir) {
				var options = this._visibleOptions.map(function (option, index) {
					return { option: option, index: index };
				}).filter(function (option) {
					return !option.option.disabled;
				});
				this._scrollToFocusedOptionOnUpdate = true;
				if (!this.state.isOpen) {
					this.setState({
						isOpen: true,
						inputValue: '',
						focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null)
					});
					return;
				}
				if (!options.length) return;
				var focusedIndex = -1;
				for (var i = 0; i < options.length; i++) {
					if (this._focusedOption === options[i].option) {
						focusedIndex = i;
						break;
					}
				}
				if (dir === 'next' && focusedIndex !== -1) {
					focusedIndex = (focusedIndex + 1) % options.length;
				} else if (dir === 'previous') {
					if (focusedIndex > 0) {
						focusedIndex = focusedIndex - 1;
					} else {
						focusedIndex = options.length - 1;
					}
				} else if (dir === 'start') {
					focusedIndex = 0;
				} else if (dir === 'end') {
					focusedIndex = options.length - 1;
				} else if (dir === 'page_up') {
					var potentialIndex = focusedIndex - this.props.pageSize;
					if (potentialIndex < 0) {
						focusedIndex = 0;
					} else {
						focusedIndex = potentialIndex;
					}
				} else if (dir === 'page_down') {
					var potentialIndex = focusedIndex + this.props.pageSize;
					if (potentialIndex > options.length - 1) {
						focusedIndex = options.length - 1;
					} else {
						focusedIndex = potentialIndex;
					}
				}
	
				if (focusedIndex === -1) {
					focusedIndex = 0;
				}
	
				this.setState({
					focusedIndex: options[focusedIndex].index,
					focusedOption: options[focusedIndex].option
				});
			}
		}, {
			key: 'getFocusedOption',
			value: function getFocusedOption() {
				return this._focusedOption;
			}
		}, {
			key: 'selectFocusedOption',
			value: function selectFocusedOption() {
				if (this._focusedOption) {
					return this.selectValue(this._focusedOption);
				}
			}
		}, {
			key: 'renderLoading',
			value: function renderLoading() {
				if (!this.props.isLoading) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
					_react2.default.createElement('span', { className: 'Select-loading' })
				);
			}
		}, {
			key: 'renderValue',
			value: function renderValue(valueArray, isOpen) {
				var _this6 = this;
	
				var renderLabel = this.props.valueRenderer || this.getOptionLabel;
				var ValueComponent = this.props.valueComponent;
				if (!valueArray.length) {
					return !this.state.inputValue ? _react2.default.createElement(
						'div',
						{ className: 'Select-placeholder' },
						this.props.placeholder
					) : null;
				}
				var onClick = this.props.onValueClick ? this.handleValueClick : null;
				if (this.props.multi) {
					return valueArray.map(function (value, i) {
						return _react2.default.createElement(
							ValueComponent,
							{
								id: _this6._instancePrefix + '-value-' + i,
								instancePrefix: _this6._instancePrefix,
								disabled: _this6.props.disabled || value.clearableValue === false,
								key: 'value-' + i + '-' + value[_this6.props.valueKey],
								onClick: onClick,
								onRemove: _this6.removeValue,
								value: value
							},
							renderLabel(value, i),
							_react2.default.createElement(
								'span',
								{ className: 'Select-aria-only' },
								'\xA0'
							)
						);
					});
				} else if (!this.state.inputValue) {
					if (isOpen) onClick = null;
					return _react2.default.createElement(
						ValueComponent,
						{
							id: this._instancePrefix + '-value-item',
							disabled: this.props.disabled,
							instancePrefix: this._instancePrefix,
							onClick: onClick,
							value: valueArray[0]
						},
						renderLabel(valueArray[0])
					);
				}
			}
		}, {
			key: 'renderInput',
			value: function renderInput(valueArray, focusedOptionIndex) {
				var _classNames,
				    _this7 = this;
	
				var className = (0, _classnames2.default)('Select-input', this.props.inputProps.className);
				var isOpen = !!this.state.isOpen;
	
				var ariaOwns = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
				var inputProps = _extends({}, this.props.inputProps, {
					role: 'combobox',
					'aria-expanded': '' + isOpen,
					'aria-owns': ariaOwns,
					'aria-haspopup': '' + isOpen,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-describedby': this.props['aria-describedby'],
					'aria-labelledby': this.props['aria-labelledby'],
					'aria-label': this.props['aria-label'],
					className: className,
					tabIndex: this.props.tabIndex,
					onBlur: this.handleInputBlur,
					onChange: this.handleInputChange,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref) {
						return _this7.input = _ref;
					},
					required: this.state.required,
					value: this.state.inputValue
				});
	
				if (this.props.inputRenderer) {
					return this.props.inputRenderer(inputProps);
				}
	
				if (this.props.disabled || !this.props.searchable) {
					var _props$inputProps = this.props.inputProps,
					    inputClassName = _props$inputProps.inputClassName,
					    divProps = _objectWithoutProperties(_props$inputProps, ['inputClassName']);
	
					var _ariaOwns = (0, _classnames2.default)(_defineProperty({}, this._instancePrefix + '-list', isOpen));
					return _react2.default.createElement('div', _extends({}, divProps, {
						role: 'combobox',
						'aria-expanded': isOpen,
						'aria-owns': _ariaOwns,
						'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
						'aria-labelledby': this.props['aria-labelledby'],
						'aria-label': this.props['aria-label'],
						className: className,
						tabIndex: this.props.tabIndex || 0,
						onBlur: this.handleInputBlur,
						onFocus: this.handleInputFocus,
						ref: function ref(_ref2) {
							return _this7.input = _ref2;
						},
						'aria-disabled': '' + !!this.props.disabled,
						style: { border: 0, width: 1, display: 'inline-block' } }));
				}
	
				if (this.props.autosize) {
					return _react2.default.createElement(_reactInputAutosize2.default, _extends({ id: this.props.id }, inputProps, { minWidth: '5' }));
				}
				return _react2.default.createElement(
					'div',
					{ className: className, key: 'input-wrap' },
					_react2.default.createElement('input', _extends({ id: this.props.id }, inputProps))
				);
			}
		}, {
			key: 'renderClear',
			value: function renderClear() {
				var valueArray = this.getValueArray(this.props.value);
				if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
				var clear = this.props.clearRenderer();
	
				return _react2.default.createElement(
					'span',
					{ className: 'Select-clear-zone', title: this.props.multi ? this.props.clearAllText : this.props.clearValueText,
						'aria-label': this.props.multi ? this.props.clearAllText : this.props.clearValueText,
						onMouseDown: this.clearValue,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove,
						onTouchEnd: this.handleTouchEndClearValue
					},
					clear
				);
			}
		}, {
			key: 'renderArrow',
			value: function renderArrow() {
				if (!this.props.arrowRenderer) return;
	
				var onMouseDown = this.handleMouseDownOnArrow;
				var isOpen = this.state.isOpen;
				var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });
	
				if (!arrow) {
					return null;
				}
	
				return _react2.default.createElement(
					'span',
					{
						className: 'Select-arrow-zone',
						onMouseDown: onMouseDown
					},
					arrow
				);
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions(excludeOptions) {
				var filterValue = this.state.inputValue;
				var options = this.props.options || [];
				if (this.props.filterOptions) {
					// Maintain backwards compatibility with boolean attribute
					var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _defaultFilterOptions2.default;
	
					return filterOptions(options, filterValue, excludeOptions, {
						filterOption: this.props.filterOption,
						ignoreAccents: this.props.ignoreAccents,
						ignoreCase: this.props.ignoreCase,
						labelKey: this.props.labelKey,
						matchPos: this.props.matchPos,
						matchProp: this.props.matchProp,
						valueKey: this.props.valueKey,
						trimFilter: this.props.trimFilter
					});
				} else {
					return options;
				}
			}
		}, {
			key: 'onOptionRef',
			value: function onOptionRef(ref, isFocused) {
				if (isFocused) {
					this.focused = ref;
				}
			}
		}, {
			key: 'renderMenu',
			value: function renderMenu(options, valueArray, focusedOption) {
				if (options && options.length) {
					return this.props.menuRenderer({
						focusedOption: focusedOption,
						focusOption: this.focusOption,
						inputValue: this.state.inputValue,
						instancePrefix: this._instancePrefix,
						labelKey: this.props.labelKey,
						onFocus: this.focusOption,
						onSelect: this.selectValue,
						optionClassName: this.props.optionClassName,
						optionComponent: this.props.optionComponent,
						optionRenderer: this.props.optionRenderer || this.getOptionLabel,
						options: options,
						selectValue: this.selectValue,
						removeValue: this.removeValue,
						valueArray: valueArray,
						valueKey: this.props.valueKey,
						onOptionRef: this.onOptionRef
					});
				} else if (this.props.noResultsText) {
					return _react2.default.createElement(
						'div',
						{ className: 'Select-noresults' },
						this.props.noResultsText
					);
				} else {
					return null;
				}
			}
		}, {
			key: 'renderHiddenField',
			value: function renderHiddenField(valueArray) {
				var _this8 = this;
	
				if (!this.props.name) return;
				if (this.props.joinValues) {
					var value = valueArray.map(function (i) {
						return stringifyValue(i[_this8.props.valueKey]);
					}).join(this.props.delimiter);
					return _react2.default.createElement('input', {
						type: 'hidden',
						ref: function ref(_ref3) {
							return _this8.value = _ref3;
						},
						name: this.props.name,
						value: value,
						disabled: this.props.disabled });
				}
				return valueArray.map(function (item, index) {
					return _react2.default.createElement('input', { key: 'hidden.' + index,
						type: 'hidden',
						ref: 'value' + index,
						name: _this8.props.name,
						value: stringifyValue(item[_this8.props.valueKey]),
						disabled: _this8.props.disabled });
				});
			}
		}, {
			key: 'getFocusableOptionIndex',
			value: function getFocusableOptionIndex(selectedOption) {
				var options = this._visibleOptions;
				if (!options.length) return null;
	
				var valueKey = this.props.valueKey;
				var focusedOption = this.state.focusedOption || selectedOption;
				if (focusedOption && !focusedOption.disabled) {
					var focusedOptionIndex = -1;
					options.some(function (option, index) {
						var isOptionEqual = option[valueKey] === focusedOption[valueKey];
						if (isOptionEqual) {
							focusedOptionIndex = index;
						}
						return isOptionEqual;
					});
					if (focusedOptionIndex !== -1) {
						return focusedOptionIndex;
					}
				}
	
				for (var i = 0; i < options.length; i++) {
					if (!options[i].disabled) return i;
				}
				return null;
			}
		}, {
			key: 'renderOuter',
			value: function renderOuter(options, valueArray, focusedOption) {
				var _this9 = this;
	
				var menu = this.renderMenu(options, valueArray, focusedOption);
				if (!menu) {
					return null;
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref5) {
							return _this9.menuContainer = _ref5;
						}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
					_react2.default.createElement(
						'div',
						{ ref: function ref(_ref4) {
								return _this9.menu = _ref4;
							}, role: 'listbox', tabIndex: -1, className: 'Select-menu', id: this._instancePrefix + '-list',
							style: this.props.menuStyle,
							onScroll: this.handleMenuScroll,
							onMouseDown: this.handleMouseDownOnMenu },
						menu
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this10 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
				var isOpen = this.state.isOpen;
				if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
				var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
	
				var focusedOption = null;
				if (focusedOptionIndex !== null) {
					focusedOption = this._focusedOption = options[focusedOptionIndex];
				} else {
					focusedOption = this._focusedOption = null;
				}
				var className = (0, _classnames2.default)('Select', this.props.className, {
					'Select--multi': this.props.multi,
					'Select--single': !this.props.multi,
					'is-clearable': this.props.clearable,
					'is-disabled': this.props.disabled,
					'is-focused': this.state.isFocused,
					'is-loading': this.props.isLoading,
					'is-open': isOpen,
					'is-pseudo-focused': this.state.isPseudoFocused,
					'is-searchable': this.props.searchable,
					'has-value': valueArray.length,
					'Select--rtl': this.props.rtl
				});
	
				var removeMessage = null;
				if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
					removeMessage = _react2.default.createElement(
						'span',
						{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
						this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
					);
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref7) {
							return _this10.wrapper = _ref7;
						},
						className: className,
						style: this.props.wrapperStyle },
					this.renderHiddenField(valueArray),
					_react2.default.createElement(
						'div',
						{ ref: function ref(_ref6) {
								return _this10.control = _ref6;
							},
							className: 'Select-control',
							style: this.props.style,
							onKeyDown: this.handleKeyDown,
							onMouseDown: this.handleMouseDown,
							onTouchEnd: this.handleTouchEnd,
							onTouchStart: this.handleTouchStart,
							onTouchMove: this.handleTouchMove
						},
						_react2.default.createElement(
							'span',
							{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
							this.renderValue(valueArray, isOpen),
							this.renderInput(valueArray, focusedOptionIndex)
						),
						removeMessage,
						this.renderLoading(),
						this.renderClear(),
						this.renderArrow()
					),
					isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
				);
			}
		}]);
	
		return Select;
	}(_react2.default.Component);
	
	;
	
	Select.propTypes = {
		'aria-describedby': _propTypes2.default.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
		'aria-label': _propTypes2.default.string, // aria label (for assistive tech)
		'aria-labelledby': _propTypes2.default.string, // html id of an element that should be used as the label (for assistive tech)
		arrowRenderer: _propTypes2.default.func, // create the drop-down caret element
		autoBlur: _propTypes2.default.bool, // automatically blur the component when an option is selected
		autoFocus: _propTypes2.default.bool, // autofocus the component on mount
		autofocus: _propTypes2.default.bool, // deprecated; use autoFocus instead
		autosize: _propTypes2.default.bool, // whether to enable autosizing or not
		backspaceRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
		backspaceToRemoveMessage: _propTypes2.default.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
		className: _propTypes2.default.string, // className for the outer element
		clearAllText: stringOrNode, // title for the "clear" control when multi: true
		clearRenderer: _propTypes2.default.func, // create clearable x element
		clearValueText: stringOrNode, // title for the "clear" control
		clearable: _propTypes2.default.bool, // should it be possible to reset value
		closeOnSelect: _propTypes2.default.bool, // whether to close the menu when a value is selected
		deleteRemoves: _propTypes2.default.bool, // whether delete removes an item if there is no text input
		delimiter: _propTypes2.default.string, // delimiter to use to join multiple values for the hidden field value
		disabled: _propTypes2.default.bool, // whether the Select is disabled or not
		escapeClearsValue: _propTypes2.default.bool, // whether escape clears the value when the menu is closed
		filterOption: _propTypes2.default.func, // method to filter a single option (option, filterString)
		filterOptions: _propTypes2.default.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
		id: _propTypes2.default.string, // html id to set on the input element for accessibility or tests
		ignoreAccents: _propTypes2.default.bool, // whether to strip diacritics when filtering
		ignoreCase: _propTypes2.default.bool, // whether to perform case-insensitive filtering
		inputProps: _propTypes2.default.object, // custom attributes for the Input
		inputRenderer: _propTypes2.default.func, // returns a custom input component
		instanceId: _propTypes2.default.string, // set the components instanceId
		isLoading: _propTypes2.default.bool, // whether the Select is loading externally or not (such as options being loaded)
		joinValues: _propTypes2.default.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
		labelKey: _propTypes2.default.string, // path of the label value in option objects
		matchPos: _propTypes2.default.string, // (any|start) match the start or entire string when filtering
		matchProp: _propTypes2.default.string, // (any|label|value) which option property to filter on
		menuBuffer: _propTypes2.default.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
		menuContainerStyle: _propTypes2.default.object, // optional style to apply to the menu container
		menuRenderer: _propTypes2.default.func, // renders a custom menu with options
		menuStyle: _propTypes2.default.object, // optional style to apply to the menu
		multi: _propTypes2.default.bool, // multi-value input
		name: _propTypes2.default.string, // generates a hidden <input /> tag with this field name for html forms
		noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
		onBlur: _propTypes2.default.func, // onBlur handler: function (event) {}
		onBlurResetsInput: _propTypes2.default.bool, // whether input is cleared on blur
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onClose: _propTypes2.default.func, // fires when the menu is closed
		onCloseResetsInput: _propTypes2.default.bool, // whether input is cleared when menu is closed through the arrow
		onFocus: _propTypes2.default.func, // onFocus handler: function (event) {}
		onInputChange: _propTypes2.default.func, // onInputChange handler: function (inputValue) {}
		onInputKeyDown: _propTypes2.default.func, // input keyDown handler: function (event) {}
		onMenuScrollToBottom: _propTypes2.default.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
		onOpen: _propTypes2.default.func, // fires when the menu is opened
		onSelectResetsInput: _propTypes2.default.bool, // whether input is cleared on select (works only for multiselect)
		onValueClick: _propTypes2.default.func, // onClick handler for value labels: function (value, event) {}
		openOnClick: _propTypes2.default.bool, // boolean to control opening the menu when the control is clicked
		openOnFocus: _propTypes2.default.bool, // always open options menu on focus
		optionClassName: _propTypes2.default.string, // additional class(es) to apply to the <Option /> elements
		optionComponent: _propTypes2.default.func, // option component to render in dropdown
		optionRenderer: _propTypes2.default.func, // optionRenderer: function (option) {}
		options: _propTypes2.default.array, // array of options
		pageSize: _propTypes2.default.number, // number of entries to page when using page up/down keys
		placeholder: stringOrNode, // field placeholder, displayed when there's no value
		removeSelected: _propTypes2.default.bool, // whether the selected option is removed from the dropdown on multi selects
		required: _propTypes2.default.bool, // applies HTML5 required attribute when needed
		resetValue: _propTypes2.default.any, // value to use when you clear the control
		rtl: _propTypes2.default.bool, // set to true in order to use react-select in right-to-left direction
		scrollMenuIntoView: _propTypes2.default.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
		searchable: _propTypes2.default.bool, // whether to enable searching feature or not
		simpleValue: _propTypes2.default.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
		style: _propTypes2.default.object, // optional style to apply to the control
		tabIndex: stringOrNumber, // optional tab index of the control
		tabSelectsValue: _propTypes2.default.bool, // whether to treat tabbing out while focused to be value selection
		trimFilter: _propTypes2.default.bool, // whether to trim whitespace around filter value
		value: _propTypes2.default.any, // initial field value
		valueComponent: _propTypes2.default.func, // value component to render
		valueKey: _propTypes2.default.string, // path of the label value in option objects
		valueRenderer: _propTypes2.default.func, // valueRenderer: function (option) {}
		wrapperStyle: _propTypes2.default.object // optional style to apply to the component wrapper
	};
	
	Select.defaultProps = {
		arrowRenderer: _defaultArrowRenderer2.default,
		autosize: true,
		backspaceRemoves: true,
		backspaceToRemoveMessage: 'Press backspace to remove {label}',
		clearable: true,
		clearAllText: 'Clear all',
		clearRenderer: _defaultClearRenderer2.default,
		clearValueText: 'Clear value',
		closeOnSelect: true,
		deleteRemoves: true,
		delimiter: ',',
		disabled: false,
		escapeClearsValue: true,
		filterOptions: _defaultFilterOptions2.default,
		ignoreAccents: true,
		ignoreCase: true,
		inputProps: {},
		isLoading: false,
		joinValues: false,
		labelKey: 'label',
		matchPos: 'any',
		matchProp: 'any',
		menuBuffer: 0,
		menuRenderer: _defaultMenuRenderer2.default,
		multi: false,
		noResultsText: 'No results found',
		onBlurResetsInput: true,
		onSelectResetsInput: true,
		onCloseResetsInput: true,
		openOnClick: true,
		optionComponent: _Option2.default,
		pageSize: 5,
		placeholder: 'Select...',
		removeSelected: true,
		required: false,
		rtl: false,
		scrollMenuIntoView: true,
		searchable: true,
		simpleValue: false,
		tabSelectsValue: true,
		trimFilter: true,
		valueComponent: _Value2.default,
		valueKey: 'value'
	};
	
	exports.default = Select;

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault(ex) {
	  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var _objectWithoutProperties = _interopDefault(__webpack_require__(163));
	
	var _extends = _interopDefault(__webpack_require__(160));
	
	var _toConsumableArray = _interopDefault(__webpack_require__(237));
	
	var _objectSpread = _interopDefault(__webpack_require__(196));
	
	var _classCallCheck = _interopDefault(__webpack_require__(158));
	
	var _createClass = _interopDefault(__webpack_require__(159));
	
	var _possibleConstructorReturn = _interopDefault(__webpack_require__(164));
	
	var _getPrototypeOf = _interopDefault(__webpack_require__(161));
	
	var _inherits = _interopDefault(__webpack_require__(162));
	
	var _assertThisInitialized = _interopDefault(__webpack_require__(127));
	
	var _defineProperty = _interopDefault(__webpack_require__(128));
	
	var React = __webpack_require__(1);
	
	var React__default = _interopDefault(React);
	
	var memoizeOne = _interopDefault(__webpack_require__(229));
	
	var core = __webpack_require__(167);
	
	var reactDom = __webpack_require__(31);
	
	var __chunk_1 = __webpack_require__(195);
	
	var __chunk_2 = __webpack_require__(234);
	
	var _css = _interopDefault(__webpack_require__(131));
	
	var diacritics = [{
	  base: 'A',
	  letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
	}, {
	  base: 'AA',
	  letters: /[\uA732]/g
	}, {
	  base: 'AE',
	  letters: /[\u00C6\u01FC\u01E2]/g
	}, {
	  base: 'AO',
	  letters: /[\uA734]/g
	}, {
	  base: 'AU',
	  letters: /[\uA736]/g
	}, {
	  base: 'AV',
	  letters: /[\uA738\uA73A]/g
	}, {
	  base: 'AY',
	  letters: /[\uA73C]/g
	}, {
	  base: 'B',
	  letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g
	}, {
	  base: 'C',
	  letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
	}, {
	  base: 'D',
	  letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
	}, {
	  base: 'DZ',
	  letters: /[\u01F1\u01C4]/g
	}, {
	  base: 'Dz',
	  letters: /[\u01F2\u01C5]/g
	}, {
	  base: 'E',
	  letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
	}, {
	  base: 'F',
	  letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g
	}, {
	  base: 'G',
	  letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
	}, {
	  base: 'H',
	  letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
	}, {
	  base: 'I',
	  letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
	}, {
	  base: 'J',
	  letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g
	}, {
	  base: 'K',
	  letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
	}, {
	  base: 'L',
	  letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
	}, {
	  base: 'LJ',
	  letters: /[\u01C7]/g
	}, {
	  base: 'Lj',
	  letters: /[\u01C8]/g
	}, {
	  base: 'M',
	  letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
	}, {
	  base: 'N',
	  letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
	}, {
	  base: 'NJ',
	  letters: /[\u01CA]/g
	}, {
	  base: 'Nj',
	  letters: /[\u01CB]/g
	}, {
	  base: 'O',
	  letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
	}, {
	  base: 'OI',
	  letters: /[\u01A2]/g
	}, {
	  base: 'OO',
	  letters: /[\uA74E]/g
	}, {
	  base: 'OU',
	  letters: /[\u0222]/g
	}, {
	  base: 'P',
	  letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g
	}, {
	  base: 'Q',
	  letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g
	}, {
	  base: 'R',
	  letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
	}, {
	  base: 'S',
	  letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
	}, {
	  base: 'T',
	  letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
	}, {
	  base: 'TZ',
	  letters: /[\uA728]/g
	}, {
	  base: 'U',
	  letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
	}, {
	  base: 'V',
	  letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g
	}, {
	  base: 'VY',
	  letters: /[\uA760]/g
	}, {
	  base: 'W',
	  letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g
	}, {
	  base: 'X',
	  letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g
	}, {
	  base: 'Y',
	  letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
	}, {
	  base: 'Z',
	  letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
	}, {
	  base: 'a',
	  letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
	}, {
	  base: 'aa',
	  letters: /[\uA733]/g
	}, {
	  base: 'ae',
	  letters: /[\u00E6\u01FD\u01E3]/g
	}, {
	  base: 'ao',
	  letters: /[\uA735]/g
	}, {
	  base: 'au',
	  letters: /[\uA737]/g
	}, {
	  base: 'av',
	  letters: /[\uA739\uA73B]/g
	}, {
	  base: 'ay',
	  letters: /[\uA73D]/g
	}, {
	  base: 'b',
	  letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g
	}, {
	  base: 'c',
	  letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
	}, {
	  base: 'd',
	  letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
	}, {
	  base: 'dz',
	  letters: /[\u01F3\u01C6]/g
	}, {
	  base: 'e',
	  letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
	}, {
	  base: 'f',
	  letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g
	}, {
	  base: 'g',
	  letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
	}, {
	  base: 'h',
	  letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
	}, {
	  base: 'hv',
	  letters: /[\u0195]/g
	}, {
	  base: 'i',
	  letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
	}, {
	  base: 'j',
	  letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g
	}, {
	  base: 'k',
	  letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
	}, {
	  base: 'l',
	  letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
	}, {
	  base: 'lj',
	  letters: /[\u01C9]/g
	}, {
	  base: 'm',
	  letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
	}, {
	  base: 'n',
	  letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
	}, {
	  base: 'nj',
	  letters: /[\u01CC]/g
	}, {
	  base: 'o',
	  letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
	}, {
	  base: 'oi',
	  letters: /[\u01A3]/g
	}, {
	  base: 'ou',
	  letters: /[\u0223]/g
	}, {
	  base: 'oo',
	  letters: /[\uA74F]/g
	}, {
	  base: 'p',
	  letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g
	}, {
	  base: 'q',
	  letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g
	}, {
	  base: 'r',
	  letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
	}, {
	  base: 's',
	  letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
	}, {
	  base: 't',
	  letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
	}, {
	  base: 'tz',
	  letters: /[\uA729]/g
	}, {
	  base: 'u',
	  letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
	}, {
	  base: 'v',
	  letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g
	}, {
	  base: 'vy',
	  letters: /[\uA761]/g
	}, {
	  base: 'w',
	  letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
	}, {
	  base: 'x',
	  letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g
	}, {
	  base: 'y',
	  letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
	}, {
	  base: 'z',
	  letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
	}];
	
	var stripDiacritics = function stripDiacritics(str) {
	  for (var i = 0; i < diacritics.length; i++) {
	    str = str.replace(diacritics[i].letters, diacritics[i].base);
	  }
	
	  return str;
	};
	
	var trimString = function trimString(str) {
	  return str.replace(/^\s+|\s+$/g, '');
	};
	
	var defaultStringify = function defaultStringify(option) {
	  return "".concat(option.label, " ").concat(option.value);
	};
	
	var createFilter = function createFilter(config) {
	  return function (option, rawInput) {
	    var _ignoreCase$ignoreAcc = _objectSpread({
	      ignoreCase: true,
	      ignoreAccents: true,
	      stringify: defaultStringify,
	      trim: true,
	      matchFrom: 'any'
	    }, config),
	        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
	        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
	        stringify = _ignoreCase$ignoreAcc.stringify,
	        trim = _ignoreCase$ignoreAcc.trim,
	        matchFrom = _ignoreCase$ignoreAcc.matchFrom;
	
	    var input = trim ? trimString(rawInput) : rawInput;
	    var candidate = trim ? trimString(stringify(option)) : stringify(option);
	
	    if (ignoreCase) {
	      input = input.toLowerCase();
	      candidate = candidate.toLowerCase();
	    }
	
	    if (ignoreAccents) {
	      input = stripDiacritics(input);
	      candidate = stripDiacritics(candidate);
	    }
	
	    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
	  };
	};
	
	var _ref =  true ? {
	  name: "1laao21-a11yText",
	  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;"
	} : {
	  name: "1laao21-a11yText",
	  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;",
	  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVFNIiwiZmlsZSI6IkExMXlUZXh0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgdHlwZSBFbGVtZW50Q29uZmlnIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vY29yZSc7XG5cbi8vIEFzc2lzdGl2ZSB0ZXh0IHRvIGRlc2NyaWJlIHZpc3VhbCBlbGVtZW50cy4gSGlkZGVuIGZvciBzaWdodGVkIHVzZXJzLlxuY29uc3QgQTExeVRleHQgPSAocHJvcHM6IEVsZW1lbnRDb25maWc8J3NwYW4nPikgPT4gKFxuICAgIDxzcGFuXG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdhMTF5VGV4dCcsXG4gICAgICAgIHpJbmRleDogOTk5OSxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICBjbGlwOiAncmVjdCgxcHgsIDFweCwgMXB4LCAxcHgpJyxcbiAgICAgICAgaGVpZ2h0OiAxLFxuICAgICAgICB3aWR0aDogMSxcbiAgICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICAgIG92ZXJmbG93OiAnaGlkZGVuJyxcbiAgICAgICAgcGFkZGluZzogMCxcbiAgICAgICAgd2hpdGVTcGFjZTogJ25vd3JhcCcsXG4gICAgICB9fVxuICAgICAgey4uLnByb3BzfVxuICAgIC8+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBBMTF5VGV4dDtcbiJdfQ== */"
	};
	
	var A11yText = function A11yText(props) {
	  return core.jsx("span", _extends({
	    css: _ref
	  }, props));
	};
	
	var DummyInput =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(DummyInput, _Component);
	
	  function DummyInput() {
	    _classCallCheck(this, DummyInput);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(DummyInput).apply(this, arguments));
	  }
	
	  _createClass(DummyInput, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          inProp = _this$props.in,
	          out = _this$props.out,
	          onExited = _this$props.onExited,
	          appear = _this$props.appear,
	          enter = _this$props.enter,
	          exit = _this$props.exit,
	          innerRef = _this$props.innerRef,
	          emotion = _this$props.emotion,
	          props = _objectWithoutProperties(_this$props, ["in", "out", "onExited", "appear", "enter", "exit", "innerRef", "emotion"]);
	
	      return core.jsx("input", _extends({
	        ref: innerRef
	      }, props, {
	        css:
	        /*#__PURE__*/
	        _css({
	          label: 'dummyInput',
	          // get rid of any default styles
	          background: 0,
	          border: 0,
	          fontSize: 'inherit',
	          outline: 0,
	          padding: 0,
	          // important! without `width` browsers won't allow focus
	          width: 1,
	          // remove cursor on desktop
	          color: 'transparent',
	          // remove cursor on mobile whilst maintaining "scroll into view" behaviour
	          left: -100,
	          opacity: 0,
	          position: 'relative',
	          transform: 'scale(0)'
	        },  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBWVEiLCJmaWxlIjoiRHVtbXlJbnB1dC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG4vKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IENvbXBvbmVudCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL2NvcmUnO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBEdW1teUlucHV0IGV4dGVuZHMgQ29tcG9uZW50PGFueT4ge1xuICByZW5kZXIgKCkge1xuICAgIGNvbnN0IHsgaW46IGluUHJvcCwgb3V0LCBvbkV4aXRlZCwgYXBwZWFyLCBlbnRlciwgZXhpdCwgaW5uZXJSZWYsIGVtb3Rpb24sIC4uLnByb3BzIH0gPSB0aGlzLnByb3BzO1xuICAgIHJldHVybihcbiAgICAgIDxpbnB1dFxuICAgICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgICB7Li4ucHJvcHN9XG4gICAgICAgIGNzcz17e1xuICAgICAgICAgIGxhYmVsOiAnZHVtbXlJbnB1dCcsXG4gICAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgICBiYWNrZ3JvdW5kOiAwLFxuICAgICAgICAgIGJvcmRlcjogMCxcbiAgICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICAgIG91dGxpbmU6IDAsXG4gICAgICAgICAgcGFkZGluZzogMCxcbiAgICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICAgIHdpZHRoOiAxLFxuXG4gICAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBkZXNrdG9wXG4gICAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIG1vYmlsZSB3aGlsc3QgbWFpbnRhaW5pbmcgXCJzY3JvbGwgaW50byB2aWV3XCIgYmVoYXZpb3VyXG4gICAgICAgICAgbGVmdDogLTEwMCxcbiAgICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxuICAgICAgICAgIHRyYW5zZm9ybTogJ3NjYWxlKDApJyxcbiAgICAgICAgfX1cbiAgICAgIC8+XG4gICAgKTtcbiAgfVxufVxuIl19 */")
	      }));
	    }
	  }]);
	
	  return DummyInput;
	}(React.Component);
	
	var NodeResolver =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(NodeResolver, _Component);
	
	  function NodeResolver() {
	    _classCallCheck(this, NodeResolver);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(NodeResolver).apply(this, arguments));
	  }
	
	  _createClass(NodeResolver, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.props.innerRef(reactDom.findDOMNode(this));
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.props.innerRef(null);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return NodeResolver;
	}(React.Component);
	
	var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
	var LOCK_STYLES = {
	  boxSizing: 'border-box',
	  // account for possible declaration `width: 100%;` on body
	  overflow: 'hidden',
	  position: 'relative',
	  height: '100%'
	};
	
	function preventTouchMove(e) {
	  e.preventDefault();
	}
	
	function allowTouchMove(e) {
	  e.stopPropagation();
	}
	
	function preventInertiaScroll() {
	  var top = this.scrollTop;
	  var totalScroll = this.scrollHeight;
	  var currentScroll = top + this.offsetHeight;
	
	  if (top === 0) {
	    this.scrollTop = 1;
	  } else if (currentScroll === totalScroll) {
	    this.scrollTop = top - 1;
	  }
	} // `ontouchstart` check works on most browsers
	// `maxTouchPoints` works on IE10/11 and Surface
	
	
	function isTouchDevice() {
	  return 'ontouchstart' in window || navigator.maxTouchPoints;
	}
	
	var canUseDOM = !!(window.document && window.document.createElement);
	var activeScrollLocks = 0;
	
	var ScrollLock =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ScrollLock, _Component);
	
	  function ScrollLock() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, ScrollLock);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollLock)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "originalStyles", {});
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "listenerOptions", {
	      capture: false,
	      passive: false
	    });
	
	    return _this;
	  }
	
	  _createClass(ScrollLock, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (!canUseDOM) return;
	      var _this$props = this.props,
	          accountForScrollbars = _this$props.accountForScrollbars,
	          touchScrollTarget = _this$props.touchScrollTarget;
	      var target = document.body;
	      var targetStyle = target && target.style;
	
	      if (accountForScrollbars) {
	        // store any styles already applied to the body
	        STYLE_KEYS.forEach(function (key) {
	          var val = targetStyle && targetStyle[key];
	          _this2.originalStyles[key] = val;
	        });
	      } // apply the lock styles and padding if this is the first scroll lock
	
	
	      if (accountForScrollbars && activeScrollLocks < 1) {
	        var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
	        var clientWidth = document.body ? document.body.clientWidth : 0;
	        var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
	        Object.keys(LOCK_STYLES).forEach(function (key) {
	          var val = LOCK_STYLES[key];
	
	          if (targetStyle) {
	            targetStyle[key] = val;
	          }
	        });
	
	        if (targetStyle) {
	          targetStyle.paddingRight = "".concat(adjustedPadding, "px");
	        }
	      } // account for touch devices
	
	
	      if (target && isTouchDevice()) {
	        // Mobile Safari ignores { overflow: hidden } declaration on the body.
	        target.addEventListener('touchmove', preventTouchMove, this.listenerOptions); // Allow scroll on provided target
	
	        if (touchScrollTarget) {
	          touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
	          touchScrollTarget.addEventListener('touchmove', allowTouchMove, this.listenerOptions);
	        }
	      } // increment active scroll locks
	
	
	      activeScrollLocks += 1;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var _this3 = this;
	
	      if (!canUseDOM) return;
	      var _this$props2 = this.props,
	          accountForScrollbars = _this$props2.accountForScrollbars,
	          touchScrollTarget = _this$props2.touchScrollTarget;
	      var target = document.body;
	      var targetStyle = target && target.style; // safely decrement active scroll locks
	
	      activeScrollLocks = Math.max(activeScrollLocks - 1, 0); // reapply original body styles, if any
	
	      if (accountForScrollbars && activeScrollLocks < 1) {
	        STYLE_KEYS.forEach(function (key) {
	          var val = _this3.originalStyles[key];
	
	          if (targetStyle) {
	            targetStyle[key] = val;
	          }
	        });
	      } // remove touch listeners
	
	
	      if (target && isTouchDevice()) {
	        target.removeEventListener('touchmove', preventTouchMove, this.listenerOptions);
	
	        if (touchScrollTarget) {
	          touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
	          touchScrollTarget.removeEventListener('touchmove', allowTouchMove, this.listenerOptions);
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return ScrollLock;
	}(React.Component);
	
	_defineProperty(ScrollLock, "defaultProps", {
	  accountForScrollbars: true
	});
	
	var _ref$1 =  true ? {
	  name: "1dsbpcp",
	  styles: "position:fixed;left:0;bottom:0;right:0;top:0;"
	} : {
	  name: "1dsbpcp",
	  styles: "position:fixed;left:0;bottom:0;right:0;top:0;",
	  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"
	}; // NOTE:
	// We shouldn't need this after updating to React v16.3.0, which introduces:
	// - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
	// - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref
	
	
	var ScrollBlock =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(ScrollBlock, _PureComponent);
	
	  function ScrollBlock() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, ScrollBlock);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollBlock)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
	      touchScrollTarget: null
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getScrollTarget", function (ref) {
	      if (ref === _this.state.touchScrollTarget) return;
	
	      _this.setState({
	        touchScrollTarget: ref
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "blurSelectInput", function () {
	      if (document.activeElement) {
	        document.activeElement.blur();
	      }
	    });
	
	    return _this;
	  }
	
	  _createClass(ScrollBlock, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          isEnabled = _this$props.isEnabled;
	      var touchScrollTarget = this.state.touchScrollTarget; // bail early if not enabled
	
	      if (!isEnabled) return children;
	      /*
	       * Div
	       * ------------------------------
	       * blocks scrolling on non-body elements behind the menu
	        * NodeResolver
	       * ------------------------------
	       * we need a reference to the scrollable element to "unlock" scroll on
	       * mobile devices
	        * ScrollLock
	       * ------------------------------
	       * actually does the scroll locking
	       */
	
	      return core.jsx("div", null, core.jsx("div", {
	        onClick: this.blurSelectInput,
	        css: _ref$1
	      }), core.jsx(NodeResolver, {
	        innerRef: this.getScrollTarget
	      }, children), touchScrollTarget ? core.jsx(ScrollLock, {
	        touchScrollTarget: touchScrollTarget
	      }) : null);
	    }
	  }]);
	
	  return ScrollBlock;
	}(React.PureComponent);
	
	var ScrollCaptor =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ScrollCaptor, _Component);
	
	  function ScrollCaptor() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, ScrollCaptor);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollCaptor)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isBottom", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isTop", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scrollTarget", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "touchStart", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cancelScroll", function (event) {
	      event.preventDefault();
	      event.stopPropagation();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleEventDelta", function (event, delta) {
	      var _this$props = _this.props,
	          onBottomArrive = _this$props.onBottomArrive,
	          onBottomLeave = _this$props.onBottomLeave,
	          onTopArrive = _this$props.onTopArrive,
	          onTopLeave = _this$props.onTopLeave;
	      var _this$scrollTarget = _this.scrollTarget,
	          scrollTop = _this$scrollTarget.scrollTop,
	          scrollHeight = _this$scrollTarget.scrollHeight,
	          clientHeight = _this$scrollTarget.clientHeight;
	      var target = _this.scrollTarget;
	      var isDeltaPositive = delta > 0;
	      var availableScroll = scrollHeight - clientHeight - scrollTop;
	      var shouldCancelScroll = false; // reset bottom/top flags
	
	      if (availableScroll > delta && _this.isBottom) {
	        if (onBottomLeave) onBottomLeave(event);
	        _this.isBottom = false;
	      }
	
	      if (isDeltaPositive && _this.isTop) {
	        if (onTopLeave) onTopLeave(event);
	        _this.isTop = false;
	      } // bottom limit
	
	
	      if (isDeltaPositive && delta > availableScroll) {
	        if (onBottomArrive && !_this.isBottom) {
	          onBottomArrive(event);
	        }
	
	        target.scrollTop = scrollHeight;
	        shouldCancelScroll = true;
	        _this.isBottom = true; // top limit
	      } else if (!isDeltaPositive && -delta > scrollTop) {
	        if (onTopArrive && !_this.isTop) {
	          onTopArrive(event);
	        }
	
	        target.scrollTop = 0;
	        shouldCancelScroll = true;
	        _this.isTop = true;
	      } // cancel scroll
	
	
	      if (shouldCancelScroll) {
	        _this.cancelScroll(event);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onWheel", function (event) {
	      _this.handleEventDelta(event, event.deltaY);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchStart", function (event) {
	      // set touch start so we can calculate touchmove delta
	      _this.touchStart = event.changedTouches[0].clientY;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchMove", function (event) {
	      var deltaY = _this.touchStart - event.changedTouches[0].clientY;
	
	      _this.handleEventDelta(event, deltaY);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getScrollTarget", function (ref) {
	      _this.scrollTarget = ref;
	    });
	
	    return _this;
	  }
	
	  _createClass(ScrollCaptor, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.startListening(this.scrollTarget);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.stopListening(this.scrollTarget);
	    }
	  }, {
	    key: "startListening",
	    value: function startListening(el) {
	      // bail early if no element is available to attach to
	      if (!el) return; // all the if statements are to appease Flow 😢
	
	      if (typeof el.addEventListener === 'function') {
	        el.addEventListener('wheel', this.onWheel, false);
	      }
	
	      if (typeof el.addEventListener === 'function') {
	        el.addEventListener('touchstart', this.onTouchStart, false);
	      }
	
	      if (typeof el.addEventListener === 'function') {
	        el.addEventListener('touchmove', this.onTouchMove, false);
	      }
	    }
	  }, {
	    key: "stopListening",
	    value: function stopListening(el) {
	      // all the if statements are to appease Flow 😢
	      if (typeof el.removeEventListener === 'function') {
	        el.removeEventListener('wheel', this.onWheel, false);
	      }
	
	      if (typeof el.removeEventListener === 'function') {
	        el.removeEventListener('touchstart', this.onTouchStart, false);
	      }
	
	      if (typeof el.removeEventListener === 'function') {
	        el.removeEventListener('touchmove', this.onTouchMove, false);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return React__default.createElement(NodeResolver, {
	        innerRef: this.getScrollTarget
	      }, this.props.children);
	    }
	  }]);
	
	  return ScrollCaptor;
	}(React.Component);
	
	var ScrollCaptorSwitch =
	/*#__PURE__*/
	function (_Component2) {
	  _inherits(ScrollCaptorSwitch, _Component2);
	
	  function ScrollCaptorSwitch() {
	    _classCallCheck(this, ScrollCaptorSwitch);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ScrollCaptorSwitch).apply(this, arguments));
	  }
	
	  _createClass(ScrollCaptorSwitch, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          isEnabled = _this$props2.isEnabled,
	          props = _objectWithoutProperties(_this$props2, ["isEnabled"]);
	
	      return isEnabled ? React__default.createElement(ScrollCaptor, props) : this.props.children;
	    }
	  }]);
	
	  return ScrollCaptorSwitch;
	}(React.Component);
	
	_defineProperty(ScrollCaptorSwitch, "defaultProps", {
	  isEnabled: true
	});
	
	var instructionsAriaMessage = function instructionsAriaMessage(event) {
	  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var isSearchable = context.isSearchable,
	      isMulti = context.isMulti,
	      label = context.label,
	      isDisabled = context.isDisabled;
	
	  switch (event) {
	    case 'menu':
	      return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu, press Tab to select the option and exit the menu.");
	
	    case 'input':
	      return "".concat(label ? label : 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
	
	    case 'value':
	      return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
	  }
	};
	
	var valueEventAriaMessage = function valueEventAriaMessage(event, context) {
	  var value = context.value,
	      isDisabled = context.isDisabled;
	  if (!value) return;
	
	  switch (event) {
	    case 'deselect-option':
	    case 'pop-value':
	    case 'remove-value':
	      return "option ".concat(value, ", deselected.");
	
	    case 'select-option':
	      return isDisabled ? "option ".concat(value, " is disabled. Select another option.") : "option ".concat(value, ", selected.");
	  }
	};
	
	var valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
	  var focusedValue = _ref.focusedValue,
	      getOptionLabel = _ref.getOptionLabel,
	      selectValue = _ref.selectValue;
	  return "value ".concat(getOptionLabel(focusedValue), " focused, ").concat(selectValue.indexOf(focusedValue) + 1, " of ").concat(selectValue.length, ".");
	};
	
	var optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
	  var focusedOption = _ref2.focusedOption,
	      getOptionLabel = _ref2.getOptionLabel,
	      options = _ref2.options;
	  return "option ".concat(getOptionLabel(focusedOption), " focused").concat(focusedOption.isDisabled ? ' disabled' : '', ", ").concat(options.indexOf(focusedOption) + 1, " of ").concat(options.length, ".");
	};
	
	var resultsAriaMessage = function resultsAriaMessage(_ref3) {
	  var inputValue = _ref3.inputValue,
	      screenReaderMessage = _ref3.screenReaderMessage;
	  return "".concat(screenReaderMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
	};
	
	var formatGroupLabel = function formatGroupLabel(group) {
	  return group.label;
	};
	
	var getOptionLabel = function getOptionLabel(option) {
	  return option.label;
	};
	
	var getOptionValue = function getOptionValue(option) {
	  return option.value;
	};
	
	var isOptionDisabled = function isOptionDisabled(option) {
	  return !!option.isDisabled;
	};
	
	var defaultStyles = {
	  clearIndicator: __chunk_2.clearIndicatorCSS,
	  container: __chunk_2.containerCSS,
	  control: __chunk_2.css,
	  dropdownIndicator: __chunk_2.dropdownIndicatorCSS,
	  group: __chunk_2.groupCSS,
	  groupHeading: __chunk_2.groupHeadingCSS,
	  indicatorsContainer: __chunk_2.indicatorsContainerCSS,
	  indicatorSeparator: __chunk_2.indicatorSeparatorCSS,
	  input: __chunk_2.inputCSS,
	  loadingIndicator: __chunk_2.loadingIndicatorCSS,
	  loadingMessage: __chunk_2.loadingMessageCSS,
	  menu: __chunk_2.menuCSS,
	  menuList: __chunk_2.menuListCSS,
	  menuPortal: __chunk_2.menuPortalCSS,
	  multiValue: __chunk_2.multiValueCSS,
	  multiValueLabel: __chunk_2.multiValueLabelCSS,
	  multiValueRemove: __chunk_2.multiValueRemoveCSS,
	  noOptionsMessage: __chunk_2.noOptionsMessageCSS,
	  option: __chunk_2.optionCSS,
	  placeholder: __chunk_2.placeholderCSS,
	  singleValue: __chunk_2.css$1,
	  valueContainer: __chunk_2.valueContainerCSS
	}; // Merge Utility
	// Allows consumers to extend a base Select with additional styles
	
	function mergeStyles(source) {
	  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}; // initialize with source styles
	
	  var styles = _objectSpread({}, source); // massage in target styles
	
	
	  Object.keys(target).forEach(function (key) {
	    if (source[key]) {
	      styles[key] = function (rsCss, props) {
	        return target[key](source[key](rsCss, props), props);
	      };
	    } else {
	      styles[key] = target[key];
	    }
	  });
	  return styles;
	}
	
	var colors = {
	  primary: '#2684FF',
	  primary75: '#4C9AFF',
	  primary50: '#B2D4FF',
	  primary25: '#DEEBFF',
	  danger: '#DE350B',
	  dangerLight: '#FFBDAD',
	  neutral0: 'hsl(0, 0%, 100%)',
	  neutral5: 'hsl(0, 0%, 95%)',
	  neutral10: 'hsl(0, 0%, 90%)',
	  neutral20: 'hsl(0, 0%, 80%)',
	  neutral30: 'hsl(0, 0%, 70%)',
	  neutral40: 'hsl(0, 0%, 60%)',
	  neutral50: 'hsl(0, 0%, 50%)',
	  neutral60: 'hsl(0, 0%, 40%)',
	  neutral70: 'hsl(0, 0%, 30%)',
	  neutral80: 'hsl(0, 0%, 20%)',
	  neutral90: 'hsl(0, 0%, 10%)'
	};
	var borderRadius = 4; // Used to calculate consistent margin/padding on elements
	
	var baseUnit = 4; // The minimum height of the control
	
	var controlHeight = 38; // The amount of space between the control and menu */
	
	var menuGutter = baseUnit * 2;
	var spacing = {
	  baseUnit: baseUnit,
	  controlHeight: controlHeight,
	  menuGutter: menuGutter
	};
	var defaultTheme = {
	  borderRadius: borderRadius,
	  colors: colors,
	  spacing: spacing
	};
	var defaultProps = {
	  backspaceRemovesValue: true,
	  blurInputOnSelect: __chunk_1.isTouchCapable(),
	  captureMenuScroll: !__chunk_1.isTouchCapable(),
	  closeMenuOnSelect: true,
	  closeMenuOnScroll: false,
	  components: {},
	  controlShouldRenderValue: true,
	  escapeClearsValue: false,
	  filterOption: createFilter(),
	  formatGroupLabel: formatGroupLabel,
	  getOptionLabel: getOptionLabel,
	  getOptionValue: getOptionValue,
	  isDisabled: false,
	  isLoading: false,
	  isMulti: false,
	  isRtl: false,
	  isSearchable: true,
	  isOptionDisabled: isOptionDisabled,
	  loadingMessage: function loadingMessage() {
	    return 'Loading...';
	  },
	  maxMenuHeight: 300,
	  minMenuHeight: 140,
	  menuIsOpen: false,
	  menuPlacement: 'bottom',
	  menuPosition: 'absolute',
	  menuShouldBlockScroll: false,
	  menuShouldScrollIntoView: !__chunk_1.isMobileDevice(),
	  noOptionsMessage: function noOptionsMessage() {
	    return 'No options';
	  },
	  openMenuOnFocus: false,
	  openMenuOnClick: true,
	  options: [],
	  pageSize: 5,
	  placeholder: 'Select...',
	  screenReaderStatus: function screenReaderStatus(_ref) {
	    var count = _ref.count;
	    return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
	  },
	  styles: {},
	  tabIndex: '0',
	  tabSelectsValue: true
	};
	var instanceId = 1;
	
	var Select =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Select, _Component); // Misc. Instance Properties
	  // ------------------------------
	  // TODO
	  // Refs
	  // ------------------------------
	  // Lifecycle
	  // ------------------------------
	
	
	  function Select(_props) {
	    var _this;
	
	    _classCallCheck(this, Select);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, _props));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
	      ariaLiveSelection: '',
	      ariaLiveContext: '',
	      focusedOption: null,
	      focusedValue: null,
	      inputIsHidden: false,
	      isFocused: false,
	      menuOptions: {
	        render: [],
	        focusable: []
	      },
	      selectValue: []
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "blockOptionHover", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isComposing", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clearFocusValueOnUpdate", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "commonProps", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "components", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "hasGroups", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "initialTouchX", 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "initialTouchY", 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputIsHiddenAfterUpdate", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "instancePrefix", '');
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "openAfterFocus", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scrollToFocusedOptionOnUpdate", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "userIsDragging", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "controlRef", null);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getControlRef", function (ref) {
	      _this.controlRef = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "focusedOptionRef", null);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getFocusedOptionRef", function (ref) {
	      _this.focusedOptionRef = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "menuListRef", null);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getMenuListRef", function (ref) {
	      _this.menuListRef = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputRef", null);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getInputRef", function (ref) {
	      _this.inputRef = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cacheComponents", function (components) {
	      _this.components = __chunk_2.defaultComponents({
	        components: components
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "focus", _this.focusInput);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "blur", _this.blurInput);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (newValue, actionMeta) {
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          name = _this$props.name;
	      onChange(newValue, _objectSpread({}, actionMeta, {
	        name: name
	      }));
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setValue", function (newValue) {
	      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set-value';
	      var option = arguments.length > 2 ? arguments[2] : undefined;
	      var _this$props2 = _this.props,
	          closeMenuOnSelect = _this$props2.closeMenuOnSelect,
	          isMulti = _this$props2.isMulti;
	
	      _this.onInputChange('', {
	        action: 'set-value'
	      });
	
	      if (closeMenuOnSelect) {
	        _this.inputIsHiddenAfterUpdate = !isMulti;
	
	        _this.onMenuClose();
	      } // when the select value should change, we should reset focusedValue
	
	
	      _this.clearFocusValueOnUpdate = true;
	
	      _this.onChange(newValue, {
	        action: action,
	        option: option
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectOption", function (newValue) {
	      var _this$props3 = _this.props,
	          blurInputOnSelect = _this$props3.blurInputOnSelect,
	          isMulti = _this$props3.isMulti;
	      var selectValue = _this.state.selectValue;
	
	      if (isMulti) {
	        if (_this.isOptionSelected(newValue, selectValue)) {
	          var candidate = _this.getOptionValue(newValue);
	
	          _this.setValue(selectValue.filter(function (i) {
	            return _this.getOptionValue(i) !== candidate;
	          }), 'deselect-option', newValue);
	
	          _this.announceAriaLiveSelection({
	            event: 'deselect-option',
	            context: {
	              value: _this.getOptionLabel(newValue)
	            }
	          });
	        } else {
	          if (!_this.isOptionDisabled(newValue, selectValue)) {
	            _this.setValue([].concat(_toConsumableArray(selectValue), [newValue]), 'select-option', newValue);
	
	            _this.announceAriaLiveSelection({
	              event: 'select-option',
	              context: {
	                value: _this.getOptionLabel(newValue)
	              }
	            });
	          } else {
	            // announce that option is disabled
	            _this.announceAriaLiveSelection({
	              event: 'select-option',
	              context: {
	                value: _this.getOptionLabel(newValue),
	                isDisabled: true
	              }
	            });
	          }
	        }
	      } else {
	        if (!_this.isOptionDisabled(newValue, selectValue)) {
	          _this.setValue(newValue, 'select-option');
	
	          _this.announceAriaLiveSelection({
	            event: 'select-option',
	            context: {
	              value: _this.getOptionLabel(newValue)
	            }
	          });
	        } else {
	          // announce that option is disabled
	          _this.announceAriaLiveSelection({
	            event: 'select-option',
	            context: {
	              value: _this.getOptionLabel(newValue),
	              isDisabled: true
	            }
	          });
	        }
	      }
	
	      if (blurInputOnSelect) {
	        _this.blurInput();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "removeValue", function (removedValue) {
	      var selectValue = _this.state.selectValue;
	
	      var candidate = _this.getOptionValue(removedValue);
	
	      var newValue = selectValue.filter(function (i) {
	        return _this.getOptionValue(i) !== candidate;
	      });
	
	      _this.onChange(newValue.length ? newValue : null, {
	        action: 'remove-value',
	        removedValue: removedValue
	      });
	
	      _this.announceAriaLiveSelection({
	        event: 'remove-value',
	        context: {
	          value: removedValue ? _this.getOptionLabel(removedValue) : ''
	        }
	      });
	
	      _this.focusInput();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clearValue", function () {
	      var isMulti = _this.props.isMulti;
	
	      _this.onChange(isMulti ? [] : null, {
	        action: 'clear'
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "popValue", function () {
	      var selectValue = _this.state.selectValue;
	      var lastSelectedValue = selectValue[selectValue.length - 1];
	      var newValue = selectValue.slice(0, selectValue.length - 1);
	
	      _this.announceAriaLiveSelection({
	        event: 'pop-value',
	        context: {
	          value: lastSelectedValue ? _this.getOptionLabel(lastSelectedValue) : ''
	        }
	      });
	
	      _this.onChange(newValue.length ? newValue : null, {
	        action: 'pop-value',
	        removedValue: lastSelectedValue
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getOptionLabel", function (data) {
	      return _this.props.getOptionLabel(data);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getOptionValue", function (data) {
	      return _this.props.getOptionValue(data);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getStyles", function (key, props) {
	      var base = defaultStyles[key](props);
	      base.boxSizing = 'border-box';
	      var custom = _this.props.styles[key];
	      return custom ? custom(base, props) : base;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getElementId", function (element) {
	      return "".concat(_this.instancePrefix, "-").concat(element);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getActiveDescendentId", function () {
	      var menuIsOpen = _this.props.menuIsOpen;
	      var _this$state = _this.state,
	          menuOptions = _this$state.menuOptions,
	          focusedOption = _this$state.focusedOption;
	      if (!focusedOption || !menuIsOpen) return undefined;
	      var index = menuOptions.focusable.indexOf(focusedOption);
	      var option = menuOptions.render[index];
	      return option && option.key;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "announceAriaLiveSelection", function (_ref2) {
	      var event = _ref2.event,
	          context = _ref2.context;
	
	      _this.setState({
	        ariaLiveSelection: valueEventAriaMessage(event, context)
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "announceAriaLiveContext", function (_ref3) {
	      var event = _ref3.event,
	          context = _ref3.context;
	
	      _this.setState({
	        ariaLiveContext: instructionsAriaMessage(event, _objectSpread({}, context, {
	          label: _this.props['aria-label']
	        }))
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuMouseDown", function (event) {
	      if (event.button !== 0) {
	        return;
	      }
	
	      event.stopPropagation();
	      event.preventDefault();
	
	      _this.focusInput();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuMouseMove", function (event) {
	      _this.blockOptionHover = false;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onControlMouseDown", function (event) {
	      var openMenuOnClick = _this.props.openMenuOnClick;
	
	      if (!_this.state.isFocused) {
	        if (openMenuOnClick) {
	          _this.openAfterFocus = true;
	        }
	
	        _this.focusInput();
	      } else if (!_this.props.menuIsOpen) {
	        if (openMenuOnClick) {
	          _this.openMenu('first');
	        }
	      } else {
	        //$FlowFixMe
	        if (event.target.tagName !== 'INPUT') {
	          _this.onMenuClose();
	        }
	      } //$FlowFixMe
	
	
	      if (event.target.tagName !== 'INPUT') {
	        event.preventDefault();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDropdownIndicatorMouseDown", function (event) {
	      // ignore mouse events that weren't triggered by the primary button
	      if (event && event.type === 'mousedown' && event.button !== 0) {
	        return;
	      }
	
	      if (_this.props.isDisabled) return;
	      var _this$props4 = _this.props,
	          isMulti = _this$props4.isMulti,
	          menuIsOpen = _this$props4.menuIsOpen;
	
	      _this.focusInput();
	
	      if (menuIsOpen) {
	        _this.inputIsHiddenAfterUpdate = !isMulti;
	
	        _this.onMenuClose();
	      } else {
	        _this.openMenu('first');
	      }
	
	      event.preventDefault();
	      event.stopPropagation();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClearIndicatorMouseDown", function (event) {
	      // ignore mouse events that weren't triggered by the primary button
	      if (event && event.type === 'mousedown' && event.button !== 0) {
	        return;
	      }
	
	      _this.clearValue();
	
	      event.stopPropagation();
	      _this.openAfterFocus = false;
	
	      if (event.type === 'touchend') {
	        _this.focusInput();
	      } else {
	        setTimeout(function () {
	          return _this.focusInput();
	        });
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onScroll", function (event) {
	      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
	        if (event.target instanceof HTMLElement && __chunk_1.isDocumentElement(event.target)) {
	          _this.props.onMenuClose();
	        }
	      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
	        if (_this.props.closeMenuOnScroll(event)) {
	          _this.props.onMenuClose();
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onCompositionStart", function () {
	      _this.isComposing = true;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onCompositionEnd", function () {
	      _this.isComposing = false;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchStart", function (_ref4) {
	      var touches = _ref4.touches;
	      var touch = touches.item(0);
	
	      if (!touch) {
	        return;
	      }
	
	      _this.initialTouchX = touch.clientX;
	      _this.initialTouchY = touch.clientY;
	      _this.userIsDragging = false;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchMove", function (_ref5) {
	      var touches = _ref5.touches;
	      var touch = touches.item(0);
	
	      if (!touch) {
	        return;
	      }
	
	      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
	      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
	      var moveThreshold = 5;
	      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchEnd", function (event) {
	      if (_this.userIsDragging) return; // close the menu if the user taps outside
	      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
	      // on events on child elements, not the document (which we've attached this handler to).
	
	      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
	        _this.blurInput();
	      } // reset move vars
	
	
	      _this.initialTouchX = 0;
	      _this.initialTouchY = 0;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onControlTouchEnd", function (event) {
	      if (_this.userIsDragging) return;
	
	      _this.onControlMouseDown(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClearIndicatorTouchEnd", function (event) {
	      if (_this.userIsDragging) return;
	
	      _this.onClearIndicatorMouseDown(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDropdownIndicatorTouchEnd", function (event) {
	      if (_this.userIsDragging) return;
	
	      _this.onDropdownIndicatorMouseDown(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputChange", function (event) {
	      var inputValue = event.currentTarget.value;
	      _this.inputIsHiddenAfterUpdate = false;
	
	      _this.onInputChange(inputValue, {
	        action: 'input-change'
	      });
	
	      _this.onMenuOpen();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onInputFocus", function (event) {
	      var _this$props5 = _this.props,
	          isSearchable = _this$props5.isSearchable,
	          isMulti = _this$props5.isMulti;
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	
	      _this.inputIsHiddenAfterUpdate = false;
	
	      _this.announceAriaLiveContext({
	        event: 'input',
	        context: {
	          isSearchable: isSearchable,
	          isMulti: isMulti
	        }
	      });
	
	      _this.setState({
	        isFocused: true
	      });
	
	      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
	        _this.openMenu('first');
	      }
	
	      _this.openAfterFocus = false;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onInputBlur", function (event) {
	      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
	        _this.inputRef.focus();
	
	        return;
	      }
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	
	      _this.onInputChange('', {
	        action: 'input-blur'
	      });
	
	      _this.onMenuClose();
	
	      _this.setState({
	        focusedValue: null,
	        isFocused: false
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onOptionHover", function (focusedOption) {
	      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
	        return;
	      }
	
	      _this.setState({
	        focusedOption: focusedOption
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "shouldHideSelectedOptions", function () {
	      var _this$props6 = _this.props,
	          hideSelectedOptions = _this$props6.hideSelectedOptions,
	          isMulti = _this$props6.isMulti;
	      if (hideSelectedOptions === undefined) return isMulti;
	      return hideSelectedOptions;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onKeyDown", function (event) {
	      var _this$props7 = _this.props,
	          isMulti = _this$props7.isMulti,
	          backspaceRemovesValue = _this$props7.backspaceRemovesValue,
	          escapeClearsValue = _this$props7.escapeClearsValue,
	          inputValue = _this$props7.inputValue,
	          isClearable = _this$props7.isClearable,
	          isDisabled = _this$props7.isDisabled,
	          menuIsOpen = _this$props7.menuIsOpen,
	          onKeyDown = _this$props7.onKeyDown,
	          tabSelectsValue = _this$props7.tabSelectsValue,
	          openMenuOnFocus = _this$props7.openMenuOnFocus;
	      var _this$state2 = _this.state,
	          focusedOption = _this$state2.focusedOption,
	          focusedValue = _this$state2.focusedValue,
	          selectValue = _this$state2.selectValue;
	      if (isDisabled) return;
	
	      if (typeof onKeyDown === 'function') {
	        onKeyDown(event);
	
	        if (event.defaultPrevented) {
	          return;
	        }
	      } // Block option hover events when the user has just pressed a key
	
	
	      _this.blockOptionHover = true;
	
	      switch (event.key) {
	        case 'ArrowLeft':
	          if (!isMulti || inputValue) return;
	
	          _this.focusValue('previous');
	
	          break;
	
	        case 'ArrowRight':
	          if (!isMulti || inputValue) return;
	
	          _this.focusValue('next');
	
	          break;
	
	        case 'Delete':
	        case 'Backspace':
	          if (inputValue) return;
	
	          if (focusedValue) {
	            _this.removeValue(focusedValue);
	          } else {
	            if (!backspaceRemovesValue) return;
	
	            if (isMulti) {
	              _this.popValue();
	            } else if (isClearable) {
	              _this.clearValue();
	            }
	          }
	
	          break;
	
	        case 'Tab':
	          if (_this.isComposing) return;
	
	          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
	          // option is already selected; it breaks the flow of navigation
	          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
	            return;
	          }
	
	          _this.selectOption(focusedOption);
	
	          break;
	
	        case 'Enter':
	          if (event.keyCode === 229) {
	            // ignore the keydown event from an Input Method Editor(IME)
	            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
	            break;
	          }
	
	          if (menuIsOpen) {
	            if (!focusedOption) return;
	            if (_this.isComposing) return;
	
	            _this.selectOption(focusedOption);
	
	            break;
	          }
	
	          return;
	
	        case 'Escape':
	          if (menuIsOpen) {
	            _this.inputIsHiddenAfterUpdate = false;
	
	            _this.onInputChange('', {
	              action: 'menu-close'
	            });
	
	            _this.onMenuClose();
	          } else if (isClearable && escapeClearsValue) {
	            _this.clearValue();
	          }
	
	          break;
	
	        case ' ':
	          // space
	          if (inputValue) {
	            return;
	          }
	
	          if (!menuIsOpen) {
	            _this.openMenu('first');
	
	            break;
	          }
	
	          if (!focusedOption) return;
	
	          _this.selectOption(focusedOption);
	
	          break;
	
	        case 'ArrowUp':
	          if (menuIsOpen) {
	            _this.focusOption('up');
	          } else {
	            _this.openMenu('last');
	          }
	
	          break;
	
	        case 'ArrowDown':
	          if (menuIsOpen) {
	            _this.focusOption('down');
	          } else {
	            _this.openMenu('first');
	          }
	
	          break;
	
	        case 'PageUp':
	          if (!menuIsOpen) return;
	
	          _this.focusOption('pageup');
	
	          break;
	
	        case 'PageDown':
	          if (!menuIsOpen) return;
	
	          _this.focusOption('pagedown');
	
	          break;
	
	        case 'Home':
	          if (!menuIsOpen) return;
	
	          _this.focusOption('first');
	
	          break;
	
	        case 'End':
	          if (!menuIsOpen) return;
	
	          _this.focusOption('last');
	
	          break;
	
	        default:
	          return;
	      }
	
	      event.preventDefault();
	    });
	
	    var value = _props.value;
	    _this.cacheComponents = memoizeOne(_this.cacheComponents, __chunk_2.exportedEqual).bind(_assertThisInitialized(_assertThisInitialized(_this)));
	
	    _this.cacheComponents(_props.components);
	
	    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);
	
	    var _selectValue = __chunk_1.cleanValue(value);
	
	    var _menuOptions = _props.menuIsOpen ? _this.buildMenuOptions(_props, _selectValue) : {
	      render: [],
	      focusable: []
	    };
	
	    _this.state.menuOptions = _menuOptions;
	    _this.state.selectValue = _selectValue;
	    return _this;
	  }
	
	  _createClass(Select, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.startListeningComposition();
	      this.startListeningToTouch();
	
	      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
	        // Listen to all scroll events, and filter them out inside of 'onScroll'
	        document.addEventListener('scroll', this.onScroll, true);
	      }
	
	      if (this.props.autoFocus) {
	        this.focusInput();
	      }
	    }
	  }, {
	    key: "UNSAFE_componentWillReceiveProps",
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      var _this$props8 = this.props,
	          options = _this$props8.options,
	          value = _this$props8.value,
	          menuIsOpen = _this$props8.menuIsOpen,
	          inputValue = _this$props8.inputValue; // re-cache custom components
	
	      this.cacheComponents(nextProps.components); // rebuild the menu options
	
	      if (nextProps.value !== value || nextProps.options !== options || nextProps.menuIsOpen !== menuIsOpen || nextProps.inputValue !== inputValue) {
	        var selectValue = __chunk_1.cleanValue(nextProps.value);
	
	        var menuOptions = nextProps.menuIsOpen ? this.buildMenuOptions(nextProps, selectValue) : {
	          render: [],
	          focusable: []
	        };
	        var focusedValue = this.getNextFocusedValue(selectValue);
	        var focusedOption = this.getNextFocusedOption(menuOptions.focusable);
	        this.setState({
	          menuOptions: menuOptions,
	          selectValue: selectValue,
	          focusedOption: focusedOption,
	          focusedValue: focusedValue
	        });
	      } // some updates should toggle the state of the input visibility
	
	
	      if (this.inputIsHiddenAfterUpdate != null) {
	        this.setState({
	          inputIsHidden: this.inputIsHiddenAfterUpdate
	        });
	        delete this.inputIsHiddenAfterUpdate;
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this$props9 = this.props,
	          isDisabled = _this$props9.isDisabled,
	          menuIsOpen = _this$props9.menuIsOpen;
	      var isFocused = this.state.isFocused;
	
	      if ( // ensure focus is restored correctly when the control becomes enabled
	      isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
	      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
	        this.focusInput();
	      } // scroll the focused option into view if necessary
	
	
	      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
	        __chunk_1.scrollIntoView(this.menuListRef, this.focusedOptionRef);
	      }
	
	      this.scrollToFocusedOptionOnUpdate = false;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.stopListeningComposition();
	      this.stopListeningToTouch();
	      document.removeEventListener('scroll', this.onScroll, true);
	    }
	  }, {
	    key: "onMenuOpen",
	    // ==============================
	    // Consumer Handlers
	    // ==============================
	    value: function onMenuOpen() {
	      this.props.onMenuOpen();
	    }
	  }, {
	    key: "onMenuClose",
	    value: function onMenuClose() {
	      var _this$props10 = this.props,
	          isSearchable = _this$props10.isSearchable,
	          isMulti = _this$props10.isMulti;
	      this.announceAriaLiveContext({
	        event: 'input',
	        context: {
	          isSearchable: isSearchable,
	          isMulti: isMulti
	        }
	      });
	      this.onInputChange('', {
	        action: 'menu-close'
	      });
	      this.props.onMenuClose();
	    }
	  }, {
	    key: "onInputChange",
	    value: function onInputChange(newValue, actionMeta) {
	      this.props.onInputChange(newValue, actionMeta);
	    } // ==============================
	    // Methods
	    // ==============================
	
	  }, {
	    key: "focusInput",
	    value: function focusInput() {
	      if (!this.inputRef) return;
	      this.inputRef.focus();
	    }
	  }, {
	    key: "blurInput",
	    value: function blurInput() {
	      if (!this.inputRef) return;
	      this.inputRef.blur();
	    } // aliased for consumers
	
	  }, {
	    key: "openMenu",
	    value: function openMenu(focusOption) {
	      var _this$state3 = this.state,
	          menuOptions = _this$state3.menuOptions,
	          selectValue = _this$state3.selectValue,
	          isFocused = _this$state3.isFocused;
	      var isMulti = this.props.isMulti;
	      var openAtIndex = focusOption === 'first' ? 0 : menuOptions.focusable.length - 1;
	
	      if (!isMulti) {
	        var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);
	
	        if (selectedIndex > -1) {
	          openAtIndex = selectedIndex;
	        }
	      } // only scroll if the menu isn't already open
	
	
	      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
	      this.inputIsHiddenAfterUpdate = false;
	      this.onMenuOpen();
	      this.setState({
	        focusedValue: null,
	        focusedOption: menuOptions.focusable[openAtIndex]
	      });
	      this.announceAriaLiveContext({
	        event: 'menu'
	      });
	    }
	  }, {
	    key: "focusValue",
	    value: function focusValue(direction) {
	      var _this$props11 = this.props,
	          isMulti = _this$props11.isMulti,
	          isSearchable = _this$props11.isSearchable;
	      var _this$state4 = this.state,
	          selectValue = _this$state4.selectValue,
	          focusedValue = _this$state4.focusedValue; // Only multiselects support value focusing
	
	      if (!isMulti) return;
	      this.setState({
	        focusedOption: null
	      });
	      var focusedIndex = selectValue.indexOf(focusedValue);
	
	      if (!focusedValue) {
	        focusedIndex = -1;
	        this.announceAriaLiveContext({
	          event: 'value'
	        });
	      }
	
	      var lastIndex = selectValue.length - 1;
	      var nextFocus = -1;
	      if (!selectValue.length) return;
	
	      switch (direction) {
	        case 'previous':
	          if (focusedIndex === 0) {
	            // don't cycle from the start to the end
	            nextFocus = 0;
	          } else if (focusedIndex === -1) {
	            // if nothing is focused, focus the last value first
	            nextFocus = lastIndex;
	          } else {
	            nextFocus = focusedIndex - 1;
	          }
	
	          break;
	
	        case 'next':
	          if (focusedIndex > -1 && focusedIndex < lastIndex) {
	            nextFocus = focusedIndex + 1;
	          }
	
	          break;
	      }
	
	      if (nextFocus === -1) {
	        this.announceAriaLiveContext({
	          event: 'input',
	          context: {
	            isSearchable: isSearchable,
	            isMulti: isMulti
	          }
	        });
	      }
	
	      this.setState({
	        inputIsHidden: nextFocus !== -1,
	        focusedValue: selectValue[nextFocus]
	      });
	    }
	  }, {
	    key: "focusOption",
	    value: function focusOption() {
	      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
	      var pageSize = this.props.pageSize;
	      var _this$state5 = this.state,
	          focusedOption = _this$state5.focusedOption,
	          menuOptions = _this$state5.menuOptions;
	      var options = menuOptions.focusable;
	      if (!options.length) return;
	      var nextFocus = 0; // handles 'first'
	
	      var focusedIndex = options.indexOf(focusedOption);
	
	      if (!focusedOption) {
	        focusedIndex = -1;
	        this.announceAriaLiveContext({
	          event: 'menu'
	        });
	      }
	
	      if (direction === 'up') {
	        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
	      } else if (direction === 'down') {
	        nextFocus = (focusedIndex + 1) % options.length;
	      } else if (direction === 'pageup') {
	        nextFocus = focusedIndex - pageSize;
	        if (nextFocus < 0) nextFocus = 0;
	      } else if (direction === 'pagedown') {
	        nextFocus = focusedIndex + pageSize;
	        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
	      } else if (direction === 'last') {
	        nextFocus = options.length - 1;
	      }
	
	      this.scrollToFocusedOptionOnUpdate = true;
	      this.setState({
	        focusedOption: options[nextFocus],
	        focusedValue: null
	      });
	      this.announceAriaLiveContext({
	        event: 'menu',
	        context: {
	          isDisabled: isOptionDisabled(options[nextFocus])
	        }
	      });
	    }
	  }, {
	    key: "getTheme",
	    // ==============================
	    // Getters
	    // ==============================
	    value: function getTheme() {
	      // Use the default theme if there are no customizations.
	      if (!this.props.theme) {
	        return defaultTheme;
	      } // If the theme prop is a function, assume the function
	      // knows how to merge the passed-in default theme with
	      // its own modifications.
	
	
	      if (typeof this.props.theme === 'function') {
	        return this.props.theme(defaultTheme);
	      } // Otherwise, if a plain theme object was passed in,
	      // overlay it with the default theme.
	
	
	      return _objectSpread({}, defaultTheme, this.props.theme);
	    }
	  }, {
	    key: "getCommonProps",
	    value: function getCommonProps() {
	      var clearValue = this.clearValue,
	          getStyles = this.getStyles,
	          setValue = this.setValue,
	          selectOption = this.selectOption,
	          props = this.props;
	      var classNamePrefix = props.classNamePrefix,
	          isMulti = props.isMulti,
	          isRtl = props.isRtl,
	          options = props.options;
	      var selectValue = this.state.selectValue;
	      var hasValue = this.hasValue();
	
	      var getValue = function getValue() {
	        return selectValue;
	      };
	
	      var cx = __chunk_1.classNames.bind(null, classNamePrefix);
	
	      return {
	        cx: cx,
	        clearValue: clearValue,
	        getStyles: getStyles,
	        getValue: getValue,
	        hasValue: hasValue,
	        isMulti: isMulti,
	        isRtl: isRtl,
	        options: options,
	        selectOption: selectOption,
	        setValue: setValue,
	        selectProps: props,
	        theme: this.getTheme()
	      };
	    }
	  }, {
	    key: "getNextFocusedValue",
	    value: function getNextFocusedValue(nextSelectValue) {
	      if (this.clearFocusValueOnUpdate) {
	        this.clearFocusValueOnUpdate = false;
	        return null;
	      }
	
	      var _this$state6 = this.state,
	          focusedValue = _this$state6.focusedValue,
	          lastSelectValue = _this$state6.selectValue;
	      var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
	
	      if (lastFocusedIndex > -1) {
	        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
	
	        if (nextFocusedIndex > -1) {
	          // the focused value is still in the selectValue, return it
	          return focusedValue;
	        } else if (lastFocusedIndex < nextSelectValue.length) {
	          // the focusedValue is not present in the next selectValue array by
	          // reference, so return the new value at the same index
	          return nextSelectValue[lastFocusedIndex];
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: "getNextFocusedOption",
	    value: function getNextFocusedOption(options) {
	      var lastFocusedOption = this.state.focusedOption;
	      return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
	    }
	  }, {
	    key: "hasValue",
	    value: function hasValue() {
	      var selectValue = this.state.selectValue;
	      return selectValue.length > 0;
	    }
	  }, {
	    key: "hasOptions",
	    value: function hasOptions() {
	      return !!this.state.menuOptions.render.length;
	    }
	  }, {
	    key: "countOptions",
	    value: function countOptions() {
	      return this.state.menuOptions.focusable.length;
	    }
	  }, {
	    key: "isClearable",
	    value: function isClearable() {
	      var _this$props12 = this.props,
	          isClearable = _this$props12.isClearable,
	          isMulti = _this$props12.isMulti; // single select, by default, IS NOT clearable
	      // multi select, by default, IS clearable
	
	      if (isClearable === undefined) return isMulti;
	      return isClearable;
	    }
	  }, {
	    key: "isOptionDisabled",
	    value: function isOptionDisabled(option, selectValue) {
	      return typeof this.props.isOptionDisabled === 'function' ? this.props.isOptionDisabled(option, selectValue) : false;
	    }
	  }, {
	    key: "isOptionSelected",
	    value: function isOptionSelected(option, selectValue) {
	      var _this2 = this;
	
	      if (selectValue.indexOf(option) > -1) return true;
	
	      if (typeof this.props.isOptionSelected === 'function') {
	        return this.props.isOptionSelected(option, selectValue);
	      }
	
	      var candidate = this.getOptionValue(option);
	      return selectValue.some(function (i) {
	        return _this2.getOptionValue(i) === candidate;
	      });
	    }
	  }, {
	    key: "filterOption",
	    value: function filterOption(option, inputValue) {
	      return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
	    }
	  }, {
	    key: "formatOptionLabel",
	    value: function formatOptionLabel(data, context) {
	      if (typeof this.props.formatOptionLabel === 'function') {
	        var inputValue = this.props.inputValue;
	        var selectValue = this.state.selectValue;
	        return this.props.formatOptionLabel(data, {
	          context: context,
	          inputValue: inputValue,
	          selectValue: selectValue
	        });
	      } else {
	        return this.getOptionLabel(data);
	      }
	    }
	  }, {
	    key: "formatGroupLabel",
	    value: function formatGroupLabel(data) {
	      return this.props.formatGroupLabel(data);
	    } // ==============================
	    // Mouse Handlers
	    // ==============================
	
	  }, {
	    key: "startListeningComposition",
	    // ==============================
	    // Composition Handlers
	    // ==============================
	    value: function startListeningComposition() {
	      if (document && document.addEventListener) {
	        document.addEventListener('compositionstart', this.onCompositionStart, false);
	        document.addEventListener('compositionend', this.onCompositionEnd, false);
	      }
	    }
	  }, {
	    key: "stopListeningComposition",
	    value: function stopListeningComposition() {
	      if (document && document.removeEventListener) {
	        document.removeEventListener('compositionstart', this.onCompositionStart);
	        document.removeEventListener('compositionend', this.onCompositionEnd);
	      }
	    }
	  }, {
	    key: "startListeningToTouch",
	    // ==============================
	    // Touch Handlers
	    // ==============================
	    value: function startListeningToTouch() {
	      if (document && document.addEventListener) {
	        document.addEventListener('touchstart', this.onTouchStart, false);
	        document.addEventListener('touchmove', this.onTouchMove, false);
	        document.addEventListener('touchend', this.onTouchEnd, false);
	      }
	    }
	  }, {
	    key: "stopListeningToTouch",
	    value: function stopListeningToTouch() {
	      if (document && document.removeEventListener) {
	        document.removeEventListener('touchstart', this.onTouchStart);
	        document.removeEventListener('touchmove', this.onTouchMove);
	        document.removeEventListener('touchend', this.onTouchEnd);
	      }
	    }
	  }, {
	    key: "buildMenuOptions",
	    // ==============================
	    // Menu Options
	    // ==============================
	    value: function buildMenuOptions(props, selectValue) {
	      var _this3 = this;
	
	      var _props$inputValue = props.inputValue,
	          inputValue = _props$inputValue === void 0 ? '' : _props$inputValue,
	          options = props.options;
	
	      var toOption = function toOption(option, id) {
	        var isDisabled = _this3.isOptionDisabled(option, selectValue);
	
	        var isSelected = _this3.isOptionSelected(option, selectValue);
	
	        var label = _this3.getOptionLabel(option);
	
	        var value = _this3.getOptionValue(option);
	
	        if (_this3.shouldHideSelectedOptions() && isSelected || !_this3.filterOption({
	          label: label,
	          value: value,
	          data: option
	        }, inputValue)) {
	          return;
	        }
	
	        var onHover = isDisabled ? undefined : function () {
	          return _this3.onOptionHover(option);
	        };
	        var onSelect = isDisabled ? undefined : function () {
	          return _this3.selectOption(option);
	        };
	        var optionId = "".concat(_this3.getElementId('option'), "-").concat(id);
	        return {
	          innerProps: {
	            id: optionId,
	            onClick: onSelect,
	            onMouseMove: onHover,
	            onMouseOver: onHover,
	            tabIndex: -1
	          },
	          data: option,
	          isDisabled: isDisabled,
	          isSelected: isSelected,
	          key: optionId,
	          label: label,
	          type: 'option',
	          value: value
	        };
	      };
	
	      return options.reduce(function (acc, item, itemIndex) {
	        if (item.options) {
	          // TODO needs a tidier implementation
	          if (!_this3.hasGroups) _this3.hasGroups = true;
	          var items = item.options;
	          var children = items.map(function (child, i) {
	            var option = toOption(child, "".concat(itemIndex, "-").concat(i));
	            if (option) acc.focusable.push(child);
	            return option;
	          }).filter(Boolean);
	
	          if (children.length) {
	            var groupId = "".concat(_this3.getElementId('group'), "-").concat(itemIndex);
	            acc.render.push({
	              type: 'group',
	              key: groupId,
	              data: item,
	              options: children
	            });
	          }
	        } else {
	          var option = toOption(item, "".concat(itemIndex));
	
	          if (option) {
	            acc.render.push(option);
	            acc.focusable.push(item);
	          }
	        }
	
	        return acc;
	      }, {
	        render: [],
	        focusable: []
	      });
	    } // ==============================
	    // Renderers
	    // ==============================
	
	  }, {
	    key: "constructAriaLiveMessage",
	    value: function constructAriaLiveMessage() {
	      var _this$state7 = this.state,
	          ariaLiveContext = _this$state7.ariaLiveContext,
	          selectValue = _this$state7.selectValue,
	          focusedValue = _this$state7.focusedValue,
	          focusedOption = _this$state7.focusedOption;
	      var _this$props13 = this.props,
	          options = _this$props13.options,
	          menuIsOpen = _this$props13.menuIsOpen,
	          inputValue = _this$props13.inputValue,
	          screenReaderStatus = _this$props13.screenReaderStatus; // An aria live message representing the currently focused value in the select.
	
	      var focusedValueMsg = focusedValue ? valueFocusAriaMessage({
	        focusedValue: focusedValue,
	        getOptionLabel: this.getOptionLabel,
	        selectValue: selectValue
	      }) : ''; // An aria live message representing the currently focused option in the select.
	
	      var focusedOptionMsg = focusedOption && menuIsOpen ? optionFocusAriaMessage({
	        focusedOption: focusedOption,
	        getOptionLabel: this.getOptionLabel,
	        options: options
	      }) : ''; // An aria live message representing the set of focusable results and current searchterm/inputvalue.
	
	      var resultsMsg = resultsAriaMessage({
	        inputValue: inputValue,
	        screenReaderMessage: screenReaderStatus({
	          count: this.countOptions()
	        })
	      });
	      return "".concat(focusedValueMsg, " ").concat(focusedOptionMsg, " ").concat(resultsMsg, " ").concat(ariaLiveContext);
	    }
	  }, {
	    key: "renderInput",
	    value: function renderInput() {
	      var _this$props14 = this.props,
	          isDisabled = _this$props14.isDisabled,
	          isSearchable = _this$props14.isSearchable,
	          inputId = _this$props14.inputId,
	          inputValue = _this$props14.inputValue,
	          tabIndex = _this$props14.tabIndex;
	      var Input = this.components.Input;
	      var inputIsHidden = this.state.inputIsHidden;
	      var id = inputId || this.getElementId('input');
	
	      if (!isSearchable) {
	        // use a dummy input to maintain focus/blur functionality
	        return React__default.createElement(DummyInput, {
	          id: id,
	          innerRef: this.getInputRef,
	          onBlur: this.onInputBlur,
	          onChange: __chunk_1.noop,
	          onFocus: this.onInputFocus,
	          readOnly: true,
	          disabled: isDisabled,
	          tabIndex: tabIndex,
	          value: ""
	        });
	      } // aria attributes makes the JSX "noisy", separated for clarity
	
	
	      var ariaAttributes = {
	        'aria-autocomplete': 'list',
	        'aria-label': this.props['aria-label'],
	        'aria-labelledby': this.props['aria-labelledby']
	      };
	      var _this$commonProps = this.commonProps,
	          cx = _this$commonProps.cx,
	          theme = _this$commonProps.theme,
	          selectProps = _this$commonProps.selectProps;
	      return React__default.createElement(Input, _extends({
	        autoCapitalize: "none",
	        autoComplete: "off",
	        autoCorrect: "off",
	        cx: cx,
	        getStyles: this.getStyles,
	        id: id,
	        innerRef: this.getInputRef,
	        isDisabled: isDisabled,
	        isHidden: inputIsHidden,
	        onBlur: this.onInputBlur,
	        onChange: this.handleInputChange,
	        onFocus: this.onInputFocus,
	        selectProps: selectProps,
	        spellCheck: "false",
	        tabIndex: tabIndex,
	        theme: theme,
	        type: "text",
	        value: inputValue
	      }, ariaAttributes));
	    }
	  }, {
	    key: "renderPlaceholderOrValue",
	    value: function renderPlaceholderOrValue() {
	      var _this4 = this;
	
	      var _this$components = this.components,
	          MultiValue = _this$components.MultiValue,
	          MultiValueContainer = _this$components.MultiValueContainer,
	          MultiValueLabel = _this$components.MultiValueLabel,
	          MultiValueRemove = _this$components.MultiValueRemove,
	          SingleValue = _this$components.SingleValue,
	          Placeholder = _this$components.Placeholder;
	      var commonProps = this.commonProps;
	      var _this$props15 = this.props,
	          controlShouldRenderValue = _this$props15.controlShouldRenderValue,
	          isDisabled = _this$props15.isDisabled,
	          isMulti = _this$props15.isMulti,
	          inputValue = _this$props15.inputValue,
	          placeholder = _this$props15.placeholder;
	      var _this$state8 = this.state,
	          selectValue = _this$state8.selectValue,
	          focusedValue = _this$state8.focusedValue,
	          isFocused = _this$state8.isFocused;
	
	      if (!this.hasValue() || !controlShouldRenderValue) {
	        return inputValue ? null : React__default.createElement(Placeholder, _extends({}, commonProps, {
	          key: "placeholder",
	          isDisabled: isDisabled,
	          isFocused: isFocused
	        }), placeholder);
	      }
	
	      if (isMulti) {
	        var selectValues = selectValue.map(function (opt, index) {
	          var isOptionFocused = opt === focusedValue;
	          return React__default.createElement(MultiValue, _extends({}, commonProps, {
	            components: {
	              Container: MultiValueContainer,
	              Label: MultiValueLabel,
	              Remove: MultiValueRemove
	            },
	            isFocused: isOptionFocused,
	            isDisabled: isDisabled,
	            key: _this4.getOptionValue(opt),
	            index: index,
	            removeProps: {
	              onClick: function onClick() {
	                return _this4.removeValue(opt);
	              },
	              onTouchEnd: function onTouchEnd() {
	                return _this4.removeValue(opt);
	              },
	              onMouseDown: function onMouseDown(e) {
	                e.preventDefault();
	                e.stopPropagation();
	              }
	            },
	            data: opt
	          }), _this4.formatOptionLabel(opt, 'value'));
	        });
	        return selectValues;
	      }
	
	      if (inputValue) {
	        return null;
	      }
	
	      var singleValue = selectValue[0];
	      return React__default.createElement(SingleValue, _extends({}, commonProps, {
	        data: singleValue,
	        isDisabled: isDisabled
	      }), this.formatOptionLabel(singleValue, 'value'));
	    }
	  }, {
	    key: "renderClearIndicator",
	    value: function renderClearIndicator() {
	      var ClearIndicator = this.components.ClearIndicator;
	      var commonProps = this.commonProps;
	      var _this$props16 = this.props,
	          isDisabled = _this$props16.isDisabled,
	          isLoading = _this$props16.isLoading;
	      var isFocused = this.state.isFocused;
	
	      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
	        return null;
	      }
	
	      var innerProps = {
	        onMouseDown: this.onClearIndicatorMouseDown,
	        onTouchEnd: this.onClearIndicatorTouchEnd,
	        'aria-hidden': 'true'
	      };
	      return React__default.createElement(ClearIndicator, _extends({}, commonProps, {
	        innerProps: innerProps,
	        isFocused: isFocused
	      }));
	    }
	  }, {
	    key: "renderLoadingIndicator",
	    value: function renderLoadingIndicator() {
	      var LoadingIndicator = this.components.LoadingIndicator;
	      var commonProps = this.commonProps;
	      var _this$props17 = this.props,
	          isDisabled = _this$props17.isDisabled,
	          isLoading = _this$props17.isLoading;
	      var isFocused = this.state.isFocused;
	      if (!LoadingIndicator || !isLoading) return null;
	      var innerProps = {
	        'aria-hidden': 'true'
	      };
	      return React__default.createElement(LoadingIndicator, _extends({}, commonProps, {
	        innerProps: innerProps,
	        isDisabled: isDisabled,
	        isFocused: isFocused
	      }));
	    }
	  }, {
	    key: "renderIndicatorSeparator",
	    value: function renderIndicatorSeparator() {
	      var _this$components2 = this.components,
	          DropdownIndicator = _this$components2.DropdownIndicator,
	          IndicatorSeparator = _this$components2.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator
	
	      if (!DropdownIndicator || !IndicatorSeparator) return null;
	      var commonProps = this.commonProps;
	      var isDisabled = this.props.isDisabled;
	      var isFocused = this.state.isFocused;
	      return React__default.createElement(IndicatorSeparator, _extends({}, commonProps, {
	        isDisabled: isDisabled,
	        isFocused: isFocused
	      }));
	    }
	  }, {
	    key: "renderDropdownIndicator",
	    value: function renderDropdownIndicator() {
	      var DropdownIndicator = this.components.DropdownIndicator;
	      if (!DropdownIndicator) return null;
	      var commonProps = this.commonProps;
	      var isDisabled = this.props.isDisabled;
	      var isFocused = this.state.isFocused;
	      var innerProps = {
	        onMouseDown: this.onDropdownIndicatorMouseDown,
	        onTouchEnd: this.onDropdownIndicatorTouchEnd,
	        'aria-hidden': 'true'
	      };
	      return React__default.createElement(DropdownIndicator, _extends({}, commonProps, {
	        innerProps: innerProps,
	        isDisabled: isDisabled,
	        isFocused: isFocused
	      }));
	    }
	  }, {
	    key: "renderMenu",
	    value: function renderMenu() {
	      var _this5 = this;
	
	      var _this$components3 = this.components,
	          Group = _this$components3.Group,
	          GroupHeading = _this$components3.GroupHeading,
	          Menu = _this$components3.Menu,
	          MenuList = _this$components3.MenuList,
	          MenuPortal = _this$components3.MenuPortal,
	          LoadingMessage = _this$components3.LoadingMessage,
	          NoOptionsMessage = _this$components3.NoOptionsMessage,
	          Option = _this$components3.Option;
	      var commonProps = this.commonProps;
	      var _this$state9 = this.state,
	          focusedOption = _this$state9.focusedOption,
	          menuOptions = _this$state9.menuOptions;
	      var _this$props18 = this.props,
	          captureMenuScroll = _this$props18.captureMenuScroll,
	          inputValue = _this$props18.inputValue,
	          isLoading = _this$props18.isLoading,
	          loadingMessage = _this$props18.loadingMessage,
	          minMenuHeight = _this$props18.minMenuHeight,
	          maxMenuHeight = _this$props18.maxMenuHeight,
	          menuIsOpen = _this$props18.menuIsOpen,
	          menuPlacement = _this$props18.menuPlacement,
	          menuPosition = _this$props18.menuPosition,
	          menuPortalTarget = _this$props18.menuPortalTarget,
	          menuShouldBlockScroll = _this$props18.menuShouldBlockScroll,
	          menuShouldScrollIntoView = _this$props18.menuShouldScrollIntoView,
	          noOptionsMessage = _this$props18.noOptionsMessage,
	          onMenuScrollToTop = _this$props18.onMenuScrollToTop,
	          onMenuScrollToBottom = _this$props18.onMenuScrollToBottom;
	      if (!menuIsOpen) return null; // TODO: Internal Option Type here
	
	      var render = function render(props) {
	        // for performance, the menu options in state aren't changed when the
	        // focused option changes so we calculate additional props based on that
	        var isFocused = focusedOption === props.data;
	        props.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;
	        return React__default.createElement(Option, _extends({}, commonProps, props, {
	          isFocused: isFocused
	        }), _this5.formatOptionLabel(props.data, 'menu'));
	      };
	
	      var menuUI;
	
	      if (this.hasOptions()) {
	        menuUI = menuOptions.render.map(function (item) {
	          if (item.type === 'group') {
	            var type = item.type,
	                group = _objectWithoutProperties(item, ["type"]);
	
	            var headingId = "".concat(item.key, "-heading");
	            return React__default.createElement(Group, _extends({}, commonProps, group, {
	              Heading: GroupHeading,
	              headingProps: {
	                id: headingId
	              },
	              label: _this5.formatGroupLabel(item.data)
	            }), item.options.map(function (option) {
	              return render(option);
	            }));
	          } else if (item.type === 'option') {
	            return render(item);
	          }
	        });
	      } else if (isLoading) {
	        var message = loadingMessage({
	          inputValue: inputValue
	        });
	        if (message === null) return null;
	        menuUI = React__default.createElement(LoadingMessage, commonProps, message);
	      } else {
	        var _message = noOptionsMessage({
	          inputValue: inputValue
	        });
	
	        if (_message === null) return null;
	        menuUI = React__default.createElement(NoOptionsMessage, commonProps, _message);
	      }
	
	      var menuPlacementProps = {
	        minMenuHeight: minMenuHeight,
	        maxMenuHeight: maxMenuHeight,
	        menuPlacement: menuPlacement,
	        menuPosition: menuPosition,
	        menuShouldScrollIntoView: menuShouldScrollIntoView
	      };
	      var menuElement = React__default.createElement(__chunk_2.MenuPlacer, _extends({}, commonProps, menuPlacementProps), function (_ref6) {
	        var ref = _ref6.ref,
	            _ref6$placerProps = _ref6.placerProps,
	            placement = _ref6$placerProps.placement,
	            maxHeight = _ref6$placerProps.maxHeight;
	        return React__default.createElement(Menu, _extends({}, commonProps, menuPlacementProps, {
	          innerRef: ref,
	          innerProps: {
	            onMouseDown: _this5.onMenuMouseDown,
	            onMouseMove: _this5.onMenuMouseMove
	          },
	          isLoading: isLoading,
	          placement: placement
	        }), React__default.createElement(ScrollCaptorSwitch, {
	          isEnabled: captureMenuScroll,
	          onTopArrive: onMenuScrollToTop,
	          onBottomArrive: onMenuScrollToBottom
	        }, React__default.createElement(ScrollBlock, {
	          isEnabled: menuShouldBlockScroll
	        }, React__default.createElement(MenuList, _extends({}, commonProps, {
	          innerRef: _this5.getMenuListRef,
	          isLoading: isLoading,
	          maxHeight: maxHeight
	        }), menuUI))));
	      }); // positioning behaviour is almost identical for portalled and fixed,
	      // so we use the same component. the actual portalling logic is forked
	      // within the component based on `menuPosition`
	
	      return menuPortalTarget || menuPosition === 'fixed' ? React__default.createElement(MenuPortal, _extends({}, commonProps, {
	        appendTo: menuPortalTarget,
	        controlElement: this.controlRef,
	        menuPlacement: menuPlacement,
	        menuPosition: menuPosition
	      }), menuElement) : menuElement;
	    }
	  }, {
	    key: "renderFormField",
	    value: function renderFormField() {
	      var _this6 = this;
	
	      var _this$props19 = this.props,
	          delimiter = _this$props19.delimiter,
	          isDisabled = _this$props19.isDisabled,
	          isMulti = _this$props19.isMulti,
	          name = _this$props19.name;
	      var selectValue = this.state.selectValue;
	      if (!name || isDisabled) return;
	
	      if (isMulti) {
	        if (delimiter) {
	          var value = selectValue.map(function (opt) {
	            return _this6.getOptionValue(opt);
	          }).join(delimiter);
	          return React__default.createElement("input", {
	            name: name,
	            type: "hidden",
	            value: value
	          });
	        } else {
	          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
	            return React__default.createElement("input", {
	              key: "i-".concat(i),
	              name: name,
	              type: "hidden",
	              value: _this6.getOptionValue(opt)
	            });
	          }) : React__default.createElement("input", {
	            name: name,
	            type: "hidden"
	          });
	          return React__default.createElement("div", null, input);
	        }
	      } else {
	        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
	
	        return React__default.createElement("input", {
	          name: name,
	          type: "hidden",
	          value: _value
	        });
	      }
	    }
	  }, {
	    key: "renderLiveRegion",
	    value: function renderLiveRegion() {
	      if (!this.state.isFocused) return null;
	      return React__default.createElement(A11yText, {
	        "aria-live": "polite"
	      }, React__default.createElement("p", {
	        id: "aria-selection-event"
	      }, "\xA0", this.state.ariaLiveSelection), React__default.createElement("p", {
	        id: "aria-context"
	      }, "\xA0", this.constructAriaLiveMessage()));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$components4 = this.components,
	          Control = _this$components4.Control,
	          IndicatorsContainer = _this$components4.IndicatorsContainer,
	          SelectContainer = _this$components4.SelectContainer,
	          ValueContainer = _this$components4.ValueContainer;
	      var _this$props20 = this.props,
	          className = _this$props20.className,
	          id = _this$props20.id,
	          isDisabled = _this$props20.isDisabled,
	          menuIsOpen = _this$props20.menuIsOpen;
	      var isFocused = this.state.isFocused;
	      var commonProps = this.commonProps = this.getCommonProps();
	      return React__default.createElement(SelectContainer, _extends({}, commonProps, {
	        className: className,
	        innerProps: {
	          id: id,
	          onKeyDown: this.onKeyDown
	        },
	        isDisabled: isDisabled,
	        isFocused: isFocused
	      }), this.renderLiveRegion(), React__default.createElement(Control, _extends({}, commonProps, {
	        innerRef: this.getControlRef,
	        innerProps: {
	          onMouseDown: this.onControlMouseDown,
	          onTouchEnd: this.onControlTouchEnd
	        },
	        isDisabled: isDisabled,
	        isFocused: isFocused,
	        menuIsOpen: menuIsOpen
	      }), React__default.createElement(ValueContainer, _extends({}, commonProps, {
	        isDisabled: isDisabled
	      }), this.renderPlaceholderOrValue(), this.renderInput()), React__default.createElement(IndicatorsContainer, _extends({}, commonProps, {
	        isDisabled: isDisabled
	      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
	    }
	  }]);
	
	  return Select;
	}(React.Component);
	
	_defineProperty(Select, "defaultProps", defaultProps);
	
	exports.Select = Select;
	exports.createFilter = createFilter;
	exports.defaultProps = defaultProps;
	exports.defaultTheme = defaultTheme;
	exports.mergeStyles = mergeStyles;


/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault(ex) {
	  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var _objectWithoutProperties = _interopDefault(__webpack_require__(163));
	
	var _extends = _interopDefault(__webpack_require__(160));
	
	var _classCallCheck = _interopDefault(__webpack_require__(158));
	
	var _createClass = _interopDefault(__webpack_require__(159));
	
	var _possibleConstructorReturn = _interopDefault(__webpack_require__(164));
	
	var _getPrototypeOf = _interopDefault(__webpack_require__(161));
	
	var _inherits = _interopDefault(__webpack_require__(162));
	
	var _assertThisInitialized = _interopDefault(__webpack_require__(127));
	
	var _defineProperty = _interopDefault(__webpack_require__(128));
	
	var React = __webpack_require__(1);
	
	var React__default = _interopDefault(React);
	
	var defaultProps = {
	  defaultInputValue: '',
	  defaultMenuIsOpen: false,
	  defaultValue: null
	};
	
	var manageState = function manageState(SelectComponent) {
	  var _class, _temp;
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(StateManager, _Component);
	
	    function StateManager() {
	      var _getPrototypeOf2;
	
	      var _this;
	
	      _classCallCheck(this, StateManager);
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(StateManager)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "select", void 0);
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
	        inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
	        menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
	        value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
	      });
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (value, actionMeta) {
	        _this.callProp('onChange', value, actionMeta);
	
	        _this.setState({
	          value: value
	        });
	      });
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onInputChange", function (value, actionMeta) {
	        // TODO: for backwards compatibility, we allow the prop to return a new
	        // value, but now inputValue is a controllable prop we probably shouldn't
	        var newValue = _this.callProp('onInputChange', value, actionMeta);
	
	        _this.setState({
	          inputValue: newValue !== undefined ? newValue : value
	        });
	      });
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuOpen", function () {
	        _this.callProp('onMenuOpen');
	
	        _this.setState({
	          menuIsOpen: true
	        });
	      });
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuClose", function () {
	        _this.callProp('onMenuClose');
	
	        _this.setState({
	          menuIsOpen: false
	        });
	      });
	
	      return _this;
	    }
	
	    _createClass(StateManager, [{
	      key: "focus",
	      value: function focus() {
	        this.select.focus();
	      }
	    }, {
	      key: "blur",
	      value: function blur() {
	        this.select.blur();
	      } // FIXME: untyped flow code, return any
	
	    }, {
	      key: "getProp",
	      value: function getProp(key) {
	        return this.props[key] !== undefined ? this.props[key] : this.state[key];
	      } // FIXME: untyped flow code, return any
	
	    }, {
	      key: "callProp",
	      value: function callProp(name) {
	        if (typeof this.props[name] === 'function') {
	          var _this$props;
	
	          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	            args[_key2 - 1] = arguments[_key2];
	          }
	
	          return (_this$props = this.props)[name].apply(_this$props, args);
	        }
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this2 = this;
	
	        var _this$props2 = this.props,
	            defaultInputValue = _this$props2.defaultInputValue,
	            defaultMenuIsOpen = _this$props2.defaultMenuIsOpen,
	            defaultValue = _this$props2.defaultValue,
	            props = _objectWithoutProperties(_this$props2, ["defaultInputValue", "defaultMenuIsOpen", "defaultValue"]);
	
	        return React__default.createElement(SelectComponent, _extends({}, props, {
	          ref: function ref(_ref) {
	            _this2.select = _ref;
	          },
	          inputValue: this.getProp('inputValue'),
	          menuIsOpen: this.getProp('menuIsOpen'),
	          onChange: this.onChange,
	          onInputChange: this.onInputChange,
	          onMenuClose: this.onMenuClose,
	          onMenuOpen: this.onMenuOpen,
	          value: this.getProp('value')
	        }));
	      }
	    }]);
	
	    return StateManager;
	  }(React.Component), _defineProperty(_class, "defaultProps", defaultProps), _temp;
	};
	
	exports.manageState = manageState;


/***/ },
/* 330 */
[2243, 2115],
/* 331 */
58,
/* 332 */
128,
/* 333 */
160,
/* 334 */
/***/ function(module, exports) {

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	module.exports = _inheritsLoose;

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.reviver = exports.retrocycle = exports.decycle = exports.CYCLIC_KEY = undefined;
	
	var _decycle2 = __webpack_require__(982);
	
	var _decycle3 = _interopRequireDefault(_decycle2);
	
	var _retrocycle2 = __webpack_require__(985);
	
	var _retrocycle3 = _interopRequireDefault(_retrocycle2);
	
	var _reviver2 = __webpack_require__(538);
	
	var _reviver3 = _interopRequireDefault(_reviver2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CYCLIC_KEY = exports.CYCLIC_KEY = '$___storybook.isCyclic';
	exports.decycle = _decycle3.default;
	exports.retrocycle = _retrocycle3.default;
	exports.reviver = _reviver3.default;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createFunction;
	
	var _canConfigureName = __webpack_require__(540);
	
	var _canConfigureName2 = _interopRequireDefault(_canConfigureName);
	
	var _createFunctionEval = __webpack_require__(988);
	
	var _createFunctionEval2 = _interopRequireDefault(_createFunctionEval);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createFunction() {
	  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  if (_canConfigureName2.default) {
	    var func = function unnamed() {};
	
	    Object.defineProperty(func, 'name', { value: name });
	
	    return func;
	  }
	
	  return (0, _createFunctionEval2.default)(name);
	}

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.types = exports.undefinedType = exports.symbolType = exports.regexpType = exports.nanType = exports.infinityType = exports.functionType = exports.dateType = exports.objectType = undefined;
	
	var _object = __webpack_require__(997);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _date = __webpack_require__(986);
	
	var _date2 = _interopRequireDefault(_date);
	
	var _function = __webpack_require__(989);
	
	var _function2 = _interopRequireDefault(_function);
	
	var _infinity = __webpack_require__(992);
	
	var _infinity2 = _interopRequireDefault(_infinity);
	
	var _nan = __webpack_require__(993);
	
	var _nan2 = _interopRequireDefault(_nan);
	
	var _regexp = __webpack_require__(999);
	
	var _regexp2 = _interopRequireDefault(_regexp);
	
	var _symbol = __webpack_require__(1001);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _undefined = __webpack_require__(1002);
	
	var _undefined2 = _interopRequireDefault(_undefined);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.objectType = _object2.default;
	exports.dateType = _date2.default;
	exports.functionType = _function2.default;
	exports.infinityType = _infinity2.default;
	exports.nanType = _nan2.default;
	exports.regexpType = _regexp2.default;
	exports.symbolType = _symbol2.default;
	exports.undefinedType = _undefined2.default;
	var types = exports.types = [_date2.default, _function2.default, _nan2.default, _infinity2.default, _regexp2.default, _symbol2.default, _undefined2.default];

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AddonStore = undefined;
	
	var _keys = __webpack_require__(277);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(103);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(140);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddonStore = exports.AddonStore = function () {
	  function AddonStore() {
	    (0, _classCallCheck3.default)(this, AddonStore);
	
	    this.loaders = {};
	    this.panels = {};
	    this.channel = null;
	    this.preview = null;
	    this.database = null;
	  }
	
	  (0, _createClass3.default)(AddonStore, [{
	    key: 'getChannel',
	    value: function getChannel() {
	      // this.channel should get overwritten by setChannel if package versions are
	      // correct and AddonStore is a proper singleton. If not, throw.
	      if (!this.channel) {
	        throw new Error('Accessing nonexistent addons channel, see https://storybook.js.org/basics/faq/#why-is-there-no-addons-channel');
	      }
	      return this.channel;
	    }
	  }, {
	    key: 'setChannel',
	    value: function setChannel(channel) {
	      this.channel = channel;
	    }
	  }, {
	    key: 'getPreview',
	    value: function getPreview() {
	      return this.preview;
	    }
	  }, {
	    key: 'setPreview',
	    value: function setPreview(preview) {
	      this.preview = preview;
	    }
	  }, {
	    key: 'getDatabase',
	    value: function getDatabase() {
	      return this.database;
	    }
	  }, {
	    key: 'setDatabase',
	    value: function setDatabase(database) {
	      this.database = database;
	    }
	  }, {
	    key: 'getPanels',
	    value: function getPanels() {
	      return this.panels;
	    }
	  }, {
	    key: 'addPanel',
	    value: function addPanel(name, panel) {
	      this.panels[name] = panel;
	    }
	  }, {
	    key: 'register',
	    value: function register(name, loader) {
	      this.loaders[name] = loader;
	    }
	  }, {
	    key: 'loadAddons',
	    value: function loadAddons(api) {
	      var _this = this;
	
	      (0, _keys2.default)(this.loaders).map(function (name) {
	        return _this.loaders[name];
	      }).forEach(function (loader) {
	        return loader(api);
	      });
	    }
	  }]);
	  return AddonStore;
	}();
	
	exports.default = new AddonStore();

/***/ },
/* 339 */
/***/ function(module, exports) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	var isArray = Array.isArray;
	
	var hexTable = (function () {
	    var array = [];
	    for (var i = 0; i < 256; ++i) {
	        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
	    }
	
	    return array;
	}());
	
	var compactQueue = function compactQueue(queue) {
	    while (queue.length > 1) {
	        var item = queue.pop();
	        var obj = item.obj[item.prop];
	
	        if (isArray(obj)) {
	            var compacted = [];
	
	            for (var j = 0; j < obj.length; ++j) {
	                if (typeof obj[j] !== 'undefined') {
	                    compacted.push(obj[j]);
	                }
	            }
	
	            item.obj[item.prop] = compacted;
	        }
	    }
	};
	
	var arrayToObject = function arrayToObject(source, options) {
	    var obj = options && options.plainObjects ? Object.create(null) : {};
	    for (var i = 0; i < source.length; ++i) {
	        if (typeof source[i] !== 'undefined') {
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	var merge = function merge(target, source, options) {
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (isArray(target)) {
	            target.push(source);
	        } else if (target && typeof target === 'object') {
	            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
	                target[source] = true;
	            }
	        } else {
	            return [target, source];
	        }
	
	        return target;
	    }
	
	    if (!target || typeof target !== 'object') {
	        return [target].concat(source);
	    }
	
	    var mergeTarget = target;
	    if (isArray(target) && !isArray(source)) {
	        mergeTarget = arrayToObject(target, options);
	    }
	
	    if (isArray(target) && isArray(source)) {
	        source.forEach(function (item, i) {
	            if (has.call(target, i)) {
	                var targetItem = target[i];
	                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
	                    target[i] = merge(targetItem, item, options);
	                } else {
	                    target.push(item);
	                }
	            } else {
	                target[i] = item;
	            }
	        });
	        return target;
	    }
	
	    return Object.keys(source).reduce(function (acc, key) {
	        var value = source[key];
	
	        if (has.call(acc, key)) {
	            acc[key] = merge(acc[key], value, options);
	        } else {
	            acc[key] = value;
	        }
	        return acc;
	    }, mergeTarget);
	};
	
	var assign = function assignSingleSource(target, source) {
	    return Object.keys(source).reduce(function (acc, key) {
	        acc[key] = source[key];
	        return acc;
	    }, target);
	};
	
	var decode = function (str, decoder, charset) {
	    var strWithoutPlus = str.replace(/\+/g, ' ');
	    if (charset === 'iso-8859-1') {
	        // unescape never throws, no try...catch needed:
	        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
	    }
	    // utf-8
	    try {
	        return decodeURIComponent(strWithoutPlus);
	    } catch (e) {
	        return strWithoutPlus;
	    }
	};
	
	var encode = function encode(str, defaultEncoder, charset) {
	    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	    // It has been adapted here for stricter adherence to RFC 3986
	    if (str.length === 0) {
	        return str;
	    }
	
	    var string = str;
	    if (typeof str === 'symbol') {
	        string = Symbol.prototype.toString.call(str);
	    } else if (typeof str !== 'string') {
	        string = String(str);
	    }
	
	    if (charset === 'iso-8859-1') {
	        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
	            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
	        });
	    }
	
	    var out = '';
	    for (var i = 0; i < string.length; ++i) {
	        var c = string.charCodeAt(i);
	
	        if (
	            c === 0x2D // -
	            || c === 0x2E // .
	            || c === 0x5F // _
	            || c === 0x7E // ~
	            || (c >= 0x30 && c <= 0x39) // 0-9
	            || (c >= 0x41 && c <= 0x5A) // a-z
	            || (c >= 0x61 && c <= 0x7A) // A-Z
	        ) {
	            out += string.charAt(i);
	            continue;
	        }
	
	        if (c < 0x80) {
	            out = out + hexTable[c];
	            continue;
	        }
	
	        if (c < 0x800) {
	            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        if (c < 0xD800 || c >= 0xE000) {
	            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        i += 1;
	        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
	        out += hexTable[0xF0 | (c >> 18)]
	            + hexTable[0x80 | ((c >> 12) & 0x3F)]
	            + hexTable[0x80 | ((c >> 6) & 0x3F)]
	            + hexTable[0x80 | (c & 0x3F)];
	    }
	
	    return out;
	};
	
	var compact = function compact(value) {
	    var queue = [{ obj: { o: value }, prop: 'o' }];
	    var refs = [];
	
	    for (var i = 0; i < queue.length; ++i) {
	        var item = queue[i];
	        var obj = item.obj[item.prop];
	
	        var keys = Object.keys(obj);
	        for (var j = 0; j < keys.length; ++j) {
	            var key = keys[j];
	            var val = obj[key];
	            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
	                queue.push({ obj: obj, prop: key });
	                refs.push(val);
	            }
	        }
	    }
	
	    compactQueue(queue);
	
	    return value;
	};
	
	var isRegExp = function isRegExp(obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	var isBuffer = function isBuffer(obj) {
	    if (!obj || typeof obj !== 'object') {
	        return false;
	    }
	
	    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
	};
	
	var combine = function combine(a, b) {
	    return [].concat(a, b);
	};
	
	module.exports = {
	    arrayToObject: arrayToObject,
	    assign: assign,
	    combine: combine,
	    compact: compact,
	    decode: decode,
	    encode: encode,
	    isBuffer: isBuffer,
	    isRegExp: isRegExp,
	    merge: merge
	};


/***/ },
/* 340 */
[2243, 1054],
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _LoadingBar = __webpack_require__(91);
	
	var _LoadingBar2 = _interopRequireDefault(_LoadingBar);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ECFForwarding = function (_Component) {
	  _inherits(ECFForwarding, _Component);
	
	  function ECFForwarding() {
	    _classCallCheck(this, ECFForwarding);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ECFForwarding.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
	    console.debug("getDerivedStateFromProps", nextProps, prevState);
	    return {
	      settingsDraft: nextProps.settings && ECFForwarding.settingsToForm(nextProps.settings)
	    };
	  };
	
	  // Convert bakcend settings struct to something that can be manipulated by UI for a better UX
	
	
	  // Create settings object that backend understands
	
	
	  ECFForwarding.prototype.onSave = function onSave(values) {
	    var settings = ECFForwarding.formToSettings(values);
	
	    this.props.onSaveSettings(settings);
	  };
	
	  ECFForwarding.prototype.render = function render() {
	    var _this2 = this;
	
	    if (this.props.loading) return _react2.default.createElement(_LoadingBar2.default, null);
	
	    return _react2.default.createElement(_reactFinalForm.Form, {
	      onSubmit: this.onSave.bind(this),
	      initialValues: this.state.settingsDraft,
	      render: function render(_ref) {
	        var handleSubmit = _ref.handleSubmit,
	            submitting = _ref.submitting,
	            pristine = _ref.pristine,
	            values = _ref.values,
	            form = _ref.form;
	        return _react2.default.createElement(
	          'form',
	          { onSubmit: handleSubmit, style: { marginBottom: '12px' } },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'form-item' },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactFinalForm.Field, { id: 'override_settings', name: 'override_settings', component: 'input', type: 'checkbox', className: 'form-checkbox' }),
	              '\xA0 Override Forwarding settings for this CaseFolder'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { /* Fields appear faded unless the box above is ticked */
	              style: { opacity: values.override_settings ? 1 : 0.50 }
	              /* when any of the fields receive focus, we assume user wants to override the settings */
	              , onFocus: function onFocus() {
	                return form.change('override_settings', true);
	              } },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Forward ECF emails for this case'
	              ),
	              _react2.default.createElement(
	                _reactFinalForm.Field,
	                { name: 'forwarding_option', component: 'select', className: 'form-select' },
	                _react2.default.createElement(
	                  'option',
	                  { value: '' },
	                  'No'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: 'pleadings' },
	                  'Only Pleadings'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: 'all' },
	                  'Forward All'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                /* forwarding tweaks only shown when options are visible  */
	                style: { display: values.forwarding_option ? 'block' : 'none' } },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'form-item' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  'Forward ECF emails on this case to the following distribution list:'
	                ),
	                _react2.default.createElement(_reactFinalForm.Field, { name: 'destinations', component: 'textarea', rows: '4', cols: '55', className: 'form-textarea',
	                  placeholder: 'Add up to 20 emails, one per line or separated by commas or semicolons' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'form-item' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  'Multiple PDF Handling'
	                ),
	                _react2.default.createElement(
	                  _reactFinalForm.Field,
	                  { name: 'combine_pdf_option', component: 'select', className: 'form-select' },
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'combine' },
	                    'Combine PDFs'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: '' },
	                    'Leave PDFs Separate'
	                  )
	                )
	              ),
	              _this2.props.permissions.can_attach_pdf && _react2.default.createElement(
	                'div',
	                { 'class': 'form-item' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  'Attach PDFs'
	                ),
	                _react2.default.createElement(
	                  _reactFinalForm.Field,
	                  { name: 'should_attach_pdf', component: 'select', className: 'form-select' },
	                  _react2.default.createElement(
	                    'option',
	                    { value: '' },
	                    'No'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'yes' },
	                    'Yes'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { type: 'submit', disabled: pristine, className: pristine || 'form-submit' },
	            'Save'
	          ),
	          '\xA0',
	          _react2.default.createElement(
	            'a',
	            { style: pristine ? { cursor: 'default', color: 'gray' } : { cursor: 'pointer', color: 'blue' }, onClick: function onClick() {
	                return form.reset();
	              } },
	            'Reset'
	          )
	        );
	      }
	    });
	  };
	
	  return ECFForwarding;
	}(_react.Component);
	
	ECFForwarding.propTypes = {
	  permissions: _propTypes2.default.object.isRequired,
	  loading: _propTypes2.default.bool,
	  onSaveSettings: _propTypes2.default.func.isRequired,
	  settings: _propTypes2.default.object
	};
	
	ECFForwarding.settingsToForm = function (settings) {
	  return {
	    override_settings: !settings.is_global,
	    forwarding_option: settings.enabled ? settings.fwd_all_case_emails ? 'all' : 'pleadings' : '',
	    destinations: settings.destinations && settings.destinations.join("\n"),
	    combine_pdf_option: settings.link_to_combined_pdf ? 'combine' : '',
	    should_attach_pdf: settings.attach_pdf ? 'yes' : ''
	  };
	};
	
	ECFForwarding.formToSettings = function (values) {
	  return {
	    is_global: !values.override_settings,
	    enabled: !!values.forwarding_option,
	    destinations: values.destinations && values.destinations.split(/[\r\n;,]+/),
	    fwd_all_case_emails: values.forwarding_option === 'all',
	    link_to_combined_pdf: values.combine_pdf_option === 'combine',
	    attach_pdf: values.should_attach_pdf === 'yes'
	  };
	};
	
	exports.default = ECFForwarding;

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FinalFormClioDocumentCategorySelector = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClioDocumentCategorySelector = function (_Component) {
	  _inherits(ClioDocumentCategorySelector, _Component);
	
	  function ClioDocumentCategorySelector() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ClioDocumentCategorySelector);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      isLoading: false,
	      isRefreshing: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ClioDocumentCategorySelector.prototype.componentDidMount = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              this.loadDocumentCategories(false);
	
	            case 1:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    function componentDidMount() {
	      return _ref.apply(this, arguments);
	    }
	
	    return componentDidMount;
	  }();
	
	  ClioDocumentCategorySelector.prototype.render = function render() {
	    var _this2 = this;
	
	    var _state = this.state,
	        isLoading = _state.isLoading,
	        isRefreshing = _state.isRefreshing,
	        documentCategoryOptions = _state.documentCategoryOptions;
	
	
	    if (isLoading && !documentCategoryOptions) return _react2.default.createElement(_reactBootstrap.ProgressBar, { now: 100 });
	
	    var refreshClasses = (0, _classnames2.default)({
	      'fa': true,
	      'fa-refresh': true,
	      'fa-spin': isRefreshing
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { key: 'self', style: { position: 'relative' } },
	      _react2.default.createElement(_reactSelect2.default, _extends({
	        defaultOptions: true,
	        options: documentCategoryOptions,
	        isClearable: true,
	        simpleValue: true,
	        disabled: isLoading
	      }, this.props)),
	      _react2.default.createElement('i', { className: refreshClasses,
	        style: {
	          position: 'absolute',
	          textAlign: 'center',
	          top: '12px',
	          right: '27px',
	          zIndex: 100,
	          cursor: 'pointer'
	        },
	        onClick: function onClick() {
	          !isRefreshing && _this2.loadDocumentCategories(true);
	        },
	        key: 'doc-category-refresh-button'
	      })
	    );
	  };
	
	  ClioDocumentCategorySelector.prototype.loadDocumentCategories = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(refreshFromClio) {
	      var connectionId, res, documentCategoryOptions;
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              this.setState({
	                isLoading: true,
	                isRefreshing: refreshFromClio
	              });
	
	              connectionId = this.props.connectionId;
	              _context2.next = 4;
	              return _superagent2.default.get('/rpc/integrations/connections/' + connectionId + '/clio/document-categories').query({ refresh: refreshFromClio });
	
	            case 4:
	              res = _context2.sent;
	              documentCategoryOptions = res.body.values.map(function (val) {
	                return { label: val.name, value: val.id };
	              });
	
	
	              this.setState({
	                isLoading: false,
	                isRefreshing: false,
	                documentCategoryOptions: documentCategoryOptions
	              });
	
	            case 7:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, this);
	    }));
	
	    function loadDocumentCategories(_x) {
	      return _ref2.apply(this, arguments);
	    }
	
	    return loadDocumentCategories;
	  }();
	
	  return ClioDocumentCategorySelector;
	}(_react.Component);
	
	ClioDocumentCategorySelector.defaultProps = {
	  connectionId: null,
	  onChange: null
	};
	ClioDocumentCategorySelector.propTypes = {
	  connectionId: _propTypes2.default.number.isRequired,
	  onChange: _propTypes2.default.func
	};
	exports.default = ClioDocumentCategorySelector;
	;
	
	/*
	  You can create Final Form compatible field via
	  ```
	    <Field
	      name="documentCateogoryId"
	      connectionId={connectionId}
	      component={FinalFormCLioDocumentCategorySelector}
	    />
	  ```
	*/
	var FinalFormClioDocumentCategorySelector = function FinalFormClioDocumentCategorySelector(_ref3) {
	  var _ref3$input = _ref3.input,
	      value = _ref3$input.value,
	      _onChange = _ref3$input.onChange,
	      rest = _objectWithoutProperties(_ref3, ['input']);
	
	  return _react2.default.createElement(ClioDocumentCategorySelector, _extends({
	    value: value,
	    onChange: function onChange(selectedOption) {
	      return _onChange(selectedOption);
	    }
	  }, rest));
	};
	exports.FinalFormClioDocumentCategorySelector = FinalFormClioDocumentCategorySelector;

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _integrationsConnectionActions = __webpack_require__(46);
	
	var _filenameTemplateFields = __webpack_require__(169);
	
	var _filenameTemplateFields2 = _interopRequireDefault(_filenameTemplateFields);
	
	var _LoadingBar = __webpack_require__(610);
	
	var _LoadingBar2 = _interopRequireDefault(_LoadingBar);
	
	var _FileFormatConfiguration = __webpack_require__(586);
	
	var _FileFormatConfiguration2 = _interopRequireDefault(_FileFormatConfiguration);
	
	var _FolderPathConfiguration = __webpack_require__(587);
	
	var _FolderPathConfiguration2 = _interopRequireDefault(_FolderPathConfiguration);
	
	var _DefaultConfigurations = __webpack_require__(579);
	
	var _DefaultConfigurations2 = _interopRequireDefault(_DefaultConfigurations);
	
	var _CustomizeDescriptionBox = __webpack_require__(584);
	
	var _CustomizeDescriptionBox2 = _interopRequireDefault(_CustomizeDescriptionBox);
	
	var _FieldsSelector = __webpack_require__(585);
	
	var _FieldsSelector2 = _interopRequireDefault(_FieldsSelector);
	
	var _SavedFormatPreview = __webpack_require__(589);
	
	var _SavedFormatPreview2 = _interopRequireDefault(_SavedFormatPreview);
	
	var _Notification = __webpack_require__(24);
	
	__webpack_require__(2147);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FilenameTemplate = function (_Component) {
	  _inherits(FilenameTemplate, _Component);
	
	  function FilenameTemplate(props) {
	    _classCallCheck(this, FilenameTemplate);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.getSelectedFieldType = function () {
	      var editableSection = _this.state.editableSection;
	
	      var selectedFieldType = null;
	      if (editableSection === 'file-format-configuration') {
	        selectedFieldType = 'selectedFileFormatFields';
	      } else if (editableSection === 'folder-path-configuration') {
	        selectedFieldType = 'selectedFolderPathFields';
	      }
	      return selectedFieldType;
	    };
	
	    _this.addField = function (fieldName) {
	      var selectedFieldType = _this.getSelectedFieldType();
	      if (selectedFieldType !== null) {
	        var _updateFilenameTempla;
	
	        var selectedFields = _this.props.filenameTemplate[selectedFieldType];
	        _this.props.dispatch((0, _integrationsConnectionActions.updateFilenameTemplate)(_this.props.connectionId, (_updateFilenameTempla = {}, _updateFilenameTempla[selectedFieldType] = selectedFields.concat([fieldName]), _updateFilenameTempla)));
	      }
	    };
	
	    _this.removeField = function (idx) {
	      var selectedFieldType = _this.getSelectedFieldType();
	      if (selectedFieldType !== null) {
	        var _updateFilenameTempla2;
	
	        var selectedFields = _this.props.filenameTemplate[selectedFieldType];
	        selectedFields.splice(idx, 1);
	        _this.props.dispatch((0, _integrationsConnectionActions.updateFilenameTemplate)(_this.props.connectionId, (_updateFilenameTempla2 = {}, _updateFilenameTempla2[selectedFieldType] = selectedFields, _updateFilenameTempla2)));
	      }
	    };
	
	    _this.appendSlashFolderPathFields = function () {
	      var selectedFolderPathFields = _this.props.filenameTemplate.selectedFolderPathFields;
	
	      var lastElem = selectedFolderPathFields[selectedFolderPathFields.length - 1];
	      var fields = selectedFolderPathFields;
	      if (lastElem !== '/' && selectedFolderPathFields.length > 0) {
	        fields.push('/');
	        _this.props.dispatch((0, _integrationsConnectionActions.updateFilenameTemplate)(_this.props.connectionId, { selectedFolderPathFields: fields }));
	      }
	      return fields;
	    };
	
	    _this.mapFields = function (field) {
	      var separatorNames = _filenameTemplateFields2.default.filter(function (x) {
	        return x.type === 'separator';
	      }).map(function (f) {
	        return f.name;
	      });
	      return separatorNames.includes(field) ? field : '{{' + field + '}}';
	    };
	
	    _this.save = function () {
	      var _this$props = _this.props,
	          filenameTemplate = _this$props.filenameTemplate,
	          connectionId = _this$props.connectionId,
	          allowFolderConfiguration = _this$props.allowFolderConfiguration;
	
	      var selectedFolderPathFields = _this.appendSlashFolderPathFields().map(_this.mapFields);
	      var selectedFileFormatFields = filenameTemplate.selectedFileFormatFields.map(_this.mapFields);
	
	      if (filenameTemplate.selectedFileFormatFields.length === 0 && filenameTemplate.selectedFolderPathFields.length === 0) {
	        return _this.props.dispatch((0, _integrationsConnectionActions.deleteFilenameTemplates)({ id: connectionId }));
	      }
	
	      var template = allowFolderConfiguration ? selectedFolderPathFields.concat(selectedFileFormatFields).join('') : selectedFileFormatFields.join('');
	
	      var params = {
	        id: connectionId,
	        date_format: filenameTemplate.date_format,
	        description_max_words: filenameTemplate.description_max_words,
	        // Folders and filename configuration
	        root_folder: filenameTemplate.root_folder,
	        template: template
	      };
	
	      _this.props.dispatch((0, _integrationsConnectionActions.saveFilenameTemplates)(params));
	    };
	
	    _this.clear = function () {
	      var selectedFieldType = _this.getSelectedFieldType();
	      if (selectedFieldType !== null) {
	        var _updateFilenameTempla3;
	
	        _this.props.dispatch((0, _integrationsConnectionActions.updateFilenameTemplate)(_this.props.connectionId, (_updateFilenameTempla3 = {}, _updateFilenameTempla3[selectedFieldType] = [], _updateFilenameTempla3)));
	      }
	    };
	
	    _this.edit = function (editableSection) {
	      _this.setState({ editableSection: editableSection });
	    };
	
	    _this.addRootFolder = function (e) {
	      _this.props.dispatch((0, _integrationsConnectionActions.updateFilenameTemplate)(_this.props.connectionId, { root_folder: e.target.value }));
	    };
	
	    _this.state = {
	      allowFolderConfiguration: _this.props.allowFolderConfiguration,
	
	      // 2 sections available
	      // folder-path-configuration | file-format-configuration
	      editableSection: _this.props.allowFolderConfiguration ? 'folder-path-configuration' : 'file-format-configuration'
	    };
	    return _this;
	  }
	
	  FilenameTemplate.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snapshot) {
	    if (this.props.allowFolderConfiguration !== prevProps.allowFolderConfiguration) this.setState({ allowFolderConfiguration: this.props.allowFolderConfiguration });
	  };
	
	  FilenameTemplate.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        filenameTemplate = _props.filenameTemplate,
	        hasAppFolder = _props.hasAppFolder;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'filename-template' },
	      _react2.default.createElement(_DefaultConfigurations2.default, null),
	      _react2.default.createElement(_CustomizeDescriptionBox2.default, null),
	      _react2.default.createElement(_FieldsSelector2.default, { description_max_words: filenameTemplate.description_max_words,
	        connectionId: this.props.connectionId,
	        date_format: filenameTemplate.date_format,
	        editableSection: this.state.editableSection,
	        root_folder: filenameTemplate.root_folder,
	        addField: this.addField,
	        addRootFolder: this.addRootFolder,
	        hasAppFolder: hasAppFolder,
	        dispatch: this.props.dispatch }),
	      _react2.default.createElement(
	        'div',
	        { className: 'right-panel' },
	        this.props.allowFolderConfiguration && _react2.default.createElement(_FolderPathConfiguration2.default, {
	          filenameTemplate: filenameTemplate,
	          editable: this.state.editableSection === 'folder-path-configuration',
	          addRootFolder: this.addRootFolder,
	          removeField: this.removeField,
	          edit: function edit() {
	            return _this2.edit('folder-path-configuration');
	          },
	          save: this.save,
	          clear: this.clear }),
	        _react2.default.createElement(_FileFormatConfiguration2.default, {
	          filenameTemplate: filenameTemplate,
	          editable: this.state.editableSection === 'file-format-configuration',
	          removeField: this.removeField,
	          edit: function edit() {
	            return _this2.edit('file-format-configuration');
	          },
	          save: this.save,
	          clear: this.clear })
	      ),
	      filenameTemplate.isLoading && _react2.default.createElement(_LoadingBar2.default, null),
	      _react2.default.createElement(_SavedFormatPreview2.default, { filenameTemplate: this.props.filenameTemplate })
	    );
	  };
	
	  return FilenameTemplate;
	}(_react.Component);
	
	FilenameTemplate.defaultProps = {
	  connectionId: null,
	  hasAppFolder: false
	};
	
	FilenameTemplate.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  filenameTemplate: _propTypes2.default.object.isRequired,
	  connectionId: _propTypes2.default.number,
	  hasAppFolder: _propTypes2.default.bool
	};
	
	exports.default = FilenameTemplate;

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactSelect = __webpack_require__(235);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SharepointDriveSelector = function (_Component) {
	  _inherits(SharepointDriveSelector, _Component);
	
	  function SharepointDriveSelector() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SharepointDriveSelector);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      drives: [],
	      selectedDrive: null
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  SharepointDriveSelector.prototype.componentDidMount = function componentDidMount() {
	    this.setState({ selectedDrive: this.props.defaultValue });
	    this.loadSharePointDrives();
	  };
	
	  SharepointDriveSelector.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snapshot) {
	    // refresh drives list when siteId prop changes
	    if (prevProps.siteId !== this.props.siteId) {
	      this.setState({ selectedDrive: null });
	      this.loadSharePointDrives();
	    }
	  };
	
	  SharepointDriveSelector.prototype.loadSharePointDrives = function loadSharePointDrives(forceRefresh) {
	    var _this2 = this;
	
	    this.setState({ isLoading: true, isError: false });
	
	    var _props = this.props,
	        connectionId = _props.connectionId,
	        siteId = _props.siteId;
	
	
	    _superagent2.default.get("/rpc/integrations/connections/" + connectionId + "/sharepoint/sites/" + siteId + "/drives").query({ refresh: forceRefresh }).then(function (res) {
	      var drives = res.body.drives || [];
	      var hasSingleDrive = drives.length === 1;
	
	      _this2.setState({
	        selectedDrive: hasSingleDrive ? drives[0] : _this2.state.selectedDrive,
	        isLoading: false,
	        drives: drives
	      });
	
	      // If we selected the drive, also call the onSelectDrive handler
	      if (hasSingleDrive && _this2.props.onSelectDrive) _this2.props.onSelectDrive(drives[0]);
	    }).catch(function (error) {
	      _this2.setState({ isLoading: false, isError: true });
	    });
	  };
	
	  SharepointDriveSelector.prototype.render = function render() {
	    var _this3 = this;
	
	    if (this.state.isError) return _react2.default.createElement(
	      _reactBootstrap.Alert,
	      null,
	      "Unable to load SharePoint Drives for Site"
	    );
	
	    var values = this.state.drives;
	    var selectedDrive = this.state.selectedDrive;
	
	
	    return _react2.default.createElement(
	      "div",
	      { style: { position: 'relative' } },
	      _react2.default.createElement(_reactSelect2.default, {
	        value: this.state.selectedDrive,
	        label: _lodash2.default.get(selectedDrive, 'name'),
	        isLoading: this.state.isLoading,
	        options: values,
	        key: this.props.siteId,
	        getOptionLabel: function getOptionLabel(value) {
	          return value.name;
	        },
	        getOptionValue: function getOptionValue(value) {
	          return value.id;
	        },
	        onChange: function onChange(selectedDrive) {
	          _this3.setState({ selectedDrive: selectedDrive });
	
	          if (_this3.props.onSelectDrive) _this3.props.onSelectDrive(selectedDrive);
	        }
	      }),
	      !this.state.isLoading && _react2.default.createElement("i", { className: "fa fa-refresh",
	        style: {
	          position: 'absolute',
	          textAlign: 'center',
	          top: '13px',
	          right: '75px',
	          zIndex: 100,
	          cursor: 'pointer'
	        },
	        onClick: function onClick() {
	          !_this3.state.isLoading && _this3.loadSharePointDrives(true);
	        },
	        key: "site-refresh-button"
	      })
	    );
	  };
	
	  return SharepointDriveSelector;
	}(_react.Component);
	
	SharepointDriveSelector.propTypes = {
	  connectionId: _propTypes2.default.number.isRequired,
	  siteId: _propTypes2.default.string,
	  onSelectDrive: _propTypes2.default.func,
	  defaultValue: _propTypes2.default.object
	};
	SharepointDriveSelector.defaultProps = {
	  connectionId: null,
	  siteId: null,
	  onSelectDrive: null
	};
	exports.default = SharepointDriveSelector;

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FinalFormSharepointSiteSearch = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (_ref) {
	  var connectionId = _ref.connectionId,
	      onSelectSite = _ref.onSelectSite,
	      defaultValue = _ref.defaultValue;
	
	  var _useState = (0, _react.useState)(defaultValue),
	      selectedValue = _useState[0],
	      setSelectedValue = _useState[1];
	
	  var getOptions = function getOptions(inputValue) {
	    // clear current selected value, otherwise loaded options will all be selected :(
	    setSelectedValue(null);
	
	    return _superagent2.default.get('/rpc/integrations/connections/' + connectionId + '/sharepoint/sites').query({ query: inputValue.trim() }).then(function (response) {
	      return response.body.sites;
	    });
	  };
	
	  var debouncedGetOptions = (0, _react.useCallback)(_lodash2.default.debounce(function (inputValue, callback) {
	    getOptions(inputValue).then(function (options) {
	      return callback(options);
	    });
	  }, 500), []);
	
	  // update internal state on change an communicate the new value via onSelectSite
	  var onChange = function onChange(option) {
	    setSelectedValue(option);
	    onSelectSite(option);
	  };
	
	  return _react2.default.createElement(_async2.default, {
	    label: _lodash2.default.get(selectedValue, 'displayName'),
	    value: selectedValue,
	    loadOptions: debouncedGetOptions,
	    loadingMessage: function loadingMessage() {
	      return 'Searching SharePoint Sites...';
	    },
	    noOptionsMessage: function noOptionsMessage() {
	      return 'No Sites Found Matching Search Criteria.';
	    },
	    isClearable: true,
	    placeholder: 'Type to search SharePoint Sites.  Only full words will match.',
	    getOptionLabel: function getOptionLabel(option) {
	      return option.displayName;
	    },
	    onChange: onChange
	  });
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _async = __webpack_require__(233);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var FinalFormSharepointSiteSearch = function FinalFormSharepointSiteSearch(_ref2) {
	  var _ref2$input = _ref2.input,
	      value = _ref2$input.value,
	      onChange = _ref2$input.onChange,
	      rest = _objectWithoutProperties(_ref2, ['input']);
	
	  return _react2.default.createElement(SharepointSiteSearch, _extends({ value: value, onSelectSite: function onSelectSite(option) {
	      return onChange(option);
	    } }, rest));
	};
	exports.FinalFormSharepointSiteSearch = FinalFormSharepointSiteSearch;

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = ECFMailboxesList;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Helpers ------------------------------------------------------
	var inboxImapUri = function inboxImapUri(_ref) {
	  var ssl = _ref.ssl,
	      hostname = _ref.hostname,
	      port = _ref.port;
	  return (ssl ? 'imap+ssl' : 'imap') + '://' + hostname + ':' + port;
	};
	
	// --------------------------------------------------------------
	
	function ECFMailboxesList(_ref2) {
	  var config = _ref2.config,
	      onConnectNewExternalInboxRequested = _ref2.onConnectNewExternalInboxRequested,
	      onDisconnectExternalInboxRequested = _ref2.onDisconnectExternalInboxRequested,
	      onEditExternalInboxRequested = _ref2.onEditExternalInboxRequested;
	
	
	  var typeToLabel = function typeToLabel(label) {
	    return {
	      gmail: 'GMail',
	      hotmail: 'HotMail',
	      imap: 'IMAP'
	    }[label] || 'Unknown';
	  };
	
	  var InboxDetails = function InboxDetails(_ref3) {
	    var inbox = _ref3.inbox;
	
	    if (inbox.type === 'imap') return _react2.default.createElement(
	      'span',
	      null,
	      _react2.default.createElement(
	        'strong',
	        null,
	        inbox.connection_secrets.username
	      ),
	      '',
	      ' ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'via'
	      ),
	      ' ',
	      '',
	      _react2.default.createElement(
	        'strong',
	        null,
	        inboxImapUri(inbox.connection_settings)
	      )
	    );
	    // Gmail, Hotmail, etc just show username
	    return _react2.default.createElement(
	      'strong',
	      null,
	      inbox.connection_secrets.username
	    );
	  };
	
	  var InboxActions = function InboxActions(_ref4) {
	    var inbox = _ref4.inbox;
	    return _react2.default.createElement(
	      _reactBootstrap.ButtonToolbar,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'link',
	          bsSize: 'xs',
	          onClick: function onClick() {
	            return onEditExternalInboxRequested(inbox);
	          }
	        },
	        _react2.default.createElement('i', { className: 'fa fa-gear' }),
	        ' ',
	        'Update Credentials'
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'link',
	          bsSize: 'xs',
	          onClick: function onClick() {
	            return confirm('\n              Are you sure you wish to disconnect ' + typeToLabel(inbox.type) + ' connection?\n              (Messages already received will not be removed from CourtDrive)\n            ') && onDisconnectExternalInboxRequested(inbox);
	          },
	          style: { color: 'red' }
	        },
	        _react2.default.createElement('i', { className: 'fa fa-unlink' }),
	        ' ',
	        'Disconnect'
	      )
	    );
	  };
	
	  var managedInbox = config.managed;
	  var externalInboxes = config.external;
	
	  var hasExternalInbox = externalInboxes.length > 0;
	
	  if (!managedInbox) return _react2.default.createElement(
	    _reactBootstrap.Panel,
	    null,
	    _react2.default.createElement(
	      _reactBootstrap.Panel.Heading,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Panel.Title,
	        null,
	        'Your CourtDrive Email'
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Panel.Body,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          onClick: function onClick() {
	            return window.open('/ecf/register');
	          }
	        },
	        'Click Here To Setup your CourtDrive Email'
	      )
	    )
	  );
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      _reactBootstrap.Panel,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Panel.Heading,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Panel.Title,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'link',
	              bsSize: 'xs',
	              onClick: function onClick() {
	                return window.open('https://support.courtdrive.com/hc/en-us/sections/200908778-ECF-Email-Manager');
	              },
	              style: { float: 'right', color: 'navy', textDecoration: 'underline' },
	              href: '#' },
	            'Instructions to add to court'
	          ),
	          'Your CourtDrive Email'
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Panel.Body,
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          managedInbox.prefix,
	          '@ecf.courtdrive.com'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Panel,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Panel.Heading,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Panel.Title,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              style: { float: 'right' },
	              bsStyle: 'primary',
	              bsSize: 'xs',
	              onClick: onConnectNewExternalInboxRequested
	            },
	            _react2.default.createElement('i', { className: 'fa fa-link' }),
	            ' ',
	            '',
	            'Connect ',
	            hasExternalInbox ? 'another' : 'an',
	            ' external mailbox'
	          ),
	          'Connect External Mailboxes (GMail, Hotmail, IMAP)'
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Panel.Heading,
	        { style: { backgroundColor: '#fcf8e3' } },
	        _react2.default.createElement('i', { className: 'fa fa-info-circle' }),
	        ' ',
	        'Use this option if you cannot add your CourtDrive email as a secondary notice recipient.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('i', { className: 'fa fa-exclamation-triangle', styl: { visibility: 'hidden' } }),
	        ' ',
	        'Please designate this inbox for ECF notices only and provide the email address only to the courts.'
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Panel.Body,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Table,
	          null,
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                null,
	                'Inbox Type'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Details'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Actions'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            externalInboxes.length === 0 && _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                { colSpan: '3' },
	                'No mailboxes have been configured.'
	              )
	            ),
	            externalInboxes.map(function (inbox) {
	              return _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  typeToLabel(inbox.type)
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  InboxDetails({ inbox: inbox })
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  InboxActions({ inbox: inbox })
	                )
	              );
	            })
	          )
	        )
	      )
	    )
	  );
	}
	
	ECFMailboxesList.propTypes = {
	  config: _propTypes2.default.object.isRequired,
	  // Callbacks
	  onConnectNewExternalInboxRequested: _propTypes2.default.func.isRequired,
	  onDisconnectExternalInboxRequested: _propTypes2.default.func.isRequired,
	  onEditExternalInboxRequested: _propTypes2.default.func.isRequired
	};

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.PER_CASE_FLAG = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = AttributeSelector;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useDataApi2 = __webpack_require__(60);
	
	var _useDataApi3 = _interopRequireDefault(_useDataApi2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Unfortunately, since we are using `simpleValue`, it becomes hard to
	// have special values, so here we invent a string that
	var PER_CASE_FLAG = exports.PER_CASE_FLAG = "<PER \b CASE>";
	
	function AttributeSelector(_ref) {
	  var connectionId = _ref.connectionId,
	      cabinet = _ref.cabinet,
	      attribute = _ref.attribute,
	      _ref$parent_key = _ref.parent_key,
	      parent_key = _ref$parent_key === undefined ? '' : _ref$parent_key,
	      input = _ref.input,
	      showPerCaseOption = _ref.showPerCaseOption;
	
	  var _useDataApi = (0, _useDataApi3.default)('/rpc/integrations/connections/' + connectionId + '/repository/' + cabinet.repositoryId + '/attribute/' + attribute.id + '/values?parent_key=' + parent_key, {}),
	      _useDataApi$ = _useDataApi[0],
	      data = _useDataApi$.data,
	      isLoading = _useDataApi$.isLoading,
	      isError = _useDataApi$.isError;
	
	  // TODO: remove when backend is fixed
	  //  weird problem where we get junk data..., maybe should move into `useDataApi`, but should really fix backend
	
	
	  if (!isError && !data) return _react2.default.createElement(
	    _reactBootstrap.Alert,
	    null,
	    'Unable to load values for ',
	    attribute.name
	  );
	
	  var values = data.values || [];
	  var valuesOptions = values.map(function (val) {
	    return {
	      label: _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          val.key
	        ),
	        ' ',
	        _react2.default.createElement(
	          'em',
	          null,
	          val.description ? ' -- ' + val.description : ''
	        )
	      ),
	      // label: val.description,
	      value: val.key
	    };
	  });
	
	  if (showPerCaseOption) valuesOptions.unshift({
	    label: _react2.default.createElement(
	      'span',
	      null,
	      _react2.default.createElement(
	        'strong',
	        { style: { color: 'purple' } },
	        'Select per case'
	      ),
	      _react2.default.createElement(
	        'em',
	        null,
	        ' -- Needs to be specified for each case individually'
	      )
	    ),
	    value: PER_CASE_FLAG
	  });
	
	  if (isError) return _react2.default.createElement(
	    _reactBootstrap.Alert,
	    null,
	    'Unable to load values for ',
	    attribute.name
	  );
	
	  return _react2.default.createElement(_reactSelect2.default, _extends({}, input, {
	    isLoading: isLoading,
	    options: valuesOptions,
	    simpleValue: true
	  }));
	}

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _DateFilter = __webpack_require__(1091);
	
	var _DateFilter2 = _interopRequireDefault(_DateFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DateFilter2.default;

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.AdvancedSearchTab = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(13);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ResultForm = __webpack_require__(361);
	
	var _ResultForm2 = _interopRequireDefault(_ResultForm);
	
	var _AdvancedSearchResults = __webpack_require__(630);
	
	var _AdvancedSearchResults2 = _interopRequireDefault(_AdvancedSearchResults);
	
	var _advancedSearchAction = __webpack_require__(178);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdvancedSearchTab = exports.AdvancedSearchTab = function (_Component) {
	  _inherits(AdvancedSearchTab, _Component);
	
	  function AdvancedSearchTab(props) {
	    _classCallCheck(this, AdvancedSearchTab);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  AdvancedSearchTab.prototype.componentDidMount = function componentDidMount() {
	    var _props = this.props,
	        tab = _props.tab,
	        courtType = _props.courtType,
	        queryParams = _props.queryParams,
	        history = _props.history,
	        onSetFormFilter = _props.onSetFormFilter;
	
	
	    onSetFormFilter({ courtType: courtType, tab: tab, queryParams: queryParams, history: history });
	  };
	
	  AdvancedSearchTab.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snapshot) {
	    var _props2 = this.props,
	        tab = _props2.tab,
	        courtType = _props2.courtType,
	        queryParams = _props2.queryParams,
	        history = _props2.history,
	        onSetFormFilter = _props2.onSetFormFilter;
	
	
	    if (tab !== prevProps.tab || courtType !== prevProps.courtType) {
	      onSetFormFilter({ courtType: courtType, tab: tab, queryParams: queryParams, history: history });
	    }
	  };
	
	  AdvancedSearchTab.prototype.render = function render() {
	    var _props3 = this.props,
	        filter = _props3.filter,
	        showResults = _props3.showResults,
	        onAdvancedSearch = _props3.onAdvancedSearch,
	        onReset = _props3.onReset,
	        InitialForm = _props3.InitialForm;
	
	
	    return showResults ? _react2.default.createElement(
	      'section',
	      { className: 'advanced-search-tab' },
	      _react2.default.createElement(_ResultForm2.default, {
	        filter: filter,
	        onSubmit: onAdvancedSearch,
	        onReset: onReset
	      }),
	      _react2.default.createElement(_AdvancedSearchResults2.default, null)
	    ) : _react2.default.createElement(
	      'section',
	      { className: 'advanced-search-tab' },
	      _react2.default.createElement(InitialForm, { filter: filter, onSubmit: onAdvancedSearch, onReset: onReset })
	    );
	  };
	
	  return AdvancedSearchTab;
	}(_react.Component);
	
	AdvancedSearchTab.propTypes = {
	  filter: _propTypes2.default.any,
	  onReset: _propTypes2.default.func.isRequired,
	  onAdvancedSearch: _propTypes2.default.func.isRequired
	};
	
	AdvancedSearchTab.defaultProps = {
	  filter: {}
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return _extends({}, state.get('advancedSearch').toJS());
	};
	
	var mapDispatchToProps = {
	  onReset: _advancedSearchAction.resetAdvancedSearch,
	  onAdvancedSearch: _advancedSearchAction.searchAdvancedFilings,
	  onSetFormFilter: _advancedSearchAction.setFormFilter
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AdvancedSearchTab);

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _AdvancedSearchHelper = __webpack_require__(79);
	
	var _AdvancedSearchHelper2 = _interopRequireDefault(_AdvancedSearchHelper);
	
	var _FieldSet = __webpack_require__(63);
	
	var _FieldSet2 = _interopRequireDefault(_FieldSet);
	
	var _formData = __webpack_require__(49);
	
	var _fields = __webpack_require__(53);
	
	__webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CasesForm = function CasesForm(_ref) {
	  var filter = _ref.filter,
	      onSubmit = _ref.onSubmit,
	      onReset = _ref.onReset;
	  return _react2.default.createElement(_reactFinalForm.Form, {
	    onSubmit: onSubmit,
	    initialValues: filter,
	    render: function render(_ref2) {
	      var handleSubmit = _ref2.handleSubmit,
	          form = _ref2.form;
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit, className: 'advanced-search-form' },
	        _react2.default.createElement(_fields.InputField, { placeholder: 'Enter case title, party name or case number' }),
	        _react2.default.createElement(_AdvancedSearchHelper2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'advanced-search-filters' },
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Advanced Filters' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.SearchPDFsField, { limitSelectOptions: _formData.limitSelectOptions, disabled: true })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.CasesField, { casefoldersSelectOptions: _formData.casefoldersSelectOptions })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Case Information' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.RegionField, { regionSelectOptions: _formData.regionSelectOptions })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.QueryField, { querySelectOptions: _formData.querySelectOptions, disabled: true })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.CaseTitlesField, { limitSelectOptions: _formData.limitSelectOptions })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.PartyNameField, { limitSelectOptions: _formData.limitSelectOptions })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Date Filters' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Cases filed'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_filed_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_filed_to', placeholderText: 'Through' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Cases closed'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_closed_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_closed_to', placeholderText: 'Through' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Cases dismissed'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_dismissed_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_dismissed_to', placeholderText: 'Through' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Cases discharged'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_discharged_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_discharged_to', placeholderText: 'Through' })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'action-btn-container' },
	          _react2.default.createElement(
	            'button',
	            { type: 'submit', className: 'btn btn-success btn-search' },
	            'Search'
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: 'btn btn-link',
	              onClick: function onClick() {
	                form.reset();
	                onReset();
	              }
	            },
	            'Clear'
	          )
	        )
	      );
	    }
	  });
	};
	
	CasesForm.propTypes = {
	  filter: _propTypes2.default.any.isRequired,
	  onSubmit: _propTypes2.default.func.isRequired,
	  onReset: _propTypes2.default.func.isRequired
	};
	
	exports.default = CasesForm;

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _AdvancedSearchHelper = __webpack_require__(79);
	
	var _AdvancedSearchHelper2 = _interopRequireDefault(_AdvancedSearchHelper);
	
	var _FieldSet = __webpack_require__(63);
	
	var _FieldSet2 = _interopRequireDefault(_FieldSet);
	
	var _formData = __webpack_require__(49);
	
	var _fields = __webpack_require__(53);
	
	__webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GeneralForm = function GeneralForm(_ref) {
	  var filter = _ref.filter,
	      onSubmit = _ref.onSubmit,
	      onReset = _ref.onReset;
	  return _react2.default.createElement(_reactFinalForm.Form, {
	    onSubmit: onSubmit,
	    initialValues: filter,
	    render: function render(_ref2) {
	      var handleSubmit = _ref2.handleSubmit,
	          form = _ref2.form;
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit, className: 'advanced-search-form' },
	        _react2.default.createElement(_fields.InputField, { placeholder: 'Enter Keywords' }),
	        _react2.default.createElement(_AdvancedSearchHelper2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'advanced-search-filters' },
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Advanced Filters' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.SearchPDFsField, { limitSelectOptions: _formData.limitSelectOptions })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.CasesField, { casefoldersSelectOptions: _formData.casefoldersSelectOptions })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Case Information' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.RegionField, { regionSelectOptions: _formData.regionSelectOptions })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.QueryField, { querySelectOptions: _formData.querySelectOptions })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.CaseTitlesField, { limitSelectOptions: _formData.limitSelectOptions })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Date Filters' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Cases filed'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_filed_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_filed_to', placeholderText: 'Through' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Cases closed'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_closed_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_closed_to', placeholderText: 'Through' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Cases dismissed'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_dismissed_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_dismissed_to', placeholderText: 'Through' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Cases discharged'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_discharged_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_discharged_to', placeholderText: 'Through' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Documents filed'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_doc_filed_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_doc_filed_to', placeholderText: 'Through' })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'action-btn-container' },
	          _react2.default.createElement(
	            'button',
	            { type: 'submit', className: 'btn btn-success btn-search' },
	            'Search'
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: 'btn btn-link',
	              onClick: function onClick() {
	                form.reset();
	                onReset();
	              }
	            },
	            'Clear'
	          )
	        )
	      );
	    }
	  });
	};
	
	GeneralForm.propTypes = {
	  filter: _propTypes2.default.any.isRequired,
	  onSubmit: _propTypes2.default.func.isRequired,
	  onReset: _propTypes2.default.func.isRequired
	};
	
	exports.default = GeneralForm;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _AdvancedSearchHelper = __webpack_require__(79);
	
	var _AdvancedSearchHelper2 = _interopRequireDefault(_AdvancedSearchHelper);
	
	var _formData = __webpack_require__(49);
	
	var _FieldSet = __webpack_require__(63);
	
	var _FieldSet2 = _interopRequireDefault(_FieldSet);
	
	var _fields = __webpack_require__(53);
	
	__webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SchedulesForm = function SchedulesForm(_ref) {
	  var filter = _ref.filter,
	      onSubmit = _ref.onSubmit,
	      onReset = _ref.onReset;
	  return _react2.default.createElement(_reactFinalForm.Form, {
	    onSubmit: onSubmit,
	    initialValues: filter,
	    render: function render(_ref2) {
	      var handleSubmit = _ref2.handleSubmit,
	          form = _ref2.form,
	          values = _ref2.values;
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit, className: 'advanced-search-form' },
	        _react2.default.createElement(_fields.InputField, { placeholder: 'Enter Keywords' }),
	        _react2.default.createElement(_AdvancedSearchHelper2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'advanced-search-filters' },
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Advanced Filters' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.SearchPDFsField, { limitSelectOptions: _formData.limitSelectOptions })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.CasesField, { casefoldersSelectOptions: _formData.casefoldersSelectOptions })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Case Information' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.RegionField, { regionSelectOptions: _formData.regionSelectOptions })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.QueryField, { querySelectOptions: _formData.querySelectOptions, disabled: true })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.ChapterField, { chapterSelectOptions: _formData.chapterSelectOptions })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.TypeField, { caseTypeSelectOptions: _formData.caseTypeSelectOptions })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.CaseTitlesField, { limitSelectOptions: _formData.limitSelectOptions })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Financial Filters' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.BusinessOnlyField, { limitSelectOptions: _formData.limitSelectOptions, disabled: true })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.IndustryField, { industrySelectOptions: _formData.industrySelectOptions })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.AssetsField, { assetsLiabilitiesSelectOptions: _formData.assetsLiabilitiesSelectOptions })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.LiabilitiesField, { assetsLiabilitiesSelectOptions: _formData.assetsLiabilitiesSelectOptions })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Schedules Filters' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                _reactFinalForm.Field,
	                { name: 'schedule', parse: function parse(_ref3) {
	                    var value = _ref3.value;
	                    return value;
	                  } },
	                function (_ref4) {
	                  var input = _ref4.input;
	                  return _react2.default.createElement(
	                    'div',
	                    { className: 'col-2' },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      'Schedule'
	                    ),
	                    _react2.default.createElement(_reactSelect2.default, _extends({}, input, { clearable: false, options: _formData.scheduleSelectOptions, className: 'form-select' }))
	                  );
	                }
	              ),
	              _react2.default.createElement(
	                _reactFinalForm.Field,
	                { name: 'schedule_category', parse: function parse(_ref5) {
	                    var value = _ref5.value;
	                    return value;
	                  } },
	                function (_ref6) {
	                  var input = _ref6.input;
	                  return _react2.default.createElement(
	                    'div',
	                    { className: 'col-2' },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      'Category'
	                    ),
	                    _react2.default.createElement(_reactSelect2.default, _extends({}, input, {
	                      clearable: false,
	                      options: _formData.scheduleCategorySelectOptions,
	                      className: 'form-select',
	                      disabled: values.schedule !== 'schedule_ab'
	                    }))
	                  );
	                }
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  'From'
	                ),
	                _react2.default.createElement(_reactFinalForm.Field, {
	                  name: 'schedule_value_from',
	                  component: 'input',
	                  type: 'text',
	                  className: 'form-input',
	                  placeholder: '$'
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  'To'
	                ),
	                _react2.default.createElement(_reactFinalForm.Field, { name: 'schedule_value_to', component: 'input', type: 'text', className: 'form-input', placeholder: '$' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Date Filters' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Cases filed'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_filed_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_filed_to', placeholderText: 'Through' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Open cases'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'open_cases_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'open_cases_to', placeholderText: 'Through' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Documents filed'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_doc_filed_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_doc_filed_to', placeholderText: 'Through' })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'action-btn-container' },
	          _react2.default.createElement(
	            'button',
	            { type: 'submit', className: 'btn btn-success btn-search' },
	            'Search'
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: 'btn btn-link',
	              onClick: function onClick() {
	                form.reset();
	                onReset();
	              }
	            },
	            'Clear'
	          )
	        )
	      );
	    }
	  });
	};
	
	SchedulesForm.propTypes = {
	  filter: _propTypes2.default.any.isRequired,
	  onSubmit: _propTypes2.default.func.isRequired,
	  onReset: _propTypes2.default.func.isRequired
	};
	
	exports.default = SchedulesForm;

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CasesForm = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _districtNosOptions = __webpack_require__(207);
	
	var _districtNosOptions2 = _interopRequireDefault(_districtNosOptions);
	
	var _AdvancedSearchHelper = __webpack_require__(79);
	
	var _AdvancedSearchHelper2 = _interopRequireDefault(_AdvancedSearchHelper);
	
	var _formData = __webpack_require__(49);
	
	var _FieldSet = __webpack_require__(63);
	
	var _FieldSet2 = _interopRequireDefault(_FieldSet);
	
	var _fields = __webpack_require__(53);
	
	__webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CasesForm = exports.CasesForm = function CasesForm(_ref) {
	  var filter = _ref.filter,
	      onSubmit = _ref.onSubmit,
	      onReset = _ref.onReset;
	  return _react2.default.createElement(_reactFinalForm.Form, {
	    onSubmit: onSubmit,
	    initialValues: filter,
	    render: function render(_ref2) {
	      var handleSubmit = _ref2.handleSubmit,
	          form = _ref2.form;
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit, className: 'advanced-search-form' },
	        _react2.default.createElement(_fields.InputField, { placeholder: 'Enter case title, party name or case number' }),
	        _react2.default.createElement(_AdvancedSearchHelper2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'advanced-search-filters' },
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Advanced Filters' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.SearchPDFsField, { limitSelectOptions: _formData.limitSelectOptions, disabled: true })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.CasesField, { casefoldersSelectOptions: _formData.casefoldersSelectOptions })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Case Information' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.RegionField, { regionSelectOptions: _formData.regionSelectOptions })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.QueryField, { querySelectOptions: _formData.querySelectOptions, disabled: true })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { style: { width: '100%' } },
	                _react2.default.createElement(_fields.NatureOfSuit, { districtNosOptions: _districtNosOptions2.default })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.CaseTitlesField, { limitSelectOptions: _formData.limitSelectOptions })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.PartyNameField, { limitSelectOptions: _formData.limitSelectOptions })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Date Filters' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Cases filed'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_filed_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_filed_to', placeholderText: 'Through' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Cases closed'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_closed_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_closed_to', placeholderText: 'Through' })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'action-btn-container' },
	          _react2.default.createElement(
	            'button',
	            { type: 'submit', className: 'btn btn-success btn-search' },
	            'Search'
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: 'btn btn-link',
	              onClick: function onClick() {
	                form.reset();
	                onReset();
	              }
	            },
	            'Clear'
	          )
	        )
	      );
	    }
	  });
	};
	
	CasesForm.propTypes = {
	  filter: _propTypes2.default.any.isRequired,
	  onSubmit: _propTypes2.default.func.isRequired,
	  onReset: _propTypes2.default.func.isRequired
	};
	
	exports.default = CasesForm;

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _districtNosOptions = __webpack_require__(207);
	
	var _districtNosOptions2 = _interopRequireDefault(_districtNosOptions);
	
	var _formData = __webpack_require__(49);
	
	var _FieldSet = __webpack_require__(63);
	
	var _FieldSet2 = _interopRequireDefault(_FieldSet);
	
	var _AdvancedSearchHelper = __webpack_require__(79);
	
	var _AdvancedSearchHelper2 = _interopRequireDefault(_AdvancedSearchHelper);
	
	var _fields = __webpack_require__(53);
	
	__webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GeneralForm = function GeneralForm(_ref) {
	  var filter = _ref.filter,
	      onSubmit = _ref.onSubmit,
	      onReset = _ref.onReset;
	  return _react2.default.createElement(_reactFinalForm.Form, {
	    onSubmit: onSubmit,
	    initialValues: filter,
	    render: function render(_ref2) {
	      var handleSubmit = _ref2.handleSubmit,
	          form = _ref2.form;
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit, className: 'advanced-search-form' },
	        _react2.default.createElement(_fields.InputField, { placeholder: 'Enter Keywords' }),
	        _react2.default.createElement(_AdvancedSearchHelper2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'advanced-search-filters' },
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Advanced Filters' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.SearchPDFsField, { limitSelectOptions: _formData.limitSelectOptions })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.CasesField, { casefoldersSelectOptions: _formData.casefoldersSelectOptions })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Case Information' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.RegionField, { regionSelectOptions: _formData.regionSelectOptions })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.QueryField, { querySelectOptions: _formData.querySelectOptions })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { style: { width: '100%' } },
	                _react2.default.createElement(_fields.NatureOfSuit, { districtNosOptions: _districtNosOptions2.default })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.CaseTitlesField, { limitSelectOptions: _formData.limitSelectOptions })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Date Filters' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Cases filed'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_filed_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_filed_to', placeholderText: 'Through' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Cases closed'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_closed_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_closed_to', placeholderText: 'Through' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Documents filed'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_doc_filed_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_doc_filed_to', placeholderText: 'Through' })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'action-btn-container' },
	          _react2.default.createElement(
	            'button',
	            { type: 'submit', className: 'btn btn-success btn-search' },
	            'Search'
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: 'btn btn-link',
	              onClick: function onClick() {
	                form.reset();
	                onReset();
	              }
	            },
	            'Clear'
	          )
	        )
	      );
	    }
	  });
	};
	
	GeneralForm.propTypes = {
	  filter: _propTypes2.default.any.isRequired,
	  onSubmit: _propTypes2.default.func.isRequired,
	  onReset: _propTypes2.default.func.isRequired
	};
	
	exports.default = GeneralForm;

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CasesForm = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _AdvancedSearchHelper = __webpack_require__(79);
	
	var _AdvancedSearchHelper2 = _interopRequireDefault(_AdvancedSearchHelper);
	
	var _formData = __webpack_require__(49);
	
	var _FieldSet = __webpack_require__(63);
	
	var _FieldSet2 = _interopRequireDefault(_FieldSet);
	
	var _fields = __webpack_require__(53);
	
	__webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CasesForm = exports.CasesForm = function CasesForm(_ref) {
	  var filter = _ref.filter,
	      onSubmit = _ref.onSubmit,
	      onReset = _ref.onReset;
	  return _react2.default.createElement(_reactFinalForm.Form, {
	    onSubmit: onSubmit,
	    initialValues: filter,
	    render: function render(_ref2) {
	      var handleSubmit = _ref2.handleSubmit,
	          form = _ref2.form;
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit, className: 'advanced-search-form' },
	        _react2.default.createElement(_fields.InputField, { placeholder: 'Enter case title, party name or case number' }),
	        _react2.default.createElement(_AdvancedSearchHelper2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'advanced-search-filters' },
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Advanced Filters' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.SearchPDFsField, { limitSelectOptions: _formData.limitSelectOptions, disabled: true })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.CasesField, { casefoldersSelectOptions: _formData.casefoldersSelectOptions })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Case Information' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.RegionField, { regionSelectOptions: _formData.regionSelectOptions })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.QueryField, { querySelectOptions: _formData.querySelectOptions, disabled: true })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.CaseTitlesField, { limitSelectOptions: _formData.limitSelectOptions })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.PartyNameField, { limitSelectOptions: _formData.limitSelectOptions })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Date Filters' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Cases filed'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_filed_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_filed_to', placeholderText: 'Through' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Cases closed'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_closed_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_closed_to', placeholderText: 'Through' })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'action-btn-container' },
	          _react2.default.createElement(
	            'button',
	            { type: 'submit', className: 'btn btn-success btn-search' },
	            'Search'
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: 'btn btn-link',
	              onClick: function onClick() {
	                form.reset();
	                onReset();
	              }
	            },
	            'Clear'
	          )
	        )
	      );
	    }
	  });
	};
	
	CasesForm.propTypes = {
	  filter: _propTypes2.default.any.isRequired,
	  onSubmit: _propTypes2.default.func.isRequired,
	  onReset: _propTypes2.default.func.isRequired
	};
	
	exports.default = CasesForm;

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _AdvancedSearchHelper = __webpack_require__(79);
	
	var _AdvancedSearchHelper2 = _interopRequireDefault(_AdvancedSearchHelper);
	
	var _formData = __webpack_require__(49);
	
	var _FieldSet = __webpack_require__(63);
	
	var _FieldSet2 = _interopRequireDefault(_FieldSet);
	
	var _fields = __webpack_require__(53);
	
	__webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GeneralForm = function GeneralForm(_ref) {
	  var filter = _ref.filter,
	      onSubmit = _ref.onSubmit,
	      onReset = _ref.onReset;
	  return _react2.default.createElement(_reactFinalForm.Form, {
	    onSubmit: onSubmit,
	    initialValues: filter,
	    render: function render(_ref2) {
	      var handleSubmit = _ref2.handleSubmit,
	          form = _ref2.form;
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit, className: 'advanced-search-form' },
	        _react2.default.createElement(_fields.InputField, { placeholder: 'Enter Keywords' }),
	        _react2.default.createElement(_AdvancedSearchHelper2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'advanced-search-filters' },
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Advanced Filters' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.SearchPDFsField, { limitSelectOptions: _formData.limitSelectOptions })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.CasesField, { casefoldersSelectOptions: _formData.casefoldersSelectOptions })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Case Information' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.RegionField, { regionSelectOptions: _formData.regionSelectOptions })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.QueryField, { querySelectOptions: _formData.querySelectOptions })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item form-item-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement(_fields.CaseTitlesField, { limitSelectOptions: _formData.limitSelectOptions })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldSet2.default,
	            { title: 'Date Filters' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Cases filed'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_filed_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_filed_to', placeholderText: 'Through' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Cases closed'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_closed_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_closed_to', placeholderText: 'Through' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-item' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Documents filed'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-item-row' },
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_doc_filed_from', placeholderText: 'From' }),
	                _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_doc_filed_to', placeholderText: 'Through' })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'action-btn-container' },
	          _react2.default.createElement(
	            'button',
	            { type: 'submit', className: 'btn btn-success btn-search' },
	            'Search'
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: 'btn btn-link',
	              onClick: function onClick() {
	                form.reset();
	                onReset();
	              }
	            },
	            'Clear'
	          )
	        )
	      );
	    }
	  });
	};
	
	GeneralForm.propTypes = {
	  filter: _propTypes2.default.any.isRequired,
	  onSubmit: _propTypes2.default.func.isRequired,
	  onReset: _propTypes2.default.func.isRequired
	};
	
	exports.default = GeneralForm;

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _formData = __webpack_require__(49);
	
	var _fields = __webpack_require__(53);
	
	__webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdvancedFilterModal = function AdvancedFilterModal(_ref) {
	  var onSave = _ref.onSave,
	      show = _ref.show,
	      onClose = _ref.onClose,
	      filter = _ref.filter;
	  return _react2.default.createElement(
	    _reactBootstrap.Modal,
	    {
	      show: show,
	      onHide: onClose
	      // backdrop="static"
	      // keyboard={false}
	      , dialogClassName: 'advanced-search-modal'
	    },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactFinalForm.Form, {
	        onSubmit: onSave,
	        initialValues: filter,
	        render: function render(_ref2) {
	          var handleSubmit = _ref2.handleSubmit;
	          return _react2.default.createElement(
	            'form',
	            { onSubmit: handleSubmit },
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Header,
	              { closeButton: true },
	              _react2.default.createElement(
	                _reactBootstrap.Modal.Title,
	                null,
	                'Advanced Filters'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Body,
	              null,
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_fields.SearchPDFsField, {
	                  limitSelectOptions: _formData.limitSelectOptions,
	                  disabled: ['cases', 'petitions'].includes(filter.tab)
	                }),
	                _react2.default.createElement(_fields.CasesField, { casefoldersSelectOptions: _formData.casefoldersSelectOptions })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Footer,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { onClick: onClose },
	                'Cancel'
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { bsStyle: 'primary', type: 'submit' },
	                'Apply'
	              )
	            )
	          );
	        }
	      })
	    )
	  );
	};
	
	AdvancedFilterModal.propTypes = {
	  onSave: _propTypes2.default.func.isRequired,
	  onClose: _propTypes2.default.func.isRequired,
	  show: _propTypes2.default.bool,
	  filter: _propTypes2.default.object.isRequired
	};
	
	AdvancedFilterModal.defaultProps = {
	  show: false
	};
	
	exports.default = AdvancedFilterModal;

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _formData = __webpack_require__(49);
	
	__webpack_require__(52);
	
	var _districtNosOptions = __webpack_require__(207);
	
	var _districtNosOptions2 = _interopRequireDefault(_districtNosOptions);
	
	var _fields = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CaseFilterModal = function CaseFilterModal(_ref) {
	  var onSave = _ref.onSave,
	      show = _ref.show,
	      onClose = _ref.onClose,
	      filter = _ref.filter;
	  return _react2.default.createElement(
	    _reactBootstrap.Modal,
	    { show: show, onHide: onClose, backdrop: 'static', keyboard: false, dialogClassName: 'advanced-search-modal' },
	    _react2.default.createElement(
	      'div',
	      { className: 'filings-page' },
	      _react2.default.createElement(_reactFinalForm.Form, {
	        onSubmit: onSave,
	        initialValues: filter,
	        render: function render(_ref2) {
	          var handleSubmit = _ref2.handleSubmit;
	          return _react2.default.createElement(
	            'form',
	            { onSubmit: handleSubmit },
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Header,
	              { closeButton: true },
	              _react2.default.createElement(
	                _reactBootstrap.Modal.Title,
	                null,
	                'Case Information'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Body,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'advanced-search-form' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-item form-item-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-2' },
	                    _react2.default.createElement(_fields.RegionField, { regionSelectOptions: _formData.regionSelectOptions })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-2' },
	                    _react2.default.createElement(_fields.QueryField, {
	                      querySelectOptions: _formData.querySelectOptions,
	                      disabled: ['cases', 'petitions', 'schedules'].includes(filter.tab)
	                    })
	                  )
	                ),
	                filter.court_type === 'bankruptcy' && _react2.default.createElement(
	                  'div',
	                  { className: 'form-item form-item-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-2' },
	                    _react2.default.createElement(_fields.ChapterField, { chapterSelectOptions: _formData.chapterSelectOptions })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-2' },
	                    _react2.default.createElement(_fields.TypeField, { caseTypeSelectOptions: _formData.caseTypeSelectOptions })
	                  )
	                ),
	                filter.court_type === 'civil' && _react2.default.createElement(
	                  'div',
	                  { className: 'form-item form-item-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { style: { width: '100%' } },
	                    _react2.default.createElement(_fields.NatureOfSuit, { districtNosOptions: _districtNosOptions2.default })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-item form-item-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-2' },
	                    _react2.default.createElement(_fields.CaseTitlesField, { limitSelectOptions: _formData.limitSelectOptions, disabled: filter.tab === 'petitions' })
	                  ),
	                  filter.tab === 'cases' && _react2.default.createElement(
	                    'div',
	                    { className: 'col-2' },
	                    _react2.default.createElement(_fields.PartyNameField, { limitSelectOptions: _formData.limitSelectOptions })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Footer,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { onClick: onClose },
	                'Cancel'
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { bsStyle: 'primary', type: 'submit' },
	                'Apply'
	              )
	            )
	          );
	        }
	      })
	    )
	  );
	};
	
	CaseFilterModal.propTypes = {
	  onSave: _propTypes2.default.func.isRequired,
	  onClose: _propTypes2.default.func.isRequired,
	  show: _propTypes2.default.bool,
	  filter: _propTypes2.default.object.isRequired
	};
	
	CaseFilterModal.defaultProps = {
	  show: false
	};
	
	exports.default = CaseFilterModal;

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _fields = __webpack_require__(53);
	
	var _globalUtils = __webpack_require__(59);
	
	__webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DateFilterModal = function DateFilterModal(_ref) {
	  var onSave = _ref.onSave,
	      show = _ref.show,
	      onClose = _ref.onClose,
	      filter = _ref.filter;
	  var tab = filter.tab,
	      court_type = filter.court_type;
	
	  var visible = {
	    date_closed: !['schedules', 'petitions'].includes(tab),
	    date_dismissed: !['schedules', 'petitions'].includes(tab) && !['civil', 'criminal'].includes(court_type),
	    date_discharged: !['schedules', 'petitions'].includes(tab) && !['civil', 'criminal'].includes(court_type),
	    date_doc_filed: !['cases', 'petitions'].includes(tab),
	    open_cases: !(0, _globalUtils.isCourtDrive)() && ['petitions', 'schedules'].includes(tab) && court_type === 'bankruptcy'
	  };
	
	  return _react2.default.createElement(
	    _reactBootstrap.Modal,
	    { show: show, onHide: onClose, backdrop: 'static', keyboard: false, dialogClassName: 'advanced-search-modal' },
	    _react2.default.createElement(
	      'div',
	      { className: 'filings-page' },
	      _react2.default.createElement(_reactFinalForm.Form, {
	        onSubmit: onSave,
	        initialValues: filter,
	        render: function render(_ref2) {
	          var handleSubmit = _ref2.handleSubmit;
	          return _react2.default.createElement(
	            'form',
	            { onSubmit: handleSubmit },
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Header,
	              { closeButton: true },
	              _react2.default.createElement(
	                _reactBootstrap.Modal.Title,
	                null,
	                'Date Filters'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Body,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'advanced-search-form' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-item' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'Cases filed'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-item-row' },
	                    _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_filed_from', placeholderText: 'From' }),
	                    _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_filed_to', placeholderText: 'Through' })
	                  )
	                ),
	                visible.open_cases && _react2.default.createElement(
	                  'div',
	                  { className: 'form-item' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'Open cases'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-item-row' },
	                    _react2.default.createElement(_fields.DatePickerField, { fieldName: 'open_cases_from', placeholderText: 'From' }),
	                    _react2.default.createElement(_fields.DatePickerField, { fieldName: 'open_cases_to', placeholderText: 'Through' })
	                  )
	                ),
	                visible.date_closed && _react2.default.createElement(
	                  'div',
	                  { className: 'form-item' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'Cases closed'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-item-row' },
	                    _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_closed_from', placeholderText: 'From' }),
	                    _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_closed_to', placeholderText: 'Through' })
	                  )
	                ),
	                visible.date_dismissed && _react2.default.createElement(
	                  'div',
	                  { className: 'form-item' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'Cases dismissed'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-item-row' },
	                    _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_dismissed_from', placeholderText: 'From' }),
	                    _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_dismissed_to', placeholderText: 'Through' })
	                  )
	                ),
	                visible.date_discharged && _react2.default.createElement(
	                  'div',
	                  { className: 'form-item' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'Cases discharged'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-item-row' },
	                    _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_discharged_from', placeholderText: 'From' }),
	                    _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_discharged_to', placeholderText: 'Through' })
	                  )
	                ),
	                visible.date_doc_filed && _react2.default.createElement(
	                  'div',
	                  { className: 'form-item' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'Documents filed'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-item-row' },
	                    _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_doc_filed_from', placeholderText: 'From' }),
	                    _react2.default.createElement(_fields.DatePickerField, { fieldName: 'date_doc_filed_to', placeholderText: 'Through' })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Footer,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { onClick: onClose },
	                'Cancel'
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { bsStyle: 'primary', type: 'submit' },
	                'Apply'
	              )
	            )
	          );
	        }
	      })
	    )
	  );
	};
	
	DateFilterModal.propTypes = {
	  onSave: _propTypes2.default.func.isRequired,
	  onClose: _propTypes2.default.func.isRequired,
	  show: _propTypes2.default.bool,
	  filter: _propTypes2.default.object.isRequired
	};
	
	DateFilterModal.defaultProps = {
	  show: false
	};
	
	exports.default = DateFilterModal;

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _formData = __webpack_require__(49);
	
	__webpack_require__(52);
	
	var _fields = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FinancialFilterModal = function FinancialFilterModal(_ref) {
	  var onSave = _ref.onSave,
	      show = _ref.show,
	      onClose = _ref.onClose,
	      filter = _ref.filter;
	  return _react2.default.createElement(
	    _reactBootstrap.Modal,
	    {
	      show: show,
	      onHide: onClose
	      // backdrop="static"
	      // keyboard={false}
	      , dialogClassName: 'advanced-search-modal'
	    },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactFinalForm.Form, {
	        onSubmit: onSave,
	        initialValues: filter,
	        render: function render(_ref2) {
	          var handleSubmit = _ref2.handleSubmit;
	          return _react2.default.createElement(
	            'form',
	            { onSubmit: handleSubmit },
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Header,
	              { closeButton: true },
	              _react2.default.createElement(
	                _reactBootstrap.Modal.Title,
	                null,
	                'Financial Filters'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Body,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'advanced-search-form' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-item form-item-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-2' },
	                    _react2.default.createElement(_fields.BusinessOnlyField, {
	                      limitSelectOptions: _formData.limitSelectOptions,
	                      disabled: ['petitions', 'schedules'].includes(filter.tab)
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-2' },
	                    _react2.default.createElement(_fields.IndustryField, { industrySelectOptions: _formData.industrySelectOptions })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-item form-item-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-2' },
	                    _react2.default.createElement(_fields.AssetsField, { assetsLiabilitiesSelectOptions: _formData.assetsLiabilitiesSelectOptions })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-2' },
	                    _react2.default.createElement(_fields.LiabilitiesField, { assetsLiabilitiesSelectOptions: _formData.assetsLiabilitiesSelectOptions })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Footer,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { onClick: onClose },
	                'Cancel'
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { bsStyle: 'primary', type: 'submit' },
	                'Apply'
	              )
	            )
	          );
	        }
	      })
	    )
	  );
	};
	
	FinancialFilterModal.propTypes = {
	  onSave: _propTypes2.default.func.isRequired,
	  onClose: _propTypes2.default.func.isRequired,
	  show: _propTypes2.default.bool,
	  filter: _propTypes2.default.object.isRequired
	};
	
	FinancialFilterModal.defaultProps = {
	  show: false
	};
	
	exports.default = FinancialFilterModal;

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _HelperPopover = __webpack_require__(1108);
	
	var _HelperPopover2 = _interopRequireDefault(_HelperPopover);
	
	var _AdvancedFilterModal = __webpack_require__(357);
	
	var _AdvancedFilterModal2 = _interopRequireDefault(_AdvancedFilterModal);
	
	var _CaseFilterModal = __webpack_require__(358);
	
	var _CaseFilterModal2 = _interopRequireDefault(_CaseFilterModal);
	
	var _DateFilterModal = __webpack_require__(359);
	
	var _DateFilterModal2 = _interopRequireDefault(_DateFilterModal);
	
	var _FinancialFilterModal = __webpack_require__(360);
	
	var _FinancialFilterModal2 = _interopRequireDefault(_FinancialFilterModal);
	
	var _ScheduleFilterModal = __webpack_require__(362);
	
	var _ScheduleFilterModal2 = _interopRequireDefault(_ScheduleFilterModal);
	
	__webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResultForm = function ResultForm(_ref) {
	  var onSubmit = _ref.onSubmit,
	      filter = _ref.filter,
	      onReset = _ref.onReset;
	
	  var _useState = (0, _react.useState)(false),
	      isAdvancedFilterModalOpen = _useState[0],
	      setIsAdvancedFilterModal = _useState[1];
	
	  var _useState2 = (0, _react.useState)(false),
	      isCaseFilterModalOpen = _useState2[0],
	      setIsCaseFilterModal = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      isDateFilterModalOpen = _useState3[0],
	      setIsDateFilterModal = _useState3[1];
	
	  var _useState4 = (0, _react.useState)(false),
	      isFinancialFilterModalOpen = _useState4[0],
	      setIsFinancialFilterModal = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      isScheduleFilterModalOpen = _useState5[0],
	      setIsScheduleFilterModal = _useState5[1];
	
	  var handleSubmitClick = function handleSubmitClick(values) {
	    onSubmit(_extends({}, values, { page: 0 }));
	  };
	
	  var countSubFilter = function countSubFilter() {
	    var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    return fields.filter(function (key) {
	      return !(!filter[key] || filter[key] && filter[key].length === 0);
	    }).length;
	  };
	
	  var caseCounter = countSubFilter(['court_code', 'query', 'chapter', 'case_type', 'nature_of_suit']) + 1;
	  var financialCounter = countSubFilter(['industry', 'assets', 'liabilities']) + 1;
	  var scheduleCounter = countSubFilter(['schedule', 'schedule_category', 'schedule_value_from', 'schedule_value_to']);
	  var dateCounter = countSubFilter(['date_filed_from', 'date_filed_to', 'date_closed_from', 'date_closed_to', 'date_dismissed_from', 'date_dismissed_to', 'date_discharged_from', 'date_discharged_to', 'date_doc_filed_from', 'date_doc_filed_to', 'open_cases_from', 'open_cases_to']);
	
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(_reactFinalForm.Form, {
	      onSubmit: handleSubmitClick,
	      initialValues: filter,
	      render: function render(_ref2) {
	        var handleSubmit = _ref2.handleSubmit,
	            form = _ref2.form;
	        return _react2.default.createElement(
	          'form',
	          { onSubmit: handleSubmit, className: 'advanced-search-form' },
	          _react2.default.createElement(
	            'div',
	            { className: 'form-item form-item-btn' },
	            _react2.default.createElement(
	              _HelperPopover2.default,
	              null,
	              _react2.default.createElement(_reactFinalForm.Field, {
	                name: 'keys',
	                component: 'input',
	                type: 'text',
	                placeholder: filter.tab === 'cases' ? 'Enter case title, party name or case number' : 'Enter Keywords',
	                className: 'form-input keys'
	              })
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'submit',
	                className: 'btn btn-success btn-search btn-blink',
	                key: filter.tab // setting the key will re-render the button on tab change and show the animation
	              },
	              'Search'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'action-btn-container' },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { bsStyle: 'primary', onClick: function onClick() {
	                  return setIsAdvancedFilterModal(true);
	                } },
	              'Advanced Filters ',
	              _react2.default.createElement(
	                _reactBootstrap.Badge,
	                null,
	                '2'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { bsStyle: 'primary', onClick: function onClick() {
	                  return setIsCaseFilterModal(true);
	                } },
	              'Case ',
	              _react2.default.createElement(
	                _reactBootstrap.Badge,
	                null,
	                caseCounter
	              )
	            ),
	            filter.court_type === 'bankruptcy' && _react2.default.createElement(
	              _reactBootstrap.Button,
	              { bsStyle: 'primary', onClick: function onClick() {
	                  return setIsFinancialFilterModal(true);
	                } },
	              'Financial ',
	              _react2.default.createElement(
	                _reactBootstrap.Badge,
	                null,
	                financialCounter
	              )
	            ),
	            filter.tab === 'schedules' && _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: scheduleCounter > 0 ? 'primary' : 'default',
	                onClick: function onClick() {
	                  return setIsScheduleFilterModal(true);
	                }
	              },
	              'Schedule ',
	              scheduleCounter > 0 && _react2.default.createElement(
	                _reactBootstrap.Badge,
	                null,
	                scheduleCounter
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { bsStyle: dateCounter > 0 ? 'primary' : 'default', onClick: function onClick() {
	                  return setIsDateFilterModal(true);
	                } },
	              'Date ',
	              dateCounter > 0 && _react2.default.createElement(
	                _reactBootstrap.Badge,
	                null,
	                dateCounter
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-link pull-right',
	                onClick: function onClick() {
	                  form.reset();
	                  onReset();
	                }
	              },
	              'Start Over'
	            )
	          )
	        );
	      }
	    }),
	    isAdvancedFilterModalOpen && _react2.default.createElement(_AdvancedFilterModal2.default, {
	      show: isAdvancedFilterModalOpen,
	      onClose: function onClose() {
	        return setIsAdvancedFilterModal(false);
	      },
	      onSave: function onSave(values) {
	        onSubmit(values);
	        setIsAdvancedFilterModal(false);
	      },
	      filter: filter
	    }),
	    isCaseFilterModalOpen && _react2.default.createElement(_CaseFilterModal2.default, {
	      show: isCaseFilterModalOpen,
	      onClose: function onClose() {
	        return setIsCaseFilterModal(false);
	      },
	      onSave: function onSave(values) {
	        onSubmit(values);
	        setIsCaseFilterModal(false);
	      },
	      filter: filter
	    }),
	    isDateFilterModalOpen && _react2.default.createElement(_DateFilterModal2.default, {
	      show: isDateFilterModalOpen,
	      onClose: function onClose() {
	        return setIsDateFilterModal(false);
	      },
	      onSave: function onSave(values) {
	        onSubmit(values);
	        setIsDateFilterModal(false);
	      },
	      filter: filter
	    }),
	    isFinancialFilterModalOpen && filter.court_type === 'bankruptcy' && _react2.default.createElement(_FinancialFilterModal2.default, {
	      show: isFinancialFilterModalOpen,
	      onClose: function onClose() {
	        return setIsFinancialFilterModal(false);
	      },
	      onSave: function onSave(values) {
	        onSubmit(values);
	        setIsFinancialFilterModal(false);
	      },
	      filter: filter
	    }),
	    isScheduleFilterModalOpen && filter.tab === 'schedules' && _react2.default.createElement(_ScheduleFilterModal2.default, {
	      show: isScheduleFilterModalOpen,
	      onClose: function onClose() {
	        return setIsScheduleFilterModal(false);
	      },
	      onSave: function onSave(values) {
	        onSubmit(values);
	        setIsScheduleFilterModal(false);
	      },
	      filter: filter
	    })
	  );
	};
	
	ResultForm.propTypes = {
	  filter: _propTypes2.default.object.isRequired,
	  onSubmit: _propTypes2.default.func.isRequired,
	  onReset: _propTypes2.default.func.isRequired
	};
	
	exports.default = ResultForm;

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _formData = __webpack_require__(49);
	
	__webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScheduleFilterModal = function ScheduleFilterModal(_ref) {
	  var onSave = _ref.onSave,
	      show = _ref.show,
	      onClose = _ref.onClose,
	      filter = _ref.filter;
	  return _react2.default.createElement(
	    _reactBootstrap.Modal,
	    { show: show, onHide: onClose, dialogClassName: 'advanced-search-modal' },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactFinalForm.Form, {
	        onSubmit: onSave,
	        initialValues: filter,
	        render: function render(_ref2) {
	          var handleSubmit = _ref2.handleSubmit,
	              values = _ref2.values;
	          return _react2.default.createElement(
	            'form',
	            { onSubmit: handleSubmit },
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Header,
	              { closeButton: true },
	              _react2.default.createElement(
	                _reactBootstrap.Modal.Title,
	                null,
	                'Schedules Filters'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Body,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'advanced-search-form' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-item form-item-row' },
	                  _react2.default.createElement(
	                    _reactFinalForm.Field,
	                    { name: 'schedule', parse: function parse(_ref3) {
	                        var value = _ref3.value;
	                        return value;
	                      } },
	                    function (_ref4) {
	                      var input = _ref4.input;
	                      return _react2.default.createElement(
	                        'div',
	                        { className: 'col-2' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Schedule'
	                        ),
	                        _react2.default.createElement(_reactSelect2.default, _extends({}, input, { clearable: false, options: _formData.scheduleSelectOptions, className: 'form-select' }))
	                      );
	                    }
	                  ),
	                  _react2.default.createElement(
	                    _reactFinalForm.Field,
	                    { name: 'schedule_category', parse: function parse(_ref5) {
	                        var value = _ref5.value;
	                        return value;
	                      } },
	                    function (_ref6) {
	                      var input = _ref6.input;
	                      return _react2.default.createElement(
	                        'div',
	                        { className: 'col-2' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Category'
	                        ),
	                        _react2.default.createElement(_reactSelect2.default, _extends({}, input, {
	                          clearable: false,
	                          options: _formData.scheduleCategorySelectOptions,
	                          className: 'form-select',
	                          disabled: values.schedule !== 'schedule_ab'
	                        }))
	                      );
	                    }
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-item form-item-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-2' },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      'From'
	                    ),
	                    _react2.default.createElement(_reactFinalForm.Field, {
	                      name: 'schedule_value_from',
	                      component: 'input',
	                      type: 'text',
	                      className: 'form-input',
	                      placeholder: '$'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-2' },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      'To'
	                    ),
	                    _react2.default.createElement(_reactFinalForm.Field, {
	                      name: 'schedule_value_to',
	                      component: 'input',
	                      type: 'text',
	                      className: 'form-input',
	                      placeholder: '$'
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Footer,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { onClick: onClose },
	                'Cancel'
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { bsStyle: 'primary', type: 'submit' },
	                'Apply'
	              )
	            )
	          );
	        }
	      })
	    )
	  );
	};
	
	ScheduleFilterModal.propTypes = {
	  onSave: _propTypes2.default.func.isRequired,
	  onClose: _propTypes2.default.func.isRequired,
	  show: _propTypes2.default.bool,
	  filter: _propTypes2.default.object.isRequired
	};
	
	ScheduleFilterModal.defaultProps = {
	  show: false
	};
	
	exports.default = ScheduleFilterModal;

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AliasesResultRow = function AliasesResultRow(_ref) {
	  var row = _ref.row;
	  return _react2.default.createElement(
	    'table',
	    { className: 'ir-search-table-results sticky-enabled' },
	    _react2.default.createElement(
	      'tbody',
	      null,
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement('span', { className: 'address-name', dangerouslySetInnerHTML: { __html: row.party.name } }),
	          _react2.default.createElement('br', null),
	          row.party.address && _react2.default.createElement(
	            'span',
	            { style: { whiteSpace: 'pre-wrap' } },
	            row.party.address
	          ),
	          row.party.phone && _react2.default.createElement(
	            'div',
	            null,
	            't: ',
	            row.party.phone
	          ),
	          row.party.fax && _react2.default.createElement(
	            'div',
	            null,
	            'f: ',
	            row.party.fax
	          ),
	          row.party.email && _react2.default.createElement(
	            'div',
	            null,
	            row.party.email
	          ),
	          row.party.role && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'em',
	              null,
	              '(',
	              row.party.role,
	              ')'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          row.party_alias.length > 1 ? 'has aliases' : 'has alias'
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          row.party_alias.map(function (alias) {
	            return _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('span', { className: 'address-name', dangerouslySetInnerHTML: { __html: alias.name } }),
	              alias.role && _react2.default.createElement(
	                'em',
	                null,
	                _react2.default.createElement('br', null),
	                '(',
	                alias.role,
	                ')'
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	AliasesResultRow.propTypes = {
	  row: _propTypes2.default.any.isRequired
	};
	
	exports.default = AliasesResultRow;

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AttorneysResultRow = function AttorneysResultRow(_ref) {
	  var row = _ref.row;
	  return _react2.default.createElement(
	    'table',
	    { className: 'ir-search-table-results sticky-enabled' },
	    _react2.default.createElement(
	      'tbody',
	      null,
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement('span', { className: 'address-name', dangerouslySetInnerHTML: { __html: row.attorney.name } }),
	          row.attorney.address && _react2.default.createElement(
	            'span',
	            { style: { whiteSpace: 'pre-wrap' } },
	            _react2.default.createElement('br', null),
	            row.attorney.address
	          ),
	          row.attorney.phone && _react2.default.createElement(
	            'div',
	            null,
	            't: ',
	            row.attorney.phone
	          ),
	          row.attorney.fax && _react2.default.createElement(
	            'div',
	            null,
	            'f: ',
	            row.attorney.fax
	          ),
	          row.attorney.email && _react2.default.createElement(
	            'div',
	            null,
	            row.attorney.email
	          ),
	          row.attorney.lead && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'em',
	              null,
	              '(',
	              row.attorney.lead,
	              ')'
	            )
	          ),
	          row.attorney.assigned_date && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'em',
	              null,
	              'Assigned: ',
	              row.attorney.assigned_date
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          'representing'
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          row.associated.map(function (associated, idx) {
	            return _react2.default.createElement(
	              'p',
	              { key: idx },
	              _react2.default.createElement('span', { className: 'address-name', dangerouslySetInnerHTML: { __html: associated.name } }),
	              associated.address && _react2.default.createElement(
	                'span',
	                { style: { whiteSpace: 'pre-wrap' } },
	                _react2.default.createElement('br', null),
	                associated.address
	              ),
	              associated.phone && _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement('br', null),
	                't: ',
	                associated.phone
	              ),
	              associated.fax && _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement('br', null),
	                'f: ',
	                associated.fax
	              ),
	              associated.email && _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement('br', null),
	                associated.email
	              ),
	              associated.role && _react2.default.createElement(
	                'em',
	                null,
	                _react2.default.createElement('br', null),
	                '(',
	                associated.role,
	                ')'
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	AttorneysResultRow.propTypes = {
	  row: _propTypes2.default.any.isRequired
	};
	
	exports.default = AttorneysResultRow;

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CreditorsResultRow = function CreditorsResultRow(_ref) {
	  var row = _ref.row;
	  return _react2.default.createElement(
	    'table',
	    { className: 'ir-search-table-results sticky-enabled' },
	    _react2.default.createElement(
	      'tbody',
	      null,
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement('span', { className: 'address-name', dangerouslySetInnerHTML: { __html: row.name } }),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'span',
	            { style: { whiteSpace: 'pre-wrap' } },
	            row.address
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          row.creditor_code
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          row.creditor_role ? '(' + row.creditor_role + ')' : ''
	        )
	      )
	    )
	  );
	};
	
	CreditorsResultRow.propTypes = {
	  row: _propTypes2.default.any.isRequired
	};
	
	exports.default = CreditorsResultRow;

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FilersResultRow = function FilersResultRow(_ref) {
	  var row = _ref.row;
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: row.name } }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'em',
	      null,
	      '(',
	      row.type,
	      ')'
	    ),
	    row.date_added && _react2.default.createElement(
	      'div',
	      null,
	      'Added: ',
	      row.date_added
	    ),
	    row.date_terminated && _react2.default.createElement(
	      'div',
	      null,
	      'Added: ',
	      row.date_terminated
	    )
	  );
	};
	
	FilersResultRow.propTypes = {
	  row: _propTypes2.default.any.isRequired
	};
	
	exports.default = FilersResultRow;

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HTMLResultRow = function HTMLResultRow(_ref) {
	  var row = _ref.row;
	  return _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: row.text } });
	};
	
	HTMLResultRow.propTypes = {
	  row: _propTypes2.default.any.isRequired
	};
	
	exports.default = HTMLResultRow;

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.AllCasesView = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _immutable = __webpack_require__(30);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _FilterTable = __webpack_require__(80);
	
	var _FilterTable2 = _interopRequireDefault(_FilterTable);
	
	var _AssociatedCasesView = __webpack_require__(369);
	
	var _RelatedCases = __webpack_require__(372);
	
	var _OtherFilings = __webpack_require__(371);
	
	var _OtherCourtInfo = __webpack_require__(370);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AllCasesView = exports.AllCasesView = function (_Component) {
	  _inherits(AllCasesView, _Component);
	
	  function AllCasesView() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AllCasesView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getTableBody = function (data, label) {
	      if (label === 'associated_cases') {
	        return _react2.default.createElement(_AssociatedCasesView.AssociatedCasesView, { associatedCases: data, key: 'associate-cases' });
	      }
	
	      if (label === 'related_cases_district') {
	        return _react2.default.createElement(_RelatedCases.RelatedCases, { relatedCases: data, key: 'related-cases' });
	      }
	
	      if (label === 'other_filings') {
	        return _react2.default.createElement(_OtherFilings.OtherFilings, { otherFilings: data, key: 'other-cases' });
	      }
	
	      if (label === 'other_court_information') {
	        return _react2.default.createElement(_OtherCourtInfo.OtherCourtInfo, { otherCourtInfo: data, key: 'other-court-info' });
	      }
	
	      return null;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  AllCasesView.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        cases = _props.cases,
	        case_uuid = _props.case_uuid;
	
	
	    var firstEntry = _lodash2.default.get(cases, '[0][1]') || [];
	    var secondEntry = _lodash2.default.get(cases, '[1][1]') || [];
	    var thirdEntry = _lodash2.default.get(cases, '[2][1]') || [];
	    var fourthEntry = _lodash2.default.get(cases, '[3][1]') || [];
	
	    var tableData = [{
	      label: _lodash2.default.get(cases, '[0][0]') || '',
	      entry: _immutable2.default.Iterable.isIterable(firstEntry) ? firstEntry.toJS() : firstEntry
	    }, {
	      label: _lodash2.default.get(cases, '[1][0]'),
	      entry: _immutable2.default.Iterable.isIterable(secondEntry) ? secondEntry.toJS() : secondEntry
	    }, {
	      label: _lodash2.default.get(cases, '[2][0]'),
	      entry: _immutable2.default.Iterable.isIterable(thirdEntry) ? thirdEntry.toJS() : thirdEntry
	    }, {
	      label: _lodash2.default.get(cases, '[3][0]'),
	      entry: _immutable2.default.Iterable.isIterable(fourthEntry) ? fourthEntry.toJS() : fourthEntry
	    }];
	    tableData = _lodash2.default.sortBy(tableData, 'label');
	
	    var totalEntries = tableData.filter(function (p) {
	      return Array.isArray(p.entry) && p.entry.length > 0;
	    });
	
	    var header = 'Associated Cases';
	    if (totalEntries.length < 1) {
	      var asso_obj = _lodash2.default.find(tableData, function (obj) {
	        return obj.label === 'associated_cases';
	      });
	      var emptyMsg = _lodash2.default.get(asso_obj, 'asso_obj.entry.empty', 'There are no associations for this case.');
	      return _react2.default.createElement(
	        'div',
	        { className: 'associated-cases' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'case-label' },
	          header
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ir-search-status-message messages warning' },
	          emptyMsg
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _FilterTable2.default,
	        {
	          showHeader: totalEntries.length > 0,
	          premiumSearch: { uuid: case_uuid, query: 'associated_cases' }
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'associated-cases' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'case-label' },
	            header
	          )
	        ),
	        tableData.map(function (p) {
	          return _this2.getTableBody(p.entry, p.label);
	        })
	      )
	    );
	  };
	
	  return AllCasesView;
	}(_react.Component);
	
	exports.default = AllCasesView;

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.AssociatedCasesView = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(2163);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AssociatedCasesView = exports.AssociatedCasesView = function (_Component) {
	  _inherits(AssociatedCasesView, _Component);
	
	  function AssociatedCasesView() {
	    _classCallCheck(this, AssociatedCasesView);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  AssociatedCasesView.prototype.render = function render() {
	    var associatedCases = this.props.associatedCases;
	
	    var header = 'Associated Cases';
	
	    if (associatedCases.empty) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        ' '
	      );
	    }
	
	    var rows = associatedCases.map(function (item, key) {
	      var ac = item.associated_case || {};
	      var cs = item.case || {};
	      var leadLink = '/filings/' + cs.case_uuid + '-';
	      var assocLink = '/filings/' + ac.case_uuid + '-';
	
	      return _react2.default.createElement(
	        'tr',
	        { key: key },
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: leadLink },
	            cs.case_code
	          ),
	          ' ',
	          _react2.default.createElement(
	            'span',
	            null,
	            ' ',
	            cs.case_name || '',
	            ' '
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: assocLink },
	            ac.case_code
	          ),
	          ' ',
	          _react2.default.createElement(
	            'span',
	            null,
	            ' ',
	            ac.case_name || '',
	            ' '
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          ac.case_type || ''
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          cs.date_closed || ''
	        )
	      );
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'associated-cases' },
	      _react2.default.createElement('h2', { className: 'case-label' }),
	      _react2.default.createElement(
	        'table',
	        { className: 'sticky-enabled tablesorter' },
	        _react2.default.createElement(
	          'thead',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'th',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'Lead Case Title'
	              )
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'Associated Case Title'
	              )
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'Type'
	              )
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'Date Closed'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'tbody',
	          null,
	          rows
	        )
	      )
	    );
	  };
	
	  return AssociatedCasesView;
	}(_react.Component);
	
	exports.default = AssociatedCasesView;

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.OtherCourtInfo = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-danger */
	
	
	var OtherCourtInfo = exports.OtherCourtInfo = function (_Component) {
	  _inherits(OtherCourtInfo, _Component);
	
	  function OtherCourtInfo() {
	    _classCallCheck(this, OtherCourtInfo);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  OtherCourtInfo.prototype.createMarkup = function createMarkup() {
	    var otherCourtInfo = this.props.otherCourtInfo;
	
	
	    var htmlStr = Array.isArray(otherCourtInfo) ? otherCourtInfo.map(function (obj) {
	      return obj.html;
	    }) : otherCourtInfo.html;
	
	    return { __html: htmlStr };
	  };
	
	  OtherCourtInfo.prototype.render = function render() {
	    var otherCourtInfo = this.props.otherCourtInfo;
	
	
	    if (otherCourtInfo.empty) {
	      return _react2.default.createElement('div', null);
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'other-court-info' },
	      _react2.default.createElement('div', { dangerouslySetInnerHTML: this.createMarkup() })
	    );
	  };
	
	  return OtherCourtInfo;
	}(_react.Component);
	
	exports.default = OtherCourtInfo;

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.OtherFilings = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(2165);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OtherFilings = exports.OtherFilings = function (_Component) {
	  _inherits(OtherFilings, _Component);
	
	  function OtherFilings() {
	    _classCallCheck(this, OtherFilings);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  OtherFilings.prototype.render = function render() {
	    var otherFilings = this.props.otherFilings;
	
	    var header = 'Other Filings by Same Debtor(s)';
	
	    if (otherFilings.empty) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        ' '
	      );
	    }
	    var rows = otherFilings.map(function (item, key) {
	      var debtor = item.debtor || {};
	      var cs = item.case || {};
	      var link = '/filings/' + cs.case_uuid + '-';
	
	      return _react2.default.createElement(
	        'tr',
	        { key: 'case-' + key },
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: link },
	            cs.case_code
	          ),
	          ' ',
	          _react2.default.createElement(
	            'span',
	            null,
	            ' ',
	            cs.case_name || '',
	            ' '
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          debtor.name || ''
	        )
	      );
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'other-filings' },
	      _react2.default.createElement('h2', { className: 'case-label' }),
	      _react2.default.createElement(
	        'table',
	        { className: 'sticky-enabled tablesorter' },
	        _react2.default.createElement(
	          'thead',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'th',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                header,
	                ' Cases'
	              )
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'Debtor(s)'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'tbody',
	          null,
	          rows
	        )
	      )
	    );
	  };
	
	  return OtherFilings;
	}(_react.Component);
	
	exports.default = OtherFilings;

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.RelatedCases = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(2166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RelatedCases = exports.RelatedCases = function (_Component) {
	  _inherits(RelatedCases, _Component);
	
	  function RelatedCases() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RelatedCases);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderRow = function (relCase) {
	      var leadLink = '/filings/' + relCase.case_uuid + '-';
	      return _react2.default.createElement(
	        'tr',
	        { key: relCase.case_uuid },
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: leadLink },
	            _react2.default.createElement(
	              'span',
	              null,
	              relCase.case_no || ''
	            )
	          ),
	          '\xA0 \xA0',
	          relCase.case_title
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          relCase.start_date
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          relCase.end_date
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  RelatedCases.prototype.render = function render() {
	    var relatedCases = this.props.relatedCases;
	
	
	    if (relatedCases.empty) {
	      return _react2.default.createElement('div', null);
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'related-cases' },
	      _react2.default.createElement('h2', { className: 'case-label' }),
	      _react2.default.createElement(
	        'table',
	        { className: 'sticky-enabled tablesorter' },
	        _react2.default.createElement(
	          'thead',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'th',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'Related Cases'
	              )
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'Start Date'
	              )
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'End Date'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'tbody',
	          null,
	          relatedCases.map(this.renderRow)
	        )
	      )
	    );
	  };
	
	  return RelatedCases;
	}(_react.Component);
	
	exports.default = RelatedCases;

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AllPartsDocument = function AllPartsDocument(_ref) {
	  var allPartsCount = _ref.allPartsCount,
	      onDownloadZipClick = _ref.onDownloadZipClick,
	      onDownloadComboPdfClick = _ref.onDownloadComboPdfClick,
	      onDownloadEmailZipClick = _ref.onDownloadEmailZipClick,
	      onEmailCombinedPdf = _ref.onEmailCombinedPdf,
	      onAllPartsPrintPreview = _ref.onAllPartsPrintPreview;
	  return _react2.default.createElement(
	    'tr',
	    { className: 'all-parts-document bulk-operations odd no-filter-search', key: 'all-parts' },
	    _react2.default.createElement('td', null),
	    _react2.default.createElement('td', null),
	    _react2.default.createElement(
	      'td',
	      null,
	      'All parts'
	    ),
	    _react2.default.createElement(
	      'td',
	      null,
	      allPartsCount
	    ),
	    _react2.default.createElement(
	      'td',
	      { className: 'bulk-operations' },
	      _react2.default.createElement(
	        'div',
	        { className: ' menu' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ui delayed dropdown item' },
	          _react2.default.createElement('span', { className: 'download icon' }),
	          ' \xA0',
	          _react2.default.createElement('span', { className: 'email icon' }),
	          ' \xA0',
	          _react2.default.createElement('span', { className: 'preview icon' }),
	          ' ...',
	          _react2.default.createElement(
	            'div',
	            { className: 'menu', style: { display: 'block' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'item', onClick: onDownloadZipClick },
	              _react2.default.createElement('span', {
	                className: 'download icon' }),
	              _react2.default.createElement('span', { className: 'zip icon right' }),
	              ' Download ZIP'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'item', onClick: onDownloadComboPdfClick },
	              _react2.default.createElement('span', { className: 'download icon' }),
	              _react2.default.createElement('span', { className: 'pdf icon right' }),
	              'Download Combined PDF \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'item', onClick: onDownloadEmailZipClick },
	              _react2.default.createElement('span', { className: 'email icon' }),
	              _react2.default.createElement('span', { className: 'zip icon right' }),
	              ' Email ZIP'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'item', onClick: onEmailCombinedPdf },
	              _react2.default.createElement('span', { className: 'email icon' }),
	              _react2.default.createElement('span', { className: 'pdf icon right' }),
	              ' Email Combined PDF'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'item', onClick: onAllPartsPrintPreview },
	              _react2.default.createElement('span', { className: 'preview icon' }),
	              ' Print Preview'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	AllPartsDocument.propTypes = {
	  allPartsCount: _propTypes2.default.number.isRequired,
	  onDownloadZipClick: _propTypes2.default.func.isRequired,
	  onDownloadComboPdfClick: _propTypes2.default.func.isRequired,
	  onDownloadEmailZipClick: _propTypes2.default.func.isRequired,
	  onEmailCombinedPdf: _propTypes2.default.func.isRequired,
	  onAllPartsPrintPreview: _propTypes2.default.func.isRequired
	};
	
	exports.default = AllPartsDocument;

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dateFormat = __webpack_require__(94);
	
	var _dateFormat2 = _interopRequireDefault(_dateFormat);
	
	var _ClaimsHistoryEntry = __webpack_require__(375);
	
	var _ClaimsHistoryEntry2 = _interopRequireDefault(_ClaimsHistoryEntry);
	
	var _DocketEntry = __webpack_require__(170);
	
	var _DocketEntry2 = _interopRequireDefault(_DocketEntry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClaimsEntry = function ClaimsEntry(_ref) {
	  var id = _ref.id,
	      claim = _ref.claim,
	      onGetDocuments = _ref.onGetDocuments,
	      selectedDocket = _ref.selectedDocket,
	      onGetClaimsDocuments = _ref.onGetClaimsDocuments,
	      selectedClaim = _ref.selectedClaim;
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'tr',
	      null,
	      _react2.default.createElement(
	        'td',
	        null,
	        claim.claim_no
	      ),
	      _react2.default.createElement(
	        'td',
	        null,
	        claim.info.original_entered_date && _react2.default.createElement(
	          'div',
	          null,
	          'Original Entered Date: ',
	          claim.info.original_entered_date
	        ),
	        claim.info.original_filed_date && _react2.default.createElement(
	          'div',
	          null,
	          'Original Filed Date: ',
	          claim.info.original_filed_date
	        ),
	        claim.info.last_amendment_filed && _react2.default.createElement(
	          'div',
	          null,
	          'Last Amendment: ',
	          claim.info.last_amendment_filed
	        )
	      ),
	      _react2.default.createElement(
	        'td',
	        { style: { whiteSpace: 'pre-wrap' } },
	        claim.creditor
	      ),
	      _react2.default.createElement(
	        'td',
	        { style: { textAlign: 'right' } },
	        '$ ',
	        claim.amounts && claim.amounts.amount && claim.amounts.amount.claimed || '0.00'
	      ),
	      _react2.default.createElement(
	        'td',
	        null,
	        (0, _dateFormat2.default)(claim.modified)
	      )
	    ),
	    claim.history.some(function (doc) {
	      return !!doc.claim_no;
	    }) && _react2.default.createElement(
	      'tr',
	      { className: 'claim-detail claim' },
	      _react2.default.createElement('td', null),
	      _react2.default.createElement(
	        'td',
	        { colSpan: '4' },
	        _react2.default.createElement(
	          'h4',
	          null,
	          'History / Documents'
	        ),
	        _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'tbody',
	            null,
	            claim.history.map(function (doc) {
	              return doc.claim_no && _react2.default.createElement(_ClaimsHistoryEntry2.default, {
	                id: 'claim-history-' + id,
	                key: 'claim-history-' + id,
	                claimHistory: doc,
	                court_code: claim.case_court,
	                case_number: claim.case_no,
	                onGetDocuments: onGetClaimsDocuments,
	                selectedClaim: selectedClaim
	              });
	            })
	          )
	        )
	      )
	    ),
	    claim.history.some(function (doc) {
	      return !!doc.docket_no;
	    }) && _react2.default.createElement(
	      'tr',
	      { className: 'docket' },
	      _react2.default.createElement('td', null),
	      _react2.default.createElement(
	        'td',
	        { colSpan: '4' },
	        _react2.default.createElement(
	          'h4',
	          null,
	          'Related Dockets'
	        ),
	        _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'tbody',
	            null,
	            claim.history.map(function (doc) {
	              return doc.docket_no && _react2.default.createElement(_DocketEntry2.default, {
	                id: 'docket-entry-' + id,
	                key: 'docket-entry-' + id,
	                docket: doc,
	                redact: {},
	                showRedactPopup: function showRedactPopup() {},
	                case_uuid: '',
	                court_code: claim.case_court,
	                case_number: claim.case_no,
	                onGetDocuments: onGetDocuments,
	                selectedDocket: selectedDocket
	              });
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'tr',
	      { className: 'claim-detail claim' },
	      _react2.default.createElement('td', null),
	      _react2.default.createElement(
	        'td',
	        { colSpan: '4' },
	        _react2.default.createElement(
	          'table',
	          { className: 'borderless-table' },
	          _react2.default.createElement(
	            'tbody',
	            null,
	            claim.description && _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                'Description:'
	              ),
	              _react2.default.createElement('td', { width: '100%', dangerouslySetInnerHTML: { __html: claim.description } })
	            ),
	            claim.remarks && _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                'Remarks:'
	              ),
	              _react2.default.createElement('td', { width: '100%', dangerouslySetInnerHTML: { __html: claim.remarks } })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	ClaimsEntry.propTypes = {
	  id: _propTypes2.default.number.isRequired,
	  claim: _propTypes2.default.object.isRequired,
	  selectedDocket: _propTypes2.default.object.isRequired,
	  onGetDocuments: _propTypes2.default.func.isRequired,
	  selectedClaim: _propTypes2.default.object.isRequired,
	  onGetClaimsDocuments: _propTypes2.default.func.isRequired
	};
	
	exports.default = ClaimsEntry;

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LoadingBar = __webpack_require__(92);
	
	var _LoadingBar2 = _interopRequireDefault(_LoadingBar);
	
	var _DocumentsRow = __webpack_require__(378);
	
	var _DocumentsRow2 = _interopRequireDefault(_DocumentsRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClaimsHistoryEntry = function ClaimsHistoryEntry(_ref) {
	  var id = _ref.id,
	      claimHistory = _ref.claimHistory,
	      onGetDocuments = _ref.onGetDocuments,
	      court_code = _ref.court_code,
	      case_number = _ref.case_number,
	      selectedClaim = _ref.selectedClaim;
	
	  var claimNum = parseInt(claimHistory.claim_no, 10) || claimHistory.claim_no === 'doc' && claimHistory.claim_seq && claimHistory.claim_seq.split('-')[0];
	  var seqNum = claimHistory.claim_sequence_number || claimHistory.claim_no === 'doc' && claimHistory.claim_seq && claimHistory.claim_seq.split('-')[1];
	  var claimNumLabel = parseInt(claimHistory.claim_no, 10) && claimHistory.claim_sequence_number ? claimHistory.claim_no + '-' + claimHistory.claim_sequence_number : 'doc';
	
	  var claimNumLink = claimNum && seqNum ? _react2.default.createElement(
	    'a',
	    {
	      href: '#',
	      className: 'docket_no',
	      onClick: function onClick(e) {
	        e.preventDefault();
	        onGetDocuments(claimNum, seqNum, court_code, case_number);
	      }
	    },
	    claimNumLabel
	  ) : 'doc';
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'tr',
	      null,
	      _react2.default.createElement(
	        'td',
	        { colSpan: '2' },
	        claimNumLink
	      ),
	      _react2.default.createElement(
	        'td',
	        null,
	        _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: claimHistory.claim_text } }),
	        claimHistory.status === 'loading' || selectedClaim.claimNum === claimNum && selectedClaim.status === 'loading' && _react2.default.createElement(_LoadingBar2.default, { overrideShow: true })
	      )
	    ),
	    selectedClaim.claimNum === claimNum && selectedClaim.status !== 'loading' && _react2.default.createElement(_DocumentsRow2.default, {
	      id: id,
	      binder: selectedClaim.binder,
	      case_uuid: '',
	      court_code: court_code,
	      case_number: case_number,
	      claimNum: claimNum,
	      seqNum: seqNum
	    })
	  );
	};
	
	ClaimsHistoryEntry.propTypes = {
	  id: _propTypes2.default.string.isRequired,
	  claimHistory: _propTypes2.default.object.isRequired,
	  selectedClaim: _propTypes2.default.object.isRequired,
	  onGetDocuments: _propTypes2.default.func.isRequired,
	  court_code: _propTypes2.default.string.isRequired,
	  case_number: _propTypes2.default.string.isRequired
	};
	
	exports.default = ClaimsHistoryEntry;

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _globalUtils = __webpack_require__(59);
	
	var _loadingBar = __webpack_require__(199);
	
	var _loadingBar2 = _interopRequireDefault(_loadingBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Document = function Document(_ref) {
	  var document = _ref.document,
	      index = _ref.index,
	      downloadFile = _ref.downloadFile,
	      emailPartPopup = _ref.emailPartPopup,
	      printPreview = _ref.printPreview,
	      createBlogPost = _ref.createBlogPost,
	      ocrDownload = _ref.ocrDownload,
	      buyPdf = _ref.buyPdf;
	
	  var row = null;
	
	  if (document.is_cached) {
	    row = _react2.default.createElement(
	      'table',
	      null,
	      _react2.default.createElement(
	        'tbody',
	        null,
	        _react2.default.createElement(
	          'tr',
	          { className: 'no-filter-search docket-document' },
	          _react2.default.createElement(
	            'td',
	            { style: { whiteSpace: 'nowrap' } },
	            _react2.default.createElement(
	              'div',
	              { id: 'download',
	                title: 'Download File',
	                onClick: function onClick() {
	                  return downloadFile(document);
	                } },
	              _react2.default.createElement('span', { className: 'download icon' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'email-pdf',
	                onClick: function onClick() {
	                  return emailPartPopup(document.friendly_name, document.docket_no, document.number);
	                },
	                id: 'email',
	                title: 'Email' },
	              _react2.default.createElement('span', { className: 'email icon' })
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                onClick: function onClick() {
	                  return printPreview(document);
	                },
	                id: 'print',
	                className: 'print',
	                title: 'Print preview' },
	              _react2.default.createElement('span', { className: 'preview icon' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'permission-check-links' },
	              (0, _globalUtils.drupalPermsInclude)('Public Link to Docket Parts PDFs') && !_lodash2.default.isEmpty(document.public_pdf_link) && _react2.default.createElement(
	                'div',
	                { className: 'menu' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ui delayed dropdown item' },
	                  _react2.default.createElement(
	                    'a',
	                    { title: 'Public Download Link', href: document.public_pdf_link },
	                    _react2.default.createElement('span', { className: 'public link icon' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'menu', style: { display: 'none' } },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'item' },
	                      'For Public Download Link:'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'item' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: document.public_pdf_link },
	                        _react2.default.createElement('span', { className: 'pdf icon' }),
	                        'Right-Click Copy This Link'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'item' },
	                      'Or copy HTML Code below:'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'item' },
	                      _react2.default.createElement(
	                        'textarea',
	                        { onFocus: function onFocus(e) {
	                            return e.target.select();
	                          } },
	                        document.public_pdf_link
	                      )
	                    )
	                  )
	                )
	              ),
	              !(0, _globalUtils.isCourtDrive)() && (0, _globalUtils.drupalPermsInclude)('subscribe to blog') && _react2.default.createElement(
	                'div',
	                { title: 'Create blog post', onClick: function onClick() {
	                    return createBlogPost(document);
	                  } },
	                _react2.default.createElement('span', { className: 'blog-post icon' })
	              ),
	              (0, _globalUtils.drupalPermsInclude)('Docket Parts OCR Link') && _react2.default.createElement(
	                'div',
	                { id: 'download-OCR', title: 'Download OCR', onClick: function onClick() {
	                    return ocrDownload(document);
	                  } },
	                _react2.default.createElement('span', { className: 'download ocr icon' })
	              )
	            )
	          )
	        )
	      )
	    );
	  } else if (document.isLoading) {
	    row = _react2.default.createElement(
	      'div',
	      { className: 'loading-bar' },
	      _react2.default.createElement('img', { src: _loadingBar2.default, alt: '' })
	    );
	  } else {
	    row = _react2.default.createElement(
	      'button',
	      {
	        onClick: function onClick() {
	          return buyPdf(document.number);
	        },
	        className: 'form-submit green'
	      },
	      'Buy $',
	      document.cost
	    );
	  }
	
	  return _react2.default.createElement(
	    'tr',
	    { className: 'odd no-filter-search', key: 'document docket-detail-' + index },
	    _react2.default.createElement('td', null),
	    _react2.default.createElement(
	      'td',
	      null,
	      document.number
	    ),
	    _react2.default.createElement(
	      'td',
	      null,
	      document.description_html || 'Docket'
	    ),
	    _react2.default.createElement(
	      'td',
	      null,
	      document.pages
	    ),
	    _react2.default.createElement(
	      'td',
	      { style: { whiteSpace: 'nowrap' } },
	      row
	    )
	  );
	};
	
	Document.propTypes = {
	  document: _propTypes2.default.object.isRequired,
	  index: _propTypes2.default.number.isRequired,
	  downloadFile: _propTypes2.default.func.isRequired,
	  emailPartPopup: _propTypes2.default.func.isRequired,
	  printPreview: _propTypes2.default.func.isRequired,
	  createBlogPost: _propTypes2.default.func.isRequired,
	  ocrDownload: _propTypes2.default.func.isRequired,
	  buyPdf: _propTypes2.default.func.isRequired
	};
	
	exports.default = Document;

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _claimDocumentsActions = __webpack_require__(725);
	
	var documentActions = _interopRequireWildcard(_claimDocumentsActions);
	
	var _Document = __webpack_require__(376);
	
	var _Document2 = _interopRequireDefault(_Document);
	
	var _AllPartsDocument = __webpack_require__(373);
	
	var _AllPartsDocument2 = _interopRequireDefault(_AllPartsDocument);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Documents = function (_Component) {
	  _inherits(Documents, _Component);
	
	  function Documents() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Documents);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onDownloadZipClick = function () {
	      var _this$props = _this.props,
	          case_uuid = _this$props.case_uuid,
	          court_code = _this$props.court_code,
	          case_number = _this$props.case_number,
	          docket_seq = _this$props.docket_seq;
	
	
	      var params = {
	        case_uuid: case_uuid,
	        court_code: court_code,
	        case_number: case_number,
	        docket_numbers: [docket_seq]
	      };
	
	      _this.props.getDocketParts(params);
	
	      _this.props.onPopupClick({
	        name: 'DownloadZipAllPdfsRangePopup',
	        show: true,
	        data: params
	      });
	    }, _this.onDownloadComboPdfClick = function () {
	      var _this$props2 = _this.props,
	          case_uuid = _this$props2.case_uuid,
	          court_code = _this$props2.court_code,
	          case_number = _this$props2.case_number,
	          docket_seq = _this$props2.docket_seq;
	
	
	      var params = {
	        case_uuid: case_uuid,
	        court_code: court_code,
	        case_number: case_number,
	        docket_numbers: [docket_seq],
	        download_option: 1
	      };
	
	      _this.props.getDocketParts(params);
	
	      _this.props.onPopupClick({
	        name: 'DownloadCombineAllPdfInRangePopup',
	        show: true,
	        data: params
	      });
	    }, _this.onDownloadEmailZipClick = function () {
	      var _this$props3 = _this.props,
	          case_uuid = _this$props3.case_uuid,
	          court_code = _this$props3.court_code,
	          case_number = _this$props3.case_number,
	          docket_seq = _this$props3.docket_seq;
	
	
	      var params = {
	        case_uuid: case_uuid,
	        court_code: court_code,
	        case_number: case_number,
	        docket_numbers: [docket_seq],
	        download_option: 1
	      };
	
	      _this.props.onPopupClick({
	        name: 'EmailAllPartsZipPopup',
	        show: true,
	        data: params
	      });
	    }, _this.onEmailCombinedPdf = function () {
	      var _this$props4 = _this.props,
	          case_uuid = _this$props4.case_uuid,
	          court_code = _this$props4.court_code,
	          case_number = _this$props4.case_number,
	          docket_seq = _this$props4.docket_seq;
	
	
	      var params = {
	        case_uuid: case_uuid,
	        court_code: court_code,
	        case_number: case_number,
	        docket_numbers: [docket_seq]
	      };
	
	      _this.props.onPopupClick({
	        name: 'EmailCombinedPdfPopup',
	        show: true,
	        data: params
	      });
	    }, _this.onAllPartsPrintPreview = function () {
	      var _this$props5 = _this.props,
	          case_uuid = _this$props5.case_uuid,
	          court_code = _this$props5.court_code,
	          case_number = _this$props5.case_number,
	          docket_seq = _this$props5.docket_seq;
	
	
	      var params = {
	        case_uuid: case_uuid,
	        court_code: court_code,
	        case_number: case_number,
	        docket_numbers: [docket_seq],
	        download_option: 1
	      };
	
	      _this.props.getDocketParts(params);
	
	      _this.props.onPopupClick({
	        name: 'AllPartsPrintPreview',
	        show: true,
	        data: params
	      });
	    }, _this.printPreview = function (document) {
	      if (document.preview_url) {
	        window.open(document.preview_url);
	        var win = window.open(document.preview_url);
	        if (!/Chrome/.test(navigator.userAgent)) {
	          win.print();
	        }
	      } else {
	        // call service to retrieve the preview url
	        _this.props.orderPdf(document).then(function (updatedDocument) {
	          window.open(updatedDocument.preview_url);
	        });
	      }
	    }, _this.emailPartPopup = function (friendly_name, docket_no, part_number) {
	      var _this$props6 = _this.props,
	          case_uuid = _this$props6.case_uuid,
	          court_code = _this$props6.court_code,
	          case_number = _this$props6.case_number;
	
	
	      var params = {
	        name: 'EmailPartPopup',
	        show: true,
	        data: {
	          case_uuid: case_uuid,
	          court_code: court_code,
	          case_number: case_number,
	          friendly_name: friendly_name,
	          docket_no: docket_no,
	          part_number: part_number
	        }
	      };
	
	      _this.props.onPopupClick(params);
	    }, _this.downloadFile = function (document) {
	      if (document.download_url) {
	        window.open(document.download_url);
	      } else {
	        // call service to retrieve the download_url
	        _this.props.orderPdf(document).then(function (updatedDocument) {
	          window.open(updatedDocument.download_url);
	        });
	      }
	    }, _this.ocrDownload = function (document) {
	      if (document.ocr_link) {
	        window.open(document.ocr_link);
	      } else {
	        // call service to retrieve the download_url
	        _this.props.orderPdf(document).then(function (updatedDocument) {
	          window.open(updatedDocument.ocr_link);
	        });
	      }
	    }, _this.createBlogPost = function (document) {
	      if (document.blog) {
	        window.open(document.blog);
	      } else {
	        // call service to retrieve the download_url
	        _this.props.orderPdf(document).then(function (updatedDocument) {
	          window.open(updatedDocument.blog);
	        });
	      }
	    }, _this.buyPdf = function (partNumber) {
	      if (_this.props.checkClientCodeValid()) {
	        var _this$props7 = _this.props,
	            court_code = _this$props7.court_code,
	            case_number = _this$props7.case_number,
	            claimNum = _this$props7.claimNum,
	            seqNum = _this$props7.seqNum;
	
	
	        var params = {
	          case_no: case_number,
	          claimNum: claimNum,
	          seqNum: seqNum,
	          partNumber: partNumber,
	          court_code: court_code
	        };
	
	        _this.props.buyPdf(params);
	        // .then(() => this.getPartsInfo(court_code, case_number, partNumber, [seqNum]));
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // getPartsInfo = (court_code, case_number, partNumber, sequence_numbers) => {
	  //   const params = { case_docket_sequence_numbers: [{ court_code, case_number, sequence_numbers }] };
	  //   this.props.getPartsPurchaseInfo(params);
	  // };
	
	  Documents.prototype.render = function render() {
	    var _this2 = this;
	
	    var documents = this.props.documents;
	
	
	    var allPartsCount = documents.reduce(function (accum, next) {
	      accum += parseInt(next.pages, 10) || 0;
	      return accum;
	    }, 0);
	
	    var rows = documents.map(function (document, index) {
	      return _react2.default.createElement(_Document2.default, {
	        key: index,
	        document: document,
	        createBlogPost: _this2.createBlogPost,
	        index: index,
	        buyPdf: _this2.buyPdf,
	        ocrDownload: _this2.ocrDownload,
	        downloadFile: _this2.downloadFile,
	        emailPartPopup: _this2.emailPartPopup,
	        printPreview: _this2.printPreview
	      });
	    });
	
	    // if (documents.length > 1) {
	    //   rows.push(
	    //     <AllPartsDocument
	    //       key="all-parts-doc"
	    //       allPartsCount={allPartsCount}
	    //       onDownloadComboPdfClick={this.onDownloadComboPdfClick}
	    //       onDownloadEmailZipClick={this.onDownloadEmailZipClick}
	    //       onEmailCombinedPdf={this.onEmailCombinedPdf}
	    //       onAllPartsPrintPreview={this.onAllPartsPrintPreview}
	    //       onDownloadZipClick={this.onDownloadZipClick}
	    //     />
	    //   );
	    // }
	    return rows;
	  };
	
	  return Documents;
	}(_react.Component);
	
	Documents.propTypes = {
	  documents: _propTypes2.default.array.isRequired,
	  onPopupClick: _propTypes2.default.func.isRequired,
	  case_uuid: _propTypes2.default.string.isRequired,
	  claimNum: _propTypes2.default.any.isRequired,
	  seqNum: _propTypes2.default.any.isRequired,
	  court_code: _propTypes2.default.string.isRequired,
	  case_number: _propTypes2.default.string.isRequired,
	  buyPdf: _propTypes2.default.func.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$get$toJS = state.get('dockets').toJS(),
	      popup = _state$get$toJS.popup;
	
	  return {
	    popup: popup
	  };
	};
	
	var mapDispatchToProps = {
	  orderPdf: documentActions.orderPdf,
	  buyPdf: documentActions.buyPdf,
	  // getPartsPurchaseInfo: documentActions.getPartsPurchaseInfo,
	  checkClientCodeValid: documentActions.checkClientCodeValid,
	  getDocketParts: documentActions.getDocketParts
	  // onPopupClick: documentActions.togglePopup,
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Documents);

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Documents = __webpack_require__(377);
	
	var _Documents2 = _interopRequireDefault(_Documents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DocumentsRow = function DocumentsRow(_ref) {
	  var id = _ref.id,
	      binder = _ref.binder,
	      case_uuid = _ref.case_uuid,
	      court_code = _ref.court_code,
	      case_number = _ref.case_number,
	      claimNum = _ref.claimNum,
	      seqNum = _ref.seqNum;
	
	  if (binder && binder.documents && binder.documents.length > 0) {
	    return _react2.default.createElement(
	      'tr',
	      { key: 'documents-row-' + id, className: 'docket docket_details dockets-documents-row no-filter-search' },
	      _react2.default.createElement('td', { colSpan: '2' }),
	      _react2.default.createElement(
	        'td',
	        { className: 'here', colSpan: '100%' },
	        _react2.default.createElement(
	          'table',
	          { className: 'sticky-enabled' },
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              { key: 'details-desc-' + id, className: 'no-filter-search' },
	              _react2.default.createElement('th', null),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Part'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Description'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Pages'
	              ),
	              _react2.default.createElement(
	                'th',
	                { width: '40%' },
	                'Action'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            _react2.default.createElement(_Documents2.default, {
	              documents: binder.documents,
	              case_uuid: case_uuid,
	              court_code: court_code,
	              case_number: case_number,
	              claimNum: claimNum,
	              seqNum: seqNum,
	              docket_seq: claimNum + '-' + seqNum
	            })
	          )
	        )
	      )
	    );
	  }
	
	  return _react2.default.createElement(
	    'tr',
	    { key: 'documents-row-' + id, className: 'docket_details no-filter-search ' },
	    _react2.default.createElement('td', { colSpan: '2' }),
	    _react2.default.createElement(
	      'td',
	      { className: 'here', colSpan: '100%' },
	      'No Accessible Documents Found'
	    )
	  );
	};
	
	DocumentsRow.propTypes = {
	  id: _propTypes2.default.string.isRequired,
	  binder: _propTypes2.default.object.isRequired,
	  case_uuid: _propTypes2.default.string.isRequired,
	  court_code: _propTypes2.default.string.isRequired,
	  case_number: _propTypes2.default.string.isRequired,
	  claimNum: _propTypes2.default.number.isRequired,
	  seqNum: _propTypes2.default.string.isRequired
	};
	
	exports.default = DocumentsRow;

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(32);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _LoadingBar = __webpack_require__(91);
	
	var _LoadingBar2 = _interopRequireDefault(_LoadingBar);
	
	var _AlertError = __webpack_require__(50);
	
	var _AlertError2 = _interopRequireDefault(_AlertError);
	
	var _Receipt = __webpack_require__(1155);
	
	var _Receipt2 = _interopRequireDefault(_Receipt);
	
	__webpack_require__(2169);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// eslint-disable-next-line react/prefer-stateless-function
	var CreditorMailing = function (_Component) {
	  _inherits(CreditorMailing, _Component);
	
	  function CreditorMailing() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CreditorMailing);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleFocus = function (e) {
	      return e.target.select();
	    }, _this.timePassed = function (timestamp) {
	      return (0, _moment2.default)(new Date(timestamp * 1000), 'm/d/yyyy h:MM tt').fromNow();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CreditorMailing.prototype.render = function render() {
	    var _this2 = this;
	
	    if (!this.props.dataReady) return _react2.default.createElement(_LoadingBar2.default, null);
	    var alertError = this.props.error ? _react2.default.createElement(_AlertError2.default, { errors: this.props.error }) : null;
	
	    var _props$creditor_maili = this.props.creditor_mailing,
	        _props$creditor_maili2 = _props$creditor_maili.meta,
	        meta = _props$creditor_maili2 === undefined ? { csv: { title: 'Buy Raw Data' }, pdf: { title: 'Buy 3 Column Format' } } : _props$creditor_maili2,
	        _props$creditor_maili3 = _props$creditor_maili.text,
	        text = _props$creditor_maili3 === undefined ? null : _props$creditor_maili3;
	
	    var is_not_creditor_mailing_variant = this.props.type != 'creditor_mailing_variant';
	    return _react2.default.createElement(
	      'div',
	      { id: 'ir-search-creditor-mailing-results' },
	      alertError,
	      _react2.default.createElement(
	        'div',
	        { className: 'download', style: { padding: '10px 0', borderBottom: '1px solid gray', marginBottom: '10px' } },
	        _react2.default.createElement(
	          'a',
	          { href: '#', className: 'green form-submit', id: 'link_download_pdf', onClick: function onClick() {
	              return _this2.props.purchaseData('col1');
	            } },
	          meta.pdf.title
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          '(PACER charges apply)'
	        ),
	        meta.pdf.timestamp && _react2.default.createElement(
	          'div',
	          { className: 'download-link' },
	          _react2.default.createElement(
	            'a',
	            { href: meta.pdf.link, className: '', id: 'link_download_pdf' },
	            _react2.default.createElement('img', { src: '/sites/all/themes/inforuptcy/icons/pdficon_large.png' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ir-search-refresh-date' },
	            'Last updated: ',
	            (0, _moment2.default)(new Date(meta.pdf.timestamp * 1000)).format('MM/DD/YYYY hh:mm a'),
	            ' (',
	            _react2.default.createElement(
	              'span',
	              null,
	              this.timePassed(meta.pdf.timestamp)
	            ),
	            ')'
	          )
	        )
	      ),
	      is_not_creditor_mailing_variant && _react2.default.createElement(
	        'div',
	        { className: 'download' },
	        _react2.default.createElement(
	          'a',
	          { href: '#', className: 'green form-submit', id: 'link_download_csv', onClick: function onClick() {
	              return _this2.props.purchaseData('rawfrmt');
	            } },
	          meta.csv.title
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          '(PACER charges apply)'
	        ),
	        meta.csv.timestamp && _react2.default.createElement(
	          'div',
	          { className: 'download-link' },
	          _react2.default.createElement(
	            'a',
	            { href: '/ir-search/query?query=creditor_mailing&case_uuid=' + meta.case_uuid, className: '', id: 'link_download_csv' },
	            _react2.default.createElement('img', { src: '/sites/all/themes/inforuptcy/icons/CSV.png' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ir-search-refresh-date' },
	            'Last updated: ',
	            (0, _moment2.default)(new Date(meta.csv.timestamp * 1000)).format('MM/DD/YYYY hh:mm a'),
	            ' (',
	            _react2.default.createElement(
	              'span',
	              null,
	              this.timePassed(meta.csv.timestamp)
	            ),
	            ')'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        text && _react2.default.createElement(
	          _react2.default.Fragment,
	          null,
	          'Below is the raw data provided by PACER.'
	        ),
	        'You can download/purchase a CSV or PDF formatted version above.'
	      ),
	      text && _react2.default.createElement('textarea', { style: { width: '100%', height: '300px' }, onFocus: function onFocus(e) {
	          return _this2.handleFocus(e);
	        }, value: text, readOnly: true }),
	      this.props.receipt && _react2.default.createElement(_Receipt2.default, { pacerReceipt: this.props.receipt })
	    );
	  };
	
	  return CreditorMailing;
	}(_react.Component);
	
	CreditorMailing.defaultProps = {
	  error: null,
	  receipt: null
	};
	
	CreditorMailing.propTypes = {
	  dataReady: _propTypes2.default.bool.isRequired,
	  creditor_mailing: _propTypes2.default.any.isRequired,
	  receipt: _propTypes2.default.any,
	  error: _propTypes2.default.any,
	  purchaseData: _propTypes2.default.func.isRequired
	};
	
	exports.default = CreditorMailing;

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _AlertError = __webpack_require__(50);
	
	var _AlertError2 = _interopRequireDefault(_AlertError);
	
	var _Popup = __webpack_require__(69);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _errorActionTypes = __webpack_require__(101);
	
	var constants = _interopRequireWildcard(_errorActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DocketError = function (_Component) {
	  _inherits(DocketError, _Component);
	
	  function DocketError() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DocketError);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onClose = function () {
	      _this.props.dispatch({
	        type: constants.RESET_VALIDATION_ERROR
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  DocketError.prototype.render = function render() {
	    if (this.props.popupErrors) {
	      return _react2.default.createElement(
	        _Popup2.default,
	        { show: true,
	          clsName: 'docket-error',
	          topBarTitle: 'Reminder!',
	          onClose: this.onClose },
	        _react2.default.createElement(
	          'div',
	          { className: 'error-text' },
	          this.props.popupErrors.messages
	        )
	      );
	    }
	    if (this.props.alertErrors) {
	      return _react2.default.createElement(_AlertError2.default, { errors: this.props.errors });
	    }
	    return null;
	  };
	
	  return DocketError;
	}(_react.Component);
	
	DocketError.defaultProps = {
	  errors: null,
	  popupErrors: null,
	  alertErrors: null
	};
	
	DocketError.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  errors: _propTypes2.default.any,
	  popupErrors: _propTypes2.default.any,
	  alertErrors: _propTypes2.default.any
	};
	
	function mapStateToProps(state) {
	  return {
	    popupErrors: state.get('validationErrors') ? state.get('validationErrors').toJS() : null,
	    alertErrors: state.get('searchErrors') ? state.get('searchErrors').toJS() : null
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(DocketError);

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDatepicker = __webpack_require__(78);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(104);
	__webpack_require__(130);
	
	var DocketPacerSearchBar = function DocketPacerSearchBar(props) {
	  var showPastEntries = props.showPastEntries,
	      pastEntriesHide = props.pastEntriesHide,
	      changePacerFilter = props.changePacerFilter,
	      changePacerDate = props.changePacerDate,
	      handlePacerDateChangeRaw = props.handlePacerDateChangeRaw,
	      pacerSearch = props.pacerSearch,
	      buyDocketSheet = props.buyDocketSheet,
	      clearPacerSearchFilter = props.clearPacerSearchFilter;
	
	
	  return _react2.default.createElement(
	    'div',
	    { id: 'pacer-filter', className: 'inside-block' },
	    showPastEntries && _react2.default.createElement(
	      'div',
	      { className: 'close', onClick: pastEntriesHide },
	      '\xD7'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'tip' },
	      'Leave blank for entire docket or specify document or date range to import partial docket sheet'
	    ),
	    _react2.default.createElement(
	      'div',
	      { id: 'pacer-docket-form' },
	      _react2.default.createElement('input', {
	        className: 'form-text',
	        value: pacerSearch.doc_from || '',
	        onChange: function onChange(e) {
	          return changePacerFilter(e, 'doc_from');
	        },
	        type: 'text',
	        placeholder: 'Doc#'
	      }),
	      _react2.default.createElement(
	        'span',
	        null,
	        '\xA0to\xA0'
	      ),
	      _react2.default.createElement('input', {
	        className: 'form-text',
	        value: pacerSearch.doc_to || '',
	        onChange: function onChange(e) {
	          return changePacerFilter(e, 'doc_to');
	        },
	        type: 'text',
	        placeholder: 'Doc#'
	      }),
	      _react2.default.createElement(
	        'span',
	        null,
	        '\xA0OR\xA0'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'date-selector' },
	        _react2.default.createElement(_reactDatepicker2.default, {
	          selected: pacerSearch.date_from,
	          onChange: changePacerDate.bind(null, 'date_from'),
	          dateFormat: 'MM/DD/YYYY',
	          isClearable: true,
	          placeholderText: 'date',
	          onChangeRaw: handlePacerDateChangeRaw.bind(null, 'date_from')
	        })
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        '\xA0to\xA0'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'date-selector' },
	        _react2.default.createElement(_reactDatepicker2.default, {
	          selected: pacerSearch.date_to,
	          onChange: changePacerDate.bind(null, 'date_to'),
	          dateFormat: 'MM/DD/YYYY',
	          isClearable: true,
	          placeholderText: 'date',
	          onChangeRaw: handlePacerDateChangeRaw.bind(null, 'date_to')
	        })
	      ),
	      _react2.default.createElement(
	        'button',
	        { type: 'submit', className: 'form-submit green', onClick: buyDocketSheet },
	        'Buy Docket Sheet'
	      ),
	      _react2.default.createElement(
	        'a',
	        { className: 'form-reset', onClick: clearPacerSearchFilter },
	        'Clear'
	      )
	    )
	  );
	};
	
	DocketPacerSearchBar.propTypes = {
	  showPastEntries: _propTypes2.default.any.isRequired,
	  pastEntriesHide: _propTypes2.default.any.isRequired,
	  changePacerFilter: _propTypes2.default.any.isRequired,
	  changePacerDate: _propTypes2.default.any.isRequired,
	  handlePacerDateChangeRaw: _propTypes2.default.any.isRequired,
	  pacerSearch: _propTypes2.default.any.isRequired,
	  buyDocketSheet: _propTypes2.default.any.isRequired,
	  clearPacerSearchFilter: _propTypes2.default.any.isRequired
	};
	
	exports.default = DocketPacerSearchBar;

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _immutable = __webpack_require__(30);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _DocketHeader = __webpack_require__(200);
	
	var _DocketHeader2 = _interopRequireDefault(_DocketHeader);
	
	var _DocketEntries = __webpack_require__(388);
	
	var _DocketEntries2 = _interopRequireDefault(_DocketEntries);
	
	var _DocketsPaginator = __webpack_require__(255);
	
	var _DocketsPaginator2 = _interopRequireDefault(_DocketsPaginator);
	
	var _UpdateRedact = __webpack_require__(386);
	
	var _UpdateRedact2 = _interopRequireDefault(_UpdateRedact);
	
	var _SearchReceipt = __webpack_require__(416);
	
	var _SearchReceipt2 = _interopRequireDefault(_SearchReceipt);
	
	var _MissingEntriesTooltip = __webpack_require__(384);
	
	var _MissingEntriesTooltip2 = _interopRequireDefault(_MissingEntriesTooltip);
	
	var _LastFilingTooltip = __webpack_require__(383);
	
	var _LastFilingTooltip2 = _interopRequireDefault(_LastFilingTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DocketsTable = function (_Component) {
	  _inherits(DocketsTable, _Component);
	
	  function DocketsTable() {
	    _classCallCheck(this, DocketsTable);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  DocketsTable.prototype.render = function render() {
	    var _props = this.props,
	        DocketsPopupComponentType = _props.DocketsPopupComponentType,
	        docketEntriesProps = _props.docketEntriesProps,
	        showMissingDockets = _props.showMissingDockets,
	        docketsPaginatorProps = _props.docketsPaginatorProps,
	        header = _props.header,
	        lastUpdated = _props.lastUpdated,
	        error = _props.error,
	        receipt = _props.receipt,
	        popup = _props.popup,
	        showPacerSearchBarClassName = _props.showPacerSearchBarClassName,
	        collapseHeader = _props.collapseHeader,
	        showRedactPopup = _props.showRedactPopup,
	        closeRedactPopup = _props.closeRedactPopup,
	        redact = _props.redact,
	        reloadDetails = _props.reloadDetails,
	        onPopupClick = _props.onPopupClick;
	
	
	    return _react2.default.createElement(
	      'div',
	      { id: 'dockets-tabs', className: 'dockets-table' },
	      _react2.default.createElement(
	        'div',
	        { className: showPacerSearchBarClassName },
	        showMissingDockets && _react2.default.createElement(_MissingEntriesTooltip2.default, null),
	        header.hasMoreRecentFilingsDate && _react2.default.createElement(_LastFilingTooltip2.default, { date: header.latest_known_date_filed }),
	        _react2.default.createElement(_DocketHeader2.default, { open: !collapseHeader, data: header, lastUpdated: lastUpdated }),
	        _react2.default.createElement(_DocketEntries2.default, docketEntriesProps),
	        _react2.default.createElement(_DocketsPaginator2.default, docketsPaginatorProps),
	        !_lodash2.default.isEmpty(receipt) && _react2.default.createElement(_SearchReceipt2.default, { receipt: _immutable2.default.fromJS({ text: receipt }) }),
	        _react2.default.createElement(_UpdateRedact2.default, { showRedactPopup: showRedactPopup, closeRedactPopup: closeRedactPopup, redact: redact }),
	        DocketsPopupComponentType && _react2.default.createElement(DocketsPopupComponentType, { onClose: onPopupClick, info: popup, reloadDetails: reloadDetails })
	      )
	    );
	  };
	
	  return DocketsTable;
	}(_react.Component);
	
	DocketsTable.defaultProps = {
	  receipt: null,
	  showMissingDockets: false
	};
	
	DocketsTable.propTypes = {
	  DocketsPopupComponentType: _propTypes2.default.any.isRequired,
	  docketFilterProps: _propTypes2.default.object.isRequired,
	  docketEntriesProps: _propTypes2.default.object.isRequired,
	  showMissingDockets: _propTypes2.default.bool,
	  header: _propTypes2.default.object.isRequired,
	  docketsPaginatorProps: _propTypes2.default.object.isRequired,
	  lastUpdated: _propTypes2.default.string.isRequired,
	  error: _propTypes2.default.any.isRequired,
	  receipt: _propTypes2.default.any,
	  popup: _propTypes2.default.any.isRequired,
	  showPacerSearchBarClassName: _propTypes2.default.string.isRequired,
	  collapseHeader: _propTypes2.default.bool.isRequired,
	  showRedactPopup: _propTypes2.default.bool.isRequired,
	  closeRedactPopup: _propTypes2.default.func.isRequired,
	  redact: _propTypes2.default.func.isRequired,
	  reloadDetails: _propTypes2.default.func.isRequired,
	  onPopupClick: _propTypes2.default.func.isRequired
	};
	
	exports.default = DocketsTable;

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LastFilingTooltip(_ref) {
	  var date = _ref.date;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'messages status missing-entries-tooltip' },
	    'Last filing was on ',
	    date,
	    ', you can update dockets for more recent filings.'
	  );
	}
	
	LastFilingTooltip.propTypes = {
	  date: _propTypes2.default.string.isRequired
	};
	
	exports.default = LastFilingTooltip;

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MissingEntriesTooltip() {
	  return _react2.default.createElement(
	    "div",
	    { className: "messages status missing-entries-tooltip" },
	    "This docket is missing some entries. Please review the entire docket below to purchase any missing docket entries of interest."
	  );
	}
	
	exports.default = MissingEntriesTooltip;

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ToolbarButtons = function (_Component) {
	  _inherits(ToolbarButtons, _Component);
	
	  function ToolbarButtons() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ToolbarButtons);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onPopupClick = function (name, download_option) {
	      var _this$props = _this.props,
	          case_uuid = _this$props.case_uuid,
	          court_code = _this$props.court_code,
	          case_number = _this$props.case_number,
	          visibleDocketNums = _this$props.visibleDocketNums,
	          getDocketParts = _this$props.getDocketParts,
	          updateDocketParts = _this$props.updateDocketParts;
	
	
	      var params = {
	        case_uuid: case_uuid,
	        court_code: court_code,
	        case_number: case_number,
	        docket_numbers: visibleDocketNums
	      };
	
	      if (download_option) {
	        params.download_option = download_option;
	      }
	
	      getDocketParts(params);
	
	      _this.props.onPopupClick({
	        name: name,
	        show: true,
	        data: params
	      });
	
	      // do we need this here?
	      updateDocketParts({});
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ToolbarButtons.prototype.render = function render() {
	    var toggleHeader = this.props.toggleHeader;
	
	
	    return _react2.default.createElement(
	      'div',
	      { id: 'docket-toolbar-buttons', className: 'right menu' },
	      _react2.default.createElement(
	        'a',
	        { className: 'item ',
	          onClick: toggleHeader,
	          title: 'Toggle Docket Header Display' },
	        _react2.default.createElement('span', { className: 'expand icon' }),
	        ' Header'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'ui delayed dropdown item' },
	        _react2.default.createElement('span', { className: 'printer icon' }),
	        ' Print',
	        _react2.default.createElement(
	          'div',
	          { className: 'menu' },
	          _react2.default.createElement(
	            'div',
	            { className: 'item',
	              title: 'Prints Docket Sheet and Header (if visible) ',
	              onClick: window.print_preview },
	            _react2.default.createElement('span', { className: 'text page icon' }),
	            ' Docket Sheet'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'item',
	              title: 'Opens bulk docket download and combine form',
	              onClick: this.onPopupClick.bind(null, 'PrintAllPdfInRangePopup', 0) },
	            _react2.default.createElement('span', { className: 'pdf icon' }),
	            ' All PDFs in range'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'ui delayed dropdown item ', id: 'docket-download-menu' },
	        _react2.default.createElement('span', { className: 'download icon' }),
	        ' Download',
	        _react2.default.createElement(
	          'div',
	          { className: 'menu' },
	          _react2.default.createElement(
	            'div',
	            { className: 'item', onClick: this.onPopupClick.bind(null, 'DownloadZipAllPdfsRangePopup', 1) },
	            _react2.default.createElement('span', { className: 'zip icon' }),
	            ' ZIP all PDFs in range'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'item', onClick: this.onPopupClick.bind(null, 'DownloadZipWithSubpartsPopup', 1) },
	            _react2.default.createElement('span', { className: 'zip icon' }),
	            ' ZIP with subparts combined'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'item', onClick: this.onPopupClick.bind(null, 'DownloadCombineAllPdfInRangePopup', 1) },
	            _react2.default.createElement('span', { className: 'pdf icon' }),
	            ' Combine all PDFs in range'
	          )
	        )
	      )
	    );
	  };
	
	  return ToolbarButtons;
	}(_react.Component);
	
	ToolbarButtons.propTypes = {
	  visibleDocketNums: _propTypes2.default.array.isRequired,
	  case_uuid: _propTypes2.default.string.isRequired,
	  onPopupClick: _propTypes2.default.func.isRequired,
	  toggleHeader: _propTypes2.default.func.isRequired,
	  updateDocketParts: _propTypes2.default.func.isRequired,
	  getDocketParts: _propTypes2.default.func.isRequired
	};
	
	exports.default = ToolbarButtons;

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Popup = __webpack_require__(69);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UpdateRedact = function UpdateRedact(_ref) {
	  var showRedactPopup = _ref.showRedactPopup,
	      closeRedactPopup = _ref.closeRedactPopup,
	      redact = _ref.redact;
	  return _react2.default.createElement(
	    _Popup2.default,
	    { show: showRedactPopup,
	      clsName: 'dockets-popup',
	      topBarTitle: 'Update or Redact Entry?',
	      onClose: closeRedactPopup },
	    _react2.default.createElement(
	      'div',
	      { className: 'inner-text' },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Updating / Redacting will delete existing data and fetch the new data from Pacer. If the court has removed a PDF, this will remove it from CourtDrive. If the court corrected an error, this will make the same correction.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'You should only update / redact an existing entry if you believe it requires correction (e.g., a court ordered redaction, docketing error, updated pleading).'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'ui-dialog-buttonpane ui-widget-content ui-helper-clearfix' },
	      _react2.default.createElement(
	        'div',
	        { className: 'ui-dialog-buttonset' },
	        _react2.default.createElement(
	          'button',
	          { type: 'button', onClick: closeRedactPopup },
	          'Cancel'
	        ),
	        _react2.default.createElement(
	          'button',
	          { type: 'button', onClick: redact },
	          'Continue'
	        )
	      )
	    )
	  );
	};
	
	UpdateRedact.defaultProps = {
	  showRedactPopup: false
	};
	
	UpdateRedact.propTypes = {
	  closeRedactPopup: _propTypes2.default.func.isRequired,
	  redact: _propTypes2.default.func.isRequired,
	  showRedactPopup: _propTypes2.default.bool
	};
	
	exports.default = UpdateRedact;

/***/ },
/* 387 */
373,
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _DocketEntriesTableBody = __webpack_require__(389);
	
	var _DocketEntriesTableBody2 = _interopRequireDefault(_DocketEntriesTableBody);
	
	var _MissingEntry = __webpack_require__(392);
	
	var _MissingEntry2 = _interopRequireDefault(_MissingEntry);
	
	var _DocketEntry = __webpack_require__(170);
	
	var _DocketEntry2 = _interopRequireDefault(_DocketEntry);
	
	var _DocketEntriesTableHeader = __webpack_require__(390);
	
	var _DocketEntriesTableHeader2 = _interopRequireDefault(_DocketEntriesTableHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DocketEntries = function (_Component) {
	  _inherits(DocketEntries, _Component);
	
	  function DocketEntries() {
	    _classCallCheck(this, DocketEntries);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  DocketEntries.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        lastUpdated = _props.lastUpdated,
	        redact = _props.redact,
	        buyMissingDockets = _props.buyMissingDockets,
	        showRedactPopup = _props.showRedactPopup,
	        case_uuid = _props.case_uuid,
	        court_code = _props.court_code,
	        case_number = _props.case_number,
	        sortDockets = _props.sortDockets,
	        updateClick = _props.updateClick,
	        pastEntriesClick = _props.pastEntriesClick,
	        entries = _props.entries,
	        showMissingDockets = _props.showMissingDockets,
	        latest_known_date_filed = _props.latest_known_date_filed,
	        selectedDocket = _props.selectedDocket;
	
	    // consider moving the rows prop to instead be react-children
	
	    var itemRows = null;
	
	    if (_lodash2.default.isEmpty(entries.data)) {
	      itemRows = _react2.default.createElement(
	        'tr',
	        { key: 'empty-data' },
	        _react2.default.createElement(
	          'td',
	          { colSpan: '4' },
	          ' No Dockets Found'
	        )
	      );
	    } else {
	      itemRows = entries.data.reduce(function (accum, docket, idx) {
	        var key = 'docket-entry-' + idx;
	
	        if (docket.missing && showMissingDockets) {
	          accum.push(_react2.default.createElement(_MissingEntry2.default, { id: key, key: key, missing: docket.missing, buyMissingDockets: buyMissingDockets }));
	          return accum;
	        }
	
	        if (docket.isVisible) {
	          accum.push(_react2.default.createElement(_DocketEntry2.default, {
	            id: key,
	            key: key,
	            docket: docket,
	            redact: redact,
	            showRedactPopup: showRedactPopup,
	            case_uuid: case_uuid,
	            court_code: court_code,
	            case_number: case_number,
	            onGetDocuments: _this2.props.onGetDocuments,
	            selectedDocket: selectedDocket
	          }));
	        }
	
	        return accum;
	      }, []);
	    }
	
	    var lastUpdatedTitle = 'Import dockets from ' + latest_known_date_filed + ' to present and update header.\nPACER charges apply per click.';
	
	    return _react2.default.createElement(
	      'div',
	      { id: 'ir-search-dockets-results', className: this.props.className },
	      _react2.default.createElement(
	        'table',
	        { className: 'filter-searchable' },
	        _react2.default.createElement(_DocketEntriesTableHeader2.default, {
	          sortDockets: sortDockets,
	          lastUpdated: lastUpdated,
	          lastUpdatedTitle: lastUpdatedTitle,
	          updateClick: updateClick,
	          pastEntriesClick: pastEntriesClick
	        }),
	        _react2.default.createElement(_DocketEntriesTableBody2.default, { rows: itemRows, keywords: this.props.keyword })
	      )
	    );
	  };
	
	  return DocketEntries;
	}(_react.Component);
	
	DocketEntries.defaultProps = {
	  redact: null,
	  showMissingDockets: false,
	  className: '',
	  // used to identify this specific component when used as React.Child
	  // https://github.com/facebook/react/issues/4915
	  displayName: 'DocketEntries',
	  keyword: null
	};
	
	DocketEntries.propTypes = {
	  entries: _propTypes2.default.object.isRequired,
	  lastUpdated: _propTypes2.default.any.isRequired,
	  buyMissingDockets: _propTypes2.default.any.isRequired,
	  onGetDocuments: _propTypes2.default.any.isRequired,
	  showRedactPopup: _propTypes2.default.any.isRequired,
	  case_uuid: _propTypes2.default.any.isRequired,
	  sortDockets: _propTypes2.default.any.isRequired,
	  updateClick: _propTypes2.default.any.isRequired,
	  pastEntriesClick: _propTypes2.default.any.isRequired,
	  latest_known_date_filed: _propTypes2.default.string.isRequired,
	  redact: _propTypes2.default.any,
	  showMissingDockets: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  // eslint-disable-next-line
	  displayName: _propTypes2.default.string,
	  keyword: _propTypes2.default.string,
	  court_code: _propTypes2.default.string.isRequired,
	  case_number: _propTypes2.default.string.isRequired,
	  selectedDocket: _propTypes2.default.object.isRequired
	};
	
	exports.default = DocketEntries;

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TextHighlight = __webpack_require__(257);
	
	var _TextHighlight2 = _interopRequireDefault(_TextHighlight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DocketEntriesTableBody = function (_Component) {
	  _inherits(DocketEntriesTableBody, _Component);
	
	  function DocketEntriesTableBody(props) {
	    _classCallCheck(this, DocketEntriesTableBody);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.domElemRef = _react2.default.createRef();
	    return _this;
	  }
	
	  DocketEntriesTableBody.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'tbody',
	      { className: 'docket-entries-table', ref: this.domElemRef },
	      _react2.default.createElement(
	        _TextHighlight2.default,
	        { searchKeywords: this.props.keywords, getParentNode: function getParentNode() {
	            return _this2.domElemRef;
	          } },
	        this.props.rows
	      )
	    );
	  };
	
	  return DocketEntriesTableBody;
	}(_react.Component);
	
	DocketEntriesTableBody.defaultProps = {
	  keywords: ''
	};
	
	DocketEntriesTableBody.propTypes = {
	  rows: _propTypes2.default.node.isRequired,
	  keywords: _propTypes2.default.string
	};
	
	exports.default = DocketEntriesTableBody;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(32);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _TimeFromNow = __webpack_require__(679);
	
	var _TimeFromNow2 = _interopRequireDefault(_TimeFromNow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DocketEntriesTableHeader = function DocketEntriesTableHeader(_ref) {
	  var sortDockets = _ref.sortDockets,
	      lastUpdated = _ref.lastUpdated,
	      lastUpdatedTitle = _ref.lastUpdatedTitle,
	      updateClick = _ref.updateClick,
	      pastEntriesClick = _ref.pastEntriesClick;
	  return _react2.default.createElement(
	    'thead',
	    null,
	    _react2.default.createElement(
	      'tr',
	      null,
	      _react2.default.createElement(
	        'th',
	        { style: { width: '55px', whiteSpace: 'nowrap' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'item', onClick: sortDockets.bind(null, 'date_filed') },
	          'Date Filed'
	        )
	      ),
	      _react2.default.createElement(
	        'th',
	        { style: { width: '55px', textAlign: 'center' } },
	        '#'
	      ),
	      _react2.default.createElement(
	        'th',
	        { style: { width: '110px', textAlign: 'center' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'item', onClick: sortDockets.bind(null, 'docket_text') },
	          'Docket text'
	        )
	      ),
	      _react2.default.createElement(
	        'th',
	        { id: 'docket_update_ctrl' },
	        _react2.default.createElement(
	          'span',
	          { className: 'ir-search-refresh-date', title: (0, _moment2.default)(lastUpdated).format('MMM D YYYY h:mm a') },
	          'Last updated \xA0',
	          _react2.default.createElement(_TimeFromNow2.default, { dateTime: lastUpdated })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ui small secondary menu' },
	          _react2.default.createElement(
	            'div',
	            { className: 'item' },
	            _react2.default.createElement(
	              'div',
	              { id: 'update-from-pacer-link', title: lastUpdatedTitle, onClick: updateClick },
	              _react2.default.createElement('img', { src: '/sites/all/themes/inforuptcy/icons/icon-update.png', height: '23', width: '23' }),
	              'Update'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'item' },
	            _react2.default.createElement(
	              'div',
	              { title: 'Show/Hide Docket Import Form', onClick: pastEntriesClick },
	              _react2.default.createElement('img', { src: '/sites/all/themes/inforuptcy/icons/icon-past-entries.png', height: '23', width: '23' }),
	              'Past Entries'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	DocketEntriesTableHeader.defaultProps = {
	  lastUpdated: '',
	  lastUpdatedTitle: ''
	};
	
	DocketEntriesTableHeader.propTypes = {
	  sortDockets: _propTypes2.default.func.isRequired,
	  lastUpdated: _propTypes2.default.string,
	  lastUpdatedTitle: _propTypes2.default.string,
	  updateClick: _propTypes2.default.func.isRequired,
	  pastEntriesClick: _propTypes2.default.func.isRequired
	};
	
	exports.default = DocketEntriesTableHeader;

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _globalUtils = __webpack_require__(59);
	
	var _Loading = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Document = function Document(_ref) {
	  var document = _ref.document,
	      index = _ref.index,
	      downloadFile = _ref.downloadFile,
	      emailPartModal = _ref.emailPartModal,
	      printPreview = _ref.printPreview,
	      createBlogPost = _ref.createBlogPost,
	      ocrDownload = _ref.ocrDownload,
	      buyPdf = _ref.buyPdf;
	
	  var row = null;
	
	  if (document.isLoading) {
	    row = _react2.default.createElement(_Loading.Loading, { show: document.isLoading, type: 'spinner' });
	  } else if (document.is_cached) {
	    row = _react2.default.createElement(
	      'table',
	      null,
	      _react2.default.createElement(
	        'tbody',
	        null,
	        _react2.default.createElement(
	          'tr',
	          { className: 'no-filter-search docket-document' },
	          _react2.default.createElement(
	            'td',
	            { style: { whiteSpace: 'nowrap' } },
	            _react2.default.createElement(
	              'div',
	              { id: 'download', title: 'Download File', onClick: function onClick() {
	                  return downloadFile(document);
	                } },
	              _react2.default.createElement('span', { className: 'download icon' })
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'email-pdf',
	                onClick: function onClick() {
	                  return emailPartModal(document.friendly_name, document.docket_no, document.number);
	                },
	                id: 'email',
	                title: 'Email'
	              },
	              _react2.default.createElement('span', { className: 'email icon' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { onClick: function onClick() {
	                  return printPreview(document);
	                }, id: 'print', className: 'print', title: 'Print preview' },
	              _react2.default.createElement('span', { className: 'preview icon' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'permission-check-links' },
	              (0, _globalUtils.drupalPermsInclude)('Public Link to Docket Parts PDFs') && !_lodash2.default.isEmpty(document.public_pdf_link) && _react2.default.createElement(
	                'div',
	                { className: 'menu' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ui delayed dropdown item' },
	                  _react2.default.createElement(
	                    'a',
	                    { title: 'Public Download Link', href: document.public_pdf_link },
	                    _react2.default.createElement('span', { className: 'public link icon' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'menu', style: { display: 'none' } },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'item' },
	                      'For Public Download Link:'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'item' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: document.public_pdf_link },
	                        _react2.default.createElement('span', { className: 'pdf icon' }),
	                        'Right-Click Copy This Link'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'item' },
	                      'Or copy HTML Code below:'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'item' },
	                      _react2.default.createElement(
	                        'textarea',
	                        { onFocus: function onFocus(e) {
	                            return e.target.select();
	                          } },
	                        document.public_pdf_link
	                      )
	                    )
	                  )
	                )
	              ),
	              !(0, _globalUtils.isCourtDrive)() && (0, _globalUtils.drupalPermsInclude)('subscribe to blog') && _react2.default.createElement(
	                'div',
	                { title: 'Create blog post', onClick: function onClick() {
	                    return createBlogPost(document);
	                  } },
	                _react2.default.createElement('span', { className: 'blog-post icon' })
	              ),
	              (0, _globalUtils.drupalPermsInclude)('Docket Parts OCR Link') && _react2.default.createElement(
	                'div',
	                { id: 'download-OCR', title: 'Download OCR', onClick: function onClick() {
	                    return ocrDownload(document);
	                  } },
	                _react2.default.createElement('span', { className: 'download ocr icon' })
	              )
	            )
	          )
	        )
	      )
	    );
	  } else {
	    row = _react2.default.createElement(
	      'button',
	      { onClick: function onClick() {
	          return buyPdf(document.docket_no, document.number);
	        }, className: 'form-submit green' },
	      'Buy $',
	      document.cost
	    );
	  }
	
	  return _react2.default.createElement(
	    'tr',
	    { className: 'no-filter-search', key: 'document docket-detail-' + index },
	    _react2.default.createElement('td', null),
	    _react2.default.createElement(
	      'td',
	      { style: { verticalAlign: 'middle' } },
	      document.number
	    ),
	    _react2.default.createElement(
	      'td',
	      { style: { verticalAlign: 'middle' } },
	      document.description_html || 'Docket'
	    ),
	    _react2.default.createElement(
	      'td',
	      { style: { verticalAlign: 'middle' } },
	      document.pages
	    ),
	    _react2.default.createElement(
	      'td',
	      { style: { whiteSpace: 'nowrap' } },
	      row
	    )
	  );
	};
	
	Document.propTypes = {
	  document: _propTypes2.default.object.isRequired,
	  index: _propTypes2.default.number.isRequired,
	  downloadFile: _propTypes2.default.func.isRequired,
	  emailPartModal: _propTypes2.default.func.isRequired,
	  printPreview: _propTypes2.default.func.isRequired,
	  createBlogPost: _propTypes2.default.func.isRequired,
	  ocrDownload: _propTypes2.default.func.isRequired,
	  buyPdf: _propTypes2.default.func.isRequired
	};
	
	exports.default = Document;

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MissingEntry = function MissingEntry(_ref) {
	  var id = _ref.id,
	      buyMissingDockets = _ref.buyMissingDockets,
	      missing = _ref.missing;
	  return _react2.default.createElement(
	    'tr',
	    { key: 'missing-entry-' + id, className: 'missing-dockets' },
	    _react2.default.createElement(
	      'td',
	      { colSpan: '5' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'Missing Docket Entries'
	        ),
	        _react2.default.createElement(
	          'button',
	          { onClick: buyMissingDockets.bind(null, missing) },
	          'Fetch Missing Entries Now'
	        )
	      )
	    )
	  );
	};
	
	MissingEntry.propTypes = {
	  id: _propTypes2.default.string.isRequired,
	  buyMissingDockets: _propTypes2.default.func.isRequired,
	  missing: _propTypes2.default.object.isRequired
	};
	
	exports.default = MissingEntry;

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileLinkMessage = function FileLinkMessage(_ref) {
	  var link = _ref.link;
	  return _react2.default.createElement(
	    'div',
	    { className: 'batch-processed' },
	    'Please click',
	    _react2.default.createElement(
	      'a',
	      { id: 'download-link', target: '_blank', href: link },
	      ' here'
	    ),
	    ' to open the combined file.',
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'em',
	        null,
	        'Please allow popups from this site to have the file open automatically'
	      )
	    )
	  );
	};
	
	FileLinkMessage.propTypes = {
	  link: _propTypes2.default.string.isRequired
	};
	
	exports.default = FileLinkMessage;

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _LoadingBar = __webpack_require__(91);
	
	var _LoadingBar2 = _interopRequireDefault(_LoadingBar);
	
	var _UpdateFromPacer = __webpack_require__(70);
	
	var _UpdateFromPacer2 = _interopRequireDefault(_UpdateFromPacer);
	
	var _FilterTable = __webpack_require__(80);
	
	var _FilterTable2 = _interopRequireDefault(_FilterTable);
	
	var _HistoryFilters = __webpack_require__(398);
	
	var _HistoryFilters2 = _interopRequireDefault(_HistoryFilters);
	
	var _Flash = __webpack_require__(256);
	
	var _Flash2 = _interopRequireDefault(_Flash);
	
	__webpack_require__(945);
	
	var _HistoryPaginator = __webpack_require__(399);
	
	var _HistoryPaginator2 = _interopRequireDefault(_HistoryPaginator);
	
	var _HistoryEntries = __webpack_require__(395);
	
	var _HistoryEntries2 = _interopRequireDefault(_HistoryEntries);
	
	var _HistoryParserFilter = __webpack_require__(400);
	
	var _HistoryParserFilter2 = _interopRequireDefault(_HistoryParserFilter);
	
	var _Notification = __webpack_require__(40);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var History = function (_Component) {
	  _inherits(History, _Component);
	
	  function History() {
	    _classCallCheck(this, History);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  History.prototype.render = function render() {
	    var HistoryPopup = this.props.HistoryPopup;
	
	    if (!_lodash2.default.has(this.props.history, 'entries')) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'history' },
	        _react2.default.createElement(
	          'div',
	          { id: 'history-tabs' },
	          _react2.default.createElement(_LoadingBar2.default, null)
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'history' },
	      _react2.default.createElement(_Notification2.default, null),
	      _react2.default.createElement(_Flash2.default, { show: this.props.docketParts.showFlash, mailto: this.props.docketParts.email_address }),
	      _react2.default.createElement(
	        'div',
	        { className: this.props.type },
	        _react2.default.createElement(_HistoryParserFilter2.default, _extends({}, this.props.docketFilterProps, {
	          keyword: this.props.docketFilterProps.keyword })),
	        _react2.default.createElement(_HistoryPaginator2.default, _extends({}, this.props.historyPaginatorProps, { togglePacerFilterSection: this.props.togglePacerFilterSection, showUpdateHistory: true,
	          showPacerFilterSection: this.props.showPacerFilterSection })),
	        this.props.showPacerFilterSection && _react2.default.createElement(_HistoryFilters2.default, {
	          onSubmit: this.props.onSubmit,
	          togglePacerFilterSection: this.props.togglePacerFilterSection,
	          showPacerFilterSection: this.props.showPacerFilterSection
	        }),
	        _react2.default.createElement(_HistoryEntries2.default, _extends({}, this.props.historyEntriesProps, { tableSortProps: this.props.tableSortProps })),
	        _react2.default.createElement(_HistoryPaginator2.default, _extends({}, this.props.historyPaginatorProps, { showUpdateHistory: false })),
	        HistoryPopup && _react2.default.createElement(HistoryPopup, { onClose: this.props.onPopupClick, info: this.props.popup }),
	        _react2.default.createElement(_UpdateFromPacer2.default, {
	          pacerUpdateHandler: this.props.purchaseData,
	          pacerReceipt: this.props.receipt,
	          lastUpdated: this.props.lastUpdated })
	      )
	    );
	  };
	
	  return History;
	}(_react.Component);
	
	History.propTypes = {
	  onSubmit: _propTypes2.default.func
	};
	History.defaultProps = {
	  onSubmit: function onSubmit() {
	    return null;
	  }
	};
	
	
	History.defaultProps = {
	  error: null,
	  receipt: null,
	  type: 'history'
	};
	
	History.propTypes = {
	  case_uuid: _propTypes2.default.string.isRequired,
	  dataReady: _propTypes2.default.bool.isRequired,
	  history: _propTypes2.default.any.isRequired,
	  receipt: _propTypes2.default.any,
	  lastUpdated: _propTypes2.default.any.isRequired,
	  type: _propTypes2.default.string,
	  noDataFoundMessage: _propTypes2.default.string.isRequired,
	  getDocketDetails: _propTypes2.default.any.isRequired,
	  showRedactPopup: _propTypes2.default.any.isRequired,
	  buyPdf: _propTypes2.default.any.isRequired,
	  sortDockets: _propTypes2.default.any.isRequired,
	  updateClick: _propTypes2.default.any.isRequired,
	  pastEntriesClick: _propTypes2.default.any.isRequired,
	  historyEntriesProps: _propTypes2.default.any.isRequired,
	  onPopupClick: _propTypes2.default.func.isRequired,
	  error: _propTypes2.default.any,
	  purchaseData: _propTypes2.default.func.isRequired,
	  buyFromPacer: _propTypes2.default.func.isRequired,
	  buyFromAlfresco: _propTypes2.default.func.isRequired,
	  toggleEmailPopup: _propTypes2.default.func.isRequired
	};
	
	exports.default = History;

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Documents = __webpack_require__(201);
	
	var _Documents2 = _interopRequireDefault(_Documents);
	
	var _HistoryEntriesTableBody = __webpack_require__(396);
	
	var _HistoryEntriesTableBody2 = _interopRequireDefault(_HistoryEntriesTableBody);
	
	var _reactBootstrap = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HistoryEntries = function HistoryEntries(props) {
	  var history = props.history,
	      getDocketDetails = props.getDocketDetails,
	      case_uuid = props.case_uuid,
	      court_code = props.court_code,
	      case_number = props.case_number,
	      selectedDocketDetailNum = props.selectedDocketDetailNum,
	      sortHistory = props.sortHistory,
	      entries = props.entries,
	      tableSortProps = props.tableSortProps,
	      selectedDocket = props.selectedDocket;
	  var _history$docketDetail = history.docketDetails,
	      docketDetails = _history$docketDetail === undefined ? {} : _history$docketDetail;
	
	  var getClassName = function getClassName(index) {
	    return index % 2 === 0 ? 'even' : 'odd';
	  };
	  var sortIconsFA = {
	    'asc': 'fa-sort-up',
	    'desc': 'fa-sort-down'
	  };
	  var itemRows = null;
	
	  if (_lodash2.default.isEmpty(entries)) {
	    itemRows = _react2.default.createElement(
	      'tr',
	      null,
	      _react2.default.createElement(
	        'td',
	        { colSpan: '4' },
	        ' No History/Documents Found'
	      )
	    );
	  } else {
	    itemRows = entries.reduce(function (accum, p, idx) {
	      var text = p.text,
	          meta = p.meta;
	
	
	      var key = 'history-entry-' + text.docket_seq;
	      var visibilityClass = p.isVisible ? '' : 'hide-history-entry-row';
	
	      var colorClasses = {
	        0: 'in-pacer',
	        1: 'in-inforuptcy',
	        2: 'purchased'
	      };
	
	      var docketNumLink = !text.docket_uri ? text.docket_no || null : _react2.default.createElement(
	        'div',
	        { className: 'view_details ' + colorClasses[meta.purchased || 0],
	          dataDocketSeq: text.docket_seq,
	          href: '',
	          onClick: function onClick() {
	            return getDocketDetails(text);
	          } },
	        _react2.default.createElement(
	          'strong',
	          null,
	          ' ',
	          text.docket_no || "doc",
	          ' '
	        )
	      );
	
	      accum.push(_react2.default.createElement(
	        'tr',
	        { key: key, className: getClassName(idx) + ' docket_details ' + visibilityClass },
	        _react2.default.createElement(
	          'td',
	          { style: { textAlign: 'center', paddingLeft: 25 }, colSpan: '2' },
	          docketNumLink
	        ),
	        _react2.default.createElement(
	          'td',
	          { style: { paddingLeft: 15 } },
	          _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: text.docket_text } })
	        ),
	        _react2.default.createElement(
	          'td',
	          { style: { textAlign: 'center' } },
	          text.date_filed
	        ),
	        _react2.default.createElement(
	          'td',
	          { style: { textAlign: 'center' } },
	          text.date_terminated
	        )
	      ));
	
	      if (selectedDocket.docket_seq === text.docket_seq) {
	        if (selectedDocket.status === 'loading') accum.push(_react2.default.createElement(
	          'tr',
	          { key: 'details-' + key, className: getClassName(idx) + ' docket_details' },
	          _react2.default.createElement('td', { colSpan: '2' }),
	          _react2.default.createElement(
	            'td',
	            { style: { paddingTop: '26px' } },
	            _react2.default.createElement(_reactBootstrap.ProgressBar, { active: true, now: 100 })
	          ),
	          _react2.default.createElement('td', { colSpan: '100%' })
	        ));else if (selectedDocket.binder.documents && selectedDocket.binder.documents.length === 0) accum.push(_react2.default.createElement(
	          'tr',
	          { key: 'details-' + key, className: getClassName(idx) + ' docket_details' },
	          _react2.default.createElement('td', { colSpan: '2' }),
	          _react2.default.createElement(
	            'td',
	            { className: 'here', colSpan: '100%' },
	            'No Accessible Documents Found'
	          )
	        ));else if (selectedDocket.binder.documents && selectedDocket.binder.documents.length > 0) accum.push(_react2.default.createElement(
	          'tr',
	          { key: 'details-' + key, className: getClassName(idx) + ' docket_details ' + visibilityClass },
	          _react2.default.createElement('td', { colSpan: '2' }),
	          _react2.default.createElement(
	            'td',
	            { className: 'here', colSpan: '100%' },
	            _react2.default.createElement(
	              'table',
	              { className: 'sticky-enabled' },
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement('th', null),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Part'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Description'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Pages'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { width: '50%' },
	                    'Action'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tbody',
	                null,
	                _react2.default.createElement(_Documents2.default, {
	                  documents: selectedDocket.binder.documents,
	                  case_uuid: case_uuid,
	                  court_code: court_code,
	                  case_number: case_number,
	                  docket_seq: selectedDocket.docket_seq
	                })
	              )
	            )
	          )
	        ));
	      }
	
	      return accum;
	    }, []);
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { id: 'ir-search-history-results' },
	    _react2.default.createElement(
	      'table',
	      null,
	      _react2.default.createElement(
	        'thead',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            { style: { textAlign: 'center', minWidth: '20px' }, colSpan: '2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'item', onClick: sortHistory.bind(null, 'docket_no') },
	              '#',
	              tableSortProps.sort_field === 'docket_no' ? _react2.default.createElement('i', { className: 'fa ' + sortIconsFA[tableSortProps.sort_direction] }) : ''
	            )
	          ),
	          _react2.default.createElement(
	            'th',
	            { style: { whiteSpace: 'nowrap', paddingLeft: 15 } },
	            _react2.default.createElement(
	              'div',
	              { className: 'item', onClick: sortHistory.bind(null, 'docket_text') },
	              'Description',
	              tableSortProps.sort_field === 'docket_text' ? _react2.default.createElement('i', { className: 'fa ' + sortIconsFA[tableSortProps.sort_direction] }) : ''
	            )
	          ),
	          _react2.default.createElement(
	            'th',
	            { style: { textAlign: 'center', minWidth: '115px' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'item', onClick: sortHistory.bind(null, 'date_filed') },
	              'Date Filed/Entered',
	              tableSortProps.sort_field === 'date_filed' ? _react2.default.createElement('i', { className: 'fa ' + sortIconsFA[tableSortProps.sort_direction] }) : ''
	            )
	          ),
	          _react2.default.createElement(
	            'th',
	            { style: { textAlign: 'center', minWidth: '115px' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'item', onClick: sortHistory.bind(null, 'date_terminated') },
	              'Date Terminated',
	              tableSortProps.sort_field === 'date_terminated' ? _react2.default.createElement('i', { className: 'fa ' + sortIconsFA[tableSortProps.sort_direction] }) : ''
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_HistoryEntriesTableBody2.default, { rows: itemRows, keywords: props.keyword })
	    )
	  );
	};
	
	HistoryEntries.defaultProps = {
	  selectedDocketDetailNum: null,
	  redactSeqNum: null
	};
	
	HistoryEntries.propTypes = {
	  entries: _propTypes2.default.array.isRequired,
	  history: _propTypes2.default.any.isRequired,
	  getDocketDetails: _propTypes2.default.any.isRequired,
	  tableSortProps: _propTypes2.default.any.isRequired,
	  case_uuid: _propTypes2.default.any.isRequired,
	  sortHistory: _propTypes2.default.any.isRequired,
	  selectedDocketDetailNum: _propTypes2.default.string,
	  redactSeqNum: _propTypes2.default.any,
	  court_code: _propTypes2.default.string.isRequired,
	  case_number: _propTypes2.default.string.isRequired
	};
	
	exports.default = HistoryEntries;

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TextHighlight = __webpack_require__(257);
	
	var _TextHighlight2 = _interopRequireDefault(_TextHighlight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HistoryEntriesTableBody = function (_Component) {
	  _inherits(HistoryEntriesTableBody, _Component);
	
	  function HistoryEntriesTableBody(props) {
	    _classCallCheck(this, HistoryEntriesTableBody);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.domElemRef = _react2.default.createRef();
	    return _this;
	  }
	
	  HistoryEntriesTableBody.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'tbody',
	      { className: 'history-entries-table', ref: this.domElemRef },
	      _react2.default.createElement(
	        _TextHighlight2.default,
	        { searchKeywords: this.props.keywords, getParentNode: function getParentNode() {
	            return _this2.domElemRef;
	          } },
	        this.props.rows
	      )
	    );
	  };
	
	  return HistoryEntriesTableBody;
	}(_react.Component);
	
	HistoryEntriesTableBody.defaultProps = {
	  keywords: ''
	};
	
	HistoryEntriesTableBody.propTypes = {
	  rows: _propTypes2.default.node.isRequired,
	  keywords: _propTypes2.default.string
	};
	
	exports.default = HistoryEntriesTableBody;

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LoadingBar = __webpack_require__(92);
	
	var _LoadingBar2 = _interopRequireDefault(_LoadingBar);
	
	var _DocumentsRow = __webpack_require__(258);
	
	var _DocumentsRow2 = _interopRequireDefault(_DocumentsRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HistoryEntry = function HistoryEntry(_ref) {
	  var id = _ref.id,
	      docket = _ref.docket,
	      case_uuid = _ref.case_uuid,
	      onGetDocuments = _ref.onGetDocuments,
	      court_code = _ref.court_code,
	      case_number = _ref.case_number,
	      selectedDocket = _ref.selectedDocket;
	
	  var docketNumLink = !docket.has_pdf_link_on_pacer ? docket.docket_no || null : _react2.default.createElement(
	    'div',
	    { className: 'view_details ' + docket.colorCode, onClick: function onClick() {
	        return onGetDocuments(docket, court_code, case_number);
	      } },
	    _react2.default.createElement(
	      'strong',
	      null,
	      ' ',
	      docket.docket_no || 'doc',
	      ' '
	    )
	  );
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'tr',
	      { key: 'docket-entry-' + id, className: 'details-visible' },
	      _react2.default.createElement(
	        'td',
	        { colSpan: '2', style: { textAlign: 'center' } },
	        docketNumLink
	      ),
	      _react2.default.createElement(
	        'td',
	        null,
	        _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: docket.docket_text } }),
	        docket.status === 'loading' || selectedDocket.docket_no === docket.docket_no && selectedDocket.docket_seq === docket.docket_seq && selectedDocket.status === 'loading' && _react2.default.createElement(_LoadingBar2.default, { overrideShow: true })
	      ),
	      _react2.default.createElement(
	        'td',
	        null,
	        'Filed: ',
	        docket.date_filed
	      )
	    ),
	    selectedDocket.docket_no === docket.docket_no && selectedDocket.docket_seq === docket.docket_seq && selectedDocket.status !== 'loading' && _react2.default.createElement(_DocumentsRow2.default, {
	      id: id,
	      binder: selectedDocket.binder,
	      case_uuid: case_uuid,
	      court_code: court_code,
	      case_number: case_number,
	      docket_seq: docket.docket_seq
	    })
	  );
	};
	
	HistoryEntry.propTypes = {
	  id: _propTypes2.default.string.isRequired,
	  docket: _propTypes2.default.object.isRequired,
	  selectedDocket: _propTypes2.default.object.isRequired,
	  case_uuid: _propTypes2.default.string.isRequired,
	  onGetDocuments: _propTypes2.default.func.isRequired,
	  court_code: _propTypes2.default.string.isRequired,
	  case_number: _propTypes2.default.string.isRequired
	};
	
	exports.default = HistoryEntry;

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	__webpack_require__(241);
	
	__webpack_require__(945);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // packages
	
	// styles
	
	
	var HistoryFilters = function (_Component) {
	  _inherits(HistoryFilters, _Component);
	
	  function HistoryFilters() {
	    _classCallCheck(this, HistoryFilters);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  HistoryFilters.prototype.render = function render() {
	    var _props = this.props,
	        onSubmit = _props.onSubmit,
	        loadingSpinner = _props.loadingSpinner;
	
	
	    var show_docket = false;
	    var history_type = 'History';
	    return _react2.default.createElement(_reactFinalForm.Form, {
	      initialValues: { show_docket: show_docket, history_type: history_type },
	      onSubmit: onSubmit,
	      render: function render(_ref) {
	        var handleSubmit = _ref.handleSubmit,
	            submitting = _ref.submitting;
	        return _react2.default.createElement(
	          'div',
	          { id: 'history-pacer-filter', className: 'inside-block' },
	          _react2.default.createElement(
	            'form',
	            { onSubmit: handleSubmit, id: 'history-pacer-form' },
	            _react2.default.createElement(
	              'button',
	              { type: 'submit', disabled: submitting, className: 'form-submit green', style: { float: 'right', marginTop: 45 } },
	              loadingSpinner ? _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' }) : _react2.default.createElement(
	                'div',
	                null,
	                'Pacer Search'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'history-pacer-form-row' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'history_type' },
	                _react2.default.createElement(_reactFinalForm.Field, {
	                  name: 'history_type',
	                  component: 'input',
	                  type: 'radio',
	                  value: 'History'
	                }),
	                ' ',
	                'All events (history)'
	              ),
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'history_type' },
	                _react2.default.createElement(_reactFinalForm.Field, {
	                  name: 'history_type',
	                  component: 'input',
	                  type: 'radio',
	                  value: 'Documents'
	                }),
	                ' ',
	                'Only events with documents'
	              ),
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'show_docket' },
	                _react2.default.createElement(_reactFinalForm.Field, {
	                  name: 'show_docket',
	                  component: 'input',
	                  type: 'checkbox'
	                }),
	                ' ',
	                'Retrieve docket text (may significantly increase PACER fee)'
	              )
	            )
	          )
	        );
	      }
	    });
	  };
	
	  return HistoryFilters;
	}(_react.Component);
	
	HistoryFilters.propTypes = {
	  onSubmit: _propTypes2.default.func,
	  togglePacerFilterSection: _propTypes2.default.func,
	  loadingSpinner: _propTypes2.default.bool,
	  showPacerFilterSection: _propTypes2.default.bool
	};
	HistoryFilters.defaultProps = {
	  onSubmit: function onSubmit() {
	    return null;
	  },
	  togglePacerFilterSection: function togglePacerFilterSection() {
	    return null;
	  },
	  loadingSpinner: false,
	  showPacerFilterSection: true
	};
	exports.default = HistoryFilters;

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HistoryPaginator = function (_Component) {
	  _inherits(HistoryPaginator, _Component);
	
	  function HistoryPaginator(props) {
	    _classCallCheck(this, HistoryPaginator);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  HistoryPaginator.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        history = _props.history,
	        selectedPageNum = _props.selectedPageNum,
	        changePage = _props.changePage,
	        case_uuid = _props.case_uuid;
	
	
	    var numPages = Math.ceil(history.total_pages || 0);
	    var allItems = Math.ceil(history.total_items || 0);
	    var pageRange = _lodash2.default.range(numPages);
	    var nextPage = selectedPageNum + 1;
	    var prevPage = selectedPageNum - 1;
	    var lastPage = pageRange[pageRange.length - 1] + 1;
	
	    var max = 6;
	
	    var pageIconCount = numPages <= max ? numPages : max;
	
	    var paginatorItems = _lodash2.default.range(pageIconCount);
	
	    if (selectedPageNum < max) {
	      // take 1-9 + numPages
	      paginatorItems = paginatorItems.map(function (el, idx) {
	        if (idx === paginatorItems.length - 1) {
	          return numPages;
	        }
	        return idx + 1;
	      });
	    } else if (selectedPageNum >= numPages - (max + 2)) {
	      // 1 + take currPage - max   (ex: 14)
	      // 1 + take curr Page - max  (ex 10) with 12
	      paginatorItems = paginatorItems.map(function (el, idx) {
	        if (idx === paginatorItems.length - 1) {
	          return 1;
	        }
	        return numPages - idx;
	      }).reverse();
	    } else {
	      // ex case 13
	      // 1.. (1-4 range) currPage (1-4 range)..max
	      // 1,...  9, 10, 11, 12, 13, 14, 15, 16, 17, ..22
	      paginatorItems = paginatorItems.map(function (el, idx) {
	        if (idx === 0) {
	          return 1;
	        }
	        if (idx === paginatorItems.length - 1) {
	          return numPages;
	        }
	        return selectedPageNum + idx - 5;
	      });
	    }
	
	    paginatorItems = paginatorItems.reduce(function (accum, el, idx) {
	      var key = 'paginator-item' + idx;
	      var item = { page: el, active: selectedPageNum === el };
	      var clsName = item.active ? 'active item' : 'item';
	
	      if (idx !== 0 && paginatorItems[idx - 1] !== paginatorItems[idx] - 1) {
	        return accum.concat([_react2.default.createElement(
	          'span',
	          { className: 'item ellipse', key: key + '-ellipse' },
	          '...'
	        ), _react2.default.createElement(
	          'span',
	          {
	            key: key,
	            className: clsName,
	            onClick: changePage.bind(null, { page: el, page_index: el }) },
	          el
	        )]);
	      }
	      return accum.concat([_react2.default.createElement(
	        'span',
	        {
	          key: key,
	          className: clsName,
	          onClick: changePage.bind(null, { page: el, page_index: el }) },
	        el
	      )]);
	    }, []);
	
	    var paginator = paginatorItems;
	
	    var pageBackward = selectedPageNum !== 1 ? changePage.bind(null, { page: selectedPageNum - 1, page_index: prevPage }) : function () {
	      return null;
	    };
	
	    var pageForward = selectedPageNum !== lastPage ? changePage.bind(null, { page: selectedPageNum, page_index: nextPage }) : function () {
	      return null;
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'history-pagination' },
	      _react2.default.createElement(
	        'div',
	        { className: 'ui small borderless menu', id: 'history-toolbar' },
	        _react2.default.createElement(
	          'div',
	          { className: 'item ' + (selectedPageNum === 1 ? 'disabled' : ''),
	            title: 'Go to previous page',
	            onClick: pageBackward },
	          '\u2190'
	        ),
	        paginator,
	        numPages > 1 && _react2.default.createElement(
	          'div',
	          { className: 'view-all item',
	            onClick: changePage.bind(null, { page_index: 0, page_size: allItems }) },
	          'View all'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'item ' + (selectedPageNum === lastPage ? 'disabled' : ''),
	            title: 'Go to next page',
	            onClick: pageForward },
	          '\u2192'
	        ),
	        this.props.showUpdateHistory && _react2.default.createElement(
	          'div',
	          {
	            id: 'update-from-pacer-link',
	            onClick: function onClick() {
	              return _this2.props.togglePacerFilterSection();
	            }
	          },
	          _react2.default.createElement('img', { src: '/sites/all/themes/inforuptcy/icons/icon-update.png', height: '23', width: '23' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'selected-history-filter-' + this.props.showPacerFilterSection },
	            'Update History'
	          )
	        )
	      )
	    );
	  };
	
	  return HistoryPaginator;
	}(_react.Component);
	
	HistoryPaginator.defaultProps = {};
	
	HistoryPaginator.propTypes = {
	  history: _propTypes2.default.object.isRequired,
	  case_uuid: _propTypes2.default.string.isRequired,
	  selectedPageNum: _propTypes2.default.number.isRequired,
	  changePage: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired
	};
	
	exports.default = HistoryPaginator;

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDatepicker = __webpack_require__(78);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(104);
	__webpack_require__(130);
	
	var HistoryParserFilter = function (_Component) {
	  _inherits(HistoryParserFilter, _Component);
	
	  function HistoryParserFilter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HistoryParserFilter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.changeText = function (e) {
	      e.persist();
	      _this.props.onChange(e, 'keyword');
	    }, _this.keydown = function (e) {
	      // only respond to tabbing through or enter.
	      // Sometimes we need to blur out for other clicks that dont trigger a buy (ie cancel button)
	      if (e.keyCode === 13 || e.keyCode === 9) {
	        _this.props.buyFilteredDockets(e);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HistoryParserFilter.prototype.render = function render() {
	    var _props = this.props,
	        keyword = _props.keyword,
	        doc_range = _props.doc_range,
	        startDate = _props.startDate,
	        doc_range_error = _props.doc_range_error,
	        endDate = _props.endDate,
	        changeDate = _props.changeDate,
	        onChangeDateRaw = _props.onChangeDateRaw,
	        _onChange = _props.onChange,
	        onClear = _props.onClear,
	        buyFilteredDockets = _props.buyFilteredDockets;
	
	
	    return _react2.default.createElement(
	      'div',
	      { id: 'history-filters' },
	      _react2.default.createElement(
	        'form',
	        { id: 'parser-history-form', onSubmit: buyFilteredDockets },
	        _react2.default.createElement('input', { type: 'text',
	          name: 'keyword',
	          id: 'alfresco-keyword',
	          className: 'form-text',
	          size: '30',
	          value: keyword,
	          onKeyDown: this.keydown,
	          onChange: this.changeText,
	          placeholder: 'Enter Keywords' }),
	        _react2.default.createElement('input', { type: 'text',
	          name: 'doc_range',
	          id: 'alfresco-doc-range',
	          size: '20',
	          className: 'form-text valid',
	          value: doc_range,
	          onChange: function onChange(e) {
	            return _onChange(e, 'doc_range');
	          },
	          onKeyDown: this.keydown,
	          placeholder: 'Doc# Ex: 1,3,4-7' }),
	        doc_range_error,
	        _react2.default.createElement(
	          'div',
	          { className: 'date-selector' },
	          _react2.default.createElement(_reactDatepicker2.default, { selected: startDate,
	            onChange: changeDate.bind(null, 'startDate'),
	            dateFormat: 'MM/DD/YYYY',
	            className: '',
	            placeholderText: 'date',
	            onChangeRaw: onChangeDateRaw.bind(null, 'startDate') })
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          '\xA0to\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'date-selector' },
	          _react2.default.createElement(_reactDatepicker2.default, { selected: endDate,
	            onChange: changeDate.bind(null, 'endDate'),
	            dateFormat: 'MM/DD/YYYY',
	            className: '',
	            placeholderText: 'date',
	            onChangeRaw: onChangeDateRaw.bind(null, 'endDate') })
	        ),
	        _react2.default.createElement(
	          'button',
	          { type: 'submit', className: 'form-submit', value: 'Submit' },
	          _react2.default.createElement('span', { className: 'magnifier icon' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'alfresco-clear', className: 'clear-button', onClick: onClear },
	          'clear'
	        )
	      )
	    );
	  };
	
	  return HistoryParserFilter;
	}(_react.Component);
	
	HistoryParserFilter.defaultProps = {
	  startDate: null,
	  endDate: null
	};
	
	HistoryParserFilter.propTypes = {
	  keyword: _propTypes2.default.string.isRequired,
	  doc_range: _propTypes2.default.string.isRequired,
	  changeDate: _propTypes2.default.func.isRequired,
	  onChangeDateRaw: _propTypes2.default.func.isRequired,
	  onChange: _propTypes2.default.func.isRequired,
	  onClear: _propTypes2.default.func.isRequired,
	  filterTable: _propTypes2.default.func.isRequired,
	  buyFilteredDockets: _propTypes2.default.func.isRequired,
	  startDate: _propTypes2.default.string,
	  endDate: _propTypes2.default.string
	};
	
	exports.default = HistoryParserFilter;

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	__webpack_require__(241);
	
	__webpack_require__(242);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // packages
	
	// styles
	
	
	var EmailPopup = function (_Component) {
	  _inherits(EmailPopup, _Component);
	
	  function EmailPopup() {
	    _classCallCheck(this, EmailPopup);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  EmailPopup.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        sendDocketViaEmail = _props.sendDocketViaEmail,
	        loadingSpinner = _props.loadingSpinner;
	
	    var mail_to = this.props.emails.email;
	    var friendly_name = this.props.friendly_name;
	    var docketNumber = this.props.docketNumber;
	    var part_number = this.props.part_number;
	    return _react2.default.createElement(
	      'div',
	      { className: 'popup' },
	      _react2.default.createElement(_reactFinalForm.Form, {
	        initialValues: { mail_to: mail_to, friendly_name: friendly_name, docketNumber: docketNumber, part_number: part_number },
	        onSubmit: sendDocketViaEmail,
	        render: function render(_ref) {
	          var handleSubmit = _ref.handleSubmit,
	              pristine = _ref.pristine,
	              form = _ref.form,
	              reset = _ref.reset,
	              submitting = _ref.submitting;
	          return _react2.default.createElement(
	            'div',
	            { className: 'popup_inner' },
	            _react2.default.createElement(
	              'div',
	              { className: 'title' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Share Docket ',
	                _react2.default.createElement('i', { onClick: _this2.props.closePopup, className: 'fa fa-times-circle', style: { float: 'right', fontSize: '16px' } })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'popup-body' },
	              _react2.default.createElement(
	                'form',
	                { onSubmit: handleSubmit, id: 'related-form' },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'mail_to' },
	                  ' Email (separate by commas)',
	                  _react2.default.createElement(_reactFinalForm.Field, {
	                    name: 'mail_to',
	                    component: 'input',
	                    type: 'text',
	                    placeholder: ''
	                  })
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'message' },
	                  ' Message (optional)',
	                  _react2.default.createElement(_reactFinalForm.Field, {
	                    name: 'message',
	                    component: 'textarea',
	                    rows: '10',
	                    cols: '30',
	                    type: 'text',
	                    placeholder: ''
	                  })
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { type: 'submit', disabled: submitting || pristine, className: 'form-submit green' },
	                  loadingSpinner ? _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' }) : _react2.default.createElement(
	                    'div',
	                    null,
	                    'Sent'
	                  )
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'reset',
	                    onClick: reset,
	                    disabled: submitting,
	                    className: 'form-reset' },
	                  'Cancel'
	                )
	              )
	            )
	          );
	        }
	      })
	    );
	  };
	
	  return EmailPopup;
	}(_react.Component);
	
	EmailPopup.propTypes = {
	  sendDocketViaEmail: _propTypes2.default.func,
	  closePopup: _propTypes2.default.func,
	  loadingSpinner: _propTypes2.default.bool
	};
	EmailPopup.defaultProps = {
	  closePopup: function closePopup() {
	    return null;
	  },
	  sendDocketViaEmail: function sendDocketViaEmail() {
	    return null;
	  },
	  loadingSpinner: false
	};
	exports.default = EmailPopup;

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	__webpack_require__(241);
	
	__webpack_require__(242);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // packages
	
	// styles
	
	
	var PublicLinkPopup = function (_Component) {
	  _inherits(PublicLinkPopup, _Component);
	
	  function PublicLinkPopup() {
	    _classCallCheck(this, PublicLinkPopup);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  PublicLinkPopup.prototype.render = function render() {
	    var publicLinkHtml = '<a href="' + this.props.public_pdf_link + '">' + this.props.friendly_name + '</a>';
	    return _react2.default.createElement(
	      'div',
	      { className: 'menu public-popup' },
	      _react2.default.createElement('i', { onClick: this.props.closePopup, className: 'fa fa-times-circle', style: { float: 'right', fontSize: '16px' } }),
	      _react2.default.createElement(
	        'div',
	        { className: 'item' },
	        'For Public Download Link:'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'item' },
	        _react2.default.createElement(
	          'a',
	          { href: this.props.public_pdf_link },
	          _react2.default.createElement('span', { className: 'pdf icon' }),
	          ' Right-Click Copy This Link'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'item' },
	        'Or copy HTML Code below:'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'item' },
	        _react2.default.createElement('textarea', { rows: '7', cols: '30', defaultValue: publicLinkHtml, onFocus: function onFocus(e) {
	            return e.target.select();
	          } })
	      )
	    );
	  };
	
	  return PublicLinkPopup;
	}(_react.Component);
	
	PublicLinkPopup.propTypes = {
	  closePopup: _propTypes2.default.func,
	  public_pdf_link: _propTypes2.default.string,
	  friendly_name: _propTypes2.default.string
	};
	PublicLinkPopup.defaultProps = {
	  closePopup: function closePopup() {
	    return null;
	  },
	  public_pdf_link: '',
	  friendly_name: ''
	};
	exports.default = PublicLinkPopup;

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Documents = __webpack_require__(201);
	
	var _Documents2 = _interopRequireDefault(_Documents);
	
	var _LoadingBar = __webpack_require__(92);
	
	var _LoadingBar2 = _interopRequireDefault(_LoadingBar);
	
	var _loadingBar = __webpack_require__(199);
	
	var _loadingBar2 = _interopRequireDefault(_loadingBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RelatedTransactionEntries = function RelatedTransactionEntries(props) {
	  var transactions = props.transactions,
	      getDocketDetails = props.getDocketDetails,
	      reloadDetails = props.reloadDetails,
	      buyPdf = props.buyPdf,
	      onPopupClick = props.onPopupClick,
	      case_uuid = props.case_uuid,
	      selectedDocketDetailNum = props.selectedDocketDetailNum,
	      sortRelatedTransaction = props.sortRelatedTransaction,
	      entries = props.entries,
	      tableSortProps = props.tableSortProps;
	  var _transactions$docketD = transactions.docketDetails,
	      docketDetails = _transactions$docketD === undefined ? {} : _transactions$docketD;
	
	  var getClassName = function getClassName(index) {
	    return index % 2 === 0 ? 'even' : 'odd';
	  };
	  var sortIconsFA = {
	    asc: 'fa-sort-up',
	    desc: 'fa-sort-down'
	  };
	  var itemRows = null;
	
	  if (_lodash2.default.isEmpty(entries)) {
	    itemRows = _react2.default.createElement(
	      'tr',
	      null,
	      _react2.default.createElement(
	        'td',
	        { colSpan: '4' },
	        'No Transactions found.'
	      )
	    );
	  } else {
	    itemRows = entries.reduce(function (accum, p, idx) {
	      var key = 'docket-entry-' + idx;
	
	      var text = p.text,
	          meta = p.meta;
	
	
	      var colorClasses = {
	        0: 'in-pacer',
	        1: 'in-inforuptcy',
	        2: 'purchased'
	      };
	      var docketNumLink = !text.docket_uri ? text.docket_no || null : _react2.default.createElement(
	        'div',
	        { className: 'view_details ' + colorClasses[meta.purchased || 0],
	          onClick: getDocketDetails.bind(null, text.docket_no, '' + idx) },
	        _react2.default.createElement(
	          'strong',
	          null,
	          ' ',
	          text.docket_no || null,
	          ' '
	        )
	      );
	      var docketRelatedNumLink = function docketRelatedNumLink(docket_no, mainIndex, relatedIndex) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'view_details-related ' + colorClasses[meta.purchased || 0],
	            onClick: getDocketDetails.bind(null, docket_no, mainIndex + '-' + relatedIndex) },
	          _react2.default.createElement(
	            'strong',
	            null,
	            ' ',
	            docket_no || null,
	            ' '
	          )
	        );
	      };
	      var relatedTransactions = {};
	
	      if (text.related) {
	        var relatedDetailResults = function relatedDetailResults(item, keyValue) {
	          return docketDetails.seqNum && docketDetails.seqNum === item.docket_no && props.visibleDocketRow === idx + '-' + keyValue;
	        };
	        var relatedDetailLoadingBar = function relatedDetailLoadingBar(item, keyValue) {
	          return relatedDetailResults(item, keyValue) ? false : (selectedDocketDetailNum === item.order_docket_seq || selectedDocketDetailNum === item.docket_no && item.docket_no != null) && props.visibleDocketRow === idx + '-' + keyValue;
	        };
	
	        var relatedTransactionsParts = docketDetails.seqNum && docketDetails.details.length === 0 ? _react2.default.createElement(
	          'tr',
	          { key: 'details-' + key, className: getClassName(idx) + ' docket_details' },
	          _react2.default.createElement('td', { colSpan: '2' }),
	          _react2.default.createElement(
	            'td',
	            { className: 'here', colSpan: '100%' },
	            'No Accessible Documents Found'
	          )
	        ) : _react2.default.createElement(
	          'tr',
	          { key: 'details-' + key, className: getClassName(idx) + ' docket_details' },
	          _react2.default.createElement('td', { colSpan: '2' }),
	          _react2.default.createElement(
	            'td',
	            { className: 'here', colSpan: '100%' },
	            _react2.default.createElement(
	              'table',
	              { className: 'sticky-enabled' },
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement('th', null),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Part'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Description'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Pages'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { width: '50%' },
	                    'Action'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tbody',
	                null,
	                _react2.default.createElement(_Documents2.default, { docketDetails: docketDetails,
	                  buyPdf: buyPdf,
	                  onPopupClick: onPopupClick,
	                  case_uuid: case_uuid,
	                  docket_number: docketDetails.seqNum,
	                  reloadDetails: reloadDetails })
	              )
	            )
	          )
	        );
	
	        relatedTransactions = text.related.map(function (item, keyValue) {
	          return _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	              'tr',
	              { colSpan: '5', key: keyValue, className: getClassName(idx) + ' details-visible heading' },
	              _react2.default.createElement(
	                'td',
	                { align: 'right', colSpan: '2' },
	                docketRelatedNumLink(item.docket_no, idx, keyValue)
	              ),
	              _react2.default.createElement(
	                'td',
	                { style: { paddingLeft: '7px' } },
	                _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: item.event_name } }),
	                relatedDetailLoadingBar(item, keyValue) ? _react2.default.createElement(_LoadingBar2.default, { overrideShow: true }) : null
	              ),
	              _react2.default.createElement(
	                'td',
	                { style: { textAlign: 'center' } },
	                item.date_event_filed || ''
	              ),
	              _react2.default.createElement(
	                'td',
	                { style: { textAlign: 'center' } },
	                item.date_event_terminated || ''
	              )
	            ),
	            relatedDetailResults(item, keyValue) ? relatedTransactionsParts : null
	          );
	        });
	      }
	
	      if (docketDetails.seqNum && docketDetails.seqNum === text.docket_no && props.visibleDocketRow === '' + idx) {
	        accum.push(_react2.default.createElement(
	          _react2.default.Fragment,
	          null,
	          _react2.default.createElement(
	            'tr',
	            { key: key, className: getClassName(idx) + ' details-visible heading' },
	            _react2.default.createElement(
	              'td',
	              { colSpan: '2' },
	              docketNumLink
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: text.event_name } })
	              ),
	              docketDetailLoadingBar
	            ),
	            _react2.default.createElement(
	              'td',
	              { style: { textAlign: 'center' } },
	              text.date_event_filed
	            ),
	            _react2.default.createElement(
	              'td',
	              { style: { textAlign: 'center' } },
	              text.date_event_terminated
	            )
	          )
	        ));
	
	        if (docketDetails.details.length === 0) {
	          accum.push(_react2.default.createElement(
	            'tr',
	            { key: 'details-' + key, className: getClassName(idx) + ' docket_details' },
	            _react2.default.createElement('td', { colSpan: '2' }),
	            _react2.default.createElement(
	              'td',
	              { className: 'here', colSpan: '100%' },
	              'No Accessible Documents Found'
	            )
	          ));
	        } else {
	          accum.push(_react2.default.createElement(
	            'tr',
	            { key: 'details-' + key, className: getClassName(idx) + ' docket_details' },
	            _react2.default.createElement('td', { colSpan: '2' }),
	            _react2.default.createElement(
	              'td',
	              { className: 'here', colSpan: '100%' },
	              _react2.default.createElement(
	                'table',
	                { className: 'sticky-enabled' },
	                _react2.default.createElement(
	                  'thead',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement('th', null),
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Part'
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Description'
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Pages'
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { width: '50%' },
	                      'Action'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'tbody',
	                  null,
	                  _react2.default.createElement(_Documents2.default, { docketDetails: docketDetails,
	                    buyPdf: buyPdf,
	                    case_uuid: case_uuid,
	                    docket_number: docketDetails.seqNum,
	                    reloadDetails: reloadDetails })
	                )
	              )
	            )
	          ));
	        }
	        accum.push(relatedTransactions);
	
	        return accum;
	      }
	
	      var docketDetailLoadingBar = (selectedDocketDetailNum === text.order_docket_seq || selectedDocketDetailNum === text.docket_no && text.docket_no != null) && props.visibleDocketRow === '' + idx ? _react2.default.createElement(_LoadingBar2.default, { overrideShow: true }) : null;
	
	      accum.push(_react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'tr',
	          { key: key, className: getClassName(idx) + ' details-visible heading' },
	          _react2.default.createElement(
	            'td',
	            { colSpan: '2', style: { textAlign: 'center' } },
	            docketNumLink
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: text.event_name } })
	            ),
	            docketDetailLoadingBar
	          ),
	          _react2.default.createElement(
	            'td',
	            { style: { textAlign: 'center' } },
	            text.date_event_filed
	          ),
	          _react2.default.createElement(
	            'td',
	            { style: { textAlign: 'center' } },
	            text.date_event_terminated
	          )
	        )
	      ));
	      accum.push(relatedTransactions);
	      return accum;
	    }, []);
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { id: 'ir-search-related-transactions-results' },
	    _react2.default.createElement(
	      'table',
	      null,
	      _react2.default.createElement(
	        'thead',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            { style: { textAlign: 'center', minWidth: '60px' }, colSpan: '2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'item', onClick: sortRelatedTransaction.bind(null, 'docket_no') },
	              '#',
	              tableSortProps.sort_field === 'docket_no' ? _react2.default.createElement('i', { className: 'fa ' + sortIconsFA[tableSortProps.sort_direction] }) : ''
	            )
	          ),
	          _react2.default.createElement(
	            'th',
	            { style: { whiteSpace: 'nowrap' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'item', onClick: sortRelatedTransaction.bind(null, 'event_name') },
	              'Event Name',
	              tableSortProps.sort_field === 'event_name' ? _react2.default.createElement('i', { className: 'fa ' + sortIconsFA[tableSortProps.sort_direction] }) : ''
	            )
	          ),
	          _react2.default.createElement(
	            'th',
	            { style: { textAlign: 'center', minWidth: '90px' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'item', onClick: sortRelatedTransaction.bind(null, 'date_event_filed') },
	              'Event Filed',
	              tableSortProps.sort_field === 'date_event_filed' ? _react2.default.createElement('i', { className: 'fa ' + sortIconsFA[tableSortProps.sort_direction] }) : ''
	            )
	          ),
	          _react2.default.createElement(
	            'th',
	            { style: { textAlign: 'center', minWidth: '90px' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'item', onClick: sortRelatedTransaction.bind(null, 'date_event_terminated') },
	              'Event Terminated',
	              tableSortProps.sort_field === 'date_event_terminated' ? _react2.default.createElement('i', { className: 'fa ' + sortIconsFA[tableSortProps.sort_direction] }) : ''
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'tbody',
	        { className: 'docket-entries-table' },
	        itemRows
	      )
	    )
	  );
	};
	
	RelatedTransactionEntries.defaultProps = {
	  selectedDocketDetailNum: null,
	  redactSeqNum: null
	};
	
	RelatedTransactionEntries.propTypes = {
	  entries: _propTypes2.default.array.isRequired,
	  transactions: _propTypes2.default.any.isRequired,
	  getDocketDetails: _propTypes2.default.any.isRequired,
	  tableSortProps: _propTypes2.default.any.isRequired,
	  buyPdf: _propTypes2.default.any.isRequired,
	  case_uuid: _propTypes2.default.any.isRequired,
	  sortRelatedTransaction: _propTypes2.default.any.isRequired,
	  onPopupClick: _propTypes2.default.func.isRequired,
	  selectedDocketDetailNum: _propTypes2.default.number,
	  redactSeqNum: _propTypes2.default.any
	};
	
	exports.default = RelatedTransactionEntries;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RelatedTransactionPaginator = function (_Component) {
	  _inherits(RelatedTransactionPaginator, _Component);
	
	  function RelatedTransactionPaginator(props) {
	    _classCallCheck(this, RelatedTransactionPaginator);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  RelatedTransactionPaginator.prototype.render = function render() {
	    var _props = this.props,
	        transactions = _props.transactions,
	        selectedPageNum = _props.selectedPageNum,
	        changePage = _props.changePage,
	        case_uuid = _props.case_uuid;
	
	
	    var numPages = Math.ceil(transactions.total_pages || 0);
	    var allItems = Math.ceil(transactions.total_items || 0);
	    var pageRange = _lodash2.default.range(numPages);
	    var nextPage = selectedPageNum + 1;
	    var prevPage = selectedPageNum - 1;
	    var lastPage = pageRange[pageRange.length - 1] + 1;
	
	    var max = 6;
	
	    var pageIconCount = numPages <= max ? numPages : max;
	
	    var paginatorItems = _lodash2.default.range(pageIconCount);
	
	    if (selectedPageNum < max) {
	      // take 1-9 + numPages
	      paginatorItems = paginatorItems.map(function (el, idx) {
	        if (idx === paginatorItems.length - 1) {
	          return numPages;
	        }
	        return idx + 1;
	      });
	    } else if (selectedPageNum >= numPages - (max + 2)) {
	      // 1 + take currPage - max   (ex: 14)
	      // 1 + take curr Page - max  (ex 10) with 12
	      paginatorItems = paginatorItems.map(function (el, idx) {
	        if (idx === paginatorItems.length - 1) {
	          return 1;
	        }
	        return numPages - idx;
	      }).reverse();
	    } else {
	      // ex case 13
	      // 1.. (1-4 range) currPage (1-4 range)..max
	      // 1,...  9, 10, 11, 12, 13, 14, 15, 16, 17, ..22
	      paginatorItems = paginatorItems.map(function (el, idx) {
	        if (idx === 0) {
	          return 1;
	        }
	        if (idx === paginatorItems.length - 1) {
	          return numPages;
	        }
	        return selectedPageNum + idx - 5;
	      });
	    }
	
	    paginatorItems = paginatorItems.reduce(function (accum, el, idx) {
	      var key = 'paginator-item' + idx;
	      var item = { page: el, active: selectedPageNum === el };
	      var clsName = item.active ? 'active item' : 'item';
	
	      if (idx !== 0 && paginatorItems[idx - 1] !== paginatorItems[idx] - 1) {
	        return accum.concat([_react2.default.createElement(
	          'span',
	          { className: 'item ellipse', key: key + '-ellipse' },
	          '...'
	        ), _react2.default.createElement(
	          'span',
	          {
	            key: key,
	            className: clsName,
	            onClick: changePage.bind(null, { page: el, page_index: el }) },
	          el
	        )]);
	      }
	      return accum.concat([_react2.default.createElement(
	        'span',
	        {
	          key: key,
	          className: clsName,
	          onClick: changePage.bind(null, { page: el, page_index: el }) },
	        el
	      )]);
	    }, []);
	
	    var paginator = paginatorItems;
	
	    var pageBackward = selectedPageNum !== 1 ? changePage.bind(null, { page: selectedPageNum - 1, page_index: prevPage }) : function () {
	      return null;
	    };
	
	    var pageForward = selectedPageNum !== lastPage ? changePage.bind(null, { page: selectedPageNum, page_index: nextPage }) : function () {
	      return null;
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'relatedTransaction-pagination' },
	      _react2.default.createElement(
	        'div',
	        { className: 'ui small borderless menu', id: 'relatedTransaction-toolbar' },
	        _react2.default.createElement(
	          'div',
	          { className: 'item ' + (selectedPageNum === 1 ? 'disabled' : ''),
	            title: 'Go to previous page',
	            onClick: pageBackward },
	          '\u2190'
	        ),
	        paginator,
	        numPages > 1 && _react2.default.createElement(
	          'div',
	          { className: 'view-all item',
	            onClick: changePage.bind(null, { page_index: 0, page_size: allItems }) },
	          'View all'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'item ' + (selectedPageNum === lastPage ? 'disabled' : ''),
	            title: 'Go to next page',
	            onClick: pageForward },
	          '\u2192'
	        )
	      )
	    );
	  };
	
	  return RelatedTransactionPaginator;
	}(_react.Component);
	
	RelatedTransactionPaginator.defaultProps = {};
	
	RelatedTransactionPaginator.propTypes = {
	  transactions: _propTypes2.default.object.isRequired,
	  case_uuid: _propTypes2.default.string.isRequired,
	  selectedPageNum: _propTypes2.default.number.isRequired,
	  changePage: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired
	};
	
	exports.default = RelatedTransactionPaginator;

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactDatepicker = __webpack_require__(78);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(32);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	__webpack_require__(241);
	
	__webpack_require__(242);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // packages
	
	// styles
	
	
	var RelatedTransactionsFilters = function (_Component) {
	  _inherits(RelatedTransactionsFilters, _Component);
	
	  function RelatedTransactionsFilters() {
	    _classCallCheck(this, RelatedTransactionsFilters);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  RelatedTransactionsFilters.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        onSubmit = _props.onSubmit,
	        loadingSpinner = _props.loadingSpinner;
	
	
	    var DateField = function DateField(_ref) {
	      var input = _ref.input,
	          label = _ref.label,
	          rest = _objectWithoutProperties(_ref, ['input', 'label']);
	
	      return _react2.default.createElement(_reactDatepicker2.default, _extends({}, input, {
	        minDate: (0, _moment2.default)().subtract(15, 'years'),
	        maxDate: (0, _moment2.default)(),
	        selected: input.value ? (0, _moment2.default)(input.value) : null,
	        dateFormat: 'MM/DD/YYYY',
	        showMonthDropdown: true,
	        showYearDropdown: true,
	        dropdownMode: 'select',
	        placeholderText: 'date'
	      }, rest));
	    };
	    var options = [{ value: 'answer', label: 'answer' }, { value: 'auditor', label: 'auditor' }, { value: 'appeal', label: 'appeal' }, { value: 'caseupld', label: 'caseupld' }, { value: 'claims', label: 'claims' }, { value: 'cmp', label: 'cmp' }, { value: 'cmpX', label: 'cmpX' }, { value: 'court', label: 'court' }, { value: 'crditcrd', label: 'crditcrd' }, { value: 'hrg', label: 'hrg' }, { value: 'misc', label: 'misc' }, { value: 'motion', label: 'motion' }, { value: 'nef', label: 'nef' }, { value: 'notice', label: 'notice' }, { value: 'order', label: 'order' }, { value: 'plan', label: 'plan' }, { value: 'trustee', label: 'trustee' }, { value: 'utility', label: 'utility' }];
	    var SelectField = function SelectField(_ref2) {
	      var input = _ref2.input,
	          rest = _objectWithoutProperties(_ref2, ['input']);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'select-parent' },
	        _react2.default.createElement(_reactSelect2.default, _extends({}, input, rest, {
	          onBlurResetsInput: false,
	          onSelectResetsInput: false,
	          simpleValue: true,
	          clearable: false,
	          searchable: false
	        }))
	      );
	    };
	
	    var pending = true;
	    return _react2.default.createElement(_reactFinalForm.Form, {
	      initialValues: { pending: pending },
	      onSubmit: onSubmit,
	      render: function render(_ref3) {
	        var handleSubmit = _ref3.handleSubmit,
	            pristine = _ref3.pristine,
	            form = _ref3.form,
	            submitting = _ref3.submitting;
	        return _react2.default.createElement(
	          'div',
	          { id: 'pacer-filter', className: 'inside-block' },
	          _this2.props.showPacerFilterSection ? _react2.default.createElement(
	            'a',
	            { className: 'hide-link filter_btn', onClick: function onClick() {
	                return _this2.props.togglePacerFilterSection();
	              } },
	            'Hide Pacer search'
	          ) : _react2.default.createElement(
	            'a',
	            { className: 'hide-link filter_btn', onClick: function onClick() {
	                return _this2.props.togglePacerFilterSection();
	              } },
	            'Show Pacer search'
	          ),
	          !_this2.props.showPacerFilterSection && _react2.default.createElement(
	            'div',
	            { id: 'related-form' },
	            _react2.default.createElement(
	              'div',
	              { className: 'tip' },
	              'Leave blank for all dockets or specify document or date range to search partial docket sheet'
	            )
	          ),
	          _this2.props.showPacerFilterSection && _react2.default.createElement(
	            'form',
	            { onSubmit: handleSubmit, id: 'related-form' },
	            _react2.default.createElement(
	              'div',
	              { className: 'tip' },
	              'Leave blank for all dockets or specify document or date range to import partial docket sheet'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'related-form-row' },
	              _react2.default.createElement(_reactFinalForm.Field, {
	                name: 'doc_from',
	                component: 'input',
	                type: 'text',
	                placeholder: 'Doc#'
	              }),
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'doc_to' },
	                'to',
	                _react2.default.createElement(_reactFinalForm.Field, {
	                  name: 'doc_to',
	                  component: 'input',
	                  type: 'text',
	                  placeholder: 'Doc#'
	                })
	              ),
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'date_from' },
	                '\xA0 OR \xA0',
	                _react2.default.createElement(_reactFinalForm.Field, {
	                  name: 'date_from',
	                  component: DateField,
	                  type: 'text',
	                  placeholder: 'Date'
	                })
	              ),
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'date_to' },
	                '\xA0 to \xA0',
	                _react2.default.createElement(_reactFinalForm.Field, {
	                  name: 'date_to',
	                  component: DateField,
	                  type: 'text',
	                  placeholder: 'Date'
	                })
	              ),
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'doc_type' },
	                ' Type:',
	                _react2.default.createElement(_reactFinalForm.Field, {
	                  name: 'doc_type',
	                  component: SelectField,
	                  options: options,
	                  placeholder: 'select...'
	                })
	              ),
	              _react2.default.createElement(
	                'button',
	                { type: 'submit', disabled: submitting, className: 'form-submit green' },
	                loadingSpinner ? _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' }) : _react2.default.createElement(
	                  'div',
	                  null,
	                  'Pacer Search'
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'reset',
	                  onClick: function onClick() {
	                    return form.reset();
	                  },
	                  disabled: submitting,
	                  className: 'form-reset' },
	                'Clear/ Show All'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'related-form-row' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'pending' },
	                'Pending:',
	                _react2.default.createElement(_reactFinalForm.Field, {
	                  name: 'pending',
	                  component: 'input',
	                  type: 'checkbox'
	                })
	              ),
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'terminated' },
	                'Terminated:',
	                _react2.default.createElement(_reactFinalForm.Field, {
	                  name: 'terminated',
	                  component: 'input',
	                  type: 'checkbox'
	                })
	              )
	            )
	          )
	        );
	      }
	    });
	  };
	
	  return RelatedTransactionsFilters;
	}(_react.Component);
	
	RelatedTransactionsFilters.propTypes = {
	  onSubmit: _propTypes2.default.func,
	  togglePacerFilterSection: _propTypes2.default.func,
	  case_uuid: _propTypes2.default.string,
	  loadingSpinner: _propTypes2.default.bool,
	  showPacerFilterSection: _propTypes2.default.bool
	};
	RelatedTransactionsFilters.defaultProps = {
	  case_uuid: '',
	  onSubmit: function onSubmit() {
	    return null;
	  },
	  togglePacerFilterSection: function togglePacerFilterSection() {
	    return null;
	  },
	  loadingSpinner: false,
	  showPacerFilterSection: true
	};
	exports.default = RelatedTransactionsFilters;

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactDatepicker = __webpack_require__(78);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(32);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(241);
	
	__webpack_require__(242);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // packages
	
	// styles
	
	
	var RelatedTransactionsParser = function (_Component) {
	  _inherits(RelatedTransactionsParser, _Component);
	
	  function RelatedTransactionsParser() {
	    _classCallCheck(this, RelatedTransactionsParser);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  RelatedTransactionsParser.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        onSubmit = _props.onSubmit,
	        loadingSpinner = _props.loadingSpinner,
	        onReset = _props.onReset;
	
	
	    var DateField = function DateField(_ref) {
	      var input = _ref.input,
	          label = _ref.label,
	          rest = _objectWithoutProperties(_ref, ['input', 'label']);
	
	      return _react2.default.createElement(_reactDatepicker2.default, _extends({}, input, {
	        minDate: (0, _moment2.default)().subtract(15, 'years'),
	        maxDate: (0, _moment2.default)(),
	        selected: input.value ? (0, _moment2.default)(input.value) : null,
	        dateFormat: 'MM/DD/YYYY',
	        showMonthDropdown: true,
	        showYearDropdown: true,
	        dropdownMode: 'select',
	        placeholderText: 'date'
	      }, rest));
	    };
	    var pending = true;
	    return _react2.default.createElement(_reactFinalForm.Form, {
	      initialValues: { pending: pending },
	      onSubmit: onSubmit,
	      render: function render(_ref2) {
	        var handleSubmit = _ref2.handleSubmit,
	            pristine = _ref2.pristine,
	            form = _ref2.form,
	            submitting = _ref2.submitting;
	        return _react2.default.createElement(
	          'div',
	          { id: 'pacer-filter', className: 'inside-block' },
	          !_this2.props.showPacerFilterSection && _react2.default.createElement(
	            'form',
	            { onSubmit: handleSubmit, id: 'related-form-parser' },
	            _react2.default.createElement(
	              'div',
	              { className: 'related-form-row' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'keyword' },
	                _react2.default.createElement(_reactFinalForm.Field, {
	                  name: 'keyword',
	                  component: 'input',
	                  id: 'alfresco-keyword',
	                  type: 'text',
	                  placeholder: 'Find what'
	                })
	              ),
	              _react2.default.createElement(_reactFinalForm.Field, {
	                name: 'doc_from',
	                component: 'input',
	                type: 'text',
	                placeholder: 'Doc#'
	              }),
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'doc_to' },
	                _react2.default.createElement(_reactFinalForm.Field, {
	                  name: 'doc_to',
	                  component: 'input',
	                  type: 'text',
	                  placeholder: 'Doc#'
	                })
	              ),
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'date_from' },
	                _react2.default.createElement(_reactFinalForm.Field, {
	                  name: 'date_from',
	                  component: DateField,
	                  type: 'text',
	                  placeholder: 'Date'
	                })
	              ),
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'date_to' },
	                _react2.default.createElement(_reactFinalForm.Field, {
	                  name: 'date_to',
	                  component: DateField,
	                  type: 'text',
	                  placeholder: 'Date'
	                })
	              ),
	              _react2.default.createElement(
	                'button',
	                { type: 'submit', disabled: submitting, className: 'form-submit' },
	                loadingSpinner ? _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' }) : _react2.default.createElement('div', { className: 'magnifier icon' })
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'reset',
	                  onClick: function onClick() {
	                    return onReset();
	                  },
	                  disabled: submitting,
	                  className: 'form-reset' },
	                'Clear/ Show All'
	              )
	            )
	          )
	        );
	      }
	    });
	  };
	
	  return RelatedTransactionsParser;
	}(_react.Component);
	
	RelatedTransactionsParser.propTypes = {
	  onSubmit: _propTypes2.default.func,
	  case_uuid: _propTypes2.default.string,
	  loadingSpinner: _propTypes2.default.bool
	};
	RelatedTransactionsParser.defaultProps = {
	  case_uuid: '',
	  onSubmit: function onSubmit() {
	    return null;
	  },
	  loadingSpinner: false
	};
	exports.default = RelatedTransactionsParser;

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	__webpack_require__(946);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeleteModal = function DeleteModal(_ref) {
	  var show = _ref.show,
	      onClose = _ref.onClose,
	      onConfirm = _ref.onConfirm,
	      title = _ref.title,
	      content = _ref.children;
	  return _react2.default.createElement(
	    _reactBootstrap.Modal,
	    { show: show, onHide: onClose, className: 'confirmation-modal' },
	    _react2.default.createElement(
	      _reactBootstrap.Modal.Header,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Modal.Title,
	        null,
	        title
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Modal.Body,
	      null,
	      content
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Modal.Footer,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        { onClick: onClose },
	        'Keep'
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: 'danger', onClick: onConfirm },
	        'Delete'
	      )
	    )
	  );
	};
	
	DeleteModal.defaultProps = {
	  show: false,
	  children: _react2.default.createElement('div', null)
	};
	
	DeleteModal.propTypes = {
	  onClose: _propTypes2.default.func.isRequired,
	  onConfirm: _propTypes2.default.func.isRequired,
	  show: _propTypes2.default.bool,
	  title: _propTypes2.default.string.isRequired,
	  children: _propTypes2.default.any
	};
	
	exports.default = DeleteModal;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NoResults = function (_Component) {
	    _inherits(NoResults, _Component);
	
	    function NoResults() {
	        _classCallCheck(this, NoResults);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    NoResults.prototype.render = function render() {
	        return _react2.default.createElement(
	            'h2',
	            { style: { color: 'red' } },
	            'No Records Found'
	        );
	    };
	
	    return NoResults;
	}(_react.Component);
	
	exports.default = NoResults;

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _formData = __webpack_require__(49);
	
	var _courts = __webpack_require__(111);
	
	var _courts2 = _interopRequireDefault(_courts);
	
	__webpack_require__(2179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var refineSearchParametersMap = {
	  court_type: 'Court type',
	  keys: 'Fulltext keywords',
	  judge_name: 'Judge',
	  assets: 'Assets (in USD)',
	  liabilities: 'Liabilities (in USD)',
	  nature_of_suit: 'Nature of Suit',
	  chapter: 'Chapter',
	  query: 'Query',
	  court: 'Court',
	  date_filed: 'Case filed'
	};
	
	var courtsMap = _lodash2.default.keyBy(_courts2.default, 'code');
	var querySelectOptionsMap = _lodash2.default.keyBy(_formData.querySelectOptions, 'value');
	var courtTypesMap = {
	  all: 'All',
	  bankruptcy: 'Bankruptcy',
	  civil: 'Civil',
	  criminal: 'Criminal',
	  appellate: 'Appellate',
	  national: 'National'
	};
	
	var getHumanReadableFacetCategoryItemKey = function getHumanReadableFacetCategoryItemKey(facetCategoryItemKey, facetCategory) {
	  if (facetCategory === 'query') {
	    return querySelectOptionsMap[facetCategoryItemKey].label;
	  }
	  if (facetCategory === 'court') {
	    return courtsMap[facetCategoryItemKey].name;
	  }
	  if (facetCategory === 'court_type') {
	    return courtTypesMap[facetCategoryItemKey];
	  }
	  return facetCategoryItemKey;
	};
	
	var RefineSearch = function RefineSearch(_ref) {
	  var facets = _ref.facets,
	      advancedSearchFilter = _ref.advancedSearchFilter,
	      onSearchAdvancedFilings = _ref.onSearchAdvancedFilings;
	
	  var _useState = (0, _react.useState)(true),
	      isOpen = _useState[0],
	      setIsOpen = _useState[1];
	
	  var arrowIconClass = (0, _classnames2.default)({
	    glyphicon: true,
	    'glyphicon-triangle-bottom': isOpen,
	    'glyphicon-triangle-right': !isOpen
	  });
	
	  var refineSearchDetails = Object.keys(facets).sort().map(function (facetCategory) {
	    var facetCategoryItemsObject = facets[facetCategory];
	
	    return _react2.default.createElement(
	      'div',
	      { key: facetCategory },
	      !_lodash2.default.isEmpty(facetCategoryItemsObject) && _react2.default.createElement(
	        'h5',
	        null,
	        refineSearchParametersMap[facetCategory]
	      ),
	      Object.keys(facetCategoryItemsObject).sort().map(function (facetCategoryItemKey, refineSearchParameterValueIndex) {
	        var humanReadableFacetCategoryItemKey = getHumanReadableFacetCategoryItemKey(facetCategoryItemKey, facetCategory);
	        var facetCategoryItemValue = facetCategoryItemsObject[facetCategoryItemKey];
	        var isArrayKey = ['query', 'court_code', 'assets', 'industry', 'liabilities', 'nature_of_suit', 'chapter', 'case_type'].includes(facetCategory);
	
	        return facetCategoryItemsObject[facetCategoryItemKey] === -1 ? _react2.default.createElement(
	          'div',
	          { key: 'refine-search-parameter-value-' + refineSearchParameterValueIndex },
	          _react2.default.createElement(
	            'span',
	            {
	              className: 'facet-link',
	              onClick: function onClick() {
	                delete advancedSearchFilter[facetCategory];
	                onSearchAdvancedFilings(advancedSearchFilter);
	              }
	            },
	            '(-)'
	          ),
	          ' ',
	          humanReadableFacetCategoryItemKey
	        ) : _react2.default.createElement(
	          'div',
	          {
	            className: 'facet-link',
	            key: 'selected-refine-search-parameter-value-' + refineSearchParameterValueIndex,
	            onClick: function onClick() {
	              var _extends2;
	
	              return onSearchAdvancedFilings(_extends({}, advancedSearchFilter, (_extends2 = {}, _extends2[facetCategory] = isArrayKey ? [facetCategoryItemKey] : facetCategoryItemKey, _extends2)));
	            }
	          },
	          humanReadableFacetCategoryItemKey + ' (' + facetCategoryItemValue + ')'
	        );
	      })
	    );
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'refine-search-summary' },
	    _react2.default.createElement(
	      'div',
	      { onClick: function onClick() {
	          return setIsOpen(!isOpen);
	        } },
	      _react2.default.createElement(
	        'h5',
	        { className: 'refine-search-title' },
	        _react2.default.createElement('span', { className: arrowIconClass }),
	        ' Refine Search'
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Collapse,
	      { 'in': isOpen },
	      _react2.default.createElement(
	        'div',
	        { className: 'refine-search-details-container' },
	        refineSearchDetails
	      )
	    )
	  );
	};
	
	RefineSearch.propTypes = {
	  facets: _propTypes2.default.object.isRequired,
	  advancedSearchFilter: _propTypes2.default.object.isRequired,
	  onSearchAdvancedFilings: _propTypes2.default.func.isRequired
	};
	
	exports.default = RefineSearch;

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PopoverOfForm = function (_Component) {
	  _inherits(PopoverOfForm, _Component);
	
	  function PopoverOfForm() {
	    _classCallCheck(this, PopoverOfForm);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  PopoverOfForm.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactBootstrap.OverlayTrigger,
	      {
	        trigger: ['hover', 'focus'],
	        placement: 'right',
	        shouldUpdatePosition: true,
	        overlay: _react2.default.createElement(
	          _reactBootstrap.Popover,
	          { id: 'popover-of-form' },
	          this.props.children
	        ) },
	      _react2.default.createElement('span', { className: 'ir-tooltip' })
	    );
	  };
	
	  return PopoverOfForm;
	}(_react.Component);
	
	PopoverOfForm.defaultProps = {
	  children: null
	};
	
	PopoverOfForm.propTypes = {
	  children: _propTypes2.default.any
	  //   .oneOfType([
	  //   PropTypes.array,
	  //   PropTypes.element,
	  // ]),
	};
	
	exports.default = PopoverOfForm;

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.AppellateForm = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactDatepicker = __webpack_require__(78);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(32);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _lodash = __webpack_require__(4);
	
	var _courts = __webpack_require__(111);
	
	var _courts2 = _interopRequireDefault(_courts);
	
	var _appellateNosOptions = __webpack_require__(699);
	
	var _appellateNosOptions2 = _interopRequireDefault(_appellateNosOptions);
	
	var _localCourtSearchAction = __webpack_require__(271);
	
	var _formValidation = __webpack_require__(415);
	
	var _CaseNumberTooltip = __webpack_require__(206);
	
	var _CaseNumberTooltip2 = _interopRequireDefault(_CaseNumberTooltip);
	
	var _clientCodeAction = __webpack_require__(64);
	
	__webpack_require__(529);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var regionOptions = (0, _lodash.orderBy)(_courts2.default.reduce(function (accum, next) {
	  if (next.type === 'appellate') {
	    accum.push({
	      label: next.name,
	      value: next.code
	    });
	  }
	  return accum;
	}, []), ['label'], ['asc']);
	
	var _onSubmit = function _onSubmit(values, _ref) {
	  var clientCode = _ref.clientCode,
	      onSearch = _ref.onSearch,
	      isValidClientCode = _ref.isValidClientCode;
	
	  if (!isValidClientCode()) {
	    return;
	  }
	
	  values.pacer_client = clientCode;
	  onSearch(values);
	};
	
	var AppellateForm = exports.AppellateForm = function AppellateForm(props) {
	  return _react2.default.createElement(_reactFinalForm.Form, {
	    onSubmit: function onSubmit(values) {
	      return _onSubmit(values, props);
	    },
	    initialValues: {},
	    validate: _formValidation.validateAppellate,
	    render: function render(_ref2) {
	      var handleSubmit = _ref2.handleSubmit,
	          submitFailed = _ref2.submitFailed,
	          form = _ref2.form,
	          errors = _ref2.errors,
	          error = _ref2.error;
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit, className: 'local-court-form' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-item' },
	          _react2.default.createElement(
	            'label',
	            null,
	            'Region'
	          ),
	          _react2.default.createElement(
	            _reactFinalForm.Field,
	            {
	              name: 'court_code',
	              parse: function parse(_ref3) {
	                var value = _ref3.value;
	                return value;
	              }
	            },
	            function (_ref4) {
	              var input = _ref4.input,
	                  meta = _ref4.meta;
	              return _react2.default.createElement(_reactSelect2.default, _extends({}, input, {
	                clearable: false,
	                options: regionOptions,
	                placeholder: 'Select a jurisdiction',
	                className: 'form-select ' + (meta.error && meta.submitFailed ? 'error' : '')
	              }));
	            }
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-item' },
	          _react2.default.createElement(
	            'label',
	            null,
	            'Case Number',
	            _react2.default.createElement(_CaseNumberTooltip2.default, null)
	          ),
	          _react2.default.createElement(_reactFinalForm.Field, {
	            name: 'case_no',
	            component: 'input',
	            type: 'text',
	            maxLength: '128',
	            className: 'form-input ' + (submitFailed && errors && errors.case_no ? 'error' : '')
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-item form-item-group party-attorney' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'Party / Attorney'
	            ),
	            _react2.default.createElement(_reactFinalForm.Field, {
	              name: 'party_name',
	              component: 'input',
	              type: 'text',
	              maxLength: '128',
	              className: 'form-input ' + (submitFailed && errors && errors.party_name ? 'error' : '')
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactFinalForm.Field, {
	                name: 'search_party',
	                component: 'input',
	                type: 'checkbox'
	              }),
	              'Party'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactFinalForm.Field, {
	                name: 'search_attorney',
	                component: 'input',
	                type: 'checkbox'
	              }),
	              'Attorney'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-item' },
	          _react2.default.createElement(
	            'label',
	            null,
	            'Nature of Suit'
	          ),
	          _react2.default.createElement(
	            _reactFinalForm.Field,
	            { name: 'nos' },
	            function (_ref5) {
	              var input = _ref5.input;
	              return _react2.default.createElement(_reactSelect2.default, _extends({}, input, {
	                multi: true,
	                options: _appellateNosOptions2.default,
	                className: 'form-select'
	              }));
	            }
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-item form-item-group' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'Filed Date from'
	            ),
	            _react2.default.createElement(
	              _reactFinalForm.Field,
	              { name: 'filed_from' },
	              function (_ref6) {
	                var input = _ref6.input,
	                    meta = _ref6.meta;
	                return _react2.default.createElement(_reactDatepicker2.default, _extends({}, input, {
	                  selected: input.value ? (0, _moment2.default)(input.value) : null,
	                  onChangeRaw: input.onChange,
	                  dateFormat: 'MM/DD/YYYY',
	                  className: 'form-input ' + (meta.submitFailed && meta.error ? 'error' : '')
	                }));
	              }
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'Filed Date to'
	            ),
	            _react2.default.createElement(
	              _reactFinalForm.Field,
	              { name: 'filed_to' },
	              function (_ref7) {
	                var input = _ref7.input,
	                    meta = _ref7.meta;
	                return _react2.default.createElement(_reactDatepicker2.default, _extends({}, input, {
	                  selected: input.value ? (0, _moment2.default)(input.value) : null,
	                  onChangeRaw: input.onChange,
	                  dateFormat: 'MM/DD/YYYY',
	                  className: 'form-input ' + (meta.submitFailed && meta.error ? 'error' : '')
	                }));
	              }
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-item form-item-group' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'Closed Date from'
	            ),
	            _react2.default.createElement(
	              _reactFinalForm.Field,
	              { name: 'closed_from' },
	              function (_ref8) {
	                var input = _ref8.input,
	                    meta = _ref8.meta;
	                return _react2.default.createElement(_reactDatepicker2.default, _extends({}, input, {
	                  selected: input.value ? (0, _moment2.default)(input.value) : null,
	                  onChangeRaw: input.onChange,
	                  dateFormat: 'MM/DD/YYYY',
	                  className: 'form-input ' + (meta.submitFailed && meta.error ? 'error' : '')
	                }));
	              }
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'Closed Date to'
	            ),
	            _react2.default.createElement(
	              _reactFinalForm.Field,
	              { name: 'closed_to' },
	              function (_ref9) {
	                var input = _ref9.input,
	                    meta = _ref9.meta;
	                return _react2.default.createElement(_reactDatepicker2.default, _extends({}, input, {
	                  selected: input.value ? (0, _moment2.default)(input.value) : null,
	                  onChangeRaw: input.onChange,
	                  dateFormat: 'MM/DD/YYYY',
	                  className: 'form-input ' + (meta.submitFailed && meta.error ? 'error' : '')
	                }));
	              }
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'warning' },
	          'WARNING: By pressing on the "Search" button you will be billed for the total number of pages. This search is not subject to the 30-page limit on PACER charges so DO NOT use broad search criteria.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'action-btn-container' },
	          _react2.default.createElement(
	            'button',
	            { type: 'submit', className: 'form-submit green action-btn-search' },
	            'Search'
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: 'form-submit',
	              onClick: function onClick() {
	                form.reset();props.onClickSearchReset();
	              }
	            },
	            'Clear'
	          )
	        ),
	        submitFailed && error && _react2.default.createElement(
	          _reactBootstrap.Alert,
	          { bsStyle: 'danger' },
	          _react2.default.createElement(
	            'div',
	            null,
	            error
	          )
	        )
	      );
	    }
	  });
	};
	
	AppellateForm.propTypes = {
	  onSearch: _propTypes2.default.func.isRequired,
	  onClickSearchReset: _propTypes2.default.func.isRequired,
	  clientCode: _propTypes2.default.string
	};
	
	AppellateForm.defaultProps = {
	  clientCode: ''
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    clientCode: state.getIn(['clientCodeReducer', 'sessionClientCode'])
	  };
	};
	
	var mapDispatchToProps = {
	  onSearch: _localCourtSearchAction.searchAppellate,
	  onClickSearchReset: _localCourtSearchAction.resetLocalCourtSearch,
	  isValidClientCode: _clientCodeAction.hasValidClientCode
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AppellateForm);

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.BankruptcyForm = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _lodash = __webpack_require__(4);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactDatepicker = __webpack_require__(78);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(32);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _courts = __webpack_require__(111);
	
	var _courts2 = _interopRequireDefault(_courts);
	
	var _bkNosOptions = __webpack_require__(1208);
	
	var _bkNosOptions2 = _interopRequireDefault(_bkNosOptions);
	
	var _localCourtSearchAction = __webpack_require__(271);
	
	var _clientCodeAction = __webpack_require__(64);
	
	var _formValidation = __webpack_require__(415);
	
	var _CaseNumberTooltip = __webpack_require__(206);
	
	var _CaseNumberTooltip2 = _interopRequireDefault(_CaseNumberTooltip);
	
	__webpack_require__(529);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var regionOptions = (0, _lodash.orderBy)(_courts2.default.reduce(function (accum, next) {
	  if (next.type === 'bankruptcy') {
	    accum.push({
	      label: next.name.replace('Bankruptcy Court', '').trim(),
	      value: next.code
	    });
	  }
	  return accum;
	}, []), ['label'], ['asc']);
	
	var _onSubmit = function _onSubmit(values, _ref) {
	  var clientCode = _ref.clientCode,
	      onSearch = _ref.onSearch,
	      isValidClientCode = _ref.isValidClientCode;
	
	  if (!isValidClientCode()) {
	    return;
	  }
	
	  values.pacer_client = clientCode;
	  onSearch(values);
	};
	
	var BankruptcyForm = exports.BankruptcyForm = function BankruptcyForm(props) {
	  return _react2.default.createElement(_reactFinalForm.Form, {
	    onSubmit: function onSubmit(values) {
	      return _onSubmit(values, props);
	    },
	    initialValues: {},
	    validate: _formValidation.validateBankruptcy,
	    render: function render(_ref2) {
	      var handleSubmit = _ref2.handleSubmit,
	          submitFailed = _ref2.submitFailed,
	          form = _ref2.form,
	          errors = _ref2.errors,
	          error = _ref2.error;
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit, className: 'local-court-form' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-item' },
	          _react2.default.createElement(
	            'label',
	            null,
	            'Region'
	          ),
	          _react2.default.createElement(
	            _reactFinalForm.Field,
	            {
	              name: 'court_code',
	              parse: function parse(_ref3) {
	                var value = _ref3.value;
	                return value;
	              }
	            },
	            function (_ref4) {
	              var input = _ref4.input,
	                  meta = _ref4.meta;
	              return _react2.default.createElement(_reactSelect2.default, _extends({}, input, {
	                clearable: false,
	                options: regionOptions,
	                placeholder: 'Select a jurisdiction',
	                className: 'form-select ' + (meta.error && meta.submitFailed ? 'error' : '')
	              }));
	            }
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-item' },
	          _react2.default.createElement(
	            'label',
	            null,
	            'Case Number',
	            _react2.default.createElement(_CaseNumberTooltip2.default, null)
	          ),
	          _react2.default.createElement(_reactFinalForm.Field, {
	            name: 'case_no',
	            component: 'input',
	            type: 'text',
	            maxLength: '128',
	            placeholder: 'Search by case number - it\'s free',
	            className: 'form-input ' + (submitFailed && errors && errors.case_no ? 'error' : '')
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-separator' },
	          _react2.default.createElement(
	            'div',
	            { className: 'form-item-group' },
	            _react2.default.createElement('hr', null),
	            _react2.default.createElement(
	              'strong',
	              null,
	              'or search by'
	            ),
	            _react2.default.createElement('hr', null)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'warning' },
	            'WARNING: If you search with the following criteria your search will not be subject to the 30-page limit on PACER charges; you will be billed for ALL returned pages so DO NOT use broad search criteria.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-item form-item-group party-name' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'Last / Business Name'
	            ),
	            _react2.default.createElement(_reactFinalForm.Field, {
	              name: 'last_business_name',
	              component: 'input',
	              type: 'text',
	              maxLength: '128',
	              className: 'form-input ' + (submitFailed && errors && errors.last_business_name ? 'error' : '')
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'First Name'
	            ),
	            _react2.default.createElement(_reactFinalForm.Field, {
	              name: 'first_name',
	              component: 'input',
	              type: 'text',
	              maxLength: '128',
	              className: 'form-input ' + (submitFailed && errors && errors.first_name ? 'error' : '')
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'Middle Name'
	            ),
	            _react2.default.createElement(_reactFinalForm.Field, {
	              name: 'middle_name',
	              component: 'input',
	              type: 'text',
	              maxLength: '128',
	              className: 'form-input'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-item form-item-group' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'SSN / TIN'
	            ),
	            _react2.default.createElement(_reactFinalForm.Field, {
	              name: 'ssntin',
	              component: 'input',
	              type: 'text',
	              maxLength: '11',
	              className: 'form-input ' + (submitFailed && errors && errors.ssntin ? 'error' : '')
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'Tax ID / EIN'
	            ),
	            _react2.default.createElement(_reactFinalForm.Field, {
	              name: 'tax_ein',
	              component: 'input',
	              type: 'text',
	              maxLength: '128',
	              className: 'form-input'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-item form-item-group' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'Filed Date from'
	            ),
	            _react2.default.createElement(
	              _reactFinalForm.Field,
	              { name: 'filed_from' },
	              function (_ref5) {
	                var input = _ref5.input,
	                    meta = _ref5.meta;
	                return _react2.default.createElement(_reactDatepicker2.default, _extends({}, input, {
	                  selected: input.value ? (0, _moment2.default)(input.value) : null,
	                  onChangeRaw: input.onChange,
	                  dateFormat: 'MM/DD/YYYY',
	                  className: 'form-input ' + (meta.submitFailed && meta.error ? 'error' : '')
	                }));
	              }
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'Filed Date to'
	            ),
	            _react2.default.createElement(
	              _reactFinalForm.Field,
	              { name: 'filed_to' },
	              function (_ref6) {
	                var input = _ref6.input,
	                    meta = _ref6.meta;
	                return _react2.default.createElement(_reactDatepicker2.default, _extends({}, input, {
	                  selected: input.value ? (0, _moment2.default)(input.value) : null,
	                  onChangeRaw: input.onChange,
	                  dateFormat: 'MM/DD/YYYY',
	                  className: 'form-input ' + (meta.submitFailed && meta.error ? 'error' : '')
	                }));
	              }
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-item' },
	          _react2.default.createElement(
	            'label',
	            null,
	            'Nature of Suit (AP and MP cases only)'
	          ),
	          _react2.default.createElement(
	            _reactFinalForm.Field,
	            { name: 'nos' },
	            function (_ref7) {
	              var input = _ref7.input;
	              return _react2.default.createElement(_reactSelect2.default, _extends({}, input, {
	                multi: true,
	                options: _bkNosOptions2.default,
	                className: 'form-select'
	              }));
	            }
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'action-btn-container' },
	          _react2.default.createElement(
	            'button',
	            { type: 'submit', className: 'form-submit green action-btn-search' },
	            'Search'
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: 'form-submit',
	              onClick: function onClick() {
	                form.reset();props.onClickSearchReset();
	              }
	            },
	            'Clear'
	          )
	        ),
	        submitFailed && error && _react2.default.createElement(
	          _reactBootstrap.Alert,
	          { bsStyle: 'danger' },
	          _react2.default.createElement(
	            'div',
	            null,
	            error
	          )
	        )
	      );
	    }
	  });
	};
	
	BankruptcyForm.propTypes = {
	  onSearch: _propTypes2.default.func.isRequired,
	  onClickSearchReset: _propTypes2.default.func.isRequired,
	  clientCode: _propTypes2.default.string
	};
	
	BankruptcyForm.defaultProps = {
	  clientCode: ''
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    clientCode: state.getIn(['clientCodeReducer', 'sessionClientCode'])
	  };
	};
	
	var mapDispatchToProps = {
	  onSearch: _localCourtSearchAction.searchBankruptcy,
	  onClickSearchReset: _localCourtSearchAction.resetLocalCourtSearch,
	  isValidClientCode: _clientCodeAction.hasValidClientCode
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BankruptcyForm);

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CivilForm = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _lodash = __webpack_require__(4);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactDatepicker = __webpack_require__(78);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(32);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _courts = __webpack_require__(111);
	
	var _courts2 = _interopRequireDefault(_courts);
	
	var _districtNosOptions = __webpack_require__(207);
	
	var _districtNosOptions2 = _interopRequireDefault(_districtNosOptions);
	
	var _causes = __webpack_require__(1209);
	
	var _causes2 = _interopRequireDefault(_causes);
	
	var _localCourtSearchAction = __webpack_require__(271);
	
	var _formValidation = __webpack_require__(415);
	
	var _CaseNumberTooltip = __webpack_require__(206);
	
	var _CaseNumberTooltip2 = _interopRequireDefault(_CaseNumberTooltip);
	
	var _clientCodeAction = __webpack_require__(64);
	
	__webpack_require__(529);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var regionOptions = (0, _lodash.orderBy)(_courts2.default.reduce(function (accum, next) {
	  if (next.type === 'district') {
	    accum.push({
	      label: next.name.replace('District Court', '').trim(),
	      value: next.code
	    });
	  }
	  // CITDCE is not your ordinary Civil court, search/query page is different
	  // if (next.code === 'citdce') {
	  //   accum.push({
	  //     label: 'US International Trade',
	  //     value: next.code,
	  //   });
	  // }
	  return accum;
	}, []), ['label'], ['asc']);
	
	var _onSubmit = function _onSubmit(values, _ref) {
	  var clientCode = _ref.clientCode,
	      onSearch = _ref.onSearch,
	      isValidClientCode = _ref.isValidClientCode;
	
	  if (!isValidClientCode()) {
	    return;
	  }
	
	  values.pacer_client = clientCode;
	  onSearch(values);
	};
	
	var CivilForm = exports.CivilForm = function CivilForm(props) {
	  return _react2.default.createElement(_reactFinalForm.Form, {
	    onSubmit: function onSubmit(values) {
	      return _onSubmit(values, props);
	    },
	    initialValues: {},
	    validate: _formValidation.validateCivil,
	    render: function render(_ref2) {
	      var handleSubmit = _ref2.handleSubmit,
	          submitFailed = _ref2.submitFailed,
	          values = _ref2.values,
	          form = _ref2.form,
	          errors = _ref2.errors,
	          error = _ref2.error;
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit, className: 'local-court-form' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-item' },
	          _react2.default.createElement(
	            'label',
	            null,
	            'Region'
	          ),
	          _react2.default.createElement(
	            _reactFinalForm.Field,
	            {
	              name: 'court_code',
	              parse: function parse(_ref3) {
	                var value = _ref3.value;
	                return value;
	              }
	            },
	            function (_ref4) {
	              var input = _ref4.input,
	                  meta = _ref4.meta;
	              return _react2.default.createElement(_reactSelect2.default, _extends({}, input, {
	                clearable: false,
	                options: regionOptions,
	                onChange: function onChange(e) {
	                  values.cause_of_action = null;input.onChange(e);
	                },
	                placeholder: 'Select a jurisdiction',
	                className: 'form-select ' + (meta.error && meta.submitFailed ? 'error' : '')
	              }));
	            }
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-item' },
	          _react2.default.createElement(
	            'label',
	            null,
	            'Case Number',
	            _react2.default.createElement(_CaseNumberTooltip2.default, null)
	          ),
	          _react2.default.createElement(_reactFinalForm.Field, {
	            name: 'case_no',
	            component: 'input',
	            type: 'text',
	            maxLength: '128',
	            placeholder: 'Search by case number - it\'s free',
	            className: 'form-input ' + (submitFailed && errors && errors.case_no ? 'error' : '')
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-separator' },
	          _react2.default.createElement(
	            'div',
	            { className: 'form-item-group' },
	            _react2.default.createElement('hr', null),
	            _react2.default.createElement(
	              'strong',
	              null,
	              'or search by'
	            ),
	            _react2.default.createElement('hr', null)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'warning' },
	            'WARNING: If you search with the following criteria your search will not be subject to the 30-page limit on PACER charges; you will be billed for ALL returned pages so DO NOT use broad search criteria.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-item' },
	          _react2.default.createElement(
	            'label',
	            null,
	            'Nature of Suit'
	          ),
	          _react2.default.createElement(
	            _reactFinalForm.Field,
	            { name: 'nos' },
	            function (_ref5) {
	              var input = _ref5.input;
	              return _react2.default.createElement(_reactSelect2.default, _extends({}, input, {
	                multi: true,
	                options: _districtNosOptions2.default,
	                className: 'form-select'
	              }));
	            }
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-item' },
	          _react2.default.createElement(
	            'label',
	            null,
	            'Cause of Action'
	          ),
	          _react2.default.createElement(
	            _reactFinalForm.Field,
	            { name: 'cause_of_action' },
	            function (_ref6) {
	              var input = _ref6.input;
	              return _react2.default.createElement(_reactSelect2.default, _extends({}, input, {
	                multi: true,
	                options: (0, _causes2.default)(values.court_code),
	                className: 'form-select'
	              }));
	            }
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-item form-item-group' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'Filed Date from'
	            ),
	            _react2.default.createElement(
	              _reactFinalForm.Field,
	              { name: 'filed_from' },
	              function (_ref7) {
	                var input = _ref7.input,
	                    meta = _ref7.meta;
	                return _react2.default.createElement(_reactDatepicker2.default, _extends({}, input, {
	                  selected: input.value ? (0, _moment2.default)(input.value) : null,
	                  onChangeRaw: input.onChange,
	                  dateFormat: 'MM/DD/YYYY',
	                  className: 'form-input ' + (meta.submitFailed && meta.error ? 'error' : '')
	                }));
	              }
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'Filed Date to'
	            ),
	            _react2.default.createElement(
	              _reactFinalForm.Field,
	              { name: 'filed_to' },
	              function (_ref8) {
	                var input = _ref8.input,
	                    meta = _ref8.meta;
	                return _react2.default.createElement(_reactDatepicker2.default, _extends({}, input, {
	                  selected: input.value ? (0, _moment2.default)(input.value) : null,
	                  onChangeRaw: input.onChange,
	                  dateFormat: 'MM/DD/YYYY',
	                  className: 'form-input ' + (meta.submitFailed && meta.error ? 'error' : '')
	                }));
	              }
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'action-btn-container' },
	          _react2.default.createElement(
	            'button',
	            { type: 'submit', className: 'form-submit green action-btn-search' },
	            'Search'
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: 'form-submit',
	              onClick: function onClick() {
	                form.reset();props.onClickSearchReset();
	              }
	            },
	            'Clear'
	          )
	        ),
	        submitFailed && error && _react2.default.createElement(
	          _reactBootstrap.Alert,
	          { bsStyle: 'danger' },
	          _react2.default.createElement(
	            'div',
	            null,
	            error
	          )
	        )
	      );
	    }
	  });
	};
	
	CivilForm.propTypes = {
	  onSearch: _propTypes2.default.func.isRequired,
	  onClickSearchReset: _propTypes2.default.func.isRequired,
	  clientCode: _propTypes2.default.string
	};
	
	CivilForm.defaultProps = {
	  clientCode: ''
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    clientCode: state.getIn(['clientCodeReducer', 'sessionClientCode'])
	  };
	};
	
	var mapDispatchToProps = {
	  onSearch: _localCourtSearchAction.searchDistrict,
	  onClickSearchReset: _localCourtSearchAction.resetLocalCourtSearch,
	  isValidClientCode: _clientCodeAction.hasValidClientCode
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CivilForm);

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LocalCourtResults = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _BankruptcyPartiesResultTable = __webpack_require__(688);
	
	var _BankruptcyPartiesResultTable2 = _interopRequireDefault(_BankruptcyPartiesResultTable);
	
	var _CivilPartiesResultTable = __webpack_require__(690);
	
	var _CivilPartiesResultTable2 = _interopRequireDefault(_CivilPartiesResultTable);
	
	var _CivilCasesResultTable = __webpack_require__(689);
	
	var _CivilCasesResultTable2 = _interopRequireDefault(_CivilCasesResultTable);
	
	var _BankruptcyCasesResultTable = __webpack_require__(687);
	
	var _BankruptcyCasesResultTable2 = _interopRequireDefault(_BankruptcyCasesResultTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var resultTables = {
	  parties: {
	    Bankruptcy: _BankruptcyPartiesResultTable2.default,
	    Civil: _CivilPartiesResultTable2.default,
	    Criminal: _CivilPartiesResultTable2.default,
	    Appellate: _CivilPartiesResultTable2.default
	  },
	  cases: {
	    Bankruptcy: _BankruptcyCasesResultTable2.default,
	    Civil: _CivilCasesResultTable2.default,
	    Criminal: _CivilCasesResultTable2.default,
	    Appellate: _CivilCasesResultTable2.default
	  }
	};
	
	var LocalCourtResults = exports.LocalCourtResults = function LocalCourtResults(_ref) {
	  var searchResultsType = _ref.searchResultsType,
	      searchType = _ref.searchType,
	      data = _ref.data;
	
	  var ResultTable = resultTables[searchResultsType][searchType];
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'search-results' },
	    _react2.default.createElement(ResultTable, { data: data, searchType: searchType })
	  );
	};
	
	LocalCourtResults.propTypes = {
	  searchResultsType: _propTypes2.default.string.isRequired,
	  data: _propTypes2.default.any.isRequired,
	  searchType: _propTypes2.default.string.isRequired
	};
	
	exports.default = LocalCourtResults;

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.validateAppellate = exports.validateCivil = exports.validateBankruptcy = undefined;
	
	var _finalForm = __webpack_require__(124);
	
	var _moment = __webpack_require__(32);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _validations = __webpack_require__(137);
	
	var _validations2 = _interopRequireDefault(_validations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isDateRange1WeekOrLess = function isDateRange1WeekOrLess(filed_from, filed_to) {
	  // definitely not less than 1 week if not filled in
	  if (!filed_from) return false;
	  if (!filed_to) return false;
	
	  // since nothing can be filed in the future,
	  // we consider blank filedTo to be same as TODAY()
	  var endDate = filed_to || (0, _moment2.default)();
	
	  return endDate.diff(filed_from, 'weeks', true) <= 1.0;
	};
	
	var validateBankruptcy = exports.validateBankruptcy = function validateBankruptcy(values) {
	  var errors = {};
	
	  if (!values.court_code) {
	    errors.court_code = 'Region is required';
	  }
	
	  if (values.case_no && !_validations2.default.CASE_NUMBER(values.case_no)) {
	    errors.case_no = 'Invalid case number format.';
	  }
	
	  if (values.ssntin && !_validations2.default.SSN_OR_TIN(values.ssntin)) {
	    errors.ssntin = 'Invalid SSN/TIN.';
	  }
	
	  if (Object.keys(errors).length > 0) {
	    errors[_finalForm.FORM_ERROR] = Object.values(errors).reduce(function (acc, error) {
	      return acc ? acc + '\n' + error : error;
	    }, '');
	
	    return errors;
	  }
	
	  // Validate Input field combinations ----------------------------------------
	  // case_no is good enough
	  if (values.case_no) return;
	  // SSN is good enough
	  if (values.ssntin) return;
	  // Last and first ok
	  if (values.last_business_name && values.first_name) return;
	  // Last and small enough date range is OK
	  if (values.last_business_name && isDateRange1WeekOrLess(values.filed_from, values.filed_to)) return;
	  // 1 week date range
	  if (isDateRange1WeekOrLess(values.filed_from, values.filed_to)) return;
	
	  if (values.filed_from && !isDateRange1WeekOrLess(values.filed_from, values.filed_to)) {
	    errors[_finalForm.FORM_ERROR] = 'Date range must be no greater than 1 Week';
	    errors.filed_from = 'error';
	    errors.filed_to = 'error';
	
	    return errors;
	  }
	
	  if (values.last_business_name && !values.first_name && !isDateRange1WeekOrLess(values.filed_from, values.filed_to)) {
	    errors[_finalForm.FORM_ERROR] = 'Last / Business Name requires First name or Date Filed Range not greater than 1 week';
	    errors.first_name = 'error';
	    errors.filed_from = 'error';
	    errors.filed_to = 'error';
	
	    return errors;
	  }
	
	  errors[_finalForm.FORM_ERROR] = ['Please enter at least one combination:', '- Case Number', '- Last Name and First Name', '- Last / Business Name and Date Filed Range not greater than 1 week', '- SSN/TIN', '- Date Filed Range not greater than 1 week'].join('\n');
	
	  errors.case_no = 'error';
	  errors.last_business_name = 'error';
	  errors.first_name = 'error';
	  errors.filed_from = 'error';
	  errors.filed_to = 'error';
	  errors.ssntin = 'error';
	
	  return errors;
	};
	
	var validateCivil = exports.validateCivil = function validateCivil(values) {
	  var errors = {};
	
	  if (!values.court_code) {
	    errors.court_code = 'Region is required';
	  }
	
	  if (values.case_no && !_validations2.default.CASE_NUMBER(values.case_no)) {
	    errors.case_no = 'Invalid case number format.';
	  }
	
	  if (Object.keys(errors).length > 0) {
	    errors[_finalForm.FORM_ERROR] = Object.values(errors).reduce(function (acc, error) {
	      return acc ? acc + '\n' + error : error;
	    }, '');
	
	    return errors;
	  }
	
	  // Validate Input field combinations ----------------------------------------
	  // case_no is good enough
	  if (values.case_no) return;
	  // // Last and first ok
	  // if (values.last_business_name && values.first_name) return;
	  // // Last and small enough date range is OK
	  // if (values.last_business_name && isDateRange1WeekOrLess(values.filed_from, values.filed_to)) return;
	  // 1 week date range
	  if (isDateRange1WeekOrLess(values.filed_from, values.filed_to)) return;
	
	  if (values.filed_from && !isDateRange1WeekOrLess(values.filed_from, values.filed_to)) {
	    errors[_finalForm.FORM_ERROR] = 'Date range must be no greater than 1 Week';
	    errors.filed_from = 'error';
	    errors.filed_to = 'error';
	
	    return errors;
	  }
	
	  // if (values.last_business_name && !values.first_name
	  //   && !isDateRange1WeekOrLess(values.filed_from, values.filed_to)) {
	  //   errors[FORM_ERROR] = 'Last / Business Name requires First name or Date Filed Range not greater than 1 week';
	  //   errors.first_name = 'error';
	  //   errors.filed_from = 'error';
	  //   errors.filed_to = 'error';
	  //
	  //   return errors;
	  // }
	
	  errors[_finalForm.FORM_ERROR] = ['Please enter at least one combination:', '- Case Number',
	  // '- Last Name and First Name',
	  // '- Last / Business Name and Date Filed Range not greater than 1 week',
	  '- Date Filed Range not greater than 1 week'].join('\n');
	
	  errors.case_no = 'error';
	  // errors.last_business_name = 'error';
	  // errors.first_name = 'error';
	  errors.filed_from = 'error';
	  errors.filed_to = 'error';
	
	  return errors;
	};
	
	var validateAppellate = exports.validateAppellate = function validateAppellate(values) {
	  var errors = {};
	
	  if (!values.court_code) {
	    errors.court_code = 'Region is required';
	  }
	
	  if (values.case_no && !_validations2.default.CASE_NUMBER(values.case_no)) {
	    errors.case_no = 'Invalid case number format.';
	  }
	
	  if (Object.keys(errors).length > 0) {
	    errors[_finalForm.FORM_ERROR] = Object.values(errors).reduce(function (acc, error) {
	      return acc ? acc + '\n' + error : error;
	    }, '');
	
	    return errors;
	  }
	
	  // Validate Input field combinations ----------------------------------------
	  // case_no is good enough
	  if (values.case_no) return;
	  // Party / Attorney name ok
	  if (values.party_name) return;
	  // 1 week date range
	  if (isDateRange1WeekOrLess(values.filed_from, values.filed_to)) return;
	
	  if (values.filed_from && !isDateRange1WeekOrLess(values.filed_from, values.filed_to)) {
	    errors[_finalForm.FORM_ERROR] = 'Date range must be no greater than 1 Week';
	    errors.filed_from = 'error';
	    errors.filed_to = 'error';
	
	    return errors;
	  }
	
	  errors[_finalForm.FORM_ERROR] = ['Please enter at least one combination:', '- Case Number', '- Party / Attorney', '- Date Filed Range not greater than 1 week'].join('\n');
	
	  errors.case_no = 'error';
	  errors.party_name = 'error';
	  errors.filed_from = 'error';
	  errors.filed_to = 'error';
	
	  return errors;
	};

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchReceipt = function (_Component) {
	    _inherits(SearchReceipt, _Component);
	
	    function SearchReceipt() {
	        _classCallCheck(this, SearchReceipt);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    SearchReceipt.prototype.render = function render() {
	        var receiptMap = this.props.receipt.get('text');
	        var receipt = receiptMap ? receiptMap.toJS() : {};
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'ir-search-receipt' },
	            receipt.source_data_id && _react2.default.createElement(
	                'div',
	                { style: { 'textAlign': 'center', 'margin': '8px' } },
	                _react2.default.createElement(
	                    'a',
	                    {
	                        target: '_blank',
	                        title: 'Click to download screenshot of updated data as it appears on PACER',
	                        href: '/rpc/capi/source-data/' + receipt.source_data_id + '/screenshot-original.pdf'
	                    },
	                    _react2.default.createElement('i', { className: 'fa fa-camera' }),
	                    ' Screenshot'
	                )
	            ),
	            receipt.screenshot && receipt.screenshot.pdf && receipt.screenshot.pdf.href && _react2.default.createElement(
	                'div',
	                { style: { 'textAlign': 'center', 'margin': '8px' } },
	                _react2.default.createElement(
	                    'a',
	                    {
	                        target: '_blank',
	                        title: 'Click to download screenshot of updated data as it appears on PACER',
	                        href: receipt.screenshot.pdf.href
	                    },
	                    _react2.default.createElement('i', { className: 'fa fa-camera' }),
	                    ' Screenshot'
	                )
	            ),
	            _react2.default.createElement(
	                'table',
	                null,
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { colSpan: '2' },
	                            'PACER Service Center'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'Receipt:'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            receipt.datetime
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'User:'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            receipt.user_id && receipt.user_id.startsWith('in1524') ? "Metered Account" : "User's PACER account"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'Client:'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            receipt.client_code
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'Description:'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            receipt.description
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '\xA0'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            receipt.criteria
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'Pages:'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            receipt.pages,
	                            '\xA0($',
	                            receipt.cost,
	                            ')'
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return SearchReceipt;
	}(_react.Component);
	
	exports.default = SearchReceipt;

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dateFormat = __webpack_require__(94);
	
	var _dateFormat2 = _interopRequireDefault(_dateFormat);
	
	var _Loading = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formatDate = function formatDate(date) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'MMM D YYYY h:mm a ([GMT]Z)';
	
	  date = parseInt(date, 10);
	  return (0, _dateFormat2.default)(date * 1000, format);
	};
	
	var AutomatedReportsTable = function AutomatedReportsTable(_ref) {
	  var alerts = _ref.alerts,
	      onRemoveButtonClick = _ref.onRemoveButtonClick,
	      isLoading = _ref.isLoading;
	
	  var columns = ['Rule', 'Filters', 'Last run', 'Created', 'Operation'];
	
	  return _react2.default.createElement(
	    'table',
	    null,
	    _react2.default.createElement(
	      'thead',
	      null,
	      _react2.default.createElement(
	        'tr',
	        null,
	        columns.map(function (column) {
	          return _react2.default.createElement(
	            'th',
	            { key: column },
	            column
	          );
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'tbody',
	      null,
	      isLoading || alerts.length === 0 ? _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          { colSpan: '100%' },
	          isLoading ? _react2.default.createElement(_Loading.Loading, { show: isLoading, type: 'bar' }) : 'No Active or Pending Rules'
	        )
	      ) : alerts.map(function (alert) {
	        return _react2.default.createElement(
	          'tr',
	          { key: alert.rtalert_cron_id },
	          _react2.default.createElement(
	            'td',
	            null,
	            'Start on ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              formatDate(alert.time_start)
	            ),
	            _react2.default.createElement('br', null),
	            'Until ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              formatDate(alert.time_end)
	            ),
	            _react2.default.createElement('br', null),
	            'Every ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              alert.interval_str
	            )
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            'court ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              alert.court_code
	            ),
	            Object.keys(alert.search_params).map(function (key) {
	              return !!alert.search_params[key] && _react2.default.createElement(
	                'div',
	                { key: key },
	                key,
	                ' ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  alert.search_params[key]
	                )
	              );
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            alert.time_last_run !== '0' ? formatDate(alert.time_last_run) : 'Never'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            formatDate(alert.created, 'MM/DD/YYYY'),
	            ' by',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: alert.creator_name } })
	          ),
	          _react2.default.createElement(
	            'td',
	            { style: { textAlign: 'center' } },
	            alert.isBeingRemoved ? _react2.default.createElement(_Loading.Loading, { show: alert.isBeingRemoved, type: 'spinner' }) : _react2.default.createElement(
	              'a',
	              { href: '#',
	                onClick: function onClick(e) {
	                  e.preventDefault();
	                  onRemoveButtonClick(alert.rtalert_cron_id);
	                },
	                className: 'form-submit button-red',
	                style: { width: 'auto' }
	              },
	              'Remove'
	            )
	          )
	        );
	      })
	    )
	  );
	};
	
	AutomatedReportsTable.propTypes = {
	  alerts: _propTypes2.default.array.isRequired,
	  isLoading: _propTypes2.default.bool.isRequired,
	  onRemoveButtonClick: _propTypes2.default.func
	};
	
	AutomatedReportsTable.defaultProps = {
	  onRemoveButtonClick: function onRemoveButtonClick() {}
	};
	
	exports.default = AutomatedReportsTable;

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CustomAlertEdit = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _copyToClipboard = __webpack_require__(750);
	
	var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _WebhookHeadersField = __webpack_require__(697);
	
	var _WebhookHeadersField2 = _interopRequireDefault(_WebhookHeadersField);
	
	__webpack_require__(2187);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var parseWebhookHeaders = function parseWebhookHeaders() {
	  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  var headers = Object.create(null);
	  var names = new Set();
	  text.split(/\r?\n/).forEach(function (line, index) {
	    if (!line.trim()) return;
	    var colon = line.indexOf(':');
	    var name = line.slice(0, colon).trim();
	    var value = line.slice(colon + 1).trim();
	    if (colon < 1 || !/^[!#$%&'*+.^_`|~0-9A-Za-z-]+$/.test(name)) {
	      throw new Error('Line ' + (index + 1) + ': enter a header name followed by a colon and its value.');
	    }
	    // eslint-disable-next-line no-control-regex
	    if (/[\x00-\x1f\x7f]/.test(value)) throw new Error('Line ' + (index + 1) + ': remove control characters from the value.');
	    if (/^(host|content-length|transfer-encoding|connection|content-type|x-courtapi-signature)$/i.test(name)) {
	      throw new Error('Line ' + (index + 1) + ': ' + name + ' is managed automatically and cannot be overridden.');
	    }
	    if (names.has(name.toLowerCase())) throw new Error('Line ' + (index + 1) + ': ' + name + ' is already listed.');
	    names.add(name.toLowerCase());
	    if (value.includes('<fill-in>')) throw new Error('Line ' + (index + 1) + ': replace <fill-in> with your value.');
	    headers[name] = value;
	  });
	  return headers;
	};
	
	var maxEmails = 10;
	
	var intervalOptions = [{ value: -1, label: 'Save/Pause' }, { value: 3600, label: 'Hourly' }, { value: 86400, label: 'Daily' }, { value: 604800, label: 'Weekly' }];
	
	var getDeliveryOptions = function getDeliveryOptions(_ref) {
	  var delivery_options = _ref.delivery_options;
	  return delivery_options;
	};
	
	var getIntervalOptions = function getIntervalOptions(_ref2) {
	  var notify_interval_options = _ref2.notify_interval_options;
	  return notify_interval_options;
	};
	
	var parseEmailList = function parseEmailList(mailString) {
	  return !mailString ? [] : mailString.split(new RegExp(/\s*\n|\s*,\s*|\s*;\s*/)).filter(function (f) {
	    return f !== '';
	  });
	};
	
	var validateEmailList = function validateEmailList(mailListString) {
	  var mailList = parseEmailList(mailListString);
	
	  if (mailList.length > maxEmails) {
	    return 'May not enter more then ' + maxEmails + ' emails';
	  }
	
	  var invalidEmail = mailList.find(function (email) {
	    return !/\S+@\S+\.\S+/.test(email);
	  });
	
	  return invalidEmail ? '\'' + invalidEmail + '\' doesn\'t look like a valid email' : null;
	};
	
	var _onSubmit = function _onSubmit(values, onSave, oldAlert) {
	  var newMailList = parseEmailList(values.mail_list);
	
	  var alert = _extends({}, values, {
	    webhook_headers: values.delivery === 'webhook' ? parseWebhookHeaders(values.webhook_headers) : oldAlert.webhook_headers || {},
	    mail_list: newMailList.length > 0 ? newMailList : oldAlert.mail_list
	  });
	
	  onSave(alert);
	};
	
	var hasError = function hasError(meta) {
	  return meta.error && meta.submitFailed;
	};
	
	var generateSigningSecret = function generateSigningSecret() {
	  var alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	  var secret = 'whsec_';
	  while (secret.length < 38) {
	    var bytes = window.crypto.getRandomValues(new Uint8Array(32));
	    for (var _iterator = bytes, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	      var _ref3;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref3 = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref3 = _i.value;
	      }
	
	      var byte = _ref3;
	
	      // Reject the uneven remainder so all 62 characters are equally likely.
	      if (byte < 248 && secret.length < 38) secret += alphabet[byte % 62];
	    }
	  }
	  return secret;
	};
	
	var WebhookSecretField = function WebhookSecretField() {
	  var _useField = (0, _reactFinalForm.useField)('webhook_secret', {
	    parse: function parse(value) {
	      return value;
	    },
	    validate: function validate(value) {
	      return value ? undefined : 'Webhook signing secret is required';
	    }
	  }),
	      input = _useField.input,
	      meta = _useField.meta;
	
	  var _useState = (0, _react.useState)(function () {
	    return !input.value;
	  }),
	      visible = _useState[0],
	      setVisible = _useState[1];
	
	  var _useState2 = (0, _react.useState)(false),
	      copied = _useState2[0],
	      setCopied = _useState2[1];
	
	  var initialized = (0, _react.useRef)(false);
	  (0, _react.useEffect)(function () {
	    if (initialized.current) return;
	    initialized.current = true;
	    if (!input.value) {
	      input.onChange(generateSigningSecret());
	    }
	  }, [input.value, input.onChange]);
	  (0, _react.useEffect)(function () {
	    return setCopied(false);
	  }, [input.value]);
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-item' },
	    _react2.default.createElement(
	      'label',
	      { htmlFor: 'edit-webhook-secret' },
	      'Webhook signing secret:'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'input-group' },
	      _react2.default.createElement('input', _extends({}, input, { id: 'edit-webhook-secret', type: visible ? 'text' : 'password',
	        autoComplete: 'new-password', readOnly: true, className: 'form-control', style: { fontSize: '12px', fontFamily: 'monospace' } })),
	      _react2.default.createElement(
	        'span',
	        { className: 'input-group-btn' },
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { type: 'button', onClick: function onClick() {
	              return setVisible(!visible);
	            },
	            'aria-label': visible ? 'Hide webhook signing secret' : 'Show webhook signing secret',
	            title: visible ? 'Hide webhook signing secret' : 'Show webhook signing secret' },
	          _react2.default.createElement(_reactBootstrap.Glyphicon, { glyph: visible ? 'eye-close' : 'eye-open' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { type: 'button', onClick: function onClick() {
	              return setCopied((0, _copyToClipboard2.default)(input.value));
	            } },
	          copied ? 'Copied' : 'Copy'
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { type: 'button', onClick: function onClick() {
	              input.onChange(generateSigningSecret());
	              setVisible(true);
	            } },
	          'Regenerate'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'description' },
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.courtapi.com/docs/api#tag/webhooks/Verify-signatures', target: '_blank', rel: 'noopener noreferrer' },
	        'Learn more about validating webhooks'
	      )
	    ),
	    hasError(meta) && _react2.default.createElement(
	      'span',
	      { className: 'error description' },
	      meta.error
	    )
	  );
	};
	
	var CustomAlertEdit = function CustomAlertEdit(_ref4) {
	  var alert = _ref4.alert,
	      onSave = _ref4.onSave,
	      show = _ref4.show,
	      onClose = _ref4.onClose;
	  return _react2.default.createElement(
	    _reactBootstrap.Modal,
	    { show: show, onHide: onClose, backdrop: 'static', keyboard: false },
	    _react2.default.createElement(
	      'div',
	      { className: 'custom-alert-edit' },
	      _react2.default.createElement(_reactFinalForm.Form, {
	        onSubmit: function onSubmit(values) {
	          return _onSubmit(values, onSave, alert);
	        },
	        initialValues: _extends({}, alert, {
	          webhook_secret: alert.webhook_secret || '',
	          webhook_headers: Object.keys(alert.webhook_headers || {}).map(function (name) {
	            return name + ': ' + alert.webhook_headers[name];
	          }).join('\n'),
	          mail_list: alert.mail_list && alert.mail_list.length > 0 ? alert.mail_list.join('\n') : ''
	        }),
	        validate: function validate(values) {
	          var errors = {};
	
	          if (!values.name) {
	            errors.name = 'Name is required';
	          }
	
	          if (!getDeliveryOptions(alert).some(function (option) {
	            return option.value === values.delivery;
	          })) {
	            errors.delivery = 'Notification Delivery is required';
	          }
	
	          if (values.delivery !== 'webhook') {
	            if (!intervalOptions.some(function (option) {
	              return option.value.toString() === values.notify_interval.toString();
	            })) {
	              errors.notify_interval = 'Notification Interval is required';
	            }
	
	            if (!values.mail_list) {
	              errors.mail_list = 'Distribution list is required';
	            }
	          }
	
	          if (values.delivery === 'webhook' && !values.webhook_url) {
	            errors.webhook_url = 'Webhook URL is required';
	          }
	
	          if (values.delivery === 'webhook') {
	            try {
	              parseWebhookHeaders(values.webhook_headers);
	            } catch (error) {
	              errors.webhook_headers = error.message;
	            }
	          }
	
	          if (values.mail_list) {
	            var errorMessage = validateEmailList(values.mail_list);
	
	            if (errorMessage) {
	              errors.mail_list = errorMessage;
	            }
	          }
	
	          return errors;
	        },
	        render: function render(_ref5) {
	          var handleSubmit = _ref5.handleSubmit,
	              values = _ref5.values;
	          return _react2.default.createElement(
	            'form',
	            { onSubmit: handleSubmit, id: 'ir-alerts-edit-form' },
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Header,
	              { closeButton: true },
	              _react2.default.createElement(
	                _reactBootstrap.Modal.Title,
	                null,
	                'Edit Alert'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Body,
	              null,
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _reactFinalForm.Field,
	                  { name: 'name' },
	                  function (_ref6) {
	                    var input = _ref6.input,
	                        meta = _ref6.meta;
	
	                    var errorClass = (0, _classnames2.default)({ error: hasError(meta) });
	
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'form-item', id: 'edit-name-wrapper' },
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'edit-name', className: errorClass },
	                        'Name:',
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'form-required', title: 'This field is required.' },
	                          '*'
	                        )
	                      ),
	                      _react2.default.createElement('input', _extends({}, input, {
	                        type: 'text',
	                        id: 'edit-name',
	                        maxLength: '50',
	                        className: 'form-text ' + errorClass,
	                        placeholder: 'The name that will be displayed for this saved search'
	                      })),
	                      hasError(meta) && _react2.default.createElement(
	                        'span',
	                        { className: 'error description' },
	                        meta.error
	                      )
	                    );
	                  }
	                ),
	                _react2.default.createElement(
	                  _reactFinalForm.Field,
	                  {
	                    name: 'delivery',
	                    parse: function parse(_ref7) {
	                      var value = _ref7.value;
	                      return value;
	                    }
	                  },
	                  function (_ref8) {
	                    var _ref8$input = _ref8.input,
	                        _onChange = _ref8$input.onChange,
	                        rest = _objectWithoutProperties(_ref8$input, ['onChange']),
	                        meta = _ref8.meta;
	
	                    var errorClass = (0, _classnames2.default)({ error: hasError(meta) });
	
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'form-item', id: 'edit-delivery-wrapper' },
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'edit-delivery', className: errorClass },
	                        'Notification delivery:',
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'form-required', title: 'This field is required.' },
	                          '*'
	                        )
	                      ),
	                      _react2.default.createElement(_reactSelect2.default, _extends({}, rest, {
	                        onChange: function onChange(_ref9) {
	                          var label = _ref9.label,
	                              value = _ref9.value;
	
	                          if (value !== 'webhook') {
	                            if (values.webhook_url) {
	                              values.webhook_url = '';
	                            }
	
	                            if (!intervalOptions.some(function (option) {
	                              return option.value === values.notify_interval;
	                            })) {
	                              values.notify_interval = intervalOptions[0].value;
	                            }
	                          }
	
	                          _onChange({ label: label, value: value });
	                        },
	                        options: getDeliveryOptions(alert),
	                        clearable: false,
	                        id: 'edit-delivery',
	                        className: 'form-select ' + errorClass
	                      })),
	                      hasError(meta) && _react2.default.createElement(
	                        'span',
	                        { className: 'error description' },
	                        meta.error
	                      )
	                    );
	                  }
	                ),
	                values.delivery !== 'webhook' && _react2.default.createElement(
	                  _reactFinalForm.Field,
	                  { name: 'notify_interval' },
	                  function (_ref10) {
	                    var _ref10$input = _ref10.input,
	                        _onChange2 = _ref10$input.onChange,
	                        rest = _objectWithoutProperties(_ref10$input, ['onChange']),
	                        meta = _ref10.meta;
	
	                    var errorClass = (0, _classnames2.default)({ error: hasError(meta) });
	
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'form-item', id: 'edit-notify-interval-wrapper' },
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'edit-notify-interval', className: errorClass },
	                        'Notification interval:',
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'form-required', title: 'This field is required.' },
	                          '*'
	                        )
	                      ),
	                      _react2.default.createElement(_reactSelect2.default, _extends({}, rest, {
	                        onChange: function onChange(_ref11) {
	                          var value = _ref11.value;
	
	                          _onChange2(value);
	                        },
	                        options: getIntervalOptions(alert),
	                        clearable: false,
	                        id: 'edit-notify-interval',
	                        className: 'form-select ' + errorClass
	                      })),
	                      hasError(meta) && _react2.default.createElement(
	                        'span',
	                        { className: 'error description' },
	                        meta.error
	                      )
	                    );
	                  }
	                ),
	                values.delivery === 'webhook' && _react2.default.createElement(
	                  _reactFinalForm.Field,
	                  { name: 'webhook_url' },
	                  function (_ref12) {
	                    var input = _ref12.input,
	                        meta = _ref12.meta;
	
	                    var errorClass = (0, _classnames2.default)({ error: hasError(meta) });
	
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'form-item', id: 'edit-webhook-url-wrapper' },
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'edit-webhook-url', className: errorClass },
	                        'Webhook URL:',
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'form-required', title: 'This field is required.' },
	                          '*'
	                        )
	                      ),
	                      _react2.default.createElement('input', _extends({}, input, {
	                        type: 'text',
	                        id: 'edit-webhook-url',
	                        maxLength: '128',
	                        className: 'form-text ' + errorClass,
	                        placeholder: 'The URL to which the payload will be delivered'
	                      })),
	                      hasError(meta) && _react2.default.createElement(
	                        'span',
	                        { className: 'error description' },
	                        meta.error
	                      )
	                    );
	                  }
	                ),
	                values.delivery === 'webhook' && _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(WebhookSecretField, null),
	                  _react2.default.createElement(_WebhookHeadersField2.default, null)
	                ),
	                values.delivery !== 'webhook' && _react2.default.createElement(
	                  _reactFinalForm.Field,
	                  { name: 'mail_list' },
	                  function (_ref13) {
	                    var input = _ref13.input,
	                        meta = _ref13.meta;
	
	                    var errorClass = (0, _classnames2.default)({ error: hasError(meta) });
	
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'form-item', id: 'edit-emails-wrapper' },
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'edit-emails', className: errorClass },
	                        'Send alert emails to the following distribution list:',
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'form-required', title: 'This field is required.' },
	                          '*'
	                        )
	                      ),
	                      _react2.default.createElement('textarea', _extends({}, input, {
	                        id: 'edit-emails',
	                        rows: '4',
	                        className: 'form-textarea ' + errorClass,
	                        placeholder: 'Add up to ' + maxEmails + ' emails, one per line or separated by commas or semicolons'
	                      })),
	                      hasError(meta) && _react2.default.createElement(
	                        'span',
	                        { className: 'error description' },
	                        meta.error
	                      )
	                    );
	                  }
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Footer,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { onClick: onClose },
	                'Cancel'
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { bsStyle: 'primary', type: 'submit' },
	                'Save Changes'
	              )
	            )
	          );
	        }
	      })
	    )
	  );
	};
	
	exports.CustomAlertEdit = CustomAlertEdit;
	CustomAlertEdit.propTypes = {
	  alert: _propTypes2.default.any,
	  onSave: _propTypes2.default.func.isRequired,
	  onClose: _propTypes2.default.func.isRequired,
	  show: _propTypes2.default.bool
	};
	
	CustomAlertEdit.defaultProps = {
	  alert: {},
	  show: false
	};
	
	exports.default = CustomAlertEdit;

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (regionOptions) {
	  var split = _lodash2.default.partition(regionOptions, function (o) {
	    return isNaN(o.value.charAt(0));
	  });
	  var sortedNums = split[1].sort(function (a, b) {
	    var x = Number(a.value.match(/\d+/g));
	    var y = Number(b.value.match(/\d+/g));
	    return x > y ? -1 : 1;
	  });
	
	  var alphaSort = split[0].sort(function (a, b) {
	    return a.value.toUpperCase() < b.value.toUpperCase() ? -1 : 1;
	  });
	
	  var fedCircuit = _lodash2.default.remove(alphaSort, { value: 'CAFC' });
	  var x = alphaSort.concat(fedCircuit);
	
	  return sortedNums.concat(x);
	};

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CreateAlertModal = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2196);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var intervalOptions = [{ value: -1, label: 'Save/Pause' }, { value: 3600, label: 'Hourly' }, { value: 86400, label: 'Daily' }, { value: 604800, label: 'Weekly' }];
	
	var getIntervalOptions = function getIntervalOptions(advancedSearchFilterTemplate) {
	  // Petitions, Schedules and Cases alerts shouldn't have Hourly option
	  if (advancedSearchFilterTemplate && ['extended', 'schedules', 'case_lookup'].includes(advancedSearchFilterTemplate)) {
	    return intervalOptions.filter(function (option) {
	      return option.value !== 3600;
	    });
	  }
	  // Case activity alerts shouldn't have Hourly and Weekly options
	  if (advancedSearchFilterTemplate && ['case_activity'].includes(advancedSearchFilterTemplate)) {
	    return intervalOptions.filter(function (option) {
	      return option.value !== 3600 && option.value !== 604800;
	    });
	  }
	
	  return intervalOptions;
	};
	
	var _onSubmit = function _onSubmit(values, onSave) {
	  onSave(values);
	};
	
	var hasError = function hasError(meta) {
	  return meta.error && meta.submitFailed;
	};
	
	var CreateAlertModal = function CreateAlertModal(_ref) {
	  var onSave = _ref.onSave,
	      show = _ref.show,
	      onClose = _ref.onClose,
	      _ref$advancedSearch = _ref.advancedSearch,
	      template = _ref$advancedSearch.filter.template,
	      _ref$advancedSearch$a = _ref$advancedSearch.alert.data,
	      data = _ref$advancedSearch$a === undefined ? {} : _ref$advancedSearch$a;
	
	  return _react2.default.createElement(
	    _reactBootstrap.Modal,
	    { show: show, onHide: onClose, backdrop: 'static', keyboard: false },
	    _react2.default.createElement(
	      'div',
	      { className: 'create-alert-modal' },
	      _react2.default.createElement(_reactFinalForm.Form, {
	        onSubmit: function onSubmit(values) {
	          return _onSubmit(values, onSave);
	        },
	        initialValues: _extends({}, data, { save_as_new: !(data && data.name) }),
	        validate: function validate(values) {
	          var errors = {};
	          if (!values.name) {
	            errors.name = 'Name is required';
	          }
	          if (values.delivery !== 'webhook') {
	            if (!intervalOptions.some(function (option) {
	              return values.notify_interval && option.value.toString() === values.notify_interval.toString();
	            })) {
	              errors.notify_interval = 'Notification Interval is required';
	            }
	          }
	          return errors;
	        },
	        render: function render(_ref2) {
	          var handleSubmit = _ref2.handleSubmit,
	              values = _ref2.values;
	          return _react2.default.createElement(
	            'form',
	            { onSubmit: handleSubmit, id: 'ir-alerts-edit-form' },
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Header,
	              { closeButton: true },
	              _react2.default.createElement(
	                _reactBootstrap.Modal.Title,
	                null,
	                data.id ? 'Edit Alert' : 'Add Alert'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Body,
	              null,
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _reactFinalForm.Field,
	                  { name: 'name' },
	                  function (_ref3) {
	                    var input = _ref3.input,
	                        meta = _ref3.meta;
	
	                    var errorClass = (0, _classnames2.default)({ error: hasError(meta) });
	
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'form-item', id: 'edit-name-wrapper' },
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'edit-name', className: errorClass },
	                        'Name:',
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'form-required', title: 'This field is required.' },
	                          '*'
	                        )
	                      ),
	                      _react2.default.createElement('input', _extends({}, input, {
	                        type: 'text',
	                        id: 'edit-name',
	                        maxLength: '50',
	                        value: values.name || '',
	                        className: 'form-text ' + errorClass
	                      })),
	                      hasError(meta) && _react2.default.createElement(
	                        'span',
	                        { className: 'error description' },
	                        meta.error
	                      )
	                    );
	                  }
	                ),
	                _react2.default.createElement(
	                  _reactFinalForm.Field,
	                  { name: 'notify_interval' },
	                  function (_ref4) {
	                    var _ref4$input = _ref4.input,
	                        _onChange = _ref4$input.onChange,
	                        rest = _objectWithoutProperties(_ref4$input, ['onChange']),
	                        meta = _ref4.meta;
	
	                    var errorClass = (0, _classnames2.default)({ error: hasError(meta) });
	
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'form-item', id: 'edit-notify-interval-wrapper' },
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'edit-notify-interval', className: errorClass },
	                        'Notification interval:',
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'form-required', title: 'This field is required.' },
	                          '*'
	                        )
	                      ),
	                      _react2.default.createElement(_reactSelect2.default, _extends({}, rest, {
	                        onChange: function onChange(_ref5) {
	                          var label = _ref5.label,
	                              value = _ref5.value;
	
	                          values.notify_interval_label = label;
	                          _onChange(value);
	                        },
	                        options: getIntervalOptions(template),
	                        clearable: false,
	                        id: 'edit-notify-interval',
	                        className: 'form-select ' + errorClass
	                      })),
	                      hasError(meta) && _react2.default.createElement(
	                        'span',
	                        { className: 'error description' },
	                        meta.error
	                      )
	                    );
	                  }
	                ),
	                data.id && _react2.default.createElement(
	                  'div',
	                  { className: 'save-as-new' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'Save as new alert instead'
	                  ),
	                  _react2.default.createElement(_reactFinalForm.Field, { name: 'save_as_new', component: 'input', type: 'checkbox' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Footer,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { onClick: onClose },
	                'Cancel'
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { bsStyle: 'primary', type: 'submit' },
	                'Save Changes'
	              )
	            )
	          );
	        }
	      })
	    )
	  );
	};
	
	exports.CreateAlertModal = CreateAlertModal;
	CreateAlertModal.propTypes = {
	  onSave: _propTypes2.default.func.isRequired,
	  onClose: _propTypes2.default.func.isRequired,
	  show: _propTypes2.default.bool,
	  advancedSearch: _propTypes2.default.object.isRequired
	};
	
	CreateAlertModal.defaultProps = {
	  show: false
	};
	
	exports.default = CreateAlertModal;

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _redux = __webpack_require__(240);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(32);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _caseLookupSearchAction = __webpack_require__(724);
	
	var actions = _interopRequireWildcard(_caseLookupSearchAction);
	
	var _sidebarActions = __webpack_require__(728);
	
	var _advancedSearchAction = __webpack_require__(178);
	
	var _errorAction = __webpack_require__(727);
	
	var errorActions = _interopRequireWildcard(_errorAction);
	
	var _Loading = __webpack_require__(81);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _RefineSearch = __webpack_require__(708);
	
	var _RefineSearch2 = _interopRequireDefault(_RefineSearch);
	
	var _RefineSearch3 = __webpack_require__(409);
	
	var _RefineSearch4 = _interopRequireDefault(_RefineSearch3);
	
	var _caseLookup = __webpack_require__(693);
	
	var _text = __webpack_require__(425);
	
	var _caseLookupSearchReducer = __webpack_require__(272);
	
	var _courts = __webpack_require__(111);
	
	var _courts2 = _interopRequireDefault(_courts);
	
	var _searchSm = __webpack_require__(2236);
	
	var _searchSm2 = _interopRequireDefault(_searchSm);
	
	__webpack_require__(2199);
	
	var _AdvancedSearchAlert = __webpack_require__(706);
	
	var _AdvancedSearchAlert2 = _interopRequireDefault(_AdvancedSearchAlert);
	
	var _TabOneSection = __webpack_require__(709);
	
	var _TabOneSection2 = _interopRequireDefault(_TabOneSection);
	
	var _TabTwoSection = __webpack_require__(710);
	
	var _TabTwoSection2 = _interopRequireDefault(_TabTwoSection);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var courtsMap = _lodash2.default.groupBy(_courts2.default, 'code');
	
	var facetsData = {
	  case_type: 'Type',
	  chapter: 'Chapter',
	  year: 'Year field',
	  court_name: 'Court'
	};
	
	var FacetsBlock = function (_Component) {
	  _inherits(FacetsBlock, _Component);
	
	  function FacetsBlock(props) {
	    _classCallCheck(this, FacetsBlock);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.componentDidMount = function () {
	      _this.props.getSidebarData({ type: _this.props.type });
	    };
	
	    _this.changeTab = function (tab) {
	      _this.setState({ selectedTab: tab });
	    };
	
	    _this.clearAllFilter = function () {
	      setTimeout(function () {
	        if (_this.props.filters.get('year')) {
	          // this is a kind of a hack  bc of react-datepicker
	          var datepickers = document.getElementsByClassName('react-datepicker__close-icon') || [];
	          // eslint-disable-next-line
	          for (var i = 0; i < datepickers.length; i++) {
	            datepickers[i].click();
	          }
	        }
	        _this.props.actions.clearAllFilter();
	        _caseLookup.search.bind(_this)({}, false);
	      });
	    };
	
	    _this.hasDataForRefinedSearch = function () {
	      // checks if all of the facets data is empty
	      var facets = _this.props.facets.toJS();
	      var containsData = false;
	      Object.values(facets).forEach(function (v) {
	        if (!_lodash2.default.isEmpty(v)) {
	          containsData = true;
	        }
	      });
	      return containsData;
	    };
	
	    _this.state = {
	      selectedTab: 1
	    };
	    return _this;
	  }
	
	  FacetsBlock.prototype.facetRowClick = function facetRowClick(facetRow) {
	    var nameOfProperty = Object.keys(facetRow)[0];
	    var valueOfProperty = facetRow[nameOfProperty];
	
	    if (nameOfProperty === 'case_type') {
	      if (valueOfProperty) {
	        facetRow[nameOfProperty] = (0, _text.firstLetterCapitalize)(valueOfProperty);
	      } else {
	        facetRow[nameOfProperty] = 'All';
	      }
	    }
	
	    var searchFilter = facetRow;
	
	    if (facetRow.year) {
	      // this is not very terse but it's late for me :|
	      facetRow.filed_from = (0, _moment2.default)(facetRow.year + '/01/01');
	      facetRow.filed_to = (0, _moment2.default)(facetRow.year + '/12/31');
	
	      searchFilter = {
	        filed_from: facetRow.year + '/01/01',
	        filed_to: facetRow.year + '/12/31',
	        year: facetRow.year
	      };
	
	      var datepickers = document.getElementsByClassName('react-datepicker__close-icon') || [];
	      // can't use forEach on nodeitems in all browsers
	      // eslint-disable-next-line
	      for (var i = 0; i < datepickers.length; i++) {
	        datepickers[i].click();
	      }
	    }
	
	    if (facetRow.court_name) {
	      var _facetRow = facetRow,
	          court_name = _facetRow.court_name;
	
	      facetRow = { region_name: court_name };
	      searchFilter = { region_name: court_name };
	    }
	
	    this.props.actions.updateFilter(facetRow);
	
	    _caseLookup.search.bind(this)(searchFilter, false);
	  };
	
	  FacetsBlock.prototype.render = function render() {
	    var _props = this.props,
	        sidebarData = _props.sidebarData,
	        type = _props.type,
	        advancedSearchFacets = _props.advancedSearchFacets,
	        advancedSearchFilter = _props.advancedSearchFilter,
	        onSearchAdvancedFilings = _props.onSearchAdvancedFilings,
	        advancedSearchShowResults = _props.advancedSearchShowResults;
	
	    var hasDataForRefinedSearch = this.hasDataForRefinedSearch();
	
	    var tabOneCls = this.state.selectedTab === 1 ? 'ui-tabs-selected' : 'ui-state-default';
	
	    var tabTwoCls = this.state.selectedTab === 2 ? 'ui-tabs-selected' : 'ui-state-default';
	
	    var refineSearch = hasDataForRefinedSearch ? _react2.default.createElement(_RefineSearch2.default, { facetsData: facetsData,
	      courtsMap: courtsMap,
	      facets: this.props.facets,
	      facetRowClick: this.facetRowClick.bind(this) }) : null;
	
	    var tabOneContent = type === 'advanced-search' && !hasDataForRefinedSearch ? _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(_AdvancedSearchAlert2.default, null),
	      advancedSearchFacets && _react2.default.createElement(_RefineSearch4.default, {
	        facets: advancedSearchFacets,
	        advancedSearchFilter: advancedSearchFilter,
	        onSearchAdvancedFilings: onSearchAdvancedFilings
	      }),
	      !advancedSearchShowResults && _react2.default.createElement(_TabOneSection2.default, { tab: sidebarData.tab_one, sidebarStatus: sidebarData.status })
	    ) : _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(_TabOneSection2.default, { tab: sidebarData.tab_one, sidebarStatus: sidebarData.status }),
	      refineSearch
	    );
	
	    var tabs = _react2.default.createElement(
	      'div',
	      { className: 'tabs' },
	      _react2.default.createElement(
	        'div',
	        { className: 'tab ' + tabOneCls },
	        tabOneContent
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'tab ' + tabTwoCls },
	        _react2.default.createElement(_TabTwoSection2.default, { tab: sidebarData.tab_two, sidebarStatus: sidebarData.status })
	      )
	    );
	
	    var loadingOrFacets = this.props.sidebarData.status === 'loading' ? _react2.default.createElement(_Loading2.default, { showOverride: true, type: 'spinner' }) : tabs;
	
	    return _react2.default.createElement(
	      'div',
	      { id: 'sidebar-first', className: 'facets-block' },
	      _react2.default.createElement(
	        'ul',
	        { className: 'ui-tabs-nav ui-helper-reset ui-helper-clearfix' },
	        _react2.default.createElement(
	          'li',
	          { className: 'ui-state-default ' + tabOneCls, onClick: this.changeTab.bind(null, 1) },
	          _react2.default.createElement(
	            'a',
	            { href: 'javascript:void(0)', className: 'icon' },
	            _react2.default.createElement('img', { src: _searchSm2.default, alt: '' })
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'ui-state-default ' + tabTwoCls, onClick: this.changeTab.bind(null, 2) },
	          _react2.default.createElement(
	            'a',
	            { href: 'javascript:void(0)' },
	            'Dashboard'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'inside menu content inside-block ui-tabs-panel ui-widget-content ui-corner-bottom' },
	        loadingOrFacets,
	        !_lodash2.default.isEqual(_caseLookupSearchReducer.initialFilters, this.props.filters.toJS()) && hasDataForRefinedSearch && _react2.default.createElement(
	          'div',
	          {
	            onClick: this.clearAllFilter,
	            className: 'ir-search-facet-link ir-search-facet-clear link-emulated active clear-all' },
	          'Clear All Filters'
	        ),
	        _react2.default.createElement(_Loading2.default, { type: 'spinner' })
	      )
	    );
	  };
	
	  return FacetsBlock;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  var caseLookupSearchReducer = state.get('caseLookupSearchReducer');
	  return {
	    facets: caseLookupSearchReducer.get('facets'),
	    filters: caseLookupSearchReducer.get('filters'),
	    sidebarData: state.get('sidebarData'),
	    advancedSearchFacets: state.toJS().advancedSearch.data.facets,
	    advancedSearchFilter: state.toJS().advancedSearch.filter,
	    advancedSearchShowResults: state.toJS().advancedSearch.showResults
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch,
	    actions: (0, _redux.bindActionCreators)(actions, dispatch),
	    errorActions: (0, _redux.bindActionCreators)(errorActions, dispatch),
	    getSidebarData: (0, _redux.bindActionCreators)(_sidebarActions.getSidebarData, dispatch),
	    onSearchAdvancedFilings: (0, _redux.bindActionCreators)(_advancedSearchAction.searchAdvancedFilings, dispatch)
	  };
	};
	
	FacetsBlock.propTypes = {
	  getSidebarData: _propTypes2.default.func.isRequired,
	  type: _propTypes2.default.string.isRequired,
	  facets: _propTypes2.default.object.isRequired,
	  actions: _propTypes2.default.object.isRequired,
	  filters: _propTypes2.default.object.isRequired,
	  sidebarData: _propTypes2.default.object.isRequired,
	  advancedSearchFacets: _propTypes2.default.object,
	  advancedSearchFilter: _propTypes2.default.object.isRequired,
	  onSearchAdvancedFilings: _propTypes2.default.func.isRequired,
	  advancedSearchShowResults: _propTypes2.default.bool.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FacetsBlock);

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (type, replacementSuffix) {
	  return sortedCourts.filter(function (p) {
	    return p.type === type;
	  }).reduce(function (accum, next) {
	    var _Object$assign;
	
	    var name = next.name.replace(replacementSuffix, '').trim();
	    return Object.assign(accum, (_Object$assign = {}, _Object$assign[next.code] = name, _Object$assign));
	  }, {});
	};
	
	var _lodash = __webpack_require__(4);
	
	var _courts = __webpack_require__(111);
	
	var _courts2 = _interopRequireDefault(_courts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sortedCourts = (0, _lodash.orderBy)(_courts2.default, ['name'], ['asc']);

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.resendCustomAlert = exports.getDeliveryLog = exports.removeCustomAlert = exports.updateCustomAlert = exports.getCustomAlerts = exports.resendTemplateAlert = exports.updateTemplateAlert = exports.getTemplateAlerts = exports.removeAutomatedReport = exports.getAutomatedReports = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _Notification = __webpack_require__(24);
	
	var _url = __webpack_require__(180);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _searchAlertsActionTypes = __webpack_require__(723);
	
	var actionTypes = _interopRequireWildcard(_searchAlertsActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getAutomatedReports = exports.getAutomatedReports = function getAutomatedReports() {
	  return function (dispatch) {
	    dispatch({ type: actionTypes.AUTOMATED_REPORTS.REQUEST });
	
	    _superagent2.default.get((0, _url2.default)('/localsearch/get-alerts')).set('Content-Type', 'application/json').then(function (_ref) {
	      var _ref$body = _ref.body,
	          body = _ref$body === undefined ? {} : _ref$body;
	      return dispatch({
	        type: actionTypes.AUTOMATED_REPORTS.SUCCESS,
	        data: body
	      });
	    }, function (error) {
	      dispatch({
	        type: actionTypes.AUTOMATED_REPORTS.ERROR,
	        error: error
	      });
	      _Notification.notify.error('Failed to fetch Automated Reports');
	    });
	  };
	};
	
	var removeAutomatedReport = exports.removeAutomatedReport = function removeAutomatedReport(_ref2) {
	  var id = _ref2.id;
	  return function (dispatch) {
	    dispatch({
	      type: actionTypes.REMOVE_AUTOMATED_REPORT.REQUEST,
	      data: { id: id }
	    });
	
	    _superagent2.default.post((0, _url2.default)('/localsearch/remove-alert')).send({ id: id }).set('Content-Type', 'application/json').then(function (_ref3) {
	      var _ref3$body = _ref3.body,
	          body = _ref3$body === undefined ? {} : _ref3$body;
	
	      dispatch({
	        type: actionTypes.REMOVE_AUTOMATED_REPORT.SUCCESS,
	        data: body
	      });
	      dispatch(getAutomatedReports());
	      _Notification.notify.success('Automated Report was removed successfully');
	    }, function (error) {
	      dispatch({
	        type: actionTypes.REMOVE_AUTOMATED_REPORT.ERROR,
	        error: error
	      });
	      _Notification.notify.error('Failed to remove Automated Report');
	    });
	  };
	};
	
	var getTemplateAlerts = exports.getTemplateAlerts = function getTemplateAlerts() {
	  return function (dispatch) {
	    dispatch({ type: actionTypes.TEMPLATE_ALERTS.REQUEST });
	
	    _superagent2.default.get((0, _url2.default)('/search-alerts/json/list-templates')).set('Content-Type', 'application/json').then(function (_ref4) {
	      var _ref4$body = _ref4.body,
	          body = _ref4$body === undefined ? {} : _ref4$body;
	      return dispatch({
	        type: actionTypes.TEMPLATE_ALERTS.SUCCESS,
	        data: body
	      });
	    }, function (error) {
	      dispatch({
	        type: actionTypes.TEMPLATE_ALERTS.ERROR,
	        error: error
	      });
	      _Notification.notify.error('Failed to fetch Template Alerts');
	    });
	  };
	};
	
	var updateTemplateAlert = exports.updateTemplateAlert = function updateTemplateAlert(payload) {
	  return function (dispatch) {
	    var _request$post$set$set;
	
	    dispatch({
	      type: actionTypes.UPDATE_TEMPLATE_ALERT.REQUEST,
	      payload: payload
	    });
	
	    var name = payload.name,
	        value = payload.value,
	        alert = payload.alert;
	
	
	    var onSuccess = function onSuccess() {
	      dispatch({
	        type: actionTypes.UPDATE_TEMPLATE_ALERT.SUCCESS,
	        payload: payload
	      });
	      _Notification.notify.success('Template Alert ' + alert.name + ' updated successfully');
	    };
	
	    var onError = function onError(error) {
	      dispatch({
	        type: actionTypes.UPDATE_TEMPLATE_ALERT.ERROR,
	        error: error,
	        payload: payload
	      });
	      _Notification.notify.error('Failed to update Template Alert ' + alert.name);
	    };
	
	    _superagent2.default.post((0, _url2.default)('/search-alerts/json/edit/' + alert.id)).set('Content-Type', 'application/json').set('X-Csrf-Token', alert.edit_token).send((_request$post$set$set = {}, _request$post$set$set[name] = value, _request$post$set$set)).then(function (_ref5) {
	      var body = _ref5.body;
	      return body && body.success ? onSuccess() : onError(body && body.error);
	    }).catch(function (error) {
	      return onError(error);
	    });
	  };
	};
	
	var resendTemplateAlert = exports.resendTemplateAlert = function resendTemplateAlert(payload) {
	  return function (dispatch) {
	    dispatch({
	      type: actionTypes.RESEND_TEMPLATE_ALERT.REQUEST,
	      payload: payload
	    });
	
	    var alert = payload.alert;
	
	
	    var onSuccess = function onSuccess() {
	      dispatch({
	        type: actionTypes.RESEND_TEMPLATE_ALERT.SUCCESS,
	        payload: payload
	      });
	
	      _Notification.notify.success('Template Alert ' + alert.name + ' was queued for resend');
	    };
	
	    var onError = function onError(error) {
	      dispatch({
	        type: actionTypes.RESEND_TEMPLATE_ALERT.ERROR,
	        error: error,
	        payload: payload
	      });
	
	      _Notification.notify.error('Failed to resend Template Alert ' + alert.name);
	    };
	
	    _superagent2.default.post((0, _url2.default)('/search-alerts/json/resend/' + alert.id)).set('Content-Type', 'application/json').set('X-Csrf-Token', alert.resend_token).then(function (_ref6) {
	      var body = _ref6.body;
	      return body && body.success ? onSuccess() : onError(body && body.error);
	    }).catch(function (error) {
	      return onError(error);
	    });
	  };
	};
	
	var getCustomAlerts = exports.getCustomAlerts = function getCustomAlerts() {
	  return function (dispatch) {
	    dispatch({ type: actionTypes.CUSTOM_ALERTS.REQUEST });
	
	    _superagent2.default.get((0, _url2.default)('/search-alerts/json/list')).set('Content-Type', 'application/json').then(function (_ref7) {
	      var _ref7$body = _ref7.body,
	          body = _ref7$body === undefined ? {} : _ref7$body;
	      return dispatch({
	        type: actionTypes.CUSTOM_ALERTS.SUCCESS,
	        data: body
	      });
	    }, function (error) {
	      dispatch({
	        type: actionTypes.CUSTOM_ALERTS.ERROR,
	        error: error
	      });
	      _Notification.notify.error('Failed to fetch Custom Alerts');
	    });
	  };
	};
	
	var updateCustomAlert = exports.updateCustomAlert = function updateCustomAlert(payload) {
	  return function (dispatch) {
	    dispatch({
	      type: actionTypes.UPDATE_CUSTOM_ALERT.REQUEST,
	      payload: payload
	    });
	
	    var alert = payload.alert;
	
	
	    var onSuccess = function onSuccess() {
	      dispatch({
	        type: actionTypes.UPDATE_CUSTOM_ALERT.SUCCESS,
	        payload: payload
	      });
	
	      _Notification.notify.success('Custom Alert ' + alert.name + ' updated successfully');
	    };
	
	    var onError = function onError(error) {
	      dispatch({
	        type: actionTypes.UPDATE_CUSTOM_ALERT.ERROR,
	        error: error,
	        payload: payload
	      });
	
	      _Notification.notify.error('Failed to update Custom Alert ' + alert.name);
	    };
	
	    _superagent2.default.post((0, _url2.default)('/search-alerts/json/edit/' + alert.id)).set('Content-Type', 'application/json').set('X-Csrf-Token', alert.edit_token).send(_extends({}, alert)).then(function (_ref8) {
	      var body = _ref8.body;
	      return body && body.success ? onSuccess() : onError(body && body.error);
	    }).catch(function (error) {
	      return onError(error);
	    });
	  };
	};
	
	var removeCustomAlert = exports.removeCustomAlert = function removeCustomAlert(payload) {
	  return function (dispatch) {
	    dispatch({
	      type: actionTypes.REMOVE_CUSTOM_ALERT.REQUEST,
	      payload: payload
	    });
	
	    var alert = payload.alert;
	
	
	    var onSuccess = function onSuccess() {
	      dispatch({
	        type: actionTypes.REMOVE_CUSTOM_ALERT.SUCCESS,
	        payload: payload
	      });
	      _Notification.notify.success('Custom Alert ' + alert.name + ' was removed successfully');
	    };
	
	    var onError = function onError(error) {
	      dispatch({
	        type: actionTypes.REMOVE_CUSTOM_ALERT.ERROR,
	        error: error,
	        payload: payload
	      });
	      _Notification.notify.error('Failed to remove Custom Alert ' + alert.name);
	    };
	
	    _superagent2.default.post((0, _url2.default)('/search-alerts/json/delete/' + alert.id)).set('Content-Type', 'application/json').set('X-Csrf-Token', alert.edit_token).then(function (_ref9) {
	      var _ref9$body = _ref9.body,
	          body = _ref9$body === undefined ? {} : _ref9$body;
	      return body && body.success ? onSuccess() : onError(body && body.error);
	    }).catch(function (error) {
	      return onError(error);
	    });
	  };
	};
	
	var getDeliveryLog = exports.getDeliveryLog = function getDeliveryLog(alertId) {
	  return function (dispatch) {
	    dispatch({ type: actionTypes.DELIVERY_LOG.REQUEST });
	
	    _superagent2.default.get((0, _url2.default)('/search-alerts/json/delivery-log/' + alertId)).set('Content-Type', 'application/json').then(function (_ref10) {
	      var _ref10$body = _ref10.body,
	          body = _ref10$body === undefined ? [] : _ref10$body;
	      return dispatch({
	        type: actionTypes.DELIVERY_LOG.SUCCESS,
	        data: body
	      });
	    }, function (error) {
	      dispatch({
	        type: actionTypes.DELIVERY_LOG.ERROR,
	        error: error
	      });
	      _Notification.notify.error('Failed to fetch delivery log');
	    });
	  };
	};
	
	var resendCustomAlert = exports.resendCustomAlert = function resendCustomAlert(payload) {
	  return function (dispatch) {
	    dispatch({
	      type: actionTypes.RESEND_CUSTOM_ALERT.REQUEST,
	      payload: payload
	    });
	
	    var alert = payload.alert;
	
	
	    var onSuccess = function onSuccess() {
	      dispatch({
	        type: actionTypes.RESEND_CUSTOM_ALERT.SUCCESS,
	        payload: payload
	      });
	
	      _Notification.notify.success('Custom Alert ' + alert.name + ' was queued for resend');
	    };
	
	    var onError = function onError(error) {
	      dispatch({
	        type: actionTypes.RESEND_CUSTOM_ALERT.ERROR,
	        error: error,
	        payload: payload
	      });
	
	      _Notification.notify.error('Failed to resend Custom Alert ' + alert.name);
	    };
	
	    _superagent2.default.post((0, _url2.default)('/search-alerts/json/resend/' + alert.id)).set('Content-Type', 'application/json').set('X-Csrf-Token', alert.resend_token).then(function (_ref11) {
	      var body = _ref11.body;
	      return body && body.success ? onSuccess() : onError(body && body.error);
	    }).catch(function (error) {
	      return onError(error);
	    });
	  };
	};

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = PagedFieldArray;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFinalFormArrays = __webpack_require__(322);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _ResultsPaginator = __webpack_require__(108);
	
	var _ResultsPaginator2 = _interopRequireDefault(_ResultsPaginator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LOCAL_STORAGE_ITEMSPERPAGE_KEY = 'PagedFieldArray.itemsPerPage';
	
	function PagedFieldArray(_ref) {
	  var name = _ref.name,
	      ItemComponent = _ref.item,
	      AfterComponent = _ref.after;
	
	  var _useState = (0, _react.useState)(1),
	      page = _useState[0],
	      gotoPage = _useState[1];
	
	  var _useState2 = (0, _react.useState)(localStorage.getItem(LOCAL_STORAGE_ITEMSPERPAGE_KEY) || 15),
	      itemsPerPage = _useState2[0],
	      setItemsPerPage = _useState2[1];
	
	  var topOfPage = (0, _react.useRef)(null);
	
	  var _useFieldArray = (0, _reactFinalFormArrays.useFieldArray)(name, { subscription: {} }),
	      fields = _useFieldArray.fields;
	
	  var totalPages = Math.ceil(fields.length / itemsPerPage);
	
	  (0, _react.useLayoutEffect)(function () {
	    if (topOfPage.current) topOfPage.current.scrollIntoView({ behavior: 'smooth' });
	  }, [page]);
	
	  (0, _react.useEffect)(function () {
	    localStorage.setItem(LOCAL_STORAGE_ITEMSPERPAGE_KEY, itemsPerPage);
	  }, [itemsPerPage]);
	
	  function Pager() {
	    if (totalPages === 0) return null;
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Well,
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { float: 'left' } },
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Records ',
	            (page - 1) * itemsPerPage + 1,
	            ' - ',
	            Math.min(page * itemsPerPage, fields.length),
	            ' of',
	            ' ',
	            fields.length
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { float: 'left', marginLeft: 24 } },
	          'Show',
	          ' ',
	          _react2.default.createElement(
	            'select',
	            {
	              onChange: function onChange(e) {
	                setItemsPerPage(e.target.value);
	                gotoPage(1);
	              },
	              value: itemsPerPage
	            },
	            _react2.default.createElement(
	              'option',
	              { value: 1 },
	              '1'
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 5 },
	              '5'
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 10 },
	              '10'
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 15 },
	              '15'
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 20 },
	              '20'
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 25 },
	              '25'
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 50 },
	              '50'
	            )
	          ),
	          ' ',
	          'records per page'
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { float: 'right', marginTop: -9 } },
	          _react2.default.createElement(_ResultsPaginator2.default, { totalPages: totalPages, selectedPage: page, onChangePage: function onChangePage(page) {
	              return gotoPage(page + 1);
	            } })
	        )
	      )
	    );
	  }
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement('div', { ref: topOfPage }),
	    _react2.default.createElement(Pager, null),
	    fields.map(function (name, index) {
	      return page * itemsPerPage > index && index >= (page - 1) * itemsPerPage ? _react2.default.createElement(ItemComponent, _extends({ key: name }, { name: name, index: index, fields: fields })) : null;
	    }),
	    (page === totalPages || totalPages === 0) && AfterComponent && _react2.default.createElement(AfterComponent, null),
	    _react2.default.createElement(Pager, null)
	  );
	}

/***/ },
/* 425 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var firstLetterCapitalize = exports.firstLetterCapitalize = function firstLetterCapitalize(text) {
	    return text[0].toUpperCase() + text.slice(1);
	};

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(754), __esModule: true };

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1330), __esModule: true };

/***/ },
/* 428 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _html = __webpack_require__(1283);
	
	var _html2 = _interopRequireDefault(_html);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _html2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9odG1sL2luZGV4LmpzIl0sIm5hbWVzIjpbImRlZmF1bHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7UUFBT0EsTyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZyb20gJy4vaHRtbCc7XG4iXX0=

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _splitStringTransformer = __webpack_require__(1308);
	
	var _splitStringTransformer2 = _interopRequireDefault(_splitStringTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _splitStringTransformer2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zcGxpdFN0cmluZ1RyYW5zZm9ybWVyL2luZGV4LmpzIl0sIm5hbWVzIjpbImRlZmF1bHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7UUFBT0EsTyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZyb20gJy4vc3BsaXRTdHJpbmdUcmFuc2Zvcm1lcic7XG4iXX0=

/***/ },
/* 431 */
143,
/* 432 */
[2254, 115, 436, 142, 284, 1336],
/* 433 */
[2257, 211, 56],
/* 434 */
[2262, 61, 44],
/* 435 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 436 */
[2268, 211],
/* 437 */
[2270, 211],
/* 438 */
[2277, 210],
/* 439 */
[2279, 83, 765, 435, 444, 434, 758],
/* 440 */
[2282, 214, 215, 119, 447, 117, 759, 73],
/* 441 */
293,
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(118);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(118);


/***/ },
/* 444 */
[2296, 445, 285],
/* 445 */
[2297, 28, 44, 212],
/* 446 */
88,
/* 447 */
[2306, 61],
/* 448 */
[2308, 61],
/* 449 */
[2309, 44, 28, 212, 450, 95],
/* 450 */
[2310, 56],
/* 451 */
[2312, 433, 56, 181, 28],
/* 452 */
/***/ function(module, exports) {



/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(297)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(43);
	var toAbsoluteIndex = __webpack_require__(151);
	var toLength = __webpack_require__(37);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ },
/* 455 */
[2256, 1383],
/* 456 */
[2259, 41, 148],
/* 457 */
[2262, 29, 25],
/* 458 */
435,
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(36)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ },
/* 460 */
[2266, 25],
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(29);
	var setPrototypeOf = __webpack_require__(470).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ },
/* 462 */
[2269, 184, 36],
/* 463 */
[2272, 145, 148, 185, 65, 36],
/* 464 */
[2273, 121, 3, 66, 65, 184, 463, 185, 76, 36],
/* 465 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ },
/* 466 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ },
/* 467 */
[2276, 25, 475, 84],
/* 468 */
[2277, 57],
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(219);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ },
/* 470 */
[2294, 29, 22, 86, 75],
/* 471 */
[2296, 222, 152],
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(290);
	var defined = __webpack_require__(97);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(88);
	var defined = __webpack_require__(97);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ },
/* 474 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ },
/* 475 */
[2301, 86, 785, 460, 457, 25, 84],
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(25);
	var DESCRIPTORS = __webpack_require__(38);
	var LIBRARY = __webpack_require__(121);
	var $typed = __webpack_require__(298);
	var hide = __webpack_require__(65);
	var redefineAll = __webpack_require__(149);
	var fails = __webpack_require__(27);
	var anInstance = __webpack_require__(143);
	var toInteger = __webpack_require__(88);
	var toLength = __webpack_require__(37);
	var toIndex = __webpack_require__(804);
	var gOPN = __webpack_require__(146).f;
	var dP = __webpack_require__(41).f;
	var arrayFill = __webpack_require__(454);
	var setToStringTag = __webpack_require__(185);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ },
/* 477 */
[2309, 25, 85, 121, 805, 41],
/* 478 */
[2312, 183, 36, 184, 85],
/* 479 */
[2315, 120, 788, 184, 77, 464],
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(19));
	
	var _index3 = _interopRequireDefault(__webpack_require__(301));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function getUTCWeekYear(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var year = date.getUTCFullYear();
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	
	  var firstWeekOfNextYear = new Date(0);
	  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
	  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index3.default)(firstWeekOfNextYear, dirtyOptions);
	  var firstWeekOfThisYear = new Date(0);
	  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
	  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index3.default)(firstWeekOfThisYear, dirtyOptions);
	
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addDays;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addDays
	 * @category Day Helpers
	 * @summary Add the specified number of days to the given date.
	 *
	 * @description
	 * Add the specified number of days to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be added
	 * @returns {Date} the new date with the days added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 10 days to 1 September 2014:
	 * var result = addDays(new Date(2014, 8, 1), 10)
	 * //=> Thu Sep 11 2014 00:00:00
	 */
	function addDays(dirtyDate, dirtyAmount) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate);
	  var amount = (0, _index.default)(dirtyAmount);
	  date.setDate(date.getDate() + amount);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addMilliseconds
	 * @category Millisecond Helpers
	 * @summary Add the specified number of milliseconds to the given date.
	 *
	 * @description
	 * Add the specified number of milliseconds to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be added
	 * @returns {Date} the new date with the milliseconds added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
	 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:30.750
	 */
	function addMilliseconds(dirtyDate, dirtyAmount) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var timestamp = (0, _index2.default)(dirtyDate).getTime();
	  var amount = (0, _index.default)(dirtyAmount);
	  return new Date(timestamp + amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(19));
	
	var _index3 = _interopRequireDefault(__webpack_require__(821));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addMonths
	 * @category Month Helpers
	 * @summary Add the specified number of months to the given date.
	 *
	 * @description
	 * Add the specified number of months to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be added
	 * @returns {Date} the new date with the months added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 months to 1 September 2014:
	 * var result = addMonths(new Date(2014, 8, 1), 5)
	 * //=> Sun Feb 01 2015 00:00:00
	 */
	function addMonths(dirtyDate, dirtyAmount) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate);
	  var amount = (0, _index.default)(dirtyAmount);
	  var desiredMonth = date.getMonth() + amount;
	  var dateWithDesiredMonth = new Date(0);
	  dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1);
	  dateWithDesiredMonth.setHours(0, 0, 0, 0);
	  var daysInMonth = (0, _index3.default)(dateWithDesiredMonth); // Set the last day of the new month
	  // if the original date was the last day of the longer month
	
	  date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()));
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfDay;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfDay
	 * @category Day Helpers
	 * @summary Return the start of a day for the given date.
	 *
	 * @description
	 * Return the start of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a day
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a day for 2 September 2014 11:55:00:
	 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 00:00:00
	 */
	function startOfDay(dirtyDate) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(35);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(123));
	
	var off = function off() {};
	
	if (_inDOM.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	var _default = off;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(35);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(123));
	
	var on = function on() {};
	
	if (_inDOM.default) {
	  on = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	var _default = on;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(35);
	
	exports.__esModule = true;
	exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(123));
	
	var transform = 'transform';
	exports.transform = transform;
	var prefix, transitionEnd, animationEnd;
	exports.animationEnd = animationEnd;
	exports.transitionEnd = transitionEnd;
	var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
	exports.transitionDelay = transitionDelay;
	exports.transitionTiming = transitionTiming;
	exports.transitionDuration = transitionDuration;
	exports.transitionProperty = transitionProperty;
	var animationName, animationDuration, animationTiming, animationDelay;
	exports.animationDelay = animationDelay;
	exports.animationTiming = animationTiming;
	exports.animationDuration = animationDuration;
	exports.animationName = animationName;
	
	if (_inDOM.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	  exports.transform = transform = prefix + "-" + transform;
	  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
	  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
	  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
	  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
	  exports.animationName = animationName = prefix + "-animation-name";
	  exports.animationDuration = animationDuration = prefix + "-animation-duration";
	  exports.animationTiming = animationTiming = prefix + "-animation-delay";
	  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
	}
	
	var _default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	exports.default = _default;
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	  var vendorMap = {
	    O: function O(e) {
	      return "o" + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return "webkit" + e;
	    },
	    ms: function ms(e) {
	      return "MS" + e;
	    }
	  };
	  var vendors = Object.keys(vendorMap);
	  var transitionEnd, animationEnd;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + "TransitionProperty" in style) {
	      prefix = "-" + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	  style = null;
	  return {
	    animationEnd: animationEnd,
	    transitionEnd: transitionEnd,
	    prefix: prefix
	  };
	}

/***/ },
/* 488 */,
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(190),
	    root = __webpack_require__(125);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1871),
	    mapCacheDelete = __webpack_require__(1872),
	    mapCacheGet = __webpack_require__(1873),
	    mapCacheHas = __webpack_require__(1874),
	    mapCacheSet = __webpack_require__(1875);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 491 */
[2246, 125],
/* 492 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 493 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 494 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(1894);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	module.exports = isArguments;


/***/ },
/* 496 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 497 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	function isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
	  if (Reflect.construct.sham) return false;
	  if (typeof Proxy === "function") return true;
	
	  try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _construct(Parent, args, Class) {
	  if (isNativeReflectConstruct()) {
	    _construct = Reflect.construct;
	  } else {
	    _construct = function _construct(Parent, args, Class) {
	      var a = [null];
	      a.push.apply(a, args);
	      var Constructor = Function.bind.apply(Parent, a);
	      var instance = new Constructor();
	      if (Class) _setPrototypeOf(instance, Class.prototype);
	      return instance;
	    };
	  }
	
	  return _construct.apply(null, arguments);
	}
	
	function _isNativeFunction(fn) {
	  return Function.toString.call(fn).indexOf("[native code]") !== -1;
	}
	
	function _wrapNativeSuper(Class) {
	  var _cache = typeof Map === "function" ? new Map() : undefined;
	
	  _wrapNativeSuper = function _wrapNativeSuper(Class) {
	    if (Class === null || !_isNativeFunction(Class)) return Class;
	
	    if (typeof Class !== "function") {
	      throw new TypeError("Super expression must either be null or a function");
	    }
	
	    if (typeof _cache !== "undefined") {
	      if (_cache.has(Class)) return _cache.get(Class);
	
	      _cache.set(Class, Wrapper);
	    }
	
	    function Wrapper() {
	      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
	    }
	
	    Wrapper.prototype = Object.create(Class.prototype, {
	      constructor: {
	        value: Wrapper,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    return _setPrototypeOf(Wrapper, Class);
	  };
	
	  return _wrapNativeSuper(Class);
	}
	
	// these aren't really private, but nor are they really useful to document
	
	/**
	 * @private
	 */
	var LuxonError =
	/*#__PURE__*/
	function (_Error) {
	  _inheritsLoose(LuxonError, _Error);
	
	  function LuxonError() {
	    return _Error.apply(this, arguments) || this;
	  }
	
	  return LuxonError;
	}(_wrapNativeSuper(Error));
	/**
	 * @private
	 */
	
	
	var InvalidDateTimeError =
	/*#__PURE__*/
	function (_LuxonError) {
	  _inheritsLoose(InvalidDateTimeError, _LuxonError);
	
	  function InvalidDateTimeError(reason) {
	    return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
	  }
	
	  return InvalidDateTimeError;
	}(LuxonError);
	/**
	 * @private
	 */
	
	var InvalidIntervalError =
	/*#__PURE__*/
	function (_LuxonError2) {
	  _inheritsLoose(InvalidIntervalError, _LuxonError2);
	
	  function InvalidIntervalError(reason) {
	    return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
	  }
	
	  return InvalidIntervalError;
	}(LuxonError);
	/**
	 * @private
	 */
	
	var InvalidDurationError =
	/*#__PURE__*/
	function (_LuxonError3) {
	  _inheritsLoose(InvalidDurationError, _LuxonError3);
	
	  function InvalidDurationError(reason) {
	    return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
	  }
	
	  return InvalidDurationError;
	}(LuxonError);
	/**
	 * @private
	 */
	
	var ConflictingSpecificationError =
	/*#__PURE__*/
	function (_LuxonError4) {
	  _inheritsLoose(ConflictingSpecificationError, _LuxonError4);
	
	  function ConflictingSpecificationError() {
	    return _LuxonError4.apply(this, arguments) || this;
	  }
	
	  return ConflictingSpecificationError;
	}(LuxonError);
	/**
	 * @private
	 */
	
	var InvalidUnitError =
	/*#__PURE__*/
	function (_LuxonError5) {
	  _inheritsLoose(InvalidUnitError, _LuxonError5);
	
	  function InvalidUnitError(unit) {
	    return _LuxonError5.call(this, "Invalid unit " + unit) || this;
	  }
	
	  return InvalidUnitError;
	}(LuxonError);
	/**
	 * @private
	 */
	
	var InvalidArgumentError =
	/*#__PURE__*/
	function (_LuxonError6) {
	  _inheritsLoose(InvalidArgumentError, _LuxonError6);
	
	  function InvalidArgumentError() {
	    return _LuxonError6.apply(this, arguments) || this;
	  }
	
	  return InvalidArgumentError;
	}(LuxonError);
	/**
	 * @private
	 */
	
	var ZoneIsAbstractError =
	/*#__PURE__*/
	function (_LuxonError7) {
	  _inheritsLoose(ZoneIsAbstractError, _LuxonError7);
	
	  function ZoneIsAbstractError() {
	    return _LuxonError7.call(this, "Zone is an abstract class") || this;
	  }
	
	  return ZoneIsAbstractError;
	}(LuxonError);
	
	/**
	 * @private
	 */
	var n = "numeric",
	    s = "short",
	    l = "long";
	var DATE_SHORT = {
	  year: n,
	  month: n,
	  day: n
	};
	var DATE_MED = {
	  year: n,
	  month: s,
	  day: n
	};
	var DATE_FULL = {
	  year: n,
	  month: l,
	  day: n
	};
	var DATE_HUGE = {
	  year: n,
	  month: l,
	  day: n,
	  weekday: l
	};
	var TIME_SIMPLE = {
	  hour: n,
	  minute: n
	};
	var TIME_WITH_SECONDS = {
	  hour: n,
	  minute: n,
	  second: n
	};
	var TIME_WITH_SHORT_OFFSET = {
	  hour: n,
	  minute: n,
	  second: n,
	  timeZoneName: s
	};
	var TIME_WITH_LONG_OFFSET = {
	  hour: n,
	  minute: n,
	  second: n,
	  timeZoneName: l
	};
	var TIME_24_SIMPLE = {
	  hour: n,
	  minute: n,
	  hour12: false
	};
	/**
	 * {@link toLocaleString}; format like '09:30:23', always 24-hour.
	 */
	
	var TIME_24_WITH_SECONDS = {
	  hour: n,
	  minute: n,
	  second: n,
	  hour12: false
	};
	/**
	 * {@link toLocaleString}; format like '09:30:23 EDT', always 24-hour.
	 */
	
	var TIME_24_WITH_SHORT_OFFSET = {
	  hour: n,
	  minute: n,
	  second: n,
	  hour12: false,
	  timeZoneName: s
	};
	/**
	 * {@link toLocaleString}; format like '09:30:23 Eastern Daylight Time', always 24-hour.
	 */
	
	var TIME_24_WITH_LONG_OFFSET = {
	  hour: n,
	  minute: n,
	  second: n,
	  hour12: false,
	  timeZoneName: l
	};
	/**
	 * {@link toLocaleString}; format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
	 */
	
	var DATETIME_SHORT = {
	  year: n,
	  month: n,
	  day: n,
	  hour: n,
	  minute: n
	};
	/**
	 * {@link toLocaleString}; format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
	 */
	
	var DATETIME_SHORT_WITH_SECONDS = {
	  year: n,
	  month: n,
	  day: n,
	  hour: n,
	  minute: n,
	  second: n
	};
	var DATETIME_MED = {
	  year: n,
	  month: s,
	  day: n,
	  hour: n,
	  minute: n
	};
	var DATETIME_MED_WITH_SECONDS = {
	  year: n,
	  month: s,
	  day: n,
	  hour: n,
	  minute: n,
	  second: n
	};
	var DATETIME_MED_WITH_WEEKDAY = {
	  year: n,
	  month: s,
	  day: n,
	  weekday: s,
	  hour: n,
	  minute: n
	};
	var DATETIME_FULL = {
	  year: n,
	  month: l,
	  day: n,
	  hour: n,
	  minute: n,
	  timeZoneName: s
	};
	var DATETIME_FULL_WITH_SECONDS = {
	  year: n,
	  month: l,
	  day: n,
	  hour: n,
	  minute: n,
	  second: n,
	  timeZoneName: s
	};
	var DATETIME_HUGE = {
	  year: n,
	  month: l,
	  day: n,
	  weekday: l,
	  hour: n,
	  minute: n,
	  timeZoneName: l
	};
	var DATETIME_HUGE_WITH_SECONDS = {
	  year: n,
	  month: l,
	  day: n,
	  weekday: l,
	  hour: n,
	  minute: n,
	  second: n,
	  timeZoneName: l
	};
	
	/*
	  This is just a junk drawer, containing anything used across multiple classes.
	  Because Luxon is small(ish), this should stay small and we won't worry about splitting
	  it up into, say, parsingUtil.js and basicUtil.js and so on. But they are divided up by feature area.
	*/
	/**
	 * @private
	 */
	// TYPES
	
	function isUndefined(o) {
	  return typeof o === "undefined";
	}
	function isNumber(o) {
	  return typeof o === "number";
	}
	function isInteger(o) {
	  return typeof o === "number" && o % 1 === 0;
	}
	function isString(o) {
	  return typeof o === "string";
	}
	function isDate(o) {
	  return Object.prototype.toString.call(o) === "[object Date]";
	} // CAPABILITIES
	
	function hasIntl() {
	  try {
	    return typeof Intl !== "undefined" && Intl.DateTimeFormat;
	  } catch (e) {
	    return false;
	  }
	}
	function hasFormatToParts() {
	  return !isUndefined(Intl.DateTimeFormat.prototype.formatToParts);
	}
	function hasRelative() {
	  try {
	    return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
	  } catch (e) {
	    return false;
	  }
	} // OBJECTS AND ARRAYS
	
	function maybeArray(thing) {
	  return Array.isArray(thing) ? thing : [thing];
	}
	function bestBy(arr, by, compare) {
	  if (arr.length === 0) {
	    return undefined;
	  }
	
	  return arr.reduce(function (best, next) {
	    var pair = [by(next), next];
	
	    if (!best) {
	      return pair;
	    } else if (compare(best[0], pair[0]) === best[0]) {
	      return best;
	    } else {
	      return pair;
	    }
	  }, null)[1];
	}
	function pick(obj, keys) {
	  return keys.reduce(function (a, k) {
	    a[k] = obj[k];
	    return a;
	  }, {});
	}
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	} // NUMBERS AND STRINGS
	
	function integerBetween(thing, bottom, top) {
	  return isInteger(thing) && thing >= bottom && thing <= top;
	} // x % n but takes the sign of n instead of x
	
	function floorMod(x, n) {
	  return x - n * Math.floor(x / n);
	}
	function padStart(input, n) {
	  if (n === void 0) {
	    n = 2;
	  }
	
	  if (input.toString().length < n) {
	    return ("0".repeat(n) + input).slice(-n);
	  } else {
	    return input.toString();
	  }
	}
	function parseInteger(string) {
	  if (isUndefined(string) || string === null || string === "") {
	    return undefined;
	  } else {
	    return parseInt(string, 10);
	  }
	}
	function parseMillis(fraction) {
	  // Return undefined (instead of 0) in these cases, where fraction is not set
	  if (isUndefined(fraction) || fraction === null || fraction === "") {
	    return undefined;
	  } else {
	    var f = parseFloat("0." + fraction) * 1000;
	    return Math.floor(f);
	  }
	}
	function roundTo(number, digits, towardZero) {
	  if (towardZero === void 0) {
	    towardZero = false;
	  }
	
	  var factor = Math.pow(10, digits),
	      rounder = towardZero ? Math.trunc : Math.round;
	  return rounder(number * factor) / factor;
	} // DATE BASICS
	
	function isLeapYear(year) {
	  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
	}
	function daysInYear(year) {
	  return isLeapYear(year) ? 366 : 365;
	}
	function daysInMonth(year, month) {
	  var modMonth = floorMod(month - 1, 12) + 1,
	      modYear = year + (month - modMonth) / 12;
	
	  if (modMonth === 2) {
	    return isLeapYear(modYear) ? 29 : 28;
	  } else {
	    return [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][modMonth - 1];
	  }
	} // covert a calendar object to a local timestamp (epoch, but with the offset baked in)
	
	function objToLocalTS(obj) {
	  var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond); // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
	
	  if (obj.year < 100 && obj.year >= 0) {
	    d = new Date(d);
	    d.setUTCFullYear(d.getUTCFullYear() - 1900);
	  }
	
	  return +d;
	}
	function weeksInWeekYear(weekYear) {
	  var p1 = (weekYear + Math.floor(weekYear / 4) - Math.floor(weekYear / 100) + Math.floor(weekYear / 400)) % 7,
	      last = weekYear - 1,
	      p2 = (last + Math.floor(last / 4) - Math.floor(last / 100) + Math.floor(last / 400)) % 7;
	  return p1 === 4 || p2 === 3 ? 53 : 52;
	}
	function untruncateYear(year) {
	  if (year > 99) {
	    return year;
	  } else return year > 60 ? 1900 + year : 2000 + year;
	} // PARSING
	
	function parseZoneInfo(ts, offsetFormat, locale, timeZone) {
	  if (timeZone === void 0) {
	    timeZone = null;
	  }
	
	  var date = new Date(ts),
	      intlOpts = {
	    hour12: false,
	    year: "numeric",
	    month: "2-digit",
	    day: "2-digit",
	    hour: "2-digit",
	    minute: "2-digit"
	  };
	
	  if (timeZone) {
	    intlOpts.timeZone = timeZone;
	  }
	
	  var modified = Object.assign({
	    timeZoneName: offsetFormat
	  }, intlOpts),
	      intl = hasIntl();
	
	  if (intl && hasFormatToParts()) {
	    var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function (m) {
	      return m.type.toLowerCase() === "timezonename";
	    });
	    return parsed ? parsed.value : null;
	  } else if (intl) {
	    // this probably doesn't work for all locales
	    var without = new Intl.DateTimeFormat(locale, intlOpts).format(date),
	        included = new Intl.DateTimeFormat(locale, modified).format(date),
	        diffed = included.substring(without.length),
	        trimmed = diffed.replace(/^[, \u200e]+/, "");
	    return trimmed;
	  } else {
	    return null;
	  }
	} // signedOffset('-5', '30') -> -330
	
	function signedOffset(offHourStr, offMinuteStr) {
	  var offHour = parseInt(offHourStr, 10); // don't || this because we want to preserve -0
	
	  if (Number.isNaN(offHour)) {
	    offHour = 0;
	  }
	
	  var offMin = parseInt(offMinuteStr, 10) || 0,
	      offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
	  return offHour * 60 + offMinSigned;
	} // COERCION
	
	function asNumber(value) {
	  var numericValue = Number(value);
	  if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new InvalidArgumentError("Invalid unit value " + value);
	  return numericValue;
	}
	function normalizeObject(obj, normalizer, nonUnitKeys) {
	  var normalized = {};
	
	  for (var u in obj) {
	    if (hasOwnProperty(obj, u)) {
	      if (nonUnitKeys.indexOf(u) >= 0) continue;
	      var v = obj[u];
	      if (v === undefined || v === null) continue;
	      normalized[normalizer(u)] = asNumber(v);
	    }
	  }
	
	  return normalized;
	}
	function formatOffset(offset, format) {
	  var hours = Math.trunc(offset / 60),
	      minutes = Math.abs(offset % 60),
	      sign = hours >= 0 && !Object.is(hours, -0) ? "+" : "-",
	      base = "" + sign + Math.abs(hours);
	
	  switch (format) {
	    case "short":
	      return "" + sign + padStart(Math.abs(hours), 2) + ":" + padStart(minutes, 2);
	
	    case "narrow":
	      return minutes > 0 ? base + ":" + minutes : base;
	
	    case "techie":
	      return "" + sign + padStart(Math.abs(hours), 2) + padStart(minutes, 2);
	
	    default:
	      throw new RangeError("Value format " + format + " is out of range for property format");
	  }
	}
	function timeObject(obj) {
	  return pick(obj, ["hour", "minute", "second", "millisecond"]);
	}
	var ianaRegex = /[A-Za-z_+-]{1,256}(:?\/[A-Za-z_+-]{1,256}(\/[A-Za-z_+-]{1,256})?)?/;
	
	function stringify(obj) {
	  return JSON.stringify(obj, Object.keys(obj).sort());
	}
	/**
	 * @private
	 */
	
	
	var monthsLong = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	var monthsShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	var monthsNarrow = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
	function months(length) {
	  switch (length) {
	    case "narrow":
	      return monthsNarrow;
	
	    case "short":
	      return monthsShort;
	
	    case "long":
	      return monthsLong;
	
	    case "numeric":
	      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
	
	    case "2-digit":
	      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
	
	    default:
	      return null;
	  }
	}
	var weekdaysLong = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
	var weekdaysShort = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
	var weekdaysNarrow = ["M", "T", "W", "T", "F", "S", "S"];
	function weekdays(length) {
	  switch (length) {
	    case "narrow":
	      return weekdaysNarrow;
	
	    case "short":
	      return weekdaysShort;
	
	    case "long":
	      return weekdaysLong;
	
	    case "numeric":
	      return ["1", "2", "3", "4", "5", "6", "7"];
	
	    default:
	      return null;
	  }
	}
	var meridiems = ["AM", "PM"];
	var erasLong = ["Before Christ", "Anno Domini"];
	var erasShort = ["BC", "AD"];
	var erasNarrow = ["B", "A"];
	function eras(length) {
	  switch (length) {
	    case "narrow":
	      return erasNarrow;
	
	    case "short":
	      return erasShort;
	
	    case "long":
	      return erasLong;
	
	    default:
	      return null;
	  }
	}
	function meridiemForDateTime(dt) {
	  return meridiems[dt.hour < 12 ? 0 : 1];
	}
	function weekdayForDateTime(dt, length) {
	  return weekdays(length)[dt.weekday - 1];
	}
	function monthForDateTime(dt, length) {
	  return months(length)[dt.month - 1];
	}
	function eraForDateTime(dt, length) {
	  return eras(length)[dt.year < 0 ? 0 : 1];
	}
	function formatRelativeTime(unit, count, numeric, narrow) {
	  if (numeric === void 0) {
	    numeric = "always";
	  }
	
	  if (narrow === void 0) {
	    narrow = false;
	  }
	
	  var units = {
	    years: ["year", "yr."],
	    quarters: ["quarter", "qtr."],
	    months: ["month", "mo."],
	    weeks: ["week", "wk."],
	    days: ["day", "day", "days"],
	    hours: ["hour", "hr."],
	    minutes: ["minute", "min."],
	    seconds: ["second", "sec."]
	  };
	  var lastable = ["hours", "minutes", "seconds"].indexOf(unit) === -1;
	
	  if (numeric === "auto" && lastable) {
	    var isDay = unit === "days";
	
	    switch (count) {
	      case 1:
	        return isDay ? "tomorrow" : "next " + units[unit][0];
	
	      case -1:
	        return isDay ? "yesterday" : "last " + units[unit][0];
	
	      case 0:
	        return isDay ? "today" : "this " + units[unit][0];
	
	      default: // fall through
	
	    }
	  }
	
	  var isInPast = Object.is(count, -0) || count < 0,
	      fmtValue = Math.abs(count),
	      singular = fmtValue === 1,
	      lilUnits = units[unit],
	      fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
	  return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
	}
	function formatString(knownFormat) {
	  // these all have the offsets removed because we don't have access to them
	  // without all the intl stuff this is backfilling
	  var filtered = pick(knownFormat, ["weekday", "era", "year", "month", "day", "hour", "minute", "second", "timeZoneName", "hour12"]),
	      key = stringify(filtered),
	      dateTimeHuge = "EEEE, LLLL d, yyyy, h:mm a";
	
	  switch (key) {
	    case stringify(DATE_SHORT):
	      return "M/d/yyyy";
	
	    case stringify(DATE_MED):
	      return "LLL d, yyyy";
	
	    case stringify(DATE_FULL):
	      return "LLLL d, yyyy";
	
	    case stringify(DATE_HUGE):
	      return "EEEE, LLLL d, yyyy";
	
	    case stringify(TIME_SIMPLE):
	      return "h:mm a";
	
	    case stringify(TIME_WITH_SECONDS):
	      return "h:mm:ss a";
	
	    case stringify(TIME_WITH_SHORT_OFFSET):
	      return "h:mm a";
	
	    case stringify(TIME_WITH_LONG_OFFSET):
	      return "h:mm a";
	
	    case stringify(TIME_24_SIMPLE):
	      return "HH:mm";
	
	    case stringify(TIME_24_WITH_SECONDS):
	      return "HH:mm:ss";
	
	    case stringify(TIME_24_WITH_SHORT_OFFSET):
	      return "HH:mm";
	
	    case stringify(TIME_24_WITH_LONG_OFFSET):
	      return "HH:mm";
	
	    case stringify(DATETIME_SHORT):
	      return "M/d/yyyy, h:mm a";
	
	    case stringify(DATETIME_MED):
	      return "LLL d, yyyy, h:mm a";
	
	    case stringify(DATETIME_FULL):
	      return "LLLL d, yyyy, h:mm a";
	
	    case stringify(DATETIME_HUGE):
	      return dateTimeHuge;
	
	    case stringify(DATETIME_SHORT_WITH_SECONDS):
	      return "M/d/yyyy, h:mm:ss a";
	
	    case stringify(DATETIME_MED_WITH_SECONDS):
	      return "LLL d, yyyy, h:mm:ss a";
	
	    case stringify(DATETIME_MED_WITH_WEEKDAY):
	      return "EEE, d LLL yyyy, h:mm a";
	
	    case stringify(DATETIME_FULL_WITH_SECONDS):
	      return "LLLL d, yyyy, h:mm:ss a";
	
	    case stringify(DATETIME_HUGE_WITH_SECONDS):
	      return "EEEE, LLLL d, yyyy, h:mm:ss a";
	
	    default:
	      return dateTimeHuge;
	  }
	}
	
	function stringifyTokens(splits, tokenToString) {
	  var s = "";
	
	  for (var _iterator = splits, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var token = _ref;
	
	    if (token.literal) {
	      s += token.val;
	    } else {
	      s += tokenToString(token.val);
	    }
	  }
	
	  return s;
	}
	
	var _macroTokenToFormatOpts = {
	  D: DATE_SHORT,
	  DD: DATE_MED,
	  DDD: DATE_FULL,
	  DDDD: DATE_HUGE,
	  t: TIME_SIMPLE,
	  tt: TIME_WITH_SECONDS,
	  ttt: TIME_WITH_SHORT_OFFSET,
	  tttt: TIME_WITH_LONG_OFFSET,
	  T: TIME_24_SIMPLE,
	  TT: TIME_24_WITH_SECONDS,
	  TTT: TIME_24_WITH_SHORT_OFFSET,
	  TTTT: TIME_24_WITH_LONG_OFFSET,
	  f: DATETIME_SHORT,
	  ff: DATETIME_MED,
	  fff: DATETIME_FULL,
	  ffff: DATETIME_HUGE,
	  F: DATETIME_SHORT_WITH_SECONDS,
	  FF: DATETIME_MED_WITH_SECONDS,
	  FFF: DATETIME_FULL_WITH_SECONDS,
	  FFFF: DATETIME_HUGE_WITH_SECONDS
	};
	/**
	 * @private
	 */
	
	var Formatter =
	/*#__PURE__*/
	function () {
	  Formatter.create = function create(locale, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    return new Formatter(locale, opts);
	  };
	
	  Formatter.parseFormat = function parseFormat(fmt) {
	    var current = null,
	        currentFull = "",
	        bracketed = false;
	    var splits = [];
	
	    for (var i = 0; i < fmt.length; i++) {
	      var c = fmt.charAt(i);
	
	      if (c === "'") {
	        if (currentFull.length > 0) {
	          splits.push({
	            literal: bracketed,
	            val: currentFull
	          });
	        }
	
	        current = null;
	        currentFull = "";
	        bracketed = !bracketed;
	      } else if (bracketed) {
	        currentFull += c;
	      } else if (c === current) {
	        currentFull += c;
	      } else {
	        if (currentFull.length > 0) {
	          splits.push({
	            literal: false,
	            val: currentFull
	          });
	        }
	
	        currentFull = c;
	        current = c;
	      }
	    }
	
	    if (currentFull.length > 0) {
	      splits.push({
	        literal: bracketed,
	        val: currentFull
	      });
	    }
	
	    return splits;
	  };
	
	  Formatter.macroTokenToFormatOpts = function macroTokenToFormatOpts(token) {
	    return _macroTokenToFormatOpts[token];
	  };
	
	  function Formatter(locale, formatOpts) {
	    this.opts = formatOpts;
	    this.loc = locale;
	    this.systemLoc = null;
	  }
	
	  var _proto = Formatter.prototype;
	
	  _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
	    if (this.systemLoc === null) {
	      this.systemLoc = this.loc.redefaultToSystem();
	    }
	
	    var df = this.systemLoc.dtFormatter(dt, Object.assign({}, this.opts, opts));
	    return df.format();
	  };
	
	  _proto.formatDateTime = function formatDateTime(dt, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    var df = this.loc.dtFormatter(dt, Object.assign({}, this.opts, opts));
	    return df.format();
	  };
	
	  _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    var df = this.loc.dtFormatter(dt, Object.assign({}, this.opts, opts));
	    return df.formatToParts();
	  };
	
	  _proto.resolvedOptions = function resolvedOptions(dt, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    var df = this.loc.dtFormatter(dt, Object.assign({}, this.opts, opts));
	    return df.resolvedOptions();
	  };
	
	  _proto.num = function num(n, p) {
	    if (p === void 0) {
	      p = 0;
	    }
	
	    // we get some perf out of doing this here, annoyingly
	    if (this.opts.forceSimple) {
	      return padStart(n, p);
	    }
	
	    var opts = Object.assign({}, this.opts);
	
	    if (p > 0) {
	      opts.padTo = p;
	    }
	
	    return this.loc.numberFormatter(opts).format(n);
	  };
	
	  _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
	    var _this = this;
	
	    var knownEnglish = this.loc.listingMode() === "en",
	        useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory" && hasFormatToParts(),
	        string = function string(opts, extract) {
	      return _this.loc.extract(dt, opts, extract);
	    },
	        formatOffset = function formatOffset(opts) {
	      if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) {
	        return "Z";
	      }
	
	      return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
	    },
	        meridiem = function meridiem() {
	      return knownEnglish ? meridiemForDateTime(dt) : string({
	        hour: "numeric",
	        hour12: true
	      }, "dayperiod");
	    },
	        month = function month(length, standalone) {
	      return knownEnglish ? monthForDateTime(dt, length) : string(standalone ? {
	        month: length
	      } : {
	        month: length,
	        day: "numeric"
	      }, "month");
	    },
	        weekday = function weekday(length, standalone) {
	      return knownEnglish ? weekdayForDateTime(dt, length) : string(standalone ? {
	        weekday: length
	      } : {
	        weekday: length,
	        month: "long",
	        day: "numeric"
	      }, "weekday");
	    },
	        maybeMacro = function maybeMacro(token) {
	      var formatOpts = Formatter.macroTokenToFormatOpts(token);
	
	      if (formatOpts) {
	        return _this.formatWithSystemDefault(dt, formatOpts);
	      } else {
	        return token;
	      }
	    },
	        era = function era(length) {
	      return knownEnglish ? eraForDateTime(dt, length) : string({
	        era: length
	      }, "era");
	    },
	        tokenToString = function tokenToString(token) {
	      // Where possible: http://cldr.unicode.org/translation/date-time#TOC-Stand-Alone-vs.-Format-Styles
	      switch (token) {
	        // ms
	        case "S":
	          return _this.num(dt.millisecond);
	
	        case "u": // falls through
	
	        case "SSS":
	          return _this.num(dt.millisecond, 3);
	        // seconds
	
	        case "s":
	          return _this.num(dt.second);
	
	        case "ss":
	          return _this.num(dt.second, 2);
	        // minutes
	
	        case "m":
	          return _this.num(dt.minute);
	
	        case "mm":
	          return _this.num(dt.minute, 2);
	        // hours
	
	        case "h":
	          return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
	
	        case "hh":
	          return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
	
	        case "H":
	          return _this.num(dt.hour);
	
	        case "HH":
	          return _this.num(dt.hour, 2);
	        // offset
	
	        case "Z":
	          // like +6
	          return formatOffset({
	            format: "narrow",
	            allowZ: _this.opts.allowZ
	          });
	
	        case "ZZ":
	          // like +06:00
	          return formatOffset({
	            format: "short",
	            allowZ: _this.opts.allowZ
	          });
	
	        case "ZZZ":
	          // like +0600
	          return formatOffset({
	            format: "techie",
	            allowZ: false
	          });
	
	        case "ZZZZ":
	          // like EST
	          return dt.zone.offsetName(dt.ts, {
	            format: "short",
	            locale: _this.loc.locale
	          });
	
	        case "ZZZZZ":
	          // like Eastern Standard Time
	          return dt.zone.offsetName(dt.ts, {
	            format: "long",
	            locale: _this.loc.locale
	          });
	        // zone
	
	        case "z":
	          // like America/New_York
	          return dt.zoneName;
	        // meridiems
	
	        case "a":
	          return meridiem();
	        // dates
	
	        case "d":
	          return useDateTimeFormatter ? string({
	            day: "numeric"
	          }, "day") : _this.num(dt.day);
	
	        case "dd":
	          return useDateTimeFormatter ? string({
	            day: "2-digit"
	          }, "day") : _this.num(dt.day, 2);
	        // weekdays - standalone
	
	        case "c":
	          // like 1
	          return _this.num(dt.weekday);
	
	        case "ccc":
	          // like 'Tues'
	          return weekday("short", true);
	
	        case "cccc":
	          // like 'Tuesday'
	          return weekday("long", true);
	
	        case "ccccc":
	          // like 'T'
	          return weekday("narrow", true);
	        // weekdays - format
	
	        case "E":
	          // like 1
	          return _this.num(dt.weekday);
	
	        case "EEE":
	          // like 'Tues'
	          return weekday("short", false);
	
	        case "EEEE":
	          // like 'Tuesday'
	          return weekday("long", false);
	
	        case "EEEEE":
	          // like 'T'
	          return weekday("narrow", false);
	        // months - standalone
	
	        case "L":
	          // like 1
	          return useDateTimeFormatter ? string({
	            month: "numeric",
	            day: "numeric"
	          }, "month") : _this.num(dt.month);
	
	        case "LL":
	          // like 01, doesn't seem to work
	          return useDateTimeFormatter ? string({
	            month: "2-digit",
	            day: "numeric"
	          }, "month") : _this.num(dt.month, 2);
	
	        case "LLL":
	          // like Jan
	          return month("short", true);
	
	        case "LLLL":
	          // like January
	          return month("long", true);
	
	        case "LLLLL":
	          // like J
	          return month("narrow", true);
	        // months - format
	
	        case "M":
	          // like 1
	          return useDateTimeFormatter ? string({
	            month: "numeric"
	          }, "month") : _this.num(dt.month);
	
	        case "MM":
	          // like 01
	          return useDateTimeFormatter ? string({
	            month: "2-digit"
	          }, "month") : _this.num(dt.month, 2);
	
	        case "MMM":
	          // like Jan
	          return month("short", false);
	
	        case "MMMM":
	          // like January
	          return month("long", false);
	
	        case "MMMMM":
	          // like J
	          return month("narrow", false);
	        // years
	
	        case "y":
	          // like 2014
	          return useDateTimeFormatter ? string({
	            year: "numeric"
	          }, "year") : _this.num(dt.year);
	
	        case "yy":
	          // like 14
	          return useDateTimeFormatter ? string({
	            year: "2-digit"
	          }, "year") : _this.num(dt.year.toString().slice(-2), 2);
	
	        case "yyyy":
	          // like 0012
	          return useDateTimeFormatter ? string({
	            year: "numeric"
	          }, "year") : _this.num(dt.year, 4);
	
	        case "yyyyyy":
	          // like 000012
	          return useDateTimeFormatter ? string({
	            year: "numeric"
	          }, "year") : _this.num(dt.year, 6);
	        // eras
	
	        case "G":
	          // like AD
	          return era("short");
	
	        case "GG":
	          // like Anno Domini
	          return era("long");
	
	        case "GGGGG":
	          return era("narrow");
	
	        case "kk":
	          return _this.num(dt.weekYear.toString().slice(-2), 2);
	
	        case "kkkk":
	          return _this.num(dt.weekYear, 4);
	
	        case "W":
	          return _this.num(dt.weekNumber);
	
	        case "WW":
	          return _this.num(dt.weekNumber, 2);
	
	        case "o":
	          return _this.num(dt.ordinal);
	
	        case "ooo":
	          return _this.num(dt.ordinal, 3);
	
	        case "q":
	          // like 1
	          return _this.num(dt.quarter);
	
	        case "qq":
	          // like 01
	          return _this.num(dt.quarter, 2);
	
	        case "X":
	          return _this.num(Math.floor(dt.ts / 1000));
	
	        case "x":
	          return _this.num(dt.ts);
	
	        default:
	          return maybeMacro(token);
	      }
	    };
	
	    return stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
	  };
	
	  _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
	    var _this2 = this;
	
	    var tokenToField = function tokenToField(token) {
	      switch (token[0]) {
	        case "S":
	          return "millisecond";
	
	        case "s":
	          return "second";
	
	        case "m":
	          return "minute";
	
	        case "h":
	          return "hour";
	
	        case "d":
	          return "day";
	
	        case "M":
	          return "month";
	
	        case "y":
	          return "year";
	
	        default:
	          return null;
	      }
	    },
	        tokenToString = function tokenToString(lildur) {
	      return function (token) {
	        var mapped = tokenToField(token);
	
	        if (mapped) {
	          return _this2.num(lildur.get(mapped), token.length);
	        } else {
	          return token;
	        }
	      };
	    },
	        tokens = Formatter.parseFormat(fmt),
	        realTokens = tokens.reduce(function (found, _ref2) {
	      var literal = _ref2.literal,
	          val = _ref2.val;
	      return literal ? found : found.concat(val);
	    }, []),
	        collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function (t) {
	      return t;
	    }));
	
	    return stringifyTokens(tokens, tokenToString(collapsed));
	  };
	
	  return Formatter;
	}();
	
	var Invalid =
	/*#__PURE__*/
	function () {
	  function Invalid(reason, explanation) {
	    this.reason = reason;
	    this.explanation = explanation;
	  }
	
	  var _proto = Invalid.prototype;
	
	  _proto.toMessage = function toMessage() {
	    if (this.explanation) {
	      return this.reason + ": " + this.explanation;
	    } else {
	      return this.reason;
	    }
	  };
	
	  return Invalid;
	}();
	
	/**
	 * @interface
	 */
	
	var Zone =
	/*#__PURE__*/
	function () {
	  function Zone() {}
	
	  var _proto = Zone.prototype;
	
	  /**
	   * Returns the offset's common name (such as EST) at the specified timestamp
	   * @abstract
	   * @param {number} ts - Epoch milliseconds for which to get the name
	   * @param {Object} opts - Options to affect the format
	   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
	   * @param {string} opts.locale - What locale to return the offset name in.
	   * @return {string}
	   */
	  _proto.offsetName = function offsetName(ts, opts) {
	    throw new ZoneIsAbstractError();
	  }
	  /**
	   * Returns the offset's value as a string
	   * @abstract
	   * @param {number} ts - Epoch milliseconds for which to get the offset
	   * @param {string} format - What style of offset to return.
	   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
	   * @return {string}
	   */
	  ;
	
	  _proto.formatOffset = function formatOffset(ts, format) {
	    throw new ZoneIsAbstractError();
	  }
	  /**
	   * Return the offset in minutes for this zone at the specified timestamp.
	   * @abstract
	   * @param {number} ts - Epoch milliseconds for which to compute the offset
	   * @return {number}
	   */
	  ;
	
	  _proto.offset = function offset(ts) {
	    throw new ZoneIsAbstractError();
	  }
	  /**
	   * Return whether this Zone is equal to another zone
	   * @abstract
	   * @param {Zone} otherZone - the zone to compare
	   * @return {boolean}
	   */
	  ;
	
	  _proto.equals = function equals(otherZone) {
	    throw new ZoneIsAbstractError();
	  }
	  /**
	   * Return whether this Zone is valid.
	   * @abstract
	   * @type {boolean}
	   */
	  ;
	
	  _createClass(Zone, [{
	    key: "type",
	
	    /**
	     * The type of zone
	     * @abstract
	     * @type {string}
	     */
	    get: function get() {
	      throw new ZoneIsAbstractError();
	    }
	    /**
	     * The name of this zone.
	     * @abstract
	     * @type {string}
	     */
	
	  }, {
	    key: "name",
	    get: function get() {
	      throw new ZoneIsAbstractError();
	    }
	    /**
	     * Returns whether the offset is known to be fixed for the whole year.
	     * @abstract
	     * @type {boolean}
	     */
	
	  }, {
	    key: "universal",
	    get: function get() {
	      throw new ZoneIsAbstractError();
	    }
	  }, {
	    key: "isValid",
	    get: function get() {
	      throw new ZoneIsAbstractError();
	    }
	  }]);
	
	  return Zone;
	}();
	
	var singleton = null;
	/**
	 * Represents the local zone for this Javascript environment.
	 * @implements {Zone}
	 */
	
	var LocalZone =
	/*#__PURE__*/
	function (_Zone) {
	  _inheritsLoose(LocalZone, _Zone);
	
	  function LocalZone() {
	    return _Zone.apply(this, arguments) || this;
	  }
	
	  var _proto = LocalZone.prototype;
	
	  /** @override **/
	  _proto.offsetName = function offsetName(ts, _ref) {
	    var format = _ref.format,
	        locale = _ref.locale;
	    return parseZoneInfo(ts, format, locale);
	  }
	  /** @override **/
	  ;
	
	  _proto.formatOffset = function formatOffset$1(ts, format) {
	    return formatOffset(this.offset(ts), format);
	  }
	  /** @override **/
	  ;
	
	  _proto.offset = function offset(ts) {
	    return -new Date(ts).getTimezoneOffset();
	  }
	  /** @override **/
	  ;
	
	  _proto.equals = function equals(otherZone) {
	    return otherZone.type === "local";
	  }
	  /** @override **/
	  ;
	
	  _createClass(LocalZone, [{
	    key: "type",
	
	    /** @override **/
	    get: function get() {
	      return "local";
	    }
	    /** @override **/
	
	  }, {
	    key: "name",
	    get: function get() {
	      if (hasIntl()) {
	        return new Intl.DateTimeFormat().resolvedOptions().timeZone;
	      } else return "local";
	    }
	    /** @override **/
	
	  }, {
	    key: "universal",
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: "isValid",
	    get: function get() {
	      return true;
	    }
	  }], [{
	    key: "instance",
	
	    /**
	     * Get a singleton instance of the local zone
	     * @return {LocalZone}
	     */
	    get: function get() {
	      if (singleton === null) {
	        singleton = new LocalZone();
	      }
	
	      return singleton;
	    }
	  }]);
	
	  return LocalZone;
	}(Zone);
	
	var matchingRegex = RegExp("^" + ianaRegex.source + "$");
	var dtfCache = {};
	
	function makeDTF(zone) {
	  if (!dtfCache[zone]) {
	    dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
	      hour12: false,
	      timeZone: zone,
	      year: "numeric",
	      month: "2-digit",
	      day: "2-digit",
	      hour: "2-digit",
	      minute: "2-digit",
	      second: "2-digit"
	    });
	  }
	
	  return dtfCache[zone];
	}
	
	var typeToPos = {
	  year: 0,
	  month: 1,
	  day: 2,
	  hour: 3,
	  minute: 4,
	  second: 5
	};
	
	function hackyOffset(dtf, date) {
	  var formatted = dtf.format(date).replace(/\u200E/g, ""),
	      parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted),
	      fMonth = parsed[1],
	      fDay = parsed[2],
	      fYear = parsed[3],
	      fHour = parsed[4],
	      fMinute = parsed[5],
	      fSecond = parsed[6];
	  return [fYear, fMonth, fDay, fHour, fMinute, fSecond];
	}
	
	function partsOffset(dtf, date) {
	  var formatted = dtf.formatToParts(date),
	      filled = [];
	
	  for (var i = 0; i < formatted.length; i++) {
	    var _formatted$i = formatted[i],
	        type = _formatted$i.type,
	        value = _formatted$i.value,
	        pos = typeToPos[type];
	
	    if (!isUndefined(pos)) {
	      filled[pos] = parseInt(value, 10);
	    }
	  }
	
	  return filled;
	}
	
	var ianaZoneCache = {};
	/**
	 * A zone identified by an IANA identifier, like America/New_York
	 * @implements {Zone}
	 */
	
	var IANAZone =
	/*#__PURE__*/
	function (_Zone) {
	  _inheritsLoose(IANAZone, _Zone);
	
	  /**
	   * @param {string} name - Zone name
	   * @return {IANAZone}
	   */
	  IANAZone.create = function create(name) {
	    if (!ianaZoneCache[name]) {
	      ianaZoneCache[name] = new IANAZone(name);
	    }
	
	    return ianaZoneCache[name];
	  }
	  /**
	   * Reset local caches. Should only be necessary in testing scenarios.
	   * @return {void}
	   */
	  ;
	
	  IANAZone.resetCache = function resetCache() {
	    ianaZoneCache = {};
	    dtfCache = {};
	  }
	  /**
	   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
	   * @param {string} s - The string to check validity on
	   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
	   * @example IANAZone.isValidSpecifier("Fantasia/Castle") //=> true
	   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
	   * @return {boolean}
	   */
	  ;
	
	  IANAZone.isValidSpecifier = function isValidSpecifier(s) {
	    return !!(s && s.match(matchingRegex));
	  }
	  /**
	   * Returns whether the provided string identifies a real zone
	   * @param {string} zone - The string to check
	   * @example IANAZone.isValidZone("America/New_York") //=> true
	   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
	   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
	   * @return {boolean}
	   */
	  ;
	
	  IANAZone.isValidZone = function isValidZone(zone) {
	    try {
	      new Intl.DateTimeFormat("en-US", {
	        timeZone: zone
	      }).format();
	      return true;
	    } catch (e) {
	      return false;
	    }
	  } // Etc/GMT+8 -> -480
	
	  /** @ignore */
	  ;
	
	  IANAZone.parseGMTOffset = function parseGMTOffset(specifier) {
	    if (specifier) {
	      var match = specifier.match(/^Etc\/GMT([+-]\d{1,2})$/i);
	
	      if (match) {
	        return -60 * parseInt(match[1]);
	      }
	    }
	
	    return null;
	  };
	
	  function IANAZone(name) {
	    var _this;
	
	    _this = _Zone.call(this) || this;
	    /** @private **/
	
	    _this.zoneName = name;
	    /** @private **/
	
	    _this.valid = IANAZone.isValidZone(name);
	    return _this;
	  }
	  /** @override **/
	
	
	  var _proto = IANAZone.prototype;
	
	  /** @override **/
	  _proto.offsetName = function offsetName(ts, _ref) {
	    var format = _ref.format,
	        locale = _ref.locale;
	    return parseZoneInfo(ts, format, locale, this.name);
	  }
	  /** @override **/
	  ;
	
	  _proto.formatOffset = function formatOffset$1(ts, format) {
	    return formatOffset(this.offset(ts), format);
	  }
	  /** @override **/
	  ;
	
	  _proto.offset = function offset(ts) {
	    var date = new Date(ts),
	        dtf = makeDTF(this.name),
	        _ref2 = dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date),
	        year = _ref2[0],
	        month = _ref2[1],
	        day = _ref2[2],
	        hour = _ref2[3],
	        minute = _ref2[4],
	        second = _ref2[5];
	
	    var asUTC = objToLocalTS({
	      year: year,
	      month: month,
	      day: day,
	      hour: hour,
	      minute: minute,
	      second: second,
	      millisecond: 0
	    });
	    var asTS = date.valueOf();
	    asTS -= asTS % 1000;
	    return (asUTC - asTS) / (60 * 1000);
	  }
	  /** @override **/
	  ;
	
	  _proto.equals = function equals(otherZone) {
	    return otherZone.type === "iana" && otherZone.name === this.name;
	  }
	  /** @override **/
	  ;
	
	  _createClass(IANAZone, [{
	    key: "type",
	    get: function get() {
	      return "iana";
	    }
	    /** @override **/
	
	  }, {
	    key: "name",
	    get: function get() {
	      return this.zoneName;
	    }
	    /** @override **/
	
	  }, {
	    key: "universal",
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: "isValid",
	    get: function get() {
	      return this.valid;
	    }
	  }]);
	
	  return IANAZone;
	}(Zone);
	
	var singleton$1 = null;
	/**
	 * A zone with a fixed offset (meaning no DST)
	 * @implements {Zone}
	 */
	
	var FixedOffsetZone =
	/*#__PURE__*/
	function (_Zone) {
	  _inheritsLoose(FixedOffsetZone, _Zone);
	
	  /**
	   * Get an instance with a specified offset
	   * @param {number} offset - The offset in minutes
	   * @return {FixedOffsetZone}
	   */
	  FixedOffsetZone.instance = function instance(offset) {
	    return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
	  }
	  /**
	   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
	   * @param {string} s - The offset string to parse
	   * @example FixedOffsetZone.parseSpecifier("UTC+6")
	   * @example FixedOffsetZone.parseSpecifier("UTC+06")
	   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
	   * @return {FixedOffsetZone}
	   */
	  ;
	
	  FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
	    if (s) {
	      var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
	
	      if (r) {
	        return new FixedOffsetZone(signedOffset(r[1], r[2]));
	      }
	    }
	
	    return null;
	  };
	
	  _createClass(FixedOffsetZone, null, [{
	    key: "utcInstance",
	
	    /**
	     * Get a singleton instance of UTC
	     * @return {FixedOffsetZone}
	     */
	    get: function get() {
	      if (singleton$1 === null) {
	        singleton$1 = new FixedOffsetZone(0);
	      }
	
	      return singleton$1;
	    }
	  }]);
	
	  function FixedOffsetZone(offset) {
	    var _this;
	
	    _this = _Zone.call(this) || this;
	    /** @private **/
	
	    _this.fixed = offset;
	    return _this;
	  }
	  /** @override **/
	
	
	  var _proto = FixedOffsetZone.prototype;
	
	  /** @override **/
	  _proto.offsetName = function offsetName() {
	    return this.name;
	  }
	  /** @override **/
	  ;
	
	  _proto.formatOffset = function formatOffset$1(ts, format) {
	    return formatOffset(this.fixed, format);
	  }
	  /** @override **/
	  ;
	
	  /** @override **/
	  _proto.offset = function offset() {
	    return this.fixed;
	  }
	  /** @override **/
	  ;
	
	  _proto.equals = function equals(otherZone) {
	    return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
	  }
	  /** @override **/
	  ;
	
	  _createClass(FixedOffsetZone, [{
	    key: "type",
	    get: function get() {
	      return "fixed";
	    }
	    /** @override **/
	
	  }, {
	    key: "name",
	    get: function get() {
	      return this.fixed === 0 ? "UTC" : "UTC" + formatOffset(this.fixed, "narrow");
	    }
	  }, {
	    key: "universal",
	    get: function get() {
	      return true;
	    }
	  }, {
	    key: "isValid",
	    get: function get() {
	      return true;
	    }
	  }]);
	
	  return FixedOffsetZone;
	}(Zone);
	
	/**
	 * A zone that failed to parse. You should never need to instantiate this.
	 * @implements {Zone}
	 */
	
	var InvalidZone =
	/*#__PURE__*/
	function (_Zone) {
	  _inheritsLoose(InvalidZone, _Zone);
	
	  function InvalidZone(zoneName) {
	    var _this;
	
	    _this = _Zone.call(this) || this;
	    /**  @private */
	
	    _this.zoneName = zoneName;
	    return _this;
	  }
	  /** @override **/
	
	
	  var _proto = InvalidZone.prototype;
	
	  /** @override **/
	  _proto.offsetName = function offsetName() {
	    return null;
	  }
	  /** @override **/
	  ;
	
	  _proto.formatOffset = function formatOffset() {
	    return "";
	  }
	  /** @override **/
	  ;
	
	  _proto.offset = function offset() {
	    return NaN;
	  }
	  /** @override **/
	  ;
	
	  _proto.equals = function equals() {
	    return false;
	  }
	  /** @override **/
	  ;
	
	  _createClass(InvalidZone, [{
	    key: "type",
	    get: function get() {
	      return "invalid";
	    }
	    /** @override **/
	
	  }, {
	    key: "name",
	    get: function get() {
	      return this.zoneName;
	    }
	    /** @override **/
	
	  }, {
	    key: "universal",
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: "isValid",
	    get: function get() {
	      return false;
	    }
	  }]);
	
	  return InvalidZone;
	}(Zone);
	
	/**
	 * @private
	 */
	function normalizeZone(input, defaultZone) {
	  var offset;
	
	  if (isUndefined(input) || input === null) {
	    return defaultZone;
	  } else if (input instanceof Zone) {
	    return input;
	  } else if (isString(input)) {
	    var lowered = input.toLowerCase();
	    if (lowered === "local") return defaultZone;else if (lowered === "utc" || lowered === "gmt") return FixedOffsetZone.utcInstance;else if ((offset = IANAZone.parseGMTOffset(input)) != null) {
	      // handle Etc/GMT-4, which V8 chokes on
	      return FixedOffsetZone.instance(offset);
	    } else if (IANAZone.isValidSpecifier(lowered)) return IANAZone.create(input);else return FixedOffsetZone.parseSpecifier(lowered) || new InvalidZone(input);
	  } else if (isNumber(input)) {
	    return FixedOffsetZone.instance(input);
	  } else if (typeof input === "object" && input.offset && typeof input.offset === "number") {
	    // This is dumb, but the instanceof check above doesn't seem to really work
	    // so we're duck checking it
	    return input;
	  } else {
	    return new InvalidZone(input);
	  }
	}
	
	var now = function now() {
	  return Date.now();
	},
	    defaultZone = null,
	    // not setting this directly to LocalZone.instance bc loading order issues
	defaultLocale = null,
	    defaultNumberingSystem = null,
	    defaultOutputCalendar = null,
	    throwOnInvalid = false;
	/**
	 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
	 */
	
	
	var Settings =
	/*#__PURE__*/
	function () {
	  function Settings() {}
	
	  /**
	   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
	   * @return {void}
	   */
	  Settings.resetCaches = function resetCaches() {
	    Locale.resetCache();
	    IANAZone.resetCache();
	  };
	
	  _createClass(Settings, null, [{
	    key: "now",
	
	    /**
	     * Get the callback for returning the current timestamp.
	     * @type {function}
	     */
	    get: function get() {
	      return now;
	    }
	    /**
	     * Set the callback for returning the current timestamp.
	     * The function should return a number, which will be interpreted as an Epoch millisecond count
	     * @type {function}
	     * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
	     * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
	     */
	    ,
	    set: function set(n) {
	      now = n;
	    }
	    /**
	     * Get the default time zone to create DateTimes in.
	     * @type {string}
	     */
	
	  }, {
	    key: "defaultZoneName",
	    get: function get() {
	      return Settings.defaultZone.name;
	    }
	    /**
	     * Set the default time zone to create DateTimes in. Does not affect existing instances.
	     * @type {string}
	     */
	    ,
	    set: function set(z) {
	      if (!z) {
	        defaultZone = null;
	      } else {
	        defaultZone = normalizeZone(z);
	      }
	    }
	    /**
	     * Get the default time zone object to create DateTimes in. Does not affect existing instances.
	     * @type {Zone}
	     */
	
	  }, {
	    key: "defaultZone",
	    get: function get() {
	      return defaultZone || LocalZone.instance;
	    }
	    /**
	     * Get the default locale to create DateTimes with. Does not affect existing instances.
	     * @type {string}
	     */
	
	  }, {
	    key: "defaultLocale",
	    get: function get() {
	      return defaultLocale;
	    }
	    /**
	     * Set the default locale to create DateTimes with. Does not affect existing instances.
	     * @type {string}
	     */
	    ,
	    set: function set(locale) {
	      defaultLocale = locale;
	    }
	    /**
	     * Get the default numbering system to create DateTimes with. Does not affect existing instances.
	     * @type {string}
	     */
	
	  }, {
	    key: "defaultNumberingSystem",
	    get: function get() {
	      return defaultNumberingSystem;
	    }
	    /**
	     * Set the default numbering system to create DateTimes with. Does not affect existing instances.
	     * @type {string}
	     */
	    ,
	    set: function set(numberingSystem) {
	      defaultNumberingSystem = numberingSystem;
	    }
	    /**
	     * Get the default output calendar to create DateTimes with. Does not affect existing instances.
	     * @type {string}
	     */
	
	  }, {
	    key: "defaultOutputCalendar",
	    get: function get() {
	      return defaultOutputCalendar;
	    }
	    /**
	     * Set the default output calendar to create DateTimes with. Does not affect existing instances.
	     * @type {string}
	     */
	    ,
	    set: function set(outputCalendar) {
	      defaultOutputCalendar = outputCalendar;
	    }
	    /**
	     * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
	     * @type {boolean}
	     */
	
	  }, {
	    key: "throwOnInvalid",
	    get: function get() {
	      return throwOnInvalid;
	    }
	    /**
	     * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
	     * @type {boolean}
	     */
	    ,
	    set: function set(t) {
	      throwOnInvalid = t;
	    }
	  }]);
	
	  return Settings;
	}();
	
	var intlDTCache = {};
	
	function getCachedDTF(locString, opts) {
	  if (opts === void 0) {
	    opts = {};
	  }
	
	  var key = JSON.stringify([locString, opts]);
	  var dtf = intlDTCache[key];
	
	  if (!dtf) {
	    dtf = new Intl.DateTimeFormat(locString, opts);
	    intlDTCache[key] = dtf;
	  }
	
	  return dtf;
	}
	
	var intlNumCache = {};
	
	function getCachedINF(locString, opts) {
	  if (opts === void 0) {
	    opts = {};
	  }
	
	  var key = JSON.stringify([locString, opts]);
	  var inf = intlNumCache[key];
	
	  if (!inf) {
	    inf = new Intl.NumberFormat(locString, opts);
	    intlNumCache[key] = inf;
	  }
	
	  return inf;
	}
	
	var intlRelCache = {};
	
	function getCachedRTF(locString, opts) {
	  if (opts === void 0) {
	    opts = {};
	  }
	
	  var key = JSON.stringify([locString, opts]);
	  var inf = intlRelCache[key];
	
	  if (!inf) {
	    inf = new Intl.RelativeTimeFormat(locString, opts);
	    intlRelCache[key] = inf;
	  }
	
	  return inf;
	}
	
	var sysLocaleCache = null;
	
	function systemLocale() {
	  if (sysLocaleCache) {
	    return sysLocaleCache;
	  } else if (hasIntl()) {
	    var computedSys = new Intl.DateTimeFormat().resolvedOptions().locale; // node sometimes defaults to "und". Override that because that is dumb
	
	    sysLocaleCache = !computedSys || computedSys === "und" ? "en-US" : computedSys;
	    return sysLocaleCache;
	  } else {
	    sysLocaleCache = "en-US";
	    return sysLocaleCache;
	  }
	}
	
	function parseLocaleString(localeStr) {
	  // I really want to avoid writing a BCP 47 parser
	  // see, e.g. https://github.com/wooorm/bcp-47
	  // Instead, we'll do this:
	  // a) if the string has no -u extensions, just leave it alone
	  // b) if it does, use Intl to resolve everything
	  // c) if Intl fails, try again without the -u
	  var uIndex = localeStr.indexOf("-u-");
	
	  if (uIndex === -1) {
	    return [localeStr];
	  } else {
	    var options;
	    var smaller = localeStr.substring(0, uIndex);
	
	    try {
	      options = getCachedDTF(localeStr).resolvedOptions();
	    } catch (e) {
	      options = getCachedDTF(smaller).resolvedOptions();
	    }
	
	    var _options = options,
	        numberingSystem = _options.numberingSystem,
	        calendar = _options.calendar; // return the smaller one so that we can append the calendar and numbering overrides to it
	
	    return [smaller, numberingSystem, calendar];
	  }
	}
	
	function intlConfigString(localeStr, numberingSystem, outputCalendar) {
	  if (hasIntl()) {
	    if (outputCalendar || numberingSystem) {
	      localeStr += "-u";
	
	      if (outputCalendar) {
	        localeStr += "-ca-" + outputCalendar;
	      }
	
	      if (numberingSystem) {
	        localeStr += "-nu-" + numberingSystem;
	      }
	
	      return localeStr;
	    } else {
	      return localeStr;
	    }
	  } else {
	    return [];
	  }
	}
	
	function mapMonths(f) {
	  var ms = [];
	
	  for (var i = 1; i <= 12; i++) {
	    var dt = DateTime.utc(2016, i, 1);
	    ms.push(f(dt));
	  }
	
	  return ms;
	}
	
	function mapWeekdays(f) {
	  var ms = [];
	
	  for (var i = 1; i <= 7; i++) {
	    var dt = DateTime.utc(2016, 11, 13 + i);
	    ms.push(f(dt));
	  }
	
	  return ms;
	}
	
	function listStuff(loc, length, defaultOK, englishFn, intlFn) {
	  var mode = loc.listingMode(defaultOK);
	
	  if (mode === "error") {
	    return null;
	  } else if (mode === "en") {
	    return englishFn(length);
	  } else {
	    return intlFn(length);
	  }
	}
	
	function supportsFastNumbers(loc) {
	  if (loc.numberingSystem && loc.numberingSystem !== "latn") {
	    return false;
	  } else {
	    return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || hasIntl() && new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
	  }
	}
	/**
	 * @private
	 */
	
	
	var PolyNumberFormatter =
	/*#__PURE__*/
	function () {
	  function PolyNumberFormatter(intl, forceSimple, opts) {
	    this.padTo = opts.padTo || 0;
	    this.floor = opts.floor || false;
	
	    if (!forceSimple && hasIntl()) {
	      var intlOpts = {
	        useGrouping: false
	      };
	      if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
	      this.inf = getCachedINF(intl, intlOpts);
	    }
	  }
	
	  var _proto = PolyNumberFormatter.prototype;
	
	  _proto.format = function format(i) {
	    if (this.inf) {
	      var fixed = this.floor ? Math.floor(i) : i;
	      return this.inf.format(fixed);
	    } else {
	      // to match the browser's numberformatter defaults
	      var _fixed = this.floor ? Math.floor(i) : roundTo(i, 3);
	
	      return padStart(_fixed, this.padTo);
	    }
	  };
	
	  return PolyNumberFormatter;
	}();
	/**
	 * @private
	 */
	
	
	var PolyDateFormatter =
	/*#__PURE__*/
	function () {
	  function PolyDateFormatter(dt, intl, opts) {
	    this.opts = opts;
	    this.hasIntl = hasIntl();
	    var z;
	
	    if (dt.zone.universal && this.hasIntl) {
	      // Chromium doesn't support fixed-offset zones like Etc/GMT+8 in its formatter,
	      // See https://bugs.chromium.org/p/chromium/issues/detail?id=364374.
	      // So we have to make do. Two cases:
	      // 1. The format options tell us to show the zone. We can't do that, so the best
	      // we can do is format the date in UTC.
	      // 2. The format options don't tell us to show the zone. Then we can adjust them
	      // the time and tell the formatter to show it to us in UTC, so that the time is right
	      // and the bad zone doesn't show up.
	      // We can clean all this up when Chrome fixes this.
	      z = "UTC";
	
	      if (opts.timeZoneName) {
	        this.dt = dt;
	      } else {
	        this.dt = dt.offset === 0 ? dt : DateTime.fromMillis(dt.ts + dt.offset * 60 * 1000);
	      }
	    } else if (dt.zone.type === "local") {
	      this.dt = dt;
	    } else {
	      this.dt = dt;
	      z = dt.zone.name;
	    }
	
	    if (this.hasIntl) {
	      var intlOpts = Object.assign({}, this.opts);
	
	      if (z) {
	        intlOpts.timeZone = z;
	      }
	
	      this.dtf = getCachedDTF(intl, intlOpts);
	    }
	  }
	
	  var _proto2 = PolyDateFormatter.prototype;
	
	  _proto2.format = function format() {
	    if (this.hasIntl) {
	      return this.dtf.format(this.dt.toJSDate());
	    } else {
	      var tokenFormat = formatString(this.opts),
	          loc = Locale.create("en-US");
	      return Formatter.create(loc).formatDateTimeFromString(this.dt, tokenFormat);
	    }
	  };
	
	  _proto2.formatToParts = function formatToParts() {
	    if (this.hasIntl && hasFormatToParts()) {
	      return this.dtf.formatToParts(this.dt.toJSDate());
	    } else {
	      // This is kind of a cop out. We actually could do this for English. However, we couldn't do it for intl strings
	      // and IMO it's too weird to have an uncanny valley like that
	      return [];
	    }
	  };
	
	  _proto2.resolvedOptions = function resolvedOptions() {
	    if (this.hasIntl) {
	      return this.dtf.resolvedOptions();
	    } else {
	      return {
	        locale: "en-US",
	        numberingSystem: "latn",
	        outputCalendar: "gregory"
	      };
	    }
	  };
	
	  return PolyDateFormatter;
	}();
	/**
	 * @private
	 */
	
	
	var PolyRelFormatter =
	/*#__PURE__*/
	function () {
	  function PolyRelFormatter(intl, isEnglish, opts) {
	    this.opts = Object.assign({
	      style: "long"
	    }, opts);
	
	    if (!isEnglish && hasRelative()) {
	      this.rtf = getCachedRTF(intl, opts);
	    }
	  }
	
	  var _proto3 = PolyRelFormatter.prototype;
	
	  _proto3.format = function format(count, unit) {
	    if (this.rtf) {
	      return this.rtf.format(count, unit);
	    } else {
	      return formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
	    }
	  };
	
	  _proto3.formatToParts = function formatToParts(count, unit) {
	    if (this.rtf) {
	      return this.rtf.formatToParts(count, unit);
	    } else {
	      return [];
	    }
	  };
	
	  return PolyRelFormatter;
	}();
	/**
	 * @private
	 */
	
	
	var Locale =
	/*#__PURE__*/
	function () {
	  Locale.fromOpts = function fromOpts(opts) {
	    return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.defaultToEN);
	  };
	
	  Locale.create = function create(locale, numberingSystem, outputCalendar, defaultToEN) {
	    if (defaultToEN === void 0) {
	      defaultToEN = false;
	    }
	
	    var specifiedLocale = locale || Settings.defaultLocale,
	        // the system locale is useful for human readable strings but annoying for parsing/formatting known formats
	    localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale()),
	        numberingSystemR = numberingSystem || Settings.defaultNumberingSystem,
	        outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
	    return new Locale(localeR, numberingSystemR, outputCalendarR, specifiedLocale);
	  };
	
	  Locale.resetCache = function resetCache() {
	    sysLocaleCache = null;
	    intlDTCache = {};
	    intlNumCache = {};
	    intlRelCache = {};
	  };
	
	  Locale.fromObject = function fromObject(_temp) {
	    var _ref = _temp === void 0 ? {} : _temp,
	        locale = _ref.locale,
	        numberingSystem = _ref.numberingSystem,
	        outputCalendar = _ref.outputCalendar;
	
	    return Locale.create(locale, numberingSystem, outputCalendar);
	  };
	
	  function Locale(locale, numbering, outputCalendar, specifiedLocale) {
	    var _parseLocaleString = parseLocaleString(locale),
	        parsedLocale = _parseLocaleString[0],
	        parsedNumberingSystem = _parseLocaleString[1],
	        parsedOutputCalendar = _parseLocaleString[2];
	
	    this.locale = parsedLocale;
	    this.numberingSystem = numbering || parsedNumberingSystem || null;
	    this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
	    this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
	    this.weekdaysCache = {
	      format: {},
	      standalone: {}
	    };
	    this.monthsCache = {
	      format: {},
	      standalone: {}
	    };
	    this.meridiemCache = null;
	    this.eraCache = {};
	    this.specifiedLocale = specifiedLocale;
	    this.fastNumbersCached = null;
	  }
	
	  var _proto4 = Locale.prototype;
	
	  _proto4.listingMode = function listingMode(defaultOK) {
	    if (defaultOK === void 0) {
	      defaultOK = true;
	    }
	
	    var intl = hasIntl(),
	        hasFTP = intl && hasFormatToParts(),
	        isActuallyEn = this.isEnglish(),
	        hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
	
	    if (!hasFTP && !(isActuallyEn && hasNoWeirdness) && !defaultOK) {
	      return "error";
	    } else if (!hasFTP || isActuallyEn && hasNoWeirdness) {
	      return "en";
	    } else {
	      return "intl";
	    }
	  };
	
	  _proto4.clone = function clone(alts) {
	    if (!alts || Object.getOwnPropertyNames(alts).length === 0) {
	      return this;
	    } else {
	      return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, alts.defaultToEN || false);
	    }
	  };
	
	  _proto4.redefaultToEN = function redefaultToEN(alts) {
	    if (alts === void 0) {
	      alts = {};
	    }
	
	    return this.clone(Object.assign({}, alts, {
	      defaultToEN: true
	    }));
	  };
	
	  _proto4.redefaultToSystem = function redefaultToSystem(alts) {
	    if (alts === void 0) {
	      alts = {};
	    }
	
	    return this.clone(Object.assign({}, alts, {
	      defaultToEN: false
	    }));
	  };
	
	  _proto4.months = function months$1(length, format, defaultOK) {
	    var _this = this;
	
	    if (format === void 0) {
	      format = false;
	    }
	
	    if (defaultOK === void 0) {
	      defaultOK = true;
	    }
	
	    return listStuff(this, length, defaultOK, months, function () {
	      var intl = format ? {
	        month: length,
	        day: "numeric"
	      } : {
	        month: length
	      },
	          formatStr = format ? "format" : "standalone";
	
	      if (!_this.monthsCache[formatStr][length]) {
	        _this.monthsCache[formatStr][length] = mapMonths(function (dt) {
	          return _this.extract(dt, intl, "month");
	        });
	      }
	
	      return _this.monthsCache[formatStr][length];
	    });
	  };
	
	  _proto4.weekdays = function weekdays$1(length, format, defaultOK) {
	    var _this2 = this;
	
	    if (format === void 0) {
	      format = false;
	    }
	
	    if (defaultOK === void 0) {
	      defaultOK = true;
	    }
	
	    return listStuff(this, length, defaultOK, weekdays, function () {
	      var intl = format ? {
	        weekday: length,
	        year: "numeric",
	        month: "long",
	        day: "numeric"
	      } : {
	        weekday: length
	      },
	          formatStr = format ? "format" : "standalone";
	
	      if (!_this2.weekdaysCache[formatStr][length]) {
	        _this2.weekdaysCache[formatStr][length] = mapWeekdays(function (dt) {
	          return _this2.extract(dt, intl, "weekday");
	        });
	      }
	
	      return _this2.weekdaysCache[formatStr][length];
	    });
	  };
	
	  _proto4.meridiems = function meridiems$1(defaultOK) {
	    var _this3 = this;
	
	    if (defaultOK === void 0) {
	      defaultOK = true;
	    }
	
	    return listStuff(this, undefined, defaultOK, function () {
	      return meridiems;
	    }, function () {
	      // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
	      // for AM and PM. This is probably wrong, but it's makes parsing way easier.
	      if (!_this3.meridiemCache) {
	        var intl = {
	          hour: "numeric",
	          hour12: true
	        };
	        _this3.meridiemCache = [DateTime.utc(2016, 11, 13, 9), DateTime.utc(2016, 11, 13, 19)].map(function (dt) {
	          return _this3.extract(dt, intl, "dayperiod");
	        });
	      }
	
	      return _this3.meridiemCache;
	    });
	  };
	
	  _proto4.eras = function eras$1(length, defaultOK) {
	    var _this4 = this;
	
	    if (defaultOK === void 0) {
	      defaultOK = true;
	    }
	
	    return listStuff(this, length, defaultOK, eras, function () {
	      var intl = {
	        era: length
	      }; // This is utter bullshit. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
	      // to definitely enumerate them.
	
	      if (!_this4.eraCache[length]) {
	        _this4.eraCache[length] = [DateTime.utc(-40, 1, 1), DateTime.utc(2017, 1, 1)].map(function (dt) {
	          return _this4.extract(dt, intl, "era");
	        });
	      }
	
	      return _this4.eraCache[length];
	    });
	  };
	
	  _proto4.extract = function extract(dt, intlOpts, field) {
	    var df = this.dtFormatter(dt, intlOpts),
	        results = df.formatToParts(),
	        matching = results.find(function (m) {
	      return m.type.toLowerCase() === field;
	    });
	    return matching ? matching.value : null;
	  };
	
	  _proto4.numberFormatter = function numberFormatter(opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
	    // (in contrast, the rest of the condition is used heavily)
	    return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
	  };
	
	  _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
	    if (intlOpts === void 0) {
	      intlOpts = {};
	    }
	
	    return new PolyDateFormatter(dt, this.intl, intlOpts);
	  };
	
	  _proto4.relFormatter = function relFormatter(opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
	  };
	
	  _proto4.isEnglish = function isEnglish() {
	    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || hasIntl() && new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
	  };
	
	  _proto4.equals = function equals(other) {
	    return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
	  };
	
	  _createClass(Locale, [{
	    key: "fastNumbers",
	    get: function get() {
	      if (this.fastNumbersCached == null) {
	        this.fastNumbersCached = supportsFastNumbers(this);
	      }
	
	      return this.fastNumbersCached;
	    }
	  }]);
	
	  return Locale;
	}();
	
	/*
	 * This file handles parsing for well-specified formats. Here's how it works:
	 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
	 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
	 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
	 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
	 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
	 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
	 */
	
	function combineRegexes() {
	  for (var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++) {
	    regexes[_key] = arguments[_key];
	  }
	
	  var full = regexes.reduce(function (f, r) {
	    return f + r.source;
	  }, "");
	  return RegExp("^" + full + "$");
	}
	
	function combineExtractors() {
	  for (var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    extractors[_key2] = arguments[_key2];
	  }
	
	  return function (m) {
	    return extractors.reduce(function (_ref, ex) {
	      var mergedVals = _ref[0],
	          mergedZone = _ref[1],
	          cursor = _ref[2];
	
	      var _ex = ex(m, cursor),
	          val = _ex[0],
	          zone = _ex[1],
	          next = _ex[2];
	
	      return [Object.assign(mergedVals, val), mergedZone || zone, next];
	    }, [{}, null, 1]).slice(0, 2);
	  };
	}
	
	function parse(s) {
	  if (s == null) {
	    return [null, null];
	  }
	
	  for (var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    patterns[_key3 - 1] = arguments[_key3];
	  }
	
	  for (var _i = 0, _patterns = patterns; _i < _patterns.length; _i++) {
	    var _patterns$_i = _patterns[_i],
	        regex = _patterns$_i[0],
	        extractor = _patterns$_i[1];
	    var m = regex.exec(s);
	
	    if (m) {
	      return extractor(m);
	    }
	  }
	
	  return [null, null];
	}
	
	function simpleParse() {
	  for (var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	    keys[_key4] = arguments[_key4];
	  }
	
	  return function (match, cursor) {
	    var ret = {};
	    var i;
	
	    for (i = 0; i < keys.length; i++) {
	      ret[keys[i]] = parseInteger(match[cursor + i]);
	    }
	
	    return [ret, null, cursor + i];
	  };
	} // ISO and SQL parsing
	
	
	var offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/,
	    isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,9}))?)?)?/,
	    isoTimeRegex = RegExp("" + isoTimeBaseRegex.source + offsetRegex.source + "?"),
	    isoTimeExtensionRegex = RegExp("(?:T" + isoTimeRegex.source + ")?"),
	    isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/,
	    isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/,
	    isoOrdinalRegex = /(\d{4})-?(\d{3})/,
	    extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay"),
	    extractISOOrdinalData = simpleParse("year", "ordinal"),
	    sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/,
	    // dumbed-down version of the ISO one
	sqlTimeRegex = RegExp(isoTimeBaseRegex.source + " ?(?:" + offsetRegex.source + "|(" + ianaRegex.source + "))?"),
	    sqlTimeExtensionRegex = RegExp("(?: " + sqlTimeRegex.source + ")?");
	
	function int(match, pos, fallback) {
	  var m = match[pos];
	  return isUndefined(m) ? fallback : parseInteger(m);
	}
	
	function extractISOYmd(match, cursor) {
	  var item = {
	    year: int(match, cursor),
	    month: int(match, cursor + 1, 1),
	    day: int(match, cursor + 2, 1)
	  };
	  return [item, null, cursor + 3];
	}
	
	function extractISOTime(match, cursor) {
	  var item = {
	    hour: int(match, cursor, 0),
	    minute: int(match, cursor + 1, 0),
	    second: int(match, cursor + 2, 0),
	    millisecond: parseMillis(match[cursor + 3])
	  };
	  return [item, null, cursor + 4];
	}
	
	function extractISOOffset(match, cursor) {
	  var local = !match[cursor] && !match[cursor + 1],
	      fullOffset = signedOffset(match[cursor + 1], match[cursor + 2]),
	      zone = local ? null : FixedOffsetZone.instance(fullOffset);
	  return [{}, zone, cursor + 3];
	}
	
	function extractIANAZone(match, cursor) {
	  var zone = match[cursor] ? IANAZone.create(match[cursor]) : null;
	  return [{}, zone, cursor + 1];
	} // ISO duration parsing
	
	
	var isoDuration = /^P(?:(?:(-?\d{1,9})Y)?(?:(-?\d{1,9})M)?(?:(-?\d{1,9})W)?(?:(-?\d{1,9})D)?(?:T(?:(-?\d{1,9})H)?(?:(-?\d{1,9})M)?(?:(-?\d{1,9})(?:[.,](-?\d{1,9}))?S)?)?)$/;
	
	function extractISODuration(match) {
	  var yearStr = match[1],
	      monthStr = match[2],
	      weekStr = match[3],
	      dayStr = match[4],
	      hourStr = match[5],
	      minuteStr = match[6],
	      secondStr = match[7],
	      millisecondsStr = match[8];
	  return [{
	    years: parseInteger(yearStr),
	    months: parseInteger(monthStr),
	    weeks: parseInteger(weekStr),
	    days: parseInteger(dayStr),
	    hours: parseInteger(hourStr),
	    minutes: parseInteger(minuteStr),
	    seconds: parseInteger(secondStr),
	    milliseconds: parseMillis(millisecondsStr)
	  }];
	} // These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
	// and not just that we're in -240 *right now*. But since I don't think these are used that often
	// I'm just going to ignore that
	
	
	var obsOffsets = {
	  GMT: 0,
	  EDT: -4 * 60,
	  EST: -5 * 60,
	  CDT: -5 * 60,
	  CST: -6 * 60,
	  MDT: -6 * 60,
	  MST: -7 * 60,
	  PDT: -7 * 60,
	  PST: -8 * 60
	};
	
	function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	  var result = {
	    year: yearStr.length === 2 ? untruncateYear(parseInteger(yearStr)) : parseInteger(yearStr),
	    month: monthsShort.indexOf(monthStr) + 1,
	    day: parseInteger(dayStr),
	    hour: parseInteger(hourStr),
	    minute: parseInteger(minuteStr)
	  };
	  if (secondStr) result.second = parseInteger(secondStr);
	
	  if (weekdayStr) {
	    result.weekday = weekdayStr.length > 3 ? weekdaysLong.indexOf(weekdayStr) + 1 : weekdaysShort.indexOf(weekdayStr) + 1;
	  }
	
	  return result;
	} // RFC 2822/5322
	
	
	var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
	
	function extractRFC2822(match) {
	  var weekdayStr = match[1],
	      dayStr = match[2],
	      monthStr = match[3],
	      yearStr = match[4],
	      hourStr = match[5],
	      minuteStr = match[6],
	      secondStr = match[7],
	      obsOffset = match[8],
	      milOffset = match[9],
	      offHourStr = match[10],
	      offMinuteStr = match[11],
	      result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
	  var offset;
	
	  if (obsOffset) {
	    offset = obsOffsets[obsOffset];
	  } else if (milOffset) {
	    offset = 0;
	  } else {
	    offset = signedOffset(offHourStr, offMinuteStr);
	  }
	
	  return [result, new FixedOffsetZone(offset)];
	}
	
	function preprocessRFC2822(s) {
	  // Remove comments and folding whitespace and replace multiple-spaces with a single space
	  return s.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
	} // http date
	
	
	var rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/,
	    rfc850 = /^(Monday|Tuesday|Wedsday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/,
	    ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
	
	function extractRFC1123Or850(match) {
	  var weekdayStr = match[1],
	      dayStr = match[2],
	      monthStr = match[3],
	      yearStr = match[4],
	      hourStr = match[5],
	      minuteStr = match[6],
	      secondStr = match[7],
	      result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
	  return [result, FixedOffsetZone.utcInstance];
	}
	
	function extractASCII(match) {
	  var weekdayStr = match[1],
	      monthStr = match[2],
	      dayStr = match[3],
	      hourStr = match[4],
	      minuteStr = match[5],
	      secondStr = match[6],
	      yearStr = match[7],
	      result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
	  return [result, FixedOffsetZone.utcInstance];
	}
	
	var isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
	var isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
	var isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
	var isoTimeCombinedRegex = combineRegexes(isoTimeRegex);
	var extractISOYmdTimeAndOffset = combineExtractors(extractISOYmd, extractISOTime, extractISOOffset);
	var extractISOWeekTimeAndOffset = combineExtractors(extractISOWeekData, extractISOTime, extractISOOffset);
	var extractISOOrdinalDataAndTime = combineExtractors(extractISOOrdinalData, extractISOTime);
	var extractISOTimeAndOffset = combineExtractors(extractISOTime, extractISOOffset);
	/**
	 * @private
	 */
	
	function parseISODate(s) {
	  return parse(s, [isoYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset], [isoWeekWithTimeExtensionRegex, extractISOWeekTimeAndOffset], [isoOrdinalWithTimeExtensionRegex, extractISOOrdinalDataAndTime], [isoTimeCombinedRegex, extractISOTimeAndOffset]);
	}
	function parseRFC2822Date(s) {
	  return parse(preprocessRFC2822(s), [rfc2822, extractRFC2822]);
	}
	function parseHTTPDate(s) {
	  return parse(s, [rfc1123, extractRFC1123Or850], [rfc850, extractRFC1123Or850], [ascii, extractASCII]);
	}
	function parseISODuration(s) {
	  return parse(s, [isoDuration, extractISODuration]);
	}
	var sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
	var sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);
	var extractISOYmdTimeOffsetAndIANAZone = combineExtractors(extractISOYmd, extractISOTime, extractISOOffset, extractIANAZone);
	var extractISOTimeOffsetAndIANAZone = combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);
	function parseSQL(s) {
	  return parse(s, [sqlYmdWithTimeExtensionRegex, extractISOYmdTimeOffsetAndIANAZone], [sqlTimeCombinedRegex, extractISOTimeOffsetAndIANAZone]);
	}
	
	var INVALID = "Invalid Duration"; // unit conversion constants
	
	var lowOrderMatrix = {
	  weeks: {
	    days: 7,
	    hours: 7 * 24,
	    minutes: 7 * 24 * 60,
	    seconds: 7 * 24 * 60 * 60,
	    milliseconds: 7 * 24 * 60 * 60 * 1000
	  },
	  days: {
	    hours: 24,
	    minutes: 24 * 60,
	    seconds: 24 * 60 * 60,
	    milliseconds: 24 * 60 * 60 * 1000
	  },
	  hours: {
	    minutes: 60,
	    seconds: 60 * 60,
	    milliseconds: 60 * 60 * 1000
	  },
	  minutes: {
	    seconds: 60,
	    milliseconds: 60 * 1000
	  },
	  seconds: {
	    milliseconds: 1000
	  }
	},
	    casualMatrix = Object.assign({
	  years: {
	    months: 12,
	    weeks: 52,
	    days: 365,
	    hours: 365 * 24,
	    minutes: 365 * 24 * 60,
	    seconds: 365 * 24 * 60 * 60,
	    milliseconds: 365 * 24 * 60 * 60 * 1000
	  },
	  quarters: {
	    months: 3,
	    weeks: 13,
	    days: 91,
	    hours: 91 * 24,
	    minutes: 91 * 24 * 60,
	    milliseconds: 91 * 24 * 60 * 60 * 1000
	  },
	  months: {
	    weeks: 4,
	    days: 30,
	    hours: 30 * 24,
	    minutes: 30 * 24 * 60,
	    seconds: 30 * 24 * 60 * 60,
	    milliseconds: 30 * 24 * 60 * 60 * 1000
	  }
	}, lowOrderMatrix),
	    daysInYearAccurate = 146097.0 / 400,
	    daysInMonthAccurate = 146097.0 / 4800,
	    accurateMatrix = Object.assign({
	  years: {
	    months: 12,
	    weeks: daysInYearAccurate / 7,
	    days: daysInYearAccurate,
	    hours: daysInYearAccurate * 24,
	    minutes: daysInYearAccurate * 24 * 60,
	    seconds: daysInYearAccurate * 24 * 60 * 60,
	    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000
	  },
	  quarters: {
	    months: 3,
	    weeks: daysInYearAccurate / 28,
	    days: daysInYearAccurate / 4,
	    hours: daysInYearAccurate * 24 / 4,
	    minutes: daysInYearAccurate * 24 * 60 / 4,
	    seconds: daysInYearAccurate * 24 * 60 * 60 / 4,
	    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000 / 4
	  },
	  months: {
	    weeks: daysInMonthAccurate / 7,
	    days: daysInMonthAccurate,
	    hours: daysInMonthAccurate * 24,
	    minutes: daysInMonthAccurate * 24 * 60,
	    seconds: daysInMonthAccurate * 24 * 60 * 60,
	    milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1000
	  }
	}, lowOrderMatrix); // units ordered by size
	
	var orderedUnits = ["years", "quarters", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds"];
	var reverseUnits = orderedUnits.slice(0).reverse(); // clone really means "create another instance just like this one, but with these changes"
	
	function clone(dur, alts, clear) {
	  if (clear === void 0) {
	    clear = false;
	  }
	
	  // deep merge for vals
	  var conf = {
	    values: clear ? alts.values : Object.assign({}, dur.values, alts.values || {}),
	    loc: dur.loc.clone(alts.loc),
	    conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy
	  };
	  return new Duration(conf);
	}
	
	function antiTrunc(n) {
	  return n < 0 ? Math.floor(n) : Math.ceil(n);
	} // NB: mutates parameters
	
	
	function convert(matrix, fromMap, fromUnit, toMap, toUnit) {
	  var conv = matrix[toUnit][fromUnit],
	      raw = fromMap[fromUnit] / conv,
	      sameSign = Math.sign(raw) === Math.sign(toMap[toUnit]),
	      // ok, so this is wild, but see the matrix in the tests
	  added = !sameSign && toMap[toUnit] !== 0 && Math.abs(raw) <= 1 ? antiTrunc(raw) : Math.trunc(raw);
	  toMap[toUnit] += added;
	  fromMap[fromUnit] -= added * conv;
	} // NB: mutates parameters
	
	
	function normalizeValues(matrix, vals) {
	  reverseUnits.reduce(function (previous, current) {
	    if (!isUndefined(vals[current])) {
	      if (previous) {
	        convert(matrix, vals, previous, vals, current);
	      }
	
	      return current;
	    } else {
	      return previous;
	    }
	  }, null);
	}
	/**
	 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime.plus} to add a Duration object to a DateTime, producing another DateTime.
	 *
	 * Here is a brief overview of commonly used methods and getters in Duration:
	 *
	 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
	 * * **Unit values** See the {@link Duration.years}, {@link Duration.months}, {@link Duration.weeks}, {@link Duration.days}, {@link Duration.hours}, {@link Duration.minutes}, {@link Duration.seconds}, {@link Duration.milliseconds} accessors.
	 * * **Configuration** See  {@link Duration.locale} and {@link Duration.numberingSystem} accessors.
	 * * **Transformation** To create new Durations out of old ones use {@link Duration.plus}, {@link Duration.minus}, {@link Duration.normalize}, {@link Duration.set}, {@link Duration.reconfigure}, {@link Duration.shiftTo}, and {@link Duration.negate}.
	 * * **Output** To convert the Duration into other representations, see {@link Duration.as}, {@link Duration.toISO}, {@link Duration.toFormat}, and {@link Duration.toJSON}
	 *
	 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
	 */
	
	
	var Duration =
	/*#__PURE__*/
	function () {
	  /**
	   * @private
	   */
	  function Duration(config) {
	    var accurate = config.conversionAccuracy === "longterm" || false;
	    /**
	     * @access private
	     */
	
	    this.values = config.values;
	    /**
	     * @access private
	     */
	
	    this.loc = config.loc || Locale.create();
	    /**
	     * @access private
	     */
	
	    this.conversionAccuracy = accurate ? "longterm" : "casual";
	    /**
	     * @access private
	     */
	
	    this.invalid = config.invalid || null;
	    /**
	     * @access private
	     */
	
	    this.matrix = accurate ? accurateMatrix : casualMatrix;
	    /**
	     * @access private
	     */
	
	    this.isLuxonDuration = true;
	  }
	  /**
	   * Create Duration from a number of milliseconds.
	   * @param {number} count of milliseconds
	   * @param {Object} opts - options for parsing
	   * @param {string} [opts.locale='en-US'] - the locale to use
	   * @param {string} opts.numberingSystem - the numbering system to use
	   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
	   * @return {Duration}
	   */
	
	
	  Duration.fromMillis = function fromMillis(count, opts) {
	    return Duration.fromObject(Object.assign({
	      milliseconds: count
	    }, opts));
	  }
	  /**
	   * Create a Duration from a Javascript object with keys like 'years' and 'hours.
	   * If this object is empty then a zero milliseconds duration is returned.
	   * @param {Object} obj - the object to create the DateTime from
	   * @param {number} obj.years
	   * @param {number} obj.quarters
	   * @param {number} obj.months
	   * @param {number} obj.weeks
	   * @param {number} obj.days
	   * @param {number} obj.hours
	   * @param {number} obj.minutes
	   * @param {number} obj.seconds
	   * @param {number} obj.milliseconds
	   * @param {string} [obj.locale='en-US'] - the locale to use
	   * @param {string} obj.numberingSystem - the numbering system to use
	   * @param {string} [obj.conversionAccuracy='casual'] - the conversion system to use
	   * @return {Duration}
	   */
	  ;
	
	  Duration.fromObject = function fromObject(obj) {
	    if (obj == null || typeof obj !== "object") {
	      throw new InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + (obj === null ? "null" : typeof obj));
	    }
	
	    return new Duration({
	      values: normalizeObject(obj, Duration.normalizeUnit, ["locale", "numberingSystem", "conversionAccuracy", "zone" // a bit of debt; it's super inconvenient internally not to be able to blindly pass this
	      ]),
	      loc: Locale.fromObject(obj),
	      conversionAccuracy: obj.conversionAccuracy
	    });
	  }
	  /**
	   * Create a Duration from an ISO 8601 duration string.
	   * @param {string} text - text to parse
	   * @param {Object} opts - options for parsing
	   * @param {string} [opts.locale='en-US'] - the locale to use
	   * @param {string} opts.numberingSystem - the numbering system to use
	   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
	   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
	   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
	   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
	   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
	   * @return {Duration}
	   */
	  ;
	
	  Duration.fromISO = function fromISO(text, opts) {
	    var _parseISODuration = parseISODuration(text),
	        parsed = _parseISODuration[0];
	
	    if (parsed) {
	      var obj = Object.assign(parsed, opts);
	      return Duration.fromObject(obj);
	    } else {
	      return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
	    }
	  }
	  /**
	   * Create an invalid Duration.
	   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
	   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
	   * @return {Duration}
	   */
	  ;
	
	  Duration.invalid = function invalid(reason, explanation) {
	    if (explanation === void 0) {
	      explanation = null;
	    }
	
	    if (!reason) {
	      throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
	    }
	
	    var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
	
	    if (Settings.throwOnInvalid) {
	      throw new InvalidDurationError(invalid);
	    } else {
	      return new Duration({
	        invalid: invalid
	      });
	    }
	  }
	  /**
	   * @private
	   */
	  ;
	
	  Duration.normalizeUnit = function normalizeUnit(unit) {
	    var normalized = {
	      year: "years",
	      years: "years",
	      quarter: "quarters",
	      quarters: "quarters",
	      month: "months",
	      months: "months",
	      week: "weeks",
	      weeks: "weeks",
	      day: "days",
	      days: "days",
	      hour: "hours",
	      hours: "hours",
	      minute: "minutes",
	      minutes: "minutes",
	      second: "seconds",
	      seconds: "seconds",
	      millisecond: "milliseconds",
	      milliseconds: "milliseconds"
	    }[unit ? unit.toLowerCase() : unit];
	    if (!normalized) throw new InvalidUnitError(unit);
	    return normalized;
	  }
	  /**
	   * Check if an object is a Duration. Works across context boundaries
	   * @param {object} o
	   * @return {boolean}
	   */
	  ;
	
	  Duration.isDuration = function isDuration(o) {
	    return o && o.isLuxonDuration || false;
	  }
	  /**
	   * Get  the locale of a Duration, such 'en-GB'
	   * @type {string}
	   */
	  ;
	
	  var _proto = Duration.prototype;
	
	  /**
	   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
	   * * `S` for milliseconds
	   * * `s` for seconds
	   * * `m` for minutes
	   * * `h` for hours
	   * * `d` for days
	   * * `M` for months
	   * * `y` for years
	   * Notes:
	   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
	   * * The duration will be converted to the set of units in the format string using {@link Duration.shiftTo} and the Durations's conversion accuracy setting.
	   * @param {string} fmt - the format string
	   * @param {Object} opts - options
	   * @param {boolean} [opts.floor=true] - floor numerical values
	   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
	   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
	   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
	   * @return {string}
	   */
	  _proto.toFormat = function toFormat(fmt, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    // reverse-compat since 1.2; we always round down now, never up, and we do it by default
	    var fmtOpts = Object.assign({}, opts, {
	      floor: opts.round !== false && opts.floor !== false
	    });
	    return this.isValid ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : INVALID;
	  }
	  /**
	   * Returns a Javascript object with this Duration's values.
	   * @param opts - options for generating the object
	   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
	   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
	   * @return {Object}
	   */
	  ;
	
	  _proto.toObject = function toObject(opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    if (!this.isValid) return {};
	    var base = Object.assign({}, this.values);
	
	    if (opts.includeConfig) {
	      base.conversionAccuracy = this.conversionAccuracy;
	      base.numberingSystem = this.loc.numberingSystem;
	      base.locale = this.loc.locale;
	    }
	
	    return base;
	  }
	  /**
	   * Returns an ISO 8601-compliant string representation of this Duration.
	   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
	   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
	   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
	   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
	   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
	   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
	   * @return {string}
	   */
	  ;
	
	  _proto.toISO = function toISO() {
	    // we could use the formatter, but this is an easier way to get the minimum string
	    if (!this.isValid) return null;
	    var s = "P";
	    if (this.years !== 0) s += this.years + "Y";
	    if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
	    if (this.weeks !== 0) s += this.weeks + "W";
	    if (this.days !== 0) s += this.days + "D";
	    if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
	    if (this.hours !== 0) s += this.hours + "H";
	    if (this.minutes !== 0) s += this.minutes + "M";
	    if (this.seconds !== 0 || this.milliseconds !== 0) // this will handle "floating point madness" by removing extra decimal places
	      // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
	      s += roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
	    if (s === "P") s += "T0S";
	    return s;
	  }
	  /**
	   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
	   * @return {string}
	   */
	  ;
	
	  _proto.toJSON = function toJSON() {
	    return this.toISO();
	  }
	  /**
	   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
	   * @return {string}
	   */
	  ;
	
	  _proto.toString = function toString() {
	    return this.toISO();
	  }
	  /**
	   * Returns an milliseconds value of this Duration.
	   * @return {number}
	   */
	  ;
	
	  _proto.valueOf = function valueOf() {
	    return this.as("milliseconds");
	  }
	  /**
	   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
	   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
	   * @return {Duration}
	   */
	  ;
	
	  _proto.plus = function plus(duration) {
	    if (!this.isValid) return this;
	    var dur = friendlyDuration(duration),
	        result = {};
	
	    for (var _iterator = orderedUnits, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var k = _ref;
	
	      if (hasOwnProperty(dur.values, k) || hasOwnProperty(this.values, k)) {
	        result[k] = dur.get(k) + this.get(k);
	      }
	    }
	
	    return clone(this, {
	      values: result
	    }, true);
	  }
	  /**
	   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
	   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
	   * @return {Duration}
	   */
	  ;
	
	  _proto.minus = function minus(duration) {
	    if (!this.isValid) return this;
	    var dur = friendlyDuration(duration);
	    return this.plus(dur.negate());
	  }
	  /**
	   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
	   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
	   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnit(x => x * 2) //=> { hours: 2, minutes: 60 }
	   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnit((x, u) => u === "hour" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
	   * @return {Duration}
	   */
	  ;
	
	  _proto.mapUnits = function mapUnits(fn) {
	    if (!this.isValid) return this;
	    var result = {};
	
	    for (var _i2 = 0, _Object$keys = Object.keys(this.values); _i2 < _Object$keys.length; _i2++) {
	      var k = _Object$keys[_i2];
	      result[k] = asNumber(fn(this.values[k], k));
	    }
	
	    return clone(this, {
	      values: result
	    }, true);
	  }
	  /**
	   * Get the value of unit.
	   * @param {string} unit - a unit such as 'minute' or 'day'
	   * @example Duration.fromObject({years: 2, days: 3}).years //=> 2
	   * @example Duration.fromObject({years: 2, days: 3}).months //=> 0
	   * @example Duration.fromObject({years: 2, days: 3}).days //=> 3
	   * @return {number}
	   */
	  ;
	
	  _proto.get = function get(unit) {
	    return this[Duration.normalizeUnit(unit)];
	  }
	  /**
	   * "Set" the values of specified units. Return a newly-constructed Duration.
	   * @param {Object} values - a mapping of units to numbers
	   * @example dur.set({ years: 2017 })
	   * @example dur.set({ hours: 8, minutes: 30 })
	   * @return {Duration}
	   */
	  ;
	
	  _proto.set = function set(values) {
	    if (!this.isValid) return this;
	    var mixed = Object.assign(this.values, normalizeObject(values, Duration.normalizeUnit, []));
	    return clone(this, {
	      values: mixed
	    });
	  }
	  /**
	   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
	   * @example dur.reconfigure({ locale: 'en-GB' })
	   * @return {Duration}
	   */
	  ;
	
	  _proto.reconfigure = function reconfigure(_temp) {
	    var _ref2 = _temp === void 0 ? {} : _temp,
	        locale = _ref2.locale,
	        numberingSystem = _ref2.numberingSystem,
	        conversionAccuracy = _ref2.conversionAccuracy;
	
	    var loc = this.loc.clone({
	      locale: locale,
	      numberingSystem: numberingSystem
	    }),
	        opts = {
	      loc: loc
	    };
	
	    if (conversionAccuracy) {
	      opts.conversionAccuracy = conversionAccuracy;
	    }
	
	    return clone(this, opts);
	  }
	  /**
	   * Return the length of the duration in the specified unit.
	   * @param {string} unit - a unit such as 'minutes' or 'days'
	   * @example Duration.fromObject({years: 1}).as('days') //=> 365
	   * @example Duration.fromObject({years: 1}).as('months') //=> 12
	   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
	   * @return {number}
	   */
	  ;
	
	  _proto.as = function as(unit) {
	    return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
	  }
	  /**
	   * Reduce this Duration to its canonical representation in its current units.
	   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
	   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
	   * @return {Duration}
	   */
	  ;
	
	  _proto.normalize = function normalize() {
	    if (!this.isValid) return this;
	    var vals = this.toObject();
	    normalizeValues(this.matrix, vals);
	    return clone(this, {
	      values: vals
	    }, true);
	  }
	  /**
	   * Convert this Duration into its representation in a different set of units.
	   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
	   * @return {Duration}
	   */
	  ;
	
	  _proto.shiftTo = function shiftTo() {
	    for (var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++) {
	      units[_key] = arguments[_key];
	    }
	
	    if (!this.isValid) return this;
	
	    if (units.length === 0) {
	      return this;
	    }
	
	    units = units.map(function (u) {
	      return Duration.normalizeUnit(u);
	    });
	    var built = {},
	        accumulated = {},
	        vals = this.toObject();
	    var lastUnit;
	    normalizeValues(this.matrix, vals);
	
	    for (var _iterator2 = orderedUnits, _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	      var _ref3;
	
	      if (_isArray2) {
	        if (_i3 >= _iterator2.length) break;
	        _ref3 = _iterator2[_i3++];
	      } else {
	        _i3 = _iterator2.next();
	        if (_i3.done) break;
	        _ref3 = _i3.value;
	      }
	
	      var k = _ref3;
	
	      if (units.indexOf(k) >= 0) {
	        lastUnit = k;
	        var own = 0; // anything we haven't boiled down yet should get boiled to this unit
	
	        for (var ak in accumulated) {
	          own += this.matrix[ak][k] * accumulated[ak];
	          accumulated[ak] = 0;
	        } // plus anything that's already in this unit
	
	
	        if (isNumber(vals[k])) {
	          own += vals[k];
	        }
	
	        var i = Math.trunc(own);
	        built[k] = i;
	        accumulated[k] = own - i; // we'd like to absorb these fractions in another unit
	        // plus anything further down the chain that should be rolled up in to this
	
	        for (var down in vals) {
	          if (orderedUnits.indexOf(down) > orderedUnits.indexOf(k)) {
	            convert(this.matrix, vals, down, built, k);
	          }
	        } // otherwise, keep it in the wings to boil it later
	
	      } else if (isNumber(vals[k])) {
	        accumulated[k] = vals[k];
	      }
	    } // anything leftover becomes the decimal for the last unit
	    // lastUnit must be defined since units is not empty
	
	
	    for (var key in accumulated) {
	      if (accumulated[key] !== 0) {
	        built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
	      }
	    }
	
	    return clone(this, {
	      values: built
	    }, true).normalize();
	  }
	  /**
	   * Return the negative of this Duration.
	   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
	   * @return {Duration}
	   */
	  ;
	
	  _proto.negate = function negate() {
	    if (!this.isValid) return this;
	    var negated = {};
	
	    for (var _i4 = 0, _Object$keys2 = Object.keys(this.values); _i4 < _Object$keys2.length; _i4++) {
	      var k = _Object$keys2[_i4];
	      negated[k] = -this.values[k];
	    }
	
	    return clone(this, {
	      values: negated
	    }, true);
	  }
	  /**
	   * Get the years.
	   * @type {number}
	   */
	  ;
	
	  /**
	   * Equality check
	   * Two Durations are equal iff they have the same units and the same values for each unit.
	   * @param {Duration} other
	   * @return {boolean}
	   */
	  _proto.equals = function equals(other) {
	    if (!this.isValid || !other.isValid) {
	      return false;
	    }
	
	    if (!this.loc.equals(other.loc)) {
	      return false;
	    }
	
	    for (var _iterator3 = orderedUnits, _isArray3 = Array.isArray(_iterator3), _i5 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
	      var _ref4;
	
	      if (_isArray3) {
	        if (_i5 >= _iterator3.length) break;
	        _ref4 = _iterator3[_i5++];
	      } else {
	        _i5 = _iterator3.next();
	        if (_i5.done) break;
	        _ref4 = _i5.value;
	      }
	
	      var u = _ref4;
	
	      if (this.values[u] !== other.values[u]) {
	        return false;
	      }
	    }
	
	    return true;
	  };
	
	  _createClass(Duration, [{
	    key: "locale",
	    get: function get() {
	      return this.isValid ? this.loc.locale : null;
	    }
	    /**
	     * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
	     *
	     * @type {string}
	     */
	
	  }, {
	    key: "numberingSystem",
	    get: function get() {
	      return this.isValid ? this.loc.numberingSystem : null;
	    }
	  }, {
	    key: "years",
	    get: function get() {
	      return this.isValid ? this.values.years || 0 : NaN;
	    }
	    /**
	     * Get the quarters.
	     * @type {number}
	     */
	
	  }, {
	    key: "quarters",
	    get: function get() {
	      return this.isValid ? this.values.quarters || 0 : NaN;
	    }
	    /**
	     * Get the months.
	     * @type {number}
	     */
	
	  }, {
	    key: "months",
	    get: function get() {
	      return this.isValid ? this.values.months || 0 : NaN;
	    }
	    /**
	     * Get the weeks
	     * @type {number}
	     */
	
	  }, {
	    key: "weeks",
	    get: function get() {
	      return this.isValid ? this.values.weeks || 0 : NaN;
	    }
	    /**
	     * Get the days.
	     * @type {number}
	     */
	
	  }, {
	    key: "days",
	    get: function get() {
	      return this.isValid ? this.values.days || 0 : NaN;
	    }
	    /**
	     * Get the hours.
	     * @type {number}
	     */
	
	  }, {
	    key: "hours",
	    get: function get() {
	      return this.isValid ? this.values.hours || 0 : NaN;
	    }
	    /**
	     * Get the minutes.
	     * @type {number}
	     */
	
	  }, {
	    key: "minutes",
	    get: function get() {
	      return this.isValid ? this.values.minutes || 0 : NaN;
	    }
	    /**
	     * Get the seconds.
	     * @return {number}
	     */
	
	  }, {
	    key: "seconds",
	    get: function get() {
	      return this.isValid ? this.values.seconds || 0 : NaN;
	    }
	    /**
	     * Get the milliseconds.
	     * @return {number}
	     */
	
	  }, {
	    key: "milliseconds",
	    get: function get() {
	      return this.isValid ? this.values.milliseconds || 0 : NaN;
	    }
	    /**
	     * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
	     * on invalid DateTimes or Intervals.
	     * @return {boolean}
	     */
	
	  }, {
	    key: "isValid",
	    get: function get() {
	      return this.invalid === null;
	    }
	    /**
	     * Returns an error code if this Duration became invalid, or null if the Duration is valid
	     * @return {string}
	     */
	
	  }, {
	    key: "invalidReason",
	    get: function get() {
	      return this.invalid ? this.invalid.reason : null;
	    }
	    /**
	     * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
	     * @type {string}
	     */
	
	  }, {
	    key: "invalidExplanation",
	    get: function get() {
	      return this.invalid ? this.invalid.explanation : null;
	    }
	  }]);
	
	  return Duration;
	}();
	function friendlyDuration(durationish) {
	  if (isNumber(durationish)) {
	    return Duration.fromMillis(durationish);
	  } else if (Duration.isDuration(durationish)) {
	    return durationish;
	  } else if (typeof durationish === "object") {
	    return Duration.fromObject(durationish);
	  } else {
	    throw new InvalidArgumentError("Unknown duration argument " + durationish + " of type " + typeof durationish);
	  }
	}
	
	var INVALID$1 = "Invalid Interval"; // checks if the start is equal to or before the end
	
	function validateStartEnd(start, end) {
	  if (!start || !start.isValid) {
	    return Interval.invalid("missing or invalid start");
	  } else if (!end || !end.isValid) {
	    return Interval.invalid("missing or invalid end");
	  } else if (end < start) {
	    return Interval.invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
	  } else {
	    return null;
	  }
	}
	/**
	 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
	 *
	 * Here is a brief overview of the most commonly used methods and getters in Interval:
	 *
	 * * **Creation** To create an Interval, use {@link fromDateTimes}, {@link after}, {@link before}, or {@link fromISO}.
	 * * **Accessors** Use {@link start} and {@link end} to get the start and end.
	 * * **Interrogation** To analyze the Interval, use {@link count}, {@link length}, {@link hasSame}, {@link contains}, {@link isAfter}, or {@link isBefore}.
	 * * **Transformation** To create other Intervals out of this one, use {@link set}, {@link splitAt}, {@link splitBy}, {@link divideEqually}, {@link merge}, {@link xor}, {@link union}, {@link intersection}, or {@link difference}.
	 * * **Comparison** To compare this Interval to another one, use {@link equals}, {@link overlaps}, {@link abutsStart}, {@link abutsEnd}, {@link engulfs}
	 * * **Output** To convert the Interval into other representations, see {@link toString}, {@link toISO}, {@link toISODate}, {@link toISOTime}, {@link toFormat}, and {@link toDuration}.
	 */
	
	
	var Interval =
	/*#__PURE__*/
	function () {
	  /**
	   * @private
	   */
	  function Interval(config) {
	    /**
	     * @access private
	     */
	    this.s = config.start;
	    /**
	     * @access private
	     */
	
	    this.e = config.end;
	    /**
	     * @access private
	     */
	
	    this.invalid = config.invalid || null;
	    /**
	     * @access private
	     */
	
	    this.isLuxonInterval = true;
	  }
	  /**
	   * Create an invalid Interval.
	   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
	   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
	   * @return {Interval}
	   */
	
	
	  Interval.invalid = function invalid(reason, explanation) {
	    if (explanation === void 0) {
	      explanation = null;
	    }
	
	    if (!reason) {
	      throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
	    }
	
	    var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
	
	    if (Settings.throwOnInvalid) {
	      throw new InvalidIntervalError(invalid);
	    } else {
	      return new Interval({
	        invalid: invalid
	      });
	    }
	  }
	  /**
	   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
	   * @param {DateTime|Date|Object} start
	   * @param {DateTime|Date|Object} end
	   * @return {Interval}
	   */
	  ;
	
	  Interval.fromDateTimes = function fromDateTimes(start, end) {
	    var builtStart = friendlyDateTime(start),
	        builtEnd = friendlyDateTime(end);
	    var validateError = validateStartEnd(builtStart, builtEnd);
	
	    if (validateError == null) {
	      return new Interval({
	        start: builtStart,
	        end: builtEnd
	      });
	    } else {
	      return validateError;
	    }
	  }
	  /**
	   * Create an Interval from a start DateTime and a Duration to extend to.
	   * @param {DateTime|Date|Object} start
	   * @param {Duration|Object|number} duration - the length of the Interval.
	   * @return {Interval}
	   */
	  ;
	
	  Interval.after = function after(start, duration) {
	    var dur = friendlyDuration(duration),
	        dt = friendlyDateTime(start);
	    return Interval.fromDateTimes(dt, dt.plus(dur));
	  }
	  /**
	   * Create an Interval from an end DateTime and a Duration to extend backwards to.
	   * @param {DateTime|Date|Object} end
	   * @param {Duration|Object|number} duration - the length of the Interval.
	   * @return {Interval}
	   */
	  ;
	
	  Interval.before = function before(end, duration) {
	    var dur = friendlyDuration(duration),
	        dt = friendlyDateTime(end);
	    return Interval.fromDateTimes(dt.minus(dur), dt);
	  }
	  /**
	   * Create an Interval from an ISO 8601 string.
	   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
	   * @param {string} text - the ISO string to parse
	   * @param {Object} [opts] - options to pass {@link DateTime.fromISO} and optionally {@link Duration.fromISO}
	   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
	   * @return {Interval}
	   */
	  ;
	
	  Interval.fromISO = function fromISO(text, opts) {
	    var _split = (text || "").split("/", 2),
	        s = _split[0],
	        e = _split[1];
	
	    if (s && e) {
	      var start = DateTime.fromISO(s, opts),
	          end = DateTime.fromISO(e, opts);
	
	      if (start.isValid && end.isValid) {
	        return Interval.fromDateTimes(start, end);
	      }
	
	      if (start.isValid) {
	        var dur = Duration.fromISO(e, opts);
	
	        if (dur.isValid) {
	          return Interval.after(start, dur);
	        }
	      } else if (end.isValid) {
	        var _dur = Duration.fromISO(s, opts);
	
	        if (_dur.isValid) {
	          return Interval.before(end, _dur);
	        }
	      }
	    }
	
	    return Interval.invalid("unparsable", "the input \"" + text + "\" can't be parsed asISO 8601");
	  }
	  /**
	   * Check if an object is an Interval. Works across context boundaries
	   * @param {object} o
	   * @return {boolean}
	   */
	  ;
	
	  Interval.isInterval = function isInterval(o) {
	    return o && o.isLuxonInterval || false;
	  }
	  /**
	   * Returns the start of the Interval
	   * @type {DateTime}
	   */
	  ;
	
	  var _proto = Interval.prototype;
	
	  /**
	   * Returns the length of the Interval in the specified unit.
	   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
	   * @return {number}
	   */
	  _proto.length = function length(unit) {
	    if (unit === void 0) {
	      unit = "milliseconds";
	    }
	
	    return this.isValid ? this.toDuration.apply(this, [unit]).get(unit) : NaN;
	  }
	  /**
	   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
	   * Unlike {@link length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
	   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
	   * @param {string} [unit='milliseconds'] - the unit of time to count.
	   * @return {number}
	   */
	  ;
	
	  _proto.count = function count(unit) {
	    if (unit === void 0) {
	      unit = "milliseconds";
	    }
	
	    if (!this.isValid) return NaN;
	    var start = this.start.startOf(unit),
	        end = this.end.startOf(unit);
	    return Math.floor(end.diff(start, unit).get(unit)) + 1;
	  }
	  /**
	   * Returns whether this Interval's start and end are both in the same unit of time
	   * @param {string} unit - the unit of time to check sameness on
	   * @return {boolean}
	   */
	  ;
	
	  _proto.hasSame = function hasSame(unit) {
	    return this.isValid ? this.e.minus(1).hasSame(this.s, unit) : false;
	  }
	  /**
	   * Return whether this Interval has the same start and end DateTimes.
	   * @return {boolean}
	   */
	  ;
	
	  _proto.isEmpty = function isEmpty() {
	    return this.s.valueOf() === this.e.valueOf();
	  }
	  /**
	   * Return whether this Interval's start is after the specified DateTime.
	   * @param {DateTime} dateTime
	   * @return {boolean}
	   */
	  ;
	
	  _proto.isAfter = function isAfter(dateTime) {
	    if (!this.isValid) return false;
	    return this.s > dateTime;
	  }
	  /**
	   * Return whether this Interval's end is before the specified DateTime.
	   * @param {DateTime} dateTime
	   * @return {boolean}
	   */
	  ;
	
	  _proto.isBefore = function isBefore(dateTime) {
	    if (!this.isValid) return false;
	    return this.e <= dateTime;
	  }
	  /**
	   * Return whether this Interval contains the specified DateTime.
	   * @param {DateTime} dateTime
	   * @return {boolean}
	   */
	  ;
	
	  _proto.contains = function contains(dateTime) {
	    if (!this.isValid) return false;
	    return this.s <= dateTime && this.e > dateTime;
	  }
	  /**
	   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
	   * @param {Object} values - the values to set
	   * @param {DateTime} values.start - the starting DateTime
	   * @param {DateTime} values.end - the ending DateTime
	   * @return {Interval}
	   */
	  ;
	
	  _proto.set = function set(_temp) {
	    var _ref = _temp === void 0 ? {} : _temp,
	        start = _ref.start,
	        end = _ref.end;
	
	    if (!this.isValid) return this;
	    return Interval.fromDateTimes(start || this.s, end || this.e);
	  }
	  /**
	   * Split this Interval at each of the specified DateTimes
	   * @param {...[DateTime]} dateTimes - the unit of time to count.
	   * @return {[Interval]}
	   */
	  ;
	
	  _proto.splitAt = function splitAt() {
	    var _this = this;
	
	    if (!this.isValid) return [];
	
	    for (var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++) {
	      dateTimes[_key] = arguments[_key];
	    }
	
	    var sorted = dateTimes.map(friendlyDateTime).filter(function (d) {
	      return _this.contains(d);
	    }).sort(),
	        results = [];
	    var s = this.s,
	        i = 0;
	
	    while (s < this.e) {
	      var added = sorted[i] || this.e,
	          next = +added > +this.e ? this.e : added;
	      results.push(Interval.fromDateTimes(s, next));
	      s = next;
	      i += 1;
	    }
	
	    return results;
	  }
	  /**
	   * Split this Interval into smaller Intervals, each of the specified length.
	   * Left over time is grouped into a smaller interval
	   * @param {Duration|Object|number} duration - The length of each resulting interval.
	   * @return {[Interval]}
	   */
	  ;
	
	  _proto.splitBy = function splitBy(duration) {
	    var dur = friendlyDuration(duration);
	
	    if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) {
	      return [];
	    }
	
	    var s = this.s,
	        added,
	        next;
	    var results = [];
	
	    while (s < this.e) {
	      added = s.plus(dur);
	      next = +added > +this.e ? this.e : added;
	      results.push(Interval.fromDateTimes(s, next));
	      s = next;
	    }
	
	    return results;
	  }
	  /**
	   * Split this Interval into the specified number of smaller intervals.
	   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
	   * @return {[Interval]}
	   */
	  ;
	
	  _proto.divideEqually = function divideEqually(numberOfParts) {
	    if (!this.isValid) return [];
	    return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
	  }
	  /**
	   * Return whether this Interval overlaps with the specified Interval
	   * @param {Interval} other
	   * @return {boolean}
	   */
	  ;
	
	  _proto.overlaps = function overlaps(other) {
	    return this.e > other.s && this.s < other.e;
	  }
	  /**
	   * Return whether this Interval's end is adjacent to the specified Interval's start.
	   * @param {Interval} other
	   * @return {boolean}
	   */
	  ;
	
	  _proto.abutsStart = function abutsStart(other) {
	    if (!this.isValid) return false;
	    return +this.e === +other.s;
	  }
	  /**
	   * Return whether this Interval's start is adjacent to the specified Interval's end.
	   * @param {Interval} other
	   * @return {boolean}
	   */
	  ;
	
	  _proto.abutsEnd = function abutsEnd(other) {
	    if (!this.isValid) return false;
	    return +other.e === +this.s;
	  }
	  /**
	   * Return whether this Interval engulfs the start and end of the specified Interval.
	   * @param {Interval} other
	   * @return {boolean}
	   */
	  ;
	
	  _proto.engulfs = function engulfs(other) {
	    if (!this.isValid) return false;
	    return this.s <= other.s && this.e >= other.e;
	  }
	  /**
	   * Return whether this Interval has the same start and end as the specified Interval.
	   * @param {Interval} other
	   * @return {boolean}
	   */
	  ;
	
	  _proto.equals = function equals(other) {
	    if (!this.isValid || !other.isValid) {
	      return false;
	    }
	
	    return this.s.equals(other.s) && this.e.equals(other.e);
	  }
	  /**
	   * Return an Interval representing the intersection of this Interval and the specified Interval.
	   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
	   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
	   * @param {Interval} other
	   * @return {Interval}
	   */
	  ;
	
	  _proto.intersection = function intersection(other) {
	    if (!this.isValid) return this;
	    var s = this.s > other.s ? this.s : other.s,
	        e = this.e < other.e ? this.e : other.e;
	
	    if (s > e) {
	      return null;
	    } else {
	      return Interval.fromDateTimes(s, e);
	    }
	  }
	  /**
	   * Return an Interval representing the union of this Interval and the specified Interval.
	   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
	   * @param {Interval} other
	   * @return {Interval}
	   */
	  ;
	
	  _proto.union = function union(other) {
	    if (!this.isValid) return this;
	    var s = this.s < other.s ? this.s : other.s,
	        e = this.e > other.e ? this.e : other.e;
	    return Interval.fromDateTimes(s, e);
	  }
	  /**
	   * Merge an array of Intervals into a equivalent minimal set of Intervals.
	   * Combines overlapping and adjacent Intervals.
	   * @param {[Interval]} intervals
	   * @return {[Interval]}
	   */
	  ;
	
	  Interval.merge = function merge(intervals) {
	    var _intervals$sort$reduc = intervals.sort(function (a, b) {
	      return a.s - b.s;
	    }).reduce(function (_ref2, item) {
	      var sofar = _ref2[0],
	          current = _ref2[1];
	
	      if (!current) {
	        return [sofar, item];
	      } else if (current.overlaps(item) || current.abutsStart(item)) {
	        return [sofar, current.union(item)];
	      } else {
	        return [sofar.concat([current]), item];
	      }
	    }, [[], null]),
	        found = _intervals$sort$reduc[0],
	        final = _intervals$sort$reduc[1];
	
	    if (final) {
	      found.push(final);
	    }
	
	    return found;
	  }
	  /**
	   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
	   * @param {[Interval]} intervals
	   * @return {[Interval]}
	   */
	  ;
	
	  Interval.xor = function xor(intervals) {
	    var _Array$prototype;
	
	    var start = null,
	        currentCount = 0;
	
	    var results = [],
	        ends = intervals.map(function (i) {
	      return [{
	        time: i.s,
	        type: "s"
	      }, {
	        time: i.e,
	        type: "e"
	      }];
	    }),
	        flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends),
	        arr = flattened.sort(function (a, b) {
	      return a.time - b.time;
	    });
	
	    for (var _iterator = arr, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	      var _ref3;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref3 = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref3 = _i.value;
	      }
	
	      var i = _ref3;
	      currentCount += i.type === "s" ? 1 : -1;
	
	      if (currentCount === 1) {
	        start = i.time;
	      } else {
	        if (start && +start !== +i.time) {
	          results.push(Interval.fromDateTimes(start, i.time));
	        }
	
	        start = null;
	      }
	    }
	
	    return Interval.merge(results);
	  }
	  /**
	   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
	   * @param {...Interval} intervals
	   * @return {[Interval]}
	   */
	  ;
	
	  _proto.difference = function difference() {
	    var _this2 = this;
	
	    for (var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      intervals[_key2] = arguments[_key2];
	    }
	
	    return Interval.xor([this].concat(intervals)).map(function (i) {
	      return _this2.intersection(i);
	    }).filter(function (i) {
	      return i && !i.isEmpty();
	    });
	  }
	  /**
	   * Returns a string representation of this Interval appropriate for debugging.
	   * @return {string}
	   */
	  ;
	
	  _proto.toString = function toString() {
	    if (!this.isValid) return INVALID$1;
	    return "[" + this.s.toISO() + " \u2013 " + this.e.toISO() + ")";
	  }
	  /**
	   * Returns an ISO 8601-compliant string representation of this Interval.
	   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
	   * @param {Object} opts - The same options as {@link DateTime.toISO}
	   * @return {string}
	   */
	  ;
	
	  _proto.toISO = function toISO(opts) {
	    if (!this.isValid) return INVALID$1;
	    return this.s.toISO(opts) + "/" + this.e.toISO(opts);
	  }
	  /**
	   * Returns an ISO 8601-compliant string representation of date of this Interval.
	   * The time components are ignored.
	   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
	   * @return {string}
	   */
	  ;
	
	  _proto.toISODate = function toISODate() {
	    if (!this.isValid) return INVALID$1;
	    return this.s.toISODate() + "/" + this.e.toISODate();
	  }
	  /**
	   * Returns an ISO 8601-compliant string representation of time of this Interval.
	   * The date components are ignored.
	   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
	   * @param {Object} opts - The same options as {@link DateTime.toISO}
	   * @return {string}
	   */
	  ;
	
	  _proto.toISOTime = function toISOTime(opts) {
	    if (!this.isValid) return INVALID$1;
	    return this.s.toISOTime(opts) + "/" + this.e.toISOTime(opts);
	  }
	  /**
	   * Returns a string representation of this Interval formatted according to the specified format string.
	   * @param {string} dateFormat - the format string. This string formats the start and end time. See {@link DateTime.toFormat} for details.
	   * @param {Object} opts - options
	   * @param {string} [opts.separator =  ' – '] - a separator to place between the start and end representations
	   * @return {string}
	   */
	  ;
	
	  _proto.toFormat = function toFormat(dateFormat, _temp2) {
	    var _ref4 = _temp2 === void 0 ? {} : _temp2,
	        _ref4$separator = _ref4.separator,
	        separator = _ref4$separator === void 0 ? " – " : _ref4$separator;
	
	    if (!this.isValid) return INVALID$1;
	    return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
	  }
	  /**
	   * Return a Duration representing the time spanned by this interval.
	   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
	   * @param {Object} opts - options that affect the creation of the Duration
	   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
	   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
	   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
	   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
	   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
	   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
	   * @return {Duration}
	   */
	  ;
	
	  _proto.toDuration = function toDuration(unit, opts) {
	    if (!this.isValid) {
	      return Duration.invalid(this.invalidReason);
	    }
	
	    return this.e.diff(this.s, unit, opts);
	  }
	  /**
	   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
	   * @param {function} mapFn
	   * @return {Interval}
	   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
	   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
	   */
	  ;
	
	  _proto.mapEndpoints = function mapEndpoints(mapFn) {
	    return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
	  };
	
	  _createClass(Interval, [{
	    key: "start",
	    get: function get() {
	      return this.isValid ? this.s : null;
	    }
	    /**
	     * Returns the end of the Interval
	     * @type {DateTime}
	     */
	
	  }, {
	    key: "end",
	    get: function get() {
	      return this.isValid ? this.e : null;
	    }
	    /**
	     * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
	     * @type {boolean}
	     */
	
	  }, {
	    key: "isValid",
	    get: function get() {
	      return this.invalidReason === null;
	    }
	    /**
	     * Returns an error code if this Interval is invalid, or null if the Interval is valid
	     * @type {string}
	     */
	
	  }, {
	    key: "invalidReason",
	    get: function get() {
	      return this.invalid ? this.invalid.reason : null;
	    }
	    /**
	     * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
	     * @type {string}
	     */
	
	  }, {
	    key: "invalidExplanation",
	    get: function get() {
	      return this.invalid ? this.invalid.explanation : null;
	    }
	  }]);
	
	  return Interval;
	}();
	
	/**
	 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
	 */
	
	var Info =
	/*#__PURE__*/
	function () {
	  function Info() {}
	
	  /**
	   * Return whether the specified zone contains a DST.
	   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
	   * @return {boolean}
	   */
	  Info.hasDST = function hasDST(zone) {
	    if (zone === void 0) {
	      zone = Settings.defaultZone;
	    }
	
	    var proto = DateTime.local().setZone(zone).set({
	      month: 12
	    });
	    return !zone.universal && proto.offset !== proto.set({
	      month: 6
	    }).offset;
	  }
	  /**
	   * Return whether the specified zone is a valid IANA specifier.
	   * @param {string} zone - Zone to check
	   * @return {boolean}
	   */
	  ;
	
	  Info.isValidIANAZone = function isValidIANAZone(zone) {
	    return IANAZone.isValidSpecifier(zone) && IANAZone.isValidZone(zone);
	  }
	  /**
	   * Converts the input into a {@link Zone} instance.
	   *
	   * * If `input` is already a Zone instance, it is returned unchanged.
	   * * If `input` is a string containing a valid time zone name, a Zone instance
	   *   with that name is returned.
	   * * If `input` is a string that doesn't refer to a known time zone, a Zone
	   *   instance with {@link Zone.isValid} == false is returned.
	   * * If `input is a number, a Zone instance with the specified fixed offset
	   *   in minutes is returned.
	   * * If `input` is `null` or `undefined`, the default zone is returned.
	   * @param {string|Zone|number} [input] - the value to be converted
	   * @return {Zone}
	   */
	  ;
	
	  Info.normalizeZone = function normalizeZone$1(input) {
	    return normalizeZone(input, Settings.defaultZone);
	  }
	  /**
	   * Return an array of standalone month names.
	   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
	   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
	   * @param {Object} opts - options
	   * @param {string} [opts.locale] - the locale code
	   * @param {string} [opts.numberingSystem=null] - the numbering system
	   * @param {string} [opts.outputCalendar='gregory'] - the calendar
	   * @example Info.months()[0] //=> 'January'
	   * @example Info.months('short')[0] //=> 'Jan'
	   * @example Info.months('numeric')[0] //=> '1'
	   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
	   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
	   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
	   * @return {[string]}
	   */
	  ;
	
	  Info.months = function months(length, _temp) {
	    if (length === void 0) {
	      length = "long";
	    }
	
	    var _ref = _temp === void 0 ? {} : _temp,
	        _ref$locale = _ref.locale,
	        locale = _ref$locale === void 0 ? null : _ref$locale,
	        _ref$numberingSystem = _ref.numberingSystem,
	        numberingSystem = _ref$numberingSystem === void 0 ? null : _ref$numberingSystem,
	        _ref$outputCalendar = _ref.outputCalendar,
	        outputCalendar = _ref$outputCalendar === void 0 ? "gregory" : _ref$outputCalendar;
	
	    return Locale.create(locale, numberingSystem, outputCalendar).months(length);
	  }
	  /**
	   * Return an array of format month names.
	   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
	   * changes the string.
	   * See {@link months}
	   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
	   * @param {Object} opts - options
	   * @param {string} [opts.locale] - the locale code
	   * @param {string} [opts.numberingSystem=null] - the numbering system
	   * @param {string} [opts.outputCalendar='gregory'] - the calendar
	   * @return {[string]}
	   */
	  ;
	
	  Info.monthsFormat = function monthsFormat(length, _temp2) {
	    if (length === void 0) {
	      length = "long";
	    }
	
	    var _ref2 = _temp2 === void 0 ? {} : _temp2,
	        _ref2$locale = _ref2.locale,
	        locale = _ref2$locale === void 0 ? null : _ref2$locale,
	        _ref2$numberingSystem = _ref2.numberingSystem,
	        numberingSystem = _ref2$numberingSystem === void 0 ? null : _ref2$numberingSystem,
	        _ref2$outputCalendar = _ref2.outputCalendar,
	        outputCalendar = _ref2$outputCalendar === void 0 ? "gregory" : _ref2$outputCalendar;
	
	    return Locale.create(locale, numberingSystem, outputCalendar).months(length, true);
	  }
	  /**
	   * Return an array of standalone week names.
	   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
	   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
	   * @param {Object} opts - options
	   * @param {string} [opts.locale] - the locale code
	   * @param {string} [opts.numberingSystem=null] - the numbering system
	   * @example Info.weekdays()[0] //=> 'Monday'
	   * @example Info.weekdays('short')[0] //=> 'Mon'
	   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
	   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
	   * @return {[string]}
	   */
	  ;
	
	  Info.weekdays = function weekdays(length, _temp3) {
	    if (length === void 0) {
	      length = "long";
	    }
	
	    var _ref3 = _temp3 === void 0 ? {} : _temp3,
	        _ref3$locale = _ref3.locale,
	        locale = _ref3$locale === void 0 ? null : _ref3$locale,
	        _ref3$numberingSystem = _ref3.numberingSystem,
	        numberingSystem = _ref3$numberingSystem === void 0 ? null : _ref3$numberingSystem;
	
	    return Locale.create(locale, numberingSystem, null).weekdays(length);
	  }
	  /**
	   * Return an array of format week names.
	   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
	   * changes the string.
	   * See {@link weekdays}
	   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
	   * @param {Object} opts - options
	   * @param {string} [opts.locale=null] - the locale code
	   * @param {string} [opts.numberingSystem=null] - the numbering system
	   * @return {[string]}
	   */
	  ;
	
	  Info.weekdaysFormat = function weekdaysFormat(length, _temp4) {
	    if (length === void 0) {
	      length = "long";
	    }
	
	    var _ref4 = _temp4 === void 0 ? {} : _temp4,
	        _ref4$locale = _ref4.locale,
	        locale = _ref4$locale === void 0 ? null : _ref4$locale,
	        _ref4$numberingSystem = _ref4.numberingSystem,
	        numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem;
	
	    return Locale.create(locale, numberingSystem, null).weekdays(length, true);
	  }
	  /**
	   * Return an array of meridiems.
	   * @param {Object} opts - options
	   * @param {string} [opts.locale] - the locale code
	   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
	   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
	   * @return {[string]}
	   */
	  ;
	
	  Info.meridiems = function meridiems(_temp5) {
	    var _ref5 = _temp5 === void 0 ? {} : _temp5,
	        _ref5$locale = _ref5.locale,
	        locale = _ref5$locale === void 0 ? null : _ref5$locale;
	
	    return Locale.create(locale).meridiems();
	  }
	  /**
	   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
	   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
	   * @param {Object} opts - options
	   * @param {string} [opts.locale] - the locale code
	   * @example Info.eras() //=> [ 'BC', 'AD' ]
	   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
	   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
	   * @return {[string]}
	   */
	  ;
	
	  Info.eras = function eras(length, _temp6) {
	    if (length === void 0) {
	      length = "short";
	    }
	
	    var _ref6 = _temp6 === void 0 ? {} : _temp6,
	        _ref6$locale = _ref6.locale,
	        locale = _ref6$locale === void 0 ? null : _ref6$locale;
	
	    return Locale.create(locale, null, "gregory").eras(length);
	  }
	  /**
	   * Return the set of available features in this environment.
	   * Some features of Luxon are not available in all environments. For example, on older browsers, timezone support is not available. Use this function to figure out if that's the case.
	   * Keys:
	   * * `zones`: whether this environment supports IANA timezones
	   * * `intlTokens`: whether this environment supports internationalized token-based formatting/parsing
	   * * `intl`: whether this environment supports general internationalization
	   * * `relative`: whether this environment supports relative time formatting
	   * @example Info.features() //=> { intl: true, intlTokens: false, zones: true, relative: false }
	   * @return {Object}
	   */
	  ;
	
	  Info.features = function features() {
	    var intl = false,
	        intlTokens = false,
	        zones = false,
	        relative = false;
	
	    if (hasIntl()) {
	      intl = true;
	      intlTokens = hasFormatToParts();
	      relative = hasRelative();
	
	      try {
	        zones = new Intl.DateTimeFormat("en", {
	          timeZone: "America/New_York"
	        }).resolvedOptions().timeZone === "America/New_York";
	      } catch (e) {
	        zones = false;
	      }
	    }
	
	    return {
	      intl: intl,
	      intlTokens: intlTokens,
	      zones: zones,
	      relative: relative
	    };
	  };
	
	  return Info;
	}();
	
	function dayDiff(earlier, later) {
	  var utcDayStart = function utcDayStart(dt) {
	    return dt.toUTC(0, {
	      keepLocalTime: true
	    }).startOf("day").valueOf();
	  },
	      ms = utcDayStart(later) - utcDayStart(earlier);
	
	  return Math.floor(Duration.fromMillis(ms).as("days"));
	}
	
	function highOrderDiffs(cursor, later, units) {
	  var differs = [["years", function (a, b) {
	    return b.year - a.year;
	  }], ["months", function (a, b) {
	    return b.month - a.month + (b.year - a.year) * 12;
	  }], ["weeks", function (a, b) {
	    var days = dayDiff(a, b);
	    return (days - days % 7) / 7;
	  }], ["days", dayDiff]];
	  var results = {};
	  var lowestOrder, highWater;
	
	  for (var _i = 0, _differs = differs; _i < _differs.length; _i++) {
	    var _differs$_i = _differs[_i],
	        unit = _differs$_i[0],
	        differ = _differs$_i[1];
	
	    if (units.indexOf(unit) >= 0) {
	      var _cursor$plus;
	
	      lowestOrder = unit;
	      var delta = differ(cursor, later);
	      highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[unit] = delta, _cursor$plus));
	
	      if (highWater > later) {
	        var _cursor$plus2;
	
	        cursor = cursor.plus((_cursor$plus2 = {}, _cursor$plus2[unit] = delta - 1, _cursor$plus2));
	        delta -= 1;
	      } else {
	        cursor = highWater;
	      }
	
	      results[unit] = delta;
	    }
	  }
	
	  return [cursor, results, highWater, lowestOrder];
	}
	
	function _diff (earlier, later, units, opts) {
	  var _highOrderDiffs = highOrderDiffs(earlier, later, units),
	      cursor = _highOrderDiffs[0],
	      results = _highOrderDiffs[1],
	      highWater = _highOrderDiffs[2],
	      lowestOrder = _highOrderDiffs[3];
	
	  var remainingMillis = later - cursor;
	  var lowerOrderUnits = units.filter(function (u) {
	    return ["hours", "minutes", "seconds", "milliseconds"].indexOf(u) >= 0;
	  });
	
	  if (lowerOrderUnits.length === 0) {
	    if (highWater < later) {
	      var _cursor$plus3;
	
	      highWater = cursor.plus((_cursor$plus3 = {}, _cursor$plus3[lowestOrder] = 1, _cursor$plus3));
	    }
	
	    if (highWater !== cursor) {
	      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
	    }
	  }
	
	  var duration = Duration.fromObject(Object.assign(results, opts));
	
	  if (lowerOrderUnits.length > 0) {
	    var _Duration$fromMillis;
	
	    return (_Duration$fromMillis = Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
	  } else {
	    return duration;
	  }
	}
	
	var numberingSystems = {
	  arab: "[\u0660-\u0669]",
	  arabext: "[\u06F0-\u06F9]",
	  bali: "[\u1B50-\u1B59]",
	  beng: "[\u09E6-\u09EF]",
	  deva: "[\u0966-\u096F]",
	  fullwide: "[\uFF10-\uFF19]",
	  gujr: "[\u0AE6-\u0AEF]",
	  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
	  khmr: "[\u17E0-\u17E9]",
	  knda: "[\u0CE6-\u0CEF]",
	  laoo: "[\u0ED0-\u0ED9]",
	  limb: "[\u1946-\u194F]",
	  mlym: "[\u0D66-\u0D6F]",
	  mong: "[\u1810-\u1819]",
	  mymr: "[\u1040-\u1049]",
	  orya: "[\u0B66-\u0B6F]",
	  tamldec: "[\u0BE6-\u0BEF]",
	  telu: "[\u0C66-\u0C6F]",
	  thai: "[\u0E50-\u0E59]",
	  tibt: "[\u0F20-\u0F29]",
	  latn: "\\d"
	};
	var numberingSystemsUTF16 = {
	  arab: [1632, 1641],
	  arabext: [1776, 1785],
	  bali: [6992, 7001],
	  beng: [2534, 2543],
	  deva: [2406, 2415],
	  fullwide: [65296, 65303],
	  gujr: [2790, 2799],
	  khmr: [6112, 6121],
	  knda: [3302, 3311],
	  laoo: [3792, 3801],
	  limb: [6470, 6479],
	  mlym: [3430, 3439],
	  mong: [6160, 6169],
	  mymr: [4160, 4169],
	  orya: [2918, 2927],
	  tamldec: [3046, 3055],
	  telu: [3174, 3183],
	  thai: [3664, 3673],
	  tibt: [3872, 3881]
	}; // eslint-disable-next-line
	
	var hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
	function parseDigits(str) {
	  var value = parseInt(str, 10);
	
	  if (isNaN(value)) {
	    value = "";
	
	    for (var i = 0; i < str.length; i++) {
	      var code = str.charCodeAt(i);
	
	      if (str[i].search(numberingSystems.hanidec) !== -1) {
	        value += hanidecChars.indexOf(str[i]);
	      } else {
	        for (var key in numberingSystemsUTF16) {
	          var _numberingSystemsUTF = numberingSystemsUTF16[key],
	              min = _numberingSystemsUTF[0],
	              max = _numberingSystemsUTF[1];
	
	          if (code >= min && code <= max) {
	            value += code - min;
	          }
	        }
	      }
	    }
	
	    return parseInt(value, 10);
	  } else {
	    return value;
	  }
	}
	function digitRegex(_ref, append) {
	  var numberingSystem = _ref.numberingSystem;
	
	  if (append === void 0) {
	    append = "";
	  }
	
	  return new RegExp("" + numberingSystems[numberingSystem || "latn"] + append);
	}
	
	var MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
	
	function intUnit(regex, post) {
	  if (post === void 0) {
	    post = function post(i) {
	      return i;
	    };
	  }
	
	  return {
	    regex: regex,
	    deser: function deser(_ref) {
	      var s = _ref[0];
	      return post(parseDigits(s));
	    }
	  };
	}
	
	function fixListRegex(s) {
	  // make dots optional and also make them literal
	  return s.replace(/\./, "\\.?");
	}
	
	function stripInsensitivities(s) {
	  return s.replace(/\./, "").toLowerCase();
	}
	
	function oneOf(strings, startIndex) {
	  if (strings === null) {
	    return null;
	  } else {
	    return {
	      regex: RegExp(strings.map(fixListRegex).join("|")),
	      deser: function deser(_ref2) {
	        var s = _ref2[0];
	        return strings.findIndex(function (i) {
	          return stripInsensitivities(s) === stripInsensitivities(i);
	        }) + startIndex;
	      }
	    };
	  }
	}
	
	function offset(regex, groups) {
	  return {
	    regex: regex,
	    deser: function deser(_ref3) {
	      var h = _ref3[1],
	          m = _ref3[2];
	      return signedOffset(h, m);
	    },
	    groups: groups
	  };
	}
	
	function simple(regex) {
	  return {
	    regex: regex,
	    deser: function deser(_ref4) {
	      var s = _ref4[0];
	      return s;
	    }
	  };
	}
	
	function escapeToken(value) {
	  // eslint-disable-next-line no-useless-escape
	  return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
	}
	
	function unitForToken(token, loc) {
	  var one = digitRegex(loc),
	      two = digitRegex(loc, "{2}"),
	      three = digitRegex(loc, "{3}"),
	      four = digitRegex(loc, "{4}"),
	      six = digitRegex(loc, "{6}"),
	      oneOrTwo = digitRegex(loc, "{1,2}"),
	      oneToThree = digitRegex(loc, "{1,3}"),
	      oneToSix = digitRegex(loc, "{1,6}"),
	      oneToNine = digitRegex(loc, "{1,9}"),
	      twoToFour = digitRegex(loc, "{2,4}"),
	      fourToSix = digitRegex(loc, "{4,6}"),
	      literal = function literal(t) {
	    return {
	      regex: RegExp(escapeToken(t.val)),
	      deser: function deser(_ref5) {
	        var s = _ref5[0];
	        return s;
	      },
	      literal: true
	    };
	  },
	      unitate = function unitate(t) {
	    if (token.literal) {
	      return literal(t);
	    }
	
	    switch (t.val) {
	      // era
	      case "G":
	        return oneOf(loc.eras("short", false), 0);
	
	      case "GG":
	        return oneOf(loc.eras("long", false), 0);
	      // years
	
	      case "y":
	        return intUnit(oneToSix);
	
	      case "yy":
	        return intUnit(twoToFour, untruncateYear);
	
	      case "yyyy":
	        return intUnit(four);
	
	      case "yyyyy":
	        return intUnit(fourToSix);
	
	      case "yyyyyy":
	        return intUnit(six);
	      // months
	
	      case "M":
	        return intUnit(oneOrTwo);
	
	      case "MM":
	        return intUnit(two);
	
	      case "MMM":
	        return oneOf(loc.months("short", true, false), 1);
	
	      case "MMMM":
	        return oneOf(loc.months("long", true, false), 1);
	
	      case "L":
	        return intUnit(oneOrTwo);
	
	      case "LL":
	        return intUnit(two);
	
	      case "LLL":
	        return oneOf(loc.months("short", false, false), 1);
	
	      case "LLLL":
	        return oneOf(loc.months("long", false, false), 1);
	      // dates
	
	      case "d":
	        return intUnit(oneOrTwo);
	
	      case "dd":
	        return intUnit(two);
	      // ordinals
	
	      case "o":
	        return intUnit(oneToThree);
	
	      case "ooo":
	        return intUnit(three);
	      // time
	
	      case "HH":
	        return intUnit(two);
	
	      case "H":
	        return intUnit(oneOrTwo);
	
	      case "hh":
	        return intUnit(two);
	
	      case "h":
	        return intUnit(oneOrTwo);
	
	      case "mm":
	        return intUnit(two);
	
	      case "m":
	        return intUnit(oneOrTwo);
	
	      case "q":
	        return intUnit(oneOrTwo);
	
	      case "qq":
	        return intUnit(two);
	
	      case "s":
	        return intUnit(oneOrTwo);
	
	      case "ss":
	        return intUnit(two);
	
	      case "S":
	        return intUnit(oneToThree);
	
	      case "SSS":
	        return intUnit(three);
	
	      case "u":
	        return simple(oneToNine);
	      // meridiem
	
	      case "a":
	        return oneOf(loc.meridiems(), 0);
	      // weekYear (k)
	
	      case "kkkk":
	        return intUnit(four);
	
	      case "kk":
	        return intUnit(twoToFour, untruncateYear);
	      // weekNumber (W)
	
	      case "W":
	        return intUnit(oneOrTwo);
	
	      case "WW":
	        return intUnit(two);
	      // weekdays
	
	      case "E":
	      case "c":
	        return intUnit(one);
	
	      case "EEE":
	        return oneOf(loc.weekdays("short", false, false), 1);
	
	      case "EEEE":
	        return oneOf(loc.weekdays("long", false, false), 1);
	
	      case "ccc":
	        return oneOf(loc.weekdays("short", true, false), 1);
	
	      case "cccc":
	        return oneOf(loc.weekdays("long", true, false), 1);
	      // offset/zone
	
	      case "Z":
	      case "ZZ":
	        return offset(new RegExp("([+-]" + oneOrTwo.source + ")(?::(" + two.source + "))?"), 2);
	
	      case "ZZZ":
	        return offset(new RegExp("([+-]" + oneOrTwo.source + ")(" + two.source + ")?"), 2);
	      // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
	      // because we don't have any way to figure out what they are
	
	      case "z":
	        return simple(/[a-z_+-/]{1,256}?/i);
	
	      default:
	        return literal(t);
	    }
	  };
	
	  var unit = unitate(token) || {
	    invalidReason: MISSING_FTP
	  };
	  unit.token = token;
	  return unit;
	}
	
	var partTypeStyleToTokenVal = {
	  year: {
	    "2-digit": "yy",
	    numeric: "yyyyy"
	  },
	  month: {
	    numeric: "M",
	    "2-digit": "MM",
	    short: "MMM",
	    long: "MMMM"
	  },
	  day: {
	    numeric: "d",
	    "2-digit": "dd"
	  },
	  weekday: {
	    short: "EEE",
	    long: "EEEE"
	  },
	  dayperiod: "a",
	  hour: {
	    numeric: "h",
	    "2-digit": "hh"
	  },
	  minute: {
	    numeric: "m",
	    "2-digit": "mm"
	  },
	  second: {
	    numeric: "s",
	    "2-digit": "ss"
	  }
	};
	
	function tokenForPart(part, locale, formatOpts) {
	  var type = part.type,
	      value = part.value;
	
	  if (type === "literal") {
	    return {
	      literal: true,
	      val: value
	    };
	  }
	
	  var style = formatOpts[type];
	  var val = partTypeStyleToTokenVal[type];
	
	  if (typeof val === "object") {
	    val = val[style];
	  }
	
	  if (val) {
	    return {
	      literal: false,
	      val: val
	    };
	  }
	
	  return undefined;
	}
	
	function buildRegex(units) {
	  var re = units.map(function (u) {
	    return u.regex;
	  }).reduce(function (f, r) {
	    return f + "(" + r.source + ")";
	  }, "");
	  return ["^" + re + "$", units];
	}
	
	function match(input, regex, handlers) {
	  var matches = input.match(regex);
	
	  if (matches) {
	    var all = {};
	    var matchIndex = 1;
	
	    for (var i in handlers) {
	      if (hasOwnProperty(handlers, i)) {
	        var h = handlers[i],
	            groups = h.groups ? h.groups + 1 : 1;
	
	        if (!h.literal && h.token) {
	          all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
	        }
	
	        matchIndex += groups;
	      }
	    }
	
	    return [matches, all];
	  } else {
	    return [matches, {}];
	  }
	}
	
	function dateTimeFromMatches(matches) {
	  var toField = function toField(token) {
	    switch (token) {
	      case "S":
	        return "millisecond";
	
	      case "s":
	        return "second";
	
	      case "m":
	        return "minute";
	
	      case "h":
	      case "H":
	        return "hour";
	
	      case "d":
	        return "day";
	
	      case "o":
	        return "ordinal";
	
	      case "L":
	      case "M":
	        return "month";
	
	      case "y":
	        return "year";
	
	      case "E":
	      case "c":
	        return "weekday";
	
	      case "W":
	        return "weekNumber";
	
	      case "k":
	        return "weekYear";
	
	      case "q":
	        return "quarter";
	
	      default:
	        return null;
	    }
	  };
	
	  var zone;
	
	  if (!isUndefined(matches.Z)) {
	    zone = new FixedOffsetZone(matches.Z);
	  } else if (!isUndefined(matches.z)) {
	    zone = IANAZone.create(matches.z);
	  } else {
	    zone = null;
	  }
	
	  if (!isUndefined(matches.q)) {
	    matches.M = (matches.q - 1) * 3 + 1;
	  }
	
	  if (!isUndefined(matches.h)) {
	    if (matches.h < 12 && matches.a === 1) {
	      matches.h += 12;
	    } else if (matches.h === 12 && matches.a === 0) {
	      matches.h = 0;
	    }
	  }
	
	  if (matches.G === 0 && matches.y) {
	    matches.y = -matches.y;
	  }
	
	  if (!isUndefined(matches.u)) {
	    matches.S = parseMillis(matches.u);
	  }
	
	  var vals = Object.keys(matches).reduce(function (r, k) {
	    var f = toField(k);
	
	    if (f) {
	      r[f] = matches[k];
	    }
	
	    return r;
	  }, {});
	  return [vals, zone];
	}
	
	var dummyDateTimeCache = null;
	
	function getDummyDateTime() {
	  if (!dummyDateTimeCache) {
	    dummyDateTimeCache = DateTime.fromMillis(1555555555555);
	  }
	
	  return dummyDateTimeCache;
	}
	
	function maybeExpandMacroToken(token, locale) {
	  if (token.literal) {
	    return token;
	  }
	
	  var formatOpts = Formatter.macroTokenToFormatOpts(token.val);
	
	  if (!formatOpts) {
	    return token;
	  }
	
	  var formatter = Formatter.create(locale, formatOpts);
	  var parts = formatter.formatDateTimeParts(getDummyDateTime());
	  var tokens = parts.map(function (p) {
	    return tokenForPart(p, locale, formatOpts);
	  });
	
	  if (tokens.includes(undefined)) {
	    return token;
	  }
	
	  return tokens;
	}
	
	function expandMacroTokens(tokens, locale) {
	  var _Array$prototype;
	
	  return (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, tokens.map(function (t) {
	    return maybeExpandMacroToken(t, locale);
	  }));
	}
	/**
	 * @private
	 */
	
	
	function explainFromTokens(locale, input, format) {
	  var tokens = expandMacroTokens(Formatter.parseFormat(format), locale),
	      units = tokens.map(function (t) {
	    return unitForToken(t, locale);
	  }),
	      disqualifyingUnit = units.find(function (t) {
	    return t.invalidReason;
	  });
	
	  if (disqualifyingUnit) {
	    return {
	      input: input,
	      tokens: tokens,
	      invalidReason: disqualifyingUnit.invalidReason
	    };
	  } else {
	    var _buildRegex = buildRegex(units),
	        regexString = _buildRegex[0],
	        handlers = _buildRegex[1],
	        regex = RegExp(regexString, "i"),
	        _match = match(input, regex, handlers),
	        rawMatches = _match[0],
	        matches = _match[1],
	        _ref6 = matches ? dateTimeFromMatches(matches) : [null, null],
	        result = _ref6[0],
	        zone = _ref6[1];
	
	    return {
	      input: input,
	      tokens: tokens,
	      regex: regex,
	      rawMatches: rawMatches,
	      matches: matches,
	      result: result,
	      zone: zone
	    };
	  }
	}
	function parseFromTokens(locale, input, format) {
	  var _explainFromTokens = explainFromTokens(locale, input, format),
	      result = _explainFromTokens.result,
	      zone = _explainFromTokens.zone,
	      invalidReason = _explainFromTokens.invalidReason;
	
	  return [result, zone, invalidReason];
	}
	
	var nonLeapLadder = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334],
	    leapLadder = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
	
	function unitOutOfRange(unit, value) {
	  return new Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
	}
	
	function dayOfWeek(year, month, day) {
	  var js = new Date(Date.UTC(year, month - 1, day)).getUTCDay();
	  return js === 0 ? 7 : js;
	}
	
	function computeOrdinal(year, month, day) {
	  return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
	}
	
	function uncomputeOrdinal(year, ordinal) {
	  var table = isLeapYear(year) ? leapLadder : nonLeapLadder,
	      month0 = table.findIndex(function (i) {
	    return i < ordinal;
	  }),
	      day = ordinal - table[month0];
	  return {
	    month: month0 + 1,
	    day: day
	  };
	}
	/**
	 * @private
	 */
	
	
	function gregorianToWeek(gregObj) {
	  var year = gregObj.year,
	      month = gregObj.month,
	      day = gregObj.day,
	      ordinal = computeOrdinal(year, month, day),
	      weekday = dayOfWeek(year, month, day);
	  var weekNumber = Math.floor((ordinal - weekday + 10) / 7),
	      weekYear;
	
	  if (weekNumber < 1) {
	    weekYear = year - 1;
	    weekNumber = weeksInWeekYear(weekYear);
	  } else if (weekNumber > weeksInWeekYear(year)) {
	    weekYear = year + 1;
	    weekNumber = 1;
	  } else {
	    weekYear = year;
	  }
	
	  return Object.assign({
	    weekYear: weekYear,
	    weekNumber: weekNumber,
	    weekday: weekday
	  }, timeObject(gregObj));
	}
	function weekToGregorian(weekData) {
	  var weekYear = weekData.weekYear,
	      weekNumber = weekData.weekNumber,
	      weekday = weekData.weekday,
	      weekdayOfJan4 = dayOfWeek(weekYear, 1, 4),
	      yearInDays = daysInYear(weekYear);
	  var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 3,
	      year;
	
	  if (ordinal < 1) {
	    year = weekYear - 1;
	    ordinal += daysInYear(year);
	  } else if (ordinal > yearInDays) {
	    year = weekYear + 1;
	    ordinal -= daysInYear(weekYear);
	  } else {
	    year = weekYear;
	  }
	
	  var _uncomputeOrdinal = uncomputeOrdinal(year, ordinal),
	      month = _uncomputeOrdinal.month,
	      day = _uncomputeOrdinal.day;
	
	  return Object.assign({
	    year: year,
	    month: month,
	    day: day
	  }, timeObject(weekData));
	}
	function gregorianToOrdinal(gregData) {
	  var year = gregData.year,
	      month = gregData.month,
	      day = gregData.day,
	      ordinal = computeOrdinal(year, month, day);
	  return Object.assign({
	    year: year,
	    ordinal: ordinal
	  }, timeObject(gregData));
	}
	function ordinalToGregorian(ordinalData) {
	  var year = ordinalData.year,
	      ordinal = ordinalData.ordinal,
	      _uncomputeOrdinal2 = uncomputeOrdinal(year, ordinal),
	      month = _uncomputeOrdinal2.month,
	      day = _uncomputeOrdinal2.day;
	
	  return Object.assign({
	    year: year,
	    month: month,
	    day: day
	  }, timeObject(ordinalData));
	}
	function hasInvalidWeekData(obj) {
	  var validYear = isInteger(obj.weekYear),
	      validWeek = integerBetween(obj.weekNumber, 1, weeksInWeekYear(obj.weekYear)),
	      validWeekday = integerBetween(obj.weekday, 1, 7);
	
	  if (!validYear) {
	    return unitOutOfRange("weekYear", obj.weekYear);
	  } else if (!validWeek) {
	    return unitOutOfRange("week", obj.week);
	  } else if (!validWeekday) {
	    return unitOutOfRange("weekday", obj.weekday);
	  } else return false;
	}
	function hasInvalidOrdinalData(obj) {
	  var validYear = isInteger(obj.year),
	      validOrdinal = integerBetween(obj.ordinal, 1, daysInYear(obj.year));
	
	  if (!validYear) {
	    return unitOutOfRange("year", obj.year);
	  } else if (!validOrdinal) {
	    return unitOutOfRange("ordinal", obj.ordinal);
	  } else return false;
	}
	function hasInvalidGregorianData(obj) {
	  var validYear = isInteger(obj.year),
	      validMonth = integerBetween(obj.month, 1, 12),
	      validDay = integerBetween(obj.day, 1, daysInMonth(obj.year, obj.month));
	
	  if (!validYear) {
	    return unitOutOfRange("year", obj.year);
	  } else if (!validMonth) {
	    return unitOutOfRange("month", obj.month);
	  } else if (!validDay) {
	    return unitOutOfRange("day", obj.day);
	  } else return false;
	}
	function hasInvalidTimeData(obj) {
	  var hour = obj.hour,
	      minute = obj.minute,
	      second = obj.second,
	      millisecond = obj.millisecond;
	  var validHour = integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0,
	      validMinute = integerBetween(minute, 0, 59),
	      validSecond = integerBetween(second, 0, 59),
	      validMillisecond = integerBetween(millisecond, 0, 999);
	
	  if (!validHour) {
	    return unitOutOfRange("hour", hour);
	  } else if (!validMinute) {
	    return unitOutOfRange("minute", minute);
	  } else if (!validSecond) {
	    return unitOutOfRange("second", second);
	  } else if (!validMillisecond) {
	    return unitOutOfRange("millisecond", millisecond);
	  } else return false;
	}
	
	var INVALID$2 = "Invalid DateTime";
	var MAX_DATE = 8.64e15;
	
	function unsupportedZone(zone) {
	  return new Invalid("unsupported zone", "the zone \"" + zone.name + "\" is not supported");
	} // we cache week data on the DT object and this intermediates the cache
	
	
	function possiblyCachedWeekData(dt) {
	  if (dt.weekData === null) {
	    dt.weekData = gregorianToWeek(dt.c);
	  }
	
	  return dt.weekData;
	} // clone really means, "make a new object with these modifications". all "setters" really use this
	// to create a new object while only changing some of the properties
	
	
	function clone$1(inst, alts) {
	  var current = {
	    ts: inst.ts,
	    zone: inst.zone,
	    c: inst.c,
	    o: inst.o,
	    loc: inst.loc,
	    invalid: inst.invalid
	  };
	  return new DateTime(Object.assign({}, current, alts, {
	    old: current
	  }));
	} // find the right offset a given local time. The o input is our guess, which determines which
	// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
	
	
	function fixOffset(localTS, o, tz) {
	  // Our UTC time is just a guess because our offset is just a guess
	  var utcGuess = localTS - o * 60 * 1000; // Test whether the zone matches the offset for this ts
	
	  var o2 = tz.offset(utcGuess); // If so, offset didn't change and we're done
	
	  if (o === o2) {
	    return [utcGuess, o];
	  } // If not, change the ts by the difference in the offset
	
	
	  utcGuess -= (o2 - o) * 60 * 1000; // If that gives us the local time we want, we're done
	
	  var o3 = tz.offset(utcGuess);
	
	  if (o2 === o3) {
	    return [utcGuess, o2];
	  } // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
	
	
	  return [localTS - Math.min(o2, o3) * 60 * 1000, Math.max(o2, o3)];
	} // convert an epoch timestamp into a calendar object with the given offset
	
	
	function tsToObj(ts, offset) {
	  ts += offset * 60 * 1000;
	  var d = new Date(ts);
	  return {
	    year: d.getUTCFullYear(),
	    month: d.getUTCMonth() + 1,
	    day: d.getUTCDate(),
	    hour: d.getUTCHours(),
	    minute: d.getUTCMinutes(),
	    second: d.getUTCSeconds(),
	    millisecond: d.getUTCMilliseconds()
	  };
	} // convert a calendar object to a epoch timestamp
	
	
	function objToTS(obj, offset, zone) {
	  return fixOffset(objToLocalTS(obj), offset, zone);
	} // create a new DT instance by adding a duration, adjusting for DSTs
	
	
	function adjustTime(inst, dur) {
	  var _dur;
	
	  var keys = Object.keys(dur.values);
	
	  if (keys.indexOf("milliseconds") === -1) {
	    keys.push("milliseconds");
	  }
	
	  dur = (_dur = dur).shiftTo.apply(_dur, keys);
	  var oPre = inst.o,
	      year = inst.c.year + dur.years,
	      month = inst.c.month + dur.months + dur.quarters * 3,
	      c = Object.assign({}, inst.c, {
	    year: year,
	    month: month,
	    day: Math.min(inst.c.day, daysInMonth(year, month)) + dur.days + dur.weeks * 7
	  }),
	      millisToAdd = Duration.fromObject({
	    hours: dur.hours,
	    minutes: dur.minutes,
	    seconds: dur.seconds,
	    milliseconds: dur.milliseconds
	  }).as("milliseconds"),
	      localTS = objToLocalTS(c);
	
	  var _fixOffset = fixOffset(localTS, oPre, inst.zone),
	      ts = _fixOffset[0],
	      o = _fixOffset[1];
	
	  if (millisToAdd !== 0) {
	    ts += millisToAdd; // that could have changed the offset by going over a DST, but we want to keep the ts the same
	
	    o = inst.zone.offset(ts);
	  }
	
	  return {
	    ts: ts,
	    o: o
	  };
	} // helper useful in turning the results of parsing into real dates
	// by handling the zone options
	
	
	function parseDataToDateTime(parsed, parsedZone, opts, format, text) {
	  var setZone = opts.setZone,
	      zone = opts.zone;
	
	  if (parsed && Object.keys(parsed).length !== 0) {
	    var interpretationZone = parsedZone || zone,
	        inst = DateTime.fromObject(Object.assign(parsed, opts, {
	      zone: interpretationZone,
	      // setZone is a valid option in the calling methods, but not in fromObject
	      setZone: undefined
	    }));
	    return setZone ? inst : inst.setZone(zone);
	  } else {
	    return DateTime.invalid(new Invalid("unparsable", "the input \"" + text + "\" can't be parsed as " + format));
	  }
	} // if you want to output a technical format (e.g. RFC 2822), this helper
	// helps handle the details
	
	
	function toTechFormat(dt, format) {
	  return dt.isValid ? Formatter.create(Locale.create("en-US"), {
	    allowZ: true,
	    forceSimple: true
	  }).formatDateTimeFromString(dt, format) : null;
	} // technical time formats (e.g. the time part of ISO 8601), take some options
	// and this commonizes their handling
	
	
	function toTechTimeFormat(dt, _ref) {
	  var _ref$suppressSeconds = _ref.suppressSeconds,
	      suppressSeconds = _ref$suppressSeconds === void 0 ? false : _ref$suppressSeconds,
	      _ref$suppressMillisec = _ref.suppressMilliseconds,
	      suppressMilliseconds = _ref$suppressMillisec === void 0 ? false : _ref$suppressMillisec,
	      includeOffset = _ref.includeOffset,
	      _ref$includeZone = _ref.includeZone,
	      includeZone = _ref$includeZone === void 0 ? false : _ref$includeZone,
	      _ref$spaceZone = _ref.spaceZone,
	      spaceZone = _ref$spaceZone === void 0 ? false : _ref$spaceZone;
	  var fmt = "HH:mm";
	
	  if (!suppressSeconds || dt.second !== 0 || dt.millisecond !== 0) {
	    fmt += ":ss";
	
	    if (!suppressMilliseconds || dt.millisecond !== 0) {
	      fmt += ".SSS";
	    }
	  }
	
	  if ((includeZone || includeOffset) && spaceZone) {
	    fmt += " ";
	  }
	
	  if (includeZone) {
	    fmt += "z";
	  } else if (includeOffset) {
	    fmt += "ZZ";
	  }
	
	  return toTechFormat(dt, fmt);
	} // defaults for unspecified units in the supported calendars
	
	
	var defaultUnitValues = {
	  month: 1,
	  day: 1,
	  hour: 0,
	  minute: 0,
	  second: 0,
	  millisecond: 0
	},
	    defaultWeekUnitValues = {
	  weekNumber: 1,
	  weekday: 1,
	  hour: 0,
	  minute: 0,
	  second: 0,
	  millisecond: 0
	},
	    defaultOrdinalUnitValues = {
	  ordinal: 1,
	  hour: 0,
	  minute: 0,
	  second: 0,
	  millisecond: 0
	}; // Units in the supported calendars, sorted by bigness
	
	var orderedUnits$1 = ["year", "month", "day", "hour", "minute", "second", "millisecond"],
	    orderedWeekUnits = ["weekYear", "weekNumber", "weekday", "hour", "minute", "second", "millisecond"],
	    orderedOrdinalUnits = ["year", "ordinal", "hour", "minute", "second", "millisecond"]; // standardize case and plurality in units
	
	function normalizeUnit(unit) {
	  var normalized = {
	    year: "year",
	    years: "year",
	    month: "month",
	    months: "month",
	    day: "day",
	    days: "day",
	    hour: "hour",
	    hours: "hour",
	    minute: "minute",
	    minutes: "minute",
	    quarter: "quarter",
	    quarters: "quarter",
	    second: "second",
	    seconds: "second",
	    millisecond: "millisecond",
	    milliseconds: "millisecond",
	    weekday: "weekday",
	    weekdays: "weekday",
	    weeknumber: "weekNumber",
	    weeksnumber: "weekNumber",
	    weeknumbers: "weekNumber",
	    weekyear: "weekYear",
	    weekyears: "weekYear",
	    ordinal: "ordinal"
	  }[unit.toLowerCase()];
	  if (!normalized) throw new InvalidUnitError(unit);
	  return normalized;
	} // this is a dumbed down version of fromObject() that runs about 60% faster
	// but doesn't do any validation, makes a bunch of assumptions about what units
	// are present, and so on.
	
	
	function quickDT(obj, zone) {
	  // assume we have the higher-order units
	  for (var _iterator = orderedUnits$1, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	    var _ref2;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref2 = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref2 = _i.value;
	    }
	
	    var u = _ref2;
	
	    if (isUndefined(obj[u])) {
	      obj[u] = defaultUnitValues[u];
	    }
	  }
	
	  var invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);
	
	  if (invalid) {
	    return DateTime.invalid(invalid);
	  }
	
	  var tsNow = Settings.now(),
	      offsetProvis = zone.offset(tsNow),
	      _objToTS = objToTS(obj, offsetProvis, zone),
	      ts = _objToTS[0],
	      o = _objToTS[1];
	
	  return new DateTime({
	    ts: ts,
	    zone: zone,
	    o: o
	  });
	}
	
	function diffRelative(start, end, opts) {
	  var round = isUndefined(opts.round) ? true : opts.round,
	      format = function format(c, unit) {
	    c = roundTo(c, round || opts.calendary ? 0 : 2, true);
	    var formatter = end.loc.clone(opts).relFormatter(opts);
	    return formatter.format(c, unit);
	  },
	      differ = function differ(unit) {
	    if (opts.calendary) {
	      if (!end.hasSame(start, unit)) {
	        return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
	      } else return 0;
	    } else {
	      return end.diff(start, unit).get(unit);
	    }
	  };
	
	  if (opts.unit) {
	    return format(differ(opts.unit), opts.unit);
	  }
	
	  for (var _iterator2 = opts.units, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	    var _ref3;
	
	    if (_isArray2) {
	      if (_i2 >= _iterator2.length) break;
	      _ref3 = _iterator2[_i2++];
	    } else {
	      _i2 = _iterator2.next();
	      if (_i2.done) break;
	      _ref3 = _i2.value;
	    }
	
	    var unit = _ref3;
	    var count = differ(unit);
	
	    if (Math.abs(count) >= 1) {
	      return format(count, unit);
	    }
	  }
	
	  return format(0, opts.units[opts.units.length - 1]);
	}
	/**
	 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
	 *
	 * A DateTime comprises of:
	 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
	 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
	 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
	 *
	 * Here is a brief overview of the most commonly used functionality it provides:
	 *
	 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link local}, {@link utc}, and (most flexibly) {@link fromObject}. To create one from a standard string format, use {@link fromISO}, {@link fromHTTP}, and {@link fromRFC2822}. To create one from a custom string format, use {@link fromFormat}. To create one from a native JS date, use {@link fromJSDate}.
	 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link toObject}), use the {@link year}, {@link month},
	 * {@link day}, {@link hour}, {@link minute}, {@link second}, {@link millisecond} accessors.
	 * * **Week calendar**: For ISO week calendar attributes, see the {@link weekYear}, {@link weekNumber}, and {@link weekday} accessors.
	 * * **Configuration** See the {@link locale} and {@link numberingSystem} accessors.
	 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link set}, {@link reconfigure}, {@link setZone}, {@link setLocale}, {@link plus}, {@link minus}, {@link endOf}, {@link startOf}, {@link toUTC}, and {@link toLocal}.
	 * * **Output**: To convert the DateTime to other representations, use the {@link toRelative}, {@link toRelativeCalendar}, {@link toJSON}, {@link toISO}, {@link toHTTP}, {@link toObject}, {@link toRFC2822}, {@link toString}, {@link toLocaleString}, {@link toFormat}, {@link toMillis} and {@link toJSDate}.
	 *
	 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
	 */
	
	
	var DateTime =
	/*#__PURE__*/
	function () {
	  /**
	   * @access private
	   */
	  function DateTime(config) {
	    var zone = config.zone || Settings.defaultZone;
	    var invalid = config.invalid || (Number.isNaN(config.ts) ? new Invalid("invalid input") : null) || (!zone.isValid ? unsupportedZone(zone) : null);
	    /**
	     * @access private
	     */
	
	    this.ts = isUndefined(config.ts) ? Settings.now() : config.ts;
	    var c = null,
	        o = null;
	
	    if (!invalid) {
	      var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
	
	      if (unchanged) {
	        var _ref4 = [config.old.c, config.old.o];
	        c = _ref4[0];
	        o = _ref4[1];
	      } else {
	        c = tsToObj(this.ts, zone.offset(this.ts));
	        invalid = Number.isNaN(c.year) ? new Invalid("invalid input") : null;
	        c = invalid ? null : c;
	        o = invalid ? null : zone.offset(this.ts);
	      }
	    }
	    /**
	     * @access private
	     */
	
	
	    this._zone = zone;
	    /**
	     * @access private
	     */
	
	    this.loc = config.loc || Locale.create();
	    /**
	     * @access private
	     */
	
	    this.invalid = invalid;
	    /**
	     * @access private
	     */
	
	    this.weekData = null;
	    /**
	     * @access private
	     */
	
	    this.c = c;
	    /**
	     * @access private
	     */
	
	    this.o = o;
	    /**
	     * @access private
	     */
	
	    this.isLuxonDateTime = true;
	  } // CONSTRUCT
	
	  /**
	   * Create a local DateTime
	   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
	   * @param {number} [month=1] - The month, 1-indexed
	   * @param {number} [day=1] - The day of the month
	   * @param {number} [hour=0] - The hour of the day, in 24-hour time
	   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
	   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
	   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
	   * @example DateTime.local()                            //~> now
	   * @example DateTime.local(2017)                        //~> 2017-01-01T00:00:00
	   * @example DateTime.local(2017, 3)                     //~> 2017-03-01T00:00:00
	   * @example DateTime.local(2017, 3, 12)                 //~> 2017-03-12T00:00:00
	   * @example DateTime.local(2017, 3, 12, 5)              //~> 2017-03-12T05:00:00
	   * @example DateTime.local(2017, 3, 12, 5, 45)          //~> 2017-03-12T05:45:00
	   * @example DateTime.local(2017, 3, 12, 5, 45, 10)      //~> 2017-03-12T05:45:10
	   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765) //~> 2017-03-12T05:45:10.765
	   * @return {DateTime}
	   */
	
	
	  DateTime.local = function local(year, month, day, hour, minute, second, millisecond) {
	    if (isUndefined(year)) {
	      return new DateTime({
	        ts: Settings.now()
	      });
	    } else {
	      return quickDT({
	        year: year,
	        month: month,
	        day: day,
	        hour: hour,
	        minute: minute,
	        second: second,
	        millisecond: millisecond
	      }, Settings.defaultZone);
	    }
	  }
	  /**
	   * Create a DateTime in UTC
	   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
	   * @param {number} [month=1] - The month, 1-indexed
	   * @param {number} [day=1] - The day of the month
	   * @param {number} [hour=0] - The hour of the day, in 24-hour time
	   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
	   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
	   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
	   * @example DateTime.utc()                            //~> now
	   * @example DateTime.utc(2017)                        //~> 2017-01-01T00:00:00Z
	   * @example DateTime.utc(2017, 3)                     //~> 2017-03-01T00:00:00Z
	   * @example DateTime.utc(2017, 3, 12)                 //~> 2017-03-12T00:00:00Z
	   * @example DateTime.utc(2017, 3, 12, 5)              //~> 2017-03-12T05:00:00Z
	   * @example DateTime.utc(2017, 3, 12, 5, 45)          //~> 2017-03-12T05:45:00Z
	   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)      //~> 2017-03-12T05:45:10Z
	   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765) //~> 2017-03-12T05:45:10.765Z
	   * @return {DateTime}
	   */
	  ;
	
	  DateTime.utc = function utc(year, month, day, hour, minute, second, millisecond) {
	    if (isUndefined(year)) {
	      return new DateTime({
	        ts: Settings.now(),
	        zone: FixedOffsetZone.utcInstance
	      });
	    } else {
	      return quickDT({
	        year: year,
	        month: month,
	        day: day,
	        hour: hour,
	        minute: minute,
	        second: second,
	        millisecond: millisecond
	      }, FixedOffsetZone.utcInstance);
	    }
	  }
	  /**
	   * Create a DateTime from a Javascript Date object. Uses the default zone.
	   * @param {Date} date - a Javascript Date object
	   * @param {Object} options - configuration options for the DateTime
	   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
	   * @return {DateTime}
	   */
	  ;
	
	  DateTime.fromJSDate = function fromJSDate(date, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    var ts = isDate(date) ? date.valueOf() : NaN;
	
	    if (Number.isNaN(ts)) {
	      return DateTime.invalid("invalid input");
	    }
	
	    var zoneToUse = normalizeZone(options.zone, Settings.defaultZone);
	
	    if (!zoneToUse.isValid) {
	      return DateTime.invalid(unsupportedZone(zoneToUse));
	    }
	
	    return new DateTime({
	      ts: ts,
	      zone: zoneToUse,
	      loc: Locale.fromObject(options)
	    });
	  }
	  /**
	   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
	   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
	   * @param {Object} options - configuration options for the DateTime
	   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
	   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
	   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
	   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
	   * @return {DateTime}
	   */
	  ;
	
	  DateTime.fromMillis = function fromMillis(milliseconds, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (!isNumber(milliseconds)) {
	      throw new InvalidArgumentError("fromMillis requires a numerical input");
	    } else if (milliseconds < -MAX_DATE || milliseconds > MAX_DATE) {
	      // this isn't perfect because because we can still end up out of range because of additional shifting, but it's a start
	      return DateTime.invalid("Timestamp out of range");
	    } else {
	      return new DateTime({
	        ts: milliseconds,
	        zone: normalizeZone(options.zone, Settings.defaultZone),
	        loc: Locale.fromObject(options)
	      });
	    }
	  }
	  /**
	   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
	   * @param {number} seconds - a number of seconds since 1970 UTC
	   * @param {Object} options - configuration options for the DateTime
	   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
	   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
	   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
	   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
	   * @return {DateTime}
	   */
	  ;
	
	  DateTime.fromSeconds = function fromSeconds(seconds, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (!isNumber(seconds)) {
	      throw new InvalidArgumentError("fromSeconds requires a numerical input");
	    } else {
	      return new DateTime({
	        ts: seconds * 1000,
	        zone: normalizeZone(options.zone, Settings.defaultZone),
	        loc: Locale.fromObject(options)
	      });
	    }
	  }
	  /**
	   * Create a DateTime from a Javascript object with keys like 'year' and 'hour' with reasonable defaults.
	   * @param {Object} obj - the object to create the DateTime from
	   * @param {number} obj.year - a year, such as 1987
	   * @param {number} obj.month - a month, 1-12
	   * @param {number} obj.day - a day of the month, 1-31, depending on the month
	   * @param {number} obj.ordinal - day of the year, 1-365 or 366
	   * @param {number} obj.weekYear - an ISO week year
	   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
	   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
	   * @param {number} obj.hour - hour of the day, 0-23
	   * @param {number} obj.minute - minute of the hour, 0-59
	   * @param {number} obj.second - second of the minute, 0-59
	   * @param {number} obj.millisecond - millisecond of the second, 0-999
	   * @param {string|Zone} [obj.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
	   * @param {string} [obj.locale='system's locale'] - a locale to set on the resulting DateTime instance
	   * @param {string} obj.outputCalendar - the output calendar to set on the resulting DateTime instance
	   * @param {string} obj.numberingSystem - the numbering system to set on the resulting DateTime instance
	   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
	   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
	   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
	   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6, zone: 'utc' }),
	   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6, zone: 'local' })
	   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6, zone: 'America/New_York' })
	   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
	   * @return {DateTime}
	   */
	  ;
	
	  DateTime.fromObject = function fromObject(obj) {
	    var zoneToUse = normalizeZone(obj.zone, Settings.defaultZone);
	
	    if (!zoneToUse.isValid) {
	      return DateTime.invalid(unsupportedZone(zoneToUse));
	    }
	
	    var tsNow = Settings.now(),
	        offsetProvis = zoneToUse.offset(tsNow),
	        normalized = normalizeObject(obj, normalizeUnit, ["zone", "locale", "outputCalendar", "numberingSystem"]),
	        containsOrdinal = !isUndefined(normalized.ordinal),
	        containsGregorYear = !isUndefined(normalized.year),
	        containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day),
	        containsGregor = containsGregorYear || containsGregorMD,
	        definiteWeekDef = normalized.weekYear || normalized.weekNumber,
	        loc = Locale.fromObject(obj); // cases:
	    // just a weekday -> this week's instance of that weekday, no worries
	    // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
	    // (gregorian month or day) + ordinal -> error
	    // otherwise just use weeks or ordinals or gregorian, depending on what's specified
	
	    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
	      throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
	    }
	
	    if (containsGregorMD && containsOrdinal) {
	      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
	    }
	
	    var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor; // configure ourselves to deal with gregorian dates or week stuff
	
	    var units,
	        defaultValues,
	        objNow = tsToObj(tsNow, offsetProvis);
	
	    if (useWeekData) {
	      units = orderedWeekUnits;
	      defaultValues = defaultWeekUnitValues;
	      objNow = gregorianToWeek(objNow);
	    } else if (containsOrdinal) {
	      units = orderedOrdinalUnits;
	      defaultValues = defaultOrdinalUnitValues;
	      objNow = gregorianToOrdinal(objNow);
	    } else {
	      units = orderedUnits$1;
	      defaultValues = defaultUnitValues;
	    } // set default values for missing stuff
	
	
	    var foundFirst = false;
	
	    for (var _iterator3 = units, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
	      var _ref5;
	
	      if (_isArray3) {
	        if (_i3 >= _iterator3.length) break;
	        _ref5 = _iterator3[_i3++];
	      } else {
	        _i3 = _iterator3.next();
	        if (_i3.done) break;
	        _ref5 = _i3.value;
	      }
	
	      var u = _ref5;
	      var v = normalized[u];
	
	      if (!isUndefined(v)) {
	        foundFirst = true;
	      } else if (foundFirst) {
	        normalized[u] = defaultValues[u];
	      } else {
	        normalized[u] = objNow[u];
	      }
	    } // make sure the values we have are in range
	
	
	    var higherOrderInvalid = useWeekData ? hasInvalidWeekData(normalized) : containsOrdinal ? hasInvalidOrdinalData(normalized) : hasInvalidGregorianData(normalized),
	        invalid = higherOrderInvalid || hasInvalidTimeData(normalized);
	
	    if (invalid) {
	      return DateTime.invalid(invalid);
	    } // compute the actual time
	
	
	    var gregorian = useWeekData ? weekToGregorian(normalized) : containsOrdinal ? ordinalToGregorian(normalized) : normalized,
	        _objToTS2 = objToTS(gregorian, offsetProvis, zoneToUse),
	        tsFinal = _objToTS2[0],
	        offsetFinal = _objToTS2[1],
	        inst = new DateTime({
	      ts: tsFinal,
	      zone: zoneToUse,
	      o: offsetFinal,
	      loc: loc
	    }); // gregorian data + weekday serves only to validate
	
	
	    if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) {
	      return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
	    }
	
	    return inst;
	  }
	  /**
	   * Create a DateTime from an ISO 8601 string
	   * @param {string} text - the ISO string
	   * @param {Object} opts - options to affect the creation
	   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
	   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
	   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
	   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
	   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
	   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
	   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
	   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
	   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
	   * @example DateTime.fromISO('2016-W05-4')
	   * @return {DateTime}
	   */
	  ;
	
	  DateTime.fromISO = function fromISO(text, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    var _parseISODate = parseISODate(text),
	        vals = _parseISODate[0],
	        parsedZone = _parseISODate[1];
	
	    return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
	  }
	  /**
	   * Create a DateTime from an RFC 2822 string
	   * @param {string} text - the RFC 2822 string
	   * @param {Object} opts - options to affect the creation
	   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
	   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
	   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
	   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
	   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
	   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
	   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
	   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
	   * @return {DateTime}
	   */
	  ;
	
	  DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    var _parseRFC2822Date = parseRFC2822Date(text),
	        vals = _parseRFC2822Date[0],
	        parsedZone = _parseRFC2822Date[1];
	
	    return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
	  }
	  /**
	   * Create a DateTime from an HTTP header date
	   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
	   * @param {string} text - the HTTP header date
	   * @param {Object} opts - options to affect the creation
	   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
	   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
	   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
	   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
	   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
	   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
	   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
	   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
	   * @return {DateTime}
	   */
	  ;
	
	  DateTime.fromHTTP = function fromHTTP(text, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    var _parseHTTPDate = parseHTTPDate(text),
	        vals = _parseHTTPDate[0],
	        parsedZone = _parseHTTPDate[1];
	
	    return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
	  }
	  /**
	   * Create a DateTime from an input string and format string.
	   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
	   * @see https://moment.github.io/luxon/docs/manual/parsing.html#table-of-tokens
	   * @param {string} text - the string to parse
	   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
	   * @param {Object} opts - options to affect the creation
	   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
	   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
	   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
	   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
	   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
	   * @return {DateTime}
	   */
	  ;
	
	  DateTime.fromFormat = function fromFormat(text, fmt, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    if (isUndefined(text) || isUndefined(fmt)) {
	      throw new InvalidArgumentError("fromFormat requires an input string and a format");
	    }
	
	    var _opts = opts,
	        _opts$locale = _opts.locale,
	        locale = _opts$locale === void 0 ? null : _opts$locale,
	        _opts$numberingSystem = _opts.numberingSystem,
	        numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem,
	        localeToUse = Locale.fromOpts({
	      locale: locale,
	      numberingSystem: numberingSystem,
	      defaultToEN: true
	    }),
	        _parseFromTokens = parseFromTokens(localeToUse, text, fmt),
	        vals = _parseFromTokens[0],
	        parsedZone = _parseFromTokens[1],
	        invalid = _parseFromTokens[2];
	
	    if (invalid) {
	      return DateTime.invalid(invalid);
	    } else {
	      return parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text);
	    }
	  }
	  /**
	   * @deprecated use fromFormat instead
	   */
	  ;
	
	  DateTime.fromString = function fromString(text, fmt, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    return DateTime.fromFormat(text, fmt, opts);
	  }
	  /**
	   * Create a DateTime from a SQL date, time, or datetime
	   * Defaults to en-US if no locale has been specified, regardless of the system's locale
	   * @param {string} text - the string to parse
	   * @param {Object} opts - options to affect the creation
	   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
	   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
	   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
	   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
	   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
	   * @example DateTime.fromSQL('2017-05-15')
	   * @example DateTime.fromSQL('2017-05-15 09:12:34')
	   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
	   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
	   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
	   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
	   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
	   * @example DateTime.fromSQL('09:12:34.342')
	   * @return {DateTime}
	   */
	  ;
	
	  DateTime.fromSQL = function fromSQL(text, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    var _parseSQL = parseSQL(text),
	        vals = _parseSQL[0],
	        parsedZone = _parseSQL[1];
	
	    return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
	  }
	  /**
	   * Create an invalid DateTime.
	   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent
	   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
	   * @return {DateTime}
	   */
	  ;
	
	  DateTime.invalid = function invalid(reason, explanation) {
	    if (explanation === void 0) {
	      explanation = null;
	    }
	
	    if (!reason) {
	      throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
	    }
	
	    var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
	
	    if (Settings.throwOnInvalid) {
	      throw new InvalidDateTimeError(invalid);
	    } else {
	      return new DateTime({
	        invalid: invalid
	      });
	    }
	  }
	  /**
	   * Check if an object is a DateTime. Works across context boundaries
	   * @param {object} o
	   * @return {boolean}
	   */
	  ;
	
	  DateTime.isDateTime = function isDateTime(o) {
	    return o && o.isLuxonDateTime || false;
	  } // INFO
	
	  /**
	   * Get the value of unit.
	   * @param {string} unit - a unit such as 'minute' or 'day'
	   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
	   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
	   * @return {number}
	   */
	  ;
	
	  var _proto = DateTime.prototype;
	
	  _proto.get = function get(unit) {
	    return this[unit];
	  }
	  /**
	   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
	   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
	   * * The DateTime was created by an operation on another invalid date
	   * @type {boolean}
	   */
	  ;
	
	  /**
	   * Returns the resolved Intl options for this DateTime.
	   * This is useful in understanding the behavior of formatting methods
	   * @param {Object} opts - the same options as toLocaleString
	   * @return {Object}
	   */
	  _proto.resolvedLocaleOpts = function resolvedLocaleOpts(opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    var _Formatter$create$res = Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this),
	        locale = _Formatter$create$res.locale,
	        numberingSystem = _Formatter$create$res.numberingSystem,
	        calendar = _Formatter$create$res.calendar;
	
	    return {
	      locale: locale,
	      numberingSystem: numberingSystem,
	      outputCalendar: calendar
	    };
	  } // TRANSFORM
	
	  /**
	   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
	   *
	   * Equivalent to {@link setZone}('utc')
	   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
	   * @param {Object} [opts={}] - options to pass to `setZone()`
	   * @return {DateTime}
	   */
	  ;
	
	  _proto.toUTC = function toUTC(offset, opts) {
	    if (offset === void 0) {
	      offset = 0;
	    }
	
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    return this.setZone(FixedOffsetZone.instance(offset), opts);
	  }
	  /**
	   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
	   *
	   * Equivalent to `setZone('local')`
	   * @return {DateTime}
	   */
	  ;
	
	  _proto.toLocal = function toLocal() {
	    return this.setZone(Settings.defaultZone);
	  }
	  /**
	   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
	   *
	   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link plus}. You may wish to use {@link toLocal} and {@link toUTC} which provide simple convenience wrappers for commonly used zones.
	   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link Zone} class.
	   * @param {Object} opts - options
	   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
	   * @return {DateTime}
	   */
	  ;
	
	  _proto.setZone = function setZone(zone, _temp) {
	    var _ref6 = _temp === void 0 ? {} : _temp,
	        _ref6$keepLocalTime = _ref6.keepLocalTime,
	        keepLocalTime = _ref6$keepLocalTime === void 0 ? false : _ref6$keepLocalTime,
	        _ref6$keepCalendarTim = _ref6.keepCalendarTime,
	        keepCalendarTime = _ref6$keepCalendarTim === void 0 ? false : _ref6$keepCalendarTim;
	
	    zone = normalizeZone(zone, Settings.defaultZone);
	
	    if (zone.equals(this.zone)) {
	      return this;
	    } else if (!zone.isValid) {
	      return DateTime.invalid(unsupportedZone(zone));
	    } else {
	      var newTS = this.ts;
	
	      if (keepLocalTime || keepCalendarTime) {
	        var offsetGuess = this.o - zone.offset(this.ts);
	        var asObj = this.toObject();
	
	        var _objToTS3 = objToTS(asObj, offsetGuess, zone);
	
	        newTS = _objToTS3[0];
	      }
	
	      return clone$1(this, {
	        ts: newTS,
	        zone: zone
	      });
	    }
	  }
	  /**
	   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
	   * @param {Object} properties - the properties to set
	   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
	   * @return {DateTime}
	   */
	  ;
	
	  _proto.reconfigure = function reconfigure(_temp2) {
	    var _ref7 = _temp2 === void 0 ? {} : _temp2,
	        locale = _ref7.locale,
	        numberingSystem = _ref7.numberingSystem,
	        outputCalendar = _ref7.outputCalendar;
	
	    var loc = this.loc.clone({
	      locale: locale,
	      numberingSystem: numberingSystem,
	      outputCalendar: outputCalendar
	    });
	    return clone$1(this, {
	      loc: loc
	    });
	  }
	  /**
	   * "Set" the locale. Returns a newly-constructed DateTime.
	   * Just a convenient alias for reconfigure({ locale })
	   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
	   * @return {DateTime}
	   */
	  ;
	
	  _proto.setLocale = function setLocale(locale) {
	    return this.reconfigure({
	      locale: locale
	    });
	  }
	  /**
	   * "Set" the values of specified units. Returns a newly-constructed DateTime.
	   * You can only set units with this method; for "setting" metadata, see {@link reconfigure} and {@link setZone}.
	   * @param {Object} values - a mapping of units to numbers
	   * @example dt.set({ year: 2017 })
	   * @example dt.set({ hour: 8, minute: 30 })
	   * @example dt.set({ weekday: 5 })
	   * @example dt.set({ year: 2005, ordinal: 234 })
	   * @return {DateTime}
	   */
	  ;
	
	  _proto.set = function set(values) {
	    if (!this.isValid) return this;
	    var normalized = normalizeObject(values, normalizeUnit, []),
	        settingWeekStuff = !isUndefined(normalized.weekYear) || !isUndefined(normalized.weekNumber) || !isUndefined(normalized.weekday);
	    var mixed;
	
	    if (settingWeekStuff) {
	      mixed = weekToGregorian(Object.assign(gregorianToWeek(this.c), normalized));
	    } else if (!isUndefined(normalized.ordinal)) {
	      mixed = ordinalToGregorian(Object.assign(gregorianToOrdinal(this.c), normalized));
	    } else {
	      mixed = Object.assign(this.toObject(), normalized); // if we didn't set the day but we ended up on an overflow date,
	      // use the last day of the right month
	
	      if (isUndefined(normalized.day)) {
	        mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
	      }
	    }
	
	    var _objToTS4 = objToTS(mixed, this.o, this.zone),
	        ts = _objToTS4[0],
	        o = _objToTS4[1];
	
	    return clone$1(this, {
	      ts: ts,
	      o: o
	    });
	  }
	  /**
	   * Add a period of time to this DateTime and return the resulting DateTime
	   *
	   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
	   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
	   * @example DateTime.local().plus(123) //~> in 123 milliseconds
	   * @example DateTime.local().plus({ minutes: 15 }) //~> in 15 minutes
	   * @example DateTime.local().plus({ days: 1 }) //~> this time tomorrow
	   * @example DateTime.local().plus({ days: -1 }) //~> this time yesterday
	   * @example DateTime.local().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
	   * @example DateTime.local().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
	   * @return {DateTime}
	   */
	  ;
	
	  _proto.plus = function plus(duration) {
	    if (!this.isValid) return this;
	    var dur = friendlyDuration(duration);
	    return clone$1(this, adjustTime(this, dur));
	  }
	  /**
	   * Subtract a period of time to this DateTime and return the resulting DateTime
	   * See {@link plus}
	   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
	   @return {DateTime}
	  */
	  ;
	
	  _proto.minus = function minus(duration) {
	    if (!this.isValid) return this;
	    var dur = friendlyDuration(duration).negate();
	    return clone$1(this, adjustTime(this, dur));
	  }
	  /**
	   * "Set" this DateTime to the beginning of a unit of time.
	   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
	   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
	   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
	   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
	   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
	   * @return {DateTime}
	   */
	  ;
	
	  _proto.startOf = function startOf(unit) {
	    if (!this.isValid) return this;
	    var o = {},
	        normalizedUnit = Duration.normalizeUnit(unit);
	
	    switch (normalizedUnit) {
	      case "years":
	        o.month = 1;
	      // falls through
	
	      case "quarters":
	      case "months":
	        o.day = 1;
	      // falls through
	
	      case "weeks":
	      case "days":
	        o.hour = 0;
	      // falls through
	
	      case "hours":
	        o.minute = 0;
	      // falls through
	
	      case "minutes":
	        o.second = 0;
	      // falls through
	
	      case "seconds":
	        o.millisecond = 0;
	        break;
	
	      case "milliseconds":
	        break;
	      // no default, invalid units throw in normalizeUnit()
	    }
	
	    if (normalizedUnit === "weeks") {
	      o.weekday = 1;
	    }
	
	    if (normalizedUnit === "quarters") {
	      var q = Math.ceil(this.month / 3);
	      o.month = (q - 1) * 3 + 1;
	    }
	
	    return this.set(o);
	  }
	  /**
	   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
	   * @param {string} unit - The unit to go to the end of. Can be 'year', 'month', 'day', 'hour', 'minute', 'second', or 'millisecond'.
	   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
	   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
	   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
	   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
	   * @return {DateTime}
	   */
	  ;
	
	  _proto.endOf = function endOf(unit) {
	    var _this$plus;
	
	    return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit).minus(1) : this;
	  } // OUTPUT
	
	  /**
	   * Returns a string representation of this DateTime formatted according to the specified format string.
	   * **You may not want this.** See {@link toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/docs/manual/formatting.html#table-of-tokens).
	   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
	   * @see https://moment.github.io/luxon/docs/manual/formatting.html#table-of-tokens
	   * @param {string} fmt - the format string
	   * @param {Object} opts - opts to override the configuration options
	   * @example DateTime.local().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
	   * @example DateTime.local().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
	   * @example DateTime.local().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
	   * @example DateTime.local().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
	   * @return {string}
	   */
	  ;
	
	  _proto.toFormat = function toFormat(fmt, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    return this.isValid ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : INVALID$2;
	  }
	  /**
	   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
	   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
	   * of the DateTime in the assigned locale.
	   * Defaults to the system's locale if no locale has been specified
	   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
	   * @param opts {Object} - Intl.DateTimeFormat constructor options and configuration options
	   * @example DateTime.local().toLocaleString(); //=> 4/20/2017
	   * @example DateTime.local().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
	   * @example DateTime.local().toLocaleString({ locale: 'en-gb' }); //=> '20/04/2017'
	   * @example DateTime.local().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
	   * @example DateTime.local().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
	   * @example DateTime.local().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
	   * @example DateTime.local().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
	   * @example DateTime.local().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
	   * @example DateTime.local().toLocaleString({ hour: '2-digit', minute: '2-digit', hour12: false }); //=> '11:32'
	   * @return {string}
	   */
	  ;
	
	  _proto.toLocaleString = function toLocaleString(opts) {
	    if (opts === void 0) {
	      opts = DATE_SHORT;
	    }
	
	    return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTime(this) : INVALID$2;
	  }
	  /**
	   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
	   * Defaults to the system's locale if no locale has been specified
	   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
	   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
	   * @example DateTime.local().toLocaleString(); //=> [
	   *                                    //=>   { type: 'day', value: '25' },
	   *                                    //=>   { type: 'literal', value: '/' },
	   *                                    //=>   { type: 'month', value: '05' },
	   *                                    //=>   { type: 'literal', value: '/' },
	   *                                    //=>   { type: 'year', value: '1982' }
	   *                                    //=> ]
	   */
	  ;
	
	  _proto.toLocaleParts = function toLocaleParts(opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
	  }
	  /**
	   * Returns an ISO 8601-compliant string representation of this DateTime
	   * @param {Object} opts - options
	   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
	   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
	   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
	   * @example DateTime.utc(1982, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
	   * @example DateTime.local().toISO() //=> '2017-04-22T20:47:05.335-04:00'
	   * @example DateTime.local().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
	   * @return {string}
	   */
	  ;
	
	  _proto.toISO = function toISO(opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    if (!this.isValid) {
	      return null;
	    }
	
	    return this.toISODate() + "T" + this.toISOTime(opts);
	  }
	  /**
	   * Returns an ISO 8601-compliant string representation of this DateTime's date component
	   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
	   * @return {string}
	   */
	  ;
	
	  _proto.toISODate = function toISODate() {
	    var format = "yyyy-MM-dd";
	
	    if (this.year > 9999) {
	      format = "+" + format;
	    }
	
	    return toTechFormat(this, format);
	  }
	  /**
	   * Returns an ISO 8601-compliant string representation of this DateTime's week date
	   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
	   * @return {string}
	   */
	  ;
	
	  _proto.toISOWeekDate = function toISOWeekDate() {
	    return toTechFormat(this, "kkkk-'W'WW-c");
	  }
	  /**
	   * Returns an ISO 8601-compliant string representation of this DateTime's time component
	   * @param {Object} opts - options
	   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
	   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
	   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
	   * @example DateTime.utc().hour(7).minute(34).toISOTime() //=> '07:34:19.361Z'
	   * @example DateTime.utc().hour(7).minute(34).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
	   * @return {string}
	   */
	  ;
	
	  _proto.toISOTime = function toISOTime(_temp3) {
	    var _ref8 = _temp3 === void 0 ? {} : _temp3,
	        _ref8$suppressMillise = _ref8.suppressMilliseconds,
	        suppressMilliseconds = _ref8$suppressMillise === void 0 ? false : _ref8$suppressMillise,
	        _ref8$suppressSeconds = _ref8.suppressSeconds,
	        suppressSeconds = _ref8$suppressSeconds === void 0 ? false : _ref8$suppressSeconds,
	        _ref8$includeOffset = _ref8.includeOffset,
	        includeOffset = _ref8$includeOffset === void 0 ? true : _ref8$includeOffset;
	
	    return toTechTimeFormat(this, {
	      suppressSeconds: suppressSeconds,
	      suppressMilliseconds: suppressMilliseconds,
	      includeOffset: includeOffset
	    });
	  }
	  /**
	   * Returns an RFC 2822-compatible string representation of this DateTime, always in UTC
	   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
	   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
	   * @return {string}
	   */
	  ;
	
	  _proto.toRFC2822 = function toRFC2822() {
	    return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ");
	  }
	  /**
	   * Returns a string representation of this DateTime appropriate for use in HTTP headers.
	   * Specifically, the string conforms to RFC 1123.
	   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
	   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
	   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
	   * @return {string}
	   */
	  ;
	
	  _proto.toHTTP = function toHTTP() {
	    return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
	  }
	  /**
	   * Returns a string representation of this DateTime appropriate for use in SQL Date
	   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
	   * @return {string}
	   */
	  ;
	
	  _proto.toSQLDate = function toSQLDate() {
	    return toTechFormat(this, "yyyy-MM-dd");
	  }
	  /**
	   * Returns a string representation of this DateTime appropriate for use in SQL Time
	   * @param {Object} opts - options
	   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
	   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
	   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
	   * @example DateTime.local().toSQL() //=> '05:15:16.345 -04:00'
	   * @example DateTime.local().toSQL({ includeOffset: false }) //=> '05:15:16.345'
	   * @example DateTime.local().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
	   * @return {string}
	   */
	  ;
	
	  _proto.toSQLTime = function toSQLTime(_temp4) {
	    var _ref9 = _temp4 === void 0 ? {} : _temp4,
	        _ref9$includeOffset = _ref9.includeOffset,
	        includeOffset = _ref9$includeOffset === void 0 ? true : _ref9$includeOffset,
	        _ref9$includeZone = _ref9.includeZone,
	        includeZone = _ref9$includeZone === void 0 ? false : _ref9$includeZone;
	
	    return toTechTimeFormat(this, {
	      includeOffset: includeOffset,
	      includeZone: includeZone,
	      spaceZone: true
	    });
	  }
	  /**
	   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
	   * @param {Object} opts - options
	   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
	   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
	   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
	   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
	   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
	   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
	   * @return {string}
	   */
	  ;
	
	  _proto.toSQL = function toSQL(opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    if (!this.isValid) {
	      return null;
	    }
	
	    return this.toSQLDate() + " " + this.toSQLTime(opts);
	  }
	  /**
	   * Returns a string representation of this DateTime appropriate for debugging
	   * @return {string}
	   */
	  ;
	
	  _proto.toString = function toString() {
	    return this.isValid ? this.toISO() : INVALID$2;
	  }
	  /**
	   * Returns the epoch milliseconds of this DateTime. Alias of {@link toMillis}
	   * @return {number}
	   */
	  ;
	
	  _proto.valueOf = function valueOf() {
	    return this.toMillis();
	  }
	  /**
	   * Returns the epoch milliseconds of this DateTime.
	   * @return {number}
	   */
	  ;
	
	  _proto.toMillis = function toMillis() {
	    return this.isValid ? this.ts : NaN;
	  }
	  /**
	   * Returns the epoch seconds of this DateTime.
	   * @return {number}
	   */
	  ;
	
	  _proto.toSeconds = function toSeconds() {
	    return this.isValid ? this.ts / 1000 : NaN;
	  }
	  /**
	   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
	   * @return {string}
	   */
	  ;
	
	  _proto.toJSON = function toJSON() {
	    return this.toISO();
	  }
	  /**
	   * Returns a BSON serializable equivalent to this DateTime.
	   * @return {Date}
	   */
	  ;
	
	  _proto.toBSON = function toBSON() {
	    return this.toJSDate();
	  }
	  /**
	   * Returns a Javascript object with this DateTime's year, month, day, and so on.
	   * @param opts - options for generating the object
	   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
	   * @example DateTime.local().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
	   * @return {Object}
	   */
	  ;
	
	  _proto.toObject = function toObject(opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    if (!this.isValid) return {};
	    var base = Object.assign({}, this.c);
	
	    if (opts.includeConfig) {
	      base.outputCalendar = this.outputCalendar;
	      base.numberingSystem = this.loc.numberingSystem;
	      base.locale = this.loc.locale;
	    }
	
	    return base;
	  }
	  /**
	   * Returns a Javascript Date equivalent to this DateTime.
	   * @return {Date}
	   */
	  ;
	
	  _proto.toJSDate = function toJSDate() {
	    return new Date(this.isValid ? this.ts : NaN);
	  } // COMPARE
	
	  /**
	   * Return the difference between two DateTimes as a Duration.
	   * @param {DateTime} otherDateTime - the DateTime to compare this one to
	   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
	   * @param {Object} opts - options that affect the creation of the Duration
	   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
	   * @example
	   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
	   *     i2 = DateTime.fromISO('1983-10-14T10:30');
	   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
	   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
	   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
	   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
	   * @return {Duration}
	   */
	  ;
	
	  _proto.diff = function diff(otherDateTime, unit, opts) {
	    if (unit === void 0) {
	      unit = "milliseconds";
	    }
	
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    if (!this.isValid || !otherDateTime.isValid) {
	      return Duration.invalid(this.invalid || otherDateTime.invalid, "created by diffing an invalid DateTime");
	    }
	
	    var durOpts = Object.assign({
	      locale: this.locale,
	      numberingSystem: this.numberingSystem
	    }, opts);
	
	    var units = maybeArray(unit).map(Duration.normalizeUnit),
	        otherIsLater = otherDateTime.valueOf() > this.valueOf(),
	        earlier = otherIsLater ? this : otherDateTime,
	        later = otherIsLater ? otherDateTime : this,
	        diffed = _diff(earlier, later, units, durOpts);
	
	    return otherIsLater ? diffed.negate() : diffed;
	  }
	  /**
	   * Return the difference between this DateTime and right now.
	   * See {@link diff}
	   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
	   * @param {Object} opts - options that affect the creation of the Duration
	   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
	   * @return {Duration}
	   */
	  ;
	
	  _proto.diffNow = function diffNow(unit, opts) {
	    if (unit === void 0) {
	      unit = "milliseconds";
	    }
	
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    return this.diff(DateTime.local(), unit, opts);
	  }
	  /**
	   * Return an Interval spanning between this DateTime and another DateTime
	   * @param {DateTime} otherDateTime - the other end point of the Interval
	   * @return {Interval}
	   */
	  ;
	
	  _proto.until = function until(otherDateTime) {
	    return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
	  }
	  /**
	   * Return whether this DateTime is in the same unit of time as another DateTime
	   * @param {DateTime} otherDateTime - the other DateTime
	   * @param {string} unit - the unit of time to check sameness on
	   * @example DateTime.local().hasSame(otherDT, 'day'); //~> true if both the same calendar day
	   * @return {boolean}
	   */
	  ;
	
	  _proto.hasSame = function hasSame(otherDateTime, unit) {
	    if (!this.isValid) return false;
	
	    if (unit === "millisecond") {
	      return this.valueOf() === otherDateTime.valueOf();
	    } else {
	      var inputMs = otherDateTime.valueOf();
	      return this.startOf(unit) <= inputMs && inputMs <= this.endOf(unit);
	    }
	  }
	  /**
	   * Equality check
	   * Two DateTimes are equal iff they represent the same millisecond, have the same zone and location, and are both valid.
	   * To compare just the millisecond values, use `+dt1 === +dt2`.
	   * @param {DateTime} other - the other DateTime
	   * @return {boolean}
	   */
	  ;
	
	  _proto.equals = function equals(other) {
	    return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
	  }
	  /**
	   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
	   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
	   * @param {Object} options - options that affect the output
	   * @param {DateTime} [options.base=DateTime.local()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
	   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
	   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
	   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
	   * @param {boolean} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
	   * @param {string} options.locale - override the locale of this DateTime
	   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
	   * @example DateTime.local().plus({ days: 1 }).toRelative() //=> "in 1 day"
	   * @example DateTime.local().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
	   * @example DateTime.local().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
	   * @example DateTime.local().minus({ days: 2 }).toRelative() //=> "2 days ago"
	   * @example DateTime.local().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
	   * @example DateTime.local().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
	   */
	  ;
	
	  _proto.toRelative = function toRelative(options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (!this.isValid) return null;
	    var base = options.base || DateTime.fromObject({
	      zone: this.zone
	    }),
	        padding = options.padding ? this < base ? -options.padding : options.padding : 0;
	    return diffRelative(base, this.plus(padding), Object.assign(options, {
	      numeric: "always",
	      units: ["years", "months", "days", "hours", "minutes", "seconds"]
	    }));
	  }
	  /**
	   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
	   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
	   * @param {Object} options - options that affect the output
	   * @param {DateTime} [options.base=DateTime.local()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
	   * @param {string} options.locale - override the locale of this DateTime
	   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
	   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
	   * @example DateTime.local().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
	   * @example DateTime.local().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
	   * @example DateTime.local().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
	   * @example DateTime.local().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
	   */
	  ;
	
	  _proto.toRelativeCalendar = function toRelativeCalendar(options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (!this.isValid) return null;
	    return diffRelative(options.base || DateTime.fromObject({
	      zone: this.zone
	    }), this, Object.assign(options, {
	      numeric: "auto",
	      units: ["years", "months", "days"],
	      calendary: true
	    }));
	  }
	  /**
	   * Return the min of several date times
	   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
	   * @return {DateTime} the min DateTime, or undefined if called with no argument
	   */
	  ;
	
	  DateTime.min = function min() {
	    for (var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++) {
	      dateTimes[_key] = arguments[_key];
	    }
	
	    if (!dateTimes.every(DateTime.isDateTime)) {
	      throw new InvalidArgumentError("min requires all arguments be DateTimes");
	    }
	
	    return bestBy(dateTimes, function (i) {
	      return i.valueOf();
	    }, Math.min);
	  }
	  /**
	   * Return the max of several date times
	   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
	   * @return {DateTime} the max DateTime, or undefined if called with no argument
	   */
	  ;
	
	  DateTime.max = function max() {
	    for (var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      dateTimes[_key2] = arguments[_key2];
	    }
	
	    if (!dateTimes.every(DateTime.isDateTime)) {
	      throw new InvalidArgumentError("max requires all arguments be DateTimes");
	    }
	
	    return bestBy(dateTimes, function (i) {
	      return i.valueOf();
	    }, Math.max);
	  } // MISC
	
	  /**
	   * Explain how a string would be parsed by fromFormat()
	   * @param {string} text - the string to parse
	   * @param {string} fmt - the format the string is expected to be in (see description)
	   * @param {Object} options - options taken by fromFormat()
	   * @return {Object}
	   */
	  ;
	
	  DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    var _options = options,
	        _options$locale = _options.locale,
	        locale = _options$locale === void 0 ? null : _options$locale,
	        _options$numberingSys = _options.numberingSystem,
	        numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys,
	        localeToUse = Locale.fromOpts({
	      locale: locale,
	      numberingSystem: numberingSystem,
	      defaultToEN: true
	    });
	    return explainFromTokens(localeToUse, text, fmt);
	  }
	  /**
	   * @deprecated use fromFormatExplain instead
	   */
	  ;
	
	  DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    return DateTime.fromFormatExplain(text, fmt, options);
	  } // FORMAT PRESETS
	
	  /**
	   * {@link toLocaleString} format like 10/14/1983
	   * @type {Object}
	   */
	  ;
	
	  _createClass(DateTime, [{
	    key: "isValid",
	    get: function get() {
	      return this.invalid === null;
	    }
	    /**
	     * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
	     * @type {string}
	     */
	
	  }, {
	    key: "invalidReason",
	    get: function get() {
	      return this.invalid ? this.invalid.reason : null;
	    }
	    /**
	     * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
	     * @type {string}
	     */
	
	  }, {
	    key: "invalidExplanation",
	    get: function get() {
	      return this.invalid ? this.invalid.explanation : null;
	    }
	    /**
	     * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
	     *
	     * @type {string}
	     */
	
	  }, {
	    key: "locale",
	    get: function get() {
	      return this.isValid ? this.loc.locale : null;
	    }
	    /**
	     * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
	     *
	     * @type {string}
	     */
	
	  }, {
	    key: "numberingSystem",
	    get: function get() {
	      return this.isValid ? this.loc.numberingSystem : null;
	    }
	    /**
	     * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
	     *
	     * @type {string}
	     */
	
	  }, {
	    key: "outputCalendar",
	    get: function get() {
	      return this.isValid ? this.loc.outputCalendar : null;
	    }
	    /**
	     * Get the time zone associated with this DateTime.
	     * @type {Zone}
	     */
	
	  }, {
	    key: "zone",
	    get: function get() {
	      return this._zone;
	    }
	    /**
	     * Get the name of the time zone.
	     * @type {string}
	     */
	
	  }, {
	    key: "zoneName",
	    get: function get() {
	      return this.isValid ? this.zone.name : null;
	    }
	    /**
	     * Get the year
	     * @example DateTime.local(2017, 5, 25).year //=> 2017
	     * @type {number}
	     */
	
	  }, {
	    key: "year",
	    get: function get() {
	      return this.isValid ? this.c.year : NaN;
	    }
	    /**
	     * Get the quarter
	     * @example DateTime.local(2017, 5, 25).quarter //=> 2
	     * @type {number}
	     */
	
	  }, {
	    key: "quarter",
	    get: function get() {
	      return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
	    }
	    /**
	     * Get the month (1-12).
	     * @example DateTime.local(2017, 5, 25).month //=> 5
	     * @type {number}
	     */
	
	  }, {
	    key: "month",
	    get: function get() {
	      return this.isValid ? this.c.month : NaN;
	    }
	    /**
	     * Get the day of the month (1-30ish).
	     * @example DateTime.local(2017, 5, 25).day //=> 25
	     * @type {number}
	     */
	
	  }, {
	    key: "day",
	    get: function get() {
	      return this.isValid ? this.c.day : NaN;
	    }
	    /**
	     * Get the hour of the day (0-23).
	     * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
	     * @type {number}
	     */
	
	  }, {
	    key: "hour",
	    get: function get() {
	      return this.isValid ? this.c.hour : NaN;
	    }
	    /**
	     * Get the minute of the hour (0-59).
	     * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
	     * @type {number}
	     */
	
	  }, {
	    key: "minute",
	    get: function get() {
	      return this.isValid ? this.c.minute : NaN;
	    }
	    /**
	     * Get the second of the minute (0-59).
	     * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
	     * @type {number}
	     */
	
	  }, {
	    key: "second",
	    get: function get() {
	      return this.isValid ? this.c.second : NaN;
	    }
	    /**
	     * Get the millisecond of the second (0-999).
	     * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
	     * @type {number}
	     */
	
	  }, {
	    key: "millisecond",
	    get: function get() {
	      return this.isValid ? this.c.millisecond : NaN;
	    }
	    /**
	     * Get the week year
	     * @see https://en.wikipedia.org/wiki/ISO_week_date
	     * @example DateTime.local(2014, 11, 31).weekYear //=> 2015
	     * @type {number}
	     */
	
	  }, {
	    key: "weekYear",
	    get: function get() {
	      return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
	    }
	    /**
	     * Get the week number of the week year (1-52ish).
	     * @see https://en.wikipedia.org/wiki/ISO_week_date
	     * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
	     * @type {number}
	     */
	
	  }, {
	    key: "weekNumber",
	    get: function get() {
	      return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
	    }
	    /**
	     * Get the day of the week.
	     * 1 is Monday and 7 is Sunday
	     * @see https://en.wikipedia.org/wiki/ISO_week_date
	     * @example DateTime.local(2014, 11, 31).weekday //=> 4
	     * @type {number}
	     */
	
	  }, {
	    key: "weekday",
	    get: function get() {
	      return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
	    }
	    /**
	     * Get the ordinal (meaning the day of the year)
	     * @example DateTime.local(2017, 5, 25).ordinal //=> 145
	     * @type {number|DateTime}
	     */
	
	  }, {
	    key: "ordinal",
	    get: function get() {
	      return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
	    }
	    /**
	     * Get the human readable short month name, such as 'Oct'.
	     * Defaults to the system's locale if no locale has been specified
	     * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
	     * @type {string}
	     */
	
	  }, {
	    key: "monthShort",
	    get: function get() {
	      return this.isValid ? Info.months("short", {
	        locale: this.locale
	      })[this.month - 1] : null;
	    }
	    /**
	     * Get the human readable long month name, such as 'October'.
	     * Defaults to the system's locale if no locale has been specified
	     * @example DateTime.local(2017, 10, 30).monthLong //=> October
	     * @type {string}
	     */
	
	  }, {
	    key: "monthLong",
	    get: function get() {
	      return this.isValid ? Info.months("long", {
	        locale: this.locale
	      })[this.month - 1] : null;
	    }
	    /**
	     * Get the human readable short weekday, such as 'Mon'.
	     * Defaults to the system's locale if no locale has been specified
	     * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
	     * @type {string}
	     */
	
	  }, {
	    key: "weekdayShort",
	    get: function get() {
	      return this.isValid ? Info.weekdays("short", {
	        locale: this.locale
	      })[this.weekday - 1] : null;
	    }
	    /**
	     * Get the human readable long weekday, such as 'Monday'.
	     * Defaults to the system's locale if no locale has been specified
	     * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
	     * @type {string}
	     */
	
	  }, {
	    key: "weekdayLong",
	    get: function get() {
	      return this.isValid ? Info.weekdays("long", {
	        locale: this.locale
	      })[this.weekday - 1] : null;
	    }
	    /**
	     * Get the UTC offset of this DateTime in minutes
	     * @example DateTime.local().offset //=> -240
	     * @example DateTime.utc().offset //=> 0
	     * @type {number}
	     */
	
	  }, {
	    key: "offset",
	    get: function get() {
	      return this.isValid ? +this.o : NaN;
	    }
	    /**
	     * Get the short human name for the zone's current offset, for example "EST" or "EDT".
	     * Defaults to the system's locale if no locale has been specified
	     * @type {string}
	     */
	
	  }, {
	    key: "offsetNameShort",
	    get: function get() {
	      if (this.isValid) {
	        return this.zone.offsetName(this.ts, {
	          format: "short",
	          locale: this.locale
	        });
	      } else {
	        return null;
	      }
	    }
	    /**
	     * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
	     * Defaults to the system's locale if no locale has been specified
	     * @type {string}
	     */
	
	  }, {
	    key: "offsetNameLong",
	    get: function get() {
	      if (this.isValid) {
	        return this.zone.offsetName(this.ts, {
	          format: "long",
	          locale: this.locale
	        });
	      } else {
	        return null;
	      }
	    }
	    /**
	     * Get whether this zone's offset ever changes, as in a DST.
	     * @type {boolean}
	     */
	
	  }, {
	    key: "isOffsetFixed",
	    get: function get() {
	      return this.isValid ? this.zone.universal : null;
	    }
	    /**
	     * Get whether the DateTime is in a DST.
	     * @type {boolean}
	     */
	
	  }, {
	    key: "isInDST",
	    get: function get() {
	      if (this.isOffsetFixed) {
	        return false;
	      } else {
	        return this.offset > this.set({
	          month: 1
	        }).offset || this.offset > this.set({
	          month: 5
	        }).offset;
	      }
	    }
	    /**
	     * Returns true if this DateTime is in a leap year, false otherwise
	     * @example DateTime.local(2016).isInLeapYear //=> true
	     * @example DateTime.local(2013).isInLeapYear //=> false
	     * @type {boolean}
	     */
	
	  }, {
	    key: "isInLeapYear",
	    get: function get() {
	      return isLeapYear(this.year);
	    }
	    /**
	     * Returns the number of days in this DateTime's month
	     * @example DateTime.local(2016, 2).daysInMonth //=> 29
	     * @example DateTime.local(2016, 3).daysInMonth //=> 31
	     * @type {number}
	     */
	
	  }, {
	    key: "daysInMonth",
	    get: function get() {
	      return daysInMonth(this.year, this.month);
	    }
	    /**
	     * Returns the number of days in this DateTime's year
	     * @example DateTime.local(2016).daysInYear //=> 366
	     * @example DateTime.local(2013).daysInYear //=> 365
	     * @type {number}
	     */
	
	  }, {
	    key: "daysInYear",
	    get: function get() {
	      return this.isValid ? daysInYear(this.year) : NaN;
	    }
	    /**
	     * Returns the number of weeks in this DateTime's year
	     * @see https://en.wikipedia.org/wiki/ISO_week_date
	     * @example DateTime.local(2004).weeksInWeekYear //=> 53
	     * @example DateTime.local(2013).weeksInWeekYear //=> 52
	     * @type {number}
	     */
	
	  }, {
	    key: "weeksInWeekYear",
	    get: function get() {
	      return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
	    }
	  }], [{
	    key: "DATE_SHORT",
	    get: function get() {
	      return DATE_SHORT;
	    }
	    /**
	     * {@link toLocaleString} format like 'Oct 14, 1983'
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATE_MED",
	    get: function get() {
	      return DATE_MED;
	    }
	    /**
	     * {@link toLocaleString} format like 'October 14, 1983'
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATE_FULL",
	    get: function get() {
	      return DATE_FULL;
	    }
	    /**
	     * {@link toLocaleString} format like 'Tuesday, October 14, 1983'
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATE_HUGE",
	    get: function get() {
	      return DATE_HUGE;
	    }
	    /**
	     * {@link toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "TIME_SIMPLE",
	    get: function get() {
	      return TIME_SIMPLE;
	    }
	    /**
	     * {@link toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "TIME_WITH_SECONDS",
	    get: function get() {
	      return TIME_WITH_SECONDS;
	    }
	    /**
	     * {@link toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "TIME_WITH_SHORT_OFFSET",
	    get: function get() {
	      return TIME_WITH_SHORT_OFFSET;
	    }
	    /**
	     * {@link toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "TIME_WITH_LONG_OFFSET",
	    get: function get() {
	      return TIME_WITH_LONG_OFFSET;
	    }
	    /**
	     * {@link toLocaleString} format like '09:30', always 24-hour.
	     * @type {Object}
	     */
	
	  }, {
	    key: "TIME_24_SIMPLE",
	    get: function get() {
	      return TIME_24_SIMPLE;
	    }
	    /**
	     * {@link toLocaleString} format like '09:30:23', always 24-hour.
	     * @type {Object}
	     */
	
	  }, {
	    key: "TIME_24_WITH_SECONDS",
	    get: function get() {
	      return TIME_24_WITH_SECONDS;
	    }
	    /**
	     * {@link toLocaleString} format like '09:30:23 EDT', always 24-hour.
	     * @type {Object}
	     */
	
	  }, {
	    key: "TIME_24_WITH_SHORT_OFFSET",
	    get: function get() {
	      return TIME_24_WITH_SHORT_OFFSET;
	    }
	    /**
	     * {@link toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
	     * @type {Object}
	     */
	
	  }, {
	    key: "TIME_24_WITH_LONG_OFFSET",
	    get: function get() {
	      return TIME_24_WITH_LONG_OFFSET;
	    }
	    /**
	     * {@link toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATETIME_SHORT",
	    get: function get() {
	      return DATETIME_SHORT;
	    }
	    /**
	     * {@link toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATETIME_SHORT_WITH_SECONDS",
	    get: function get() {
	      return DATETIME_SHORT_WITH_SECONDS;
	    }
	    /**
	     * {@link toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATETIME_MED",
	    get: function get() {
	      return DATETIME_MED;
	    }
	    /**
	     * {@link toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATETIME_MED_WITH_SECONDS",
	    get: function get() {
	      return DATETIME_MED_WITH_SECONDS;
	    }
	    /**
	     * {@link toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATETIME_MED_WITH_WEEKDAY",
	    get: function get() {
	      return DATETIME_MED_WITH_WEEKDAY;
	    }
	    /**
	     * {@link toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATETIME_FULL",
	    get: function get() {
	      return DATETIME_FULL;
	    }
	    /**
	     * {@link toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATETIME_FULL_WITH_SECONDS",
	    get: function get() {
	      return DATETIME_FULL_WITH_SECONDS;
	    }
	    /**
	     * {@link toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATETIME_HUGE",
	    get: function get() {
	      return DATETIME_HUGE;
	    }
	    /**
	     * {@link toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATETIME_HUGE_WITH_SECONDS",
	    get: function get() {
	      return DATETIME_HUGE_WITH_SECONDS;
	    }
	  }]);
	
	  return DateTime;
	}();
	function friendlyDateTime(dateTimeish) {
	  if (DateTime.isDateTime(dateTimeish)) {
	    return dateTimeish;
	  } else if (dateTimeish && dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) {
	    return DateTime.fromJSDate(dateTimeish);
	  } else if (dateTimeish && typeof dateTimeish === "object") {
	    return DateTime.fromObject(dateTimeish);
	  } else {
	    throw new InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
	  }
	}
	
	exports.DateTime = DateTime;
	exports.Duration = Duration;
	exports.FixedOffsetZone = FixedOffsetZone;
	exports.IANAZone = IANAZone;
	exports.Info = Info;
	exports.Interval = Interval;
	exports.InvalidZone = InvalidZone;
	exports.LocalZone = LocalZone;
	exports.Settings = Settings;
	exports.Zone = Zone;
	//# sourceMappingURL=luxon.js.map


/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var getNanoSeconds, hrtime, loadTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(231)))

/***/ },
/* 499 */
/***/ function(module, exports) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	var isArray = Array.isArray;
	
	var hexTable = (function () {
	    var array = [];
	    for (var i = 0; i < 256; ++i) {
	        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
	    }
	
	    return array;
	}());
	
	var compactQueue = function compactQueue(queue) {
	    while (queue.length > 1) {
	        var item = queue.pop();
	        var obj = item.obj[item.prop];
	
	        if (isArray(obj)) {
	            var compacted = [];
	
	            for (var j = 0; j < obj.length; ++j) {
	                if (typeof obj[j] !== 'undefined') {
	                    compacted.push(obj[j]);
	                }
	            }
	
	            item.obj[item.prop] = compacted;
	        }
	    }
	};
	
	var arrayToObject = function arrayToObject(source, options) {
	    var obj = options && options.plainObjects ? Object.create(null) : {};
	    for (var i = 0; i < source.length; ++i) {
	        if (typeof source[i] !== 'undefined') {
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	var merge = function merge(target, source, options) {
	    /* eslint no-param-reassign: 0 */
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (isArray(target)) {
	            target.push(source);
	        } else if (target && typeof target === 'object') {
	            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
	                target[source] = true;
	            }
	        } else {
	            return [target, source];
	        }
	
	        return target;
	    }
	
	    if (!target || typeof target !== 'object') {
	        return [target].concat(source);
	    }
	
	    var mergeTarget = target;
	    if (isArray(target) && !isArray(source)) {
	        mergeTarget = arrayToObject(target, options);
	    }
	
	    if (isArray(target) && isArray(source)) {
	        source.forEach(function (item, i) {
	            if (has.call(target, i)) {
	                var targetItem = target[i];
	                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
	                    target[i] = merge(targetItem, item, options);
	                } else {
	                    target.push(item);
	                }
	            } else {
	                target[i] = item;
	            }
	        });
	        return target;
	    }
	
	    return Object.keys(source).reduce(function (acc, key) {
	        var value = source[key];
	
	        if (has.call(acc, key)) {
	            acc[key] = merge(acc[key], value, options);
	        } else {
	            acc[key] = value;
	        }
	        return acc;
	    }, mergeTarget);
	};
	
	var assign = function assignSingleSource(target, source) {
	    return Object.keys(source).reduce(function (acc, key) {
	        acc[key] = source[key];
	        return acc;
	    }, target);
	};
	
	var decode = function (str, decoder, charset) {
	    var strWithoutPlus = str.replace(/\+/g, ' ');
	    if (charset === 'iso-8859-1') {
	        // unescape never throws, no try...catch needed:
	        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
	    }
	    // utf-8
	    try {
	        return decodeURIComponent(strWithoutPlus);
	    } catch (e) {
	        return strWithoutPlus;
	    }
	};
	
	var encode = function encode(str, defaultEncoder, charset) {
	    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	    // It has been adapted here for stricter adherence to RFC 3986
	    if (str.length === 0) {
	        return str;
	    }
	
	    var string = str;
	    if (typeof str === 'symbol') {
	        string = Symbol.prototype.toString.call(str);
	    } else if (typeof str !== 'string') {
	        string = String(str);
	    }
	
	    if (charset === 'iso-8859-1') {
	        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
	            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
	        });
	    }
	
	    var out = '';
	    for (var i = 0; i < string.length; ++i) {
	        var c = string.charCodeAt(i);
	
	        if (
	            c === 0x2D // -
	            || c === 0x2E // .
	            || c === 0x5F // _
	            || c === 0x7E // ~
	            || (c >= 0x30 && c <= 0x39) // 0-9
	            || (c >= 0x41 && c <= 0x5A) // a-z
	            || (c >= 0x61 && c <= 0x7A) // A-Z
	        ) {
	            out += string.charAt(i);
	            continue;
	        }
	
	        if (c < 0x80) {
	            out = out + hexTable[c];
	            continue;
	        }
	
	        if (c < 0x800) {
	            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        if (c < 0xD800 || c >= 0xE000) {
	            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        i += 1;
	        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
	        out += hexTable[0xF0 | (c >> 18)]
	            + hexTable[0x80 | ((c >> 12) & 0x3F)]
	            + hexTable[0x80 | ((c >> 6) & 0x3F)]
	            + hexTable[0x80 | (c & 0x3F)];
	    }
	
	    return out;
	};
	
	var compact = function compact(value) {
	    var queue = [{ obj: { o: value }, prop: 'o' }];
	    var refs = [];
	
	    for (var i = 0; i < queue.length; ++i) {
	        var item = queue[i];
	        var obj = item.obj[item.prop];
	
	        var keys = Object.keys(obj);
	        for (var j = 0; j < keys.length; ++j) {
	            var key = keys[j];
	            var val = obj[key];
	            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
	                queue.push({ obj: obj, prop: key });
	                refs.push(val);
	            }
	        }
	    }
	
	    compactQueue(queue);
	
	    return value;
	};
	
	var isRegExp = function isRegExp(obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	var isBuffer = function isBuffer(obj) {
	    if (!obj || typeof obj !== 'object') {
	        return false;
	    }
	
	    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
	};
	
	var combine = function combine(a, b) {
	    return [].concat(a, b);
	};
	
	module.exports = {
	    arrayToObject: arrayToObject,
	    assign: assign,
	    combine: combine,
	    compact: compact,
	    decode: decode,
	    encode: encode,
	    isBuffer: isBuffer,
	    isRegExp: isRegExp,
	    merge: merge
	};


/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(1913)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var stringify = __webpack_require__(864);
	
	var _window =
	  typeof window !== 'undefined'
	    ? window
	    : typeof global !== 'undefined'
	      ? global
	      : typeof self !== 'undefined'
	        ? self
	        : {};
	
	function isObject(what) {
	  return typeof what === 'object' && what !== null;
	}
	
	// Yanked from https://git.io/vS8DV re-used under CC0
	// with some tiny modifications
	function isError(value) {
	  switch (Object.prototype.toString.call(value)) {
	    case '[object Error]':
	      return true;
	    case '[object Exception]':
	      return true;
	    case '[object DOMException]':
	      return true;
	    default:
	      return value instanceof Error;
	  }
	}
	
	function isErrorEvent(value) {
	  return Object.prototype.toString.call(value) === '[object ErrorEvent]';
	}
	
	function isDOMError(value) {
	  return Object.prototype.toString.call(value) === '[object DOMError]';
	}
	
	function isDOMException(value) {
	  return Object.prototype.toString.call(value) === '[object DOMException]';
	}
	
	function isUndefined(what) {
	  return what === void 0;
	}
	
	function isFunction(what) {
	  return typeof what === 'function';
	}
	
	function isPlainObject(what) {
	  return Object.prototype.toString.call(what) === '[object Object]';
	}
	
	function isString(what) {
	  return Object.prototype.toString.call(what) === '[object String]';
	}
	
	function isArray(what) {
	  return Object.prototype.toString.call(what) === '[object Array]';
	}
	
	function isEmptyObject(what) {
	  if (!isPlainObject(what)) return false;
	
	  for (var _ in what) {
	    if (what.hasOwnProperty(_)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	function supportsErrorEvent() {
	  try {
	    new ErrorEvent(''); // eslint-disable-line no-new
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function supportsDOMError() {
	  try {
	    new DOMError(''); // eslint-disable-line no-new
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function supportsDOMException() {
	  try {
	    new DOMException(''); // eslint-disable-line no-new
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function supportsFetch() {
	  if (!('fetch' in _window)) return false;
	
	  try {
	    new Headers(); // eslint-disable-line no-new
	    new Request(''); // eslint-disable-line no-new
	    new Response(); // eslint-disable-line no-new
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	// Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
	// https://caniuse.com/#feat=referrer-policy
	// It doesn't. And it throw exception instead of ignoring this parameter...
	// REF: https://github.com/getsentry/raven-js/issues/1233
	function supportsReferrerPolicy() {
	  if (!supportsFetch()) return false;
	
	  try {
	    // eslint-disable-next-line no-new
	    new Request('pickleRick', {
	      referrerPolicy: 'origin'
	    });
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function supportsPromiseRejectionEvent() {
	  return typeof PromiseRejectionEvent === 'function';
	}
	
	function wrappedCallback(callback) {
	  function dataCallback(data, original) {
	    var normalizedData = callback(data) || data;
	    if (original) {
	      return original(normalizedData) || normalizedData;
	    }
	    return normalizedData;
	  }
	
	  return dataCallback;
	}
	
	function each(obj, callback) {
	  var i, j;
	
	  if (isUndefined(obj.length)) {
	    for (i in obj) {
	      if (hasKey(obj, i)) {
	        callback.call(null, i, obj[i]);
	      }
	    }
	  } else {
	    j = obj.length;
	    if (j) {
	      for (i = 0; i < j; i++) {
	        callback.call(null, i, obj[i]);
	      }
	    }
	  }
	}
	
	function objectMerge(obj1, obj2) {
	  if (!obj2) {
	    return obj1;
	  }
	  each(obj2, function(key, value) {
	    obj1[key] = value;
	  });
	  return obj1;
	}
	
	/**
	 * This function is only used for react-native.
	 * react-native freezes object that have already been sent over the
	 * js bridge. We need this function in order to check if the object is frozen.
	 * So it's ok that objectFrozen returns false if Object.isFrozen is not
	 * supported because it's not relevant for other "platforms". See related issue:
	 * https://github.com/getsentry/react-native-sentry/issues/57
	 */
	function objectFrozen(obj) {
	  if (!Object.isFrozen) {
	    return false;
	  }
	  return Object.isFrozen(obj);
	}
	
	function truncate(str, max) {
	  if (typeof max !== 'number') {
	    throw new Error('2nd argument to `truncate` function should be a number');
	  }
	  if (typeof str !== 'string' || max === 0) {
	    return str;
	  }
	  return str.length <= max ? str : str.substr(0, max) + '\u2026';
	}
	
	/**
	 * hasKey, a better form of hasOwnProperty
	 * Example: hasKey(MainHostObject, property) === true/false
	 *
	 * @param {Object} host object to check property
	 * @param {string} key to check
	 */
	function hasKey(object, key) {
	  return Object.prototype.hasOwnProperty.call(object, key);
	}
	
	function joinRegExp(patterns) {
	  // Combine an array of regular expressions and strings into one large regexp
	  // Be mad.
	  var sources = [],
	    i = 0,
	    len = patterns.length,
	    pattern;
	
	  for (; i < len; i++) {
	    pattern = patterns[i];
	    if (isString(pattern)) {
	      // If it's a string, we need to escape it
	      // Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
	      sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'));
	    } else if (pattern && pattern.source) {
	      // If it's a regexp already, we want to extract the source
	      sources.push(pattern.source);
	    }
	    // Intentionally skip other cases
	  }
	  return new RegExp(sources.join('|'), 'i');
	}
	
	function urlencode(o) {
	  var pairs = [];
	  each(o, function(key, value) {
	    pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
	  });
	  return pairs.join('&');
	}
	
	// borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
	// intentionally using regex and not <a/> href parsing trick because React Native and other
	// environments where DOM might not be available
	function parseUrl(url) {
	  if (typeof url !== 'string') return {};
	  var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
	
	  // coerce to undefined values to empty string so we don't get 'undefined'
	  var query = match[6] || '';
	  var fragment = match[8] || '';
	  return {
	    protocol: match[2],
	    host: match[4],
	    path: match[5],
	    relative: match[5] + query + fragment // everything minus origin
	  };
	}
	function uuid4() {
	  var crypto = _window.crypto || _window.msCrypto;
	
	  if (!isUndefined(crypto) && crypto.getRandomValues) {
	    // Use window.crypto API if available
	    // eslint-disable-next-line no-undef
	    var arr = new Uint16Array(8);
	    crypto.getRandomValues(arr);
	
	    // set 4 in byte 7
	    arr[3] = (arr[3] & 0xfff) | 0x4000;
	    // set 2 most significant bits of byte 9 to '10'
	    arr[4] = (arr[4] & 0x3fff) | 0x8000;
	
	    var pad = function(num) {
	      var v = num.toString(16);
	      while (v.length < 4) {
	        v = '0' + v;
	      }
	      return v;
	    };
	
	    return (
	      pad(arr[0]) +
	      pad(arr[1]) +
	      pad(arr[2]) +
	      pad(arr[3]) +
	      pad(arr[4]) +
	      pad(arr[5]) +
	      pad(arr[6]) +
	      pad(arr[7])
	    );
	  } else {
	    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
	    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
	      var r = (Math.random() * 16) | 0,
	        v = c === 'x' ? r : (r & 0x3) | 0x8;
	      return v.toString(16);
	    });
	  }
	}
	
	/**
	 * Given a child DOM element, returns a query-selector statement describing that
	 * and its ancestors
	 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
	 * @param elem
	 * @returns {string}
	 */
	function htmlTreeAsString(elem) {
	  /* eslint no-extra-parens:0*/
	  var MAX_TRAVERSE_HEIGHT = 5,
	    MAX_OUTPUT_LEN = 80,
	    out = [],
	    height = 0,
	    len = 0,
	    separator = ' > ',
	    sepLength = separator.length,
	    nextStr;
	
	  while (elem && height++ < MAX_TRAVERSE_HEIGHT) {
	    nextStr = htmlElementAsString(elem);
	    // bail out if
	    // - nextStr is the 'html' element
	    // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
	    //   (ignore this limit if we are on the first iteration)
	    if (
	      nextStr === 'html' ||
	      (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)
	    ) {
	      break;
	    }
	
	    out.push(nextStr);
	
	    len += nextStr.length;
	    elem = elem.parentNode;
	  }
	
	  return out.reverse().join(separator);
	}
	
	/**
	 * Returns a simple, query-selector representation of a DOM element
	 * e.g. [HTMLElement] => input#foo.btn[name=baz]
	 * @param HTMLElement
	 * @returns {string}
	 */
	function htmlElementAsString(elem) {
	  var out = [],
	    className,
	    classes,
	    key,
	    attr,
	    i;
	
	  if (!elem || !elem.tagName) {
	    return '';
	  }
	
	  out.push(elem.tagName.toLowerCase());
	  if (elem.id) {
	    out.push('#' + elem.id);
	  }
	
	  className = elem.className;
	  if (className && isString(className)) {
	    classes = className.split(/\s+/);
	    for (i = 0; i < classes.length; i++) {
	      out.push('.' + classes[i]);
	    }
	  }
	  var attrWhitelist = ['type', 'name', 'title', 'alt'];
	  for (i = 0; i < attrWhitelist.length; i++) {
	    key = attrWhitelist[i];
	    attr = elem.getAttribute(key);
	    if (attr) {
	      out.push('[' + key + '="' + attr + '"]');
	    }
	  }
	  return out.join('');
	}
	
	/**
	 * Returns true if either a OR b is truthy, but not both
	 */
	function isOnlyOneTruthy(a, b) {
	  return !!(!!a ^ !!b);
	}
	
	/**
	 * Returns true if both parameters are undefined
	 */
	function isBothUndefined(a, b) {
	  return isUndefined(a) && isUndefined(b);
	}
	
	/**
	 * Returns true if the two input exception interfaces have the same content
	 */
	function isSameException(ex1, ex2) {
	  if (isOnlyOneTruthy(ex1, ex2)) return false;
	
	  ex1 = ex1.values[0];
	  ex2 = ex2.values[0];
	
	  if (ex1.type !== ex2.type || ex1.value !== ex2.value) return false;
	
	  // in case both stacktraces are undefined, we can't decide so default to false
	  if (isBothUndefined(ex1.stacktrace, ex2.stacktrace)) return false;
	
	  return isSameStacktrace(ex1.stacktrace, ex2.stacktrace);
	}
	
	/**
	 * Returns true if the two input stack trace interfaces have the same content
	 */
	function isSameStacktrace(stack1, stack2) {
	  if (isOnlyOneTruthy(stack1, stack2)) return false;
	
	  var frames1 = stack1.frames;
	  var frames2 = stack2.frames;
	
	  // Exit early if stacktrace is malformed
	  if (frames1 === undefined || frames2 === undefined) return false;
	
	  // Exit early if frame count differs
	  if (frames1.length !== frames2.length) return false;
	
	  // Iterate through every frame; bail out if anything differs
	  var a, b;
	  for (var i = 0; i < frames1.length; i++) {
	    a = frames1[i];
	    b = frames2[i];
	    if (
	      a.filename !== b.filename ||
	      a.lineno !== b.lineno ||
	      a.colno !== b.colno ||
	      a['function'] !== b['function']
	    )
	      return false;
	  }
	  return true;
	}
	
	/**
	 * Polyfill a method
	 * @param obj object e.g. `document`
	 * @param name method name present on object e.g. `addEventListener`
	 * @param replacement replacement function
	 * @param track {optional} record instrumentation to an array
	 */
	function fill(obj, name, replacement, track) {
	  if (obj == null) return;
	  var orig = obj[name];
	  obj[name] = replacement(orig);
	  obj[name].__raven__ = true;
	  obj[name].__orig__ = orig;
	  if (track) {
	    track.push([obj, name, orig]);
	  }
	}
	
	/**
	 * Join values in array
	 * @param input array of values to be joined together
	 * @param delimiter string to be placed in-between values
	 * @returns {string}
	 */
	function safeJoin(input, delimiter) {
	  if (!isArray(input)) return '';
	
	  var output = [];
	
	  for (var i = 0; i < input.length; i++) {
	    try {
	      output.push(String(input[i]));
	    } catch (e) {
	      output.push('[value cannot be serialized]');
	    }
	  }
	
	  return output.join(delimiter);
	}
	
	// Default Node.js REPL depth
	var MAX_SERIALIZE_EXCEPTION_DEPTH = 3;
	// 50kB, as 100kB is max payload size, so half sounds reasonable
	var MAX_SERIALIZE_EXCEPTION_SIZE = 50 * 1024;
	var MAX_SERIALIZE_KEYS_LENGTH = 40;
	
	function utf8Length(value) {
	  return ~-encodeURI(value).split(/%..|./).length;
	}
	
	function jsonSize(value) {
	  return utf8Length(JSON.stringify(value));
	}
	
	function serializeValue(value) {
	  if (typeof value === 'string') {
	    var maxLength = 40;
	    return truncate(value, maxLength);
	  } else if (
	    typeof value === 'number' ||
	    typeof value === 'boolean' ||
	    typeof value === 'undefined'
	  ) {
	    return value;
	  }
	
	  var type = Object.prototype.toString.call(value);
	
	  // Node.js REPL notation
	  if (type === '[object Object]') return '[Object]';
	  if (type === '[object Array]') return '[Array]';
	  if (type === '[object Function]')
	    return value.name ? '[Function: ' + value.name + ']' : '[Function]';
	
	  return value;
	}
	
	function serializeObject(value, depth) {
	  if (depth === 0) return serializeValue(value);
	
	  if (isPlainObject(value)) {
	    return Object.keys(value).reduce(function(acc, key) {
	      acc[key] = serializeObject(value[key], depth - 1);
	      return acc;
	    }, {});
	  } else if (Array.isArray(value)) {
	    return value.map(function(val) {
	      return serializeObject(val, depth - 1);
	    });
	  }
	
	  return serializeValue(value);
	}
	
	function serializeException(ex, depth, maxSize) {
	  if (!isPlainObject(ex)) return ex;
	
	  depth = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_DEPTH : depth;
	  maxSize = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_SIZE : maxSize;
	
	  var serialized = serializeObject(ex, depth);
	
	  if (jsonSize(stringify(serialized)) > maxSize) {
	    return serializeException(ex, depth - 1);
	  }
	
	  return serialized;
	}
	
	function serializeKeysForMessage(keys, maxLength) {
	  if (typeof keys === 'number' || typeof keys === 'string') return keys.toString();
	  if (!Array.isArray(keys)) return '';
	
	  keys = keys.filter(function(key) {
	    return typeof key === 'string';
	  });
	  if (keys.length === 0) return '[object has no keys]';
	
	  maxLength = typeof maxLength !== 'number' ? MAX_SERIALIZE_KEYS_LENGTH : maxLength;
	  if (keys[0].length >= maxLength) return keys[0];
	
	  for (var usedKeys = keys.length; usedKeys > 0; usedKeys--) {
	    var serialized = keys.slice(0, usedKeys).join(', ');
	    if (serialized.length > maxLength) continue;
	    if (usedKeys === keys.length) return serialized;
	    return serialized + '\u2026';
	  }
	
	  return '';
	}
	
	function sanitize(input, sanitizeKeys) {
	  if (!isArray(sanitizeKeys) || (isArray(sanitizeKeys) && sanitizeKeys.length === 0))
	    return input;
	
	  var sanitizeRegExp = joinRegExp(sanitizeKeys);
	  var sanitizeMask = '********';
	  var safeInput;
	
	  try {
	    safeInput = JSON.parse(stringify(input));
	  } catch (o_O) {
	    return input;
	  }
	
	  function sanitizeWorker(workerInput) {
	    if (isArray(workerInput)) {
	      return workerInput.map(function(val) {
	        return sanitizeWorker(val);
	      });
	    }
	
	    if (isPlainObject(workerInput)) {
	      return Object.keys(workerInput).reduce(function(acc, k) {
	        if (sanitizeRegExp.test(k)) {
	          acc[k] = sanitizeMask;
	        } else {
	          acc[k] = sanitizeWorker(workerInput[k]);
	        }
	        return acc;
	      }, {});
	    }
	
	    return workerInput;
	  }
	
	  return sanitizeWorker(safeInput);
	}
	
	module.exports = {
	  isObject: isObject,
	  isError: isError,
	  isErrorEvent: isErrorEvent,
	  isDOMError: isDOMError,
	  isDOMException: isDOMException,
	  isUndefined: isUndefined,
	  isFunction: isFunction,
	  isPlainObject: isPlainObject,
	  isString: isString,
	  isArray: isArray,
	  isEmptyObject: isEmptyObject,
	  supportsErrorEvent: supportsErrorEvent,
	  supportsDOMError: supportsDOMError,
	  supportsDOMException: supportsDOMException,
	  supportsFetch: supportsFetch,
	  supportsReferrerPolicy: supportsReferrerPolicy,
	  supportsPromiseRejectionEvent: supportsPromiseRejectionEvent,
	  wrappedCallback: wrappedCallback,
	  each: each,
	  objectMerge: objectMerge,
	  truncate: truncate,
	  objectFrozen: objectFrozen,
	  hasKey: hasKey,
	  joinRegExp: joinRegExp,
	  urlencode: urlencode,
	  uuid4: uuid4,
	  htmlTreeAsString: htmlTreeAsString,
	  htmlElementAsString: htmlElementAsString,
	  isSameException: isSameException,
	  isSameStacktrace: isSameStacktrace,
	  parseUrl: parseUrl,
	  fill: fill,
	  safeJoin: safeJoin,
	  serializeException: serializeException,
	  serializeKeysForMessage: serializeKeysForMessage,
	  sanitize: sanitize
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _all = _interopRequireDefault(__webpack_require__(314));
	
	var _Button = _interopRequireDefault(__webpack_require__(232));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var propTypes = {
	  vertical: _propTypes.default.bool,
	  justified: _propTypes.default.bool,
	
	  /**
	   * Display block buttons; only useful when used with the "vertical" prop.
	   * @type {bool}
	   */
	  block: (0, _all.default)(_propTypes.default.bool, function (_ref) {
	    var block = _ref.block,
	        vertical = _ref.vertical;
	    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
	  })
	};
	var defaultProps = {
	  block: false,
	  justified: false,
	  vertical: false
	};
	
	var ButtonGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(ButtonGroup, _React$Component);
	
	  function ButtonGroup() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ButtonGroup.prototype;
	
	  _proto.render = function render() {
	    var _extends2;
	
	    var _this$props = this.props,
	        block = _this$props.block,
	        justified = _this$props.justified,
	        vertical = _this$props.vertical,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["block", "justified", "vertical", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps)] = !vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'vertical')] = vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2[(0, _bootstrapUtils.prefix)(_Button.default.defaultProps, 'block')] = block, _extends2));
	    return _react.default.createElement("div", (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return ButtonGroup;
	}(_react.default.Component);
	
	ButtonGroup.propTypes = propTypes;
	ButtonGroup.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('btn-group', ButtonGroup);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var propTypes = {
	  label: _propTypes.default.string.isRequired,
	  onClick: _propTypes.default.func
	};
	var defaultProps = {
	  label: 'Close'
	};
	
	var CloseButton =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(CloseButton, _React$Component);
	
	  function CloseButton() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = CloseButton.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        label = _this$props.label,
	        onClick = _this$props.onClick;
	    return _react.default.createElement("button", {
	      type: "button",
	      className: "close",
	      onClick: onClick
	    }, _react.default.createElement("span", {
	      "aria-hidden": "true"
	    }, "\xD7"), _react.default.createElement("span", {
	      className: "sr-only"
	    }, label));
	  };
	
	  return CloseButton;
	}(_react.default.Component);
	
	CloseButton.propTypes = propTypes;
	CloseButton.defaultProps = defaultProps;
	var _default = CloseButton;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _elementType = _interopRequireDefault(__webpack_require__(34));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _StyleConfig = __webpack_require__(51);
	
	var propTypes = {
	  componentClass: _elementType.default,
	
	  /**
	   * The number of columns you wish to span
	   *
	   * for Extra small devices Phones (<768px)
	   *
	   * class-prefix `col-xs-`
	   */
	  xs: _propTypes.default.number,
	
	  /**
	   * The number of columns you wish to span
	   *
	   * for Small devices Tablets (≥768px)
	   *
	   * class-prefix `col-sm-`
	   */
	  sm: _propTypes.default.number,
	
	  /**
	   * The number of columns you wish to span
	   *
	   * for Medium devices Desktops (≥992px)
	   *
	   * class-prefix `col-md-`
	   */
	  md: _propTypes.default.number,
	
	  /**
	   * The number of columns you wish to span
	   *
	   * for Large devices Desktops (≥1200px)
	   *
	   * class-prefix `col-lg-`
	   */
	  lg: _propTypes.default.number,
	
	  /**
	   * Hide column
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `hidden-xs`
	   */
	  xsHidden: _propTypes.default.bool,
	
	  /**
	   * Hide column
	   *
	   * on Small devices Tablets
	   *
	   * adds class `hidden-sm`
	   */
	  smHidden: _propTypes.default.bool,
	
	  /**
	   * Hide column
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `hidden-md`
	   */
	  mdHidden: _propTypes.default.bool,
	
	  /**
	   * Hide column
	   *
	   * on Large devices Desktops
	   *
	   * adds class `hidden-lg`
	   */
	  lgHidden: _propTypes.default.bool,
	
	  /**
	   * Move columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-offset-`
	   */
	  xsOffset: _propTypes.default.number,
	
	  /**
	   * Move columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-offset-`
	   */
	  smOffset: _propTypes.default.number,
	
	  /**
	   * Move columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-offset-`
	   */
	  mdOffset: _propTypes.default.number,
	
	  /**
	   * Move columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-offset-`
	   */
	  lgOffset: _propTypes.default.number,
	
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-push-`
	   */
	  xsPush: _propTypes.default.number,
	
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-push-`
	   */
	  smPush: _propTypes.default.number,
	
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-push-`
	   */
	  mdPush: _propTypes.default.number,
	
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-push-`
	   */
	  lgPush: _propTypes.default.number,
	
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-pull-`
	   */
	  xsPull: _propTypes.default.number,
	
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-pull-`
	   */
	  smPull: _propTypes.default.number,
	
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-pull-`
	   */
	  mdPull: _propTypes.default.number,
	
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-pull-`
	   */
	  lgPull: _propTypes.default.number
	};
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Col =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Col, _React$Component);
	
	  function Col() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Col.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.componentClass,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      function popProp(propSuffix, modifier) {
	        var propName = "" + size + propSuffix;
	        var propValue = elementProps[propName];
	
	        if (propValue != null) {
	          classes.push((0, _bootstrapUtils.prefix)(bsProps, "" + size + modifier + "-" + propValue));
	        }
	
	        delete elementProps[propName];
	      }
	
	      popProp('', '');
	      popProp('Offset', '-offset');
	      popProp('Push', '-push');
	      popProp('Pull', '-pull');
	      var hiddenPropName = size + "Hidden";
	
	      if (elementProps[hiddenPropName]) {
	        classes.push("hidden-" + size);
	      }
	
	      delete elementProps[hiddenPropName];
	    });
	
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return Col;
	}(_react.default.Component);
	
	Col.propTypes = propTypes;
	Col.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('col', Col);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _parseInt2 = _interopRequireDefault(__webpack_require__(972));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _style = _interopRequireDefault(__webpack_require__(226));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _Transition = _interopRequireWildcard(__webpack_require__(526));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(897));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var _collapseStyles;
	
	var MARGINS = {
	  height: ['marginTop', 'marginBottom'],
	  width: ['marginLeft', 'marginRight']
	}; // reading a dimension prop will cause the browser to recalculate,
	// which will let our animations work
	
	function triggerBrowserReflow(node) {
	  node.offsetHeight; // eslint-disable-line no-unused-expressions
	}
	
	function getDimensionValue(dimension, elem) {
	  var value = elem["offset" + (0, _capitalize.default)(dimension)];
	  var margins = MARGINS[dimension];
	  return value + (0, _parseInt2.default)((0, _style.default)(elem, margins[0]), 10) + (0, _parseInt2.default)((0, _style.default)(elem, margins[1]), 10);
	}
	
	var collapseStyles = (_collapseStyles = {}, _collapseStyles[_Transition.EXITED] = 'collapse', _collapseStyles[_Transition.EXITING] = 'collapsing', _collapseStyles[_Transition.ENTERING] = 'collapsing', _collapseStyles[_Transition.ENTERED] = 'collapse in', _collapseStyles);
	var propTypes = {
	  /**
	   * Show the component; triggers the expand or collapse animation
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes.default.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is collapsed
	   */
	  unmountOnExit: _propTypes.default.bool,
	
	  /**
	   * Run the expand animation when the component mounts, if it is initially
	   * shown
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * Duration of the collapse animation in milliseconds, to ensure that
	   * finishing callbacks are fired even if the original browser transition end
	   * events are canceled
	   */
	  timeout: _propTypes.default.number,
	
	  /**
	   * Callback fired before the component expands
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired after the component starts to expand
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired after the component has expanded
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired before the component collapses
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired after the component starts to collapse
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * Callback fired after the component has collapsed
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * The dimension used when collapsing, or a function that returns the
	   * dimension
	   *
	   * _Note: Bootstrap only partially supports 'width'!
	   * You will need to supply your own CSS animation for the `.width` CSS class._
	   */
	  dimension: _propTypes.default.oneOfType([_propTypes.default.oneOf(['height', 'width']), _propTypes.default.func]),
	
	  /**
	   * Function that returns the height or width of the animating DOM node
	   *
	   * Allows for providing some custom logic for how much the Collapse component
	   * should animate in its specified dimension. Called with the current
	   * dimension prop value and the DOM node.
	   */
	  getDimensionValue: _propTypes.default.func,
	
	  /**
	   * ARIA role of collapsible element
	   */
	  role: _propTypes.default.string
	};
	var defaultProps = {
	  in: false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  dimension: 'height',
	  getDimensionValue: getDimensionValue
	};
	
	var Collapse =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Collapse, _React$Component);
	
	  function Collapse() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _this.handleEnter = function (elem) {
	      elem.style[_this.getDimension()] = '0';
	    };
	
	    _this.handleEntering = function (elem) {
	      var dimension = _this.getDimension();
	
	      elem.style[dimension] = _this._getScrollDimensionValue(elem, dimension);
	    };
	
	    _this.handleEntered = function (elem) {
	      elem.style[_this.getDimension()] = null;
	    };
	
	    _this.handleExit = function (elem) {
	      var dimension = _this.getDimension();
	
	      elem.style[dimension] = _this.props.getDimensionValue(dimension, elem) + "px";
	      triggerBrowserReflow(elem);
	    };
	
	    _this.handleExiting = function (elem) {
	      elem.style[_this.getDimension()] = '0';
	    };
	
	    return _this;
	  }
	
	  var _proto = Collapse.prototype;
	
	  _proto.getDimension = function getDimension() {
	    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
	  }; // for testing
	
	
	  _proto._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
	    return elem["scroll" + (0, _capitalize.default)(dimension)] + "px";
	  };
	  /* -- Expanding -- */
	
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var _this$props = this.props,
	        onEnter = _this$props.onEnter,
	        onEntering = _this$props.onEntering,
	        onEntered = _this$props.onEntered,
	        onExit = _this$props.onExit,
	        onExiting = _this$props.onExiting,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["onEnter", "onEntering", "onEntered", "onExit", "onExiting", "className", "children"]);
	    delete props.dimension;
	    delete props.getDimensionValue;
	    var handleEnter = (0, _createChainedFunction.default)(this.handleEnter, onEnter);
	    var handleEntering = (0, _createChainedFunction.default)(this.handleEntering, onEntering);
	    var handleEntered = (0, _createChainedFunction.default)(this.handleEntered, onEntered);
	    var handleExit = (0, _createChainedFunction.default)(this.handleExit, onExit);
	    var handleExiting = (0, _createChainedFunction.default)(this.handleExiting, onExiting);
	    return _react.default.createElement(_Transition.default, (0, _extends2.default)({}, props, {
	      "aria-expanded": props.role ? props.in : null,
	      onEnter: handleEnter,
	      onEntering: handleEntering,
	      onEntered: handleEntered,
	      onExit: handleExit,
	      onExiting: handleExiting
	    }), function (state, innerProps) {
	      return _react.default.cloneElement(children, (0, _extends2.default)({}, innerProps, {
	        className: (0, _classnames.default)(className, children.props.className, collapseStyles[state], _this2.getDimension() === 'width' && 'width')
	      }));
	    });
	  };
	
	  return Collapse;
	}(_react.default.Component);
	
	Collapse.propTypes = propTypes;
	Collapse.defaultProps = defaultProps;
	var _default = Collapse;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _elementType = _interopRequireDefault(__webpack_require__(34));
	
	var _warning = _interopRequireDefault(__webpack_require__(47));
	
	var _FormControlFeedback = _interopRequireDefault(__webpack_require__(1934));
	
	var _FormControlStatic = _interopRequireDefault(__webpack_require__(1935));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _StyleConfig = __webpack_require__(51);
	
	var propTypes = {
	  componentClass: _elementType.default,
	
	  /**
	   * Only relevant if `componentClass` is `'input'`.
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <FormControl inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes.default.func
	};
	var defaultProps = {
	  componentClass: 'input'
	};
	var contextTypes = {
	  $bs_formGroup: _propTypes.default.object
	};
	
	var FormControl =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(FormControl, _React$Component);
	
	  function FormControl() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = FormControl.prototype;
	
	  _proto.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	    var _this$props = this.props,
	        Component = _this$props.componentClass,
	        type = _this$props.type,
	        _this$props$id = _this$props.id,
	        id = _this$props$id === void 0 ? controlId : _this$props$id,
	        inputRef = _this$props.inputRef,
	        className = _this$props.className,
	        bsSize = _this$props.bsSize,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "type", "id", "inputRef", "className", "bsSize"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning.default)(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0; // input[type="file"] should not have .form-control.
	
	    var classes;
	
	    if (type !== 'file') {
	      classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    } // If user provides a size, make sure to append it to classes as input-
	    // e.g. if bsSize is small, it will append input-sm
	
	
	    if (bsSize) {
	      var size = _StyleConfig.SIZE_MAP[bsSize] || bsSize;
	      classes[(0, _bootstrapUtils.prefix)({
	        bsClass: 'input'
	      }, size)] = true;
	    }
	
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      type: type,
	      id: id,
	      ref: inputRef,
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return FormControl;
	}(_react.default.Component);
	
	FormControl.propTypes = propTypes;
	FormControl.defaultProps = defaultProps;
	FormControl.contextTypes = contextTypes;
	FormControl.Feedback = _FormControlFeedback.default;
	FormControl.Static = _FormControlStatic.default;
	
	var _default = (0, _bootstrapUtils.bsClass)('form-control', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.SMALL, _StyleConfig.Size.LARGE], FormControl));
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var propTypes = {
	  /**
	   * An icon name without "glyphicon-" prefix. See e.g. http://getbootstrap.com/components/#glyphicons
	   */
	  glyph: _propTypes.default.string.isRequired
	};
	
	var Glyphicon =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Glyphicon, _React$Component);
	
	  function Glyphicon() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Glyphicon.prototype;
	
	  _proto.render = function render() {
	    var _extends2;
	
	    var _this$props = this.props,
	        glyph = _this$props.glyph,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["glyph", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, glyph)] = true, _extends2));
	    return _react.default.createElement("span", (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return Glyphicon;
	}(_react.default.Component);
	
	Glyphicon.propTypes = propTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('glyphicon', Glyphicon);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _uncontrollable = _interopRequireDefault(__webpack_require__(155));
	
	var TAB = 'tab';
	var PANE = 'pane';
	
	var idPropType = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]);
	
	var propTypes = {
	  /**
	   * HTML id attribute, required if no `generateChildId` prop
	   * is specified.
	   */
	  id: function id(props) {
	    var error = null;
	
	    if (!props.generateChildId) {
	      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      error = idPropType.apply(void 0, [props].concat(args));
	
	      if (!error && !props.id) {
	        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
	      }
	    }
	
	    return error;
	  },
	
	  /**
	   * A function that takes an `eventKey` and `type` and returns a unique id for
	   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
	   * function, meaning it should always return the _same_ id for the same set
	   * of inputs. The default value requires that an `id` to be set for the
	   * `<TabContainer>`.
	   *
	   * The `type` argument will either be `"tab"` or `"pane"`.
	   *
	   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
	   */
	  generateChildId: _propTypes.default.func,
	
	  /**
	   * A callback fired when a tab is selected.
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes.default.func,
	
	  /**
	   * The `eventKey` of the currently active tab.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes.default.any
	};
	var childContextTypes = {
	  $bs_tabContainer: _propTypes.default.shape({
	    activeKey: _propTypes.default.any,
	    onSelect: _propTypes.default.func.isRequired,
	    getTabId: _propTypes.default.func.isRequired,
	    getPaneId: _propTypes.default.func.isRequired
	  })
	};
	
	var TabContainer =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(TabContainer, _React$Component);
	
	  function TabContainer() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = TabContainer.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    var _this$props = this.props,
	        activeKey = _this$props.activeKey,
	        onSelect = _this$props.onSelect,
	        generateChildId = _this$props.generateChildId,
	        id = _this$props.id;
	
	    var getId = generateChildId || function (key, type) {
	      return id ? id + "-" + type + "-" + key : null;
	    };
	
	    return {
	      $bs_tabContainer: {
	        activeKey: activeKey,
	        onSelect: onSelect,
	        getTabId: function getTabId(key) {
	          return getId(key, TAB);
	        },
	        getPaneId: function getPaneId(key) {
	          return getId(key, PANE);
	        }
	      }
	    };
	  };
	
	  _proto.render = function render() {
	    var _this$props2 = this.props,
	        children = _this$props2.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["children"]);
	    delete props.generateChildId;
	    delete props.onSelect;
	    delete props.activeKey;
	    return _react.default.cloneElement(_react.default.Children.only(children), props);
	  };
	
	  return TabContainer;
	}(_react.default.Component);
	
	TabContainer.propTypes = propTypes;
	TabContainer.childContextTypes = childContextTypes;
	
	var _default = (0, _uncontrollable.default)(TabContainer, {
	  activeKey: 'onSelect'
	});
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(58));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _elementType = _interopRequireDefault(__webpack_require__(34));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var propTypes = {
	  componentClass: _elementType.default,
	
	  /**
	   * Sets a default animation strategy for all children `<TabPane>`s. Use
	   * `false` to disable, `true` to enable the default `<Fade>` animation or
	   * a react-transition-group v2 `<Transition/>` component.
	   */
	  animation: _propTypes.default.oneOfType([_propTypes.default.bool, _elementType.default]),
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes.default.bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when they are no longer visible
	   */
	  unmountOnExit: _propTypes.default.bool
	};
	var defaultProps = {
	  componentClass: 'div',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	var contextTypes = {
	  $bs_tabContainer: _propTypes.default.shape({
	    activeKey: _propTypes.default.any
	  })
	};
	var childContextTypes = {
	  $bs_tabContent: _propTypes.default.shape({
	    bsClass: _propTypes.default.string,
	    animation: _propTypes.default.oneOfType([_propTypes.default.bool, _elementType.default]),
	    activeKey: _propTypes.default.any,
	    mountOnEnter: _propTypes.default.bool,
	    unmountOnExit: _propTypes.default.bool,
	    onPaneEnter: _propTypes.default.func.isRequired,
	    onPaneExited: _propTypes.default.func.isRequired,
	    exiting: _propTypes.default.bool.isRequired
	  })
	};
	
	var TabContent =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(TabContent, _React$Component);
	
	  function TabContent(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    _this.handlePaneEnter = _this.handlePaneEnter.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handlePaneExited = _this.handlePaneExited.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this))); // Active entries in state will be `null` unless `animation` is set. Need
	    // to track active child in case keys swap and the active child changes
	    // but the active key does not.
	
	    _this.state = {
	      activeKey: null,
	      activeChild: null
	    };
	    return _this;
	  }
	
	  var _proto = TabContent.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    var _this$props = this.props,
	        bsClass = _this$props.bsClass,
	        animation = _this$props.animation,
	        mountOnEnter = _this$props.mountOnEnter,
	        unmountOnExit = _this$props.unmountOnExit;
	    var stateActiveKey = this.state.activeKey;
	    var containerActiveKey = this.getContainerActiveKey();
	    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
	    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;
	    return {
	      $bs_tabContent: {
	        bsClass: bsClass,
	        animation: animation,
	        activeKey: activeKey,
	        mountOnEnter: mountOnEnter,
	        unmountOnExit: unmountOnExit,
	        onPaneEnter: this.handlePaneEnter,
	        onPaneExited: this.handlePaneExited,
	        exiting: exiting
	      }
	    };
	  };
	
	  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (!nextProps.animation && this.state.activeChild) {
	      this.setState({
	        activeKey: null,
	        activeChild: null
	      });
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  _proto.getContainerActiveKey = function getContainerActiveKey() {
	    var tabContainer = this.context.$bs_tabContainer;
	    return tabContainer && tabContainer.activeKey;
	  };
	
	  _proto.handlePaneEnter = function handlePaneEnter(child, childKey) {
	    if (!this.props.animation) {
	      return false;
	    } // It's possible that this child should be transitioning out.
	
	
	    if (childKey !== this.getContainerActiveKey()) {
	      return false;
	    }
	
	    this.setState({
	      activeKey: childKey,
	      activeChild: child
	    });
	    return true;
	  };
	
	  _proto.handlePaneExited = function handlePaneExited(child) {
	    // This might happen as everything is unmounting.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState(function (_ref) {
	      var activeChild = _ref.activeChild;
	
	      if (activeChild !== child) {
	        return null;
	      }
	
	      return {
	        activeKey: null,
	        activeChild: null
	      };
	    });
	  };
	
	  _proto.render = function render() {
	    var _this$props2 = this.props,
	        Component = _this$props2.componentClass,
	        className = _this$props2.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["componentClass", "className"]);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation', 'mountOnEnter', 'unmountOnExit']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'content'))
	    }));
	  };
	
	  return TabContent;
	}(_react.default.Component);
	
	TabContent.propTypes = propTypes;
	TabContent.defaultProps = defaultProps;
	TabContent.contextTypes = contextTypes;
	TabContent.childContextTypes = childContextTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('tab', TabContent);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(243);
	
	var _interopRequireDefault = __webpack_require__(35);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ManagerReferenceNodeSetterContext = exports.ManagerReferenceNodeContext = void 0;
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(331));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(334));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(332));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(1989));
	
	var ManagerReferenceNodeContext = (0, _createReactContext.default)();
	exports.ManagerReferenceNodeContext = ManagerReferenceNodeContext;
	var ManagerReferenceNodeSetterContext = (0, _createReactContext.default)();
	exports.ManagerReferenceNodeSetterContext = ManagerReferenceNodeSetterContext;
	
	var Manager =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Manager, _React$Component);
	
	  function Manager() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "referenceNode", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setReferenceNode", function (newReferenceNode) {
	      if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
	        _this.referenceNode = newReferenceNode;
	
	        _this.forceUpdate();
	      }
	    });
	    return _this;
	  }
	
	  var _proto = Manager.prototype;
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.referenceNode = null;
	  };
	
	  _proto.render = function render() {
	    return React.createElement(ManagerReferenceNodeContext.Provider, {
	      value: this.referenceNode
	    }, React.createElement(ManagerReferenceNodeSetterContext.Provider, {
	      value: this.setReferenceNode
	    }, this.props.children));
	  };
	
	  return Manager;
	}(React.Component);
	
	exports.default = Manager;

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var ReactDOM = _interopDefault(__webpack_require__(31));
	var reactFinalForm = __webpack_require__(17);
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	//      
	var warning =  true ?
	/* istanbul ignore next */
	function (condition, message) {} : function (condition, message) {
	  if (!condition) {
	    console.error("Warning: " + message);
	  }
	};
	
	var errorKeys = ['badInput', 'patternMismatch', 'rangeOverflow', 'rangeUnderflow', 'stepMismatch', 'tooLong', 'tooShort', 'typeMismatch', 'valueMissing'];
	
	var Html5ValidationField = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(Html5ValidationField, _React$Component);
	
	  function Html5ValidationField() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _defineProperty(_assertThisInitialized(_this), "validate", function (value, allValues) {
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          input = _assertThisInitialize.input,
	          validate = _assertThisInitialize.props.validate;
	
	      if (input) {
	        var validity = input && input.validity;
	
	        if (validate) {
	          var error = validate(value, allValues);
	
	          if (input.setCustomValidity && typeof error === 'string') {
	            input.setCustomValidity(error);
	          }
	
	          if (error) {
	            return error;
	          }
	        }
	
	        input.setCustomValidity('');
	
	        if (validity && !validity.valid) {
	          if (validity.customError) {
	            return validity.customError;
	          }
	
	          var errorKey = errorKeys.find(function (key) {
	            return validity[key];
	          });
	
	          var _error = errorKey && _this.props[errorKey];
	
	          if (typeof _error === 'function') {
	            _error = _error(value, _this.props);
	          }
	
	          input.setCustomValidity(_error);
	          return _error;
	        }
	      } else if (validate) {
	        return validate(value, allValues);
	      }
	    });
	
	    return _this;
	  }
	
	  var _proto = Html5ValidationField.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    var root = ReactDOM.findDOMNode(this);
	
	    if (root) {
	      var input;
	
	      if (/input|textarea|select/.test(root.nodeName.toLowerCase())) {
	        input = root;
	      } else if (root.querySelector) {
	        var name = this.props.name;
	        input = root.querySelector("input[name=\"" + name + "\"],textarea[name=\"" + name + "\"],select[name=\"" + name + "\"]");
	      }
	
	      var foundInput = input && typeof input.setCustomValidity === 'function';
	
	      if (foundInput) {
	        this.input = input;
	      }
	
	      warning(foundInput, 'Could not find DOM input with HTML validity API');
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        validate = _this$props.validate,
	        badInput = _this$props.badInput,
	        patternMismatch = _this$props.patternMismatch,
	        rangeOverflow = _this$props.rangeOverflow,
	        rangeUnderflow = _this$props.rangeUnderflow,
	        stepMismatch = _this$props.stepMismatch,
	        tooLong = _this$props.tooLong,
	        tooShort = _this$props.tooShort,
	        typeMismatch = _this$props.typeMismatch,
	        valueMissing = _this$props.valueMissing,
	        innerRef = _this$props.innerRef,
	        rest = _objectWithoutPropertiesLoose(_this$props, ["validate", "badInput", "patternMismatch", "rangeOverflow", "rangeUnderflow", "stepMismatch", "tooLong", "tooShort", "typeMismatch", "valueMissing", "innerRef"]);
	
	    return React.createElement(reactFinalForm.Field, _extends({
	      validate: this.validate,
	      ref: innerRef
	    }, rest));
	  };
	
	  return Html5ValidationField;
	}(React.Component);
	
	_defineProperty(Html5ValidationField, "defaultProps", {
	  badInput: 'Incorrect input',
	  patternMismatch: 'Does not match expected pattern',
	  rangeOverflow: 'Value too high',
	  rangeUnderflow: 'Value too low',
	  stepMismatch: 'Invalid step value',
	  tooLong: 'Too long',
	  tooShort: 'Too short',
	  typeMismatch: 'Invalid value',
	  valueMissing: 'Required'
	});
	
	var Html5ValidationField$1 = React.forwardRef(function (props, ref) {
	  return React.createElement(Html5ValidationField, _extends({
	    innerRef: ref
	  }, props));
	});
	
	exports.Field = Html5ValidationField$1;


/***/ },
/* 512 */
/***/ function(module, exports) {

	
	
	// currently used to initiate the velocity style object to 0
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mapToZero;
	
	function mapToZero(obj) {
	  var ret = {};
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      ret[key] = 0;
	    }
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ },
/* 513 */
/***/ function(module, exports) {

	
	
	// usage assumption: currentStyle values have already been rendered but it says
	// nothing of whether currentStyle is stale (see unreadPropStyle)
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldStopAnimation;
	
	function shouldStopAnimation(currentStyle, style, currentVelocity) {
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	
	    if (currentVelocity[key] !== 0) {
	      return false;
	    }
	
	    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
	    // stepper will have already taken care of rounding precision errors, so
	    // won't have such thing as 0.9999 !=== 1
	    if (currentStyle[key] !== styleValue) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ },
/* 514 */
/***/ function(module, exports) {

	
	
	// stepper is used a lot. Saves allocation to return the same array wrapper.
	// This is fine and danger-free against mutations because the callsite
	// immediately destructures it and gets the numbers inside without passing the
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = stepper;
	
	var reusedTuple = [0, 0];
	
	function stepper(secondPerFrame, x, v, destX, k, b, precision) {
	  // Spring stiffness, in kg / s^2
	
	  // for animations, destX is really spring length (spring at rest). initial
	  // position is considered as the stretched/compressed position of a spring
	  var Fspring = -k * (x - destX);
	
	  // Damping, in kg / s
	  var Fdamper = -b * v;
	
	  // usually we put mass here, but for animation purposes, specifying mass is a
	  // bit redundant. you could simply adjust k and b accordingly
	  // let a = (Fspring + Fdamper) / mass;
	  var a = Fspring + Fdamper;
	
	  var newV = v + a * secondPerFrame;
	  var newX = x + newV * secondPerFrame;
	
	  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
	    reusedTuple[0] = destX;
	    reusedTuple[1] = 0;
	    return reusedTuple;
	  }
	
	  reusedTuple[0] = newX;
	  reusedTuple[1] = newV;
	  return reusedTuple;
	}
	
	module.exports = exports["default"];
	// array reference around.

/***/ },
/* 515 */
[2243, 2030],
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(2043);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function elementType(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  if (propType !== 'function' && propType !== 'string') {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ },
/* 517 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Router = __webpack_require__(520);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Router2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;
	
	var _reducer = __webpack_require__(923);
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__(922);
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _sync = __webpack_require__(2082);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _middleware = __webpack_require__(2081);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.syncHistoryWithStore = _sync2['default'];
	exports.routerMiddleware = _middleware2['default'];

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(194);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(68);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(126);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for putting history on context.
	 */
	var Router = function (_React$Component) {
	  _inherits(Router, _React$Component);
	
	  function Router() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Router);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props.history.location.pathname)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Router.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        history: this.props.history,
	        route: {
	          location: this.props.history.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Router.prototype.computeMatch = function computeMatch(pathname) {
	    return {
	      path: "/",
	      url: "/",
	      params: {},
	      isExact: pathname === "/"
	    };
	  };
	
	  Router.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        history = _props.history;
	
	
	    (0, _invariant2.default)(children == null || _react2.default.Children.count(children) === 1, "A <Router> may have only one child element");
	
	    // Do this here so we can setState when a <Redirect> changes the
	    // location in componentWillMount. This happens e.g. when doing
	    // server rendering using a <StaticRouter>.
	    this.unlisten = history.listen(function () {
	      _this2.setState({
	        match: _this2.computeMatch(history.location.pathname)
	      });
	    });
	  };
	
	  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(this.props.history === nextProps.history, "You cannot change <Router history>");
	  };
	
	  Router.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unlisten();
	  };
	
	  Router.prototype.render = function render() {
	    var children = this.props.children;
	
	    return children ? _react2.default.Children.only(children) : null;
	  };
	
	  return Router;
	}(_react2.default.Component);
	
	Router.propTypes = {
	  history: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node
	};
	Router.contextTypes = {
	  router: _propTypes2.default.object
	};
	Router.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Router;

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(925);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compilePath = function compilePath(pattern, options) {
	  var cacheKey = "" + options.end + options.strict + options.sensitive;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var keys = [];
	  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
	  var compiledPattern = { re: re, keys: keys };
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledPattern;
	    cacheCount++;
	  }
	
	  return compiledPattern;
	};
	
	/**
	 * Public API for matching a URL pathname to a path pattern.
	 */
	var matchPath = function matchPath(pathname) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var parent = arguments[2];
	
	  if (typeof options === "string") options = { path: options };
	
	  var _options = options,
	      path = _options.path,
	      _options$exact = _options.exact,
	      exact = _options$exact === undefined ? false : _options$exact,
	      _options$strict = _options.strict,
	      strict = _options$strict === undefined ? false : _options$strict,
	      _options$sensitive = _options.sensitive,
	      sensitive = _options$sensitive === undefined ? false : _options$sensitive;
	
	
	  if (path == null) return parent;
	
	  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
	      re = _compilePath.re,
	      keys = _compilePath.keys;
	
	  var match = re.exec(pathname);
	
	  if (!match) return null;
	
	  var url = match[0],
	      values = match.slice(1);
	
	  var isExact = pathname === url;
	
	  if (exact && !isExact) return null;
	
	  return {
	    path: path, // the path pattern used to match
	    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
	    isExact: isExact, // whether or not we matched exactly
	    params: keys.reduce(function (memo, key, index) {
	      memo[key.name] = values[index];
	      return memo;
	    }, {})
	  };
	};
	
	exports.default = matchPath;

/***/ },
/* 522 */
[2411, 2089],
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stripDiacritics = __webpack_require__(932);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	var _trim = __webpack_require__(2097);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function filterOptions(options, filterValue, excludeOptions, props) {
		var _this = this;
	
		if (props.ignoreAccents) {
			filterValue = (0, _stripDiacritics2.default)(filterValue);
		}
	
		if (props.ignoreCase) {
			filterValue = filterValue.toLowerCase();
		}
	
		if (props.trimFilter) {
			filterValue = (0, _trim2.default)(filterValue);
		}
	
		if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
			return i[props.valueKey];
		});
	
		return options.filter(function (option) {
			if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
			if (props.filterOption) return props.filterOption.call(_this, option, filterValue);
			if (!filterValue) return true;
			var valueTest = String(option[props.valueKey]);
			var labelTest = String(option[props.labelKey]);
	
			if (props.ignoreAccents) {
				if (props.matchProp !== 'label') valueTest = (0, _stripDiacritics2.default)(valueTest);
				if (props.matchProp !== 'value') labelTest = (0, _stripDiacritics2.default)(labelTest);
			}
	
			if (props.ignoreCase) {
				if (props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
				if (props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
			}
			return props.matchPos === 'start' ? props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
		});
	}
	
	exports.default = filterOptions;

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function menuRenderer(_ref) {
		var focusedOption = _ref.focusedOption,
		    focusOption = _ref.focusOption,
		    inputValue = _ref.inputValue,
		    instancePrefix = _ref.instancePrefix,
		    labelKey = _ref.labelKey,
		    onFocus = _ref.onFocus,
		    onOptionRef = _ref.onOptionRef,
		    onSelect = _ref.onSelect,
		    optionClassName = _ref.optionClassName,
		    optionComponent = _ref.optionComponent,
		    optionRenderer = _ref.optionRenderer,
		    options = _ref.options,
		    removeValue = _ref.removeValue,
		    selectValue = _ref.selectValue,
		    valueArray = _ref.valueArray,
		    valueKey = _ref.valueKey;
	
		var Option = optionComponent;
	
		return options.map(function (option, i) {
			var isSelected = valueArray && valueArray.some(function (x) {
				return x[valueKey] == option[valueKey];
			});
			var isFocused = option === focusedOption;
			var optionClass = (0, _classnames2.default)(optionClassName, {
				'Select-option': true,
				'is-selected': isSelected,
				'is-focused': isFocused,
				'is-disabled': option.disabled
			});
	
			return _react2.default.createElement(
				Option,
				{
					className: optionClass,
					focusOption: focusOption,
					inputValue: inputValue,
					instancePrefix: instancePrefix,
					isDisabled: option.disabled,
					isFocused: isFocused,
					isSelected: isSelected,
					key: 'option-' + i + '-' + option[valueKey],
					onFocus: onFocus,
					onSelect: onSelect,
					option: option,
					optionIndex: i,
					ref: function ref(_ref2) {
						onOptionRef(_ref2, isFocused);
					},
					removeValue: removeValue,
					selectValue: selectValue
				},
				optionRenderer(option, i, inputValue)
			);
		});
	}
	
	exports.default = menuRenderer;

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.isValidDelay = isValidDelay;
	exports.objectValues = objectValues;
	exports.falseOrElement = exports.falseOrDelay = void 0;
	
	var _react = __webpack_require__(1);
	
	function isValidDelay(val) {
	  return typeof val === 'number' && !isNaN(val) && val > 0;
	}
	
	function objectValues(obj) {
	  return Object.keys(obj).map(function (key) {
	    return obj[key];
	  });
	}
	
	function withRequired(fn) {
	  fn.isRequired = function (props, propName, componentName) {
	    var prop = props[propName];
	
	    if (typeof prop === 'undefined') {
	      return new Error("The prop " + propName + " is marked as required in \n      " + componentName + ", but its value is undefined.");
	    }
	
	    fn(props, propName, componentName);
	  };
	
	  return fn;
	}
	
	var falseOrDelay = withRequired(function (props, propName, componentName) {
	  var prop = props[propName];
	
	  if (prop !== false && !isValidDelay(prop)) {
	    return new Error(componentName + " expect " + propName + " \n      to be a valid Number > 0 or equal to false. " + prop + " given.");
	  }
	
	  return null;
	});
	exports.falseOrDelay = falseOrDelay;
	var falseOrElement = withRequired(function (props, propName, componentName) {
	  var prop = props[propName];
	
	  if (prop !== false && !(0, _react.isValidElement)(prop)) {
	    return new Error(componentName + " expect " + propName + " \n      to be a valid react element or equal to false. " + prop + " given.");
	  }
	
	  return null;
	});
	exports.falseOrElement = falseOrElement;

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(527));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(31));
	
	var _reactLifecyclesCompat = __webpack_require__(906);
	
	var _PropTypes = __webpack_require__(2121);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  var _proto = Transition.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: null // allows for nested Transitions
	
	    };
	  };
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  }; // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      var node = _reactDom.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      _this2.onTransitionEnd(node, enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
	
	    if (!exit) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	
	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      this.props.addEndListener(node, this.nextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return _react.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func // Name the function so it is clearer in the documentation
	
	} : {};
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);
	
	exports.default = _default;

/***/ },
/* 527 */
[2243, 2118],
/* 528 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function isAbsolute(pathname) {
	  return pathname.charAt(0) === '/';
	}
	
	// About 1.5x faster than the two-arg version of Array#splice()
	function spliceOne(list, index) {
	  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
	    list[i] = list[k];
	  }
	
	  list.pop();
	}
	
	// This implementation is based heavily on node's url.parse
	function resolvePathname(to) {
	  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var toParts = to && to.split('/') || [];
	  var fromParts = from && from.split('/') || [];
	
	  var isToAbs = to && isAbsolute(to);
	  var isFromAbs = from && isAbsolute(from);
	  var mustEndAbs = isToAbs || isFromAbs;
	
	  if (to && isAbsolute(to)) {
	    // to is absolute
	    fromParts = toParts;
	  } else if (toParts.length) {
	    // to is relative, drop the filename
	    fromParts.pop();
	    fromParts = fromParts.concat(toParts);
	  }
	
	  if (!fromParts.length) return '/';
	
	  var hasTrailingSlash = void 0;
	  if (fromParts.length) {
	    var last = fromParts[fromParts.length - 1];
	    hasTrailingSlash = last === '.' || last === '..' || last === '';
	  } else {
	    hasTrailingSlash = false;
	  }
	
	  var up = 0;
	  for (var i = fromParts.length; i >= 0; i--) {
	    var part = fromParts[i];
	
	    if (part === '.') {
	      spliceOne(fromParts, i);
	    } else if (part === '..') {
	      spliceOne(fromParts, i);
	      up++;
	    } else if (up) {
	      spliceOne(fromParts, i);
	      up--;
	    }
	  }
	
	  if (!mustEndAbs) for (; up--; up) {
	    fromParts.unshift('..');
	  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
	
	  var result = fromParts.join('/');
	
	  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
	
	  return result;
	}
	
	exports.default = resolvePathname;
	module.exports = exports['default'];

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1636);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./LocalCourtSearch.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./LocalCourtSearch.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1656);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./filings.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./filings.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 531 */
/***/ function(module, exports) {

	/**
	 * Check if `obj` is an object.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isObject(obj) {
	  return null !== obj && 'object' === typeof obj;
	}
	
	module.exports = isObject;


/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {var nextTick = __webpack_require__(231).nextTick;
	var apply = Function.prototype.apply;
	var slice = Array.prototype.slice;
	var immediateIds = {};
	var nextImmediateId = 0;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) { timeout.close(); };
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// That's not how node.js implements it but the exposed api is the same.
	exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
	  var id = nextImmediateId++;
	  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	
	  immediateIds[id] = true;
	
	  nextTick(function onNextTick() {
	    if (immediateIds[id]) {
	      // fn.call() is faster so we optimize for the common use-case
	      // @see http://jsperf.com/call-apply-segu
	      if (args) {
	        fn.apply(null, args);
	      } else {
	        fn.call(null);
	      }
	      // Prevent ids from leaking
	      exports.clearImmediate(id);
	    }
	  });
	
	  return id;
	};
	
	exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
	  delete immediateIds[id];
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(532).setImmediate, __webpack_require__(532).clearImmediate))

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(752);

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1324);

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var sheet = __webpack_require__(537);
	var Stylis = _interopDefault(__webpack_require__(978));
	__webpack_require__(981);
	
	// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
	// inlined to avoid umd wrapper and peerDep warnings/installing stylis
	// since we use stylis after closure compiler
	var delimiter = '/*|*/';
	var needle = delimiter + '}';
	
	function toSheet(block) {
	  if (block) {
	    Sheet.current.insert(block + '}');
	  }
	}
	
	var Sheet = {
	  current: null
	};
	var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
	  switch (context) {
	    // property
	    case 1:
	      {
	        switch (content.charCodeAt(0)) {
	          case 64:
	            {
	              // @import
	              Sheet.current.insert(content + ';');
	              return '';
	            }
	          // charcode for l
	
	          case 108:
	            {
	              // charcode for b
	              // this ignores label
	              if (content.charCodeAt(2) === 98) {
	                return '';
	              }
	            }
	        }
	
	        break;
	      }
	    // selector
	
	    case 2:
	      {
	        if (ns === 0) return content + delimiter;
	        break;
	      }
	    // at-rule
	
	    case 3:
	      {
	        switch (ns) {
	          // @font-face, @page
	          case 102:
	          case 112:
	            {
	              Sheet.current.insert(selectors[0] + content);
	              return '';
	            }
	
	          default:
	            {
	              return content + (at === 0 ? delimiter : '');
	            }
	        }
	      }
	
	    case -2:
	      {
	        content.split(needle).forEach(toSheet);
	      }
	  }
	};
	
	var createCache = function createCache(options) {
	  if (options === undefined) options = {};
	  var key = options.key || 'css';
	  var stylisOptions;
	
	  if (options.prefix !== undefined) {
	    stylisOptions = {
	      prefix: options.prefix
	    };
	  }
	
	  var stylis = new Stylis(stylisOptions);
	
	  if (false) {
	    // $FlowFixMe
	    if (/[^a-z-]/.test(key)) {
	      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
	    }
	  }
	
	  var inserted = {}; // $FlowFixMe
	
	  var container;
	
	  {
	    container = options.container || document.head;
	    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
	    Array.prototype.forEach.call(nodes, function (node) {
	      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
	
	      attrib.split(' ').forEach(function (id) {
	        inserted[id] = true;
	      });
	
	      if (node.parentNode !== container) {
	        container.appendChild(node);
	      }
	    });
	  }
	
	  var _insert;
	
	  {
	    stylis.use(options.stylisPlugins)(ruleSheet);
	
	    _insert = function insert(selector, serialized, sheet, shouldCache) {
	      var name = serialized.name;
	      Sheet.current = sheet;
	
	      if (false) {
	        var map = serialized.map;
	        Sheet.current = {
	          insert: function insert(rule) {
	            sheet.insert(rule + map);
	          }
	        };
	      }
	
	      stylis(selector, serialized.styles);
	
	      if (shouldCache) {
	        cache.inserted[name] = true;
	      }
	    };
	  }
	
	  if (false) {
	    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
	    var commentStart = /\/\*/g;
	    var commentEnd = /\*\//g;
	    stylis.use(function (context, content) {
	      switch (context) {
	        case -1:
	          {
	            while (commentStart.test(content)) {
	              commentEnd.lastIndex = commentStart.lastIndex;
	
	              if (commentEnd.test(content)) {
	                commentStart.lastIndex = commentEnd.lastIndex;
	                continue;
	              }
	
	              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
	            }
	
	            commentStart.lastIndex = 0;
	            break;
	          }
	      }
	    });
	    stylis.use(function (context, content, selectors) {
	      switch (context) {
	        case -1:
	          {
	            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
	            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);
	
	            if (unsafePseudoClasses && cache.compat !== true) {
	              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
	                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
	                var ignore = ignoreRegExp.test(content);
	
	                if (unsafePseudoClass && !ignore) {
	                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
	                }
	              });
	            }
	
	            break;
	          }
	      }
	    });
	  }
	
	  var cache = {
	    key: key,
	    sheet: new sheet.StyleSheet({
	      key: key,
	      container: container,
	      nonce: options.nonce,
	      speedy: options.speedy
	    }),
	    nonce: options.nonce,
	    inserted: inserted,
	    registered: {},
	    insert: _insert
	  };
	  return cache;
	};
	
	exports.default = createCache;


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var hashString = _interopDefault(__webpack_require__(976));
	var unitless = _interopDefault(__webpack_require__(979));
	var memoize = _interopDefault(__webpack_require__(977));
	
	var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
	var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
	var hyphenateRegex = /[A-Z]|^ms/g;
	var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
	
	var isCustomProperty = function isCustomProperty(property) {
	  return property.charCodeAt(1) === 45;
	};
	
	var isProcessableValue = function isProcessableValue(value) {
	  return value != null && typeof value !== 'boolean';
	};
	
	var processStyleName = memoize(function (styleName) {
	  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
	});
	
	var processStyleValue = function processStyleValue(key, value) {
	  switch (key) {
	    case 'animation':
	    case 'animationName':
	      {
	        if (typeof value === 'string') {
	          return value.replace(animationRegex, function (match, p1, p2) {
	            cursor = {
	              name: p1,
	              styles: p2,
	              next: cursor
	            };
	            return p1;
	          });
	        }
	      }
	  }
	
	  if (unitless[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
	    return value + 'px';
	  }
	
	  return value;
	};
	
	if (false) {
	  var contentValuePattern = /(attr|calc|counters?|url)\(/;
	  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
	  var oldProcessStyleValue = processStyleValue;
	  var msPattern = /^-ms-/;
	  var hyphenPattern = /-(.)/g;
	  var hyphenatedCache = {};
	
	  processStyleValue = function processStyleValue(key, value) {
	    if (key === 'content') {
	      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
	        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
	      }
	    }
	
	    var processed = oldProcessStyleValue(key, value);
	
	    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
	      hyphenatedCache[key] = true;
	      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
	        return _char.toUpperCase();
	      }) + "?");
	    }
	
	    return processed;
	  };
	}
	
	var shouldWarnAboutInterpolatingClassNameFromCss = true;
	
	function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
	  if (interpolation == null) {
	    return '';
	  }
	
	  if (interpolation.__emotion_styles !== undefined) {
	    if (false) {
	      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	    }
	
	    return interpolation;
	  }
	
	  switch (typeof interpolation) {
	    case 'boolean':
	      {
	        return '';
	      }
	
	    case 'object':
	      {
	        if (interpolation.anim === 1) {
	          cursor = {
	            name: interpolation.name,
	            styles: interpolation.styles,
	            next: cursor
	          };
	          return interpolation.name;
	        }
	
	        if (interpolation.styles !== undefined) {
	          var next = interpolation.next;
	
	          if (next !== undefined) {
	            // not the most efficient thing ever but this is a pretty rare case
	            // and there will be very few iterations of this generally
	            while (next !== undefined) {
	              cursor = {
	                name: next.name,
	                styles: next.styles,
	                next: cursor
	              };
	              next = next.next;
	            }
	          }
	
	          var styles = interpolation.styles + ";";
	
	          if (false) {
	            styles += interpolation.map;
	          }
	
	          return styles;
	        }
	
	        return createStringFromObject(mergedProps, registered, interpolation);
	      }
	
	    case 'function':
	      {
	        if (mergedProps !== undefined) {
	          var previousCursor = cursor;
	          var result = interpolation(mergedProps);
	          cursor = previousCursor;
	          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
	        } else if (false) {
	          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
	        }
	
	        break;
	      }
	
	    case 'string':
	      if (false) {
	        var matched = [];
	        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
	          var fakeVarName = "animation" + matched.length;
	          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
	          return "${" + fakeVarName + "}";
	        });
	
	        if (matched.length) {
	          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
	        }
	      }
	
	      break;
	  } // finalize string values (regular strings and functions interpolated into css calls)
	
	
	  if (registered == null) {
	    return interpolation;
	  }
	
	  var cached = registered[interpolation];
	
	  if (false) {
	    console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
	    shouldWarnAboutInterpolatingClassNameFromCss = false;
	  }
	
	  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
	}
	
	function createStringFromObject(mergedProps, registered, obj) {
	  var string = '';
	
	  if (Array.isArray(obj)) {
	    for (var i = 0; i < obj.length; i++) {
	      string += handleInterpolation(mergedProps, registered, obj[i], false);
	    }
	  } else {
	    for (var _key in obj) {
	      var value = obj[_key];
	
	      if (typeof value !== 'object') {
	        if (registered != null && registered[value] !== undefined) {
	          string += _key + "{" + registered[value] + "}";
	        } else if (isProcessableValue(value)) {
	          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
	        }
	      } else {
	        if (_key === 'NO_COMPONENT_SELECTOR' && ("production") !== 'production') {
	          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	        }
	
	        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
	          for (var _i = 0; _i < value.length; _i++) {
	            if (isProcessableValue(value[_i])) {
	              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
	            }
	          }
	        } else {
	          var interpolated = handleInterpolation(mergedProps, registered, value, false);
	
	          switch (_key) {
	            case 'animation':
	            case 'animationName':
	              {
	                string += processStyleName(_key) + ":" + interpolated + ";";
	                break;
	              }
	
	            default:
	              {
	                if (false) {
	                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
	                }
	
	                string += _key + "{" + interpolated + "}";
	              }
	          }
	        }
	      }
	    }
	  }
	
	  return string;
	}
	
	var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
	var sourceMapPattern;
	
	if (false) {
	  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
	} // this is the cursor for keyframes
	// keyframes are stored on the SerializedStyles object as a linked list
	
	
	var cursor;
	var serializeStyles = function serializeStyles(args, registered, mergedProps) {
	  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
	    return args[0];
	  }
	
	  var stringMode = true;
	  var styles = '';
	  cursor = undefined;
	  var strings = args[0];
	
	  if (strings == null || strings.raw === undefined) {
	    stringMode = false;
	    styles += handleInterpolation(mergedProps, registered, strings, false);
	  } else {
	    if (false) {
	      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
	    }
	
	    styles += strings[0];
	  } // we start at 1 since we've already handled the first arg
	
	
	  for (var i = 1; i < args.length; i++) {
	    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
	
	    if (stringMode) {
	      if (false) {
	        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
	      }
	
	      styles += strings[i];
	    }
	  }
	
	  var sourceMap;
	
	  if (false) {
	    styles = styles.replace(sourceMapPattern, function (match) {
	      sourceMap = match;
	      return '';
	    });
	  } // using a global regex with .exec is stateful so lastIndex has to be reset each time
	
	
	  labelPattern.lastIndex = 0;
	  var identifierName = '';
	  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
	
	  while ((match = labelPattern.exec(styles)) !== null) {
	    identifierName += '-' + // $FlowFixMe we know it's not null
	    match[1];
	  }
	
	  var name = hashString(styles) + identifierName;
	
	  if (false) {
	    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
	    return {
	      name: name,
	      styles: styles,
	      map: sourceMap,
	      next: cursor,
	      toString: function toString() {
	        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
	      }
	    };
	  }
	
	  return {
	    name: name,
	    styles: styles,
	    next: cursor
	  };
	};
	
	exports.serializeStyles = serializeStyles;


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/*
	
	Based off glamor's StyleSheet, thanks Sunil ❤️
	
	high performance StyleSheet for css-in-js systems
	
	- uses multiple style tags behind the scenes for millions of rules
	- uses `insertRule` for appending in production for *much* faster performance
	
	// usage
	
	import { StyleSheet } from '@emotion/sheet'
	
	let styleSheet = new StyleSheet({ key: '', container: document.head })
	
	styleSheet.insert('#box { border: 1px solid red; }')
	- appends a css rule into the stylesheet
	
	styleSheet.flush()
	- empties the stylesheet of all its contents
	
	*/
	// $FlowFixMe
	function sheetForTag(tag) {
	  if (tag.sheet) {
	    // $FlowFixMe
	    return tag.sheet;
	  } // this weirdness brought to you by firefox
	
	  /* istanbul ignore next */
	
	
	  for (var i = 0; i < document.styleSheets.length; i++) {
	    if (document.styleSheets[i].ownerNode === tag) {
	      // $FlowFixMe
	      return document.styleSheets[i];
	    }
	  }
	}
	
	function createStyleElement(options) {
	  var tag = document.createElement('style');
	  tag.setAttribute('data-emotion', options.key);
	
	  if (options.nonce !== undefined) {
	    tag.setAttribute('nonce', options.nonce);
	  }
	
	  tag.appendChild(document.createTextNode(''));
	  return tag;
	}
	
	var StyleSheet =
	/*#__PURE__*/
	function () {
	  function StyleSheet(options) {
	    this.isSpeedy = options.speedy === undefined ? ("production") === 'production' : options.speedy;
	    this.tags = [];
	    this.ctr = 0;
	    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
	
	    this.key = options.key;
	    this.container = options.container;
	    this.before = null;
	  }
	
	  var _proto = StyleSheet.prototype;
	
	  _proto.insert = function insert(rule) {
	    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
	    // it's 1 in dev because we insert source maps that map a single rule to a location
	    // and you can only have one source map per style tag
	    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
	      var _tag = createStyleElement(this);
	
	      var before;
	
	      if (this.tags.length === 0) {
	        before = this.before;
	      } else {
	        before = this.tags[this.tags.length - 1].nextSibling;
	      }
	
	      this.container.insertBefore(_tag, before);
	      this.tags.push(_tag);
	    }
	
	    var tag = this.tags[this.tags.length - 1];
	
	    if (this.isSpeedy) {
	      var sheet = sheetForTag(tag);
	
	      try {
	        // this is a really hot path
	        // we check the second character first because having "i"
	        // as the second character will happen less often than
	        // having "@" as the first character
	        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
	        // the big drawback is that the css won't be editable in devtools
	
	        sheet.insertRule(rule, // we need to insert @import rules before anything else
	        // otherwise there will be an error
	        // technically this means that the @import rules will
	        // _usually_(not always since there could be multiple style tags)
	        // be the first ones in prod and generally later in dev
	        // this shouldn't really matter in the real world though
	        // @import is generally only used for font faces from google fonts and etc.
	        // so while this could be technically correct then it would be slower and larger
	        // for a tiny bit of correctness that won't matter in the real world
	        isImportRule ? 0 : sheet.cssRules.length);
	      } catch (e) {
	        if (false) {
	          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
	        }
	      }
	    } else {
	      tag.appendChild(document.createTextNode(rule));
	    }
	
	    this.ctr++;
	  };
	
	  _proto.flush = function flush() {
	    // $FlowFixMe
	    this.tags.forEach(function (tag) {
	      return tag.parentNode.removeChild(tag);
	    });
	    this.tags = [];
	    this.ctr = 0;
	  };
	
	  return StyleSheet;
	}();
	
	exports.StyleSheet = StyleSheet;


/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(244);
	
	function reviver(key, value) {
	  if ((0, _util.isObject)(value)) {
	    var result = (0, _util.typeReviver)(value);
	
	    if (result) {
	      return result.value;
	    }
	  }
	
	  return value;
	}
	
	exports.default = reviver;

/***/ },
/* 539 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = configureDepth;
	var DEPTH_KEY = exports.DEPTH_KEY = '$___storybook.depthKey';
	
	function configureDepth(obj) {
	  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  obj[DEPTH_KEY] = depth; // eslint-disable-line no-param-reassign
	
	  return obj;
	}

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getOwnPropertyDescriptor = __webpack_require__(1266);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// IE11 may return an undefined descriptor, but it supports Function#name
	var func = function unnamed() {};
	var nameDescriptor = (0, _getOwnPropertyDescriptor2.default)(func, 'name');
	// This condition is true in modern browsers that implement Function#name properly
	var canConfigureName = !nameDescriptor || nameDescriptor.configurable;
	
	exports.default = canConfigureName;

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.config = undefined;
	
	var _assign = __webpack_require__(275);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.configureActions = configureActions;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = exports.config = {
	  depth: 10
	};
	
	function configureActions() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _assign2.default)(config, options);
	}

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action = __webpack_require__(1010);
	
	Object.defineProperty(exports, 'action', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_action).default;
	  }
	});
	
	var _configureActions = __webpack_require__(541);
	
	Object.defineProperty(exports, 'configureActions', {
	  enumerable: true,
	  get: function get() {
	    return _configureActions.configureActions;
	  }
	});
	
	var _decorateAction = __webpack_require__(1011);
	
	Object.defineProperty(exports, 'decorateAction', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_decorateAction).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hrefTo = exports.linkTo = exports.openLink = undefined;
	
	var _promise = __webpack_require__(427);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _toConsumableArray2 = __webpack_require__(280);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _addons = __webpack_require__(338);
	
	var _addons2 = _interopRequireDefault(_addons);
	
	var _ = __webpack_require__(168);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var openLink = exports.openLink = function openLink(params) {
	  return _addons2.default.getChannel().emit(_.EVENT_ID, params);
	};
	
	var valueOrCall = function valueOrCall(args) {
	  return function (value) {
	    return typeof value === 'function' ? value.apply(undefined, (0, _toConsumableArray3.default)(args)) : value;
	  };
	};
	
	var linkTo = exports.linkTo = function linkTo(kind, story) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var resolver = valueOrCall(args);
	    openLink({
	      kind: resolver(kind),
	      story: resolver(story)
	    });
	  };
	};
	
	var hrefTo = exports.hrefTo = function hrefTo(kind, story) {
	  return new _promise2.default(function (resolve) {
	    var channel = _addons2.default.getChannel();
	    channel.on(_.RECEIVE_HREF_EVENT_ID, resolve);
	    channel.emit(_.REQUEST_HREF_EVENT_ID, { kind: kind, story: story });
	  });
	};

/***/ },
/* 544 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _global = global,
	    console = _global.console;
	var logger = exports.logger = {
	  info: function info(message) {
	    return console.log(message);
	  },
	  warn: function warn(message) {
	    return console.warn(message);
	  },
	  error: function error(message) {
	    return console.error(message);
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(114);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(428);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(103);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(140);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(279);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(278);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(1027);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LEFT_BUTTON = 0;
	// Cmd/Ctrl/Shift/Alt + Click should trigger default browser behaviour. Same applies to non-left clicks
	var isPlainLeftClick = function isPlainLeftClick(e) {
	  return e.button === LEFT_BUTTON && !e.altKey && !e.ctrlKey && !e.metaKey && !e.shiftKey;
	};
	
	var wrapOnClick = function wrapOnClick(fn) {
	  return function (e) {
	    return isPlainLeftClick(e) ? e.preventDefault() || fn(e) : false;
	  };
	};
	
	var RoutedLink = function (_React$Component) {
	  (0, _inherits3.default)(RoutedLink, _React$Component);
	
	  function RoutedLink(props) {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, RoutedLink);
	
	    for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      rest[_key - 1] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = RoutedLink.__proto__ || (0, _getPrototypeOf2.default)(RoutedLink)).call.apply(_ref, [this].concat([props].concat(rest))));
	
	    var onClick = props.onClick;
	
	    _this.onClick = onClick ? wrapOnClick(onClick) : undefined;
	    return _this;
	  }
	
	  (0, _createClass3.default)(RoutedLink, [{
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(_ref2) {
	      var onClick = _ref2.onClick;
	
	      this.onClick = wrapOnClick(onClick);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var onClick = this.onClick;
	      var _props = this.props,
	          href = _props.href,
	          children = _props.children,
	          rest = (0, _objectWithoutProperties3.default)(_props, ['href', 'children']);
	
	      var props = (0, _extends3.default)({ href: href }, rest, { onClick: onClick });
	      return _react2.default.createElement(
	        'a',
	        props,
	        children
	      );
	    }
	  }]);
	  return RoutedLink;
	}(_react2.default.Component);
	
	exports.default = RoutedLink;
	
	
	RoutedLink.defaultProps = {
	  onClick: null,
	  href: '#',
	  children: null
	};
	
	RoutedLink.propTypes = {
	  onClick: _propTypes2.default.func,
	  href: _propTypes2.default.string,
	  children: _propTypes2.default.node
	};

/***/ },
/* 546 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var baseFonts = exports.baseFonts = {
	  fontFamily: '-apple-system, ".SFNSText-Regular", "San Francisco", BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Lucida Grande", "Arial", sans-serif',
	  color: '#444',
	  WebkitFontSmoothing: 'antialiased'
	};
	
	var monoFonts = exports.monoFonts = {
	  fontFamily: '"Operator Mono", "Fira Code Retina", "Fira Code", "FiraCode-Retina", "Andale Mono", "Lucida Console", Consolas, Monaco, monospace',
	  color: '#444',
	  WebkitFontSmoothing: 'antialiased'
	};

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(277);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(103);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(140);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(279);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(278);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _events = __webpack_require__(1036);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var count = 0; /* eslint no-underscore-dangle: 0 */
	
	
	function getId() {
	  count += 1;
	  return count;
	}
	
	var StoryStore = function (_EventEmitter) {
	  (0, _inherits3.default)(StoryStore, _EventEmitter);
	
	  function StoryStore() {
	    (0, _classCallCheck3.default)(this, StoryStore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (StoryStore.__proto__ || (0, _getPrototypeOf2.default)(StoryStore)).call(this));
	
	    _this._data = {};
	    _this._revision = 0;
	    return _this;
	  }
	
	  (0, _createClass3.default)(StoryStore, [{
	    key: 'getRevision',
	    value: function getRevision() {
	      return this._revision;
	    }
	  }, {
	    key: 'incrementRevision',
	    value: function incrementRevision() {
	      this._revision += 1;
	    }
	  }, {
	    key: 'addStory',
	    value: function addStory(kind, name, fn, fileName) {
	      if (!this._data[kind]) {
	        this._data[kind] = {
	          kind: kind,
	          fileName: fileName,
	          index: getId(),
	          stories: {}
	        };
	      }
	
	      this._data[kind].stories[name] = {
	        name: name,
	        index: getId(),
	        fn: fn
	      };
	
	      this.emit('storyAdded', kind, name, fn);
	    }
	  }, {
	    key: 'getStoryKinds',
	    value: function getStoryKinds() {
	      var _this2 = this;
	
	      return (0, _keys2.default)(this._data).map(function (key) {
	        return _this2._data[key];
	      }).filter(function (kind) {
	        return (0, _keys2.default)(kind.stories).length > 0;
	      }).sort(function (info1, info2) {
	        return info1.index - info2.index;
	      }).map(function (info) {
	        return info.kind;
	      });
	    }
	  }, {
	    key: 'getStories',
	    value: function getStories(kind) {
	      var _this3 = this;
	
	      if (!this._data[kind]) {
	        return [];
	      }
	
	      return (0, _keys2.default)(this._data[kind].stories).map(function (name) {
	        return _this3._data[kind].stories[name];
	      }).sort(function (info1, info2) {
	        return info1.index - info2.index;
	      }).map(function (info) {
	        return info.name;
	      });
	    }
	  }, {
	    key: 'getStoryFileName',
	    value: function getStoryFileName(kind) {
	      var storiesKind = this._data[kind];
	      if (!storiesKind) {
	        return null;
	      }
	
	      return storiesKind.fileName;
	    }
	  }, {
	    key: 'getStory',
	    value: function getStory(kind, name) {
	      var storiesKind = this._data[kind];
	      if (!storiesKind) {
	        return null;
	      }
	
	      var storyInfo = storiesKind.stories[name];
	      if (!storyInfo) {
	        return null;
	      }
	
	      return storyInfo.fn;
	    }
	  }, {
	    key: 'removeStoryKind',
	    value: function removeStoryKind(kind) {
	      if (this.hasStoryKind(kind)) {
	        this._data[kind].stories = {};
	      }
	    }
	  }, {
	    key: 'hasStoryKind',
	    value: function hasStoryKind(kind) {
	      return Boolean(this._data[kind]);
	    }
	  }, {
	    key: 'hasStory',
	    value: function hasStory(kind, name) {
	      return Boolean(this.getStory(kind, name));
	    }
	  }, {
	    key: 'dumpStoryBook',
	    value: function dumpStoryBook() {
	      var _this4 = this;
	
	      var data = this.getStoryKinds().map(function (kind) {
	        return {
	          kind: kind,
	          stories: _this4.getStories(kind)
	        };
	      });
	
	      return data;
	    }
	  }, {
	    key: 'size',
	    value: function size() {
	      return (0, _keys2.default)(this._data).length;
	    }
	  }, {
	    key: 'clean',
	    value: function clean() {
	      var _this5 = this;
	
	      this.getStoryKinds().forEach(function (kind) {
	        return delete _this5._data[kind];
	      });
	    }
	  }]);
	  return StoryStore;
	}(_events.EventEmitter);
	
	exports.default = StoryStore;

/***/ },
/* 548 */
[2244, 339],
/* 549 */
[2246, 1052],
/* 550 */
[2251, 1046, 1048, 1053],
/* 551 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(550);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(1060);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 553 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(325);
	
	var _Filings = __webpack_require__(711);
	
	var _Filings2 = _interopRequireDefault(_Filings);
	
	var _AdvancedSearch = __webpack_require__(704);
	
	var _AdvancedSearch2 = _interopRequireDefault(_AdvancedSearch);
	
	var _AdvancedSearchIR = __webpack_require__(705);
	
	var _AdvancedSearchIR2 = _interopRequireDefault(_AdvancedSearchIR);
	
	var _ErrorBoundary = __webpack_require__(568);
	
	var _ErrorBoundary2 = _interopRequireDefault(_ErrorBoundary);
	
	var _globalUtils = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Note for HMR, these 4 components must have an error in them somewhere
	 * I can get HMR to work on a temp component, but these might be importing some weird js someplace
	 */
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  App.prototype.render = function render() {
	    return _react2.default.createElement(
	      _ErrorBoundary2.default,
	      null,
	      _react2.default.createElement(
	        _reactRouterDom.BrowserRouter,
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_reactRouterDom.Route, { path: '/filings/:tab', component: _Filings2.default }),
	          _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/filings', render: function render() {
	              return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/filings/search-court-filings' });
	            } }),
	          (0, _globalUtils.isCourtDrive)() ? _react2.default.createElement(
	            _reactRouterDom.Switch,
	            null,
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/advanced-search/:courtType/:tab', component: _AdvancedSearch2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              exact: true,
	              path: '/advanced-search',
	              render: function render(_ref) {
	                var location = _ref.location;
	                return _react2.default.createElement(_reactRouterDom.Redirect, { to: { pathname: '/advanced-search/all/general', search: location.search } });
	              }
	            }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              exact: true,
	              path: '/advanced-search/all',
	              render: function render(_ref2) {
	                var location = _ref2.location;
	                return _react2.default.createElement(_reactRouterDom.Redirect, { to: { pathname: '/advanced-search/all/general', search: location.search } });
	              }
	            }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              exact: true,
	              path: '/advanced-search/bankruptcy',
	              render: function render(_ref3) {
	                var location = _ref3.location;
	                return _react2.default.createElement(_reactRouterDom.Redirect, { to: { pathname: '/advanced-search/bankruptcy/general', search: location.search } });
	              }
	            }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              exact: true,
	              path: '/advanced-search/civil',
	              render: function render(_ref4) {
	                var location = _ref4.location;
	                return _react2.default.createElement(_reactRouterDom.Redirect, { to: { pathname: '/advanced-search/civil/general', search: location.search } });
	              }
	            }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              exact: true,
	              path: '/advanced-search/criminal',
	              render: function render(_ref5) {
	                var location = _ref5.location;
	                return _react2.default.createElement(_reactRouterDom.Redirect, { to: { pathname: '/advanced-search/criminal/general', search: location.search } });
	              }
	            }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              exact: true,
	              path: '/advanced-search/appellate',
	              render: function render(_ref6) {
	                var location = _ref6.location;
	                return _react2.default.createElement(_reactRouterDom.Redirect, { to: { pathname: '/advanced-search/appellate/general', search: location.search } });
	              }
	            })
	          ) : _react2.default.createElement(
	            _reactRouterDom.Switch,
	            null,
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/advanced-search/:courtType/:tab', component: _AdvancedSearchIR2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              exact: true,
	              path: '/advanced-search',
	              render: function render(_ref7) {
	                var location = _ref7.location;
	                return _react2.default.createElement(_reactRouterDom.Redirect, { to: { pathname: '/advanced-search/bankruptcy/general', search: location.search } });
	              }
	            }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              exact: true,
	              path: '/advanced-search/bankruptcy',
	              render: function render(_ref8) {
	                var location = _ref8.location;
	                return _react2.default.createElement(_reactRouterDom.Redirect, { to: { pathname: '/advanced-search/bankruptcy/general', search: location.search } });
	              }
	            }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              exact: true,
	              path: '/advanced-search/extended',
	              render: function render(_ref9) {
	                var location = _ref9.location;
	                return _react2.default.createElement(_reactRouterDom.Redirect, { to: { pathname: '/advanced-search/bankruptcy/petitions', search: location.search } });
	              }
	            }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              exact: true,
	              path: '/advanced-search/schedules',
	              render: function render(_ref10) {
	                var location = _ref10.location;
	                return _react2.default.createElement(_reactRouterDom.Redirect, { to: { pathname: '/advanced-search/bankruptcy/schedules', search: location.search } });
	              }
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return App;
	}(_react.Component);
	
	exports.default = App;

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _ClioDocumentCategorySelector = __webpack_require__(342);
	
	var _ClioDocumentCategorySelector2 = _interopRequireDefault(_ClioDocumentCategorySelector);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClioMatter = __webpack_require__(556);
	
	var _ClioMatter2 = _interopRequireDefault(_ClioMatter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClioCaseFolderSettingsForm = function (_React$Component) {
	  _inherits(ClioCaseFolderSettingsForm, _React$Component);
	
	  function ClioCaseFolderSettingsForm() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ClioCaseFolderSettingsForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      // form values:
	      client_id: null,
	      matter_id: null,
	      document_category_id: null,
	
	      // form state:
	      isPristine: true,
	      isSubmitting: false
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	
	      _this.setState({ isSubmitting: true });
	
	      // Call onSave handler with the values
	      var _this$state = _this.state,
	          client_id = _this$state.client_id,
	          matter_id = _this$state.matter_id,
	          document_category_id = _this$state.document_category_id;
	
	      // TODO - all three fields are required.  Should provide some kind of feeback if anything
	      // is missing?
	
	      _this.props.onSave({
	        client_id: client_id,
	        matter_id: matter_id,
	        document_category_id: document_category_id
	      });
	
	      // reset form state
	      _this.setState({
	        isPristine: true,
	        isSubmitting: false
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ClioCaseFolderSettingsForm.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snapshot) {
	    var _this2 = this;
	
	    var prevSettings = prevProps.settings;
	
	    // when we receive settings prop, copy values to state
	    ['client_id', 'matter_id', 'document_category_id'].forEach(function (setting) {
	      if (prevSettings[setting] !== _this2.props.settings[setting]) _this2.state[setting] = _this2.props.settings[setting];
	    });
	  };
	
	  ClioCaseFolderSettingsForm.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        connectionId = _props.connectionId,
	        settings = _props.settings;
	    var _state = this.state,
	        isSubmitting = _state.isSubmitting,
	        isPristine = _state.isPristine;
	
	
	    return _react2.default.createElement(
	      _reactBootstrap.Form,
	      { onSubmit: this.handleSubmit },
	      false && _react2.default.createElement(
	        'pre',
	        null,
	        JSON.stringify(this.state)
	      ),
	      _react2.default.createElement(_ClioMatter2.default, {
	        connectionId: connectionId,
	        matterId: settings.matter_id,
	        onMatterSelect: function onMatterSelect(matter) {
	          return _this3.setState({
	            client_id: matter.client.id,
	            matter_id: matter.id,
	            isPristine: false
	          });
	        }
	      }),
	      _react2.default.createElement(
	        _reactBootstrap.Panel,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Panel.Heading,
	          null,
	          'Document Category'
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Panel.Body,
	          null,
	          _react2.default.createElement(_ClioDocumentCategorySelector2.default, {
	            connectionId: connectionId,
	            clearable: false,
	            required: true,
	            value: this.state.document_category_id,
	            onChange: function onChange(documentCategoryId) {
	              return _this3.setState({
	                document_category_id: documentCategoryId,
	                isPristine: false
	              });
	            }
	          })
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        { type: 'submit', bsStyle: 'primary', disabled: isSubmitting || isPristine },
	        'Save'
	      )
	    );
	  };
	
	  return ClioCaseFolderSettingsForm;
	}(_react2.default.Component);
	
	ClioCaseFolderSettingsForm.propTypes = {
	  connectionId: _propTypes2.default.number.isRequired,
	  settings: _propTypes2.default.object.isRequired,
	  onSave: _propTypes2.default.func.isRequired
	};
	exports.default = ClioCaseFolderSettingsForm;

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClioMatterSearch = __webpack_require__(557);
	
	var _ClioMatterSearch2 = _interopRequireDefault(_ClioMatterSearch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClioMatter = function (_Component) {
	  _inherits(ClioMatter, _Component);
	
	  function ClioMatter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ClioMatter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      isLoading: false,
	      showMatterSearch: false,
	      error: null,
	      matter: null
	    }, _this.handleMatterSelect = function (matter) {
	      _this.setState({ matter: matter });
	
	      if (_this.props.onMatterSelect) _this.props.onMatterSelect(matter);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ClioMatter.prototype.componentDidMount = function componentDidMount() {
	    this.loadMatter();
	  };
	
	  ClioMatter.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snapshot) {
	    if (prevProps.matterId !== this.props.matterId) this.loadMatter();
	  };
	
	  ClioMatter.prototype.loadMatter = function loadMatter() {
	    var _this2 = this;
	
	    var _props = this.props,
	        connectionId = _props.connectionId,
	        matterId = _props.matterId;
	
	
	    if (!matterId) return;
	
	    this.setState({ isLoading: true });
	
	    _superagent2.default.get('/rpc/integrations/connections/' + connectionId + '/clio/matters/' + matterId).then(function (response) {
	      _this2.setState({
	        isLoading: false,
	        error: null,
	        matter: response.body.data
	      });
	    }).catch(function (err) {
	      return _this2.setState({
	        isLoading: false,
	        error: "Failed to load clio matter"
	      });
	    });
	  };
	
	  ClioMatter.prototype.render = function render() {
	    var _this3 = this;
	
	    var _state = this.state,
	        isLoading = _state.isLoading,
	        error = _state.error,
	        matter = _state.matter;
	
	    // if the change matter button was clicked, or, there is no matter selected,
	    // we will show the chooser.
	
	    var showMatterChooser = this.state.showMatterSearch || !this.state.matter;
	
	    if (isLoading) return _react2.default.createElement(_reactBootstrap.ProgressBar, { now: 100 });
	
	    if (error) return _react2.default.createElement(
	      'div',
	      null,
	      'Failed to load Clio matter.'
	    );
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      matter && _react2.default.createElement(
	        _reactBootstrap.Panel,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Panel.Heading,
	          null,
	          'Clio Client'
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Panel.Body,
	          null,
	          matter.client.name
	        )
	      ),
	      !showMatterChooser && _react2.default.createElement(
	        _reactBootstrap.Panel,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Panel.Heading,
	          null,
	          'Clio Matter'
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Panel.Body,
	          null,
	          _react2.default.createElement(
	            'b',
	            null,
	            matter.display_number
	          ),
	          ' - ',
	          matter.description,
	          ' ',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { onClick: function onClick() {
	                return _this3.setState({ showMatterSearch: true });
	              } },
	            'Change Matter'
	          )
	        )
	      ),
	      showMatterChooser && _react2.default.createElement(
	        _reactBootstrap.Panel,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Panel.Heading,
	          null,
	          'Search Clio Matters'
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Panel.Body,
	          null,
	          _react2.default.createElement(_ClioMatterSearch2.default, {
	            connectionId: this.props.connectionId,
	            onSelectMatter: this.handleMatterSelect
	          })
	        )
	      )
	    );
	  };
	
	  return ClioMatter;
	}(_react.Component);
	
	ClioMatter.propTypes = {
	  connectionId: _propTypes2.default.number.isRequired,
	  matterId: _propTypes2.default.number,
	  onMatterSelect: _propTypes2.default.func
	};
	exports.default = ClioMatter;

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _async = __webpack_require__(233);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClioMatterSearch = function (_Component) {
	  _inherits(ClioMatterSearch, _Component);
	
	  function ClioMatterSearch() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ClioMatterSearch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.loadClioMatters = function (inputValue) {
	      var connectionId = _this.props.connectionId;
	
	
	      return _superagent2.default.get('/rpc/integrations/connections/' + connectionId + '/clio/matters').query({ query: inputValue }).then(function (response) {
	        return response.body.data;
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ClioMatterSearch.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(_async2.default, {
	      cacheOptions: true,
	      defaultOptions: true,
	      loadOptions: this.loadClioMatters,
	      isClearable: true,
	      placeholder: 'Search Clio Matters...',
	      getOptionValue: function getOptionValue(option) {
	        return option.id;
	      },
	      getOptionLabel: function getOptionLabel(option) {
	        return _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'b',
	            null,
	            option.display_number
	          ),
	          ' - ',
	          option.description
	        );
	      },
	      onChange: function onChange(option) {
	        return _this2.props.onSelectMatter(option);
	      }
	    });
	  };
	
	  return ClioMatterSearch;
	}(_react.Component);
	
	ClioMatterSearch.propTypes = {
	  connectionId: _propTypes2.default.number.isRequired,
	  onSelectMatter: _propTypes2.default.func.isRequired
	};
	exports.default = ClioMatterSearch;

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactFinalFormHtml5Validation = __webpack_require__(511);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _RocketMatterClientSelector = __webpack_require__(559);
	
	var _RocketMatterMatterSelector = __webpack_require__(560);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RocketMatterCaseFolderSettingsForm = function (_React$Component) {
	  _inherits(RocketMatterCaseFolderSettingsForm, _React$Component);
	
	  function RocketMatterCaseFolderSettingsForm() {
	    _classCallCheck(this, RocketMatterCaseFolderSettingsForm);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  RocketMatterCaseFolderSettingsForm.prototype.render = function render() {
	    var _props = this.props,
	        connectionId = _props.connectionId,
	        onSave = _props.onSave,
	        settings = _props.settings;
	
	
	    return _react2.default.createElement(
	      _reactFinalForm.Form,
	      { initialValues: settings, onSubmit: onSave },
	      function (_ref) {
	        var handleSubmit = _ref.handleSubmit,
	            pristine = _ref.pristine,
	            values = _ref.values,
	            submitting = _ref.submitting;
	        return _react2.default.createElement(
	          _reactBootstrap.Form,
	          { onSubmit: handleSubmit },
	          _react2.default.createElement(
	            _reactBootstrap.FormGroup,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.ControlLabel,
	              null,
	              'Client'
	            ),
	            _react2.default.createElement(_reactFinalFormHtml5Validation.Field, { name: 'client_id',
	              component: _RocketMatterClientSelector.FinalFormRocketMatterClientSelector,
	              connectionId: connectionId,
	              clearable: false,
	              required: true
	            })
	          ),
	          _lodash2.default.get(values, 'client_id') && _react2.default.createElement(
	            _reactBootstrap.FormGroup,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.ControlLabel,
	              null,
	              'Matter'
	            ),
	            _react2.default.createElement(_reactFinalFormHtml5Validation.Field, { name: 'matter_id',
	              component: _RocketMatterMatterSelector.FinalFormRocketMatterMatterSelector,
	              connectionId: connectionId,
	              clientId: _lodash2.default.get(values, 'client_id'),
	              clearable: false,
	              required: true
	            })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.FormGroup,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { type: 'submit', bsStyle: 'primary', disabled: pristine || submitting },
	              'Save'
	            )
	          )
	        );
	      }
	    );
	  };
	
	  return RocketMatterCaseFolderSettingsForm;
	}(_react2.default.Component);
	
	RocketMatterCaseFolderSettingsForm.propTypes = {
	  connectionId: _propTypes2.default.number.isRequired,
	  settings: _propTypes2.default.object.isRequired,
	  onSave: _propTypes2.default.func.isRequired
	};
	exports.default = RocketMatterCaseFolderSettingsForm;
	;

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FinalFormRocketMatterClientSelector = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RocketMatterClientSelector = function (_React$Component) {
	  _inherits(RocketMatterClientSelector, _React$Component);
	
	  function RocketMatterClientSelector() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RocketMatterClientSelector);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      isLoading: false,
	      isRefreshing: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  RocketMatterClientSelector.prototype.componentDidMount = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              this.loadClients(false);
	
	            case 1:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    function componentDidMount() {
	      return _ref.apply(this, arguments);
	    }
	
	    return componentDidMount;
	  }();
	
	  RocketMatterClientSelector.prototype.render = function render() {
	    var _this2 = this;
	
	    var _state = this.state,
	        isLoading = _state.isLoading,
	        isRefreshing = _state.isRefreshing,
	        clientSelectOptions = _state.clientSelectOptions;
	
	
	    if (isLoading && !clientSelectOptions) return _react2.default.createElement(_reactBootstrap.ProgressBar, { now: 100 });
	
	    var refreshClasses = (0, _classnames2.default)({
	      'fa': true,
	      'fa-refresh': true,
	      'fa-spin': isRefreshing
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { key: 'self', style: { position: 'relative' } },
	      _react2.default.createElement(_reactSelect2.default, _extends({
	        defaultOptions: true,
	        options: this.state.clientSelectOptions,
	        isClearable: true,
	        simpleValue: true,
	        disabled: isLoading
	      }, this.props)),
	      _react2.default.createElement('i', { className: refreshClasses,
	        style: {
	          position: 'absolute',
	          textAlign: 'center',
	          top: '12px',
	          right: '27px',
	          zIndex: 100,
	          cursor: 'pointer'
	        },
	        onClick: function onClick() {
	          return _this2.loadClients(true);
	        },
	        key: 'client-refresh-button'
	      })
	    );
	  };
	
	  RocketMatterClientSelector.prototype.loadClients = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(refresh) {
	      var connectionId, res, clientSelectOptions;
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              connectionId = this.props.connectionId;
	
	
	              this.setState({
	                isLoading: true,
	                isRefreshing: refresh
	              });
	
	              _context2.next = 4;
	              return _superagent2.default.get('/rpc/integrations/connections/' + connectionId + '/rocketmatter/clients').query({ refresh: refresh });
	
	            case 4:
	              res = _context2.sent;
	              clientSelectOptions = _lodash2.default.get(res.body, 'Clients', []).map(function (val) {
	                return { label: val.Code, value: val.ContactID };
	              });
	
	
	              this.setState({
	                isLoading: false,
	                isRefreshing: false,
	                clientSelectOptions: clientSelectOptions
	              });
	
	            case 7:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, this);
	    }));
	
	    function loadClients(_x) {
	      return _ref2.apply(this, arguments);
	    }
	
	    return loadClients;
	  }();
	
	  return RocketMatterClientSelector;
	}(_react2.default.Component);
	
	RocketMatterClientSelector.defaultProps = {
	  connectionId: null
	};
	RocketMatterClientSelector.propTypes = {
	  connectionId: _propTypes2.default.number.isRequired
	};
	exports.default = RocketMatterClientSelector;
	;
	
	/**
	 * FinalForm adaptor
	 */
	var FinalFormRocketMatterClientSelector = function FinalFormRocketMatterClientSelector(_ref3) {
	  var _ref3$input = _ref3.input,
	      value = _ref3$input.value,
	      _onChange = _ref3$input.onChange,
	      rest = _objectWithoutProperties(_ref3, ['input']);
	
	  return _react2.default.createElement(RocketMatterClientSelector, _extends({
	    value: value,
	    onChange: function onChange(selectedOption) {
	      return _onChange(selectedOption);
	    }
	  }, rest));
	};
	exports.FinalFormRocketMatterClientSelector = FinalFormRocketMatterClientSelector;

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FinalFormRocketMatterMatterSelector = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RocketMatterMatterSelector = function (_React$Component) {
	  _inherits(RocketMatterMatterSelector, _React$Component);
	
	  function RocketMatterMatterSelector() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RocketMatterMatterSelector);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      isLoading: false,
	      isRefreshing: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  RocketMatterMatterSelector.prototype.componentDidMount = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      var clientId;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              clientId = this.props.clientId;
	
	              if (!clientId) {
	                _context.next = 4;
	                break;
	              }
	
	              _context.next = 4;
	              return this.loadMatters();
	
	            case 4:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    function componentDidMount() {
	      return _ref.apply(this, arguments);
	    }
	
	    return componentDidMount;
	  }();
	
	  RocketMatterMatterSelector.prototype.componentDidUpdate = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(prevProps, prevState, snapshot) {
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              if (!(prevProps.clientId !== this.props.clientId)) {
	                _context2.next = 4;
	                break;
	              }
	
	              this.setState({ matterOptions: null });
	              _context2.next = 4;
	              return this.loadMatters();
	
	            case 4:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, this);
	    }));
	
	    function componentDidUpdate(_x, _x2, _x3) {
	      return _ref2.apply(this, arguments);
	    }
	
	    return componentDidUpdate;
	  }();
	
	  RocketMatterMatterSelector.prototype.render = function render() {
	    var _this2 = this;
	
	    var _state = this.state,
	        isLoading = _state.isLoading,
	        isRefreshing = _state.isRefreshing,
	        matterOptions = _state.matterOptions;
	
	
	    if (isLoading && !matterOptions) return _react2.default.createElement(_reactBootstrap.ProgressBar, { now: 100 });
	
	    var refreshClasses = (0, _classnames2.default)({
	      'fa': true,
	      'fa-refresh': true,
	      'fa-spin': isRefreshing
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { key: 'self', style: { position: 'relative' } },
	      _react2.default.createElement(_reactSelect2.default, _extends({
	        defaultOptions: true,
	        options: matterOptions,
	        isClearable: true,
	        simpleValue: true,
	        key: this.props.clientId,
	        disabled: isLoading
	      }, this.props)),
	      _react2.default.createElement('i', { className: refreshClasses,
	        style: {
	          position: 'absolute',
	          textAlign: 'center',
	          top: '12px',
	          right: '27px',
	          zIndex: 100,
	          cursor: 'pointer'
	        },
	        onClick: function onClick() {
	          !isRefreshing && _this2.loadMatters(true);
	        },
	        key: 'matter-refresh-button'
	      })
	    );
	  };
	
	  RocketMatterMatterSelector.prototype.loadMatters = function () {
	    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(refreshFromRocketMatter) {
	      var _props, connectionId, clientId, res, matterOptions;
	
	      return regeneratorRuntime.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _props = this.props, connectionId = _props.connectionId, clientId = _props.clientId;
	
	              if (!(!clientId || !connectionId)) {
	                _context3.next = 3;
	                break;
	              }
	
	              return _context3.abrupt('return');
	
	            case 3:
	
	              this.setState({
	                isLoading: true,
	                isRefreshing: refreshFromRocketMatter
	              });
	
	              _context3.next = 6;
	              return _superagent2.default.get('/rpc/integrations/connections/' + connectionId + '/rocketmatter/matters?client_id=' + clientId).query({ refresh: refreshFromRocketMatter });
	
	            case 6:
	              res = _context3.sent;
	              matterOptions = this.convertMattersToSelectOptions(_.get(res.body, 'Matters', []));
	
	
	              this.setState({
	                isLoading: false,
	                isRefreshing: false,
	                matterOptions: matterOptions
	              });
	
	            case 9:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, this);
	    }));
	
	    function loadMatters(_x4) {
	      return _ref3.apply(this, arguments);
	    }
	
	    return loadMatters;
	  }();
	
	  RocketMatterMatterSelector.prototype.convertMattersToSelectOptions = function convertMattersToSelectOptions(matters) {
	    var options = matters.map(function (matter) {
	      return { label: matter.MatterName, value: matter.MatterId };
	    });
	
	    return options;
	  };
	
	  RocketMatterMatterSelector.prototype.matterLabel = function matterLabel(matter) {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'b',
	        null,
	        matter.display_number
	      ),
	      ' - ',
	      matter.description
	    );
	  };
	
	  return RocketMatterMatterSelector;
	}(_react2.default.Component);
	
	RocketMatterMatterSelector.defaultProps = {
	  connectionId: null,
	  clientId: null
	};
	RocketMatterMatterSelector.propTypes = {
	  connectionId: _propTypes2.default.number.isRequired,
	  clientId: _propTypes2.default.number
	};
	exports.default = RocketMatterMatterSelector;
	;
	
	/**
	 * FinalForm compatible field, use like:
	 * ```
	 * <Field name="matter_id"
	 *   component={FinalFormClioMatterSelector}
	 *   connectionId={connectionId}
	 *   clientId={_.get(values, 'client_id')}
	 * />
	 * ```
	 */
	var FinalFormRocketMatterMatterSelector = function FinalFormRocketMatterMatterSelector(_ref4) {
	  var _ref4$input = _ref4.input,
	      value = _ref4$input.value,
	      _onChange = _ref4$input.onChange,
	      rest = _objectWithoutProperties(_ref4, ['input']);
	
	  return _react2.default.createElement(RocketMatterMatterSelector, _extends({
	    value: value,
	    onChange: function onChange(selectedOption) {
	      return _onChange(selectedOption);
	    }
	  }, rest));
	};
	exports.FinalFormRocketMatterMatterSelector = FinalFormRocketMatterMatterSelector;

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Notification = __webpack_require__(24);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _SharepointDriveSelector = __webpack_require__(344);
	
	var _SharepointDriveSelector2 = _interopRequireDefault(_SharepointDriveSelector);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _SharepointSiteSearch = __webpack_require__(345);
	
	var _SharepointSiteSearch2 = _interopRequireDefault(_SharepointSiteSearch);
	
	var _SharepointFolderSelector = __webpack_require__(603);
	
	var _SharepointFolderSelector2 = _interopRequireDefault(_SharepointFolderSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SharepointCasefolderSettings = function (_Component) {
	  _inherits(SharepointCasefolderSettings, _Component);
	
	  function SharepointCasefolderSettings() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SharepointCasefolderSettings);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._isMounted = false, _this.state = {
	      site: null,
	      selectedDrive: null,
	      error: false,
	      folderPath: []
	    }, _this.onSelectSite = function (value) {
	      _this.setStateIfMounted({ site: value });
	    }, _this.onSelectDrive = function (value) {
	      var newState = {};
	
	      // if drive is cleared, clear folder path as well
	      if (value === null) newState.folderPath = [];
	
	      _this.setStateIfMounted(_extends({ selectedDrive: value }, newState));
	    }, _this.onSelectFolder = function (newState) {
	      _this.setStateIfMounted(_extends({}, newState));
	    }, _this.onSave = function () {
	      var _this$props = _this.props,
	          connectionId = _this$props.connectionId,
	          casefolderId = _this$props.casefolderId;
	      var _this$state = _this.state,
	          site = _this$state.site,
	          selectedDrive = _this$state.selectedDrive,
	          folderPath = _this$state.folderPath;
	
	
	      var saveProps = {
	        drive_type: 'site',
	        site: site,
	        drive: selectedDrive,
	        folders: folderPath
	      };
	
	      _superagent2.default.post('/rpc/integrations/connections/' + connectionId + '/casefolders/' + casefolderId + '/sharepoint/drive').send(saveProps).then(function () {
	        _Notification.notify.success("Sharepoint Casefolder Settings Saved");
	
	        if (_this.props.onSave) _this.props.onSave(saveProps);
	      }).catch(function (e) {
	        console.log("Failed to save sharepoint settings ", e);
	        _Notification.notify.error("Failed to Save SharePoint Casefolder Settings");
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  SharepointCasefolderSettings.prototype.componentDidMount = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              this._isMounted = true;
	              _context.next = 3;
	              return this.loadCasefolderDrive();
	
	            case 3:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    function componentDidMount() {
	      return _ref.apply(this, arguments);
	    }
	
	    return componentDidMount;
	  }();
	
	  SharepointCasefolderSettings.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._isMounted = false;
	  };
	
	  // avoid state updates on unmounted component warnings
	
	
	  SharepointCasefolderSettings.prototype.setStateIfMounted = function setStateIfMounted(state) {
	    if (this._isMounted) this.setState(state);
	  };
	
	  SharepointCasefolderSettings.prototype.loadCasefolderDrive = function loadCasefolderDrive() {
	    var _this2 = this;
	
	    var _props = this.props,
	        connectionId = _props.connectionId,
	        casefolderId = _props.casefolderId;
	
	
	    this.setStateIfMounted({ isLoading: true });
	
	    _superagent2.default.get('/rpc/integrations/connections/' + connectionId + '/casefolders/' + casefolderId + '/sharepoint/drive').then(function (response) {
	      var _response$body = response.body,
	          site = _response$body.site,
	          selectedDrive = _response$body.drive,
	          folderPath = _response$body.folders;
	
	
	      _this2.setStateIfMounted({
	        isLoading: false,
	        site: site,
	        selectedDrive: selectedDrive,
	        folderPath: folderPath || []
	      });
	    }).catch(function (e) {
	      console.error(e.response);
	      _this2.setStateIfMounted({
	        isLoading: false,
	        error: e.response.status !== 404
	      });
	    });
	  };
	
	  SharepointCasefolderSettings.prototype.render = function render() {
	    var _this3 = this;
	
	    var _state = this.state,
	        folderPath = _state.folderPath,
	        site = _state.site,
	        selectedDrive = _state.selectedDrive;
	
	
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Panel,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Panel.Heading,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Panel.Title,
	            { componentClass: 'h3' },
	            'SharePoint Drive Settings'
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Panel.Body,
	          null,
	          function () {
	            if (_this3.state.error) return _react2.default.createElement(
	              _reactBootstrap.Alert,
	              { bsStyle: 'danger' },
	              'There was an error loading SharePoint Settings Information. If the problem persists, please contact CourtDrive support.'
	            );
	
	            if (_this3.state.isLoading) return _react2.default.createElement(_reactBootstrap.ProgressBar, { active: true, now: 100 });
	
	            return _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.ControlLabel,
	                  null,
	                  'Sharepoint Site'
	                ),
	                _react2.default.createElement(_SharepointSiteSearch2.default, {
	                  connectionId: _this3.props.connectionId,
	                  onSelectSite: _this3.onSelectSite,
	                  defaultValue: site
	                })
	              ),
	              site && _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.ControlLabel,
	                  null,
	                  'Sharepoint Document Library'
	                ),
	                _react2.default.createElement(_SharepointDriveSelector2.default, {
	                  connectionId: _this3.props.connectionId,
	                  siteId: site.id,
	                  defaultValue: _this3.state.selectedDrive,
	                  onSelectDrive: _this3.onSelectDrive
	                })
	              ),
	              selectedDrive && _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.ControlLabel,
	                  null,
	                  'Folder'
	                ),
	                _react2.default.createElement(_SharepointFolderSelector2.default, {
	                  connectionId: _this3.props.connectionId,
	                  selectedDrive: selectedDrive,
	                  onSelectFolder: _this3.onSelectFolder,
	                  folderPath: folderPath
	                })
	              ),
	              _this3.state.selectedDrive && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  { bsStyle: 'primary', disabled: !_this3.state.selectedDrive, onClick: _this3.onSave },
	                  'Save'
	                )
	              )
	            );
	          }()
	        )
	      )
	    );
	  };
	
	  return SharepointCasefolderSettings;
	}(_react.Component);
	
	SharepointCasefolderSettings.defaultProps = {
	  connectionId: null,
	  casefolderId: null
	};
	SharepointCasefolderSettings.propTypes = {
	  connectionId: _propTypes2.default.number.isRequired,
	  casefolderId: _propTypes2.default.number.isRequired,
	  onSave: _propTypes2.default.func,
	  onLoad: _propTypes2.default.func
	};
	exports.default = SharepointCasefolderSettings;

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(235);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _Notification = __webpack_require__(24);
	
	__webpack_require__(2144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UploadFolderTree = function (_Component) {
	  _inherits(UploadFolderTree, _Component);
	
	  function UploadFolderTree() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UploadFolderTree);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      isLoading: false,
	      finalPath: [],
	      folderOptions: []
	    }, _this.onValueChange = function (folder) {
	      _this.setState({ value: folder });
	
	      if (_this.props.valueSelected)
	        // sub-folder select changed, call the callback, appending current folder to the path
	        _this.props.valueSelected(_this.props.pathToFolder.concat(folder.name));else {
	        // top level select changed
	        var finalPath = [folder.name];
	        _this.setState({ finalPath: finalPath });
	        if (_this.props.onFinalValueChange) _this.props.onFinalValueChange(finalPath);
	      }
	    }, _this.valueSelected = function (newPath) {
	      _this.setState({ finalPath: newPath });
	
	      if (_this.props.onFinalValueChange) _this.props.onFinalValueChange(newPath);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  UploadFolderTree.prototype.componentDidMount = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return this.loadFolders();
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    function componentDidMount() {
	      return _ref.apply(this, arguments);
	    }
	
	    return componentDidMount;
	  }();
	
	  UploadFolderTree.prototype.componentDidUpdate = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(prevProps, prevState, snapshot) {
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              if (!(prevProps.parentFolderId !== this.props.parentFolderId)) {
	                _context2.next = 4;
	                break;
	              }
	
	              this.setState({ folderOptions: [], value: null });
	              _context2.next = 4;
	              return this.loadFolders();
	
	            case 4:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, this);
	    }));
	
	    function componentDidUpdate(_x, _x2, _x3) {
	      return _ref2.apply(this, arguments);
	    }
	
	    return componentDidUpdate;
	  }();
	
	  UploadFolderTree.prototype.render = function render() {
	    if (this.state.isLoading) return _react2.default.createElement(_reactBootstrap.ProgressBar, { now: 100 });
	
	    if (!this.state.folderOptions.length) return null;
	
	    // TODO make ul styling prettier
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'upload-folder-tree' },
	        _react2.default.createElement(_reactSelect2.default, _extends({
	          defaultMenuisOpen: true,
	          options: this.state.folderOptions,
	          isClearable: true,
	          simpleValue: true,
	          getOptionValue: function getOptionValue(folder) {
	            return folder.id;
	          },
	          getOptionLabel: function getOptionLabel(folder) {
	            return folder.name;
	          },
	          disabled: this.state.isLoading,
	          key: this.props.parentFolderId,
	          onChange: this.onValueChange,
	          value: this.state.value
	        }, this.props)),
	        this.state.value && _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(UploadFolderTree, {
	              defaultMenuisOpen: true,
	              connectionId: this.props.connectionId,
	              casefolderId: this.props.casefolderId,
	              parentFolderId: this.state.value.id,
	              pathToFolder: this.props.pathToFolder.concat(this.state.value.name),
	              valueSelected: this.props.valueSelected || this.valueSelected
	            })
	          )
	        )
	      )
	    );
	  };
	
	  UploadFolderTree.prototype.loadFolders = function () {
	    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	      var _props, connectionId, casefolderId, response;
	
	      return regeneratorRuntime.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              this.setState({ isLoading: true });
	
	              _props = this.props, connectionId = _props.connectionId, casefolderId = _props.casefolderId;
	              _context3.prev = 2;
	              _context3.next = 5;
	              return _superagent2.default.post('/rpc/integrations/connections/' + connectionId + '/casefolders/' + casefolderId + '/list-folders').set('Content-Type', 'application/json').send({ parent_id: this.props.parentFolderId });
	
	            case 5:
	              response = _context3.sent;
	
	
	              this.setState({ folderOptions: response.body.folders });
	              _context3.next = 12;
	              break;
	
	            case 9:
	              _context3.prev = 9;
	              _context3.t0 = _context3['catch'](2);
	
	              if (_context3.t0.response.code !== 404) _Notification.notify.error("Failed to load folder list");
	
	            case 12:
	              _context3.prev = 12;
	
	              this.setState({ isLoading: false });
	              return _context3.finish(12);
	
	            case 15:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, this, [[2, 9, 12, 15]]);
	    }));
	
	    function loadFolders() {
	      return _ref3.apply(this, arguments);
	    }
	
	    return loadFolders;
	  }();
	
	  return UploadFolderTree;
	}(_react.Component);
	
	UploadFolderTree.defaultProps = {
	  connectionId: null,
	  casefolderId: null,
	  parentFolderId: null,
	  pathToFolder: []
	};
	UploadFolderTree.propTypes = {
	  connectionId: _propTypes2.default.number.isRequired,
	  casefolderId: _propTypes2.default.number.isRequired, // FIXME: we get number-as-string instead of number from backend?
	  parentFolderId: _propTypes2.default.string,
	  onFinalValueChange: _propTypes2.default.func
	};
	exports.default = UploadFolderTree;

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _iManageMatterSelector = __webpack_require__(565);
	
	var _IManageWorkspaceFolderSelector = __webpack_require__(564);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var changeWorkspaceValue = function changeWorkspaceValue(form, value, prevValue) {
	  // if the workspace id changed, then change the workspace and clear the folder
	  if (_lodash2.default.get(value, 'id') !== _lodash2.default.get(prevValue, 'id')) {
	    form.change('workspace', value);
	    form.change('folder', undefined);
	  }
	};
	
	exports.default = function (_ref) {
	  var connectionId = _ref.connectionId,
	      onSave = _ref.onSave,
	      settings = _ref.settings;
	
	  return _react2.default.createElement(
	    _reactFinalForm.Form,
	    { initialValues: settings, onSubmit: onSave },
	    function (_ref2) {
	      var handleSubmit = _ref2.handleSubmit,
	          form = _ref2.form,
	          pristine = _ref2.pristine,
	          values = _ref2.values,
	          submitting = _ref2.submitting;
	      return _react2.default.createElement(
	        _reactBootstrap.Form,
	        { onSubmit: handleSubmit },
	        false && _react2.default.createElement(
	          'pre',
	          null,
	          JSON.stringify(values, 0, 2)
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.FormGroup,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.ControlLabel,
	            null,
	            'iManage Matter'
	          ),
	          _react2.default.createElement(_reactFinalForm.Field, { name: 'workspace',
	            validate: function validate(value) {
	              return value ? undefined : 'Workspace is required';
	            },
	            component: _iManageMatterSelector.FinalFormIManageMatterSelector,
	            connectionId: connectionId,
	            value: settings.workspace,
	            onChange: function onChange(value) {
	              return changeWorkspaceValue(form, value, _lodash2.default.get(values, 'workspace'));
	            },
	            clearable: true
	          })
	        ),
	        values.workspace && _react2.default.createElement(
	          _reactBootstrap.FormGroup,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.ControlLabel,
	            null,
	            'Workspace Folder'
	          ),
	          _react2.default.createElement(_reactFinalForm.Field, { name: 'folder',
	            validate: function validate(value) {
	              return value && _lodash2.default.size(value) > 0 ? undefined : 'Folder is required';
	            },
	            component: _IManageWorkspaceFolderSelector.FinalFormIManageWorkspaceFolderSelect,
	            connectionId: connectionId,
	            libraryId: _lodash2.default.get(values, 'workspace.database'),
	            workspaceId: _lodash2.default.get(values, 'workspace.id'),
	            required: true,
	            clearable: true
	          })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.FormGroup,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { type: 'submit', bsStyle: 'primary', disabled: pristine || submitting },
	            'Save'
	          )
	        )
	      );
	    }
	  );
	};

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FinalFormIManageWorkspaceFolderSelect = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactSelect = __webpack_require__(235);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Notification = __webpack_require__(24);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IManageWorkspaceFolderSelector = function (_Component) {
	  _inherits(IManageWorkspaceFolderSelector, _Component);
	
	  function IManageWorkspaceFolderSelector() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, IManageWorkspaceFolderSelector);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      isLoading: false,
	      options: null,
	      value: _this.props.value
	    }, _this.refreshOptions = function (event) {
	      event.preventDefault();
	      _this.loadOptions(true);
	    }, _this.onValueChange = function (value) {
	      _this.setState({ value: value }, function () {
	        if (_this.props.onChange) _this.props.onChange(_this.currentPathToFolder());
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  IManageWorkspaceFolderSelector.prototype.componentDidMount = function componentDidMount() {
	    if (!this.state.options) this.loadOptions(false);
	  };
	
	  // if workspace or parent folder changed, refresh options
	
	
	  IManageWorkspaceFolderSelector.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snapshot) {
	    var curProps = this.props;
	
	    if (prevProps.workspaceId !== curProps.workspaceId || prevProps.parentFolder !== curProps.parentFolder) {
	      this.loadOptions(false);
	    }
	  };
	
	  IManageWorkspaceFolderSelector.prototype.loadOptions = function loadOptions(refresh) {
	    var _this2 = this;
	
	    var _props = this.props,
	        connectionId = _props.connectionId,
	        libraryId = _props.libraryId,
	        workspaceId = _props.workspaceId,
	        parentFolder = _props.parentFolder;
	
	
	    var parentType = parentFolder ? 'folder' : 'workspace';
	    var parent = parentFolder ? parentFolder.id : workspaceId;
	
	    // if we do not yet have a parent, bail out.  Probably component hasn't received the prop yet
	    if (!parent) return;
	
	    this.setState({ isLoading: true });
	
	    _superagent2.default.get('/rpc/integrations/connections/' + connectionId + '/imanage/workspace-folders').query({
	      library: libraryId,
	      workspace: workspaceId,
	      parent_type: parentType,
	      parent: parent,
	      refresh: refresh
	    }).then(function (response) {
	      // if the new set of options does not contain the value that was selected, clear it.
	      var options = _lodash2.default.get(response, 'body.folders', []);
	
	      // set value to null if the current selected value is not in the new set of options.
	      var currentValue = _this2.state.value;
	      var newValue = currentValue && _lodash2.default.find(options, { id: currentValue.id }) ? currentValue : null;
	
	      _this2.setState({ isLoading: false, value: newValue, options: options });
	    }).catch(function (error) {
	      return _Notification.notify.error("Failed to load iManage workspace folders");
	    });
	  };
	
	  IManageWorkspaceFolderSelector.prototype.currentPathToFolder = function currentPathToFolder() {
	    var value = this.state.value;
	    var pathToFolder = this.props.pathToFolder;
	
	
	    if (value) return pathToFolder.concat(value);else return pathToFolder;
	  };
	
	  IManageWorkspaceFolderSelector.prototype.render = function render() {
	    var _state = this.state,
	        isLoading = _state.isLoading,
	        options = _state.options,
	        value = _state.value;
	    var _props2 = this.props,
	        meta = _props2.meta,
	        connectionId = _props2.connectionId,
	        libraryId = _props2.libraryId,
	        workspaceId = _props2.workspaceId,
	        parentFolder = _props2.parentFolder;
	
	    // if we do not yet have the workspaceId, bail out.
	
	    if (!workspaceId) return null;
	
	    if (isLoading) return _react2.default.createElement(_reactBootstrap.ProgressBar, { now: 100 });
	
	    // if this is a sub-folder select and there are no subfolders, do not render anything
	    if (parentFolder && options && options.length === 0) return null;
	
	    var hasErrors = meta && meta.error && meta.touched;
	
	    var containerClasses = (0, _classnames2.default)({
	      'folder-tree': true,
	      'has-error': hasErrors
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: containerClasses },
	      _react2.default.createElement(_reactSelect2.default, {
	        value: value,
	        label: _lodash2.default.get(value, 'name'),
	        options: options,
	        placeholder: 'Select folder',
	        getOptionLabel: function getOptionLabel(option) {
	          return option.name;
	        },
	        getOptionValue: function getOptionValue(option) {
	          return option.id;
	        },
	        onChange: this.onValueChange,
	        isClearable: true
	      }),
	      _react2.default.createElement(
	        'a',
	        { href: '#', onClick: this.refreshOptions },
	        'Refresh'
	      ),
	      hasErrors && _react2.default.createElement(
	        _reactBootstrap.HelpBlock,
	        null,
	        meta.error
	      ),
	      value && _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(IManageWorkspaceFolderSelector, {
	            connectionId: connectionId,
	            libraryId: libraryId,
	            workspaceId: workspaceId,
	            onChange: this.props.onChange,
	            parentFolder: value,
	            value: _lodash2.default.head(this.props.subFolders),
	            subFolders: _lodash2.default.slice(this.props.subFolders, 1),
	            pathToFolder: this.props.pathToFolder.concat(value)
	          })
	        )
	      )
	    );
	  };
	
	  return IManageWorkspaceFolderSelector;
	}(_react.Component);
	
	IManageWorkspaceFolderSelector.propTypes = {
	  connectionId: _propTypes2.default.number.isRequired,
	  libraryId: _propTypes2.default.string.isRequired,
	  workspaceId: _propTypes2.default.string.isRequired,
	  onChange: _propTypes2.default.func.isRequired,
	  value: _propTypes2.default.object,
	  meta: _propTypes2.default.object,
	  parentFolder: _propTypes2.default.object,
	  pathToFolder: _propTypes2.default.array,
	  subFolders: _propTypes2.default.array
	};
	IManageWorkspaceFolderSelector.defaultProps = {
	  pathToFolder: [],
	  subFolders: []
	};
	exports.default = IManageWorkspaceFolderSelector;
	;
	
	// final form compatible component
	var FinalFormIManageWorkspaceFolderSelect = function FinalFormIManageWorkspaceFolderSelect(_ref) {
	  var _ref$input = _ref.input,
	      value = _ref$input.value,
	      _onChange = _ref$input.onChange,
	      rest = _objectWithoutProperties(_ref, ['input']);
	
	  return _react2.default.createElement(IManageWorkspaceFolderSelector, _extends({
	    onChange: function onChange(selectedOption) {
	      return _onChange(selectedOption);
	    },
	    value: _lodash2.default.head(value),
	    subFolders: _lodash2.default.slice(value, 1)
	  }, rest));
	};
	exports.FinalFormIManageWorkspaceFolderSelect = FinalFormIManageWorkspaceFolderSelect;

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.FinalFormIManageMatterSelector = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _async = __webpack_require__(233);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var IManageMatterSelect = function IManageMatterSelect(_ref) {
	  var connectionId = _ref.connectionId,
	      onChange = _ref.onChange,
	      value = _ref.value,
	      meta = _ref.meta;
	
	  var getOptions = function getOptions(inputValue) {
	    if (!inputValue) return [];
	
	    return _superagent2.default.get("/rpc/integrations/connections/" + connectionId + "/imanage/matters/search").query({ name: inputValue }).then(function (response) {
	      return response.body.results;
	    });
	  };
	
	  var loadSuggestedOptions = (0, _react.useCallback)(_lodash2.default.debounce(function (inputValue, callback) {
	    getOptions(inputValue).then(function (options) {
	      return callback(options);
	    });
	  }, 500), []);
	
	  var hasError = meta.error && meta.touched;
	
	  return _react2.default.createElement(
	    "div",
	    { className: hasError ? 'has-error' : undefined },
	    _react2.default.createElement(_async2.default, {
	      label: _lodash2.default.get(value, 'name'),
	      value: value,
	      loadOptions: loadSuggestedOptions,
	      loadingMessage: function loadingMessage() {
	        return 'Searching iManage Matters';
	      },
	      noOptionsMessage: function noOptionsMessage() {
	        return 'Type to search Matters, only full words will match...';
	      },
	      placeholder: "Search Matters...",
	      getOptionLabel: function getOptionLabel(option) {
	        return option.name;
	      },
	      isClearable: true,
	      onChange: onChange
	    }),
	    hasError && _react2.default.createElement(
	      _reactBootstrap.HelpBlock,
	      null,
	      meta.error
	    )
	  );
	};
	
	exports.default = IManageMatterSelect;
	var FinalFormIManageMatterSelector = function FinalFormIManageMatterSelector(_ref2) {
	  var _ref2$input = _ref2.input,
	      value = _ref2$input.value,
	      _onChange = _ref2$input.onChange,
	      rest = _objectWithoutProperties(_ref2, ["input"]);
	
	  return _react2.default.createElement(IManageMatterSelect, _extends({
	    value: value,
	    onChange: function onChange(selectedOption) {
	      return _onChange(selectedOption);
	    }
	  }, rest));
	};
	exports.FinalFormIManageMatterSelector = FinalFormIManageMatterSelector;

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.today_at_time = today_at_time;
	exports.now = now;
	exports.next_time_it_is = next_time_it_is;
	exports.hours_in_timezone = hours_in_timezone;
	exports.snap_forward = snap_forward;
	exports.user_timezone = user_timezone;
	
	var _luxon = __webpack_require__(497);
	
	function today_at_time(hour, zone) {
	  return _luxon.DateTime.fromObject({ hour: hour, zone: zone });
	}
	
	function now(zone) {
	  return _luxon.DateTime.fromObject({ zone: zone });
	}
	
	function next_time_it_is(hour, zone) {
	  var date = today_at_time(hour, zone);
	  return date < now(zone) ? date.plus({ day: 1 }) : date;
	}
	
	function hours_in_timezone(date, zone) {
	  return _luxon.DateTime.fromISO(date).setZone(zone).get('hour');
	}
	
	// to make sure date is sometime in the future
	function snap_forward(date, zone) {
	  var date_object = _luxon.DateTime.fromISO(date).setZone(zone);
	  return date_object < now(zone) ? next_time_it_is(hours_in_timezone(date, zone), zone) : date_object;
	}
	
	function user_timezone() {
	  try {
	    return Intl.DateTimeFormat().resolvedOptions().timeZone;
	  } catch (error) {
	    return 'America/New_York';
	  }
	}

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _luxon = __webpack_require__(497);
	
	var _reactDatepicker = __webpack_require__(900);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	__webpack_require__(952);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactBootstrapToggle = __webpack_require__(865);
	
	var _reactBootstrapToggle2 = _interopRequireDefault(_reactBootstrapToggle);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _Input = __webpack_require__(2000);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Radio = __webpack_require__(2001);
	
	var _Radio2 = _interopRequireDefault(_Radio);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalFormArrays = __webpack_require__(322);
	
	var _finalFormArrays = __webpack_require__(189);
	
	var _finalFormArrays2 = _interopRequireDefault(_finalFormArrays);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _finalForm = __webpack_require__(124);
	
	var _DocketAlertTimeCalculations = __webpack_require__(566);
	
	var _StandaloneClientCode = __webpack_require__(607);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _Notification = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DocketAlerts = function (_Component) {
	  _inherits(DocketAlerts, _Component);
	
	  function DocketAlerts(props) {
	    _classCallCheck(this, DocketAlerts);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      isUserAgreed: props.settings.enabled
	    };
	    return _this;
	  }
	
	  // Convert backend settings struct to something that can be manipulated by UI for a better UX
	
	
	  // To signal error during save, onSaveSettings should resolve to DocketAlerts.saveErrorSignal(actual error)
	
	
	  // Create settings object that backend understands
	
	
	  DocketAlerts.prototype.render = function render() {
	    var _this2 = this;
	
	    console.log("<DocketAlerts> render()", "props", this.props, "state", this.state);
	
	    var initialSettings = this.props.settings;
	
	    return _react2.default.createElement(_reactFinalForm.Form, {
	      onSubmit: function onSubmit(values) {
	        return _this2.props.onSaveSettings(DocketAlerts.formToSettings(values));
	      },
	      initialValues: DocketAlerts.settingsToForm(this.props.settings),
	      mutators: _extends({}, _finalFormArrays2.default),
	      render: function render(_ref) {
	        var handleSubmit = _ref.handleSubmit,
	            form = _ref.form,
	            submitting = _ref.submitting,
	            pristine = _ref.pristine,
	            values = _ref.values;
	        return _react2.default.createElement(
	          _reactBootstrap.Form,
	          { onSubmit: handleSubmit },
	          _react2.default.createElement(_reactFinalForm.FormSpy, {
	            subscription: { valid: true, dirtyFields: true },
	            onChange: function onChange(_ref2) {
	              var valid = _ref2.valid,
	                  dirtyFields = _ref2.dirtyFields;
	
	              // Auto save "enabled"
	              if (valid && (dirtyFields.enabled || dirtyFields.next_run)) {
	                form.submit();
	              }
	            }
	          }),
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            {
	              bsStyle: _this2.state.isUserAgreed || values.enabled ? 'success' : 'warning',
	              defaultExpanded: !(_this2.state.isUserAgreed || values.enabled)
	            },
	            _react2.default.createElement(
	              _reactBootstrap.Panel.Heading,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Panel.Title,
	                { toggle: true },
	                _this2.state.isUserAgreed || values.enabled ? _react2.default.createElement(
	                  _react.Fragment,
	                  null,
	                  _react2.default.createElement('i', { className: 'fa fa-check' }),
	                  ' ',
	                  'Docket Alert Caution: Agreed to'
	                ) : _react2.default.createElement(
	                  _react.Fragment,
	                  null,
	                  _react2.default.createElement('i', { className: 'fa fa-exclamation-triangle' }),
	                  ' ',
	                  'Docket Alert Caution'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Panel.Collapse,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Panel.Body,
	                null,
	                'This automated Docket Alert will incur PACER charges while on. I will set my frequency accordingly and turn off the alert when no longer needed. This alert is not needed if ECF notices can be received.',
	                !(_this2.state.isUserAgreed || values.enabled) && _react2.default.createElement(
	                  _react.Fragment,
	                  null,
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    { bsStyle: 'success', style: { float: 'right' }, onClick: function onClick() {
	                        return _this2.setState(_extends({}, _this2.state, { isUserAgreed: true }));
	                      } },
	                    _react2.default.createElement(
	                      _reactBootstrap.Panel.Toggle,
	                      { componentClass: 'span' },
	                      'I agree'
	                    )
	                  ),
	                  _react2.default.createElement('div', { style: { clear: 'both' } })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement('div', { ref: _this2.props.statusPanelRef }),
	          (_this2.state.isUserAgreed || values.enabled) && _react2.default.createElement(
	            _react.Fragment,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { bsStyle: values.enabled ? "success" : "danger" },
	              _react2.default.createElement(
	                _reactBootstrap.Panel.Heading,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Panel.Title,
	                  null,
	                  values.enabled && _react2.default.createElement(
	                    'div',
	                    { style: { float: 'right' } },
	                    submitting ? _react2.default.createElement('i', { className: 'fa fa-circle-o-notch fa-spin' }) : _react2.default.createElement(_reactFinalForm.Field, {
	                      name: 'enabled',
	                      component: ToggleAdapter,
	                      size: 'xs',
	                      onstyle: "success",
	                      offstyle: "danger"
	                    })
	                  ),
	                  'Status'
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Panel.Body,
	                null,
	                initialSettings.enabled ? _react2.default.createElement(AlertCurrentSettings, { settings: initialSettings }) : _react2.default.createElement(
	                  'p',
	                  null,
	                  'Automated docket updates and alerts are not enabled. Configure and test your alert below before turning on.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Panel.Heading,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel.Title,
	                    null,
	                    _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	                    ' ',
	                    'Frequency Settings',
	                    _react2.default.createElement(SaveButton, { form: form, pristine: pristine, submitting: submitting, values: values })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Panel.Heading,
	                  { style: { backgroundColor: '#fcf8e3' } },
	                  _react2.default.createElement('i', { className: 'fa fa-exclamation-triangle' }),
	                  ' ',
	                  'Docket alerts incur PACER charges. Select your frequency accordingly and remember to turn off your alert when no longer needed.'
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Panel.Body,
	                  { style: { lineHeight: '32px' } },
	                  'Update docket',
	                  _react2.default.createElement(
	                    'div',
	                    { style: { display: 'inline-block', marginLeft: '16px', marginRight: '16px', verticalAlign: 'middle' } },
	                    _react2.default.createElement(_reactFinalForm.Field, {
	                      name: 'frequency',
	                      component: ReactSelectAdapter,
	                      placeholder: '',
	                      style: { width: '150px' },
	                      options: ['P1D', 'P2D', 'P3D', 'P7D'].map(function (period) {
	                        return { value: period, label: period2string(period) };
	                      }),
	                      clearable: false
	                    })
	                  ),
	                  'at',
	                  _react2.default.createElement(
	                    'div',
	                    { style: { display: 'inline-block', marginLeft: '16px', verticalAlign: 'middle' } },
	                    _react2.default.createElement(_reactFinalForm.Field, {
	                      name: 'start_time',
	                      component: ReactSelectAdapter,
	                      placeholder: '',
	                      style: { width: '150px' },
	                      options: [{ value: 0, label: "12 am" }, { value: 1, label: "1 am" }, { value: 2, label: "2 am" }, { value: 3, label: "3 am" }, { value: 4, label: "4 am" }, { value: 5, label: "5 am" }, { value: 6, label: "6 am" }, { value: 7, label: "7 am" }, { value: 8, label: "8 am" }, { value: 9, label: "9 am" }, { value: 10, label: "10 am" }, { value: 11, label: "11 am" }, { value: 12, label: "12 pm" }, { value: 13, label: "1 pm" }, { value: 14, label: "2 pm" }, { value: 15, label: "3 pm" }, { value: 16, label: "4 pm" }, { value: 17, label: "5 pm" }, { value: 18, label: "6 pm" }, { value: 19, label: "7 pm" }, { value: 20, label: "8 pm" }, { value: 21, label: "9 pm" }, { value: 22, label: "10 pm" }, { value: 23, label: "11 pm" }],
	                      clearable: false
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { style: { display: 'inline-block', marginLeft: '16px', verticalAlign: 'middle' } },
	                    _react2.default.createElement(_reactFinalForm.Field, {
	                      name: 'time_zone',
	                      component: ReactSelectAdapter,
	                      placeholder: values.time_zone || 'Select a time zone',
	                      style: { width: '250px' },
	                      options: [{ label: 'US/Alaska', value: 'America/Anchorage' }, { label: 'US/Aleutian', value: 'America/Adak' }, { label: 'US/Arizona', value: 'America/Phoenix' }, { label: 'US/Central', value: 'America/Chicago' }, { label: 'US/Eastern', value: 'America/New_York' }, { label: 'US/East-Indiana', value: 'America/Indiana/Indianapolis' }, { label: 'US/Hawaii', value: 'Pacific/Honolulu' }, { label: 'US/Indiana-Starke', value: 'America/Indiana/Knox' }, { label: 'US/Michigan', value: 'America/Detroit' }, { label: 'US/Mountain', value: 'America/Denver' }, { label: 'US/Pacific', value: 'America/Los_Angeles' }, { label: 'US/Samoa', value: 'Pacific/Pago_Pago' }],
	                      clearable: false
	                    })
	                  ),
	                  _react2.default.createElement('br', null)
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Panel.Heading,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel.Title,
	                    null,
	                    _react2.default.createElement('i', { className: 'fa fa-gear' }),
	                    ' ',
	                    'Update Options',
	                    _react2.default.createElement(SaveButton, { form: form, pristine: pristine, submitting: submitting, values: values })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Panel.Body,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.FormGroup,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.ControlLabel,
	                      null,
	                      'Client Code'
	                    ),
	                    ' ',
	                    _react2.default.createElement(
	                      _reactBootstrap.FormControl.Static,
	                      { componentClass: 'div' },
	                      _react2.default.createElement(_reactFinalForm.Field, {
	                        name: 'client_code',
	                        component: _StandaloneClientCode.FinalFormStandaloneClientCodeAdapter
	                      })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.HelpBlock,
	                      null,
	                      'The selected client code will be used to make PACER purchases.'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.FormGroup,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.ControlLabel,
	                      null,
	                      'Docket Header'
	                    ),
	                    _react2.default.createElement(
	                      _Radio2.default,
	                      { name: 'minimize_header' },
	                      _react2.default.createElement(
	                        'option',
	                        { value: false },
	                        'Full'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: true },
	                        'Minimize'
	                      )
	                    ),
	                    _react2.default.createElement(_reactBootstrap.FormControl.Feedback, null),
	                    _react2.default.createElement(
	                      _reactBootstrap.HelpBlock,
	                      null,
	                      'If up-to-date docket header is not important to you, select "Minimize" to save costs on cases with long headers.'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Panel.Heading,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel.Title,
	                    null,
	                    _react2.default.createElement('i', { className: 'fa fa-bell' }),
	                    ' ',
	                    'Notification Preferences',
	                    _react2.default.createElement(SaveButton, { form: form, pristine: pristine, submitting: submitting, values: values })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Panel.Body,
	                  null,
	                  _react2.default.createElement(
	                    _Radio2.default,
	                    { name: 'report_settings.email_mode' },
	                    _react2.default.createElement(
	                      'option',
	                      { value: 'never' },
	                      'Do not send me any emails, just update the docket for me'
	                    ),
	                    _react2.default.createElement(
	                      'option',
	                      { value: 'always' },
	                      'Email whenever docket alert is run (even when nothing new found)'
	                    ),
	                    _react2.default.createElement(
	                      'option',
	                      { value: 'new' },
	                      'Email new docket entries (only when new entries found)'
	                    ),
	                    _react2.default.createElement(
	                      'option',
	                      { value: 'matching' },
	                      'Email only new docket entries that meet the following criteria:'
	                    )
	                  ),
	                  _lodash2.default.get(values, 'report_settings.email_mode') === "matching" && _react2.default.createElement(
	                    _reactBootstrap.FormGroup,
	                    null,
	                    _react2.default.createElement(
	                      _reactFinalFormArrays.FieldArray,
	                      { name: 'report_settings.docket_entry_filters' },
	                      function (_ref3) {
	                        var fields = _ref3.fields;
	                        return fields.map(function (name, index) {
	                          return _react2.default.createElement(
	                            _reactBootstrap.InputGroup,
	                            { key: index },
	                            _react2.default.createElement(_Input2.default, { type: 'text', name: name, placeholder: 'Docket text search term to be matched' }),
	                            _react2.default.createElement(
	                              _reactBootstrap.InputGroup.Button,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                { onClick: function onClick() {
	                                    return fields.remove(index);
	                                  } },
	                                '\u274C'
	                              )
	                            )
	                          );
	                        });
	                      }
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'link',
	                        bsSize: 'small',
	                        onClick: function onClick() {
	                          return form.mutators.push('report_settings.docket_entry_filters', '');
	                        }
	                      },
	                      '+ Add Search Term'
	                    )
	                  ),
	                  _lodash2.default.get(values, 'report_settings.email_mode') !== "never" && _react2.default.createElement(
	                    _reactBootstrap.FormGroup,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.InputGroup,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.ControlLabel,
	                        null,
	                        _react2.default.createElement('i', { className: 'fa fa-envelope' }),
	                        ' Send docket alert emails to the following distribution list'
	                      ),
	                      _react2.default.createElement(_Input2.default, { type: 'textarea', name: 'report_settings.email_distribution_list' })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Panel.Heading,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel.Title,
	                    null,
	                    _react2.default.createElement('i', { className: 'fa fa-play-circle' }),
	                    ' ',
	                    'Test Settings'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Panel.Heading,
	                  { style: { backgroundColor: '#fcf8e3' } },
	                  _react2.default.createElement('i', { className: 'fa fa-exclamation-triangle' }),
	                  ' ',
	                  'It is recommended that you test your docket alert when changing the configuration. PACER Charges Apply.'
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Panel.Body,
	                  null,
	                  _react2.default.createElement(_reactFinalForm.Form, {
	                    initialValues: { update_full_docket: false },
	                    onSubmit: function onSubmit(testConfig) {
	                      return _this2.props.onTestAlert(DocketAlerts.formToSettings(values), testConfig);
	                    },
	                    render: function render(_ref4) {
	                      var testForm = _ref4.form;
	                      return _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                          _reactBootstrap.FormGroup,
	                          null,
	                          _react2.default.createElement(
	                            _Radio2.default,
	                            { name: 'update_full_docket' },
	                            _react2.default.createElement(
	                              'option',
	                              { value: false },
	                              'Test by updating as of last known filed date'
	                            ),
	                            _react2.default.createElement(
	                              'option',
	                              { value: true },
	                              'Test by updating full docket'
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Button,
	                          {
	                            disabled: !!_this2.props.testStatus.testProgressViewComponent,
	                            bsStyle: 'primary',
	                            onClick: function onClick() {
	                              return testForm.submit();
	                            }
	                          },
	                          _this2.props.testStatus.testProgressViewComponent ? _react2.default.createElement('i', { className: 'fa fa-play-circle fa-spin' }) : _react2.default.createElement('i', { className: 'fa fa-play-circle' }),
	                          ' ',
	                          values.enabled ? 'Test and Save Docket Alert' : 'Test and Activate Docket Alert'
	                        ),
	                        _react2.default.createElement('p', null),
	                        _this2.props.testStatus.testProgressViewComponent && _react2.default.createElement(
	                          _reactBootstrap.Alert,
	                          { bsStyle: 'info' },
	                          _react2.default.createElement(
	                            'h4',
	                            null,
	                            'Testing in progress...'
	                          ),
	                          _this2.props.testStatus.testProgressViewComponent
	                        )
	                      );
	                    }
	                  }),
	                  _react2.default.createElement('p', null),
	                  _this2.props.testStatus.testError && _react2.default.createElement(
	                    _reactBootstrap.Alert,
	                    { bsStyle: 'danger' },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      'Error running alert'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Please correct the error and try again. Contact us if problem pesists. Details:'
	                    ),
	                    _react2.default.createElement(
	                      'pre',
	                      null,
	                      "" + _this2.props.testStatus.testError
	                    )
	                  ),
	                  _this2.props.testStatus.isTestSuccessful && pristine && (initialSettings.enabled ? _react2.default.createElement(
	                    _reactBootstrap.Alert,
	                    { bsStyle: 'success' },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      'Test Successful, alert up to date'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      _react2.default.createElement(AlertCurrentSettings, { settings: values })
	                    )
	                  ) : _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Alert,
	                      { bsStyle: 'info' },
	                      _react2.default.createElement(
	                        'h4',
	                        null,
	                        'Your alert tested successfully, turning on...'
	                      )
	                    )
	                  ))
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: '#', onClick: function onClick(e) {
	                alert(JSON.stringify(values, null, 2));e.preventDefault();
	              } },
	            'Inspect Raw Settings'
	          )
	        );
	      } }); // end FinalForm render function
	  };
	
	  return DocketAlerts;
	}(_react.Component);
	
	DocketAlerts.saveErrorSignal = function (error) {
	  var _ref11;
	
	  return _ref11 = {}, _ref11[_finalForm.FORM_ERROR] = error, _ref11;
	};
	
	DocketAlerts.defaultProps = {
	  settings: { enabled: false, report_settings: {} }
	};
	DocketAlerts.propTypes = {
	  settings: _propTypes2.default.object,
	  onSaveSettings: _propTypes2.default.func.isRequired,
	  onTestAlert: _propTypes2.default.func.isRequired,
	  testProgress: _propTypes2.default.object
	};
	
	DocketAlerts.settingsToForm = function (settings) {
	  return _lodash2.default.merge({}, settings, {
	    start_time: (0, _DocketAlertTimeCalculations.hours_in_timezone)(settings.next_run, settings.time_zone),
	    report_settings: {
	      // It's easier for users to edit one large list vs individual emails
	      email_distribution_list: _lodash2.default.get(settings, 'report_settings.email_distribution_list', []).join('\n'),
	      // Inject blank search term so empty field shows up without users needing to click 'Add Search Term'
	      docket_entry_filters: settings.report_settings.docket_entry_filters.length ? settings.report_settings.docket_entry_filters : ['']
	    }
	  });
	};
	
	DocketAlerts.formToSettings = function (values) {
	  return _lodash2.default.merge({}, values, {
	    next_run: (0, _DocketAlertTimeCalculations.snap_forward)(_luxon.DateTime.fromISO(values.next_run).setZone(values.time_zone).set({ hour: values.start_time, minute: 0, second: 0, millisecond: 0 }).toISO(), values.time_zone),
	
	    report_settings: {
	      // massage emails back into individual entries
	      email_distribution_list: _lodash2.default.filter(values.report_settings.email_distribution_list.split('\n')),
	      // get rid of any empty values
	      docket_entry_filters: _lodash2.default.filter(values.report_settings.docket_entry_filters)
	    }
	  });
	};
	
	var ToggleAdapter = function ToggleAdapter(_ref5) {
	  var _ref5$input = _ref5.input,
	      onChange = _ref5$input.onChange,
	      value = _ref5$input.value,
	      rest = _objectWithoutProperties(_ref5, ['input']);
	
	  return _react2.default.createElement(_reactBootstrapToggle2.default, _extends({
	    active: !!value,
	    onClick: function onClick() {
	      return onChange(!value);
	    }
	  }, rest));
	};
	
	var ReactSelectAdapter = function ReactSelectAdapter(_ref6) {
	  var input = _ref6.input,
	      rest = _objectWithoutProperties(_ref6, ['input']);
	
	  return _react2.default.createElement(_reactSelect2.default, _extends({}, input, rest, { simpleValue: true }));
	};
	
	var LinkDateInput = function LinkDateInput(_ref7) {
	  var value = _ref7.value,
	      onClick = _ref7.onClick;
	  return _react2.default.createElement(
	    _reactBootstrap.Button,
	    { bsStyle: 'link', bsSize: 'xs', onClick: onClick },
	    _react2.default.createElement('i', { className: 'fa fa-calendar' }),
	    ' ',
	    _luxon.DateTime.fromFormat(value, 'D').toFormat('DDDD')
	  );
	};
	
	var ReactDatePickerAdapter = function ReactDatePickerAdapter(_ref8) {
	  var _ref8$input = _ref8.input,
	      _onChange = _ref8$input.onChange,
	      value = _ref8$input.value,
	      rest = _objectWithoutProperties(_ref8, ['input']);
	
	  return _react2.default.createElement(_reactDatepicker2.default, _extends({
	    selected: _luxon.DateTime.fromISO(value).toJSDate(),
	    onChange: function onChange(newDate) {
	      return _onChange(_luxon.DateTime.fromJSDate(newDate).toISODate());
	    },
	    customInput: _react2.default.createElement(LinkDateInput, null)
	  }, rest));
	};
	
	var AlertCurrentSettings = function AlertCurrentSettings(_ref9) {
	  var settings = _ref9.settings;
	
	  try {
	    var next_run = _luxon.DateTime.fromISO(settings.next_run).setZone(settings.time_zone);
	    return _react2.default.createElement(
	      'span',
	      null,
	      'Alert will run be ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        period2string(settings.frequency)
	      ),
	      ' ',
	      ' at ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        next_run.toFormat('t ZZZZ')
	      ),
	      '.',
	      ' ',
	      ' Next run is scheduled for ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        next_run.toRelativeCalendar()
	      ),
	      ' ',
	      ' on ',
	      _react2.default.createElement(
	        'div',
	        { style: { display: 'inline-block' } },
	        _react2.default.createElement(_reactFinalForm.Field, {
	          name: 'next_run',
	          component: ReactDatePickerAdapter,
	          placeholderText: 'Select a starting Date',
	          minDate: new Date(),
	          todayButton: 'Today'
	        })
	      ),
	      ' (click to reschedule)'
	    );
	  } catch (error) {
	    return _react2.default.createElement(
	      _reactBootstrap.Alert,
	      { bsStyle: 'danger' },
	      'There was an error calculating time period: ',
	      '' + error
	    );
	  }
	};
	
	var SaveButton = function SaveButton(_ref10) {
	  var values = _ref10.values,
	      form = _ref10.form,
	      pristine = _ref10.pristine,
	      submitting = _ref10.submitting;
	  return (
	    // We can only trigger the save when form is already enabled
	    values.enabled ? _react2.default.createElement(
	      'span',
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          style: { float: 'right' },
	          bsStyle: pristine ? 'default' : 'success',
	          bsSize: 'xs'
	          // instaed of type=submit, since we dont' want stray [Enter] to submit the form
	          , onClick: function onClick() {
	            return form.submit();
	          },
	          disabled: submitting || pristine
	        },
	        'Save',
	        ' ',
	        submitting && _react2.default.createElement('i', { className: 'fa fa-circle-o-notch fa-spin' })
	      ),
	      _react2.default.createElement('div', { style: { clear: 'both' } })
	    ) : null
	  );
	};
	
	var period2string = function period2string(period) {
	  return {
	    'P1D': 'daily',
	    'P2D': 'every 2 days',
	    'P3D': 'every 3 days',
	    'P7D': 'weekly'
	  }[period] || period;
	};
	
	exports.default = DocketAlerts;

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _logger = __webpack_require__(744);
	
	var _ravenJs = __webpack_require__(863);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ErrorBoundary = function (_Component) {
	  _inherits(ErrorBoundary, _Component);
	
	  function ErrorBoundary(props) {
	    _classCallCheck(this, ErrorBoundary);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = { hasError: false };
	    return _this;
	  }
	
	  ErrorBoundary.prototype.componentDidCatch = function componentDidCatch(error, info) {
	    var _this2 = this;
	
	    // Display fallback UI and log to Raven
	    this.setState({ hasError: true, isSubmittingToSentry: true }, function () {
	      var eventId = (0, _logger.logException)(error, info);
	      _this2.setState({ hasError: true, isSubmittingToSentry: false, event_id: eventId });
	    });
	  };
	
	  ErrorBoundary.prototype.render = function render() {
	    var _this3 = this;
	
	    if (this.state.hasError) {
	      return this.state.isSubmittingToSentry ? _react2.default.createElement(
	        _reactBootstrap.Alert,
	        { bsStyle: 'danger' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'There was an unexpected error.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(_reactBootstrap.ProgressBar, { now: '100', active: true, label: 'Sending Error Report...', bsStyle: 'danger' }),
	          'Sending Error Report...'
	        )
	      ) : _react2.default.createElement(
	        _reactBootstrap.Alert,
	        { bsStyle: 'danger' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'There was an unexpected error.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Our engineers have been notified and will work towards a solution.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'If you require immediate assistance, please quote',
	          _react2.default.createElement(
	            'strong',
	            null,
	            ' Event ID ',
	            ' ',
	            _react2.default.createElement(
	              'code',
	              { style: { fontSize: '16px' } },
	              ' ',
	              this.state.event_id
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '#', onClick: function onClick(e) {
	                try {
	                  e.stopPropagation();
	                } catch (and_ignore) {/* seen it bail on click in dev, guessing `e` not valid sometimes */};
	                _ravenJs2.default.showReportDialog({
	                  eventId: _this3.state.event_id,
	                  user: {
	                    name: _.get(Drupal, 'settings.currentUserName', ''),
	                    email: _.get(Drupal, 'settings.currentUserMail', '')
	                  }
	                });
	              } },
	            'Click here to provide additional details'
	          )
	        )
	      );
	    }
	    return this.props.children;
	  };
	
	  return ErrorBoundary;
	}(_react.Component);
	
	ErrorBoundary.propTypes = {
	  children: _propTypes2.default.element.isRequired
	};
	
	exports.default = ErrorBoundary;

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactHotLoader = __webpack_require__(2012);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ErrorBoundary = function ErrorBoundary(props) {
	  return _react2.default.createElement(
	    _reactBootstrap.Alert,
	    { bsStyle: 'danger' },
	    'Apologies, we have encountered an unexpected error. Please try again and contact support if problem persists. ',
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'small',
	      null,
	      'Technical Data follows:',
	      _react2.default.createElement(
	        'pre',
	        null,
	        JSON.stringify(props)
	      )
	    )
	  );
	};
	
	var ErrorHandlingAppContainer = function ErrorHandlingAppContainer(props) {
	  return _react2.default.createElement(_reactHotLoader.AppContainer, _extends({ errorReporter: ErrorBoundary }, props));
	};
	
	exports.default = ErrorHandlingAppContainer;

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(32);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _LoadingBar = __webpack_require__(91);
	
	var _LoadingBar2 = _interopRequireDefault(_LoadingBar);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _AlertError = __webpack_require__(50);
	
	var _AlertError2 = _interopRequireDefault(_AlertError);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	__webpack_require__(2146);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var currentPeriodEndDate = new Date();
	
	var ApiCallsView = function (_Component) {
	  _inherits(ApiCallsView, _Component);
	
	  function ApiCallsView() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ApiCallsView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getDetailsTable = function (data) {
	      var rows = data.map(function (item, key) {
	        return _react2.default.createElement(
	          'tr',
	          { key: key },
	          _react2.default.createElement(
	            'td',
	            null,
	            (0, _moment2.default)(item.interval).utc().format('MM/DD/YYYY') || ''
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            item.service_name || ''
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            item.calls || '0'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            item.type || ''
	          )
	        );
	      });
	      return _react2.default.createElement(
	        'table',
	        { className: 'sticky-enabled tablesorter', align: 'center' },
	        _react2.default.createElement(
	          'thead',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'th',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'Billing Period'
	              )
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'Service'
	              )
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'API Cals'
	              )
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'Type'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'tbody',
	          null,
	          _this.props.period_selected && _this.noDataFound(data),
	          rows
	        )
	      );
	    }, _this.getSummaryTable = function (data) {
	      var rows = data.map(function (item, key) {
	        return _react2.default.createElement(
	          'tr',
	          { key: key },
	          _react2.default.createElement(
	            'td',
	            null,
	            (0, _moment2.default)(item.start).utc().format('MM/DD/YYYY') + ' - ' + (0, _moment2.default)(item.end || currentPeriodEndDate).utc().format('MM/DD/YYYY') || ''
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            item.usage || '0'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            '$',
	            item.total_cost || '0.00'
	          )
	        );
	      });
	      return _react2.default.createElement(
	        'table',
	        { className: 'sticky-enabled tablesorter', align: 'center' },
	        _react2.default.createElement(
	          'thead',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'th',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'Billing Period'
	              )
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'API Cals'
	              )
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'Amount'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'tbody',
	          null,
	          _this.noDataFound(data),
	          rows
	        )
	      );
	    }, _this.noDataFound = function (data) {
	      if (data.length === 0 && _this.props.dataReady) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'ir-search-integrations-message' },
	          _react2.default.createElement(
	            'div',
	            { className: 'messages warning' },
	            _this.props.noDataFoundMessage
	          )
	        );
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ApiCallsView.prototype.render = function render() {
	    if (!this.props.dataReady) return _react2.default.createElement(_LoadingBar2.default, null);
	    var alertError = this.props.error ? _react2.default.createElement(_AlertError2.default, { errors: this.props.error }) : null;
	
	    var tableDetailsData = this.props.usage || [];
	    var tableSummaryData = this.props.periods || [];
	
	    var periodDropdown = this.props.periods.map(function (item) {
	      return { label: (0, _moment2.default)(item.start).utc().format('MM/DD/YYYY') + ' - ' + (0, _moment2.default)(item.end || currentPeriodEndDate).utc().format('MM/DD/YYYY'), value: JSON.stringify({ period_start: item.start, period_end: item.end || currentPeriodEndDate }) };
	    });
	
	    if (!this.props.period_selected && this.props.periods.length > 0) {
	      var mostRecentPeriod = this.props.periods[0];
	      var initialValues = JSON.stringify({ period_start: mostRecentPeriod.start, period_end: mostRecentPeriod.end || currentPeriodEndDate });
	      this.props.handleChange(initialValues);
	    }
	    return _react2.default.createElement(
	      'div',
	      { className: this.props.type },
	      alertError,
	      _react2.default.createElement(
	        _reactBootstrap.Tabs,
	        { defaultActiveKey: 1, id: 'apicalls', bsStyle: 'tabs' },
	        _react2.default.createElement(
	          _reactBootstrap.Tab,
	          { eventKey: 1, title: 'Details' },
	          _react2.default.createElement(
	            'div',
	            { className: 'period-section' },
	            _react2.default.createElement(
	              'div',
	              { className: 'period' },
	              'Period:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'selectParent' },
	              _react2.default.createElement(_reactSelect2.default, {
	                options: periodDropdown,
	                onBlurResetsInput: false,
	                onSelectResetsInput: false,
	                onChange: this.props.handleChange,
	                simpleValue: true,
	                value: JSON.stringify({ period_start: this.props.period_start, period_end: this.props.period_end }),
	                searchable: true })
	            )
	          ),
	          this.getDetailsTable(tableDetailsData)
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Tab,
	          { eventKey: 2, title: 'Summary' },
	          this.getSummaryTable(tableSummaryData)
	        )
	      ),
	      !this.props.dataReady && _react2.default.createElement(_LoadingBar2.default, null)
	    );
	  };
	
	  return ApiCallsView;
	}(_react.Component);
	
	ApiCallsView.defaultProps = {
	  error: null,
	  type: 'apicalls'
	};
	
	ApiCallsView.propTypes = {
	  handleChange: _propTypes2.default.func.isRequired,
	  dataReady: _propTypes2.default.bool.isRequired,
	  usage: _propTypes2.default.any.isRequired,
	  period_selected: _propTypes2.default.any.isRequired,
	  periods: _propTypes2.default.any.isRequired,
	  type: _propTypes2.default.string,
	  noDataFoundMessage: _propTypes2.default.string.isRequired,
	  error: _propTypes2.default.any
	};
	
	exports.default = ApiCallsView;

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(129);
	
	var _integrationsConnectionActions = __webpack_require__(46);
	
	var _box = __webpack_require__(957);
	
	var _box2 = _interopRequireDefault(_box);
	
	var _BoxAuthenticator = __webpack_require__(1078);
	
	var _BoxAuthenticator2 = _interopRequireDefault(_BoxAuthenticator);
	
	var _Notification = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BoxSwitch = function (_Component) {
	  _inherits(BoxSwitch, _Component);
	
	  function BoxSwitch() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BoxSwitch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      loading: false
	    }, _this.onClick = function () {
	      var connectionId = _this.props.connectionId;
	
	
	      if (connectionId === null) {
	        _this.setState({ loading: true });
	        (0, _BoxAuthenticator2.default)().login({ state: { redirect_host: window.location.host } }) // TODO adjust scopes to minimum required
	        .then(function (_ref) {
	          var authResponse = _ref.authResponse;
	
	          _this.props.dispatch((0, _integrationsConnectionActions.connectIntegration)('files', 'box', authResponse));
	          _this.setState({ loading: false });
	        }, function (res) {
	          var _res$error = res.error,
	              code = _res$error.code,
	              message = _res$error.message;
	
	          _this.setState({ loading: false });
	          _Notification.notify.error('Error connecting to Box: [' + code + '] ' + (message || ''));
	        });
	      } else {
	        _this.props.dispatch((0, _integrationsConnectionActions.disconnectIntegration)(connectionId));
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BoxSwitch.prototype.render = function render() {
	    var _props = this.props,
	        connectionId = _props.connectionId,
	        agreedToPricing = _props.agreedToPricing;
	
	    var iconCls = 'kloudless-switch ' + (connectionId ? 'on' : '') + ' ' + (agreedToPricing ? '' : 'hidden');
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'kloudless-control-holder2' },
	      _react2.default.createElement('img', { className: 'kloudless-connection-icon',
	        src: _box2.default, TODO: true,
	        alt: 'Box logo'
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: iconCls, onClick: this.onClick },
	        this.state.loading && _react2.default.createElement('i', {
	          className: "fa fa-circle-o-notch fa-spin",
	          style: { marginTop: '10px', marginLeft: '11px', fontSize: '11px' }
	        })
	      )
	    );
	  };
	
	  return BoxSwitch;
	}(_react.Component);
	
	BoxSwitch.defaultProps = {
	  connectionId: null
	};
	BoxSwitch.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  connectionId: _propTypes2.default.number,
	  agreedToPricing: _propTypes2.default.bool.isRequired
	};
	exports.default = BoxSwitch;

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _ProgressBar = __webpack_require__(266);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CalendarFeedSettings = function (_Component) {
	  _inherits(CalendarFeedSettings, _Component);
	
	  function CalendarFeedSettings() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CalendarFeedSettings);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.initialState = {
	      loading: true,
	      calendarSettings: null
	    }, _this.state = _extends({}, _this.initialState), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CalendarFeedSettings.prototype.componentDidMount = function componentDidMount() {
	    this.fetchCalendarFeedSettings();
	  };
	
	  CalendarFeedSettings.prototype.fetchCalendarFeedSettings = function fetchCalendarFeedSettings() {
	    var _this2 = this;
	
	    console.log('Fetching calendar feed settings for ' + this.props.connectionId);
	
	    this.setState(this.initialState);
	
	    _superagent2.default.get('/rpc/integrations/connections/' + this.props.connectionId + '/calendar-settings').then(function (res) {
	      _this2.setState({ loading: false, calendarSettings: res.body });
	    }, function (errRes) {
	      _this2.setState({ loading: false });
	    });
	  };
	
	  CalendarFeedSettings.prototype.render = function render() {
	    if (this.state.loading) return _react2.default.createElement(_ProgressBar2.default, { active: true, now: 100 });
	
	    var calendarSettings = this.state.calendarSettings;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'calendar-feed-settings' },
	      _react2.default.createElement(
	        _reactBootstrap.PageHeader,
	        null,
	        'Calendar Feed Settings'
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Alert,
	        { bsStyle: 'info' },
	        'Calendar Feeds only include bankruptcy courts. In addition, the following courts do not provide a calendar feed:',
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Maryland Bankruptcy Court'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Massachusetts Bankruptcy Court'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Pennsylvania Middle Bankruptcy Court'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Texas Southern Bankruptcy Court'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Calendar feeds include events in the next 30 days.  You will be charged one integration call per event that is delivered to your calendar feed.'
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Panel,
	        { className: 'calendar-feed' },
	        _react2.default.createElement(
	          _reactBootstrap.Panel.Heading,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Panel.Title,
	            null,
	            'My Cases Calendar Feed'
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Panel.Body,
	          null,
	          calendarSettings.user_feed_url,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Use this address to access your cases calendar from other applications.  The calendar is in iCal format.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Panel,
	        { className: 'calendar-feed' },
	        _react2.default.createElement(
	          _reactBootstrap.Panel.Heading,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Panel.Title,
	            null,
	            'Firm Cases Calendar Feed'
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Panel.Body,
	          null,
	          calendarSettings.firm_feed_url,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Use this address to access your firm cases calendar from other applications.  The calendar is in iCal format.'
	          )
	        )
	      )
	    );
	  };
	
	  return CalendarFeedSettings;
	}(_react.Component);
	
	CalendarFeedSettings.defaultProps = {
	  connectionId: null
	};
	CalendarFeedSettings.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  connectionId: _propTypes2.default.number
	};
	exports.default = CalendarFeedSettings;

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(129);
	
	var _integrationsConnectionActions = __webpack_require__(46);
	
	var _Notification = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CalendarFeedSwitch = function (_Component) {
	  _inherits(CalendarFeedSwitch, _Component);
	
	  function CalendarFeedSwitch() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CalendarFeedSwitch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      loading: false
	    }, _this.onClick = function () {
	      var connectionId = _this.props.connectionId;
	
	
	      if (connectionId === null) {
	        _this.setState({ loading: true });
	
	        // TODO need to deal with calendar_feed_id somehow
	        _this.props.dispatch((0, _integrationsConnectionActions.connectIntegration)('calendar', 'calendar', null));
	        _this.setState({ loading: false });
	      } else {
	        _this.props.dispatch((0, _integrationsConnectionActions.disconnectIntegration)(connectionId));
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CalendarFeedSwitch.prototype.render = function render() {
	    var _props = this.props,
	        connectionId = _props.connectionId,
	        agreedToPricing = _props.agreedToPricing;
	
	    var iconCls = 'kloudless-switch ' + (connectionId ? 'on' : '') + ' ' + (agreedToPricing ? '' : 'hidden');
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'kloudless-control-holder2' },
	      _react2.default.createElement(
	        'h2',
	        { className: 'calendar-switch' },
	        _react2.default.createElement('i', { className: 'fa fa-calendar' }),
	        ' Bankruptcy Calendar Feed'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: iconCls, onClick: this.onClick },
	        this.state.loading && _react2.default.createElement('i', {
	          className: "fa fa-circle-o-notch fa-spin",
	          style: { marginTop: '10px', marginLeft: '11px', fontSize: '11px' }
	        })
	      )
	    );
	  };
	
	  return CalendarFeedSwitch;
	}(_react.Component);
	
	CalendarFeedSwitch.defaultProps = {
	  connectionId: null
	};
	CalendarFeedSwitch.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  connectionId: _propTypes2.default.number,
	  agreedToPricing: _propTypes2.default.bool.isRequired
	};
	exports.default = CalendarFeedSwitch;

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function () {
	  return _hello2.default
	  // install Clio driver
	  .init({
	    clio: {
	      name: 'Clio',
	
	      base: 'https://app.clio.com/',
	
	      oauth: {
	        version: 2,
	        auth: 'https://app.clio.com/oauth/authorize',
	        grant: 'https://app.clio.com/oauth/token',
	        response_type: 'code'
	      },
	
	      login: function login(p) {
	        // sets popup size to fit the Clio login screen
	        p.options.popup.width = 1024;
	        p.options.popup.height = 730;
	      }
	    }
	  })
	
	  // Initialize Driver instance
	  .init({ clio: window.Drupal.settings.INTEGRATIONS_CLIO_APP_ID }, {
	    redirect_uri: 'https://app.courtdrive.com/rpc/static/hello.js/redirect.html',
	    oauth_proxy: window.location.origin + '/rpc/integrations/oauth_proxy'
	  })('clio'); // spawn an instance of the driver that one can call .login() on
	};
	
	var _hello = __webpack_require__(112);
	
	var _hello2 = _interopRequireDefault(_hello);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ClioConnectionSettingsForm = __webpack_require__(576);
	
	var _ClioConnectionSettingsForm2 = _interopRequireDefault(_ClioConnectionSettingsForm);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _Notification = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClioConnectionSettings = function (_Component) {
	  _inherits(ClioConnectionSettings, _Component);
	
	  function ClioConnectionSettings() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ClioConnectionSettings);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.initialState = {
	      isLoading: true,
	      error: null,
	      clioSettings: {}
	    }, _this.state = _extends({}, _this.initialState), _this.onSave = function (clioSettings) {
	      console.log("Submit: ", clioSettings);
	
	      return _superagent2.default.post('/rpc/integrations/connections/' + _this.props.connectionId + '/clio/settings').send(clioSettings).then(function (res) {
	        console.debug('Saved! Result:', res);
	        _Notification.notify.success('Clio Settings Saved');
	      }, function (errRes) {
	        var _ref;
	
	        console.error('Error Saving!', errRes);
	        return _ref = {}, _ref[_reactFinalForm.FORM_ERROR] = 'Error Saving', _ref;
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ClioConnectionSettings.prototype.componentDidMount = function componentDidMount() {
	    this.fetchConnectionSettings();
	  };
	
	  ClioConnectionSettings.prototype.fetchConnectionSettings = function fetchConnectionSettings(refreshFromClio) {
	    var _this2 = this;
	
	    this.setState(this.initialState);
	
	    return _superagent2.default.get('/rpc/integrations/connections/' + this.props.connectionId + '/clio/settings').query({ refresh: refreshFromClio }).then(function (res) {
	      _this2.setState({
	        isLoading: false,
	        clioSettings: res.body
	      });
	    }).catch(function (err) {
	      console.error("Failed to fetch clio settings: ", err);
	
	      // 404 not found just means no settings have been configured.
	      _this2.setState({
	        isLoading: false,
	        error: _lodash2.default.get(err, 'response.status') !== 404 ? true : false
	      });
	    });
	  };
	
	  ClioConnectionSettings.prototype.render = function render() {
	    var _this3 = this;
	
	    var connectionId = this.props.connectionId;
	
	
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Panel,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Panel.Heading,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Panel.Title,
	            { componentClass: 'h3' },
	            'Clio Settings'
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Panel.Body,
	          null,
	          function () {
	            if (_this3.state.error) return _react2.default.createElement(
	              _reactBootstrap.Alert,
	              { bsStyle: 'danger' },
	              'There was an error loading Clio Settings Information. If the problem persists, please contact CourtDrive support.'
	            );
	
	            if (_this3.state.isLoading) return _react2.default.createElement(_reactBootstrap.ProgressBar, { active: true, now: 100 });
	
	            return _react2.default.createElement(_ClioConnectionSettingsForm2.default, {
	              connectionId: connectionId,
	              onSave: _this3.onSave,
	              clioSettings: _this3.state.clioSettings
	            });
	          }()
	        )
	      )
	    );
	  };
	
	  return ClioConnectionSettings;
	}(_react.Component);
	
	ClioConnectionSettings.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  connectionId: _propTypes2.default.number.isRequired
	};
	exports.default = ClioConnectionSettings;

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactFinalFormHtml5Validation = __webpack_require__(511);
	
	var _finalFormArrays = __webpack_require__(189);
	
	var _finalFormArrays2 = _interopRequireDefault(_finalFormArrays);
	
	var _ClioDocumentCategorySelector = __webpack_require__(342);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _Notification = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClioConnectionSettingsForm = function (_Component) {
	  _inherits(ClioConnectionSettingsForm, _Component);
	
	  function ClioConnectionSettingsForm() {
	    _classCallCheck(this, ClioConnectionSettingsForm);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ClioConnectionSettingsForm.prototype.render = function render() {
	    var _props = this.props,
	        connectionId = _props.connectionId,
	        clioSettings = _props.clioSettings,
	        onSave = _props.onSave;
	
	
	    return _react2.default.createElement(
	      _reactFinalForm.Form,
	      { onSubmit: onSave, initialValues: clioSettings, mutators: _extends({}, _finalFormArrays2.default) },
	      function (_ref) {
	        var handleSubmit = _ref.handleSubmit,
	            pristine = _ref.pristine,
	            submitting = _ref.submitting;
	        return _react2.default.createElement(
	          _reactBootstrap.Form,
	          { horizontal: true, style: { padding: "8px 42px 8px 16px" }, onSubmit: handleSubmit },
	          _react2.default.createElement(
	            _reactBootstrap.FormGroup,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.ControlLabel,
	              null,
	              'Default Document Category'
	            ),
	            _react2.default.createElement(_reactFinalFormHtml5Validation.Field, { name: 'document_category_id', connectionId: connectionId, component: _ClioDocumentCategorySelector.FinalFormClioDocumentCategorySelector })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.FormGroup,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { type: 'submit', bsStyle: 'primary', disabled: pristine || submitting },
	              'Save'
	            )
	          )
	        );
	      }
	    );
	  };
	
	  return ClioConnectionSettingsForm;
	}(_react.Component);
	
	ClioConnectionSettingsForm.propTypes = {
	  connectionId: _propTypes2.default.number.isRequired,
	  clioSettings: _propTypes2.default.object.isRequired,
	  onSave: _propTypes2.default.func.isRequired
	};
	exports.default = ClioConnectionSettingsForm;

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(129);
	
	var _integrationsConnectionActions = __webpack_require__(46);
	
	var _clio = __webpack_require__(2222);
	
	var _clio2 = _interopRequireDefault(_clio);
	
	var _ClioAuthenticator = __webpack_require__(574);
	
	var _ClioAuthenticator2 = _interopRequireDefault(_ClioAuthenticator);
	
	var _Notification = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClioSwitch = function (_Component) {
	  _inherits(ClioSwitch, _Component);
	
	  function ClioSwitch() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ClioSwitch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      loading: false
	    }, _this.onClick = function () {
	      var connectionId = _this.props.connectionId;
	
	
	      if (connectionId === null) {
	        _this.setState({ loading: true });
	        (0, _ClioAuthenticator2.default)().login({
	          // TODO adjust scopes to minimum required
	          scope: 'full',
	          state: { redirect_host: window.location.host }
	        }).then(function (_ref) {
	          var authResponse = _ref.authResponse;
	
	          _this.props.dispatch((0, _integrationsConnectionActions.connectIntegration)('files', 'clio', authResponse));
	          _this.setState({ loading: false });
	        }, function (res) {
	          var _res$error = res.error,
	              code = _res$error.code,
	              message = _res$error.message;
	
	          _this.setState({ loading: false });
	          _Notification.notify.error('Error connecting to Clio: [' + code + '] ' + (message || ''));
	        });
	      } else {
	        _this.props.dispatch((0, _integrationsConnectionActions.disconnectIntegration)(connectionId));
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ClioSwitch.prototype.render = function render() {
	    var _props = this.props,
	        connectionId = _props.connectionId,
	        agreedToPricing = _props.agreedToPricing;
	
	    var iconCls = 'kloudless-switch ' + (connectionId ? 'on' : '') + ' ' + (agreedToPricing ? '' : 'hidden');
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'kloudless-control-holder2' },
	      _react2.default.createElement('img', { className: 'kloudless-connection-icon',
	        src: _clio2.default, TODO: true,
	        alt: 'Clio logo'
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: iconCls, onClick: this.onClick },
	        this.state.loading && _react2.default.createElement('i', {
	          className: "fa fa-circle-o-notch fa-spin",
	          style: { marginTop: '10px', marginLeft: '11px', fontSize: '11px' }
	
	        })
	      )
	    );
	  };
	
	  return ClioSwitch;
	}(_react.Component);
	
	ClioSwitch.defaultProps = {
	  connectionId: null
	};
	ClioSwitch.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  connectionId: _propTypes2.default.number,
	  agreedToPricing: _propTypes2.default.bool.isRequired
	};
	exports.default = ClioSwitch;

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactBootstrap = __webpack_require__(7);
	
	__webpack_require__(129);
	
	var _BoxSwitch = __webpack_require__(571);
	
	var _BoxSwitch2 = _interopRequireDefault(_BoxSwitch);
	
	var _DropboxSwitch = __webpack_require__(581);
	
	var _DropboxSwitch2 = _interopRequireDefault(_DropboxSwitch);
	
	var _GoogleDriveSwitch = __webpack_require__(591);
	
	var _GoogleDriveSwitch2 = _interopRequireDefault(_GoogleDriveSwitch);
	
	var _IManageSwitch = __webpack_require__(592);
	
	var _IManageSwitch2 = _interopRequireDefault(_IManageSwitch);
	
	var _NetDocumentsSwitch = __webpack_require__(598);
	
	var _NetDocumentsSwitch2 = _interopRequireDefault(_NetDocumentsSwitch);
	
	var _NetDocumentsDocketLinkPanel = __webpack_require__(597);
	
	var _NetDocumentsDocketLinkPanel2 = _interopRequireDefault(_NetDocumentsDocketLinkPanel);
	
	var _OneDriveSwitch = __webpack_require__(600);
	
	var _OneDriveSwitch2 = _interopRequireDefault(_OneDriveSwitch);
	
	var _CalendarFeedSwitch = __webpack_require__(573);
	
	var _CalendarFeedSwitch2 = _interopRequireDefault(_CalendarFeedSwitch);
	
	var _CalendarFeedConfig = __webpack_require__(572);
	
	var _CalendarFeedConfig2 = _interopRequireDefault(_CalendarFeedConfig);
	
	var _FileSyncSettings = __webpack_require__(582);
	
	var _FileSyncSettings2 = _interopRequireDefault(_FileSyncSettings);
	
	var _RocketMatterSwitch = __webpack_require__(601);
	
	var _RocketMatterSwitch2 = _interopRequireDefault(_RocketMatterSwitch);
	
	var _SharepointSwitch = __webpack_require__(604);
	
	var _SharepointSwitch2 = _interopRequireDefault(_SharepointSwitch);
	
	var _SharepointConnectionSettings = __webpack_require__(602);
	
	var _SharepointConnectionSettings2 = _interopRequireDefault(_SharepointConnectionSettings);
	
	var _FileSyncUploadDestinationSettings = __webpack_require__(583);
	
	var _FileSyncUploadDestinationSettings2 = _interopRequireDefault(_FileSyncUploadDestinationSettings);
	
	var _Notification = __webpack_require__(40);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	var _integrationsConnectionActions = __webpack_require__(46);
	
	var _box = __webpack_require__(957);
	
	var _box2 = _interopRequireDefault(_box);
	
	var _dropbox = __webpack_require__(958);
	
	var _dropbox2 = _interopRequireDefault(_dropbox);
	
	var _gdrive = __webpack_require__(959);
	
	var _gdrive2 = _interopRequireDefault(_gdrive);
	
	var _onedrive = __webpack_require__(960);
	
	var _onedrive2 = _interopRequireDefault(_onedrive);
	
	var _onedrivebiz = __webpack_require__(2225);
	
	var _onedrivebiz2 = _interopRequireDefault(_onedrivebiz);
	
	var _rocketmatter = __webpack_require__(961);
	
	var _rocketmatter2 = _interopRequireDefault(_rocketmatter);
	
	var _sharepointonline = __webpack_require__(962);
	
	var _sharepointonline2 = _interopRequireDefault(_sharepointonline);
	
	var _FilenameTemplate = __webpack_require__(343);
	
	var _FilenameTemplate2 = _interopRequireDefault(_FilenameTemplate);
	
	var _InstructionsPanel = __webpack_require__(593);
	
	var _InstructionsPanel2 = _interopRequireDefault(_InstructionsPanel);
	
	var _PricingAgreement = __webpack_require__(588);
	
	var _PricingAgreement2 = _interopRequireDefault(_PricingAgreement);
	
	var _NetDocumentsCabinetsConfig = __webpack_require__(596);
	
	var _NetDocumentsCabinetsConfig2 = _interopRequireDefault(_NetDocumentsCabinetsConfig);
	
	var _globalUtils = __webpack_require__(59);
	
	var _ClioSwitch = __webpack_require__(577);
	
	var _ClioSwitch2 = _interopRequireDefault(_ClioSwitch);
	
	var _ClioConnectionSettings = __webpack_require__(575);
	
	var _ClioConnectionSettings2 = _interopRequireDefault(_ClioConnectionSettings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Icons --------------------------------------------------------------
	
	// --------------------------------------------------------------------
	
	var icons = {
	  box: _box2.default,
	  dropbox: _dropbox2.default,
	  gdrive: _gdrive2.default,
	  onedrive: _onedrive2.default,
	  onedrivebiz: _onedrivebiz2.default,
	  sharepointonline: _sharepointonline2.default
	};
	
	var ConnectionsLayout = function (_Component) {
	  _inherits(ConnectionsLayout, _Component);
	
	  function ConnectionsLayout() {
	    _classCallCheck(this, ConnectionsLayout);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ConnectionsLayout.prototype.componentDidMount = function componentDidMount() {
	    this.props.dispatch((0, _integrationsConnectionActions.getConnections)());
	  };
	
	  ConnectionsLayout.prototype.render = function render() {
	    var _this2 = this;
	
	    var kloudless = this.props.kloudless;
	    var errorMessage = kloudless.errorMessage,
	        isLoading = kloudless.isLoading,
	        results = kloudless.results,
	        agreedToPricing = kloudless.agreedToPricing;
	
	    var connections = _lodash2.default.get(kloudless, 'results', []);
	
	    var svcProps = function svcProps(svcName) {
	      var connectionDetails = _lodash2.default.find(results, { service: svcName }) || {};
	      var key = 'integration-connection-switch-' + svcName;
	
	      return {
	        key: key,
	        dispatch: _this2.props.dispatch,
	        imgSrc: icons[svcName],
	        connectionId: connectionDetails.connectionId || null,
	        svcName: svcName,
	        agreedToPricing: agreedToPricing
	      };
	    };
	
	    if (errorMessage) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'error-loading' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'this.props.kloudless.errorMessage'
	        )
	      );
	    }
	
	    if (isLoading) return _react2.default.createElement(_reactBootstrap.ProgressBar, { now: 100, active: true });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'kloudless-layout' },
	      _react2.default.createElement(_PricingAgreement2.default, { dispatch: this.props.dispatch,
	        showAgreeLink: !agreedToPricing }),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Notification2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'kloudless-switch-container' },
	          _react2.default.createElement(_BoxSwitch2.default, svcProps('box')),
	          _react2.default.createElement(_DropboxSwitch2.default, svcProps('dropbox')),
	          _react2.default.createElement(_GoogleDriveSwitch2.default, svcProps('gdrive')),
	          (0, _globalUtils.drupalPermsInclude)('iManage Integration') && _react2.default.createElement(_IManageSwitch2.default, svcProps('imanage')),
	          _react2.default.createElement(_OneDriveSwitch2.default, svcProps('onedrive')),
	          _react2.default.createElement(_SharepointSwitch2.default, svcProps('sharepoint')),
	          (0, _globalUtils.drupalPermsInclude)('NetDocuments Integration') && _react2.default.createElement(_NetDocumentsSwitch2.default, svcProps('netdocuments')),
	          (0, _globalUtils.drupalPermsInclude)('Clio Integration') && _react2.default.createElement(_ClioSwitch2.default, svcProps('clio')),
	          (0, _globalUtils.drupalPermsInclude)('RocketMatter Integration') && _react2.default.createElement(_RocketMatterSwitch2.default, svcProps('rocketmatter')),
	          _react2.default.createElement(_CalendarFeedSwitch2.default, svcProps('calendar'))
	        ),
	        _react2.default.createElement(_InstructionsPanel2.default, null)
	      ),
	      connections.length > 0 && _react2.default.createElement(
	        'h1',
	        { className: 'title' },
	        'Service Settings'
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Tabs,
	        { animation: false },
	        connections.map(function (connection, index) {
	          return _react2.default.createElement(
	            _reactBootstrap.Tab,
	            { eventKey: index, title: _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement('i', { className: 'fa fa-gear' }),
	                ' ',
	                connection.service
	              ) },
	            connection.connectionId && agreedToPricing && connection.integration_type === 'files' && !connection.hasMatterFolders && _react2.default.createElement(_FileSyncUploadDestinationSettings2.default, {
	              dispatch: _this2.props.dispatch,
	              connectionId: connection.connectionId,
	              folderConfig: connection.folder_config
	            }),
	            connection.connectionId && agreedToPricing && connection.integration_type === 'files' && _react2.default.createElement(_FileSyncSettings2.default, {
	              dispatch: _this2.props.dispatch,
	              connectionId: connection.connectionId,
	              syncType: connection.sync_type,
	              syncFrom: connection.sync_from,
	              combinePDFs: connection.combine_pdfs,
	              syncMode: connection.sync_mode
	            }),
	            connection.connectionId && agreedToPricing && connection.integration_type === 'calendar' && _react2.default.createElement(_CalendarFeedConfig2.default, {
	              connectionId: connection.connectionId,
	              dispatch: _this2.props.dispatch
	            }),
	            connection.connectionId && agreedToPricing && connection.integration_type === 'files' && connection.filenameSettings && _react2.default.createElement(_FilenameTemplate2.default, {
	              filenameTemplate: connection.filenameSettings.filenameTemplate,
	              connectionId: connection.connectionId,
	              dispatch: _this2.props.dispatch,
	              allowFolderConfiguration: connection.folder_config === 'connection',
	              hasAppFolder: connection.hasAppFolder
	            }),
	            connection.connectionId && agreedToPricing && connection.service === 'netdocuments' && _react2.default.createElement(_NetDocumentsDocketLinkPanel2.default, { connectionId: connection.connectionId }),
	            connection.connectionId && agreedToPricing && connection.service === 'netdocuments' && _react2.default.createElement(_NetDocumentsCabinetsConfig2.default, {
	              connectionId: connection.connectionId,
	              dispatch: _this2.props.dispatch
	            }),
	            connection.connectionId && agreedToPricing && connection.service === 'clio' && _react2.default.createElement(_ClioConnectionSettings2.default, {
	              connectionId: connection.connectionId,
	              dispatch: _this2.props.dispatch
	            }),
	            connection.connectionId && agreedToPricing && connection.service === 'sharepoint' && connection.folder_config === 'connection' && _react2.default.createElement(_SharepointConnectionSettings2.default, {
	              connectionId: connection.connectionId,
	              dispatch: _this2.props.dispatch
	            })
	          );
	        })
	      )
	    );
	  };
	
	  return ConnectionsLayout;
	}(_react.Component);
	
	ConnectionsLayout.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  kloudless: _propTypes2.default.object.isRequired,
	  svc: _propTypes2.default.array.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    kloudless: state.get('kloudless')
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ConnectionsLayout);

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    { className: "default-configurations" },
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        "span",
	        { className: "filename-template-heading" },
	        "Default Configurations"
	      ),
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(
	        "b",
	        null,
	        "If you choose not to customize your folder and file formats, we will use the following defaults:"
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      { className: "subtext" },
	      "Folders will be created on the service as follows: CourtDrive/{case number - case name}",
	      _react2.default.createElement("br", null),
	      "Files will be named as follows: court-citation_case_number_docket-entry-number.pdf"
	    )
	  );
	};

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (type) {
	  return _hello2.default
	  // Initialize Driver instance
	  .init({
	    dropbox: type === 'full' ? window.Drupal.settings.INTEGRATIONS_DROPBOX_FULL_APP_ID // Use Full Access App
	    : window.Drupal.settings.INTEGRATIONS_DROPBOX_APP_ID // Use AppFolder App
	  }, {
	    redirect_uri: 'https://app.courtdrive.com/rpc/static/hello.js/redirect.html',
	    oauth_proxy: window.location.origin + '/rpc/integrations/oauth_proxy',
	    response_type: 'code'
	  })('dropbox'); // spawn an instance of the driver that one can call .login() on
	};
	
	var _hello = __webpack_require__(112);
	
	var _hello2 = _interopRequireDefault(_hello);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	__webpack_require__(129);
	
	var _integrationsConnectionActions = __webpack_require__(46);
	
	var _dropbox = __webpack_require__(958);
	
	var _dropbox2 = _interopRequireDefault(_dropbox);
	
	var _Notification = __webpack_require__(24);
	
	var _DropboxAuthenticator = __webpack_require__(580);
	
	var _DropboxAuthenticator2 = _interopRequireDefault(_DropboxAuthenticator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DropboxSwitch = function (_React$Component) {
	  _inherits(DropboxSwitch, _React$Component);
	
	  function DropboxSwitch() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DropboxSwitch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      loading: false,
	      showTypeChooser: false
	    }, _this.handleShowChooser = function () {
	      _this.setState({ showTypeChooser: true });
	    }, _this.handleHideChooser = function () {
	      _this.setState({ showTypeChooser: false });
	    }, _this.connectDropbox = function (type) {
	      _this.setState({ showTypeChooser: false, loading: true });
	
	      (0, _DropboxAuthenticator2.default)(type).login({ state: { connection_type: type, redirect_host: window.location.host } }).then(function (_ref) {
	        var authResponse = _ref.authResponse;
	
	        _this.props.dispatch((0, _integrationsConnectionActions.connectIntegration)('files', 'dropbox', authResponse));
	        _this.setState({ loading: false });
	      }, function (res) {
	        var _res$error = res.error,
	            code = _res$error.code,
	            message = _res$error.message;
	
	        _this.setState({ loading: false });
	        _Notification.notify.error('Error connecting to Dropbox: [' + code + '] ' + (message || ''));
	      });
	    }, _this.onClick = function () {
	      var _this$props = _this.props,
	          connectionId = _this$props.connectionId,
	          agreedToPricing = _this$props.agreedToPricing;
	
	
	      if (connectionId === null) {
	        _this.handleShowChooser();
	        return;
	      } else {
	        // just turn off the integration.
	        _this.props.dispatch((0, _integrationsConnectionActions.disconnectIntegration)(connectionId));
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  DropboxSwitch.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        connectionId = _props.connectionId,
	        agreedToPricing = _props.agreedToPricing;
	
	
	    var iconCls = 'kloudless-switch ' + (connectionId ? 'on' : '') + ' ' + (agreedToPricing ? '' : 'hidden');
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'kloudless-control-holder2' },
	      _react2.default.createElement('img', { className: 'kloudless-connection-icon',
	        src: _dropbox2.default,
	        alt: 'Dropbox Logo'
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: iconCls, onClick: this.onClick },
	        this.state.loading && _react2.default.createElement('i', { className: "fa fa-circle-o-notch fa-spin",
	          style: { marginTop: '10px', marginLeft: '11px', fontSize: '11px' } })
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Modal,
	        { show: this.state.showTypeChooser, onHide: this.handleHideChooser },
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Header,
	          { closeButton: true },
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Title,
	            null,
	            'Choose Dropbox Integration Type'
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Panel.Heading,
	              null,
	              'App Folder ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Dropbox/Apps/CourtDrive'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Panel.Body,
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Files will be uploaded to Dropbox under Apps/CourtDrive.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'CourtDrive will not be able to read or write any files outside of this folder.'
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { bsStyle: 'primary', onClick: function onClick() {
	                    return _this2.connectDropbox('appFolder');
	                  } },
	                'Choose App Folder'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Panel.Heading,
	              null,
	              'Full Access ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Dropbox/CourtDrive'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Panel.Body,
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Files will be uploaded under a folder name that you choose at the top of your Dropbox folder.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'CourtDrive will need read/write access to your entire Dropbox for this.'
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { bsStyle: 'primary', onClick: function onClick() {
	                    return _this2.connectDropbox('full');
	                  } },
	                'Choose Full Access'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return DropboxSwitch;
	}(_react2.default.Component);
	
	DropboxSwitch.defaultProps = {
	  connectionId: null
	};
	DropboxSwitch.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  connectionId: _propTypes2.default.number,
	  agreedToPricing: _propTypes2.default.bool.isRequired
	};
	exports.default = DropboxSwitch;

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactBootstrapToggle = __webpack_require__(865);
	
	var _reactBootstrapToggle2 = _interopRequireDefault(_reactBootstrapToggle);
	
	var _reactDatepicker = __webpack_require__(900);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	__webpack_require__(952);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _Notification = __webpack_require__(24);
	
	var _integrationsConnectionActions = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var datePickerAdapter = function datePickerAdapter(_ref) {
	  var _ref$input = _ref.input,
	      _onChange = _ref$input.onChange,
	      value = _ref$input.value,
	      rest = _objectWithoutProperties(_ref, ['input']);
	
	  // console.log("Picker value", value);
	  return _react2.default.createElement(_reactDatepicker2.default, _extends({
	    selected: value,
	    onChange: function onChange(newDate) {
	      return _onChange(newDate);
	    }
	  }, rest));
	};
	
	var toggleAdapter = function toggleAdapter(_ref2) {
	  var _ref2$input = _ref2.input,
	      onChange = _ref2$input.onChange,
	      value = _ref2$input.value,
	      rest = _objectWithoutProperties(_ref2, ['input']);
	
	  return _react2.default.createElement(_reactBootstrapToggle2.default, _extends({
	    active: !!value,
	    onClick: function onClick() {
	      return onChange(!value);
	    }
	  }, rest));
	};
	
	var syncModeToggleAdapter = function syncModeToggleAdapter(_ref3) {
	  var _ref3$input = _ref3.input,
	      onChange = _ref3$input.onChange,
	      value = _ref3$input.value,
	      rest = _objectWithoutProperties(_ref3, ['input']);
	
	  return _react2.default.createElement(_reactBootstrapToggle2.default, _extends({
	    active: value === 'user',
	    onClick: function onClick() {
	      return onChange(value === 'user' ? 'firm' : 'user');
	    }
	  }, rest));
	};
	
	var FileSyncSettings = function (_React$Component) {
	  _inherits(FileSyncSettings, _React$Component);
	
	  function FileSyncSettings(props) {
	    _classCallCheck(this, FileSyncSettings);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.initialState = {
	      isLoading: false,
	      error: null
	    };
	
	    _this.state = _extends({}, _this.initialState);
	    return _this;
	  }
	
	  FileSyncSettings.prototype.formInitialValues = function formInitialValues() {
	    return {
	      use_start_date: this.props.syncType === 'new',
	      sync_from: this.props.syncFrom,
	      combine_pdfs: this.props.combinePDFs,
	      sync_mode: this.props.syncMode
	    };
	  };
	
	  FileSyncSettings.prototype.onSave = function onSave(settings) {
	    var _this2 = this;
	
	    var values = {
	      sync_type: settings.use_start_date ? 'new' : 'full',
	      sync_from: settings.sync_from.toISOString(),
	      combine_pdfs: settings.combine_pdfs,
	      sync_mode: settings.sync_mode
	    };
	
	    return _superagent2.default.patch('/rpc/integrations/connections/' + this.props.connectionId).send(values).then(function (res) {
	      _Notification.notify.success('Document Upload Settings Saved');
	      console.log("Received update: ", res.body);
	      _this2.props.dispatch((0, _integrationsConnectionActions.updateConnection)(_this2.props.connectionId, res.body));
	    }, function (errRes) {
	      var _ref4;
	
	      return _ref4 = {}, _ref4[_reactFinalForm.FORM_ERROR] = 'Error Saving Document Upload Settings', _ref4;
	    });
	  };
	
	  FileSyncSettings.prototype.render = function render() {
	    var _this3 = this;
	
	    return _react2.default.createElement(
	      _reactFinalForm.Form,
	      {
	        onSubmit: function onSubmit(settings) {
	          return _this3.onSave(settings);
	        },
	        initialValues: this.formInitialValues()
	      },
	      function (_ref5) {
	        var handleSubmit = _ref5.handleSubmit,
	            form = _ref5.form,
	            submitting = _ref5.submitting,
	            pristine = _ref5.pristine,
	            values = _ref5.values;
	        return _react2.default.createElement(
	          _reactBootstrap.Form,
	          { onSubmit: handleSubmit },
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Panel.Heading,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Panel.Title,
	                null,
	                'How should we upload your PDFs?'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Panel.Body,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                null,
	                _react2.default.createElement(_reactFinalForm.Field, { name: 'use_start_date', component: toggleAdapter, size: 'xs', onstyle: "success" }),
	                ' ',
	                ' ',
	                _react2.default.createElement(
	                  _reactBootstrap.ControlLabel,
	                  null,
	                  'Restrict Uploads to a Specific Start Date'
	                )
	              ),
	              values.use_start_date && _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.ControlLabel,
	                  null,
	                  'Only upload documents accruing to my account on or after:'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(_reactFinalForm.Field, {
	                  name: 'sync_from',
	                  component: datePickerAdapter,
	                  placeholder: 'Select a starting date',
	                  todayButton: 'Today',
	                  dateFormat: 'MM/dd/yyyy'
	                })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                null,
	                _react2.default.createElement(_reactFinalForm.Field, { name: 'combine_pdfs', component: toggleAdapter, size: 'xs', onstyle: "success" }),
	                ' ',
	                ' ',
	                _react2.default.createElement(
	                  _reactBootstrap.ControlLabel,
	                  null,
	                  'Upload combined PDFs (leave OFF to upload exhibits as separate PDFs)'
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                null,
	                _react2.default.createElement(_reactFinalForm.Field, { name: 'sync_mode', component: syncModeToggleAdapter, size: 'xs', onstyle: "success" }),
	                ' ',
	                _react2.default.createElement(
	                  _reactBootstrap.ControlLabel,
	                  null,
	                  'Restrict uploads to my CaseFolders only (leave OFF to upload PDFs for all Firm CaseFolders)'
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  { type: 'submit', bsStyle: 'primary', disabled: pristine || submitting },
	                  'Save'
	                )
	              )
	            )
	          )
	        );
	      }
	    );
	  };
	
	  return FileSyncSettings;
	}(_react2.default.Component);
	
	FileSyncSettings.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  connectionId: _propTypes2.default.number.isRequired,
	  syncType: _propTypes2.default.string.isRequired,
	  syncFrom: _propTypes2.default.instanceOf(Date).isRequired,
	  combinePDFs: _propTypes2.default.bool.isRequired,
	  syncMode: _propTypes2.default.string.isRequired
	};
	exports.default = FileSyncSettings;
	;

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = FileSyncUploadDestinationSettings;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _integrationsConnectionActions = __webpack_require__(46);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _Notification = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FileSyncUploadDestinationSettings(_ref) {
	  var dispatch = _ref.dispatch,
	      connectionId = _ref.connectionId,
	      folderConfig = _ref.folderConfig;
	
	  var onSave = function onSave(settings) {
	    return _superagent2.default.patch('/rpc/integrations/connections/' + connectionId).send(settings).then(function (res) {
	      _Notification.notify.success('PDF Destination setting saved');
	      dispatch((0, _integrationsConnectionActions.updateConnection)(connectionId, res.body));
	    }, function (errRes) {
	      _Notification.notify.error('Failed to save PDF destination settings');
	    });
	  };
	
	  return _react2.default.createElement(
	    _reactFinalForm.Form,
	    {
	      onSubmit: function onSubmit(settings) {
	        return onSave(settings);
	      },
	      initialValues: { folder_config: folderConfig }
	    },
	    function (_ref2) {
	      var handleSubmit = _ref2.handleSubmit,
	          form = _ref2.form,
	          submitting = _ref2.submitting,
	          pristine = _ref2.pristine,
	          values = _ref2.values;
	      return _react2.default.createElement(
	        _reactBootstrap.Form,
	        { onSubmit: handleSubmit },
	        _react2.default.createElement(
	          _reactBootstrap.Panel,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Panel.Heading,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Panel.Title,
	              null,
	              'Where do you want your PDFs to go?'
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Panel.Body,
	            null,
	            values.folder_config === 'none' && _react2.default.createElement(
	              _reactBootstrap.Alert,
	              { bsStyle: 'warning' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                'Selection Required'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'No PDFs will be synced until you choose where you want to save your PDFs.'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.FormGroup,
	              null,
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactFinalForm.Field, { name: 'folder_config', component: 'input', value: 'casefolder', type: 'radio' }),
	                ' ',
	                'Upload PDFs to their corresponding client matter folders (configure your folder paths per case)',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  'NOTE:'
	                ),
	                ' PDFs will begin to upload as you configure each case in the CaseFolder settings.'
	              ),
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactFinalForm.Field, { name: 'folder_config', component: 'input', value: 'connection', type: 'radio' }),
	                ' ',
	                'Upload PDFs to a single folder with optional subfolders (configure your folder path below)',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  'NOTE:'
	                ),
	                ' PDFs will begin to upload 15 minutes after you save this selection.'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { bsStyle: 'primary', type: 'submit', disabled: pristine || submitting },
	              'Save'
	            )
	          )
	        )
	      );
	    }
	  );
	}

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CustomizeDescriptionBox = function CustomizeDescriptionBox() {
	  return _react2.default.createElement(
	    "div",
	    { className: "customize-description-box" },
	    _react2.default.createElement(
	      "div",
	      { className: "filename-template-heading" },
	      "Customize your filename format below"
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "filename-template-heading2" },
	      "Click \u201Cedit\u201D in either the Folder or Filename box to edit configurations for that setting.",
	      _react2.default.createElement("br", null),
	      "Select fields on the left to add them to your configuration.  Click Save at the bottom when done."
	    )
	  );
	};
	
	exports.default = CustomizeDescriptionBox;

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _PopoverOfForm = __webpack_require__(410);
	
	var _PopoverOfForm2 = _interopRequireDefault(_PopoverOfForm);
	
	var _filenameTemplateFields = __webpack_require__(169);
	
	var _filenameTemplateFields2 = _interopRequireDefault(_filenameTemplateFields);
	
	var _Notification = __webpack_require__(24);
	
	var _integrationsConnectionActions = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FieldsSelector = function (_Component) {
	  _inherits(FieldsSelector, _Component);
	
	  function FieldsSelector() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FieldsSelector);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.validateMaxWords = function () {
	      var description_max_words = _this.props.description_max_words;
	
	      if (description_max_words > 10) {
	        _Notification.notify.error('Error!  Description max words exceeded (10): ' + description_max_words, { position: 'top-center' });
	      }
	    }, _this.changeMaxWords = function (e) {
	      _this.props.dispatch((0, _integrationsConnectionActions.updateFilenameTemplate)(_this.props.connectionId, { description_max_words: e.target.value }));
	    }, _this.changeDateFormat = function (e) {
	      _this.props.dispatch((0, _integrationsConnectionActions.updateFilenameTemplate)(_this.props.connectionId, { date_format: e.target.value }));
	    }, _this.validateDateFormat = function () {
	      var date_format = _this.props.date_format;
	
	      if (date_format.match(/^[MMDDYYYY\- .]*$/) === null) {
	        _Notification.notify.error('Error!  Bad date format: ' + date_format, { position: 'top-center' });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  FieldsSelector.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        description_max_words = _props.description_max_words,
	        date_format = _props.date_format,
	        editableSection = _props.editableSection,
	        root_folder = _props.root_folder,
	        addField = _props.addField,
	        addRootFolder = _props.addRootFolder;
	
	
	    var isFolderPathEditable = editableSection === 'folder-path-configuration';
	    var isFileFormatEditable = editableSection === 'file-format-configuration';
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'fields-selector left-panel ' + (editableSection === '' ? 'hidden' : '') },
	      _react2.default.createElement(
	        'div',
	        { className: 'field-group' },
	        _react2.default.createElement(
	          'div',
	          { className: 'label' },
	          'Document Fields'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'fields' },
	          _filenameTemplateFields2.default.filter(function (f) {
	            return f.type === 'document';
	          }).map(function (field, idx) {
	            var tooltip = null;
	            var value = null;
	
	            if (field.tooltip) {
	              tooltip = field.tooltip();
	            }
	
	            if (field.name === 'document_description') {
	              value = _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Doc Description of',
	                  _react2.default.createElement('input', { type: 'text',
	                    className: 'description-max-words',
	                    onBlur: _this2.validateMaxWords,
	                    onClick: function onClick(e) {
	                      // input field is a child of a clickable div.  prevent event from bubbling up to parent
	                      e.stopPropagation();
	                    },
	                    onChange: _this2.changeMaxWords,
	                    value: description_max_words }),
	                  'words'
	                ),
	                tooltip
	              );
	            } else {
	              value = _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  field.value
	                ),
	                ' ',
	                tooltip
	              );
	            }
	            return _react2.default.createElement(
	              'div',
	              { key: 'selectablef-' + field.name + '-' + idx,
	                className: 'field',
	                onClick: function onClick() {
	                  return addField(field.name);
	                } },
	              value
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'field-group' },
	        _react2.default.createElement(
	          'div',
	          { className: 'label' },
	          'Case Related Fields'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'fields' },
	          _filenameTemplateFields2.default.filter(function (f) {
	            return f.type === 'case';
	          }).map(function (field, idx) {
	            return _react2.default.createElement(
	              'div',
	              { key: 'selectablef2-' + field.name + '-' + idx,
	                className: 'field',
	                onClick: function onClick() {
	                  return addField(field.name);
	                } },
	              _react2.default.createElement(
	                'span',
	                null,
	                field.value
	              )
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'field-group' },
	        _react2.default.createElement(
	          'div',
	          { className: 'label' },
	          'Court Related Fields'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'fields' },
	          _filenameTemplateFields2.default.filter(function (f) {
	            return f.type === 'court';
	          }).map(function (field, idx) {
	            return _react2.default.createElement(
	              'div',
	              { key: 'selectablef3-' + field.name + '-' + idx,
	                className: 'field',
	                onClick: function onClick() {
	                  return addField(field.name);
	                } },
	              _react2.default.createElement(
	                'span',
	                null,
	                field.value
	              )
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'field-group' },
	        _react2.default.createElement(
	          'div',
	          { className: 'label' },
	          'Formatting Options'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'fields separators-fields margin-top-5' },
	          _filenameTemplateFields2.default.filter(function (x) {
	            return x.type === 'separator';
	          }).map(function (field, idx) {
	            var editable = field.showOnFolderPathEdit && isFolderPathEditable || field.showOnFileFormatEdit && isFileFormatEditable;
	
	            return _react2.default.createElement(
	              'div',
	              { key: 'sepfield-' + field.name + '-' + idx,
	                className: 'field-separator ' + (editable ? '' : 'hidden'),
	                onClick: function onClick() {
	                  return addField(field.name);
	                } },
	              field.value
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'field-group' },
	        _react2.default.createElement(
	          'div',
	          { className: 'label' },
	          'Date Format'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'fields margin-top-5' },
	          _react2.default.createElement(
	            'div',
	            { className: 'field-no-hover date-format-selector ' + (isFolderPathEditable ? 'hidden' : '') },
	            _react2.default.createElement(
	              'span',
	              null,
	              'Date Format'
	            ),
	            _react2.default.createElement('input', { type: 'text',
	              onChange: this.changeDateFormat,
	              onBlur: this.validateDateFormat,
	              value: date_format }),
	            _react2.default.createElement(
	              _PopoverOfForm2.default,
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Customize date field formats'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Must include at least one of the following: DD MM YYYY'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'May use these field separators:'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                '. - [space] '
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Examples:'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'YYYY-MM-DD , MM-DD-YYYY, YYYY.MM.DD, YYYY DD'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'field-group' },
	        _react2.default.createElement(
	          'div',
	          { className: 'label' },
	          'Root Folder'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'fields margin-top-5' },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'field-no-hover date-format-selector ' + (isFolderPathEditable ? '' : 'hidden') },
	            _react2.default.createElement(
	              'span',
	              null,
	              'Root Folder'
	            ),
	            _react2.default.createElement('input', { type: 'text',
	              onChange: addRootFolder
	              // onBlur={this.validateDateFormat}
	              , value: root_folder }),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { bsSize: 'xsmall',
	                bsStyle: 'primary',
	                className: 'add-btn',
	                onClick: function onClick() {
	                  return addRootFolder(root_folder);
	                } },
	              'add'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return FieldsSelector;
	}(_react.Component);
	
	FieldsSelector.defaultProps = {
	  hasAppFolder: false
	};
	
	FieldsSelector.propTypes = {
	  connectionId: _propTypes2.default.number.isRequired,
	  description_max_words: _propTypes2.default.number.isRequired,
	  date_format: _propTypes2.default.string.isRequired,
	  editableSection: _propTypes2.default.string.isRequired,
	  root_folder: _propTypes2.default.string.isRequired,
	  addField: _propTypes2.default.func.isRequired,
	  addRootFolder: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  hasAppFolder: _propTypes2.default.bool
	};
	
	exports.default = FieldsSelector;

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _filenameTemplateFields = __webpack_require__(169);
	
	var _filenameTemplateFields2 = _interopRequireDefault(_filenameTemplateFields);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileFormatConfiguration = function FileFormatConfiguration(_ref) {
	  var filenameTemplate = _ref.filenameTemplate,
	      removeField = _ref.removeField,
	      edit = _ref.edit,
	      editable = _ref.editable,
	      save = _ref.save,
	      clear = _ref.clear;
	  var selectedFileFormatFields = filenameTemplate.selectedFileFormatFields;
	
	
	  var fieldPreviews = selectedFileFormatFields.map(function (field, idx) {
	    var foundField = _lodash2.default.find(_filenameTemplateFields2.default, { name: field });
	    return _react2.default.createElement(
	      'span',
	      { key: 'pf2-' + field + '-' + idx, className: 'preview-field' },
	      foundField && foundField.preview ? foundField.preview(filenameTemplate) : field
	    );
	  });
	
	  var preview = fieldPreviews.length > 0 ? fieldPreviews.concat(_react2.default.createElement(
	    'span',
	    { className: 'preview-field' },
	    '.pdf'
	  )) : fieldPreviews;
	
	  var hiddenCls = editable ? '' : 'hidden';
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'configuration-box file-format-configuration' },
	    _react2.default.createElement(
	      'div',
	      { className: 'right-panel-element' },
	      _react2.default.createElement(
	        'div',
	        { className: 'label' },
	        'File Format Configuration',
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { bsSize: 'xsmall', bsStyle: 'success', className: 'edit-btn', onClick: edit },
	          'Edit'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'field-container ' + hiddenCls },
	        _react2.default.createElement(
	          'div',
	          { className: 'fields' },
	          selectedFileFormatFields.map(function (field, idx) {
	            return _react2.default.createElement(
	              'div',
	              { key: 'selectedf-' + field + '-' + idx,
	                className: 'field selected-field',
	                onClick: function onClick() {
	                  return removeField(idx);
	                } },
	              _react2.default.createElement(
	                'div',
	                null,
	                field === ' ' ? '[space]' : field
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'close-marker' },
	                'X'
	              )
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'action-buttons ' + hiddenCls },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { bsSize: 'small', bsStyle: 'warning', className: 'clear-btn', onClick: clear },
	            'Clear'
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { bsSize: 'small', bsStyle: 'primary', className: 'save-btn', onClick: save },
	            'Save'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'preview-panel ' + hiddenCls },
	        _react2.default.createElement(
	          'div',
	          { className: 'label' },
	          'File Format Preview'
	        ),
	        preview
	      )
	    )
	  );
	};
	
	FileFormatConfiguration.defaultProps = {
	  editable: false
	};
	
	FileFormatConfiguration.propTypes = {
	  filenameTemplate: _propTypes2.default.object.isRequired,
	  editable: _propTypes2.default.bool,
	  removeField: _propTypes2.default.func.isRequired,
	  save: _propTypes2.default.func.isRequired,
	  edit: _propTypes2.default.func.isRequired,
	  clear: _propTypes2.default.func.isRequired
	};
	
	exports.default = FileFormatConfiguration;

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _filenameTemplateFields = __webpack_require__(169);
	
	var _filenameTemplateFields2 = _interopRequireDefault(_filenameTemplateFields);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FolderPathConfiguration = function FolderPathConfiguration(_ref) {
	  var filenameTemplate = _ref.filenameTemplate,
	      addRootFolder = _ref.addRootFolder,
	      removeField = _ref.removeField,
	      edit = _ref.edit,
	      editable = _ref.editable,
	      save = _ref.save,
	      clear = _ref.clear;
	  var selectedFolderPathFields = filenameTemplate.selectedFolderPathFields,
	      root_folder = filenameTemplate.root_folder;
	
	
	  var fieldPreviews = selectedFolderPathFields.map(function (field, idx) {
	    var foundField = _lodash2.default.find(_filenameTemplateFields2.default, { name: field });
	    return _react2.default.createElement(
	      'span',
	      { key: 'pf2-' + field + '-' + idx, className: 'preview-field' },
	      foundField.preview(filenameTemplate)
	    );
	  });
	
	  var preview = [_react2.default.createElement(
	    'span',
	    { key: 'pf2-prefix', className: 'preview-field' },
	    root_folder,
	    ' / '
	  )].concat(fieldPreviews);
	
	  var hiddenCls = editable ? '' : 'hidden';
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'configuration-box folder-path-configuration' },
	    _react2.default.createElement(
	      'div',
	      { className: 'right-panel-element' },
	      _react2.default.createElement(
	        'div',
	        { className: 'label' },
	        'Folder Path Configuration',
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { bsSize: 'xsmall', bsStyle: 'success', className: 'edit-btn', onClick: edit },
	          'Edit'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'field-container ' + hiddenCls },
	        _react2.default.createElement(
	          'div',
	          { className: 'fields' },
	          !_lodash2.default.isEmpty(root_folder) && _react2.default.createElement(
	            'div',
	            { className: 'field selected-field',
	              onClick: function onClick() {
	                addRootFolder({ target: { value: '' } });
	              } },
	            _react2.default.createElement(
	              'div',
	              null,
	              'Root Folder: ',
	              root_folder[root_folder.length - 1] === '/' ? root_folder : root_folder + ' /'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'close-marker' },
	              'X'
	            )
	          ),
	          selectedFolderPathFields.map(function (field, idx) {
	            return _react2.default.createElement(
	              'div',
	              { key: 'selectedf-' + field + '-' + idx,
	                className: 'field selected-field',
	                onClick: function onClick() {
	                  return removeField(idx);
	                } },
	              _react2.default.createElement(
	                'div',
	                null,
	                field === ' ' ? '[space]' : field
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'close-marker' },
	                'X'
	              )
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'action-buttons ' + hiddenCls },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { bsSize: 'small', bsStyle: 'warning', className: 'clear-btn', onClick: clear },
	            'Clear'
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { bsSize: 'small', bsStyle: 'primary', className: 'save-btn', onClick: save },
	            'Save'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'preview-panel ' + hiddenCls },
	        _react2.default.createElement(
	          'div',
	          { className: 'label' },
	          'Folder Path Preview'
	        ),
	        preview
	      )
	    )
	  );
	};
	
	FolderPathConfiguration.defaultProps = {
	  editable: false
	};
	
	FolderPathConfiguration.propTypes = {
	  filenameTemplate: _propTypes2.default.object.isRequired,
	  editable: _propTypes2.default.bool,
	  clear: _propTypes2.default.func.isRequired,
	  addRootFolder: _propTypes2.default.func.isRequired,
	  removeField: _propTypes2.default.func.isRequired,
	  edit: _propTypes2.default.func.isRequired,
	  save: _propTypes2.default.func.isRequired
	};
	
	exports.default = FolderPathConfiguration;

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _integrationsConnectionActions = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PricingAgreement = function (_Component) {
	  _inherits(PricingAgreement, _Component);
	
	  function PricingAgreement() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PricingAgreement);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.agreeToPricing = function () {
	      _this.props.dispatch({
	        type: _integrationsConnectionActions.actionTypes.UPDATE_PRICING,
	        agreedToPricing: true
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  PricingAgreement.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'kloudless-description-text' },
	      _react2.default.createElement(
	        'p',
	        null,
	        'PRICING: included in your Pro subscription is up to 250 PDF syncs every month to your desired service. Any PDF synced above the 250 limit incurs an overage charge of $0.25 per PDF. For larger volumes, please inquire about our discount pricing.'
	      ),
	      this.props.showAgreeLink && _react2.default.createElement(
	        'div',
	        { className: 'agree-btn' },
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { bsSize: 'small', bsStyle: 'success', className: 'agree-btn', onClick: this.agreeToPricing },
	          'I agree, let me continue'
	        )
	      )
	    );
	  };
	
	  return PricingAgreement;
	}(_react.Component);
	
	PricingAgreement.defaultProps = {
	  showAgreeLink: false
	};
	
	PricingAgreement.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  showAgreeLink: _propTypes2.default.bool
	};
	
	exports.default = PricingAgreement;

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _filenameTemplateFields = __webpack_require__(169);
	
	var _filenameTemplateFields2 = _interopRequireDefault(_filenameTemplateFields);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SavedFormatPreview = function SavedFormatPreview(_ref) {
	  var filenameTemplate = _ref.filenameTemplate;
	
	
	  var folderPath = filenameTemplate.savedRootFolder + '/' + filenameTemplate.savedFolderPathFields.map(function (field) {
	    var foundField = _lodash2.default.find(_filenameTemplateFields2.default, { name: field });
	    return foundField && foundField.preview ? foundField.preview(filenameTemplate) : field;
	  }).join('');
	
	  var folderPathwIcons = _lodash2.default.filter(folderPath.split('/')) // split into components, filtering out any empty ones
	  .map(function (component) {
	    return _react2.default.createElement(
	      'span',
	      null,
	      _react2.default.createElement('i', { className: 'fa fa-folder', style: { color: 'orange' } }),
	      '\xA0',
	      component
	    );
	  });
	
	  // Render Sample Filename
	  var fileName = filenameTemplate.savedFileFormatFields.map(function (field) {
	    var foundField = _lodash2.default.find(_filenameTemplateFields2.default, { name: field });
	    return foundField && foundField.preview ? foundField.preview(filenameTemplate) : field;
	  }).join('') + '.pdf';
	
	  var fileNamewIcon = _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement('i', { className: 'fa fa-file', style: { color: '#04547B' } }),
	    '\xA0',
	    fileName
	  );
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'preview-template-container' },
	    _react2.default.createElement(
	      'div',
	      { className: 'label' },
	      'File Format Currently In Use'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'preview-template' },
	      _lodash2.default.reduceRight(folderPathwIcons.concat(fileNamewIcon), function (item, acc) {
	        return _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            acc,
	            item
	          )
	        );
	      }, [])
	    )
	  );
	};
	
	SavedFormatPreview.propTypes = {
	  filenameTemplate: _propTypes2.default.object.isRequired
	};
	
	exports.default = SavedFormatPreview;

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var _gdrive;
	
	  return _hello2.default
	  // install Google Drive driver
	  .init({
	    gdrive: (_gdrive = {
	      name: 'Google Drive',
	
	      base: 'https://accounts.google.com/o/oauth2/v2/',
	
	      oauth: {
	        version: 2,
	        auth: 'https://accounts.google.com/o/oauth2/v2/auth',
	        grant: 'https://www.googleapis.com/oauth2/v4/token',
	        response_type: 'code'
	      },
	
	      login: function login(p) {
	        // sets popup size to fit NetDocuments login screen
	        p.options.popup.width = 950;
	        p.options.popup.height = 600;
	      },
	
	
	      scope: {
	        appdata: 'https://www.googleapis.com/auth/drive.appdata',
	        files: 'https://www.googleapis.com/auth/drive.file',
	        // 'drive' is read/write to all files in your google drive
	        // to use a pre-existing folder for upload, we need to allow access to all files, even those not
	        // created with google drive.
	        drive: 'https://www.googleapis.com/auth/drive'
	      },
	
	      scope_delim: ' '
	
	    }, _gdrive['login'] = function login(p) {
	      // set access_type to 'offline' so that we get a refresh token
	      p.qs.access_type = 'offline';
	
	      // The default here is 'select_account', but if that is used, we wont always get a refresh token.
	      p.qs.prompt = 'consent';
	
	      // Reauthenticate
	      if (p.options.force) p.qs.approval_prompt = 'force';
	    }, _gdrive)
	  })
	  // Initialize Driver instance
	  // TODO: can we stick some of this configuration up above?
	  .init({ gdrive: window.Drupal.settings.INTEGRATIONS_GDRIVE_APP_ID }, {
	    redirect_uri: 'https://app.courtdrive.com/rpc/static/hello.js/redirect.html',
	    oauth_proxy: window.location.origin + '/rpc/integrations/oauth_proxy'
	  })('gdrive'); // spawn an instance of the driver that one can call .login() on
	};
	
	var _hello = __webpack_require__(112);
	
	var _hello2 = _interopRequireDefault(_hello);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(129);
	
	var _integrationsConnectionActions = __webpack_require__(46);
	
	var _gdrive = __webpack_require__(959);
	
	var _gdrive2 = _interopRequireDefault(_gdrive);
	
	var _GoogleDriveAuthenticator = __webpack_require__(590);
	
	var _GoogleDriveAuthenticator2 = _interopRequireDefault(_GoogleDriveAuthenticator);
	
	var _Notification = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GoogleDriveSwitch = function (_Component) {
	  _inherits(GoogleDriveSwitch, _Component);
	
	  function GoogleDriveSwitch() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GoogleDriveSwitch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      loading: false
	    }, _this.onClick = function () {
	      var connectionId = _this.props.connectionId;
	
	
	      if (connectionId === null) {
	        _this.setState({ loading: true });
	        (0, _GoogleDriveAuthenticator2.default)().login({
	          scope: 'appdata files drive',
	          state: { redirect_host: window.location.host }
	        }).then(function (_ref) {
	          var authResponse = _ref.authResponse;
	
	          _this.props.dispatch((0, _integrationsConnectionActions.connectIntegration)('files', 'gdrive', authResponse));
	          _this.setState({ loading: false });
	        }, function (res) {
	          var _res$error = res.error,
	              code = _res$error.code,
	              message = _res$error.message;
	
	          _this.setState({ loading: false });
	          _Notification.notify.error('Error connecting to Google Drive: [' + code + '] ' + (message || ''));
	        });
	      } else {
	        _this.props.dispatch((0, _integrationsConnectionActions.disconnectIntegration)(connectionId));
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  GoogleDriveSwitch.prototype.render = function render() {
	    var _props = this.props,
	        connectionId = _props.connectionId,
	        agreedToPricing = _props.agreedToPricing;
	
	    var iconCls = 'kloudless-switch ' + (connectionId ? 'on' : '') + ' ' + (agreedToPricing ? '' : 'hidden');
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'kloudless-control-holder2' },
	      _react2.default.createElement('img', { className: 'kloudless-connection-icon',
	        src: _gdrive2.default,
	        alt: 'Google Drive Logo'
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: iconCls, onClick: this.onClick },
	        this.state.loading && _react2.default.createElement('i', {
	          className: "fa fa-circle-o-notch fa-spin",
	          style: { marginTop: '10px', marginLeft: '11px', fontSize: '11px' }
	
	        })
	      )
	    );
	  };
	
	  return GoogleDriveSwitch;
	}(_react.Component);
	
	GoogleDriveSwitch.defaultProps = {
	  connectionId: null
	};
	GoogleDriveSwitch.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  connectionId: _propTypes2.default.number,
	  agreedToPricing: _propTypes2.default.bool.isRequired
	};
	exports.default = GoogleDriveSwitch;

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _integrationsConnectionActions = __webpack_require__(46);
	
	var _imanage = __webpack_require__(2223);
	
	var _imanage2 = _interopRequireDefault(_imanage);
	
	var _iManageAuthenticator = __webpack_require__(605);
	
	var _iManageAuthenticator2 = _interopRequireDefault(_iManageAuthenticator);
	
	var _reactBootstrap = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IManageSwitch = function (_Component) {
	  _inherits(IManageSwitch, _Component);
	
	  function IManageSwitch() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, IManageSwitch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      loading: false,
	      showServerDialog: false,
	      serverName: null
	    }, _this.onClick = function () {
	      var connectionId = _this.props.connectionId;
	
	
	      if (connectionId === null) {
	        _this.showServerDialog();
	        return;
	      } else {
	        return _this.props.dispatch((0, _integrationsConnectionActions.disconnectIntegration)(connectionId));
	      }
	    }, _this.hideServerDialog = function () {
	      _this.setState({ showServerDialog: false });
	    }, _this.showServerDialog = function () {
	      _this.setState({ showServerDialog: true });
	    }, _this.handleServerNameChange = function (event) {
	      _this.setState({ serverName: event.target.value });
	    }, _this.connectToIManage = function () {
	      _this.setState({ showServerDialog: false, loading: true });
	
	      var serverName = _this.state.serverName;
	
	      // TODO - we should put the server name into the OAuth state
	
	      (0, _iManageAuthenticator2.default)(serverName).login('imanage', {
	        scope: 'user',
	        state: { redirect_host: window.location.host, serverName: serverName }
	      }).then(function (_ref) {
	        var authResponse = _ref.authResponse;
	
	        _this.props.dispatch((0, _integrationsConnectionActions.connectIntegration)('files', 'imanage', authResponse));
	
	        _this.setState({ loading: false });
	      }, function (res) {
	        var _res$error = res.error,
	            code = _res$error.code,
	            message = _res$error.message;
	
	
	        _this.setState({ loading: false });
	
	        notify.error('Error connecting to iManage: [' + code + '] ' + (message || ''));
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  IManageSwitch.prototype.render = function render() {
	    var _props = this.props,
	        connectionId = _props.connectionId,
	        agreedToPricing = _props.agreedToPricing;
	
	    var iconCls = 'kloudless-switch ' + (connectionId ? 'on' : '') + ' ' + (agreedToPricing ? '' : 'hidden');
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'kloudless-control-holder2' },
	      _react2.default.createElement('img', { className: 'kloudless-connection-icon',
	        src: _imanage2.default,
	        alt: 'iManage Logo'
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: iconCls, onClick: this.onClick },
	        this.state.loading && _react2.default.createElement('i', {
	          className: "fa fa-circle-o-notch fa-spin",
	          style: { marginTop: '10px', marginLeft: '11px', fontSize: '11px' }
	        })
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Modal,
	        { show: this.state.showServerDialog, onHide: this.hideServerDialog },
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Header,
	          { closeButton: true },
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Title,
	            null,
	            'iManage Server Settings'
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Form,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.FormGroup,
	              { controlId: 'formIManageServer' },
	              _react2.default.createElement(
	                _reactBootstrap.ControlLabel,
	                null,
	                'Enter your iManage Server Name'
	              ),
	              _react2.default.createElement(_reactBootstrap.FormControl, {
	                type: 'text',
	                value: this.state.serverName,
	                placeholder: 'imanage.yourfirm.com',
	                onChange: this.handleServerNameChange,
	                style: { width: '100%', boxSizing: 'border-box' }
	              }),
	              _react2.default.createElement(_reactBootstrap.FormControl.Feedback, null)
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { bsStyle: 'primary', onClick: this.connectToIManage, disabled: !this.state.serverName },
	            'Connect To iManage'
	          )
	        )
	      )
	    );
	  };
	
	  return IManageSwitch;
	}(_react.Component);
	
	IManageSwitch.defaultProps = {
	  connectionId: null
	};
	IManageSwitch.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  connectionId: _propTypes2.default.number,
	  agreedToPricing: _propTypes2.default.bool.isRequired
	};
	exports.default = IManageSwitch;

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    { className: "text-description" },
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        "b",
	        null,
	        "How it works"
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "1.) Toggle ON the desired service and go through all the wizard to complete the integration. Syncing will begin 15 minutes thereafter using the default folder and file format structure shown below."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "2.)  If desired, select a custom folder and/or file format configuration using the configuration wizard below."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        "b",
	        null,
	        "Important Facts on Integrations"
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "1.) After any sync has been made, if you rename, delete or move a folder on the selected service, OR if you change your default configuration after a sync, we will create a new folder and continue syncing according to the template you set below."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "2.) If you change your default configurations later, you can choose to re-sync at any time by clicking the re-sync button.  But you will be responsible for overages that result if you sync over 250 PDFs in any given month."
	    )
	  );
	};

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _finalForm = __webpack_require__(124);
	
	var _Notification = __webpack_require__(24);
	
	var _NetDocumentsCabinetProfileConfigAttributeForm = __webpack_require__(595);
	
	var _NetDocumentsCabinetProfileConfigAttributeForm2 = _interopRequireDefault(_NetDocumentsCabinetProfileConfigAttributeForm);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NetDocumentsCabinetProfileConfig = function (_Component) {
	  _inherits(NetDocumentsCabinetProfileConfig, _Component);
	
	  function NetDocumentsCabinetProfileConfig() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, NetDocumentsCabinetProfileConfig);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.initialState = {
	      isLoading: true,
	      error: null,
	      attributes: [],
	      profile: null
	    }, _this.state = _extends({}, _this.initialState), _this.onSave = function (_ref) {
	      var attributes = _ref.attributes;
	
	      console.log('Saving ', attributes);
	      var profile = attributes.map(function (_ref2) {
	        var id = _ref2.id,
	            value = _ref2.value;
	        return { id: id, value: value };
	      }).filter(function (_ref3) {
	        var value = _ref3.value;
	        return value;
	      });
	      return _superagent2.default.post('/rpc/integrations/connections/' + _this.props.connectionId + '/cabinets/' + _this.props.cabinet.id + '/profile').send({
	        name: _this.props.cabinet.name,
	        profile: profile
	      }).then(function (res) {
	        console.log('Saved! Result:', res);
	        _Notification.notify.success('Cabinet Profile Saved');
	        _this.setState({ profile: res.body.profile });
	      }, function (errRes) {
	        var _ref4;
	
	        console.log('Error Saving!', errRes);
	        return _ref4 = {}, _ref4[_finalForm.FORM_ERROR] = 'Error Saving', _ref4;
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  NetDocumentsCabinetProfileConfig.prototype.componentDidMount = function componentDidMount() {
	    this.fetchAttributesAndProfileConfig();
	  };
	
	  NetDocumentsCabinetProfileConfig.prototype.fetchAttributesAndProfileConfig = function fetchAttributesAndProfileConfig(refreshFromNetdocs) {
	    var _this2 = this;
	
	    this.setState(this.initialState);
	
	    console.log('Requesting attribute list and profile settings for ' + this.props.cabinet.id);
	    Promise.all([
	    // Attributes
	    _superagent2.default.get('/rpc/integrations/connections/' + this.props.connectionId + '/cabinets/' + this.props.cabinet.id + '/attributes').query({ refresh: refreshFromNetdocs }).then(function (res) {
	      return _this2.setState({ attributes: res.body.attributes });
	    }),
	    // Profile Config
	    _superagent2.default.get('/rpc/integrations/connections/' + this.props.connectionId + '/cabinets/' + this.props.cabinet.id + '/profile').then(function (res) {
	      return _this2.setState({ profile: res.body.profile });
	    }).catch(function (err) {
	      console.log('Catching error refreshing profile', err);
	      // make sure error is not in fetching, but just that cabinet profile hasn't been configured yet
	      if (!_lodash2.default.get(err, 'response.body.error', '').startsWith('No cabinet profile found for cabinet')) {
	        throw new Error(err);
	      }
	    })]).then(function (res) {
	      return _this2.setState({ isLoading: false });
	    }, function (errRes) {
	      console.error('There was some error refreshing cabinet attributes and profile', errRes);
	      _this2.setState({
	        isLoading: false,
	        error: errRes
	      });
	    });
	    return true;
	  };
	
	  NetDocumentsCabinetProfileConfig.prototype.render = function render() {
	    var _this3 = this;
	
	    var cabinet = this.props.cabinet;
	
	
	    var configurableAttrs = configurableAttributes(cabinet, this.state.attributes, this.state.profile);
	
	    return _react2.default.createElement(
	      _reactBootstrap.Panel,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Panel.Heading,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Panel.Title,
	          { componentClass: 'h3' },
	          _react2.default.createElement('i', { className: 'fa fa-archive' }),
	          ' ',
	          cabinet.name,
	          ' (',
	          cabinet.id,
	          ')'
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Panel.Body,
	        null,
	        function () {
	          if (_this3.state.error) return _react2.default.createElement(
	            _reactBootstrap.Alert,
	            { bsStyle: 'danger' },
	            'There was an error loading Cabinet Information. If the problem persists, please quote the following when contacting CourtDrive support:',
	            _react2.default.createElement(
	              'pre',
	              null,
	              _this3.state.error
	            )
	          );
	
	          if (_this3.state.isLoading) return _react2.default.createElement(_reactBootstrap.ProgressBar, { active: true, now: 100 });
	
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Alert,
	              { bsStyle: 'info' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                organizingAttributes(cabinet, _this3.state.attributes).map(function (attr) {
	                  return attr.name;
	                }).join(" > ")
	              ),
	              ' ',
	              'needs to be assigned to each CaseFolder that should be synced. Attributes below will be applied to each uploaded file.'
	            ),
	            _react2.default.createElement(_NetDocumentsCabinetProfileConfigAttributeForm2.default, {
	              connectionId: _this3.props.connectionId,
	              cabinet: cabinet,
	              attributes: configurableAttrs,
	              cabinetAttributes: _this3.state.attributes,
	              onSave: _this3.onSave
	            })
	          );
	        }()
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Panel.Footer,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { bsStyle: 'link', bsSize: 'xsmall', onClick: function onClick() {
	              return _this3.fetchAttributesAndProfileConfig(true);
	            } },
	          'Refresh Attributes'
	        )
	      )
	    );
	  };
	
	  return NetDocumentsCabinetProfileConfig;
	}(_react.Component);
	
	NetDocumentsCabinetProfileConfig.propTypes = {
	  connectionId: _propTypes2.default.number.isRequired,
	  cabinet: _propTypes2.default.object.isRequired
	};
	
	
	function organizingAttributes(cabinet, attributes) {
	  if (!cabinet.wsAttrNum) {
	    console.log('Cabinet is not organized in a workspace');
	    return [];
	  }
	  var attributesById = _lodash2.default.keyBy(attributes, function (attr) {
	    return attr.id;
	  });
	
	  var organizingAttribute = attributesById[cabinet.wsAttrNum];
	
	  if (!organizingAttribute) {
	    console.log('Can not find organizing attribute - no attribute with id \'' + cabinet.wsAttrNum + '\' found in', attributes);
	    return [];
	  }
	
	  var attributeList = [organizingAttribute];
	  var attr = organizingAttribute;
	  while (attr.linked) {
	    attr = attributesById[attr.linked];
	    attributeList.unshift(attr);
	  }
	
	  return attributeList;
	}
	
	function configurableAttributes(cabinet, attributes, profile) {
	  var attributeIdsToExclude = _lodash2.default.map(organizingAttributes(cabinet, attributes), function (attr) {
	    return attr.id;
	  });
	  var attributeValuesById = _lodash2.default.mapValues(_lodash2.default.keyBy(profile, 'id'), 'value');
	  return attributes
	  // organizing attributes are not globally configurable
	  .filter(function (attr) {
	    return !attributeIdsToExclude.includes(attr.id);
	  })
	  // merge any configured profile fields values
	  .map(function (attr) {
	    return _extends({}, attr, { value: attributeValuesById[attr.id] });
	  });
	}
	
	exports.default = NetDocumentsCabinetProfileConfig;

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactFinalFormHtml5Validation = __webpack_require__(511);
	
	var _reactFinalFormArrays = __webpack_require__(322);
	
	var _finalFormArrays = __webpack_require__(189);
	
	var _finalFormArrays2 = _interopRequireDefault(_finalFormArrays);
	
	var _AttributeSelector = __webpack_require__(347);
	
	var _AttributeSelector2 = _interopRequireDefault(_AttributeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NetDocumentsCabinetProfileConfigAttributeForm = function (_Component) {
	  _inherits(NetDocumentsCabinetProfileConfigAttributeForm, _Component);
	
	  function NetDocumentsCabinetProfileConfigAttributeForm() {
	    _classCallCheck(this, NetDocumentsCabinetProfileConfigAttributeForm);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  NetDocumentsCabinetProfileConfigAttributeForm.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(_reactFinalForm.Form, {
	      initialValues: { attributes: this.props.attributes },
	      onSubmit: this.props.onSave,
	      mutators: _extends({}, _finalFormArrays2.default),
	      render: function render(_ref) {
	        var handleSubmit = _ref.handleSubmit,
	            pristine = _ref.pristine,
	            form = _ref.form,
	            submitting = _ref.submitting,
	            reset = _ref.reset,
	            values = _ref.values,
	            submitError = _ref.submitError,
	            hasValidationErrors = _ref.hasValidationErrors;
	
	        return _react2.default.createElement(
	          _reactBootstrap.Form,
	          { horizontal: true, style: { padding: "8px 42px 8px 16px" }, onSubmit: handleSubmit },
	          _react2.default.createElement(
	            _reactFinalFormArrays.FieldArray,
	            { name: 'attributes' },
	            function (_ref2) {
	              var fields = _ref2.fields;
	              return fields.map(function (name, index) {
	                return renderAttributeEditInput(form, values, _this2.props.attributes, name, index, _this2.props.cabinet, _this2.props.connectionId, _this2.props.cabinetAttributes);
	              });
	            }
	          ),
	          submitError && _react2.default.createElement(
	            _reactBootstrap.Alert,
	            { bsStyle: 'danger' },
	            submitError
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.FormGroup,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { type: 'submit', bsStyle: 'primary',
	                title: hasValidationErrors ? "Can't save while form contains invalid values" : undefined,
	                disabled: submitting || pristine || hasValidationErrors },
	              _react2.default.createElement('i', { className: 'fa ' + (submitting ? 'fa-spinner fa-spin' : 'fa-gavel') }),
	              ' ',
	              ' Save'
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'link',
	                onClick: function onClick() {
	                  if (pristine || confirm("You will lose unsaved changes")) reset();return false;
	                },
	                disabled: submitting || pristine },
	              'Reset'
	            )
	          ),
	          hasValidationErrors && _react2.default.createElement(
	            _reactBootstrap.Alert,
	            { bsStyle: 'danger' },
	            'Please correct any errors above before saving.'
	          )
	        );
	      } });
	  };
	
	  return NetDocumentsCabinetProfileConfigAttributeForm;
	}(_react.Component);
	
	// Net Document Profile Field types: https://support.netdocuments.com/hc/en-us/articles/205220550
	
	NetDocumentsCabinetProfileConfigAttributeForm.propTypes = {
	  connectionId: _propTypes2.default.number.isRequired,
	  cabinet: _propTypes2.default.object.isRequired,
	  attributes: _propTypes2.default.array.isRequired,
	  onSave: _propTypes2.default.func.isRequired,
	  cabinetAttributes: _propTypes2.default.array.isRequired
	};
	function renderAttributeEditInput(form, values, attributes, name, index, cabinet, connectionId, cabinetAttributes) {
	  var parentAttribute = attributes[index].linked && _lodash2.default.find(cabinetAttributes, { id: attributes[index].linked });
	  var isRequired = cabinet.wsOrgAttrNum == attributes[index].id;
	  var hasError = _lodash2.default.get(form.getState(), 'errors.attributes[' + index + ']');
	
	  return _react2.default.createElement(
	    _reactBootstrap.FormGroup,
	    { validationState: hasError && 'error' },
	    _react2.default.createElement(
	      _reactBootstrap.ControlLabel,
	      null,
	      attributes[index].name,
	      _react2.default.createElement(
	        'sup',
	        null,
	        ' ',
	        _react2.default.createElement(
	          _reactBootstrap.Label,
	          null,
	          'Type: ',
	          attributes[index].type
	        )
	      ),
	      _react2.default.createElement(
	        'sup',
	        null,
	        ' ',
	        _react2.default.createElement(
	          _reactBootstrap.Label,
	          null,
	          'Max Len: ',
	          attributes[index].maxLen
	        )
	      ),
	      attributes[index].useLookup && _react2.default.createElement(
	        'sup',
	        null,
	        ' ',
	        _react2.default.createElement(
	          _reactBootstrap.Label,
	          null,
	          _react2.default.createElement('i', { className: 'fa fa-binoculars' }),
	          ' Lookup'
	        )
	      ),
	      attributes[index].linked && _react2.default.createElement(
	        'sup',
	        null,
	        ' ',
	        _react2.default.createElement(
	          _reactBootstrap.Label,
	          { title: 'This attribute values are dependant on values selected in another attribute' },
	          _react2.default.createElement('i', { className: 'fa fa-link' }),
	          ' Linked'
	        )
	      ),
	      isRequired && _react2.default.createElement(
	        'sup',
	        null,
	        ' ',
	        _react2.default.createElement(
	          _reactBootstrap.Label,
	          { bsStyle: hasError ? 'danger' : 'success' },
	          'Required'
	        )
	      )
	    ),
	    attributes[index].useLookup && !attributes[index].linked ? _react2.default.createElement(
	      _reactFinalFormHtml5Validation.Field,
	      { name: name + '.value', validate: function validate(val) {
	          return isRequired && !val ? 'Required' : undefined;
	        } },
	      function (_ref3) {
	        var input = _ref3.input;
	        return _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _react2.default.createElement(_AttributeSelector2.default, {
	            attribute: attributes[index],
	            connectionId: connectionId,
	            cabinet: cabinet,
	            initialValue: values.attributes[index].value,
	            input: input,
	            showPerCaseOption: isRequired
	          })
	        );
	      }
	    ) : attributes[index].linked ? _react2.default.createElement(
	      _reactBootstrap.Alert,
	      { bsStyle: 'warning' },
	      'Configuring this attribute is not currently supported as it depends on ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        _lodash2.default.get(parentAttribute, 'name', 'Attribute <ID:' + attributes[index].linked + '>')
	      ),
	      ' selection.'
	    ) : _react2.default.createElement(
	      _reactBootstrap.InputGroup,
	      null,
	      _react2.default.createElement(_reactFinalFormHtml5Validation.Field, { name: name + '.value', component: 'input', type: 'input', className: 'form-control',
	        required: isRequired
	      }),
	      _react2.default.createElement(TemplateMenu, {
	        onSelect: function onSelect(templateVal) {
	          return form.change(name + '.value', (values.attributes[index].value || '') + templateVal);
	        }
	      })
	    )
	  );
	}
	
	function TemplateMenu(props) {
	  var fieldsToOffer = netdocs_fields;
	
	  var previousFieldType = fieldsToOffer[0].type; // remember so we can draw divider in the menu
	
	  return _react2.default.createElement(
	    _reactBootstrap.DropdownButton,
	    {
	      componentClass: _reactBootstrap.InputGroup.Button,
	      bsStyle: 'default',
	      title: '+',
	      noCaret: true
	    },
	    fieldsToOffer.map(function (field) {
	      return [previousFieldType !== field.type && (previousFieldType = field.type) && _react2.default.createElement(_reactBootstrap.MenuItem, { divider: true }), // <MenuItem header>{ field.type }</MenuItem>,
	      _react2.default.createElement(
	        _reactBootstrap.MenuItem,
	        { onSelect: function onSelect() {
	            return props.onSelect(fieldToInput(field));
	          }, style: { width: '316px' } },
	        field.value,
	        _react2.default.createElement(
	          'small',
	          { style: { float: 'right' } },
	          _react2.default.createElement(
	            _reactBootstrap.Label,
	            null,
	            fieldToInput(field)
	          )
	        ),
	        _react2.default.createElement('div', { style: { clear: 'both' } })
	      )];
	    })
	  );
	}
	
	function fieldToInput(field) {
	  return field.type === 'separator' ? field.name : '{{' + field.name + '}}';
	}
	
	var netdocs_fields = [{
	  type: 'document',
	  name: 'document_date',
	  value: 'Document Filed Date'
	}, {
	  type: 'document',
	  name: 'part_description',
	  value: 'Part Description'
	}, {
	  type: 'document',
	  name: 'docket_number',
	  value: 'Document Entry Number'
	}, {
	  type: 'document',
	  name: 'docket_text',
	  value: 'Docket Text'
	}, {
	  type: 'case',
	  name: 'case_title',
	  value: 'Case Title'
	}, {
	  type: 'case',
	  name: 'case_date',
	  value: 'Case Date'
	}, {
	  type: 'case',
	  name: 'case_number',
	  value: 'Case Number'
	}, {
	  type: 'court',
	  name: 'court_code',
	  value: 'Court Code'
	}, {
	  type: 'court',
	  name: 'court_name',
	  value: 'Court Name'
	}, {
	  type: 'court',
	  name: 'court_citation',
	  value: 'Court Citation'
	}, {
	  type: 'judge',
	  name: 'judge_name',
	  value: 'Judge Name'
	}, {
	  type: 'separator',
	  name: '-',
	  value: '-'
	}, {
	  type: 'separator',
	  name: '(',
	  value: '('
	}, {
	  type: 'separator',
	  name: ')',
	  value: ')'
	}, {
	  type: 'separator',
	  name: '.',
	  value: '.'
	}, {
	  type: 'separator',
	  name: '/',
	  value: '/'
	}, {
	  type: 'separator',
	  name: '_',
	  value: '_'
	}, {
	  type: 'separator',
	  name: ' ',
	  value: '[space]'
	}];
	
	exports.default = NetDocumentsCabinetProfileConfigAttributeForm;

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _NetDocumentsCabinetProfileConfig = __webpack_require__(594);
	
	var _NetDocumentsCabinetProfileConfig2 = _interopRequireDefault(_NetDocumentsCabinetProfileConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NetDocumentsCabinetsConfig = function (_Component) {
	  _inherits(NetDocumentsCabinetsConfig, _Component);
	
	  function NetDocumentsCabinetsConfig() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, NetDocumentsCabinetsConfig);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.initialState = {
	      loading: true,
	      cabinets: []
	    }, _this.state = _extends({}, _this.initialState), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  NetDocumentsCabinetsConfig.prototype.componentDidMount = function componentDidMount() {
	    this.fetchCabinets();
	  };
	
	  NetDocumentsCabinetsConfig.prototype.fetchCabinets = function fetchCabinets(refreshFromNetdocs) {
	    var _this2 = this;
	
	    console.log('Refreshing Cabinet List for ' + this.props.connectionId);
	    this.setState(this.initialState);
	    // Fetch Cabinets
	    _superagent2.default.get('/rpc/integrations/connections/' + this.props.connectionId + '/cabinets').query({ refresh: refreshFromNetdocs }).then(function (res) {
	      _this2.setState({ loading: false, cabinets: res.body.cabinets });
	    }, function (errRes) {
	      _this2.setState({ loading: false });
	    });
	  };
	
	  NetDocumentsCabinetsConfig.prototype.render = function render() {
	    var _this3 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { style: { marginBottom: '360px' /* for attribute menus to not cause scrolling */ } },
	      _react2.default.createElement(
	        _reactBootstrap.PageHeader,
	        null,
	        'NetDocuments Cabinet Profiles'
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Alert,
	        { bsStyle: 'warning' },
	        'Your account is connected to NetDocuments. Each cabinet that should receive a copy of files needs be properly configured below. Please change these values only as directed by CourtDrive engineers. If you are experiencing issues, please contact CourtDrive Support.'
	      ),
	      this.state.loading ? _react2.default.createElement(_reactBootstrap.ProgressBar, { active: true, now: 100 }) : _react2.default.createElement(
	        _reactBootstrap.Tabs,
	        { animation: false },
	        this.state.cabinets.map(function (cabinet, index) {
	          return _react2.default.createElement(
	            _reactBootstrap.Tab,
	            { eventKey: index, title: _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement('i', { className: 'fa fa-archive' }),
	                ' ',
	                cabinet.name,
	                ' '
	              ) },
	            _react2.default.createElement(_NetDocumentsCabinetProfileConfig2.default, {
	              connectionId: _this3.props.connectionId,
	              cabinet: cabinet
	            })
	          );
	        })
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: 'link', bsSize: 'xsmall', onClick: function onClick() {
	            return _this3.fetchCabinets(true);
	          } },
	        'Refresh Cabinets'
	      )
	    );
	  };
	
	  return NetDocumentsCabinetsConfig;
	}(_react.Component);
	
	NetDocumentsCabinetsConfig.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  connectionId: _propTypes2.default.number.isRequired
	};
	exports.default = NetDocumentsCabinetsConfig;

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (_ref) {
	  var connectionId = _ref.connectionId;
	
	  var inputRef = (0, _react.useRef)(null);
	
	  var copyToClipBoard = function copyToClipBoard(button) {
	    inputRef.current.select();
	    document.execCommand("copy");
	    _Notification.notify.success('Link copied to clipboard');
	  };
	
	  var netDocsQueryParams = {
	    ndpage: '{!Current.Page.URL}',
	    ndAttrKey: '{!Workspace.Base.Attribute.Key}',
	    ndBaseKey: '{!Workspace.Parent.Attribute.Key}',
	    ndUserId: '{!Current.User.GUID}',
	    ndUserEmail: '{!Current.User.Email.Address}',
	    ndUserName: '{!Current.User.Name}'
	  };
	
	  // NOTE, we don't want URL escaping here since these values are special to netdocs UI.
	  // so do not e.g. use URLSearchParams
	  var queryString = _lodash2.default.toPairs(netDocsQueryParams).map(function (item) {
	    return item.join('=');
	  }).join('&');
	
	  return _react2.default.createElement(
	    _reactBootstrap.Panel,
	    null,
	    _react2.default.createElement(
	      _reactBootstrap.Panel.Heading,
	      { componentClass: "h3" },
	      "NetDocuments Docket Display Link"
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Panel.Body,
	      null,
	      _react2.default.createElement(
	        "p",
	        null,
	        "Copy/Paste this link into any NetDocuments Workspace Overview to utilize the CourtDrive docket for this case within NetDocuments.  You can use this link in a workspace template in NetDocuments so it will apply to all newly created cases in NetDocuments."
	      ),
	      _react2.default.createElement("input", {
	        type: "text",
	        ref: inputRef,
	        value: "https://app.courtdrive.com/rpc/integrations/connections/" + connectionId + "/netdocuments/case-docket?" + queryString,
	        size: "75",
	        readonly: true
	      }),
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: "primary", onClick: copyToClipBoard },
	        "Copy"
	      )
	    )
	  );
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _Notification = __webpack_require__(24);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(129);
	
	var _integrationsConnectionActions = __webpack_require__(46);
	
	var _netdocuments = __webpack_require__(2224);
	
	var _netdocuments2 = _interopRequireDefault(_netdocuments);
	
	var _NetDocumentsAuthenticator = __webpack_require__(1080);
	
	var _NetDocumentsAuthenticator2 = _interopRequireDefault(_NetDocumentsAuthenticator);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _Notification = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NetDocumentsSwitch = function (_Component) {
	  _inherits(NetDocumentsSwitch, _Component);
	
	  function NetDocumentsSwitch() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, NetDocumentsSwitch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      loading: false,
	      showRegionDialog: false,
	      scopes: {
	        read: true,
	        edit: true,
	        organize: true,
	        delete_doc: true,
	        delete_container: false
	      }
	    }, _this.showRegionChooser = function () {
	      _this.setState({ showRegionDialog: true });
	    }, _this.hideRegionChooser = function () {
	      _this.setState({ showRegionDialog: false });
	    }, _this.onClick = function () {
	      var connectionId = _this.props.connectionId;
	
	
	      if (connectionId === null) {
	        _this.showRegionChooser();
	        return;
	      } else {
	        // disconnect from netdocuments
	        _this.props.dispatch((0, _integrationsConnectionActions.disconnectIntegration)(connectionId));
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  NetDocumentsSwitch.prototype.selectRegion = function selectRegion(selectedRegion) {
	    this.setState(selectedRegion);
	    this.connectNetDocuments();
	  };
	
	  NetDocumentsSwitch.prototype.connectNetDocuments = function connectNetDocuments(region) {
	    var _this2 = this;
	
	    this.setState({
	      loading: true,
	      showRegionDialog: false,
	      region: region
	    });
	
	    var scopes = Object.keys(this.state.scopes).filter(function (key) {
	      return _this2.state.scopes[key];
	    }).join(' ');
	
	    (0, _NetDocumentsAuthenticator2.default)(region).login({
	      scope: scopes,
	      state: {
	        redirect_host: window.location.host,
	        region: region
	      }
	    }).then(function (_ref) {
	      var authResponse = _ref.authResponse;
	
	      _this2.props.dispatch((0, _integrationsConnectionActions.connectIntegration)('files', 'netdocuments', authResponse));
	      _this2.setState({ loading: false });
	    }, function (res) {
	      var _res$error = res.error,
	          code = _res$error.code,
	          message = _res$error.message;
	
	      _this2.setState({ loading: false });
	      _Notification.notify.error('Error connecting to NetDocuments: [' + code + '] ' + (message || ''));
	    });
	  };
	
	  NetDocumentsSwitch.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        connectionId = _props.connectionId,
	        agreedToPricing = _props.agreedToPricing;
	
	    var iconCls = 'kloudless-switch ' + (connectionId ? 'on' : '') + ' ' + (agreedToPricing ? '' : 'hidden');
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'kloudless-control-holder2' },
	      _react2.default.createElement('img', { className: 'kloudless-connection-icon',
	        src: _netdocuments2.default,
	        alt: 'logo'
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: iconCls, onClick: this.onClick },
	        this.state.loading && _react2.default.createElement('i', {
	          className: "fa fa-circle-o-notch fa-spin",
	          style: { marginTop: '10px', marginLeft: '11px', fontSize: '11px' }
	
	        })
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Modal,
	        { show: this.state.showRegionDialog, onHide: this.hideRegionChooser },
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Header,
	          { closeButton: true },
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Title,
	            null,
	            'Select NetDocuments Region'
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Panel.Body,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { style: { width: '100%' }, bsStyle: 'primary', onClick: function onClick() {
	                    return _this3.connectNetDocuments('US');
	                  } },
	                'US - vault.netvoyage.com'
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { style: { width: '100%', marginTop: '1em' }, onClick: function onClick() {
	                    return _this3.connectNetDocuments('DE');
	                  } },
	                'DE - de.netdocuments.com'
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { style: { width: '100%', marginTop: '1em' }, onClick: function onClick() {
	                    return _this3.connectNetDocuments('EU');
	                  } },
	                'EU - eu.netdocuments.com'
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { style: { width: '100%', marginTop: '1em' }, onClick: function onClick() {
	                    return _this3.connectNetDocuments('AU');
	                  } },
	                'AU - eu.netdocuments.com'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return NetDocumentsSwitch;
	}(_react.Component);
	
	NetDocumentsSwitch.defaultProps = {
	  connectionId: null
	};
	NetDocumentsSwitch.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  connectionId: _propTypes2.default.number,
	  agreedToPricing: _propTypes2.default.bool.isRequired
	};
	exports.default = NetDocumentsSwitch;

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (type) {
	  return _hello2.default
	  // install microsoft driver
	  .init({
	    onedrive: {
	      name: 'OneDrive',
	
	      base: 'https://login.microsoftonline.com/',
	
	      oauth: {
	        version: 2,
	        auth: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize',
	        grant: 'https://login.microsoftonline.com/common/oauth2/v2.0/token',
	        response_type: 'code'
	      },
	
	      scope: {
	        appfiles: 'Files.ReadWrite.AppFolder',
	        files: 'Files.ReadWrite.All',
	        sites: 'Sites.Read.All',
	        groups: 'Group.Read.All',
	        offline: 'offline_access'
	      },
	
	      scope_delim: ' '
	    }
	  })
	  // Initialize Driver instance
	  .init({
	    onedrive: type === 'full' ? window.Drupal.settings.INTEGRATIONS_ONEDRIVE_FULL_APP_ID // Use full access app
	    : window.Drupal.settings.INTEGRATIONS_ONEDRIVE_APP_ID // Use AppFolder limited app
	  }, {
	    redirect_uri: 'https://app.courtdrive.com/rpc/static/hello.js/redirect.html',
	    oauth_proxy: window.location.origin + '/rpc/integrations/oauth_proxy',
	    scope: 'files offline_access',
	    prompt: 'consent'
	  })('onedrive'); // spawn an instance of the driver that one can call .login() on
	};
	
	var _hello = __webpack_require__(112);
	
	var _hello2 = _interopRequireDefault(_hello);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	__webpack_require__(129);
	
	var _integrationsConnectionActions = __webpack_require__(46);
	
	var _onedrive = __webpack_require__(960);
	
	var _onedrive2 = _interopRequireDefault(_onedrive);
	
	var _OneDriveAuthenticator = __webpack_require__(599);
	
	var _OneDriveAuthenticator2 = _interopRequireDefault(_OneDriveAuthenticator);
	
	var _Notification = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OneDriveSwitch = function (_Component) {
	  _inherits(OneDriveSwitch, _Component);
	
	  function OneDriveSwitch() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, OneDriveSwitch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      loading: false,
	      showTypeChooser: false
	    }, _this.handleShowChooser = function () {
	      _this.setState({ showTypeChooser: true });
	    }, _this.handleHideChooser = function () {
	      _this.setState({ showTypeChooser: false });
	    }, _this.connectOneDrive = function (type) {
	      _this.setState({ showTypeChooser: false, loading: true });
	
	      var fileScope = type === 'appFolder' ? 'appfiles' : 'files';
	
	      (0, _OneDriveAuthenticator2.default)(type).login({
	        scope: fileScope + ' groups sites offline',
	        state: {
	          connection_type: type,
	          redirect_host: window.location.host
	        }
	      }).then(function (_ref) {
	        var authResponse = _ref.authResponse;
	
	        _this.props.dispatch((0, _integrationsConnectionActions.connectIntegration)('files', 'onedrive', authResponse));
	        _this.setState({ loading: false });
	      }, function (res) {
	        var _res$error = res.error,
	            code = _res$error.code,
	            message = _res$error.message;
	
	        _this.setState({ loading: false });
	        _Notification.notify.error('Error connecting to One Drive: [' + code + '] ' + (message || ''));
	      });
	    }, _this.onClick = function () {
	      var connectionId = _this.props.connectionId;
	
	
	      if (connectionId === null) {
	        // Show the connection type chooser
	        _this.handleShowChooser();
	        return;
	      } else {
	        // turn off the integration
	        _this.props.dispatch((0, _integrationsConnectionActions.disconnectIntegration)(connectionId));
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  OneDriveSwitch.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        connectionId = _props.connectionId,
	        agreedToPricing = _props.agreedToPricing;
	
	    var iconCls = 'kloudless-switch ' + (connectionId ? 'on' : '') + ' ' + (agreedToPricing ? '' : 'hidden');
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'kloudless-control-holder2' },
	      _react2.default.createElement('img', { className: 'kloudless-connection-icon',
	        src: _onedrive2.default,
	        alt: 'Google Drive Logo'
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: iconCls, onClick: this.onClick },
	        this.state.loading && _react2.default.createElement('i', {
	          className: "fa fa-circle-o-notch fa-spin",
	          style: { marginTop: '10px', marginLeft: '11px', fontSize: '11px' }
	
	        })
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Modal,
	        { show: this.state.showTypeChooser, onHide: this.handleHideChooser },
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Header,
	          { closeButton: true },
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Title,
	            null,
	            'Choose OneDrive Integration Type'
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Panel.Heading,
	              null,
	              'App Folder ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'OneDrive/Apps/CourtDrive'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Panel.Body,
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Files will be uploaded to OneDrive under the folder Apps/CourtDrive.',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'CourtDrive will not be able to read or write any files outside of this folder.'
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { bsStyle: 'primary', onClick: function onClick() {
	                    return _this2.connectOneDrive('appFolder');
	                  } },
	                'Choose App Folder'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Panel.Heading,
	              null,
	              'Full Access ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'OneDrive/CourtDrive'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Panel.Body,
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Files will be uploaded to OneDrive under a folder name that you choose at the top of your OneDrive folder.',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'CourtDrive will need read and write access to your entire OneDrive for this.'
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { bsStyle: 'primary', onClick: function onClick() {
	                    return _this2.connectOneDrive('full');
	                  } },
	                'Choose Full Access'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return OneDriveSwitch;
	}(_react.Component);
	
	OneDriveSwitch.defaultProps = {
	  connectionId: null
	};
	OneDriveSwitch.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  connectionId: _propTypes2.default.number,
	  agreedToPricing: _propTypes2.default.bool.isRequired
	};
	exports.default = OneDriveSwitch;

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _integrationsConnectionActions = __webpack_require__(46);
	
	var _rocketmatter = __webpack_require__(961);
	
	var _rocketmatter2 = _interopRequireDefault(_rocketmatter);
	
	var _RocketMatterAuthenticator = __webpack_require__(1081);
	
	var _RocketMatterAuthenticator2 = _interopRequireDefault(_RocketMatterAuthenticator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RocketMatterSwitch = function (_React$Component) {
	  _inherits(RocketMatterSwitch, _React$Component);
	
	  function RocketMatterSwitch() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RocketMatterSwitch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      loading: false
	    }, _this.onClick = function () {
	      var connectionId = _this.props.connectionId;
	
	
	      if (connectionId === null) {
	        _this.setState({ loading: true });
	        // call Authenticator
	        (0, _RocketMatterAuthenticator2.default)().login({ state: { redirect_host: window.location.host } }).then(function (_ref) {
	          var authResponse = _ref.authResponse;
	
	          _this.props.dispatch((0, _integrationsConnectionActions.connectIntegration)('files', 'rocketmatter', authResponse));
	          _this.setState({ loading: false });
	        }, function (res) {
	          var _res$error = res.error,
	              code = _res$error.code,
	              message = _res$error.message;
	
	          _this.setState({ loading: false });
	          notify.error('Error connecting to RocketMatter: [' + code + '] ' + (message || ''));
	        });
	      } else {
	        _this.props.dispatch((0, _integrationsConnectionActions.disconnectIntegration)(connectionId));
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  RocketMatterSwitch.prototype.render = function render() {
	    var _props = this.props,
	        connectionId = _props.connectionId,
	        agreedToPricing = _props.agreedToPricing;
	
	    var iconCls = 'kloudless-switch ' + (connectionId ? 'on' : '') + ' ' + (agreedToPricing ? '' : 'hidden');
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'kloudless-control-holder2' },
	      _react2.default.createElement('img', { className: 'kloudless-connection-icon',
	        src: _rocketmatter2.default,
	        alt: 'Rocket Matter Logo'
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: iconCls, onClick: this.onClick },
	        this.state.loading && _react2.default.createElement('i', { className: "fa fa-circle-o-notch fa-spin",
	          style: { marginTop: '10px', marginLeft: '11px', fontSize: '11px' }
	        })
	      )
	    );
	  };
	
	  return RocketMatterSwitch;
	}(_react2.default.Component);
	
	RocketMatterSwitch.defaultProps = {
	  connectionId: null
	};
	RocketMatterSwitch.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  connectionId: _propTypes2.default.number,
	  agreedToPricing: _propTypes2.default.bool.isRequired
	};
	exports.default = RocketMatterSwitch;

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _SharepointDriveSelector = __webpack_require__(344);
	
	var _SharepointDriveSelector2 = _interopRequireDefault(_SharepointDriveSelector);
	
	var _SharepointSiteSearch = __webpack_require__(345);
	
	var _SharepointSiteSearch2 = _interopRequireDefault(_SharepointSiteSearch);
	
	var _Notification = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SharepointConnectionSettings = function (_React$Component) {
	  _inherits(SharepointConnectionSettings, _React$Component);
	
	  function SharepointConnectionSettings() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SharepointConnectionSettings);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.initialState = {
	      isLoading: true,
	      error: null,
	      selectedSite: null,
	      selectedDrive: null
	    }, _this.state = _extends({}, _this.initialState), _this.onSelectSite = function (selectedSite) {
	      _this.setState({
	        selectedDrive: null, // clear drive selection when site changes
	        selectedSite: selectedSite
	      });
	    }, _this.onSelectDrive = function (selectedDrive) {
	      _this.setState({ selectedDrive: selectedDrive });
	    }, _this.onSave = function () {
	      _this.setState({ isLoading: true });
	
	      _superagent2.default.post("/rpc/integrations/connections/" + _this.props.connectionId + "/sharepoint/drive").send({
	        drive_type: 'site', // TODO - support personal drive or site drive selection?
	        site: _this.state.selectedSite,
	        drive: _this.state.selectedDrive
	      }).then(function (res) {
	        _this.setState({ isLoading: false });
	        _Notification.notify.success("Default SharePoint drive saved");
	      }).catch(function (err) {
	        _this.setState({ isLoading: false });
	        _Notification.notify.error("Failed to save SharePoint default drive");
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  SharepointConnectionSettings.prototype.componentDidMount = function componentDidMount() {
	    this.loadDefaultDrive();
	  };
	
	  SharepointConnectionSettings.prototype.loadDefaultDrive = function loadDefaultDrive(refreshFromSharepoint) {
	    var _this2 = this;
	
	    this.setState(this.initialState);
	
	    return _superagent2.default.get("/rpc/integrations/connections/" + this.props.connectionId + "/sharepoint/drive").query({ refresh: refreshFromSharepoint }).then(function (res) {
	      _this2.setState({
	        isLoading: false,
	        selectedSite: res.body.site,
	        selectedDrive: res.body.drive
	      });
	    }).catch(function (err) {
	      _this2.setState({
	        isLoading: false,
	        error: _lodash2.default.get(err, 'response.status') !== 404 ? true : false
	      });
	    });
	  };
	
	  SharepointConnectionSettings.prototype.render = function render() {
	    var _this3 = this;
	
	    var selectedSite = this.state.selectedSite;
	
	
	    return _react2.default.createElement(
	      _reactBootstrap.Panel,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Panel.Heading,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Panel.Title,
	          { componentClass: "h3" },
	          "SharePoint Settings"
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Panel.Body,
	        null,
	        function () {
	          if (_this3.state.error) return _react2.default.createElement(
	            _reactBootstrap.Alert,
	            { bsStyle: "danger" },
	            "There was an error loading SharePoint Settings Information. If the problem persists, please contact CourtDrive support."
	          );
	
	          if (_this3.state.isLoading) return _react2.default.createElement(_reactBootstrap.ProgressBar, { active: true, now: 100 });
	
	          return _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.FormGroup,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.ControlLabel,
	                null,
	                "Sharepoint Site"
	              ),
	              _react2.default.createElement(_SharepointSiteSearch2.default, {
	                connectionId: _this3.props.connectionId,
	                defaultValue: selectedSite,
	                onSelectSite: _this3.onSelectSite
	              })
	            ),
	            selectedSite && _react2.default.createElement(
	              _reactBootstrap.FormGroup,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.ControlLabel,
	                null,
	                "Sharepoint Document Library"
	              ),
	              _react2.default.createElement(_SharepointDriveSelector2.default, {
	                connectionId: _this3.props.connectionId,
	                siteId: selectedSite.id,
	                onSelectDrive: _this3.onSelectDrive
	              })
	            ),
	            _this3.state.selectedDrive && _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { bsStyle: "primary", onClick: _this3.onSave },
	                "Save"
	              )
	            )
	          );
	        }()
	      )
	    );
	  };
	
	  return SharepointConnectionSettings;
	}(_react2.default.Component);
	
	SharepointConnectionSettings.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  connectionId: _propTypes2.default.number.isRequired
	};
	exports.default = SharepointConnectionSettings;

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(235);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SharepointFolderSelector = function (_Component) {
	  _inherits(SharepointFolderSelector, _Component);
	
	  function SharepointFolderSelector() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SharepointFolderSelector);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      folders: [],
	      selectedFolderPath: _this.props.folderPath || [],
	      selectedFolder: (_this.props.folderPath || []).slice(-1)[0] || null,
	      isLoading: false,
	      isError: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  SharepointFolderSelector.prototype.loadFolders = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      var _props, connectionId, selectedDrive, selectedFolder, response;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _props = this.props, connectionId = _props.connectionId, selectedDrive = _props.selectedDrive;
	              selectedFolder = this.state.selectedFolder;
	
	              // can't load folders unless a drive is selected
	
	              if (selectedDrive) {
	                _context.next = 5;
	                break;
	              }
	
	              this.setState({ folders: [] });
	              return _context.abrupt("return");
	
	            case 5:
	              if (!(selectedFolder && !selectedFolder.id)) {
	                _context.next = 7;
	                break;
	              }
	
	              return _context.abrupt("return");
	
	            case 7:
	
	              this.setState({ isError: false, isLoading: true });
	
	              _context.prev = 8;
	              _context.next = 11;
	              return _superagent2.default.get("/rpc/integrations/connections/" + connectionId + "/sharepoint/list-folder").query({ drive: selectedDrive.id, parent_id: _lodash2.default.get(selectedFolder, 'id') });
	
	            case 11:
	              response = _context.sent;
	
	
	              this.setState({ folders: _lodash2.default.get(response.body, 'folders', []) });
	              _context.next = 19;
	              break;
	
	            case 15:
	              _context.prev = 15;
	              _context.t0 = _context["catch"](8);
	
	              console.error("Failed to load sharepoint folder list: ", _context.t0);
	              this.setState({ isError: true });
	
	            case 19:
	              _context.prev = 19;
	
	              this.setState({ isLoading: false });
	              return _context.finish(19);
	
	            case 22:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, this, [[8, 15, 19, 22]]);
	    }));
	
	    function loadFolders() {
	      return _ref.apply(this, arguments);
	    }
	
	    return loadFolders;
	  }();
	
	  SharepointFolderSelector.prototype.isLegacyFolderPath = function isLegacyFolderPath() {
	    var selectedFolderPath = this.state.selectedFolderPath;
	
	
	    if (selectedFolderPath === null) return false;
	
	    if (selectedFolderPath.length === 0) return false;
	
	    return !selectedFolderPath[0].id;
	  };
	
	  // For the current folder item, returns the full/path/to/the/folder string
	
	
	  SharepointFolderSelector.prototype.folderPathName = function folderPathName(folder) {
	    var selectedFolderPath = this.state.selectedFolderPath;
	
	    // if this is just hte legacy folder path that we loaded in, just return the path name.
	
	    if (this.isLegacyFolderPath()) {
	      return selectedFolderPath.map(function (folder) {
	        return folder.name;
	      }).join('/');
	    }
	
	    // filter out the selected folder from the selected folder path to get the path.
	    var pathToFolder = selectedFolderPath.filter(function (item) {
	      return item.id !== folder.id;
	    });
	
	    // this is a top level folder, just return the name
	    if (pathToFolder.length === 0) return folder.name;
	
	    // return full path to the folder
	    return pathToFolder.map(function (folder) {
	      return folder.name;
	    }).join('/') + '/' + folder.name;
	  };
	
	  SharepointFolderSelector.prototype.componentDidMount = function componentDidMount() {
	    this.loadFolders();
	  };
	
	  SharepointFolderSelector.prototype.componentDidUpdate = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(prevProps, prevState, snapshot) {
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              if (!(_lodash2.default.get(prevProps, 'selectedDrive.id') !== _lodash2.default.get(this.props, 'selectedDrive.id'))) {
	                _context2.next = 5;
	                break;
	              }
	
	              _context2.next = 3;
	              return this.setState({
	                selectedFolder: null,
	                selectedFolderPath: []
	              });
	
	            case 3:
	              _context2.next = 5;
	              return this.loadFolders();
	
	            case 5:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, this);
	    }));
	
	    function componentDidUpdate(_x, _x2, _x3) {
	      return _ref2.apply(this, arguments);
	    }
	
	    return componentDidUpdate;
	  }();
	
	  SharepointFolderSelector.prototype.render = function render() {
	    var _this2 = this;
	
	    var _state = this.state,
	        folders = _state.folders,
	        isError = _state.isError,
	        isLoading = _state.isLoading,
	        selectedFolder = _state.selectedFolder,
	        selectedFolderPath = _state.selectedFolderPath;
	    var _props2 = this.props,
	        isDisabled = _props2.isDisabled,
	        onSelectFolder = _props2.onSelectFolder;
	
	
	    if (isError) {
	      return _react2.default.createElement(
	        "div",
	        { className: "alert alert-danger" },
	        "Failed to load sharepoint folders"
	      );
	    }
	
	    return _react2.default.createElement(_reactSelect2.default, {
	      placeholder: "Select subfolder (optional)",
	      isDisabled: isDisabled,
	      value: selectedFolder,
	      options: folders,
	      isLoading: isLoading,
	      getOptionLabel: function getOptionLabel(folder) {
	        return _this2.folderPathName(folder);
	      },
	      getOptionValue: function getOptionValue(folder) {
	        return folder.id;
	      },
	      noOptionsMessage: function noOptionsMessage() {
	        return "No subfolders available";
	      },
	      isClearable: true,
	      key: "select-sharepoint-folder",
	      onChange: function () {
	        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(option) {
	          var newSelectedFolderPath;
	          return regeneratorRuntime.wrap(function _callee3$(_context3) {
	            while (1) {
	              switch (_context3.prev = _context3.next) {
	                case 0:
	                  // if the value was cleared, clear the path to the folder
	                  newSelectedFolderPath = option === null ? [] : [].concat(selectedFolderPath, [option]);
	                  _context3.next = 3;
	                  return _this2.setState({
	                    selectedFolderPath: newSelectedFolderPath,
	                    selectedFolder: option
	                  });
	
	                case 3:
	                  _context3.next = 5;
	                  return _this2.loadFolders();
	
	                case 5:
	
	                  // communicate the new folder list to the containing component
	                  if (onSelectFolder) onSelectFolder({ folderPath: newSelectedFolderPath });
	
	                case 6:
	                case "end":
	                  return _context3.stop();
	              }
	            }
	          }, _callee3, _this2);
	        }));
	
	        return function (_x4) {
	          return _ref3.apply(this, arguments);
	        };
	      }()
	    });
	  };
	
	  return SharepointFolderSelector;
	}(_react.Component);
	
	SharepointFolderSelector.defaultProps = {
	  connectionId: null,
	  selectedDrive: null,
	  onSelectFolder: null,
	  folderPath: []
	};
	exports.default = SharepointFolderSelector;

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _sharepointonline = __webpack_require__(962);
	
	var _sharepointonline2 = _interopRequireDefault(_sharepointonline);
	
	var _OneDriveAuthenticator = __webpack_require__(599);
	
	var _OneDriveAuthenticator2 = _interopRequireDefault(_OneDriveAuthenticator);
	
	var _integrationsConnectionActions = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SharepointSwitch = function (_React$Component) {
	  _inherits(SharepointSwitch, _React$Component);
	
	  function SharepointSwitch() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SharepointSwitch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      isLoading: false
	    }, _this.onClick = function () {
	      var connectionId = _this.props.connectionId;
	
	
	      if (connectionId) {
	        _this.props.dispatch((0, _integrationsConnectionActions.disconnectIntegration)(connectionId));
	      } else {
	        _this.setState({ isLoading: true });
	
	        // Sharepoint uses Graph API, just like OneDrive.
	        // TOOD rename this to something like MicrosoftGraphAuthenticator
	        (0, _OneDriveAuthenticator2.default)('full').login({
	          scope: 'files groups sites offline',
	          state: {
	            connection_type: 'full',
	            redirect_host: window.location.host
	          }
	        }).then(function (_ref) {
	          var authResponse = _ref.authResponse;
	
	          _this.props.dispatch((0, _integrationsConnectionActions.connectIntegration)('files', 'sharepoint', authResponse));
	          _this.setState({ isLoading: false });
	        }, function (res) {
	          var _res$error = res.error,
	              code = _res$error.code,
	              message = _res$error.message;
	
	          _this.setState({ isLoading: false });
	          notify.error("Error connecting to Sharepoint: [" + code + "] " + (message || ''));
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  SharepointSwitch.prototype.render = function render() {
	    var _props = this.props,
	        connectionId = _props.connectionId,
	        agreedToPricing = _props.agreedToPricing;
	
	
	    var iconCls = "kloudless-switch " + (connectionId ? 'on' : '') + " " + (agreedToPricing ? '' : 'hidden');
	
	    return _react2.default.createElement(
	      "div",
	      { className: "kloudless-control-holder2" },
	      _react2.default.createElement("img", { className: "kloudless-connection-icon",
	        src: _sharepointonline2.default,
	        alt: "Sharepoint Logo"
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: iconCls, onClick: this.onClick },
	        this.state.isLoading && _react2.default.createElement("i", { className: "fa fa-circle-o-notch fa-spin",
	          style: { marginTop: '10px', marginLeft: '11px', fontSize: '11px' } })
	      )
	    );
	  };
	
	  return SharepointSwitch;
	}(_react2.default.Component);
	
	SharepointSwitch.defaultProps = {
	  connectionId: null
	};
	SharepointSwitch.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  connectionId: _propTypes2.default.number,
	  agreedToPricing: _propTypes2.default.bool.isRequired
	};
	exports.default = SharepointSwitch;

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (serverName) {
	  return _hello2.default.init({
	    imanage: {
	      name: 'iManage Work',
	
	      base: 'https://' + serverName + '/auth/oauth2',
	
	      oauth: {
	        version: 2,
	        auth: 'https://' + serverName + '/auth/oauth2/authorize',
	        grant: 'https://' + serverName + '/auth/oauth2/token',
	        response_type: 'code',
	        state_encoding: 'base64'
	      },
	
	      scope: {},
	
	      scope_delim: ' '
	    }
	  })
	
	  // Initialize Driver instance
	  .init({ imanage: window.Drupal.settings.INTEGRATIONS_IMANAGE_APP_ID }, {
	    redirect_uri: 'https://app.courtdrive.com/rpc/static/hello.js/redirect.html',
	    oauth_proxy: window.location.origin + '/rpc/integrations/oauth_proxy'
	  })('imanage'); // spawn an instance of the driver that one can call .login() on
	};
	
	var _hello = __webpack_require__(112);
	
	var _hello2 = _interopRequireDefault(_hello);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ECFExternalMailboxEditForm;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactSelect = __webpack_require__(235);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _finalForm = __webpack_require__(124);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function ECFExternalMailboxEditForm(_ref) {
	  var settings = _ref.settings,
	      onSaveSettings = _ref.onSaveSettings,
	      onCancel = _ref.onCancel;
	
	  if (!settings) return null;
	
	  return _react2.default.createElement(_reactFinalForm.Form, {
	    onSubmit: onSaveSettings || alert,
	    initialValues: settings || {},
	    render: function render(_ref2) {
	      var form = _ref2.form,
	          submitting = _ref2.submitting,
	          pristine = _ref2.pristine,
	          values = _ref2.values;
	      return _react2.default.createElement(
	        _reactBootstrap.Form,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.FormGroup,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.ControlLabel,
	            null,
	            'Mail Provider / Type of server'
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.FormControl.Static,
	            { componentClass: 'div', style: { zIndex: 1000, position: 'relative' } },
	            _react2.default.createElement(_reactFinalForm.Field, {
	              name: 'type',
	              component: FinalFormReactSelectAdapter,
	              placeholder: 'Select your mail provider or server type',
	              autoFocus: true,
	              defaultMenuIsOpen: !settings.id,
	              isDisabled: settings.id // Don't allow type to be changed on existing settings
	              , options: [{ label: _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement('i', { className: 'fa fa-google' }),
	                  ' GMail                '
	                ), value: 'gmail' }, { label: _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement('i', { className: 'fa fa-envelope' }),
	                  ' Outlook365 / Hotmail '
	                ), value: 'hotmail' }, { label: _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement('i', { className: 'fa fa-envelope' }),
	                  ' IMAP                 '
	                ), value: 'imap' }],
	              clearable: false
	            })
	          )
	        ),
	        !!_lodash2.default.get(values, 'type') && _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _lodash2.default.get(values, 'type') === 'gmail' && _react2.default.createElement(
	            _reactBootstrap.Alert,
	            { bsStyle: 'warning' },
	            'The following adjustments are needed to connect to GMail with your username and password:',
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'Enable IMAP access in your ',
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  {
	                    href: 'https://mail.google.com/mail/u/0/#settings/fwdandpop',
	                    target: '_blank',
	                    rel: 'noopener noreferrer'
	                  },
	                  'GMail Forwarding and POP/IMAP settings',
	                  ' ',
	                  _react2.default.createElement('i', { className: 'fa fa-external-link' })
	                ),
	                '.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'It may also be necessary to ',
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  {
	                    href: 'https://myaccount.google.com/lesssecureapps',
	                    target: '_blank',
	                    rel: 'noopener noreferrer'
	                  },
	                  'Allow "less secure apps"',
	                  ' ',
	                  _react2.default.createElement('i', { className: 'fa fa-external-link' })
	                ),
	                '.'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Rest assured that you mailbox information is kept safe: all usernames and passwords are stored encrypted, and our connection to GMail is secured using bank-grade SSL protocol.'
	            )
	          ),
	          _lodash2.default.get(values, 'type') === 'imap' && _react2.default.createElement(
	            _reactBootstrap.Panel,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Panel.Heading,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Panel.Title,
	                null,
	                'Server Connection Settings'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Panel.Body,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.ControlLabel,
	                  null,
	                  'Server Address (Hostname)'
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.InputGroup,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.InputGroup.Addon,
	                    null,
	                    _react2.default.createElement('i', { className: 'fa fa-server' })
	                  ),
	                  _react2.default.createElement(_reactFinalForm.Field, { name: 'connection_settings.hostname', component: 'input', type: 'input', className: 'form-control' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.HelpBlock,
	                  null,
	                  'Examples: ',
	                  _react2.default.createElement(
	                    'code',
	                    null,
	                    'imap.example.org'
	                  ),
	                  ', ',
	                  _react2.default.createElement(
	                    'code',
	                    null,
	                    'mail.example.org'
	                  ),
	                  '.'
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.ControlLabel,
	                  null,
	                  'Server Port'
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.InputGroup,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.InputGroup.Addon,
	                    null,
	                    '#'
	                  ),
	                  _react2.default.createElement(_reactFinalForm.Field, { name: 'connection_settings.port', component: 'input', type: 'text', className: 'form-control' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.HelpBlock,
	                  null,
	                  'Examples: ',
	                  _react2.default.createElement(
	                    'code',
	                    null,
	                    '143'
	                  ),
	                  ' (without SSL), ',
	                  _react2.default.createElement(
	                    'code',
	                    null,
	                    '993'
	                  ),
	                  ' (with SSL)'
	                )
	              ),
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactFinalForm.Field, { name: 'connection_settings.ssl', component: 'input', type: 'checkbox' }),
	                ' ',
	                ' Use SSL (Secure Connection)'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Panel.Heading,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Panel.Title,
	                null,
	                'Login Credentials'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Panel.Body,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.ControlLabel,
	                  null,
	                  'Login'
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.InputGroup,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.InputGroup.Addon,
	                    null,
	                    _react2.default.createElement('i', { className: 'fa fa-user' })
	                  ),
	                  _react2.default.createElement(_reactFinalForm.Field, { name: 'connection_secrets.username', component: 'input', type: 'text', className: 'form-control' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.HelpBlock,
	                  null,
	                  'Server login name. Examples: ',
	                  _react2.default.createElement(
	                    'code',
	                    null,
	                    'jsmith'
	                  ),
	                  ', ',
	                  _react2.default.createElement(
	                    'code',
	                    null,
	                    'jsmith@example.org'
	                  ),
	                  ', ',
	                  _react2.default.createElement(
	                    'code',
	                    null,
	                    'jsmith@gmail.com'
	                  ),
	                  ', ',
	                  _react2.default.createElement(
	                    'code',
	                    null,
	                    'jsmith@hotmail.com'
	                  ),
	                  '.'
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.ControlLabel,
	                  null,
	                  'Password'
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.InputGroup,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.InputGroup.Addon,
	                    null,
	                    _react2.default.createElement('i', { className: 'fa fa-key' })
	                  ),
	                  _react2.default.createElement(_reactFinalForm.Field, {
	                    name: 'connection_secrets.password',
	                    autoFocus: !!values.id // auto focus the password when updating credentials
	                    , component: 'input',
	                    type: 'password',
	                    className: 'form-control'
	                  })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'link'
	            // instead of type=submit, since we dont' want stray [Enter] to submit the form
	            , onClick: function onClick() {
	              return (pristine || confirm('This will give up any changes')) && onCancel();
	            },
	            disabled: submitting
	          },
	          'Cancel'
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            style: { float: 'right' },
	            bsStyle: pristine ? 'default' : 'primary'
	            // instead of type=submit, since we dont' want stray [Enter] to submit the form
	            , onClick: function onClick() {
	              return form.submit();
	            },
	            disabled: submitting || pristine
	          },
	          submitting ? _react2.default.createElement('i', { className: 'fa fa-link fa-spin' }) : _react2.default.createElement('i', { className: 'fa fa-link' }),
	          ' ',
	          'Validate and Save'
	        )
	      );
	    } });
	}
	
	// Clients need to return this from onSaveSettings handler to tell us there has been an error
	ECFExternalMailboxEditForm.saveErrorSignal = function (error) {
	  var _ref3;
	
	  return _ref3 = {}, _ref3[_finalForm.FORM_ERROR] = error, _ref3;
	};
	
	var FinalFormReactSelectAdapter = function FinalFormReactSelectAdapter(_ref4) {
	  var _ref4$input = _ref4.input,
	      value = _ref4$input.value,
	      _onChange = _ref4$input.onChange,
	      options = _ref4.options,
	      rest = _objectWithoutProperties(_ref4, ['input', 'options']);
	
	  return _react2.default.createElement(_reactSelect2.default, _extends({
	    value: _lodash2.default.find(options, { value: value }),
	    onChange: function onChange(selectedOption) {
	      return _onChange(_lodash2.default.get(selectedOption, 'value'));
	    },
	    options: options
	  }, rest));
	};

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FinalFormStandaloneClientCodeAdapter = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = StandaloneClientCode;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _asyncCreatable = __webpack_require__(2100);
	
	var _asyncCreatable2 = _interopRequireDefault(_asyncCreatable);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                             Client Code Selector that is suitable for use in forms, not connected to
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                             Redux etc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */
	
	
	var convertOptionsToReactSelectOptions = function convertOptionsToReactSelectOptions(options) {
	  return options.map(function (_ref) {
	    var text = _ref.text,
	        children = _ref.children;
	    return {
	      label: text,
	      value: text,
	      options: children && convertOptionsToReactSelectOptions(children)
	    };
	  });
	};
	
	var fetchClientCodeOptions = function () {
	  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(inputValue) {
	    var res;
	    return regeneratorRuntime.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _superagent2.default.get('/clientcode/get-codes?query=' + inputValue + '&page=1');
	
	          case 2:
	            res = _context.sent;
	            return _context.abrupt('return', convertOptionsToReactSelectOptions(res.body.data));
	
	          case 4:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function fetchClientCodeOptions(_x) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	// we send "UID--client code", hence we can't let user enter the same length as on PACER
	var PACER_MAX_CODE_LENGTH = 32;
	var IR_UID_MAX_LENGTH = 6; // work up to million users
	var IR_CODE_SPLIT_LENGTH = 2;
	
	var MAX_CODE_LENGTH = PACER_MAX_CODE_LENGTH - IR_UID_MAX_LENGTH - IR_CODE_SPLIT_LENGTH;
	
	var trimClientCode = function trimClientCode(val) {
	  return val.substr(0, MAX_CODE_LENGTH);
	};
	
	function StandaloneClientCode(props) {
	
	  return _react2.default.createElement(_asyncCreatable2.default, _extends({
	    defaultOptions: true,
	    loadOptions: fetchClientCodeOptions,
	    isClearable: true,
	    getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
	      return {
	        value: trimClientCode(inputValue),
	        label: _react2.default.createElement(
	          'span',
	          null,
	          'New code: ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            trimClientCode(inputValue)
	          )
	        )
	      };
	    }
	  }, props));
	}
	
	/*
	  You can create Final Form compatible field via
	  ```
	    <Field
	      name="client_code"
	      component={FinalFormStandaloneClientCodeAdapter}
	    />
	  ```
	*/
	var FinalFormStandaloneClientCodeAdapter = function FinalFormStandaloneClientCodeAdapter(_ref3) {
	  var _ref3$input = _ref3.input,
	      value = _ref3$input.value,
	      _onChange = _ref3$input.onChange,
	      rest = _objectWithoutProperties(_ref3, ['input']);
	
	  return _react2.default.createElement(StandaloneClientCode, _extends({
	    value: { value: value, label: value },
	    onChange: function onChange(selectedOption) {
	      return _onChange(_lodash2.default.get(selectedOption, 'value'));
	    }
	  }, rest));
	};
	exports.FinalFormStandaloneClientCodeAdapter = FinalFormStandaloneClientCodeAdapter;

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _SubmitButton = __webpack_require__(1086);
	
	var _SubmitButton2 = _interopRequireDefault(_SubmitButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SubmitButton2.default;

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _InfoMessage = __webpack_require__(1102);
	
	var _InfoMessage2 = _interopRequireDefault(_InfoMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _InfoMessage2.default;

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loadingBar = __webpack_require__(199);
	
	var _loadingBar2 = _interopRequireDefault(_loadingBar);
	
	__webpack_require__(943);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //packages
	
	
	//images
	
	
	//styles
	
	
	var LoadingBar = function (_Component) {
	    _inherits(LoadingBar, _Component);
	
	    function LoadingBar() {
	        _classCallCheck(this, LoadingBar);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    LoadingBar.prototype.render = function render() {
	        return _react2.default.createElement('img', { className: 'loading-bar', src: _loadingBar2.default });
	    };
	
	    return LoadingBar;
	}(_react.Component);
	
	exports.default = LoadingBar;

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(2159);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Receipt = function (_Component) {
	    _inherits(Receipt, _Component);
	
	    function Receipt() {
	        _classCallCheck(this, Receipt);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    Receipt.prototype.render = function render() {
	        var _props$children = this.props.children,
	            datetime = _props$children.datetime,
	            user_id = _props$children.user_id,
	            client_code = _props$children.client_code,
	            description = _props$children.description,
	            criteria = _props$children.criteria,
	            pages = _props$children.pages,
	            cost = _props$children.cost;
	
	
	        return !!datetime && _react2.default.createElement(
	            'div',
	            { className: 'receipt-module' },
	            _react2.default.createElement(
	                'table',
	                null,
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { colSpan: '2' },
	                            'PACER Service Center'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'Receipt:'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            datetime
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'User:'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            user_id
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'Client:'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            client_code
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'Description:'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            description
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '\xA0'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            criteria
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'Pages:'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            pages,
	                            '\xA0($',
	                            cost,
	                            ')'
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return Receipt;
	}(_react.Component);
	
	Receipt.propTypes = {
	    children: _propTypes2.default.object
	};
	Receipt.defaultProps = {
	    children: {}
	};
	exports.default = Receipt;

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	__webpack_require__(612);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //packages
	
	
	//styles
	
	
	var SelectorPopover = function (_Component) {
	    _inherits(SelectorPopover, _Component);
	
	    function SelectorPopover() {
	        _classCallCheck(this, SelectorPopover);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    SelectorPopover.prototype.render = function render() {
	        return _react2.default.createElement(
	            _reactBootstrap.OverlayTrigger,
	            {
	                trigger: ['hover', 'focus'],
	                placement: 'right',
	                shouldUpdatePosition: true,
	                overlay: _react2.default.createElement(
	                    _reactBootstrap.Popover,
	                    { id: 'popover-of-form' },
	                    this.props.children
	                ) },
	            _react2.default.createElement('span', { className: 'ir-tooltip' })
	        );
	    };
	
	    return SelectorPopover;
	}(_react.Component);
	
	SelectorPopover.propTypes = {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.element])
	};
	SelectorPopover.defaultProps = {};
	exports.default = SelectorPopover;

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _WarningBox = __webpack_require__(1107);
	
	var _WarningBox2 = _interopRequireDefault(_WarningBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _WarningBox2.default;

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var KnowledgeBaseLink = function KnowledgeBaseLink() {
	  return _react2.default.createElement(
	    _reactBootstrap.OverlayTrigger,
	    {
	      trigger: ['hover', 'focus'],
	      placement: 'right',
	      shouldUpdatePosition: true,
	      overlay: _react2.default.createElement(
	        _reactBootstrap.Popover,
	        { id: 'popover-of-form' },
	        'To learn more about using our Advanced Search, please read our Knowledge Base'
	      )
	    },
	    _react2.default.createElement(
	      'a',
	      { style: { float: 'right' },
	        href: 'http://support.courtdrive.com/hc/en-us/articles/205450048-How-do-I-search-across-cases-using-keywords-and-filters-',
	        target: '_blank'
	      },
	      _react2.default.createElement('span', { className: 'ir-tooltip' }),
	      ' Learn more'
	    )
	  );
	};
	
	exports.default = KnowledgeBaseLink;

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AssetsField = function AssetsField(_ref) {
	  var assetsLiabilitiesSelectOptions = _ref.assetsLiabilitiesSelectOptions;
	
	  return _react2.default.createElement(
	    _reactFinalForm.Field,
	    { name: 'assets', parse: function parse(values) {
	        return values.map(function (_ref2) {
	          var value = _ref2.value;
	          return value;
	        });
	      } },
	    function (_ref3) {
	      var input = _ref3.input;
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          'label',
	          null,
	          'Assets'
	        ),
	        _react2.default.createElement(_reactSelect2.default, _extends({}, input, { multi: true, options: assetsLiabilitiesSelectOptions, className: 'form-select' }))
	      );
	    }
	  );
	};
	
	AssetsField.propTypes = {
	  assetsLiabilitiesSelectOptions: _propTypes2.default.array.isRequired
	};
	
	exports.default = AssetsField;

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BusinessOnlyField = function BusinessOnlyField(_ref) {
	  var limitSelectOptions = _ref.limitSelectOptions,
	      disabled = _ref.disabled;
	
	  return _react2.default.createElement(
	    _reactFinalForm.Field,
	    { name: 'business_cases', parse: function parse(_ref2) {
	        var value = _ref2.value;
	        return value;
	      } },
	    function (_ref3) {
	      var input = _ref3.input;
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          'label',
	          null,
	          'Business Cases Only'
	        ),
	        _react2.default.createElement(_reactSelect2.default, _extends({}, input, {
	          clearable: false,
	          options: limitSelectOptions,
	          className: 'form-select',
	          disabled: disabled
	        }))
	      );
	    }
	  );
	};
	
	BusinessOnlyField.propTypes = {
	  limitSelectOptions: _propTypes2.default.array.isRequired,
	  disabled: _propTypes2.default.bool
	};
	
	BusinessOnlyField.defaultProps = {
	  disabled: false
	};
	
	exports.default = BusinessOnlyField;

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CaseTitlesField = function CaseTitlesField(_ref) {
	  var limitSelectOptions = _ref.limitSelectOptions,
	      disabled = _ref.disabled;
	
	  return _react2.default.createElement(
	    _reactFinalForm.Field,
	    { name: 'case_titles', parse: function parse(_ref2) {
	        var value = _ref2.value;
	        return value;
	      } },
	    function (_ref3) {
	      var input = _ref3.input;
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          'label',
	          null,
	          'Case Titles'
	        ),
	        _react2.default.createElement(_reactSelect2.default, _extends({}, input, {
	          clearable: false,
	          options: limitSelectOptions,
	          className: 'form-select',
	          disabled: disabled
	        }))
	      );
	    }
	  );
	};
	
	CaseTitlesField.propTypes = {
	  limitSelectOptions: _propTypes2.default.array.isRequired,
	  disabled: _propTypes2.default.bool
	};
	
	CaseTitlesField.defaultProps = {
	  disabled: false
	};
	
	exports.default = CaseTitlesField;

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CasesField = function CasesField(_ref) {
	  var casefoldersSelectOptions = _ref.casefoldersSelectOptions;
	
	  return _react2.default.createElement(
	    _reactFinalForm.Field,
	    { name: 'my_cases', parse: function parse(_ref2) {
	        var value = _ref2.value;
	        return value;
	      } },
	    function (_ref3) {
	      var input = _ref3.input;
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          'label',
	          null,
	          'Search What'
	        ),
	        _react2.default.createElement(_reactSelect2.default, _extends({}, input, { clearable: false, options: casefoldersSelectOptions, className: 'form-select' }))
	      );
	    }
	  );
	};
	
	CasesField.propTypes = {
	  casefoldersSelectOptions: _propTypes2.default.array.isRequired
	};
	
	exports.default = CasesField;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CasesField = function CasesField(_ref) {
	  var chapterSelectOptions = _ref.chapterSelectOptions;
	
	  return _react2.default.createElement(
	    _reactFinalForm.Field,
	    { name: 'chapter', parse: function parse(values) {
	        return values.map(function (_ref2) {
	          var value = _ref2.value;
	          return value;
	        });
	      } },
	    function (_ref3) {
	      var input = _ref3.input;
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          'label',
	          null,
	          'Chapter'
	        ),
	        _react2.default.createElement(_reactSelect2.default, _extends({}, input, { multi: true, options: chapterSelectOptions, className: 'form-select' }))
	      );
	    }
	  );
	};
	
	CasesField.propTypes = {
	  chapterSelectOptions: _propTypes2.default.array.isRequired
	};
	
	exports.default = CasesField;

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactDatepicker = __webpack_require__(78);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(32);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatePickerField = function DatePickerField(_ref) {
	  var fieldName = _ref.fieldName,
	      placeholderText = _ref.placeholderText;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'col-2' },
	    _react2.default.createElement(
	      _reactFinalForm.Field,
	      { name: fieldName },
	      function (_ref2) {
	        var input = _ref2.input,
	            meta = _ref2.meta;
	        return _react2.default.createElement(_reactDatepicker2.default, _extends({}, input, {
	          selected: input.value ? (0, _moment2.default)(input.value) : null,
	          onChangeRaw: input.onChange,
	          dateFormat: 'MM/DD/YYYY',
	          className: 'form-input ' + (meta.submitFailed && meta.error ? 'error' : ''),
	          placeholderText: placeholderText,
	          isClearable: true
	        }));
	      }
	    )
	  );
	};
	
	DatePickerField.propTypes = {
	  fieldName: _propTypes2.default.string.isRequired,
	  placeholderText: _propTypes2.default.string.isRequired
	};
	
	exports.default = DatePickerField;

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndustryField = function IndustryField(_ref) {
	  var industrySelectOptions = _ref.industrySelectOptions;
	
	  return _react2.default.createElement(
	    _reactFinalForm.Field,
	    { name: 'industry', parse: function parse(values) {
	        return values.map(function (_ref2) {
	          var value = _ref2.value;
	          return value;
	        });
	      } },
	    function (_ref3) {
	      var input = _ref3.input;
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          'label',
	          null,
	          'Industry'
	        ),
	        _react2.default.createElement(_reactSelect2.default, _extends({}, input, { multi: true, options: industrySelectOptions, className: 'form-select' }))
	      );
	    }
	  );
	};
	
	IndustryField.propTypes = {
	  industrySelectOptions: _propTypes2.default.array.isRequired
	};
	
	exports.default = IndustryField;

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InputField = function InputField(_ref) {
	  var placeholder = _ref.placeholder;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-item' },
	    _react2.default.createElement(_reactFinalForm.Field, { name: 'keys', component: 'input', type: 'text', placeholder: placeholder, className: 'form-input keys' })
	  );
	};
	
	InputField.propTypes = {
	  placeholder: _propTypes2.default.string.isRequired
	};
	
	exports.default = InputField;

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LiabilitiesField = function LiabilitiesField(_ref) {
	  var assetsLiabilitiesSelectOptions = _ref.assetsLiabilitiesSelectOptions;
	
	  return _react2.default.createElement(
	    _reactFinalForm.Field,
	    { name: 'liabilities', parse: function parse(values) {
	        return values.map(function (_ref2) {
	          var value = _ref2.value;
	          return value;
	        });
	      } },
	    function (_ref3) {
	      var input = _ref3.input;
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          'label',
	          null,
	          'Liabilities'
	        ),
	        _react2.default.createElement(_reactSelect2.default, _extends({}, input, { multi: true, options: assetsLiabilitiesSelectOptions, className: 'form-select' }))
	      );
	    }
	  );
	};
	
	LiabilitiesField.propTypes = {
	  assetsLiabilitiesSelectOptions: _propTypes2.default.array.isRequired
	};
	
	exports.default = LiabilitiesField;

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NatureOfSuitField = function NatureOfSuitField(_ref) {
	  var districtNosOptions = _ref.districtNosOptions;
	
	  return _react2.default.createElement(
	    _reactFinalForm.Field,
	    { name: 'nature_of_suit', parse: function parse(values) {
	        return values.map(function (_ref2) {
	          var value = _ref2.value;
	          return value;
	        });
	      } },
	    function (_ref3) {
	      var input = _ref3.input;
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          'label',
	          null,
	          'Nature of Suit'
	        ),
	        _react2.default.createElement(_reactSelect2.default, _extends({}, input, { multi: true, options: districtNosOptions, className: 'form-select' }))
	      );
	    }
	  );
	};
	
	NatureOfSuitField.propTypes = {
	  districtNosOptions: _propTypes2.default.array.isRequired
	};
	
	exports.default = NatureOfSuitField;

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PartyNameField = function PartyNameField(_ref) {
	  var limitSelectOptions = _ref.limitSelectOptions;
	
	  return _react2.default.createElement(
	    _reactFinalForm.Field,
	    { name: 'party_name', parse: function parse(_ref2) {
	        var value = _ref2.value;
	        return value;
	      } },
	    function (_ref3) {
	      var input = _ref3.input;
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          'label',
	          null,
	          'Party Name'
	        ),
	        _react2.default.createElement(_reactSelect2.default, _extends({}, input, { clearable: false, options: limitSelectOptions, className: 'form-select' }))
	      );
	    }
	  );
	};
	
	PartyNameField.propTypes = {
	  limitSelectOptions: _propTypes2.default.array.isRequired
	};
	
	exports.default = PartyNameField;

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QueryField = function QueryField(_ref) {
	  var querySelectOptions = _ref.querySelectOptions,
	      disabled = _ref.disabled;
	
	  return _react2.default.createElement(
	    _reactFinalForm.Field,
	    { name: 'query', parse: function parse(values) {
	        return values.map(function (_ref2) {
	          var value = _ref2.value;
	          return value;
	        });
	      } },
	    function (_ref3) {
	      var input = _ref3.input;
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          'label',
	          null,
	          'Query'
	        ),
	        _react2.default.createElement(_reactSelect2.default, _extends({}, input, { multi: true, options: querySelectOptions, className: 'form-select', disabled: disabled }))
	      );
	    }
	  );
	};
	
	QueryField.propTypes = {
	  querySelectOptions: _propTypes2.default.array.isRequired,
	  disabled: _propTypes2.default.bool
	};
	
	QueryField.defaultProps = {
	  disabled: false
	};
	
	exports.default = QueryField;

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegionField = function RegionField(_ref) {
	  var regionSelectOptions = _ref.regionSelectOptions;
	
	  return _react2.default.createElement(
	    _reactFinalForm.Field,
	    { name: 'court_code', parse: function parse(values) {
	        return values.map(function (_ref2) {
	          var value = _ref2.value;
	          return value;
	        });
	      } },
	    function (_ref3) {
	      var input = _ref3.input;
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          'label',
	          null,
	          'Region'
	        ),
	        _react2.default.createElement(_reactSelect2.default, _extends({}, input, { multi: true, options: regionSelectOptions, className: 'form-select' }))
	      );
	    }
	  );
	};
	
	RegionField.propTypes = {
	  regionSelectOptions: _propTypes2.default.array.isRequired
	};
	
	exports.default = RegionField;

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SearchPDFsField = function SearchPDFsField(_ref) {
	  var limitSelectOptions = _ref.limitSelectOptions,
	      disabled = _ref.disabled;
	
	  return _react2.default.createElement(
	    _reactFinalForm.Field,
	    { name: 'search_pdfs', parse: function parse(_ref2) {
	        var value = _ref2.value;
	        return value;
	      } },
	    function (_ref3) {
	      var input = _ref3.input;
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          'label',
	          null,
	          'Search text of PDF documents'
	        ),
	        _react2.default.createElement(_reactSelect2.default, _extends({}, input, {
	          clearable: false,
	          options: limitSelectOptions,
	          className: 'form-select',
	          disabled: disabled
	        }))
	      );
	    }
	  );
	};
	
	SearchPDFsField.propTypes = {
	  limitSelectOptions: _propTypes2.default.array.isRequired,
	  disabled: _propTypes2.default.bool
	};
	
	SearchPDFsField.defaultProps = {
	  disabled: false
	};
	
	exports.default = SearchPDFsField;

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CasesField = function CasesField(_ref) {
	  var caseTypeSelectOptions = _ref.caseTypeSelectOptions;
	
	  return _react2.default.createElement(
	    _reactFinalForm.Field,
	    { name: 'case_type', parse: function parse(values) {
	        return values.map(function (_ref2) {
	          var value = _ref2.value;
	          return value;
	        });
	      } },
	    function (_ref3) {
	      var input = _ref3.input;
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          'label',
	          null,
	          'Type'
	        ),
	        _react2.default.createElement(_reactSelect2.default, _extends({}, input, { multi: true, options: caseTypeSelectOptions, className: 'form-select' }))
	      );
	    }
	  );
	};
	
	CasesField.propTypes = {
	  caseTypeSelectOptions: _propTypes2.default.array.isRequired
	};
	
	exports.default = CasesField;

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(13);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CasesResults = __webpack_require__(633);
	
	var _CasesResults2 = _interopRequireDefault(_CasesResults);
	
	var _CasesPartyResults = __webpack_require__(632);
	
	var _CasesPartyResults2 = _interopRequireDefault(_CasesPartyResults);
	
	var _EntriesResults = __webpack_require__(132);
	
	var _EntriesResults2 = _interopRequireDefault(_EntriesResults);
	
	var _Loading = __webpack_require__(81);
	
	var _advancedSearchAction = __webpack_require__(178);
	
	var _PetitionResults = __webpack_require__(634);
	
	var _PetitionResults2 = _interopRequireDefault(_PetitionResults);
	
	var _ScheduleResults = __webpack_require__(635);
	
	var _ScheduleResults2 = _interopRequireDefault(_ScheduleResults);
	
	var _CaseActivityResults = __webpack_require__(631);
	
	var _CaseActivityResults2 = _interopRequireDefault(_CaseActivityResults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdvancedSearchResults = function AdvancedSearchResults(_ref) {
	  var data = _ref.data,
	      isLoading = _ref.isLoading,
	      showResults = _ref.showResults,
	      resultsFilter = _ref.resultsFilter,
	      onReset = _ref.onReset,
	      onAdvancedSearch = _ref.onAdvancedSearch,
	      onGetPetitionPdf = _ref.onGetPetitionPdf;
	
	  var isCase = resultsFilter.grouped || data.results && data.results.length > 0 && data.results[0].document_type === 'cases';
	  var resultTypes = {
	    cases: _CasesPartyResults2.default,
	    schedules: _ScheduleResults2.default,
	    petitions: _PetitionResults2.default,
	    general: isCase ? _CasesResults2.default : _EntriesResults2.default,
	    'case-activity': _CaseActivityResults2.default
	  };
	  var Results = resultTypes[resultsFilter.tab];
	
	  return showResults && _react2.default.createElement(
	    'section',
	    { className: 'advanced-search-results' },
	    isLoading ? _react2.default.createElement(_Loading.Loading, { show: isLoading }) : data.results && data.results.length > 0 ? _react2.default.createElement(Results, {
	      data: data,
	      filter: resultsFilter,
	      onReset: onReset,
	      onSearch: onAdvancedSearch,
	      onGetPetitionPdf: onGetPetitionPdf
	    }) : _react2.default.createElement(
	      'div',
	      null,
	      'No results found'
	    )
	  );
	};
	
	AdvancedSearchResults.propTypes = {
	  isLoading: _propTypes2.default.bool,
	  data: _propTypes2.default.any,
	  onReset: _propTypes2.default.func.isRequired,
	  onAdvancedSearch: _propTypes2.default.func.isRequired
	};
	
	AdvancedSearchResults.defaultProps = {
	  isLoading: false,
	  data: {}
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return _extends({}, state.get('advancedSearch').toJS());
	};
	
	var mapDispatchToProps = {
	  onReset: _advancedSearchAction.resetAdvancedSearch,
	  onAdvancedSearch: _advancedSearchAction.searchAdvancedFilings,
	  onGetPetitionPdf: _advancedSearchAction.getPetitionPdf
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AdvancedSearchResults);

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CaseActivityDocketsRow = __webpack_require__(638);
	
	var _CaseActivityDocketsRow2 = _interopRequireDefault(_CaseActivityDocketsRow);
	
	var _CaseActivityClaimsRow = __webpack_require__(637);
	
	var _CaseActivityClaimsRow2 = _interopRequireDefault(_CaseActivityClaimsRow);
	
	var _DocketPopup = __webpack_require__(259);
	
	var _DocketPopup2 = _interopRequireDefault(_DocketPopup);
	
	var _ResultsPaginator = __webpack_require__(108);
	
	var _ResultsPaginator2 = _interopRequireDefault(_ResultsPaginator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CaseActivityResults = function CaseActivityResults(_ref) {
	  var data = _ref.data,
	      filter = _ref.filter,
	      onSearch = _ref.onSearch;
	  return _react2.default.createElement(
	    'div',
	    { id: 'ir-search-search-premium-results' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Results \u2013 ',
	      data.num_found,
	      ' matches within ',
	      data.num_cases,
	      ' cases'
	    ),
	    data.results.map(function (row, idx) {
	      var type = row.query || row.document_type.replace('_part', '');
	      var case_url = '/rpc/legacy/case-menu-redirect/' + row.case_court + '/' + row.case_no;
	
	      return _react2.default.createElement(
	        'div',
	        { key: idx, className: 'result-item result-item-' + type },
	        _react2.default.createElement(
	          'h3',
	          { className: 'result-item-header' },
	          row.case_title,
	          ' | ',
	          _react2.default.createElement(
	            'a',
	            { href: case_url, title: 'Go to Case Query Menu', target: '_blank' },
	            row.case_no
	          ),
	          ' | ',
	          'Entries: ',
	          row.dockets.length + row.claims.length
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'result-item-body' },
	          row.dockets && row.dockets.length > 0 && _react2.default.createElement(
	            'table',
	            { className: 'ir-search-table-results sticky-enabled docket' },
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Date Filed'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  '#'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Docket Text'
	                )
	              )
	            ),
	            row.dockets.map(function (docket, idx) {
	              return _react2.default.createElement(_CaseActivityDocketsRow2.default, { row: docket, id: idx, key: idx });
	            })
	          ),
	          row.claims && row.claims.length > 0 && _react2.default.createElement(
	            'table',
	            { className: 'ir-search-table-results sticky-enabled docket' },
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  '#'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Original Filed Date'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Creditor'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Total Claimed Amount'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Last Updated'
	                )
	              )
	            ),
	            row.claims.map(function (claim, idx) {
	              return _react2.default.createElement(_CaseActivityClaimsRow2.default, { row: claim, key: idx });
	            })
	          )
	        )
	      );
	    }),
	    _react2.default.createElement(_ResultsPaginator2.default, {
	      totalPages: data.page_count,
	      selectedPage: filter.page + 1 || 1,
	      onChangePage: function onChangePage(page) {
	        return onSearch(_extends({}, filter, { page: page }));
	      }
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'docket' },
	      _react2.default.createElement(_DocketPopup2.default, null)
	    )
	  );
	};
	
	CaseActivityResults.propTypes = {
	  data: _propTypes2.default.any.isRequired
	};
	
	exports.default = CaseActivityResults;

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CasesPartyResults = function CasesPartyResults(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { id: 'ir-search-search-premium-results' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Results \u2013 ',
	      data.num_cases,
	      ' ',
	      data.num_cases > 1 ? 'cases' : 'case'
	    ),
	    _react2.default.createElement(
	      'table',
	      { className: 'ir-search-table-results sticky-enabled' },
	      _react2.default.createElement(
	        'thead',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            'Case Title'
	          ),
	          _react2.default.createElement(
	            'th',
	            null,
	            'Party Name/Role'
	          ),
	          _react2.default.createElement(
	            'th',
	            null,
	            'Court'
	          ),
	          _react2.default.createElement(
	            'th',
	            null,
	            'Case No'
	          ),
	          _react2.default.createElement(
	            'th',
	            null,
	            'Chp'
	          ),
	          _react2.default.createElement(
	            'th',
	            null,
	            'Date\xA0Filed',
	            _react2.default.createElement('br', null),
	            'Date\xA0Closed'
	          ),
	          _react2.default.createElement(
	            'th',
	            null,
	            'Disposition'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        data.results.map(function (row, idx) {
	          return _react2.default.createElement(
	            'tr',
	            { key: idx },
	            _react2.default.createElement(
	              'td',
	              null,
	              row.case_title
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              row.ncl_parties.map(function (_ref2, i) {
	                var name = _ref2.name,
	                    role = _ref2.role;
	                return _react2.default.createElement(
	                  'div',
	                  { key: i },
	                  name,
	                  ' (',
	                  role,
	                  ')'
	                );
	              })
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'ir-search-court', title: row.court_name },
	              row.case_court
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'ir-search-no-wrap', title: row.case_title },
	              _react2.default.createElement(
	                'b',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  {
	                    href: '/rpc/legacy/case-menu-redirect/' + row.case_court + '/' + row.case_no,
	                    target: '_blank' },
	                  row.case_no
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              row.chapter
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              row.date_filed || row.date_closed
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              row.disposition
	            )
	          );
	        })
	      )
	    )
	  );
	};
	
	CasesPartyResults.propTypes = {
	  data: _propTypes2.default.any.isRequired
	};
	
	exports.default = CasesPartyResults;

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ResultsPaginator = __webpack_require__(108);
	
	var _ResultsPaginator2 = _interopRequireDefault(_ResultsPaginator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CasesResults = function CasesResults(_ref) {
	  var data = _ref.data,
	      filter = _ref.filter,
	      onSearch = _ref.onSearch;
	  return _react2.default.createElement(
	    'div',
	    { id: 'ir-search-search-premium-results' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Results \u2013 ',
	      data.num_cases,
	      ' cases within ',
	      data.num_found,
	      ' total matches',
	      _react2.default.createElement(
	        'span',
	        { className: 'ir-search-premium-reset' },
	        filter.grouped && _react2.default.createElement(
	          'a',
	          {
	            href: '',
	            className: 'active',
	            onClick: function onClick(e) {
	              e.preventDefault();onSearch(_extends({}, filter, { grouped: false, page: 0 }));
	            }
	          },
	          'Display All Matching Entries'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'table',
	      { className: 'ir-search-table-results sticky-enabled' },
	      _react2.default.createElement(
	        'thead',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            'Case Title'
	          ),
	          _react2.default.createElement(
	            'th',
	            null,
	            'Court'
	          ),
	          _react2.default.createElement(
	            'th',
	            null,
	            'Case No'
	          ),
	          _react2.default.createElement(
	            'th',
	            null,
	            'Chp'
	          ),
	          _react2.default.createElement(
	            'th',
	            null,
	            'Date\xA0Filed',
	            _react2.default.createElement('br', null),
	            'Date\xA0Closed'
	          ),
	          _react2.default.createElement(
	            'th',
	            null,
	            'Matches'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        data.results.map(function (row, idx) {
	          return _react2.default.createElement(
	            'tr',
	            { key: idx },
	            _react2.default.createElement(
	              'td',
	              null,
	              row.case_title
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'ir-search-court', title: row.court_name },
	              row.court
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'ir-search-no-wrap', title: row.case_title },
	              _react2.default.createElement(
	                'b',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  {
	                    href: '/rpc/legacy/case-menu-redirect/' + row.court + '/' + row.case_no,
	                    target: '_blank' },
	                  row.case_no
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              row.chapter
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              row.date_filed || row.date_closed
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              row.inner_hits
	            )
	          );
	        })
	      )
	    ),
	    _react2.default.createElement(_ResultsPaginator2.default, {
	      totalPages: data.page_count,
	      selectedPage: filter.page + 1 || 1,
	      onChangePage: function onChangePage(page) {
	        return onSearch(_extends({}, filter, { page: page }));
	      }
	    })
	  );
	};
	
	CasesResults.propTypes = {
	  data: _propTypes2.default.any.isRequired
	};
	
	exports.default = CasesResults;

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ResultsPaginator = __webpack_require__(108);
	
	var _ResultsPaginator2 = _interopRequireDefault(_ResultsPaginator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PetitionResults = function PetitionResults(_ref) {
	  var data = _ref.data,
	      filter = _ref.filter,
	      onSearch = _ref.onSearch,
	      onGetPetitionPdf = _ref.onGetPetitionPdf;
	
	  var onPetitionClick = function onPetitionClick(event, row) {
	    event.preventDefault();
	    var params = {
	      court_code: row.case_court,
	      case_no: row.case_no
	    };
	    onGetPetitionPdf(params);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { id: 'ir-search-search-premium-results' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Results \u2013 ',
	      data.num_cases,
	      ' ',
	      data.num_cases > 1 ? 'cases' : 'case'
	    ),
	    data.results.map(function (row, idx) {
	      var case_url = '/rpc/legacy/case-menu-redirect/' + row.case_court + '/' + row.case_no;
	
	      return _react2.default.createElement(
	        'div',
	        { key: idx, className: 'result-item result-item-case-extended' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'result-item-header' },
	          row.case_title,
	          ' | ',
	          _react2.default.createElement(
	            'a',
	            { href: case_url, title: 'Go to Case Query Menu', target: '_blank' },
	            row.case_no
	          ),
	          ' | ',
	          row.case_court,
	          ' | ',
	          'Chp. ',
	          row.case_chapter,
	          ' | ',
	          row.date_filed || row.date_closed,
	          ' | ',
	          'Business BK Filings'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'result-item-section result-item-body' },
	          _react2.default.createElement(
	            'span',
	            { className: 'result-case-extended-info' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Assets: '
	            ),
	            row.assets
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'result-case-extended-info' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Liabilities: '
	            ),
	            row.liabilities
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'result-case-extended-info' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Industry: '
	            ),
	            row.industry || 'Unknown'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'result-item-section result-item-case-schedules' },
	          _react2.default.createElement(
	            'a',
	            { href: '#', className: 'schedule-link', onClick: function onClick(e) {
	                return onPetitionClick(e, row);
	              } },
	            'Petition'
	          )
	        )
	      );
	    }),
	    _react2.default.createElement(_ResultsPaginator2.default, {
	      totalPages: data.page_count,
	      selectedPage: filter.page + 1 || 1,
	      onChangePage: function onChangePage(page) {
	        return onSearch(_extends({}, filter, { page: page }));
	      }
	    })
	  );
	};
	
	PetitionResults.propTypes = {
	  data: _propTypes2.default.any.isRequired,
	  filter: _propTypes2.default.any.isRequired,
	  onSearch: _propTypes2.default.func.isRequired,
	  onGetPetitionPdf: _propTypes2.default.func.isRequired
	};
	
	exports.default = PetitionResults;

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _moment = __webpack_require__(32);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _dateFormat = __webpack_require__(94);
	
	var _dateFormat2 = _interopRequireDefault(_dateFormat);
	
	var _ResultsPaginator = __webpack_require__(108);
	
	var _ResultsPaginator2 = _interopRequireDefault(_ResultsPaginator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheduleTypes = {
	  ab: 'Schedule A/B',
	  a: 'Schedule A',
	  b: 'Schedule B',
	  d: 'Schedule D',
	  ef: 'Schedule E/F',
	  e: 'Schedule E',
	  f: 'Schedule F',
	  top20: 'Top Twenty'
	};
	
	var ScheduleResults = function ScheduleResults(_ref) {
	  var data = _ref.data,
	      filter = _ref.filter,
	      onSearch = _ref.onSearch,
	      onGetPetitionPdf = _ref.onGetPetitionPdf;
	
	  var onPetitionClick = function onPetitionClick(event, row) {
	    event.preventDefault();
	    var params = {
	      court_code: row.case_court,
	      case_no: row.case_no
	    };
	    onGetPetitionPdf(params);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { id: 'ir-search-search-premium-results' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Results \u2013 ',
	      data.num_cases,
	      ' ',
	      data.num_cases > 1 ? 'cases' : 'case'
	    ),
	    data.results.map(function (row, idx) {
	      var case_url = '/rpc/legacy/case-menu-redirect/' + row.case_court + '/' + row.case_no;
	      var emailedDate = (0, _lodash.maxBy)(Object.values(row.schedules), function (s) {
	        return s && s.is_new && s.created ? (0, _moment2.default)(s.created) : null;
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { key: idx, className: 'result-item result-item-case-extended' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'result-item-header' },
	          row.case_title,
	          ' | ',
	          _react2.default.createElement(
	            'a',
	            { href: case_url, title: 'Go to Case Query Menu', target: '_blank' },
	            row.case_no
	          ),
	          ' | ',
	          row.case_court,
	          ' | ',
	          'Chp. ',
	          row.case_chapter,
	          ' | ',
	          row.date_filed || row.date_closed,
	          ' | ',
	          'Schedules'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'result-item-section result-item-body' },
	          _react2.default.createElement(
	            'span',
	            { className: 'result-case-extended-info' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Assets: '
	            ),
	            row.assets
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'result-case-extended-info' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Liabilities: '
	            ),
	            row.liabilities
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'result-case-extended-info' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Industry: '
	            ),
	            row.industry || 'Unknown'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'result-item-section result-item-case-schedules' },
	          _react2.default.createElement(
	            'a',
	            { href: '#', className: 'schedule-link', onClick: function onClick(e) {
	                return onPetitionClick(e, row);
	              } },
	            'Petition'
	          ),
	          Object.keys(scheduleTypes).map(function (type) {
	            return !row.schedules[type] ? null : _react2.default.createElement(
	              'a',
	              {
	                href: row.schedules[type].url,
	                className: 'schedule-link ' + (row.schedules[type].is_new ? 'new' : '')
	              },
	              scheduleTypes[type]
	            );
	          }),
	          emailedDate && emailedDate.created && _react2.default.createElement(
	            'span',
	            { className: 'email-date' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Emailed:'
	            ),
	            (0, _dateFormat2.default)(emailedDate.created)
	          )
	        )
	      );
	    }),
	    _react2.default.createElement(_ResultsPaginator2.default, {
	      totalPages: data.page_count,
	      selectedPage: filter.page + 1 || 1,
	      onChangePage: function onChangePage(page) {
	        return onSearch(_extends({}, filter, { page: page }));
	      }
	    })
	  );
	};
	
	ScheduleResults.propTypes = {
	  data: _propTypes2.default.any.isRequired,
	  filter: _propTypes2.default.object.isRequired,
	  onSearch: _propTypes2.default.func.isRequired,
	  onGetPetitionPdf: _propTypes2.default.func.isRequired
	};
	
	exports.default = ScheduleResults;

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AssociatedCasesResultRow = function AssociatedCasesResultRow(_ref) {
	  var row = _ref.row;
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'a',
	      { href: '/filings/search-court-filings?search_type=case_no&search_term=' + row.associated_case.case_no },
	      row.associated_case.case_no
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: row.associated_case.case_name } }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'em',
	      null,
	      '(',
	      row.associated_case.case_type,
	      ')'
	    )
	  );
	};
	
	AssociatedCasesResultRow.propTypes = {
	  row: _propTypes2.default.any.isRequired
	};
	
	exports.default = AssociatedCasesResultRow;

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(198);
	
	var _dateFormat = __webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CaseActivityClaimsRow = function (_Component) {
	  _inherits(CaseActivityClaimsRow, _Component);
	
	  function CaseActivityClaimsRow(props) {
	    _classCallCheck(this, CaseActivityClaimsRow);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.onShowHistory = function () {
	      _this.setState({ showHistory: !_this.state.showHistory });
	    };
	
	    _this.state = { showHistory: false };
	    return _this;
	  }
	
	  CaseActivityClaimsRow.prototype.render = function render() {
	    var _this2 = this;
	
	    var row = this.props.row;
	
	    var creditor = row.creditor.split('\n')[0];
	    var address = row.creditor.replace(creditor, '');
	
	    return _react2.default.createElement(
	      'tbody',
	      null,
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'a',
	            {
	              href: '#',
	              className: 'docket_no in-inforuptcy',
	              onClick: function onClick(e) {
	                e.preventDefault();_this2.onShowHistory();
	              }
	            },
	            row.claim_no
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          row.info && row.info.original_filed_date
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          creditor
	        ),
	        _react2.default.createElement(
	          'td',
	          { style: { textAlign: 'right' } },
	          '$',
	          row.amounts && row.amounts.amount && row.amounts.amount.claimed || '0.00'
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          (0, _dateFormat.formatUnixDate)(row.timestamp)
	        )
	      ),
	      _react2.default.createElement(
	        'tr',
	        { className: 'claim-detail claim', style: { display: this.state.showHistory ? 'table-row' : 'none' } },
	        _react2.default.createElement('td', null),
	        _react2.default.createElement(
	          'td',
	          null,
	          row.info.original_filed_date && _react2.default.createElement(
	            'div',
	            null,
	            'Original Filed Date: ',
	            row.info.original_filed_date
	          ),
	          row.info.last_amendment_filed && _react2.default.createElement(
	            'div',
	            null,
	            'Last Amendment Filed: ',
	            row.info.last_amendment_filed
	          ),
	          row.info.original_entered_date && _react2.default.createElement(
	            'div',
	            null,
	            'Original Entered Date: ',
	            row.info.original_entered_date
	          ),
	          row.info.last_amendment_entered && _react2.default.createElement(
	            'div',
	            null,
	            'Last Amendment Entered: ',
	            row.info.last_amendment_entered
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          { style: { whiteSpace: 'pre-wrap' } },
	          address
	        ),
	        _react2.default.createElement(
	          'td',
	          { style: { textAlign: 'right' } },
	          row.amounts && row.amounts.unknown && _react2.default.createElement(
	            'div',
	            null,
	            'Unknown: ',
	            row.amounts.unknown.claimed
	          ),
	          row.amounts && row.amounts.priority && _react2.default.createElement(
	            'div',
	            null,
	            'Priority: ',
	            row.amounts.priority.claimed
	          ),
	          row.amounts && row.amounts.secured && _react2.default.createElement(
	            'div',
	            null,
	            'Secured allowed: ',
	            row.amounts.secured.claimed
	          ),
	          row.amounts && row.amounts.unsecured && _react2.default.createElement(
	            'div',
	            null,
	            'Unsecured: ',
	            row.amounts.unsecured.claimed
	          ),
	          row.amounts && row.amounts.admin && _react2.default.createElement(
	            'div',
	            null,
	            'Admin: ',
	            row.amounts.admin.claimed
	          )
	        ),
	        _react2.default.createElement('td', null)
	      ),
	      _react2.default.createElement(
	        'tr',
	        { className: 'claim-detail claim', style: { display: this.state.showHistory ? 'table-row' : 'none' } },
	        _react2.default.createElement('td', null),
	        _react2.default.createElement(
	          'td',
	          { colSpan: '4' },
	          _react2.default.createElement(
	            'u',
	            null,
	            'History / Documents'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'table',
	            null,
	            _react2.default.createElement(
	              'tbody',
	              null,
	              row.history.map(function (doc) {
	                return doc.claim_no && _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'view_detail_width' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'view_details' },
	                      _react2.default.createElement(
	                        'strong',
	                        null,
	                        doc.claim_no
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    doc.claim_text
	                  )
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'u',
	            null,
	            'Related Dockets'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'table',
	            null,
	            _react2.default.createElement(
	              'tbody',
	              null,
	              row.history.map(function (doc) {
	                return doc.docket_no && _react2.default.createElement(
	                  'tr',
	                  { key: doc.docket_no },
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'view_detail_width' },
	                    _react2.default.createElement(
	                      'a',
	                      { href: '#', className: 'view_details unknown-purchase-status' },
	                      _react2.default.createElement(
	                        'strong',
	                        null,
	                        doc.docket_no
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    doc.docket_date + ' ' + doc.docket_text
	                  )
	                );
	              })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'tr',
	        { className: 'claim-detail claim', style: { display: this.state.showHistory ? 'table-row' : 'none' } },
	        _react2.default.createElement('td', null),
	        _react2.default.createElement(
	          'td',
	          { colSpan: '4' },
	          _react2.default.createElement(
	            'table',
	            { className: 'borderless-table' },
	            _react2.default.createElement(
	              'tbody',
	              null,
	              row.description && _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  'Description:'
	                ),
	                _react2.default.createElement('td', { width: '100%', dangerouslySetInnerHTML: { __html: row.description } })
	              ),
	              row.remarks && _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  'Remarks:'
	                ),
	                _react2.default.createElement('td', { width: '100%', dangerouslySetInnerHTML: { __html: row.remarks } })
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return CaseActivityClaimsRow;
	}(_react.Component);
	
	CaseActivityClaimsRow.propTypes = {
	  row: _propTypes2.default.any.isRequired
	};
	
	exports.default = CaseActivityClaimsRow;

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _Snippet = __webpack_require__(252);
	
	var _Snippet2 = _interopRequireDefault(_Snippet);
	
	var _DocketEntry = __webpack_require__(170);
	
	var _DocketEntry2 = _interopRequireDefault(_DocketEntry);
	
	var _docketActions = __webpack_require__(42);
	
	var docketActions = _interopRequireWildcard(_docketActions);
	
	__webpack_require__(198);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CaseActivityDocketsRow = function CaseActivityDocketsRow(_ref) {
	  var row = _ref.row,
	      id = _ref.id,
	      getDocuments = _ref.getDocuments,
	      selectedDocket = _ref.selectedDocket;
	
	  var onGetDocuments = function onGetDocuments(docket, court_code, case_number) {
	    getDocuments({
	      docket_no: docket.docket_no,
	      docket_seq: docket.docket_seq,
	      court_code: court_code,
	      case_number: case_number
	    });
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'tbody',
	      null,
	      _react2.default.createElement(_DocketEntry2.default, {
	        id: 'docket-entry-' + id,
	        key: 'docket-entry-' + id,
	        docket: row,
	        redact: {},
	        showRedactPopup: null,
	        case_uuid: '',
	        court_code: row.case_court,
	        case_number: row.case_no,
	        onGetDocuments: onGetDocuments,
	        selectedDocket: selectedDocket
	      })
	    ),
	    row.parts && Object.values(row.parts).map(function (part, idx) {
	      return _react2.default.createElement(_Snippet2.default, { key: idx, part: part });
	    })
	  );
	};
	
	CaseActivityDocketsRow.propTypes = {
	  row: _propTypes2.default.any.isRequired,
	  id: _propTypes2.default.any.isRequired,
	  selectedDocket: _propTypes2.default.any.isRequired,
	  getDocuments: _propTypes2.default.func.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    selectedDocket: state.getIn(['dockets', 'selectedDocket']).toJS()
	  };
	};
	
	var mapDispatchToProps = {
	  getDocuments: docketActions.getDocuments
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CaseActivityDocketsRow);

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _Snippet = __webpack_require__(252);
	
	var _Snippet2 = _interopRequireDefault(_Snippet);
	
	__webpack_require__(198);
	
	var _ClaimsEntry = __webpack_require__(374);
	
	var _ClaimsEntry2 = _interopRequireDefault(_ClaimsEntry);
	
	var _docketActions = __webpack_require__(42);
	
	var docketActions = _interopRequireWildcard(_docketActions);
	
	var _claimDocumentsActions = __webpack_require__(725);
	
	var claimDocumentsActions = _interopRequireWildcard(_claimDocumentsActions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClaimsResultRow = function ClaimsResultRow(_ref) {
	  var row = _ref.row,
	      id = _ref.id,
	      getDocuments = _ref.getDocuments,
	      selectedDocket = _ref.selectedDocket,
	      getClaimsDocuments = _ref.getClaimsDocuments,
	      selectedClaim = _ref.selectedClaim;
	
	  var onGetDocketDocuments = function onGetDocketDocuments(docket, court_code, case_number) {
	    getDocuments({
	      docket_no: docket.docket_no,
	      docket_seq: docket.docket_seq,
	      court_code: court_code,
	      case_number: case_number
	    });
	  };
	
	  var onGetClaimsDocuments = function onGetClaimsDocuments(claimNum, seqNum, court_code, case_number) {
	    getClaimsDocuments({
	      claimNum: claimNum,
	      seqNum: seqNum,
	      court_code: court_code,
	      case_number: case_number
	    });
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'table',
	      null,
	      _react2.default.createElement(
	        'tbody',
	        null,
	        _react2.default.createElement(_ClaimsEntry2.default, {
	          id: id,
	          claim: row,
	          selectedDocket: selectedDocket,
	          onGetDocuments: onGetDocketDocuments,
	          selectedClaim: selectedClaim,
	          onGetClaimsDocuments: onGetClaimsDocuments
	        })
	      )
	    ),
	    row.parts && Object.values(row.parts).map(function (part, idx) {
	      return _react2.default.createElement(_Snippet2.default, { key: idx, part: part });
	    })
	  );
	};
	
	ClaimsResultRow.propTypes = {
	  row: _propTypes2.default.any.isRequired,
	  id: _propTypes2.default.number.isRequired,
	  selectedDocket: _propTypes2.default.any.isRequired,
	  getDocuments: _propTypes2.default.func.isRequired,
	  selectedClaim: _propTypes2.default.any.isRequired,
	  getClaimsDocuments: _propTypes2.default.func.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    selectedDocket: state.getIn(['dockets', 'selectedDocket']).toJS(),
	    selectedClaim: state.getIn(['claimDocuments', 'selectedClaim']).toJS()
	  };
	};
	
	var mapDispatchToProps = {
	  getDocuments: docketActions.getDocuments,
	  getClaimsDocuments: claimDocumentsActions.getDocuments
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ClaimsResultRow);

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _Snippet = __webpack_require__(252);
	
	var _Snippet2 = _interopRequireDefault(_Snippet);
	
	var _DocketEntry = __webpack_require__(170);
	
	var _DocketEntry2 = _interopRequireDefault(_DocketEntry);
	
	var _docketActions = __webpack_require__(42);
	
	var docketActions = _interopRequireWildcard(_docketActions);
	
	__webpack_require__(198);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DocketsResultRow = function DocketsResultRow(_ref) {
	  var row = _ref.row,
	      id = _ref.id,
	      getDocuments = _ref.getDocuments,
	      selectedDocket = _ref.selectedDocket;
	
	  var onGetDocuments = function onGetDocuments(docket, court_code, case_number) {
	    getDocuments({
	      docket_no: docket.docket_no,
	      docket_seq: docket.docket_seq,
	      court_code: court_code,
	      case_number: case_number
	    });
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'table',
	      { className: 'ir-search-table-results sticky-enabled docket' },
	      _react2.default.createElement(
	        'tbody',
	        null,
	        _react2.default.createElement(_DocketEntry2.default, {
	          id: 'docket-entry-' + id,
	          key: 'docket-entry-' + id,
	          docket: row,
	          redact: {},
	          showRedactPopup: null,
	          case_uuid: '',
	          court_code: row.case_court,
	          case_number: row.case_no,
	          onGetDocuments: onGetDocuments,
	          selectedDocket: selectedDocket
	        })
	      )
	    ),
	    row.parts && Object.values(row.parts).map(function (part, idx) {
	      return _react2.default.createElement(_Snippet2.default, { key: idx, part: part });
	    })
	  );
	};
	
	DocketsResultRow.propTypes = {
	  row: _propTypes2.default.any.isRequired,
	  id: _propTypes2.default.any.isRequired,
	  selectedDocket: _propTypes2.default.any.isRequired,
	  getDocuments: _propTypes2.default.func.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    selectedDocket: state.getIn(['dockets', 'selectedDocket']).toJS()
	  };
	};
	
	var mapDispatchToProps = {
	  getDocuments: docketActions.getDocuments
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DocketsResultRow);

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _HistoryEntry = __webpack_require__(397);
	
	var _HistoryEntry2 = _interopRequireDefault(_HistoryEntry);
	
	var _docketActions = __webpack_require__(42);
	
	var docketActions = _interopRequireWildcard(_docketActions);
	
	__webpack_require__(198);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventsResultRow = function EventsResultRow(_ref) {
	  var row = _ref.row,
	      id = _ref.id,
	      getDocuments = _ref.getDocuments,
	      selectedDocket = _ref.selectedDocket;
	
	  var onGetDocuments = function onGetDocuments(docket, court_code, case_number) {
	    getDocuments({
	      docket_no: docket.docket_no,
	      docket_seq: docket.docket_seq,
	      court_code: court_code,
	      case_number: case_number
	    });
	  };
	
	  return _react2.default.createElement(
	    'table',
	    { className: 'ir-search-table-results sticky-enabled docket' },
	    _react2.default.createElement(
	      'tbody',
	      null,
	      _react2.default.createElement(_HistoryEntry2.default, {
	        id: 'docket-entry-' + id,
	        key: 'docket-entry-' + id,
	        docket: row,
	        redact: {},
	        showRedactPopup: function showRedactPopup() {},
	        case_uuid: '',
	        court_code: row.case_court,
	        case_number: row.case_no,
	        onGetDocuments: onGetDocuments,
	        selectedDocket: selectedDocket
	      })
	    )
	  );
	};
	
	EventsResultRow.propTypes = {
	  row: _propTypes2.default.any.isRequired,
	  id: _propTypes2.default.any.isRequired,
	  selectedDocket: _propTypes2.default.any.isRequired,
	  getDocuments: _propTypes2.default.func.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    selectedDocket: state.getIn(['dockets', 'selectedDocket']).toJS()
	  };
	};
	
	var mapDispatchToProps = {
	  getDocuments: docketActions.getDocuments
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EventsResultRow);

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PartiesResultRow = function PartiesResultRow(_ref) {
	  var row = _ref.row;
	  return _react2.default.createElement(
	    'table',
	    { className: 'ir-search-table-results sticky-enabled' },
	    _react2.default.createElement(
	      'tbody',
	      null,
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement('span', { className: 'address-name', dangerouslySetInnerHTML: { __html: row.party.name } }),
	          row.party.address && _react2.default.createElement(
	            'span',
	            { style: { whiteSpace: 'pre-wrap' } },
	            _react2.default.createElement('br', null),
	            row.party.address
	          ),
	          row.party.phone && _react2.default.createElement(
	            'div',
	            null,
	            't: ',
	            row.party.phone
	          ),
	          row.party.fax && _react2.default.createElement(
	            'div',
	            null,
	            'f: ',
	            row.party.fax
	          ),
	          row.party.email && _react2.default.createElement(
	            'div',
	            null,
	            row.party.email
	          ),
	          row.party.role && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'em',
	              null,
	              '(',
	              row.party.role,
	              ')'
	            )
	          ),
	          row.party.added_date && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'em',
	              null,
	              'Added: ',
	              row.party.added_date
	            )
	          )
	        ),
	        row.associated && row.associated.length > 0 && _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _react2.default.createElement(
	            'td',
	            null,
	            'representing'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            row.associated.map(function (associated, idx) {
	              return _react2.default.createElement(
	                'p',
	                { key: idx },
	                _react2.default.createElement('span', { className: 'address-name', dangerouslySetInnerHTML: { __html: associated.name } }),
	                associated.address && _react2.default.createElement(
	                  'span',
	                  { style: { whiteSpace: 'pre-wrap' } },
	                  _react2.default.createElement('br', null),
	                  associated.address
	                ),
	                associated.phone && _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement('br', null),
	                  't: ',
	                  associated.phone
	                ),
	                associated.fax && _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement('br', null),
	                  'f: ',
	                  associated.fax
	                ),
	                associated.email && _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement('br', null),
	                  associated.email
	                ),
	                associated.lead && _react2.default.createElement(
	                  'em',
	                  null,
	                  _react2.default.createElement('br', null),
	                  '(',
	                  associated.lead,
	                  ')'
	                )
	              );
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	PartiesResultRow.propTypes = {
	  row: _propTypes2.default.any.isRequired
	};
	
	exports.default = PartiesResultRow;

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScheduleResultRow = function ScheduleResultRow(_ref) {
	  var row = _ref.row;
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    row.event_name + ' (doc: ' + row.doc_no + ')',
	    row.date_filed && _react2.default.createElement(
	      'div',
	      null,
	      'Event Filed: ',
	      row.date_filed
	    ),
	    row.date_due_set && _react2.default.createElement(
	      'div',
	      null,
	      'Due / Set: ',
	      row.date_due_set
	    ),
	    row.date_satisfied && _react2.default.createElement(
	      'div',
	      null,
	      'Satisfied: ',
	      row.date_satisfied
	    ),
	    row.date_terminated && _react2.default.createElement(
	      'div',
	      null,
	      'Terminated: ',
	      row.date_terminated
	    ),
	    row.hearing_judge && _react2.default.createElement(
	      'div',
	      null,
	      'Hearing Judge: ',
	      row.hearing_judge
	    )
	  );
	};
	
	ScheduleResultRow.propTypes = {
	  row: _propTypes2.default.any.isRequired
	};
	
	exports.default = ScheduleResultRow;

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StatusResultRow = function StatusResultRow(_ref) {
	  var row = _ref.row;
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    row.status + ' (#: ' + row.docket_no + ')',
	    row.status_set_by && _react2.default.createElement(
	      'div',
	      null,
	      'Set By: ',
	      row.status_set_by
	    ),
	    row.date_status_begin && _react2.default.createElement(
	      'div',
	      null,
	      'Begin Date: ',
	      row.date_status_begin
	    ),
	    row.time_in_status && _react2.default.createElement(
	      'div',
	      null,
	      'Time in Status: ',
	      row.time_in_status
	    )
	  );
	};
	
	StatusResultRow.propTypes = {
	  row: _propTypes2.default.any.isRequired
	};
	
	exports.default = StatusResultRow;

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TransactionsResultRow = function TransactionsResultRow(_ref) {
	  var row = _ref.row;
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    row.event_name + ' (doc: ' + row.docket_no + ')',
	    row.date_event_filed && _react2.default.createElement(
	      'div',
	      null,
	      'Event Filed: ',
	      row.date_event_filed
	    )
	  );
	};
	
	TransactionsResultRow.propTypes = {
	  row: _propTypes2.default.any.isRequired
	};
	
	exports.default = TransactionsResultRow;

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _AllCasesView = __webpack_require__(368);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Case Menu/All Cases', module).add('Showing All', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      ' All Cases view wth data '
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_AllCasesView.AllCasesView, {
	      cases: allData,
	      case_uuid: ''
	    })
	  );
	}).add('Showing Only Associate', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      ' All Cases view wth data '
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_AllCasesView.AllCasesView, {
	      cases: associateData,
	      case_uuid: ''
	    })
	  );
	}).add('Showing Only Related', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      ' All Cases view wth data '
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_AllCasesView.AllCasesView, {
	      cases: relatedData,
	      case_uuid: ''
	    })
	  );
	}).add('Showing Only Other Filings', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      ' All Cases view wth data '
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_AllCasesView.AllCasesView, {
	      cases: otherData,
	      case_uuid: ''
	    })
	  );
	}).add('Showing Only Associate and Others', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      ' All Cases view wth data '
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_AllCasesView.AllCasesView, {
	      cases: associateOtherData,
	      case_uuid: ''
	    })
	  );
	}).add('Showing Only Associate and Related', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      ' All Cases view wth data '
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_AllCasesView.AllCasesView, {
	      cases: associateRelatedData,
	      case_uuid: ''
	    })
	  );
	}).add('Showing Only Related and Others', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      ' All Cases view wth data '
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_AllCasesView.AllCasesView, {
	      cases: relatedOtherData,
	      case_uuid: ''
	    })
	  );
	}).add('No data', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      ' All Cases with no data'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_AllCasesView.AllCasesView, {
	      cases: allEmpty1,
	      case_uuid: ''
	    })
	  );
	}).add('Data with Empty keys', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'All Cases Empty messages'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_AllCasesView.AllCasesView, {
	      cases: allEmpty2,
	      case_uuid: ''
	    })
	  );
	});
	
	var associatedCases = {
	  data: {
	    associated_cases: [{
	      associated_case: {
	        case_code: '05-06235-fra',
	        case_id: '190584',
	        case_name: 'Sticka v. Allied Building Products Corp',
	        case_type: 'Adversary',
	        case_uri: 'https://ecf.orb.uscourts.gov/cgi-bin/DktRpt.pl?190584',
	        case_uuid: 'orbke_190584'
	      },
	      case: {
	        case_code: '04-63199-fra7',
	        case_id: '154519',
	        case_name: 'A & B Davis, Inc',
	        case_title: 'A & B Davis, Inc',
	        case_uri: 'https://ecf.orb.uscourts.gov/cgi-bin/DktRpt.pl?154519',
	        case_uuid: 'orbke_154519',
	        end_date: null
	      }
	    }, {
	      associated_case: {
	        case_code: '05-06244-fra',
	        case_id: '191104',
	        case_name: 'Sticka v. Custom Bilt Metals Inc.',
	        case_type: 'Adversary',
	        case_uri: 'https://ecf.orb.uscourts.gov/cgi-bin/DktRpt.pl?191104',
	        case_uuid: 'orbke_191104'
	      },
	      case: {
	        case_code: '04-63199-fra7',
	        case_id: '154519',
	        case_name: 'A & B Davis, Inc',
	        case_title: 'A & B Davis, Inc',
	        case_uri: 'https://ecf.orb.uscourts.gov/cgi-bin/DktRpt.pl?154519',
	        case_uuid: 'orbke_154519',
	        end_date: null
	      }
	    }]
	  }
	};
	
	var associatedCasesEmpty = {
	  data: {
	    associated_cases: {
	      empty: 'There are no associateds cases. '
	    }
	  }
	};
	
	var relatedCasesData = {
	  data: {
	    related_cases_district: [{
	      case_uuid: 'nyebke_42023-111',
	      case_title: 'S.E.C. v. Walsh',
	      case_no: '1:02-cv-09921',
	      end_date: '05/24/2005',
	      start_date: '05/24/2004'
	    }, {
	      case_uuid: 'nyebke_283201',
	      case_title: 'Securities and Exchange Commission v. Tyco International Ltd.',
	      case_no: '1:06-cv-02942',
	      end_date: '',
	      start_date: '07/20/2004'
	    }, {
	      case_uuid: 'nyebke_296957',
	      case_title: 'United States Securities and Exchange Commission v. Power et al',
	      case_no: '1:06-cv-15343',
	      end_date: '',
	      start_date: '09/29/2004'
	    }]
	  }
	};
	
	var relatedCasesEmpty = {
	  data: {
	    related_cases_district: {
	      empty: 'There are no related cases.'
	    }
	  }
	};
	
	var otherFilings = {
	  data: {
	    other_filings: [{
	      case: {
	        case_code: '15-32192-rld7',
	        case_id: '465340',
	        case_name: 'Jamie Lynn Smith and Billy Ruben Smith',
	        case_uri: 'https://ecf.orb.uscourts.gov/cgi-bin/DktRpt.pl?465340',
	        case_uuid: 'orbke_465340'
	      },
	      debtor: {
	        name: 'Billy Ruben Smith'
	      }
	    }, {
	      case: {
	        case_code: '15-32192-rld7',
	        case_id: '465340',
	        case_name: 'Jamie Lynn Smith and Billy Ruben Smith',
	        case_title: 'Jamie Lynn Smith and Billy Ruben Smith',
	        case_uri: 'https://ecf.orb.uscourts.gov/cgi-bin/DktRpt.pl?465340',
	        case_uuid: 'orbke_465340'
	      },
	      debtor: {
	        name: 'Jamie Lynn Smith'
	      }
	    }]
	  }
	};
	
	var otherFilingsEmpty = {
	  data: {
	    other_filings: {
	      empty: 'There Are No Case Filing Associations For This Case. '
	    }
	  }
	};
	
	var allData = [['associated_cases', associatedCases.data.associated_cases], ['related_cases_district', relatedCasesData.data.related_cases_district], ['other_filings', otherFilings.data.other_filings]];
	
	var associateData = [['associated_cases', associatedCases.data.associated_cases], [], []];
	
	var relatedData = [[], ['related_cases_district', relatedCasesData.data.related_cases_district], []];
	
	var otherData = [[], [], ['other_filings', otherFilings.data.other_filings]];
	
	var associateOtherData = [['associated_cases', associatedCases.data.associated_cases], [], ['other_filings', otherFilings.data.other_filings]];
	
	var associateRelatedData = [['associated_cases', associatedCases.data.associated_cases], ['related_cases_district', relatedCasesData.data.related_cases_district], []];
	
	var relatedOtherData = [[], ['related_cases_district', relatedCasesData.data.related_cases_district], ['other_filings', otherFilings.data.other_filings]];
	
	var allEmpty1 = [[], [], []];
	
	var allEmpty2 = [['associated_cases', associatedCasesEmpty.data.associated_cases], ['related_cases_district', relatedCasesEmpty.data.related_cases_district], ['other_filings', otherFilingsEmpty.data.other_filings]];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _addonLinks = __webpack_require__(168);
	
	var _demo = __webpack_require__(246);
	
	var _AssociatedCasesView = __webpack_require__(369);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Case Menu/Associated Cases', module).add('Showing', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      ' Associated Cases view wth data '
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_AssociatedCasesView.AssociatedCasesView, {
	      associatedCases: associatedCases.data.associated_cases
	    })
	  );
	}).add('Empty', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      ' Associated Cases Empty'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_AssociatedCasesView.AssociatedCasesView, {
	      associatedCases: associatedCasesEmpty.data.associated_cases
	    })
	  );
	});
	
	var associatedCases = {
	  data: {
	    associated_cases: [{
	      associated_case: {
	        case_code: "05-06235-fra",
	        case_id: "190584",
	        case_name: "Sticka v. Allied Building Products Corp",
	        case_type: "Adversary",
	        case_uri: "https://ecf.orb.uscourts.gov/cgi-bin/DktRpt.pl?190584",
	        case_uuid: "orbke_190584"
	      },
	      case: {
	        case_code: "04-63199-fra7",
	        case_id: "154519",
	        case_name: "A & B Davis, Inc",
	        case_title: "A & B Davis, Inc",
	        case_uri: "https://ecf.orb.uscourts.gov/cgi-bin/DktRpt.pl?154519",
	        case_uuid: "orbke_154519",
	        date_closed: null
	      }
	    }, {
	      associated_case: {
	        case_code: "05-06244-fra",
	        case_id: "191104",
	        case_name: "Sticka v. Custom Bilt Metals Inc.",
	        case_type: "Adversary",
	        case_uri: "https://ecf.orb.uscourts.gov/cgi-bin/DktRpt.pl?191104",
	        case_uuid: "orbke_191104"
	      },
	      case: {
	        case_code: "04-63199-fra7",
	        case_id: "154519",
	        case_name: "A & B Davis, Inc",
	        case_title: "A & B Davis, Inc",
	        case_uri: "https://ecf.orb.uscourts.gov/cgi-bin/DktRpt.pl?154519",
	        case_uuid: "orbke_154519",
	        date_closed: null
	      }
	    }]
	  }
	};
	
	var associatedCasesEmpty = {
	  data: {
	    associated_cases: {
	      'empty': "There are no associateds cases. "
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _OtherCourtInfo = __webpack_require__(370);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Case Menu/Other Court Information', module).add('Showing', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_OtherCourtInfo.OtherCourtInfo, {
	      otherCourtInfo: otherCourtInfoData.data
	    })
	  );
	}).add('Empty', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      ' Other Court Information Empty'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_OtherCourtInfo.OtherCourtInfo, {
	      otherCourtInfo: otherCourtInfoEmpty.data
	    })
	  );
	});
	
	var otherCourtInfoData = {
	  data: {
	    html: '<B>Other Court Information</B><P><TABLE border=1><TR><TH>Court Name</TH><TH>Case Number</TH><TH>Start Date</TH><TH>End Date</TH></TR><TR><TD>Johnson County District Court</TD><TD>16CV01866</TD><TD>04/21/2016</TD><TD></TD></TR></TABLE>'
	  }
	};
	
	var otherCourtInfoEmpty = {
	  data: {
	    empty: 'There are no related info.'
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _addonLinks = __webpack_require__(168);
	
	var _demo = __webpack_require__(246);
	
	var _OtherFilings = __webpack_require__(371);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Case Menu/Other Filings', module).add('Showing', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      ' Other Filings view wth data '
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_OtherFilings.OtherFilings, {
	      otherFilings: otherFilings.data.other_filings
	    })
	  );
	}).add('Empty', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      ' Other FilingsCases Empty'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_OtherFilings.OtherFilings, {
	      otherFilings: otherFilingsEmpty.data.other_filings
	    })
	  );
	});
	
	var otherFilings = {
	  data: {
	    other_filings: [{
	      case: {
	        case_code: "15-32192-rld7",
	        case_id: "465340",
	        case_name: "Jamie Lynn Smith and Billy Ruben Smith",
	        case_uri: "https://ecf.orb.uscourts.gov/cgi-bin/DktRpt.pl?465340",
	        case_uuid: "orbke_465340"
	      },
	      debtor: {
	        name: "Billy Ruben Smith"
	      }
	    }, {
	      case: {
	        case_code: "15-32192-rld7",
	        case_id: "465340",
	        case_name: "Jamie Lynn Smith and Billy Ruben Smith",
	        case_title: "Jamie Lynn Smith and Billy Ruben Smith",
	        case_uri: "https://ecf.orb.uscourts.gov/cgi-bin/DktRpt.pl?465340",
	        case_uuid: "orbke_465340"
	      },
	      debtor: {
	        name: "Jamie Lynn Smith"
	      }
	    }]
	  }
	};
	
	var otherFilingsEmpty = {
	  data: {
	    other_filings: {
	      'empty': "There Are No Case Filing Associations For This Case. "
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _addonLinks = __webpack_require__(168);
	
	var _demo = __webpack_require__(246);
	
	var _RelatedCases = __webpack_require__(372);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Case Menu/Related Cases', module).add('Showing', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      ' Related Cases Component showing some data'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_RelatedCases.RelatedCases, {
	      relatedCases: relatedCasesData.data.related_cases_district
	    })
	  );
	}).add('Empty', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      ' Related Cases Empty'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_RelatedCases.RelatedCases, {
	      relatedCases: relatedCasesEmpty.data.related_cases_district
	    })
	  );
	});
	
	var relatedCasesData = {
	  data: {
	    related_cases_district: [{
	      "case_uuid": "nyebke_42023-111",
	      "case_title": "S.E.C. v. Walsh",
	      'case_no': '1:02-cv-09921',
	      "end_date": '05/24/2005',
	      "start_date": "05/24/2004"
	    }, {
	      "case_uuid": "nyebke_283201",
	      "case_title": "Securities and Exchange Commission v. Tyco International Ltd.",
	      'case_no': '1:06-cv-02942',
	      "end_date": '',
	      "start_date": "07/20/2004"
	    }, {
	      "case_uuid": "nyebke_296957",
	      "case_title": "United States Securities and Exchange Commission v. Power et al",
	      'case_no': '1:06-cv-15343',
	      "end_date": '',
	      "start_date": "09/29/2004"
	    }]
	  }
	};
	
	var relatedCasesEmpty = {
	  data: {
	    related_cases_district: {
	      'empty': "There are no related cases."
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AlertError = __webpack_require__(50);
	
	var _AlertError2 = _interopRequireDefault(_AlertError);
	
	var _Popup = __webpack_require__(69);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClientCodeDialogView = function (_Component) {
	  _inherits(ClientCodeDialogView, _Component);
	
	  function ClientCodeDialogView() {
	    _classCallCheck(this, ClientCodeDialogView);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ClientCodeDialogView.prototype.render = function render() {
	    if (this.props.dialog_opened) {
	      return _react2.default.createElement(
	        _Popup2.default,
	        { show: true,
	          clsName: 'clientcode-dialog',
	          topBarTitle: 'Reminder!',
	          onClose: this.props.onClose },
	        _react2.default.createElement(
	          'div',
	          { className: 'error-text' },
	          this.props.popupErrors.messages
	        )
	      );
	    }
	    return null;
	  };
	
	  return ClientCodeDialogView;
	}(_react.Component);
	
	ClientCodeDialogView.propTypes = {
	  popupErrors: _propTypes2.default.any.isRequired,
	  onClose: _propTypes2.default.func.isRequired
	};
	
	exports.default = ClientCodeDialogView;

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _CreditorMailing = __webpack_require__(379);
	
	var _CreditorMailing2 = _interopRequireDefault(_CreditorMailing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emptyProps = {
	  case_uuid: 'azbtest_2644',
	  purchase_right_away: false,
	  creditor_mailing: {},
	  dataReady: true,
	  dispatch: null,
	  lastUpdated: 1000,
	  error: null,
	  receipt: null
	};
	
	var pdfDocumentCreditorMailingesProps = {
	  case_uuid: 'azbtest_2644',
	  dataReady: true,
	  receipt: null,
	  lastUpdated: 1000,
	  error: null,
	  creditor_mailing: {
	    meta: {
	      case_uuid: 'azbtest_2644',
	      csv: { title: 'Buy Raw Data' },
	      pdf: {
	        friendly_name: 'Bankr.D.Ariz.TEST_2-07-bk-00012_creditor_matrix.pdf',
	        timestamp: 1548766827.20697,
	        link: 'http://aws-s3.inforuptcy.dev.azk.io/inforuptcy-storage/pacer/azbtest/2644/creditor_mailing/pdf-D9081DB4-23C5-11E9-9E16-881D5B15AC09?response-content-disposition=attachment%3B+filename%3DBankr.D.Ariz.TEST_2-07-bk-00012_creditor_matrix.pdf&AWSAccessKeyId=proxy_dummy_key&Expires=1864386051&Signature=Mzh8i7OqbncdVTcw9snJF64oITg%3D',
	        title: 'Buy 3 Column Format'
	      },
	      timestamp: 1548767636.12717
	    },
	    text: null
	  },
	  dispatch: function dispatch() {
	    return (0, _addonActions.action)('dispatch');
	  },
	  purchaseData: function purchaseData() {
	    return (0, _addonActions.action)('purchaseData');
	  }
	};
	
	var csvDocumentCreditorMailingesProps = {
	  case_uuid: 'azbtest_2644',
	  dataReady: true,
	  receipt: null,
	  lastUpdated: 1000,
	  error: null,
	  creditor_mailing: {
	    meta: {
	      case_uuid: 'azbtest_2644',
	      csv: {
	        friendly_name: 'Bankr.D.Ariz.TEST_2-07-bk-00012_creditor_matrix.csv',
	        timestamp: 1548767636.12717,
	        link: 'http://aws-s3.inforuptcy.dev.azk.io/inforuptcy-storage/pacer/azbtest/2644/creditor_mailing/csv-BB616C1E-23C7-11E9-9E16-881D5B15AC09?response-content-disposition=attachment%3B+filename%3DBankr.D.Ariz.TEST_2-07-bk-00012_creditor_matrix.csv&AWSAccessKeyId=proxy_dummy_key&Expires=1864386887&Signature=BP5pPLPCOzl0Bgi%2FVKtWCDUovdw%3D',
	        title: 'Buy Raw Data'
	      },
	      pdf: {
	        title: 'Buy 3 Column Format'
	      }
	    },
	    text: '2:07-bk-00012-BMW,FIRST TIME MORTGAGE ,4545 N NORTHERN AVE,"PHOENIX, AZ 85112 ",,,,\n    2:07-bk-00012-BMW,"U.S. Bankruptcy Court, Arizona","230 North First Avenue, Suite 101","Phoenix, AZ 85003-1727", ,,,\n    2:07-bk-00012-BMW,ABC BANK ,123 N. CENTRAL AVE.,"PHOENIX, AZ 85001", ,,,\n    2:07-bk-00012-BMW,AMERICAN EXPRESS ,P.O. BOX 3024,MALVERN PA 19355-0701, ,,,\n    2:07-bk-00012-BMW,AMEX ,P.O. BOX 7871,FORT LAUDERDALE FL 33329, ,,,\n    2:07-bk-00012-BMW,BENEFICIAL/HFC ,2700 SANDERS RD,PROSPECT HEIGHTS IL 60070, ,,,\n    2:07-bk-00012-BMW,Bloomingdales ,PO Box 8745,New York NY 10012-8745, ,,,\n    2:07-bk-00012-BMW,CHASE CHASE BANK ,P.O. BOX 52195,PHOENIX AZ 85072-2195, ,,,\n    2:07-bk-00012-BMW,CITICORP TRUST BANK ,1190 WINTERSON ROAD ST.,LINTHICUM HEIGHTS MD 21090, ,,,\n    2:07-bk-00012-BMW,CROSS COUNTRY BANK ,P.O. BOX 222222,HUNTINGTON WV 25770, ,,,\n    2:07-bk-00012-BMW,Carr & Masterson Fine Jewelry ,908 North Michigan Ave.,Chicago IL 60669, ,,,\n    2:07-bk-00012-BMW,Chase Bank ,1900 Central St.,Evanston IL 60201, ,,,\n    2:07-bk-00012-BMW,Citibank VISA ,PO Box 198,Sioux Falls SD 57188-1234, ,,,\n    2:07-bk-00012-BMW,DILLARD NATIONAL BANK ,PO BOX 52005,PHOENIX AZ 85072, ,,,\n    2:07-bk-00012-BMW,DIRECT MERCHANTS BANK ,P.O. BOX 60142,CITY OF INDUSTRY CA 91716-0142, ,,,\n    2:07-bk-00012-BMW,DISCOVER CARD ,P.O. BOX 30395,SALT LAKE CITY UT 84130, ,,,\n    2:07-bk-00012-BMW,Davis Department Store ,PO Box 909,Portland OR 87655, ,,,\n    2:07-bk-00012-BMW,Debbie&#039;s Catering ,121 Augusta Lane,Suite 8,Park Ridge IL 60356, ,,\n    2:07-bk-00012-BMW,Don&#039;s Lawns ,1340 Green Bay Road,Suite 963,Kenosha WI 67896, ,,\n    2:07-bk-00012-BMW,First City Bank ,560 North Michigan Avenue,Chicago IL 60604, ,,,\n    2:07-bk-00012-BMW,GMAC Finance ,1700 Greenbay Road,Wilmette IL 63221, ,,,\n    2:07-bk-00012-BMW,Honda Finance ,1323 Santa Vista,Orosi CA 93647, ,,,\n    2:07-bk-00012-BMW,IRS ,230 S. Dearborn St.,Chicago IL 60604, ,,,\n    2:07-bk-00012-BMW,Jan and Elwood Smith , ,,,,,\n    2:07-bk-00012-BMW,Minor Child ,143 W Arthur Blvd.,Chicago IL 60657, ,,,\n    2:07-bk-00012-BMW,SUE TEST ,345 N. 1ST ST.,"PHOENIX, AZ 85003", ,,,\n    2:07-bk-00012-BMW,Sallie Mae Servicing ,P.O. Box 9532,Wilkes Barre PA 18773-9532, ,,,\n    2:07-bk-00012-BMW,U.S. Trustee&#039;s Office ,"230 N. First Avenue, Suite 204","Phoenix, AZ 85003 ",,,,\n    2:07-bk-00012-BMW,JAMES J. GENTILE ,"JAMES J. GENTILE, PC","5355 W. CHANDLER BLVD., &#035;7","CHANDLER, AZ 85226 ",,,\n    2:07-bk-00012-BMW,Joseph Wayne Sample ,PO BOX 123,"CHANDLER, AZ 85226 ",,,,n\n    2:07-bk-00012-BMW,Sarah Lynn Sample ,PO BOX 123,"CHICAGO, IL 60605-0123 ",,,,\n    2:07-bk-00012-BMW,Sue Test ,"Sue&#039;s Law Firm, PC","333 N. 3rd St, &#035;100","Phoenix, AZ 85000 ",,,'
	  },
	  dispatch: function dispatch() {
	    return (0, _addonActions.action)('dispatch');
	  },
	  purchaseData: function purchaseData() {
	    return (0, _addonActions.action)('purchaseData');
	  }
	};
	
	(0, _react3.storiesOf)('Case Menu/CreditorMailing', module).add('Loading', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Component can be in a loading state while we fetch data'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_CreditorMailing2.default, null)
	  );
	}).add('View', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'By default, buttons for buy pdf and csv formats '
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'On click \'Buy 3 Column Format\' pacer is contacted for purchase of pdf format.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'On click \'Buy Raw Data\' pacer is contacted for purchase of csv format.'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_CreditorMailing2.default, _extends({}, emptyProps, {
	      purchaseData: (0, _addonActions.action)('purchaseData')
	    }))
	  );
	}).add('Buy 3 Column Format', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Buy 3 Column Format - pdf format of the document '
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Document can be updated by pressing the \'Buy 3 Column Format\' button on the left side.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Right side has updated date and download link with icons for pdf.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Updated date has date of an update and amount of time passed from the update.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Bottom of the page contains textarea with Raw Data ready to be copied.'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_CreditorMailing2.default, _extends({}, pdfDocumentCreditorMailingesProps, {
	      purchaseData: (0, _addonActions.action)('purchaseData')
	    }))
	  );
	}).add('Buy Raw Data', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Buy Raw Data - csv format of the document '
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Document can be updated by pressing the \'Buy Raw Data\' button on the left side.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Right side has updated date and download link with icons for csv.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Updated date has date of an update and amount of time passed from the update.'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_CreditorMailing2.default, _extends({}, csvDocumentCreditorMailingesProps, {
	      purchaseData: (0, _addonActions.action)('purchaseData')
	    }))
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _DeadlineCases = __webpack_require__(253);
	
	var _DeadlineCases2 = _interopRequireDefault(_DeadlineCases);
	
	var _deadlineArray = __webpack_require__(654);
	
	var _deadlineArray2 = _interopRequireDefault(_deadlineArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emptyProps = {
	  case_uuid: 'azbtest_2644',
	  purchase_right_away: false,
	  deadlines: [],
	  noDataFoundMessage: 'There are no Deadline/Hearing events for this case.',
	  dataReady: true,
	  dispatch: null,
	  lastUpdated: 1000,
	  error: null,
	  receipt: null
	};
	
	var sampleDeadlinesProps = {
	  case_uuid: 'azbtest_2644',
	  dataReady: true,
	  receipt: null,
	  lastUpdated: 1000,
	  error: null,
	  deadlines: _deadlineArray2.default,
	  dispatch: function dispatch() {
	    return (0, _addonActions.action)('dispatch');
	  },
	  purchaseData: function purchaseData() {
	    return (0, _addonActions.action)('purchaseData');
	  },
	  type: 'schedule',
	  sidebarData: {},
	  kloudless: {}
	};
	
	(0, _react3.storiesOf)('Case Menu/Deadlines', module).add('Loading', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Component can be in a loading state while we fetch data'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_DeadlineCases2.default, null)
	  );
	}).add('View', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'By default, we show a list of deadlines/schedules received form the API'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Page contains \'Find What\' input that searches through table of data.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'There is \'Premium Search\' button, which leads to the premium search url.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'We can refresh list by clicking the \'Update from Pacer\' button'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_DeadlineCases2.default, _extends({}, sampleDeadlinesProps, {
	      purchaseData: (0, _addonActions.action)('purchaseData')
	    }))
	  );
	}).add('No Data', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'If there is no data found, message is displayed.'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'We can refresh list by clicking the \'Update from Pacer\' button'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_DeadlineCases2.default, emptyProps)
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 654 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = [{
	  date_event_filed: '01/27/2012',
	  date_terminated: null,
	  modified: '2018-07-11 10:33:07.273226+00',
	  event_name: 'Preliminary Hearing',
	  hearing_judge: 'Marlar, James M.',
	  date_due_set: '05/02/2012',
	  doc_uri: 'https://ecf-test.azb.uscourts.gov/doc2/024075940',
	  doc_no: '48',
	  date_satisfied: null
	}, {
	  doc_no: '49',
	  date_satisfied: null,
	  modified: '2018-07-11 10:33:07.242249+00',
	  date_terminated: null,
	  date_event_filed: '02/10/2012',
	  date_due_set: '04/04/2012',
	  doc_uri: 'https://ecf-test.azb.uscourts.gov/doc2/024076535',
	  hearing_judge: 'Marlar, James M.',
	  event_name: 'Preliminary Hearing'
	}, {
	  date_satisfied: null,
	  doc_no: '47',
	  date_due_set: '12/15/2011',
	  doc_uri: null,
	  hearing_judge: 'Marlar, James M.',
	  event_name: 'Preliminary Hearing',
	  modified: '2018-07-11 10:33:07.222524+00',
	  date_terminated: null,
	  date_event_filed: '11/21/2011'
	}, {
	  date_satisfied: null,
	  doc_no: '45',
	  date_due_set: '12/15/2009',
	  doc_uri: null,
	  hearing_judge: 'Marlar, James M.',
	  event_name: 'Hrg on Motion',
	  modified: '2018-07-11 10:33:07.192612+00',
	  date_terminated: null,
	  date_event_filed: '12/22/2009'
	}, {
	  date_satisfied: null,
	  doc_no: '44',
	  doc_uri: null,
	  date_due_set: '12/15/2009',
	  hearing_judge: 'Marlar, James M.',
	  event_name: 'Hearing',
	  date_terminated: null,
	  modified: '2018-07-11 10:33:07.177026+00',
	  date_event_filed: '12/22/2009'
	}, {
	  date_due_set: '03/26/2009',
	  doc_uri: 'https://ecf-test.azb.uscourts.gov/doc2/024032146',
	  event_name: 'Status Hearing',
	  hearing_judge: 'Marlar, James M.',
	  modified: '2018-07-11 10:33:07.163592+00',
	  date_terminated: null,
	  date_event_filed: '02/17/2009',
	  date_satisfied: null,
	  doc_no: '40'
	}, {
	  doc_no: '37',
	  date_satisfied: null,
	  date_terminated: null,
	  modified: '2018-07-11 10:33:07.137973+00',
	  date_event_filed: '08/25/2008',
	  date_due_set: '08/29/2008',
	  doc_uri: 'https://ecf-test.azb.uscourts.gov/doc2/024028619',
	  event_name: 'Status Hearing',
	  hearing_judge: 'Marlar, James M.'
	}, {
	  date_satisfied: null,
	  doc_no: '39',
	  date_event_filed: '08/26/2008',
	  date_terminated: null,
	  modified: '2018-07-11 10:33:07.1193+00',
	  event_name: 'Status Hearing',
	  hearing_judge: 'Marlar, James M.',
	  date_due_set: '08/28/2008',
	  doc_uri: 'https://ecf-test.azb.uscourts.gov/doc2/024028691'
	}, {
	  doc_no: '38',
	  date_satisfied: null,
	  date_due_set: '08/28/2008',
	  doc_uri: 'https://ecf-test.azb.uscourts.gov/doc2/024028623',
	  hearing_judge: 'Marlar, James M.',
	  event_name: 'Status Hearing',
	  modified: '2018-07-11 10:33:07.087783+00',
	  date_terminated: null,
	  date_event_filed: '08/25/2008'
	}, {
	  doc_no: '2',
	  date_satisfied: null,
	  date_due_set: '10/31/2007',
	  doc_uri: null,
	  event_name: '341 Meeting',
	  hearing_judge: '',
	  modified: '2018-07-11 10:33:07.059562+00',
	  date_terminated: null,
	  date_event_filed: '02/19/2007'
	}, {
	  date_terminated: null,
	  modified: '2018-07-11 10:33:07.035109+00',
	  date_event_filed: '05/21/2007',
	  doc_uri: null,
	  date_due_set: '10/18/2007',
	  event_name: 'Final Filing Fee Installment',
	  hearing_judge: '',
	  doc_no: '22',
	  date_satisfied: null
	}, {
	  date_terminated: null,
	  modified: '2018-07-11 10:33:07.012086+00',
	  date_event_filed: '05/21/2007',
	  doc_uri: null,
	  date_due_set: '09/04/2007',
	  hearing_judge: '',
	  event_name: 'Third Filing Fee Installment',
	  doc_no: '22',
	  date_satisfied: null
	}, {
	  date_satisfied: null,
	  doc_no: '15',
	  modified: '2018-07-11 10:33:06.980146+00',
	  date_terminated: '05/21/2007',
	  date_event_filed: '04/02/2007',
	  date_due_set: '08/30/2007',
	  doc_uri: 'https://ecf-test.azb.uscourts.gov/doc2/02402529',
	  hearing_judge: '',
	  event_name: 'Final Filing Fee Installment'
	}, {
	  doc_no: '15',
	  date_satisfied: null,
	  doc_uri: 'https://ecf-test.azb.uscourts.gov/doc2/02402529',
	  date_due_set: '07/31/2007',
	  hearing_judge: '',
	  event_name: 'Third Filing Fee Installment',
	  modified: '2018-07-11 10:33:06.955655+00',
	  date_terminated: '05/21/2007',
	  date_event_filed: '04/02/2007'
	}, {
	  date_event_filed: '07/02/2007',
	  date_terminated: null,
	  modified: '2018-07-11 10:33:06.92921+00',
	  event_name: 'Conversion Filing Fee Due Date',
	  hearing_judge: '',
	  date_due_set: '07/23/2007',
	  doc_uri: null,
	  date_satisfied: null,
	  doc_no: '27'
	}, {
	  date_event_filed: '07/02/2007',
	  date_terminated: null,
	  modified: '2018-07-11 10:33:06.903902+00',
	  hearing_judge: '',
	  event_name: 'Conversion Filing Fee Due Date',
	  date_due_set: '07/23/2007',
	  doc_uri: 'https://ecf-test.azb.uscourts.gov/doc2/02409341',
	  date_satisfied: null,
	  doc_no: '26'
	}, {
	  date_event_filed: '05/21/2007',
	  modified: '2018-07-11 10:33:06.876369+00',
	  date_terminated: null,
	  hearing_judge: '',
	  event_name: 'Second Filing Fee Installment',
	  date_due_set: '07/20/2007',
	  doc_uri: null,
	  date_satisfied: null,
	  doc_no: '22'
	}, {
	  date_event_filed: '04/02/2007',
	  date_terminated: '05/21/2007',
	  modified: '2018-07-11 10:33:06.864278+00',
	  event_name: 'Second Filing Fee Installment',
	  hearing_judge: '',
	  doc_uri: 'https://ecf-test.azb.uscourts.gov/doc2/02402529',
	  date_due_set: '07/02/2007',
	  doc_no: '15',
	  date_satisfied: null
	}, {
	  date_satisfied: null,
	  doc_no: '22',
	  date_terminated: null,
	  modified: '2018-07-11 10:33:06.843588+00',
	  date_event_filed: '05/21/2007',
	  doc_uri: null,
	  date_due_set: '06/05/2007',
	  hearing_judge: '',
	  event_name: 'Minimum 50.00 Fee'
	}, {
	  hearing_judge: '',
	  event_name: 'First Filing Fee Installment',
	  date_due_set: '06/01/2007',
	  doc_uri: 'https://ecf-test.azb.uscourts.gov/doc2/02402529',
	  date_event_filed: '04/02/2007',
	  date_terminated: null,
	  modified: '2018-07-11 10:33:06.83199+00',
	  doc_no: '15',
	  date_satisfied: null
	}, {
	  date_due_set: '04/13/2007',
	  doc_uri: 'https://ecf-test.azb.uscourts.gov/doc2/02402356',
	  hearing_judge: '',
	  event_name: 'Objection/Response Due',
	  date_terminated: null,
	  modified: '2018-07-11 10:33:06.806704+00',
	  date_event_filed: '03/29/2007',
	  doc_no: '13',
	  date_satisfied: null
	}, {
	  date_terminated: null,
	  modified: '2018-07-11 10:33:06.782902+00',
	  date_event_filed: '02/19/2007',
	  doc_uri: 'https://ecf-test.azb.uscourts.gov/doc2/024025013',
	  date_due_set: '03/12/2007',
	  event_name: 'Declaration ECF Petition',
	  hearing_judge: '',
	  doc_no: '1',
	  date_satisfied: null
	}];

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _DocketHeader = __webpack_require__(200);
	
	var _DocketHeader2 = _interopRequireDefault(_DocketHeader);
	
	var _DocketFilters = __webpack_require__(254);
	
	var _DocketFilters2 = _interopRequireDefault(_DocketFilters);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Docket/DocketFilters', module).add('Empty', function () {
	  return _react2.default.createElement(_DocketFilters2.default, props);
	});
	
	var props = {
	  keyword: null,
	  doc_range: null,
	  changeDate: function changeDate() {
	    return null;
	  },
	  onChangeDateRaw: function onChangeDateRaw() {
	    return null;
	  },
	  onChange: function onChange() {
	    return null;
	  },
	  onClear: function onClear() {
	    return null;
	  },
	  getFilteredDockets: function getFilteredDockets() {
	    return null;
	  },
	  date_filed_from: null,
	  date_filed_to: null
	};
	
	var mockHeaderData = {
	  "assigned_to": "Judge Randall L. Dunn",
	  "attorneys": [{
	    "associated": [{
	      "address": "419 Main Street\nOregon City, OR 97045\nCLACKAMAS-OR",
	      "ein": "93-1293801",
	      "name": "Blue Heron Paper Company",
	      "role": "Debtor"
	    }],
	    "attorney": {
	      "address": "600 University St #3600\nSeattle, WA 98101",
	      "name": "DAVID B LEVANT",
	      "phone": "206-386-7601"
	    }
	  }, {
	    "associated": [{
	      "address": "419 Main Street\nOregon City, OR 97045\nCLACKAMAS-OR",
	      "ein": "93-1293801",
	      "name": "Blue Heron Paper Company",
	      "role": "Debtor"
	    }],
	    "attorney": {
	      "address": "900 SW 5th Ave #2600\nPortland, OR 97204",
	      "name": "BRANDY A SARGENT",
	      "phone": "503-224-3380"
	    }
	  }, {
	    "associated": [{
	      "address": "419 Main Street\nOregon City, OR 97045\nCLACKAMAS-OR",
	      "ein": "93-1293801",
	      "name": "Blue Heron Paper Company",
	      "role": "Debtor"
	    }],
	    "attorney": {
	      "address": "900 SW Fifth Ave #2600\nPortland, OR 97204",
	      "name": "GARVEY SCHUBERT",
	      "phone": "503-224-3380"
	    }
	  }, {
	    "associated": [{
	      "address": "419 Main Street\nOregon City, OR 97045\nCLACKAMAS-OR",
	      "ein": "93-1293801",
	      "name": "Blue Heron Paper Company",
	      "role": "Debtor"
	    }],
	    "attorney": {
	      "address": "319 SW Washington #520\nPortland, OR 97204",
	      "name": "ROBERT J VANDEN BOS",
	      "phone": "503-241-4869"
	    }
	  }, {
	    "associated": [{
	      "address": "515 NW Saltzman Rd.\nPMB #917\nPortland, OR 97229",
	      "name": "Peter C McKittrick",
	      "phone": "503-616-4979",
	      "role": "Trustee"
	    }],
	    "attorney": {
	      "address": "101 SW Main #1100\nPortland, OR 97204",
	      "name": "DAVID W CRISWELL",
	      "phone": "503-228-2525"
	    }
	  }, {
	    "associated": [{
	      "address": "515 NW Saltzman Rd.\nPMB #917\nPortland, OR 97229",
	      "name": "Peter C McKittrick",
	      "phone": "503-616-4979",
	      "role": "Trustee"
	    }],
	    "attorney": {
	      "address": "101 SW Main St #1100\nPortland, OR 97204",
	      "name": "MATHEW W LAURITSEN",
	      "phone": "503-228-2525"
	    }
	  }, {
	    "associated": [{
	      "address": "515 NW Saltzman Rd.\nPMB #917\nPortland, OR 97229",
	      "name": "Peter C McKittrick",
	      "phone": "503-616-4979",
	      "role": "Trustee"
	    }],
	    "attorney": {
	      "address": "111 SW Columbia, Ste 1100\nPortland, OR 97201",
	      "name": "JUSTIN D LEONARD",
	      "phone": "971-634-0192"
	    }
	  }, {
	    "associated": [{
	      "address": "515 NW Saltzman Rd.\nPMB #917\nPortland, OR 97229",
	      "name": "Peter C McKittrick",
	      "phone": "503-616-4979",
	      "role": "Trustee"
	    }],
	    "attorney": {
	      "address": "101 SW Main #1100\nPortland, OR 97204",
	      "name": "BRAD T SUMMERS",
	      "phone": "503-228-2525"
	    }
	  }, {
	    "associated": [{
	      "address": "c/o Michael R. Riley\n303 W. Madison St\nChicago, IL 60603\nx 1310",
	      "name": "National Fiber Supply",
	      "phone": "312-346-4800",
	      "role": "Creditor Committee",
	      "terminated_date": "05/25/2011"
	    }],
	    "attorney": {
	      "address": "62 SW Morrison St #1225\nPortland, OR 97205\n1orbtester+",
	      "email": "70@gmail.com",
	      "name": "JOSEPH Aorb FIELD",
	      "phone": "503-228-9115",
	      "terminated_date": "05/25/2011"
	    }
	  }, {
	    "associated": [{
	      "address": "2125 SE 76th Ave\nPortland, OR 97215",
	      "name": "Committee of Retired Employees",
	      "phone": "503-775-8243",
	      "role": "Creditor Committee"
	    }],
	    "attorney": {
	      "address": "15545 Village Park Ct\nLake Oswego, OR 97034",
	      "name": "BRADLEY O BAKER",
	      "phone": "503-697-0557"
	    }
	  }],
	  "chapter": "7",
	  "date_filed": "12/31/2009",
	  "filing_claims_deadline": "08/08/2011",
	  "has_asset": 1,
	  "header_html_timestamp": "2019-09-05T16:06:35Z",
	  "html": "<TABLE  class=\"DktRpt\"  width=\"100%\" align=right BORDER=0 CELLSPACING=5><TR><TD ALIGN=right><h2> <FONT SIZE=\"3\">APPEAL, CONVERTED, DENYDISCH522q1</FONT></h2></TD></TR></TABLE><BR><BR><BR><CENTER><B><FONT SIZE=\"+1\">U.S. Bankruptcy Court<BR>District of Oregon (Portland)<BR>Bankruptcy Petition #: 09-40921-rld7</FONT></B></CENTER><TABLE  class=\"DktRpt\"  width=\"100%\" BORDER=0 CELLSPACING=1><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><BR><I>Assigned to:</I>      Judge Randall L. Dunn<BR>Chapter          7<BR>Previous chapter 11<BR>Voluntary<BR>Asset <br><div class=\"noprint\"><A HREF='/cgi-bin/qryAscCases.pl?381842'>Show Associated Cases</A></div> <div class=\"noprint\"><a href='/cgi-bin/SearchClaims.pl?caseid=381842;sc'>Claims Register</a></div><BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"50%\" ALIGN=right><FONT SIZE=\"+0\"><TABLE  class=\"DktRpt\"  border=0 cellspacing=0 cellpadding=0 align=center><TR><td align=\"right\" valign=\"top\"><I>Date filed:</I></td><td align=\"left\" valign=\"top\">&nbsp;&nbsp;12/31/2009</td></TR><TR><td align=\"right\" valign=\"top\"><I>Date converted:</I></td><td align=\"left\" valign=\"top\">&nbsp;&nbsp;04/01/2011</td></TR><TR><td align=\"right\" valign=\"top\"><I>341 meeting:</I></td><td align=\"left\" valign=\"top\">&nbsp;&nbsp;05/10/2011</td></TR><TR><td align=\"right\" valign=\"top\"><I>Deadline for filing claims:</I></td><td align=\"left\" valign=\"top\">&nbsp;&nbsp;08/08/2011  </td></TR><TR><td align=\"right\" valign=\"top\"><I>Deadline for objecting to discharge:</I></td><td align=\"left\" valign=\"top\">&nbsp;&nbsp;07/11/2011  </td></TR></TABLE>\t</FONT></TD>\n</TR>\n</TABLE><BR><FONT SIZE=\"5\"><B></B>\n\t\t</FONT><TABLE  class=\"DktRpt\"  width=\"100%\" BORDER=0 CELLSPACING=1><TR><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Debtor</B></I><BR><B>Blue Heron Paper Company</B>\n<BR>419 Main Street\n<BR>Oregon City, OR 97045\n<BR>CLACKAMAS-OR\n<BR>Tax ID / EIN: 93-1293801     <BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  ALIGN=right><FONT SIZE=\"+0\">represented by\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\">\n  \t                    <font size=\"+0\"><B>DAVID B LEVANT</B>\n<BR>600 University St &#035;3600\n<BR>Seattle, WA 98101\n<BR>(206) 386-7601<BR><BR><B>BRANDY A SARGENT</B>\n<BR>900 SW 5th Ave &#035;2600\n<BR>Portland, OR 97204\n<BR>(503) 224-3380<BR><BR><B>GARVEY SCHUBERT</B>\n<BR>900 SW Fifth Ave &#035;2600\n<BR>Portland, OR 97204\n<BR>(503) 224-3380<BR><BR><B>ROBERT J VANDEN BOS</B>\n<BR>319 SW Washington &#035;520\n<BR>Portland, OR 97204\n<BR>(503) 241-4869<BR><BR></font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Trustee</B></I><BR><B>Peter C McKittrick</B>\n<BR>515 NW Saltzman Rd.\n<BR>PMB &#035;917\n<BR>Portland, OR 97229\n<BR>(503) 616-4979<BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  ALIGN=right><FONT SIZE=\"+0\">represented by\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\">\n  \t                    <font size=\"+0\"><B>DAVID W CRISWELL</B>\n<BR>101 SW Main &#035;1100\n<BR>Portland, OR 97204\n<BR>(503) 228-2525<BR><BR><B>MATHEW W LAURITSEN</B>\n<BR>101 SW Main St &#035;1100\n<BR>Portland, OR 97204\n<BR>(503) 228-2525<BR><BR><B>JUSTIN D LEONARD</B>\n<BR>111 SW Columbia, Ste 1100\n<BR>Portland, OR 97201\n<BR>(971) 634-0192<BR><BR><B>BRAD T SUMMERS</B>\n<BR>101 SW Main &#035;1100\n<BR>Portland, OR 97204\n<BR>(503) 228-2525<BR><BR></font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>U.S. Trustee</B></I><BR><B>US Trustee, Portland</B>\n<BR>620 SW Main St &#035;213\n<BR>Portland, OR 97205\n<BR>(503) 326-4000<BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"20%\" ALIGN=right><FONT SIZE=\"+0\">&nbsp;\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\" NOWRAP>\n  \t                    <font size=\"+0\">&nbsp;</font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Cred. Comm. Chair</B></I><BR><B>Weyerhaeuser</B>\n<BR>c/o Linda Fornero\n<BR>CH2E30 P.O. Box 9777\n<BR>Federal Way, WA 98063\n<BR>253-924-7176<BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"20%\" ALIGN=right><FONT SIZE=\"+0\">&nbsp;\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\" NOWRAP>\n  \t                    <font size=\"+0\">&nbsp;</font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Creditor Committee</B></I><BR><B>Metro Waste Paper Recovery, Inc.</B>\n<BR>c/o Ken Rasmussen\n<BR>12345 104 Ave.\n<BR>Surrey, BC V3V3H2\n<BR>604-580-3070<BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"20%\" ALIGN=right><FONT SIZE=\"+0\">&nbsp;\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\" NOWRAP>\n  \t                    <font size=\"+0\">&nbsp;</font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Creditor Committee</B></I><BR><B>Ashland, Inc.</B>\n<BR>c/o Terry Nicholson\n<BR>5200 Blazer Parkway\n<BR>Dublin, OH 43017\n<BR>614-790-3009<BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"20%\" ALIGN=right><FONT SIZE=\"+0\">&nbsp;\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\" NOWRAP>\n  \t                    <font size=\"+0\">&nbsp;</font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Creditor Committee</B></I><BR><B>Nationwide Magazine Recycling, Inc.</B>\n<BR>c/o Roy Threlkeld\n<BR>2300 Apollo Circle\n<BR>Carrollton, TX 75006\n<BR>972-416-9599<BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"20%\" ALIGN=right><FONT SIZE=\"+0\">&nbsp;\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\" NOWRAP>\n  \t                    <font size=\"+0\">&nbsp;</font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Creditor Committee</B></I><BR><B>National Fiber Supply</B>\n<BR>c/o Michael R. Riley\n<BR>303 W. Madison St\n<BR>Chicago, IL 60603\n<BR>312-346-4800 x 1310\n<BR><I> TERMINATED: 05/25/2011</I><BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  ALIGN=right><FONT SIZE=\"+0\">represented by\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\">\n  \t                    <font size=\"+0\"><B>JOSEPH Aorb FIELD</B>\n<BR>62 SW Morrison St &#035;1225\n<BR>Portland, OR 97205\n<BR>(503) 228-9115\n<BR>Email:&nbsp;<a href='mailto:1orbtester+70@gmail.com'>1orbtester+70@gmail.com</a>\n<BR><I> TERMINATED: 05/25/2011</I><BR><BR></font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Creditor Committee</B></I><BR><B>Demitrakikes Trucking, Inc.</B>\n<BR>c/o Denise Thornton\n<BR>P.O. Box 381\n<BR>Canby, OR 97013\n<BR>503-266-9265<BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"20%\" ALIGN=right><FONT SIZE=\"+0\">&nbsp;\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\" NOWRAP>\n  \t                    <font size=\"+0\">&nbsp;</font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Creditor Committee</B></I><BR><B>Pacific Fibre Products</B>\n<BR>c/o Don Lightfoot\n<BR>PO Box 278\n<BR>Longview, WA 98632\n<BR>360-577-7112<BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"20%\" ALIGN=right><FONT SIZE=\"+0\">&nbsp;\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\" NOWRAP>\n  \t                    <font size=\"+0\">&nbsp;</font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Creditor Committee</B></I><BR><B>Committee of Retired Employees</B>\n<BR>2125 SE 76th Ave\n<BR>Portland, OR 97215\n<BR>(503) 775-8243<BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  ALIGN=right><FONT SIZE=\"+0\">represented by\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\">\n  \t                    <font size=\"+0\"><B>BRADLEY O BAKER</B>\n<BR>15545 Village Park Ct\n<BR>Lake Oswego, OR 97034\n<BR>(503) 697-0557<BR><BR></font></TD></TR><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Creditor Committee</B></I><BR><B>K&L Gates</B>\n<BR>Attn: R Gibson Masters\n<BR>1 SW Columbia St &#035;1900\n<BR>Portland, OR 97258-2041\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"20%\" ALIGN=right><FONT SIZE=\"+0\">&nbsp;\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"40%\"><FONT SIZE=\"+0\">&nbsp;\t</FONT></TD>\n</TR></TABLE><BR>",
	  "is_header_html_valid": 1,
	  "latest_docket_number": 1578,
	  "latest_history_number": null,
	  "latest_known_date_filed": "05/02/2019",
	  "meeting_341": "05/10/2011",
	  "modified": "2019-09-05T16:06:35.935260Z",
	  "objecting_discharge_deadline": "07/11/2011",
	  "trustees": [{
	    "address": "515 NW Saltzman Rd.\nPMB #917\nPortland, OR 97229",
	    "name": "Peter C McKittrick",
	    "phone": "503-616-4979",
	    "role": "Trustee"
	  }],
	  "voluntary": 1
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _DocketHeader = __webpack_require__(200);
	
	var _DocketHeader2 = _interopRequireDefault(_DocketHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Docket/DocketHeader', module).add('View', function () {
	  return _react2.default.createElement(_DocketHeader2.default, { open: true,
	    data: mockHeaderData,
	    displayName: 'example name' });
	});
	
	var mockHeaderData = {
	  "assigned_to": "Judge Randall L. Dunn",
	  "attorneys": [{
	    "associated": [{
	      "address": "419 Main Street\nOregon City, OR 97045\nCLACKAMAS-OR",
	      "ein": "93-1293801",
	      "name": "Blue Heron Paper Company",
	      "role": "Debtor"
	    }],
	    "attorney": {
	      "address": "600 University St #3600\nSeattle, WA 98101",
	      "name": "DAVID B LEVANT",
	      "phone": "206-386-7601"
	    }
	  }, {
	    "associated": [{
	      "address": "419 Main Street\nOregon City, OR 97045\nCLACKAMAS-OR",
	      "ein": "93-1293801",
	      "name": "Blue Heron Paper Company",
	      "role": "Debtor"
	    }],
	    "attorney": {
	      "address": "900 SW 5th Ave #2600\nPortland, OR 97204",
	      "name": "BRANDY A SARGENT",
	      "phone": "503-224-3380"
	    }
	  }, {
	    "associated": [{
	      "address": "419 Main Street\nOregon City, OR 97045\nCLACKAMAS-OR",
	      "ein": "93-1293801",
	      "name": "Blue Heron Paper Company",
	      "role": "Debtor"
	    }],
	    "attorney": {
	      "address": "900 SW Fifth Ave #2600\nPortland, OR 97204",
	      "name": "GARVEY SCHUBERT",
	      "phone": "503-224-3380"
	    }
	  }, {
	    "associated": [{
	      "address": "419 Main Street\nOregon City, OR 97045\nCLACKAMAS-OR",
	      "ein": "93-1293801",
	      "name": "Blue Heron Paper Company",
	      "role": "Debtor"
	    }],
	    "attorney": {
	      "address": "319 SW Washington #520\nPortland, OR 97204",
	      "name": "ROBERT J VANDEN BOS",
	      "phone": "503-241-4869"
	    }
	  }, {
	    "associated": [{
	      "address": "515 NW Saltzman Rd.\nPMB #917\nPortland, OR 97229",
	      "name": "Peter C McKittrick",
	      "phone": "503-616-4979",
	      "role": "Trustee"
	    }],
	    "attorney": {
	      "address": "101 SW Main #1100\nPortland, OR 97204",
	      "name": "DAVID W CRISWELL",
	      "phone": "503-228-2525"
	    }
	  }, {
	    "associated": [{
	      "address": "515 NW Saltzman Rd.\nPMB #917\nPortland, OR 97229",
	      "name": "Peter C McKittrick",
	      "phone": "503-616-4979",
	      "role": "Trustee"
	    }],
	    "attorney": {
	      "address": "101 SW Main St #1100\nPortland, OR 97204",
	      "name": "MATHEW W LAURITSEN",
	      "phone": "503-228-2525"
	    }
	  }, {
	    "associated": [{
	      "address": "515 NW Saltzman Rd.\nPMB #917\nPortland, OR 97229",
	      "name": "Peter C McKittrick",
	      "phone": "503-616-4979",
	      "role": "Trustee"
	    }],
	    "attorney": {
	      "address": "111 SW Columbia, Ste 1100\nPortland, OR 97201",
	      "name": "JUSTIN D LEONARD",
	      "phone": "971-634-0192"
	    }
	  }, {
	    "associated": [{
	      "address": "515 NW Saltzman Rd.\nPMB #917\nPortland, OR 97229",
	      "name": "Peter C McKittrick",
	      "phone": "503-616-4979",
	      "role": "Trustee"
	    }],
	    "attorney": {
	      "address": "101 SW Main #1100\nPortland, OR 97204",
	      "name": "BRAD T SUMMERS",
	      "phone": "503-228-2525"
	    }
	  }, {
	    "associated": [{
	      "address": "c/o Michael R. Riley\n303 W. Madison St\nChicago, IL 60603\nx 1310",
	      "name": "National Fiber Supply",
	      "phone": "312-346-4800",
	      "role": "Creditor Committee",
	      "terminated_date": "05/25/2011"
	    }],
	    "attorney": {
	      "address": "62 SW Morrison St #1225\nPortland, OR 97205\n1orbtester+",
	      "email": "70@gmail.com",
	      "name": "JOSEPH Aorb FIELD",
	      "phone": "503-228-9115",
	      "terminated_date": "05/25/2011"
	    }
	  }, {
	    "associated": [{
	      "address": "2125 SE 76th Ave\nPortland, OR 97215",
	      "name": "Committee of Retired Employees",
	      "phone": "503-775-8243",
	      "role": "Creditor Committee"
	    }],
	    "attorney": {
	      "address": "15545 Village Park Ct\nLake Oswego, OR 97034",
	      "name": "BRADLEY O BAKER",
	      "phone": "503-697-0557"
	    }
	  }],
	  "chapter": "7",
	  "date_filed": "12/31/2009",
	  "filing_claims_deadline": "08/08/2011",
	  "has_asset": 1,
	  "header_html_timestamp": "2019-09-05T16:06:35Z",
	  "html": "<TABLE  class=\"DktRpt\"  width=\"100%\" align=right BORDER=0 CELLSPACING=5><TR><TD ALIGN=right><h2> <FONT SIZE=\"3\">APPEAL, CONVERTED, DENYDISCH522q1</FONT></h2></TD></TR></TABLE><BR><BR><BR><CENTER><B><FONT SIZE=\"+1\">U.S. Bankruptcy Court<BR>District of Oregon (Portland)<BR>Bankruptcy Petition #: 09-40921-rld7</FONT></B></CENTER><TABLE  class=\"DktRpt\"  width=\"100%\" BORDER=0 CELLSPACING=1><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><BR><I>Assigned to:</I>      Judge Randall L. Dunn<BR>Chapter          7<BR>Previous chapter 11<BR>Voluntary<BR>Asset <br><div class=\"noprint\"><A HREF='/cgi-bin/qryAscCases.pl?381842'>Show Associated Cases</A></div> <div class=\"noprint\"><a href='/cgi-bin/SearchClaims.pl?caseid=381842;sc'>Claims Register</a></div><BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"50%\" ALIGN=right><FONT SIZE=\"+0\"><TABLE  class=\"DktRpt\"  border=0 cellspacing=0 cellpadding=0 align=center><TR><td align=\"right\" valign=\"top\"><I>Date filed:</I></td><td align=\"left\" valign=\"top\">&nbsp;&nbsp;12/31/2009</td></TR><TR><td align=\"right\" valign=\"top\"><I>Date converted:</I></td><td align=\"left\" valign=\"top\">&nbsp;&nbsp;04/01/2011</td></TR><TR><td align=\"right\" valign=\"top\"><I>341 meeting:</I></td><td align=\"left\" valign=\"top\">&nbsp;&nbsp;05/10/2011</td></TR><TR><td align=\"right\" valign=\"top\"><I>Deadline for filing claims:</I></td><td align=\"left\" valign=\"top\">&nbsp;&nbsp;08/08/2011  </td></TR><TR><td align=\"right\" valign=\"top\"><I>Deadline for objecting to discharge:</I></td><td align=\"left\" valign=\"top\">&nbsp;&nbsp;07/11/2011  </td></TR></TABLE>\t</FONT></TD>\n</TR>\n</TABLE><BR><FONT SIZE=\"5\"><B></B>\n\t\t</FONT><TABLE  class=\"DktRpt\"  width=\"100%\" BORDER=0 CELLSPACING=1><TR><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Debtor</B></I><BR><B>Blue Heron Paper Company</B>\n<BR>419 Main Street\n<BR>Oregon City, OR 97045\n<BR>CLACKAMAS-OR\n<BR>Tax ID / EIN: 93-1293801     <BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  ALIGN=right><FONT SIZE=\"+0\">represented by\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\">\n  \t                    <font size=\"+0\"><B>DAVID B LEVANT</B>\n<BR>600 University St &#035;3600\n<BR>Seattle, WA 98101\n<BR>(206) 386-7601<BR><BR><B>BRANDY A SARGENT</B>\n<BR>900 SW 5th Ave &#035;2600\n<BR>Portland, OR 97204\n<BR>(503) 224-3380<BR><BR><B>GARVEY SCHUBERT</B>\n<BR>900 SW Fifth Ave &#035;2600\n<BR>Portland, OR 97204\n<BR>(503) 224-3380<BR><BR><B>ROBERT J VANDEN BOS</B>\n<BR>319 SW Washington &#035;520\n<BR>Portland, OR 97204\n<BR>(503) 241-4869<BR><BR></font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Trustee</B></I><BR><B>Peter C McKittrick</B>\n<BR>515 NW Saltzman Rd.\n<BR>PMB &#035;917\n<BR>Portland, OR 97229\n<BR>(503) 616-4979<BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  ALIGN=right><FONT SIZE=\"+0\">represented by\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\">\n  \t                    <font size=\"+0\"><B>DAVID W CRISWELL</B>\n<BR>101 SW Main &#035;1100\n<BR>Portland, OR 97204\n<BR>(503) 228-2525<BR><BR><B>MATHEW W LAURITSEN</B>\n<BR>101 SW Main St &#035;1100\n<BR>Portland, OR 97204\n<BR>(503) 228-2525<BR><BR><B>JUSTIN D LEONARD</B>\n<BR>111 SW Columbia, Ste 1100\n<BR>Portland, OR 97201\n<BR>(971) 634-0192<BR><BR><B>BRAD T SUMMERS</B>\n<BR>101 SW Main &#035;1100\n<BR>Portland, OR 97204\n<BR>(503) 228-2525<BR><BR></font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>U.S. Trustee</B></I><BR><B>US Trustee, Portland</B>\n<BR>620 SW Main St &#035;213\n<BR>Portland, OR 97205\n<BR>(503) 326-4000<BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"20%\" ALIGN=right><FONT SIZE=\"+0\">&nbsp;\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\" NOWRAP>\n  \t                    <font size=\"+0\">&nbsp;</font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Cred. Comm. Chair</B></I><BR><B>Weyerhaeuser</B>\n<BR>c/o Linda Fornero\n<BR>CH2E30 P.O. Box 9777\n<BR>Federal Way, WA 98063\n<BR>253-924-7176<BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"20%\" ALIGN=right><FONT SIZE=\"+0\">&nbsp;\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\" NOWRAP>\n  \t                    <font size=\"+0\">&nbsp;</font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Creditor Committee</B></I><BR><B>Metro Waste Paper Recovery, Inc.</B>\n<BR>c/o Ken Rasmussen\n<BR>12345 104 Ave.\n<BR>Surrey, BC V3V3H2\n<BR>604-580-3070<BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"20%\" ALIGN=right><FONT SIZE=\"+0\">&nbsp;\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\" NOWRAP>\n  \t                    <font size=\"+0\">&nbsp;</font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Creditor Committee</B></I><BR><B>Ashland, Inc.</B>\n<BR>c/o Terry Nicholson\n<BR>5200 Blazer Parkway\n<BR>Dublin, OH 43017\n<BR>614-790-3009<BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"20%\" ALIGN=right><FONT SIZE=\"+0\">&nbsp;\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\" NOWRAP>\n  \t                    <font size=\"+0\">&nbsp;</font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Creditor Committee</B></I><BR><B>Nationwide Magazine Recycling, Inc.</B>\n<BR>c/o Roy Threlkeld\n<BR>2300 Apollo Circle\n<BR>Carrollton, TX 75006\n<BR>972-416-9599<BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"20%\" ALIGN=right><FONT SIZE=\"+0\">&nbsp;\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\" NOWRAP>\n  \t                    <font size=\"+0\">&nbsp;</font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Creditor Committee</B></I><BR><B>National Fiber Supply</B>\n<BR>c/o Michael R. Riley\n<BR>303 W. Madison St\n<BR>Chicago, IL 60603\n<BR>312-346-4800 x 1310\n<BR><I> TERMINATED: 05/25/2011</I><BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  ALIGN=right><FONT SIZE=\"+0\">represented by\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\">\n  \t                    <font size=\"+0\"><B>JOSEPH Aorb FIELD</B>\n<BR>62 SW Morrison St &#035;1225\n<BR>Portland, OR 97205\n<BR>(503) 228-9115\n<BR>Email:&nbsp;<a href='mailto:1orbtester+70@gmail.com'>1orbtester+70@gmail.com</a>\n<BR><I> TERMINATED: 05/25/2011</I><BR><BR></font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Creditor Committee</B></I><BR><B>Demitrakikes Trucking, Inc.</B>\n<BR>c/o Denise Thornton\n<BR>P.O. Box 381\n<BR>Canby, OR 97013\n<BR>503-266-9265<BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"20%\" ALIGN=right><FONT SIZE=\"+0\">&nbsp;\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\" NOWRAP>\n  \t                    <font size=\"+0\">&nbsp;</font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Creditor Committee</B></I><BR><B>Pacific Fibre Products</B>\n<BR>c/o Don Lightfoot\n<BR>PO Box 278\n<BR>Longview, WA 98632\n<BR>360-577-7112<BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"20%\" ALIGN=right><FONT SIZE=\"+0\">&nbsp;\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\" NOWRAP>\n  \t                    <font size=\"+0\">&nbsp;</font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Creditor Committee</B></I><BR><B>Committee of Retired Employees</B>\n<BR>2125 SE 76th Ave\n<BR>Portland, OR 97215\n<BR>(503) 775-8243<BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  ALIGN=right><FONT SIZE=\"+0\">represented by\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\">\n  \t                    <font size=\"+0\"><B>BRADLEY O BAKER</B>\n<BR>15545 Village Park Ct\n<BR>Lake Oswego, OR 97034\n<BR>(503) 697-0557<BR><BR></font></TD></TR><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Creditor Committee</B></I><BR><B>K&L Gates</B>\n<BR>Attn: R Gibson Masters\n<BR>1 SW Columbia St &#035;1900\n<BR>Portland, OR 97258-2041\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"20%\" ALIGN=right><FONT SIZE=\"+0\">&nbsp;\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"40%\"><FONT SIZE=\"+0\">&nbsp;\t</FONT></TD>\n</TR></TABLE><BR>",
	  "is_header_html_valid": 1,
	  "latest_docket_number": 1578,
	  "latest_history_number": null,
	  "latest_known_date_filed": "05/02/2019",
	  "meeting_341": "05/10/2011",
	  "modified": "2019-09-05T16:06:35.935260Z",
	  "objecting_discharge_deadline": "07/11/2011",
	  "trustees": [{
	    "address": "515 NW Saltzman Rd.\nPMB #917\nPortland, OR 97229",
	    "name": "Peter C McKittrick",
	    "phone": "503-616-4979",
	    "role": "Trustee"
	  }],
	  "voluntary": 1
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 657 */
/***/ function(module, exports) {

	"use strict";

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Dockets = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(32);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _docketActions = __webpack_require__(42);
	
	var docketActions = _interopRequireWildcard(_docketActions);
	
	var _clientCodeAction = __webpack_require__(64);
	
	var _AllPartsPrintPreview = __webpack_require__(133);
	
	var _AllPartsPrintPreview2 = _interopRequireDefault(_AllPartsPrintPreview);
	
	var _EmailCombinedPdfPopup = __webpack_require__(173);
	
	var _EmailCombinedPdfPopup2 = _interopRequireDefault(_EmailCombinedPdfPopup);
	
	var _DownloadZipAllPdfsRangePopup = __webpack_require__(134);
	
	var _DownloadZipAllPdfsRangePopup2 = _interopRequireDefault(_DownloadZipAllPdfsRangePopup);
	
	var _DownloadCombineAllPdfInRangePopup = __webpack_require__(171);
	
	var _DownloadCombineAllPdfInRangePopup2 = _interopRequireDefault(_DownloadCombineAllPdfInRangePopup);
	
	var _DownloadZipWithSubpartsPopup = __webpack_require__(135);
	
	var _DownloadZipWithSubpartsPopup2 = _interopRequireDefault(_DownloadZipWithSubpartsPopup);
	
	var _PrintAllPdfInRangePopup = __webpack_require__(175);
	
	var _PrintAllPdfInRangePopup2 = _interopRequireDefault(_PrintAllPdfInRangePopup);
	
	var _EmailPartPopup = __webpack_require__(174);
	
	var _EmailPartPopup2 = _interopRequireDefault(_EmailPartPopup);
	
	var _EmailPartModal = __webpack_require__(136);
	
	var _EmailPartModal2 = _interopRequireDefault(_EmailPartModal);
	
	var _EmailAllPartsZipPopup = __webpack_require__(172);
	
	var _EmailAllPartsZipPopup2 = _interopRequireDefault(_EmailAllPartsZipPopup);
	
	var _DocketPacerSearchBar = __webpack_require__(381);
	
	var _DocketPacerSearchBar2 = _interopRequireDefault(_DocketPacerSearchBar);
	
	var _DocketFilters = __webpack_require__(254);
	
	var _DocketFilters2 = _interopRequireDefault(_DocketFilters);
	
	var _DocketsPaginator = __webpack_require__(255);
	
	var _DocketsPaginator2 = _interopRequireDefault(_DocketsPaginator);
	
	var _DocketError = __webpack_require__(380);
	
	var _DocketError2 = _interopRequireDefault(_DocketError);
	
	var _DocketsTable = __webpack_require__(382);
	
	var _DocketsTable2 = _interopRequireDefault(_DocketsTable);
	
	var _Notification = __webpack_require__(40);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	__webpack_require__(198);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(104);
	__webpack_require__(130);
	
	var initState = {
	  docNumFrom: null,
	  docNumTo: null,
	  date_filed_from: null,
	  date_filed_to: null,
	  pacerSearch: {
	    date_from: null,
	    date_to: null,
	    doc_from: null,
	    doc_to: null
	  },
	  doc_range: '',
	  search_keyword: '',
	  sort_column: 'date_filed',
	  sort_order: window.Drupal.settings.docket_sort_order || 'desc',
	  docket_sort_order: window.Drupal.settings.docket_sort_order,
	  collapseHeader: !(window.Drupal.settings.auto_show_docket_header === 'yes')
	};
	
	var Dockets = exports.Dockets = function (_Component) {
	  _inherits(Dockets, _Component);
	
	  function Dockets(props) {
	    _classCallCheck(this, Dockets);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.getDockets = function () {
	      var itemParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var _this$props = _this.props,
	          case_uuid = _this$props.case_uuid,
	          court_code = _this$props.court_code,
	          case_number = _this$props.case_number;
	
	
	      var params = _extends({}, itemParams, {
	        case_uuid: case_uuid,
	        court_code: court_code,
	        case_number: case_number,
	        sort_order: _this.state.sort_order,
	        sort_column: _this.state.sort_column,
	        page_number: _this.state.selectedPageNum
	      });
	
	      _this.props.getDockets(params);
	    };
	
	    _this.purchaseData = function () {
	      return _this.props.purchaseDockets({
	        case_number: _this.props.case_number,
	        court_code: _this.props.court_code
	      }).then(function (receipt) {
	        _this.getDockets({ receipt: receipt });
	      });
	    };
	
	    _this.changeDate = function (type, date) {
	      var _this$setState;
	
	      _this.setState((_this$setState = {}, _this$setState[type] = date, _this$setState));
	    };
	
	    _this.changePacerDate = function (type, date) {
	      var _extends2;
	
	      var pacerSearch = _extends({}, _this.state.pacerSearch, (_extends2 = {}, _extends2[type] = date, _extends2));
	      _this.setState({ pacerSearch: pacerSearch });
	    };
	
	    _this.handleDateChangeRaw = function (type, e) {
	      var _this$setState2;
	
	      var date = e.target.value;
	      if (date.split('/').length !== 3) {
	        return;
	      }
	
	      var sanitized = date.split('/').reduce(function (accum, next, idx) {
	        var n = next.length < 2 ? '0' + next : next;
	
	        return idx === 0 ? accum + n : accum + '/' + n;
	      }, '');
	
	      var d = (0, _moment2.default)(sanitized, 'MM-DD-YYYY');
	
	      _this.setState((_this$setState2 = {}, _this$setState2[type] = d, _this$setState2));
	    };
	
	    _this.handlePacerDateChangeRaw = function (type, e) {
	      var _extends3;
	
	      var date = e.target.value;
	      if (date.split('/').length !== 3) {
	        return;
	      }
	
	      var sanitized = date.split('/').reduce(function (accum, next, idx) {
	        var n = next.length < 2 ? '0' + next : next;
	
	        return idx === 0 ? accum + n : accum + '/' + n;
	      }, '');
	
	      var d = (0, _moment2.default)(sanitized, 'MM-DD-YYYY');
	
	      var pacerSearch = _extends({}, _this.state.pacerSearch, (_extends3 = {}, _extends3[type] = d, _extends3));
	
	      _this.setState({ pacerSearch: pacerSearch });
	    };
	
	    _this.clear = function () {
	      _this.setState(initState);
	    };
	
	    _this.clearPacerSearchFilter = function () {
	      _this.setState({
	        pacerSearch: {
	          date_from: null,
	          date_to: null,
	          doc_from: null,
	          doc_to: null
	        }
	      });
	    };
	
	    _this.buyDocketSheet = function () {
	      if (_this.props.hasValidClientCode()) {
	        var pacerSearch = _this.state.pacerSearch;
	        var date_from = pacerSearch.date_from,
	            date_to = pacerSearch.date_to,
	            doc_from = pacerSearch.doc_from,
	            doc_to = pacerSearch.doc_to;
	
	        var showFullDocketData = {};
	
	        var pacerSearchFilterParams = {
	          court_code: _this.props.court_code,
	          case_number: _this.props.case_number,
	          include_documents: 0,
	          date_from: date_from ? date_from.format('MM/DD/YYYY') : null,
	          date_to: date_to ? date_to.format('MM/DD/YYYY') : null,
	          doc_from: doc_from ? parseInt(doc_from, 10) : null,
	          doc_to: doc_to ? parseInt(doc_to, 10) : null,
	          minimize_header: 0
	        };
	
	        var getDocRange = function getDocRange() {
	          if (doc_from && doc_to) {
	            return doc_from + '-' + doc_to;
	          }
	          if (doc_from) {
	            return doc_from + '-';
	          }
	          if (doc_to) {
	            return '-' + doc_to;
	          }
	          return null;
	        };
	
	        if (window.Drupal.settings.always_show_full_docket_after_update === '') {
	          showFullDocketData = {
	            date_filed_from: date_from,
	            date_filed_to: date_to,
	            doc_range: getDocRange()
	          };
	        }
	
	        _this.setState(_extends({ showPastEntries: false }, showFullDocketData), function () {
	          _this.props.purchaseDockets(pacerSearchFilterParams).then(function (receipt) {
	            if (window.Drupal.settings.always_show_full_docket_after_update === '') {
	              var _this$state = _this.state,
	                  date_filed_from = _this$state.date_filed_from,
	                  date_filed_to = _this$state.date_filed_to,
	                  doc_range = _this$state.doc_range;
	
	
	              var docketFilterParams = {
	                date_filed_from: date_filed_from ? date_filed_from.format('MM/DD/YYYY') : null,
	                date_filed_to: date_filed_to ? date_filed_to.format('MM/DD/YYYY') : null,
	                docket_number_range: _lodash2.default.isEmpty(doc_range) ? null : doc_range
	              };
	
	              _this.getDockets(_extends({ receipt: receipt }, docketFilterParams));
	              _this.clearPacerSearchFilter();
	            } else {
	              _this.getDockets({ receipt: receipt });
	              _this.clear();
	            }
	          });
	        });
	      }
	    };
	
	    _this.buyMissingDockets = function (docNumRange) {
	      if (_this.props.hasValidClientCode()) {
	        var date_from = docNumRange.prev_date_filed;
	        var date_to = docNumRange.next_date_filed;
	
	        var params = {
	          case_uuid: _this.props.case_uuid,
	          court_code: _this.props.court_code,
	          case_number: _this.props.case_number,
	          doc_from: null,
	          doc_to: null,
	          date_from: date_from,
	          date_to: date_to
	        };
	
	        _this.props.purchaseDockets(params).then(function (receipt) {
	          _this.getDockets({ receipt: receipt });
	        });
	      }
	    };
	
	    _this.getFilteredDockets = function () {
	      var _this$props2 = _this.props,
	          court_code = _this$props2.court_code,
	          case_number = _this$props2.case_number;
	      var _this$state2 = _this.state,
	          date_filed_from = _this$state2.date_filed_from,
	          date_filed_to = _this$state2.date_filed_to,
	          doc_range = _this$state2.doc_range,
	          search_keyword = _this$state2.search_keyword;
	
	
	      var params = {
	        date_filed_from: date_filed_from ? date_filed_from.format('MM/DD/YYYY') : null,
	        date_filed_to: date_filed_to ? date_filed_to.format('MM/DD/YYYY') : null,
	        docket_number_range: _lodash2.default.isEmpty(doc_range) ? null : doc_range,
	        search_keyword: _lodash2.default.isEmpty(search_keyword) ? null : search_keyword,
	        court_code: court_code,
	        case_number: case_number,
	        sort_order: _this.state.sort_order,
	        page_number: _this.state.selectedPageNum
	      };
	
	      return _this.props.getDockets(params);
	    };
	
	    _this.onClear = function () {
	      var date_filed_from = initState.date_filed_from,
	          date_filed_to = initState.date_filed_to,
	          doc_range = initState.doc_range,
	          search_keyword = initState.search_keyword,
	          pacerSearch = initState.pacerSearch;
	
	      var state = {
	        date_filed_from: date_filed_from,
	        date_filed_to: date_filed_to,
	        doc_range: doc_range,
	        search_keyword: search_keyword,
	        pacerSearch: pacerSearch
	      };
	
	      _this.setState(state, function () {
	        _this.getFilteredDockets();
	      });
	    };
	
	    _this.onGetDocuments = function (docket, court_code, case_number) {
	      _this.props.onGetDocuments({
	        docket_no: docket.docket_no,
	        docket_seq: docket.docket_seq,
	        court_code: court_code,
	        case_number: case_number
	      });
	    };
	
	    _this.popupForm = {
	      EmailCombinedPdfPopup: _EmailCombinedPdfPopup2.default,
	      AllPartsPrintPreview: _AllPartsPrintPreview2.default,
	      DownloadZipAllPdfsRangePopup: _DownloadZipAllPdfsRangePopup2.default,
	      DownloadZipWithSubpartsPopup: _DownloadZipWithSubpartsPopup2.default,
	      DownloadCombineAllPdfInRangePopup: _DownloadCombineAllPdfInRangePopup2.default,
	      PrintAllPdfInRangePopup: _PrintAllPdfInRangePopup2.default,
	      EmailPartPopup: _EmailPartPopup2.default,
	      EmailPartModal: _EmailPartModal2.default,
	      EmailAllPartsZipPopup: _EmailAllPartsZipPopup2.default
	    };
	
	    _this.changePage = function (headerParams, itemParams) {
	      // todo old was in setstate, make sure this is working
	      // page: itemParams.page
	      _this.setState({ selectedPageNum: itemParams.page_index }, function () {
	        _this.getDockets(itemParams);
	      });
	    };
	
	    _this.sortDockets = function (sort_column) {
	      var sort_order = _this.state.sort_order === 'asc' ? 'desc' : 'asc';
	
	      _this.setState({ sort_column: sort_column, sort_order: sort_order }, _this.getDockets);
	    };
	
	    _this.toggleHeader = function () {
	      _this.setState({ collapseHeader: !_this.state.collapseHeader });
	    };
	
	    _this.pastEntriesClick = function () {
	      if (_this.props.hasValidClientCode()) {
	        _this.setState({ showPacerSearchBar: true, showPastEntries: true });
	      }
	    };
	
	    _this.pastEntriesHide = function () {
	      _this.setState({ showPacerSearchBar: false, showPastEntries: false });
	      _this.clear();
	    };
	
	    _this.updateClick = function () {
	      if (_this.props.hasValidClientCode()) {
	        var date_from = _this.state.pacerSearch.date_from;
	        var _this$state3 = _this.state,
	            sort_order = _this$state3.sort_order,
	            sort_column = _this$state3.sort_column,
	            collapseHeader = _this$state3.collapseHeader;
	        var latest_known_date_filed = _this.props.header.latest_known_date_filed;
	
	
	        if (_lodash2.default.isEmpty(date_from) && !_lodash2.default.isEmpty(_this.props.dockets.entries)) {
	          var sorted = _lodash2.default.sortBy(_this.props.dockets.entries.data, function (entry) {
	            return (0, _moment2.default)(entry.date_filed, 'MM/DD/YYYY');
	          }).reverse();
	          date_from = (0, _moment2.default)(sorted[0].date_filed, 'MM/DD/YYYY');
	        }
	
	        var pacerSearch = _extends({}, _this.state.pacerSearch, {
	          date_from: date_from || (0, _moment2.default)(latest_known_date_filed, 'MM/DD/YYYY')
	        });
	        var state = _extends({}, initState, {
	          pacerSearch: pacerSearch,
	          showPacerSearchBar: true,
	          sort_order: sort_order,
	          sort_column: sort_column,
	          collapseHeader: collapseHeader
	        });
	
	        _this.setState(state, function () {
	          _this.buyDocketSheet();
	        });
	      }
	    };
	
	    _this.showRedactPopup = function (seqNum) {
	      _this.props.updateRedact({ showPopup: true, seqNum: seqNum });
	    };
	
	    _this.closeRedactPopup = function () {
	      _this.props.updateRedact({ showPopup: false });
	    };
	
	    _this.redact = function () {
	      _this.closeRedactPopup();
	
	      var seqNum = _this.props.redact.seqNum;
	
	      var num = parseFloat(seqNum);
	      var doc_range = num % 1 === 0 ? num.toString() : '';
	
	      var case_uuid = _this.props.case_uuid;
	
	
	      var params = {
	        redactSeqNum: seqNum,
	        doc_range: doc_range,
	        case_uuid: case_uuid,
	        sort_order: _this.state.sort_order,
	        page_number: _this.state.selectedPageNum,
	        court_code: _this.props.court_code,
	        case_number: _this.props.case_number
	        // sort_field:
	      };
	
	      _this.setState({ doc_range: doc_range }, function () {
	        _this.props.deleteAndRepurchase(params).then(function () {
	          _this.props.updateRedact({ seqNum: null });
	        });
	      });
	    };
	
	    _this.reloadDetails = function () {
	      var _this$props3 = _this.props,
	          selectedDocket = _this$props3.selectedDocket,
	          court_code = _this$props3.court_code,
	          case_number = _this$props3.case_number;
	
	      _this.getFilteredDockets().then(function () {
	        return _this.onGetDocuments(selectedDocket, court_code, case_number);
	      });
	    };
	
	    _this.changeFilter = function (e, name) {
	      var _filter;
	
	      var filter = (_filter = {}, _filter[name] = e.target.value, _filter);
	      _this.setState(filter, function () {
	        _this.props.filterDocketEntries(filter);
	      });
	    };
	
	    _this.changePacerFilter = function (e, name) {
	      var _extends4;
	
	      var pacerSearch = _extends({}, _this.state.pacerSearch, (_extends4 = {}, _extends4[name] = e.target.value, _extends4));
	      _this.setState({ pacerSearch: pacerSearch });
	    };
	
	    _this.allFiltersEmpty = function () {
	      var filtersAreEmpty = _lodash2.default.isEmpty(_this.state.search_keyword) && _lodash2.default.isEmpty(_this.state.doc_range) && _lodash2.default.isEmpty(_this.state.date_filed_from) && _lodash2.default.isEmpty(_this.state.date_filed_to);
	
	      var pacerFiltersAreEmpty = _lodash2.default.isEmpty(_this.state.pacerSearch.date_from) && _lodash2.default.isEmpty(_this.state.pacerSearch.date_to) && _lodash2.default.isEmpty(_this.state.pacerSearch.doc_from) && _lodash2.default.isEmpty(_this.state.pacerSearch.doc_to);
	
	      return filtersAreEmpty && pacerFiltersAreEmpty;
	    };
	
	    _this.state = _extends({}, initState, {
	      selectedPageNum: 1,
	      showPacerSearchBar: true,
	      showPastEntries: false
	    });
	    return _this;
	  }
	
	  Dockets.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.purchase_right_away) {
	      this.purchaseData();
	    } else {
	      var sort_order = this.state.sort_order;
	
	      this.getDockets({ sort_order: sort_order });
	    }
	  };
	
	  Dockets.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    // quick stop gap.  need to fix this somewhere else, probably service layer
	    window.fixHeaderAssociatedCasesButton();
	    window.$("#docket-header-content a[href^='/cgi-bin']").hide();
	
	    // if there's data when the page first loads, don't show the pacer search bar
	    if (prevProps.header.status !== 'done' && this.props.header.status === 'done') {
	      this.setState({ showPacerSearchBar: false });
	    }
	  };
	
	  // TODO: check func usage
	
	
	  Dockets.prototype.render = function render() {
	    var _props = this.props,
	        header = _props.header,
	        entries = _props.entries,
	        selectedDocket = _props.selectedDocket;
	
	    var lastUpdated = header.modified || '';
	
	    var showMissingDockets = entries.showMissingDockets;
	
	    showMissingDockets = showMissingDockets && this.allFiltersEmpty();
	
	    var docketFilterProps = {
	      keyword: this.state.search_keyword,
	      doc_range: this.state.doc_range,
	      date_filed_from: this.state.date_filed_from,
	      date_filed_to: this.state.date_filed_to,
	      onChange: this.changeFilter,
	      changeDate: this.changeDate,
	      onChangeDateRaw: this.handleDateChangeRaw,
	      getFilteredDockets: this.getFilteredDockets,
	      onClear: this.onClear
	    };
	
	    var docketSearchBarProps = {
	      showPastEntries: this.state.showPastEntries,
	      pastEntriesHide: this.pastEntriesHide,
	      changePacerFilter: this.changePacerFilter,
	      changePacerDate: this.changePacerDate,
	      handlePacerDateChangeRaw: this.handlePacerDateChangeRaw,
	      pacerSearch: this.state.pacerSearch,
	      buyDocketSheet: this.buyDocketSheet,
	      clearPacerSearchFilter: this.clearPacerSearchFilter
	    };
	
	    var docketEntriesProps = {
	      filterTable: function filterTable() {
	        return null;
	      },
	      entries: entries,
	      lastUpdated: lastUpdated,
	      showMissingDockets: showMissingDockets,
	      selectedDocket: selectedDocket,
	      redact: this.props.redact,
	      buyMissingDockets: this.buyMissingDockets,
	      onGetDocuments: this.onGetDocuments,
	      showRedactPopup: this.showRedactPopup,
	      case_uuid: this.props.case_uuid,
	      court_code: this.props.court_code,
	      case_number: this.props.case_number,
	      sortDockets: this.sortDockets,
	      updateClick: this.updateClick,
	      pastEntriesClick: this.pastEntriesClick,
	      latest_known_date_filed: header.latest_known_date_filed || '',
	      reloadDetails: this.reloadDetails,
	      keyword: this.state.search_keyword
	    };
	
	    var visibleDocketNums = _lodash2.default.get(entries, 'data', []).reduce(function (accum, next) {
	      // use docket_no to determine that it's not a missing entry type of docket
	      if (next.isVisible && next.docket_no) {
	        accum.push(next.docket_seq);
	      }
	      return accum;
	    }, []);
	
	    var docketsPaginatorProps = {
	      total_pages: _lodash2.default.get(entries, 'total_pages', 0),
	      visibleDocketNums: visibleDocketNums,
	      case_uuid: this.props.case_uuid,
	      court_code: this.props.court_code,
	      case_number: this.props.case_number,
	      selectedPageNum: this.state.selectedPageNum,
	      changePage: this.changePage,
	      onPopupClick: this.props.onPopupClick,
	      toggleHeader: this.toggleHeader,
	      getDocketParts: this.props.getDocketParts,
	      updateDocketParts: this.props.updateDocketParts
	    };
	
	    var name = this.props.popup.name;
	
	    var DocketsPopupComponentType = this.props.popup.show && this.popupForm[name];
	
	    var showPacerSearchBarClassName = this.state.showPacerSearchBar ? 'show-pacer-search-bar' : '';
	
	    var docketsTableProps = {
	      showPacerSearchBar: this.state.showPacerSearchBar,
	      DocketsPopupComponentType: DocketsPopupComponentType,
	      docketSearchBarProps: docketSearchBarProps,
	      docketFilterProps: docketFilterProps,
	      docketEntriesProps: docketEntriesProps,
	      showMissingDockets: showMissingDockets,
	      header: header,
	      docketsPaginatorProps: docketsPaginatorProps,
	      lastUpdated: lastUpdated,
	      error: this.props.error,
	      receipt: this.props.receipt,
	      popup: this.props.popup,
	      showPacerSearchBarClassName: showPacerSearchBarClassName,
	      collapseHeader: this.state.collapseHeader,
	      showRedactPopup: this.props.redact.showPopup,
	      closeRedactPopup: this.closeRedactPopup,
	      redact: this.redact,
	      reloadDetails: this.reloadDetails,
	      onPopupClick: this.props.onPopupClick
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'docket' },
	      _react2.default.createElement(_Notification2.default, null),
	      this.state.showPacerSearchBar && _react2.default.createElement(_DocketPacerSearchBar2.default, docketSearchBarProps),
	      header.status && _react2.default.createElement(
	        'div',
	        { className: showPacerSearchBarClassName },
	        _react2.default.createElement(_DocketFilters2.default, _extends({}, docketFilterProps, { caseUuid: docketEntriesProps.case_uuid })),
	        _react2.default.createElement(_DocketsPaginator2.default, _extends({}, docketsPaginatorProps, { hasToolbar: true }))
	      ),
	      header.status === 'loading' && _react2.default.createElement(
	        'div',
	        null,
	        this.state.showPacerSearchBar && _react2.default.createElement(
	          'div',
	          null,
	          'Contacting PACER...'
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_reactBootstrap.ProgressBar, { active: true, now: 100 })
	        )
	      ),
	      _react2.default.createElement(_DocketError2.default, { errors: this.props.error }),
	      header.status === 'done' && _react2.default.createElement(_DocketsTable2.default, docketsTableProps)
	    );
	  };
	
	  return Dockets;
	}(_react.Component);
	
	Dockets.defaultProps = {
	  purchase_right_away: false,
	  error: null,
	  receipt: null,
	  lastUpdated: null
	};
	
	Dockets.propTypes = {
	  case_uuid: _propTypes2.default.any.isRequired,
	  purchase_right_away: _propTypes2.default.bool,
	  dataReady: _propTypes2.default.bool.isRequired,
	  dockets: _propTypes2.default.object.isRequired,
	  docketParts: _propTypes2.default.object.isRequired,
	  popup: _propTypes2.default.object.isRequired,
	  header: _propTypes2.default.object.isRequired,
	  redact: _propTypes2.default.object.isRequired,
	  selectedDocket: _propTypes2.default.object.isRequired,
	  receipt: _propTypes2.default.any,
	  lastUpdated: _propTypes2.default.any,
	  error: _propTypes2.default.any,
	  court_code: _propTypes2.default.string.isRequired,
	  case_number: _propTypes2.default.string.isRequired,
	  entries: _propTypes2.default.object.isRequired,
	  onGetDocuments: _propTypes2.default.func.isRequired,
	  getDockets: _propTypes2.default.func.isRequired,
	  purchaseDockets: _propTypes2.default.func.isRequired,
	  resetDocketParts: _propTypes2.default.func.isRequired,
	  onPopupClick: _propTypes2.default.func.isRequired,
	  hasValidClientCode: _propTypes2.default.func.isRequired,
	  updateRedact: _propTypes2.default.func.isRequired,
	  deleteAndRepurchase: _propTypes2.default.func.isRequired,
	  filterDocketEntries: _propTypes2.default.func.isRequired,
	  updateDocketParts: _propTypes2.default.func.isRequired,
	  getDocketParts: _propTypes2.default.func.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var irSearch = state.get('irSearch').toJS();
	  var dockets = irSearch.data.reduce(function (accum, next) {
	    // eslint-disable-next-line
	    accum[next[0]] = next[1];
	    return accum;
	  }, {});
	
	  var _state$get$toJS = state.get('dockets').toJS(),
	      popup = _state$get$toJS.popup,
	      docketParts = _state$get$toJS.docketParts,
	      header = _state$get$toJS.header,
	      redact = _state$get$toJS.redact,
	      selectedDocket = _state$get$toJS.selectedDocket,
	      entries = _state$get$toJS.entries,
	      receipt = _state$get$toJS.receipt;
	
	  return {
	    dataReady: irSearch.data_ready,
	    dockets: dockets,
	    entries: entries,
	    receipt: receipt,
	    lastUpdated: irSearch.lastUpdated,
	    error: irSearch.error,
	    popup: popup,
	    docketParts: docketParts,
	    header: header,
	    redact: redact,
	    selectedDocket: selectedDocket
	  };
	};
	
	var mapDispatchToProps = {
	  onGetDocuments: docketActions.getDocuments,
	  resetDocketParts: docketActions.resetDocketParts,
	  onPopupClick: docketActions.togglePopup,
	  getDockets: docketActions.getDockets,
	  purchaseDockets: docketActions.purchaseDockets,
	  hasValidClientCode: _clientCodeAction.hasValidClientCode,
	  updateRedact: docketActions.updateRedact,
	  deleteAndRepurchase: docketActions.deleteAndRepurchase,
	  filterDocketEntries: docketActions.filterDocketEntries,
	  updateDocketParts: docketActions.updateDocketParts,
	  getDocketParts: docketActions.getDocketParts
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Dockets);

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _reactRedux = __webpack_require__(13);
	
	var _configureStore = __webpack_require__(102);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _AllPartsPrintPreview = __webpack_require__(133);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Docket/Popups/AllPartsPrintPreview', module).add('View', function () {
	  return _react2.default.createElement(
	    _reactRedux.Provider,
	    { store: (0, _configureStore2.default)() },
	    _react2.default.createElement(_AllPartsPrintPreview.AllPartsPrintPreview, {
	      docketParts: {
	        partsToPurchase: 18, // Number of parts that need purchasing, can be greater than number of dockets
	        totalParts: 27, // Total number of parts that will be bundled.
	        totalCost: 12.4, // Total cost for all purchases
	        parts: [1, 2, 3, 4, 5], // List of input Docket numbers ?
	        percentage: 99, // Current Step percent complete
	        step: 1, // Current Step number
	        status: 'done' // loading, done
	      },
	      buy: (0, _addonActions.action)('Buy'),
	      onClose: (0, _addonActions.action)('Close Popup'),
	      popup: { show: true },
	      reloadDetails: (0, _addonActions.action)('Reload Parts')
	    })
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _reactRedux = __webpack_require__(13);
	
	var _configureStore = __webpack_require__(102);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _DocketDetailsPurchaseForm = __webpack_require__(109);
	
	var _DocketDetailsPurchaseForm2 = _interopRequireDefault(_DocketDetailsPurchaseForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Docket/Popups/DocketDetailsPurchaseForm', module).add('View', function () {
	  return [_react2.default.createElement(
	    'h3',
	    null,
	    'Step 1'
	  ), _react2.default.createElement(
	    'p',
	    null,
	    'First, we look at price of all dockets'
	  ), _react2.default.createElement(_DocketDetailsPurchaseForm2.default, {
	    docketParts: {
	      parts: [1, 2, 3, 4, 5], // List of input Docket numbers ?
	      percentage: 57, // Current Step percent complete
	      step: 1, // Current Step number
	      status: 'loading' // loading, done
	    },
	    buy: (0, _addonActions.action)('Buy'),
	    showXfaWarning: true
	  }), _react2.default.createElement('hr', null), _react2.default.createElement(
	    'h3',
	    null,
	    'Step 1b'
	  ), _react2.default.createElement(
	    'p',
	    null,
	    'We show price for downloads, and user has to click to proceed'
	  ), _react2.default.createElement(
	    _reactRedux.Provider,
	    { store: (0, _configureStore2.default)() },
	    _react2.default.createElement(_DocketDetailsPurchaseForm2.default, {
	      docketParts: {
	        partsToPurchase: 18, // Number of parts that need purchasing, can be greater than number of dockets
	        totalParts: 27, // Total number of parts that will be bundled.
	        totalCost: 12.4, // Total cost for all purchases
	        parts: [1, 2, 3, 4, 5], // List of input Docket numbers ?
	        percentage: 99, // Current Step percent complete
	        step: 1, // Current Step number
	        status: 'done' // loading, done
	      },
	      buy: (0, _addonActions.action)('Buy'),
	      showXfaWarning: true
	    })
	  ), _react2.default.createElement('hr', null), _react2.default.createElement(
	    'h3',
	    null,
	    'Step 2'
	  ), _react2.default.createElement(
	    'p',
	    null,
	    'Then, we buy all the dockets'
	  ), _react2.default.createElement(_DocketDetailsPurchaseForm2.default, {
	    docketParts: {
	      totalParts: 27, // Total number of parts that will be bundled.
	      partsToPurchase: 7, // Number of parts that need purchasing, can be greater than number of dockets
	      // totalCost: 12.40,       // Total cost for all purchases
	      parts: [1, 2, 3, 4, 5],
	      percentage: 17,
	      step: 2,
	      status: 'loading',
	      alreadyPurchased: false // If there was no purchases to be made for step 2
	    },
	    buy: (0, _addonActions.action)('Buy'),
	    showXfaWarning: true
	  }), _react2.default.createElement('hr', null), _react2.default.createElement(
	    'h3',
	    null,
	    'Step 2 - Error'
	  ), _react2.default.createElement(
	    'p',
	    null,
	    'If an error occurred purchasing, the dialog shows the error'
	  ), _react2.default.createElement(_DocketDetailsPurchaseForm2.default, {
	    docketParts: {
	      totalParts: 27, // Total number of parts that will be bundled.
	      partsToPurchase: 7, // Number of parts that need purchasing, can be greater than number of dockets
	      // totalCost: 12.40,       // Total cost for all purchases
	      parts: [1, 2, 3, 4, 5],
	      percentage: 17,
	      step: 2,
	      status: 'done',
	      errors: ['No PACER Credentials for uid 123.'],
	      alreadyPurchased: false // If there was no purchases to be made for step 2
	    },
	    buy: (0, _addonActions.action)('Buy'),
	    showXfaWarning: true
	  }), _react2.default.createElement('hr', null), _react2.default.createElement(
	    'h3',
	    null,
	    'Step 3'
	  ), _react2.default.createElement(
	    'p',
	    null,
	    'Lastly we do some combining'
	  ), _react2.default.createElement(_DocketDetailsPurchaseForm2.default, {
	    docketParts: {
	      totalParts: 27, // Total number of parts that will be bundled.
	      partsToPurchase: 7, // Number of parts that need purchasing, can be greater than number of dockets
	      parts: [1, 2, 3, 4, 5],
	      percentage: 17,
	      step: 3,
	      status: 'loading',
	      purchased: 7, // Number of parts purchased for step 2
	      alreadyPurchased: false // If there was no purchases to be made for step 2
	    },
	    buy: (0, _addonActions.action)('Buy'),
	    showXfaWarning: true
	  }), _react2.default.createElement('hr', null), _react2.default.createElement(
	    'h3',
	    null,
	    'Final Message'
	  ), _react2.default.createElement(
	    'p',
	    null,
	    'In the end, we can show a link for download'
	  ), _react2.default.createElement(_DocketDetailsPurchaseForm2.default, {
	    docketParts: {
	      totalParts: 27, // Total number of parts that will be bundled.
	      partsToPurchase: 7, // Number of parts that need purchasing, can be greater than number of dockets
	      parts: [1, 2, 3, 4, 5],
	      percentage: 17,
	      step: 3,
	      status: 'done',
	      purchased: 7, // Number of parts purchased for step 2
	      alreadyPurchased: false, // If there was no purchases to be made for step 2
	      link: 'http://link-to-download'
	    },
	    buy: (0, _addonActions.action)('Buy'),
	    showXfaWarning: true
	  })];
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _reactRedux = __webpack_require__(13);
	
	var _configureStore = __webpack_require__(102);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _DownloadZipAllPdfsRangePopup = __webpack_require__(134);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Docket/Popups/DownloadZipAllPdfsRangePopup', module).add('View', function () {
	  return _react2.default.createElement(
	    _reactRedux.Provider,
	    { store: (0, _configureStore2.default)() },
	    _react2.default.createElement(_DownloadZipAllPdfsRangePopup.DownloadZipAllPdfsRangePopup, {
	      docketParts: {
	        partsToPurchase: 18, // Number of parts that need purchasing, can be greater than number of dockets
	        totalParts: 27, // Total number of parts that will be bundled.
	        totalCost: 12.4, // Total cost for all purchases
	        parts: [1, 2, 3, 4, 5], // List of input Docket numbers ?
	        percentage: 99, // Current Step percent complete
	        step: 1, // Current Step number
	        status: 'done' // loading, done
	      },
	      buy: (0, _addonActions.action)('Buy'),
	      onClose: (0, _addonActions.action)('Close Popup'),
	      popup: { show: true },
	      reloadDetails: (0, _addonActions.action)('Reload Parts')
	    })
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _reactRedux = __webpack_require__(13);
	
	var _configureStore = __webpack_require__(102);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _DownloadZipWithSubpartsPopup = __webpack_require__(135);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Docket/Popups/DownloadZipWithSubpartsPopup', module).add('View', function () {
	  return _react2.default.createElement(
	    _reactRedux.Provider,
	    { store: (0, _configureStore2.default)() },
	    _react2.default.createElement(_DownloadZipWithSubpartsPopup.DownloadZipWithSubpartsPopup, {
	      docketParts: {
	        partsToPurchase: 18, // Number of parts that need purchasing, can be greater than number of dockets
	        totalParts: 27, // Total number of parts that will be bundled.
	        totalCost: 12.4, // Total cost for all purchases
	        parts: [1, 2, 3, 4, 5], // List of input Docket numbers ?
	        percentage: 99, // Current Step percent complete
	        step: 1, // Current Step number
	        status: 'done' // loading, done
	      },
	      buy: (0, _addonActions.action)('Buy'),
	      onClose: (0, _addonActions.action)('Close Popup'),
	      popup: { show: true },
	      reloadDetails: (0, _addonActions.action)('Reload Parts')
	    })
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _reactRedux = __webpack_require__(13);
	
	var _configureStore = __webpack_require__(102);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _EmailAttachmentPurchaseForm = __webpack_require__(260);
	
	var _EmailAttachmentPurchaseForm2 = _interopRequireDefault(_EmailAttachmentPurchaseForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Docket/Popups/EmailAttachmentPurchaseForm', module).add('View', function () {
	  return [_react2.default.createElement(
	    'h3',
	    null,
	    'Step 1'
	  ), _react2.default.createElement(
	    'p',
	    null,
	    'First, we look at price of all PDFs'
	  ), _react2.default.createElement(_EmailAttachmentPurchaseForm2.default, {
	    docketParts: {
	      parts: [1, 2, 3, 4, 5], // List of input Docket numbers ?
	      percentage: 57, // Current Step percent complete
	      step: 1, // Current Step number
	      status: 'loading' // loading, done
	    },
	    buy: (0, _addonActions.action)('Buy'),
	    showXfaWarning: true
	  }), _react2.default.createElement('hr', null), _react2.default.createElement(
	    'h3',
	    null,
	    'Step 1b'
	  ), _react2.default.createElement(
	    'p',
	    null,
	    'We show price for downloads, and user has to click to proceed'
	  ), _react2.default.createElement(
	    _reactRedux.Provider,
	    { store: (0, _configureStore2.default)() },
	    _react2.default.createElement(_EmailAttachmentPurchaseForm2.default, {
	      docketParts: {
	        partsToPurchase: 18, // Number of parts that need purchasing, can be greater than number of dockets
	        totalParts: 27, // Total number of parts that will be bundled.
	        totalCost: 12.4, // Total cost for all purchases
	        parts: [1, 2, 3, 4, 5], // List of input Docket numbers ?
	        percentage: 99, // Current Step percent complete
	        step: 1, // Current Step number
	        status: 'done' // loading, done
	      },
	      buy: (0, _addonActions.action)('Buy')
	    })
	  ), _react2.default.createElement('hr', null), _react2.default.createElement(
	    'h3',
	    null,
	    'Step 2'
	  ), _react2.default.createElement(
	    'p',
	    null,
	    'Then, we buy all the dockets'
	  ), _react2.default.createElement(_EmailAttachmentPurchaseForm2.default, {
	    docketParts: {
	      totalParts: 27, // Total number of parts that will be bundled.
	      partsToPurchase: 7, // Number of parts that need purchasing, can be greater than number of dockets
	      // totalCost: 12.40,       // Total cost for all purchases
	      parts: [1, 2, 3, 4, 5],
	      percentage: 17,
	      step: 2,
	      status: 'loading',
	      alreadyPurchased: false // If there was no purchases to be made for step 2
	    },
	    buy: (0, _addonActions.action)('Buy')
	  }), _react2.default.createElement('hr', null), _react2.default.createElement(
	    'h3',
	    null,
	    'Step 2 - Error'
	  ), _react2.default.createElement(
	    'p',
	    null,
	    'If an error occurred purchasing, the dialog shows the error'
	  ), _react2.default.createElement(_EmailAttachmentPurchaseForm2.default, {
	    docketParts: {
	      totalParts: 27, // Total number of parts that will be bundled.
	      partsToPurchase: 7, // Number of parts that need purchasing, can be greater than number of dockets
	      // totalCost: 12.40,       // Total cost for all purchases
	      parts: [1, 2, 3, 4, 5],
	      percentage: 17,
	      step: 2,
	      status: 'done',
	      errors: ['No PACER Credentials for uid 123.'],
	      alreadyPurchased: false // If there was no purchases to be made for step 2
	    },
	    buy: (0, _addonActions.action)('Buy')
	  }), _react2.default.createElement('hr', null), _react2.default.createElement(
	    'h3',
	    null,
	    'Step 3'
	  ), _react2.default.createElement(
	    'p',
	    null,
	    'Lastly, we could be preparing and sending the message'
	  ), _react2.default.createElement(_EmailAttachmentPurchaseForm2.default, {
	    docketParts: {
	      totalParts: 27, // Total number of parts that will be bundled.
	      partsToPurchase: 7, // Number of parts that need purchasing, can be greater than number of dockets
	      parts: [1, 2, 3, 4, 5],
	      percentage: 17,
	      step: 3,
	      status: 'loading',
	      purchased: 7, // Number of parts purchased for step 2
	      alreadyPurchased: false // If there was no purchases to be made for step 2
	    },
	    buy: (0, _addonActions.action)('Buy')
	  })];
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _reactRedux = __webpack_require__(13);
	
	var _configureStore = __webpack_require__(102);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _EmailBulkModal = __webpack_require__(202);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Docket/Popups/EmailBulkModal', module).add('View', function () {
	  return _react2.default.createElement(
	    _reactRedux.Provider,
	    { store: (0, _configureStore2.default)() },
	    _react2.default.createElement(_EmailBulkModal.EmailBulkModal, {
	      topBarTitle: 'Email Combined PDFs',
	      onClose: (0, _addonActions.action)('Close Popup'),
	      emailActionName: (0, _addonActions.action)('emailPartsPdfCombined'),
	      docketParts: {
	        partsToPurchase: 18, // Number of parts that need purchasing, can be greater than number of dockets
	        totalParts: 27, // Total number of parts that will be bundled.
	        totalCost: 12.4, // Total cost for all purchases
	        parts: [1, 2, 3, 4, 5], // List of input Docket numbers ?
	        percentage: 99, // Current Step percent complete
	        step: 1, // Current Step number
	        status: 'done' // loading, done
	      },
	      popup: {
	        show: true,
	        data: {
	          case_uuid: 'orbtrain_460215',
	          court_code: 'orbtrain',
	          case_number: '3:19-bk-30014',
	          friendly_name: '',
	          sequence_number: '3.00000',
	          part_number: 1,
	          docket: {
	            docket_no: 3,
	            date_filed: '03/04/2019',
	            docket_text: 'Notice of Chapter 13 Bankruptcy Case and Notice of Meeting of Creditors Set\n             for 4/2/2019 at 09:00 AM at Chapter 13 Trustee, Portland, Chapter 13 Trustee Office, \n             222 SW Columbia St., #1700, Portland, OR 97201,Confirmation Hearing Set for 5/9/2019 at 09:00AM \n             at Courtroom #4, Portland, US Bankruptcy Court, Courtroom #4, 1050 SW 6th Ave., 7th Floor, Portland, \n             OR 97204. Proofs of Claims due by 5/13/2019. (kjh) (Entered: 03/04/2019)'
	          }
	        }
	      },
	      selectedDocket: null,
	      entries: null,
	      orderPdf: (0, _addonActions.action)('Order PDF'),
	      dispatch: (0, _addonActions.action)('dispatch')
	    })
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _reactRedux = __webpack_require__(13);
	
	var _configureStore = __webpack_require__(102);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _EmailPartModal = __webpack_require__(136);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Docket/Popups/EmailPartModal', module).add('View', function () {
	  return _react2.default.createElement(
	    _reactRedux.Provider,
	    { store: (0, _configureStore2.default)() },
	    _react2.default.createElement(_EmailPartModal.EmailPartModal, {
	      onClose: (0, _addonActions.action)('Close Popup'),
	      popup: {
	        show: true,
	        data: {
	          case_uuid: 'orbtrain_460215',
	          court_code: 'orbtrain',
	          case_number: '3:19-bk-30014',
	          friendly_name: '',
	          sequence_number: '3.00000',
	          part_number: 1,
	          docket: {
	            docket_no: 3,
	            date_filed: '03/04/2019',
	            docket_text: 'Notice of Chapter 13 Bankruptcy Case and Notice of Meeting of Creditors Set for \n            4/2/2019 at 09:00 AM at Chapter 13 Trustee, Portland, Chapter 13 Trustee Office, 222 SW Columbia St., \n            #1700, Portland, OR 97201,Confirmation Hearing Set for 5/9/2019 at 09:00AM at Courtroom #4, Portland, \n            US Bankruptcy Court, Courtroom #4, 1050 SW 6th Ave., 7th Floor, Portland, OR 97204. Proofs of Claims \n            due by 5/13/2019. (kjh) (Entered: 03/04/2019)'
	          }
	        }
	      },
	      selectedDocket: {
	        binder: {
	          documents: [{
	            number: 1,
	            download_url: 'Bankr.D.Or.TRAIN._3-19-bk-30014_3_2.pdf',
	            filename: 'Bankr.D.Or.TRAIN._3-19-bk-30014_3_2.pdf'
	          }]
	        }
	      },
	      orderPdf: (0, _addonActions.action)('Order PDF'),
	      onSendEmail: (0, _addonActions.action)('Send Email')
	    })
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _FilersCases = __webpack_require__(262);
	
	var _FilersCases2 = _interopRequireDefault(_FilersCases);
	
	var _filersArray = __webpack_require__(667);
	
	var _filersArray2 = _interopRequireDefault(_filersArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emptyProps = {
	  case_uuid: 'azbtest_2644',
	  purchase_right_away: false,
	  filers: [],
	  noDataFoundMessage: 'No parties have filed anything for this case',
	  dataReady: true,
	  dispatch: null,
	  lastUpdated: 1000,
	  error: null,
	  receipt: null
	};
	
	var samplefilersProps = {
	  case_uuid: 'azbtest_2644',
	  dataReady: true,
	  receipt: null,
	  lastUpdated: 1000,
	  error: null,
	  filers: _filersArray2.default,
	  dispatch: function dispatch() {
	    return (0, _addonActions.action)('dispatch');
	  },
	  purchaseData: function purchaseData() {
	    return (0, _addonActions.action)('purchaseData');
	  },
	  type: 'schedule',
	  sidebarData: {},
	  kloudless: {}
	};
	
	(0, _react3.storiesOf)('Case Menu/Filers', module).add('Loading', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Component can be in a loading state while we fetch data'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_FilersCases2.default, null)
	  );
	}).add('View', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'By default, we show a list of filers received form the API'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Page contains \'Find What\' input that searches through table of data.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'There is \'Premium Search\' button, which leads to the premium search url.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'We can refresh list by clicking the \'Update from Pacer\' button'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_FilersCases2.default, _extends({}, samplefilersProps, {
	      purchaseData: (0, _addonActions.action)('purchaseData')
	    }))
	  );
	}).add('No Data', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'If there is no data found, message is displayed.'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'We can refresh list by clicking the \'Update from Pacer\' button'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_FilersCases2.default, emptyProps)
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 667 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = [{
	  date_terminated: '',
	  name: 'FIRST TIME MORTGAGE',
	  type: 'Creditor',
	  date_added: '05/14/2007',
	  uri: 'https://ecf-test.azb.uscourts.gov/cgi-bin/FilerQry.pl?828211101082837-L_ShowDktSummaryList_1-0-55-10488-2644'
	}, {
	  type: 'Trustee',
	  date_added: '02/19/2007',
	  date_terminated: '07/02/2007',
	  name: 'DIANE MANN',
	  uri: 'https://ecf-test.azb.uscourts.gov/cgi-bin/FilerQry.pl?828211101082837-L_ShowDktSummaryList_1-0-11-3664-2644'
	}, {
	  name: 'Joseph Wayne Sample',
	  date_terminated: '',
	  date_added: '02/19/2007',
	  type: 'Debtor',
	  uri: 'https://ecf-test.azb.uscourts.gov/cgi-bin/FilerQry.pl?828211101082837-L_ShowDktSummaryList_1-0-3-7914-2644'
	}, {
	  name: 'Sarah Lynn Sample',
	  date_terminated: '',
	  date_added: '02/19/2007',
	  type: 'Joint Debtor',
	  uri: 'https://ecf-test.azb.uscourts.gov/cgi-bin/FilerQry.pl?828211101082837-L_ShowDktSummaryList_1-0-5-7915-2644'
	}, {
	  uri: 'https://ecf-test.azb.uscourts.gov/cgi-bin/FilerQry.pl?828211101082837-L_ShowDktSummaryList_1-0-8-1418-2644',
	  type: 'U.S. Trustee',
	  date_added: '02/19/2007',
	  date_terminated: '',
	  name: 'U.S. Trustee\'s Office'
	}];

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _History = __webpack_require__(394);
	
	var _History2 = _interopRequireDefault(_History);
	
	var _HistoryArray = __webpack_require__(669);
	
	var _HistoryArray2 = _interopRequireDefault(_HistoryArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: remove when removing from TextHighlight.jsx
	window.$ = function () {
	  return {
	    highlight: function highlight() {},
	    removeHighlight: function removeHighlight() {}
	  };
	};
	
	var emptyProps = {
	  case_uuid: 'azbtest_2644',
	  purchase_right_away: false,
	  history: [],
	  noDataFoundMessage: 'There are no transactions.',
	  dataReady: true,
	  dispatch: null,
	  lastUpdated: 1000,
	  error: null,
	  receipt: null,
	  dockets: {
	    data: [],
	    dataReady: false,
	    error: {},
	    lastUpdated: ''
	  }
	};
	
	var sampleHistorysProps = {
	  case_uuid: 'azbtest_2644',
	  closeEmailNotification: function closeEmailNotification() {
	    return (0, _addonActions.action)('closeEmailNotification');
	  },
	  currentUser: "1",
	  dataReady: true,
	  dispatch: function dispatch() {
	    return (0, _addonActions.action)('dispatch');
	  },
	  displayLoader: "",
	  docketFilterProps: { keyword: "", doc_range: "", startDate: null, endDate: null, onChange: function onChange() {
	      return (0, _addonActions.action)('onChange');
	    }, changeDate: function changeDate() {
	      return (0, _addonActions.action)('changeDate');
	    }, onChangeDateRaw: function onChangeDateRaw() {
	      return (0, _addonActions.action)('onChangeDateRaw');
	    } },
	  docketParts: { step: 0, purchased: 0, parts_to_purchase: 0, total_cost: 0, parts: 0 },
	  error: {},
	  getDocketData: function getDocketData() {
	    return (0, _addonActions.action)('getDocketData');
	  },
	  getDocketDatafromPacer: function getDocketDatafromPacer() {
	    return (0, _addonActions.action)('getDocketDatafromPacer');
	  },
	  getDocketDetails: function getDocketDetails() {
	    return (0, _addonActions.action)('getDocketDetails');
	  },
	  history: { total_pages: 10.01, page_size: 100, total_items: 1001, entries: _HistoryArray2.default, favoriteEmail: "rimzoni@gmail.com" },
	  historyEntriesProps: { entries: Array(100), history: { total_pages: 10.01, page_size: 100, total_items: 1001, entries: _HistoryArray2.default, favoriteEmail: "rimzoni@gmail.com" }, redactSeqNum: undefined, buyMissingDockets: undefined, getDocketDetails: function getDocketDetails() {
	      return (0, _addonActions.action)('getDocketDetails');
	    }, sortHistory: function sortHistory() {
	      return (0, _addonActions.action)('sortHistory');
	    } },
	  historyPaginatorProps: { history: { total_pages: 10.01, page_size: 100, total_items: 1001, entries: _HistoryArray2.default, favoriteEmail: "rimzoni@gmail.com" }, case_uuid: "debke_156594", selectedPageNum: 1, changePage: function changePage() {
	      return (0, _addonActions.action)('changePage');
	    }, dispatch: function dispatch() {
	      return (0, _addonActions.action)('dispatch');
	    } },
	  lastUpdated: undefined,
	  noDataFoundMessage: "No Transactions found.",
	  onPopupClick: function onPopupClick() {
	    return (0, _addonActions.action)('onPopupClick');
	  },
	  onSubmit: function onSubmit() {
	    return (0, _addonActions.action)('onSubmit');
	  },
	  onSubmitParser: function onSubmitParser() {
	    return (0, _addonActions.action)('onSubmitParser');
	  },
	  popup: { name: "EmailCombinedPdfPopup", show: false, data: _HistoryArray2.default },
	  purchaseData: function purchaseData() {
	    return (0, _addonActions.action)('purchaseData');
	  },
	  purchase_right_away: false,
	  receipt: null,
	  sendDocketViaEmail: function sendDocketViaEmail() {
	    return (0, _addonActions.action)('sendDocketViaEmail');
	  },
	  showEmailNotification: false,
	  showEmailPopup: false,
	  showPacerFilterSection: true,
	  showPubliclinkPopup: false,
	  tableSortProps: { sort_direction: "desc", sort_field: "date_filed" },
	  toggleEmailPopup: function toggleEmailPopup() {
	    return (0, _addonActions.action)('toggleEmailPopup');
	  },
	  togglePacerFilterSection: function togglePacerFilterSection() {
	    return (0, _addonActions.action)('togglePacerFilterSection');
	  },
	  togglePublicLinkPopup: function togglePublicLinkPopup() {
	    return (0, _addonActions.action)('togglePublicLinkPopup');
	  },
	  type: "history"
	};
	
	var sampleHistorysWithDocketsProps = {};
	
	var sampleDocketsEmailProps = {};
	
	var sampleDocketsPubliclProps = {};
	
	(0, _react3.storiesOf)('Case Menu/History', module).add('Loading', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Component can be in a loading state while we fetch data'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_History2.default, null)
	  );
	}).add('View', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'By default, we show a list of history received form the parser API'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Page contains \'Find What\' input that searches through table of data.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'There is \'Premium Search\' button, which leads to the premium search url.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'There is \'Pacer filter\' section, that searches transactions from pacer api.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'There is \'Parser filter\' section, that searches transactions from parser api.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'We can refresh list by clicking the \'Update from Pacer\' button'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_History2.default, sampleHistorysProps)
	  );
	});
	// .add('View Docket Details', () => (
	//   <div>
	//     <h3>On click docket number Docket Details row is being displayed</h3>
	//     <hr />
	//     <History
	//       {...sampleHistorysWithDocketsProps}
	//       purchaseData={action('purchaseData')}
	//      />
	//   </div>
	// ))
	// .add('View Docket Details - email popup', () => (
	//   <div>
	//     <h3>On click email icon Share Docket popup is displayed</h3>
	//     <hr />
	//     <History
	//       {...sampleDocketsEmailProps}
	//       purchaseData={action('purchaseData')}
	//      />
	//   </div>
	// ))
	// .add('View Docket Details - public link popup', () => (
	//   <div>
	//     <h3>On click email icon Public Link popup is displayed</h3>
	//     <hr />
	//     <History
	//       {...sampleDocketsPubliclProps}
	//       purchaseData={action('purchaseData')}
	//      />
	//   </div>
	// ))
	// .add('No Data', () => (
	//   <div>
	//     <h3>If there is no data found, message is displayed.</h3>
	//     <hr />
	//     <h4>We can refresh list by clicking the 'Update from Pacer' button</h4>
	//     <hr />
	
	//     <History {...emptyProps} />
	//   </div>
	// ));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 669 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = [{
	    "meta": {
	        "date_filed": "07/31/2018",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545958158.50098,
	        "docket_text": "Affidavit/Declaration of Service <i>re: Post-Confirmation Report for the Quarter Ending June 2018</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017767441'>997</a>) Filed by KiOR, Inc.. (Steele, Amanda)",
	        "docket_no": 998,
	        "docket_seq": "998.00000",
	        "date_terminated": null,
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017769532",
	        "purchased": 2
	    },
	    "text": {
	        "date_filed": "07/31/2018",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545958158.50098,
	        "docket_text": "Affidavit/Declaration of Service <i>re: Post-Confirmation Report for the Quarter Ending June 2018</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017767441'>997</a>) Filed by KiOR, Inc.. (Steele, Amanda)",
	        "docket_no": 998,
	        "docket_seq": "998.00000",
	        "date_terminated": null,
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017769532"
	    }
	}, {
	    "meta": {
	        "date_filed": "07/30/2018",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545958158.50098,
	        "docket_text": "Post-Confirmation Report <i>for the Quarter Ending June 2018</i> Filed by KiOR, Inc.. (Steele, Amanda)",
	        "docket_no": 997,
	        "date_terminated": null,
	        "docket_seq": "997.00000",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017767441",
	        "purchased": 2
	    },
	    "text": {
	        "date_filed": "07/30/2018",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545958158.50098,
	        "docket_text": "Post-Confirmation Report <i>for the Quarter Ending June 2018</i> Filed by KiOR, Inc.. (Steele, Amanda)",
	        "docket_no": 997,
	        "date_terminated": null,
	        "docket_seq": "997.00000",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017767441"
	    }
	}, {
	    "meta": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017727673",
	        "date_filed": "07/10/2018",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545958158.50098,
	        "docket_no": 996,
	        "docket_text": "Records Transmittal & Receipt - SF135. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "docket_seq": "996.00000",
	        "date_terminated": null,
	        "purchased": 0
	    },
	    "text": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017727673",
	        "date_filed": "07/10/2018",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545958158.50098,
	        "docket_no": 996,
	        "docket_text": "Records Transmittal & Receipt - SF135. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "docket_seq": "996.00000",
	        "date_terminated": null
	    }
	}, {
	    "text": {
	        "case_uuid": "debke_156594",
	        "date_filed": "07/02/2018",
	        "docket_seq": "995.00000",
	        "date_terminated": null,
	        "timestamp": 1545958158.50098,
	        "docket_no": 995,
	        "docket_text": "Transcript regarding Hearing Held 6/26/18 RE: Final Decree. Remote electronic access to the transcript is restricted until 10/1/2018. The transcript may be viewed at the Bankruptcy Court Clerk&#039;s Office. For information about how to contact the transcriber, call the Clerk&#039;s Office or Contact the Court Reporter/Transcriber, eScribers, LLC at Telephone number 973-406-2250. Notice of Intent to Request Redaction Deadline Due By 7/9/2018. Redaction Request Due By 7/23/2018. Redacted Transcript Submission Due By 8/2/2018. Transcript access will be restricted through 10/1/2018. (Murin, Leslie)",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017714695"
	    },
	    "meta": {
	        "case_uuid": "debke_156594",
	        "date_filed": "07/02/2018",
	        "docket_seq": "995.00000",
	        "date_terminated": null,
	        "timestamp": 1545958158.50098,
	        "docket_no": 995,
	        "docket_text": "Transcript regarding Hearing Held 6/26/18 RE: Final Decree. Remote electronic access to the transcript is restricted until 10/1/2018. The transcript may be viewed at the Bankruptcy Court Clerk&#039;s Office. For information about how to contact the transcriber, call the Clerk&#039;s Office or Contact the Court Reporter/Transcriber, eScribers, LLC at Telephone number 973-406-2250. Notice of Intent to Request Redaction Deadline Due By 7/9/2018. Redaction Request Due By 7/23/2018. Redacted Transcript Submission Due By 8/2/2018. Transcript access will be restricted through 10/1/2018. (Murin, Leslie)",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017714695",
	        "purchased": 0
	    }
	}, {
	    "text": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017705842",
	        "docket_text": "Affidavit/Declaration of Service <i>of Konstantina Haidopoulos</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017704391'>988</a>). Filed by Epiq Bankruptcy Solutions LLC. (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017704391'>988</a>) (Garabato, Sid)",
	        "docket_no": 994,
	        "timestamp": 1545958158.50098,
	        "docket_seq": "994.00000",
	        "date_terminated": null,
	        "date_filed": "06/27/2018",
	        "case_uuid": "debke_156594"
	    },
	    "meta": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017705842",
	        "docket_text": "Affidavit/Declaration of Service <i>of Konstantina Haidopoulos</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017704391'>988</a>). Filed by Epiq Bankruptcy Solutions LLC. (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017704391'>988</a>) (Garabato, Sid)",
	        "docket_no": 994,
	        "timestamp": 1545958158.50098,
	        "docket_seq": "994.00000",
	        "date_terminated": null,
	        "date_filed": "06/27/2018",
	        "case_uuid": "debke_156594",
	        "purchased": 0
	    }
	}, {
	    "text": {
	        "timestamp": 1545958158.50098,
	        "docket_text": "Affidavit/Declaration of Service <i>of Konstantina Haidopoulos</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017697669'>982</a>). Filed by Epiq Bankruptcy Solutions LLC. (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017697669'>982</a>) (Garabato, Sid)",
	        "docket_no": 993,
	        "date_terminated": null,
	        "docket_seq": "993.00000",
	        "date_filed": "06/27/2018",
	        "case_uuid": "debke_156594",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017705834"
	    },
	    "meta": {
	        "timestamp": 1545958158.50098,
	        "docket_text": "Affidavit/Declaration of Service <i>of Konstantina Haidopoulos</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017697669'>982</a>). Filed by Epiq Bankruptcy Solutions LLC. (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017697669'>982</a>) (Garabato, Sid)",
	        "docket_no": 993,
	        "date_terminated": null,
	        "docket_seq": "993.00000",
	        "date_filed": "06/27/2018",
	        "case_uuid": "debke_156594",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017705834",
	        "purchased": 0
	    }
	}, {
	    "text": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017705607",
	        "case_uuid": "debke_156594",
	        "date_filed": "06/27/2018",
	        "date_terminated": null,
	        "docket_seq": "992.00000",
	        "docket_text": "Final Claims Register <i>Numerical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "docket_no": 992,
	        "timestamp": 1545958158.50098
	    },
	    "meta": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017705607",
	        "case_uuid": "debke_156594",
	        "date_filed": "06/27/2018",
	        "date_terminated": null,
	        "docket_seq": "992.00000",
	        "docket_text": "Final Claims Register <i>Numerical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "docket_no": 992,
	        "timestamp": 1545958158.50098,
	        "purchased": 0
	    }
	}, {
	    "meta": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017705595",
	        "docket_no": 991,
	        "docket_text": "Final Claims Register <i>Alphabetical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "timestamp": 1545958158.50098,
	        "date_terminated": null,
	        "docket_seq": "991.00000",
	        "date_filed": "06/27/2018",
	        "case_uuid": "debke_156594",
	        "purchased": 0
	    },
	    "text": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017705595",
	        "docket_no": 991,
	        "docket_text": "Final Claims Register <i>Alphabetical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "timestamp": 1545958158.50098,
	        "date_terminated": null,
	        "docket_seq": "991.00000",
	        "date_filed": "06/27/2018",
	        "case_uuid": "debke_156594"
	    }
	}, {
	    "text": {
	        "case_uuid": "debke_156594",
	        "date_filed": "06/26/2018",
	        "date_terminated": null,
	        "docket_seq": "990.00000",
	        "docket_text": "Corrected Objection to the Debtors Motion to Close and Exit This Chapter 11 Bankruptcy Case and Support for the Liquidating Trustee to have extended Termination Date for 60 days past the Hearing Date, June 26, 2018 (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017692211'>979</a>) Filed by Robert Dalton (Murin, Leslie) Modified Text on 6/29/2018 (LB).",
	        "docket_no": 990,
	        "timestamp": 1545958158.50098,
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017705406"
	    },
	    "meta": {
	        "case_uuid": "debke_156594",
	        "date_filed": "06/26/2018",
	        "date_terminated": null,
	        "docket_seq": "990.00000",
	        "docket_text": "Corrected Objection to the Debtors Motion to Close and Exit This Chapter 11 Bankruptcy Case and Support for the Liquidating Trustee to have extended Termination Date for 60 days past the Hearing Date, June 26, 2018 (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017692211'>979</a>) Filed by Robert Dalton (Murin, Leslie) Modified Text on 6/29/2018 (LB).",
	        "docket_no": 990,
	        "timestamp": 1545958158.50098,
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017705406",
	        "purchased": 0
	    }
	}, {
	    "meta": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017705021",
	        "docket_seq": "989.00000",
	        "date_terminated": null,
	        "timestamp": 1545958158.50098,
	        "docket_no": 989,
	        "docket_text": "Certificate of Service <i>to Order Granting Liquidating Trustee&#039;s Motion for Entry of An Order Extending The Trust Termination Date</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017698607'>983</a>) Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. (Gwynne, Kurt)",
	        "case_uuid": "debke_156594",
	        "date_filed": "06/26/2018",
	        "purchased": 0
	    },
	    "text": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017705021",
	        "docket_seq": "989.00000",
	        "date_terminated": null,
	        "timestamp": 1545958158.50098,
	        "docket_no": 989,
	        "docket_text": "Certificate of Service <i>to Order Granting Liquidating Trustee&#039;s Motion for Entry of An Order Extending The Trust Termination Date</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017698607'>983</a>) Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. (Gwynne, Kurt)",
	        "case_uuid": "debke_156594",
	        "date_filed": "06/26/2018"
	    }
	}, {
	    "text": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017704391",
	        "timestamp": 1545958158.50098,
	        "docket_text": "Order (I) Granting Final Decree Closing the Chapter 11 Case of KiOR, Inc. and (II) Terminating Claims and Noticing Services. (related document <a href='https://ecf.deb.uscourts.gov/doc1/042017662744'>972</a>). Order Signed on 6/26/2018. (DMC)",
	        "docket_no": 988,
	        "docket_seq": "988.00000",
	        "date_terminated": null,
	        "date_filed": "06/26/2018",
	        "case_uuid": "debke_156594"
	    },
	    "meta": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017704391",
	        "timestamp": 1545958158.50098,
	        "docket_text": "Order (I) Granting Final Decree Closing the Chapter 11 Case of KiOR, Inc. and (II) Terminating Claims and Noticing Services. (related document <a href='https://ecf.deb.uscourts.gov/doc1/042017662744'>972</a>). Order Signed on 6/26/2018. (DMC)",
	        "docket_no": 988,
	        "docket_seq": "988.00000",
	        "date_terminated": null,
	        "date_filed": "06/26/2018",
	        "case_uuid": "debke_156594",
	        "purchased": 0
	    }
	}, {
	    "meta": {
	        "docket_seq": "987.00000",
	        "date_terminated": null,
	        "timestamp": 1545958158.50098,
	        "docket_no": 987,
	        "docket_text": "Hearing Held 6/26/2018 at 2:00 p.m. Court Sign-In Sheet (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017663850'>974</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017697669'>982</a>) (DMC)",
	        "case_uuid": "debke_156594",
	        "date_filed": "06/26/2018",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017704376",
	        "purchased": 0
	    },
	    "text": {
	        "docket_seq": "987.00000",
	        "date_terminated": null,
	        "timestamp": 1545958158.50098,
	        "docket_no": 987,
	        "docket_text": "Hearing Held 6/26/2018 at 2:00 p.m. Court Sign-In Sheet (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017663850'>974</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017697669'>982</a>) (DMC)",
	        "case_uuid": "debke_156594",
	        "date_filed": "06/26/2018",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017704376"
	    }
	}, {
	    "text": {
	        "case_uuid": "debke_156594",
	        "date_filed": "06/26/2018",
	        "docket_seq": "986.00000",
	        "date_terminated": null,
	        "docket_no": 986,
	        "docket_text": "Affidavit/Declaration of Service <i>of Forrest Kuffer</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017696321'>981</a>). Filed by Epiq Bankruptcy Solutions LLC. (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017696321'>981</a>) (Garabato, Sid)",
	        "timestamp": 1545958158.50098,
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017704233"
	    },
	    "meta": {
	        "case_uuid": "debke_156594",
	        "date_filed": "06/26/2018",
	        "docket_seq": "986.00000",
	        "date_terminated": null,
	        "docket_no": 986,
	        "docket_text": "Affidavit/Declaration of Service <i>of Forrest Kuffer</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017696321'>981</a>). Filed by Epiq Bankruptcy Solutions LLC. (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017696321'>981</a>) (Garabato, Sid)",
	        "timestamp": 1545958158.50098,
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017704233",
	        "purchased": 0
	    }
	}, {
	    "meta": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017704162",
	        "case_uuid": "debke_156594",
	        "date_filed": "06/26/2018",
	        "docket_seq": "985.00000",
	        "date_terminated": null,
	        "docket_text": "PDF with attached Audio File. Instructions for opening the attached Audio File can be found on the Court&#039;s website under Case Info/Digital Audio in CM/ECF. Court Date & Time [ 6/26/2018 2:00:10 PM ]. File Size [ 9372 KB ]. Run Time [ 00:39:03 ]. (audio_admin).",
	        "docket_no": 985,
	        "timestamp": 1545958158.50098,
	        "purchased": 0
	    },
	    "text": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017704162",
	        "case_uuid": "debke_156594",
	        "date_filed": "06/26/2018",
	        "docket_seq": "985.00000",
	        "date_terminated": null,
	        "docket_text": "PDF with attached Audio File. Instructions for opening the attached Audio File can be found on the Court&#039;s website under Case Info/Digital Audio in CM/ECF. Court Date & Time [ 6/26/2018 2:00:10 PM ]. File Size [ 9372 KB ]. Run Time [ 00:39:03 ]. (audio_admin).",
	        "docket_no": 985,
	        "timestamp": 1545958158.50098
	    }
	}, {
	    "text": {
	        "docket_uri": null,
	        "date_filed": "06/25/2018",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545950343.0324,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 984,
	        "docket_seq": "984.00000",
	        "date_terminated": null
	    },
	    "meta": {
	        "docket_uri": null,
	        "date_filed": "06/25/2018",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545950343.0324,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 984,
	        "docket_seq": "984.00000",
	        "date_terminated": null,
	        "purchased": 0
	    }
	}, {
	    "text": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017698607",
	        "docket_text": "Order Granting Liquidating Trustee&#039;s Motion for Entry of An Order Extending The Trust Termination Date. (Related Doc # <a href='https://ecf.deb.uscourts.gov/doc1/042017660441'>968</a>) Order Signed on 6/22/2018. (DMC)",
	        "docket_no": 983,
	        "timestamp": 1545958158.50098,
	        "date_terminated": null,
	        "docket_seq": "983.00000",
	        "date_filed": "06/22/2018",
	        "case_uuid": "debke_156594"
	    },
	    "meta": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017698607",
	        "docket_text": "Order Granting Liquidating Trustee&#039;s Motion for Entry of An Order Extending The Trust Termination Date. (Related Doc # <a href='https://ecf.deb.uscourts.gov/doc1/042017660441'>968</a>) Order Signed on 6/22/2018. (DMC)",
	        "docket_no": 983,
	        "timestamp": 1545958158.50098,
	        "date_terminated": null,
	        "docket_seq": "983.00000",
	        "date_filed": "06/22/2018",
	        "case_uuid": "debke_156594",
	        "purchased": 0
	    }
	}, {
	    "meta": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017697669",
	        "case_uuid": "debke_156594",
	        "date_filed": "06/22/2018",
	        "date_terminated": null,
	        "docket_seq": "982.00000",
	        "docket_no": 982,
	        "docket_text": "Notice of Agenda of Matters Scheduled for Hearing Filed by KiOR, Inc.. Hearing scheduled for 6/26/2018 at 02:00 PM at US Bankruptcy Court, 824 Market St., 5th Fl., Courtroom &#035;6, Wilmington, Delaware. (Steele, Amanda)",
	        "timestamp": 1545958158.50098,
	        "purchased": 0
	    },
	    "text": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017697669",
	        "case_uuid": "debke_156594",
	        "date_filed": "06/22/2018",
	        "date_terminated": null,
	        "docket_seq": "982.00000",
	        "docket_no": 982,
	        "docket_text": "Notice of Agenda of Matters Scheduled for Hearing Filed by KiOR, Inc.. Hearing scheduled for 6/26/2018 at 02:00 PM at US Bankruptcy Court, 824 Market St., 5th Fl., Courtroom &#035;6, Wilmington, Delaware. (Steele, Amanda)",
	        "timestamp": 1545958158.50098
	    }
	}, {
	    "text": {
	        "docket_no": 981,
	        "docket_text": "Reply <i>// Reorganized Debtor&#039;s Reply in Support of Reorganized Debtor&#039;s Motion for Order (I) Granting Final Decree Closing the Chapter 11 Case of KiOR, Inc. and (II) Terminating Claims and Noticing Services</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017662744'>972</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017692211'>979</a>) Filed by KiOR, Inc. (Attachments: # <a href='https://ecf.deb.uscourts.gov/doc1/042117696322'>1</a> Exhibit A # <a href='https://ecf.deb.uscourts.gov/doc1/042117696323'>2</a> Exhibit B) (Steele, Amanda)",
	        "timestamp": 1545958158.50098,
	        "date_terminated": null,
	        "docket_seq": "981.00000",
	        "date_filed": "06/21/2018",
	        "case_uuid": "debke_156594",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017696321"
	    },
	    "meta": {
	        "docket_no": 981,
	        "docket_text": "Reply <i>// Reorganized Debtor&#039;s Reply in Support of Reorganized Debtor&#039;s Motion for Order (I) Granting Final Decree Closing the Chapter 11 Case of KiOR, Inc. and (II) Terminating Claims and Noticing Services</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017662744'>972</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017692211'>979</a>) Filed by KiOR, Inc. (Attachments: # <a href='https://ecf.deb.uscourts.gov/doc1/042117696322'>1</a> Exhibit A # <a href='https://ecf.deb.uscourts.gov/doc1/042117696323'>2</a> Exhibit B) (Steele, Amanda)",
	        "timestamp": 1545958158.50098,
	        "date_terminated": null,
	        "docket_seq": "981.00000",
	        "date_filed": "06/21/2018",
	        "case_uuid": "debke_156594",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017696321",
	        "purchased": 0
	    }
	}, {
	    "meta": {
	        "docket_seq": "980.00000",
	        "date_terminated": null,
	        "timestamp": 1545958158.50098,
	        "docket_no": 980,
	        "docket_text": "Certificate of No Objection <i>to Liquidating Trustee&#039;s Motion for Entry of an Order Extending the Trust Termination Date</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017660441'>968</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017663850'>974</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017692211'>979</a>) Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. (Gwynne, Kurt)",
	        "case_uuid": "debke_156594",
	        "date_filed": "06/21/2018",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017695289",
	        "purchased": 0
	    },
	    "text": {
	        "docket_seq": "980.00000",
	        "date_terminated": null,
	        "timestamp": 1545958158.50098,
	        "docket_no": 980,
	        "docket_text": "Certificate of No Objection <i>to Liquidating Trustee&#039;s Motion for Entry of an Order Extending the Trust Termination Date</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017660441'>968</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017663850'>974</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017692211'>979</a>) Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. (Gwynne, Kurt)",
	        "case_uuid": "debke_156594",
	        "date_filed": "06/21/2018",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017695289"
	    }
	}, {
	    "text": {
	        "timestamp": 1545958158.50098,
	        "docket_no": 979,
	        "docket_text": "Objection <i>to the Debtors Motion to Close and Exit This Chapter 11 Bankruptcy Case and Support for the Liquidating Trustee to have extended Termination Date for 60 days past the Hearing Date, June 26, 2018.</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042015029817'>328</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042015240428'>588</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042015266529'>618</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042015267619'>621</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017660441'>968</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017662744'>972</a>) Filed by Robert Dalton (DMC)",
	        "docket_seq": "979.00000",
	        "date_terminated": null,
	        "date_filed": "06/20/2018",
	        "case_uuid": "debke_156594",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017692211"
	    },
	    "meta": {
	        "timestamp": 1545958158.50098,
	        "docket_no": 979,
	        "docket_text": "Objection <i>to the Debtors Motion to Close and Exit This Chapter 11 Bankruptcy Case and Support for the Liquidating Trustee to have extended Termination Date for 60 days past the Hearing Date, June 26, 2018.</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042015029817'>328</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042015240428'>588</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042015266529'>618</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042015267619'>621</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017660441'>968</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017662744'>972</a>) Filed by Robert Dalton (DMC)",
	        "docket_seq": "979.00000",
	        "date_terminated": null,
	        "date_filed": "06/20/2018",
	        "case_uuid": "debke_156594",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017692211",
	        "purchased": 0
	    }
	}, {
	    "text": {
	        "docket_text": "Affidavit/Declaration of Service <i>of Forrest Kuffer</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017662744'>972</a>). Filed by Epiq Bankruptcy Solutions LLC. (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017662744'>972</a>) (Garabato, Sid)",
	        "docket_no": 978,
	        "timestamp": 1545958158.50098,
	        "date_terminated": null,
	        "docket_seq": "978.00000",
	        "date_filed": "06/11/2018",
	        "case_uuid": "debke_156594",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017670418"
	    },
	    "meta": {
	        "docket_text": "Affidavit/Declaration of Service <i>of Forrest Kuffer</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017662744'>972</a>). Filed by Epiq Bankruptcy Solutions LLC. (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017662744'>972</a>) (Garabato, Sid)",
	        "docket_no": 978,
	        "timestamp": 1545958158.50098,
	        "date_terminated": null,
	        "docket_seq": "978.00000",
	        "date_filed": "06/11/2018",
	        "case_uuid": "debke_156594",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017670418",
	        "purchased": 0
	    }
	}, {
	    "text": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017670392",
	        "case_uuid": "debke_156594",
	        "date_filed": "06/11/2018",
	        "docket_seq": "977.00000",
	        "date_terminated": null,
	        "timestamp": 1545958158.50098,
	        "docket_no": 977,
	        "docket_text": "Affidavit/Declaration of Service <i>of Konstantina Haidopoulos</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017657922'>961</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017658258'>962</a>). Filed by Epiq Bankruptcy Solutions LLC. (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017657922'>961</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017658258'>962</a>) (Garabato, Sid)"
	    },
	    "meta": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017670392",
	        "case_uuid": "debke_156594",
	        "date_filed": "06/11/2018",
	        "docket_seq": "977.00000",
	        "date_terminated": null,
	        "timestamp": 1545958158.50098,
	        "docket_no": 977,
	        "docket_text": "Affidavit/Declaration of Service <i>of Konstantina Haidopoulos</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017657922'>961</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017658258'>962</a>). Filed by Epiq Bankruptcy Solutions LLC. (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017657922'>961</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017658258'>962</a>) (Garabato, Sid)",
	        "purchased": 0
	    }
	}, {
	    "text": {
	        "docket_uri": null,
	        "date_filed": "06/11/2018",
	        "case_uuid": "debke_156594",
	        "docket_no": 976,
	        "docket_text": "Standing Order/Transcripts",
	        "timestamp": 1545950342.25225,
	        "docket_seq": "976.00000",
	        "date_terminated": null
	    },
	    "meta": {
	        "docket_uri": null,
	        "date_filed": "06/11/2018",
	        "case_uuid": "debke_156594",
	        "docket_no": 976,
	        "docket_text": "Standing Order/Transcripts",
	        "timestamp": 1545950342.25225,
	        "docket_seq": "976.00000",
	        "date_terminated": null,
	        "purchased": 0
	    }
	}, {
	    "text": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017668507",
	        "date_filed": "06/08/2018",
	        "case_uuid": "debke_156594",
	        "docket_no": 975,
	        "docket_text": "Affidavit/Declaration of Service <i>re: Post-Confirmation Quarterly Reports</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017662482'>970</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017662485'>971</a>) Filed by KiOR, Inc.. (Steele, Amanda)",
	        "timestamp": 1545958158.50098,
	        "date_terminated": null,
	        "docket_seq": "975.00000"
	    },
	    "meta": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017668507",
	        "date_filed": "06/08/2018",
	        "case_uuid": "debke_156594",
	        "docket_no": 975,
	        "docket_text": "Affidavit/Declaration of Service <i>re: Post-Confirmation Quarterly Reports</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017662482'>970</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017662485'>971</a>) Filed by KiOR, Inc.. (Steele, Amanda)",
	        "timestamp": 1545958158.50098,
	        "date_terminated": null,
	        "docket_seq": "975.00000",
	        "purchased": 0
	    }
	}, {
	    "meta": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017663850",
	        "docket_text": "Notice of Hearing <i>/[CORRECTED] Notice of Liquidating Trustee&#039;s Motion for Entry of an Order Extending the Trust Termination Date</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017660441'>968</a>) Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. Hearing scheduled for 6/26/2018 at 02:00 PM at US Bankruptcy Court, 824 Market St., 5th Fl., Courtroom &#035;6, Wilmington, Delaware. Objections due by 6/19/2018. (Attachments: # <a href='https://ecf.deb.uscourts.gov/doc1/042117663851'>1</a> Certificate of Service) (Gwynne, Kurt)",
	        "docket_no": 974,
	        "timestamp": 1545958158.50098,
	        "date_terminated": null,
	        "docket_seq": "974.00000",
	        "date_filed": "06/07/2018",
	        "case_uuid": "debke_156594",
	        "purchased": 0
	    },
	    "text": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017663850",
	        "docket_text": "Notice of Hearing <i>/[CORRECTED] Notice of Liquidating Trustee&#039;s Motion for Entry of an Order Extending the Trust Termination Date</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017660441'>968</a>) Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. Hearing scheduled for 6/26/2018 at 02:00 PM at US Bankruptcy Court, 824 Market St., 5th Fl., Courtroom &#035;6, Wilmington, Delaware. Objections due by 6/19/2018. (Attachments: # <a href='https://ecf.deb.uscourts.gov/doc1/042117663851'>1</a> Certificate of Service) (Gwynne, Kurt)",
	        "docket_no": 974,
	        "timestamp": 1545958158.50098,
	        "date_terminated": null,
	        "docket_seq": "974.00000",
	        "date_filed": "06/07/2018",
	        "case_uuid": "debke_156594"
	    }
	}, {
	    "meta": {
	        "date_filed": "06/07/2018",
	        "case_uuid": "debke_156594",
	        "docket_no": 973,
	        "docket_text": "Certificate of Service <i>to Report and Declaration of Kurt F. Gwynne, as Liquidating Trustee, Regarding Activities of the KiOR Liquidating Trust</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017660420'>967</a>) Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. (Gwynne, Kurt)",
	        "timestamp": 1545958158.50098,
	        "docket_seq": "973.00000",
	        "date_terminated": null,
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017663831",
	        "purchased": 0
	    },
	    "text": {
	        "date_filed": "06/07/2018",
	        "case_uuid": "debke_156594",
	        "docket_no": 973,
	        "docket_text": "Certificate of Service <i>to Report and Declaration of Kurt F. Gwynne, as Liquidating Trustee, Regarding Activities of the KiOR Liquidating Trust</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017660420'>967</a>) Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. (Gwynne, Kurt)",
	        "timestamp": 1545958158.50098,
	        "docket_seq": "973.00000",
	        "date_terminated": null,
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017663831"
	    }
	}, {
	    "text": {
	        "docket_seq": "972.00000",
	        "date_terminated": null,
	        "docket_no": 972,
	        "docket_text": "Motion for Final Decree <i>//Reorganized Debtor&#039;s Motion for Order (I) Granting Final Decree Closing the Chapter 11 Case of KiOR, Inc. and (II) Terminating Claims and Noticing Services</i> Filed by KiOR, Inc.. Hearing scheduled for 6/26/2018 at 02:00 PM at US Bankruptcy Court, 824 Market St., 5th Fl., Courtroom &#035;6, Wilmington, Delaware. Objections due by 6/19/2018. (Attachments: # <a href='https://ecf.deb.uscourts.gov/doc1/042117662745'>1</a> Notice # <a href='https://ecf.deb.uscourts.gov/doc1/042117662746'>2</a> Exhibit A # <a href='https://ecf.deb.uscourts.gov/doc1/042117662747'>3</a> Exhibit B) (Steele, Amanda)",
	        "timestamp": 1545958158.50098,
	        "case_uuid": "debke_156594",
	        "date_filed": "06/06/2018",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017662744"
	    },
	    "meta": {
	        "docket_seq": "972.00000",
	        "date_terminated": null,
	        "docket_no": 972,
	        "docket_text": "Motion for Final Decree <i>//Reorganized Debtor&#039;s Motion for Order (I) Granting Final Decree Closing the Chapter 11 Case of KiOR, Inc. and (II) Terminating Claims and Noticing Services</i> Filed by KiOR, Inc.. Hearing scheduled for 6/26/2018 at 02:00 PM at US Bankruptcy Court, 824 Market St., 5th Fl., Courtroom &#035;6, Wilmington, Delaware. Objections due by 6/19/2018. (Attachments: # <a href='https://ecf.deb.uscourts.gov/doc1/042117662745'>1</a> Notice # <a href='https://ecf.deb.uscourts.gov/doc1/042117662746'>2</a> Exhibit A # <a href='https://ecf.deb.uscourts.gov/doc1/042117662747'>3</a> Exhibit B) (Steele, Amanda)",
	        "timestamp": 1545958158.50098,
	        "case_uuid": "debke_156594",
	        "date_filed": "06/06/2018",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017662744",
	        "purchased": 0
	    }
	}, {
	    "text": {
	        "date_filed": "06/06/2018",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545958158.50098,
	        "docket_text": "Post-Confirmation Report <i>for the Quarter Ending March 31, 2018</i> Filed by KiOR, Inc.. (Steele, Amanda)",
	        "docket_no": 971,
	        "date_terminated": null,
	        "docket_seq": "971.00000",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017662485"
	    },
	    "meta": {
	        "date_filed": "06/06/2018",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545958158.50098,
	        "docket_text": "Post-Confirmation Report <i>for the Quarter Ending March 31, 2018</i> Filed by KiOR, Inc.. (Steele, Amanda)",
	        "docket_no": 971,
	        "date_terminated": null,
	        "docket_seq": "971.00000",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017662485",
	        "purchased": 0
	    }
	}, {
	    "meta": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017662482",
	        "date_filed": "06/06/2018",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545958158.50098,
	        "docket_text": "Post-Confirmation Report <i>(Amended) for the Quarter Ending December 31, 2017</i> Filed by KiOR, Inc.. (Steele, Amanda)",
	        "docket_no": 970,
	        "docket_seq": "970.00000",
	        "date_terminated": null,
	        "purchased": 0
	    },
	    "text": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017662482",
	        "date_filed": "06/06/2018",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545958158.50098,
	        "docket_text": "Post-Confirmation Report <i>(Amended) for the Quarter Ending December 31, 2017</i> Filed by KiOR, Inc.. (Steele, Amanda)",
	        "docket_no": 970,
	        "docket_seq": "970.00000",
	        "date_terminated": null
	    }
	}, {
	    "meta": {
	        "date_terminated": null,
	        "docket_seq": "969.00000",
	        "docket_no": 969,
	        "docket_text": "Affidavit/Declaration of Service <i>re: Post-Confirmation Quarterly Reports</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017659177'>963</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017659180'>964</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017659195'>965</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017659208'>966</a>) Filed by KiOR, Inc.. (Steele, Amanda)",
	        "timestamp": 1545958158.50098,
	        "case_uuid": "debke_156594",
	        "date_filed": "06/06/2018",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017661551",
	        "purchased": 0
	    },
	    "text": {
	        "date_terminated": null,
	        "docket_seq": "969.00000",
	        "docket_no": 969,
	        "docket_text": "Affidavit/Declaration of Service <i>re: Post-Confirmation Quarterly Reports</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017659177'>963</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017659180'>964</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017659195'>965</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017659208'>966</a>) Filed by KiOR, Inc.. (Steele, Amanda)",
	        "timestamp": 1545958158.50098,
	        "case_uuid": "debke_156594",
	        "date_filed": "06/06/2018",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017661551"
	    }
	}, {
	    "text": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017660441",
	        "docket_seq": "968.00000",
	        "date_terminated": null,
	        "timestamp": 1545958158.50098,
	        "docket_text": "Motion to Extend <i>/Liquidating Trustee&#039;s Motion for Entry of an Order Extending the Trust Termination Date</i> Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. Hearing scheduled for 6/26/2018 at 02:00 PM at US Bankruptcy Court, 824 Market St., 5th Fl., Courtroom &#035;6, Wilmington, Delaware. Objections due by 6/19/2018. (Attachments: # <a href='https://ecf.deb.uscourts.gov/doc1/042117660442'>1</a> Notice # <a href='https://ecf.deb.uscourts.gov/doc1/042117660443'>2</a> Proposed Form of Order # <a href='https://ecf.deb.uscourts.gov/doc1/042117660444'>3</a> Certificate of Service) (Gwynne, Kurt)",
	        "docket_no": 968,
	        "case_uuid": "debke_156594",
	        "date_filed": "06/05/2018"
	    },
	    "meta": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017660441",
	        "docket_seq": "968.00000",
	        "date_terminated": null,
	        "timestamp": 1545958158.50098,
	        "docket_text": "Motion to Extend <i>/Liquidating Trustee&#039;s Motion for Entry of an Order Extending the Trust Termination Date</i> Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. Hearing scheduled for 6/26/2018 at 02:00 PM at US Bankruptcy Court, 824 Market St., 5th Fl., Courtroom &#035;6, Wilmington, Delaware. Objections due by 6/19/2018. (Attachments: # <a href='https://ecf.deb.uscourts.gov/doc1/042117660442'>1</a> Notice # <a href='https://ecf.deb.uscourts.gov/doc1/042117660443'>2</a> Proposed Form of Order # <a href='https://ecf.deb.uscourts.gov/doc1/042117660444'>3</a> Certificate of Service) (Gwynne, Kurt)",
	        "docket_no": 968,
	        "case_uuid": "debke_156594",
	        "date_filed": "06/05/2018",
	        "purchased": 0
	    }
	}, {
	    "meta": {
	        "case_uuid": "debke_156594",
	        "date_filed": "06/05/2018",
	        "docket_seq": "967.00000",
	        "date_terminated": null,
	        "docket_no": 967,
	        "docket_text": "Post-Confirmation Report <i>/ Report and Declaration of Kurt F. Gwynne, as Liquidating Trustee, Regarding Activities of the KiOR Liquidating Trust</i> Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. (Gwynne, Kurt)",
	        "timestamp": 1545958158.50098,
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017660420",
	        "purchased": 0
	    },
	    "text": {
	        "case_uuid": "debke_156594",
	        "date_filed": "06/05/2018",
	        "docket_seq": "967.00000",
	        "date_terminated": null,
	        "docket_no": 967,
	        "docket_text": "Post-Confirmation Report <i>/ Report and Declaration of Kurt F. Gwynne, as Liquidating Trustee, Regarding Activities of the KiOR Liquidating Trust</i> Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. (Gwynne, Kurt)",
	        "timestamp": 1545958158.50098,
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017660420"
	    }
	}, {
	    "text": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017659208",
	        "timestamp": 1545958158.50098,
	        "docket_no": 966,
	        "docket_text": "Post-Confirmation Report <i>for the Quarter Ending December 31, 2017</i> Filed by KiOR, Inc.. (Steele, Amanda)",
	        "date_terminated": null,
	        "docket_seq": "966.00000",
	        "date_filed": "06/05/2018",
	        "case_uuid": "debke_156594"
	    },
	    "meta": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017659208",
	        "timestamp": 1545958158.50098,
	        "docket_no": 966,
	        "docket_text": "Post-Confirmation Report <i>for the Quarter Ending December 31, 2017</i> Filed by KiOR, Inc.. (Steele, Amanda)",
	        "date_terminated": null,
	        "docket_seq": "966.00000",
	        "date_filed": "06/05/2018",
	        "case_uuid": "debke_156594",
	        "purchased": 0
	    }
	}, {
	    "meta": {
	        "date_filed": "06/05/2018",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545958158.50098,
	        "docket_no": 965,
	        "docket_text": "Post-Confirmation Report <i>for the Quarter Ending September 30, 2017</i> Filed by KiOR, Inc.. (Steele, Amanda)",
	        "date_terminated": null,
	        "docket_seq": "965.00000",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017659195",
	        "purchased": 0
	    },
	    "text": {
	        "date_filed": "06/05/2018",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545958158.50098,
	        "docket_no": 965,
	        "docket_text": "Post-Confirmation Report <i>for the Quarter Ending September 30, 2017</i> Filed by KiOR, Inc.. (Steele, Amanda)",
	        "date_terminated": null,
	        "docket_seq": "965.00000",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017659195"
	    }
	}, {
	    "text": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017659180",
	        "date_filed": "06/05/2018",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545958158.50098,
	        "docket_no": 964,
	        "docket_text": "Post-Confirmation Report <i>for the Quarter Ending June 30, 2017</i> Filed by KiOR, Inc.. (Steele, Amanda)",
	        "docket_seq": "964.00000",
	        "date_terminated": null
	    },
	    "meta": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017659180",
	        "date_filed": "06/05/2018",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545958158.50098,
	        "docket_no": 964,
	        "docket_text": "Post-Confirmation Report <i>for the Quarter Ending June 30, 2017</i> Filed by KiOR, Inc.. (Steele, Amanda)",
	        "docket_seq": "964.00000",
	        "date_terminated": null,
	        "purchased": 0
	    }
	}, {
	    "text": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017659177",
	        "docket_no": 963,
	        "docket_text": "Post-Confirmation Report <i>for the Quarter Ending March 31, 2017</i> Filed by KiOR, Inc.. (Steele, Amanda)",
	        "timestamp": 1545958158.50098,
	        "docket_seq": "963.00000",
	        "date_terminated": null,
	        "date_filed": "06/05/2018",
	        "case_uuid": "debke_156594"
	    },
	    "meta": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017659177",
	        "docket_no": 963,
	        "docket_text": "Post-Confirmation Report <i>for the Quarter Ending March 31, 2017</i> Filed by KiOR, Inc.. (Steele, Amanda)",
	        "timestamp": 1545958158.50098,
	        "docket_seq": "963.00000",
	        "date_terminated": null,
	        "date_filed": "06/05/2018",
	        "case_uuid": "debke_156594",
	        "purchased": 0
	    }
	}, {
	    "text": {
	        "case_uuid": "debke_156594",
	        "date_filed": "06/04/2018",
	        "docket_seq": "962.00000",
	        "date_terminated": null,
	        "timestamp": 1545958158.50098,
	        "docket_no": 962,
	        "docket_text": "Order Scheduling Omnibus Hearings. All hearings will be held at US Bankruptcy Court, 824 Market St., 5th Fl., Courtroom #6, Wilmington, Delaware . Omnibus Hearings scheduled for 6/26/2018 at 02:00 PM. Signed on 6/4/2018. (CAS)",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017658258"
	    },
	    "meta": {
	        "case_uuid": "debke_156594",
	        "date_filed": "06/04/2018",
	        "docket_seq": "962.00000",
	        "date_terminated": null,
	        "timestamp": 1545958158.50098,
	        "docket_no": 962,
	        "docket_text": "Order Scheduling Omnibus Hearings. All hearings will be held at US Bankruptcy Court, 824 Market St., 5th Fl., Courtroom #6, Wilmington, Delaware . Omnibus Hearings scheduled for 6/26/2018 at 02:00 PM. Signed on 6/4/2018. (CAS)",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017658258",
	        "purchased": 0
	    }
	}, {
	    "meta": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017657922",
	        "date_terminated": null,
	        "docket_seq": "961.00000",
	        "timestamp": 1545958158.50098,
	        "docket_no": 961,
	        "docket_text": "Certification of Counsel <i>Regarding Scheduling of Omnibus Hearing Date</i> Filed by KiOR, Inc.. (Steele, Amanda)",
	        "case_uuid": "debke_156594",
	        "date_filed": "06/04/2018",
	        "purchased": 0
	    },
	    "text": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017657922",
	        "date_terminated": null,
	        "docket_seq": "961.00000",
	        "timestamp": 1545958158.50098,
	        "docket_no": 961,
	        "docket_text": "Certification of Counsel <i>Regarding Scheduling of Omnibus Hearing Date</i> Filed by KiOR, Inc.. (Steele, Amanda)",
	        "case_uuid": "debke_156594",
	        "date_filed": "06/04/2018"
	    }
	}, {
	    "text": {
	        "case_uuid": "debke_156594",
	        "date_filed": "05/29/2018",
	        "date_terminated": null,
	        "docket_seq": "960.00000",
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 960,
	        "timestamp": 1545950339.42332,
	        "docket_uri": null
	    },
	    "meta": {
	        "case_uuid": "debke_156594",
	        "date_filed": "05/29/2018",
	        "date_terminated": null,
	        "docket_seq": "960.00000",
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 960,
	        "timestamp": 1545950339.42332,
	        "docket_uri": null,
	        "purchased": 0
	    }
	}, {
	    "text": {
	        "docket_uri": null,
	        "date_filed": "05/14/2018",
	        "case_uuid": "debke_156594",
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 959,
	        "timestamp": 1545950339.38072,
	        "docket_seq": "959.00000",
	        "date_terminated": null
	    },
	    "meta": {
	        "docket_uri": null,
	        "date_filed": "05/14/2018",
	        "case_uuid": "debke_156594",
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 959,
	        "timestamp": 1545950339.38072,
	        "docket_seq": "959.00000",
	        "date_terminated": null,
	        "purchased": 0
	    }
	}, {
	    "text": {
	        "docket_seq": "958.00000",
	        "date_terminated": null,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 958,
	        "timestamp": 1545950339.32642,
	        "case_uuid": "debke_156594",
	        "date_filed": "04/30/2018",
	        "docket_uri": null
	    },
	    "meta": {
	        "docket_seq": "958.00000",
	        "date_terminated": null,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 958,
	        "timestamp": 1545950339.32642,
	        "case_uuid": "debke_156594",
	        "date_filed": "04/30/2018",
	        "docket_uri": null,
	        "purchased": 0
	    }
	}, {
	    "meta": {
	        "date_filed": "04/23/2018",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545958158.50098,
	        "docket_no": 957,
	        "docket_text": "Quarterly Claims Register <i>Numerical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "docket_seq": "957.00000",
	        "date_terminated": null,
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017568124",
	        "purchased": 0
	    },
	    "text": {
	        "date_filed": "04/23/2018",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545958158.50098,
	        "docket_no": 957,
	        "docket_text": "Quarterly Claims Register <i>Numerical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "docket_seq": "957.00000",
	        "date_terminated": null,
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017568124"
	    }
	}, {
	    "text": {
	        "docket_no": 956,
	        "docket_text": "Quarterly Claims Register <i>Alphabetical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "timestamp": 1545958158.50098,
	        "date_terminated": null,
	        "docket_seq": "956.00000",
	        "date_filed": "04/23/2018",
	        "case_uuid": "debke_156594",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017568119"
	    },
	    "meta": {
	        "docket_no": 956,
	        "docket_text": "Quarterly Claims Register <i>Alphabetical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "timestamp": 1545958158.50098,
	        "date_terminated": null,
	        "docket_seq": "956.00000",
	        "date_filed": "04/23/2018",
	        "case_uuid": "debke_156594",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017568119",
	        "purchased": 0
	    }
	}, {
	    "text": {
	        "docket_uri": null,
	        "date_filed": "04/16/2018",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545950339.15873,
	        "docket_no": 955,
	        "docket_text": "Standing Order/Transcripts",
	        "date_terminated": null,
	        "docket_seq": "955.00000"
	    },
	    "meta": {
	        "docket_uri": null,
	        "date_filed": "04/16/2018",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545950339.15873,
	        "docket_no": 955,
	        "docket_text": "Standing Order/Transcripts",
	        "date_terminated": null,
	        "docket_seq": "955.00000",
	        "purchased": 0
	    }
	}, {
	    "meta": {
	        "case_uuid": "debke_156594",
	        "date_filed": "04/02/2018",
	        "docket_seq": "954.00000",
	        "date_terminated": null,
	        "docket_no": 954,
	        "docket_text": "Standing Order/Transcripts",
	        "timestamp": 1545950339.11511,
	        "docket_uri": null,
	        "purchased": 0
	    },
	    "text": {
	        "case_uuid": "debke_156594",
	        "date_filed": "04/02/2018",
	        "docket_seq": "954.00000",
	        "date_terminated": null,
	        "docket_no": 954,
	        "docket_text": "Standing Order/Transcripts",
	        "timestamp": 1545950339.11511,
	        "docket_uri": null
	    }
	}, {
	    "text": {
	        "case_uuid": "debke_156594",
	        "date_filed": "03/19/2018",
	        "date_terminated": null,
	        "docket_seq": "953.00000",
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 953,
	        "timestamp": 1545950339.04632,
	        "docket_uri": null
	    },
	    "meta": {
	        "case_uuid": "debke_156594",
	        "date_filed": "03/19/2018",
	        "date_terminated": null,
	        "docket_seq": "953.00000",
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 953,
	        "timestamp": 1545950339.04632,
	        "docket_uri": null,
	        "purchased": 0
	    }
	}, {
	    "text": {
	        "case_uuid": "debke_156594",
	        "date_filed": "03/05/2018",
	        "docket_seq": "952.00000",
	        "date_terminated": null,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 952,
	        "timestamp": 1545950338.99167,
	        "docket_uri": null
	    },
	    "meta": {
	        "case_uuid": "debke_156594",
	        "date_filed": "03/05/2018",
	        "docket_seq": "952.00000",
	        "date_terminated": null,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 952,
	        "timestamp": 1545950338.99167,
	        "docket_uri": null,
	        "purchased": 0
	    }
	}, {
	    "text": {
	        "docket_uri": null,
	        "date_filed": "02/20/2018",
	        "case_uuid": "debke_156594",
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 951,
	        "timestamp": 1545950338.88714,
	        "docket_seq": "951.00000",
	        "date_terminated": null
	    },
	    "meta": {
	        "docket_uri": null,
	        "date_filed": "02/20/2018",
	        "case_uuid": "debke_156594",
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 951,
	        "timestamp": 1545950338.88714,
	        "docket_seq": "951.00000",
	        "date_terminated": null,
	        "purchased": 0
	    }
	}, {
	    "text": {
	        "docket_seq": "950.00000",
	        "date_terminated": null,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 950,
	        "timestamp": 1545950338.84431,
	        "case_uuid": "debke_156594",
	        "date_filed": "02/05/2018",
	        "docket_uri": null
	    },
	    "meta": {
	        "docket_seq": "950.00000",
	        "date_terminated": null,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 950,
	        "timestamp": 1545950338.84431,
	        "case_uuid": "debke_156594",
	        "date_filed": "02/05/2018",
	        "docket_uri": null,
	        "purchased": 0
	    }
	}, {
	    "text": {
	        "docket_uri": null,
	        "docket_seq": "949.00000",
	        "date_terminated": null,
	        "timestamp": 1545950338.76031,
	        "docket_no": 949,
	        "docket_text": "Standing Order/Transcripts",
	        "case_uuid": "debke_156594",
	        "date_filed": "01/22/2018"
	    },
	    "meta": {
	        "docket_uri": null,
	        "docket_seq": "949.00000",
	        "date_terminated": null,
	        "timestamp": 1545950338.76031,
	        "docket_no": 949,
	        "docket_text": "Standing Order/Transcripts",
	        "case_uuid": "debke_156594",
	        "date_filed": "01/22/2018",
	        "purchased": 0
	    }
	}, {
	    "text": {
	        "date_terminated": null,
	        "docket_seq": "948.00000",
	        "docket_no": 948,
	        "docket_text": "Quarterly Claims Register <i>Numerical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "timestamp": 1545958158.50098,
	        "case_uuid": "debke_156594",
	        "date_filed": "01/17/2018",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017357891"
	    },
	    "meta": {
	        "date_terminated": null,
	        "docket_seq": "948.00000",
	        "docket_no": 948,
	        "docket_text": "Quarterly Claims Register <i>Numerical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "timestamp": 1545958158.50098,
	        "case_uuid": "debke_156594",
	        "date_filed": "01/17/2018",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017357891",
	        "purchased": 1
	    }
	}, {
	    "text": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017357882",
	        "date_filed": "01/17/2018",
	        "case_uuid": "debke_156594",
	        "docket_text": "Quarterly Claims Register <i>Alphabetical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "docket_no": 947,
	        "timestamp": 1545958158.50098,
	        "date_terminated": null,
	        "docket_seq": "947.00000"
	    },
	    "meta": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017357882",
	        "date_filed": "01/17/2018",
	        "case_uuid": "debke_156594",
	        "docket_text": "Quarterly Claims Register <i>Alphabetical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "docket_no": 947,
	        "timestamp": 1545958158.50098,
	        "date_terminated": null,
	        "docket_seq": "947.00000",
	        "purchased": 1
	    }
	}, {
	    "text": {
	        "docket_uri": null,
	        "date_terminated": null,
	        "docket_seq": "946.00000",
	        "docket_no": 946,
	        "docket_text": "Standing Order/Transcripts",
	        "timestamp": 1545950338.54274,
	        "case_uuid": "debke_156594",
	        "date_filed": "01/08/2018"
	    },
	    "meta": {
	        "docket_uri": null,
	        "date_terminated": null,
	        "docket_seq": "946.00000",
	        "docket_no": 946,
	        "docket_text": "Standing Order/Transcripts",
	        "timestamp": 1545950338.54274,
	        "case_uuid": "debke_156594",
	        "date_filed": "01/08/2018",
	        "purchased": 0
	    }
	}, {
	    "text": {
	        "docket_uri": null,
	        "case_uuid": "debke_156594",
	        "date_filed": "12/11/2017",
	        "docket_seq": "945.00000",
	        "date_terminated": null,
	        "docket_no": 945,
	        "docket_text": "Standing Order/Transcripts",
	        "timestamp": 1545950338.49636
	    },
	    "meta": {
	        "docket_uri": null,
	        "case_uuid": "debke_156594",
	        "date_filed": "12/11/2017",
	        "docket_seq": "945.00000",
	        "date_terminated": null,
	        "docket_no": 945,
	        "docket_text": "Standing Order/Transcripts",
	        "timestamp": 1545950338.49636,
	        "purchased": 0
	    }
	}, {
	    "meta": {
	        "docket_uri": null,
	        "date_terminated": null,
	        "docket_seq": "944.00000",
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 944,
	        "timestamp": 1545950338.42577,
	        "case_uuid": "debke_156594",
	        "date_filed": "11/27/2017",
	        "purchased": 0
	    },
	    "text": {
	        "docket_uri": null,
	        "date_terminated": null,
	        "docket_seq": "944.00000",
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 944,
	        "timestamp": 1545950338.42577,
	        "case_uuid": "debke_156594",
	        "date_filed": "11/27/2017"
	    }
	}, {
	    "text": {
	        "docket_seq": "943.00000",
	        "date_terminated": null,
	        "timestamp": 1545950338.37841,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 943,
	        "case_uuid": "debke_156594",
	        "date_filed": "11/13/2017",
	        "docket_uri": null
	    },
	    "meta": {
	        "docket_seq": "943.00000",
	        "date_terminated": null,
	        "timestamp": 1545950338.37841,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 943,
	        "case_uuid": "debke_156594",
	        "date_filed": "11/13/2017",
	        "docket_uri": null,
	        "purchased": 0
	    }
	}, {
	    "meta": {
	        "date_filed": "10/30/2017",
	        "case_uuid": "debke_156594",
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 942,
	        "timestamp": 1545950338.32783,
	        "docket_seq": "942.00000",
	        "date_terminated": null,
	        "docket_uri": null,
	        "purchased": 0
	    },
	    "text": {
	        "date_filed": "10/30/2017",
	        "case_uuid": "debke_156594",
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 942,
	        "timestamp": 1545950338.32783,
	        "docket_seq": "942.00000",
	        "date_terminated": null,
	        "docket_uri": null
	    }
	}, {
	    "text": {
	        "case_uuid": "debke_156594",
	        "date_filed": "10/16/2017",
	        "date_terminated": null,
	        "docket_seq": "941.00000",
	        "timestamp": 1545950338.29227,
	        "docket_no": 941,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_uri": null
	    },
	    "meta": {
	        "case_uuid": "debke_156594",
	        "date_filed": "10/16/2017",
	        "date_terminated": null,
	        "docket_seq": "941.00000",
	        "timestamp": 1545950338.29227,
	        "docket_no": 941,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_uri": null,
	        "purchased": 0
	    }
	}, {
	    "meta": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017142323",
	        "timestamp": 1545958158.50098,
	        "docket_text": "Quarterly Claims Register <i>Numerical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "docket_no": 940,
	        "docket_seq": "940.00000",
	        "date_terminated": null,
	        "date_filed": "10/12/2017",
	        "case_uuid": "debke_156594",
	        "purchased": 1
	    },
	    "text": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017142323",
	        "timestamp": 1545958158.50098,
	        "docket_text": "Quarterly Claims Register <i>Numerical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "docket_no": 940,
	        "docket_seq": "940.00000",
	        "date_terminated": null,
	        "date_filed": "10/12/2017",
	        "case_uuid": "debke_156594"
	    }
	}, {
	    "meta": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017142316",
	        "docket_text": "Quarterly Claims Register <i>Alphabetical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "docket_no": 939,
	        "timestamp": 1545958158.50098,
	        "docket_seq": "939.00000",
	        "date_terminated": null,
	        "date_filed": "10/12/2017",
	        "case_uuid": "debke_156594",
	        "purchased": 1
	    },
	    "text": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017142316",
	        "docket_text": "Quarterly Claims Register <i>Alphabetical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "docket_no": 939,
	        "timestamp": 1545958158.50098,
	        "docket_seq": "939.00000",
	        "date_terminated": null,
	        "date_filed": "10/12/2017",
	        "case_uuid": "debke_156594"
	    }
	}, {
	    "meta": {
	        "docket_uri": null,
	        "case_uuid": "debke_156594",
	        "date_filed": "10/02/2017",
	        "docket_seq": "938.00000",
	        "date_terminated": null,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 938,
	        "timestamp": 1545950338.0455,
	        "purchased": 0
	    },
	    "text": {
	        "docket_uri": null,
	        "case_uuid": "debke_156594",
	        "date_filed": "10/02/2017",
	        "docket_seq": "938.00000",
	        "date_terminated": null,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 938,
	        "timestamp": 1545950338.0455
	    }
	}, {
	    "meta": {
	        "case_uuid": "debke_156594",
	        "date_filed": "09/18/2017",
	        "date_terminated": null,
	        "docket_seq": "937.00000",
	        "timestamp": 1545950337.94578,
	        "docket_no": 937,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_uri": null,
	        "purchased": 0
	    },
	    "text": {
	        "case_uuid": "debke_156594",
	        "date_filed": "09/18/2017",
	        "date_terminated": null,
	        "docket_seq": "937.00000",
	        "timestamp": 1545950337.94578,
	        "docket_no": 937,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_uri": null
	    }
	}, {
	    "meta": {
	        "docket_uri": null,
	        "case_uuid": "debke_156594",
	        "date_filed": "09/05/2017",
	        "date_terminated": null,
	        "docket_seq": "936.00000",
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 936,
	        "timestamp": 1545950337.91007,
	        "purchased": 0
	    },
	    "text": {
	        "docket_uri": null,
	        "case_uuid": "debke_156594",
	        "date_filed": "09/05/2017",
	        "date_terminated": null,
	        "docket_seq": "936.00000",
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 936,
	        "timestamp": 1545950337.91007
	    }
	}, {
	    "text": {
	        "docket_uri": null,
	        "docket_seq": "935.00000",
	        "date_terminated": null,
	        "timestamp": 1545950337.87544,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 935,
	        "case_uuid": "debke_156594",
	        "date_filed": "08/21/2017"
	    },
	    "meta": {
	        "docket_uri": null,
	        "docket_seq": "935.00000",
	        "date_terminated": null,
	        "timestamp": 1545950337.87544,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 935,
	        "case_uuid": "debke_156594",
	        "date_filed": "08/21/2017",
	        "purchased": 0
	    }
	}, {
	    "meta": {
	        "docket_seq": "934.00000",
	        "date_terminated": null,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 934,
	        "timestamp": 1545950337.81194,
	        "case_uuid": "debke_156594",
	        "date_filed": "07/24/2017",
	        "docket_uri": null,
	        "purchased": 0
	    },
	    "text": {
	        "docket_seq": "934.00000",
	        "date_terminated": null,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 934,
	        "timestamp": 1545950337.81194,
	        "case_uuid": "debke_156594",
	        "date_filed": "07/24/2017",
	        "docket_uri": null
	    }
	}, {
	    "text": {
	        "docket_seq": "933.00000",
	        "date_terminated": null,
	        "timestamp": 1545958158.50098,
	        "docket_text": "Quarterly Claims Register <i>Numerical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "docket_no": 933,
	        "case_uuid": "debke_156594",
	        "date_filed": "07/17/2017",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016951355"
	    },
	    "meta": {
	        "docket_seq": "933.00000",
	        "date_terminated": null,
	        "timestamp": 1545958158.50098,
	        "docket_text": "Quarterly Claims Register <i>Numerical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "docket_no": 933,
	        "case_uuid": "debke_156594",
	        "date_filed": "07/17/2017",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016951355",
	        "purchased": 1
	    }
	}, {
	    "text": {
	        "case_uuid": "debke_156594",
	        "date_filed": "07/17/2017",
	        "date_terminated": null,
	        "docket_seq": "932.00000",
	        "docket_no": 932,
	        "docket_text": "Quarterly Claims Register <i>Alphabetical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "timestamp": 1545958158.50098,
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016951352"
	    },
	    "meta": {
	        "case_uuid": "debke_156594",
	        "date_filed": "07/17/2017",
	        "date_terminated": null,
	        "docket_seq": "932.00000",
	        "docket_no": 932,
	        "docket_text": "Quarterly Claims Register <i>Alphabetical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "timestamp": 1545958158.50098,
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016951352",
	        "purchased": 1
	    }
	}, {
	    "meta": {
	        "docket_uri": null,
	        "timestamp": 1545950337.60993,
	        "docket_no": 931,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_seq": "931.00000",
	        "date_terminated": null,
	        "date_filed": "07/10/2017",
	        "case_uuid": "debke_156594",
	        "purchased": 0
	    },
	    "text": {
	        "docket_uri": null,
	        "timestamp": 1545950337.60993,
	        "docket_no": 931,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_seq": "931.00000",
	        "date_terminated": null,
	        "date_filed": "07/10/2017",
	        "case_uuid": "debke_156594"
	    }
	}, {
	    "text": {
	        "docket_uri": null,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 930,
	        "timestamp": 1545950337.57022,
	        "date_terminated": null,
	        "docket_seq": "930.00000",
	        "date_filed": "06/26/2017",
	        "case_uuid": "debke_156594"
	    },
	    "meta": {
	        "docket_uri": null,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 930,
	        "timestamp": 1545950337.57022,
	        "date_terminated": null,
	        "docket_seq": "930.00000",
	        "date_filed": "06/26/2017",
	        "case_uuid": "debke_156594",
	        "purchased": 0
	    }
	}, {
	    "text": {
	        "docket_uri": null,
	        "date_filed": "06/12/2017",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545950337.52552,
	        "docket_no": 929,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_seq": "929.00000",
	        "date_terminated": null
	    },
	    "meta": {
	        "docket_uri": null,
	        "date_filed": "06/12/2017",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545950337.52552,
	        "docket_no": 929,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_seq": "929.00000",
	        "date_terminated": null,
	        "purchased": 0
	    }
	}, {
	    "meta": {
	        "case_uuid": "debke_156594",
	        "date_filed": "05/30/2017",
	        "date_terminated": null,
	        "docket_seq": "928.00000",
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 928,
	        "timestamp": 1545950337.15763,
	        "docket_uri": null,
	        "purchased": 0
	    },
	    "text": {
	        "case_uuid": "debke_156594",
	        "date_filed": "05/30/2017",
	        "date_terminated": null,
	        "docket_seq": "928.00000",
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 928,
	        "timestamp": 1545950337.15763,
	        "docket_uri": null
	    }
	}, {
	    "meta": {
	        "docket_uri": null,
	        "docket_seq": "927.00000",
	        "date_terminated": null,
	        "timestamp": 1545950336.99531,
	        "docket_no": 927,
	        "docket_text": "Standing Order/Transcripts",
	        "case_uuid": "debke_156594",
	        "date_filed": "05/15/2017",
	        "purchased": 0
	    },
	    "text": {
	        "docket_uri": null,
	        "docket_seq": "927.00000",
	        "date_terminated": null,
	        "timestamp": 1545950336.99531,
	        "docket_no": 927,
	        "docket_text": "Standing Order/Transcripts",
	        "case_uuid": "debke_156594",
	        "date_filed": "05/15/2017"
	    }
	}, {
	    "text": {
	        "docket_uri": null,
	        "date_filed": "05/05/2017",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545950336.94236,
	        "docket_no": 926,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_seq": "926.00000",
	        "date_terminated": null
	    },
	    "meta": {
	        "docket_uri": null,
	        "date_filed": "05/05/2017",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545950336.94236,
	        "docket_no": 926,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_seq": "926.00000",
	        "date_terminated": null,
	        "purchased": 0
	    }
	}, {
	    "meta": {
	        "docket_no": 925,
	        "docket_text": "Quarterly Claims Register <i>Numerical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "timestamp": 1545958158.50098,
	        "date_terminated": null,
	        "docket_seq": "925.00000",
	        "date_filed": "04/18/2017",
	        "case_uuid": "debke_156594",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016766532",
	        "purchased": 1
	    },
	    "text": {
	        "docket_no": 925,
	        "docket_text": "Quarterly Claims Register <i>Numerical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "timestamp": 1545958158.50098,
	        "date_terminated": null,
	        "docket_seq": "925.00000",
	        "date_filed": "04/18/2017",
	        "case_uuid": "debke_156594",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016766532"
	    }
	}, {
	    "meta": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016766529",
	        "timestamp": 1545958158.50098,
	        "docket_text": "Quarterly Claims Register <i>Alphabetical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "docket_no": 924,
	        "docket_seq": "924.00000",
	        "date_terminated": null,
	        "date_filed": "04/18/2017",
	        "case_uuid": "debke_156594",
	        "purchased": 1
	    },
	    "text": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016766529",
	        "timestamp": 1545958158.50098,
	        "docket_text": "Quarterly Claims Register <i>Alphabetical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "docket_no": 924,
	        "docket_seq": "924.00000",
	        "date_terminated": null,
	        "date_filed": "04/18/2017",
	        "case_uuid": "debke_156594"
	    }
	}, {
	    "text": {
	        "docket_uri": null,
	        "docket_seq": "923.00000",
	        "date_terminated": null,
	        "timestamp": 1545950336.76245,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 923,
	        "case_uuid": "debke_156594",
	        "date_filed": "04/17/2017"
	    },
	    "meta": {
	        "docket_uri": null,
	        "docket_seq": "923.00000",
	        "date_terminated": null,
	        "timestamp": 1545950336.76245,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 923,
	        "case_uuid": "debke_156594",
	        "date_filed": "04/17/2017",
	        "purchased": 0
	    }
	}, {
	    "text": {
	        "docket_no": 922,
	        "docket_text": "Standing Order/Transcripts",
	        "timestamp": 1545950336.72731,
	        "docket_seq": "922.00000",
	        "date_terminated": null,
	        "date_filed": "04/03/2017",
	        "case_uuid": "debke_156594",
	        "docket_uri": null
	    },
	    "meta": {
	        "docket_no": 922,
	        "docket_text": "Standing Order/Transcripts",
	        "timestamp": 1545950336.72731,
	        "docket_seq": "922.00000",
	        "date_terminated": null,
	        "date_filed": "04/03/2017",
	        "case_uuid": "debke_156594",
	        "docket_uri": null,
	        "purchased": 0
	    }
	}, {
	    "meta": {
	        "docket_uri": null,
	        "docket_seq": "921.00000",
	        "date_terminated": null,
	        "timestamp": 1545950336.69215,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 921,
	        "case_uuid": "debke_156594",
	        "date_filed": "03/20/2017",
	        "purchased": 0
	    },
	    "text": {
	        "docket_uri": null,
	        "docket_seq": "921.00000",
	        "date_terminated": null,
	        "timestamp": 1545950336.69215,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 921,
	        "case_uuid": "debke_156594",
	        "date_filed": "03/20/2017"
	    }
	}, {
	    "meta": {
	        "docket_uri": null,
	        "docket_no": 920,
	        "docket_text": "Standing Order/Transcripts",
	        "timestamp": 1545950336.6532,
	        "docket_seq": "920.00000",
	        "date_terminated": null,
	        "date_filed": "03/06/2017",
	        "case_uuid": "debke_156594",
	        "purchased": 0
	    },
	    "text": {
	        "docket_uri": null,
	        "docket_no": 920,
	        "docket_text": "Standing Order/Transcripts",
	        "timestamp": 1545950336.6532,
	        "docket_seq": "920.00000",
	        "date_terminated": null,
	        "date_filed": "03/06/2017",
	        "case_uuid": "debke_156594"
	    }
	}, {
	    "text": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016664123",
	        "timestamp": 1545958158.50098,
	        "docket_text": "Order (COPY FROM DISTRICT COURT) (BAP 15-62) (Civ No. 15-1009) Affirming Order Denying Application of Leidos Engineering, LLC for Allowance and Payment of Claims for Substantial Contribution. (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042015573506'>793</a>) Order Signed on 2/27/2017. (DMC)",
	        "docket_no": 919,
	        "docket_seq": "919.00000",
	        "date_terminated": null,
	        "date_filed": "02/27/2017",
	        "case_uuid": "debke_156594"
	    },
	    "meta": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016664123",
	        "timestamp": 1545958158.50098,
	        "docket_text": "Order (COPY FROM DISTRICT COURT) (BAP 15-62) (Civ No. 15-1009) Affirming Order Denying Application of Leidos Engineering, LLC for Allowance and Payment of Claims for Substantial Contribution. (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042015573506'>793</a>) Order Signed on 2/27/2017. (DMC)",
	        "docket_no": 919,
	        "docket_seq": "919.00000",
	        "date_terminated": null,
	        "date_filed": "02/27/2017",
	        "case_uuid": "debke_156594",
	        "purchased": 1
	    }
	}, {
	    "meta": {
	        "timestamp": 1545958158.50098,
	        "docket_no": 918,
	        "docket_text": "Memorandum Opinion (COPY FROM DISTRICT COURT) (BAP 15-62) (Civ No. 15-1009). (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042015605009'>798</a>) (DMC) Modified Text on 2/28/2017 (LB).",
	        "date_terminated": null,
	        "docket_seq": "918.00000",
	        "date_filed": "02/27/2017",
	        "case_uuid": "debke_156594",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016664083",
	        "purchased": 1
	    },
	    "text": {
	        "timestamp": 1545958158.50098,
	        "docket_no": 918,
	        "docket_text": "Memorandum Opinion (COPY FROM DISTRICT COURT) (BAP 15-62) (Civ No. 15-1009). (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042015605009'>798</a>) (DMC) Modified Text on 2/28/2017 (LB).",
	        "date_terminated": null,
	        "docket_seq": "918.00000",
	        "date_filed": "02/27/2017",
	        "case_uuid": "debke_156594",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016664083"
	    }
	}, {
	    "text": {
	        "docket_uri": null,
	        "docket_no": 917,
	        "docket_text": "Standing Order/Transcripts",
	        "timestamp": 1545950336.5202,
	        "docket_seq": "917.00000",
	        "date_terminated": null,
	        "date_filed": "02/21/2017",
	        "case_uuid": "debke_156594"
	    },
	    "meta": {
	        "docket_uri": null,
	        "docket_no": 917,
	        "docket_text": "Standing Order/Transcripts",
	        "timestamp": 1545950336.5202,
	        "docket_seq": "917.00000",
	        "date_terminated": null,
	        "date_filed": "02/21/2017",
	        "case_uuid": "debke_156594",
	        "purchased": 0
	    }
	}, {
	    "text": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016593791",
	        "timestamp": 1545958158.50098,
	        "docket_no": 916,
	        "docket_text": "Affidavit/Declaration of Service <i>re: Post-Confirmation Report for Quarter Ending December 2016</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042016591672'>915</a>) Filed by KiOR, Inc.. (Steele, Amanda)",
	        "docket_seq": "916.00000",
	        "date_terminated": null,
	        "date_filed": "01/25/2017",
	        "case_uuid": "debke_156594"
	    },
	    "meta": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016593791",
	        "timestamp": 1545958158.50098,
	        "docket_no": 916,
	        "docket_text": "Affidavit/Declaration of Service <i>re: Post-Confirmation Report for Quarter Ending December 2016</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042016591672'>915</a>) Filed by KiOR, Inc.. (Steele, Amanda)",
	        "docket_seq": "916.00000",
	        "date_terminated": null,
	        "date_filed": "01/25/2017",
	        "case_uuid": "debke_156594",
	        "purchased": 1
	    }
	}, {
	    "text": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016591672",
	        "date_filed": "01/24/2017",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545958158.50098,
	        "docket_text": "Post-Confirmation Report <i>for Quarter Ending December 2016</i> Filed by KiOR, Inc.. (Steele, Amanda)",
	        "docket_no": 915,
	        "date_terminated": null,
	        "docket_seq": "915.00000"
	    },
	    "meta": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016591672",
	        "date_filed": "01/24/2017",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545958158.50098,
	        "docket_text": "Post-Confirmation Report <i>for Quarter Ending December 2016</i> Filed by KiOR, Inc.. (Steele, Amanda)",
	        "docket_no": 915,
	        "date_terminated": null,
	        "docket_seq": "915.00000",
	        "purchased": 1
	    }
	}, {
	    "meta": {
	        "docket_no": 914,
	        "docket_text": "Standing Order/Transcripts",
	        "timestamp": 1545950336.39512,
	        "docket_seq": "914.00000",
	        "date_terminated": null,
	        "date_filed": "01/23/2017",
	        "case_uuid": "debke_156594",
	        "docket_uri": null,
	        "purchased": 0
	    },
	    "text": {
	        "docket_no": 914,
	        "docket_text": "Standing Order/Transcripts",
	        "timestamp": 1545950336.39512,
	        "docket_seq": "914.00000",
	        "date_terminated": null,
	        "date_filed": "01/23/2017",
	        "case_uuid": "debke_156594",
	        "docket_uri": null
	    }
	}, {
	    "meta": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016578003",
	        "case_uuid": "debke_156594",
	        "date_filed": "01/17/2017",
	        "date_terminated": null,
	        "docket_seq": "913.00000",
	        "docket_text": "Affidavit/Declaration of Service <i>of Barbara J. Witters (Post-Confirmation Quarterly Report for the Reporting Period September 2016)</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042016548588'>911</a>) Filed by KiOR, Inc.. (Steele, Amanda)",
	        "docket_no": 913,
	        "timestamp": 1545958158.50098,
	        "purchased": 1
	    },
	    "text": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016578003",
	        "case_uuid": "debke_156594",
	        "date_filed": "01/17/2017",
	        "date_terminated": null,
	        "docket_seq": "913.00000",
	        "docket_text": "Affidavit/Declaration of Service <i>of Barbara J. Witters (Post-Confirmation Quarterly Report for the Reporting Period September 2016)</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042016548588'>911</a>) Filed by KiOR, Inc.. (Steele, Amanda)",
	        "docket_no": 913,
	        "timestamp": 1545958158.50098
	    }
	}, {
	    "text": {
	        "date_filed": "01/09/2017",
	        "case_uuid": "debke_156594",
	        "docket_no": 912,
	        "docket_text": "Standing Order/Transcripts",
	        "timestamp": 1545950336.31047,
	        "date_terminated": null,
	        "docket_seq": "912.00000",
	        "docket_uri": null
	    },
	    "meta": {
	        "date_filed": "01/09/2017",
	        "case_uuid": "debke_156594",
	        "docket_no": 912,
	        "docket_text": "Standing Order/Transcripts",
	        "timestamp": 1545950336.31047,
	        "date_terminated": null,
	        "docket_seq": "912.00000",
	        "docket_uri": null,
	        "purchased": 0
	    }
	}, {
	    "meta": {
	        "date_filed": "01/03/2017",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545958158.50098,
	        "docket_no": 911,
	        "docket_text": "Post-Confirmation Report <i>(Post-Confirmation Quarterly Report for the Reporting Period September 2016)</i> Filed by KiOR, Inc.. (Steele, Amanda)",
	        "docket_seq": "911.00000",
	        "date_terminated": null,
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016548588",
	        "purchased": 1
	    },
	    "text": {
	        "date_filed": "01/03/2017",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545958158.50098,
	        "docket_no": 911,
	        "docket_text": "Post-Confirmation Report <i>(Post-Confirmation Quarterly Report for the Reporting Period September 2016)</i> Filed by KiOR, Inc.. (Steele, Amanda)",
	        "docket_seq": "911.00000",
	        "date_terminated": null,
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016548588"
	    }
	}, {
	    "meta": {
	        "timestamp": 1545950336.17571,
	        "docket_no": 910,
	        "docket_text": "Standing Order/Transcripts",
	        "date_terminated": null,
	        "docket_seq": "910.00000",
	        "date_filed": "12/27/2016",
	        "case_uuid": "debke_156594",
	        "docket_uri": null,
	        "purchased": 0
	    },
	    "text": {
	        "timestamp": 1545950336.17571,
	        "docket_no": 910,
	        "docket_text": "Standing Order/Transcripts",
	        "date_terminated": null,
	        "docket_seq": "910.00000",
	        "date_filed": "12/27/2016",
	        "case_uuid": "debke_156594",
	        "docket_uri": null
	    }
	}, {
	    "meta": {
	        "case_uuid": "debke_156594",
	        "date_filed": "12/19/2016",
	        "date_terminated": null,
	        "docket_seq": "909.00000",
	        "timestamp": 1545958158.50098,
	        "docket_text": "Quarterly Claims Register <i>Numerical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "docket_no": 909,
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016521188",
	        "purchased": 1
	    },
	    "text": {
	        "case_uuid": "debke_156594",
	        "date_filed": "12/19/2016",
	        "date_terminated": null,
	        "docket_seq": "909.00000",
	        "timestamp": 1545958158.50098,
	        "docket_text": "Quarterly Claims Register <i>Numerical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "docket_no": 909,
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016521188"
	    }
	}, {
	    "text": {
	        "case_uuid": "debke_156594",
	        "date_filed": "12/19/2016",
	        "date_terminated": null,
	        "docket_seq": "908.00000",
	        "timestamp": 1545958158.50098,
	        "docket_no": 908,
	        "docket_text": "Quarterly Claims Register <i>Alphabetical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016521165"
	    },
	    "meta": {
	        "case_uuid": "debke_156594",
	        "date_filed": "12/19/2016",
	        "date_terminated": null,
	        "docket_seq": "908.00000",
	        "timestamp": 1545958158.50098,
	        "docket_no": 908,
	        "docket_text": "Quarterly Claims Register <i>Alphabetical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016521165",
	        "purchased": 1
	    }
	}, {
	    "text": {
	        "docket_seq": "907.00000",
	        "date_terminated": null,
	        "timestamp": 1545950336.00561,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 907,
	        "case_uuid": "debke_156594",
	        "date_filed": "12/12/2016",
	        "docket_uri": null
	    },
	    "meta": {
	        "docket_seq": "907.00000",
	        "date_terminated": null,
	        "timestamp": 1545950336.00561,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 907,
	        "case_uuid": "debke_156594",
	        "date_filed": "12/12/2016",
	        "docket_uri": null,
	        "purchased": 0
	    }
	}, {
	    "meta": {
	        "timestamp": 1545958158.50098,
	        "docket_text": "Amended Certificate of Service <i>to Order Approving Stipulation Regarding The Claim of Matheson Tri-Gas, Inc.</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042016482208'>904</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042016482462'>905</a>) Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. (Devan, Emily)",
	        "docket_no": 906,
	        "docket_seq": "906.00000",
	        "date_terminated": null,
	        "date_filed": "12/02/2016",
	        "case_uuid": "debke_156594",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016484635",
	        "purchased": 1
	    },
	    "text": {
	        "timestamp": 1545958158.50098,
	        "docket_text": "Amended Certificate of Service <i>to Order Approving Stipulation Regarding The Claim of Matheson Tri-Gas, Inc.</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042016482208'>904</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042016482462'>905</a>) Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. (Devan, Emily)",
	        "docket_no": 906,
	        "docket_seq": "906.00000",
	        "date_terminated": null,
	        "date_filed": "12/02/2016",
	        "case_uuid": "debke_156594",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016484635"
	    }
	}, {
	    "meta": {
	        "case_uuid": "debke_156594",
	        "date_filed": "12/01/2016",
	        "date_terminated": null,
	        "docket_seq": "905.00000",
	        "docket_no": 905,
	        "docket_text": "Certificate of Service <i>to Order Approving the Claim of Matheson Tri-Gas, Inc.</i> Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. (Devan, Emily)",
	        "timestamp": 1545958158.50098,
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016482462",
	        "purchased": 1
	    },
	    "text": {
	        "case_uuid": "debke_156594",
	        "date_filed": "12/01/2016",
	        "date_terminated": null,
	        "docket_seq": "905.00000",
	        "docket_no": 905,
	        "docket_text": "Certificate of Service <i>to Order Approving the Claim of Matheson Tri-Gas, Inc.</i> Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. (Devan, Emily)",
	        "timestamp": 1545958158.50098,
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016482462"
	    }
	}, {
	    "text": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016482208",
	        "case_uuid": "debke_156594",
	        "date_filed": "12/01/2016",
	        "docket_seq": "904.00000",
	        "date_terminated": null,
	        "docket_no": 904,
	        "docket_text": "Order Approving Stipulation Regarding The Claim of Matheson Tri-Gas, Inc. (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042016343159'>894</a>) Order Signed on 12/1/2016. (Attachments: # <a href='https://ecf.deb.uscourts.gov/doc1/042116482209'>1</a> Exhibit A) (DMC)",
	        "timestamp": 1545958158.50098
	    },
	    "meta": {
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016482208",
	        "case_uuid": "debke_156594",
	        "date_filed": "12/01/2016",
	        "docket_seq": "904.00000",
	        "date_terminated": null,
	        "docket_no": 904,
	        "docket_text": "Order Approving Stipulation Regarding The Claim of Matheson Tri-Gas, Inc. (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042016343159'>894</a>) Order Signed on 12/1/2016. (Attachments: # <a href='https://ecf.deb.uscourts.gov/doc1/042116482209'>1</a> Exhibit A) (DMC)",
	        "timestamp": 1545958158.50098,
	        "purchased": 1
	    }
	}, {
	    "text": {
	        "date_filed": "11/29/2016",
	        "case_uuid": "debke_156594",
	        "docket_no": 903,
	        "docket_text": "Certification of Counsel <i>Regarding Stipulation Regarding the Claim of Matheson Tri-Gas, Inc.</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042016343159'>894</a>) Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. (Attachments: # <a href='https://ecf.deb.uscourts.gov/doc1/042116474818'>1</a> Exhibit 1) (Devan, Emily)",
	        "timestamp": 1545958158.50098,
	        "date_terminated": null,
	        "docket_seq": "903.00000",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016474817"
	    },
	    "meta": {
	        "date_filed": "11/29/2016",
	        "case_uuid": "debke_156594",
	        "docket_no": 903,
	        "docket_text": "Certification of Counsel <i>Regarding Stipulation Regarding the Claim of Matheson Tri-Gas, Inc.</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042016343159'>894</a>) Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. (Attachments: # <a href='https://ecf.deb.uscourts.gov/doc1/042116474818'>1</a> Exhibit 1) (Devan, Emily)",
	        "timestamp": 1545958158.50098,
	        "date_terminated": null,
	        "docket_seq": "903.00000",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016474817",
	        "purchased": 1
	    }
	}, {
	    "text": {
	        "date_filed": "11/28/2016",
	        "case_uuid": "debke_156594",
	        "docket_text": "HEARING CANCELLED/RESCHEDULED. Notice of Agenda of Matters Scheduled for Hearing. Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. Hearing scheduled for 11/30/2016 at 11:00 AM at US Bankruptcy Court, 824 Market St., 5th Fl., Courtroom &#035;6, Wilmington, Delaware. (Attachments: # <a href='https://ecf.deb.uscourts.gov/doc1/042116472467'>1</a> Certificate of Service) (Devan, Emily)",
	        "docket_no": 902,
	        "timestamp": 1545958158.50098,
	        "date_terminated": null,
	        "docket_seq": "902.00000",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016472466"
	    },
	    "meta": {
	        "date_filed": "11/28/2016",
	        "case_uuid": "debke_156594",
	        "docket_text": "HEARING CANCELLED/RESCHEDULED. Notice of Agenda of Matters Scheduled for Hearing. Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. Hearing scheduled for 11/30/2016 at 11:00 AM at US Bankruptcy Court, 824 Market St., 5th Fl., Courtroom &#035;6, Wilmington, Delaware. (Attachments: # <a href='https://ecf.deb.uscourts.gov/doc1/042116472467'>1</a> Certificate of Service) (Devan, Emily)",
	        "docket_no": 902,
	        "timestamp": 1545958158.50098,
	        "date_terminated": null,
	        "docket_seq": "902.00000",
	        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016472466",
	        "purchased": 1
	    }
	}, {
	    "meta": {
	        "date_terminated": null,
	        "docket_seq": "901.00000",
	        "timestamp": 1545950335.67558,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 901,
	        "case_uuid": "debke_156594",
	        "date_filed": "11/28/2016",
	        "docket_uri": null,
	        "purchased": 0
	    },
	    "text": {
	        "date_terminated": null,
	        "docket_seq": "901.00000",
	        "timestamp": 1545950335.67558,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 901,
	        "case_uuid": "debke_156594",
	        "date_filed": "11/28/2016",
	        "docket_uri": null
	    }
	}, {
	    "text": {
	        "date_filed": "11/14/2016",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545950335.64627,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 900,
	        "date_terminated": null,
	        "docket_seq": "900.00000",
	        "docket_uri": null
	    },
	    "meta": {
	        "date_filed": "11/14/2016",
	        "case_uuid": "debke_156594",
	        "timestamp": 1545950335.64627,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_no": 900,
	        "date_terminated": null,
	        "docket_seq": "900.00000",
	        "docket_uri": null,
	        "purchased": 0
	    }
	}, {
	    "text": {
	        "case_uuid": "debke_156594",
	        "date_filed": "10/31/2016",
	        "date_terminated": null,
	        "docket_seq": "899.00000",
	        "timestamp": 1545950335.60894,
	        "docket_no": 899,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_uri": null
	    },
	    "meta": {
	        "case_uuid": "debke_156594",
	        "date_filed": "10/31/2016",
	        "date_terminated": null,
	        "docket_seq": "899.00000",
	        "timestamp": 1545950335.60894,
	        "docket_no": 899,
	        "docket_text": "Standing Order/Transcripts",
	        "docket_uri": null,
	        "purchased": 0
	    }
	}];

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _PartiesCases = __webpack_require__(263);
	
	var _PartiesCases2 = _interopRequireDefault(_PartiesCases);
	
	var _partiesArray = __webpack_require__(671);
	
	var _partiesArray2 = _interopRequireDefault(_partiesArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emptyProps = {
	  case_uuid: 'azbtest_2644',
	  purchase_right_away: false,
	  parties: [],
	  noDataFoundMessage: 'There are no parties.',
	  dataReady: true,
	  dispatch: null,
	  lastUpdated: 1000,
	  error: null,
	  receipt: null
	};
	
	var samplefilersProps = {
	  case_uuid: 'azbtest_2644',
	  dataReady: true,
	  receipt: null,
	  lastUpdated: 1000,
	  error: null,
	  currentUser: '1',
	  parties: _partiesArray2.default,
	  dispatch: function dispatch() {
	    return (0, _addonActions.action)('dispatch');
	  },
	  purchaseData: function purchaseData() {
	    return (0, _addonActions.action)('purchaseData');
	  },
	  type: 'schedule',
	  sidebarData: {},
	  kloudless: {}
	};
	
	(0, _react3.storiesOf)('Case Menu/Parties', module).add('Loading', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Component can be in a loading state while we fetch data'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_PartiesCases2.default, null)
	  );
	}).add('View', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'By default, we show a list of parties received form the API'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Page contains \'Find What\' input that searches through table of data.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'There is \'Premium Search\' button, which leads to the premium search url.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'There is \'Download as CSV\' button, that downloads Parties list to CSV file.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'We can refresh list by clicking the \'Update from Pacer\' button'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_PartiesCases2.default, _extends({}, samplefilersProps, {
	      purchaseData: (0, _addonActions.action)('purchaseData')
	    }))
	  );
	}).add('No Data', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'If there is no data found, message is displayed.'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'We can refresh list by clicking the \'Update from Pacer\' button'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_PartiesCases2.default, emptyProps)
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 671 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = [{
	  party: {
	    name: 'FIRST TIME MORTGAGE',
	    fax: null,
	    modified: '2018-07-16 14:33:55.888087+00',
	    role: 'Creditor',
	    address: '4545 N NORTHERN AVE\nPHOENIX, AZ 85112',
	    email: null,
	    case_party_id: 114838,
	    added_date: '05/14/2007',
	    phone: null
	  },
	  associated: [{
	    fax: null,
	    lead: null,
	    name: 'TEST 4 ATTORNEY',
	    email: 'www.tammierae@aol.com',
	    address: 'ATTORNEYS R US\n123 MAIN ST.\nPHOENIX, AZ 85000',
	    phone: '602-555-5555'
	  }]
	}, {
	  party: {
	    phone: '480-451-3053',
	    added_date: '02/19/2007',
	    email: null,
	    case_party_id: 114839,
	    address: 'PO BOX 12970\nSCOTTSDALE, AZ 85267-2970',
	    role: 'Trustee',
	    modified: '2018-07-16 14:33:55.926156+00',
	    fax: null,
	    name: 'DIANE MANN'
	  },
	  associated: [{
	    phone: '480-961-1906',
	    address: 'JAMES J. GENTILE, PC\n5355 W. CHANDLER BLVD., #7\nCHANDLER, AZ 85226',
	    fax: '480-705-4425',
	    name: 'JAMES J. GENTILE',
	    lead: null,
	    email: null
	  }, {
	    address: 'ATTORNEYS R US\n123 MAIN ST. Suite 200\nPHOENIX, AZ 85000',
	    phone: '602-555-5555',
	    email: null,
	    fax: null,
	    lead: null,
	    name: 'TEST 3 ATTORNEY'
	  }]
	}, {
	  party: {
	    modified: '2018-07-16 14:33:55.939242+00',
	    fax: null,
	    name: 'Joseph Wayne Sample',
	    address: 'PO BOX 123\nCHANDLER, AZ 85226',
	    role: 'Debtor',
	    added_date: '02/19/2007',
	    email: null,
	    case_party_id: 114840,
	    phone: null
	  },
	  associated: [{
	    fax: '480-705-4425',
	    email: null,
	    lead: null,
	    name: 'JAMES J. GENTILE',
	    phone: '480-961-1906',
	    address: 'JAMES J. GENTILE, PC\n5355 W. CHANDLER BLVD., #7\nCHANDLER, AZ 85226'
	  }, {
	    address: 'Sue\'s Law Firm, PC\n333 N. 3rd St,\nPhoenix, AZ 85000',
	    phone: '602-555-5555',
	    fax: null,
	    email: 'sue_christensen@azb.uscourts.gov',
	    lead: null,
	    name: 'Sue Test',
	    uuid: 21
	  }]
	}, {
	  party: {
	    added_date: '02/19/2007',
	    case_party_id: 114841,
	    email: null,
	    phone: null,
	    modified: '2018-07-16 14:33:55.955052+00',
	    fax: null,
	    name: 'Sarah Lynn Sample',
	    address: 'PO BOX 123\nCHICAGO, IL 60605-0123',
	    role: 'Joint Debtor'
	  },
	  associated: [{
	    email: null,
	    fax: '480-705-4425',
	    lead: null,
	    name: 'JAMES J. GENTILE',
	    address: 'JAMES J. GENTILE, PC\n5355 W. CHANDLER BLVD., #7\nCHANDLER, AZ 85226',
	    phone: '480-961-1906'
	  }, {
	    address: 'Sue\'s Law Firm, PC\n333 N. 3rd St,\nPhoenix, AZ 85000',
	    phone: '602-555-5555',
	    fax: null,
	    lead: null,
	    email: 'sue_christensen@azb.uscourts.gov',
	    name: 'Sue Test',
	    uuid: 21
	  }]
	}, {
	  associated: [{
	    address: 'JAMES J. GENTILE, PC\n5355 W. CHANDLER BLVD., #7\nCHANDLER, AZ 85226',
	    phone: '480-961-1906',
	    lead: null,
	    fax: '480-705-4425',
	    email: null,
	    name: 'JAMES J. GENTILE'
	  }],
	  party: {
	    case_party_id: 114842,
	    email: null,
	    added_date: '02/19/2007',
	    phone: null,
	    fax: null,
	    name: 'U.S. Trustee\'s Office',
	    modified: '2018-07-16 14:33:55.972618+00',
	    role: 'U.S. Trustee',
	    address: '230 N. First Avenue, Suite 204\nPhoenix, AZ 85003'
	  }
	}];

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _emptyProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _RelatedTransaction = __webpack_require__(264);
	
	var _RelatedTransaction2 = _interopRequireDefault(_RelatedTransaction);
	
	var _RelatedTransactionArray = __webpack_require__(673);
	
	var _RelatedTransactionArray2 = _interopRequireDefault(_RelatedTransactionArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emptyProps = (_emptyProps = {
	  case_uuid: 'azbtest_2644',
	  purchase_right_away: false,
	  transactions: [],
	  noDataFoundMessage: 'There are no transactions.'
	}, _emptyProps['case_uuid'] = 'azbtest_2644', _emptyProps.dataReady = true, _emptyProps.receipt = null, _emptyProps.lastUpdated = 1000, _emptyProps.error = null, _emptyProps.currentUser = '1', _emptyProps.docketParts = {
	  alreadyPurchased: false,
	  errors: null,
	  parts: 0,
	  partsToPurchase: 0,
	  percentage: 0,
	  purchased: 0,
	  status: "loading",
	  step: 0,
	  totalCost: 0
	}, _emptyProps.tableSortProps = {
	  sort_direction: "desc",
	  sort_field: "date_event_filed"
	}, _emptyProps.relatedTransactionEntriesProps = {
	  buyPdf: function buyPdf() {
	    return (0, _addonActions.action)('buyPdf');
	  },
	  case_uuid: "azbtest_2644",
	  sortRelatedTransaction: function sortRelatedTransaction() {
	    return (0, _addonActions.action)('sortRelatedTransaction');
	  },
	  entries: [],
	  selectedDocketDetailNum: null,
	  showRedactPopup: undefined,
	  transactions: { total_items: 56, page_size: 500, total_pages: 0.112, entries: [] }
	}, _emptyProps.relatedTransactionPaginatorProps = {
	  case_uuid: "azbtest_2644",
	  changePage: function changePage() {
	    return (0, _addonActions.action)('changePage');
	  },
	  selectedPageNum: 1,
	  transactions: { total_items: 56, page_size: 500, total_pages: 0.112, entries: [] }
	}, _emptyProps['transactions'] = [], _emptyProps.dispatch = function dispatch() {
	  return (0, _addonActions.action)('dispatch');
	}, _emptyProps.purchaseData = function purchaseData() {
	  return (0, _addonActions.action)('purchaseData');
	}, _emptyProps.sidebarData = {}, _emptyProps.kloudless = {}, _emptyProps);
	
	var sampleRelatedTransactionsProps = {
	  case_uuid: 'azbtest_2644',
	  dataReady: true,
	  receipt: null,
	  lastUpdated: 1000,
	  error: null,
	  currentUser: '1',
	  docketParts: {
	    alreadyPurchased: false,
	    errors: null,
	    parts: 0,
	    partsToPurchase: 0,
	    percentage: 0,
	    purchased: 0,
	    status: "loading",
	    step: 0,
	    totalCost: 0
	  },
	  tableSortProps: {
	    sort_direction: "desc",
	    sort_field: "date_event_filed"
	  },
	  relatedTransactionEntriesProps: {
	    buyPdf: function buyPdf() {
	      return (0, _addonActions.action)('buyPdf');
	    },
	    getDocketDetails: function getDocketDetails() {
	      return (0, _addonActions.action)('getDocketDetails');
	    },
	    case_uuid: "azbtest_2644",
	    sortRelatedTransaction: function sortRelatedTransaction() {
	      return (0, _addonActions.action)('sortRelatedTransaction');
	    },
	    entries: _RelatedTransactionArray2.default,
	    selectedDocketDetailNum: null,
	    showRedactPopup: undefined,
	    transactions: { total_items: 56, page_size: 500, total_pages: 0.112, entries: _RelatedTransactionArray2.default }
	  },
	  relatedTransactionPaginatorProps: {
	    case_uuid: "azbtest_2644",
	    changePage: function changePage() {
	      return (0, _addonActions.action)('changePage');
	    },
	    selectedPageNum: 1,
	    transactions: { total_items: 56, page_size: 500, total_pages: 0.112, entries: _RelatedTransactionArray2.default }
	  },
	  transactions: _RelatedTransactionArray2.default,
	  dispatch: function dispatch() {
	    return (0, _addonActions.action)('dispatch');
	  },
	  purchaseData: function purchaseData() {
	    return (0, _addonActions.action)('purchaseData');
	  },
	  sidebarData: {},
	  kloudless: {}
	};
	
	var docketPartsProps = {
	  case_uuid: 'azbtest_2644',
	  dataReady: true,
	  receipt: null,
	  lastUpdated: 1000,
	  error: null,
	  currentUser: '1',
	  docketParts: {
	    alreadyPurchased: false,
	    errors: null,
	    parts: 0,
	    partsToPurchase: 0,
	    percentage: 0,
	    purchased: 0,
	    status: "loading",
	    step: 0,
	    totalCost: 0
	  },
	  tableSortProps: {
	    sort_direction: "desc",
	    sort_field: "date_event_filed"
	  },
	  selectedDocket: {
	    seqNum: 940,
	    status: "done"
	  },
	  relatedTransactionEntriesProps: {
	    buyPdf: function buyPdf() {
	      return (0, _addonActions.action)('buyPdf');
	    },
	    getDocketDetails: function getDocketDetails() {
	      return (0, _addonActions.action)('getDocketDetails');
	    },
	    case_uuid: "azbtest_2644",
	    onPopupClick: function onPopupClick() {
	      return (0, _addonActions.action)('onPopupClick');
	    },
	    sortRelatedTransaction: function sortRelatedTransaction() {
	      return (0, _addonActions.action)('sortRelatedTransaction');
	    },
	    entries: _RelatedTransactionArray2.default,
	    selectedDocketDetailNum: 940,
	    showRedactPopup: undefined,
	    transactions: {
	      total_items: 56,
	      page_size: 500,
	      total_pages: 0.112,
	      entries: _RelatedTransactionArray2.default,
	      docketDetails: {
	        details: [{
	          action: "https://ecf-test.azb.uscourts.gov/doc2/024140168?caseid=2644",
	          case_uuid: "azbtest_2644",
	          cost: "0.00",
	          create_blog_post_url: "/create-pleadings-blog-post/azbtest_2644/41/1/20ee507ef3952d8b3f69d5ba067c5972",
	          description_html: null,
	          docket_no: "940",
	          download_ocr_uri: "/ir-documentselect/download_ocr/azbtest_2644/41/1",
	          download_url: "/ir-documentselect/download_pdf/docket/azbtest_2644/41/1",
	          filename: "Bankr.D.Ariz.TEST_2-07-bk-00012_41.pdf",
	          free: null,
	          friendly_name: "Bankr.D.Ariz.TEST_2-07-bk-00012_41.pdf",
	          number: 1,
	          ocr_link: "http://aws-s3.inforuptcy.dev.azk.io/inforuptcy-storage/pacer-ocr/pacer/azbtest/2644/dockets/41/1-9E5150F4-947D-11E9-A6D5-ACACFDDFD522.txt?response-content-disposition=attachment%3B+filename%3DBankr.D.Ariz.TEST_2-07-bk-00012_41.pdf.txt&AWSAccessKeyId=dummy_aws_access_key&Expires=1877043966&Signature=afwEpHhb5B7kogO6VhWjpMsGkLA%3D",
	          pages: "1",
	          public_pdf_link: "http://aws-s3.courtdrive.inforuptcy.dev.azk.io/inforuptcy-storage/pacer/azbtest/2644/dockets/41/1-9E5150F4-947D-11E9-A6D5-ACACFDDFD522",
	          raw_location: "s3://inforuptcy-storage/pacer/azbtest/2644/dockets/41/1-9E5150F4-947D-11E9-A6D5-ACACFDDFD522",
	          sequence_number: "940.00000"
	        }],
	        seqNum: 940 } }
	  },
	  relatedTransactionPaginatorProps: {
	    case_uuid: "azbtest_2644",
	    changePage: function changePage() {
	      return (0, _addonActions.action)('changePage');
	    },
	    selectedPageNum: 1,
	    transactions: { total_items: 56, page_size: 500, total_pages: 0.112, entries: _RelatedTransactionArray2.default }
	  },
	  transactions: _RelatedTransactionArray2.default,
	  dispatch: function dispatch() {
	    return (0, _addonActions.action)('dispatch');
	  },
	  purchaseData: function purchaseData() {
	    return (0, _addonActions.action)('purchaseData');
	  },
	  visibleDocketRow: "0-0",
	  sidebarData: {},
	  kloudless: {}
	};
	
	(0, _react3.storiesOf)('Case Menu/Related Transactions', module).add('Loading', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Component can be in a loading state while we fetch data'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_RelatedTransaction2.default, null)
	  );
	}).add('View', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'By default, we show a list of transactions received form the parser API'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Page contains \'Find What\' input that searches through table of data.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'There is \'Premium Search\' button, which leads to the premium search url.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Show/Hide \'Pacer filter\' display/hide pacer filter section, that searches transactions from pacer api.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'If transactions are available \'Parser filter\' section, that searches transactions from parser api.'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_RelatedTransaction2.default, _extends({}, sampleRelatedTransactionsProps, {
	      purchaseData: (0, _addonActions.action)('purchaseData')
	    }))
	  );
	}).add('View Docket Details', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'On click docket number Docket Details row is being displayed'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_RelatedTransaction2.default, _extends({}, docketPartsProps, {
	      purchaseData: (0, _addonActions.action)('purchaseData')
	    }))
	  );
	}).add('No Data', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'If there is no data found, message is displayed.'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'We can refresh list by clicking the \'Update from Pacer\' button'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_RelatedTransaction2.default, emptyProps)
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 673 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = [{
	  meta: {
	    case_uuid: "azbtest_2644",
	    date_event_filed: '09/15/2008',
	    date_event_terminated: null,
	    docket_no: 7,
	    event_name: "Motion to Authorize<i>: Debtor's Motion Pursuant to Sections 105(a), 342(a), and 521(a)(1) of the Bankruptcy Code, Bankruptcy Rules 1007(a) and 2002(a), (f) and (l), and Local Bankruptcy Rule 1007-1 for (i) a Waiver of the Requirement to File a List of Creditors and (ii) Approval of the Form and Manner of Notifying Creditors of the Commencement of the Debtor's Chapter 11 Case</i>filed by Harvey R. Miller on behalf of Lehman Brothers Holdings Inc.. (Miller, Harvey) (Entered: 09/15/2008)",
	    event_uri: null,
	    order_docket_seq: '7.00000',
	    timestamp: 1534169124.30955
	  },
	  text: {
	    case_uuid: "azbtest_2644",
	    date_event_filed: '09/15/2008',
	    date_event_terminated: null,
	    docket_no: 7,
	    docket_uri: "https://ecf.nysb.uscourts.gov/doc1/12607320573",
	    event_name: "Motion to Authorize<i>: Debtor's Motion Pursuant to Sections 105(a), 342(a), and 521(a)(1) of the Bankruptcy Code, Bankruptcy Rules 1007(a) and 2002(a), (f) and (l), and Local Bankruptcy Rule 1007-1 for (i) a Waiver of the Requirement to File a List of Creditors and (ii) Approval of the Form and Manner of Notifying Creditors of the Commencement of the Debtor's Chapter 11 Case</i>filed by Harvey R. Miller on behalf of Lehman Brothers Holdings Inc.. (Miller, Harvey) (Entered: 09/15/2008)",
	    event_uri: null,
	    order_docket_seq: '7.00000',
	    timestamp: 1534169124.30955,
	    related: [{
	      date_event_filed: '09/15/2008',
	      date_event_terminated: null,
	      docket_no: 7,
	      docket_uri: "https://ecf.nysb.uscourts.gov/doc1/12607320573",
	      event_name: "Motion to Authorize<i>: Debtor's Motion Pursuant to Sections 105(a), 342(a), and 521(a)(1) of the Bankruptcy Code, Bankruptcy Rules 1007(a) and 2002(a), (f) and (l), and Local Bankruptcy Rule 1007-1 for (i) a Waiver of the Requirement to File a List of Creditors and (ii) Approval of the Form and Manner of Notifying Creditors of the Commencement of the Debtor's Chapter 11 Case</i>filed by Harvey R. Miller on behalf of Lehman Brothers Holdings Inc.. (Miller, Harvey) (Entered: 09/15/2008)",
	      order_docket_no: 7,
	      order_docket_seq: '1.00000'
	    }]
	  }
	}, {
	  meta: {
	    case_uuid: "azbtest_2644",
	    date_event_filed: '09/15/2008',
	    date_event_terminated: null,
	    docket_no: 7,
	    event_name: "Motion to Authorize<i>: Debtor's Motion Pursuant to Sections 105(a), 342(a), and 521(a)(1) of the Bankruptcy Code, Bankruptcy Rules 1007(a) and 2002(a), (f) and (l), and Local Bankruptcy Rule 1007-1 for (i) a Waiver of the Requirement to File a List of Creditors and (ii) Approval of the Form and Manner of Notifying Creditors of the Commencement of the Debtor's Chapter 11 Case</i>filed by Harvey R. Miller on behalf of Lehman Brothers Holdings Inc.. (Miller, Harvey) (Entered: 09/15/2008)",
	    event_uri: null,
	    order_docket_seq: '7.00000',
	    timestamp: 1534169124.30955
	  },
	  text: {
	    case_uuid: "azbtest_2644",
	    date_event_filed: '09/15/2008',
	    date_event_terminated: null,
	    docket_no: 1,
	    docket_uri: "https://ecf.nysb.uscourts.gov/doc1/12607320573",
	    event_name: "Motion to Authorize<i>: Debtor's Motion Pursuant to Sections 105(a), 342(a), and 521(a)(1) of the Bankruptcy Code, Bankruptcy Rules 1007(a) and 2002(a), (f) and (l), and Local Bankruptcy Rule 1007-1 for (i) a Waiver of the Requirement to File a List of Creditors and (ii) Approval of the Form and Manner of Notifying Creditors of the Commencement of the Debtor's Chapter 11 Case</i>filed by Harvey R. Miller on behalf of Lehman Brothers Holdings Inc.. (Miller, Harvey) (Entered: 09/15/2008)",
	    event_uri: null,
	    order_docket_seq: '1.00000',
	    timestamp: 1534169124.30955,
	    related: [{
	      date_event_filed: '09/15/2008',
	      date_event_terminated: null,
	      docket_no: 1,
	      docket_uri: "https://ecf.nysb.uscourts.gov/doc1/12607320573",
	      event_name: "Motion to Authorize<i>: Debtor's Motion Pursuant to Sections 105(a), 342(a), and 521(a)(1) of the Bankruptcy Code, Bankruptcy Rules 1007(a) and 2002(a), (f) and (l), and Local Bankruptcy Rule 1007-1 for (i) a Waiver of the Requirement to File a List of Creditors and (ii) Approval of the Form and Manner of Notifying Creditors of the Commencement of the Debtor's Chapter 11 Case</i>filed by Harvey R. Miller on behalf of Lehman Brothers Holdings Inc.. (Miller, Harvey) (Entered: 09/15/2008)",
	      order_docket_no: 1,
	      order_docket_seq: '1.00000'
	    }]
	  }
	}, {
	  meta: {
	    case_uuid: "azbtest_2644",
	    date_event_filed: '09/15/2008',
	    date_event_terminated: null,
	    docket_no: 940,
	    event_name: "Objection to Motion<i>//Limited Objection of the Pension Benefit Guaranty Corporation to Debtors' Motion for Entry of Order Pursuant to Sections 105, 363, and 365 of the Bankruptcy Code and Federal Rules of Bankruptcy Procedure 2002, 6004, 6006, and 9019: (I) Approving Equity Interests Purchase Agreement; (II) Authorizing Debtors to Compromise, Settle, and Release Related Claims and (III) Granting Certain Related Relief with attached Certificate of Service</i>(related document(s) <span class=\"docket_ref\">746</span>) filed by Colin B. Albaugh on behalf of Pension Benefit Guaranty Corporation. (Albaugh, Colin) (Entered: 10/14/2008)",
	    event_uri: null,
	    order_docket_seq: '940.00000',
	    timestamp: 1534169124.30955
	  },
	  text: {
	    case_uuid: "azbtest_2644",
	    date_event_filed: '09/15/2008',
	    date_event_terminated: null,
	    docket_no: 940,
	    docket_uri: "https://ecf.nysb.uscourts.gov/doc1/12607320573",
	    event_name: "Objection to Motion<i>//Limited Objection of the Pension Benefit Guaranty Corporation to Debtors' Motion for Entry of Order Pursuant to Sections 105, 363, and 365 of the Bankruptcy Code and Federal Rules of Bankruptcy Procedure 2002, 6004, 6006, and 9019: (I) Approving Equity Interests Purchase Agreement; (II) Authorizing Debtors to Compromise, Settle, and Release Related Claims and (III) Granting Certain Related Relief with attached Certificate of Service</i>(related document(s) <span class=\"docket_ref\">746</span>) filed by Colin B. Albaugh on behalf of Pension Benefit Guaranty Corporation. (Albaugh, Colin) (Entered: 10/14/2008)",
	    event_uri: null,
	    order_docket_seq: '940.00000',
	    timestamp: 1534169124.30955,
	    related: []
	  }
	}];

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _Status = __webpack_require__(265);
	
	var _Status2 = _interopRequireDefault(_Status);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emptyProps = {
	    case_uuid: 'azbtest_2644',
	    purchase_right_away: false,
	    statuses: [],
	    noDataFoundMessage: 'There are no pending statuses.',
	    dataReady: true,
	    dispatch: null,
	    lastUpdated: 1000,
	    error: null,
	    receipt: null
	};
	
	var sampleStatusesProps = {
	    case_uuid: 'azbtest_2644',
	    dataReady: true,
	    receipt: null,
	    lastUpdated: 1000,
	    error: null,
	    statuses: [{
	        status_set_by: "Notice of Appeal",
	        docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-6704-21829",
	        status: "Appeal Filed",
	        docket_no: 6704,
	        date_status_begin: "01/19/2010",
	        time_in_status: "3192 days",
	        modified: "2018-10-16 16:05:01.668187+00",
	        docket_uri: "https://ecf.nysb.uscourts.gov/doc1/12608914603"
	    }, {
	        time_in_status: "3172 days",
	        date_status_begin: "02/08/2010",
	        docket_uri: "https://ecf.nysb.uscourts.gov/doc1/12609007573",
	        modified: "2018-10-16 16:05:01.72876+00",
	        status_set_by: "Notice of Appeal",
	        status: "Appeal Filed",
	        docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-7018-22689",
	        docket_no: 7018
	    }, {
	        time_in_status: "3085 days",
	        date_status_begin: "05/06/2010",
	        modified: "2018-10-16 16:05:01.771315+00",
	        docket_uri: "https://ecf.nysb.uscourts.gov/doc1/12609358207",
	        status: "Appeal Filed",
	        docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-8831-28665",
	        status_set_by: "Notice of Appeal",
	        docket_no: 8831
	    }, {
	        date_status_begin: "05/27/2010",
	        time_in_status: "3064 days",
	        modified: "2018-10-16 16:05:01.815288+00",
	        docket_uri: "https://ecf.nysb.uscourts.gov/doc1/12609440650",
	        docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-9312-30085",
	        status: "Appeal Filed",
	        status_set_by: "Notice of Appeal",
	        docket_no: 9312
	    }, {
	        docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-9313-30091",
	        status: "Appeal Filed",
	        status_set_by: "Notice of Appeal",
	        docket_no: 9313,
	        date_status_begin: "05/27/2010",
	        time_in_status: "3064 days",
	        modified: "2018-10-16 16:05:01.886628+00",
	        docket_uri: "https://ecf.nysb.uscourts.gov/doc1/12609440761"
	    }, {
	        modified: "2018-10-16 16:05:01.951911+00",
	        docket_uri: "https://ecf.nysb.uscourts.gov/doc1/12609469459",
	        date_status_begin: "06/02/2010",
	        time_in_status: "3058 days",
	        docket_no: 9372,
	        status_set_by: "Notice of Appeal",
	        docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-9372-30263",
	        status: "Appeal Filed"
	    }, {
	        docket_no: 9374,
	        status: "Appeal Filed",
	        docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-9374-30279",
	        status_set_by: "Notice of Appeal",
	        docket_uri: "https://ecf.nysb.uscourts.gov/doc1/12609469651",
	        modified: "2018-10-16 16:05:02.010515+00",
	        time_in_status: "3058 days",
	        date_status_begin: "06/02/2010"
	    }, {
	        docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-12876-41052",
	        status: "Appeal Filed",
	        status_set_by: "Notice of Appeal",
	        docket_no: 12876,
	        time_in_status: "2891 days",
	        date_status_begin: "11/16/2010",
	        modified: "2018-10-16 16:05:02.061365+00",
	        docket_uri: "https://ecf.nysb.uscourts.gov/doc1/126010146315"
	    }, {
	        time_in_status: "2770 days",
	        date_status_begin: "03/17/2011",
	        docket_uri: "https://ecf.nysb.uscourts.gov/doc1/126010610871",
	        modified: "2018-10-16 16:05:02.136418+00",
	        status: "Appeal Filed",
	        docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-15132-47594",
	        status_set_by: "Notice of Appeal",
	        docket_no: 15132
	    }, {
	        status_set_by: "Notice of Appeal",
	        docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-18676-58545",
	        status: "Appeal Filed",
	        docket_no: 18676,
	        time_in_status: "2645 days",
	        date_status_begin: "07/20/2011",
	        docket_uri: "https://ecf.nysb.uscourts.gov/doc1/126011115084",
	        modified: "2018-10-16 16:05:02.190055+00"
	    }, {
	        modified: "2018-10-16 16:05:02.258715+00",
	        docket_uri: "https://ecf.nysb.uscourts.gov/doc1/126011149281",
	        date_status_begin: "07/28/2011",
	        time_in_status: "2637 days",
	        docket_no: 18844,
	        docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-18844-59009",
	        status: "Appeal Filed",
	        status_set_by: "Notice of Appeal"
	    }, {
	        docket_no: 18849,
	        status_set_by: "Notice of Appeal",
	        status: "Appeal Filed",
	        docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-18849-59023",
	        docket_uri: "https://ecf.nysb.uscourts.gov/doc1/126011150054",
	        modified: "2018-10-16 16:05:02.349246+00",
	        date_status_begin: "07/28/2011",
	        time_in_status: "2637 days"
	    }, {
	        modified: "2018-10-16 16:05:02.429267+00",
	        docket_uri: "https://ecf.nysb.uscourts.gov/doc1/126014729417",
	        time_in_status: "1567 days",
	        date_status_begin: "07/02/2014",
	        docket_no: 44952,
	        status: "Appeal Filed",
	        docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-44952-152348",
	        status_set_by: "Notice of Appeal"
	    }, {
	        docket_no: 46214,
	        status_set_by: "Notice of Appeal",
	        docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-46214-158402",
	        status: "Appeal Filed",
	        docket_uri: "https://ecf.nysb.uscourts.gov/doc1/126014898943",
	        modified: "2018-10-16 16:05:02.45626+00",
	        date_status_begin: "09/03/2014",
	        time_in_status: "1504 days"
	    }, {
	        modified: "2018-10-16 16:05:02.498813+00",
	        docket_uri: "https://ecf.nysb.uscourts.gov/doc1/126015105720",
	        date_status_begin: "11/21/2014",
	        time_in_status: "1425 days",
	        docket_no: 47003,
	        status_set_by: "Notice of Appeal",
	        docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-47003-162152",
	        status: "Appeal Filed"
	    }],
	    dispatch: function dispatch() {
	        return (0, _addonActions.action)('dispatch');
	    },
	    purchaseData: function purchaseData() {
	        return (0, _addonActions.action)('purchaseData');
	    },
	    type: 'status_pending',
	    sidebarData: {},
	    kloudless: {}
	};
	
	(0, _react3.storiesOf)('Case Menu/Status', module).add('Loading', function () {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'h3',
	            null,
	            'Component can be in a loading state while we fetch data'
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(_Status2.default, null)
	    );
	}).add('View', function () {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'h3',
	            null,
	            'By default, we show a list of pending statuses received form the API'
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	            'h4',
	            null,
	            'Page contains \'Find What\' input that searches through table of data.'
	        ),
	        _react2.default.createElement(
	            'h4',
	            null,
	            'There is \'Premium Search\' button, which leads to the premium search url.'
	        ),
	        _react2.default.createElement(
	            'h4',
	            null,
	            'We can refresh list by clicking the \'Update from Pacer\' button'
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(_Status2.default, _extends({}, sampleStatusesProps, {
	            purchaseData: (0, _addonActions.action)('purchaseData')
	        }))
	    );
	}).add('No Data', function () {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'h3',
	            null,
	            'If there is no data found, message is displayed.'
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	            'h4',
	            null,
	            'We can refresh list by clicking the \'Update from Pacer\' button'
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(_Status2.default, emptyProps)
	    );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Loading = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _loadingBar = __webpack_require__(199);
	
	var _loadingBar2 = _interopRequireDefault(_loadingBar);
	
	var _loadingSpinner = __webpack_require__(963);
	
	var _loadingSpinner2 = _interopRequireDefault(_loadingSpinner);
	
	__webpack_require__(2175);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Loading = exports.Loading = function (_Component) {
	  _inherits(Loading, _Component);
	
	  function Loading() {
	    _classCallCheck(this, Loading);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Loading.prototype.render = function render() {
	    var isSpinner = this.props.type === 'spinner';
	
	    var show = this.props.show || this.props.showOverride;
	
	    return show && _react2.default.createElement(
	      'div',
	      { className: isSpinner ? 'spinner' : 'loading_bar' },
	      _react2.default.createElement('img', { src: isSpinner ? _loadingSpinner2.default : _loadingBar2.default })
	    );
	  };
	
	  return Loading;
	}(_react.Component);
	
	// todo refactor this showoverride out.
	
	
	Loading.defaultProps = {
	  type: 'bar',
	  showOverride: false
	};
	
	Loading.propTypes = {
	  type: _propTypes2.default.string,
	  showOverride: _propTypes2.default.bool
	};
	
	// todo use new pattern of status: loading to accomplish this.  remove a reducer for global status
	function mapStateToProps(state) {
	  return { show: state.get('loadingSpinner') };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Loading);

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	__webpack_require__(946);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfirmationModal = function ConfirmationModal(_ref) {
	  var show = _ref.show,
	      onClose = _ref.onClose,
	      onConfirm = _ref.onConfirm,
	      title = _ref.title,
	      content = _ref.children;
	  return _react2.default.createElement(
	    _reactBootstrap.Modal,
	    { show: show, onHide: onClose, className: 'confirmation-modal' },
	    _react2.default.createElement(
	      _reactBootstrap.Modal.Header,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Modal.Title,
	        null,
	        title
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Modal.Body,
	      null,
	      content
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Modal.Footer,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        { onClick: onClose },
	        'Close'
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: 'primary', onClick: onConfirm },
	        'Continue'
	      )
	    )
	  );
	};
	
	ConfirmationModal.defaultProps = {
	  show: false,
	  children: _react2.default.createElement('div', null)
	};
	
	ConfirmationModal.propTypes = {
	  onClose: _propTypes2.default.func.isRequired,
	  onConfirm: _propTypes2.default.func.isRequired,
	  show: _propTypes2.default.bool,
	  title: _propTypes2.default.string.isRequired,
	  children: _propTypes2.default.any
	};
	
	exports.default = ConfirmationModal;

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _DeleteModal = __webpack_require__(407);
	
	var _DeleteModal2 = _interopRequireDefault(_DeleteModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DeleteModal2.default;

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = RPCProgressBar;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _useDataApi2 = __webpack_require__(60);
	
	var _useDataApi3 = _interopRequireDefault(_useDataApi2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RPCProgressBar(_ref) {
	  var taskUrl = _ref.taskUrl,
	      onSuccess = _ref.onSuccess,
	      onError = _ref.onError,
	      label = _ref.label;
	
	  // console.log("RPC Progress from ", taskUrl);
	  var status = rpcProgress(taskUrl, onSuccess, onError) || { pending: true };
	  // console.log("Progress", status);
	
	  return _react2.default.createElement(_reactBootstrap.ProgressBar, {
	    active: status.pending,
	    now: parseFloat(status.progress_percent) || 100,
	    label: status.success ? '' : label
	  });
	}
	
	function rpcProgress(url, onSuccess, onError) {
	  var _useDataApi = (0, _useDataApi3.default)(url),
	      response = _useDataApi[0].response,
	      triggerRefresh = _useDataApi[1].triggerRefresh;
	
	  var _useState = (0, _react.useState)({}),
	      progressValue = _useState[0],
	      setProgressValue = _useState[1];
	
	  (0, _react.useEffect)(function () {
	    if (!response) return;
	
	    if (response.accepted) {
	      // For Stuff with no redirect URL when it's done
	      if (response.body.success) {
	        onSuccess(response.body);
	        return;
	      }
	
	      setProgressValue(response.body);
	
	      // wait 0.5s and then update progress again
	      setTimeout(triggerRefresh, 2000);
	      return;
	    }
	
	    // when progress finishes, it returns a 302 response to the actual results, but it appears that  superagent
	    // follows that redirect for us, so we should have a 200 response here
	    if (response.status !== 200) {
	      onError(response.body);
	      return;
	    }
	
	    if (response.body.error || response.body.success === false) onError(response.body);else onSuccess(response.body);
	  }, [response]);
	
	  return progressValue;
	}

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = TimeFromNow;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(32);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _useInterval = __webpack_require__(1255);
	
	var _useInterval2 = _interopRequireDefault(_useInterval);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TimeFromNow(_ref) {
	  var dateTime = _ref.dateTime;
	
	  var _useState = (0, _react.useState)((0, _moment2.default)(dateTime).fromNow()),
	      relativeTime = _useState[0],
	      setRelativeTime = _useState[1];
	
	  // no need to auto refresh, if period is greater then one day
	
	
	  if ((0, _moment2.default)().diff((0, _moment2.default)(dateTime), 'days') < 1) {
	    (0, _useInterval2.default)(function () {
	      setRelativeTime((0, _moment2.default)(dateTime).fromNow());
	    }, 60000);
	  }
	  return _react2.default.createElement(
	    'span',
	    null,
	    relativeTime
	  );
	}
	
	TimeFromNow.propTypes = {
	  dateTime: _propTypes2.default.string.isRequired
	};

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CaseNumberTooltip = __webpack_require__(206);
	
	var _CaseNumberTooltip2 = _interopRequireDefault(_CaseNumberTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CaseNumberSelector = function (_Component) {
	  _inherits(CaseNumberSelector, _Component);
	
	  function CaseNumberSelector() {
	    _classCallCheck(this, CaseNumberSelector);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  CaseNumberSelector.prototype.render = function render() {
	    var clsName = this.props.showFlash ? 'input-search x-closeable flash-yellow' : 'input-search  x-closeable';
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'form-item', style: { display: 'inline-block', width: 'auto' } },
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'case-number' },
	        'Case Number: ',
	        _react2.default.createElement(_CaseNumberTooltip2.default, null)
	      ),
	      _react2.default.createElement('input', { type: 'search',
	        maxLength: '128',
	        id: 'case-number',
	        size: '60',
	        ref: 'case_no',
	        onChange: this.props.onChange,
	        value: this.props.value,
	        className: clsName })
	    );
	  };
	
	  return CaseNumberSelector;
	}(_react.Component);
	
	CaseNumberSelector.propTypes = {
	  showFlash: _propTypes2.default.bool,
	  onChange: _propTypes2.default.func,
	  value: _propTypes2.default.string
	};
	
	CaseNumberSelector.defaultProps = {
	  showFlash: false,
	  value: '',
	  onChange: function onChange() {
	    return null;
	  }
	};
	
	exports.default = CaseNumberSelector;

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CaseTitleTooltip = __webpack_require__(686);
	
	var _CaseTitleTooltip2 = _interopRequireDefault(_CaseTitleTooltip);
	
	__webpack_require__(2191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CaseNumberSelector = function (_Component) {
	  _inherits(CaseNumberSelector, _Component);
	
	  function CaseNumberSelector() {
	    _classCallCheck(this, CaseNumberSelector);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  CaseNumberSelector.prototype.render = function render() {
	    var clsName = this.props.showFlash ? 'input-search x-closeable flash-yellow' : 'input-search x-closeable';
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'form-item', style: { display: 'inline-block', width: 'auto' } },
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'title-or-name' },
	        'Case Title or Party Name: ',
	        _react2.default.createElement(_CaseTitleTooltip2.default, null)
	      ),
	      _react2.default.createElement('input', { type: 'search',
	        maxLength: '128',
	        id: 'title-or-name',
	        size: '60',
	        onChange: this.props.onChange,
	        value: this.props.value,
	        className: clsName })
	    );
	  };
	
	  return CaseNumberSelector;
	}(_react.Component);
	
	CaseNumberSelector.defaultProps = {
	  showFlash: false,
	  value: '',
	  onChange: function onChange() {
	    return null;
	  }
	};
	
	CaseNumberSelector.propTypes = {
	  showFlash: _propTypes2.default.bool,
	  onChange: _propTypes2.default.func,
	  value: _propTypes2.default.string
	};
	
	exports.default = CaseNumberSelector;

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(13);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _inputValidations = __webpack_require__(100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChapterSelector = function ChapterSelector(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'chapter-selector-container' },
	    _react2.default.createElement(
	      'label',
	      { htmlFor: 'chapter-selector' },
	      'Chapters: '
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'chapter-selector' },
	      _react2.default.createElement(_reactSelect2.default, {
	        className: props.className,
	        name: 'form-field-name',
	        options: chapterOptions,
	        multi: true,
	        simpleValue: true,
	        value: props.pacerSearchResults.getIn(['filters', 'chapter']) || 'one',
	        placeholder: 'Select...',
	        onChange: function onChange(chapter) {
	          return props.onChange({ chapter: chapter || '' });
	        }
	      })
	    )
	  );
	};
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return (0, _inputValidations.mapValidationFieldsToClassName)(state, 'chapter');
	})(ChapterSelector);
	
	// TODO move this to separate file (or maybe it initializes from service?)
	
	var chapterOptions = [{ value: '7', label: '7' }, { value: '9', label: '9' }, { value: '11', label: '11' }, { value: '12', label: '12' }, { value: '13', label: '13' }, { value: '15', label: '15' }, { value: '304', label: '304' }];

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	__webpack_require__(2185);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaginatorItem = function (_Component) {
	    _inherits(PaginatorItem, _Component);
	
	    function PaginatorItem() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, PaginatorItem);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.clickPage = function () {
	            var page = _this.props.item.nextPage ? _this.props.item.nextPage : _this.props.item.page;
	
	            _this.props.clickPage(page);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    PaginatorItem.prototype.render = function render() {
	        var className = 'pagination-item' + (this.props.item.active ? ' active' : '');
	
	        return _react2.default.createElement(
	            'li',
	            { className: className, onClick: this.clickPage },
	            _react2.default.createElement(
	                'div',
	                null,
	                this.props.item.page
	            )
	        );
	    };
	
	    return PaginatorItem;
	}(_react.Component);
	
	exports.default = PaginatorItem;

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchType = function (_Component) {
	    _inherits(SearchType, _Component);
	
	    function SearchType() {
	        _classCallCheck(this, SearchType);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    SearchType.prototype.render = function render() {
	        var formItemClass = 'form-item' + (this.props.isSelected ? ' selected' : '');
	        var wrapperDivId = 'edit-ir-search-pacer-type-set-court-type-search' + this.props.name + '-wrapper';
	        var labelFor = 'edit-ir-search-pacer-type-set-court-type-search' + this.props.name;
	        var inputId = 'edit-ir-search-pacer-type-set-court-type-search' + this.props.name;
	
	        return _react2.default.createElement(
	            'div',
	            {
	                onClick: this.props.changeSearchType.bind(this, this.props.name),
	                className: formItemClass, id: wrapperDivId },
	            _react2.default.createElement(
	                'label',
	                { className: 'option', htmlFor: labelFor },
	                _react2.default.createElement('input', {
	                    type: 'radio',
	                    id: inputId,
	                    name: this.props.formName,
	                    checked: this.props.isSelected,
	                    onChange: function onChange() {
	                        return null;
	                    },
	                    className: 'form-radio' }),
	                ' ',
	                this.props.name
	            )
	        );
	    };
	
	    return SearchType;
	}(_react.Component);
	
	SearchType.defaultProps = {
	    formName: 'pacerSearch'
	};
	
	SearchType.propTypes = {
	    formName: _propTypes2.default.string
	};
	
	exports.default = SearchType;

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SearchType = __webpack_require__(684);
	
	var _SearchType2 = _interopRequireDefault(_SearchType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchTypes = function (_Component) {
	  _inherits(SearchTypes, _Component);
	
	  function SearchTypes() {
	    _classCallCheck(this, SearchTypes);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SearchTypes.prototype.getSearchTypeRadioButtons = function getSearchTypeRadioButtons() {
	    var _this2 = this;
	
	    return this.props.listOfSearchTypes.map(function (type) {
	      return _react2.default.createElement(_SearchType2.default, {
	        key: type,
	        changeSearchType: _this2.props.changeSearchType,
	        isSelected: _this2.props.selectedSearchType === type,
	        name: type
	      });
	    });
	  };
	
	  SearchTypes.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { id: 'court_type_wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'form-item' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-radios' },
	          this.getSearchTypeRadioButtons()
	        )
	      ),
	      _react2.default.createElement('div', { className: 'clear' })
	    );
	  };
	
	  return SearchTypes;
	}(_react.Component);
	
	SearchTypes.propTypes = {
	  listOfSearchTypes: _propTypes2.default.array
	};
	
	SearchTypes.defaultProps = {
	  listOfSearchTypes: ['Bankruptcy', 'Civil', 'Criminal']
	};
	
	exports.default = SearchTypes;

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PopoverOfForm = __webpack_require__(203);
	
	var _PopoverOfForm2 = _interopRequireDefault(_PopoverOfForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //packages
	
	
	//form elements
	
	
	var CaseTitleTooltip = function (_Component) {
	    _inherits(CaseTitleTooltip, _Component);
	
	    function CaseTitleTooltip() {
	        _classCallCheck(this, CaseTitleTooltip);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    CaseTitleTooltip.prototype.render = function render() {
	        return _react2.default.createElement(
	            _PopoverOfForm2.default,
	            null,
	            _react2.default.createElement(
	                'p',
	                null,
	                'To search for a specific case title, enter the title in this field.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Cast Title searches are not case sensitive, so it doesn\'t matter if you enter any combination of lower or upper case letters.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'A search wildcard is assumed at the end of the search string. Use the \'*\' character to specify a wildcard in your search.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Enter all available search criteria into the form for fastest results. Multiple fileds can be used in the search.'
	            )
	        );
	    };
	
	    return CaseTitleTooltip;
	}(_react.Component);
	
	exports.default = CaseTitleTooltip;

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BankruptcyCasesResultTable = function BankruptcyCasesResultTable(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'table',
	    { className: 'ir-search-table-results sticky-enabled sticky-table' },
	    _react2.default.createElement(
	      'thead',
	      { className: 'tableHeader-processed' },
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'th',
	          null,
	          'Case Title'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Court'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Case No'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Chapter'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Date Filed'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Date Closed'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'tbody',
	      null,
	      data.map(function (row, idx) {
	        return _react2.default.createElement(
	          'tr',
	          { key: idx },
	          _react2.default.createElement(
	            'td',
	            null,
	            row.case_title
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            row.court_code
	          ),
	          _react2.default.createElement(
	            'td',
	            { className: 'ir-search-no-wrap' },
	            _react2.default.createElement(
	              'a',
	              {
	                href: '/rpc/legacy/case-menu-redirect/' + row.court_code + '/' + row.case_no,
	                target: '_blank'
	              },
	              row.case_no
	            )
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            row.chapter
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            row.date_filed
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            row.date_closed
	          )
	        );
	      })
	    )
	  );
	};
	
	BankruptcyCasesResultTable.propTypes = {
	  data: _propTypes2.default.array.isRequired
	};
	
	exports.default = BankruptcyCasesResultTable;

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BankruptcyPartiesResultTable = function BankruptcyPartiesResultTable(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'table',
	    { className: 'ir-search-table-results sticky-enabled sticky-table' },
	    _react2.default.createElement(
	      'thead',
	      { className: 'tableHeader-processed' },
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'th',
	          null,
	          'Party Name'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Role'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Court'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Case No'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Chapter'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Date Filed'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Date Closed'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'tbody',
	      null,
	      data.map(function (row, idx) {
	        return _react2.default.createElement(
	          'tr',
	          { key: idx },
	          _react2.default.createElement(
	            'td',
	            null,
	            row.party_name
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            row.party_role
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            row.court_code
	          ),
	          _react2.default.createElement(
	            'td',
	            { className: 'ir-search-no-wrap' },
	            _react2.default.createElement(
	              'a',
	              {
	                href: '/rpc/legacy/case-menu-redirect/' + row.court_code + '/' + row.case_no,
	                target: '_blank'
	              },
	              row.case_no
	            )
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            row.chapter
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            row.date_filed
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            row.date_closed
	          )
	        );
	      })
	    )
	  );
	};
	
	BankruptcyPartiesResultTable.propTypes = {
	  data: _propTypes2.default.array.isRequired
	};
	
	exports.default = BankruptcyPartiesResultTable;

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CivilCasesResultTable = function CivilCasesResultTable(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'table',
	    { className: 'ir-search-table-results sticky-enabled sticky-table' },
	    _react2.default.createElement(
	      'thead',
	      { className: 'tableHeader-processed' },
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'th',
	          null,
	          'Case Title'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Court'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Case No'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'NOS'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Date Filed'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Date Closed'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'tbody',
	      null,
	      data.map(function (row, idx) {
	        return _react2.default.createElement(
	          'tr',
	          { key: idx },
	          _react2.default.createElement(
	            'td',
	            null,
	            row.case_title
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            row.court_code
	          ),
	          _react2.default.createElement(
	            'td',
	            { className: 'ir-search-no-wrap' },
	            _react2.default.createElement(
	              'a',
	              {
	                href: '/rpc/legacy/case-menu-redirect/' + row.court_code + '/' + row.case_no,
	                target: '_blank'
	              },
	              row.case_no
	            )
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            row.nature_of_suit_code
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            row.date_filed
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            row.date_closed
	          )
	        );
	      })
	    )
	  );
	};
	
	CivilCasesResultTable.propTypes = {
	  data: _propTypes2.default.array.isRequired
	};
	
	exports.default = CivilCasesResultTable;

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CivilPartiesResultTable = function CivilPartiesResultTable(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'table',
	    { className: 'ir-search-table-results sticky-enabled sticky-table' },
	    _react2.default.createElement(
	      'thead',
	      { className: 'tableHeader-processed' },
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'th',
	          null,
	          'Party Name'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Role'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Court'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Case No'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'NOS'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Date Filed'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Date Closed'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'tbody',
	      null,
	      data.map(function (row, idx) {
	        return _react2.default.createElement(
	          'tr',
	          { key: idx },
	          _react2.default.createElement(
	            'td',
	            null,
	            row.party_name
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            row.party_role
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            row.court_code
	          ),
	          _react2.default.createElement(
	            'td',
	            { className: 'ir-search-no-wrap' },
	            _react2.default.createElement(
	              'a',
	              {
	                href: '/rpc/legacy/case-menu-redirect/' + row.court_code + '/' + row.case_no,
	                target: '_blank'
	              },
	              row.case_no
	            )
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            row.nature_of_suit_code
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            row.date_filed
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            row.date_closed
	          )
	        );
	      })
	    )
	  );
	};
	
	CivilPartiesResultTable.propTypes = {
	  data: _propTypes2.default.array.isRequired
	};
	
	exports.default = CivilPartiesResultTable;

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LocalCourtSearch = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _SearchTypes = __webpack_require__(685);
	
	var _SearchTypes2 = _interopRequireDefault(_SearchTypes);
	
	var _BankruptcyForm = __webpack_require__(412);
	
	var _BankruptcyForm2 = _interopRequireDefault(_BankruptcyForm);
	
	var _CivilForm = __webpack_require__(413);
	
	var _CivilForm2 = _interopRequireDefault(_CivilForm);
	
	var _AppellateForm = __webpack_require__(411);
	
	var _AppellateForm2 = _interopRequireDefault(_AppellateForm);
	
	var _Loading = __webpack_require__(81);
	
	var _Receipt = __webpack_require__(611);
	
	var _Receipt2 = _interopRequireDefault(_Receipt);
	
	var _NoResults = __webpack_require__(408);
	
	var _NoResults2 = _interopRequireDefault(_NoResults);
	
	var _localCourtSearchAction = __webpack_require__(271);
	
	var _LocalCourtResults = __webpack_require__(414);
	
	var _LocalCourtResults2 = _interopRequireDefault(_LocalCourtResults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var searchForms = {
	  Bankruptcy: _BankruptcyForm2.default,
	  Civil: _CivilForm2.default,
	  Criminal: _CivilForm2.default,
	  Appellate: _AppellateForm2.default
	};
	
	var LocalCourtSearch = exports.LocalCourtSearch = function (_Component) {
	  _inherits(LocalCourtSearch, _Component);
	
	  function LocalCourtSearch(props) {
	    _classCallCheck(this, LocalCourtSearch);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.handleChangeSearchType = function (selectedSearchType) {
	      _this.setState({ selectedSearchType: selectedSearchType });
	      _this.props.onResetSearch();
	    };
	
	    _this.state = {
	      selectedSearchType: 'Bankruptcy'
	    };
	    return _this;
	  }
	
	  LocalCourtSearch.prototype.render = function render() {
	    var selectedSearchType = this.state.selectedSearchType;
	
	    var SearchForm = searchForms[selectedSearchType];
	    var _props = this.props,
	        searchResultsType = _props.searchResultsType,
	        isLoading = _props.isLoading,
	        receipts = _props.receipts,
	        searchType = _props.searchType,
	        data = _props.data;
	
	
	    return _react2.default.createElement(
	      'section',
	      { className: 'filings-form' },
	      _react2.default.createElement(_SearchTypes2.default, {
	        listOfSearchTypes: Object.keys(searchForms),
	        changeSearchType: this.handleChangeSearchType,
	        selectedSearchType: selectedSearchType
	      }),
	      _react2.default.createElement(SearchForm, this.props),
	      _react2.default.createElement(_Loading.Loading, { show: isLoading }),
	      searchResultsType && _react2.default.createElement(
	        'div',
	        { className: 'ir-search-items' },
	        searchResultsType === 'empty' ? _react2.default.createElement(_NoResults2.default, null) : _react2.default.createElement(_LocalCourtResults2.default, { data: data, searchResultsType: searchResultsType, searchType: searchType }),
	        receipts.map(function (receipt, idx) {
	          return _react2.default.createElement(
	            _Receipt2.default,
	            { key: idx },
	            receipt
	          );
	        })
	      )
	    );
	  };
	
	  return LocalCourtSearch;
	}(_react.Component);
	
	LocalCourtSearch.displayName = 'LocalCourtSearch';
	
	
	LocalCourtSearch.propTypes = {
	  searchResultsType: _propTypes2.default.string,
	  isLoading: _propTypes2.default.bool,
	  receipts: _propTypes2.default.any,
	  onResetSearch: _propTypes2.default.func.isRequired,
	  data: _propTypes2.default.any,
	  searchType: _propTypes2.default.string
	};
	
	LocalCourtSearch.defaultProps = {
	  searchResultsType: null,
	  isLoading: false,
	  receipts: [],
	  data: [],
	  searchType: ''
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return _extends({}, state.get('localCourtSearch').toJS());
	};
	
	var mapDispatchToProps = {
	  onResetSearch: _localCourtSearchAction.resetLocalCourtSearch
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LocalCourtSearch);

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _redux = __webpack_require__(240);
	
	var _BankruptcySearchForm = __webpack_require__(1184);
	
	var _BankruptcySearchForm2 = _interopRequireDefault(_BankruptcySearchForm);
	
	var _CivilSearchForm = __webpack_require__(1186);
	
	var _CivilSearchForm2 = _interopRequireDefault(_CivilSearchForm);
	
	var _CriminalSearchForm = __webpack_require__(1187);
	
	var _CriminalSearchForm2 = _interopRequireDefault(_CriminalSearchForm);
	
	var _SearchTypes = __webpack_require__(685);
	
	var _SearchTypes2 = _interopRequireDefault(_SearchTypes);
	
	var _SearchResults = __webpack_require__(1181);
	
	var _SearchResults2 = _interopRequireDefault(_SearchResults);
	
	var _Loading = __webpack_require__(81);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _AppellateForm = __webpack_require__(1183);
	
	var _AppellateForm2 = _interopRequireDefault(_AppellateForm);
	
	var _globalUtils = __webpack_require__(59);
	
	var _pacerSearch = __webpack_require__(93);
	
	var actions = _interopRequireWildcard(_pacerSearch);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var courtDriveSearchForms = {
	  Bankruptcy: _BankruptcySearchForm2.default,
	  Civil: _CivilSearchForm2.default,
	  Criminal: _CriminalSearchForm2.default,
	  Appellate: _AppellateForm2.default
	};
	var inforuptcySearchForms = {
	  Bankruptcy: _BankruptcySearchForm2.default
	};
	
	var searchForms = (0, _globalUtils.isCourtDrive)() ? courtDriveSearchForms : inforuptcySearchForms;
	
	var PacerSearch = function (_Component) {
	  _inherits(PacerSearch, _Component);
	
	  function PacerSearch(props) {
	    _classCallCheck(this, PacerSearch);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.changeSearchType = function (caseType) {
	      _this.props.actions.resetSearchResults();
	      _this.props.actions.updateFilter({ case_type: caseType });
	    };
	
	    _this.resetFilters = function () {
	      _this.props.actions.resetFilters();
	    };
	
	    _this.state = {
	      // it's possible for user to set 'Civil' on courtdrive and then go to Inforuptcy where that form doesn't exist
	      // this ensures that we dont' throw errors in such cases (
	      // mostly admin might do this, regular users don't hop between sites)
	      selectedSearchType: (0, _globalUtils.isCourtDrive)() ? props.user.getIn(['settings', 'pacer_search_default_case_type'], 'Bankruptcy') : props.filters.get('case_type', 'Bankruptcy')
	    };
	    return _this;
	  }
	
	  PacerSearch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var selectedSearchType = nextProps.filters.get('case_type', 'Bankruptcy');
	    if (selectedSearchType !== this.state.selectedSearchType) {
	      this.setState({ selectedSearchType: selectedSearchType });
	    }
	  };
	
	  PacerSearch.prototype.render = function render() {
	    var selectedSearchType = this.state.selectedSearchType;
	
	    var SearchForm = searchForms[selectedSearchType];
	    var searchResultsType = this.props.pacerSearchResults.get('searchResultsType');
	
	    var results = searchResultsType != null ? _react2.default.createElement(_SearchResults2.default, _extends({}, this.props, {
	      selectedSearchType: selectedSearchType,
	      clickPage: this.clickPage,
	      filters: this.props.filters })) : null;
	
	    var searchTypes = Object.keys(searchForms);
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'pacer-search-container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'filings-form' },
	        _react2.default.createElement(_SearchTypes2.default, {
	          listOfSearchTypes: searchTypes,
	          changeSearchType: this.changeSearchType,
	          selectedSearchType: selectedSearchType }),
	        _react2.default.createElement(SearchForm, _extends({}, this.props, {
	          searchType: selectedSearchType,
	          filters: this.props.filters,
	          updateFilter: this.props.actions.updateFilter,
	          resetFilters: this.resetFilters })),
	        _react2.default.createElement(_Loading2.default, { show: this.props.pacerSearchResults.get('isLoading') }),
	        results
	      )
	    );
	  };
	
	  return PacerSearch;
	}(_react.Component);
	
	PacerSearch.propTypes = {
	  // will fix these types later
	  user: _propTypes2.default.any.isRequired,
	  filters: _propTypes2.default.any.isRequired,
	  actions: _propTypes2.default.object.isRequired,
	  pacerSearchResults: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    pacerSearchResults: state.get('pacerSearchResults'),
	    filters: state.get('pacerSearchResults').get('filters'),
	    user: state.get('user')
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PacerSearch);

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.search = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //packages
	
	
	//validations
	
	
	//constants
	
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _querystring = __webpack_require__(862);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	var _reactRouterRedux = __webpack_require__(519);
	
	var _validations = __webpack_require__(137);
	
	var _validations2 = _interopRequireDefault(_validations);
	
	var _errorActionTypes = __webpack_require__(101);
	
	var errorConstants = _interopRequireWildcard(_errorActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validateInputs = function validateInputs(search_type, againstPacer) {
	  if (againstPacer && !client_code_is_valid()) {
	    return {
	      messages: ["Please set a valid client code first."]
	    };
	  }
	
	  var messages = [];
	  var fields = [];
	
	  switch (search_type) {
	    case 'case_no':
	      var case_no = this.props.filters.get('case_no');
	      if (!case_no || !_validations2.default.CASE_NUMBER_WILDCARD(case_no)) {
	        messages.push('Invalid case number format.');
	        fields.push('case_no');
	      }
	      break;
	    case 'party_title':
	      var party_title = this.props.filters.get('party_title');
	      if (party_title && !_validations2.default.PARTY_NAME_CASE_TITLE(party_title)) {
	        messages.push('Invalid case title format.');
	        fields.push('party_title');
	      }
	  }
	
	  return messages.length ? { messages: messages, fields: fields } : null;
	};
	
	var urlUpdate = function urlUpdate(query, search_term) {
	  var court_name = query.court_name,
	      court_code = query.court_code;
	
	  var courts = '';
	  var courtCodes = '';
	
	  if (court_name && court_name.includes(',')) {
	    delete query.court_name;
	    courts = court_name.split(',').reduce(function (accum, next) {
	      return accum += '&court_name[]=' + next;
	    }, '');
	    courts = encodeURI(courts);
	  }
	
	  if (court_code && court_code.includes(',')) {
	    delete query.court_code;
	    courtCodes = court_code.split(',').reduce(function (accum, next) {
	      return accum += '&court_code[]=' + next;
	    }, '');
	    courtCodes = encodeURI(courtCodes);
	  }
	
	  var queriesStringifed = _querystring2.default.stringify(_extends({}, query, { search_term: search_term
	  }));
	
	  this.props.dispatch(function (dispatch, state) {
	    dispatch((0, _reactRouterRedux.push)('/filings/search-court-filings?' + queriesStringifed + courts + courtCodes));
	  });
	};
	
	var search = exports.search = function search() {
	  var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var againstPacer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  var filters = this.props.filters;
	  console.log("Overide Filter", filter, "Filters", filters.toJS());
	
	  var search_type = filter.search_type || filters.get('search_type');
	  var searchTypeQueryName = search_type === 'case_no' && !_lodash2.default.isEmpty(filters) ? 'case_no' : 'party_title';
	
	  var searchValue = searchTypeQueryName === 'party_title' && !filters.get(search_type) ? '*' : filters.get(search_type);
	
	  var case_type = filter.case_type || filters.get('case_type');
	
	  var query = _lodash2.default.pickBy({
	    case_type: /all/i.test(case_type) ? null : case_type.toLowerCase(),
	    filed_from: !_lodash2.default.isUndefined(filter.filed_from) ? filter.filed_from : filters.get('filed_from') && filters.get('filed_from').format('MM/DD/YYYY'),
	    filed_to: !_lodash2.default.isUndefined(filter.filed_to) ? filter.filed_to : filters.get('filed_to') && filters.get('filed_to').format('MM/DD/YYYY'),
	    order: !_lodash2.default.isUndefined(filter.order) ? filter.order : filters.get('order'),
	    sort: !_lodash2.default.isUndefined(filter.sort) ? filter.sort : filters.get('sort'),
	    year: !_lodash2.default.isUndefined(filter.year) ? filter.year : filters.get('year'),
	    chapter: !_lodash2.default.isUndefined(filter.chapter) ? filter.chapter : filters.get('chapter'),
	    court_name: !_lodash2.default.isUndefined(filter.court_name) ? filter.court_name : filters.get('court_name'),
	    page: !_lodash2.default.isUndefined(filter.page) ? filter.page : filters.get('page'),
	    court_code: !_lodash2.default.isUndefined(filter.region_name) ? filter.region_name : filters.get('region_name') || ''
	  }, _lodash2.default.identity);
	
	  var validationErrors = validateInputs.bind(this)(searchTypeQueryName, againstPacer);
	
	  if (validationErrors) {
	    this.props.errorActions.receiveError(errorConstants.VALIDATION_ERROR, validationErrors);
	  } else {
	    urlUpdate.bind(this)(_extends({}, query, { search_type: search_type }), searchValue);
	    this.props.actions.partySearch(query, searchTypeQueryName, searchValue);
	  }
	};

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.AutomatedReports = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _searchAlertsAction = __webpack_require__(423);
	
	var _AutomatedReportsTable = __webpack_require__(417);
	
	var _AutomatedReportsTable2 = _interopRequireDefault(_AutomatedReportsTable);
	
	var _DeleteModal = __webpack_require__(677);
	
	var _DeleteModal2 = _interopRequireDefault(_DeleteModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AutomatedReports = exports.AutomatedReports = function (_Component) {
	  _inherits(AutomatedReports, _Component);
	
	  function AutomatedReports(props) {
	    _classCallCheck(this, AutomatedReports);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.onRemoveButtonClick = function (id) {
	      _this.setState({
	        showPopup: true,
	        onConfirmModal: function onConfirmModal() {
	          _this.props.removeAlert({ id: id });
	          _this.onCloseModal();
	        }
	      });
	    };
	
	    _this.onCloseModal = function () {
	      _this.setState({
	        showPopup: false,
	        onConfirmModal: function onConfirmModal() {}
	      });
	    };
	
	    _this.state = {
	      showPopup: false,
	      onConfirmModal: function onConfirmModal() {}
	    };
	    return _this;
	  }
	
	  AutomatedReports.prototype.componentDidMount = function componentDidMount() {
	    this.props.getAlerts();
	  };
	
	  AutomatedReports.prototype.render = function render() {
	    var _props = this.props,
	        alerts = _props.alerts,
	        getAlerts = _props.getAlerts,
	        isLoading = _props.isLoading;
	
	
	    return _react2.default.createElement(
	      'section',
	      null,
	      _react2.default.createElement(
	        'h2',
	        { id: 'realtime-alerts-top', style: { marginTop: '32px' } },
	        'Automated Reports'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Receive reports (email & CSV) of bankruptcy cases matching specific criteria that you set.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { textAlign: 'right' } },
	        _react2.default.createElement(
	          'a',
	          { href: '/filings/search-bankruptcy-reports', className: 'form-submit' },
	          'Add New Report'
	        )
	      ),
	      _react2.default.createElement(_AutomatedReportsTable2.default, {
	        alerts: alerts,
	        isLoading: isLoading,
	        onRemoveButtonClick: this.onRemoveButtonClick
	      }),
	      _react2.default.createElement(
	        'div',
	        { style: { textAlign: 'right' } },
	        _react2.default.createElement(
	          'small',
	          null,
	          _react2.default.createElement(
	            'a',
	            {
	              href: '#',
	              onClick: function onClick(e) {
	                e.preventDefault();getAlerts();
	              }
	            },
	            'Refresh'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _DeleteModal2.default,
	        {
	          show: this.state.showPopup,
	          title: 'Remove Alert',
	          onClose: this.onCloseModal,
	          onConfirm: this.state.onConfirmModal
	        },
	        'Are you sure you wish to remove this alert?'
	      )
	    );
	  };
	
	  return AutomatedReports;
	}(_react.Component);
	
	AutomatedReports.displayName = 'AutomatedReports';
	
	
	AutomatedReports.propTypes = {
	  alerts: _propTypes2.default.array,
	  isLoading: _propTypes2.default.bool,
	  getAlerts: _propTypes2.default.func,
	  removeAlert: _propTypes2.default.func
	};
	
	AutomatedReports.defaultProps = {
	  alerts: [],
	  isLoading: false,
	  getAlerts: function getAlerts() {},
	  removeAlert: function removeAlert() {}
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    alerts: state.getIn(['automatedReports', 'alerts']).toJS(),
	    isLoading: state.getIn(['automatedReports', 'isLoading'])
	  };
	};
	
	var mapDispatchToProps = {
	  getAlerts: _searchAlertsAction.getAutomatedReports,
	  removeAlert: _searchAlertsAction.removeAutomatedReport
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AutomatedReports);

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CustomAlerts = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactRedux = __webpack_require__(13);
	
	var _Notification = __webpack_require__(24);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	var _searchAlertsAction = __webpack_require__(423);
	
	var _dateFormat = __webpack_require__(94);
	
	var _CustomAlertEdit = __webpack_require__(418);
	
	var _CustomAlertEdit2 = _interopRequireDefault(_CustomAlertEdit);
	
	var _Loading = __webpack_require__(81);
	
	var _DeleteModal = __webpack_require__(677);
	
	var _DeleteModal2 = _interopRequireDefault(_DeleteModal);
	
	var _DeliveryLogModal = __webpack_require__(696);
	
	var _DeliveryLogModal2 = _interopRequireDefault(_DeliveryLogModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CustomAlerts = exports.CustomAlerts = function (_Component) {
	  _inherits(CustomAlerts, _Component);
	
	  function CustomAlerts(props) {
	    _classCallCheck(this, CustomAlerts);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.onEditButtonClick = function (event, oldAlert, index) {
	      event.preventDefault();
	
	      _this.setState({
	        showEditModal: true,
	        alert: oldAlert,
	        onSaveEditModal: function onSaveEditModal(editedAlert) {
	          _this.props.updateCustomAlert({ alert: editedAlert, index: index });
	          _this.onCloseEditModal();
	        }
	      });
	    };
	
	    _this.onCloseEditModal = function () {
	      _this.setState({
	        showEditModal: false,
	        onSaveEditModal: function onSaveEditModal() {
	          return null;
	        }
	      });
	    };
	
	    _this.onRemoveButtonClick = function (event, alert, index) {
	      event.preventDefault();
	
	      _this.setState({
	        showRemoveModal: true,
	        alert: alert,
	        onConfirmRemoveModal: function onConfirmRemoveModal() {
	          _this.props.removeCustomAlert({ alert: alert, index: index });
	          _this.onCloseRemoveModal();
	        }
	      });
	    };
	
	    _this.onResendButtonClick = function (event, alert, index) {
	      event.preventDefault();
	      _this.props.resendCustomAlert({ alert: alert, index: index });
	    };
	
	    _this.onCloseRemoveModal = function () {
	      _this.setState({
	        showRemoveModal: false,
	        onConfirmRemoveModal: function onConfirmRemoveModal() {
	          return null;
	        }
	      });
	    };
	
	    _this.onLogButtonClick = function (event, alert) {
	      event.preventDefault();
	      _this.setState({ showLogModal: true, logAlert: alert });
	      _this.props.getDeliveryLog(alert.id);
	    };
	
	    _this.onCloseLogModal = function () {
	      _this.setState({ showLogModal: false, logAlert: null });
	    };
	
	    _this.state = {
	      alert: {},
	      showEditModal: false,
	      showRemoveModal: false,
	      showLogModal: false,
	      logAlert: null,
	      onSaveEditModal: function onSaveEditModal() {
	        return null;
	      },
	      onConfirmRemoveModal: function onConfirmRemoveModal() {
	        return null;
	      }
	    };
	    return _this;
	  }
	
	  CustomAlerts.prototype.componentDidMount = function componentDidMount() {
	    this.props.getCustomAlerts();
	  };
	
	  CustomAlerts.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        alerts = _props.alerts,
	        isLoading = _props.isLoading;
	
	    var columns = ['Name', 'Created', 'Last executed', 'Type', 'List', 'Interval', 'Operations'];
	
	    var EditLink = function EditLink(_ref) {
	      var alert = _ref.alert,
	          index = _ref.index,
	          children = _ref.children;
	      return alert.customize_access && !alert.isUpdating ? _react2.default.createElement(
	        'a',
	        { href: '#', onClick: function onClick(e) {
	            return _this2.onEditButtonClick(e, alert, index);
	          } },
	        children
	      ) : _react2.default.createElement(
	        'span',
	        null,
	        children
	      );
	    };
	
	    var hasForwarding = function hasForwarding(alert) {
	      return alert.mail_list && alert.mail_list.length > 0 && alert.notify_interval.toString() !== '-1' && alert.delivery !== 'webhook';
	    };
	
	    return _react2.default.createElement(
	      'section',
	      null,
	      _react2.default.createElement(_Notification2.default, null),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Custom Alerts'
	      ),
	      _react2.default.createElement(
	        'table',
	        null,
	        _react2.default.createElement(
	          'thead',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            columns.map(function (column, index) {
	              return _react2.default.createElement(
	                'th',
	                {
	                  key: column,
	                  colSpan: index === columns.length - 1 ? 4 : 1
	                },
	                column
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'tbody',
	          null,
	          alerts.length === 0 || isLoading ? _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'td',
	              { colSpan: '100%' },
	              isLoading ? _react2.default.createElement(_Loading.Loading, { show: isLoading, type: 'bar' }) : 'You have created no search alerts yet.'
	            )
	          ) : alerts.map(function (alert, index) {
	            return _react2.default.createElement(
	              'tr',
	              { key: alert.id },
	              _react2.default.createElement(
	                'td',
	                null,
	                alert.name
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                (0, _dateFormat.formatUnixDate)(alert.created)
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                (0, _dateFormat.getPeriodFromNow)(alert.last_execute)
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                alert.type_label
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  EditLink,
	                  { alert: alert, index: index },
	                  _react2.default.createElement(
	                    _reactBootstrap.OverlayTrigger,
	                    {
	                      trigger: ['hover', 'focus'],
	                      placement: 'right',
	                      overlay: _react2.default.createElement(
	                        _reactBootstrap.Popover,
	                        { id: 'popover-list-' + alert.id },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          'To:'
	                        ),
	                        hasForwarding(alert) ? _react2.default.createElement(
	                          'ul',
	                          { style: { display: 'inline-grid' } },
	                          alert.mail_list.map(function (email, i) {
	                            return _react2.default.createElement(
	                              'li',
	                              {
	                                key: i,
	                                style: { background: 'none' }
	                              },
	                              email
	                            );
	                          })
	                        ) : _react2.default.createElement(
	                          'em',
	                          null,
	                          '\xA0No forwarding set'
	                        ),
	                        _react2.default.createElement('hr', null),
	                        alert.customize_access && _react2.default.createElement(
	                          'small',
	                          null,
	                          'Click the icon to change forwarding settings'
	                        )
	                      )
	                    },
	                    _react2.default.createElement('i', {
	                      className: 'fa fa-users',
	                      style: {
	                        color: hasForwarding(alert) ? '#55c231' : 'silver',
	                        fontSize: '2em'
	                      }
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  EditLink,
	                  { alert: alert, index: index },
	                  alert.delivery === 'webhook' ? 'Webhook' : alert.notify_interval_options.find(function (option) {
	                    return option.value.toString() === alert.notify_interval.toString();
	                  }).label
	                ),
	                alert.delivery === 'webhook' && _react2.default.createElement(
	                  'span',
	                  { style: { whiteSpace: 'nowrap' } },
	                  ' | ',
	                  _react2.default.createElement(
	                    'a',
	                    { href: '#', onClick: function onClick(e) {
	                        return _this2.onLogButtonClick(e, alert);
	                      } },
	                    'Log'
	                  ),
	                  alert.has_failed_deliveries && _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    '\xA0',
	                    _react2.default.createElement('i', {
	                      className: 'fa fa-exclamation-triangle',
	                      style: { color: '#d9534f' },
	                      title: 'Recent delivery failures'
	                    })
	                  )
	                )
	              ),
	              alert.customize_access ? alert.isUpdating ? _react2.default.createElement(
	                'td',
	                { colSpan: '4' },
	                _react2.default.createElement(_Loading.Loading, { show: alert.isUpdating, type: 'spinner' })
	              ) : _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: '#', onClick: function onClick(e) {
	                        return _this2.onEditButtonClick(e, alert, index);
	                      } },
	                    'Edit'
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: alert.url },
	                    'Show'
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  alert.isBeingResent ? _react2.default.createElement(_Loading.Loading, { show: alert.isBeingResent, type: 'spinner' }) : alert.resend ? _react2.default.createElement(
	                    'a',
	                    { className: 'disabled' },
	                    'Resend'
	                  ) : _react2.default.createElement(
	                    'a',
	                    { href: '#', onClick: function onClick(e) {
	                        return _this2.onResendButtonClick(e, alert, index);
	                      } },
	                    'Resend'
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  alert.isBeingRemoved ? _react2.default.createElement(_Loading.Loading, { show: alert.isBeingRemoved, type: 'spinner' }) : _react2.default.createElement(
	                    'a',
	                    { href: '#', onClick: function onClick(e) {
	                        return _this2.onRemoveButtonClick(e, alert, index);
	                      } },
	                    'Delete'
	                  )
	                )
	              ) : _react2.default.createElement(
	                'td',
	                { colSpan: '4' },
	                _react2.default.createElement(
	                  'em',
	                  null,
	                  'Permission denied'
	                )
	              )
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { textAlign: 'right' } },
	        _react2.default.createElement(
	          'small',
	          null,
	          _react2.default.createElement(
	            'a',
	            {
	              href: '#',
	              onClick: function onClick(e) {
	                e.preventDefault();_this2.props.getCustomAlerts();
	              }
	            },
	            'Refresh'
	          )
	        )
	      ),
	      _react2.default.createElement(_CustomAlertEdit2.default, {
	        show: this.state.showEditModal,
	        onClose: this.onCloseEditModal,
	        onSave: this.state.onSaveEditModal,
	        alert: this.state.alert
	      }),
	      _react2.default.createElement(
	        _DeleteModal2.default,
	        {
	          show: this.state.showRemoveModal,
	          title: 'Delete Alert',
	          onClose: this.onCloseRemoveModal,
	          onConfirm: this.state.onConfirmRemoveModal
	        },
	        'Do you really want to delete ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          this.state.alert.name
	        ),
	        '?'
	      ),
	      _react2.default.createElement(_DeliveryLogModal2.default, {
	        show: this.state.showLogModal,
	        alert: this.state.logAlert,
	        entries: this.props.deliveryLog,
	        isLoading: this.props.deliveryLogLoading,
	        error: this.props.deliveryLogError,
	        onClose: this.onCloseLogModal,
	        onRetry: function onRetry() {
	          return _this2.props.getDeliveryLog(_this2.state.logAlert.id);
	        }
	      })
	    );
	  };
	
	  return CustomAlerts;
	}(_react.Component);
	
	CustomAlerts.displayName = 'CustomAlerts';
	
	
	CustomAlerts.propTypes = {
	  alerts: _propTypes2.default.array,
	  isLoading: _propTypes2.default.bool,
	  deliveryLog: _propTypes2.default.array,
	  deliveryLogLoading: _propTypes2.default.bool,
	  deliveryLogError: _propTypes2.default.any,
	  getCustomAlerts: _propTypes2.default.func,
	  updateCustomAlert: _propTypes2.default.func,
	  removeCustomAlert: _propTypes2.default.func,
	  resendCustomAlert: _propTypes2.default.func,
	  getDeliveryLog: _propTypes2.default.func
	};
	
	CustomAlerts.defaultProps = {
	  alerts: [],
	  isLoading: false,
	  deliveryLog: [],
	  deliveryLogLoading: false,
	  deliveryLogError: null,
	  getCustomAlerts: function getCustomAlerts() {},
	  updateCustomAlert: function updateCustomAlert() {},
	  removeCustomAlert: function removeCustomAlert() {},
	  resendCustomAlert: function resendCustomAlert() {},
	  getDeliveryLog: function getDeliveryLog() {}
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    alerts: state.getIn(['customAlerts', 'alerts']).toJS(),
	    isLoading: state.getIn(['customAlerts', 'isLoading']),
	    deliveryLog: state.getIn(['customAlerts', 'deliveryLog']).toJS(),
	    deliveryLogLoading: state.getIn(['customAlerts', 'deliveryLogLoading']),
	    deliveryLogError: state.getIn(['customAlerts', 'deliveryLogError'])
	  };
	};
	
	var mapDispatchToProps = {
	  getCustomAlerts: _searchAlertsAction.getCustomAlerts,
	  updateCustomAlert: _searchAlertsAction.updateCustomAlert,
	  removeCustomAlert: _searchAlertsAction.removeCustomAlert,
	  resendCustomAlert: _searchAlertsAction.resendCustomAlert,
	  getDeliveryLog: _searchAlertsAction.getDeliveryLog
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CustomAlerts);

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _Loading = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formatTimestamp = function formatTimestamp(timestamp) {
	  if (!timestamp) return '';
	  var date = new Date(timestamp);
	  return date.toLocaleString();
	};
	
	var ellipsisStyle = {
	  maxWidth: '200px',
	  overflow: 'hidden',
	  textOverflow: 'ellipsis',
	  whiteSpace: 'nowrap'
	};
	
	var StatusBadge = function StatusBadge(_ref) {
	  var code = _ref.code;
	
	  var style = {
	    display: 'inline-block',
	    padding: '2px 6px',
	    borderRadius: '3px',
	    color: '#fff',
	    fontSize: '12px',
	    fontWeight: 'bold',
	    backgroundColor: code <= 299 ? '#5cb85c' : '#d9534f'
	  };
	  return _react2.default.createElement(
	    'span',
	    { style: style },
	    code
	  );
	};
	
	var DeliveryLogModal = function DeliveryLogModal(_ref2) {
	  var show = _ref2.show,
	      alert = _ref2.alert,
	      entries = _ref2.entries,
	      isLoading = _ref2.isLoading,
	      error = _ref2.error,
	      onClose = _ref2.onClose,
	      onRetry = _ref2.onRetry;
	  return _react2.default.createElement(
	    _reactBootstrap.Modal,
	    { show: show, onHide: onClose, bsSize: 'large' },
	    _react2.default.createElement(
	      _reactBootstrap.Modal.Header,
	      { closeButton: true },
	      _react2.default.createElement(
	        _reactBootstrap.Modal.Title,
	        null,
	        'Webhook Delivery Log ',
	        alert && '\u2014 ' + alert.name
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Modal.Body,
	      null,
	      isLoading && _react2.default.createElement(_Loading.Loading, { show: true, type: 'bar' }),
	      error && !isLoading && _react2.default.createElement(
	        'p',
	        null,
	        'Failed to load delivery log.',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: '#', onClick: function onClick(e) {
	              e.preventDefault();onRetry();
	            } },
	          'Retry'
	        )
	      ),
	      !isLoading && !error && entries.length === 0 && _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'em',
	          null,
	          'No webhook deliveries recorded yet.'
	        )
	      ),
	      !isLoading && !error && entries.length > 0 && _react2.default.createElement(
	        'table',
	        { className: 'table table-condensed' },
	        _react2.default.createElement(
	          'thead',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'th',
	              null,
	              'Timestamp'
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              'URL'
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              'Status'
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              'Response'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'tbody',
	          null,
	          entries.map(function (entry) {
	            return _react2.default.createElement(
	              'tr',
	              { key: entry.id },
	              _react2.default.createElement(
	                'td',
	                { style: { whiteSpace: 'nowrap' } },
	                formatTimestamp(entry.timestamp)
	              ),
	              _react2.default.createElement(
	                'td',
	                { style: ellipsisStyle, title: entry.webhook_url },
	                entry.webhook_url
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(StatusBadge, { code: entry.response_status_code })
	              ),
	              _react2.default.createElement(
	                'td',
	                { style: ellipsisStyle, title: entry.response_text },
	                entry.response_text
	              )
	            );
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Modal.Footer,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        { onClick: onClose },
	        'Close'
	      )
	    )
	  );
	};
	
	DeliveryLogModal.defaultProps = {
	  show: false,
	  alert: null,
	  entries: [],
	  isLoading: false,
	  error: null
	};
	
	DeliveryLogModal.propTypes = {
	  show: _propTypes2.default.bool,
	  alert: _propTypes2.default.object,
	  entries: _propTypes2.default.array,
	  isLoading: _propTypes2.default.bool,
	  error: _propTypes2.default.any,
	  onClose: _propTypes2.default.func.isRequired,
	  onRetry: _propTypes2.default.func.isRequired
	};
	
	exports.default = DeliveryLogModal;

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = WebhookHeadersField;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactFinalForm = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HeaderDropdownItem(_ref) {
	  var name = _ref.name,
	      value = _ref.value,
	      label = _ref.label,
	      _onSelect = _ref.onSelect;
	
	  return _react2.default.createElement(
	    _reactBootstrap.MenuItem,
	    { onSelect: function onSelect() {
	        return _onSelect(name, value);
	      } },
	    _react2.default.createElement(
	      'code',
	      { style: { display: 'block' } },
	      name + ': ' + value.replace('<fill-in>', '').trim()
	    ),
	    _react2.default.createElement(
	      'em',
	      { style: { display: 'block' } },
	      label
	    )
	  );
	}
	
	function WebhookHeadersField() {
	  var _useField = (0, _reactFinalForm.useField)('webhook_headers'),
	      input = _useField.input,
	      meta = _useField.meta;
	
	  var textarea = (0, _react.useRef)(null);
	
	  var _useState = (0, _react.useState)(null),
	      selection = _useState[0],
	      setSelection = _useState[1];
	
	  (0, _react.useEffect)(function () {
	    if (!selection) return undefined;
	    var timer = setTimeout(function () {
	      textarea.current.focus();
	      textarea.current.setSelectionRange(selection.start, selection.end);
	      setSelection(null);
	    }, 0);
	    return function () {
	      return clearTimeout(timer);
	    };
	  }, [selection]);
	
	  function appendHeader(name, value) {
	    var text = input.value || '';
	    var prefix = text + (text && !text.endsWith('\n') ? '\n' : '');
	    var line = name + ': ' + value;
	    input.onChange(prefix + line);
	    var placeholder = line.indexOf('<fill-in>');
	    var start = prefix.length + (placeholder < 0 ? line.length : placeholder);
	    setSelection({ start: start, end: start + (placeholder < 0 ? 0 : '<fill-in>'.length) });
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-item' },
	    _react2.default.createElement(
	      'label',
	      { htmlFor: 'edit-webhook-headers' },
	      'Additional webhook headers:'
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { marginBottom: 8 } },
	      _react2.default.createElement(
	        _reactBootstrap.DropdownButton,
	        { id: 'webhook-common-headers', title: 'Common Headers', bsSize: 'small' },
	        _react2.default.createElement(HeaderDropdownItem, { name: 'Authorization', value: 'Bearer <fill-in>',
	          label: 'Bearer token (AI Agent / Pipedream)', onSelect: appendHeader }),
	        _react2.default.createElement(HeaderDropdownItem, { name: 'Authorization', value: 'Basic <fill-in>',
	          label: 'Basic auth (Base64 username:password)', onSelect: appendHeader }),
	        _react2.default.createElement(HeaderDropdownItem, { name: 'X-API-Key', value: '<fill-in>', label: 'API key', onSelect: appendHeader }),
	        _react2.default.createElement(HeaderDropdownItem, { name: 'x-make-apikey', value: '<fill-in>', label: 'Make webhook API key', onSelect: appendHeader }),
	        _react2.default.createElement(HeaderDropdownItem, { name: 'X-Webhook-Secret', value: '<fill-in>', label: 'n8n Header Auth (example name)', onSelect: appendHeader }),
	        _react2.default.createElement(HeaderDropdownItem, { name: 'anthropic-version', value: '2023-06-01', label: 'Anthropic Version', onSelect: appendHeader })
	      )
	    ),
	    _react2.default.createElement('textarea', _extends({}, input, { ref: textarea, id: 'edit-webhook-headers', rows: '4', className: 'form-textarea',
	      placeholder: 'eg. X-My-Custom-Header: your-value' })),
	    _react2.default.createElement(
	      'div',
	      { className: 'description' },
	      'One header per line, written as Name: value. Leave empty to send no additional headers.'
	    ),
	    meta.error && meta.submitFailed && _react2.default.createElement(
	      'span',
	      { className: 'error description' },
	      meta.error
	    )
	  );
	}

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TemplateAlerts = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactRedux = __webpack_require__(13);
	
	var _searchAlertsAction = __webpack_require__(423);
	
	var _dateFormat = __webpack_require__(94);
	
	var _globalUtils = __webpack_require__(59);
	
	var _Loading = __webpack_require__(81);
	
	var _off_button_small = __webpack_require__(2234);
	
	var _off_button_small2 = _interopRequireDefault(_off_button_small);
	
	var _on_button_small = __webpack_require__(2235);
	
	var _on_button_small2 = _interopRequireDefault(_on_button_small);
	
	__webpack_require__(2188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TemplateAlerts = exports.TemplateAlerts = function (_Component) {
	  _inherits(TemplateAlerts, _Component);
	
	  function TemplateAlerts() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TemplateAlerts);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onEnabledButtonClick = function (index, oldValue, alert) {
	      _this.props.updateAlert({
	        index: index,
	        name: 'enabled',
	        value: !oldValue ? 1 : 0,
	        alert: alert
	      });
	    }, _this.onIntervalSelectChange = function (index, value, alert) {
	      _this.props.updateAlert({
	        index: index,
	        name: 'notify_interval',
	        value: value,
	        alert: alert
	      });
	    }, _this.onResendButtonClick = function (event, alert, index) {
	      event.preventDefault();
	      _this.props.resendTemplateAlert({ alert: alert, index: index });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  TemplateAlerts.prototype.componentDidMount = function componentDidMount() {
	    this.props.getAlerts();
	  };
	
	  TemplateAlerts.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        alerts = _props.alerts,
	        isLoading = _props.isLoading;
	
	
	    return _react2.default.createElement(
	      'section',
	      null,
	      _react2.default.createElement(
	        'h2',
	        { id: 'template-alerts', style: { marginTop: '32px' } },
	        'Template Alerts'
	      ),
	      _react2.default.createElement(
	        'table',
	        { className: 'template-alerts-table' },
	        _react2.default.createElement(
	          'thead',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'th',
	              null,
	              'Name'
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              'Created'
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              'Last executed'
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              'Type'
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              'Opt in/out'
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              'Interval'
	            ),
	            _react2.default.createElement(
	              'th',
	              { colSpan: '2' },
	              'Operation'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'tbody',
	          null,
	          alerts.length === 0 || isLoading ? _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'td',
	              { colSpan: '100%' },
	              isLoading ? _react2.default.createElement(_Loading.Loading, { show: isLoading, type: 'bar' }) : 'No templates available.'
	            )
	          ) : alerts.map(function (alert, index) {
	            return _react2.default.createElement(
	              'tr',
	              { key: alert.id },
	              _react2.default.createElement(
	                'td',
	                null,
	                alert.name
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                (0, _dateFormat.formatUnixDate)(alert.created)
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                (0, _dateFormat.getPeriodFromNow)(alert.last_execute)
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                alert.type_label
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                alert.customize_access ? alert.isUpdating && alert.isUpdating.enabled ? _react2.default.createElement(_Loading.Loading, { show: alert.isUpdating.enabled, type: 'spinner' }) : _react2.default.createElement(
	                  'div',
	                  {
	                    className: 'onoff-switch',
	                    onClick: function onClick() {
	                      return _this2.onEnabledButtonClick(index, alert.enabled, alert);
	                    }
	                  },
	                  _react2.default.createElement('img', { src: alert.enabled ? _on_button_small2.default : _off_button_small2.default, alt: 'on/off switch' })
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'form-item' },
	                  _react2.default.createElement('input', {
	                    type: 'checkbox',
	                    name: 'enabled',
	                    checked: alert.enabled && 'checked',
	                    disabled: 'disabled',
	                    className: 'form-checkbox' })
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                alert.isUpdating && alert.isUpdating.notify_interval ? _react2.default.createElement(_Loading.Loading, { show: alert.isUpdating.notify_interval, type: 'spinner' }) : _react2.default.createElement(
	                  'div',
	                  { className: 'interval-select' },
	                  _react2.default.createElement(_reactSelect2.default, {
	                    options: alert.notify_interval_options,
	                    value: alert.notify_interval,
	                    onChange: function onChange(_ref) {
	                      var value = _ref.value;
	                      return _this2.onIntervalSelectChange(index, value, alert);
	                    },
	                    clearable: false,
	                    disabled: !alert.customize_access
	                  })
	                )
	              ),
	              alert.customize_access ? _react2.default.createElement(
	                _react.Fragment,
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: alert.url },
	                    'Show'
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  alert.isBeingResent ? _react2.default.createElement(_Loading.Loading, { show: alert.isBeingResent, type: 'spinner' }) : alert.resend || !alert.enabled ? _react2.default.createElement(
	                    'a',
	                    { className: 'disabled' },
	                    'Resend'
	                  ) : _react2.default.createElement(
	                    'a',
	                    { href: '#', onClick: function onClick(e) {
	                        return _this2.onResendButtonClick(e, alert, index);
	                      } },
	                    'Resend'
	                  )
	                )
	              ) : _react2.default.createElement(
	                'td',
	                { colSpan: '2' },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    href: (0, _globalUtils.isCourtDrive)() ? 'https://www.courtdrive.com/pricing-plans.html' : 'https://www.inforuptcy.com/pricing/investors'
	                  },
	                  'Upgrade'
	                )
	              )
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { textAlign: 'right' } },
	        _react2.default.createElement(
	          'small',
	          null,
	          _react2.default.createElement(
	            'a',
	            {
	              href: '#',
	              onClick: function onClick(e) {
	                e.preventDefault();_this2.props.getAlerts();
	              }
	            },
	            'Refresh'
	          )
	        )
	      )
	    );
	  };
	
	  return TemplateAlerts;
	}(_react.Component);
	
	TemplateAlerts.propTypes = {
	  alerts: _propTypes2.default.array,
	  isLoading: _propTypes2.default.bool,
	  getAlerts: _propTypes2.default.func,
	  updateAlert: _propTypes2.default.func,
	  resendTemplateAlert: _propTypes2.default.func
	};
	
	TemplateAlerts.defaultProps = {
	  alerts: [],
	  isLoading: false,
	  getAlerts: function getAlerts() {},
	  updateAlert: function updateAlert() {},
	  resendTemplateAlert: function resendTemplateAlert() {}
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    alerts: state.getIn(['templateAlerts', 'alerts']).toJS(),
	    isLoading: state.getIn(['templateAlerts', 'isLoading'])
	  };
	};
	
	var mapDispatchToProps = {
	  getAlerts: _searchAlertsAction.getTemplateAlerts,
	  updateAlert: _searchAlertsAction.updateTemplateAlert,
	  resendTemplateAlert: _searchAlertsAction.resendTemplateAlert
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TemplateAlerts);

/***/ },
/* 699 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = [{ value: '1110', label: '1110 Insurance' }, { value: '1120', label: '1120 Marine Contract Actions' }, { value: '1130', label: '1130 Miller Act' }, { value: '1140', label: '1140 Negotiable Instruments' }, { value: '1150', label: '1150 Overpayments & Enforc. of Judgments' }, { value: '1151', label: '1151 Overpayments Under Medicare Act' }, { value: '1152', label: '1152 Recovery of Defaulted Student Loans' }, { value: '1153', label: '1153 Recovery of Ovrpmnts of Vet Benefit' }, { value: '1190', label: '1190 Other Contract Actions' }, { value: '1195', label: '1195 Contract Product Liability' }, { value: '1196', label: '1196 Franchise' }, { value: '1210', label: '1210 Land Condemnation' }, { value: '1220', label: '1220 Foreclosure' }, { value: '1230', label: '1230 Rent, Lease, Ejectment' }, { value: '1240', label: '1240 Torts To Land' }, { value: '1245', label: '1245 Tort Product Liability' }, { value: '1290', label: '1290 Other Real Property Actions' }, { value: '1340', label: '1340 Marine Personal Injury' }, { value: '1350', label: '1350 Motor Vehicle' }, { value: '1360', label: '1360 Other Personal Injury' }, { value: '1370', label: '1370 Other Fraud' }, { value: '1371', label: '1371 Truth in Lending' }, { value: '1380', label: '1380 Other Personal Property Damage' }, { value: '1385', label: '1385 Property Damage - Product Liability' }, { value: '1410', label: '1410 Antitrust' }, { value: '1422', label: '1422 Bankruptcy Appeals Rule 28 USC 158' }, { value: '1423', label: '1423 Bankruptcy Withdraw 28 USC 157' }, { value: '1430', label: '1430 Banks and Banking' }, { value: '1440', label: '1440 Other Civil Rights' }, { value: '1441', label: '1441 Civil Rights Voting' }, { value: '1442', label: '1442 Civil Rights Jobs' }, { value: '1443', label: '1443 Civil Rights Accommodations' }, { value: '1444', label: '1444 Civil Rights Welfare' }, { value: '1445', label: '1445 American w/Disab.Act-Empl' }, { value: '1446', label: '1446 Americans w/Disab Act - Other' }, { value: '1450', label: '1450 Interstate Commerce' }, { value: '1470', label: '1470 Civil (RICO)' }, { value: '1480', label: '1480 Consumer Credit' }, { value: '1490', label: '1490 Cable Satellite/TV' }, { value: '1610', label: '1610 Agricultural Acts' }, { value: '1620', label: '1620 Food and Drugs Acts' }, { value: '1625', label: '1625 Drug Related Seizure of Property' }, { value: '1630', label: '1630 Liquor Laws' }, { value: '1640', label: '1640 Railroad and Trucks' }, { value: '1650', label: '1650 Airline Regulations' }, { value: '1660', label: '1660 Occupational Safety/Health' }, { value: '1690', label: '1690 Other Forfeiture and Penalty Suits' }, { value: '1710', label: '1710 Fair Labor Standards Act' }, { value: '1720', label: '1720 Labor/Management Relations Act' }, { value: '1730', label: '1730 Report & Disclosure' }, { value: '1740', label: '1740 Railway Labor Act' }, { value: '1790', label: '1790 Other Labor Litigation' }, { value: '1791', label: '1791 Employee Retirement' }, { value: '1830', label: '1830 Patent' }, { value: '1840', label: '1840 Trademark' }, { value: '1850', label: '1850 Securities, Commodities, Exchange' }, { value: '1862', label: '1862 Black Lung' }, { value: '1863', label: '1863 D.I.W.C./D.I.W.W.' }, { value: '1870', label: '1870 Tax Suits' }, { value: '1871', label: '1871 IRS 3rd Party Suits 26 USC 7609' }, { value: '1890', label: '1890 Other Statutory Actions' }, { value: '1891', label: '1891 Agricultural Acts' }, { value: '1892', label: '1892 Economic Stabilization Act' }, { value: '1893', label: '1893 Environmental Matters' }, { value: '1894', label: '1894 Energy Allocation Act' }, { value: '1950', label: '1950 Constitutionality of State Statutes' }, { value: '1990', label: '1990 Other' }, { value: '1999', label: '1999 Miscellaneous' }, { value: '2110', label: '2110 Insurance' }, { value: '2120', label: '2120 Marine Contract Actions' }, { value: '2130', label: '2130 Miller Act' }, { value: '2140', label: '2140 Negotiable Instruments' }, { value: '2150', label: '2150 Ovrpmnts & Enforcement of Judgments' }, { value: '2151', label: '2151 Overpayments Under Medicare Act' }, { value: '2152', label: '2152 Recovery of Defaulted Student Loans' }, { value: '2153', label: '2153 Recovery Overpayment Vet Benefits' }, { value: '2190', label: '2190 Other Contract Actions' }, { value: '2195', label: '2195 Contract Product Liability' }, { value: '2196', label: '2196 Franchise' }, { value: '2210', label: '2210 Land Condemnation' }, { value: '2220', label: '2220 Foreclosure' }, { value: '2230', label: '2230 Rent, Lease, Ejectment' }, { value: '2240', label: '2240 Torts to Land' }, { value: '2245', label: '2245 Tort Product Liability' }, { value: '2290', label: '2290 Other Real Property Actions' }, { value: '2310', label: '2310 Airplane Personal Injury' }, { value: '2315', label: '2315 Airplane Product Liability' }, { value: '2320', label: '2320 Assault, Libel, and Slander' }, { value: '2330', label: '2330 Federal Employers\' Liability' }, { value: '2340', label: '2340 Marine Personal Injury' }, { value: '2345', label: '2345 Marine - Product Liability' }, { value: '2350', label: '2350 Motor Vehicle' }, { value: '2355', label: '2355 Motor Vehicle Product Liability' }, { value: '2360', label: '2360 Other Personal Injury' }, { value: '2362', label: '2362 Medical Malpractice' }, { value: '2365', label: '2365 Personal Injury - Product Liability' }, { value: '2368', label: '2368 Asbestos Personal Injury-Product Liability' }, { value: '2370', label: '2370 Other Fraud' }, { value: '2371', label: '2371 Truth in Lending' }, { value: '2380', label: '2380 Other Personal Property Damage' }, { value: '2385', label: '2385 Property Damage-Product Liability' }, { value: '2410', label: '2410 Antitrust' }, { value: '2422', label: '2422 Bankruptcy Appeals Rule 28 USC 158' }, { value: '2423', label: '2423 Bankruptcy Withdrawal 28 USC 157' }, { value: '2430', label: '2430 Banks and Banking' }, { value: '2440', label: '2440 Other Civil Rights' }, { value: '2441', label: '2441 Civil Rights Voting' }, { value: '2442', label: '2442 Civil Rights Jobs' }, { value: '2443', label: '2443 Civil Rights Accommodations' }, { value: '2444', label: '2444 Civil Rights Welfare' }, { value: '2445', label: '2445 Americans w/Disab.Act-Empl' }, { value: '2446', label: '2446 Americans w/Disab Act - Other' }, { value: '2450', label: '2450 Interstate Commerce' }, { value: '2460', label: '2460 Deportation' }, { value: '2462', label: '2462 Naturalization Application' }, { value: '2463', label: '2463 Habeas Corpus- Alien Detainee' }, { value: '2465', label: '2465 Other Immigration Actions' }, { value: '2480', label: '2480 Consumer Credit' }, { value: '2490', label: '2490 Cable Satellite/TV' }, { value: '2510', label: '2510 Prisoner Petitions - Vacate Sentence' }, { value: '2530', label: '2530 Habeas Corpus' }, { value: '2535', label: '2535 Habeas Corpus: Death Penalty' }, { value: '2540', label: '2540 Prisoner Petitions - Mandamus & Other' }, { value: '2550', label: '2550 Prisoner - Civil Rights' }, { value: '2555', label: '2555 Prison Condition' }, { value: '2610', label: '2610 Agricultural Acts' }, { value: '2620', label: '2620 Food and Drug Acts' }, { value: '2625', label: '2625 Drug Related Seizure of Property' }, { value: '2630', label: '2630 Liquor Laws' }, { value: '2640', label: '2640 Railroad and Trucks' }, { value: '2650', label: '2650 Airline Regulations' }, { value: '2660', label: '2660 Occupational Safety/Health' }, { value: '2690', label: '2690 Other Forfeiture and Penalty Suits' }, { value: '2710', label: '2710 Fair Labor Standards Act' }, { value: '2720', label: '2720 Labor Management Relations Act' }, { value: '2730', label: '2730 Labor/Management Rept & Disclsure' }, { value: '2740', label: '2740 Railway Labor Act' }, { value: '2790', label: '2790 Other Labor Litigation' }, { value: '2791', label: '2791 Employee Retirement' }, { value: '2810', label: '2810 Selective Service' }, { value: '2830', label: '2830 Patent' }, { value: '2850', label: '2850 Securities, Commodities, Exch.' }, { value: '2860', label: '2860 Social Security' }, { value: '2861', label: '2861 Medicare' }, { value: '2862', label: '2862 Black Lung' }, { value: '2863', label: '2863 D.I.W.C./D.I.W.W.' }, { value: '2864', label: '2864 S.S.I.D.' }, { value: '2865', label: '2865 R.S.I.' }, { value: '2870', label: '2870 Tax Suits' }, { value: '2871', label: '2871 IRS 3rd Party Suits 26 USC 7609' }, { value: '2875', label: '2875 Customer Challenge 12 USC 3410' }, { value: '2890', label: '2890 Other Statutory Actions' }, { value: '2891', label: '2891 Agricultural Acts' }, { value: '2892', label: '2892 Economic Stabilization Act' }, { value: '2893', label: '2893 Environmental Matters' }, { value: '2894', label: '2894 Energy Allocation Act' }, { value: '2895', label: '2895 Freedom of Information Act of 1974' }, { value: '2900', label: '2900 Appeal of Fee -Equal Access Justice' }, { value: '2950', label: '2950 Constitutionality of State Statutes' }, { value: '2990', label: '2990 Other' }, { value: '2999', label: '2999 Miscellaneous' }, { value: '3110', label: '3110 Insurance' }, { value: '3120', label: '3120 Marine Contract Actions' }, { value: '3130', label: '3130 Miller Act' }, { value: '3140', label: '3140 Negotiable Instruments' }, { value: '3150', label: '3150 Recovery of Overpayment of Benefits' }, { value: '3151', label: '3151 Overpayments Under Medicare Act' }, { value: '3160', label: '3160 Stockholders\' Suits' }, { value: '3190', label: '3190 Other Contract Actions' }, { value: '3196', label: '3196 Franchise' }, { value: '3210', label: '3210 Land Condemnation' }, { value: '3220', label: '3220 Foreclosure' }, { value: '3230', label: '3230 Rent, Lease, Ejectment' }, { value: '3240', label: '3240 Torts to Land' }, { value: '3245', label: '3245 Tort Product Liability' }, { value: '3290', label: '3290 Other Real Property Actions' }, { value: '3310', label: '3310 Airplane Personal Injury' }, { value: '3315', label: '3315 Airplane Product Liability' }, { value: '3320', label: '3320 Assault, Libel, and Slander' }, { value: '3330', label: '3330 Federal Employers\' Liability' }, { value: '3340', label: '3340 Marine Personal Injury' }, { value: '3345', label: '3345 Marine - Product Liability' }, { value: '3350', label: '3350 Motor Vehicle Personal Injury' }, { value: '3355', label: '3355 Motor Vehicle Product Liability' }, { value: '3360', label: '3360 Other Personal Injury' }, { value: '3365', label: '3365 Personal Injury - Product Liability' }, { value: '3368', label: '3368 Asbestos Personal Injury - Product Liability' }, { value: '3370', label: '3370 Other Fraud' }, { value: '3371', label: '3371 Truth In Lending' }, { value: '3380', label: '3380 Other Personal Property Damage' }, { value: '3385', label: '3385 Property Damage - Product Liability' }, { value: '3400', label: '3400 State Re-Apportionment' }, { value: '3410', label: '3410 Antitrust' }, { value: '3422', label: '3422 Bankruptcy Appeals Rule 28 USC 158' }, { value: '3423', label: '3423 Bankruptcy Withdrawal 28 USC 157' }, { value: '3430', label: '3430 Banks and Banking' }, { value: '3440', label: '3440 Other Civil Rights' }, { value: '3441', label: '3441 Civil Rights Voting' }, { value: '3442', label: '3442 Civil Rights Jobs' }, { value: '3443', label: '3443 Civil Rights Accommodations' }, { value: '3444', label: '3444 Civil Rights Welfare' }, { value: '3445', label: '3445 Americans with Disabilities Act - Empl' }, { value: '3446', label: '3446 Americans with Disabilities Act - Other' }, { value: '3450', label: '3450 Interstate Commerce' }, { value: '3460', label: '3460 Deportation' }, { value: '3470', label: '3470 Civil (RICO)' }, { value: '3480', label: '3480 Consumer Credit' }, { value: '3490', label: '3490 Cable Satellite/TV' }, { value: '3530', label: '3530 Habeas Corpus' }, { value: '3535', label: '3535 Habeas Corpus: Death Penalty' }, { value: '3540', label: '3540 Prisoner Petitions-Mandamus & Other' }, { value: '3550', label: '3550 Prisoner - Civil Rights' }, { value: '3555', label: '3555 Prison Condition' }, { value: '3710', label: '3710 Fair Labor Standards Act' }, { value: '3720', label: '3720 Labor/Management Relations Act' }, { value: '3730', label: '3730 Report & Disclosure' }, { value: '3740', label: '3740 Railway Labor Act' }, { value: '3790', label: '3790 Other Labor Litigation' }, { value: '3791', label: '3791 Employee Retirement' }, { value: '3810', label: '3810 Selective Service' }, { value: '3820', label: '3820 Copyright' }, { value: '3830', label: '3830 Patent' }, { value: '3840', label: '3840 Trademark' }, { value: '3850', label: '3850 Securities, Commodities, Exch.' }, { value: '3890', label: '3890 Other Statutory Actions' }, { value: '3891', label: '3891 Agricultural Acts' }, { value: '3892', label: '3892 Economic Stabilization Act' }, { value: '3893', label: '3893 Environmental Matters' }, { value: '3894', label: '3894 Energy Allocation Act' }, { value: '3895', label: '3895 Freedom of Information Act of 1974' }, { value: '3950', label: '3950 Constitutionality of State Statutes' }, { value: '3990', label: '3990 Other' }, { value: '3999', label: '3999 Miscellaneous' }, { value: '4110', label: '4110 Insurance' }, { value: '4120', label: '4120 Marine Contract Actions' }, { value: '4140', label: '4140 Negotiable Instruments' }, { value: '4150', label: '4150 Overpayments & Enforcement of Judgments' }, { value: '4160', label: '4160 Stockholders Suits' }, { value: '4190', label: '4190 Other Contract Actions' }, { value: '4195', label: '4195 Contract Product Liability' }, { value: '4196', label: '4196 Franchise' }, { value: '4210', label: '4210 Land Condemnation' }, { value: '4220', label: '4220 Foreclosure' }, { value: '4230', label: '4230 Rent, Lease, Ejectment' }, { value: '4240', label: '4240 Torts to Land' }, { value: '4245', label: '4245 Tort Product Liability' }, { value: '4290', label: '4290 Other Real Property Actions' }, { value: '4310', label: '4310 Airplane Personal Injury' }, { value: '4315', label: '4315 Airplane Product Liability' }, { value: '4320', label: '4320 Assault, Libel, and Slander' }, { value: '4340', label: '4340 Marine Personal Injury' }, { value: '4345', label: '4345 Marine - Product Liability' }, { value: '4350', label: '4350 Motor Vehicle Personal Injury' }, { value: '4355', label: '4355 Motor Vehicle Product Liability' }, { value: '4360', label: '4360 Other Personal Injury' }, { value: '4362', label: '4362 Medical Malpractice' }, { value: '4365', label: '4365 Personal Injury - Product Liability' }, { value: '4368', label: '4368 Asbestos Personal Injury - Product Liability' }, { value: '4370', label: '4370 Other Fraud' }, { value: '4371', label: '4371 Truth in Lending' }, { value: '4380', label: '4380 Other Personal Property Damage' }, { value: '4385', label: '4385 Property Damage - Product Liability' }, { value: '4440', label: '4440 Other Civil Rights' }, { value: '4441', label: '4441 Civil Rights Voting' }, { value: '4442', label: '4442 Civil Rights Jobs' }, { value: '4443', label: '4443 Civil Rights Accommodations' }, { value: '4444', label: '4444 Civil Rights Welfare' }, { value: '4445', label: '4445 Americans with Disabilities Act - Empl' }, { value: '4446', label: '4446 Americans with Disabilities Act - Other' }, { value: '4470', label: '4470 Civil (RICO)' }, { value: '4480', label: '4480 Consumer Credit' }, { value: '4490', label: '4490 Cable Satellite/TV' }, { value: '4555', label: '4555 Prisoner- Prison Condition' }, { value: '4950', label: '4950 Constitutionality of State Statutes' }, { value: '4990', label: '4990 Other' }, { value: '4999', label: '4999 Miscellaneous' }, { value: '5535', label: '5535 Habeas Corpus: Death Penalty' }, { value: '5990', label: '5990 Other' }, { value: '5992', label: '5992 Local Jurisdictional Appeal' }, { value: 'ZZZ', label: 'Other Nature of Suit' }];

/***/ },
/* 700 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = [{ value: '', label: '' }, { value: '1', label: "Debtor's aggregate noncontingent liquidated debts (excluding debts owed to insiders or affiliates) are less than $2,490,925 (amount subject to adjustment on 4/01/16 and every 3 years after that)." }, { value: '2', label: 'The debtor is a small business debtor as defined in 11 U.S.C. § 101(51D). If the debtor is a small business debtor, attach the most recent balance sheet, statement of operations, cash-flow statement, and federal income tax return or if all of these documents do not exist, follow the procedure in 11 U.S.C. § 1116(1)(B).' }, { value: '3', label: 'A plan is being filed with this petition.' }, { value: '4', label: 'Acceptances of the plan were solicited prepetition from one or more classes of creditors, in accordance with 11 U.S.C. § 1126(b).' }, { value: '5', label: 'The debtor is required to file periodic reports (for example, 10K and 10Q) with the Securities and Exchange Commission according to § 13 or 15(d) of the Securities Exchange Act of 1934. File the Attachment to Voluntary Petition for Non-Individuals Filing for Bankruptcy under Chapter 11 (Official Form 201A) with this form.' }, { value: '6', label: 'The debtor is a shell company as defined in the Securities Exchange Act of 1934 Rule 12b-2.' }];

/***/ },
/* 701 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = [{ value: '', label: '' }, { value: '1111', label: '1111  Oilseed and Grain Farming' }, { value: '1112', label: '1112  Vegetable and Melon Farming' }, { value: '1113', label: '1113  Fruit and Tree Nut Farming' }, { value: '1114', label: '1114  Greenhouse, Nursery, and Floriculture Production' }, { value: '1119', label: '1119  Other Crop Farming' }, { value: '1121', label: '1121  Cattle Ranching and Farming' }, { value: '1122', label: '1122  Hog and Pig Farming' }, { value: '1123', label: '1123  Poultry and Egg Production' }, { value: '1124', label: '1124  Sheep and Goat Farming' }, { value: '1125', label: '1125  Aquaculture' }, { value: '1129', label: '1129  Other Animal Production' }, { value: '1131', label: '1131  Timber Tract Operations' }, { value: '1132', label: '1132  Forest Nurseries and Gathering of Forest Products' }, { value: '1133', label: '1133  Logging' }, { value: '1141', label: '1141  Fishing' }, { value: '1142', label: '1142  Hunting and Trapping' }, { value: '1151', label: '1151  Support Activities for Crop Production' }, { value: '1152', label: '1152  Support Activities for Animal Production' }, { value: '1153', label: '1153  Support Activities for Forestry' }, { value: '2111', label: '2111  Oil and Gas Extraction' }, { value: '2121', label: '2121  Coal Mining' }, { value: '2122', label: '2122  Metal Ore Mining' }, { value: '2123', label: '2123  Nonmetallic Mineral Mining and Quarrying' }, { value: '2131', label: '2131  Support Activities for Mining' }, { value: '2211', label: '2211  Electric Power Generation, Transmission and Distribution' }, { value: '2212', label: '2212  Natural Gas Distribution' }, { value: '2213', label: '2213  Water, Sewage and Other Systems' }, { value: '2361', label: '2361  Residential Building Construction' }, { value: '2362', label: '2362  Nonresidential Building Construction' }, { value: '2371', label: '2371  Utility System Construction' }, { value: '2372', label: '2372  Land Subdivision' }, { value: '2373', label: '2373  Highway, Street, and Bridge Construction' }, { value: '2379', label: '2379  Other Heavy and Civil Engineering Construction' }, { value: '2381', label: '2381  Foundation, Structure, and Building Exterior Contractors' }, { value: '2382', label: '2382  Building Equipment Contractors' }, { value: '2383', label: '2383  Building Finishing Contractors' }, { value: '2389', label: '2389  Other Specialty Trade Contractors' }, { value: '3111', label: '3111  Animal Food Manufacturing' }, { value: '3112', label: '3112  Grain and Oilseed Milling' }, { value: '3113', label: '3113  Sugar and Confectionery Product Manufacturing' }, { value: '3114', label: '3114  Fruit and Vegetable Preserving and Specialty Food Manufacturing' }, { value: '3115', label: '3115  Dairy Product Manufacturing' }, { value: '3116', label: '3116  Animal Slaughtering and Processing' }, { value: '3117', label: '3117  Seafood Product Preparation and Packaging' }, { value: '3118', label: '3118  Bakeries and Tortilla Manufacturing' }, { value: '3119', label: '3119  Other Food Manufacturing' }, { value: '3121', label: '3121  Beverage Manufacturing' }, { value: '3122', label: '3122  Tobacco Manufacturing' }, { value: '3131', label: '3131  Fiber, Yarn, and Thread Mills' }, { value: '3132', label: '3132  Fabric Mills' }, { value: '3133', label: '3133  Textile and Fabric Finishing and Fabric Coating Mills' }, { value: '3141', label: '3141  Textile Furnishings Mills' }, { value: '3149', label: '3149  Other Textile Product Mills' }, { value: '3151', label: '3151  Apparel Knitting Mills' }, { value: '3152', label: '3152  Cut and Sew Apparel Manufacturing' }, { value: '3159', label: '3159  Apparel Accessories and Other Apparel Manufacturing' }, { value: '3161', label: '3161  Leather and Hide Tanning and Finishing' }, { value: '3162', label: '3162  Footwear Manufacturing' }, { value: '3169', label: '3169  Other Leather and Allied Product Manufacturing' }, { value: '3211', label: '3211  Sawmills and Wood Preservation' }, { value: '3212', label: '3212  Veneer, Plywood, and Engineered Wood Product Manufacturing' }, { value: '3219', label: '3219  Other Wood Product Manufacturing' }, { value: '3221', label: '3221  Pulp, Paper, and Paperboard Mills' }, { value: '3222', label: '3222  Converted Paper Product Manufacturing' }, { value: '3231', label: '3231  Printing and Related Support Activities' }, { value: '3241', label: '3241  Petroleum and Coal Products Manufacturing' }, { value: '3251', label: '3251  Basic Chemical Manufacturing' }, { value: '3252', label: '3252  Resin, Synthetic Rubber, and Artificial and Synthetic Fibers and Filaments Manufacturing' }, { value: '3253', label: '3253  Pesticide, Fertilizer, and Other Agricultural Chemical Manufacturing' }, { value: '3254', label: '3254  Pharmaceutical and Medicine Manufacturing' }, { value: '3255', label: '3255  Paint, Coating, and Adhesive Manufacturing' }, { value: '3256', label: '3256  Soap, Cleaning Compound, and Toilet Preparation Manufacturing' }, { value: '3259', label: '3259  Other Chemical Product and Preparation Manufacturing' }, { value: '3261', label: '3261  Plastics Product Manufacturing' }, { value: '3262', label: '3262  Rubber Product Manufacturing' }, { value: '3271', label: '3271  Clay Product and Refractory Manufacturing' }, { value: '3272', label: '3272  Glass and Glass Product Manufacturing' }, { value: '3273', label: '3273  Cement and Concrete Product Manufacturing' }, { value: '3274', label: '3274  Lime and Gypsum Product Manufacturing' }, { value: '3279', label: '3279  Other Nonmetallic Mineral Product Manufacturing' }, { value: '3311', label: '3311  Iron and Steel Mills and Ferroalloy Manufacturing' }, { value: '3312', label: '3312  Steel Product Manufacturing from Purchased Steel' }, { value: '3313', label: '3313  Alumina and Aluminum Production and Processing' }, { value: '3314', label: '3314  Nonferrous Metal (except Aluminum) Production and Processing' }, { value: '3315', label: '3315  Foundries' }, { value: '3321', label: '3321  Forging and Stamping' }, { value: '3322', label: '3322  Cutlery and Handtool Manufacturing' }, { value: '3323', label: '3323  Architectural and Structural Metals Manufacturing' }, { value: '3324', label: '3324  Boiler, Tank, and Shipping Container Manufacturing' }, { value: '3325', label: '3325  Hardware Manufacturing' }, { value: '3326', label: '3326  Spring and Wire Product Manufacturing' }, { value: '3327', label: '3327  Machine Shops; Turned Product; and Screw, Nut, and Bolt Manufacturing' }, { value: '3328', label: '3328  Coating, Engraving, Heat Treating, and Allied Activities' }, { value: '3329', label: '3329  Other Fabricated Metal Product Manufacturing' }, { value: '3331', label: '3331  Agriculture, Construction, and Mining Machinery Manufacturing' }, { value: '3332', label: '3332  Industrial Machinery Manufacturing' }, { value: '3333', label: '3333  Commercial and Service Industry Machinery Manufacturing' }, { value: '3334', label: '3334  Ventilation, Heating, Air-Conditioning, and Commercial Refrigeration Equipment Manufacturing' }, { value: '3335', label: '3335  Metalworking Machinery Manufacturing' }, { value: '3336', label: '3336  Engine, Turbine, and Power Transmission Equipment Manufacturing' }, { value: '3339', label: '3339  Other General Purpose Machinery Manufacturing' }, { value: '3341', label: '3341  Computer and Peripheral Equipment Manufacturing' }, { value: '3342', label: '3342  Communications Equipment Manufacturing' }, { value: '3343', label: '3343  Audio and Video Equipment Manufacturing' }, { value: '3344', label: '3344  Semiconductor and Other Electronic Component Manufacturing' }, { value: '3345', label: '3345  Navigational, Measuring, Electromedical, and Control Instruments Manufacturing' }, { value: '3346', label: '3346  Manufacturing and Reproducing Magnetic and Optical Media' }, { value: '3351', label: '3351  Electric Lighting Equipment Manufacturing' }, { value: '3352', label: '3352  Household Appliance Manufacturing' }, { value: '3353', label: '3353  Electrical Equipment Manufacturing' }, { value: '3359', label: '3359  Other Electrical Equipment and Component Manufacturing' }, { value: '3361', label: '3361  Motor Vehicle Manufacturing' }, { value: '3362', label: '3362  Motor Vehicle Body and Trailer Manufacturing' }, { value: '3363', label: '3363  Motor Vehicle Parts Manufacturing' }, { value: '3364', label: '3364  Aerospace Product and Parts Manufacturing' }, { value: '3365', label: '3365  Railroad Rolling Stock Manufacturing' }, { value: '3366', label: '3366  Ship and Boat Building' }, { value: '3369', label: '3369  Other Transportation Equipment Manufacturing' }, { value: '3371', label: '3371  Household and Institutional Furniture and Kitchen Cabinet Manufacturing' }, { value: '3372', label: '3372  Office Furniture (including Fixtures) Manufacturing' }, { value: '3379', label: '3379  Other Furniture Related Product Manufacturing' }, { value: '3391', label: '3391  Medical Equipment and Supplies Manufacturing' }, { value: '3399', label: '3399  Other Miscellaneous Manufacturing' }, { value: '4231', label: '4231  Motor Vehicle and Motor Vehicle Parts and Supplies Merchant Wholesalers' }, { value: '4232', label: '4232  Furniture and Home Furnishing Merchant Wholesalers' }, { value: '4233', label: '4233  Lumber and Other Construction Materials Merchant Wholesalers' }, { value: '4234', label: '4234  Professional and Commercial Equipment and Supplies Merchant Wholesalers' }, { value: '4235', label: '4235  Metal and Mineral (except Petroleum) Merchant Wholesalers' }, { value: '4236', label: '4236  Household Appliances and Electrical and Electronic Goods Merchant Wholesalers' }, { value: '4237', label: '4237  Hardware, and Plumbing and Heating Equipment and Supplies Merchant Wholesalers' }, { value: '4238', label: '4238  Machinery, Equipment, and Supplies Merchant Wholesalers' }, { value: '4239', label: '4239  Miscellaneous Durable Goods Merchant Wholesalers' }, { value: '4241', label: '4241  Paper and Paper Product Merchant Wholesalers' }, { value: '4242', label: '4242  Drugs and Druggists\' Sundries Merchant Wholesalers' }, { value: '4243', label: '4243  Apparel, Piece Goods, and Notions Merchant Wholesalers' }, { value: '4244', label: '4244  Grocery and Related Product Merchant Wholesalers' }, { value: '4245', label: '4245  Farm Product Raw Material Merchant Wholesalers' }, { value: '4246', label: '4246  Chemical and Allied Products Merchant Wholesalers' }, { value: '4247', label: '4247  Petroleum and Petroleum Products Merchant Wholesalers' }, { value: '4248', label: '4248  Beer, Wine, and Distilled Alcoholic Beverage Merchant Wholesalers' }, { value: '4249', label: '4249  Miscellaneous Nondurable Goods Merchant Wholesalers' }, { value: '4251', label: '4251  Wholesale Trade Agents and Brokers' }, { value: '4411', label: '4411  Automobile Dealers' }, { value: '4412', label: '4412  Other Motor Vehicle Dealers' }, { value: '4413', label: '4413  Automotive Parts, Accessories, and Tire Retailers' }, { value: '4421', label: '4421  Furniture Stores (retired)' }, { value: '4422', label: '4422  Home Furnishings Stores (retired)' }, { value: '4431', label: '4431  Electronics and Appliance Stores (retired)' }, { value: '4441', label: '4441  Building Material and Supplies Dealers' }, { value: '4442', label: '4442  Lawn and Garden Equipment and Supplies Retailers' }, { value: '4451', label: '4451  Grocery and Convenience Retailers' }, { value: '4452', label: '4452  Specialty Food Retailers' }, { value: '4453', label: '4453  Beer, Wine, and Liquor Retailers' }, { value: '4461', label: '4461  Health and Personal Care Stores (retired)' }, { value: '4471', label: '4471  Gasoline Stations (retired)' }, { value: '4481', label: '4481  Clothing Stores (retired)' }, { value: '4482', label: '4482  Shoe Stores (retired)' }, { value: '4483', label: '4483  Jewelry, Luggage, and Leather Goods Stores (retired)' }, { value: '4491', label: '4491  Furniture and Home Furnishings Retailers' }, { value: '4492', label: '4492  Electronics and Appliance Retailers' }, { value: '4511', label: '4511  Sporting Goods, Hobby, and Musical Instrument Stores (retired)' }, { value: '4512', label: '4512  Book Stores and News Dealers (retired)' }, { value: '4521', label: '4521  Department Stores (retired)' }, { value: '4529', label: '4529  Other General Merchandise Stores (retired)' }, { value: '4531', label: '4531  Florists (retired)' }, { value: '4532', label: '4532  Office Supplies, Stationery, and Gift Stores (retired)' }, { value: '4533', label: '4533  Used Merchandise Stores (retired)' }, { value: '4539', label: '4539  Other Miscellaneous Store Retailers (retired)' }, { value: '4541', label: '4541  Electronic Shopping and Mail-Order Houses (retired)' }, { value: '4542', label: '4542  Vending Machine Operators (retired)' }, { value: '4543', label: '4543  Direct Selling Establishments (retired)' }, { value: '4551', label: '4551  Department Stores' }, { value: '4552', label: '4552  Warehouse Clubs, Supercenters, and Other General Merchandise Retailers' }, { value: '4561', label: '4561  Health and Personal Care Retailers' }, { value: '4571', label: '4571  Gasoline Stations' }, { value: '4572', label: '4572  Fuel Dealers' }, { value: '4581', label: '4581  Clothing and Clothing Accessories Retailers' }, { value: '4582', label: '4582  Shoe Retailers' }, { value: '4583', label: '4583  Jewelry, Luggage, and Leather Goods Retailers' }, { value: '4591', label: '4591  Sporting Goods, Hobby, and Musical Instrument Retailers' }, { value: '4592', label: '4592  Book Retailers and News Dealers' }, { value: '4593', label: '4593  Florists' }, { value: '4594', label: '4594  Office Supplies, Stationery, and Gift Retailers' }, { value: '4595', label: '4595  Used Merchandise Retailers' }, { value: '4599', label: '4599  Other Miscellaneous Retailers' }, { value: '4811', label: '4811  Scheduled Air Transportation' }, { value: '4812', label: '4812  Nonscheduled Air Transportation' }, { value: '4821', label: '4821  Rail Transportation' }, { value: '4831', label: '4831  Deep Sea, Coastal, and Great Lakes Water Transportation' }, { value: '4832', label: '4832  Inland Water Transportation' }, { value: '4841', label: '4841  General Freight Trucking' }, { value: '4842', label: '4842  Specialized Freight Trucking' }, { value: '4851', label: '4851  Urban Transit Systems' }, { value: '4852', label: '4852  Interurban and Rural Bus Transportation' }, { value: '4853', label: '4853  Taxi and Limousine Service' }, { value: '4854', label: '4854  School and Employee Bus Transportation' }, { value: '4855', label: '4855  Charter Bus Industry' }, { value: '4859', label: '4859  Other Transit and Ground Passenger Transportation' }, { value: '4861', label: '4861  Pipeline Transportation of Crude Oil' }, { value: '4862', label: '4862  Pipeline Transportation of Natural Gas' }, { value: '4869', label: '4869  Other Pipeline Transportation' }, { value: '4871', label: '4871  Scenic and Sightseeing Transportation, Land' }, { value: '4872', label: '4872  Scenic and Sightseeing Transportation, Water' }, { value: '4879', label: '4879  Scenic and Sightseeing Transportation, Other' }, { value: '4881', label: '4881  Support Activities for Air Transportation' }, { value: '4882', label: '4882  Support Activities for Rail Transportation' }, { value: '4883', label: '4883  Support Activities for Water Transportation' }, { value: '4884', label: '4884  Support Activities for Road Transportation' }, { value: '4885', label: '4885  Freight Transportation Arrangement' }, { value: '4889', label: '4889  Other Support Activities for Transportation' }, { value: '4911', label: '4911  Postal Service' }, { value: '4921', label: '4921  Couriers and Express Delivery Services' }, { value: '4922', label: '4922  Local Messengers and Local Delivery' }, { value: '4931', label: '4931  Warehousing and Storage' }, { value: '5111', label: '5111  Newspaper, Periodical, Book, and Directory Publishers (retired)' }, { value: '5112', label: '5112  Software Publishers (retired)' }, { value: '5121', label: '5121  Motion Picture and Video Industries' }, { value: '5122', label: '5122  Sound Recording Industries' }, { value: '5131', label: '5131  Newspaper, Periodical, Book, and Directory Publishers' }, { value: '5132', label: '5132  Software Publishers' }, { value: '5151', label: '5151  Radio and Television Broadcasting (retired)' }, { value: '5152', label: '5152  Cable and Other Subscription Programming (retired)' }, { value: '5161', label: '5161  Radio and Television Broadcasting Stations' }, { value: '5162', label: '5162  Media Streaming Distribution Services, Social Networks, and Other Media Networks and Content Providers' }, { value: '5171', label: '5171  Wired and Wireless Telecommunications (except Satellite)' }, { value: '5172', label: '5172  Wireless Telecommunications Carriers (except Satellite) (retired)' }, { value: '5174', label: '5174  Satellite Telecommunications' }, { value: '5178', label: '5178  All Other Telecommunications' }, { value: '5179', label: '5179  Other Telecommunications (retired)' }, { value: '5182', label: '5182  Computing Infrastructure Providers, Data Processing, Web Hosting, and Related Services' }, { value: '5191', label: '5191  Other Information Services (retired)' }, { value: '5192', label: '5192  Web Search Portals, Libraries, Archives, and Other Information Services' }, { value: '5211', label: '5211  Monetary Authorities-Central Bank' }, { value: '5221', label: '5221  Depository Credit Intermediation' }, { value: '5222', label: '5222  Nondepository Credit Intermediation' }, { value: '5223', label: '5223  Activities Related to Credit Intermediation' }, { value: '5231', label: '5231  Securities and Commodity Contracts Intermediation and Brokerage' }, { value: '5232', label: '5232  Securities and Commodity Exchanges' }, { value: '5239', label: '5239  Other Financial Investment Activities' }, { value: '5241', label: '5241  Insurance Carriers' }, { value: '5242', label: '5242  Agencies, Brokerages, and Other Insurance Related Activities' }, { value: '5251', label: '5251  Insurance and Employee Benefit Funds' }, { value: '5259', label: '5259  Other Investment Pools and Funds' }, { value: '5311', label: '5311  Lessors of Real Estate' }, { value: '5312', label: '5312  Offices of Real Estate Agents and Brokers' }, { value: '5313', label: '5313  Activities Related to Real Estate' }, { value: '5321', label: '5321  Automotive Equipment Rental and Leasing' }, { value: '5322', label: '5322  Consumer Goods Rental' }, { value: '5323', label: '5323  General Rental Centers' }, { value: '5324', label: '5324  Commercial and Industrial Machinery and Equipment Rental and Leasing' }, { value: '5331', label: '5331  Lessors of Nonfinancial Intangible Assets (except Copyrighted Works)' }, { value: '5411', label: '5411  Legal Services' }, { value: '5412', label: '5412  Accounting, Tax Preparation, Bookkeeping, and Payroll Services' }, { value: '5413', label: '5413  Architectural, Engineering, and Related Services' }, { value: '5414', label: '5414  Specialized Design Services' }, { value: '5415', label: '5415  Computer Systems Design and Related Services' }, { value: '5416', label: '5416  Management, Scientific, and Technical Consulting Services' }, { value: '5417', label: '5417  Scientific Research and Development Services' }, { value: '5418', label: '5418  Advertising, Public Relations, and Related Services' }, { value: '5419', label: '5419  Other Professional, Scientific, and Technical Services' }, { value: '5511', label: '5511  Management of Companies and Enterprises' }, { value: '5611', label: '5611  Office Administrative Services' }, { value: '5612', label: '5612  Facilities Support Services' }, { value: '5613', label: '5613  Employment Services' }, { value: '5614', label: '5614  Business Support Services' }, { value: '5615', label: '5615  Travel Arrangement and Reservation Services' }, { value: '5616', label: '5616  Investigation and Security Services' }, { value: '5617', label: '5617  Services to Buildings and Dwellings' }, { value: '5619', label: '5619  Other Support Services' }, { value: '5621', label: '5621  Waste Collection' }, { value: '5622', label: '5622  Waste Treatment and Disposal' }, { value: '5629', label: '5629  Remediation and Other Waste Management Services' }, { value: '6111', label: '6111  Elementary and Secondary Schools' }, { value: '6112', label: '6112  Junior Colleges' }, { value: '6113', label: '6113  Colleges, Universities, and Professional Schools' }, { value: '6114', label: '6114  Business Schools and Computer and Management Training' }, { value: '6115', label: '6115  Technical and Trade Schools' }, { value: '6116', label: '6116  Other Schools and Instruction' }, { value: '6117', label: '6117  Educational Support Services' }, { value: '6211', label: '6211  Offices of Physicians' }, { value: '6212', label: '6212  Offices of Dentists' }, { value: '6213', label: '6213  Offices of Other Health Practitioners' }, { value: '6214', label: '6214  Outpatient Care Centers' }, { value: '6215', label: '6215  Medical and Diagnostic Laboratories' }, { value: '6216', label: '6216  Home Health Care Services' }, { value: '6219', label: '6219  Other Ambulatory Health Care Services' }, { value: '6221', label: '6221  General Medical and Surgical Hospitals' }, { value: '6222', label: '6222  Psychiatric and Substance Abuse Hospitals' }, { value: '6223', label: '6223  Specialty (except Psychiatric and Substance Abuse) Hospitals' }, { value: '6231', label: '6231  Nursing Care Facilities (Skilled Nursing Facilities)' }, { value: '6232', label: '6232  Residential Intellectual and Developmental Disability, Mental Health, and Substance Abuse Facilities' }, { value: '6233', label: '6233  Continuing Care Retirement Communities and Assisted Living Facilities for the Elderly' }, { value: '6239', label: '6239  Other Residential Care Facilities' }, { value: '6241', label: '6241  Individual and Family Services' }, { value: '6242', label: '6242  Community Food and Housing, and Emergency and Other Relief Services' }, { value: '6243', label: '6243  Vocational Rehabilitation Services' }, { value: '6244', label: '6244  Child Care Services' }, { value: '7111', label: '7111  Performing Arts Companies' }, { value: '7112', label: '7112  Spectator Sports' }, { value: '7113', label: '7113  Promoters of Performing Arts, Sports, and Similar Events' }, { value: '7114', label: '7114  Agents and Managers for Artists, Athletes, Entertainers, and Other Public Figures' }, { value: '7115', label: '7115  Independent Artists, Writers, and Performers' }, { value: '7121', label: '7121  Museums, Historical Sites, and Similar Institutions' }, { value: '7131', label: '7131  Amusement Parks and Arcades' }, { value: '7132', label: '7132  Gambling Industries' }, { value: '7139', label: '7139  Other Amusement and Recreation Industries' }, { value: '7211', label: '7211  Traveler Accommodation' }, { value: '7212', label: '7212  RV (Recreational Vehicle) Parks and Recreational Camps' }, { value: '7213', label: '7213  Rooming and Boarding Houses, Dormitories, and Workers\' Camps' }, { value: '7223', label: '7223  Special Food Services' }, { value: '7224', label: '7224  Drinking Places (Alcoholic Beverages)' }, { value: '7225', label: '7225  Restaurants and Other Eating Places' }, { value: '8111', label: '8111  Automotive Repair and Maintenance' }, { value: '8112', label: '8112  Electronic and Precision Equipment Repair and Maintenance' }, { value: '8113', label: '8113  Commercial and Industrial Machinery and Equipment (except Automotive and Electronic) Repair and Maintenance' }, { value: '8114', label: '8114  Personal and Household Goods Repair and Maintenance' }, { value: '8121', label: '8121  Personal Care Services' }, { value: '8122', label: '8122  Death Care Services' }, { value: '8123', label: '8123  Drycleaning and Laundry Services' }, { value: '8129', label: '8129  Other Personal Services' }, { value: '8131', label: '8131  Religious Organizations' }, { value: '8132', label: '8132  Grantmaking and Giving Services' }, { value: '8133', label: '8133  Social Advocacy Organizations' }, { value: '8134', label: '8134  Civic and Social Organizations' }, { value: '8139', label: '8139  Business, Professional, Labor, Political, and Similar Organizations' }, { value: '8141', label: '8141  Private Households' }, { value: '9211', label: '9211  Executive, Legislative, and Other General Government Support' }, { value: '9221', label: '9221  Justice, Public Order, and Safety Activities' }, { value: '9231', label: '9231  Administration of Human Resource Programs' }, { value: '9241', label: '9241  Administration of Environmental Quality Programs' }, { value: '9251', label: '9251  Administration of Housing Programs, Urban Planning, and Community Development' }, { value: '9261', label: '9261  Administration of Economic Programs' }, { value: '9271', label: '9271  Space Research and Technology' }, { value: '9281', label: '9281  National Security and International Affairs' }];

/***/ },
/* 702 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/* eslint-disable */
	
	exports.default = {
	  '01': 'First Circuit',
	  '02': 'Second Circuit',
	  '03': 'Third Circuit',
	  '04': 'Fourth Circuit',
	  '05': 'Fifth Circuit',
	  '06': 'Sixth Circuit',
	  '07': 'Seventh Circuit',
	  '08': 'Eighth Circuit',
	  '09': 'Ninth Circuit',
	  '10': 'Tenth Circuit',
	  '11': 'Eleventh Circuit',
	  "AL": "Alabama",
	  "alm": "Alabama Middle",
	  "aln": "Alabama Northern",
	  "als": "Alabama Southern",
	  "AK": "Alaska",
	  "AZ": "Arizona",
	  "AR": "Arkansas",
	  "are": "Arkansas Eastern",
	  "arw": "Arkansas Western",
	  "CA": "California",
	  "cac": "California Central",
	  "cae": "California Eastern",
	  "can": "California Northern",
	  "cas": "California Southern",
	  "CO": "Colorado",
	  "CT": "Connecticut",
	  "DE": "Delaware",
	  "DC": "District of Columbia",
	  "FL": "Florida",
	  "flm": "Florida Middle",
	  "fln": "Florida Northern",
	  "fls": "Florida Southern",
	  "GA": "Georgia",
	  "gam": "Georgia Middle",
	  "gan": "Georgia Northern",
	  "gas": "Georgia Southern",
	  "GU": "Guam",
	  "HI": "Hawaii",
	  "ID": "Idaho",
	  "IL": "Illinois",
	  "ilc": "Illinois Central",
	  "iln": "Illinois Northern",
	  "ils": "Illinois Southern",
	  "IN": "Indiana",
	  "inn": "Indiana Northern",
	  "ins": "Indiana Southern",
	  "IA": "Iowa",
	  "ian": "Iowa Northern",
	  "ias": "Iowa Southern",
	  "KS": "Kansas",
	  "KY": "Kentucky",
	  "kye": "Kentucky Eastern",
	  "kyw": "Kentucky Western",
	  "LA": "Louisiana",
	  "lae": "Louisiana Eastern",
	  "lam": "Louisiana Middle",
	  "law": "Louisiana Western",
	  "ME": "Maine",
	  "MD": "Maryland",
	  "MA": "Massachusetts",
	  "MI": "Michigan",
	  "mie": "Michigan Eastern",
	  "miw": "Michigan Western",
	  "MN": "Minnesota",
	  "MS": "Mississippi",
	  "msn": "Mississippi Northern",
	  "mss": "Mississippi Southern",
	  "MO": "Missouri",
	  "moe": "Missouri Eastern",
	  "mow": "Missouri Western",
	  "MT": "Montana",
	  "NE": "Nebraska",
	  "NV": "Nevada",
	  "NH": "New Hampshire",
	  "NJ": "New Jersey",
	  "NM": "New Mexico",
	  "NY": "New York",
	  "nye": "New York Eastern",
	  "nyn": "New York Northern",
	  "nys": "New York Southern",
	  "nyw": "New York Western",
	  "NC": "North Carolina",
	  "nce": "North Carolina Eastern",
	  "ncm": "North Carolina Middle",
	  "ncw": "North Carolina Western",
	  "ND": "North Dakota",
	  "NMI": "Northern Mariana Islands",
	  "OH": "Ohio",
	  "ohn": "Ohio Northern",
	  "ohs": "Ohio Southern",
	  "OK": "Oklahoma",
	  "oke": "Oklahoma Eastern",
	  "okn": "Oklahoma Northern",
	  "okw": "Oklahoma Western",
	  "OR": "Oregon",
	  "PA": "Pennsylvania",
	  "pae": "Pennsylvania Eastern",
	  "pam": "Pennsylvania Middle",
	  "paw": "Pennsylvania Western",
	  "PR": "Puerto Rico",
	  "RI": "Rhode Island",
	  "SC": "South Carolina",
	  "SD": "South Dakota",
	  "TN": "Tennessee",
	  "tne": "Tennessee Eastern",
	  "tnm": "Tennessee Middle",
	  "tnw": "Tennessee Western",
	  "TX": "Texas",
	  "txe": "Texas Eastern",
	  "txn": "Texas Northern",
	  "txs": "Texas Southern",
	  "txw": "Texas Western",
	  "UT": "Utah",
	  "VT": "Vermont",
	  "VI": "Virgin Islands",
	  "VA": "Virginia",
	  "vae": "Virginia Eastern",
	  "vaw": "Virginia Western",
	  "WA": "Washington",
	  "wae": "Washington Eastern",
	  "waw": "Washington Western",
	  "WV": "West Virginia",
	  "wvn": "West Virginia Northern",
	  "wvs": "West Virginia Southern",
	  "WI": "Wisconsin",
	  "wie": "Wisconsin Eastern",
	  "wiw": "Wisconsin Western",
	  "WY": "Wyoming"
	};

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactRedux = __webpack_require__(13);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _configureStore = __webpack_require__(102);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _App = __webpack_require__(554);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _ConnectionsLayout = __webpack_require__(578);
	
	var _ConnectionsLayout2 = _interopRequireDefault(_ConnectionsLayout);
	
	var _ErrorHandlingAppContainer = __webpack_require__(569);
	
	var _ErrorHandlingAppContainer2 = _interopRequireDefault(_ErrorHandlingAppContainer);
	
	__webpack_require__(1253);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var elemForReact = window.document.getElementById('react-app');
	
	var preloadedState = {
	  user: {
	    settings: _lodash2.default.pick(window.Drupal.settings, 'case_lookup_default_courts', 'pacer_search_default_case_type', 'currentUser', 'firmMember', 'firmMaster')
	  },
	  // todo leaving below for now, but remember to refactor this out of the components in the future
	  immediateSearch: window.immediateSearchArgs || {}
	};
	
	var hydratedState = (0, _configureStore.hydrateState)(preloadedState);
	var sharedStore = (0, _configureStore2.default)(hydratedState);
	
	if (elemForReact) {
	  var renderDom = function renderDom(Component) {
	    (0, _reactDom.render)(_react2.default.createElement(
	      _ErrorHandlingAppContainer2.default,
	      null,
	      _react2.default.createElement(
	        _reactRedux.Provider,
	        { store: sharedStore },
	        _react2.default.createElement(Component, null)
	      )
	    ), elemForReact);
	  };
	
	  renderDom(_App2.default);
	
	  if (false) {
	    module.hot.accept('./App', function () {
	      console.info('!!!accepted hot reload!');
	      var Next = require('./App').default;
	      renderDom(Next);
	    });
	  }
	}
	
	// TODO: List of supported services should be hard-coded in the ConnectionsLayout,
	// it's not something that is "configurable"
	var kloudlessServices = ['box', 'dropbox', 'gdrive', 'skydrive', 'onedrivebiz'];
	
	window.UI = {
	  mountComponent: function mountComponent(dest, sourceFile, props) {
	    try {
	      var context = __webpack_require__(965);
	
	      console.log('mountComponent', sourceFile, 'into', dest, 'with', props);
	      var c = context(sourceFile);
	      var Component = c.default;
	      if (!Component) throw 'Unable to require(\'./components/case/' + sourceFile + '\')';
	
	      var store = sourceFile.includes('docket') || sourceFile.includes('client_code_dialog') ? sharedStore : (0, _configureStore2.default)();
	
	      (0, _reactDom.render)(_react2.default.createElement(
	        _ErrorHandlingAppContainer2.default,
	        null,
	        _react2.default.createElement(
	          _reactRedux.Provider,
	          { store: store },
	          _react2.default.createElement(Component, props)
	        )
	      ), dest);
	
	      module.hot && module.hot.accept(context.id, function () {
	        var context = __webpack_require__(965);
	
	        console.log('Accepted hot reload for ' + sourceFile + '!');
	        var NextComponent = context(sourceFile).default;
	        (0, _reactDom.render)(_react2.default.createElement(
	          _ErrorHandlingAppContainer2.default,
	          null,
	          _react2.default.createElement(
	            _reactRedux.Provider,
	            { store: store },
	            _react2.default.createElement(NextComponent, props)
	          )
	        ), dest);
	      });
	    } catch (e) {
	      console.log('Unable to Mount Component', e);
	    }
	  },
	  mountIntegrationsConnections: function mountIntegrationsConnections() {
	    (0, _reactDom.render)(_react2.default.createElement(
	      _ErrorHandlingAppContainer2.default,
	      null,
	      _react2.default.createElement(
	        _reactRedux.Provider,
	        { store: sharedStore },
	        _react2.default.createElement(_ConnectionsLayout2.default, { svc: kloudlessServices })
	      )
	    ), document.getElementById('kloudless-ctrl-root'));
	
	    if (false) {
	      module.hot.accept('./Integrations/connections/ConnectionsLayout', function () {
	        console.log('accepted hot reload! kloudless');
	        var NextLayout = require('./Integrations/connections/ConnectionsLayout').default;
	        (0, _reactDom.render)(_react2.default.createElement(
	          _ErrorHandlingAppContainer2.default,
	          null,
	          _react2.default.createElement(
	            _reactRedux.Provider,
	            { store: sharedStore },
	            _react2.default.createElement(NextLayout, null)
	          )
	        ), document.getElementById('kloudless-ctrl-root'));
	      });
	    }
	  },
	  automountReactComponents: function automountReactComponents() {
	    console.log('Looking for components to mount');
	    var elements = document.querySelectorAll('.__react__component');
	    for (var i = 0; i < elements.length; i++) {
	      var elt = elements[i];
	      console.log("About to mount react component on ", elt);
	      var props = JSON.parse(elt.getAttribute('data-component-props'));
	      mountReactComponent(elt, elt.getAttribute('data-component'), props);
	    }
	  },
	
	
	  mountReactComponent: mountReactComponent
	};
	
	// Automounting of components from the page that look like this:
	// <div class="__react_component" data-component="path/to/Source.jsx" data-component-props="{PROPS}"></div>
	// this is equivalent to mounting <Source ...PROPS />
	
	function mountReactComponent(dest, sourceFile, props) {
	  try {
	    var context = __webpack_require__(964);
	
	    console.log('mountComponent', sourceFile, 'with props', props, 'into', dest);
	    var Component = context(sourceFile).default;
	    if (!Component) throw 'Unable to require(\'./' + sourceFile + '\')';
	
	    (0, _reactDom.render)(_react2.default.createElement(
	      _ErrorHandlingAppContainer2.default,
	      null,
	      _react2.default.createElement(
	        _reactRedux.Provider,
	        { store: sharedStore },
	        _react2.default.createElement(Component, props)
	      )
	    ), dest);
	
	    module.hot && module.hot.accept(context.id, function () {
	      var context = __webpack_require__(964);
	
	      console.log('Accepted hot reload for ' + sourceFile + '!');
	      var NextComponent = context(sourceFile).default;
	      (0, _reactDom.render)(_react2.default.createElement(
	        _ErrorHandlingAppContainer2.default,
	        null,
	        _react2.default.createElement(
	          _reactRedux.Provider,
	          { store: sharedStore },
	          _react2.default.createElement(NextComponent, props)
	        )
	      ), dest);
	    });
	  } catch (e) {
	    console.log('Unable to Mount Component', e);
	  }
	}
	
	UI.automountReactComponents();
	
	// // leaving here for now
	// if (window.location.href.indexOf('#tab-menu') !== -1 && window.Drupal.settings.has_dockets) {
	//   const segments = window.location.href.split('/');
	//   const case_uuid = segments[segments.length - 1].split('-')[0];
	//   window.openTab('query-ajax', 'dockets', 'Docket', case_uuid, false, '#dockets');
	// }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouterDom = __webpack_require__(325);
	
	var _FacetsBlock = __webpack_require__(421);
	
	var _FacetsBlock2 = _interopRequireDefault(_FacetsBlock);
	
	var _Notification = __webpack_require__(24);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	var _KnowledgeBaseLink = __webpack_require__(614);
	
	var _KnowledgeBaseLink2 = _interopRequireDefault(_KnowledgeBaseLink);
	
	var _AdvancedSearchTab = __webpack_require__(349);
	
	var _AdvancedSearchTab2 = _interopRequireDefault(_AdvancedSearchTab);
	
	var _GeneralForm = __webpack_require__(351);
	
	var _GeneralForm2 = _interopRequireDefault(_GeneralForm);
	
	var _CasesForm = __webpack_require__(350);
	
	var _CasesForm2 = _interopRequireDefault(_CasesForm);
	
	var _GeneralForm3 = __webpack_require__(250);
	
	var _GeneralForm4 = _interopRequireDefault(_GeneralForm3);
	
	var _CasesForm3 = __webpack_require__(249);
	
	var _CasesForm4 = _interopRequireDefault(_CasesForm3);
	
	var _PetitionsForm = __webpack_require__(251);
	
	var _PetitionsForm2 = _interopRequireDefault(_PetitionsForm);
	
	var _GeneralForm5 = __webpack_require__(354);
	
	var _GeneralForm6 = _interopRequireDefault(_GeneralForm5);
	
	var _CasesForm5 = __webpack_require__(353);
	
	var _CasesForm6 = _interopRequireDefault(_CasesForm5);
	
	var _GeneralForm7 = __webpack_require__(356);
	
	var _GeneralForm8 = _interopRequireDefault(_GeneralForm7);
	
	var _CasesForm7 = __webpack_require__(355);
	
	var _CasesForm8 = _interopRequireDefault(_CasesForm7);
	
	var _advancedSearchAction = __webpack_require__(178);
	
	__webpack_require__(530);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var courtRadios = [{
	  type: 'all',
	  label: 'All Courts',
	  tabs: [{
	    segment: 'general',
	    label: 'General',
	    component: _GeneralForm2.default
	  }, {
	    segment: 'cases',
	    label: 'Cases',
	    component: _CasesForm2.default
	  }, {
	    segment: 'case-activity',
	    label: 'Case Activity',
	    component: _GeneralForm2.default
	  }]
	}, {
	  type: 'bankruptcy',
	  label: 'Bankruptcy',
	  tabs: [{
	    segment: 'general',
	    label: 'General',
	    component: _GeneralForm4.default
	  }, {
	    segment: 'petitions',
	    label: 'Petitions',
	    component: _PetitionsForm2.default
	  }, {
	    segment: 'cases',
	    label: 'Cases',
	    component: _CasesForm4.default
	  }]
	}, {
	  type: 'civil',
	  label: 'Civil',
	  tabs: [{
	    segment: 'general',
	    label: 'General',
	    component: _GeneralForm6.default
	  }, {
	    segment: 'cases',
	    label: 'Cases',
	    component: _CasesForm6.default
	  }]
	}, {
	  type: 'criminal',
	  label: 'Criminal',
	  tabs: [{
	    segment: 'general',
	    label: 'General',
	    component: _GeneralForm8.default
	  }, {
	    segment: 'cases',
	    label: 'Cases',
	    component: _CasesForm8.default
	  }]
	}, {
	  type: 'appellate',
	  label: 'Appellate',
	  tabs: [{
	    segment: 'general',
	    label: 'General',
	    component: _GeneralForm2.default
	  }, {
	    segment: 'cases',
	    label: 'Cases',
	    component: _CasesForm2.default
	  }]
	}];
	
	var AdvancedSearch = function AdvancedSearch(props) {
	  var location = props.location;
	
	  var queryObject = (0, _advancedSearchAction.parseQueryStringToObject)(location.search);
	  var _props$match$params = props.match.params,
	      courtType = _props$match$params.courtType,
	      tab = _props$match$params.tab;
	
	  var selectedCourt = courtRadios.find(function (court) {
	    return court.type === courtType;
	  }) || courtRadios[0];
	  var SelectedForm = (selectedCourt.tabs.find(function (t) {
	    return t.segment === tab;
	  }) || selectedCourt.tabs[0]).component;
	
	  var radiosSelector = courtRadios.map(function (_ref) {
	    var type = _ref.type,
	        label = _ref.label;
	    return _react2.default.createElement(
	      'div',
	      { className: 'form-item' + (courtType === type ? ' selected' : ''), key: type },
	      _react2.default.createElement(
	        'label',
	        { className: 'option' },
	        _react2.default.createElement(
	          _reactRouterDom.Link,
	          {
	            to: {
	              pathname: '/advanced-search/' + type,
	              search: location.search
	            }
	          },
	          _react2.default.createElement('input', { type: 'radio', name: type, checked: courtType === type, onChange: function onChange() {
	              return null;
	            }, className: 'form-radio' })
	        ),
	        ' ',
	        label
	      )
	    );
	  });
	
	  var tabsSelector = selectedCourt.tabs.map(function (_ref2) {
	    var segment = _ref2.segment,
	        label = _ref2.label;
	
	    var selectedCls = tab === segment ? 'ui-state-default ui-tabs-selected ui-state-active' : 'ui-state-default';
	
	    return _react2.default.createElement(
	      'li',
	      { className: selectedCls, key: segment },
	      _react2.default.createElement(
	        _reactRouterDom.Link,
	        {
	          to: {
	            pathname: '/advanced-search/' + courtType + '/' + segment,
	            search: location.search
	          }
	        },
	        _react2.default.createElement(
	          'span',
	          null,
	          label
	        )
	      )
	    );
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'filings filings-page' },
	    _react2.default.createElement(_Notification2.default, null),
	    _react2.default.createElement(_FacetsBlock2.default, { type: 'advanced-search' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'filings-forms' },
	      _react2.default.createElement(_KnowledgeBaseLink2.default, null),
	      _react2.default.createElement(
	        'h1',
	        { className: 'title' },
	        'Advanced Search'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'court-type-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-radios' },
	          radiosSelector
	        )
	      ),
	      _react2.default.createElement('div', { className: 'clear' }),
	      _react2.default.createElement(
	        'ul',
	        { className: 'ui-tabs-nav ui-helper-reset ui-helper-clearfix filings-forms-tabs' },
	        tabsSelector
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'inside-block ui-tabs-panel ui-widget ui-widget-content ui-corner-bottom' },
	        _react2.default.createElement(_AdvancedSearchTab2.default, {
	          history: props.history,
	          courtType: courtType,
	          tab: tab,
	          queryParams: queryObject,
	          InitialForm: SelectedForm
	        })
	      )
	    )
	  );
	};
	
	AdvancedSearch.propTypes = {
	  match: _propTypes2.default.any.isRequired,
	  history: _propTypes2.default.any.isRequired,
	  location: _propTypes2.default.any.isRequired
	};
	
	exports.default = AdvancedSearch;

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _reactRouterDom = __webpack_require__(325);
	
	var _FacetsBlock = __webpack_require__(421);
	
	var _FacetsBlock2 = _interopRequireDefault(_FacetsBlock);
	
	__webpack_require__(530);
	
	var _Notification = __webpack_require__(24);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	var _AdvancedSearchTab = __webpack_require__(349);
	
	var _AdvancedSearchTab2 = _interopRequireDefault(_AdvancedSearchTab);
	
	var _GeneralForm = __webpack_require__(250);
	
	var _GeneralForm2 = _interopRequireDefault(_GeneralForm);
	
	var _CasesForm = __webpack_require__(249);
	
	var _CasesForm2 = _interopRequireDefault(_CasesForm);
	
	var _PetitionsForm = __webpack_require__(251);
	
	var _PetitionsForm2 = _interopRequireDefault(_PetitionsForm);
	
	var _SchedulesForm = __webpack_require__(352);
	
	var _SchedulesForm2 = _interopRequireDefault(_SchedulesForm);
	
	var _advancedSearchAction = __webpack_require__(178);
	
	var _KnowledgeBaseLink = __webpack_require__(614);
	
	var _KnowledgeBaseLink2 = _interopRequireDefault(_KnowledgeBaseLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pages = {
	  general: {
	    title: 'Advanced Search',
	    component: _GeneralForm2.default
	  },
	  cases: {
	    title: 'Advanced Search',
	    component: _CasesForm2.default
	  },
	  petitions: {
	    title: 'Petitions',
	    component: _PetitionsForm2.default
	  },
	  schedules: {
	    title: 'Schedules',
	    component: _SchedulesForm2.default
	  }
	};
	
	var AdvancedSearchIR = function AdvancedSearchIR(props) {
	  var location = props.location;
	
	  var queryObject = (0, _advancedSearchAction.parseQueryStringToObject)(location.search);
	  var _props$match$params = props.match.params,
	      courtType = _props$match$params.courtType,
	      tab = _props$match$params.tab;
	
	  var selectedPage = pages[tab] || pages.general;
	  var SelectedForm = selectedPage.component;
	
	  var selectedCls = function selectedCls(segment) {
	    return tab === segment ? 'ui-state-default ui-tabs-selected ui-state-active' : 'ui-state-default';
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'filings filings-page' },
	    _react2.default.createElement(_Notification2.default, null),
	    _react2.default.createElement(_FacetsBlock2.default, { type: 'advanced-search' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'filings-forms' },
	      _react2.default.createElement(_KnowledgeBaseLink2.default, null),
	      _react2.default.createElement(
	        'h1',
	        { className: 'title' },
	        selectedPage.title || 'Advanced Search'
	      ),
	      ['general', 'cases'].includes(tab) && _react2.default.createElement(
	        'ul',
	        { className: 'ui-tabs-nav ui-helper-reset ui-helper-clearfix filings-forms-tabs' },
	        _react2.default.createElement(
	          'li',
	          { className: selectedCls('general') },
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: '/advanced-search/' + courtType + '/general' },
	            _react2.default.createElement(
	              'span',
	              null,
	              'General'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: selectedCls('cases') },
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: '/advanced-search/' + courtType + '/cases' },
	            _react2.default.createElement(
	              'span',
	              null,
	              'Cases'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'inside-block ui-tabs-panel ui-widget ui-widget-content ui-corner-bottom' },
	        _react2.default.createElement(_AdvancedSearchTab2.default, {
	          history: props.history,
	          courtType: courtType,
	          tab: tab,
	          queryParams: queryObject,
	          InitialForm: SelectedForm
	        })
	      )
	    )
	  );
	};
	
	AdvancedSearchIR.propTypes = {
	  match: _propTypes2.default.any.isRequired,
	  history: _propTypes2.default.any.isRequired,
	  location: _propTypes2.default.any.isRequired
	};
	
	AdvancedSearchIR.defaultProps = {};
	
	var mapStateToProps = function mapStateToProps() {
	  return {};
	};
	
	var mapDispatchToProps = {};
	
	exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AdvancedSearchIR));

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactRedux = __webpack_require__(13);
	
	var _CreateAlertModal = __webpack_require__(420);
	
	var _CreateAlertModal2 = _interopRequireDefault(_CreateAlertModal);
	
	var _advancedSearchAction = __webpack_require__(178);
	
	__webpack_require__(2197);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdvancedSearchAlert = function (_Component) {
	  _inherits(AdvancedSearchAlert, _Component);
	
	  function AdvancedSearchAlert(props) {
	    _classCallCheck(this, AdvancedSearchAlert);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.onClose = function () {
	      _this.setState({ showModal: false });
	    };
	
	    _this.onSave = function (params) {
	      var save_as_new = params.save_as_new,
	          rest = _objectWithoutProperties(params, ['save_as_new']);
	
	      var filter = _this.props.advancedSearch.filter;
	
	
	      if (save_as_new) {
	        _this.props.createAlert(rest, filter);
	      } else {
	        _this.props.editAlert(rest, filter);
	      }
	      _this.onClose();
	    };
	
	    _this.clickCreateAlert = function () {
	      _this.setState({ showModal: true });
	    };
	
	    _this.state = { showModal: false };
	    return _this;
	  }
	
	  AdvancedSearchAlert.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.advancedSearch.filter.alert_id) {
	      this.props.getAlert(this.props.advancedSearch.filter.alert_id);
	    }
	  };
	
	  AdvancedSearchAlert.prototype.render = function render() {
	    var _props$advancedSearch = this.props.advancedSearch,
	        showResults = _props$advancedSearch.showResults,
	        alert = _props$advancedSearch.alert;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'facets-create-alert' },
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsSize: 'small',
	          bsStyle: 'success',
	          className: 'edit-btn',
	          onClick: this.clickCreateAlert,
	          disabled: !showResults
	        },
	        alert.data && alert.data.id ? _react2.default.createElement(
	          'span',
	          null,
	          'Create or Edit Alert'
	        ) : _react2.default.createElement(
	          'span',
	          null,
	          'Create Alert for Current Search'
	        )
	      ),
	      _react2.default.createElement(_CreateAlertModal2.default, {
	        show: this.state.showModal,
	        onSave: this.onSave,
	        onClose: this.onClose,
	        advancedSearch: this.props.advancedSearch
	      })
	    );
	  };
	
	  return AdvancedSearchAlert;
	}(_react.Component);
	
	AdvancedSearchAlert.propTypes = {
	  createAlert: _propTypes2.default.func.isRequired,
	  editAlert: _propTypes2.default.func.isRequired,
	  getAlert: _propTypes2.default.func.isRequired,
	  advancedSearch: _propTypes2.default.object.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    advancedSearch: state.toJS().advancedSearch
	  };
	};
	
	var mapDispatchToProps = {
	  createAlert: _advancedSearchAction.createAlert,
	  editAlert: _advancedSearchAction.editAlert,
	  getAlert: _advancedSearchAction.getAlert
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AdvancedSearchAlert);

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(13);
	
	var _redux = __webpack_require__(240);
	
	var _reactDatepicker = __webpack_require__(78);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _immutable = __webpack_require__(30);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _querystring = __webpack_require__(862);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	var _moment = __webpack_require__(32);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _configureStore = __webpack_require__(102);
	
	var _SearchTypesOfCaseLookup = __webpack_require__(1171);
	
	var _SearchTypesOfCaseLookup2 = _interopRequireDefault(_SearchTypesOfCaseLookup);
	
	var _OrSeparator = __webpack_require__(1165);
	
	var _OrSeparator2 = _interopRequireDefault(_OrSeparator);
	
	var _ActionButtonOfCaseLookup = __webpack_require__(1159);
	
	var _ActionButtonOfCaseLookup2 = _interopRequireDefault(_ActionButtonOfCaseLookup);
	
	var _CaseNumberSelectorOfCaseLookup = __webpack_require__(680);
	
	var _CaseNumberSelectorOfCaseLookup2 = _interopRequireDefault(_CaseNumberSelectorOfCaseLookup);
	
	var _CaseTitleOrPartyNameSelectorOfCaseLookup = __webpack_require__(681);
	
	var _CaseTitleOrPartyNameSelectorOfCaseLookup2 = _interopRequireDefault(_CaseTitleOrPartyNameSelectorOfCaseLookup);
	
	var _ArrowFormElement = __webpack_require__(1161);
	
	var _ArrowFormElement2 = _interopRequireDefault(_ArrowFormElement);
	
	var _ResultColumnHeadTextFormElement = __webpack_require__(1169);
	
	var _ResultColumnHeadTextFormElement2 = _interopRequireDefault(_ResultColumnHeadTextFormElement);
	
	var _Collapsible = __webpack_require__(110);
	
	var _Collapsible2 = _interopRequireDefault(_Collapsible);
	
	var _AlertError = __webpack_require__(50);
	
	var _AlertError2 = _interopRequireDefault(_AlertError);
	
	var _Loading = __webpack_require__(81);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _caseLookup = __webpack_require__(693);
	
	var _text = __webpack_require__(425);
	
	var _caseLookupSearchReducer = __webpack_require__(272);
	
	var _PaginatorItem = __webpack_require__(683);
	
	var _PaginatorItem2 = _interopRequireDefault(_PaginatorItem);
	
	var _errorActionTypes = __webpack_require__(101);
	
	var errorConstants = _interopRequireWildcard(_errorActionTypes);
	
	var _caseLookupSearchAction = __webpack_require__(724);
	
	var actions = _interopRequireWildcard(_caseLookupSearchAction);
	
	var _errorAction = __webpack_require__(727);
	
	var errorActions = _interopRequireWildcard(_errorAction);
	
	var _pacerSearch = __webpack_require__(93);
	
	var actionsOfPacerSearch = _interopRequireWildcard(_pacerSearch);
	
	var _RegionSelector = __webpack_require__(270);
	
	var _RegionSelector2 = _interopRequireDefault(_RegionSelector);
	
	var _regionsSorter = __webpack_require__(419);
	
	var _regionsSorter2 = _interopRequireDefault(_regionsSorter);
	
	var _courts = __webpack_require__(111);
	
	var _courts2 = _interopRequireDefault(_courts);
	
	var _regions = __webpack_require__(1212);
	
	var _regions2 = _interopRequireDefault(_regions);
	
	var _globalUtils = __webpack_require__(59);
	
	__webpack_require__(2198);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var courtDriveSearchTypes = ['All', 'Bankruptcy', 'Civil', 'Criminal', 'Appellate', 'National'];
	
	var inforuptcySearchTypes = ['Bankruptcy'];
	
	var searchTypes = (0, _globalUtils.isCourtDrive)() ? courtDriveSearchTypes : inforuptcySearchTypes;
	
	var regions = (0, _globalUtils.isProd)() ? _courts2.default.filter(function (p) {
	  return !p.is_test;
	}) : _courts2.default;
	
	var courtToRegionOption = function courtToRegionOption(_ref) {
	  var code = _ref.code,
	      name = _ref.name;
	  return { value: code, label: name };
	};
	
	var CaseLookupSearch = function (_Component) {
	  _inherits(CaseLookupSearch, _Component);
	
	  function CaseLookupSearch(props) {
	    _classCallCheck(this, CaseLookupSearch);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.valueDebounce = _lodash2.default.debounce(function (name) {
	      if (name === 'case_no') {
	        _this.searchClickHandle('case_no', true);
	      } else {
	        _this.searchClickHandle('party_title', true);
	      }
	    }, 500);
	    _this.searchAction = {
	      All: _this.props.actionsOfPacerSearch.searchCivil,
	      Bankruptcy: _this.props.actionsOfPacerSearch.searchBankruptcies,
	      Civil: _this.props.actionsOfPacerSearch.searchCivil,
	      Criminal: _this.props.actionsOfPacerSearch.searchCriminal,
	      Appellate: _this.props.actionsOfPacerSearch.searchAppellates
	    };
	    _this.bkRegions = regions.filter(function (p) {
	      return p.type === 'bankruptcy';
	    }).map(courtToRegionOption);
	    _this.dcRegions = regions.filter(function (p) {
	      return p.type === 'district';
	    }).map(courtToRegionOption);
	    _this.apRegions = regions.filter(function (p) {
	      return p.type === 'appellate';
	    }).map(courtToRegionOption);
	    _this.nationalRegions = regions.filter(function (p) {
	      return p.type === 'national';
	    }).map(courtToRegionOption);
	    _this.allRegions = regions.map(courtToRegionOption);
	    _this.regionOptions = {
	      All: _this.allRegions,
	      Bankruptcy: _this.bkRegions.concat(_regions2.default),
	      Civil: _this.dcRegions.concat(_regions2.default),
	      Criminal: _this.dcRegions.concat(_regions2.default),
	      Appellate: _this.apRegions.concat(_regions2.default),
	      National: _this.nationalRegions
	    };
	
	    _this.browserRouterListener = function (location) {
	      console.log("Browser Router Listener");
	      var query = _querystring2.default.parse(location.search.slice(1));
	
	      var searchType = query.search_type;
	      query[searchType] = query.search_term;
	
	      delete query.search_term;
	
	      if (query.case_type) {
	        query.case_type = (0, _text.firstLetterCapitalize)(query.case_type);
	      }
	
	      for (var key in query) {
	        var _this$props$actions$u;
	
	        var queryValue = query[key];
	
	        if (_this.props.filters.get(key) == queryValue) continue;
	
	        var isDateField = key === 'filed_from' || key === 'filed_to';
	
	        var value = isDateField && typeof queryValue === 'string' ? (0, _moment2.default)(queryValue) : queryValue;
	
	        value = key === 'page' ? parseInt(value) : value;
	
	        _this.props.actions.updateFilter((_this$props$actions$u = {}, _this$props$actions$u[key] = value, _this$props$actions$u));
	      }
	
	      _this.valueDebounce(searchType);
	    };
	
	    _this.resetFilters = function () {
	      // this.props.actions.resetFilters()
	    };
	
	    _this.searchClickHandle = function (search_type, forceSearch) {
	      // if length of case number less than 4 or party title was empty then do nothing.
	      var isEmpty = _lodash2.default.isEqual(_caseLookupSearchReducer.initialFilters, _this.props.filters.toJS());
	
	      var party_title = _this.props.filters.get('party_title');
	      var case_no = _this.props.filters.get('case_no');
	      if (search_type === 'case_no' && case_no.length === 0 && !_this.state.isFirstLoad) {
	        _this.setState({ caseNumShowFlash: true }, _lodash2.default.debounce(function () {
	          _this.setState({ caseNumShowFlash: false });
	        }, 1000));
	      }
	
	      if (search_type === 'party_title' && party_title.length === 0 && !_this.state.isFirstLoad) {
	        _this.setState({ caseTitleShowFlash: true }, _lodash2.default.debounce(function () {
	          _this.setState({ caseTitleShowFlash: false });
	        }, 1000));
	      }
	
	      _this.setState({ isFirstLoad: false });
	
	      if (!forceSearch || search_type == 'case_no' && case_no.length < 4 || isEmpty || search_type == 'party_title' && party_title.length == 0) return;
	
	      _this.props.actions.updateFilter({ search_type: search_type });
	      _caseLookup.search.bind(_this)({ search_type: search_type }, false);
	    };
	
	    _this.handleDateChangeRaw = function (datePosition, data) {
	      if (data.split('/').length !== 3) {
	        return;
	      }
	
	      var sanitized = data.split('/').reduce(function (accum, next, idx) {
	        var n = next.length < 2 ? '0' + next : next;
	
	        return idx === 0 ? accum + n : accum + '/' + n;
	      }, '');
	
	      _this.stateValueSet(datePosition, (0, _moment2.default)(sanitized, 'MM-DD-YYYY'));
	    };
	
	    _this.stateValueSet = function (name, e) {
	      var _ref2, _ref3;
	
	      var value = name === 'region_name' ? _lodash2.default.get(e, 'target.value', e).court_id : _lodash2.default.get(e, 'target.value', e);
	
	      var isDateField = name === 'filed_from' || name === 'filed_to';
	      var filters = _this.props.filters;
	
	      var searchFieldsEmpty = _lodash2.default.isEmpty(filters.get('case_no')) && _lodash2.default.isEmpty(filters.get('party_title'));
	
	      var newFilters = isDateField && searchFieldsEmpty ? (_ref2 = {}, _ref2[name] = value, _ref2.party_title = '*', _ref2) : (_ref3 = {}, _ref3[name] = value, _ref3);
	
	      if (name === 'case_type') {
	        newFilters = _extends({}, newFilters, { region_name: null });
	      }
	
	      _this.props.actions.updateFilter(newFilters);
	
	      if (name === 'case_type'
	      // why were we doing this before?
	      // || (isDateField && value == null)
	      ) return;
	
	      // dont search if under 3 chars
	      if (name !== 'region_name' && typeof value === 'string' && value.length < 3) {
	        return;
	      }
	
	      var search_type = name === 'party_title' || name === 'case_no' ? name : _this.props.filters.get('search_type');
	
	      _this.valueDebounce(search_type);
	    };
	
	    _this.clearDateFilters = function () {
	      _this.stateValueSet('filed_from', null);
	      _this.stateValueSet('filed_to', null);
	    };
	
	    _this.changeSortBy = function () {
	      var sort = _this.props.filters.get('sort') === 'asc' ? 'desc' : 'asc';
	      console.log("Flipping sort from", _this.props.filters.get('sort'), "to", sort);
	
	      _this.props.actions.updateFilter({ sort: sort });
	      _caseLookup.search.bind(_this)({ sort: sort }, false);
	    };
	
	    _this.changeOrder = function (order) {
	      if (order === _this.props.filters.get('order')) {
	        _this.changeSortBy();
	      } else {
	        console.log("Changing order from", _this.props.filters.get('order'), "to", order);
	        _this.props.actions.updateFilter({ order: order });
	        _caseLookup.search.bind(_this)({ order: order }, false);
	      }
	    };
	
	    _this.pacerSearch = function (e) {
	      e.preventDefault();
	
	      _this.props.history.push('/filings/search-bankruptcy-records');
	
	      var filters = _this.props.filters.toJS();
	
	      // TODO: Translate National:Cofce into Civil search with said court - quirk of PCL
	
	      // additions to filters
	      filters.case_title = filters.party_title;
	
	      var region = filters.region_name || '';
	
	      if (region.includes(',')) {
	        filters.court_id = region.split(',').reduce(function (accum, next, idx) {
	          // pacer regions are actual regions so all caps
	          if (next === next.toUpperCase()) {
	            var x = idx === 0 ? next : ',' + next;
	
	            return accum += x;
	          }
	          return accum;
	        }, '');
	      } else {
	        filters.court_id = region === region.toUpperCase() ? region : '';
	      }
	
	      // not used in pacer search
	      delete filters.party_title;
	      delete filters.order;
	      delete filters.search_type;
	      delete filters.page;
	      delete filters.year;
	      delete filters.court_name;
	      delete filters.court_code;
	      delete filters.region_name;
	
	      // All only exists on Case Lookup form.  Default to Bankruptcy for others
	      filters.case_type = filters.case_type === 'All' ? 'Bankruptcy' : filters.case_type;
	
	      // filter out pacer search
	      _this.props.actionsOfPacerSearch.updateFilter(filters);
	
	      var clientCodeErr = !client_code_is_valid() ? { messages: ['Please set a valid client code first.'] } : null;
	
	      if (clientCodeErr) {
	        _this.props.actionsOfPacerSearch.receiveError(errorConstants.VALIDATION_ERROR, clientCodeErr);
	      } else {
	        _this.searchAction[filters.case_type](_immutable2.default.fromJS(filters));
	      }
	    };
	
	    _this.isNoResultWarningMessageShow = function () {
	      var initialFilters = _lodash2.default.cloneDeep(initialFilters);
	      var currentFilters = _this.props.filters.toJS();
	
	      return !_lodash2.default.isEqual(_lodash2.default.omit(initialFilters, 'case_type'), _lodash2.default.omit(currentFilters, 'case_type')) && _this.props.isReady;
	    };
	
	    _this.clickPage = function (page) {
	      _this.props.actions.updateFilter({ page: page });
	      _caseLookup.search.bind(_this)({ page: page }, false);
	    };
	
	    _this.state = {
	      isFirstLoad: true,
	      caseNumShowFlash: false,
	      caseTitleShowFlash: false
	    };
	    return _this;
	  }
	
	  CaseLookupSearch.prototype.componentDidMount = function componentDidMount() {
	    this.browserRouterListener(_configureStore.browserHistory.location);
	  };
	
	  CaseLookupSearch.prototype.render = function render() {
	    var _this2 = this;
	
	    // todo - bunch of this is duplicated from ResultsTable.js.  Adding for now, but should refactor into a component later
	    var case_type = this.props.filters.get('case_type');
	    var nosOrChpHeader = case_type === 'Bankruptcy' ? 'Chp' : case_type === 'All' ? 'Chp/NOS' : 'NOS';
	
	    var headers = ['Case Title', 'Party Name', 'Court', 'Case No', nosOrChpHeader, 'Date Filed', 'Disposition'].map(function (header, index) {
	      var order = _this2.props.filters.get('order');
	
	      var className = header.toLowerCase().split(' ').join('-');
	      var colspan = header === 'Party Name' ? '2' : '1';
	
	      return _react2.default.createElement(
	        'th',
	        { key: index, className: className, colSpan: colspan },
	        _react2.default.createElement(
	          _ResultColumnHeadTextFormElement2.default,
	          {
	            isSelected: order === header,
	            onClick: _this2.changeOrder.bind(_this2, header) },
	          header
	        ),
	        _react2.default.createElement(_ArrowFormElement2.default, {
	          show: order === header,
	          onClick: _this2.changeSortBy,
	          sort: _this2.props.filters.get('sort') })
	      );
	    });
	
	    // todo - this is duplicated from ResultsTable.js.  Adding like this for now, but we should refactor into a component later
	    var pages = this.props.pages.toJS();
	    var paginatorItems = null;
	
	    if (pages.totalitems > 0) {
	      var currPage = this.props.filters.get('page');
	      var numPages = Math.ceil(pages.totalitems / pages.pagesize);
	      var max = 10;
	
	      var pageIconCount = numPages <= max ? numPages : max;
	
	      // 22
	      // 1  - 1, 2, 3, 4, 5, 6, 7, 8, 9, ... 22
	      // 5  - 1, 2, 3, 4, 5, 6, 7, 8, 9, ... 22
	      // 2  - 1, 2, 3, 4, 5, 6, 7, 8, 9, ... 22
	      // 20 - 1, ... , 14, 15, 16, 17, 18, 19, 20, 21, 22
	      // 10 - 1 ..., 7, 8, 9, 10, 11, 12, 13, ... 22
	      // 12 - 1, ...,  14, 15, 16, 17, 18, 19, 20, 21, 22
	
	      paginatorItems = _lodash2.default.range(pageIconCount);
	
	      if (currPage < max) {
	        // take 1-9 + numPages
	        paginatorItems = paginatorItems.map(function (el, idx) {
	          if (idx === paginatorItems.length - 1) {
	            return numPages;
	          }
	          return idx + 1;
	        });
	      } else if (currPage >= numPages - max + 2) {
	        // 1 + take currPage - max   (ex: 14)
	        // 1 + take curr Page - max  (ex 10) with 12
	        paginatorItems = paginatorItems.map(function (el, idx) {
	          if (idx === paginatorItems.length - 1) {
	            return 1;
	          }
	          return numPages - idx;
	        }).reverse();
	      } else {
	        // ex case 13
	        // 1.. (1-4 range) currPage (1-4 range)..max
	        // 1,...  9, 10, 11, 12, 13, 14, 15, 16, 17, ..22
	        paginatorItems = paginatorItems.map(function (el, idx) {
	          if (idx === 0) {
	            return 1;
	          }
	          if (idx === paginatorItems.length - 1) {
	            return numPages;
	          }
	          return currPage + idx - 5;
	        });
	      }
	
	      var previousItem = {
	        nextPage: currPage !== 1 && numPages > 1 ? currPage - 1 : currPage,
	        page: 'Previous'
	      };
	
	      var previousPage = _react2.default.createElement(_PaginatorItem2.default, { key: 'prev', item: previousItem, clickPage: this.clickPage });
	
	      var nextItem = {
	        nextPage: currPage !== numPages ? currPage + 1 : currPage,
	        page: 'Next'
	      };
	      var nextPage = _react2.default.createElement(_PaginatorItem2.default, { key: 'next', item: nextItem, clickPage: this.clickPage });
	
	      paginatorItems = paginatorItems.reduce(function (accum, el, idx) {
	        var item = { page: el, active: currPage === el };
	        var key = 'page-item-' + idx;
	
	        if (idx !== 0 && paginatorItems[idx - 1] !== paginatorItems[idx] - 1) {
	          return accum.concat([_react2.default.createElement(
	            'span',
	            null,
	            '...'
	          ), _react2.default.createElement(_PaginatorItem2.default, { key: key, item: item, clickPage: _this2.clickPage })]);
	        }
	        return accum.concat([_react2.default.createElement(_PaginatorItem2.default, { key: key, item: item, clickPage: _this2.clickPage })]);
	      }, []);
	
	      paginatorItems.unshift(previousPage);
	      paginatorItems.push(nextPage);
	    }
	
	    var results = this.props.contents.map(function (_ref4, index) {
	      var meta = _ref4.meta;
	
	      var nclParties = meta.ncl_parties || [];
	      var partieNames = nclParties.map(function (p, i) {
	        return _react2.default.createElement(
	          'div',
	          { key: i },
	          p.name,
	          ' ',
	          '(' + p.role + ')'
	        );
	      });
	
	      return _react2.default.createElement(
	        'tr',
	        { key: index, className: index % 2 === 0 ? 'even' : 'odd' },
	        _react2.default.createElement(
	          'td',
	          null,
	          meta.title
	        ),
	        _react2.default.createElement(
	          'td',
	          { colSpan: '2', className: 'party-name' },
	          partieNames
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'abbr',
	            { title: meta.title },
	            meta.court
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'ir-search-no-wrap', style: { fontWeight: 'bold' } },
	          _react2.default.createElement(
	            'a',
	            { href: '/filings/' + meta.case_uuid },
	            meta.case_no
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          meta.chapter || meta.nature_of_suit_code || ''
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          meta.date_filed,
	          _react2.default.createElement('br', null),
	          meta.date_closed
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'disposition' },
	          meta.disposition
	        )
	      );
	    });
	
	    var filedFrom = this.props.filters.get('filed_from');
	    var filedTo = this.props.filters.get('filed_to');
	    var regionOptions = this.regionOptions[this.props.filters.get('case_type')] || [];
	    var filtersForRegions = this.props.filters.mapKeys(function (k) {
	      if (k === "court_id") return "region_name";
	      return k;
	    });
	
	    var expandRegionSelector = (filtersForRegions.get('region_name') || '').split(',').length > 2 ? '764px' : '386px';
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'pacer-search-container case-lookup' },
	      _react2.default.createElement(
	        'div',
	        { className: 'filings-form' },
	        _react2.default.createElement(_SearchTypesOfCaseLookup2.default, {
	          onChange: this.stateValueSet.bind(this, 'case_type'),
	          selectedSearchType: this.props.filters.get('case_type'),
	          listOfSearchTypes: searchTypes }),
	        _react2.default.createElement(
	          'div',
	          { className: 'search-form-container' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_CaseNumberSelectorOfCaseLookup2.default, {
	              showFlash: this.state.caseNumShowFlash,
	              onChange: this.stateValueSet.bind(this, 'case_no'),
	              value: this.props.filters.get('case_no') }),
	            _react2.default.createElement(_ActionButtonOfCaseLookup2.default, {
	              onClick: this.searchClickHandle.bind(this, 'case_no') })
	          ),
	          _react2.default.createElement(_OrSeparator2.default, null),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_CaseTitleOrPartyNameSelectorOfCaseLookup2.default, {
	              showFlash: this.state.caseTitleShowFlash,
	              onChange: this.stateValueSet.bind(this, 'party_title'),
	              value: this.props.filters.get('party_title')
	
	            }),
	            _react2.default.createElement(_ActionButtonOfCaseLookup2.default, {
	              onClick: this.searchClickHandle.bind(this, 'party_title') })
	          ),
	          _react2.default.createElement(
	            _Collapsible2.default,
	            { title: 'Filters', initCollapsed: false },
	            _react2.default.createElement(_RegionSelector2.default, {
	              width: expandRegionSelector,
	              courtField: 'region_name',
	              filters: filtersForRegions,
	              regionOptions: (0, _regionsSorter2.default)(regionOptions),
	              onChange: this.stateValueSet.bind(this, 'region_name') }),
	            _react2.default.createElement('div', null),
	            _react2.default.createElement(
	              'div',
	              { className: 'date-picker-container' },
	              _react2.default.createElement(
	                'label',
	                { className: 'date-picker-label' },
	                'Date filed from:'
	              ),
	              _react2.default.createElement(_reactDatepicker2.default, {
	                selected: filedFrom,
	                onChange: this.stateValueSet.bind(this, 'filed_from'),
	                dateFormat: 'MM/DD/YYYY',
	                isClearable: true,
	                className: 'date-picker',
	                onChangeRaw: function onChangeRaw(event) {
	                  return _this2.handleDateChangeRaw('filed_from', event.target.value);
	                } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'date-picker-container' },
	              _react2.default.createElement(
	                'label',
	                { className: 'date-picker-label' },
	                'through:'
	              ),
	              _react2.default.createElement(_reactDatepicker2.default, {
	                selected: filedTo,
	                onChange: this.stateValueSet.bind(this, 'filed_to'),
	                dateFormat: 'MM/DD/YYYY',
	                isClearable: true,
	                className: 'date-picker',
	                onChangeRaw: function onChangeRaw(event) {
	                  return _this2.handleDateChangeRaw('filed_to', event.target.value);
	                } })
	            )
	          ),
	          _react2.default.createElement(_AlertError2.default, null)
	        ),
	        _react2.default.createElement(_Loading2.default, null),
	        this.props.contents.length ? _react2.default.createElement(
	          'div',
	          { id: 'basic-search-results' },
	          _react2.default.createElement(
	            'div',
	            { className: 'warning', style: { textAlign: 'center' } },
	            'Click on desired case number to continue'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'item-list' },
	            _react2.default.createElement(
	              'ul',
	              { style: { margin: '20px 0 0 0' }, className: 'pager' },
	              paginatorItems
	            )
	          ),
	          _react2.default.createElement(
	            'table',
	            { className: 'ir-search-table-results sticky-enabled sticky-table' },
	            _react2.default.createElement(
	              'thead',
	              { className: 'tableHeader-processed' },
	              _react2.default.createElement(
	                'tr',
	                null,
	                headers
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              results
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'item-list' },
	            _react2.default.createElement(
	              'ul',
	              { style: { margin: '20px 0 0 0' }, className: 'pager' },
	              paginatorItems
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'free-search-results warning' },
	            'If your case was not listed above,',
	            _react2.default.createElement(
	              'a',
	              {
	                onClick: this.pacerSearch,
	                href: '#ir-search-tab-2',
	                className: 'free-search-results' },
	              ' click here '
	            ),
	            'to immediately check PACER ',
	            _react2.default.createElement(
	              'span',
	              { className: 'charges-apply' },
	              '(PACER charges apply)'
	            )
	          )
	        ) : this.props.isError ? _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          'There was an error searching, please try again or contact support if the problem persists.'
	        ) : this.isNoResultWarningMessageShow() && _react2.default.createElement(
	          'div',
	          { className: 'messages' },
	          _react2.default.createElement(
	            'a',
	            {
	              onClick: this.pacerSearch,
	              href: '#ir-search-tab-2',
	              className: 'form-submit green',
	              style: { float: 'right', marginRight: '120px', marginTop: '4px' } },
	            'Continue'
	          ),
	          ' Free search does not have matches so we\'ll check PACER for you next',
	          _react2.default.createElement(
	            'small',
	            { style: { whiteSpace: 'nowrap' } },
	            ' (PACER charges apply)'
	          )
	        )
	      )
	    );
	  };
	
	  return CaseLookupSearch;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var caseLookupSearchReducer = state.get('caseLookupSearchReducer');
	
	  return {
	    filters: caseLookupSearchReducer.get('filters'),
	    pages: caseLookupSearchReducer.get('pages'),
	    facets: caseLookupSearchReducer.get('facets'),
	    contents: caseLookupSearchReducer.get('contents') || [],
	    isReady: caseLookupSearchReducer.get('isReady'),
	    isError: caseLookupSearchReducer.get('isError')
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch,
	    actionsOfPacerSearch: (0, _redux.bindActionCreators)(actionsOfPacerSearch, dispatch),
	    actions: (0, _redux.bindActionCreators)(actions, dispatch),
	    errorActions: (0, _redux.bindActionCreators)(errorActions, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CaseLookupSearch);

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _text = __webpack_require__(425);
	
	var _Collapsible = __webpack_require__(110);
	
	var _Collapsible2 = _interopRequireDefault(_Collapsible);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RefineSearch = function (_Component) {
	  _inherits(RefineSearch, _Component);
	
	  function RefineSearch() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RefineSearch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.courtNameParse = function (courtName) {
	      var courtValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	      var nameLengthLimit = courtValue ? 35 : 30;
	
	      courtValue = typeof courtValue === 'number' ? courtValue.toString() : courtValue;
	
	      var courtNameParsedChunkLast = courtValue.length ? ' (' + courtValue + ')' : '';
	
	      if (courtName.length + courtNameParsedChunkLast.length <= nameLengthLimit) {
	        return courtName + courtNameParsedChunkLast;
	      }
	
	      var courtNameParsedChunkFirst = courtName.substr(0, nameLengthLimit - courtNameParsedChunkLast.length - 1);
	
	      var suffix = courtName !== 'Default' ? '\u2026' + courtNameParsedChunkLast : '';
	
	      return '' + courtNameParsedChunkFirst + suffix;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  RefineSearch.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        facetsData = _props.facetsData,
	        courtsMap = _props.courtsMap,
	        facets = _props.facets,
	        facetRowClick = _props.facetRowClick;
	
	
	    var refinedSearchFacets = Object.keys(facetsData).map(function (facetName, index) {
	      var value = facets.get(facetName) ? facets.get(facetName).toJS() : {};
	
	      var valueKeys = Object.keys(value);
	
	      var facetRows = [];
	      var courtValue = valueKeys[0];
	      if (valueKeys.length === 1 && value[courtValue] === -1) {
	        // in case if in facets block there was only 1 instance,
	        // i.e. we've selected case type or one of the chapters, etc.
	        var courtName = _lodash2.default.get(courtsMap, '[\'' + courtValue + '\'][0][\'name\']') || (0, _text.firstLetterCapitalize)(courtValue);
	        var facetRowTitle = _this2.courtNameParse(courtName);
	
	        var link = _react2.default.createElement(
	          'div',
	          { key: facetRows.length, className: 'link' },
	          _react2.default.createElement(
	            'span',
	            { onClick: function onClick() {
	                var _facetRowClick;
	
	                return facetRowClick((_facetRowClick = {}, _facetRowClick[facetName] = null, _facetRowClick));
	              },
	              className: 'ir-search-facet-link link-emulated active' },
	            '(-)'
	          ),
	          ' ',
	          facetRowTitle
	        );
	        facetRows.push(link);
	      } else if (!_lodash2.default.isEmpty(value)) {
	        var facetRowKeys = facetName === 'court_name' ? valueKeys.sort() : valueKeys.sort().reverse();
	
	        // in case if in facets block there was only various instances in current facet block
	        // that we able to choose one for filter.
	        facetRows.push(facetRowKeys.map(function (facetRowName, idx) {
	          var courtName = _lodash2.default.get(courtsMap, '[\'' + facetRowName + '\'][0][\'name\']') || (0, _text.firstLetterCapitalize)(facetRowName);
	          var nextCourtValue = value[facetRowName];
	          var facetRowTitle = _this2.courtNameParse(courtName, nextCourtValue);
	
	          return _react2.default.createElement(
	            'div',
	            { key: idx, className: 'link' },
	            _react2.default.createElement(
	              'span',
	              {
	                id: 'left-panel-' + facetRowName,
	                onClick: function onClick() {
	                  var _facetRowClick2;
	
	                  return facetRowClick((_facetRowClick2 = {}, _facetRowClick2[facetName] = facetRowName, _facetRowClick2));
	                },
	                className: 'ir-search-facet-link link-emulated active' },
	              facetRowTitle
	            )
	          );
	        }));
	      }
	
	      if (facetRows.length) {
	        return _react2.default.createElement(
	          'div',
	          { key: index, className: 'tab-section' },
	          _react2.default.createElement(
	            'div',
	            { className: 'title' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              facetsData[facetName]
	            )
	          ),
	          facetRows
	        );
	      }
	      return _react2.default.createElement('div', null);
	    });
	
	    var facetComponents = _lodash2.default.compact(refinedSearchFacets);
	
	    return _react2.default.createElement(
	      _Collapsible2.default,
	      {
	        initCollapsed: false,
	        title: 'Refine Search',
	        key: 'refine-search' },
	      facetComponents
	    );
	  };
	
	  return RefineSearch;
	}(_react.Component);
	
	RefineSearch.defaultProps = {
	  facetsData: {},
	  courtsMap: {},
	  facets: []
	};
	
	RefineSearch.propTypes = {
	  facetsData: _propTypes2.default.object,
	  courtsMap: _propTypes2.default.object,
	  facets: _propTypes2.default.object,
	  facetRowClick: _propTypes2.default.func.isRequired
	};
	
	exports.default = RefineSearch;

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Collapsible = __webpack_require__(110);
	
	var _Collapsible2 = _interopRequireDefault(_Collapsible);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TabOneSection = function TabOneSection(_ref) {
	  var tab = _ref.tab,
	      sidebarStatus = _ref.sidebarStatus;
	
	  if (sidebarStatus !== 'done' || _lodash2.default.isEmpty(tab)) {
	    return null;
	  }
	  var tabOneSection = _lodash2.default.map(tab, function (val, key) {
	    if (_lodash2.default.isEmpty(val.title)) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'tab-section', key: key },
	        val.links && val.links.map(function (p, i) {
	          return _react2.default.createElement('div', { className: 'link',
	            dangerouslySetInnerHTML: { __html: p },
	            key: 'searchlink' + i });
	        })
	      );
	    }
	    return _react2.default.createElement(
	      'div',
	      { key: key },
	      _react2.default.createElement(
	        _Collapsible2.default,
	        {
	          initCollapsed: false,
	          title: val.title
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'tab-section' },
	          val.links && val.links.map(function (p, i) {
	            return _react2.default.createElement('div', { className: 'link',
	              dangerouslySetInnerHTML: { __html: p },
	              key: 'searchlink' + i });
	          })
	        )
	      )
	    );
	  });
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    tabOneSection
	  );
	};
	
	TabOneSection.defaultProps = {
	  tab: {}
	};
	
	TabOneSection.propTypes = {
	  tab: _propTypes2.default.object,
	  sidebarStatus: _propTypes2.default.string.isRequired
	};
	
	exports.default = TabOneSection;

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Collapsible = __webpack_require__(110);
	
	var _Collapsible2 = _interopRequireDefault(_Collapsible);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TabTwoSection = function TabTwoSection(_ref) {
	  var tab = _ref.tab,
	      sidebarStatus = _ref.sidebarStatus;
	
	  if (sidebarStatus !== 'done' || _lodash2.default.isEmpty(tab)) {
	    return null;
	  }
	  var tabTwoSection = _lodash2.default.map(tab, function (val, key, idx) {
	    var contentOrLinks = null;
	
	    if (val.view_content) {
	      contentOrLinks = _react2.default.createElement('div', { className: 'link',
	        dangerouslySetInnerHTML: { __html: val.view_content },
	        key: 'contentlink' + idx });
	    } else if (val.links) {
	      contentOrLinks = val.links.map(function (p, i) {
	        return _react2.default.createElement('div', { className: 'link',
	          dangerouslySetInnerHTML: { __html: p },
	          key: 'searchlink' + i });
	      });
	    }
	
	    if (_lodash2.default.includes(val.class || [], 'collapsible')) {
	      return _react2.default.createElement(
	        'div',
	        { key: key, className: 'tab-section tab-section-2' },
	        _react2.default.createElement(
	          _Collapsible2.default,
	          {
	            initCollapsed: false,
	            title: val.title },
	          contentOrLinks
	        )
	      );
	    }
	    var title = null;
	    if (val.title) {
	      title = _react2.default.createElement('div', { className: 'title', dangerouslySetInnerHTML: { __html: val.title } });
	    }
	    if (val.href) {
	      title = _react2.default.createElement('a', { className: 'title link', href: '/' + val.href, dangerouslySetInnerHTML: { __html: val.title } });
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'tab-section tab-section-2', key: key },
	      title,
	      contentOrLinks
	    );
	  });
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    tabTwoSection
	  );
	};
	
	TabTwoSection.defaultProps = {
	  tab: {}
	};
	
	TabTwoSection.propTypes = {
	  tab: _propTypes2.default.object,
	  sidebarStatus: _propTypes2.default.string.isRequired
	};
	
	exports.default = TabTwoSection;

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouterDom = __webpack_require__(325);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _FacetsBlock = __webpack_require__(421);
	
	var _FacetsBlock2 = _interopRequireDefault(_FacetsBlock);
	
	var _CaseLookup = __webpack_require__(707);
	
	var _CaseLookup2 = _interopRequireDefault(_CaseLookup);
	
	var _PacerSearch = __webpack_require__(692);
	
	var _PacerSearch2 = _interopRequireDefault(_PacerSearch);
	
	var _ReportsTab = __webpack_require__(1215);
	
	var _ReportsTab2 = _interopRequireDefault(_ReportsTab);
	
	__webpack_require__(530);
	
	var _globalUtils = __webpack_require__(59);
	
	var _LocalCourtSearch = __webpack_require__(691);
	
	var _LocalCourtSearch2 = _interopRequireDefault(_LocalCourtSearch);
	
	var _Notification = __webpack_require__(24);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tabs = [{
	  segment: 'search-court-filings',
	  label: 'Case Lookup',
	  route: '/filings/search-court-filings',
	  component: _CaseLookup2.default
	}, {
	  segment: 'search-bankruptcy-records',
	  label: 'Pacer Search',
	  route: '/filings/search-bankruptcy-records',
	  component: _PacerSearch2.default
	}, {
	  segment: 'search-bankruptcy-reports',
	  label: 'Reports',
	  route: '/filings/search-bankruptcy-reports',
	  component: _ReportsTab2.default
	}];
	
	if ((0, _globalUtils.isCourtDrive)()) {
	  tabs.splice(2, 0, {
	    segment: 'search-local-court',
	    label: 'Local Court Search',
	    route: '/filings/search-local-court',
	    component: _LocalCourtSearch2.default
	  });
	}
	
	var Filings = function Filings(props) {
	  var tab = props.match.params.tab;
	
	  var SelectedForm = _lodash2.default.find(tabs, ['segment', tab]).component;
	
	  var tabsSelector = tabs.map(function (p) {
	    var selectedCls = tab === p.segment ? 'ui-state-default ui-tabs-selected ui-state-active' : 'ui-state-default';
	
	    return _react2.default.createElement(
	      'li',
	      { className: selectedCls, key: p.segment },
	      _react2.default.createElement(
	        _reactRouterDom.Link,
	        { to: p.route },
	        _react2.default.createElement(
	          'span',
	          null,
	          p.label
	        )
	      )
	    );
	  });
	
	  var headerText = (0, _globalUtils.isCourtDrive)() ? 'Access bankruptcy, civil, and criminal cases across all districts nationwide' : 'Access bankruptcy cases across all districts nationwide';
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'filings filings-page' },
	    _react2.default.createElement(_Notification2.default, null),
	    _react2.default.createElement(_FacetsBlock2.default, { type: 'filings' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'filings-forms' },
	      _react2.default.createElement(
	        'h1',
	        { className: 'title' },
	        'Search Court Records'
	      ),
	      _react2.default.createElement(
	        'h4',
	        null,
	        headerText
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: 'ui-tabs-nav ui-helper-reset ui-helper-clearfix filings-forms-tabs' },
	        tabsSelector
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'inside-block ui-tabs-panel ui-widget-content ui-corner-bottom' },
	        _react2.default.createElement(SelectedForm, { history: props.history })
	      )
	    )
	  );
	};
	
	Filings.propTypes = {
	  match: _propTypes2.default.any.isRequired,
	  history: _propTypes2.default.any.isRequired
	};
	
	exports.default = Filings;

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ADVANCED_SEARCH_DOCUMENT_FETCH = exports.ADVANCED_SEARCH_RESULT_DOCKET_UPDATE = exports.ADVANCED_SEARCH_ALERT = exports.ADVANCED_SEARCH_URL_PARAMS_UPDATE = exports.ADVANCED_SEARCH_FORM_FILTER_SET = exports.ADVANCED_SEARCH_RESET = exports.ADVANCED_SEARCH_ALL_GENERAL = undefined;
	
	var _utils = __webpack_require__(33);
	
	var ADVANCED_SEARCH_ALL_GENERAL = exports.ADVANCED_SEARCH_ALL_GENERAL = (0, _utils.createAsyncTypes)('ADVANCED_SEARCH_ALL_GENERAL');
	var ADVANCED_SEARCH_RESET = exports.ADVANCED_SEARCH_RESET = 'ADVANCED_SEARCH_RESET';
	var ADVANCED_SEARCH_FORM_FILTER_SET = exports.ADVANCED_SEARCH_FORM_FILTER_SET = 'ADVANCED_SEARCH_FORM_FILTER_SET';
	var ADVANCED_SEARCH_URL_PARAMS_UPDATE = exports.ADVANCED_SEARCH_URL_PARAMS_UPDATE = 'ADVANCED_SEARCH_URL_PARAMS_UPDATE';
	var ADVANCED_SEARCH_ALERT = exports.ADVANCED_SEARCH_ALERT = (0, _utils.createAsyncTypes)('ADVANCED_SEARCH_ALERT');
	var ADVANCED_SEARCH_RESULT_DOCKET_UPDATE = exports.ADVANCED_SEARCH_RESULT_DOCKET_UPDATE = 'ADVANCED_SEARCH_RESULT_DOCKET_UPDATE';
	var ADVANCED_SEARCH_DOCUMENT_FETCH = exports.ADVANCED_SEARCH_DOCUMENT_FETCH = (0, _utils.createAsyncTypes)('ADVANCED_SEARCH_DOCUMENT_FETCH');

/***/ },
/* 713 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var REQUEST_API_CALLS_DETAILS = exports.REQUEST_API_CALLS_DETAILS = 'REQUEST_API_CALLS_DETAILS';
	var RECEIVE_API_CALLS_DETAILS = exports.RECEIVE_API_CALLS_DETAILS = 'RECEIVE_API_CALLS_DETAILS';
	var REQUEST_API_CALLS_SUMMARY = exports.REQUEST_API_CALLS_SUMMARY = 'REQUEST_API_CALLS_SUMMARY';
	var RECEIVE_API_CALLS_SUMMARY = exports.RECEIVE_API_CALLS_SUMMARY = 'RECEIVE_API_CALLS_SUMMARY';
	var SERVICE_ERROR = exports.SERVICE_ERROR = 'SERVICE_ERROR';

/***/ },
/* 714 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var REQUEST_CASE_DATA_OF_CASE_LOOKUP = exports.REQUEST_CASE_DATA_OF_CASE_LOOKUP = 'REQUEST_CASE_DATA_OF_CASE_LOOKUP';
	var RECEIVE_CASE_DATA_OF_CASE_LOOKUP = exports.RECEIVE_CASE_DATA_OF_CASE_LOOKUP = 'RECEIVE_CASE_DATA_OF_CASE_LOOKUP';
	var RECEIVE_CASE_LOOKUP_ERROR = exports.RECEIVE_CASE_LOOKUP_ERROR = 'RECEIVE_CASE_LOOKUP_ERROR';
	
	var UPDATE_FILTERS_OF_CASE_DATA_OF_CASE_LOOKUP = exports.UPDATE_FILTERS_OF_CASE_DATA_OF_CASE_LOOKUP = 'UPDATE_FILTERS_OF_CASE_DATA_OF_CASE_LOOKUP';
	
	var CLEAR_ALL_FILTERS_OF_CASE_LOOKUP = exports.CLEAR_ALL_FILTERS_OF_CASE_LOOKUP = 'CLEAR_ALL_FILTERS_OF_CASE_LOOKUP';

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.UPDATE_CLAIM_DOCUMENT = exports.UPDATE_SELECTED_CLAIM = exports.UPDATE_CLAIMS = exports.UPDATE_REDACT = exports.UPDATE_DOCKET_DETAILS = exports.UPDATE_DOCKET_HEADER = exports.DOCKETS_FAVORITE_EMAIL = exports.RESET_CLAIMS_PARTS = exports.UPDATE_CLAIMS_PARTS = exports.FETCH_CLAIM_DOCUMENTS = exports.ORDER_PDF_DOCUMENT = exports.BUY_PDF_DOCUMENT = undefined;
	
	var _utils = __webpack_require__(33);
	
	// export const DOCUMENTS = createAsyncTypes('DOCUMENTS');
	var BUY_PDF_DOCUMENT = exports.BUY_PDF_DOCUMENT = (0, _utils.createAsyncTypes)('BUY_PDF_DOCUMENT');
	var ORDER_PDF_DOCUMENT = exports.ORDER_PDF_DOCUMENT = (0, _utils.createAsyncTypes)('ORDER_PDF_DOCUMENT');
	
	var FETCH_CLAIM_DOCUMENTS = exports.FETCH_CLAIM_DOCUMENTS = (0, _utils.createAsyncTypes)('FETCH_CLAIM_DOCUMENTS');
	// export const DOCKETS_POPUP = 'DOCKETS_POPUP';
	var UPDATE_CLAIMS_PARTS = exports.UPDATE_CLAIMS_PARTS = 'UPDATE_CLAIMS_PARTS';
	var RESET_CLAIMS_PARTS = exports.RESET_CLAIMS_PARTS = 'RESET_CLAIMS_PARTS';
	var DOCKETS_FAVORITE_EMAIL = exports.DOCKETS_FAVORITE_EMAIL = 'DOCKETS_FAVORITE_EMAIL';
	var UPDATE_DOCKET_HEADER = exports.UPDATE_DOCKET_HEADER = 'UPDATE_DOCKET_HEADER';
	var UPDATE_DOCKET_DETAILS = exports.UPDATE_DOCKET_DETAILS = 'UPDATE_DOCKET_DETAILS';
	var UPDATE_REDACT = exports.UPDATE_REDACT = 'UPDATE_REDACT';
	var UPDATE_CLAIMS = exports.UPDATE_CLAIMS = 'UPDATE_CLAIMS';
	var UPDATE_SELECTED_CLAIM = exports.UPDATE_SELECTED_CLAIM = 'UPDATE_SELECTED_CLAIM';
	var UPDATE_CLAIM_DOCUMENT = exports.UPDATE_CLAIM_DOCUMENT = 'UPDATE_CLAIM_DOCUMENT';

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CLIENT_CODE_VALIDATION_SUCCESS = exports.CLIENT_CODE_VALIDATION_ERROR = exports.CLIENT_CODE_SET = exports.CLIENT_CODE_LIST = undefined;
	
	var _utils = __webpack_require__(33);
	
	var CLIENT_CODE_LIST = exports.CLIENT_CODE_LIST = (0, _utils.createAsyncTypes)('CLIENT_CODE_LIST');
	var CLIENT_CODE_SET = exports.CLIENT_CODE_SET = (0, _utils.createAsyncTypes)('CLIENT_CODE_SET');
	
	var CLIENT_CODE_VALIDATION_ERROR = exports.CLIENT_CODE_VALIDATION_ERROR = 'CLIENT_CODE_VALIDATION_ERROR';
	var CLIENT_CODE_VALIDATION_SUCCESS = exports.CLIENT_CODE_VALIDATION_SUCCESS = 'CLIENT_CODE_VALIDATION_SUCCESS';

/***/ },
/* 717 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var REQUEST_CREDITOR_MAILING = exports.REQUEST_CREDITOR_MAILING = 'REQUEST_CREDITOR_MAILING';
	var RECEIVE_CREDITOR_MAILING = exports.RECEIVE_CREDITOR_MAILING = 'RECEIVE_CREDITOR_MAILING';
	var SERVICE_ERROR = exports.SERVICE_ERROR = 'SERVICE_ERROR';
	var RESET_SERVICE_ERROR = exports.RESET_SERVICE_ERROR = 'RESET_SERVICE_ERROR';

/***/ },
/* 718 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var REQUEST_DOCKET_PARTS = exports.REQUEST_DOCKET_PARTS = 'REQUEST_DOCKET_PARTS';
	var RECEIVE_DOCKET_PARTS = exports.RECEIVE_DOCKET_PARTS = 'RECEIVE_DOCKET_PARTS';
	var REQUEST_HISTORY_DATA = exports.REQUEST_HISTORY_DATA = 'REQUEST_HISTORY_DATA';
	var RECEIVE_HISTORY_DATA = exports.RECEIVE_HISTORY_DATA = 'RECEIVE_HISTORY_DATA';
	var REQUEST_FILTER_HISTORY_DATA = exports.REQUEST_FILTER_HISTORY_DATA = 'REQUEST_FILTER_HISTORY_DATA';
	var SERVICE_ERROR = exports.SERVICE_ERROR = 'SERVICE_ERROR';
	var RESET_SERVICE_ERROR = exports.RESET_SERVICE_ERROR = 'RESET_SERVICE_ERROR';

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LOCAL_COURT_SEARCH_RESET = exports.LOCAL_COURT_SEARCH_BANKRUPTCY = exports.LOCAL_COURT_SEARCH_DISTRICT = exports.LOCAL_COURT_SEARCH_APPELLATE = undefined;
	
	var _utils = __webpack_require__(33);
	
	var LOCAL_COURT_SEARCH_APPELLATE = exports.LOCAL_COURT_SEARCH_APPELLATE = (0, _utils.createAsyncTypes)('LOCAL_COURT_SEARCH_APPELLATE');
	var LOCAL_COURT_SEARCH_DISTRICT = exports.LOCAL_COURT_SEARCH_DISTRICT = (0, _utils.createAsyncTypes)('LOCAL_COURT_SEARCH_DISTRICT');
	var LOCAL_COURT_SEARCH_BANKRUPTCY = exports.LOCAL_COURT_SEARCH_BANKRUPTCY = (0, _utils.createAsyncTypes)('LOCAL_COURT_SEARCH_BANKRUPTCY');
	var LOCAL_COURT_SEARCH_RESET = exports.LOCAL_COURT_SEARCH_RESET = 'LOCAL_COURT_SEARCH_RESET';

/***/ },
/* 720 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var REQUEST_BANKRUPTCY_SEARCH = exports.REQUEST_BANKRUPTCY_SEARCH = 'REQUEST_BANKRUPTCY_SEARCH';
	var RECEIVE_SEARCH_RESULTS = exports.RECEIVE_SEARCH_RESULTS = 'RECEIVE_SEARCH_RESULTS';
	var REQUEST_VIEW_SEARCH = exports.REQUEST_VIEW_SEARCH = 'REQUEST_VIEW_SEARCH';
	var REQUEST_CIVIL_SEARCH = exports.REQUEST_CIVIL_SEARCH = 'REQUEST_CIVIL_SEARCH';
	var REQUEST_CRIMINAL_SEARCH = exports.REQUEST_CRIMINAL_SEARCH = 'REQUEST_CRIMINAL_SEARCH';
	var RESET_SEARCH_RESULTS = exports.RESET_SEARCH_RESULTS = 'RESET_SEARCH_RESULTS';
	var SERVICE_ERROR = exports.SERVICE_ERROR = 'SERVICE_ERROR';
	var UPDATE_FILTERS = exports.UPDATE_FILTERS = 'UPDATE_FILTERS';
	var RESET_FILTERS = exports.RESET_FILTERS = 'RESET_FILTERS';
	var REQUEST_APPELLATE_SEARCH = exports.REQUEST_APPELLATE_SEARCH = 'REQUEST_APPELLATE_SEARCH';
	var REQUEST_BANKRUPTCY_LOCAL_SEARCH = exports.REQUEST_BANKRUPTCY_LOCAL_SEARCH = 'REQUEST_BANKRUPTCY_LOCAL_SEARCH';
	var UPDATE_FILTER = exports.UPDATE_FILTER = 'UPDATE_FILTER';

/***/ },
/* 721 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var REQUEST_DOCKET_PARTS = exports.REQUEST_DOCKET_PARTS = 'REQUEST_DOCKET_PARTS';
	var RECEIVE_DOCKET_PARTS = exports.RECEIVE_DOCKET_PARTS = 'RECEIVE_DOCKET_PARTS';
	var REQUEST_RELATED_TRANSACTION_DATA = exports.REQUEST_RELATED_TRANSACTION_DATA = 'REQUEST_RELATED_TRANSACTION_DATA';
	var RECEIVE__RELATED_TRANSACTION_DATA = exports.RECEIVE__RELATED_TRANSACTION_DATA = 'RECEIVE__RELATED_TRANSACTION_DATA';
	var SERVICE_ERROR = exports.SERVICE_ERROR = 'SERVICE_ERROR';
	var RESET_SERVICE_ERROR = exports.RESET_SERVICE_ERROR = 'RESET_SERVICE_ERROR';

/***/ },
/* 722 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var REQUEST_REPORTS = exports.REQUEST_REPORTS = 'REQUEST_REPORTS';
	var RECEIVE_REPORTS = exports.RECEIVE_REPORTS = 'RECEIVE_REPORTS';
	var REQUEST_AUTOMATE_MAILING_REPORTS = exports.REQUEST_AUTOMATE_MAILING_REPORTS = 'REQUEST_AUTOMATE_MAILING_REPORTS';
	var RECEIVE_AUTOMATE_MAILING_REPORTS = exports.RECEIVE_AUTOMATE_MAILING_REPORTS = 'RECEIVE_AUTOMATE_MAILING_REPORTS';
	
	// todo was in postcss branch?
	// export const REQUEST_REPORTS = 'REQUEST_APPELLATE_SEARCH';

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.DELIVERY_LOG = exports.RESEND_CUSTOM_ALERT = exports.REMOVE_CUSTOM_ALERT = exports.UPDATE_CUSTOM_ALERT = exports.CUSTOM_ALERTS = exports.RESEND_TEMPLATE_ALERT = exports.UPDATE_TEMPLATE_ALERT = exports.TEMPLATE_ALERTS = exports.REMOVE_AUTOMATED_REPORT = exports.AUTOMATED_REPORTS = undefined;
	
	var _utils = __webpack_require__(33);
	
	var AUTOMATED_REPORTS = exports.AUTOMATED_REPORTS = (0, _utils.createAsyncTypes)('AUTOMATED_REPORTS');
	var REMOVE_AUTOMATED_REPORT = exports.REMOVE_AUTOMATED_REPORT = (0, _utils.createAsyncTypes)('REMOVE_AUTOMATED_REPORT');
	var TEMPLATE_ALERTS = exports.TEMPLATE_ALERTS = (0, _utils.createAsyncTypes)('TEMPLATE_ALERTS');
	var UPDATE_TEMPLATE_ALERT = exports.UPDATE_TEMPLATE_ALERT = (0, _utils.createAsyncTypes)('UPDATE_TEMPLATE_ALERT');
	var RESEND_TEMPLATE_ALERT = exports.RESEND_TEMPLATE_ALERT = (0, _utils.createAsyncTypes)('RESEND_TEMPLATE_ALERT');
	var CUSTOM_ALERTS = exports.CUSTOM_ALERTS = (0, _utils.createAsyncTypes)('CUSTOM_ALERTS');
	var UPDATE_CUSTOM_ALERT = exports.UPDATE_CUSTOM_ALERT = (0, _utils.createAsyncTypes)('UPDATE_CUSTOM_ALERT');
	var REMOVE_CUSTOM_ALERT = exports.REMOVE_CUSTOM_ALERT = (0, _utils.createAsyncTypes)('REMOVE_CUSTOM_ALERT');
	var RESEND_CUSTOM_ALERT = exports.RESEND_CUSTOM_ALERT = (0, _utils.createAsyncTypes)('RESEND_CUSTOM_ALERT');
	var DELIVERY_LOG = exports.DELIVERY_LOG = (0, _utils.createAsyncTypes)('DELIVERY_LOG');

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.clearAllFilter = exports.updateFilter = exports.partySearch = undefined;
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _caseLookupActionTypes = __webpack_require__(714);
	
	var types = _interopRequireWildcard(_caseLookupActionTypes);
	
	var _courts = __webpack_require__(111);
	
	var _courts2 = _interopRequireDefault(_courts);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var partySearch = exports.partySearch = function partySearch(query, searchType, searchValue) {
	  return function (dispatch) {
	    console.log("Requesting Case Lookup", searchType, searchValue, query);
	    dispatch({
	      type: types.REQUEST_CASE_DATA_OF_CASE_LOOKUP,
	      params: query
	    });
	
	    var court_name = query.court_name,
	        court_code = query.court_code;
	
	
	    if (!court_code && court_name && court_name.includes(',')) {
	      query['court_name[]'] = court_name.split(',');
	    }
	
	    if (court_code) {
	      delete query.court_code;
	      // Replace each court code with its region code
	      query['court_code[]'] = court_code.split(',').map(function (code) {
	        var court = _lodash2.default.find(_courts2.default, { code: code });
	        if (court) return court.region_code;
	        // we were probably passed in region code already
	        return code.toLowerCase();
	      });
	    }
	
	    var onSuccess = function onSuccess(response) {
	      return dispatch({
	        type: types.RECEIVE_CASE_DATA_OF_CASE_LOOKUP,
	        facets: response.facets,
	        contents: response.contents,
	        pages: response.pages
	      });
	    };
	
	    var onError = function onError(response) {
	      return dispatch({
	        type: types.RECEIVE_CASE_LOOKUP_ERROR
	      });
	    };
	
	    return _superagent2.default.get('/filings/json/' + searchType + '/' + searchValue).query(query).set('Accept', 'application/json').set('Content-Type', 'application/json').then(
	    // 200 doesn't mean success, need to check the status flag
	    function (response) {
	      return response.body.status === 'success' ? onSuccess(response.body) : onError(response);
	    }, onError);
	  };
	};
	
	var updateFilter = exports.updateFilter = function updateFilter(filter) {
	  return {
	    type: types.UPDATE_FILTERS_OF_CASE_DATA_OF_CASE_LOOKUP,
	    filter: filter
	  };
	};
	
	var clearAllFilter = exports.clearAllFilter = function clearAllFilter() {
	  return {
	    type: types.CLEAR_ALL_FILTERS_OF_CASE_LOOKUP
	  };
	};

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.updateDocketParts = exports.togglePopup = exports.resetDocketParts = exports.updateRedact = exports.buyPdf = exports.getDocketParts = exports.emailPartsPdfCombined = exports.emailPartsZip = exports.previewPdf = exports.downloadPdfCombined = exports.downloadPdfCombinedZipped = exports.downloadPdfZip = exports.updatePopup = exports.buyAllParts = exports.purchaseDockets = exports.orderPdf = exports.getDocuments = exports.getPartsPurchaseInfo = exports.checkClientCodeValid = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.receiveError = receiveError;
	exports.onFailure = onFailure;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _pacerSearch = __webpack_require__(93);
	
	var _irSearchActionTypes = __webpack_require__(138);
	
	var types = _interopRequireWildcard(_irSearchActionTypes);
	
	var _errorActionTypes = __webpack_require__(101);
	
	var errorActionTypes = _interopRequireWildcard(_errorActionTypes);
	
	var _claimDocumentsActionTypes = __webpack_require__(715);
	
	var documentsActionTypes = _interopRequireWildcard(_claimDocumentsActionTypes);
	
	var _Notification = __webpack_require__(24);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapResponseErrorsToMessage(err) {
	  var request_id = _lodash2.default.get(err, ['response', 'body', 'error', 'request_id']);
	  var errorMessageExtra = request_id ? 'When contacting support, please quote Request ID \'' + request_id + '\'' : '';
	
	  return {
	    // We want to hide real messages from user since traces are confusing to them
	    // TODO: coordinate with API to surface proper errors such as field validation?
	    messages: ['PACER is experiencing some issues. Please try again in a few minutes.', errorMessageExtra],
	    // but we include the real message in the details so we receive it in the sentry report
	    details: _lodash2.default.get(err, ['response', 'body', 'error']) || []
	  };
	}
	
	function receiveError(err, msg) {
	  return {
	    type: types.SERVICE_ERROR,
	    error: msg,
	    errors: msg
	  };
	}
	
	function onFailure(dispatch) {
	  return function (err) {
	    console.error(err);
	    return dispatch(receiveError(types.SERVICE_ERROR, mapResponseErrorsToMessage(err)));
	  };
	}
	
	// TODO: move to clientCode actions file
	var checkClientCodeValid = exports.checkClientCodeValid = function checkClientCodeValid() {
	  return function (dispatch) {
	    if (!window.client_code_is_valid()) {
	      dispatch((0, _pacerSearch.receiveError)(errorActionTypes.VALIDATION_ERROR, { messages: ['Please set a valid client code first.'] }));
	      return;
	    }
	    dispatch({
	      type: errorActionTypes.RESET_VALIDATION_ERROR
	    });
	    return true;
	  };
	};
	
	var getPartsPurchaseInfo = exports.getPartsPurchaseInfo = function getPartsPurchaseInfo(params) {
	  return function (dispatch, getState) {
	    function onSuccess(response) {
	      if (!_lodash2.default.isEmpty(response.body.error)) {
	        return onFailure(dispatch)({ response: response });
	      }
	
	      var _getState$get$toJS = getState().get('dockets').toJS(),
	          entries = _getState$get$toJS.entries;
	
	      var updatedEntriesData = entries.data.map(function (docket) {
	        // default to in-pacer
	        docket.colorCode = 'in-pacer';
	
	        var seqNum = docket.seqNum;
	
	        var responseEntry = _lodash2.default.find(response.body, { sequence_number: seqNum });
	
	        if (responseEntry) {
	          if (responseEntry.has_user_purchased_any_document) {
	            docket.colorCode = 'purchased';
	          } else {
	            docket.colorCode = 'in-inforuptcy';
	          }
	        }
	        return docket;
	      });
	
	      dispatch({
	        type: documentsActionTypes.UPDATE_CLAIMS,
	        entries: _extends({}, entries, { status: 'done', data: updatedEntriesData })
	      });
	
	      return Promise.resolve(response.body);
	    }
	
	    return _superagent2.default.post('/rpc/dockets/purchase_info').set('Accept', 'application/json').send(params).then(onSuccess, onFailure(dispatch));
	  };
	};
	
	var getDocumentsFromPacer = function getDocumentsFromPacer(_ref) {
	  var court_code = _ref.court_code,
	      case_number = _ref.case_number,
	      claimNum = _ref.claimNum,
	      seqNum = _ref.seqNum;
	  return function (dispatch) {
	    dispatch({
	      type: documentsActionTypes.FETCH_CLAIM_DOCUMENTS.REQUEST,
	      selectedClaim: {
	        status: 'loading',
	        claimNum: claimNum,
	        seqNum: seqNum,
	        court_code: court_code,
	        case_number: case_number
	      }
	    });
	
	    var onError = function onError(error) {
	      dispatch({
	        type: documentsActionTypes.FETCH_CLAIM_DOCUMENTS.ERROR,
	        error: error
	      });
	
	      _Notification.notify.error(error || 'Failed to load data');
	    };
	
	    function onSuccess(response) {
	      if (response.body && !_lodash2.default.isEmpty(response.body.error)) {
	        onError(response.body.error);
	        return onFailure(dispatch)({ response: response });
	      }
	
	      dispatch({
	        type: documentsActionTypes.FETCH_CLAIM_DOCUMENTS.SUCCESS,
	        selectedClaim: {
	          status: 'done',
	          claimNum: claimNum,
	          seqNum: seqNum,
	          court_code: court_code,
	          case_number: case_number,
	          binder: response.body
	        }
	      });
	    }
	
	    return _superagent2.default.post('/rpc/capi/cases/pacer/' + court_code + '/' + case_number + '/claims/' + claimNum + '/documents/' + seqNum).then(onSuccess, onFailure(dispatch)).catch(function (error) {
	      return onError(error);
	    });
	  };
	};
	
	var getDocuments = exports.getDocuments = function getDocuments(_ref2) {
	  var court_code = _ref2.court_code,
	      case_number = _ref2.case_number,
	      claimNum = _ref2.claimNum,
	      seqNum = _ref2.seqNum;
	  return function (dispatch, getState) {
	    // check for documents in existing entries
	    /*
	    const cachedDocket = getState()
	      .getIn(['dockets', 'entries', 'data'])
	      .find(docket => docket.get('claimNum') === claimNum);
	     if (cachedDocket && cachedDocket.getIn(['binder', 'documents', 0])) {
	      return dispatch({
	        type: documentsActionTypes.UPDATE_SELECTED_DOCKET,
	        selectedClaim: {
	          status: 'done',
	          claimNum,
	          ...cachedDocket.toJS(),
	        },
	      });
	    }
	    */
	
	    // retrieve from pacer
	    return dispatch(getDocumentsFromPacer({ court_code: court_code, case_number: case_number, claimNum: claimNum, seqNum: seqNum }));
	  };
	};
	
	// this is basically just a passthrough from the document response, located in links.order_pdf
	// adding it here so we can update the state of the documents to inlcude the download links
	var orderPdf = exports.orderPdf = function orderPdf(document) {
	  return function (dispatch) {
	    if (!(document.links && document.links.order_pdf)) {
	      return Promise.reject();
	    }
	
	    var url = document.links.order_pdf.href;
	    var rpcLinkSegment = '/rpc/' + url.split('/rpc/')[1];
	
	    dispatch({
	      type: documentsActionTypes.ORDER_PDF_DOCUMENT.REQUEST,
	      number: document.number
	    });
	
	    var onError = function onError(error) {
	      dispatch({
	        type: documentsActionTypes.ORDER_PDF_DOCUMENT.ERROR,
	        error: error
	      });
	
	      _Notification.notify.error(error || 'Failed to load data');
	    };
	
	    function onSuccess(response) {
	      if (response.body && !_lodash2.default.isEmpty(response.body.error)) {
	        onError(response.body.error);
	        return onFailure(dispatch)({ response: response });
	      }
	
	      var updatedDocument = response.body.document;
	
	
	      dispatch({
	        type: documentsActionTypes.ORDER_PDF_DOCUMENT.SUCCESS,
	        document: _extends({}, updatedDocument, { status: 'done' })
	      });
	
	      return Promise.resolve(updatedDocument);
	    }
	
	    return (0, _superagent2.default)(rpcLinkSegment).then(onSuccess, onFailure(dispatch)).catch(function (error) {
	      return onError(error);
	    });
	  };
	};
	
	var purchaseDockets = exports.purchaseDockets = function purchaseDockets(params) {
	  return function (dispatch, getState) {
	    var court_code = params.court_code,
	        case_number = params.case_number;
	
	
	    dispatch({
	      type: documentsActionTypes.UPDATE_CLAIMS,
	      header: { status: 'loading' },
	      entries: { status: 'loading' }
	    });
	
	    var currentState = getState().toJS();
	    var clientCode = currentState.clientCodeReducer.sessionClientCode;
	    var pacer_client = _lodash2.default.isEmpty(clientCode) ? window.Drupal.settings.clientCode : clientCode;
	
	    function onSuccess(response) {
	      if (!_lodash2.default.isEmpty(response.body.error)) {
	        return onFailure(dispatch)({ response: response });
	      }
	
	      var receipt = _lodash2.default.get(response.body, 'receipts', {});
	
	      dispatch({
	        type: documentsActionTypes.UPDATE_CLAIMS,
	        receipt: receipt
	      });
	
	      return Promise.resolve(response.body);
	    }
	
	    var paramsStringNullRemoved = _lodash2.default.omitBy(_extends({}, params, { pacer_client: pacer_client }), _lodash2.default.isNil);
	
	    return _superagent2.default.post('/rpc/capi/cases/pacer/' + court_code + '/' + case_number + '/dockets/update').type('form').send(paramsStringNullRemoved)
	    // .set('Accept', 'application/json')
	    .then(onSuccess, onFailure(dispatch));
	  };
	};
	
	// Taken from https://gist.github.com/joepie91/2664c85a744e6bd0629c#gistcomment-1787629
	var wait = function wait(ms) {
	  return new Promise(function (resolve) {
	    return setTimeout(resolve, ms);
	  });
	};
	
	function rpcProgress(url, dispatch, getState) {
	  return _superagent2.default.get(url).set('Accept', 'application/json').then(function (response) {
	    if (response.accepted) {
	      // still processing, update percentage so progress bar updates.
	      var percentage = Math.floor(response.body.task_progress);
	
	      var state = getState().toJS();
	
	      var docketParts = _extends({}, state.dockets.docketParts, {
	        percentage: percentage
	      });
	
	      dispatch({
	        type: documentsActionTypes.UPDATE_DOCKETS_PARTS,
	        docketParts: docketParts
	      });
	
	      // wait 0.5s and then update progress again
	      return wait(500).then(function () {
	        return rpcProgress(url, dispatch, getState);
	      });
	    }
	
	    // when progress finishes, it returns a 302 response to the actual results, but it appears that  superagent
	    // follows that redirect for us, so we should have a 200 response here
	    if (response.status !== 200) {
	      return onFailure(dispatch)({ response: response });
	    }
	
	    return Promise.resolve(response.body);
	  }, onFailure(dispatch));
	}
	
	var buyAllParts = exports.buyAllParts = function buyAllParts(params) {
	  return function (dispatch, getState) {
	    var currentState = getState().toJS();
	    var prevDocketParts = currentState.dockets.docketParts;
	    var clientCode = currentState.clientCodeReducer.sessionClientCode;
	    var pacer_client = _lodash2.default.isEmpty(clientCode) ? window.Drupal.settings.clientCode : clientCode;
	
	    params = _extends({}, params, { pacer_client: pacer_client });
	
	    dispatch({
	      type: documentsActionTypes.UPDATE_DOCKETS_PARTS,
	      docketParts: _extends({}, prevDocketParts, {
	        status: 'loading',
	        step: 2,
	        percentage: 0
	      })
	    });
	
	    return _superagent2.default.post('/rpc/dockets/documents/purchase').type('json').send(params).then(function (response) {
	      if (!response.accepted || _lodash2.default.isEmpty(response.header.location)) {
	        return onFailure(dispatch)({ response: response });
	      }
	
	      return rpcProgress(response.header.location, dispatch, getState);
	    }, onFailure(dispatch)).then(function (purchaseResponse) {
	      if (purchaseResponse.errors.length > 0) {
	        var errors = _lodash2.default.uniq(purchaseResponse.errors.map(function (_ref3) {
	          var error = _ref3.error;
	          return error;
	        }));
	        dispatch({
	          type: documentsActionTypes.UPDATE_DOCKETS_PARTS,
	          docketParts: {
	            purchased: purchaseResponse.purchased,
	            step: 2,
	            percentage: 0,
	            status: 'done',
	            errors: errors
	          }
	        });
	
	        return Promise.reject(purchaseResponse);
	      }
	
	      dispatch({
	        type: documentsActionTypes.UPDATE_DOCKETS_PARTS,
	        docketParts: {
	          purchased: purchaseResponse.purchased,
	          step: 3,
	          percentage: 0,
	          errors: null,
	          status: 'done'
	        }
	      });
	
	      return Promise.resolve(purchaseResponse);
	    }, onFailure(dispatch));
	  };
	};
	
	var updatePopup = exports.updatePopup = function updatePopup(popup) {
	  return function (dispatch) {
	    return dispatch({
	      type: documentsActionTypes.DOCKETS_POPUP,
	      popup: popup
	    });
	  };
	};
	
	function downloadDocuments(params, dispatch, getState, type, combine_binders) {
	  var printPreview = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
	
	  var prevDocketParts = getState().getIn(['claimDocuments', 'docketParts']).toJS();
	  var prevPopup = getState().getIn(['claimDocuments', 'popup']).toJS();
	
	  dispatch({
	    type: documentsActionTypes.UPDATE_DOCKETS_PARTS,
	    docketParts: _extends({}, prevDocketParts, {
	      status: 'loading',
	      step: 3
	    })
	  });
	
	  var deliverParams = {
	    court_code: params.court_code,
	    case_number: params.case_number,
	    docket_numbers: params.docket_numbers,
	    delivery_method: 'download',
	    type: type,
	    combine_binders: combine_binders
	  };
	
	  return _superagent2.default.post('/rpc/dockets/documents/deliver').type('json').send(deliverParams).then(function (response) {
	    if (!response.accepted || _lodash2.default.isEmpty(response.header.location)) {
	      return onFailure(dispatch)({ response: response });
	    }
	    return rpcProgress(response.header.location, dispatch, getState);
	  }, onFailure(dispatch)).then(function (deliverResponse) {
	    // what we get here is
	    // delivery_method: "download"
	    // download_url: "http://..."
	    // print_url: "http://..."
	    // filename: "..."
	    var link = printPreview ? deliverResponse.print_url : deliverResponse.download_url;
	    var pretty_name = deliverResponse.filename;
	
	    dispatch({
	      type: documentsActionTypes.UPDATE_DOCKETS_PARTS,
	      docketParts: _extends({}, prevDocketParts, {
	        email_address: params.email_address,
	        step: 3,
	        link: link,
	        pretty_name: pretty_name
	      })
	    });
	
	    dispatch(updatePopup(_extends({}, prevPopup, { data: {} })));
	
	    window.open(link);
	
	    if (params.docket_numbers && params.docket_numbers.length === 1) {
	      return dispatch(getDocuments({
	        court_code: params.court_code,
	        case_number: params.case_number,
	        seqNum: params.docket_numbers[0],
	        claimNum: parseInt(params.docket_numbers[0], 10)
	      }));
	    }
	
	    return Promise.resolve(deliverResponse);
	  }, onFailure(dispatch));
	}
	
	function emailParts(params, dispatch, getState, type, combine_binders) {
	  var _getState$toJS = getState().toJS(),
	      dockets = _getState$toJS.dockets;
	
	  dispatch({
	    type: documentsActionTypes.UPDATE_DOCKETS_PARTS,
	    docketParts: _extends({}, dockets.docketParts, {
	      status: 'loading',
	      step: 3
	    })
	  });
	
	  var deliverParams = _extends({}, params, {
	    delivery_method: 'email',
	    type: type,
	    combine_binders: combine_binders
	  });
	
	  return _superagent2.default.post('/rpc/dockets/documents/deliver').type('json').send(deliverParams).then(function (response) {
	    if (!response.accepted || _lodash2.default.isEmpty(response.header.location)) {
	      return onFailure(dispatch)({ response: response });
	    }
	    return rpcProgress(response.header.location, dispatch, getState);
	  }, onFailure(dispatch)).then(function (deliverResponse) {
	    var email_addresses = deliverResponse.email_addresses,
	        success = deliverResponse.success;
	
	
	    dispatch(updatePopup(_extends({}, dockets.popup, { show: false, data: {} })));
	
	    dispatch({
	      type: documentsActionTypes.UPDATE_DOCKETS_PARTS,
	      docketParts: _extends({}, dockets.docketParts, {
	        email_address: email_addresses.join(', '),
	        step: 3,
	        success: success,
	        showFlash: true
	      })
	    });
	
	    dispatch({
	      type: documentsActionTypes.DOCKETS_FAVORITE_EMAIL,
	      favoriteEmail: _extends({}, dockets.favoriteEmail, {
	        status: 'done'
	      })
	    });
	
	    if (params.docket_numbers && params.docket_numbers.length === 1) {
	      return dispatch(getDocuments({
	        court_code: params.court_code,
	        case_number: params.case_number,
	        seqNum: params.docket_numbers[0],
	        claimNum: parseInt(params.docket_numbers[0], 10)
	      }));
	    }
	
	    return Promise.resolve('success');
	  }, onFailure(dispatch));
	}
	
	var downloadPdfZip = exports.downloadPdfZip = function downloadPdfZip(params) {
	  return function (dispatch, getState) {
	    return downloadDocuments(params, dispatch, getState, 'zip', false);
	  };
	};
	
	var downloadPdfCombinedZipped = exports.downloadPdfCombinedZipped = function downloadPdfCombinedZipped(params) {
	  return function (dispatch, getState) {
	    return downloadDocuments(params, dispatch, getState, 'zip', true);
	  };
	};
	
	var downloadPdfCombined = exports.downloadPdfCombined = function downloadPdfCombined(params) {
	  return function (dispatch, getState) {
	    return downloadDocuments(params, dispatch, getState, 'pdf', false);
	  };
	};
	
	var previewPdf = exports.previewPdf = function previewPdf(params) {
	  return function (dispatch, getState) {
	    return downloadDocuments(params, dispatch, getState, 'pdf', false, true);
	  };
	};
	
	var emailPartsZip = exports.emailPartsZip = function emailPartsZip(params) {
	  return function (dispatch, getState) {
	    return emailParts(params, dispatch, getState, 'zip', false);
	  };
	};
	
	var emailPartsPdfCombined = exports.emailPartsPdfCombined = function emailPartsPdfCombined(params) {
	  return function (dispatch, getState) {
	    return emailParts(params, dispatch, getState, 'pdf', true);
	  };
	};
	
	var getDocketParts = exports.getDocketParts = function getDocketParts(params) {
	  return function (dispatch, getState) {
	    dispatch({
	      type: documentsActionTypes.UPDATE_DOCKETS_PARTS,
	      docketParts: {
	        step: 1,
	        status: 'loading',
	        totalParts: 0
	      }
	    });
	
	    return _superagent2.default.post('/rpc/dockets/documents/cost').type('json').send(params).then(function (response) {
	      if (!response.accepted || _lodash2.default.isEmpty(response.header.location)) {
	        return onFailure(dispatch)({ response: response });
	      }
	
	      return rpcProgress(response.header.location, dispatch, getState);
	    }, onFailure(dispatch)).then(function (costResponse) {
	      var totalCost = parseFloat(costResponse.total.cost);
	
	      var docketParts = {
	        partsToPurchase: costResponse.pacer.documents,
	        totalParts: costResponse.total.documents,
	        totalCost: totalCost,
	        step: 1,
	        status: 'done'
	      };
	
	      // if no docs need to be purchased from pacer, move to step 2
	      if (costResponse.pacer.documents === 0) {
	        docketParts.step = 2;
	        docketParts.alreadyPurchased = true;
	      }
	
	      dispatch({
	        type: documentsActionTypes.UPDATE_DOCKETS_PARTS,
	        docketParts: docketParts
	      });
	    }, onFailure(dispatch));
	  };
	};
	
	var buyPdf = exports.buyPdf = function buyPdf(params) {
	  return function (dispatch) {
	    var case_no = params.case_no,
	        claimNum = params.claimNum,
	        seqNum = params.seqNum,
	        partNumber = params.partNumber,
	        court_code = params.court_code;
	
	
	    dispatch({
	      type: documentsActionTypes.BUY_PDF_DOCUMENT.REQUEST,
	      number: partNumber
	    });
	
	    function onSuccess(_ref4) {
	      var body = _ref4.body;
	
	      if (!_lodash2.default.isEmpty(body.error)) {
	        return dispatch(receiveError(null, { messages: [body.error.errorMessage] }));
	      }
	
	      var document = body.document;
	
	
	      dispatch({
	        type: documentsActionTypes.BUY_PDF_DOCUMENT.SUCCESS, // UPDATE_CLAIM_DOCUMENT,
	        document: document
	        // TODO: add receipt in correct location (nested in the entry)
	        // receipt,
	      });
	
	      return Promise.resolve(body);
	    }
	
	    return _superagent2.default.post('/rpc/capi/cases/pacer/' + court_code + '/' + case_no + '/claims/' + claimNum + '/documents/' + seqNum + '/' + partNumber).set('Accept', 'application/json').then(onSuccess, onFailure(dispatch));
	  };
	};
	
	var updateRedact = exports.updateRedact = function updateRedact(updatedRedact) {
	  return function (dispatch, getState) {
	    var _getState$get$toJS2 = getState().get('dockets').toJS(),
	        redact = _getState$get$toJS2.redact;
	
	    return dispatch({
	      type: documentsActionTypes.UPDATE_REDACT,
	      redact: _extends({}, redact, updatedRedact)
	    });
	  };
	};
	
	var resetDocketParts = exports.resetDocketParts = function resetDocketParts() {
	  return function (dispatch) {
	    return dispatch({ type: documentsActionTypes.RESET_DOCKETS_PARTS });
	  };
	};
	
	var togglePopup = exports.togglePopup = function togglePopup() {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function (dispatch) {
	    dispatch(resetDocketParts());
	
	    var popup = params.show ? _extends({}, params) : { show: false };
	
	    dispatch(updatePopup(popup));
	  };
	};
	
	var updateDocketParts = exports.updateDocketParts = function updateDocketParts(docketParts) {
	  return function (dispatch) {
	    return dispatch({
	      type: documentsActionTypes.UPDATE_DOCKETS_PARTS,
	      docketParts: docketParts
	    });
	  };
	};

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.deleteAndRepurchase = exports.getItems = exports.getDocketDetails = exports.loadFavoriteEmails = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.updateHasMoreRecentFilingDate = updateHasMoreRecentFilingDate;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _irSearchActionTypes = __webpack_require__(138);
	
	var types = _interopRequireWildcard(_irSearchActionTypes);
	
	var _docketsActionTypes = __webpack_require__(177);
	
	var docketActionTypes = _interopRequireWildcard(_docketsActionTypes);
	
	var _irSearchActions = __webpack_require__(71);
	
	var _docketActions = __webpack_require__(42);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function updateHasMoreRecentFilingDate(response) {
	  var _ref = _lodash2.default.find(response.body.items, 'docket_headers') || {},
	      _ref$docket_headers = _ref.docket_headers,
	      docket_headers = _ref$docket_headers === undefined ? {} : _ref$docket_headers;
	
	  var _ref2 = _lodash2.default.find(docket_headers, 'meta') || {},
	      _ref2$meta = _ref2.meta,
	      meta = _ref2$meta === undefined ? {} : _ref2$meta;
	
	  var hasMoreRecentFilingsDate = parseInt(meta.latest_docket_number, 10) < parseInt(meta.latest_history_number, 10) ? meta.latest_known_date_filed : null;
	
	  return {
	    type: docketActionTypes.UPDATE_DOCKET_HEADER,
	    docketHeader: { hasMoreRecentFilingsDate: hasMoreRecentFilingsDate }
	  };
	}
	
	var loadFavoriteEmails = exports.loadFavoriteEmails = function loadFavoriteEmails() {
	  return function (dispatch, getState) {
	    var state = getState();
	
	    return _superagent2.default.get('/ir-documentselect/load_favourite_emails').set('Accept', 'application/json').then(function (response) {
	      if (!_lodash2.default.isEmpty(response.body.error) || response.body.success < 1) {
	        return dispatch((0, _docketActions.onFailure)({ response: response }));
	      }
	      var _state$toJS$irSearch = state.toJS().irSearch,
	          data = _state$toJS$irSearch.data,
	          lastUpdated = _state$toJS$irSearch.lastUpdated,
	          receipt = _state$toJS$irSearch.receipt;
	
	      data.push(['favoriteEmail', response.body.email]);
	
	      dispatch({
	        type: types.RECEIVE_CASE_DATA,
	        data_type: 'dockets',
	        data: data,
	        lastUpdated: lastUpdated,
	        receipt: receipt
	      });
	
	      dispatch({
	        type: docketActionTypes.DOCKETS_FAVORITE_EMAIL,
	        favoriteEmail: { email: response.body.email, status: 'done' }
	      });
	    }, function (responseError) {
	      return dispatch((0, _docketActions.onFailure)(responseError));
	    });
	  };
	};
	
	var getDocketDetails = exports.getDocketDetails = function getDocketDetails(params) {
	  return function (dispatch, getState) {
	    var case_uuid = params.case_uuid,
	        seqNum = params.seqNum;
	
	
	    (0, _irSearchActions.requestCaseData)({}, dispatch);
	
	    dispatch({
	      type: docketActionTypes.UPDATE_DOCKET_DETAILS,
	      selectedDocket: {
	        seqNum: seqNum,
	        status: 'loading'
	      }
	    });
	
	    var state = getState();
	
	    return _superagent2.default.get('/ir-documentselect-json/' + case_uuid + '/' + seqNum).set('Accept', 'application/json').then(function (response) {
	      if (response.body && !_lodash2.default.isEmpty(response.body.error)) {
	        return dispatch((0, _docketActions.onFailure)({ response: response }));
	      }
	      var data = state.toJS().irSearch.data;
	
	      // add the property to color the docket number correctly
	
	      var keys = data.map(function (p) {
	        return p[0];
	      });
	      if (_lodash2.default.includes(keys, 'docketDetails')) {
	        data = data.map(function (datum) {
	          if (datum[0] === 'docketDetails') {
	            return ['docketDetails', {
	              details: response.body || [],
	              seqNum: seqNum
	            }];
	          }
	          return datum;
	        });
	      } else {
	        data.push(['docketDetails', {
	          details: response.body || [],
	          seqNum: seqNum
	        }]);
	      }
	
	      dispatch({
	        type: docketActionTypes.UPDATE_DOCKET_DETAILS,
	        selectedDocket: {
	          seqNum: params.seqNum,
	          status: 'done'
	        }
	      });
	
	      dispatch({
	        type: types.RECEIVE_CASE_DATA,
	        data_type: 'dockets',
	        data: data,
	        lastUpdated: _lodash2.default.get(response.body, 'items.receipts[0].meta.timestamp'),
	        receipt: _lodash2.default.get(response.body, 'items.receipts[0].text')
	      });
	    }, function (responseError) {
	      dispatch({
	        type: docketActionTypes.UPDATE_DOCKET_DETAILS,
	        seqNum: null
	      });
	      dispatch((0, _docketActions.onFailure)(responseError));
	    });
	  };
	};
	
	var getItems = exports.getItems = function getItems(itemParams, sort_direction, selectedPageNum) {
	  var receipts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	  return function (dispatch, getState) {
	    (0, _irSearchActions.requestCaseData)({}, dispatch);
	
	    var itemQs = _extends({
	      date_from: '_',
	      date_to: '_',
	      doc_range: '_',
	      keyword: '_',
	      page: 0,
	      page_index: 1,
	      sort_direction: sort_direction,
	      sort_field: 'date_filed'
	    }, itemParams);
	
	    if (itemQs.date_from.includes('/')) {
	      var from = itemQs.date_from.split('/');
	      itemQs.date_from = from[2] + '-' + from[0] + '-' + from[1];
	    }
	
	    if (itemQs.date_to.includes('/')) {
	      var to = itemQs.date_to.split('/');
	      itemQs.date_to = to[2] + '-' + to[0] + '-' + to[1];
	    }
	
	    var state = getState();
	
	    return _superagent2.default.post('/dockets/search').query(itemQs).set('Accept', 'application/json').then(function (response) {
	      if (!_lodash2.default.isEmpty(response.body.error)) {
	        return dispatch((0, _docketActions.onFailure)({ response: response }));
	        // return dispatch(receiveError(null, { messages: [response.body.error.errorMessage] }));
	      }
	
	      var dockets = (0, _docketActions.getDocketsFromResp)(response, sort_direction, selectedPageNum);
	      var data = Object.keys(dockets).reduce(function (accum, next) {
	        accum.push([next, dockets[next]]);
	        return accum;
	      }, []);
	
	      var ds = state.toJS().irSearch.data.reduce(function (accum, next) {
	        // eslint-disable-next-line
	        accum[next[0]] = next[1];
	        return accum;
	      }, {});
	
	      data.push(['headers', ds.headers || []]);
	
	      return dispatch({
	        type: types.RECEIVE_CASE_DATA,
	        data_type: 'dockets',
	        data: data,
	        lastUpdated: _lodash2.default.get(receipts, '[0].meta.timestamp'),
	        receipt: _lodash2.default.get(receipts, '[0].text')
	      });
	    }, function (responseError) {
	      return dispatch((0, _docketActions.onFailure)(responseError));
	    });
	  };
	};
	
	var deleteAndRepurchase = exports.deleteAndRepurchase = function deleteAndRepurchase(params) {
	  return function (dispatch) {
	    var case_uuid = params.case_uuid,
	        redactSeqNum = params.redactSeqNum,
	        doc_range = params.doc_range;
	
	    var repurchaseParams = {
	      case_uuid: case_uuid,
	      sequence_number: redactSeqNum,
	      confirm: 'yes'
	    };
	
	    return _superagent2.default.post('/dockets/delete-and-repurchase-docket-entry').type('form').send(repurchaseParams).then(function (response) {
	      if (!_lodash2.default.isEmpty(response.body.error)) {
	        return dispatch((0, _docketActions.onFailure)({ response: response }));
	        // return dispatch(receiveError(null, { messages: [response.body.error.errorMessage] }));
	      }
	
	      var getDocketsParams = _extends({}, params, {
	        docket_number_range: doc_range
	      });
	
	      var receipt = _lodash2.default.get(response.body, 'items.receipts[0].text', []);
	
	      dispatch({
	        type: docketActionTypes.UPDATE_DOCKETS,
	        receipt: receipt
	      });
	
	      return dispatch((0, _docketActions.getDockets)(getDocketsParams));
	    }, function (responseError) {
	      return dispatch((0, _docketActions.onFailure)(responseError));
	    });
	  };
	};

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.onFailure = exports.receiveError = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var receiveError = exports.receiveError = function receiveError(errorType, errors) {
	    return {
	        type: errorType,
	        errors: errors
	    };
	};
	
	var mapResponseErrorsToMessage = function mapResponseErrorsToMessage(error) {
	    var request_id = _lodash2.default.get(error, ['response', 'body', 'error', 'request_id']);
	    var errorMessageExtra = request_id ? 'When contacting support, please quote Request ID \'' + request_id + '\'' : '';
	
	    return {
	        // We want to hide real messages from user since traces are confusing to them
	        // TODO: coordinate with API to surface proper errors such as field validation?
	        messages: ['PACER is experiencing some issues. Please try again in a few minutes.', errorMessageExtra],
	        // but we include the real message in the details so we receive it in the sentry report
	        details: _lodash2.default.get(error, ['response', 'body', 'error'])
	    };
	};
	
	var onFailure = exports.onFailure = function onFailure(dispatch) {
	    return function (error) {
	        return dispatch(receiveError(mapResponseErrorsToMessage(error)));
	    };
	};

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getSidebarData = exports.actionTypes = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _url = __webpack_require__(180);
	
	var _url2 = _interopRequireDefault(_url);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionTypes = exports.actionTypes = {
	  SIDEBAR_DATA_REQUEST: 'SIDEBAR_DATA_REQUEST',
	  SIDEBAR_DATA_SUCCESS: 'SIDEBAR_DATA_SUCCESS',
	  SIDEBAR_DATA_ERROR: 'SIDEBAR_DATA_ERROR'
	};
	
	var getSidebarData = exports.getSidebarData = function getSidebarData() {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function (dispatch) {
	    dispatch({
	      type: actionTypes.SIDEBAR_DATA_REQUEST,
	      data: { status: 'loading' }
	    });
	
	    var onSuccess = function onSuccess(resp) {
	      var _resp$body$data = resp.body.data,
	          data = _resp$body$data === undefined ? {} : _resp$body$data;
	
	      dispatch({
	        type: actionTypes.SIDEBAR_DATA_SUCCESS,
	        data: _extends({}, data, { status: 'done' })
	      });
	    };
	
	    var onFailure = function onFailure(error) {
	      dispatch({
	        type: actionTypes.SIDEBAR_DATA_ERROR,
	        error: error
	      });
	    };
	
	    var _params$type = params.type,
	        type = _params$type === undefined ? 'filings' : _params$type;
	
	
	    return _superagent2.default.get((0, _url2.default)('/ui/sidebar?url=' + type)).set('Accept', 'application/json').set('Content-Type', 'application/json').then(onSuccess, onFailure);
	  };
	};

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = PagedItems;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _ResultsPaginator = __webpack_require__(108);
	
	var _ResultsPaginator2 = _interopRequireDefault(_ResultsPaginator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LOCAL_STORAGE_ITEMSPERPAGE_KEY = 'PagedItems.itemsPerPage';
	
	function PagedItems(_ref) {
	  var records = _ref.records,
	      AfterComponent = _ref.after,
	      Component = _ref.component;
	
	  var _useState = (0, _react.useState)(1),
	      page = _useState[0],
	      setPage = _useState[1];
	
	  var _useState2 = (0, _react.useState)(localStorage.getItem(LOCAL_STORAGE_ITEMSPERPAGE_KEY) || 50),
	      itemsPerPage = _useState2[0],
	      setItemsPerPage = _useState2[1];
	
	  var topOfPage = (0, _react.useRef)(null);
	  var totalPages = Math.ceil(records.length / itemsPerPage);
	
	  function gotoPage(page) {
	    setPage(page);
	    if (topOfPage.current) topOfPage.current.scrollIntoView({ behavior: 'smooth' });
	  }
	
	  (0, _react.useEffect)(function () {
	    localStorage.setItem(LOCAL_STORAGE_ITEMSPERPAGE_KEY, itemsPerPage);
	  }, [itemsPerPage]);
	
	  (0, _react.useEffect)(function () {
	    setPage(1);
	  }, [records]);
	
	  function Pager() {
	    if (totalPages === 0 || totalPages === 1) return null;
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Well,
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { float: 'left' } },
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Records ',
	            (page - 1) * itemsPerPage + 1,
	            ' - ',
	            Math.min(page * itemsPerPage, records.length),
	            ' of',
	            ' ',
	            records.length
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { float: 'left', marginLeft: 24 } },
	          'Show',
	          ' ',
	          _react2.default.createElement(
	            'select',
	            {
	              onChange: function onChange(e) {
	                setItemsPerPage(e.target.value);
	                gotoPage(1);
	              },
	              value: itemsPerPage
	            },
	            _react2.default.createElement(
	              'option',
	              { value: 10 },
	              '10'
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 25 },
	              '25'
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 50 },
	              '50'
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 50 },
	              '100'
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 50 },
	              '200'
	            )
	          ),
	          ' ',
	          'per page'
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { float: 'right', marginTop: -9 } },
	          _react2.default.createElement(_ResultsPaginator2.default, { totalPages: totalPages, selectedPage: page, onChangePage: function onChangePage(page) {
	              return gotoPage(page + 1);
	            } })
	        )
	      )
	    );
	  }
	
	  var recordsToDraw = records.filter(function (_item, index) {
	    return page * itemsPerPage > index && index >= (page - 1) * itemsPerPage;
	  });
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement('div', { ref: topOfPage }),
	    _react2.default.createElement(Pager, null),
	    _react2.default.createElement(Component, { visibleRecords: recordsToDraw }),
	    (page === totalPages || totalPages === 0) && AfterComponent && _react2.default.createElement(AfterComponent, null),
	    _react2.default.createElement(Pager, null)
	  );
	}

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _PetitionForm = __webpack_require__(731);
	
	var _PetitionForm2 = _interopRequireDefault(_PetitionForm);
	
	var _industry = __webpack_require__(701);
	
	var _industry2 = _interopRequireDefault(_industry);
	
	var _ch11Type = __webpack_require__(700);
	
	var _ch11Type2 = _interopRequireDefault(_ch11Type);
	
	__webpack_require__(947);
	
	var _ScheduleVeriyToolbar = __webpack_require__(179);
	
	var _ScheduleVeriyToolbar2 = _interopRequireDefault(_ScheduleVeriyToolbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Petition = function (_Component) {
	  _inherits(Petition, _Component);
	
	  function Petition() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Petition);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPetitiondata = function (schedule) {
	      var _schedule$data = schedule.data,
	          data = _schedule$data === undefined ? {} : _schedule$data,
	          _schedule$header = schedule.header,
	          header = _schedule$header === undefined ? {} : _schedule$header;
	
	      var naics = header.naics ? _industry2.default.filter(function (industryValue) {
	        return industryValue.label.indexOf(header.naics) >= 0;
	      })[0].label : '';
	      var ch11_type = header.ch11_type ? _ch11Type2.default.filter(function (ch11TypeValue) {
	        return ch11TypeValue.label === header.ch11_type;
	      })[0].label : '';
	      return _react2.default.createElement(
	        'table',
	        { id: 'petition' },
	        _react2.default.createElement(
	          'tbody',
	          { id: 'view-petitions' },
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'td',
	              { style: { width: 225 } },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label-petitioner' },
	                  'Principal place of business:'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { style: { width: 225 } },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label-petitioner' },
	                  'Location of principal assets:'
	                )
	              )
	            ),
	            _react2.default.createElement('td', null)
	          ),
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label' },
	                  'Street'
	                )
	              ),
	              _react2.default.createElement('br', null),
	              data.principal_place_of_business_street || ''
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label' },
	                  'Street'
	                )
	              ),
	              _react2.default.createElement('br', null),
	              data.location_place_of_business_street || ''
	            ),
	            _react2.default.createElement('td', null)
	          ),
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label' },
	                  'City'
	                )
	              ),
	              _react2.default.createElement('br', null),
	              data.principal_place_of_business_city || ''
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label' },
	                  'City'
	                )
	              ),
	              _react2.default.createElement('br', null),
	              data.location_place_of_business_city || ''
	            ),
	            _react2.default.createElement('td', null)
	          ),
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label' },
	                  'State'
	                )
	              ),
	              _react2.default.createElement('br', null),
	              data.principal_place_of_business_state || ''
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label' },
	                  'State'
	                )
	              ),
	              _react2.default.createElement('br', null),
	              data.location_place_of_business_state || ''
	            ),
	            _react2.default.createElement('td', null)
	          ),
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label' },
	                  'Zip Code'
	                )
	              ),
	              _react2.default.createElement('br', null),
	              data.principal_place_of_business_zip_code || ''
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label' },
	                  'Zip Code'
	                )
	              ),
	              _react2.default.createElement('br', null),
	              data.location_place_of_business_zip_code || ''
	            ),
	            _react2.default.createElement('td', null)
	          ),
	          ' ',
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label' },
	                  'Country'
	                )
	              ),
	              _react2.default.createElement('br', null),
	              data.principal_place_of_business_country || ''
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label' },
	                  'Country'
	                )
	              ),
	              _react2.default.createElement('br', null),
	              data.location_place_of_business_country || ''
	            ),
	            _react2.default.createElement('td', null)
	          ),
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label' },
	                  'Describe debtor\u2019s business'
	                )
	              ),
	              _react2.default.createElement('br', null),
	              data.describe_debtor_business || ''
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label' },
	                  'Authorized representative of debtor'
	                )
	              ),
	              _react2.default.createElement('br', null),
	              data.authorized_representative_of_debtor || ''
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label' },
	                  'Title'
	                )
	              ),
	              _react2.default.createElement('br', null),
	              data.title || ''
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label' },
	                  'Estimated number of creditors'
	                )
	              ),
	              _react2.default.createElement('br', null),
	              data.estimated_number_of_creditors || ''
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label' },
	                  'Estimated assets'
	                )
	              ),
	              _react2.default.createElement('br', null),
	              header.estimated_assets || ''
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label' },
	                  'Estimated liabilities'
	                )
	              ),
	              _react2.default.createElement('br', null),
	              header.estimated_liabilities || ''
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'td',
	              { colSpan: '2' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label' },
	                  'Website '
	                )
	              ),
	              _react2.default.createElement('br', null),
	              header.website || ''
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'justify-alignment' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label' },
	                  'Chapter 11 Type'
	                )
	              ),
	              _react2.default.createElement('br', null),
	              ch11_type || ''
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'td',
	              { colSpan: '3' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label' },
	                  'Naics (4-digit code) '
	                )
	              ),
	              _react2.default.createElement('br', null),
	              naics || ''
	            )
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Petition.prototype.render = function render() {
	    var _props = this.props,
	        schedule = _props.schedule,
	        editScheduleForm = _props.editScheduleForm,
	        can_see_details = _props.can_see_details,
	        canEdit = _props.canEdit,
	        toggleScheduleForm = _props.toggleScheduleForm,
	        onSubmit = _props.onSubmit,
	        type = _props.type;
	
	    var tableData = schedule || {};
	    var noDataFoundMessage = schedule.data === null ? 'There is no Petition for this case.' : null;
	    var statisticalSummaryMissing = schedule.header ? schedule.header.website === null && schedule.header.estimated_assets === null && schedule.header.ch11_type === null && schedule.header.naics === null && schedule.header.estimated_liabilities === null : null;
	    var noDataFound = noDataFoundMessage || schedule.empty || null;
	
	    if (statisticalSummaryMissing && noDataFound && !editScheduleForm) {
	      return _react2.default.createElement(
	        'div',
	        { id: 'ir-search-schedule-petition-results' },
	        _react2.default.createElement(
	          _reactBootstrap.Well,
	          { bsSize: 'small' },
	          noDataFound
	        ),
	        canEdit && _react2.default.createElement(_ScheduleVeriyToolbar2.default, { schedule: schedule }),
	        canEdit && !editScheduleForm && _react2.default.createElement(
	          'div',
	          { className: 'editable' },
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary', onClick: toggleScheduleForm },
	            'Edit'
	          )
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: type },
	      can_see_details && _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { id: 'schedule-petition' },
	          _react2.default.createElement(
	            'div',
	            { id: 'ir-search-schedule-petition-results' },
	            editScheduleForm ? _react2.default.createElement(_PetitionForm2.default, _extends({}, this.props, { onSubmit: onSubmit })) : _react2.default.createElement(
	              _react2.default.Fragment,
	              null,
	              canEdit && _react2.default.createElement(_ScheduleVeriyToolbar2.default, { schedule: schedule }),
	              this.getPetitiondata(tableData),
	              canEdit && _react2.default.createElement(
	                'div',
	                { className: 'editable' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'btn btn-primary', onClick: toggleScheduleForm },
	                  'Edit'
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Petition;
	}(_react.Component);
	
	Petition.defaultProps = {
	  type: 'petition'
	};
	
	Petition.propTypes = {
	  schedule: _propTypes2.default.any.isRequired,
	  type: _propTypes2.default.string,
	  editScheduleForm: _propTypes2.default.bool.isRequired,
	  toggleScheduleForm: _propTypes2.default.func.isRequired,
	  onSubmit: _propTypes2.default.func.isRequired,
	  can_see_details: _propTypes2.default.bool.isRequired,
	  canEdit: _propTypes2.default.bool.isRequired
	};
	
	exports.default = Petition;

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactBootstrap = __webpack_require__(7);
	
	__webpack_require__(947);
	
	var _assetsAndLiabilities = __webpack_require__(1207);
	
	var _assetsAndLiabilities2 = _interopRequireDefault(_assetsAndLiabilities);
	
	var _industry = __webpack_require__(701);
	
	var _industry2 = _interopRequireDefault(_industry);
	
	var _noOfCreditors = __webpack_require__(1211);
	
	var _noOfCreditors2 = _interopRequireDefault(_noOfCreditors);
	
	var _debtorBusiness = __webpack_require__(1210);
	
	var _debtorBusiness2 = _interopRequireDefault(_debtorBusiness);
	
	var _ch11Type = __webpack_require__(700);
	
	var _ch11Type2 = _interopRequireDefault(_ch11Type);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import data
	
	
	var PetitionForm = function (_Component) {
	  _inherits(PetitionForm, _Component);
	
	  function PetitionForm() {
	    _classCallCheck(this, PetitionForm);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  PetitionForm.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        schedule = _props.schedule,
	        onSubmit = _props.onSubmit;
	    var _schedule$data = schedule.data,
	        data = _schedule$data === undefined ? {} : _schedule$data,
	        _schedule$header = schedule.header,
	        header = _schedule$header === undefined ? {} : _schedule$header;
	
	    var SelectField = function SelectField(_ref) {
	      var input = _ref.input,
	          rest = _objectWithoutProperties(_ref, ['input']);
	
	      return _react2.default.createElement(_reactSelect2.default, _extends({}, input, rest, {
	        onBlurResetsInput: false,
	        onSelectResetsInput: false,
	        simpleValue: true,
	        autosize: true,
	        searchable: true
	      }));
	    };
	
	    var InputField = function InputField(_ref2) {
	      var input = _ref2.input,
	          rest = _objectWithoutProperties(_ref2, ['input']);
	
	      return _react2.default.createElement(_reactBootstrap.FormControl, _extends({}, input, rest));
	    };
	
	    function getByLabel(collection, label, defaultVal) {
	      if (!label) return defaultVal;
	      var option = collection.find(function (option) {
	        return option.label === label;
	      });
	      if (!option) return defaultVal;
	      return option.value;
	    }
	
	    var estimated_assets = getByLabel(_assetsAndLiabilities2.default, header && header.estimated_assets, 'Unknown');
	    var estimated_number_of_creditors = getByLabel(_noOfCreditors2.default, data && data.estimated_number_of_creditors, 'Unknown');
	    var describe_debtor_business = getByLabel(_debtorBusiness2.default, data && data.describe_debtor_business, 'None');
	    var estimated_liabilities = getByLabel(_assetsAndLiabilities2.default, header && header.estimated_liabilities, 'Unknown');
	    var naics = header && header.naics ? _industry2.default.filter(function (industryValue) {
	      return industryValue.label.indexOf(header.naics) >= 0;
	    })[0].value : '';
	    var ch11_type = getByLabel(_ch11Type2.default, header && header.ch11_type, '');
	
	    // prettier-ignore
	    var initialData = {
	      estimated_assets: estimated_assets,
	      estimated_liabilities: estimated_liabilities,
	      naics: naics,
	      ch11_type: ch11_type,
	      estimated_number_of_creditors: estimated_number_of_creditors,
	      describe_debtor_business: describe_debtor_business,
	      website: header.website,
	      location_place_of_business_city: data ? data.location_place_of_business_city : '',
	      location_place_of_business_state: data ? data.location_place_of_business_state : '',
	      location_place_of_business_street: data ? data.location_place_of_business_street : '',
	      location_place_of_business_zip_code: data ? data.location_place_of_business_zip_code : '',
	      location_place_of_business_country: data ? data.location_place_of_business_country : '',
	      principal_place_of_business_city: data ? data.principal_place_of_business_city : '',
	      principal_place_of_business_state: data ? data.principal_place_of_business_state : '',
	      principal_place_of_business_street: data ? data.principal_place_of_business_street : '',
	      principal_place_of_business_zip_code: data ? data.principal_place_of_business_zip_code : '',
	      principal_place_of_business_country: data ? data.principal_place_of_business_country : '',
	      debtor_estimate_of_available_funds: data ? data.debtor_estimate_of_available_funds : '',
	      authorized_representative_of_debtor: data ? data.authorized_representative_of_debtor : '',
	      title: data ? data.title : ''
	    };
	
	    return _react2.default.createElement(_reactFinalForm.Form, {
	      initialValues: initialData,
	      onSubmit: onSubmit,
	      render: function render(_ref3) {
	        var handleSubmit = _ref3.handleSubmit,
	            pristine = _ref3.pristine,
	            submitting = _ref3.submitting;
	        return _react2.default.createElement(
	          'form',
	          { onSubmit: handleSubmit, id: 'parser-schedule-petition-form' },
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'ir-search-double' },
	            _react2.default.createElement(
	              'table',
	              { id: 'petition' },
	              _react2.default.createElement(
	                'tbody',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label-petitioner' },
	                        'Principal place of business:'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label-petitioner' },
	                        'Location of principal assets:'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement('td', null)
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'Street'
	                      )
	                    ),
	                    _react2.default.createElement(_reactFinalForm.Field, { name: 'principal_place_of_business_street', component: InputField, placeholder: 'Street' })
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'Street'
	                      )
	                    ),
	                    _react2.default.createElement(_reactFinalForm.Field, { name: 'location_place_of_business_street', component: InputField, placeholder: 'Street' })
	                  ),
	                  _react2.default.createElement('td', null)
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'City'
	                      )
	                    ),
	                    _react2.default.createElement(_reactFinalForm.Field, { name: 'principal_place_of_business_city', component: InputField, placeholder: 'City' })
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'City'
	                      )
	                    ),
	                    _react2.default.createElement(_reactFinalForm.Field, { name: 'location_place_of_business_city', component: InputField, placeholder: 'City' })
	                  ),
	                  _react2.default.createElement('td', null)
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'State'
	                      )
	                    ),
	                    _react2.default.createElement(_reactFinalForm.Field, { name: 'principal_place_of_business_state', component: InputField, placeholder: 'State' })
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'State'
	                      )
	                    ),
	                    _react2.default.createElement(_reactFinalForm.Field, { name: 'location_place_of_business_state', component: InputField, placeholder: 'State' })
	                  ),
	                  _react2.default.createElement('td', null)
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'Zip Code'
	                      )
	                    ),
	                    _react2.default.createElement(_reactFinalForm.Field, {
	                      name: 'principal_place_of_business_zip_code',
	                      component: InputField,
	                      placeholder: 'Zip Code'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'Zip Code'
	                      )
	                    ),
	                    _react2.default.createElement(_reactFinalForm.Field, { name: 'location_place_of_business_zip_code', component: InputField, placeholder: 'Zip Code' })
	                  ),
	                  _react2.default.createElement('td', null)
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'Country'
	                      )
	                    ),
	                    _react2.default.createElement(_reactFinalForm.Field, { name: 'principal_place_of_business_country', component: InputField, placeholder: 'Country' })
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'Country'
	                      )
	                    ),
	                    _react2.default.createElement(_reactFinalForm.Field, { name: 'location_place_of_business_country', component: InputField, placeholder: 'Country' })
	                  ),
	                  _react2.default.createElement('td', null)
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'Describe debtor\u2019s business'
	                      )
	                    ),
	                    _react2.default.createElement(_reactFinalForm.Field, {
	                      name: 'describe_debtor_business',
	                      component: SelectField,
	                      options: _debtorBusiness2.default,
	                      rows: '3',
	                      cols: '33',
	                      placeholder: 'Describe debtor business'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'Authorized representative of debtor'
	                      )
	                    ),
	                    _react2.default.createElement(_reactFinalForm.Field, {
	                      name: 'authorized_representative_of_debtor',
	                      component: InputField,
	                      rows: '3',
	                      cols: '33',
	                      id: 'authorized_representative_of_debtor'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'Title'
	                      )
	                    ),
	                    _react2.default.createElement(_reactFinalForm.Field, { name: 'title', component: InputField, rows: '3', cols: '33', id: 'title' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'Estimated number of creditors'
	                      )
	                    ),
	                    _react2.default.createElement(_reactFinalForm.Field, {
	                      name: 'estimated_number_of_creditors',
	                      component: SelectField,
	                      options: _noOfCreditors2.default,
	                      autosize: true,
	                      placeholder: 'Select number of Creditors'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'Estimated assets'
	                      )
	                    ),
	                    _react2.default.createElement(_reactFinalForm.Field, {
	                      name: 'estimated_assets',
	                      component: SelectField,
	                      options: _assetsAndLiabilities2.default,
	                      autosize: true,
	                      placeholder: 'Select new asset'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'Estimated liabilities'
	                      )
	                    ),
	                    _react2.default.createElement(_reactFinalForm.Field, {
	                      name: 'estimated_liabilities',
	                      component: SelectField,
	                      options: _assetsAndLiabilities2.default,
	                      autosize: true,
	                      placeholder: 'Select new liability'
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    { colSpan: '2' },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'Website'
	                      )
	                    ),
	                    _react2.default.createElement(_reactFinalForm.Field, {
	                      name: 'website',
	                      component: InputField,
	                      type: 'text',
	                      id: 'website',
	                      placeholder: 'Enter new website'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'Chapter 11 Type'
	                      )
	                    ),
	                    _react2.default.createElement(_reactFinalForm.Field, {
	                      name: 'ch11_type',
	                      component: SelectField,
	                      options: _ch11Type2.default,
	                      placeholder: 'Select new chanel 11 type'
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    { colSpan: '3' },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'Naics (4-digit code) '
	                      )
	                    ),
	                    _react2.default.createElement(_reactFinalForm.Field, {
	                      name: 'naics',
	                      component: SelectField,
	                      autosize: true,
	                      options: _industry2.default,
	                      placeholder: 'Select new industry'
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'buttons' },
	              _react2.default.createElement(
	                'button',
	                { type: 'submit', disabled: submitting || pristine, className: 'btn btn-primary' },
	                'Submit Changes'
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  onClick: function onClick() {
	                    if (pristine || confirm('You are about to lose unsaved changes!\nPress "Cancel" to continue editing, "OK" to discard changes!')) _this2.props.onCancel();
	                  },
	                  disabled: submitting,
	                  className: 'btn btn-link ' + (pristine ? '' : 'cancel-link')
	                },
	                pristine ? 'Cancel Editing' : 'Discard Changes'
	              )
	            )
	          )
	        );
	      }
	    });
	  };
	
	  return PetitionForm;
	}(_react.Component);
	
	PetitionForm.propTypes = {
	  schedule: _propTypes2.default.any.isRequired,
	  onSubmit: _propTypes2.default.func,
	  toggleFilterSection: _propTypes2.default.func,
	  loadingSpinner: _propTypes2.default.bool,
	  showFilterSection: _propTypes2.default.bool
	};
	PetitionForm.defaultProps = {
	  onSubmit: function onSubmit() {
	    return null;
	  },
	  toggleFilterSection: function toggleFilterSection() {
	    return null;
	  },
	  loadingSpinner: false,
	  showFilterSection: true
	};
	exports.default = PetitionForm;

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ScheduleABForm = __webpack_require__(733);
	
	var _ScheduleABForm2 = _interopRequireDefault(_ScheduleABForm);
	
	__webpack_require__(948);
	
	var _MoneyFormat = __webpack_require__(273);
	
	var _MoneyFormat2 = _interopRequireDefault(_MoneyFormat);
	
	var _EditCopyPasteSchedule = __webpack_require__(208);
	
	var _EditCopyPasteSchedule2 = _interopRequireDefault(_EditCopyPasteSchedule);
	
	var _ScheduleVeriyToolbar = __webpack_require__(179);
	
	var _ScheduleVeriyToolbar2 = _interopRequireDefault(_ScheduleVeriyToolbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BLANK_FORM_DATA = {
	  acct_rcpt: 0,
	  cash: 0,
	  deposits: 0,
	  farming: 0,
	  intangibles: 0,
	  inventory: 0,
	  investments: 0,
	  machinery: 0,
	  office: 0,
	  others: 0,
	  property: 0
	};
	
	var ScheduleAB = function (_Component) {
	  _inherits(ScheduleAB, _Component);
	
	  function ScheduleAB() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ScheduleAB);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getScheduleABdata = function (data) {
	      var rows = _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'tbody',
	          null,
	          _react2.default.createElement(
	            'tr',
	            { className: 'odd' },
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Cash, cash equivalents, and financial assets.'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'schedule-tips' },
	                'Copy line 5, Part 1'
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'money', id: 'cash' },
	              (0, _MoneyFormat2.default)(data.cash)
	            ),
	            _react2.default.createElement('td', null)
	          ),
	          _react2.default.createElement(
	            'tr',
	            { className: 'even' },
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Deposits and prepayments.'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'schedule-tips' },
	                'Copy line 9, Part 2'
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'money', id: 'deposits' },
	              (0, _MoneyFormat2.default)(data.deposits)
	            ),
	            _react2.default.createElement('td', null)
	          ),
	          _react2.default.createElement(
	            'tr',
	            { className: 'odd' },
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Accounts receivable.'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'schedule-tips' },
	                'Copy line 12, Part 3'
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'money', id: 'acct-rcpt' },
	              (0, _MoneyFormat2.default)(data.acct_rcpt)
	            ),
	            _react2.default.createElement('td', null)
	          ),
	          _react2.default.createElement(
	            'tr',
	            { className: 'even' },
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Investments.'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'schedule-tips' },
	                'Copy line 17, Part 4'
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'money', id: 'investments' },
	              (0, _MoneyFormat2.default)(data.investments)
	            ),
	            _react2.default.createElement('td', null)
	          ),
	          _react2.default.createElement(
	            'tr',
	            { className: 'odd' },
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Inventory.'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'schedule-tips' },
	                'Copy line 23, Part 5'
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'money', id: 'inventory' },
	              (0, _MoneyFormat2.default)(data.inventory)
	            ),
	            _react2.default.createElement('td', null)
	          ),
	          _react2.default.createElement(
	            'tr',
	            { className: 'even' },
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Farming and fishing-related assets.'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'schedule-tips' },
	                'Copy line 33, Part 6'
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'money', id: 'farming' },
	              (0, _MoneyFormat2.default)(data.farming)
	            ),
	            _react2.default.createElement('td', null)
	          ),
	          _react2.default.createElement(
	            'tr',
	            { className: 'odd' },
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Office furniture, fixtures, and equipment; and collectibles.'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'schedule-tips' },
	                'Copy line 43, Part 7'
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'money', id: 'office' },
	              (0, _MoneyFormat2.default)(data.office)
	            ),
	            _react2.default.createElement('td', null)
	          ),
	          _react2.default.createElement(
	            'tr',
	            { className: 'even' },
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Machinery, equipment, and vehicles.'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'schedule-tips' },
	                'Copy line 51, Part 8'
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'money', id: 'machinery' },
	              (0, _MoneyFormat2.default)(data.machinery)
	            ),
	            _react2.default.createElement('td', null)
	          ),
	          _react2.default.createElement(
	            'tr',
	            { className: 'odd' },
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Real Property.'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'schedule-tips' },
	                'Copy line 56, Part 9'
	              )
	            ),
	            _react2.default.createElement('td', null),
	            _react2.default.createElement(
	              'td',
	              { className: 'money', id: 'property' },
	              (0, _MoneyFormat2.default)(data.property)
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { className: 'even' },
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Intangibles and intellectual property.'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'schedule-tips' },
	                'Copy line 66, Part 10'
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'money', id: 'intangibles' },
	              (0, _MoneyFormat2.default)(data.intangibles)
	            ),
	            _react2.default.createElement('td', null)
	          ),
	          _react2.default.createElement(
	            'tr',
	            { className: 'odd' },
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'All other assets.'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'schedule-tips' },
	                'Copy line 78, Part 11'
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'money', id: 'others' },
	              (0, _MoneyFormat2.default)(data.others)
	            ),
	            _react2.default.createElement('td', null)
	          )
	        ),
	        _react2.default.createElement(
	          'tfoot',
	          null,
	          _react2.default.createElement(
	            'tr',
	            { className: 'even' },
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Total'
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'money subtotal', id: 'personal' },
	              (0, _MoneyFormat2.default)(data.personal_total || 0)
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'money subtotal', id: 'real' },
	              (0, _MoneyFormat2.default)(data.real_total || 0)
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { className: 'odd' },
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Total of all property on Schedule A/B.'
	              )
	            ),
	            _react2.default.createElement('td', null),
	            _react2.default.createElement(
	              'td',
	              { className: 'money total', id: 'total' },
	              (0, _MoneyFormat2.default)(data.total || 0)
	            )
	          )
	        )
	      );
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'table',
	          { className: 'sticky-enabled tablesorter' },
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                null,
	                'Type of property'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Current value of personal\xA0property'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Current value of real\xA0property'
	              )
	            )
	          ),
	          rows
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ScheduleAB.prototype.render = function render() {
	    var _props = this.props,
	        type = _props.type,
	        schedule = _props.schedule,
	        editScheduleForm = _props.editScheduleForm,
	        canEdit = _props.canEdit,
	        can_see_details = _props.can_see_details,
	        onCancel = _props.onCancel,
	        onSubmit = _props.onSubmit,
	        onPastedData = _props.onPastedData,
	        toggleScheduleForm = _props.toggleScheduleForm;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: type },
	      can_see_details && _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { id: 'schedule-ab' },
	          _react2.default.createElement(
	            'div',
	            { id: 'ir-search-schedule-ab-results' },
	            editScheduleForm ? _react2.default.createElement(_ScheduleABForm2.default, _extends({}, this.props, {
	              // editScheduleForm could be a draft object
	              schedule: editScheduleForm === true ? schedule.data ? schedule : { data: BLANK_FORM_DATA } : editScheduleForm,
	              isDraft: editScheduleForm !== true,
	              onCancel: onCancel,
	              onSubmit: onSubmit
	            })) : _react2.default.createElement(
	              _react2.default.Fragment,
	              null,
	              canEdit && _react2.default.createElement(_ScheduleVeriyToolbar2.default, { schedule: schedule }),
	              canEdit && _react2.default.createElement(_EditCopyPasteSchedule2.default, {
	                schedule: schedule.data ? schedule : { schedule_type: 'ab', data: {} },
	                onPastedData: onPastedData,
	                toggleScheduleForm: toggleScheduleForm
	              }),
	              this.getScheduleABdata(schedule.data || {})
	            ),
	            canEdit && !editScheduleForm && _react2.default.createElement(
	              'div',
	              { className: 'editable' },
	              _react2.default.createElement(
	                'btn',
	                { className: 'btn btn-primary', onClick: toggleScheduleForm },
	                'Edit'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return ScheduleAB;
	}(_react.Component);
	
	ScheduleAB.defaultProps = {
	  type: 'schedule_ab',
	  viewFilters: {},
	  keyword: '',
	  value_from: '',
	  value_to: ''
	};
	
	ScheduleAB.propTypes = {
	  schedule: _propTypes2.default.any.isRequired,
	  type: _propTypes2.default.string,
	  viewFilters: _propTypes2.default.object,
	  keyword: _propTypes2.default.string,
	  value_to: _propTypes2.default.string,
	  value_from: _propTypes2.default.string,
	  editScheduleForm: _propTypes2.default.bool.isRequired,
	  canEdit: _propTypes2.default.bool.isRequired,
	  can_see_details: _propTypes2.default.bool.isRequired,
	  onCancel: _propTypes2.default.func.isRequired,
	  onSubmit: _propTypes2.default.func.isRequired,
	  toggleScheduleForm: _propTypes2.default.func.isRequired
	};
	
	exports.default = ScheduleAB;

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _finalFormCalculate = __webpack_require__(840);
	
	var _finalFormCalculate2 = _interopRequireDefault(_finalFormCalculate);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _currencyConversion = __webpack_require__(72);
	
	var _currencyConversion2 = _interopRequireDefault(_currencyConversion);
	
	__webpack_require__(948);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var MoneyField = function MoneyField(_ref) {
	  var input = _ref.input,
	      rest = _objectWithoutProperties(_ref, ['input']);
	
	  return _react2.default.createElement(
	    _reactBootstrap.InputGroup,
	    null,
	    _react2.default.createElement(
	      _reactBootstrap.InputGroup.Addon,
	      null,
	      '$'
	    ),
	    _react2.default.createElement(_reactBootstrap.FormControl, _extends({ bsSize: 'small', type: 'text' }, input, rest))
	  );
	};
	
	var ScheduleABForm = function (_Component) {
	  _inherits(ScheduleABForm, _Component);
	
	  function ScheduleABForm() {
	    _classCallCheck(this, ScheduleABForm);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ScheduleABForm.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        onSubmit = _props.onSubmit,
	        data = _props.schedule.data;
	
	    var calculator = (0, _finalFormCalculate2.default)({
	      field: ['cash', 'deposits', 'acct_rcpt', 'investments', 'inventory', 'farming', 'office', 'machinery', 'intangibles', 'others'],
	      updates: {
	        personal_total: function personal_total(fieldValue, allValues) {
	          return _currencyConversion2.default.toDollars(_currencyConversion2.default.toCents(allValues.cash) + _currencyConversion2.default.toCents(allValues.deposits) + _currencyConversion2.default.toCents(allValues.acct_rcpt) + _currencyConversion2.default.toCents(allValues.investments) + _currencyConversion2.default.toCents(allValues.inventory) + _currencyConversion2.default.toCents(allValues.farming) + _currencyConversion2.default.toCents(allValues.office) + _currencyConversion2.default.toCents(allValues.machinery) + _currencyConversion2.default.toCents(allValues.intangibles) + _currencyConversion2.default.toCents(allValues.others));
	        }
	      }
	    }, {
	      field: 'property',
	      updates: {
	        real_total: function real_total(property) {
	          return _currencyConversion2.default.toDollars(_currencyConversion2.default.toCents(property));
	        }
	      }
	    }, {
	      field: ['personal_total', 'real_total'],
	      updates: {
	        total: function total(ignoredValue, allValues) {
	          return _currencyConversion2.default.toDollars(_currencyConversion2.default.toCents(allValues.personal_total) + _currencyConversion2.default.toCents(allValues.real_total));
	        }
	      }
	    });
	
	    var field_format = function field_format(value) {
	      return '$' + (value || 0).toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,');
	    };
	    var initialData = {
	      acct_rcpt: _currencyConversion2.default.toDollarsOrStr(data.acct_rcpt),
	      cash: _currencyConversion2.default.toDollarsOrStr(data.cash),
	      deposits: _currencyConversion2.default.toDollarsOrStr(data.deposits),
	      farming: _currencyConversion2.default.toDollarsOrStr(data.farming),
	      intangibles: _currencyConversion2.default.toDollarsOrStr(data.intangibles),
	      inventory: _currencyConversion2.default.toDollarsOrStr(data.inventory),
	      investments: _currencyConversion2.default.toDollarsOrStr(data.investments),
	      machinery: _currencyConversion2.default.toDollarsOrStr(data.machinery),
	      office: _currencyConversion2.default.toDollarsOrStr(data.office),
	      others: _currencyConversion2.default.toDollarsOrStr(data.others),
	      personal_total: _currencyConversion2.default.toDollarsOrStr(data.personal_total),
	      property: _currencyConversion2.default.toDollarsOrStr(data.property),
	      real_total: _currencyConversion2.default.toDollarsOrStr(data.real_total),
	      total: _currencyConversion2.default.toDollarsOrStr(data.total)
	    };
	
	    return _react2.default.createElement(_reactFinalForm.Form, {
	      initialValues: initialData,
	      onSubmit: onSubmit,
	      decorators: [calculator],
	      render: function render(_ref2) {
	        var handleSubmit = _ref2.handleSubmit,
	            submitting = _ref2.submitting,
	            pristine = _ref2.pristine;
	        return _react2.default.createElement(
	          'form',
	          { onSubmit: handleSubmit, id: 'parser-schedule-ab-form' },
	          _react2.default.createElement(
	            'table',
	            { className: 'sticky-enabled tablesorter' },
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Type of property'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Current value of personal\xA0property'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Current value of real\xA0property'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              _react2.default.createElement(
	                'tr',
	                { className: 'odd' },
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'cash' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'Cash, cash equivalents, and financial assets.'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'schedule-tips' },
	                      'Copy line 5, Part 1'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'money' },
	                  _react2.default.createElement(_reactFinalForm.Field, { name: 'cash', component: MoneyField, id: 'cash', size: 20 })
	                ),
	                _react2.default.createElement('td', null)
	              ),
	              _react2.default.createElement(
	                'tr',
	                { className: 'even' },
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'deposits' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'Deposits and prepayments.'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'schedule-tips' },
	                      'Copy line 9, Part 2'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'money' },
	                  _react2.default.createElement(_reactFinalForm.Field, { name: 'deposits', component: MoneyField, id: 'deposits', size: 20 })
	                ),
	                _react2.default.createElement('td', null)
	              ),
	              _react2.default.createElement(
	                'tr',
	                { className: 'odd' },
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'acct-rcpt' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'Accounts receivable'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'schedule-tips' },
	                      'Copy line 12, Part 3'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'money' },
	                  _react2.default.createElement(_reactFinalForm.Field, { name: 'acct_rcpt', component: MoneyField, id: 'acct-rcpt', size: 20 })
	                ),
	                _react2.default.createElement('td', null)
	              ),
	              _react2.default.createElement(
	                'tr',
	                { className: 'even' },
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'investments' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'Investments.'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'schedule-tips' },
	                      'Copy line 17, Part 4'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'money' },
	                  _react2.default.createElement(_reactFinalForm.Field, { name: 'investments', component: MoneyField, id: 'investments', size: 20 })
	                ),
	                _react2.default.createElement('td', null)
	              ),
	              _react2.default.createElement(
	                'tr',
	                { className: 'odd' },
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'inventory' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'Inventory.'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'schedule-tips' },
	                      'Copy line 23, Part 5'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'money' },
	                  _react2.default.createElement(_reactFinalForm.Field, { name: 'inventory', component: MoneyField, id: 'inventory', size: 20 })
	                ),
	                _react2.default.createElement('td', null)
	              ),
	              _react2.default.createElement(
	                'tr',
	                { className: 'even' },
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'farming' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'Farming and fishing-related assets.'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'schedule-tips' },
	                      'Copy line 33, Part 6'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'money' },
	                  _react2.default.createElement(_reactFinalForm.Field, { name: 'farming', component: MoneyField, id: 'farming', size: 20 })
	                ),
	                _react2.default.createElement('td', null)
	              ),
	              _react2.default.createElement(
	                'tr',
	                { className: 'odd' },
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'office' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'Office furniture, fixtures, and equipment; and collectibles.'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'schedule-tips' },
	                      'Copy line 43, Part 7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'money' },
	                  _react2.default.createElement(_reactFinalForm.Field, { name: 'office', component: MoneyField, id: 'office', size: 20 })
	                ),
	                _react2.default.createElement('td', null)
	              ),
	              _react2.default.createElement(
	                'tr',
	                { className: 'even' },
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'machinery' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'Machinery, equipment, and vehicles.'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'schedule-tips' },
	                      'Copy line 51, Part 8'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'money' },
	                  _react2.default.createElement(_reactFinalForm.Field, { name: 'machinery', component: MoneyField, id: 'machinery', size: 20 })
	                ),
	                _react2.default.createElement('td', null)
	              ),
	              _react2.default.createElement(
	                'tr',
	                { className: 'odd' },
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'property' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'Real Property.'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'schedule-tips' },
	                      'Copy line 56, Part 9'
	                    )
	                  )
	                ),
	                _react2.default.createElement('td', null),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'money' },
	                  _react2.default.createElement(_reactFinalForm.Field, { name: 'property', component: MoneyField, id: 'property', size: 20 })
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                { className: 'even' },
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'intangibles' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'Intangibles and intellectual property.'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'schedule-tips' },
	                      'Copy line 66, Part 10'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'money' },
	                  _react2.default.createElement(_reactFinalForm.Field, { name: 'intangibles', component: MoneyField, id: 'intangibles', size: 20 })
	                ),
	                _react2.default.createElement('td', null)
	              ),
	              _react2.default.createElement(
	                'tr',
	                { className: 'odd' },
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'others' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'All other assets.'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'schedule-tips' },
	                      'Copy line 78, Part 11'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'money' },
	                  _react2.default.createElement(_reactFinalForm.Field, { name: 'others', component: MoneyField, id: 'others', size: 20 })
	                ),
	                _react2.default.createElement('td', null)
	              )
	            ),
	            _react2.default.createElement(
	              'tfoot',
	              null,
	              _react2.default.createElement(
	                'tr',
	                { className: 'even' },
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'label' },
	                    'Total'
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'money subtotal', id: 'personal' },
	                  _react2.default.createElement(_reactFinalForm.Field, {
	                    name: 'personal_total',
	                    component: MoneyField,
	                    format: function format(value) {
	                      return field_format(value);
	                    },
	                    id: 'totals',
	                    type: 'text',
	                    disabled: true
	                  })
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'money subtotal', id: 'real' },
	                  _react2.default.createElement(_reactFinalForm.Field, {
	                    name: 'real_total',
	                    component: MoneyField,
	                    format: function format(value) {
	                      return field_format(value);
	                    },
	                    id: 'totals',
	                    type: 'text',
	                    disabled: true
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                { className: 'odd' },
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'label' },
	                    'Total of all property on Schedule A/B.'
	                  )
	                ),
	                _react2.default.createElement('td', null),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'money total', id: 'total' },
	                  _react2.default.createElement(_reactFinalForm.Field, {
	                    name: 'total',
	                    component: MoneyField,
	                    format: function format(value) {
	                      return field_format(value);
	                    },
	                    id: 'totals',
	                    type: 'text',
	                    disabled: true
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'submit',
	              value: 'Submit',
	              className: 'form-submit',
	              disabled: submitting || pristine && !_this2.props.isDraft
	            },
	            'Save'
	          ),
	          _react2.default.createElement(
	            'a',
	            { id: 'alfresco-clear', className: 'cancel-link', onClick: _this2.props.onCancel },
	            'Cancel'
	          ),
	          _react2.default.createElement('div', { id: 'schedule-ab-validation-messages', className: 'warning', style: { display: 'none' } })
	        );
	      }
	    });
	  };
	
	  return ScheduleABForm;
	}(_react.Component);
	
	ScheduleABForm.propTypes = {
	  onSubmit: _propTypes2.default.func,
	  schedule: _propTypes2.default.any.isRequired,
	  isDraft: _propTypes2.default.bool
	};
	ScheduleABForm.defaultProps = {
	  onSubmit: function onSubmit() {
	    return null;
	  }
	};
	exports.default = ScheduleABForm;

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _ScheduleFilters = __webpack_require__(274);
	
	var _ScheduleFilters2 = _interopRequireDefault(_ScheduleFilters);
	
	var _ScheduleDForm = __webpack_require__(736);
	
	var _ScheduleDForm2 = _interopRequireDefault(_ScheduleDForm);
	
	__webpack_require__(949);
	
	var _MoneyFormat = __webpack_require__(273);
	
	var _MoneyFormat2 = _interopRequireDefault(_MoneyFormat);
	
	var _currencyConversion = __webpack_require__(72);
	
	var _currencyConversion2 = _interopRequireDefault(_currencyConversion);
	
	var _EditCopyPasteSchedule = __webpack_require__(208);
	
	var _EditCopyPasteSchedule2 = _interopRequireDefault(_EditCopyPasteSchedule);
	
	var _ScheduleVeriyToolbar = __webpack_require__(179);
	
	var _ScheduleVeriyToolbar2 = _interopRequireDefault(_ScheduleVeriyToolbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getScheduleDdata = function getScheduleDdata(_ref) {
	  var data = _ref.data,
	      viewFilters = _ref.viewFilters;
	  var _data$creditors = data.creditors,
	      creditors = _data$creditors === undefined ? [] : _data$creditors,
	      _data$total_claims_am = data.total_claims_amount_cents,
	      total_claims_amount_cents = _data$total_claims_am === undefined ? 0 : _data$total_claims_am;
	  var _viewFilters$value_fr = viewFilters.value_from,
	      value_from = _viewFilters$value_fr === undefined ? '' : _viewFilters$value_fr,
	      _viewFilters$value_to = viewFilters.value_to,
	      value_to = _viewFilters$value_to === undefined ? '' : _viewFilters$value_to,
	      _viewFilters$keyword = viewFilters.keyword,
	      keyword = _viewFilters$keyword === undefined ? '' : _viewFilters$keyword;
	
	  var searchWords = keyword.toLowerCase().split(' ').filter(function (p) {
	    return p !== '';
	  }).reverse();
	  var inRange = function inRange(value) {
	    return (value_from ? _currencyConversion2.default.toDollars(value) >= value_from : true) && (value_to ? _currencyConversion2.default.toDollars(value) <= value_to : true);
	  };
	  var filteredCreditors = creditors.map(function (creditor) {
	    var text = Object.values(creditor).join(' ').toLowerCase();
	    var visible = (_lodash2.default.isEmpty(searchWords) || _lodash2.default.every(searchWords, function (word) {
	      return text.indexOf(word) > -1;
	    })) && (inRange(creditor.claim_amount_cents) || inRange(creditor.collateral_amount_cents));
	    return _extends({}, creditor, {
	      visible: visible
	    });
	  });
	  var hasFilteredCreditors = filteredCreditors.filter(function (_ref2) {
	    var visible = _ref2.visible;
	    return visible;
	  }).length > 0;
	  if (!hasFilteredCreditors) {
	    return _react2.default.createElement(
	      _reactBootstrap.Well,
	      { bsSize: 'small' },
	      'No results for searched term, try to search something different.'
	    );
	  }
	  return _react2.default.createElement(
	    'table',
	    { id: 'secured-creditors' },
	    _react2.default.createElement(
	      'thead',
	      null,
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'th',
	          null,
	          'Creditors Who Have Secured Claims'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'tbody',
	      null,
	      filteredCreditors.map(function (item, key) {
	        return _react2.default.createElement(
	          'tr',
	          { key: key, style: { display: item.visible ? 'table-row' : 'none' } },
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              'table',
	              null,
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    { colSpan: '2' },
	                    '2.',
	                    key + 1
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'total-claim' },
	                    _react2.default.createElement(
	                      'label',
	                      { htmlFor: '' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'Amount of claim'
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'schedule-tips' },
	                        'Do not deduct the value of collateral.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'collateral-value' },
	                    _react2.default.createElement(
	                      'label',
	                      { htmlFor: '' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'Value of collateral that supports this claim'
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tbody',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { htmlFor: '' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'Creditor\'s name'
	                      )
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                      'span',
	                      { id: 'address' },
	                      item.creditor_name
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { htmlFor: '' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'Describe debtor\u2019s property that is subject to a lien'
	                      )
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                      'span',
	                      { id: 'property', style: { whiteSpace: 'pre-wrap' } },
	                      item.property_description
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'money' },
	                    _react2.default.createElement(
	                      'span',
	                      { id: 'claim-amount' },
	                      (0, _MoneyFormat2.default)(item.claim_amount_cents)
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'money' },
	                    _react2.default.createElement(
	                      'span',
	                      { id: 'collateral-value' },
	                      (0, _MoneyFormat2.default)(item.collateral_amount_cents)
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { htmlFor: '' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'Creditor\'s mailing address'
	                      )
	                    ),
	                    _react2.default.createElement('br', null),
	                    item.creditor_address_street,
	                    _react2.default.createElement('br', null),
	                    item.creditor_address_city,
	                    ' ',
	                    item.creditor_address_state,
	                    ' ',
	                    item.creditor_address_zip_code,
	                    _react2.default.createElement('br', null),
	                    item.creditor_address_country
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { htmlFor: '' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'Describe the lien'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { style: { whiteSpace: 'pre-wrap' } },
	                      item.lien_description || ''
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { htmlFor: '' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'Creditor\'s email address, if known'
	                      )
	                    ),
	                    _react2.default.createElement('br', null),
	                    item.creditor_email || ''
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { htmlFor: '' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'Is creditor an insider or related party?'
	                      )
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                      _reactBootstrap.Radio,
	                      {
	                        name: 'is_creditor_an_insider' + key,
	                        checked: item.is_creditor_an_insider === false,
	                        readOnly: true
	                      },
	                      'No'
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Radio,
	                      { name: 'is_creditor_an_insider' + key, checked: item.is_creditor_an_insider, readOnly: true },
	                      'Yes'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { htmlFor: '' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'Date debt was incurred'
	                      )
	                    ),
	                    _react2.default.createElement('br', null),
	                    item.debt_date || ''
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { rowSpan: '2', colSpan: 2 },
	                    _react2.default.createElement(
	                      'label',
	                      { htmlFor: '' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'Is anyone else liable on this claim?'
	                      )
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                      _reactBootstrap.Radio,
	                      {
	                        name: 'is_anyone_else_liable' + key,
	                        checked: item.is_anyone_else_liable === false,
	                        readOnly: true
	                      },
	                      'No'
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Radio,
	                      { name: 'is_anyone_else_liable' + key, checked: item.is_anyone_else_liable, readOnly: true },
	                      'Yes.',
	                      ' ',
	                      _react2.default.createElement(
	                        'small',
	                        null,
	                        'Fill out ',
	                        _react2.default.createElement(
	                          'em',
	                          null,
	                          'Schedule H: Codebtors'
	                        ),
	                        ' (Official Form 206H).'
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { htmlFor: '' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'Last 4 digits of account number'
	                      )
	                    ),
	                    _react2.default.createElement('br', null),
	                    item.account_number_last_4_digits || ''
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { htmlFor: '' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'Do multiple creditors have an interest in the same property?'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Radio,
	                      {
	                        name: 'has_multiple_creditor_interest' + key,
	                        checked: !item.has_multiple_creditor_interest,
	                        readOnly: true
	                      },
	                      'No'
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Radio,
	                      {
	                        name: 'has_multiple_creditor_interest' + key,
	                        checked: item.has_multiple_creditor_interest,
	                        readOnly: true
	                      },
	                      'Yes'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      {
	                        className: 'is-multiple-creditors-interested-yes',
	                        style: { display: item.has_multiple_creditor_interest ? 'inherit' : 'none' }
	                      },
	                      key === 0 ? _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'creditor-priority' },
	                          'Specify each creditor, including this creditor, and its relative priority'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { style: { whiteSpace: 'pre-wrap' } },
	                          item.creditor_priority
	                        )
	                      ) : _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'has-specified-creditor-priority' },
	                          'Have you already specified the relative priority?'
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Radio,
	                          {
	                            name: 'has-specified-creditor-priority' + key,
	                            checked: !item.has_already_specified_creditor_priority,
	                            readOnly: true
	                          },
	                          'No'
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Radio,
	                          {
	                            name: 'has-specified-creditor-priority' + key,
	                            checked: item.has_already_specified_creditor_priority,
	                            readOnly: true
	                          },
	                          'Yes'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          {
	                            className: 'has-specified-creditor-priority-no',
	                            style: { display: !item.has_already_specified_creditor_priority ? 'inherit' : 'none' }
	                          },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'creditor-priority' },
	                            'Specify each creditor, including this creditor, and its relative priority'
	                          ),
	                          item.creditor_priority
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          {
	                            className: 'has-specified-creditor-priority-yes',
	                            style: { display: item.has_already_specified_creditor_priority ? 'inherit' : 'none' }
	                          },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'creditor-priority' },
	                            'The relative priority of creditors is specified on lines'
	                          ),
	                          _react2.default.createElement('br', null),
	                          item.creditor_priority_specified_on_line
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { htmlFor: '' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'As of the petition filing date, the claim is:'
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'schedule-tips' },
	                        'Check all that apply.'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Checkbox,
	                      { name: 'is_contingent', checked: item.is_contingent, readOnly: true },
	                      'Contingent'
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Checkbox,
	                      { name: 'claim_type', checked: item.is_unliquidated, readOnly: true },
	                      'Unliquidated'
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Checkbox,
	                      { name: 'claim_type', checked: item.is_disputed, readOnly: true },
	                      'Disputed'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        );
	      })
	    ),
	    _react2.default.createElement(
	      'tfoot',
	      null,
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'table',
	            null,
	            _react2.default.createElement(
	              'tbody',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'label' },
	                    'Total of the dollar amounts from Part 1, Column A, including the amounts from the Additional Page, if any.'
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'money total' },
	                  _react2.default.createElement(
	                    'span',
	                    { id: 'total-claim' },
	                    (0, _MoneyFormat2.default)(total_claims_amount_cents)
	                  )
	                ),
	                _react2.default.createElement('td', { className: 'money' })
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	function ScheduleD(props) {
	  var _useState = (0, _react.useState)({}),
	      viewFilters = _useState[0],
	      setViewFilters = _useState[1];
	
	  var scheduleFiltersProps = {
	    viewFilters: viewFilters,
	    setViewFilters: setViewFilters
	  };
	
	  var type = props.type,
	      schedule = props.schedule,
	      editScheduleForm = props.editScheduleForm,
	      canEdit = props.canEdit,
	      can_see_details = props.can_see_details,
	      onSubmit = props.onSubmit,
	      toggleScheduleForm = props.toggleScheduleForm,
	      onPastedData = props.onPastedData;
	
	
	  var tableData = schedule.data || {};
	  var noDataFound = schedule.data === null ? 'There is no Schedule D for this case.' : schedule.empty || null;
	
	  if (noDataFound && !editScheduleForm) {
	    return _react2.default.createElement(
	      'div',
	      { id: 'ir-search-schedule-d-results' },
	      _react2.default.createElement(
	        _reactBootstrap.Well,
	        { bsSize: 'small' },
	        noDataFound
	      ),
	      canEdit && _react2.default.createElement(_ScheduleVeriyToolbar2.default, { schedule: schedule }),
	      canEdit && _react2.default.createElement(_EditCopyPasteSchedule2.default, {
	        schedule: { schedule_type: 'd' },
	        onPastedData: onPastedData,
	        toggleScheduleForm: toggleScheduleForm
	      })
	    );
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: type },
	    can_see_details && _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        'div',
	        { id: 'schedule-d' },
	        _react2.default.createElement(
	          'div',
	          { id: 'ir-search-schedule-d-results' },
	          editScheduleForm ? _react2.default.createElement(_ScheduleDForm2.default, _extends({}, props, {
	            // editScheduleForm could be a draft object
	            schedule: editScheduleForm === true ? schedule : editScheduleForm,
	            isDraft: editScheduleForm !== true,
	            onSubmit: onSubmit,
	            onCancel: toggleScheduleForm
	          })) : _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(_ScheduleFilters2.default, scheduleFiltersProps),
	            canEdit && _react2.default.createElement(_ScheduleVeriyToolbar2.default, { schedule: schedule }),
	            canEdit && _react2.default.createElement(_EditCopyPasteSchedule2.default, {
	              onPastedData: onPastedData,
	              schedule: schedule,
	              toggleScheduleForm: toggleScheduleForm
	            }),
	            getScheduleDdata({ data: tableData, viewFilters: viewFilters })
	          ),
	          canEdit && !editScheduleForm && _react2.default.createElement(
	            'div',
	            { className: 'editable' },
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary', onClick: toggleScheduleForm },
	              'Edit'
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	ScheduleD.defaultProps = {
	  type: 'schedule_d',
	  scheduleFiltersProps: {},
	  viewFilters: {},
	  keyword: '',
	  value_from: '',
	  value_to: ''
	};
	
	ScheduleD.propTypes = {
	  schedule: _propTypes2.default.any.isRequired,
	  type: _propTypes2.default.string,
	  scheduleFiltersProps: _propTypes2.default.object,
	  viewFilters: _propTypes2.default.object,
	  keyword: _propTypes2.default.string,
	  value_to: _propTypes2.default.string,
	  value_from: _propTypes2.default.string,
	  editScheduleForm: _propTypes2.default.bool.isRequired,
	  canEdit: _propTypes2.default.bool.isRequired,
	  can_see_details: _propTypes2.default.bool.isRequired,
	  onSubmit: _propTypes2.default.func.isRequired,
	  toggleScheduleForm: _propTypes2.default.func.isRequired
	};
	
	exports.default = ScheduleD;

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactBootstrap = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var InputField = function InputField(_ref) {
	  var input = _ref.input,
	      rest = _objectWithoutProperties(_ref, ['input']);
	
	  return _react2.default.createElement(_reactBootstrap.FormControl, _extends({}, input, rest));
	};
	
	var MoneyField = function MoneyField(_ref2) {
	  var input = _ref2.input,
	      rest = _objectWithoutProperties(_ref2, ['input']);
	
	  return _react2.default.createElement(
	    _reactBootstrap.InputGroup,
	    null,
	    _react2.default.createElement(
	      _reactBootstrap.InputGroup.Addon,
	      null,
	      '$'
	    ),
	    _react2.default.createElement(_reactBootstrap.FormControl, _extends({ bsSize: 'small', type: 'text' }, input, rest))
	  );
	};
	
	var CheckboxField = function CheckboxField(_ref3) {
	  var input = _ref3.input,
	      rest = _objectWithoutProperties(_ref3, ['input']);
	
	  return _react2.default.createElement(
	    _reactBootstrap.Checkbox,
	    _extends({}, input, rest),
	    rest.title
	  );
	};
	
	function ScheduleDCreditorFields(_ref4) {
	  var creditor = _ref4.creditor,
	      index = _ref4.index,
	      onRemove = _ref4.onRemove,
	      onMoveDown = _ref4.onMoveDown,
	      onMoveUp = _ref4.onMoveUp,
	      onAdd = _ref4.onAdd;
	
	  // Subscribe to changes to creditor value
	  // This is used to show/hide extra fields based on answers to some yes/no questions
	  var _useField = (0, _reactFinalForm.useField)(creditor),
	      creditorValue = _useField.input.value;
	
	  return _react2.default.createElement(
	    'table',
	    null,
	    _react2.default.createElement(
	      'thead',
	      null,
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          { colSpan: '2' },
	          '2.',
	          index + 1,
	          '.',
	          ' ',
	          onAdd && _react2.default.createElement(
	            'div',
	            { className: 'btn btn-success btn-sm', onClick: onAdd, title: 'Insert new creditor' },
	            '+'
	          ),
	          onMoveUp && _react2.default.createElement(
	            'div',
	            { className: 'btn btn-primary btn-sm', onClick: onMoveUp, title: 'Swap this creditor with 2.' + index },
	            '\u25B2'
	          ),
	          onMoveDown && _react2.default.createElement(
	            'div',
	            {
	              className: 'btn btn-primary btn-sm',
	              onClick: onMoveDown,
	              title: 'Swap this creditor with 2.' + (index + 2)
	            },
	            '\u25BC'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'btn btn-danger btn-sm', onClick: onRemove, title: 'Remove creditor' },
	            'X'
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'claim-amount' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: '' },
	            _react2.default.createElement(
	              'span',
	              { className: 'label' },
	              'Amount of claim'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'schedule-tips' },
	              'Do not deduct the value of collateral.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'collateral-value' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: '' },
	            _react2.default.createElement(
	              'span',
	              { className: 'label' },
	              'Value of collateral that supports this claim'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'tbody',
	      null,
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'label' },
	              'Creditor\'s name'
	            )
	          ),
	          _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.creditor_name', component: InputField, type: 'text', size: 'lg', placeholder: '' })
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'label' },
	              'Describe debtor\u2019s property that is subject to a lien'
	            )
	          ),
	          _react2.default.createElement(_reactFinalForm.Field, {
	            name: creditor + '.property_description',
	            component: InputField,
	            componentClass: 'textarea',
	            rows: '3',
	            cols: '30',
	            id: 'property_description-' + index
	          })
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'money' },
	          _react2.default.createElement(_reactFinalForm.Field, {
	            name: creditor + '.claim_amount_cents',
	            component: MoneyField,
	            id: 'claim-amount-' + index,
	            size: 10
	          })
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'money' },
	          _react2.default.createElement(_reactFinalForm.Field, {
	            name: creditor + '.collateral_amount_cents',
	            component: MoneyField,
	            id: 'collateral_amount_cents-' + index,
	            size: 10
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'label' },
	              'Creditor\'s mailing address'
	            )
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'label' },
	              'Street'
	            )
	          ),
	          _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.creditor_address_street', component: InputField, placeholder: 'Street' }),
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'label' },
	              'City'
	            )
	          ),
	          _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.creditor_address_city', component: InputField, placeholder: 'City' }),
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'label' },
	              'State'
	            )
	          ),
	          _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.creditor_address_state', component: InputField, placeholder: 'State' }),
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'label' },
	              'Zip Code'
	            )
	          ),
	          _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.creditor_address_zip_code', component: InputField, placeholder: 'Zip Code' }),
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'label' },
	              'Country'
	            )
	          ),
	          _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.creditor_address_country', component: InputField, placeholder: 'Country' })
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'label' },
	              'Describe the lien'
	            )
	          ),
	          _react2.default.createElement(_reactFinalForm.Field, {
	            name: creditor + '.lien_description',
	            component: InputField,
	            componentClass: 'textarea',
	            rows: '3',
	            cols: '30',
	            id: 'lien_description-' + index
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'label' },
	              'Creditor\'s email address, if known'
	            )
	          ),
	          _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.creditor_email', component: InputField, type: 'text', placeholder: '' })
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'label',
	            { htmlFor: '' },
	            _react2.default.createElement(
	              'span',
	              { className: 'label' },
	              'Is creditor an insider or related party?'
	            )
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            _reactFinalForm.Field,
	            { name: creditor + '.is_creditor_an_insider', component: InputField, componentClass: 'select' },
	            _react2.default.createElement('option', { value: '' }),
	            _react2.default.createElement(
	              'option',
	              { value: 'no' },
	              'No'
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 'yes' },
	              'Yes'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'label',
	            { htmlFor: '' },
	            _react2.default.createElement(
	              'span',
	              { className: 'label' },
	              'Date debt was incurred'
	            )
	          ),
	          _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.debt_date', component: InputField, type: 'text', placeholder: '' })
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'label',
	            { htmlFor: '' },
	            _react2.default.createElement(
	              'span',
	              { className: 'label' },
	              'Is anyone else liable on this claim?'
	            )
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            _reactFinalForm.Field,
	            { name: creditor + '.is_anyone_else_liable', component: InputField, componentClass: 'select' },
	            _react2.default.createElement('option', { value: '' }),
	            _react2.default.createElement(
	              'option',
	              { value: 'no' },
	              'No'
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 'yes' },
	              'Yes'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'label' },
	              'Last 4 digits of account number'
	            )
	          ),
	          _react2.default.createElement(_reactFinalForm.Field, {
	            name: creditor + '.account_number_last_4_digits',
	            component: InputField,
	            type: 'text',
	            placeholder: ''
	          })
	        ),
	        _react2.default.createElement(
	          'td',
	          { rowSpan: '2' },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'label' },
	              'As of the petition filing date, the claim is:'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'schedule-tips' },
	              'Check all that apply.'
	            )
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_reactFinalForm.Field, {
	            name: creditor + '.is_contingent',
	            component: CheckboxField,
	            type: 'checkbox',
	            title: 'Contingent'
	          }),
	          ' ',
	          _react2.default.createElement(_reactFinalForm.Field, {
	            name: creditor + '.is_unliquidated',
	            component: CheckboxField,
	            type: 'checkbox',
	            title: 'Unliquidated'
	          }),
	          ' ',
	          _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.is_disputed', component: CheckboxField, type: 'checkbox', title: 'Disputed' }),
	          ' '
	        )
	      ),
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'label',
	            { htmlFor: '' },
	            _react2.default.createElement(
	              'span',
	              { className: 'label multiple-interest' },
	              'Do multiple creditors have an interest in the same property?'
	            )
	          ),
	          _react2.default.createElement(
	            _reactFinalForm.Field,
	            { name: creditor + '.has_multiple_creditor_interest', component: InputField, componentClass: 'select' },
	            _react2.default.createElement(
	              'option',
	              { value: 'no' },
	              'No'
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 'yes' },
	              'Yes'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'is-multiple-creditors-interested-yes',
	              style: {
	                display: creditorValue.has_multiple_creditor_interest === 'yes' ? 'inherit' : 'none'
	              }
	            },
	            index === 0 ? _react2.default.createElement(
	              _react2.default.Fragment,
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'creditor-priority' },
	                'Specify each creditor, including this creditor, and its relative priority'
	              ),
	              _react2.default.createElement(_reactFinalForm.Field, {
	                name: creditor + '.creditor_priority',
	                component: InputField,
	                componentClass: 'textarea',
	                rows: '3',
	                cols: '30',
	                id: 'creditor-priority-' + index
	              })
	            ) : _react2.default.createElement(
	              _react2.default.Fragment,
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'has-specified-creditor-priority' },
	                'Have you already specified the relative priority?'
	              ),
	              _react2.default.createElement(
	                _reactFinalForm.Field,
	                {
	                  name: creditor + '.has_already_specified_creditor_priority',
	                  component: InputField,
	                  componentClass: 'select'
	                },
	                _react2.default.createElement(
	                  'option',
	                  { value: 'no' },
	                  'No'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: 'yes' },
	                  'Yes'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'has-specified-creditor-priority-no',
	                  style: {
	                    display: creditorValue.has_already_specified_creditor_priority === 'no' ? 'inherit' : 'none'
	                  }
	                },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'creditor-priority' },
	                  'Specify each creditor, including this creditor, and its relative priority'
	                ),
	                _react2.default.createElement(_reactFinalForm.Field, {
	                  name: creditor + '.creditor_priority',
	                  component: InputField,
	                  componentClass: 'textarea',
	                  rows: '3',
	                  cols: '30',
	                  id: 'creditor-priority-' + index
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'has-specified-creditor-priority-yes',
	                  style: {
	                    display: creditorValue.has_already_specified_creditor_priority === 'yes' ? 'inherit' : 'none'
	                  }
	                },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'creditor-priority' },
	                  'The relative priority of creditors is specified on lines'
	                ),
	                ' ',
	                _react2.default.createElement(_reactFinalForm.Field, {
	                  name: creditor + '.creditor_priority_specified_on_line',
	                  component: InputField,
	                  id: 'creditor_priority_specified_on_line-' + index,
	                  type: 'text',
	                  defaultValue: creditor.creditor_priority_specified_on_line
	                })
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = ScheduleDCreditorFields;

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _finalFormArrays = __webpack_require__(189);
	
	var _finalFormArrays2 = _interopRequireDefault(_finalFormArrays);
	
	var _finalFormCalculate = __webpack_require__(840);
	
	var _finalFormCalculate2 = _interopRequireDefault(_finalFormCalculate);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _currencyConversion = __webpack_require__(72);
	
	var _currencyConversion2 = _interopRequireDefault(_currencyConversion);
	
	__webpack_require__(949);
	
	var _ScheduleDCreditorFields = __webpack_require__(735);
	
	var _ScheduleDCreditorFields2 = _interopRequireDefault(_ScheduleDCreditorFields);
	
	var _PagedFieldArray = __webpack_require__(424);
	
	var _PagedFieldArray2 = _interopRequireDefault(_PagedFieldArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var creditorToForm = function creditorToForm(creditor) {
	  return _extends({}, creditor, {
	    claim_amount_cents: _currencyConversion2.default.toDollarsOrStr(creditor.claim_amount_cents),
	    collateral_amount_cents: _currencyConversion2.default.toDollarsOrStr(creditor.collateral_amount_cents),
	    is_creditor_an_insider: creditor.is_creditor_an_insider ? 'yes' : creditor.is_creditor_an_insider === false ? 'no' : '',
	    is_anyone_else_liable: creditor.is_anyone_else_liable ? 'yes' : creditor.is_anyone_else_liable === false ? 'no' : '',
	    has_multiple_creditor_interest: creditor.has_multiple_creditor_interest ? 'yes' : 'no',
	    has_already_specified_creditor_priority: creditor.has_already_specified_creditor_priority ? 'yes' : 'no'
	  });
	};
	
	var confirm_remove_claim = function confirm_remove_claim() {
	  return confirm('Remove this creditor?');
	};
	var confirm_move_claim = function confirm_move_claim() {
	  return confirm('Move / renumber this creditor?');
	};
	
	var NumberField = function NumberField(_ref) {
	  var input = _ref.input,
	      rest = _objectWithoutProperties(_ref, ['input']);
	
	  return _react2.default.createElement(
	    _reactBootstrap.InputGroup,
	    null,
	    _react2.default.createElement(
	      _reactBootstrap.InputGroup.Addon,
	      null,
	      '$'
	    ),
	    _react2.default.createElement(_reactBootstrap.FormControl, _extends({ bsSize: 'small' }, input, rest))
	  );
	};
	
	var ScheduleDForm = function (_Component) {
	  _inherits(ScheduleDForm, _Component);
	
	  function ScheduleDForm() {
	    _classCallCheck(this, ScheduleDForm);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ScheduleDForm.prototype.render = function render() {
	    var _this2 = this;
	
	    var onSubmit = this.props.onSubmit;
	
	
	    var calculator = (0, _finalFormCalculate2.default)({
	      field: /\.claim_amount_cents/,
	      updates: {
	        total_claims_amount_cents: function total_claims_amount_cents(fieldValue, allValues) {
	          return _currencyConversion2.default.toDollars((allValues.creditors || []).reduce(function (total, creditor) {
	            return total + _currencyConversion2.default.toCents(creditor.claim_amount_cents);
	          }, 0));
	        }
	      }
	    });
	
	    var initialValue = {
	      creditors: _lodash2.default.cloneDeep(_lodash2.default.get(this.props.schedule, 'data.creditors', []).map(creditorToForm)),
	      total_claims_amount_cents: this.props.schedule.data ? _currencyConversion2.default.toDollars(this.props.schedule.data.total_claims_amount_cents) : 0
	    };
	
	    return _react2.default.createElement(_reactFinalForm.Form, {
	      initialValues: initialValue,
	      onSubmit: onSubmit,
	      mutators: _extends({}, _finalFormArrays2.default),
	      subscription: {} // optimization for large number of creditors
	      , decorators: [calculator],
	      render: function render(_ref2) {
	        var handleSubmit = _ref2.handleSubmit,
	            form = _ref2.form;
	        return _react2.default.createElement(
	          'form',
	          { onSubmit: handleSubmit, id: 'parser-schedule-d-form' },
	          _react2.default.createElement(
	            'table',
	            { id: 'secured-creditors' },
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  { colSpan: 2 },
	                  'Creditors Who Have Secured Claims'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              _react2.default.createElement(_PagedFieldArray2.default, {
	                name: 'creditors',
	                item: function item(_ref3) {
	                  var fields = _ref3.fields,
	                      name = _ref3.name,
	                      index = _ref3.index;
	                  return _react2.default.createElement(
	                    'tr',
	                    { key: name, className: index !== 0 ? 'additional_creditor' : '' },
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      _react2.default.createElement(_ScheduleDCreditorFields2.default, {
	                        index: index,
	                        creditor: name,
	                        onRemove: function onRemove() {
	                          return confirm_remove_claim() && fields.remove(index);
	                        },
	                        onMoveUp: index > 0 && function () {
	                          return confirm_move_claim() && fields.swap(index, index - 1);
	                        },
	                        onMoveDown: index < fields.length - 1 && function () {
	                          return confirm_move_claim() && fields.swap(index, index + 1);
	                        },
	                        onAdd: function onAdd() {
	                          var creditors = [].concat(form.getState().values.creditors);
	                          creditors.splice(index, 0, creditorToForm({}));
	                          form.change('creditors', creditors);
	                          // for some reason this leads to uneditable form fields
	                          // fields.insert(index, creditorToForm({}))
	                        }
	                      })
	                    )
	                  );
	                },
	                after: function after() {
	                  return _react2.default.createElement(
	                    'div',
	                    { className: 'editable' },
	                    _react2.default.createElement(
	                      'button',
	                      {
	                        className: 'btn btn-success',
	                        type: 'button',
	                        onClick: function onClick() {
	                          return form.mutators.push('creditors', creditorToForm({}));
	                        }
	                      },
	                      '+ Add creditor'
	                    )
	                  );
	                }
	              })
	            ),
	            _react2.default.createElement(
	              'tfoot',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'table',
	                    null,
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'label' },
	                            'Total of the dollar amounts from Part 1, Column A, including the amounts from the Additional Page, if any.'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          { className: 'money total' },
	                          _react2.default.createElement(_reactFinalForm.Field, {
	                            name: 'total_claims_amount_cents',
	                            component: NumberField,
	                            id: 'claim-total',
	                            size: 10,
	                            type: 'text',
	                            step: 0.01,
	                            precision: 2,
	                            placeholder: '',
	                            readOnly: true
	                          })
	                        ),
	                        _react2.default.createElement('td', { className: 'money' })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactFinalForm.FormSpy,
	            {
	              subscription: {
	                submitting: true,
	                pristine: true,
	                values: true // needed for `pristine` to properly work (in some? cases)
	              }
	            },
	            function (_ref4) {
	              var submitting = _ref4.submitting,
	                  pristine = _ref4.pristine;
	              return _react2.default.createElement(
	                'div',
	                { className: 'buttons' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'submit',
	                    disabled: submitting || pristine && !_this2.props.isDraft,
	                    className: 'btn btn-primary'
	                  },
	                  'Submit Changes'
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    onClick: function onClick() {
	                      if (pristine || confirm('You are about to lose unsaved changes!\nPress "Cancel" to continue editing, "OK" to discard changes!')) _this2.props.onCancel();
	                    },
	                    disabled: submitting,
	                    className: 'btn btn-link ' + (pristine ? '' : 'cancel-link')
	                  },
	                  pristine ? 'Cancel Editing' : 'Discard Changes'
	                )
	              );
	            }
	          )
	        );
	      }
	    });
	  };
	
	  return ScheduleDForm;
	}(_react.Component);
	
	ScheduleDForm.propTypes = {
	  onSubmit: _propTypes2.default.func,
	  isDraft: _propTypes2.default.bool
	};
	ScheduleDForm.defaultProps = {
	  onSubmit: function onSubmit() {
	    return null;
	  }
	};
	
	
	ScheduleDForm.propTypes = {
	  schedule: _propTypes2.default.any.isRequired
	};
	
	exports.default = ScheduleDForm;

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _ScheduleFilters = __webpack_require__(274);
	
	var _ScheduleFilters2 = _interopRequireDefault(_ScheduleFilters);
	
	var _ScheduleEFForm = __webpack_require__(738);
	
	var _ScheduleEFForm2 = _interopRequireDefault(_ScheduleEFForm);
	
	__webpack_require__(950);
	
	var _MoneyFormat = __webpack_require__(273);
	
	var _MoneyFormat2 = _interopRequireDefault(_MoneyFormat);
	
	var _currencyConversion = __webpack_require__(72);
	
	var _currencyConversion2 = _interopRequireDefault(_currencyConversion);
	
	var _EditCopyPasteSchedule = __webpack_require__(208);
	
	var _EditCopyPasteSchedule2 = _interopRequireDefault(_EditCopyPasteSchedule);
	
	var _ScheduleVeriyToolbar = __webpack_require__(179);
	
	var _ScheduleVeriyToolbar2 = _interopRequireDefault(_ScheduleVeriyToolbar);
	
	var _PagedItems = __webpack_require__(729);
	
	var _PagedItems2 = _interopRequireDefault(_PagedItems);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScheduleEF = function (_Component) {
	  _inherits(ScheduleEF, _Component);
	
	  function ScheduleEF() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ScheduleEF);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getScheduleData = function (data) {
	      var _data$priority_credit = data.priority_creditors,
	          priority_creditors = _data$priority_credit === undefined ? [] : _data$priority_credit,
	          _data$non_priority_cr = data.non_priority_creditors,
	          non_priority_creditors = _data$non_priority_cr === undefined ? [] : _data$non_priority_cr;
	      var _this$props$viewFilte = _this.props.viewFilters,
	          _this$props$viewFilte2 = _this$props$viewFilte.value_from,
	          value_from = _this$props$viewFilte2 === undefined ? '' : _this$props$viewFilte2,
	          _this$props$viewFilte3 = _this$props$viewFilte.value_to,
	          value_to = _this$props$viewFilte3 === undefined ? '' : _this$props$viewFilte3,
	          _this$props$viewFilte4 = _this$props$viewFilte.keyword,
	          keyword = _this$props$viewFilte4 === undefined ? '' : _this$props$viewFilte4;
	
	      var searchWords = keyword.toLowerCase().split(' ').filter(function (p) {
	        return p !== '';
	      }).reverse();
	      var inRange = function inRange(value) {
	        return (value_from ? _currencyConversion2.default.toDollars(value) >= value_from : true) && (value_to ? _currencyConversion2.default.toDollars(value) <= value_to : true);
	      };
	      var filteredPriorityCreditors = priority_creditors.map(function (creditor, index) {
	        return _extends({}, creditor, { index: index });
	      }).filter(function (priority_creditor) {
	        var text = Object.values(priority_creditor).join(' ').toLowerCase();
	        return (_lodash2.default.isEmpty(searchWords) || _lodash2.default.every(searchWords, function (word) {
	          return text.indexOf(word) > -1;
	        })) && (inRange(priority_creditor.total_claim) || inRange(priority_creditor.priority_amount));
	      });
	      var filteredNonPriorityCreditors = non_priority_creditors.map(function (creditor, index) {
	        return _extends({}, creditor, { index: index });
	      }).filter(function (non_priority_creditor) {
	        var text = Object.values(non_priority_creditor).join(' ');
	        return (_lodash2.default.isEmpty(searchWords) || _lodash2.default.every(searchWords, function (word) {
	          return text.toLowerCase().indexOf(word) > -1;
	        })) && inRange(non_priority_creditor.total_claim);
	      });
	      var hasFilteredPriorityValues = filteredPriorityCreditors.length > 0;
	      var hasFilteredNonPriorityValues = filteredNonPriorityCreditors.length > 0;
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        hasFilteredPriorityValues && _react2.default.createElement(
	          _react2.default.Fragment,
	          null,
	          _react2.default.createElement(
	            'table',
	            null,
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Priority creditors'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_PagedItems2.default, {
	            records: filteredPriorityCreditors,
	            component: function component(_ref) {
	              var visibleRecords = _ref.visibleRecords;
	              return _react2.default.createElement(
	                'table',
	                { id: 'priority-creditors' },
	                _react2.default.createElement(
	                  'tbody',
	                  null,
	                  visibleRecords.map(function (creditor) {
	                    return _this.priority_creditor_item(creditor);
	                  })
	                )
	              );
	            }
	          })
	        ),
	        hasFilteredNonPriorityValues && _react2.default.createElement(
	          _react2.default.Fragment,
	          null,
	          _react2.default.createElement(
	            'table',
	            null,
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Nonpriority creditors'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_PagedItems2.default, {
	            records: filteredNonPriorityCreditors,
	            component: function component(_ref2) {
	              var visibleRecords = _ref2.visibleRecords;
	              return _react2.default.createElement(
	                'table',
	                { id: 'nonpriority-creditors' },
	                _react2.default.createElement(
	                  'tbody',
	                  null,
	                  visibleRecords.map(function (creditor) {
	                    return _this.nonpriority_creditor_item(creditor);
	                  })
	                )
	              );
	            }
	          })
	        ),
	        !hasFilteredPriorityValues && !hasFilteredNonPriorityValues && _react2.default.createElement(
	          _reactBootstrap.Well,
	          { bsSize: 'small' },
	          'No results for searched term, try to search something different.'
	        )
	      );
	    }, _this.priority_creditor_item = function (creditor) {
	      return _react2.default.createElement(
	        'tr',
	        { key: 'priority-creditor-' + creditor.index },
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'table',
	            null,
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  { colSpan: '2' },
	                  '2.',
	                  creditor.index + 1
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'total-claim', align: 'right' },
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: '' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'Total claim'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'priority-amount', align: 'right' },
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: '' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'Priority amount'
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: '' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'Priority creditor\'s name and mailing address'
	                    )
	                  ),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'span',
	                    { id: 'address' },
	                    creditor.creditor_name,
	                    _react2.default.createElement('br', null),
	                    creditor.creditor_address_street,
	                    _react2.default.createElement('br', null),
	                    creditor.creditor_address_city,
	                    ' ',
	                    creditor.creditor_address_state,
	                    ' ',
	                    creditor.creditor_address_zip_code,
	                    _react2.default.createElement('br', null),
	                    creditor.creditor_address_country
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: '' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'As of petition filing date, the claim is:'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Checkbox,
	                    { name: 'claim_type', readOnly: true, checked: creditor.is_contingent },
	                    ' ',
	                    'Contingent',
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Checkbox,
	                    { name: 'claim_type', readOnly: true, checked: creditor.is_unliquidated },
	                    ' ',
	                    'Unliquidated',
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Checkbox,
	                    { name: 'claim_type', readOnly: true, checked: creditor.is_disputed },
	                    ' ',
	                    'Disputed',
	                    ' '
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'money' },
	                  _react2.default.createElement(
	                    'span',
	                    { id: 'total-claim' },
	                    (0, _MoneyFormat2.default)(creditor.total_claim)
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'money' },
	                  _react2.default.createElement(
	                    'span',
	                    { id: 'priority-amount' },
	                    (0, _MoneyFormat2.default)(creditor.priority_amount)
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: '' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'Date or dates debt was incurred'
	                    )
	                  ),
	                  _react2.default.createElement('br', null),
	                  creditor.debt_date
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: '' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'Basis for the claim'
	                    )
	                  ),
	                  _react2.default.createElement('br', null),
	                  creditor.claim_basis
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: '' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'Last 4 digits of account number'
	                    )
	                  ),
	                  _react2.default.createElement('br', null),
	                  creditor.account_number_last_4_digits
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { rowSpan: '2' },
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: '' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'Is the claim subject to offset?'
	                    )
	                  ),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    _reactBootstrap.Radio,
	                    {
	                      name: 'is_offset_claim_' + creditor.index + '_no_priority',
	                      value: 'No',
	                      readOnly: true,
	                      checked: !creditor.is_subject_to_offset
	                    },
	                    'No'
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Radio,
	                    {
	                      name: 'is_offset_claim_' + creditor.index + '_yes_priority',
	                      value: 'Yes',
	                      readOnly: true,
	                      checked: creditor.is_subject_to_offset
	                    },
	                    'Yes'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: '' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'Specify Code subsection of PRIORITY unsecured claim:'
	                    )
	                  ),
	                  '11 U.S.C. \xA7 507(a) (',
	                  creditor.usc_subsection,
	                  ')'
	                )
	              )
	            )
	          )
	        )
	      );
	    }, _this.nonpriority_creditor_item = function (creditor) {
	      return _react2.default.createElement(
	        'tr',
	        { key: 'non-priority-creditor-' + creditor.index },
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'table',
	            null,
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  { colSpan: '2' },
	                  '3.',
	                  creditor.index + 1
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'total-claim' },
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: '' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'Amount of claim'
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  { rowSpan: '2' },
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: '' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'Nonpriority creditor\'s name and mailing address'
	                    )
	                  ),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'span',
	                    { id: 'address' },
	                    creditor.creditor_name,
	                    _react2.default.createElement('br', null),
	                    creditor.creditor_address_street,
	                    _react2.default.createElement('br', null),
	                    creditor.creditor_address_city,
	                    ' ',
	                    creditor.creditor_address_state,
	                    ' ',
	                    creditor.creditor_address_zip_code,
	                    _react2.default.createElement('br', null),
	                    creditor.creditor_address_country
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: '' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'As of petition filing date, the claim is:'
	                    )
	                  ),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    _reactBootstrap.Checkbox,
	                    { name: 'claim_type', readOnly: true, checked: creditor.is_contingent },
	                    ' ',
	                    'Contingent',
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Checkbox,
	                    { name: 'claim_type', readOnly: true, checked: creditor.is_unliquidated },
	                    ' ',
	                    'Unliquidated',
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Checkbox,
	                    { name: 'claim_type', readOnly: true, checked: creditor.is_disputed },
	                    ' ',
	                    'Disputed',
	                    ' '
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'money' },
	                  _react2.default.createElement(
	                    'span',
	                    { id: 'total-claim' },
	                    (0, _MoneyFormat2.default)(creditor.total_claim)
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: '' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'Basis for the claim'
	                    )
	                  ),
	                  _react2.default.createElement('br', null),
	                  creditor.claim_basis
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: '' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'Date or dates debt was incurred'
	                    )
	                  ),
	                  _react2.default.createElement('br', null),
	                  creditor.debt_date
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { rowSpan: '2' },
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: '' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'Is the claim subject to offset?'
	                    )
	                  ),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    _reactBootstrap.Radio,
	                    {
	                      name: 'is_offset_claim_' + creditor.index + '_no_non_priority',
	                      value: 'No',
	                      readOnly: true,
	                      checked: !creditor.is_subject_to_offset
	                    },
	                    'No'
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Radio,
	                    {
	                      name: 'is_offset_claim_' + creditor.index + '_yes_non_priority',
	                      value: 'Yes',
	                      readOnly: true,
	                      checked: creditor.is_subject_to_offset
	                    },
	                    'Yes'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: '' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'Last 4 digits of account number'
	                    )
	                  ),
	                  _react2.default.createElement('br', null),
	                  creditor.account_number_last_4_digits
	                )
	              )
	            )
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ScheduleEF.prototype.render = function render() {
	    var _props = this.props,
	        type = _props.type,
	        schedule = _props.schedule,
	        editScheduleForm = _props.editScheduleForm,
	        canEdit = _props.canEdit,
	        can_see_details = _props.can_see_details,
	        onCancel = _props.onCancel,
	        onSubmit = _props.onSubmit,
	        onPastedData = _props.onPastedData,
	        scheduleFiltersProps = _props.scheduleFiltersProps,
	        toggleScheduleForm = _props.toggleScheduleForm;
	
	
	    var tableData = schedule.data || {};
	    var noDataFound = schedule.data === null ? 'There is no Schedule EF for this case.' : schedule.empty || null;
	    var _tableData$priority_c = tableData.priority_creditors,
	        priority_creditors = _tableData$priority_c === undefined ? [] : _tableData$priority_c,
	        _tableData$non_priori = tableData.non_priority_creditors,
	        non_priority_creditors = _tableData$non_priori === undefined ? [] : _tableData$non_priori;
	
	    var hasCreditors = priority_creditors.length >= 0 || non_priority_creditors.length >= 0;
	
	    if (noDataFound && !editScheduleForm) {
	      return _react2.default.createElement(
	        'div',
	        { id: 'ir-search-schedule-ef-results' },
	        _react2.default.createElement(
	          _reactBootstrap.Well,
	          { bsSize: 'small' },
	          noDataFound
	        ),
	        canEdit && _react2.default.createElement(_ScheduleVeriyToolbar2.default, { schedule: schedule }),
	        canEdit && _react2.default.createElement(_EditCopyPasteSchedule2.default, {
	          schedule: { schedule_type: 'ef' },
	          onPastedData: onPastedData,
	          toggleScheduleForm: toggleScheduleForm
	        })
	      );
	    }
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: type },
	        can_see_details && _react2.default.createElement(
	          _react2.default.Fragment,
	          null,
	          _react2.default.createElement(
	            'div',
	            { id: 'schedule-ef' },
	            _react2.default.createElement(
	              'div',
	              { id: 'ir-search-schedule-ef-results' },
	              editScheduleForm ? _react2.default.createElement(_ScheduleEFForm2.default, _extends({}, this.props, {
	                // editScheduleForm could be a draft object
	                schedule: editScheduleForm === true ? schedule : editScheduleForm,
	                isDraft: editScheduleForm !== true,
	                onSubmit: onSubmit,
	                onCancel: onCancel
	              })) : _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                hasCreditors && _react2.default.createElement(_ScheduleFilters2.default, scheduleFiltersProps),
	                canEdit && _react2.default.createElement(_ScheduleVeriyToolbar2.default, { schedule: schedule }),
	                canEdit && _react2.default.createElement(_EditCopyPasteSchedule2.default, {
	                  schedule: schedule,
	                  onPastedData: onPastedData,
	                  toggleScheduleForm: toggleScheduleForm
	                }),
	                this.getScheduleData(tableData)
	              ),
	              canEdit && !editScheduleForm && _react2.default.createElement(
	                'div',
	                { className: 'editable' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'btn btn-primary', onClick: toggleScheduleForm },
	                  'Edit'
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return ScheduleEF;
	}(_react.Component);
	
	ScheduleEF.defaultProps = {
	  type: 'schedule_ef',
	  scheduleFiltersProps: {},
	  viewFilters: {},
	  keyword: '',
	  value_from: '',
	  value_to: ''
	};
	
	ScheduleEF.propTypes = {
	  schedule: _propTypes2.default.any.isRequired,
	  type: _propTypes2.default.string,
	  scheduleFiltersProps: _propTypes2.default.object,
	  viewFilters: _propTypes2.default.object,
	  keyword: _propTypes2.default.string,
	  value_to: _propTypes2.default.string,
	  value_from: _propTypes2.default.string,
	  editScheduleForm: _propTypes2.default.bool.isRequired,
	  canEdit: _propTypes2.default.bool.isRequired,
	  can_see_details: _propTypes2.default.bool.isRequired,
	  onCancel: _propTypes2.default.func.isRequired,
	  onSubmit: _propTypes2.default.func.isRequired,
	  toggleScheduleForm: _propTypes2.default.func.isRequired
	};
	
	exports.default = ScheduleEF;

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _finalFormArrays = __webpack_require__(189);
	
	var _finalFormArrays2 = _interopRequireDefault(_finalFormArrays);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(950);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ScheduleEFPriorityCreditorForm = __webpack_require__(740);
	
	var _ScheduleEFPriorityCreditorForm2 = _interopRequireDefault(_ScheduleEFPriorityCreditorForm);
	
	var _ScheduleEFNonPriorityCreditorForm = __webpack_require__(739);
	
	var _ScheduleEFNonPriorityCreditorForm2 = _interopRequireDefault(_ScheduleEFNonPriorityCreditorForm);
	
	var _currencyConversion = __webpack_require__(72);
	
	var _currencyConversion2 = _interopRequireDefault(_currencyConversion);
	
	var _PagedFieldArray = __webpack_require__(424);
	
	var _PagedFieldArray2 = _interopRequireDefault(_PagedFieldArray);
	
	var _reactBootstrap = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function confirm_remove_creditor() {
	  return confirm('Remove this creditor?');
	}
	
	function confirm_move_creditor() {
	  return confirm('Move / renumber this creditor?');
	}
	
	var ScheduleEFForm = function (_Component) {
	  _inherits(ScheduleEFForm, _Component);
	
	  function ScheduleEFForm() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ScheduleEFForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.render = function () {
	      return _react2.default.createElement(_reactFinalForm.Form, {
	        initialValues: _this.initialValues(),
	        onSubmit: _this.props.onSubmit,
	        mutators: _extends({}, _finalFormArrays2.default),
	        subscription: {} // optimization for large number of creditors
	        , render: function render(_ref) {
	          var handleSubmit = _ref.handleSubmit,
	              pristine = _ref.pristine,
	              form = _ref.form;
	          return _react2.default.createElement(
	            'form',
	            { onSubmit: handleSubmit, id: 'parser-schedule-ef-form' },
	            _react2.default.createElement(
	              _reactBootstrap.Tabs,
	              { id: 'creditor-type-tabs' },
	              _react2.default.createElement(
	                _reactBootstrap.Tab,
	                { eventKey: 1, title: 'Priority creditors' },
	                _react2.default.createElement(
	                  'div',
	                  { id: 'priority-creditors', className: 'ir-search-double' },
	                  _react2.default.createElement(_PagedFieldArray2.default, {
	                    name: 'priority_creditors',
	                    item: function item(_ref2) {
	                      var fields = _ref2.fields,
	                          name = _ref2.name,
	                          index = _ref2.index;
	                      return _react2.default.createElement(
	                        'div',
	                        { style: { borderBottom: '1px solid gray', marginBottom: 8 } },
	                        _react2.default.createElement(_ScheduleEFPriorityCreditorForm2.default, {
	                          index: index,
	                          creditor: name,
	                          onRemove: function onRemove() {
	                            return confirm_remove_creditor() && fields.remove(index);
	                          },
	                          onMoveUp: index > 0 && function () {
	                            return confirm_move_creditor() && fields.swap(index, index - 1);
	                          },
	                          onMoveDown: index < fields.length - 1 && function () {
	                            return confirm_move_creditor() && fields.swap(index, index + 1);
	                          },
	                          onAdd: function onAdd() {
	                            var creditors = [].concat(form.getState().values.priority_creditors);
	                            creditors.splice(index, 0, {});
	                            form.change('priority_creditors', creditors);
	                            // for some reason this leads to uneditable form fields
	                            // fields.insert(index, {});
	                          }
	                        })
	                      );
	                    },
	                    after: function after() {
	                      return _react2.default.createElement(
	                        'div',
	                        { className: 'editable' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            className: 'btn btn-success',
	                            type: 'button',
	                            onClick: function onClick() {
	                              return form.mutators.push('priority_creditors', {});
	                            }
	                          },
	                          'Add priority creditor'
	                        )
	                      );
	                    }
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Tab,
	                { eventKey: 2, title: 'Nonpriority creditors' },
	                _react2.default.createElement(
	                  'div',
	                  { id: 'nonpriority-creditors', className: 'ir-search-double' },
	                  _react2.default.createElement(_PagedFieldArray2.default, {
	                    name: 'non_priority_creditors',
	                    subscription: {},
	                    item: function item(_ref3) {
	                      var fields = _ref3.fields,
	                          name = _ref3.name,
	                          index = _ref3.index;
	                      return _react2.default.createElement(
	                        'div',
	                        { style: { borderBottom: '1px solid gray', marginBottom: 8 } },
	                        _react2.default.createElement(_ScheduleEFNonPriorityCreditorForm2.default, {
	                          index: index,
	                          creditor: name,
	                          onRemove: function onRemove() {
	                            return confirm_remove_creditor() && fields.remove(index);
	                          },
	                          onMoveUp: index > 0 && function () {
	                            return confirm_move_creditor() && fields.swap(index, index - 1);
	                          },
	                          onMoveDown: index < fields.length - 1 && function () {
	                            return confirm_move_creditor() && fields.swap(index, index + 1);
	                          },
	                          onAdd: function onAdd() {
	                            var creditors = [].concat(form.getState().values.non_priority_creditors);
	                            creditors.splice(index, 0, {});
	                            form.change('non_priority_creditors', creditors);
	                            // for some reason this leads to uneditable form fields
	                            // fields.insert(index, {});
	                          }
	                        })
	                      );
	                    },
	                    after: function after() {
	                      return _react2.default.createElement(
	                        'div',
	                        { className: 'editable' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            className: 'btn btn-success',
	                            type: 'button',
	                            onClick: function onClick() {
	                              return form.mutators.push('non_priority_creditors', {});
	                            }
	                          },
	                          'Add non-priority creditor'
	                        )
	                      );
	                    }
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactFinalForm.FormSpy,
	              {
	                subscription: {
	                  submitting: true,
	                  pristine: true,
	                  values: true // needed for `pristine` to properly work (in some? cases)
	                }
	              },
	              function (_ref4) {
	                var submitting = _ref4.submitting,
	                    pristine = _ref4.pristine;
	                return _react2.default.createElement(
	                  'div',
	                  { className: 'buttons' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'submit',
	                      disabled: submitting || pristine && !_this.props.isDraft,
	                      className: 'btn btn-primary'
	                    },
	                    'Submit Changes'
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      onClick: function onClick() {
	                        if (pristine || confirm('You are about to lose unsaved changes!\nPress "Cancel" to continue editing, "OK" to discard changes!')) _this.props.onCancel();
	                      },
	                      disabled: submitting,
	                      className: 'btn btn-link ' + (pristine ? '' : 'cancel-link')
	                    },
	                    pristine ? 'Cancel Editing' : 'Discard Changes'
	                  )
	                );
	              }
	            )
	          );
	        }
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ScheduleEFForm.prototype.initialValues = function initialValues() {
	    var vals = _lodash2.default.cloneDeep(this.props.schedule.data || { priority_creditors: [], non_priority_creditors: [] });
	    vals.priority_creditors.forEach(function (cred) {
	      cred.priority_amount = _currencyConversion2.default.toDollarsOrStr(cred.priority_amount);
	      cred.total_claim = _currencyConversion2.default.toDollarsOrStr(cred.total_claim);
	    });
	    vals.non_priority_creditors.forEach(function (cred) {
	      cred.total_claim = _currencyConversion2.default.toDollarsOrStr(cred.total_claim);
	    });
	    return vals;
	  };
	
	  return ScheduleEFForm;
	}(_react.Component);
	
	ScheduleEFForm.propTypes = {
	  onSubmit: _propTypes2.default.func,
	  schedule: _propTypes2.default.any.isRequired,
	  isDraft: _propTypes2.default.bool
	};
	ScheduleEFForm.defaultProps = {
	  onSubmit: function onSubmit() {
	    return null;
	  }
	};
	exports.default = ScheduleEFForm;

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ScheduleEFNonPriorityCreditorForm;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactFinalForm = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var InputField = function InputField(_ref) {
	  var input = _ref.input,
	      rest = _objectWithoutProperties(_ref, ['input']);
	
	  return _react2.default.createElement(_reactBootstrap.FormControl, _extends({}, input, rest));
	};
	
	var DollarField = function DollarField(_ref2) {
	  var input = _ref2.input,
	      rest = _objectWithoutProperties(_ref2, ['input']);
	
	  return _react2.default.createElement(
	    _reactBootstrap.InputGroup,
	    null,
	    _react2.default.createElement(
	      _reactBootstrap.InputGroup.Addon,
	      null,
	      '$'
	    ),
	    _react2.default.createElement(_reactBootstrap.FormControl, _extends({ bsSize: 'small' }, input, rest))
	  );
	};
	
	var CheckboxField = function CheckboxField(_ref3) {
	  var input = _ref3.input,
	      rest = _objectWithoutProperties(_ref3, ['input']);
	
	  return _react2.default.createElement(
	    _reactBootstrap.Checkbox,
	    _extends({}, input, rest),
	    rest.title
	  );
	};
	
	function ScheduleEFNonPriorityCreditorForm(_ref4) {
	  var index = _ref4.index,
	      creditor = _ref4.creditor,
	      onRemove = _ref4.onRemove,
	      onMoveDown = _ref4.onMoveDown,
	      onMoveUp = _ref4.onMoveUp,
	      onAdd = _ref4.onAdd;
	
	  return _react2.default.createElement(
	    'table',
	    null,
	    _react2.default.createElement(
	      'thead',
	      null,
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          { colSpan: '2' },
	          '3.',
	          index + 1,
	          ' ',
	          onAdd && _react2.default.createElement(
	            'div',
	            { className: 'btn btn-success btn-sm', onClick: onAdd, title: 'Add new creditor' },
	            '+'
	          ),
	          onMoveUp && _react2.default.createElement(
	            'div',
	            { className: 'btn btn-primary btn-sm', onClick: onMoveUp, title: 'Swap this creditor with 2.' + index },
	            '\u25B2'
	          ),
	          onMoveDown && _react2.default.createElement(
	            'div',
	            {
	              className: 'btn btn-primary btn-sm',
	              onClick: onMoveDown,
	              title: 'Swap this creditor with 2.' + (index + 2)
	            },
	            '\u25BC'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'btn btn-danger btn-sm', onClick: onRemove, title: 'Remove creditor' },
	            'X'
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'total-claim' },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'label' },
	              'Amount of claim'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'tbody',
	      null,
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          { rowSpan: '2' },
	          _react2.default.createElement(
	            'div',
	            { className: 'form-item' },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Nonpriority creditor\'s name and mailing address'
	              )
	            ),
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Name'
	              )
	            ),
	            _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.creditor_name', component: InputField, placeholder: 'Name' }),
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Street'
	              )
	            ),
	            _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.creditor_address_street', component: InputField, placeholder: 'Street' }),
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'City'
	              )
	            ),
	            _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.creditor_address_city', component: InputField, placeholder: 'City' }),
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'State'
	              )
	            ),
	            _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.creditor_address_state', component: InputField, placeholder: 'State' }),
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Zip Code'
	              )
	            ),
	            _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.creditor_address_zip_code', component: InputField, placeholder: 'Zip Code' }),
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Country'
	              )
	            ),
	            _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.creditor_address_country', component: InputField, placeholder: 'Country' })
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'form-item' },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'As of petition filing date, the claim is:'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'schedule-tips' },
	                'Check all that apply.'
	              )
	            ),
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactFinalForm.Field, {
	                name: creditor + '.is_contingent',
	                component: CheckboxField,
	                type: 'checkbox',
	                title: 'Contingent'
	              }),
	              ' ',
	              _react2.default.createElement(_reactFinalForm.Field, {
	                name: creditor + '.is_unliquidated',
	                component: CheckboxField,
	                type: 'checkbox',
	                title: 'Unliquidated'
	              }),
	              ' ',
	              _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.is_disputed', component: CheckboxField, type: 'checkbox', title: 'Disputed' }),
	              ' '
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'money' },
	          _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.total_claim', component: DollarField, type: 'text', size: '10' })
	        )
	      ),
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'form-item' },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Basis for the claim'
	              )
	            ),
	            _react2.default.createElement(_reactFinalForm.Field, {
	              name: creditor + '.claim_basis',
	              component: InputField,
	              componentClass: 'textarea',
	              rows: '3',
	              cols: '30'
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'form-item' },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Date or dates debt was incurred'
	              )
	            ),
	            _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.debt_date', component: InputField, type: 'text', placeholder: '' })
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'form-item' },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Is the claim subject to offset?'
	              )
	            ),
	            _react2.default.createElement(
	              _reactFinalForm.Field,
	              { name: creditor + '.is_subject_to_offset', component: InputField, componentClass: 'select' },
	              _react2.default.createElement(
	                'option',
	                { value: false },
	                'No'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: true },
	                'Yes'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'form-item no-num-range' },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Last 4 digits of account number'
	              )
	            ),
	            _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.account_number_last_4_digits', component: InputField, type: 'text' })
	          )
	        )
	      )
	    )
	  );
	}

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ScheduleEFPriorityCreditorForm;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactFinalForm = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var InputField = function InputField(_ref) {
	  var input = _ref.input,
	      rest = _objectWithoutProperties(_ref, ['input']);
	
	  return _react2.default.createElement(_reactBootstrap.FormControl, _extends({}, input, rest));
	};
	
	var DollarField = function DollarField(_ref2) {
	  var input = _ref2.input,
	      rest = _objectWithoutProperties(_ref2, ['input']);
	
	  return _react2.default.createElement(
	    _reactBootstrap.InputGroup,
	    null,
	    _react2.default.createElement(
	      _reactBootstrap.InputGroup.Addon,
	      null,
	      '$'
	    ),
	    _react2.default.createElement(_reactBootstrap.FormControl, _extends({}, input, rest))
	  );
	};
	
	var CheckboxField = function CheckboxField(_ref3) {
	  var input = _ref3.input,
	      rest = _objectWithoutProperties(_ref3, ['input']);
	
	  return _react2.default.createElement(
	    _reactBootstrap.Checkbox,
	    _extends({}, input, rest),
	    rest.title
	  );
	};
	
	function ScheduleEFPriorityCreditorForm(_ref4) {
	  var index = _ref4.index,
	      creditor = _ref4.creditor,
	      onRemove = _ref4.onRemove,
	      onMoveDown = _ref4.onMoveDown,
	      onMoveUp = _ref4.onMoveUp,
	      onAdd = _ref4.onAdd;
	
	  return _react2.default.createElement(
	    'table',
	    null,
	    _react2.default.createElement(
	      'thead',
	      null,
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          { colSpan: '2' },
	          '2.',
	          index + 1,
	          ' ',
	          onAdd && _react2.default.createElement(
	            'div',
	            { className: 'btn btn-success btn-sm', onClick: onAdd, title: 'Add new creditor' },
	            '+'
	          ),
	          onMoveUp && _react2.default.createElement(
	            'div',
	            { className: 'btn btn-primary btn-sm', onClick: onMoveUp, title: 'Swap this creditor with 2.' + index },
	            '\u25B2'
	          ),
	          onMoveDown && _react2.default.createElement(
	            'div',
	            {
	              className: 'btn btn-primary btn-sm',
	              onClick: onMoveDown,
	              title: 'Swap this creditor with 2.' + (index + 2)
	            },
	            '\u25BC'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'btn btn-danger btn-sm', onClick: onRemove, title: 'Remove creditor' },
	            'X'
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'total-claim' },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'label' },
	              'Total claim'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'priority-amount' },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'label' },
	              'Priority amount'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'tbody',
	      null,
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'form-item' },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Priority creditor\'s name and mailing address '
	              )
	            ),
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Name'
	              )
	            ),
	            _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.creditor_name', component: InputField, placeholder: 'Name' }),
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Street'
	              )
	            ),
	            _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.creditor_address_street', component: InputField, placeholder: 'Street' }),
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'City'
	              )
	            ),
	            _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.creditor_address_city', component: InputField, placeholder: 'City' }),
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'State'
	              )
	            ),
	            _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.creditor_address_state', component: InputField, placeholder: 'State' }),
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Zip Code'
	              )
	            ),
	            _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.creditor_address_zip_code', component: InputField, placeholder: 'Zip Code' }),
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Country'
	              )
	            ),
	            _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.creditor_address_country', component: InputField, placeholder: 'Country' })
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'form-item' },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'As of petition filing date, the claim is:'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'schedule-tips' },
	                'Check all that apply.'
	              )
	            ),
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactFinalForm.Field, {
	                name: creditor + '.is_contingent',
	                component: CheckboxField,
	                title: 'Contingent',
	                type: 'checkbox'
	              }),
	              ' ',
	              _react2.default.createElement(_reactFinalForm.Field, {
	                name: creditor + '.is_unliquidated',
	                component: CheckboxField,
	                title: 'Unliquidated',
	                type: 'checkbox'
	              }),
	              ' ',
	              _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.is_disputed', component: CheckboxField, title: 'Disputed', type: 'checkbox' }),
	              ' '
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-item' },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Basis for the claim'
	              )
	            ),
	            _react2.default.createElement(_reactFinalForm.Field, {
	              name: creditor + '.claim_basis',
	              component: InputField,
	              componentClass: 'textarea',
	              rows: '3',
	              cols: '30'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'money' },
	          _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.total_claim', component: DollarField, type: 'text', size: '10' })
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'money' },
	          _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.priority_amount', component: DollarField, type: 'text', size: '10' })
	        )
	      ),
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'form-item' },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Date or dates debt was incurred'
	              )
	            ),
	            _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.debt_date', component: InputField, type: 'text', placeholder: '' })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'form-item no-num-range' },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Last 4 digits of account number'
	              )
	            ),
	            _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.account_number_last_4_digits', component: InputField, type: 'text' })
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'form-item' },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Is the claim subject to offset?'
	              )
	            ),
	            _react2.default.createElement(
	              _reactFinalForm.Field,
	              { name: creditor + '.is_subject_to_offset', component: InputField, componentClass: 'select' },
	              _react2.default.createElement(
	                'option',
	                { value: false },
	                'No'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: true },
	                'Yes'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          { colSpan: 2 },
	          _react2.default.createElement(
	            'div',
	            { className: 'form-item no-num-range' },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Specify Code subsection of PRIORITY unsecured claim:'
	              )
	            ),
	            '11 U.S.C. \xA7 507(a) (',
	            _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.usc_subsection', component: InputField, type: 'text', size: '4' }),
	            ')'
	          )
	        )
	      )
	    )
	  );
	}

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _currencyConversion = __webpack_require__(72);
	
	var _currencyConversion2 = _interopRequireDefault(_currencyConversion);
	
	var _TopTwentyForm = __webpack_require__(743);
	
	var _TopTwentyForm2 = _interopRequireDefault(_TopTwentyForm);
	
	var _ScheduleFilters = __webpack_require__(274);
	
	var _ScheduleFilters2 = _interopRequireDefault(_ScheduleFilters);
	
	__webpack_require__(951);
	
	var _MoneyFormat = __webpack_require__(273);
	
	var _MoneyFormat2 = _interopRequireDefault(_MoneyFormat);
	
	var _EditCopyPasteSchedule = __webpack_require__(208);
	
	var _EditCopyPasteSchedule2 = _interopRequireDefault(_EditCopyPasteSchedule);
	
	var _ScheduleVeriyToolbar = __webpack_require__(179);
	
	var _ScheduleVeriyToolbar2 = _interopRequireDefault(_ScheduleVeriyToolbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TopTwenty = function (_Component) {
	  _inherits(TopTwenty, _Component);
	
	  function TopTwenty() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TopTwenty);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getTopTwentydata = function (data) {
	      var _data$creditors = data.creditors,
	          creditors = _data$creditors === undefined ? [] : _data$creditors;
	      var _this$props$viewFilte = _this.props.viewFilters,
	          _this$props$viewFilte2 = _this$props$viewFilte.value_from,
	          value_from = _this$props$viewFilte2 === undefined ? '' : _this$props$viewFilte2,
	          _this$props$viewFilte3 = _this$props$viewFilte.value_to,
	          value_to = _this$props$viewFilte3 === undefined ? '' : _this$props$viewFilte3,
	          _this$props$viewFilte4 = _this$props$viewFilte.keyword,
	          keyword = _this$props$viewFilte4 === undefined ? '' : _this$props$viewFilte4;
	
	      var searchWords = keyword.toLowerCase().split(' ').filter(function (p) {
	        return p !== '';
	      }).reverse();
	      var inRange = function inRange(value) {
	        return (value_from ? _currencyConversion2.default.toDollars(value) >= value_from : true) && (value_to ? _currencyConversion2.default.toDollars(value) <= value_to : true);
	      };
	      var filteredCreditors = creditors.map(function (creditor) {
	        var text = Object.values(creditor).join(' ').toLowerCase();
	        var visible = (_lodash2.default.isEmpty(searchWords) || _lodash2.default.every(searchWords, function (word) {
	          return text.indexOf(word) > -1;
	        })) && (inRange(creditor.total) || inRange(creditor.deduction) || inRange(creditor.unsecured));
	        return _extends({}, creditor, {
	          visible: visible
	        });
	      });
	      var hasCreditors = creditors.length > 0;
	      if (!hasCreditors) {
	        return _react2.default.createElement(
	          _reactBootstrap.Well,
	          { bsSize: 'small' },
	          'There is no Largest 20 schedule for this case.'
	        );
	      }
	      var hasFilteredCreditors = filteredCreditors.filter(function (_ref) {
	        var visible = _ref.visible;
	        return visible;
	      }).length > 0;
	      if (!hasFilteredCreditors) {
	        return _react2.default.createElement(
	          _reactBootstrap.Well,
	          { bsSize: 'small' },
	          'No results for searched term, try to search something different.'
	        );
	      }
	      return _react2.default.createElement(
	        'table',
	        { id: 'creditors' },
	        _react2.default.createElement(
	          'thead',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'th',
	              { rowSpan: '2', colSpan: '2' },
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Creditor name and address'
	              )
	            ),
	            _react2.default.createElement(
	              'th',
	              { rowSpan: '2' },
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Creditor contact information'
	              )
	            ),
	            _react2.default.createElement(
	              'th',
	              { rowSpan: '2' },
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Nature of the claim'
	              )
	            ),
	            _react2.default.createElement(
	              'th',
	              { rowSpan: '2' },
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Indicate if claim is contingent, unliquidated, or disputed'
	              )
	            ),
	            _react2.default.createElement(
	              'th',
	              { colSpan: '3' },
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Amount of unsecured claim'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'th',
	              null,
	              'Total claim, if partially secured'
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              'Deduction for value of collateral or setoff'
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              'Unsecured claim'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'tbody',
	          { id: 'view-creditors' },
	          filteredCreditors.map(function (item, key) {
	            return _react2.default.createElement(
	              'tr',
	              { key: key, style: { display: item.visible ? 'table-row' : 'none' } },
	              _react2.default.createElement(
	                'td',
	                { style: { width: 5 } },
	                _react2.default.createElement(
	                  'span',
	                  { id: 'address' },
	                  key + 1
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                { style: { width: 200 } },
	                _react2.default.createElement(
	                  'span',
	                  { id: 'address', style: { whiteSpace: 'pre-wrap' } },
	                  item.creditor_name,
	                  _react2.default.createElement('br', null),
	                  item.creditor_address_street,
	                  _react2.default.createElement('br', null),
	                  item.creditor_address_city,
	                  ' ',
	                  item.creditor_address_state,
	                  ' ',
	                  item.creditor_address_zip_code,
	                  _react2.default.createElement('br', null),
	                  item.creditor_address_country
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                { style: { width: 70 } },
	                _react2.default.createElement(
	                  'span',
	                  { id: 'contact', style: { whiteSpace: 'pre-wrap' } },
	                  item.contact_address
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                { style: { width: 50 } },
	                _react2.default.createElement(
	                  'span',
	                  { id: 'claim-type' },
	                  item.claim_type
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                { style: { width: 50 } },
	                _react2.default.createElement(
	                  'span',
	                  { id: 'claim-status' },
	                  item.claim_status
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                { className: 'money' },
	                _react2.default.createElement(
	                  'span',
	                  { id: 'total' },
	                  (0, _MoneyFormat2.default)(item.total)
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                { className: 'money' },
	                _react2.default.createElement(
	                  'span',
	                  { id: 'deduction' },
	                  (0, _MoneyFormat2.default)(item.deduction)
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                { className: 'money' },
	                _react2.default.createElement(
	                  'span',
	                  { id: 'deduction' },
	                  (0, _MoneyFormat2.default)(item.unsecured)
	                )
	              )
	            );
	          })
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  TopTwenty.prototype.render = function render() {
	    var _props = this.props,
	        schedule = _props.schedule,
	        editScheduleForm = _props.editScheduleForm,
	        can_see_details = _props.can_see_details,
	        canEdit = _props.canEdit,
	        toggleScheduleForm = _props.toggleScheduleForm,
	        onCancel = _props.onCancel,
	        scheduleFiltersProps = _props.scheduleFiltersProps,
	        onSubmit = _props.onSubmit,
	        onPastedData = _props.onPastedData,
	        type = _props.type;
	
	
	    var tableData = schedule.data || {};
	    var noDataFound = schedule.empty || null;
	    var haveSchedule = schedule.data && schedule.data.creditors.length > 0;
	
	    if (noDataFound && !editScheduleForm) {
	      return _react2.default.createElement(
	        'div',
	        { id: 'ir-search-schedule-top20-results' },
	        _react2.default.createElement(
	          _reactBootstrap.Well,
	          { bsSize: 'small' },
	          noDataFound
	        ),
	        canEdit && _react2.default.createElement(_ScheduleVeriyToolbar2.default, { schedule: schedule }),
	        canEdit && _react2.default.createElement(_EditCopyPasteSchedule2.default, {
	          schedule: { schedule_type: 'top20' },
	          onPastedData: onPastedData,
	          toggleScheduleForm: toggleScheduleForm
	        })
	      );
	    }
	    return _react2.default.createElement(
	      'div',
	      { className: type },
	      can_see_details && _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { id: 'schedule-top20' },
	          _react2.default.createElement(
	            'div',
	            { id: 'ir-search-schedule-top20-results' },
	            editScheduleForm ? _react2.default.createElement(_TopTwentyForm2.default, _extends({}, this.props, {
	              // editScheduleForm could be a draft object
	              schedule: editScheduleForm === true ? schedule : editScheduleForm,
	              isDraft: editScheduleForm !== true,
	              onSubmit: onSubmit,
	              onCancel: onCancel
	            })) : _react2.default.createElement(
	              _react2.default.Fragment,
	              null,
	              haveSchedule && _react2.default.createElement(_ScheduleFilters2.default, scheduleFiltersProps),
	              ' ',
	              canEdit && _react2.default.createElement(_ScheduleVeriyToolbar2.default, { schedule: schedule }),
	              canEdit && _react2.default.createElement(_EditCopyPasteSchedule2.default, {
	                schedule: schedule,
	                onPastedData: onPastedData,
	                toggleScheduleForm: toggleScheduleForm
	              }),
	              this.getTopTwentydata(tableData)
	            ),
	            canEdit && !editScheduleForm && _react2.default.createElement(
	              'div',
	              { className: 'editable' },
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary', onClick: toggleScheduleForm },
	                'Edit'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return TopTwenty;
	}(_react.Component);
	
	TopTwenty.defaultProps = {
	  type: 'top20',
	  scheduleFiltersProps: {},
	  viewFilters: {},
	  keyword: '',
	  value_from: '',
	  value_to: ''
	};
	
	TopTwenty.propTypes = {
	  schedule: _propTypes2.default.any.isRequired,
	  type: _propTypes2.default.string,
	  scheduleFiltersProps: _propTypes2.default.object,
	  viewFilters: _propTypes2.default.object,
	  keyword: _propTypes2.default.string,
	  value_to: _propTypes2.default.string,
	  value_from: _propTypes2.default.string,
	  editScheduleForm: _propTypes2.default.bool.isRequired,
	  canEdit: _propTypes2.default.bool.isRequired,
	  can_see_details: _propTypes2.default.bool.isRequired,
	  onCancel: _propTypes2.default.func.isRequired,
	  onSubmit: _propTypes2.default.func.isRequired,
	  toggleScheduleForm: _propTypes2.default.func.isRequired
	};
	
	exports.default = TopTwenty;

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _reactBootstrap = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var InputField = function InputField(_ref) {
	  var input = _ref.input,
	      rest = _objectWithoutProperties(_ref, ['input']);
	
	  return _react2.default.createElement(_reactBootstrap.FormControl, _extends({}, input, rest));
	};
	
	var NumberField = function NumberField(_ref2) {
	  var input = _ref2.input,
	      rest = _objectWithoutProperties(_ref2, ['input']);
	
	  return _react2.default.createElement(
	    _reactBootstrap.InputGroup,
	    null,
	    _react2.default.createElement(
	      _reactBootstrap.InputGroup.Addon,
	      null,
	      '$'
	    ),
	    _react2.default.createElement(_reactBootstrap.FormControl, _extends({ bsSize: 'small', type: 'text' }, input, rest))
	  );
	};
	
	exports.default = function (creditor, index) {
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'tr',
	      null,
	      _react2.default.createElement(
	        'td',
	        { rowSpan: 2 },
	        _react2.default.createElement(
	          'label',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'label' },
	            'Name'
	          )
	        ),
	        _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.creditor_name', component: InputField, placeholder: 'Name' }),
	        _react2.default.createElement(
	          'label',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'label' },
	            'Street'
	          )
	        ),
	        _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.creditor_address_street', component: InputField, placeholder: 'Street' }),
	        _react2.default.createElement(
	          'label',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'label' },
	            'City'
	          )
	        ),
	        _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.creditor_address_city', component: InputField, placeholder: 'City' }),
	        _react2.default.createElement(
	          'label',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'label' },
	            'State'
	          )
	        ),
	        _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.creditor_address_state', component: InputField, placeholder: 'State' }),
	        _react2.default.createElement(
	          'label',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'label' },
	            'Zip Code'
	          )
	        ),
	        _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.creditor_address_zip_code', component: InputField, placeholder: 'Zip Code' }),
	        _react2.default.createElement(
	          'label',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'label' },
	            'Country'
	          )
	        ),
	        _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.creditor_address_country', component: InputField, placeholder: 'Country' })
	      ),
	      _react2.default.createElement(
	        'td',
	        null,
	        _react2.default.createElement(_reactFinalForm.Field, {
	          name: creditor + '.contact_address',
	          component: InputField,
	          componentClass: 'textarea',
	          rows: '4',
	          className: 'address',
	          cols: '15',
	          placeholder: 'Creditor Telephone and Email Contact'
	        })
	      ),
	      _react2.default.createElement(
	        'td',
	        null,
	        _react2.default.createElement(_reactFinalForm.Field, {
	          name: creditor + '.claim_type',
	          component: InputField,
	          type: 'text',
	          className: 'claimType',
	          size: '15',
	          placeholder: 'Nature of the claim'
	        })
	      ),
	      _react2.default.createElement(
	        'td',
	        null,
	        _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.claim_status', component: InputField, componentClass: 'textarea' })
	      )
	    ),
	    _react2.default.createElement(
	      'tr',
	      { style: { borderBottom: '1px solid gray' } },
	      _react2.default.createElement(
	        'td',
	        { colSpan: 3 },
	        _react2.default.createElement(
	          'table',
	          { id: 'creditors' },
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                { colSpan: '3', style: { width: 270 } },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label' },
	                  'Amount of unsecured claim'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                null,
	                'Total claim, if partially secured'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Deduction for value of collateral or setoff'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Unsecured claim'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            _react2.default.createElement(
	              'td',
	              { className: 'money' },
	              _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.total', component: NumberField, size: '8' })
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'money' },
	              _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.deduction', component: NumberField, size: '8' })
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'money' },
	              _react2.default.createElement(_reactFinalForm.Field, { name: creditor + '.unsecured', component: NumberField, size: '8' })
	            )
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _finalFormArrays = __webpack_require__(189);
	
	var _finalFormArrays2 = _interopRequireDefault(_finalFormArrays);
	
	var _reactFinalFormArrays = __webpack_require__(322);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _currencyConversion = __webpack_require__(72);
	
	var _currencyConversion2 = _interopRequireDefault(_currencyConversion);
	
	__webpack_require__(951);
	
	var _TopTwentyCreditorForm = __webpack_require__(742);
	
	var _TopTwentyCreditorForm2 = _interopRequireDefault(_TopTwentyCreditorForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TopTwentyForm = function (_Component) {
	  _inherits(TopTwentyForm, _Component);
	
	  function TopTwentyForm() {
	    _classCallCheck(this, TopTwentyForm);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  TopTwentyForm.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        onSubmit = _props.onSubmit,
	        schedule = _props.schedule;
	
	
	    var confirm_remove_claim = function confirm_remove_claim() {
	      return confirm('Remove this creditor?');
	    };
	    var confirm_move_claim = function confirm_move_claim() {
	      return confirm('Move / renumber this claim?');
	    };
	    var initialValue = { creditors: _lodash2.default.cloneDeep(_lodash2.default.get(schedule, 'data.creditors', [])) };
	    initialValue.creditors.map(function (creditor) {
	      creditor.total = _currencyConversion2.default.toDollarsOrStr(creditor.total);
	      creditor.deduction = _currencyConversion2.default.toDollarsOrStr(creditor.deduction);
	      creditor.unsecured = _currencyConversion2.default.toDollarsOrStr(creditor.unsecured);
	      return creditor;
	    });
	    return _react2.default.createElement(_reactFinalForm.Form, {
	      initialValues: initialValue,
	      onSubmit: onSubmit,
	      mutators: _extends({}, _finalFormArrays2.default),
	      render: function render(_ref) {
	        var handleSubmit = _ref.handleSubmit,
	            pristine = _ref.pristine,
	            form = _ref.form,
	            submitting = _ref.submitting,
	            values = _ref.values;
	        return _react2.default.createElement(
	          'form',
	          { onSubmit: handleSubmit, id: 'parser-schedule-top20-form' },
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'ir-search-double' },
	            _react2.default.createElement(
	              'table',
	              { id: 'creditors' },
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    { colSpan: 2, rowSpan: '2', style: { width: 125 } },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'Creditor name and address'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { rowSpan: '2', style: { width: 125 } },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'Creditor contact information'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { rowSpan: '2', style: { width: 115 } },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'Nature of the claim'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { rowSpan: '2', style: { width: 100 } },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label' },
	                      'Indicate if claim is contingent, unliquidated, or disputed'
	                    )
	                  )
	                ),
	                _react2.default.createElement('tr', null)
	              ),
	              _react2.default.createElement(
	                'tbody',
	                null,
	                _react2.default.createElement(
	                  _reactFinalFormArrays.FieldArray,
	                  { name: 'creditors' },
	                  function (_ref2) {
	                    var fields = _ref2.fields;
	                    return fields.map(function (name, index) {
	                      return _react2.default.createElement(
	                        _react.Fragment,
	                        null,
	                        _react2.default.createElement(
	                          'tr',
	                          { key: index + '-top20' },
	                          _react2.default.createElement(
	                            'td',
	                            { rowSpan: 3 },
	                            _react2.default.createElement(
	                              'h2',
	                              null,
	                              index + 1,
	                              '.'
	                            ),
	                            _react2.default.createElement('br', null),
	                            index > 0 && _react2.default.createElement(
	                              _react2.default.Fragment,
	                              null,
	                              _react2.default.createElement(
	                                'div',
	                                {
	                                  className: 'btn btn-primary btn-sm',
	                                  onClick: function onClick() {
	                                    return confirm_move_claim() && fields.swap(index, index - 1);
	                                  },
	                                  title: 'Swap this claim with ' + index,
	                                  style: { width: '1em' }
	                                },
	                                '\u25B2'
	                              ),
	                              _react2.default.createElement('br', null)
	                            ),
	                            index < fields.length - 1 && _react2.default.createElement(
	                              _react2.default.Fragment,
	                              null,
	                              _react2.default.createElement(
	                                'div',
	                                {
	                                  className: 'btn btn-primary btn-sm',
	                                  onClick: function onClick() {
	                                    return confirm_move_claim() && fields.swap(index, index + 1);
	                                  },
	                                  title: 'Swap this claim with ' + (index + 2),
	                                  style: { width: '1em' }
	                                },
	                                '\u25BC'
	                              ),
	                              _react2.default.createElement('br', null)
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              {
	                                className: 'btn btn-danger btn-sm',
	                                onClick: function onClick() {
	                                  return confirm_remove_claim() && fields.remove(index);
	                                },
	                                title: 'Remove claim',
	                                style: { width: '1em' }
	                              },
	                              'X'
	                            )
	                          )
	                        ),
	                        (0, _TopTwentyCreditorForm2.default)(name, index, values)
	                      );
	                    });
	                  }
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'editable' },
	              _react2.default.createElement(
	                'button',
	                { type: 'button', onClick: function onClick() {
	                    return form.mutators.push('creditors', {});
	                  } },
	                'Add creditor'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'buttons' },
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'submit',
	                  disabled: submitting || pristine && !_this2.props.isDraft,
	                  className: 'btn btn-primary'
	                },
	                'Submit Changes'
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  onClick: function onClick() {
	                    if (pristine || confirm('You are about to lose unsaved changes!\nPress "Cancel" to continue editing, "OK" to discard changes!')) _this2.props.onCancel();
	                  },
	                  disabled: submitting,
	                  className: 'btn btn-link ' + (pristine ? '' : 'cancel-link')
	                },
	                pristine ? 'Cancel Editing' : 'Discard Changes'
	              )
	            )
	          )
	        );
	      }
	    });
	  };
	
	  return TopTwentyForm;
	}(_react.Component);
	
	TopTwentyForm.propTypes = {
	  onSubmit: _propTypes2.default.func,
	  schedule: _propTypes2.default.any.isRequired,
	  isDraft: _propTypes2.default.bool
	};
	TopTwentyForm.defaultProps = {
	  onSubmit: function onSubmit() {
	    return null;
	  }
	};
	exports.default = TopTwentyForm;

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.initAWSMobileAnalytics = exports.logActionToAWSAnalytics = exports.logException = exports.logActionToRaven = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _immutable = __webpack_require__(30);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// AWS doesn't apparently know how to work with modern js, need to import the compiled version which exposes to window
	// import entire SDK - https://github.com/aws/aws-sdk-js/issues/603
	// import 'aws-sdk/dist/aws-sdk';
	// const AWS = window.AWS;
	//
	// import 'aws-sdk-mobile-analytics/dist/aws-sdk-mobile-analytics';
	// const AMA = window.AMA;
	
	
	/**
	 * TODO
	 * Note: for the sake of time, i'm lazy loading this with a manual stub during unit 'tests'.
	 * Need to figure out a better overall global mocking strategy since I'm having issues with jsdom-global
	 * http://airbnb.io/enzyme/docs/guides/jsdom.html
	 */
	var RavenStub = {
	  config: function config() {
	    return this;
	  },
	  install: function install() {
	    return this;
	  },
	  setTagsContext: function setTagsContext() {
	    return this;
	  },
	  setUserContext: function setUserContext() {
	    return this;
	  },
	  captureMessage: function captureMessage() {
	    return this;
	  },
	  captureBreadcrumb: function captureBreadcrumb() {
	    return this;
	  },
	  captureException: function captureException() {
	    console.error('raven exception');
	    return this;
	  }
	};
	var Raven =  false ? RavenStub : __webpack_require__(863);
	
	Raven.config('https://1fa9ee9c3f284073819aade25c957ea6@sentry.courtdrive.com/165', {
	  autoBreadcrumbs: {
	    console: false
	  },
	  environment: ("production")
	}).install();
	// .setTagsContext({
	//   environment: process.env.NODE_ENV || 'development',
	// });
	
	function getDrupalUser() {
	  return window.Drupal && window.Drupal.settings ? window.Drupal.settings.currentUser || '' : '';
	}
	
	function applyDeep(o, func) {
	  for (var i in o) {
	    func.apply(this, [o, i]);
	    if (o[i] !== null && _typeof(o[i]) === 'object') {
	      // going on step down in the object tree!!
	      applyDeep(o[i], func);
	    }
	  }
	}
	
	function removeNulls(obj, key) {
	  if (obj[key] === undefined || obj[key] === null) {
	    delete obj[key];
	  }
	  return obj;
	}
	
	/**
	 * @param attributes
	 * @returns {*}
	 * Removes null values and truncates values 200 chars for recordEvent (side effecty)
	 */
	var truncateAWSAttributes = function truncateAWSAttributes(attributes) {
	  applyDeep(attributes, removeNulls);
	
	  return _lodash2.default.mapValues(attributes, function (v) {
	    var asString = typeof v === 'string' ? v : JSON.stringify(v);
	
	    return asString.substr(0, 200);
	  });
	};
	
	// add more actions you want to log here as needed
	var actionMessagesMapper = {
	  SERVICE_ERROR: function SERVICE_ERROR(action, state) {
	    // Raven.setUserContext({
	    //   currentUser: getDrupalUser(),
	    // });
	    //
	    // Raven.captureMessage(action.type, {
	    //   extra: {
	    //     action,
	    //     state,
	    //   },
	    //   level: 'error',
	    // });
	  }
	};
	
	/**
	 * @param action
	 * @param state
	 * Buffers the actions via breadcrumbs which are released when Raven.captureMessage is called on service error
	 */
	var logActionToRaven = exports.logActionToRaven = function logActionToRaven(action, state) {
	  // Buffer the actions (breadcrumbs) to be released by raven whenever Raven.captureMessage is called
	  // Raven.captureBreadcrumb({
	  //   message: action.type,
	  //   category: 'action',
	  //   data: {
	  //     action,
	  //     state,
	  //   },
	  // });
	
	  var errorMessage = actionMessagesMapper[action.type];
	  if (errorMessage) {
	    errorMessage(action, state);
	  }
	};
	
	var logException = exports.logException = function logException(error, info) {
	  console.error('Uncaught React Exception', error, info);
	  Raven.captureException(error);
	  // Raven.showReportDialog();
	  return Raven.lastEventId();
	};
	
	// Note: recordEvent takes the attributes, metrics and stringifies whatever you input.
	// this is an actual mutation, be careful it modifies the actual source variable as well
	var logActionToAWSAnalytics = exports.logActionToAWSAnalytics = function logActionToAWSAnalytics(action, state) {
	  // record event takes optional args attributes, metrics
	  var name = action.type || 'action';
	  var currentUser = { currentUser: getDrupalUser() };
	  var attributes = Object.assign({}, currentUser, action);
	  var truncatedAttributes = truncateAWSAttributes(attributes);
	
	  window.mobileAnalyticsClient.recordEvent(name, truncatedAttributes);
	};
	
	var initAWSMobileAnalytics = exports.initAWSMobileAnalytics = function initAWSMobileAnalytics() {
	  window.AWS.config.region = 'us-east-1';
	  window.AWS.config.credentials = new window.AWS.CognitoIdentityCredentials({
	    IdentityPoolId: 'us-east-1:7da6a325-e959-4876-a13d-b516964d3e1f' // Amazon Cognito Identity Pool ID
	  });
	
	  // There's nowhere to place an environment config?
	  // Suggestion is to use a seperate config but for now I'm just skipping dev logging
	  // http://stackoverflow.com/questions/29803540/aws-mobile-analytics-enviornment
	  var options = {
	    appId: '1c31009f8a174788a57274fac211b38f', // Amazon Mobile Analytics App ID
	    appTitle: 'Justin Example App' // Optional e.g. 'Example App'
	    // ,logger   : console                        //Optional helps with debugging
	    // appVersionName : APP_VERSION_NAME, //Optional e.g. '1.4.1'
	    // appVersionCode : APP_VERSION_CODE, //Optional e.g. '42'
	    // appPackageName : APP_PACKAGE_NAME  //Optional e.g. 'com.amazon.example'
	  };
	
	  window.mobileAnalyticsClient = new window.AMA.Manager(options);
	};

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1320), __esModule: true };

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1331), __esModule: true };

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(1260);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(1259);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _removeNonPrintingValuesTransformer = __webpack_require__(1300);
	
	var _removeNonPrintingValuesTransformer2 = _interopRequireDefault(_removeNonPrintingValuesTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _removeNonPrintingValuesTransformer2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZW1vdmVOb25QcmludGluZ1ZhbHVlc1RyYW5zZm9ybWVyL2luZGV4LmpzIl0sIm5hbWVzIjpbImRlZmF1bHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7UUFBT0EsTyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZyb20gJy4vcmVtb3ZlTm9uUHJpbnRpbmdWYWx1ZXNUcmFuc2Zvcm1lcic7XG4iXX0=

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _replaceSubstitutionTransformer = __webpack_require__(1304);
	
	var _replaceSubstitutionTransformer2 = _interopRequireDefault(_replaceSubstitutionTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _replaceSubstitutionTransformer2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZXBsYWNlU3Vic3RpdHV0aW9uVHJhbnNmb3JtZXIvaW5kZXguanMiXSwibmFtZXMiOlsiZGVmYXVsdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztRQUFPQSxPIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnJvbSAnLi9yZXBsYWNlU3Vic3RpdHV0aW9uVHJhbnNmb3JtZXInO1xuIl19

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var deselectCurrent = __webpack_require__(2216);
	
	var clipboardToIE11Formatting = {
	  "text/plain": "Text",
	  "text/html": "Url",
	  "default": "Text"
	}
	
	var defaultMessage = "Copy to clipboard: #{key}, Enter";
	
	function format(message) {
	  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
	  return message.replace(/#{\s*key\s*}/g, copyKey);
	}
	
	function copy(text, options) {
	  var debug,
	    message,
	    reselectPrevious,
	    range,
	    selection,
	    mark,
	    success = false;
	  if (!options) {
	    options = {};
	  }
	  debug = options.debug || false;
	  try {
	    reselectPrevious = deselectCurrent();
	
	    range = document.createRange();
	    selection = document.getSelection();
	
	    mark = document.createElement("span");
	    mark.textContent = text;
	    // reset user styles for span element
	    mark.style.all = "unset";
	    // prevents scrolling to the end of the page
	    mark.style.position = "fixed";
	    mark.style.top = 0;
	    mark.style.clip = "rect(0, 0, 0, 0)";
	    // used to preserve spaces and line breaks
	    mark.style.whiteSpace = "pre";
	    // do not inherit user-select (it may be `none`)
	    mark.style.webkitUserSelect = "text";
	    mark.style.MozUserSelect = "text";
	    mark.style.msUserSelect = "text";
	    mark.style.userSelect = "text";
	    mark.addEventListener("copy", function(e) {
	      e.stopPropagation();
	      if (options.format) {
	        e.preventDefault();
	        if (typeof e.clipboardData === "undefined") { // IE 11
	          debug && console.warn("unable to use e.clipboardData");
	          debug && console.warn("trying IE specific stuff");
	          window.clipboardData.clearData();
	          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"]
	          window.clipboardData.setData(format, text);
	        } else { // all other browsers
	          e.clipboardData.clearData();
	          e.clipboardData.setData(options.format, text);
	        }
	      }
	      if (options.onCopy) {
	        e.preventDefault();
	        options.onCopy(e.clipboardData);
	      }
	    });
	
	    document.body.appendChild(mark);
	
	    range.selectNodeContents(mark);
	    selection.addRange(range);
	
	    var successful = document.execCommand("copy");
	    if (!successful) {
	      throw new Error("copy command was unsuccessful");
	    }
	    success = true;
	  } catch (err) {
	    debug && console.error("unable to copy using execCommand: ", err);
	    debug && console.warn("trying IE specific stuff");
	    try {
	      window.clipboardData.setData(options.format || "text", text);
	      options.onCopy && options.onCopy(window.clipboardData);
	      success = true;
	    } catch (err) {
	      debug && console.error("unable to copy using clipboardData: ", err);
	      debug && console.error("falling back to prompt");
	      message = format("message" in options ? options.message : defaultMessage);
	      window.prompt(message, text);
	    }
	  } finally {
	    if (selection) {
	      if (typeof selection.removeRange == "function") {
	        selection.removeRange(range);
	      } else {
	        selection.removeAllRanges();
	      }
	    }
	
	    if (mark) {
	      document.body.removeChild(mark);
	    }
	    reselectPrevious();
	  }
	
	  return success;
	}
	
	module.exports = copy;


/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(217);
	__webpack_require__(1357);
	module.exports = __webpack_require__(28).Array.from;


/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1362);
	module.exports = __webpack_require__(28).Object.assign;


/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1363);
	var $Object = __webpack_require__(28).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1365);
	var $Object = __webpack_require__(28).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1367);
	var $Object = __webpack_require__(28).Object;
	module.exports = function getOwnPropertyDescriptor(it, key) {
	  return $Object.getOwnPropertyDescriptor(it, key);
	};


/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1369);
	module.exports = __webpack_require__(28).Object.keys;


/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(452);
	__webpack_require__(218);
	__webpack_require__(1374);
	__webpack_require__(1382);
	__webpack_require__(1381);
	module.exports = __webpack_require__(28).WeakMap;


/***/ },
/* 758 */
[2266, 44],
/* 759 */
[2267, 73, 116, 434],
/* 760 */
[2269, 181, 56],
/* 761 */
[2271, 83],
/* 762 */
[2273, 212, 39, 443, 118, 181, 1342, 216, 767, 56],
/* 763 */
[2274, 56],
/* 764 */
[2278, 73, 182, 441, 214, 142, 436, 116],
/* 765 */
[2281, 95, 83, 182, 73],
/* 766 */
[2284, 768, 435],
/* 767 */
[2285, 117, 142, 444],
/* 768 */
[2286, 117, 119, 1334, 444],
/* 769 */
[2289, 73, 182, 119, 214],
/* 770 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ },
/* 771 */
[2291, 83, 61, 438],
/* 772 */
[2298, 83, 210, 56],
/* 773 */
474,
/* 774 */
[2301, 115, 1341, 758, 434, 44, 211],
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(84);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(43);
	var toAbsoluteIndex = __webpack_require__(151);
	var toLength = __webpack_require__(37);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(144);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(57);
	var toObject = __webpack_require__(43);
	var IObject = __webpack_require__(220);
	var toLength = __webpack_require__(37);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(57);
	var isObject = __webpack_require__(29);
	var invoke = __webpack_require__(785);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(41).f;
	var create = __webpack_require__(145);
	var redefineAll = __webpack_require__(149);
	var ctx = __webpack_require__(86);
	var anInstance = __webpack_require__(143);
	var forOf = __webpack_require__(144);
	var $iterDefine = __webpack_require__(464);
	var step = __webpack_require__(788);
	var setSpecies = __webpack_require__(150);
	var DESCRIPTORS = __webpack_require__(38);
	var fastKey = __webpack_require__(122).fastKey;
	var validate = __webpack_require__(153);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(183);
	var from = __webpack_require__(777);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ },
/* 782 */
[2258, 149, 122, 22, 29, 143, 144, 96, 74, 153],
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(289);
	var isObject = __webpack_require__(29);
	var toLength = __webpack_require__(37);
	var ctx = __webpack_require__(86);
	var IS_CONCAT_SPREADABLE = __webpack_require__(36)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ },
/* 784 */
[2267, 38, 27, 457],
/* 785 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(29);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ },
/* 787 */
[2271, 22],
/* 788 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(466);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ },
/* 790 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ },
/* 791 */
/***/ function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ },
/* 792 */
[2278, 38, 147, 293, 221, 43, 220, 27],
/* 793 */
[2281, 41, 22, 147, 38],
/* 794 */
[2283, 77, 146],
/* 795 */
[2286, 74, 77, 286, 471],
/* 796 */
[2289, 38, 147, 77, 221],
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(146);
	var gOPS = __webpack_require__(293);
	var anObject = __webpack_require__(22);
	var Reflect = __webpack_require__(25).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(25).parseFloat;
	var $trim = __webpack_require__(186).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(474) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ },
/* 799 */
[2290, 25, 186, 474],
/* 800 */
770,
/* 801 */
[2291, 22, 29, 468],
/* 802 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(37);
	var repeat = __webpack_require__(473);
	var defined = __webpack_require__(97);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(88);
	var toLength = __webpack_require__(37);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ },
/* 805 */
[2310, 36],
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(780);
	var validate = __webpack_require__(153);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(287)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(469);
	__webpack_require__(3)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(38) && /./g.flags != 'g') __webpack_require__(41).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(219)
	});


/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(780);
	var validate = __webpack_require__(153);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(287)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ },
/* 810 */
[2331, 25, 96, 66, 122, 792, 782, 29, 153, 153, 287],
/* 811 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addLeadingZeros;
	
	function addLeadingZeros(number, targetLength) {
	  var sign = number < 0 ? '-' : '';
	  var output = Math.abs(number).toString();
	
	  while (output.length < targetLength) {
	    output = '0' + output;
	  }
	
	  return sign + output;
	}
	
	module.exports = exports.default;

/***/ },
/* 812 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	function dateLongFormatter(pattern, formatLong) {
	  switch (pattern) {
	    case 'P':
	      return formatLong.date({
	        width: 'short'
	      });
	
	    case 'PP':
	      return formatLong.date({
	        width: 'medium'
	      });
	
	    case 'PPP':
	      return formatLong.date({
	        width: 'long'
	      });
	
	    case 'PPPP':
	    default:
	      return formatLong.date({
	        width: 'full'
	      });
	  }
	}
	
	function timeLongFormatter(pattern, formatLong) {
	  switch (pattern) {
	    case 'p':
	      return formatLong.time({
	        width: 'short'
	      });
	
	    case 'pp':
	      return formatLong.time({
	        width: 'medium'
	      });
	
	    case 'ppp':
	      return formatLong.time({
	        width: 'long'
	      });
	
	    case 'pppp':
	    default:
	      return formatLong.time({
	        width: 'full'
	      });
	  }
	}
	
	function dateTimeLongFormatter(pattern, formatLong) {
	  var matchResult = pattern.match(/(P+)(p+)?/);
	  var datePattern = matchResult[1];
	  var timePattern = matchResult[2];
	
	  if (!timePattern) {
	    return dateLongFormatter(pattern, formatLong);
	  }
	
	  var dateTimeFormat;
	
	  switch (datePattern) {
	    case 'P':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'short'
	      });
	      break;
	
	    case 'PP':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'medium'
	      });
	      break;
	
	    case 'PPP':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'long'
	      });
	      break;
	
	    case 'PPPP':
	    default:
	      dateTimeFormat = formatLong.dateTime({
	        width: 'full'
	      });
	      break;
	  }
	
	  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
	}
	
	var longFormatters = {
	  p: timeLongFormatter,
	  P: dateTimeLongFormatter
	};
	var _default = longFormatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(300));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1677));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	
	function getUTCISOWeek(dirtyDate) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime(); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	
	module.exports = exports.default;

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(300));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function getUTCISOWeekYear(dirtyDate) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getUTCFullYear();
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index2.default)(fourthOfJanuaryOfNextYear);
	  var fourthOfJanuaryOfThisYear = new Date(0);
	  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
	  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index2.default)(fourthOfJanuaryOfThisYear);
	
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(301));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1678));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	
	function getUTCWeek(dirtyDate, options) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date, options).getTime() - (0, _index3.default)(date, options).getTime(); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	
	module.exports = exports.default;

/***/ },
/* 816 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
	exports.isProtectedWeekYearToken = isProtectedWeekYearToken;
	exports.throwProtectedError = throwProtectedError;
	var protectedDayOfYearTokens = ['D', 'DD'];
	var protectedWeekYearTokens = ['YY', 'YYYY'];
	
	function isProtectedDayOfYearToken(token) {
	  return protectedDayOfYearTokens.indexOf(token) !== -1;
	}
	
	function isProtectedWeekYearToken(token) {
	  return protectedWeekYearTokens.indexOf(token) !== -1;
	}
	
	function throwProtectedError(token) {
	  if (token === 'YYYY') {
	    throw new RangeError('Use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr');
	  } else if (token === 'YY') {
	    throw new RangeError('Use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr');
	  } else if (token === 'D') {
	    throw new RangeError('Use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr');
	  } else if (token === 'DD') {
	    throw new RangeError('Use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr');
	  }
	}

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addHours;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(482));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_HOUR = 3600000;
	/**
	 * @name addHours
	 * @category Hour Helpers
	 * @summary Add the specified number of hours to the given date.
	 *
	 * @description
	 * Add the specified number of hours to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of hours to be added
	 * @returns {Date} the new date with the hours added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 2 hours to 10 July 2014 23:00:00:
	 * var result = addHours(new Date(2014, 6, 10, 23, 0), 2)
	 * //=> Fri Jul 11 2014 01:00:00
	 */
	
	function addHours(dirtyDate, dirtyAmount) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * MILLISECONDS_IN_HOUR);
	}
	
	module.exports = exports.default;

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(482));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_MINUTE = 60000;
	/**
	 * @name addMinutes
	 * @category Minute Helpers
	 * @summary Add the specified number of minutes to the given date.
	 *
	 * @description
	 * Add the specified number of minutes to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be added
	 * @returns {Date} the new date with the minutes added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 30 minutes to 10 July 2014 12:00:00:
	 * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 12:30:00
	 */
	
	function addMinutes(dirtyDate, dirtyAmount) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
	}
	
	module.exports = exports.default;

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(481));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addWeeks
	 * @category Week Helpers
	 * @summary Add the specified number of weeks to the given date.
	 *
	 * @description
	 * Add the specified number of week to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of weeks to be added
	 * @returns {Date} the new date with the weeks added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 4 weeks to 1 September 2014:
	 * var result = addWeeks(new Date(2014, 8, 1), 4)
	 * //=> Mon Sep 29 2014 00:00:00
	 */
	function addWeeks(dirtyDate, dirtyAmount) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var amount = (0, _index.default)(dirtyAmount);
	  var days = amount * 7;
	  return (0, _index2.default)(dirtyDate, days);
	}
	
	module.exports = exports.default;

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addYears;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(483));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addYears
	 * @category Year Helpers
	 * @summary Add the specified number of years to the given date.
	 *
	 * @description
	 * Add the specified number of years to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be added
	 * @returns {Date} the new date with the years added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 years to 1 September 2014:
	 * var result = addYears(new Date(2014, 8, 1), 5)
	 * //=> Sun Sep 01 2019 00:00:00
	 */
	function addYears(dirtyDate, dirtyAmount) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * 12);
	}
	
	module.exports = exports.default;

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDaysInMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDaysInMonth
	 * @category Month Helpers
	 * @summary Get the number of days in a month of the given date.
	 *
	 * @description
	 * Get the number of days in a month of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the number of days in a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // How many days are in February 2000?
	 * var result = getDaysInMonth(new Date(2000, 1))
	 * //=> 29
	 */
	function getDaysInMonth(dirtyDate) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var monthIndex = date.getMonth();
	  var lastDayOfMonth = new Date(0);
	  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
	  lastDayOfMonth.setHours(0, 0, 0, 0);
	  return lastDayOfMonth.getDate();
	}
	
	module.exports = exports.default;

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValid;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isValid
	 * @category Common Helpers
	 * @summary Is the given date valid?
	 *
	 * @description
	 * Returns false if argument is Invalid Date and true otherwise.
	 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * Invalid Date is a Date, whose time value is NaN.
	 *
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - Now `isValid` doesn't throw an exception
	 *   if the first argument is not an instance of Date.
	 *   Instead, argument is converted beforehand using `toDate`.
	 *
	 *   Examples:
	 *
	 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
	 *   |---------------------------|---------------|---------------|
	 *   | `new Date()`              | `true`        | `true`        |
	 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
	 *   | `new Date('')`            | `false`       | `false`       |
	 *   | `new Date(1488370835081)` | `true`        | `true`        |
	 *   | `new Date(NaN)`           | `false`       | `false`       |
	 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
	 *   | `''`                      | `TypeError`   | `false`       |
	 *   | `1488370835081`           | `TypeError`   | `true`        |
	 *   | `NaN`                     | `TypeError`   | `false`       |
	 *
	 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
	 *   that try to coerce arguments to the expected type
	 *   (which is also the case with other *date-fns* functions).
	 *
	 * @param {*} date - the date to check
	 * @returns {Boolean} the date is valid
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // For the valid date:
	 * var result = isValid(new Date(2014, 1, 31))
	 * //=> true
	 *
	 * @example
	 * // For the value, convertable into a date:
	 * var result = isValid(1393804800000)
	 * //=> true
	 *
	 * @example
	 * // For the invalid date:
	 * var result = isValid(new Date(''))
	 * //=> false
	 */
	function isValid(dirtyDate) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  return !isNaN(date);
	}
	
	module.exports = exports.default;

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1709));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1710));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1711));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1712));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1713));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (United States).
	 * @language English
	 * @iso-639-2 eng
	 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
	 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
	 */
	var locale = {
	  code: 'en-US',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(19));
	
	var _index3 = _interopRequireDefault(__webpack_require__(821));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setMonth
	 * @category Month Helpers
	 * @summary Set the month to the given date.
	 *
	 * @description
	 * Set the month to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} month - the month of the new date
	 * @returns {Date} the new date with the month set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set February to 1 September 2014:
	 * var result = setMonth(new Date(2014, 8, 1), 1)
	 * //=> Sat Feb 01 2014 00:00:00
	 */
	function setMonth(dirtyDate, dirtyMonth) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate);
	  var month = (0, _index.default)(dirtyMonth);
	  var year = date.getFullYear();
	  var day = date.getDate();
	  var dateWithDesiredMonth = new Date(0);
	  dateWithDesiredMonth.setFullYear(year, month, 15);
	  dateWithDesiredMonth.setHours(0, 0, 0, 0);
	  var daysInMonth = (0, _index3.default)(dateWithDesiredMonth); // Set the last day of the new month
	  // if the original date was the last day of the longer month
	
	  date.setMonth(month, Math.min(day, daysInMonth));
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfQuarter
	 * @category Quarter Helpers
	 * @summary Return the start of a year quarter for the given date.
	 *
	 * @description
	 * Return the start of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a quarter for 2 September 2014 11:55:00:
	 * var result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Jul 01 2014 00:00:00
	 */
	function startOfQuarter(dirtyDate) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var currentMonth = date.getMonth();
	  var month = currentMonth - currentMonth % 3;
	  date.setMonth(month, 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfWeek
	 * @category Week Helpers
	 * @summary Return the start of a week for the given date.
	 *
	 * @description
	 * Return the start of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the start of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The start of a week for 2 September 2014 11:55:00:
	 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Aug 31 2014 00:00:00
	 *
	 * @example
	 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
	 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfWeek(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index2.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index2.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setDate(date.getDate() - diff);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(482));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subMilliseconds
	 * @category Millisecond Helpers
	 * @summary Subtract the specified number of milliseconds from the given date.
	 *
	 * @description
	 * Subtract the specified number of milliseconds from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be subtracted
	 * @returns {Date} the new date with the milliseconds subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
	 * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:29.250
	 */
	function subMilliseconds(dirtyDate, dirtyAmount) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(35);
	
	exports.__esModule = true;
	exports.default = activeElement;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(187));
	
	function activeElement(doc) {
	  if (doc === void 0) {
	    doc = (0, _ownerDocument.default)();
	  }
	
	  try {
	    return doc.activeElement;
	  } catch (e) {
	    /* ie throws if no active element */
	  }
	}
	
	module.exports = exports["default"];

/***/ },
/* 829 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(35);
	
	exports.__esModule = true;
	exports.default = offset;
	
	var _contains = _interopRequireDefault(__webpack_require__(188));
	
	var _isWindow = _interopRequireDefault(__webpack_require__(302));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(187));
	
	function offset(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      win = (0, _isWindow.default)(doc),
	      docElem = doc && doc.documentElement,
	      box = {
	    top: 0,
	    left: 0,
	    height: 0,
	    width: 0
	  };
	  if (!doc) return; // Make sure it's not a disconnected DOM node
	
	  if (!(0, _contains.default)(docElem, node)) return box;
	  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height
	
	  box = {
	    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
	    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
	    width: (box.width == null ? node.offsetWidth : box.width) || 0,
	    height: (box.height == null ? node.offsetHeight : box.height) || 0
	  };
	  return box;
	}
	
	module.exports = exports["default"];

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(35);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(302));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	}
	
	module.exports = exports["default"];

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(35);
	
	exports.__esModule = true;
	exports.default = camelizeStyleName;
	
	var _camelize = _interopRequireDefault(__webpack_require__(1747));
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	 */
	var msPattern = /^-ms-/;
	
	function camelizeStyleName(string) {
	  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = exports["default"];

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(35);
	
	exports.__esModule = true;
	exports.default = scrollbarSize;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(123));
	
	var size;
	
	function scrollbarSize(recalc) {
	  if (!size && size !== 0 || recalc) {
	    if (_inDOM.default) {
	      var scrollDiv = document.createElement('div');
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	}
	
	module.exports = exports["default"];

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(1752);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f4769f9bdb7466be65088239c12046d1.eot";

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "674f50d287a8c48dc19ba404d20fe713.eot";

/***/ },
/* 837 */
836,
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "912ec66d7572ff821749319396470bde.svg";

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b06871f281fee6b241d60582ae9369b9.ttf";

/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var finalForm = __webpack_require__(124);
	
	var isPromise = (function (obj) {
	  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	});
	
	//      
	
	var tripleEquals = function tripleEquals(a, b) {
	  return a === b;
	};
	
	var createDecorator = function createDecorator() {
	  for (var _len = arguments.length, calculations = new Array(_len), _key = 0; _key < _len; _key++) {
	    calculations[_key] = arguments[_key];
	  }
	
	  return function (form) {
	    var previousValues = {};
	    var unsubscribe = form.subscribe(function (_ref) {
	      var values = _ref.values;
	      form.batch(function () {
	        var runUpdates = function runUpdates(field, isEqual, updates) {
	          var next = values && finalForm.getIn(values, field);
	          var previous = previousValues && finalForm.getIn(previousValues, field);
	
	          if (!isEqual(next, previous)) {
	            if (typeof updates === 'function') {
	              var results = updates(next, field, values, previousValues);
	
	              if (isPromise(results)) {
	                results.then(function (resolved) {
	                  Object.keys(resolved).forEach(function (destField) {
	                    form.change(destField, resolved[destField]);
	                  });
	                });
	              } else {
	                Object.keys(results).forEach(function (destField) {
	                  form.change(destField, results[destField]);
	                });
	              }
	            } else {
	              Object.keys(updates).forEach(function (destField) {
	                var update = updates[destField];
	                var result = update(next, values, previousValues);
	
	                if (isPromise(result)) {
	                  result.then(function (resolved) {
	                    form.change(destField, resolved);
	                  });
	                } else {
	                  form.change(destField, result);
	                }
	              });
	            }
	          }
	        };
	
	        var fields = form.getRegisteredFields();
	        calculations.forEach(function (_ref2) {
	          var field = _ref2.field,
	              isEqual = _ref2.isEqual,
	              updates = _ref2.updates;
	
	          if (typeof field === 'string') {
	            runUpdates(field, isEqual || tripleEquals, updates);
	          } else {
	            // field is a either array or regex
	            var matches = Array.isArray(field) ? function (name) {
	              return ~field.indexOf(name) || field.findIndex(function (f) {
	                return f instanceof RegExp && f.test(name);
	              }) !== -1;
	            } : function (name) {
	              return field.test(name);
	            };
	            fields.forEach(function (fieldName) {
	              if (matches(fieldName)) {
	                runUpdates(fieldName, isEqual || tripleEquals, updates);
	              }
	            });
	          }
	        });
	        previousValues = values;
	      });
	    }, {
	      values: true
	    });
	    return unsubscribe;
	  };
	};
	
	//
	
	exports.default = createDecorator;


/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2209);


/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.processStyleName = undefined;
	exports.createMarkupForStyles = createMarkupForStyles;
	
	var _camelizeStyleName = __webpack_require__(1751);
	
	var _camelizeStyleName2 = _interopRequireDefault(_camelizeStyleName);
	
	var _dangerousStyleValue = __webpack_require__(1767);
	
	var _dangerousStyleValue2 = _interopRequireDefault(_dangerousStyleValue);
	
	var _hyphenateStyleName = __webpack_require__(1754);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _memoizeStringOnly = __webpack_require__(1755);
	
	var _memoizeStringOnly2 = _interopRequireDefault(_memoizeStringOnly);
	
	var _warning = __webpack_require__(834);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var processStyleName = exports.processStyleName = (0, _memoizeStringOnly2.default)(_hyphenateStyleName2.default); /**
	                                                                                                                   * Copyright 2013-present, Facebook, Inc.
	                                                                                                                   * All rights reserved.
	                                                                                                                   *
	                                                                                                                   * This source code is licensed under the BSD-style license found in the
	                                                                                                                   * LICENSE file in the root directory of this source tree. An additional grant
	                                                                                                                   * of patent rights can be found in the PATENTS file in the same directory.
	                                                                                                                   *
	                                                                                                                   * @providesModule CSSPropertyOperations
	                                                                                                                   */
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function warnHyphenatedStyleName(name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Unsupported style property %s. Did you mean %s?%s', name, (0, _camelizeStyleName2.default)(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function warnBadVendoredStyleName(name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function warnStyleValueWithSemicolon(name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function warnStyleValueIsNaN(name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function checkRenderMessage(owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function warnValidStyle(name, value, component) {
	    //eslint-disable-line no-var
	    var owner = void 0;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	
	function createMarkupForStyles(styles, component) {
	  var serialized = '';
	  for (var styleName in styles) {
	    var isCustomProp = styleName.indexOf('--') === 0;
	    if (!styles.hasOwnProperty(styleName)) {
	      continue;
	    }
	    if (styleName === 'label') {
	      continue;
	    }
	    var styleValue = styles[styleName];
	    if (false) {
	      warnValidStyle(styleName, styleValue, component);
	    }
	    if (styleValue != null) {
	      if (isCustomProp) {
	        serialized += styleName + ':' + styleValue + ';';
	      } else {
	        serialized += processStyleName(styleName) + ':';
	        serialized += (0, _dangerousStyleValue2.default)(styleName, styleValue, component) + ';';
	      }
	    }
	  }
	  return serialized || null;
	}

/***/ },
/* 843 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path.substr(1) : path;
	};
	
	var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
	  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
	};
	
	var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
	  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
	};
	
	var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
	  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = path || '/';
	  var search = '';
	  var hash = '';
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substr(hashIndex);
	    pathname = pathname.substr(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substr(searchIndex);
	    pathname = pathname.substr(0, searchIndex);
	  }
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  var pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	
	  var path = pathname || '/';
	
	  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
	
	  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
	
	  return path;
	};

/***/ },
/* 844 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = capitalizeString;
	function capitalizeString(str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	}
	module.exports = exports["default"];

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(305),
	    stackClear = __webpack_require__(1883),
	    stackDelete = __webpack_require__(1884),
	    stackGet = __webpack_require__(1885),
	    stackHas = __webpack_require__(1886),
	    stackSet = __webpack_require__(1887);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(1824),
	    createBaseEach = __webpack_require__(1849);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(850),
	    isKey = __webpack_require__(308),
	    toKey = __webpack_require__(227);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1829),
	    isObject = __webpack_require__(192),
	    isObjectLike = __webpack_require__(228);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {boolean} [bitmask] The bitmask of comparison flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - Unordered comparison
	 *     2 - Partial comparison
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, bitmask, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(1836),
	    baseMatchesProperty = __webpack_require__(1837),
	    identity = __webpack_require__(1892),
	    isArray = __webpack_require__(89),
	    property = __webpack_require__(1899);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(89),
	    stringToPath = __webpack_require__(1888);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	module.exports = castPath;


/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(1812),
	    arraySome = __webpack_require__(1819);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!seen.has(othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	              return seen.add(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, customizer, bitmask, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 852 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(850),
	    isArguments = __webpack_require__(495),
	    isArray = __webpack_require__(89),
	    isIndex = __webpack_require__(493),
	    isKey = __webpack_require__(308),
	    isLength = __webpack_require__(496),
	    toKey = __webpack_require__(227);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var result,
	      index = -1,
	      length = path.length;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result) {
	    return result;
	  }
	  var length = object ? object.length : 0;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 854 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	module.exports = isHostObject;


/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(192);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 856 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 857 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(1816),
	    baseFilter = __webpack_require__(1820),
	    baseIteratee = __webpack_require__(849),
	    isArray = __webpack_require__(89);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity]
	 *  The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(492),
	    baseIteratee = __webpack_require__(849),
	    baseMap = __webpack_require__(1835),
	    isArray = __webpack_require__(89);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(1900);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 861 */
[2244, 499],
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(1911);
	exports.encode = exports.stringify = __webpack_require__(1912);


/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Enforces a single instance of the Raven client, and the
	 * main entry point for Raven. If you are a consumer of the
	 * Raven library, you SHOULD load this file (vs raven.js).
	 **/
	
	var RavenConstructor = __webpack_require__(1916);
	
	// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
	var _window =
	  typeof window !== 'undefined'
	    ? window
	    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	var _Raven = _window.Raven;
	
	var Raven = new RavenConstructor();
	
	/*
	 * Allow multiple versions of Raven to be installed.
	 * Strip Raven from the global context and returns the instance.
	 *
	 * @return {Raven}
	 */
	Raven.noConflict = function() {
	  _window.Raven = _Raven;
	  return Raven;
	};
	
	Raven.afterLoad();
	
	module.exports = Raven;
	
	/**
	 * DISCLAIMER:
	 *
	 * Expose `Client` constructor for cases where user want to track multiple "sub-applications" in one larger app.
	 * It's not meant to be used by a wide audience, so pleaaase make sure that you know what you're doing before using it.
	 * Accidentally calling `install` multiple times, may result in an unexpected behavior that's very hard to debug.
	 *
	 * It's called `Client' to be in-line with Raven Node implementation.
	 *
	 * HOWTO:
	 *
	 * import Raven from 'raven-js';
	 *
	 * const someAppReporter = new Raven.Client();
	 * const someOtherAppReporter = new Raven.Client();
	 *
	 * someAppReporter.config('__DSN__', {
	 *   ...config goes here
	 * });
	 *
	 * someOtherAppReporter.config('__OTHER_DSN__', {
	 *   ...config goes here
	 * });
	 *
	 * someAppReporter.captureMessage(...);
	 * someAppReporter.captureException(...);
	 * someAppReporter.captureBreadcrumb(...);
	 *
	 * someOtherAppReporter.captureMessage(...);
	 * someOtherAppReporter.captureException(...);
	 * someOtherAppReporter.captureBreadcrumb(...);
	 *
	 * It should "just work".
	 */
	module.exports.Client = RavenConstructor;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 864 */
/***/ function(module, exports) {

	/*
	 json-stringify-safe
	 Like JSON.stringify, but doesn't throw on circular references.
	
	 Originally forked from https://github.com/isaacs/json-stringify-safe
	 version 5.0.1 on 3/8/2017 and modified to handle Errors serialization
	 and IE8 compatibility. Tests for this are in test/vendor.
	
	 ISC license: https://github.com/isaacs/json-stringify-safe/blob/master/LICENSE
	*/
	
	exports = module.exports = stringify;
	exports.getSerialize = serializer;
	
	function indexOf(haystack, needle) {
	  for (var i = 0; i < haystack.length; ++i) {
	    if (haystack[i] === needle) return i;
	  }
	  return -1;
	}
	
	function stringify(obj, replacer, spaces, cycleReplacer) {
	  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
	}
	
	// https://github.com/ftlabs/js-abbreviate/blob/fa709e5f139e7770a71827b1893f22418097fbda/index.js#L95-L106
	function stringifyError(value) {
	  var err = {
	    // These properties are implemented as magical getters and don't show up in for in
	    stack: value.stack,
	    message: value.message,
	    name: value.name
	  };
	
	  for (var i in value) {
	    if (Object.prototype.hasOwnProperty.call(value, i)) {
	      err[i] = value[i];
	    }
	  }
	
	  return err;
	}
	
	function serializer(replacer, cycleReplacer) {
	  var stack = [];
	  var keys = [];
	
	  if (cycleReplacer == null) {
	    cycleReplacer = function(key, value) {
	      if (stack[0] === value) {
	        return '[Circular ~]';
	      }
	      return '[Circular ~.' + keys.slice(0, indexOf(stack, value)).join('.') + ']';
	    };
	  }
	
	  return function(key, value) {
	    if (stack.length > 0) {
	      var thisPos = indexOf(stack, this);
	      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
	      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
	
	      if (~indexOf(stack, value)) {
	        value = cycleReplacer.call(this, key, value);
	      }
	    } else {
	      stack.push(value);
	    }
	
	    return replacer == null
	      ? value instanceof Error ? stringifyError(value) : value
	      : replacer.call(this, key, value);
	  };
	}


/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Bootstrap2Toggle = undefined;
	
	var _reactBootstrapToggle = __webpack_require__(866);
	
	var _reactBootstrapToggle2 = _interopRequireDefault(_reactBootstrapToggle);
	
	var _reactBootstrap2Toggle = __webpack_require__(1919);
	
	var _reactBootstrap2Toggle2 = _interopRequireDefault(_reactBootstrap2Toggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reactBootstrapToggle2.default;
	exports.Bootstrap2Toggle = _reactBootstrap2Toggle2.default;

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1922);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _resizeObserverPolyfill = __webpack_require__(2141);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	var _utils = __webpack_require__(1920);
	
	var util = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var eitherStringOrInteger = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
	
	var ReactBootstrapToggle = function (_Component) {
	  _inherits(ReactBootstrapToggle, _Component);
	
	  function ReactBootstrapToggle() {
	    _classCallCheck(this, ReactBootstrapToggle);
	
	    var _this = _possibleConstructorReturn(this, (ReactBootstrapToggle.__proto__ || Object.getPrototypeOf(ReactBootstrapToggle)).call(this));
	
	    _this.state = { width: null, height: null };
	    _this.resizeObserver = null;
	    _this.onClick = _this.onClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(ReactBootstrapToggle, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.width && this.props.height) {
	        return;
	      }
	      this.setDimensions();
	      if (this.props.recalculateOnResize) {
	        this.resizeObserver = new _resizeObserverPolyfill2.default(function (ent, obs) {
	          _this2.setDimensions();
	        });
	        this.resizeObserver.observe(this.parent);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props.width && this.props.height) {
	        return;
	      }
	      this.setDimensions();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // shutdown listener
	      if (this.resizeObserver) {
	        this.resizeObserver.unobserve(this.parent);
	      }
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(evt) {
	      if (this.props.disabled) return;
	      if (typeof this.props.onClick === 'function') {
	        this.props.onClick(!this.props.active, this.parent, evt);
	      }
	    }
	  }, {
	    key: 'setDimensions',
	    value: function setDimensions() {
	      var onDim = util.getDimension(this.on);
	      var offDim = util.getDimension(this.off);
	
	      var width = Math.max(onDim.width, offDim.width);
	      var height = Math.max(onDim.height, offDim.height);
	
	      // Check if the sizes are the same with a margin of error of one pixel
	      var areAlmostTheSame = util.compareWithMarginOfError(this.state.width, width, this.props.width) && util.compareWithMarginOfError(this.state.height, height, this.props.height);
	
	      // if they are the same then return
	      if (areAlmostTheSame) {
	        return;
	      }
	
	      this.setState({
	        width: this.props.width || width,
	        height: this.props.height || height
	      });
	    }
	  }, {
	    key: 'getSizeClass',
	    value: function getSizeClass() {
	      if (this.props.size === 'lg') return 'btn-lg';
	      if (this.props.size === 'sm') return 'btn-sm';
	      if (this.props.size === 'xs') return 'btn-xs';
	      return 'btn-md';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _cn,
	          _this3 = this;
	
	      var _props = this.props,
	          active = _props.active,
	          onClick = _props.onClick,
	          onstyle = _props.onstyle,
	          onClassName = _props.onClassName,
	          offstyle = _props.offstyle,
	          offClassName = _props.offClassName,
	          handlestyle = _props.handlestyle,
	          handleClassName = _props.handleClassName,
	          style = _props.style,
	          on = _props.on,
	          off = _props.off,
	          className = _props.className,
	          disabled = _props.disabled,
	          width = _props.width,
	          height = _props.height,
	          recalculateOnResize = _props.recalculateOnResize,
	          props = _objectWithoutProperties(_props, ['active', 'onClick', 'onstyle', 'onClassName', 'offstyle', 'offClassName', 'handlestyle', 'handleClassName', 'style', 'on', 'off', 'className', 'disabled', 'width', 'height', 'recalculateOnResize']);
	
	      var sizeClass = this.getSizeClass();
	
	      var s = {
	        width: this.state.width || width,
	        height: this.state.height || height
	      };
	
	      return (
	        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
	        _react2.default.createElement(
	          'div',
	          _extends({
	            role: 'button',
	            disabled: disabled,
	            className: (0, _classnames2.default)('btn', 'toggle', className, sizeClass, (_cn = {}, _defineProperty(_cn, 'off btn-' + offstyle, !this.props.active), _defineProperty(_cn, 'btn-' + onstyle, this.props.active), _cn)),
	            onClick: this.onClick,
	            style: Object.assign({}, s, style)
	          }, props, {
	            ref: function ref(c) {
	              _this3.parent = c;
	            }
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'toggle-group' },
	            _react2.default.createElement(
	              'span',
	              {
	                ref: function ref(onLabel) {
	                  _this3.on = onLabel;
	                },
	                className: (0, _classnames2.default)('btn toggle-on', sizeClass, onClassName, _defineProperty({}, 'btn-' + onstyle, onstyle)),
	                disabled: disabled
	              },
	              on
	            ),
	            _react2.default.createElement(
	              'span',
	              {
	                ref: function ref(offLabel) {
	                  _this3.off = offLabel;
	                },
	                className: (0, _classnames2.default)('btn toggle-off', sizeClass, offClassName, _defineProperty({}, 'btn-' + offstyle, offstyle)),
	                disabled: disabled
	              },
	              off
	            ),
	            _react2.default.createElement('span', {
	              disabled: disabled,
	              className: (0, _classnames2.default)('toggle-handle btn', sizeClass, handleClassName, _defineProperty({}, 'btn-' + handlestyle, handlestyle))
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ReactBootstrapToggle;
	}(_react.Component);
	
	ReactBootstrapToggle.propTypes = {
	  style: _propTypes2.default.shape(),
	  // Holds the className for label one
	  onstyle: _propTypes2.default.string,
	  // additional className for the on component
	  onClassName: _propTypes2.default.string,
	  // Holds the className for label two
	  offstyle: _propTypes2.default.string,
	  // additional className for the off component
	  offClassName: _propTypes2.default.string,
	  // The className for the handle
	  handlestyle: _propTypes2.default.string,
	  // additional className for the handle component
	  handleClassName: _propTypes2.default.string,
	  // Height prop
	  height: eitherStringOrInteger,
	  // Width prop
	  width: eitherStringOrInteger,
	  // The on and off elements defaults to 'On' and 'Off'
	  on: _propTypes2.default.node,
	  off: _propTypes2.default.node,
	  // The initial state of the component
	  active: _propTypes2.default.bool,
	  // Sets the button to disabled
	  disabled: _propTypes2.default.bool,
	  // Set the size of the button defaults to normal
	  size: _propTypes2.default.string,
	  // The onClick event, returns the state as the argument
	  onClick: _propTypes2.default.func,
	  className: _propTypes2.default.string,
	  // If the toggle should recalculate it's dimensions when visibility or dimensions change
	  recalculateOnResize: _propTypes2.default.bool
	};
	ReactBootstrapToggle.defaultProps = {
	  onstyle: 'primary',
	  onClassName: '',
	  offstyle: 'default',
	  offClassName: '',
	  handlestyle: 'default',
	  handleClassName: '',
	  width: '',
	  height: '',
	  on: 'On',
	  off: 'Off',
	  disabled: false,
	  size: 'normal',
	  active: true,
	  style: {},
	  recalculateOnResize: false
	};
	exports.default = ReactBootstrapToggle;

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _values = _interopRequireDefault(__webpack_require__(166));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _StyleConfig = __webpack_require__(51);
	
	var _CloseButton = _interopRequireDefault(__webpack_require__(503));
	
	var propTypes = {
	  onDismiss: _propTypes.default.func,
	  closeLabel: _propTypes.default.string
	};
	var defaultProps = {
	  closeLabel: 'Close alert'
	};
	
	var Alert =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Alert, _React$Component);
	
	  function Alert() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Alert.prototype;
	
	  _proto.render = function render() {
	    var _extends2;
	
	    var _this$props = this.props,
	        onDismiss = _this$props.onDismiss,
	        closeLabel = _this$props.closeLabel,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["onDismiss", "closeLabel", "className", "children"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var dismissable = !!onDismiss;
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dismissable')] = dismissable, _extends2));
	    return _react.default.createElement("div", (0, _extends3.default)({}, elementProps, {
	      role: "alert",
	      className: (0, _classnames.default)(className, classes)
	    }), dismissable && _react.default.createElement(_CloseButton.default, {
	      onClick: onDismiss,
	      label: closeLabel
	    }), children);
	  };
	
	  return Alert;
	}(_react.default.Component);
	
	Alert.propTypes = propTypes;
	Alert.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsStyles)((0, _values.default)(_StyleConfig.State), _StyleConfig.State.INFO, (0, _bootstrapUtils.bsClass)('alert', Alert));
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _SafeAnchor = _interopRequireDefault(__webpack_require__(90));
	
	var propTypes = {
	  /**
	   * If set to true, renders `span` instead of `a`
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * `href` attribute for the inner `a` element
	   */
	  href: _propTypes.default.string,
	
	  /**
	   * `title` attribute for the inner `a` element
	   */
	  title: _propTypes.default.node,
	
	  /**
	   * `target` attribute for the inner `a` element
	   */
	  target: _propTypes.default.string
	};
	var defaultProps = {
	  active: false
	};
	
	var BreadcrumbItem =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(BreadcrumbItem, _React$Component);
	
	  function BreadcrumbItem() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = BreadcrumbItem.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        active = _this$props.active,
	        href = _this$props.href,
	        title = _this$props.title,
	        target = _this$props.target,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["active", "href", "title", "target", "className"]); // Don't try to render these props on non-active <span>.
	
	    var linkProps = {
	      href: href,
	      title: title,
	      target: target
	    };
	    return _react.default.createElement("li", {
	      className: (0, _classnames.default)(className, {
	        active: active
	      })
	    }, active ? _react.default.createElement("span", props) : _react.default.createElement(_SafeAnchor.default, (0, _extends2.default)({}, props, linkProps)));
	  };
	
	  return BreadcrumbItem;
	}(_react.default.Component);
	
	BreadcrumbItem.propTypes = propTypes;
	BreadcrumbItem.defaultProps = defaultProps;
	var _default = BreadcrumbItem;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(58));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(31));
	
	var _transition = _interopRequireDefault(__webpack_require__(1745));
	
	var propTypes = {
	  direction: _propTypes.default.oneOf(['prev', 'next']),
	  onAnimateOutEnd: _propTypes.default.func,
	  active: _propTypes.default.bool,
	  animateIn: _propTypes.default.bool,
	  animateOut: _propTypes.default.bool,
	  index: _propTypes.default.number
	};
	var defaultProps = {
	  active: false,
	  animateIn: false,
	  animateOut: false
	};
	
	var CarouselItem =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(CarouselItem, _React$Component);
	
	  function CarouselItem(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.state = {
	      direction: null
	    };
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  var _proto = CarouselItem.prototype;
	
	  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.active !== nextProps.active) {
	      this.setState({
	        direction: null
	      });
	    }
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _this2 = this;
	
	    var active = this.props.active;
	    var prevActive = prevProps.active;
	
	    if (!active && prevActive) {
	      _transition.default.end(_reactDom.default.findDOMNode(this), this.handleAnimateOutEnd);
	    }
	
	    if (active !== prevActive) {
	      setTimeout(function () {
	        return _this2.startAnimation();
	      }, 20);
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  _proto.handleAnimateOutEnd = function handleAnimateOutEnd() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    if (this.props.onAnimateOutEnd) {
	      this.props.onAnimateOutEnd(this.props.index);
	    }
	  };
	
	  _proto.startAnimation = function startAnimation() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState({
	      direction: this.props.direction === 'prev' ? 'right' : 'left'
	    });
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        direction = _this$props.direction,
	        active = _this$props.active,
	        animateIn = _this$props.animateIn,
	        animateOut = _this$props.animateOut,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["direction", "active", "animateIn", "animateOut", "className"]);
	    delete props.onAnimateOutEnd;
	    delete props.index;
	    var classes = {
	      item: true,
	      active: active && !animateIn || animateOut
	    };
	
	    if (direction && active && animateIn) {
	      classes[direction] = true;
	    }
	
	    if (this.state.direction && (animateIn || animateOut)) {
	      classes[this.state.direction] = true;
	    }
	
	    return _react.default.createElement("div", (0, _extends2.default)({}, props, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return CarouselItem;
	}(_react.default.Component);
	
	CarouselItem.propTypes = propTypes;
	CarouselItem.defaultProps = defaultProps;
	var _default = CarouselItem;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _warning = _interopRequireDefault(__webpack_require__(47));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var propTypes = {
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  htmlFor: _propTypes.default.string,
	  srOnly: _propTypes.default.bool
	};
	var defaultProps = {
	  srOnly: false
	};
	var contextTypes = {
	  $bs_formGroup: _propTypes.default.object
	};
	
	var ControlLabel =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(ControlLabel, _React$Component);
	
	  function ControlLabel() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ControlLabel.prototype;
	
	  _proto.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	    var _this$props = this.props,
	        _this$props$htmlFor = _this$props.htmlFor,
	        htmlFor = _this$props$htmlFor === void 0 ? controlId : _this$props$htmlFor,
	        srOnly = _this$props.srOnly,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["htmlFor", "srOnly", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning.default)(controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : void 0;
	    var classes = (0, _extends2.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'sr-only': srOnly
	    });
	    return _react.default.createElement("label", (0, _extends2.default)({}, elementProps, {
	      htmlFor: htmlFor,
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return ControlLabel;
	}(_react.default.Component);
	
	ControlLabel.propTypes = propTypes;
	ControlLabel.defaultProps = defaultProps;
	ControlLabel.contextTypes = contextTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('control-label', ControlLabel);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _Dropdown = _interopRequireDefault(__webpack_require__(318));
	
	var _splitComponentProps2 = _interopRequireDefault(__webpack_require__(321));
	
	var propTypes = (0, _extends2.default)({}, _Dropdown.default.propTypes, {
	  // Toggle props.
	  bsStyle: _propTypes.default.string,
	  bsSize: _propTypes.default.string,
	  title: _propTypes.default.node.isRequired,
	  noCaret: _propTypes.default.bool,
	  // Override generated docs from <Dropdown>.
	
	  /**
	   * @private
	   */
	  children: _propTypes.default.node
	});
	
	var DropdownButton =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(DropdownButton, _React$Component);
	
	  function DropdownButton() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = DropdownButton.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        bsSize = _this$props.bsSize,
	        bsStyle = _this$props.bsStyle,
	        title = _this$props.title,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["bsSize", "bsStyle", "title", "children"]);
	
	    var _splitComponentProps = (0, _splitComponentProps2.default)(props, _Dropdown.default.ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1];
	
	    return _react.default.createElement(_Dropdown.default, (0, _extends2.default)({}, dropdownProps, {
	      bsSize: bsSize,
	      bsStyle: bsStyle
	    }), _react.default.createElement(_Dropdown.default.Toggle, (0, _extends2.default)({}, toggleProps, {
	      bsSize: bsSize,
	      bsStyle: bsStyle
	    }), title), _react.default.createElement(_Dropdown.default.Menu, null, children));
	  };
	
	  return DropdownButton;
	}(_react.default.Component);
	
	DropdownButton.propTypes = propTypes;
	var _default = DropdownButton;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _Button = _interopRequireDefault(__webpack_require__(232));
	
	var _SafeAnchor = _interopRequireDefault(__webpack_require__(90));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var propTypes = {
	  noCaret: _propTypes.default.bool,
	  open: _propTypes.default.bool,
	  title: _propTypes.default.string,
	  useAnchor: _propTypes.default.bool
	};
	var defaultProps = {
	  open: false,
	  useAnchor: false,
	  bsRole: 'toggle'
	};
	
	var DropdownToggle =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(DropdownToggle, _React$Component);
	
	  function DropdownToggle() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = DropdownToggle.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        noCaret = _this$props.noCaret,
	        open = _this$props.open,
	        useAnchor = _this$props.useAnchor,
	        bsClass = _this$props.bsClass,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["noCaret", "open", "useAnchor", "bsClass", "className", "children"]);
	    delete props.bsRole;
	    var Component = useAnchor ? _SafeAnchor.default : _Button.default;
	    var useCaret = !noCaret; // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	    // FIXME: Should this really fall back to `title` as children?
	
	    return _react.default.createElement(Component, (0, _extends2.default)({}, props, {
	      role: "button",
	      className: (0, _classnames.default)(className, bsClass),
	      "aria-haspopup": true,
	      "aria-expanded": open
	    }), children || props.title, useCaret && ' ', useCaret && _react.default.createElement("span", {
	      className: "caret"
	    }));
	  };
	
	  return DropdownToggle;
	}(_react.default.Component);
	
	DropdownToggle.propTypes = propTypes;
	DropdownToggle.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('dropdown-toggle', DropdownToggle);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _StyleConfig = __webpack_require__(51);
	
	var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(62));
	
	var propTypes = {
	  /**
	   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
	   */
	  controlId: _propTypes.default.string,
	  validationState: _propTypes.default.oneOf(['success', 'warning', 'error', null])
	};
	var childContextTypes = {
	  $bs_formGroup: _propTypes.default.object.isRequired
	};
	
	var FormGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(FormGroup, _React$Component);
	
	  function FormGroup() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = FormGroup.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    var _this$props = this.props,
	        controlId = _this$props.controlId,
	        validationState = _this$props.validationState;
	    return {
	      $bs_formGroup: {
	        controlId: controlId,
	        validationState: validationState
	      }
	    };
	  };
	
	  _proto.hasFeedback = function hasFeedback(children) {
	    var _this = this;
	
	    return _ValidComponentChildren.default.some(children, function (child) {
	      return child.props.bsRole === 'feedback' || child.props.children && _this.hasFeedback(child.props.children);
	    });
	  };
	
	  _proto.render = function render() {
	    var _this$props2 = this.props,
	        validationState = _this$props2.validationState,
	        className = _this$props2.className,
	        children = _this$props2.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["validationState", "className", "children"]);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['controlId']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var classes = (0, _extends2.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'has-feedback': this.hasFeedback(children)
	    });
	
	    if (validationState) {
	      classes["has-" + validationState] = true;
	    }
	
	    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }), children);
	  };
	
	  return FormGroup;
	}(_react.default.Component);
	
	FormGroup.propTypes = propTypes;
	FormGroup.childContextTypes = childContextTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('form-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], FormGroup));
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _elementType = _interopRequireDefault(__webpack_require__(34));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var propTypes = {
	  /**
	   * Turn any fixed-width grid layout into a full-width layout by this property.
	   *
	   * Adds `container-fluid` class.
	   */
	  fluid: _propTypes.default.bool,
	
	  /**
	   * You can use a custom element for this component
	   */
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  componentClass: 'div',
	  fluid: false
	};
	
	var Grid =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Grid, _React$Component);
	
	  function Grid() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Grid.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        fluid = _this$props.fluid,
	        Component = _this$props.componentClass,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["fluid", "componentClass", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.prefix)(bsProps, fluid && 'fluid');
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return Grid;
	}(_react.default.Component);
	
	Grid.propTypes = propTypes;
	Grid.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('container', Grid);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var HelpBlock =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(HelpBlock, _React$Component);
	
	  function HelpBlock() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = HelpBlock.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement("span", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return HelpBlock;
	}(_react.default.Component);
	
	var _default = (0, _bootstrapUtils.bsClass)('help-block', HelpBlock);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _InputGroupAddon = _interopRequireDefault(__webpack_require__(1937));
	
	var _InputGroupButton = _interopRequireDefault(__webpack_require__(1938));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _StyleConfig = __webpack_require__(51);
	
	var InputGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(InputGroup, _React$Component);
	
	  function InputGroup() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = InputGroup.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement("span", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return InputGroup;
	}(_react.default.Component);
	
	InputGroup.Addon = _InputGroupAddon.default;
	InputGroup.Button = _InputGroupButton.default;
	
	var _default = (0, _bootstrapUtils.bsClass)('input-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], InputGroup));
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _values = _interopRequireDefault(__webpack_require__(166));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _StyleConfig = __webpack_require__(51);
	
	var propTypes = {
	  active: _propTypes.default.any,
	  disabled: _propTypes.default.any,
	  header: _propTypes.default.node,
	  listItem: _propTypes.default.bool,
	  onClick: _propTypes.default.func,
	  href: _propTypes.default.string,
	  type: _propTypes.default.string
	};
	var defaultProps = {
	  listItem: false
	};
	
	var ListGroupItem =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(ListGroupItem, _React$Component);
	
	  function ListGroupItem() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ListGroupItem.prototype;
	
	  _proto.renderHeader = function renderHeader(header, headingClassName) {
	    if (_react.default.isValidElement(header)) {
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames.default)(header.props.className, headingClassName)
	      });
	    }
	
	    return _react.default.createElement("h4", {
	      className: headingClassName
	    }, header);
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        active = _this$props.active,
	        disabled = _this$props.disabled,
	        className = _this$props.className,
	        header = _this$props.header,
	        listItem = _this$props.listItem,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["active", "disabled", "className", "header", "listItem", "children"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends2.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active,
	      disabled: disabled
	    });
	    var Component;
	
	    if (elementProps.href) {
	      Component = 'a';
	    } else if (elementProps.onClick) {
	      Component = 'button';
	      elementProps.type = elementProps.type || 'button';
	    } else if (listItem) {
	      Component = 'li';
	    } else {
	      Component = 'span';
	    }
	
	    elementProps.className = (0, _classnames.default)(className, classes); // TODO: Deprecate `header` prop.
	
	    if (header) {
	      return _react.default.createElement(Component, elementProps, this.renderHeader(header, (0, _bootstrapUtils.prefix)(bsProps, 'heading')), _react.default.createElement("p", {
	        className: (0, _bootstrapUtils.prefix)(bsProps, 'text')
	      }, children));
	    }
	
	    return _react.default.createElement(Component, elementProps, children);
	  };
	
	  return ListGroupItem;
	}(_react.default.Component);
	
	ListGroupItem.propTypes = propTypes;
	ListGroupItem.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('list-group-item', (0, _bootstrapUtils.bsStyles)((0, _values.default)(_StyleConfig.State), ListGroupItem));
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(58));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _all = _interopRequireDefault(__webpack_require__(314));
	
	var _SafeAnchor = _interopRequireDefault(__webpack_require__(90));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var propTypes = {
	  /**
	   * Highlight the menu item as active.
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * Disable the menu item, making it unselectable.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Styles the menu item as a horizontal rule, providing visual separation between
	   * groups of menu items.
	   */
	  divider: (0, _all.default)(_propTypes.default.bool, function (_ref) {
	    var divider = _ref.divider,
	        children = _ref.children;
	    return divider && children ? new Error('Children will not be rendered for dividers') : null;
	  }),
	
	  /**
	   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
	   */
	  eventKey: _propTypes.default.any,
	
	  /**
	   * Styles the menu item as a header label, useful for describing a group of menu items.
	   */
	  header: _propTypes.default.bool,
	
	  /**
	   * HTML `href` attribute corresponding to `a.href`.
	   */
	  href: _propTypes.default.string,
	
	  /**
	   * Callback fired when the menu item is clicked.
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * Callback fired when the menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _propTypes.default.func
	};
	var defaultProps = {
	  divider: false,
	  disabled: false,
	  header: false
	};
	
	var MenuItem =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(MenuItem, _React$Component);
	
	  function MenuItem(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    return _this;
	  }
	
	  var _proto = MenuItem.prototype;
	
	  _proto.handleClick = function handleClick(event) {
	    var _this$props = this.props,
	        href = _this$props.href,
	        disabled = _this$props.disabled,
	        onSelect = _this$props.onSelect,
	        eventKey = _this$props.eventKey;
	
	    if (!href || disabled) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props2 = this.props,
	        active = _this$props2.active,
	        disabled = _this$props2.disabled,
	        divider = _this$props2.divider,
	        header = _this$props2.header,
	        onClick = _this$props2.onClick,
	        className = _this$props2.className,
	        style = _this$props2.style,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["active", "disabled", "divider", "header", "onClick", "className", "style"]);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['eventKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    if (divider) {
	      // Forcibly blank out the children; separators shouldn't render any.
	      elementProps.children = undefined;
	      return _react.default.createElement("li", (0, _extends2.default)({}, elementProps, {
	        role: "separator",
	        className: (0, _classnames.default)(className, 'divider'),
	        style: style
	      }));
	    }
	
	    if (header) {
	      return _react.default.createElement("li", (0, _extends2.default)({}, elementProps, {
	        role: "heading",
	        className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'header')),
	        style: style
	      }));
	    }
	
	    return _react.default.createElement("li", {
	      role: "presentation",
	      className: (0, _classnames.default)(className, {
	        active: active,
	        disabled: disabled
	      }),
	      style: style
	    }, _react.default.createElement(_SafeAnchor.default, (0, _extends2.default)({}, elementProps, {
	      role: "menuitem",
	      tabIndex: "-1",
	      onClick: (0, _createChainedFunction.default)(onClick, this.handleClick)
	    })));
	  };
	
	  return MenuItem;
	}(_react.default.Component);
	
	MenuItem.propTypes = propTypes;
	MenuItem.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('dropdown', MenuItem);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _elementType = _interopRequireDefault(__webpack_require__(34));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var propTypes = {
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalBody =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(ModalBody, _React$Component);
	
	  function ModalBody() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ModalBody.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.componentClass,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return ModalBody;
	}(_react.default.Component);
	
	ModalBody.propTypes = propTypes;
	ModalBody.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('modal-body', ModalBody);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _StyleConfig = __webpack_require__(51);
	
	var propTypes = {
	  /**
	   * A css class to apply to the Modal dialog DOM node.
	   */
	  dialogClassName: _propTypes.default.string
	};
	
	var ModalDialog =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(ModalDialog, _React$Component);
	
	  function ModalDialog() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ModalDialog.prototype;
	
	  _proto.render = function render() {
	    var _extends2;
	
	    var _this$props = this.props,
	        dialogClassName = _this$props.dialogClassName,
	        className = _this$props.className,
	        style = _this$props.style,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["dialogClassName", "className", "style", "children"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(bsProps);
	    var modalStyle = (0, _extends3.default)({
	      display: 'block'
	    }, style);
	    var dialogClasses = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dialog')] = true, _extends2));
	    return _react.default.createElement("div", (0, _extends3.default)({}, elementProps, {
	      tabIndex: "-1",
	      role: "dialog",
	      style: modalStyle,
	      className: (0, _classnames.default)(className, bsClassName)
	    }), _react.default.createElement("div", {
	      className: (0, _classnames.default)(dialogClassName, dialogClasses)
	    }, _react.default.createElement("div", {
	      className: (0, _bootstrapUtils.prefix)(bsProps, 'content'),
	      role: "document"
	    }, children)));
	  };
	
	  return ModalDialog;
	}(_react.default.Component);
	
	ModalDialog.propTypes = propTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], ModalDialog));
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _elementType = _interopRequireDefault(__webpack_require__(34));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var propTypes = {
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalFooter =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(ModalFooter, _React$Component);
	
	  function ModalFooter() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ModalFooter.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.componentClass,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return ModalFooter;
	}(_react.default.Component);
	
	ModalFooter.propTypes = propTypes;
	ModalFooter.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('modal-footer', ModalFooter);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var _CloseButton = _interopRequireDefault(__webpack_require__(503));
	
	// TODO: `aria-label` should be `closeLabel`.
	var propTypes = {
	  /**
	   * Provides an accessible label for the close
	   * button. It is used for Assistive Technology when the label text is not
	   * readable.
	   */
	  closeLabel: _propTypes.default.string,
	
	  /**
	   * Specify whether the Component should contain a close button
	   */
	  closeButton: _propTypes.default.bool,
	
	  /**
	   * A Callback fired when the close button is clicked. If used directly inside
	   * a Modal component, the onHide will automatically be propagated up to the
	   * parent Modal `onHide`.
	   */
	  onHide: _propTypes.default.func
	};
	var defaultProps = {
	  closeLabel: 'Close',
	  closeButton: false
	};
	var contextTypes = {
	  $bs_modal: _propTypes.default.shape({
	    onHide: _propTypes.default.func
	  })
	};
	
	var ModalHeader =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(ModalHeader, _React$Component);
	
	  function ModalHeader() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ModalHeader.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        closeLabel = _this$props.closeLabel,
	        closeButton = _this$props.closeButton,
	        onHide = _this$props.onHide,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["closeLabel", "closeButton", "onHide", "className", "children"]);
	    var modal = this.context.$bs_modal;
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }), closeButton && _react.default.createElement(_CloseButton.default, {
	      label: closeLabel,
	      onClick: (0, _createChainedFunction.default)(modal && modal.onHide, onHide)
	    }), children);
	  };
	
	  return ModalHeader;
	}(_react.default.Component);
	
	ModalHeader.propTypes = propTypes;
	ModalHeader.defaultProps = defaultProps;
	ModalHeader.contextTypes = contextTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('modal-header', ModalHeader);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _elementType = _interopRequireDefault(__webpack_require__(34));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var propTypes = {
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var ModalTitle =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(ModalTitle, _React$Component);
	
	  function ModalTitle() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ModalTitle.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.componentClass,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return ModalTitle;
	}(_react.default.Component);
	
	ModalTitle.propTypes = propTypes;
	ModalTitle.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('modal-title', ModalTitle);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _keycode = _interopRequireDefault(__webpack_require__(304));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(31));
	
	var _all = _interopRequireDefault(__webpack_require__(314));
	
	var _warning = _interopRequireDefault(__webpack_require__(47));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(62));
	
	// TODO: Should we expose `<NavItem>` as `<Nav.Item>`?
	// TODO: This `bsStyle` is very unlike the others. Should we rename it?
	// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
	// Consider renaming or replacing them.
	var propTypes = {
	  /**
	   * Marks the NavItem with a matching `eventKey` as active. Has a
	   * higher precedence over `activeHref`.
	   */
	  activeKey: _propTypes.default.any,
	
	  /**
	   * Marks the child NavItem with a matching `href` prop as active.
	   */
	  activeHref: _propTypes.default.string,
	
	  /**
	   * NavItems are be positioned vertically.
	   */
	  stacked: _propTypes.default.bool,
	  justified: (0, _all.default)(_propTypes.default.bool, function (_ref) {
	    var justified = _ref.justified,
	        navbar = _ref.navbar;
	    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
	  }),
	
	  /**
	   * A callback fired when a NavItem is selected.
	   *
	   * ```js
	   * function (
	   *  Any eventKey,
	   *  SyntheticEvent event?
	   * )
	   * ```
	   */
	  onSelect: _propTypes.default.func,
	
	  /**
	   * ARIA role for the Nav, in the context of a TabContainer, the default will
	   * be set to "tablist", but can be overridden by the Nav when set explicitly.
	   *
	   * When the role is set to "tablist" NavItem focus is managed according to
	   * the ARIA authoring practices for tabs:
	   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
	   */
	  role: _propTypes.default.string,
	
	  /**
	   * Apply styling an alignment for use in a Navbar. This prop will be set
	   * automatically when the Nav is used inside a Navbar.
	   */
	  navbar: _propTypes.default.bool,
	
	  /**
	   * Float the Nav to the right. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullRight: _propTypes.default.bool,
	
	  /**
	   * Float the Nav to the left. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullLeft: _propTypes.default.bool
	};
	var defaultProps = {
	  justified: false,
	  pullRight: false,
	  pullLeft: false,
	  stacked: false
	};
	var contextTypes = {
	  $bs_navbar: _propTypes.default.shape({
	    bsClass: _propTypes.default.string,
	    onSelect: _propTypes.default.func
	  }),
	  $bs_tabContainer: _propTypes.default.shape({
	    activeKey: _propTypes.default.any,
	    onSelect: _propTypes.default.func.isRequired,
	    getTabId: _propTypes.default.func.isRequired,
	    getPaneId: _propTypes.default.func.isRequired
	  })
	};
	
	var Nav =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Nav, _React$Component);
	
	  function Nav() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Nav.prototype;
	
	  _proto.componentDidUpdate = function componentDidUpdate() {
	    var _this = this;
	
	    if (!this._needsRefocus) {
	      return;
	    }
	
	    this._needsRefocus = false;
	    var children = this.props.children;
	
	    var _this$getActiveProps = this.getActiveProps(),
	        activeKey = _this$getActiveProps.activeKey,
	        activeHref = _this$getActiveProps.activeHref;
	
	    var activeChild = _ValidComponentChildren.default.find(children, function (child) {
	      return _this.isActive(child, activeKey, activeHref);
	    });
	
	    var childrenArray = _ValidComponentChildren.default.toArray(children);
	
	    var activeChildIndex = childrenArray.indexOf(activeChild);
	
	    var childNodes = _reactDom.default.findDOMNode(this).children;
	
	    var activeNode = childNodes && childNodes[activeChildIndex];
	
	    if (!activeNode || !activeNode.firstChild) {
	      return;
	    }
	
	    activeNode.firstChild.focus();
	  };
	
	  _proto.getActiveProps = function getActiveProps() {
	    var tabContainer = this.context.$bs_tabContainer;
	
	    if (tabContainer) {
	       false ? (0, _warning.default)(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ("activeKey={" + this.props.activeKey + "} />`.")) : void 0;
	      return tabContainer;
	    }
	
	    return this.props;
	  };
	
	  _proto.getNextActiveChild = function getNextActiveChild(offset) {
	    var _this2 = this;
	
	    var children = this.props.children;
	    var validChildren = children.filter(function (child) {
	      return child.props.eventKey != null && !child.props.disabled;
	    });
	
	    var _this$getActiveProps2 = this.getActiveProps(),
	        activeKey = _this$getActiveProps2.activeKey,
	        activeHref = _this$getActiveProps2.activeHref;
	
	    var activeChild = _ValidComponentChildren.default.find(children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    }); // This assumes the active child is not disabled.
	
	
	    var activeChildIndex = validChildren.indexOf(activeChild);
	
	    if (activeChildIndex === -1) {
	      // Something has gone wrong. Select the first valid child we can find.
	      return validChildren[0];
	    }
	
	    var nextIndex = activeChildIndex + offset;
	    var numValidChildren = validChildren.length;
	
	    if (nextIndex >= numValidChildren) {
	      nextIndex = 0;
	    } else if (nextIndex < 0) {
	      nextIndex = numValidChildren - 1;
	    }
	
	    return validChildren[nextIndex];
	  };
	
	  _proto.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
	    var _this3 = this;
	
	    if (!tabContainer && navRole !== 'tablist') {
	      // No tab props here.
	      return null;
	    }
	
	    var _child$props = child.props,
	        id = _child$props.id,
	        controls = _child$props['aria-controls'],
	        eventKey = _child$props.eventKey,
	        role = _child$props.role,
	        onKeyDown = _child$props.onKeyDown,
	        tabIndex = _child$props.tabIndex;
	
	    if (tabContainer) {
	       false ? (0, _warning.default)(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	      id = tabContainer.getTabId(eventKey);
	      controls = tabContainer.getPaneId(eventKey);
	    }
	
	    if (navRole === 'tablist') {
	      role = role || 'tab';
	      onKeyDown = (0, _createChainedFunction.default)(function (event) {
	        return _this3.handleTabKeyDown(onSelect, event);
	      }, onKeyDown);
	      tabIndex = active ? tabIndex : -1;
	    }
	
	    return {
	      id: id,
	      role: role,
	      onKeyDown: onKeyDown,
	      'aria-controls': controls,
	      tabIndex: tabIndex
	    };
	  };
	
	  _proto.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
	    var nextActiveChild;
	
	    switch (event.keyCode) {
	      case _keycode.default.codes.left:
	      case _keycode.default.codes.up:
	        nextActiveChild = this.getNextActiveChild(-1);
	        break;
	
	      case _keycode.default.codes.right:
	      case _keycode.default.codes.down:
	        nextActiveChild = this.getNextActiveChild(1);
	        break;
	
	      default:
	        // It was a different key; don't handle this keypress.
	        return;
	    }
	
	    event.preventDefault();
	
	    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey != null) {
	      onSelect(nextActiveChild.props.eventKey);
	    }
	
	    this._needsRefocus = true;
	  };
	
	  _proto.isActive = function isActive(_ref2, activeKey, activeHref) {
	    var props = _ref2.props;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  _proto.render = function render() {
	    var _extends2,
	        _this4 = this;
	
	    var _this$props = this.props,
	        stacked = _this$props.stacked,
	        justified = _this$props.justified,
	        onSelect = _this$props.onSelect,
	        propsRole = _this$props.role,
	        propsNavbar = _this$props.navbar,
	        pullRight = _this$props.pullRight,
	        pullLeft = _this$props.pullLeft,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["stacked", "justified", "onSelect", "role", "navbar", "pullRight", "pullLeft", "className", "children"]);
	    var tabContainer = this.context.$bs_tabContainer;
	    var role = propsRole || (tabContainer ? 'tablist' : null);
	
	    var _this$getActiveProps3 = this.getActiveProps(),
	        activeKey = _this$getActiveProps3.activeKey,
	        activeHref = _this$getActiveProps3.activeHref;
	
	    delete props.activeKey; // Accessed via this.getActiveProps().
	
	    delete props.activeHref; // Accessed via this.getActiveProps().
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'stacked')] = stacked, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2));
	    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
	    var pullLeftClassName;
	    var pullRightClassName;
	
	    if (navbar) {
	      var navbarProps = this.context.$bs_navbar || {
	        bsClass: 'navbar'
	      };
	      classes[(0, _bootstrapUtils.prefix)(navbarProps, 'nav')] = true;
	      pullRightClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'right');
	      pullLeftClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'left');
	    } else {
	      pullRightClassName = 'pull-right';
	      pullLeftClassName = 'pull-left';
	    }
	
	    classes[pullRightClassName] = pullRight;
	    classes[pullLeftClassName] = pullLeft;
	    return _react.default.createElement("ul", (0, _extends3.default)({}, elementProps, {
	      role: role,
	      className: (0, _classnames.default)(className, classes)
	    }), _ValidComponentChildren.default.map(children, function (child) {
	      var active = _this4.isActive(child, activeKey, activeHref);
	
	      var childOnSelect = (0, _createChainedFunction.default)(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);
	      return (0, _react.cloneElement)(child, (0, _extends3.default)({}, _this4.getTabProps(child, tabContainer, role, active, childOnSelect), {
	        active: active,
	        activeKey: activeKey,
	        activeHref: activeHref,
	        onSelect: childOnSelect
	      }));
	    }));
	  };
	
	  return Nav;
	}(_react.default.Component);
	
	Nav.propTypes = propTypes;
	Nav.defaultProps = defaultProps;
	Nav.contextTypes = contextTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('nav', (0, _bootstrapUtils.bsStyles)(['tabs', 'pills'], Nav));
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(58));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _SafeAnchor = _interopRequireDefault(__webpack_require__(90));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var propTypes = {
	  active: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  role: _propTypes.default.string,
	  href: _propTypes.default.string,
	  onClick: _propTypes.default.func,
	  onSelect: _propTypes.default.func,
	  eventKey: _propTypes.default.any
	};
	var defaultProps = {
	  active: false,
	  disabled: false
	};
	
	var NavItem =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(NavItem, _React$Component);
	
	  function NavItem(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    return _this;
	  }
	
	  var _proto = NavItem.prototype;
	
	  _proto.handleClick = function handleClick(e) {
	    if (this.props.disabled) {
	      e.preventDefault();
	      return;
	    }
	
	    if (this.props.onSelect) {
	      this.props.onSelect(this.props.eventKey, e);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        active = _this$props.active,
	        disabled = _this$props.disabled,
	        onClick = _this$props.onClick,
	        className = _this$props.className,
	        style = _this$props.style,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["active", "disabled", "onClick", "className", "style"]);
	    delete props.onSelect;
	    delete props.eventKey; // These are injected down by `<Nav>` for building `<SubNav>`s.
	
	    delete props.activeKey;
	    delete props.activeHref;
	
	    if (!props.role) {
	      if (props.href === '#') {
	        props.role = 'button';
	      }
	    } else if (props.role === 'tab') {
	      props['aria-selected'] = active;
	    }
	
	    return _react.default.createElement("li", {
	      role: "presentation",
	      className: (0, _classnames.default)(className, {
	        active: active,
	        disabled: disabled
	      }),
	      style: style
	    }, _react.default.createElement(_SafeAnchor.default, (0, _extends2.default)({}, props, {
	      disabled: disabled,
	      onClick: (0, _createChainedFunction.default)(onClick, this.handleClick)
	    })));
	  };
	
	  return NavItem;
	}(_react.default.Component);
	
	NavItem.propTypes = propTypes;
	NavItem.defaultProps = defaultProps;
	var _default = NavItem;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var contextTypes = {
	  $bs_navbar: _propTypes.default.shape({
	    bsClass: _propTypes.default.string
	  })
	};
	
	var NavbarBrand =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(NavbarBrand, _React$Component);
	
	  function NavbarBrand() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = NavbarBrand.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "children"]);
	    var navbarProps = this.context.$bs_navbar || {
	      bsClass: 'navbar'
	    };
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'brand');
	
	    if (_react.default.isValidElement(children)) {
	      return _react.default.cloneElement(children, {
	        className: (0, _classnames.default)(children.props.className, className, bsClassName)
	      });
	    }
	
	    return _react.default.createElement("span", (0, _extends2.default)({}, props, {
	      className: (0, _classnames.default)(className, bsClassName)
	    }), children);
	  };
	
	  return NavbarBrand;
	}(_react.default.Component);
	
	NavbarBrand.contextTypes = contextTypes;
	var _default = NavbarBrand;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _Overlay = _interopRequireDefault(__webpack_require__(2035));
	
	var _elementType = _interopRequireDefault(__webpack_require__(34));
	
	var _Fade = _interopRequireDefault(__webpack_require__(319));
	
	var propTypes = (0, _extends2.default)({}, _Overlay.default.propTypes, {
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _propTypes.default.bool,
	
	  /**
	   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
	   */
	  rootClose: _propTypes.default.bool,
	
	  /**
	   * A callback invoked by the overlay when it wishes to be hidden. Required if
	   * `rootClose` is specified.
	   */
	  onHide: _propTypes.default.func,
	
	  /**
	   * Use animation
	   */
	  animation: _propTypes.default.oneOfType([_propTypes.default.bool, _elementType.default]),
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Sets the direction of the Overlay.
	   */
	  placement: _propTypes.default.oneOf(['top', 'right', 'bottom', 'left'])
	});
	var defaultProps = {
	  animation: _Fade.default,
	  rootClose: false,
	  show: false,
	  placement: 'right'
	};
	
	var Overlay =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Overlay, _React$Component);
	
	  function Overlay() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Overlay.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        animation = _this$props.animation,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["animation", "children"]);
	    var transition = animation === true ? _Fade.default : animation || null;
	    var child;
	
	    if (!transition) {
	      child = (0, _react.cloneElement)(children, {
	        className: (0, _classnames.default)(children.props.className, 'in')
	      });
	    } else {
	      child = children;
	    }
	
	    return _react.default.createElement(_Overlay.default, (0, _extends2.default)({}, props, {
	      transition: transition
	    }), child);
	  };
	
	  return Overlay;
	}(_react.default.Component);
	
	Overlay.propTypes = propTypes;
	Overlay.defaultProps = defaultProps;
	var _default = Overlay;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(58));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _SafeAnchor = _interopRequireDefault(__webpack_require__(90));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var propTypes = {
	  disabled: _propTypes.default.bool,
	  previous: _propTypes.default.bool,
	  next: _propTypes.default.bool,
	  onClick: _propTypes.default.func,
	  onSelect: _propTypes.default.func,
	  eventKey: _propTypes.default.any
	};
	var defaultProps = {
	  disabled: false,
	  previous: false,
	  next: false
	};
	
	var PagerItem =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(PagerItem, _React$Component);
	
	  function PagerItem(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    _this.handleSelect = _this.handleSelect.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    return _this;
	  }
	
	  var _proto = PagerItem.prototype;
	
	  _proto.handleSelect = function handleSelect(e) {
	    var _this$props = this.props,
	        disabled = _this$props.disabled,
	        onSelect = _this$props.onSelect,
	        eventKey = _this$props.eventKey;
	
	    if (disabled) {
	      e.preventDefault();
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, e);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props2 = this.props,
	        disabled = _this$props2.disabled,
	        previous = _this$props2.previous,
	        next = _this$props2.next,
	        onClick = _this$props2.onClick,
	        className = _this$props2.className,
	        style = _this$props2.style,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["disabled", "previous", "next", "onClick", "className", "style"]);
	    delete props.onSelect;
	    delete props.eventKey;
	    return _react.default.createElement("li", {
	      className: (0, _classnames.default)(className, {
	        disabled: disabled,
	        previous: previous,
	        next: next
	      }),
	      style: style
	    }, _react.default.createElement(_SafeAnchor.default, (0, _extends2.default)({}, props, {
	      disabled: disabled,
	      onClick: (0, _createChainedFunction.default)(onClick, this.handleSelect)
	    })));
	  };
	
	  return PagerItem;
	}(_react.default.Component);
	
	PagerItem.propTypes = propTypes;
	PagerItem.defaultProps = defaultProps;
	var _default = PagerItem;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _Collapse = _interopRequireDefault(__webpack_require__(505));
	
	var propTypes = {
	  /**
	   * Callback fired before the component expands
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired after the component starts to expand
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired after the component has expanded
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired before the component collapses
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired after the component starts to collapse
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * Callback fired after the component has collapsed
	   */
	  onExited: _propTypes.default.func
	};
	var contextTypes = {
	  $bs_panel: _propTypes.default.shape({
	    headingId: _propTypes.default.string,
	    bodyId: _propTypes.default.string,
	    bsClass: _propTypes.default.string,
	    expanded: _propTypes.default.bool
	  })
	};
	
	var PanelCollapse =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(PanelCollapse, _React$Component);
	
	  function PanelCollapse() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = PanelCollapse.prototype;
	
	  _proto.render = function render() {
	    var children = this.props.children;
	
	    var _ref = this.context.$bs_panel || {},
	        headingId = _ref.headingId,
	        bodyId = _ref.bodyId,
	        _bsClass = _ref.bsClass,
	        expanded = _ref.expanded;
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(this.props),
	        bsProps = _splitBsProps[0],
	        props = _splitBsProps[1];
	
	    bsProps.bsClass = _bsClass || bsProps.bsClass;
	
	    if (headingId && bodyId) {
	      props.id = bodyId;
	      props.role = props.role || 'tabpanel';
	      props['aria-labelledby'] = headingId;
	    }
	
	    return _react.default.createElement(_Collapse.default, (0, _extends2.default)({
	      in: expanded
	    }, props), _react.default.createElement("div", {
	      className: (0, _bootstrapUtils.prefix)(bsProps, 'collapse')
	    }, children));
	  };
	
	  return PanelCollapse;
	}(_react.default.Component);
	
	PanelCollapse.propTypes = propTypes;
	PanelCollapse.contextTypes = contextTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('panel', PanelCollapse);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _uncontrollable = _interopRequireDefault(__webpack_require__(155));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(62));
	
	var _PropTypes = __webpack_require__(896);
	
	var propTypes = {
	  accordion: _propTypes.default.bool,
	
	  /**
	   * When `accordion` is enabled, `activeKey` controls the which child `Panel` is expanded. `activeKey` should
	   * match a child Panel `eventKey` prop exactly.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes.default.any,
	
	  /**
	   * A callback fired when a child Panel collapse state changes. It's called with the next expanded `activeKey`
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes.default.func,
	
	  /**
	   * An HTML role attribute
	   */
	  role: _propTypes.default.string,
	
	  /**
	   * A function that takes an eventKey and type and returns a
	   * unique id for each Panel heading and Panel Collapse. The function _must_ be a pure function,
	   * meaning it should always return the _same_ id for the same set of inputs. The default
	   * value requires that an `id` to be set for the PanelGroup.
	   *
	   * The `type` argument will either be `"body"` or `"heading"`.
	   *
	   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
	   */
	  generateChildId: _propTypes.default.func,
	
	  /**
	   * HTML id attribute, required if no `generateChildId` prop
	   * is specified.
	   */
	  id: (0, _PropTypes.generatedId)('PanelGroup')
	};
	var defaultProps = {
	  accordion: false
	};
	var childContextTypes = {
	  $bs_panelGroup: _propTypes.default.shape({
	    getId: _propTypes.default.func,
	    headerRole: _propTypes.default.string,
	    panelRole: _propTypes.default.string,
	    activeKey: _propTypes.default.any,
	    onToggle: _propTypes.default.func
	  })
	};
	
	var PanelGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(PanelGroup, _React$Component);
	
	  function PanelGroup() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _this.handleSelect = function (key, expanded, e) {
	      if (expanded) {
	        _this.props.onSelect(key, e);
	      } else if (_this.props.activeKey === key) {
	        _this.props.onSelect(null, e);
	      }
	    };
	
	    return _this;
	  }
	
	  var _proto = PanelGroup.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    var _this$props = this.props,
	        activeKey = _this$props.activeKey,
	        accordion = _this$props.accordion,
	        generateChildId = _this$props.generateChildId,
	        id = _this$props.id;
	    var getId = null;
	
	    if (accordion) {
	      getId = generateChildId || function (key, type) {
	        return id ? id + "-" + type + "-" + key : null;
	      };
	    }
	
	    return {
	      $bs_panelGroup: (0, _extends2.default)({
	        getId: getId,
	        headerRole: 'tab',
	        panelRole: 'tabpanel'
	      }, accordion && {
	        activeKey: activeKey,
	        onToggle: this.handleSelect
	      })
	    };
	  };
	
	  _proto.render = function render() {
	    var _this$props2 = this.props,
	        accordion = _this$props2.accordion,
	        className = _this$props2.className,
	        children = _this$props2.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["accordion", "className", "children"]);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['onSelect', 'activeKey']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    if (accordion) {
	      elementProps.role = elementProps.role || 'tablist';
	    }
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }), _ValidComponentChildren.default.map(children, function (child) {
	      return (0, _react.cloneElement)(child, {
	        bsStyle: child.props.bsStyle || bsProps.bsStyle
	      });
	    }));
	  };
	
	  return PanelGroup;
	}(_react.default.Component);
	
	PanelGroup.propTypes = propTypes;
	PanelGroup.defaultProps = defaultProps;
	PanelGroup.childContextTypes = childContextTypes;
	
	var _default = (0, _uncontrollable.default)((0, _bootstrapUtils.bsClass)('panel-group', PanelGroup), {
	  activeKey: 'onSelect'
	});
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(58));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _elementType = _interopRequireDefault(__webpack_require__(516));
	
	var _SafeAnchor = _interopRequireDefault(__webpack_require__(90));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var propTypes = {
	  /**
	   * only here to satisfy linting, just the html onClick handler.
	   *
	   * @private
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * You can use a custom element for this component
	   */
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  componentClass: _SafeAnchor.default
	};
	var contextTypes = {
	  $bs_panel: _propTypes.default.shape({
	    bodyId: _propTypes.default.string,
	    onToggle: _propTypes.default.func,
	    expanded: _propTypes.default.bool
	  })
	};
	
	var PanelToggle =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(PanelToggle, _React$Component);
	
	  function PanelToggle() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    _this.handleToggle = _this.handleToggle.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    return _this;
	  }
	
	  var _proto = PanelToggle.prototype;
	
	  _proto.handleToggle = function handleToggle(event) {
	    var _ref = this.context.$bs_panel || {},
	        onToggle = _ref.onToggle;
	
	    if (onToggle) {
	      onToggle(event);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        onClick = _this$props.onClick,
	        className = _this$props.className,
	        componentClass = _this$props.componentClass,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["onClick", "className", "componentClass"]);
	
	    var _ref2 = this.context.$bs_panel || {},
	        expanded = _ref2.expanded,
	        bodyId = _ref2.bodyId;
	
	    var Component = componentClass;
	    props.onClick = (0, _createChainedFunction.default)(onClick, this.handleToggle);
	    props['aria-expanded'] = expanded;
	    props.className = (0, _classnames.default)(className, !expanded && 'collapsed');
	
	    if (bodyId) {
	      props['aria-controls'] = bodyId;
	    }
	
	    return _react.default.createElement(Component, props);
	  };
	
	  return PanelToggle;
	}(_react.default.Component);
	
	PanelToggle.propTypes = propTypes;
	PanelToggle.defaultProps = defaultProps;
	PanelToggle.contextTypes = contextTypes;
	var _default = PanelToggle;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _warning = _interopRequireDefault(__webpack_require__(47));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	/* eslint-disable jsx-a11y/label-has-for */
	var propTypes = {
	  inline: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  title: _propTypes.default.string,
	
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _propTypes.default.oneOf(['success', 'warning', 'error', null]),
	
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Radio inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes.default.func
	};
	var defaultProps = {
	  inline: false,
	  disabled: false,
	  title: ''
	};
	
	var Radio =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Radio, _React$Component);
	
	  function Radio() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Radio.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        inline = _this$props.inline,
	        disabled = _this$props.disabled,
	        validationState = _this$props.validationState,
	        inputRef = _this$props.inputRef,
	        className = _this$props.className,
	        style = _this$props.style,
	        title = _this$props.title,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["inline", "disabled", "validationState", "inputRef", "className", "style", "title", "children"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react.default.createElement("input", (0, _extends2.default)({}, elementProps, {
	      ref: inputRef,
	      type: "radio",
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2); // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	
	
	       false ? (0, _warning.default)(!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	      return _react.default.createElement("label", {
	        className: (0, _classnames.default)(className, _classes),
	        style: style,
	        title: title
	      }, input, children);
	    }
	
	    var classes = (0, _extends2.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	
	    if (validationState) {
	      classes["has-" + validationState] = true;
	    }
	
	    return _react.default.createElement("div", {
	      className: (0, _classnames.default)(className, classes),
	      style: style
	    }, _react.default.createElement("label", {
	      title: title
	    }, input, children));
	  };
	
	  return Radio;
	}(_react.default.Component);
	
	Radio.propTypes = propTypes;
	Radio.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('radio', Radio);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _elementType = _interopRequireDefault(__webpack_require__(34));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var propTypes = {
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Row =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Row, _React$Component);
	
	  function Row() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Row.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.componentClass,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return Row;
	}(_react.default.Component);
	
	Row.propTypes = propTypes;
	Row.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('row', Row);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(58));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _elementType = _interopRequireDefault(__webpack_require__(34));
	
	var _warning = _interopRequireDefault(__webpack_require__(47));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var _Fade = _interopRequireDefault(__webpack_require__(319));
	
	var propTypes = {
	  /**
	   * Uniquely identify the `<TabPane>` among its siblings.
	   */
	  eventKey: _propTypes.default.any,
	
	  /**
	   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
	   * `true` to enable the default `<Fade>` animation or
	   * a react-transition-group v2 `<Transition/>` component.
	   */
	  animation: _propTypes.default.oneOfType([_propTypes.default.bool, _elementType.default]),
	
	  /** @private * */
	  id: _propTypes.default.string,
	
	  /** @private * */
	  'aria-labelledby': _propTypes.default.string,
	
	  /**
	   * If not explicitly specified and rendered in the context of a
	   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
	   * If otherwise not explicitly specified, `tab-pane`.
	   */
	  bsClass: _propTypes.default.string,
	
	  /**
	   * Transition onEnter callback when animation is not `false`
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Transition onEntering callback when animation is not `false`
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Transition onEntered callback when animation is not `false`
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Transition onExit callback when animation is not `false`
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Transition onExiting callback when animation is not `false`
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * Transition onExited callback when animation is not `false`
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Wait until the first "enter" transition to mount the tab (add it to the DOM)
	   */
	  mountOnEnter: _propTypes.default.bool,
	
	  /**
	   * Unmount the tab (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes.default.bool
	};
	var contextTypes = {
	  $bs_tabContainer: _propTypes.default.shape({
	    getTabId: _propTypes.default.func,
	    getPaneId: _propTypes.default.func
	  }),
	  $bs_tabContent: _propTypes.default.shape({
	    bsClass: _propTypes.default.string,
	    animation: _propTypes.default.oneOfType([_propTypes.default.bool, _elementType.default]),
	    activeKey: _propTypes.default.any,
	    mountOnEnter: _propTypes.default.bool,
	    unmountOnExit: _propTypes.default.bool,
	    onPaneEnter: _propTypes.default.func.isRequired,
	    onPaneExited: _propTypes.default.func.isRequired,
	    exiting: _propTypes.default.bool.isRequired
	  })
	};
	/**
	 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
	 * conflict with the top level one.
	 */
	
	var childContextTypes = {
	  $bs_tabContainer: _propTypes.default.oneOf([null])
	};
	
	var TabPane =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(TabPane, _React$Component);
	
	  function TabPane(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    _this.handleEnter = _this.handleEnter.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleExited = _this.handleExited.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.in = false;
	    return _this;
	  }
	
	  var _proto = TabPane.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      $bs_tabContainer: null
	    };
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    if (this.shouldBeIn()) {
	      // In lieu of the action event firing.
	      this.handleEnter();
	    }
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate() {
	    if (this.in) {
	      if (!this.shouldBeIn()) {
	        // We shouldn't be active any more. Notify the parent.
	        this.handleExited();
	      }
	    } else if (this.shouldBeIn()) {
	      // We are the active child. Notify the parent.
	      this.handleEnter();
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    if (this.in) {
	      // In lieu of the action event firing.
	      this.handleExited();
	    }
	  };
	
	  _proto.getAnimation = function getAnimation() {
	    if (this.props.animation != null) {
	      return this.props.animation;
	    }
	
	    var tabContent = this.context.$bs_tabContent;
	    return tabContent && tabContent.animation;
	  };
	
	  _proto.handleEnter = function handleEnter() {
	    var tabContent = this.context.$bs_tabContent;
	
	    if (!tabContent) {
	      return;
	    }
	
	    this.in = tabContent.onPaneEnter(this, this.props.eventKey);
	  };
	
	  _proto.handleExited = function handleExited() {
	    var tabContent = this.context.$bs_tabContent;
	
	    if (!tabContent) {
	      return;
	    }
	
	    tabContent.onPaneExited(this);
	    this.in = false;
	  };
	
	  _proto.isActive = function isActive() {
	    var tabContent = this.context.$bs_tabContent;
	    var activeKey = tabContent && tabContent.activeKey;
	    return this.props.eventKey === activeKey;
	  };
	
	  _proto.shouldBeIn = function shouldBeIn() {
	    return this.getAnimation() && this.isActive();
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        eventKey = _this$props.eventKey,
	        className = _this$props.className,
	        onEnter = _this$props.onEnter,
	        onEntering = _this$props.onEntering,
	        onEntered = _this$props.onEntered,
	        onExit = _this$props.onExit,
	        onExiting = _this$props.onExiting,
	        onExited = _this$props.onExited,
	        propsMountOnEnter = _this$props.mountOnEnter,
	        propsUnmountOnExit = _this$props.unmountOnExit,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["eventKey", "className", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "mountOnEnter", "unmountOnExit"]);
	    var _this$context = this.context,
	        tabContent = _this$context.$bs_tabContent,
	        tabContainer = _this$context.$bs_tabContainer;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var active = this.isActive();
	    var animation = this.getAnimation();
	    var mountOnEnter = propsMountOnEnter != null ? propsMountOnEnter : tabContent && tabContent.mountOnEnter;
	    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;
	
	    if (!active && !animation && unmountOnExit) {
	      return null;
	    }
	
	    var Transition = animation === true ? _Fade.default : animation || null;
	
	    if (tabContent) {
	      bsProps.bsClass = (0, _bootstrapUtils.prefix)(tabContent, 'pane');
	    }
	
	    var classes = (0, _extends2.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active
	    });
	
	    if (tabContainer) {
	       false ? (0, _warning.default)(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	      elementProps.id = tabContainer.getPaneId(eventKey);
	      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
	    }
	
	    var pane = _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
	      role: "tabpanel",
	      "aria-hidden": !active,
	      className: (0, _classnames.default)(className, classes)
	    }));
	
	    if (Transition) {
	      var exiting = tabContent && tabContent.exiting;
	      return _react.default.createElement(Transition, {
	        in: active && !exiting,
	        onEnter: (0, _createChainedFunction.default)(this.handleEnter, onEnter),
	        onEntering: onEntering,
	        onEntered: onEntered,
	        onExit: onExit,
	        onExiting: onExiting,
	        onExited: (0, _createChainedFunction.default)(this.handleExited, onExited),
	        mountOnEnter: mountOnEnter,
	        unmountOnExit: unmountOnExit
	      }, pane);
	    }
	
	    return pane;
	  };
	
	  return TabPane;
	}(_react.default.Component);
	
	TabPane.propTypes = propTypes;
	TabPane.contextTypes = contextTypes;
	TabPane.childContextTypes = childContextTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('tab-pane', TabPane);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Button = _interopRequireDefault(__webpack_require__(232));
	
	var propTypes = {
	  /**
	   * The `<input>` `type`
	   * @type {[type]}
	   */
	  type: _propTypes.default.oneOf(['checkbox', 'radio']),
	
	  /**
	   * The HTML input name, used to group like checkboxes or radio buttons together
	   * semantically
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * The checked state of the input, managed by `<ToggleButtonGroup>`` automatically
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * The disabled state of both the label and input
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * [onChange description]
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The value of the input, and unique identifier in the ToggleButtonGroup
	   */
	  value: _propTypes.default.any.isRequired
	};
	
	var ToggleButton =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(ToggleButton, _React$Component);
	
	  function ToggleButton() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ToggleButton.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        name = _this$props.name,
	        checked = _this$props.checked,
	        type = _this$props.type,
	        onChange = _this$props.onChange,
	        value = _this$props.value,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["children", "name", "checked", "type", "onChange", "value"]);
	    var disabled = props.disabled;
	    return _react.default.createElement(_Button.default, (0, _extends2.default)({}, props, {
	      active: !!checked,
	      componentClass: "label"
	    }), _react.default.createElement("input", {
	      name: name,
	      type: type,
	      autoComplete: "off",
	      value: value,
	      checked: !!checked,
	      disabled: !!disabled,
	      onChange: onChange
	    }), children);
	  };
	
	  return ToggleButton;
	}(_react.default.Component);
	
	ToggleButton.propTypes = propTypes;
	var _default = ToggleButton;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.generatedId = generatedId;
	exports.requiredRoles = requiredRoles;
	exports.exclusiveRoles = exclusiveRoles;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _createChainableTypeChecker = _interopRequireDefault(__webpack_require__(317));
	
	var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(62));
	
	var idPropType = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]);
	
	function generatedId(name) {
	  return function (props) {
	    var error = null;
	
	    if (!props.generateChildId) {
	      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      error = idPropType.apply(void 0, [props].concat(args));
	
	      if (!error && !props.id) {
	        error = new Error("In order to properly initialize the " + name + " in a way that is accessible to assistive technologies " + ("(such as screen readers) an `id` or a `generateChildId` prop to " + name + " is required"));
	      }
	    }
	
	    return error;
	  };
	}
	
	function requiredRoles() {
	  for (var _len2 = arguments.length, roles = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    roles[_key2] = arguments[_key2];
	  }
	
	  return (0, _createChainableTypeChecker.default)(function (props, propName, component) {
	    var missing;
	    roles.every(function (role) {
	      if (!_ValidComponentChildren.default.some(props.children, function (child) {
	        return child.props.bsRole === role;
	      })) {
	        missing = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (missing) {
	      return new Error("(children) " + component + " - Missing a required child with bsRole: " + (missing + ". " + component + " must have at least one child of each of ") + ("the following bsRoles: " + roles.join(', ')));
	    }
	
	    return null;
	  });
	}
	
	function exclusiveRoles() {
	  for (var _len3 = arguments.length, roles = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    roles[_key3] = arguments[_key3];
	  }
	
	  return (0, _createChainableTypeChecker.default)(function (props, propName, component) {
	    var duplicate;
	    roles.every(function (role) {
	      var childrenWithRole = _ValidComponentChildren.default.filter(props.children, function (child) {
	        return child.props.bsRole === role;
	      });
	
	      if (childrenWithRole.length > 1) {
	        duplicate = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (duplicate) {
	      return new Error("(children) " + component + " - Duplicate children detected of bsRole: " + (duplicate + ". Only one child each allowed with the following ") + ("bsRoles: " + roles.join(', ')));
	    }
	
	    return null;
	  });
	}

/***/ },
/* 897 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = capitalize;
	
	function capitalize(string) {
	  return "" + string.charAt(0).toUpperCase() + string.slice(1);
	}
	
	module.exports = exports["default"];

/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Collapse = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(899);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMotion = __webpack_require__(2027);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SPRING_PRECISION = 1;
	
	var WAITING = 'WAITING';
	var RESIZING = 'RESIZING';
	var RESTING = 'RESTING';
	var IDLING = 'IDLING';
	
	var noop = function noop() {
	  return null;
	};
	var css = {
	  collapse: 'ReactCollapse--collapse',
	  content: 'ReactCollapse--content'
	};
	
	var Collapse = exports.Collapse = function (_React$PureComponent) {
	  _inherits(Collapse, _React$PureComponent);
	
	  function Collapse(props) {
	    _classCallCheck(this, Collapse);
	
	    var _this = _possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      currentState: IDLING,
	      from: 0,
	      to: 0
	    };
	    return _this;
	  }
	
	  _createClass(Collapse, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          isOpened = _props.isOpened,
	          forceInitialAnimation = _props.forceInitialAnimation,
	          onRest = _props.onRest;
	
	      if (isOpened) {
	        var to = this.getTo();
	        if (forceInitialAnimation) {
	          var from = this.wrapper.clientHeight;
	          this.setState({ currentState: RESIZING, from: from, to: to });
	        } else {
	          this.setState({ currentState: IDLING, from: to, to: to });
	        }
	      }
	      onRest();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.hasNestedCollapse) {
	        // For nested collapses we do not need to change to waiting state
	        // and should keep `height:auto`
	        // Because children will be animated and height will not jump anyway
	        // See https://github.com/nkbt/react-collapse/issues/76 for more details
	        if (nextProps.isOpened !== this.props.isOpened) {
	          // Still go to WAITING state if own isOpened was changed
	          this.setState({ currentState: WAITING });
	        }
	      } else if (this.state.currentState === IDLING && (nextProps.isOpened || this.props.isOpened)) {
	        this.setState({ currentState: WAITING });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(_, prevState) {
	      var _props2 = this.props,
	          isOpened = _props2.isOpened,
	          onRest = _props2.onRest,
	          onMeasure = _props2.onMeasure;
	
	
	      if (this.state.currentState === IDLING) {
	        onRest();
	        return;
	      }
	
	      if (prevState.to !== this.state.to) {
	        onMeasure({ height: this.state.to, width: this.content.clientWidth });
	      }
	
	      var from = this.wrapper.clientHeight;
	      var to = isOpened ? this.getTo() : 0;
	
	      if (from !== to) {
	        this.setState({ currentState: RESIZING, from: from, to: to });
	        return;
	      }
	
	      if (this.state.currentState === RESTING || this.state.currentState === WAITING) {
	        this.setState({ currentState: IDLING, from: from, to: to });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      cancelAnimationFrame(this.raf);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_reactMotion.Motion, _extends({}, this.getMotionProps(), {
	        onRest: this.onRest,
	        children: this.renderContent }));
	    }
	  }]);
	
	  return Collapse;
	}(_react2.default.PureComponent);
	
	Collapse.propTypes = {
	  isOpened: _propTypes2.default.bool.isRequired,
	  springConfig: _propTypes2.default.objectOf(_propTypes2.default.number),
	  forceInitialAnimation: _propTypes2.default.bool,
	
	  hasNestedCollapse: _propTypes2.default.bool,
	
	  fixedHeight: _propTypes2.default.number,
	
	  theme: _propTypes2.default.objectOf(_propTypes2.default.string),
	  style: _propTypes2.default.object,
	
	  onRender: _propTypes2.default.func,
	  onRest: _propTypes2.default.func,
	  onMeasure: _propTypes2.default.func,
	
	  children: _propTypes2.default.node.isRequired
	};
	Collapse.defaultProps = {
	  forceInitialAnimation: false,
	  hasNestedCollapse: false,
	  fixedHeight: -1,
	  style: {},
	  theme: css,
	  onRender: noop,
	  onRest: noop,
	  onMeasure: noop
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.onContentRef = function (content) {
	    _this2.content = content;
	  };
	
	  this.onWrapperRef = function (wrapper) {
	    _this2.wrapper = wrapper;
	  };
	
	  this.onRest = function () {
	    _this2.raf = requestAnimationFrame(_this2.setResting);
	  };
	
	  this.setResting = function () {
	    _this2.setState({ currentState: RESTING });
	  };
	
	  this.getTo = function () {
	    var fixedHeight = _this2.props.fixedHeight;
	
	    return fixedHeight > -1 ? fixedHeight : _this2.content.clientHeight;
	  };
	
	  this.getWrapperStyle = function (height) {
	    if (_this2.state.currentState === IDLING && _this2.state.to) {
	      var fixedHeight = _this2.props.fixedHeight;
	
	      if (fixedHeight > -1) {
	        return { overflow: 'hidden', height: fixedHeight };
	      }
	      return { height: 'auto' };
	    }
	
	    if (_this2.state.currentState === WAITING && !_this2.state.to) {
	      return { overflow: 'hidden', height: 0 };
	    }
	
	    return { overflow: 'hidden', height: Math.max(0, height) };
	  };
	
	  this.getMotionProps = function () {
	    var springConfig = _this2.props.springConfig;
	
	
	    return _this2.state.currentState === IDLING ? {
	      // When completely stable, instantly jump to the position
	      defaultStyle: { height: _this2.state.to },
	      style: { height: _this2.state.to }
	    } : {
	      // Otherwise, animate
	      defaultStyle: { height: _this2.state.from },
	      style: { height: (0, _reactMotion.spring)(_this2.state.to, _extends({ precision: SPRING_PRECISION }, springConfig)) }
	    };
	  };
	
	  this.renderContent = function (_ref) {
	    var height = _ref.height;
	
	    // eslint-disable-line
	    var _props3 = _this2.props,
	        _isOpened = _props3.isOpened,
	        _springConfig = _props3.springConfig,
	        _forceInitialAnimation = _props3.forceInitialAnimation,
	        _hasNestedCollapse = _props3.hasNestedCollapse,
	        _fixedHeight = _props3.fixedHeight,
	        theme = _props3.theme,
	        style = _props3.style,
	        onRender = _props3.onRender,
	        _onRest = _props3.onRest,
	        _onMeasure = _props3.onMeasure,
	        children = _props3.children,
	        props = _objectWithoutProperties(_props3, ['isOpened', 'springConfig', 'forceInitialAnimation', 'hasNestedCollapse', 'fixedHeight', 'theme', 'style', 'onRender', 'onRest', 'onMeasure', 'children']);
	
	    var _state = _this2.state,
	        from = _state.from,
	        to = _state.to;
	
	    // DANGEROUS, use with caution, never do setState with it
	
	    onRender({ current: height, from: from, to: to });
	
	    return _react2.default.createElement(
	      'div',
	      _extends({
	        ref: _this2.onWrapperRef,
	        className: theme.collapse,
	        style: _extends({}, _this2.getWrapperStyle(Math.max(0, height)), style)
	      }, props),
	      _react2.default.createElement(
	        'div',
	        { ref: _this2.onContentRef, className: theme.content },
	        children
	      )
	    );
	  };
	};

/***/ },
/* 899 */
[2243, 1984],
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports,__webpack_require__(1),__webpack_require__(901),__webpack_require__(6),__webpack_require__(1698),__webpack_require__(822),__webpack_require__(1686),__webpack_require__(818),__webpack_require__(817),__webpack_require__(481),__webpack_require__(819),__webpack_require__(483),__webpack_require__(820),__webpack_require__(1728),__webpack_require__(1727),__webpack_require__(1726),__webpack_require__(1730),__webpack_require__(1729),__webpack_require__(1731),__webpack_require__(1693),__webpack_require__(1690),__webpack_require__(1689),__webpack_require__(1688),__webpack_require__(1687),__webpack_require__(1691),__webpack_require__(1692),__webpack_require__(1695),__webpack_require__(1694),__webpack_require__(1722),__webpack_require__(1720),__webpack_require__(1719),__webpack_require__(824),__webpack_require__(1721),__webpack_require__(1723),__webpack_require__(1715),__webpack_require__(1714),__webpack_require__(1679),__webpack_require__(1680),__webpack_require__(1681),__webpack_require__(1682),__webpack_require__(484),__webpack_require__(826),__webpack_require__(1724),__webpack_require__(825),__webpack_require__(1725),__webpack_require__(1683),__webpack_require__(1685),__webpack_require__(1684),__webpack_require__(1699),__webpack_require__(1700),__webpack_require__(1701),__webpack_require__(1703),__webpack_require__(1702),__webpack_require__(1696),__webpack_require__(1697),__webpack_require__(1704),__webpack_require__(19),__webpack_require__(1717),__webpack_require__(1718),__webpack_require__(1993),__webpack_require__(1996)):"function"==typeof define&&define.amd?define(["exports","react","prop-types","classnames","date-fns/isDate","date-fns/isValid","date-fns/format","date-fns/addMinutes","date-fns/addHours","date-fns/addDays","date-fns/addWeeks","date-fns/addMonths","date-fns/addYears","date-fns/subMinutes","date-fns/subHours","date-fns/subDays","date-fns/subWeeks","date-fns/subMonths","date-fns/subYears","date-fns/getSeconds","date-fns/getMinutes","date-fns/getHours","date-fns/getDay","date-fns/getDate","date-fns/getMonth","date-fns/getQuarter","date-fns/getYear","date-fns/getTime","date-fns/setSeconds","date-fns/setMinutes","date-fns/setHours","date-fns/setMonth","date-fns/setQuarter","date-fns/setYear","date-fns/min","date-fns/max","date-fns/differenceInCalendarDays","date-fns/differenceInCalendarMonths","date-fns/differenceInCalendarWeeks","date-fns/differenceInCalendarYears","date-fns/startOfDay","date-fns/startOfWeek","date-fns/startOfMonth","date-fns/startOfQuarter","date-fns/startOfYear","date-fns/endOfDay","date-fns/endOfWeek","date-fns/endOfMonth","date-fns/isEqual","date-fns/isSameDay","date-fns/isSameMonth","date-fns/isSameYear","date-fns/isSameQuarter","date-fns/isAfter","date-fns/isBefore","date-fns/isWithinInterval","date-fns/toDate","date-fns/parse","date-fns/parseISO","react-onclickoutside","react-popper"],t):t((e=e||self).DatePicker={},e.React,e.PropTypes,e.classNames,e.isDate,e.isValidDate,e.format,e.addMinutes,e.addHours,e.utils,e.utils$1,e.addMonths,e.addYears,e.subMinutes,e.subHours,e.subDays,e.subWeeks,e.subMonths,e.subYears,e.getSeconds,e.getMinutes,e.getHours,e.getDay,e.getDate,e.getMonth,e.getQuarter,e.getYear,e.getTime,e.setSeconds,e.setMinutes,e.setHours,e.utils$2,e.utils$3,e.setYear,e.min,e.max,e.differenceInCalendarDays,e.differenceInCalendarMonths,e.differenceInCalendarWeeks,e.differenceInCalendarYears,e.startOfDay,e.startOfWeek,e.startOfMonth,e.startOfQuarter,e.startOfYear,e.endOfDay,e.endOfWeek,e.endOfMonth,e.dfIsEqual,e.dfIsSameDay,e.dfIsSameMonth,e.dfIsSameYear,e.dfIsSameQuarter,e.isAfter,e.isBefore,e.isWithinInterval,e.toDate,e.parse,e.parseISO,e.onClickOutside,e.ReactPopper)}(this,function(e,t,r,n,a,o,s,p,i,c,d,l,u,h,f,m,y,w,v,D,g,k,C,_,b,S,M,O,P,E,N,Y,T,x,I,q,L,W,F,B,R,j,H,Q,A,V,K,U,$,z,G,J,X,Z,ee,te,re,ne,ae,oe,se){"use strict";function pe(e){return(pe="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function ie(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function ce(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function de(e,t,r){return t&&ce(e.prototype,t),r&&ce(e,r),e}function le(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function ue(){return(ue=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e}).apply(this,arguments)}function he(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),r.push.apply(r,n)}return r}function fe(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&ye(e,t)}function me(e){return(me=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function ye(e,t){return(ye=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function we(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function ve(e,t){return!t||"object"!=typeof t&&"function"!=typeof t?we(e):t}t=t&&t.hasOwnProperty("default")?t.default:t,r=r&&r.hasOwnProperty("default")?r.default:r,n=n&&n.hasOwnProperty("default")?n.default:n,a=a&&a.hasOwnProperty("default")?a.default:a,o=o&&o.hasOwnProperty("default")?o.default:o,s=s&&s.hasOwnProperty("default")?s.default:s,p=p&&p.hasOwnProperty("default")?p.default:p,i=i&&i.hasOwnProperty("default")?i.default:i,c=c&&c.hasOwnProperty("default")?c.default:c,d=d&&d.hasOwnProperty("default")?d.default:d,l=l&&l.hasOwnProperty("default")?l.default:l,u=u&&u.hasOwnProperty("default")?u.default:u,h=h&&h.hasOwnProperty("default")?h.default:h,f=f&&f.hasOwnProperty("default")?f.default:f,m=m&&m.hasOwnProperty("default")?m.default:m,y=y&&y.hasOwnProperty("default")?y.default:y,w=w&&w.hasOwnProperty("default")?w.default:w,v=v&&v.hasOwnProperty("default")?v.default:v,D=D&&D.hasOwnProperty("default")?D.default:D,g=g&&g.hasOwnProperty("default")?g.default:g,k=k&&k.hasOwnProperty("default")?k.default:k,C=C&&C.hasOwnProperty("default")?C.default:C,_=_&&_.hasOwnProperty("default")?_.default:_,b=b&&b.hasOwnProperty("default")?b.default:b,S=S&&S.hasOwnProperty("default")?S.default:S,M=M&&M.hasOwnProperty("default")?M.default:M,O=O&&O.hasOwnProperty("default")?O.default:O,P=P&&P.hasOwnProperty("default")?P.default:P,E=E&&E.hasOwnProperty("default")?E.default:E,N=N&&N.hasOwnProperty("default")?N.default:N,Y=Y&&Y.hasOwnProperty("default")?Y.default:Y,T=T&&T.hasOwnProperty("default")?T.default:T,x=x&&x.hasOwnProperty("default")?x.default:x,I=I&&I.hasOwnProperty("default")?I.default:I,q=q&&q.hasOwnProperty("default")?q.default:q,L=L&&L.hasOwnProperty("default")?L.default:L,W=W&&W.hasOwnProperty("default")?W.default:W,F=F&&F.hasOwnProperty("default")?F.default:F,B=B&&B.hasOwnProperty("default")?B.default:B,R=R&&R.hasOwnProperty("default")?R.default:R,j=j&&j.hasOwnProperty("default")?j.default:j,H=H&&H.hasOwnProperty("default")?H.default:H,Q=Q&&Q.hasOwnProperty("default")?Q.default:Q,A=A&&A.hasOwnProperty("default")?A.default:A,V=V&&V.hasOwnProperty("default")?V.default:V,K=K&&K.hasOwnProperty("default")?K.default:K,U=U&&U.hasOwnProperty("default")?U.default:U,$=$&&$.hasOwnProperty("default")?$.default:$,z=z&&z.hasOwnProperty("default")?z.default:z,G=G&&G.hasOwnProperty("default")?G.default:G,J=J&&J.hasOwnProperty("default")?J.default:J,X=X&&X.hasOwnProperty("default")?X.default:X,Z=Z&&Z.hasOwnProperty("default")?Z.default:Z,ee=ee&&ee.hasOwnProperty("default")?ee.default:ee,te=te&&te.hasOwnProperty("default")?te.default:te,re=re&&re.hasOwnProperty("default")?re.default:re,ne=ne&&ne.hasOwnProperty("default")?ne.default:ne,ae=ae&&ae.hasOwnProperty("default")?ae.default:ae,oe=oe&&oe.hasOwnProperty("default")?oe.default:oe;var De,ge=function(e,t){return e(t={exports:{}},t.exports),t.exports}(function(e,t){function r(e,t){switch(e){case"P":return t.date({width:"short"});case"PP":return t.date({width:"medium"});case"PPP":return t.date({width:"long"});case"PPPP":default:return t.date({width:"full"})}}function n(e,t){switch(e){case"p":return t.time({width:"short"});case"pp":return t.time({width:"medium"});case"ppp":return t.time({width:"long"});case"pppp":default:return t.time({width:"full"})}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var a={p:n,P:function(e,t){var a,o=e.match(/(P+)(p+)?/),s=o[1],p=o[2];if(!p)return r(e,t);switch(s){case"P":a=t.dateTime({width:"short"});break;case"PP":a=t.dateTime({width:"medium"});break;case"PPP":a=t.dateTime({width:"long"});break;case"PPPP":default:a=t.dateTime({width:"full"})}return a.replace("{{date}}",r(s,t)).replace("{{time}}",n(p,t))}};t.default=a,e.exports=t.default}),ke=(De=ge)&&De.__esModule&&Object.prototype.hasOwnProperty.call(De,"default")?De.default:De,Ce=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;function _e(e){var t=e?"string"==typeof e||e instanceof String?ae(e):re(e):new Date;return Se(t)?t:null}function be(e,t,r,n){var a=null,o=We(r)||Le(),p=!0;return Array.isArray(t)?(t.forEach(function(t){var r=ne(e,t,new Date,{locale:o});n&&(p=Se(r)&&e===s(r,t,{awareOfUnicodeTokens:!0})),Se(r)&&p&&(a=r)}),a):(a=ne(e,t,new Date,{locale:o}),n?p=Se(a)&&e===s(a,t,{awareOfUnicodeTokens:!0}):Se(a)||(t=t.match(Ce).map(function(e){var t=e[0];if("p"===t||"P"===t){var r=ke[t];return o?r(e,o.formatLong):t}return e}).join(""),e.length>0&&(a=ne(e,t.slice(0,e.length),new Date)),Se(a)||(a=new Date(e))),Se(a)&&p?a:null)}function Se(e){return o(e)&&Z(e,new Date("1/1/1000"))}function Me(e,t,r){if("en"===r)return s(e,t,{awareOfUnicodeTokens:!0});var n=We(r);return r&&!n&&console.warn('A locale object was not found for the provided string ["'.concat(r,'"].')),!n&&Le()&&We(Le())&&(n=We(Le())),s(e,t,{locale:n||null,awareOfUnicodeTokens:!0})}function Oe(e,t){var r=t.hour,n=void 0===r?0:r,a=t.minute,o=void 0===a?0:a,s=t.second;return N(E(P(e,void 0===s?0:s),o),n)}function Pe(e,t){var r=We(t||Le());return j(e,{locale:r})}function Ee(e){return H(e)}function Ne(e,t){return e&&t?J(e,t):!e&&!t}function Ye(e,t){return e&&t?G(e,t):!e&&!t}function Te(e,t){return e&&t?X(e,t):!e&&!t}function xe(e,t){return e&&t?z(e,t):!e&&!t}function Ie(e,t){return e&&t?$(e,t):!e&&!t}function qe(e,t,r){var n,a=R(t),o=V(r);try{n=te(e,{start:a,end:o})}catch(e){n=!1}return n}function Le(){return("undefined"!=typeof window?window:global).__localeId__}function We(e){if("string"==typeof e){var t="undefined"!=typeof window?window:global;return t.__localeData__?t.__localeData__[e]:null}return e}function Fe(e,t){return Me(Y(_e(),e),"LLL",t)}function Be(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,a=t.excludeDates,o=t.includeDates,s=t.filterDate;return Ae(e,{minDate:r,maxDate:n})||a&&a.some(function(t){return xe(e,t)})||o&&!o.some(function(t){return xe(e,t)})||s&&!s(_e(e))||!1}function Re(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,a=t.excludeDates,o=t.includeDates,s=t.filterDate;return Ae(e,{minDate:r,maxDate:n})||a&&a.some(function(t){return Ye(e,t)})||o&&!o.some(function(t){return Ye(e,t)})||s&&!s(_e(e))||!1}function je(e,t,r,n){var a=M(e),o=b(e),s=M(t),p=b(t),i=M(n);return a===s&&a===i?o<=r&&r<=p:a<s?i===a&&o<=r||i===s&&p>=r||i<s&&i>a:void 0}function He(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,a=t.excludeDates,o=t.includeDates,s=t.filterDate;return Ae(e,{minDate:r,maxDate:n})||a&&a.some(function(t){return Te(e,t)})||o&&!o.some(function(t){return Te(e,t)})||s&&!s(_e(e))||!1}function Qe(e,t,r,n){var a=M(e),o=S(e),s=M(t),p=S(t),i=M(n);return a===s&&a===i?o<=r&&r<=p:a<s?i===a&&o<=r||i===s&&p>=r||i<s&&i>a:void 0}function Ae(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate;return r&&L(e,r)<0||n&&L(e,n)>0}function Ve(e,t){for(var r=t.length,n=0;n<r;n++)if(k(t[n])===k(e)&&g(t[n])===g(e))return!0;return!1}function Ke(e,t){var r=t.minTime,n=t.maxTime;if(!r||!n)throw new Error("Both minTime and maxTime props required");var a,o=_e(),s=N(E(o,g(e)),k(e)),p=N(E(o,g(r)),k(r)),i=N(E(o,g(n)),k(n));try{a=!te(s,{start:p,end:i})}catch(e){a=!1}return a}function Ue(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.includeDates,a=w(e,1);return r&&W(r,a)>0||n&&n.every(function(e){return W(e,a)>0})||!1}function $e(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.includeDates,a=l(e,1);return r&&W(a,r)>0||n&&n.every(function(e){return W(a,e)>0})||!1}function ze(e){var t=e.minDate,r=e.includeDates;if(r&&t){var n=r.filter(function(e){return L(e,t)>=0});return I(n)}return r?I(r):t}function Ge(e){var t=e.maxDate,r=e.includeDates;if(r&&t){var n=r.filter(function(e){return L(e,t)<=0});return q(n)}return r?q(r):t}function Je(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"react-datepicker__day--highlighted",r=new Map,n=0,o=e.length;n<o;n++){var s=e[n];if(a(s)){var p=Me(s,"MM.dd.yyyy"),i=r.get(p)||[];i.includes(t)||(i.push(t),r.set(p,i))}else if("object"===pe(s)){var c=Object.keys(s),d=c[0],l=s[c[0]];if("string"==typeof d&&l.constructor===Array)for(var u=0,h=l.length;u<h;u++){var f=Me(l[u],"MM.dd.yyyy"),m=r.get(f)||[];m.includes(d)||(m.push(d),r.set(f,m))}}}return r}function Xe(e,t,r,n,a){for(var o=a.length,s=[],c=0;c<o;c++){var d=p(i(e,k(a[c])),g(a[c])),l=p(e,(r+1)*n);Z(d,t)&&ee(d,l)&&s.push(a[c])}return s}function Ze(e){return e<10?"0".concat(e):"".concat(e)}function et(e,t,r,n){for(var a=[],o=0;o<2*t+1;o++){var s=e+t-o,p=!0;r&&(p=M(r)<=s),n&&p&&(p=M(n)>=s),p&&a.push(s)}return a}var tt=oe(function(e){function r(e){var n;ie(this,r),le(we(n=ve(this,me(r).call(this,e))),"renderOptions",function(){var e=n.props.year,r=n.state.yearsList.map(function(r){return t.createElement("div",{className:e===r?"react-datepicker__year-option react-datepicker__year-option--selected_year":"react-datepicker__year-option",key:r,ref:r,onClick:n.onChange.bind(we(n),r)},e===r?t.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",r)}),a=n.props.minDate?M(n.props.minDate):null,o=n.props.maxDate?M(n.props.maxDate):null;return o&&n.state.yearsList.find(function(e){return e===o})||r.unshift(t.createElement("div",{className:"react-datepicker__year-option",ref:"upcoming",key:"upcoming",onClick:n.incrementYears},t.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),a&&n.state.yearsList.find(function(e){return e===a})||r.push(t.createElement("div",{className:"react-datepicker__year-option",ref:"previous",key:"previous",onClick:n.decrementYears},t.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),r}),le(we(n),"onChange",function(e){n.props.onChange(e)}),le(we(n),"handleClickOutside",function(){n.props.onCancel()}),le(we(n),"shiftYears",function(e){var t=n.state.yearsList.map(function(t){return t+e});n.setState({yearsList:t})}),le(we(n),"incrementYears",function(){return n.shiftYears(1)}),le(we(n),"decrementYears",function(){return n.shiftYears(-1)});var a=e.yearDropdownItemNumber,o=e.scrollableYearDropdown,s=a||(o?10:5);return n.state={yearsList:et(n.props.year,s,n.props.minDate,n.props.maxDate)},n}return fe(r,t.Component),de(r,[{key:"render",value:function(){var e=n({"react-datepicker__year-dropdown":!0,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return t.createElement("div",{className:e},this.renderOptions())}}]),r}()),rt=function(e){function r(){var e,n;ie(this,r);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return le(we(n=ve(this,(e=me(r)).call.apply(e,[this].concat(o)))),"state",{dropdownVisible:!1}),le(we(n),"renderSelectOptions",function(){for(var e=n.props.minDate?M(n.props.minDate):1900,r=n.props.maxDate?M(n.props.maxDate):2100,a=[],o=e;o<=r;o++)a.push(t.createElement("option",{key:o,value:o},o));return a}),le(we(n),"onSelectChange",function(e){n.onChange(e.target.value)}),le(we(n),"renderSelectMode",function(){return t.createElement("select",{value:n.props.year,className:"react-datepicker__year-select",onChange:n.onSelectChange},n.renderSelectOptions())}),le(we(n),"renderReadView",function(e){return t.createElement("div",{key:"read",style:{visibility:e?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:function(e){return n.toggleDropdown(e)}},t.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),t.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},n.props.year))}),le(we(n),"renderDropdown",function(){return t.createElement(tt,{key:"dropdown",ref:"options",year:n.props.year,onChange:n.onChange,onCancel:n.toggleDropdown,minDate:n.props.minDate,maxDate:n.props.maxDate,scrollableYearDropdown:n.props.scrollableYearDropdown,yearDropdownItemNumber:n.props.yearDropdownItemNumber})}),le(we(n),"renderScrollMode",function(){var e=n.state.dropdownVisible,t=[n.renderReadView(!e)];return e&&t.unshift(n.renderDropdown()),t}),le(we(n),"onChange",function(e){n.toggleDropdown(),e!==n.props.year&&n.props.onChange(e)}),le(we(n),"toggleDropdown",function(e){n.setState({dropdownVisible:!n.state.dropdownVisible},function(){n.props.adjustDateOnChange&&n.handleYearChange(n.props.date,e)})}),le(we(n),"handleYearChange",function(e,t){n.onSelect(e,t),n.setOpen()}),le(we(n),"onSelect",function(e,t){n.props.onSelect&&n.props.onSelect(e,t)}),le(we(n),"setOpen",function(){n.props.setOpen&&n.props.setOpen(!0)}),n}return fe(r,t.Component),de(r,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return t.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(),nt=oe(function(e){function r(){var e,n;ie(this,r);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return le(we(n=ve(this,(e=me(r)).call.apply(e,[this].concat(o)))),"renderOptions",function(){return n.props.monthNames.map(function(e,r){return t.createElement("div",{className:n.props.month===r?"react-datepicker__month-option react-datepicker__month-option--selected_month":"react-datepicker__month-option",key:e,ref:e,onClick:n.onChange.bind(we(n),r)},n.props.month===r?t.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",e)})}),le(we(n),"onChange",function(e){return n.props.onChange(e)}),le(we(n),"handleClickOutside",function(){return n.props.onCancel()}),n}return fe(r,t.Component),de(r,[{key:"render",value:function(){return t.createElement("div",{className:"react-datepicker__month-dropdown"},this.renderOptions())}}]),r}()),at=function(e){function r(){var e,n;ie(this,r);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return le(we(n=ve(this,(e=me(r)).call.apply(e,[this].concat(o)))),"state",{dropdownVisible:!1}),le(we(n),"renderSelectOptions",function(e){return e.map(function(e,r){return t.createElement("option",{key:r,value:r},e)})}),le(we(n),"renderSelectMode",function(e){return t.createElement("select",{value:n.props.month,className:"react-datepicker__month-select",onChange:function(e){return n.onChange(e.target.value)}},n.renderSelectOptions(e))}),le(we(n),"renderReadView",function(e,r){return t.createElement("div",{key:"read",style:{visibility:e?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:n.toggleDropdown},t.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}),t.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},r[n.props.month]))}),le(we(n),"renderDropdown",function(e){return t.createElement(nt,{key:"dropdown",ref:"options",month:n.props.month,monthNames:e,onChange:n.onChange,onCancel:n.toggleDropdown})}),le(we(n),"renderScrollMode",function(e){var t=n.state.dropdownVisible,r=[n.renderReadView(!t,e)];return t&&r.unshift(n.renderDropdown(e)),r}),le(we(n),"onChange",function(e){n.toggleDropdown(),e!==n.props.month&&n.props.onChange(e)}),le(we(n),"toggleDropdown",function(){return n.setState({dropdownVisible:!n.state.dropdownVisible})}),n}return fe(r,t.Component),de(r,[{key:"render",value:function(){var e,r=this,n=[0,1,2,3,4,5,6,7,8,9,10,11].map(this.props.useShortMonthInDropdown?function(e){return Fe(e,r.props.locale)}:function(e){return t=e,n=r.props.locale,Me(Y(_e(),t),"LLLL",n);var t,n});switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode(n);break;case"select":e=this.renderSelectMode(n)}return t.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}();function ot(e,t){for(var r=[],n=Ee(e),a=Ee(t);!Z(n,a);)r.push(_e(n)),n=l(n,1);return r}var st=oe(function(e){function r(e){var n;return ie(this,r),le(we(n=ve(this,me(r).call(this,e))),"renderOptions",function(){return n.state.monthYearsList.map(function(e){var r=O(e),a=Ne(n.props.date,e)&&Ye(n.props.date,e);return t.createElement("div",{className:a?"react-datepicker__month-year-option --selected_month-year":"react-datepicker__month-year-option",key:r,ref:r,onClick:n.onChange.bind(we(n),r)},a?t.createElement("span",{className:"react-datepicker__month-year-option--selected"},"✓"):"",Me(e,n.props.dateFormat))})}),le(we(n),"onChange",function(e){return n.props.onChange(e)}),le(we(n),"handleClickOutside",function(){n.props.onCancel()}),n.state={monthYearsList:ot(n.props.minDate,n.props.maxDate)},n}return fe(r,t.Component),de(r,[{key:"render",value:function(){var e=n({"react-datepicker__month-year-dropdown":!0,"react-datepicker__month-year-dropdown--scrollable":this.props.scrollableMonthYearDropdown});return t.createElement("div",{className:e},this.renderOptions())}}]),r}()),pt=function(e){function r(){var e,n;ie(this,r);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return le(we(n=ve(this,(e=me(r)).call.apply(e,[this].concat(o)))),"state",{dropdownVisible:!1}),le(we(n),"renderSelectOptions",function(){for(var e=Ee(n.props.minDate),r=Ee(n.props.maxDate),a=[];!Z(e,r);){var o=O(e);a.push(t.createElement("option",{key:o,value:o},Me(e,n.props.dateFormat,n.props.locale))),e=l(e,1)}return a}),le(we(n),"onSelectChange",function(e){n.onChange(e.target.value)}),le(we(n),"renderSelectMode",function(){return t.createElement("select",{value:O(Ee(n.props.date)),className:"react-datepicker__month-year-select",onChange:n.onSelectChange},n.renderSelectOptions())}),le(we(n),"renderReadView",function(e){var r=Me(n.props.date,n.props.dateFormat,n.props.locale);return t.createElement("div",{key:"read",style:{visibility:e?"visible":"hidden"},className:"react-datepicker__month-year-read-view",onClick:function(e){return n.toggleDropdown(e)}},t.createElement("span",{className:"react-datepicker__month-year-read-view--down-arrow"}),t.createElement("span",{className:"react-datepicker__month-year-read-view--selected-month-year"},r))}),le(we(n),"renderDropdown",function(){return t.createElement(st,{key:"dropdown",ref:"options",date:n.props.date,dateFormat:n.props.dateFormat,onChange:n.onChange,onCancel:n.toggleDropdown,minDate:n.props.minDate,maxDate:n.props.maxDate,scrollableMonthYearDropdown:n.props.scrollableMonthYearDropdown})}),le(we(n),"renderScrollMode",function(){var e=n.state.dropdownVisible,t=[n.renderReadView(!e)];return e&&t.unshift(n.renderDropdown()),t}),le(we(n),"onChange",function(e){n.toggleDropdown();var t=_e(parseInt(e));Ne(n.props.date,t)&&Ye(n.props.date,t)||n.props.onChange(t)}),le(we(n),"toggleDropdown",function(){return n.setState({dropdownVisible:!n.state.dropdownVisible})}),n}return fe(r,t.Component),de(r,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return t.createElement("div",{className:"react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(),it=function(e){function r(){var e,t;ie(this,r);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return le(we(t=ve(this,(e=me(r)).call.apply(e,[this].concat(o)))),"handleClick",function(e){!t.isDisabled()&&t.props.onClick&&t.props.onClick(e)}),le(we(t),"handleMouseEnter",function(e){!t.isDisabled()&&t.props.onMouseEnter&&t.props.onMouseEnter(e)}),le(we(t),"isSameDay",function(e){return xe(t.props.day,e)}),le(we(t),"isKeyboardSelected",function(){return!t.props.disabledKeyboardNavigation&&!t.props.inline&&!t.isSameDay(t.props.selected)&&t.isSameDay(t.props.preSelection)}),le(we(t),"isDisabled",function(){return Be(t.props.day,t.props)}),le(we(t),"isExcluded",function(){return function(e){var t=(arguments.length>1&&void 0!==arguments[1]?arguments[1]:{}).excludeDates;return t&&t.some(function(t){return xe(e,t)})||!1}(t.props.day,t.props)}),le(we(t),"getHighLightedClass",function(e){var r=t.props,n=r.day,a=r.highlightDates;if(!a)return!1;var o=Me(n,"MM.dd.yyyy");return a.get(o)}),le(we(t),"isInRange",function(){var e=t.props,r=e.day,n=e.startDate,a=e.endDate;return!(!n||!a)&&qe(r,n,a)}),le(we(t),"isInSelectingRange",function(){var e=t.props,r=e.day,n=e.selectsStart,a=e.selectsEnd,o=e.selectingDate,s=e.startDate,p=e.endDate;return!(!n&&!a||!o||t.isDisabled())&&(n&&p&&(ee(o,p)||Ie(o,p))?qe(r,o,p):!(!a||!s||!Z(o,s)&&!Ie(o,s))&&qe(r,s,o))}),le(we(t),"isSelectingRangeStart",function(){if(!t.isInSelectingRange())return!1;var e=t.props,r=e.day,n=e.selectingDate,a=e.startDate;return xe(r,e.selectsStart?n:a)}),le(we(t),"isSelectingRangeEnd",function(){if(!t.isInSelectingRange())return!1;var e=t.props,r=e.day,n=e.selectingDate,a=e.endDate;return xe(r,e.selectsEnd?n:a)}),le(we(t),"isRangeStart",function(){var e=t.props,r=e.day,n=e.startDate,a=e.endDate;return!(!n||!a)&&xe(n,r)}),le(we(t),"isRangeEnd",function(){var e=t.props,r=e.day,n=e.startDate,a=e.endDate;return!(!n||!a)&&xe(a,r)}),le(we(t),"isWeekend",function(){var e=C(t.props.day);return 0===e||6===e}),le(we(t),"isOutsideMonth",function(){return void 0!==t.props.month&&t.props.month!==b(t.props.day)}),le(we(t),"getClassNames",function(e){var r,a=t.props.dayClassName?t.props.dayClassName(e):void 0;return n("react-datepicker__day",a,"react-datepicker__day--"+Me(t.props.day,"ddd",r),{"react-datepicker__day--disabled":t.isDisabled(),"react-datepicker__day--excluded":t.isExcluded(),"react-datepicker__day--selected":t.isSameDay(t.props.selected),"react-datepicker__day--keyboard-selected":t.isKeyboardSelected(),"react-datepicker__day--range-start":t.isRangeStart(),"react-datepicker__day--range-end":t.isRangeEnd(),"react-datepicker__day--in-range":t.isInRange(),"react-datepicker__day--in-selecting-range":t.isInSelectingRange(),"react-datepicker__day--selecting-range-start":t.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":t.isSelectingRangeEnd(),"react-datepicker__day--today":t.isSameDay(_e()),"react-datepicker__day--weekend":t.isWeekend(),"react-datepicker__day--outside-month":t.isOutsideMonth()},t.getHighLightedClass("react-datepicker__day--highlighted"))}),t}return fe(r,t.Component),de(r,[{key:"render",value:function(){return t.createElement("div",{className:this.getClassNames(this.props.day),onClick:this.handleClick,onMouseEnter:this.handleMouseEnter,"aria-label":"day-".concat(_(this.props.day)),role:"option","aria-disabled":this.isDisabled()},this.props.renderDayContents?this.props.renderDayContents(_(this.props.day),this.props.day):_(this.props.day))}}]),r}(),ct=function(e){function r(){var e,t;ie(this,r);for(var n=arguments.length,a=new Array(n),o=0;o<n;o++)a[o]=arguments[o];return le(we(t=ve(this,(e=me(r)).call.apply(e,[this].concat(a)))),"handleClick",function(e){t.props.onClick&&t.props.onClick(e)}),t}return fe(r,t.Component),de(r,[{key:"render",value:function(){var e={"react-datepicker__week-number":!0,"react-datepicker__week-number--clickable":!!this.props.onClick};return t.createElement("div",{className:n(e),"aria-label":"week-".concat(this.props.weekNumber),onClick:this.handleClick},this.props.weekNumber)}}]),r}(),dt=function(e){function r(){var e,n;ie(this,r);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return le(we(n=ve(this,(e=me(r)).call.apply(e,[this].concat(o)))),"handleDayClick",function(e,t){n.props.onDayClick&&n.props.onDayClick(e,t)}),le(we(n),"handleDayMouseEnter",function(e){n.props.onDayMouseEnter&&n.props.onDayMouseEnter(e)}),le(we(n),"handleWeekClick",function(e,t,r){"function"==typeof n.props.onWeekSelect&&n.props.onWeekSelect(e,t,r),n.props.shouldCloseOnSelect&&n.props.setOpen(!1)}),le(we(n),"formatWeekNumber",function(e){return n.props.formatWeekNumber?n.props.formatWeekNumber(e):function(e){return Ne(K(e),e)?F(e,A(e))+1:1}(e)}),le(we(n),"renderDays",function(){var e=Pe(n.props.day,n.props.locale),r=[],a=n.formatWeekNumber(e);if(n.props.showWeekNumber){var o=n.props.onWeekSelect?n.handleWeekClick.bind(we(n),e,a):void 0;r.push(t.createElement(ct,{key:"W",weekNumber:a,onClick:o}))}return r.concat([0,1,2,3,4,5,6].map(function(r){var a=c(e,r);return t.createElement(it,{key:r,day:a,month:n.props.month,onClick:n.handleDayClick.bind(we(n),a),onMouseEnter:n.handleDayMouseEnter.bind(we(n),a),minDate:n.props.minDate,maxDate:n.props.maxDate,excludeDates:n.props.excludeDates,includeDates:n.props.includeDates,inline:n.props.inline,highlightDates:n.props.highlightDates,selectingDate:n.props.selectingDate,filterDate:n.props.filterDate,preSelection:n.props.preSelection,selected:n.props.selected,selectsStart:n.props.selectsStart,selectsEnd:n.props.selectsEnd,startDate:n.props.startDate,endDate:n.props.endDate,dayClassName:n.props.dayClassName,renderDayContents:n.props.renderDayContents,disabledKeyboardNavigation:n.props.disabledKeyboardNavigation})}))}),n}return fe(r,t.Component),de(r,[{key:"render",value:function(){return t.createElement("div",{className:"react-datepicker__week"},this.renderDays())}}],[{key:"defaultProps",get:function(){return{shouldCloseOnSelect:!0}}}]),r}(),lt=6,ut=function(e){function r(){var e,a;ie(this,r);for(var o=arguments.length,s=new Array(o),p=0;p<o;p++)s[p]=arguments[p];return le(we(a=ve(this,(e=me(r)).call.apply(e,[this].concat(s)))),"handleDayClick",function(e,t){a.props.onDayClick&&a.props.onDayClick(e,t,a.props.orderInDisplay)}),le(we(a),"handleDayMouseEnter",function(e){a.props.onDayMouseEnter&&a.props.onDayMouseEnter(e)}),le(we(a),"handleMouseLeave",function(){a.props.onMouseLeave&&a.props.onMouseLeave()}),le(we(a),"isRangeStartMonth",function(e){var t=a.props,r=t.day,n=t.startDate,o=t.endDate;return!(!n||!o)&&Ye(Y(r,e),n)}),le(we(a),"isRangeStartQuarter",function(e){var t=a.props,r=t.day,n=t.startDate,o=t.endDate;return!(!n||!o)&&Te(T(r,e),n)}),le(we(a),"isRangeEndMonth",function(e){var t=a.props,r=t.day,n=t.startDate,o=t.endDate;return!(!n||!o)&&Ye(Y(r,e),o)}),le(we(a),"isRangeEndQuarter",function(e){var t=a.props,r=t.day,n=t.startDate,o=t.endDate;return!(!n||!o)&&Te(T(r,e),o)}),le(we(a),"isWeekInMonth",function(e){var t=a.props.day,r=c(e,6);return Ye(e,t)||Ye(r,t)}),le(we(a),"renderWeeks",function(){for(var e=[],r=a.props.fixedHeight,n=Pe(Ee(a.props.day),a.props.locale),o=0,s=!1;e.push(t.createElement(dt,{key:o,day:n,month:b(a.props.day),onDayClick:a.handleDayClick,onDayMouseEnter:a.handleDayMouseEnter,onWeekSelect:a.props.onWeekSelect,formatWeekNumber:a.props.formatWeekNumber,locale:a.props.locale,minDate:a.props.minDate,maxDate:a.props.maxDate,excludeDates:a.props.excludeDates,includeDates:a.props.includeDates,inline:a.props.inline,highlightDates:a.props.highlightDates,selectingDate:a.props.selectingDate,filterDate:a.props.filterDate,preSelection:a.props.preSelection,selected:a.props.selected,selectsStart:a.props.selectsStart,selectsEnd:a.props.selectsEnd,showWeekNumber:a.props.showWeekNumbers,startDate:a.props.startDate,endDate:a.props.endDate,dayClassName:a.props.dayClassName,setOpen:a.props.setOpen,shouldCloseOnSelect:a.props.shouldCloseOnSelect,disabledKeyboardNavigation:a.props.disabledKeyboardNavigation,renderDayContents:a.props.renderDayContents})),!s;){o++,n=d(n,1);var p=r&&o>=lt,i=!r&&!a.isWeekInMonth(n);if(p||i){if(!a.props.peekNextMonth)break;s=!0}}return e}),le(we(a),"onMonthClick",function(e,t){a.handleDayClick(Ee(Y(a.props.day,t)),e)}),le(we(a),"onQuarterClick",function(e,t){var r;a.handleDayClick((r=T(a.props.day,t),Q(r)),e)}),le(we(a),"getMonthClassNames",function(e){var t=a.props,r=t.day,o=t.startDate,s=t.endDate,p=t.selected,i=t.minDate,c=t.maxDate;return n("react-datepicker__month-text","react-datepicker__month-".concat(e),{"react-datepicker__month--disabled":(i||c)&&Re(Y(r,e),a.props),"react-datepicker__month--selected":b(r)===e&&M(r)===M(p),"react-datepicker__month--in-range":je(o,s,e,r),"react-datepicker__month--range-start":a.isRangeStartMonth(e),"react-datepicker__month--range-end":a.isRangeEndMonth(e)})}),le(we(a),"getQuarterClassNames",function(e){var t=a.props,r=t.day,o=t.startDate,s=t.endDate,p=t.selected,i=t.minDate,c=t.maxDate;return n("react-datepicker__quarter-text","react-datepicker__quarter-".concat(e),{"react-datepicker__quarter--disabled":(i||c)&&He(T(r,e),a.props),"react-datepicker__quarter--selected":S(r)===e&&M(r)===M(p),"react-datepicker__quarter--in-range":Qe(o,s,e,r),"react-datepicker__quarter--range-start":a.isRangeStartQuarter(e),"react-datepicker__quarter--range-end":a.isRangeEndQuarter(e)})}),le(we(a),"renderMonths",function(){return[[0,1,2],[3,4,5],[6,7,8],[9,10,11]].map(function(e,r){return t.createElement("div",{className:"react-datepicker__month-wrapper",key:r},e.map(function(e,r){return t.createElement("div",{key:r,onClick:function(t){a.onMonthClick(t,e)},className:a.getMonthClassNames(e)},Fe(e,a.props.locale))}))})}),le(we(a),"renderQuarters",function(){return t.createElement("div",{className:"react-datepicker__quarter-wrapper"},[1,2,3,4].map(function(e,r){return t.createElement("div",{key:r,onClick:function(t){a.onQuarterClick(t,e)},className:a.getQuarterClassNames(e)},(n=e,o=a.props.locale,Me(T(_e(),n),"QQQ",o)));var n,o}))}),le(we(a),"getClassNames",function(){var e=a.props,t=e.selectingDate,r=e.selectsStart,o=e.selectsEnd,s=e.showMonthYearPicker,p=e.showQuarterYearPicker;return n("react-datepicker__month",{"react-datepicker__month--selecting-range":t&&(r||o)},{"react-datepicker__monthPicker":s},{"react-datepicker__quarterPicker":p})}),a}return fe(r,t.Component),de(r,[{key:"render",value:function(){var e=this.props,r=e.showMonthYearPicker,n=e.showQuarterYearPicker;return t.createElement("div",{className:this.getClassNames(),onMouseLeave:this.handleMouseLeave,role:"listbox","aria-label":"month-"+Me(this.props.day,"yyyy-MM")},r?this.renderMonths():n?this.renderQuarters():this.renderWeeks())}}]),r}(),ht=function(e){function r(){var e,n;ie(this,r);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return le(we(n=ve(this,(e=me(r)).call.apply(e,[this].concat(o)))),"state",{height:null}),le(we(n),"handleClick",function(e){(n.props.minTime||n.props.maxTime)&&Ke(e,n.props)||n.props.excludeTimes&&Ve(e,n.props.excludeTimes)||n.props.includeTimes&&!Ve(e,n.props.includeTimes)||n.props.onChange(e)}),le(we(n),"liClasses",function(e,t,r){var a=["react-datepicker__time-list-item"];return n.props.selected&&t===k(e)&&r===g(e)&&a.push("react-datepicker__time-list-item--selected"),((n.props.minTime||n.props.maxTime)&&Ke(e,n.props)||n.props.excludeTimes&&Ve(e,n.props.excludeTimes)||n.props.includeTimes&&!Ve(e,n.props.includeTimes))&&a.push("react-datepicker__time-list-item--disabled"),n.props.injectTimes&&(60*k(e)+g(e))%n.props.intervals!=0&&a.push("react-datepicker__time-list-item--injected"),a.join(" ")}),le(we(n),"renderTimes",function(){for(var e,r=[],a=n.props.format?n.props.format:"p",o=n.props.intervals,s=n.props.selected||n.props.openToDate||_e(),i=k(s),c=g(s),d=(e=_e(),R(e)),l=1440/o,u=n.props.injectTimes&&n.props.injectTimes.sort(function(e,t){return e-t}),h=0;h<l;h++){var f=p(d,h*o);if(r.push(f),u){var m=Xe(d,f,h,o,u);r=r.concat(m)}}return r.map(function(e,r){return t.createElement("li",{key:r,onClick:n.handleClick.bind(we(n),e),className:n.liClasses(e,i,c),ref:function(t){i===k(e)&&c>=g(e)&&(n.centerLi=t)}},Me(e,a,n.props.locale))})}),n}return fe(r,t.Component),de(r,[{key:"componentDidMount",value:function(){this.list.scrollTop=r.calcCenterPosition(this.props.monthRef?this.props.monthRef.clientHeight-this.header.clientHeight:this.list.clientHeight,this.centerLi),this.props.monthRef&&this.header&&this.setState({height:this.props.monthRef.clientHeight-this.header.clientHeight})}},{key:"render",value:function(){var e=this,r=this.state.height;return t.createElement("div",{className:"react-datepicker__time-container ".concat(this.props.todayButton?"react-datepicker__time-container--with-today-button":"")},t.createElement("div",{className:"react-datepicker__header react-datepicker__header--time",ref:function(t){e.header=t}},t.createElement("div",{className:"react-datepicker-time__header"},this.props.timeCaption)),t.createElement("div",{className:"react-datepicker__time"},t.createElement("div",{className:"react-datepicker__time-box"},t.createElement("ul",{className:"react-datepicker__time-list",ref:function(t){e.list=t},style:r?{height:r}:{}},this.renderTimes()))))}}],[{key:"defaultProps",get:function(){return{intervals:30,onTimeChange:function(){},todayButton:null,timeCaption:"Time"}}}]),r}();le(ht,"calcCenterPosition",function(e,t){return t.offsetTop-(e/2-t.clientHeight/2)});var ft=function(e){function r(e){var t;return ie(this,r),le(we(t=ve(this,me(r).call(this,e))),"onTimeChange",function(e){t.setState({time:e});var r=new Date;r.setHours(e.split(":")[0]),r.setMinutes(e.split(":")[1]),t.props.onChange(r)}),t.state={time:t.props.timeString},t}return fe(r,t.Component),de(r,[{key:"render",value:function(){var e=this,r=this.state.time,n=this.props.timeString;return t.createElement("div",{className:"react-datepicker__input-time-container"},t.createElement("div",{className:"react-datepicker-time__caption"},this.props.timeInputLabel),t.createElement("div",{className:"react-datepicker-time__input-container"},t.createElement("div",{className:"react-datepicker-time__input"},t.createElement("input",{type:"time",className:"react-datepicker-time__input",placeholder:"Time",name:"time-input",required:!0,value:r,onChange:function(t){e.onTimeChange(t.target.value||n)}}))))}}]),r}();function mt(e){var r=e.className,n=e.children,a=e.showPopperArrow,o=e.arrowProps,s=void 0===o?{}:o;return t.createElement("div",{className:r},a&&t.createElement("div",ue({className:"react-datepicker__triangle"},s)),n)}var yt=["react-datepicker__year-select","react-datepicker__month-select","react-datepicker__month-year-select"],wt=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=(e.className||"").split(/\s+/);return yt.some(function(e){return t.indexOf(e)>=0})},vt=function(e){function r(e){var n;return ie(this,r),le(we(n=ve(this,me(r).call(this,e))),"handleClickOutside",function(e){n.props.onClickOutside(e)}),le(we(n),"setClickOutsideRef",function(){return n.containerRef.current}),le(we(n),"handleDropdownFocus",function(e){wt(e.target)&&n.props.onDropdownFocus()}),le(we(n),"getDateInView",function(){var e=n.props,t=e.preSelection,r=e.selected,a=e.openToDate,o=ze(n.props),s=Ge(n.props),p=_e(),i=a||r||t;return i||(o&&ee(p,o)?o:s&&Z(p,s)?s:p)}),le(we(n),"increaseMonth",function(){n.setState(function(e){var t=e.date;return{date:l(t,1)}},function(){return n.handleMonthChange(n.state.date)})}),le(we(n),"decreaseMonth",function(){n.setState(function(e){var t=e.date;return{date:w(t,1)}},function(){return n.handleMonthChange(n.state.date)})}),le(we(n),"handleDayClick",function(e,t,r){return n.props.onSelect(e,t,r)}),le(we(n),"handleDayMouseEnter",function(e){n.setState({selectingDate:e}),n.props.onDayMouseEnter&&n.props.onDayMouseEnter(e)}),le(we(n),"handleMonthMouseLeave",function(){n.setState({selectingDate:null}),n.props.onMonthMouseLeave&&n.props.onMonthMouseLeave()}),le(we(n),"handleYearChange",function(e){n.props.onYearChange&&n.props.onYearChange(e)}),le(we(n),"handleMonthChange",function(e){n.props.onMonthChange&&n.props.onMonthChange(e),n.props.adjustDateOnChange&&(n.props.onSelect&&n.props.onSelect(e),n.props.setOpen&&n.props.setOpen(!0))}),le(we(n),"handleMonthYearChange",function(e){n.handleYearChange(e),n.handleMonthChange(e)}),le(we(n),"changeYear",function(e){n.setState(function(t){var r=t.date;return{date:x(r,e)}},function(){return n.handleYearChange(n.state.date)})}),le(we(n),"changeMonth",function(e){n.setState(function(t){var r=t.date;return{date:Y(r,e)}},function(){return n.handleMonthChange(n.state.date)})}),le(we(n),"changeMonthYear",function(e){n.setState(function(t){var r=t.date;return{date:x(Y(r,b(e)),M(e))}},function(){return n.handleMonthYearChange(n.state.date)})}),le(we(n),"header",function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:n.state.date,r=Pe(e,n.props.locale),a=[];return n.props.showWeekNumbers&&a.push(t.createElement("div",{key:"W",className:"react-datepicker__day-name"},n.props.weekLabel||"#")),a.concat([0,1,2,3,4,5,6].map(function(e){var a=c(r,e),o=n.formatWeekday(a,n.props.locale);return t.createElement("div",{key:e,className:"react-datepicker__day-name"},o)}))}),le(we(n),"formatWeekday",function(e,t){return n.props.formatWeekDay?function(e,t,r){return t(Me(e,"EEEE",r))}(e,n.props.formatWeekDay,t):n.props.useWeekdaysShort?function(e,t){return Me(e,"EEE",t)}(e,t):function(e,t){return Me(e,"EEEEEE",t)}(e,t)}),le(we(n),"decreaseYear",function(){n.setState(function(e){var t=e.date;return{date:v(t,1)}},function(){return n.handleYearChange(n.state.date)})}),le(we(n),"renderPreviousButton",function(){if(!n.props.renderCustomHeader){var e=n.props.showMonthYearPicker?function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.includeDates,a=v(e,1);return r&&B(r,a)>0||n&&n.every(function(e){return B(e,a)>0})||!1}(n.state.date,n.props):Ue(n.state.date,n.props);if((n.props.forceShowMonthNavigation||n.props.showDisabledMonthNavigation||!e)&&!n.props.showTimeSelectOnly){var r=["react-datepicker__navigation","react-datepicker__navigation--previous"],a=n.decreaseMonth;return(n.props.showMonthYearPicker||n.props.showQuarterYearPicker)&&(a=n.decreaseYear),e&&n.props.showDisabledMonthNavigation&&(r.push("react-datepicker__navigation--previous--disabled"),a=null),t.createElement("button",{type:"button",className:r.join(" "),onClick:a},n.props.showMonthYearPicker||n.props.showQuarterYearPicker?n.props.previousYearButtonLabel:n.props.previousMonthButtonLabel)}}}),le(we(n),"increaseYear",function(){n.setState(function(e){var t=e.date;return{date:u(t,1)}},function(){return n.handleYearChange(n.state.date)})}),le(we(n),"renderNextButton",function(){if(!n.props.renderCustomHeader){var e=n.props.showMonthYearPicker?function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.includeDates,a=u(e,1);return r&&B(a,r)>0||n&&n.every(function(e){return B(a,e)>0})||!1}(n.state.date,n.props):$e(n.state.date,n.props);if((n.props.forceShowMonthNavigation||n.props.showDisabledMonthNavigation||!e)&&!n.props.showTimeSelectOnly){var r=["react-datepicker__navigation","react-datepicker__navigation--next"];n.props.showTimeSelect&&r.push("react-datepicker__navigation--next--with-time"),n.props.todayButton&&r.push("react-datepicker__navigation--next--with-today-button");var a=n.increaseMonth;return(n.props.showMonthYearPicker||n.props.showQuarterYearPicker)&&(a=n.increaseYear),e&&n.props.showDisabledMonthNavigation&&(r.push("react-datepicker__navigation--next--disabled"),a=null),t.createElement("button",{type:"button",className:r.join(" "),onClick:a},n.props.showMonthYearPicker||n.props.showQuarterYearPicker?n.props.nextYearButtonLabel:n.props.nextMonthButtonLabel)}}}),le(we(n),"renderCurrentMonth",function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:n.state.date,r=["react-datepicker__current-month"];return n.props.showYearDropdown&&r.push("react-datepicker__current-month--hasYearDropdown"),n.props.showMonthDropdown&&r.push("react-datepicker__current-month--hasMonthDropdown"),n.props.showMonthYearDropdown&&r.push("react-datepicker__current-month--hasMonthYearDropdown"),t.createElement("div",{className:r.join(" ")},Me(e,n.props.dateFormat,n.props.locale))}),le(we(n),"renderYearDropdown",function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(n.props.showYearDropdown&&!e)return t.createElement(rt,{adjustDateOnChange:n.props.adjustDateOnChange,date:n.state.date,onSelect:n.props.onSelect,setOpen:n.props.setOpen,dropdownMode:n.props.dropdownMode,onChange:n.changeYear,minDate:n.props.minDate,maxDate:n.props.maxDate,year:M(n.state.date),scrollableYearDropdown:n.props.scrollableYearDropdown,yearDropdownItemNumber:n.props.yearDropdownItemNumber})}),le(we(n),"renderMonthDropdown",function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(n.props.showMonthDropdown&&!e)return t.createElement(at,{dropdownMode:n.props.dropdownMode,locale:n.props.locale,onChange:n.changeMonth,month:b(n.state.date),useShortMonthInDropdown:n.props.useShortMonthInDropdown})}),le(we(n),"renderMonthYearDropdown",function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(n.props.showMonthYearDropdown&&!e)return t.createElement(pt,{dropdownMode:n.props.dropdownMode,locale:n.props.locale,dateFormat:n.props.dateFormat,onChange:n.changeMonthYear,minDate:n.props.minDate,maxDate:n.props.maxDate,date:n.state.date,scrollableMonthYearDropdown:n.props.scrollableMonthYearDropdown})}),le(we(n),"renderTodayButton",function(){if(n.props.todayButton&&!n.props.showTimeSelectOnly)return t.createElement("div",{className:"react-datepicker__today-button",onClick:function(e){return n.props.onSelect(R(_e()),e)}},n.props.todayButton)}),le(we(n),"renderDefaultHeader",function(e){var r=e.monthDate,a=e.i;return t.createElement("div",{className:"react-datepicker__header"},n.renderCurrentMonth(r),t.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(n.props.dropdownMode),onFocus:n.handleDropdownFocus},n.renderMonthDropdown(0!==a),n.renderMonthYearDropdown(0!==a),n.renderYearDropdown(0!==a)),t.createElement("div",{className:"react-datepicker__day-names"},n.header(r)))}),le(we(n),"renderCustomHeader",function(e){var r=e.monthDate;if(0!==e.i)return null;var a=Ue(n.state.date,n.props),o=$e(n.state.date,n.props);return t.createElement("div",{className:"react-datepicker__header react-datepicker__header--custom",onFocus:n.props.onDropdownFocus},n.props.renderCustomHeader(function(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?he(r,!0).forEach(function(t){le(e,t,r[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):he(r).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))})}return e}({},n.state,{changeMonth:n.changeMonth,changeYear:n.changeYear,decreaseMonth:n.decreaseMonth,increaseMonth:n.increaseMonth,prevMonthButtonDisabled:a,nextMonthButtonDisabled:o})),t.createElement("div",{className:"react-datepicker__day-names"},n.header(r)))}),le(we(n),"renderYearHeader",function(){return t.createElement("div",{className:"react-datepicker__header react-datepicker-year-header"},M(n.state.date))}),le(we(n),"renderMonths",function(){if(!n.props.showTimeSelectOnly){for(var e=[],r=n.props.showPreviousMonths?n.props.monthsShown-1:0,a=w(n.state.date,r),o=0;o<n.props.monthsShown;++o){var s=o-n.props.monthSelectedIn,p=l(a,s),i="month-".concat(o);e.push(t.createElement("div",{key:i,ref:function(e){n.monthContainer=e},className:"react-datepicker__month-container"},n.props.showMonthYearPicker||n.props.showQuarterYearPicker?n.renderYearHeader({monthDate:p,i:o}):n.props.renderCustomHeader?n.renderCustomHeader({monthDate:p,i:o}):n.renderDefaultHeader({monthDate:p,i:o}),t.createElement(ut,{onChange:n.changeMonthYear,day:p,dayClassName:n.props.dayClassName,onDayClick:n.handleDayClick,onDayMouseEnter:n.handleDayMouseEnter,onMouseLeave:n.handleMonthMouseLeave,onWeekSelect:n.props.onWeekSelect,orderInDisplay:o,formatWeekNumber:n.props.formatWeekNumber,locale:n.props.locale,minDate:n.props.minDate,maxDate:n.props.maxDate,excludeDates:n.props.excludeDates,highlightDates:n.props.highlightDates,selectingDate:n.state.selectingDate,includeDates:n.props.includeDates,inline:n.props.inline,fixedHeight:n.props.fixedHeight,filterDate:n.props.filterDate,preSelection:n.props.preSelection,selected:n.props.selected,selectsStart:n.props.selectsStart,selectsEnd:n.props.selectsEnd,showWeekNumbers:n.props.showWeekNumbers,startDate:n.props.startDate,endDate:n.props.endDate,peekNextMonth:n.props.peekNextMonth,setOpen:n.props.setOpen,shouldCloseOnSelect:n.props.shouldCloseOnSelect,renderDayContents:n.props.renderDayContents,disabledKeyboardNavigation:n.props.disabledKeyboardNavigation,showMonthYearPicker:n.props.showMonthYearPicker,showQuarterYearPicker:n.props.showQuarterYearPicker})))}return e}}),le(we(n),"renderTimeSection",function(){if(n.props.showTimeSelect&&(n.state.monthContainer||n.props.showTimeSelectOnly))return t.createElement(ht,{selected:n.props.selected,openToDate:n.props.openToDate,onChange:n.props.onTimeChange,format:n.props.timeFormat,includeTimes:n.props.includeTimes,intervals:n.props.timeIntervals,minTime:n.props.minTime,maxTime:n.props.maxTime,excludeTimes:n.props.excludeTimes,timeCaption:n.props.timeCaption,todayButton:n.props.todayButton,showMonthDropdown:n.props.showMonthDropdown,showMonthYearDropdown:n.props.showMonthYearDropdown,showYearDropdown:n.props.showYearDropdown,withPortal:n.props.withPortal,monthRef:n.state.monthContainer,injectTimes:n.props.injectTimes,locale:n.props.locale})}),le(we(n),"renderInputTimeSection",function(){var e=new Date(n.props.selected),r="".concat(Ze(e.getHours()),":").concat(Ze(e.getMinutes()));if(n.props.showTimeInput)return t.createElement(ft,{timeString:r,timeInputLabel:n.props.timeInputLabel,onChange:n.props.onTimeChange})}),n.containerRef=t.createRef(),n.state={date:n.getDateInView(),selectingDate:null,monthContainer:null},n}return fe(r,t.Component),de(r,null,[{key:"defaultProps",get:function(){return{onDropdownFocus:function(){},monthsShown:1,monthSelectedIn:0,forceShowMonthNavigation:!1,timeCaption:"Time",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month"}}}]),de(r,[{key:"componentDidMount",value:function(){var e=this;this.props.showTimeSelect&&(this.assignMonthContainer=void e.setState({monthContainer:e.monthContainer}))}},{key:"componentDidUpdate",value:function(e){this.props.preSelection&&!xe(this.props.preSelection,e.preSelection)?this.setState({date:this.props.preSelection}):this.props.openToDate&&!xe(this.props.openToDate,e.openToDate)&&this.setState({date:this.props.openToDate})}},{key:"render",value:function(){var e=this.props.container||mt;return t.createElement("div",{ref:this.containerRef},t.createElement(e,{className:n("react-datepicker",this.props.className,{"react-datepicker--time-only":this.props.showTimeSelectOnly}),showPopperArrow:this.props.showPopperArrow},this.renderPreviousButton(),this.renderNextButton(),this.renderMonths(),this.renderTodayButton(),this.renderTimeSection(),this.renderInputTimeSection(),this.props.children))}}]),r}(),Dt=function(e){function r(){return ie(this,r),ve(this,me(r).apply(this,arguments))}return fe(r,t.Component),de(r,[{key:"render",value:function(){var e,r=this.props,a=r.className,o=r.wrapperClassName,s=r.hidePopper,p=r.popperComponent,i=r.popperModifiers,c=r.popperPlacement,d=r.popperProps,l=r.targetComponent;if(!s){var u=n("react-datepicker-popper",a);e=t.createElement(se.Popper,ue({modifiers:i,placement:c},d),function(e){var r=e.ref,n=e.style,a=e.placement,o=e.arrowProps;return t.createElement("div",ue({ref:r,style:n},{className:u,"data-placement":a}),t.cloneElement(p,{arrowProps:o}))})}this.props.popperContainer&&(e=t.createElement(this.props.popperContainer,{},e));var h=n("react-datepicker-wrapper",o);return t.createElement(se.Manager,{className:"react-datepicker-manager"},t.createElement(se.Reference,null,function(e){var r=e.ref;return t.createElement("div",{ref:r,className:h},l)}),e)}}],[{key:"defaultProps",get:function(){return{hidePopper:!0,popperModifiers:{preventOverflow:{enabled:!0,escapeWithReference:!0,boundariesElement:"viewport"}},popperProps:{},popperPlacement:"bottom-start"}}}]),r}(),gt="react-datepicker-ignore-onclickoutside",kt=oe(vt);var Ct="Date input not valid.",_t=function(e){function r(e){var o;return ie(this,r),le(we(o=ve(this,me(r).call(this,e))),"getPreSelection",function(){return o.props.openToDate?o.props.openToDate:o.props.selectsEnd&&o.props.startDate?o.props.startDate:o.props.selectsStart&&o.props.endDate?o.props.endDate:_e()}),le(we(o),"calcInitialState",function(){var e=o.getPreSelection(),t=ze(o.props),r=Ge(o.props),n=t&&ee(e,t)?t:r&&Z(e,r)?r:e;return{open:o.props.startOpen||!1,preventFocus:!1,preSelection:o.props.selected?o.props.selected:n,highlightDates:Je(o.props.highlightDates),focused:!1}}),le(we(o),"clearPreventFocusTimeout",function(){o.preventFocusTimeout&&clearTimeout(o.preventFocusTimeout)}),le(we(o),"setFocus",function(){o.input&&o.input.focus&&o.input.focus()}),le(we(o),"setBlur",function(){o.input&&o.input.blur&&o.input.blur(),o.cancelFocusInput()}),le(we(o),"setOpen",function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];o.setState({open:e,preSelection:e&&o.state.open?o.state.preSelection:o.calcInitialState().preSelection,lastPreSelectChange:St},function(){e||o.setState(function(e){return{focused:!!t&&e.focused}},function(){!t&&o.setBlur(),o.setState({inputValue:null})})})}),le(we(o),"inputOk",function(){return a(o.state.preSelection)}),le(we(o),"isCalendarOpen",function(){return void 0===o.props.open?o.state.open&&!o.props.disabled&&!o.props.readOnly:o.props.open}),le(we(o),"handleFocus",function(e){o.state.preventFocus||(o.props.onFocus(e),o.props.preventOpenOnFocus||o.props.readOnly||o.setOpen(!0)),o.setState({focused:!0})}),le(we(o),"cancelFocusInput",function(){clearTimeout(o.inputFocusTimeout),o.inputFocusTimeout=null}),le(we(o),"deferFocusInput",function(){o.cancelFocusInput(),o.inputFocusTimeout=setTimeout(function(){return o.setFocus()},1)}),le(we(o),"handleDropdownFocus",function(){o.cancelFocusInput()}),le(we(o),"handleBlur",function(e){!o.state.open||o.props.withPortal||o.props.showTimeInput?o.props.onBlur(e):o.deferFocusInput(),o.setState({focused:!1})}),le(we(o),"handleCalendarClickOutside",function(e){o.props.inline||o.setOpen(!1),o.props.onClickOutside(e),o.props.withPortal&&e.preventDefault()}),le(we(o),"handleChange",function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];var n=t[0];if(!o.props.onChangeRaw||(o.props.onChangeRaw.apply(we(o),t),"function"==typeof n.isDefaultPrevented&&!n.isDefaultPrevented())){o.setState({inputValue:n.target.value,lastPreSelectChange:bt});var a=be(n.target.value,o.props.dateFormat,o.props.locale,o.props.strictParsing);!a&&n.target.value||o.setSelected(a,n,!0)}}),le(we(o),"handleSelect",function(e,t,r){o.setState({preventFocus:!0},function(){return o.preventFocusTimeout=setTimeout(function(){return o.setState({preventFocus:!1})},50),o.preventFocusTimeout}),o.setSelected(e,t,void 0,r),!o.props.shouldCloseOnSelect||o.props.showTimeSelect?o.setPreSelection(e):o.props.inline||o.setOpen(!1)}),le(we(o),"setSelected",function(e,t,r,n){var a=e;if(null===a||!Be(a,o.props)){if(!Ie(o.props.selected,a)||o.props.allowSameDay){if(null!==a){if(o.props.selected){var s=o.props.selected;r&&(s=_e(a)),a=Oe(a,{hour:k(s),minute:g(s),second:D(s)})}o.props.inline||o.setState({preSelection:a}),o.props.inline&&o.props.monthsShown>1&&!o.props.inlineFocusSelectedMonth&&o.setState({monthSelectedIn:n})}o.props.onChange(a,t)}o.props.onSelect(a,t),r||o.setState({inputValue:null})}}),le(we(o),"setPreSelection",function(e){var t=void 0!==o.props.minDate,r=void 0!==o.props.maxDate,n=!0;e&&(t&&r?n=qe(e,o.props.minDate,o.props.maxDate):t?n=Z(e,o.props.minDate):r&&(n=ee(e,o.props.maxDate))),n&&o.setState({preSelection:e})}),le(we(o),"handleTimeChange",function(e){var t=Oe(o.props.selected?o.props.selected:o.getPreSelection(),{hour:k(e),minute:g(e)});o.setState({preSelection:t}),o.props.onChange(t),o.props.shouldCloseOnSelect&&o.setOpen(!1),o.props.showTimeInput&&o.setOpen(!0),o.setState({inputValue:null})}),le(we(o),"onInputClick",function(){o.props.disabled||o.props.readOnly||o.setOpen(!0),o.props.onInputClick()}),le(we(o),"onInputKeyDown",function(e){o.props.onKeyDown(e);var t=e.key;if(o.state.open||o.props.inline||o.props.preventOpenOnFocus){var r=_e(o.state.preSelection);if("Enter"===t)e.preventDefault(),o.inputOk()&&o.state.lastPreSelectChange===St?(o.handleSelect(r,e),!o.props.shouldCloseOnSelect&&o.setPreSelection(r)):o.setOpen(!1);else if("Escape"===t)e.preventDefault(),o.setOpen(!1),o.inputOk()||o.props.onInputError({code:1,msg:Ct});else if("Tab"===t)o.setOpen(!1,!0);else if(!o.props.disabledKeyboardNavigation){var n;switch(t){case"ArrowLeft":n=m(r,1);break;case"ArrowRight":n=c(r,1);break;case"ArrowUp":n=y(r,1);break;case"ArrowDown":n=d(r,1);break;case"PageUp":n=w(r,1);break;case"PageDown":n=l(r,1);break;case"Home":n=v(r,1);break;case"End":n=u(r,1)}if(!n)return void(o.props.onInputError&&o.props.onInputError({code:1,msg:Ct}));e.preventDefault(),o.setState({lastPreSelectChange:St}),o.props.adjustDateOnChange&&o.setSelected(n),o.setPreSelection(n)}}else"ArrowDown"!==t&&"ArrowUp"!==t||o.onInputClick()}),le(we(o),"onClearClick",function(e){e&&e.preventDefault&&e.preventDefault(),o.props.onChange(null,e),o.setState({inputValue:null})}),le(we(o),"clear",function(){o.onClearClick()}),le(we(o),"renderCalendar",function(){return o.props.inline||o.isCalendarOpen()?t.createElement(kt,{ref:function(e){o.calendar=e},locale:o.props.locale,adjustDateOnChange:o.props.adjustDateOnChange,setOpen:o.setOpen,shouldCloseOnSelect:o.props.shouldCloseOnSelect,dateFormat:o.props.dateFormatCalendar,useWeekdaysShort:o.props.useWeekdaysShort,formatWeekDay:o.props.formatWeekDay,dropdownMode:o.props.dropdownMode,selected:o.props.selected,preSelection:o.state.preSelection,onSelect:o.handleSelect,onWeekSelect:o.props.onWeekSelect,openToDate:o.props.openToDate,minDate:o.props.minDate,maxDate:o.props.maxDate,selectsStart:o.props.selectsStart,selectsEnd:o.props.selectsEnd,startDate:o.props.startDate,endDate:o.props.endDate,excludeDates:o.props.excludeDates,filterDate:o.props.filterDate,onClickOutside:o.handleCalendarClickOutside,formatWeekNumber:o.props.formatWeekNumber,highlightDates:o.state.highlightDates,includeDates:o.props.includeDates,includeTimes:o.props.includeTimes,injectTimes:o.props.injectTimes,inline:o.props.inline,peekNextMonth:o.props.peekNextMonth,showMonthDropdown:o.props.showMonthDropdown,showPreviousMonths:o.props.showPreviousMonths,useShortMonthInDropdown:o.props.useShortMonthInDropdown,showMonthYearDropdown:o.props.showMonthYearDropdown,showWeekNumbers:o.props.showWeekNumbers,showYearDropdown:o.props.showYearDropdown,withPortal:o.props.withPortal,forceShowMonthNavigation:o.props.forceShowMonthNavigation,showDisabledMonthNavigation:o.props.showDisabledMonthNavigation,scrollableYearDropdown:o.props.scrollableYearDropdown,scrollableMonthYearDropdown:o.props.scrollableMonthYearDropdown,todayButton:o.props.todayButton,weekLabel:o.props.weekLabel,outsideClickIgnoreClass:gt,fixedHeight:o.props.fixedHeight,monthsShown:o.props.monthsShown,monthSelectedIn:o.state.monthSelectedIn,onDropdownFocus:o.handleDropdownFocus,onMonthChange:o.props.onMonthChange,onYearChange:o.props.onYearChange,dayClassName:o.props.dayClassName,showTimeSelect:o.props.showTimeSelect,showTimeSelectOnly:o.props.showTimeSelectOnly,onTimeChange:o.handleTimeChange,timeFormat:o.props.timeFormat,timeIntervals:o.props.timeIntervals,minTime:o.props.minTime,maxTime:o.props.maxTime,excludeTimes:o.props.excludeTimes,timeCaption:o.props.timeCaption,className:o.props.calendarClassName,container:o.props.calendarContainer,yearDropdownItemNumber:o.props.yearDropdownItemNumber,previousMonthButtonLabel:o.props.previousMonthButtonLabel,nextMonthButtonLabel:o.props.nextMonthButtonLabel,previousYearButtonLabel:o.props.previousYearButtonLabel,nextYearButtonLabel:o.props.nextYearButtonLabel,timeInputLabel:o.props.timeInputLabel,disabledKeyboardNavigation:o.props.disabledKeyboardNavigation,renderCustomHeader:o.props.renderCustomHeader,popperProps:o.props.popperProps,renderDayContents:o.props.renderDayContents,onDayMouseEnter:o.props.onDayMouseEnter,onMonthMouseLeave:o.props.onMonthMouseLeave,showTimeInput:o.props.showTimeInput,showMonthYearPicker:o.props.showMonthYearPicker,showQuarterYearPicker:o.props.showQuarterYearPicker,showPopperArrow:o.props.showPopperArrow},o.props.children):null}),le(we(o),"renderDateInput",function(){var e,r,a,s,p,i=n(o.props.className,le({},gt,o.state.open)),c=o.props.customInput||t.createElement("input",{type:"text"}),d=o.props.customInputRef||"ref",l="string"==typeof o.props.value?o.props.value:"string"==typeof o.state.inputValue?o.state.inputValue:(r=o.props.selected,a=o.props,s=a.dateFormat,p=a.locale,r&&Me(r,Array.isArray(s)?s[0]:s,p)||"");return t.cloneElement(c,(le(e={},d,function(e){o.input=e}),le(e,"value",l),le(e,"onBlur",o.handleBlur),le(e,"onChange",o.handleChange),le(e,"onClick",o.onInputClick),le(e,"onFocus",o.handleFocus),le(e,"onKeyDown",o.onInputKeyDown),le(e,"id",o.props.id),le(e,"name",o.props.name),le(e,"autoFocus",o.props.autoFocus),le(e,"placeholder",o.props.placeholderText),le(e,"disabled",o.props.disabled),le(e,"autoComplete",o.props.autoComplete),le(e,"className",n(c.props.className,i)),le(e,"title",o.props.title),le(e,"readOnly",o.props.readOnly),le(e,"required",o.props.required),le(e,"tabIndex",o.props.tabIndex),le(e,"aria-labelledby",o.props.ariaLabelledBy),e))}),le(we(o),"renderClearButton",function(){return o.props.isClearable&&null!=o.props.selected?t.createElement("button",{type:"button",className:"react-datepicker__close-icon","aria-label":"Close",onClick:o.onClearClick,title:o.props.clearButtonTitle,tabIndex:-1}):null}),o.state=o.calcInitialState(),o}return fe(r,t.Component),de(r,null,[{key:"defaultProps",get:function(){return{allowSameDay:!1,dateFormat:"MM/dd/yyyy",dateFormatCalendar:"LLLL yyyy",onChange:function(){},disabled:!1,disabledKeyboardNavigation:!1,dropdownMode:"scroll",onFocus:function(){},onBlur:function(){},onKeyDown:function(){},onInputClick:function(){},onSelect:function(){},onClickOutside:function(){},onMonthChange:function(){},onCalendarOpen:function(){},onCalendarClose:function(){},preventOpenOnFocus:!1,onYearChange:function(){},onInputError:function(){},monthsShown:1,readOnly:!1,withPortal:!1,shouldCloseOnSelect:!0,showTimeSelect:!1,showTimeInput:!1,showPreviousMonths:!1,showMonthYearPicker:!1,showQuarterYearPicker:!1,strictParsing:!1,timeIntervals:30,timeCaption:"Time",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",timeInputLabel:"Time",renderDayContents:function(e){return e},inlineFocusSelectedMonth:!1,showPopperArrow:!0}}}]),de(r,[{key:"componentDidUpdate",value:function(e,t){var r,n;e.inline&&(r=e.selected,n=this.props.selected,r&&n?b(r)!==b(n)||M(r)!==M(n):r!==n)&&this.setPreSelection(this.props.selected),void 0!==this.state.monthSelectedIn&&e.monthsShown!==this.props.monthsShown&&this.setState({monthSelectedIn:0}),e.highlightDates!==this.props.highlightDates&&this.setState({highlightDates:Je(this.props.highlightDates)}),t.focused||Ie(e.selected,this.props.selected)||this.setState({inputValue:null}),t.open!==this.state.open&&(!1===t.open&&!0===this.state.open&&this.props.onCalendarOpen(),!0===t.open&&!1===this.state.open&&this.props.onCalendarClose())}},{key:"componentWillUnmount",value:function(){this.clearPreventFocusTimeout()}},{key:"render",value:function(){var e=this.renderCalendar();return this.props.inline&&!this.props.withPortal?e:this.props.withPortal?t.createElement("div",null,this.props.inline?null:t.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),this.state.open||this.props.inline?t.createElement("div",{className:"react-datepicker__portal"},e):null):t.createElement(Dt,{className:this.props.popperClassName,wrapperClassName:this.props.wrapperClassName,hidePopper:!this.isCalendarOpen(),popperModifiers:this.props.popperModifiers,targetComponent:t.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),popperContainer:this.props.popperContainer,popperComponent:e,popperPlacement:this.props.popperPlacement,popperProps:this.props.popperProps})}}]),r}(),bt="input",St="navigate";e.CalendarContainer=mt,e.default=_t,e.getDefaultLocale=Le,e.registerLocale=function(e,t){var r="undefined"!=typeof window?window:global;r.__localeData__||(r.__localeData__={}),r.__localeData__[e]=t},e.setDefaultLocale=function(e){("undefined"!=typeof window?window:global).__localeId__=e},Object.defineProperty(e,"__esModule",{value:!0})});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 901 */
[2243, 1991],
/* 902 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setRef = exports.shallowEqual = exports.safeInvoke = exports.unwrapArray = void 0;
	
	/**
	 * Takes an argument and if it's an array, returns the first item in the array,
	 * otherwise returns the argument. Used for Preact compatibility.
	 */
	var unwrapArray = function unwrapArray(arg) {
	  return Array.isArray(arg) ? arg[0] : arg;
	};
	/**
	 * Takes a maybe-undefined function and arbitrary args and invokes the function
	 * only if it is defined.
	 */
	
	
	exports.unwrapArray = unwrapArray;
	
	var safeInvoke = function safeInvoke(fn) {
	  if (typeof fn === "function") {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return fn.apply(void 0, args);
	  }
	};
	/**
	 * Does a shallow equality check of two objects by comparing the reference
	 * equality of each value.
	 */
	
	
	exports.safeInvoke = safeInvoke;
	
	var shallowEqual = function shallowEqual(objA, objB) {
	  var aKeys = Object.keys(objA);
	  var bKeys = Object.keys(objB);
	
	  if (bKeys.length !== aKeys.length) {
	    return false;
	  }
	
	  for (var i = 0; i < bKeys.length; i++) {
	    var key = aKeys[i];
	
	    if (objA[key] !== objB[key]) {
	      return false;
	    }
	  }
	
	  return true;
	};
	/**
	 * Sets a ref using either a ref callback or a ref object
	 */
	
	
	exports.shallowEqual = shallowEqual;
	
	var setRef = function setRef(ref, node) {
	  // if its a function call it
	  if (typeof ref === "function") {
	    return safeInvoke(ref, node);
	  } // otherwise we should treat it as a ref object
	  else if (ref != null) {
	      ref.current = node;
	    }
	};
	
	exports.setRef = setRef;

/***/ },
/* 903 */
194,
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(905));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _has2 = _interopRequireDefault(__webpack_require__(1890));
	
	var _map2 = _interopRequireDefault(__webpack_require__(859));
	
	var _get2 = _interopRequireDefault(__webpack_require__(310));
	
	var _pick2 = _interopRequireDefault(__webpack_require__(1898));
	
	var _filter2 = _interopRequireDefault(__webpack_require__(858));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(311));
	
	var _Col = _interopRequireDefault(__webpack_require__(504));
	
	var _FormControl = _interopRequireDefault(__webpack_require__(506));
	
	var _InputGroup = _interopRequireDefault(__webpack_require__(876));
	
	var _FormGroup = _interopRequireDefault(__webpack_require__(873));
	
	var _ControlLabel = _interopRequireDefault(__webpack_require__(870));
	
	var _HelpBlock = _interopRequireDefault(__webpack_require__(875));
	
	var _MenuItem = _interopRequireDefault(__webpack_require__(878));
	
	var _DropdownButton = _interopRequireDefault(__webpack_require__(871));
	
	var _reactFinalForm = __webpack_require__(2006);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var Wrap =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(Wrap, _React$Component);
	
	  function Wrap() {
	    var _this;
	
	    _classCallCheck(this, Wrap);
	
	    _this = _possibleConstructorReturn(this, (Wrap.__proto__ || Object.getPrototypeOf(Wrap)).call(this));
	    _this.input = {};
	    _this.custom = {};
	    _this.dropdownButton = _this.dropdownButton.bind(_assertThisInitialized(_this));
	    _this.dropDown = _this.dropDown.bind(_assertThisInitialized(_this));
	    _this.renderField = _this.renderField.bind(_assertThisInitialized(_this));
	    _this.options = _this.options.bind(_assertThisInitialized(_this));
	    return _this;
	  }
	
	  _createClass(Wrap, [{
	    key: "options",
	    value: function options(props) {
	      if (props.type === 'select') {
	        return this.props.children;
	      }
	    }
	  }, {
	    key: "dropDown",
	    value: function dropDown(props) {
	      var _this2 = this;
	
	      var menuItem = [];
	      var dropDownTitle = (0, _get2.default)(props.field, 'title', null);
	      (0, _map2.default)(props.field.children, function (item, key) {
	        var select = function select() {
	          _this2.input.onBlur();
	
	          _this2.input.onChange(item.props.value);
	        };
	
	        if (item.props.selected && !props.input.value) {
	          dropDownTitle = item.props.children;
	          menuItem.push(_react.default.createElement(_MenuItem.default, {
	            key: key,
	            onSelect: select
	          }, item.props.children));
	        } else {
	          if (String(_this2.input.value) === String(item.props.value)) {
	            dropDownTitle = item.props.children;
	          }
	
	          menuItem.push(_react.default.createElement(_MenuItem.default, {
	            key: key,
	            onSelect: select
	          }, item.props.children));
	        }
	
	        if (item.props.selected) {
	          menuItem.push(_react.default.createElement(_MenuItem.default, {
	            key: key + '_div',
	            divider: true
	          }));
	        }
	      });
	      return {
	        dropDownTitle: dropDownTitle,
	        menuItem: menuItem
	      };
	    }
	  }, {
	    key: "dropdownButton",
	    value: function dropdownButton(props, isStatic) {
	      var _dropDown = this.dropDown(props),
	          dropDownTitle = _dropDown.dropDownTitle,
	          menuItem = _dropDown.menuItem;
	
	      var size = (0, _get2.default)(props.field, 'bsSize', this.props.size);
	
	      var thisSize = function thisSize() {
	        if (size !== 'medium') {
	          return {
	            bsSize: size
	          };
	        }
	      };
	
	      var disabled = false;
	
	      if (props.field && props.field.disabled && (0, _isFunction2.default)(props.field.disabled)) {
	        disabled = this.context.checkCondition(props.field.disabled());
	      }
	
	      if (isStatic === true || disabled === true) {
	        return _react.default.createElement(_FormControl.default.Static, null, dropDownTitle || (0, _get2.default)(props.field, 'placeholder'));
	      }
	
	      return _react.default.createElement(_DropdownButton.default, _extends({
	        key: this.input.name,
	        onClick: function onClick(event) {
	          event.preventDefault();
	        }
	      }, thisSize(), {
	        title: dropDownTitle || (0, _get2.default)(props.field, 'placeholder'),
	        id: 'input-dropdown-addon' + this.input.name
	      }), menuItem);
	    }
	  }, {
	    key: "renderField",
	    value: function renderField(props) {
	      var _this3 = this;
	
	      var input = props.input,
	          help = props.help,
	          _props$meta = props.meta,
	          touched = _props$meta.touched,
	          error = _props$meta.error,
	          submitError = _props$meta.submitError,
	          submitFailed = _props$meta.submitFailed,
	          valid = _props$meta.valid,
	          custom = _objectWithoutProperties(props, ["input", "help", "meta"]);
	
	      this.input = input;
	      var size = (0, _get2.default)(props.field, 'bsSize', this.props.size);
	
	      if (props.field && props.field.hidden && (0, _isFunction2.default)(props.field.hidden)) {
	        if (this.context.checkCondition(props.field.hidden, (0, _get2.default)(props, 'parent')) === true) {
	          return null;
	        }
	      } else if (props.field && props.field.show && (0, _isFunction2.default)(props.field.show)) {
	        if (this.context.checkCondition(props.field.show, (0, _get2.default)(props, 'parent')) !== true) {
	          return null;
	        }
	      }
	
	      var thisSize = function thisSize() {
	        if (size !== 'medium') {
	          return {
	            bsSize: size
	          };
	        }
	      };
	
	      var labelSize = function labelSize() {
	        if ((0, _has2.default)(props.field, 'labelSize')) {
	          return props.field.labelSize;
	        }
	      };
	
	      var fieldSize = function fieldSize() {
	        if ((0, _has2.default)(props.field, 'fieldSize')) {
	          return props.field.fieldSize;
	        }
	      };
	
	      var add = (0, _pick2.default)(custom, ['type', 'placeholder', 'rows', 'cols']);
	
	      if (add.type === 'select') {
	        add.componentClass = 'select';
	      }
	
	      if (custom.field.disabled && (0, _isFunction2.default)(custom.field.disabled)) {
	        add.disabled = this.context.checkCondition(custom.field.disabled, (0, _get2.default)(props, 'parent'));
	      }
	
	      if (props.field.placeholder) {
	        add.placeholder = props.field.placeholder;
	      }
	
	      if (props.field.cols) {
	        add.cols = props.field.cols;
	      }
	
	      if (props.field.rows) {
	        add.rows = props.field.rows;
	      }
	
	      var component = function component() {
	        // Render custom component
	        if (_this3.props.component) {
	          var Comp = _this3.props.component;
	          return _react.default.createElement(Comp, props);
	        }
	
	        if (_this3.context.isStatic === true || (0, _get2.default)(props.field, 'static', false) === true) {
	          var value = function value() {
	            if (props.field.type === 'select') {
	              return (0, _map2.default)((0, _filter2.default)(props.field.options, {
	                value: _this3.input.value
	              }), function (item, key) {
	                return _react.default.createElement("span", {
	                  key: key
	                }, item.desc);
	              });
	            }
	
	            return _this3.input.value;
	          };
	
	          switch (props.type) {
	            case 'dropdown':
	              return _this3.dropdownButton(props, true);
	
	            default:
	              {
	                return _react.default.createElement(_FormControl.default.Static, null, value());
	              }
	          }
	        }
	
	        switch (props.field.type) {
	          case 'dropdown':
	            return _this3.dropdownButton(props, false);
	
	          case 'textarea':
	            return _react.default.createElement(_FormControl.default, _extends({
	              componentClass: "textarea"
	            }, input, add));
	
	          case 'select':
	            return _react.default.createElement(_FormControl.default, _extends({
	              componentClass: "textarea"
	            }, input, add), _this3.options(props));
	
	          default:
	            return _react.default.createElement(_FormControl.default, _extends({}, input, add));
	        }
	      };
	
	      var validationState = function validationState() {
	        if (touched && error || submitFailed && submitError) {
	          return 'error';
	        }
	
	        if (touched && valid) {
	          return 'success';
	        }
	      };
	
	      var buttonBefore = function buttonBefore() {
	        if ((0, _has2.default)(props.field, 'buttonBefore')) {
	          return _react.default.createElement(_InputGroup.default.Button, null, props.field.buttonBefore());
	        }
	      };
	
	      var buttonAfter = function buttonAfter() {
	        if ((0, _has2.default)(props.field, 'buttonAfter')) {
	          return _react.default.createElement(_InputGroup.default.Button, null, props.field.buttonAfter());
	        }
	      };
	
	      var addonBefore = function addonBefore() {
	        if ((0, _has2.default)(props.field, 'addonBefore')) {
	          return _react.default.createElement(_InputGroup.default.Addon, null, (0, _get2.default)(props.field, 'addonBefore'));
	        }
	      };
	
	      var addonAfter = function addonAfter() {
	        if ((0, _has2.default)(props.field, 'addonAfter')) {
	          return _react.default.createElement(_InputGroup.default.Addon, null, (0, _get2.default)(props.field, 'addonAfter'));
	        }
	      };
	
	      var getField = function getField() {
	        if ((0, _has2.default)(props.field, 'addonBefore') || (0, _has2.default)(props.field, 'addonAfter') || (0, _has2.default)(props.field, 'buttonBefore') || (0, _has2.default)(props.field, 'buttonAfter')) {
	          return _react.default.createElement(_InputGroup.default, null, buttonBefore(), addonBefore(), component(), addonAfter(), buttonAfter());
	        }
	
	        return component();
	      };
	
	      if (props.type === 'dropdown' && !(0, _has2.default)(props.field, 'label')) {
	        return getField();
	      }
	
	      var getLabel = function getLabel() {
	        if (props.field.label) {
	          return _react.default.createElement(_Col.default, _extends({
	            componentClass: _ControlLabel.default
	          }, labelSize()), props.field.label);
	        }
	      };
	
	      var rendered = _react.default.createElement(_FormGroup.default, _extends({}, thisSize(), {
	        validationState: validationState()
	      }), getLabel(), _react.default.createElement(_Col.default, fieldSize(), getField(), (touched && error || submitFailed && submitError) && _react.default.createElement(_FormControl.default.Feedback, null), props.field.help && (!touched || !submitError && !error) && _react.default.createElement(_HelpBlock.default, null, props.field.help), (touched && error || submitFailed && submitError) && _react.default.createElement(_HelpBlock.default, null, submitError || error)));
	
	      if (this.context.debug) {
	        return _react.default.createElement("div", {
	          style: {
	            position: 'relative'
	          }
	        }, rendered);
	      }
	
	      return rendered;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          name = _props.name,
	          rest = _objectWithoutProperties(_props, ["name"]);
	
	      return _react.default.createElement(_reactFinalForm.Field, {
	        component: this.renderField,
	        type: this.props.type,
	        name: name,
	        field: rest
	      });
	    }
	  }]);
	
	  return Wrap;
	}(_react.default.Component);
	
	Wrap.propTypes = {
	  'field': _propTypes.default.object,
	  'size': _propTypes.default.string,
	  'addField': _propTypes.default.func,
	  'static': _propTypes.default.bool,
	  'name': _propTypes.default.string.isRequired,
	  type: _propTypes.default.string.isRequired,
	  component: _propTypes.default.func,
	  children: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.array, _propTypes.default.bool])
	};
	Wrap.contextTypes = {
	  debug: _propTypes.default.bool.isRequired,
	  checkCondition: _propTypes.default.func.isRequired,
	  isStatic: _propTypes.default.bool.isRequired
	};
	Wrap.defaultProps = {};
	var _default = Wrap;
	exports.default = _default;

/***/ },
/* 905 */
[2243, 2004],
/* 906 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ },
/* 907 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
	  gentle: { stiffness: 120, damping: 14 },
	  wobbly: { stiffness: 180, damping: 12 },
	  stiff: { stiffness: 210, damping: 20 }
	};
	module.exports = exports["default"];

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(156);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(315);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _getContainer = __webpack_require__(324);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(193);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _LegacyPortal = __webpack_require__(2032);
	
	var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setContainer = function () {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
	
	      _this._portalContainerNode = (0, _getContainer2.default)(props.container, (0, _ownerDocument2.default)(_this).body);
	    }, _this.getMountNode = function () {
	      return _this._portalContainerNode;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Portal.prototype.componentDidMount = function componentDidMount() {
	    this.setContainer();
	    this.forceUpdate(this.props.onRendered);
	  };
	
	  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.container !== this.props.container) {
	      this.setContainer(nextProps);
	    }
	  };
	
	  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._portalContainerNode = null;
	  };
	
	  Portal.prototype.render = function render() {
	    return this.props.children && this._portalContainerNode ? _reactDom2.default.createPortal(this.props.children, this._portalContainerNode) : null;
	  };
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.displayName = 'Portal';
	Portal.propTypes = {
	  /**
	   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	   * appended to it.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  onRendered: _propTypes2.default.func
	};
	exports.default = _reactDom2.default.createPortal ? Portal : _LegacyPortal2.default;
	module.exports = exports['default'];

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _contains = __webpack_require__(188);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _propTypes = __webpack_require__(156);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _addEventListener = __webpack_require__(910);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _ownerDocument = __webpack_require__(193);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var escapeKeyCode = 27;
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	/**
	 * The `<RootCloseWrapper/>` component registers your callback on the document
	 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
	 * style behavior where your callback is triggered when the user tries to
	 * interact with the rest of the document or hits the `esc` key.
	 */
	
	var RootCloseWrapper = function (_React$Component) {
	  _inherits(RootCloseWrapper, _React$Component);
	
	  function RootCloseWrapper(props, context) {
	    _classCallCheck(this, RootCloseWrapper);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.addEventListeners = function () {
	      var event = _this.props.event;
	
	      var doc = (0, _ownerDocument2.default)(_this);
	
	      // Use capture for this listener so it fires before React's listener, to
	      // avoid false positives in the contains() check below if the target DOM
	      // element is removed in the React mouse callback.
	      _this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, _this.handleMouseCapture, true);
	
	      _this.documentMouseListener = (0, _addEventListener2.default)(doc, event, _this.handleMouse);
	
	      _this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this.handleKeyUp);
	    };
	
	    _this.removeEventListeners = function () {
	      if (_this.documentMouseCaptureListener) {
	        _this.documentMouseCaptureListener.remove();
	      }
	
	      if (_this.documentMouseListener) {
	        _this.documentMouseListener.remove();
	      }
	
	      if (_this.documentKeyupListener) {
	        _this.documentKeyupListener.remove();
	      }
	    };
	
	    _this.handleMouseCapture = function (e) {
	      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
	    };
	
	    _this.handleMouse = function (e) {
	      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.handleKeyUp = function (e) {
	      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.preventMouseRootClose = false;
	    return _this;
	  }
	
	  RootCloseWrapper.prototype.componentDidMount = function componentDidMount() {
	    if (!this.props.disabled) {
	      this.addEventListeners();
	    }
	  };
	
	  RootCloseWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (!this.props.disabled && prevProps.disabled) {
	      this.addEventListeners();
	    } else if (this.props.disabled && !prevProps.disabled) {
	      this.removeEventListeners();
	    }
	  };
	
	  RootCloseWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (!this.props.disabled) {
	      this.removeEventListeners();
	    }
	  };
	
	  RootCloseWrapper.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return RootCloseWrapper;
	}(_react2.default.Component);
	
	RootCloseWrapper.displayName = 'RootCloseWrapper';
	
	RootCloseWrapper.propTypes = {
	  /**
	   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
	   */
	  onRootClose: _propTypes2.default.func,
	  /**
	   * Children to render.
	   */
	  children: _propTypes2.default.element,
	  /**
	   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Choose which document mouse event to bind to.
	   */
	  event: _propTypes2.default.oneOf(['click', 'mousedown'])
	};
	
	RootCloseWrapper.defaultProps = {
	  event: 'click'
	};
	
	exports.default = RootCloseWrapper;
	module.exports = exports['default'];

/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (node, event, handler, capture) {
	  (0, _on2.default)(node, event, handler, capture);
	
	  return {
	    remove: function remove() {
	      (0, _off2.default)(node, event, handler, capture);
	    }
	  };
	};
	
	var _on = __webpack_require__(486);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(485);
	
	var _off2 = _interopRequireDefault(_off);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isOverflowing;
	
	var _isWindow = __webpack_require__(302);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	var _ownerDocument = __webpack_require__(187);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	}
	
	function bodyIsOverflowing(node) {
	  var doc = (0, _ownerDocument2.default)(node);
	  var win = (0, _isWindow2.default)(doc);
	  var fullWidth = win.innerWidth;
	
	  // Support: ie8, no innerWidth
	  if (!fullWidth) {
	    var documentElementRect = doc.documentElement.getBoundingClientRect();
	    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	  }
	
	  return doc.body.clientWidth < fullWidth;
	}
	
	function isOverflowing(container) {
	  var win = (0, _isWindow2.default)(container);
	
	  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
	}
	module.exports = exports['default'];

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = connectAdvanced;
	
	var _hoistNonReactStatics = __webpack_require__(2053);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(68);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _Subscription = __webpack_require__(2051);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _PropTypes = __webpack_require__(914);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	function noop() {}
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return;
	
	        // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription2.default(this.store, parentSub, this.onStateChange.bind(this));
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      Connect.prototype.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	          this.initSubscription();
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = __webpack_require__(915);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    // allow detectFactoryAndVerify to get ownProps
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = undefined;
	
	var _propTypes = __webpack_require__(917);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscriptionShape = exports.subscriptionShape = _propTypes2.default.shape({
	  trySubscribe: _propTypes2.default.func.isRequired,
	  tryUnsubscribe: _propTypes2.default.func.isRequired,
	  notifyNestedSubs: _propTypes2.default.func.isRequired,
	  isSubscribed: _propTypes2.default.func.isRequired
	});
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = __webpack_require__(2062);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(517);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject2.default)(value)) {
	    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}

/***/ },
/* 916 */
[2246, 2060],
/* 917 */
[2243, 2063],
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(326);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(68);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isModifiedEvent = function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	};
	
	/**
	 * The public API for rendering a history-aware <a>.
	 */
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Link);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) _this.props.onClick(event);
	
	      if (!event.defaultPrevented && // onClick prevented default
	      event.button === 0 && // ignore right clicks
	      !_this.props.target && // let browser handle "target=_blank" etc.
	      !isModifiedEvent(event) // ignore clicks with modifier keys
	      ) {
	          event.preventDefault();
	
	          var history = _this.context.router.history;
	          var _this$props = _this.props,
	              replace = _this$props.replace,
	              to = _this$props.to;
	
	
	          if (replace) {
	            history.replace(to);
	          } else {
	            history.push(to);
	          }
	        }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Link.prototype.render = function render() {
	    var _props = this.props,
	        replace = _props.replace,
	        to = _props.to,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars
	
	    (0, _invariant2.default)(this.context.router, 'You should not use <Link> outside a <Router>');
	
	    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
	  };
	
	  return Link;
	}(_react2.default.Component);
	
	Link.propTypes = {
	  onClick: _propTypes2.default.func,
	  target: _propTypes2.default.string,
	  replace: _propTypes2.default.bool,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
	  innerRef: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	};
	Link.defaultProps = {
	  replace: false
	};
	Link.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired,
	      createHref: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Link;

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Route = __webpack_require__(924);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Route2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 920 */
[2411, 2074],
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(format, subs) {
	    var index = 0;
	    var message =
	      'Warning: ' +
	      (subs.length > 0
	        ? format.replace(/%s/g, function() {
	            return subs[index++];
	          })
	        : format);
	
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	
	    try {
	      // --- Welcome to debugging history ---
	      // This error was thrown as a convenience so that you can use the
	      // stack trace to find the callsite that triggered this warning.
	      throw new Error(message);
	    } catch (e) {}
	  };
	}
	
	module.exports = function(member) {
	  printWarning(
	    'Please use `require("history").%s` instead of `require("history/%s")`. ' +
	      'Support for the latter will be removed in the next major release.',
	    [member, member]
	  );
	};


/***/ },
/* 922 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ },
/* 923 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  locationBeforeTransitions: null
	};
	
	/**
	 * This reducer will update the state with the most recent location history
	 * has transitioned to. This may not be in sync with the router, particularly
	 * if you have asynchronously-loaded routes, so reading from and relying on
	 * this state is discouraged.
	 */
	function routerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      type = _ref.type,
	      payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { locationBeforeTransitions: payload });
	  }
	
	  return state;
	}

/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(194);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(68);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(126);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _matchPath = __webpack_require__(521);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEmptyChildren = function isEmptyChildren(children) {
	  return _react2.default.Children.count(children) === 0;
	};
	
	/**
	 * The public API for matching a single path and rendering.
	 */
	
	var Route = function (_React$Component) {
	  _inherits(Route, _React$Component);
	
	  function Route() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Route);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props, _this.context.router)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Route.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        route: {
	          location: this.props.location || this.context.router.route.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Route.prototype.computeMatch = function computeMatch(_ref, router) {
	    var computedMatch = _ref.computedMatch,
	        location = _ref.location,
	        path = _ref.path,
	        strict = _ref.strict,
	        exact = _ref.exact,
	        sensitive = _ref.sensitive;
	
	    if (computedMatch) return computedMatch; // <Switch> already computed the match for us
	
	    (0, _invariant2.default)(router, "You should not use <Route> or withRouter() outside a <Router>");
	
	    var route = router.route;
	
	    var pathname = (location || route.location).pathname;
	
	    return (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
	  };
	
	  Route.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");
	
	    (0, _warning2.default)(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");
	
	    (0, _warning2.default)(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
	  };
	
	  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	
	    this.setState({
	      match: this.computeMatch(nextProps, nextContext.router)
	    });
	  };
	
	  Route.prototype.render = function render() {
	    var match = this.state.match;
	    var _props = this.props,
	        children = _props.children,
	        component = _props.component,
	        render = _props.render;
	    var _context$router = this.context.router,
	        history = _context$router.history,
	        route = _context$router.route,
	        staticContext = _context$router.staticContext;
	
	    var location = this.props.location || route.location;
	    var props = { match: match, location: location, history: history, staticContext: staticContext };
	
	    if (component) return match ? _react2.default.createElement(component, props) : null;
	
	    if (render) return match ? render(props) : null;
	
	    if (typeof children === "function") return children(props);
	
	    if (children && !isEmptyChildren(children)) return _react2.default.Children.only(children);
	
	    return null;
	  };
	
	  return Route;
	}(_react2.default.Component);
	
	Route.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  path: _propTypes2.default.string,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  sensitive: _propTypes2.default.bool,
	  component: _propTypes2.default.func,
	  render: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	  location: _propTypes2.default.object
	};
	Route.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.object.isRequired,
	    route: _propTypes2.default.object.isRequired,
	    staticContext: _propTypes2.default.object
	  })
	};
	Route.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Route;

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(2091)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(157);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Select = __webpack_require__(327);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _stripDiacritics = __webpack_require__(932);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
		autoload: _propTypes2.default.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
		cache: _propTypes2.default.any, // object to use to cache results; set to null/false to disable caching
		children: _propTypes2.default.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
		ignoreAccents: _propTypes2.default.bool, // strip diacritics when filtering; defaults to true
		ignoreCase: _propTypes2.default.bool, // perform case-insensitive filtering; defaults to true
		loadOptions: _propTypes2.default.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
		loadingPlaceholder: _propTypes2.default.oneOfType([// replaces the placeholder while options are loading
		_propTypes2.default.string, _propTypes2.default.node]),
		multi: _propTypes2.default.bool, // multi-value input
		noResultsText: _propTypes2.default.oneOfType([// field noResultsText, displayed when no options come back from the server
		_propTypes2.default.string, _propTypes2.default.node]),
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onInputChange: _propTypes2.default.func, // optional for keeping track of what is being typed
		options: _propTypes2.default.array.isRequired, // array of options
		placeholder: _propTypes2.default.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
		_propTypes2.default.string, _propTypes2.default.node]),
		searchPromptText: _propTypes2.default.oneOfType([// label to prompt for search input
		_propTypes2.default.string, _propTypes2.default.node]),
		value: _propTypes2.default.any // initial field value
	};
	
	var defaultCache = {};
	
	var defaultProps = {
		autoload: true,
		cache: defaultCache,
		children: defaultChildren,
		ignoreAccents: true,
		ignoreCase: true,
		loadingPlaceholder: 'Loading...',
		options: [],
		searchPromptText: 'Type to search'
	};
	
	var Async = function (_Component) {
		_inherits(Async, _Component);
	
		function Async(props, context) {
			_classCallCheck(this, Async);
	
			var _this = _possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));
	
			_this._cache = props.cache === defaultCache ? {} : props.cache;
	
			_this.state = {
				inputValue: '',
				isLoading: false,
				options: props.options
			};
	
			_this.onInputChange = _this.onInputChange.bind(_this);
			return _this;
		}
	
		_createClass(Async, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var autoload = this.props.autoload;
	
	
				if (autoload) {
					this.loadOptions('');
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.options !== this.props.options) {
					this.setState({
						options: nextProps.options
					});
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this._callback = null;
			}
		}, {
			key: 'loadOptions',
			value: function loadOptions(inputValue) {
				var _this2 = this;
	
				var loadOptions = this.props.loadOptions;
	
				var cache = this._cache;
	
				if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
					this._callback = null;
	
					this.setState({
						isLoading: false,
						options: cache[inputValue]
					});
	
					return;
				}
	
				var callback = function callback(error, data) {
					var options = data && data.options || [];
	
					if (cache) {
						cache[inputValue] = options;
					}
	
					if (callback === _this2._callback) {
						_this2._callback = null;
	
						_this2.setState({
							isLoading: false,
							options: options
						});
					}
				};
	
				// Ignore all but the most recent request
				this._callback = callback;
	
				var promise = loadOptions(inputValue, callback);
				if (promise) {
					promise.then(function (data) {
						return callback(null, data);
					}, function (error) {
						return callback(error);
					});
				}
	
				if (this._callback && !this.state.isLoading) {
					this.setState({
						isLoading: true
					});
				}
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(inputValue) {
				var _props = this.props,
				    ignoreAccents = _props.ignoreAccents,
				    ignoreCase = _props.ignoreCase,
				    onInputChange = _props.onInputChange;
	
				var newInputValue = inputValue;
	
				if (onInputChange) {
					var value = onInputChange(newInputValue);
					// Note: != used deliberately here to catch undefined and null
					if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
						newInputValue = '' + value;
					}
				}
	
				var transformedInputValue = newInputValue;
	
				if (ignoreAccents) {
					transformedInputValue = (0, _stripDiacritics2.default)(transformedInputValue);
				}
	
				if (ignoreCase) {
					transformedInputValue = transformedInputValue.toLowerCase();
				}
	
				this.setState({ inputValue: newInputValue });
				this.loadOptions(transformedInputValue);
	
				// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
				return newInputValue;
			}
		}, {
			key: 'noResultsText',
			value: function noResultsText() {
				var _props2 = this.props,
				    loadingPlaceholder = _props2.loadingPlaceholder,
				    noResultsText = _props2.noResultsText,
				    searchPromptText = _props2.searchPromptText;
				var _state = this.state,
				    inputValue = _state.inputValue,
				    isLoading = _state.isLoading;
	
	
				if (isLoading) {
					return loadingPlaceholder;
				}
				if (inputValue && noResultsText) {
					return noResultsText;
				}
				return searchPromptText;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _props3 = this.props,
				    children = _props3.children,
				    loadingPlaceholder = _props3.loadingPlaceholder,
				    multi = _props3.multi,
				    onChange = _props3.onChange,
				    placeholder = _props3.placeholder,
				    value = _props3.value;
				var _state2 = this.state,
				    isLoading = _state2.isLoading,
				    options = _state2.options;
	
	
				var props = {
					noResultsText: this.noResultsText(),
					placeholder: isLoading ? loadingPlaceholder : placeholder,
					options: isLoading && loadingPlaceholder ? [] : options,
					ref: function ref(_ref) {
						return _this3.select = _ref;
					}
				};
	
				return children(_extends({}, this.props, props, {
					isLoading: isLoading,
					onInputChange: this.onInputChange
				}));
			}
		}]);
	
		return Async;
	}(_react.Component);
	
	exports.default = Async;
	
	
	Async.propTypes = propTypes;
	Async.defaultProps = defaultProps;
	
	function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	}

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(157);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Select = __webpack_require__(327);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _defaultFilterOptions = __webpack_require__(523);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(524);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreatableSelect = function (_React$Component) {
		_inherits(CreatableSelect, _React$Component);
	
		function CreatableSelect(props, context) {
			_classCallCheck(this, CreatableSelect);
	
			var _this = _possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));
	
			_this.filterOptions = _this.filterOptions.bind(_this);
			_this.menuRenderer = _this.menuRenderer.bind(_this);
			_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
			_this.onInputChange = _this.onInputChange.bind(_this);
			_this.onOptionSelect = _this.onOptionSelect.bind(_this);
			return _this;
		}
	
		_createClass(CreatableSelect, [{
			key: 'createNewOption',
			value: function createNewOption() {
				var _props = this.props,
				    isValidNewOption = _props.isValidNewOption,
				    newOptionCreator = _props.newOptionCreator,
				    onNewOptionClick = _props.onNewOptionClick,
				    _props$options = _props.options,
				    options = _props$options === undefined ? [] : _props$options,
				    shouldKeyDownEventCreateNewOption = _props.shouldKeyDownEventCreateNewOption;
	
	
				if (isValidNewOption({ label: this.inputValue })) {
					var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
					var _isOptionUnique = this.isOptionUnique({ option: option });
	
					// Don't add the same option twice.
					if (_isOptionUnique) {
						if (onNewOptionClick) {
							onNewOptionClick(option);
						} else {
							options.unshift(option);
	
							this.select.selectValue(option);
						}
					}
				}
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions() {
				var _props2 = this.props,
				    filterOptions = _props2.filterOptions,
				    isValidNewOption = _props2.isValidNewOption,
				    promptTextCreator = _props2.promptTextCreator;
	
				// TRICKY Check currently selected options as well.
				// Don't display a create-prompt for a value that's selected.
				// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
	
				var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];
	
				var filteredOptions = filterOptions.apply(undefined, arguments) || [];
	
				if (isValidNewOption({ label: this.inputValue })) {
					var _newOptionCreator = this.props.newOptionCreator;
	
	
					var option = _newOptionCreator({
						label: this.inputValue,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});
	
					// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
					// For multi-selects, this would remove it from the filtered list.
					var _isOptionUnique2 = this.isOptionUnique({
						option: option,
						options: excludeOptions.concat(filteredOptions)
					});
	
					if (_isOptionUnique2) {
						var prompt = promptTextCreator(this.inputValue);
	
						this._createPlaceholderOption = _newOptionCreator({
							label: prompt,
							labelKey: this.labelKey,
							valueKey: this.valueKey
						});
	
						filteredOptions.unshift(this._createPlaceholderOption);
					}
				}
	
				return filteredOptions;
			}
		}, {
			key: 'isOptionUnique',
			value: function isOptionUnique(_ref) {
				var option = _ref.option,
				    options = _ref.options;
				var isOptionUnique = this.props.isOptionUnique;
	
	
				options = options || this.props.options;
	
				return isOptionUnique({
					labelKey: this.labelKey,
					option: option,
					options: options,
					valueKey: this.valueKey
				});
			}
		}, {
			key: 'menuRenderer',
			value: function menuRenderer(params) {
				var menuRenderer = this.props.menuRenderer;
	
	
				return menuRenderer(_extends({}, params, {
					onSelect: this.onOptionSelect,
					selectValue: this.onOptionSelect
				}));
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(input) {
				var onInputChange = this.props.onInputChange;
	
				// This value may be needed in between Select mounts (when this.select is null)
	
				this.inputValue = input;
	
				if (onInputChange) {
					this.inputValue = onInputChange(input);
				}
	
				return this.inputValue;
			}
		}, {
			key: 'onInputKeyDown',
			value: function onInputKeyDown(event) {
				var _props3 = this.props,
				    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
				    onInputKeyDown = _props3.onInputKeyDown;
	
				var focusedOption = this.select.getFocusedOption();
	
				if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
					this.createNewOption();
	
					// Prevent decorated Select from doing anything additional with this keyDown event
					event.preventDefault();
				} else if (onInputKeyDown) {
					onInputKeyDown(event);
				}
			}
		}, {
			key: 'onOptionSelect',
			value: function onOptionSelect(option, event) {
				if (option === this._createPlaceholderOption) {
					this.createNewOption();
				} else {
					this.select.selectValue(option);
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props4 = this.props,
				    newOptionCreator = _props4.newOptionCreator,
				    shouldKeyDownEventCreateNewOption = _props4.shouldKeyDownEventCreateNewOption,
				    refProp = _props4.ref,
				    restProps = _objectWithoutProperties(_props4, ['newOptionCreator', 'shouldKeyDownEventCreateNewOption', 'ref']);
	
				var children = this.props.children;
	
				// We can't use destructuring default values to set the children,
				// because it won't apply work if `children` is null. A falsy check is
				// more reliable in real world use-cases.
	
				if (!children) {
					children = defaultChildren;
				}
	
				var props = _extends({}, restProps, {
					allowCreate: true,
					filterOptions: this.filterOptions,
					menuRenderer: this.menuRenderer,
					onInputChange: this.onInputChange,
					onInputKeyDown: this.onInputKeyDown,
					ref: function ref(_ref2) {
						_this2.select = _ref2;
	
						// These values may be needed in between Select mounts (when this.select is null)
						if (_ref2) {
							_this2.labelKey = _ref2.props.labelKey;
							_this2.valueKey = _ref2.props.valueKey;
						}
						if (refProp) {
							refProp(_ref2);
						}
					}
				});
	
				return children(props);
			}
		}]);
	
		return CreatableSelect;
	}(_react2.default.Component);
	
	;
	
	function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	function isOptionUnique(_ref3) {
		var option = _ref3.option,
		    options = _ref3.options,
		    labelKey = _ref3.labelKey,
		    valueKey = _ref3.valueKey;
	
		return options.filter(function (existingOption) {
			return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
		}).length === 0;
	};
	
	function isValidNewOption(_ref4) {
		var label = _ref4.label;
	
		return !!label;
	};
	
	function newOptionCreator(_ref5) {
		var label = _ref5.label,
		    labelKey = _ref5.labelKey,
		    valueKey = _ref5.valueKey;
	
		var option = {};
		option[valueKey] = label;
		option[labelKey] = label;
		option.className = 'Select-create-option-placeholder';
		return option;
	};
	
	function promptTextCreator(label) {
		return 'Create option "' + label + '"';
	}
	
	function shouldKeyDownEventCreateNewOption(_ref6) {
		var keyCode = _ref6.keyCode;
	
		switch (keyCode) {
			case 9: // TAB
			case 13: // ENTER
			case 188:
				// COMMA
				return true;
			default:
				return false;
		}
	};
	
	// Default prop methods
	CreatableSelect.isOptionUnique = isOptionUnique;
	CreatableSelect.isValidNewOption = isValidNewOption;
	CreatableSelect.newOptionCreator = newOptionCreator;
	CreatableSelect.promptTextCreator = promptTextCreator;
	CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;
	
	CreatableSelect.defaultProps = {
		filterOptions: _defaultFilterOptions2.default,
		isOptionUnique: isOptionUnique,
		isValidNewOption: isValidNewOption,
		menuRenderer: _defaultMenuRenderer2.default,
		newOptionCreator: newOptionCreator,
		promptTextCreator: promptTextCreator,
		shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
	};
	
	CreatableSelect.propTypes = {
		// Child function responsible for creating the inner Select component
		// This component can be used to compose HOCs (eg Creatable and Async)
		// (props: Object): PropTypes.element
		children: _propTypes2.default.func,
	
		// See Select.propTypes.filterOptions
		filterOptions: _propTypes2.default.any,
	
		// Searches for any matching option within the set of options.
		// This function prevents duplicate options from being created.
		// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
		isOptionUnique: _propTypes2.default.func,
	
		// Determines if the current input text represents a valid option.
		// ({ label: string }): boolean
		isValidNewOption: _propTypes2.default.func,
	
		// See Select.propTypes.menuRenderer
		menuRenderer: _propTypes2.default.any,
	
		// Factory to create new option.
		// ({ label: string, labelKey: string, valueKey: string }): Object
		newOptionCreator: _propTypes2.default.func,
	
		// input change handler: function (inputValue) {}
		onInputChange: _propTypes2.default.func,
	
		// input keyDown handler: function (event) {}
		onInputKeyDown: _propTypes2.default.func,
	
		// new option click handler: function (option) {}
		onNewOptionClick: _propTypes2.default.func,
	
		// See Select.propTypes.options
		options: _propTypes2.default.array,
	
		// Creates prompt/placeholder option text.
		// (filterText: string): string
		promptTextCreator: _propTypes2.default.func,
	
		ref: _propTypes2.default.func,
	
		// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
		shouldKeyDownEventCreateNewOption: _propTypes2.default.func
	};
	
	exports.default = CreatableSelect;

/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(157);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = function (_React$Component) {
		_inherits(Option, _React$Component);
	
		function Option(props) {
			_classCallCheck(this, Option);
	
			var _this = _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
			_this.handleMouseMove = _this.handleMouseMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.onFocus = _this.onFocus.bind(_this);
			return _this;
		}
	
		_createClass(Option, [{
			key: 'blockEvent',
			value: function blockEvent(event) {
				event.preventDefault();
				event.stopPropagation();
				if (event.target.tagName !== 'A' || !('href' in event.target)) {
					return;
				}
				if (event.target.target) {
					window.open(event.target.href, event.target.target);
				} else {
					window.location.href = event.target.href;
				}
			}
		}, {
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onSelect(this.props.option, event);
			}
		}, {
			key: 'handleMouseEnter',
			value: function handleMouseEnter(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleMouseMove',
			value: function handleMouseMove(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove(event) {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart(event) {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'onFocus',
			value: function onFocus(event) {
				if (!this.props.isFocused) {
					this.props.onFocus(this.props.option, event);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    option = _props.option,
				    instancePrefix = _props.instancePrefix,
				    optionIndex = _props.optionIndex;
	
				var className = (0, _classnames2.default)(this.props.className, option.className);
	
				return option.disabled ? _react2.default.createElement(
					'div',
					{ className: className,
						onMouseDown: this.blockEvent,
						onClick: this.blockEvent },
					this.props.children
				) : _react2.default.createElement(
					'div',
					{ className: className,
						style: option.style,
						role: 'option',
						'aria-label': option.label,
						onMouseDown: this.handleMouseDown,
						onMouseEnter: this.handleMouseEnter,
						onMouseMove: this.handleMouseMove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove,
						onTouchEnd: this.handleTouchEnd,
						id: instancePrefix + '-option-' + optionIndex,
						title: option.title },
					this.props.children
				);
			}
		}]);
	
		return Option;
	}(_react2.default.Component);
	
	;
	
	Option.propTypes = {
		children: _propTypes2.default.node,
		className: _propTypes2.default.string, // className (based on mouse position)
		instancePrefix: _propTypes2.default.string.isRequired, // unique prefix for the ids (used for aria)
		isDisabled: _propTypes2.default.bool, // the option is disabled
		isFocused: _propTypes2.default.bool, // the option is focused
		isSelected: _propTypes2.default.bool, // the option is selected
		onFocus: _propTypes2.default.func, // method to handle mouseEnter on option element
		onSelect: _propTypes2.default.func, // method to handle click on option element
		onUnfocus: _propTypes2.default.func, // method to handle mouseLeave on option element
		option: _propTypes2.default.object.isRequired, // object that is base for that option
		optionIndex: _propTypes2.default.number // index of the option, used to generate unique ids for aria
	};
	
	exports.default = Option;

/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(157);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Value = function (_React$Component) {
		_inherits(Value, _React$Component);
	
		function Value(props) {
			_classCallCheck(this, Value);
	
			var _this = _possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.onRemove = _this.onRemove.bind(_this);
			_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			return _this;
		}
	
		_createClass(Value, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				if (event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				if (this.props.onClick) {
					event.stopPropagation();
					this.props.onClick(this.props.value, event);
					return;
				}
				if (this.props.value.href) {
					event.stopPropagation();
				}
			}
		}, {
			key: 'onRemove',
			value: function onRemove(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onRemove(this.props.value);
			}
		}, {
			key: 'handleTouchEndRemove',
			value: function handleTouchEndRemove(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.onRemove(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove(event) {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart(event) {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'renderRemoveIcon',
			value: function renderRemoveIcon() {
				if (this.props.disabled || !this.props.onRemove) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-value-icon',
						'aria-hidden': 'true',
						onMouseDown: this.onRemove,
						onTouchEnd: this.handleTouchEndRemove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove },
					'\xD7'
				);
			}
		}, {
			key: 'renderLabel',
			value: function renderLabel() {
				var className = 'Select-value-label';
				return this.props.onClick || this.props.value.href ? _react2.default.createElement(
					'a',
					{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
					this.props.children
				) : _react2.default.createElement(
					'span',
					{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
					this.props.children
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)('Select-value', this.props.value.className),
						style: this.props.value.style,
						title: this.props.value.title
					},
					this.renderRemoveIcon(),
					this.renderLabel()
				);
			}
		}]);
	
		return Value;
	}(_react2.default.Component);
	
	;
	
	Value.propTypes = {
		children: _propTypes2.default.node,
		disabled: _propTypes2.default.bool, // disabled prop passed to ReactSelect
		id: _propTypes2.default.string, // Unique id for the value - used for aria
		onClick: _propTypes2.default.func, // method to handle click on value label
		onRemove: _propTypes2.default.func, // method to handle removal of the value
		value: _propTypes2.default.object.isRequired // the option object for this value
	};
	
	exports.default = Value;

/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = arrowRenderer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(157);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function arrowRenderer(_ref) {
		var onMouseDown = _ref.onMouseDown;
	
		return _react2.default.createElement('span', {
			className: 'Select-arrow',
			onMouseDown: onMouseDown
		});
	};
	
	arrowRenderer.propTypes = {
		onMouseDown: _propTypes2.default.func
	};

/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = clearRenderer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function clearRenderer() {
		return _react2.default.createElement('span', {
			className: 'Select-clear',
			dangerouslySetInnerHTML: { __html: '&times;' }
		});
	};

/***/ },
/* 932 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = stripDiacritics;
	var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];
	
	function stripDiacritics(str) {
		for (var i = 0; i < map.length; i++) {
			str = str.replace(map[i].letters, map[i].base);
		}
		return str;
	};

/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Flip = exports.Zoom = exports.Slide = exports.Bounce = void 0;
	
	var _cssTransition = _interopRequireDefault(__webpack_require__(934));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Bounce = (0, _cssTransition.default)({
	  enter: 'Toastify__bounce-enter',
	  exit: 'Toastify__bounce-exit',
	  appendPosition: true
	});
	exports.Bounce = Bounce;
	var Slide = (0, _cssTransition.default)({
	  enter: 'Toastify__slide-enter',
	  exit: 'Toastify__slide-exit',
	  duration: [450, 750],
	  appendPosition: true
	});
	exports.Slide = Slide;
	var Zoom = (0, _cssTransition.default)({
	  enter: 'Toastify__zoom-enter',
	  exit: 'Toastify__zoom-exit'
	});
	exports.Zoom = Zoom;
	var Flip = (0, _cssTransition.default)({
	  enter: 'Toastify__flip-enter',
	  exit: 'Toastify__flip-exit'
	});
	exports.Flip = Flip;

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = _default;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Transition = _interopRequireDefault(__webpack_require__(526));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var noop = function noop() {};
	
	function _default(_ref) {
	  var enter = _ref.enter,
	      exit = _ref.exit,
	      _ref$duration = _ref.duration,
	      duration = _ref$duration === void 0 ? 750 : _ref$duration,
	      _ref$appendPosition = _ref.appendPosition,
	      appendPosition = _ref$appendPosition === void 0 ? false : _ref$appendPosition;
	  return function Animation(_ref2) {
	    var children = _ref2.children,
	        position = _ref2.position,
	        preventExitTransition = _ref2.preventExitTransition,
	        props = _objectWithoutPropertiesLoose(_ref2, ["children", "position", "preventExitTransition"]);
	
	    var enterClassName = appendPosition ? enter + "--" + position : enter;
	    var exitClassName = appendPosition ? exit + "--" + position : exit;
	    var enterDuration, exitDuration;
	
	    if (Array.isArray(duration) && duration.length === 2) {
	      enterDuration = duration[0];
	      exitDuration = duration[1];
	    } else {
	      enterDuration = exitDuration = duration;
	    }
	
	    var onEnter = function onEnter(node) {
	      node.classList.add(enterClassName);
	      node.style.animationFillMode = 'forwards';
	      node.style.animationDuration = enterDuration * 0.001 + "s";
	    };
	
	    var onEntered = function onEntered(node) {
	      node.classList.remove(enterClassName);
	      node.style.cssText = '';
	    };
	
	    var onExit = function onExit(node) {
	      node.classList.add(exitClassName);
	      node.style.animationFillMode = 'forwards';
	      node.style.animationDuration = exitDuration * 0.001 + "s";
	    };
	
	    return _react.default.createElement(_Transition.default, _extends({}, props, {
	      timeout: preventExitTransition ? 0 : {
	        enter: enterDuration,
	        exit: exitDuration
	      },
	      onEnter: onEnter,
	      onEntered: onEntered,
	      onExit: preventExitTransition ? noop : onExit
	    }), children);
	  };
	}

/***/ },
/* 935 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	var eventManager = {
	  list: new Map(),
	  on: function on(event, callback) {
	    this.list.has(event) || this.list.set(event, []);
	    this.list.get(event).push(callback);
	    return this;
	  },
	  off: function off(event) {
	    this.list.delete(event);
	    return this;
	  },
	  emit: function emit(event) {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    if (!this.list.has(event)) {
	      return false;
	    }
	
	    this.list.get(event).forEach(function (callback) {
	      return setTimeout(function () {
	        return callback.call.apply(callback, [null].concat(args));
	      }, 0);
	    });
	    return true;
	  }
	};
	var _default = eventManager;
	exports.default = _default;

/***/ },
/* 936 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (action) {
	  return action && action.type === '@@redux/INIT' ? 'initialState argument passed to createStore' : 'previous state received by the reducer';
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=getStateName.js.map

/***/ },
/* 937 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  } else {
	    var _ret = function () {
	      var last = funcs[funcs.length - 1];
	      var rest = funcs.slice(0, -1);
	      return {
	        v: function v() {
	          return rest.reduceRight(function (composed, f) {
	            return f(composed);
	          }, last.apply(undefined, arguments));
	        }
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  }
	}

/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports["default"] = createStore;
	
	var _isPlainObject = __webpack_require__(941);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(2214);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	};
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [initialState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} enhancer The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, initialState, enhancer) {
	  var _ref2;
	
	  if (typeof initialState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = initialState;
	    initialState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, initialState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = initialState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2["default"])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/zenparsing/es-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2["default"]] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2["default"]] = observable, _ref2;
	}

/***/ },
/* 939 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 940 */
[2246, 2139],
/* 941 */
[2251, 2133, 2135, 2140],
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1584);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../css-loader/index.js!../../../less-loader/index.js!./react-widgets.less", function() {
				var newContent = require("!!../../../css-loader/index.js!../../../less-loader/index.js!./react-widgets.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1601);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./LoadingBar.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./LoadingBar.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1617);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./DocketPopup.less", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./DocketPopup.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1619);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./History.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./History.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1624);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./ConfirmationModal.less", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./ConfirmationModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1658);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./Petition.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./Petition.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1659);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./ScheduleAB.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./ScheduleAB.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1660);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./ScheduleD.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./ScheduleD.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1661);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./ScheduleEF.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./ScheduleEF.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1662);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./TopTwenty.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./TopTwenty.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 952 */
[2412, 1665],
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	  if (condition) {
	    return;
	  }
	
	  if (isProduction) {
	    throw new Error(prefix);
	  } else {
	    throw new Error(prefix + ": " + (message || ''));
	  }
	}
	
	module.exports = invariant;


/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "af7ae505a9eed503f8b8e6982036873e.woff2";

/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fee66e712a8a08eef5805a46892932ad.woff";

/***/ },
/* 957 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 958 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAo4AAACFCAYAAADVVnkKAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QsRDBgoMA2qqwAAIABJREFUeNrtnTuM21ba958zSOMvBUfwpvRLzajIpqKElBtAVJG0pEqnoQRvFQSRBOwGqUJpq8B5AUl5t1xDUpOUolqnoARkS0NSZaSYkYSURkCrMFKer+DQke258PIc3vT8gAFmsx5dDg95/ue5/A8AQRAEQRAEQRAEQRAEQRDEUbB5wTmNgv+xcl7xcxoJgiAIgiCOCucVP9d+4ByanGs/cE4C8nb6TzmXvuBc/gfn02c0VgRBEARBiIGl7QONfuG8/SPA/o8//5t0D6CrA3Q+Y4wu2Z9sXnDeeAKw+PXN/65VAMaPoFR4n13SKBEEQRAEkTvheJMIOqT6IcDgIUBFJgFpWpz3Zjf//yS2CYIgCILIpXA0Lc4HT9+MMt767zWAnn6cgsh+znn7J4D1b/7+ffVDgPEjgLMPSEASBEEQBJFh4bjcuVFGvyLoEPm+K4hqHx2HIHJe8fPuDC6GP4cU50cstgmCIAiCyLBwjCqCDml9CtDV8l3PN33mRhl3v0d7HeWBm+o/FrFNEARBEETGhaP93I0yRhVBh0j33Ohj/eN8CSLnFT9vPIGL2RL3dY9BbBMEQRAEkWHhKEoEHaJV3IhaHur5+k8571r+6z6DIt93xypvYpsgCIIgiIwLx+ssdkSR9W5iP93l2GKbrHsIgiAIgkhcOMYtgg7JonXPXRY7IsX24HOA5icUfSQIgiAIIgHhGNRiR9jnyEA3cVCLHZFim6x7CIIgCIKITThGsdgRRVqtezC7y7GQ7gG0PyPrHoIgCIIgBArHNIqgt0lTNzGWxY4olAeu2KZTegiCIAiCQBWOIix2RJF0N3Ec3eV5FdsEQRAEQWRYOGZNBB2SRDexaIsdkWL7mE7pIQiCIAgCWTjGabEjirise5LsLs+62CYIgiAIIsPCMS8i6BCR3cRJWeyIFNtk3UMQBEEQJBx9iaA0WOyIAtO6Jy0WO1kU2wRBEHExGo34druN9Bq9Xo+egwQJx0PSaLEjCuWB2zwTtp4vC93lWJB1D0EQmd8EV6t8sVjEspYSRB44uUsEtX7kvNI9DtEI4H7P2mOA1o+cO6/4eZC/nT7jvGweh2gEcCPPvRmA8i3nyx3ndDsRBEEQRL65cZeUJYsdUfi17slydzkmZN1DEETWoIgjQQTj5DoRpP3Aee3xcYtGAPf71/8NoP1wc/Sx/5Tz4j9JNAIADH8GKJtwYT+n6CNBEARB5F44Tp+RCLqO2RKg+E+46D/9UxBtXnBe/Y7zzk/5bRYKK7Zrj28X2wRBEARBZBMG4EYZ9f+DizxZ7Iii+iGA+le3to+4Heme23mdxCk9tm0nHvU8PT2FSqVCKSyCSPMznVLVBBGI97xf1L/my5tRFOX/ASg/cOsfjz2VfxfFv7g/SVCr1dIyDBwAQJZlKBaLUC6XoVgsgqqqJCoJgiCIzPHGwnVMtjtBUR640bOKzF5HaY/FdicocZ3I40ewpXqcJAlUVQVd10HX9VKhUKCmIoKIGYo4EgTCZM/qmcqiRNBtXoUktt96CKfHGDxzDTqapkGj0YB6vU6LEEGQcCSI7AhHgHweLShSBOX9VB0/Ajupesa8CEcPWZah2+1Cs9mkxYggSDgSRKq40QD87APGFt8wNv3SFQXHJoL6DwEW3zDmN3LW0xlb9VyxeWwYfwPYfg+lFInGTLPb7aDZbIIsy3w6nZK1EUEQBJF+4ehR/5ix7fdQMv52HAOiVVwRFKY+zxPbo0fHIbbl+wD21wCTvzNGpt9iBGS9XgdN07jjOGRtRBAEQaRfOAIAFN5nl5O/M2Z/7YqFvIqg6ZcAs6+ii6DmJ67Y1ir5nTimBrDqQSnsmd6Ef2azGRSLxQuKPhIEQRCZEI4etY8YW/WgZGr5GoTWp64Iwky1Ft5nl7Ov8ie2lQcAy66bmqcoY3zs93uo1+tgmiaJR4IgCCIxQgulPHQTKw/cs6hFR83yYN1zV3d5CsmtwDIMAyaTCUV6CQIBao4hiJgne1ate0wtfhGUVbGdIosdEo4kHgmChCNBJMhJ1BfofJatbuLqhwCbx8lEzioyY+t/MWZq2Wieke4BjB4F6y4n4mEymYBhGJS2JgiCILIlHAGyYd0TxmJHFFmw7vG6y5ufkGBMs3js9/skHgmCIIjYQBcFzit+3v4JLib/TZcIGj+CUhqbOUa/cN7+MT2pfvm+m5bOQbf00Qgq27ahVquRwCeIEFCqmiBSMtnt52493+73ZEXQ4GGqTjO5UWw3nsDFbJns52h9CtDV0imwSTjeMs9lGVarFZ11LYjlcslfvnwJAACr1Qq83wEATk9PoVwuv/69UqmQgHh3Y8OvG7tyuQynp6eJj1sahKM3x16+fAmr1er1fy8Wi1AsFgEAjmJzuNls+Ha7BQCA7XYL3u8eqqq+/p02yzkUjp4gGvwMF70ZiaA0i23lgRtlrMi5SktHFo6GYbx+aAdltVrBdruF9Xodz3xvtWA4HGbu+nkLxXWLxCGNRgPOzs6Efz/btvl8PofVagWr1Qp2u13g15AkCcrlMqiqCqqqHtUC5zjOuWVZF/P5HObzeaDxUxQFyuUy6LoOqqrGthFKQjjats0ty4LVagVB3luW5ddzS9f1WO4JkRuyw3stzLPSu9cO7jfaQGddOL6eIDF2E8dlsSNSbMdl3ZNBi51YhSNWCthbJMbjMez3e5EP4rCRGx7X82Oz2XDLssATFn7HQ2Q6fjqdcsuywLIsYddH0zTQdR10XY97YQt1bfv9PnQ6HRZkjo/HY5hMJmgf3DAMaDQawoV3XMJxs9nw8XgM4/E41IbkJrHdbreTmFehxeJ4PAbLstDG4LoxaTQaaMJ6s9nwcrmM9myoVquwWCyEr7mKonCswIWiKLBer5PRCf2nnEtfcA5NMT+mxXOTnlzuOFe+FTdW1e8437zgeU7n8qg/XooNk9FoxGVZ5hif7+2farXK4xyrIMcg2rbNNU1LzbVwHOfcNE0uSZKQa3HTjyRJ3DAMvtlseJrvA79G85vNxpt3wn6q1aqQe/FQOCJ8zjvnmuh5ZZpmao8mFfncu+1H0zSUuTMajVA/l+imRuz5tlwuk9UKmxeuaCER5HMCWLhjJX3B+egXfgz1f6kUjt5C0mq1hDwoQ35mYe+FJSywrkVSgvG6n5gEpLBNiGgxdJ0IECGMRApH27ZjFUyyLAsV2SEi16m41zA2H1E2vtcJfVH3/pXIy4zIDcT0WfToo/QF5/2n+RdBWGJb+4Fz5xU/h+MgtcLxcBeL/VANGXUM9V5Xu/BYvh/GtUjLInZddE9gpAh9HjmOcy46ynjbgot9Zrso4Xi14Cbyc7UxTYy4BXOQzUdYweY4zjnmd4qQIboVRVFQxyt1K7vzip8b/yER5HvhC5nql//Buf2cH5vfX+qFo7c7xBYzIR6M6OlM7GhUlGuRpNDx+6Moiqh0EKoYchznHHNhSkMURIRwvDLnT3xOJZG6FpVNScPmI+3RPMznrizLqS19cHcnz11x41cETZ8dnQh6Q2xrP/gXja0fj09gZ0k4epG5hKMNqLtREZGWsNdChDAX+XNXFDfO++DtRSMtohEOUv1pFI5xp/DTIh7TNj9EzR/M64uZsr56RuanrtGvIGr9SCLIL9Nnt4tt5VvOl7vjFdhZEo7Yu/SrdIrwsbou1XK1k0+FcMQW5BBj6joN98HbY57GqC3GWGEKR1HzP+3iMWsbtMNnWJixwbwXMFLW2Gn0zJ1Idl03sfLtUaZaQ4lt6Yt8dZcfi3AEAMC88QPuFkPvlg9fZLPZCFs8gl6LrIpG7GgaVvQzTVE07CgtlnAUOf8xxCOJRjxh7TjOOeZ3jirUMAMPqaxr9B0OtkgE+Q5RP3fF9RFY7ORaOGJGKwJGYlBSdJhdh1GuRdZFI/KuP/Icwq7rwv6RJClSWg1LOKa9jlZEw0zWRWOUqB/m8zrKHMZMUUuSlO66xrsiaV4d3zE2wQTFa5o50iaY3AhHALyOuIARhshjhF1fE/Za5GUhw4qmYUQ9s1C3FiWihmgXlfofzGda1moaRUT5MSN9YeYwdoo6TVZOgRj98m7n8LHY7gTlJpseEtvZFY7I0TLhY+V1J4qMNvq9FtgP0bRE0yIWz0eKwmQpehu23hFDOKY92gjh659vRPQ9n5WNGqZ4DjqHMbv3kWurkxVBR3baiW/uMgY/IqPvXAnHqzRB3LvHSA+bK2GTuHDM40IWNZoWVbRmSYiHTbNlRfSlSSAk6VGZto0adpbDb8oaM1UeNFV/khYRVDYBFr/e/u8WvwKcfX0lmo4Ur56xN7v93+3/AGg+ASCxnS0KhcKlpmkor7VarYR/3u12C5ZlJT5u0+mUz2azXM6J9XoNSXQ57vd7YecJi/q87Xb7gp4itzMYDCBKHZvjOOfdbjeXY7Pf76HRaAT6m0qlwgaDAdpn8PP+juOcB/2cNyFJEliWVQryN+8leZGWO84bTwB6AZ/3vRmA8i3ng4cAtY8YO4ab3XnFz7szuKg9DvZ3i18ByqYrtnv6cYxV1tF1HTBE0Ha7jUU4xiFQ76Ldbgt7bVmWQdd1UFUVTk9PoVwulwqFwqXjOOer1eri5cuXMJ/PYT6fw3q9FvIZut0uOI5zXigULtM6bxVFAVVVoVwuQ7FYvHaeWJYlVIxalpXqcVIUBXRdh3K5DKenp1Cr1RiA25HtjZE3Tvv9Xpg4Go/HFwDAQt5rF6I+myRJr8fHm0dnZ2cMwI3seffaarUCURvFxWIB0+mU1+t13+PTbDaZpmkom9f1eg2mafJer8duEZdo18CyLEjzc+UNEXSXZyMZXB9EU575N0i/7efIvB0zWyiM1cUaIP0QKbUDCRf1i7KKMQwjcKfjcrnkok4NCZliFJ7aa7VagdJ7IscozDjFkaoOM5dGo5GwUoGwtY6iylJkWQ5cXyjy3Pkw44NdY33TfMFMUSd9NKVvgpwSE+RIvTyeJhP0lBgS2/kQjlifP8DDL9PdoNgLh6Ioka+9bdscu+M0ZA1fKs/99QSkiK7coIu+SOGIcZSkqI1RmGP3sAW/JEmRbaccxzkXUd8cplEG07rqutpmTP/IKLXTsdU4eudS1x4D7H7Hfe3d7wD1fwPkqZu4/5Tz4j/hYrbEf+3hzwBlEy7Iuie9VKvV6PdFhurTwjIajThm2kzTNJjP5yUvhRiWWq3G5vN5CateFcBNMQ4Gg1TU8PX7fZjNZsxLI4ahUqmw9XrNDMPAXQ92O0jDcWmGYcB8Pi9VKpVIc6nX67HlcgmSJKF+vqC1yZvNhk8mE7T3lyQJ5vM5dDqdSONTKBQuZ7MZ6/f7qOMzHo9DzWnTNFHe30tZH/43XddRUtRXdY2h/z4W4Th95oqgyX/Fvs9sCVD8J1xk2brH6y7v/OQ2uIhi9ztA7XG+xHaeeLtGLOtIkgSapoFpmmDbNmw2GwC3xsrXz01CDrMoXdM0mM1mDKvex1vQMMVjmMVMgFiPvNgfMplM0MVj0uNkGAZMJhO0uVSpVNh8PkcVj0GFA+aYeqIxqqg+pNPpsNFohPYZF4tFqA1Ir9djGBv/q9fyPHKh3+/zxWKBdn9E2fQJFY6eCKr/W6wIemNX/gdA56dsdhObFudnX9/dXS5CbB+5dU9uhWPSpwBUq1WYTqew3+/ZbDZjvV6P1Wq1SJEqj+VyybGaURRFgfF4XBIxBuPxuKQoCs6Gb7eDJEsoTNOEZrOJ3mQ3mUxQBXaSnf7VahUmkwn6GFUqFYb5vfb7faC5hCkcsUWjR7PZZK1WK/ENiGVZJSyR32g0YLlccqxO9larBUEaf2IVjv2n/ix2RJEl6x7vfO5eQm4iZN2TX1arVSKpTUmSYDqdwmKxYFEfUnGIg/F4LKyzsFAoXGIuukmJomq1Crd1emIIbKzFdrfbQUTj9NDzPqi1SRBqtRpaKtQTcH43aVilL6ZpChGNHsPhkGFt1MLea5j3/G63A1VVUbrsFUWB4XAYeezRhaMngkSnWv3iWfeksZ7P6y6vdAHWvyX/eQ6te0hyJUuWU9VeGkqUYMQWUK1WS+hCBuBGi7AiIUkJR9Hp30KhcIlZeuBXFGEyGAyEW5u02+2SLMuxjhHWnJNlWejm4/A6YIm2sPWy9Xod7Z5PQ12jEOHovOLnppUeEXTI+je3ni9N3cT2c87LJlwMf07XWO3/+FNsH5F1DwlHZNEoWog5jnOOlabudrulOMYG632SiKYZhgEY5QV30Ww2GZYoittfVJZlIWn86wQ2VtrS7xhhifC4jMNrtRpanWGU744Z/cQQ01j3MIpw9ERQL+UHN3jdxEla93gWOyK6y7HFdqWbLrFNpJ92uy1cNF49zFFS8IZhxGZ+WygULrGaQOKOpsV5UkjcoiiLY6TrOkpaf7/f+6qDxmjKkCQpFmF9+CxKw702Ho/RO+LDPOcwxz6ScBRpsSOKJK17Rr+Is9gRLbbJuofwszDEkYbCFAW6rsc6RljvF6coUhQllmjjoSjCeB2sDtQ0iqJCoXCJOJdu3YRhNWPFfa/V63WGIdii3mvYRxKGuX8HgwFqViW0cIzLYkcUcVr3eN3lzSfpqPsMI7bJuoe4C6yzU+OIAniLveg6zLQuZmm9rp4owuqwjstVIG5RhPmedx1NinV0aVbHaLfbRZ5HV0cSJrKZF9H4F1g4JmGxI4o4rHtMK9nuchFim6x7iKQFBsZipqpqIuOE8b5xCsckFvxyuYzyOnG5CiQxl1RVLcVxL2EJx7g3aZjXBWMejcdjtKYmvwwGAyGlQ4GEY9IWO6IQYd1zaLGTdYH9ttgm6x7iup1tHLWNh1GAtIiTJN4X87Scu65rnGnqpEV9lj5voVC4jEOIYET3k2oQwbrHX758iXK94nRE0DRNWPmEL+GYNosdUWBY96TNYkek2C6b7maCZBMRpwjDSj8mJRyxREYcx+olKK5RomlxNRElIa4BcNwX4oheJ+USgbWZxRojzCMJb0OWZWEHGtwpHNNssSOKKNY9abXYEYWX6ifrHiLOiAtW+vH09DSRscJ6X4woSFqFY1yd7hhg2b4kdX3umkcY8yypeQSQXLTzJjCPJLwJy7KE3kMnd4mgtFvsiCKIdU9WLHZEiu1K1031U/MMDkmYF2dRhEVczEpJvG+cKf0sX9ckBRldn4PnO5JfKj2b3hB2JVEWPf1+X/gz5uQ6EZQ1ix1R+LHuyaLFjrCd1Iyse471oZlkRCEsWYpqEUSWyeLzQeRGHvsYUg9N06DT6QjfmL4hHLNusSOK66x7sm6xI1Js1x4DGP+h6GMayFJ0i0gfWT76Mi6y1siT5w1slqjX6wy7uSkuB4QTADfKmBeLHVEcWvfkyWJHFJP/umI7yVN6aIdLECQcCSKNtFotjuEOcUi73Y7lONL3Xu+a/kpCyA/l/wEo/gXg9P+RyL5z0fmL+0MEJ47GB4IgooPlc0gcD7Zt81qthv66+/0+Fj/dEwCAwvvssqcztuwCKA/ool6H8gDA/hpg+DljzU8YW/Wg1PqUxuU6pHsApgaw/hdjFZlRqjQEGAXpcTYXUCoqn8R93jMJRyLvOI5zLjKlvFgswDRNoVHHN2ocKzJj638x1n/oLv6EiyeCah/9KYIK77PL4eeM2V+T2H5DrHwIsOoB9HQSjFF2o1n7zFRLmU8o8k2QuMZF1/UL0Qb+vV5P6DpyrR1P5zPGVj1XBBy7CNo8vl0E1T5yxbapHfdYSfcARo8AFt8wdvYBicYoYNU3UtH+7cRRC3RTxIFGn0iLIIsjW5B14Yj1LDVNky8Wi1g+c6PREPasudHH8ewDxhbfMDZ6dHzRR+keQP9hMBHU0xnbPD5Osa1VALbfQ6n5CQlGDLCOpaLGhnQuZnGdn4z0WRN777gW2Cx/Tow5fJdVTtznK+dVtC6XS97r9WJ7v91uB41GQ8iz5s4jB5ufMLb9Hkpa5bhEUOez4CLIE9vHkuqX77t1n7OvGCu8z8gTD4HNZsOxDHez7p0mWhAntaBgvW+eI0VZi8omFb3OynGBSbpEYHcuh53PcVnlHDKbzWA0GqHPTV9nVRfeZ5ezr9x6Pvl+fkXQ9EscEdT5LP9iu/UpwKoHpcO6TyI6WKawkiTltu4Q61zgpKJpmOfeiv6sSZ0aghWVjWvzlIQw2mw2HKNWLo4NSFL3GladX9R51Gg0LpISsCIsek6C/OPaR/nsJvZEUP3ju0WQ84qfb17c7U3oie3pl/kS28oDgGXX7S6nKCP+rnQwGKC8Vt7rGzGO60oqCoLxvqKOK7uO6XTKszhGcYmipOYSlhi7SxRhiO/9fp9IVBZrjKLMo9FoxGez5M5u3u/36MbgJ0H/wOsmzoN1z6HFjh8RNH3mnt9dNgEOT5G5jfrH+RDbZLEjnsFggNZtl3fhiLGYrdfr2BczrFKEOMsQsGpuk3jPuM4jz/IY3ZWKxhLfSYwRVgYn7DxaLpe83W4n/rxcr9fQarXQnnUnYf/Qs+4xtWzW811nsXMTzit+rv3gnqyz+/3PU2SUbzlf7vxFH7Ns3UMWO/EICqxoI0B8R09lWThiLiwJCKLcCkcscS1JUmznke/3+9gjs1jX5a7SD6xNaNz3GtY8kmU51DxyHOe80WiAaOsdvwyHQ7TU/UnUF+jp2bLu8WOxc0j/qXt+92x5jYr/DaDSBTAtf+cyZ826hyx24gPzAaMoClodYFrBapCJezHD2hzEKRz3+72QAvs8jRHm5/bDaDRCqW/0c0gAVtR2vV7H6lGLGG0M9XfdbvcCq0YYqzRF13WUxrMTjA+TBeueoBY7mxecV7/jvPPT3UcL9mYAZRMu7Of+0tdZsO4hi534aLVaqN5ecRw5lTRYUZDdbhebKBqNRmhn08ZditDtdmN5H8dxzpNe8MOyWCxiE0ZY18PPGBUKhUssS54451GS9eLT6ZQPh0OctVjT0ETw1ZGEkRvPTjAvVlqte4Ja7JgW52dfBzu7e/c7QO0xgPEff9HHtFr3kMVOvIxGI7QHzOGuMu9UKhWGtQtvt9vC7V8cxznHqnWSZTn2iPJutxN+jNnVpifTdb5x1LP1+/3YNyBYY7lYLGJJ6Sc5jzabDcfavEuSBOPxuFSv15lhGCivOZvNoN/vR7oGJ9gXLE3WPdK9YBY7yx3nyrec9yI0QE3+C1D8J1xMn/mLPqbJuocsduLFMAzebDaxXzP3aWpsgXzVdSjUlBtzIUtqY9Dr9WC5XApb9LG7T1VVLcU9RthNCO+sUcslx4za+R0jTBHeaDSENqVhziNZlgPbXum6jlZ2NB6PX9dXDgaDEmbkN8q9fCLq4iVt3dP61I0y+rXYaf3IeaXr1i1GXoj+AKj/G6D6HedZsO4hi514sW2bK4rCJ5NJJiMeaQFzMVssFmAYhpDFzDAMVEGUZCmCqqpCxCN292m1Wo2tMeZthsOhkPIHz0Qasxba7xjpuo4mwj17GBFRfux5FHSTZpom2gEOmqZBvV5/rV8KhcIlcso69DU4EXkDJWHd46Va/Yog+7lrsTP8Gf+zLH4FSLN1D1nsxC8YDcPgtVpNiLGypmm5Nf2+aTHD9DOcTCZgGAbHWtAcxzk3DAN1gxAmAoLJfr9HF4+2bXNVVVG7T5Mu12g2m5HTgW8LIlVVUU2kg2xACoXCpabhdXWu12tQVfUCcx6NRiP0eRREhNq2jXakoJeifvu/12o1Zpom2jXodruhMi0ncdxEcVn3mBrA7n+DWezUHrv1icIetCm17iGLHfEsl0s+Go14q9XisizzWq0GIqKMHnF2daaBQqFwiS0QJpMJqKp6EbXJ4UoMXWBf7zRElD3xGFUYOY5zbpomr9Vq6JYljUajlPQ4dTod0DQt8kak3+9zVVXRN5tB7x3sSPeVeESZR17ZD+Y8qlarvst+sI8UPExRv02v12OKoqC8z3A4DFVzGrto2LzgvPEkWOOJHxE0eOgKVF87k184b/94d7e0KHEbRKyZVrSay3d2MvcABp+7jUw51xUcjgjTNKHX67EExyqR+bTZbPjZ2ZmYzVW1Cu12+4100V1Mp1M+GAwAs0v+MAqx3W5LAVOwQu+DarUK3W4XarWa7zFyHOfcsqyLbrcr5BxhwzBgMpmwAN+Bi7heh9et3W5Do9EIVH88Go24qDHSNA1ms1nge1aWZS7i88iyDN1uF3Rd9z2/Pe/b8XgsxCvRtm3f8xpzDvm5NsvlklcqlcSeK4mJBwzxJt0D6Opug0lSojXUTXIfYPzIrQON83NrFYDxIygdSR3j0QhHWZZhtVqVItR0ZVY4xrXwq6oK5XIZyuXyGydpbLdb2G63sFqtYD6fCzX7Dbk54HHNQV3XQVVVOD09fWPB3Ww2/HCMRB+/FmTBj2P+HKIoCui6/s488pjP57HMpaBjdChmsRv6rtuMePPobbug+XwO2+0W5vM5iDz7uVqtwmKx8Of13O/zTqcT+7Mc832DfN9EH/YAbrq48eR6c20/Imjw0LW18fXQtTgfPE0myngTrU8Bupp/Idd/ynnXCv4d5PvuWPlpFCLhmD2Wy2XUurdMC0fM3XcONwdHFXkPugDGLRyzOkZvzUUuUrSlAb/CGvvZk+Smp9/vQ6fT8fXeJ0lenDDWPYcWO35E46HFTppEIwDA8Gfx1j2exc6RicajYTQaHVVDzHVUKhXWarVy/R0Hg0FiXcJZIi6D6TfWJMQGrSyMUd5rqVutli/xhl3X6Pd9DxmPx2jzr9Pp+G56O0nDhfJr3ZOkxY4oPOse7Qdc6x7lQbDuciJ7GIYBzWaTNgTuYojmcZY23rblIG6+H8KkX6OSJQusarUaeYzq9TrD7LBOE1e1lr4aqxqNBlqXe5D3PeTs7IxhHpvq1yYpdQ+j5c6t5zsUe0FrAu3n7muI7JYWsnMNWLPpvOLn3dm7VkJBG3BySq5TdEEbAGIYq8Tnm23bvFar5eo6K4oC8/k8sfpVWZYhC2nJkI3MiNNgAAAHz0lEQVRDnpiKlO7bbDbQaDQg7eluSZJgtVqhHBDgOM55sVi8EFmHmYj+8Fn2g13rGbbm9GBzieYV62dtOUnbhXvbuieNFjui8Kx7qt+Fs+6pfgiweUyi8RgiK4iiMTfUajXW7/dz832uvNwSTVEXi0XA8o0TSZLjdHZ2xpJIkQel2+2inSpVKBQu5/N5rp4ffst+sE3Gw6Sor5n/aBmXyWRyp0VPbhafJC12REGRw0jkMuIY0XZH5FilZp5im24nJRrn8zlG/Wqka1utVsGyrFK5XL5Ia+Sx1WrBcDhkEb5j6IijJEmw3+/Z1edAP3c+7ZvNOLqs4xKNfst+FEVBOx0GwRHjNZgZl7ui0ydZv+CbF5xXv+O8+SRfohEAoDcDkP/Buf2cH1VnJHH9jTydTkWIxtwxmUyYYRgkGpHAPOpMhCCKIhqjcmgX0+12S1jGzJgoigKDwUCIIXqz2WSj0ehoRGOr1eKYRuyYkfJarYbWJOgdSXgTmRaOpsV52Uzel1Eku98Bao8BWj9y7rzi50AcHZqmwXa7LVGDRDDxmIUUa9pF4+GilDaBkLaSjUKhcGlZVqq6rBFqZH2Jx+l0mrnu8qCicTqdokaUMVLUb4O5eVksFmCaJs+NcEyzxY4oglr3ENlHlmWwbRtmsxkjK5bg9Hq9TC1o1WoVttttKa32Ss1mMzWR3LSIRlVV3/jfZ2dnbD6fp2LOxSEaPer1OpvP55DGiOtNz9blculbNG42G4555KKiKKG6qP1sXjCzA71eD647fjVTwjErFjuiCGrdQ2RXMI5GI9jtdiwJe5E8Ua/X2Wq1gmq1mtrPKEkS9Pt9WCwWqd8gTCaTxBuQ+v1+qpvDKpUKm8/nkKQ9lGEYsF6vY51PV9+7lHZP1VarBavVKtAGrdFooJ7kI7KZq1KpoGZbGo3GOxY9mRGO9nPOy+a71jPHyGwJUDbdk2RoNPKBJElgGAbYtg273Y6RPyMeZ2dnbLFYsOl0CmnzejQMA7bbbcnviQ1poNPpJBLJVRQFlsslpGms3j4S73DxXq1Wpbg3LF4tdFLCulAoXA6HQ7ZcLlO3WatWq7BcLmE4HAYS1KZpop4sZJqm8FKUXq/HsMZ/t9tBo9G4yJRwzLrFjiiCWvcQ6UOWZTAMA6bTKez3ezaZTCjCKJB6vc52ux0bjUaJp9QMw4DNZgOTySSTZQj1ep1tt9tSHKlrLyK7Xq9Z2tL41503fSiiFosF6/f7sYjsVquVmlroSqXCFosFs207cQGpaRrYtg2LxSLw/LFtm/d6PdTNT1wNjpinysxmMxiNRq91RqoXqekz18j7WOoYI+1iyLrnbVIjpr0HZ7lchtPTU1BVFcrlcilFgiFXdjx+WS6XfDweg2VZsZhcK4oCjUYDGo1GnNc+sh3PXecabzYb3u12AdsC6eo0DdB1Xeh4RbHjcRzH12dzHOd8MBhcDAYD1JSnJEnQaDSg3W6jeTSKYLPZ8PF4DOPxOJZ7TZZl714LPS4iTM79Goxj0e/3eafTQZtrnkVPqh/2yx3n7Z/y3TWNcpMEPFmHIIh3ReR8PgfvB2OxUBQFyuUyqKoKqqomtbALF46HC+14PL6Yz+cQ9hQLRVFAVVVoNBq5PYN9Op1yy7LAsqxQ80yWZVBVFXRdz+RRlJvNhluWBavVCubzOYqQlGX59b2m63qqRXQeyMTg9p9y3rUo8ngdrU8BuhqU6DxqgsDDcZzz1Wp18fLlS1itVgAAcPj7IV4k+fD3FJUcxCYcrxPjq9UKttstAAC8fdJIsViEYrEIp6enUC6X0xaFj01ErVar1/NqtVrBy5cv3xkjALeDu1gs5lIU2bbN376/rjuZ5nA8vN+Pcd6QcPR7g71wo4+zJV00APeIwfEj94hGGg2CINImHAmCyCeZ6ao++4Cx2VeMTb90z7A+Vrzzu9f/YoxEI0EQBEEQcfJe1j5w/WPGnFf8vDs7Pmue6odulPHsAxKMBEEQBEGQcPTFVT0fs5+7Xdd5t+mR7gEMPgdofsLY2Tc0aQmCIAiCSIZMn1Vd+4ix3f8yZmr5vUBaBWD7PZSan1CUkSAIgiAIEo6R6emMLbtuKjcvyPcB7K8BZl8xRh3TBEEQBEGkgffy8kW8RpE8WPeQxQ5BEARBEGnkJG9fqPMZY6uem+LNGsoDgGUXYPg5RRkJgiAIgiDhGAtZs+4hix2CIAiCILLAe3n+clmw7iGLHYIgCIIgssJJ3r9g4X12OfycMftrt+EkLUj3APoPARbfMEaikSAIgiCILPDesXzR2keuODMtznuzZD+LVgEYP6LmF4IgCIIgssXJsX3hJK175PsA0y/JYocgCIIgiGzy3jF+6SSse8hihyAIgiCIrHNyzF8+Duse5YFr5E0WOwRBEARBkHDMOCKtezyLHa++kiAIgiAIgoRjDqh/zNj2eygZf4v+WtUPATaP3XpKGlmCIAiCIEg45pDC++xy8vfw1j1ksUMQBEEQRJ55j4bgXWofucbhg5/hwq91D1nsEARBEARBwvFIuRKAbLnjvPEEYP3b9f9Ovg8weOimugtf0bgRBEEQBJFfKJ3qk+use8hihyCINGPbNo/y96enp1CpVGidIAiCCMPmBefV7zhXvuXcfs45jQhBEARBEARBEARBEARBEARBEARBEEQY/j8Ew/WoDbk6JwAAAABJRU5ErkJggg=="

/***/ },
/* 959 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAloAAABkCAYAAABetJ4eAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4wkMEQ8R6w7rPwAAIABJREFUeNrsnXecHGX9x9/P7F7JJYFAILTQexUEBX9H6AgERdAgKKACSich5dm9hABn2t3uk0KTDkFABUVEKQkgHQ5QFAWEkEAChJCQdpdc2zbz/P6YmWNus2X2Wi4wH17L5famPPPM83yfz/OtsJFx7nOz0P/6Af0JeuFYAgQIECBAgAABugvRXxry+mtXiqHlIrTH5gNAA1rno0E+vytyjHb+J7K+FYYl9pyp9aJxiD1nByMkQIAAAQIECNBlhDfmzX/8dIw/fjcKwHuJsn0ONlITsJIptLBZkc5LqrSHJOouEy3R6dQQQqwF40/AWwHJChAgQIAAAQJ0F/1Co/X9+WqYTjT+5jCxbNR1OzZCKFSYJBX8WzahKkbC9Jc/jQEQ3ux2Njv0KjH88oReOBax15xglAQIECBAgAABugRjY9141FN1AEz994NGKtV8xPJUctTz6w1ea6xw6J/I4oO5PhT+XRc6N/tjgJUAK/FDWj/4PoDYaw7608nBKAkQIECAAAECbFpE6+GTJgLwrxUfbp82M9esT7bwuVnGA6sqySR0DrLlB6Uen0PbZbZvTWb9WfqjSdsD0LY+GCUBAgQIECBAgE2HaJ3x5AwAfvb8nLKEmT69KdV6GFqjBbzVXs5fVlaAtvDne9WTEKCTYCXOILX2ewBinxvRi8YHIyVAgAABAgQI0P+J1k//PpO/jJwEwNq2ll3azNR169PtCCEIAStMg782VvBFC13wIMsiZqLYBUSO8w0w2wystp/pRRMOABB7zgpGSoAAAQIECBCg/xOt5c1rARg1v74iZaavXJNo3goBWtgarXAI3k2W8acvKsG0CpCtItourUtwhM+GCVaimnTT9/XSO8ogyK0VIECAAAECBOjnROtHT9fz/BkzuP3tJ0hZ6YPXp9uubM8kEQ6b0thKqHU6xNPrKninKYR/82Gp2qxc8DjUm21gJX5J6zvfAoLowwABAgQIECBA/yZaf/5uDQBPLX97YHsmNWVtsgVDCCc4UHQE/5WFNQvSZfxlZQXppM6h1fJBvnRX/Lt053+bbbthtZ6lP5q8OYD+INBqBQgQIECAAAH6KdFykbYyp6xNtnzXtKzOFEeAFgJhQMYQPN9cwUtryrphAuzOOcJJ95C8kPTa/wMQe89BL5kUjJoAAQIECBAgQP8iWlcuehKAM5+qG9qcap/elGpFCDuHlXaIlMbWbmkhKAvDEjPMY2vKWduGncUdTe9FIuZIfCoAs2UgZvvF+oPx2wCQWBeMGp+IRCL94hoBAgQIECDAxkKfleD5ZMEbALRm0petbl+/l9ceKIRA6y/dqlxTYjgML7VW8MzqNGdVpiAksvhQHtLVYxowAToFVtsPsMr/rD+74/di+EWm/nAcYo+gRE82otEo6XSa2bPtvonH4wBIKQcD2wNbA1sCg4ABnvFnAkmgFWgC1hiGsSIWi33hXgPg6KOP5jvf+Q719fVBZwcIECBAgE0CfVKC58fz6/jjyRM5++n4np+2rP7nirbGzQ1hZHEjm2kJt6C0pREWJNKaoysS/HrXVnYbYoEWvUS0dIG/Cyjb6m3Cg08Xe9+0JBg2nRGJRPASomg0aliWdSCwP7AXsAuwAzAMGAoMzkG0Eg7RagTWAJ8DnwIfAu8B7yilGt17SClRSgWdH6BPUeq4C8ZpgAAB+oRoHf23q3nxtOmc9Ni1D37csuqsjGXm5UdCgLBcsgXa0hgpi7HDWvjVTknC5V6tlu4hklWEaGkNRhWUbzmR8m3niN2nJPXCqxB7XR8sOp5FJBKJ7Kq1Ph74tkOy9naIVXeQBBYC7wNvAs8rpd7MR/ICBOiDcV8JHA4MLCJQ3lFKLQt6LECAgGj1Ks6YP4O/nDyJM5+qP/6j5hXzm5KtYZHnthqNcDVWDtESWpNKwz4iRd2uzXxzaxO00UWSlY9oFStM7fyvbOgawoOPFfvc8s7XedBkkxsp5SHAKOBI4CBgSC/dOgP8F3gNeEQp9XxAuAJsBKK1DfAgsBO2NjYbhvP9RKXUI0GPBQgQEK1eh9Zpcdzfav+xtHX1YboIGdJa207ylrb90TVgalIpza+2aGH0Lgk2G5DFhUpK5VCq2dBDtEQZlA+7m9DgK8Xes9u/blqtaDRKLBbzEq49tNYXAydia7DCfdichcAzwB1KqbedBTAw0wToC6I1HHgd2xxeCBcopeYGPRYgwNcbvbownj5/Bo+ePIkz5qtLVyXWHWppy2F3Bfhdh2O8wNZxgTA0oTD8pXEA1UPSHFuR8XjO9yTJcrmnzvFnAVYazJbzCZX/Ti+9/kWx41WW/jCK2CP2lR8okUikg2RNnDgxnMlkrtRanwccAJRthCbtBewJ/J+U8l7gbqVU69ixYykvL+9ECAME6Om9I5AucozlfAIECPA1R6+ld7js+d/w6MmT+OWLvxm6KtFU055Jii+lVO7/XJqDcL7xlOYxDPiCMA+vqmBFq0OGukWytE/i1ZkEYjYbmIkptH5YCUD6q5/uYcKECR1muUgkckAmk3kEuBY4ZCORLC8rPgSYBtwppdx7zpw5xGIxpJTB7A4QYBNBb8/Xr2OamNraWsaNGxf0Sz9Ar5kOT31yCk+MvJaRT/z65o/Wr7gsbWVKupfXhCg0YGm0CSJpEd9xHafvkMYw/F5Sl/C9LvBnh5yFBkL5Nr+gfOj9Yrcplv7gKsTeX00Totf3SUp5nkOw9uiHTbWA/wCTlFJPucI7MCUG6AVSsAPwCnY0baHxeIFS6rdBj/nu13Ls4JnuKgC0YRhpIBGLxZr9yLavGqLRKMlkkuuvv55IJLKZ1voM4DtAFfCJEOLheDz+3696P/QX9Irp8IfzpvPIKVdz7t9nHfx+42dnpa2M8ObJ8ksBXROixkn9YGhSYYN7V1ZxyObN7LqZ1UWu6IN46QINM9vAbJ1OiseBNV9VkuX1yYpEIlO11pdh58HqjzCAbwJzpZRSa/2gUsrM9isLECBAv8VBwB3Yefa6ZXa1LEsDppTSBNqBFcBi7OjltwYPHvzva6+9tuMeEyZMYNCgQdTW1n4lOtIlWVLKQ7XWdcBhTr8aQEJrfUEkEpllGMYt9fX1iWBTugkSrUdOuRqAFW1N9etTbUNdC5/70w/hEgjHoChceoMWdh3E/yTKeWplGT8fkGJAUcNVV4tSUzg5aqZxB0JVY/WCcdeIfWbrr9rAkFJ2EBQp5R1a63Oxc191B63AB8AnwGqgzenYSofA7YDtdzWsG/fYDpgrhGgD/hKQrAABNhlUAfs68qCnobFTxbQD7c3NzY1SyreAR8Ph8Ly6uro2gDFjxjBgwIBNOimyq6GSUu4L1AMnZB0yEBiotY6ZprlWSvl7pVQqGH6bENE6/clpPDpyMmc+XX/m+43Ljshoa8OS0DloiRBf5tHqpP3S9h+1cCiXEBhlcNeqKkZskWb/ofm0WqWYC7twmJWC9DpJedlv9Yc1i8QeX51s5VnmwoeA04HyLl7u38DfhBAvaK0/dgRdxvloD60NOeOxXAgxTGs9AvgucGoX7vk3574BAgTYdKDJnS6jJyAcAlcJbIFdqWIv4HuZTGaFlPJx4Gal1Cdga7jC4fAmSbji8TiTJk0KpdPpU3OQrOz1/xrgRWBJYELchIjWoyMno9sTxlHzr5uYyKQ29z3DdI6f2smt5RApjUAITSikWZEJ87sVFUQHJti8sotkKt/x2uf1Mk3llA1SYo8bTtcfjEbsfeMmPyBqa2tZt26dS7LuAc6gdIf3BPCAEOJOrfVCIUQiFAol6+rq/L6YZVLK94DfCiGGAWdpra/En6brz0DUFZiB6TBAgAB5UIad828IsBtwjpTyQaBeKbUye9O5KSGdTg8H/s/HobsBe02ePPnjadOm6WBI9A56NOrwtHnTADj9+Zk1qxLNe2W02RFN2LU9iOigOdoQtt+WszcpL9M82DiAd5uEz+DDXFGG3S1SbUKq8Qf6gzHHi71vRC+esMkPiObmZubMmUMkEpkF/LREkmUCvwUOEUJcFgqF/qmUaorH4wmXZEWjUV8XUkollVLr4vH4IiAGHIztiJ8oxPOBiFLqI4coBiQrQIAAflCO7XYwBmiQUv5kxowZwjHBbYrPMwi7tqyPZVZsl06nw8EQ2ASI1uVv3MzfTpnMBS/cuMPy9sbz01Zm4Jd0ZsM0Dv65lmNL1NpO9WDYvlpCCDJlIX7zeRVr23UXiZMfR/pCkYkCzGbItNwIIHabuUkPBikls2bNQkp5odb6EqCihNPfA06trKw8X2u9IB6Pp+vq6vT48eOZNGlSx0F+iU80GmXbbbcFIB6Pp5VSy4UQM4QQhwshns5xymPAeKXUYvdZAufOAAECdGFN3B34XWNj4y1SyqFKKSZMmOB7k9hPkMT2iS2+wmndJIQwg1e/CRCtJ/77HgDLWlbXNiZbdza1VYC6dCZd2eTL+33HcYIvHbeEQBsQDmleaKvg+VVh0mYhnyzt//uuKLgyq/fTH4y+EkAvHL1JDoRoNIpSCinlfkAdtmOqH5jAw4ZhHKOUemrq1Kl65syZHbvAWbNmMWPGjJLbE4vFWLFiRQcBdAiXGY/H39ZanwVM9bytJ4CrApIVIECAHoIALgH+IqXcY+bMmZtUfj7DMD4H3vJxaDuwsL6+Pkiu29+J1ulPzeDji27h7KfjI5a3NX03Y2V8m5tykqos8iWEoKN0j6PRQtj/Li8XzP58IKvaSkk+qn18XUJCUysJ6cZa/eGEzcVem6aflkfTNBfYyudp7dgOpGfGYrFVQMfOryeJjlKKmpoaJkyY4P7eBPwaGA08DIwNSFaAAF9ptAI/F0JsJ4TYpchnNyHE/kKIbwkhvgdcAdwE/NPR9JSCEcBjUsoDXFm0KST5jMVibcA87JQWhTALWApB8tLeZu3dwmlPTudvI+10Dkc/OvGxz1vXfi9lZToIUk/BJlpO0gftJjEFYWmSCRi71Xqu2C1JZZmguFrKjybLL3Fzc1aENBU73yL2veWKTXUwSCmvA6L4S+PQCtyklJoIfet0notMBQQrQB/OkyBhae/06wiHHAzM8ecWYJSbjLiriEajA7XWJ2mtfwqMxH/Kmg+B05RS7wOMHTuWOXPmbAp9eiZwI7Bt1qIlgAew3S1WBvKzd9FtjZZLsk6fN/281Yn130o7JMslR97Pl4Spy3QLrzcWhl2ep7wcbvtiEJ8163RhjtUdc2GRg7QpyDRepBeO3R9AL7hyUxFuOLuZ3YFf+RQ8CeABl2R56yD2BZRSTJ48ueP3yZMnB0IiQIAAhQgWEyZMIBaLtcbj8UeUUqOEEHsCNwB+6qjtATzgFBRnzpw5/dqM6GqnlFJ/Ao4FbsZO1roUeAE70OlXAcnqG3RL5fT9J6by2KnXcNWrcwe/vuLdJ1YnmkekLNPXRV1zoPenl6Bl/31DvqNB2xotLLDadNP1O66vOW2H5KxQmRjomyhpv1/6KkitqdzxWbHvHScC6EWjEXtuGqZEKeV9wNkUjzI0gXlKqe+7EzrIvRLga6Z5CTRavdOvva7RcknX2rVrufPOO9377osd2fw9H2viQ8AljvtCv04fE4lEsCyLmTNnFtxoBySr99FljdbZL87isVOvAWBB48dXNqXaD/ZLslwylf0zl+ZrQw2YditPu4wNLE250NN/ePojt1tJa96GoY19QbIAtCC9+mi9YMwZtt4n3a9fvrvrkVIeBhyHv1QOSwzDuNAVMgHJChAgwKaEWCzGnXfeSSQSYfz48Sil3i8vL/8RcDXQWOT0s4CfRSKRMvda/RXxeLwgyQICktXfida6dettwvV0fJ9V7etHpa3MYNEXLfZquITtGG+YvC/C4bsBMmkxLpOymr4kQ6WYKktxqM8Ds70Mc90MvWJumTjwVvQHo/v1RHRwCf6SgbYANbFYbGVfmwsDBAgQoKfl36xZs4hEIkyfPj2tlKoDxgOfFzl1NrDvJpbuIcCmRrROe3I68077NQBftDdd2pJJfCNtZvq25U66B5HRCENMNExrPUDVsU8uNZPW9doq4AyWk391l5B5/pZZuxtN/4oA/TZbvMc3axfgKIprszTwglLqz1LKQJMVIECArwzh8vg0zQUmA18UOCWktY5rratmz54ddGCA3iFaXzrATzthbaLllKSZMhB91+gOvy0NwuIvlmm98MHlc809bjsfgIwxsC6TtD7yz5G6WRcxG2aqnPTay/SHNcOhfzrGG4b96p2cVNv4OKXFMIyaYMpsiFLDomtqajbJdgNMnDix32wSeusZ+xtKHS9BmH7XyJaroXLI1mxsDX4+nKS1PnrZsmVBfwcozllKPeF7T07l8ZHXMOWNhyrnL3vzztWJ9ee2m6mOeoSijxiXRiNSut2wxDFLfnXPP9zvE6+cSuWRT9D+4kmjygeGHjLCwijMmUohWX4LUmsQ4TQVO9wn9rvjl/15AEgpn8Iu3ly4u+FRpdQPJ0yYUNTu/1VHTU0NmUxmg36QUlZiO/JWYBfJNrCDBzJAWygUaquvr89kL4p9qR3M5fwajUYNy7IGYUecljntdgv8JoUQbfF4vD3Xgt5XbVdK8eKLL/L44497nyXs9HcVdt1Ww+nrJNCilEpkPWdH0km/vil5Uon0ujN8vr510hNUaa3LnTGm3WcWQrTE4/HUxhxf3RybfeIM76ffr7766rJUKnUPcE6BdfIfQoij4vF4srfaU8zZftSoURx11FGMHr1pJsreGOhKAEN351GXWdHJj1137mdta2atT7UNy3/xXiRdlkYkdb1ImtOWXHlf6x53/JIPL7oLgOQzR1Bx4uskXz35qfKq0HcL84dSyFQJRAsBocGNVA7/gdh7zst6wRWIfW7ub5qYQ7TWvwf2KXKoCYxQSr1WW1tLbW3t13KCujtXd8JJKQ1ge2yN4I7YIeC7YPu7DXQW/wTQDHwGLAEWAquAZUqpxr5YEGtqakgkElx//fXeRW1zYAfs/Dq7Om3fAdgcqHTJIbAS+BRYgO27sqKsrOyzGTNm6L5ou6u9cslONBqtsixrR6fdewN7AsOBwQ5JbAVWO/38PvCxEOLTeDzeDDB69GhuvPFGl6SVF5GBaaVUKkebeo1oZRO7iRMnGplMZrgzznZ05upOwFDnPWlnfH2BnetpIfCZEGJpPB5fvykRrv5AtLx9JaU8BLgPOKDA4SOUUq/U1NRQX1+/wYL+9ttvM2/evJIW8uwx71yrwrKsgQ65NoHUdttt1zJu3DjAzutVWVlJXV1dwU2CnzHnd6z0RsRidzdBhWRg9vuRUg505N1ARxZ02rgAraFQqKm+vj7ZXdJVEhM69ckpPDHyWs55etb2C9cvu7Mx2TIyaaULEqqeJFudssWn9OKQxamLfzV3QfZx7a+PYsARD5N48eRvhCtpCFWEqvz7ZHXTId7rGiZCFuXDnmG/uacIIbR+70rEfjf1C41MfX09UsrLsTOsDy1yykKl1N5f1x1QbW0tLS0tHRqsmpqaAaZp7gt8CzgBOJLOCQGL4R3gOeB54B03q31vLIjZwkhKuTPwDeyM1ydgF+v2i1UOwXgG+JdhGO86Gah7ZSHPWny2BA7E9iccCRzuU369B/wNeAp4UynV4lzvYOBEh6DpPLLxNaXUvL4iWt53JaUsBw5yxtjJznMP8Xmpd4EngeeEEP+Mx+NrCy04AdHaEOeccw6/+93vkFLWYxearsxz6B+VUmcVGv+RSGSA1nqLHONMYLtkNMdiMZ1jDAxyNkA7OwR7e6cdSaDJs3lbqpRakC2zamtrkVJWOeMm1xhPA41KKTNHmwdprQcX6KKEUqqxJ8lW1nzfhtyuTQJIAU1KqaKO4dFoFMuyvH06BLuW5S6OHHQ3mEOwLREmdsWTNU7/LnJkyKfAR0qp5q7Iat8Vu898diZ/Ot4ugfJ5+5qzWtOJ49szKQwhCoq77EwLTm73Tj/9nJetXzEsVHmb+RHAvnf9kvd/eVfHnwcc8TCJl06m8qj5/02+fNJtRliPE4boIskqhQlmZ5WwDDJNR/DBFecD91CW7BcCzSNoD/FBsgD+1FWV61dBi+Vq8CKRiKG1/qZpmt8HfuJoU7qCA53PGGC+lPKPwLNKqU+dnXS3hZe7oHoEzHbA8cCP8ZcvKBe2Bs5wPh9alvWQlPKJHXbY4bWrrrqqx3a40WgU0zSJx+NMmjQpnE6nq4FRwHnODrQU7Od8LgDullLOVUotAg4DrsuzqLu401n4+2ScuUI7EokcpLX+HnAusG8XLneA87lUa/0HKeWDQ4YMeeHqq6/WzgYrCOsvguHDh7v/vMuZL/vn0z9Eo9HNYrHY+vzLgj4IkI6G2ItK4DFHvibOPPNMt97sAGd8ngKc6hDufMgA9zvjuxPRcvB/2FHlbTnW/kXAb7C11tnYDri2wCZkMXBdT46jeDxOTU0NlmUN1VqrApzlH9gllYrOKXe9cjZqhwMnORuXUhUH7wBPSSmfA15XSjWWIqt9E611rXby3B88Of2gpa2rzm7LJCvcJKPZCUf9aKXyFZT2cQGEqZ8Vln58wZj70jvdcm4nktUxgo+aT+uzI9HaiptJa1R4QGinrmmsukO+LLCSm5NpvEQvnvo3sds1q/UHlyP2/s1GFyRTpkwRzc3Nu/g8/Enga0eyvNGVUsphWuuzgYsKCN2u4GTn8xcp5R3A35VSme4uhl6thZTyROB8hxz2FPbAzjs0atmyZXdKKf+glPo827zaFZLV2trKzTffjJRyx3Q6/ROHkG7fzfYOAyYCh0spxzsL1PoiRCvRl+OspqamwjTNM7XWlwHf6YFLD3bG64lNTU03SCnvVUqtc+v1BZHD+eHKOqXUh1LKfzoLc671cqBlWccBjxaZKz/K87dG4K9A4k9/+hNSyr1xsrY7ZMfHimhHSE6cOLGT6dCzqct37/9hl+HJRbRWOAQznxZ1lZTycaXUP3tyA26apgF839lU5cPSXFq4AtqxI5zrnefMie5sji8EHpRS/i6dTjcopbQfmecr6vD7T07l6dOmcuP/HitfnVh/Zls6+e10VnLS7ISjvQZTJ4XFbxZffO9nAPvvskfeQwce/ySVR83/wsro63TGKpFklZiDK1diVQBtQqZ5fxJLRwP9gmQBNDc37+5TO9BmGMa/v26CNkuFfyB2FNLsHiZZXpyBXdB7jJRyqFKKCRMmiEmTJnWp7Y5Wq0JKORq4o4dJlhd7AzOBWZFI5Ih4PN4pXL5UkhWLxVyS9S3sgrexHiBZXhyHXfvtBPwl6O2TcSalHGqa5rWOBuU7PXybXYHrgWmRSGTb7hDhrxM8ebIexzYl5cNIgAJztZCJK2XvyEFKebSjYbrWJ8kCWAvcCuQiWWCbBwttJHQektIM3FKExJ8NkEqleqzPha2xubTAIe8Cv/fKuXwbl0mTJpVJKW1rElzWDZLlxRZO++4qLy+/qKampioej5PJZArKPF9E67GRdgb4Jxa/Wd2SSZzbmknaJsO8nEP3DvGyNIbJ/UZavwiw2+3nM29kbXEOJMTDmZT1cuchVWoy01JIFnSyzOh0FZnGUXrRhIMA9ILL+oMcGe5z4C2IxWKJng5h7s/J/rJI1pGOwDkH21myN7EtMAP4tZRy+MyZM3WpQiwSibgL92amaU4F5lDYl6incLbW+hYp5UigqODJ1W6Pmv84p8/P7KW2jsA2RQ7pD+PM8UeJA5Ow/UR6C1dorWc59wvSEvjUagkhnnUITT4cBZBIdE0BWlVV1S6lPArbHHZ8KWoH4BWl1Kdjx47tsed2SbgQ4q4CRK0SGCGlHNRTxbWd8bgf8O0Ch/1bKfVfyJ3V3jOnqtLptMSuZblvLwyPfbTWyjTNSVLKzWbPno1pmnlTsRQ1HboO8L947vot3m/87OzWdPsulrY6mQqLGQ0LkS2v+bEYjIxeKkweWHzZvWsBFl88t+DxiZdOofKoeSSaUq0DNi+71kxbz4UqDIHuocjCvGQz21fLBKttL1KrrwAuEvvcgv5fLWL/2o0pR7bGDosvhvd7Ywcci8WYPHlyKJlMXoC/QtY9CQPbOfr97MmapXL+P0f4HdyHbSt3dkxVUsrJSqnP/ZoRXY1QTU1NpWmaMWzfjL7EIcBNUkpDKfV4KfmuLMvykqwbKBzp1ROo2JiTz5NqYhCgKGwq6Un8FDCj0ejFsVisPfDX8kU8mqSUnxZYsHeLRqMDY7FYaxcun2xtbT3A0WIdWOK5aVfrVFbWs8pZRyu0REr5d2xfsVzYCdu8+GB3x5En0vOCAod9jh3YktP07blGBRB1Pr05zwcDESAspZyqlGrNJ/OKEq0nRl4LwMfNK49pyyR/2m6mNvDH0j4JV6kkrBMhs0Bo5la0iTcAdr/jQj666O6C51QeNY/EC8dQecxzOvHiya9ZGX2nEdYXCaObJKugJivPNax0iMz6U/QHV5wq9r75CULLN7b8GEL+SBovlvViG0LYDsnD6DH1oi+Esc1G7+cjWZFIZF+t9Q19TLK8RPA8YL2UslYp1VTMp8abdsM0zRkbgWR1LDqAklI2KqVe9SOAPbvQQ4G6PiBZGxU33nijN+/RtD4kWS7OsyxrubMQBfBBiIH/OpqrXJvCMq31PsC/unALS2t9IbaWtVR8oJR6rjc2wqFQh/L++gJEa5hLtLpL1p2EsQMty/ppgcMWGYbxeK7nzfITuxIY55NkfQp8gO2nlnDWhsHY1oW9gK2KnF/m3GvFhAkTblFKpXLJ6oKmw5FP2IL7jPnTd2xNJy5sTrUNKrQc6qxPj8F2gP+HyIiHF4ydm9jqhrOLkqwvR4yd9Lzy6PlJbXGjlbZW9QjJ8n0N9zsLrMRw0o3n60+uHyz2uX1jmxCr8BcM0dSLbRAO2StzNDl99THIkTvMNE134R+qta7DjvwpBcudHddsbDOQdIjkHcCrXSCDvwJ+7hFEeQ9uaWlx234ZcEUXBu4b2P5geG08AAAgAElEQVRBv3baPRHb9+pRCpcjyYV9gJiUchvX8brQTtYhWVthO9d/u8R7fYwdtVXvEIcItvn1D8BH/XHxXrJkifuuznfecanPew8wAfgZdmTiJc4z/53C/kBejJFSnuH0fcCo8sCzeC8if3CE1lrv3sVbHIvt/F2e5+//xs7lNdPZhMzGjjJ8GTsqtldMwG4wjRDiJez8bPnk90GOA3+X4VabsCzrZPLX3G0GnonFYskxY8ZsqNpLp905NQoYCwwqctsXgNHAL5yf0iM/xmH7dJ2LXfvypSKLfBlwnWEY/3fNNdeIXLI670L7w+freeTYGn678OnQnf979qSWdOLUpJnBcMrf+IkyLOK55HspFqbOYHL/kkvmvgOw3WZDWO3z9MoRD5F46SQqj3oKK5FeKIxwnZGxZouw0XWCpbuSa0uAToPZejxt7/0EuANzo6Z7COPPRy/Vy+2wNtLzb5dLm+XkL/o58IMSrrXAEYavAZ8IIVZXVla2TJkyRUspy7CDDrbFjj46FTsC0I+/VxUwWkr5tlLq+Uwmk5esOG3fzyErfu0IGeBBh0wtFEKsEEI0xWKx9LRp08S6desGOju64dhh4r/Ef0qL7zik7ZJCu23P367AcSr2if86hONNYCmw5rjjjms75ZRT3Az9Q512H44d+v6N/qQhkVIOdwR7lc9TP8N2lH4eWKKUWpk1BgZorYc7z3kpttN/IVQAcSnli0qptQGlKoqlRWThDl287jfzLIvzsJ2+/wcsNwyjxbIs0zCMsFPFYShO8eveCmyIRCI89NBDiR//+Md3Ygel5MLOjqyMd9V86JIk4PJCm1ghxAMAAwcOzCf/9qJ4hHIrUAs8oZR6v8Bxnzgy5ikp5ePYwUpjnHVD53hnQ7TWU5PJ5A+BVZ5nKky0mtba6Rz+sOiVPRJmanRzqr2TA3wpKR38kK98NEWYgMWToQyPAOx62/m8c/5tJd2z8ig7x92AE59LJ1488RFT8NNwmMN6xlRYTJOV9Z2VGEKm6cd60aRnxJ4zlmzEjPGmT5YZ+ooKziG5FnwhxF5a66tLuM6dwJ2GYfwnFott4DiqlEpjZypfDbwrpWwAnnAI0WF5Jq0XuwE/l1L+Tym1Mpda2vN7KRF6HzgC57nsRRtg8uTJGjtJZAvwsZTyH8B8R3tyqY/rG8DpUsq/KaWezCWEPQLyWOyoSL/+FDOB+yorK/83depUy9PX7s8Etsl7WTQa/adlWS84RO58Skhp0xvwBDdMdoi3HzwJ/DocDv+3rq6uY3d23nnnsf322xOLxXBKJC0CFjnvagq2P1Yh0u2m6BgfpHsosk0WYpXWupC2cGgXL5292W3HNic/pJT6qIB2Z7mjwek1Hzs3etipHjItz1jaDNspfo4j60rGzJkzkVLuDlTn42LAa/F4/BOAGTNm5JN/FzsbwnxYCVwcCoWeqK+vT3s3Prk2RJlMhlmzZqGUWjhp0qRZmUxmqdZ6qiOTc+FIrfVpUsr7lVIpb3LgnBqNkfOm8NyP6rjw+RsHNqcSP25Kth1oaSuXvrTDx6o70YUFz7T0FyKjf7/4sns/B1hyydwu3SPxol2Jp32tXmpZ1Jspi55JWl/KcwvQGbASR5P6/KfAxizLk8CfmWGzr6jsHOBd8B2hNUBrfQmwpc/+u04IEVVK/dMlWfnMe656XCm1Uin1qKMd+muRfYaLUcDRuXavnrafjG2G8IN/AGcrpR50SVYh85EjzFNKqbeBSUKIcT41kds4u8Cci0E8Hue6664LOYRgL59tvwSYppR6Z+rUqVY+s8mkSZMYN24csVjMctotsdNFJDbmoJszZw5Syn2w/V78bGJ+B1yolPpHXV1dcty4ccyePRuA+++/v9Mi4faFUupTbPPJMz7e0/nRaHS3gGQV22Pr1iJ9OagHbtMMjBFCzHZJ1vjx4wu6DPR2IEM8HkcIsQL4c4HD9gGOKST/CmnNHPyc/ObTtc482MBM6pF/x2FbC/JZadqB85VSj7okC/LnhozFYsyaNYuJEycipWTGjBmZeDz+e2czu6rAI0Vxovm9Wq2cjXryFNsB/qP1K/ZpSyfHtmYShbO/e8hWT6dzwNKPDUyE/gZ2OoeuovLop2l56ltsccbfLSujX9amfgizBE2WLjUHVwGyZSXDmC2j9AdjDwfQCy7dGLJjPf7MgtvzFUc8Hmfu3LkIIXbCn8+MBmYKIVQ8Hm/0Tvh8E7eurq6TkHBClCPAsxSn/AOB70Wj0W1ytd0zwf2Yod4Dfq6U+k/W4lxQmEciEZdwNYVCoZuxfdD84CAp5enZQti9b1tb2wmukPaBKwzDmKuUWucSw3wEYcaMGcyePdv7fOscLc999G3gRa5F5SKHhBYbY38XQlyplFrxi1/8gkgkwuzZs3Hr2xWCU0fzIeyEmIUwxLKs0bkWsQCdNFqJIkSrJ6LbJhuGcW88Hk+472PWrFkbPVG01toECmkEdsPOuF5yWz3z9xcFDvtQKfVMrvnu+f0HFM72PtYwjKe8Gis/qKurw+tnahjGPdj+n/mwJ3CUlDI0a9as/ETrFMcB/kfz64ekzMyla5MtW1BiFvfsPFpd0nppEBbvhzLi9++NuacdiqdzKIayKjuAYMAxz6zUGX2rmbZafOSmyCMDuyGrtQlW8mDSK8/Sa/5aJva5Ff2/2r6eP6vYsCxDLuxRTOOxiaKTZuO9994r11r/sMCuyovfCyGud8w1vrNs5ygauxDb6Xylj3uebFnW/rkWxGg0ejB2mY5io7lRCDHGrYvmzXzvp+2uwKmrq0tjO+U+4lOrdVa2EPbc9wT8mdDmAvfGYrGU60Dvt91SSsaPH49Sqk0IMR3bkXijEPpJkyaVY+dKKrYwrxJCXByPxxvHjx/PsGHD8r6rbNIppfyOlPIu7JQBxZISC+AsN/FigLxEK1RkfnXX1/Qe4PdezXh/eR9KKY1dgua/eQ4xgEMdv8OSIaU8pcCGvhmnBFz2BsO1EkgpD6OwyfAp4M+xWMx05WdXCKGjIc8Ad2NbBfLhbByLiUvoNiBa806tRWstVrU3HdqcarswZXYuGq09/5VKvrJJWL7vtdZgaU1G//XjS+59HmDPOy7s9oCpGDGP9hdt60omaf5Lm/omK61LJFnFNqF+zhFgtYOV+DEr551ov4llfT1/Psf2vymGbxTTeHT3tWwk+dGeRSDLsaO4imEBcG88Hl9TCsnK1hBNmDDB/fU/2E7jxTAMOHTSpEkh935uJmrLss6icCkZsLWXf4zH4393292Vd+qp75UWQlzlCMJiC/n+UsrdcgjYvYFDfdx2LVCrlGotpMUq1N9uuHo8Hv+U/GVHeh3pdPpEH9qsjEPkFwMMHjx4g2f2bnycyMFKKeV5Uspngb84Y3l3/PmkbWma5k9L2el/3WBZVkURotWdyKaV2CkSVrvvoL+UO/Ns6tqwo6fzYV+cAAy/m3LPtS8mv8lvrWEY9wJUVXVW2HuCg75D4WCXuNa6y/K6Y4EoL3fn29vAiwUO/R5O6iT3PXZ6uJMft7UqpzxeOzRlZa5dm2op6PCuu6mBz6vpstM5vBZOcw/ANreewyK/6RyKoNLaGYCqE59rMTP6YZ3RC0ojWT1RkNohZGbbDmSaztIfXrO12PdO9Pt9l+7BMIzFwDofh24mpTyol5qRAW7DLiFxSw99rsfOZ2P6EG54wtt3IEfKhxx4Win19+5O2oqKCnfSpoGnnR1jMRyWTqc7dn4ep9CTfBDW9djh4d2uc+cStHg8vhQ7JYQfklidQ8B+A39Zm+fgOP96CGrJBNFz3z/47O8eg7v7Bo6keEWGFsMwbnAXXU+B4A1MvdFodGcpZR3wljP+j3WIXCkZLMuBq7K1jgE6YTCFferWd+Pa893xKKXsV+/AlRNKqQx26pp8VpBtcDLkl6JtdtwhjstDYlPA/Fgstg5g2rRpG8ihmpqaSkeO5BvvrwL/mzlzpu7KJs2L+vp6xo8f7/7agJ1qJReqhBAHRqNRw6vysynYvCnM/14t5/19TlmbmRrZmGw5ytSWr7xYOuu/7kJovU5k9MNLLv/tIoDhFT1XKUMcey+JF06wdZKrw/+xLH2TlbZ8kCzdgyTL2ejrFFips0kuOwlA7HtLn02gWCzW7mi1/ODYXmqGiR35NgHbWbnbH6XUWOBtijsaf+b5d8gVEkWw1LuT6c6knT59unfn9zl2moViOBg7TUQHotHoTj40JCbwolLqk+62O3vBNwzjJj8aE5z8WDU1Nd777539PHlwvxvRFA53PWjQs2i0YJsP2/pqvnnq0B1KYV86Dcyrr69vc4lPTU0NbokVj3nwaCnlw5Zl/Qs7788+2A7ZpYb4ZIC7hBA/D7hUQWxXhLx2R0P6mlJqRSkkpS/hbm6EEGvdFAv55JNTo7TT5qDQxsOyrPPIXxmk1d3I5dO0mqa5G7bmNh8eVEp90VN94fG7eqvQ+qm1PtSyrI41qENqPe44wC9tXTW0PZOcvi7d1slkmEURilCJDYmH8Dv/NWDSUJU27gDY5daf868LerYQc+Uxfwdg6x/NtxLPHveMYYSeJqS/m7+JPVCyJ+exAsyWckTZuXrh+DfEXrMW6fcvRex7a69OnPPPP5+5c+fiEJJTKR5ZeDZwQ0+GgEejUXeH0t4Lj+gn1HppFtHykwH+fUdbRk/0hScdQZuU8iUfp+zhPptrXrAs6wCKZ/hPCiH+5u6Ye0KYu88ei8WWSCnfxvYRy4cyVxi64c5SyirsHDzF8AyOQ/e4ceM6zu8qPM/f4GjJdqePMHHixIpMJrO1DyHRSWPqPnMkEhmktT4PO2L1AGfcdjX9ykeOBux3QJMQIuUdVwE2wPAiRGtpF6+7LmvT1+/glvcJhULtmUxmLnYwRy4chJ3h/p+NjY1+Nx6/yDOGNfCuUupNd8ORBztjlwLKhxop5eU93CUaWwtcqPD3Qc5zpTs0Wic7DvCnz5teqbW+bFVi/fBCdKorruA6x39eUtbxnaWXiqS+e8GV97YCfHzpb3tl8CReOskmXcc/t8jM6HvMtJXJ/ci6B3sh12UyYCVOIvWFo9W6tdcnzn777ef+83UKh6q6OCwSifRoCHhvCXMp5R7kzy6cTZo8jBc/2Y0/7UmtEMCVV17p/nMNdm6rQjAc7ZC3//aguJkohZOZvid3zJ5dph+SuJmU0kvot/b5nl5x2t8tbVY2uTUM4x3wnfe4R5DJZHaieF1PDbzrHWORSGR3KeWNWusl2LU3D3EEfVdI1hNCiFMconaDUuoLpVQyFovprjgJf9XhMfnuV+jdCSEWdvEWK9yNRL6CxBsbLimqq6vT2FniXy2woToiGo1uecMNN/iR1SMcopRr5W0XQtwNkCsTvAfDisiRHRzZ3pOffZwNWiHN9E54LIYGwPxTa7l78Ys0Jlt2WpdqndSWToLPVA3doRobONRrEBn98tLL7/szwK63/6LXBo+bxBTASljPYun7dEb3PJEq2lMCzBawUhfrBZcdCqDf790yda7JqqKi4mVnV18MIa315e4uuz/Co6o+qMhOwxWMb3n8Dw38ZXb+oqfb7cly3Aos9nHK1hMnTvQusNtR3OE5E4/He7wcjWdRfs/H4VUOuXKxBT7ylQkh3hdCZHqS3DptX4G/YJCexFb4iGoVQnxeW1srpJSnSinna60XYidc3cohV6WaB9diR4nujh0G/5RSKqGUMr3yIIg6LKh5OZD8fpDJ4cOHd5VoteI40ndXW9ub8Mj99dgRwPnwTcuyDs/aiOW71vnk18Y3VlVVPQCwxRZbFJL3W1A8h5nohU8x7LAB0QJ46L1nB1hYU1a2rw9lZ4AvRh16pMahBmHyQSgj5gDsfsf5LLn43l4fQMkXjmfAic+tNlPWH7Wpl9ldWMxU2JVoxFxfe3rQbDuAdNMP9IeTB4p9b0NPmdrrE2fatGkmtgml3cdAvSAajW7uRp31Y6J1OIVVyQCLtdaNWQtLMQflBL1Q99EjXFPOglgMAzKZjJdYDaJ4KaXm3twxCyH8ENBw1g6wAn9FzVcIIcyebK+nH1r7eJhW+dBCCa31Ja2trR8Cj2MHOhh0Lb3yv4UQFxqGsZNSarxSarFSytRZQr0/+gX1J3IhpdyZwr6E/xk9erR2o4BLRAYw+3tfePwbU8BzBWTV7thRgHkzrrsFpLGT9obz9MkfamtrzexgkBzyvqqfdlmn9cQAOG3eNJEyM99a3d58lqnNHHygtESkXSJdmoRIW49/ctlv3yR6KB9dNLdPeqPimGcBaFodetYy9f0bOMb70kqVSMo2SIAqwGoFK3UlyeXfBBDXXoNecHGvTxzsUHA/Wq3BlmVd6wrm/hQG7grEaDS6LbZZpdii9FzWixE+Fn0T/wV7uwILfwlkyw3DMLIIS7HnTRXbNHUTfrKtG3Q2cZbhLzIuUVlZ2bM16r/sh1QfD9UyH6TYwC6Ls1sXx1AL8EfgO0OGDDksHo/fE4vFWidMmOCtThCwKB/4+OOP3X+eQGHt6wuwYWmYrxo85GYNdmHrfDjCqTu4gQXEsiz357kFNrdJIcRt+chatjzsp901wCuXDYCWVPuAZCZ9w9rk+qICKjsPVimkK5fmS7v/y+j3y1OiDuC7x53dpz2SePEEthn1TCadMP+sLf3PvtFi5TjWah6CbjtffzBmGIDY5/Zef3al1Ot09lfKhxBwsVO4mHwFjjfmbsuyrO9S2CnbxRN0TjDo1vUrtkhWuLuyXkCI4v47AAnLsry7oWKlQTp2fb3lf6O19lN+xDQMI5FF/lI+rl3V1tYmerK9nn7o6xxuiV7QXljOBuAjYCqwt1LqLKXU61dffbV2F7qZM2d6zWABimDSpEn88Y9/dH89lQIBNkKIJ78OfeISLaXUeiHEnwocejh2HdcNzNEekn9OHm2UBl6Jx+Mf9YCbirt5TfbxJ40d0dyx2Bsjn5wiQP/0i0TTwdohYLqPKlR0kC1LrzVS1h2LR9+3BuDpk/rWNFV5tB2FWHX882+SNh/SGctCuOTKKkIXc326cg5gJcBMnE9mzeF9qQnCDqFd4ZOl33bdddcZs2bN6hcmRLcN0Wh0MHAaxVMdtAshnneyHXuHYrE8OOWusO1JwuJxtq3AX6qDFiGEt3hrsw+iNXDy5Mm9ufPbyccxKTqb6hL4iDgVQmzvZOXuDQzs4+HaTM9pRTPOmH0R+ElZWdm+SqlapdTn48aN65jbgd9V15BMJl35cgSFk2GuLCsre+Xr0i/uJtMJzHgmz2GbYTvFV3plnDsmI5HIIdgO5SLPuL6lhLFbaLO2CLs02UXYNVL76nMxMBpPEtvw+kRrVZuZjDen2unkm+Us/oXSMuTTahVKcpqLbZUlK5b8uPWWh9bMqh9qhTGMcBnCCCNECCFCYBigtd0WQ3y5NPoox+vzMADebB6QenFV3UvfGPbfl8p15hiE0L2ryfK20Pl3RggzPOjy1f+Z+NZWB9f1ativx+7+qJTyMh8LvQEc0d7ePh2Y6JZk2VjC3HtvRxV9oo/THtRat7tCwyFNGliC7fBaCNvX1taGamtre0wr4dEyDMZfYeWV8XjcO5g+8bF4h1Op1IE4qSl6of/9pMZoC4VCXhN1Iz580rTWB2CbtzM9mXogEonsqLXu64Lpy+h+Ues27EjhZ4DfuDUrve/DLTodoPtyBTuVRqGNxP3Tp0/XX5e0GO4zhkKhVaZpPlhA5o6wLOsbwBuJRKLTeuOkKMlnNvxcKfU3P9o1R8NWaLOWBB5SSi3fWP3lppMJN7U0b7EmuT5slIk8NOBLme43F5bWGiFEx89CpCScqrB2Wn3UzsvKPn1FCxESmXLb81OAcF1AhUv68nBg3TNE68DKdnH38vGZQavXbTkw3JrQWmi/98hxP539R+2v7ypCmfUDQ2Z72Enk3VdCZZZDNIqRrTKt9Wgp5f+UUg94SrJsNGEopTwcuIDi+cAQQtztaoQ8gtHCLq1zWpHTd2ltbd0XeLcXBOtwihfwbsETCu440i+iuAmuXGt9LPCvnnxX8Xica6+9VrS3tx/t4/A1M2bM6GhnOBxemclk/GhRjwFiQCKdTveY4NNaH4wdxddnUEqtkFJ2JdLRxA7EWIKd9+oBt1yLdy4E2queWRg9cuW72HUp80X1aiHEXVmy5GtBROvr69NSytew84ftmOOwg7H9Zd+YM2eOVyNWZlnWKeT3ib09B9nNSbQcrHXkYi73hd2cNWGjES1X1obf/dktn213yzlTCAlVzE3Tj5YrW9vlJV0bLHpaMKBpWyO0fI+tVgxu2ypcNRghhE2wDAFCOKRFO//uWlyjLuU4bbGSgfhzOymirCpw71znCCHIJNppbxtw45v3rf20LwZCPB7nggsuQCn1lJTyaWzbeTFTTRVwYyQSaVy2bNkTbhmbviJbXmEYiUR211pPwvEJKIIXtdb/jsfj2juRnai21334He6H7X/wbk8IVrfPpJRDgJE+TlngaDM6ohVDodBbpmkWy3BeAZwOzOypd+S2PZFIHOWQxGJamP+BbUaoq6ujrq4uKaX82Met/k8IscM111yzfurUqd1OqOl5/hE+iG2PwdPuRc5Y9WMObcNOKfJv4G6l1Dz3D+PHj2fw4MHU1tYWJVjZZsSNqYXu7wTClQGRSGSo1loCuxQ45S/xeHzB160/Pc/qVrTI50NylJTyr0qp5a68sCzrTDqneek03g3DuCfrHsWwCjsfXq4FexB2+psPNnafGQDlhnGLSFsf+ickpZXbybeAhdsr2WLFIWAIdDqN0AJhhMAIIYRha8OEQBjC5V2+PmT9LHp8h8bO/j0kNGHD8vUJiTzfFzg+7zmkMcz2hysyjS+zaj/ryPEf9ckgGDbMzvdmGEYN4DcfzBZa63u33377M6WUYaUUXt+Q3sDEiRM7EbpIJLKn1rrOhybKRb2r/fFO5Hg8bgFv+Hlm4PhoNLqZdwHrDlFxsCvwEx+ndSr74GRKb3YW70J+WgI4UEpZUtHXQu/BbbvWepwfbZbbv3V1dd70Cu8DfjYUl6RSqTLoXhCG+9xSyu2waw72WcSShxy+ir+6eM3YNR5HKqVGuSTLHXOzZs0qWubEK3/j8TgTJ040SlzEvjaoqanBsix341Outb4OKKSpzQghprvpCr6OUEqtw67TmE/2HAvsn7XBGeXI0Vx4LBaLfVGiXP20iAw51qlC0WNrU3YwlJ+0OQZAWzLdLixqhFl6aoau1jcUlmDwmt0Z0L492hBoDVY65fhlGV8yJbSjyfKnkdJZmiRdVAh1vcMLnZvLXFn4XgIzmWjTlnnHqzfsuwLglVl9Ux2kvr4eJyv0cuzIJb/5orbCdqS/XEo5ZPbs2fRWni0pJXV1dR0TVkr5ba319cCZPi/xKHa9P9PbPo9zZxNO6ZMiONGyrDPcBasrk9cV6s5zDMZO3OenbNA/vCajzTbbzPtsySLnDsIuRxFyfeu6CteEJ6U8HrtSfTEsx64tiFcbZxjGW/hIdqq1vsSyrP1dgtFVbYVH2P8MOzP6xsDTOObfIlgthIgrpRaMHj0aN0dTqYu6R2u6ZSaTOVNKuUs28Qw0WRHq6+uZOXMmUsoKoMaZk4XSj9z18ccf//vrmknfM3YWYed7y4VtgcOi0WjIOWcvbHNiPtvZzV0Y40sonOi5g9j1FCFuamrqpDzylMjKT7S2vOFMVo15UFeUl/9VpK1ns32KuqLl2iDjew6UtQxmi5WHYIW17ewuBGbGdBYgN/mx/dE5TJW5kqWWSpK6SrKKnatLJVlCoM00ViZzd6q56U2AERMW9+nEicfjXHXVVSil/oCd+devw/dmzs57tpTyQHch7ylB7g5ezzUHSynPAu7En7kNYK0QonarrbZqz9pdeTUNKeA+n+Tyl5FI5KCukC0pJZlMxksYvgdc6ePUd4H/evvEo9F42MfibThanLFdJYmzZ89m3Lhx7oK0A3ADxfNCJbGL5q4bN25ctpbnU+AfPm5dDqhIJDKsK+Mqy5/vMGzz+GA2ApRSi7HNqMUiRXfWWt983XXXGTfeeCNd8U/zkKywQx4eBG6WUh4rpSzvyXm6KRMGz9gY4vTTBApnG/8YmLrzzjt/bfvNI0M/Ax4rcOjJlmXt4fz7bPL7Rb6rlHrloosu8t2Gs88+G6VUK/BOgfm0H3BMJBIxemKsRyIRbr/9diKRyM5SyhMjkcjBbnSlO47Gjx+/gbbZ2GaIvZFOrG83heZakdEb1PzrSub37BqGnTRfGcEWKw4ibA52SFYIRAitwUyl0F6dkMjfhpLKOevuE6xihClf/2gfajUzlVxqppN/eP03BzUefMlCXp65W59PnooKO63QgAEDJPBIKQpKZwf4J+AiKeXu2YSmlNxT3mM9fiVlUsrvAL8G7sHOl+X3TV6ntX4vGo3mJRdKqQx2JJef4rBHaq0nRyKRXdw2+pnA7sI3c+ZM9/dTgJk+n+FJZ4HutDMbN24cSqkVFFbhuxjgaLVGedvtSTFRsO3jxo1j9uzZruntRhyzQBEsA+4FqKyszPWO52EXNy+GE7TWV0spt3THlZ92Z5GsnYDrKB5d2muaEwd3YhcTLkaMf9LW1naZO5f8LhLRaJQJEyZ0mMGAywG3YNypztweI6Xczb12fy2t1dvvwkM298UOuri6CAlPAuOB5aW8k68qSXXS5LyJ7T+aCyP4so7sCQUI7A0AW265pe/7e4ju6w7Zyoertda7dnesZ/ninQ08rrV+wLKsiJTyOCnlNvClWd87Noz3f34b291yDivGPqgx+acw9d2YugiJ6nq5Ha01VU3D2KxpX3RYg2sqNMJoDKxMBiuTtrU83RwIXnLli/B0k2R1SWsmBFY6hZVJ35lc/dlbAJtvXrZRJk4sFiMSiTBlyhQTuBQ7sWcp2Bs7B8pdUspLpZSHRiKRvMky3YUy28btPVZKOUxKeazWeqKjac5oZwAAABu2SURBVBvLl4nu/ITBzhVC3KuUSo8fPz6n+tgz8daWQHzO1FrPlFJ+M0tg552knmPKpZQ/cfrKj0P2EuBJpVTbhAkTOv2hqqoj518cf0WShwI3SSnPl1IOUkpRV1fH+PHjcxIXlxB52n6gIxR/6ONeGeA5NwWBN3O2+46dhLnP+BQno4FfRyKRPcH299p9991ztjvbAVxKuQ92ZO332EjwpFN5DNvfrtgzh4E6KeVFUsoqj29izoNramoYM2YMsVjM1ToOc0hBHZ390YY44+UGKeXJV199dai/ltbqSeTZwG0npfwZcDd2vqViwndWOBx+VCmlXTIbaLX4EPhrgQ3DEVLKc7ALSOdCkxDiz1BavUfPOvG688mHfYGaSCQyxH33pZKtiRMnYpqmK0sOAH7kzKn9nc3/g0BMSnmOlHJXKaXhHRshgJYnbDLY8uQ71uBTD/pQa35KWAwoteP9rHqhVJhtPjmaMnMIhEIIIwyhMMIoQ4gwAoEWAjuXllHS/bUdnEhPVxrRPnJ1defiZjLxr3SiNfbGrYd8fuS4Rbw8c/eNNnleffVVd6fSXl1d/ZKz+y+1Qbs4O+cjgF2rq6u3ra6u3qy6ujpUXV2dbmhoSAO88oqd58/9KaUMVVdXD62urt61urr6m9XV1ScBvwCuwo6aKzUc/wkhxNh4PL4G4Nhjj+Xll1/O+cwADQ0NZnV19afYTpzb+bj+fsDB1dXVurq6enVDQ8P6hoaGvP3qPOO3HYE+leLJVV3cDPy+oaHBHDFiRMe1AF566SX3fa2prq7e0tlBFsMgZ3c5uLq6et2RRx75xcyZMy33PeRp9w7V1dU/AGbgL1+ZK4CvaGhoWBOJRDq12yUMr776KtXV1cuBb/sknd8G9qyurm4fMWLE6scee6ytULuj0egW1dXVpwFTsGurlYJ/NDQ0zMv+srq6ejPsdCJDioiFvzY0NPw3zzMvww7iKCZny513VVVdXb2moaFheXY/unjllVd44403kFIOrK6uHgFEnLmTz+l/L+Bk0zTD1dXVnymlmtiIqK6u3hk4N097U8AfGxoafEUIRaPRDcab+/u0adPEoYceum91dfVIh7wXiy508VshxKRYLJa88sorGTJkCC+88IKf5zoA21con8b38YaGhhW91KffJr+LxXLg4YaGhrXduUdDQ0Oqurq63BnPuaotbObM213yENm7lFKP5JIRfrVq1dXVJlBdYE5+ExAjRox489VXX028+uqr1NbW+np/jv8yr732GlLKrR0ZeFLWYQOxU1r8EDvw5/2GhgbLu2MCYPtbz+XzSx9ApMzFRrkRM00dI2SLC78JSHURAqa1xeBVuzGgbQcIC9tkaIQQIkxH3VQh0BkTK50iVDEg71V1qXlB+5Bg+W6DEFippGWl079tmL2nzXbLN37pJk+6hs+i0eillmXFHAZfKg7iSxPfB9iOk59JKVdhR1WlPIS/ypkkw7DzsuxJ8bQBhfAUMDYej3/uCt5Ctcg8auEvsM1LD+GvYOnhzjM+LaV8Htu5e5kQoklrncHOF7O1I2S+6UzQQ0t4juex8yalpJQFUxuEQqF60zSPc9pUDAOBccBJWuvHpZT/BhYLIVYB7VrrELA5dhX6/YCjgO/jv2xNO3CjUmphPk2iR8PzjpTyLuedb+7j2icD37Es669SylecsbVcCNHsFEx2w7r3tixrhKPFGko/gOeZn5VS3u8s9MUwwCEDx0spH8f21fsEWCOESAghhNZ6kNZ6a2AP4FvAD8id3ygbWwHTsOt/LunHChSNne6iVG0H0Wh0kNZ6K631cGCXdevWHeAs/P9Xwnh+UAgRicfjLQADBgzwHfX5VdcSOn39Dnagx4/yrAOFSMRdXl+5LmrV5mM75V9e4F5Ry7I2l1LepJR6r7a2lhNPPJHDDz+cadOm5V0TcrgejCrQpCZsf9pMtmoagM8vfcD+OebB1La3nPOgyOifaUPsbxMHvwlICxASAWWtA9nii2+iDZtkGSLkrLG2M7xwIw21xsqkEeEyRCiMQKN1H81mn1qxbpMsQJsmVib9VKat+TGAIyd8xCv1/cPB0rVlx2Kxj6SUV2CH6F/UxcsJ7JIL+/RR8x8XQsh4PL7I3fUUiw6Kx+OuX4sViUSe0VorZ1L5wQBnYfsBds25T7TWjc5kG+CQxz26oJH72H4VamGWUMn5rurr69dLKcdi++Bs6/Me+zufJmCh1voLhySFHOK7k0OASsX9pmneAhAOh4sSXK31XCHEQdjlK/zkmNocO3rwPIfcfqa1Xu9MzcEOQdybvq9n6HtxMgzj15ZlHeyQWD/4pvNZ7WgLV2ut27XWwnnmbZ1nriyxSb8JhUJv9vM1vRw4zzHVh33ImzLnnEGWZW3pzMGdsJNYDirx3vcKIa6Ox+MrszZlX3t4XACWSimfy0O0CpGGlwzD+F93ojddrZaU8laHQH+7wOGXAHtJKX9nGMa8WCy2/Jlnnim4KaqpqRlsWdZ3tdYXOhvlQqa2GcAH2bklOw3YHW49h2WX/o5wu/V5ukrU6wz3UybsNOeeBKSdlTI+iZdlsuXygyjLDIGwsEvrdHwMT0oHh2tZGaxMipAR6pPKi97HykWWdDc0X/lkgZVONWWSiT803LTfxwCvbESTYb6B5gyWFVLKCHaEyVUUrmS/MWEB9wshpsTj8cVZO66iGDRoEFdccQXxeDwppbzJEcznl9iG3Snd1JoLq4FpW2211Xw/wt1DFF+TUo4HbqO0yLohRQRUKXjUMIxrHeFXsP89YywVjUZnaK2311qfXiKJd8niJrM4OZuYtVLKq4AHHK2hX2xFz2W1/yNwTX19fbqfE4gK4Fd9fM/1wC1CiFnxeHx1QLIKb5awI4jfwk7h4Bc3WG6um24oBZyf70kp49iuFoU2mscB37Is6zQp5RvYwTifAmsNw8hYllXhbOR2BPY2TfPbzmZo+wJ6F4Ed2HOfUiqVvTHuxMyWXfo7ht1wFp+N/0MGzTPC0k8Vi2PSWnf65G6FxYCmYQxu3MfJ3BCy/a88RAthfJnGQTjkLpNGm5nOWUV7gWD1qg9WPpJlprEy6ScyzWseB+ir5KTdGMTrysrKpjsah5f6YVNXA7921PuLXQFQyk6ptra2w7lcKbUGuAa4fyM8y1qgVmt9fzQa1X6Fu6s5Ukr93iHE6zdC2/8KjHMTD/pxFvZoT5cBUSHEvK/64uQhxm8Bl2Enb+1rPGQYxgSlVGNXTTdfYfxHCDEmFApNCUhW8bEMYBjG29gmaL/4TAjxolLK6m4bPFGkf8YO/ihW6mowtgViBnZwz23A3ZZl3YOdG/J25/s67AjDYiTrHeBapdQX/9/e2UdJWd13/Pu7z8wuKwICRuRNayRGjE2P8Zgco7Ft1DbW2KNNagGP56RN0tISVmHn2VkBdbECM3OXd1ATX8LRhGI1PSbYE1O1qUFerLUxpxpDFAR52wUUlmVfZuaZ++sf9z6zzw4zO7Mzs7so9/PPsuzM8/7c+733/n7fnz/LFuSUKbDQCB0j9PlfURsprKEMezyQGtE5wovBoDRj3IGrIHiEickKzmZR3wzDrKgisGKwlwZYVe2h8IVVtWweytkG66XRD7yerqd3PHLlMWDozEkreYiXLl2qpJTPmo7hQQCHT5ND3GIEoPSn98t1bA5mX0kpDxDRPQDWDorezs8+APNDodBjLS0tqYF0gLFYLJvBKaV8AsC3oZcfh4pHhRDzpJTvD7TjFkL4HdnviagewL8M4nEqc507h/OhrampwZw5cyClfMXcq61DuPv1RBSJx+P7ShXEZwjHTQf7nUQisSEWi3VHIhGcyQ7wpRKPx1PmGS61X3jcLPdXbC8SbLcdx/k+ETWj/4LTQS6Gjtf7c+jEgRsBXA0d7lEs9ICgrS0aALzhi6zc9+kUoXXwH57ChIdm4MVNP4bwsB2KNyDDZTvAM3sYfWQazuqaBDgiGwDPFNJLhn4QPPcKrGAtReV54ArKbuSKq5I+j9IsLMoSWSAoL41MKvl8+//pjKavRN477Ucszc3NaGho8Dvxt4loCXSG0OMDeKAHQ5QsBPBtKeW/SSmzjWKl9fAC9gAHANwH7UO0b5DP578A3MnMP1q2bFmynA7Qd/k35/EsdBzTc4N83O3m+iyMx+Pvl3vcfoMbj8ffgzaNvA/FHe/L4SFob6+Tw/leLV26FCNHjvTv1XboGMiHh0BI3AXgvkQisd/O0mTpMG3ZLDMzke00W1pacKY6wJeKP8Ajou0IVIHob7BDRJvq6urSwVmxSgjEqiaFEOugE00+HORT3wHge5lM5iU/VCJf25c3qGuUp2s+Hpq78Rh5eIoyfLjXOHQAoouAUE8txrZdAaKwWTJ0st5ZFCxOiL7Fqv1lRD3745U9q1WOuCpFtJUt9pQCZ7y3Mj1dT731H3d6X7p7F7a0TDvtX6Tm5mYsX748KEB6pJQvQjsp32Y6iI+G6HA+gE7Xvw3ASinlu34nXa1GMei1YtLeHzGN8JMobgw6UFqhU/H/Vkr5SktLS6aSpZzg96SUW6CXEb+H/ktVlMtG6LTuh6WUR6px3KaxOiiEWA5t6/HLKh1rEkCciBZCZ8ByCc3CoA9iArOQv4Verp4JXUi62jwD4K+EEA9LKT+yy4UAdEzRYuiM2iYp5c+llCcKzUxY+h8oJRKJVgCvIifrLg/PMfO+Bx54oKpmuX67HYvFksy8AcDtGLxQl6eIaLaU8uUVK1Zwf89L3uyN9+rX4vz1s9A6ZyNCSbyedvAIe7gvNxcon9ginSOof3IKYw9djZr0uF4HeDgAhcDZmoYiK7R80eVnKWZL8GQ8KC8EERZVnV0aSEtaFTd5IrCXTns93T/btvKSHQBwdh19rF6onM4QpvbeLxobG19n5h9CT8HeCh08KKq46xS0ZcPPAGwHsFdKeRIAIpEIHMep+qjTf2mZGVLKNIBXXdd9B9r6YSZ0ncVKstr2QJuw/hTA76WU3b5grLQDXLNmDXbu3In169dDSrk3Go1+Xyn1KoA/g16m+mwFm1em034SwK+llIeq1TEFjCQRj8e7ALzguu47RPTHzDwbekq/3NnC1QBeSiQSJ13XdVDc+q+nwP8LFLehEKU+G34n5fuhAdjkuu6b0EWNv4uB2YHk43kzW/PfUsqDwRmA0wzf5mUw2Q0d/PwatKP5XmiX9+zsZqBtq9Y++8uSrKtyO5lLfwasI1Ca/WVJ+O0WEW1h5regfaUK8SjMSojjOFU94UCCjQfgP13XfQ/a32oudNZppbxFRCuYeXOp8XslXeQJ62ZeqcL0Q66hkktXMDHq2s/B5HdvRkiNATk1ICcMEjWACGVntrTQQtacNGvxQL5oIx3G5YTg1NSChKia1UOxZUE/XKxaJXtYKWRSPa8lj384c8fa6e9f07ALW0/j2KyBvFyB32uNn8/50Nkn15ifn0Npafs+HdAlZ35thNVvoAPejxjRg+nTp+OWW24ZklF5rohwXfdcABcQ0XXMfL0RmKVkY74DYBt0hspvALT6jbzruiCiqp5PnvszgpmnQrsl32QEcSkZb8egs4p+Ab00sM8P/ARQ8XJtsWu+aNEiJ5lMToG2mrgVwJ+geKZhm7nOzwF43VxrZbb9HQBLoNP+C7FYStmc55rWAriSmQsZ/fk15d/xRWiZ5x+G9pL7DHTsyHUoLaMrae7Vi9DBybuDx9HQ0ADHcU672SxTumu2ER+VzBozEXnM3E1EJ5j5KBEdZOZWaC+uDgDtUsqu/t6VKp7XF6DjWrvyCLBdAJ6WUu4fpGt6HbQFSneefe8GsCFYqL4aLFiwIJROp/8G2jw5lWcA0g6gRUp5bDCfp5zyWyMATCai65n5NmgvvoEOLl+C9lP7lRBibywW80odYPYrtCaun4VDczbi8sbbxeGLQnNViFYhXOI0EKcwaedNGNUxDRBhLbREGOT0XUL0TUp9gZW1i8j+juxnRDgMEarM0HMoZrAKfV95qeOpE8cf2Lr80yvxCSNfIxWNRmuUUqPMKLUOOiV9iunczgmM+D0iOsnMx03neMA0ht3QAcsnzegEADBv3jzU1dX1a0A6VOcZjUZHKKXGABhJROMBXMTME6GzWsJE1AWgnZn3EJHv9XQSwHG/0587dy7q6uoGtePLPe6mpibKZDLnmOMcZRqhP2DmseZeZQB0ENEhZn4felnYP+6e/kRotckVcab472gzq3SROe7R0L5JJwG0EtG7pmNtJ6LjiURCBY/Vdd16AM0Axvaz6/lSyj7v6t13341Vq1aVfOx+fchKRL25f2OYeRSA0UQ00dRuG2/uFZnzPkJEu40XWgcRtScSic6hvFcVioIQtJFupbMsrD1cmYkow8xpf3BWSrs1COcVhvbuytereAC6pZSZau6zubnZr7dXa9rfQvvuqkbWn89dd92F1atX+8KmkJ+bB6Czv5imwRqwmT5pnHnvL4OeLb4I2nfvbNMneab/aYX2q3sT2oT0CBF9lEgk0v52hRAlDTBLfqAnrJ35WVVD61SYbijmtsCUwai2C3H+vj+Fw6MAUQPhhACnBqAQhDAB8RB6cVD0iizOEVsEyk4tkSCIcK0WaVUWVoMtslhl4PV0vdx5aN+tbzzxxZPXNOzG1uWfxieR/l4e05j6TrUUaBgVMyvHcbxYLKZK6XCHk0LHEo1GQ0qpbKkDIlJEpIQQqWXLlvFwd3qFjrupqYmYOczMDjML/54QkRePx0+Jt6ivr8fUqVOHtD5evk6xqalJKKVqzDGTGXl6uR1rQ0MDamtroZRCLBaD67r/DB1wX9Dck4i+mUgkfpKzvwHVY6vkmS0kAhKJBI4ePVpj3PuFaS8VAM/vBIJEIhHU1tZiyZIlH8s2o1rU19dj3LhxQ+bo3tjYiP3792Pjxo3Dcv6lbrOa+45Go0ilUli5cuVpcc+LDJIdpVQd9PJq2LQfwsgGZQRXCkBPcKBfzntdVGhNfOgOHPqnHwMAznto5rdUiB7jMJ3iIpp1UxeAkwQm/+4vUZeclJ3FIhHWM1tm2ZBNbJYfEE9mubB3Vivwu+g9TAqF4Tjhgt5avqnFQLVSNZYj+9tGJp1sTbUfa9i2ctpGnGE0NzfjjTfewObNm4ekgxoOSu2A/ZHmx7GDu+eee7Bs2bJhOa5gI3n//fdj8eLFRbcxe/ZsXHbZZaivr8+3/R8BuKPfxpHoqkQi8T8ft2esHEFosZxJ/VE5bXAls58lzWiNWfnXaJ/3DCasmnG+qhMrVYhmFPomUwrjP7gC4w9/EYLP0iLLCYGcGoDCZslQABBmdVBk47FylwvJ99cS1BsbDwERqoFwnLJFVVAYVaMIdbHvq0wGXmfHc1viU24DgC/P34VtKy62T7zFUqQxa2xsnArgQCKRUNUS3ya+7hnoOK+CCCFGx+PxDntXLBZLJZSU7TD+bF1gvu3uTa1Iq2cpw0fyiyxGTecYjPlwOoQaoUVVNtvQn9mngAO8CYAH9dF8WWuHgBrkwOGyyvSWBCpDFAUtGgZbZDEzVCa9N93dkQ3UsCLLYjlF/ADQy2ILFiwIua47y3Xd15j5bZjiyJWKrEAa+dUAihUVfVsp1W3vjMViGRKhtfu7T+K8dTMBALXd6t9J8U+gOI+oSGPcwSt0PUMS4GwNw6CdQ3BZEH3qG/adYOuN0+I+fyHtRVWiQqqWE3xZIgsAs0p7XSdf2rFm+hYAuDay2z51Fgv08rCPCVC/wHXdB9Lp9B5o64irAIxi5kWu69bkiKUBE5gpuwk6ALY/tgJQvseVxWKxlEtZ2R2fWjPjeh5B61SILu3dksLIDyfi/D1fRTgzDnBCEI6Oy9KxWbr0DpPQ3u++WWmOnUNuvJaWgoHsw0AMlwifGqtVreXAQsKqlG1z4AuZnu5dqeOHb9i+7vI99nGzWPrS0tJCbW1t10K7lX8NOuvs1IaK6GYAL/jZgwPFX5J0XfcG6JJKlxb5yl8AeEFKyfYuWSyWSijLKO1I/aaXOYOfItMr1yjNGHv4jxD2xujSOqK3niFlZ7ZEbyxW0BGe+rrC925UqxZCr8gCmZkiYvhFv6u9HJhPYJWy7VxneVaqK93dsXH7usv3XDP/Pfu0WSw5tLW1fQPaXf4bhUSWfu/4XwFMd12XAJSU7djU1NRnSTIajX4KwJwSRFYHEW2xIstisQyL0JqwfgYAwEmpp0nxa7oR9DD66HSM6JoIiBDgmGVCPz7LiKxeg3QKaCkKDlsDs1l9hrPZz2f/yATOZMBqcNvCUkRbvtI9zApeT+fu7mNHlwLA1hXT7NNmseTgOM7PoQ1pizGSmV8F8AXXdZ1gRmLu8p7/eywWy2YuNjY2jlNKxaDNTovxKDMn7d2xWCzVoCJjuPHrZ9zDtWh2UiNqJu+6GWd1X6AzBIWj7RycMIgckAjlXTLUE1YFfLMIp2QjBsvyZD9PAlRlC/+BCKxCKM87kTx2eN72VZc88eWG3dj2CfXMsljKJbCc900AK2CC3ouQga7d+DiAdK6/TY7gIqWUw8x/CCAO4MaSGkWiS4UQO609gsViGTahNekHd+Lg3z+Fc1ffPiVT6z1xbus1N44/+iUIrtXLg44DohAgtDkpm1ktAswSIgLiybduoN4lQqLAXFuuW7wI/BtgAoQI9X6mHFGF3sxGX2BRsc/1c/GYmdMnT2x7NT7lWvuIWSzFcV33IQD/OICvvAlgORG9xMzd0AaD/mspiKgGwCXM/HfQdSnrShRZawG4iUQiORSu4RaLxQqtgpy7dgaOzt2EqTH3W+P3Xzu7tvu8syAySsdjOZyNzxJ+ADw4W2rHzFxxVmBRYKJKBJISqc+yIQXitNBnFswsU5YhsYqJpqDK4lKvKaPT6+m8d/uqS375Ffd9bJEX2SfNYsmDb6wZjUYvVEptQBFvqwLjn9ehiwN3G0E1Cbq8xtgBbqsNwFVSyn32zlgslmEXWgBw4ZJFtHfhgzZgtADWmNRiKU5gCfFGAKuhC14PNQo6IH+zlDJzOtcEtFgsZ5DQslgslmoQiUSopaWFXdedBeBBFPe5qrbIehDAEillyoosi8VSTYS9BBaLZbgJhULc0NAAKeVGAIsAvDNEu+4mojXhcDgmpUyZY7A3xGKxWKFlsVg+OcRiMTiOg/nz5/tiay6AV4CsW99gcJiIlgghokuXLu2ORCKYPHmyvRkWi6Wq2KVDi8Vy2rBgwQIkk0lavnw5R6PRSUqphSitZM5A6ATwv0S0IpFIPAfoODEiqkrRaovFYrFCy2KxnNYErRVc1/06gDsAXAngMxVs9hiA3wJ4AcBjUsrW3H1ZLBaLFVoWi+WME1tGcH0N2nT0cwAuBDARwJh+NtEJ4DCAAwB2AdgB4Hkp5f5C+7BYLBYrtCwWy5kuuCYA+DyAiwFMBjAOQC2AEAAPQBJAO4BWaH+t30kpdwa3aTMLLRaLxWKxWALk1jTM5d577+03uScSiRTdhsVisVSb/wc/BKyTPJibLwAAAABJRU5ErkJggg=="

/***/ },
/* 960 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 961 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "937865ddbe3f578111eb395221678616.png";

/***/ },
/* 963 */
/***/ function(module, exports) {

	module.exports = "data:image/gif;base64,R0lGODlhEAAQAPUWAAAAARoaGvv7+/Hx8dTU1M7Ozuvr61NTU01NTeHh4TQ0NI6OjhUVFZSUlDo6Otvb28DAwGVlZVxcXGtra0NDQ6GhoZqamq6uroWFhSEhISoqKnt7e3BwcCUlJefn5xcXF1ZWVoeHhwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh/i1NYWRlIGJ5IEtyYXNpbWlyYSBOZWpjaGV2YSAod3d3LmxvYWRpbmZvLm5ldCkAIfkEBQoAFgAsAAAAABAAEAAABU6gJY7QcUBjmhoOADiGKhJTVAUuQ8jWFAQIigsxkAkivwNhsUjwLAXJ6UlqFIpUywOhiGCp2+6XCmnssilCQYDWSgvtR0RyRj8e7bw+FQIAIfkEBQoADwAsAAAAAA8ACgAABUzgI45GVRljmmJBsAhJkg7XlRwtwmrWeCmOikWj4QQAAI3s8VNYBgVCgYHMLAeVBkok2DBcIkNhoHoICASBGYOolFWDBaL3TonJdVEIACH5BAUKABUALAIAAAAOAAsAAAVHYCWKzzOeJ4QgkOCeyZNYitIU0USQkUQQkUhBEghMSJIDYcAcHIpH0U+QOiAaBhTqQWE4INrRAkA+hEXj8rmSQHjB6wEhGwIAIfkEBQoADQAsBgAAAAoADwAABVCgIQhNaTYGhhlnWRxHMVzXUA6WNVSKcrUNi8JRARosFRZQYDmsWgUNI1M8RQPUk6DAQSyUDcGGwcCQTAQGAJBJnAiBdcbTWnQ6FmCD4C6FAAAh+QQFCgAMACwFAAIACwAOAAAGT0CGcPh4DI8MgiRiRDIKB0kTKSAQnEdCA4IdRBSI6dALFgsHha0TEr0KE4sF4RAIRASMAQIAoCDqE3gEH3wBFRETbgYOfA4GBHhDbCBcSEEAIfkEBQoADgAsAQAGAA8ACgAABUygI46kMxRGqToWggkr2S6CIRAEXJ6pswSMjc5haFQGokQGAAgUngKLQnFJapgBjkZjkVJHlkwGgwgEDonLBTlKJAQY8yI2GlQqPVIIACH5BAUKABYALAAABQAOAAsAAAVJoGUQg2WeKOQwSIK+ByAvLxrP9akyVI4aFcQBghIQCKdIICAZDAyCwkHysAgmS0khEjlKIlULYRIpNBSKRuLhKgogQqLP9AifQgAh+QQFCgANACwAAAEACgAPAAAGU8CGMJEQGoWWTGYhOCY6AEDg4cxEP4SjABNgbJpCQwjBKYCFlUxAUzg20uv2cYA5WM5Oi8XgblwUChZ9f4EDegNCAxcXAwUHB3JHBhgYfH0DAgZBADs="

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./01-welcome.stories.jsx": 1063,
		"./Admin/DocketAlerts.jsx": 1064,
		"./App.jsx": 554,
		"./CaseFolder/Integrations/Clio/ClioCaseFolderSettings.jsx": 1065,
		"./CaseFolder/Integrations/Clio/ClioCaseFolderSettingsForm.jsx": 555,
		"./CaseFolder/Integrations/Clio/ClioClientSelector.jsx": 1066,
		"./CaseFolder/Integrations/Clio/ClioMatter.jsx": 556,
		"./CaseFolder/Integrations/Clio/ClioMatterSearch.jsx": 557,
		"./CaseFolder/Integrations/Clio/ClioMatterSelector.jsx": 1067,
		"./CaseFolder/Integrations/NetDocuments/AttributeConfig.jsx": 1068,
		"./CaseFolder/Integrations/RocketMatter/RocketMatterCaseFolderSettings.jsx": 1069,
		"./CaseFolder/Integrations/RocketMatter/RocketMatterCaseFolderSettingsForm.jsx": 558,
		"./CaseFolder/Integrations/RocketMatter/RocketMatterClientSelector.jsx": 559,
		"./CaseFolder/Integrations/RocketMatter/RocketMatterMatterSelector.jsx": 560,
		"./CaseFolder/Integrations/SharePointDocketEmbedSettings.jsx": 1070,
		"./CaseFolder/Integrations/SharepointCasefolderSettings.jsx": 561,
		"./CaseFolder/Integrations/UploadFolderSelect.jsx": 1071,
		"./CaseFolder/Integrations/UploadFolderTree.jsx": 562,
		"./CaseFolder/Integrations/iManage/IManageCaseFolderSettings.jsx": 1072,
		"./CaseFolder/Integrations/iManage/IManageCaseFolderSettingsForm.jsx": 563,
		"./CaseFolder/Integrations/iManage/IManageWorkspaceFolderSelector.jsx": 564,
		"./CaseFolder/Integrations/iManage/iManageMatterSelector.jsx": 565,
		"./CaseFolder/Settings/DocketAlerts.jsx": 567,
		"./CaseFolder/Settings/DocketAlertsContainer.jsx": 1073,
		"./CaseFolder/Settings/ECFForwarding.jsx": 341,
		"./CaseFolder/Settings/ECFForwarding.stories.jsx": 1074,
		"./CaseFolder/Settings/ECFForwardingContainer.jsx": 1075,
		"./ErrorBoundary.jsx": 568,
		"./ErrorHandlingAppContainer.jsx": 569,
		"./Integrations/ApiCalls.stories.jsx": 1076,
		"./Integrations/ApiCallsContainer.jsx": 1077,
		"./Integrations/connections/BoxSwitch.jsx": 571,
		"./Integrations/connections/CalendarFeedConfig.jsx": 572,
		"./Integrations/connections/CalendarFeedSwitch.jsx": 573,
		"./Integrations/connections/ClioAuthenticator.jsx": 574,
		"./Integrations/connections/ClioConnectionSettings.jsx": 575,
		"./Integrations/connections/ClioConnectionSettingsForm.jsx": 576,
		"./Integrations/connections/ClioDocumentCategorySelector.jsx": 342,
		"./Integrations/connections/ClioSwitch.jsx": 577,
		"./Integrations/connections/ConnectionsLayout.jsx": 578,
		"./Integrations/connections/DefaultConfigurations.jsx": 579,
		"./Integrations/connections/DropboxAuthenticator.jsx": 580,
		"./Integrations/connections/DropboxSwitch.jsx": 581,
		"./Integrations/connections/FileSyncSettings.jsx": 582,
		"./Integrations/connections/FileSyncUploadDestinationSettings.jsx": 583,
		"./Integrations/connections/FilenameTemplate/CustomizeDescriptionBox.jsx": 584,
		"./Integrations/connections/FilenameTemplate/FieldsSelector.jsx": 585,
		"./Integrations/connections/FilenameTemplate/FileFormatConfiguration.jsx": 586,
		"./Integrations/connections/FilenameTemplate/FilenameTemplate.jsx": 343,
		"./Integrations/connections/FilenameTemplate/FilenameTemplate.stories.jsx": 1079,
		"./Integrations/connections/FilenameTemplate/FolderPathConfiguration.jsx": 587,
		"./Integrations/connections/FilenameTemplate/PricingAgreement.jsx": 588,
		"./Integrations/connections/FilenameTemplate/SavedFormatPreview.jsx": 589,
		"./Integrations/connections/GoogleDriveAuthenticator.jsx": 590,
		"./Integrations/connections/GoogleDriveSwitch.jsx": 591,
		"./Integrations/connections/IManageSwitch.jsx": 592,
		"./Integrations/connections/InstructionsPanel.jsx": 593,
		"./Integrations/connections/NetDocumentsCabinetProfileConfig.jsx": 594,
		"./Integrations/connections/NetDocumentsCabinetProfileConfigAttributeForm.jsx": 595,
		"./Integrations/connections/NetDocumentsCabinetsConfig.jsx": 596,
		"./Integrations/connections/NetDocumentsDocketLinkPanel.jsx": 597,
		"./Integrations/connections/NetDocumentsSwitch.jsx": 598,
		"./Integrations/connections/OneDriveSwitch.jsx": 600,
		"./Integrations/connections/RocketMatterSwitch.jsx": 601,
		"./Integrations/connections/SharepointConnectionSettings.jsx": 602,
		"./Integrations/connections/SharepointDriveSelector.jsx": 344,
		"./Integrations/connections/SharepointFolderSelector.jsx": 603,
		"./Integrations/connections/SharepointSiteSearch.jsx": 345,
		"./Integrations/connections/SharepointSwitch.jsx": 604,
		"./Integrations/connections/iManageAuthenticator.jsx": 605,
		"./User/ECFMailboxes/ECFExternalMailboxEditForm.jsx": 606,
		"./User/ECFMailboxes/ECFMailboxesContainer.jsx": 1082,
		"./User/ECFMailboxes/ECFMailboxesList.jsx": 346,
		"./User/ECFMailboxes/ECFMailboxesList.stories.jsx": 1083,
		"./clientCode/ClientCode.jsx": 247,
		"./clientCode/StandaloneClientCode.jsx": 607,
		"./clientCode/clientCode.stories.jsx": 1085,
		"./components/Integrations/NetDocuments/AttributeSelector.jsx": 347,
		"./components/advancedSearch/AdvancedSearchHelper.jsx": 79,
		"./components/advancedSearch/AdvancedSearchTab.jsx": 349,
		"./components/advancedSearch/fields/AssetsField.jsx": 615,
		"./components/advancedSearch/fields/BusinessOnlyField.jsx": 616,
		"./components/advancedSearch/fields/CaseTitlesField.jsx": 617,
		"./components/advancedSearch/fields/CasesField.jsx": 618,
		"./components/advancedSearch/fields/ChapterField.jsx": 619,
		"./components/advancedSearch/fields/DatePickerField.jsx": 620,
		"./components/advancedSearch/fields/IndustryField.jsx": 621,
		"./components/advancedSearch/fields/InputField.jsx": 622,
		"./components/advancedSearch/fields/LiabilitiesField.jsx": 623,
		"./components/advancedSearch/fields/NatureOfSuit.jsx": 624,
		"./components/advancedSearch/fields/PartyNameField.jsx": 625,
		"./components/advancedSearch/fields/QueryField.jsx": 626,
		"./components/advancedSearch/fields/RegionField.jsx": 627,
		"./components/advancedSearch/fields/SearchPDFsField.jsx": 628,
		"./components/advancedSearch/fields/TypeField.jsx": 629,
		"./components/advancedSearch/fields/index.jsx": 53,
		"./components/advancedSearch/initialForms/allCourts/CasesForm.jsx": 350,
		"./components/advancedSearch/initialForms/allCourts/CasesForm.stories.jsx": 1109,
		"./components/advancedSearch/initialForms/allCourts/GeneralForm.jsx": 351,
		"./components/advancedSearch/initialForms/allCourts/GeneralForm.stories.jsx": 1110,
		"./components/advancedSearch/initialForms/bankruptcy/CasesForm.jsx": 249,
		"./components/advancedSearch/initialForms/bankruptcy/CasesForm.stories.jsx": 1111,
		"./components/advancedSearch/initialForms/bankruptcy/GeneralForm.jsx": 250,
		"./components/advancedSearch/initialForms/bankruptcy/GeneralForm.stories.jsx": 1112,
		"./components/advancedSearch/initialForms/bankruptcy/PetitionsForm.jsx": 251,
		"./components/advancedSearch/initialForms/bankruptcy/PetitionsForm.stories.jsx": 1113,
		"./components/advancedSearch/initialForms/bankruptcy/SchedulesForm.jsx": 352,
		"./components/advancedSearch/initialForms/bankruptcy/SchedulesForm.stories.jsx": 1114,
		"./components/advancedSearch/initialForms/civil/CasesForm.jsx": 353,
		"./components/advancedSearch/initialForms/civil/CasesForm.stories.jsx": 1115,
		"./components/advancedSearch/initialForms/civil/GeneralForm.jsx": 354,
		"./components/advancedSearch/initialForms/civil/GeneralForm.stories.jsx": 1116,
		"./components/advancedSearch/initialForms/criminal/CasesForm.jsx": 355,
		"./components/advancedSearch/initialForms/criminal/CasesForm.stories.jsx": 1117,
		"./components/advancedSearch/initialForms/criminal/GeneralForm.jsx": 356,
		"./components/advancedSearch/initialForms/criminal/GeneralForm.stories.jsx": 1118,
		"./components/advancedSearch/resultForms/AdvancedFilterModal.jsx": 357,
		"./components/advancedSearch/resultForms/AdvancedFilterModal.stories.jsx": 1119,
		"./components/advancedSearch/resultForms/CaseFilterModal.jsx": 358,
		"./components/advancedSearch/resultForms/CaseFilterModal.stories.jsx": 1120,
		"./components/advancedSearch/resultForms/DateFilterModal.jsx": 359,
		"./components/advancedSearch/resultForms/DateFilterModal.stories.jsx": 1121,
		"./components/advancedSearch/resultForms/FinancialFilterModal.jsx": 360,
		"./components/advancedSearch/resultForms/FinancialFilterModal.stories.jsx": 1122,
		"./components/advancedSearch/resultForms/ResultForm.jsx": 361,
		"./components/advancedSearch/resultForms/ResultForm.stories.jsx": 1123,
		"./components/advancedSearch/resultForms/ScheduleFilterModal.jsx": 362,
		"./components/advancedSearch/resultForms/ScheduleFilterModal.stories.jsx": 1124,
		"./components/advancedSearch/results/AdvancedSearchResults.jsx": 630,
		"./components/advancedSearch/results/CaseActivityResults.jsx": 631,
		"./components/advancedSearch/results/CasesPartyResults.jsx": 632,
		"./components/advancedSearch/results/CasesResults.jsx": 633,
		"./components/advancedSearch/results/EntriesResults.jsx": 132,
		"./components/advancedSearch/results/PetitionResults.jsx": 634,
		"./components/advancedSearch/results/ResultsPaginator.jsx": 108,
		"./components/advancedSearch/results/ScheduleResults.jsx": 635,
		"./components/advancedSearch/results/Snippet.jsx": 252,
		"./components/advancedSearch/results/rows/AliasesResultRow.jsx": 363,
		"./components/advancedSearch/results/rows/AliasesResultRow.stories.jsx": 1125,
		"./components/advancedSearch/results/rows/AssociatedCasesResultRow.jsx": 636,
		"./components/advancedSearch/results/rows/AttorneysResultRow.jsx": 364,
		"./components/advancedSearch/results/rows/AttorneysResultRow.stories.jsx": 1126,
		"./components/advancedSearch/results/rows/CaseActivityClaimsRow.jsx": 637,
		"./components/advancedSearch/results/rows/CaseActivityDocketsRow.jsx": 638,
		"./components/advancedSearch/results/rows/ClaimsResultRow.jsx": 639,
		"./components/advancedSearch/results/rows/CreditorsResultRow.jsx": 365,
		"./components/advancedSearch/results/rows/CreditorsResultRow.stories.jsx": 1127,
		"./components/advancedSearch/results/rows/DocketsResultRow.jsx": 640,
		"./components/advancedSearch/results/rows/EventsResultRow.jsx": 641,
		"./components/advancedSearch/results/rows/FilersResultRow.jsx": 366,
		"./components/advancedSearch/results/rows/FilersResultRow.stories.jsx": 1128,
		"./components/advancedSearch/results/rows/HTMLResultRow.jsx": 367,
		"./components/advancedSearch/results/rows/HTMLResultRow.stories.jsx": 1129,
		"./components/advancedSearch/results/rows/PartiesResultRow.jsx": 642,
		"./components/advancedSearch/results/rows/ScheduleResultRow.jsx": 643,
		"./components/advancedSearch/results/rows/StatusResultRow.jsx": 644,
		"./components/advancedSearch/results/rows/TransactionsResultRow.jsx": 645,
		"./components/case/associated_cases/AllCasesView.stories.jsx": 646,
		"./components/case/associated_cases/AssociatedCasesView.stories.jsx": 647,
		"./components/case/associated_cases/OtherCourtInfo.stories.jsx": 648,
		"./components/case/associated_cases/OtherFilings.stories.jsx": 649,
		"./components/case/associated_cases/RelatedCases.stories.jsx": 650,
		"./components/case/claims/claimsEntries/AllPartsDocument.jsx": 373,
		"./components/case/claims/claimsEntries/ClaimsEntry.jsx": 374,
		"./components/case/claims/claimsEntries/ClaimsHistoryEntry.jsx": 375,
		"./components/case/claims/claimsEntries/Document.jsx": 376,
		"./components/case/claims/claimsEntries/Documents.jsx": 377,
		"./components/case/claims/claimsEntries/DocumentsRow.jsx": 378,
		"./components/case/creditor_mailing/CreditorMailing.stories.jsx": 652,
		"./components/case/deadlines/DeadLineCases.stories.jsx": 653,
		"./components/case/docket/DocketError.jsx": 380,
		"./components/case/docket/DocketFilters.jsx": 254,
		"./components/case/docket/DocketFilters.stories.jsx": 655,
		"./components/case/docket/DocketHeader.jsx": 200,
		"./components/case/docket/DocketHeader.stories.jsx": 656,
		"./components/case/docket/DocketPacerSearchBar.jsx": 381,
		"./components/case/docket/DocketParts.jsx": 657,
		"./components/case/docket/Dockets.jsx": 658,
		"./components/case/docket/DocketsPaginator.jsx": 255,
		"./components/case/docket/DocketsTable.jsx": 382,
		"./components/case/docket/Flash.jsx": 256,
		"./components/case/docket/LastFilingTooltip.jsx": 383,
		"./components/case/docket/MissingEntriesTooltip.jsx": 384,
		"./components/case/docket/TextHighlight.jsx": 257,
		"./components/case/docket/ToolbarButtons.jsx": 385,
		"./components/case/docket/UpdateRedact.jsx": 386,
		"./components/case/docket/docketEntries/AllPartsDocument.jsx": 387,
		"./components/case/docket/docketEntries/DocketEntries.jsx": 388,
		"./components/case/docket/docketEntries/DocketEntriesTableBody.jsx": 389,
		"./components/case/docket/docketEntries/DocketEntriesTableHeader.jsx": 390,
		"./components/case/docket/docketEntries/DocketEntry.jsx": 170,
		"./components/case/docket/docketEntries/Document.jsx": 391,
		"./components/case/docket/docketEntries/Documents.jsx": 201,
		"./components/case/docket/docketEntries/DocumentsRow.jsx": 258,
		"./components/case/docket/docketEntries/MissingEntry.jsx": 392,
		"./components/case/docket/popups/AllPartsPrintPreview.jsx": 133,
		"./components/case/docket/popups/AllPartsPrintPreview.stories.jsx": 659,
		"./components/case/docket/popups/DocketDetailsPurchaseForm.jsx": 109,
		"./components/case/docket/popups/DocketDetailsPurchaseForm.stories.jsx": 660,
		"./components/case/docket/popups/DocketPopup.jsx": 259,
		"./components/case/docket/popups/DownloadCombineAllPdfInRangePopup.jsx": 171,
		"./components/case/docket/popups/DownloadZipAllPdfsRangePopup.jsx": 134,
		"./components/case/docket/popups/DownloadZipAllPdfsRangePopup.stories.jsx": 661,
		"./components/case/docket/popups/DownloadZipWithSubpartsPopup.jsx": 135,
		"./components/case/docket/popups/DownloadZipWithSubpartsPopup.stories.jsx": 662,
		"./components/case/docket/popups/EmailAllPartsZipPopup.jsx": 172,
		"./components/case/docket/popups/EmailAttachmentPurchaseForm.jsx": 260,
		"./components/case/docket/popups/EmailAttachmentPurchaseForm.stories.jsx": 663,
		"./components/case/docket/popups/EmailBulkModal.jsx": 202,
		"./components/case/docket/popups/EmailBulkModal.stories.jsx": 664,
		"./components/case/docket/popups/EmailCombinedPdfPopup.jsx": 173,
		"./components/case/docket/popups/EmailForm.jsx": 261,
		"./components/case/docket/popups/EmailPartModal/EmailPartModal.jsx": 136,
		"./components/case/docket/popups/EmailPartModal/EmailPartModal.stories.jsx": 665,
		"./components/case/docket/popups/EmailPartPopup.jsx": 174,
		"./components/case/docket/popups/FileLinkMessage.jsx": 393,
		"./components/case/docket/popups/PrintAllPdfInRangePopup.jsx": 175,
		"./components/case/filers/FilersCases.stories.jsx": 666,
		"./components/case/history/History.stories.jsx": 668,
		"./components/case/history/HistoryEntries.jsx": 395,
		"./components/case/history/HistoryEntriesTableBody.jsx": 396,
		"./components/case/history/HistoryEntry.jsx": 397,
		"./components/case/history/HistoryFilters.jsx": 398,
		"./components/case/history/HistoryPaginator.jsx": 399,
		"./components/case/history/HistoryParserFilter.jsx": 400,
		"./components/case/parties/PartiesCases.stories.jsx": 670,
		"./components/case/related_transaction/EmailPopup.jsx": 401,
		"./components/case/related_transaction/PublicLinkPopup.jsx": 402,
		"./components/case/related_transaction/RelatedTransaction.stories.jsx": 672,
		"./components/case/related_transaction/RelatedTransactionEntries.jsx": 403,
		"./components/case/related_transaction/RelatedTransactionPaginator.jsx": 404,
		"./components/case/related_transaction/RelatedTransactionsFilters.jsx": 405,
		"./components/case/related_transaction/RelatedTransactionsParser.jsx": 406,
		"./components/case/status/Status.stories.jsx": 674,
		"./components/common/Loading/Loading.stories.jsx": 1150,
		"./components/common/Modals/ConfirmationModal/ConfirmationModal.jsx": 676,
		"./components/common/Modals/ConfirmationModal/ConfirmationModal.stories.jsx": 1151,
		"./components/common/Modals/DeleteModal/DeleteModal.jsx": 407,
		"./components/common/Modals/DeleteModal/DeleteModal.stories.jsx": 1152,
		"./components/common/Notification/Notification.jsx": 40,
		"./components/common/Notification/Notification.stories.jsx": 1153,
		"./components/common/Popup.jsx": 69,
		"./components/common/Popup.stories.jsx": 1154,
		"./components/common/PopupErrorComponent/PopupError.jsx": 176,
		"./components/common/RPCProgressBar.jsx": 678,
		"./components/common/TimeFromNow.jsx": 679,
		"./components/refineSearch/RefineSearch.jsx": 409,
		"./components/refineSearch/RefineSearch.stories.jsx": 1157,
		"./components/search/FormElements/caseSelector/CaseNumberSelector.jsx": 204,
		"./components/search/FormElements/caseSelector/CaseNumberSelectorOfCaseLookup.jsx": 680,
		"./components/search/FormElements/caseSelector/CaseTitleOrPartyNameSelectorOfCaseLookup.jsx": 681,
		"./components/search/FormElements/caseSelector/CaseTitleSelector.jsx": 205,
		"./components/search/localCourtSearch/AppellateForm.jsx": 411,
		"./components/search/localCourtSearch/AppellateForm.stories.jsx": 1188,
		"./components/search/localCourtSearch/BankruptcyCasesResultTable.jsx": 687,
		"./components/search/localCourtSearch/BankruptcyForm.jsx": 412,
		"./components/search/localCourtSearch/BankruptcyForm.stories.jsx": 1189,
		"./components/search/localCourtSearch/BankruptcyPartiesResultTable.jsx": 688,
		"./components/search/localCourtSearch/CivilCasesResultTable.jsx": 689,
		"./components/search/localCourtSearch/CivilForm.jsx": 413,
		"./components/search/localCourtSearch/CivilForm.stories.jsx": 1190,
		"./components/search/localCourtSearch/CivilPartiesResultTable.jsx": 690,
		"./components/search/localCourtSearch/LocalCourtResults.jsx": 414,
		"./components/search/localCourtSearch/LocalCourtSearch.jsx": 691,
		"./components/search/localCourtSearch/LocalCourtsResults.stories.jsx": 1191,
		"./components/search/sections/pacerSearch/PacerSearch.jsx": 692,
		"./components/searchAlerts/AutomatedReports/AutomatedReports.jsx": 694,
		"./components/searchAlerts/AutomatedReports/AutomatedReportsTable.jsx": 417,
		"./components/searchAlerts/AutomatedReports/AutomtatedReports.stories.jsx": 1202,
		"./components/searchAlerts/AutomatedReports/AutomtatedReportsTable.stories.jsx": 1203,
		"./components/searchAlerts/CustomAlerts/CustomAlertEdit.jsx": 418,
		"./components/searchAlerts/CustomAlerts/CustomAlertEdit.stories.jsx": 1204,
		"./components/searchAlerts/CustomAlerts/CustomAlerts.jsx": 695,
		"./components/searchAlerts/CustomAlerts/CustomAlerts.stories.jsx": 1205,
		"./components/searchAlerts/CustomAlerts/DeliveryLogModal.jsx": 696,
		"./components/searchAlerts/CustomAlerts/WebhookHeadersField.jsx": 697,
		"./components/searchAlerts/TemplateAlerts/TemplateAlerts.jsx": 698,
		"./components/searchAlerts/TemplateAlerts/TemplateAlerts.stories.jsx": 1206,
		"./index.jsx": 703,
		"./pages/advancedSearch/AdvancedSearch.jsx": 704,
		"./pages/advancedSearch/AdvancedSearchIR.jsx": 705,
		"./pages/advancedSearch/Alerts/AdvancedSearchAlert.jsx": 706,
		"./pages/advancedSearch/Alerts/CreateAlertModal.jsx": 420,
		"./pages/advancedSearch/Alerts/CreateAlertModal.stories.jsx": 1213,
		"./pages/filings/CaseLookup/CaseLookup.jsx": 707,
		"./pages/filings/FacetsBlock/RefineSearch.jsx": 708,
		"./pages/filings/FacetsBlock/TabOneSection.jsx": 709,
		"./pages/filings/FacetsBlock/TabTwoSection.jsx": 710,
		"./pages/filings/Filings.jsx": 711,
		"./scheduleform/common/EditCopyPasteSchedule.jsx": 208,
		"./scheduleform/common/PagedFieldArray.jsx": 424,
		"./scheduleform/common/PagedItems.jsx": 729,
		"./scheduleform/common/RenderCount.jsx": 1247,
		"./scheduleform/common/ScheduleFilters.jsx": 274,
		"./scheduleform/common/ScheduleVeriyToolbar.jsx": 179,
		"./scheduleform/petition/Petition.jsx": 730,
		"./scheduleform/petition/PetitionContainer.jsx": 1248,
		"./scheduleform/petition/PetitionForm.jsx": 731,
		"./scheduleform/schedule_ab/ScheduleAB.jsx": 732,
		"./scheduleform/schedule_ab/ScheduleABContainer.jsx": 1249,
		"./scheduleform/schedule_ab/ScheduleABForm.jsx": 733,
		"./scheduleform/schedule_d/ScheduleD.jsx": 734,
		"./scheduleform/schedule_d/ScheduleDContainer.jsx": 1250,
		"./scheduleform/schedule_d/ScheduleDCreditorFields.jsx": 735,
		"./scheduleform/schedule_d/ScheduleDForm.jsx": 736,
		"./scheduleform/schedule_ef/ScheduleEF.jsx": 737,
		"./scheduleform/schedule_ef/ScheduleEFContainer.jsx": 1251,
		"./scheduleform/schedule_ef/ScheduleEFForm.jsx": 738,
		"./scheduleform/schedule_ef/ScheduleEFNonPriorityCreditorForm.jsx": 739,
		"./scheduleform/schedule_ef/ScheduleEFPriorityCreditorForm.jsx": 740,
		"./scheduleform/schedule_top20/TopTwenty.jsx": 741,
		"./scheduleform/schedule_top20/TopTwentyContainer.jsx": 1252,
		"./scheduleform/schedule_top20/TopTwentyCreditorForm.jsx": 742,
		"./scheduleform/schedule_top20/TopTwentyForm.jsx": 743
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 964;


/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./alias/PartiesWithAlias.js": 1130,
		"./associated_cases/AllCasesView.js": 368,
		"./associated_cases/AllCasesView.stories.jsx": 646,
		"./associated_cases/AssociatedCases.js": 1131,
		"./associated_cases/AssociatedCasesView.js": 369,
		"./associated_cases/AssociatedCasesView.stories.jsx": 647,
		"./associated_cases/OtherCourtInfo.js": 370,
		"./associated_cases/OtherCourtInfo.stories.jsx": 648,
		"./associated_cases/OtherFilings.js": 371,
		"./associated_cases/OtherFilings.stories.jsx": 649,
		"./associated_cases/RelatedCases.js": 372,
		"./associated_cases/RelatedCases.stories.jsx": 650,
		"./attorneys/CaseAttorneys.js": 1132,
		"./claims/claimsEntries/AllPartsDocument.jsx": 373,
		"./claims/claimsEntries/ClaimsEntry.jsx": 374,
		"./claims/claimsEntries/ClaimsHistoryEntry.jsx": 375,
		"./claims/claimsEntries/Document.jsx": 376,
		"./claims/claimsEntries/Documents.jsx": 377,
		"./claims/claimsEntries/DocumentsRow.jsx": 378,
		"./client_code_dialog/clientCodeDialogContainer.js": 1133,
		"./client_code_dialog/clientCodeDialogView.js": 651,
		"./creditor_mailing/CreditorMailing.js": 379,
		"./creditor_mailing/CreditorMailing.stories.jsx": 652,
		"./creditor_mailing/CreditorMailingContainer.js": 1134,
		"./creditors/CaseCreditors.js": 1135,
		"./deadlines/DeadLineCases.stories.jsx": 653,
		"./deadlines/DeadlineCases.js": 253,
		"./deadlines/DeadlineCasesContainer.js": 1136,
		"./deadlines/deadlineArray.js": 654,
		"./deadlines/index.js": 1137,
		"./docket/DocketError.jsx": 380,
		"./docket/DocketFilters.jsx": 254,
		"./docket/DocketFilters.stories.jsx": 655,
		"./docket/DocketHeader.jsx": 200,
		"./docket/DocketHeader.stories.jsx": 656,
		"./docket/DocketPacerSearchBar.jsx": 381,
		"./docket/DocketParts.jsx": 657,
		"./docket/Dockets.jsx": 658,
		"./docket/DocketsPaginator.jsx": 255,
		"./docket/DocketsTable.jsx": 382,
		"./docket/Flash.jsx": 256,
		"./docket/LastFilingTooltip.jsx": 383,
		"./docket/MissingEntriesTooltip.jsx": 384,
		"./docket/TextHighlight.jsx": 257,
		"./docket/ToolbarButtons.jsx": 385,
		"./docket/UpdateRedact.jsx": 386,
		"./docket/docketEntries/AllPartsDocument.jsx": 387,
		"./docket/docketEntries/DocketEntries.jsx": 388,
		"./docket/docketEntries/DocketEntriesTableBody.jsx": 389,
		"./docket/docketEntries/DocketEntriesTableHeader.jsx": 390,
		"./docket/docketEntries/DocketEntry.jsx": 170,
		"./docket/docketEntries/Document.jsx": 391,
		"./docket/docketEntries/Documents.jsx": 201,
		"./docket/docketEntries/DocumentsRow.jsx": 258,
		"./docket/docketEntries/MissingEntry.jsx": 392,
		"./docket/popups/AllPartsPrintPreview.jsx": 133,
		"./docket/popups/AllPartsPrintPreview.stories.jsx": 659,
		"./docket/popups/DocketDetailsPurchaseForm.jsx": 109,
		"./docket/popups/DocketDetailsPurchaseForm.stories.jsx": 660,
		"./docket/popups/DocketPopup.jsx": 259,
		"./docket/popups/DownloadCombineAllPdfInRangePopup.jsx": 171,
		"./docket/popups/DownloadZipAllPdfsRangePopup.jsx": 134,
		"./docket/popups/DownloadZipAllPdfsRangePopup.stories.jsx": 661,
		"./docket/popups/DownloadZipWithSubpartsPopup.jsx": 135,
		"./docket/popups/DownloadZipWithSubpartsPopup.stories.jsx": 662,
		"./docket/popups/EmailAllPartsZipPopup.jsx": 172,
		"./docket/popups/EmailAttachmentPurchaseForm.jsx": 260,
		"./docket/popups/EmailAttachmentPurchaseForm.stories.jsx": 663,
		"./docket/popups/EmailBulkModal.jsx": 202,
		"./docket/popups/EmailBulkModal.stories.jsx": 664,
		"./docket/popups/EmailCombinedPdfPopup.jsx": 173,
		"./docket/popups/EmailForm.jsx": 261,
		"./docket/popups/EmailPartModal/EmailPartModal.jsx": 136,
		"./docket/popups/EmailPartModal/EmailPartModal.stories.jsx": 665,
		"./docket/popups/EmailPartPopup.jsx": 174,
		"./docket/popups/FileLinkMessage.jsx": 393,
		"./docket/popups/PrintAllPdfInRangePopup.jsx": 175,
		"./filers/FilersCases.js": 262,
		"./filers/FilersCases.stories.jsx": 666,
		"./filers/FilersCasesContainer.js": 1138,
		"./filers/filersArray.js": 667,
		"./filers/index.js": 1139,
		"./history/History.js": 394,
		"./history/History.stories.jsx": 668,
		"./history/HistoryArray.js": 669,
		"./history/HistoryContainer.js": 1140,
		"./history/HistoryEntries.jsx": 395,
		"./history/HistoryEntriesTableBody.jsx": 396,
		"./history/HistoryEntry.jsx": 397,
		"./history/HistoryFilters.jsx": 398,
		"./history/HistoryPaginator.jsx": 399,
		"./history/HistoryParserFilter.jsx": 400,
		"./notice/NoticeOfBankruptcyCaseFiling.js": 1141,
		"./parties/PartiesCases.js": 263,
		"./parties/PartiesCases.stories.jsx": 670,
		"./parties/PartiesCasesContainer.js": 1142,
		"./parties/index.js": 1143,
		"./parties/partiesArray.js": 671,
		"./related_transaction/EmailPopup.jsx": 401,
		"./related_transaction/PublicLinkPopup.jsx": 402,
		"./related_transaction/RelatedTransaction.js": 264,
		"./related_transaction/RelatedTransaction.stories.jsx": 672,
		"./related_transaction/RelatedTransactionArray.js": 673,
		"./related_transaction/RelatedTransactionContainer.js": 1144,
		"./related_transaction/RelatedTransactionEntries.jsx": 403,
		"./related_transaction/RelatedTransactionPaginator.jsx": 404,
		"./related_transaction/RelatedTransactionsFilters.jsx": 405,
		"./related_transaction/RelatedTransactionsParser.jsx": 406,
		"./related_transaction/index.js": 1145,
		"./status/Status.js": 265,
		"./status/Status.stories.jsx": 674,
		"./status/StatusContainer.js": 1146,
		"./status/index.js": 1147,
		"./summary/CaseSummary.js": 1148
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 965;


/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(751);

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1317);

/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(753);

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(754);

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(755);

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(756);

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1329);

/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(757);

/***/ },
/* 974 */
/***/ function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;

/***/ },
/* 975 */
334,
/* 976 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/* eslint-disable */
	// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
	function murmurhash2_32_gc(str) {
	  var l = str.length,
	      h = l ^ l,
	      i = 0,
	      k;
	
	  while (l >= 4) {
	    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    k ^= k >>> 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
	    l -= 4;
	    ++i;
	  }
	
	  switch (l) {
	    case 3:
	      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	
	    case 2:
	      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	
	    case 1:
	      h ^= str.charCodeAt(i) & 0xff;
	      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  }
	
	  h ^= h >>> 13;
	  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  h ^= h >>> 15;
	  return (h >>> 0).toString(36);
	}
	
	exports.default = murmurhash2_32_gc;


/***/ },
/* 977 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function memoize(fn) {
	  var cache = {};
	  return function (arg) {
	    if (cache[arg] === undefined) cache[arg] = fn(arg);
	    return cache[arg];
	  };
	}
	
	exports.default = memoize;


/***/ },
/* 978 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function stylis_min (W) {
	  function M(d, c, e, h, a) {
	    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
	      g = e.charCodeAt(l);
	      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
	
	      if (0 === b + n + v + m) {
	        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
	          switch (g) {
	            case 32:
	            case 9:
	            case 59:
	            case 13:
	            case 10:
	              break;
	
	            default:
	              f += e.charAt(l);
	          }
	
	          g = 59;
	        }
	
	        switch (g) {
	          case 123:
	            f = f.trim();
	            q = f.charCodeAt(0);
	            k = 1;
	
	            for (t = ++l; l < B;) {
	              switch (g = e.charCodeAt(l)) {
	                case 123:
	                  k++;
	                  break;
	
	                case 125:
	                  k--;
	                  break;
	
	                case 47:
	                  switch (g = e.charCodeAt(l + 1)) {
	                    case 42:
	                    case 47:
	                      a: {
	                        for (u = l + 1; u < J; ++u) {
	                          switch (e.charCodeAt(u)) {
	                            case 47:
	                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                              break;
	
	                            case 10:
	                              if (47 === g) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                          }
	                        }
	
	                        l = u;
	                      }
	
	                  }
	
	                  break;
	
	                case 91:
	                  g++;
	
	                case 40:
	                  g++;
	
	                case 34:
	                case 39:
	                  for (; l++ < J && e.charCodeAt(l) !== g;) {
	                  }
	
	              }
	
	              if (0 === k) break;
	              l++;
	            }
	
	            k = e.substring(t, l);
	            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
	
	            switch (q) {
	              case 64:
	                0 < r && (f = f.replace(N, ''));
	                g = f.charCodeAt(1);
	
	                switch (g) {
	                  case 100:
	                  case 109:
	                  case 115:
	                  case 45:
	                    r = c;
	                    break;
	
	                  default:
	                    r = O;
	                }
	
	                k = M(c, r, k, g, a + 1);
	                t = k.length;
	                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
	                if (0 < t) switch (g) {
	                  case 115:
	                    f = f.replace(da, ea);
	
	                  case 100:
	                  case 109:
	                  case 45:
	                    k = f + '{' + k + '}';
	                    break;
	
	                  case 107:
	                    f = f.replace(fa, '$1 $2');
	                    k = f + '{' + k + '}';
	                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
	                    break;
	
	                  default:
	                    k = f + k, 112 === h && (k = (p += k, ''));
	                } else k = '';
	                break;
	
	              default:
	                k = M(c, X(c, f, I), k, h, a + 1);
	            }
	
	            F += k;
	            k = I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	            break;
	
	          case 125:
	          case 59:
	            f = (0 < r ? f.replace(N, '') : f).trim();
	            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
	              case 0:
	                break;
	
	              case 64:
	                if (105 === g || 99 === g) {
	                  G += f + e.charAt(l);
	                  break;
	                }
	
	              default:
	                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
	            }
	            I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	        }
	      }
	
	      switch (g) {
	        case 13:
	        case 10:
	          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
	          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
	          z = 1;
	          D++;
	          break;
	
	        case 59:
	        case 125:
	          if (0 === b + n + v + m) {
	            z++;
	            break;
	          }
	
	        default:
	          z++;
	          y = e.charAt(l);
	
	          switch (g) {
	            case 9:
	            case 32:
	              if (0 === n + m + b) switch (x) {
	                case 44:
	                case 58:
	                case 9:
	                case 32:
	                  y = '';
	                  break;
	
	                default:
	                  32 !== g && (y = ' ');
	              }
	              break;
	
	            case 0:
	              y = '\\0';
	              break;
	
	            case 12:
	              y = '\\f';
	              break;
	
	            case 11:
	              y = '\\v';
	              break;
	
	            case 38:
	              0 === n + b + m && (r = I = 1, y = '\f' + y);
	              break;
	
	            case 108:
	              if (0 === n + b + m + E && 0 < u) switch (l - u) {
	                case 2:
	                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
	
	                case 8:
	                  111 === K && (E = K);
	              }
	              break;
	
	            case 58:
	              0 === n + b + m && (u = l);
	              break;
	
	            case 44:
	              0 === b + v + n + m && (r = 1, y += '\r');
	              break;
	
	            case 34:
	            case 39:
	              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
	              break;
	
	            case 91:
	              0 === n + b + v && m++;
	              break;
	
	            case 93:
	              0 === n + b + v && m--;
	              break;
	
	            case 41:
	              0 === n + b + m && v--;
	              break;
	
	            case 40:
	              if (0 === n + b + m) {
	                if (0 === q) switch (2 * x + 3 * K) {
	                  case 533:
	                    break;
	
	                  default:
	                    q = 1;
	                }
	                v++;
	              }
	
	              break;
	
	            case 64:
	              0 === b + v + n + m + u + k && (k = 1);
	              break;
	
	            case 42:
	            case 47:
	              if (!(0 < n + m + v)) switch (b) {
	                case 0:
	                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
	                    case 235:
	                      b = 47;
	                      break;
	
	                    case 220:
	                      t = l, b = 42;
	                  }
	
	                  break;
	
	                case 42:
	                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
	              }
	          }
	
	          0 === b && (f += y);
	      }
	
	      K = x;
	      x = g;
	      l++;
	    }
	
	    t = p.length;
	
	    if (0 < t) {
	      r = c;
	      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
	      p = r.join(',') + '{' + p + '}';
	
	      if (0 !== w * E) {
	        2 !== w || L(p, 2) || (E = 0);
	
	        switch (E) {
	          case 111:
	            p = p.replace(ha, ':-moz-$1') + p;
	            break;
	
	          case 112:
	            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
	        }
	
	        E = 0;
	      }
	    }
	
	    return G + p + F;
	  }
	
	  function X(d, c, e) {
	    var h = c.trim().split(ia);
	    c = h;
	    var a = h.length,
	        m = d.length;
	
	    switch (m) {
	      case 0:
	      case 1:
	        var b = 0;
	
	        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
	          c[b] = Z(d, c[b], e).trim();
	        }
	
	        break;
	
	      default:
	        var v = b = 0;
	
	        for (c = []; b < a; ++b) {
	          for (var n = 0; n < m; ++n) {
	            c[v++] = Z(d[n] + ' ', h[b], e).trim();
	          }
	        }
	
	    }
	
	    return c;
	  }
	
	  function Z(d, c, e) {
	    var h = c.charCodeAt(0);
	    33 > h && (h = (c = c.trim()).charCodeAt(0));
	
	    switch (h) {
	      case 38:
	        return c.replace(F, '$1' + d.trim());
	
	      case 58:
	        return d.trim() + c.replace(F, '$1' + d.trim());
	
	      default:
	        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
	    }
	
	    return d + c;
	  }
	
	  function P(d, c, e, h) {
	    var a = d + ';',
	        m = 2 * c + 3 * e + 4 * h;
	
	    if (944 === m) {
	      d = a.indexOf(':', 9) + 1;
	      var b = a.substring(d, a.length - 1).trim();
	      b = a.substring(0, d).trim() + b + ';';
	      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
	    }
	
	    if (0 === w || 2 === w && !L(a, 1)) return a;
	
	    switch (m) {
	      case 1015:
	        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
	
	      case 951:
	        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
	
	      case 963:
	        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
	
	      case 1009:
	        if (100 !== a.charCodeAt(4)) break;
	
	      case 969:
	      case 942:
	        return '-webkit-' + a + a;
	
	      case 978:
	        return '-webkit-' + a + '-moz-' + a + a;
	
	      case 1019:
	      case 983:
	        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
	
	      case 883:
	        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
	        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
	        break;
	
	      case 932:
	        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
	          case 103:
	            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
	
	          case 98:
	            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
	        }
	        return '-webkit-' + a + '-ms-' + a + a;
	
	      case 964:
	        return '-webkit-' + a + '-ms-flex-' + a + a;
	
	      case 1023:
	        if (99 !== a.charCodeAt(8)) break;
	        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
	        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
	
	      case 1005:
	        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
	
	      case 1e3:
	        b = a.substring(13).trim();
	        c = b.indexOf('-') + 1;
	
	        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
	          case 226:
	            b = a.replace(G, 'tb');
	            break;
	
	          case 232:
	            b = a.replace(G, 'tb-rl');
	            break;
	
	          case 220:
	            b = a.replace(G, 'lr');
	            break;
	
	          default:
	            return a;
	        }
	
	        return '-webkit-' + a + '-ms-' + b + a;
	
	      case 1017:
	        if (-1 === a.indexOf('sticky', 9)) break;
	
	      case 975:
	        c = (a = d).length - 10;
	        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
	
	        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
	          case 203:
	            if (111 > b.charCodeAt(8)) break;
	
	          case 115:
	            a = a.replace(b, '-webkit-' + b) + ';' + a;
	            break;
	
	          case 207:
	          case 102:
	            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
	        }
	
	        return a + ';';
	
	      case 938:
	        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
	          case 105:
	            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
	
	          default:
	            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
	        }
	        break;
	
	      case 973:
	      case 989:
	        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
	
	      case 931:
	      case 953:
	        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
	        break;
	
	      case 962:
	        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
	    }
	
	    return a;
	  }
	
	  function L(d, c) {
	    var e = d.indexOf(1 === c ? ':' : '{'),
	        h = d.substring(0, 3 !== c ? e : 10);
	    e = d.substring(e + 1, d.length - 1);
	    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
	  }
	
	  function ea(d, c) {
	    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
	    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
	  }
	
	  function H(d, c, e, h, a, m, b, v, n, q) {
	    for (var g = 0, x = c, w; g < A; ++g) {
	      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
	        case void 0:
	        case !1:
	        case !0:
	        case null:
	          break;
	
	        default:
	          x = w;
	      }
	    }
	
	    if (x !== c) return x;
	  }
	
	  function T(d) {
	    switch (d) {
	      case void 0:
	      case null:
	        A = S.length = 0;
	        break;
	
	      default:
	        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
	          T(d[c]);
	        } else Y = !!d | 0;
	    }
	
	    return T;
	  }
	
	  function U(d) {
	    d = d.prefix;
	    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
	    return U;
	  }
	
	  function B(d, c) {
	    var e = d;
	    33 > e.charCodeAt(0) && (e = e.trim());
	    V = e;
	    e = [V];
	
	    if (0 < A) {
	      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
	      void 0 !== h && 'string' === typeof h && (c = h);
	    }
	
	    var a = M(O, e, c, 0, 0);
	    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
	    V = '';
	    E = 0;
	    z = D = 1;
	    return a;
	  }
	
	  var ca = /^\0+/g,
	      N = /[\0\r\f]/g,
	      aa = /: */g,
	      ka = /zoo|gra/,
	      ma = /([,: ])(transform)/g,
	      ia = /,\r+?/g,
	      F = /([\t\r\n ])*\f?&/g,
	      fa = /@(k\w+)\s*(\S*)\s*/,
	      Q = /::(place)/g,
	      ha = /:(read-only)/g,
	      G = /[svh]\w+-[tblr]{2}/,
	      da = /\(\s*(.*)\s*\)/g,
	      oa = /([\s\S]*?);/g,
	      ba = /-self|flex-/g,
	      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
	      la = /stretch|:\s*\w+\-(?:conte|avail)/,
	      ja = /([^-])(image-set\()/,
	      z = 1,
	      D = 1,
	      E = 0,
	      w = 1,
	      O = [],
	      S = [],
	      A = 0,
	      R = null,
	      Y = 0,
	      V = '';
	  B.use = T;
	  B.set = U;
	  void 0 !== W && U(W);
	  return B;
	}
	
	exports.default = stylis_min;


/***/ },
/* 979 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var unitlessKeys = {
	  animationIterationCount: 1,
	  borderImageOutset: 1,
	  borderImageSlice: 1,
	  borderImageWidth: 1,
	  boxFlex: 1,
	  boxFlexGroup: 1,
	  boxOrdinalGroup: 1,
	  columnCount: 1,
	  columns: 1,
	  flex: 1,
	  flexGrow: 1,
	  flexPositive: 1,
	  flexShrink: 1,
	  flexNegative: 1,
	  flexOrder: 1,
	  gridRow: 1,
	  gridRowEnd: 1,
	  gridRowSpan: 1,
	  gridRowStart: 1,
	  gridColumn: 1,
	  gridColumnEnd: 1,
	  gridColumnSpan: 1,
	  gridColumnStart: 1,
	  msGridRow: 1,
	  msGridRowSpan: 1,
	  msGridColumn: 1,
	  msGridColumnSpan: 1,
	  fontWeight: 1,
	  lineHeight: 1,
	  opacity: 1,
	  order: 1,
	  orphans: 1,
	  tabSize: 1,
	  widows: 1,
	  zIndex: 1,
	  zoom: 1,
	  WebkitLineClamp: 1,
	  // SVG-related properties
	  fillOpacity: 1,
	  floodOpacity: 1,
	  stopOpacity: 1,
	  strokeDasharray: 1,
	  strokeDashoffset: 1,
	  strokeMiterlimit: 1,
	  strokeOpacity: 1,
	  strokeWidth: 1
	};
	
	exports.default = unitlessKeys;


/***/ },
/* 980 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var isBrowser = "object" !== 'undefined';
	function getRegisteredStyles(registered, registeredStyles, classNames) {
	  var rawClassName = '';
	  classNames.split(' ').forEach(function (className) {
	    if (registered[className] !== undefined) {
	      registeredStyles.push(registered[className]);
	    } else {
	      rawClassName += className + " ";
	    }
	  });
	  return rawClassName;
	}
	var insertStyles = function insertStyles(cache, serialized, isStringTag) {
	  var className = cache.key + "-" + serialized.name;
	
	  if ( // we only need to add the styles to the registered cache if the
	  // class name could be used further down
	  // the tree but if it's a string tag, we know it won't
	  // so we don't have to add it to registered cache.
	  // this improves memory usage since we can avoid storing the whole style string
	  (isStringTag === false || // we need to always store it if we're in compat mode and
	  // in node since emotion-server relies on whether a style is in
	  // the registered cache to know whether a style is global or not
	  // also, note that this check will be dead code eliminated in the browser
	  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
	    cache.registered[className] = serialized.styles;
	  }
	
	  if (cache.inserted[serialized.name] === undefined) {
	    var current = serialized;
	
	    do {
	      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
	
	      current = current.next;
	    } while (current !== undefined);
	  }
	};
	
	exports.getRegisteredStyles = getRegisteredStyles;
	exports.insertStyles = insertStyles;


/***/ },
/* 981 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var weakMemoize = function weakMemoize(func) {
	  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
	  var cache = new WeakMap();
	  return function (arg) {
	    if (cache.has(arg)) {
	      // $FlowFixMe
	      return cache.get(arg);
	    }
	
	    var ret = func(arg);
	    cache.set(arg, ret);
	    return ret;
	  };
	};
	
	exports.default = weakMemoize;


/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(745);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(209);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _weakMap = __webpack_require__(1269);
	
	var _weakMap2 = _interopRequireDefault(_weakMap);
	
	exports.default = decycle;
	
	var _errors = __webpack_require__(984);
	
	var _util = __webpack_require__(244);
	
	var _ = __webpack_require__(335);
	
	var _types = __webpack_require__(337);
	
	var _configureDepth = __webpack_require__(539);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	function decycle(object) {
	  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	
	  var objects = new _weakMap2.default();
	
	  var isCyclic = false;
	
	  var res = function derez(value, path, _depth, _branchDepthMax) {
	    var oldPath = void 0;
	    var obj = void 0;
	
	    var maxDepth = _branchDepthMax;
	
	    var result = (0, _util.typeReplacer)(value);
	
	    if (result) {
	      return result.value;
	    }
	
	    var type = typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value);
	
	    if (value instanceof Boolean || value instanceof Number || value instanceof String) {
	      return value;
	    }
	
	    if (type === 'object' && value !== null) {
	      oldPath = objects.get(value);
	      if (oldPath !== undefined) {
	        isCyclic = true;
	
	        return { $ref: oldPath };
	      }
	
	      try {
	        objects.set(value, path);
	      } catch (error) {
	        console.error(error); // eslint-disable-line no-console
	        return new _errors.DecycleError(error.message);
	      }
	
	      if (Array.isArray(value)) {
	        obj = [];
	        for (var i = 0; i < value.length; i += 1) {
	          obj[i] = derez(value[i], path + '[' + i + ']', _depth + 1, maxDepth);
	        }
	      } else {
	        obj = _types.objectType.serialize(value);
	
	        var newDepth = void 0;
	        if (hasOwnProperty.call(obj, _configureDepth.DEPTH_KEY)) {
	          if (_depth + 1 < maxDepth) {
	            var depthKey = obj[_configureDepth.DEPTH_KEY];
	
	            newDepth = depthKey === 0 ? 0 : _depth + depthKey;
	            maxDepth = newDepth >= depth ? depth : newDepth;
	          }
	
	          delete obj[_configureDepth.DEPTH_KEY];
	        }
	
	        if (_depth <= maxDepth) {
	          (0, _util.getPropertiesList)(value).forEach(function (name) {
	            if (!(0, _util.omitProperty)(name)) {
	              try {
	                obj[name] = derez(value[name], path + '[' + (0, _stringify2.default)(name) + ']', _depth + 1, maxDepth);
	              } catch (error) {
	                console.error(error); // eslint-disable-line no-console
	                obj[name] = new _errors.DecycleError(error.message);
	              }
	            }
	          });
	        }
	      }
	
	      if (_depth === 0 && value instanceof Object && isCyclic) {
	        obj[_.CYCLIC_KEY] = true;
	      }
	
	      return obj;
	    }
	
	    return value;
	  }(object, '$', 0, depth);
	
	  return res;
	}

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(103);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(279);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(278);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _makeError = __webpack_require__(1904);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DecycleError = function (_BaseError) {
	  (0, _inherits3.default)(DecycleError, _BaseError);
	
	  function DecycleError() {
	    (0, _classCallCheck3.default)(this, DecycleError);
	    return (0, _possibleConstructorReturn3.default)(this, (DecycleError.__proto__ || (0, _getPrototypeOf2.default)(DecycleError)).apply(this, arguments));
	  }
	
	  return DecycleError;
	}(_makeError.BaseError);
	
	exports.default = DecycleError;

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DecycleError = undefined;
	
	var _DecycleError2 = __webpack_require__(983);
	
	var _DecycleError3 = _interopRequireDefault(_DecycleError2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.DecycleError = _DecycleError3.default;

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(209);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.default = retrocycle;
	
	var _reviver = __webpack_require__(538);
	
	var _reviver2 = _interopRequireDefault(_reviver);
	
	var _util = __webpack_require__(244);
	
	var _ = __webpack_require__(335);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line no-control-regex
	var pathReg = /^\$(?:\[(?:\d+|"(?:[^\\"\u0000-\u001f]|\\([\\"/bfnrt]|u[0-9a-zA-Z]{4}))*")])*$/;
	
	function retrocycle(json) {
	  var $ = JSON.parse(json, _reviver2.default);
	
	  if ((typeof $ === 'undefined' ? 'undefined' : (0, _typeof3.default)($)) !== 'object' || $ === null) {
	    return $;
	  }
	
	  (function rez(value) {
	    if (value && (typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object') {
	      if (Array.isArray(value)) {
	        for (var i = 0; i < value.length; i += 1) {
	          var item = value[i];
	          if (item && (typeof item === 'undefined' ? 'undefined' : (0, _typeof3.default)(item)) === 'object') {
	            var path = item.$ref;
	            if (typeof path === 'string' && pathReg.test(path)) {
	              value[i] = eval(path); // eslint-disable-line no-eval, no-param-reassign
	            } else {
	              rez(item);
	            }
	          }
	        }
	      } else {
	        // eslint-disable-next-line no-restricted-syntax, guard-for-in
	        for (var name in value) {
	          var _item = value[name];
	
	          if ((typeof _item === 'undefined' ? 'undefined' : (0, _typeof3.default)(_item)) === 'object' && _item !== null) {
	            var _path = _item.$ref;
	
	            if (typeof _path === 'string' && pathReg.test(_path)) {
	              value[name] = eval(_path); // eslint-disable-line no-eval, no-param-reassign
	            } else {
	              rez(_item);
	            }
	          }
	        }
	      }
	    }
	  })($);
	
	  (0, _util.muteProperty)(_.CYCLIC_KEY, $);
	
	  return $;
	}

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(113);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var KEY = '$___storybook.Date';
	
	var dateType = {
	  KEY: KEY,
	  is: function is(value) {
	    return value instanceof Date;
	  },
	  serialize: function serialize(value) {
	    return (0, _defineProperty3.default)({}, KEY, value.toISOString());
	  },
	  deserialize: function deserialize(value) {
	    return new Date(value[KEY]);
	  }
	};
	
	exports.default = dateType;

/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createBoundFunction;
	
	var _createFunction = __webpack_require__(336);
	
	var _createFunction2 = _interopRequireDefault(_createFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createBoundFunction(name) {
	  return (0, _createFunction2.default)(name).bind({});
	}

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createFunctionEval;
	
	var _isReserved = __webpack_require__(990);
	
	var _isReserved2 = _interopRequireDefault(_isReserved);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createFunctionEval(name) {
	  var fnName = (0, _isReserved2.default)(name) ? name + '$' : name;
	
	  // eslint-disable-next-line no-new-func
	  return new Function('return function ' + fnName + '() {}')();
	}

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(113);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _createBoundFunction = __webpack_require__(987);
	
	var _createBoundFunction2 = _interopRequireDefault(_createBoundFunction);
	
	var _createFunction = __webpack_require__(336);
	
	var _createFunction2 = _interopRequireDefault(_createFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var KEY = '$___storybook.functionName';
	
	var functionType = {
	  KEY: KEY,
	  is: function is(value) {
	    return typeof value === 'function';
	  },
	  serialize: function serialize(value) {
	    return (0, _defineProperty3.default)({}, KEY, value.name || '');
	  },
	  deserialize: function deserialize(value) {
	    var parts = value[KEY].split(' ');
	
	    return parts.length === 2 && parts[0] === 'bound' ? (0, _createBoundFunction2.default)(parts[1]) : (0, _createFunction2.default)(parts[0]);
	  }
	};
	
	exports.default = functionType;

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isReserved;
	
	var _reservedKeywords = __webpack_require__(991);
	
	var _reservedKeywords2 = _interopRequireDefault(_reservedKeywords);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isReserved(name) {
	  return _reservedKeywords2.default.indexOf(name) >= 0;
	}

/***/ },
/* 991 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var reservedWords = ['break', 'case', 'catch', 'class', 'continue', 'debugger', 'default', 'delete', 'do', 'else', 'export', 'extends', 'finally', 'for', 'function', 'if', 'import', 'in', 'instanceof', 'new', 'return', 'super', 'switch', 'this', 'throw', 'try', 'typeof', 'var', 'void', 'while', 'with', 'yield'];
	
	exports.default = reservedWords;

/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(113);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _isFinite = __webpack_require__(1261);
	
	var _isFinite2 = _interopRequireDefault(_isFinite);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var KEY = '$___storybook.Infinity';
	
	var InfinityType = {
	  KEY: KEY,
	  is: function is(value) {
	    return typeof value === 'number' && !(0, _isFinite2.default)(value);
	  },
	  serialize: function serialize(value) {
	    return (0, _defineProperty3.default)({}, KEY, value === Infinity);
	  },
	  deserialize: function deserialize(value) {
	    return value[KEY] ? Infinity : -Infinity;
	  }
	};
	
	exports.default = InfinityType;

/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(113);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _isNan = __webpack_require__(1262);
	
	var _isNan2 = _interopRequireDefault(_isNan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var KEY = '$___storybook.NaN';
	var NaNType = {
	  KEY: KEY,
	  is: function is(value) {
	    return typeof value === 'number' && (0, _isNan2.default)(value);
	  },
	  serialize: function serialize() {
	    return (0, _defineProperty3.default)({}, KEY, true);
	  },
	  deserialize: function deserialize() {
	    return NaN;
	  }
	};
	
	exports.default = NaNType;

/***/ },
/* 994 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = canAccessProperty;
	function canAccessProperty(key, value) {
	  var prop = void 0;
	
	  try {
	    prop = value[key];
	  } catch (error) {
	    console.error(error); // eslint-disable-line no-console
	  }
	
	  return !!prop;
	}

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(275);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = createNamedObject;
	
	var _createFunction = __webpack_require__(336);
	
	var _createFunction2 = _interopRequireDefault(_createFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createNamedObject(obj, key) {
	  var Func = (0, _createFunction2.default)(obj[key]);
	  var namedObj = new Func();
	
	  delete obj[key]; // eslint-disable-line no-param-reassign
	
	  (0, _assign2.default)(namedObj, obj);
	
	  return namedObj;
	}

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getObjectName;
	
	var _canAccessProperty = __webpack_require__(994);
	
	var _canAccessProperty2 = _interopRequireDefault(_canAccessProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getObjectName(value) {
	  if ((0, _canAccessProperty2.default)('toString', value)) {
	    var stringValue = value.toString();
	
	    if (stringValue.slice(0, 5) === 'class') {
	      return stringValue.slice(6, -3);
	    }
	
	    var type = stringValue.slice(8, -1);
	
	    if (stringValue.slice(1, 7) === 'object' && type !== 'Object') {
	      return type;
	    }
	
	    var parts = stringValue.match(/function (\w+).*/);
	
	    if (parts && parts.length === 2) {
	      return parts[1];
	    }
	  }
	
	  return value.constructor ? value.constructor.name : 'Object';
	}

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(113);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _createNamedObject = __webpack_require__(995);
	
	var _createNamedObject2 = _interopRequireDefault(_createNamedObject);
	
	var _getObjectName = __webpack_require__(996);
	
	var _getObjectName2 = _interopRequireDefault(_getObjectName);
	
	var _configureDepth2 = __webpack_require__(539);
	
	var _configureDepth3 = _interopRequireDefault(_configureDepth2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var maxDepth = 2;
	var KEY = '$___storybook.objectName';
	
	var objectType = {
	  KEY: KEY,
	  // is: (value) => , // not used
	  serialize: function serialize(value) {
	    var objectName = (0, _getObjectName2.default)(value);
	    if (objectName === 'Object') {
	      return (0, _defineProperty3.default)({}, KEY, objectName);
	    }
	
	    return (0, _configureDepth3.default)((0, _defineProperty3.default)({}, KEY, objectName), maxDepth);
	  },
	  deserialize: function deserialize(value) {
	    return (0, _createNamedObject2.default)(value, KEY);
	  }
	};
	
	exports.default = objectType;

/***/ },
/* 998 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createRegExp;
	function createRegExp(regExp) {
	  var parts = regExp.split('/');
	
	  return new RegExp(parts[1], parts[2]);
	}

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(113);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _createRegExp = __webpack_require__(998);
	
	var _createRegExp2 = _interopRequireDefault(_createRegExp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var KEY = '$___storybook.regExpKey';
	
	var regExpType = {
	  KEY: KEY,
	  is: function is(value) {
	    return value instanceof RegExp;
	  },
	  serialize: function serialize(value) {
	    return (0, _defineProperty3.default)({}, KEY, value.toString());
	  },
	  deserialize: function deserialize(value) {
	    return (0, _createRegExp2.default)(value[KEY]);
	  }
	};
	
	exports.default = regExpType;

/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _symbol = __webpack_require__(746);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	exports.default = createSymbol;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createSymbol(name) {
	  return (0, _symbol2.default)(name);
	}

/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(113);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _typeof2 = __webpack_require__(209);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _createSymbol = __webpack_require__(1000);
	
	var _createSymbol2 = _interopRequireDefault(_createSymbol);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var KEY = '$___storybook.symbolName';
	
	var symbolType = {
	  KEY: KEY,
	  is: function is(value) {
	    return (typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'symbol';
	  },
	  serialize: function serialize(value) {
	    return (0, _defineProperty3.default)({}, KEY, String(value).slice(7, -1) || null);
	  },
	  deserialize: function deserialize(value) {
	    return (0, _createSymbol2.default)(value[KEY]);
	  }
	};
	
	exports.default = symbolType;

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(113);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var KEY = '$___storybook.undefined';
	
	var undefinedType = {
	  KEY: KEY,
	  is: function is(value) {
	    return value === undefined;
	  },
	  serialize: function serialize() {
	    return (0, _defineProperty3.default)({}, KEY, true);
	  },
	  deserialize: function deserialize() {
	    return undefined;
	  }
	};
	
	exports.default = undefinedType;

/***/ },
/* 1003 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getPropertiesList;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	function getPropertiesList(value) {
	  var keys = [];
	
	  // eslint-disable-next-line no-restricted-syntax, guard-for-in
	  for (var name in value) {
	    try {
	      if (hasOwnProperty.call(value, name) || typeof value[name] !== 'function') {
	        keys.push(name);
	      }
	    } catch (error) {
	      // eslint-disable-next-line no-console
	      console.error('Error accessing property ' + name, error);
	    }
	  }
	
	  return keys;
	}

/***/ },
/* 1004 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isObject;
	var toString = Object.prototype.toString;
	function isObject(value) {
	  return toString.call(value) === '[object Object]';
	}

/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty = __webpack_require__(426);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	exports.default = muteProperty;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function muteProperty(key, value) {
	  return (0, _defineProperty2.default)(value, key, { enumerable: false });
	}

/***/ },
/* 1006 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = omitProperty;
	function omitProperty(name) {
	  return name.startsWith('__') || name.startsWith('STORYBOOK_');
	}

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(745);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	exports.default = prepareArguments;
	
	var _index = __webpack_require__(335);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function prepareArguments(arg, depth) {
	  try {
	    return (0, _stringify2.default)((0, _index.decycle)(arg, depth));
	  } catch (error) {
	    return error.toString(); // IE still cyclic.
	  }
	}

/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(337);
	
	function typeReplacer(value) {
	  var found = _types.types.find(function (type) {
	    return type.is(value);
	  });
	
	  if (found) {
	    return {
	      value: found.serialize(value)
	    };
	  }
	
	  return false;
	}
	
	exports.default = typeReplacer;

/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(337);
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	
	var allTypes = _types.types.concat(_types.objectType);
	
	function typeFilter(value) {
	  var found = allTypes.find(function (type) {
	    return hasOwnProperty.call(value, type.KEY);
	  });
	
	  if (found) {
	    return {
	      value: found.deserialize(value)
	    };
	  }
	
	  return false;
	}
	
	exports.default = typeFilter;

/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(114);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = action;
	
	var _v = __webpack_require__(2240);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _addons = __webpack_require__(338);
	
	var _addons2 = _interopRequireDefault(_addons);
	
	var _ = __webpack_require__(21);
	
	var _util = __webpack_require__(244);
	
	var _configureActions = __webpack_require__(541);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function action(name) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var actionOptions = (0, _extends3.default)({}, _configureActions.config, options);
	
	  // eslint-disable-next-line no-shadow
	  var handler = function action() {
	    for (var _len = arguments.length, _args = Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    var args = _args.map(function (arg) {
	      return (0, _util.prepareArguments)(arg, actionOptions.depth);
	    });
	    var channel = _addons2.default.getChannel();
	    var id = (0, _v2.default)();
	    channel.emit(_.EVENT_ID, {
	      id: id,
	      data: { name: name, args: args }
	    });
	  };
	
	  if (_util.canConfigureName && name && typeof name === 'string') {
	    Object.defineProperty(handler, 'name', { value: name });
	  }
	  return handler;
	}

/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(280);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.default = decorateAction;
	
	var _preview = __webpack_require__(542);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function decorateAction(decorators) {
	  return function (name, options) {
	    var callAction = (0, _preview.action)(name, options);
	    return function () {
	      for (var _len = arguments.length, _args = Array(_len), _key = 0; _key < _len; _key++) {
	        _args[_key] = arguments[_key];
	      }
	
	      var decorated = decorators.reduce(function (args, fn) {
	        return fn(args);
	      }, _args);
	      callAction.apply(undefined, (0, _toConsumableArray3.default)(decorated));
	    };
	  };
	}

/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(114);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(428);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _regenerator = __webpack_require__(1274);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(1270);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(103);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(140);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(279);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(278);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1015);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _components = __webpack_require__(1022);
	
	var _preview = __webpack_require__(543);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LinkTo = function (_PureComponent) {
	  (0, _inherits3.default)(LinkTo, _PureComponent);
	
	  function LinkTo() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, LinkTo);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = LinkTo.__proto__ || (0, _getPrototypeOf2.default)(LinkTo)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = {
	      href: '/'
	    };
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(LinkTo, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateHref(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      if (props.kind !== this.props.kind || props.story !== this.props.story) {
	        this.updateHref(props);
	      }
	    }
	  }, {
	    key: 'updateHref',
	    value: function () {
	      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(props) {
	        var href;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return (0, _preview.hrefTo)(props.kind, props.story);
	
	              case 2:
	                href = _context.sent;
	
	                this.setState({ href: href });
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function updateHref(_x) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return updateHref;
	    }()
	  }, {
	    key: 'handleClick',
	    value: function handleClick() {
	      (0, _preview.openLink)(this.props);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          kind = _props.kind,
	          story = _props.story,
	          rest = (0, _objectWithoutProperties3.default)(_props, ['kind', 'story']);
	
	
	      return _react2.default.createElement(_components.RoutedLink, (0, _extends3.default)({ href: this.state.href, onClick: this.handleClick }, rest));
	    }
	  }]);
	  return LinkTo;
	}(_react.PureComponent);
	
	exports.default = LinkTo;
	
	
	LinkTo.defaultProps = {
	  kind: null,
	  story: null
	};
	
	LinkTo.propTypes = {
	  kind: _propTypes2.default.string,
	  story: _propTypes2.default.string
	};

/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _link = __webpack_require__(1012);
	
	var _link2 = _interopRequireDefault(_link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _link2.default;

/***/ },
/* 1014 */
[2242, 1016],
/* 1015 */
[2243, 1014],
/* 1016 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1013);


/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PostmsgTransport = exports.KEY = undefined;
	
	var _promise = __webpack_require__(427);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(103);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(140);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	exports.default = createChannel;
	
	var _global = __webpack_require__(303);
	
	var _channels = __webpack_require__(1019);
	
	var _channels2 = _interopRequireDefault(_channels);
	
	var _jsonStringifySafe = __webpack_require__(1794);
	
	var _jsonStringifySafe2 = _interopRequireDefault(_jsonStringifySafe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var KEY = exports.KEY = 'storybook-channel'; /* eslint-disable no-underscore-dangle */
	
	var PostmsgTransport = exports.PostmsgTransport = function () {
	  function PostmsgTransport(config) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, PostmsgTransport);
	
	    this._config = config;
	    this._buffer = [];
	    this._handler = null;
	    _global.window.addEventListener('message', this._handleEvent.bind(this), false);
	    _global.document.addEventListener('DOMContentLoaded', function () {
	      return _this._flush();
	    });
	    // Check whether the config.page parameter has a valid value
	    if (config.page !== 'manager' && config.page !== 'preview') {
	      throw new Error('postmsg-channel: "config.page" cannot be "' + config.page + '"');
	    }
	  }
	
	  (0, _createClass3.default)(PostmsgTransport, [{
	    key: 'setHandler',
	    value: function setHandler(handler) {
	      this._handler = handler;
	    }
	  }, {
	    key: 'send',
	    value: function send(event) {
	      var _this2 = this;
	
	      var iframeWindow = this._getWindow();
	      if (!iframeWindow) {
	        return new _promise2.default(function (resolve, reject) {
	          _this2._buffer.push({ event: event, resolve: resolve, reject: reject });
	        });
	      }
	      var data = (0, _jsonStringifySafe2.default)({ key: KEY, event: event });
	      iframeWindow.postMessage(data, '*');
	      return _promise2.default.resolve(null);
	    }
	  }, {
	    key: '_flush',
	    value: function _flush() {
	      var _this3 = this;
	
	      var buffer = this._buffer;
	      this._buffer = [];
	      buffer.forEach(function (item) {
	        _this3.send(item.event).then(item.resolve).catch(item.reject);
	      });
	    }
	  }, {
	    key: '_getWindow',
	    value: function _getWindow() {
	      if (this._config.page === 'manager') {
	        // FIXME this is a really bad idea! use a better way to do this.
	        // This finds the storybook preview iframe to send messages to.
	        var iframe = _global.document.getElementById('storybook-preview-iframe');
	        if (!iframe) {
	          return null;
	        }
	        return iframe.contentWindow;
	      }
	      return _global.window.parent;
	    }
	  }, {
	    key: '_handleEvent',
	    value: function _handleEvent(rawEvent) {
	      try {
	        var data = rawEvent.data;
	
	        var _JSON$parse = JSON.parse(data),
	            key = _JSON$parse.key,
	            event = _JSON$parse.event;
	
	        if (key === KEY) {
	          this._handler(event);
	        }
	      } catch (error) {} // eslint-disable-line
	    }
	  }]);
	  return PostmsgTransport;
	}();
	
	function createChannel(_ref) {
	  var page = _ref.page;
	
	  var transport = new PostmsgTransport({ page: page });
	  return new _channels2.default({ transport: transport });
	}

/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(280);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _keys = __webpack_require__(277);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(103);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(140);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint no-underscore-dangle: 0 */
	
	var Channel = function () {
	  function Channel(_ref) {
	    var transport = _ref.transport;
	    (0, _classCallCheck3.default)(this, Channel);
	
	    this._sender = this._randomId();
	    this._transport = transport;
	    this._transport.setHandler(this._handleEvent.bind(this));
	    this._listeners = {};
	  }
	
	  (0, _createClass3.default)(Channel, [{
	    key: "addListener",
	    value: function addListener(type, listener) {
	      this.on(type, listener);
	    }
	  }, {
	    key: "addPeerListener",
	    value: function addPeerListener(type, listener) {
	      var _this = this;
	
	      var peerListener = listener;
	      peerListener.isPeer = function (from) {
	        return from === _this._sender;
	      };
	      this.on(type, peerListener);
	    }
	  }, {
	    key: "emit",
	    value: function emit(type) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var event = { type: type, args: args, from: this._sender };
	      this._transport.send(event);
	    }
	  }, {
	    key: "eventNames",
	    value: function eventNames() {
	      return (0, _keys2.default)(this._listeners);
	    }
	  }, {
	    key: "listenerCount",
	    value: function listenerCount(type) {
	      var listeners = this._listeners[type];
	      return listeners ? listeners.length : 0;
	    }
	  }, {
	    key: "listeners",
	    value: function listeners(type) {
	      return this._listeners[type];
	    }
	  }, {
	    key: "on",
	    value: function on(type, listener) {
	      this._listeners[type] = this._listeners[type] || [];
	      this._listeners[type].push(listener);
	    }
	  }, {
	    key: "once",
	    value: function once(type, listener) {
	      var onceListener = this._onceListener(type, listener);
	      this.on(type, onceListener);
	    }
	  }, {
	    key: "prependListener",
	    value: function prependListener(type, listener) {
	      this._listeners[type] = this._listeners[type] || [];
	      this._listeners[type].unshift(listener);
	    }
	  }, {
	    key: "prependOnceListener",
	    value: function prependOnceListener(type, listener) {
	      var onceListener = this._onceListener(type, listener);
	      this.prependListener(type, onceListener);
	    }
	  }, {
	    key: "removeAllListeners",
	    value: function removeAllListeners(type) {
	      if (!type) {
	        this._listeners = {};
	      } else if (this._listeners[type]) {
	        delete this._listeners[type];
	      }
	    }
	  }, {
	    key: "removeListener",
	    value: function removeListener(type, listener) {
	      var listeners = this._listeners[type];
	      if (listeners) {
	        this._listeners[type] = listeners.filter(function (l) {
	          return l !== listener;
	        });
	      }
	    }
	  }, {
	    key: "_randomId",
	    value: function _randomId() {
	      // generates a random 13 character string
	      return Math.random().toString(16).slice(2);
	    }
	  }, {
	    key: "_handleEvent",
	    value: function _handleEvent(event) {
	      var listeners = this._listeners[event.type];
	      if (listeners) {
	        listeners.forEach(function (fn) {
	          return !(fn.isPeer && fn.isPeer(event.from)) && fn.apply(undefined, (0, _toConsumableArray3.default)(event.args));
	        });
	      }
	    }
	  }, {
	    key: "_onceListener",
	    value: function _onceListener(type, listener) {
	      var _this2 = this;
	
	      var onceListener = function onceListener() {
	        _this2.removeListener(type, onceListener);
	        return listener.apply(undefined, arguments);
	      };
	      return onceListener;
	    }
	  }]);
	  return Channel;
	}();
	
	exports.default = Channel;

/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(114);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _glamorous = __webpack_require__(154);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _theme = __webpack_require__(546);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _glamorous2.default.button((0, _extends3.default)({}, _theme.baseFonts, {
	  border: 'none',
	  boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.2)',
	  backgroundColor: 'rgb(255, 255, 255)',
	  padding: '4px 10px 7px',
	  borderRadius: 4,
	  cursor: 'pointer',
	  transition: 'box-shadow 0.15s ease-out',
	  ':hover': {
	    transition: 'background-color 0.15s ease-out',
	    boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.3)'
	  },
	  ':focus': {
	    transition: 'background-color 0.15s ease-out',
	    outline: 'none',
	    boxShadow: '0 0 0 2px rgba(0, 0, 0, 0.3)'
	  },
	  ':active': {
	    transition: 'none',
	    backgroundColor: 'rgb(247, 247, 247)'
	  }
	})).withProps({ type: 'button' });

/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _glamorous = __webpack_require__(154);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _glamorous2.default.button({
	  border: '1px solid rgba(0, 0, 0, 0)',
	  font: 'inherit',
	  background: 'none',
	  boxShadow: 'none',
	  padding: 0,
	  ':hover': {
	    backgroundColor: 'rgba(0, 0, 0, 0.05)',
	    border: '1px solid #ccc'
	  }
	}, function (props) {
	  var styles = [];
	
	  if (props.highlight) {
	    styles.push({
	      backgroundColor: 'rgba(0, 0, 0, 0.05)',
	      border: '1px solid #ccc'
	    });
	  }
	
	  return styles;
	});

/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _theme = __webpack_require__(546);
	
	Object.defineProperty(exports, 'baseFonts', {
	  enumerable: true,
	  get: function get() {
	    return _theme.baseFonts;
	  }
	});
	Object.defineProperty(exports, 'monoFonts', {
	  enumerable: true,
	  get: function get() {
	    return _theme.monoFonts;
	  }
	});
	
	var _routed_link = __webpack_require__(545);
	
	Object.defineProperty(exports, 'RoutedLink', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routed_link).default;
	  }
	});
	
	var _menu_link = __webpack_require__(1023);
	
	Object.defineProperty(exports, 'MenuLink', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_menu_link).default;
	  }
	});
	
	var _highlight_button = __webpack_require__(1021);
	
	Object.defineProperty(exports, 'HighlightButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_highlight_button).default;
	  }
	});
	
	var _table = __webpack_require__(1025);
	
	Object.defineProperty(exports, 'Table', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_table).default;
	  }
	});
	
	var _cell = __webpack_require__(1024);
	
	Object.defineProperty(exports, 'Td', {
	  enumerable: true,
	  get: function get() {
	    return _cell.td;
	  }
	});
	Object.defineProperty(exports, 'Th', {
	  enumerable: true,
	  get: function get() {
	    return _cell.th;
	  }
	});
	
	var _button = __webpack_require__(1020);
	
	Object.defineProperty(exports, 'Button', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_button).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _glamorous = __webpack_require__(154);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _routed_link = __webpack_require__(545);
	
	var _routed_link2 = _interopRequireDefault(_routed_link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _glamorous2.default)(_routed_link2.default, { rootEl: 'a' })({
	  display: 'block',
	  color: '#828282',
	  textDecoration: 'none',
	  fontSize: '13px',
	  lineHeight: '16px',
	  padding: '1px 5px 4px',
	  marginLeft: '5px',
	  position: 'relative',
	  zIndex: 1
	}, function (_ref) {
	  var active = _ref.active;
	  return active && {
	    color: 'inherit',
	    fontWeight: 'bold',
	    backgroundColor: '#EEE',
	    zIndex: 0
	  };
	});

/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.th = exports.td = undefined;
	
	var _glamorous = __webpack_require__(154);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dynamicStyles = function dynamicStyles(props) {
	  var styles = [];
	
	  if (props.bordered) {
	    styles.push({
	      border: '1px solid #ccc'
	    });
	  }
	
	  if (props.code) {
	    styles.push({
	      whiteSpace: 'nowrap',
	      fontFamily: 'Monaco, Consolas, "Courier New", monospace'
	    });
	  }
	
	  return styles;
	};
	
	var styles = {
	  padding: '2px 6px'
	};
	
	var td = exports.td = _glamorous2.default.td(styles, dynamicStyles);
	var th = exports.th = _glamorous2.default.th(styles, dynamicStyles);

/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _glamorous = __webpack_require__(154);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _glamorous2.default.table({
	  borderCollapse: 'collapse'
	});

/***/ },
/* 1026 */
[2242, 1028],
/* 1027 */
[2243, 1026],
/* 1028 */
1016,
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1030).default;


/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _preview = __webpack_require__(1033);
	
	var _preview2 = _interopRequireDefault(_preview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _preview2.default;

/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(280);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _keys = __webpack_require__(277);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(114);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(103);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _clientLogger = __webpack_require__(544);
	
	var _story_store = __webpack_require__(547);
	
	var _story_store2 = _interopRequireDefault(_story_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint no-underscore-dangle: 0 */
	
	var defaultDecorateStory = function defaultDecorateStory(getStory, decorators) {
	  return decorators.reduce(function (decorated, decorator) {
	    return function (context) {
	      return decorator(function () {
	        return decorated(context);
	      }, context);
	    };
	  }, getStory);
	};
	
	var ClientApi = function ClientApi() {
	  var _this = this;
	
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$storyStore = _ref.storyStore,
	      storyStore = _ref$storyStore === undefined ? new _story_store2.default() : _ref$storyStore,
	      _ref$decorateStory = _ref.decorateStory,
	      decorateStory = _ref$decorateStory === undefined ? defaultDecorateStory : _ref$decorateStory;
	
	  (0, _classCallCheck3.default)(this, ClientApi);
	
	  this.setAddon = function (addon) {
	    _this._addons = (0, _extends3.default)({}, _this._addons, addon);
	  };
	
	  this.addDecorator = function (decorator) {
	    _this._globalDecorators.push(decorator);
	  };
	
	  this.clearDecorators = function () {
	    _this._globalDecorators = [];
	  };
	
	  this.storiesOf = function (kind, m) {
	    if (!kind && typeof kind !== 'string') {
	      throw new Error('Invalid or missing kind provided for stories, should be a string');
	    }
	
	    if (!m) {
	      _clientLogger.logger.warn('Missing \'module\' parameter for story with a kind of \'' + kind + '\'. It will break your HMR');
	    }
	
	    if (m && m.hot && m.hot.dispose) {
	      m.hot.dispose(function () {
	        _this._storyStore.removeStoryKind(kind);
	        _this._storyStore.incrementRevision();
	      });
	    }
	
	    var localDecorators = [];
	    var api = {
	      kind: kind
	    };
	
	    // apply addons
	    (0, _keys2.default)(_this._addons).forEach(function (name) {
	      var addon = _this._addons[name];
	      api[name] = function () {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        addon.apply(api, args);
	        return api;
	      };
	    });
	
	    api.add = function (storyName, getStory) {
	      if (typeof storyName !== 'string') {
	        throw new Error('Invalid or missing storyName provided for a "' + kind + '" story.');
	      }
	
	      if (_this._storyStore.hasStory(kind, storyName)) {
	        _clientLogger.logger.warn('Story of "' + kind + '" named "' + storyName + '" already exists');
	      }
	
	      // Wrap the getStory function with each decorator. The first
	      // decorator will wrap the story function. The second will
	      // wrap the first decorator and so on.
	      var decorators = [].concat(localDecorators, (0, _toConsumableArray3.default)(_this._globalDecorators));
	
	      var fileName = m ? m.filename : null;
	
	      // Add the fully decorated getStory function.
	      _this._storyStore.addStory(kind, storyName, _this._decorateStory(getStory, decorators), fileName);
	      return api;
	    };
	
	    api.addDecorator = function (decorator) {
	      localDecorators.push(decorator);
	      return api;
	    };
	
	    return api;
	  };
	
	  this.getStorybook = function () {
	    return _this._storyStore.getStoryKinds().map(function (kind) {
	      var fileName = _this._storyStore.getStoryFileName(kind);
	
	      var stories = _this._storyStore.getStories(kind).map(function (name) {
	        var render = _this._storyStore.getStory(kind, name);
	        return { name: name, render: render };
	      });
	
	      return { kind: kind, fileName: fileName, stories: stories };
	    });
	  };
	
	  this._storyStore = storyStore;
	  this._addons = {};
	  this._globalDecorators = [];
	  this._decorateStory = decorateStory;
	};
	
	exports.default = ClientApi;

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(103);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(140);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _global = __webpack_require__(303);
	
	var _actions = __webpack_require__(245);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint no-underscore-dangle: 0 */
	
	var ConfigApi = function () {
	  function ConfigApi(_ref) {
	    var _this = this;
	
	    var channel = _ref.channel,
	        storyStore = _ref.storyStore,
	        reduxStore = _ref.reduxStore,
	        clearDecorators = _ref.clearDecorators;
	    (0, _classCallCheck3.default)(this, ConfigApi);
	
	    this.configure = function (loaders, module) {
	      var render = function render() {
	        try {
	          _this._renderMain(loaders);
	        } catch (error) {
	          if (module.hot && module.hot.status() === 'apply') {
	            // We got this issue, after webpack fixed it and applying it.
	            // Therefore error message is displayed forever even it's being fixed.
	            // So, we'll detect it reload the page.
	            _global.location.reload();
	          } else {
	            // If we are accessing the site, but the error is not fixed yet.
	            // There we can render the error.
	            _this._renderError(error);
	          }
	        }
	      };
	
	      if (module.hot) {
	        module.hot.accept(function () {
	          setTimeout(render);
	        });
	        module.hot.dispose(function () {
	          _this._clearDecorators();
	        });
	      }
	
	      if (_this._channel) {
	        render();
	      } else {
	        loaders();
	      }
	    };
	
	    // channel can be null when running in node
	    // always check whether channel is available
	    this._channel = channel;
	    this._storyStore = storyStore;
	    this._reduxStore = reduxStore;
	    this._clearDecorators = clearDecorators;
	  }
	
	  (0, _createClass3.default)(ConfigApi, [{
	    key: '_renderMain',
	    value: function _renderMain(loaders) {
	      if (loaders) loaders();
	
	      var stories = this._storyStore.dumpStoryBook();
	      // send to the parent frame.
	      this._channel.emit('setStories', { stories: stories });
	
	      // clear the error if exists.
	      this._reduxStore.dispatch((0, _actions.clearError)());
	      this._reduxStore.dispatch((0, _actions.setInitialStory)(stories));
	    }
	  }, {
	    key: '_renderError',
	    value: function _renderError(e) {
	      var stack = e.stack,
	          message = e.message;
	
	      var error = { stack: stack, message: message };
	      this._reduxStore.dispatch((0, _actions.setError)(error));
	    }
	  }]);
	  return ConfigApi;
	}();
	
	exports.default = ConfigApi;

/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__(245);
	
	var Actions = _interopRequireWildcard(_actions);
	
	var _client_api = __webpack_require__(1031);
	
	var _client_api2 = _interopRequireDefault(_client_api);
	
	var _config_api = __webpack_require__(1032);
	
	var _config_api2 = _interopRequireDefault(_config_api);
	
	var _story_store = __webpack_require__(547);
	
	var _story_store2 = _interopRequireDefault(_story_store);
	
	var _reducer = __webpack_require__(1034);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _syncUrlWithStore = __webpack_require__(1035);
	
	var _syncUrlWithStore2 = _interopRequireDefault(_syncUrlWithStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = { Actions: Actions, ClientApi: _client_api2.default, ConfigApi: _config_api2.default, StoryStore: _story_store2.default, reducer: _reducer2.default, syncUrlWithStore: _syncUrlWithStore2.default };

/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(747);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _extends2 = __webpack_require__(114);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = reducer;
	
	var _actions = __webpack_require__(245);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actions.types.CLEAR_ERROR:
	      {
	        return (0, _extends3.default)({}, state, {
	          error: null
	        });
	      }
	
	    case _actions.types.SET_ERROR:
	      {
	        return (0, _extends3.default)({}, state, {
	          error: action.error
	        });
	      }
	
	    case _actions.types.SELECT_STORY:
	      {
	        return (0, _extends3.default)({}, state, {
	          selectedKind: action.kind,
	          selectedStory: action.story
	        });
	      }
	
	    case _actions.types.SET_INITIAL_STORY:
	      {
	        var newState = (0, _extends3.default)({}, state);
	        var storyKindList = action.storyKindList;
	
	        if (!newState.selectedKind && storyKindList.length > 0) {
	          newState.selectedKind = storyKindList[0].kind;
	
	          var _storyKindList$0$stor = (0, _slicedToArray3.default)(storyKindList[0].stories, 1);
	
	          newState.selectedStory = _storyKindList$0$stor[0];
	        }
	        return newState;
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(114);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = syncUrlToStore;
	
	var _qs = __webpack_require__(1037);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _global = __webpack_require__(303);
	
	var _actions = __webpack_require__(245);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Ensure the story in the redux store and on the preview URL are in sync.
	// In theory we should listen to pushState events but given it's an iframe
	// the user can't actually change the URL.
	// We should change this if we support a "preview only" mode in the future.
	function syncUrlToStore(reduxStore) {
	  // handle query params
	  var queryParams = _qs2.default.parse(_global.window.location.search.substring(1));
	  if (queryParams.selectedKind) {
	    reduxStore.dispatch((0, _actions.selectStory)(queryParams.selectedKind, queryParams.selectedStory));
	  }
	
	  reduxStore.subscribe(function () {
	    var _reduxStore$getState = reduxStore.getState(),
	        selectedKind = _reduxStore$getState.selectedKind,
	        selectedStory = _reduxStore$getState.selectedStory;
	
	    var queryString = _qs2.default.stringify((0, _extends3.default)({}, queryParams, {
	      selectedKind: selectedKind,
	      selectedStory: selectedStory
	    }));
	    _global.window.history.replaceState({}, '', '?' + queryString);
	  });
	}

/***/ },
/* 1036 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var objectCreate = Object.create || objectCreatePolyfill
	var objectKeys = Object.keys || objectKeysPolyfill
	var bind = Function.prototype.bind || functionBindPolyfill
	
	function EventEmitter() {
	  if (!this._events || !Object.prototype.hasOwnProperty.call(this, '_events')) {
	    this._events = objectCreate(null);
	    this._eventsCount = 0;
	  }
	
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	var defaultMaxListeners = 10;
	
	var hasDefineProperty;
	try {
	  var o = {};
	  if (Object.defineProperty) Object.defineProperty(o, 'x', { value: 0 });
	  hasDefineProperty = o.x === 0;
	} catch (err) { hasDefineProperty = false }
	if (hasDefineProperty) {
	  Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
	    enumerable: true,
	    get: function() {
	      return defaultMaxListeners;
	    },
	    set: function(arg) {
	      // check whether the input is a positive number (whose value is zero or
	      // greater and not a NaN).
	      if (typeof arg !== 'number' || arg < 0 || arg !== arg)
	        throw new TypeError('"defaultMaxListeners" must be a positive number');
	      defaultMaxListeners = arg;
	    }
	  });
	} else {
	  EventEmitter.defaultMaxListeners = defaultMaxListeners;
	}
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
	  if (typeof n !== 'number' || n < 0 || isNaN(n))
	    throw new TypeError('"n" argument must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	function $getMaxListeners(that) {
	  if (that._maxListeners === undefined)
	    return EventEmitter.defaultMaxListeners;
	  return that._maxListeners;
	}
	
	EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
	  return $getMaxListeners(this);
	};
	
	// These standalone emit* functions are used to optimize calling of event
	// handlers for fast cases because emit() itself often has a variable number of
	// arguments and can be deoptimized because of that. These functions always have
	// the same number of arguments and thus do not get deoptimized, so the code
	// inside them can execute faster.
	function emitNone(handler, isFn, self) {
	  if (isFn)
	    handler.call(self);
	  else {
	    var len = handler.length;
	    var listeners = arrayClone(handler, len);
	    for (var i = 0; i < len; ++i)
	      listeners[i].call(self);
	  }
	}
	function emitOne(handler, isFn, self, arg1) {
	  if (isFn)
	    handler.call(self, arg1);
	  else {
	    var len = handler.length;
	    var listeners = arrayClone(handler, len);
	    for (var i = 0; i < len; ++i)
	      listeners[i].call(self, arg1);
	  }
	}
	function emitTwo(handler, isFn, self, arg1, arg2) {
	  if (isFn)
	    handler.call(self, arg1, arg2);
	  else {
	    var len = handler.length;
	    var listeners = arrayClone(handler, len);
	    for (var i = 0; i < len; ++i)
	      listeners[i].call(self, arg1, arg2);
	  }
	}
	function emitThree(handler, isFn, self, arg1, arg2, arg3) {
	  if (isFn)
	    handler.call(self, arg1, arg2, arg3);
	  else {
	    var len = handler.length;
	    var listeners = arrayClone(handler, len);
	    for (var i = 0; i < len; ++i)
	      listeners[i].call(self, arg1, arg2, arg3);
	  }
	}
	
	function emitMany(handler, isFn, self, args) {
	  if (isFn)
	    handler.apply(self, args);
	  else {
	    var len = handler.length;
	    var listeners = arrayClone(handler, len);
	    for (var i = 0; i < len; ++i)
	      listeners[i].apply(self, args);
	  }
	}
	
	EventEmitter.prototype.emit = function emit(type) {
	  var er, handler, len, args, i, events;
	  var doError = (type === 'error');
	
	  events = this._events;
	  if (events)
	    doError = (doError && events.error == null);
	  else if (!doError)
	    return false;
	
	  // If there is no 'error' event listener then throw.
	  if (doError) {
	    if (arguments.length > 1)
	      er = arguments[1];
	    if (er instanceof Error) {
	      throw er; // Unhandled 'error' event
	    } else {
	      // At least give some kind of context to the user
	      var err = new Error('Unhandled "error" event. (' + er + ')');
	      err.context = er;
	      throw err;
	    }
	    return false;
	  }
	
	  handler = events[type];
	
	  if (!handler)
	    return false;
	
	  var isFn = typeof handler === 'function';
	  len = arguments.length;
	  switch (len) {
	      // fast cases
	    case 1:
	      emitNone(handler, isFn, this);
	      break;
	    case 2:
	      emitOne(handler, isFn, this, arguments[1]);
	      break;
	    case 3:
	      emitTwo(handler, isFn, this, arguments[1], arguments[2]);
	      break;
	    case 4:
	      emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
	      break;
	      // slower
	    default:
	      args = new Array(len - 1);
	      for (i = 1; i < len; i++)
	        args[i - 1] = arguments[i];
	      emitMany(handler, isFn, this, args);
	  }
	
	  return true;
	};
	
	function _addListener(target, type, listener, prepend) {
	  var m;
	  var events;
	  var existing;
	
	  if (typeof listener !== 'function')
	    throw new TypeError('"listener" argument must be a function');
	
	  events = target._events;
	  if (!events) {
	    events = target._events = objectCreate(null);
	    target._eventsCount = 0;
	  } else {
	    // To avoid recursion in the case that type === "newListener"! Before
	    // adding it to the listeners, first emit "newListener".
	    if (events.newListener) {
	      target.emit('newListener', type,
	          listener.listener ? listener.listener : listener);
	
	      // Re-assign `events` because a newListener handler could have caused the
	      // this._events to be assigned to a new object
	      events = target._events;
	    }
	    existing = events[type];
	  }
	
	  if (!existing) {
	    // Optimize the case of one listener. Don't need the extra array object.
	    existing = events[type] = listener;
	    ++target._eventsCount;
	  } else {
	    if (typeof existing === 'function') {
	      // Adding the second element, need to change to array.
	      existing = events[type] =
	          prepend ? [listener, existing] : [existing, listener];
	    } else {
	      // If we've already got an array, just append.
	      if (prepend) {
	        existing.unshift(listener);
	      } else {
	        existing.push(listener);
	      }
	    }
	
	    // Check for listener leak
	    if (!existing.warned) {
	      m = $getMaxListeners(target);
	      if (m && m > 0 && existing.length > m) {
	        existing.warned = true;
	        var w = new Error('Possible EventEmitter memory leak detected. ' +
	            existing.length + ' "' + String(type) + '" listeners ' +
	            'added. Use emitter.setMaxListeners() to ' +
	            'increase limit.');
	        w.name = 'MaxListenersExceededWarning';
	        w.emitter = target;
	        w.type = type;
	        w.count = existing.length;
	        if (typeof console === 'object' && console.warn) {
	          console.warn('%s: %s', w.name, w.message);
	        }
	      }
	    }
	  }
	
	  return target;
	}
	
	EventEmitter.prototype.addListener = function addListener(type, listener) {
	  return _addListener(this, type, listener, false);
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.prependListener =
	    function prependListener(type, listener) {
	      return _addListener(this, type, listener, true);
	    };
	
	function onceWrapper() {
	  if (!this.fired) {
	    this.target.removeListener(this.type, this.wrapFn);
	    this.fired = true;
	    switch (arguments.length) {
	      case 0:
	        return this.listener.call(this.target);
	      case 1:
	        return this.listener.call(this.target, arguments[0]);
	      case 2:
	        return this.listener.call(this.target, arguments[0], arguments[1]);
	      case 3:
	        return this.listener.call(this.target, arguments[0], arguments[1],
	            arguments[2]);
	      default:
	        var args = new Array(arguments.length);
	        for (var i = 0; i < args.length; ++i)
	          args[i] = arguments[i];
	        this.listener.apply(this.target, args);
	    }
	  }
	}
	
	function _onceWrap(target, type, listener) {
	  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
	  var wrapped = bind.call(onceWrapper, state);
	  wrapped.listener = listener;
	  state.wrapFn = wrapped;
	  return wrapped;
	}
	
	EventEmitter.prototype.once = function once(type, listener) {
	  if (typeof listener !== 'function')
	    throw new TypeError('"listener" argument must be a function');
	  this.on(type, _onceWrap(this, type, listener));
	  return this;
	};
	
	EventEmitter.prototype.prependOnceListener =
	    function prependOnceListener(type, listener) {
	      if (typeof listener !== 'function')
	        throw new TypeError('"listener" argument must be a function');
	      this.prependListener(type, _onceWrap(this, type, listener));
	      return this;
	    };
	
	// Emits a 'removeListener' event if and only if the listener was removed.
	EventEmitter.prototype.removeListener =
	    function removeListener(type, listener) {
	      var list, events, position, i, originalListener;
	
	      if (typeof listener !== 'function')
	        throw new TypeError('"listener" argument must be a function');
	
	      events = this._events;
	      if (!events)
	        return this;
	
	      list = events[type];
	      if (!list)
	        return this;
	
	      if (list === listener || list.listener === listener) {
	        if (--this._eventsCount === 0)
	          this._events = objectCreate(null);
	        else {
	          delete events[type];
	          if (events.removeListener)
	            this.emit('removeListener', type, list.listener || listener);
	        }
	      } else if (typeof list !== 'function') {
	        position = -1;
	
	        for (i = list.length - 1; i >= 0; i--) {
	          if (list[i] === listener || list[i].listener === listener) {
	            originalListener = list[i].listener;
	            position = i;
	            break;
	          }
	        }
	
	        if (position < 0)
	          return this;
	
	        if (position === 0)
	          list.shift();
	        else
	          spliceOne(list, position);
	
	        if (list.length === 1)
	          events[type] = list[0];
	
	        if (events.removeListener)
	          this.emit('removeListener', type, originalListener || listener);
	      }
	
	      return this;
	    };
	
	EventEmitter.prototype.removeAllListeners =
	    function removeAllListeners(type) {
	      var listeners, events, i;
	
	      events = this._events;
	      if (!events)
	        return this;
	
	      // not listening for removeListener, no need to emit
	      if (!events.removeListener) {
	        if (arguments.length === 0) {
	          this._events = objectCreate(null);
	          this._eventsCount = 0;
	        } else if (events[type]) {
	          if (--this._eventsCount === 0)
	            this._events = objectCreate(null);
	          else
	            delete events[type];
	        }
	        return this;
	      }
	
	      // emit removeListener for all listeners on all events
	      if (arguments.length === 0) {
	        var keys = objectKeys(events);
	        var key;
	        for (i = 0; i < keys.length; ++i) {
	          key = keys[i];
	          if (key === 'removeListener') continue;
	          this.removeAllListeners(key);
	        }
	        this.removeAllListeners('removeListener');
	        this._events = objectCreate(null);
	        this._eventsCount = 0;
	        return this;
	      }
	
	      listeners = events[type];
	
	      if (typeof listeners === 'function') {
	        this.removeListener(type, listeners);
	      } else if (listeners) {
	        // LIFO order
	        for (i = listeners.length - 1; i >= 0; i--) {
	          this.removeListener(type, listeners[i]);
	        }
	      }
	
	      return this;
	    };
	
	function _listeners(target, type, unwrap) {
	  var events = target._events;
	
	  if (!events)
	    return [];
	
	  var evlistener = events[type];
	  if (!evlistener)
	    return [];
	
	  if (typeof evlistener === 'function')
	    return unwrap ? [evlistener.listener || evlistener] : [evlistener];
	
	  return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
	}
	
	EventEmitter.prototype.listeners = function listeners(type) {
	  return _listeners(this, type, true);
	};
	
	EventEmitter.prototype.rawListeners = function rawListeners(type) {
	  return _listeners(this, type, false);
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  if (typeof emitter.listenerCount === 'function') {
	    return emitter.listenerCount(type);
	  } else {
	    return listenerCount.call(emitter, type);
	  }
	};
	
	EventEmitter.prototype.listenerCount = listenerCount;
	function listenerCount(type) {
	  var events = this._events;
	
	  if (events) {
	    var evlistener = events[type];
	
	    if (typeof evlistener === 'function') {
	      return 1;
	    } else if (evlistener) {
	      return evlistener.length;
	    }
	  }
	
	  return 0;
	}
	
	EventEmitter.prototype.eventNames = function eventNames() {
	  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
	};
	
	// About 1.5x faster than the two-arg version of Array#splice().
	function spliceOne(list, index) {
	  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)
	    list[i] = list[k];
	  list.pop();
	}
	
	function arrayClone(arr, n) {
	  var copy = new Array(n);
	  for (var i = 0; i < n; ++i)
	    copy[i] = arr[i];
	  return copy;
	}
	
	function unwrapListeners(arr) {
	  var ret = new Array(arr.length);
	  for (var i = 0; i < ret.length; ++i) {
	    ret[i] = arr[i].listener || arr[i];
	  }
	  return ret;
	}
	
	function objectCreatePolyfill(proto) {
	  var F = function() {};
	  F.prototype = proto;
	  return new F;
	}
	function objectKeysPolyfill(obj) {
	  var keys = [];
	  for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k)) {
	    keys.push(k);
	  }
	  return k;
	}
	function functionBindPolyfill(context) {
	  var fn = this;
	  return function () {
	    return fn.apply(context, arguments);
	  };
	}


/***/ },
/* 1037 */
[2245, 1039, 1038, 548],
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(339);
	
	var has = Object.prototype.hasOwnProperty;
	
	var defaults = {
	    allowDots: false,
	    allowPrototypes: false,
	    arrayLimit: 20,
	    charset: 'utf-8',
	    charsetSentinel: false,
	    comma: false,
	    decoder: utils.decode,
	    delimiter: '&',
	    depth: 5,
	    ignoreQueryPrefix: false,
	    interpretNumericEntities: false,
	    parameterLimit: 1000,
	    parseArrays: true,
	    plainObjects: false,
	    strictNullHandling: false
	};
	
	var interpretNumericEntities = function (str) {
	    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
	        return String.fromCharCode(parseInt(numberStr, 10));
	    });
	};
	
	// This is what browsers will submit when the ✓ character occurs in an
	// application/x-www-form-urlencoded body and the encoding of the page containing
	// the form is iso-8859-1, or when the submitted form has an accept-charset
	// attribute of iso-8859-1. Presumably also with other charsets that do not contain
	// the ✓ character, such as us-ascii.
	var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
	
	// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
	var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
	
	var parseValues = function parseQueryStringValues(str, options) {
	    var obj = {};
	    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
	    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
	    var parts = cleanStr.split(options.delimiter, limit);
	    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
	    var i;
	
	    var charset = options.charset;
	    if (options.charsetSentinel) {
	        for (i = 0; i < parts.length; ++i) {
	            if (parts[i].indexOf('utf8=') === 0) {
	                if (parts[i] === charsetSentinel) {
	                    charset = 'utf-8';
	                } else if (parts[i] === isoSentinel) {
	                    charset = 'iso-8859-1';
	                }
	                skipIndex = i;
	                i = parts.length; // The eslint settings do not allow break;
	            }
	        }
	    }
	
	    for (i = 0; i < parts.length; ++i) {
	        if (i === skipIndex) {
	            continue;
	        }
	        var part = parts[i];
	
	        var bracketEqualsPos = part.indexOf(']=');
	        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
	
	        var key, val;
	        if (pos === -1) {
	            key = options.decoder(part, defaults.decoder, charset);
	            val = options.strictNullHandling ? null : '';
	        } else {
	            key = options.decoder(part.slice(0, pos), defaults.decoder, charset);
	            val = options.decoder(part.slice(pos + 1), defaults.decoder, charset);
	        }
	
	        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
	            val = interpretNumericEntities(val);
	        }
	
	        if (val && options.comma && val.indexOf(',') > -1) {
	            val = val.split(',');
	        }
	
	        if (has.call(obj, key)) {
	            obj[key] = utils.combine(obj[key], val);
	        } else {
	            obj[key] = val;
	        }
	    }
	
	    return obj;
	};
	
	var parseObject = function (chain, val, options) {
	    var leaf = val;
	
	    for (var i = chain.length - 1; i >= 0; --i) {
	        var obj;
	        var root = chain[i];
	
	        if (root === '[]' && options.parseArrays) {
	            obj = [].concat(leaf);
	        } else {
	            obj = options.plainObjects ? Object.create(null) : {};
	            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
	            var index = parseInt(cleanRoot, 10);
	            if (!options.parseArrays && cleanRoot === '') {
	                obj = { 0: leaf };
	            } else if (
	                !isNaN(index)
	                && root !== cleanRoot
	                && String(index) === cleanRoot
	                && index >= 0
	                && (options.parseArrays && index <= options.arrayLimit)
	            ) {
	                obj = [];
	                obj[index] = leaf;
	            } else {
	                obj[cleanRoot] = leaf;
	            }
	        }
	
	        leaf = obj;
	    }
	
	    return leaf;
	};
	
	var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
	    if (!givenKey) {
	        return;
	    }
	
	    // Transform dot notation to bracket notation
	    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
	
	    // The regex chunks
	
	    var brackets = /(\[[^[\]]*])/;
	    var child = /(\[[^[\]]*])/g;
	
	    // Get the parent
	
	    var segment = options.depth > 0 && brackets.exec(key);
	    var parent = segment ? key.slice(0, segment.index) : key;
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (parent) {
	        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
	        if (!options.plainObjects && has.call(Object.prototype, parent)) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	
	        keys.push(parent);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
	        i += 1;
	        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	        keys.push(segment[1]);
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return parseObject(keys, val, options);
	};
	
	var normalizeParseOptions = function normalizeParseOptions(opts) {
	    if (!opts) {
	        return defaults;
	    }
	
	    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
	        throw new TypeError('Decoder has to be a function.');
	    }
	
	    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
	        throw new Error('The charset option must be either utf-8, iso-8859-1, or undefined');
	    }
	    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;
	
	    return {
	        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
	        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
	        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
	        charset: charset,
	        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
	        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
	        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
	        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
	        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
	        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
	        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
	        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
	        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
	        parseArrays: opts.parseArrays !== false,
	        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
	        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
	    };
	};
	
	module.exports = function (str, opts) {
	    var options = normalizeParseOptions(opts);
	
	    if (str === '' || str === null || typeof str === 'undefined') {
	        return options.plainObjects ? Object.create(null) : {};
	    }
	
	    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
	    var obj = options.plainObjects ? Object.create(null) : {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var newObj = parseKeys(key, tempObj[key], options);
	        obj = utils.merge(obj, newObj, options);
	    }
	
	    return utils.compact(obj);
	};


/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(339);
	var formats = __webpack_require__(548);
	var has = Object.prototype.hasOwnProperty;
	
	var arrayPrefixGenerators = {
	    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
	        return prefix + '[]';
	    },
	    comma: 'comma',
	    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
	        return prefix + '[' + key + ']';
	    },
	    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
	        return prefix;
	    }
	};
	
	var isArray = Array.isArray;
	var push = Array.prototype.push;
	var pushToArray = function (arr, valueOrArray) {
	    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
	};
	
	var toISO = Date.prototype.toISOString;
	
	var defaultFormat = formats['default'];
	var defaults = {
	    addQueryPrefix: false,
	    allowDots: false,
	    charset: 'utf-8',
	    charsetSentinel: false,
	    delimiter: '&',
	    encode: true,
	    encoder: utils.encode,
	    encodeValuesOnly: false,
	    format: defaultFormat,
	    formatter: formats.formatters[defaultFormat],
	    // deprecated
	    indices: false,
	    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
	        return toISO.call(date);
	    },
	    skipNulls: false,
	    strictNullHandling: false
	};
	
	var isNonNullishPrimitive = function isNonNullishPrimitive(v) { // eslint-disable-line func-name-matching
	    return typeof v === 'string'
	        || typeof v === 'number'
	        || typeof v === 'boolean'
	        || typeof v === 'symbol'
	        || typeof v === 'bigint'; // eslint-disable-line valid-typeof
	};
	
	var stringify = function stringify( // eslint-disable-line func-name-matching
	    object,
	    prefix,
	    generateArrayPrefix,
	    strictNullHandling,
	    skipNulls,
	    encoder,
	    filter,
	    sort,
	    allowDots,
	    serializeDate,
	    formatter,
	    encodeValuesOnly,
	    charset
	) {
	    var obj = object;
	    if (typeof filter === 'function') {
	        obj = filter(prefix, obj);
	    } else if (obj instanceof Date) {
	        obj = serializeDate(obj);
	    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
	        obj = obj.join(',');
	    }
	
	    if (obj === null) {
	        if (strictNullHandling) {
	            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset) : prefix;
	        }
	
	        obj = '';
	    }
	
	    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
	        if (encoder) {
	            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset);
	            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset))];
	        }
	        return [formatter(prefix) + '=' + formatter(String(obj))];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys;
	    if (isArray(filter)) {
	        objKeys = filter;
	    } else {
	        var keys = Object.keys(obj);
	        objKeys = sort ? keys.sort(sort) : keys;
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        if (isArray(obj)) {
	            pushToArray(values, stringify(
	                obj[key],
	                typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix,
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly,
	                charset
	            ));
	        } else {
	            pushToArray(values, stringify(
	                obj[key],
	                prefix + (allowDots ? '.' + key : '[' + key + ']'),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly,
	                charset
	            ));
	        }
	    }
	
	    return values;
	};
	
	var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
	    if (!opts) {
	        return defaults;
	    }
	
	    if (opts.encoder !== null && opts.encoder !== undefined && typeof opts.encoder !== 'function') {
	        throw new TypeError('Encoder has to be a function.');
	    }
	
	    var charset = opts.charset || defaults.charset;
	    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
	        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
	    }
	
	    var format = formats['default'];
	    if (typeof opts.format !== 'undefined') {
	        if (!has.call(formats.formatters, opts.format)) {
	            throw new TypeError('Unknown format option provided.');
	        }
	        format = opts.format;
	    }
	    var formatter = formats.formatters[format];
	
	    var filter = defaults.filter;
	    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
	        filter = opts.filter;
	    }
	
	    return {
	        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
	        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
	        charset: charset,
	        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
	        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
	        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
	        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
	        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
	        filter: filter,
	        formatter: formatter,
	        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
	        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
	        sort: typeof opts.sort === 'function' ? opts.sort : null,
	        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
	    };
	};
	
	module.exports = function (object, opts) {
	    var obj = object;
	    var options = normalizeStringifyOptions(opts);
	
	    var objKeys;
	    var filter;
	
	    if (typeof options.filter === 'function') {
	        filter = options.filter;
	        obj = filter('', obj);
	    } else if (isArray(options.filter)) {
	        filter = options.filter;
	        objKeys = filter;
	    }
	
	    var keys = [];
	
	    if (typeof obj !== 'object' || obj === null) {
	        return '';
	    }
	
	    var arrayFormat;
	    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
	        arrayFormat = opts.arrayFormat;
	    } else if (opts && 'indices' in opts) {
	        arrayFormat = opts.indices ? 'indices' : 'repeat';
	    } else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
	
	    if (!objKeys) {
	        objKeys = Object.keys(obj);
	    }
	
	    if (options.sort) {
	        objKeys.sort(options.sort);
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (options.skipNulls && obj[key] === null) {
	            continue;
	        }
	        pushToArray(keys, stringify(
	            obj[key],
	            key,
	            generateArrayPrefix,
	            options.strictNullHandling,
	            options.skipNulls,
	            options.encode ? options.encoder : null,
	            options.filter,
	            options.sort,
	            options.allowDots,
	            options.serializeDate,
	            options.formatter,
	            options.encodeValuesOnly,
	            options.charset
	        ));
	    }
	
	    var joined = keys.join(options.delimiter);
	    var prefix = options.addQueryPrefix === true ? '?' : '';
	
	    if (options.charsetSentinel) {
	        if (options.charset === 'iso-8859-1') {
	            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
	            prefix += 'utf8=%26%2310003%3B&';
	        } else {
	            // encodeURIComponent('✓')
	            prefix += 'utf8=%E2%9C%93&';
	        }
	    }
	
	    return joined.length > 0 ? prefix + joined : '';
	};


/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isPriorToFiber = exports.isValidFiberElement = undefined;
	
	var _slicedToArray2 = __webpack_require__(747);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(1807);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// return true if the element is renderable with react fiber
	var isValidFiberElement = exports.isValidFiberElement = function isValidFiberElement(element) {
	  return typeof element === 'string' || typeof element === 'number' || _react2.default.isValidElement(element);
	};
	
	var isPriorToFiber = exports.isPriorToFiber = function isPriorToFiber(version) {
	  var _version$split = version.split('.'),
	      _version$split2 = (0, _slicedToArray3.default)(_version$split, 1),
	      majorVersion = _version$split2[0];
	
	  return Number(majorVersion) < 16;
	};
	
	// accepts an element and return true if renderable else return false
	var isReactRenderable = function isReactRenderable(element) {
	  // storybook is running with a version prior to fiber,
	  // run a simple check on the element
	  if (isPriorToFiber(_react2.default.version)) {
	    return _react2.default.isValidElement(element);
	  }
	
	  // the element is not an array, check if its a fiber renderable element
	  if (!Array.isArray(element)) {
	    return isValidFiberElement(element);
	  }
	
	  // the element is in fact a list of elements (array),
	  // loop on its elements to see if its ok to render them
	  var elementsList = element.map(isReactRenderable);
	
	  // flatten the list of elements (possibly deep nested)
	  var flatList = (0, _lodash2.default)(elementsList);
	
	  // keep only invalid elements
	  var invalidElements = flatList.filter(function (elementIsRenderable) {
	    return elementIsRenderable === false;
	  });
	
	  // it's ok to render this list if there is no invalid elements inside
	  return !invalidElements.length;
	};
	
	exports.default = isReactRenderable;

/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(340);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mainStyle = {
	  position: 'fixed',
	  top: 0,
	  bottom: 0,
	  left: 0,
	  right: 0,
	  padding: 20,
	  backgroundColor: 'rgb(187, 49, 49)',
	  color: '#FFF',
	  WebkitFontSmoothing: 'antialiased'
	};
	
	var headingStyle = {
	  fontSize: 20,
	  fontWeight: 600,
	  letterSpacing: 0.2,
	  margin: '10px 0',
	  fontFamily: '\n    -apple-system, ".SFNSText-Regular", "San Francisco", Roboto, "Segoe UI",\n    "Helvetica Neue", "Lucida Grande", sans-serif\n    '
	};
	
	var codeStyle = {
	  fontSize: 14,
	  width: '100vw',
	  overflow: 'auto'
	};
	
	var ErrorDisplay = function ErrorDisplay(_ref) {
	  var error = _ref.error;
	  return _react2.default.createElement(
	    'div',
	    { style: mainStyle },
	    _react2.default.createElement(
	      'div',
	      { style: headingStyle },
	      error.message
	    ),
	    _react2.default.createElement(
	      'pre',
	      { style: codeStyle },
	      _react2.default.createElement(
	        'code',
	        null,
	        error.stack
	      )
	    )
	  );
	};
	
	ErrorDisplay.propTypes = {
	  error: _propTypes2.default.shape({
	    message: _propTypes2.default.string,
	    stack: _propTypes2.default.string
	  }).isRequired
	};
	
	exports.default = ErrorDisplay;

/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.forceReRender = exports.configure = exports.getStorybook = exports.clearDecorators = exports.addDecorator = exports.setAddon = exports.storiesOf = undefined;
	
	var _extends2 = __webpack_require__(114);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(275);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _redux = __webpack_require__(1059);
	
	var _addons = __webpack_require__(338);
	
	var _addons2 = _interopRequireDefault(_addons);
	
	var _global = __webpack_require__(303);
	
	var _channelPostmessage = __webpack_require__(1018);
	
	var _channelPostmessage2 = _interopRequireDefault(_channelPostmessage);
	
	var _key_events = __webpack_require__(1062);
	
	var _client = __webpack_require__(1029);
	
	var _render = __webpack_require__(1043);
	
	var _render2 = _interopRequireDefault(_render);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// check whether we're running on node/browser
	var isBrowser = _global.navigator && _global.navigator.userAgent && _global.navigator.userAgent !== 'storyshots' && !(_global.navigator.userAgent.indexOf('Node.js') > -1) && !(_global.navigator.userAgent.indexOf('jsdom') > -1);
	
	var storyStore = new _client.StoryStore();
	var reduxStore = (0, _redux.createStore)(_client.reducer);
	var context = { storyStore: storyStore, reduxStore: reduxStore };
	
	var clientApi = new _client.ClientApi(context);
	var storiesOf = clientApi.storiesOf,
	    setAddon = clientApi.setAddon,
	    addDecorator = clientApi.addDecorator,
	    clearDecorators = clientApi.clearDecorators,
	    getStorybook = clientApi.getStorybook;
	exports.storiesOf = storiesOf;
	exports.setAddon = setAddon;
	exports.addDecorator = addDecorator;
	exports.clearDecorators = clearDecorators;
	exports.getStorybook = getStorybook;
	
	
	var channel = void 0;
	if (isBrowser) {
	  // setup preview channel
	  channel = (0, _channelPostmessage2.default)({ page: 'preview' });
	  channel.on('setCurrentStory', function (data) {
	    reduxStore.dispatch(_client.Actions.selectStory(data.kind, data.story));
	  });
	  _addons2.default.setChannel(channel);
	  (0, _assign2.default)(context, { channel: channel });
	
	  (0, _client.syncUrlWithStore)(reduxStore);
	
	  // Handle keyboard shortcuts
	  _global.window.onkeydown = (0, _key_events.handleKeyboardShortcuts)(channel);
	}
	
	// Provide access to external scripts if `window` is defined.
	// NOTE this is different to isBrowser, primarily for the JSDOM use case
	if (typeof _global.window !== 'undefined') {
	  _global.window.__STORYBOOK_CLIENT_API__ = clientApi;
	  _global.window.__STORYBOOK_ADDONS_CHANNEL__ = channel; // may not be defined
	}
	
	var configApi = new _client.ConfigApi((0, _extends3.default)({ clearDecorators: clearDecorators }, context));
	var configure = configApi.configure;
	
	// initialize the UI
	
	exports.configure = configure;
	var renderUI = function renderUI() {
	  if (isBrowser) {
	    (0, _render2.default)(context);
	  }
	};
	
	reduxStore.subscribe(renderUI);
	
	var forceReRender = exports.forceReRender = function forceReRender() {
	  return (0, _render2.default)(context, true);
	};

/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _taggedTemplateLiteral2 = __webpack_require__(1271);
	
	var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
	
	var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n        Did you forget to return the React element from the story?\n        Use "() => (<MyComp/>)" or "() => { return <MyComp/>; }" when defining the story.\n      '], ['\n        Did you forget to return the React element from the story?\n        Use "() => (<MyComp/>)" or "() => { return <MyComp/>; }" when defining the story.\n      ']),
	    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n         Seems like you are not returning a correct React element from the story.\n         Could you double check that?\n       '], ['\n         Seems like you are not returning a correct React element from the story.\n         Could you double check that?\n       ']); /* global document */
	
	exports.renderError = renderError;
	exports.renderException = renderException;
	exports.renderMain = renderMain;
	exports.default = renderPreview;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _commonTags = __webpack_require__(1284);
	
	var _clientLogger = __webpack_require__(544);
	
	var _element_check = __webpack_require__(1040);
	
	var _element_check2 = _interopRequireDefault(_element_check);
	
	var _error_display = __webpack_require__(1041);
	
	var _error_display2 = _interopRequireDefault(_error_display);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// check whether we're running on node/browser
	var isBrowser = typeof window !== 'undefined';
	
	var rootEl = null;
	var previousKind = '';
	var previousStory = '';
	var previousRevision = -1;
	
	if (isBrowser) {
	  rootEl = document.getElementById('root');
	}
	
	function renderError(error) {
	  var properError = new Error(error.title);
	  properError.stack = error.description;
	
	  var redBox = _react2.default.createElement(_error_display2.default, { error: properError });
	  _reactDom2.default.render(redBox, rootEl);
	}
	
	function renderException(error) {
	  // We always need to render redbox in the mainPage if we get an error.
	  // Since this is an error, this affects to the main page as well.
	  var realError = new Error(error.message);
	  realError.stack = error.stack;
	  var redBox = _react2.default.createElement(_error_display2.default, { error: realError });
	  _reactDom2.default.render(redBox, rootEl);
	
	  // Log the stack to the console. So, user could check the source code.
	  _clientLogger.logger.error(error.stack);
	}
	
	function renderMain(data, storyStore, forceRender) {
	  if (storyStore.size() === 0) return null;
	
	  var NoPreview = function NoPreview() {
	    return _react2.default.createElement(
	      'p',
	      null,
	      'No Preview Available!'
	    );
	  };
	  var noPreview = _react2.default.createElement(NoPreview, null);
	  var selectedKind = data.selectedKind,
	      selectedStory = data.selectedStory;
	
	
	  var revision = storyStore.getRevision();
	  var story = storyStore.getStory(selectedKind, selectedStory);
	  if (!story) {
	    _reactDom2.default.render(noPreview, rootEl);
	    return null;
	  }
	
	  // Unmount the previous story only if selectedKind or selectedStory has changed.
	  // renderMain() gets executed after each action. Actions will cause the whole
	  // story to re-render without this check.
	  //    https://github.com/storybooks/react-storybook/issues/116
	  // However, we do want the story to re-render if the store itself has changed
	  // (which happens at the moment when HMR occurs)
	  if (!forceRender && revision === previousRevision && selectedKind === previousKind && previousStory === selectedStory) {
	    return null;
	  }
	
	  // We need to unmount the existing set of components in the DOM node.
	  // Otherwise, React may not recrease instances for every story run.
	  // This could leads to issues like below:
	  //    https://github.com/storybooks/react-storybook/issues/81
	  previousRevision = revision;
	  previousKind = selectedKind;
	  previousStory = selectedStory;
	  _reactDom2.default.unmountComponentAtNode(rootEl);
	
	  var context = {
	    kind: selectedKind,
	    story: selectedStory
	  };
	
	  var element = story(context);
	
	  if (!element) {
	    var error = {
	      title: 'Expecting a React element from the story: "' + selectedStory + '" of "' + selectedKind + '".',
	      description: (0, _commonTags.stripIndents)(_templateObject)
	    };
	    return renderError(error);
	  }
	
	  if (!(0, _element_check2.default)(element)) {
	    var _error = {
	      title: 'Expecting a valid React element from the story: "' + selectedStory + '" of "' + selectedKind + '".',
	      description: (0, _commonTags.stripIndents)(_templateObject2)
	    };
	    return renderError(_error);
	  }
	
	  _reactDom2.default.render(element, rootEl);
	  return null;
	}
	
	function renderPreview(_ref) {
	  var reduxStore = _ref.reduxStore,
	      storyStore = _ref.storyStore;
	  var forceRender = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var state = reduxStore.getState();
	  if (state.error) {
	    return renderException(state.error);
	  }
	
	  try {
	    return renderMain(state, storyStore, forceRender);
	  } catch (ex) {
	    return renderException(ex);
	  }
	}

/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(428);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _propTypes = __webpack_require__(340);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamorous = __webpack_require__(154);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = (0, _glamorous2.default)(function (_ref) {
	  var children = _ref.children,
	      rest = (0, _objectWithoutProperties3.default)(_ref, ['children']);
	  return _react2.default.createElement(
	    'button',
	    rest,
	    children
	  );
	})({
	  border: '1px solid #eee',
	  borderRadius: 3,
	  backgroundColor: '#FFFFFF',
	  cursor: 'pointer',
	  fontSize: 15,
	  padding: '3px 10px',
	  margin: 10
	});
	
	Button.displayName = 'Button';
	Button.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  onClick: _propTypes2.default.func
	};
	
	exports.default = Button;

/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(340);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _glamorous = __webpack_require__(154);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _react3 = __webpack_require__(1017);
	
	var _react4 = _interopRequireDefault(_react3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Main = _glamorous2.default.article({
	  margin: 15,
	  maxWidth: 600,
	  lineHeight: 1.4,
	  fontFamily: '"Helvetica Neue", Helvetica, "Segoe UI", Arial, freesans, sans-serif'
	});
	
	var Title = _glamorous2.default.h1({});
	
	var Note = _glamorous2.default.p({
	  opacity: 0.5
	});
	
	var InlineCode = _glamorous2.default.code({
	  fontSize: 15,
	  fontWeight: 600,
	  padding: '2px 5px',
	  border: '1px solid #eae9e9',
	  borderRadius: 4,
	  backgroundColor: '#f3f2f2',
	  color: '#3a3a3a'
	});
	
	var Link = _glamorous2.default.a({
	  color: '#1474f3',
	  textDecoration: 'none',
	  borderBottom: '1px solid #1474f3',
	  paddingBottom: 2
	});
	
	var NavButton = (0, _glamorous2.default)(Link.withComponent('button'))({
	  borderTop: 'none',
	  borderRight: 'none',
	  borderLeft: 'none',
	  backgroundColor: 'transparent',
	  padding: 0,
	  cursor: 'pointer',
	  font: 'inherit'
	});
	var StoryLink = Link.withComponent(_react4.default);
	
	var Welcome = function Welcome(props) {
	  return _react2.default.createElement(
	    Main,
	    null,
	    _react2.default.createElement(
	      Title,
	      null,
	      'Welcome to storybook'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This is a UI component dev environment for your app.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'We\'ve added some basic stories inside the ',
	      _react2.default.createElement(
	        InlineCode,
	        null,
	        'src/stories'
	      ),
	      ' directory.',
	      _react2.default.createElement('br', null),
	      'A story is a single state of one or more UI components. You can have as many stories as you want.',
	      _react2.default.createElement('br', null),
	      '(Basically a story is like a visual test case.)'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'See these sample',
	      ' ',
	      props.showApp ? _react2.default.createElement(
	        NavButton,
	        { onClick: props.showApp },
	        'stories'
	      ) : _react2.default.createElement(
	        StoryLink,
	        { kind: props.showKind, story: props.showStory },
	        'stories'
	      ),
	      ' ',
	      'for a component called ',
	      _react2.default.createElement(
	        InlineCode,
	        null,
	        'Button'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Just like that, you can add your own components as stories.',
	      _react2.default.createElement('br', null),
	      'You can also edit those components and see changes right away.',
	      _react2.default.createElement('br', null),
	      '(Try editing the ',
	      _react2.default.createElement(
	        InlineCode,
	        null,
	        'Button'
	      ),
	      ' stories located at',
	      ' ',
	      _react2.default.createElement(
	        InlineCode,
	        null,
	        'src/stories/index.js'
	      ),
	      '.)'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Usually we create stories with smaller UI components in the app.',
	      _react2.default.createElement('br', null),
	      'Have a look at the',
	      ' ',
	      _react2.default.createElement(
	        Link,
	        {
	          href: 'https://storybook.js.org/basics/writing-stories',
	          target: '_blank',
	          rel: 'noopener noreferrer'
	        },
	        'Writing Stories'
	      ),
	      ' ',
	      'section in our documentation.'
	    ),
	    _react2.default.createElement(
	      Note,
	      null,
	      _react2.default.createElement(
	        'b',
	        null,
	        'NOTE:'
	      ),
	      _react2.default.createElement('br', null),
	      'Have a look at the ',
	      _react2.default.createElement(
	        InlineCode,
	        null,
	        '.storybook/webpack.config.js'
	      ),
	      ' to add webpack loaders and plugins you are using in this project.'
	    )
	  );
	};
	
	Welcome.displayName = 'Welcome';
	Welcome.propTypes = {
	  showApp: _propTypes2.default.func,
	  showKind: _propTypes2.default.string,
	  showStory: _propTypes2.default.string
	};
	Welcome.defaultProps = {
	  showApp: null,
	  showKind: null,
	  showStory: null
	};
	
	exports.default = Welcome;

/***/ },
/* 1046 */
[2247, 549, 1049, 1050],
/* 1047 */
852,
/* 1048 */
[2248, 1051],
/* 1049 */
[2249, 549],
/* 1050 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 1051 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 1052 */
[2250, 1047],
/* 1053 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 1054 */
[2242, 1055],
/* 1055 */
1016,
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(551);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 1057 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(552);
	
	var _isPlainObject = __webpack_require__(550);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(553);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(552);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(1058);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(1057);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(1056);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(551);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(553);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(1061);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(16)(module)))

/***/ },
/* 1061 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.features = undefined;
	exports.isModifierPressed = isModifierPressed;
	exports.default = handle;
	exports.handleKeyboardShortcuts = handleKeyboardShortcuts;
	
	var _keycode = __webpack_require__(304);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var features = exports.features = {
	  FULLSCREEN: 'FULLSCREEN',
	  ADDON_PANEL: 'ADDON_PANEL',
	  STORIES_PANEL: 'STORIES_PANEL',
	  SHORTCUTS_HELP: 'SHORTCUTS_HELP',
	  ESCAPE: 'ESCAPE',
	  NEXT_STORY: 'NEXT_STORY',
	  PREV_STORY: 'PREV_STORY',
	  SHOW_SEARCH: 'SHOW_SEARCH',
	  ADDON_PANEL_IN_RIGHT: 'ADDON_PANEL_IN_RIGHT'
	}; /* eslint-disable no-fallthrough */
	function isModifierPressed(e) {
	  return (e.ctrlKey || e.keyCode === 91 || e.metaKey) && e.shiftKey;
	}
	
	function focusInInput(e) {
	  return (/input|textarea/i.test(e.target.tagName) || e.target.getAttribute('contenteditable') !== null
	  );
	}
	
	function handle(e) {
	  if (e.keyCode === (0, _keycode2.default)('escape')) {
	    // We don't need to preventDefault escape.
	    // Just getting the event is enough for us.
	    return features.ESCAPE;
	  }
	  if (focusInInput(e)) {
	    // if we're focused in an element that accepts input,
	    // then we shouldn't perform a shortcut action
	    return false;
	  }
	
	  if (!isModifierPressed(e)) return false;
	
	  switch (e.keyCode) {
	    case (0, _keycode2.default)('F'):
	      e.preventDefault();
	      return features.FULLSCREEN;
	    case (0, _keycode2.default)('C'):
	    // backward-compatibility
	    case (0, _keycode2.default)('D'):
	      e.preventDefault();
	      return features.ADDON_PANEL;
	    case (0, _keycode2.default)('X'):
	    // backward-compatibility
	    case (0, _keycode2.default)('L'):
	      e.preventDefault();
	      return features.STORIES_PANEL;
	    case (0, _keycode2.default)('right'):
	      e.preventDefault();
	      return features.NEXT_STORY;
	    case (0, _keycode2.default)('left'):
	      e.preventDefault();
	      return features.PREV_STORY;
	    case (0, _keycode2.default)('O'):
	    // backward-compatibility
	    case (0, _keycode2.default)('P'):
	      e.preventDefault();
	      return features.SHOW_SEARCH;
	    case (0, _keycode2.default)('G'):
	    // backward-compatibility
	    case (0, _keycode2.default)('J'):
	      e.preventDefault();
	      return features.ADDON_PANEL_IN_RIGHT;
	    default:
	      return false;
	  }
	}
	
	// window.keydown handler to dispatch a key event to the preview channel
	function handleKeyboardShortcuts(channel) {
	  return function (event) {
	    var parsedEvent = handle(event);
	    if (parsedEvent) {
	      channel.emit('applyShortcut', { event: parsedEvent });
	    }
	  };
	}

/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _addonLinks = __webpack_require__(168);
	
	var _demo = __webpack_require__(246);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Welcome', module).add('to Storybook', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Welcome to Storybook'
	    ),
	    'Stories can be used for development and validation.'
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = DocketAlerts;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useDataApi2 = __webpack_require__(60);
	
	var _useDataApi3 = _interopRequireDefault(_useDataApi2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _luxon = __webpack_require__(497);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DocketAlerts() {
	  // TODO - we don't handle paging in the UI yet...
	  var _useDataApi = (0, _useDataApi3.default)('/rpc/admin/docket-alerts?page_size=1000'),
	      _useDataApi$ = _useDataApi[0],
	      data = _useDataApi$.data,
	      isLoading = _useDataApi$.isLoading,
	      isError = _useDataApi$.isError;
	
	  if (isLoading) return _react2.default.createElement(_reactBootstrap.ProgressBar, { now: 100, active: true });
	
	  if (isError) return _react2.default.createElement(
	    _reactBootstrap.Alert,
	    { bsStyle: 'danger' },
	    'There has been an error loading the list of Docket Alerts.',
	    _react2.default.createElement(
	      'pre',
	      null,
	      '' + isError
	    )
	  );
	
	  return _react2.default.createElement(
	    _reactBootstrap.Table,
	    { striped: true, bordered: true, condensed: true, hover: true },
	    _react2.default.createElement(
	      'thead',
	      null,
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'th',
	          null,
	          'Uid'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'CaseUUID'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'NextRun'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Frequency'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Enaled'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'tbody',
	      null,
	      data.alerts.map(function (alert) {
	        return _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/user/' + alert.uid + '/edit' },
	              alert.uid
	            )
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/filings/' + alert.case_uuid },
	              alert.case_uuid
	            )
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _luxon.DateTime.fromISO(alert.next_run).setZone(alert.time_zone).toFormat('DDDD t ZZZZ')
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            alert.frequency
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            alert.enabled && 'Yes'
	          )
	        );
	      })
	    )
	  );
	}

/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = ClioCaseFolderSettings;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useDataApi2 = __webpack_require__(60);
	
	var _useDataApi3 = _interopRequireDefault(_useDataApi2);
	
	var _ClioCaseFolderSettingsForm = __webpack_require__(555);
	
	var _ClioCaseFolderSettingsForm2 = _interopRequireDefault(_ClioCaseFolderSettingsForm);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _Notification = __webpack_require__(24);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _onSave = function _onSave(connectionId, casefolderId, settings) {
	  return _superagent2.default.post('/rpc/integrations/connections/' + connectionId + '/clio/casefolders/' + casefolderId).send(settings).then(function (res) {
	    _Notification.notify.success('Clio CaseFolder Settings Saved');
	  }, function (errRes) {
	    var _ref;
	
	    return _ref = {}, _ref[_reactFinalForm.FORM_ERROR] = 'Error Saving', _ref;
	  });
	};
	
	function ClioCaseFolderSettings(_ref2) {
	  var connection_id = _ref2.connection_id,
	      casefolder_id = _ref2.casefolder_id,
	      uid = _ref2.uid;
	
	  var _useDataApi = (0, _useDataApi3.default)('/rpc/integrations/connections/' + connection_id + '/clio/casefolders/' + casefolder_id, {}),
	      _useDataApi$ = _useDataApi[0],
	      data = _useDataApi$.data,
	      isLoading = _useDataApi$.isLoading,
	      isError = _useDataApi$.isError;
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_Notification2.default, null),
	    _react2.default.createElement(_ClioCaseFolderSettingsForm2.default, {
	      connectionId: connection_id,
	      caseFolderId: casefolder_id,
	      onSave: function onSave(settings) {
	        return _onSave(connection_id, casefolder_id, settings);
	      },
	      settings: data
	    })
	  );
	}

/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FinalFormClioClientSelector = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _async = __webpack_require__(233);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClioClientSelector = function (_Component) {
	  _inherits(ClioClientSelector, _Component);
	
	  function ClioClientSelector() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ClioClientSelector);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      isLoading: false,
	      isRefreshing: false
	    }, _this.loadClients = function (inputValue) {
	      var _this$props = _this.props,
	          connectionId = _this$props.connectionId,
	          initialClientId = _this$props.initialClientId;
	
	
	      if (!inputValue && initialClientId) {
	        return _superagent2.default.get('/rpc/integrations/connections/' + connectionId + '/clio/clients/' + value).then(function (response) {
	          return [response.body.data];
	        });
	      } else {
	        return _superagent2.default.get('/rpc/integrations/connections/' + connectionId + '/clio/clients').query({ query: inputValue }).then(function (response) {
	          return response.body.data;
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ClioClientSelector.prototype.render = function render() {
	    var _this2 = this;
	
	    var _state = this.state,
	        isLoading = _state.isLoading,
	        isRefreshing = _state.isRefreshing,
	        clientSelectOptions = _state.clientSelectOptions;
	
	
	    if (isLoading && !clientSelectOptions) return _react2.default.createElement(_reactBootstrap.ProgressBar, { now: 100 });
	
	    var refreshClasses = (0, _classnames2.default)({
	      'fa': true,
	      'fa-refresh': true,
	      'fa-spin': isRefreshing
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { key: 'self', style: { position: 'relative' } },
	      _react2.default.createElement(_async2.default, _extends({
	        cacheOptions: true,
	        key: this.props.value,
	        defaultOptions: true,
	        loadOptions: this.loadClients,
	        noOptionsMessage: function noOptionsMessage() {
	          return 'Type to search clients...';
	        },
	        placeholder: 'Search Clients...',
	        loadingMess: true,
	        isClearable: true,
	        getOptionLabel: function getOptionLabel(option) {
	          return option.name;
	        },
	        getOptionValue: function getOptionValue(option) {
	          return option.id;
	        }
	      }, this.props)),
	      _react2.default.createElement('i', { className: refreshClasses,
	        style: {
	          position: 'absolute',
	          textAlign: 'center',
	          top: '12px',
	          right: '27px',
	          zIndex: 100,
	          cursor: 'pointer'
	        },
	        onClick: function onClick() {
	          return _this2.loadClients(true);
	        },
	        key: 'client-refresh-button'
	      })
	    );
	  };
	
	  return ClioClientSelector;
	}(_react.Component);
	
	/**
	 * Final Form compatible component adapter
	 * Can be used as:
	 *  <Field name="client_id">
	 *    {props =>
	 *      <ClioClientSelector
	 *        input={props.input}
	 *        connectionId={connectionId}
	 *      />
	 *    }
	 *  </Field>
	 */
	
	
	ClioClientSelector.defaultProps = {
	  connectionId: null
	};
	ClioClientSelector.propTypes = {
	  connectionId: _propTypes2.default.number.isRequired
	};
	exports.default = ClioClientSelector;
	var FinalFormClioClientSelector = function FinalFormClioClientSelector(_ref) {
	  var _ref$input = _ref.input,
	      value = _ref$input.value,
	      _onChange = _ref$input.onChange,
	      rest = _objectWithoutProperties(_ref, ['input']);
	
	  // NOTE does not work for Async select in react-select3 because we dont have the values yet...
	  return _react2.default.createElement(ClioClientSelector
	  //value={value}
	  , _extends({ onChange: function onChange(selectedClient) {
	      return _onChange(_.get(selectedClient, 'id'));
	    }
	  }, rest));
	};
	exports.FinalFormClioClientSelector = FinalFormClioClientSelector;

/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FinalFormClioMatterSelector = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClioMatterSelector = function (_Component) {
	  _inherits(ClioMatterSelector, _Component);
	
	  function ClioMatterSelector() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ClioMatterSelector);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      isLoading: false,
	      isRefreshing: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ClioMatterSelector.prototype.componentDidMount = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      var clientId;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              clientId = this.props.clientId;
	
	              if (!clientId) {
	                _context.next = 4;
	                break;
	              }
	
	              _context.next = 4;
	              return this.loadMatters();
	
	            case 4:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    function componentDidMount() {
	      return _ref.apply(this, arguments);
	    }
	
	    return componentDidMount;
	  }();
	
	  ClioMatterSelector.prototype.componentDidUpdate = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(prevProps, prevState, snapshot) {
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              if (!(prevProps.clientId !== this.props.clientId)) {
	                _context2.next = 4;
	                break;
	              }
	
	              this.setState({ matterOptions: null });
	              _context2.next = 4;
	              return this.loadMatters();
	
	            case 4:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, this);
	    }));
	
	    function componentDidUpdate(_x, _x2, _x3) {
	      return _ref2.apply(this, arguments);
	    }
	
	    return componentDidUpdate;
	  }();
	
	  ClioMatterSelector.prototype.render = function render() {
	    var _this2 = this;
	
	    var _state = this.state,
	        isLoading = _state.isLoading,
	        isRefreshing = _state.isRefreshing,
	        matterOptions = _state.matterOptions;
	
	
	    if (isLoading && !matterOptions) return React.createElement(_reactBootstrap.ProgressBar, { now: 100 });
	
	    var refreshClasses = (0, _classnames2.default)({
	      'fa': true,
	      'fa-refresh': true,
	      'fa-spin': isRefreshing
	    });
	
	    return React.createElement(
	      'div',
	      { key: 'self', style: { position: 'relative' } },
	      React.createElement(_reactSelect2.default, _extends({
	        defaultOptions: true,
	        options: matterOptions,
	        isClearable: true,
	        simpleValue: true,
	        key: this.props.clientId,
	        disabled: isLoading
	      }, this.props)),
	      React.createElement('i', { className: refreshClasses,
	        style: {
	          position: 'absolute',
	          textAlign: 'center',
	          top: '12px',
	          right: '27px',
	          zIndex: 100,
	          cursor: 'pointer'
	        },
	        onClick: function onClick() {
	          !isRefreshing && _this2.loadMatters(true);
	        },
	        key: 'matter-refresh-button'
	      })
	    );
	  };
	
	  ClioMatterSelector.prototype.loadMatters = function () {
	    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(refreshFromClio) {
	      var _props, connectionId, clientId, res, matterOptions;
	
	      return regeneratorRuntime.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _props = this.props, connectionId = _props.connectionId, clientId = _props.clientId;
	
	              if (!(!clientId || !connectionId)) {
	                _context3.next = 3;
	                break;
	              }
	
	              return _context3.abrupt('return');
	
	            case 3:
	
	              this.setState({
	                isLoading: true,
	                isRefreshing: refreshFromClio
	              });
	
	              _context3.next = 6;
	              return _superagent2.default.get('/rpc/integrations/connections/' + connectionId + '/clio/matters?client_id=' + clientId).query({ refresh: refreshFromClio });
	
	            case 6:
	              res = _context3.sent;
	              matterOptions = this.convertMattersToSelectOptions(res.body.data);
	
	
	              this.setState({
	                isLoading: false,
	                isRefreshing: false,
	                matterOptions: matterOptions
	              });
	
	            case 9:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, this);
	    }));
	
	    function loadMatters(_x4) {
	      return _ref3.apply(this, arguments);
	    }
	
	    return loadMatters;
	  }();
	
	  ClioMatterSelector.prototype.convertMattersToSelectOptions = function convertMattersToSelectOptions(matters) {
	    var _this3 = this;
	
	    var options = matters.map(function (val) {
	      return { label: _this3.matterLabel(val), value: val.id };
	    });
	
	    return options;
	  };
	
	  ClioMatterSelector.prototype.matterLabel = function matterLabel(matter) {
	    return React.createElement(
	      'div',
	      null,
	      React.createElement(
	        'b',
	        null,
	        matter.display_number
	      ),
	      ' - ',
	      matter.description
	    );
	  };
	
	  return ClioMatterSelector;
	}(Component);
	
	ClioMatterSelector.defaultProps = {
	  connectionId: null,
	  clientId: null
	};
	ClioMatterSelector.propTypes = {
	  connectionId: _propTypes2.default.number.isRequired,
	  clientId: _propTypes2.default.number
	};
	exports.default = ClioMatterSelector;
	;
	
	/**
	 * FinalForm compatible field, use like:
	 * ```
	 * <Field name="matter_id"
	 *   component={FinalFormClioMatterSelector}
	 *   connectionId={connectionId}
	 *   clientId={_.get(values, 'client_id')}
	 * />
	 * ```
	 */
	var FinalFormClioMatterSelector = function FinalFormClioMatterSelector(_ref4) {
	  var _ref4$input = _ref4.input,
	      value = _ref4$input.value,
	      _onChange = _ref4$input.onChange,
	      rest = _objectWithoutProperties(_ref4, ['input']);
	
	  return React.createElement(ClioMatterSelector, _extends({
	    value: value,
	    onChange: function onChange(selectedOption) {
	      return _onChange(selectedOption);
	    }
	  }, rest));
	};
	exports.FinalFormClioMatterSelector = FinalFormClioMatterSelector;

/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _useDataApi6 = __webpack_require__(60);
	
	var _useDataApi7 = _interopRequireDefault(_useDataApi6);
	
	var _AttributeSelector = __webpack_require__(347);
	
	var _usePostApi2 = __webpack_require__(139);
	
	var _usePostApi3 = _interopRequireDefault(_usePostApi2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var selectStyle = { width: '180px' }; // Fit about 4 in a line on Room Settings Screen
	
	function AttributeConfig(_ref) {
	  var connection_id = _ref.connection_id,
	      casefolder_id = _ref.casefolder_id,
	      uid = _ref.uid;
	
	  var _useDataApi = (0, _useDataApi7.default)('/rpc/integrations/connections/' + connection_id + '/casefolders/' + casefolder_id + '/netdocuments-profile', {}),
	      _useDataApi$ = _useDataApi[0],
	      data = _useDataApi$.data,
	      isLoading = _useDataApi$.isLoading,
	      isError = _useDataApi$.isError,
	      setData = _useDataApi[1].setData;
	
	  var _useState = (0, _react.useState)(null),
	      newProfile = _useState[0],
	      setNewProfile = _useState[1];
	
	  var _usePostApi = (0, _usePostApi3.default)('/rpc/integrations/connections/' + connection_id + '/casefolders/' + casefolder_id + '/netdocuments-profile'),
	      _usePostApi$ = _usePostApi[0],
	      newProfileSavedResult = _usePostApi$.data,
	      isSaveInProgress = _usePostApi$.isLoading,
	      profileSaveError = _usePostApi$.isError,
	      triggerPost = _usePostApi[1];
	
	  (0, _react.useEffect)(function () {
	    if (newProfileSavedResult) setData(newProfileSavedResult);
	  }, [newProfileSavedResult]);
	
	  function saveData() {
	    triggerPost(newProfile);
	    setNewProfile(null);
	  }
	
	  if (isLoading) return _react2.default.createElement(_reactBootstrap.ProgressBar, { active: true, now: 100 });
	  if (isError) return _react2.default.createElement(
	    _reactBootstrap.Alert,
	    { bsStyle: 'danger' },
	    'Error Loading Current Config: ',
	    ErrorExplanation(isError),
	    ' '
	  );
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { style: { float: 'left' } },
	      _react2.default.createElement(ProfileSelector, {
	        connection_id: connection_id,
	        casefolder_id: casefolder_id,
	        uid: uid,
	        existingProfileConfig: data,
	        onSelectFinal: setNewProfile
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { float: 'left', marginLeft: '4px', marginTop: '1px' } },
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        { disabled: !newProfile, onClick: saveData, bsStyle: 'primary' },
	        _react2.default.createElement('i', { className: 'fa ' + (isSaveInProgress ? 'fa-spinner fa-spinning' : 'fa-save') }),
	        '\xA0 Save'
	      )
	    ),
	    _react2.default.createElement('div', { style: { clear: 'both' } }),
	    _react2.default.createElement(
	      'p',
	      { style: { marginBottom: 0 } },
	      'Note: Closed matters are not included and can not be used.'
	    )
	  );
	}
	
	function ProfileSelector(_ref2) {
	  var connection_id = _ref2.connection_id,
	      existingProfileConfig = _ref2.existingProfileConfig,
	      onSelectFinal = _ref2.onSelectFinal;
	
	  var _useState2 = (0, _react.useState)(null),
	      selectedCabinet = _useState2[0],
	      setSelectedCabinet = _useState2[1];
	
	  var _useDataApi2 = (0, _useDataApi7.default)('/rpc/integrations/connections/' + connection_id + '/cabinets', {}),
	      _useDataApi2$ = _useDataApi2[0],
	      data = _useDataApi2$.data,
	      isLoading = _useDataApi2$.isLoading,
	      isError = _useDataApi2$.isError;
	
	  var cabinets = data.cabinets || [];
	
	  if (isError) return _react2.default.createElement(
	    _reactBootstrap.Alert,
	    { bsStyle: 'danger' },
	    'Error Loading Cabinets'
	  );
	
	  var cabinetOptions = cabinets.map(function (cabinet) {
	    return _extends({}, cabinet, {
	      label: _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('i', { className: 'fa fa-archive' }),
	        ' ',
	        cabinet.name
	      ),
	      value: cabinet.id
	    });
	  });
	  var preselectedOption = _lodash2.default.find(cabinetOptions, { id: existingProfileConfig.cabinet_id });
	
	  // on first load
	  (0, _react.useEffect)(function () {
	    // preselected cabinet
	    if (preselectedOption) setSelectedCabinet(preselectedOption);
	    // auto select if there is only one
	    else if (cabinetOptions.length == 1) setSelectedCabinet(cabinetOptions[0]);
	  }, [existingProfileConfig, data]);
	
	  var onSelectFinalAttribute = function onSelectFinalAttribute(selectedAttributeValues) {
	    onSelectFinal({
	      cabinet_id: selectedCabinet.id,
	      profile: selectedAttributeValues.map(function (attrval) {
	        return {
	          id: attrval.attribute_id,
	          value: attrval.value
	        };
	      })
	    });
	  };
	
	  var selectedCabinetId = _lodash2.default.get(selectedCabinet, 'id', null);
	  var preSelectedCabinetId = _lodash2.default.get(preselectedOption, 'id', null);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { style: { display: 'inline-block' } },
	      _react2.default.createElement(_reactSelect2.default, {
	        style: selectStyle,
	        placeholder: 'Cabinet',
	        isLoading: isLoading,
	        options: cabinetOptions,
	        value: selectedCabinet,
	        onChange: setSelectedCabinet
	      })
	    ),
	    selectedCabinet && _react2.default.createElement(AttributesSelectors, {
	      connection_id: connection_id,
	      cabinet: selectedCabinet
	      // NOTE - can't just use _.isEqual(selectedCabinet, preselectedOption) because they contain deep differences in DOM stuff.
	      , existingProfileConfig: _lodash2.default.isEqual(selectedCabinetId, preSelectedCabinetId) ? existingProfileConfig : {},
	      onSelectFinalAttribute: onSelectFinalAttribute
	    })
	  );
	}
	
	AttributeConfig.propTypes = {
	  connection_id: _propTypes2.default.number.isRequired,
	  casefolder_id: _propTypes2.default.number.isRequired,
	  uid: _propTypes2.default.number.isRequired
	};
	
	function AttributesSelectors(_ref3) {
	  var connection_id = _ref3.connection_id,
	      cabinet = _ref3.cabinet,
	      onSelectFinalAttribute = _ref3.onSelectFinalAttribute,
	      existingProfileConfig = _ref3.existingProfileConfig;
	
	  var _useDataApi3 = (0, _useDataApi7.default)('/rpc/integrations/connections/' + connection_id + '/cabinets/' + cabinet.id + '/profile', {}),
	      _useDataApi3$ = _useDataApi3[0],
	      cabinetProfileData = _useDataApi3$.data,
	      cabinetProfileIsLoading = _useDataApi3$.isLoading,
	      cabinetProfileIsError = _useDataApi3$.isError;
	
	  var _useDataApi4 = (0, _useDataApi7.default)('/rpc/integrations/connections/' + connection_id + '/cabinets/' + cabinet.id + '/attributes', {}),
	      _useDataApi4$ = _useDataApi4[0],
	      data = _useDataApi4$.data,
	      isLoading = _useDataApi4$.isLoading,
	      isError = _useDataApi4$.isError;
	
	  if (isError) return _react2.default.createElement(
	    _reactBootstrap.Alert,
	    { bsStyle: 'danger' },
	    'Error Loading List of Attributes for cabinet'
	  );
	  if (cabinetProfileIsError) return _react2.default.createElement(
	    _reactBootstrap.Alert,
	    { bsStyle: 'danger' },
	    'Error Loading Cabinet Profile, make sure it is configured on ',
	    _react2.default.createElement(
	      'a',
	      { href: '/integrations/show', target: '_blank' },
	      'Connection Configuration Page'
	    )
	  );
	
	  // Our Loading bar looks like a disabled select
	  if (isLoading || cabinetProfileIsLoading) {
	    return _react2.default.createElement(
	      'div',
	      { style: { display: 'inline-block' } },
	      _react2.default.createElement(_reactSelect2.default, { placeholder: 'Loading Attributes', style: selectStyle, isLoading: true, disabled: true })
	    );
	  }
	
	  var attributes = organizingAttributes(cabinet, data.attributes || [], cabinetProfileData);
	
	  if (!attributes.length) return _react2.default.createElement(
	    _reactBootstrap.Alert,
	    null,
	    'Cabinet does not have any organizational attributes'
	  );
	
	  return _react2.default.createElement(AttributeSelector, {
	    connection_id: connection_id,
	    cabinet: cabinet,
	    attributes: attributes,
	    onSelectFinalAttribute: onSelectFinalAttribute,
	    existingProfileConfig: existingProfileConfig
	  });
	}
	
	function AttributeSelector(_ref4) {
	  var connection_id = _ref4.connection_id,
	      cabinet = _ref4.cabinet,
	      attributes = _ref4.attributes,
	      _ref4$parent_key = _ref4.parent_key,
	      parent_key = _ref4$parent_key === undefined ? '' : _ref4$parent_key,
	      _onSelectFinalAttribute = _ref4.onSelectFinalAttribute,
	      existingProfileConfig = _ref4.existingProfileConfig;
	  var attribute = attributes[0],
	      childAttributes = attributes.slice(1);
	
	
	  var hasChildren = childAttributes.length > 0;
	
	  var _useState3 = (0, _react.useState)(null),
	      selected = _useState3[0],
	      setSelected = _useState3[1];
	
	  // To support non-linked but mandatory attributes (i.e. wsOrgAttr that is specified as "Select per case"
	
	
	  var parent_key_to_use = attribute.linked ? parent_key : '';
	
	  var _useDataApi5 = (0, _useDataApi7.default)('/rpc/integrations/connections/' + connection_id + '/repository/' + cabinet.repositoryId + '/attribute/' + attribute.id + '/values?parent_key=' + parent_key_to_use, {}),
	      _useDataApi5$ = _useDataApi5[0],
	      data = _useDataApi5$.data,
	      isLoading = _useDataApi5$.isLoading,
	      isError = _useDataApi5$.isError,
	      fetchData = _useDataApi5[1].fetchData;
	
	  var trigger_refresh = function () {
	    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              return _context.abrupt('return', fetchData('/rpc/integrations/connections/' + connection_id + '/repository/' + cabinet.repositoryId + '/attribute/' + attribute.id + '/values?parent_key=' + parent_key_to_use + '&refresh=true'));
	
	            case 1:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    return function trigger_refresh() {
	      return _ref5.apply(this, arguments);
	    };
	  }();
	
	  var values = data.values || [];
	  var valuesOptions = values.map(function (val) {
	    return _extends({}, val, {
	      // If the key is only digits, include both key and description in the label.
	      // IE client code 001 Client 1, or matter: 0001 Matter 1-1
	      // This allows easier finding for customers who know the codes and just want to type them in
	      label: attributeLabel(val.key, val.description),
	      value: val.key,
	      attribute_id: attribute.id
	    });
	  });
	  var existingProfileValue = _lodash2.default.find(existingProfileConfig.profile, { id: attribute.id });
	  var preselectedOption = existingProfileValue && _lodash2.default.find(valuesOptions, { value: existingProfileValue.value });
	
	  (0, _react.useEffect)(function () {
	    // Select existing option when appropriate
	    if (preselectedOption) setSelected(preselectedOption);
	    // Auto Select Attribute value if these is only one option
	    else if (valuesOptions.length === 1) {
	        setSelected(valuesOptions[0]);
	        if (!hasChildren) _onSelectFinalAttribute(valuesOptions);
	      }
	  }, [data, existingProfileConfig]);
	
	  if (isError) return _react2.default.createElement(
	    _reactBootstrap.Alert,
	    null,
	    'Unable to load values for ',
	    attribute.name
	  );
	
	  return [
	  /* 1. SelectBox for this attribute */
	  /* TODO: upgrade react-select to get defaultMenuIsOpen functionality */
	  _react2.default.createElement(
	    'div',
	    { style: { display: 'inline-block' }, key: 'self' },
	    _react2.default.createElement(_reactSelect2.default, {
	      style: selectStyle,
	      autoFocus: true,
	      defaultMenuIsOpen: true,
	      placeholder: attribute.name,
	      isLoading: isLoading,
	      options: valuesOptions,
	      value: selected,
	      onChange: function onChange(val) {
	        if (!hasChildren && val) _onSelectFinalAttribute([val]);
	        return setSelected(val);
	      }
	    })
	  ), isLoading || _react2.default.createElement(
	    'div',
	    {
	      style: {
	        display: 'inline-block',
	        position: 'absolute',
	        zIndex: 100,
	        margin: '9px 0 0 -53px',
	        cursor: 'pointer'
	      },
	      onClick: trigger_refresh,
	      key: 'refresh-button'
	    },
	    _react2.default.createElement('i', { className: 'fa fa-refresh' })
	  ),
	  /* 2. Any Child Attributes */
	  selected && hasChildren && _react2.default.createElement(AttributeSelector, {
	    key: selected.value,
	    connection_id: connection_id,
	    cabinet: cabinet,
	    attributes: childAttributes,
	    parent_key: selected.value
	    /* we wrap the onSelect so that we can bubble up all the attribute values to the top  */
	    , onSelectFinalAttribute: function onSelectFinalAttribute(val) {
	      return _onSelectFinalAttribute(val.concat(selected));
	    },
	    existingProfileConfig: _lodash2.default.isEqual(selected, preselectedOption) ? existingProfileConfig : {}
	  })];
	}
	
	function attributeLabel(key, description) {
	  // no description, return the key
	  if (description == null || description.length == 0) return key;
	
	  // If the key is not present in the description, include both key and description.
	  // Returning both allows autocompletion typing for client/matter codes for example
	  if (description.toLowerCase().indexOf(key.toLowerCase()) === -1) return key + ' ' + description;else return description;
	}
	
	function organizingAttributes(cabinet, attributes, cabinetProfile) {
	  if (!cabinet) return [];
	  if (!attributes.length) return [];
	
	  if (!cabinet.wsAttrNum) {
	    console.log('Cabinet is not organized in a workspace');
	    return [];
	  }
	  var attributesById = _lodash2.default.keyBy(attributes, function (attr) {
	    return attr.id;
	  });
	
	  var organizingAttribute = attributesById[cabinet.wsAttrNum];
	
	  if (!organizingAttribute) {
	    console.log('Can not find organizing attribute - no attribute with id \'' + cabinet.wsAttrNum + '\' found in', attributes);
	    return [];
	  }
	
	  var attributeList = [organizingAttribute];
	  var attr = organizingAttribute;
	  while (attr.linked) {
	    attr = attributesById[attr.linked];
	    attributeList.unshift(attr);
	  }
	
	  // Sometimes people use a child attribute of the wsAttrNum to organize workspaces
	  var workspaceOrgAttr = attributesById[cabinet.wsOrgAttrNum];
	  if (workspaceOrgAttr && organizingAttribute.id === workspaceOrgAttr.linked) {
	    attributeList.push(workspaceOrgAttr);
	  }
	
	  // Attribute that was configured to be per-case
	  var perCaseAttributeRef = _lodash2.default.find(cabinetProfile.profile, { value: _AttributeSelector.PER_CASE_FLAG });
	  var perCaseAttribute = attributesById[_lodash2.default.get(perCaseAttributeRef, 'id')];
	  if (perCaseAttribute && !_lodash2.default.find(attributeList, { id: perCaseAttribute.id })) {
	    attributeList.push(perCaseAttribute);
	  }
	
	  return attributeList;
	}
	
	function ErrorExplanation(error) {
	  var prettyError = _lodash2.default.get(error, 'response.body.error');
	  if (prettyError) return prettyError;
	
	  return '' + error;
	}
	
	exports.default = AttributeConfig;

/***/ },
/* 1069 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (_ref2) {
	  var connection_id = _ref2.connection_id,
	      casefolder_id = _ref2.casefolder_id;
	
	  var _useDataApi = (0, _useDataApi3.default)("/rpc/integrations/connections/" + connection_id + "/rocketmatter/" + casefolder_id, {}),
	      data = _useDataApi[0].data;
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_Notification2.default, null),
	    _react2.default.createElement(_RocketMatterCaseFolderSettingsForm2.default, {
	      connectionId: connection_id,
	      caseFolderId: casefolder_id,
	      onSave: function onSave(settings) {
	        return _onSave(connection_id, casefolder_id, settings);
	      },
	      settings: data
	    })
	  );
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RocketMatterCaseFolderSettingsForm = __webpack_require__(558);
	
	var _RocketMatterCaseFolderSettingsForm2 = _interopRequireDefault(_RocketMatterCaseFolderSettingsForm);
	
	var _useDataApi2 = __webpack_require__(60);
	
	var _useDataApi3 = _interopRequireDefault(_useDataApi2);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _Notification = __webpack_require__(24);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	var _reactFinalForm = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _onSave = function _onSave(connectionId, casefolderId, settings) {
	  return _superagent2.default.post("/rpc/integrations/connections/" + connectionId + "/rocketmatter/" + casefolderId).send(settings).then(function (res) {
	    _Notification.notify.success('RocketMatter CaseFolder Settings Saved');
	  }, function (errRes) {
	    var _ref;
	
	    return _ref = {}, _ref[_reactFinalForm.FORM_ERROR] = 'Error Saving', _ref;
	  });
	};

/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (_ref) {
	  var connectionId = _ref.connectionId,
	      courtCode = _ref.courtCode,
	      caseNumber = _ref.caseNumber;
	
	  var inputRef = (0, _react.useRef)(null);
	
	  var copyToClipBoard = function copyToClipBoard(button) {
	    inputRef.current.select();
	    document.execCommand("copy");
	    _Notification.notify.success('Link copied to clipboard');
	  };
	
	  return _react2.default.createElement(
	    _reactBootstrap.Panel,
	    null,
	    _react2.default.createElement(
	      _reactBootstrap.Panel.Heading,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Panel.Title,
	        { componentClass: "h3" },
	        "SharePoint Docket Embed Widget"
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Panel.Body,
	      null,
	      _react2.default.createElement(
	        "p",
	        null,
	        "Copy/Paste this embed code into the SharePoint site for this case to utilize the CourtDrive docket for this case within SharePoint."
	      ),
	      _react2.default.createElement("input", {
	        type: "text",
	        ref: inputRef,
	        value: "<iframe src=\"https://app.courtdrive.com/rpc/integrations/connections/" + connectionId + "/sharepoint/case/" + courtCode + "/" + caseNumber + "/docket\" width=\"800\" height=\"400\" />",
	        size: "75",
	        readOnly: true
	      }),
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: "primary", onClick: copyToClipBoard },
	        "Copy"
	      )
	    )
	  );
	};
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Notification = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _UploadFolderTree = __webpack_require__(562);
	
	var _UploadFolderTree2 = _interopRequireDefault(_UploadFolderTree);
	
	var _Notification = __webpack_require__(24);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _SharepointCasefolderSettings = __webpack_require__(561);
	
	var _SharepointCasefolderSettings2 = _interopRequireDefault(_SharepointCasefolderSettings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //
	// Integrations CaseFolder Upload Folder Selection Widget
	//
	// Shows current casefolder upload path with an edit button that will open the
	// upload folder selection tree.
	//
	
	
	var UploadFolderSelect = function (_Component) {
	  _inherits(UploadFolderSelect, _Component);
	
	  function UploadFolderSelect() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UploadFolderSelect);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      isFolderTreeOpen: false,
	      isSavingFolderPath: false,
	      uploadFolder: null,
	      newFolderPath: []
	    }, _this.openFolderTree = function () {
	      _this.setState({
	        newFolderPath: [],
	        isFolderTreeOpen: true
	      });
	    }, _this.closeFolderTree = function () {
	      _this.setState({ isFolderTreeOpen: false, newFolderPath: [] });
	    }, _this.saveFolderPath = function () {
	      _this.setState({ isSavingFolderPath: true });
	
	      var _this$props = _this.props,
	          connectionId = _this$props.connectionId,
	          casefolderId = _this$props.casefolderId;
	
	
	      var folderPath = _this.state.newFolderPath.join('/');
	
	      _superagent2.default.post('/rpc/integrations/connections/' + connectionId + '/casefolders/' + casefolderId + '/upload-path').send({ folder_path: folderPath }).then(function () {
	        _this.setState({ isSavingFolderPath: false, uploadFolder: folderPath });
	
	        _Notification.notify.success('Case folder Upload Path Saved');
	
	        _this.closeFolderTree();
	      }).catch(function () {
	        _Notification.notify.error('Failed to save Case folder Upload path');
	      }).finally(function () {
	        _this.setState({ isSavingFolderPath: false });
	      });
	    }, _this.updateSharepointSettings = function (savedValues) {
	      var site = savedValues.site,
	          drive = savedValues.drive;
	
	
	      _this.setState({
	        sharepointDrive: drive,
	        sharepointSite: site
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  UploadFolderSelect.prototype.componentDidMount = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return this.loadCurrentUploadFolder();
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    function componentDidMount() {
	      return _ref.apply(this, arguments);
	    }
	
	    return componentDidMount;
	  }();
	
	  UploadFolderSelect.prototype.loadCurrentUploadFolder = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	      var _props, connectionId, casefolderId, response;
	
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              this.setState({ isLoading: true });
	
	              _props = this.props, connectionId = _props.connectionId, casefolderId = _props.casefolderId;
	              _context2.prev = 2;
	              _context2.next = 5;
	              return _superagent2.default.get('/rpc/integrations/connections/' + connectionId + '/casefolders/' + casefolderId + '/upload-path');
	
	            case 5:
	              response = _context2.sent;
	
	
	              this.setState({ uploadFolder: response.body.folder_path });
	              _context2.next = 12;
	              break;
	
	            case 9:
	              _context2.prev = 9;
	              _context2.t0 = _context2['catch'](2);
	
	              if (!_context2.t0.response.status === 404) _Notification.notify.error("Failed to load current upload folder");
	
	            case 12:
	              _context2.prev = 12;
	
	              this.setState({ isLoading: false });
	              return _context2.finish(12);
	
	            case 15:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, this, [[2, 9, 12, 15]]);
	    }));
	
	    function loadCurrentUploadFolder() {
	      return _ref2.apply(this, arguments);
	    }
	
	    return loadCurrentUploadFolder;
	  }();
	
	  // return true if we can show the folder selection UI
	
	
	  UploadFolderSelect.prototype.canEditFolderSelection = function canEditFolderSelection() {
	    if (this.props.service === 'sharepoint' && !this.state.sharepointDrive) return false;
	
	    return true;
	  };
	
	  // update sharepoint drive settings when they are saved
	
	
	  UploadFolderSelect.prototype.render = function render() {
	    var _this2 = this;
	
	    if (this.state.isLoading) return _react2.default.createElement(_reactBootstrap.ProgressBar, { now: 100 });
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Notification2.default, null),
	      this.props.service === 'sharepoint' && _react2.default.createElement(_SharepointCasefolderSettings2.default, {
	        connectionId: this.props.connectionId,
	        casefolderId: this.props.casefolderId,
	        onLoad: this.updateSharepointSettings,
	        onSave: this.updateSharepointSettings
	      }),
	      this.props.service !== 'sharepoint' && _react2.default.createElement(
	        'p',
	        null,
	        'Current Folder Selection: ',
	        this.state.uploadFolder || 'None',
	        _react2.default.createElement('br', null),
	        this.canEditFolderSelection() && _react2.default.createElement(
	          _reactBootstrap.Button,
	          { disabled: this.state.isFolderTreeOpen,
	            onClick: this.openFolderTree,
	            bsSize: 'sm'
	          },
	          'Edit'
	        )
	      ),
	      this.canEditFolderSelection() && _react2.default.createElement(
	        'div',
	        null,
	        this.state.isFolderTreeOpen && _react2.default.createElement(
	          'p',
	          null,
	          'New Selection: ',
	          this.state.newFolderPath.join('/') || 'None',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { bsSize: 'sm',
	              onClick: this.saveFolderPath,
	              disabled: this.state.isSavingFolderPath },
	            'Save'
	          ),
	          ' ',
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { bsSize: 'sm', bsStyle: 'danger', onClick: this.closeFolderTree },
	            'Cancel'
	          )
	        ),
	        this.state.isFolderTreeOpen && _react2.default.createElement(_UploadFolderTree2.default, {
	          connectionId: this.props.connectionId,
	          casefolderId: this.props.casefolderId,
	          service: this.props.service,
	          sharepointSite: this.state.sharepointSite,
	          sharepointDrive: this.state.sharepointDrive,
	          onFinalValueChange: function onFinalValueChange(value) {
	            return _this2.setState({ newFolderPath: value });
	          }
	        })
	      )
	    );
	  };
	
	  return UploadFolderSelect;
	}(_react.Component);
	
	UploadFolderSelect.defaultProps = {
	  connectionId: null,
	  casefolderId: null,
	  courtCode: null,
	  caseNumber: null,
	  service: null
	};
	UploadFolderSelect.propTypes = {
	  connectionId: _propTypes2.default.number.isRequired,
	  casefolderId: _propTypes2.default.number.isRequired,
	  service: _propTypes2.default.string.isRequired,
	  uploadFolder: _propTypes2.default.string
	};
	exports.default = UploadFolderSelect;

/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (_ref2) {
	  var connectionId = _ref2.connection_id,
	      casefolderId = _ref2.casefolder_id;
	
	  var _useDataApi = (0, _useDataApi3.default)("/rpc/integrations/connections/" + connectionId + "/imanage/casefolders/" + casefolderId, {}),
	      data = _useDataApi[0].data;
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_Notification2.default, null),
	    _react2.default.createElement(_IManageCaseFolderSettingsForm2.default, {
	      onSave: function onSave(settings) {
	        return _onSave(connectionId, casefolderId, settings);
	      },
	      connectionId: connectionId,
	      casefolderId: casefolderId,
	      settings: data
	    })
	  );
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IManageCaseFolderSettingsForm = __webpack_require__(563);
	
	var _IManageCaseFolderSettingsForm2 = _interopRequireDefault(_IManageCaseFolderSettingsForm);
	
	var _useDataApi2 = __webpack_require__(60);
	
	var _useDataApi3 = _interopRequireDefault(_useDataApi2);
	
	var _Notification = __webpack_require__(24);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	var _reactFinalForm = __webpack_require__(17);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _onSave = function _onSave(connectionId, casefolderId, settings) {
	  var folder = settings.folder,
	      workspace = settings.workspace;
	
	
	  return _superagent2.default.post("/rpc/integrations/connections/" + connectionId + "/imanage/casefolders/" + casefolderId).send({ folder: folder, workspace: workspace }).then(function (res) {
	    _Notification.notify.success('iManage Settings Saved');
	  }, function (error) {
	    var _ref;
	
	    _Notification.notify.error('Failed to save iManage settings');
	    return _ref = {}, _ref[_reactFinalForm.FORM_ERROR] = 'Error Saving', _ref;
	  });
	};

/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DocketAlerts = __webpack_require__(567);
	
	var _DocketAlerts2 = _interopRequireDefault(_DocketAlerts);
	
	var _useDataApi2 = __webpack_require__(60);
	
	var _useDataApi3 = _interopRequireDefault(_useDataApi2);
	
	var _DocketAlertTimeCalculations = __webpack_require__(566);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _Notification = __webpack_require__(24);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _RPCProgressBar = __webpack_require__(678);
	
	var _RPCProgressBar2 = _interopRequireDefault(_RPCProgressBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function DocketAlertsContainer(_ref) {
	  var _this = this;
	
	  var court_code = _ref.court_code,
	      case_number = _ref.case_number,
	      uid = _ref.uid;
	
	  var _useState = (0, _react.useState)({
	    isTestSuccessful: false,
	    testError: null,
	    testProgressViewComponent: null
	  }),
	      testStatus = _useState[0],
	      setTestStatus = _useState[1];
	
	  var statusPanelEl = (0, _react.useRef)(null);
	
	  var _useDataApi = (0, _useDataApi3.default)('/rpc/cases/' + court_code + '/' + case_number + '/docket-alert/' + uid, {}, {
	    enabled: false,
	    frequency: 'P1D',
	    minimize_header: false,
	    next_run: (0, _DocketAlertTimeCalculations.next_time_it_is)(16), // 4pm default
	    time_zone: (0, _DocketAlertTimeCalculations.user_timezone)(), // wherever user is
	    report_settings: {
	      docket_entry_filters: [],
	      email_mode: 'new',
	      email_distribution_list: [window.Drupal.settings.currentUserMail]
	    }
	  }),
	      _useDataApi$ = _useDataApi[0],
	      data = _useDataApi$.data,
	      isLoading = _useDataApi$.isLoading,
	      isError = _useDataApi$.isError,
	      setData = _useDataApi[1].setData;
	
	  if (isLoading) return _react2.default.createElement(_reactBootstrap.ProgressBar, { now: 100, active: true });
	
	  if (isError) return _react2.default.createElement(
	    _reactBootstrap.Alert,
	    { bsStyle: 'danger' },
	    'There has been an error loading Docket Alert settings. Please try again and contact support if the problem persists.',
	    _react2.default.createElement(
	      'pre',
	      null,
	      '' + isError
	    )
	  );
	
	  var saveSettings = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(settings) {
	      var clearTestResults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var method, result;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              console.debug('Saving Docket Alert settings', settings);
	              method = settings.id ? 'patch' : 'post';
	              _context.prev = 2;
	
	              setTestStatus({}); // make sure any old test results are gone
	              _context.next = 6;
	              return _superagent2.default[method]('/rpc/cases/' + court_code + '/' + case_number + '/docket-alert/' + uid).send(settings);
	
	            case 6:
	              result = _context.sent;
	
	              setData(result.body);
	              _Notification.notify.success('Docket Alert Saved');
	              _context.next = 15;
	              break;
	
	            case 11:
	              _context.prev = 11;
	              _context.t0 = _context['catch'](2);
	
	              _Notification.notify.error(_react2.default.createElement(
	                'span',
	                null,
	                'We were unable to save your changes!',
	                _react2.default.createElement(
	                  'div',
	                  { style: { border: '1px dotted maroon', padding: '4px', margin: '4px' } },
	                  '' + _context.t0
	                ),
	                'Please try again or contact support if problem persists.'
	              ));
	              return _context.abrupt('return', _DocketAlerts2.default.saveErrorSignal(_context.t0));
	
	            case 15:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this, [[2, 11]]);
	    }));
	
	    return function saveSettings(_x) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  var testSettings = function () {
	    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(settings, testConfig) {
	      var method, result, testResult;
	      return regeneratorRuntime.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              console.debug('Testing Docket Alert settings', settings);
	              method = settings.id ? 'patch' : 'post';
	              _context3.prev = 2;
	
	              setTestStatus({
	                testProgressViewComponent: _react2.default.createElement(_reactBootstrap.ProgressBar, { label: 'Saving Alert...', active: true, now: 100 })
	              });
	
	              // Save current settings
	              _context3.next = 6;
	              return _superagent2.default[method]('/rpc/cases/' + court_code + '/' + case_number + '/docket-alert/' + uid).send(settings);
	
	            case 6:
	              result = _context3.sent;
	
	
	              // we need to save the id in settings so that the post-test request will do a PATCH
	              if (method === 'post') settings.id = result.body.id;
	
	              setTestStatus({
	                testProgressViewComponent: _react2.default.createElement(_reactBootstrap.ProgressBar, { label: 'Alert saved, initiating test...', active: true, now: 100 })
	              });
	
	              _context3.next = 11;
	              return _superagent2.default.post('/rpc/cases/' + court_code + '/' + case_number + '/docket-alert/' + uid + '/execute').send(testConfig);
	
	            case 11:
	              testResult = _context3.sent;
	
	
	              console.log("Test Initiated: ", testResult);
	              setTestStatus({
	                testProgressViewComponent: _react2.default.createElement(_RPCProgressBar2.default, {
	                  taskUrl: testResult.header.location,
	                  label: 'Updating Dockets...',
	                  onError: function onError(errorObject) {
	                    console.error("Docket Alert Test Error", errorObject);setTestStatus({ testError: errorObject ? errorObject.error || errorObject : 'Unknown Error' });
	                  },
	                  onSuccess: _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	                    var saveErrors;
	                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                      while (1) {
	                        switch (_context2.prev = _context2.next) {
	                          case 0:
	                            console.info("Docket Alert Test Success");
	                            setTestStatus({ isTestSuccessful: true });
	
	                            if (settings.enabled) {
	                              _context2.next = 8;
	                              break;
	                            }
	
	                            console.log("Turning on alert since test passed");
	                            _context2.next = 6;
	                            return saveSettings(_extends({}, settings, { enabled: true }), false);
	
	                          case 6:
	                            saveErrors = _context2.sent;
	
	                            if (!saveErrors) {
	                              console.log('Scrolling status panel into view');
	                              statusPanelEl.current.scrollIntoView({ behavior: 'smooth' });
	                            }
	
	                          case 8:
	                          case 'end':
	                            return _context2.stop();
	                        }
	                      }
	                    }, _callee2, _this);
	                  }))
	                })
	              });
	
	              setData(result.body);
	              _context3.next = 21;
	              break;
	
	            case 17:
	              _context3.prev = 17;
	              _context3.t0 = _context3['catch'](2);
	
	              console.log("Error Initiating Test", _context3.t0);
	              setTestStatus({ testError: _context3.t0 });
	
	            case 21:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this, [[2, 17]]);
	    }));
	
	    return function testSettings(_x3, _x4) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_DocketAlerts2.default, {
	      statusPanelRef: statusPanelEl,
	      settings: data,
	      onSaveSettings: saveSettings,
	      onTestAlert: testSettings,
	      testStatus: testStatus
	    }),
	    _react2.default.createElement(_Notification2.default, null)
	  );
	}
	
	DocketAlertsContainer.propTypes = {
	  court_code: _propTypes2.default.string.isRequired,
	  case_number: _propTypes2.default.string.isRequired,
	  uid: _propTypes2.default.number.isRequired
	};
	
	exports.default = DocketAlertsContainer;

/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _ECFForwarding = __webpack_require__(341);
	
	var _ECFForwarding2 = _interopRequireDefault(_ECFForwarding);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('CaseFolder/Settings/ECF Forwarding', module).add('Loading', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Component can be in a loading state while we fetch data'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_ECFForwarding2.default, { loading: true })
	  );
	}).add('Account Default', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'When no overrides are specified for this CaseFolder, we show a faded edit form.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Toggling the Override checkbox makes the form come alive'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'In this example, user doesn\'t have permission to attach PDFs'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_ECFForwarding2.default, {
	      onSaveSettings: (0, _addonActions.action)('onSaveSettings'),
	      settings: sampleGlobalSettings,
	      permissions: {}
	    })
	  );
	}).add('Overriden', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'When settings are overriden, form is displayed non-faded by default'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_ECFForwarding2.default, {
	      onSaveSettings: (0, _addonActions.action)('onSaveSettings'),
	      settings: sampleOverrideSettings,
	      permissions: { can_attach_pdf: true }
	    })
	  );
	});
	
	var sampleGlobalSettings = {
	  is_global: true,
	  destinations: ['lawyer@firm.com', 'paralegal@firm.com'],
	  all_case_emails: false,
	  attach_pdf: false,
	  link_to_combined_pdf: true
	};
	
	var sampleOverrideSettings = {
	  is_global: false,
	  destinations: ['onlyparalegal@firm.com'],
	  all_case_emails: true,
	  attach_pdf: true,
	  link_to_combined_pdf: false
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ECFForwarding = __webpack_require__(341);
	
	var _ECFForwarding2 = _interopRequireDefault(_ECFForwarding);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// TODO: use Redux
	var ECFForwardingContainer = function (_Component) {
	  _inherits(ECFForwardingContainer, _Component);
	
	  function ECFForwardingContainer(props) {
	    _classCallCheck(this, ECFForwardingContainer);
	
	    // State is given to <ScheduleEF> as props
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      loading: true
	    };
	    return _this;
	  }
	
	  ECFForwardingContainer.prototype.render = function render() {
	    var _this2 = this;
	
	    if (this.state.error) return _react2.default.createElement(
	      'button',
	      { onClick: function onClick() {
	          return _this2.fetchSettings();
	        } },
	      'Reload ECF Notification Settings'
	    );
	
	    return _react2.default.createElement(_ECFForwarding2.default, _extends({}, this.state, {
	      permissions: this.props.permissions,
	      onSaveSettings: function onSaveSettings(value) {
	        _this2.onSaveSettings(value);
	      }
	    }));
	  };
	
	  ECFForwardingContainer.prototype.componentDidMount = function componentDidMount() {
	    this.fetchSettings();
	  };
	
	  ECFForwardingContainer.prototype.fetchSettings = function fetchSettings() {
	    console.log('Fetching ECF Settings For ' + this.props.casefolder_nid);
	
	    var component = this;
	
	    component.setState({
	      error: false,
	      loading: true
	    });
	
	    var casefolder_nid = this.props.casefolder_nid;
	
	
	    return _superagent2.default.get('/rpc/case-folders/' + casefolder_nid + '/ecf-forwarding-settings').then(function onSuccess(response) {
	      console.debug("fetchSettings", response.body);
	      if (response.status !== 200) {
	        return onFailure(response.message || 'service error');
	      }
	
	      component.setState({
	        loading: false,
	        settings: response.body
	      });
	    }, function onFailure(errorMessage) {
	      console.log("onFailure", arguments);
	
	      component.setState({
	        loading: false,
	        error: true
	      });
	
	      // extract useful message if possible
	      try {
	        errorMessage = errorMessage.response.body.error.errorMessage;
	      } catch (and_ignore) {}
	
	      alert('Error Loading!\n\n' + errorMessage);
	    });
	  };
	
	  ECFForwardingContainer.prototype.onSaveSettings = function onSaveSettings(values) {
	    console.log('New Values', values);
	
	    var component = this;
	
	    component.setState(_extends({}, component.state, {
	      loading: true,
	      settings: { data: values } // don't lose values in case of error
	    }));
	
	    function onSuccess(response) {
	      console.log("onSuccess", arguments);
	      if (response.status !== 200) {
	        return onFailure(response.message || 'service error');
	      }
	
	      component.setState(_extends({}, component.state, {
	        loading: false,
	        settings: response.body // server will provide new version of schedule
	      }));
	    }
	
	    function onFailure(errorMessage) {
	      console.log("onFailure", arguments);
	      component.setState(_extends({}, component.state, {
	        loading: false
	      }));
	      // extract useful message if possible
	      try {
	        errorMessage = errorMessage.response.body.error.errorMessage;
	      } catch (and_ignore) {}
	
	      alert('Error Saving!\n\n' + errorMessage);
	    }
	
	    var casefolder_nid = this.props.casefolder_nid;
	
	
	    return _superagent2.default.post('/rpc/case-folders/' + casefolder_nid + '/ecf-forwarding-settings').send({
	      settings: values
	    }).then(onSuccess, onFailure);
	  };
	
	  return ECFForwardingContainer;
	}(_react.Component);
	
	ECFForwardingContainer.propTypes = {
	  casefolder_nid: _propTypes2.default.string.isRequired,
	  permissions: _propTypes2.default.object.isRequired
	};
	exports.default = ECFForwardingContainer;

/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _ApiCallsView = __webpack_require__(570);
	
	var _ApiCallsView2 = _interopRequireDefault(_ApiCallsView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sampleNoData = {
	  uid: '1',
	  dataReady: true,
	  interval_grouping: 'day',
	  noDataFoundMessage: 'There are no API calls made.',
	  period_start: '2018-10-01T00:00:00Z',
	  period_end: '2018-10-31T00:00:00Z',
	  period_selected: false,
	  status: 'success',
	  periods: [],
	  usage: []
	};
	
	var sampleFullAPICalls = {
	  uid: '1',
	  dataReady: true,
	  interval_grouping: 'day',
	  noDataFoundMessage: 'There are no API calls made.',
	  period_start: '2018-10-01T00:00:00Z',
	  period_end: '2018-10-31T00:00:00Z',
	  period_selected: true,
	  status: 'success',
	  periods: [{
	    api_calls: 21,
	    end: '2018-08-31T00:00:00Z',
	    start: '2018-08-01T00:00:00Z',
	    title: 'Dropbox',
	    total_cost: 21
	  }, {
	    api_calls: 13,
	    end: '2018-09-30T00:00:00Z',
	    start: '2018-09-01T00:00:00Z',
	    title: 'Dropbox',
	    total_cost: 13
	  }, {
	    api_calls: 10,
	    end: '2018-10-31T00:00:00Z',
	    start: '2018-10-01T00:00:00Z',
	    title: 'Dropbox',
	    total_cost: 10
	  }],
	  usage: [{
	    calls: 20,
	    description: '20 Document API Calls Synced to Dropbox',
	    interval: '2018-10-03T00:00:00Z',
	    service: 'dropbox',
	    service_name: 'Dropbox',
	    type: 'files'
	  }, {
	    calls: 3,
	    description: '3 Document API Calls Synced to Dropbox',
	    interval: '2018-10-04T00:00:00Z',
	    service: 'dropbox',
	    service_name: 'Dropbox',
	    type: 'files'
	  }, {
	    calls: 2,
	    description: '2 Document API Calls Synced to Dropbox',
	    interval: '2018-10-05T00:00:00Z',
	    service: 'dropbox',
	    service_name: 'Dropbox',
	    type: 'files'
	  }, {
	    calls: 2,
	    description: '2 Document API Calls Synced to Dropbox',
	    interval: '2018-10-06T00:00:00Z',
	    service: 'dropbox',
	    service_name: 'Dropbox',
	    type: 'files'
	  }, {
	    calls: 1,
	    description: '1 Document API Calls Synced to Dropbox',
	    interval: '2018-10-07T00:00:00Z',
	    service: 'dropbox',
	    service_name: 'Dropbox',
	    type: 'files'
	  }, {
	    calls: 1,
	    description: '1 Document API Calls Synced to Dropbox',
	    interval: '2018-10-08T00:00:00Z',
	    service: 'dropbox',
	    service_name: 'Dropbox',
	    type: 'files'
	  }]
	};
	
	(0, _react3.storiesOf)('Integrations', module).add('Loading', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Component can be in a loading state while we fetch periods data'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_ApiCallsView2.default, { loadingBar: true })
	  );
	}).add('ApiCalls', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'By default, we display ',
	      _react2.default.createElement(
	        'b',
	        null,
	        'Details tab'
	      ),
	      ' which contains details of billing periods'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Clicking the ',
	      _react2.default.createElement(
	        'b',
	        null,
	        'Summary tab'
	      ),
	      ' should bring up Summary table '
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_ApiCallsView2.default, sampleFullAPICalls)
	  );
	}).add('ApiCalls - no data', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'When there is no data display message no data found'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_ApiCallsView2.default, sampleNoData)
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ApiCallsContainer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _integrationsActions = __webpack_require__(1223);
	
	var integrationsActions = _interopRequireWildcard(_integrationsActions);
	
	var _ApiCallsView = __webpack_require__(570);
	
	var _ApiCallsView2 = _interopRequireDefault(_ApiCallsView);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var noDataFoundMessage = 'There are no API calls made.';
	
	var ApiCallsContainer = exports.ApiCallsContainer = function (_Component) {
	  _inherits(ApiCallsContainer, _Component);
	
	  function ApiCallsContainer(props) {
	    _classCallCheck(this, ApiCallsContainer);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.getApiCallsDetails = function (period_start, period_end, interval_grouping) {
	      _this.props.dispatch(integrationsActions.getApiCallsDetails({
	        uid: _this.props.uid,
	        period_start: period_start,
	        period_end: period_end,
	        interval_grouping: interval_grouping,
	        periods: _this.props.periods ? _this.props.periods : []
	      }));
	    };
	
	    _this.getApiCallsSummary = function () {
	      _this.props.dispatch(integrationsActions.getApiCallsSummary({
	        uid: _this.props.uid,
	        usage: _this.props.usage ? _this.props.usage : []
	      }));
	    };
	
	    _this.handleChange = function (params) {
	      if (params) {
	        params = JSON.parse(params);
	        _this.setState({
	          period_start: params.period_start,
	          period_end: params.period_end,
	          period_selected: true
	        });
	        _this.getApiCallsDetails(params.period_start, params.period_end, _this.state.interval_grouping);
	      }
	    };
	
	    _this.state = {
	      period_start: '',
	      period_end: '',
	      interval_grouping: 'day',
	      period_selected: false
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    return _this;
	  }
	
	  ApiCallsContainer.prototype.componentDidMount = function componentDidMount() {
	    this.getApiCallsSummary();
	  };
	
	  ApiCallsContainer.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(_ApiCallsView2.default, _extends({}, this.props, {
	      noDataFoundMessage: noDataFoundMessage,
	      period_start: this.state.period_start,
	      period_end: this.state.period_end,
	      interval_grouping: this.state.interval_grouping,
	      period_selected: this.state.period_selected,
	      handleChange: function handleChange(params) {
	        return _this2.handleChange(params);
	      }
	    }));
	  };
	
	  return ApiCallsContainer;
	}(_react.Component);
	
	ApiCallsContainer.defaultProps = {
	  error: null
	};
	
	ApiCallsContainer.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  uid: _propTypes2.default.string.isRequired,
	  dataReady: _propTypes2.default.bool.isRequired,
	  usage: _propTypes2.default.any.isRequired,
	  periods: _propTypes2.default.any.isRequired,
	  status: _propTypes2.default.string.isRequired,
	  error: _propTypes2.default.any
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var integrationsState = state.get('integrations').toJS();
	  return {
	    dataReady: integrationsState.data_ready,
	    usage: integrationsState.usage,
	    periods: integrationsState.periods,
	    status: integrationsState.status,
	    error: integrationsState.error
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ApiCallsContainer);

/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function () {
	  return _hello2.default
	  // install Box driver
	  .init({
	    box: {
	      name: 'Box',
	
	      oauth: {
	        version: 2,
	        auth: 'https://app.box.com/api/oauth2/authorize',
	        grant: 'https://app.box.com/oauth2/token',
	        response_type: 'code'
	      },
	
	      base: 'https://api.box.com/2.0/',
	
	      login: function login(p) {
	        // sets popup size to fit the Clio login screen
	        p.options.popup.width = 740;
	        p.options.popup.height = 640;
	      }
	    }
	  })
	
	  // Initialize Driver instance
	  .init({ box: window.Drupal.settings.INTEGRATIONS_BOX_APP_ID }, {
	    redirect_uri: 'https://app.courtdrive.com/rpc/static/hello.js/redirect.html',
	    oauth_proxy: window.location.origin + '/rpc/integrations/oauth_proxy'
	  })('box'); // spawn an instance of the driver that one can call .login() on
	};
	
	var _hello = __webpack_require__(112);
	
	var _hello2 = _interopRequireDefault(_hello);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _FilenameTemplate = __webpack_require__(343);
	
	var _FilenameTemplate2 = _interopRequireDefault(_FilenameTemplate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var filenameTemplateInitProp = {
	  isLoading: false,
	  created: null,
	  modified: null,
	  date_format: null,
	  selectedFields: [],
	  errorMessage: null,
	  savedFileFormatFields: [],
	  selectedFileFormatFields: [],
	  savedFolderPathFields: [],
	  selectedFolderPathFields: []
	};
	
	(0, _react3.storiesOf)('Filename Templates', module).add('Empty', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_FilenameTemplate2.default, { filenameTemplate: filenameTemplateInitProp,
	      dispatch: (0, _addonActions.action)('dispatch'),
	      connectionId: 1 })
	  );
	}).add('loading', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_FilenameTemplate2.default, { filenameTemplate: _extends({}, filenameTemplateInitProp, { isLoading: true }),
	      dispatch: (0, _addonActions.action)('dispatch'),
	      connectionId: 1 })
	  );
	}).add('With Valid Selections', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_FilenameTemplate2.default, {
	      filenameTemplate: _extends({}, filenameTemplateInitProp, {
	        selectedFields: ['case_id', '_', 'case_title', 'case_number', '.', 'court_name']
	      }),
	      dispatch: (0, _addonActions.action)('dispatch'),
	      connectionId: 1 })
	  );
	}).add('Without Folder Options', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_FilenameTemplate2.default, {
	      filenameTemplate: filenameTemplateInitProp,
	      dispatch: (0, _addonActions.action)('dispatch'),
	      requireFolderConfiguration: true,
	      connectionId: 1 })
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (region) {
	  // throw exception or something if its not found?
	  var serviceName = regionServiceNames[region];
	
	  return _hello2.default
	  // install NetDocuments driver
	  .init({
	    netdocumentsAU: buildNetDocumentsService('netdocumentsAU', 'https://au.netdocuments.com', 'https://api.au.netdocuments.com'),
	
	    netdocumentsDE: buildNetDocumentsService('netdocumentsDE', 'https://de.netdocuments.com', 'https://api.de.netdocuments.com'),
	
	    netdocumentsEU: buildNetDocumentsService('netdocumentsEU', 'https://eu.netdocuments.com', 'https://api.eu.netdocuments.com'),
	
	    netdocumentsUS: buildNetDocumentsService('netdocumentsUS', 'https://vault.netvoyage.com', 'https://api.vault.netvoyage.com')
	  }).init({
	    netdocumentsAU: window.Drupal.settings.INTEGRATIONS_NETDOCS_AU_APP_ID,
	    netdocumentsDE: window.Drupal.settings.INTEGRATIONS_NETDOCS_DE_APP_ID,
	    netdocumentsEU: window.Drupal.settings.INTEGRATIONS_NETDOCS_EU_APP_ID,
	    netdocumentsUS: window.Drupal.settings.INTEGRATIONS_NETDOCS_APP_ID
	  }, {
	    redirect_uri: 'https://app.courtdrive.com/rpc/static/hello.js/redirect.html',
	    oauth_proxy: window.location.origin + '/rpc/integrations/oauth_proxy'
	  })(serviceName); // spawn instance that caller will call .login() on.
	};
	
	var _hello = __webpack_require__(112);
	
	var _hello2 = _interopRequireDefault(_hello);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// generator to build driver config for a netdocs region
	function buildNetDocumentsService(name, applicationUrl, apiUrl) {
	  return {
	    name: name,
	    base: apiUrl,
	
	    oauth: {
	      version: 2,
	      auth: applicationUrl + '/neWeb2/OAuth.aspx',
	      grant: apiUrl + '/v1/OAuth',
	      response_type: 'code'
	    },
	
	    login: function login(p) {
	      // sets popup size to fit NetDocuments login screen
	      p.options.popup.width = 950;
	      p.options.popup.height = 600;
	    },
	
	
	    // read – read all data the user has rights to access
	    // edit - upload document content, create versions, check out, check in, change official version, create or modify document attachments
	    // organize – create folders and saved searches, file items in folders, manipulate ACLs and profile values, manipulate favorite lists, home page, and recent docs lists, change folder parent
	    // lookup – insert, update, and delete lookup table rows
	    // delete_doc – delete documents
	    // delete_container – delete folders, saved searches, filters, and workspaces
	    // full – full access to all resources.  The application is allowed to do everything the user has rights to do.
	    scope: {
	      read: 'read',
	      edit: 'edit',
	      organize: 'organize',
	      lookup: 'lookup',
	      delete_doc: 'delete_doc',
	      delete_container: 'delete_container',
	      full: 'full'
	    },
	
	    scope_delim: ' '
	  };
	}
	
	var regionServiceNames = {
	  US: 'netdocumentsUS',
	  EU: 'netdocumentsEU',
	  DE: 'netdocumentsDE',
	  AU: 'netdocumentsAU'
	};

/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function () {
	  return _hello2.default
	  // install RocketMatter driver
	  .init({
	    rocketmatter: {
	      name: 'Rocket Matter',
	
	      base: 'https://www.rocketmatter.net/public/',
	
	      oauth: {
	        version: 2,
	        auth: 'https://www.rocketmatter.net/public/AuthenticationStart.aspx',
	        // NOTE
	        // This grant URL wont work, but Hello.js requires a grant url to be defined for 'code' response type
	        // to be used, so just use a dummy URL here.  OAuth Proxy figures out the right URL for us
	        grant: 'https://www.rocketmatter.net/api_v2/Authentication.svc/json/GrantToken',
	        response_type: 'code'
	      },
	
	      scope: []
	    }
	  })
	  // Initialize Driver instance
	  .init({ rocketmatter: window.Drupal.settings.INTEGRATIONS_ROCKETMATTER_APP_ID }, {
	    redirect_uri: 'https://app.courtdrive.com/rpc/static/hello.js/redirect.html',
	    oauth_proxy: window.location.origin + '/rpc/integrations/oauth_proxy/rocket-matter'
	  })('rocketmatter'); // spawn an instance of the driver that one can call .login() on
	};
	
	var _hello = __webpack_require__(112);
	
	var _hello2 = _interopRequireDefault(_hello);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = ECFMailboxesContainer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _ECFExternalMailboxEditForm = __webpack_require__(606);
	
	var _ECFExternalMailboxEditForm2 = _interopRequireDefault(_ECFExternalMailboxEditForm);
	
	var _ECFMailboxesList = __webpack_require__(346);
	
	var _ECFMailboxesList2 = _interopRequireDefault(_ECFMailboxesList);
	
	var _useDataApi2 = __webpack_require__(60);
	
	var _useDataApi3 = _interopRequireDefault(_useDataApi2);
	
	var _Notification = __webpack_require__(24);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function ECFMailboxesContainer() {
	  var _this = this;
	
	  var _useState = (0, _react.useState)(null),
	      currentlyEditedInbox = _useState[0],
	      setCurrentlyEditedInbox = _useState[1];
	
	  var _useDataApi = (0, _useDataApi3.default)('/rpc/ecf/inbox', []),
	      _useDataApi$ = _useDataApi[0],
	      data = _useDataApi$.data,
	      isLoading = _useDataApi$.isLoading,
	      isError = _useDataApi$.isError,
	      triggerRefresh = _useDataApi[1].triggerRefresh;
	
	  var saveSettings = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(settings) {
	      var url, errorSummary;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              console.debug('Saving Inbox settings', settings);
	              url = settings.id ? '/rpc/ecf/inbox/external/' + settings.id : '/rpc/ecf/inbox/external';
	              _context.prev = 2;
	              _context.next = 5;
	              return _superagent2.default.post(url).send(settings);
	
	            case 5:
	              setCurrentlyEditedInbox(null);
	              triggerRefresh();
	              _Notification.notify.success('Inbox settings saved');
	              _context.next = 15;
	              break;
	
	            case 10:
	              _context.prev = 10;
	              _context.t0 = _context['catch'](2);
	              errorSummary = _lodash2.default.get(_context.t0, 'response.body.error', '' + _context.t0);
	
	              _Notification.notify.error(_react2.default.createElement(
	                'span',
	                null,
	                'We were unable to save your changes!',
	                _react2.default.createElement(
	                  'div',
	                  { style: { border: '1px dotted maroon', padding: '4px', margin: '4px' } },
	                  errorSummary
	                ),
	                'Please try again or contact support if problem persists.'
	              ));
	              return _context.abrupt('return', _ECFExternalMailboxEditForm2.default.saveErrorSignal(errorSummary));
	
	            case 15:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this, [[2, 10]]);
	    }));
	
	    return function saveSettings(_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  var removeInbox = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(inbox) {
	      var errorSummary;
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.prev = 0;
	              _context2.next = 3;
	              return _superagent2.default.delete('/rpc/ecf/inbox/external/' + inbox.id);
	
	            case 3:
	              _Notification.notify.success('Inbox successfully disconnected');
	              triggerRefresh();
	              _context2.next = 11;
	              break;
	
	            case 7:
	              _context2.prev = 7;
	              _context2.t0 = _context2['catch'](0);
	              errorSummary = _lodash2.default.get(_context2.t0, 'response.body.error', '' + _context2.t0);
	
	              _Notification.notify.error(_react2.default.createElement(
	                'span',
	                null,
	                'We were unable to disconnect your inbox.',
	                _react2.default.createElement(
	                  'div',
	                  { style: { border: '1px dotted maroon', padding: '4px', margin: '4px' } },
	                  errorSummary
	                ),
	                'Please try again or contact support if problem persists.'
	              ));
	
	            case 11:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this, [[0, 7]]);
	    }));
	
	    return function removeInbox(_x2) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  if (isLoading) return _react2.default.createElement(_reactBootstrap.ProgressBar, { now: 100, active: true });
	
	  if (isError) return _react2.default.createElement(
	    _reactBootstrap.Alert,
	    { bsStyle: 'danger' },
	    'There has been an error loading ECF Inbox settings. Please ',
	    _react2.default.createElement(
	      'a',
	      { onClick: function onClick() {
	          triggerRefresh();
	        } },
	      'try again'
	    ),
	    ' and contact support if the problem persists.',
	    _react2.default.createElement(
	      'pre',
	      null,
	      '' + isError
	    )
	  );
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement('div', { style: { marginTop: '22px' } }),
	    _react2.default.createElement(_ECFMailboxesList2.default, {
	      config: data,
	      onConnectNewExternalInboxRequested: function onConnectNewExternalInboxRequested() {
	        return setCurrentlyEditedInbox({});
	      },
	      onEditExternalInboxRequested: setCurrentlyEditedInbox,
	      onDisconnectExternalInboxRequested: removeInbox
	    }),
	    currentlyEditedInbox && _react2.default.createElement(
	      _reactBootstrap.Modal,
	      { show: true },
	      _react2.default.createElement(
	        _reactBootstrap.Modal.Header,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Title,
	          null,
	          currentlyEditedInbox.id ? 'Update external mailbox credentials' : 'Connect an external mailbox'
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Modal.Body,
	        null,
	        _react2.default.createElement(_ECFExternalMailboxEditForm2.default, {
	          settings: currentlyEditedInbox,
	          onSaveSettings: saveSettings,
	          onCancel: function onCancel() {
	            return setCurrentlyEditedInbox(null);
	          }
	        })
	      )
	    ),
	    _react2.default.createElement(_Notification2.default, null)
	  );
	}

/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _ECFMailboxesList = __webpack_require__(346);
	
	var _ECFMailboxesList2 = _interopRequireDefault(_ECFMailboxesList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var story = function story(descriptions, cmps) {
	  return function () {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Well,
	        { bsStyle: 'info' },
	        _react2.default.createElement('i', { className: 'fa fa-book' }),
	        ' ',
	        descriptions
	      ),
	      _react2.default.createElement('div', { style: { height: '1px', margin: '0 0 20px 0', borderTop: '1px dotted silver' } }),
	      cmps
	    );
	  };
	};
	
	var stubActions = {
	  onConnectNewExternalInboxRequested: (0, _addonActions.action)('onConnectNewExternalInboxRequested'),
	  onEditExternalInboxRequested: (0, _addonActions.action)('onEditExternalInboxRequested'),
	  onDisconnectExternalInboxRequested: (0, _addonActions.action)('onDisconnectExternalInboxRequested')
	};
	
	(0, _react3.storiesOf)('ECFMailboxesList', module).add('Empty', story('When no mailboxes are configured, user is instructed to setup a CourtDrive mailbox first', _react2.default.createElement(_ECFMailboxesList2.default, _extends({}, stubActions, { config: { external: [] } })))).add('With Managed Inbox', story('When managed inbox is setup, user is allowed to connect an external mailbox', _react2.default.createElement(_ECFMailboxesList2.default, _extends({}, stubActions, {
	  config: {
	    managed: {
	      prefix: 'jsmith'
	    },
	    external: []
	  }
	})))).add('With External Inboxes', story('User is allowed to keep adding inboxes. \n      Clicking [Edit] will trigger an edit request. \n      Clicking [Delete] will confirm with the user before firing the delete request.', _react2.default.createElement(_ECFMailboxesList2.default, _extends({}, stubActions, {
	  config: {
	    managed: { prefix: 'jsmith' },
	    external: [{
	      type: 'gmail',
	      connection_secrets: {
	        username: 'j.smith@gmail.com'
	      }
	    }, {
	      type: 'hotmail',
	      connection_secrets: {
	        username: 'j.smith@hotmail.com'
	      }
	    }, {
	      type: 'imap',
	      connection_settings: {
	        hostname: 'imap.example.org',
	        port: 143,
	        ssl: false
	      },
	      connection_secrets: {
	        username: 'j.smith@example.org'
	      }
	    }, {
	      type: 'imap',
	      connection_settings: {
	        hostname: 'ssl.imap.example.org',
	        port: 993,
	        ssl: true
	      },
	      connection_secrets: {
	        username: 'j.smith2@example.org'
	      }
	    }]
	  }
	}))));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// Where to pickup CDN resources from
	// We assume we are loaded from <script id='ui-bundle'>, so we strip the filename from the `src`
	// (we look for last `/` and strip everything after it)
	__webpack_require__.p = document.querySelector('script[id=ui-bundle]').src.replace(/\/[^/]+$/, '/');

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ClientCode = __webpack_require__(247);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var options = [{ id: '1008', text: '1008' }, { id: '1009', text: '1009' }, { id: '1010', text: '1010' }];
	
	(0, _react3.storiesOf)('ClientCode', module).addWithJSX('SearchClientCode', function () {
	  return _react2.default.createElement(_ClientCode.PureClientCode, {
	    sessionClientCode: '',
	    dispatch: (0, _addonActions.action)('dispatch'),
	    onClientCodeSuggestionsRequested: (0, _addonActions.action)('onClientCodeSuggestionsRequested'),
	    onClick: (0, _addonActions.action)('onClick') });
	}).addWithJSX('ClientCodefromSession', function () {
	  return _react2.default.createElement(_ClientCode.PureClientCode, {
	    clientCodeSuggestions: options,
	    onClientCodeSuggestionsRequested: (0, _addonActions.action)('onClientCodeSuggestionsRequested'),
	    dispatch: (0, _addonActions.action)('dispatch-remove'),
	    sessionClientCode: '119-Session',
	    onClick: (0, _addonActions.action)('onClick') });
	})
	// example of adding in some more states
	.add('Show Loading State', function () {
	  return _react2.default.createElement(_ClientCode.PureClientCode, {
	    initialClientCode: '',
	    clientCodeList: options,
	    hasMadeRequest: true,
	    loadedPrevClientCodeList: false,
	    dispatch: (0, _addonActions.action)('dispatch'),
	    sessionClientCode: '' });
	}).add('Locked', function () {
	  return _react2.default.createElement(_ClientCode.PureClientCode, {
	    initialClientCode: 'blah',
	    isClientCodeLocked: true,
	    clientCodeList: [],
	    dispatch: (0, _addonActions.action)('dispatch'),
	    onClientCodeSuggestionsRequested: (0, _addonActions.action)('ShouldNotDispatchAnyActionsWhenDisabled!'),
	    onClick: (0, _addonActions.action)('ShouldNotDispatchAnyActionsWhenDisabled!')
	  });
	}).add('Show New Code and Partial Match', function () {
	  return _react2.default.createElement(_ClientCode.PureClientCode, {
	    initialClientCode: '',
	    clientCodeList: options,
	    hasMadeRequest: false,
	    loadedPrevClientCodeList: false,
	    dispatch: (0, _addonActions.action)('dispatch'),
	    sessionClientCode: 'New code: 100',
	    placeholder: '100',
	    autoFocus: true,
	    openOnFocus: true });
	}).addWithJSX('ClientCodeMsg', function () {
	  return withWindow();
	});
	
	function withWindow() {
	  _lodash2.default.set(window, 'Drupal.settings.clientCodeChanged', true);
	  _lodash2.default.set(window, 'Drupal.settings.clientCode', 'abc');
	
	  return _react2.default.createElement(_ClientCode.PureClientCode, {
	    dispatch: (0, _addonActions.action)('dispatch'),
	    onClientCodeSuggestionsRequested: (0, _addonActions.action)('onClientCodeSuggestionsRequested'),
	    onClick: (0, _addonActions.action)('onClick'),
	    sessionClientCode: '123'
	  });
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(2149);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //packages
	
	
	//styles
	
	
	var SubmitButton = function (_Component) {
	    _inherits(SubmitButton, _Component);
	
	    function SubmitButton() {
	        _classCallCheck(this, SubmitButton);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    SubmitButton.prototype.render = function render() {
	        var _props = this.props,
	            children = _props.children,
	            onClick = _props.onClick,
	            disabled = _props.disabled,
	            type = _props.type,
	            size = _props.size,
	            className = _props.className;
	
	
	        return _react2.default.createElement('input', {
	            type: 'button',
	            disabled: disabled,
	            value: children,
	            onClick: onClick,
	            className: 'submit-button submit-button-' + type + ' submit-button-' + size + ' ' + className + ' ' + (disabled ? 'disabled' : '')
	        });
	    };
	
	    return SubmitButton;
	}(_react.Component);
	
	SubmitButton.propTypes = {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array, _propTypes2.default.string, _propTypes2.default.number]),
	
	    onClick: _propTypes2.default.func,
	
	    disabled: _propTypes2.default.bool,
	
	    type: _propTypes2.default.string,
	
	    className: _propTypes2.default.string
	};
	SubmitButton.defaultProps = {
	    children: 'Submit',
	
	    onClick: function onClick() {
	        return null;
	    },
	
	    disabled: false,
	
	    type: 'success',
	
	    size: 'big',
	
	    className: ''
	};
	exports.default = SubmitButton;

/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InfoMessage = __webpack_require__(609);
	
	var _InfoMessage2 = _interopRequireDefault(_InfoMessage);
	
	__webpack_require__(2150);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //packages
	
	
	//modules
	
	
	//styles
	
	
	var LoggedOutInfoMessage = function (_Component) {
	    _inherits(LoggedOutInfoMessage, _Component);
	
	    function LoggedOutInfoMessage() {
	        _classCallCheck(this, LoggedOutInfoMessage);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    LoggedOutInfoMessage.prototype.render = function render() {
	        return _react2.default.createElement(
	            _InfoMessage2.default,
	            null,
	            'You need to ',
	            _react2.default.createElement(
	                'a',
	                { href: '/user-portal?destination=filings/search-court-filings' },
	                'login'
	            ),
	            ' in order to access Case Lookup'
	        );
	    };
	
	    return LoggedOutInfoMessage;
	}(_react.Component);
	
	exports.default = LoggedOutInfoMessage;

/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _LoggedOutInfoMessage = __webpack_require__(1087);
	
	var _LoggedOutInfoMessage2 = _interopRequireDefault(_LoggedOutInfoMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _LoggedOutInfoMessage2.default;

/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(2151);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //packages
	
	
	//styles
	
	
	var AlertMessage = function (_Component) {
	    _inherits(AlertMessage, _Component);
	
	    function AlertMessage() {
	        _classCallCheck(this, AlertMessage);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    AlertMessage.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'alert-message' },
	            this.props.children
	        );
	    };
	
	    return AlertMessage;
	}(_react.Component);
	
	AlertMessage.propTypes = {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array, _propTypes2.default.string, _propTypes2.default.number])
	};
	AlertMessage.defaultProps = {
	    children: ''
	};
	exports.default = AlertMessage;

/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _AlertMessage = __webpack_require__(1089);
	
	var _AlertMessage2 = _interopRequireDefault(_AlertMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AlertMessage2.default;

/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDatepicker = __webpack_require__(78);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _reactRedux = __webpack_require__(13);
	
	var _moment = __webpack_require__(32);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(104);
	
	__webpack_require__(130);
	
	__webpack_require__(2152);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // TODO remove this entire module and merge the logic into the other date filter
	
	
	var DateFilter = function (_Component) {
	  _inherits(DateFilter, _Component);
	
	  function DateFilter() {
	    _classCallCheck(this, DateFilter);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  DateFilter.prototype.render = function render() {
	    var _props = this.props,
	        onChangeFrom = _props.onChangeFrom,
	        onChangeTo = _props.onChangeTo,
	        from = _props.from,
	        to = _props.to,
	        name = _props.name,
	        className = _props.className;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'date-picker-parent-container ' + className },
	      _react2.default.createElement(
	        'div',
	        { className: 'date-picker-container' },
	        _react2.default.createElement(
	          'label',
	          { className: 'date-picker-label' },
	          'Date',
	          name ? ' ' + name : '',
	          ' from'
	        ),
	        _react2.default.createElement(_reactDatepicker2.default, {
	          selected: (0, _moment2.default)(from),
	          onChange: onChangeFrom,
	          dateFormat: 'MM/DD/YYYY',
	          className: 'date-picker' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'date-picker-container' },
	        _react2.default.createElement(
	          'label',
	          { className: 'date-picker-label' },
	          'Date',
	          name ? ' ' + name : '',
	          ' to'
	        ),
	        _react2.default.createElement(_reactDatepicker2.default, {
	          selected: (0, _moment2.default)(to),
	          onChange: onChangeTo,
	          dateFormat: 'MM/DD/YYYY',
	          minDate: (0, _moment2.default)(from),
	          maxDate: (0, _moment2.default)(from).add(30, 'days'),
	          className: 'date-picker' })
	      )
	    );
	  };
	
	  return DateFilter;
	}(_react.Component);
	
	DateFilter.propTypes = {
	  name: _propTypes2.default.string,
	  onChangeFrom: _propTypes2.default.func,
	  onChangeTo: _propTypes2.default.func,
	  from: _propTypes2.default.object,
	  to: _propTypes2.default.object,
	  className: _propTypes2.default.string
	};
	DateFilter.defaultProps = {
	  name: '',
	  onChangeFrom: function onChangeFrom() {},
	  onChangeTo: function onChangeTo() {},
	  from: (0, _moment2.default)(),
	  to: (0, _moment2.default)(),
	  className: ''
	};
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    validationErrorsFields: state.getIn(['validationErrors', 'fields'], [])
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(DateFilter);

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(942);
	
	__webpack_require__(2153);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //packages
	
	
	//styles
	
	
	var DateRangeContainer = function (_Component) {
	    _inherits(DateRangeContainer, _Component);
	
	    function DateRangeContainer() {
	        _classCallCheck(this, DateRangeContainer);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    DateRangeContainer.prototype.render = function render() {
	        var _props = this.props,
	            children = _props.children,
	            className = _props.className;
	
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'date-picker-parent-container ' + className },
	            children
	        );
	    };
	
	    return DateRangeContainer;
	}(_react.Component);
	
	DateRangeContainer.propTypes = {
	    className: _propTypes2.default.string,
	
	    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)])
	};
	DateRangeContainer.defaultProps = {
	    className: ''
	};
	exports.default = DateRangeContainer;

/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _DateRangeContainer = __webpack_require__(1092);
	
	var _DateRangeContainer2 = _interopRequireDefault(_DateRangeContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DateRangeContainer2.default;

/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(32);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(1095);
	
	__webpack_require__(104);
	
	__webpack_require__(942);
	
	__webpack_require__(2154);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //packages
	
	
	//drupal old addons
	
	
	//constants
	var defaultFormats = {
	    calendar: 'MM/DD/YYYY',
	    time: 'hh:mm a',
	    dateTime: 'MM/DD/YYYY hh:mm a'
	};
	
	//styles
	
	var DateTimePicker = function (_Component) {
	    _inherits(DateTimePicker, _Component);
	
	    function DateTimePicker(props) {
	        _classCallCheck(this, DateTimePicker);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	        _this.onBlur = function () {
	            if (!_this.state.isValueChangedByKeyDown) return;
	            _this.props.onChange(new Date(_this.state.value));
	        };
	
	        var time = props.time,
	            calendar = props.calendar,
	            value = props.value;
	
	
	        var format = props.format || (time && calendar ? defaultFormats.dateTime : time ? defaultFormats.time : defaultFormats.calendar);
	
	        _this.state = {
	            value: value ? (0, _moment2.default)(value).format(format) : '',
	            format: format,
	            isValueChangedByKeyDown: false
	        };
	        return _this;
	    }
	
	    DateTimePicker.prototype.componentDidMount = function componentDidMount() {
	        this.dateTimeInit();
	    };
	
	    DateTimePicker.prototype.dateTimeInit = function dateTimeInit() {
	        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	        var time = props.time,
	            calendar = props.calendar,
	            min = props.min,
	            max = props.max;
	
	        //user should set "true" (boolean) one of props: time or calendar.
	
	        if (!time && !calendar) {
	            throw new Error('Select at least one of parameters: calendar or time.');
	        }
	
	        var valueChangeFunc = this.valueChange.bind(this);
	        var timeParams = {
	            controlType: 'select',
	            timeFormat: 'hh:mm tt',
	            showTime: false,
	            showMinute: false,
	            onSelect: valueChangeFunc,
	            hourText: 'Time' + dateFormat(' (Z) ')
	        };
	
	        if (min) {
	            timeParams.minDate = min;
	        }
	
	        if (max) {
	            timeParams.maxDate = max;
	        }
	
	        var target = $(_reactDom2.default.findDOMNode(this.refs.dateTimePicker));
	        if (time && calendar) {
	            target.datetimepicker(timeParams);
	        } else if (time) {
	            target.timepicker(timeParams);
	        } else {
	            target.datepicker(timeParams);
	        }
	    };
	
	    DateTimePicker.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	        var min = props.min,
	            max = props.max,
	            value = props.value,
	            time = props.time,
	            calendar = props.calendar;
	
	
	        var target = $(_reactDom2.default.findDOMNode(this.refs.dateTimePicker));
	        if (time !== this.props.time || calendar !== this.props.calendar) {
	            if (this.props.time && this.props.calendar) {
	                target.datetimepicker('destroy');
	            } else if (this.props.time) {
	                target.timepicker('destroy');
	            } else {
	                target.datepicker('destroy');
	            }
	
	            return this.dateTimeInit();
	        }
	
	        var dateValueFormatted = value ? (0, _moment2.default)(value).format(this.state.format) : '';
	
	        var options = {};
	        if (this.props.min && !(0, _moment2.default)(min).isSame(this.props.min, 'day')) {
	            options.minDate = min;
	        }
	
	        if (this.props.max && !(0, _moment2.default)(max).isSame(this.props.max, 'day')) {
	            options.maxDate = max;
	        }
	
	        if (!_lodash2.default.isEmpty(options)) {
	            if (time && calendar) {
	                target.datetimepicker('option', options);
	            } else if (time) {
	                target.timepicker('option', options);
	            } else {
	                target.datepicker('option', options);
	            }
	        }
	
	        if (this.state.value !== dateValueFormatted) {
	            this.setState({ value: dateValueFormatted });
	        }
	    };
	
	    DateTimePicker.prototype.valueChange = function valueChange(e) {
	        var value = _lodash2.default.get(e, 'target.value', e);
	
	        var isValueChangedByKeyDown = !!e.target;
	
	        //if changed in line by typing
	        if (this.state.isValueChangedByKeyDown && !isValueChangedByKeyDown) {
	            this.props.onChange(new Date(value));
	            return this.setState({
	                value: (0, _moment2.default)(value).format(this.state.format),
	                isValueChangedByKeyDown: isValueChangedByKeyDown
	            });
	        }
	
	        this.setState({
	            value: value,
	            isValueChangedByKeyDown: isValueChangedByKeyDown
	        });
	
	        if (!isValueChangedByKeyDown) {
	            this.props.onChange(new Date(this.state.value));
	        }
	    };
	
	    DateTimePicker.prototype.render = function render() {
	        var _props = this.props,
	            title = _props.title,
	            time = _props.time;
	
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'date-picker-custom date-picker-type-' + (time ? 'datetime-picker' : 'date-picker') },
	            _react2.default.createElement(
	                'label',
	                { className: 'selector-label' },
	                title
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'date-picker-container' },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement('input', {
	                                className: 'Select-value-label',
	                                ref: 'dateTimePicker',
	                                type: 'text',
	                                value: this.state.value,
	                                onChange: this.valueChange.bind(this),
	                                onBlur: this.onBlur
	                            })
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return DateTimePicker;
	}(_react.Component);
	
	DateTimePicker.propTypes = {
	    title: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array, _propTypes2.default.string, _propTypes2.default.number]),
	
	    format: _propTypes2.default.string,
	
	    time: _propTypes2.default.bool,
	    calendar: _propTypes2.default.bool,
	
	    onChange: _propTypes2.default.func,
	
	    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	
	    min: _propTypes2.default.object,
	    max: _propTypes2.default.object
	};
	DateTimePicker.defaultProps = {
	    onChange: function onChange() {
	        return null;
	    },
	
	    value: new Date(),
	
	    title: 'Date',
	
	    time: false,
	    calendar: true
	};
	exports.default = DateTimePicker;

/***/ },
/* 1095 */
/***/ function(module, exports) {

	"use strict";
	
	/*
	 * Date Format 1.2.3
	 * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
	 * MIT license
	 *
	 * Includes enhancements by Scott Trenda <scott.trenda.net>
	 * and Kris Kowal <cixar.com/~kris.kowal/>
	 *
	 * Accepts a date, a mask, or a date and a mask.
	 * Returns a formatted version of the given date.
	 * The date defaults to the current date/time.
	 * The mask defaults to dateFormat.masks.default.
	 */
	
	var dateFormat = function () {
	    var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
	        timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
	        timezoneClip = /[^-+\dA-Z]/g,
	        pad = function pad(val, len) {
	        val = String(val);
	        len = len || 2;
	        while (val.length < len) {
	            val = "0" + val;
	        }return val;
	    };
	
	    // Regexes and supporting functions are cached through closure
	    return function (date, mask, utc) {
	        var dF = dateFormat;
	
	        // You can't provide utc if you skip other args (use the "UTC:" mask prefix)
	        if (arguments.length == 1 && Object.prototype.toString.call(date) == "[object String]" && !/\d/.test(date)) {
	            mask = date;
	            date = undefined;
	        }
	
	        // Passing date through Date applies Date.parse, if necessary
	        date = date ? new Date(date) : new Date();
	        if (isNaN(date)) throw SyntaxError("invalid date");
	
	        mask = String(dF.masks[mask] || mask || dF.masks["default"]);
	
	        // Allow setting the utc argument via the mask
	        if (mask.slice(0, 4) == "UTC:") {
	            mask = mask.slice(4);
	            utc = true;
	        }
	
	        var _ = utc ? "getUTC" : "get",
	            d = date[_ + "Date"](),
	            D = date[_ + "Day"](),
	            m = date[_ + "Month"](),
	            y = date[_ + "FullYear"](),
	            H = date[_ + "Hours"](),
	            M = date[_ + "Minutes"](),
	            s = date[_ + "Seconds"](),
	            L = date[_ + "Milliseconds"](),
	            o = utc ? 0 : date.getTimezoneOffset(),
	            flags = {
	            d: d,
	            dd: pad(d),
	            ddd: dF.i18n.dayNames[D],
	            dddd: dF.i18n.dayNames[D + 7],
	            m: m + 1,
	            mm: pad(m + 1),
	            mmm: dF.i18n.monthNames[m],
	            mmmm: dF.i18n.monthNames[m + 12],
	            yy: String(y).slice(2),
	            yyyy: y,
	            h: H % 12 || 12,
	            hh: pad(H % 12 || 12),
	            H: H,
	            HH: pad(H),
	            M: M,
	            MM: pad(M),
	            s: s,
	            ss: pad(s),
	            l: pad(L, 3),
	            L: pad(L > 99 ? Math.round(L / 10) : L),
	            t: H < 12 ? "a" : "p",
	            tt: H < 12 ? "am" : "pm",
	            T: H < 12 ? "A" : "P",
	            TT: H < 12 ? "AM" : "PM",
	            Z: utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
	            o: (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
	            S: ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
	        };
	
	        return mask.replace(token, function ($0) {
	            return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
	        });
	    };
	}();
	
	// Some common format strings
	dateFormat.masks = {
	    "default": "ddd mmm dd yyyy HH:MM:ss",
	    shortDate: "m/d/yy",
	    mediumDate: "mmm d, yyyy",
	    longDate: "mmmm d, yyyy",
	    fullDate: "dddd, mmmm d, yyyy",
	    shortTime: "h:MM TT",
	    mediumTime: "h:MM:ss TT",
	    longTime: "h:MM:ss TT Z",
	    isoDate: "yyyy-mm-dd",
	    isoTime: "HH:MM:ss",
	    isoDateTime: "yyyy-mm-dd'T'HH:MM:ss",
	    isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
	};
	
	// Internationalization strings
	dateFormat.i18n = {
	    dayNames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	    monthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
	};
	
	// For convenience...
	Date.prototype.format = function (mask, utc) {
	    return dateFormat(this, mask, utc);
	};

/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _DateTimePicker = __webpack_require__(1094);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DateTimePicker2.default;

/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(2155);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //packages
	
	
	//styles
	
	
	var FieldSet = function (_Component) {
	    _inherits(FieldSet, _Component);
	
	    function FieldSet() {
	        _classCallCheck(this, FieldSet);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    FieldSet.prototype.render = function render() {
	        var _props = this.props,
	            children = _props.children,
	            title = _props.title;
	
	
	        return _react2.default.createElement(
	            'fieldset',
	            { className: 'ir-fieldset' },
	            _react2.default.createElement(
	                'legend',
	                null,
	                title
	            ),
	            children
	        );
	    };
	
	    return FieldSet;
	}(_react.Component);
	
	FieldSet.propTypes = {
	    title: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array, _propTypes2.default.string, _propTypes2.default.number]),
	    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array, _propTypes2.default.string, _propTypes2.default.number])
	};
	FieldSet.defaultProps = {
	    children: '',
	    title: ''
	};
	exports.default = FieldSet;

/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	__webpack_require__(2156);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // packages
	
	
	// styles
	
	
	var FormOption = function (_Component) {
	  _inherits(FormOption, _Component);
	
	  function FormOption() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FormOption);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onClick = function () {
	      return _this.props.onClick(_reactDom2.default.findDOMNode(_this.refs.radio).value);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  FormOption.prototype.render = function render() {
	    var _props = this.props,
	        eventKey = _props.eventKey,
	        activeKey = _props.activeKey,
	        children = _props.children;
	
	
	    var id = 'form-options-' + eventKey + '-hash-' + _lodash2.default.random(9999);
	
	    var isSelected = activeKey === eventKey;
	
	    return _react2.default.createElement(
	      'div',
	      {
	        onClick: this.onClick,
	        className: 'form-option ' + (isSelected ? 'selected' : '') },
	      _react2.default.createElement(
	        'label',
	        { className: 'option', htmlFor: id },
	        _react2.default.createElement('input', {
	          ref: 'radio',
	          type: 'radio',
	          id: id,
	          value: eventKey,
	          onChange: function onChange() {
	            return null;
	          },
	          checked: isSelected,
	          className: 'form-radio' }),
	        ' ',
	        children
	      )
	    );
	  };
	
	  return FormOption;
	}(_react.Component);
	
	FormOption.propTypes = {
	  activeKey: _propTypes2.default.string,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array, _propTypes2.default.string, _propTypes2.default.number]),
	  eventKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	  onClick: _propTypes2.default.func
	};
	FormOption.defaultProps = {
	  selected: false,
	  children: ''
	};
	exports.default = FormOption;

/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _FormOption = __webpack_require__(1098);
	
	var _FormOption2 = _interopRequireDefault(_FormOption);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FormOption2.default;

/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	__webpack_require__(2157);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //packages
	
	
	//styles
	
	
	var FormOptions = function (_Component) {
	    _inherits(FormOptions, _Component);
	
	    function FormOptions() {
	        _classCallCheck(this, FormOptions);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    FormOptions.prototype.render = function render() {
	        var _this2 = this;
	
	        var activeKey = this.props.activeKey;
	        var Options = this.props.children;
	
	
	        Options = !_lodash2.default.isArray(Options) ? [Options] : Options;
	        Options = Options.map(function (option, index) {
	            return _react2.default.cloneElement(option, {
	                onClick: _this2.props.onSelect,
	                key: index,
	                activeKey: activeKey
	            });
	        });
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'form-options' },
	            Options
	        );
	    };
	
	    return FormOptions;
	}(_react.Component);
	
	FormOptions.propTypes = {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array]),
	    onSelect: _propTypes2.default.func,
	    activeKey: _propTypes2.default.string
	};
	FormOptions.defaultProps = {
	    onSelect: function onSelect() {
	        return null;
	    }
	};
	exports.default = FormOptions;

/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _FormOptions = __webpack_require__(1100);
	
	var _FormOptions2 = _interopRequireDefault(_FormOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FormOptions2.default;

/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(2158);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //packages
	
	
	//styles
	
	
	var InfoMessage = function (_Component) {
	    _inherits(InfoMessage, _Component);
	
	    function InfoMessage() {
	        _classCallCheck(this, InfoMessage);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    InfoMessage.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'info-message' },
	            this.props.children
	        );
	    };
	
	    return InfoMessage;
	}(_react.Component);
	
	InfoMessage.propTypes = {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array, _propTypes2.default.string, _propTypes2.default.number])
	};
	InfoMessage.defaultProps = {
	    children: ''
	};
	exports.default = InfoMessage;

/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(2160);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //packages
	
	
	//styles
	
	
	var ResultsTable = function (_Component) {
	    _inherits(ResultsTable, _Component);
	
	    function ResultsTable() {
	        _classCallCheck(this, ResultsTable);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    ResultsTable.prototype.render = function render() {
	        var _props = this.props,
	            children = _props.children,
	            titles = _props.titles;
	
	
	        if (!children.size) return null;
	
	        var Trs = children.map(function (data, index) {
	            var meta = data.get('meta');
	
	            var caseTitle = meta.get('case_title');
	            var caseUuid = meta.get('case_uuid');
	            var courtCode = meta.get('court_code');
	            var caseNo = meta.get('case_no');
	            var chapter = meta.get('chapter');
	            var dateFiled = meta.get('date_filed');
	            var dateClosed = meta.get('date_closed');
	            var disposition = meta.get('disposition');
	
	            var url = (caseUuid + '-' + caseNo + '-' + caseTitle).replace(/[:\s]/ig, '-').toLowerCase();
	
	            return _react2.default.createElement(
	                'tr',
	                { className: index % 2 == 0 ? 'odd' : 'even', key: index },
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    caseTitle
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    courtCode
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: 'ir-search-no-wrap' },
	                    _react2.default.createElement(
	                        'a',
	                        { href: '/filings/' + url },
	                        caseNo
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    chapter
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    dateFiled
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    dateClosed
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    disposition
	                )
	            );
	        });
	
	        return _react2.default.createElement(
	            'table',
	            { className: 'results-table' },
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    titles.map(function (title, index) {
	                        return _react2.default.createElement(
	                            'th',
	                            { key: index },
	                            title
	                        );
	                    })
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                Trs
	            )
	        );
	    };
	
	    return ResultsTable;
	}(_react.Component);
	
	ResultsTable.propTypes = {
	    children: _propTypes2.default.object,
	    titles: _propTypes2.default.array
	};
	ResultsTable.defaultProps = {
	    children: '',
	    titles: []
	};
	exports.default = ResultsTable;

/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _ResultsTable = __webpack_require__(1103);
	
	var _ResultsTable2 = _interopRequireDefault(_ResultsTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ResultsTable2.default;

/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _SelectorPopover = __webpack_require__(1106);
	
	var _SelectorPopover2 = _interopRequireDefault(_SelectorPopover);
	
	__webpack_require__(2161);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Selector = function (_Component) {
	  _inherits(Selector, _Component);
	
	  function Selector() {
	    _classCallCheck(this, Selector);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Selector.prototype.mapToOptions = function mapToOptions(mapOfOptions) {
	    return Object.keys(mapOfOptions).map(function (instance) {
	      return {
	        value: instance,
	        label: mapOfOptions[instance]
	      };
	    });
	  };
	
	  Selector.prototype.render = function render() {
	    var _props = this.props,
	        title = _props.title,
	        options = _props.options,
	        info = _props.info,
	        value = _props.value,
	        placeholder = _props.placeholder,
	        onChange = _props.onChange,
	        className = _props.className,
	        multi = _props.multi,
	        clearable = _props.clearable,
	        disabled = _props.disabled;
	
	
	    var id = title.replace(/\s/, '-').toLowerCase();
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'selector-container ' + className, id: id },
	      _react2.default.createElement(
	        'label',
	        { className: 'selector-label', htmlFor: id },
	        title,
	        ' ',
	        info && _react2.default.createElement(
	          _SelectorPopover2.default,
	          null,
	          info
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'select-wrapper' },
	        _react2.default.createElement(_reactSelect2.default, {
	          name: id,
	          className: 'selector',
	          options: this.mapToOptions(options),
	          clearable: clearable,
	          multi: multi,
	          simpleValue: true,
	          value: value,
	          disabled: disabled,
	          placeholder: placeholder,
	          onChange: onChange })
	      )
	    );
	  };
	
	  return Selector;
	}(_react.Component);
	
	Selector.propTypes = {
	  title: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array, _propTypes2.default.string, _propTypes2.default.number]),
	  info: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array, _propTypes2.default.string, _propTypes2.default.number]),
	  className: _propTypes2.default.string,
	  options: _propTypes2.default.object,
	  value: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.object), _propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.object, _propTypes2.default.string]),
	  placeholder: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  multi: _propTypes2.default.bool,
	  clearable: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool
	};
	Selector.defaultProps = {
	  title: '',
	  info: '',
	  options: [],
	  value: [],
	  placeholder: '',
	  className: '',
	  onChange: function onChange() {
	    return null;
	  },
	  multi: false,
	  clearable: true,
	  disabled: false
	};
	exports.default = Selector;

/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _SelectorPopover = __webpack_require__(612);
	
	var _SelectorPopover2 = _interopRequireDefault(_SelectorPopover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SelectorPopover2.default;

/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(2162);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //packages
	
	
	//styles
	
	
	var WarningBox = function (_Component) {
	    _inherits(WarningBox, _Component);
	
	    function WarningBox() {
	        _classCallCheck(this, WarningBox);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    WarningBox.prototype.render = function render() {
	        var children = this.props.children;
	
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'ir-warning-box' },
	            children
	        );
	    };
	
	    return WarningBox;
	}(_react.Component);
	
	WarningBox.propTypes = {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array, _propTypes2.default.string, _propTypes2.default.number])
	};
	WarningBox.defaultProps = {
	    children: ''
	};
	exports.default = WarningBox;

/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HelperPopover = function (_Component) {
	  _inherits(HelperPopover, _Component);
	
	  function HelperPopover() {
	    _classCallCheck(this, HelperPopover);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  HelperPopover.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactBootstrap.OverlayTrigger,
	      {
	        trigger: ['hover', 'focus'],
	        placement: 'left',
	        shouldUpdatePosition: true,
	        overlay: _react2.default.createElement(
	          _reactBootstrap.Popover,
	          { id: 'popover-of-form' },
	          _react2.default.createElement(
	            'div',
	            { className: 'help-operators' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Help operators:'
	            ),
	            _react2.default.createElement(
	              'table',
	              null,
	              _react2.default.createElement(
	                'tbody',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  { title: 'Find all words, e.g.: motion AND 363' },
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'AND'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'All Words'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  { title: 'Find at least one of the words, e.g.: motion OR 363' },
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'OR'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Either Word'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  { title: 'Find these words within n words of each other, e.g.: motion /3 363' },
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    '/n'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Within ',
	                    _react2.default.createElement(
	                      'var',
	                      null,
	                      'n'
	                    ),
	                    ' terms of'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  { title: 'Find this sequence of words exactly as typed, e.g.: "order on motion for relief from stay"' },
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    '"_"'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Phrase'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  { title: 'Find results without this word, e.g.: order -relief' },
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    '-word'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'But not'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  { title: 'Find words that start or end as specified, e.g.: evid*' },
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    '*'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Wildcard'
	                  )
	                )
	              )
	            )
	          )
	        ) },
	      this.props.children
	    );
	  };
	
	  return HelperPopover;
	}(_react.Component);
	
	HelperPopover.defaultProps = {
	  children: null
	};
	
	HelperPopover.propTypes = {
	  children: _propTypes2.default.any
	  //   .oneOfType([
	  //   PropTypes.array,
	  //   PropTypes.element,
	  // ]),
	};
	
	exports.default = HelperPopover;

/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _CasesForm = __webpack_require__(350);
	
	var _CasesForm2 = _interopRequireDefault(_CasesForm);
	
	var _Notification = __webpack_require__(40);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Advanced Search/Initial Forms/All Courts/Cases', module).add('View', function () {
	  return _react2.default.createElement(_CasesForm2.default, { onSubmit: (0, _addonActions.action)('searchGeneral'), onReset: (0, _addonActions.action)('resetGeneralSearch') });
	}).add('Search error', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Notification2.default, null),
	    _react2.default.createElement(_CasesForm2.default, {
	      onSubmit: function onSubmit() {
	        _Notification.notify.error('Failed to return Advanced Search results');
	        (0, _addonActions.action)('searchGeneral').apply(undefined, arguments);
	      },
	      onReset: (0, _addonActions.action)('resetGeneralSearch')
	    })
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _GeneralForm = __webpack_require__(351);
	
	var _GeneralForm2 = _interopRequireDefault(_GeneralForm);
	
	var _Notification = __webpack_require__(40);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Advanced Search/Initial Forms/All Courts/General', module).add('View', function () {
	  return _react2.default.createElement(
	    'div',
	    { className: 'advanced-search-form' },
	    _react2.default.createElement(_GeneralForm2.default, { onSubmit: (0, _addonActions.action)('searchGeneral'), onReset: (0, _addonActions.action)('resetGeneralSearch') })
	  );
	}).add('Search error', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Notification2.default, null),
	    _react2.default.createElement(_GeneralForm2.default, {
	      onSubmit: function onSubmit() {
	        _Notification.notify.error('Failed to return Advanced Search results');
	        (0, _addonActions.action)('searchGeneral').apply(undefined, arguments);
	      },
	      onReset: (0, _addonActions.action)('resetGeneralSearch')
	    })
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _CasesForm = __webpack_require__(249);
	
	var _CasesForm2 = _interopRequireDefault(_CasesForm);
	
	var _Notification = __webpack_require__(40);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Advanced Search/Initial Forms/Bankruptcy/Cases', module).add('View', function () {
	  return _react2.default.createElement(_CasesForm2.default, { onSubmit: (0, _addonActions.action)('searchGeneral'), onReset: (0, _addonActions.action)('resetGeneralSearch') });
	}).add('Search error', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Notification2.default, null),
	    _react2.default.createElement(_CasesForm2.default, {
	      onSubmit: function onSubmit() {
	        _Notification.notify.error('Failed to return Advanced Search results');
	        (0, _addonActions.action)('searchGeneral').apply(undefined, arguments);
	      },
	      onReset: (0, _addonActions.action)('resetGeneralSearch')
	    })
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _GeneralForm = __webpack_require__(250);
	
	var _GeneralForm2 = _interopRequireDefault(_GeneralForm);
	
	var _Notification = __webpack_require__(40);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Advanced Search/Initial Forms/Bankruptcy/General', module).add('View', function () {
	  return _react2.default.createElement(
	    'div',
	    { className: 'advanced-search-form' },
	    _react2.default.createElement(_GeneralForm2.default, { onSubmit: (0, _addonActions.action)('searchGeneral'), onReset: (0, _addonActions.action)('resetGeneralSearch') })
	  );
	}).add('Search error', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Notification2.default, null),
	    _react2.default.createElement(_GeneralForm2.default, {
	      onSubmit: function onSubmit() {
	        _Notification.notify.error('Failed to return Advanced Search results');
	        (0, _addonActions.action)('searchGeneral').apply(undefined, arguments);
	      },
	      onReset: (0, _addonActions.action)('resetGeneralSearch')
	    })
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _PetitionsForm = __webpack_require__(251);
	
	var _PetitionsForm2 = _interopRequireDefault(_PetitionsForm);
	
	var _Notification = __webpack_require__(40);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Advanced Search/Initial Forms/Bankruptcy/Petitions', module).add('View', function () {
	  return _react2.default.createElement(
	    'div',
	    { className: 'advanced-search-form' },
	    _react2.default.createElement(_PetitionsForm2.default, { onSubmit: (0, _addonActions.action)('searchGeneral'), onReset: (0, _addonActions.action)('resetGeneralSearch') })
	  );
	}).add('Search error', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Notification2.default, null),
	    _react2.default.createElement(_PetitionsForm2.default, {
	      onSubmit: function onSubmit() {
	        _Notification.notify.error('Failed to return Advanced Search results');
	        (0, _addonActions.action)('searchGeneral').apply(undefined, arguments);
	      },
	      onReset: (0, _addonActions.action)('resetGeneralSearch')
	    })
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _SchedulesForm = __webpack_require__(352);
	
	var _SchedulesForm2 = _interopRequireDefault(_SchedulesForm);
	
	var _Notification = __webpack_require__(40);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Advanced Search/Initial Forms/Bankruptcy/Schedules', module).add('View', function () {
	  return _react2.default.createElement(
	    'div',
	    { className: 'advanced-search-form' },
	    _react2.default.createElement(_SchedulesForm2.default, { onSubmit: (0, _addonActions.action)('searchGeneral'), onReset: (0, _addonActions.action)('resetGeneralSearch') })
	  );
	}).add('Search error', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Notification2.default, null),
	    _react2.default.createElement(_SchedulesForm2.default, {
	      onSubmit: function onSubmit() {
	        _Notification.notify.error('Failed to return Advanced Search results');
	        (0, _addonActions.action)('searchGeneral').apply(undefined, arguments);
	      },
	      onReset: (0, _addonActions.action)('resetGeneralSearch')
	    })
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _CasesForm = __webpack_require__(353);
	
	var _CasesForm2 = _interopRequireDefault(_CasesForm);
	
	var _Notification = __webpack_require__(40);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Advanced Search/Initial Forms/Civil/Cases', module).add('View', function () {
	  return _react2.default.createElement(_CasesForm2.default, { onSubmit: (0, _addonActions.action)('searchGeneral'), onReset: (0, _addonActions.action)('resetGeneralSearch') });
	}).add('Search error', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Notification2.default, null),
	    _react2.default.createElement(_CasesForm2.default, {
	      onSubmit: function onSubmit() {
	        _Notification.notify.error('Failed to return Advanced Search results');
	        (0, _addonActions.action)('searchGeneral').apply(undefined, arguments);
	      },
	      onReset: (0, _addonActions.action)('resetGeneralSearch')
	    })
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _GeneralForm = __webpack_require__(354);
	
	var _GeneralForm2 = _interopRequireDefault(_GeneralForm);
	
	var _Notification = __webpack_require__(40);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Advanced Search/Initial Forms/Civil/General', module).add('View', function () {
	  return _react2.default.createElement(
	    'div',
	    { className: 'advanced-search-form' },
	    _react2.default.createElement(_GeneralForm2.default, { onSubmit: (0, _addonActions.action)('searchGeneral'), onReset: (0, _addonActions.action)('resetGeneralSearch') })
	  );
	}).add('Search error', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Notification2.default, null),
	    _react2.default.createElement(_GeneralForm2.default, {
	      onSubmit: function onSubmit() {
	        _Notification.notify.error('Failed to return Advanced Search results');
	        (0, _addonActions.action)('searchGeneral').apply(undefined, arguments);
	      },
	      onReset: (0, _addonActions.action)('resetGeneralSearch')
	    })
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _CasesForm = __webpack_require__(355);
	
	var _CasesForm2 = _interopRequireDefault(_CasesForm);
	
	var _Notification = __webpack_require__(40);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Advanced Search/Initial Forms/Criminal/Cases', module).add('View', function () {
	  return _react2.default.createElement(_CasesForm2.default, { onSubmit: (0, _addonActions.action)('searchGeneral'), onReset: (0, _addonActions.action)('resetGeneralSearch') });
	}).add('Search error', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Notification2.default, null),
	    _react2.default.createElement(_CasesForm2.default, {
	      onSubmit: function onSubmit() {
	        _Notification.notify.error('Failed to return Advanced Search results');
	        (0, _addonActions.action)('searchGeneral').apply(undefined, arguments);
	      },
	      onReset: (0, _addonActions.action)('resetGeneralSearch')
	    })
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _GeneralForm = __webpack_require__(356);
	
	var _GeneralForm2 = _interopRequireDefault(_GeneralForm);
	
	var _Notification = __webpack_require__(40);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Advanced Search/Initial Forms/Criminal/General', module).add('View', function () {
	  return _react2.default.createElement(
	    'div',
	    { className: 'advanced-search-form' },
	    _react2.default.createElement(_GeneralForm2.default, { onSubmit: (0, _addonActions.action)('searchGeneral'), onReset: (0, _addonActions.action)('resetGeneralSearch') })
	  );
	}).add('Search error', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Notification2.default, null),
	    _react2.default.createElement(_GeneralForm2.default, {
	      onSubmit: function onSubmit() {
	        _Notification.notify.error('Failed to return Advanced Search results');
	        (0, _addonActions.action)('searchGeneral').apply(undefined, arguments);
	      },
	      onReset: (0, _addonActions.action)('resetGeneralSearch')
	    })
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _AdvancedFilterModal = __webpack_require__(357);
	
	var _AdvancedFilterModal2 = _interopRequireDefault(_AdvancedFilterModal);
	
	var _addonActions = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Advanced Search/Result Form/Modals', module).add('AdvancedFilterModal', function () {
	  return _react2.default.createElement(_AdvancedFilterModal2.default, {
	    show: true,
	    onClose: function onClose() {
	      return null;
	    },
	    onSave: (0, _addonActions.action)('submitAdvancedSearch'),
	    filter: filter
	  });
	});
	
	var filter = {};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _CaseFilterModal = __webpack_require__(358);
	
	var _CaseFilterModal2 = _interopRequireDefault(_CaseFilterModal);
	
	var _addonActions = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Advanced Search/Result Form/Modals', module).add('CaseFilterModal', function () {
	  return _react2.default.createElement(_CaseFilterModal2.default, {
	    show: true,
	    onClose: function onClose() {
	      return null;
	    },
	    onSave: (0, _addonActions.action)('submitAdvancedSearch'),
	    filter: filter
	  });
	});
	
	var filter = {};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _DateFilterModal = __webpack_require__(359);
	
	var _DateFilterModal2 = _interopRequireDefault(_DateFilterModal);
	
	var _addonActions = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Advanced Search/Result Form/Modals', module).add('DateFilterModal', function () {
	  return _react2.default.createElement(_DateFilterModal2.default, {
	    show: true,
	    onClose: function onClose() {
	      return null;
	    },
	    onSave: (0, _addonActions.action)('submitAdvancedSearch'),
	    filter: filter
	  });
	});
	
	var filter = {};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _FinancialFilterModal = __webpack_require__(360);
	
	var _FinancialFilterModal2 = _interopRequireDefault(_FinancialFilterModal);
	
	var _addonActions = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Advanced Search/Result Form/Modals', module).add('FinancialFilterModal', function () {
	  return _react2.default.createElement(_FinancialFilterModal2.default, {
	    show: true,
	    onClose: function onClose() {
	      return null;
	    },
	    onSave: (0, _addonActions.action)('submitAdvancedSearch'),
	    filter: filter
	  });
	});
	
	var filter = {};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _ResultForm = __webpack_require__(361);
	
	var _ResultForm2 = _interopRequireDefault(_ResultForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Advanced Search/Result Form', module).add('View', function () {
	  return _react2.default.createElement(_ResultForm2.default, {
	    filter: { court_type: 'bankruptcy', tab: 'schedules' },
	    onSubmit: (0, _addonActions.action)('searchGeneral'),
	    onReset: (0, _addonActions.action)('resetGeneralSearch')
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _ScheduleFilterModal = __webpack_require__(362);
	
	var _ScheduleFilterModal2 = _interopRequireDefault(_ScheduleFilterModal);
	
	var _addonActions = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Advanced Search/Result Form/Modals', module).add('ScheduleFilterModal', function () {
	  return _react2.default.createElement(_ScheduleFilterModal2.default, {
	    show: true,
	    onClose: function onClose() {
	      return null;
	    },
	    onSave: (0, _addonActions.action)('submitAdvancedSearch'),
	    filter: filter
	  });
	});
	
	var filter = {};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _AliasesResultRow = __webpack_require__(363);
	
	var _AliasesResultRow2 = _interopRequireDefault(_AliasesResultRow);
	
	var _EntriesResults = __webpack_require__(132);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Advanced Search/Result Rows', module).add('Aliases', function () {
	  return _react2.default.createElement(
	    'div',
	    { className: 'result-item' },
	    _react2.default.createElement(_EntriesResults.RowHeader, { row: row }),
	    _react2.default.createElement(
	      'div',
	      { className: 'result-item-body' },
	      _react2.default.createElement(_AliasesResultRow2.default, { row: row })
	    )
	  );
	});
	
	var row = {
	  case: {
	    date_plan_confirmed: null,
	    chapter: 11,
	    case_nature_of_suit_code: null,
	    index_timestamp: 1567082914
	  },
	  case_assets: "Unknown",
	  case_chapter: 11,
	  case_court: "nysbke",
	  case_date_filed: "03/10/2014",
	  case_judge_name: "Martin Glenn",
	  case_liabilities: "Unknown",
	  case_naics_code: null,
	  case_nature_of_suit_code: null,
	  case_no: "1:14-bk-10557",
	  case_title: "Sbarro LLC",
	  case_type: "bk",
	  case_uuid: "nysbke_247775",
	  date_filed: "08/29/2019",
	  document_type: "alias",
	  id: "alias:nysbke_247775--Sbarro LLC",
	  index_timestamp: 1567082848,
	  party: {
	    address: "401 Broadhollow Road↵Melville, NY 11747",
	    email: null,
	    fax: null,
	    name: '<span class="highlight">Sbarro</span> LLC',
	    participant_id: 668034,
	    phone: null,
	    role: "Debtor"
	  },
	  party_alias: [{
	    modified: "2014-04-23 16:44:34.421029+00",
	    name: 'New <span class="highlight">Sbarro</span> LLC',
	    role: "aka"
	  }],
	  query: "alias",
	  timestamp: 1567082848,
	  type_code: 11
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _AttorneysResultRow = __webpack_require__(364);
	
	var _AttorneysResultRow2 = _interopRequireDefault(_AttorneysResultRow);
	
	var _EntriesResults = __webpack_require__(132);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Advanced Search/Result Rows', module).add('Attorneys', function () {
	  return _react2.default.createElement(
	    'div',
	    { className: 'result-item' },
	    _react2.default.createElement(_EntriesResults.RowHeader, { row: row }),
	    _react2.default.createElement(
	      'div',
	      { className: 'result-item-body' },
	      _react2.default.createElement(_AttorneysResultRow2.default, { row: row })
	    )
	  );
	});
	
	var row = {
	  associated: [{
	    address: "401 Broadhollow Road↵Melville, NY 11747",
	    email: null,
	    fax: null,
	    name: '<span class="highlight">Sbarro</span> LLC',
	    phone: null,
	    role: "Debtor"
	  }, {
	    address: "401 Broadhollow Road↵Melville, NY 11747",
	    email: null,
	    fax: null,
	    name: '<span class="highlight">Sbarro</span> LLC',
	    phone: null,
	    role: "Joint Debtor"
	  }, {
	    address: "401 Broadhollow Road↵Melville, NY 11747",
	    email: null,
	    fax: null,
	    name: '<span class="highlight">Sbarro</span> LLC,  <I>Debtor</I>',
	    phone: null,
	    role: "Debtor"
	  }, {
	    address: "401 Broadhollow Road↵Melville, NY 11747",
	    email: null,
	    fax: null,
	    name: '<span class="highlight">Sbarro</span> LLC,  <I>et al.</I>',
	    phone: null,
	    role: "Debtor"
	  }],
	  attorney: {
	    address: "Kirkland & Ellis, LLP↵601 Lexington Avenue↵New York, NY 10022",
	    assigned_date: null,
	    case_attorney_id: 87066,
	    email: "ngreenblatt@kirkland.com",
	    fax: "(212) 446-4900",
	    lead: "Attorney",
	    modified: "2014-03-10 13:01:50.412383+00",
	    name: "Nicole Greenblatt",
	    phone: "(212) 446-4800"
	  },
	  case: { jurisdiction: null, case_no: "1:14-bk-10557", date_discharged: null },
	  case_assets: "Unknown",
	  case_chapter: 11,
	  case_court: "nysbke",
	  case_date_filed: "03/10/2014",
	  case_judge_name: "Martin Glenn",
	  case_liabilities: "Unknown",
	  case_naics_code: null,
	  case_nature_of_suit_code: null,
	  case_no: "1:14-bk-10557",
	  case_title: "Sbarro LLC",
	  case_type: "bk",
	  case_uuid: "nysbke_247775",
	  date_filed: "08/29/2019",
	  document_type: "attorneys"
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _CreditorsResultRow = __webpack_require__(365);
	
	var _CreditorsResultRow2 = _interopRequireDefault(_CreditorsResultRow);
	
	var _EntriesResults = __webpack_require__(132);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Advanced Search/Result Rows', module).add('Creditors', function () {
	  return _react2.default.createElement(
	    'div',
	    { className: 'result-item' },
	    _react2.default.createElement(_EntriesResults.RowHeader, { row: row }),
	    _react2.default.createElement(
	      'div',
	      { className: 'result-item-body' },
	      _react2.default.createElement(_CreditorsResultRow2.default, { row: row })
	    )
	  );
	});
	
	var row = {
	  address: "c/o Daniel L. Goodkin↵1875 Century Park East, Suite 1860↵Los Angeles, CA 90067",
	  case: { case_court: "nysbke", type_code: 0, schedule_ab: null, case_naics_code: null },
	  case_assets: "Unknown",
	  case_chapter: 11,
	  case_court: "nysbke",
	  case_date_filed: "03/10/2014",
	  case_judge_name: "Martin Glenn",
	  case_liabilities: "Unknown",
	  case_naics_code: null,
	  case_nature_of_suit_code: null,
	  case_no: "1:14-bk-10557",
	  case_title: "Sbarro LLC",
	  case_type: "bk",
	  case_uuid: "nysbke_247775",
	  creditor_code: "6449847",
	  creditor_role: "cr",
	  date_filed: "08/29/2019",
	  document_type: "creditors",
	  id: "creditors:nysbke_247775--6449847",
	  index_timestamp: 1567082848,
	  modified: "2014-03-16 18:27:19.420753+00",
	  name: "5060 Montclair Plaza Lane Owner, LLC",
	  query: "creditors",
	  timestamp: 1567082848,
	  type_code: 5
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _FilersResultRow = __webpack_require__(366);
	
	var _FilersResultRow2 = _interopRequireDefault(_FilersResultRow);
	
	var _EntriesResults = __webpack_require__(132);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Advanced Search/Result Rows', module).add('Filers', function () {
	  return _react2.default.createElement(
	    'div',
	    { className: 'result-item' },
	    _react2.default.createElement(_EntriesResults.RowHeader, { row: row }),
	    _react2.default.createElement(
	      'div',
	      { className: 'result-item-body' },
	      _react2.default.createElement(_FilersResultRow2.default, { row: row })
	    )
	  );
	});
	
	var row = {
	  case: {},
	  case_assets: "Unknown",
	  case_chapter: 11,
	  case_court: "nysbke",
	  case_date_filed: "03/10/2014",
	  case_judge_name: "Martin Glenn",
	  case_liabilities: "Unknown",
	  case_naics_code: null,
	  case_nature_of_suit_code: null,
	  case_no: "1:14-bk-10557",
	  case_title: "Sbarro LLC",
	  case_type: "bk",
	  case_uuid: "nysbke_247775",
	  date_added: "03/28/2014",
	  date_filed: "08/29/2019",
	  date_terminated: null,
	  document_type: "filers",
	  highlighted: { name: true },
	  id: "filers:nysbke_247775--Official Committee of Unsecured Creditors of Sbarro LLC, et al./Creditor Committee",
	  index_timestamp: 1567082848,
	  join: { name: "documents", parent: "cases:nysbke_247775" },
	  modified: "2014-05-01 19:43:54.973514+00",
	  name: 'Official Committee of Unsecured Creditors of <span class="highlight">Sbarro</span> LLC, et al.',
	  query: "filers",
	  type: "Creditor Committee"
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _HTMLResultRow = __webpack_require__(367);
	
	var _HTMLResultRow2 = _interopRequireDefault(_HTMLResultRow);
	
	var _EntriesResults = __webpack_require__(132);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Advanced Search/Result Rows', module).add('Case Summary', function () {
	  return _react2.default.createElement(
	    'div',
	    { className: 'result-item' },
	    _react2.default.createElement(_EntriesResults.RowHeader, { row: CaseSummaryRow }),
	    _react2.default.createElement(
	      'div',
	      { className: 'result-item-body' },
	      _react2.default.createElement(_HTMLResultRow2.default, { row: CaseSummaryRow })
	    )
	  );
	}).add('Notice', function () {
	  return _react2.default.createElement(
	    'div',
	    { className: 'result-item' },
	    _react2.default.createElement(_EntriesResults.RowHeader, { row: NoticeRow }),
	    _react2.default.createElement(
	      'div',
	      { className: 'result-item-body' },
	      _react2.default.createElement(_HTMLResultRow2.default, { row: NoticeRow })
	    )
	  );
	});
	
	var CaseSummaryRow = {
	  case: {},
	  case_chapter: 11,
	  case_court: "casbke",
	  case_date_filed: "01/08/2014",
	  case_judge_name: "Louise DeCarl Adler",
	  case_liabilities: "Unknown",
	  case_naics_code: null,
	  case_nature_of_suit_code: null,
	  case_no: "3:14-bk-00092",
	  case_title: "SoCal Eats LLC",
	  case_type: "bk",
	  case_uuid: "casbke_390125",
	  date_filed: "05/04/2015",
	  document_type: "case_summary",
	  text: '<h2 align=center>Case Summary</h2> <script type="text/javascript" src="/lib/widgits.js"></script> <script> var debtorPanel = null; function create_panel(clid, message) { if (!debtorPanel) { debtorPanel = new CMECF.widget.Panel(\'debtorPanel\', { close:true, draggable:false, context:[clid, \'tl\', \'br\'], width: "250" + "px", height: "110" + "px", constraintoviewport:true }); debtorPanel.setHeader("Barred Debtor Information"); debtorPanel.setBody(message); debtorPanel.body.style.height = "8em"; debtorPanel.render(document.body); } else { debtorPanel.show(); } } function close_panel() { if (debtorPanel) { debtorPanel.destroy(); debtorPanel = null; } } </script> <TABLE cellspacing=0 cellpadding=0> <TR> <TD colspan=1><B>Office: </B> San Diego </TD> <TD colspan=1 align=right><B> Filed: </B></TD> <TD colspan=1>01/08/2014</TD> </TR> <TR> <TD colspan=1><B>County: </B> SAN DIEGO-CA </TD> <TD colspan=1 align=right><B> Terminated: </B></TD> <TD colspan=1></TD> </TR> <TR> <TD colspan=1><B>Fee: </B> Paid </TD> <TD colspan=1 align=right><B> Debtor discharged: </B></TD> </TR> <TR> <TD colspan=1><B>Origin: </B> 0 </TD> <TD colspan=1 align=right><B> Reopened: </B></TD> <TD colspan=1></TD> </TR> <TR> <TD colspan=1><B>Previous term: </B> </TD> <TD colspan=1 align=right><B> Converted: </B></TD> <TD colspan=1></TD> </TR> <TR> <TD colspan=1></TD> <TD colspan=1 align=right><B> Debtor dismissed: </B></TD> </TR> <TR> <TD colspan=1><B>Joint:</B> n</TD> <TD colspan=1 align=right><B>Confirmation hearing: </B></TD> <TD colspan=1> </TD> </TR> <tr> <TD colspan=1><B>Original chapter: </B>11</TD> <TD colspan=2></td> </tr> <tr> <TD colspan=1><B>Current chapter: </B>11</TD> <TD colspan=2></td> </tr> <TR> <TD colspan=3> </TD> </TR> <TR> <TD colspan=3> </TD> </TR> <TR> <TD colspan=3><B> Nature of debt:</B> business </TD></TR> </TR><TR><TD colspan=4><B>Flags:</B> ConsLead</TD></TR><BR> <TR> <TD colspan=3> </TD> </TR> <TR> <TD colspan=3> </TD> </TR> <TR><TD colspan=3><B>Party 1:</B> <span class="highlight">SoCal</span> <span class="highlight">Eats</span> <span class="highlight">LLC</span> (Debtor) <br> Tax ID / EIN: 27-0587158 </TD></TR> <TR> <TD colspan=3> </TD> </TR> <TR><TD valign=top><B>Atty:</B> Alan Vanderhoff </TD><TD valign=top><B> Represents party 1: </B>Debtor </TD> <TD valign=top><TABLE border=0 cellspacing=0 cellpadding=0><TR><TD align=right><B>Phone: </B></TD><TD>(619) 299-2050</TR><TR><TD align=right><B>Fax: </B></TD><TD>(619)239-6554</TR><TR><TD align=right><B>Email: </B></TD><TD>alan.vanderhoff&#064;vanderhofflaw.com</TR></TABLE></TD></TR> <TR> <TD></TD> </TR> <TR><TD><B>Location of case files: </B></TD> <TR> <TD colspan=6> <B> Volume:</B> CS1 <BR> The case file may be available. <BR><BR> </TD> </TR> </TABLE><BR>'
	};
	
	var NoticeRow = {
	  case: {},
	  case_assets: "More than $1 billion",
	  case_chapter: 11,
	  case_court: "debke",
	  case_date_filed: "02/05/2015",
	  case_judge_name: "Brendan Linehan Shannon",
	  case_liabilities: "More than $1 billion",
	  case_naics_code: null,
	  case_nature_of_suit_code: null,
	  case_no: "1:15-bk-10197",
	  case_title: "RadioShack Corporation",
	  case_type: "bk",
	  case_uuid: "debke_157447",
	  date_filed: "02/06/2015",
	  document_type: "notice",
	  text: '<p align="center">United States Bankruptcy Court<br /> District of Delaware<br /></p> <table cellpadding="2"><tr><td> <h3 align="left">Notice of Bankruptcy Case Filing</h3><br /> A bankruptcy case concerning the debtor(s) listed below was filed under Chapter 11 of the United States Bankruptcy Code, entered on 02/05/2015 at 5:09 PM and filed on 02/05/2015. <script type="text/javascript" src="/lib/widgits.js"></script> <script> var debtorPanel = null; function create_panel(clid, message) { if (!debtorPanel) { debtorPanel = new CMECF.widget.Panel(\'debtorPanel\', { close:true, draggable:false, context:[clid, \'tl\', \'br\'], width: "250" + "px", height: "110" + "px", constraintoviewport:true }); debtorPanel.setHeader("Barred Debtor Information"); debtorPanel.setBody(message); debtorPanel.body.style.height = "8em"; debtorPanel.render(document.body); } else { debtorPanel.show(); } } function close_panel() { if (debtorPanel) { debtorPanel.destroy(); debtorPanel = null; } } </script> <p id="3"> <B><span class="highlight">RadioShack</span> Corporation</B> <BR>300 <span class="highlight">RadioShack</span> Circle <BR>Fort Worth, TX 76102 <br>Tax ID / EIN: 75-1047710 </p> </TD><TD valign=top> <IMG align=right SRC=\'/cgi-bin/SealFly.pl?02/05/2015&5:09+PM\'> </td></tr></table> <table cellpadding=10><tr><td>The case was filed by the debtor\'s attorney:</td></tr><tr><td valign="top"> <p class="3"><B>David M. Fournier</B> <BR>Pepper Hamilton LLP <BR>Hercules Plaza, Suite 5100 <BR>1313 Market Street <BR>Wilmington, DE 19899-1709<BR>usa <BR>302 777-6500</p> </td></tr></table>The case was assigned case number 15-10197-KJC to Judge Kevin J. Carey. <p> In most instances, the filing of the bankruptcy case automatically stays certain collection and other actions against the debtor and the debtor\'s property. Under certain circumstances, the stay may be limited to 30 days or not exist at all, although the debtor can request the court to extend or impose a stay. If you attempt to collect a debt or take other action in violation of the Bankruptcy Code, you may be penalized. Consult a lawyer to determine your rights in this case. </p> <p>If you would like to view the bankruptcy petition and other documents filed by the debtor, they are available at our <i>Internet</i> home page www.deb.uscourts.gov or at the Clerk\'s Office, 824 Market Street, 3rd Floor, Wilmington, DE 19801. </p> <p>You may be a creditor of the debtor. If so, you will receive an additional notice from the court setting forth important deadlines. </p> <br> <TABLE CELLPADDING=2> <TR> <TD width=65%></TD> <TD><H3>David D. Bird<BR>Clerk, U.S. Bankruptcy Court</H3></TD> </TR> </TABLE>'
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(13);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _LoadingBar = __webpack_require__(92);
	
	var _LoadingBar2 = _interopRequireDefault(_LoadingBar);
	
	var _AlertError = __webpack_require__(50);
	
	var _AlertError2 = _interopRequireDefault(_AlertError);
	
	var _UpdateFromPacer = __webpack_require__(70);
	
	var _UpdateFromPacer2 = _interopRequireDefault(_UpdateFromPacer);
	
	var _FilterTable = __webpack_require__(80);
	
	var _FilterTable2 = _interopRequireDefault(_FilterTable);
	
	var _irSearchActions = __webpack_require__(71);
	
	var irSearchActions = _interopRequireWildcard(_irSearchActions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CASE_TYPE = 'alias';
	
	var PartiesWithAlias = function (_Component) {
	  _inherits(PartiesWithAlias, _Component);
	
	  function PartiesWithAlias() {
	    _classCallCheck(this, PartiesWithAlias);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  PartiesWithAlias.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.purchase_right_away) this.purchaseAlias();else this.getAlias();
	  };
	
	  PartiesWithAlias.prototype.getAlias = function getAlias() {
	    this.props.dispatch(irSearchActions.getCaseData({
	      type: CASE_TYPE,
	      case_uuid: this.props.case_uuid
	    }));
	  };
	
	  PartiesWithAlias.prototype.purchaseAlias = function purchaseAlias() {
	    this.props.dispatch(irSearchActions.purchaseCaseData({
	      type: CASE_TYPE,
	      case_uuid: this.props.case_uuid
	    }));
	  };
	
	  PartiesWithAlias.prototype.render = function render() {
	    if (!this.props.dataReady) return _react2.default.createElement(_LoadingBar2.default, null);
	
	    var errorMessage = this.props.error ? _react2.default.createElement(_AlertError2.default, { errors: this.props.error }) : null;
	
	    var aliases = this.props.alias;
	    var receipt = this.props.receipt;
	
	    var isEmpty = _lodash2.default.get(aliases, '[0][0]') == 'empty' || _lodash2.default.get(aliases, 'empty');
	
	    var Aliases = isEmpty ? [] : aliases.map(function (alias, index) {
	      var partyAlias = alias.party_alias;
	
	      var party = alias.party;
	      var PartyAliasNameComponents = partyAlias.map(function (alias, index) {
	        return _react2.default.createElement(
	          'div',
	          { key: index, className: 'ir-search-card' },
	          _react2.default.createElement(
	            'b',
	            null,
	            alias.name
	          )
	        );
	      });
	
	      var PartyAliasRoleAliases = partyAlias.map(function (alias, index) {
	        return _react2.default.createElement(
	          'div',
	          { key: index, className: 'ir-search-card' },
	          party.role
	        );
	      });
	
	      return _react2.default.createElement(
	        'tr',
	        { key: index, className: index % 2 == 0 ? 'even' : 'odd' },
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'ir-search-card' },
	            _react2.default.createElement(
	              'b',
	              null,
	              party.name
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'span',
	              null,
	              party.address
	            ),
	            _react2.default.createElement('br', null),
	            party.ssn ? _react2.default.createElement(
	              'span',
	              null,
	              'SSN / ITIN: ',
	              party.ssn,
	              _react2.default.createElement('br', null)
	            ) : null,
	            _react2.default.createElement(
	              'i',
	              null,
	              '(',
	              party.role,
	              ')'
	            ),
	            _react2.default.createElement('br', null)
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          PartyAliasRoleAliases
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          PartyAliasNameComponents
	        )
	      );
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'ir-search-query alias' },
	      errorMessage,
	      _react2.default.createElement(
	        _FilterTable2.default,
	        null,
	        !!Aliases.length ? _react2.default.createElement(
	          'table',
	          { className: 'sticky-enabled tablesorter' },
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Party'
	                )
	              ),
	              _react2.default.createElement('th', null),
	              _react2.default.createElement(
	                'th',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Alias'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            Aliases
	          )
	        ) : _react2.default.createElement(
	          'div',
	          {
	            className: 'ir-search-status-message messages warning'
	          },
	          'There Are No Parties with Alias For This Case'
	        )
	      ),
	      _react2.default.createElement(_UpdateFromPacer2.default, {
	        pacerUpdateHandler: this.purchaseAlias.bind(this),
	        pacerReceipt: receipt,
	        lastUpdated: this.props.lastUpdated })
	    );
	  };
	
	  return PartiesWithAlias;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  var irSearch = state.get('irSearch').toJS();
	
	  return {
	    dataReady: irSearch.data_ready,
	    alias: irSearch.data,
	    receipt: irSearch.receipt,
	    lastUpdated: irSearch.lastUpdated,
	    error: irSearch.error
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PartiesWithAlias);

/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.AssociatedCases = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _irSearchActions = __webpack_require__(71);
	
	var irSearchActions = _interopRequireWildcard(_irSearchActions);
	
	var _LoadingBar = __webpack_require__(92);
	
	var _LoadingBar2 = _interopRequireDefault(_LoadingBar);
	
	var _UpdateFromPacer = __webpack_require__(70);
	
	var _UpdateFromPacer2 = _interopRequireDefault(_UpdateFromPacer);
	
	var _AllCasesView = __webpack_require__(368);
	
	var _AllCasesView2 = _interopRequireDefault(_AllCasesView);
	
	var _PopupError = __webpack_require__(176);
	
	var _PopupError2 = _interopRequireDefault(_PopupError);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AssociatedCases = exports.AssociatedCases = function (_Component) {
	  _inherits(AssociatedCases, _Component);
	
	  function AssociatedCases() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AssociatedCases);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getData = function () {
	      var _this$props = _this.props,
	          dispatch = _this$props.dispatch,
	          case_uuid = _this$props.case_uuid;
	
	      dispatch(irSearchActions.getCaseData({
	        type: 'associated_cases',
	        case_uuid: case_uuid
	      }));
	    }, _this.purchaseData = function () {
	      var _this$props2 = _this.props,
	          dispatch = _this$props2.dispatch,
	          case_uuid = _this$props2.case_uuid;
	
	
	      dispatch(irSearchActions.purchaseCaseData({
	        type: 'associated_cases',
	        case_uuid: case_uuid
	      }));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  AssociatedCases.prototype.componentDidMount = function componentDidMount() {
	    var purchase_right_away = this.props.purchase_right_away;
	
	    if (purchase_right_away) {
	      this.purchaseData();
	    } else {
	      this.getData();
	    }
	  };
	
	  AssociatedCases.prototype.render = function render() {
	    var _props = this.props,
	        dataReady = _props.dataReady,
	        error = _props.error,
	        case_uuid = _props.case_uuid,
	        receipt = _props.receipt,
	        lastUpdated = _props.lastUpdated,
	        cases = _props.cases;
	
	    if (!dataReady) return _react2.default.createElement(_LoadingBar2.default, null);
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'associated-cases' },
	      _react2.default.createElement(_PopupError2.default, { errors: error }),
	      _react2.default.createElement(_AllCasesView2.default, { cases: cases, case_uuid: case_uuid }),
	      _react2.default.createElement(_UpdateFromPacer2.default, {
	        pacerUpdateHandler: this.purchaseData,
	        pacerReceipt: receipt,
	        lastUpdated: lastUpdated })
	    );
	  };
	
	  return AssociatedCases;
	}(_react.Component);
	
	AssociatedCases.defaultProps = {
	  purchase_right_away: false,
	  error: null
	};
	
	AssociatedCases.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  case_uuid: _propTypes2.default.any.isRequired,
	  purchase_right_away: _propTypes2.default.bool,
	  dataReady: _propTypes2.default.bool.isRequired,
	  cases: _propTypes2.default.any.isRequired,
	  receipt: _propTypes2.default.objectOf(_propTypes2.default.any).isRequired,
	  lastUpdated: _propTypes2.default.any.isRequired,
	  error: _propTypes2.default.any
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var irSearch = state.get('irSearch').toJS();
	  return {
	    dataReady: irSearch.data_ready,
	    cases: irSearch.data,
	    receipt: irSearch.receipt,
	    lastUpdated: irSearch.lastUpdated,
	    error: irSearch.error
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AssociatedCases);

/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CaseAttorneys = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(13);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _he = __webpack_require__(1775);
	
	var _he2 = _interopRequireDefault(_he);
	
	var _irSearchActions = __webpack_require__(71);
	
	var irSearchActions = _interopRequireWildcard(_irSearchActions);
	
	var _LoadingBar = __webpack_require__(92);
	
	var _LoadingBar2 = _interopRequireDefault(_LoadingBar);
	
	var _FilterTable = __webpack_require__(80);
	
	var _FilterTable2 = _interopRequireDefault(_FilterTable);
	
	var _UpdateFromPacer = __webpack_require__(70);
	
	var _UpdateFromPacer2 = _interopRequireDefault(_UpdateFromPacer);
	
	var _PopupError = __webpack_require__(176);
	
	var _PopupError2 = _interopRequireDefault(_PopupError);
	
	__webpack_require__(2167);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CaseAttorneys = exports.CaseAttorneys = function (_Component) {
	  _inherits(CaseAttorneys, _Component);
	
	  function CaseAttorneys() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CaseAttorneys);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getAttorneyData = function () {
	      _this.props.dispatch(irSearchActions.getCaseData({
	        type: 'attorneys',
	        case_uuid: _this.props.case_uuid
	      }));
	    }, _this.purchaseAttorneyData = function () {
	      _this.props.dispatch(irSearchActions.purchaseCaseData({
	        type: 'attorneys',
	        case_uuid: _this.props.case_uuid,
	        purchase_right_away: _this.props.purchase_right_away
	      }));
	    }, _this.getAttorneysTableBody = function (attorneys) {
	      if (_lodash2.default.get(attorneys, '[0][0]') == 'empty') return [];
	
	      return attorneys.map(function (item, key) {
	        if (Object.keys(item).length) {
	          return _react2.default.createElement(
	            'tr',
	            { key: key },
	            _react2.default.createElement(
	              'td',
	              null,
	              _this.getAttorneyInfo(item.attorney)
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              'representing'
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _this.getAttorneyParty(item.associated)
	            )
	          );
	        }
	      });
	    }, _this.getAttorneyParty = function (associated) {
	      return associated.map(function (el, key) {
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          _react2.default.createElement(
	            'strong',
	            null,
	            ' ',
	            _he2.default.decode(el.name || ''),
	            ' '
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            ' ',
	            _this.getFormattedAddress(el.address),
	            ' '
	          ),
	          el.role ? _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'i',
	              null,
	              '(',
	              el.role,
	              ')'
	            )
	          ) : '',
	          el.phone ? _react2.default.createElement(
	            'p',
	            null,
	            ' t: ',
	            el.phone,
	            ' '
	          ) : '',
	          el.fax ? _react2.default.createElement(
	            'p',
	            null,
	            ' f: ',
	            el.fax,
	            ' '
	          ) : '',
	          el.email ? _react2.default.createElement(
	            'p',
	            null,
	            el.email
	          ) : ''
	        );
	      });
	    }, _this.getAttorneyInfo = function (attorney) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ir-search-card' },
	        _react2.default.createElement(
	          'strong',
	          null,
	          ' ',
	          attorney.profile_link ? _react2.default.createElement(
	            'a',
	            { href: attorney.profile_link },
	            ' ',
	            _he2.default.decode(attorney.name || ''),
	            ' '
	          ) : _he2.default.decode(attorney.name || '')
	        ),
	        _react2.default.createElement('br', null),
	        _this.getFormattedAddress(attorney.address),
	        attorney.phone ? _react2.default.createElement(
	          'div',
	          null,
	          ' t: ',
	          attorney.phone,
	          ' '
	        ) : '',
	        attorney.fax ? _react2.default.createElement(
	          'div',
	          null,
	          ' f: ',
	          attorney.fax,
	          ' '
	        ) : '',
	        attorney.email ? _react2.default.createElement(
	          'div',
	          null,
	          ' ',
	          attorney.email,
	          ' '
	        ) : '',
	        attorney.lead ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'i',
	            null,
	            ' (',
	            attorney.lead,
	            ') '
	          )
	        ) : '',
	        attorney.assigned_date ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'i',
	            null,
	            ' Assigned: (',
	            attorney.assigned_date,
	            ') '
	          )
	        ) : '',
	        attorney.terminated_date ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'i',
	            null,
	            ' Terminated: (',
	            attorney.terminated_date,
	            ') '
	          )
	        ) : ''
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CaseAttorneys.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.purchase_right_away) this.purchaseAttorneyData();else this.getAttorneyData();
	  };
	
	  CaseAttorneys.prototype.render = function render() {
	    if (!this.props.dataReady) return _react2.default.createElement(_LoadingBar2.default, null);
	
	    var Attorneys = !this.props.attorneys.empty ? this.getAttorneysTableBody(this.props.attorneys) : [];
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'case-attorneys' },
	      _react2.default.createElement(_PopupError2.default, { errors: this.props.error }),
	      _react2.default.createElement(
	        'a',
	        { href: '/attorneys/export-xlsx/' + this.props.case_uuid, className: 'form-submit',
	          style: { float: "right", marginLeft: '4px' } },
	        _react2.default.createElement('i', { className: 'fa  fa-file-excel-o' }),
	        ' Download Excel'
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '/attorneys/export-csv/' + this.props.case_uuid, className: 'form-submit', style: { float: "right" } },
	        _react2.default.createElement('i', { className: 'fa fa-table' }),
	        ' Download CSV'
	      ),
	      _react2.default.createElement(
	        _FilterTable2.default,
	        null,
	        !!Attorneys.length ? _react2.default.createElement(
	          'table',
	          { className: 'sticky-enabled tablesorter' },
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Attorney'
	                )
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Type'
	                )
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Party'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            Attorneys
	          )
	        ) : _react2.default.createElement(
	          'div',
	          {
	            className: 'ir-search-status-message messages warning'
	          },
	          'There Are No Attorneys For This Case'
	        )
	      ),
	      _react2.default.createElement(_UpdateFromPacer2.default, {
	        pacerUpdateHandler: this.purchaseAttorneyData.bind(null, this.props.case_uuid, 'attorneys', true),
	        pacerReceipt: this.props.receipt,
	        lastUpdated: this.props.lastUpdated })
	    );
	  };
	
	  CaseAttorneys.prototype.getFormattedAddress = function getFormattedAddress(address) {
	    if (address) {
	      var splitAddress = address.split(/\r?\n/);
	      return splitAddress.map(function (el, idx) {
	        if (idx < splitAddress.length) return [el, _react2.default.createElement('br', null)];
	      });
	    }
	  };
	
	  return CaseAttorneys;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  var irSearch = state.get('irSearch').toJS();
	
	  return {
	    dataReady: irSearch.data_ready,
	    attorneys: irSearch.data,
	    receipt: irSearch.receipt,
	    lastUpdated: irSearch.lastUpdated,
	    error: irSearch.error
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CaseAttorneys);

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	__webpack_require__(2168);
	
	var _clientCodeDialogView = __webpack_require__(651);
	
	var _clientCodeDialogView2 = _interopRequireDefault(_clientCodeDialogView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClientCodeDialogContainer = function (_Component) {
	  _inherits(ClientCodeDialogContainer, _Component);
	
	  function ClientCodeDialogContainer(props) {
	    _classCallCheck(this, ClientCodeDialogContainer);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.onClose = function () {
	      _this.setState({ dialog_opened: false });
	      // unmount component to go over hot reload error about state change.
	      _reactDom2.default.unmountComponentAtNode(document.getElementById('tab-menu-clientcode-dialog'));
	    };
	
	    _this.state = {
	      popupErrors: {
	        messages: ['Please set a valid client code first.']
	      },
	      dialog_opened: true
	    };
	    _this.onClose = _this.onClose.bind(_this);
	    return _this;
	  }
	
	  ClientCodeDialogContainer.prototype.render = function render() {
	    var _this2 = this;
	
	    var popupErrors = this.props.popupErrors || this.state.popupErrors;
	    return _react2.default.createElement(_clientCodeDialogView2.default, _extends({}, this.props, {
	      popupErrors: popupErrors,
	      dialog_opened: this.state.dialog_opened,
	      onClose: function onClose() {
	        return _this2.onClose();
	      }
	    }));
	  };
	
	  return ClientCodeDialogContainer;
	}(_react.Component);
	
	ClientCodeDialogContainer.defaultProps = {
	  errors: null,
	  popupErrors: null
	};
	
	ClientCodeDialogContainer.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  errors: _propTypes2.default.any,
	  popupErrors: _propTypes2.default.any
	};
	
	function mapStateToProps(state) {
	  return {
	    popupErrors: state.get('validationErrors') ? state.get('validationErrors').toJS() : null
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ClientCodeDialogContainer);

/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CreditorMailingContainer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _creditorMailingActions = __webpack_require__(1221);
	
	var irActions = _interopRequireWildcard(_creditorMailingActions);
	
	var _CreditorMailing = __webpack_require__(379);
	
	var _CreditorMailing2 = _interopRequireDefault(_CreditorMailing);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var type = 'creditor_mailing';
	
	var CreditorMailingContainer = exports.CreditorMailingContainer = function (_Component) {
	  _inherits(CreditorMailingContainer, _Component);
	
	  function CreditorMailingContainer() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CreditorMailingContainer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getData = function () {
	      _this.props.dispatch(irActions.getCreditorMailingData({
	        type: type,
	        case_uuid: _this.props.case_uuid
	      }));
	    }, _this.purchaseData = function (format) {
	      _this.props.dispatch(irActions.purchaseCreditorMailingData({
	        type: _this.props.type,
	        queryType: type,
	        case_uuid: _this.props.case_uuid,
	        format: format
	      }));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CreditorMailingContainer.prototype.componentDidMount = function componentDidMount() {
	    this.getData();
	  };
	
	  CreditorMailingContainer.prototype.render = function render() {
	    return _react2.default.createElement(_CreditorMailing2.default, _extends({}, this.props, {
	      type: this.props.type,
	      purchaseData: this.purchaseData
	    }));
	  };
	
	  return CreditorMailingContainer;
	}(_react.Component);
	
	CreditorMailingContainer.defaultProps = {
	  purchase_right_away: false,
	  type: 'creditor_mailing',
	  error: null,
	  receipt: null
	};
	
	CreditorMailingContainer.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  case_uuid: _propTypes2.default.any.isRequired,
	  purchase_right_away: _propTypes2.default.bool,
	  type: _propTypes2.default.string,
	  dataReady: _propTypes2.default.bool.isRequired,
	  creditor_mailing: _propTypes2.default.any.isRequired,
	  receipt: _propTypes2.default.any,
	  error: _propTypes2.default.any
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var creditorMailing = state.get('creditorMailing').toJS();
	  return {
	    dataReady: creditorMailing.data_ready,
	    creditor_mailing: creditorMailing.data,
	    receipt: creditorMailing.receipt,
	    lastUpdated: creditorMailing.lastUpdated,
	    error: creditorMailing.error
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CreditorMailingContainer);

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CaseCreditors = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(13);
	
	var _irSearchActions = __webpack_require__(71);
	
	var irSearchActions = _interopRequireWildcard(_irSearchActions);
	
	var _LoadingBar = __webpack_require__(92);
	
	var _LoadingBar2 = _interopRequireDefault(_LoadingBar);
	
	var _PopupError = __webpack_require__(176);
	
	var _PopupError2 = _interopRequireDefault(_PopupError);
	
	var _UpdateFromPacer = __webpack_require__(70);
	
	var _UpdateFromPacer2 = _interopRequireDefault(_UpdateFromPacer);
	
	var _FilterTable = __webpack_require__(80);
	
	var _FilterTable2 = _interopRequireDefault(_FilterTable);
	
	var _globalUtils = __webpack_require__(59);
	
	__webpack_require__(2170);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CaseCreditors = exports.CaseCreditors = function (_Component) {
	  _inherits(CaseCreditors, _Component);
	
	  function CaseCreditors() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CaseCreditors);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getCreditors = function () {
	      _this.props.dispatch(irSearchActions.getCaseData({
	        type: 'creditors',
	        case_uuid: _this.props.case_uuid
	      }));
	    }, _this.purchaseCreditors = function () {
	      _this.props.dispatch(irSearchActions.purchaseCaseData({
	        type: 'creditors',
	        case_uuid: _this.props.case_uuid,
	        purchase_right_away: _this.props.purchase_right_away
	      }));
	    }, _this.NoFound = _react2.default.createElement(
	      'span',
	      { style: {
	          marginTop: '24px',
	          display: 'table',
	          fontWeight: '700'
	        } },
	      'No creditor found for this case.'
	    ), _this.getCreditorsTableBody = function (creditors) {
	      return creditors.map(function (creditor, key) {
	        return _react2.default.createElement(
	          'tr',
	          { key: key },
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'ir-search-card' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                creditor.name
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'span',
	                { style: { whiteSpace: 'pre-wrap' } },
	                creditor.address
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            creditor.creditor_code
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            '(' + creditor.creditor_role + ')'
	          )
	        );
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CaseCreditors.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.purchase_right_away) {
	      this.purchaseCreditors();
	    } else {
	      this.getCreditors();
	    }
	  };
	
	  CaseCreditors.prototype.render = function render() {
	    if (!this.props.dataReady) return _react2.default.createElement(_LoadingBar2.default, null);
	
	    var creditors = this.props.creditors;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'case-creditors' },
	      _react2.default.createElement(_PopupError2.default, { errors: this.props.error }),
	      (0, _globalUtils.drupalPermsInclude)('93 - Business Bankruptcies searches - Creditors CSV attachment') && _react2.default.createElement(
	        'a',
	        {
	          href: '/creditors/export-xlsx/' + this.props.case_uuid,
	          className: 'form-submit',
	          style: { float: 'right', marginLeft: '4px' }
	        },
	        _react2.default.createElement('i', { className: 'fa  fa-file-excel-o' }),
	        ' Download Excel'
	      ),
	      _react2.default.createElement(
	        _FilterTable2.default,
	        null,
	        !!creditors.length && _lodash2.default.get(creditors, '[0][0]') !== 'empty' ? _react2.default.createElement(
	          'table',
	          { className: 'sticky-enabled tablesorter' },
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Creditor'
	                )
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Code'
	                )
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Type'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            this.getCreditorsTableBody(creditors)
	          )
	        ) : _react2.default.createElement(
	          'div',
	          {
	            className: 'ir-search-status-message messages warning'
	          },
	          'No creditor found for this case.'
	        )
	      ),
	      _react2.default.createElement(_UpdateFromPacer2.default, {
	        pacerUpdateHandler: this.purchaseCreditors.bind(null, this.props.case_uuid, 'creditors', true),
	        pacerReceipt: this.props.receipt,
	        lastUpdated: this.props.lastUpdated })
	    );
	  };
	
	  return CaseCreditors;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  var irSearch = state.get('irSearch').toJS();
	  return {
	    dataReady: irSearch.data_ready,
	    creditors: irSearch.data,
	    receipt: irSearch.receipt,
	    lastUpdated: irSearch.lastUpdated,
	    error: irSearch.error
	  };
	}
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CaseCreditors);

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.DeadlineCasesContainer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _irSearchActions = __webpack_require__(71);
	
	var irActions = _interopRequireWildcard(_irSearchActions);
	
	var _DeadlineCases = __webpack_require__(253);
	
	var _DeadlineCases2 = _interopRequireDefault(_DeadlineCases);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var type = 'schedule';
	var noDataFoundMessage = 'There are no Deadline/Hearing events for this case.';
	
	var DeadlineCasesContainer = exports.DeadlineCasesContainer = function (_Component) {
	  _inherits(DeadlineCasesContainer, _Component);
	
	  function DeadlineCasesContainer() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DeadlineCasesContainer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getData = function () {
	      _this.props.dispatch(irActions.getCaseData({
	        type: type,
	        case_uuid: _this.props.case_uuid
	      }));
	    }, _this.purchaseData = function () {
	      _this.props.dispatch(irActions.purchaseCaseData({
	        type: type,
	        case_uuid: _this.props.case_uuid
	      }));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  DeadlineCasesContainer.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.purchase_right_away) {
	      this.purchaseData();
	    } else {
	      this.getData();
	    }
	  };
	
	  DeadlineCasesContainer.prototype.render = function render() {
	    return _react2.default.createElement(_DeadlineCases2.default, _extends({}, this.props, {
	      type: type,
	      purchaseData: this.purchaseData,
	      noDataFoundMessage: noDataFoundMessage
	    }));
	  };
	
	  return DeadlineCasesContainer;
	}(_react.Component);
	
	DeadlineCasesContainer.defaultProps = {
	  purchase_right_away: false,
	  error: null,
	  receipt: null
	};
	
	DeadlineCasesContainer.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  case_uuid: _propTypes2.default.any.isRequired,
	  purchase_right_away: _propTypes2.default.bool,
	  dataReady: _propTypes2.default.bool.isRequired,
	  deadlines: _propTypes2.default.any.isRequired,
	  receipt: _propTypes2.default.any,
	  lastUpdated: _propTypes2.default.any.isRequired,
	  error: _propTypes2.default.any
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var irSearch = state.get('irSearch').toJS();
	  return {
	    dataReady: irSearch.data_ready,
	    deadlines: irSearch.data,
	    receipt: irSearch.receipt,
	    lastUpdated: irSearch.lastUpdated,
	    error: irSearch.error
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DeadlineCasesContainer);

/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _DeadlineCases = __webpack_require__(253);
	
	var _DeadlineCases2 = _interopRequireDefault(_DeadlineCases);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DeadlineCases2.default;

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FilersCasesContainer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _irSearchActions = __webpack_require__(71);
	
	var irActions = _interopRequireWildcard(_irSearchActions);
	
	var _FilersCases = __webpack_require__(262);
	
	var _FilersCases2 = _interopRequireDefault(_FilersCases);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var type = 'filers';
	var noDataFoundMessage = 'No parties have filed anything for this case';
	
	var FilersCasesContainer = exports.FilersCasesContainer = function (_Component) {
	  _inherits(FilersCasesContainer, _Component);
	
	  function FilersCasesContainer(props) {
	    _classCallCheck(this, FilersCasesContainer);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.getData = function () {
	      _this.props.dispatch(irActions.getCaseData({
	        type: type,
	        case_uuid: _this.props.case_uuid
	      }));
	    };
	
	    _this.purchaseData = function () {
	      _this.props.dispatch(irActions.purchaseCaseData({
	        type: type,
	        case_uuid: _this.props.case_uuid
	      }));
	    };
	
	    _this.changeFilter = function (e, name) {
	      var _this$setState;
	
	      _this.setState((_this$setState = {}, _this$setState[name] = e.target.value, _this$setState));
	    };
	
	    _this.onClear = function () {
	      var state = {
	        keyword: ''
	      };
	
	      _this.setState({ keyword: '' });
	    };
	
	    _this.state = {
	      keyword: ''
	    };
	    return _this;
	  }
	
	  FilersCasesContainer.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.purchase_right_away) {
	      this.purchaseData();
	    } else {
	      this.getData();
	    }
	  };
	
	  FilersCasesContainer.prototype.render = function render() {
	    var filersProps = {
	      keyword: this.state.keyword,
	      onChange: this.changeFilter,
	      onClear: this.onClear
	    };
	    return _react2.default.createElement(_FilersCases2.default, _extends({}, this.props, {
	      type: type,
	      filersProps: filersProps,
	      keyword: this.state.keyword,
	      purchaseData: this.purchaseData,
	      noDataFoundMessage: noDataFoundMessage
	    }));
	  };
	
	  return FilersCasesContainer;
	}(_react.Component);
	
	FilersCasesContainer.defaultProps = {
	  purchase_right_away: false,
	  error: null,
	  receipt: null
	};
	
	FilersCasesContainer.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  case_uuid: _propTypes2.default.any.isRequired,
	  purchase_right_away: _propTypes2.default.bool,
	  dataReady: _propTypes2.default.bool.isRequired,
	  filers: _propTypes2.default.any.isRequired,
	  receipt: _propTypes2.default.any,
	  lastUpdated: _propTypes2.default.any.isRequired,
	  error: _propTypes2.default.any
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var irSearch = state.get('irSearch').toJS();
	  return {
	    dataReady: irSearch.data_ready,
	    filers: irSearch.data,
	    receipt: irSearch.receipt,
	    lastUpdated: irSearch.lastUpdated,
	    error: irSearch.error
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FilersCasesContainer);

/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _FilersCases = __webpack_require__(262);
	
	var _FilersCases2 = _interopRequireDefault(_FilersCases);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FilersCases2.default;

/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HistoryContainer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(32);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(13);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _docketActions = __webpack_require__(42);
	
	var docketActions = _interopRequireWildcard(_docketActions);
	
	var _historyActions = __webpack_require__(1222);
	
	var historyActions = _interopRequireWildcard(_historyActions);
	
	var _AllPartsPrintPreview = __webpack_require__(133);
	
	var _AllPartsPrintPreview2 = _interopRequireDefault(_AllPartsPrintPreview);
	
	var _EmailCombinedPdfPopup = __webpack_require__(173);
	
	var _EmailCombinedPdfPopup2 = _interopRequireDefault(_EmailCombinedPdfPopup);
	
	var _DownloadZipAllPdfsRangePopup = __webpack_require__(134);
	
	var _DownloadZipAllPdfsRangePopup2 = _interopRequireDefault(_DownloadZipAllPdfsRangePopup);
	
	var _DownloadCombineAllPdfInRangePopup = __webpack_require__(171);
	
	var _DownloadCombineAllPdfInRangePopup2 = _interopRequireDefault(_DownloadCombineAllPdfInRangePopup);
	
	var _DownloadZipWithSubpartsPopup = __webpack_require__(135);
	
	var _DownloadZipWithSubpartsPopup2 = _interopRequireDefault(_DownloadZipWithSubpartsPopup);
	
	var _PrintAllPdfInRangePopup = __webpack_require__(175);
	
	var _PrintAllPdfInRangePopup2 = _interopRequireDefault(_PrintAllPdfInRangePopup);
	
	var _EmailPartPopup = __webpack_require__(174);
	
	var _EmailPartPopup2 = _interopRequireDefault(_EmailPartPopup);
	
	var _EmailPartModal = __webpack_require__(136);
	
	var _EmailPartModal2 = _interopRequireDefault(_EmailPartModal);
	
	var _EmailAllPartsZipPopup = __webpack_require__(172);
	
	var _EmailAllPartsZipPopup2 = _interopRequireDefault(_EmailAllPartsZipPopup);
	
	var _History = __webpack_require__(394);
	
	var _History2 = _interopRequireDefault(_History);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var section_type = 'history';
	var parser_type = 'history_parser';
	var noDataFoundMessage = 'No Transactions found.';
	var loggedUser = window.Drupal.settings.currentUser;
	var initState = {
	  docNumFrom: null,
	  docNumTo: null,
	  startDate: null,
	  endDate: null,
	  pacerSearch: {
	    startDate: null,
	    endDate: null,
	    doc_from: null,
	    doc_to: null
	  },
	  doc_range: '',
	  doc_range_error: '',
	  keyword: '',
	  sort_field: 'date_filed',
	  sort_direction: 'desc',
	  ir_search_page_size: window.Drupal.settings.ir_search_page_size || 50
	};
	
	var HistoryContainer = exports.HistoryContainer = function (_Component) {
	  _inherits(HistoryContainer, _Component);
	
	  function HistoryContainer(props) {
	    _classCallCheck(this, HistoryContainer);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.onPopupClick = function (params) {
	      _this.props.dispatch(docketActions.togglePopup(params));
	    };
	
	    _this.onClear = function (e) {
	      _this.setState(initState, function () {
	        _this.buyFilteredDockets(e);
	      });
	    };
	
	    _this.setDocketRowVisible = function (key) {
	      return _this.setState({ visibleDocketRow: key });
	    };
	
	    _this.getData = function () {
	      var page_num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var sort_direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.sort_direction;
	      var sort_field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.state.sort_field;
	
	      _this.props.dispatch(historyActions.getParserSearchData({
	        type: parser_type,
	        case_uuid: _this.props.case_uuid,
	        date_from: '_',
	        date_to: '_',
	        doc_from: '_',
	        doc_to: '_',
	        keyword: '_',
	        sort_field: sort_field,
	        sort_direction: sort_direction,
	        page_num: page_num
	      }, null));
	    };
	
	    _this.getParserData = function (values) {
	      var date_from = values.date_from ? values.date_from.format('YYYY-MM-DD') : '_';
	      var date_to = values.date_to ? values.date_to.format('YYYY-MM-DD') : '_';
	      var doc_from = values.doc_from ? values.doc_from : '_';
	      var doc_to = values.doc_to ? values.doc_to : '_';
	
	      _this.props.dispatch(historyActions.getParserSearchData({
	        type: parser_type,
	        case_uuid: _this.props.case_uuid,
	        date_from: date_from,
	        date_to: date_to,
	        doc_from: doc_from,
	        doc_to: doc_to
	      }, null));
	    };
	
	    _this.getPacerData = function (values) {
	      var keyword = values.keyword ? values.keyword : '';
	      var date_from = values.date_from ? values.date_from.format('YYYY-MM-DD') : '';
	      var date_to = values.date_to ? values.date_to.format('YYYY-MM-DD') : '';
	      var doc_from = values.doc_from ? values.doc_from : '';
	      var doc_to = values.doc_to ? values.doc_to : '';
	      var show_pending = values.pending ? values.pending : false;
	      var show_terminated = values.terminated ? 1 : false;
	      var doc_type = values.doc_type ? values.doc_type : '';
	      _this.props.dispatch(historyActions.getPacerRelatedData({
	        type: section_type,
	        case_uuid: _this.props.case_uuid,
	        keyword: keyword,
	        date_from: date_from,
	        date_to: date_to,
	        doc_from: doc_from,
	        doc_to: doc_to,
	        show_pending: show_pending,
	        show_terminated: show_terminated,
	        doc_type: doc_type
	      }));
	      _this.getData();
	    };
	
	    _this.getDocketDetails = function (docket) {
	      _this.setState({ selectedDocketDetailNum: docket.docket_seq }, function () {
	        var params = {
	          case_number: _this.props.case_number,
	          court_code: _this.props.court_code,
	          docket_no: docket.docket_no,
	          docket_seq: docket.docket_seq
	        };
	        _this.props.dispatch(docketActions.getDocuments(params));
	      });
	    };
	
	    _this.purchaseData = function (values) {
	      var history_type = values.history_type ? values.history_type : '';
	      var show_docket = values.show_docket ? '1' : '0';
	      _this.props.dispatch(historyActions.purchaseHistoryCaseData({
	        type: section_type,
	        case_uuid: _this.props.case_uuid,
	        history_type: history_type,
	        show_docket: show_docket
	      }));
	    };
	
	    _this.changePage = function (itemParams) {
	      _this.setState({ selectedPageNum: itemParams.page_index });
	      _this.getData(itemParams.page_index);
	    };
	
	    _this.getFilteredHistory = function () {
	      var page_num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var sort_direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.sort_direction;
	      var sort_field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.state.sort_field;
	
	
	      var params = {
	        type: parser_type,
	        case_uuid: _this.props.case_uuid,
	        date_from: '_',
	        date_to: '_',
	        doc_from: '_',
	        doc_to: '_',
	        keyword: '_',
	        sort_field: sort_field,
	        sort_direction: sort_direction,
	        page_num: page_num
	      };
	      return _this.props.dispatch(historyActions.getHistoryItems(params, null));
	    };
	
	    _this.reloadDetails = function (seqNum) {
	      _this.getFilteredHistory().then(function () {
	        return _this.getDocketDetails(seqNum);
	      });
	    };
	
	    _this.sortHistory = function (sort_field) {
	      var sort_direction = _this.state.sort_direction === 'asc' ? 'desc' : 'asc';
	
	      _this.setState({ sort_field: sort_field, sort_direction: sort_direction });
	      _this.getData(0, sort_direction, sort_field);
	    };
	
	    _this.changeFilter = function (e, name) {
	      if (name === 'doc_range' && (!name.includes(',') || !name.includes('-'))) {
	        var _this$setState;
	
	        _this.setState((_this$setState = {}, _this$setState[name] = e.target.value, _this$setState.doc_range_error = 'Please enter range in valid format!', _this$setState));
	      } else {
	        var _this$setState2;
	
	        _this.setState((_this$setState2 = {}, _this$setState2[name] = e.target.value, _this$setState2), function () {
	          var _historyActions$filte;
	
	          _this.props.dispatch(historyActions.filterHistoryEntries((_historyActions$filte = {}, _historyActions$filte[name] = e.target.value, _historyActions$filte)));
	        });
	      }
	    };
	
	    _this.changeDate = function (type, date) {
	      var _this$setState3;
	
	      _this.setState((_this$setState3 = {}, _this$setState3[type] = date, _this$setState3));
	    };
	
	    _this.handleDateChangeRaw = function (type, e) {
	      var _this$setState4;
	
	      var date = e.target.value;
	      if (date.split('/').length !== 3) {
	        return;
	      }
	
	      var sanitized = date.split('/').reduce(function (accum, next, idx) {
	        var n = next.length < 2 ? '0' + next : next;
	
	        return idx === 0 ? accum + n : accum + '/' + n;
	      }, '');
	
	      var d = (0, _moment2.default)(sanitized, 'MM-DD-YYYY');
	
	      _this.setState((_this$setState4 = {}, _this$setState4[type] = d, _this$setState4));
	    };
	
	    _this.handleDocRange = function (range) {
	      var ranges = { doc_from: '_', doc_to: '_', mid_range: '_', delimeter: '_' };
	      // check if its not empty
	      if (range) {
	        if (range.includes(',') && range.includes('-')) {
	          // special check for number - number, number
	          range = range.replace(/\s+/g, '');
	
	          var _range$split = range.split('-'),
	              doc_from = _range$split[0],
	              doc_to = _range$split[1];
	
	          ranges.doc_from = doc_from || '_';
	
	          var _doc_to$split = doc_to.split(','),
	              mid_range = _doc_to$split[0],
	              end_range = _doc_to$split[1];
	
	          ranges.doc_to = end_range || '_';
	          ranges.mid_range = mid_range;
	          ranges.delimeter = '*';
	        } else if (range.includes(',')) {
	          range = range.replace(/\s+/g, '');
	
	          var _range$split2 = range.split(','),
	              _doc_from = _range$split2[0],
	              _doc_to = _range$split2[1];
	
	          ranges.doc_from = _doc_from || '_';
	          ranges.doc_to = _doc_to || '_';
	          ranges.delimeter = ',';
	        } else if (range.includes('-')) {
	          range = range.replace(/\s+/g, '');
	
	          var _range$split3 = range.split('-'),
	              _doc_from2 = _range$split3[0],
	              _doc_to2 = _range$split3[1];
	
	          ranges.doc_from = _doc_from2 || '_';
	          ranges.doc_to = _doc_to2 || '_';
	          ranges.delimeter = '-';
	        } else {
	          ranges.doc_from = range;
	        }
	      }
	      return ranges;
	    };
	
	    _this.buyFilteredDockets = function (e) {
	      e.preventDefault();
	      _this.setState({ showLoadingBar: true });
	      var _this$state = _this.state,
	          startDate = _this$state.startDate,
	          endDate = _this$state.endDate,
	          doc_range = _this$state.doc_range,
	          keyword = _this$state.keyword;
	
	      var doc_range_object = _this.handleDocRange(doc_range);
	      var params = {
	        type: parser_type,
	        case_uuid: _this.props.case_uuid,
	        // is_ajax: 1,
	        // receipt_only: 1,
	        query: 'history_search',
	        date_from: startDate ? startDate.format('MM-DD-YYYY') : '_',
	        date_to: endDate ? endDate.format('MM-DD-YYYY') : '_',
	        doc_from: doc_range_object.doc_from,
	        doc_to: doc_range_object.doc_to,
	        delimeter: doc_range_object.delimeter,
	        keyword: _lodash2.default.isEmpty(keyword) ? '_' : keyword,
	        sort_field: _this.state.sort_field,
	        sort_direction: _this.state.sort_direction,
	        page_num: 0
	      };
	      _this.props.dispatch(historyActions.getParserSearchData(params, null));
	    };
	
	    _this.popupForm = {
	      EmailCombinedPdfPopup: _EmailCombinedPdfPopup2.default,
	      AllPartsPrintPreview: _AllPartsPrintPreview2.default,
	      DownloadZipAllPdfsRangePopup: _DownloadZipAllPdfsRangePopup2.default,
	      DownloadZipWithSubpartsPopup: _DownloadZipWithSubpartsPopup2.default,
	      DownloadCombineAllPdfInRangePopup: _DownloadCombineAllPdfInRangePopup2.default,
	      PrintAllPdfInRangePopup: _PrintAllPdfInRangePopup2.default,
	      EmailPartPopup: _EmailPartPopup2.default,
	      EmailPartModal: _EmailPartModal2.default,
	      EmailAllPartsZipPopup: _EmailAllPartsZipPopup2.default
	    };
	
	    _this.props = props;
	    _this.state = _extends({}, initState, {
	      visibleDocketRow: '',
	      selectedPageNum: 1,
	      selectedDocketDetailNum: null,
	      showEmailPopup: false,
	      showEmailNotification: false,
	      showPubliclinkPopup: false,
	      showPacerFilterSection: _this.props.purchase_right_away
	    });
	    _this.setDocketRowVisible = _this.setDocketRowVisible.bind(_this);
	    _this.togglePacerFilterSection = _this.togglePacerFilterSection.bind(_this);
	    _this.changePage = _this.changePage.bind(_this);
	    _this.getDocketDetails = _this.getDocketDetails.bind(_this);
	    return _this;
	  }
	
	  HistoryContainer.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.purchase_right_away) {
	      this.purchaseData();
	    } else {
	      this.getData();
	    }
	  };
	
	  HistoryContainer.prototype.toggleEmailPopup = function toggleEmailPopup() {
	    this.setState({
	      showEmailPopup: !this.state.showEmailPopup
	    });
	  };
	
	  HistoryContainer.prototype.closeEmailNotification = function closeEmailNotification() {
	    this.setState({
	      showEmailNotification: false
	    });
	  };
	
	  HistoryContainer.prototype.togglePublicLinkPopup = function togglePublicLinkPopup() {
	    this.setState({
	      showPubliclinkPopup: !this.state.showPubliclinkPopup
	    });
	  };
	
	  HistoryContainer.prototype.togglePacerFilterSection = function togglePacerFilterSection() {
	    this.setState({
	      showPacerFilterSection: !this.state.showPacerFilterSection
	    });
	  };
	
	  HistoryContainer.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props$history$entrie = this.props.history.entries,
	        entries = _props$history$entrie === undefined ? {} : _props$history$entrie;
	    var name = this.props.popup.name;
	
	    var HistoryPopup = this.props.popup.show && this.popupForm[name];
	
	    var docketFilterProps = {
	      keyword: this.state.keyword,
	      doc_range: this.state.doc_range,
	      startDate: this.state.startDate,
	      endDate: this.state.endDate,
	      onChange: this.changeFilter,
	      changeDate: this.changeDate,
	      onChangeDateRaw: this.handleDateChangeRaw,
	      buyFilteredDockets: function buyFilteredDockets(e) {
	        return _this2.setState({ showLoadingBar: true }, _this2.buyFilteredDockets(e));
	      },
	      onClear: this.onClear
	    };
	    var historyPaginatorProps = {
	      history: this.props.history,
	      case_uuid: this.props.case_uuid,
	      court_code: this.props.court_code,
	      case_number: this.props.case_number,
	      selectedPageNum: this.state.selectedPageNum,
	      changePage: this.changePage,
	      dispatch: this.props.dispatch
	    };
	    var historyEntriesProps = {
	      entries: entries,
	      history: this.props.history,
	      redactSeqNum: this.state.redactSeqNum,
	      buyMissingDockets: this.buyMissingDockets,
	      getDocketDetails: this.getDocketDetails,
	      showRedactPopup: this.showRedactPopup,
	      case_uuid: this.props.case_uuid,
	      court_code: this.props.court_code,
	      case_number: this.props.case_number,
	      sortHistory: this.sortHistory,
	      selectedDocketDetailNum: this.state.selectedDocketDetailNum,
	      keyword: this.state.keyword,
	      selectedDocket: this.props.selectedDocket
	    };
	    var tableSortProps = {
	      sort_direction: this.state.sort_direction,
	      sort_field: this.state.sort_field
	    };
	
	    return _react2.default.createElement(_History2.default, _extends({}, this.props, {
	      type: section_type,
	      purchaseData: this.purchaseData,
	      onSubmit: function onSubmit(value) {
	        return _this2.purchaseData(value);
	      },
	      showPacerFilterSection: this.state.showPacerFilterSection,
	      togglePacerFilterSection: this.togglePacerFilterSection,
	      togglePublicLinkPopup: this.togglePublicLinkPopup,
	      noDataFoundMessage: noDataFoundMessage,
	      historyPaginatorProps: historyPaginatorProps,
	      docketParts: this.props.docketParts,
	      getDocketDetails: this.getDocketDetails,
	      docketFilterProps: docketFilterProps,
	      historyEntriesProps: historyEntriesProps,
	      tableSortProps: tableSortProps,
	      HistoryPopup: HistoryPopup,
	      onPopupClick: this.onPopupClick
	    }));
	  };
	
	  return HistoryContainer;
	}(_react.Component);
	
	HistoryContainer.defaultProps = {
	  purchase_right_away: false,
	  error: null,
	  receipt: null
	};
	
	HistoryContainer.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  case_uuid: _propTypes2.default.any.isRequired,
	  purchase_right_away: _propTypes2.default.bool,
	  dataReady: _propTypes2.default.bool.isRequired,
	  docketParts: _propTypes2.default.any.isRequired,
	  history: _propTypes2.default.any.isRequired,
	  receipt: _propTypes2.default.any,
	  lastUpdated: _propTypes2.default.any.isRequired,
	  error: _propTypes2.default.any
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var historyReducer = state.get('history').toJS();
	  var irSearch = state.get('irSearch').toJS();
	
	  historyReducer.data = [].concat(historyReducer.data, irSearch.data);
	  var history = historyReducer.data.reduce(function (accum, next) {
	    // eslint-disable-next-line
	    accum[next[0]] = next[1];
	    return accum;
	  }, {});
	
	  var _state$get$toJS = state.get('dockets').toJS(),
	      popup = _state$get$toJS.popup,
	      docketParts = _state$get$toJS.docketParts,
	      selectedDocket = _state$get$toJS.selectedDocket;
	
	  return {
	    dataReady: historyReducer.data_ready,
	    // dockets,
	    history: history,
	    popup: popup,
	    docketParts: docketParts,
	    receipt: historyReducer.receipt,
	    lastUpdated: historyReducer.lastUpdated,
	    error: historyReducer.error,
	    selectedDocket: selectedDocket
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(HistoryContainer);

/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(13);
	
	var _LoadingBar = __webpack_require__(92);
	
	var _LoadingBar2 = _interopRequireDefault(_LoadingBar);
	
	var _PopupError = __webpack_require__(176);
	
	var _PopupError2 = _interopRequireDefault(_PopupError);
	
	var _UpdateFromPacer = __webpack_require__(70);
	
	var _UpdateFromPacer2 = _interopRequireDefault(_UpdateFromPacer);
	
	var _SearchReceipt = __webpack_require__(416);
	
	var _SearchReceipt2 = _interopRequireDefault(_SearchReceipt);
	
	var _irSearchActions = __webpack_require__(71);
	
	var irSearchActions = _interopRequireWildcard(_irSearchActions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NoticeOfBankruptcyCaseFiling = function (_Component) {
	    _inherits(NoticeOfBankruptcyCaseFiling, _Component);
	
	    function NoticeOfBankruptcyCaseFiling() {
	        _classCallCheck(this, NoticeOfBankruptcyCaseFiling);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    NoticeOfBankruptcyCaseFiling.prototype.componentDidMount = function componentDidMount() {
	        if (this.props.purchase_right_away) this.purchaseNotice();else this.getNotice();
	    };
	
	    NoticeOfBankruptcyCaseFiling.prototype.getNotice = function getNotice() {
	        console.log('fetching notice from cache');
	        this.props.dispatch(irSearchActions.getCaseData({ type: 'notice', case_uuid: this.props.case_uuid }));
	    };
	
	    NoticeOfBankruptcyCaseFiling.prototype.purchaseNotice = function purchaseNotice() {
	        console.log('purchasing notice from pacer');
	        this.props.dispatch(irSearchActions.purchaseCaseData({ type: 'notice', case_uuid: this.props.case_uuid }));
	    };
	
	    NoticeOfBankruptcyCaseFiling.prototype.render = function render() {
	        if (!this.props.dataReady) return _react2.default.createElement(_LoadingBar2.default, null);
	
	        var receipt = this.props.receipt;
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_PopupError2.default, { errors: this.props.error }),
	            _react2.default.createElement('div', { className: 'ir-search-query', dangerouslySetInnerHTML: { __html: this.props.notice } }),
	            receipt ? _react2.default.createElement(_SearchReceipt2.default, { receipt: receipt }) : null,
	            _react2.default.createElement(_UpdateFromPacer2.default, {
	                pacerUpdateHandler: this.purchaseNotice.bind(this),
	                pacerReceipt: receipt,
	                lastUpdated: this.props.lastUpdated })
	        );
	    };
	
	    return NoticeOfBankruptcyCaseFiling;
	}(_react.Component);
	
	function mapStateToProps(state) {
	    var irSearch = state.get('irSearch');
	    return {
	        dataReady: irSearch.get('data_ready'),
	        notice: irSearch.get('data'),
	        receipt: irSearch.receipt,
	        error: irSearch.get('error')
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NoticeOfBankruptcyCaseFiling);

/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.PartiesCasesContainer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _irSearchActions = __webpack_require__(71);
	
	var irActions = _interopRequireWildcard(_irSearchActions);
	
	var _PartiesCases = __webpack_require__(263);
	
	var _PartiesCases2 = _interopRequireDefault(_PartiesCases);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var type = 'parties';
	var noDataFoundMessage = 'There are no parties.';
	var loggedUser = window.Drupal.settings.currentUser;
	
	var PartiesCasesContainer = exports.PartiesCasesContainer = function (_Component) {
	  _inherits(PartiesCasesContainer, _Component);
	
	  function PartiesCasesContainer() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PartiesCasesContainer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getData = function () {
	      _this.props.dispatch(irActions.getCaseData({
	        type: type,
	        case_uuid: _this.props.case_uuid
	      }));
	    }, _this.purchaseData = function () {
	      _this.props.dispatch(irActions.purchaseCaseData({
	        type: type,
	        case_uuid: _this.props.case_uuid
	      }));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  PartiesCasesContainer.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.purchase_right_away) {
	      this.purchaseData();
	    } else {
	      this.getData();
	    }
	  };
	
	  PartiesCasesContainer.prototype.render = function render() {
	    return _react2.default.createElement(_PartiesCases2.default, _extends({}, this.props, {
	      type: type,
	      purchaseData: this.purchaseData,
	      currentUser: loggedUser,
	      noDataFoundMessage: noDataFoundMessage
	    }));
	  };
	
	  return PartiesCasesContainer;
	}(_react.Component);
	
	PartiesCasesContainer.defaultProps = {
	  purchase_right_away: false,
	  error: null,
	  receipt: null
	};
	
	PartiesCasesContainer.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  case_uuid: _propTypes2.default.any.isRequired,
	  purchase_right_away: _propTypes2.default.bool,
	  dataReady: _propTypes2.default.bool.isRequired,
	  parties: _propTypes2.default.any.isRequired,
	  receipt: _propTypes2.default.any,
	  lastUpdated: _propTypes2.default.any.isRequired,
	  error: _propTypes2.default.any
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var irSearch = state.get('irSearch').toJS();
	  return {
	    dataReady: irSearch.data_ready,
	    parties: irSearch.data,
	    receipt: irSearch.receipt,
	    lastUpdated: irSearch.lastUpdated,
	    error: irSearch.error
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PartiesCasesContainer);

/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _PartiesCases = __webpack_require__(263);
	
	var _PartiesCases2 = _interopRequireDefault(_PartiesCases);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _PartiesCases2.default;

/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.RelatedTransactionContainer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _docketActions = __webpack_require__(42);
	
	var docketActions = _interopRequireWildcard(_docketActions);
	
	var _drupalDocketActions = __webpack_require__(726);
	
	var drupalDocketActions = _interopRequireWildcard(_drupalDocketActions);
	
	var _relatedTransactionActions = __webpack_require__(1224);
	
	var relatedTransactionActions = _interopRequireWildcard(_relatedTransactionActions);
	
	var _clientCodeAction = __webpack_require__(64);
	
	var _AllPartsPrintPreview = __webpack_require__(133);
	
	var _AllPartsPrintPreview2 = _interopRequireDefault(_AllPartsPrintPreview);
	
	var _EmailCombinedPdfPopup = __webpack_require__(173);
	
	var _EmailCombinedPdfPopup2 = _interopRequireDefault(_EmailCombinedPdfPopup);
	
	var _DownloadZipAllPdfsRangePopup = __webpack_require__(134);
	
	var _DownloadZipAllPdfsRangePopup2 = _interopRequireDefault(_DownloadZipAllPdfsRangePopup);
	
	var _DownloadCombineAllPdfInRangePopup = __webpack_require__(171);
	
	var _DownloadCombineAllPdfInRangePopup2 = _interopRequireDefault(_DownloadCombineAllPdfInRangePopup);
	
	var _DownloadZipWithSubpartsPopup = __webpack_require__(135);
	
	var _DownloadZipWithSubpartsPopup2 = _interopRequireDefault(_DownloadZipWithSubpartsPopup);
	
	var _PrintAllPdfInRangePopup = __webpack_require__(175);
	
	var _PrintAllPdfInRangePopup2 = _interopRequireDefault(_PrintAllPdfInRangePopup);
	
	var _EmailPartPopup = __webpack_require__(174);
	
	var _EmailPartPopup2 = _interopRequireDefault(_EmailPartPopup);
	
	var _EmailPartModal = __webpack_require__(136);
	
	var _EmailPartModal2 = _interopRequireDefault(_EmailPartModal);
	
	var _EmailAllPartsZipPopup = __webpack_require__(172);
	
	var _EmailAllPartsZipPopup2 = _interopRequireDefault(_EmailAllPartsZipPopup);
	
	var _RelatedTransaction = __webpack_require__(264);
	
	var _RelatedTransaction2 = _interopRequireDefault(_RelatedTransaction);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var type = 'related_transactions';
	var noDataFoundMessage = 'No Transactions found.';
	
	var initState = {
	  docNumFrom: null,
	  docNumTo: null,
	  startDate: null,
	  endDate: null,
	  pacerSearch: {
	    startDate: null,
	    endDate: null,
	    doc_from: null,
	    doc_to: null
	  },
	  doc_range: '',
	  doc_range_error: '',
	  keyword: '',
	  sort_field: 'date_event_filed',
	  sort_direction: 'desc',
	  ir_search_page_size: window.Drupal.settings.ir_search_page_size || 50
	};
	
	var RelatedTransactionContainer = exports.RelatedTransactionContainer = function (_Component) {
	  _inherits(RelatedTransactionContainer, _Component);
	
	  function RelatedTransactionContainer(props) {
	    _classCallCheck(this, RelatedTransactionContainer);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.onPopupClick = function (params) {
	      _this.props.dispatch(docketActions.togglePopup(params));
	    };
	
	    _this.onClear = function (e) {
	      _this.setState(initState, function () {
	        _this.buyFilteredDockets(e);
	      });
	    };
	
	    _this.getData = function () {
	      var page_num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var sort_direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.sort_direction;
	      var sort_field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.state.sort_field;
	
	      _this.setState({ showPacerFilterSection: false });
	      _this.props.dispatch(relatedTransactionActions.getParserSearchData({
	        type: type,
	        case_uuid: _this.props.case_uuid,
	        date_from: '_',
	        date_to: '_',
	        doc_from: '_',
	        doc_to: '_',
	        keyword: '_',
	        sort_field: sort_field,
	        sort_direction: sort_direction,
	        page_num: page_num
	      }, null));
	    };
	
	    _this.getParserData = function (values) {
	      var page_num = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	      var sort_direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.state.sort_direction;
	      var sort_field = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _this.state.sort_field;
	
	      var date_from = values.date_from ? values.date_from.format('YYYY-MM-DD') : '_';
	      var date_to = values.date_to ? values.date_to.format('YYYY-MM-DD') : '_';
	      var doc_from = values.doc_from ? values.doc_from : '_';
	      var doc_to = values.doc_to ? values.doc_to : '_';
	      var keyword = values.keyword ? values.keyword : '_';
	
	      _this.props.dispatch(relatedTransactionActions.getParserSearchData({
	        type: type,
	        case_uuid: _this.props.case_uuid,
	        date_from: date_from,
	        date_to: date_to,
	        doc_from: doc_from,
	        doc_to: doc_to,
	        keyword: keyword,
	        sort_field: sort_field,
	        sort_direction: sort_direction,
	        page_num: page_num
	      }, null));
	    };
	
	    _this.getDocketDetails = function (seqNum) {
	      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.visibleDocketRow;
	
	      _this.setState({ selectedDocketDetailNum: seqNum, visibleDocketRow: '' + index }, function () {
	        var params = { case_uuid: _this.props.case_uuid, seqNum: seqNum };
	        _this.props.dispatch(drupalDocketActions.getDocketDetails(params));
	      });
	    };
	
	    _this.getCaseData = function () {
	      _this.props.dispatch(relatedTransactionActions.getCaseData({
	        type: type,
	        case_uuid: _this.props.case_uuid
	      }, null));
	    };
	
	    _this.purchaseData = function (values) {
	      var keyword = values.keyword ? values.keyword : '';
	      var doc_type = values.doc_type ? values.doc_type : '';
	      var date_from = values.date_from ? values.date_from.format('YYYY-MM-DD') : '';
	      var date_to = values.date_to ? values.date_to.format('YYYY-MM-DD') : '';
	      var doc_from = values.doc_from ? values.doc_from : '';
	      var doc_to = values.doc_to ? values.doc_to : '';
	      var show_pending = values.pending ? values.pending : false;
	      var show_terminated = values.terminated ? 1 : false;
	
	      show_pending = show_pending ? '1' : '0';
	      show_terminated = show_terminated ? '1' : '0';
	      _this.props.dispatch(relatedTransactionActions.purchaseRelatedTransactionsCaseData({
	        type: type,
	        case_uuid: _this.props.case_uuid,
	        keyword: keyword,
	        date_from: date_from,
	        date_to: date_to,
	        doc_from: doc_from,
	        doc_to: doc_to,
	        show_pending: show_pending,
	        show_terminated: show_terminated,
	        doc_type: doc_type
	      })).then(_this.getCaseData());
	    };
	
	    _this.changePage = function (itemParams) {
	      _this.setState({ selectedPageNum: itemParams.page_index });
	      _this.getData(itemParams.page_index);
	    };
	
	    _this.reloadDetails = function () {
	      _this.getDocketDetails(_this.props.selectedDocket.seqNum);
	    };
	
	    _this.buyPdf = function (docket_no, number, seqNum) {
	      if (_this.props.dispatch((0, _clientCodeAction.hasValidClientCode)())) {
	        var params = {
	          case_uuid: _this.props.case_uuid,
	          docket_no: docket_no,
	          number: number,
	          seqNum: seqNum
	        };
	        _this.props.dispatch(docketActions.buyPdf(params)).then(_this.reloadDetails);
	      }
	    };
	
	    _this.sortRelatedTransaction = function (sort_field) {
	      var sort_direction = _this.state.sort_direction === 'asc' ? 'desc' : 'asc';
	
	      _this.setState({ sort_field: sort_field, sort_direction: sort_direction });
	      _this.getData(0, sort_direction, sort_field);
	    };
	
	    _this.changeFilter = function (e, name) {
	      var _this$setState2;
	
	      if (name === 'doc_range' && (!name.includes(',') || !name.includes('-'))) {
	        var _this$setState;
	
	        _this.setState((_this$setState = {}, _this$setState[name] = e.target.value, _this$setState.doc_range_error = 'Please enter range in valid format!', _this$setState));
	      }
	      _this.setState((_this$setState2 = {}, _this$setState2[name] = e.target.value, _this$setState2));
	    };
	
	    _this.changeDate = function (type, date) {
	      var _this$setState3;
	
	      _this.setState((_this$setState3 = {}, _this$setState3[type] = date, _this$setState3));
	    };
	
	    _this.handleDateChangeRaw = function (type, e) {
	      var _this$setState4;
	
	      var date = e.target.value;
	      if (date.split('/').length !== 3) {
	        return;
	      }
	
	      var sanitized = date.split('/').reduce(function (accum, next, idx) {
	        var n = next.length < 2 ? '0' + next : next;
	
	        return idx === 0 ? accum + n : accum + '/' + n;
	      }, '');
	
	      var d = moment(sanitized, 'MM-DD-YYYY');
	
	      _this.setState((_this$setState4 = {}, _this$setState4[type] = d, _this$setState4));
	    };
	
	    _this.handleDocRange = function (range) {
	      var ranges = { doc_from: '_', doc_to: '_' };
	      // check if its not empty
	      if (range) {
	        if (range.includes(',')) {
	          var _range$split = range.split(','),
	              doc_from = _range$split[0],
	              doc_to = _range$split[1];
	
	          ranges.doc_from = doc_from;
	          ranges.doc_to = doc_to;
	        } else if (range.includes('-')) {
	          var _range$split2 = range.split('-'),
	              _doc_from = _range$split2[0],
	              _doc_to = _range$split2[1];
	
	          ranges.doc_from = _doc_from;
	          ranges.doc_to = _doc_to;
	        } else {
	          ranges.doc_from = range;
	        }
	      }
	      return ranges;
	    };
	
	    _this.buyFilteredDockets = function (values) {
	      _this.setState({ showLoadingBar: true });
	      var _values$date_from = values.date_from,
	          date_from = _values$date_from === undefined ? '' : _values$date_from,
	          _values$date_to = values.date_to,
	          date_to = _values$date_to === undefined ? '' : _values$date_to,
	          _values$doc_range = values.doc_range,
	          doc_range = _values$doc_range === undefined ? '' : _values$doc_range,
	          _values$keyword = values.keyword,
	          keyword = _values$keyword === undefined ? '' : _values$keyword;
	
	      var doc_range_object = _this.handleDocRange(doc_range);
	      var params = {
	        type: type,
	        case_uuid: _this.props.case_uuid,
	        // is_ajax: 1,
	        // receipt_only: 1,
	        query: 'relatedTransaction_search',
	        date_from: date_from ? date_from.format('MM-DD-YYYY') : '_',
	        date_to: date_to ? date_to.format('MM-DD-YYYY') : '_',
	        doc_from: doc_range_object.doc_from,
	        doc_to: doc_range_object.doc_to,
	        keyword: _.isEmpty(keyword) ? '_' : keyword,
	        sort_field: _this.state.sort_field,
	        sort_direction: _this.state.sort_direction,
	        page_num: 0
	      };
	      _this.props.dispatch(relatedTransactionActions.getParserSearchData(params, null));
	    };
	
	    _this.reloadDetails = function () {
	      _this.getDocketDetails(_this.props.selectedDocket.seqNum);
	    };
	
	    _this.popupForm = {
	      EmailCombinedPdfPopup: _EmailCombinedPdfPopup2.default,
	      AllPartsPrintPreview: _AllPartsPrintPreview2.default,
	      DownloadZipAllPdfsRangePopup: _DownloadZipAllPdfsRangePopup2.default,
	      DownloadZipWithSubpartsPopup: _DownloadZipWithSubpartsPopup2.default,
	      DownloadCombineAllPdfInRangePopup: _DownloadCombineAllPdfInRangePopup2.default,
	      PrintAllPdfInRangePopup: _PrintAllPdfInRangePopup2.default,
	      EmailPartPopup: _EmailPartPopup2.default,
	      EmailPartModal: _EmailPartModal2.default,
	      EmailAllPartsZipPopup: _EmailAllPartsZipPopup2.default
	    };
	
	    _this.props = props;
	    _this.state = _extends({}, initState, {
	      visibleDocketRow: '',
	      selectedPageNum: 1,
	      selectedDocketDetailNum: null,
	      showEmailPopup: false,
	      showEmailNotification: false,
	      showPubliclinkPopup: false,
	      showPacerFilterSection: _this.props.purchase_right_away
	    });
	    _this.togglePacerFilterSection = _this.togglePacerFilterSection.bind(_this);
	    _this.changePage = _this.changePage.bind(_this);
	    _this.getDocketDetails = _this.getDocketDetails.bind(_this);
	    return _this;
	  }
	
	  RelatedTransactionContainer.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.purchase_right_away) {
	      this.purchaseData();
	    } else {
	      this.getData();
	    }
	  };
	
	  RelatedTransactionContainer.prototype.toggleEmailPopup = function toggleEmailPopup() {
	    this.setState({
	      showEmailPopup: !this.state.showEmailPopup
	    });
	  };
	
	  RelatedTransactionContainer.prototype.closeEmailNotification = function closeEmailNotification() {
	    this.setState({
	      showEmailNotification: false
	    });
	  };
	
	  RelatedTransactionContainer.prototype.togglePublicLinkPopup = function togglePublicLinkPopup() {
	    this.setState({
	      showPubliclinkPopup: !this.state.showPubliclinkPopup
	    });
	  };
	
	  RelatedTransactionContainer.prototype.togglePacerFilterSection = function togglePacerFilterSection() {
	    this.setState({
	      showPacerFilterSection: !this.state.showPacerFilterSection
	    });
	  };
	
	  RelatedTransactionContainer.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props$transactions$e = this.props.transactions.entries,
	        entries = _props$transactions$e === undefined ? [] : _props$transactions$e;
	    var name = this.props.popup.name;
	
	    var RelatedTransactionPopup = this.props.popup.show && this.popupForm[name];
	
	    var docketFilterProps = {
	      keyword: this.state.keyword,
	      doc_range: this.state.doc_range,
	      startDate: this.state.startDate,
	      endDate: this.state.endDate,
	      onChange: this.changeFilter,
	      changeDate: this.changeDate,
	      onChangeDateRaw: this.handleDateChangeRaw,
	      buyFilteredDockets: function buyFilteredDockets(e) {
	        return _this2.setState({ showLoadingBar: true }, _this2.buyFilteredDockets(e));
	      },
	      onClear: this.onClear
	    };
	    var relatedTransactionPaginatorProps = {
	      transactions: this.props.transactions,
	      case_uuid: this.props.case_uuid,
	      selectedPageNum: this.state.selectedPageNum,
	      changePage: this.changePage,
	      dispatch: this.props.dispatch
	    };
	    var relatedTransactionEntriesProps = {
	      entries: entries,
	      transactions: this.props.transactions,
	      redactSeqNum: this.state.redactSeqNum,
	      buyMissingDockets: this.buyMissingDockets,
	      getDocketDetails: this.getDocketDetails,
	      showRedactPopup: this.showRedactPopup,
	      reloadDetails: this.reloadDetails,
	      buyPdf: this.buyPdf,
	      case_uuid: this.props.case_uuid,
	      sortRelatedTransaction: this.sortRelatedTransaction,
	      onPopupClick: this.onPopupClick,
	      selectedDocketDetailNum: this.state.selectedDocketDetailNum
	    };
	    var tableSortProps = {
	      sort_direction: this.state.sort_direction,
	      sort_field: this.state.sort_field
	    };
	
	    return _react2.default.createElement(_RelatedTransaction2.default, _extends({}, this.props, {
	      type: type,
	      purchaseData: this.purchaseData,
	      onSubmit: function onSubmit(value) {
	        return _this2.purchaseData(value);
	      },
	      resetParser: function resetParser() {
	        return _this2.getData();
	      },
	      onSubmitParser: function onSubmitParser(value) {
	        return _this2.getParserData(value);
	      },
	      showPacerFilterSection: this.state.showPacerFilterSection,
	      togglePacerFilterSection: this.togglePacerFilterSection,
	      visibleDocketRow: this.state.visibleDocketRow,
	      togglePublicLinkPopup: this.togglePublicLinkPopup,
	      noDataFoundMessage: noDataFoundMessage,
	      relatedTransactionPaginatorProps: relatedTransactionPaginatorProps,
	      docketParts: this.props.docketParts,
	      getDocketDetails: this.getDocketDetails,
	      docketFilterProps: docketFilterProps,
	      relatedTransactionEntriesProps: relatedTransactionEntriesProps,
	      tableSortProps: tableSortProps,
	      RelatedTransactionPopup: RelatedTransactionPopup,
	      onPopupClick: this.onPopupClick,
	      reloadDetails: this.reloadDetails
	    }));
	  };
	
	  return RelatedTransactionContainer;
	}(_react.Component);
	
	RelatedTransactionContainer.defaultProps = {
	  purchase_right_away: false,
	  error: null,
	  receipt: null
	};
	
	RelatedTransactionContainer.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  case_uuid: _propTypes2.default.any.isRequired,
	  purchase_right_away: _propTypes2.default.bool,
	  dataReady: _propTypes2.default.bool.isRequired,
	  docketParts: _propTypes2.default.any.isRequired,
	  selectedDocket: _propTypes2.default.object.isRequired,
	  transactions: _propTypes2.default.any.isRequired,
	  receipt: _propTypes2.default.any,
	  lastUpdated: _propTypes2.default.any.isRequired,
	  error: _propTypes2.default.any
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var relatedTransactionReducer = state.get('relatedTransactions').toJS();
	  var irSearch = state.get('irSearch').toJS();
	
	  relatedTransactionReducer.data = [].concat(relatedTransactionReducer.data, irSearch.data);
	  var transactions = relatedTransactionReducer.data.reduce(function (accum, next) {
	    // eslint-disable-next-line
	    accum[next[0]] = next[1];
	    return accum;
	  }, {});
	
	  var _state$get$toJS = state.get('dockets').toJS(),
	      popup = _state$get$toJS.popup,
	      docketParts = _state$get$toJS.docketParts,
	      selectedDocket = _state$get$toJS.selectedDocket;
	
	  return {
	    dataReady: relatedTransactionReducer.data_ready,
	    transactions: transactions,
	    popup: popup,
	    docketParts: docketParts,
	    selectedDocket: selectedDocket,
	    receipt: relatedTransactionReducer.receipt,
	    lastUpdated: relatedTransactionReducer.lastUpdated,
	    error: relatedTransactionReducer.error
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(RelatedTransactionContainer);

/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _RelatedTransaction = __webpack_require__(264);
	
	var _RelatedTransaction2 = _interopRequireDefault(_RelatedTransaction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RelatedTransaction2.default;

/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.StatusController = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _irSearchActions = __webpack_require__(71);
	
	var irActions = _interopRequireWildcard(_irSearchActions);
	
	var _Status = __webpack_require__(265);
	
	var _Status2 = _interopRequireDefault(_Status);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var type = 'status_pending';
	var noDataFoundMessage = 'There are no pending statuses.';
	
	var StatusController = exports.StatusController = function (_Component) {
	  _inherits(StatusController, _Component);
	
	  function StatusController() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StatusController);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getData = function () {
	      _this.props.dispatch(irActions.getCaseData({
	        type: type,
	        case_uuid: _this.props.case_uuid
	      }));
	    }, _this.purchaseData = function () {
	      _this.props.dispatch(irActions.purchaseCaseData({
	        type: type,
	        case_uuid: _this.props.case_uuid
	      }));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StatusController.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.purchase_right_away) {
	      this.purchaseData();
	    } else {
	      this.getData();
	    }
	  };
	
	  StatusController.prototype.render = function render() {
	    return _react2.default.createElement(_Status2.default, _extends({}, this.props, {
	      type: type,
	      purchaseData: this.purchaseData,
	      noDataFoundMessage: noDataFoundMessage
	    }));
	  };
	
	  return StatusController;
	}(_react.Component);
	
	StatusController.defaultProps = {
	  purchase_right_away: false,
	  error: null,
	  receipt: null
	};
	
	StatusController.propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  case_uuid: _propTypes2.default.any.isRequired,
	  purchase_right_away: _propTypes2.default.bool,
	  dataReady: _propTypes2.default.bool.isRequired,
	  statuses: _propTypes2.default.any.isRequired,
	  receipt: _propTypes2.default.any,
	  lastUpdated: _propTypes2.default.any.isRequired,
	  error: _propTypes2.default.any
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var irSearch = state.get('irSearch').toJS();
	  return {
	    dataReady: irSearch.data_ready,
	    statuses: irSearch.data,
	    receipt: irSearch.receipt,
	    lastUpdated: irSearch.lastUpdated,
	    error: irSearch.error
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(StatusController);

/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _Status = __webpack_require__(265);
	
	var _Status2 = _interopRequireDefault(_Status);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Status2.default;

/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(13);
	
	var _irSearchActions = __webpack_require__(71);
	
	var irSearchActions = _interopRequireWildcard(_irSearchActions);
	
	var _LoadingBar = __webpack_require__(92);
	
	var _LoadingBar2 = _interopRequireDefault(_LoadingBar);
	
	var _PopupError = __webpack_require__(176);
	
	var _PopupError2 = _interopRequireDefault(_PopupError);
	
	var _FilterTable = __webpack_require__(80);
	
	var _FilterTable2 = _interopRequireDefault(_FilterTable);
	
	var _UpdateFromPacer = __webpack_require__(70);
	
	var _UpdateFromPacer2 = _interopRequireDefault(_UpdateFromPacer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CaseSummary = function (_Component) {
	    _inherits(CaseSummary, _Component);
	
	    function CaseSummary() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, CaseSummary);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getSummaryData = function () {
	            _this.props.dispatch(irSearchActions.getCaseData({
	                type: 'case_summary',
	                case_uuid: _this.props.case_uuid
	            }));
	        }, _this.purchaseSummaryData = function () {
	            _this.props.dispatch(irSearchActions.purchaseCaseData({
	                type: 'case_summary',
	                case_uuid: _this.props.case_uuid,
	                purchase_right_away: _this.props.purchase_right_away
	            }));
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    CaseSummary.prototype.componentDidMount = function componentDidMount() {
	        if (this.props.purchase_right_away) this.purchaseSummaryData();else this.getSummaryData();
	    };
	
	    CaseSummary.prototype.render = function render() {
	        if (!this.props.dataReady) return _react2.default.createElement(_LoadingBar2.default, null);
	
	        var SummaryData = this.props.summary || [];
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'ir-search-query case-summary' },
	            _react2.default.createElement(_PopupError2.default, { errors: this.props.error }),
	            _react2.default.createElement(
	                _FilterTable2.default,
	                null,
	                !!SummaryData.length ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: SummaryData } }) : _react2.default.createElement(
	                    'div',
	                    {
	                        className: 'ir-search-status-message messages warning'
	                    },
	                    'There Are No Summary Data For This Case'
	                )
	            ),
	            _react2.default.createElement(_UpdateFromPacer2.default, {
	                pacerUpdateHandler: this.purchaseSummaryData,
	                pacerReceipt: this.props.receipt,
	                lastUpdated: this.props.lastUpdated })
	        );
	    };
	
	    return CaseSummary;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    var irSearch = state.get('irSearch').toJS();
	    var validationErrors = state.get('validationErrors') ? state.get('validationErrors').toJS() : null;
	    return {
	        dataReady: irSearch.data_ready,
	        summary: irSearch.data,
	        receipt: irSearch.receipt,
	        lastUpdated: irSearch.lastUpdated,
	        error: irSearch.error,
	        clientCodeValidation: validationErrors
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CaseSummary);

/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FilterTableHeader(_ref) {
	  var changeText = _ref.changeText,
	      advancedSearchLink = _ref.advancedSearchLink,
	      getDowloadExcel = _ref.getDowloadExcel;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'live_search' },
	    _react2.default.createElement(
	      'span',
	      null,
	      'Find What: '
	    ),
	    _react2.default.createElement('input', { onChange: changeText,
	      placeholder: 'enter search term',
	      type: 'search',
	      style: { width: 250 } }),
	    advancedSearchLink,
	    getDowloadExcel
	  );
	}
	
	FilterTableHeader.defaultProps = {
	  advancedSearchLink: null,
	  getDowloadExcel: null,
	  changeText: function changeText() {
	    return null;
	  }
	};
	
	FilterTableHeader.propTypes = {
	  advancedSearchLink: _propTypes2.default.any,
	  getDowloadExcel: _propTypes2.default.any,
	  changeText: _propTypes2.default.func
	};
	
	exports.default = FilterTableHeader;

/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _Loading = __webpack_require__(675);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Common/Loading', module).add('Bar', function () {
	  return _react2.default.createElement(_Loading.Loading, { show: 'true' });
	}).add('Spinner', function () {
	  return _react2.default.createElement(_Loading.Loading, { show: 'true', type: 'spinner' });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _ConfirmationModal = __webpack_require__(676);
	
	var _ConfirmationModal2 = _interopRequireDefault(_ConfirmationModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Common/Modals/ConfirmationModal', module).add('View', function () {
	  return _react2.default.createElement(
	    _ConfirmationModal2.default,
	    {
	      show: true,
	      title: 'Title',
	      onClose: function onClose() {},
	      onConfirm: function onConfirm() {}
	    },
	    'Message'
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _DeleteModal = __webpack_require__(407);
	
	var _DeleteModal2 = _interopRequireDefault(_DeleteModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Common/Modals/DeleteModal', module).add('View', function () {
	  return _react2.default.createElement(
	    _DeleteModal2.default,
	    {
	      show: true,
	      title: 'Delete',
	      onClose: function onClose() {},
	      onConfirm: function onConfirm() {}
	    },
	    'Are you sure?'
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _Notification = __webpack_require__(40);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Common/Notification', module).add('View', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Notification2.default, null),
	    _react2.default.createElement(
	      'button',
	      { className: 'btn btn-info', onClick: function onClick() {
	          return _Notification.notify.info('Info');
	        } },
	      'Info'
	    ),
	    _react2.default.createElement(
	      'button',
	      { className: 'btn btn-success', onClick: function onClick() {
	          return _Notification.notify.success('Success message');
	        } },
	      'Success'
	    ),
	    _react2.default.createElement(
	      'button',
	      { className: 'btn btn-warning', onClick: function onClick() {
	          return _Notification.notify.warn('Warning');
	        } },
	      'Warning'
	    ),
	    _react2.default.createElement(
	      'button',
	      { className: 'btn btn-danger', onClick: function onClick() {
	          return _Notification.notify.error('Failed action');
	        } },
	      'Error'
	    )
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _Popup = __webpack_require__(69);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Common/Popup', module).add('View', function () {
	  return _react2.default.createElement(
	    _Popup2.default,
	    { show: true,
	      clsName: 'some-class-name',
	      topBarTitle: 'Sample Popup',
	      onClose: (0, _addonActions.action)('OnClose') },
	    _react2.default.createElement(
	      'div',
	      null,
	      ' Sample Popup Children Area '
	    )
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PacerReceipt = function (_Component) {
	    _inherits(PacerReceipt, _Component);
	
	    function PacerReceipt() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, PacerReceipt);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPacerUpdateReceipt = function (params) {
	            var datetime = params.datetime,
	                user_id = params.user_id,
	                client_code = params.client_code,
	                description = params.description,
	                criteria = params.criteria,
	                pages = params.pages,
	                cost = params.cost;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'ir-search-receipt' },
	                _react2.default.createElement(
	                    'table',
	                    null,
	                    _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '2' },
	                                'PACER Service Center'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Receipt:'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                datetime
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'User:'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                user_id
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Client:'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                client_code
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description:'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                description
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                criteria
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Pages:'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                pages,
	                                '\xA0($',
	                                cost,
	                                ')'
	                            )
	                        )
	                    )
	                )
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    PacerReceipt.prototype.render = function render() {
	        var pacerReceiptMarkup = void 0;
	        var pacerReceipt = this.props.pacerReceipt;
	
	
	        if (pacerReceipt) pacerReceiptMarkup = this.getPacerUpdateReceipt(pacerReceipt);
	
	        return _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            pacerReceiptMarkup
	        );
	    };
	
	    return PacerReceipt;
	}(_react.Component);
	
	exports.default = PacerReceipt;

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	__webpack_require__(2195);
	
	var _arrowAsc = __webpack_require__(2226);
	
	var _arrowAsc2 = _interopRequireDefault(_arrowAsc);
	
	var _arrowDesc = __webpack_require__(2227);
	
	var _arrowDesc2 = _interopRequireDefault(_arrowDesc);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SortArrow = function (_Component) {
	    _inherits(SortArrow, _Component);
	
	    function SortArrow() {
	        _classCallCheck(this, SortArrow);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    SortArrow.prototype.render = function render() {
	        var arrowImg = this.props.isReverse ? _arrowAsc2.default : _arrowDesc2.default;
	
	        return _react2.default.createElement('img', { src: arrowImg, className: 'arrow-img' });
	    };
	
	    return SortArrow;
	}(_react.Component);
	
	exports.default = SortArrow;

/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _RefineSearch = __webpack_require__(409);
	
	var _RefineSearch2 = _interopRequireDefault(_RefineSearch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Advanced Search', module).add('RefineSearch', function () {
	  return _react2.default.createElement(_RefineSearch2.default, { advancedSearchFilter: advancedSearchFilter, facets: facets, onSearchAdvancedFilings: function onSearchAdvancedFilings() {
	      return null;
	    } });
	});
	
	var advancedSearchFilter = {
	  case_titles: 'include',
	  court_type: 'all',
	  do_search: true,
	  grouped: true,
	  keys: 'lehman',
	  my_cases: '',
	  page: 0,
	  party_name: 'include',
	  query: null,
	  search_pdfs: 'exclude',
	  tab: 'cases',
	  template: 'case_lookup'
	};
	
	var facets = {
	  chapter: {
	    10: 2
	  },
	  court: {
	    randomCourt: 3
	  },
	  court_type: {
	    bankruptcy: 20
	  },
	  date_filed: { 2008: 1 },
	  judge_name: { 'Leonardo diCaprio': 1 }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActionButtonOfCaseLookup = function (_Component) {
	  _inherits(ActionButtonOfCaseLookup, _Component);
	
	  function ActionButtonOfCaseLookup() {
	    _classCallCheck(this, ActionButtonOfCaseLookup);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ActionButtonOfCaseLookup.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      {
	        onClick: this.props.onClick,
	        className: 'form-item',
	        style: { display: 'inline-block', width: 'auto' } },
	      _react2.default.createElement(
	        'a',
	        { className: 'form-submit', style: { left: '15px' } },
	        _react2.default.createElement('span', {
	          style: {
	            background: "url(/sites/all/themes/inforuptcy/icons/small-white-magnifier.png) center no-repeat",
	            padding: "2px 0 0 16px"
	          } })
	      )
	    );
	  };
	
	  return ActionButtonOfCaseLookup;
	}(_react.Component);
	
	ActionButtonOfCaseLookup.defaultProps = {
	  onClick: function onClick() {}
	};
	
	ActionButtonOfCaseLookup.propTypes = {
	  onClick: _propTypes2.default.func
	};
	
	exports.default = ActionButtonOfCaseLookup;

/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _ActionButtonOfCaseLookup = __webpack_require__(1158);
	
	var _ActionButtonOfCaseLookup2 = _interopRequireDefault(_ActionButtonOfCaseLookup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ActionButtonOfCaseLookup2.default;

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArrowFormElement = function (_Component) {
	  _inherits(ArrowFormElement, _Component);
	
	  function ArrowFormElement() {
	    _classCallCheck(this, ArrowFormElement);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ArrowFormElement.prototype.render = function render() {
	    var sort = this.props.sort;
	
	    return this.props.show ? _react2.default.createElement('img', { onClick: this.props.onClick,
	      src: '/misc/arrow-' + sort + '.png',
	      alt: 'sortBy icon',
	      title: 'sortBy ' + sort + 'ending',
	      width: '13', height: '13' }) : null;
	  };
	
	  return ArrowFormElement;
	}(_react.Component);
	
	ArrowFormElement.defaultProps = {
	  // alternative "desc"
	  sort: 'asc',
	  show: false,
	  onClick: function onClick() {}
	};
	
	ArrowFormElement.propTypes = {
	  sort: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  show: _propTypes2.default.bool
	};
	
	exports.default = ArrowFormElement;

/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _ArrowFormElement = __webpack_require__(1160);
	
	var _ArrowFormElement2 = _interopRequireDefault(_ArrowFormElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ArrowFormElement2.default;

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _inputValidations = __webpack_require__(100);
	
	var _NatureOfSuitTooltip = __webpack_require__(1177);
	
	var _NatureOfSuitTooltip2 = _interopRequireDefault(_NatureOfSuitTooltip);
	
	var _appellateNosOptions = __webpack_require__(699);
	
	var _appellateNosOptions2 = _interopRequireDefault(_appellateNosOptions);
	
	__webpack_require__(2180);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function NatureOfSuitOfAppellete(_ref) {
	  var className = _ref.className,
	      filters = _ref.filters,
	      _onChange = _ref.onChange;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'nature-of-suit-selector-container' },
	    _react2.default.createElement(
	      'label',
	      { style: { fontWeight: 700 }, className: 'nature-of-suit-selector-label', htmlFor: 'nature-of-suit-selector' },
	      'Nature of Suit:'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'div',
	      { className: 'nature-of-suit-selector ' + className },
	      _react2.default.createElement(_reactSelect2.default, {
	        name: 'nature-of-suit-field-name',
	        options: _appellateNosOptions2.default,
	        multi: true,
	        simpleValue: true,
	        value: filters.get('nos'),
	        placeholder: 'Select...',
	        onChange: function onChange(nos) {
	          return _onChange({ nos: nos || '' });
	        }
	      })
	    ),
	    _react2.default.createElement(_NatureOfSuitTooltip2.default, null)
	  );
	}
	
	NatureOfSuitOfAppellete.propTypes = {
	  onChange: _propTypes2.default.func,
	  filters: _propTypes2.default.any.isRequired,
	  className: _propTypes2.default.string
	};
	
	NatureOfSuitOfAppellete.defaultProps = {
	  onChange: function onChange() {},
	  className: ''
	};
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return (0, _inputValidations.mapValidationFieldsToClassName)(state, 'nos', 'nos-selector');
	})(NatureOfSuitOfAppellete);

/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _NatureOfSuitOfAppellete = __webpack_require__(1162);
	
	var _NatureOfSuitOfAppellete2 = _interopRequireDefault(_NatureOfSuitOfAppellete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _NatureOfSuitOfAppellete2.default;

/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrSeparator = function (_Component) {
	    _inherits(OrSeparator, _Component);
	
	    function OrSeparator() {
	        _classCallCheck(this, OrSeparator);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    OrSeparator.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { style: { width: '400px', textAlign: 'center' } },
	            _react2.default.createElement('hr', { style: { width: '400px', position: 'absolute', marginTop: '10px' } }),
	            _react2.default.createElement(
	                'span',
	                { style: { background: 'white', padding: '10px', position: 'relative' } },
	                ' or '
	            )
	        );
	    };
	
	    return OrSeparator;
	}(_react.Component);
	
	exports.default = OrSeparator;

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _OrSeparator = __webpack_require__(1164);
	
	var _OrSeparator2 = _interopRequireDefault(_OrSeparator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _OrSeparator2.default;

/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.regionOptions = undefined;
	exports.map2Options = map2Options;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _RegionTooltip = __webpack_require__(1179);
	
	var _RegionTooltip2 = _interopRequireDefault(_RegionTooltip);
	
	var _regionsSorter = __webpack_require__(419);
	
	var _regionsSorter2 = _interopRequireDefault(_regionsSorter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RegionSelectorOfAppellate = function (_Component) {
	  _inherits(RegionSelectorOfAppellate, _Component);
	
	  function RegionSelectorOfAppellate() {
	    _classCallCheck(this, RegionSelectorOfAppellate);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  RegionSelectorOfAppellate.prototype.render = function render() {
	    var _this2 = this;
	
	    var regions = (0, _regionsSorter2.default)(map2Options(regionOptions));
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'region-selector-container' },
	      _react2.default.createElement(
	        'label',
	        { className: 'region-selector-label', htmlFor: 'region-selector' },
	        'Region: '
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'region-selector' },
	        _react2.default.createElement(_reactSelect2.default, {
	          name: 'form-field-name',
	          options: regions,
	          multi: true,
	          simpleValue: true,
	          value: this.props.filters.get('court_id'),
	          placeholder: 'All Courts',
	          onChange: function onChange(court_id) {
	            return _this2.props.onChange({ court_id: court_id || '' });
	          }
	        })
	      ),
	      _react2.default.createElement(_RegionTooltip2.default, null)
	    );
	  };
	
	  return RegionSelectorOfAppellate;
	}(_react.Component);
	
	RegionSelectorOfAppellate.defaultProps = {
	  onChange: function onChange() {}
	};
	
	RegionSelectorOfAppellate.propTypes = {
	  onChange: _propTypes2.default.func
	};
	
	// todo - wth lol, refactor all this
	function map2Options(mapOfOptions) {
	  return Object.keys(mapOfOptions).map(function (instance) {
	    return {
	      value: instance,
	      label: mapOfOptions[instance]
	    };
	  });
	}
	
	var regionOptions = exports.regionOptions = {
	  '01': 'First Circuit',
	  '02': 'Second Circuit',
	  '03': 'Third Circuit',
	  '04': 'Fourth Circuit',
	  '05': 'Fifth Circuit',
	  '06': 'Sixth Circuit',
	  '07': 'Seventh Circuit',
	  '08': 'Eighth Circuit',
	  '09': 'Ninth Circuit',
	  '10': 'Tenth Circuit',
	  '11': 'Eleventh Circuit',
	  'DC': 'District of Columbia',
	  'CAFC': 'Federal Circuit'
	};
	
	exports.default = RegionSelectorOfAppellate;

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _RegionSelectorOfAppellate = __webpack_require__(1166);
	
	var _RegionSelectorOfAppellate2 = _interopRequireDefault(_RegionSelectorOfAppellate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RegionSelectorOfAppellate2.default;

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(2181);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResultColumnHeadTextFormElement = function (_Component) {
	    _inherits(ResultColumnHeadTextFormElement, _Component);
	
	    function ResultColumnHeadTextFormElement() {
	        _classCallCheck(this, ResultColumnHeadTextFormElement);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    ResultColumnHeadTextFormElement.prototype.render = function render() {
	        var text = this.props.children;
	
	        return _react2.default.createElement('span', {
	            onClick: this.props.onClick,
	            className: 'result-column-head-text-form-element ' + (this.props.isSelected ? 'result-column-head-text-form-element-selected' : ''),
	            title: text,
	            dangerouslySetInnerHTML: { __html: text }
	        });
	    };
	
	    return ResultColumnHeadTextFormElement;
	}(_react.Component);
	
	ResultColumnHeadTextFormElement.propTypes = {
	    isSelected: _propTypes2.default.bool,
	    children: _propTypes2.default.string,
	    onClick: _propTypes2.default.func
	};
	
	ResultColumnHeadTextFormElement.defaultProps = {
	    isSelected: false,
	    children: '',
	    onClick: function onClick() {}
	};
	
	exports.default = ResultColumnHeadTextFormElement;

/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _ResultColumnHeadTextFormElement = __webpack_require__(1168);
	
	var _ResultColumnHeadTextFormElement2 = _interopRequireDefault(_ResultColumnHeadTextFormElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ResultColumnHeadTextFormElement2.default;

/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SearchType = __webpack_require__(684);
	
	var _SearchType2 = _interopRequireDefault(_SearchType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchTypesOfCaseLookup = function (_Component) {
	  _inherits(SearchTypesOfCaseLookup, _Component);
	
	  function SearchTypesOfCaseLookup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SearchTypesOfCaseLookup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getSearchTypeRadioButtons = function () {
	      return _this.props.listOfSearchTypes.map(function (type) {
	        return _react2.default.createElement(_SearchType2.default, {
	          formName: 'caseLookup',
	          key: type,
	          changeSearchType: _this.props.onChange,
	          isSelected: _this.props.selectedSearchType === type,
	          name: type
	        });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  SearchTypesOfCaseLookup.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { id: 'court_type_wrapper', style: { display: 'inline-block' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'form-item' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-radios' },
	          this.getSearchTypeRadioButtons()
	        )
	      ),
	      _react2.default.createElement('div', { className: 'clear' })
	    );
	  };
	
	  return SearchTypesOfCaseLookup;
	}(_react.Component);
	
	SearchTypesOfCaseLookup.propTypes = {
	  selectedSearchType: _propTypes2.default.string,
	  listOfSearchTypes: _propTypes2.default.array.isRequired,
	  onChange: _propTypes2.default.func
	};
	
	SearchTypesOfCaseLookup.defaultProps = {
	  selectedSearchType: 'Bankruptcy',
	  onChange: function onChange() {}
	};
	
	exports.default = SearchTypesOfCaseLookup;

/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _SearchTypesOfCaseLookup = __webpack_require__(1170);
	
	var _SearchTypesOfCaseLookup2 = _interopRequireDefault(_SearchTypesOfCaseLookup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SearchTypesOfCaseLookup2.default;

/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(2182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tip = function (_Component) {
	    _inherits(Tip, _Component);
	
	    function Tip() {
	        _classCallCheck(this, Tip);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    Tip.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'ir-cck-tip' },
	            _react2.default.createElement(
	                'h4',
	                null,
	                this.props.title
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'content' },
	                this.props.children
	            )
	        );
	    };
	
	    return Tip;
	}(_react.Component);
	
	Tip.defaultProps = {
	    title: ''
	};
	
	Tip.propTypes = {
	    title: _propTypes2.default.string,
	    children: _propTypes2.default.any
	    //   .oneOfType([
	    //   PropTypes.element,
	    //   PropTypes.string,
	    //   PropTypes.array
	    // ]),
	};
	
	exports.default = Tip;

/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _reactSelect = __webpack_require__(23);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _inputValidations = __webpack_require__(100);
	
	var _districtNosOptions = __webpack_require__(207);
	
	var _districtNosOptions2 = _interopRequireDefault(_districtNosOptions);
	
	__webpack_require__(2184);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function NOSSelector(_ref) {
	  var className = _ref.className,
	      filters = _ref.filters,
	      _onChange = _ref.onChange;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'nos-selector-container' },
	    _react2.default.createElement(
	      'label',
	      { className: 'nos-selector-label', htmlFor: 'nos-selector' },
	      'Nature of Suit:',
	      ' '
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: className },
	      _react2.default.createElement(_reactSelect2.default, {
	        name: 'nos-field-name',
	        options: _districtNosOptions2.default,
	        multi: true,
	        simpleValue: true,
	        value: filters.get('nos'),
	        placeholder: 'Select...',
	        onChange: function onChange(nos) {
	          return _onChange({ nos: nos || '' });
	        }
	      })
	    )
	  );
	}
	
	NOSSelector.propTypes = {
	  onChange: _propTypes2.default.func,
	  filters: _propTypes2.default.any.isRequired,
	  className: _propTypes2.default.string
	};
	
	NOSSelector.defaultProps = {
	  onChange: function onChange() {},
	  className: ''
	};
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return (0, _inputValidations.mapValidationFieldsToClassName)(state, 'nos', 'nos-selector');
	})(NOSSelector);

/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(13);
	
	var _inputValidations = __webpack_require__(100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SSN4 = function (_Component) {
	    _inherits(SSN4, _Component);
	
	    function SSN4() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, SSN4);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onChange = function () {
	            var value = _this.refs.ssn4.value;
	            _this.props.onChange({ ssn4: value });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    SSN4.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'ssn-item ssn-selector' },
	            _react2.default.createElement(
	                'label',
	                { htmlFor: 'ssn-last-four' },
	                'Four Digit SSN: '
	            ),
	            _react2.default.createElement('input', { type: 'text',
	                maxLength: '128',
	                id: 'ssn-last-four',
	                size: '4',
	                ref: 'ssn4',
	                onBlur: this.onChange,
	                className: this.props.className })
	        );
	    };
	
	    SSN4.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!nextProps.value) {
	            this.refs.ssn4.value = '';
	        }
	    };
	
	    return SSN4;
	}(_react.Component);
	
	function mapStateToProps(state) {
	    return {
	        className: (0, _inputValidations.mapValidationFieldsToClassName)(state, 'ssn4', 'input-search').className,
	        value: state.getIn(['pacerSearchResults', 'filters', 'ssn4'])
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(SSN4);

/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(13);
	
	var _inputValidations = __webpack_require__(100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SSNTin = function (_Component) {
	    _inherits(SSNTin, _Component);
	
	    function SSNTin() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, SSNTin);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onChange = function () {
	            var value = _this.refs.ssntin.value;
	            _this.props.onChange({ ssntin: value });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    SSNTin.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'ssn-item' },
	            _react2.default.createElement(
	                'label',
	                { htmlFor: 'ssn-tin' },
	                'SSN/TIN: '
	            ),
	            _react2.default.createElement('input', { type: 'text',
	                maxLength: '128',
	                id: 'ssn-tin',
	                size: '11',
	                ref: 'ssntin',
	                onBlur: this.onChange,
	                className: this.props.className })
	        );
	    };
	
	    SSNTin.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!nextProps.value) {
	            this.refs.ssntin.value = '';
	        }
	    };
	
	    return SSNTin;
	}(_react.Component);
	
	function mapStateToProps(state) {
	    return {
	        className: (0, _inputValidations.mapValidationFieldsToClassName)(state, 'ssntin', 'input-search').className,
	        value: state.getIn(['pacerSearchResults', 'filters', 'ssntin'])
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(SSNTin);

/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PopoverOfForm = __webpack_require__(203);
	
	var _PopoverOfForm2 = _interopRequireDefault(_PopoverOfForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //packages
	
	
	//form elements
	
	
	var NatureOfSuitTooltip = function (_Component) {
	    _inherits(NatureOfSuitTooltip, _Component);
	
	    function NatureOfSuitTooltip() {
	        _classCallCheck(this, NatureOfSuitTooltip);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    NatureOfSuitTooltip.prototype.render = function render() {
	        return _react2.default.createElement(
	            _PopoverOfForm2.default,
	            null,
	            _react2.default.createElement(
	                'p',
	                null,
	                'Leave this field blank (do not select any entries) in order to match all Nature of Suit codes. Otherwise, select the Nature of Suit you want to match from the drop down list. You can select multiple entries by holding down the Control key while clicking.'
	            )
	        );
	    };
	
	    return NatureOfSuitTooltip;
	}(_react.Component);
	
	exports.default = NatureOfSuitTooltip;

/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _NatureOfSuitTooltip = __webpack_require__(1176);
	
	var _NatureOfSuitTooltip2 = _interopRequireDefault(_NatureOfSuitTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _NatureOfSuitTooltip2.default;

/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PopoverOfForm = __webpack_require__(203);
	
	var _PopoverOfForm2 = _interopRequireDefault(_PopoverOfForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //packages
	
	
	//form elements
	
	
	var RegionTooltip = function (_Component) {
	    _inherits(RegionTooltip, _Component);
	
	    function RegionTooltip() {
	        _classCallCheck(this, RegionTooltip);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    RegionTooltip.prototype.render = function render() {
	        return _react2.default.createElement(
	            _PopoverOfForm2.default,
	            null,
	            _react2.default.createElement(
	                'p',
	                null,
	                'Select one or more regional areas to limit the scope of your search to those regions. '
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Select the region you want to search from the drop down list. You can select from the list of circuits or actual regions, such as "New Jersey." '
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'You may also select a state or Circuit from an interactive map. Click on the desired region and the selection list will be updated automatically. You can click on multiple regions and the selection list will add them. Click on any region a second time to unselect it.'
	            )
	        );
	    };
	
	    return RegionTooltip;
	}(_react.Component);
	
	exports.default = RegionTooltip;

/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _RegionTooltip = __webpack_require__(1178);
	
	var _RegionTooltip2 = _interopRequireDefault(_RegionTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RegionTooltip2.default;

/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PopoverOfForm = __webpack_require__(203);
	
	var _PopoverOfForm2 = _interopRequireDefault(_PopoverOfForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //packages
	
	
	//form elements
	
	
	var CaseTitleTooltip = function (_Component) {
	    _inherits(CaseTitleTooltip, _Component);
	
	    function CaseTitleTooltip() {
	        _classCallCheck(this, CaseTitleTooltip);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    CaseTitleTooltip.prototype.render = function render() {
	        return _react2.default.createElement(
	            _PopoverOfForm2.default,
	            null,
	            _react2.default.createElement(
	                'p',
	                null,
	                'To search for an individual party, use the name format: ',
	                _react2.default.createElement(
	                    'i',
	                    null,
	                    'last, first'
	                ),
	                ' A comma should be included to separate the last name and the first name.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'To search for a company, enter the company name'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Party Name searches are not case sensitive, so it doesn\'t matter if you enter any combination of lower or upper case letters.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'A search wildcard is assumed at the end of the search string. Use the \'*\' character to specify a wildcard in your search.'
	            )
	        );
	    };
	
	    return CaseTitleTooltip;
	}(_react.Component);
	
	exports.default = CaseTitleTooltip;

/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(13);
	
	var _SearchReceipt = __webpack_require__(416);
	
	var _SearchReceipt2 = _interopRequireDefault(_SearchReceipt);
	
	var _ResultsTable = __webpack_require__(1198);
	
	var _ResultsTable2 = _interopRequireDefault(_ResultsTable);
	
	var _Loading = __webpack_require__(81);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _NoResults = __webpack_require__(408);
	
	var _NoResults2 = _interopRequireDefault(_NoResults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //todo refactor this out
	
	
	var SearchResults = function (_Component) {
	  _inherits(SearchResults, _Component);
	
	  function SearchResults() {
	    _classCallCheck(this, SearchResults);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SearchResults.prototype.render = function render() {
	    var searchReceipts = this.props.pacerSearchResults.get('receipts').map(function (receipt, idx) {
	      return _react2.default.createElement(_SearchReceipt2.default, { key: idx, receipt: receipt });
	    });
	
	    var searchResultsType = this.props.pacerSearchResults.get('searchResultsType');
	
	    var hasValidReceipt = this.props.pacerSearchResults.get('receipts').filter(function (receipt) {
	      return !!receipt.getIn(['text', 'description']);
	    }).size > 0;
	
	    var results = searchResultsType == 'empty' ? hasValidReceipt && _react2.default.createElement(_NoResults2.default, null) : _react2.default.createElement(_ResultsTable2.default, null);
	
	    return _react2.default.createElement(
	      'div',
	      { id: 'pacer-search-results' },
	      _react2.default.createElement(
	        'div',
	        { className: 'ir-search-items' },
	        results,
	        _react2.default.createElement(_Loading2.default, null),
	        searchReceipts
	      )
	    );
	  };
	
	  return SearchResults;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    pacerSearchResults: state.get('pacerSearchResults')
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(SearchResults);

/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(13);
	
	var _NatureOfSuitOfAppellete = __webpack_require__(1163);
	
	var _NatureOfSuitOfAppellete2 = _interopRequireDefault(_NatureOfSuitOfAppellete);
	
	var _RegionSelectorOfAppellate = __webpack_require__(1167);
	
	var _RegionSelectorOfAppellate2 = _interopRequireDefault(_RegionSelectorOfAppellate);
	
	var _CaseNumberSelector = __webpack_require__(204);
	
	var _CaseNumberSelector2 = _interopRequireDefault(_CaseNumberSelector);
	
	var _CaseTitleSelector = __webpack_require__(205);
	
	var _CaseTitleSelector2 = _interopRequireDefault(_CaseTitleSelector);
	
	var _DateFilter = __webpack_require__(268);
	
	var _DateFilter2 = _interopRequireDefault(_DateFilter);
	
	var _PartySelector = __webpack_require__(269);
	
	var _PartySelector2 = _interopRequireDefault(_PartySelector);
	
	var _ActionButtons = __webpack_require__(267);
	
	var _ActionButtons2 = _interopRequireDefault(_ActionButtons);
	
	var _Collapsible = __webpack_require__(110);
	
	var _Collapsible2 = _interopRequireDefault(_Collapsible);
	
	var _AlertError = __webpack_require__(50);
	
	var _AlertError2 = _interopRequireDefault(_AlertError);
	
	var _pacerSearch = __webpack_require__(93);
	
	var _validations = __webpack_require__(137);
	
	var _validations2 = _interopRequireDefault(_validations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //packages
	
	
	//form elements
	
	
	//common
	
	
	//actions
	
	
	//validations
	
	
	var AppellateForm = function (_Component) {
	    _inherits(AppellateForm, _Component);
	
	    function AppellateForm(props) {
	        _classCallCheck(this, AppellateForm);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.changeSearchType = function (e) {
	            _this.props.actions.resetSearchResults();
	            _this.setState({ selectedSearchType: e.target.value });
	        };
	
	        _this.dateCollapseChanged = function (collapsible) {
	            _this.setState({ dateCollapsed: collapsible.isCollapsed });
	        };
	
	        _this.searchClickHandler = function () {
	            var validationErrors = _this.validateInputs(_this.props.filters);
	            if (validationErrors) {
	                _this.props.dispatch((0, _pacerSearch.receiveError)('VALIDATION_ERROR', validationErrors));
	            } else {
	                _this.props.actions.searchAppellates(_this.props.filters);
	            }
	        };
	
	        _this.componentDidMount = function () {
	            if (_this.props.immediateSearch) {
	                _this.searchClickHandler();
	            }
	        };
	
	        _this.state = {
	            dateCollapsed: true
	        };
	        return _this;
	    }
	
	    AppellateForm.prototype.validateInputs = function validateInputs(filtersMap) {
	        var filters = filtersMap.toJS();
	        if (!client_code_is_valid()) return { messages: ["Please set a valid client code first."] };
	
	        var messages = [];
	        var fields = [];
	
	        if (filters.last_name && !_validations2.default.PARTY_NAME_CASE_TITLE(filters.last_name)) {
	            messages.push('Invalid party name.');
	            fields.push('last_name');
	        }
	
	        if (filters.case_title && !_validations2.default.PARTY_NAME_CASE_TITLE(filters.case_title)) {
	            messages.push('Invalid case title.');
	            fields.push('case_title');
	        }
	
	        if (filters.case_no && !_validations2.default.CASE_NUMBER(filters.case_no)) {
	            messages.push('Invalid case number format.');
	            fields.push('case_no');
	        }
	
	        var desired_fields = ['case_no', 'case_title', 'last_name', 'filed_from', 'filed_to', 'closed_from', 'closed_to'];
	        var fieldNotEmpty = function fieldNotEmpty(fieldName) {
	            return !!filters[fieldName];
	        };
	        if (!desired_fields.find(fieldNotEmpty)) {
	            return {
	                messages: ["Please enter at least one search parameter:", "- Case number", "- Case title", "- Party name", "- Date Field"],
	                fields: desired_fields
	            };
	        }
	
	        return !_lodash2.default.isEmpty(messages) ? { messages: messages, fields: fields } : null;
	    };
	
	    AppellateForm.prototype.render = function render() {
	        var formElemProps = Object.assign({}, _extends({}, this.props), { onChange: this.props.updateFilter });
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'search-form-container' },
	            _react2.default.createElement(_RegionSelectorOfAppellate2.default, formElemProps),
	            _react2.default.createElement(_CaseNumberSelector2.default, formElemProps),
	            _react2.default.createElement(_CaseTitleSelector2.default, formElemProps),
	            _react2.default.createElement(_NatureOfSuitOfAppellete2.default, formElemProps),
	            _react2.default.createElement(
	                _Collapsible2.default,
	                { title: 'Date Filters', onChange: this.dateCollapseChanged },
	                _react2.default.createElement(_DateFilter2.default, _extends({}, formElemProps, { name: 'filed' })),
	                _react2.default.createElement(_DateFilter2.default, _extends({}, formElemProps, { name: 'closed' }))
	            ),
	            _react2.default.createElement(_PartySelector2.default, _extends({}, formElemProps, {
	                tooltipClassName: 'party-tooltip' + (!this.state.dateCollapsed ? ' top-70' : '') })),
	            _react2.default.createElement(_ActionButtons2.default, _extends({}, formElemProps, { searchClickHandler: this.searchClickHandler })),
	            _react2.default.createElement(_AlertError2.default, null)
	        );
	    };
	
	    return AppellateForm;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return { immediateSearch: state.get('immediateSearch') };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(AppellateForm);

/***/ },
/* 1183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _AppellateForm = __webpack_require__(1182);
	
	var _AppellateForm2 = _interopRequireDefault(_AppellateForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AppellateForm2.default;

/***/ },
/* 1184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _RegionSelector = __webpack_require__(270);
	
	var _RegionSelector2 = _interopRequireDefault(_RegionSelector);
	
	var _ChapterSelector = __webpack_require__(682);
	
	var _ChapterSelector2 = _interopRequireDefault(_ChapterSelector);
	
	var _CaseNumberSelector = __webpack_require__(204);
	
	var _CaseNumberSelector2 = _interopRequireDefault(_CaseNumberSelector);
	
	var _CaseTitleSelector = __webpack_require__(205);
	
	var _CaseTitleSelector2 = _interopRequireDefault(_CaseTitleSelector);
	
	var _PartySelector = __webpack_require__(269);
	
	var _PartySelector2 = _interopRequireDefault(_PartySelector);
	
	var _SSN = __webpack_require__(1174);
	
	var _SSN2 = _interopRequireDefault(_SSN);
	
	var _SSNTin = __webpack_require__(1175);
	
	var _SSNTin2 = _interopRequireDefault(_SSNTin);
	
	var _Collapsible = __webpack_require__(110);
	
	var _Collapsible2 = _interopRequireDefault(_Collapsible);
	
	var _AlertError = __webpack_require__(50);
	
	var _AlertError2 = _interopRequireDefault(_AlertError);
	
	var _DateFilter = __webpack_require__(268);
	
	var _DateFilter2 = _interopRequireDefault(_DateFilter);
	
	var _ActionButtons = __webpack_require__(267);
	
	var _ActionButtons2 = _interopRequireDefault(_ActionButtons);
	
	var _pacerSearch = __webpack_require__(93);
	
	var _validateLocalCourtsInputs = __webpack_require__(1185);
	
	var _validateLocalCourtsInputs2 = _interopRequireDefault(_validateLocalCourtsInputs);
	
	var _validations = __webpack_require__(137);
	
	var _validations2 = _interopRequireDefault(_validations);
	
	var _Tip = __webpack_require__(1172);
	
	var _Tip2 = _interopRequireDefault(_Tip);
	
	var _errorActionTypes = __webpack_require__(101);
	
	var errorConstants = _interopRequireWildcard(_errorActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BankruptcySearchForm = function (_Component) {
	  _inherits(BankruptcySearchForm, _Component);
	
	  function BankruptcySearchForm(props) {
	    _classCallCheck(this, BankruptcySearchForm);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.dateCollapseChanged = function (collapsible) {
	      _this.setState({ dateCollapsed: collapsible.isCollapsed });
	    };
	
	    _this.componentDidMount = function () {
	      if (_this.props.immediateSearch) {
	        _this.searchClickHandler();
	      }
	    };
	
	    _this.searchClickHandler = function () {
	      var validationErrors = _this.validateInputs(_this.props.filters);
	      if (validationErrors) {
	        _this.props.dispatch((0, _pacerSearch.receiveError)(errorConstants.VALIDATION_ERROR, validationErrors));
	      } else {
	        _this.props.actions.searchBankruptcies(_this.props.filters);
	      }
	    };
	
	    _this.searchBankruptciesLocalClickHandler = function () {
	      var validationErrors = (0, _validateLocalCourtsInputs2.default)(_this.props.filters);
	      if (validationErrors) {
	        return _this.props.dispatch((0, _pacerSearch.receiveError)('VALIDATION_ERROR', validationErrors));
	      }
	
	      _this.props.actions.searchBankruptciesLocal(_this.props.filters);
	    };
	
	    _this.state = {
	      dateCollapsed: true
	    };
	    return _this;
	  }
	
	  BankruptcySearchForm.prototype.validateInputs = function validateInputs(filtersMap) {
	    var filters = filtersMap.toJS();
	    if (!client_code_is_valid()) return { messages: ["Please set a valid client code first."] };
	
	    var messages = [];
	    var fields = [];
	
	    if (filters.last_name && !_validations2.default.PARTY_NAME_CASE_TITLE(filters.last_name)) {
	      messages.push('Invalid party name.');
	      fields.push('last_name');
	    }
	
	    if (filters.case_title && !_validations2.default.PARTY_NAME_CASE_TITLE(filters.case_title)) {
	      messages.push('Invalid case title.');
	      fields.push('case_title');
	    }
	
	    if (filters.case_no && !_validations2.default.CASE_NUMBER(filters.case_no)) {
	      messages.push('Invalid case number format.');
	      fields.push('case_no');
	    }
	
	    if (filters.ssn4) {
	      if (!_validations2.default.SSN4(filters.ssn4)) {
	        messages.push('Invalid last 4 digits of SSN/TIN.');
	        fields.push('ssn4');
	      }
	      if (_lodash2.default.isEmpty(filters.last_name)) {
	        messages.push('Party Name must be included when searching by 4 digit SSN.');
	        fields.push('last_name');
	      }
	    }
	
	    if (filters.ssntin && !_validations2.default.SSN_OR_TIN(filters.ssntin)) {
	      messages.push('Invalid SSN/TIN.');
	      fields.push('ssntin');
	    }
	
	    // return any errors found so far
	    if (!_lodash2.default.isEmpty(messages)) return { messages: messages, fields: fields };
	
	    // if no other errors to report, check if we have any fields filled in at all
	    var desired_fields = ['chapter', 'case_no', 'case_title', 'ssntin', 'last_name', 'filed_from', 'filed_to', 'closed_from', 'closed_to', 'dismissed_from', 'dismissed_to', 'discharged_from', 'discharged_to'];
	
	    var fieldNotEmpty = function fieldNotEmpty(fieldName) {
	      return !!filters[fieldName];
	    };
	    if (!desired_fields.find(fieldNotEmpty)) {
	      return {
	        messages: ["Please enter at least one search parameter:", "- Chapter", "- Case number", "- Case title", "- Party name", "- SSN/TIN", "- Date Field"],
	        fields: desired_fields
	      };
	    }
	  };
	
	  BankruptcySearchForm.prototype.render = function render() {
	    var formElemProps = Object.assign({}, _extends({}, this.props), { onChange: this.props.updateFilter });
	
	    var localValidationErrors = (0, _validateLocalCourtsInputs2.default)(this.props.filters);
	    var isLocalSearchAllowed = !localValidationErrors;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'search-form-container' },
	      _react2.default.createElement(
	        _Tip2.default,
	        { title: 'Using Local Court Search' },
	        _react2.default.createElement(
	          'p',
	          null,
	          '1. Select a single bankruptcy court (not a general area or circuit court).'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '2. Enter at least one of the following: case number, or party name, SSN, or date filter (you cannot search by case title).'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '3. Local Court Search, (unlike Pacer Search), is NOT subject to the 30-page limit so be careful to select criteria that is not too broad or general.'
	        )
	      ),
	      _react2.default.createElement(
	        'fieldset',
	        { className: 'ir-search-double' },
	        _react2.default.createElement(_RegionSelector2.default, formElemProps),
	        _react2.default.createElement(_ChapterSelector2.default, formElemProps)
	      ),
	      _react2.default.createElement(_CaseNumberSelector2.default, formElemProps),
	      _react2.default.createElement(_CaseTitleSelector2.default, formElemProps),
	      _react2.default.createElement(
	        _Collapsible2.default,
	        { title: 'Date Filters', onChange: this.dateCollapseChanged },
	        _react2.default.createElement(_DateFilter2.default, _extends({}, formElemProps, { name: 'filed' })),
	        _react2.default.createElement(_DateFilter2.default, _extends({}, formElemProps, { name: 'closed' })),
	        _react2.default.createElement(_DateFilter2.default, _extends({}, formElemProps, { name: 'dismissed' })),
	        _react2.default.createElement(_DateFilter2.default, _extends({}, formElemProps, { name: 'discharged' }))
	      ),
	      _react2.default.createElement(_PartySelector2.default, _extends({}, formElemProps, {
	        tooltipClassName: 'party-tooltip' + (!this.state.dateCollapsed ? ' top-70' : '')
	      })),
	      _react2.default.createElement(_SSN2.default, formElemProps),
	      _react2.default.createElement(_SSNTin2.default, formElemProps),
	      _react2.default.createElement(_ActionButtons2.default, _extends({}, formElemProps, {
	        searchType: this.props.searchType,
	        searchClickHandler: this.searchClickHandler,
	        isLocalSearchAllowed: isLocalSearchAllowed,
	        localSearchClickHandler: this.searchBankruptciesLocalClickHandler
	      })),
	      isLocalSearchAllowed && _react2.default.createElement(
	        'div',
	        { className: 'warning' },
	        'By pressing on the "Local Court Search" button you will be billed for the total number of pages (this report is not subject to the 30-page limit on PACER charges).'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(_AlertError2.default, null)
	    );
	  };
	
	  return BankruptcySearchForm;
	}(_react.Component);
	
	BankruptcySearchForm.propTypes = {
	  searchType: _propTypes2.default.string
	};
	
	BankruptcySearchForm.defaultProps = {
	  searchType: 'bottom'
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return { immediateSearch: state.get('immediateSearch') };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(BankruptcySearchForm);

/***/ },
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = validateLocalCourtsInputs;
	
	var _immutable = __webpack_require__(30);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _moment = __webpack_require__(32);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _regionOptionsOfBankruptcySearchFormMap = __webpack_require__(702);
	
	var _regionOptionsOfBankruptcySearchFormMap2 = _interopRequireDefault(_regionOptionsOfBankruptcySearchFormMap);
	
	var _validations = __webpack_require__(137);
	
	var _validations2 = _interopRequireDefault(_validations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validateLocalCourtsInputs(filtersMap) {
	  if (!client_code_is_valid()) {
	    return {
	      messages: ['Please set a valid client code first.']
	    };
	  }
	
	  // Check if only allowed fields are entered
	  var allowedFields = _immutable2.default.Set(['case_no', 'court_id', 'filed_from', 'filed_to', 'last_business_name', 'first_name', 'middle_name', 'party_name', 'ssntin', 'case_type']);
	
	  var extraFields = filtersMap.filter(function (value) {
	    return !!value;
	  }).keySeq().toSet().subtract(allowedFields);
	  if (!extraFields.isEmpty()) {
	    return {
	      messages: ['Local search accepts only Case Number, SSN, Party Name and Date Filed Filters.'],
	      fields: extraFields.toJS()
	    };
	  }
	
	  // extract fields into variables for convenience
	
	  var _filtersMap$toJS = filtersMap.toJS(),
	      court_id = _filtersMap$toJS.court_id,
	      case_no = _filtersMap$toJS.case_no,
	      ssntin = _filtersMap$toJS.ssntin,
	      last_business_name = _filtersMap$toJS.last_business_name,
	      first_name = _filtersMap$toJS.first_name,
	      filed_from = _filtersMap$toJS.filed_from,
	      filed_to = _filtersMap$toJS.filed_to,
	      party_name = _filtersMap$toJS.party_name;
	
	  var messages = [];
	  var fields = [];
	
	  // Validate data of individual fields ---------------------------------------
	  if (noneOrMoreThanOneRegionSelected(court_id)) {
	    return {
	      messages: ['Please select exactly one bankruptcy court for region.'],
	      fields: ['court_id']
	    };
	  }
	
	  if (!specificCourtSelected(court_id)) {
	    return {
	      messages: ['Selected region can\'t be a Circuit and it has to be specific instead of catchall.'],
	      fields: ['court_id']
	    };
	  }
	
	  if (ssntin && !_validations2.default.SSN_OR_TIN(ssntin)) {
	    messages.push('Invalid SSN/TIN.');
	    fields.push('ssntin');
	  }
	
	  if (party_name && !_validations2.default.PARTY_NAME_CASE_TITLE(party_name)) {
	    messages.push('Invalid party name.');
	    fields.push('party_name');
	  }
	
	  // Fail right away if any fields contain invalid data
	  if (messages.length > 0) return { messages: messages, fields: fields };
	
	  // Validate Input field combinations ----------------------------------------
	  // case_no is good enough
	  if (case_no) return;
	  // SSN is good enough
	  if (ssntin) return;
	  // Last and first ok
	  if (last_business_name && first_name) return;
	  // Last and small enough date range is OK
	  if (last_business_name && isDateRange1WeekOrLess(filed_from, filed_to)) return;
	  // 1 week date range
	  if (isDateRange1WeekOrLess(filed_from, filed_to)) return;
	
	  if (filed_from && !isDateRange1WeekOrLess(filed_from, filed_to)) {
	    return {
	      messages: ['Date range must be no greater than 1 Week'],
	      fields: ['filed_from', 'filed_to']
	    };
	  }
	
	  if (last_business_name && !first_name && !isDateRange1WeekOrLess(filed_from, filed_to)) {
	    return {
	      messages: ['Last / Business Name requires First name or Date Filed Range not greater than 1 week'],
	      fields: ['first_name', 'filed_from', 'filed_to']
	    };
	  }
	
	  return {
	    messages: ['Please enter at least one combination:', '- Case Number', '- Last Name and First Name', '- Last / Business Name and Date Filed Range not greater than 1 week', '- SSN/TIN', '- Date Filed Range not greater than 1 week'],
	    fields: ['last_business_name', 'first_name', 'filed_from', 'filed_to', 'ssntin']
	  };
	}
	
	function noneOrMoreThanOneRegionSelected(court_id) {
	  return !court_id || /,/.test(court_id);
	}
	
	function specificCourtSelected(court_id) {
	  if (!court_id) return false;
	  var regionOptionsOfBankruptcySearchFormMapList = _lodash2.default.map(_regionOptionsOfBankruptcySearchFormMap2.default);
	  var regionName = _regionOptionsOfBankruptcySearchFormMap2.default[court_id];
	  if (court_id.split(',').length > 1 || /Circuit/i.test(regionName)) {
	    return false;
	  }
	  for (var key in regionOptionsOfBankruptcySearchFormMapList) {
	    var regionNameRegExp = new RegExp(regionName, 'g');
	    var instanceOfRegionNames = regionOptionsOfBankruptcySearchFormMapList[key];
	    if (instanceOfRegionNames !== regionName && regionNameRegExp.test(instanceOfRegionNames)) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function isDateRange1WeekOrLess(filed_from, filed_to) {
	  // definitely not less than 1 week if not filled in
	  if (!filed_from) return false;
	
	  // since nothing can be filed in the future,
	  // we consider blank filedTo to be same as TODAY()
	  var endDate = filed_to || (0, _moment2.default)();
	
	  return endDate.diff(filed_from, 'weeks', true) <= 1.0;
	}

/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(13);
	
	var _RegionSelector = __webpack_require__(270);
	
	var _RegionSelector2 = _interopRequireDefault(_RegionSelector);
	
	var _CaseNumberSelector = __webpack_require__(204);
	
	var _CaseNumberSelector2 = _interopRequireDefault(_CaseNumberSelector);
	
	var _CaseTitleSelector = __webpack_require__(205);
	
	var _CaseTitleSelector2 = _interopRequireDefault(_CaseTitleSelector);
	
	var _DateFilter = __webpack_require__(268);
	
	var _DateFilter2 = _interopRequireDefault(_DateFilter);
	
	var _NOSSelector = __webpack_require__(1173);
	
	var _NOSSelector2 = _interopRequireDefault(_NOSSelector);
	
	var _PartySelector = __webpack_require__(269);
	
	var _PartySelector2 = _interopRequireDefault(_PartySelector);
	
	var _ActionButtons = __webpack_require__(267);
	
	var _ActionButtons2 = _interopRequireDefault(_ActionButtons);
	
	var _Collapsible = __webpack_require__(110);
	
	var _Collapsible2 = _interopRequireDefault(_Collapsible);
	
	var _AlertError = __webpack_require__(50);
	
	var _AlertError2 = _interopRequireDefault(_AlertError);
	
	var _pacerSearch = __webpack_require__(93);
	
	var _validations = __webpack_require__(137);
	
	var _validations2 = _interopRequireDefault(_validations);
	
	var _errorActionTypes = __webpack_require__(101);
	
	var errorConstants = _interopRequireWildcard(_errorActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CivilSearchForm = function (_Component) {
	    _inherits(CivilSearchForm, _Component);
	
	    function CivilSearchForm(props) {
	        _classCallCheck(this, CivilSearchForm);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.changeSearchType = function (e) {
	            _this.props.actions.resetSearchResults();
	            _this.setState({ selectedSearchType: e.target.value });
	        };
	
	        _this.dateCollapseChanged = function (collapsible) {
	            _this.setState({ dateCollapsed: collapsible.isCollapsed });
	        };
	
	        _this.searchClickHandler = function () {
	            var validationErrors = _this.validateInputs(_this.props.filters);
	            if (validationErrors) {
	                _this.props.dispatch((0, _pacerSearch.receiveError)(errorConstants.VALIDATION_ERROR, validationErrors));
	            } else {
	                _this.props.actions.searchCivil(_this.props.filters);
	            }
	        };
	
	        _this.regionOptions = _RegionSelector.defaultRegionOptions.concat([{ value: 'COF', label: 'Federal Claims' }, { value: 'CIT', label: 'US International Trade' }]);
	
	        _this.componentDidMount = function () {
	            if (_this.props.immediateSearch) {
	                _this.searchClickHandler();
	            }
	        };
	
	        _this.state = {
	            dateCollapsed: true
	        };
	        return _this;
	    }
	
	    CivilSearchForm.prototype.validateInputs = function validateInputs(filtersMap) {
	        var filters = filtersMap.toJS();
	        if (!client_code_is_valid()) return { messages: ["Please set a valid client code first."] };
	
	        var messages = [];
	        var fields = [];
	
	        if (filters.last_name && !_validations2.default.PARTY_NAME_CASE_TITLE(filters.last_name)) {
	            messages.push('Invalid party name.');
	            fields.push('last_name');
	        }
	
	        if (filters.case_title && !_validations2.default.PARTY_NAME_CASE_TITLE(filters.case_title)) {
	            messages.push('Invalid case title.');
	            fields.push('case_title');
	        }
	
	        if (filters.case_no && !_validations2.default.CASE_NUMBER(filters.case_no)) {
	            messages.push('Invalid case number format.');
	            fields.push('case_no');
	        }
	
	        var desired_fields = ['case_no', 'case_title', 'last_name', 'filed_from', 'filed_to', 'closed_from', 'closed_to'];
	        var fieldNotEmpty = function fieldNotEmpty(fieldName) {
	            return !!filters[fieldName];
	        };
	        if (!desired_fields.find(fieldNotEmpty)) {
	            return {
	                messages: ["Please enter at least one search parameter:", "- Case number", "- Case title", "- Party name", "- Date Field"],
	                fields: desired_fields
	            };
	        }
	
	        return !_lodash2.default.isEmpty(messages) ? { messages: messages, fields: fields } : null;
	    };
	
	    CivilSearchForm.prototype.render = function render() {
	        var formElemProps = Object.assign({}, _extends({}, this.props), { onChange: this.props.updateFilter });
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'search-form-container' },
	            _react2.default.createElement(
	                'fieldset',
	                { className: 'ir-search-double' },
	                _react2.default.createElement(_RegionSelector2.default, _extends({}, formElemProps, { regionOptions: this.regionOptions }))
	            ),
	            _react2.default.createElement(_CaseNumberSelector2.default, formElemProps),
	            _react2.default.createElement(_CaseTitleSelector2.default, formElemProps),
	            _react2.default.createElement(_NOSSelector2.default, formElemProps),
	            _react2.default.createElement('div', null),
	            _react2.default.createElement(
	                _Collapsible2.default,
	                { title: 'Date Filters', onChange: this.dateCollapseChanged },
	                _react2.default.createElement(_DateFilter2.default, _extends({}, formElemProps, { name: 'filed' })),
	                _react2.default.createElement(_DateFilter2.default, _extends({}, formElemProps, { name: 'closed' }))
	            ),
	            _react2.default.createElement(_PartySelector2.default, _extends({}, formElemProps, {
	                tooltipClassName: 'party-tooltip' + (!this.state.dateCollapsed ? ' top-55' : '') })),
	            _react2.default.createElement(_ActionButtons2.default, _extends({}, formElemProps, { searchClickHandler: this.searchClickHandler })),
	            _react2.default.createElement(_AlertError2.default, null)
	        );
	    };
	
	    return CivilSearchForm;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return { immediateSearch: state.get('immediateSearch') };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(CivilSearchForm);

/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(13);
	
	var _RegionSelector = __webpack_require__(270);
	
	var _RegionSelector2 = _interopRequireDefault(_RegionSelector);
	
	var _ChapterSelector = __webpack_require__(682);
	
	var _ChapterSelector2 = _interopRequireDefault(_ChapterSelector);
	
	var _CaseNumberSelector = __webpack_require__(204);
	
	var _CaseNumberSelector2 = _interopRequireDefault(_CaseNumberSelector);
	
	var _CaseTitleSelector = __webpack_require__(205);
	
	var _CaseTitleSelector2 = _interopRequireDefault(_CaseTitleSelector);
	
	var _DateFilter = __webpack_require__(268);
	
	var _DateFilter2 = _interopRequireDefault(_DateFilter);
	
	var _PartySelector = __webpack_require__(269);
	
	var _PartySelector2 = _interopRequireDefault(_PartySelector);
	
	var _ActionButtons = __webpack_require__(267);
	
	var _ActionButtons2 = _interopRequireDefault(_ActionButtons);
	
	var _Collapsible = __webpack_require__(110);
	
	var _Collapsible2 = _interopRequireDefault(_Collapsible);
	
	var _AlertError = __webpack_require__(50);
	
	var _AlertError2 = _interopRequireDefault(_AlertError);
	
	var _pacerSearch = __webpack_require__(93);
	
	var _inputValidations = __webpack_require__(100);
	
	var _validations = __webpack_require__(137);
	
	var _validations2 = _interopRequireDefault(_validations);
	
	var _errorActionTypes = __webpack_require__(101);
	
	var errorConstants = _interopRequireWildcard(_errorActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CriminalSearchForm = function (_Component) {
	    _inherits(CriminalSearchForm, _Component);
	
	    function CriminalSearchForm(props) {
	        _classCallCheck(this, CriminalSearchForm);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.changeSearchType = function (e) {
	            _this.props.actions.resetSearchResults();
	            _this.setState({ selectedSearchType: e.target.value });
	        };
	
	        _this.dateCollapseChanged = function (collapsible) {
	            _this.setState({ dateCollapsed: collapsible.isCollapsed });
	        };
	
	        _this.validateInputs = function (filtersMap) {
	            var filters = filtersMap.toJS();
	            if (!client_code_is_valid()) return { messages: ["Please set a valid client code first."] };
	
	            var messages = [];
	            var fields = [];
	
	            if (filters.last_name && !_validations2.default.PARTY_NAME_CASE_TITLE(filters.last_name)) {
	                messages.push('Invalid party name.');
	                fields.push('last_name');
	            }
	
	            if (filters.case_title && !_validations2.default.PARTY_NAME_CASE_TITLE(filters.case_title)) {
	                messages.push('Invalid case title.');
	                fields.push('case_title');
	            }
	
	            if (filters.case_no && !_validations2.default.CASE_NUMBER(filters.case_no)) {
	                messages.push('Invalid case number format.');
	                fields.push('case_no');
	            }
	
	            var desired_fields = ['case_no', 'case_title', 'last_name', 'filed_from', 'filed_to', 'closed_from', 'closed_to'];
	            var fieldNotEmpty = function fieldNotEmpty(fieldName) {
	                return !!filters[fieldName];
	            };
	            if (!desired_fields.find(fieldNotEmpty)) {
	                return {
	                    messages: ["Please enter at least one search parameter:", "- Case number", "- Case title", "- Party name", "- Date Field"],
	                    fields: desired_fields
	                };
	            }
	
	            return !_lodash2.default.isEmpty(messages) ? { messages: messages, fields: fields } : null;
	        };
	
	        _this.searchClickHandler = function () {
	            var validationErrors = _this.validateInputs(_this.props.filters);
	            if (validationErrors) {
	                _this.props.dispatch((0, _pacerSearch.receiveError)(errorConstants.VALIDATION_ERROR, validationErrors));
	            } else {
	                _this.props.actions.searchCriminal(_this.props.filters);
	            }
	        };
	
	        _this.componentDidMount = function () {
	            if (_this.props.immediateSearch) {
	                _this.searchClickHandler();
	            }
	        };
	
	        _this.state = {
	            dateCollapsed: true
	        };
	        return _this;
	    }
	
	    CriminalSearchForm.prototype.render = function render() {
	        var formElemProps = Object.assign({}, _extends({}, this.props), { onChange: this.props.updateFilter });
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'search-form-container' },
	            _react2.default.createElement(
	                'fieldset',
	                { className: 'ir-search-double' },
	                _react2.default.createElement(_RegionSelector2.default, formElemProps)
	            ),
	            _react2.default.createElement(_CaseNumberSelector2.default, formElemProps),
	            _react2.default.createElement(_CaseTitleSelector2.default, formElemProps),
	            _react2.default.createElement(
	                _Collapsible2.default,
	                { title: 'Date Filters', onChange: this.dateCollapseChanged },
	                _react2.default.createElement(_DateFilter2.default, _extends({}, formElemProps, { name: 'filed' })),
	                _react2.default.createElement(_DateFilter2.default, _extends({}, formElemProps, { name: 'closed' }))
	            ),
	            _react2.default.createElement(_PartySelector2.default, _extends({}, formElemProps, { tooltipClassName: 'party-tooltip' + (!this.state.dateCollapsed ? ' top-55' : '') })),
	            _react2.default.createElement(_ActionButtons2.default, _extends({}, formElemProps, { searchClickHandler: this.searchClickHandler })),
	            _react2.default.createElement(_AlertError2.default, null)
	        );
	    };
	
	    return CriminalSearchForm;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return { immediateSearch: state.get('immediateSearch') };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(CriminalSearchForm);

/***/ },
/* 1188 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _AppellateForm = __webpack_require__(411);
	
	var _Notification = __webpack_require__(40);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Fillings/LocalCourtSearch/Forms/Appellate', module).add('View', function () {
	  return _react2.default.createElement(_AppellateForm.AppellateForm, {
	    onSubmit: (0, _addonActions.action)('searchAppellate'),
	    onClickSearchReset: (0, _addonActions.action)('resetLocalSearch')
	  });
	}).add('Search error', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Notification2.default, null),
	    _react2.default.createElement(_AppellateForm.AppellateForm, {
	      onSubmit: function onSubmit() {
	        _Notification.notify.error('Failed to search Appellate Local Court');
	        (0, _addonActions.action)('searchAppellate').apply(undefined, arguments);
	      },
	      onClickSearchReset: (0, _addonActions.action)('resetLocalSearch')
	    })
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _BankruptcyForm = __webpack_require__(412);
	
	var _Notification = __webpack_require__(40);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Fillings/LocalCourtSearch/Forms/Bankruptcy', module).add('View', function () {
	  return _react2.default.createElement(_BankruptcyForm.BankruptcyForm, {
	    onSubmit: (0, _addonActions.action)('searchBankruptcy'),
	    onClickSearchReset: (0, _addonActions.action)('resetLocalSearch')
	  });
	}).add('Search error', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Notification2.default, null),
	    _react2.default.createElement(_BankruptcyForm.BankruptcyForm, {
	      onSubmit: function onSubmit() {
	        _Notification.notify.error('Failed to search Bankruptcy Local Court');
	        (0, _addonActions.action)('searchAppellate').apply(undefined, arguments);
	      },
	      onClickSearchReset: (0, _addonActions.action)('resetLocalSearch')
	    })
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1190 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _CivilForm = __webpack_require__(413);
	
	var _Notification = __webpack_require__(40);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Fillings/LocalCourtSearch/Forms/Civil & Criminal', module).add('View', function () {
	  return _react2.default.createElement(_CivilForm.CivilForm, {
	    onSubmit: (0, _addonActions.action)('searchDistrict'),
	    onClickSearchReset: (0, _addonActions.action)('resetLocalSearch')
	  });
	}).add('Search error', function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Notification2.default, null),
	    _react2.default.createElement(_CivilForm.CivilForm, {
	      onSubmit: function onSubmit() {
	        _Notification.notify.error('Failed to search District Local Court');
	        (0, _addonActions.action)('searchAppellate').apply(undefined, arguments);
	      },
	      onClickSearchReset: (0, _addonActions.action)('resetLocalSearch')
	    })
	  );
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _LocalCourtResults = __webpack_require__(414);
	
	var _LocalCourtResults2 = _interopRequireDefault(_LocalCourtResults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Fillings/LocalCourtSearch/ResultsTable/Cases', module).add('Bankruptcy', function () {
	  return _react2.default.createElement(_LocalCourtResults2.default, {
	    data: cases,
	    searchResultsType: 'cases',
	    searchType: 'Bankruptcy'
	  });
	}).add('Civil, Criminal, Appellate', function () {
	  return _react2.default.createElement(_LocalCourtResults2.default, {
	    data: cases,
	    searchResultsType: 'cases',
	    searchType: 'Civil'
	  });
	});
	
	(0, _react3.storiesOf)('Fillings/LocalCourtSearch/ResultsTable/Parties', module).add('Bankruptcy', function () {
	  return _react2.default.createElement(_LocalCourtResults2.default, {
	    data: parties,
	    searchResultsType: 'parties',
	    searchType: 'Bankruptcy'
	  });
	}).add('Civil, Criminal, Appellate', function () {
	  return _react2.default.createElement(_LocalCourtResults2.default, {
	    data: parties,
	    searchResultsType: 'parties',
	    searchType: 'Civil'
	  });
	});
	
	var cases = [{
	  case_title: 'SAMPLE v. ABC',
	  court_code: 'azbtest',
	  case_no: '2:10-ap-00020',
	  chapter: '7',
	  date_filed: '01/01/20019',
	  date_closed: null,
	  nos: ''
	}];
	
	var parties = [{
	  party_name: 'SAMPLE, FINAL',
	  party_role: 'Plaintiff',
	  court_code: 'azbtest',
	  case_no: '2:10-ap-00020',
	  chapter: '7',
	  date_filed: '01/01/20019',
	  date_closed: null,
	  nos: ''
	}];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1192 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BankruptcyCasesRow = function BankruptcyCasesRow(_ref) {
	    var meta = _ref.meta;
	    return _react2.default.createElement(
	        "tr",
	        null,
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.case_title
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.court_code
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: "ir-search-no-wrap" },
	            _react2.default.createElement(
	                "a",
	                { href: "/filings/" + meta.case_uuid, target: "_blank" },
	                meta.case_no
	            )
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.chapter
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.date_filed
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.date_closed
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.disposition
	        )
	    );
	};
	
	exports.default = BankruptcyCasesRow;

/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BankruptcyPartiesRow = function BankruptcyPartiesRow(_ref) {
	    var meta = _ref.meta;
	    return _react2.default.createElement(
	        "tr",
	        { className: "bankruptcy-parties-row" },
	        _react2.default.createElement(
	            "td",
	            { className: "party_name" },
	            meta.party_name
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.party_role
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.court_code
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: "ir-search-no-wrap" },
	            _react2.default.createElement(
	                "a",
	                { href: "/filings/" + meta.case_uuid, target: "_blank" },
	                meta.case_no
	            )
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.chapter
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.date_filed
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.date_closed
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: "disposition" },
	            meta.disposition
	        )
	    );
	};
	
	exports.default = BankruptcyPartiesRow;

/***/ },
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CivilCasesRow = function CivilCasesRow(_ref) {
	    var meta = _ref.meta;
	    return _react2.default.createElement(
	        "tr",
	        null,
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.case_title
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.court_code
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: "ir-search-no-wrap" },
	            _react2.default.createElement(
	                "a",
	                { href: "/filings/" + meta.case_uuid, target: "_blank" },
	                meta.case_no
	            )
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.nature_of_suit_code
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.date_filed
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.date_closed
	        )
	    );
	};
	
	exports.default = CivilCasesRow;

/***/ },
/* 1195 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CivilPartiesRow = function CivilPartiesRow(_ref) {
	    var meta = _ref.meta;
	    return _react2.default.createElement(
	        "tr",
	        null,
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.party_name
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.party_role
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.court_code
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: "ir-search-no-wrap" },
	            _react2.default.createElement(
	                "a",
	                { href: "/filings/" + meta.case_uuid, target: "_blank" },
	                meta.case_no
	            )
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.nature_of_suit_code
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.date_filed
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.date_closed
	        )
	    );
	};
	
	exports.default = CivilPartiesRow;

/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CriminalCasesRow = function CriminalCasesRow(_ref) {
	    var meta = _ref.meta;
	    return _react2.default.createElement(
	        "tr",
	        null,
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.case_title
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.court_code
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: "ir-search-no-wrap" },
	            _react2.default.createElement(
	                "a",
	                { href: "/filings/" + meta.case_uuid, target: "_blank" },
	                meta.case_no
	            )
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.date_filed
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.date_closed
	        )
	    );
	};
	
	exports.default = CriminalCasesRow;

/***/ },
/* 1197 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CriminalPartiesRow = function CriminalPartiesRow(_ref) {
	    var meta = _ref.meta;
	    return _react2.default.createElement(
	        "tr",
	        null,
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.party_name
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.party_role
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.court_code
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: "ir-search-no-wrap" },
	            _react2.default.createElement(
	                "a",
	                { href: "/filings/" + meta.case_uuid, target: "_blank" },
	                meta.case_no
	            )
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.date_filed
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.date_closed
	        )
	    );
	};
	
	exports.default = CriminalPartiesRow;

/***/ },
/* 1198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(13);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _immutable = __webpack_require__(30);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _PaginatorItem = __webpack_require__(683);
	
	var _PaginatorItem2 = _interopRequireDefault(_PaginatorItem);
	
	var _SortArrow = __webpack_require__(1156);
	
	var _SortArrow2 = _interopRequireDefault(_SortArrow);
	
	var _NoResults = __webpack_require__(408);
	
	var _NoResults2 = _interopRequireDefault(_NoResults);
	
	var _pacerSearch = __webpack_require__(93);
	
	var _NatureOfSuitPartiesRow = __webpack_require__(1200);
	
	var _NatureOfSuitPartiesRow2 = _interopRequireDefault(_NatureOfSuitPartiesRow);
	
	var _NatureOfSuitCasesRow = __webpack_require__(1199);
	
	var _NatureOfSuitCasesRow2 = _interopRequireDefault(_NatureOfSuitCasesRow);
	
	var _BankruptcyPartiesRow = __webpack_require__(1193);
	
	var _BankruptcyPartiesRow2 = _interopRequireDefault(_BankruptcyPartiesRow);
	
	var _BankruptcyCasesRow = __webpack_require__(1192);
	
	var _BankruptcyCasesRow2 = _interopRequireDefault(_BankruptcyCasesRow);
	
	var _CriminalPartiesRow = __webpack_require__(1197);
	
	var _CriminalPartiesRow2 = _interopRequireDefault(_CriminalPartiesRow);
	
	var _CriminalCasesRow = __webpack_require__(1196);
	
	var _CriminalCasesRow2 = _interopRequireDefault(_CriminalCasesRow);
	
	var _CivilPartiesRow = __webpack_require__(1195);
	
	var _CivilPartiesRow2 = _interopRequireDefault(_CivilPartiesRow);
	
	var _CivilCasesRow = __webpack_require__(1194);
	
	var _CivilCasesRow2 = _interopRequireDefault(_CivilCasesRow);
	
	__webpack_require__(2194);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	//packages
	
	
	//form elements
	
	
	//common
	
	
	//actions
	
	
	//rows
	
	
	//styles
	
	
	var ResultsTable = function (_Component) {
	    _inherits(ResultsTable, _Component);
	
	    function ResultsTable(props) {
	        _classCallCheck(this, ResultsTable);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.findHeaderFieldBy = function (key, value) {
	            return _this.props.pacerSearchResults.get('headerFields').find(function (field) {
	                return field.get(key) == value;
	            }).toJS() || {};
	        };
	
	        _this.clickSort = function (field) {
	            var sortState = {
	                activeField: _this.findHeaderFieldBy('name', field.name),
	                isReverse: _this.state.activeField.name === field.name ? +!_this.state.isReverse : 0
	            };
	
	            _this.setState(sortState, _this.doPagingSorting);
	        };
	
	        _this.clickPage = function (page) {
	            var p = parseInt(page, 10);
	            _this.setState({ currentPage: p }, _this.doPagingSorting);
	        };
	
	        var active = props.pacerSearchResults.getIn(['searchOptions', 'sort', 'active']);
	
	        _this.state = {
	            activeField: active ? _this.findHeaderFieldBy('key', active.get('field')) : 'Case Title',
	            isReverse: active ? active.get('isReverse') : false,
	            currentPage: 1
	        };
	        return _this;
	    }
	
	    ResultsTable.prototype.doPagingSorting = function doPagingSorting() {
	        var params = this.props.filters.merge({
	            page: this.state.currentPage,
	            sort: this.state
	        });
	        this.props.dispatch((0, _pacerSearch.searchView)(params));
	    };
	
	    ResultsTable.prototype.render = function render() {
	        var _this2 = this;
	
	        var searchResultsType = this.props.pacerSearchResults.get('searchResultsType');
	
	        if (searchResultsType == 'empty') return _react2.default.createElement(_NoResults2.default, null);
	
	        var pacerSearchResults = this.props.pacerSearchResults;
	        var pages = pacerSearchResults.getIn(['searchOptions', 'pages']) || null;
	        var paginatorItems = null;
	        var previous = null;
	
	        //TODO abstract this all into the reducer (except jsx markup code)
	        if (!_lodash2.default.isEmpty(pages)) {
	            pages = pages.toJS();
	            pages = _lodash2.default.sortBy(pages, 'page');
	            var page = _lodash2.default.findIndex(pages, { page: this.state.currentPage });
	
	            if (page > -1) {
	                pages[page] = Object.assign({}, pages[page], { active: true, url: "" });
	            } else {
	                pages.splice(this.state.currentPage - 1, 0, { active: true, url: "", page: this.state.currentPage });
	            }
	
	            var prevIdx = _lodash2.default.findIndex(pages, { page: 'Previous' });
	            if (prevIdx > -1) {
	                var prev = pages.splice(prevIdx, 1)[0];
	                pages.unshift(prev); //previous is always first element
	            } else {
	                previous = _react2.default.createElement(
	                    'li',
	                    { className: 'pager-previous first' },
	                    'Previous'
	                );
	            }
	
	            //todo - this is overly complicated.  Refactor and move to separate mapper
	            paginatorItems = pages.reduce(function (prev, next, idx) {
	                var prevIdx = prev.idx;
	                var prevPages = prev.pages;
	                if (prevIdx > 0 && prevPages[prevIdx - 1].page !== 'ellipse' && next.page - prevPages[prevIdx - 1].page > 1) {
	                    prevIdx++;
	                    prev.pages.push({ page: 'ellipse' });
	                }
	
	                prevIdx++;
	                prev.idx = prevIdx;
	                prev.pages.push(next);
	
	                return prev;
	            }, { pages: [], idx: 0 });
	
	            paginatorItems = paginatorItems.pages.map(function (item) {
	                if (item.page == 'ellipse') {
	                    return _react2.default.createElement(
	                        'span',
	                        null,
	                        '...'
	                    );
	                }
	                return _react2.default.createElement(_PaginatorItem2.default, { item: item, clickPage: _this2.clickPage });
	            });
	        }
	
	        var data = this.props.pacerSearchResults.get('data') ? this.props.pacerSearchResults.get('data').toJS() : [];
	
	        var RowRenderer = {
	            parties: {
	                Bankruptcy: _BankruptcyPartiesRow2.default,
	                Civil: _CivilPartiesRow2.default,
	                Criminal: _CriminalPartiesRow2.default,
	                Appellate: _NatureOfSuitPartiesRow2.default
	            },
	            cases: {
	                Bankruptcy: _BankruptcyCasesRow2.default,
	                Civil: _CivilCasesRow2.default,
	                Criminal: _CriminalCasesRow2.default,
	                Appellate: _NatureOfSuitCasesRow2.default
	            }
	        }[searchResultsType][this.props.pacerSearchResults.get('searchType')];
	
	        var caseResults = this.props.pacerSearchResults.get('data').toJS().map(function (result, idx) {
	            return _react2.default.createElement(RowRenderer, { key: idx, meta: result.meta });
	        });
	
	        var availableSortFields = pacerSearchResults.getIn(['searchOptions', 'sort', 'available']);
	        availableSortFields = availableSortFields ? availableSortFields.toJS() : [];
	
	        var headerFields = null;
	        if (!_lodash2.default.isEmpty(this.props.pacerSearchResults.get('headerFields'))) {
	            var headerFieldsJS = this.props.pacerSearchResults.get('headerFields').toJS();
	            headerFields = _lodash2.default.map(headerFieldsJS, function (field) {
	                var sortable = _lodash2.default.includes(availableSortFields, field.key);
	                return _react2.default.createElement(
	                    'th',
	                    null,
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'result-header-item ' + (sortable ? 'sortable' : ''), onClick: function onClick(e) {
	                                return sortable ? _this2.clickSort(field) : null;
	                            } },
	                        field.name,
	                        field.name === _this2.state.activeField.name ? _react2.default.createElement(_SortArrow2.default, { isReverse: _this2.state.isReverse }) : null
	                    )
	                );
	            });
	        }
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'item-list' },
	                _react2.default.createElement(
	                    'ul',
	                    { style: { margin: '20px 0 0 0' }, className: 'pager' },
	                    previous,
	                    paginatorItems
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'search-results' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'ir-search-table-results sticky-enabled sticky-table' },
	                    _react2.default.createElement(
	                        'thead',
	                        { className: 'tableHeader-processed' },
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            headerFields
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        caseResults
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'item-list' },
	                _react2.default.createElement(
	                    'ul',
	                    { style: { margin: '20px 0 0 0' }, className: 'pager' },
	                    previous,
	                    paginatorItems
	                )
	            )
	        );
	    };
	
	    return ResultsTable;
	}(_react.Component);
	
	function mapStateToProps(state) {
	    return {
	        pacerSearchResults: state.get('pacerSearchResults'),
	        filters: state.getIn(['pacerSearchResults', 'filters'])
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ResultsTable);

/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NatureOfSuitCasesRow = function NatureOfSuitCasesRow(_ref) {
	    var meta = _ref.meta;
	    return _react2.default.createElement(
	        "tr",
	        null,
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.case_title
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.court_code
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: "ir-search-no-wrap" },
	            _react2.default.createElement(
	                "a",
	                { href: "/filings/" + meta.case_uuid, target: "_blank" },
	                meta.case_no
	            )
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.nature_of_suit_code
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.date_filed
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.date_closed
	        )
	    );
	};
	
	exports.default = NatureOfSuitCasesRow;

/***/ },
/* 1200 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NatureOfSuitPartiesRow = function NatureOfSuitPartiesRow(_ref) {
	    var meta = _ref.meta;
	    return _react2.default.createElement(
	        "tr",
	        null,
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.party_name
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.party_role
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.court_code
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: "ir-search-no-wrap" },
	            _react2.default.createElement(
	                "a",
	                { href: "/filings/" + meta.case_uuid, target: "_blank" },
	                meta.case_no
	            )
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.nature_of_suit_code
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.date_filed
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            meta.date_closed
	        )
	    );
	};
	
	exports.default = NatureOfSuitPartiesRow;

/***/ },
/* 1201 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	    Bankruptcy: {
	        casesHeaderFields: [{ key: 'cs_title', name: 'Case Title' }, { key: 'court_id', name: 'Court' }, { key: 'case_no', name: 'Case No' }, { key: 'chapter', name: 'Chapter' }, { key: 'cs_date_filed', name: 'Date Filed' }, { key: 'cs_date_term', name: 'Date Closed' }, { key: 'disposition', name: 'Disposition' }],
	        partiesHeaderFields: [{ key: 'party_name', name: 'Party Name' }, { key: 'party_role', name: 'Role' }, { key: 'court_id', name: 'Court' }, { key: 'case_no', name: 'Case No' }, { key: 'chapter', name: 'Chapter' }, { key: 'cs_date_filed', name: 'Date Filed' }, { key: 'cs_date_term', name: 'Date Closed' }, { key: 'disposition', name: 'Disposition' }]
	    },
	    Civil: {
	        casesHeaderFields: [{ key: 'cs_title', name: 'Case Title' }, { key: 'court_id', name: 'Court' }, { key: 'case_no', name: 'Case No' }, { key: 'nature_of_suit_code', name: 'NOS' }, { key: 'cs_date_filed', name: 'Date Filed' }, { key: 'cs_date_term', name: 'Date Closed' }],
	        partiesHeaderFields: [{ key: 'party_name', name: 'Party Name' }, { key: 'party_role', name: 'Role' }, { key: 'court_id', name: 'Court' }, { key: 'case_no', name: 'Case No' }, { key: 'nature_of_suit_code', name: 'NOS' }, { key: 'cs_date_filed', name: 'Date Filed' }, { key: 'cs_date_term', name: 'Date Closed' }]
	    },
	    Criminal: {
	        casesHeaderFields: [{ key: 'cs_title', name: 'Case Title' }, { key: 'court_id', name: 'Court' }, { key: 'case_no', name: 'Case No' }, { key: 'cs_date_filed', name: 'Date Filed' }, { key: 'cs_date_term', name: 'Date Closed' }],
	        partiesHeaderFields: [{ key: 'party_name', name: 'Party Name' }, { key: 'party_role', name: 'Role' }, { key: 'court_id', name: 'Court' }, { key: 'case_no', name: 'Case No' }, { key: 'cs_date_filed', name: 'Date Filed' }, { key: 'cs_date_term', name: 'Date Closed' }]
	    },
	    Appellate: {
	        casesHeaderFields: [{ key: 'cs_title', name: 'Case Title' }, { key: 'court_id', name: 'Court' }, { key: 'case_no', name: 'Case No' }, { key: 'nos', name: 'NOS' }, { key: 'cs_date_filed', name: 'Date Filed' }, { key: 'cs_date_term', name: 'Date Closed' }],
	        partiesHeaderFields: [{ key: 'party_name', name: 'Party Name' }, { key: 'party_role', name: 'Role' }, { key: 'court_id', name: 'Court' }, { key: 'case_no', name: 'Case No' }, { key: 'nos', name: 'NOS' }, { key: 'cs_date_filed', name: 'Date Filed' }, { key: 'cs_date_term', name: 'Date Closed' }]
	    }
	};

/***/ },
/* 1202 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _AutomatedReports = __webpack_require__(694);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Manage Alerts/AutomatedReports', module).add('View', function () {
	  return _react2.default.createElement(_AutomatedReports.AutomatedReports, null);
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1203 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _AutomatedReportsTable = __webpack_require__(417);
	
	var _AutomatedReportsTable2 = _interopRequireDefault(_AutomatedReportsTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Manage Alerts/AutomatedReports/AutomatedReportsTable', module).add('Loading', function () {
	  return _react2.default.createElement(_AutomatedReportsTable2.default, {
	    alerts: [],
	    isLoading: true
	  });
	}).add('View without data', function () {
	  return _react2.default.createElement(_AutomatedReportsTable2.default, {
	    alerts: [],
	    isLoading: false
	  });
	}).add('View', function () {
	  return _react2.default.createElement(_AutomatedReportsTable2.default, {
	    alerts: sampleGetAlertsResponse.alerts,
	    isLoading: false,
	    onRemoveButtonClick: (0, _addonActions.action)('onRemoveButtonClick')
	  });
	});
	
	var sampleGetAlertsResponse = {
	  alerts: [{
	    isBeingRemoved: true,
	    rtalert_cron_id: '1145',
	    uid_creator: '1',
	    uid_master: '1',
	    time_start: '1532260800',
	    time_end: '1847919600',
	    interval_minute: '10080',
	    court_code: 'casbke',
	    chapter_code: '0',
	    case_type: '',
	    csv: '0',
	    enabled: '1',
	    time_last_run: '1540123200',
	    discovered_cases: 'casbke_431519,casbke_431520,casbke_431528,casbke_431552,casbke_431555,casbke_431556,\n        casbke_431562,casbke_431582,casbke_431581,casbke_431589,casbke_431592,casbke_431595,casbke_431594,casbke_431596,\n        casbke_431599,casbke_431622,casbke_431634',
	    created: '1532043435',
	    modified: '2018-10-21 12:00:29',
	    disabled: '0',
	    search_params: {
	      query_type: 'localcourtreport',
	      date_type: 'filed',
	      chapter: ['11', '7', '13'],
	      case_type: 'bk',
	      asset_notice: '',
	      nature_of_debt: '',
	      type_of_debtor: '',
	      nature_of_business: '',
	      open_cases: 1,
	      closed_cases: '',
	      voluntary: '',
	      involuntary: '',
	      smallbusiness: '',
	      proseonly: 1,
	      nature_of_suit: '',
	      citation: '',
	      office: '',
	      cause: '',
	      jurisdic: '',
	      case_flags: '',
	      cvbcases: '',
	      pending_defendants: '',
	      terminated_defendants: '',
	      pacer_client_code: ''
	    },
	    creator_name: '<a href="https://www.inforuptcy.com/users/inforuptcy-team-profile" title="View user profile.">\n            Inforuptcy Team\n        </a>',
	    interval_str: '1 week'
	  }, {
	    rtalert_cron_id: '1146',
	    uid_creator: '1',
	    uid_master: '1',
	    time_start: '1532260800',
	    time_end: '1847919600',
	    interval_minute: '10080',
	    court_code: 'mdbke',
	    chapter_code: '0',
	    case_type: '',
	    csv: '0',
	    enabled: '1',
	    time_last_run: '1540123200',
	    discovered_cases: 'mdbke_721685,mdbke_721772,mdbke_721873,mdbke_721885,mdbke_721886,mdbke_721908',
	    created: '1532043549',
	    modified: '2018-10-21 12:00:32',
	    disabled: '0',
	    search_params: {
	      query_type: 'localcourtreport',
	      date_type: 'filed',
	      chapter: ['11', '7', '12', '9', '15'],
	      case_type: 'bk',
	      asset_notice: '',
	      nature_of_debt: 'b',
	      type_of_debtor: '',
	      nature_of_business: '',
	      open_cases: 1,
	      closed_cases: '',
	      voluntary: '',
	      involuntary: '',
	      smallbusiness: '',
	      proseonly: '',
	      nature_of_suit: '',
	      citation: '',
	      office: '',
	      cause: '',
	      jurisdic: '',
	      case_flags: '',
	      cvbcases: '',
	      pending_defendants: '',
	      terminated_defendants: '',
	      pacer_client_code: ''
	    },
	    creator_name: '<a href="https://www.inforuptcy.com/users/inforuptcy-team-profile" title="View user profile.">\n            Inforuptcy Team\n        </a>',
	    interval_str: '1 week'
	  }, {
	    rtalert_cron_id: '1147',
	    uid_creator: '1',
	    uid_master: '1',
	    time_start: '1532260800',
	    time_end: '1847919600',
	    interval_minute: '10080',
	    court_code: 'cacbke',
	    chapter_code: '0',
	    case_type: '',
	    csv: '0',
	    enabled: '1',
	    time_last_run: '1540123200',
	    discovered_cases: 'cacbke_1842157,cacbke_1842164,cacbke_1842167,cacbke_1842172,cacbke_1842182,cacbke_1842185,\n        cacbke_1842192,cacbke_1842197,cacbke_1842199,cacbke_1842200,cacbke_1842201,cacbke_1842215,cacbke_1842227,\n        cacbke_1842235,cacbke_1842245,cacbke_1842247,cacbke_1842248,cacbke_1842252,cacbke_1842257,cacbke_1842268,\n        cacbke_1842282,cacbke_1842283,cacbke_1842293,cacbke_1842348,cacbke_1842158,cacbke_1842160,cacbke_1842165,\n        cacbke_1842174,cacbke_1842177,cacbke_1842180,cacbke_1842188,cacbke_1842190,cacbke_1842193,cacbke_1842195,\n        cacbke_1842202,cacbke_1842210,cacbke_1842214,cacbke_1842239,cacbke_1842267,cacbke_1842209,cacbke_1842217,\n        cacbke_1842343,cacbke_1842344,cacbke_1842365,cacbke_1842372,cacbke_1842373,cacbke_1842377,cacbke_1842384,\n        cacbke_1842404,cacbke_1842410,cacbke_1842341,cacbke_1842342,cacbke_1842349,cacbke_1842351,cacbke_1842375,\n        cacbke_1842389,cacbke_1842350,cacbke_1842396,cacbke_1842346,cacbke_1842353,cacbke_1842525,cacbke_1842537,\n        cacbke_1842443,cacbke_1842446,cacbke_1842447,cacbke_1842449,cacbke_1842452,cacbke_1842454,cacbke_1842483,\n        cacbke_1842487,cacbke_1842520,cacbke_1842522,cacbke_1842526,cacbke_1842445,cacbke_1842448,cacbke_1842491,\n        cacbke_1842495,cacbke_1842538,cacbke_1842533,cacbke_1842516,cacbke_1842596,cacbke_1842603,cacbke_1842611,\n        cacbke_1842618,cacbke_1842622,cacbke_1842623,cacbke_1842638,cacbke_1842642,cacbke_1842660,cacbke_1842667,\n        cacbke_1842669,cacbke_1842670,cacbke_1842683,cacbke_1842598,cacbke_1842607,cacbke_1842615,cacbke_1842625,\n        cacbke_1842637,cacbke_1842671,cacbke_1842658,cacbke_1842663,cacbke_1842751,cacbke_1842814,cacbke_1842731,\n        cacbke_1842773,cacbke_1842795,cacbke_1842800,cacbke_1842802,cacbke_1842813,cacbke_1842818,cacbke_1842820,\n        cacbke_1842822,cacbke_1842829,cacbke_1842742,cacbke_1842752,cacbke_1842756,cacbke_1842772,cacbke_1842774,\n        cacbke_1842789,cacbke_1842794,cacbke_1842816,cacbke_1842821,cacbke_1842732,cacbke_1842744',
	    created: '1532043644',
	    modified: '2018-10-21 12:00:46',
	    disabled: '0',
	    search_params: {
	      query_type: 'localcourtreport',
	      date_type: 'filed',
	      chapter: ['11', '7', '13'],
	      case_type: 'bk',
	      asset_notice: '',
	      nature_of_debt: '',
	      type_of_debtor: '',
	      nature_of_business: '',
	      open_cases: 1,
	      closed_cases: '',
	      voluntary: '',
	      involuntary: '',
	      smallbusiness: '',
	      proseonly: 1,
	      nature_of_suit: '',
	      citation: '',
	      office: '',
	      cause: '',
	      jurisdic: '',
	      case_flags: '',
	      cvbcases: '',
	      pending_defendants: '',
	      terminated_defendants: '',
	      pacer_client_code: ''
	    },
	    creator_name: '<a href="https://www.inforuptcy.com/users/inforuptcy-team-profile" title="View user profile.">\n            Inforuptcy Team\n        </a>',
	    interval_str: '1 week'
	  }, {
	    rtalert_cron_id: '1149',
	    uid_creator: '1',
	    uid_master: '1',
	    time_start: '1532260800',
	    time_end: '1847919600',
	    interval_minute: '10080',
	    court_code: 'scbke',
	    chapter_code: '0',
	    case_type: '',
	    csv: '0',
	    enabled: '1',
	    time_last_run: '1540123200',
	    discovered_cases: 'scbke_252228,scbke_252953,scbke_255637,scbke_256433,scbke_256478,scbke_256719,scbke_258242,\n        scbke_258925,scbke_259297,scbke_259609,scbke_259705,scbke_260269,scbke_260776,scbke_264576,scbke_266108,\n        scbke_266249,scbke_266315,scbke_267603,scbke_268345,scbke_270367,scbke_270594,scbke_270697,scbke_271384,\n        scbke_271658,scbke_273796,scbke_274079,scbke_274348,scbke_275704,scbke_276121,scbke_276527,scbke_276888,\n        scbke_277244,scbke_277519,scbke_278110,scbke_278616,scbke_279924,scbke_281360,scbke_281519,scbke_281600,\n        scbke_282650,scbke_282670,scbke_282804,scbke_282863,scbke_283038,scbke_283378,scbke_283404,scbke_283436,\n        scbke_283455,scbke_283760,scbke_283846,scbke_283867,scbke_283922,scbke_284274,scbke_284298,scbke_284394,\n        scbke_284441,scbke_284448,scbke_284473,scbke_284637,scbke_284642,scbke_284664,scbke_284674,scbke_284968,\n        scbke_284999,scbke_285022,scbke_285027,scbke_285035,scbke_285119',
	    created: '1532043825',
	    modified: '2018-10-21 12:00:57',
	    disabled: '0',
	    search_params: {
	      query_type: 'localcourtreport',
	      date_type: 'dismissed',
	      chapter: ['13'],
	      case_type: 'bk',
	      asset_notice: '',
	      nature_of_debt: '',
	      type_of_debtor: '',
	      nature_of_business: '',
	      open_cases: '',
	      closed_cases: '',
	      voluntary: '',
	      involuntary: '',
	      smallbusiness: '',
	      proseonly: '',
	      nature_of_suit: '',
	      citation: '',
	      office: '',
	      cause: '',
	      jurisdic: '',
	      case_flags: '',
	      cvbcases: '',
	      pending_defendants: '',
	      terminated_defendants: '',
	      pacer_client_code: ''
	    },
	    creator_name: '<a href="https://www.inforuptcy.com/users/inforuptcy-team-profile" title="View user profile.">\n            Inforuptcy Team\n        </a>',
	    interval_str: '1 week'
	  }, {
	    rtalert_cron_id: '1150',
	    uid_creator: '1',
	    uid_master: '1',
	    time_start: '1532260800',
	    time_end: '1847919600',
	    interval_minute: '10080',
	    court_code: 'txwbke',
	    chapter_code: '0',
	    case_type: '',
	    csv: '0',
	    enabled: '1',
	    time_last_run: '1540123200',
	    discovered_cases: 'txwbke_293200,txwbke_294902,txwbke_299194,txwbke_302258,txwbke_305876,txwbke_306584,\n        txwbke_310280,txwbke_310888,txwbke_312029,txwbke_312534,txwbke_317889,txwbke_318591,txwbke_318744,txwbke_321130,\n        txwbke_322892,txwbke_324012,txwbke_324313,txwbke_324317,txwbke_324813,txwbke_324978,txwbke_325186,txwbke_326219,\n        txwbke_326607,txwbke_328686,txwbke_329119,txwbke_329407,txwbke_329428,txwbke_329857,txwbke_330169,txwbke_330091,\n        txwbke_330366,txwbke_330404,txwbke_330452,txwbke_330833,txwbke_330812,txwbke_331285,txwbke_331269,txwbke_331407,\n        txwbke_331385,txwbke_331477,txwbke_309768,txwbke_331512',
	    created: '1532043926',
	    modified: '2018-10-21 12:01:05',
	    disabled: '0',
	    search_params: {
	      query_type: 'localcourtreport',
	      date_type: 'dismissed',
	      chapter: ['7', '13'],
	      case_type: 'bk',
	      asset_notice: '',
	      nature_of_debt: 'c',
	      type_of_debtor: 'i',
	      nature_of_business: '',
	      open_cases: '',
	      closed_cases: '',
	      voluntary: '',
	      involuntary: '',
	      smallbusiness: '',
	      proseonly: '',
	      nature_of_suit: '',
	      citation: '',
	      office: '',
	      cause: '',
	      jurisdic: '',
	      case_flags: '',
	      cvbcases: '',
	      pending_defendants: '',
	      terminated_defendants: '',
	      pacer_client_code: ''
	    },
	    creator_name: '<a href="https://www.inforuptcy.com/users/inforuptcy-team-profile" title="View user profile.">\n            Inforuptcy Team\n        </a>',
	    interval_str: '1 week'
	  }, {
	    rtalert_cron_id: '1151',
	    uid_creator: '1',
	    uid_master: '1',
	    time_start: '1532260800',
	    time_end: '1847919600',
	    interval_minute: '10080',
	    court_code: 'utbke',
	    chapter_code: '0',
	    case_type: '',
	    csv: '0',
	    enabled: '1',
	    time_last_run: '1540123800',
	    discovered_cases: 'utbke_425393,utbke_425396,utbke_425413,utbke_425437,utbke_425474,utbke_425500,utbke_425504,\n        utbke_425513,utbke_425523,utbke_425558,utbke_425564',
	    created: '1532044022',
	    modified: '2018-10-21 12:10:05',
	    disabled: '0',
	    search_params: {
	      query_type: 'localcourtreport',
	      date_type: 'filed',
	      chapter: ['7', '13'],
	      case_type: 'bk',
	      asset_notice: '',
	      nature_of_debt: '',
	      type_of_debtor: '',
	      nature_of_business: '',
	      open_cases: '',
	      closed_cases: '',
	      voluntary: '',
	      involuntary: '',
	      smallbusiness: '',
	      proseonly: 1,
	      nature_of_suit: '',
	      citation: '',
	      office: '',
	      cause: '',
	      jurisdic: '',
	      case_flags: '',
	      cvbcases: '',
	      pending_defendants: '',
	      terminated_defendants: '',
	      pacer_client_code: ''
	    },
	    creator_name: '<a href="https://www.inforuptcy.com/users/inforuptcy-team-profile" title="View user profile.">\n            Inforuptcy Team\n        </a>',
	    interval_str: '1 week'
	  }, {
	    rtalert_cron_id: '1152',
	    uid_creator: '1',
	    uid_master: '1',
	    time_start: '1534680000',
	    time_end: '1850335200',
	    interval_minute: '10080',
	    court_code: 'flmbke',
	    chapter_code: '0',
	    case_type: '',
	    csv: '0',
	    enabled: '1',
	    time_last_run: '1540123200',
	    discovered_cases: 'flmbke_1111834,flmbke_1130470,flmbke_1185372,flmbke_1202730,flmbke_1202917,flmbke_1208913,\n        flmbke_1213082,flmbke_1212984,flmbke_1225885,flmbke_1229203,flmbke_1229801,flmbke_1230981,flmbke_1237066,\n        flmbke_1241530,flmbke_1243317,flmbke_1245309,flmbke_1246291,flmbke_1246481,flmbke_1249462,flmbke_1249641,\n        flmbke_1251240,flmbke_1253818,flmbke_1254799,flmbke_1255070,flmbke_1255195,flmbke_1255777,flmbke_1256939,\n        flmbke_1257182,flmbke_1257724,flmbke_1257868,flmbke_1258299,flmbke_1258855,flmbke_1259027,flmbke_1260099,\n        flmbke_1260108,flmbke_1260318,flmbke_1260610,flmbke_1260910,flmbke_1261167,flmbke_1264614,flmbke_1264843,\n        flmbke_1265800,flmbke_1265929,flmbke_1266205,flmbke_1266093,flmbke_1266099,flmbke_1266450,flmbke_1266537,\n        flmbke_1266639,flmbke_1266682,flmbke_1266662,flmbke_1266731,flmbke_1266880,flmbke_1266697,flmbke_1266795,\n        flmbke_1266883,flmbke_1266800,flmbke_1266846,flmbke_1266915,flmbke_1267064,flmbke_1266949,flmbke_1267056,\n        flmbke_1267085,flmbke_1267292,flmbke_1267148,flmbke_1267044,flmbke_1267127,flmbke_1267142,flmbke_1267415,\n        flmbke_1267329',
	    created: '1534370964',
	    modified: '2018-10-21 12:01:20',
	    disabled: '0',
	    search_params: {
	      query_type: 'localcourtreport',
	      date_type: 'dismissed',
	      chapter: ['13'],
	      case_type: 'bk',
	      asset_notice: '',
	      nature_of_debt: '',
	      type_of_debtor: '',
	      nature_of_business: '',
	      open_cases: '',
	      closed_cases: '',
	      voluntary: '',
	      involuntary: '',
	      smallbusiness: '',
	      proseonly: '',
	      nature_of_suit: '',
	      citation: '',
	      office: '',
	      cause: '',
	      jurisdic: '',
	      case_flags: '',
	      cvbcases: '',
	      pending_defendants: '',
	      terminated_defendants: '',
	      pacer_client_code: ''
	    },
	    creator_name: '<a href="https://www.inforuptcy.com/users/inforuptcy-team-profile" title="View user profile.">\n            Inforuptcy Team\n        </a>',
	    interval_str: '1 week'
	  }],
	  input: {
	    filter: [],
	    validate: []
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1204 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _CustomAlertEdit = __webpack_require__(418);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Manage Alerts/CustomAlerts', module).add('Edit Alert', function () {
	  return _react2.default.createElement(_CustomAlertEdit.CustomAlertEdit, {
	    show: true,
	    alert: customAlert,
	    onClose: function onClose() {
	      return null;
	    },
	    onSave: (0, _addonActions.action)('updateCustomAlert')
	  });
	}).add('Edit Alert invalid', function () {
	  return _react2.default.createElement(_CustomAlertEdit.CustomAlertEdit, {
	    show: true,
	    alert: invalidAlert,
	    onClose: function onClose() {
	      return null;
	    },
	    onSave: (0, _addonActions.action)('updateCustomAlert')
	  });
	}).add('Edit Alert with all interval options ', function () {
	  return _react2.default.createElement(_CustomAlertEdit.CustomAlertEdit, {
	    show: true,
	    alert: customAlertWithAllIntervalOptions,
	    onClose: function onClose() {
	      return null;
	    },
	    onSave: (0, _addonActions.action)('updateCustomAlert')
	  });
	}).add('Edit Alert with limited interval options ', function () {
	  return _react2.default.createElement(_CustomAlertEdit.CustomAlertEdit, {
	    show: true,
	    alert: customAlertWithLimitedIntervalOptions,
	    onClose: function onClose() {
	      return null;
	    },
	    onSave: (0, _addonActions.action)('updateCustomAlert')
	  });
	});
	
	var invalidAlert = {
	  id: 206,
	  name: '',
	  created: 1532043435,
	  last_execute: 1540123200,
	  type: 'General',
	  notify_interval: 300,
	  delivery: '0',
	  mail_list: ['qwe'],
	  delivery_options: ['', 'rss', 'webhook'],
	  list: ['asasd.asdasd@qwewqe.dvo', 'qwe@asd.zx']
	};
	
	var customAlert = {
	  id: 206,
	  name: 'motion - docket',
	  created: 1532043435,
	  last_execute: 1540123200,
	  type: 'General',
	  notify_interval: 3600,
	  notify_interval_options: [{ value: -1, label: 'Save/Pause' }, { value: 3600, label: 'Hourly' }, { value: 86400, label: 'Daily' }, { value: 604800, label: 'Weekly' }],
	  delivery: '',
	  delivery_options: [{ value: '', label: 'Email' }, { value: 'rss', label: 'RSS' }, { value: 'webhook', label: 'Webhook' }],
	  list: ['asasd.asdasd@qwewqe.dvo', 'qwe@asd.zx']
	};
	
	var customAlertWithAllIntervalOptions = {
	  id: 206,
	  name: 'motion - docket',
	  created: 1532043435,
	  last_execute: 1540123200,
	  type: 'General',
	  notify_interval: 3600,
	  notify_interval_options: [{ value: -1, label: 'Save/Pause' }, { value: 3600, label: 'Hourly' }, { value: 86400, label: 'Daily' }, { value: 604800, label: 'Weekly' }],
	  delivery: '',
	  delivery_options: [{ value: '', label: 'Email' }, { value: 'rss', label: 'RSS' }, { value: 'webhook', label: 'Webhook' }],
	  list: ['asasd.asdasd@qwewqe.dvo', 'qwe@asd.zx']
	};
	
	var customAlertWithLimitedIntervalOptions = {
	  id: 206,
	  name: 'motion - docket',
	  created: 1532043435,
	  last_execute: 1540123200,
	  type: 'General',
	  notify_interval: 3600,
	  notify_interval_options: [{ value: -1, label: 'Save/Pause' }, { value: 3600, label: 'Hourly' }],
	  delivery: '',
	  delivery_options: [{ value: '', label: 'Email' }, { value: 'rss', label: 'RSS' }],
	  list: ['asasd.asdasd@qwewqe.dvo', 'qwe@asd.zx']
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _CustomAlerts = __webpack_require__(695);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Manage Alerts/CustomAlerts', module).add('Loading', function () {
	  return _react2.default.createElement(_CustomAlerts.CustomAlerts, { isLoading: true });
	}).add('View without data', function () {
	  return _react2.default.createElement(_CustomAlerts.CustomAlerts, { alerts: [] });
	}).add('View', function () {
	  return _react2.default.createElement(_CustomAlerts.CustomAlerts, {
	    alerts: data.alerts,
	    getCustomAlerts: (0, _addonActions.action)('getCustomAlerts'),
	    updateCustomAlert: (0, _addonActions.action)('updateCustomAlert'),
	    removeCustomAlert: (0, _addonActions.action)('removeCustomAlert')
	  });
	});
	
	var data = {
	  alerts: [{
	    id: 206,
	    name: 'motion - docket',
	    created: 1532043435,
	    last_execute: 1540123200,
	    type_label: 'General',
	    delivery: '',
	    delivery_options: [{ value: '', label: 'Email' }, { value: 'rss', label: 'RSS' }, { value: 'webhook', label: 'Webhook' }],
	    notify_interval: '-1',
	    notify_interval_options: [{ value: -1, label: 'Save/Pause' }, { value: 3600, label: 'Hourly' }, { value: 86400, label: 'Daily' }, { value: 604800, label: 'Weekly' }],
	    mail_list: ['asasd.asdasd@qwewqe.dvo', 'qwe@asd.zx'],
	    customize_access: true
	  }, {
	    id: 208,
	    name: 'motion - alert',
	    created: 1532043435,
	    last_execute: 1540123200,
	    type_label: 'General',
	    delivery: '',
	    delivery_options: [{ value: '', label: 'Email' }, { value: 'rss', label: 'RSS' }, { value: 'webhook', label: 'Webhook' }],
	    notify_interval: '86400',
	    notify_interval_options: [{ value: -1, label: 'Save/Pause' }, { value: 3600, label: 'Hourly' }, { value: 86400, label: 'Daily' }, { value: 604800, label: 'Weekly' }],
	    mail_list: ['asasd.asdasd@qwewqe.dvo', 'qwe@asd.zx'],
	    customize_access: true,
	    isUpdating: true
	  }, {
	    id: 207,
	    name: 'motion - history',
	    created: 1532043435,
	    last_execute: 1540123200,
	    type_label: 'General',
	    delivery: 'rss',
	    delivery_options: [{ value: '', label: 'Email' }, { value: 'rss', label: 'RSS' }, { value: 'webhook', label: 'Webhook' }],
	    notify_interval: '3600',
	    notify_interval_options: [{ value: -1, label: 'Save/Pause' }, { value: 3600, label: 'Hourly' }, { value: 86400, label: 'Daily' }, { value: 604800, label: 'Weekly' }],
	    mail_list: ['asd@qwe.vo'],
	    customize_access: false,
	    isUpdating: true
	  }, {
	    id: 991,
	    name: 'Personal property SOLR alert check',
	    created: 1532043435,
	    last_execute: 1540123200,
	    type_label: 'Assets',
	    delivery: '',
	    delivery_options: [{ value: '', label: 'Email' }, { value: 'rss', label: 'RSS' }],
	    notify_interval: '604800',
	    notify_interval_options: [{ value: -1, label: 'Save/Pause' }, { value: 86400, label: 'Daily' }, { value: 604800, label: 'Weekly' }],
	    mail_list: [],
	    customize_access: true,
	    resend: true
	  }, {
	    id: 992,
	    name: 'News alert SOLR check',
	    created: 1532043435,
	    last_execute: 1540123200,
	    type_label: 'News',
	    delivery: 'webhook',
	    delivery_options: [{ value: '', label: 'Email' }, { value: 'rss', label: 'RSS' }],
	    webhook_url: 'http://courtdrive.dev.azk',
	    notify_interval: '3600',
	    notify_interval_options: [{ value: -1, label: 'Save/Pause' }, { value: 3600, label: 'Hourly' }, { value: 86400, label: 'Daily' }, { value: 604800, label: 'Weekly' }],
	    mail_list: [],
	    customize_access: false
	  }]
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1206 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _addonActions = __webpack_require__(21);
	
	var _TemplateAlerts = __webpack_require__(698);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Manage Alerts/TemplateAlerts', module).add('Loading', function () {
	  return _react2.default.createElement(_TemplateAlerts.TemplateAlerts, { isLoading: true });
	}).add('View without data', function () {
	  return _react2.default.createElement(_TemplateAlerts.TemplateAlerts, { alerts: [] });
	}).add('View', function () {
	  return _react2.default.createElement(_TemplateAlerts.TemplateAlerts, {
	    alerts: sampleGetAlertsResponse.alerts,
	    getAlerts: (0, _addonActions.action)('getTemplateAlerts'),
	    updateAlert: (0, _addonActions.action)('updateTemplateAlert')
	  });
	});
	
	var sampleGetAlertsResponse = {
	  alerts: [{
	    id: 1,
	    name: 'Business Bankruptcies',
	    created: 1532043435,
	    last_execute: 1540123200,
	    type_label: 'Petitions',
	    enabled: 1,
	    notify_interval: '3600',
	    notify_interval_options: [{ value: -1, label: 'Save/Pause' }, { value: 3600, label: 'Hourly' }, { value: 86400, label: 'Daily' }, { value: 604800, label: 'Weekly' }],
	    customize_access: true,
	    isUpdating: { enabled: true }
	  }, {
	    id: 2,
	    name: 'Business Bankruptcies ­ Schedules',
	    created: 1532043435,
	    last_execute: 1544705100,
	    type_label: 'Schedules',
	    enabled: 0,
	    notify_interval: '86400',
	    notify_interval_options: [{ value: -1, label: 'Save/Pause' }, { value: 3600, label: 'Hourly' }, { value: 86400, label: 'Daily' }, { value: 604800, label: 'Weekly' }],
	    customize_access: true,
	    isUpdating: { notify_interval: true }
	  }, {
	    id: 3,
	    name: 'Case Activity',
	    created: 1532043435,
	    last_execute: 1509573600,
	    type_label: 'Case Activity',
	    enabled: 1,
	    notify_interval: '-1',
	    notify_interval_options: [{ value: -1, label: 'Save/Pause' }, { value: 3600, label: 'Hourly' }, { value: 86400, label: 'Daily' }, { value: 604800, label: 'Weekly' }],
	    customize_access: true,
	    resend: true
	  }, {
	    id: 4,
	    name: 'New Cases Alert',
	    created: 1532043435,
	    last_execute: 1540123200,
	    type_label: 'Cases',
	    enabled: 1,
	    notify_interval: '86400',
	    notify_interval_options: [{ value: -1, label: 'Save/Pause' }, { value: 3600, label: 'Hourly' }, { value: 86400, label: 'Daily' }],
	    customize_access: false
	  }]
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1207 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = [{
	  label: 'Unknown', value: 'Unknown'
	}, {
	  label: '$0 to $50,000', value: '$0 to $50,000'
	}, {
	  label: '$50,001 to $100,000', value: '$50,001 to $100,000'
	}, {
	  label: '$100,001 to $500,000', value: '$100,001 to $500,000'
	}, {
	  label: '$500,001 to $1 million', value: '$500,001 to $1 million'
	}, {
	  label: '$1,000,001 to $10 million', value: '$1,000,001 to $10 million'
	}, {
	  label: '$10,000,001 to $50 million', value: '$10,000,001 to $50 million'
	}, {
	  label: '$50,000,001 to $100 million', value: '$50,000,001 to $100 million'
	}, {
	  label: '$100,000,001 to $500 million', value: '$100,000,001 to $500 million'
	}, {
	  label: '$500,000,001 to $1 billion', value: '$500,000,001 to $1 billion'
	}, {
	  label: 'More than $1 billion', value: 'More than $1 billion'
	}, {
	  label: '$1,000,000,001 to $10 billion', value: '$1,000,000,001 to $10 billion'
	}, {
	  label: '$10,000,000,001 to $50 billion', value: '$10,000,000,001 to $50 billion'
	}, {
	  label: 'More than $50 billion', value: 'More than $50 billion'
	}];

/***/ },
/* 1208 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = [{ value: '01', label: '01 (Determination of removed claim or cause)' }, {
	  value: '02',
	  label: '02 (Other (e.g. other actions that would have been brought in state court if unrelated to bankruptcy))'
	}, { value: '11', label: '11 (Recovery of money/property - 542 turnover of property)' }, { value: '12', label: '12 (Recovery of money/property - 547 preference)' }, { value: '13', label: '13 (Recovery of money/property - 548 fraudulent transfer)' }, { value: '14', label: '14 (Recovery of money/property - other)' }, { value: '21', label: '21 (Validity, priority or extent of lien or other interest in property)' }, { value: '31', label: '31 (Approval of sale of property of estate and of a co-owner - 363(h))' }, { value: '41', label: '41 (Objection / revocation of discharge - 727(c),(d),(e))' }, { value: '424', label: '424 (Obj/Revocation Discharge 727)' }, { value: '426', label: '426 (Dischargeability 523)' }, { value: '434', label: '434 (Injunctive Relief)' }, { value: '435', label: '435 (Validity/Priority/Extent Lien)' }, { value: '454', label: '454 (Recover Money/Property)' }, { value: '455', label: '455 (Revoke Plan Confirmation)' }, { value: '456', label: '456 (Declaratory Judgment)' }, { value: '457', label: '457 (Subordinate Claim/Interest)' }, { value: '458', label: '458 (Approval For Sale)' }, { value: '459', label: '459 (Application For Removal)' }, { value: '498', label: '498 (Other Action)' }, { value: '51', label: '51 (Revocation of confirmation)' }, { value: '61', label: '61 (Dischargeability - 523(a)(5), domestic support)' }, { value: '62', label: '62 (Dischargeability - 523(a)(2), false pretenses, false representation, actual fraud)' }, { value: '63', label: '63 (Dischargeability - 523(a)(8), student loan)' }, { value: '64', label: '64 (Dischargeability - 523(a)(15), divorce/sep property settlement/decree)' }, { value: '65', label: '65 (Dischargeability - other)' }, { value: '66', label: '66 (Dischargeability - 523(a)(1),(14),(14A) priority tax claims)' }, { value: '67', label: '67 (Dischargeability - 523(a)(4), fraud as fiduciary, embezzlement, larceny)' }, { value: '68', label: '68 (Dischargeability - 523(a)(6), willful and malicious injury)' }, { value: '71', label: '71 (Injunctive relief - reinstatement of stay)' }, { value: '72', label: '72 (Injunctive relief - other)' }, { value: '81', label: '81 (Subordination of claim or interest)' }, { value: '91', label: '91 (Declaratory judgment)' }, { value: 'SS', label: 'SS (SIPA Case - 15 U.S.C. 78aaa et.seq.)' }];

/***/ },
/* 1209 */
/***/ function(module, exports) {

	"use strict";exports.__esModule=true;var causes={"akdce":{"0":"0 (No cause code entered)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"almdce":{"0":"0 (No cause code entered)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8101":"05:8101 (05:8101 Workmen's Compensation Benefits)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","05:8701":"05:8701 (05:8701 Federal Employees' Group Life Insurance Act)","05:8705":"05:8705 (05:8705 Declaratory Judgment - Insurance)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0136":"07:0136 (07:0136 Fed. Insecticide Fungicide & Rodenticide Act of 1942)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:0901":"07:0901 (07:0901 Rural Electrification Act)","07:1501":"07:1501 (07:1501 Federal Crop Insurance Act)","07:2156":"07:2156 (07:2156 Animal Fighting Venture Prohibition)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1421":"08:1421 (08:1421 Judicial Review of Naturalization Authority)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451(j)":"08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0004":"09:0004 (09:0004 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Award)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1072tc":"10:1072tc (10:1072 TRICARE PROGRAM)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","11:525":"11:525 (11:525 Discrimination Treatment (Bankruptcy))","12:0022":"12:0022 (12:22 Securities Fraud)","12:0611":"12:0611 (12:0611 Edge Act)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1452":"12:1452 (12:1452 Federa Home Loan Mortgage Corporation)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 FDIC Insurance Funds)","12:191":"12:191 (12:191 Bank Foreclosure)","12:192":"12:192 (12:192 Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act)","12:2601":"12:2601 (12:2601 Real Estate Settlement Procedures Act)","12:2605":"12:2605 (12:2605 Real Estate Settlement Procedures Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","12:3801":"12:3801 (12:3801 Parity Act)","12:5201":"12:5201 (12:5201 Economic Stabilization Act of 2008)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0013":"15:0013 (15:0013 Robinson Patman Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0015a":"15:0015a (15:15(a) Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1120":"15:1120 (15:1120 Trademark - False or Fraudulent Registration)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1667":"15:1667 (15:1667 Consumer Leasing Act)","15:1671":"15:1671 (15:1671 Consumer Credit Protection Act)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1691":"15:1691 (15:1691 Equal Credit Opportunity Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693":"15:1693 (15:1693 Electronic Fund Transfer Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0470":"16:0470 (16:0470 National Historic Preservation Act)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1244":"16:1244 (16:1244 National Scenic and National Historic Trails)","16:1533":"16:1533 (16:1533 Endangered Species Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0981":"18:0981 (18:0981 Civil forfeiture)","18:1030":"18:1030 (18:1030 Computer Fraud and Abuse Act)","18:1345":"18:1345 (18:1345 Fraud Injunction Statute)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1956":"18:1956 (18:1956 Forfeiture Property)","18:1957":"18:1957 (18:1957 Forfeiture Property)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2254":"18:2254 (18:2254 Civil Forfeiture)","18:2510":"18:2510 (18:2510 Electronic Communications Privacy Act)","18:2511":"18:2511 (18:2511 Wiretapping)","18:2721":"18:2721 (18:2721 Automobile Information Disclosure Act)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:3184":"18:3184 (18:3184 Extradition Procedure)","18:3771":"18:3771 (18:3771(d)(3) Crime Victims' Rights Motion for Relief and Writ)","18:4100":"18:4100 (18:4100 Transfer of Offenders)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","18:492":"18:492 (18:492 Counterfeiting and Forgery)","18:922":"18:922 (18:922 Firearms - Unlawful Possession)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","19:1607":"19:1607 (19:1607 Notice of Seizure-Return of Seized Property)","20:107":"20:107 (20:107 Randolph-Sheppard Vending Stand Act)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1681":"20:1681 (20:1681 Education: Sex)","21:0360":"21:0360 (21:0360 Federal Food, Drug and Cosmetic Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0112":"23:0112 (23:112 Federal Highway Act)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","25:2701":"25:2701 (25:2701 Indian Gaming Regulation)","26:6109":"26:6109 (26:6109 IRS:Procedure and Administration)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6221":"26:6221 (TEFRA Tax, Equity and Fiscal Responsibility Act of 1982)","26:63":"26:63 (26:63 IRS: Taxable income)","26:6330":"26:6330 (26:6330 IRS: Notice and Opportunity for Hearing before Levy)","26:6331":"26:6331 (26:6331 IRS: Levy and distraint-Seizure of Property for Collection of Taxes)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6694":"26:6694 (26:6694 IRS: Injunction against Tax Preparer)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7407":"26:7407 (26:7407 IRS Action to enjoin tax return preparers)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331ej Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332":"28:1332 (28:1332 Diversity)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fo":"28:1332fo (28:1332 Diversity - Real Property Foreclosure)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332if":"28:1332if (28:1332 Diversity- Insurance Fraud)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332rp":"28:1332rp (28:1332 Diversity-Real Property)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wc":"28:1332wc (28:1332 Diversity- Worker's Compensation Benefits)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Cases & Proceedings)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1350":"28:1350 (28:1350 Alien's action for tort)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441":"28:1441 (28:1441 Notice of Removal (Lanham Act))","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441ada":"28:1441ada (28:1441 Notice of Removal-Americans with Disabilities Act)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441ba":"28:1441ba (Notice of Removal - National Bank Act)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441bfd":"28:1441bfd (28:1441bfd Notice of Removal-Breach of Fiduciary Duties)","28:1441ca":"28:1441ca (28:1441 Notice of Removal (Carmack Amendment))","28:1441cla":"28:1441cla (28:1441 Notice of Removal - Consumer Leasing Act)","28:1441cpl":"28:1441cpl (28:1441 Notice of Removal - Contract Product Liability)","28:1441cr":"28:1441cr (28:1441 Notice of Removal - Civil Rights)","28:1441cra":"28:1441cra (28:1441 Notice of Removal - Fair Credit Reporting Act)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441dea":"28:1441dea (28:1441 Notice of Removal - Disabilities Education Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ec":"28:1441ec (28:1441 Notice of Removal - Electronic Comm. Privacy Act)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441em":"28:1441em (28:1441 Notice of Removal - Emergency Medical Treatment & Active Labor)","28:1441eri":"28:1441eri (28:1441 Notice of Removal - E.R.I.S.A.)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fd":"28:1441fd (28:1441 Notice of Removal - Fair Debt Collection Practices Act)","28:1441fh":"28:1441fh (28:1441 Notice of Removal (FEHBA))","28:1441fif":"28:1441fif (28:1441 Notice of Removal - Insecticide/Fungicide/Rodenticide Act -1942)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441fsa":"28:1441fsa (28:1441 Notice of Removal - Federal Food Stamp Act)","28:1441if":"28:1441if (28:1441 Notice of Removal - Insurance Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441la":"28:1441la (28:1441 Notice of Removal - Truth in Lending Act)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441mv":"28:1441mv (28:1441 Notice of Removal - Motor Vehicle Safety)","28:1441mw":"28:1441mw (28:1441 Notice of Removal - Magnuson-Moss Warranty Act)","28:1441nba":"28:1441nba (28:1441 Notice of Removal - National Bank Act)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441res":"28:1441res (28:1441 Notice of Removal - \"RESPA\")","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tc":"28:1441tc (28:1441 Notice of Removal - Tort Claim)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tma":"28:1441tma (28:1441 Notice of Removal - Alabama Telemarketing Act)","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441tr":"28:1441tr (28:1441 Notice of Removal - Tricare Program)","28:1441use":"28:1441use (28:1441 Notice of Removal - Uniformed Svc Emp/Reemp Rights Act)","28:1441wc":"28:1441wc (28:1441 Notice of Removal - Worker's Compensation Benefits)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1441wt":"28:1441wt (28:1441wt Notice of Removal - Wrongful Termination (Employment))","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 Removal of claims related to bankruptcy case)","28:1453":"28:1453 (28:1453 Class Action Fairness Act)","28:14706":"28:14706 (Carmack Amendment to Hepburn Act (Interstate Commerce))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1738A":"28:1738A (28:1738A Full faith and credit given to Child Custody Determinations)","28:1782":"28:1782 (28:1782 Letter Rogatory - Appointment)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2001":"28:2001 (28:2001 Judicial Sale of Realty)","28:2071":"28:2071 (28:2071 Rule Making Power Generally)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:2679":"28:2679 (28:2679 Federal Tort Claim)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","28:3203":"28:3203 (28:3203 Writ of Execution)","28:3301":"28:3301 (28:3301 Fraudulent Transfer Federal Debt Collection Procedures Act)","28:636":"28:636 (28:636 Jurisdiction, Powers & Temporary Assignment)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0206d":"29:0206d (29:206(d) The Equal Pay Act)","29:0207fl":"29:0207fl (29:0207 Fair Labor Standards Act)","29:0215fl":"29:0215fl (29:0215 Fair Labor Standards Act)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1162":"29:1162 (29:1162 COBRA)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:206":"29:206 (29:206 Equal Pay Act)","29:2101":"29:2101 (29:2101 Worker Adjustment and Retaining Notification Act)","29:2601":"29:2601 (29:2601 Family and Medical Leave Act)","29:2617":"29:2617 (29:2617 Family & Medical Leave)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","31:5332":"31:5332 (31:5332.F Transport and Transfer US currency from in to out)","31:9306":"31:9306 (31:9306 Registration of Power of Attorney)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","33:2702":"33:2702 (33:2702 Federal Oil Pollution Act of 1990)","35:0102":"35:0102 (35:0102 Patent Grants)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","35:0282":"35:0282 (35:0282 Patent Infringement)","38:1110":"38:1110 (38:1110 VA Basic Entitlements)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:1965":"38:1965 (38:1965 Servicemembers Group Life Insurance Act)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (38:2021 Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4311":"38:4311 (38:4311 Uniformed Service Employment/Reemployment Rights Act)","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act OLD)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:3131":"40:3131 (40:3131 Miller Act NEW)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","41:4712":"41:4712 (41:4712 Public Contracts: Enhancement of contractor protection from reprisal for disclosure)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0256":"42:0256 (42:0256 Public Health Services Act)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:10801":"42:10801 (42:10801 Protection & Advocacy for Individuals with Mental Illness Act of 1986 (\"PAIMI Act\")","42:11112":"42:11112 (42:11112 Health Care Quality Improvement Act)","42:11601":"42:11601 (42:11601 International Child Abduction Remedies Act)","42:120711":"42:120711 (42:120711 Americans with Disabilities Act)","42:12101":"42:12101 (42:12101 Americans with Disabilities Act)","42:12102":"42:12102 (42:12102 Americans with Disabilities Act (\"ADA\"))","42:12111":"42:12111 (42:12111 Americans with Disabilities Act)","42:12112":"42:12112 (42:12112 Americans with Disabilities Act)","42:12117":"42:12117 (42:12117 Americans with Disabilities Act of 1990)","42:12181":"42:12181 (42:12181Americans with Disabilities Act-Public Accommodations Private)","42:12201":"42:12201 (42:12201 Americans with Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1395dd":"42:1395dd (42:1395 Emergency Medical Treatment and Active Labor Act)","42:1395w21":"42:1395w21 (42:1395w21 Medicare Act)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:14135":"42:14135 (42:14135 DNA Backlog Grant Program)","42:1437":"42:1437 (42:1437 U.S. Housing Act)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:15483":"42:15483 (42:15483 Help America Vote Act)","42:1973":"42:1973 (42:1973 Voting Rights Act)","42:1973c":"42:1973c (42:1973(c) Voting Rights -Qualifications & Procedures)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:1997":"42:1997 (42:1997 Civil Rights of Institutionalized Persons Act)","42:2000":"42:2000 (42:2000 Job Discrimination)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000cc":"42:2000cc (42:2000cc Protection of Religious Exercise in Land Use and by Institutionalized Persons)","42:2000d":"42:2000d (42:2000d Discrimination under federal programs on ground of race, color, or national origin)","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000pb Job Discrimination (Public Accommodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2615 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:32701":"42:32701 (42:32701 Odometer Disclosure)","42:3601":"42:3601 (42:3601 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:4821":"42:4821 (42:4821 Lead-Based Paint Poisoning Prevention Act)","42:6000":"42:6000 (42:6000 Developmental Disabilities Asst./Bill of Rights Act)","42:6101":"42:6101 (42:6101 Age Discrimination in Federally Assisted Programs)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:6991":"42:6991 (42:6991 Regulation of Underground Storage Tanks)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7475":"42:7475 (42:7475 Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9601":"42:9601 (42:9601 Comprehensive Environmental Response, Compensation & Liability Act of 1980 (CERCLA))","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:501":"45:501 (45:501 Rail Passenger Service Act)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:1701":"46:1701 (46:1701 Shipping Act of 1984)","47:0151":"47:0151 (47:0151 Communications Act)","47:0332":"47:0332 (47:332 Mobile Services)","47:0521":"47:0521 (47:521 Cable Communications Act)","47:227":"47:227 (47:227 Telephone Consumer Protection Act)","47:252":"47:252 (47:252 Telecommunications Act)","47:605":"47:605 (47:605 Unauthorized publication or use of communications)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:10101":"49:10101 (49:10101 Interstate Commerce Act-Interstate Transportation Rail)","49:11501":"49:11501 (49:11501 Railroad Revitalization & Regulatory Reform Act)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:14706":"49:14706 (Carmack Amendment to the Interstate Commerce Act)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","49:30112":"49:30112 (49:30112 Motor Vehicle Safety)","49:32701":"49:32701 (49:32701 Odometer Disclosure)","49:41705":"49:41705 (49:41705 Air Carrier Access Act of 1986 (ACAA))","50:501":"50:501 (50:501 Soldiers' & Sailors' Civil Relief Act)","5:8901":"5:8901 (5:8901 Notice of Removal - FEHBP)","7:2023":"7:2023 (7:2023 Administrative & Judicial Review (Food Stamp Program))","8:1481":"8:1481 (8:1481 Immigration and Nationality Act)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","9:201":"9:201 (Convention on the Recognition and Enforcement of Foreign Arbitral Awards)","adsup":"adsup (Administrative Subpoena)","contempt":"contempt (Contempt Proceedings)","dbexam":"dbexam (Motion for Order Requiring Examination of Judgment Debtor)","disbar":"disbar (Disbarment Proceedings)","fordepo":"fordepo (Foreign Deposition)","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Conclusion of Law)","writgar":"writgar (Application for a Writ of Garnishment)"},"alndce":{"0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:1926":"07:1926 (07:1926 Water & Waste Facility Loans)","07:2001":"07:2001 (07:2001 - Food Stamps)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:0287":"08:0287 (08:0287 Petition to Enforce INS Subpoena)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1522":"08:1522 (Refugee Act of 1980)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","11:524":"11:524 (11:524 Enjoin Collection due to Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1441":"12:1441 (12:1441 Action by Resolution Trust Corp - collection)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1831jb":"12:1831jb (12:1831j(b) - FDIC employment protection act)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:2601":"12:2601 (12:2601 - Real Estate Settlement Proceedures Act)","12:2604":"12:2604 (12:2604 RESPA (Real Estate Settlement Procedures Act))","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0053b":"15:0053b (15:0053(b) Prelim & Perm Inj Relief & other Equitable Relief)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1667":"15:1667 (15:1667 - Violation of the Consumer Leasing Act)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","16:831dd":"16:831dd (16:831dd - Land Condemnation)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0981":"18:0981 (18:0981 Civil Forfeiture)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1955":"18:1955 (18:1955(d) Seizure of Property - Illegal Gambling)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","19:3301":"19:3301 (19:3301 - NAFTA)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1681":"20:1681 (20:1681 Title IX Education Amendments of 1972)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332ej":"28:1332ej (28:1332 Diversity - Enforcement of Judgment)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345fr":"28:1345fr (28:1345 Enjoin Fraud)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441eri":"28:1441eri (28:1441eri - Petition for removal - E.R.I.S.A.)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0790":"29:0790 (29:0790 Rehabilitation of Labor)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2601":"29:2601 (29:2601 Family and Medical Leave Act (1993))","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:0903":"33:0903 (33:0903 Longshore & Harbor Worker's Compensation Act)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","35:0292":"35:0292 (35:0292 False Marking - Marking with Patent Number that is expired)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","39:0409":"39:0409 (39:0409 Postal Service)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0300":"42:0300 (42:0300 National Vaccine Injury Comp Program)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0425":"42:0425 (42:0425 Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:12117ad":"42:12117ad (42:12117ad - Americans with Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1973":"42:1973 (42:1973 Voting Rights Act)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:31325":"42:31325 (42:31325 Admiralty and Maritime Claim)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:5851":"42:5851 (Energy reorg act-empl contract)","42:6291":"42:6291 (42:6291 (EPCA)-Energy Policy and Conservation Act of 1975)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9601":"42:9601 (42:9601 - CERCLA)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:0945":"43:0945 (43:0945 Compensation for Land Condemnation)","43:0945a":"43:0945a (43:0945(a) Complaint in Condemnation)","43:0946":"43:0946 (43:0946 Complaint in Condemnation - Eminent Domain)","43:4323":"43:4323 (Soldiers and Sailors Employment and Reemployment Act)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0183":"46:0183 (46:0183 Admiralty - exoneration of liability)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:0151ta":"47:0151ta (47:0151ta - Telecommunications Act of 1996)","47:605":"47:605 (47:605 Electronic Communications Privacy Act)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1374(c)":"49:1374(c) (49:1374(c)(1) - Air Carriers Access Act)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","49:20109":"49:20109 (49:20109 - Federal Railroad Safety Act)","49:30101":"49:30101 (49:30101 - National Traffic & Motor Vehicle Safety Act)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"alsdce":{"0":"0 (No cause code entered)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","02:1202":"02:1202 (02:1202 Discriminatory practices affecting US Senate employees)","02:1301":"02:1301 (02:1301 Congressional Accountability Act)","02:1317a":"02:1317a (02:1317a Violation of Congressional Accountability Act)","02:138":"02:138 (02:138 Library of Congress Access)","02:358":"02:358 (02:358 President's Recommendations on Exec., Jud. & Leg. Salary)","02:681":"02:681 (02:681 Deferral of Budget Authority)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","05:8701":"05:8701 (05:8701 Federal Employees Group Life Insurance Act of 1954)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2011":"07:2011 (07:2011 Food Stamp Program)","07:2023":"07:2023 (07:2023 Food Stamp Program, Judicial Review)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1421":"08:1421 (08:1421 Review of Denial of Naturalization)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451(j)":"08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1787":"12:1787 (12:1787(a)(B) Fed Credit Unions: Liquidation of Insured Credit Union by Board)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:191":"12:191 (12:191 Bank Foreclosure)","12:192":"12:192 (12:192 Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act)","12:2601":"12:2601 (12:2601 Real Estate Settlement Procedures Act (RESPA) (findings & purpose))","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1666":"15:1666 (15:1666 Fair Credit Billing Act Dispute)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693ef":"15:1693ef (15:1693ef Electronic Funds Transfer Act)","15:1701":"15:1701 (15:1701 Interstate Land Sales Full Disclosure Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1030":"18:1030 (18:1030 Fraud and Related Activity in Connection with Computers)","18:1836a":"18:1836a (18:1836(a) - Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) - Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2511":"18:2511 (18:2511 Wiretapping)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","18:981":"18:981 (18:981 Civil Forfeiture)","18:981(a)":"18:981(a) (18:981(a)(1)(A) Civil Forfeiture)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1681":"20:1681 (20:1681 Title IX Educational Amendments 1992 - Sex Discrimination)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157b":"28:0157b (28:0157(b) Bankruptcy Claim to be tried in U.S. District Court)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332":"28:1332 (28:1332 Diversity Action)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332rp":"28:1332rp (28:1332rp Diversity-Real Property)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1333ds":"28:1333ds (28:1333 Marine-Contract Dispute)","28:1333ll":"28:1333ll (28:1333 Marine-Exoneration from/or Limitation of Liability)","28:1333mt":"28:1333mt (28:1333 Marine Tort/Collision/Allision)","28:1333pi":"28:1333pi (28:1333 Marine-Personal Injury)","28:1333pm":"28:1333pm (28:1333 Marine-Preferred Ship Mortgage)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1350":"28:1350 (28:1350 Alien Tort Claims Act)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446":"28:1446 (28:1446 Removal of Civil/Criminal Action from State Court)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254dp":"28:2254dp (Petition for Writ of Habeas Corpus (Death Penalty))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:2679":"28:2679 (28:2679(d)(2) Federal Tort Claims Act - Employee of U.S.A.)","28:3001":"28:3001 (28:3001 Federal Debt Collection)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1232":"29:1232 (29:1232 E.R.I.S.A.)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2101":"29:2101 (Worker Adjustment and Retraining Notification Act)","29:2601":"29:2601 (Family & Medical Leave Act of 1993)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","33:906":"33:906 (Longshore & Haborworker's Compensation)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:3114":"40:3114 (40:3114 Declaration of Taking)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:12101":"42:12101 (Disability Act of 1990)","42:12182":"42:12182 (Prohibition of discrimination by public accommodations)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000a-3":"42:2000a-3 (42:2000a-3pa Discrimination, Segregation; Public Accommodation - Injunctive Relief)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000d":"42:2000d (42:2000d Federally Assisted Programs)","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000pg":"42:2000pg (Job Discrimination (Pregancy))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000rt":"42:2000rt (42:2000rt Job Discrimination/Retaliation)","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0688ja":"46:0688ja (46:0688 Marine-Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:30104":"46:30104 (46:30104 Marine Personal Injury - Jones Act)","46:30505":"46:30505 (46:30505-30510 Exoneration, Limitation of Liability)","47:0151":"47:0151 (47:0151 Wire or Radio Communication)","47:227b3":"47:227b3 (47:227(b)(3) Telephone Consumer Protection Act of 1991)","47:553":"47:553 (Communications Act of 1934)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","PhenFen":"PhenFen (Phen Fen Actions)","adsup":"adsup (Administrative Subpoena)","amtrak":"amtrak (Amtrak Sunset Limited Train Crash - MDL 1003)","appstate":"appstate (Appeal from State Court Decision)","contempt":"contempt (Contempt Proceedings)","crmisc":"crmisc (Miscellaneous Criminal Action)","disbar":"disbar (Disbarment Proceedings)","expunge":"expunge (Motion for Expungement)","fordepo":"fordepo (Foreign Deposition)","forreq":"forreq (Foreign Request for Assistance)","mdl":"mdl (Multi-District Litigation)","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","objsubp":"objsubp (Objection to Non-Party Subpoena)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","powatty":"powatty (Power of Attorney for Service of Process)","regjgm":"regjgm (Registration of Foreign Judgment)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","writgar":"writgar (Application for a Writ of Garnishment)"},"aredce":{"*41*":"*41* ( )","0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8902":"05:8902 (05:8902 Health Insurance - Govt Organizations and Employees)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2014":"07:2014 (07:2014 Welfare Food and Stamp Act)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1154":"08:1154 (08:1154 Immigration and Nationality Act)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0004":"09:0004 (09:4 Petition for Order Compelling Arbitration)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:191":"12:191 (12:191 Bank Foreclosure)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1605":"15:1605 (15:1605 Consumer Credit Protection - Finance Charge)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0981":"18:0981 (18:981 Civil Forfeiture)","18:0982":"18:0982 (18:982 Criminal Forfeiture)","18:0985":"18:0985 (18:985 Forfeiture of Real Property)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881j":"21:0881j (21:0881j Forfeiture Property-Gambling)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7433":"26:7433 (26:7433 Civil Damages for Unauthorized Collection Actions)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:01851m":"28:01851m (28:185 Labor/Management Relations Act)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331mp":"28:1331mp (28:1331 Federal Question-Marine Personal Injury)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tc":"28:1331tc (28:1331 Federal Question-Fed. Telecomm. Act of 1996)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332":"28:1332 (28:1332 Diversity-Personal Injury-Product Liability)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assualt,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mp":"28:1332mp (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332rp":"28:1332rp (28:1332 Diversity-Real Property)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-core))","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 Agricultural Acts)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hd":"28:1345hd (28:1345 Default of HUD Loan)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345us":"28:1345us (28:1345 Debt to United States)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1404":"28:1404 (28:1404 Registration of Judgment)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441":"28:1441 (28:1441 Contract Property Liability)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441ag":"28:1441ag (28:1441ag Petition for Removal-Age Discrimination)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cr":"28:1441cr (28:1441 Petition for Removal-Constitutional Rights)","28:1441crl":"28:1441crl (28:1441 Petition for Removal - 42:1983 Civil Rights)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgement)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrimination)","28:1441em":"28:1441em (28:1441 Petition for Removal-Employment Discrimination)","28:1441er":"28:1441er (28:1441 Petition for Removal-ERISA)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting Act)","28:1441fl":"28:1441fl (28:1441 Petition for Removal-Family & Medical Leave Act)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interpleader)","28:1441lb":"28:1441lb (28:1441 Petition for Removal- Libel,Assualt,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)","28:1441rc":"28:1441rc (28:1441 Petition for Removal-Race Discrimination)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)","28:1441ts":"28:1441ts (28:1441 Petition for Removal-Title VII)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446bc":"28:1446bc (28:1446 Petition for Removal-Breach of Contract)","28:1446er":"28:1446er (28:1446 Petition for Removal-ERISA)","28:1446fl":"28:1446fl (28:1446 Petition for Removal-Fair Labor Standards)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1446sd":"28:1446sd (28:1446 Petition for Removal-Sex Discrimination/Harass)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1491":"28:1491 (28:1491 Claim Against the United States)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus)","28:2242":"28:2242 (28:2242 Petition for Writ of Habeas Corpus)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Petition for Writ of Habeas Corpus (Federal))","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:2679":"28:2679 (28:2679 Petition for Removal-Tort Claims Procedure)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0701":"29:0701 (29:701 Rehabilitation Act of 1973)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:0825":"29:0825 (29:825 The Family and Medical Leave Act of 1993)","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2001":"29:2001 (29:2001 Employee Polygraph Protection Act)","29:2601":"29:2601 (29:2601 Violation of the Family and Medical Leave Act-1993)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","35:1331":"35:1331 (35:1331 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)","38:3116":"38:3116 (38:3116 VA Overpayment)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0257":"40:0257 (40:0257 Land Condemnation Action)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405":"42:0405 (42:0405 Review of HHS Decision)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:12101":"42:12101 (42:12101 American Disability Act for Handicapped)","42:12111":"42:12111 (42:12111 American Disability Act)","42:12117":"42:12117 (42:12117 Americans with Disabilities Act-Enforcement)","42:12131":"42:12131 (42:12131 Americans with Disabilities Act)","42:12133":"42:12133 (42:12133 Americans with Disabilities Act-Enforcement)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1437":"42:1437 (42:1437 Housing Act)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)","42:1973":"42:1973 (42:1973 Voting Rights Act)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1982":"42:1982 (42:1982 Property Rights of Citizens)","42:1983":"42:1983 (42:1983 Other Civil Rights)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1985":"42:1985 (42:1985 Conspiracy to interfere with civil rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:292(f)":"42:292(f) (42:292(f) Registration of State Court Judgment)","42:3601":"42:3601 (42:3601 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:425":"42:425 (42:427 Social Security Benefits)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:6928":"42:6928 (42:6928 Environmental Protection Agency Rules Violation)","42:698":"42:698 ( )","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9601":"42:9601 (42:9601 Environmental Matters)","42:9606":"42:9606 (42:9606 Environmental Matters-Abatement Actions)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","42:9613":"42:9613 (42:9613 Environmental Matters)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0063":"46:0063 (46:63 Marine Personal Injury)","46:0688":"46:0688 (46:0688 Jones Act)","46:0688mp":"46:0688mp (46:688 Maritime Personal Injury)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:3134":"46:3134 (46:3134 Marine Contract Actions)","47:521":"47:521 (47:521 Communications Act)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:10743":"49:10743 (49:10743 Revised Interstate Commerce Act)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summons)","49:32710":"49:32710 (49:32710 Odometer Tampering)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","gj":"gj (Grand Jury Matters)","misc":"misc (Civil Miscellaneous Case)"},"arwdce":{"0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2022":"07:2022 (07:2022 Food Stamp Program: Review of Admin. Decision)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","07:6999":"07:6999 (Review from National Appeals Division-Dept of Agriculture)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1421":"08:1421 (08:1421(c) - Judicial Review of Naturalization Application)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1441a":"12:1441a (12:1441a Resolution Trust Corporation Act)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:2601":"12:2601 (12:2601 Real Estate Settlement Procedures Act (RESPA))","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0072":"15:0072 (15:72 Anti-dumping Act of 1916)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693":"15:1693 (15:1693 Electronic Funds Transfer Act)","15:1701":"15:1701 (15:1701 Interstate Land Sales - Full Disclosure Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:2805":"15:2805 (15:2805 Dispute in Franchise Agreement)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1836a":"18:1836a (18:1836(a) - Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) - Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2255":"18:2255 (18:2255 Violation of Protection of Children Against Sexual Exploitation Act)","18:2721":"18:2721 (18:2721 Driver Privacy Protection Act)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","18:512":"18:512 (18:512 Forfeiture of Motor Vehicle)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0601":"21:0601 (21:0601 Federal Meat Inspection Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0842":"21:0842 (21:842 Drug Abuse Prevention Act)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","22:6081":"22:6081 (22:6081 Cuban Liberty & Democratic Solidarity Act of 1996)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0157e":"28:0157e (28:0157(e) Jury Trial in Bankruptcy Proceeding)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332cafa":"28:1332cafa (28:1332(d) - Class Action Fairness Act - DISCONTINUED)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-core))","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345qt":"28:1345qt (28:1345 Petition to Quiet Title)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1367":"28:1367 (28:1367 Supplemental Jurisdiction)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrimination)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting Act)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interpleader)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443 Petition for Removal - Civil Rights)","28:1443(1)":"28:1443(1) (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1453":"28:1453 (28:1453 Class Action Fairness Act)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Petition for Writ of Habeas Corpus (Federal))","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0217":"29:0217 (29:217 Injunction proceedings to enjoin violations of 29:215)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2101":"29:2101 (29:2101 Worker Adjustment and Retraining Notification Act)","29:2601":"29:2601 (29:2601 Family and Medical Leave Act of 1993)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act - 1977)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3730(h)":"31:3730(h) (31:3730(h) Whistleblower Protection Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","33:2701":"33:2701 (33:2701 Oil Pollution Act of 1990)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:1975":"38:1975 (38:1975 Servicemen's Group Life Insurance Act)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4301":"38:4301 (38:4301 Uniformed Services Employment and Reemployment Act)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:3133":"40:3133 (40:3133 Miller Act)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405rsi":"42:0405rsi (42:0405g Review of HHS Decision (RSI))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0415":"42:0415 (42:415 Windfall Elimination Provision)","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:0532":"42:0532 (42:0532 Dispute in Franchise Agreement)","42:0688":"42:0688 (42:0688 Jones Act Case)","42:11601":"42:11601 (42:11601 International Child Abduction Remedies Act)","42:12101":"42:12101 (42:12101 Americans with Disabilities Act of 1990)","42:12117":"42:12117 (42:12117 Americans with Disabilities-Employment)","42:12133":"42:12133 (42:12133 Americans with Disabilities-Services)","42:12188":"42:12188 (42:12188 Americans with Disabilities-Public Accommodations)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accommodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sh":"42:2000sh (42:2000 Job Discrimination (Sexual Harassment))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:405rsi":"42:405rsi (42:405g Review of HHS Decision (RSI))","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:425":"42:425 (42:427 Social Security Benenfits)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9601":"42:9601 (42:9601 Environmental Act (CERCLA))","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:0251":"47:0251 (47:251 Telecommunications Act of 1996)","47:0277":"47:0277 (47:0277 Telephone Consumer Protection Act)","47:0542":"47:0542 (47:0542 Dispute in Franchise Agreement)","47:0553":"47:0553 (47:0553 Unauthorized Reception of Cable/Satellite TV)","47:0605":"47:0605 (47:0605 Unauthorized Use or Publication of Communication)","47:521":"47:521 (47:521 Cable Communications Policy Act)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)","49:11704":"49:11704 (49:11704 Private Action to Enjoin Abandonment of Service)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summons)","49:2501":"49:2501 (49:2501 Motor Carrier Act of 1984)","50:501":"50:501 (50:501 Servicemembers Civil Relief Act)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"azdce":{"0":"0 (No cause code entered)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693":"15:1693 (15:1693 Electronic Fund Transfer Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1030":"18:1030 (18:1030 Computer Fraud and Abuse Act)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2510":"18:2510 (18:2510 Electronic Communications Privacy Act)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","22:9003":"22:9003 (22:9003 International Child Abduction Remedies Act)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1303":"25:1303 (25:1303 Indian Habeas Corpus)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-Citizenship)","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-core))","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgement)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrimination)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting Act)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interpleader)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Petition for Removal - Breach of Contract - Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2601":"29:2601 (29:2601 FMLA: Family and Medical Leave Act (Findings and Purposes))","29:2617":"29:2617 (29:2617 FMLA: Enforcement)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","31:5317":"31:5317 (Search and forfeiture of monetary instruments)","31:5332":"31:5332 (Bulk cash smuggling into or out of the United States)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4323":"38:4323 (38:4323 Uniformed Services Employment and Reemployment Rights Act)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:3131":"40:3131 (40:3131 Miller Act)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11601":"42:11601 (42:11601 International Child Abduction Remedies Act)","42:12101":"42:12101 (42:12101 Americans with Disabilities Act)","42:12181":"42:12181 (42:12181 Americans with Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:0227":"47:0227 (47:227 Telephone Consumer Protection Act)","47:0605":"47:0605 (47:0605 Communications Act of 1934)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)","49:14706":"49:14706 (49:14706 Carmack Amendment to the Interstate Commerce Act)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","49:32710":"49:32710 (49:32710 Federal Odometer Act)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"cacdce":{"0":"0 (00:0000 Cause Code Unknown)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:0006(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (07:0025 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:0181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:0601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:0287":"08:0287 (08:0287 Petition To Enforce INS Subpoena)","08:1105":"08:1105 (08:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1446":"08:1446 (08:1446 Application for Naturalization Hearing)","08:1447":"08:1447 (08:1447 Denial of Application for Naturalization Hearing)","08:1451":"08:1451 (08:1451(a) Revoke Citizenship)","09:0001":"09:0001 (09:0001 U.S. Arbitration Act)","09:0009":"09:0009 (09:0009 Petition to Confirm Arbitration Award)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:0101 Bankruptcy)","11:0523":"11:0523 (11:0523 Dischargeable Debt)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:0635 Breach of Insurance Contract)","12:1345":"12:1345 (12:1345 Default on Promissory Note - FDIC Receiver)","12:1452":"12:1452 (12:1452(f) Federal Home Loan Mortgage: Investments)","12:1452f":"12:1452f (12:1452(f) Federal Home Loan Mortgage: Investments)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1811":"12:1811 (12:1811 Recovery & Enforcement Act (FIRREA))","12:1818":"12:1818 (12:1818 FDIC)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1904":"12:1904 (12:1904 Credit Controls)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:0001 Antitrust Litigation)","15:0002at":"15:0002at (15:0002 Antitrust Litigation)","15:0002fl":"15:0002fl (15:0002(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0053b":"15:0053b (15:0053(b) Prelim & Perm Inj Relief & Other Equitable Rel)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0106":"17:0106 (17:0106 Motion Pictures & Other Audiovisual Works)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0981":"18:0981 (18:0981 Civil Forfeiture)","18:0982":"18:0982 (18:0982 Criminal Forfeiture)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2510":"18:2510 (18:2510 Wire Interception)","18:3184":"18:3184 (18:3184 Extradition)","18:4108":"18:4108 (18:4108 Prisoner Exchanges)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","18:923f3":"18:923f3 (18:0923(f)(3) Firearms Licensing)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","19:1673":"19:1673 (19:1673 Violations of Antidumping Act)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881dr":"21:0881dr (21:0881 Forfeiture Property - Drugs)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:0154":"23:0154 (23:0154 National Maximum Speed Limit)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331fp":"28:1331fp (28:1331 Forma Pauperis Denial)","28:1331gl":"28:1331gl (28:1331 Guardian Ad Litem Application)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-core))","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Notice of Removal - Account Receivable)","28:1441al":"28:1441al (28:1441 Notice of Removal - Airline Crash)","28:1441as":"28:1441as (28:1441 Notice of Removal - Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Notice of Removal - Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Notice of Removal - Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Notice of Removal - Civil Rights Act)","28:1441df":"28:1441df (28:1441 Notice of Removal - Contract Default)","28:1441dj":"28:1441dj (28:1441 Notice of Removal - Declaratory Judgement)","28:1441ds":"28:1441ds (28:1441 Notice of Removal - Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Notice of Removal - Employment Discrimination)","28:1441fc":"28:1441fc (28:1441 Notice of Removal - Fair Credit Reporting Act)","28:1441fr":"28:1441fr (28:1441 Notice of Removal - Fraud)","28:1441ij":"28:1441ij (28:1441 Notice of Removal - Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Notice of Removal - Insurance Contract)","28:1441int":"28:1441int (28:1441 Notice of Removal - Action for Interpleader)","28:1441lb":"28:1441lb (28:1441 Notice of Removal - Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Notice of Removal - Labor/Mgmnt. Relations)","28:1441mm":"28:1441mm (28:1441 Notice of Removal - Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Notice of Removal - Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Notice of Removal - Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Notice of Removal -- Other Contract)","28:1441pd":"28:1441pd (28:1441 Notice of Removal - Property Damage)","28:1441pi":"28:1441pi (28:1441 Notice of Removal - Personal Injury)","28:1441pl":"28:1441pl (28:1441 Notice of Removal - Product Liability)","28:1441pr":"28:1441pr (28:1441 Notice of Removal)","28:1441qt":"28:1441qt (28:1441 Notice of Removal - Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Notice of Removal - Racketeering (RICO) Act)","28:1441sa":"28:1441sa (28:1441 - Notice of Removal - SEC Act)","28:1441sf":"28:1441sf (28:1441 - Notice of Removal - Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Notice of Removal - Torts to Land)","28:1441tm":"28:1441tm (28:1441 Notice of Removal - Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Petition for Removal - Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Notice of Removal - Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Notice of Removal - Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Notice of Removal)","28:1443":"28:1443 (28:1443(1) Notice of Removal - Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Notice of Removal - Foreclosure)","28:1446in":"28:1446in (28:1446 Notice of Removal - Breach of Contract - Insurance)","28:1446pd":"28:1446pd (28:1446 Notice of Removal - Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Notice of Removal - Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Notice of Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Notice of Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1833a":"28:1833a (28:1833a Civil Penalty - FIRREA)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))","28:2241me":"28:2241me (28:2241 Motion to Extend Time to File 28:2241)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254me":"28:2254me (28:2254 Motion to Extend Time to File 28:2254)","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)","28:2255me":"28:2255me (28:2255 Motion to Extend Time to File 28:2255)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3205":"28:3205 (28:3205 Garnishment)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0207":"29:0207 (29:0207 Maximum Hours)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0790":"29:0790 (29:0790 Rehabilitation of Labor)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2601":"29:2601 (29:2601 Family and Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act - 1977)","30:0923":"30:0923 (30:923 Federal Coal Mine Health and Safety Act of 1969)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)","38:3116":"38:3116 (38:3116 VA Overpayment)","39:0409":"39:0409 (39:0409 Postal Service)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:3008":"39:3008 (39:3008 Pandering)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0425":"42:0425 (42:0425 Suspension of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:0901":"42:0901 (42:0901 Comprehensive Response, Compensation & Liability)","42:12101":"42:12101 (42:12101 Americans With Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","42:9831":"42:9831 (42:9831 Head Start Program)","42:9835(d)":"42:9835(d) (42:9835(d) Head Start Handicap)","43:0945":"43:0945 (43:0945 Compensation for Land Condemnation)","43:0945a":"43:0945a (43:0945(a) Complaint in Condemnation)","43:0946":"43:0946 (43:0946 Complaint in Condemnation - Eminent Domain)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:0953":"46:0953 (46:0953 Foreclosure on Maritime Lien)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:1701":"46:1701 (46:1701 Shipping/Maritime)","47:0227":"47:0227 (47:0227 Violation of Telephone Consumer Protection Act)","47:0521":"47:0521 (47:521 Violations of Cable Communications Act of 1984)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summons)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"caedce":{"0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assualt,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-core))","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgement)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrimination)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting Act)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interpleader)","28:1441lb":"28:1441lb (28:1441 Petition for Removal - Libel, Assault, Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1867":"28:1867 (28:1867 Grand Jury Disclosure)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Petition for Writ of Habeas Corpus (Federal))","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act - 1977)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","32:4323":"32:4323 (32:4323 Employment Rights of Uniformed Officers)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)","38:3116":"38:3116 (38:3116 VA Overpayment)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:0427 Social Security Benefits)","42:12101":"42:12101 (42:12101 Americans with Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:0227":"47:0227 (47:227 Telephone Consumer Protection Act)","47:0553":"47:0553 (47:553 Unauthorized Reception of Cable Service)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summons)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"candce":{"0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1421":"08:1421 (Review of denial of an application for naturalization)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1447":"08:1447 (Application for Naturalization)","08:287":"08:287 (8:287 Petition to Enforce INS Subpoena)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","09:0201":"09:0201 (09:201 Petition for Enforcement of Foreign Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","12:4001":"12:4001 (Expedited Funds Availability Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0053b":"15:0053b (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1361":"16:1361 ()","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1836a":"18:1836a (18:1836(a) - Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) - Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)","20:1071":"20:1071 (Defaulted Student Loan)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6103":"26:6103 (26:6103 Taxpayer wrongful disclosure)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7431":"26:7431 (26:7431 Taxpayer wrongful disclosure)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity-Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fls":"28:1332fls (28:1332 Diversity-Fair Labor Standards Act)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity-Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pp":"28:1332pp (28:1332 Diversity-Personal Property)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 Diversity-Securities & Exchange Commission Act)","28:1332sf":"28:1332sf (28:1332 Diversity-Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity-Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy cases and proceedings under title 11)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-core))","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgement)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrimination)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting Act)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interpleader)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:2201":"28:2201 (28:2201 Constitutionality of State Statutes)","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Petition for Writ of Habeas Corpus (Federal))","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 E.R.I.S.A. Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.: Employee Benefits)","29:1144a":"29:1144a (29:1144(a) E.R.I.S.A supersedes state law employee benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 E.R.I.S.A.)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act - 1977)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1321":"33:1321 ()","33:1344":"33:1344 ()","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1729":"38:1729 (38:1729 Recovery of Medical Payments)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)","38:3116":"38:3116 (38:3116 VA Overpayment)","39:0409":"39:0409 (Postal Service)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0425":"42:0425 (42:427 Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:12101":"42:12101 (42:12101 Americans w/ Disabilities Act (ADA))","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9601":"42:9601 (42:9601 CERCLA)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","42:9613b":"42:9613b (Environmental Matters)","42:9659":"42:9659 (42:9659 CERCLA Comprehensive Environmental Response)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0183":"46:0183 (Petition for limitation of liability)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:227":"47:227 (47:227 Telephone Consumer Protection Act)","47:553":"47:553 (47:553 Communications Act of 1994)","47:605":"47:605 (47:605 Communications Act of 1994)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:10761":"49:10761 (49:10761 I.C.C. Tariff Enforcement Action)","49:1150":"49:1150 ()","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summons)","misc":"misc (Civil Miscellaneous Case)"},"casdce":{"0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0138":"02:0138 (02:0138 Library of Congress Access)","02:0358":"02:0358 (02:0358 President's Recommendations on Exec., Jud. & Leg. Salary)","02:0431":"02:0431 (02:0431 Federal Election Commission: Failure to Enforce Compliance)","02:0437":"02:0437 (02:0437 Federal Election Commission)","02:0681":"02:0681 (02:0681 Deferral of Budget Authority)","02:1202":"02:1202 (02:1202 Discriminatory practices affecting US Senate employees)","02:1301":"02:1301 (02:1301 Congressional Accountability Act)","02:1317(a)":"02:1317(a) (02:1317(a) Violation of Congressional Accountability Act)","05:0101":"05:0101 (05:0101 Ethics in Government Act)","05:0504c2":"05:0504c2 (05:0504(c )(2) Equal Access to Justice (Govt Employees))","05:0551":"05:0551 (05:0551 Administrative Procedures Act)","05:0552bg":"05:0552bg (05:0552b(g)sa Implement requirements of Govt in Sunshine Act)","05:0552fi":"05:0552fi (05:0552fi Freedom of Information Act)","05:0552pa":"05:0552pa (05:0552pa Right to Privacy Act)","05:0554":"05:0554 (05:0554 Adjudications Required by Statutes )","05:0555(b)":"05:0555(b) (05:0555(b) Agency Decision - Right to Counsel )","05:0701":"05:0701 (05:0701 Judicial Review of Agency Decision)","05:0702":"05:0702 (05:0702 Administrative Procedure Act - Right of Review)","05:0704":"05:0704 (05:0704 Labor Litigation)","05:0706":"05:0706 (05:0706 Judicial Review of Agency Action)","05:1508":"05:1508 (05:1508 Judicial Review of Order Issued by the Merit Systems Protection Board)","05:2302":"05:2302 (05:2302 Federal Whistleblowing Act / Civil Service Reform Act (CSRA))","05:3318":"05:3318 (05:3318 Veterans Preference Act)","05:5514":"05:5514 (05:5514 Debt Collection Act of 1982)","05:5542":"05:5542 (05:5542 Federal Employees Pay Act -- overtime rates)","05:7101":"05:7101 (05:7101 Labor-Management Relations (Findings and Purpose))","05:7123":"05:7123 (05:7123 Petition by FLRA against unfair labor practices)","05:7501":"05:7501 (05:7501 Government Employees Adverse Action--14 days or less)","05:7511":"05:7511 (05:7511 Government Employees Adverse Action--Over 14 days)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8101":"05:8101 (05:8101 Workmen's Compensation Benefits)","05:8110":"05:8110 (05:8110 Augmented Compensation for dependents of Govt. Employees)","05:8316":"05:8316 (05:8316 Claims agst US re Retirement for Federal Emp.)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","05:8701":"05:8701 (05:8701 Federal Employees Group Life Insurance Act of 1954)","05:8705":"05:8705 (05:8705 Declaratory Judgment - Insurance)","05:8715":"05:8715 (05:8715 Claims against the US - Jurisdiction of Courts)","05:8901":"05:8901 (05:8901 Federal Employees Health Benefits Act)","05:8902":"05:8902 (05:8902 Contracting Authority of OPM - Group Health Insurance )","05:8903":"05:8903 (05:8903 Federal Employees Health Benefit Act)","05:8912":"05:8912 (05:8912 Claims agst US re health benefits for Federal emp.)","07:0001":"07:0001 (07:0001 Commodity Exchange Act)","07:0006(b)":"07:0006(b) (07:0006(b) Federal Commodity Exchange Regulation)","07:0009a":"07:0009a (07:0009a Recovery of penalties by Commodity Futures Trading Com)","07:0013a":"07:0013a (07:0013a Contract market rules violations; recovery of penalty)","07:0013a-1":"07:0013a-1 (07:0013a-1 Enjoin or restrain violations Contract Market rules)","07:0025":"07:0025 (07:0025 Fraud - Commodities Leverage Contracts)","07:0087":"07:0087 (07:0087 Enforcement of United States Grain Standards Act)","07:0136":"07:0136 (07:0136 Violations of EPA re Environmental Pesticide Control)","07:0181":"07:0181 (07:0181 Packers & Stockyards Act)","07:0193(b)":"07:0193(b) (07:0193(b) Recovery of penalties re violations by packers)","07:0203":"07:0203 (07:0203 Recovery of penalties for violations by stockyards)","07:0209(b)":"07:0209(b) (07:0209(b) Violations re purchase, sale, handling of livestock)","07:0210(f)":"07:0210(f) (07:0210(f) Suit to enforce award of damages (Packers/Stockyards))","07:0213(b)":"07:0213(b) (07:0213(b) Unfair, discriminatory, deceptive practice/marketing)","07:0216":"07:0216 (07:0216 Injunctions to restrain & enforce orders of Secretary)","07:0222":"07:0222 (07:0222 Adoption of FTC powers for enforcement.)","07:0228a":"07:0228a (07:0228a Request by Secretary for TRO or Inj. re Poultry)","07:0245":"07:0245 (07:0245 Action on bond by person injured in Warehouse)","07:0292":"07:0292 (07:0292 Monopolizing or restraining trade & enhancing prices)","07:0499":"07:0499 (07:0499 Agricultural Commodities Act)","07:0601":"07:0601 (07:0601 USDA Condemnation)","07:0608":"07:0608 (07:0608 Agriculture Adjustment Act)","07:0901":"07:0901 (07:0901 Rural Electrification Act)","07:1291(b)":"07:1291(b) (07:1291(b) Agricultural Adjustment Act; freight rates.)","07:1376":"07:1376 (07:1376 Adjustment of Quotas and Enforcement; penalties.)","07:1501":"07:1501 (07:1501 Federal Crop Insurance Act)","07:1508":"07:1508 (07:1508 Crop Insurance)","07:1631":"07:1631 (07:1631 Food Security Act)","07:1721":"07:1721 (07:1721 Agricultural Trade Development Asst Act)","07:1922":"07:1922 (07:1922 Persons Eligible for Loans - Forclosure)","07:1926":"07:1926 (07:1926 Water and Waste Facility Loans and Grants)","07:1930":"07:1930 (07:1930 Perishable Agric. Comm. Act of 1930)","07:2011":"07:2011 (07:2011 Supplemental Nutrition Assistance Program)","07:2022":"07:2022 (07:2022 Disposition of Claims: Denial application to participate; food stamp prog.)","07:2023(a)":"07:2023(a) (07:2023(a) Judicial Review of Food Stamp Disqualification)","07:2024":"07:2024 (07:2024 False Claims Act, Food Stamp Fraud)","07:2131":"07:2131 (07:2131 Violation of the Animal Welfare Act)","07:2146":"07:2146 (07:2146 Transportation, Sale, and Handling of Animals)","07:2301":"07:2301 (07:2301 Agricultural Fair Practices Act)","07:2305":"07:2305 (07:2305 Unfair trade practices affecting producers Agri prod)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","07:2563":"07:2563 (07:2563 Plant Variety Protection and Rights - Injunction)","07:499E(c)":"07:499E(c) (07:499E(c )(4) Perishable Agricultural Commodities Act (PACA))","07:6999":"07:6999 (07:6999 Judicial Review of Adverse Farm Agency Decision)","08:1101i":"08:1101i (08:1101i Immigration & Nationality Act (Definitions))","08:1105a":"08:1105a (08:1105a Immigration: Judicial Review for Battered Spouses; Deportation (INS))","08:1151":"08:1151 (08:1151 Immigration and Nationality Act of 1952)","08:1152":"08:1152 (08:1152 Immigration: Numerical limitations on individual foreign states)","08:1153":"08:1153 (08:1153 Immigration: Allocation of Immigrant Visas)","08:1154":"08:1154 (08:1154 Immigration: Procedure for Granting Immigration Status)","08:1158":"08:1158 (08:1158 Immigration & Nationality Act, Section 208 (Asylum))","08:1182":"08:1182 (08:1182 Inadmissible Aliens: Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1183":"08:1183 (08:1183 Admission of Aliens on Giving Bond or Undertaking; Return on Departure)","08:1188":"08:1188 (08:1188 Immigration: Admission of Temporary H-2A Workers)","08:1225":"08:1225 (08:1225 Immigration: Enforcement of Administrative Subpoena)","08:1231(a)":"08:1231(a) (08:1231(a) Immigration: Due Process Clause)","08:1251(A)":"08:1251(A) (08:1251(A)(4) Immigration: Application for a Stay of Deportation)","08:1252":"08:1252 (08:1252 Judicial Review of Orders of Removal)","08:1255":"08:1255 (08:1255 Immigration: Failure USCIS To Adjudicate Permanent Residency Petition)","08:1260":"08:1260 (08:1260 Aliens: Removal of Aliens Falling into Distress)","08:1324":"08:1324 (08:1324 Immigration: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Immigration: Writ of Mandamus to Adjudicate Visa Petition)","08:1357":"08:1357 (08:1357 Immigration and Nationality Act - Administrative Search Warrant)","08:1421":"08:1421 (08:1421 Immigration: Naturalization Authority)","08:1445":"08:1445 (08:1445 Immigration: Application for Naturalization)","08:1446":"08:1446 (08:1446 Immigration: Petition for Naturalization Hearing)","08:1447":"08:1447 (08:1447 Immigration: Review of Denial of Naturalization Application)","08:1451":"08:1451 (08:1451 Immigration: Revocation of Citizenship)","08:1451(a)":"08:1451(a) (08:1451(a) Action to revoke Citizenship)","08:1451(j)":"08:1451(j) (08:1451(j) Immigration: Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:0001 U.S. Arbitration Act)","09:0003":"09:0003 (09:0003 Application to Stay Proceedings Pending Arbitration)","09:0004":"09:0004 (09:0004 Petition to order arbitration; failure to arbitrate)","09:0007":"09:0007 (09:0007 Petition to compel attendance before arbitrator)","09:0008":"09:0008 (09:0008 Declaratory Judgment/Admiralty)","09:0009":"09:0009 (09:0009 Motion to Confirm Arbitration Award)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","09:0011":"09:0011 (09:0011 Motion to modify or correct arbitration award)","09:0201":"09:0201 (09:0201 Petition to Compel/Stay Arbitration under an Insurance Contract)","09:0202":"09:0202 (09:0202 Award under Convention on Foreign Arbitral Awards)","09:0205":"09:0205 (09:0205 Removal from State Court: Enforcement of Foreign Arbital Awards)","09:0207":"09:0207 (09:0207 Application for order confirming award of arbitrators)","10:0672":"10:0672 (10:0672 Armed Forces: Active Guard/Reserve (AGR) Program)","10:1006":"10:1006 (10:1006 Armed Forces: Review of Agency Decision)","10:1072tc":"10:1072tc (10:1072tc Armed Forces: TRICARE PROGRAM)","10:1089c":"10:1089c (10:1089(c ) Armed Forces: Removal; dft acting in scope of duties)","10:1091":"10:1091 (10:1091 Armed Forces: Personal Service Contracts)","10:1107":"10:1107 (10:1107 Armed Forces: Use Of Investigational New Drug)","10:1408":"10:1408 (10:1408 Armed Forces: Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: Review of Discharge or Dismissal)","10:2005":"10:2005 (10:2005 Armed Forces: Advanced Education Assistance)","10:2121":"10:2121 (10:2121 Armed Forces: Health Professions Scholarship Financial Asst Prog)","10:2302":"10:2302 (10:2302 Armed Forces: Arms Services Procurement Act)","10:2305":"10:2305 (10:2305 Armed Forces: Review of Federal Contract)","10:2323fa":"10:2323fa (10:2323fa Armed Forces: Fifth Amendment Equal Protection: Contract Goal for Small Disadv Businesses)","10:2733":"10:2733 (10:2733 Armed Forces: Military Claims Act)","10:2734":"10:2734 (10:2734 Armed Forces: Foreign Military Claims Act)","10:2771":"10:2771 (10:2771 Armed Forces: Final Settlement - Deceased Members)","10:3258":"10:3258 (10:3258 Armed Forces: Reg.Army: Re-enlistment after Service as Ofcr)","11:0101":"11:0101 (11:0101 Bankruptcy (Definitions))","11:0110":"11:0110 (11:0110 Bankruptcy: Penalty for Preparers of Fraudulent or Negligent Petitions)","11:0362(h)":"11:0362(h) (11:0362(h) Bankruptcy: Violation of Automatic Stay)","11:0523":"11:0523 (11:0523 Bankruptcy: Exceptions to Discharge)","11:0524":"11:0524 (11:0524 Bankruptcy: Effect of Discharge)","11:0525":"11:0525 (11:0525 Bankruptcy: Protections Against Discriminatory Treatment )","11:0548":"11:0548 (11:0548 Bankruptcy: Fraudulent Transfers and Obligations)","11:0704":"11:0704 (11:0704 Bankruptcy: Duties of Trustee)","12:0085":"12:0085 (12:0085 National Banks: Rate of Interest on Loans, Discounts, and Purchases)","12:0093(a)":"12:0093(a) (12:0093(a) National Banks: Violation of Prov; Forfeit of Franchise; Personal Liability of Director)","12:0191":"12:0191 (12:0191 National Banks: Appointment of Receiver)","12:0192":"12:0192 (12:0192 National Banks: Liquidation of National Bank)","12:0215":"12:0215 (12:0215 National Banks: Consolidation and Merger)","12:0622":"12:0622 (12:0622 Foreign Banking: Forfeiture, Dissolution & Liability of Dirs & Officers for Noncompliance)","12:0632":"12:0632 (12:0632 Foreign Banking: Voluntary Liquidation)","12:0635i-3":"12:0635i-3 (12:0635i-3 Export-Import Bank: Breach of Insurance Contract)","12:1421":"12:1421 (12:1421 Federal Home Loan Bank Act (Short Title))","12:1441":"12:1441 (12:1441 FHLB: Financial Inst Reform Receiving Enforcement Act 1989)","12:1451":"12:1451 (12:1451 Emergency Home Loan Corporation (Definitions))","12:1452":"12:1452 (12:1452 Federal Home Loan Mortgage Corporation Act)","12:1452(f)":"12:1452(f) (12:1452(f) Fed Home Loan Mortgage Corp: Actions by and against the Corporation)","12:1455(b)":"12:1455(b) (12:1455(b) Fed Home Loan Mortgage Corp: Enforcement of Regulations)","12:1461":"12:1461 (12:1461 Savings Associations: Homeowners Loan Act (Short Title))","12:1464":"12:1464 (12:1464 Savings Associations: Federal Savings and Loan)","12:1703":"12:1703 (12:1703 National Housing: Insurance of Financial Institutions)","12:1715(b)":"12:1715(b) (12:1715(b) National Housing: Rules and Regulations)","12:1749aaa":"12:1749aaa (12:1749aaa National Housing: National Insurance Development Program)","12:1751":"12:1751 (12:1751 Fed Credit Unions: Short Title)","12:1782":"12:1782 (12:1782 Fed Credit Unions: Administration of Insurance Fund)","12:1786":"12:1786 (12:1786 Fed Credit Unions: Actions re Violations by Credit Unions)","12:1787aB":"12:1787aB (12:1787(a)(B) Fed Credit Unions: Liquidation of Insured Credit Union by Board)","12:1789a2":"12:1789a2 (12:1789(a)(2) Fed Credit Unions: Admin Provision to Sue and be Sued)","12:1811":"12:1811 (12:1811 FDIC: Financial Inst. Reform Recovery Act of 1989 (FIRREA) (Organization of FDIC))","12:1818":"12:1818 (12:1818 FDIC: Violations re Federal Deposit Insurance Corporation)","12:1818(e)":"12:1818(e) (12:1818(e) FDIC: Suspension or Removal of Bank Officer)","12:1819":"12:1819 (12:1819 FDIC: Corporate Powers )","12:1821":"12:1821 (12:1821 FDIC: Insurance Funds )","12:1831":"12:1831 (12:1831 FDIC: Separability of Certain Provisions)","12:1831(d)":"12:1831(d) (12:1831(d) FDIC: Deposit. Inst. Dereg. & Monetary Ctrl. Act of 1980)","12:1831r-1":"12:1831r-1 (12:1831r-1 FDIC: Notice of Branch Closure)","12:1833(a)":"12:1833(a) (12:1833(a) FDIC: Forfieture Civil Penalties)","12:1954":"12:1954 (12:1954 Injunctions (Action by Sec of Treasury re financial recordkeeping))","12:1971":"12:1971 (12:1971 Relief under Bank Holding Company Act (Definitions))","12:1972":"12:1972 (12:1972 Tying Arrangement Act)","12:2001":"12:2001 (12:2001 Farm Credit Act of 1971)","12:2601":"12:2601 (12:2601 Real Estate Settlement Procedures Act (RESPA) (findings & purpose))","12:2604(c)":"12:2604(c) (12:2604(c) Real Estate Settlement Procedures Act (RESPA))","12:2605":"12:2605 (12:2605 RESPA: Servicing of Mortgage Loans)","12:2607":"12:2607 (12:2607 RESPA: Violation re kickbacks/unearned fees; Real Estate)","12:2609":"12:2609 (12:2609 RESPA: Escrow)","12:3012":"12:3012 (12:3012 National Consumer Cooperative Bank: Suits by or against Bank)","12:3410":"12:3410 (12:3410 Right to Financial Privacy: Customer Challenges )","12:3751":"12:3751 (12:3751 Single Family Mortgage Forclosure Act: Findings and Purpose)","12:3801":"12:3801 (12:3801 Alternative Mortgage Transaction Parity Act)","12:3907":"12:3907 (12:3907 International Lending Supervision: Capital Adequacy)","12:4010":"12:4010 (12:4010 Expedited Funds Availability: Violation of Act (Civil Liability))","12:5101":"12:5101 (12:5101 Fraudulent Transfer Act (Enforcement for Mortgage Licensing))","15:0001":"15:0001 (15:0001 Antitrust Litigation (Monopolizing Trade))","15:0002at":"15:0002at (15:0002at Antitrust Litigation)","15:0002fl":"15:0002fl (15:0002fl Antitrust Litigation)","15:0004":"15:0004 (15:0004 USDC Jurisdiction re violations of Sec. 1-7 of Title 15)","15:0005":"15:0005 (15:0005 Bringing in Additional Parties)","15:0009":"15:0009 (15:0009 USDC Jurisdiction re violations of Sec. 8 of Title 15)","15:0013":"15:0013 (15:0013 Robinson Patman Act)","15:0014":"15:0014 (15:0014 Clayton Act)","15:0015":"15:0015 (15:0015 Antitrust Litigation)","15:0025":"15:0025 (15:0025 Clayton Act)","15:0026":"15:0026 (15:0026 Suit for injunctive relief re violation antitrust laws)","15:0041":"15:0041 (15:0041 Federal Trade Commission Act)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act (unfair or deceptive acts))","15:0045cp":"15:0045cp (15:0045cp Violation of Children Online Privacy Protection Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act )","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0053(b)":"15:0053(b) (15:0053(b) Prelim & Perm Inj Relief & other Equitable Relief)","15:0068":"15:0068 (15:0068 Proceedings re FTC violations re wool products)","15:0069":"15:0069 (15:0069 Proceedings re FTC violations re fur products)","15:0070":"15:0070 (15:0070 Proceedings re FTC violations re textile fiber product)","15:0077":"15:0077 (15:0077 Securities Fraud)","15:0078jb":"15:0078jb (15:0078j(b)ss Stockholder Suit)","15:0078ma":"15:0078ma (15:0078m(a) Securities Exchange Act)","15:0079":"15:0079 (15:0079 Public Utility Holding Companies)","15:0080a-3":"15:0080a-3 (15:0080a-3 Investment Company Act of 1940)","15:0260":"15:0260 (15:0260 Proceedings re weights and measures and standard time)","15:0298":"15:0298 (15:0298 Violation of Law Proceedings re gold or silver)","15:0433":"15:0433 (15:0433 Discrimination against farmers)","15:0631":"15:0631 (15:0631 Small Business Act)","15:0636":"15:0636 (15:0636 Small Business Act - Aid to small business)","15:0661":"15:0661 (15:0661 Small Business Investment Act of 1958)","15:0687":"15:0687 (15:0687 Small Business Investment Program)","15:0714(b)":"15:0714(b) (15:0714(b) Commodity Credit Corporation)","15:0715(f)":"15:0715(f) (15:0715(f) Proceedings re petroleum and petroleum products)","15:0717":"15:0717 (15:0717 Natural Gas Act)","15:0719ic":"15:0719ic (15:0719i(c ) Civil actions re violations or inj involving Gas)","15:0766":"15:0766 (15:0766 Controversies arising re Federal Energy Admin. rules)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1071":"15:1071 (15:1071 Appeal of Decision of U.S. Patent & Trademark Office (Comm / Trademark Trial Bd))","15:1114":"15:1114 (15:1114 Trademark Infringement (Lanham Act))","15:1116":"15:1116 (15:1116 Inj to prevent violation rights of trademark owner)","15:1120":"15:1120 (15:1120 Trademark - False or Fraudulent Registration)","15:1121":"15:1121 (15:1121 Trademark Infringement (jurisdiction))","15:1125(a)":"15:1125(a) (15:1125(a) False representation of goods sold in interstate commerce)","15:1125dac":"15:1125dac (15:1125(d)ac Trademark (Anticybersquatting consumer protection))","15:1125la":"15:1125la (15:1125la Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Trademarks - International conventions)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1191":"15:1191 (15:1191 Flamable Fabrics Act)","15:1221":"15:1221 (15:1221 Auto Dealer Suits Agst Manufacturers)","15:1261":"15:1261 (15:1261 Hazardous Substances (definitions))","15:1263":"15:1263 (15:1263 Prohibited Hazardous Substance - Interstate Commerce)","15:1267(a)":"15:1267(a) (15:1267(a) Federal Hazardous Substances Act)","15:1314":"15:1314 (15:1314 Antitrust--Petition for enforcement)","15:1501":"15:1501 (15:1501 Estab of Dept of Commerce)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1605":"15:1605 (15:1605 Determination of Finance Charge)","15:1638":"15:1638 (15:1638 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1666":"15:1666 (15:1666 Fair Credit Billing Act Dispute)","15:1667":"15:1667 (15:1667 Consumer Leasing Act)","15:1679":"15:1679 (15:1679 Violation of Credit Repair Organizations Act)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1691":"15:1691 (15:1691 Equal Credit Opportunity Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693ef":"15:1693ef (15:1693ef Electronic Funds Transfer Act)","15:1693m":"15:1693m (15:1693m Violation of Prov. of Subchpt.VI (Electronic Fund Transfers))","15:1701":"15:1701 (15:1701 Interstate Land Sales Full Disclosure Act (ILFFDA))","15:1709":"15:1709 (15:1709 Interstate Land Sales )","15:1714":"15:1714 (15:1714 Actions to enjoin violations re interstate land sale)","15:2071":"15:2071 (15:2071 Consumer Product Safety; Condemnation hazardous prod)","15:2073":"15:2073 (15:2073 Private action to enforce Consumer Product Safety)","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2310(c)":"15:2310(c) (15:2310(c ) Consumer Product Warranties)","15:2601":"15:2601 (15:2601 Toxic Substances Control Act (TCSA))","15:2604":"15:2604 (15:2604 Application for inj re distribution toxic substance)","15:2616":"15:2616 (15:2616 Toxic Substance control; seizure of chemical)","15:2620":"15:2620 (15:2620 Toxic Substances Control Act: citizen's petition)","15:2651":"15:2651 (15:2651 Asbestos Hazard Emergency Response Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:2805":"15:2805 (15:2805 Petroleum Marketing Practices-Franchise Protection)","15:34-35":"15:34-35 (15:34-35 Investment Company Act of 1940 )","15:3414":"15:3414 (15:3414 National Gas Policy Act)","15:3710a":"15:3710a (15:3710a Federal Technology Transfer Act of 1986)","15:3901":"15:3901 (15:3901 Federal Risk Retention Act)","15:6801":"15:6801 (15:6801 Gram-Leach-Bliley Act)","15:7701":"15:7701 (15:7701 Federal CAN-Spam Act)","16:0019jj":"16:0019jj (16:0019jj Park System Resource Protection Act)","16:0470":"16:0470 (16:0470 Archaeological resources Protection Act)","16:0470f":"16:0470f (16:0470f National Historic Preservation Act)","16:0668":"16:0668 (16:0668 Bald and Golden Eagle Protection Act)","16:0669":"16:0669 (16:0669 Pittman-Robertson Conservation Restoration Act)","16:0675":"16:0675 (16:0675 Norbeck Wildlife Preserve Organic Act)","16:0703":"16:0703 (16:0703 Migratory Bird Act)","16:0823a":"16:0823a (16:0823a Federal Public Utility Regulatory Policies Act)","16:0825":"16:0825 (16:0825 Federal Power Commission Regulation; Public Utilities)","16:0831":"16:0831 (16:0831 Actions re: rights of Tennessee Valley Authority)","16:1244":"16:1244 (16:1244 National Scenic and National Historic Trails)","16:1374d6":"16:1374d6 (16:1374(d)(6) Petition for Review re Application for Import of Polar Bear Trophies)","16:1531":"16:1531 (16:1531 Endangered Species Act)","16:1533":"16:1533 (16:1533 Endangered Species Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:1540":"16:1540 (16:1540 Endangered Species Act - Penalties and Enforcement)","16:1600":"16:1600 (16:1600 National Forest Management Act of 1976)","16:1801":"16:1801 (16:1801 Magnuson-Stevens Fishery Conservation and Management Act )","16:1858":"16:1858 (16:1858 National Fishery Management Program - Civil Penalties and Permit Sanctions)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act (Definitions))","16:3372":"16:3372 (16:3372 Lacey Act: Prohibited Acts)","16:3373":"16:3373 (16:3373 Lacey Act: Penalties and Sanctions - Appeal of Decision - DOI )","16:3374":"16:3374 (16:3374 Lacey Act: Complaint for Forfeiture )","17:0101":"17:0101 (17:0101 Copyright Infringement (definitions))","17:0201":"17:0201 (17:0201 Ownership of Copyright)","17:0205(d)":"17:0205(d) (17:0205(d) Priority Between Conflicting Transfers)","17:0407":"17:0407 (17:0407 Recovery of fines & penalties by Register of Copyrights)","17:0411(b)":"17:0411(b) (17:0411(b) Action by copyright owner for infringement)","17:0501":"17:0501 (17:0501 Copyright Infringement)","17:0502(a)":"17:0502(a) (17:0502(a) Inj to prevent or restrain infringement copyright)","17:0504":"17:0504 (17:0504 Remedies for Copyright Infringement)","17:0512":"17:0512 (17:0512 Copyright Infringement of Digital Communications)","17:1201":"17:1201 (17:1201 Digital Millennium Copyright Act)","18:0492":"18:0492 (18:0492 Forfeiture of Counterfeit Paraphernalia)","18:0603":"18:0603 (18:0603 Conflict of Interest)","18:0922":"18:0922 (18:0922 Firearms - Unlawful Possession (Civil Fines) )","18:0923f3":"18:0923f3 (18:0923(f)(3) Review of Revocation of a License as a Dealer in Firearms)","18:0925(c)":"18:0925(c) (18:0925(c) Restoration of ability to possess firearms/ammo)","18:0981":"18:0981 (18:0981 Civil Forfeiture)","18:0981a1A":"18:0981a1A (18:0981(a)(1)(A) Civil Forfeiture: Money Laundering Control Act)","18:0983":"18:0983 (18:0983 Civil Forfeiture - General Rules)","18:1030":"18:1030 (18:1030 Fraud & Related Activity in Connection with Computers)","18:1345":"18:1345 (18:1345 Injunction against Fraud)","18:1514":"18:1514 (18:1514 Civil Action to Restrain Harassment of a Victim)","18:1514A":"18:1514A (18:1514A Civil Action to Protect Against Retaliation in Fraud Cases)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1905":"18:1905 (18:1905 Disclosure of Confidential Information)","18:1955":"18:1955 (18:1955 Civil Forfeiture-Prohibition of Illegal Gambling)","18:1956b3":"18:1956b3 (18:1956(b)(3) Laundering of Monetary Instruments - Forfeit Property)","18:1964":"18:1964 (18:1964 Civil Remedies: Racketeering (RICO) Act)","18:1968":"18:1968 (18:1968 Action re civil investigative demand)","18:2254":"18:2254 (18:2254 Civil Forfeiture - Exploitation of Children)","18:2333":"18:2333 (18:2333 Civil Remedies: Anti-Terrorism Act of 1991)","18:2511":"18:2511 (18:2511 Wiretapping - Injunctive Relief or Civil Fine)","18:2520":"18:2520 (18:2520 Civil Damages for Interception Wire or Oral Communications)","18:2707":"18:2707 (18:2707 Civil Action: Stored Communications)","18:2710c":"18:2710c (18:2710(c) Wrongful Disclosure of Video Tape Rental or Sales Records)","18:2724":"18:2724 (18:2724 Civil Action - Motor Vehicle Records)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:3184":"18:3184 (18:3184 Extradition Procedure)","18:3663":"18:3663 (18:3663 Civil Enforcement of Crim. Rest. Obligation)","18:4100":"18:4100 (18:4100 Transfer of Offenders)","19:1305":"19:1305 (19:1305 Customs Duties: Forfeiture-Immoral Articles)","19:1497":"19:1497 (19:1497 Customs Duties: Penalty for Failure to Declare)","19:1595a":"19:1595a (19:1595a Customs Duties: Forfeiture and Other Penalties)","19:1607":"19:1607 (19:1607 Customs Duties: Notice of Seizure)","20:0107":"20:0107 (20:0107 Randolph-Sheppard Vending Stand Act)","20:1070":"20:1070 (20:1070 Student Assistance)","20:1080":"20:1080 (20:1080 Default of Student Loan: Recovery)","20:1087":"20:1087 (20:1087 Student Loan Discharge)","20:1095a":"20:1095a (20:1095a Education - Wage Garnishment Requirement)","20:1097":"20:1097 (20:1097 Education - Criminal penalties for fraud)","20:1098g":"20:1098g (20:1098g Higher Education Act - Exemption from state disclosure)","20:1232(g)":"20:1232(g) (20:1232(g) Family Education Rights & Privacy Act of 1974)","20:1400":"20:1400 (20:1400 IDEA: Individuals With Disabilities Education Act (short title))","20:1401":"20:1401 (20:1401 IDEA: Education of Individuals with Disabilities (definitions))","20:1412":"20:1412 (20:1412 IDEA: State Eligibility)","20:1415":"20:1415 (20:1415 IDEA: Challenge decision re education for handicapped )","20:1415e2":"20:1415e2 (20:1415(e)(2)de IDEA: Mediation)","20:1681":"20:1681 (20:1681 Title IX Educational Amendments 1992 - Sex Discrimination)","20:1683":"20:1683 (20:1683 Judicial Review: Prohibition against sex discrimination in education)","20:1706":"20:1706 (20:1706 Relief from denial of equal educational opportunity)","20:1717":"20:1717 (20:1717 Reopening proceedings w/order to end segregation)","21:0301":"21:0301 (21:0301 Federal Food, Drug & Cosmetic Act)","21:0331":"21:0331 (21:0331 Federal Food, Drug & Cosmetic Act - Prohibited Acts)","21:0332":"21:0332 (21:0332 Federal Food, Drug and Cosmetic Act, Injunctive Relief)","21:0332(a)":"21:0332(a) (21:0332(a) Federal Food, Drug, and Cosmetic Act)","21:0334(a)":"21:0334(a) (21:0334(a) Forfeiture or condemnation-food, drug, cosmetics)","21:0348":"21:0348 (21:0348 Federal Food, Drug and Cosmetic Act - Food Additives)","21:0360":"21:0360 (21:0360 Federal Food, Drug & Cosmetic Act - Drugs and Devices)","21:0467":"21:0467 (21:0467 Seizure and condemnation of poultry products)","21:0601":"21:0601 (21:0601 Federal Meat Inspection Act 21 USC 601-695 (Definitions))","21:0673":"21:0673 (21:0673 Seizure and condemnation of meat or meat products)","21:0674":"21:0674 (21:0674 Proceeding to enforce & enjoin re meat products)","21:0821":"21:0821 (21:0821 Violation of Record Keeping Provision of Controlled Substance Act)","21:0841":"21:0841 (21:0841 Forfeiture Property - Drugs)","21:0842":"21:0842 (21:0842 Civil Penalty for violation re controlled substance)","21:0881":"21:0881 (21:0881 Forfeiture Property - Drugs)","21:0881a":"21:0881a (21:0881a Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:0881re Forfeiture Property - Real Estate)","21:0882":"21:0882 (21:0882 Inj to enjoin violations re controlled substance)","21:1049":"21:1049 (21:1049 Seizure and condemnation re eggs or egg products)","22:0286":"22:0286 (22:0286 Action against World Bank or IMF)","22:2702":"22:2702 (22:2702 Medical Malpractice by Govt. Medical Personnel)","22:3612":"22:3612 (22:3612 Claim for Damage to Panama Canal)","22:3776":"22:3776 (22:3776 Panama Canal Commission Action on claims)","22:3777":"22:3777 (22:3777 Investigation of accident or injury giving rise to a claim)","22:4140":"22:4140 (22:4140 Foreign Service Grievance Act - Judicial Review)","23:0112":"23:0112 (23:0112 Federal Highway Act - Letting of Contracts)","23:0134":"23:0134 (23:0134 Metropolitan Transportation Planning)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","25:2701":"25:2701 (25:2701 Indian Gaming Regulatory Act (IGRA))","25:4101":"25:4101 (25:4101 Native American Housing Assistance and Self-Determination Act (NAHASDA))","26:0063":"26:0063 (26:0063 IRS: Taxable income (Definition))","26:0982":"26:0982 (26:0982 IRS: To Quash IRS Formal Document Request)","26:2032":"26:2032 (26:2032 IRS: Alternate valuation)","26:6212":"26:6212 (26:6212 IRS: Notice of Deficiency (Injunctive Relief from IRS Lien))","26:6213":"26:6213 (26:6213 IRS: Injunctive Relief from IRS Lien in Tax Court)","26:6221":"26:6221 (26:6221 IRS: TEFRA Tax, Equity and Fiscal Responsibility Act of 1982)","26:6226":"26:6226 (26:6226 IRS: Judicial Review of Partnership Adjustment)","26:6320":"26:6320 (26:6320 IRS: Notice and Opportunity for Hearing upon Filing Notice of Lien)","26:6330":"26:6330 (26:6330 IRS: Notice and Opportunity for Hearing before Levy)","26:6331":"26:6331 (26:6331 IRS: Wrongful Levy)","26:6334":"26:6334 (26:6334 IRS: Property Exempt from Levy)","26:6502":"26:6502 (26:6502 IRS: Collection after Assessment (Enforcement of tax liens))","26:6532":"26:6532 (26:6532 IRS: Periods of Limitation on Suits)","26:6653sp":"26:6653sp (26:6653sp IRS: Failure to Pay Stamp Tax)","26:6672":"26:6672 (26:6672 IRS: Failure to Collect and Pay Over Tax, or Attempt to Evade or Defeat Tax)","26:6694":"26:6694 (26:6694 IRS: Underestimate Of Tax Liability By Tax Preparer)","26:6702":"26:6702 (26:6702 IRS: Penalty for Frivolous Tax Submission)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7323":"26:7323 (26:7323 IRS: Proceedings in rem enforce forfeitures property)","26:7401":"26:7401 (26:7401 IRS: Tax Liability - Authorization to collect via civil action)","26:7402":"26:7402 (26:7402 IRS: Jurisdiction of District Courts)","26:7403":"26:7403 (26:7403 IRS: Action to Enforce Federal Tax Lien)","26:7404":"26:7404 (26:7404 IRS: Action for collection of estate tax)","26:7405":"26:7405 (26:7405 IRS: Action for recovery of refunds erroneously made)","26:7407":"26:7407 (26:7407 IRS: Action to enjoin income tax preparers)","26:7422rt":"26:7422rt (26:7422rt IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422rx IRS: Refund Excise Tax)","26:7425(a)":"26:7425(a) (26:7425(a) IRS: Judiciary & Judicial Procedures - Discharge of Liens)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7428":"26:7428 (26:7428 IRS: Declaratory Judgment)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7430":"26:7430 (26:7430 IRS: Awarding of Costs and Certain Fees in Tax Suit)","26:7431":"26:7431 (26:7431 IRS: Unauthorized Disclosure of Return & Return Info)","26:7434":"26:7434 (26:7434 IRS: Civil Damages for Fraudulent Filing of Information)","26:7604":"26:7604 (26:7604 IRS: Enforce summons; examination books & witnesses)","26:7604(a)":"26:7604(a) (26:7604(a) IRS: Complaint to Enforce IRS Summons)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","26:7609en":"26:7609en (26:7609en IRS: Petition to serve Third-Party Summons)","28:0157(b)":"28:0157(b) (28:0157(b) Bankruptcy Claim to be tried in U.S. District Court)","28:0157(c)":"28:0157(c) (28:0157(c )(1) Findings, Concl. & Proposed Judgment)","28:0157(d)":"28:0157(d) (28:0157(d) Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (District or BAP))","28:0463":"28:0463 (28:0463 Expenses of Judicial Litigation)","28:0534":"28:0534 (28:0534 Arrest Records)","28:0591":"28:0591 (28:0591 Independent Counsel)","28:0592":"28:0592 (28:0592 Independent Counsel - Application for Appointment)","28:0593":"28:0593 (28:0593 Independent Counsel - Court Responsibilities)","28:0594":"28:0594 (28:0594 Independent Counsel - Responsibilities)","28:0595":"28:0595 (28:0595 Independent Counsel - Congressional Oversight)","28:0596":"28:0596 (28:0596 Independent Counsel - Removal)","28:0597":"28:0597 (28:0597 Independent Counsel - Dept. of Justice Relationship)","28:0598":"28:0598 (28:0598 Independent Counsel - Chapter Termination)","28:0636":"28:0636 (28:0636 Jurisdiction and Power of Magistrate Judges)","28:0754":"28:0754 (28:0754 Receiver of Property in Different Districts )","28:1291":"28:1291 (28:1291 Maritime)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331ag":"28:1331ag (28:1331ag Fed. Question: Employment Discrimination (Age))","28:1331al":"28:1331al (28:1331al Fed. Question: Airline Crash)","28:1331as":"28:1331as (28:1331as Fed. Question: Assault, Libel, Slander)","28:1331at":"28:1331at (28:1331at Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331au Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331b Fed. Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331bc Fed. Question: Breach of Contract)","28:1331bv":"28:1331bv (28:1331bv Fed. Question: Bivens-Prisoner)","28:1331ca":"28:1331ca (28:1331ca Fed Question: Fed Communications Act)","28:1331cm":"28:1331cm (28:1331cm Fed. Question: Interstate Commerce Act)","28:1331cr":"28:1331cr (28:1331cr Fed. Question: Civil Rights (Race Discrimination))","28:1331cv":"28:1331cv (28:1331cv Fed. Question: Other Civil Rights)","28:1331dd":"28:1331dd (28:1331dd Fed. Question: Discovery Disputes (conversion case))","28:1331dj":"28:1331dj (28:1331dj Fed. Question: Declaratory Judgment)","28:1331dp":"28:1331dp (28:1331dp Fed. Question: Violation of Due Process)","28:1331ed":"28:1331ed (28:1331ed Fed. Question: Employment Discrimination)","28:1331ef":"28:1331ef (28:1331ef Fed. Question: Civil Rights Violation (Excess Force))","28:1331ej":"28:1331ej (28:1331ej Fed. Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331es Fed. Question: Enforcement of Administrative Subpoena)","28:1331fa":"28:1331fa (28:1331fa Fed. Question: Civil Rights Violation-False Arrest)","28:1331fl":"28:1331fl (28:1331fl Fed. Question: Fair Labor Standards)","28:1331fm":"28:1331fm (28:1331fm Fed. Question: Family and Medical Leave Act)","28:1331fr":"28:1331fr (28:1331fr Fed. Question: Fraud)","28:1331in":"28:1331in (28:1331in Fed. Question: Insurance Contract)","28:1331lm":"28:1331lm (28:1331lm Fed. Question: Legal Malpractice)","28:1331mm":"28:1331mm (28:1331mm Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331ng Fed. Question: Natural Gas Act)","28:1331ni":"28:1331ni (28:1331ni Fed. Question: Negotiable Instrument)","28:1331pd":"28:1331pd (28:1331pd Fed. Question: Property Damage)","28:1331pi":"28:1331pi (28:1331pi Fed. Question: Personal Injury)","28:1331pl":"28:1331pl (28:1331pl Fed. Question: Product Liability)","28:1331pr":"28:1331pr (28:1331pr Fed. Question: Federal Prisoner Civil Rights)","28:1331ra":"28:1331ra (28:1331ra Fed. Question: Racketeering (RICO) Act)","28:1331rc":"28:1331rc (28:1331rc Fed. Question: Reclamation Project Auth. Act of 1972)","28:1331rd":"28:1331rd (28:1331rd Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a)rp Fed. Question: Real Property )","28:1331rr":"28:1331rr (28:1331rr Fed. Question: Railway Labor Act)","28:1331rs":"28:1331rs (28:1331rs Fed. Question: Federal Rail Safety Act)","28:1331sh":"28:1331sh (28:1331sh Fed. Question: Sexual Harassment)","28:1331ss":"28:1331ss (28:1331ss Fed. Question: Constitutionality of State Statutes)","28:1331sv":"28:1331sv (28:1331sv Fed. Question: Securities Violation)","28:1331sx":"28:1331sx (28:1331sx Fed. Question: Employment Discrimination (Sex))","28:1331tr":"28:1331tr (28:1331tr Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331tt Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331v Fed. Question: Violation 5th & 8th Amendments)","28:1331va":"28:1331va (28:1331va Fed. Question: Violation 5th & 14th Amendment)","28:1331vc":"28:1331vc (28:1331vc Fed. Question: Violation of Constitutional Rights)","28:1331w":"28:1331w (28:1331w Fed. Question: Wrongful Termination of Employment)","28:1331wd":"28:1331wd (28:1331wd Fed. Question: Wrongful Death)","28:1331wl":"28:1331wl (28:1331wl Fed. Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331wt Fed. Question: Water Rights)","28:1332":"28:1332 (28:1332 Diversity Action)","28:1332ac":"28:1332ac (28:1332ac Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332al Diversity-Airline Crash)","28:1332ap":"28:1332ap (28:1332ap Diversity-Airplane Product Liability)","28:1332as":"28:1332as (28:1332as Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332au Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332bc Diversity-Breach of Contract)","28:1332bw":"28:1332bw (28:1332bw Diversity -Breach of Warranty)","28:1332co":"28:1332co (28:1332co Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332ct Diversity-(Citizenship))","28:1332de":"28:1332de (28:1332de Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332df Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332ds Diversity-Contract Dispute)","28:1332dtp":"28:1332dtp (28:1332dtp Diversity - Deceptive Trade Practices)","28:1332ed":"28:1332ed (28:1332ed Diversity-Employment Discrimination)","28:1332ej":"28:1332ej (28:1332ej Diversity-Enforcement of Judgment)","28:1332fc":"28:1332fc (28:1332fc Diversity - Foreclosure)","28:1332fd":"28:1332fd (28:1332fd Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332fr Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332ia Diversity-Interpleader Action)","28:1332if":"28:1332if (28:1332if Diversity- Insurance Fraud)","28:1332ij":"28:1332ij (28:1332ij Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332in Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332jd Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332lb Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332lm Diversity - Legal Malpractice)","28:1332lp":"28:1332lp (28:1332lp Diversity-Property Damage/Product Liability)","28:1332lr":"28:1332lr (28:1332lr Diversity - Labor)","28:1332ma":"28:1332ma (28:1332ma Diversity-Miller Act)","28:1332md":"28:1332md (28:1332md Diversity-Motor Vehicle/Wrongful Death)","28:1332mm":"28:1332mm (28:1332mm Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332mv Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332ni Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332nm Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332nr Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332oc Diversity-Other Contract)","28:1332op":"28:1332op (28:1332op Diversity-Recovery of Overpayment)","28:1332pa":"28:1332pa (28:1332pa Diversity-Personal Injury/Airplane)","28:1332pd":"28:1332pd (28:1332pd Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332pi Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332pl Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332pr Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332qt Diversity-Petition to Quiet Title)","28:1332rd":"28:1332rd (28:1332rd Diversity-Recovery of Debt)","28:1332ri":"28:1332ri (28:1332ri Diversity-Racketeering (RICO) Act)","28:1332rl":"28:1332rl (28:1332rl Diversity-Rent Lease & Ejectment)","28:1332rp":"28:1332rp (28:1332rp Diversity-Real Property)","28:1332sa":"28:1332sa (28:1332sa Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332sf Diversity: Securities Fraud)","28:1332sh":"28:1332sh (28:1332sh Diversity-Sexual Harassment)","28:1332ss":"28:1332ss (28:1332ss Diversity - Stockholders Suits)","28:1332t":"28:1332t (28:1332t Diversity-Torts)","28:1332tl":"28:1332tl (28:1332tl Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332tm Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332tn Diversity-Tort/Non-Motor Vehicle)","28:1332ts":"28:1332ts (28:1332ts Diversity-Misappropriation of Trade Secrets)","28:1332vt":"28:1332vt (28:1332vt Diversity-Natl Motor Vehicle Title Information System)","28:1332wc":"28:1332wc (28:1332wc Diversity- Worker's Compensation Benefits)","28:1332wd":"28:1332wd (28:1332wd Diversity-Wrongful Death)","28:1333ad":"28:1333ad (28:1333ad Admiralty)","28:1333in":"28:1333in (28:1333in Personal Injury)","28:1333mc":"28:1333mc (28:1333mc Marine Contract)","28:1333pd":"28:1333pd (28:1333pd Property Damage)","28:1333pi":"28:1333pi (28:1333pi Marine Personal Injury)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334(b)":"28:1334(b) (28:1334(b) Proceeding arising/related to case under title 11)","28:1334(c)":"28:1334(c) (28:1334(c) R&R re motions for abstention)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337sc":"28:1337sc (28:1337sc Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338cp Copyright Infringement)","28:1338pt":"28:1338pt (28:1338pt Patent Infringement)","28:1338tr":"28:1338tr (28:1338tr Trademark Infringement)","28:1339":"28:1339 (28:1339 Postal matters)","28:1340tp":"28:1340tp (28:1340tp Jurisdiction of Internal Revenue Matters; Customs Duties)","28:1341":"28:1341 (28:1341 Taxes by States)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1344":"28:1344 (28:1344 Election disputes)","28:1345":"28:1345 (28:1345 U.S. Plaintiff)","28:1345co":"28:1345co (28:1345co Replevin & Conversion)","28:1345db":"28:1345db (28:1345db Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345df Default of Promissory Note)","28:1345er":"28:1345er (28:1345er Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345fc Foreclosure)","28:1345ff":"28:1345ff (28:1345ff Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345hl VA Home Loan Guaranty Debt)","28:1345lc":"28:1345lc (28:1345lc Land Condemnation)","28:1345mc":"28:1345mc (28:1345mc Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345mi Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345pd Property Damage)","28:1345pe":"28:1345pe (28:1345pe Property Ejectment)","28:1345rc":"28:1345rc (28:1345rc Recovery of Debt to US)","28:1345ro":"28:1345ro (28:1345ro Recovery of Retirement Overpayment)","28:1345st":"28:1345st (28:1345st Default of Student Loan)","28:1345tp":"28:1345tp (28:1345tp Trespass on Public Land)","28:1345tx":"28:1345tx (28:1345tx Prohibit dfts assessing tx on purch/use of pers prop)","28:1345va":"28:1345va (28:1345va Recovery of VA Overpayment)","28:1346":"28:1346 (28:1346 U.S. Defendant)","28:1346bc":"28:1346bc (28:1346bc Breach of Contract)","28:1346pi":"28:1346pi (28:1346pi Marine Personal Injury (or tort claim - personal injury / motor vehicle))","28:1346rc":"28:1346rc (28:1346rc Recovery of IRS Tax)","28:1346t":"28:1346t (28:1346t Tort Claim)","28:1346wd":"28:1346wd (28:1346wd Wrongful Death)","28:1348":"28:1348 (28:1348 Banking association as party)","28:1349":"28:1349 (28:1349 Corporation organized under Federal Law as party)","28:1350":"28:1350 (28:1350 Alien Tort Claims Act)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1356":"28:1356 (28:1356 Executory Process/Foreclosure)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1361pr":"28:1361pr (28:1361pr Complaint for mandamus relief (prisoner))","28:1362ic":"28:1362ic (28:1362ic Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362iw Declaration re: Indian Tribal Water Rights)","28:1363":"28:1363 (28:1363 Action for protection of jurors employment rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1367":"28:1367 (28:1367 Other Property Damage)","28:1391":"28:1391 (28:1391 Venue)","28:1394":"28:1394 (28:1394 Banking Assoc action agst Comptroller of Currency)","28:1395":"28:1395 (28:1395 Complaint for Forfeiture )","28:1402":"28:1402 (28:1402 US as Defendant)","28:1403":"28:1403 (28:1403 Condemnation of real estate for the use of the US)","28:1407":"28:1407 (28:1407 MDL: Airline Crash)","28:1407im":"28:1407im (28:1407im MDL: Silicone Gel Breast Implant Products Liability)","28:1407md":"28:1407md (28:1407md MDL: Multidistrict Litigation)","28:1407n":"28:1407n (28:1407n MDL: Personal Injury/Norplant Product Liability)","28:1407pl":"28:1407pl (28:1407pl MDL: Products Liability)","28:1441ac":"28:1441ac (28:1441ac Removal- Account Receivable)","28:1441ada":"28:1441ada (28:1441ada Removal- Americans with Disabilities Act)","28:1441ag":"28:1441ag (28:1441ag Removal- Civil Rights (Age))","28:1441al":"28:1441al (28:1441al Removal- Airline Crash)","28:1441as":"28:1441as (28:1441as Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441au Removal- Auto Negligence)","28:1441ba":"28:1441ba (28:1441ba Removal - National Bank Act)","28:1441bc":"28:1441bc (28:1441bc Removal- Breach of Contract)","28:1441bfd":"28:1441bfd (28:1441bfd Removal- Breach of Fiduciary Duties)","28:1441ca":"28:1441ca (28:1441ca Removal - Carmack Amendment)","28:1441cc":"28:1441cc (28:1441cc Removal- Computer Crimes Act)","28:1441cj":"28:1441cj (28:1441cj Removal- Confessed Judgement)","28:1441cla":"28:1441cla (28:1441cla Removal - Consumer Leasing Act)","28:1441cp":"28:1441cp (28:1441cp Removal- Copyright)","28:1441cpl":"28:1441cpl (28:1441cpl Removal - Contract Product Liability)","28:1441cra":"28:1441cra (28:1441cra Removal - Fair Credit Reporting Act)","28:1441cv":"28:1441cv (28:1441cv Removal- Civil Rights Act)","28:1441dea":"28:1441dea (28:1441dea Removal - Disabilities Education Act)","28:1441df":"28:1441df (28:1441df Removal- Contract Default)","28:1441di":"28:1441di (28:1441di Removal- Civil Rights (Disability Act))","28:1441dj":"28:1441dj (28:1441dj Removal- Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441ds Removal- Contract Dispute)","28:1441ea":"28:1441ea (28:1441ea Removal- Employment Discrimination (Age))","28:1441eb":"28:1441eb (28:1441eb Removal - E.R.I.S.A. Employee Benefits)","28:1441ec":"28:1441ec (28:1441ec Removal - Electronic Comm. Privacy Act)","28:1441ed":"28:1441ed (28:1441ed Removal - Employment Discrimination)","28:1441em":"28:1441em (28:1441em Removal - Emergency Medical Treatment & Active Labor)","28:1441er":"28:1441er (28:1441er Removal- Employment Discrimination (Race))","28:1441es":"28:1441es (28:1441es Removal- Employment Discrimination (Sex))","28:1441fa":"28:1441fa (28:1441fa Removal - Civil Rights - False Arrest)","28:1441fc":"28:1441fc (28:1441fc Removal - Fair Credit Reporting Act)","28:1441fd":"28:1441fd (28:1441fd Removal - Fair Debt Collection Practices Act)","28:1441fe":"28:1441fe (28:1441fe Removal- Fed. Employee Garnishment Statute)","28:1441fh":"28:1441fh (28:1441fh Removal- FEHBA)","28:1441fif":"28:1441fif (28:1441fif Removal - Insecticide/Fungicide/Rodenticide Act -1942)","28:1441fl":"28:1441fl (28:1441fl Removal- Fair Labor Standards Act)","28:1441fm":"28:1441fm (28:1441fm Removal - Family and Medical Leave Act)","28:1441fr":"28:1441fr (28:1441fr Removal- Fraud)","28:1441fs":"28:1441fs (28:1441fs Removal - Foreign Sovereign Immunities Act)","28:1441fsa":"28:1441fsa (28:1441fsa Removal - Federal Food Stamp Act)","28:1441hb":"28:1441hb (28:1441hb Removal - Petition of Habeas Corpus)","28:1441hc":"28:1441hc (28:1441hc Removal - Handicapped Child Protection Act)","28:1441hd":"28:1441hd (28:1441hd Removal- Housing Discrimination)","28:1441ia":"28:1441ia (28:1441ia Removal- Interstate Commerce Act)","28:1441if":"28:1441if (28:1441if Removal - Insurance Fraud)","28:1441ij":"28:1441ij (28:1441ij Removal- Injunctive/Declaratory Relief)","28:1441il":"28:1441il (28:1441il Removal- Interstate Land Full Discloser Act)","28:1441in":"28:1441in (28:1441in Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441int Removal- Action for Interpleader)","28:1441la":"28:1441la (28:1441la Removal - Truth in Lending Act)","28:1441lb":"28:1441lb (28:1441lb Removal- Libel, Assault, Slander)","28:1441lm":"28:1441lm (28:1441lm Removal- Labor/Mgmt. Relations)","28:1441ml":"28:1441ml (28:1441ml Removal- Motor Vehicle Prod Liability)","28:1441mm":"28:1441mm (28:1441mm Removal- Medical Malpractice)","28:1441mv":"28:1441mv (28:1441mv Removal- Motor Vehicle)","28:1441ni":"28:1441ni (28:1441ni Removal- Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441nm Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441nr Notice of Removal)","28:1441oc":"28:1441oc (28:1441oc Removal- Other Contract)","28:1441pa":"28:1441pa (28:1441pa Removal - Patent Infringement)","28:1441pd":"28:1441pd (28:1441pd Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441pi Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441pl Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441pr Petition for Removal)","28:1441qt":"28:1441qt (28:1441qt Removal- Petition to Quiet Title)","28:1441ra":"28:1441ra (28:1441ra Removal- Civil Rights (Race))","28:1441ri":"28:1441ri (28:1441ri Removal- Racketeering (RICO))","28:1441rl":"28:1441rl (28:1441rl Removal- Rent, Lease, & Ejectment)","28:1441sa":"28:1441sa (28:1441sa Removal- SEC Act)","28:1441sf":"28:1441sf (28:1441sf Removal- Securities Fraud)","28:1441sh":"28:1441sh (28:1441sh Removal-Sexual Harassment)","28:1441st":"28:1441st (28:1441st Removal - Stockholders Suit)","28:1441sv":"28:1441sv (28:1441sv Removal-Security Violation)","28:1441sx":"28:1441sx (28:1441sx Removal-Civil Rights (Sex))","28:1441tc":"28:1441tc (28:1441tc Removal - Tricare Program)","28:1441ti":"28:1441ti (28:1441ti Removal-Trademark Infringement)","28:1441til":"28:1441til (28:1441til Removal - Truth and Lending)","28:1441tl":"28:1441tl (28:1441tl Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441tm Removal- Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441tn Removal- Tort/Non-Motor Vehicle)","28:1441us":"28:1441us (28:1441us Removal - Uniformed Svc Emp/Reemp Rights Act)","28:1441wc":"28:1441wc (28:1441wc Removal - Worker's Compensation Benefits)","28:1441wd":"28:1441wd (28:1441wd Removal- Wrongful Death)","28:1441wt":"28:1441wt (28:1441wt Removal- Employment (Wrongful Termination))","28:1442":"28:1442 (28:1442 Notice of Removal - Suit against Federal Officer)","28:1442aaf":"28:1442aaf (28:1442aaf Petition for Removal - Agst members of armed forces)","28:1443(1)":"28:1443(1) (28:1443(1) Removal from State Court - Civil Rights: Rent, Lease, and Ejectment)","28:1444":"28:1444 (28:1444 Notice of Removal- Foreclosure)","28:1446al":"28:1446al (28:1446al Notice of Removal - Airline Crash)","28:1446as":"28:1446as (28:1446as Notice of Removal - Asbestos Litigation)","28:1446bc":"28:1446bc (28:1446bc Notice of Removal - Breach of Contract)","28:1446cs":"28:1446cs (28:1446cs Notice of Removal - Child Support Enforcement)","28:1446dj":"28:1446dj (28:1446dj Notice of Removal - Declaratory Judgment)","28:1446er":"28:1446er (28:1446er Notice of Removal - E.R.I.S.A)","28:1446fm":"28:1446fm (28:1446fm Notice of Removal - Family and Medical Leave Act)","28:1446fr":"28:1446fr (28:1446fr Notice of Removal - Fraud)","28:1446in":"28:1446in (28:1446in Breach of Contract - Insurance)","28:1446lb":"28:1446lb (28:1446lb Notice of Removal - Libel, Assault, Slander)","28:1446ml":"28:1446ml (28:1446ml Notice of Removal - Motor Vehicle Prod Liability)","28:1446mm":"28:1446mm (28:1446mm Notice of Removal - Medical Malpractice)","28:1446mv":"28:1446mv (28:1446mv Notice of Removal - Motor Vehicle)","28:1446ni":"28:1446ni (28:1446ni Notice of Removal - Negotiable Instrument)","28:1446nr":"28:1446nr (28:1446nr Notice of Removal)","28:1446oc":"28:1446oc (28:1446oc Notice of Removal - Other Contract)","28:1446pd":"28:1446pd (28:1446pd Notice of Removal - Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446pi Notice of Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Notice of Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446pr Petition for Removal)","28:1446st":"28:1446st (28:1446st Notice of Removal - Stockholders Suit)","28:1446tl":"28:1446tl (28:1446tl Notice of Removal - Torts to Land)","28:1446wd":"28:1446wd (28:1446wd Notice of Removal - Wrongful Death)","28:1452":"28:1452 (28:1452 Removal of Claims Related to Bankruptcy Cases)","28:1453":"28:1453 (28:1453 Class Action Fairness Act)","28:1491":"28:1491 (28:1491 Tucker Act)","28:1602":"28:1602 (28:1602 Foreign Sovereign Immunities Act)","28:1605":"28:1605 (28:1605 Foreign Sovereign Immunities Act of 1976)","28:1605A":"28:1605A (28:1605A Antiterrorism & Effective Death Penalty Act 1996)","28:1610":"28:1610 (28:1610 Juridictional Immunities of Foreign States)","28:1631":"28:1631 (28:1631 Case Transferred to Cure Want of Jurisdiction)","28:1651cn":"28:1651cn (28:1651cn Petition for Writ of Error Coram Nobis )","28:1651hc":"28:1651hc (28:1651hc Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651mn Petition for Writ of Mandamus)","28:1651ne":"28:1651ne (28:1651ne Application for Writ Ne Exeat)","28:1651w":"28:1651w (28:1651w All Writs Act)","28:1715":"28:1715 (28:1715 Class Action Fairness Act of 2005)","28:1732":"28:1732 (28:1732 Reproduction of Records)","28:1738Acs":"28:1738Acs (28:1738Acs The Uniform Child Custody Jurisdiction Act)","28:1782":"28:1782 (28:1782 Assistance to Foreign Tribunals (incl letter rogatory))","28:1783":"28:1783 (28:1783 Petition for Subpoena of person in foreign country)","28:1826":"28:1826 (28:1826 Order of confinement of recalcitrant witness)","28:1875":"28:1875 (28:1875 Juror Protection Act / Protection of Jurors' Employment)","28:1916":"28:1916 (28:1916 Marine Personal Injury)","28:1963":"28:1963 (28:1963 Registration of judgment from another district)","28:2001":"28:2001 (28:2001 Judicial Sale of Realty)","28:2071":"28:2071 (28:2071 Rule Making Power Generally)","28:2201":"28:2201 (28:2201 Creation of a Remedy - Declaration of Rights)","28:2201an":"28:2201an (28:2201an Declaratory Judgement (aliens and nationality))","28:2201cp":"28:2201cp (28:2201cp Declaratory Judgment (Copyright))","28:2201dj":"28:2201dj (28:2201dj Declaratory Judgment)","28:2201fa":"28:2201fa (28:2201fa Declaratory Judgment- Firearms)","28:2201fs":"28:2201fs (28:2201fs Declaratory Judgment (Food Security Act))","28:2201ij":"28:2201ij (28:2201ij Injunction)","28:2201in":"28:2201in (28:2201in Declaratory Judgment (Insurance))","28:2201pi":"28:2201pi (28:2201pi Declaratory Judgment - Personal Injury)","28:2241fd":"28:2241fd (28:2241fd Petition for Writ of Habeas Corpus (federal))","28:2241in":"28:2241in (28:2241in Habeas Corpus: INS)","28:2241st":"28:2241st (28:2241st Petition for Writ of Habeas Corpus (State))","28:2244":"28:2244 (28:2244 Habeas Corpus - Finality of Determination)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254dp":"28:2254dp (28:2254dp Petition for Writ of Habeas Corpus (Death Penalty))","28:2254se":"28:2254se (28:2254se Petition for Writ of Habeas Corpus (Stay of Execution))","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)","28:2283":"28:2283 (28:2283 Stay of State Court Proceedings (Injunctive Relief))","28:2347":"28:2347 (28:2347 Petition to Review Orders in the Ct of Appeals)","28:2401":"28:2401 (28:2401 Federal Tort Claims Act (Time for commencing action against the US))","28:2403":"28:2403 (28:2403 Constitutionality of State Statute(s) )","28:2405":"28:2405 (28:2405 Garnishment of debtors of a corporation by US)","28:2409(a)":"28:2409(a) (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title - Actions affecting property on which United States has lien)","28:2412":"28:2412 (28:2412 Equal Access to Justice Act)","28:2415":"28:2415 (28:2415 Detinue and Conversion)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act (Definitions))","28:2672mv":"28:2672mv (28:2672mv Federal Tort Claims Act - Motor Vehicle)","28:2672pi":"28:2672pi (28:2672pi Federal Tort Claim Act - Personal Injury)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act - Liability of US)","28:2675":"28:2675 (28:2675 Federal Tort Claims Act - Disposition by Agency Req)","28:2679d2":"28:2679d2 (28:2679(d)(2) Federal Tort Claims Act - Employee of U.S.A.)","28:2680":"28:2680 (28:2680 Federal Tort Claims Act - Exceptions)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","28:3001(a)":"28:3001(a) (28:3001(a) Federal Debt Collection Procedures Act of 1990)","28:3203":"28:3203 (28:3203 Postjudgment Remedies: Writ of Execution)","28:3301":"28:3301 (28:3301 Fraudulent Transfer Federal Debt Collection Procedures Act)","29:0101":"29:0101 (29:0101 Labor: Issuance of Restraining Orders and Injunctions )","29:0151":"29:0151 (29:0151 Labor: National Labor Relations Act (NLRA))","29:0158(b)":"29:0158(b) (29:0158(b) Labor: NLRA - Unfair Labor Practices)","29:0159":"29:0159 (29:0159 Labor: Violation of Collective Bargaining Agreement )","29:0160":"29:0160 (29:0160 Labor: NLRA - Prevention of Unfair Labor Practices)","29:0160j":"29:0160j (29:0160j Labor: Petition for Inj - Relief from Unfair Labor Practice)","29:0160l":"29:0160l (29:0160l Labor: Petition for Inj re Uncertified Labor Organizations)","29:0161(2)":"29:0161(2) (29:0161(2) Labor: Enforcement of agency subpoena)","29:0178":"29:0178 (29:0178 Labor: Petition for Inj to Enjoin Strike during Natl Emergency)","29:0185":"29:0185 (29:0185 Labor: Suits by and against Labor Organizations)","29:0186":"29:0186 (29:0186 Labor: Liabilities of and Restrictions on Labor and Management)","29:0187":"29:0187 (29:0187 Labor: Recover Damages from Unfair Labor Practice)","29:0201fl":"29:0201fl (29:0201fl FLSA: Fair Labor Standards Act (FLSA))","29:0203":"29:0203 (29:0203 FLSA: Definitions)","29:0206":"29:0206 (29:0206 FLSA: Minimum Wage)","29:0206(d)":"29:0206(d) (29:0206(d) FLSA: Prohibition of Sex Discrimination)","29:0207(a)":"29:0207(a) (29:0207(a) FLSA: Action for Overtime Wage Violation)","29:0207fl":"29:0207fl (29:0207fl FLSA: Maximum Hours)","29:0210":"29:0210 (29:0210 FLSA: Court Review of Wage Orders in PR and VI)","29:0215fl":"29:0215fl (29:0215fl FLSA: Prohibited Acts)","29:0216(b)":"29:0216(b) (29:0216(b) FLSA: Minimum wage or overtime compensation)","29:0216(e)":"29:0216(e) (29:0216(e) FLSA: Penalty assessed for child labor provisions)","29:0217":"29:0217 (29:0217 FLSA: Enjoin Violations of Fair Labor Standards Act)","29:0260":"29:0260 (29:0260 FLSA: Liquidated Damages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0411":"29:0411 (29:0411 Landrum Griffin Act)","29:0412":"29:0412 (29:0412 Infringement of rights; members of labor organization)","29:0440":"29:0440 (29:0440 violations reporting requirements; labor organization)","29:0501(b)":"29:0501(b) (29:0501(b) Violation of Fiduciary Responsibility)","29:0621":"29:0621 (29:0621 Job Discrimination (Age))","29:0623":"29:0623 (29:0623 Job Discrimination (Prohibition of Age Discrimination))","29:0626":"29:0626 (29:0626 Job Discrimination (Investigation and Enforcement))","29:0633":"29:0633 (29:0633 Job Discrimination (Age - Federal-State Realtionshship))","29:0651":"29:0651 (29:0651 Occupational Safety/Health)","29:0660":"29:0660 (29:0660 Action by Sec Labor for discrimination re rights OSHA)","29:0662":"29:0662 (29:0662 Inj proceedings re dangerous emp conditions; by Sec.)","29:0666":"29:0666 (29:0666 Collection of civil penalties under OSHA)","29:0701":"29:0701 (29:0701 Vocational Rehabilitation)","29:0791":"29:0791 (29:0791 Job Discrimination (Rehabilitation Act))","29:0792d2":"29:0792d2 (29:0792(d)(2) Accessible facilities for phys. handicapped emp)","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement (Definitions))","29:1055":"29:1055 (29:1055 E.R.I.S.A., Employee Retirement (Joint and Survivor Annuity))","29:1101":"29:1101 (29:1101 E.R.I.S.A.: Coverage)","29:1104":"29:1104 (29:1104 E.R.I.S.A.: Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 E.R.I.S.A.: Breach of Fiduciary Duties)","29:1132":"29:1132 (29:1132 E.R.I.S.A.: Civil Enforcement of Employee Benefits )","29:1145":"29:1145 (29:1145 E.R.I.S.A.: Delinquent Contributions)","29:1149":"29:1149 (29:1149 E.R.I.S.A.: Prohibition on False Statements and Representations)","29:1161":"29:1161 (29:1161 COBRA - Continuation Coverage)","29:1162":"29:1162 (29:1162 COBRA - Continuation Coverage)","29:1303":"29:1303 (29:1303 PBGC: Operation of Corporation)","29:1362":"29:1362 (29:1362 E.R.I.S.A.: Liability for Termination of Single Employer Plans)","29:1381":"29:1381 (29:1381 E.R.I.S.A.: Withdrawal Liability)","29:1401b2":"29:1401b2 (29:1401(b)(2) E.R.I.S.A.: Resolution of Disputes - Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.: Enforcement - Civil Actions)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:1854":"29:1854 (29:1854 Migrant & Seasonal Agri Worker Protect Act (AWPA))","29:1916":"29:1916 (29:1916 Spec. Rule for Longshoremen & Harborworkers)","29:2001":"29:2001 (29:2001 Employee Polygraph Protection Act)","29:2101":"29:2101 (29:2101 Worker Adjustment and Retraining Notification Act)","29:2104":"29:2104 (29:2104 Worker Adjustment & Retraining Notification (WARN))","29:2601":"29:2601 (29:2601 FMLA: Family and Medical Leave Act (Findings and Purposes))","29:2611":"29:2611 (29:2611 FMLA: Definitions)","29:2612":"29:2612 (29:2612 FMLA: Leave Requirements)","29:2617":"29:2617 (29:2617 FMLA: Enforcement)","30:0022":"30:0022 (30:0022 General Mining Law of 1872 (Lands Open to Purchase by Citizens))","30:0181":"30:0181 (30:0181 Land subject to disposition; persons entitled to benefits; reciprocal privileges)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:0815":"30:0815 (30:0815 Federal Mine Safety & Health Act (Procedure for Enforcement))","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action (Congressional Findings))","30:1202":"30:1202 (30:1202 Mining Reclamation Act (Statement of Purpose))","30:1276":"30:1276 (30:1276 Interior: Judicial Review of Agency Action)","30:1701":"30:1701 (30:1701 Federal Oil Gas Royalty Mgt Act 1982 (FOGRMA))","31:0732":"31:0732 (31:0732 General Acct. Office Personnel Act of 1980 (Personnel Management System))","31:1341":"31:1341 (31:1341 Government employee--limitations on expending monies)","31:3545":"31:3545 (31:3545 Civil Action to Recovery Money)","31:3702":"31:3702 (31:3702 Procedures for Settling Claims )","31:3713":"31:3713 (31:3713 Priority of Government Claims)","31:3720":"31:3720 (31:3720 Federal Income Tax Interceptions (Collection of Payments))","31:3728":"31:3728 (31:3728 Setoff against Judgment )","31:3729":"31:3729 (31:3729 False Claims Act - Liability )","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 False Claims Act - Procedures)","31:3733j2":"31:3733j2 (31:3733(j)(2) Pet to Mod or Set Aside CV Investigative Demand)","31:5314":"31:5314 (31:5314 Failure to Report Interest in Foreign Accounts)","31:5317":"31:5317 (31:5317 Search and Forfeiture of Monetary Instruments)","31:5320":"31:5320 (31:5320 Inj proceedings re Rpts of Currency & Foreign Trans. )","31:5321":"31:5321 (31:5321 Penalty; Reports of Currency and Foreign Transaction )","31:5332(a)":"31:5332(a) (31:5332(a) Evading Currency Reporting Requirement)","31:5332(f)":"31:5332(f) (31:5332(f) Transport and Transfer US currency from in to out)","31:6716":"31:6716 (31:6716 Discrimination re money and finance )","31:9701":"31:9701 (31:9701 Federal User Charge Statute)","33:0408":"33:0408 (33:0408 Injury to Harbor Improvement)","33:0594":"33:0594 (33:0594 Land Condemnation)","33:0901":"33:0901 (33:0901 Longshoremen Harbor Workers Compensation Act (Navigation and Navigable Waters))","33:0905(b)":"33:0905(b) (33:0905(b) Longshoremen Workers Comp. Act - Recovery of Damage caused by negligence of Vessel)","33:0918":"33:0918 (33:0918 Longshore and Harbor Workers Compensation Act - Collection of Defaulted Payments)","33:0921":"33:0921 (33:0921 Longshore & Harbor Workers Compensation Act - Review of Compensation Orders)","33:0933":"33:0933 (33:0933 Longshore and Harbor Workers Comp.Act - Compensation for Injuries (Third-Party Claims))","33:1221":"33:1221 (33:1221 Ports and Waterways Safety Program)","33:1251":"33:1251 (33:1251 Federal Water Pollution Control Act (Clean Water Act))","33:1319a2":"33:1319a2 (33:1319(a)(2)pv Clean Water Act - Pollutants & Permit Violations)","33:1319cw":"33:1319cw (33:1319cw Clean Water Act - Enforcement)","33:1321":"33:1321 (33:1321 Clean Water Act - Discharge of hazardous substance or pollutants/water)","33:1361":"33:1361 (33:1361 Clean Water Act-Administrator Authority)","33:1364":"33:1364 (33:1364 Clean Water Act - EPA action to restrain pollution endangering health (emergency powers))","33:1365":"33:1365 (33:1365 Clean Water Act - Citizen Suits re Environmental Matters )","33:1415":"33:1415 (33:1415 Marine Protection, Research, and Sanctuaries Act)","33:1515":"33:1515 (33:1515 Deepwater Ports Act (citizen civil action))","33:2701":"33:2701 (33:2701 Oil Pollution Act of 1940)","35:0001":"35:0001 (35:0001 Establishment of PTO)","35:0032":"35:0032 (35:0032 Suspension from Practice before Patent & Trade. Off.)","35:0145":"35:0145 (35:0145 Civil Action to Obtain Patent)","35:0146":"35:0146 (35:0146 Appeal from Decision of the Board of Patent Appeals)","35:0183":"35:0183 (35:0183 Right to Compensation - Patent Laws)","35:0256":"35:0256 (35:0256 Patent Non-Infringement (Correction of Named Inventor))","35:0271":"35:0271 (35:0271 Patent Infringement)","35:0281":"35:0281 (35:0281 Remedy for Infringement of Patent/jurisdiction conferred 28:1338)","35:0282":"35:0282 (35:0282 Patent Infringement - Defenses)","35:0283":"35:0283 (35:0283 Action to enjoin violation of right secured by patent)","35:0289":"35:0289 (35:0289 Recover profits from unlicensed use of design patent)","35:0291":"35:0291 (35:0291 Action for relief between owners; interfering patents)","35:0292":"35:0292 (35:0292 Penalty & Forfeiture; illegal use of word patent (false marking))","35:0311":"35:0311 (35:0311 Patent - Request for Inter Partes Reexamination)","38:1110":"38:1110 (38:1110 Basic Entitlements / Wartime)","38:1131":"38:1131 (38:1131 Basic Entitlements / Peacetime)","38:1816":"38:1816 (38:1816 Deficiency balance on VA Mortgage Foreclosure (Reg. Governing the VA Loan Guaranty Prgm))","38:1965":"38:1965 (38:1965 Servicemen's Group Life Insurance (Definitions))","38:1975":"38:1975 (38:1975 Recovery of Servicemen's Group Life Insurance - Jurisdiction of District Court)","38:1984":"38:1984 (38:1984 Suit for Veterans Insurance)","38:3481":"38:3481 (38:3481 Recovery of VA Overpayment)","38:3680":"38:3680 (38:3680 Recovery of Education Assist Allowance Overpayment)","38:4212":"38:4212 (38:4212 Veterans Employment Emphasis Under Federal Contracts )","38:4301":"38:4301 (38:4301 Uniformed Srvs. Employment & Reemployment Rights Act (purpose))","38:4302":"38:4302 (38:4302 Veterans Reemployment Rights Act (relation to other laws and plans or agreements.)","38:4311":"38:4311 (38:4311 Uniformed Service Employment or Reemployment Rights Act (USERRA) - Discrimination)","38:4312":"38:4312 (38:4312 Rights of inducted persons to reemployment )","38:4323":"38:4323 (38:4323 USERRA - Enforcement of rights with respect to state or private employer )","38:4324":"38:4324 (38:4324 USERRA - Enforcement of rights with respect to federal executive agencies)","38:5315":"38:5315 (38:5315 Delinquent Payment of Amounts Due to US)","38:5316":"38:5316 (38:5316 VA Overpayment )","39:0403":"39:0403 (39:0403 Discriminatory use of the Postal Service)","39:0409":"39:0409 (39:0409 Suits by and against the Postal Service)","39:1207":"39:1207 (39:1207 Review Agency Action--Labor Disputes)","39:1208(b)":"39:1208(b) (39:1208(b) Postal Reorganization Act of 1970 - Suits)","39:3005":"39:3005 (39:3005 False Representations and Lotteries)","39:3007":"39:3007 (39:3007 Detention of Mail for Temporary Periods - Injunction directing retention of incoming mail)","39:3008(e)":"39:3008(e) (39:3008(e) Enforce compliance with a USPS Prohibitory Order)","40:0581":"40:0581 (40:0581 General Authority of Administrator of General Services)","40:1101":"40:1101 (40:1101 Brooks Architect - Engineers Act)","40:3131":"40:3131 (40:3131 Bonds of contractors of public buildings )","40:3142":"40:3142 (40:3142 Davis-Bacon Act (prevailing wages))","41:2102":"41:2102 (41:2102-2107 Procurement Integrity Act)","41:3301":"41:3301 (41:3301 Competition in Contracting Act)","41:6503":"41:6503 (41:6503 Walsh-Healy Act - Breach of Public Contract)","41:6505":"41:6505 (41:6505 Exclusions - Review of legal questions in contracts; Walsh-Healy Act)","41:6702":"41:6702 (41:6702-6704 Service Contract Labor Standards / McNamara-O'Hara Service Contract Act 1965)","41:7105(f)":"41:7105(f) (41:7105(f) Action to Judicially Enforce Administrative Subpoena)","42:0205":"42:0205 (42:0205 Appointment of Surgeon General)","42:0206":"42:0206 (42:0206 Surgeon General - Assignment of Officers)","42:0254o":"42:0254o (42:0254o Breach of Scholarship Contract)","42:0256":"42:0256 (42:0256 Public Health Services Act - Grants)","42:0292f":"42:0292f (42:0292f Default of borrower)","42:0292k":"42:0292k (42:0292k Student loan insurance (Public Health Occupations))","42:0293":"42:0293 (42:0293 Recovery of losses from loan guarantee; public health)","42:0297":"42:0297 (42:0297 Student loans; public or nonprofit school of nursing)","42:0300aa":"42:0300aa (42:0300aa-1 Nat'l. Childhood Vaccine Injury Compensation Act)","42:0300f":"42:0300f (42:0300f Safe Drinking Water Act (Definitions))","42:0300g":"42:0300g (42:0300g Actions re safety of public water systems (EPA))","42:0300g-3":"42:0300g-3 (42:0300g-3 Enforcement of Drinking Water Regulations)","42:0401":"42:0401 (42:0401 Social Security Act - Trust Funds)","42:0402":"42:0402 (42:0402 Social Security Benefits)","42:0405id":"42:0405id (42:0405id Review of HHS Decision (SSID))","42:0405rs":"42:0405rs (42:0405rs Review of HHS Decision (RSI))","42:0405wc":"42:0405wc (42:0405wc Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:0405ww Review of HHS Decision (DIWW))","42:0421(d)":"42:0421(d) (42:0421(d) Review HHS decision re disability determinations)","42:0423":"42:0423 (42:0423 Social Security Act (Disability Insurance Benefit Payments))","42:0427":"42:0427 (42:0427 Social Security Benefits (Transitional Insured Status))","42:0601":"42:0601 (42:0601 Title IV-A of Social Security Act (Grants to States for Aid and Assist to Needy Families))","42:0602":"42:0602 (42:0602 Temp. Assistance for Needy Families (TANF) )","42:0660":"42:0660 (42:0660 Action to enforce child support obligations)","42:10139":"42:10139 (42:10139 judicial review of agency actions )","42:10801":"42:10801 (42:10801 Protection & Advocacy for Individuals with Mental Illness Act of 1986 (PAIMI))","42:10805":"42:10805 (42:10805 Protection and Advocacy Systems)","42:11001":"42:11001 (42:11001 Emergency Plan. & Comm. Right to Know Act (EPCRA))","42:11046":"42:11046 (42:11046 Fed Emer Plan Comm Right-to-know Act (EPCRA) - civil actions)","42:11101":"42:11101 (42:11101 Health Care Quality Improvement Act of 1986 )","42:11112":"42:11112 (42:11112 Health Care Quality Improvement Act (Standards for Professional Review Actions))","42:11601":"42:11601 (42:11601 International Child Abduction Remedies Act)","42:11603b":"42:11603b (42:11603(b) Int'l. Child Abduction Remedies Act (ICARA) - Judicial Remedies)","42:12101":"42:12101 (42:12101 The Americans with Disabilities Act of 1990)","42:12102":"42:12102 (42:12102 Americans with Disabilities Act (ADA) Disability Definition)","42:12111":"42:12111 (42:12111 Americans with Disabilities Act - Employment )","42:12112":"42:12112 (42:12112 Americans with Disabilities Act - Employment Discrimination)","42:12117":"42:12117 (42:12117 Americans with Disabilities Act - Enforcement)","42:12132":"42:12132 (42:12132 Americans with Disabilities Act - Discrimination)","42:12188":"42:12188 (42:12188 Americans With Disabilities Act - Civil Enforcement Actions)","42:1320a":"42:1320a (42:1320a-7b(b)(2)(A) Anti-Kickback Act (for federal health care programs) )","42:1320d-2":"42:1320d-2 (42:1320d-2 Health Insurance Portability And Accountability Act (HIPAA))","42:1381a":"42:1381a (42:1381a Supplemental Security Income benefits (SSID))","42:1382":"42:1382 (42:1382 Eligibility for benefits)","42:1383":"42:1383 (42:1383 Review of HHS Decision (regarding payment of benefits))","42:1395":"42:1395 (42:1395 Emergency Medical Treatment and Active Labor Act )","42:1395dd":"42:1395dd (42:1395dd Exam & Treatment Emergency Med Cond & Women in Labor)","42:1395hr":"42:1395hr (42:1395hr Hospital Reimbursement for Medicare Services)","42:1395w":"42:1395w (42:1395w-21 Medicare Act (Eligibility, Election, and Enrollment))","42:1396a":"42:1396a (42:1396a State Plans for Medical Assistance)","42:1396b":"42:1396b (42:1396b Medical Assist Prgm, Pmt to States/Medicaid Implem)","42:13981":"42:13981 (42:13981 Violence Against Women Act (Civil Rights))","42:14135":"42:14135 (42:14135 DNA Backlog Grant Program)","42:1437":"42:1437 (42:1437 U.S. Housing Act of 1937)","42:1475":"42:1475 (42:1475 Declaratory & Injunctive Relief - Foreclosure Procedures)","42:1479":"42:1479 (42:1479 Mortgage, lease, contract re farm housing)","42:14901":"42:14901 (42:14901 Intercountry Adoptions)","42:15483":"42:15483 (42:15483 Help America Vote Act)","42:1651":"42:1651 (42:1651 Defense Base Act)","42:1705":"42:1705 (42:1705 Receipt of Workmen's compensation benefits)","42:1971":"42:1971 (42:1971 Voting Rights Law)","42:1973":"42:1973 (42:1973 Voting Rights Act)","42:1973(a)":"42:1973(a) (42:1973(a) Enforcement of Voting Rights)","42:1973(c)":"42:1973(c) (42:1973(c ) Voting Rights -Qualifications & Procedures)","42:1973gg":"42:1973gg (42:1973gg-2 Nat'l. Voter Registration Act of 1993 (NVRA))","42:1981a":"42:1981a (42:1981a Damages in cases of intentional discrim. in employment)","42:1981cv":"42:1981cv (42:1981cv Civil Rights)","42:1981hs":"42:1981hs (42:1981hs Housing Discrimination)","42:1981jb":"42:1981jb (42:1981jb Job Discrimination (Race))","42:1981ra":"42:1981ra (42:1981ra Race Discrimination)","42:1981sx":"42:1981sx (42:1981sx Sex Discrimination)","42:1982hs":"42:1982hs (42:1982hs Discrimination re property rights (housing))","42:1982ra":"42:1982ra (42:1982ra Discrimination re property rights (race))","42:1982sx":"42:1982sx (42:1982sx Discrimination re property rights (sex))","42:1983bv":"42:1983bv (42:1983bv Bivens Non-Prisoner)","42:1983cv":"42:1983cv (42:1983cv Civil Rights Act - Civil Action for Deprivation of Rights)","42:1983cvp":"42:1983cvp (42:1983cvp Civil Rights (Personal Property))","42:1983d":"42:1983d (42:1983d Civil Rights (Death))","42:1983dp":"42:1983dp (42:1983dp Civil Right Denial of Due Process)","42:1983ed":"42:1983ed (42:1983ed Civil Rights (Employment Discrimination) )","42:1983pr":"42:1983pr (42:1983pr Prisoner Civil Rights)","42:1983vp":"42:1983vp (42:1983vp Violation of Due Process and Equal Protection)","42:1985":"42:1985 (42:1985 Consipracy to interfere with civil rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:1987":"42:1987 (42:1987 Prosecution of violations of certain laws (sec 1990,5506,5516,5518 to 5532))","42:1988":"42:1988 (42:1988 Proceedings in Vindication of Civil Rights)","42:1997":"42:1997 (42:1997 Institutionalized Persons Act of 1980 )","42:2000ad":"42:2000ad (42:2000ad Job Discrimination (Disability Act))","42:2000apa":"42:2000apa (42:2000a-3pa Discrimination, segregation; public accommodation - Injunctive Relief)","42:2000bb":"42:2000bb (42:2000bb Religious Freedom Restoration Act of 1993)","42:2000bea":"42:2000bea (42:2000bea Equal access to public facilities)","42:2000cc":"42:2000cc (42:2000cc Religious Land Use & Institutionalized Persons Act of 2000)","42:2000ced":"42:2000ced (42:2000c-6ed Discrimination in Education)","42:2000d":"42:2000d (42:2000d Federally Assisted Programs)","42:2000e2e":"42:2000e2e (42:2000e-2e Job Discrimination (Unlawful Employment Practices))","42:2000eag":"42:2000eag (42:2000e-2ag Job Discrimination (Age))","42:2000eeo":"42:2000eeo (42:2000e-5eeo Petition to Enforce EEOC Subpoena)","42:2000eno":"42:2000eno (42:2000e-2no Job Discrimination (National Origin))","42:2000eot":"42:2000eot (42:2000e-2ot Job Discrimination (other))","42:2000epb":"42:2000epb (42:2000e-2pb Job Discrimination (Public Accomodations))","42:2000era":"42:2000era (42:2000e-2ra Job Discrimination (Race))","42:2000erl":"42:2000erl (42:2000e-2rl Job Discrimination (religion))","42:2000esh":"42:2000esh (42:2000e-2sh Job Discrimination (Sexual Harassment))","42:2000esx":"42:2000esx (42:2000e-2sx Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Regulations of Indian Hospitals)","42:2005":"42:2005 (42:2005 financial assistance to Indian tribes )","42:2210":"42:2210 (42:2210 Indeminification & Limitation of Liability-Financial)","42:2651":"42:2651 (42:2651 Medical Care Recovery by US)","42:2996":"42:2996 (42:2996 Legal Services Corporation Act)","42:3058(g)":"42:3058(g) (42:3058(g) Older American's Act of 1965, 42 U.S.C. 3058(g) (State Long-term Care Ombudsman Program))","42:3121":"42:3121 (42:3121 Public Works and Economic Development Act of 1965)","42:3133":"42:3133 (42:3133 Coordination - Grants for Public Works and Economic Development)","42:3601":"42:3601 (42:3601 Fair Housing Act)","42:3604f3c":"42:3604f3c (42:3604(f)(3)(c) Fair Housing Amendments Act)","42:3610":"42:3610 (42:3610 Fair Housing Act-Administrative Enforcement; Preliminary Matters)","42:3612":"42:3612 (42:3612 Civil rights in housing - Enforcement by Secretary)","42:3613":"42:3613 (42:3613 Action for inj relief re deprivation of civil rights)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4013":"42:4013 (42:4013 National Flood Insurance Act - Nature and Limitation of Insurance Coverage)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment (Declaration of Purpose))","42:4332":"42:4332 (42:4332 Environmental Policy - Cooperation of Agencies; Reports)","42:4721":"42:4721 (42:4721 Intergovernmental Personnel Act (findings and purposes))","42:4821":"42:4821 (42:4821 Lead-Based Paint Poisoning Prevention Act (findings and purposes) )","42:4901":"42:4901 (42:4901 Noise Control Act of 1972 (findings and purposes))","42:4910(c)":"42:4910(c) (42:4910(c) Action to restrain violation re noise control)","42:5101":"42:5101 (42:5101 Child Abuse Prevention and Treatment Act)","42:5303":"42:5303 (42:5303 Block Grant Act of 1974 (42 USC 5301-5321))","42:5401":"42:5401 (42:5401 Natl Mnfactrd Housing Cnstr Safety Standard Act 1974 (findings and purposes))","42:5411":"42:5411 (42:5411 Housing Construction and Safety Standards Act - Injunctive Relief)","42:5851":"42:5851 (42:5851 Discrimination Whistle blower Employee - ERA (employee protection))","42:6101":"42:6101 (42:6101 Age Discrimination in Federally Assisted Programs (statement of purpose))","42:6201":"42:6201 (42:6201 Energy Policy & Conservation Act (statement of purpose))","42:6393":"42:6393 (42:6393 Controversies under Energy Policy & Conservation Act (Admin Procedure and Judicial Review))","42:6901en":"42:6901en (42:6901en Environmental Cleanup Expenses (congressional findings))","42:6901rs":"42:6901rs (42:6901rs Resource & Recovery Act (congressional findings))","42:6928":"42:6928 (42:6928 Violations of requirements of hazardous Waste Mgmt (federal enforcement))","42:6961":"42:6961 (42:6961 Federal Facilities Compliance Act)","42:6972":"42:6972 (42:6972 Resource & Recovery Act - Citizen Suit)","42:6972(a)":"42:6972(a) (42:6972(a) Solid Waste Disposal Act - Citizen Suit)","42:7192":"42:7192 (42:7192 Controversies under Dept of Energy Organization Act - Judicial Review)","42:7384":"42:7384 (42:7384 Energy Employees Occupational Illness Compensation Program Act (EEOICPA))","42:7401":"42:7401 (42:7401 Clean Air Act (findings & declarations))","42:7412":"42:7412 (42:7412 Air Pollution Control - emission standards )","42:7413(b)":"42:7413(b) (42:7413(b) Clean Air Act - Enforcement)","42:7475":"42:7475 (42:7475 Clean Air Act - Preconstruction Requirements)","42:7545":"42:7545 (42:7545 Air Pollution Prevention - Regulation of Fuels)","42:7603":"42:7603 (42:7603 Action for immediate restraint (Emergency Powers))","42:7604":"42:7604 (42:7604 Clean Air Act - Citizen suit to enforce Clean Air Act)","42:7604fcl":"42:7604fcl (42:7604(f)cl Clear Air Act - Emission Standards)","42:7671":"42:7671 (42:7671 Clean Air Act (Stratospheric Ozone Protection) (Definitions))","42:8324":"42:8324 (42:8324 Powerplant and Industrial Fuel Use - terms and conditions)","42:8351":"42:8351 (42:8351 Powerplant and Industrial Fuel Use - Temporary Exemptions)","42:9601":"42:9601 (42:9601 Comprehensive Environmental Compen/Resp/Liab (CERCLA) (Definitions))","42:9604":"42:9604 (42:9604 Comprehensive Envir., Response, Comp. & Liab. Act (CERCLA) - Removal & Oth. Remedial Action)","42:9607":"42:9607 (42:9607 Real Property Tort to Land - Liability)","42:9613":"42:9613 (42:9613 Comp Environ Recovery Comp & Liability Act (CERCLA) - Civil Proceedings)","43:0421":"43:0421 (43:0421 Complaint in Condemnation - Eminent Domain)","43:0945a":"43:0945a (43:0945a Compensation for Land Condemnation )","43:0945b":"43:0945b (43:0945b Complaint in Condemnation - Easements)","43:0946":"43:0946 (43:0946 Complaint in Condemnation - Right of Way for Irrigation and Drainage Projects)","43:1331":"43:1331 (43:1331 Outer Continental Shelf Lands Act (Definitions))","43:1333":"43:1333 (43:1333 Outer Continental Shelf Lands Act - Laws and Regulations Governing Lands)","43:1349":"43:1349 (43:1349 Outer Continental Land Shelf Act - Citizen Suits)","43:1701":"43:1701 (43:1701 Violation of Federal Land Policy and Management Act (FLPMA))","43:1737":"43:1737 (43:1737 FLPMA - Implementation Provisions)","44:2107":"44:2107 (44:2107 Presidential Recordings and Materials Act (NARA accept of records for hist. preservation))","45:0051":"45:0051 (45:0051 Railways: Fed. Employer's Liability Act)","45:0056":"45:0056 (45:0056 Employers Liability Act - Personal Inj re Railroads (bringing an action))","45:0151":"45:0151 (45:0151 Railway Labor Act (Definitions))","45:0152":"45:0152 (45:0152 Railway Labor Act - General Duties)","45:0153":"45:0153 (45:0153 First Railway Labor Act - National Railroad Adjustment Board)","45:0159":"45:0159 (45:0159 Review of arbitration award (RR Carriers/Mediation Bd))","45:0184":"45:0184 (45:0184 Action to Set Aside Award of a System Board)","45:0231(f)":"45:0231(f) (45:0231(f) Compel obedience to order of Railroad Retirement Bd)","45:0351":"45:0351 (45:0351 Railroad Unemployment Insurance Act)","45:0719":"45:0719 (45:0719 Regional Rail Reorganization Act of 1973 (judicial review))","45:1105":"45:1105 (45:1105 Northeast Rail Service Act - Judicial Review)","46:2114":"46:2114 (46:2114 Wrongful Discharge from Employment - protection from discrimination)","46:30101":"46:30101 (46:30101 Extension of jurisdiction to cases of damage or injury on land)","46:30104":"46:30104 (46:30104 Marine Personal Injury - Jones Act)","46:30302":"46:30302 (46:30302 Shipping: Damages for Death on High Seas )","46:30304":"46:30304 (46:30304 Breach of Maritime Contract - liability of noncompliance)","46:30503":"46:30503 (46:30503 Limitation of Liability - declaration of nature and value of goods)","46:30504":"46:30504 (46:30504 Limitation of Liability - loss by fire)","46:30505":"46:30505 (46:30505-30510 Exoneration, Limitation of Liability)","46:30511":"46:30511 (46:30511 Action by owner for limitation)","46:30701":"46:30701 (46:30701 Marine Cargo Loss or Damage - Liability of Water Carriers)","46:30704":"46:30704 (46:30704 Liability of Water Carriers - Loading, stowage, custody, care, and delivery)","46:30902":"46:30902 (46:30902 to 30911 Suits in Admiralty Act )","46:31102":"46:31102 (46:31102 Public Vessels Act - Waiver of Immunity)","46:31301":"46:31301 (46:31301 Federal Maritime Lien Act)","46:31301a":"46:31301a (46:31301 to 31343 Maritime Commercial Instruments and Liens Act)","46:31321":"46:31321 (46:31321 Foreclosure of Preferred Ship Mortgages)","46:31325":"46:31325 (46:31325 Suit to enforce lien upon mort. vessel-foreclosure / Foreclosure of Pref Foreign Ship Mort)","46:31341":"46:31341 (46:31341 Federal Maritime Lien Act)","46:31342":"46:31342 (46:31342 Breach of Maritime Contract (establishing maritime liens))","46:31343":"46:31343 (46:31343 Commercial Instruments & Maritime Liens)","46:40101":"46:40101 (46:40101 Shipping Act of 1998 )","46:41102a":"46:41102a (46:41102(a) Shipping Act of 1984 - General Prohibitions)","46:41309":"46:41309 (46:41309 Shipping Act of 1984 - Enforcement of Reparation Orders)","46:50101":"46:50101 (46:50101 Violation of Maritime Regulations )","46:58109":"46:58109 (46:58109 Violation of Merchant Marine Act - Penalties)","47:0151":"47:0151 (47:0151 Federal Communications Act of 1934)","47:0151cs":"47:0151cs (47:0151cs Federal Communications Act - Collection for Services)","47:0201bt":"47:0201bt (47:0201bt Breach of Tariff)","47:0203":"47:0203 (47:0203 Telecommunications Collection of Charges)","47:0205":"47:0205 (47:0205 Wire and Radio Communication Svc and Charges (Recovery of Damages) )","47:0206":"47:0206 (47:0206 Carrier's Liability for Damages)","47:0227":"47:0227 (47:0227 FCC-Unsolicited Telephone Sales)","47:0227b3":"47:0227b3 (47:0227(b)(3) Telephone Consumer Protection Act of 1991)","47:0251":"47:0251 (47:0251 Telecommunications Act of 1996 - Interconnection)","47:0252":"47:0252 (47:0252 Telecommunications Act)","47:0254(h)":"47:0254(h) (47:0254(h) Children's Internet Protection Act)","47:0332":"47:0332 (47:0332 FCA-Wire or Radio Communications (Mobile Services))","47:0332(c)":"47:0332(c) (47:0332(c ) Federal Telecommunications Act of 1996)","47:0338":"47:0338 (47:0338 Satellite Home Viewer Improvement Act)","47:0401":"47:0401 (47:0401 Application of Federal Communication Comm for Inj. (Enforcement Provisions))","47:0407":"47:0407 (47:0407 Order for payment of money; petition for enforcement;)","47:0510":"47:0510 (47:0510 Forfeiture of Communications Devices)","47:0521":"47:0521 (47:0521 Cable Televsn. Consumer Protection & Competition Act of 1992)","47:0532":"47:0532 (47:0532 Cable Communication Policy Act of 1984)","47:0551":"47:0551 (47:0551 Cable Communications Act)","47:0553":"47:0553 (47:0553 U.S.C.A. Cable Communications Policy Act)","47:0605":"47:0605 (47:0605 Unlawful Reception Broadcast Signal i.e., Satellite - Theft of Satellite Communications)","49:0101":"49:0101 (49:0101 ICC Termination Act of 1996)","49:0502":"49:0502 (49:0502 Transportation Administrative Subpoena)","49:10101":"49:10101 (49:10101 Interstate Commerce Act-Interstate Transportation Rail)","49:10743":"49:10743 (49:10743 Revised Interstate Commerce Act)","49:11101":"49:11101 (49:11101 Interstate Commerce Act)","49:1113":"49:1113 (49:1113 Petition to enforce administrative summon)","49:1136":"49:1136 (49:1136 Aviation Disaster Family Assistance Act of 1996)","49:11501":"49:11501 (49:11501 Railroad Revitalization & Regulatory Reform Act (General jurisdiction))","49:11502":"49:11502 (49:11502 Railroad Revitalization Regulatory Reform (authority to exempt rail carrier transportation))","49:11701":"49:11701 (49:11701 General authority of enforcement of regulations in rail)","49:11702":"49:11702 (49:11702 Enforcement by the Board)","49:11705":"49:11705 (49:11705 Limitation on actions by and against rail carriers)","49:11706":"49:11706 (49:11706 Carmack Amendent (Liability of carriers under receipts and bills of lading))","49:11707":"49:11707 (49:11707 Carmack Amendment (Liability when property delivered in violation of routing instruct))","49:13101":"49:13101 (49:13101 Transportation Policy)","49:13702":"49:13702 (49:13702 Tariff requirement for certain transportation)","49:13706":"49:13706 (49:13706 Motor Carriers, etc-Liability for Payment of Rates)","49:14501":"49:14501 (49:14501 Preemption (federal authority of intrastate transportation))","49:14705":"49:14705 (49:14705 Interstate Commerce Act/Carmack Amendment (Limitations on actions by and against carriers))","49:14706":"49:14706 (49:14706 Carmack Amendment Interstate Commerce Act / Liab. of Carriers - Receipts & Bills of Landing)","49:20301":"49:20301 (49:20301-20306 Federal Safety Appliance Act)","49:21302":"49:21302 (49:21302 Carriers violate of Interstate Comm Act (Chap 201,203 & 209 accident & incident violations))","49:30101":"49:30101 (49:30101 National Traffic & Motor Vehicle Safety Act )","49:30112":"49:30112 (49:30112 Motor Vehicle Safety (prohibition on non-complying motor vehicles and equipment))","49:30502":"49:30502 (49:30502 Natl Motor Vehicle Title Information Syst)","49:31114":"49:31114 (49:31114 Access to Interstate System/Commercial Motor Vehicle )","49:31502":"49:31502 (49:31502 Motor Carrier Safety: Requirements for Qualifications)","49:32101":"49:32101 (49:32101 Motor Vehicle Information and Costs Savings Act)","49:32701":"49:32701 (49:32701 Odometer Requirements Act)","49:40101":"49:40101 (49:40101 Federal Aviation Act)","49:40102":"49:40102 (49:40102 Airline Deregulation Actv(definitions of air and commerce safety) )","49:40105":"49:40105 (49:40105 Warsaw Convention )","49:41705":"49:41705 (49:41705 Air Carrier Access Act (discrimination against handicapped individuals))","49:41713":"49:41713 (49:41713 Airline Deregulation Actv (premp of authority over prices, routes, and service))","49:44709":"49:44709 (49:44709 Noise Control Act of 1972 )","49:44715":"49:44715 (49:44715 Noise Control Act of 1972 )","49:46507":"49:46507 (49:46507 False information and threats)","49:47101":"49:47101 (49:47101 Airport and Airway Improvement Act of 1982)","49:47501":"49:47501 (49:47501 Aviation Safety & Noise Abatement Act of 1979 )","49:49101":"49:49101 (49:49101 Wrongful Termination in Contravention of Published Regulations)","49:49104":"49:49104 (49:49104 Breach of Lease by Metro. Wash. Airport Auth.)","49:60101":"49:60101 (49:60101 Pipeline Safety Act of 1994)","49:60102":"49:60102 (49:60102 Hazardous Liquid Pipeline Safety Act of 1979 (HLPSA))","49:80102":"49:80102 (49:80102 Bills of Lading - Application)","49:80302":"49:80302 (49:80302 Contraband - Prohibitions)","49:80303":"49:80303 (49:80303 Seizure and forfeiture of vessel or aircraft conveying contraband )","50:1701":"50:1701 (50:1701-1706 International Emergency Economic Powers Act)","50a:0001":"50a:0001 (50a:0001 Trading With the Enemy Act (act located in Title 50, Appendix.))","50a:0501":"50a:0501 (50a:0501 Sailors and Soldiers Civil Relief Act (act located in Title 50, Appendix.))","50a:0533":"50a:0533 (50a:0533 Servicemembers Civil Relief Act-mortgages (act located in Title 50, Appendix.))","50a:0540":"50a:0540 (50a:0540 Sailors and Soldiers Civil Relief Act (act located in Title 50, Appendix.))","50a:2412":"50a:2412 (50a:2412 Export Administration Act--1979 (act located in Title 50, Appendix.))","51:20137a":"51:20137a (51:20137(a) Malpractice & Negligence Against U.S. Space program )","ins":"ins (Immigration Petition)","misc":"misc (Civil Miscellaneous Case)"},"codce":{"0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0138":"02:0138 (02:0138 Library of Congress Access)","02:0358":"02:0358 (02:0358 President's Recommendations on Exec., Jud. & Leg. Salary)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","02:0681":"02:0681 (02:0681 Deferral of Budget Authority)","02:1202":"02:1202 (02:1202 Discriminatory practices affecting US Senate employees)","02:1301":"02:1301 (02:1301 Congressional Accountability Act)","02:1317a":"02:1317a (02:1317a Violation of Congressional Accountability Act)","03:4301":"03:4301 (03:4301 Uniformed Services Employment and Reemployment Fights Act)","05:0101":"05:0101 (05:0101 - Ethics in Government Act)","05:0304":"05:0304 (05:304 Subpoenas)","05:0504(c)":"05:0504(c) (05:0504(c)(2) - Equal Access to Justice (Govt. Employees))","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0552sa":"05:0552sa (05:0552b(g) - Implement Requirements of Govt. in Sunshine Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0555(b)":"05:0555(b) (05:0555(b) - Agency Decision - Right to Counsel)","05:0701":"05:0701 (05:0701 Administrative Procedure Act)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:0706":"05:0706 (05:0706 - Judicial Review of Agency Action)","05:1508":"05:1508 (05:1508 - Judicial Review of Order Issued by MSPB)","05:2302":"05:2302 (05:2302 Civil Service Reform Act (CSRA))","05:3318":"05:3318 (05:3318 - Veterans Preference Act)","05:5514":"05:5514 (05:5514 (05:5514 Debt Collection Act of 1982))","05:5542":"05:5542 (05:5542 - Federal Employees Pay Act - overtime rates)","05:7101":"05:7101 (05:7101 - Labor-Management Relations(Findings and Purpose))","05:7123":"05:7123 (05:7123 - Petition by FLRA against unfair labor practices)","05:7501":"05:7501 (05:7501 - Government Employees Adverse Action - 14 days or less)","05:7511":"05:7511 (05:7511 - Government Employees Adverse Action - Over 14 days)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8101":"05:8101 (05:8101 - Workmen's Compensation Benefits)","05:8110":"05:8110 (05:8110 - Augmented Compensation for Dependents of Govt. Employees)","05:8316":"05:8316 (05:8316 - Claims Against US re: Retirement for Federal Emp.)","05:8470":"05:8470 (05:8470 - Enforcement of Judgment Against Retirement Benefits)","05:8701":"05:8701 (05:8701 Federal Employees Group Life Insurance Act (FEGLI))","05:8705":"05:8705 (05:8705 - Declaratory Judgment - Insurance)","05:8715":"05:8715 (05:8715 - Claims against the US - Jurisdiction of Courts)","05:8901":"05:8901 (05:8901 Federal Employees Health Benefit Act)","05:8902":"05:8902 (05:8902 - Contracting authority of OPM - Group Health Insurance)","05:8903":"05:8903 (05:8903 - Federal Employees Health Benefit Act)","05:8912":"05:8912 (05:8912 Jurisdiction of courts)","05:AppII":"05:AppII (05:AppII Federal Advisory Committee Act (FACA))","07:0001":"07:0001 (07:0001 Commodity Exchange Act)","07:0006(b)":"07:0006(b) (07:0006(b) - Federal Commodity Exchange Regulation)","07:0009a":"07:0009a (07:009a - Recovery of Penalties by Commodity Futures Trading Com)","07:0013a":"07:0013a (07:0013a - Contract Market Rules Violations; Recovery of Penalty)","07:0013a-1":"07:0013a-1 (07:0013a-1 -- Enjoin or Restrain Violations Contract Market Rules)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0087":"07:0087 (07:0087 - Enforcement of US Grain Standards Act)","07:0136":"07:0136 (07:0136 - Violations of EPA re: Environmental Pesticide Control)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0193(b)":"07:0193(b) (07:0193(b) - Recovery of Penalties re: violations by packers)","07:0203":"07:0203 (07:0203 - Recovery of Penalties for Violations by Stockyards)","07:0209(b)":"07:0209(b) (07:0209(b) - Violations re: Purchase, Sale, Handling of Livestock)","07:0210(f)":"07:0210(f) (07:0210(f) - Suit to enforce Award of Damages (Packers/Stockyards))","07:0213(b)":"07:0213(b) (07:0213(b) - Unfair, Discriminatory, Deceptive Practice/Marketing)","07:0216":"07:0216 (07:0216 - Injunctions to Restrain & Enforce Orders of Secretary)","07:0222":"07:0222 (07:0222 - Adoption of FTC Powers for Enforcement)","07:0228a":"07:0228a (07:0228a - Request by Secretary for TRO or Inj. re: Poultry)","07:0245":"07:0245 (07:0245 - Action on Bond by Person Injured in Warehouse)","07:0292":"07:0292 (07:0292 - Monopolizing or Restraining Trade & Enhancing Prices)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0499E":"07:0499E (07:0499E(c)(4) - Perishable Agricultural Commodities Act (PACA))","07:0601":"07:0601 (07:601 USDA Condemnation)","07:0608":"07:0608 (07:0608 - Agriculture Adjustment Act)","07:0901":"07:0901 (07:0901 - Rural Electrification Act)","07:1291(b)":"07:1291(b) (07:1291(b) - Agricultural Adjustment Act; Freight Rates)","07:1376":"07:1376 (07:1376 - Adjustment of Quotas and Enforcement Penalties)","07:1501":"07:1501 (07:1501 Federal Crop Protection)","07:1508":"07:1508 (07:1508 - Crop Insurance)","07:1631":"07:1631 (07:1631 Food Security Act)","07:1721":"07:1721 (07:1721 - Agricultural Trade Development Asst. Act)","07:1901":"07:1901 (07:1901 Commercial Transportation of Equine for Slaughter Act)","07:1922":"07:1922 (07:1922 - Persons Eligible for Loans - Foreclosure)","07:1926":"07:1926 (07:1926 - Water and Waste Facility Loans and Grants)","07:1930":"07:1930 (07:1930 - Perishable Agric. Comm. Act of 1930)","07:2011":"07:2011 (07:2011 - Supplemental Nutrition Assistance Program)","07:2022":"07:2022 (07:2022 - Disposition of Claims: Denial Application to Participate; Food Stamp Prog.)","07:2023":"07:2023 (07:2023 (a)(07:2023(a) Jud Rvw Admin Agency Determin))","07:2024":"07:2024 (07:2024 - Flase Claims Act, Food Stamp Fraud)","07:2131":"07:2131 (07:2131 - Violation of the Animal Welfare Act)","07:2146":"07:2146 (07:2146 - Transportation, Sale, and Handling of Animals)","07:2301":"07:2301 (07:2301 Agricultural Fair Practices Act)","07:2305":"07:2305 (07:2305 - Unfair Trade Practices Affecting Producers Agri. Prod.)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","07:2563":"07:2563 (07:2563 - Plant Variety Protection and Rights - Injunction)","07:6999":"07:6999 (07:6999 - Judicial Review of Adverse Farm Agency Decision)","08:0336":"08:0336 (08:0336 (08:0336 Judicial Review of Naturalization Denials))","08:1101":"08:1101 (08:1101 (08:1101 Illegal Immigration Reform and Immigrant Responsibility Act))","08:1151":"08:1151 (08:1151 Immigration and Nationality Act of 1952)","08:1152":"08:1152 (08:1152 Numerical limitations on individual foreign states)","08:1153":"08:1153 (08:1153 Allocation of Immigrant Visas)","08:1154":"08:1154 (08:1154 - Immigration: Procedure for Granting Immigration Status)","08:1158":"08:1158 (08:1158 - Immigration & Nationality Act, Section 208 (Asylum))","08:1182":"08:1182 (08:1182 - Inadmissible Aliens: Defend. Denial of Pla. Appl. for Alien Employment Cert.)","08:1183":"08:1183 (08:1183 - Admission of Aliens on Giving Bond or Undertaking; Return on Departure)","08:1188":"08:1188 (08:1188: Admission of Temporary H-2A Workers)","08:1225":"08:1225 (08:1225 - Immigration: Enforcement of Administrative Subpoena)","08:1231a6":"08:1231a6 (08:1231(a)(6) - Immigration: Due Process Clause)","08:1251a4":"08:1251a4 (08:1251(a)(4) - Immigration: Application for a Stay of Deportation)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1255":"08:1255 (08:1255 Immigration and Nationality Act)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1357":"08:1357 (08:1357 Immigration and Nationality Act - Administrative Search Warrant)","08:1421":"08:1421 (08:1421 Aliens and Nationality)","08:1445":"08:1445 (08:1445 (08:1445 Immigration and Nationality Act))","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1447":"08:1447 (08:1447 (08:1447 Petition for Naturalization Hearing Before District Court))","08:1451":"08:1451 (08:1451 Revocation of Naturalization )","08:1451(a)":"08:1451(a) (08:1451(a) - Action to Revoke Citizenship)","08:1451(j)":"08:1451(j) (08:1451(j) - Immigration: Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0003":"09:0003 (09:0003 - Application to Stay Proceedings Pending Arbitration)","09:0004":"09:0004 (09:4 Federal Arbitration Act)","09:0007":"09:0007 (09:0007 - Petition to Compel Attendance Before Arbitrator)","09:0008":"09:0008 (09:0008 - Declaratory Judgment/Admiralty)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","09:0011":"09:0011 (09:0011 - Motion to Modify or Correct Arbitration Award)","09:0202":"09:0202 (09:0202 - Award Under Convention on Foreign Arbitral Awards)","09:0205":"09:0205 (09:0205 - Removal From State Court: Enforcement of Foreign Arbital Awards)","09:0207":"09:0207 (09:0207 - Application for Order Confirming Award of Arbitrators)","09:201":"09:201 (09:201 Conv. on the Recog. & Enf. of Foreign Arbitral Awards)","10:0672":"10:0672 (10:0672 - Armed Forces: Active Guard/Reserve (AGR) Program)","10:1006":"10:1006 (10:1006 - Armed Forces: Review of Agency Decision)","10:1072tc":"10:1072tc (10:1072tc - Armed Forces: Tricare Program)","10:1089(c)":"10:1089(c) (10:1089(c) - Armed Forces: Removal, Dft. Acting in Scope of Duties)","10:1091":"10:1091 (10:1091 Personal Service Contract)","10:1107":"10:1107 (10:1107 Armed Forces: Use Of Investigational New Drug)","10:1408":"10:1408 (10:1408 - Armed Forces: Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2005":"10:2005 (10:2005 - Armed Forces: Advanced Education Assistance)","10:2121":"10:2121 (10:2121 - Armed Forces: Helath Professions Scholarship Financial Asst. Prog.)","10:2302":"10:2302 (10:2302 - Armed Forces: Arms Services Procurement Act)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","10:2323fa":"10:2323fa (10:2323fa - Armed Forces: Fifth Amendment Equal Protection: Contract Goal for Small Disadvant. Bus.)","10:2733":"10:2733 (10:2733 - Armed Forces: Military Claims Act)","10:2734":"10:2734 (10:2734 - Armed Forces: Foreign Military Claims Act)","10:2771":"10:2771 (10:2771 Armed Forces: Final Settlement - Deceased Members)","10:3258":"10:3258 (10:3258 - Armed Forces: Reg. Army: Re-Enlistment After Service as Ofcr.)","11:0101":"11:0101 (11:101 Bankruptcy)","11:0110":"11:0110 (11:0110 Bankruptcy)","11:0362h":"11:0362h (11:362h Bankruptcy - Violation of Automatic Stay)","11:0523":"11:0523 (11:0523 - Bankruptcy: Exceptions to Discharge)","11:0524":"11:0524 (11:0524 - Bankruptcy: Effect of Discharge)","11:0525":"11:0525 (11:0525 - Bankruptcy: Protections Against Discriminatory Treatment)","11:0548":"11:0548 (11:0548 - Bankruptcy: Fraudulent Transfers and Obligations)","11:0704":"11:0704 (11:0704 | 11:0704 Bankruptcy - Duties of Trustee)","11:Append":"11:Append (11:Appendix - Bankruptcy Appeal: This Refers to Rule 8001, not Section 8001)","12:0085":"12:0085 (12:0085 National Bank Act)","12:0093":"12:0093 (12:0093(a) National Bank Act)","12:0191":"12:0191 (12:0191 - National Banks: Appointment of Receiver)","12:0192":"12:0192 (12:0192 - National Banks: Liquidation of National Bank)","12:0215":"12:0215 (12:0215 Banks and Banking - Consolidation and Merger)","12:0622":"12:0622 (12:0622 - Foreign Banking: Forfeiture, Dissolution, and Liability of Directors & Officers for Noncmp)","12:0632":"12:0632 (12:0632 - Foreign Banking: Voluntary Liquidation)","12:0635":"12:0635 (12:635(i)(3) Breach of Insurance Contract)","12:1421":"12:1421 (12:1421 - Federal Home Loan Bank Act (Short Title))","12:1441":"12:1441 (12:1441 Financial Inst Reform Receiving Enforcement Act 1989)","12:1451":"12:1451 (12:1451 Federal Home Loan Mortgage Corporation Act)","12:1452":"12:1452 (12:1452 - Federal Home Loan Mortgage Corporation Act)","12:1452(f)":"12:1452(f) (12:1452(f) - Fed. Home Loan Mortgage Corp: Actions By and Against Corporation)","12:1455(b)":"12:1455(b) (12:1455(b) - Fed Home Loan Mortgage Corp: Enforcement of Regulations)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 - Savings Associations - Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1715(b)":"12:1715(b) (12:1715(b) - National Housing: Rules and Regulations)","12:1749aaa":"12:1749aaa (12:1749aaa - National Housing: National Insurance Development Program)","12:1751":"12:1751 (12:1751 - Fed. Credit Unions: Short Title)","12:1782":"12:1782 (12:1782 - Fed. Credit Unions: Administration of Insurance Fund)","12:1786":"12:1786 (12:1786 - Fed. Credit Unions: Actions re: Violations by Credit Unions)","12:1787":"12:1787 (12:1787(a)(B) Federal Credit Union Act)","12:1789a2":"12:1789a2 (12:1789(a)(2) - Fed. Credit Unions: Admin. Provision to Sue and be Sued)","12:1811":"12:1811 (12:1811 - FDIC: Financial Inst. Reform Recovery Act of 1989(FIRREA) (Org. of FDIC))","12:1818":"12:1818 (12:1818 FDIC - Subpoena Power)","12:1818(e)":"12:1818(e) (12:1818(e) - FDIC: Suspension or Removal of Bank Officer)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1831":"12:1831 (12:1831 Depository Institution Dereg Monetary Act 1980(DIDA))","12:1831(d)":"12:1831(d) (12:1831(d) - FDIC: Deposit Inst. Dereg & Monetary Ctrl. Act of 1980)","12:1831r-1":"12:1831r-1 (12:1831r-1 - FDIC: Notice of Branch Closure)","12:1833a":"12:1833a (12:1833a Financial Institutions Reform, Recovery and Enforcement Act)","12:1904":"12:1904 (12:1904 Economic Stablization Act of 1970)","12:1954":"12:1954 (12:1954 - Injunctions (Action by Sec. of Treasury re: Financial Recordkeeping))","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 - Tying Arrangement Act)","12:2001":"12:2001 (12:2001 Farm Credit Act of 1971)","12:2601":"12:2601 (12:2601 Real Estate Settlement Procedure Act of 1974 (RESPA))","12:2604(c)":"12:2604(c) (12:2604(c) - Real Estate Settlement Procedures Act (RESPA))","12:2605":"12:2605 (12:2605 - RESPA: Servicing of Mortgage Loans)","12:2607":"12:2607 (12:2607 - RESPA: Violation re: Kickbacks/Unearned Fees; Real Estate)","12:2609":"12:2609 (12:2609 - RESPA: Escrow)","12:3012":"12:3012 (12:3012 - National Consumer Cooperative Bank: Suits By or Against Bank)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","12:3416":"12:3416 (12:3416 Right to Financial Privacy Act)","12:3751":"12:3751 (12:3751 - Single Family Mortgage Forclosure Act: Findings & Purpose)","12:3801":"12:3801 (12:3801 - Alternative Mortgage Transaction Parity Act)","12:3907":"12:3907 (12:3907 - International Lending Supervision: Capital Adequacy)","12:4010":"12:4010 (Expedited Funds Availability: Violation of Act (Civil Liability))","12:5101":"12:5101 (12:5101 - Fraudulent Transfer Act (Enforcement for Mortgage Licensing))","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0004":"15:0004 (15:0004 - USDC Jurisdiction re: Violations of Sec. 1-7 of Title 15)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0009":"15:0009 (15:0009 - USDC Jurisdiction re: Violations of Sec. 8 of Title 15)","15:0010":"15:0010 (15:10 Securities Exchange Act)","15:0013":"15:0013 (15:0013 Robinson-Patman Act)","15:0014":"15:0014 (15:0014 Clayton Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0026":"15:0026 (15:0026 - Suit for Injunctive Relief re: Violation Antitrust Laws)","15:0041":"15:0041 (15:0041 - Federal Trade Commission Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045cp":"15:0045cp (15:0045cp - Violation of Children Online Privacy Protection Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0068":"15:0068 (15:0068 - Proceedings re: FTC Violations re: Wool Products)","15:0069":"15:0069 (15:0069 - Proceedings re: FTC Violations re: Fur Products)","15:0070":"15:0070 (15:0070 - Proceedings re: FTC Violations re: Textile Fiber Product)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78 Securities Exchange Act)","15:0078jb":"15:0078jb (15:0078j(b)ss - Stockholder Suit)","15:0078ma":"15:0078ma (15:0078m(a) - Securities Exchange Act)","15:0079":"15:0079 (15:0079 - Public Utility Holding Companies)","15:0080":"15:0080 (15:0080 Investment Company Act of 1940)","15:0080a-3":"15:0080a-3 (15:0080a-3 - Investment Company Act of 1940)","15:0260":"15:0260 (15:0260 - Proceedings re: Weights and Measures and Standard Time)","15:0298":"15:0298 (15:0298 - Violation of Law Proceedings re: Gold or Silver)","15:0433":"15:0433 (15:0433 - Discrimination against Farmers)","15:0631":"15:0631 (15:631 Small Business Act)","15:0636":"15:0636 (15:0636 - Small Business Act - Aid to Small Business)","15:0661":"15:0661 (15:0661 - Small Business Investment Act of 1958)","15:0687":"15:0687 (15:0687 - Small Business Investment Program)","15:0714(b)":"15:0714(b) (15:0714(b) - Commodity Credit Corporation)","15:0715(f)":"15:0715(f) (15:0715(f) - Proceedings re: Petroleum and Petroleum Products)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0719ic":"15:0719ic (15:0719i(c) - Civil Actions re: Violations for Inj. Involving Gas)","15:0751":"15:0751 (15:0751 - Energy Allocation Act; Emergency Petroleum Allocation)","15:0754":"15:0754 (15\"0754 - Emergency Petroleum Allocation-Admin. & Enforcement)","15:0766":"15:0766 (15:0766 - Controversies Arising re: Federal Energy Admin. Rules)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1071":"15:1071 (15:1071 - Appeal of Decision of US Patent & Trademark Office (Comm/Trademark Trial Bd))","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1116":"15:1116 (15:1116 - Inj. to Prevent Violation Rights of Trademark Owner)","15:1120":"15:1120 (15:1120 - Trademark - False or Fraudulent Registration)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Unfair Competition (Lanham Act))","15:1125(a)":"15:1125(a) (15:1125(a) - False Representation of Goods Sold in Interstate Commerce)","15:1125d":"15:1125d (15:1125d Anti Cybersquatting Consumer Protection Act)","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1191":"15:1191 (15:1191 - Flamable Fabrics Act)","15:1221":"15:1221 (15:1221 Automobile Dealer's Day in Court Act (DDCA))","15:1261":"15:1261 (15:1261 - Hazardous Substances (Definitions))","15:1263":"15:1263 (15:1263 - Prohibited Hazardous Substance - Interstate Commerce)","15:1267(a)":"15:1267(a) (15:1267(a) - Federal Hazardous Substances Act)","15:1314":"15:1314 (15:1314 - Antitrust - Petition for Enforcement)","15:1501":"15:1501 (15:1501 - Estab. of Dept. of Commerce)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1605":"15:1605 (15:1605 - Determination of Finance Charge)","15:1638":"15:1638 (15:1638 Truth in Lending)","15:1639":"15:1639 (15:1639 Home Owners Equity Protection Act (HOEPA))","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1666":"15:1666 (15:1666 - Fair Credit Billing Act Dispute)","15:1667":"15:1667 (15:1667 Federal Consumer Leasing Act)","15:1679":"15:1679 (15:1679 Credit Repair Organizations Act)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1691":"15:1691 (15:1691 Equal Credit Opportunity Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693":"15:1693 (15:1693 Electronic Fund Transfer Act)","15:1693m":"15:1693m (15:1693m - Violation of Prov. of Subchpt. VI (Electronic Fund Transfer))","15:1701":"15:1701 (15:1701 Interstate Land Sales Disclosure Act-15 USC:1701)","15:1709":"15:1709 (15:1709 - Interstate Land Sales)","15:1714":"15:1714 (15:1714 - Actions to Enjoin Violations re: Interstate Land Sale)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:2071":"15:2071 (15:2071 - Consumer Product Safety; Condemnation Hazardous Prod.)","15:2073":"15:2073 (15:2073 - Private Action to Enforce Consumer Product Safety)","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2310(c)":"15:2310(c) (15:2310(c) - Consumer Product Warranties)","15:2601":"15:2601 (15:2601 Toxic Substances Control Act (TCSA))","15:2604":"15:2604 (15:2604 - Application for Inj. re: Distribution Toxic Substance)","15:2616":"15:2616 (15:2616 - Toxic Substnace Control; Seizure of Chemical)","15:2620":"15:2620 (15:2620 - Toxic Substances Control Act - Citizen's Petition)","15:2651":"15:2651 (15:2651 Asbestos Hazard Emergency Response Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:2805":"15:2805 (15:2805 - Petroleum Marketing Practices-Franchise Protection)","15:34-35":"15:34-35 (15:34-35 - Investment Company Act of 1940)","15:3414":"15:3414 (15:3414 - National Gas Policy Act)","15:3710a":"15:3710a (15:3710a - Federal Technology Transfer Act of 1986)","15:3901":"15:3901 (15:3901 Federal Risk Retention Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","15:6801":"15:6801 (15:6801 - Gram-Leach-Bliley Act)","15:7701":"15:7701 (15:7701 - Federal CAN-Spam Act)","16:0019":"16:0019 (16:0019(j)(j) (16:0019 Park System Resource Protection Act))","16:0470":"16:0470 (16:0470 - Archaeological Resources Protection Act)","16:0470(f)":"16:0470(f) (16:0470(f) - National Historic Preservation Act)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0669":"16:0669 (16:0669 Pittman-Robertson Conservation Restoration Act)","16:0675":"16:0675 (16:0675 Norbeck Wildlife Preserve Organic Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:0823(a)":"16:0823(a) (16:0823(a) - Federal Public Utility Regulatory Policies Act)","16:0825":"16:0825 (16:0825 - Federal Power Commission Regulation;Public Utilities)","16:0831":"16:0831 (16:0831 - Actions re: Rights of Tennessee Valley Authority)","16:1244":"16:1244 (16:1244 - National Scenic and National Historic Trails)","16:1331":"16:1331 (16:1331 Wild Free Roaming Horse Act)","16:1374d6":"16:1374d6 (16:1374(d)(6) - Petition for Review re: Application for Import of Polar Bear Trophies)","16:1531":"16:1531 (16:1531 Endangered Species Act)","16:1533":"16:1533 (16:1533 - Endangered Species Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:1540":"16:1540 (16:1540 - Endangered Species Act - Penalties and Enforcement)","16:1600":"16:1600 (16:1600 National Forest Managment Act)","16:1801":"16:1801 (16:1801 - Magnuson-Stevens Fishery Conservation and Management Act)","16:1858":"16:1858 (16:1858 - National Fishery Management Program - Civil Penalties and Permit Sanctions)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","16:6802":"16:6802 (16:6802 Recreation Enhancement Act (REA))","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0201":"17:0201 (17:0201 - Ownership of Copyright)","17:0205(d)":"17:0205(d) (17:0205(d) - Priority Between Conflicting Transfers)","17:0407":"17:0407 (17:0407 - Recovery of Fines & Penalties by Register of Copyrights)","17:0411":"17:0411 (17:0411(b) Copyright infringment)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0502(a)":"17:0502(a) (17:0502(a) - Inj. to Prevent or Restrain Infringement Copyright)","17:0504":"17:0504 (17:504 Copyright Infringement)","17:0512":"17:0512 (17:0512 - Copyright Infringement of Digital Communications)","17:1201":"17:1201 (17:1201 Digital Millennium Copyright Act)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0248":"18:0248 (18:248 Freedom of Access to Clinic Entrances Act)","18:0492":"18:0492 (18:0492: Forfeiture: Counterfeiting and Forgery)","18:0603":"18:0603 (18:0603 - Conflict of Interest)","18:0921":"18:0921 (18:0921 Title IV Omnibus Crime Control & Safe Streets Act)","18:0922":"18:0922 (18:0922 - Firearms - Unlawful Possession (Civil Fines))","18:0923":"18:0923 (18:0923 Gun Control Act of 1968)","18:0923f3":"18:0923f3 (18:0923(f)(3) - Review of Revocation of a License as a Dealer in Firearms)","18:0924":"18:0924 (18:0924 Civil Forfeiture)","18:0925(c)":"18:0925(c) (18:0925(c) - Restoration of Ability to Possess Firearms/Ammo)","18:0981":"18:0981 (18:0981 Civil Forfeiture)","18:0981a1A":"18:0981a1A (18:0981(a)(1)(A) - Civil Forfeiture: Money Laundering Control Act)","18:0983":"18:0983 (18:0983 (18:0983 Civil Forfeiture))","18:1030g":"18:1030g (18:1030(g) - Fraud & Related Matters in Connection w/ Computers)","18:1201":"18:1201 (18:1201 Federal Kidnapping across state lines)","18:1343":"18:1343 (Fraud by wire)","18:1345":"18:1345 (18:1345 - Injunction Against Fraud)","18:1514":"18:1514 (18:1514 - Civil Action to Restrain Harrassment of a Victim)","18:1514A":"18:1514A (18:1514A Sarbanes-Oxley Act)","18:1589":"18:1589 (18:1589 Forced Labor)","18:1831":"18:1831 (18:1831: Economic Espionage Act of 1996)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1905":"18:1905 (18:1905 - Disclosure of Confidential Information)","18:1955":"18:1955 (18:1955 - Civil Forfeiture - Prohibition of Illegal Gambling)","18:1956b3":"18:1956b3 (18:1956(b)(3) - Laundering of Monetary Instruments - Forfeit Property)","18:1957":"18:1957 (18:1957 - Forfeiture Property)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:1968":"18:1968 (18:1968 - Action re: Civil Investigative Demand)","18:2252":"18:2252 (18:2252 - Assault, Internet Pornography)","18:2254":"18:2254 (18:2254 - Civil Forfeiture - Exploitation of Children)","18:2331":"18:2331 (18:2331 - Anti-Terrorism Act (Definitions))","18:2333":"18:2333 (18:2333 - Civil Remedies: Anti-Terrorism Act of 1991)","18:2382":"18:2382 (18:2382 - Misprison of Treason -- No Civil Action)","18:2510":"18:2510 (18:2510 Electronic Communications Privacy Act of 1986)","18:2511":"18:2511 (18:2511 - Wiretapping - Injunctive Relief or Civil Fine)","18:2520":"18:2520 (18:2520 Interception of Communications)","18:2701":"18:2701 (18:2701 Unlawful Access To Stored Communications)","18:2707":"18:2707 (18:2707 - Civil Action: Stored Communications)","18:2710(c)":"18:2710(c) (18:2710(c) - Wrongful Disclosure of Video Tape Rental or Sales Records)","18:2721":"18:2721 (18:2721 Drivers Privacy Protection Act of 1994)","18:2724":"18:2724 (18:2724 - Civil Action - Motor Vehicle Records)","18:3006":"18:3006 (18:3006 - Hyde Amendment, Statutory Note)","18:3114":"18:3114 (18:3114 - Motion for Return of Seized Property)","18:3184":"18:3184 (18:3184 - Extradition Procedure)","18:3569":"18:3569 (18:3569 - Unresolved Committed Fine -- Indigent Prisoners)","18:3663":"18:3663 (18:3663 - Civil Enforcement of Crim. Rest. Obligation)","18:4100":"18:4100 (18:4100 - Transfer of Offenders)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","19:1497":"19:1497 (19:1497 - Customs Duties: Penalty for Failure to Declare)","19:1595(a)":"19:1595(a) (19:1595(a) - Customs Duties: Forfeiture and Other Penalties)","19:1607":"19:1607 (19:1607 - Customs Duties: Notice of Seizure)","20:0107":"20:0107 (20:0107 Randolph - Sheppard Act)","20:1070":"20:1070 (20:1070 - Student Assistance)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1087":"20:1087 (20:1087 - Student Loan Discharge)","20:1095a":"20:1095a (20:1095a Education - Wage Garnishment Requirement)","20:1097":"20:1097 (20:1097 - Education - Criminal Penalties for Fraud)","20:1098(g)":"20:1098(g) (20:1098(g) - Higher Education Act - Exemption From State Disclosure)","20:1232(g)":"20:1232(g) (20:1232(g) - Family Education Rights & Privacy Act of 1974)","20:1332":"20:1332 (20:1332 - ERISA)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1412":"20:1412 (20:1412 - IDEA: State Eligibility)","20:1415":"20:1415 (20:1415 - IDEA: Challenge Decision re: Education for Handicapped)","20:1415e2":"20:1415e2 (20:1415(e)(2)de - IDEA: Mediation)","20:1681":"20:1681 (20:1681 Title IX Educational Amendments 1992)","20:1683":"20:1683 (20:1683 - Judicial Review: Prohibition Against Sex Descrimination in Education)","20:1706":"20:1706 (20:1706 - Relief From Denial of Equal Educational Opportunity)","20:1717":"20:1717 (20:1717 - Reopening Proceedings w/Order to End Segregation)","21:0301":"21:0301 (21:0301 - Federal Food, Drug & Cosmetic Act)","21:0331":"21:0331 (21:331 Federal Food, Drug & Cosmetic Act)","21:0332":"21:0332 (21:0332 Federal Food, Drug and Cosmetic Act, Injunctive Relief)","21:0332(a)":"21:0332(a) (21:0332(a) - Federal Food, Drug & Cosmetic Act)","21:0334(a)":"21:0334(a) (21:0334(a) - Forfeiture or Condemnation- food, drug,cosmetics)","21:0348":"21:0348 (21:0348 - Federal Food, Drug & Cosmetic Act - Food Additives)","21:0360":"21:0360 (21:0360 - Federal Food, Drug & Cosmetic Act - Drugs & Devices)","21:0467":"21:0467 (21:0467 - Seizure & Condemnation of Poultry Products)","21:0601":"21:0601 (21:0601 - Federal Meat Inspection Act 21 USC 601-695 (Definitions))","21:0673":"21:0673 (21:0673 - Seizure & condemnation of Meat or Meat Products)","21:0674":"21:0674 (21:0674 - Proceeding to Enforce& Enjoin re: Meat Products)","21:0821":"21:0821 (21:0821 - Violation of Record Keeping Provision of Controlled Substances Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0842":"21:0842 (21:0842 - Civil Penalty for Violation re: Controlled Substance)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","21:0882":"21:0882 (21:0882 - Inj. to Enjoin Violations re: Controlled Substance)","21:1049":"21:1049 (21:1049 - Seiure & condemnation re: Eggs or Egg Products)","22:0286":"22:0286 (22:0286 - Action Against Workd Bank or IMF)","22:2702":"22:2702 (22:2702 - Medical Malpractice by Govt. Medical Personnel)","22:3612":"22:3612 (22:3612 - Claim for Damage to Panama Canal)","22:3776":"22:3776 (22:3776 - Panama Canal Commission Action on Claims)","22:3777":"22:3777 (22:3777 - Investigation of Accident or Injury Giving Rise to a Claim)","22:4140":"22:4140 (22:4140 - Foreign Service Grievance Act - Judicial Review)","23:0112":"23:0112 (23:0112 - Federal Highway Act - Letting of Contracts)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0391":"25:0391 (25:0391 Indian Land Laws)","25:0640":"25:0640 (25:640(a)(d) - Indian Tribal Rights)","25:1303":"25:1303 (25:1303 Petition for Writ of Habeas Corpus)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","25:2701":"25:2701 (25:2701 - Indian Gaming Regulatory Act (IGRA))","25:4101":"25:4101 (25:4101 Native American Housing Assistance and Self-Determination Act (NAHASDA))","26:0063":"26:0063 (26:0063 - IRS: Taxable Income (definition))","26:0982":"26:0982 (26:0982 - IRS: To Quash IRS Formal Document Request)","26:2032":"26:2032 ((26:2032 IRS: Alternate valuation))","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6221":"26:6221 (26:6221 - IRS: TEFRA Tax, Equity and Fiscal Responsibility Act of 1982)","26:6226":"26:6226 (26:6226 - IRS - Partnership Administrative Adjustment)","26:6320":"26:6320 (26:6320 - IRS: Notice and Opportunity for Hearing Upon Filing Notice of Lien)","26:6330":"26:6330 (26:6330 IRS: Appeal of Agency Determination)","26:6331":"26:6331 (26:6331 IRS: Wrongful Levy)","26:6334":"26:6334 (26:6334 IRS: Property Exempt from Levy)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6653sp":"26:6653sp (26:6653 IRS: Additions & Penalties - Spousal Liability)","26:6672":"26:6672 (26:6672 - IRS: Failure to Collect and Pay Over Tax, or Attempt to Evade or Defeat Tax)","26:6694":"26:6694 (26:6694 - IRS: Underestimate of Tax Liability by Tax Preparer)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7323":"26:7323 (26:7323 - IRS: Proceedings in Rem Enforce Forfeitures Property)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 - IRS: Jurisdiction of District Courts)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7404":"26:7404 (26:7404 - IRS: Enforce Summons, Examination Books & Witnesses)","26:7405":"26:7405 (26:7405 - IRS: Action for Recovery of Refunds Erroneously Made)","26:7407":"26:7407 (26:7407 Action to enjoin tax return preparers)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7425(a)":"26:7425(a) (26:7425(a) - IRS: Judiciary & Judicial Procedures - Discharge of Liens)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7428":"26:7428 (26:7428 - IRS: Declaratory Judgment)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7430":"26:7430 (26:7430 - IRS: Awarding of Costs and Certain Fees in Tax Suit)","26:7431":"26:7431 (26:7431 Civil damages for unauth disclosure returns & info)","26:7433":"26:7433 (26:7433 Civil damages for unauthorized collection actions)","26:7434":"26:7434 (26:7434 Taxpayer Bill of Rights)","26:7604(a)":"26:7604(a) (26:7604(a) - IRS: Complaint to Enforce IRS Summons)","26:7609":"26:7609 (26:7609 - IRS: Petition to Serve Third Party Summons)","26:7609j":"26:7609j (26:7609 IRS: Petition for John Doe Summons)","26:7609q":"26:7609q (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0051":"28:0051 (28:0051 - Personal Injury)","28:0157b":"28:0157b (28:157b Bankruptcy Claim to be tried in U.S. District Court)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0463":"28:0463 (28:0463 - Expenses of Judicial Litigation)","28:0534":"28:0534 (28:0534 - Arrest Records)","28:0591":"28:0591 (28:0591 - Independent Counsel)","28:0592":"28:0592 (28:0592 - Independent Counsel - Application for Appointment)","28:0593":"28:0593 (28:0593 - Independent Counsel - Court Responsibilities)","28:0594":"28:0594 (28:0594 - Independent Counsel - Responsibilities)","28:0595":"28:0595 (28:0595 - Independent Counsel - Congressional Oversight)","28:0596":"28:0596 (28:0596 - Independent Counsel - Removal)","28:0597":"28:0597 (28:0597 - Independent Counsel - Dept. of Justice Relationship)","28:0598":"28:0598 (28:0598 - Independent Counsel - Chapter Termination)","28:0636":"28:0636 (28:0636 - Jurisdiction and Power of Magistrate Judges)","28:0754":"28:0754 (28:0754 - Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1291":"28:1291 (28:1291 - Maritime)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question: Labor)","28:1331ag":"28:1331ag (28:1331ag - Fed. Question - Employment Discrimination (Age))","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331as":"28:1331as (28:1331as - Fed. Question - Assault, Libel, Slander)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331bv":"28:1331bv (28:1331bv - Fed. Question - Bivens-Prisoner)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cr":"28:1331cr (28:1331cr - Fed. Question - Civil Rights (Race Discrimination))","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331dd":"28:1331dd (28:1331dd Fed. Question: Discovery Disputes)","28:1331dj":"28:1331dj (28:1331dj - Fed. Question - Declaratory Judgment)","28:1331dp":"28:1331dp (28:1331dp - Fed. Question - Violation of Due Process)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ef":"28:1331ef (28:1331ef - Fed. Question - Civil Rights Violation (Excess Force))","28:1331ej":"28:1331ej (28:1331ej - Fed. Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fa":"28:1331fa (28:1331fa - Fed. Question: Civil Rights Violation - False Arrest)","28:1331fd":"28:1331fd (28:1331 Fed. Question: Fraud)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331fm":"28:1331fm (28:1331fm - Fed. Question: Family and Medical Leave Act)","28:1331fr":"28:1331fr (28:1331fr - Fed. Question - Fraud)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331lm":"28:1331lm (28:1331lm - Fed. Question - Legal Malpractice)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331ng - Fed. Question - Natural Gas Act)","28:1331ni":"28:1331ni (28:1331ni - Negotiable Instrument)","28:1331pd":"28:1331pd (28:1331pd - Fed. Question - Property Damage)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331pl":"28:1331pl (28:1331pl - Fed. Question - Product Liability)","28:1331pr":"28:1331pr (28:1331pr - Fed. Question: Federal Prisoner Civil Rights)","28:1331ra":"28:1331ra (28:1331ra - Fed. Question: Racketeering (RICO) Act)","28:1331rc":"28:1331rc (28:1331 Fed. Question: Reclamation Project Auth. Act of 1972)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331rs":"28:1331rs (28:1331rs Federal Rail Safety Act)","28:1331sh":"28:1331sh (28:1331sh - Fed. Question - Sexual Harrassment)","28:1331ss":"28:1331ss (28:1331ss - Fed. Question: Constitutionality of State Statutes)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331sx":"28:1331sx (28:1331sx - Fed. Question: Employment Discrimination (Sex))","28:1331ta":"28:1331ta (28:1331 Fed. Question: Taxes)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331va":"28:1331va (28:1331va - Fed. Question: Violation 5th & 14th Amendments)","28:1331vc":"28:1331vc (28:1331vc - Fed. Question: Violation of Constitutional Rights)","28:1331w":"28:1331w (28:1331w - Fed. Question: Wrongful Termination of Employment)","28:1331wd":"28:1331wd (28:1331wd - Fed.Question: Wrongful Death)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332":"28:1332 (28:1332 Diversity)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332ap":"28:1332ap (28:1332ap - Diversity - Airplane Product Liability)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332bw":"28:1332bw (28:1332bw - Diversity - Breach of Warranty)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332de":"28:1332de (28:1332de - Diversity: Forcible Detainer)","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332dm":"28:1332dm (28:1332 Diversity-Discrimination)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332dtp":"28:1332dtp (28:1332 Diversity - Deceptive Trade Practices)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332ej":"28:1332ej (28:1332ej (28:1332 Enforcement of Judgment))","28:1332em":"28:1332em (28:1332 Diversity - Employment)","28:1332fc":"28:1332fc (28:1332 Diversity - Foreclosure)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332if":"28:1332if (28:1332if - Diversity - Insurance Fraud)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332lp":"28:1332lp (28:1332lp - Diversity: Property Damage/Product Liability)","28:1332lr":"28:1332lr (28:1332lr Diversity - Labor)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332md":"28:1332md (28:1332md - Diversity: Motor Vehicle/Wrongful Death)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332nr - Diversity: Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332op":"28:1332op (28:1332op - Diversity: Recovery of Overpayment)","28:1332pa":"28:1332pa (28:1332pa - Diversity: Personal Injury/Airplane)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332rd":"28:1332rd (28:1332rd - Diversity: Recovery of Debt)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332rl":"28:1332rl (28:1332rl - Diversity: Rent Lease & Ejectment)","28:1332rp":"28:1332rp (28:1332 Diversity - Real Property)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities)","28:1332sh":"28:1332sh (28:1332sh - Diversity: Sexual Harassment)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332t":"28:1332t (28:1332t - Diversity: Torts)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332ts":"28:1332ts (28:1332ts - Diversity: Misappropriation of Trade Secrets)","28:1332vt":"28:1332vt (28:1332vt - Diversity: Natl. Motor Vehicle Title Information System)","28:1332wc":"28:1332wc (28:1332wc - Diversity: Worker's Compensation Benefits)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333ad - Admiralty)","28:1333in":"28:1333in (28:1333in - Personal Injury)","28:1333mc":"28:1333mc (28:1333mc - Marine Contract)","28:1333pd":"28:1333pd (28:1333pd - Property Damage)","28:1333pi":"28:1333pi (28:1333pid - Marine Personal Injury)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334(b)":"28:1334(b) (28:1334(b) - Proceeding Arising/Related to Case Under Title 11)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Commerce and Antitrust Regulations)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1339":"28:1339 (28:1339 - Postal Matters)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1340tp":"28:1340tp (28:1340tp Injunction of Tax Preparer)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1344":"28:1344 (28:1344 - Election Disputes)","28:1345":"28:1345 (28:1345 - U.S. Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345lc":"28:1345lc (28:1345lc - Land Condemnation)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345ro":"28:1345ro (28:1345 Recovery of Retirement Overpayment)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345tx":"28:1345tx (28:1345 Prohibit dfts assessing tx on purch/use of pers prop)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346":"28:1346 ()","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346pi":"28:1346pi (28:1346pi - Marine Personal Injury (or Tort Claim - Personal Injury/Motor Vehicle))","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346t Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1348":"28:1348 (28:1348 - Banking Association as Party)","28:1349":"28:1349 (28:1349 - Corporation Organized Under Federal Law as Party)","28:1350":"28:1350 (28:1350 - Alien Tort Claims Act)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1356":"28:1356 (28:1356 - Executory Process/Foreclosure)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 - Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1363":"28:1363 (28:1363 - Action for Protection of Jurors Employment Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1367":"28:1367 (28:1367 - Other Property Damage)","28:1369":"28:1369 (28:1369 Multiparty, multiforum jurisdiction)","28:1391":"28:1391 (28:1391 - Venue)","28:1394":"28:1394 (28:1394 - Banking Assoc. Action Against Comptroller of Currency)","28:1395":"28:1395 (28:1395 - Complaint for Forfeiture)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1403":"28:1403 (28:1403 - Condemnation of Real Estate for the Use of the US)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1407im":"28:1407im (28:1407im - MDL: Silicone Gel Breast Implant Products Liability)","28:1407md":"28:1407md (28:1407md - MDL: Multidistrict Litigation)","28:1407n":"28:1407n (28:1407n - MDL: Personal Injury/Norplant Product Liability)","28:1407pl":"28:1407pl (28:1407pl - MDL: Products Liability)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441ada":"28:1441ada (28:1441ada - Removal - Americans With Disabilities Act)","28:1441ag":"28:1441ag (28:1441ag - Removal - Civil Rights (Age))","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441ba":"28:1441ba (28:1441ba - Removal - National Bank Act)","28:1441bc":"28:1441bc (28:1441bc - Removal - Breach of Contract)","28:1441bfd":"28:1441bfd (28:1441bfd - Removal - Breach of Fiduciary Duties)","28:1441ca":"28:1441ca (28:1441ca - Removal - Carmack Amendment)","28:1441cc":"28:1441cc (28:1441cc - Removal - Computer Crimes Act)","28:1441cj":"28:1441cj (28:1441cj - Removal - Confessed Judgment)","28:1441cla":"28:1441cla (28:1441cla - Removal - Consumer Leasing Act)","28:1441cp":"28:1441cp (28:1441cp - Removal - Copyright)","28:1441cpl":"28:1441cpl (28:1441cpl - Removal - Contract Product Liability)","28:1441cra":"28:1441cra (28:1441cra - Removal - Fair Credit Reporting Act)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441dea":"28:1441dea (28:1441dea - Removal - Disabilities Education Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441di":"28:1441di (28:1441di - Removal - Civil Rights (Disability Act))","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ea":"28:1441ea (28:1441ea - Removal - Employment Discrimination (Age))","28:1441eb":"28:1441eb (28:1441eb - Removal - ERISA Employee Benefits)","28:1441ec":"28:1441ec (28:1441ec - Removal - Electronic Comm. Privacy Act)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441em":"28:1441em (28:1441em - Removal - Emergency Medical Treatment & Active Labor)","28:1441er":"28:1441er (28:1441er - Removal - Employment Discrimination (Race))","28:1441es":"28:1441es (28:1441es - Removal - Employment Discrimination (Sex))","28:1441fa":"28:1441fa (28:1441fa - Removal - Civil Rights -- False Arrest)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fd":"28:1441fd (28:1441fd - Removal - Fair Debt Collection Practices Act)","28:1441fe":"28:1441fe (28:1441fe - Removal - Fed. Employee Garnishment Statute)","28:1441fh":"28:1441fh (28:1441fh - Removal - FEHBA)","28:1441fif":"28:1441fif (28:1441fif - Removal -- Insecticide/Fungicide/Rodenticide Act - 1942)","28:1441fl":"28:1441fl (28:1441fl - Removal - Fair Labor Standards Act)","28:1441fm":"28:1441fm (28:1441fm - Removal - Family and Medical Leave Act)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441fs":"28:1441fs (28:1441fs - Removal - Foreign Sovereign Immunities Act)","28:1441fsa":"28:1441fsa (28:1441fsa - Removal - Federal Food Stamp Act)","28:1441hb":"28:1441hb (28:1441hb - Removal - Petition of Habeas Corpus)","28:1441hc":"28:1441hc (28:1441hc - Removal - Handicapped Child Protection Act)","28:1441hd":"28:1441hd (28:1441hd - Removal - Housing Discrimination)","28:1441ia":"28:1441ia (28:1441ia - Removal - Interstate Commerce Act)","28:1441if":"28:1441if (28:1441if - Removal - Insurance Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441il":"28:1441il (28:1441il - Removal - Interstate Land Full Discloser Act)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441la":"28:1441la (28:1441la - Removal -- Truth In Lending Act)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441ml":"28:1441ml (28:1441ml - Removal - Motor Vehicle Prod. Liability)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441mv":"28:1441mv (28:1441mv - Removal - Motor Vehicle)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441nr - Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pa":"28:1441pa (28:1441pa - Removal - Patent Infringement)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ra":"28:1441ra (28:1441ra - Removal -- Civil Rights (Race))","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441rl":"28:1441rl (28:1441rl - Removal -- Rent, Lease & Ejectment)","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441sh":"28:1441sh (28:1441sh - Removal - Sexual Harassment)","28:1441st":"28:1441st (28:1441st - Removal -- Stockholders Suit)","28:1441sv":"28:1441sv (28:1441sv - Removal -- Security Violation)","28:1441sx":"28:1441sx (28:1441sx - Removal -- Civil Rights (Sex))","28:1441tc":"28:1441tc (28:1441tc - Removal -- Tricare Program)","28:1441ti":"28:1441ti (28:1441ti - Removal - Trademark Infringement)","28:1441til":"28:1441til (28:1441til - Removal -- Truth and Lending)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441us":"28:1441us (28:1441us - Removal -- Uniformed Svc. Emp./Reemp. Rights Act)","28:1441wc":"28:1441wc (28:1441wc - Removal -- Worker's Compensation Benefits)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1441wt":"28:1441wt (28:1441wt - Removal -- Employment (Wrongful Termination))","28:1442":"28:1442 (28:1442 - Notice of Removal -- Suit Against Federal Officer)","28:1442aaf":"28:1442aaf (28:1442aaf - Petition for Removal -- Agst. Members of Armed Forces)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446al":"28:1446al (28:1446al - Notice of Removal -- Airline Crash)","28:1446as":"28:1446as (28:1446as - Notice of Removal -- Asbestos Litigation)","28:1446bc":"28:1446bc (28:1446bc - Notice of Removal -- Breach of Contract)","28:1446cs":"28:1446cs (28:1446cs - Notice of Removal -- Child Support Enforcement)","28:1446dj":"28:1446dj (28:1446dj - Notice of Removal -- Declaratory Judgment)","28:1446er":"28:1446er (28:1446er - Notice of Removal -- ERISA)","28:1446fm":"28:1446fm (28:1446fm - Notice of Removal -- Family and Medical Leave Act)","28:1446fr":"28:1446fr (28:1446fr - Notice of Removal -- Fraud)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446lb":"28:1446lb (28:1446lb - Notice of Removal -- Libel, Assault, Slander)","28:1446ml":"28:1446ml (28:1446ml - Notice of Removal -- Motor Vehicle Prod. Liability)","28:1446mm":"28:1446mm (28:1446mm - Notice of Removal -- Medical Malpractice)","28:1446mv":"28:1446mv (28:1446mv - Notice of Removal -- Motor Vehicle)","28:1446ni":"28:1446ni (28:1446ni - Notice of Removal -- Negotiable Instrument)","28:1446nr":"28:1446nr (28:1446nr - Notice of Removal)","28:1446oc":"28:1446oc (28:1446oc - Notice of Removal -- Other Contract)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl - Notice of Removal -- Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1446st":"28:1446st (28:1446st - Notice of Removal - Stockholders Suit)","28:1446tl":"28:1446tl (28:1446tl - Notice of Removal -- Torts to Land)","28:1446wd":"28:1446wd (28:1446ws - Notice of Removal -- Wrongful Death)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1452a":"28:1452a (28:1452 (a) Removal of Claims Related to Bankruptcy Cases)","28:1453":"28:1453 (28:1453 - Class Action Fairness Act)","28:1491":"28:1491 (28:1491 Tucker Act - Claims Against United States)","28:1602":"28:1602 (28:1602 Foreign Sovereign Immunities Act of 1976)","28:1605":"28:1605 (28:1605 - Foreigh Sovereign Immunities Act of 1976)","28:1605A":"28:1605A (28:1605A - Antiterrorism & Effective Death Penalty Act 1996)","28:1610":"28:1610 (28:1610 Juridictional Immunities of Foreign States)","28:1631":"28:1631 (28:1631 - Case Transferred to Cure Want of Jurisdiction)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1651ne":"28:1651ne (28:1651ne - Application for Writ Ne Exeat)","28:1651w":"28:1651w (28:1651w - All Writs Act)","28:1715":"28:1715 (28:1715 - Class Action Fairness Act of 2005)","28:1732":"28:1732 (28:1732 - Reproduction of Records)","28:1738Acs":"28:1738Acs (28:1738Acs - The Uniform Child Custody Jurisdiction Act)","28:1782":"28:1782 (28:1782 Assistance to foreign & international tribunals & litigants)","28:1783":"28:1783 (28:1783 - Petition for Subpoena of Person in Foreign Country)","28:1826":"28:1826 (28:1826 - Order of Confinement of Recalcitrant Witness)","28:1875":"28:1875 (28:1875 Protection of Jurors' Employment)","28:1916":"28:1916 (28:1916 - Marine Personal Injury)","28:1963":"28:1963 (28:1963 - Registration of Judgment From Another District)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2001":"28:2001 (28:2001 Judicial Sale of Realty)","28:2071":"28:2071 (28:2071 - Rule Making Power Generally)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201an":"28:2201an (28:2201an - Declaratory Judgment (Aliens and Nationality))","28:2201cp":"28:2201cp (28:2201cp - Declaratory Judgment (Copyright))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201fa":"28:2201fa (28:2201fa - Declaratory Judgment -- Firearms)","28:2201fs":"28:2201fs (28:2201fs - Declaratory Judgment -- Food Securty Act)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2201pi":"28:2201pi (28:2201pi - Declaratory Judgment -- Personal Injury)","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2241fd":"28:2241fd (28:2241fd - Petition for Writ of Habeas Corpus (Federal))","28:2241in":"28:2241in (28:2241in - Habeas Corpus: INS)","28:2241st":"28:2241st (28:2241st - Petition for Writ of Habeas Corpus (State))","28:2244":"28:2244 (28:2244 Habeas Corpus - Finality of Determination)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254dp":"28:2254dp (28:2254dp - Petition for Writ of Habeas Corpus (Death Penalty))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2255hc":"28:2255hc (28:2255 Petition for Writ of Habeas Corpus)","28:2256":"28:2256 (28:2256 - Transfer Convicted Offenders to Foreign Country)","28:2283":"28:2283 (28:2283 Stay of State Court Proceedings)","28:2347":"28:2347 (28:2347 - Petition to Review Orders in the Court of Appeals)","28:2401":"28:2401 (28:2401 - Federal Tort Claims Act (Time for Commencing Action Against the US))","28:2403":"28:2403 (28:2403 - Constitutionality of State Statute(s))","28:2405":"28:2405 (28:2405 - Garnishment of Debtors of a Corporation by US)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Action affecting property on which US has lien)","28:2412":"28:2412 (28:2412 Equal Access to Justice Act)","28:2415":"28:2415 (28:2415 - Detinue and Conversion)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2672mv":"28:2672mv (28:2672mv - Federal Tort Claims Act -- Motor Vehicle)","28:2672pi":"28:2672pi (28:2672pi - Federal Tort Claims Act -- Personal Injury)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:2675":"28:2675 (28:2675 - Federal Tort Claims Act - Disposition by Agency Req.)","28:2679":"28:2679 (28:2679 Federal Tort Claims Act)","28:2679d2":"28:2679d2 (28:2679(d)(2) - Federal Tort Claims Act - Employee of USA)","28:2680":"28:2680 (28:2680 - Federal Tort Claims Act -- Exceptions)","28:3001":"28:3001 (28:3001 - Federal Debt Collection Act)","28:3001(a)":"28:3001(a) (28:3001(a) - Federal Debt Collection Procedures Act of 1990)","28:3203":"28:3203 (28:3203 - Post Judgment Remedies: Writ of Execution)","28:3301":"28:3301 (28:3301 - Fraudulent Transfer Federal Debt Collection Procedures Act)","28:6694":"28:6694 (28:6694 IRS Underestimate Of Tax Liability By Tax Preparer)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","28:876":"28:876 (28:876 Controlled Substance Act)","29:0101":"29:0101 (29:0101 Equal Pay Act)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0158":"29:0158 (29:0158 Unfair Labor Practices)","29:0158(b)":"29:0158(b) (29:0158(b) - NLRA -- Unfair Labor Practices)","29:0159":"29:0159 (29:0159 - Labor: Violation of Collective Bargaining Agreement)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0160j":"29:0160j (29:0160j - Labor: Petition for Inj. -- Relief From Unfair Labor Practice)","29:0160l":"29:0160l (29:0160l - Labor: Petition for Inj. re: Uncertified Labor Organizations)","29:0161(2)":"29:0161(2) (29:0161(2) - Labor: Enforcement of Agency Subpoena)","29:0178":"29:0178 (29:0178 - Labor: Petition for Inj. to Enjoin Strike During Nat'l. Emergency)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185":"29:0185 (29:0185 - Labor: Suits By and Against Labor Organizations)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations)","29:0186":"29:0186 (29:0186 Liabilities of and Restrictions on Labor and Management)","29:0187":"29:0187 (29:0187 - Labor: Recover Damages From Unfair Labor Practice)","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:0206 - FLSA -- Minimum Wage)","29:0206(d)":"29:0206(d) (29:0206(d) - FLSA: Prohibition of Sex Discrimination)","29:0207(a)":"29:0207(a) (29:0207(a) - FLSA: Action for Overtime Wage Violation)","29:0207fl":"29:0207fl (29:0207fl - FLSA: Maximum Hours)","29:0210":"29:0210 (29:0210 - FLSA: Court Review of Wage Orders in PR and VI)","29:0215":"29:0215 (29:215 Fair Labor Standards Act)","29:0215fl":"29:0215fl (29:0215fl - FLSA: Prohibited Acts)","29:0216":"29:0216 (29:0216 Fair Labor Standards Act)","29:0216(b)":"29:0216(b) (29:0216(b) - FLSA: Minimum Wage or Overtime Compensation)","29:0216(e)":"29:0216(e) (29:0216(e) - FLSA: Penalty Assessed for Child Labor Provisions)","29:0217":"29:0217 (29:0217 - FLSA: Enjoin Violations of Fair Labor Standards Act)","29:0260":"29:0260 (29:0260 - FLSA: Liquidated Damages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0411":"29:0411 (29:0411 - Landrum Griffin Act)","29:0412":"29:0412 (29:0412 - Infringement of Rights; Members of Labor Organization)","29:0440":"29:0440 (29:0440 - Violations Reporting Requirements; Labor Organization)","29:0501(b)":"29:0501(b) (29:0501(b) - Violation of Fiduciary Responsibility)","29:0621":"29:0621 (29:621 Job Discrimination)","29:0623":"29:0623 (29:623 Job Discrimination)","29:0626":"29:0626 (29:626 Job Discrimination)","29:0633":"29:0633 (29:633 Job Discrimination)","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0660":"29:0660 (29:0660 - Action by Sec. Labor for Discrimination re: Rights OSHA)","29:0662":"29:0662 (29:0662 - Inj. PRoceedings re: Dangerous Emp. Conditions; by Sec.)","29:0666":"29:0666 (29:0666 - Collection of Civil Penalties Under OSHA)","29:0701":"29:0701 (29:0701 Vocational Rehabilitation)","29:0706":"29:0706 (29:0706 Rehabilitation Act of 1973)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0792d2":"29:0792d2 (29:0792(d)(2) - Accessible Facilities for Phys. Handicapped Emp.)","29:0794":"29:0794 (29:0794 Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1055":"29:1055 (29:1055 - ERISA: Employee Retirement (Joint & Survivor Annuity))","29:1101":"29:1101 (29:1101 E.R.I.S.A.)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1161":"29:1161 (29:1161 ERISA, COBRA)","29:1162":"29:1162 (29:1162 - COBRA -- Continuation Coverage)","29:1303":"29:1303 (29:1303 - PBGC: Operation of Corporation)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:159":"29:159 (29:159 - Labor: Violation of Collective Bargaining Agreement)","29:1612":"29:1612 (29:1612 - FMLA: Leave Requirements)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:1854":"29:1854 (28:1854 Migrant & Seasonal Agri Worker Protect Act (AWPA))","29:1916":"29:1916 (29:1916 - Spec. Rule for Longshoremen & Harborworkers)","29:2001":"29:2001 (29:2001 Employee Polygraph Protection Act)","29:2101":"29:2101 (29:2101 Worker Adjustment and Retaining Notification Act)","29:2104":"29:2104 (29:2104 - Worker Adjustment & Retraining Notification (WARN))","29:2601":"29:2601 (29:2601 Family and Medical Leave Act)","29:2611":"29:2611 (29:2611 Family & Medical Leave Act 1993)","29:2615":"29:2615 (29:2615 Family and Medical Leave Act)","29:2617":"29:2617 (29:2617 Family and Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0022":"30:0022 (30:0022 General Mining Law of 1872 )","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:0815":"30:0815 (30:0815 Federal Mine Safety & Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","30:1701":"30:1701 (30:1701 Federal Oil Gas Royalty Mgt Act 1982 (FOGRMA))","30:181":"30:181 (30:181 Mineral Lands Leasing Act (MLLA))","31:0732":"31:0732 (31:0732 General Acct. Office Personnel Act of 1980)","31:1341":"31:1341 (31:1341 - Government Employee -- Limitations on Expending Monies)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3702":"31:3702 (31:3702 - Procedures for Settling Claims)","31:3713":"31:3713 (31:3713 - Priority of Government Claims)","31:3720":"31:3720 (31:3720 - Federal Income Tax Interceptions (Collection of Payments))","31:3728":"31:3728 (31:3728 - Setoff Against Judgment)","31:3729":"31:3729 (31:3729 - False Claims Act -- Liability)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","31:3733":"31:3733 (31:3733(j)(2)Pet to Mod or Set Aside CV Investigative Demand)","31:5314":"31:5314 (31:5314 - Failure to Report Interest in Foreign Accounts)","31:5317":"31:5317 (31:5317 - Search and Forfeiture of Monetary Instruments)","31:5320":"31:5320 (31:5320 - Inj. or Penalty; Failure to File Foreign Currency Rpt.)","31:5321":"31:5321 (31:5321 - Penalty for Failure to Report Transportation Money)","31:5332(a)":"31:5332(a) (31:5332(a) - Evading Currency Reporting Requirement)","31:5332(f)":"31:5332(f) (31:5332(f) - Transport and Transfer US Currency From in to Out)","31:6716":"31:6716 (31:6716 - Discrimination re: Money and Finance)","31:9701":"31:9701 (31:9701 - Federal User Charge Statute)","33.1301":"33.1301 (33.1301 Clean Water Act)","33:0408":"33:0408 (33:0408 - Injury to Harbor Improvement)","33:0594":"33:0594 (33:0594 - Land Condemnation)","33:0901":"33:0901 (33:0901 - Longshoremen Harbor Workers Compensation Ace (Navigation & Navigable Waters))","33:0905(b)":"33:0905(b) (33:0905(b) - Longshoremen Workers' Compensation Act -- Recovery of Damages Caused by Negl. of V)","33:0918":"33:0918 (33:0918 - Longshore & Harbor Workers Compensation Act -- Collection of Defaulted Payments)","33:0921":"33:0921 (33:0921 - Longshore & Harborworkers Compensation Act -- Review of Compensation Orders)","33:0933":"33:0933 (33:0933 - Longshore & Harbor Workers' Compensation Act - Comp. for Injuries (Third-Party Claims)","33:1221":"33:1221 (33:1221 - Ports and Waterways Safety Program)","33:1251":"33:1251 (33:1251 - Federal Water Pollution Control Act (Clean Water Act))","33:1311":"33:1311 (33:1311 Federal Water Pollution Control Act)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1321":"33:1321 (33:1321 - Clean Water Act -- Discharge of Hazardous Substance or Pollutants/Water)","33:1342":"33:1342 (33:1342 Federal Water Pollution Control Act)","33:1361":"33:1361 (33:1361 - Clean Water Act -- Administrator Authority)","33:1364":"33:1364 (33:1364 - Clean Water Act -- EPA Action to Restrain Pollution Endangering Health (Emergency Powers))","33:1365":"33:1365 (33:1365 Environmental Matters)","33:1415":"33:1415 (33:1415 - Marine Protection, Research, & Sanctuaries Act)","33:1515":"33:1515 (33:1515 - Deepwater Ports Act (Citizen Civil Action))","33:2701":"33:2701 (33:2701 - Oil Pollution Act of 1940)","35:0001":"35:0001 ( 35:0001 Patent Infringement)","35:0032":"35:0032 (35:0032 - Suspension From Practice Before Patent & Trade Off.)","35:0101":"35:0101 (35:0101 (35:101 Patent Infringement))","35:0145":"35:0145 (35:145 Patent Infringement)","35:0146":"35:0146 (35:0146 - Appeal From Decision of the Board of Patent Appeals)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0256":"35:0256 (35:0256 (35:256 Patent Infringement))","35:0271":"35:0271 (35:271 Patent Infringement)","35:0281":"35:0281 (35:0281 - Remedy for Infringement of Patent/Jurisdiction Conferred 28:1338)","35:0282":"35:0282 (35:0282 - Patent Infringement -- Defenses)","35:0283":"35:0283 (35:0283 - Action to Enjoin Violation of Right Secured by Patent)","35:0289":"35:0289 (35:0289 - Recover Profits From Unlicensed Use of Design Patent)","35:0291":"35:0291 (35:0291 - Action for Relief Between Owners; Interferring Patents)","35:0292":"35:0292 (35:0292 - Penalty & Forfeiture; Illegal Use of Word Patent (False Marking))","35:0311":"35:0311 (35:0311 - Patent - Request for Inter Partes Reexamination)","36:220501":"36:220501 (36:220501 Olympic and Amateur Sports Act)","37:3729(a)":"37:3729(a) (Unsealed Qui Tam Case)","38:1110":"38:1110 (38:1110 - Basic Entitlements/Wartime)","38:1131":"38:1131 (38:1131 - Basic Entitlements/Peacetime)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:1816":"38:1816 (38:1816 Recover Liability of Home Loan Deficiency Amount)","38:1965":"38:1965 (38:1965 Servicemen's Group Life Insurance)","38:1975":"38:1975 (38:1975 Servicemembers Group Life Insurance Traumatic Injury Protection Program \"TGSLI\")","38:1984":"38:1984 (1984 - Suit For Veterans Insurance)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (38:2021 Reemployment of Inducted Persons; Benefits Protected)","38:2024":"38:2024 (38:2024 Enlisted/Active Duty Persons Rights; Reserves)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:3481":"38:3481 (38:3481 - Recovery of VA Overpayment)","38:3680":"38:3680 (38:3680 - Recovery of Education Assist Allowance Overpayment)","38:4212":"38:4212 (38:4212 - Veterans Employment Emphasis Under Federal Contracts)","38:4301":"38:4301 (38:4301 Uniformed Services Employment and Reemployment Rights Act)","38:4302":"38:4302 (38:4302 Veterans Reemployment Rights Act)","38:4311":"38:4311 (38:4311 - Uniformed Service Employment or Reemployment Rights Act (USERRA) - Discrimination)","38:4312":"38:4312 (38:4312 - Rights of Inducted Persons to Reemployment)","38:4323":"38:4323 (38:4323 - USERRA -- Enforcement of Rights With Respect to State or Private Employer)","38:4324":"38:4324 (38:4324 - USERRA -- Enforcement of Rights With Respect to Federal Executive Agencies)","38:5315":"38:5315 (38:5315 Delinquent Payment of Amounts Due to US)","38:5316":"38:5316 (38:5316 - VA Overpayment)","39:0403":"39:0403 (39:0403 - Discriminatory Use of the Postal Service)","39:1207":"39:1207 (39:1207 - Review Agency Action -- Labor Disputes)","39:1208(b)":"39:1208(b) (39:1208(b) - Postal Reorganization Ace of 1970 - Suits)","39:3005":"39:3005 (39:3005 - False Representations and Lotteries)","39:3007":"39:3007 (39:3007 - Detention of Mail for Temporary Periods - Inj. Directing Retention of Incoming Mail)","39:3008(e)":"39:3008(e) (39:3008(e) - Enforce Compliance With a USPS Prohibitory Order)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:1101":"40:1101 (40:1101 - Brooks Architect -- Engineers Act)","40:3131":"40:3131 (40:3131 Miller Act)","40:3142":"40:3142 (40:3142 - Davis-Bacon Act (Prevailing Wages))","40:581":"40:581 (40:581 General Authority of Administrator of General Services)","41:0351":"41:0351 (41:0351 McNamara-O'Hara Service Contract Act 1965)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","41:2102-":"41:2102- (41:2102-2107 -- Procurement Integrity Act)","41:3301":"41:3301 (41:3301 - Competition in Contracting Act)","41:6503":"41:6503 (41:6503 - Walsh-Healy Act -- Breach of Public Contract)","41:6505":"41:6505 (41:6505 - Exclusions -- Review of Legal Questions in Contracts; Walsh-Healy Act)","41:6702-":"41:6702- (41:6702-6704 -- Service Contract Labor Standards/McNamara-O'Hara Service Contract Act 1965)","41:7105(f)":"41:7105(f) (41:7105(f) - Action to Judicially Enforce Administrative Subpoena)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0254o":"42:0254o (42:0254(o) - Breach of Scholarship Contract)","42:0256":"42:0256 (42:0256 - Public Health Services Act -- Grants)","42:0274e":"42:0274e (42:0274e National Organ Transplant Act)","42:0292(f)":"42:0292(f) (42:0292(f) - Default of Borrower)","42:0292(k)":"42:0292(k) (42:0292(k) - Student Loan Insurance (Public Health Occupations))","42:0293":"42:0293 (42:0293 - Recovery of Lossed From Loan Guarantee; Public Health)","42:0294":"42:0294 (42:0294(w) - Health Educ Assist Loan (HEAL) under Public Health Svc Act)","42:0297":"42:0297 (42:0297 - Student Loans; Public or Nonprofit School of Nursing)","42:0300(f)":"42:0300(f) (42:0300(f) - Safe Drinking Water Act (Definitions))","42:0300(g)":"42:0300(g) (42:0300(g) - Actions re: Safety of Public Water Systems (EPA))","42:0300aa1":"42:0300aa1 (42:0300(a)(a)(1) - Nat'l Childhoot Vaccine Injury Compensation Act)","42:0401":"42:0401 (42:0401 - Social Security Act -- Trust Funds)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405rs":"42:0405rs (42:0405(r)(s) - Review of HHS Decision (RSI))","42:0405si":"42:0405si (42:405 Review of HHS Decision (RSI))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0421(d)":"42:0421(d) (42:0421(d) - Review of HHS Decision re: Disability Determinations)","42:0423":"42:0423 (42:0423 - Social Security Act (Disability Insurance Benefit Payments))","42:0427":"42:0427 (42:427 Social Security Benefits)","42:0601":"42:0601 (42:0601 - Title IV-A of the Social Security Act (Grants to State for Aid & Asst. to Needy Families))","42:0602":"42:0602 (42:0602 Aid to Families with Dependent Children (AFDC))","42:0660":"42:0660 (42:0660 - Action to Enforce Child Support Obligations)","42:10139":"42:10139 (42:10139 - Judicial Review of Agency Actions)","42:10801":"42:10801 (42:10801 - Protection & Advocacy for Individuals With Mental Illness Act of 1986 (PAIMI))","42:10805":"42:10805 (42:10805 Protection and Advocacy Systems)","42:11001":"42:11001 (42:11001 - Emergency Plan. & Comm. Right to Know Act (EPCRA))","42:11046":"42:11046 (42:11046 Fed Emer Plan Comm Right-to-know Act (EPCRA))","42:11101":"42:11101 (42:11101 - Health Care Quality Improvement Act of 1986)","42:11112":"42:11112 (42:11112 - Health Care Quality Improvement Act (Standards for Professional Review Actions))","42:11601":"42:11601 (42:11601 Intl Child Abduction Remedies Act (ICARA))","42:11603b":"42:11603b (42:11603(b) - Int'l. Child Abduction Remedies Act (ICARA) -- Judicial Review)","42:12101":"42:12101 (42:12101 Americans With Disabilities Act (ADA))","42:12102":"42:12102 (42:12102 - Americans With Disabilities Act (ADA) Disability Definition)","42:12111":"42:12111 (42:12111 - Americans With Disabilities Act - Employment)","42:12112":"42:12112 (42:12112 American with Disabilities Act (ADA- Discrimination))","42:12117":"42:12117 (42:12117 American With Disabilities Act (ADA))","42:12131":"42:12131 (42:12131 American with Disabilities Act (ADA- Accommodations))","42:12132":"42:12132 (42:12132 - Americans With Disabilities Act -- Discrimination)","42:12134":"42:12134 (42:12134 Americans with Disabilities Act (IDEA) Education)","42:12181":"42:12181 (42:12181 American With Disabilities Act (ADA))","42:12188":"42:12188 (42:12188 - Americans With Disabilities Act -- Civil Enforcement Actions)","42:12201":"42:12201 (42:12201 - Violation sof Title II Amer. With Disabilities Act)","42:1320a7b":"42:1320a7b (42:1320(a)(7)(b)(b)(2)(A) - Anti-Kickback Act (For Federal Health Care Programs))","42:1320d-2":"42:1320d-2 (42:1320(d)(2) - Health Insurance Portability & Accountability Act (HIPAA))","42:1381(a)":"42:1381(a) (42:1381(a) - Supplemental Security Income Benefits (SSID))","42:1382":"42:1382 (42:1382 - Eligibility for Benefits)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1385":"42:1385 (42:1385 - Medicare Health Act)","42:1395":"42:1395 (42:1395 - Emergency Medical Treatment & Active Labor Act)","42:1395dd":"42:1395dd (42:1395dd Emergency Medical Treatment and Active Labor Act)","42:1395hr":"42:1395hr (42:1395(h)(r) - Hospital Reimbursement for Medicare Services)","42:1395w21":"42:1395w21 (42:1395(w)(21) - Medicare Act (Eligibility, Election, & Enrollment))","42:1396":"42:1396 (42:1396 Grants to States for Medical Assistance Programs)","42:1396(a)":"42:1396(a) (42:1396(a) - State Plans for Medical Assistance)","42:1396(b)":"42:1396(b) (42:1396(b) - Medical Asst. Prgm., Pmt. to States/Medicaid Implem.)","42:13981":"42:13981 (42:13981 Civil Rights for Women Act 1994)","42:1401":"42:1401 (42:1401 - Actions by or Against U.S. Housing Authority)","42:14135":"42:14135 (42:14135 - DNA Backlog Grant Program)","42:1437":"42:1437 (42:1437 - U.S. Housing Act of 1937)","42:1456":"42:1456 (42:1456 - U.S. Housing Authority Action re: Slums/Urban Renewal)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1475":"42:1475 (42:1475 - Declaratory & Injunctive Relief -- Foreclosure Procedures)","42:1479":"42:1479 (42:1479 - Mortgage, Lease, Contract re: Farm Housing)","42:14901":"42:14901 (42:14901 Intercountry Adoptions)","42:15483":"42:15483 (42:15483 - Help America Vote Act)","42:1651":"42:1651 (42:1651 Defense Base Act)","42:1705":"42:1705 (42:1705 - Receipt of Workmen's Compensation Benefits)","42:1971":"42:1971 (42:1971 Voting Rights Act of 1965)","42:1973":"42:1973 (42:1973 - Voting Rights Act)","42:1973(c)":"42:1973(c) (42:1973(c) - Voting Rights -- Qualifications & Procedures)","42:1973a":"42:1973a (Enforcement of Voting Rights)","42:1973gg2":"42:1973gg2 (42:1973(g)(g)(2) - Nat'l. Voter Registration Act of 1993 (NVRA))","42:1981(a)":"42:1981(a) (42:1981(a) - Damages in Cases of Intentional Descrim. in Employment)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination)","42:1981ra":"42:1981ra (42:1981(r)(a) - Race Discrimination)","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1982hs":"42:1982hs (42:1982(h)(s) - Discrimation re: Property Rights (Housing))","42:1982ra":"42:1982ra (42:1982(r)(a) - Discrimination re: Property Rights (Race))","42:1982sx":"42:1982sx (42:1982(s)(x) - Discrimination re: Property Rights (Sex))","42:1983(d)":"42:1983(d) (42:1983(d) - Civil Rights (Death))","42:1983bv":"42:1983bv (42:1983(b)(v) - Bivens -- Non Prisoner)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983cvp":"42:1983cvp (42:1983(c)(v)(p) - Civil Rights (Personal Property))","42:1983dp":"42:1983dp (42:1983(d)(p) - Civil Right Denial of Due Process)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1983vp":"42:1983vp (42:1983(v)(p) - Violation of Due Process & Equal Protection)","42:1984":"42:1984 (Civil Rights)","42:1985":"42:1985 (42:1985 Conspiracy to Interfere with Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:1987":"42:1987 (42:1987 - Procesution of Violations of Certain Laws (Viol. of Sec. 1990 or 5506-5516 or 5518-5532))","42:1988":"42:1988 (42:1988 - Proceedings in Vindication of Civil Rights)","42:1997":"42:1997 (42:1997 - Institutional Persons Act of 1980)","42:2000":"42:2000 (42:2000 Job Discrimination (Gender))","42:2000(b)":"42:2000(b) (42:2000(b) - Equal Access to Public Facilities)","42:2000a":"42:2000a (42:2000a Title II Civil Rights Act 1964)","42:2000a3":"42:2000a3 (42:2000(a)(3)-(p)(a) - Discrimination, Segregation; Public Accommodation -- Inj. Relief)","42:2000ad":"42:2000ad (42:2000(a)(d) - Job Discrimination (Disability Act))","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000bb":"42:2000bb (42:2000bb Religious Freedom Restoration Act.)","42:2000c6":"42:2000c6 (42:2000(c)(6)-(e)(d) - Discrimination in Education)","42:2000cc":"42:2000cc (42:2000cc Religious Land Use & Institutionalized Persons Act of 2000)","42:2000d":"42:2000d (42:2000d (42:2000d Federally Assisted Programs))","42:2000di":"42:2000di (42:2000 Job Discrimination (Disability))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000e2":"42:2000e2 (42:2000(e)(2)-(o)(t) - Job Discrimination (Other))","42:2000e2s":"42:2000e2s (42:2000(e)(2) - (s)(h) -- Job Discrimination (Sexual Harassment))","42:2000e5e":"42:2000e5e (42:2000(s)(5) - (e)(e)(o) -- Petition to Enforce EEOC Subpoena)","42:2000e9":"42:2000e9 (42:2000e9 Petition to Enforce EEOC Subpoena)","42:2000no":"42:2000no (42:2000no Job Discrimination (National Origin))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:200e2rl":"42:200e2rl (42:2000(e)(2) - (r)(l) -- Job Discrimination (Religion))","42:2210":"42:2210 (42:2210 Indeminification & Limitation of Liability-Financial)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:2996":"42:2996 (42:2996 - Legal Services Corporation Act)","42:300g-3":"42:300g-3 (42:300g-3 Enforcement of Drinking Water Regulations)","42:3058(g)":"42:3058(g) (42:3058(g) - Older American's Act of 1965; 42 USC 3058(g) (State Long-Term Care Ombudsman Prgm.)","42:3121":"42:3121 (42:3121 Public Works and Economic Development Act of 1965)","42:3133":"42:3133 (42:3133 - Coordination -- Grants for Public Works & Economic Development)","42:3601":"42:3601 (42:3601 Fair Housing Act)","42:3604f3c":"42:3604f3c (42:3604(f)(3)(c) - Fair Housing Amendments Act)","42:3610":"42:3610 (42:3610 - Fair Housing Act -- Administrative Enforcement; Preliminary Matters)","42:3612":"42:3612 (42:3612 - Civil Rights in Housing -- Enforcement by Secretary)","42:3613":"42:3613 (42:3613 - Action for Inj. Relief re: Deprivation of Civil Rights)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001(s)(r) - National Insurance Flood Act)","42:4013":"42:4013 (42:4013 - National Flood Insurance Act -- Nature & Limitation of Insurance Coverage)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4231":"42:4231 (42:4231 National Environmental Policy Act (NEPA))","42:425":"42:425 (42:427 Social Security Benenfits)","42:4321":"42:4321 (42:4321 - Review of Agency Action -- Environment (Declaration of Purpose))","42:4331":"42:4331 (42:4331 National Environmental Policy Act (NEPA))","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:4721":"42:4721 (42:4721 Intergovernmental Personnel Act)","42:4821":"42:4821 (42:4821 - Lead-Based Paint Poisoning Prevention Act (Findings & Purposes))","42:4901":"42:4901 (42:4901 - Noise Control Act of 1972 (Findings & Purposes))","42:4910(c)":"42:4910(c) (42:4910(c) - Action to Restrain Violation re: Noise Control)","42:5101":"42:5101 (42:5101 Child Abuse Prevention and Treatment Act)","42:5303":"42:5303 (42:5303 - Block Grant Act of 1974 (42 USC 5301-5321))","42:5401":"42:5401 (42:5401 Natl Mnfactrd Housing Cnstr Safety Standard Act 1974)","42:5411":"42:5411 (42:5411 - Housing Construction & Safety Standards Act -- Injunctive Relief)","42:5851":"42:5851 (42:5851 - Discrimination \"Whistle Blower\" Employee - ERA (Employee Protection))","42:6101":"42:6101 (42:6101 Age Discrimination in Federally Assisted Programs (Statement of Purpose))","42:6201":"42:6201 (42:6201 - Energy Policy & Conservation Act (Statement of Purpose))","42:6393":"42:6393 (42:6393 - Controversies Under Energy Policy & Conservation Act (Admin. Procedure & Judicial Review))","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:6928":"42:6928 (42:6928 - Violations of Requirements of Hazardous Waste Mgmt. (Federal Enforcement))","42:6961":"42:6961 (42:6961 Federal Facilities Compliance Act)","42:6972":"42:6972 (42:6972 Resource & Recovery Act - Citizen Suit)","42:6972(a)":"42:6972(a) (42:6972(a) - Solid Waste Disposal Act - Citizen Suit)","42:7192":"42:7192 (42:7192 - Controversies Under Dept. of Energy Organization Act -- Judical Review)","42:7384":"42:7384 (42:7384 Energy Employees Occupational Illness Compensation Program Act (EEOICPA))","42:7401":"42:7401 (42:7401 Air Pollution Prevention and Control Act)","42:7412":"42:7412 (42:7412 - Air Pollution Control -- Emission Standards)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7475":"42:7475 (42:7475 - Clean Air Act -- Preconstruction Requirements)","42:7545":"42:7545 (42:7545 Clean Air Act)","42:7603":"42:7603 (42:7603 - Action for Immediate Restraint (Emergency Powers))","42:7604":"42:7604 (42:7604 - Clean Air Act -- Citizen Suit to Enforce Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:7671":"42:7671 (42:7671 - Clean Air Act (Stratospheric Ozone Protection) (Definitions))","42:8324":"42:8324 (42:8324 - Powerplant & Industrial Fuel Use -- Terms & Conditions)","42:8351":"42:8351 (42:8351 - Powerplant & Industrial Fuel Use -- Temporary Exemptions)","42:9601":"42:9601 (42:9601 - Comprehensive Environmental Compen/Resp/Liab (CERCLA) (Definitions))","42:9604":"42:9604 (42:9604 - Comprehensive Envir., Response, Comp. & Liab. Act (CERCLA) -- Removal & Other Remedial Act)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","42:9613":"42:9613 (42:9613 Comp Environ Recovery Comp & Liability Act (CERCLA))","43:0421":"43:0421 (43:0421 - Complaint in Condemnation -- Eminent Domain)","43:0945(b)":"43:0945(b) (43:0945(b) - Complaint in Condemnation -- Easements)","43:1331":"43:1331 (43:1331 - Outer Continental Shelf Lands Act (Definitions))","43:1333":"43:1333 (43:1333 - Outer Continental Shelf Lands Act -- Laws & Regulations Governing Lands)","43:1349":"43:1349 (43:1349 - Outer Continental Land Shelf Act -- Citizen Suits)","43:1701":"43:1701 (43:1701 - Violation of Federal Land Policy & Management Act (FLPMA))","43:1737":"43:1737 (43:1737 FLPMA)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","44:2107":"44:2107 (44:2107 - Presidential Records & Materials Act (NARA Acceptance of Records for Historical Preserv.))","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0056":"45:0056 (45:0056 - Employers Liability Act - Personal Inj. re: Railroads (Bringing an Action))","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0152":"45:0152 (45:0152 - Railway Labor Act -- General Duties)","45:0153":"45:0153 (45:0153 - First Railway Labor Act -- National Railroad Adjustment Board)","45:0159":"45:0159 (45:0159 - Review of Arbitration Award (RR Carriers/Mediation Bd.))","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:0231(f)":"45:0231(f) (45:0231(f) - Compel Obedience to Order of Railroad Retirement Bd.)","45:0351":"45:0351 (45:0351 - Railroad Unemployment Insurance Act)","45:0719":"45:0719 (45:0719 - Regional Rail Reorganization Act of 1973 (Judicial Review))","45:1105":"45:1105 (45:1105 - Northeast Rail Service Act -- Judicial Review)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1300":"46:1300 (46:1300 Carriage of Goods by Sea Act (COGSA))","46:2114":"46:2114 (46:2114 - Wrongful Discharge From Employment -- Protection From Discrimination)","46:30101":"46:30101 (46:30101 - Extension of Jurisdiction to Cases of Damage or Injury on Land)","46:30104":"46:30104 (46:30104 - Marine Personal Injury - Jones Act)","46:30302":"46:30302 (46:30302 - Shipping: Damages for Death on High Seas)","46:30304":"46:30304 (46:30304 - Breach of Maritime Contract -- Liability of Noncompliance)","46:30503":"46:30503 (46:30503 - Limitation of Liability -- Declaration of Nature & Value of Goods)","46:30504":"46:30504 (46:30504 - Limitation of Liability -- Loss by Fire)","46:30505":"46:30505 (46:30505-30510 - Exoneration, Limitation of Liability)","46:30511":"46:30511 (46:30511 - Action by Owner for Limitation)","46:30701":"46:30701 (46:30701 - Marine Cargo Loss or Damage -- Liability of Water Carriers)","46:30704":"46:30704 (46:30704 - Liability of Water Carriers -- Loading, Stowage, Custoey, Care, and Delivery)","46:30902":"46:30902 (46:30902-30911 - Suits in Admiralty Act)","46:31102":"46:31102 (46:31102 - Public Vessels Act -- Waiver of Immunity)","46:31301":"46:31301 (46:31301 - Federal Maritime Lien Act)","46:31321":"46:31321 (46:31321 - Foreclosure of Preferred Ship Mortgages)","46:31325":"46:31325 (46:31325 - Suit to Enforce Lien Upon Mortgaged Vessel/Foreclosure of Preferred Foreign Ship)","46:31341":"46:31341 (46:31341 - Federal Maritime Lien Act)","46:31342":"46:31342 (46:31342 - Breach of Maritime Contract (Establishing Maritime Liens))","46:31343":"46:31343 (46:31343 - Commercial Instruments & Maritime Liens)","46:40101":"46:40101 (46:40101 - Shipping Act of 1998)","46:41102a":"46:41102a (46:41102(a) - Shipping Act of 1984 -- General Prohibitions)","46:41309":"46:41309 (46:41309 - Shipping Act of 1984 -- Enforcement of Reparation Orders)","46:50101":"46:50101 (46:50101 - Violation of Maritime Regulations)","46:58109":"46:58109 (46:58109 - Violation of Merchant Marine Act -- Penalties)","47:0151":"47:0151 (47:0151 Communications Act of 1934)","47:0151cs":"47:0151cs (47:0151(c)(s) - Federal Communications Act -- Collection for Services)","47:0201bt":"47:0201bt (47:0201(b)(t) - Breach of Tariff)","47:0203":"47:0203 (47:0203 - Telecommunications Collection of Charges)","47:0205":"47:0205 (47:0205 - Waire & Radio Communication Svc. & Charges (Recovery of Damages))","47:0206":"47:0206 (47:0206 - Carrier's Liability for Damages)","47:0207":"47:0207 (47:0207 Wire and Radio Communication Svc and Charges)","47:0227":"47:0227 (47:0227 Telephone Consumer Protection Act)","47:0227b3":"47:0227b3 (47:0227(b)(3) - Telephone Consumer Protection Act of 1991)","47:0251":"47:0251 (47:0251 - Telecommunications Act of 1996 -- Interconnection)","47:0252":"47:0252 (47:0252 - Telecommunications Act)","47:0254(h)":"47:0254(h) (47:0254(h) - Children's Internet Protection Act)","47:0332":"47:0332 (47:0332 Telecommunications Act of 1996)","47:0332(c)":"47:0332(c) (47:0332(c) - Federal Telecommunications Act of 1996)","47:0338":"47:0338 (47:0338 - Satellite Home Viewer Improvement Act)","47:0401":"47:0401 (47:0401 - Application of Federal Communication Comm. for Inj. (Enforcement Provisions))","47:0407":"47:0407 (47:0407 - Order for Payment of Money; Petition for Enforcement)","47:0510":"47:0510 (47:510 Forfeiture of Communications Devices)","47:0521":"47:0521 (47:0521 Cable Consumer Protection and Competition Act 1992)","47:0532":"47:0532 (47:0532 Cable Communication Policy Act of 1984)","47:0551":"47:0551 (47:0551 Cable Communications:Protection of Subscriber Prvcy.)","47:0553":"47:0553 (47:0553 Cable Comm: Unauthorized Reception of Cable Services)","47:0605":"47:0605 (47:0605 Cable Comm:Unauthorized publication or use of comm)","47:407":"47:407 (47:407 Order for payment of money; petition for enforcement;)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0101":"49:0101 (49:0101 - ICC Termination Act of 1996)","49:0502":"49:0502 (49:0502 Transportation Administrative Subpoena)","49:10101":"49:10101 (49:10101 Rail Transportation)","49:10501":"49:10501 (49:10501 Rail Interstate Transportation - General Jurisdiction)","49:10743":"49:10743 (49:10743 - Revised Interstate Commerce Act)","49:10903":"49:10903 (49:10903 Filing and Procedure for Application to Abandon or Discontinue)","49:11101":"49:11101 (49:11101 Interstate Commerce Act)","49:1113":"49:1113 (49:1113 - Petition to Enforce Administrative Summon)","49:1136":"49:1136 (Aviation Disaster Family Assistance Act of 1996)","49:11501":"49:11501 (49:11501 - Railroad Revitalization & Regulatory Reform Act (General Jurisdiction))","49:11502":"49:11502 (49:11502 - Transportation)","49:11701":"49:11701 (49:11701 - General Authority of Enforcement of Regulations in Rail)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:11705":"49:11705 (49:11705 - Limitation on Actions by and Against Rail Carriers)","49:11706":"49:11706 (49:11706 - Carmack Amendment (Liability of Carriers Under Receipts & Bills of Lading))","49:11707":"49:11707 (49:11707 - Instructions)","49:1305":"49:1305 (49:1305 FAA Regulations)","49:13101":"49:13101 (49:13101 ICC Termination Act)","49:13702":"49:13702 (49:13702 - Tariff Requirement for Certain Transportation)","49:13706":"49:13706 (49:13706 Motor Carriers, etc-Liability for Payment of Rates)","49:14501":"49:14501 (49:14501 - Preemption (Federal Authority of Intrastate Transportation))","49:14705":"49:14705 (49:14705 - Carriers)","49:14706":"49:14706 (49:14706 Carmack Amendment to the Interstate Commerce Act)","49:20301":"49:20301 (49:20301-20306 - Federal Safety Appliance Act)","49:21302":"49:21302 (49:21302 - Carriers Violations of Interstate Comm. Act (Ch. 201 Accident & Incident Viol. & ch. 209))","49:30101":"49:30101 (49:30101 - National Traffic & Motor Vehicle Safety Act)","49:30112":"49:30112 (49:30112 - Motor Vehicle Safety (Prohibition on Non-Complying Motor Vehicles & Equip))","49:30502":"49:30502 (49:30502 - Nat'l. Motor Vehicle Title Information Syst.)","49:31105":"49:31105 (49:31105 Surface Transportation Assistance Act)","49:31114":"49:31114 (49:31114 - Access to Interstate System/Commercial Motor Vehicle)","49:31502":"49:31502 (49:31502 - Motor Carrier Safety: Requirements for Qualifications)","49:32101":"49:32101 (49:32101 - Motor Vehicle Information & Costs Savings Act)","49:32701":"49:32701 (49:32701 - Odometer Requirements Act)","49:40101":"49:40101 (49:40101 - Federal Aviation Act)","49:40102":"49:40102 (49:40102 - Airline Deregulation Act (Definitions of Air & Commerce Safety))","49:40105":"49:40105 (49:40105 - Warsaw Convention)","49:41705":"49:41705 (49:41705 - Air Carrier Access Act (Discrimination Against Handicapped Individuals))","49:41713":"49:41713 (49:41713 - Airline Deregulation Avt (Premp. of Authority Over Prices, Routes & Service))","49:44709":"49:44709 (49:44709 - Noise Control Act of 1972)","49:44715":"49:44715 (49:44715 - Noise Control Act of 1972)","49:46507":"49:46507 (49:46507 - False Information & Threats)","49:47101":"49:47101 (49:47101 - Airport & Airway Improvement Act)","49:47501":"49:47501 (49:47501 - Aviation Safety & Noise Abatement Act of 1979)","49:49101":"49:49101 (49:49101 - Wrongful Termination in Contravention of Published Regulations)","49:49104":"49:49104 (49:49104 - Breach of Lease by Metro Wash. Airport Authority)","49:60101":"49:60101 (49:60101 Pipeline Safety Act of 1994)","49:60102":"49:60102 (49:60102 - Hazardous Liquid Pipeline Safety Act of 1979 (HLPSA))","49:80102":"49:80102 (49:80102 - Bills of Lading -- Application)","49:80302":"49:80302 (49:80302 - Contraband - Prohibitions)","49:80303":"49:80303 (49:80303 - Seizure & Forfeiture of Vessel or Aircraft Conveying Contraband)","50(a):0001":"50(a):0001 (50(a):0001 - Trading With the Enemy Act (Act in Title 50 Appendix))","50(a):0533":"50(a):0533 (50(a):0533 - Servicemenbers Civil Relief Act -- Mortgages (In Title 50 Appendix))","50(a):0540":"50(a):0540 (50(a):0540 - Sailors & Soldiers Civil Relief Act (In Title 50 Appendix))","50(a):2412":"50(a):2412 (50(a):2412 - Export Administration Act - 1979 (In Title 50 Appendix))","50:0501":"50:0501 (50:0501: Soldiers and Sailors Civil Relief Act of 1940)","50:1701-06":"50:1701-06 (50:1701-1706 -- International Emergency Economic Powers Act)","51:20137a":"51:20137a (51:20137(a) - Malpractice & Negligence Against U.S. Space Program)","BR9020":"BR9020 (BR9020 Bankruptcy Rule 9020)","bj":"bj (bk Execution of Bankruptcy Judgments)","misc":"misc (Civil Miscellaneous Case)","rj":"rj (Registration of Foreign Judgments)"},"ctdce":{"0":"0 (No cause code entered)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451(j)":"08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Award)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1819COS":"12:1819COS (12:1819 Default of Promisory Note)","12:1819Fdi":"12:1819Fdi (Default by Promissary Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:191":"12:191 (12:191 Bank Foreclosure)","12:192":"12:192 (12:192 Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0078COL":"15:0078COL (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1451j":"18:1451j (8:1451j Motion to Correct Order & Judg. of Naturalization)","18:1514":"18:1514 (18:1514 Civil action to restrain harassment of a victim or witness)","18:1514A":"18:1514A (18:1514A Motion for Protective Order)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2511":"18:2511 (18:2511 Wiretapping)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Venue)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2601":"29:2601 (29:2601 Family & Medical Leave Act)","29:2612":"29:2612 (29:2612 Family & Medical Leave Act)","29:2615":"29:2615 (29:2615 Family & Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4301":"38:4301 (38:4301-4335 Uniformed Services Employment and Reemployment Rights Act (USERRA))","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:3131":"40:3131 (40:3131 et seq Miller Act)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405":"42:0405 (42:0405 Public Health and Welfare HHS)","42:0405dc":"42:0405dc (42:0405dc Review of SSA Decision SSDC - Concurrent Title II and Title XVI Claims)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405rs":"42:0405rs (42:0405rs Review of SSA Decision RSI - Application for Retirement or Survivor Benefits)","42:0405wc":"42:0405wc (42:405 Review of SSA Decision DIWC - Title II Worker or Child Claims)","42:0405ww":"42:0405ww (42:405 Review of SSA Decision DIWW - Title II Widow or Widower Claims)","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11601":"42:11601 (International Child Abduction Remedies Act)","42:12101":"42:12101 (42:12101 Americans with Disabilities Act)","42:12182":"42:12182 (42:12182 Americans with Disabilities Act)","42:1383":"42:1383 (42:1383 Review of SSA Decision SSID - SSI Disability Cases)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:3601 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:31342":"46:31342 (Maritime Lien)","47:0332":"47:0332 (Telecommunications Act)","47:0553":"47:0553 (47:0553 Unauthorized reception of signal)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","Alleyne":"Alleyne (Request for Relief Pursuant to Alleyne)","MDL1180":"MDL1180 (28:1332 diversity-airline crash MDL #1180)","MDL1210":"MDL1210 (In re: SmithKline Beecham Clinical Labs MDL#1210)","MDL1241":"MDL1241 (15:78m(a) Securities Exchange Act MDL1241)","MDL1463":"MDL1463 (In Re: Xerox Corp Securities Litigation)","MDL1505":"MDL1505 (In Re: Cardiac Devices Qui Tam Litigation)","MDL1542":"MDL1542 (In Re: EPDM Anti-trust Litigation)","MDL1568":"MDL1568 (In re Parcel Tanker Shipping Services Antitrust Litigation)","MDL1572":"MDL1572 (In Re: Aircrash near Castellon Spain Oct 10 2001)","MDL1631":"MDL1631 (MDL1631 - In Re: Publication Paper Antitrust Litigation)","MDL1642":"MDL1642 (In re: Polychloroprene Rubber (CR) Antitrust Litigation)","MDL1649":"MDL1649 (MDL1649 In re Helicopter Crash Near Wendle Creek, BC on August 8, 2002)","MDL1894":"MDL1894 (MDL1894 In Re: US Foodservice Inc.)","MDL2407":"MDL2407 (MDL 2407 In Re: Higher One OneAccount Marketing and Sales Practices)","MDL2478":"MDL2478 (MDL 2478 In Re: Convergent Telephone Consumer Protection Act)","MDL2516":"MDL2516 (MDL 2516 In Re: Aggrenox Antitrust Litigation)","RSI":"RSI (Repetitive Stress Injury Case)","Resign":"Resign (Resign)","adsup":"adsup (Administrative Subpoena)","attyappt":"attyappt (Appointment of Attorney/GJ)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","fordepo":"fordepo (Foreign Deposition)","gpcmp":"gpcmp (Grievance Complaint)","gpfed":"gpfed (Federal Conviction)","gpre":"gpre (Petition for Reinstatement)","gprec":"gprec (Reciprocal Discipline)","gpref":"gpref (Referral by Judge)","gpst":"gpst (State Court Discipline)","gpstate":"gpstate (State Conviction)","juryosc":"juryosc (Jury Order to Show Cause)","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","penreg":"penreg (Application for Pen Register)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","prem":"prem (Application to Enter Premises)","pwratty":"pwratty (Power of Attorney)","regjgm":"regjgm (Registration of Foreign Judgment)","seizwar":"seizwar (Seizure Warrant)","tap":"tap (Wiretap)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","writgar":"writgar (Application for a Writ of Garnishment)"},"dcdce":{"0":"0 (No cause code entered)","01D2439":"01D2439 (01DCC2439 WMATA (court jurisdiction) )","02:0138":"02:0138 (2:138 Library of Congress Access )","02:0358":"02:0358 (02:0358 President's Recommendations on Exec.,Jud.&Leg.Salary)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","02:0681":"02:0681 (2:681 Deferral of Budget Authority )","02:1202":"02:1202 (02:1201 Discriminatory pract. affecting US Senate employees )","02:1317a":"02:1317a (Violation of Congressional Accountability Act )","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0504":"05:0504 (05:0504 Equal Access to Justice )","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0555b":"05:0555b (05:0555b Agency Decision - Right to Counsel )","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:0706":"05:0706 (05:0706 Judicial Review of Agency Actions)","05:2302":"05:2302 (05:2302 Merit System Principles )","05:5542":"05:5542 (05:5542 Federal Employees Pay Act -- overtime rates )","05:7101":"05:7101 (05:7101 Labor-Management Relations )","05:7501":"05:7501 (05:7501 Government Employees Adverse Action--14 days or less)","05:7511":"05:7511 (05:7511 Government Employees Adverse Action--Over 14 days )","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8101":"05:8101 (05:8101 Federal Employees' Liability Act )","05:8110":"05:8110 (05:8110 Aug. Compensation for dependents of Govt. Employees )","05:8715":"05:8715 (05:8715 Unemployment Compensation - Jurisdiction of Courts )","05:App1":"05:App1 (05:App1 Government Employees Reorganization Plans )","05:App2":"05:App2 (05:App. 2,1 Federal Advisory Committee Act )","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0136":"07:0136 (7:136 Forfeiture/Penalty of Environmental Protection Agency )","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:0608":"07:0608 (07:0608 Agricultural Marketing Agreement Act )","07:2023":"07:2023 (07:2023 Judicial Review of Admin Determination by DOA )","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1101":"08:1101 (8:1101 Immigration and Nationality Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451":"08:1451 (08:1451 Revocation of Naturalization )","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","09:0202":"09:0202 (09:0202 Award under Convention on Foreign Arbitral Awards )","10:1006":"10:1006 (10:1006 Review of Agency Decision)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","10:2734":"10:2734 (10:2734 Foreign Military Claims Act )","11:0101":"11:0101 (11:101 Bankruptcy)","11:8001":"11:8001 (11:8001 Bankruptcy Appeal )","12:0022":"12:0022 (12:22 Securities Fraud)","12:0632":"12:0632 (12:0632 Foreign Banking )","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1441":"12:1441 (12:1441 Financing Corporation )","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1818e":"12:1818e (12:1818e Suspension or Removal of Bank Officer )","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","12:3907":"12:3907 (12:3907 Summary Enforcement of Capital Directive )","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0053b":"15:0053b (15:53b Federal Trade Commission Act )","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0078ss":"15:0078ss (15:78j(b) Stockholder Suit )","15:0078ud":"15:0078ud (15:78u(d) Securities Exchange Act )","15:0631":"15:0631 (15:631 Small Business Act)","15:0661":"15:0661 (15:0661 Small Business Investment Act of 1958 )","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0751":"15:0751 (15:0751 Economic Stabilization Act of 1970 )","15:078ss":"15:078ss (15:078JCB; Stockholder Suit )","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1263":"15:1263 (15:1263 Prohibited Hazardous Substance - Interstate Commerce)","15:1314":"15:1314 (15:1314 Antitrust--Petition for enforcement )","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1666":"15:1666 (15:1666 Consumer Credit Protection-billing errors )","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2620":"15:2620 (15:2620 Toxic Substances Control Act )","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:1540":"16:1540 (16:1540 Endangered Species Act )","16:1801":"16:1801 (16:1801 Fishery Conservation and Management Act (FCMA) )","16:1831r-1":"16:1831r-1 (16:1831r-1 Notice of Branch Closure)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1905":"18:1905 (18:1905 Disclosure of Confidential Information )","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2331":"18:2331 (18:2331 Anti-terrorism Act )","18:3511":"18:3511 (18:3511 Petition for Judicial Review)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","18:981":"18:981 (18:981 Civil Forfeiture)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0348":"21:0348 (21:0348 Federal Food, Drug and Cosmetic Act )","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","22:2702":"22:2702 (22:2702 Medical Malpractice by Govt. Medical Personnel )","22:286":"22:286 (22:286 Action against World Bank )","22:4140":"22:4140 (22:4140 Foreign Service Grievance Act )","22:4181":"22:4181 (22:4181 Foreign Service Grievance Act )","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","25:2701":"25:2701 (25:2701 Indian Gaming Regulatory Act )","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422":"26:7422 (26:7422 Civil Actions by Taxpayers for Refund of Taxes )","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7428":"26:7428 (26:7428 IRS: Declaratory Judgment )","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7431":"26:7431 (26:7431 IRS: Unauthorized Inspection or Disclosure of Returns and Return Information)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0463":"28:0463 (Expenses of Judicial Litigation )","28:0591":"28:0591 (28:0591 Independent Counsel )","28:0592":"28:0592 (28:0592 Independent Counsel - Application for Appointment )","28:0593":"28:0593 (28:0593 Independent Counsel - Court Responsibilities )","28:0594":"28:0594 (28:0594 Independent Counsel - Responsibilities )","28:0595":"28:0595 (28:0595 Independent Counsel - Congressional Oversight )","28:0596":"28:0596 (28:0596 Independent Counsel - Removal )","28:0597":"28:0597 (28:0597 Independent Counsel - Dept. of Justice Relationship )","28:0598":"28:0598 (28:0598 Independent Counsel - Chapter Termination )","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332dj":"28:1332dj (28:1332 Diversity-Declaratory Judgment )","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cr":"28:1441cr (Petition for Removal- Civil Rights )","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1602":"28:1602 (28:1602 Foreign Sovereign Immunities Act)","28:1605A":"28:1605A (28:1605A Foreign Sovereign Immunities Act)","28:1631":"28:1631 (28:1631 Case Transferred to Cure Want of Jurisdiction )","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1738":"28:1738 (28:1738 State and Territorial Statutes-Full Faith and Credit)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201an":"28:2201an (28:2201 Declaratory Judgment (aliens and nationality))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201fa":"28:2201fa (28:2201 Declaratory Judgment- Firearms )","28:2201fs":"28:2201fs (28:2201fs Declaratory Judgment (Food Security Act) )","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2255mo":"28:2255mo (Motion to Vacate, Set Aside or Correct Sentence )","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2347":"28:2347 (28:2347 Withdrawal of Bankruptcy Appeal )","28:2401":"28:2401 (28:2401 Federal Tort Claims Act- time for commencing action )","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act )","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0187":"29:0187 (29:0187 Labor Management Relations Act-unfair labor practice)","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0216":"29:0216 (29:216 Fair Labor Standards Act )","29:0260":"29:0260 (Family and Medical Leave Act of 1993)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0501(b)":"29:0501(b) (29:0501(b) Violation of Fiduciary Responsibility )","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2001":"29:2001 (29:2001 Employee Polygraph Protection Act )","29:2601":"29:2601 (Family Medical Leave Act of 1993 )","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:1341":"31:1341 (31:1341 Government employee--limitations on expending monies)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1361":"33:1361 (33:1361 Clean Water Act-Administrator Authority )","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0032":"35:0032 (35:0032 Suspension from Practice before Patent & Trade. Off.)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","35:146":"35:146 (35:146 Patent Interference - Dissatisfaction )","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4301":"38:4301 (38:4301 Uniformed Services Employment & Re-Employment Rights)","39:0403":"39:0403 (39:0403 Discriminatory use of the Postal Service )","39:0409":"39:0409 (39:0409 Action by or against the Postal Service )","39:1207":"39:1207 (39:1207 Review Agency Action--Labor )","39:1208":"39:1208 (39:1208 1970 Postal Act-enforced supervision by parent union)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0254o":"42:0254o (42:254o Breach of Scholarship Contract )","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405rd":"42:0405rd (42:0405rd Review of HHS Decision (RSI) )","42:0405rsi":"42:0405rsi (42:0405rsi Review of HHS Decision (RSI) )","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:12101":"42:12101 (Viol. of the Americans with Disabilities Act of 1990)","42:12188":"42:12188 (42:12188 Americans With Disabilities Act )","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1395dd":"42:1395dd (42:1395 Denial of Services (EMTALA) )","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:13981":"42:13981 (42:13981 Violence Against Women Act )","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1973":"42:1973 (42:1973 Voting Rights Act )","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000":"42:2000 (42:2000 Religion )","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:2996":"42:2996 (42:2996 Legal Services Corporation Act )","42:300":"42:300 (42:300 Safe Drinking Water Act )","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:4901":"42:4901 (42:4901 Noise Control Act of 1972 )","42:5411":"42:5411 (42:5411 Housing Construction and Safety Standards Act )","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7192":"42:7192 (42:7192 Review by U.S.District Court of D.O.E. Agency Action)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7523":"42:7523 (42:7523 Clean Air Act-Mobile Source Emissions)","42:7545":"42:7545 (42:7545 Air Pollution Prevention - Regulation of Fuels )","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:7671":"42:7671 (42:7671 Clean Air Act (Stratospheric Ozone Protection) )","42:9601":"42:9601 (42:9601 Environmental Response,Compensation & Liability Act )","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:1701":"43:1701 (43:1701 Violation of Federal Land and Management Act)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","44:2107":"44:2107 (44:2107 Presidential Recordings and Materials Act )","45:0002":"45:0002 (45:2 Federal Employers' Liability Act )","45:0023":"45:0023 (45:23 Federal Employees' Liability Act )","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:0719":"45:0719 (45:0719 Regional Rail Reorganization Act of 1973 )","45:1105":"45:1105 (45:1105 Northeast Rail Service Act )","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:0951":"46:0951 (46:0951 Foreclosure of Preferred Foreign Ship Mortgages )","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:0206":"47:0206 (47:0206 Carrier's Liability for Damages )","47:0605":"47:0605 (47:0605 Theft of Satellite Communications Services )","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0020":"49:0020 (49:0020 Liability for Motor Carrier )","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:14706":"49:14706 (49:14706 Liability of Carriers - Receipts & Bills of Landing)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1552":"49:1552 (49:1552 Airline Deregulation Act;Labor Protection Provisions)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","50:0001":"50:0001 (50:0001 Trading With the Enemy Act )","50:2412":"50:2412 (50:2412 Export Administration Act--1979 )","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:99":"99:99 (TEMPORARILY OUT OF ORDER )","MS:1001":"MS:1001 (Registration of Foreign Judgment )","MS:1002":"MS:1002 (Motion for Extension of Time )","MS:1003":"MS:1003 (Motion to Quash Subpoenas )","MS:1004":"MS:1004 (Application: Order Show Cause for Non-Enforcement Subpoena )","MS:1005":"MS:1005 (Notice of Appeal: Orders of Bankruptcy Court )","MS:1006":"MS:1006 (Motion to Compel )","MS:1007":"MS:1007 (Notice of Filing Arbitration Award )","MS:1008":"MS:1008 (Motion for Reconsideration of Court Ruling )","MS:1009":"MS:1009 (Petition for Writ of Mandamus )","MS:1010":"MS:1010 (Writ of Habeas Corpus Ad Testificandum & Ad Prosequendum )","MS:1011":"MS:1011 (Motion for Production of Documents & Continued Deposition )","MS:1012":"MS:1012 (Application for Letters Rogatory )","MS:1013":"MS:1013 (Complaint )","MS:1014":"MS:1014 (Application for Order Immunizing Testimony )","MS:1015":"MS:1015 (Appointment of Receiver )","MS:1016":"MS:1016 (Request for Judicial Assistance )","MS:1017":"MS:1017 (Motion to Enforce Subpoena )","MS:1018":"MS:1018 (Motion for Protective Order )","MS:1019":"MS:1019 (Petition for Ancillary Hearing )","MS:1020":"MS:1020 (MS:1020 Perpetuate Testimony )","MS:1021":"MS:1021 (Withdrawal of Reference (from U. S. Bankruptcy Court) )","MS:1022":"MS:1022 (Motion for Return of Property )","MS:1023":"MS:1023 (MS:1023 Application for Extradition )","MS:1024":"MS:1024 (Application to Effect Levy )","MS:1025":"MS:1025 (Motion to Stay Arbitration )","MS:1026":"MS:1026 (Petition for Expungement )","MS:1027":"MS:1027 (Motion to Vacate Forfeiture of Collateral )","MS:1028":"MS:1028 (Leave of Court before Filing and Action )","MS:1029":"MS:1029 (U.M.W.A. - Employee Benefit Plans Litigation )","MS:1030":"MS:1030 (SEALED )","MS:1031":"MS:1031 (Contempt Proceeding )","MS:1032":"MS:1032 (Motion to Intervene )","MS:1033":"MS:1033 (Petition for Disclosure )","MS:1034":"MS:1034 (Certification to the USDC/DC pursuant to 11 Section 110(i) )","MS:1035":"MS:1035 (Application for Pen Register)","MS:Administrative Subpoena":"MS:Administrative Subpoena (Administrative Subpoena)","MS:Consent Order":"MS:Consent Order (MS:Consent Order)","MS:MiscOrder":"MS:MiscOrder (MS:Motion for Order)","MS:MotionFor OrderDelNtc":"MS:MotionFor OrderDelNtc (Motion for Order Authorizing Delayed Notice)","MS:NoticeRemoval":"MS:NoticeRemoval (MS:Notice of Removal)","MS:Tracking Device":"MS:Tracking Device (Application for Tracking Device)","MS:Wire Comm":"MS:Wire Comm (Application for Interception of Wire Communication)","misc":"misc (Civil Miscellaneous Case)"},"dedce":{"0":"0 (no cause specified)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2023":"07:2023 (07:2023 Review of Agency Action - Agriculture)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451(j)":"08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","09:0207":"09:0207 (09:207 Confirm Arbitral Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","11:0547":"11:0547 (11:0547 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:191":"12:191 (12:191 Bank Foreclosure)","12:192":"12:192 (12:192 Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0080":"15:0080 (15:0080 Investment Companies)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1261":"15:1261 (15:1261 Federal Hazardous Substance Act)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1679":"15:1679 (15:1679 Credit Repair Organizations Act)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0492":"18:0492 (18:492 Forfeiture - Counterfeit Obligations)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2511":"18:2511 (18:2511 Wiretapping)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:3184":"18:3184 (18:3184 Fugitives From Foreign Countries)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","18:923":"18:923 (18:923 Firearms Licensing Review)","19:1305":"19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1415":"20:1415 (20:1415 Education: Procedural Safeguards)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:0982":"26:0982 (26:0982 IRS:Petition to Quash Formal Document Request)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Fed. Question: Civil Rights Violation)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel, Assault, Slander)","28:1332lm":"28:1332lm (Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 VA Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Notice of Removal-Account Receivable)","28:1441al":"28:1441al (28:1441 Notice of Removal-Airline Crash)","28:1441as":"28:1441as (28:1441 Notice of Removal-Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Notice of Removal-Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Notice of Removal-Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Notice of Removal-Contract Default)","28:1441dj":"28:1441dj (28:1441 Notice of Removal-Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441 Notice of Removal-Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Notice of Removal-Fraud)","28:1441ij":"28:1441ij (28:1441 Notice of Removal-Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Notice of Removal-Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Notice of Removal-Libel, Assault, Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Notice of Removal-Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Notice of Removal-Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Notice of Removal-Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Notice of Removal-Property Damage)","28:1441pi":"28:1441pi (28:1441 Notice of Removal-Personal Injury)","28:1441pl":"28:1441pl (28:1441 Notice of Removal-Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Notice of Removal-Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Notice of Removal-Torts to Land)","28:1441tm":"28:1441tm (28:1441 Notice of Removal-Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Notice of Removal-Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Notice of Removal-Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Notice of Removal-Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1441 Notice of Removal-Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Notice of Removal-Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Notice of Removal-Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (Actions affecting property on which United States had lien)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (Federal Debt Collection)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2104":"29:2104 (29:2104 Worker Adjustment & Retraining Notification Act)","29:2601":"29:2601 (29:2601 Family and Medical Leave Act of 1993)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:01":"35:01 (35:1 Patent Infringement)","35:0146":"35:0146 (35:0146 Review of Board of Patent Appeals Decision)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","35:0297":"35:0297 (35:0297 - American Inventor's Protection Act)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11601":"42:11601 (42:11601 International Child Abduction Remedies Act)","42:12101":"42:12101 (42:12101 Americans with Disabilities Act)","42:1320":"42:1320 (42:1320 Health Insurance Portability And Accountability Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accommodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000re":"42:2000re (42:2000 Job Discrimination (Religion))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:0151":"47:0151 (Internet Tax Freedom Act)","47:332":"47:332 (Mobile Services)","47:605a":"47:605a (Cable System Piracy)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","77-7777mc":"77-7777mc (Miscellaneous Case Cause not Known)","88:8888mc":"88:8888mc (Miscellaneous Case Cause not Known)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 (Miscellaneous Case - Cause Not Known))","adsup":"adsup (Administrative Subpoena)","bail":"bail (Bail - Other District)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","fordepo":"fordepo (Foreign Deposition)","misc":"misc (Civil Miscellaneous Case)","miscapp":"miscapp (Miscellaneous Application)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","writgar":"writgar (Application for a Writ of Garnishment)"},"flmdce":{"0":"0 (no cause specified)","01:01test":"01:01test (01:01 test case)","02:0431":"02:0431 (02:0431 Fed. Election Comm: Failure Enforcement Compliance)","02:0437":"02:0437 (02:0437 Federal Election Commission)","05:0075":"05:0075 (05:0075(2) Contract-Reduction in Grade)","05:0551":"05:0551 (05:0551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:0552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:0552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:0702 Administrative Procedure Act)","05:0704":"05:0704 (05:0704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","07:0006":"07:0006 (07:0006(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (07:0025 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:0181 Packers & Stockyard Act)","07:0499":"07:0499 (07:0499 Agricultural Commodities Act)","07:0601":"07:0601 (07:0601 USDA Condemnation)","07:2023":"07:2023 (07:2023 Review of Findings of Dept. of Agriculture)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:0287":"08:0287 (08:0287 Petition to Enforce INS Subpoena)","08:1105":"08:1105 (08:1105(a) Aliens:Habeas Corpus to Release INS Detainee)","08:1182":"08:1182 (08:1182 Defend. Denial of Pla. Appl. Alien Employment Cert)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1446":"08:1446 (08:1446 Petition for Naturalization Hearing)","08:1447":"08:1447 (08:1447 Hearings on denials of applications for naturalization)","08:1451j":"08:1451j (08:1451j Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:0001 U.S. Arbitration Act)","09:0009":"09:0009 (09:0009 Motion to confirm arbitration award)","09:0010":"09:0010 (09:10 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:0101 Bankruptcy)","11:0525":"11:0525 (11:0525 Protection Against Discriminatory Treatment)","12:0022":"12:0022 (12:0022 Securities Fraud)","12:0635":"12:0635 (12:0635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection Under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:191":"12:191 (12:191 Bank Foreclosure)","12:192":"12:192 (12:192 Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Tying Arrangement Act)","12:2607":"12:2607 (Real Estate Settlement Procedure (RESPA) Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:0001 Antitrust Litigation)","15:0002at":"15:0002at (15:0002 Antitrust Litigation)","15:0002fl":"15:0002fl (15:0002(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:0005(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:0015 Antitrust Litigation)","15:0025":"15:0025 (15:0025 Clayton Act)","15:0044":"15:0044 (15:0044 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:53 Federal Trade Commission Act)","15:0077":"15:0077 (15:0077 Securities Fraud)","15:0078":"15:0078 (15:0078m(a) Securities Exchange Act)","15:0631":"15:0631 (15:0631 Small Business Act)","15:0717":"15:0717 (15:0717 Natural Gas Act)","15:0754":"15:0754 (15:0754 Emergency Petroleum Allocation-Admin. & Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1691":"15:1691 (15:1691 Equal Credit Opportunity Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693":"15:1693 (15:1693 Electronic Fund Transfer Act (EFTA))","15:1701":"15:1701 (15:1701 Interstate Land Sales Full Disclosure Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53b":"15:53b (15:53b - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","17:512h":"17:512h (17:512h Limitations on liability relating to material online)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0983":"18:0983 (18:983 Civil Forfeiture Proceedings)","18:1030":"18:1030 (18:1030 Violation of Computer Fraud & Abuse Act)","18:1345":"18:1345 (18:1345 Injunctions Against Fraud)","18:1514":"18:1514 (18:1514 Civil Action to Restrain Harassment of a Victim or Witness)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2333":"18:2333 (18:2333 Civil Remedies - International Terrorism)","18:2511":"18:2511 (18:2511 Wiretapping)","18:2721":"18:2721 (18:2721 Driver's Privacy Protection Act)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1095":"20:1095 (20:1095 Wage Garnishment Requirement)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0301":"21:0301 (21:0301 Federal Food, Drug & Cosmetic Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","21:801":"21:801 (21:801 Comprehensive Drug Abuse Prevention Control Act)","22:6081":"22:6081 (22:6081 Protection of Property Rights of U.S. Nationals)","22:6081USC":"22:6081USC (22:6081 Protection of Property Rights of U.S. Nationals)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7405":"26:7405 (26:7405 IRS: Recovery of IRS Tax)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7431":"26:7431 (26:7431 Civil Damages for Unauthorized Inspection or Disclosure of Returns and Return Information)","26:7434":"26:7434 (Fraudulent Filing of Information Returns)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0157e":"28:0157e (28:0157e Bankruptcy Case Jury Trial)","28:0158":"28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Antitrust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Fed. Question: Civil Rights Violation)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Fed. Question - Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332fd Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel, Assault, Slander)","28:1332lm":"28:1332lm (28:1332 Diversity-Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 VA Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Not to be used for cause)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Notice of Removal-Account Receivable)","28:1441al":"28:1441al (28:1441 Notice of Removal-Airline Crash)","28:1441as":"28:1441as (28:1441 Notice of Removal-Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Notice of Removal-Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Notice of Removal-Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Notice of Removal- Civil Rights Act)","28:1441dc":"28:1441dc (Notice of Removal - Discrimination)","28:1441df":"28:1441df (28:1441 Notice of Removal-Contract Default)","28:1441dj":"28:1441dj (28:1441 Notice of Removal-Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441 Notice of Removal-Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Notice of Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Notice of Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Notice of Removal-Fraud)","28:1441ij":"28:1441ij (28:1441 Notice of Removal-Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Notice of Removal-Insurance Contract)","28:1441int":"28:1441int (28:1441 Notice of Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Notice of Removal-Libel, Assault, Slander)","28:1441lm":"28:1441lm (28:1441 Notice of Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Notice of Removal-Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Notice of Removal-Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Notice of Removal-Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Notice of Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Notice of Removal-Property Damage)","28:1441pi":"28:1441pi (28:1441 Notice of Removal-Personal Injury)","28:1441pl":"28:1441pl (28:1441 Notice of Removal-Product Liability)","28:1441pr":"28:1441pr (28:1441 Notice of Removal)","28:1441qt":"28:1441qt (28:1441 Notice of Removal-Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Notice of Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Notice of Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Notice of Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Notice of Removal-Torts to Land)","28:1441tm":"28:1441tm (28:1441 Notice of Removal-Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Notice of Removal-Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Notice of Removal-Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Notice of Removal-Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Notice of Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1443cr":"28:1443cr (28:1443 Notice of Removal-Criminal)","28:1444":"28:1444 (28:1441 Notice of Removal-Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Notice of Removal-Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Notice of Removal-Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)","28:1453":"28:1453 (Notice of Removal - class actions)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1711":"28:1711 (28:1711 Class Action Fairness Act of 2005)","28:1738":"28:1738 (28:1738A Full Faith and Credit Given to Child Custody Determinations)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1875":"28:1875 (28:1875 Protection of Jurors Employment)","28:1983":"28:1983 (28:1983 Civil Rights (DO NOT USE))","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))","28:2241st":"28:2241st (28:2241 Petition for Writ of Habeas Corpus (State))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Actions affecting property which US had lien)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:0151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:0184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1161":"29:1161 (29:1161 COBRA - Continuation Coverage)","29:1162":"29:1162 (29:1162 COBRA - Continuation Coverage)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2001":"29:2001 (29:2001 Employee Polygraph Protection Act)","29:2102":"29:2102 (29:2102 Notice Required Before Plant Closings and Mass Layoffs)","29:2601":"29:2601 (29:2601 Family Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","30:775":"30:775 (30:775 Recovery of Servicemen's Group Life Insurance)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:0901":"33:0901 (33:0901 Longshore and Harbor Workers Compensation Act)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (38:2021 Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4301":"38:4301 (38:4301 Uniformed Services Employment and Reemployment Rights Act of 1994 (USERRA))","38:7462":"38:7462 (38:7462 Major adverse actions involving professional conduct or competence)","38:775":"38:775 (38:775 Recovery of Servicemens Group Life Insurance)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11601":"42:11601 (42:11601 International Child Abduction Remedies Act)","42:12131":"42:12131 (Americans with Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:13981":"42:13981 (42:13981 Violence Against Women Act)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1973":"42:1973 (42:1973 Voting Rights Act)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accommodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2615 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:3601 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (National Environmental Policy Act NEPA)","42:5121":"42:5121 (42:5121 Stafford Disaster Relief and Emergency Assistance Act)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7384":"42:7384 (42:7384 ENERGY EMPLOYEES OCCUPATIONAL ILLNESS COMPENSATION PROGRAM)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employers Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:0688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:31301":"46:31301 (46:31301 Commercial Instruments and Maritime Liens)","46:688USC":"46:688USC (46:688 Jones Act)","47:0201bt":"47:0201bt (47:0201 Breach of Tariff)","47:0227":"47:0227 (Restrictions on Use of Telephone Equipment)","47:0605":"47:0605 (47:0605 Federal Communications Act)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)","49:14706":"49:14706 (49:14706 Liability of Carriers Under Receipts and Bills of Lading)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","49:32701":"49:32701 (49:32701 Findings and Purposes)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","adsup":"adsup (Administrative Subpoena)","ausaappt":"ausaappt (Registration of AUSA appointment)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","enlvy":"enlvy (Application for entry on premises to effect levy)","fordepo":"fordepo (Foreign Deposition)","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","ohabpet":"ohabpet (Order: 2nd or Successive Habeas Petition)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","regstjgm":"regstjgm (Registration of State Court Judgment)","stano":"stano (Standing Order)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","writgar":"writgar (Application for a Writ of Garnishment)"},"flndce":{"0":"0 (No cause code entered)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451(j)":"08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:191":"12:191 (12:191 Bank Foreclosure)","12:192":"12:192 (12:192 Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2511":"18:2511 (18:2511 Wiretapping)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1983":"28:1983 ((DO NOT USE) 28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2601":"29:2601 (29:2601 Family and Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4301":"38:4301 (38:4301 Uniformed Services Employment and Reemployment Rights Act of 1994 (USERRA))","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0183":"46:0183 (46:183 Limitation of Liability)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:688USC":"46:688USC (46:688 Jones Act)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","adsup":"adsup (Administrative Subpoena)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","enlvy":"enlvy (Application for entry on premises to effect levy)","fordepo":"fordepo (Foreign Deposition)","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","regigm":"regigm (Registration of Foreign Judgement)","regjgm":"regjgm (Registration of Foreign Judgment)","stano":"stano (Standing Order)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","writgar":"writgar (Application for a Writ of Garnishment)"},"flsdce":{"0":"0 (no cause specified)","02:0431":"02:0431 (02:0431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:0437 Federal Election Commission)","05:0075":"05:0075 (05:0075(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:0551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:0552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:0552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:0702 Administrative Procedure Act)","05:0704":"05:0704 (05:0704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0009":"07:0009 (07:0009 Commodity Futures Trading Act)","07:0025":"07:0025 (07:0025 Fraud - Commodities Leverage Contracts)","07:006(b)":"07:006(b) (07:006 Federal Commodity Exchange Regulation)","07:0181":"07:0181 (07:0181 Packers & Stockyard Act)","07:0499":"07:0499 (07:0499 Agricultural Commodities Act)","07:0601":"07:0601 (07:0601 USDA Condemnation)","07:2023a":"07:2023a (07:2023a Food Stamp Program)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (08:1105(a)Immigration and Nationality (Deportation Review))","08:1182":"08:1182 (08:1182 Defend. Denial of Pla. Appl. for Alien Employment Ce)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1446":"08:1446 (08:1446 Petition for Naturalization Hearing)","08:1451(j)":"08:1451(j) (08:1451 Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:0001 U.S. Arbitration Act)","09:0009":"09:0009 (09:0009 Motion to confirm arbitration award)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:0101 Bankruptcy)","11:0523":"11:0523 (11:0523 Discharge of Tax Liability)","11:0548":"11:0548 (11:0548 Bankruptcy- Fraudulent Transfers)","12:0022":"12:0022 (12:0022 Securities Fraud)","12:0191":"12:0191 (12:0191 Bank Foreclosure)","12:0192":"12:0192 (12:0192 Liquidation of National Bank)","12:0635":"12:0635 (12:0635 Breach of Insurance Contract)","12:1441":"12:1441 (12:1441 Federal Mortgage Foreclosure)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1821(d)":"12:1821(d) (12:1821 Claim for Indemnification)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:0001 Antitrust Litigation)","15:0002at":"15:0002at (15:0002 Antitrust Litigation)","15:0002fl":"15:0002fl (15:0002 Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0005(m)":"15:0005(m) (15:0005 Fair Labor Standards Act)","15:0015":"15:0015 (15:0015 Antitrust Litigation)","15:0025":"15:0025 (15:0025 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:0077 Securities Fraud)","15:0078":"15:0078 (15:0078 Securities Exchange Act)","15:0631":"15:0631 (15:0631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:0754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1701":"15:1701 (15:1701 Interstate Land Sales Full Disclosure Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0410":"16:0410 (16:0410 Land Condemnation)","16:0668":"16:0668 (16:0668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:0703 Migratory Bird Act)","16:1437":"16:1437 (16:1437 Marine Sanctuaries Act (MPRSA))","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:1540":"16:1540 (16:1540 ESA - Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:0101 Copyright Infringement)","17:0501":"17:0501 (17:0501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","17:0512":"17:0512 (17:0512 Limitations on liability relating to material online)","18:0241":"18:0241 (18:0241 Conspiracy Against Citizen Rights)","18:0981":"18:0981 (18:0981 Property forfeiture from criminal acts)","18:0983":"18:0983 (18:0983 Civil Asset Forfeiture Reform Act of 2000 (CAFRA))","18:1030":"18:1030 (Computer Fraud and Abuse Act)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1957":"18:1957 (18:1957 Forfeiture - currency from criminal acts)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2511":"18:2511 (18:2511 Wiretapping)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:3181":"18:3181 (18:3181 Extradition to Foreign Country)","18:3582":"18:3582 (18:3582 Motion to Reduce Sentence)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1099":"20:1099 (20:1099 Higher Education Act - Accreditation)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:0841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:0881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:0134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:0640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:0185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157 BKC 9033 Proposed findings/judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)","28:0158a":"28:0158a (28:0158 Motion for Leave to File Notice of Appeal)","28:0185":"28:0185 (28:0185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:0451 Employment Discrimination)","28:0754":"28:0754 (28:0754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:0794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Federal Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Fed. Question: Civil Rights Violation)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331 Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332":"28:1332 (28:1332 Diversity)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel, Assault, Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1333dc":"28:1333dc (28:1333 Admiralty - Damaged/Lost Cargo)","28:1333fc":"28:1333fc (28:1333 Admiralty - Freight/Tariff Charges)","28:1333fm":"28:1333fm (28:1333 Admiralty - Foreclose Ship's Mortgage)","28:1333sc":"28:1333sc (28:1333 Admiralty - Seaman Complaint)","28:1333sr":"28:1333sr (28:1333 Admiralty - Services Rendered)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 VA Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1348":"28:1348 (28:1348 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1361us":"28:1361us (28:1361 Action to compel U.S. officer to perform duty)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Multidistrict Litigation)","28:1441ac":"28:1441ac (28:1441 Notice of Removal-Account Receivable)","28:1441al":"28:1441al (28:1441 Notice of Removal-Airline Crash)","28:1441as":"28:1441as (28:1441 Notice of Removal-Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Notice of Removal-Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Notice of Removal-Breach of Contract)","28:1441cs":"28:1441cs (28:1441 Notice of Removal-Constitutionality State Statutes)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Notice of Removal-Contract Default)","28:1441dj":"28:1441dj (28:1441 Notice of Removal-Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441 Notice of Removal-Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Notice of Removal-Fraud)","28:1441ij":"28:1441ij (28:1441 Notice of Removal-Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Notice of Removal-Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441la":"28:1441la (28:1441 Notice of Removal - Labor)","28:1441lb":"28:1441lb (28:1441 Notice of Removal-Libel, Assault, Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Notice of Removal-Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Notice of Removal-Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Notice of Removal-Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Notice of Removal-Property Damage)","28:1441pi":"28:1441pi (28:1441 Notice of Removal-Personal Injury)","28:1441pl":"28:1441pl (28:1441 Notice of Removal-Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Notice of Removal-Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Notice of Removal-Torts to Land)","28:1441tm":"28:1441tm (28:1441 Notice of Removal-Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Notice of Removal-Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Notice of Removal-Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Notice of Removal-Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443 Rent, Lease & Ejectment)","28:1443cv":"28:1443cv (28:1443cv Notice of Removal - Civil Rights Cases)","28:1444":"28:1444 (28:1441 Notice of Removal-Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Notice of Removal-Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Notice of Removal-Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)","28:1602":"28:1602 (28:1602 Foreign Sovereign Immunities Act)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1875":"28:1875 (28:1875 Protection of Jurors' Employment)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))","28:2242":"28:2242 (28:2242 Application for writ of Habeas Corpus)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409 Quiet Title Action)","28:2410":"28:2410 (28:2410 Actions affecting property on which USA had lien)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:0151 Labor: Review of Agency Action)","29:0158":"29:0158 (29:0158 Interstate Commerce Commission)","29:0160":"29:0160 (29:0160 National Labor Relations Act)","29:0184":"29:0184 (29:0184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:0185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:01851 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:0201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:0201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:0206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:0621 Job Discrimination (Age))","29:0623":"29:0623 (29:0623 Job Discrimination (Age))","29:0626":"29:0626 (29:0626 Job Discrimination (Age))","29:0633":"29:0633 (29:0633 Job Discrimination (Age))","29:0651":"29:0651 (29:0651 Occupational Safety/Health)","29:0754":"29:0754 (29:0754 Discrimination)","29:0791":"29:0791 (29:0791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2001":"29:2001 (29:2001 Employee Polygraph Protection Act)","29:2611":"29:2611 (29:2611 Family Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:0181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recover Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","31:5313":"31:5313 (31:5313 Forfeiture - currency reporting violation)","31:5316":"31:5316 (31:5316 Forfeiture - currency reporting violation)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:0145 Patent Infringement)","35:0183":"35:0183 (35:0183 Patent Infringement)","35:0271":"35:0271 (35:0271 Patent Infringement)","38:0775":"38:0775 (38:0775 Recovery of Servicemen's Group Life Insurance)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:1803":"38:1803 (38:1803 Recoupment of VA mortgage)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (38:2021 Deactivated Per Administrative Office)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4311":"38:4311 (38:4311 Uniformed Service Employment or Reemployment Rights Act - Discrimination)","38:4323":"38:4323 (38:4323 Uniformed Service Employment/Reemployment Rights Act - Enforcement re state/private employer)","38:4324":"38:4324 (38:4324 Uniformed Service Employment/Reemployment Rights Act - Enforcement re Federal Exec. Agencies)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:3007":"39:3007 (39:3007 Injunc. direct. retention/examination incoming mail)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:0258 Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:0270 Miller Act)","40:0875":"40:0875 (40:0875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:0251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:0205 Denial Social Security Benefits)","42:0206":"42:0206 (42:0206 Social Security Benefits)","42:0247":"42:0247 (42:0247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:0402 Social Security Benefits)","42:0405":"42:0405 (42:0405 Fair Housing Act)","42:0405id":"42:0405id (42:0405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:0405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:0405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:0416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11601":"42:11601 (42:11601 International Child Abduction Remedies Act)","42:12182":"42:12182 (42:12182 Americans with Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (Public Health and Welfare)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 State Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accommodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2615 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:3601 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:0051 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:0151 Railway Labor Act)","45:0184":"45:0184 (45:0184 Action to Set Aside Award of a System Board of Adjus)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0185":"46:0185 (46:0185 Petition by vessel owner for limitation of liability)","46:0688":"46:0688 (46:0688 Jones Act)","46:0741":"46:0741 (46:0741 Shipping)","46:0761":"46:0761 (46:0761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:1301":"46:1301 (46:1301 Admiralty - Damaged/Lost Cargo)","47:0151":"47:0151 (47:0151 Telegraphs/Telephones - FCC: fees/charges)","47:0202":"47:0202 (47:0202 Discriminations and Preferences)","47:0605":"47:0605 (47:0605 Unauthorized publication or use of communications)","48:0883":"48:0883 (48:0883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:0081 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:0781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:11707":"49:11707 (49:11707 Liability of Common Carriers)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1502":"49:1502 (49:1502 Air Transportation (Warsaw Convention))","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","49:32701":"49:32701 (49:32701 Federal Odometer Act)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","adsup":"adsup (Administrative Subpoena)","apptrec":"apptrec (Appointment of receiver)","attydiscp":"attydiscp (Attorney Discipline)","bvcmp":"bvcmp (Bivens - Federal Prisoner Civil Rights)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","fordepo":"fordepo (Foreign Deposition)","menfsubp":"menfsubp (Motion to enforce deposition subpoena)","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel)","motjudrev":"motjudrev (Motion for Judicial Review)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","motstaybkc":"motstaybkc (Motion to Stay Bankruptcy Proceedings)","mottro":"mottro (Motion for Temporary Restraining Order)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","writgar":"writgar (Application for a Writ of Garnishment)","writman":"writman (Writ of Mandamus)"},"gamdce":{"0":"0 (No cause code entered)","02:0138":"02:0138 (02:138 Library of Congress Access)","02:0358":"02:0358 (02:358 President's Recommendations on Exec., Jud. & Leg. Salary)","02:0431":"02:0431 (02:431 Federal Election Commission: Failure to Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","02:0681":"02:0681 (02:681 Deferral of Budget Authority)","02:1202":"02:1202 (02:1202 Discriminatory practices affecting US Senate employees)","02:1301":"02:1301 (02:1301 Congressional Accountability Act)","02:1317a":"02:1317a (02:1317a Violation of Congressional Accountability Act)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits )","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451(j)":"08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization )","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement )","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan )","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1818":"12:1818 (12:1818 Federal Depository Insurance Act )","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:191":"12:191 (12:191 Bank Foreclosure )","12:192":"12:192 (12:192 Liquidation of National Bank )","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act )","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement )","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1030":"18:1030 (18:1030(g) Computer Fraud and Abuse Act )","18:1836a":"18:1836a (18:1836(a) - Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2511":"18:2511 (18:2511 Wiretapping)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property )","18:3524f":"18:3524f (18:3524 Child Custody Arrangements)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","22:9001":"22:9001 (22:9001 International Child Abduction Remedies Act)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:5872":"26:5872 (26:5872 Forfeitures)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts )","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment )","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act )","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal )","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff )","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party )","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal )","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal )","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal )","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment )","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2617":"28:2617 (28:2617 Family & Medical Leave Act of 1993 )","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3301":"28:3301 (28:3301 Federal Debt Collection Procedures Act )","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","31:5314":"31:5314 (Records and Reports on Foreign Financial Agency Transactions)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (Right to re-employment of inducted persons )","38:3116":"38:3116 (38:3116 VA Overpayment)","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance )","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:12182":"42:12182 (42:12182 Americans with Disabilities Act )","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2616 Medical Recovery Act )","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:0254":"47:0254 (Telegraphs, Telephones, and Radio Telegraphs )","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!) )","adsup":"adsup (Administrative Subpoena )","contempt":"contempt (Contempt Proceedings )","disbar":"disbar (Disbarment Proceedings )","fordepo":"fordepo (Foreign Deposition )","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel )","motquash":"motquash (Motion to Quash )","motret":"motret (Motion for Return of Property )","petenf":"petenf (Petition to Enforce IRS Summons )","petper":"petper (Petition to Perpetuate Testimony )","regjgm":"regjgm (Registration of Foreign Judgment )","rule60":"rule60 (Rule 60(b) Motion for Relief from Judgment/Order)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference )","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law )","writgar":"writgar (Application for a Writ of Garnishment )"},"gasdce":{"0":"0 (no cause specified)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451(j)":"08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:191":"12:191 (12:191 Bank Foreclosure)","12:192":"12:192 (12:192 Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0078(j)":"15:0078(j) (15:78(j) Securities Fraud under Securities Exch. Act of 1934)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0981":"18:0981 (18:0981 Civil Forfeiture)","18:1581":"18:1581 (18:1581 Peonage: Obstructing Enforcement)","18:1582":"18:1582 (18:1582 Vessels for Slave Trade)","18:1583":"18:1583 (18:1583 Enticement Into Slavery)","18:1584":"18:1584 (18:1584 Sale Into Involuntary Servitude)","18:1585":"18:1585 (18:1585 Seizure, Detention, Transportation or Sale of Slave)","18:1586":"18:1586 (18:1586 Service on Vessels in Slave Trade)","18:1587":"18:1587 (18:1587 Possession of Slaves Aboard Vessel)","18:1588":"18:1588 (18:1588 Transportation of Slaves from U.S.)","18:1589":"18:1589 (18:1589 Forced Labor)","18:1590":"18:1590 (18:1590 Trafficking With Respect to Peonage, Slavery, Involuntary Servitude, or Forced Labor)","18:1591":"18:1591 (18:1591 Sex Trafficking of Children or by Force, Fraud or Coercion)","18:1592":"18:1592 (18:1592 Unlawful Conduct w/ Respect to Documents in Furtherance of Trafficking, ..., Forced Labor)","18:1594":"18:1594 (18:1594 Forfeiture)","18:1594(A)":"18:1594(A) (18:1594(A) Attempt to Establish Peonage, Slavery, Involuntary Servitude, or Human Trafficking)","18:1594(C)":"18:1594(C) (18:1594(C) Conspiracy to Commit Sex Trafficking of Children by Force, Fraud, or Coercion)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2511":"18:2511 (18:2511 Wiretapping)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","18:843(b)":"18:843(b) (Use of Communication Facility)","19:1305":"19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Fed. Question: Civil Rights Violation)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331pr":"28:1331pr (Fed. Question: Prisoner Petition)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332":"28:1332 (28:1332 Diversity of citizenship)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332ip":"28:1332ip (Diversity - Interpleader Action)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel, Assault, Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 VA Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346(b)":"28:1346(b) (28:1346(b) Federal Tort Claims Act)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Actions against Insurers of Diplomatic Missions)","28:1391":"28:1391 (28:1391 Venue Generally)","28:1402":"28:1402 (28:1402 United States as Defendant)","28:1407":"28:1407 (28:1407 Multidistrict Litigation)","28:1441ac":"28:1441ac (28:1441 Notice of Removal-Account Receivable)","28:1441al":"28:1441al (28:1441 Notice of Removal-Airline Crash)","28:1441as":"28:1441as (28:1441 Notice of Removal-Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Notice of Removal-Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Notice of Removal-Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Notice of Removal-Contract Default)","28:1441dj":"28:1441dj (28:1441 Notice of Removal-Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441 Notice of Removal-Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Notice of Removal-Fraud)","28:1441ij":"28:1441ij (28:1441 Notice of Removal-Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Notice of Removal-Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Notice of Removal-Libel, Assault, Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Notice of Removal-Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Notice of Removal-Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Notice of Removal-Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Notice of Removal-Property Damage)","28:1441pi":"28:1441pi (28:1441 Notice of Removal-Personal Injury)","28:1441pl":"28:1441pl (28:1441 Notice of Removal-Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Notice of Removal-Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Notice of Removal-Torts to Land)","28:1441tm":"28:1441tm (28:1441 Notice of Removal-Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Notice of Removal-Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Notice of Removal-Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Notice of Removal-Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1441 Notice of Removal-Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Notice of Removal-Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Notice of Removal-Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (Actions affecting property on which United States had lien)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2615":"29:2615 (Family and Medical Leave Act of 1993 (FMLA of 1993))","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11601":"42:11601 (42:11601 Int'l Child Abduction Remedies Act (Hague Conventn))","42:12111":"42:12111 (Americans with Disabilities Act of 1990)","42:12117":"42:12117 (42:12117 Americans with Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accommodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:3601 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332)","42:5851":"42:5851 (42:5851 Proto/emp. Reporting Violations/atomic energy act)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9604":"42:9604 (42:9604 Comp. Environ. Response Comp. and Liab. Act (CERCLA))","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:227":"47:227 (47 USC 227 Telephone Consumer Protection Act)","47:332":"47:332 (47.U.S.C. 332(c)(7) Federal Communications Act of 1996)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:11707":"49:11707 (Liability of Common Carriers)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","4:111":"4:111 (4:111 Taxation Affecting Federal Employees)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","adsup":"adsup (Administrative Subpoena)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","fordepo":"fordepo (Foreign Deposition)","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","writgar":"writgar (Application for a Writ of Garnishment)"},"gudce":{"0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2023":"07:2023 (07:2023 Administrative and judicial review - restoration of rights)","07:2024e":"07:2024e (Forfeiture of property involved in illegal benefit transactions, 7 USC 2014(e))","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451a":"08:1451a (Revocation of Naturalization - Title 8 USC 1451(a))","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0981a1C":"18:0981a1C (Civil Forfeiture, 18 USC 981(a)(1)(C))","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2323":"18:2323 (18:2323 Forfeiture, destruction, and restitution)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","21:451":"21:451 (21:451 Poultry and Poultry Products Inspection)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-core))","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgement)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrimination)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting Act)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interpleader)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2001":"29:2001 (29:2001 Employee Polygraph Protection Act)","29:2101":"29:2101 (29:2101 Worker Adjustment and Retraining Notification Act)","29:2601":"29:2601 (29:2601 FMLA: Family and Medical Leave Act (Findings and Purposes))","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act - 1977)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","33:901":"33:901 (33:901 Longshoremen & Harbor Worker's Comp Act)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4323b3":"38:4323b3 (Enforcement of rights with respect to a private employer)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:3131":"40:3131 (40:3131 Miller Act)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:12101":"42:12101 (42:12101 Violation of Americans with Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1985":"42:1985 (42:1985 Civil Rights Act)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:190":"46:190 (46:190 INDEMNITY UNDER THE GENERAL MARITIME LAW)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1424":"48:1424 (48:1424 The Organic Act of Guam)","48:1983":"48:1983 (48:1983 Civil Rights)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summons)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","MiscCause":"MiscCause (Civil Miscellaneous Case)","Rule9H":"Rule9H (Breach of Contract - Maritime Rule 9(h))","misc":"misc (Civil Miscellaneous Case)"},"hidce":{"*41*":"*41* ()","0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1153b5":"08:1153b5 (08:1153b5 Immigrant Investor Law)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451a":"08:1451a (Revocation of Naturalization - Title 8 USC 1451(a))","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:1801":"16:1801 (Magnuson-Stevens Fishery Conservation and Management Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:01956":"18:01956 (Civil Money Laundering Penalty)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0924":"18:0924 (18:0924(d) Forfeiture - Firearms)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1955":"18:1955 (18:1955 Forfeiture - Illegal Gambling)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-core))","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgement)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrimination)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting Act)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interpleader)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2601":"29:2601 (29:2601 Family and Medical Leave Act of 1993)","29:481":"29:481 (Labor-Mgmt Reporting and Disclosure Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act - 1977)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","33:9091":"33:9091 (Longshoremen's and Harbor Workers' Compensation Act)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)","38:3116":"38:3116 (38:3116 VA Overpayment)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:12101":"42:12101 (42:12101 Violation of Americans with Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:3601 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:521":"47:521 (CABLE TV CONSUMER PROTECTION ACT)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summons)","49:41705":"49:41705 (Discrimination Against Handicapped Individuals)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","Rule9H":"Rule9H (Breach of Contract - Maritime Rule 9(h))","misc":"misc (Civil Miscellaneous Case)"},"iandce":{"0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown )","02:0358":"02:0358 (02:358 President's Recommendations on Exec., Jud. & Leg. Salary)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","02:0681":"02:0681 (02:681 Deferral of Budget Authority)","02:1202":"02:1202 (02:1202 Discriminatory practices affecting US Senate employees)","02:1301":"02:1301 (02:1301 Congressional Accountability Act)","02:1317(a)":"02:1317(a) (02:1317(a) Violation of Congressional Accountability Act)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0101":"05:0101 (05:101 Ethics in Government Act)","05:0504":"05:0504 (05:504(c)(2) Equal Access to Justice (Govt Employees))","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552":"05:0552 (05:552b(g)sa Implement Requirements of Govt in Sunshine Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Adjudications Required by Statutes)","05:0555(b)":"05:0555(b) (05:555(b) Agency Decision - Right to Counsel)","05:0701":"05:0701 (05:0701 Judicial Review of Agency Decision)","05:0702":"05:0702 (05:702 Administrative Procedure Act - Right of Review)","05:0704":"05:0704 (05:704 Labor Litigation)","05:0706":"05:0706 (05:706 Judicial Review of Agency Action)","05:1508":"05:1508 (05:1508 Judicial Review of Order Issued by the Merit Systems Protection Board)","05:2302":"05:2302 (05:2302 Federal Whistleblowing Act/Civil Service Reform Act (CSRA))","05:3318":"05:3318 (05:3318 Veterans Preference Act)","05:5514":"05:5514 (05:5514 Debt Collection Act of 1982)","05:5542":"05:5542 (05:5542 Federal Employees Pay Act - overtime rates)","05:7101":"05:7101 (05:7101 Labor-Management Relations (Findings and Purpose))","05:7123":"05:7123 (05:7123 Petition by FLRA against unfair labor practices)","05:7501":"05:7501 (05:7501 Government Employees Adverse Action - 14 days or less)","05:7511":"05:7511 (05:7511 Government Employees Adverse Action--Over 14 days)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8101":"05:8101 (05:8101 Workmen's Compensation Benefits)","05:8110":"05:8110 (05:8110 Augmented Compensation for dependents of Govt. Employees)","05:8316":"05:8316 (05:8316 Claims agst US re Retirement for Federal Emp.)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","05:8701":"05:8701 (05:8701 Federal Employees Group Life Insurance Act of 1954)","05:8705":"05:8705 (05:8705 Declaratory Judgment - Insurance)","05:8715":"05:8715 (05:8715 Claims against the US - Jurisdiction of Courts)","05:8901":"05:8901 (05:8901 Federal Employees Health Benefits Act)","05:8902":"05:8902 (05:8902 Contracting Authority of OPM - Group Health Insurance)","05:8903":"05:8903 (05:8903 Federal Employees Health Benefit Act)","05:8912":"05:8912 (05:8912 Claims agst US re health benefits for Federal emp.)","07:0001":"07:0001 (07:1 Commodity Exchange Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0009a":"07:0009a (07:9a Recovery of penalties by Commodity Futures Trading Com)","07:0013a":"07:0013a (07:13a Contract market rules violations; recovery of penalty)","07:0013a-1":"07:0013a-1 (07:13a-1 Enjoin or restrain violations Contract Market rules)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0087":"07:0087 (07:87 Enforcement of United States Grain Standards Act)","07:0136":"07:0136 (07:136 Violations of EPA re Environmental Pesticide Control)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0193(b)":"07:0193(b) (07:193(b) Recovery of penalties re violations by packers)","07:0203":"07:0203 (07:203 Recovery of penalties for violations by stockyards)","07:0209(b)":"07:0209(b) (07:209(b) Violations re purchase, sale, handling of livestock)","07:0210(f)":"07:0210(f) (07:210(f) Suit to enforce award of damages (Packers/Stockyards))","07:0213(b)":"07:0213(b) (07:213(b) Unfair, discriminatory, deceptive practice/marketing)","07:0216":"07:0216 (07:216 Injunctions to restrain & enforce orders of Secretary)","07:0222":"07:0222 (07:222 Adoption of FTC powers for enforcement)","07:0228a":"07:0228a (07:228a Request by Secretary for TRO or Inj. re Poultry)","07:0245":"07:0245 (07:245 Action on bond by person injured in Warehouse)","07:0292":"07:0292 (07:292 Monopolizing or restraining trade & enhancing prices)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0499E":"07:0499E (07:499E (c)(4) Perishable Agriculture Commodities Act (PACA))","07:0601":"07:0601 (07:601 USDA Condemnation)","07:0608":"07:0608 (07:608 Agriculture Adjustment Act)","07:0901":"07:0901 (07:901 Rural Electrification Act)","07:1291(b)":"07:1291(b) (07:1291(b) Agricultural Adjustment Act; freight rates)","07:1376":"07:1376 (07:1376 Adjustment of Quotas and Enforcement; penalties)","07:1501":"07:1501 (07:1501 Federal Crop Insurance Act)","07:1508":"07:1508 (07:1508 Crop Insurance )","07:1631":"07:1631 (07:1631 Food Security Act)","07:1721":"07:1721 (07:1721 Agricultural Trade Development Asst Act)","07:1922":"07:1922 (07:1922 Persons Eligible for Loans - Forclosure)","07:1926":"07:1926 (07:1926 Water and Waste Facility Loans and Grants)","07:1930":"07:1930 (07:1930 Perishable Agric. Comm. Act of 1930)","07:2011":"07:2011 (07:2011 Supplemental Nutrition Assistance Program)","07:2022":"07:2022 (07:2022 Disposition of Claims; Denial application to participate; food stamp prog.)","07:2023(a)":"07:2023(a) (07:2023(a) Judicial Review of Food Stamp Disqualification)","07:2024":"07:2024 (07:2024 False Claims Act, Food Stamp Fraud)","07:2131":"07:2131 (07:2131 Violation of the Animal Welfare Act)","07:2146":"07:2146 (07:2146 Transportation, Sale, and Handling of Animals)","07:2301":"07:2301 (07:2301 Agricultural Fair Practices Act)","07:2305":"07:2305 (07:2305 Unfair trade practices affecting producers Agri prod)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","07:2563":"07:2563 (07:2563 Plant Variety Protection and Rights - Injunction)","07:6999":"07:6999 (07:6999 Judicial Review of Adverse Farm Agency Decision)","08:1101":"08:1101 (08:1101 Immigration & Nationality Act (Definitions))","08:1105":"08:1105 (8:1105a Immigration: Judicial Review for Battered Spouses; Deportation (INS))","08:1151":"08:1151 (08:1151 Immigration and Nationality Act of 1952)","08:1152":"08:1152 (08:1152 Immigration: Numerical limitations on individual foreign states)","08:1153":"08:1153 (08:1153 Immigration: Allocation of Immigrant Visas)","08:1154":"08:1154 (08:1154 Immigration: Procedure for Granting Immigration Status)","08:1158":"08:1158 (08:1158 Immigration & Nationality Act, Section 208 (Asylum))","08:1182":"08:1182 (08:1182 Inadmissible Aliens: Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1183":"08:1183 (08:1183 Admission of Aliens on Giving Bond or Undertaking; Return on Departure)","08:1188":"08:1188 (08:1188 Immigration: Admission of Temporary H-2A Workers)","08:1225":"08:1225 (08:1225 Immigration: Enforcement of Administrative Subpoena)","08:1231":"08:1231 (08:1231(a)(6) Immigration: Due Process Clause)","08:1251":"08:1251 (081251(A)(4) Immigration: Application for a Stay of Deportation)","08:1252":"08:1252 (08:1252 Judicial Review of Orders of Removal)","08:1255":"08:1255 (08:1255 Immigration: Failure USCIS To Adjudicate Permanent Residency Petition)","08:1260":"08:1260 (08:1260 Aliens: Removal of Aliens Falling into Distress)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1357":"08:1357 (08:1357 Immigration and Nationality Act - Administrative Search Warrant)","08:1421":"08:1421 (08:1421 Immigration: Naturalization Authority)","08:1445":"08:1445 (08:1445 Immigration: Application for Naturalization)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1447":"08:1447 (08:1447 Immigration: Review of Denial of Naturalization Application)","08:1451":"08:1451 (08:1451 Immigration: Revocation of Citizenship)","08:1451(a)":"08:1451(a) (08:1451(a) Action to revoke Citizenship)","08:1451(j)":"08:1451(j) (08:1451(j) Immigation: Motion to Correct Order and Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0003":"09:0003 (09:3 Application to Stay Proceedings Pending Arbitration)","09:0004":"09:0004 (09:4 Petition to order arbitration; failure to arbitrate)","09:0007":"09:0007 (09:7 Petition to compel attendance before arbitrator)","09:0008":"09:0008 (09:8 Declaratory Judgment/Admiralty)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","09:0011":"09:0011 (09:11 Motion to modify or correct arbitration award)","09:0201":"09:0201 (09:201 Petition to Compel/Stay Arbitration under an Insurance Contract)","09:0202":"09:0202 (09:202 Award under Convention on Foreign Arbitral Awards)","09:0205":"09:0205 (09:205 Removal from State Court: Enforcement of Foreign Arbital Awards)","09:0207":"09:0207 (09:207 Application for order confirming award of arbitrators)","10:0672":"10:0672 (10:672 Armed Forces: Active Guard/Reserve (AGR) Program)","10:1006":"10:1006 (10:1006 Armed Forces: Review of Agency Decision)","10:1072":"10:1072 (10:1072 Armed Forces: TRICARE PROGRAM)","10:1089(c)":"10:1089(c) (10:1089(c) Armed Forces: Removal; dft acting in scope of duties)","10:1091":"10:1091 (10:1091 Armed Forces: Personal Service Contracts)","10:1107":"10:1107 (10:1107 Armed Forces: Use of Investigational New Drug)","10:1408":"10:1408 (10:1408 Armed Forces: Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: Review of Discharge or Dismissal)","10:2005":"10:2005 (10:2005 Armed Forces: Advanced Education Assistance)","10:2121":"10:2121 (10:2121 Armed Forces: Health Professions Scholarship Financial Asst Prog)","10:2302":"10:2302 (10:2302 Armed Forces: Arms Services Procurement Act)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","10:2323":"10:2323 (10:2323fa Armed Forces: 5th Amendment Equal Protection: Contract Goal for Small Disadvantaged Bus.)","10:2733":"10:2733 (10:2733 Armed Forces: Military Claims Act)","10:2734":"10:2734 (10:2734 Armed Forces: Foreign Military Claims Act)","10:2771":"10:2771 (10:2771 Armed Forces: Final Settlement - Deceased Members)","10:3258":"10:3258 (10:3258 Armed Forces: Reg.Army: Re-enlistment after Service as Ofcr)","11:0101":"11:0101 (11:101 Bankruptcy)","11:0110":"11:0110 (11:110 Bankruptcy: Penalty for Preparers of Fraudulent or Negligent Petitions)","11:0362(h)":"11:0362(h) (11:362(h) Bankruptcy: Violation of Automatic Stay)","11:0523":"11:0523 (11:523 Bankruptcy: Exceptions to Discharge)","11:0524":"11:0524 (11:524 Bankruptcy: Effect of Discharge)","11:0525":"11:0525 (11:525 Bankruptcy: Protections Against Discriminatory Treatment)","11:0548":"11:0548 (11:548 Bankruptcy: Fraudulent Transfers and Obligations)","11:0704":"11:0704 (11:704 Bankruptcy: Duties of Trustee)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0085":"12:0085 (12:85 National Banks: Rate of Interest on Loans, Discounts, and Purchases)","12:0093(a)":"12:0093(a) (12:93(a) National Banks: Violation of Provisions; Forfeiture of Franchise; Per. Liability of Dir.)","12:0191":"12:0191 (12:191 National Banks: Appointment of Receiver)","12:0192":"12:0192 (12:192 National Banks: Liquidation of National Bank)","12:0215":"12:0215 (12:215 National Banks: Consolidation and Merger)","12:0622":"12:0622 (12:622 Foreign Banking: Forfeiture, Dissolution, and Liability of Dir. and Officers for Noncomplianc)","12:0632":"12:0632 (12:632 Foreign Banking: Voluntary Liquidation)","12:0635":"12:0635 (12:635i-3 Export-Import Bank: Breach of Insurance Contract)","12:1421":"12:1421 (12:1421 Federal Home Loan Bank Act (Short Title))","12:1441":"12:1441 (12:1441 FHLB: Financial Inst Reform Receiving Enforcement Act 1989)","12:1451":"12:1451 (12:1451 Emergency Home Loan Corporation (Definitions))","12:1452":"12:1452 (12:1452 Federal Home Loan Mortgage Corporation Act)","12:1452(f)":"12:1452(f) (12:1452(f) Fed Home Loan Mortgage Corp: Actions by and against the Corporation)","12:1455(b)":"12:1455(b) (12:1455(b) Fed Home Loan Mortgage Corp: Enforcement of Regulations)","12:1461":"12:1461 (12:1461 Savings Association: Homeowners Loan Act (Short Title))","12:1464":"12:1464 (12:1464 Savings Associations: Federal Savings and Loan)","12:1703":"12:1703 (12:1703 National Housing: Insurance of Financial Institutions)","12:1715(b)":"12:1715(b) (12:1715(b) National Housing: Rules and Regulations)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1749aaa":"12:1749aaa (12:1749aaa National Housing: National Insurance Development Program)","12:1751":"12:1751 (12:1751 Fed Credit Unions: Short Title)","12:1782":"12:1782 (12:1782 Fed Credit Unions: Administration of Insurance Fund)","12:1786":"12:1786 (12:1786 Fed Credit Unions: Actions re Violations by Credit Unions)","12:1787":"12:1787 (12:(a)(B) Fed Credit Unions: Liquidation of Insured Credit Union by Board)","12:1789":"12:1789 (12:1789(a)(2) Fed Credit Unions: Admin Provision to Sue and be Sued)","12:1811":"12:1811 (12:1811 FDIC: Financial Inst. Reform Recovery Act of 1989 (FIRREA) (Org of FDIC))","12:1818":"12:1818 (12:1818 FDIC: Violations re Federal Deposit Insurance Corporation)","12:1818(e)":"12:1818(e) (12:1818(e) FDIC: Suspension of Removal of Bank Officer)","12:1819":"12:1819 (12:1819 FDIC: Corporate Powers)","12:1821":"12:1821 (12:1821 FDIC: Insurance Funds)","12:1831":"12:1831 (12:1831 FDIC: Separability of Certain Provisions)","12:1831(d)":"12:1831(d) (12:1831(d) FDIC: Deposit. Inst. Dereg. & Monetary Ctrl. Act of 1980)","12:1831r-1":"12:1831r-1 (12:1831r-1 FDIC: Notice of Branch Closure)","12:1833(a)":"12:1833(a) (12:1833(a) FDIC: Forfeiture Civil Penalties)","12:1954":"12:1954 (12:1954 Injunctions (Action by Sec of Treasury re financial recordkeeping))","12:1971":"12:1971 (12:1971 Relief under Bank Holding Company Act (Definitions))","12:1972":"12:1972 (12:1972 Tying Arrangement Act)","12:2001":"12:2001 (12:2001 Farm Credit Act of 1971)","12:2601":"12:2601 (12:2601 Real Estate Settlement Procedures Act (RESPA) (findings & purpose))","12:2604(c)":"12:2604(c) (12:2604(c) Real Estate Settlement Procedures Act (\"RESPA\"))","12:2605":"12:2605 (12:2605 RESPA: Servicing of Mortgage Loans)","12:2607":"12:2607 (12:2607 RESPA: Violation re kickbacks/unearned fees; Real Estate)","12:2609":"12:2609 (12:2609 RESPA: Escrow)","12:3012":"12:3012 (12:3012 National Consumer Cooperative Bank: Suits by or against Bank)","12:3410":"12:3410 (12:3410 Right to Financial Privacy: Customer Challenges)","12:3751":"12:3751 (12:3751 Single Family Mortgage Foreclosure Act: Findings and Purpose)","12:3801":"12:3801 (12:3801 Alternative Mortgage Transaction Parity Act)","12:3907":"12:3907 (12:3907 International Lending Supervision: Capital Adequacy)","12:4010":"12:4010 (12:4010 Expedited Funds Availability: Violation of Act (Civil Liability))","12:5101":"12:5101 (12:5101 Fraudulent Transfer Act (Enforcement for Mortgage Licensing))","15:0001":"15:0001 (15:1 Antitrust Litigation (Monopolizing Trade))","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2fl Antitrust Litigation)","15:0004":"15:0004 (15:4 USDC Jurisdiction re violations of Sec. 1-7 of Title 15)","15:0005":"15:0005 (15:5 Bringing in Additional Parties)","15:0009":"15:0009 (15:9 USDC Jurisdiction re violations of Sec. 8 of Title 15)","15:0013":"15:0013 (15:13 Robinson Patman Act)","15:0014":"15:0014 (15:14 Clayton Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0026":"15:0026 (15:26 Suit for injunctive relief re violation antitrust laws)","15:0041":"15:0041 (15:41 Federal Trade Commission Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act (unfair or deceptive acts))","15:0045cp":"15:0045cp (15:45cp Violation of Children Online Privacy Protection Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0053(b)":"15:0053(b) (15:53(b) Prelim & Perm Inj Relief & other Equitable Relief)","15:0068":"15:0068 (15:68 Proceedings re FTC violations re wool products)","15:0069":"15:0069 (15:69 Proceedings re FTC violations re fur products)","15:0070":"15:0070 (15:70 Proceedings re FTC violations re textile fiber product)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0079":"15:0079 (15:79 Public Utility Holding Companies)","15:0080a-3":"15:0080a-3 (15:80a-3 Investment Company Act of 1940)","15:0260":"15:0260 (15:260 Proceedings re weights and measures and standard time)","15:0298":"15:0298 (15:0298 Violation of Law Proceedings re gold or silver)","15:0433":"15:0433 (15:433 Discrimination against farmers)","15:0631":"15:0631 (15:631 Small Business Act)","15:0636":"15:0636 (15:636 Small Business Act - Aid to small business)","15:0661":"15:0661 (15:661 Small Business Investment Act of 1958)","15:0687":"15:0687 (15:687 Small Business Investment Program)","15:0714(b)":"15:0714(b) (15:714(b) Commodity Credit Corporation)","15:0715(f)":"15:0715(f) (15:715(f) Proceedings re petroleum and petroleum products)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0719i":"15:0719i (15:719i(c) Civil actions re violations or inj involving Gas)","15:0766":"15:0766 (15:766 Controversies arising re Federal Energy Admin. rules)","15:078j(b)":"15:078j(b) (15:78j(b)ss Stockholder Suit)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1071":"15:1071 (15:1071 Appeal of Decision of U.S. Patent & Trademark Office (Comm/Trademark Trial Bd))","15:1114":"15:1114 (15:1114 Trademark Infringement (Lanham Act))","15:1116":"15:1116 (15:1116 Inj to prevent violation rights of trademark owner)","15:1120":"15:1120 (15:1120 Trademark - False or Fraudulent Registration)","15:1121":"15:1121 (15:1121 Trademark Infringement (jurisdiction))","15:1125":"15:1125 (15:1125la Trademark Infringement (Lanham Act))","15:1125(a)":"15:1125(a) (15:1125(a) False representation of goods sold in interstate commerce)","15:1125(d)":"15:1125(d) (15:1125(d)ac Trademark (Anticybersquatting consumer protection))","15:1126":"15:1126 (15:1126 Trademarks - International conventions)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1191":"15:1191 (15:1191 Flamable Fabrics Act)","15:1221":"15:1221 (15:1221 Auto Dealer Suits Agst Manufacturers)","15:1261":"15:1261 (15:1261 Hazardous Substances (definitions))","15:1263":"15:1263 (15:1263 Prohibited Hazardous Substance - Interstate Commerce)","15:1267(a)":"15:1267(a) (15:1267(a) Federal Hazardous Substance Act)","15:1314":"15:1314 (15:1314 Antitrust--Petition for enforcement)","15:1501":"15:1501 (15:1501 Estab of Dept of Commerce)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1605":"15:1605 (15:1605 Determination of Finance Charge)","15:1638":"15:1638 (15:1638 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1666":"15:1666 (15:1666 Fair Credit Billing Act Dispute)","15:1667":"15:1667 (15:1667 Consumer Leasing Act)","15:1679":"15:1679 (15:1679 Violation of Credit Repair Organizations Act)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1691":"15:1691 (15:1691 Equal Credit Opportunity Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693":"15:1693 (15:1693ef Electronic Funds Transfer Act)","15:1693m":"15:1693m (15:1693m Violation of Prov. of Subchpt. VI (Electronic Fund Transfers))","15:1701":"15:1701 (15:1701 Interstate Land Sales Full Disclosure Act (ILFFDA))","15:1709":"15:1709 (15:1709 Interstate Land Sales)","15:1714":"15:1714 (15:1714 Actions to enjoin violations re interstate land sale)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2071":"15:2071 (15:2071 Consumer Product Safety; Condemnation hazardous prod)","15:2073":"15:2073 (15:2073 Private action to enforce Consumer Product Safety)","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2310(c)":"15:2310(c) (15:2310(c) Consumer Product Warranties)","15:2601":"15:2601 (15:2601 Toxic Substances Control Act (TCSA))","15:2604":"15:2604 (15:2604 Application for inj re distribution toxic substance)","15:2616":"15:2616 (15:2616 Toxic Substance control; seizure of chemical)","15:2620":"15:2620 (15:2620 Toxic Substances Control Act: citizen's petition)","15:2651":"15:2651 (15:2651 Asbestos Hazard Emergency Response Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:2805":"15:2805 (15:2805 Petroleum Marketing Practices-Franchise Protection)","15:34-35":"15:34-35 (15:34-35 Investment Company Act of 1940)","15:3414":"15:3414 (15:3414 National Gas Policy Act)","15:3710":"15:3710 (15:3710a Federal Technology Transfer Act of 1986)","15:3901":"15:3901 (15:3901 Federal Risk Retention Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","15:6801":"15:6801 (15:6801 Gram-Leach-Bliley Act)","15:7701":"15:7701 (15:7701 Federal CAN-Spam Act)","16:0019jj":"16:0019jj (16:19jj Park System Resource Protection Act)","16:0470":"16:0470 (16:470 Archaeological Resources Protection Act)","16:0470f":"16:0470f (16:470f National Historic Preservation Act)","16:0668":"16:0668 (16:668 Bald and Golden Eagle Protection Act)","16:0669":"16:0669 (16:669 Pittman-Robertson Conservation Restoration Act)","16:0675":"16:0675 (16:675 Norbeck Wildlife Preserve Organic Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:0823":"16:0823 (16:823a Federal Public Utility Regulatory Policies Act)","16:0825":"16:0825 (16:825 Federal Power Commission Regulation; Public Utilities)","16:0831":"16:0831 (16:831 Actions re: rights of Tennessee Valley Authority)","16:1244":"16:1244 (16:1244 National Scenic and National Historic Trails)","16:1374(d)":"16:1374(d) (16:1374(d)(6) Petition for Review re Application for Import of Polar Bear Trophies)","16:1531":"16:1531 (16:1531 Endangered Species Act)","16:1533":"16:1533 (16:1533 Endangered Species Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:1540":"16:1540 (16:1540 Endangered Species Act - Penalties and Enforcement)","16:1600":"16:1600 (16:1600 National Forest Management Act of 1976)","16:1801":"16:1801 (16:1801 Magnuson-Stevens Fishery Conservation and Management Act)","16:1858":"16:1858 (16:1858 National Fishery Management Program-Civil Penalties and Permit Sanctions)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act (Definitions)","16:3372":"16:3372 (16:3372 Lacey Act: Prohibited Acts)","16:3373":"16:3373 (16:3373 Lacey Act: Penalties and Sanctions - Appeal of Decision-DOI)","16:3374":"16:3374 (16:3374 Lacey Act: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement (definitions))","17:0201":"17:0201 (17:201 Ownership of Copyright)","17:0205(d)":"17:0205(d) (17:205(d) Priority Between Conflicting Transfers)","17:0407":"17:0407 (17:407 Recovery of fines & penalties by Register of Copyrights)","17:0411(b)":"17:0411(b) (17:411(b) Action by copyright owner for infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0502(a)":"17:0502(a) (17:502(a) Inj to prevent or restrain infringement copyright)","17:0504":"17:0504 (17:504 Remedies for Copyright Infringement)","17:0512":"17:0512 (17:512 Copyright Infringement of Digital Communications)","17:1201":"17:1201 (17:1201 Digital Millennium Copyright Act)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0492":"18:0492 (18:492 Forfeiture of Counterfeit Paraphernalia)","18:0603":"18:0603 (18:603 Conflict of Interest)","18:0922":"18:0922 (18:922 Firearms - Unlawful Possession (Civil Fines))","18:0923(f)":"18:0923(f) (18:923(f)(3) Review of Revocation of a License as a Dealer in Firearms)","18:0924":"18:0924 (18:0924 Firearms Seizure, Forfeiture and Disposition of Firearm)","18:0925(c)":"18:0925(c) (18:925(c) Restoration of ability to possess firearms/ammo)","18:0981":"18:0981 (18:981 Civil Forfeiture )","18:0981(a)":"18:0981(a) (18:981(a)(1)(A) Civil Forfeiture: Money Laundering Control Act)","18:0983":"18:0983 (18:983 Civil Forfeiture - General Rules)","18:1030":"18:1030 (18:1030 Fraud & Related Activity in Connection with Computers)","18:1345":"18:1345 (18:1345 Injunction against Fraud)","18:1514":"18:1514 (18:1514 Civil Action to Restrain Harassment of a Victim)","18:1514(A)":"18:1514(A) (18:1514(A) Civil Action to Protect Against Retaliation in Fraud Cases)","18:1836(a)":"18:1836(a) (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836(b)":"18:1836(b) (18:1836(b) Civil Action to Protect Trade Secrets)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1905":"18:1905 (18:1905 Disclosure of Confidential Information)","18:1955":"18:1955 (18:1955 Civil Forfeiture-Prohibition of Illegal Gambling)","18:1956(b)":"18:1956(b) (18:1956(b)(3) Laundering of Monetary Instruments - Forfeit Property)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Civil Remedies: Racketeering (RICO) Act)","18:1968":"18:1968 (18:1968 Action re civil investigative demand)","18:2254":"18:2254 (18:2254 Civil Forfeiture - Exploitation of Children)","18:2333":"18:2333 (18:2333 Civil Remedies: Anti-Terrorism Act of 1991)","18:2428":"18:2428 (Forfeiture of property)","18:2511":"18:2511 (18:2511 Wiretapping - Injunctive Relief or Civil Fine)","18:2520":"18:2520 (18:2520 Civil Damages for Interception Wire or Oral Communications)","18:2707":"18:2707 (18:2707 Civil Action: Stored Communications)","18:2710(c)":"18:2710(c) (18:2710(c) Wrongful Disclosure of Video Tape Rental or Sales Records)","18:2724":"18:2724 (18:2724 Civil Action - Motor Vehicle Records)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:3184":"18:3184 (18:3184 Extradition Procedure)","18:3511":"18:3511 (18:3511 Petition for Judicial Review)","18:3663":"18:3663 (18:3663 Civil Enforcement of Crim. Rest. Obligation)","18:4100":"18:4100 (18:4100 Transfer of Offenders)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)","19:1497":"19:1497 (19:1497 Customs Duties: Penalty for Failure to Declare)","19:1595a":"19:1595a (19:1595a Customs Duties: Forfeiture and Other Penalties)","19:1607":"19:1607 (19:1607 Customs Duties: Notice of Seizure)","20:0107":"20:0107 (20:107 Randolph-Sheppard Vending Stand Act)","20:1070":"20:1070 (20:1070 Student Assistance)","20:1080":"20:1080 (20:1080 Default of Student Loan: Recovery)","20:1087":"20:1087 (20:1087 Student Loan Discharge)","20:1095a":"20:1095a (20:1095a Education - Wage Garnishment Requirement)","20:1097":"20:1097 (20:1097 Education - Criminal penalties for fraud)","20:1098g":"20:1098g (20:1098g Higher Education Act - Exemption from state disclosure)","20:1232(g)":"20:1232(g) (20:1232(g) Family Education Rights & Privacy Act of 1974)","20:1400":"20:1400 (20:1400 IDEA: Individuals With Disabilities Education Act (short title))","20:1401":"20:1401 (20:1401 IDEA: Education of Individuals with Disabilities (definitions))","20:1412":"20:1412 (20:1412 IDEA: State Eligibility)","20:1415":"20:1415 (20:1415 IDEA: Challenge decision re education for handicapped)","20:1415(e)":"20:1415(e) (20:1415(e)(2)de IDEA: Mediation)","20:1681":"20:1681 (20:1681 Title IX Educational Amendments 1992 - Sex Discrimination)","20:1683":"20:1683 (20:1683 Judicial Review: Prohibition against sex discrimination in education)","20:1706":"20:1706 (20:1706 Relief from denial of equal educational opportunity)","20:1717":"20:1717 (20:1717 Reopening proceedings w/order to end segregation)","21:0301":"21:0301 (21:0301 Federal Food, Drug & Cosmetic Act)","21:0331":"21:0331 (21:0331 Federal Food, Drug & Cosmetic Act - Prohibited Acts)","21:0332":"21:0332 (21:332 Federal Food, Drug and Cosmetic Act, Injunctive Relief)","21:0332(a)":"21:0332(a) (21:332(a) Federal Food, Drug, and Cosmetic Act)","21:0334(a)":"21:0334(a) (21:334(a) Forfeiture or condemnation-food, drug, cosmetics)","21:0348":"21:0348 (21:348 Federal Food, Drug and Cosmetic Act - Food Additives)","21:0360":"21:0360 (21:360 Federal Food, Drug & Cosmetic Act - Drugs and Devices)","21:0467":"21:0467 (21:467 Seizure and condemnation of poultry products)","21:0601":"21:0601 (21:601 Federal Meat Inspection Act 21 USC 601-695 (Definitions))","21:0673":"21:0673 (21:673 Seizure and condemnation of meat or meat products)","21:0674":"21:0674 (21:674 Proceeding to enforce & enjoin re meat products)","21:0821":"21:0821 (21:821 Violation of Record Keeping Provision of Controlled Substance Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0842":"21:0842 (21:842 Civil Penalty for violation re controlled substance)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","21:0882":"21:0882 (21:882 Inj to enjoin violations re controlled substance)","21:1049":"21:1049 (21:1049 Seizure and condemnation re eggs or egg products)","22:0286":"22:0286 (22:286 Action against World Bank or IMF)","22:2702":"22:2702 (22:2702 Medical Malpractice by Govt. Medical Personnel)","22:3612":"22:3612 (22:3612 Claim for Damage to Panama Canal)","22:3776":"22:3776 (22:3776 Panama Canal Commission Action on claims)","22:3777":"22:3777 (22:3777 Investigation of accident or injury giving rise to a claim)","22:4140":"22:4140 (22:4140 Foreign Service Grievance Act - Judicial Review)","23:0112":"23:0112 (23:112 Federal Highway Act - Letting of Contracts)","23:0134":"23:0134 (23:134 Metropolitan Transportation Planning)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","25:2701":"25:2701 (25:2701 Indian Gaming Regulatory Act (IGRA))","25:4101":"25:4101 (25:4101 Native American Housing Assistance and Self-Determination Act (NAHASDA))","26:0063":"26:0063 (26:63 IRS: Taxable income (Definition))","26:0982":"26:0982 (26:982 IRS: To Quash IRS Formal Document Request)","26:2032":"26:2032 (26:2032 IRS: Alternate valuation)","26:6212":"26:6212 (26:6212 IRS: Notice of Deficiency (Injunctive Relief from IRS Lien))","26:6213":"26:6213 (26:6213 IRS: Injunctive Relief from IRS Lien in Tax Court)","26:6221":"26:6221 (26:6221 IRS: TEFRA Tax, Equity and Fiscal Responsibility Act of 1982)","26:6226":"26:6226 (26:6226 IRS: Judicial Review of Partnership Adjustment)","26:6320":"26:6320 (26:6320 IRS: Notice and Opportunity for Hearing upon Filing Notice of Lien)","26:6330":"26:6330 (26:6330 IRS: Notice and Opportunity for Hearing before Levy)","26:6331":"26:6331 (26:6331 IRS: Wrongful Levy)","26:6334":"26:6334 (26:6334 IRS: Property Exempt from Levy)","26:6502":"26:6502 (26:6502 IRS: Collection after Assessment (Enforcement of tax liens))","26:6532":"26:6532 (26:6532 IRS: Periods of Limitation on Suits)","26:6653":"26:6653 (26:6653sp IRS: Failure to Pay Stamp Tax)","26:6672":"26:6672 (26:6672 IRS: Failure to Collect and Pay Over Tax, or Attempt to Evade or Defeat Tax)","26:6694":"26:6694 (26:6694 IRS: Underestimate of Tax Liability By Tax Preparer)","26:6702":"26:6702 (26:6702 IRS: Penalty for Frivolous Tax Submission)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7323":"26:7323 (26:7323 IRS: Proceedings in rem enforce forfeitures property)","26:7401":"26:7401 (26:7401 IRS: Tax Liability - Authorization to collect via civil action)","26:7402":"26:7402 (26:7402 IRS: Jurisdiction of District Courts)","26:7402(b)":"26:7402(b) (26:7402(b) IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 IRS: Action to Enforce Federal Tax Lien)","26:7404":"26:7404 (26:7404 IRS: Action for collection of estate tax)","26:7405":"26:7405 (26:7405 IRS: Action for recovery of refunds erroneously made)","26:7407":"26:7407 (26:7407 IRS: Action to enjoin income tax preparers)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7425(a)":"26:7425(a) (26:7425(a) IRS: Judiciary & Judicial Procedures - Discharge of Liens)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7428":"26:7428 (26:7428 IRS: Declaratory Judgment)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7430":"26:7430 (26:7430 IRS: Awarding of Costs and Certain Fees in Tax Suit)","26:7431":"26:7431 (26:7431 IRS: Unauthorized Disclosure of Return & Return Info)","26:7434":"26:7434 (26:7434 IRS: Civil Damages for Fraudulent Filing of Information)","26:7604":"26:7604 (26:7604 IRS: Enforce summons; examination books & witnesses)","26:7604(a)":"26:7604(a) (26:7604(a) IRS: Complaint to Enforce IRS Summons)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","26:7609en":"26:7609en (26:7609en IRS: Petition to serve Third-Party Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157(b)":"28:0157(b) (28:157(b) Bankruptcy Claim to be tried in U.S. District Court)","28:0157(c)":"28:0157(c) (28:157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0463":"28:0463 (28:463 Expenses of Judicial Litigation)","28:0534":"28:0534 (28:534 Arrest Records)","28:0591":"28:0591 (28:591 Independent Counsel)","28:0592":"28:0592 (28:592 Independent Counsel - Application for Appointment)","28:0593":"28:0593 (28:593 Independent Counsel - Court Responsibilities)","28:0594":"28:0594 (28:594 Independent Counsel - Responsibilities)","28:0595":"28:0595 (28:595 Independent Counsel - Congressional Oversight)","28:0596":"28:0596 (28:596 Independent Counsel - Removal)","28:0597":"28:0597 (28:597 Independent Counsel - Dept. of Justice Relationship)","28:0598":"28:0598 (28:598 Independent Counsel - Chapter Termination)","28:0636":"28:0636 (28:636 Jurisdiction and Power of Magistrate Judges)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1291":"28:1291 (28:1291 Maritime)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331ag":"28:1331ag (28:1331 Fed. Question: Employment Discrimination (Age))","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331as":"28:1331as (28:1331 Fed. Question: Assault, Libel, Slander)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331bv":"28:1331bv (28:1331 Fed. Question: Bivens-Prisoner)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cr":"28:1331cr (28:1331 Fed. Question: Civil Rights (Race Discrimination))","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331dd":"28:1331dd (28:1331 Fed. Question: Discovery Disputes (conversion case))","28:1331dj":"28:1331dj (28:1331 Fed. Question: Declaratory Judgment)","28:1331dp":"28:1331dp (28:1331 Fed. Question: Violation of Due Process)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ef":"28:1331ef (28:1331 Fed. Question: Civil Rights Violation (Excess Force))","28:1331ej":"28:1331ej (28:1331 Fed Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fa":"28:1331fa (28:1331 Fed. Question: Civil Rights Violation - False Arrest)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331fm":"28:1331fm (28:1331 Fed. Question: Family and Medical Leave Act)","28:1331fr":"28:1331fr (28:1331 Fed. Question: Fraud)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331lm":"28:1331lm (28:1331 Fed. Question: Labor/Mgt. Relations Act)","28:1331lml":"28:1331lml (28:1331 Fed. Question: Legal Malpractice)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331ni":"28:1331ni (28:1331 Fed. Question: Negotiable Instrument)","28:1331pd":"28:1331pd (28:1331 Fed. Question: Property Damage)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331pl":"28:1331pl (28:1331 Fed. Question: Product Liability)","28:1331pr":"28:1331pr (28:1331 Fed. Question: Federal Prisoner Civil Rights)","28:1331ra":"28:1331ra (28:1331 Fed. Question: Racketeering (RICO) Act)","28:1331rc":"28:1331rc (28:1331 Fed. Question: Reclamation Project Auth. Act of 1972)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331rs":"28:1331rs (28:1331 Fed. Question: Federal Rail Safety Act)","28:1331sh":"28:1331sh (28:1331 Fed. Question: Sexual Harassment)","28:1331ss":"28:1331ss (28:1331 Fed. Question: Constitutionality of State Statutes)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331sx":"28:1331sx (28:1331 Fed. Question: Employment Discrimination (Sex))","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331va":"28:1331va (28:1331 Fed. Question: Violation 5th & 14th Amendment)","28:1331vc":"28:1331vc (28:1331 Fed. Question: Violation of Constitutional Rights)","28:1331w":"28:1331w (28:1331 Fed. Question: Wrongful Termination of Employment)","28:1331wd":"28:1331wd (28:1331 Fed. Question: Wrongful Death)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332":"28:1332 (28:1332 Diversity Action)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332ap":"28:1332ap (28:1332 Diversity-Airplane Product Liability)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332bw":"28:1332bw (28:1332 Diversity-Breach of Warranty)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332de":"28:1332de (28:1332 Diversity-Forcible Detainer)","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332dtp":"28:1332dtp (28:1332 Diversity-Deceptive Trade Practices)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332ej":"28:1332ej (28:1332 Diversity-Enforcement of Judgment)","28:1332fc":"28:1332fc (28:1332 Diversity-Foreclosure)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332if":"28:1332if (28:1332 Diversity-Insurance Fraud)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332lp":"28:1332lp (28:1332 Diversity-Property Damage/Product Liability)","28:1332lr":"28:1332lr (28:1332 Diversity-Labor)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332md":"28:1332md (28:1332 Diversity-Motor Vehicle/Wrongful Death)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332op":"28:1332op (28:1332 Diversity-Recovery of Overpayment)","28:1332pa":"28:1332pa (28:1332 Diversity-Personal Injury/Airplane)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332rd":"28:1332rd (28:1332 Diversity-Recovery of Debt)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332rl":"28:1332rl (28:1332 Diversity-Rent Lease & Ejectment)","28:1332rp":"28:1332rp (28:1332 Diversity-Real Property)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332sh":"28:1332sh (28:1332 Diversity-Sexual Harassment)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332t":"28:1332t (28:1332 Diversity-Torts)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332ts":"28:1332ts (28:1332 Diversity-Misappropriation of Trade Secrets)","28:1332vt":"28:1332vt (28:1332 Diversity-Natl Motor Vehicle Title Information System)","28:1332wc":"28:1332wc (28:1332 Diversity-Worker's Compensation Benefits)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1333ad":"28:1333ad (28:1333 Admiralty)","28:1333in":"28:1333in (28:1333 Personal Injury)","28:1333mc":"28:1333mc (28:1333 Marine Contract)","28:1333pd":"28:1333pd (28:1333 Property Damage)","28:1333pi":"28:1333pi (28:1333 Marine Personal Injury)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334(b)":"28:1334(b) (28:1334(b) Proceeding arising/related to case under title 11)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1339":"28:1339 (28:1339 Postal matters)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1340tp":"28:1340tp (28:1340 Jurisdiction of Internal Revenue Matters; Customs Duties)","28:1341":"28:1341 (28:1341 Taxes by States)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1344":"28:1344 (28:1344 Election disputes)","28:1345":"28:1345 (28:1345 U.S. Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345lc":"28:1345lc (28:1345 Land Condemnation)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345ro":"28:1345ro (28:1345 Recovery of Retirement Overpayment)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345tx":"28:1345tx (28:1345 Prohibit dfts assessing tx on purch/use of pers prop)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346":"28:1346 (28:1346 U.S. Defendant)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346pi":"28:1346pi (28:1346 Marine Personal Injury (or tort claim-personal injury/motor vehicle)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346t":"28:1346t (28:1346 Tort Claim)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1348":"28:1348 (28:1348 Banking association as party)","28:1349":"28:1349 (28:1349 Corporation organized under Federal Law as party)","28:1350":"28:1350 (28:1350 Alien Tort Claims Act)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1356":"28:1356 (28:1356 Executory Process/Foreclosure)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1361pr":"28:1361pr (28:1361 Complaint for mandamus relief (prisoner))","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1363":"28:1363 (28:1363 Action for protection of jurors employment rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1367":"28:1367 (28:1367 Other Property Damage)","28:1391":"28:1391 (28:1391 Venue)","28:1394":"28:1394 (28:1394 Banking Assoc action agst Comptroller of Currency)","28:1395":"28:1395 (28:1395 Complaint for Forfeiture)","28:1402":"28:1402 (28:1402 US as Defendant)","28:1403":"28:1403 (28:1403 Condemnation of real estate for the use of the US)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1407im":"28:1407im (28:1407 MDL: Silicone Gel Breast Implant Products Liability)","28:1407md":"28:1407md (28:1407 MDL: Multidistrict Litigation)","28:1407n":"28:1407n (28:1407 MDL: Personal Injury/Norplant Product Liability)","28:1407pl":"28:1407pl (28:1407 MDL: Products Liability)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441ada":"28:1441ada (28:1441 Removal-Americans with Disabilities Act)","28:1441ag":"28:1441ag (28:1441 Removal-Civil Rights (Age))","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441ba":"28:1441ba (28:1441 Removal-National Bank Act)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441bce":"28:1441bce (28:1441 Removal-Employee Benefits)","28:1441bfd":"28:1441bfd (28:1441 Removal-Breach of Fiduciary Duties)","28:1441ca":"28:1441ca (28:1441 Removal-Carmack Amendment)","28:1441cc":"28:1441cc (28:1441 Removal-Computer Crimes Act)","28:1441cj":"28:1441cj (28:1441 Removal-Confessed Judgment)","28:1441cla":"28:1441cla (28:1441 Removal-Consumer Leasing Act)","28:1441cp":"28:1441cp (28:1441 Removal-Copyright)","28:1441cpl":"28:1441cpl (28:1441 Removal-Contract Product Liability)","28:1441cra":"28:1441cra (28:1441 Removal-Fair Credit Reporting Act)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441dea":"28:1441dea (28:1441 Removal-Disabilities Education Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441di":"28:1441di (28:1441 Removal-Civil Rights (Disability Act))","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ea":"28:1441ea (28:1441 Removal-Employment Discrimination (Age))","28:1441eb":"28:1441eb (28:1441 Removal-E.R.I.S.A. Employee Benefits)","28:1441ec":"28:1441ec (28:1441 Removal-Electronic Comm. Privacy Act)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441em":"28:1441em (28:1441 Removal-Emergency Medical Treatment & Active Labor)","28:1441er":"28:1441er (28:1441 Removal-Employment Discrimination (Race))","28:1441es":"28:1441es (28:1441 Removal-Employment Discrimination (Sex))","28:1441fa":"28:1441fa (28:1441 Removal-Civil Rights - False Arrest)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fd":"28:1441fd (28:1441 Removal-Fair Debt Collection Practices Act)","28:1441fe":"28:1441fe (28:1441 Removal-Fed. Employee Garnishment Statute)","28:1441fh":"28:1441fh (28:1441 Removal-FEHBA)","28:1441fif":"28:1441fif (28:1441 Removal-Insecticide/Fungicide/Rodenticide Act-1942)","28:1441fl":"28:1441fl (28:1441 Removal-Fair Labor Standards Act)","28:1441fm":"28:1441fm (28:1441 Removal-Family and Medical Leave Act)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441fs":"28:1441fs (28:1441 Removal-Foreign Sovereign Immunities Act)","28:1441fsa":"28:1441fsa (28:1441 Removal-Federal Food Stamp Act)","28:1441hb":"28:1441hb (28:1441 Removal-Petition of Habeas Corpus)","28:1441hc":"28:1441hc (28:1441 Removal-Handicapped Child Protection Act)","28:1441hd":"28:1441hd (28:1441 Removal-Housing Discrimination)","28:1441ia":"28:1441ia (28:1441 Removal-Interstate Commerce Act)","28:1441if":"28:1441if (28:1441 Removal-Insurance Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441il":"28:1441il (28:1441 Removal-Interstate Land Full Discloser Act)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441la":"28:1441la (28:1441 Removal-Truth in Lending Act)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441ml":"28:1441ml (28:1441 Removal-Motor Vehicle Prod Liability)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441mv":"28:1441mv (28:1441 Removal-Motor Vehicle)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pa":"28:1441pa (28:1441 Removal-Patent Infringement)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ra":"28:1441ra (28:1441 Removal-Civil Rights (Race))","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441rl":"28:1441rl (28:1441 Removal-Rent, Lease, & Ejectment)","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441sh":"28:1441sh (28:1441 Removal-Sexual Harassment)","28:1441st":"28:1441st (28:1441 Removal-Stockholders Suit)","28:1441sv":"28:1441sv (28:1441 Removal-Security Violation)","28:1441sx":"28:1441sx (28:1441 Removal-Civil Rights (Sex))","28:1441tc":"28:1441tc (28:1441 Removal-Tricare Program)","28:1441ti":"28:1441ti (28:1441 Removal-Trademark Infringement)","28:1441til":"28:1441til (28:1441 Removal-Truth and Lending)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441us":"28:1441us (28:1441 Removal-Uniformed Svc Emp/Reemp Rights Act)","28:1441wc":"28:1441wc (28:1441 Removal-Worker's Compensation Benefits)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1441wt":"28:1441wt (28:1441 Removal-Employment (Wrongful Termination))","28:1442":"28:1442 (28:1442 Notice of Removal-Suit against Federal Officer)","28:1442aaf":"28:1442aaf (28:1442 Petition for Removal-Agst members of armed forces)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1443(1)":"28:1443(1) (28:1443(1) Removal from State Court-Civil Rights: Rent, Lease, and Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446al":"28:1446al (28:1446 Notice of Removal - Airline Crash)","28:1446as":"28:1446as (28:1446 Notice of Removal - Asbestos Litigation)","28:1446bc":"28:1446bc (28:1446 Notice of Removal - Breach of Contract)","28:1446cs":"28:1446cs (28:1446 Notice of Removal - Child Support Enforcement)","28:1446dj":"28:1446dj (28:1446 Notice of Removal - Declaratory Judgment)","28:1446er":"28:1446er (28:1446 Notice of Removal - E.R.I.S.A)","28:1446fm":"28:1446fm (28:1446 Notice of Removal - Family and Medical Leave Act)","28:1446fr":"28:1446fr (28:1446 Notice of Removal - Fraud)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446lb":"28:1446lb (28:1446 Notice of Removal - Libel, Assault, Slander)","28:1446ml":"28:1446ml (28:1446 Notice of Removal - Motor Vehicle Prod Liability)","28:1446mm":"28:1446mm (28:1446 Notice of Removal - Medical Malpractice)","28:1446mv":"28:1446mv (28:1446 Notice of Removal - Motor Vehicle)","28:1446ni":"28:1446ni (28:1446 Notice of Removal - Negotiable Instrument)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446oc":"28:1446oc (28:1446 Notice of Removal - Other Contract)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1446st":"28:1446st (28:1446 Notice of Removal - Stockholders Suit)","28:1446tl":"28:1446tl (28:1446 Notice of Removal - Torts to Land)","28:1446wd":"28:1446wd (28:1446 Notice of Removal - Wrongful Death)","28:1452":"28:1452 (28:1452 Removal of Claims Related to Bankruptcy Cases)","28:1453":"28:1453 (28:1453 Class Action Fairness Act)","28:1491":"28:1491 (28:1491 Tucker Act)","28:1602":"28:1602 (28:1602 Foreign Sovereign Immunities Act)","28:1605":"28:1605 (28:1605 Foreign Sovereign Immunities Act of 1976)","28:1605A":"28:1605A (28:1605A Antiterrorism & Effective Death Penalty Act 1996)","28:1610":"28:1610 (28:1610 Juridictional Immunities of Foreign States)","28:1631":"28:1631 (28:1631 Case Transferred to Cure Want of Jurisdiction)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651cn":"28:1651cn (28:1651 Petition for Writ of Error Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1651ne":"28:1651ne (28:1651 Application for Writ Ne Exeat)","28:1651w":"28:1651w (28:1651 All Writs Act)","28:1715":"28:1715 (28:1715 Class Action Fairness Act of 2005)","28:1732":"28:1732 (28:1732 Reproduction of Records)","28:1738Acs":"28:1738Acs (28:1738 The Uniform Child Custody Jurisdiction Act)","28:1782":"28:1782 (28:1782 Assistance to Foreign Tribunals (incl letter rogatory))","28:1783":"28:1783 (28:1783 Petition for Subpoena of person in foreign country)","28:1826":"28:1826 (28:1826 Order of confinement of recalcitrant witness)","28:1875":"28:1875 (28:1875 Juror Protection Act / Protection of Juror's Employment)","28:1916":"28:1916 (28:1916 Marine Personal Injury)","28:1963":"28:1963 (28:1963 Registration of judgment from another district)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2001":"28:2001 (28:2001 Judicial Sale of Realty)","28:2071":"28:2071 (28:2071 Rule Making Power Generally)","28:2201":"28:2201 (28:2201 Creation of a Remedy - Declaration of Rights)","28:2201an":"28:2201an (28:2201 Declaratory Judgment (aliens and nationality))","28:2201cp":"28:2201cp (28:2201 Declaratory Judgment (Copyright))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201fa":"28:2201fa (28:2201 Declaratory Judgment (Firearms))","28:2201fs":"28:2201fs (28:2201 Declaratory Judgment (Food Security Act))","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2201pi":"28:2201pi (28:2201 Declaratory Judgment (Personal Injury))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2241fd":"28:2241fd (28:2241 Petition for Writ of Habeas Corpus (Federal))","28:2241in":"28:2241in (28:2241 Habeas Corpus: INS)","28:2241st":"28:2241st (28:2241 Petition for Writ of Habeas Corpus (State))","28:2244":"28:2244 (28:2244 Habeas Corpus - Finality of Determination)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254dp":"28:2254dp (28:2254 Petition for Writ of Habeas Corpus (Death Penalty))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2283":"28:2283 (28:2283 Stay of State Court Proceedings (Injunctive Relief))","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2347":"28:2347 (28:2347 Petition to Review Orders in the Ct of Appeals)","28:2401":"28:2401 (28:2401 Federal Tort Claims Act (Time for commencing action against the US))","28:2403":"28:2403 (28:2403 Constitutionality of State Statute(s))","28:2405":"28:2405 (28:2405 Garnishment of debtors of a corporation by US)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title - Actions affecting property on which United States has lien)","28:2412":"28:2412 (28:2412 Equal Access to Justice Act)","28:2415":"28:2415 (28:2415 Detinue and Conversion)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act (Definitions))","28:2672mv":"28:2672mv (28:2672 Federal Tort Claims Act - Motor Vehicle)","28:2672pi":"28:2672pi (28:2672 Federal Tort Claims Act - Personal Injury)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act - Liability of US)","28:2675":"28:2675 (28:2675 Federal Tort Claims Act - Disposition by Agency Req)","28:2679(d)":"28:2679(d) (28:2679(d)(2) Federal Tort Claims Act - Employee of U.S.A.)","28:2680":"28:2680 (28:2680 Federal Tort Claims Act - Exceptions)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","28:3001(a)":"28:3001(a) (28:3001(a) Federal Debt Collection Procedures Act of 1990)","28:3203":"28:3203 (28:3203 Postjudgment Remedies: Writ of Execution)","28:3301":"28:3301 (28:3301 Fraudulent Transfer Federal Debt Collection Procedures Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0101":"29:0101 (29:101 Labor: Issuance of Restraining Orders and Injunctions)","29:0151":"29:0151 (29:151 Labor: National Labor Relations Act (NLRA))","29:0160":"29:0160 (29:160 Labor: NLRA - Prevention of Unfair Labor Practices)","29:0160(i)":"29:0160(i) (29:160(i) Labor: Petition for Inj re Uncertified Labor Organizations)","29:0160(j)":"29:0160(j) (29:160(j) Labor: Petition for Inj - Relief from Unfair Labor Practice)","29:0161(2)":"29:0161(2) (29:161(2) Labor: Enforcement of agency subpoena)","29:0178":"29:0178 (29:178 Labor: Petiton for Inj to Enjoin Strike duing Natl Emergency)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185":"29:0185 (29:185 Labor: Suits by and against Labor Organizations)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0186":"29:0186 (29:186 Labor: Liabilities of and Restrictions on Labor and Management)","29:0187":"29:0187 (29:187 Labor: Recover Damages from Unfair Labor Practice)","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 FLSA: Definitions)","29:0206":"29:0206 (29:206 FLSA: Minimum Wage)","29:0206(d)":"29:0206(d) (29:206(d) FLSA: Prohibition of Sex Discrimination)","29:0207(a)":"29:0207(a) (29:207(a) FLSA: Action for Overtime Wage Violation)","29:0207fl":"29:0207fl (29:207fl FLSA: Maximum Hours)","29:0210":"29:0210 (29:210 FLSA: Court Review of Wage Orders in PR and VI)","29:0215fl":"29:0215fl (29:215fl FLSA: Prohibited Acts)","29:0216(b)":"29:0216(b) (29:216(b) FLSA: Minimum wage or overtime compensation)","29:0216(e)":"29:0216(e) (29:216(e) FLSA: Penalty assessed for child labor provision)","29:0217":"29:0217 (29:217 FLSA: Enjoin Violations of Fair Labor Standards Act)","29:0260":"29:0260 (29:260 FLSA: Liquidated Damages)","29:0401":"29:0401 (29:401 Labor Management Disclosure Act)","29:0411":"29:0411 (29:411 Landrum Griffin Act)","29:0412":"29:0412 (29:412 Infringement of rights; members of labor organization)","29:0440":"29:0440 (29:440 violations reporting requirements; labor organization)","29:0501(b)":"29:0501(b) (29:501(b) Violation of Fiduciary Responsibility)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Prohibition of Age Discrimination))","29:0626":"29:0626 (29:626 Job Discrimination (Investigation and Enforcement))","29:0633":"29:0633 (29:633 Job Discrimination (Age - Federal - State Relationship))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0660":"29:0660 (29:660 Action by Sec Labor for discrimination re rights OSHA)","29:0662":"29:0662 (29:662 Inj proceedings re dangerous emp conditions; by Sec.)","29:0666":"29:0666 (29:666 Collection of civil penalties under OSHA)","29:0701":"29:0701 (29:701 Vocational Rehabilitation)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0792(d)":"29:0792(d) (29:792(d)(2) Accessible facilities for phys. handicapped emp)","29:0794":"29:0794 (29:794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement (Definitions))","29:1055":"29:1055 (29:1055 E.R.I.S.A.: Employee Retirement (Joint and Survivor Annuity))","29:1101":"29:1101 (29:1101 E.R.I.S.A.: Coverage)","29:1104":"29:1104 (29:1104 E.R.I.S.A.: Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 E.R.I.S.A.: Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.: Civil Enforcement of Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.: Delinquent Contributions)","29:1149":"29:1149 (29:1149 E.R.I.S.A.: Prohibition on False Statements and Representations)","29:1161":"29:1161 (29:1161 COBRA - Continuation Coverage)","29:1162":"29:1162 (29:1162 COBRA - Continuation Coverage)","29:1303":"29:1303 (29:1303 PBGC: Operation of Corporation)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 E.R.I.S.A.: Liability for Termination of Single Employer Plans)","29:1381":"29:1381 (29:1381 E.R.I.S.A.: WIthdrawal Liability)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1401(b)":"29:1401(b) (29:1401(b)(2) E.R.I.S.A.: Resolution of Disputes - Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.: Enforcement - Civil Actions)","29:158(b)":"29:158(b) (29:158(b) Labor: NLRA - Unfair Labor Practices)","29:159":"29:159 (29:159 Labor: Violation of Collective Bargaining Agreement)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:1854":"29:1854 (29:1854 Migrant & Seasonal Agri Worker Protect Act (AWPA))","29:1916":"29:1916 (29:1916 Spec. Rule for Longshoremen & Harborworkers)","29:2001":"29:2001 (29:2001 Employee Polygraph Protection Act)","29:2101":"29:2101 (29:2101 Worker Adjustment and Retraining Notification Act)","29:2102":"29:2102 (29:2102 Notice required before plant closings & mass layoffs)","29:2104":"29:2104 (29:2104 Worker Adjustment & Retraining Notification (WARN))","29:2601":"29:2601 (29:2601 FMLA: Family and Medical Leave Act (Findings and Purposes))","29:2611":"29:2611 (29:2611 FMLA: Definitions)","29:2612":"29:2612 (29:2612 FMLA: Leave Requirements)","29:2617":"29:2617 (29:2617 FMLA: Enforcement)","29:790":"29:790 (29:790 Rehabilitation of Labor)","2:138":"2:138 (Library of Congress Access)","30:0022":"30:0022 (30:22 General Mining Law of 1872 (Lands Open to Purchase by Citizens))","30:0181":"30:0181 (30:0181 Land subject to disposition; presons entitled to benefits; reciprocal privileges)","30:0801":"30:0801 (30:801 Penalties/Federal Mine Safety Health Act)","30:0815":"30:0815 (30:815 Federal Mine Safety & Health Act (Procedure for Enforcement))","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action (Congressional Findings))","30:1202":"30:1202 (30:1202 Mining Reclamation Act (Statement of Purpose))","30:1276":"30:1276 (30:1276 Interior: Judicial Review of Agency Action)","30:1701":"30:1701 (30:1701 Federal Oil Gas Royalty Mgt Act 1983 (FOGRMA))","31:0732":"31:0732 (31:732 General Acct. Office Personnel Act of 1980 (Personnel Management System))","31:1341":"31:1341 (31:1341 Government employee--limitations on expending monies)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3702":"31:3702 (31:3702 Procedures for Settling Claims)","31:3713":"31:3713 (31:3713 Priority of Government Claims)","31:3720":"31:3720 (31:3720 Federal Income Tax Interceptions (Collection of Payments))","31:3728":"31:3728 (31:3728 Setoff against Judgment)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 False Claims Act - Procedures)","31:3733(j)":"31:3733(j) (31:3733(j)(2) Pet to Mod or Set Aside CV Investigative Demand)","31:5314":"31:5314 (31:5314 Failure to Report Interest in Foreign Accounts)","31:5317":"31:5317 (31:5317 Search and forfeiture of monetary instruments)","31:5320":"31:5320 (31:5320 Inj proceedings re Rpts of Currency & Foreign Trans.)","31:5321":"31:5321 (31:5321 Civil Penalties re Reports of Currency and Foreign Transaction)","31:5324":"31:5324 (31:5324 Structuring transactions to evade reporting requirement prohibited)","31:5332":"31:5332 (31:5332(a) Evading Currency Reporting Requirement)","31:5332(f)":"31:5332(f) (31:5332(f) Transport and Transfer US currency from in to out)","31:6716":"31:6716 (31:6716 Discrimination re money and finance)","31:9701":"31:9701 (31:9701 Federal User Charge Statute)","33:0408":"33:0408 (33:408 Injury to Harbor Improvement)","33:0412":"33:0412 (33:412 Liability of Pilots and Vessels Engaged in Violations)","33:0594":"33:0594 (33:594 Land Condemnation)","33:0901":"33:0901 (33:901 Longshoremen Harbor Workers Compensation Act (Navigation and Navigable Waters))","33:0905(b)":"33:0905(b) (33:905(b) Longshoremen Workers' Compensation Act - Recovery of Damages cause by the negligence )","33:0918":"33:0918 (33:918 Longshore and Harbor Workers Compensation Act - Collection of Defaulted Payments)","33:0921":"33:0921 (33:921 Longshore & Harbor Workers Compensation Act - Review of Compensation Orders)","33:0933":"33:0933 (33:933 Longshore and Harbor Workers' Compensation Act - Compensation for Injuries (Third-Party )","33:1221":"33:1221 (33:1221 Ports and Waterways Safety Program)","33:1251":"33:1251 (33:1251 Federal Water Pollution Control Act (Clean Water Act))","33:1319(a)":"33:1319(a) (33:1319(a)(2)pv Clean Water Act - Pollutants & Permit Violations)","33:1319cw":"33:1319cw (33:1319cw Clean Water Act - Enforcement)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1321":"33:1321 (33:1321 Clean Water Act - Discharge of hazardous substance or pollutants/water)","33:1361":"33:1361 (33:1361 Clean Water Act - Administrator Authority)","33:1364":"33:1364 (33:1364 Clean Water Act - EPA action to restrain pollution endangering health (emergency powers))","33:1365":"33:1365 (33:1365 Clean Water Act - CItizen Suits re Environmental Matters)","33:1415":"33:1415 (33:1415 Marine Protection, Research, and Sanctuaries Act)","33:1515":"33:1515 (33:1515 Deepwater Ports Act (citizen civil action))","33:2701":"33:2701 (33:2701 Oil Pollution Act of 1940)","35:0001":"35:0001 (35:1 Establishment of PTO)","35:0032":"35:0032 (35:0032 Suspension from Practice before Patent & Trade. Off.)","35:0145":"35:0145 (35:145 Civil Action to Obtain Patent)","35:0146":"35:0146 (35:146 Appeal from Decision of the Board of Patent Appeals)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0256":"35:0256 (35:256 Patent Non-Infringement (Correction of Named Inventor))","35:0271":"35:0271 (35:271 Patent Infringement)","35:0281":"35:0281 (35:281 Remedy for Infringement of Patent/jurisdiction conferred 28:1338)","35:0282":"35:0282 (35:282 Patent Infringement - Defenses)","35:0283":"35:0283 (35:283 Action to enjoin violation of right secured by patent)","35:0289":"35:0289 (35:289 Recover profits from unlicensed use of design patent)","35:0291":"35:0291 (35:291 Action for relief between owners; interferring patents)","35:0292":"35:0292 (35:292 Penalty & Forfeiture; illegal use of word patent (false marking))","35:0311":"35:0311 (35:311 Patent - Request for Inter Partes Reexamination)","35:183":"35:183 (35:183 Right to Compensation - Patent Laws)","38:1100":"38:1100 (38:1100 Basic Entitlements / Wartime)","38:1131":"38:1131 (38:1131 Basic Entitlements / Peacetime)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:1816":"38:1816 (38:1816 Deficiency balance on VA Mortgage Foreclosure (Regulations Governing the VA Loan Guaranty Pr)","38:1965":"38:1965 (38:1965 Servicemen's Group Life Insurance (Definitions))","38:1975":"38:1975 (38:1975 Recovery of Servicemen's Group Life Insurance - Jurisdiction of District Court)","38:1984":"38:1984 (38:1984 Suit for Veterans Insurance)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:3481":"38:3481 (38:3481 Recovery of VA Overpayment)","38:3680":"38:3680 (38:3680 Recovery of Education Assist Allowance Overpayment)","38:4212":"38:4212 (38:4212 Veterans Employment Emphasis Under Federal Contracts)","38:4300":"38:4300 (38:4300 Uniformed Services Employment and Reemployment Act )","38:4301":"38:4301 (38:4301 Uniformed Srvs. Employment & Reemployment Rights Act (purpose))","38:4302":"38:4302 (38:4302 Veterans Reemployment Rights Act (relation to other laws and plans or agreements))","38:4311":"38:4311 (38:4311 Uniformed Service Employment or Reemployment Rights Act (USERRA) - Discrimination)","38:4312":"38:4312 (38:4312 Rights of inducted persons to reemployment)","38:4323":"38:4323 (38:4323 USERAA - Enforcement of rights with respect to state or private employer)","38:4324":"38:4324 (38:4324 USERRA - Enforcement of rights with respect to federal executive agencies)","38:5315":"38:5315 (38:5315 Delinquent Payment of Amounts Due to US)","38:5316":"38:5316 (38:5316 VA Overpayment)","39:0403":"39:0403 (39:0403 Discriminatory use of the Postal Service)","39:0409":"39:0409 (39:0409 Suits by and against the Postal Service)","39:1207":"39:1207 (39:1207 Review Agency Action --Labor Disputes)","39:1208(b)":"39:1208(b) (39:1208(b) Postal Reorganization Act of 1970 - Suits)","39:3005":"39:3005 (39:3005 False Representation and Lotteries)","39:3007":"39:3007 (39:3007 Detention of Mail for Temporary Periods - Injunction directing retention of incoming mail)","39:3008(e)":"39:3008(e) (39:3008(e) Enforce compliance with a USPS Prohibitory Order)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0581":"40:0581 (40:581 General Authority of Administrator of General Services)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:1101":"40:1101 (40:1101 Brooks Architecht - Engineers Act)","40:3131":"40:3131 (40:3131 Bonds of contractors of public buildings)","40:3142":"40:3142 (40:3142 Davis-Bacon Act (prevailing wages))","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","41:2102-21":"41:2102-21 (41:2102-2107 Procurement Integrity Act)","41:3301":"41:3301 (41:3301 Competition in Contracting Act)","41:6503":"41:6503 (41:6503 Walsh-Healy Act - Breach of Public Contract)","41:6702":"41:6702 (41:6702-6704 Service Contract Labor Standards/McNamara-O\"Hara Service Contract Act 1965)","41:6702-67":"41:6702-67 (41:6702-6704)","41:7105(f)":"41:7105(f) (41:7105(f) Action to Judicially Enforce Administrative Subpoena)","42:0205":"42:0205 (42:205 Appointment of Surgeon General)","42:0206":"42:0206 (42:206 Surgeon General - Assignment of Officers)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0254o":"42:0254o (42:254 Breach of Scholarship Contract)","42:0256":"42:0256 (42:256 Public Health Services Act - Grants)","42:0292f":"42:0292f (42:292 Default of borrower)","42:0292k":"42:0292k (42:292 Student loan insurance (Public Health Occupations))","42:0293":"42:0293 (42:293 Recovery of losses from loan guarantee; public health)","42:0297":"42:0297 (42:297 Student loans; public or nonprofit school of nursing)","42:0300aa":"42:0300aa (42:0300 Nat'l Childhood Vaccine Injury Compensation Act)","42:0300f":"42:0300f (42:300 Safe Drinking Water Act (Definitions))","42:0300g":"42:0300g (42:300 Actions re safety of public water systems (EPA))","42:0300g-3":"42:0300g-3 (42:300 Enforcement of Drinking Water Regulations)","42:0401":"42:0401 (42:401 Social Security Act - Trust Funds)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405rs":"42:0405rs (42:405 Review of HHS Decision (RSI))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0421(d)":"42:0421(d) (42:421(d) Review of HHS Decision re disability determinations)","42:0423":"42:0423 (42:423 Social Security Act (Disability Insurance Benefit Payments))","42:0427":"42:0427 (42:427 Social Security Benefits (Transitional Insured Status))","42:0601":"42:0601 (42:601 Title IV-A of the Social Security Act-Grants to States for Aid & Assistance to Needy Families)","42:0602":"42:0602 (42:602 Temp. Assistance for Needy Families (TANF))","42:0660":"42:0660 (42:660 Action to enforce child support obligations)","42:10139":"42:10139 (42:10139 Judicial Review of Agency Actions)","42:10801":"42:10801 (42:10801 Protection & Advocacy for Individuals with Mental Illness Act of 1986 (PAIMI))","42:10805":"42:10805 (42:10805 Protection and Advocacy Systems)","42:11001":"42:11001 (42:11001 Emergency Plan. & Comm. Right to Know Act (EPCRA))","42:11046":"42:11046 (42:11046 Fed Emer Plan Comm Right to Know Act (EPCRA) - Civil actions)","42:11101":"42:11101 (42:11101 Health Care Quality Improvement Act of 1986)","42:11112":"42:11112 (42:11112 Health Care Quality Improvement Act (Standards for Professional Review Actions))","42:11601":"42:11601 (International Child Abduction Remedies Act)","42:11603":"42:11603 (42:11603(b) Int'l. Child Abduction Remedies Act (ICARA) - Judicial Remedies)","42:1210":"42:1210 (42:12100 Americans With Disabilities Act )","42:12101":"42:12101 (42:12101 The Americans with Disabilities Act of 1990)","42:12102":"42:12102 (42:12102 Americans with Disabilities Act (ADA) Disability Definition)","42:12111":"42:12111 (42:12111 Americans with Disabilities Act - Employment)","42:12112":"42:12112 (42:12112 Americans with Disabilities Act - Employment Discrimination)","42:12117":"42:12117 (42:12117 Americans with Disabilities Act - Enforcement)","42:12132":"42:12132 (42:12132 Americans with Disabilities Act - Discrimination)","42:12188":"42:12188 (42:12188 Americans with Disabilities Act - Civil Enforcement Actions)","42:1320a-7":"42:1320a-7 (42:1320(b)(2)(A) Anti-Kickback Act (for federal health care programs))","42:1320d-2":"42:1320d-2 (42:1320 Health Insurance Portability And Accountability Act (HIPAA))","42:1381a":"42:1381a (42:1381 Supplemental Security Income Benefits (SSID))","42:1382":"42:1382 (42:1382 Eligibility for benefits)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 Emergency Medical Treatment and Active Labor Act)","42:1395dd":"42:1395dd (42:1395 Exam & Treatment Emergency Med Cond & Women in Labor)","42:1395hr":"42:1395hr (42:1395 Hospital Reimbursement for Medicare Services)","42:1395w":"42:1395w (42:1395 Medicare Act (Eligibility, Election, and Enrollment))","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1396a":"42:1396a (42:1396 State Plans for Medical Assistance)","42:1396b":"42:1396b (42:1396 Medical Assist Prgm, Pmt to States/Medicaid Implem)","42:13981":"42:13981 (42:13981 Violence Against Women Act )","42:14135":"42:14135 (42:14135 DNA Backlog Grant Program)","42:1437":"42:1437 (42:1437 U.S. Housing Act of 1937)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1475":"42:1475 (42:1475 Declaratory & Injunctive Relief - Foreclosure Procedures)","42:1479":"42:1479 (42:1479 Mortgage, lease, contract re farm housing)","42:14901":"42:14901 (42:14901 Intercountry Adoptions)","42:15483":"42:15483 (42:15483 Help America Vote Act)","42:1651":"42:1651 (42:1651 Defense Base Act)","42:1705":"42:1705 (42:1705 Receipt of Workmen's Compensation Benefits)","42:1971":"42:1971 (42:1971 Voting Rights Law)","42:1973":"42:1973 (42:1973 Voting Rights Act)","42:1973(a)":"42:1973(a) (42:1973(a) Enforcement of Voting Rights)","42:1973(c)":"42:1973(c) (42:1973(c) Voting Rights - Qualifications & Procedures)","42:1973gg":"42:1973gg (42:1973 Nat'l. Voter Registration Act of 1993 (NVRA))","42:1981a":"42:1981a (42:1981 Damages in cases of intentional discrim in employment)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981ra":"42:1981ra (42:1981 Race Discrimination)","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1982hs":"42:1982hs (42:1982 Discrimination re property rights (housing))","42:1982ra":"42:1982ra (42:1982 Discrimination re property rights (race))","42:1982sx":"42:1982sx (42:1982 Discrimination re property rights (sex))","42:1983bv":"42:1983bv (42:1983 Bivens Non-Prisoner)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act - Civil Action for Deprivation of Rights)","42:1983cvp":"42:1983cvp (42:1983 Civil Rights (Personal Property))","42:1983d":"42:1983d (42:1983 Civil Rights (Death))","42:1983dp":"42:1983dp (42:1983 Civil Rights Denial of Due Process)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1983vp":"42:1983vp (42:1983 Violation of Due Process and Equal Protection)","42:1985":"42:1985 (42:1985 Consipracy to interfere with civil rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:1987":"42:1987 (42:1987 Prosecutionof violations of certain laws (violations of sec 1990, 5506, 5516, 5518, 5532))","42:1988":"42:1988 (42:1988 Proceedings in Vindication of Civil Rights)","42:1997":"42:1997 (42:1997 Institutionalized Persons Act of 1980)","42:20002sx":"42:20002sx (42:2000e-2sx)","42:2000a-3":"42:2000a-3 (42:2000 Discrimination, segregation; public accommodation-Injunctive Relief)","42:2000ad":"42:2000ad (42:2000 Job Discrimination (Disability Act))","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000bb":"42:2000bb (42:2000 Religious Freedom Restoration Act of 1993)","42:2000bea":"42:2000bea (42:2000 Equal access to public facilities)","42:2000c-6":"42:2000c-6 (42:2000 Discrimination in Education)","42:2000cc":"42:2000cc (42:2000 Religious Land Use & Institutionalized Persons Act of 2000)","42:2000d":"42:2000d (42:2000 Federally Assisted Programs)","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000e-2":"42:2000e-2 (42:2000 Job Discrimination (Age))","42:2000e-5":"42:2000e-5 (42:2000 Petition to Enforce EEOC Subpoena)","42:2000e2a":"42:2000e2a (42:2000e-2ag)","42:2000e2e":"42:2000e2e (42:2000e-2e)","42:2000e2n":"42:2000e2n (42:2000e-2no)","42:2000e2o":"42:2000e2o (42:2000e-2ot)","42:2000e2p":"42:2000e2p (42:2000e-2pb)","42:2000e2r":"42:2000e2r (42:2000e-2ra)","42:2000e2s":"42:2000e2s (42:2000e-2sh)","42:2000erl":"42:2000erl (42:2000e-2rl)","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Regulations of Indian Hospitals)","42:2005":"42:2005 (42:2005 Financial Assistance to Indian Tribes)","42:2210":"42:2210 (42:2210 Indeminification & Limitation of Liability-Financial)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:2996":"42:2996 (42:2996 Legal Services Corporation Act)","42:3058(g)":"42:3058(g) (42:3058(g) Older American's Act of 1965, 42 USC 3058(g)(State Long-term Care Ombudsman Program))","42:3121":"42:3121 (42:3121 Public Works and Economic Development Act of 1965)","42:3133":"42:3133 (42:3133 Coordination-Grants for Public Works and Economic Development)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:3604(f)":"42:3604(f) (42:3604(f)(3)(c) Fair Housing Amendments Act)","42:3610":"42:3610 (42:3610 Fair Housing Act-Administrative Enforcement; Preliminary Matters)","42:3612":"42:3612 (42:3612 Civil Rights in housing-Enforcement by Secretary)","42:3613":"42:3613 (42:3613 Action for inj relief re deprivation of civil rights)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4013":"42:4013 (42:4013 National Flood Insurance Act-Nature and Limitation of Insurance Coverage)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:4721":"42:4721 (42:4721 Intergovernmental Personnel Act (findings and purposes))","42:4821":"42:4821 (42:4821 Lead-Based Paint Poisoning Prevention Act (findings and purposes))","42:4901":"42:4901 (42:4901 Noise Control Act of 1972 (findings and purpose))","42:4910(c)":"42:4910(c) (42:4910(c) Action to restrain violation re noise control)","42:5101":"42:5101 (42:5101 Child Abuse Prevention and Treatment Act)","42:5303":"42:5303 (42:5303 Block Grant Act of 1974 (42 USC 5301-5321))","42:5401":"42:5401 (42:5401 Natl Mnfactrd Housing Cnstr Safety Standard Act of 1974 (findings and purposes))","42:5411":"42:5411 (42:5411 Housing Construction and Safety Standards Act-Injunctive Relief)","42:5851":"42:5851 (42:5851 Discrimination \"Whistle Blower\" Employee-ERA (employee protection))","42:6101":"42:6101 (42:6101 Age Discrimination in Federally Assisted Programs (statement of purpose))","42:6201":"42:6201 (42:6201 Energy Policy & Conservation Act (statement of purpose))","42:6393":"42:6393 (42:6393 Controversies under Energy Policy & Conservation Act (Admin Procedure and Judicial Review))","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:6928":"42:6928 (42:6928 Violations of requirements of hazardous Waste Mgmt (federal enforcement))","42:6961":"42:6961 (42:6961 Federal Facilities Compliance Act)","42:6972":"42:6972 (42:6972 Resource & Recovery Act-Citizen Suit)","42:6972(a)":"42:6972(a) (42:6972(a) Solid Waste Disposal Act-Citizen Suit)","42:7192":"42:7192 (42:7192 Controversies under Dept of Energy Organization Act-Judicial Review)","42:7384":"42:7384 (42:7384 Energy Employees Occupational Illness Compensation Program Act (EEOICPA))","42:7401":"42:7401 (42:7401 Clean Air Act (findings & declarations))","42:7412":"42:7412 (42:7412 Air Pollution Control-emission standards)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7413(b)":"42:7413(b) (42:7413(b) Clean Air Act-Enforcement)","42:7475":"42:7475 (42:7475 Clean Air Act-Preconstruction Requirements)","42:7545":"42:7545 (42:7545 Air Pollution Prevention (Regulation of Fuels))","42:7603":"42:7603 (42:7603 Action for immediate restraint (Emergency Powers))","42:7604":"42:7604 (42:7604 Clean Air Act - Citizen suit to enforce Clean Air Act)","42:7604(f)":"42:7604(f) (42:7604(f) Clean Air Act - Emission Standards)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:7671":"42:7671 (42:7671 Clean Air Act (Stratospheric Ozone Protection) (Definitions))","42:8324":"42:8324 (42:8324 Powerplant and Industrial Fuel Use - terms and conditions)","42:8351":"42:8351 (42:8351 Powerplant and Industrial Fuel Use - Temporary Exemptions)","42:9601":"42:9601 (42:9601 Comprehensive Environmental Compen/Resp/Liab (CERLA) (Definitions))","42:9604":"42:9604 (42:9604 Comprehensive Envir., Response, Comp. & Liab. Act (CERCLA)-Removal and Other Remedial Action)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","42:9613":"42:9613 (42:9613 Comp Environ Recovery Comp & Liability Act (CERCLA) - Civil Proceedings)","43:0945a":"43:0945a (43:945a Compensation for Land Condemnation)","43:0946":"43:0946 (43:946 Complaint in Condemnation - Right of Way for Irrigation and Drainage Projects)","43:1331":"43:1331 (43:1331 Outer Continental Shelf Lands Act (Definitions))","43:1333":"43:1333 (43:1333 Outer Continental Shelf Lands Act - Citizen Suits)","43:1701":"43:1701 (43:1701 Violation of Federal Land Policy and Management Act (FLPMA))","43:1737":"43:1737 (43:1737 FLPMA - Implementation Provisions)","43:421":"43:421 (43:421 Complaint in Condemnation- Eminent Domain)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","44:2107":"44:2107 (44:2107 Presidential Recordings and Materials Act (NARA acceptance of records for historical preserv)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0056":"45:0056 (45:56 Employers Liability Act - Personal Inj re Railroads (bringing an action))","45:0151":"45:0151 (45:151 Railway Labor Act (Definitions))","45:0152":"45:0152 (45:152 Railway Labor Act - General Duties)","45:0153":"45:0153 (45:153 First Railway Labor Act - National Railroad Adjustment Board)","45:0159":"45:0159 (45:159 Review of arbitration award (RR Carriers/Mediation Bd))","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:0231(f)":"45:0231(f) (45:0231(f) Compel obediance to order of Railroad Retirement Bd)","45:0351":"45:0351 (45:351 Railroad Unemployment Insurance Act)","45:0719":"45:0719 (45:719 Regional Rail Reorganization Act of 1973 (judicial review))","45:1105":"45:1105 (45:1105 Northeast Rail Service Act - Judicial Review)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0151":"46:0151 (46:151 Federal Communications Act of 1934)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:2114":"46:2114 (46:2114 Wrongful Discharge from Employment - protection from discrimination)","46:30101":"46:30101 (46:3010 Extension of jurisdiction to cases or damage or injury on land)","46:30104":"46:30104 (46:30104 Marine Personal Injury - Jones Act)","46:30302":"46:30302 (46:30302 Shipping: Damages for Death on High Seas)","46:30304":"46:30304 (46:30304 Breach of Maritime Contract - liability of noncompliance)","46:30503":"46:30503 (46:30503 Limitation of Liability - declaration of nature and value of goods)","46:30504":"46:30504 (46:30504 Limitation of Liability - loss by fire)","46:30511":"46:30511 (46:30511 Action by owner for limitation)","46:30701":"46:30701 (46:30701 Marine Cargo Loss or Damage - Loading, stowage, custody, care, and deliver)","46:30704":"46:30704 (46:30704 Liability of Water Carriers - Loading, stowage, custody, care, and delivery)","46:30902":"46:30902 (46:30902 to 30911 Suits in Admirality Act)","46:31102":"46:31102 (46:31102 Public Vessels Act - Waiver of Immunity)","46:31301":"46:31301 (46:31301 Federal Maritime Lien Act)","46:31321":"46:31321 (46:31321 Foreclosure of Preferred Ship Mortgages)","46:31325":"46:31325 (46:31325 Suit to enforce lien upon mortgaged vessel-foreclosure/Foreclosure of Preferred Foreign Shi)","46:31341":"46:31341 (46:31341 Federal Maritime Lien Act)","46:31343":"46:31343 (46:31343 Commercial Instruments & Maritime Liens)","46:4010":"46:4010 (46:4010 Shipping Act of 1998)","46:41102(a":"46:41102(a (46:41102(a) Shipping Act of 1984 - General Prohibitions)","46:41309":"46:41309 (46:41309 Shipping Act of 1984 - Enforcement of Reparation Orders)","46:50101":"46:50101 (46:50101 Violation of Maritime Regulations)","46:58109":"46:58109 (46:58108 Violation of Merchant Marine Act - Penalties)","47:0151cs":"47:0151cs (47:151cs Federal Coummunications Act - Collection for Services)","47:0201bt":"47:0201bt (47:201bt Breach of Tariff)","47:0203":"47:0203 (47:203 Telecommunications Collection of Charges)","47:0205":"47:0205 (47:205 Wire and Radio Communication Svc and Charges(Recovery of Damages))","47:0206":"47:0206 (47:206 Carrier's Liability for Damages)","47:0227":"47:0227 (47:227 FCC-Unsolicited Telephone Sales)","47:0227(b)":"47:0227(b) (47:227(b)(3) Telephone Consumer Protection Act of 1991)","47:0251":"47:0251 (47:251 Telecommunications Act of 1996 - Interconnection)","47:0252":"47:0252 (47:252 Telecommunications Act)","47:0254(h)":"47:0254(h) (47:254(h) Children's Internet Protection Act)","47:0332":"47:0332 (47:332 FCA-Wire or Radio Communications (Mobile Services))","47:0332(c)":"47:0332(c) (47:332(c) Federal Telecommunications Act of 1996)","47:0401":"47:0401 (47:401 Application of Federal Communication Comm for Inj. (Enforcement Provisions))","47:0407":"47:0407 (47:407 Order for paymnet of money; petition for enforcement)","47:0510":"47:0510 (47:510 Forfeiture of Communications Devices)","47:0521":"47:0521 (47:521 Cable Televsn. Consumer Protection & Competition Act of 1992)","47:0532":"47:0532 (47:532 Cable Communication Policy Act of 1984)","47:0551":"47:0551 (47:551 Cable Communications Act)","47:0553":"47:0553 (47:553 U.S.C.A. Cable Communications Policy Act)","47:0605":"47:0605 (47:605 Unlawful Reception Broadcase Signal i.e., Satellite - Theft of Satellite Communications)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0101":"49:0101 (49:101 ICC Termination Act of 1996)","49:0502":"49:0502 (49:502 Transportation Administration Subpoena)","49:0781":"49:0781 (49:781 Forfeiture)","49:0945b":"49:0945b (49:945b Complaint in Condemnation - Easements)","49:10101":"49:10101 (49:10101 Interstate Commerce Act - Interstate Transportation Rail)","49:10743":"49:10743 (49:10743 Revised Interstate Commerce Act)","49:11101":"49:11101 (49:11101 Interstate Commerce Act)","49:1113":"49:1113 (49:1113 Petition to enforce administative summon)","49:1136":"49:1136 (49:1136 Aviation Disaster Family Assistance Act of 1996)","49:11501":"49:11501 (49:11501 Railroad Revitalization & Regulatory Act (General Jurisdiction))","49:11502":"49:11502 (49:11502 Railroad Revitalization Regulatory Reform (authority to exempt rail carrier transportation))","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11701":"49:11701 (49:11701 General authority of enforcement of regulations in rail)","49:11702":"49:11702 (49:11702 Enforcement by the Board)","49:11705":"49:11705 (49:11705 Limitation on actions by and against rail carriers)","49:11706":"49:11706 (49:11706 Carmack Amendment (Liability of carriers under receipts and bills of lading))","49:11707":"49:11707 (49:11707 Carmack Amendment (Liability when property is delivered in violation of routing instruction)","49:13101":"49:13101 (49:13101 Transportation Policy)","49:13702":"49:13702 (49:13702 Tariff requirement for certain transportation)","49:13706":"49:13706 (49:13706 Motor Carriers etc. - Liability for Payment of Rates)","49:14501":"49:14501 (49:14501 Preemption (Federal authority of intrastate transportation))","49:14705":"49:14705 (49:14705 Interstate Commerce Act/Carmack Amendment (Limitations on actions by and against carriers))","49:14706":"49:14706 (49:14706 Carmack Amendment to the Interstate Commerce Act/Liability of Carriers - Receipts & Bills)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","49:20301":"49:20301 (49:20301 Federal Safety Appliance Act)","49:20302":"49:20302 (49:20302 Federal Safety Appliance Act)","49:20303":"49:20303 (49:20303 Federal Safety Appliance Act)","49:20304":"49:20304 (49:20304 Federal Safety Appliance Act)","49:20305":"49:20305 (49:20305 Federal Safety Appliance Act)","49:20306":"49:20306 (49:20306 Federal Safety Appliance Act)","49:21302":"49:21302 (49:21302 Carriers violations of Interstate Commerce Act Chapter 201 accident and incident violations)","49:30101":"49:30101 (49:30101 National Traffic and Motor Vehicle Safety Act)","49:30112":"49:30112 (49:30112 Motor Vehicle Safety (prohibition on non-complying motor vehicles and equipment))","49:30502":"49:30502 (49:30502 Natl Motor Vehicle Title Information Syst)","49:31114":"49:31114 (49:31114 Access to Interstate System/Commercial Motor Vehicle)","49:31502":"49:31502 (49:31502 Motor Carrier Safety - Requirements for Qualifications)","49:32101":"49:32101 (49:32101 Motor Vehicle Information and Costs Savings Act)","49:32701":"49:32701 (49:32701 Odometer Requirements Act)","49:40101":"49:40101 (49:40101 Federal Aviation Act)","49:40102":"49:40102 (49:40102 Airline Deregulation Act (definitions of air and commerce safety))","49:40105":"49:40105 (49:40105 Warsaw Convention)","49:41705":"49:41705 (49:41705 Air Carrier Access Act (discrimination against handicapped indiciduals))","49:41713":"49:41713 (49:41713 Airline Deregulation Act (premp of authority over prices, routes and service))","49:44709":"49:44709 (49:44709 Noise Control Act of 1972)","49:44715":"49:44715 (49:44715 Noise Control Act of 1972)","49:46507":"49:46507 (49:46507 False Information and Threats)","49:47101":"49:47101 (49:47101 Airport and Airway Improvement Act of 1982)","49:47501":"49:47501 (49:47501 Aviation Safety & Noise Abatement Act of 1979)","49:49101":"49:49101 (49:49101 Wrongful Termination in Contravention of Published Regulations)","49:49104":"49:49104 (49:49104 Breach of Lease by Metro. Wash. Airport Auth.)","49:60101":"49:60101 (49:60101 Pipeline Safety Act of 1994)","49:60102":"49:60102 (49:60102 Hazardous Liquid Pipeline Safety Act of 1979 (HLPSA))","49:80102":"49:80102 (49:80102 Bills of Lading - Application)","49:80302":"49:80302 (49:80302 Contraband - Prohibitions)","49:80303":"49:80303 (49:80303 Seizure and forfeiture of vessel or aircraft conveying contraband)","50:0001":"50:0001 (50(a):0001 Trading With the Enemy Act (act located in Title 50, Appendix))","50:0501":"50:0501 (50(a):501 Sailors and Soldiers Civil Relief Act (act located in Title 50, Appendix))","50:0533":"50:0533 (50(a):533 Servicemembers Civil Relief Act - Mortgages (act located in Title 50, Appendix))","50:0540":"50:0540 (50(a):540 Sailors and Soldiers Civil Relief Act (act located in Title 50, Appendix))","50:1701":"50:1701 (50:1701 International Emergency Economic Powers Act)","50:1702":"50:1702 (50:1702 International Emergency Economic Powers Act)","50:1703":"50:1703 (50:1703 International Emergency Economic Powers Act)","50:1704":"50:1704 (50:1704 International Emergency Economic Powers Act)","50:1705":"50:1705 (50:1705 International Emergency Economic Powers Act)","50:1706":"50:1706 (50:1706 International Emergency Economic Powers Act)","50:2412":"50:2412 (50(a):2412 Export Administration Act - 1979 (act located in Title 50, Appendix))","51:20137":"51:20137 (51:20137(a) Malpractice and Negligence Against U.S. Space program)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"iasdce":{"0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown )","02:0138":"02:0138 (02:0138 Library of Congress Access)","02:0358":"02:0358 (02:0358 President's Recommendations on Exec., Jud. & Leg. Salary)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","02:0681":"02:0681 (02:0681 Deferral of Budget Authority)","02:1202":"02:1202 (02:1202 Discriminatory practices affecting US Senate employees)","02:1301":"02:1301 (02:1301 Congressional Accountability Act)","02:1317(a)":"02:1317(a) (02:1317(a) Violation of Congressional Accountability Act)","05:0101":"05:0101 (05:0101 Ethics in Government Act)","05:0504(c":"05:0504(c (05:0504(c )(2) Equal Access to Justice (Govt Employees))","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552b(g":"05:0552b(g (05:0552b(g)sa Implement requirements of Govt in Sunshine Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0555(b)":"05:0555(b) (05:0555(b) Agency Decision - Right to Counsel )","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:0706":"05:0706 (05:0706 Judicial Review of Agency Action)","05:1508":"05:1508 (05:1508 Judicial Review of Order Issued by the Merit Systems Protection Board)","05:2302":"05:2302 (05:2302 Federal Whistleblowing Act / Civil Service Reform Act (CSRA))","05:3318":"05:3318 (05:3318 Veterans Preference Act)","05:5514":"05:5514 (05:5514 Debt Collection Act of 1982)","05:5542":"05:5542 (05:5542 Federal Employees Pay Act -- overtime rates)","05:7101":"05:7101 (05:7101 Labor-Management Relations (Findings and Purpose))","05:7123":"05:7123 (05:7123 Petition by FLRA against unfair labor practices)","05:7501":"05:7501 (05:7501 Government Employees Adverse Action--14 days or less)","05:7511":"05:7511 (05:7511 Government Employees Adverse Action--Over 14 days)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8101":"05:8101 (05:8101 Workmen's Compensation Benefits)","05:8110":"05:8110 (05:8110 Augmented Compensation for dependents of Govt. Employees)","05:8316":"05:8316 (05:8316 Claims agst US re Retirement for Federal Emp.)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","05:8701":"05:8701 (05:8701 Federal Employees Group Life Insurance Act of 1954)","05:8705":"05:8705 (05:8705 Declaratory Judgment - Insurance)","05:8715":"05:8715 (05:8715 Claims against the US - Jurisdiction of Courts)","05:8901":"05:8901 (05:8901 Federal Employees Health Benefits Act)","05:8902":"05:8902 (05:8902 Contracting Authority of OPM - Group Health Insurance )","05:8903":"05:8903 (05:8903 Federal Employees Health Benefit Act)","05:8912":"05:8912 (05:8912 Claims agst US re health benefits for Federal emp.)","07:0001":"07:0001 (07:0001 Commodity Exchange Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0006(b)":"07:0006(b) (07:0006(b) Federal Commodity Exchange Regulation)","07:0009a":"07:0009a (07:0009a Recovery of penalties by Commodity Futures Trading Com)","07:0013a":"07:0013a (07:0013a Contract market rules violations; recovery of penalty)","07:0013a-1":"07:0013a-1 (07:0013a-1 Enjoin or restrain violations Contract Market rules)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0087":"07:0087 (07:0087 Enforcement of United States Grain Standards Act)","07:0136":"07:0136 (07:0136 Violations of EPA re Environmental Pesticide Control)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0193(b)":"07:0193(b) (07:0193(b) Recovery of penalties re violations by packers)","07:0203":"07:0203 (07:0203 Recovery of penalties for violations by stockyards)","07:0209(b)":"07:0209(b) (07:0209(b) Violations re purchase, sale, handling of livestock)","07:0210(f)":"07:0210(f) (07:0210(f) Suit to enforce award of damages (Packers/Stockyards))","07:0213(b)":"07:0213(b) (07:0213(b) Unfair, discriminatory, deceptive practice/marketing)","07:0216":"07:0216 (07:0216 Injunctions to restrain & enforce orders of Secretary)","07:0222":"07:0222 (07:0222 Adoption of FTC powers for enforcement.)","07:0228a":"07:0228a (07:0228a Request by Secretary for TRO or Inj. re Poultry)","07:0245":"07:0245 (07:0245 Action on bond by person injured in Warehouse)","07:0292":"07:0292 (07:0292 Monopolizing or restraining trade & enhancing prices)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0499E(c":"07:0499E(c (07:0499E(c )(4) Perishable Agricultural Commodities Act (PACA))","07:0601":"07:0601 (07:601 USDA Condemnation)","07:0608":"07:0608 (07:0608 Agriculture Adjustment Act)","07:0901":"07:0901 (07:0901 Rural Electrification Act)","07:1291(b)":"07:1291(b) (07:1291(b) Agricultural Adjustment Act; freight rates.)","07:1376":"07:1376 (07:1376 Adjustment of Quotas and Enforcement; penalties.)","07:1501":"07:1501 (Federal Crop Insurance Act )","07:1508":"07:1508 (07:1508 Crop Insurance)","07:1631":"07:1631 (07:1631 Food Security Act)","07:1721":"07:1721 (07:1721 Agricultural Trade Development Asst Act)","07:1922":"07:1922 (07:1922 Persons Eligible for Loans - Forclosure)","07:1926":"07:1926 (07:1926 Water and Waste Facility Loans and Grants)","07:1930":"07:1930 (07:1930 Perishable Agric. Comm. Act of 1930)","07:2011":"07:2011 (07:2011 Supplemental Nutrition Assistance Program)","07:2022":"07:2022 (07:2022 Disposition of Claims: Denial application to participate; food stamp prog.)","07:2023(a)":"07:2023(a) (07:2023(a) Judicial Review of Food Stamp Disqualification)","07:2024":"07:2024 (07:2024 False Claims Act, Food Stamp Fraud)","07:2131":"07:2131 (07:2131 Violation of the Animal Welfare Act)","07:2146":"07:2146 (07:2146 Transportation, Sale, and Handling of Animals)","07:2301":"07:2301 (07:2301 Agricultural Fair Practices Act)","07:2305":"07:2305 (07:2305 Unfair trade practices affecting producers Agri prod)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","07:2563":"07:2563 (07:2563 Plant Variety Protection and Rights - Injunction)","07:6999":"07:6999 (07:6999 Judicial Review of Adverse Farm Agency Decision)","08:1101":"08:1101 (08:1101 Immigration & Nationality Act (Definitions))","08:1105(a)":"08:1105(a) (08:1105(a)Immigration: Judicial Review for Battered Spouses; Deportation (INS))","08:1151":"08:1151 (08:1151 Immigration and Nationality Act of 1952)","08:1152":"08:1152 (08:1152 Immigration: Numerical limitations on individual foreign states)","08:1153":"08:1153 (08:1153 Immigration: Allocation of Immigrant Visas)","08:1154":"08:1154 (08:1154 Immigration: Procedure for Granting Immigration Status)","08:1158":"08:1158 (08:1158 Immigration & Nationality Act, Section 208 (Asylum))","08:1182":"08:1182 (08:1182 Inadmissible Aliens: Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1183":"08:1183 (08:1183 Admission of Aliens on Giving Bond or Undertaking; Return on Departure)","08:1188":"08:1188 (08:1188 Immigration: Admission of Temporary H-2A Workers)","08:1225":"08:1225 (08:1225 Immigration: Enforcement of Administrative Subpoena)","08:1231(a)":"08:1231(a) (08:1231(a)(6) Immigration: Due Process Clause)","08:1251(A)":"08:1251(A) (08:1251(A)(4) Immigration: Application for a Stay of Deportation)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1255":"08:1255 (08:1255 Immigration: Failure USCIS To Adjudicate Permanent Residency Petition)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1357":"08:1357 (08:1357 Immigration and Nationality Act - Administrative Search Warrant)","08:1421":"08:1421 (08:1421 Immigration: Naturalization Authority)","08:1445":"08:1445 (08:1445 Immigration: Application for Naturalization)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1447":"08:1447 (08:1447 Immigration: Review of Denial of Naturalization Application)","08:1451":"08:1451 (08:1451 Immigration: Revocation of Citizenship)","08:1451(a)":"08:1451(a) (08:1451(a) Action to revoke Citizenship)","08:1451(j)":"08:1451(j) (08:1451(j) Immigration: Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0003":"09:0003 (09:0003 Application to Stay Proceedings Pending Arbitration)","09:0004":"09:0004 (09:0004 Petition to order arbitration; failure to arbitrate)","09:0007":"09:0007 (09:0007 Petition to compel attendance before arbitrator)","09:0008":"09:0008 (09:0008 Declaratory Judgment/Admiralty)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","09:0011":"09:0011 (09:0011 Motion to modify or correct arbitration award)","09:0201":"09:0201 (09:0201 Petition to Compel/Stay Arbitration under an Insurance Contract)","09:0202":"09:0202 (09:0202 Award under Convention on Foreign Arbitral Awards)","09:0205":"09:0205 (09:0205 Removal from State Court: Enforcement of Foreign Arbital Awards)","09:0207":"09:0207 (09:0207 Application for order confirming award of arbitrators)","10:0672":"10:0672 (10:0672 Armed Forces: Active Guard/Reserve (AGR) Program)","10:1006":"10:1006 (10:1006 Armed Forces: Review of Agency Decision)","10:1072tc":"10:1072tc (10:1072tc Armed Forces: TRICARE PROGRAM)","10:1089(c":"10:1089(c (10:1089(c ) Armed Forces: Removal; dft acting in scope of duties)","10:1091":"10:1091 (10:1091 Armed Forces: Personal Service Contracts)","10:1107":"10:1107 (10:1107 Armed Forces: Use Of Investigational New Drug)","10:1408":"10:1408 (10:1408 Armed Forces: Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2005":"10:2005 (10:2005 Armed Forces: Advanced Education Assistance)","10:2121":"10:2121 (10:2121 Armed Forces: Health Professions Scholarship Financial Asst Prog)","10:2302":"10:2302 (10:2302 Armed Forces: Arms Services Procurement Act)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","10:2323fa":"10:2323fa (10:2323fa Armed Forces: Fifth Amendment Equal Protection: Contract Goal for Small Disadvantaged Bus)","10:2733":"10:2733 (10:2733 Armed Forces: Military Claims Act)","10:2734":"10:2734 (10:2734 Armed Forces: Foreign Military Claims Act)","10:2771":"10:2771 (10:2771 Armed Forces: Final Settlement - Deceased Members)","10:3258":"10:3258 (10:3258 Armed Forces: Reg.Army: Re-enlistment after Service as Ofcr)","11:0101":"11:0101 (11:101 Bankruptcy)","11:0110":"11:0110 (11:0110 Bankruptcy: Penalty for Preparers of Fraudulent or Negligent Petitions)","11:0362(h)":"11:0362(h) (11:0362(h) Bankruptcy: Violation of Automatic Stay)","11:0523":"11:0523 (11:0523 Bankruptcy: Exceptions to Discharge)","11:0524":"11:0524 (11:0524 Bankruptcy: Effect of Discharge)","11:0525":"11:0525 (11:0525 Bankruptcy: Protections Against Discriminatory Treatment )","11:0548":"11:0548 (11:0548 Bankruptcy: Fraudulent Transfers and Obligations)","11:0704":"11:0704 (11:0704 Bankruptcy: Duties of Trustee)","11:Appendi":"11:Appendi (11:Appendix Bankruptcy Appeal - this refers to rule 8001, not section 8001)","12:0085":"12:0085 (12:0085 National Banks: Rate of Interest on Loans, Discounts, and Purchases)","12:0093(a)":"12:0093(a) (12:0093(a) National Banks: Violation of Provisions; Forfeiture of Franchise; Personal Liability of )","12:0191":"12:0191 (12:0191 National Banks: Appointment of Receiver)","12:0192":"12:0192 (12:0192 National Banks: Liquidation of National Bank)","12:0215":"12:0215 (12:0215 National Banks: Consolidation and Merger)","12:0622":"12:0622 (12:0622 Foreign Banking: Forfeiture, Dissolution, and Liability of Directors and Officers for Nonco)","12:0632":"12:0632 (12:0632 Foreign Banking: Voluntary Liquidation)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:0635i-3":"12:0635i-3 (12:0635i-3 Export-Import Bank: Breach of Insurance Contract)","12:1421":"12:1421 (12:1421 Federal Home Loan Bank Act (Short Title))","12:1441":"12:1441 (12:1441 FHLB: Financial Inst Reform Receiving Enforcement Act 1989)","12:1451":"12:1451 (12:1451 Emergency Home Loan Corporation (Definitions))","12:1452":"12:1452 (12:1452 Federal Home Loan Mortgage Corporation Act)","12:1452(f)":"12:1452(f) (12:1452(f) Fed Home Loan Mortgage Corp: Actions by and against the Corporation)","12:1455(b)":"12:1455(b) (12:1455(b) Fed Home Loan Mortgage Corp: Enforcement of Regulations)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Savings Associations: Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1715(b)":"12:1715(b) (12:1715(b) National Housing: Rules and Regulations)","12:1749aaa":"12:1749aaa (12:1749aaa National Housing: National Insurance Development Program)","12:1751":"12:1751 (12:1751 Fed Credit Unions: Short Title)","12:1782":"12:1782 (12:1782 Fed Credit Unions: Administration of Insurance Fund)","12:1786":"12:1786 (12:1786 Fed Credit Unions: Actions re Violations by Credit Unions)","12:1787(a)":"12:1787(a) (12:1787(a)(B) Fed Credit Unions: Liquidation of Insured Credit Union by Board)","12:1789(a)":"12:1789(a) (12:1789(a)(2) Fed Credit Unions: Admin Provision to Sue and be Sued)","12:1811":"12:1811 (12:1811 FDIC: Financial Inst. Reform Recovery Act of 1989 (FIRREA) (Organization of FDIC))","12:1818":"12:1818 (12:1818 FDIC: Violations re Federal Deposit Insurance Corporation)","12:1818(e)":"12:1818(e) (12:1818(e) FDIC: Suspension or Removal of Bank Officer)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1831":"12:1831 (12:1831 FDIC: Separability of Certain Provisions)","12:1831(d)":"12:1831(d) (12:1831(d) FDIC: Deposit. Inst. Dereg. & Monetary Ctrl. Act of 1980)","12:1831r-1":"12:1831r-1 (12:1831r-1 FDIC: Notice of Branch Closure)","12:1833(a)":"12:1833(a) (12:1833(a) FDIC: Forfeiture Civil Penalties)","12:1954":"12:1954 (12:1954 Injunctions (Action by Sec of Treasury re financial recordkeeping))","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Tying Arrangement Act)","12:2001":"12:2001 (12:2001 Farm Credit Act of 1971)","12:2601":"12:2601 (12:2601 Real Estate Settlement Procedures Act (RESPA) (findings & purpose))","12:2604(c":"12:2604(c (12:2604(c ) Real Estate Settlement Procedures Act (RESPA))","12:2605":"12:2605 (12:2605 RESPA: Servicing of Mortgage Loans)","12:2607":"12:2607 (12:2607 RESPA: Violation re kickbacks/unearned fees; Real Estate)","12:2609":"12:2609 (12:2609 RESPA: Escrow)","12:3012":"12:3012 (12:3012 National Consumer Cooperative Bank: Suits by or against Bank)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","12:3751":"12:3751 (12:3751 Single Family Mortgage Forclosure Act: Findings and Purpose)","12:3801":"12:3801 (12:3801 Alternative Mortgage Transaction Parity Act)","12:3907":"12:3907 (12:3907 International Lending Supervision: Capital Adequacy)","12:4010":"12:4010 (12:4010 Expedited Funds Availability: Violation of Act (Civil Liability))","12:5101":"12:5101 (12:5101 Fraudulent Transfer Act (Enforcement for Mortgage Licensing))","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0004":"15:0004 (15:0004 USDC Jurisdiction re violations of Sec. 1-7 of Title 15)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0009":"15:0009 (15:0009 USDC Jurisdiction re violations of Sec. 8 of Title 15)","15:0013":"15:0013 (15:0013 Robinson Patman Act)","15:0014":"15:0014 (15:0014 Clayton Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0026":"15:0026 (15:0026 Suit for injunctive relief re violation antitrust laws)","15:0041":"15:0041 (15:0041 Federal Trade Commission Act)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act (unfair or deceptive acts))","15:0045cp":"15:0045cp (15:0045cp Violation of Children Online Privacy Protection Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0068":"15:0068 (15:0068 Proceedings re FTC violations re wool products)","15:0069":"15:0069 (15:0069 Proceedings re FTC violations re fur products)","15:0070":"15:0070 (15:0070 Proceedings re FTC violations re textile fiber product)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0078j(b":"15:0078j(b (15:0078j(b)ss Stockholder Suit)","15:0078m(a":"15:0078m(a (15:0078m(a) Securities Exchange Act)","15:0079":"15:0079 (15:0079 Public Utility Holding Companies)","15:0080a-3":"15:0080a-3 (15:0080a-3 Investment Company Act of 1940)","15:0260":"15:0260 (15:0260 Proceedings re weights and measures and standard time)","15:0298":"15:0298 (15:0298 Violation of Law Proceedings re gold or silver)","15:0433":"15:0433 (15:0433 Discrimination against farmers)","15:0631":"15:0631 (15:631 Small Business Act)","15:0636":"15:0636 (15:0636 Small Business Act - Aid to small business)","15:0661":"15:0661 (15:0661 Small Business Investment Act of 1958)","15:0687":"15:0687 (15:0687 Small Business Investment Program)","15:0714(b)":"15:0714(b) (15:0714(b) Commodity Credit Corporation)","15:0715(f)":"15:0715(f) (15:0715(f) Proceedings re petroleum and petroleum products)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0719i(c":"15:0719i(c (15:0719i(c ) Civil actions re violations or inj involving Gas)","15:0766":"15:0766 (15:0766 Controversies arising re Federal Energy Admin. rules)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1071":"15:1071 (15:1071 Appeal of Decision of U.S. Patent & Trademark Office (Comm / Trademark Trial Bd))","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1116":"15:1116 (15:1116 Inj to prevent violation rights of trademark owner)","15:1120":"15:1120 (15:1120 Trademark - False or Fraudulent Registration)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1125(a)":"15:1125(a) (15:1125(a) False representation of goods sold in interstate commerce)","15:1125(d)":"15:1125(d) (15:1125(d)ac Trademark (Anticybersquatting consumer protection))","15:1125la":"15:1125la (15:1125la Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1191":"15:1191 (15:1191 Flamable Fabrics Act)","15:1221":"15:1221 (15:1221 Auto Dealer Suits Agst Manufacturers)","15:1261":"15:1261 (15:1261 Hazardous Substances (definitions))","15:1263":"15:1263 (15:1263 Prohibited Hazardous Substance - Interstate Commerce)","15:1267(a)":"15:1267(a) (15:1267(a) Federal Hazardous Substances Act)","15:1314":"15:1314 (15:1314 Antitrust--Petition for enforcement)","15:1501":"15:1501 (15:1501 Estab of Dept of Commerce)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1605":"15:1605 (15:1605 Determination of Finance Charge)","15:1638":"15:1638 (15:1638 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1666":"15:1666 (15:1666 Fair Credit Billing Act Dispute)","15:1667":"15:1667 (15:1667 Consumer Leasing Act)","15:1679":"15:1679 (15:1679 Violation of Credit Repair Organizations Act)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1691":"15:1691 (15:1691 Equal Credit Opportunity Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693ef":"15:1693ef (15:1693ef Electronic Funds Transfer Act)","15:1693m":"15:1693m (15:1693m Violation of Prov. of Subchpt.VI (Electronic Fund Transfers))","15:1701":"15:1701 (15:1701 Interstate Land Sales Full Disclosure Act (ILFFDA))","15:1709":"15:1709 (15:1709 Interstate Land Sales )","15:1714":"15:1714 (15:1714 Actions to enjoin violations re interstate land sale)","15:2071":"15:2071 (15:2071 Consumer Product Safety; Condemnation hazardous prod)","15:2073":"15:2073 (15:2073 Private action to enforce Consumer Product Safety)","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2310(c":"15:2310(c (15:2310(c ) Consumer Product Warranties)","15:2601":"15:2601 (15:2601 Toxic Substances Control Act (TCSA))","15:2604":"15:2604 (15:2604 Application for inj re distribution toxic substance)","15:2616":"15:2616 (15:2616 Toxic Substance control; seizure of chemical)","15:2620":"15:2620 (15:2620 Toxic Substances Control Act: citizen's petition)","15:2651":"15:2651 (15:2651 Asbestos Hazard Emergency Response Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:2805":"15:2805 (15:2805 Petroleum Marketing Practices-Franchise Protection)","15:34-35":"15:34-35 (15:34-35 Investment Company Act of 1940 )","15:3414":"15:3414 (15:3414 National Gas Policy Act)","15:3710a":"15:3710a (15:3710a Federal Technology Transfer Act of 1986)","15:3901":"15:3901 (15:3901 Federal Risk Retention Act)","15:45":"15:45 (15:45 Federal Trade Commission Act (unfair or deceptive acts))","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","15:6801":"15:6801 (15:6801 Gram-Leach-Bliley Act)","15:7701":"15:7701 (15:7701 Federal CAN-Spam Act)","16:0019jj":"16:0019jj (16:0019jj Park System Resource Protection Act)","16:0470":"16:0470 (16:0470 Archaeological resources Protection Act)","16:0470f":"16:0470f (16:0470f National Historic Preservation Act)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0669":"16:0669 (16:0669 Pittman-Robertson Conservation Restoration Act)","16:0675":"16:0675 (16:0675 Norbeck Wildlife Preserve Organic Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:0823a":"16:0823a (16:0823a Federal Public Utility Regulatory Policies Act)","16:0825":"16:0825 (16:0825 Federal Power Commission Regulation; Public Utilities)","16:0831":"16:0831 (16:0831 Actions re: rights of Tennessee Valley Authority)","16:1244":"16:1244 (16:1244 National Scenic and National Historic Trails)","16:1374(d)":"16:1374(d) (16:1374(d)(6) Petition for Review re Application for Import of Polar Bear Trophies)","16:1531":"16:1531 (16:1531 Endangered Species Act)","16:1533":"16:1533 (16:1533 Endangered Species Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:1540":"16:1540 (16:1540 Endangered Species Act - Penalties and Enforcement)","16:1600":"16:1600 (16:1600 National Forest Management Act of 1976)","16:1801":"16:1801 (16:1801 Magnuson-Stevens Fishery Conservation and Management Act )","16:1858":"16:1858 (16:1858 National Fishery Management Program - Civil Penalties and Permit Sanctions)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0201":"17:0201 (17:0201 Ownership of Copyright)","17:0205(d)":"17:0205(d) (17:0205(d) Priority Between Conflicting Transfers)","17:0407":"17:0407 (17:0407 Recovery of fines & penalties by Register of Copyrights)","17:0411(b)":"17:0411(b) (17:0411(b) Action by copyright owner for infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0502(a)":"17:0502(a) (17:0502(a) Inj to prevent or restrain infringement copyright)","17:0504":"17:0504 (17:504 Copyright Infringement)","17:0512":"17:0512 (17:0512 Copyright Infringement of Digital Communications)","17:1201":"17:1201 (17:1201 Digital Millennium Copyright Act)","18:0492":"18:0492 (18:0492 Forfeiture of Counterfeit Paraphernalia)","18:0603":"18:0603 (18:0603 Conflict of Interest)","18:0922":"18:0922 (18:0922 Firearms - Unlawful Possession (Civil Fines) )","18:0923(f)":"18:0923(f) (18:0923(f)(3) Review of Revocation of a License as a Dealer in Firearms)","18:0925(c":"18:0925(c (18:0925(c ) Restoration of ability to possess firearms/ammo)","18:1030":"18:1030 (18:1030 Fraud & Related Activity in Connection with Computers)","18:1345":"18:1345 (18:1345 Injunction against Fraud)","18:1514":"18:1514 (18:1514 Civil Action to Restrain Harassment of a Victim)","18:1514A":"18:1514A (18:1514A Civil Action to Protect Against Retaliation in Fraud Cases)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1905":"18:1905 (18:1905 Disclosure of Confidential Information)","18:1955":"18:1955 (18:1955 Civil Forfeiture-Prohibition of Illegal Gambling)","18:1956(b)":"18:1956(b) (18:1956(b)(3) Laundering of Monetary Instruments - Forfeit Property)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:1968":"18:1968 (18:1968 Action re civil investigative demand)","18:2254":"18:2254 (18:2254 Civil Forfeiture - Exploitation of Children)","18:2333":"18:2333 (18:2333 Civil Remedies: Anti-Terrorism Act of 1991)","18:2511":"18:2511 (18:2511 Wiretapping - Injunctive Relief or Civil Fine)","18:2520":"18:2520 (18:2520 Civil Damages for Interception Wire or Oral Communications)","18:2707":"18:2707 (Electronic Communications Privacy Act)","18:2710( c":"18:2710( c (18:2710( c) Wrongful Disclosure of Video Tape Rental or Sales Records)","18:2724":"18:2724 (18:2724 Civil Action - Motor Vehicle Records)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:3184":"18:3184 (18:3184 Extradition Procedure)","18:3663":"18:3663 (18:3663 Civil Enforcement of Crim. Rest. Obligation)","18:4100":"18:4100 (18:4100 Transfer of Offenders)","18:981":"18:981 (18:981 Civil Forfeiture)","18:981(a)(":"18:981(a)( (18:981(a)(1)(A) Civil Forfeiture: Money Laundering Control Act)","18:983":"18:983 (18:983 Civil Forfeiture - General Rules)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","19:1497":"19:1497 (19:1497 Customs Duties: Penalty for Failure to Declare)","19:1595a":"19:1595a (19:1595a Customs Duties: Forfeiture and Other Penalties)","19:1607":"19:1607 (19:1607 Customs Duties: Notice of Seizure)","20:0107":"20:0107 (20:0107 Randolph-Sheppard Vending Stand Act)","20:1070":"20:1070 (20:1070 Student Assistance)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1087":"20:1087 (20:1087 Student Loan Discharge)","20:1095a":"20:1095a (20:1095a Education - Wage Garnishment Requirement)","20:1097":"20:1097 (20:1097 Education - Criminal penalties for fraud)","20:1098g":"20:1098g (20:1098g Higher Education Act - Exemption from state disclosure)","20:1232(g)":"20:1232(g) (20:1232(g) Family Education Rights & Privacy Act of 1974)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1412":"20:1412 (20:1412 IDEA: State Eligibility)","20:1415":"20:1415 (20:1415 IDEA: Challenge decision re education for handicapped )","20:1415(e)":"20:1415(e) (20:1415(e)(2)de IDEA: Mediation)","20:1681":"20:1681 (20:1681 Title IX Educational Amendments 1992 - Sex Discrimination)","20:1683":"20:1683 (20:1683 Judicial Review: Prohibition against sex discrimination in education)","20:1706":"20:1706 (20:1706 Relief from denial of equal educational opportunity)","20:1717":"20:1717 (20:1717 Reopening proceedings w/order to end segregation)","21:0301":"21:0301 (21:0301 Federal Food, Drug & Cosmetic Act)","21:0331":"21:0331 (21:0331 Federal Food, Drug & Cosmetic Act - Prohibited Acts)","21:0332":"21:0332 (21:0332 Federal Food, Drug and Cosmetic Act, Injunctive Relief)","21:0332(a)":"21:0332(a) (21:0332(a) Federal Food, Drug, and Cosmetic Act)","21:0334(a)":"21:0334(a) (21:0334(a) Forfeiture or condemnation-food, drug, cosmetics)","21:0348":"21:0348 (21:0348 Federal Food, Drug and Cosmetic Act - Food Additives)","21:0360":"21:0360 (21:0360 Federal Food, Drug & Cosmetic Act - Drugs and Devices)","21:0467":"21:0467 (21:0467 Seizure and condemnation of poultry products)","21:0601":"21:0601 (21:0601 Federal Meat Inspection Act 21 USC 601-695 (Definitions))","21:0673":"21:0673 (21:0673 Seizure and condemnation of meat or meat products)","21:0674":"21:0674 (21:0674 Proceeding to enforce & enjoin re meat products)","21:0821":"21:0821 (21:0821 Violation of Record Keeping Provision of Controlled Substance Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0842":"21:0842 (21:0842 Civil Penalty for violation re controlled substance)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","21:0882":"21:0882 (21:0882 Inj to enjoin violations re controlled substance)","21:1049":"21:1049 (21:1049 Seizure and condemnation re eggs or egg products)","22:0286":"22:0286 (22:0286 Action against World Bank or IMF)","22:2702":"22:2702 (22:2702 Medical Malpractice by Govt. Medical Personnel)","22:3612":"22:3612 (22:3612 Claim for Damage to Panama Canal)","22:3776":"22:3776 (22:3776 Panama Canal Commission Action on claims)","22:3777":"22:3777 (22:3777 Investigation of accident or injury giving rise to a claim)","22:4140":"22:4140 (22:4140 Foreign Service Grievance Act - Judicial Review)","23:0112":"23:0112 (23:0112 Federal Highway Act - Letting of Contracts)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","25:2701":"25:2701 (25:2701 Indian Gaming Regulatory Act (IGRA))","25:4101":"25:4101 (25:4101 Native American Housing Assistance and Self-Determination Act (NAHASDA))","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6653sp":"26:6653sp (26:6653sp IRS: Failure to Pay Stamp Tax)","26:6672":"26:6672 (26:6672 IRS: Failure to Collect and Pay Over Tax, or Attempt to Evade or Defeat Tax)","26:6694":"26:6694 (26:6694 IRS: Underestimate Of Tax Liability By Tax Preparer)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7323":"26:7323 (26:7323 IRS: Proceedings in rem enforce forfeitures property)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7404":"26:7404 (26:7404 IRS: Action for collection of estate tax)","26:7405":"26:7405 (26:7405 IRS: Action for recovery of refunds erroneously made)","26:7407":"26:7407 (26:7407 IRS: Action to enjoin income tax preparers)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7425(a)":"26:7425(a) (26:7425(a) IRS: Judiciary & Judicial Procedures - Discharge of Liens)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7428":"26:7428 (26:7428 IRS: Declaratory Judgment)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7430":"26:7430 (26:7430 IRS: Awarding of Costs and Certain Fees in Tax Suit)","26:7431":"26:7431 (26:7431 IRS: Unauthorized Disclosure of Return & Return Info)","26:7434":"26:7434 (26:7434 IRS: Civil Damages for Fraudulent Filing of Information)","26:7604":"26:7604 (26:7604 IRS: Enforce summons; examination books & witnesses)","26:7604(a)":"26:7604(a) (26:7604(a) IRS: Complaint to Enforce IRS Summons)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","26:7609en":"26:7609en (26:7609en IRS: Petition to serve Third-Party Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157(b)":"28:0157(b) (28:0157(b) Bankruptcy Claim to be tried in U.S. District Court)","28:0157(c":"28:0157(c (28:0157(c )(1) Findings, Concl. & Proposed Judgment)","28:0157(d)":"28:0157(d) (28:0157(d) Motion for Withdrawal of Reference)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0463":"28:0463 (28:0463 Expenses of Judicial Litigation)","28:0534":"28:0534 (28:0534 Arrest Records)","28:0591":"28:0591 (28:0591 Independent Counsel)","28:0592":"28:0592 (28:0592 Independent Counsel - Application for Appointment)","28:0593":"28:0593 (28:0593 Independent Counsel - Court Responsibilities)","28:0594":"28:0594 (28:0594 Independent Counsel - Responsibilities)","28:0595":"28:0595 (28:0595 Independent Counsel - Congressional Oversight)","28:0596":"28:0596 (28:0596 Independent Counsel - Removal)","28:0597":"28:0597 (28:0597 Independent Counsel - Dept. of Justice Relationship)","28:0598":"28:0598 (28:0598 Independent Counsel - Chapter Termination)","28:0636":"28:0636 (28:0636 Jurisdiction and Power of Magistrate Judges)","28:0754":"28:0754 (28:0754 Receiver of Property in Different Districts )","28:1291":"28:1291 (28:1291 Maritime)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331(a)":"28:1331(a) (28:1331(a)rp Fed. Question: Real Property )","28:1331ag":"28:1331ag (28:1331ag Fed. Question: Employment Discrimination (Age))","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331as":"28:1331as (28:1331as Fed. Question: Assault, Libel, Slander)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cr":"28:1331cr (28:1331cr Fed. Question: Civil Rights (Race Discrimination))","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331dd":"28:1331dd (28:1331dd Fed. Question: Discovery Disputes (conversion case))","28:1331dj":"28:1331dj (28:1331dj Fed. Question: Declaratory Judgment)","28:1331dp":"28:1331dp (28:1331dp Fed. Question: Violation of Due Process)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ef":"28:1331ef (28:1331ef Fed. Question: Civil Rights Violation (Excess Force))","28:1331ej":"28:1331ej (28:1331ej Fed. Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fa":"28:1331fa (28:1331fa Fed. Question: Civil Rights Violation-False Arrest)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331fm":"28:1331fm (28:1331fm Fed. Question: Family and Medical Leave Act)","28:1331fr":"28:1331fr (28:1331fr Fed. Question: Fraud)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331ng Fed. Question: Natural Gas Act)","28:1331ni":"28:1331ni (28:1331ni Fed. Question: Negotiable Instrument)","28:1331pd":"28:1331pd (28:1331pd Fed. Question: Property Damage)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331pl":"28:1331pl (28:1331pl Fed. Question: Product Liability)","28:1331pr":"28:1331pr (28:1331pr Fed. Question: Federal Prisoner Civil Rights)","28:1331ra":"28:1331ra (28:1331ra Fed. Question: Racketeering (RICO) Act)","28:1331rc":"28:1331rc (28:1331rc Fed. Question: Reclamation Project Auth. Act of 1972)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331rs":"28:1331rs (28:1331rs Fed. Question: Federal Rail Safety Act)","28:1331sh":"28:1331sh (28:1331sh Fed. Question: Sexual Harassment)","28:1331ss":"28:1331ss (28:1331ss Fed. Question: Constitutionality of State Statutes)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331sx":"28:1331sx (28:1331sx Fed. Question: Employment Discrimination (Sex))","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331va":"28:1331va (28:1331va Fed. Question: Violation 5th & 14th Amendment)","28:1331vc":"28:1331vc (28:1331vc Fed. Question: Violation of Constitutional Rights)","28:1331w":"28:1331w (28:1331w Fed. Question: Wrongful Termination of Employment)","28:1331wd":"28:1331wd (28:1331wd Fed. Question: Wrongful Death)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332":"28:1332 (28:1332 Diversity Action)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332ap":"28:1332ap (28:1332ap Diversity-Airplane Product Liability)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332bw":"28:1332bw (28:1332bw Diversity -Breach of Warranty)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332de":"28:1332de (28:1332de Diversity: Forcible Detainer)","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332dtp":"28:1332dtp (28:1332dtp Diversity - Deceptive Trade Practices)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332ej":"28:1332ej (28:1332ej Diversity-Enforcement of Judgment)","28:1332fc":"28:1332fc (28:1332fc Diversity - Foreclosure)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332if":"28:1332if (28:1332if Diversity- Insurance Fraud)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332lp":"28:1332lp (28:1332lp Diversity-Property Damage/Product Liability)","28:1332lr":"28:1332lr (28:1332lr Diversity - Labor)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332md":"28:1332md (28:1332md Diversity-Motor Vehicle/Wrongful Death)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332nr Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332op":"28:1332op (28:1332op Diversity-Recovery of Overpayment)","28:1332pa":"28:1332pa (28:1332pa Diversity-Personal Injury/Airplane)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332rd":"28:1332rd (28:1332rd Diversity-Recovery of Debt)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332rl":"28:1332rl (28:1332rl Diversity-Rent Lease & Ejectment)","28:1332rp":"28:1332rp (28:1332rp Diversity-Real Property)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332sh":"28:1332sh (28:1332sh Diversity-Sexual Harassment)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332t":"28:1332t (28:1332t Diversity-Torts)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332ts":"28:1332ts (28:1332ts Diversity-Misappropriation of Trade Secrets)","28:1332vt":"28:1332vt (28:1332vt Diversity-Natl Motor Vehicle Title Information System)","28:1332wc":"28:1332wc (28:1332wc Diversity- Worker's Compensation Benefits)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1333ad":"28:1333ad (28:1333ad Admiralty)","28:1333in":"28:1333in (28:1333in Personal Injury)","28:1333mc":"28:1333mc (28:1333mc Marine Contract)","28:1333pd":"28:1333pd (28:1333pd Property Damage)","28:1333pi":"28:1333pi (28:1333pi Marine Personal Injury)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334(b)":"28:1334(b) (28:1334(b) Proceeding arising/related to case under title 11)","28:1334(c":"28:1334(c (28:1334(c ) R&R re motions for abstention)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1337sc":"28:1337sc (28:1337sc Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1339":"28:1339 (28:1339 Postal matters)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1340tp":"28:1340tp (28:1340tp Jurisdiction of Internal Revenue Matters; Customs Duties)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1344":"28:1344 (28:1344 Election disputes)","28:1345":"28:1345 (28:1345 U.S. Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345lc":"28:1345lc (28:1345lc Land Condemnation)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345ro":"28:1345ro (28:1345ro Recovery of Retirement Overpayment)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345tx":"28:1345tx (28:1345tx Prohibit dfts assessing tx on purch/use of pers prop)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346":"28:1346 (28:1346 U.S. Defendant)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346pi":"28:1346pi (28:1346pi Marine Personal Injury (or tort claim - personal injury / motor vehicle))","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346t":"28:1346t (28:1346t Tort Claim)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1348":"28:1348 (28:1348 Banking association as party)","28:1349":"28:1349 (28:1349 Corporation organized under Federal Law as party)","28:1350":"28:1350 (28:1350 Alien Tort Claims Act)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1356":"28:1356 (28:1356 Executory Process/Foreclosure)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1361pr":"28:1361pr (28:1361pr Complaint for mandamus relief (prisoner))","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1363":"28:1363 (28:1363 Action for protection of jurors employment rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1367":"28:1367 (28:1367 Other Property Damage)","28:1394":"28:1394 (28:1394 Banking Assoc action agst Comptroller of Currency)","28:1395":"28:1395 (28:1395 Complaint for Forfeiture )","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1403":"28:1403 (28:1403 Condemnation of real estate for the use of the US)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1407im":"28:1407im (28:1407im MDL: Silicone Gel Breast Implant Products Liability)","28:1407md":"28:1407md (28:1407md MDL: Multidistrict Litigation)","28:1407n":"28:1407n (28:1407n MDL: Personal Injury/Norplant Product Liability)","28:1407pl":"28:1407pl (28:1407pl MDL: Products Liability)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441ada":"28:1441ada (28:1441ada Removal- Americans with Disabilities Act)","28:1441ag":"28:1441ag (28:1441ag Removal- Civil Rights (Age))","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441ba":"28:1441ba (28:1441ba Removal - National Bank Act)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441bfd":"28:1441bfd (28:1441bfd Removal- Breach of Fiduciary Duties)","28:1441ca":"28:1441ca (28:1441ca Removal - Carmack Amendment)","28:1441cc":"28:1441cc (28:1441cc Removal- Computer Crimes Act)","28:1441cj":"28:1441cj (28:1441cj Removal- Confessed Judgement)","28:1441cla":"28:1441cla (28:1441cla Removal - Consumer Leasing Act)","28:1441cp":"28:1441cp (28:1441cp Removal- Copyright)","28:1441cpl":"28:1441cpl (28:1441cpl Removal - Contract Product Liability)","28:1441cra":"28:1441cra (28:1441cra Removal - Fair Credit Reporting Act)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441dea":"28:1441dea (28:1441dea Removal - Disabilities Education Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441di":"28:1441di (28:1441di Removal- Civil Rights (Disability Act))","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ea":"28:1441ea (28:1441ea Removal- Employment Discrimination (Age))","28:1441eb":"28:1441eb (28:1441eb Removal - E.R.I.S.A. Employee Benefits)","28:1441ec":"28:1441ec (28:1441ec Removal - Electronic Comm. Privacy Act)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441em":"28:1441em (28:1441em Removal - Emergency Medical Treatment & Active Labor)","28:1441er":"28:1441er (28:1441er Removal- Employment Discrimination (Race))","28:1441es":"28:1441es (28:1441es Removal- Employment Discrimination (Sex))","28:1441fa":"28:1441fa (28:1441fa Removal - Civil Rights - False Arrest)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fd":"28:1441fd (28:1441fd Removal - Fair Debt Collection Practices Act)","28:1441fe":"28:1441fe (28:1441fe Removal- Fed. Employee Garnishment Statute)","28:1441fh":"28:1441fh (28:1441fh Removal- FEHBA)","28:1441fif":"28:1441fif (28:1441fif Removal - Insecticide/Fungicide/Rodenticide Act -1942)","28:1441fl":"28:1441fl (28:1441fl Removal- Fair Labor Standards Act)","28:1441fm":"28:1441fm (28:1441fm Removal - Family and Medical Leave Act)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441fs":"28:1441fs (28:1441fs Removal - Foreign Sovereign Immunities Act)","28:1441fsa":"28:1441fsa (28:1441fsa Removal - Federal Food Stamp Act)","28:1441hb":"28:1441hb (28:1441hb Removal - Petition of Habeas Corpus)","28:1441hc":"28:1441hc (28:1441hc Removal - Handicapped Child Protection Act)","28:1441hd":"28:1441hd (28:1441hd Removal- Housing Discrimination)","28:1441ia":"28:1441ia (28:1441ia Removal- Interstate Commerce Act)","28:1441if":"28:1441if (28:1441if Removal - Insurance Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441il":"28:1441il (28:1441il Removal- Interstate Land Full Discloser Act)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441la":"28:1441la (28:1441la Removal - Truth in Lending Act)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441ml":"28:1441ml (28:1441ml Removal- Motor Vehicle Prod Liability)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441mv":"28:1441mv (28:1441mv Removal- Motor Vehicle)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441nr Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pa":"28:1441pa (28:1441pa Removal - Patent Infringement)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ra":"28:1441ra (28:1441ra Removal- Civil Rights (Race))","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441rl":"28:1441rl (28:1441rl Removal- Rent, Lease, & Ejectment)","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441sh":"28:1441sh (28:1441sh Removal-Sexual Harassment)","28:1441st":"28:1441st (28:1441st Removal - Stockholders Suit)","28:1441sv":"28:1441sv (28:1441sv Removal-Security Violation)","28:1441sx":"28:1441sx (28:1441sx Removal-Civil Rights (Sex))","28:1441tc":"28:1441tc (28:1441tc Removal - Tricare Program)","28:1441ti":"28:1441ti (28:1441ti Removal-Trademark Infringement)","28:1441til":"28:1441til (28:1441til Removal - Truth and Lending)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441us":"28:1441us (28:1441us Removal - Uniformed Svc Emp/Reemp Rights Act)","28:1441wc":"28:1441wc (28:1441wc Removal - Worker's Compensation Benefits)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1441wt":"28:1441wt (28:1441wt Removal- Employment (Wrongful Termination))","28:1442":"28:1442 (28:1442 Notice of Removal - Suit against Federal Officer)","28:1442aaf":"28:1442aaf (28:1442aaf Petition for Removal - Agst members of armed forces)","28:1443":"28:1443 (28:1443(1) Removal - Civil Rights: Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446al":"28:1446al (28:1446al Notice of Removal - Airline Crash)","28:1446as":"28:1446as (28:1446as Notice of Removal - Asbestos Litigation)","28:1446bc":"28:1446bc (28:1446bc Notice of Removal - Breach of Contract)","28:1446cs":"28:1446cs (28:1446cs Notice of Removal - Child Support Enforcement)","28:1446dj":"28:1446dj (28:1446dj Notice of Removal - Declaratory Judgment)","28:1446er":"28:1446er (28:1446er Notice of Removal - E.R.I.S.A)","28:1446fm":"28:1446fm (28:1446fm Notice of Removal - Family and Medical Leave Act)","28:1446fr":"28:1446fr (28:1446fr Notice of Removal - Fraud)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446lb":"28:1446lb (28:1446lb Notice of Removal - Libel, Assault, Slander)","28:1446ml":"28:1446ml (28:1446ml Notice of Removal - Motor Vehicle Prod Liability)","28:1446mm":"28:1446mm (28:1446mm Notice of Removal - Medical Malpractice)","28:1446mv":"28:1446mv (28:1446mv Notice of Removal - Motor Vehicle)","28:1446ni":"28:1446ni (28:1446ni Notice of Removal - Negotiable Instrument)","28:1446nr":"28:1446nr (28:1446nr Notice of Removal)","28:1446oc":"28:1446oc (28:1446oc Notice of Removal - Other Contract)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1446st":"28:1446st (28:1446st Notice of Removal - Stockholders Suit)","28:1446tl":"28:1446tl (28:1446tl Notice of Removal - Torts to Land)","28:1446wd":"28:1446wd (28:1446wd Notice of Removal - Wrongful Death)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1453":"28:1453 (28:1453 Class Action Fairness Act)","28:1491":"28:1491 (28:1491 Tucker Act)","28:1602":"28:1602 (28:1602 Foreign Sovereign Immunities Act)","28:1605":"28:1605 (28:1605 Foreign Sovereign Immunities Act of 1976)","28:1605A":"28:1605A (28:1605A Antiterrorism & Effective Death Penalty Act 1996)","28:1610":"28:1610 (28:1610 Juridictional Immunities of Foreign States)","28:1631":"28:1631 (28:1631 Case Transferred to Cure Want of Jurisdiction)","28:1651cn":"28:1651cn (28:1651cn Petition for Writ of Error Coram Nobis )","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1651ne":"28:1651ne (28:1651ne Application for Writ Ne Exeat)","28:1651w":"28:1651w (28:1651w All Writs Act)","28:1715":"28:1715 (28:1715 Class Action Fairness Act of 2005)","28:1732":"28:1732 (28:1732 Reproduction of Records)","28:1738Acs":"28:1738Acs (28:1738Acs The Uniform Child Custody Jurisdiction Act)","28:1782":"28:1782 (28:1782 Assistance to Foreign Tribunals (incl letter rogatory))","28:1783":"28:1783 (28:1783 Petition for Subpoena of person in foreign country)","28:1826":"28:1826 (28:1826 Order of confinement of recalcitrant witness)","28:1875":"28:1875 (28:1875 Juror Protection Act / Protection of Jurors' Employment)","28:1916":"28:1916 (28:1916 Marine Personal Injury)","28:1963":"28:1963 (28:1963 Registration of judgment from another district)","28:2001":"28:2001 (28:2001 Judicial Sale of Realty)","28:2071":"28:2071 (28:2071 Rule Making Power Generally)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201an":"28:2201an (28:2201an Declaratory Judgement (aliens and nationality))","28:2201cp":"28:2201cp (28:2201cp Declaratory Judgment (Copyright))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201fa":"28:2201fa (28:2201fa Declaratory Judgment- Firearms)","28:2201fs":"28:2201fs (28:2201fs Declaratory Judgment (Food Security Act))","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2201pi":"28:2201pi (28:2201pi Declaratory Judgment - Personal Injury)","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2241fd":"28:2241fd (28:2241fd Petition for Writ of Habeas Corpus (federal))","28:2241in":"28:2241in (28:2241in Habeas Corpus: INS)","28:2241st":"28:2241st (28:2241st Petition for Writ of Habeas Corpus (State))","28:2244":"28:2244 (28:2244 Habeas Corpus - Finality of Determination)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254dp":"28:2254dp (28:2254dp Petition for Writ of Habeas Corpus (Death Penalty))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2283":"28:2283 (28:2283 Stay of State Court Proceedings (Injunctive Relief))","28:2347":"28:2347 (28:2347 Petition to Review Orders in the Ct of Appeals)","28:2401":"28:2401 (28:2401 Federal Tort Claims Act (Time for commencing action against the US))","28:2403":"28:2403 (28:2403 Constitutionality of State Statute(s) )","28:2405":"28:2405 (28:2405 Garnishment of debtors of a corporation by US)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2409(a)":"28:2409(a) (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2412":"28:2412 (28:2412 Equal Access to Justice Act)","28:2415":"28:2415 (28:2415 Detinue and Conversion)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2672mv":"28:2672mv (28:2672mv Federal Tort Claims Act - Motor Vehicle)","28:2672pi":"28:2672pi (28:2672pi Federal Tort Claim Act - Personal Injury)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:2675":"28:2675 (28:2675 Federal Tort Claims Act - Disposition by Agency Req)","28:2679(d)":"28:2679(d) (28:2679(d)(2) Federal Tort Claims Act - Employee of U.S.A.)","28:2680":"28:2680 (28:2680 Federal Tort Claims Act - Exceptions)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","28:3001(a)":"28:3001(a) (28:3001(a) Federal Debt Collection Procedures Act of 1990)","28:3203":"28:3203 (28:3203 Postjudgment Remedies: Writ of Execution)","28:3301":"28:3301 (28:3301 Fraudulent Transfer Federal Debt Collection Procedures Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0101":"29:0101 (29:0101 Labor: Issuance of Restraining Orders and Injunctions )","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0158(b)":"29:0158(b) (29:0158(b) Labor: NLRA - Unfair Labor Practices)","29:0159":"29:0159 (29:0159 Labor: Violation of Collective Bargaining Agreement )","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0160j":"29:0160j (29:0160j Labor: Petition for Inj - Relief from Unfair Labor Practice)","29:0160l":"29:0160l (29:0160l Labor: Petition for Inj re Uncertified Labor Organizations)","29:0161(2)":"29:0161(2) (29:0161(2) Labor: Enforcement of agency subpoena)","29:0178":"29:0178 (29:0178 Labor: Petition for Inj to Enjoin Strike during Natl Emergency)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185":"29:0185 (29:0185 Labor: Suits by and against Labor Organizations)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0186":"29:0186 (29:0186 Labor: Liabilities of and Restrictions on Labor and Management)","29:0187":"29:0187 (29:0187 Labor: Recover Damages from Unfair Labor Practice)","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0206(d)":"29:0206(d) (29:0206(d) FLSA: Prohibition of Sex Discrimination)","29:0207(a)":"29:0207(a) (29:0207(a) FLSA: Action for Overtime Wage Violation)","29:0207fl":"29:0207fl (29:0207fl FLSA: Maximum Hours)","29:0210":"29:0210 (29:0210 FLSA: Court Review of Wage Orders in PR and VI)","29:0215fl":"29:0215fl (29:0215fl FLSA: Prohibited Acts)","29:0216(b)":"29:0216(b) (29:0216(b) FLSA: Minimum wage or overtime compensation)","29:0216(e)":"29:0216(e) (29:0216(e) FLSA: Penalty assessed for child labor provisions)","29:0217":"29:0217 (29:0217 FLSA: Enjoin Violations of Fair Labor Standards Act)","29:0260":"29:0260 (29:0260 FLSA: Liquidated Damages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0411":"29:0411 (29:0411 Landrum Griffin Act)","29:0412":"29:0412 (29:0412 Infringement of rights; members of labor organization)","29:0440":"29:0440 (29:0440 violations reporting requirements; labor organization)","29:0501(b)":"29:0501(b) (29:0501(b) Violation of Fiduciary Responsibility)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0660":"29:0660 (29:0660 Action by Sec Labor for discrimination re rights OSHA)","29:0662":"29:0662 (29:0662 Inj proceedings re dangerous emp conditions; by Sec.)","29:0666":"29:0666 (29:0666 Collection of civil penalties under OSHA)","29:0701":"29:0701 (29:0701 Vocational Rehabilitation)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0792(d)":"29:0792(d) (29:0792(d)(2) Accessible facilities for phys. handicapped emp)","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1055":"29:1055 (29:1055 E.R.I.S.A., Employee Retirement (Joint and Survivor Annuity))","29:1101":"29:1101 (29:1101 E.R.I.S.A.: Coverage)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1161":"29:1161 (29:1161 COBRA - Continuation Coverage)","29:1162":"29:1162 (29:1162 COBRA - Continuation Coverage)","29:1303":"29:1303 (29:1303 PBGC: Operation of Corporation)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1401(b)":"29:1401(b) (29:1401(b)(2) E.R.I.S.A.: Resolution of Disputes - Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:1854":"29:1854 (29:1854 Migrant & Seasonal Agri Worker Protect Act (AWPA))","29:1916":"29:1916 (29:1916 Spec. Rule for Longshoremen & Harborworkers)","29:2001":"29:2001 (29:2001 Employee Polygraph Protection Act)","29:2101":"29:2101 (29:2101 Worker Adjustment Retraining Notification Act)","29:2102":"29:2102 (29:2102 Notice required before plant closings and mass layoffs)","29:2104":"29:2104 (29:2104 Worker Adjustment & Retraining Notification (WARN))","29:2601":"29:2601 (29:2601 FMLA: Family and Medical Leave Act (Findings and Purposes))","29:2611":"29:2611 (29:2611 FMLA: Definitions)","29:2612":"29:2612 (29:2612 FMLA: Leave Requirements)","29:2617":"29:2617 (29:2617 Family and Medical Leave Act)","30:0022":"30:0022 (30:0022 General Mining Law of 1872 (Lands Open to Purchase by Citizens))","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:0815":"30:0815 (30:0815 Federal Mine Safety & Health Act (Procedure for Enforcement))","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","30:1701":"30:1701 (30:1701 Federal Oil Gas Royalty Mgt Act 1982 (FOGRMA))","31:0732":"31:0732 (31:0732 General Acct. Office Personnel Act of 1980 (Personnel Management System))","31:1341":"31:1341 (31:1341 Government employee--limitations on expending monies)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3702":"31:3702 (31:3702 Procedures for Settling Claims )","31:3713":"31:3713 (31:3713 Priority of Government Claims)","31:3720":"31:3720 (31:3720 Federal Income Tax Interceptions (Collection of Payments))","31:3728":"31:3728 (31:3728 Setoff against Judgment )","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","31:3733(j)":"31:3733(j) (31:3733(j)(2) Pet to Mod or Set Aside CV Investigative Demand)","31:5314":"31:5314 (31:5314 Failure to Report Interest in Foreign Accounts)","31:5332(a)":"31:5332(a) (31:5332(a) Evading Currency Reporting Requirement)","31:5332(f)":"31:5332(f) (31:5332(f) Transport and Transfer US currency from in to out)","31:6716":"31:6716 (31:6716 Discrimination re money and finance )","31:9701":"31:9701 (31:9701 Federal User Charge Statute)","33:0408":"33:0408 (33:0408 Injury to Harbor Improvement)","33:0412":"33:0412 (33:412 Liability of Pilots & Vessels Engaged in Violations)","33:0594":"33:0594 (33:0594 Land Condemnation)","33:0901":"33:0901 (33:0901 Longshoremen Harbor Workers Compensation Act (Navigation and Navigable Waters))","33:0905(b)":"33:0905(b) (33:0905(b) Longshoremen Workers' Compensation Act - Recovery of Damages caused by the negligence of )","33:0918":"33:0918 (33:0918 Longshore and Harbor Workers Compensation Act - Collection of Defaulted Payments)","33:0921":"33:0921 (33:0921 Longshore & Harbor Workers Compensation Act - Review of Compensation Orders)","33:0933":"33:0933 (33:0933 Longshore and Harbor Workers' Compensation Act - Compensation for Injuries (Third-Party Clai)","33:1221":"33:1221 (33:1221 Ports and Waterways Safety Program)","33:1251":"33:1251 (33:1251 Federal Water Pollution Control Act (Clean Water Act))","33:1319(a)":"33:1319(a) (33:1319(a)(2)pv Clean Water Act - Pollutants & Permit Violations)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1321":"33:1321 (33:1321 Clean Water Act - Discharge of hazardous substance or pollutants/water)","33:1361":"33:1361 (33:1361 Clean Water Act-Administrator Authority)","33:1364":"33:1364 (33:1364 Clean Water Act - EPA action to restrain pollution endangering health (emergency powers))","33:1365":"33:1365 (33:1365 Environmental Matters)","33:1415":"33:1415 (33:1415 Marine Protection, Research, and Sanctuaries Act)","33:1515":"33:1515 (33:1515 Deepwater Ports Act (citizen civil action))","33:2701":"33:2701 (33:2701 Oil Pollution Act of 1940)","35:0001":"35:0001 (35:0001 Establishment of PTO)","35:0032":"35:0032 (35:0032 Suspension from Practice before Patent & Trade. Off.)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0146":"35:0146 (35:0146 Appeal from Decision of the Board of Patent Appeals)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0256":"35:0256 (35:0256 Patent Non-Infringement (Correction of Named Inventor))","35:0271":"35:0271 (35:271 Patent Infringement)","35:0281":"35:0281 (35:0281 Remedy for Infringement of Patent/jurisdiction conferred 28:1338)","35:0282":"35:0282 (35:0282 Patent Infringement - Defenses)","35:0283":"35:0283 (35:0283 Action to enjoin violation of right secured by patent)","35:0289":"35:0289 (35:0289 Recover profits from unlicensed use of design patent)","35:0291":"35:0291 (35:0291 Action for relief between owners; interfering patents)","35:0292":"35:0292 (35:0292 Penalty & Forfeiture; illegal use of word patent (false marking))","35:0311":"35:0311 (35:0311 Patent - Request for Inter Partes Reexamination)","38:1110":"38:1110 (38:1110 Basic Entitlements / Wartime)","38:1131":"38:1131 (38:1131 Basic Entitlements / Peacetime)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:1816":"38:1816 (38:1816 Deficiency balance on VA Mortgage Foreclosure (Regulations Governing the VA Loan Guaranty Pr)","38:1965":"38:1965 (38:1965 Servicemen's Group Life Insurance (Definitions))","38:1975":"38:1975 (38:1975 Recovery of Servicemen's Group Life Insurance - Jurisdiction of District Court)","38:1984":"38:1984 (38:1984 Suit for Veterans Insurance)","38:2011":"38:2011 (38:2011 - Veterans Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:3481":"38:3481 (38:3481 Recovery of VA Overpayment)","38:3680":"38:3680 (38:3680 Recovery of Education Assist Allowance Overpayment)","38:4212":"38:4212 (38:4212 Veterans Employment Emphasis Under Federal Contracts )","38:4300":"38:4300 (38:4300 Uniformed Services Employment and Reemployment Act)","38:4301":"38:4301 (38:4301 Uniformed Srvs. Employment & Reemployment Rights Act (purpose))","38:4302":"38:4302 (38:4302 Veterans Reemployment Rights Act (relation to other laws and plans or agreements.)","38:4311":"38:4311 (38:4311 Uniformed Service Employment or Reemployment Rights Act (USERRA) - Discrimination)","38:4312":"38:4312 (38:4312 Rights of inducted persons to reemployment )","38:4323":"38:4323 (38:4323 USERRA - Enforcement of rights with respect to state or private employer )","38:4324":"38:4324 (38:4324 USERRA - Enforcement of rights with respect to federal executive agencies)","38:5315":"38:5315 (38:5315 Delinquent Payment of Amounts Due to US)","38:5316":"38:5316 (38:5316 VA Overpayment )","39:0403":"39:0403 (39:0403 Discriminatory use of the Postal Service)","39:1207":"39:1207 (39:1207 Review Agency Action--Labor Disputes)","39:1208(b)":"39:1208(b) (39:1208(b) Postal Reorganization Act of 1970 - Suits)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:3007":"39:3007 (39:3007 Detention of Mail for Temporary Periods - Injunction directing retention of incoming mail)","39:3008(e)":"39:3008(e) (39:3008(e) Enforce compliance with a USPS Prohibitory Order)","39:409":"39:409 (39:409 Postal Service)","40:0270":"40:0270 (40:270 Miller Act)","40:0581":"40:0581 (40:0581 General Authority of Administrator of General Services)","40:1101":"40:1101 (40:1101 Brooks Architect - Engineers Act)","40:3131":"40:3131 (40:3131 Bonds of contractors of public buildings )","40:3142":"40:3142 (40:3142 Davis-Bacon Act (prevailing wages))","41:2102-21":"41:2102-21 (41:2102-2107 Procurement Integrity Act)","41:3301":"41:3301 (41:3301 Competition in Contracting Act)","41:6503":"41:6503 (41:6503 Walsh-Healy Act - Breach of Public Contract)","41:6505":"41:6505 (41:6505 Exclusions - Review of legal questions in contracts; Walsh-Healy Act)","41:6702 -":"41:6702 - (41:6702 - 6704 Service Contract Labor Standards / McNamara-O'Hara Service Contract Act 1965)","41:7105(f)":"41:7105(f) (41:7105(f) Action to Judicially Enforce Administrative Subpoena)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0254o":"42:0254o (42:0254o Breach of Scholarship Contract)","42:0256":"42:0256 (42:0256 Public Health Services Act - Grants)","42:0292f":"42:0292f (42:0292f Default of borrower)","42:0292k":"42:0292k (42:0292k Student loan insurance (Public Health Occupations))","42:0293":"42:0293 (42:0293 Recovery of losses from loan guarantee; public health)","42:0297":"42:0297 (42:0297 Student loans; public or nonprofit school of nursing)","42:0300aa-":"42:0300aa- (42:0300aa-1 Nat'l. Childhood Vaccine Injury Compensation Act)","42:0300f":"42:0300f (42:0300f Safe Drinking Water Act (Definitions))","42:0300g":"42:0300g (42:0300g Actions re safety of public water systems (EPA))","42:0300g-3":"42:0300g-3 (42:0300g-3 Enforcement of Drinking Water Regulations)","42:0401":"42:0401 (42:0401 Social Security Act - Trust Funds)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405rs":"42:0405rs (42:0405rs Review of HHS Decision (RSI))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0421(d)":"42:0421(d) (42:0421(d) Review HHS decision re disability determinations)","42:0423":"42:0423 (42:0423 Social Security Act (Disability Insurance Benefit Payments))","42:0427":"42:0427 (42:427 Social Security Benefits)","42:0601":"42:0601 (42:0601 Title IV-A of the Social Security Act (Grants to States for Aid and Assistance to Needy Fami)","42:0602":"42:0602 (42:0602 Temp. Assistance for Needy Families (TANF) )","42:0660":"42:0660 (42:0660 Action to enforce child support obligations)","42:10139":"42:10139 (42:10139 judicial review of agency actions )","42:10801":"42:10801 (42:10801 Protection & Advocacy for Individuals with Mental Illness Act of 1986 (PAIMI))","42:10805":"42:10805 (42:10805 Protection and Advocacy Systems)","42:11001":"42:11001 (42:11001 Emergency Plan. & Comm. Right to Know Act (EPCRA))","42:11046":"42:11046 (42:11046 Fed Emer Plan Comm Right-to-know Act (EPCRA) - civil actions)","42:11101":"42:11101 (42:11101 Health Care Quality Improvement Act of 1986 )","42:11112":"42:11112 (42:11112 Health Care Quality Improvement Act (Standards for Professional Review Actions))","42:11601":"42:11601 (42:11601 International Child Abduction Remedies Act)","42:11603(b":"42:11603(b (42:11603(b) Int'l. Child Abduction Remedies Act (ICARA) - Judicial Remedies)","42:12101":"42:12101 (42:12101 The Americans with Disabilities Act of 1990)","42:12102":"42:12102 (42:12102 Americans with Disabilities Act (ADA) Disability Definition)","42:12111":"42:12111 (42:12111 Americans with Disabilities Act - Employment )","42:12112":"42:12112 (42:12112 Americans with Disabilities Act - Employment Discrimination)","42:12117":"42:12117 (42:12117 Americans with Disabilities Act - Enforcement)","42:12132":"42:12132 (42:12132 Americans with Disabilities Act - Discrimination)","42:12188":"42:12188 (42:12188 Americans With Disabilities Act - Civil Enforcement Actions)","42:1320a-7":"42:1320a-7 (42:1320a-7b(b)(2)(A) Anti-Kickback Act (for federal health care programs) )","42:1320d-2":"42:1320d-2 (42:1320d-2 Health Insurance Portability And Accountability Act (HIPAA))","42:1381a":"42:1381a (42:1381a Supplemental Security Income benefits (SSID))","42:1382":"42:1382 (42:1382 Eligibility for benefits)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1395dd":"42:1395dd (42:1395dd Exam & Treatment Emergency Med Cond & Women in Labor)","42:1395hr":"42:1395hr (42:1395hr Hospital Reimbursement for Medicare Services)","42:1395w-2":"42:1395w-2 (42:1395w-21 Medicare Act (Eligibility, Election, and Enrollment))","42:1396a":"42:1396a (42:1396a State Plans for Medical Assistance)","42:1396b":"42:1396b (42:1396b Medical Assist Prgm, Pmt to States/Medicaid Implem)","42:13981":"42:13981 (42:13981 Violence Against Women Act)","42:14135":"42:14135 (42:14135 DNA Backlog Grant Program)","42:1437":"42:1437 (42:1437 U.S. Housing Act of 1937)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1475":"42:1475 (42:1475 Declaratory & Injunctive Relief - Foreclosure Procedures)","42:1479":"42:1479 (42:1479 Mortgage, lease, contract re farm housing)","42:14901":"42:14901 (42:14901 Intercountry Adoptions)","42:15483":"42:15483 (42:15483 Help America Vote Act)","42:1651":"42:1651 (42:1651 Defense Base Act)","42:1705":"42:1705 (42:1705 Receipt of Workmen's compensation benefits)","42:1971":"42:1971 (42:1971 Voting Rights Law)","42:1973":"42:1973 (42:1973 Voting Rights Act)","42:1973(a)":"42:1973(a) (42:1973(a) Enforcement of Voting Rights)","42:1973(c":"42:1973(c (42:1973(c ) Voting Rights -Qualifications & Procedures)","42:1973gg-":"42:1973gg- (42:1973gg-2 Nat'l. Voter Registration Act of 1993 (NVRA))","42:1981a":"42:1981a (42:1981a Damages in cases of intentional discrim. in employment)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981ra":"42:1981ra (42:1981ra Race Discrimination)","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1982hs":"42:1982hs (42:1982hs Discrimination re property rights (housing))","42:1982ra":"42:1982ra (42:1982ra Discrimination re property rights (race))","42:1982sx":"42:1982sx (42:1982sx Discrimination re property rights (sex))","42:1983bv":"42:1983bv (42:1983bv Bivens Non-Prisoner)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983cvp":"42:1983cvp (42:1983cvp Civil Rights (Personal Property))","42:1983d":"42:1983d (42:1983d Civil Rights (Death))","42:1983dp":"42:1983dp (42:1983dp Civil Right Denial of Due Process)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1983vp":"42:1983vp (42:1983vp Violation of Due Process and Equal Protection)","42:1985":"42:1985 (42:1985 Consipracy to interfere with civil rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:1987":"42:1987 (42:1987 Prosecution of violations of certain laws (violations of sec 1990 or 5506 to 5516 or 5518 to)","42:1988":"42:1988 (42:1988 Proceedings in Vindication of Civil Rights)","42:1997":"42:1997 (42:1997 Institutionalized Persons Act of 1980 )","42:2000a-3":"42:2000a-3 (42:2000a-3pa Discrimination, segregation; public accommodation - Injunctive Relief)","42:2000ad":"42:2000ad (42:2000ad Job Discrimination (Disability Act))","42:2000ag":"42:2000ag (42:2000e-2ag Job Discrimination (Age))","42:2000bb":"42:2000bb (42:2000bb Religious Freedom Restoration Act of 1993)","42:2000bea":"42:2000bea (42:2000bea Equal access to public facilities)","42:2000c-6":"42:2000c-6 (42:2000c-6ed Discrimination in Education)","42:2000cc":"42:2000cc (42:2000cc Religious Land Use & Institutionalized Persons Act of 2000)","42:2000d":"42:2000d (42:2000d Federally Assisted Programs)","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000e-5":"42:2000e-5 (42:2000e-5eeo Petition to Enforce EEOC Subpoena)","42:2000e2e":"42:2000e2e (42:2000e-2e Job Discrimination (Unlawful Employment Practices))","42:2000no":"42:2000no (42:2000e-2no Job Discrimination (National Origin))","42:2000ot":"42:2000ot (42:2000e-2ot Job Discrimination (other))","42:2000pb":"42:2000pb (42:2000e-2pb Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000e-2ra Job Discrimination (Race))","42:2000rl":"42:2000rl (42:2000e-2rl Job Discrimination (religion))","42:2000sh":"42:2000sh (42:2000e-2sh Job Discrimination (Sexual Harassment))","42:2000sx":"42:2000sx (42:2000e-2sx Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2210":"42:2210 (42:2210 Indeminification & Limitation of Liability-Financial)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:2996":"42:2996 (42:2996 Legal Services Corporation Act)","42:3058(g)":"42:3058(g) (42:3058(g) Older American's Act of 1965, 42 U.S.C. 3058(g) (State Long-term Care Ombudsman Program))","42:3121":"42:3121 (42:3121 Public Works and Economic Development Act of 1965)","42:3133":"42:3133 (42:3133 Coordination - Grants for Public Works and Economic Development)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:3604(f)":"42:3604(f) (42:3604(f)(3)(c ) Fair Housing Amendments Act)","42:3610":"42:3610 (42:3610 Fair Housing Act-Administrative Enforcement; Preliminary Matters)","42:3612":"42:3612 (42:3612 Civil rights in housing - Enforcement by Secretary)","42:3613":"42:3613 (42:3613 Action for inj relief re deprivation of civil rights)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4013":"42:4013 (42:4013 National Flood Insurance Act - Nature and Limitation of Insurance Coverage)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4721":"42:4721 (42:4721 Intergovernmental Personnel Act (findings and purposes))","42:4821":"42:4821 (42:4821 Lead-Based Paint Poisoning Prevention Act (findings and purposes) )","42:4901":"42:4901 (42:4901 Noise Control Act of 1972 (findings and purposes))","42:4910(c":"42:4910(c (42:4910(c ) Action to restrain violation re noise control)","42:5101":"42:5101 (42:5101 Child Abuse Prevention and Treatment Act)","42:5303":"42:5303 (42:5303 Block Grant Act of 1974 (42 USC 5301-5321))","42:5401":"42:5401 (42:5401 Natl Mnfactrd Housing Cnstr Safety Standard Act 1974 (findings and purposes))","42:5411":"42:5411 (42:5411 Housing Construction and Safety Standards Act - Injunctive Relief)","42:5851":"42:5851 (42:5851 Discrimination Whistle blower Employee - ERA (employee protection))","42:6101":"42:6101 (42:6101 Age Discrimination in Federally Assisted Programs (statement of purpose))","42:6201":"42:6201 (42:6201 Energy Policy & Conservation Act (statement of purpose))","42:6393":"42:6393 (42:6393 Controversies under Energy Policy & Conservation Act (Admin Procedure and Judicial Review))","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:6928":"42:6928 (42:6928 Violations of requirements of hazardous Waste Mgmt (federal enforcement))","42:6961":"42:6961 (42:6961 Federal Facilities Compliance Act)","42:6972":"42:6972 (42:6972 Private Action for Remediation (Environment))","42:6972(a)":"42:6972(a) (42:6972(a) Solid Waste Disposal Act - Citizen Suit)","42:7192":"42:7192 (42:7192 Controversies under Dept of Energy Organization Act - Judicial Review)","42:7384":"42:7384 (42:7384 Energy Employees Occupational Illness Compensation Program Act (EEOICPA))","42:7401":"42:7401 (42:7401 Clean Air Act (findings & declarations))","42:7412":"42:7412 (42:7412 Air Pollution Control - emission standards )","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7413(b)":"42:7413(b) (42:7413(b) Clean Air Act - Enforcement)","42:7475":"42:7475 (42:7475 Clean Air Act - Preconstruction Requirements)","42:7545":"42:7545 (42:7545 Air Pollution Prevention - Regulation of Fuels)","42:7603":"42:7603 (42:7603 Action for immediate restraint (Emergency Powers))","42:7604":"42:7604 (42:7604 Clean Air Act - Citizen suit to enforce Clean Air Act)","42:7604(f)":"42:7604(f) (42:7604(f)cl Clear Air Act - Emission Standards)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:7671":"42:7671 (42:7671 Clean Air Act (Stratospheric Ozone Protection) (Definitions))","42:8324":"42:8324 (42:8324 Powerplant and Industrial Fuel Use - terms and conditions)","42:8351":"42:8351 (42:8351 Powerplant and Industrial Fuel Use - Temporary Exemptions)","42:9601":"42:9601 (42:9601 Comprehensive Environmental Compen/Resp/Liab (CERCLA) (Definitions))","42:9604":"42:9604 (42:9604 Comprehensive Envir., Response, Comp. & Liab. Act (CERCLA) - Removal and Other Remedial Acti)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","42:9613":"42:9613 (42:9613 Comp Environ Recovery Comp & Liability Act (CERCLA) - Civil Proceedings)","43:1333":"43:1333 (43:1333 Outer Continental Shelf Lands Act - Laws and Regulations Governing Lands)","43:1349":"43:1349 (43:1349 Outer Continental Land Shelf Act - Citizen Suits)","43:1701":"43:1701 (43:1701 Violation of Federal Land Policy and Management Act (FLPMA))","43:1737":"43:1737 (43:1737 FLPMA - Implementation Provisions)","43:421":"43:421 (43:421 Complaint in Condemnation - Eminent Domain)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:945b":"43:945b (43:945b Complaint in Condemnation - Easements)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","44:2107":"44:2107 (44:2107 Presidential Recordings and Materials Act (NARA acceptance of records for historical preserv)","45:0051":"45:0051 (45:51 Railways: Fed. Employers Liability Act)","45:0056":"45:0056 (45:0056 Employers Liability Act - Personal Inj re Railroads (bringing an action))","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0152":"45:0152 (45:0152 Railway Labor Act - General Duties)","45:0153":"45:0153 (45:0153 First Railway Labor Act - National Railroad Adjustment Board)","45:0159":"45:0159 (45:0159 Review of arbitration award (RR Carriers/Mediation Bd))","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:0231(f)":"45:0231(f) (45:0231(f) Compel obedience to order of Railroad Retirement Bd)","45:0351":"45:0351 (45:0351 Railroad Unemployment Insurance Act)","45:0719":"45:0719 (45:0719 Regional Rail Reorganization Act of 1973 (judicial review))","45:1105":"45:1105 (45:1105 Northeast Rail Service Act - Judicial Review)","46:0688":"46:0688 (46:688 Jones Act)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:2114":"46:2114 (46:2114 Wrongful Discharge from Employment - protection from discrimination)","46:30101":"46:30101 (46:30101 Extension of jurisdiction to cases of damage or injury on land)","46:30302":"46:30302 (46:30302 Shipping: Damages for Death on High Seas )","46:30304":"46:30304 (46:30304 Breach of Maritime Contract - liability of noncompliance)","46:30503":"46:30503 (46:30503 Limitation of Liability - declaration of nature and value of goods)","46:30504":"46:30504 (46:30504 Limitation of Liability - loss by fire)","46:30505-3":"46:30505-3 (46:30505-30510 Exoneration, Limitation of Liability)","46:30511":"46:30511 (46:30511 Action by owner for limitation)","46:30701":"46:30701 (46:30701 Marine Cargo Loss or Damage - Liability of Water Carriers)","46:30704":"46:30704 (46:30704 Liability of Water Carriers - Loading, stowage, custody, care, and delivery)","46:30902 t":"46:30902 t (46:30902 to 30911 Suits in Admiralty Act )","46:31102":"46:31102 (46:31102 Public Vessels Act - Waiver of Immunity)","46:31301":"46:31301 (46:31301 Federal Maritime Lien Act)","46:31301 t":"46:31301 t (46:31301 to 31343 Maritime Commercial Instruments and Liens Act)","46:31321":"46:31321 (46:31321 Foreclosure of Preferred Ship Mortgages)","46:31325":"46:31325 (46:31325 Suit to enforce lien upon mortgaged vessel-foreclosure / Foreclosure of Preferred Foreign S)","46:31341":"46:31341 (46:31341 Federal Maritime Lien Act)","46:31343":"46:31343 (46:31343 Commercial Instruments & Maritime Liens)","46:40101":"46:40101 (46:40101 Shipping Act of 1998 )","46:41102(a":"46:41102(a (46:41102(a) Shipping Act of 1984 - General Prohibitions)","46:41309":"46:41309 (46:41309 Shipping Act of 1984 - Enforcement of Reparation Orders)","46:50101":"46:50101 (46:50101 Violation of Maritime Regulations )","46:58109":"46:58109 (46:58109 Violation of Merchant Marine Act - Penalties)","47:0151":"47:0151 (47:0151 Federal Communications Act of 1934)","47:0151cs":"47:0151cs (47:0151cs Federal Communications Act - Collection for Services)","47:0201bt":"47:0201bt (47:0201bt Breach of Tariff)","47:0203":"47:0203 (47:0203 Telecommunications Collection of Charges)","47:0205":"47:0205 (47:0205 Wire and Radio Communication Svc and Charges (Recovery of Damages) )","47:0206":"47:0206 (47:0206 Carrier's Liability for Damages)","47:0227":"47:0227 (47:0227 FCC-Unsolicited Telephone Sales)","47:0227(b)":"47:0227(b) (47:0227(b)(3) Telephone Consumer Protection Act of 1991)","47:0251":"47:0251 (47:0251 Telecommunications Act of 1996 - Interconnection)","47:0252":"47:0252 (47:0252 Telecommunications Act)","47:0254(h)":"47:0254(h) (47:0254(h) Children's Internet Protection Act)","47:0332":"47:0332 (47:332(c)(7)(B) Telecommunications Act of 1996)","47:0332(c":"47:0332(c (47:0332(c ) Federal Telecommunications Act of 1996)","47:0338":"47:0338 (47:0338 Satellite Home Viewer Improvement Act)","47:0401":"47:0401 (47:0401 Application of Federal Communication Comm for Inj. (Enforcement Provisions))","47:0407":"47:0407 (47:0407 Order for payment of money; petition for enforcement;)","47:0510":"47:0510 (47:0510 Forfeiture of Communications Devices)","47:0521":"47:0521 (47:0521 Cable Televsn. Consumer Protection & Competition Act of 1992)","47:0532":"47:0532 (47:0532 Cable Communication Policy Act of 1984)","47:0551":"47:0551 (47:0551 Cable Communications Act)","47:0553":"47:0553 (47:0553 U.S.C.A. Cable Communications Policy Act)","47:605":"47:605 (47:605 Communications Act of 1934)","49:0101":"49:0101 (49:0101 ICC Termination Act of 1996)","49:0502":"49:0502 (49:0502 Transportation Administrative Subpoena)","49:10101":"49:10101 (49:10101 Interstate Commerce Act-Interstate Transportation Rail)","49:10743":"49:10743 (49:10743 Revised Interstate Commerce Act)","49:11101":"49:11101 (49:11101 Interstate Commerce Act)","49:1113":"49:1113 (49:1113 Petition to enforce administrative summon)","49:1136":"49:1136 (49:1136 Aviation Disaster Family Assistance Act of 1996)","49:11501":"49:11501 (49:11501 Railroad Revitalization & Regulatory Reform Act (General jurisdiction))","49:11502":"49:11502 (49:11502 Railroad Revitalization Regulatory Reform (authority to exempt rail carrier transportation))","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:11705":"49:11705 (49:11705 Limitation on actions by and against rail carriers)","49:11706":"49:11706 (49:11706 Carmack Amendent (Liability of carriers under receipts and bills of lading))","49:11707":"49:11707 (49:11707 Carmack Amendment (Liability when property is delivered in violation of routing instruction)","49:13101":"49:13101 (49:13101 Transportation Policy)","49:13702":"49:13702 (49:13702 Tariff requirement for certain transportation)","49:13706":"49:13706 (49:13706 Motor Carriers, etc-Liability for Payment of Rates)","49:14501":"49:14501 (49:14501 Preemption (federal authority of intrastate transportation))","49:14705":"49:14705 (49:14705 Interstate Commerce Act/Carmack Amendment (Limitations on actions by and against carriers))","49:14706":"49:14706 (49:14706 Carmack Amendment to the Interstate Commerce Act / Liability of Carriers - Receipts & Bills)","49:20301-2":"49:20301-2 (49:20301-20306 Federal Safety Appliance Act)","49:21302":"49:21302 (49:21302 Carriers violations of Interstate Commerce Act (Chapter 201 accident and incident violation)","49:30101":"49:30101 (49:30101 National Traffic & Motor Vehicle Safety Act )","49:30112":"49:30112 (49:30112 Motor Vehicle Safety (prohibition on non-complying motor vehicles and equipment))","49:30502":"49:30502 (49:30502 Natl Motor Vehicle Title Information Syst)","49:31114":"49:31114 (49:31114 Access to Interstate System/Commercial Motor Vehicle )","49:31502":"49:31502 (49:31502 Motor Carrier Safety: Requirements for Qualifications)","49:32101":"49:32101 (49:32101 Motor Vehicle Information and Costs Savings Act)","49:32701":"49:32701 (49:32701 Odometer Requirements Act)","49:40101":"49:40101 (49:40101 Federal Aviation Act)","49:40102":"49:40102 (49:40102 Airline Deregulation Actv(definitions of air and commerce safety) )","49:40105":"49:40105 (49:40105 Warsaw Convention )","49:41705":"49:41705 (49:41705 Air Carrier Access Act (discrimination against handicapped individuals))","49:41713":"49:41713 (49:41713 Airline Deregulation Actv (premp of authority over prices, routes, and service))","49:44709":"49:44709 (49:44709 Noise Control Act of 1972 )","49:44715":"49:44715 (49:44715 Noise Control Act of 1972 )","49:46507":"49:46507 (49:46507 False information and threats)","49:47101":"49:47101 (49:47101 Airport and Airway Improvement Act of 1982)","49:47501":"49:47501 (49:47501 Aviation Safety & Noise Abatement Act of 1979 )","49:49101":"49:49101 (49:49101 Wrongful Termination in Contravention of Published Regulations)","49:49104":"49:49104 (49:49104 Breach of Lease by Metro. Wash. Airport Auth.)","49:60101":"49:60101 (49:60101 Pipeline Safety Act of 1994)","49:60102":"49:60102 (49:60102 Hazardous Liquid Pipeline Safety Act of 1979 (HLPSA))","49:80102":"49:80102 (49:80102 Bills of Lading - Application)","49:80302":"49:80302 (49:80302 Contraband - Prohibitions)","49:80303":"49:80303 (49:80303 Seizure and forfeiture of vessel or aircraft conveying contraband )","50:1701-17":"50:1701-17 (50:1701-1706 International Emergency Economic Powers Act)","50a:1":"50a:1 (50a:1 Trading With the Enemy Act (act located in Title 50, Appendix.))","50a:2412":"50a:2412 (50a:2412 Export Administration Act--1979 (act located in Title 50, Appendix.))","50a:501":"50a:501 (50a:501 Sailors and Soldiers Civil Relief Act (act located in Title 50, Appendix.))","50a:533":"50a:533 (50a:533 Servicemembers Civil Relief Act-mortgages (act located in Title 50, Appendix.))","50a:540":"50a:540 (50a:540 Sailors and Soldiers Civil Relief Act (act located in Title 50, Appendix.))","51:20137(a":"51:20137(a (51:20137(a) Malpractice & Negligence Against U.S. Space program )","misc":"misc (Civil Miscellaneous Case)"},"iddce":{"0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:1221":"05:1221 (05:1221 Federal Whistleblower Protection Act)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (07:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (07:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2302":"07:2302 (07:2302 Agricultural Fair Practices Act)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:0287":"08:0287 (08:287 Petition to Enforce INS Subpoena)","08:1105":"08:1105 (08:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1446":"08:1446 (08:1446 Petition for Naturalization Hearing)","08:1451":"08:1451 (08:1451 Revocation of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (09:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:10 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","11:0342":"11:0342 (11:342 Bankrupty Notice)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection under Contract Guaranty)","12:1811":"12:1811 (12:1811 Federal Deposit Insurance Act)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissory Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:45 Federal Trade Commission Act)","15:0052":"15:0052 (15:52 Federal Trade Commission Act)","15:0053":"15:0053 (15:53 Federal Trade Commission Act)","15:0053(b)":"15:0053(b) (15:53(b) Prelim & Perm Inj Relief & Other Equitable Relief)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1691":"15:1691 (15:1691 Equal Credit Opportunity Act;Consumer Protection Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693":"15:1693 (15:1693 Electronic Fund Transfer Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","15:7701":"15:7701 (15:7701 Congressional findings and policy)","15:7704":"15:7704 (15:7704 Other protections for users of commercial electronic mail)","15:7706":"15:7706 (15:7706 Enforcement generally)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:0791":"16:0791 (16:791 Federal Power Act)","16:0814":"16:0814 (16:814 Power of Eminent Domain/Waterways)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0923":"18:0923 (18:923 Firearms Sales - Licensing)","18:0981":"18:0981 (18:981 Forfeiture of Property - Contract Fraud/Sole Source)","18:1514":"18:1514 (18:1514 Motion for Issuance of Protective Order (harassment))","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1955":"18:1955 (18:1955 Forfeiture of Real Property)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2254":"18:2254 (18:2254 Civil Forfeiture)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0331":"21:0331 (21:331 Federal Food Drug & Cosmetic Act)","21:0841":"21:0841 (21:841 Forfeiture Property - Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property - Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0357":"25:0357 (25:0357 Condemnation of Indian Lands)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1303cc":"25:1303cc (25:1303 Tribal Court Jurisdiction - Child Custody)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6330":"26:6330 (26:6330 Notice & Opportunity for Hearing - IRS Levy)","26:6502":"26:6502 (26:6502 IRS: Enforcement of Tax Liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:158 Notice of Appeal re Bankruptcy Matter (BAP))","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Fed. Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed. Question: Fed Communications Act of 1934)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Fed. Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Fed. Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity-Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel, Assault, Slander)","28:1332lm":"28:1332lm (28:1332 Diversity-Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 Diversity-Securities & Exchange Commission Act)","28:1332sf":"28:1332sf (28:1332 Diversity-Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity-Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-core))","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgement)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal- Employment Discrimination)","28:1441fc":"28:1441fc (28:1441 Petition for Removal- Fair Credit Reporting Act)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interpleader)","28:1441lb":"28:1441lb (28:1441 Petition for Removal- Libel, Assault, Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition for Removal- Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)","28:1441sa":"28:1441sa (28:1441 Petition for Removal- SEC Act)","28:1441sf":"28:1441sf (28:1441 Petition for Removal- Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446 Petition for Removal- Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Petition for Writ of Habeas Corpus (Federal))","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:2679":"28:2679 (28:2679 Certification as US Employee)","28:3001":"28:3001 (28:3001 Federal Debt Collection Procedures Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0790":"29:0790 (29:790 Rehabilitation of Labor)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 E.R.I.S.A.-Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 E.R.I.S.A.)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2601":"29:2601 (29:2601 Family Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:801 Penalties/Federal Mine Safety Health Act - 1977)","30:0818":"30:0818 (30:818 Federal Mine Safety & Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recover Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 Veteran's Readjustment Assistance Act of 1974)","38:3116":"38:3116 (38:3116 VA Overpayment)","39:0409":"39:0409 (39:409 Postal Service)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:3133":"40:3133 (40:3133 Rights of Persons Furnishing Labor or Material)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts-Unlawful Employment Practices)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:10801":"42:10801 (42:10801 Protection & Advocacy for Individuals w/Mental Ill)","42:11603":"42:11603 (42:11603 International Child Abduction Remedies Act)","42:12101":"42:12101 (42:12101 Americans with Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000 Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accommodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:3601 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)","42:5851":"42:5851 (42:5851 Nuclear Whistleblower Protection - Employee Discrim)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:0945":"43:0945 (43:945 Compensation for Land Condemnation)","43:0945a":"43:0945a (43:945a Complaint in Condemnation)","43:0946":"43:0946 (43:946 Complaint in Condemnation - Eminent Domain)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0153":"45:0153 (45:153 Action to Set Aside Award of a System Board of Adjust)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:0153":"47:0153 (47:153 Telecommunications Act of 1966)","47:0605":"47:0605 (47:605 Federal Communications Act of 1934)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summons)","49:31105":"49:31105 (49:31105 Surface Transportation Assistance Act)","49:5101":"49:5101 (49:5101 Federal Hazardous Materials Transportation Law)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"ilcdce":{"0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:555e":"05:555e (05:555 Enforcement of Agency Subpoena)","05:555q":"05:555q (05:555 Quash Agency Subpoena)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8701":"05:8701 (05:8701 FEGLI Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2023":"07:2023 (07:2023 Business Disqualification for Food Stamp Program)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1421":"08:1421 (08:1421 Review of Denial of Application for Naturalization)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1447b":"08:1447b (08:1447(b) Naturalization - Request for Hearing Before U.S. District Court)","08:287":"08:287 (08:287 Petition to Enforce INS Subpoena)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:2605":"12:2605 (12:2605 Mortgage Servicer Failure to Comply w/Request f/Info)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","12:4001":"12:4001 (12:4001 Expedited Funds Availability Act)","14:0088":"14:0088 (14:88 False Distress Signal to Coast Guard)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693":"15:1693 (15:1693 Electronic Fund Transfer Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","15:6101":"15:6101 (15:6101 Telemarketing Act/Consumer Fraud)","15:717":"15:717 (15:717(h) Natural Gas Act)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","17:1203":"17:1203 (17:1203 Digital Millennium-Copyright Act)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1030":"18:1030 (18:1030(g) Computer Fraud and Abuse Act)","18:1345":"18:1345 (18:1345 Injunction Against Fraud)","18:1517":"18:1517 (18:1517 Obstructing Examination of Financial Institution)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2119":"18:2119 (18:2119 Motor Vehicle Theft - Carjacking)","18:2254":"18:2254 (Forfeiture of Property)","18:2510":"18:2510 (18:2510 Wire/Electronic/Oral Communications Interception)","18:2707":"18:2707 (18:2707 Wire/Electronic/Transactional Record Access)","18:2710":"18:2710 (18:2710 Video Privacy Act of 1988)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","18:981a":"18:981a (18:981(a)(1)(D) Asset Forfeiture)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1415":"20:1415 (20:1415 Individuals with Disabilities Education Act)","20:1681":"20:1681 (20:1681 Discrimination in Federally-Funded Education Program)","21:0301":"21:0301 (21:301 Federal Food, Drug & Cosmetics Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","21:842c":"21:842c (21:842c Comprehensive Drug Abuse Prevention and Control Act)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6103":"26:6103 (26:6103 Wrongful Disclosure)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7434":"26:7434 (26:7434 Civil Damages for Faudulent Filing of Info. Returns)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0157e":"28:0157e (28:0157 Bankruptcy Judge Authorized to Conduct Jury Trial)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:0881":"28:0881 (28:881 Drug Related Seizure of Property)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fm":"28:1332fm (Mortgage Foreclosure)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity - Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Notice of Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334b":"28:1334b (28:1334(b) Bankruptcy Matters (other))","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Notice of Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Notice of Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Notice of Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Notice of Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Notice of Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Notice of Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Notice of Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Notice of Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Notice of Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Notice of Removal - Employment Discrim)","28:1441er":"28:1441er (28:1441 Notice of Removal - ERISA)","28:1441fc":"28:1441fc (28:1441 Notice of Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Notice of Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Notice of Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Notice of Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Notice of Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Notice of Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Notice of Removal- Labor/Mgmnt. Relations)","28:1441mm":"28:1441mm (28:1441 Notice of Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Notice of Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Notice of Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Notice of Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Notice of Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Notice of Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Notice of Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Notice of Removal)","28:1441qt":"28:1441qt (28:1441 Notice of Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Notice of Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Notice of Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Notice of Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Notice of Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Notice of Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Notice of Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Notice of Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Notice of Removal- Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Notice of Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Notice of Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Notice of Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Notice of Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Notice of Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Notice of Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1916":"28:1916 (28:1916 Seaman's Suit Filing Fee Waived)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2284":"28:2284 (Three Judge Court)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (28:3001 Debt Collection Act)","28:3301":"28:3301 (28:3301 Fraudulent Transfer Action)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:1854":"29:1854 (29:1854 Migrant and Seasonal Agricultural Worker Protection Act)","29:2101":"29:2101 (29:2101 WARN Act)","29:2601":"29:2601 (29:2601 Family and Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","30:932a":"30:932a (30:932 Black Lung Benefits: Longshore & Harbor Workers Act)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","33:2701":"33:2701 (33:2701 Oil Pollution Act)","33:921d":"33:921d (33:921 Longshore & Harbor Workers Comp. Act: Jurisdiction)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4223":"38:4223 (38:4223 Employment Rights - Uniformed Services)","38:4301":"38:4301 (38:4301 Uniformed Svcs Emplmnt and Re-Emplmnt Act of 1994)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:0351":"41:0351 (41:0351 McNamara-O'Hara Service Contract Act of 1965)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0300g":"42:0300g (42:300g-3- Enforcement of Drinking Water Regulations)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11604":"42:11604 (42:11604 International Child Abduction Remedies Act)","42:12101":"42:12101 (42:12101 Americans with Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:13981":"42:13981 (42:13981 Violence Against Women Act)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000cc":"42:2000cc (42:2000 Religious Land Use and Institutionalized Persons Act)","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:6972":"42:6972 (42:6972 Resource and Recovery Act)","42:7401":"42:7401 (42:7401 Clean Air Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9601en":"42:9601en (42:9601 Environmental Cleanup Expenses)","42:9601rs":"42:9601rs (42:9601 Resource and Recovery Act)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:30505":"46:30505 (Limitation of Vessel Owner's Liability)","46:30511":"46:30511 (Limitation of Vessel Owner's Liability)","46:688":"46:688 (46:688 Jones Act)","46:740":"46:740 (46:740 Admiralty Jurisdiction Extension Act)","47:227":"47:227 (47:227 Telephone Consumer Protection Act)","47:332":"47:332 (47:332 Telecommunications Act of 1996)","47:605":"47:605 (47:605 Communications Act of 1934)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:10101":"49:10101 (49:10101 Rail Transportation Policy)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:14706":"49:14706 (Interstate Cargo Claim)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1671":"49:1671 (49:1671 Natural Gas Pipeline Safety Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","49:20302":"49:20302 (49:20302 Federal Safety Appliance Act)","49:32705a":"49:32705a (49:32705(a)(1)(B) Vehicle Odometer Disclosure Act/Tampering)","5:552a":"5:552a (5:552a Administrative Procedures Act)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","cvmisc":"cvmisc (Civil Miscellaneous Case)","misc":"misc (Civil Miscellaneous Case)"},"ilndce":{"02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Administrative Procedure Act)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:287":"08:287 (8:287 Petition to Enforce INS Subpoena)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","11:110i":"11:110i (11:110(i) Order on a standing petition)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2518":"18:2518 (18:2518 Interception of Wire/Oral/Electronic Communication)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:0881 Forfeiture of Property)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881c":"21:0881c (21:881 Forfeiture of Property-Currency)","21:0881dr":"21:0881dr (21:0881 Forfeiture Property-Drugs)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Federal Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mf":"28:1332mf (28:1332 Diversity-Mortgage Foreclosure)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-core))","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgement)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrimination)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting Act)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interpleader)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Remedies on motion attacking sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2101":"29:2101 (Worker Adjustment and Restraining Notification Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act - 1977)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)","38:3116":"38:3116 (38:3116 VA Overpayment)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:3131":"40:3131 (Miller Act)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:12101":"42:12101 (42:12101 Americans with Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1985cv":"42:1985cv (42:1985 Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:425":"42:425 (42:425 Social Security Benefits)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summons)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"ilsdce":{"*41*":"*41* ()","0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","18:4248":"18:4248 (18:4248(a) Adam Walsh Act)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","1:102":"1:102 (1:102 Americans with Disabilities Act)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (28:3001 Applicability of chapter)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2601":"29:2601 (29:2601 FMLA: Family and Medical Leave Act (Findings and Purposes))","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"inndce":{"0":"0 (00:0000)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:151":"07:151 (07:151 The Tax Freedom Act)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1183":"08:1183 (8:1183 Immigration and Nationality Act)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1503":"08:1503 (8:1503 - Unlawful denial of U.S. Passport)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1790":"12:1790 (12:1790 Federal Credit Union Act)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:2605":"12:2605 (12:2605 Lender Refusal to Acct for Mortgage Loan Receipts)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","12:5001-5018":"12:5001-5018 (12:5001-5018 Check Clearing for the 21st Century Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1071":"15:1071 (15:1071 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1635":"15:1635 (15:1635 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1691":"15:1691 (15:1691 Equal Credit Opportunity Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693":"15:1693 (15:1693 Electronic Funds Transfer Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","17:1203":"17:1203 (17:1203 Digital Millenium Copyright Act)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1030":"18:1030 (Computer Fraud and Abuse Act)","18:1514":"18:1514 (18:1514 Action to Restrain Harrassment of Victim or Witness)","18:1835":"18:1835 (18:1835 Orders to Preserve Confidentiality)","18:1836":"18:1836 (18:1836 Civil Proceedings to Enjoin Violations)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2254":"18:2254 (18:2254 Forfeiture - Pornography)","18:2381":"18:2381 (18:2381 Treason)","18:2510":"18:2510 (18:2510 Federal Wire Tap Act)","18:2520":"18:2520 (18:2520 Unlawful Interception of Wire Communication)","18:2721":"18:2721 (18:2721 Unlawful release of personal information from State motor vehicle records)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1071":"20:1071 (20:1071 Alledged student loan default)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1415":"20:1415 (20:1415 Individuals With Disabilities Education Act)","20:1681":"20:1681 (20:1681(a) Title IX Sex Discrimination in Education)","21:0332":"21:0332 (21:332 Federal Food Drug and Cosmetic Act)","21:0399d":"21:0399d (21:399d Employee Protections)","21:0601":"21:0601 (21:601 Federal Meat Inspection Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0853":"21:0853 (21:853Forfeiture Property - Firearms)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881cc":"21:0881cc (21:881 Forfeiture Property - Credit Card Fraud)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","21:1441ag":"21:1441ag (Petition for Removal - Agricultural Commodities Act)","21:853a":"21:853a (21:853 Forfeiture of Property - Automobiles)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6330":"26:6330 (26:6330 Review of Tax Levy)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","26:9701":"26:9701 (Coal Industry Retiree Health Benefit Act of 1992 (Coal Act))","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0187":"28:0187 (Unfair labor practices - Damages from actions of labor org)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0636":"28:0636 (28:636 Appeal to District Court from Magistrate Judgment)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331ta":"28:1331ta (28:1331 Telecommunications Act of 1996)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1356":"28:1356 (28:1356 Seizures not with Admiralty and Maritime jursdicatio)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441er":"28:1441er (28:1441 Petition for Removal-ERISA)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting)","28:1441fml":"28:1441fml (28:1441fml Petition for Removal - Family and Medical Leave Act)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441fw":"28:1441fw (28:1441 Petition for Removal - Federal Wire Tap Act)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441ti":"28:1441ti (28:1441 Petn for Removal: Trademark Infringement-Lanham Act)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 International Litigant Assistance)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2241cab":"28:2241cab (28:2241 Habeas Disciplinary (Good Time) Action)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2401":"28:2401 (28:2401(b) Final Denial of Administrative Claim)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2461":"28:2461 (28:2461 Recovery Funds or Property)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:2675":"28:2675 (28:2675 Disposition By Federal Agency As Pre-Requisite; Evidence)","28:2679":"28:2679 (28:2679 Petition for Certification of Scope of Employment)","28:3001":"28:3001 (Federal Debt Collection Procedure Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0510":"29:0510 (29:510 E.R.I.S.A.)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0631":"29:0631 (29:0631(a) Age Discrimination in Employment Act of 1967)","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1501":"29:1501 (Job Training Partnership Act)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:1854":"29:1854 (29:1854 Migrant and Seasonal Agric. Workers Proctection Act)","29:2101":"29:2101 (29:2101 WARN Act: Worker Adjustment and Retraining Notification Act)","29:2601":"29:2601 (29:2601 Family and Medical Leave Act)","29:2615":"29:2615 (29:2615 Family Medical Leave Act (FMLA))","29:2617":"29:2617 (29:2617 Family Medical Leave Act (FMLA))","29:481-84":"29:481-84 (29:481-84 Title IV Labor-Management Reporting and Disclosure Act of 1959)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","31:5317":"31:5317 (31:5317 Asset Forfeiture)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0041":"35:0041 (35:41 Patent Infringement)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4301":"38:4301 (Uniformed Services Employment and Reemployment Act of 1994)","38:4311":"38:4311 (Wrongful Termination for Membership in US Military Service)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:276":"40:276 (40:0276 Failure to pay prevailing wages in contracts with USA)","40:3133":"40:3133 (40:3133 Rights of persons furnishing labor or material)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405rsi":"42:0405rsi (42:405 Review of HHS Decision (RSI))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11601":"42:11601 (42:11601 International Child Abduction Remedies Act)","42:12101":"42:12101 (42:12101 Americans with Disabilites Act)","42:12117":"42:12117 (42:117 Americans with Disabilites Act)","42:12131":"42:12131 (42:13131 Americans With Disabilities Act)","42:1320":"42:1320 (42:1320 Health Insurance Portability and Accountability Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1395dd":"42:1395dd (42:1395 Violation of Emerg Med Treatment & Active Labor Act)","42:1395sp":"42:1395sp (42:1395 Medicare Secondary Payer Law)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:1997":"42:1997 (42:1997 Civil Rights of Institutionalized Persons Act)","42:2000a":"42:2000a (42:2000a Access to Public Accommodations)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000no":"42:2000no (42:2000 Job Discrimination (National Origin))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:4852":"42:4852 (Residential Lead-Based Paint Hazard Reduction Act)","42:5401":"42:5401 (Violation of Manufactured Housing Standards act of 1974)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:6972":"42:6972 (42:6972 Resource Conservation and Recovery Act)","42:6991":"42:6991 (Environmental Matters)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9601":"42:9601 (42:9601 Comprehensive Env Response, Compensation & Liability Act)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0056":"45:0056 (45:56 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0183":"46:0183 (46:183 Action for Limitation of and Exoneration from Liability)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:31342":"46:31342 (46:31342 Maritime Liens)","47:227":"47:227 (47:227 Telephone Consumer Protection Act)","47:521":"47:521 (47:521 Cable Communications Policy Act of 1984)","47:553":"47:553 (47:553 Unauthorized Reception of Cable/Satellite TV)","47:605":"47:605 (47:605 Federal Communications Act of 1934)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1983":"48:1983 (Petition for Judicial Review of State Board of Special Ed)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:10101":"49:10101 (49:10101 Interstate Commerce Act)","49:10741":"49:10741 (49:10741 Collection of unpaid freight bills)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:14706":"49:14706 (49:14706 Damages to Interstate Shipments by Motor Carriers)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","49:20109":"49:20109 (49:20109 Railway: Employee Protections)","49:501":"49:501 (49:501 Federal Motor Carrier Saftey Regulation)","7:2023":"7:2023 (7:2023 Food Stamp Program - denial of application to partic.)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"insdce":{"0":"0 (No cause code entered)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1421":"08:1421 (08:1421 Immigration: Naturalization Authority)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1447":"08:1447 (08:1447 Immigration: Review of Denial of Naturalization Application)","08:1451":"08:1451 (08:1451 Immigration: Revocation of Citizenship)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1345":"18:1345 (18:1345 Injunction against Fraud)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","18:981":"18:981 (Civil Forfeiture)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1415":"20:1415 (20:1415 IDEA: Challenge decision re education for handicapped)","20:1681":"20:1681 (20:1681 Title IX Educational Amendments - Sex Discrimination)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0842":"21:0842 (21:0842 Civil Penalty for Violation re Controlled Substance)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7433":"26:7433 (26:7433 IRS: Civil Damages for Unauthorized Collection Actions)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331as":"28:1331as (28:1331 Fed. Question: Assault, Libel, Slander)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1367":"28:1367 (28:1367 Other Property Damage)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1407pl":"28:1407pl (28:1407 Products Liability)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1605A":"28:1605A (28:1605 Antiterrorism & Effective Death Penalty Act 1996)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2101":"29:2101 (29:2101 Worker Adjustment and Retraining Notification Act)","29:2104":"29:2104 (29:2104 Worker Adjustment & Retraining Notification (WARN))","29:2601":"29:2601 (29:2601 FMLA:Family and Medical Leave Act)","29:2612":"29:2612 (29:2612 FMLA: Leave Requirements)","29:2617":"29:2617 (29:2617 FMLA: Enforcement)","29:701":"29:701 (29:701 Vocational Rehabilitation)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4311":"38:4311 (38:4311 Uniformed Service Employment or Reemployment Rights Act (USERRA) - Discrimination)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0254o":"42:0254o (42:254o Breach of Scholarship Contract)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:10801":"42:10801 (42:10801 Protection & Advocacy for Individuals with Mental Illness Act of 1986 (PAIMI))","42:10805":"42:10805 (42:10805 Protection and Advocacy System)","42:12101":"42:12101 (42:12101 The Americans with Disabilities Act)","42:12117":"42:12117 (42:12117 Americans with Disabilities Act - Enforcement)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1395dd":"42:1395dd (42:1395dd Exam & Treatment Emergency Med Cond & Women in Labor)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1973gg2":"42:1973gg2 (42:1973gg-2 Nat'l. Voter Registration Act of 1993 (NVRA))","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981ra":"42:1981ra (42:1981ra Race Discrimination)","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000cc":"42:2000cc (42:2000 Religious Land Use & Institutionalized Persons Act of 2000)","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000e2e":"42:2000e2e (42:2000e-2e Injunctive Relief/TRO (Unlawful Employment Practices))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:405rs":"42:405rs (42:405rs Review of HHS Decision (RSI))","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9601":"42:9601 (42:9601 Comprehensive Environmental Compen/Resp/Liab (CERCLA) (Definitions))","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:227b3":"47:227b3 (47:227b3 Telephone Consumer Protection Act)","47:605":"47:605 (47:605 Unlawful Reception Broadcast Signal i.e., Satellite Comm.)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:14706":"49:14706 (49:14706 Carmack Amendment to the Interstate Commerce Act)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"ksdce":{"0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:1926":"07:1926 (07:1926 Water and Waste Facility Loans and Grants)","07:2023":"07:2023 (07:2023 Agriculture Food Stamp Program)","07:2131":"07:2131 (07:2131 Animal Welfare Act)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","07:6999":"07:6999 (07:6999 Judicial Review from Agency Action)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451":"08:1451 (08:1451 Immigration and Nationality Act of 1952)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","09:0206":"09:0206 (9:206 Order to Compel Arbitration)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1261":"15:1261 (15:1261 - Federal Hazardous Substances Act FHSA)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1691":"15:1691 (15:1691 Equal Credit Opportunity)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693":"15:1693 (15:1693 Electronic Funds Transfer Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:0791":"16:0791 (16:791 Federal Power Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","16:3837":"16:3837 (16:3837 Wetlands Reserve Program)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0981":"18:0981 (18:981 Civil Forfeiture)","18:1030":"18:1030 (18:1030 Fraud and Related Activity in Connection with Computers)","18:1345":"18:1345 (18:1345 Injunctions Against Fraud)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2511":"18:2511 (18: 2511 Interception and Disclosure of Wire, Oral or Electronic Communications)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1681":"20:1681 (20:1681 Education: Sex Discrimination)","21:0331":"21:0331 (21:0331 Federal Food, Drug, and Cosmetic Act)","21:0801":"21:0801 (21:801 COMPREHENSIVE DRUG ABUSE PREVENTION AND CONTROL ACT)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","25:3731":"25:3731 (25:3731 Haskell Indian Nations University and Southwestern Indian Polytechnic Institute Adminstrativ)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6320":"26:6320 (26:6320 Notice and Hearing Upon Filing of Notice of Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7405":"26:7405 (26:7405 Recovery of Erroneous Refund)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7433":"26:7433 (26:7433 IRS: Unauthorized Collection Action)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1339":"28:1339 (28:1339 Postal Matters)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Multi-District Litigation)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1875":"28:1875 (28:1875 Protection of Jurors Employment)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","28:875":"28:875 (28:0875 Protection of Jurors Employment)","29:0141":"29:0141 (29:141 Labor Management Relations Act)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0660":"29:0660 (29:0660 Occupational Safety and Health Act)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2101":"29:2101 (29:2101 Worker Adjustment Retraining Notification (WARN))","29:2601":"29:2601 (29:2601 Family Medical Leave Act)","29:2617":"29:2617 (29:2617(a)(2) Family and Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Civil Actions for False Claims)","31:3731":"31:3731 (31:3731 Fraud)","31:3801":"31:3801 (31:3801 Program Fraud Civil Remedies Act)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4301":"38:4301 (38:4301Federal Uniformed Services Employment/Re-Employment Act)","38:4323":"38:4323 (38:4323 Enforcement of employer rights)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11603":"42:11603 (42:11603 International Child Abduction Remedies Act)","42:12101":"42:12101 (42:12101 Americans with Disabilities Act)","42:12131":"42:12131 (42:12131 Civil Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:13981":"42:13981 (42:13981 Violence Against Women Act (VAWA))","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sh":"42:1981sh (42:1981 Sexual Harrassment)","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000cc":"42:2000cc (42:2000 Protection of Land Use as Religious Exercise)","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:425":"42:425 (42:427 Social Security Benenfits)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:4852d":"42:4852d (42:4852d Disclosure of Information Concerning Lead)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9601":"42:9601 (42:9601 Environmental Cleanup)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:0151":"47:0151 (47:0151 Communications Act of 1934)","47:0227":"47:0227 (47:0227 Telephone Consumer Protection Act)","47:0332":"47:0332 (47:0332 Mobile Services)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:10101":"49:10101 (49:10101 Interstate Commerce Act)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","49:3102":"49:3102 (49:3102 Motor Carrier Safety Requirements)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"kyedce":{"0":"0 (No cause code entered)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","18:4245":"18:4245 (18:4245 Petition to Determine Mental Cond. of Impris..Person)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1681":"20:1681 (20:1681 Title IX Educational Amendments 1992 - Sex Discrimination)","20:1683":"20:1683 (20:1683 Judicial Review: Prohibition against sex discrimination in education)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Removal of Criminal Prosecution - Civil Rights)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2244":"28:2244 (Second Petition for Writ of Habeas Corpus )","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2462":"28:2462 (Occupation Safety and Health Act of 1970)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2001":"29:2001 (Employee Polygraph Protection Act )","29:2101":"29:2101 (29:2101 Workers Adjustment - Retraining Notification Act )","29:2601":"29:2601 (29:2601 Family Leave Act )","29:2612":"29:2612 (29:2612 Family and Medical Leave Act )","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4301":"38:4301 (38:4301 Uniformed Services Employment and Reemployment Rights Act)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:12101":"42:12101 (42:12101et seq. - Americans with Disabilities Act )","42:1331":"42:1331 (42:1331 Prisoner Civil Rights - Bivens Action )","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0183":"46:0183 (46:183 Limitation of Vessel Owners Liability)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"kywdce":{"0":"0 (No cause code entered)","02:0138":"02:0138 (02:138 Library of Congress Access)","02:0358":"02:0358 (02:358 President's Recommendations on Exec., Jud. & Leg. Salary)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","02:0681":"02:0681 (02:681 Deferral of Budget Authority)","02:1202":"02:1202 (02:1202 Discriminatory practices affecting US Senate employees)","02:1301":"02:1301 (02:1301 Congressional Accountability Act)","02:1317(a)":"02:1317(a) (02:1317(a) Violation of Congressional Accountability Act)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0101":"05:0101 (05:101 Ethics in Government Act)","05:0504":"05:0504 (05:504(c)(2) Equal Access to Justice (Govt Employees))","05:0504(c )(2)":"05:0504(c )(2) (05:0504(c )(2) Equal Access to Justice (Govt Employees))","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552b(g)sa":"05:0552b(g)sa (05:0552b(g)sa Implement requirements of Govt in Sunshine Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0552sa":"05:0552sa (05:552b(g)sa Implement requirements of Govt in Sunshine Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0555(b)":"05:0555(b) (05:0555(b) Agency Decision - Right to Counsel )","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:0706":"05:0706 (05:0706 Judicial Review of Agency Action)","05:1508":"05:1508 (05:1508 Judicial Review of Order Issued by the Merit Systems Protection Board)","05:2302":"05:2302 (05:2302 Federal Whistleblowing Act / Civil Service Reform Act (CSRA))","05:3318":"05:3318 (05:3318 Veterans Preference Act)","05:5514":"05:5514 (05:5514 Debt Collection Act of 1982)","05:5542":"05:5542 (05:5542 Federal Employees Pay Act -- overtime rates)","05:7101":"05:7101 (05:7101 Labor-Management Relations (Findings and Purpose))","05:7123":"05:7123 (05:7123 Petition by FLRA against unfair labor practices)","05:7501":"05:7501 (05:7501 Government Employees Adverse Action--14 days or less)","05:7511":"05:7511 (05:7511 Government Employees Adverse Action--Over 14 days)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8101":"05:8101 (05:8101 Workmen's Compensation Benefits)","05:8110":"05:8110 (05:8110 Augmented Compensation for dependents of Govt. Employees)","05:8316":"05:8316 (05:8316 Claims agst US re Retirement for Federal Emp.)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","05:8701":"05:8701 (05:8701 Federal Employees Group Life Insurance Act of 1954)","05:8705":"05:8705 (05:8705 Declaratory Judgment - Insurance)","05:8715":"05:8715 (05:8715 Claims against the US - Jurisdiction of Courts)","05:8901":"05:8901 (05:8901 Federal Employees Health Benefits Act)","05:8902":"05:8902 (05:8902 Contracting Authority of OPM - Group Health Insurance )","05:8903":"05:8903 (05:8903 Federal Employees Health Benefit Act)","05:8912":"05:8912 (05:8912 Claims agst US re health benefits for Federal emp.)","07:0001":"07:0001 (07:0001 Commodity Exchange Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0006(b)":"07:0006(b) (07:0006(b) Federal Commodity Exchange Regulation)","07:0009a":"07:0009a (07:0009a Recovery of penalties by Commodity Futures Trading Com)","07:0013a":"07:0013a (07:0013a Contract market rules violations; recovery of penalty)","07:0013a-1":"07:0013a-1 (07:0013a-1 Enjoin or restrain violations Contract Market rules)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0087":"07:0087 (07:0087 Enforcement of United States Grain Standards Act)","07:0136":"07:0136 (07:0136 Violations of EPA re Environmental Pesticide Control)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0193(b)":"07:0193(b) (07:0193(b) Recovery of penalties re violations by packers)","07:0203":"07:0203 (07:0203 Recovery of penalties for violations by stockyards)","07:0209(b)":"07:0209(b) (07:0209(b) Violations re purchase, sale, handling of livestock)","07:0210(f)":"07:0210(f) (07:0210(f) Suit to enforce award of damages (Packers/Stockyards))","07:0213(b)":"07:0213(b) (07:0213(b) Unfair, discriminatory, deceptive practice/marketing)","07:0216":"07:0216 (07:0216 Injunctions to restrain & enforce orders of Secretary)","07:0222":"07:0222 (07:0222 Adoption of FTC powers for enforcement.)","07:0228a":"07:0228a (07:0228a Request by Secretary for TRO or Inj. re Poultry)","07:0245":"07:0245 (07:0245 Action on bond by person injured in Warehouse)","07:0292":"07:0292 (07:0292 Monopolizing or restraining trade & enhancing prices)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0499E(c )(4)":"07:0499E(c )(4) (07:0499E(c )(4) Perishable Agricultural Commodities Act (PACA))","07:0601":"07:0601 (07:601 USDA Condemnation)","07:0608":"07:0608 (07:0608 Agriculture Adjustment Act)","07:0901":"07:0901 (07:0901 Rural Electrification Act)","07:1291(b)":"07:1291(b) (07:1291(b) Agricultural Adjustment Act; freight rates.)","07:1376":"07:1376 (07:1376 Adjustment of Quotas and Enforcement; penalties.)","07:1501":"07:1501 (07:1501 Federal Crop Insurance Act)","07:1508":"07:1508 (07:1508 Crop Insurance)","07:1631":"07:1631 (07:1631 Food Security Act)","07:1721":"07:1721 (07:1721 Agricultural Trade Development Asst Act)","07:1922":"07:1922 (07:1922 Persons Eligible for Loans - Forclosure)","07:1926":"07:1926 (07:1926 Water and Waste Facility Loans and Grants)","07:1930":"07:1930 (07:1930 Perishable Agric. Comm. Act of 1930)","07:2011":"07:2011 (07:2011 Supplemental Nutrition Assistance Program)","07:2022":"07:2022 (07:2022 Disposition of Claims: Denial application to participate; food stamp prog.)","07:2023(a)":"07:2023(a) (07:2023(a) Judicial Review of Food Stamp Disqualification)","07:2024":"07:2024 (07:2024 False Claims Act, Food Stamp Fraud)","07:2131":"07:2131 (07:2131 Violation of the Animal Welfare Act)","07:2146":"07:2146 (07:2146 Transportation, Sale, and Handling of Animals)","07:2301":"07:2301 (07:2301 Agricultural Fair Practices Act)","07:2305":"07:2305 (07:2305 Unfair trade practices affecting producers Agri prod)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","07:2563":"07:2563 (07:2563 Plant Variety Protection and Rights - Injunction)","07:6999":"07:6999 (07:6999 Judicial Review of Adverse Farm Agency Decision)","08:1101":"08:1101 (08:1101 Immigration & Nationality Act (Definitions))","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1105a":"08:1105a (08:1105a Immigration: Judicial Review for Battered Spouses; Deportation (INS))","08:1151":"08:1151 (08:1151 Immigration and Nationality Act of 1952)","08:1152":"08:1152 (08:1152 Immigration: Numerical limitations on individual foreign states)","08:1153":"08:1153 (08:1153 Immigration: Allocation of Immigrant Visas)","08:1154":"08:1154 (08:1154 Immigration: Procedure for Granting Immigration Status)","08:1158":"08:1158 (08:1158 Immigration & Nationality Act, Section 208 (Asylum))","08:1182":"08:1182 (08:1182 Inadmissible Aliens: Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1183":"08:1183 (08:1183 Admission of Aliens on Giving Bond or Undertaking; Return on Departure)","08:1188":"08:1188 (08:1188 Immigration: Admission of Temporary H-2A Workers)","08:1225":"08:1225 (08:1225 Immigration: Enforcement of Administrative Subpoena)","08:1231(a)(6)":"08:1231(a)(6) (08:1231(a)(6) Immigration: Due Process Clause)","08:1251(A)(4)":"08:1251(A)(4) (08:1251(A)(4) Immigration: Application for a Stay of Deportation)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1255":"08:1255 (08:1255 Immigration: Failure USCIS To Adjudicate Permanent Residency Petition)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1357":"08:1357 (08:1357 Immigration and Nationality Act - Administrative Search Warrant)","08:1421":"08:1421 (08:1421 Immigration: Naturalization Authority)","08:1445":"08:1445 (08:1445 Immigration: Application for Naturalization)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1447":"08:1447 (08:1447 Immigration: Review of Denial of Naturalization Application)","08:1451":"08:1451 (08:1451 Immigration: Revocation of Citizenship)","08:1451(a)":"08:1451(a) (08:1451(a) Action to revoke Citizenship)","08:1451(j)":"08:1451(j) (08:1451(j) Immigration: Motion to Correct Order & Judg. of Naturalization)","08:287":"08:287 (08:287 Petition to Enforce INS Subpoena)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0003":"09:0003 (09:0003 Application to Stay Proceedings Pending Arbitration)","09:0004":"09:0004 (09:0004 Petition to order arbitration; failure to arbitrate)","09:0007":"09:0007 (09:0007 Petition to compel attendance before arbitrator)","09:0008":"09:0008 (09:0008 Declaratory Judgment/Admiralty)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","09:0011":"09:0011 (09:0011 Motion to modify or correct arbitration award)","09:0201":"09:0201 (09:0201 Petition to Compel/Stay Arbitration under an Insurance Contract)","09:0202":"09:0202 (09:0202 Award under Convention on Foreign Arbitral Awards)","09:0205":"09:0205 (09:0205 Removal from State Court: Enforcement of Foreign Arbital Awards)","09:0207":"09:0207 (09:0207 Application for order confirming award of arbitrators)","10:0672":"10:0672 (10:0672 Armed Forces: Active Guard/Reserve (AGR) Program)","10:1006":"10:1006 (10:1006 Armed Forces: Review of Agency Decision)","10:1072tc":"10:1072tc (10:1072tc Armed Forces: TRICARE PROGRAM)","10:1089(c )":"10:1089(c ) (10:1089(c ) Armed Forces: Removal; dft acting in scope of duties)","10:1091":"10:1091 (10:1091 Armed Forces: Personal Service Contracts)","10:1107":"10:1107 (10:1107 Armed Forces: Use Of Investigational New Drug)","10:1408":"10:1408 (10:1408 Armed Forces: Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2005":"10:2005 (10:2005 Armed Forces: Advanced Education Assistance)","10:2121":"10:2121 (10:2121 Armed Forces: Health Professions Scholarship Financial Asst Prog)","10:2302":"10:2302 (10:2302 Armed Forces: Arms Services Procurement Act)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","10:2323fa":"10:2323fa (10:2323fa Armed Forces: Fifth Amendment Equal Protection: Contract Goal for Small Disadvantaged Bus)","10:2733":"10:2733 (10:2733 Armed Forces: Military Claims Act)","10:2734":"10:2734 (10:2734 Armed Forces: Foreign Military Claims Act)","10:2771":"10:2771 (10:2771 Armed Forces: Final Settlement - Deceased Members)","10:3258":"10:3258 (10:3258 Armed Forces: Reg.Army: Re-enlistment after Service as Ofcr)","11:0101":"11:0101 (11:101 Bankruptcy)","11:0110":"11:0110 (11:0110 Bankruptcy: Penalty for Preparers of Fraudulent or Negligent Petitions)","11:0362(h)":"11:0362(h) (11:0362(h) Bankruptcy: Violation of Automatic Stay)","11:0523":"11:0523 (11:0523 Bankruptcy: Exceptions to Discharge)","11:0524":"11:0524 (11:0524 Bankruptcy: Effect of Discharge)","11:0525":"11:0525 (11:0525 Bankruptcy: Protections Against Discriminatory Treatment )","11:0548":"11:0548 (11:0548 Bankruptcy: Fraudulent Transfers and Obligations)","11:0704":"11:0704 (11:0704 Bankruptcy: Duties of Trustee)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0085":"12:0085 (12:0085 National Banks: Rate of Interest on Loans, Discounts, and Purchases)","12:0093(a)":"12:0093(a) (12:0093(a) National Banks: Violation of Provisions; Forfeiture of Franchise; Personal Liability of )","12:0191":"12:0191 (12:0191 National Banks: Appointment of Receiver)","12:0192":"12:0192 (12:0192 National Banks: Liquidation of National Bank)","12:0215":"12:0215 (12:0215 National Banks: Consolidation and Merger)","12:0622":"12:0622 (12:0622 Foreign Banking: Forfeiture, Dissolution, and Liability of Directors and Officers for Nonco)","12:0632":"12:0632 (12:0632 Foreign Banking: Voluntary Liquidation)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:0635i-3":"12:0635i-3 (12:0635i-3 Export-Import Bank: Breach of Insurance Contract)","12:1421":"12:1421 (12:1421 Federal Home Loan Bank Act (Short Title))","12:1441":"12:1441 (12:1441 FHLB: Financial Inst Reform Receiving Enforcement Act 1989)","12:1451":"12:1451 (12:1451 Emergency Home Loan Corporation (Definitions))","12:1452":"12:1452 (12:1452 Federal Home Loan Mortgage Corporation Act)","12:1452(f)":"12:1452(f) (12:1452(f) Fed Home Loan Mortgage Corp: Actions by and against the Corporation)","12:1455(b)":"12:1455(b) (12:1455(b) Fed Home Loan Mortgage Corp: Enforcement of Regulations)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Savings Associations: Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1715(b)":"12:1715(b) (12:1715(b) National Housing: Rules and Regulations)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1749aaa":"12:1749aaa (12:1749aaa National Housing: National Insurance Development Program)","12:1751":"12:1751 (12:1751 Fed Credit Unions: Short Title)","12:1782":"12:1782 (12:1782 Fed Credit Unions: Administration of Insurance Fund)","12:1786":"12:1786 (12:1786 Fed Credit Unions: Actions re Violations by Credit Unions)","12:1787(a)(B)":"12:1787(a)(B) (12:1787(a)(B) Fed Credit Unions: Liquidation of Insured Credit Union by Board)","12:1789(a)(2)":"12:1789(a)(2) (12:1789(a)(2) Fed Credit Unions: Admin Provision to Sue and be Sued)","12:1811":"12:1811 (12:1811 FDIC: Financial Inst. Reform Recovery Act of 1989 (FIRREA) (Organization of FDIC))","12:1818":"12:1818 (12:1818 FDIC: Violations re Federal Deposit Insurance Corporation)","12:1818(e)":"12:1818(e) (12:1818(e) FDIC: Suspension or Removal of Bank Officer)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1831":"12:1831 (12:1831 FDIC: Separability of Certain Provisions)","12:1831(d)":"12:1831(d) (12:1831(d) FDIC: Deposit. Inst. Dereg. & Monetary Ctrl. Act of 1980)","12:1831r-1":"12:1831r-1 (12:1831r-1 FDIC: Notice of Branch Closure)","12:1833(a)":"12:1833(a) (12:1833(a) FDIC: Forfieture Civil Penalties)","12:1954":"12:1954 (12:1954 Injunctions (Action by Sec of Treasury re financial recordkeeping))","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Tying Arrangement Act)","12:2001":"12:2001 (12:2001 Farm Credit Act of 1971)","12:2601":"12:2601 (Real Estate Settlement Procedures Act of 1974)","12:2604(c )":"12:2604(c ) (12:2604(c ) Real Estate Settlement Procedures Act (RESPA))","12:2605":"12:2605 (12:2605 RESPA: Servicing of Mortgage Loans)","12:2607":"12:2607 (12:2607 RESPA: Violation re kickbacks/unearned fees; Real Estate)","12:2609":"12:2609 (12:2609 RESPA: Escrow)","12:3012":"12:3012 (12:3012 National Consumer Cooperative Bank: Suits by or against Bank)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","12:3751":"12:3751 (12:3751 Single Family Mortgage Forclosure Act: Findings and Purpose)","12:3801":"12:3801 (12:3801 Alternative Mortgage Transaction Parity Act)","12:3907":"12:3907 (12:3907 International Lending Supervision: Capital Adequacy)","12:4010":"12:4010 (12:4010 Expedited Funds Availability: Violation of Act (Civil Liability))","12:5101":"12:5101 (12:5101 Fraudulent Transfer Act (Enforcement for Mortgage Licensing))","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0004":"15:0004 (15:0004 USDC Jurisdiction re violations of Sec. 1-7 of Title 15)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0009":"15:0009 (15:0009 USDC Jurisdiction re violations of Sec. 8 of Title 15)","15:0013":"15:0013 (15:0013 Robinson Patman Act)","15:0014":"15:0014 (15:0014 Clayton Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0026":"15:0026 (15:0026 Suit for injunctive relief re violation antitrust laws)","15:0034-35":"15:0034-35 (15:0034-35 Investment Company Act of 1940 )","15:0041":"15:0041 (15:0041 Federal Trade Commission Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0045cp":"15:0045cp (15:0045cp Violation of Children Online Privacy Protection Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0053(b)":"15:0053(b) (15:0053(b) Prelim & Perm Inj Relief & other Equitable Relief)","15:0068":"15:0068 (15:0068 Proceedings re FTC violations re wool products)","15:0069":"15:0069 (15:0069 Proceedings re FTC violations re fur products)","15:0070":"15:0070 (15:0070 Proceedings re FTC violations re textile fiber product)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0078j(b)ss":"15:0078j(b)ss (15:0078j(b)ss Stockholder Suit)","15:0078m(a)":"15:0078m(a) (15:0078m(a) Securities Exchange Act)","15:0079":"15:0079 (15:0079 Public Utility Holding Companies)","15:0080a-3":"15:0080a-3 (15:0080a-3 Investment Company Act of 1940)","15:0260":"15:0260 (15:0260 Proceedings re weights and measures and standard time)","15:0298":"15:0298 (15:0298 Violation of Law Proceedings re gold or silver)","15:0433":"15:0433 (15:0433 Discrimination against farmers)","15:0631":"15:0631 (15:631 Small Business Act)","15:0636":"15:0636 (15:0636 Small Business Act - Aid to small business)","15:0661":"15:0661 (15:0661 Small Business Investment Act of 1958)","15:0687":"15:0687 (15:0687 Small Business Investment Program)","15:0714(b)":"15:0714(b) (15:0714(b) Commodity Credit Corporation)","15:0715(f)":"15:0715(f) (15:0715(f) Proceedings re petroleum and petroleum products)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0719i(c )":"15:0719i(c ) (15:0719i(c ) Civil actions re violations or inj involving Gas)","15:0766":"15:0766 (15:0766 Controversies arising re Federal Energy Admin. rules)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1071":"15:1071 (15:1071 Appeal of Decision of U.S. Patent & Trademark Office (Comm / Trademark Trial Bd))","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1116":"15:1116 (15:1116 Inj to prevent violation rights of trademark owner)","15:1120":"15:1120 (15:1120 Trademark - False or Fraudulent Registration)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1125(a)":"15:1125(a) (15:1125(a) False representation of goods sold in interstate commerce)","15:1125(d)ac":"15:1125(d)ac (15:1125(d)ac Trademark (Anticybersquatting consumer protection))","15:1125la":"15:1125la (15:1125la Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1191":"15:1191 (15:1191 Flamable Fabrics Act)","15:1221":"15:1221 (15:1221 Auto Dealer Suits Agst Manufacturers)","15:1261":"15:1261 (15:1261 Hazardous Substances (definitions))","15:1263":"15:1263 (15:1263 Prohibited Hazardous Substance - Interstate Commerce)","15:1267(a)":"15:1267(a) (15:1267(a) Federal Hazardous Substances Act)","15:1314":"15:1314 (15:1314 Antitrust--Petition for enforcement)","15:1501":"15:1501 (15:1501 Estab of Dept of Commerce)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1605":"15:1605 (15:1605 Determination of Finance Charge)","15:1638":"15:1638 (15:1638 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1666":"15:1666 (15:1666 Fair Credit Billing Act Dispute)","15:1667":"15:1667 (15:1667 Consumer Leasing Act)","15:1679":"15:1679 (15:1679 Violation of Credit Repair Organizations Act)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1691":"15:1691 (15:1691 Equal Credit Opportunity Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693ef":"15:1693ef (15:1693ef Electronic Funds Transfer Act)","15:1693m":"15:1693m (15:1693m Violation of Prov. of Subchpt.VI (Electronic Fund Transfers))","15:1701":"15:1701 (15:1701 Interstate Land Sales Full Disclosure Act (ILFFDA))","15:1709":"15:1709 (15:1709 Interstate Land Sales )","15:1714":"15:1714 (15:1714 Actions to enjoin violations re interstate land sale)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2071":"15:2071 (15:2071 Consumer Product Safety; Condemnation hazardous prod)","15:2073":"15:2073 (15:2073 Private action to enforce Consumer Product Safety)","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2310(c )":"15:2310(c ) (15:2310(c ) Consumer Product Warranties)","15:2601":"15:2601 (15:2601 Toxic Substances Control Act (TCSA))","15:2604":"15:2604 (15:2604 Application for inj re distribution toxic substance)","15:2616":"15:2616 (15:2616 Toxic Substance control; seizure of chemical)","15:2620":"15:2620 (15:2620 Toxic Substances Control Act: citizen's petition)","15:2651":"15:2651 (15:2651 Asbestos Hazard Emergency Response Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:2805":"15:2805 (15:2805 Petroleum Marketing Practices-Franchise Protection)","15:3414":"15:3414 (15:3414 National Gas Policy Act)","15:3710a":"15:3710a (15:3710a Federal Technology Transfer Act of 1986)","15:3901":"15:3901 (15:3901 Federal Risk Retention Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","15:6801":"15:6801 (15:6801 Gram-Leach-Bliley Act)","15:7701":"15:7701 (15:7701 Federal CAN-Spam Act)","16:0019jj":"16:0019jj (16:0019jj Park System Resource Protection Act)","16:0470":"16:0470 (16:0470 Archaeological resources Protection Act)","16:0470f":"16:0470f (16:0470f National Historic Preservation Act)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0669":"16:0669 (16:0669 Pittman-Robertson Conservation Restoration Act)","16:0675":"16:0675 (16:0675 Norbeck Wildlife Preserve Organic Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:0823a":"16:0823a (16:0823a Federal Public Utility Regulatory Policies Act)","16:0825":"16:0825 (16:0825 Federal Power Commission Regulation; Public Utilities)","16:0831":"16:0831 (16:0831 Actions re: rights of Tennessee Valley Authority)","16:1244":"16:1244 (16:1244 National Scenic and National Historic Trails)","16:1374(d)(6)":"16:1374(d)(6) (16:1374(d)(6) Petition for Review re Application for Import of Polar Bear Trophies)","16:1531":"16:1531 (16:1531 Endangered Species Act)","16:1533":"16:1533 (16:1533 Endangered Species Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:1540":"16:1540 (16:1540 Endangered Species Act - Penalties and Enforcement)","16:1600":"16:1600 (16:1600 National Forest Management Act of 1976)","16:1801":"16:1801 (16:1801 Magnuson-Stevens Fishery Conservation and Management Act )","16:1858":"16:1858 (16:1858 National Fishery Management Program - Civil Penalties and Permit Sanctions)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0201":"17:0201 (17:0201 Ownership of Copyright)","17:0205(d)":"17:0205(d) (17:0205(d) Priority Between Conflicting Transfers)","17:0407":"17:0407 (17:0407 Recovery of fines & penalties by Register of Copyrights)","17:0411(b)":"17:0411(b) (17:0411(b) Action by copyright owner for infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0502(a)":"17:0502(a) (17:0502(a) Inj to prevent or restrain infringement copyright)","17:0504":"17:0504 (17:504 Copyright Infringement)","17:0512":"17:0512 (17:0512 Copyright Infringement of Digital Communications)","17:1201":"17:1201 (17:1201 Digital Millennium Copyright Act)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0492":"18:0492 (18:0492 Forfeiture of Counterfeit Paraphernalia)","18:0603":"18:0603 (18:0603 Conflict of Interest)","18:0922":"18:0922 (18:0922 Firearms - Unlawful Possession (Civil Fines) )","18:0923(f)(3)":"18:0923(f)(3) (18:0923(f)(3) Review of Revocation of a License as a Dealer in Firearms)","18:0925(c )":"18:0925(c ) (18:0925(c ) Restoration of ability to possess firearms/ammo)","18:0981":"18:0981 (18:0981 Civil Forfeiture)","18:0981(a)(1)(A)":"18:0981(a)(1)(A) (18:0981(a)(1)(A) Civil Forfeiture: Money Laundering Control Act)","18:0983":"18:0983 (18:0983 Civil Forfeiture - General Rules)","18:1030":"18:1030 (18:1030 Fraud & Related Activity in Connection with Computers)","18:1345":"18:1345 (18:1345 Injunction against Fraud)","18:1514":"18:1514 (18:1514 Civil Action to Restrain Harassment of a Victim)","18:1514A":"18:1514A (18:1514A Civil Action to Protect Against Retaliation in Fraud Cases)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1905":"18:1905 (18:1905 Disclosure of Confidential Information)","18:1955":"18:1955 (18:1955 Civil Forfeiture-Prohibition of Illegal Gambling)","18:1956(b)(3)":"18:1956(b)(3) (18:1956(b)(3) Laundering of Monetary Instruments - Forfeit Property)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:1968":"18:1968 (18:1968 Action re civil investigative demand)","18:2254":"18:2254 (18:2254 Civil Forfeiture - Exploitation of Children)","18:2333":"18:2333 (18:2333 Civil Remedies: Anti-Terrorism Act of 1991)","18:2511":"18:2511 (18:2511 Wiretapping - Injunctive Relief or Civil Fine)","18:2520":"18:2520 (18:2520 Civil Damages for Interception Wire or Oral Communications)","18:2707":"18:2707 (18:2707 Civil Action: Stored Communications)","18:2710( c)":"18:2710( c) (18:2710( c) Wrongful Disclosure of Video Tape Rental or Sales Records)","18:2724":"18:2724 (18:2724 Civil Action - Motor Vehicle Records)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:3184":"18:3184 (18:3184 Extradition Procedure)","18:3663":"18:3663 (18:3663 Civil Enforcement of Crim. Rest. Obligation)","18:4100":"18:4100 (18:4100 Transfer of Offenders)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","19:1497":"19:1497 (19:1497 Customs Duties: Penalty for Failure to Declare)","19:1595a":"19:1595a (19:1595a Customs Duties: Forfeiture and Other Penalties)","19:1607":"19:1607 (19:1607 Customs Duties: Notice of Seizure)","20:0107":"20:0107 (20:0107 Randolph-Sheppard Vending Stand Act)","20:1070":"20:1070 (20:1070 Student Assistance)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1087":"20:1087 (20:1087 Student Loan Discharge)","20:1095a":"20:1095a (20:1095a Education - Wage Garnishment Requirement)","20:1097":"20:1097 (20:1097 Education - Criminal penalties for fraud)","20:1098g":"20:1098g (20:1098g Higher Education Act - Exemption from state disclosure)","20:1232(g)":"20:1232(g) (20:1232(g) Family Education Rights & Privacy Act of 1974)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1412":"20:1412 (20:1412 IDEA: State Eligibility)","20:1415":"20:1415 (20:1415 IDEA: Challenge decision re education for handicapped )","20:1415(e)(2)de":"20:1415(e)(2)de (20:1415(e)(2)de IDEA: Mediation)","20:1681":"20:1681 (20:1681 Title IX Educational Amendments 1992 - Sex Discrimination)","20:1683":"20:1683 (20:1683 Judicial Review: Prohibition against sex discrimination in education)","20:1706":"20:1706 (20:1706 Relief from denial of equal educational opportunity)","20:1717":"20:1717 (20:1717 Reopening proceedings w/order to end segregation)","21:0301":"21:0301 (21:0301 Federal Food, Drug & Cosmetic Act)","21:0331":"21:0331 (21:0331 Federal Food, Drug & Cosmetic Act - Prohibited Acts)","21:0332":"21:0332 (21:0332 Federal Food, Drug and Cosmetic Act, Injunctive Relief)","21:0332(a)":"21:0332(a) (21:0332(a) Federal Food, Drug, and Cosmetic Act)","21:0334(a)":"21:0334(a) (21:0334(a) Forfeiture or condemnation-food, drug, cosmetics)","21:0348":"21:0348 (21:0348 Federal Food, Drug and Cosmetic Act - Food Additives)","21:0360":"21:0360 (21:0360 Federal Food, Drug & Cosmetic Act - Drugs and Devices)","21:0467":"21:0467 (21:0467 Seizure and condemnation of poultry products)","21:0601":"21:0601 (21:0601 Federal Meat Inspection Act 21 USC 601-695 (Definitions))","21:0673":"21:0673 (21:0673 Seizure and condemnation of meat or meat products)","21:0674":"21:0674 (21:0674 Proceeding to enforce & enjoin re meat products)","21:0821":"21:0821 (21:0821 Violation of Record Keeping Provision of Controlled Substance Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0842":"21:0842 (21:0842 Civil Penalty for violation re controlled substance)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","21:0882":"21:0882 (21:0882 Inj to enjoin violations re controlled substance)","21:1049":"21:1049 (21:1049 Seizure and condemnation re eggs or egg products)","22:0286":"22:0286 (22:0286 Action against World Bank or IMF)","22:2702":"22:2702 (22:2702 Medical Malpractice by Govt. Medical Personnel)","22:3612":"22:3612 (22:3612 Claim for Damage to Panama Canal)","22:3776":"22:3776 (22:3776 Panama Canal Commission Action on claims)","22:3777":"22:3777 (22:3777 Investigation of accident or injury giving rise to a claim)","22:4140":"22:4140 (22:4140 Foreign Service Grievance Act - Judicial Review)","23:0112":"23:0112 (23:0112 Federal Highway Act - Letting of Contracts)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","25:2701":"25:2701 (25:2701 Indian Gaming Regulatory Act (IGRA))","25:4101":"25:4101 (25:4101 Native American Housing Assistance and Self-Determination Act (NAHASDA))","26:0063":"26:0063 (26:0063 IRS: Taxable income (Definition))","26:0982":"26:0982 (26:0982 IRS: To Quash IRS Formal Document Request)","26:2032":"26:2032 (26:2032 IRS: Alternate valuation)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6221":"26:6221 (26:6221 IRS: TEFRA Tax, Equity and Fiscal Responsibility Act of 1982)","26:6226":"26:6226 (26:6226 IRS: Judicial Review of Partnership Adjustment)","26:6320":"26:6320 (26:6320 IRS: Notice and Opportunity for Hearing upon Filing Notice of Lien)","26:6330":"26:6330 (26:6330 IRS: Notice and Opportunity for Hearing before Levy)","26:6331":"26:6331 (26:6331 IRS: Wrongful Levy)","26:6334":"26:6334 (26:6334 IRS: Property Exempt from Levy)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6653sp":"26:6653sp (26:6653sp IRS: Failure to Pay Stamp Tax)","26:6672":"26:6672 (26:6672 IRS: Failure to Collect and Pay Over Tax, or Attempt to Evade or Defeat Tax)","26:6694":"26:6694 (26:6694 IRS: Underestimate Of Tax Liability By Tax Preparer)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7323":"26:7323 (26:7323 IRS: Proceedings in rem enforce forfeitures property)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7404":"26:7404 (26:7404 IRS: Action for collection of estate tax)","26:7405":"26:7405 (26:7405 IRS: Action for recovery of refunds erroneously made)","26:7407":"26:7407 (26:7407 IRS: Action to enjoin income tax preparers)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7425(a)":"26:7425(a) (26:7425(a) IRS: Judiciary & Judicial Procedures - Discharge of Liens)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7428":"26:7428 (26:7428 IRS: Declaratory Judgment)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7430":"26:7430 (26:7430 IRS: Awarding of Costs and Certain Fees in Tax Suit)","26:7431":"26:7431 (26:7431 IRS: Unauthorized Disclosure of Return & Return Info)","26:7434":"26:7434 (26:7434 IRS: Civil Damages for Fraudulent Filing of Information)","26:7604":"26:7604 (26:7604 IRS: Enforce summons; examination books & witnesses)","26:7604(a)":"26:7604(a) (26:7604(a) IRS: Complaint to Enforce IRS Summons)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","26:7609en":"26:7609en (26:7609en IRS: Petition to serve Third-Party Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157(b)":"28:0157(b) (28:0157(b) Bankruptcy Claim to be tried in U.S. District Court)","28:0157(c )(1)":"28:0157(c )(1) (28:0157(c )(1) Findings, Concl. & Proposed Judgment)","28:0157(d)":"28:0157(d) (28:0157(d) Motion for Withdrawal of Reference)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0463":"28:0463 (28:0463 Expenses of Judicial Litigation)","28:0534":"28:0534 (28:0534 Arrest Records)","28:0591":"28:0591 (28:0591 Independent Counsel)","28:0592":"28:0592 (28:0592 Independent Counsel - Application for Appointment)","28:0593":"28:0593 (28:0593 Independent Counsel - Court Responsibilities)","28:0594":"28:0594 (28:0594 Independent Counsel - Responsibilities)","28:0595":"28:0595 (28:0595 Independent Counsel - Congressional Oversight)","28:0596":"28:0596 (28:0596 Independent Counsel - Removal)","28:0597":"28:0597 (28:0597 Independent Counsel - Dept. of Justice Relationship)","28:0598":"28:0598 (28:0598 Independent Counsel - Chapter Termination)","28:0636":"28:0636 (28:0636 Jurisdiction and Power of Magistrate Judges)","28:0754":"28:0754 (28:0754 Receiver of Property in Different Districts )","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1291":"28:1291 (28:1291 Maritime)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331(a)rp":"28:1331(a)rp (28:1331(a)rp Fed. Question: Real Property )","28:1331ag":"28:1331ag (28:1331ag Fed. Question: Employment Discrimination (Age))","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331as":"28:1331as (28:1331as Fed. Question: Assault, Libel, Slander)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331bv":"28:1331bv (28:1331bv Fed. Question: Bivens-Prisoner)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cr":"28:1331cr (28:1331cr Fed. Question: Civil Rights (Race Discrimination))","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331dd":"28:1331dd (28:1331dd Fed. Question: Discovery Disputes (conversion case))","28:1331dj":"28:1331dj (28:1331dj Fed. Question: Declaratory Judgment)","28:1331dp":"28:1331dp (28:1331dp Fed. Question: Violation of Due Process)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ef":"28:1331ef (28:1331ef Fed. Question: Civil Rights Violation (Excess Force))","28:1331ej":"28:1331ej (28:1331ej Fed. Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fa":"28:1331fa (28:1331fa Fed. Question: Civil Rights Violation-False Arrest)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331fm":"28:1331fm (28:1331fm Fed. Question: Family and Medical Leave Act)","28:1331fr":"28:1331fr (28:1331fr Fed. Question: Fraud)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331lm":"28:1331lm (28:1331lm Fed. Question: Labor/Mgt. Relations Act)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331ng Fed. Question: Natural Gas Act)","28:1331ni":"28:1331ni (28:1331ni Fed. Question: Negotiable Instrument)","28:1331pd":"28:1331pd (28:1331pd Fed. Question: Property Damage)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331pl":"28:1331pl (28:1331pl Fed. Question: Product Liability)","28:1331pr":"28:1331pr (28:1331pr Fed. Question: Federal Prisoner Civil Rights)","28:1331ra":"28:1331ra (28:1331ra Fed. Question: Racketeering (RICO) Act)","28:1331rc":"28:1331rc (28:1331rc Fed. Question: Reclamation Project Auth. Act of 1972)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331rs":"28:1331rs (28:1331rs Fed. Question: Federal Rail Safety Act)","28:1331sh":"28:1331sh (28:1331sh Fed. Question: Sexual Harassment)","28:1331ss":"28:1331ss (28:1331ss Fed. Question: Constitutionality of State Statutes)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331sx":"28:1331sx (28:1331sx Fed. Question: Employment Discrimination (Sex))","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331va":"28:1331va (28:1331va Fed. Question: Violation 5th & 14th Amendment)","28:1331vc":"28:1331vc (28:1331vc Fed. Question: Violation of Constitutional Rights)","28:1331w":"28:1331w (28:1331w Fed. Question: Wrongful Termination of Employment)","28:1331wd":"28:1331wd (28:1331wd Fed. Question: Wrongful Death)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332":"28:1332 (28:1332 Diversity Action)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332ap":"28:1332ap (28:1332ap Diversity-Airplane Product Liability)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332bw":"28:1332bw (28:1332bw Diversity -Breach of Warranty)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332de":"28:1332de (28:1332de Diversity: Forcible Detainer)","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332dtp":"28:1332dtp (28:1332dtp Diversity - Deceptive Trade Practices)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332ej":"28:1332ej (28:1332ej Diversity-Enforcement of Judgment)","28:1332fc":"28:1332fc (28:1332fc Diversity - Foreclosure)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332if":"28:1332if (28:1332if Diversity- Insurance Fraud)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332lp":"28:1332lp (28:1332lp Diversity-Property Damage/Product Liability)","28:1332lr":"28:1332lr (28:1332lr Diversity - Labor)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332md":"28:1332md (28:1332md Diversity-Motor Vehicle/Wrongful Death)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332nr Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332op":"28:1332op (28:1332op Diversity-Recovery of Overpayment)","28:1332pa":"28:1332pa (28:1332pa Diversity-Personal Injury/Airplane)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332rd":"28:1332rd (28:1332rd Diversity-Recovery of Debt)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332rl":"28:1332rl (28:1332rl Diversity-Rent Lease & Ejectment)","28:1332rp":"28:1332rp (28:1332rp Diversity-Real Property)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332sh":"28:1332sh (28:1332sh Diversity-Sexual Harassment)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332t":"28:1332t (28:1332t Diversity-Torts)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332ts":"28:1332ts (28:1332ts Diversity-Misappropriation of Trade Secrets)","28:1332vt":"28:1332vt (28:1332vt Diversity-Natl Motor Vehicle Title Information System)","28:1332wc":"28:1332wc (28:1332wc Diversity- Worker's Compensation Benefits)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1333ad":"28:1333ad (28:1333ad Admiralty)","28:1333in":"28:1333in (28:1333in Personal Injury)","28:1333mc":"28:1333mc (28:1333mc Marine Contract)","28:1333pd":"28:1333pd (28:1333pd Property Damage)","28:1333pi":"28:1333pi (28:1333pi Marine Personal Injury)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334(b)":"28:1334(b) (28:1334(b) Proceeding arising/related to case under title 11)","28:1334(c )":"28:1334(c ) (28:1334(c ) R&R re motions for abstention)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1337sc":"28:1337sc (28:1337sc Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1339":"28:1339 (28:1339 Postal matters)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1340tp":"28:1340tp (28:1340tp Jurisdiction of Internal Revenue Matters; Customs Duties)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1344":"28:1344 (28:1344 Election disputes)","28:1345":"28:1345 (28:1345 U.S. Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345lc":"28:1345lc (28:1345lc Land Condemnation)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345ro":"28:1345ro (28:1345ro Recovery of Retirement Overpayment)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345tx":"28:1345tx (28:1345tx Prohibit dfts assessing tx on purch/use of pers prop)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346":"28:1346 (28:1346 U.S. Defendant)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346pi":"28:1346pi (28:1346pi Marine Personal Injury (or tort claim - personal injury / motor vehicle))","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346t":"28:1346t (28:1346t Tort Claim)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1348":"28:1348 (28:1348 Banking association as party)","28:1349":"28:1349 (28:1349 Corporation organized under Federal Law as party)","28:1350":"28:1350 (28:1350 Alien Tort Claims Act)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1356":"28:1356 (28:1356 Executory Process/Foreclosure)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1361pr":"28:1361pr (28:1361pr Complaint for mandamus relief (prisoner))","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1363":"28:1363 (28:1363 Action for protection of jurors employment rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1367":"28:1367 (28:1367 Other Property Damage)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1394":"28:1394 (28:1394 Banking Assoc action agst Comptroller of Currency)","28:1395":"28:1395 (28:1395 Complaint for Forfeiture )","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1403":"28:1403 (28:1403 Condemnation of real estate for the use of the US)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1407im":"28:1407im (28:1407im MDL: Silicone Gel Breast Implant Products Liability)","28:1407md":"28:1407md (28:1407md MDL: Multidistrict Litigation)","28:1407n":"28:1407n (28:1407n MDL: Personal Injury/Norplant Product Liability)","28:1407pl":"28:1407pl (28:1407pl MDL: Products Liability)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441ada":"28:1441ada (28:1441ada Removal- Americans with Disabilities Act)","28:1441ag":"28:1441ag (28:1441ag Removal- Civil Rights (Age))","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441ba":"28:1441ba (28:1441ba Removal - National Bank Act)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441bfd":"28:1441bfd (28:1441bfd Removal- Breach of Fiduciary Duties)","28:1441ca":"28:1441ca (28:1441ca Removal - Carmack Amendment)","28:1441cc":"28:1441cc (28:1441cc Removal- Computer Crimes Act)","28:1441cj":"28:1441cj (28:1441cj Removal- Confessed Judgement)","28:1441cla":"28:1441cla (28:1441cla Removal - Consumer Leasing Act)","28:1441cp":"28:1441cp (28:1441cp Removal- Copyright)","28:1441cpl":"28:1441cpl (28:1441cpl Removal - Contract Product Liability)","28:1441cra":"28:1441cra (28:1441cra Removal - Fair Credit Reporting Act)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441dea":"28:1441dea (28:1441dea Removal - Disabilities Education Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441di":"28:1441di (28:1441di Removal- Civil Rights (Disability Act))","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ea":"28:1441ea (28:1441ea Removal- Employment Discrimination (Age))","28:1441eb":"28:1441eb (28:1441eb Removal - E.R.I.S.A. Employee Benefits)","28:1441ec":"28:1441ec (28:1441ec Removal - Electronic Comm. Privacy Act)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441em":"28:1441em (28:1441em Removal - Emergency Medical Treatment & Active Labor)","28:1441er":"28:1441er (28:1441er Removal- Employment Discrimination (Race))","28:1441es":"28:1441es (28:1441es Removal- Employment Discrimination (Sex))","28:1441fa":"28:1441fa (28:1441fa Removal - Civil Rights - False Arrest)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fd":"28:1441fd (28:1441fd Removal - Fair Debt Collection Practices Act)","28:1441fe":"28:1441fe (28:1441fe Removal- Fed. Employee Garnishment Statute)","28:1441fh":"28:1441fh (28:1441fh Removal- FEHBA)","28:1441fif":"28:1441fif (28:1441fif Removal - Insecticide/Fungicide/Rodenticide Act -1942)","28:1441fl":"28:1441fl (28:1441fl Removal- Fair Labor Standards Act)","28:1441fm":"28:1441fm (28:1441fm Removal - Family and Medical Leave Act)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441fs":"28:1441fs (28:1441fs Removal - Foreign Sovereign Immunities Act)","28:1441fsa":"28:1441fsa (28:1441fsa Removal - Federal Food Stamp Act)","28:1441hb":"28:1441hb (28:1441hb Removal - Petition of Habeas Corpus)","28:1441hc":"28:1441hc (28:1441hc Removal - Handicapped Child Protection Act)","28:1441hd":"28:1441hd (28:1441hd Removal- Housing Discrimination)","28:1441ia":"28:1441ia (28:1441ia Removal- Interstate Commerce Act)","28:1441if":"28:1441if (28:1441if Removal - Insurance Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441il":"28:1441il (28:1441il Removal- Interstate Land Full Discloser Act)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441la":"28:1441la (28:1441la Removal - Truth in Lending Act)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441ml":"28:1441ml (28:1441ml Removal- Motor Vehicle Prod Liability)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441mv":"28:1441mv (28:1441mv Removal- Motor Vehicle)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441nr Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pa":"28:1441pa (28:1441pa Removal - Patent Infringement)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ra":"28:1441ra (28:1441ra Removal- Civil Rights (Race))","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441rl":"28:1441rl (28:1441rl Removal- Rent, Lease, & Ejectment)","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441sh":"28:1441sh (28:1441sh Removal-Sexual Harassment)","28:1441st":"28:1441st (28:1441st Removal - Stockholders Suit)","28:1441sv":"28:1441sv (28:1441sv Removal-Security Violation)","28:1441sx":"28:1441sx (28:1441sx Removal-Civil Rights (Sex))","28:1441tc":"28:1441tc (28:1441tc Removal - Tricare Program)","28:1441ti":"28:1441ti (28:1441ti Removal-Trademark Infringement)","28:1441til":"28:1441til (28:1441til Removal - Truth and Lending)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441us":"28:1441us (28:1441us Removal - Uniformed Svc Emp/Reemp Rights Act)","28:1441wc":"28:1441wc (28:1441wc Removal - Worker's Compensation Benefits)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1441wt":"28:1441wt (28:1441wt Removal- Employment (Wrongful Termination))","28:1442":"28:1442 (28:1442 Notice of Removal - Suit against Federal Officer)","28:1442aaf":"28:1442aaf (28:1442aaf Petition for Removal - Agst members of armed forces)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1443(1)":"28:1443(1) (28:1443(1) Removal from State Court - Civil Rights: Rent, Lease, and Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446al":"28:1446al (28:1446al Notice of Removal - Airline Crash)","28:1446as":"28:1446as (28:1446as Notice of Removal - Asbestos Litigation)","28:1446bc":"28:1446bc (28:1446bc Notice of Removal - Breach of Contract)","28:1446cs":"28:1446cs (28:1446cs Notice of Removal - Child Support Enforcement)","28:1446dj":"28:1446dj (28:1446dj Notice of Removal - Declaratory Judgment)","28:1446er":"28:1446er (28:1446er Notice of Removal - E.R.I.S.A)","28:1446fm":"28:1446fm (28:1446fm Notice of Removal - Family and Medical Leave Act)","28:1446fr":"28:1446fr (28:1446fr Notice of Removal - Fraud)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446lb":"28:1446lb (28:1446lb Notice of Removal - Libel, Assault, Slander)","28:1446ml":"28:1446ml (28:1446ml Notice of Removal - Motor Vehicle Prod Liability)","28:1446mm":"28:1446mm (28:1446mm Notice of Removal - Medical Malpractice)","28:1446mv":"28:1446mv (28:1446mv Notice of Removal - Motor Vehicle)","28:1446ni":"28:1446ni (28:1446ni Notice of Removal - Negotiable Instrument)","28:1446nr":"28:1446nr (28:1446nr Notice of Removal)","28:1446oc":"28:1446oc (28:1446oc Notice of Removal - Other Contract)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1446st":"28:1446st (28:1446st Notice of Removal - Stockholders Suit)","28:1446tl":"28:1446tl (28:1446tl Notice of Removal - Torts to Land)","28:1446wd":"28:1446wd (28:1446wd Notice of Removal - Wrongful Death)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1453":"28:1453 (28:1453 Class Action Fairness Act)","28:1491":"28:1491 (28:1491 Tucker Act)","28:1602":"28:1602 (28:1602 Foreign Sovereign Immunities Act)","28:1605":"28:1605 (28:1605 Foreign Sovereign Immunities Act of 1976)","28:1605A":"28:1605A (28:1605A Antiterrorism & Effective Death Penalty Act 1996)","28:1610":"28:1610 (28:1610 Juridictional Immunities of Foreign States)","28:1631":"28:1631 (28:1631 Case Transferred to Cure Want of Jurisdiction)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651cn":"28:1651cn (28:1651cn Petition for Writ of Error Coram Nobis )","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1651ne":"28:1651ne (28:1651ne Application for Writ Ne Exeat)","28:1651w":"28:1651w (28:1651w All Writs Act)","28:1715":"28:1715 (28:1715 Class Action Fairness Act of 2005)","28:1732":"28:1732 (28:1732 Reproduction of Records)","28:1738Acs":"28:1738Acs (28:1738Acs The Uniform Child Custody Jurisdiction Act)","28:1782":"28:1782 (28:1782 Assistance to Foreign Tribunals (incl letter rogatory))","28:1783":"28:1783 (28:1783 Petition for Subpoena of person in foreign country)","28:1826":"28:1826 (28:1826 Order of confinement of recalcitrant witness)","28:1875":"28:1875 (28:1875 Juror Protection Act / Protection of Jurors' Employment)","28:1916":"28:1916 (28:1916 Marine Personal Injury)","28:1963":"28:1963 (28:1963 Registration of judgment from another district)","28:2001":"28:2001 (28:2001 Judicial Sale of Realty)","28:2071":"28:2071 (28:2071 Rule Making Power Generally)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201an":"28:2201an (28:2201an Declaratory Judgement (aliens and nationality))","28:2201cp":"28:2201cp (28:2201cp Declaratory Judgment (Copyright))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201fa":"28:2201fa (28:2201fa Declaratory Judgment- Firearms)","28:2201fs":"28:2201fs (28:2201fs Declaratory Judgment (Food Security Act))","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2201pi":"28:2201pi (28:2201pi Declaratory Judgment - Personal Injury)","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2241fd":"28:2241fd (28:2241fd Petition for Writ of Habeas Corpus (federal))","28:2241in":"28:2241in (28:2241in Habeas Corpus: INS)","28:2241st":"28:2241st (28:2241st Petition for Writ of Habeas Corpus (State))","28:2244":"28:2244 (28:2244 Habeas Corpus - Finality of Determination)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254dp":"28:2254dp (28:2254dp Petition for Writ of Habeas Corpus (Death Penalty))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2283":"28:2283 (28:2283 Stay of State Court Proceedings (Injunctive Relief))","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2347":"28:2347 (28:2347 Petition to Review Orders in the Ct of Appeals)","28:2401":"28:2401 (28:2401 Federal Tort Claims Act (Time for commencing action against the US))","28:2403":"28:2403 (28:2403 Constitutionality of State Statute(s) )","28:2405":"28:2405 (28:2405 Garnishment of debtors of a corporation by US)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2409(a)":"28:2409(a) (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2412":"28:2412 (28:2412 Equal Access to Justice Act)","28:2415":"28:2415 (28:2415 Detinue and Conversion)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2672mv":"28:2672mv (28:2672mv Federal Tort Claims Act - Motor Vehicle)","28:2672pi":"28:2672pi (28:2672pi Federal Tort Claim Act - Personal Injury)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:2675":"28:2675 (28:2675 Federal Tort Claims Act - Disposition by Agency Req)","28:2679(d)":"28:2679(d) (28:2679(d)(2) Federal Tort Claims Act - Employee of U.S.A.)","28:2680":"28:2680 (28:2680 Federal Tort Claims Act - Exceptions)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","28:3001(a)":"28:3001(a) (28:3001(a) Federal Debt Collection Procedures Act of 1990)","28:3203":"28:3203 (28:3203 Postjudgment Remedies: Writ of Execution)","28:3301":"28:3301 (28:3301 Fraudulent Transfer Federal Debt Collection Procedures Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0101":"29:0101 (29:0101 Labor: Issuance of Restraining Orders and Injunctions )","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0158(b)":"29:0158(b) (29:0158(b) Labor: NLRA - Unfair Labor Practices)","29:0159":"29:0159 (29:0159 Labor: Violation of Collective Bargaining Agreement )","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0160j":"29:0160j (29:0160j Labor: Petition for Inj - Relief from Unfair Labor Practice)","29:0160l":"29:0160l (29:0160l Labor: Petition for Inj re Uncertified Labor Organizations)","29:0161(2)":"29:0161(2) (29:0161(2) Labor: Enforcement of agency subpoena)","29:0178":"29:0178 (29:0178 Labor: Petition for Inj to Enjoin Strike during Natl Emergency)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185":"29:0185 (29:0185 Labor: Suits by and against Labor Organizations)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0186":"29:0186 (29:0186 Labor: Liabilities of and Restrictions on Labor and Management)","29:0187":"29:0187 (29:0187 Labor: Recover Damages from Unfair Labor Practice)","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0206(d)":"29:0206(d) (29:0206(d) FLSA: Prohibition of Sex Discrimination)","29:0207(a)":"29:0207(a) (29:0207(a) FLSA: Action for Overtime Wage Violation)","29:0207fl":"29:0207fl (29:0207fl FLSA: Maximum Hours)","29:0210":"29:0210 (29:0210 FLSA: Court Review of Wage Orders in PR and VI)","29:0215fl":"29:0215fl (29:0215fl FLSA: Prohibited Acts)","29:0216(b)":"29:0216(b) (29:0216(b) FLSA: Minimum wage or overtime compensation)","29:0216(e)":"29:0216(e) (29:0216(e) FLSA: Penalty assessed for child labor provisions)","29:0217":"29:0217 (29:0217 FLSA: Enjoin Violations of Fair Labor Standards Act)","29:0260":"29:0260 (29:0260 FLSA: Liquidated Damages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0411":"29:0411 (29:0411 Landrum Griffin Act)","29:0412":"29:0412 (29:0412 Infringement of rights; members of labor organization)","29:0440":"29:0440 (29:0440 violations reporting requirements; labor organization)","29:0501(b)":"29:0501(b) (29:0501(b) Violation of Fiduciary Responsibility)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0660":"29:0660 (29:0660 Action by Sec Labor for discrimination re rights OSHA)","29:0662":"29:0662 (29:0662 Inj proceedings re dangerous emp conditions; by Sec.)","29:0666":"29:0666 (29:0666 Collection of civil penalties under OSHA)","29:0701":"29:0701 (29:0701 Vocational Rehabilitation)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0792(d)(2)":"29:0792(d)(2) (29:0792(d)(2) Accessible facilities for phys. handicapped emp)","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:0794ra":"29:0794ra (29:0794 Rehabilitation Act)","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1055":"29:1055 (29:1055 E.R.I.S.A., Employee Retirement (Joint and Survivor Annuity))","29:1101":"29:1101 (29:1101 E.R.I.S.A.: Coverage)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1161":"29:1161 (29:1161 COBRA - Continuation Coverage)","29:1162":"29:1162 (29:1162 COBRA - Continuation Coverage)","29:1303":"29:1303 (29:1303 PBGC: Operation of Corporation)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1401(b)(2)":"29:1401(b)(2) (29:1401(b)(2) E.R.I.S.A.: Resolution of Disputes - Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:1854":"29:1854 (29:1854 Migrant & Seasonal Agri Worker Protect Act (AWPA))","29:1916":"29:1916 (29:1916 Spec. Rule for Longshoremen & Harborworkers)","29:2001":"29:2001 (29:2001 Employee Polygraph Protection Act)","29:2101":"29:2101 (29:2101 Worker Adjustment and Retraining Notification Act)","29:2104":"29:2104 (29:2104 Worker Adjustment & Retraining Notification (WARN))","29:2601":"29:2601 (29:2601 Family and Medical Leave Act (FMLA))","29:2610":"29:2610 (29:2610 Family & Maternity Leave Act)","29:2611":"29:2611 (29:2611 FMLA: Definitions)","29:2612":"29:2612 (29:2612 FMLA: Leave Requirements)","29:2617":"29:2617 (29:2617 Family and Medical Leave Act (FMLA))","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0022":"30:0022 (30:0022 General Mining Law of 1872 (Lands Open to Purchase by Citizens))","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:0815":"30:0815 (30:0815 Federal Mine Safety & Health Act (Procedure for Enforcement))","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","30:1701":"30:1701 (30:1701 Federal Oil Gas Royalty Mgt Act 1982 (FOGRMA))","31:0732":"31:0732 (31:0732 General Acct. Office Personnel Act of 1980 (Personnel Management System))","31:1341":"31:1341 (31:1341 Government employee--limitations on expending monies)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3702":"31:3702 (31:3702 Procedures for Settling Claims )","31:3713":"31:3713 (31:3713 Priority of Government Claims)","31:3720":"31:3720 (31:3720 Federal Income Tax Interceptions (Collection of Payments))","31:3728":"31:3728 (31:3728 Setoff against Judgment )","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","31:3733(j)(2)":"31:3733(j)(2) (31:3733(j)(2) Pet to Mod or Set Aside CV Investigative Demand)","31:5314":"31:5314 (31:5314 Failure to Report Interest in Foreign Accounts)","31:5317":"31:5317 (31:5317 Forfeiture of money; transportation not reported )","31:5320":"31:5320 (31:5320 Inj proceedings re Rpts of Currency & Foreign Trans. )","31:5321":"31:5321 (31:5321 Penalty; Reports of Currency and Foreign Transaction )","31:5332(a)":"31:5332(a) (31:5332(a) Evading Currency Reporting Requirement)","31:5332(f)":"31:5332(f) (31:5332(f) Transport and Transfer US currency from in to out)","31:6716":"31:6716 (31:6716 Discrimination re money and finance )","31:9701":"31:9701 (31:9701 Federal User Charge Statute)","33:0408":"33:0408 (33:0408 Injury to Harbor Improvement)","33:0594":"33:0594 (33:0594 Land Condemnation)","33:0901":"33:0901 (33:0901 Longshoremen Harbor Workers Compensation Act (Navigation and Navigable Waters))","33:0905(b)":"33:0905(b) (33:0905(b) Longshoremen Workers' Compensation Act - Recovery of Damages caused by the negligence of )","33:0918":"33:0918 (33:0918 Longshore and Harbor Workers Compensation Act - Collection of Defaulted Payments)","33:0921":"33:0921 (33:0921 Longshore & Harbor Workers Compensation Act - Review of Compensation Orders)","33:0933":"33:0933 (33:0933 Longshore and Harbor Workers' Compensation Act - Compensation for Injuries (Third-Party Clai)","33:1221":"33:1221 (33:1221 Ports and Waterways Safety Program)","33:1251":"33:1251 (33:1251 Federal Water Pollution Control Act (Clean Water Act))","33:1319(a)(2)pv":"33:1319(a)(2)pv (33:1319(a)(2)pv Clean Water Act - Pollutants & Permit Violations)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1321":"33:1321 (33:1321 Clean Water Act - Discharge of hazardous substance or pollutants/water)","33:1361":"33:1361 (33:1361 Clean Water Act-Administrator Authority)","33:1364":"33:1364 (33:1364 Clean Water Act - EPA action to restrain pollution endangering health (emergency powers))","33:1365":"33:1365 (33:1365 Environmental Matters)","33:1415":"33:1415 (33:1415 Marine Protection, Research, and Sanctuaries Act)","33:1515":"33:1515 (33:1515 Deepwater Ports Act (citizen civil action))","33:2701":"33:2701 (33:2701 Oil Pollution Act of 1940)","35:0001":"35:0001 (35:0001 Establishment of PTO)","35:0032":"35:0032 (35:0032 Suspension from Practice before Patent & Trade. Off.)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0146":"35:0146 (35:0146 Appeal from Decision of the Board of Patent Appeals)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0256":"35:0256 (35:0256 Patent Non-Infringement (Correction of Named Inventor))","35:0271":"35:0271 (35:271 Patent Infringement)","35:0281":"35:0281 (35:0281 Remedy for Infringement of Patent/jurisdiction conferred 28:1338)","35:0282":"35:0282 (35:0282 Patent Infringement - Defenses)","35:0283":"35:0283 (35:0283 Action to enjoin violation of right secured by patent)","35:0289":"35:0289 (35:0289 Recover profits from unlicensed use of design patent)","35:0291":"35:0291 (35:0291 Action for relief between owners; interfering patents)","35:0292":"35:0292 (35:0292 Penalty & Forfeiture; illegal use of word patent (false marking))","35:0311":"35:0311 (35:0311 Patent - Request for Inter Partes Reexamination)","38:1110":"38:1110 (38:1110 Basic Entitlements / Wartime)","38:1131":"38:1131 (38:1131 Basic Entitlements / Peacetime)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:1816":"38:1816 (38:1816 Deficiency balance on VA Mortgage Foreclosure (Regulations Governing the VA Loan Guaranty Pr)","38:1965":"38:1965 (38:1965 Servicemen's Group Life Insurance (Definitions))","38:1975":"38:1975 (38:1975 Recovery of Servicemen's Group Life Insurance - Jurisdiction of District Court)","38:1984":"38:1984 (38:1984 Suit for Veterans Insurance)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:3481":"38:3481 (38:3481 Recovery of VA Overpayment)","38:3680":"38:3680 (38:3680 Recovery of Education Assist Allowance Overpayment)","38:4212":"38:4212 (38:4212 Veterans Employment Emphasis Under Federal Contracts )","38:4301":"38:4301 (38:4301 Uniformed Srvs. Employment & Reemployment Rights Act (purpose))","38:4302":"38:4302 (38:4302 Veterans Reemployment Rights Act (relation to other laws and plans or agreements.)","38:4311":"38:4311 (38:4311 Uniformed Service Employment or Reemployment Rights Act (USERRA) - Discrimination)","38:4312":"38:4312 (38:4312 Rights of inducted persons to reemployment )","38:4322":"38:4322 (38:4322 Enforcement of employment or reemployment rights)","38:4323":"38:4323 (38:4323 Enforcement of rights with respect to a State or private employer)","38:4324":"38:4324 (38:4324 Enforcement of rights with respect to Federal executive agencies)","38:4325":"38:4325 (38:4325 Enforcement of rights with respect to certain Federal agencies)","38:5315":"38:5315 (38:5315 Delinquent Payment of Amounts Due to US)","38:5316":"38:5316 (38:5316 VA Overpayment )","39:0403":"39:0403 (39:0403 Discriminatory use of the Postal Service)","39:0409":"39:0409 (39:0409 Suits by and against the Postal Service)","39:1207":"39:1207 (39:1207 Review Agency Action--Labor Disputes)","39:1208(b)":"39:1208(b) (39:1208(b) Postal Reorganization Act of 1970 - Suits)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:3007":"39:3007 (39:3007 Detention of Mail for Temporary Periods - Injunction directing retention of incoming mail)","39:3008(e)":"39:3008(e) (39:3008(e) Enforce compliance with a USPS Prohibitory Order)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0581":"40:0581 (40:0581 General Authority of Administrator of General Services)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:1101":"40:1101 (40:1101 Brooks Architect - Engineers Act)","40:3131":"40:3131 (40:3131 Bonds of contractors of public buildings )","40:3142":"40:3142 (40:3142 Davis-Bacon Act (prevailing wages))","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","41:2102-2107":"41:2102-2107 (41:2102-2107 Procurement Integrity Act)","41:3301":"41:3301 (41:3301 Competition in Contracting Act)","41:6503":"41:6503 (41:6503 Walsh-Healy Act - Breach of Public Contract)","41:6505":"41:6505 (41:6505 Exclusions - Review of legal questions in contracts; Walsh-Healy Act)","41:6702 - 6704":"41:6702 - 6704 (41:6702 - 6704 Service Contract Labor Standards / McNamara-O'Hara Service Contract Act 1965)","41:7105(f)":"41:7105(f) (41:7105(f) Action to Judicially Enforce Administrative Subpoena)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0254o":"42:0254o (42:0254o Breach of Scholarship Contract)","42:0256":"42:0256 (42:0256 Public Health Services Act - Grants)","42:0292f":"42:0292f (42:0292f Default of borrower)","42:0292k":"42:0292k (42:0292k Student loan insurance (Public Health Occupations))","42:0293":"42:0293 (42:0293 Recovery of losses from loan guarantee; public health)","42:0297":"42:0297 (42:0297 Student loans; public or nonprofit school of nursing)","42:0300aa-1":"42:0300aa-1 (42:0300aa-1 Nat'l. Childhood Vaccine Injury Compensation Act)","42:0300f":"42:0300f (42:0300f Safe Drinking Water Act (Definitions))","42:0300g":"42:0300g (42:0300g Actions re safety of public water systems (EPA))","42:0300g-3":"42:0300g-3 (42:0300g-3 Enforcement of Drinking Water Regulations)","42:0401":"42:0401 (42:0401 Social Security Act - Trust Funds)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405rs":"42:0405rs (42:0405rs Review of HHS Decision (RSI))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0421(d)":"42:0421(d) (42:0421(d) Review HHS decision re disability determinations)","42:0423":"42:0423 (42:0423 Social Security Act (Disability Insurance Benefit Payments))","42:0427":"42:0427 (42:427 Social Security Benefits)","42:0601":"42:0601 (42:0601 Title IV-A of the Social Security Act (Grants to States for Aid and Assistance to Needy Fami)","42:0602":"42:0602 (42:0602 Temp. Assistance for Needy Families (TANF) )","42:0660":"42:0660 (42:0660 Action to enforce child support obligations)","42:10139":"42:10139 (42:10139 judicial review of agency actions )","42:10801":"42:10801 (42:10801 Protection & Advocacy for Individuals with Mental Illness Act of 1986 (PAIMI))","42:10805":"42:10805 (42:10805 Protection and Advocacy Systems)","42:11001":"42:11001 (42:11001 Emergency Plan. & Comm. Right to Know Act (EPCRA))","42:11046":"42:11046 (42:11046 Fed Emer Plan Comm Right-to-know Act (EPCRA) - civil actions)","42:11101":"42:11101 (42:11101 Health Care Quality Improvement Act of 1986 )","42:11112":"42:11112 (42:11112 Health Care Quality Improvement Act (Standards for Professional Review Actions))","42:11601":"42:11601 (42:11601 International Child Abduction Remedies Act)","42:11603(b)":"42:11603(b) (42:11603(b) Int'l. Child Abduction Remedies Act (ICARA) - Judicial Remedies)","42:12101":"42:12101 (42:12101 Americans with Disabilities Act)","42:12102":"42:12102 (42:12102 Americans with Disabilities Act (ADA) Disability Definition)","42:12111":"42:12111 (42:12111 Americans with Disabilities Act - Employment )","42:12112":"42:12112 (42:12112 Americans with Disabilities Act - Employment Discrimination)","42:12117":"42:12117 (42:12117 Americans with Disabilities Act - Enforcement)","42:12132":"42:12132 (42:12132 Americans with Disabilities Act - Discrimination)","42:12188":"42:12188 (42:12188 Americans With Disabilities Act - Civil Enforcement Actions)","42:1320a-7b(b)(2)(A)":"42:1320a-7b(b)(2)(A) (42:1320a-7b(b)(2)(A) Anti-Kickback Act (for federal health care programs) )","42:1320d-2":"42:1320d-2 (42:1320d-2 Health Insurance Portability And Accountability Act (HIPAA))","42:1381a":"42:1381a (42:1381a Supplemental Security Income benefits (SSID))","42:1382":"42:1382 (42:1382 Eligibility for benefits)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1395dd":"42:1395dd (42:1395dd Exam & Treatment Emergency Med Cond & Women in Labor)","42:1395hr":"42:1395hr (42:1395hr Hospital Reimbursement for Medicare Services)","42:1395w-21":"42:1395w-21 (42:1395w-21 Medicare Act (Eligibility, Election, and Enrollment))","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1396a":"42:1396a (42:1396a State Plans for Medical Assistance)","42:1396b":"42:1396b (42:1396b Medical Assist Prgm, Pmt to States/Medicaid Implem)","42:13981":"42:13981 (42:13981 Violence Against Women Act (Civil Rights))","42:14135":"42:14135 (42:14135 DNA Backlog Grant Program)","42:1437":"42:1437 (42:1437 U.S. Housing Act of 1937)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1475":"42:1475 (42:1475 Declaratory & Injunctive Relief - Foreclosure Procedures)","42:1479":"42:1479 (42:1479 Mortgage, lease, contract re farm housing)","42:14901":"42:14901 (42:14901 Intercountry Adoptions)","42:15483":"42:15483 (42:15483 Help America Vote Act)","42:1651":"42:1651 (42:1651 Defense Base Act)","42:1705":"42:1705 (42:1705 Receipt of Workmen's compensation benefits)","42:1971":"42:1971 (42:1971 Voting Rights Law)","42:1973":"42:1973 (42:1973 Voting Rights Act)","42:1973(a)":"42:1973(a) (42:1973(a) Enforcement of Voting Rights)","42:1973(c )":"42:1973(c ) (42:1973(c ) Voting Rights -Qualifications & Procedures)","42:1973gg-2":"42:1973gg-2 (42:1973gg-2 Nat'l. Voter Registration Act of 1993 (NVRA))","42:1981a":"42:1981a (42:1981a Damages in cases of intentional discrim. in employment)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981ra":"42:1981ra (42:1981ra Race Discrimination)","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1982hs":"42:1982hs (42:1982hs Discrimination re property rights (housing))","42:1982ra":"42:1982ra (42:1982ra Discrimination re property rights (race))","42:1982sx":"42:1982sx (42:1982sx Discrimination re property rights (sex))","42:1983bv":"42:1983bv (42:1983bv Bivens Non-Prisoner)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983cvp":"42:1983cvp (42:1983cvp Civil Rights (Personal Property))","42:1983d":"42:1983d (42:1983d Civil Rights (Death))","42:1983dp":"42:1983dp (42:1983dp Civil Right Denial of Due Process)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1983vp":"42:1983vp (42:1983vp Violation of Due Process and Equal Protection)","42:1985":"42:1985 (42:1985 Consipracy to interfere with civil rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:1987":"42:1987 (42:1987 Prosecution of violations of certain laws (violations of sec 1990 or 5506 to 5516 or 5518 to)","42:1988":"42:1988 (42:1988 Proceedings in Vindication of Civil Rights)","42:1997":"42:1997 (42:1997 Institutionalized Persons Act of 1980 )","42:2000a-3pa":"42:2000a-3pa (42:2000a-3pa Discrimination, segregation; public accommodation - Injunctive Relief)","42:2000ad":"42:2000ad (42:2000ad Job Discrimination (Disability Act))","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000bb":"42:2000bb (42:2000bb Religious Freedom Restoration Act of 1993)","42:2000bea":"42:2000bea (42:2000bea Equal access to public facilities)","42:2000c-6ed":"42:2000c-6ed (42:2000c-6ed Discrimination in Education)","42:2000cc":"42:2000cc (42:2000cc Religious Land Use & Institutionalized Persons Act of 2000)","42:2000d":"42:2000d (42:2000d Federally Assisted Programs)","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000e-2ag":"42:2000e-2ag (42:2000e-2ag Job Discrimination (Age))","42:2000e-2e":"42:2000e-2e (42:2000e-2e Job Discrimination (Unlawful Employment Practices))","42:2000e-2no":"42:2000e-2no (42:2000e-2no Job Discrimination (National Origin))","42:2000e-2ot":"42:2000e-2ot (42:2000e-2ot Job Discrimination (other))","42:2000e-2pb":"42:2000e-2pb (42:2000e-2pb Job Discrimination (Public Accomodations))","42:2000e-2ra":"42:2000e-2ra (42:2000e-2ra Job Discrimination (Race))","42:2000e-2rl":"42:2000e-2rl (42:2000e-2rl Job Discrimination (religion))","42:2000e-2sh":"42:2000e-2sh (42:2000e-2sh Job Discrimination (Sexual Harassment))","42:2000e-2sx":"42:2000e-2sx (42:2000e-2sx Job Discrimination (Sex))","42:2000e-5eeo":"42:2000e-5eeo (42:2000e-5eeo Petition to Enforce EEOC Subpoena)","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2210":"42:2210 (42:2210 Indeminification & Limitation of Liability-Financial)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:2996":"42:2996 (42:2996 Legal Services Corporation Act)","42:3058(g)":"42:3058(g) (42:3058(g) Older American's Act of 1965, 42 U.S.C. 3058(g) (State Long-term Care Ombudsman Program))","42:3121":"42:3121 (42:3121 Public Works and Economic Development Act of 1965)","42:3133":"42:3133 (42:3133 Coordination - Grants for Public Works and Economic Development)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:3604(f)(3)(c )":"42:3604(f)(3)(c ) (42:3604(f)(3)(c ) Fair Housing Amendments Act)","42:3610":"42:3610 (42:3610 Fair Housing Act-Administrative Enforcement; Preliminary Matters)","42:3612":"42:3612 (42:3612 Civil rights in housing - Enforcement by Secretary)","42:3613":"42:3613 (42:3613 Action for inj relief re deprivation of civil rights)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4013":"42:4013 (42:4013 National Flood Insurance Act - Nature and Limitation of Insurance Coverage)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:4721":"42:4721 (42:4721 Intergovernmental Personnel Act (findings and purposes))","42:4821":"42:4821 (42:4821 Lead-Based Paint Poisoning Prevention Act (findings and purposes) )","42:4901":"42:4901 (42:4901 Noise Control Act of 1972 (findings and purposes))","42:4910(c )":"42:4910(c ) (42:4910(c ) Action to restrain violation re noise control)","42:5101":"42:5101 (42:5101 Child Abuse Prevention and Treatment Act)","42:5303":"42:5303 (42:5303 Block Grant Act of 1974 (42 USC 5301-5321))","42:5401":"42:5401 (42:5401 Natl Mnfactrd Housing Cnstr Safety Standard Act 1974 (findings and purposes))","42:5411":"42:5411 (42:5411 Housing Construction and Safety Standards Act - Injunctive Relief)","42:5851":"42:5851 (42:5851 Discrimination Whistle blower Employee - ERA (employee protection))","42:6101":"42:6101 (42:6101 Age Discrimination in Federally Assisted Programs (statement of purpose))","42:6201":"42:6201 (42:6201 Energy Policy & Conservation Act (statement of purpose))","42:6393":"42:6393 (42:6393 Controversies under Energy Policy & Conservation Act (Admin Procedure and Judicial Review))","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:6928":"42:6928 (42:6928 Violations of requirements of hazardous Waste Mgmt (federal enforcement))","42:6961":"42:6961 (42:6961 Federal Facilities Compliance Act)","42:6972":"42:6972 (42:6972 Resource & Recovery Act - Citizen Suit)","42:6972(a)":"42:6972(a) (42:6972(a) Solid Waste Disposal Act - Citizen Suit)","42:7192":"42:7192 (42:7192 Controversies under Dept of Energy Organization Act - Judicial Review)","42:7384":"42:7384 (42:7384 Energy Employees Occupational Illness Compensation Program Act (EEOICPA))","42:7401":"42:7401 (42:7401 Clean Air Act (findings & declarations))","42:7412":"42:7412 (42:7412 Air Pollution Control - emission standards )","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7413(b)":"42:7413(b) (42:7413(b) Clean Air Act - Enforcement)","42:7475":"42:7475 (42:7475 Clean Air Act - Preconstruction Requirements)","42:7545":"42:7545 (42:7545 Air Pollution Prevention - Regulation of Fuels)","42:7603":"42:7603 (42:7603 Action for immediate restraint (Emergency Powers))","42:7604":"42:7604 (42:7604 Clean Air Act - Citizen suit to enforce Clean Air Act)","42:7604(f)cl":"42:7604(f)cl (42:7604(f)cl Clear Air Act - Emission Standards)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:7671":"42:7671 (42:7671 Clean Air Act (Stratospheric Ozone Protection) (Definitions))","42:8324":"42:8324 (42:8324 Powerplant and Industrial Fuel Use - terms and conditions)","42:8351":"42:8351 (42:8351 Powerplant and Industrial Fuel Use - Temporary Exemptions)","42:9601":"42:9601 (42:9601 Comprehensive Environmental Compen/Resp/Liab (CERCLA) (Definitions))","42:9604":"42:9604 (42:9604 Comprehensive Envir., Response, Comp. & Liab. Act (CERCLA) - Removal and Other Remedial Acti)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","42:9613":"42:9613 (42:9613 Comp Environ Recovery Comp & Liability Act (CERCLA) - Civil Proceedings)","43:0421":"43:0421 (43:0421 Complaint in Condemnation - Eminent Domain)","43:0945a":"43:0945a (43:0945a Compensation for Land Condemnation )","43:0945b":"43:0945b (43:0945b Complaint in Condemnation - Easements)","43:0946":"43:0946 (43:0946 Complaint in Condemnation - Right of Way for Irrigation and Drainage Projects)","43:1331":"43:1331 (43:1331 Outer Continental Shelf Lands Act (Definitions))","43:1333":"43:1333 (43:1333 Outer Continental Shelf Lands Act - Laws and Regulations Governing Lands)","43:1349":"43:1349 (43:1349 Outer Continental Land Shelf Act - Citizen Suits)","43:1701":"43:1701 (43:1701 Violation of Federal Land Policy and Management Act (FLPMA))","43:1737":"43:1737 (43:1737 FLPMA - Implementation Provisions)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","44:2107":"44:2107 (44:2107 Presidential Recordings and Materials Act (NARA acceptance of records for historical preserv)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0056":"45:0056 (45:0056 Employers Liability Act - Personal Inj re Railroads (bringing an action))","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0152":"45:0152 (45:0152 Railway Labor Act - General Duties)","45:0153":"45:0153 (45:0153 First Railway Labor Act - National Railroad Adjustment Board)","45:0159":"45:0159 (45:0159 Review of arbitration award (RR Carriers/Mediation Bd))","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:0231(f)":"45:0231(f) (45:0231(f) Compel obedience to order of Railroad Retirement Bd)","45:0351":"45:0351 (45:0351 Railroad Unemployment Insurance Act)","45:0719":"45:0719 (45:0719 Regional Rail Reorganization Act of 1973 (judicial review))","45:1105":"45:1105 (45:1105 Northeast Rail Service Act - Judicial Review)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:2114":"46:2114 (46:2114 Wrongful Discharge from Employment - protection from discrimination)","46:30101":"46:30101 (46:30101 Extension of jurisdiction to cases of damage or injury on land)","46:30104":"46:30104 (46:30104 Marine Personal Injury - Jones Act)","46:30302":"46:30302 (46:30302 Shipping: Damages for Death on High Seas )","46:30304":"46:30304 (46:30304 Breach of Maritime Contract - liability of noncompliance)","46:30503":"46:30503 (46:30503 Limitation of Liability - declaration of nature and value of goods)","46:30504":"46:30504 (46:30504 Limitation of Liability - loss by fire)","46:30505-30510":"46:30505-30510 (46:30505-30510 Exoneration, Limitation of Liability)","46:30511":"46:30511 (46:30511 Action by owner for limitation)","46:30701":"46:30701 (46:30701 Marine Cargo Loss or Damage - Liability of Water Carriers)","46:30704":"46:30704 (46:30704 Liability of Water Carriers - Loading, stowage, custody, care, and delivery)","46:30902 to 30911":"46:30902 to 30911 (46:30902 to 30911 Suits in Admiralty Act )","46:31102":"46:31102 (46:31102 Public Vessels Act - Waiver of Immunity)","46:31301":"46:31301 (46:31301 Federal Maritime Lien Act)","46:31301 to 31343":"46:31301 to 31343 (46:31301 to 31343 Maritime Commercial Instruments and Liens Act)","46:31321":"46:31321 (46:31321 Foreclosure of Preferred Ship Mortgages)","46:31325":"46:31325 (46:31325 Suit to enforce lien upon mortgaged vessel-foreclosure / Foreclosure of Preferred Foreign S)","46:31341":"46:31341 (46:31341 Federal Maritime Lien Act)","46:31342":"46:31342 (46:31342 Breach of Maritime Contract (establishing maritime liens))","46:31343":"46:31343 (46:31343 Commercial Instruments & Maritime Liens)","46:40101":"46:40101 (46:40101 Shipping Act of 1998 )","46:41102(a)":"46:41102(a) (46:41102(a) Shipping Act of 1984 - General Prohibitions)","46:41309":"46:41309 (46:41309 Shipping Act of 1984 - Enforcement of Reparation Orders)","46:50101":"46:50101 (46:50101 Violation of Maritime Regulations )","46:58109":"46:58109 (46:58109 Violation of Merchant Marine Act - Penalties)","47:0151":"47:0151 (47:0151 Federal Communications Act of 1934)","47:0151cs":"47:0151cs (47:0151cs Federal Communications Act - Collection for Services)","47:0201bt":"47:0201bt (47:0201bt Breach of Tariff)","47:0203":"47:0203 (47:0203 Telecommunications Collection of Charges)","47:0205":"47:0205 (47:0205 Wire and Radio Communication Svc and Charges (Recovery of Damages) )","47:0206":"47:0206 (47:0206 Carrier's Liability for Damages)","47:0227":"47:0227 (47:0227 FCC-Unsolicited Telephone Sales)","47:0227(b)(3)":"47:0227(b)(3) (47:0227(b)(3) Telephone Consumer Protection Act of 1991)","47:0251":"47:0251 (47:0251 Telecommunications Act of 1996 - Interconnection)","47:0252":"47:0252 (47:0252 Telecommunications Act)","47:0254(h)":"47:0254(h) (47:0254(h) Children's Internet Protection Act)","47:0332":"47:0332 (47:0332 FCA-Wire or Radio Communications (Mobile Services))","47:0332(c )":"47:0332(c ) (47:0332(c ) Federal Telecommunications Act of 1996)","47:0338":"47:0338 (47:0338 Satellite Home Viewer Improvement Act)","47:0401":"47:0401 (47:0401 Application of Federal Communication Comm for Inj. (Enforcement Provisions))","47:0407":"47:0407 (47:0407 Order for payment of money; petition for enforcement;)","47:0510":"47:0510 (47:0510 Forfeiture of Communications Devices)","47:0521":"47:0521 (47:0521 Cable Televsn. Consumer Protection & Competition Act of 1992)","47:0532":"47:0532 (47:0532 Cable Communication Policy Act of 1984)","47:0551":"47:0551 (47:0551 Cable Communications Act)","47:0553":"47:0553 (47:0553 U.S.C.A. Cable Communications Policy Act)","47:0605":"47:0605 (47:0605 Unlawful Reception Broadcast Signal i.e., Satellite - Theft of Satellite Communications)","47:227":"47:227 (Restrictions on use of telephone equipment)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0101":"49:0101 (49:0101 ICC Termination Act of 1996)","49:0502":"49:0502 (49:0502 Transportation Administrative Subpoena)","49:0781":"49:0781 (49:781 Forfeiture)","49:10101":"49:10101 (49:10101 Interstate Commerce Act-Interstate Transportation Rail)","49:10743":"49:10743 (49:10743 Revised Interstate Commerce Act)","49:11101":"49:11101 (49:11101 Interstate Commerce Act)","49:1113":"49:1113 (49:1113 Petition to enforce administrative summon)","49:1136":"49:1136 (49:1136 Aviation Disaster Family Assistance Act of 1996)","49:11501":"49:11501 (49:11501 Railroad Revitalization & Regulatory Reform Act (General jurisdiction))","49:11502":"49:11502 (49:11502 Railroad Revitalization Regulatory Reform (authority to exempt rail carrier transportation))","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11701":"49:11701 (49:11701 General authority of enforcement of regulations in rail)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:11705":"49:11705 (49:11705 Limitation on actions by and against rail carriers)","49:11706":"49:11706 (49:11706 Carmack Amendent (Liability of carriers under receipts and bills of lading))","49:11707":"49:11707 (49:11707 Carmack Amendment (Liability when property is delivered in violation of routing instruction)","49:13101":"49:13101 (49:13101 Transportation Policy)","49:13702":"49:13702 (49:13702 Tariff requirement for certain transportation)","49:13706":"49:13706 (49:13706 Motor Carriers, etc-Liability for Payment of Rates)","49:14501":"49:14501 (49:14501 Preemption (federal authority of intrastate transportation))","49:14705":"49:14705 (49:14705 Interstate Commerce Act/Carmack Amendment (Limitations on actions by and against carriers))","49:14706":"49:14706 (49:14706 Carmack Amendment to the Interstate Commerce Act / Liability of Carriers - Receipts & Bills)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","49:20301-20306":"49:20301-20306 (49:20301-20306 Federal Safety Appliance Act)","49:21302":"49:21302 (49:21302 Carriers violations of Interstate Commerce Act (Chapter 201 accident and incident violation)","49:30101":"49:30101 (49:30101 National Traffic & Motor Vehicle Safety Act )","49:30112":"49:30112 (49:30112 Motor Vehicle Safety (prohibition on non-complying motor vehicles and equipment))","49:30502":"49:30502 (49:30502 Natl Motor Vehicle Title Information Syst)","49:31114":"49:31114 (49:31114 Access to Interstate System/Commercial Motor Vehicle )","49:31502":"49:31502 (49:31502 Motor Carrier Safety: Requirements for Qualifications)","49:32101":"49:32101 (49:32101 Motor Vehicle Information and Costs Savings Act)","49:32701":"49:32701 (49:32701 Odometer Requirements Act)","49:32710":"49:32710 (Odometers Act)","49:40101":"49:40101 (49:40101 Federal Aviation Act)","49:40102":"49:40102 (49:40102 Airline Deregulation Actv(definitions of air and commerce safety) )","49:40105":"49:40105 (49:40105 Warsaw Convention )","49:41705":"49:41705 (49:41705 Air Carrier Access Act (discrimination against handicapped individuals))","49:41713":"49:41713 (49:41713 Airline Deregulation Actv (premp of authority over prices, routes, and service))","49:44709":"49:44709 (49:44709 Noise Control Act of 1972 )","49:44715":"49:44715 (49:44715 Noise Control Act of 1972 )","49:46507":"49:46507 (49:46507 False information and threats)","49:47101":"49:47101 (49:47101 Airport and Airway Improvement Act of 1982)","49:47501":"49:47501 (49:47501 Aviation Safety & Noise Abatement Act of 1979 )","49:49101":"49:49101 (49:49101 Wrongful Termination in Contravention of Published Regulations)","49:49104":"49:49104 (49:49104 Breach of Lease by Metro. Wash. Airport Auth.)","49:60101":"49:60101 (49:60101 Pipeline Safety Act of 1994)","49:60102":"49:60102 (49:60102 Hazardous Liquid Pipeline Safety Act of 1979 (HLPSA))","49:80102":"49:80102 (49:80102 Bills of Lading - Application)","49:80302":"49:80302 (49:80302 Contraband - Prohibitions)","49:80303":"49:80303 (49:80303 Seizure and forfeiture of vessel or aircraft conveying contraband )","50:1701-1706":"50:1701-1706 (50:1701-1706 International Emergency Economic Powers Act)","50a:0001":"50a:0001 (50a:0001 Trading With the Enemy Act (act located in Title 50, Appendix.))","50a:0501":"50a:0501 (50a:0501 Sailors and Soldiers Civil Relief Act (act located in Title 50, Appendix.))","50a:0533":"50a:0533 (50a:0533 Servicemembers Civil Relief Act-mortgages (act located in Title 50, Appendix.))","50a:0540":"50a:0540 (50a:0540 Sailors and Soldiers Civil Relief Act (act located in Title 50, Appendix.))","50a:2412":"50a:2412 (50a:2412 Export Administration Act--1979 (act located in Title 50, Appendix.))","51:20137(a)":"51:20137(a) (51:20137(a) Malpractice & Negligence Against U.S. Space program )","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"laedce":{"00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552ad":"05:0552ad (05:0552 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:0706":"05:0706 (05:0706 Jud. Review of Food Stamp Rev. Program)","05:2302":"05:2302 (05:2302 Federal Whistleblowing Act)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (07:0006(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (07:0025 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:1721":"07:1721 (07:1721 Agricultural Trade Development Asst Act)","07:1930":"07:1930 (07:1930 Perishable Agric. Comm. Act of 1930)","07:2023":"07:2023 (07:2023 Food Stamp Act)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:0287":"08:0287 (08:0287 Petition to Enforce INS Subpoena)","08:1101":"08:1101 (08:1101 Immigration & Nationality Act)","08:1105":"08:1105 (08:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1251":"08:1251 (08:1251 Immigration and Nationality Act)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1255":"08:1255 (08:1255 - Immigration and Nationality Act)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1446":"08:1446 (08:1446 Petition for Naturalization Hearing)","08:1447":"08:1447 (08:1447 Review of Denial of Naturalization Application)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0004":"09:0004 (09:0004 Arbitration)","09:0008":"09:0008 (09:0008 Declaratory Judgment/Admiralty)","09:0009":"09:0009 (09:0009 Motion to Confirm Arbitration Award)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","09:0201":"09:0201 (09:0201 Recognition & Enforcement of Foreign Arbitral Awards)","09:0205":"09:0205 (09:0205 - Enforcement of Foreign Arbital Awards)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","11:1445":"11:1445 (11:1445 Collection of a Discharged Obligation)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1421":"12:1421 (12:1421 Federal Home Loan Bank Act)","12:1421fi":"12:1421fi (12:1421fi FIRRE)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1818":"12:1818 (12:1818 Recovery On Notes By FDIC)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:2601":"12:2601 (12:2601 Real Estate Settlement Procedures Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","12:3479":"12:3479 (12:3479 Louisiana Watercraft Statute)","12:4010":"12:4010 (12:4010 Violation of Expedited Funds Availability Act)","14:1125":"14:1125 (14:1125 Anticybersquatting Piracy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fi":"15:0002fi (15:0002fi Fair Labor Standards Act)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0053b":"15:0053b (15:0053(b) Prelim & Perm Inj Relief & Other Equitable Relief)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:0717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1221":"15:1221 (15:1221 Auto Dealer Suits Agst Manufactures)","15:1267":"15:1267 (15:1267 Federal Hazardous Substances Act)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1691":"15:1691 (15:1691 Equal Credit Opportunity Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1709":"15:1709 (15:1709 Other Fraud)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2616":"15:2616 (15:2616 Environmental Matters)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:6801":"15:6801 (15:6801 - Gram-Leach-Bliley Act)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0201":"17:0201 (17:0201 - Ownership of Copyright)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1030":"18:1030 (18:1030 United States Computer Fraud Abuse Act)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2252":"18:2252 (18:2252 Assault, Internet Pornography)","18:2510":"18:2510 (18:2510 Electronic Communications Privacy Act)","18:2707":"18:2707 (18:2707 Electronic Communication Privacy Act)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","18:925c":"18:925c (18:925(c) Petition for Relief from Disabilities under FFA)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1087":"20:1087 (20:1087 Student Loan Recovery)","20:1097":"20:1097 (20:1097 Education - fraud)","20:1332":"20:1332 (20:1332 - E.R.I.S.A.)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1412":"20:1412 (20:1412 Disabilities Education Act)","21:0301":"21:0301 (21:0301 Food, Drug & Cosmetic Act)","21:0332":"21:0332 (21:0332 Federal Food, Drug & Cosmetic Act)","21:0360":"21:0360 (21:0360 - Federal Food, Drug & Cosmetic Act)","21:0601":"21:0601 (21:0601 Federal Meat Inspection Act(FMIA))","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","22:3612":"22:3612 (22:3612 Claim for Damage to Panama Canal)","22:3776":"22:3776 (22:3776 Panama Canal Commission Action)","22:3777":"22:3777 (22:3777 Allision in Panama Canal Locks)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6320":"26:6320 (26:6320 - Ntc of Determ. Concerning Collection Action(s))","26:6502":"26:6502 (26:6502 IRS: Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422":"26:7422 (26:7422 IRS Tax Suit)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7430":"26:7430 (26:7430 IRS Tax Suit)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0051":"28:0051 (28:0051 Personal Injury)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1291":"28:1291 (28:1291 Maritime)","28:1300":"28:1300 (28:1300 Cargo Damage/Loss)","28:1301":"28:1301 (28:1301 Cargo Loss or Damage)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332":"28:1332 (28:1332 Marine Personal Injury)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assualt,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1333in":"28:1333in (28:1333 Personal Injury)","28:1333mc":"28:1333mc (28:1333 Marine Contract)","28:1333pd":"28:1333pd (28:1333 Property Damage)","28:1333pi":"28:1333pi (28:1333 Marine Personal Injury)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334b":"28:1334b (28:1334(b) Proceeding arising/related to case under title 11)","28:1334d":"28:1334d (28:1334(d) R&R re motions for abstention (non-core))","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1339":"28:1339 (28:1339 Postal Matters)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345lc":"28:1345lc (28:1345lc Land Condemnation)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346a1":"28:1346a1 (28:1346a1 IRS Tax Suit)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346pi":"28:1346pi (28:1346 - Marine Personal Injury)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1356":"28:1356 (28:1356 Executory Process/Foreclosure)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1367":"28:1367 (28:1367 Other Property Damage)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1391c":"28:1391c (28:1391 Breach of Contract)","28:1391in":"28:1391in (28:1391 Insurance Contract)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1407im":"28:1407im (28:1407 Silicone Gel Breast Implant Products Liability)","28:1407md":"28:1407md (28:1407md Multidistrict Litigation)","28:1407n":"28:1407n (28:1407n - Personal Injury/Norplant Product Liability)","28:1407pl":"28:1407pl (28:1407 Products Liability)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrimination)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting Act)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interpleader)","28:1441lb":"28:1441lb (28:1441 Petition for Removal - Libel, Assault, Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pe":"28:1441pe (28:1441pe Personal Injury)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) State Ct Crim Case Removal)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1452a":"28:1452a (28:1452a Removal of Claims Related to Bankruptcy Cases)","28:1452b":"28:1452b (28:1452 Removal of Claims in re Bankruptcy)","28:1491":"28:1491 (28:1491 Recovery of I.R.S. Taxes)","28:1602":"28:1602 (28:1602 Foreign Sovereign Immunities Act)","28:1605":"28:1605 (28:1605 Foreign Sovereign Immunities Act of 1976)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1651w":"28:1651w (28:1651 All Writs Act)","28:1732":"28:1732 (28:1732 Collection of Indebtedness)","28:1738":"28:1738 (28:1738(a) Parental Kidnapping Prevention Act)","28:1782":"28:1782 (28:1782 Assistance to Foreign Tribunals)","28:1875":"28:1875 (28:1875 Juror Protection Act)","28:1916":"28:1916 (28:1916 Marine Personal Injury)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2000e":"28:2000e (28:2000e Pregnancy Discrimination Act)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2201pi":"28:2201pi (28:2201pi Declaratory Judgment - Personal Injury)","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate)","28:2255mv":"28:2255mv (28:2255 Motion to Vacate)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2283":"28:2283 (28:2283 Injunctive Relief)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2391":"28:2391 (28:2391 Guaranty Agreements)","28:2401":"28:2401 (28:2401 Federal Tort Claims Act)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2412":"28:2412 (28:2412 Equal Access to Justice Act)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:2675":"28:2675 (28:2675 Federal Tort Claims Act)","28:2679d2":"28:2679d2 (28:2679d2 Employee of U.S.A.)","28:2680":"28:2680 (28:2680 Federal Tort Claims Act)","28:2861":"28:2861 (28:2861 Federal Tort Claims Act)","28:3001a":"28:3001a (28:3001(a) Federal Debt Collection Procedures Act of 1990)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","28:7425a":"28:7425a (28:7425a Judiciary & Judicial Procedures)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0207":"29:0207 (29:0207 Fair Labor Standards Act)","29:0210":"29:0210 (29:0210 Workers Adj and Restraining Notification Act (WARN))","29:0216b":"29:0216b (29:0216(b) Fair Labor Standards Act)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0411":"29:0411 (29:0411 Land Griffin Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0626s":"29:0626s (29:0626s Job Discrimination (Sex))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0745":"29:0745 (29:0745 Discrimination)","29:0754":"29:0754 (29:754 Discrimination)","29:0790":"29:0790 (29:0790 Rehabilitation of Labor)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1055":"29:1055 (29:1055 - E.R.I.S.A., Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1161":"29:1161 (29:1161 Comprehensive Omnibus Budget Rec Act of 1985)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1343":"29:1343 (29:1343 - Title VII Discrimination Case)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:1916":"29:1916 (29:1916 Spec. Rule for Longshoremen & Harborworkers)","29:2001":"29:2001 (29:2001 Employee Polygraph Protection Act of 1988)","29:2101":"29:2101 (29:2101 Worker Adjustment & Restraining Notification Act)","29:2601":"29:2601 (29:2601 Family Medical Leave Act)","29:2609":"29:2609 (29:2609 Family & Medical Leave Act)","29:2612":"29:2612 (29:2612 Family Medical Leave Act)","29:2617":"29:2617 (29:2617 Employment Discrimination (Pregnancy))","29:2617ml":"29:2617ml (29:2617 Family & Medical Leave Act)","29:301":"29:301 (29:301(a) Labor Management Relations Act)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalties/Federal Mine Safety Health Act - 1977)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:1331":"31:1331 (31:1331 False Claims Act)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","32:0715":"32:0715 (32:0715 Federal Tort Claims Act)","33:0408":"33:0408 (33:0408 Injury to Harbor Improvement)","33:0594":"33:0594 (33:0594 Land Condemnation)","33:0901":"33:0901 (33:0901 Longshoremen Harbor Workers Compensation Act)","33:0905":"33:0905 (33:0905 Marine Personal Injury)","33:0918":"33:0918 (33:0918 Longshore and Harbor Workers Compensation Act)","33:0921":"33:0921 (33:0921 Longshore & Harbor Workers Compensation Act)","33:0933":"33:0933 (33:0933 Longshore and Harbor Workers' Compensation Act)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1333":"33:1333 (33:1333 Admiralty)","33:1365":"33:1365 (33:1365 Environmental Matters)","33:1515":"33:1515 (33:1515 Deepwater Ports Act)","33:2001":"33:2001 (33:2001 U.S. Inland Navigation Rules)","33:2005":"33:2005 (33:2005 Violation of the Inland Navigation Rules Act of 1980)","33:2701":"33:2701 (33:2701 - Oil Pollution Act)","34:0504":"34:0504 (34:0504 - Rehabilitation Act)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0172":"35:0172 (35:172 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4301":"38:4301 (38:4301 Veterans Re-Employment Act)","39:0409":"39:0409 (39:0409 Postal Service)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:3131":"40:3131 (40:3131 Miller Act)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:0351":"41:0351 (41:0351 Service Contract Act)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0034":"42:0034 (42:0034 Other Civil Rights)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0300":"42:0300 (42:0300 Pub Health & Welfare-Grants & Contracts for Family Planning)","42:0401":"42:0401 (42:0401 Social Security Act)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0423":"42:0423 (42:0423 - Social Security Act)","42:0425":"42:0425 (42:0425 Social Security Benefits)","42:11601":"42:11601 (42:11601 International Child Abduction Remedies Act)","42:1210":"42:1210 (42:1210 Age in Employment Act)","42:12101":"42:12101 (42:12101 Americans With Disabilities Act)","42:12117":"42:12117 (42:12117 Americans with Disabilities Act)","42:12132":"42:12132 (42:12132 Americans with Disabilities Act)","42:12181":"42:12181 (42:12181 Title III Americans with Disabilities Act)","42:12201":"42:12201 (42:12201 Violations of Title II Amer W/Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1395dd":"42:1395dd (42:1395dd Treatment for Emergency Med Conditions)","42:1395hr":"42:1395hr (42:1395 - Hospital Reimbursement for Medicare Services)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:13981":"42:13981 (42:13981 Violence Against Women Act)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983d":"42:1983d (42:1983 Civil Rights (Death))","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1984":"42:1984 (42:1984 Civil Rights)","42:1985":"42:1985 (42:1985 Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:1988":"42:1988 (42:1988 Civil Rights Employment)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3133":"42:3133 (42:3133 - Miller Act)","42:3601":"42:3601 (42:3601 Fair Housing Act)","42:3612":"42:3612 (42:3612 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Flood Insurance Act)","42:4013":"42:4013 (42:4013 National Flood Insurance Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)","42:6201":"42:6201 (42:6201 Energy Policy & Conservation Act)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7401":"42:7401 (42:7401 Clean Air Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9601":"42:9601 (42:9601 Comp Environ, Response, Comp, & Liability Act)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:0945":"43:0945 (43:0945 Compensation for Land Condemnation)","43:0945a":"43:0945a (43:0945a Complaint in Condemnation)","43:0946":"43:0946 (43:0946 Complaint in Condemnation - Eminent Domain)","43:1301":"43:1301 (43:1301 Outer Continental Shelf Lands Act (Definitions))","43:1331":"43:1331 (43:1331 Outer Continental Shelf Lands Act (Definitions))","43:1333":"43:1333 (43:1333 Outer Continental Shelf Lands Act)","43:1349":"43:1349 (43:1349 Outer Continental Land Shelf Act)","43:1438":"43:1438 (43:1438 Marine Personal Injury)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0152":"45:0152 (45:0152 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0181":"46:0181 (46:0181 Limitation of Liability)","46:0182":"46:0182 (46:0182 Limitation of Liability)","46:0183":"46:0183 (46:0183 Limitation of Liability)","46:0185":"46:0185 (46:0185 Exoneration from or Limitation of Liability)","46:0190":"46:0190 (46:0190 Marine Contract)","46:0688":"46:0688 (46:0688 Marine Personal Injury)","46:0740":"46:0740 (46:0740 Marine Injury)","46:0740pd":"46:0740pd (46:0740pd Property Damage)","46:0741":"46:0741 (46:741 Shipping)","46:0742":"46:0742 (46:0742 Suits in Admiralty Act)","46:0745":"46:0745 (46:0745 Suits in Admiralty Acts)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:0781":"46:0781 (46:0781 Public Vessels Act)","46:0951":"46:0951 (46:0951 Maritime Foreclosure)","46:0971":"46:0971 (46:0971 Preferred Maritime Lien)","46:0971pi":"46:0971pi (46:0971pi Maritime Personal Injury)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:1300":"46:1300 (46:1300 Marine Cargo Loss or Damage)","46:1301":"46:1301 (46:1301 Cargo Loss & Damage)","46:1331":"46:1331 (46:1331 Outer Continental Shelf Lands Act)","46:1701":"46:1701 (46:1701 Shipping Act of 1984)","46:1709":"46:1709 (46:1709 Shipping Act of 1984 10(a))","46:1713d":"46:1713d (46:1713(d) Shipping Act of 1984 14(d))","46:2114":"46:2114 (46:2114 Wrongful Discharge from Employment)","46:30104":"46:30104 (46:30104 Marine Personal Injury)","46:30504":"46:30504 (46:30504 Exoneration from or Limitation of Liability)","46:31301":"46:31301 (46:31301 Breach of Maritime Contract)","46:31321":"46:31321 (46:31321 Foreclosure of Preferred Ship Mortgages)","46:31325":"46:31325 (46:31325 Admiralty)","46:31341":"46:31341 (46:31341 Federal Maritime Lien Act)","46:31342":"46:31342 (46:31342 Breach of Maritime Contract)","46:31343":"46:31343 (46:31343 Commercial Instruments & Maritime Liens)","46:9721":"46:9721 (46:9721 Federal Maritime Lien Act)","47:0251":"47:0251 (47:0251 Telecommunications Act of 1996)","47:0605":"47:0605 (47:0605 Theft of Satellite Communications)","47:4072":"47:4072 (47:4072 National Flood Insurance Program)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:10743":"49:10743 (49:10743 Revised Interstate Commerce Act)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)","49:11701":"49:11701 (49:11701 Admiralty & Maritime)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)","49:1305":"49:1305 (49:1305 Airline Deregulation Act)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summons)","49:30101":"49:30101 (49:30101 National Traffic & Motor Vehicle Safety Act)","49:40101":"49:40101 (49:40101 Federal Aviation Act)","50:0540":"50:0540 (50:0540 Sailors and Soldiers Civil Relief Act)","misc":"misc (Civil Miscellaneous Case)"},"lamdce":{"0":"0 (no cause specified)","00:0000":"00:0000 (Cause code unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451(j)":"08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:191":"12:191 (12:191 Bank Foreclosure)","12:192":"12:192 (12:192 Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:3901":"15:3901 (15:3901 Liability Risk Retention Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2511":"18:2511 (18:2511 Wiretapping)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0301":"21:0301 (21:0301 FDA Drug & Cosmetic Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Fed. Question: Civil Rights Violation)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel, Assault, Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 VA Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Notice of Removal-Account Receivable)","28:1441al":"28:1441al (28:1441 Notice of Removal-Airline Crash)","28:1441as":"28:1441as (28:1441 Notice of Removal-Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Notice of Removal-Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Notice of Removal-Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Notice of Removal-Contract Default)","28:1441dj":"28:1441dj (28:1441 Notice of Removal-Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441 Notice of Removal-Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Notice of Removal-Fraud)","28:1441ij":"28:1441ij (28:1441 Notice of Removal-Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Notice of Removal-Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Notice of Removal-Libel, Assault, Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Notice of Removal-Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Notice of Removal-Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Notice of Removal-Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Notice of Removal-Property Damage)","28:1441pi":"28:1441pi (28:1441 Notice of Removal-Personal Injury)","28:1441pl":"28:1441pl (28:1441 Notice of Removal-Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Notice of Removal-Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Notice of Removal-Torts to Land)","28:1441tm":"28:1441tm (28:1441 Notice of Removal-Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Notice of Removal-Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Notice of Removal-Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Notice of Removal-Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1441 Notice of Removal-Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Notice of Removal-Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Notice of Removal-Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1655":"28:1655 (28:1655 Petn, Relief from Judgment)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1911":"28:1911 (Fees and Costs)","28:1962":"28:1962 (28:1962 Cmp to retrieve a federal court judgment)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (Actions affecting property on which United States had lien)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2617":"29:2617 (Family and Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:12101":"42:12101 (Americans with Disabilities Act)","42:12182":"42:12182 (42:12182 Americans with Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1984":"42:1984 (Wrongful taking of Property Rights by Municipal w/o Due Proc)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accommodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:0688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:0605":"47:0605 (47:0605 Communications Act of 1934)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","adsup":"adsup (Administrative Subpoena)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","fordepo":"fordepo (Foreign Deposition)","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","writgar":"writgar (Application for a Writ of Garnishment)"},"lawdce":{"0":"0 (No cause code entered)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:1501":"07:1501 (07:1501 Federal Crop Insurance Act)","07:2023":"07:2023 (07:2023 Suit for injunctive relief under Food Stamp Act)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:0287":"08:0287 (08:0287 Petition to Enforce INS Subpoena)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1183":"08:1183 (08:1183 Alien Admission - Sponsor Obligations)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","09:0201":"09:0201 (09:0201 Enforcement of foreign arbitral awards)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","11:0362":"11:0362 (11:0362 Alleged Violation of Automatic Stay)","11:0525":"11:0525 (11:0525 Protection Against Debtor Discrimination)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0191":"12:0191 (12:0191 Bank Foreclosure)","12:0192":"12:0192 (12:0192 Liquidation of National Bank)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1818i2I":"12:1818i2I (12:1818(i)(2)(I) Federal Deposit Insurance Act)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act)","12:2011":"12:2011 (12:2011 Farm Credit Act of 1971)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0053(b)":"15:0053(b) (15:0053(b) - Prelim & Perm Inj Relief & other Equity)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0078j":"15:0078j (15:78j(b)ss Stockholder Suit)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1691":"15:1691 (15:1691 Equal Credit Opportunity Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693":"15:1693 (15:1693 Electronic Fund Transfer Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0922":"18:0922 (18:0922 Brady Handgun Control Act)","18:1030":"18:1030 (18:1030 Computer Fraud and Abuse Act)","18:1836a":"18:1836a (18:1836(a) - Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) - Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2511":"18:2511 (18:2511 Wiretapping)","18:2701":"18:2701 (18:2701 Unlawful access to stored communications)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1071":"20:1071 (20:1071 Student Loan Recovery)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1087":"20:1087 (20:1087 National Direct Student Loan)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0674":"21:0674 (21:0674 Enforcement & Inj. relief from F.D.A.)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0842":"21:0842 (21:0842 Civil penalties-recordkeeping violations)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","22:9001":"22:9001 (22:9001 International Child Abduction Remedies)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:4968":"26:4968 (26:4968 Recovery of refund of IRS taxes)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:0754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Cases and Proceedings)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-core))","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1349 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1395":"28:1395 (28:1395 Fine, Penalty, Forfeiture)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrimination)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interpleader)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 Removal of claim in civil action related to BK. case)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1962":"28:1962 (28:1962 Lien Against Property)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0790":"29:0790 (29:0790 Rehabilitation of Labor)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2001":"29:2001 (29:2001 Violation of employer polygraph protection act)","29:2101":"29:2101 (29:2101 Worker Adjustment & Retraining Notification)","29:2601":"29:2601 (29:2601 Family and Medical Leave Act)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:0901":"33:0901 (33:0901 Longshoreman's & Harbor Worker's Act)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","33:2001":"33:2001 (33:2001 Inland Navigation Rules)","33:905(b)":"33:905(b) (Longshoremen Workers' Compensation Act - Recovery of Damages caused by the negligence of a Vess)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act)","38:2021":"38:2021 (38:2021 Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4301":"38:4301 (38:4301 Employment & Re-employment Rights of Uniformed Service Members)","39:0409":"39:0409 (39:0409 - Postal Service)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:3131":"40:3131 (40:3131 Miller Act)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0121":"42:0121 (42:121 Judicial Proceedings to Exercise Rights of Access)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0294":"42:0294 (42:0294 Health Education Assist Loan)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11603":"42:11603 (42:11603 International child abduction)","42:12101":"42:12101 (42:12101 Americans with Disabilities Act)","42:12132":"42:12132 (42:12132 Americans with Disabilities Act - Discrimination)","42:12181":"42:12181 (42:12181 Americans with Disabilities Act - Public Accomodations)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1395dd":"42:1395dd (42:1395dd Emergency Medical Treatment & Active Labor Act)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:1997":"42:1997 (42:1997 Civil rights of institutionalized persons act)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2541(q)":"42:2541(q) (42:2541(q) Suit on Natl Health Svc Corp Sch Loan)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:3604":"42:3604 (42:3604 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:0945":"43:0945 (43:0945 Compensation for Land Condemnation)","43:0945a":"43:0945a (43:0945a Complaint in Condemnation)","43:0946":"43:0946 (43:0946 Complaint in Condemnation - Eminent Domain)","43:1331":"43:1331 (43:1331 General Maritime/OCSLA)","43:1333":"43:1333 (43:1333 Outer Continental Shelf Lands Act)","43:1349(h)":"43:1349(h) (43:1349(h) Suit on open acct for enforcement of lien)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0183":"46:0183 (46:0183 Exoneration from or limitation of liability)","46:0688":"46:0688 (46:0688 Jones Act Suit)","46:0740":"46:0740 (46:0740 Admiralty & Maritime Jurisdiction)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:30104":"46:30104 (46:30104 Personal Injury to or Death of Seamen)","46:30501":"46:30501 (46:30501 Exoneration & Limitation of Liability)","46:31325":"46:31325 (46:31325 Preferred Mortgage Liens & Enforcement)","47:0227":"47:0227 (47:0227 Telephone Consumer Protection Act)","47:0503":"47:0503 (47:0503 Violation of wire or radio comm regulations)","47:0605":"47:0605 (47:0605 Unauthorized Publication or Use of Communications)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summons)"},"madce":{"0":"0 (No cause code entered)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (5:8470 Enforcement of Judgment Against Retirement Benefits)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451(j)":"08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","11:0548":"11:0548 (11:548 Unfair and Deceptive Trade Acts)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1452f":"12:1452f (12:1452(f) Action to enforce note and mortgage)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:191":"12:191 (12:191 Bank Foreclosure)","12:192":"12:192 (12:192 Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act)","12:2601":"12:2601 (Real Estate Settlement Procedures Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1679":"15:1679 (Credit Repair Organizations Act)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","17:0512":"17:0512 (17:512(h) Digitial Millennium Copyright Act of 1998)","17:512h":"17:512h (17:512(h) Subpoena issued)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1030":"18:1030 (18:1030 Violation of Computer Fraud and Abuse Act)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1955":"18:1955 (Forfeiture - gambling)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2511":"18:2511 (18:2511 Wiretapping)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","18:4246":"18:4246 (Certification of Dangerousness Due to Mental Disease or Defect)","18:4248":"18:4248 (18:4248(a) Commitment of Sexually Dangerous Person)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1415":"20:1415 (20:1415 Rights to Special Educational Services)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1349 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1342":"29:1342 (ERISA - Termination Proceedings)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2601":"29:2601 (Family and Medical Leave Act of 1993)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (38:2021 Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:775":"38:775 (38:775 Recovery of Servicemen's Group Life Insurance)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:12182":"42:12182 (42:1218(2) Americans with Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:13981":"42:13981 (Violence Against Women Act)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:31324":"46:31324 (46:3132(4) In Rem Action to Foreclose Ship's Mortgage)","47:0151":"47:0151 (47:151 Federal Communications Act of 1934)","47:0553":"47:0553 (47:553 Cable Communications Policy Act)","47:332c":"47:332c (47:332(c) Federal Telecommunications Act of 1996)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:10761":"49:10761 (49:1076(1) Failure to pay tariff)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","950":"950 (Constitutionality of State Statutes)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","MDL":"MDL (Multi District Litigation - 28 USC 1407)","adsup":"adsup (Administrative Subpoena)","appl6001":"appl6001 (Application pursuant to 18:6001 et seq.)","applIII":"applIII (Application - Title III wiretaps)","appldisclo":"appldisclo (Application for disclosure order)","asgnjgm":"asgnjgm (Assignment of Judgment to US)","attydisc":"attydisc (Referral from BK Court - Attorney Discipline)","bkadv":"bkadv (Adversarial proceedings - Bankruptcy)","bkcert":"bkcert (Certification of issue from Bankruptcy Court)","cmprcv":"cmprcv (Complaint and Order establishing Receivership)","contempt":"contempt (Contempt Proceedings)","contproc":"contproc (Contested miscellaneous proceeding)","disbar":"disbar (Disbarment Proceedings)","extindi":"extindi (Motion to extend time to indict)","fordepo":"fordepo (Foreign Deposition)","gjproc":"gjproc (Grand Jury Proceedings)","inc":"inc (Incomplete filing by pro se litigant)","lvapp":"lvapp (For leave to appeal interlocutory order of BK Court)","mdl":"mdl (Multi District Litigation - master case)","misc":"misc (Civil Miscellaneous Case)","motcnsl":"motcnsl (Motion for appointment of counsel for grand jury)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","penreg":"penreg (Application for a pen register)","petenf":"petenf (Petition to enforce IRS summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","trap":"trap (Trap & trace application - 18 USC 3122, 3123)","writent":"writent (Application for writ of entry)","writgar":"writgar (Application for a Writ of Garnishment)","writhc":"writhc (Petition for writ of habeas corpus)","xx":"xx (JS 44 Sec. IV - no matching citation currently in database)"},"mddce":{"0":"0 (00:0000)","02:0138":"02:0138 (02:0138 Library of Congress Access)","02:0358":"02:0358 (02:0358 President's Recommendations on Exec., Jud. & Leg. Salary)","02:0431":"02:0431 (02:0431 Federal Election Commission: Failure to Enforce Compliance)","02:0437":"02:0437 (02:0437 Federal Election Commission)","02:0681":"02:0681 (02:0681 Deferral of Budget Authority)","02:1202":"02:1202 (02:1202 Discriminatory practices affecting US Senate employees)","02:1301":"02:1301 (02:1301 Congressional Accountability Act)","02:1317(a)":"02:1317(a) (02:1317(a) Violation of Congressional Accountability Act)","05:0075":"05:0075 (DO NOT USE 05:75(2) Contract - Reduction in Grade)","05:0101":"05:0101 (05:0101 Ethics in Government Act)","05:0504(c)":"05:0504(c) (05:0504(c)(2) Equal Access to Justice (Govt Employees))","05:0551":"05:0551 (05:551 Administrative Procedures Act)","05:0552b":"05:0552b (05:0552b(g)sa Implement requirements of Govt in Sunshine Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Adjudications Required by Statutes)","05:0555(b)":"05:0555(b) (05:0555(b) Agency Decision - Right to Counsel)","05:0701":"05:0701 (05:0701 Judicial Review of Agency Decision)","05:0702":"05:0702 (05:702 Administrative Procedure Act - Right of Review)","05:0704":"05:0704 (05:704 Labor Litigation)","05:0706":"05:0706 (05:706 Judicial Review of Agency Action)","05:1158":"05:1158 (5:1158 Immigration & Nationality Act, Section 208 (Asylum))","05:1508":"05:1508 (5:1508 Judicial Review of Order Issued by the Merit Systems Protection Board)","05:2302":"05:2302 (5:2302 Federal Whistleblowing Act / Civil Service Reform Act (CSRA))","05:3318":"05:3318 (5:3318 Veterans Preference Act)","05:5514":"05:5514 (5:5514 Debt Collection Act of 1982)","05:5542":"05:5542 (5:5542 Federal Employees Pay Act -- overtime rates)","05:7101":"05:7101 (5:7101 Labor-Management Relations (Findings and Purpose))","05:7123":"05:7123 (5:7123 Petition by FLRA against unfair labor practices)","05:7501":"05:7501 (5:7501 Government Employees Adverse Action--14 days or less)","05:7511":"05:7511 (5:7511 Government Employees Adverse Action--Over 14 days)","05:7703":"05:7703 (5:7703 Discrimination - Review of Agency Act)","05:8101":"05:8101 (5:8101 Workmen's Compensation Benefits)","05:8110":"05:8110 (5:8110 Augmented Compensation for dependents of Govt. Employees)","05:8316":"05:8316 (5:8316 Claims agst US re Retirement for Federal Emp.)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits )","05:8701":"05:8701 (5:8701 Federal Employees Group Life Insurance Act of 1954)","05:8705":"05:8705 (5:8705 Declaratory Judgment - Insurance)","05:8715":"05:8715 (5:8715 Claims against the US - Jurisdiction of Courts)","05:8901":"05:8901 (5:8901 Federal Employees Health Benefits Act)","05:8902":"05:8902 (5:8902 Contracting Authority of OPM - Group Health Insurance)","05:8903":"05:8903 (5:8903 Federal Employees Health Benefit Act)","05:8912":"05:8912 (5:8912 Claims agst US re health benefits for Federal emp.)","07:0001":"07:0001 (7:1 Commodity Exchange Act)","07:0006":"07:0006 (DO NOT USE7:6(b) Federal Commodity Exchange Regulation)","07:0006(b)":"07:0006(b) (7:6(b) Federal Commodity Exchange Regulation)","07:0009a":"07:0009a (7:9a Recovery of penalties by Commodity Futures Trading Com)","07:0013a":"07:0013a (7:13a Contract market rules violations; recovery of penalty)","07:0013a-1":"07:0013a-1 (7:13a-1 Enjoin or restrain violations Contract Market rules)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0087":"07:0087 (7:87 Enforcement of United States Grain Standards Act)","07:0136":"07:0136 (7:136 Violations of EPA re Environmental Pesticide Control)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0193(b)":"07:0193(b) (7:193(b) Recovery of penalties re violations by packers)","07:0203":"07:0203 (7:203 Recovery of penalties for violations by stockyards)","07:0209(b)":"07:0209(b) (7:209(b) Violations re purchase, sale, handling of livestock)","07:0210(f)":"07:0210(f) (7:210(f) Suit to enforce award of damages (Packers/Stockyards))","07:0213(b)":"07:0213(b) (7:213(b) Unfair, discriminatory, deceptive practice/marketing)","07:0216":"07:0216 (7:216 Injunctions to restrain & enforce orders of Secretary)","07:0222":"07:0222 (7:222 Adoption of FTC powers for enforcement.)","07:0245":"07:0245 (7:245 Action on bond by person injured in Warehouse)","07:0292":"07:0292 (7:292 Monopolizing or restraining trade & enhancing prices)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:0608":"07:0608 (7:608 Agriculture Adjustment Act)","07:0901":"07:0901 (7:901 Rural Electrification Act)","07:1291(b)":"07:1291(b) (7:1291(b) Agricultural Adjustment Act; freight rates.)","07:1376":"07:1376 (7:1376 Adjustment of Quotas and Enforcement; penalties.)","07:1501":"07:1501 (7:1501 Federal Crop Insurance Act)","07:1508":"07:1508 (7:1508 Crop Insurance)","07:1631":"07:1631 (7:1631 Food Security Act)","07:1721":"07:1721 (7:1721 Agricultural Trade Development Asst Act)","07:1922":"07:1922 (7:1922 Persons Eligible for Loans - Forclosure)","07:1926":"07:1926 (7:1926 Water and Waste Facility Loans and Grants)","07:1930":"07:1930 (7:1930 Perishable Agric. Comm. Act of 1930)","07:2011":"07:2011 (7:2011 Supplemental Nutrition Assistance Program)","07:2022":"07:2022 (7:2022 Disposition of Claims: Denial application to participate; food stamp prog.)","07:2023(a)":"07:2023(a) (7:2023(a) Judicial Review of Food Stamp Disqualification)","07:2024":"07:2024 (7:2024 False Claims Act, Food Stamp Fraud)","07:2131":"07:2131 (7:2131 Violation of the Animal Welfare Act)","07:2146":"07:2146 (7:2146 Transportation, Sale, and Handling of Animals)","07:228a":"07:228a (7:228a Request by Secretary for TRO or Inj. re Poultry)","07:2301":"07:2301 (7:2301 Agricultural Fair Practices Act)","07:2305":"07:2305 (7:2305 Unfair trade practices affecting producers Agri prod)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","07:2563":"07:2563 (7:2563 Plant Variety Protection and Rights - Injunction)","07:6999":"07:6999 (7:6999 Judicial Review of Adverse Farm Agency Decision)","08:1101":"08:1101 (8:1101 Immigration & Nationality Act (Definitions))","08:1105":"08:1105 (DO NOT USE 8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1105a":"08:1105a (8:1105a Immigration: Judicial Review for Battered Spouses; Deportation (INS))","08:1151":"08:1151 (8:1151 Immigration and Nationality Act of 1952)","08:1152":"08:1152 (8:1152 Immigration: Numerical limitations on individual foreign states)","08:1153":"08:1153 (8:1153 Immigration: Allocation of Immigrant Visas)","08:1154":"08:1154 (8:1154 Immigration: Procedure for Granting Immigration Status)","08:1158":"08:1158 (8:1158 Immigration & Nationality Act, Section 208 (Asylum))","08:1182":"08:1182 (8:1182 Inadmissible Aliens: Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1183":"08:1183 (8:1183 Admission of Aliens on Giving Bond or Undertaking; Return on Departure)","08:1188":"08:1188 (8:1188 Immigration: Admission of Temporary H-2A Workers)","08:1225":"08:1225 (8:1225 Immigration: Enforcement of Administrative Subpoena)","08:1252":"08:1252 (08:1252 Judicial Review of Orders of Removal)","08:1255":"08:1255 (8:1255 Immigration: Failure USCIS To Adjudicate Permanent Residency Petition)","08:1260":"08:1260 (08:1260 Aliens: Removal of Aliens Falling into Distress)","08:1324":"08:1324 (08:1324 Immigration: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Immigration: Writ of Mandamus to Adjudicate Visa Petition)","08:1357":"08:1357 (8:1357 Immigration and Nationality Act - Administrative Search Warrant)","08:1421":"08:1421 (8:1421 Immigration: Naturalization Authority)","08:1445":"08:1445 (8:1445 Immigration: Application for Naturalization)","08:1446":"08:1446 (8:1446 Immigration: Petition for Naturalization Hearing)","08:1447":"08:1447 (8:1447 Immigration: Review of Denial of Naturalization Application)","08:1451":"08:1451 (8:1451 Immigration: Revocation of Citizenship)","08:1451(a)":"08:1451(a) (8:1451(a) Action to revoke Citizenship)","08:1451(j)":"08:1451(j) (8:1451(j) Immigration: Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0003":"09:0003 (9:3 Application to Stay Proceedings Pending Arbitration)","09:0004":"09:0004 (9:4 Petition to order arbitration; failure to arbitrate)","09:0007":"09:0007 (9:7 Petition to compel attendance before arbitrator)","09:0008":"09:0008 (9:8 Declaratory Judgment/Admiralty)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Award)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","09:0011":"09:0011 (9:11 Motion to modify or correct arbitration award)","09:0201":"09:0201 (9:201 Petition to Compel/Stay Arbitration under an Insurance Contract)","09:0202":"09:0202 (9:202 Award under Convention on Foreign Arbitral Awards)","09:0205":"09:0205 (9:205 Removal from State Court: Enforcement of Foreign Arbital Awards)","09:0207":"09:0207 (9:207 Application for order confirming award of arbitrators)","10:0672":"10:0672 (10:672 Armed Forces: Active Guard/Reserve (AGR) Program)","10:1006":"10:1006 (10:1006 Armed Forces: Review of Agency Decision)","10:1072tc":"10:1072tc (10:1072tc Armed Forces: TRICARE PROGRAM)","10:1089(c)":"10:1089(c) (10:1089(c) Armed Forces: Removal; dft acting in scope of duties)","10:1091":"10:1091 (10:1091 Armed Forces: Personal Service Contracts)","10:1107":"10:1107 (10:1107 Armed Forces: Use Of Investigational New Drug)","10:1408":"10:1408 (10:1408 Armed Forces: Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: Review of Discharge or Dismissal)","10:2005":"10:2005 (10:2005 Armed Forces: Advanced Education Assistance)","10:2121":"10:2121 (10:2121 Armed Forces: Health Professions Scholarship Financial Asst Prog)","10:2302":"10:2302 (10:2302 Armed Forces: Arms Services Procurement Act)","10:2305":"10:2305 (10:2305 Armed Forces: Review of Federal Contract)","10:2323fa":"10:2323fa (10:2323fa Armed Forces: Fifth Amendment Equal Protection: Contract Goal for Small Disadvantaged Bus)","10:2733":"10:2733 (10:2733 Armed Forces: Military Claims Act)","10:2734":"10:2734 (10:2734 Armed Forces: Foreign Military Claims Act)","10:2771":"10:2771 (10:2771 Armed Forces: Final Settlement - Deceased Members)","10:3258":"10:3258 (10:3258 Armed Forces: Reg.Army: Re-enlistment after Service as Ofcr)","11:0101":"11:0101 (11:101 Bankruptcy (Definitions))","11:0110":"11:0110 (11:110 Bankruptcy: Penalty for Preparers of Fraudulent or Negligent Petitions)","11:0362(h)":"11:0362(h) (11:362(h) Bankruptcy: Violation of Automatic Stay)","11:0523":"11:0523 (11:523 Bankruptcy: Exceptions to Discharge)","11:0524":"11:0524 (11:524 Bankruptcy: Effect of Discharge)","11:0525":"11:0525 (11:525 Bankruptcy: Protections Against Discriminatory Treatment)","11:0548":"11:0548 (11:548 Bankruptcy: Fraudulent Transfers and Obligations)","11:0704":"11:0704 (11:704 Bankruptcy: Duties of Trustee)","12:0022":"12:0022 (DO NOT USE 12:22 Securities Fraud)","12:0085":"12:0085 (12:85 National Banks: Rate of Interest on Loans, Discounts, and Purchases)","12:0093(a)":"12:0093(a) (12:93(a) National Banks: Violation of Provisions; Forfeiture of Franchise; Personal Liability of Di)","12:0191":"12:0191 (12:191 National Banks: Appointment of Receiver)","12:0192":"12:0192 (12:192 National Banks: Liquidation of National Bank)","12:0215":"12:0215 (12:215 National Banks: Consolidation and Merger)","12:0622":"12:0622 (12:622 Foreign Banking: Forfeiture, Dissolution, and Liability of Directors and Officers for Noncom)","12:0632":"12:0632 (12:632 Foreign Banking: Voluntary Liquidation)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:0635i-3":"12:0635i-3 (12:635i-3 Export-Import Bank: Breach of Insurance Contract)","12:1421":"12:1421 (12:1421 Federal Home Loan Bank Act (Short Title))","12:1441":"12:1441 (12:1441 FHLB: Financial Inst Reform Receiving Enforcement Act 1989)","12:1451":"12:1451 (12:1451 Emergency Home Loan Corporation (Definitions))","12:1452":"12:1452 (12:1452 Federal Home Loan Mortgage Corporation Act)","12:1452(f)":"12:1452(f) (12:1452(f) Fed Home Loan Mortgage Corp: Actions by and against the Corporation)","12:1455(b)":"12:1455(b) (12:1455(b) Fed Home Loan Mortgage Corp: Enforcement of Regulations)","12:1461":"12:1461 (12:1461 Savings Associations: Homeowners Loan Act (Short Title))","12:1464":"12:1464 (12:1464 Savings Associations: Federal Savings and Loan)","12:1703":"12:1703 (12:1703 National Housing: Insurance of Financial Institutions)","12:1715(b)":"12:1715(b) (12:1715(b) National Housing: Rules and Regulations)","12:1725":"12:1725 (DO NOT USE 12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (DO NOT USE 12:1730 Collection Under Contract Guaranty)","12:1749aaa":"12:1749aaa (12:1749aaa National Housing: National Insurance Development Program)","12:1751":"12:1751 (12:1751 Fed Credit Unions: Short Title)","12:1782":"12:1782 (12:1782 Fed Credit Unions: Administration of Insurance Fund)","12:1786":"12:1786 (12:1786 Fed Credit Unions: Actions re Violations by Credit Unions)","12:1811":"12:1811 (12:1811 FDIC: Financial Inst. Reform Recovery Act of 1989 (FIRREA) (Organization of FDIC))","12:1818":"12:1818 (12:1818 FDIC: Violations re Federal Deposit Insurance Corporation)","12:1818(e)":"12:1818(e) (12:1818(e) FDIC: Suspension or Removal of Bank Officer)","12:1819":"12:1819 (12:1819 FDIC: Corporate Powers)","12:1821":"12:1821 (12:1821 FDIC: Insurance Funds)","12:1831":"12:1831 (12:1831 FDIC: Separability of Certain Provisions)","12:1831(d)":"12:1831(d) (12:1831(d) FDIC: Deposit. Inst. Dereg. & Monetary Ctrl. Act of 1980)","12:1831r-1":"12:1831r-1 (12:1831r-1 FDIC: Notice of Branch Closure)","12:1833(a)":"12:1833(a) (12:1833(a) FDIC: Forfieture Civil Penalties)","12:1954":"12:1954 (12:1954 Injunctions (Action by Sec of Treasury re financial recordkeeping))","12:1971":"12:1971 (12:1971 Relief under Bank Holding Company Act (Definitions))","12:1972":"12:1972 (12:1972 Typing Arrangement Act )","12:2001":"12:2001 (12:2001 Farm Credit Act of 1971)","12:2601":"12:2601 (12:2601 Real Estate Settlement Procedures Act (RESPA) (findings & purpose))","12:2604(c)":"12:2604(c) (12:2604(c) Real Estate Settlement Procedures Act (\"RESPA\"))","12:2605":"12:2605 (12:2605 RESPA: Servicing of Mortgage Loans)","12:2607":"12:2607 (12:2607 RESPA: Violation re kickbacks/unearned fees; Real Estate)","12:2609":"12:2609 (12:2609 RESPA: Escrow)","12:3012":"12:3012 (12:3012 National Consumer Cooperative Bank: Suits by or against Bank)","12:3410":"12:3410 (12:3410 Right to Financial Privacy: Customer Challenges)","12:3751":"12:3751 (12:3751 Single Family Mortgage Forclosure Act: Findings and Purpose)","12:3801":"12:3801 (12:3801 Alternative Mortgage Transaction Parity Act)","12:3907":"12:3907 (12:3907 International Lending Supervision: Capital Adequacy)","12:4010":"12:4010 (12:4010 Expedited Funds Availability: Violation of Act (Civil Liability))","12:5101":"12:5101 (12:5101 Fraudulent Transfer Act (Enforcement for Mortgage Licensing))","15:0001":"15:0001 (15:1 Antitrust Litigation (Monopolizing Trade))","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2fl Antitrust Litigation)","15:0004":"15:0004 (15:4 USDC Jurisdiction re violations of Sec. 1-7 of Title 15)","15:0005":"15:0005 (15:5 Bringing in Additional Parties)","15:0009":"15:0009 (15:9 USDC Jurisdiction re violations of Sec. 8 of Title 15)","15:0013":"15:0013 (15:13 Robinson Patman Act)","15:0014":"15:0014 (15:14 Clayton Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0026":"15:0026 (15:26 Suit for injunctive relief re violation antitrust laws)","15:0041":"15:0041 (15:41 Federal Trade Commission Act)","15:0044":"15:0044 (DO NOT USE 15:44 Trademark Infringement)","15:0045":"15:0045 (15:45 Federal Trade Commission Act (unfair or deceptive acts))","15:0045cp":"15:0045cp (15:45cp Violation of Children Online Privacy Protection Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0053(b)":"15:0053(b) (15:53(b) Prelim & Perm Inj Relief & other Equitable Relief)","15:0068":"15:0068 (15:68 Proceedings re FTC violations re wool products)","15:0069":"15:0069 (15:69 Proceedings re FTC violations re fur products)","15:0070":"15:0070 (15:70 Proceedings re FTC violations re textile fiber product)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0079":"15:0079 (15:79 Public Utility Holding Companies)","15:0080a-3":"15:0080a-3 (15:80a-3 Investment Company Act of 1940)","15:0260":"15:0260 (15:260 Proceedings re weights and measures and standard time)","15:0298":"15:0298 (15:298 Violation of Law Proceedings re gold or silver)","15:0433":"15:0433 (15:433 Discrimination against farmers)","15:0631":"15:0631 (15:631 Small Business Act)","15:0636":"15:0636 (15:636 Small Business Act - Aid to small business)","15:0661":"15:0661 (15:661 Small Business Investment Act of 1958)","15:0687":"15:0687 (15:687 Small Business Investment Program)","15:0714(b)":"15:0714(b) (15:714(b) Commodity Credit Corporation)","15:0715(f)":"15:0715(f) (15:715(f) Proceedings re petroleum and petroleum products)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (DO NOT USE 15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:0766":"15:0766 (15:766 Controversies arising re Federal Energy Admin. rules)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1071":"15:1071 (15:1071 Appeal of Decision of U.S. Patent & Trademark Office (Comm / Trademark Trial Bd))","15:1114":"15:1114 (15:1114 Trademark Infringement (Lanham Act))","15:1116":"15:1116 (15:1116 Inj to prevent violation rights of trademark owner)","15:1120":"15:1120 (15:1120 Trademark - False or Fraudulent Registration)","15:1121":"15:1121 (15:1121 Trademark Infringement (jurisdiction))","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1125(a)":"15:1125(a) (15:1125(a) False representation of goods sold in interstate commerce)","15:1125la":"15:1125la (15:1125la Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Trademarks - International conventions)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1191":"15:1191 (15:1191 Flamable Fabrics Act)","15:1221":"15:1221 (15:1221 Auto Dealer Suits Agst Manufacturers)","15:1261":"15:1261 (15:1261 Hazardous Substances (definitions))","15:1263":"15:1263 (15:1263 Prohibited Hazardous Substance - Interstate Commerce)","15:1267(a)":"15:1267(a) (15:1267(a) Federal Hazardous Substances Act)","15:1314":"15:1314 (15:1314 Antitrust--Petition for enforcement)","15:1501":"15:1501 (15:1501 Estab of Dept of Commerce)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1605":"15:1605 (15:1605 Determination of Finance Charge)","15:1638":"15:1638 (15:1638 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1666":"15:1666 (15:1666 Fair Credit Billing Act Dispute)","15:1667":"15:1667 (15:1667 Consumer Leasing Act)","15:1679":"15:1679 (15:1679 Violation of Credit Repair Organizations Act)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1691":"15:1691 (15:1691 Equal Credit Opportunity Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693ef":"15:1693ef (15:1693ef Electronic Funds Transfer Act)","15:1693m":"15:1693m (15:1693m Violation of Prov. of Subchpt.VI (Electronic Fund Transfers))","15:1701":"15:1701 (15:1701 Interstate Land Sales Full Disclosure Act (ILFFDA))","15:1709":"15:1709 (15:1709 Interstate Land Sales)","15:1714":"15:1714 (15:1714 Actions to enjoin violations re interstate land sale)","15:1938":"15:1938 (DO NOT USE 15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (DO NOT USE 15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (DO NOT USE 15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (DO NOT USE 15:1989 Fraud-Motor Vehicle (Odometer))","15:2071":"15:2071 (15:2071 Consumer Product Safety; Condemnation hazardous prod)","15:2073":"15:2073 (15:2073 Private action to enforce Consumer Product Safety)","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2310(c)":"15:2310(c) (15:2310(c) Consumer Product Warranties)","15:2601":"15:2601 (15:2601 Toxic Substances Control Act (TCSA))","15:2604":"15:2604 (15:2604 Application for inj re distribution toxic substance)","15:2616":"15:2616 (15:2616 Toxic Substance control; seizure of chemical)","15:2620":"15:2620 (15:2620 Toxic Substances Control Act: citizen's petition)","15:2651":"15:2651 (15:2651 Asbestos Hazard Emergency Response Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:2805":"15:2805 (15:2805 Petroleum Marketing Practices-Franchise Protection)","15:3414":"15:3414 (15:3414 National Gas Policy Act)","15:3710a":"15:3710a (15:3710a Federal Technology Transfer Act of 1986)","15:3901":"15:3901 (15:3901 Federal Risk Retention Act)","15:6801":"15:6801 (15:6801 Gram-Leach-Bliley Act)","15:7701":"15:7701 (15:7701 Federal CAN-Spam Act)","16:0470":"16:0470 (16:470 Archaeological resources Protection Act)","16:0668":"16:0668 (16:668 Bald and Golden Eagle Protection Act)","16:0669":"16:0669 (16:669 Pittman-Robertson Conservation Restoration Act)","16:0675":"16:0675 (16:675 Norbeck Wildlife Preserve Organic Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:0825":"16:0825 (16:825 Federal Power Commission Regulation; Public Utilities)","16:0831":"16:0831 (16:831 Actions re: rights of Tennessee Valley Authority)","16:1244":"16:1244 (16:1244 National Scenic and National Historic Trails)","16:1374":"16:1374 (12:1374(d)(6) Petition for Review re Application for Import of Polar Bear Trophies)","16:1531":"16:1531 (16:1531 Endangered Species Act)","16:1533":"16:1533 (16:1533 Endangered Species Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:1540":"16:1540 (16:1540 Endangered Species Act - Penalties and Enforcement)","16:1600":"16:1600 (16:1600 National Forest Management Act of 1976)","16:1801":"16:1801 (16:1801 Magnuson-Stevens Fishery Conservation and Management Act)","16:1858":"16:1858 (16:1858 National Fishery Management Program - Civil Penalties and Permit Sanctions)","16:19jj":"16:19jj (16:19jj Park System Resource Protection Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act (Definitions))","16:3372":"16:3372 (16:3372 Lacey Act: Prohibited Acts)","16:3373":"16:3373 (16:3373 Lacey Act: Penalties and Sanctions - Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Lacey Act: Complaint for Forfeiture)","16:470f":"16:470f (16:470f National Historic Preservation Act)","16:823a":"16:823a (16:823a Federal Public Utility Regulatory Policies Act)","17:0101":"17:0101 (17:101 Copyright Infringement (definitions))","17:0201":"17:0201 (17:201 Ownership of Copyright)","17:0205":"17:0205 (17:205(d) Priority Between Conflicting Transfers)","17:0407":"17:0407 (17:407 Recovery of fines & penalties by Register of Copyrights)","17:0411":"17:0411 (17:411 Action by copyright owner for infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0502":"17:0502 (17:502(a) Inj to prevent or restrain infringement copyright)","17:0504":"17:0504 (17:504 Copyright Infringement)","17:0512":"17:0512 (17:512 Copyright Infringement of Digital Communications)","17:1201":"17:1201 (17:1201 Digital Millennium Copyright Act)","18:0241":"18:0241 (DO NOT USE 18:241 Conspiracy Against Citizen Rights)","18:0492":"18:0492 (18:492 Forfeiture of Counterfeit Paraphernalia)","18:0603":"18:0603 (18:603 Conflict of Interest)","18:0922":"18:0922 (18:922 Firearms - Unlawful Possession (Civil Fines))","18:0923":"18:0923 (18:923(f)(3) Review of Revocation of a License as a Dealer in Firearms)","18:0925":"18:0925 (18:925(c) Restoration of ability to possess firearms/ammo)","18:0981":"18:0981 (18:981 Civil Forfeiture)","18:0981(a)":"18:0981(a) (12:981(a)(1)(A) Civil Forfeiture: Money Laundering Control Act)","18:1030":"18:1030 (18:1030 Fraud & Related Activity in Connection with Computers)","18:1345":"18:1345 (18:1345 Injunction against Fraud)","18:1514":"18:1514 (18:1514 Civil Action to Restrain Harassment of a Victim)","18:1514A":"18:1514A (18:1514A Civil Action to Protect Against Retaliation in Fraud Cases)","18:1836a":"18:1836a (18:1836(a) - Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) - Civil Action to Protect Trade Secrets)","18:1905":"18:1905 (18:1905 Disclosure of Confidential Information)","18:1956":"18:1956 (18:1956(b)(3) Laundering of Monetary Instruments - Forfeit Property)","18:1961":"18:1961 (DO NOT USE 18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (DO NOT USE 18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:1968":"18:1968 (18:1968 Action re civil investigative demand)","18:2254":"18:2254 (18:2254 Civil Forfeiture - Exploitation of Children)","18:2333":"18:2333 (18:2333 Civil Remedies: Anti-Terrorism Act of 1991)","18:2511":"18:2511 (18:2511 Wiretapping - Injunctive Relief or Civil Fine)","18:2520":"18:2520 (18:2520 Civil Damages for Interception Wire or Oral Communications)","18:2707":"18:2707 (18:2707 Civil Action: Stored Communications)","18:2710":"18:2710 (18:2710(c) Wrongful Disclosure of Video Tape Rental or Sales Records)","18:2724":"18:2724 (18:2724 Civil Action - Motor Vehicle Records)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property )","18:3184":"18:3184 (18;3184 Extradition Procedure)","18:3663":"18:3663 (18:3663 Civil Enforcement of Crim. Rest. Obligation)","18:4100":"18:4100 (18:4100 Transfer of Offenders)","18:4208":"18:4208 (DO NOT USE 18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Customs Duties: Forfeiture-Immoral Articles)","19:1497":"19:1497 (19:1497 Customs Duties: Penalty for Failure to Declare)","19:1595":"19:1595 (19:1595 Customs Duties: Forfeiture and Other Penalties)","19:1607":"19:1607 (19:1607 Customs Duties: Notice of Seizure)","19:1955":"19:1955 (19:1955 Civil Forfeiture-Prohibition of Illegal Gambling)","20-0107":"20-0107 (20-107 Randolph-Sheppard Vending Stand Act)","20-1087":"20-1087 (20:1087 Student Loan Discharge)","20:1070":"20:1070 (20:1070 Student Assistance)","20:1080":"20:1080 (20:1080 Default of Student Loan: Recovery)","20:1095":"20:1095 (20:1095a Education - Wage Garnishment Requirement)","20:1097":"20:1097 (20:1097 Education - Criminal penalties for fraud)","20:1098":"20:1098 (20:1098g Higher Education Act - Exemption from state disclosure)","20:1232":"20:1232 (20:1232g Family Education Rights & Privacy Act of 1974)","20:1400":"20:1400 (20:1400 IDEA: Individuals With Disabilities Education Act (short title))","20:1401":"20:1401 (20:1401 IDEA: Education of Individuals with Disabilities (definitions))","20:1415":"20:1415 (20:1415 IDEA: Challenge decision re education for handicapped)","20:1415(e)":"20:1415(e) (20:1415(e)(2)de IDEA: Mediation)","20:1681":"20:1681 (20:1681 Title IX Educational Amendments 1992 - Sex Discrimination)","20:1683":"20:1683 (20:1683 Judicial Review: Prohibition against sex discrimination in education)","20:1706":"20:1706 (20:1706 Relief from denial of equal educational opportunity)","20:1717":"20:1717 (20:1717 Relief from denial of equal educational opportunity)","21:0301":"21:0301 (21:301 Federal Food, Drug & Cosmetic Act)","21:0331":"21:0331 (21:331 Federal Food, Drug & Cosmetic Act - Prohibited Acts)","21:0332":"21:0332 (21:332 Federal Food, Drug and Cosmetic Act, Injunctive Relief)","21:0332(a)":"21:0332(a) (21:332(a) Federal Food, Drug, and Cosmetic Act)","21:0334(a)":"21:0334(a) (21:334(a) Forfeiture or condemnation-food, drug, cosmetics)","21:0348":"21:0348 (21:348 Federal Food, Drug and Cosmetic Act - Food Additives)","21:0360":"21:0360 (21:360 Federal Food, Drug & Cosmetic Act - Drugs and Devices)","21:0467":"21:0467 (21:467 Seizure and condemnation of poultry products)","21:0601":"21:0601 (21:601 Federal Meat Inspection Act 21 USC 601-695 (Definitions))","21:0673":"21:0673 (21:673 Seizure and condemnation of meat or meat products)","21:0674":"21:0674 (21:674 Proceeding to enforce & enjoin re meat products)","21:0821":"21:0821 (21:821 Violation of Record Keeping Provision of Controlled Substance Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0842":"21:0842 (21:842 Civil Penalty for violation re controlled substance)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","21:0882":"21:0882 (21:882 Inj to enjoin violations re controlled substance)","21:1049":"21:1049 (21:1049 Seizure and condemnation re eggs or egg products)","22:0286":"22:0286 (22:286 Action against World Bank or IMF)","22:2702":"22:2702 (22:2702 Medical Malpractice by Govt. Medical Personnel)","22:3612":"22:3612 (22:3612 Claim for Damage to Panama Canal)","22:3776":"22:3776 (22:3776 Panama Canal Commission Action on claims)","22:3777":"22:3777 (22:3777 Investigation of accident or injury giving rise to a claim)","22:4140":"22:4140 (22:4140 Foreign Service Grievance Act - Judicial Review)","23:0112":"23:0112 (23:112 Federal Highway Act - Letting of Contracts)","23:0134":"23:0134 (23:134 Metropolitan Transportation Planning)","23:1441":"23:1441 (DO NOT USE 23:1441 Contract Real Estate)","24:1000":"24:1000 (DO NOT USE 24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","25:2701":"25:2701 (25:2701 Indian Gaming Regulatory Act (IGRA))","25:4101":"25:4101 (25:4101 Native American Housing Assistance and Self-Determination Act (NAHASDA))","26:0063":"26:0063 (26:63 IRS: Taxable income (Definition))","26:0982":"26:0982 (26:982 IRS: To Quash IRS Formal Document Request)","26:2032":"26:2032 (26:2032 IRS: Alternate valuation)","26:6212":"26:6212 (26:6212 IRS: Notice of Deficiency (Injunctive Relief from IRS Lien))","26:6213":"26:6213 (26:6213 IRS: Injunctive Relief from IRS Lien in Tax Court)","26:6221":"26:6221 (26:6221 IRS: TEFRA Tax, Equity and Fiscal Responsibility Act of 1982)","26:6226":"26:6226 (26:6226 IRS: Judicial Review of Partnership Adjustment)","26:6320":"26:6320 (26:6320 IRS: Notice and Opportunity for Hearing upon Filing Notice of Lien)","26:6330":"26:6330 (26:6330 IRS: Notice and Opportunity for Hearing before Levy)","26:6331":"26:6331 (26:6331 IRS: Wrongful Levy)","26:6334":"26:6334 (26:6334 IRS: Property Exempt from Levy)","26:6502":"26:6502 (26:6502 IRS: Collection after Assessment (Enforcement of tax liens))","26:6532":"26:6532 (26:6532 IRS: Periods of Limitation on Suits)","26:6653sp":"26:6653sp (26:6653sp IRS: Failure to Pay Stamp Tax)","26:6672":"26:6672 (26:6672 IRS: Failure to Collect and Pay Over Tax, or Attempt to Evade or Defeat Tax)","26:6694":"26:6694 (26:6694 IRS: Underestimate Of Tax Liability By Tax Preparer)","26:6702":"26:6702 (26:6702 IRS: Penalty for Frivolous Tax Submission)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7323":"26:7323 (26:7323 IRS: Proceedings in rem enforce forfeitures property)","26:7401":"26:7401 (26:7401 IRS: Tax Liability - Authorization to collect via civil action)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 IRS: Action to Enforce Federal Tax Lien)","26:7404":"26:7404 (26:7404 IRS: Action for collection of estate tax)","26:7405":"26:7405 (26:7405 IRS: Action for recovery of refunds erroneously made)","26:7407":"26:7407 (26:7407 IRS: Action to enjoin income tax preparers)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7425(a)":"26:7425(a) (26:7425(a) IRS: Judiciary & Judicial Procedures - Discharge of Liens)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7428":"26:7428 (26:7428 IRS: Declaratory Judgment)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7430":"26:7430 (26:7430 IRS: Awarding of Costs and Certain Fees in Tax Suit)","26:7431":"26:7431 (26:7431 IRS: Unauthorized Disclosure of Return & Return Info)","26:7434":"26:7434 (26:7434 IRS: Civil Damages for Fraudulent Filing of Information)","26:7604":"26:7604 (26:7604 IRS: Enforce summons; examination books & witnesses)","26:7604(a)":"26:7604(a) (26:7604(a) IRS: Complaint to Enforce IRS Summons)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","26:7609en":"26:7609en (26:7609en IRS: Petition to serve Third-Party Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28-1332rl":"28-1332rl (28:1332 Diversity-Rent Lease & Ejectment)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (DO NOT USE 28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (DO NOT USE 28:451 Employment Discrimination)","28:0463":"28:0463 (28:0463 Expenses of Judicial Litigation)","28:0534":"28:0534 (28:0534 Arrest Records)","28:0591":"28:0591 (28:0591 Independent Counsel)","28:0592":"28:0592 (28:0592 Independent Counsel - Application for Appointment)","28:0593":"28:0593 (28:0593 Independent Counsel - Court Responsibilities)","28:0594":"28:0594 (28:0594 Independent Counsel - Responsibilities)","28:0595":"28:0595 (28:0595 Independent Counsel - Congressional Oversight)","28:0596":"28:0596 (28:0596 Independent Counsel - Removal)","28:0597":"28:0597 (28:0597 Independent Counsel - Dept. of Justice Relationship)","28:0598":"28:0598 (28:0598 Independent Counsel - Chapter Termination)","28:0636":"28:0636 (28:0636 Jurisdiction and Power of Magistrate Judges)","28:0754":"28:0754 (28:0754 Receiver of Property in Different Districts)","28:0794":"28:0794 (DO NOT USE 28:794 Rehabilitation Act)","28:1001":"28:1001 (DO NOT USE 28:1001 E.R.I.S.A.)","28:1132":"28:1132 (DO NOT USE 28:1132 E.R.I.S.A.)","28:1291":"28:1291 (28:1291 Maritime)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question: Bivens-Prisoner)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cr":"28:1331cr (28:1331cr Fed. Question: Civil Rights (Race Discrimination))","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331dd":"28:1331dd (28:1331dd Fed. Question: Discovery Disputes (conversion case))","28:1331dj":"28:1331dj (28:1331dj Fed. Question: Declaratory Judgment)","28:1331dp":"28:1331dp (28:1331dp Fed. Question: Violation of Due Process)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ef":"28:1331ef (28:1331ef Fed. Question: Civil Rights Violation (Excess Force))","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment )","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fa":"28:1331fa (28:1331fa Fed. Question: Civil Rights Violation-False Arrest)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331fm":"28:1331fm (28:1331fm Fed. Question: Family and Medical Leave Act)","28:1331fr":"28:1331fr (28:1331fr Fed. Question: Fraud)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act )","28:1331ni":"28:1331ni (28:1331ni Fed. Question: Negotiable Instrument)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331pl":"28:1331pl (28:1331 Product Liability)","28:1331pr":"28:1331pr (28:1331 Federal Prisoner Civil Rights)","28:1331ra":"28:1331ra (28:1331 Racketeering (RICO) Act)","28:1331rc":"28:1331rc (28:1331 Reclamation Project Auth. Act of 1972)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331rs":"28:1331rs (28:1331 Federal Rail Safety Act)","28:1331sh":"28:1331sh (28:1331 Sexual Harrassment)","28:1331ss":"28:1331ss (28:1331 Constitutionality of State Statutes)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331sx":"28:1331sx (28:1331 Employment Discrimination (Sex))","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331va":"28:1331va (28:1331 Violation 5th & 8th Amendments)","28:1331vc":"28:1331vc (28:1331 Violation of Constitutional Rights)","28:1331w":"28:1331w (28:1331 Wrongful Termination of Employment)","28:1331wd":"28:1331wd (28:1331 Wrongful Death)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332":"28:1332 (28:1332 Diversity Action)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332ap":"28:1332ap (28:1332 Diversity-Airplane Product Liability)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332bw":"28:1332bw (28:1332 Diversity-Breach of Warranty)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332de":"28:1332de (28:1332 Diversity-Forcible Detainer)","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332dtp":"28:1332dtp (28:1332 Diversity-Deceptive Trade Practices)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332ej":"28:1332ej (28:1332 Diversity-Enforcement of Judgement)","28:1332fc":"28:1332fc (28:1332 Diversity-Foreclosure)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332if":"28:1332if (28:1332 Diversity-Insurance Fraud)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332lp":"28:1332lp (28:1332 Diversity-Property Damage/Product Liability)","28:1332lr":"28:1332lr (28:1332 Diversity-Labor)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332md":"28:1332md (28:1332 Diversity-Motor Vehicle/Wrongful Death)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal )","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332op":"28:1332op (28:1332 Diversity-Recovery of Overpayment)","28:1332pa":"28:1332pa (28:1332 Personal Injury/Airplane)","28:1332pd":"28:1332pd (28:1332 Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332rd":"28:1332rd (28:1332 Diversity-Recovery of Debt)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332rp":"28:1332rp (28:1332 Diversity-Real Property)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332sh":"28:1332sh (28:1332 Diversity-Sexual Harassment)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332t":"28:1332t (28:1332 Diversity-Torts)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332ts":"28:1332ts (28:1332 Diversity-Misappropriation of Trade Secrets)","28:1332vt":"28:1332vt (28:1332 Diversity-Natl Motor Vehicle Title Information System)","28:1332wc":"28:1332wc (28:1332 Diversity-Worker's Compensation Benefits)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1333ad":"28:1333ad (28:1333 Admiralty)","28:1333in":"28:1333in (28:1333 Personal Injury)","28:1333mc":"28:1333mc (28:1333 Marine Contract)","28:1333pd":"28:1333pd (28:1333 Property Damage)","28:1333pi":"28:1333pi (28:1333 Marine Personal Injury)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334(b)":"28:1334(b) (28:1334 Bankruptcy Appeal)","28:1334(c)":"28:1334(c) (28:1334 R&R re motions for absention)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1337sc":"28:1337sc (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1339":"28:1339 (28:1339 Postal matters)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1340tp":"28:1340tp (28:1340 Jurisdiction of Internal Revenue Matters; Customs Duties)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1344":"28:1344 (28:1344 Elections disputes)","28:1345":"28:1345 (28:1345 USA Plaintiff )","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345lc":"28:1345lc (28:1345 Land Condemnation)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345ro":"28:1345ro (28:1345 Recovery of Retirement Overpayment)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345tx":"28:1345tx (28:1345 Prohibit dfts assessing tx on purch/use of pers prop)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346":"28:1346 (28:1346 U.S. Defendant)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346pi":"28:1346pi (28:1346 Marine Personal Injury (or tort claim - personal injury / motor vehicle))","28:1346rc":"28:1346rc (28:1346 Rcovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1348":"28:1348 (28:1348 Banking association as party)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party )","28:1350":"28:1350 (28:1350 Alien Tort Claims Act)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1356":"28:1356 (28:1356 Executory Process/Foreclosure)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1361pr":"28:1361pr (28:1361 Complaint for mandamus relief (prisoner))","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1363":"28:1363 (28:1363 Action for protection of jurors employment rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1367":"28:1367 (28:1367 Other Property Damage)","28:1391":"28:1391 (DO NOT USE 28:1391 Personal Injury)","28:1394":"28:1394 (28:1394 Banking Assoc action agst Comptroller of Currency)","28:1395":"28:1395 (28:1395 Complaint of Forfeiture)","28:1402":"28:1402 (28:1402 US as Defendant)","28:1403":"28:1403 (28:1403 Condemnation of real estate for the use of the US)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1407im":"28:1407im (28:1407 MDL: Silicone Gel Breast Implant Products Liability)","28:1407md":"28:1407md (28:1407 MDL: Multidistrict Litigation)","28:1407n":"28:1407n (28:1407 MDL: Perosnal/Injury/Norplant Product Liability)","28:1407pl":"28:1407pl (28:1407 MDL: Products Liability)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441ada":"28:1441ada (28:1441 Removal-Americans with Disabilities Act)","28:1441ag":"28:1441ag (28:1441 Removal - Civil Rights (Age))","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441ba":"28:1441ba (28:1441 Removal - National Bank Act)","28:1441bc":"28:1441bc (28:1441 Removal - Breach of Contract)","28:1441bfd":"28:1441bfd (28:1441 Removal - Breach of Fiduciary Duties)","28:1441ca":"28:1441ca (28:1441 Removal - Carmack Amendment)","28:1441cc":"28:1441cc (28:1441 Removal - Computer Crimes Act)","28:1441cj":"28:1441cj (28:1441 Removal - Confessed Judgement)","28:1441cla":"28:1441cla (28:1441 Removal - Consumer Leasing Act)","28:1441cp":"28:1441cp (28:1441 Removal - Copyright)","28:1441cpl":"28:1441cpl (28:1441 Removal - Contract Product Liability)","28:1441cra":"28:1441cra (28:1441 Removal - Fair Credit Reporting Act)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441dea":"28:1441dea (28:1441 Removal - Disabilities Education Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441di":"28:1441di (28:1441 Removal - Civil Rights (Disability Act))","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ea":"28:1441ea (28:1441 Removal - Employment Discrimination (Age))","28:1441eb":"28:1441eb (28:1441 Removal - E.R.I.S.A. Employee Benefits)","28:1441ec":"28:1441ec (28:1441 Removal - Electronic Comm. Privacy Act)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441em":"28:1441em (28:1441 Removal - Emergency Medical Treatment & Active Labor)","28:1441er":"28:1441er (28:1441 Removal - Employment Discrimination (Race))","28:1441es":"28:1441es (28:1441 Removal - Employment Discrimination (Sex))","28:1441fa":"28:1441fa (28:1441 Removal - Civil Rights (False Arrest))","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fd":"28:1441fd (28:1441 Removal - Fair Debt Collection Practices Act)","28:1441fe":"28:1441fe (28:1441 Removal - Fed. Employee Garnishment Statute)","28:1441fh":"28:1441fh (28:1441 Removal - FEHBA)","28:1441fif":"28:1441fif (28:1441 Removal - Insecticide/Fungicide/Rodenticide Act -1942)","28:1441fl":"28:1441fl (28:1441 Removal - Fair Labor Standards Act)","28:1441fm":"28:1441fm (28:1441 Removal - Family and Medical Leave Act)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441fs":"28:1441fs (28:1441 Removal - Foreigh Sovereign Immunities Act)","28:1441fsa":"28:1441fsa (28:1441 Removal - Federal Food Stamp Act)","28:1441hb":"28:1441hb (28:1441 Removal - Petition of Habeas Corpus)","28:1441hc":"28:1441hc (28:1441 Removal - Handicapped Child Protection Act)","28:1441hd":"28:1441hd (28:1441 Removal - Housing Discrimination)","28:1441ia":"28:1441ia (28:1441 Removal - Interstate Commerse Act)","28:1441if":"28:1441if (28:1441 Removal - Insurance Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441il":"28:1441il (28:1441 Removal - Interstate Land Full Discloser Act)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441la":"28:1441la (28:1441la Removal - Truth in Lending Act)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441ml":"28:1441ml (28:1441 Removal - Motor Vehicle Prod Liability)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441mv":"28:1441mv (28:1441 Removal - Motor Vehicle)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pa":"28:1441pa (28:1441 Removal - Patent Infringement)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ra":"28:1441ra (28:1441 Removal - Civil Rights (Race))","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441rl":"28:1441rl (28:1441 Removal - Rent, Lease & Ejectment)","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441sh":"28:1441sh (28:1441 Removal - Sexual Harassment)","28:1441st":"28:1441st (28:1441 Removal - Stockholders Suit)","28:1441sv":"28:1441sv (28:1441 Removal - Security Violation)","28:1441sx":"28:1441sx (28:1441 Removal - Civil Rights (Sex))","28:1441tc":"28:1441tc (28:1441 Removal - Tricare Program)","28:1441ti":"28:1441ti (28:1441 Removal - Trademark Infridgement)","28:1441til":"28:1441til (28:1441 Removal - Truth and Lending)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441us":"28:1441us (28:1441 Removal - Uniformed Svc Emp/Reemp Rights Act)","28:1441wc":"28:1441wc (28:1441 Removal - Worker's Compensation Benefits)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1441wt":"28:1441wt (28:1441 Removal - Employment (Wrongful Termination))","28:1442":"28:1442 (28:1442 Notice of Removal - Suit against Federal Officer)","28:1442aaf":"28:1442aaf (28:1442 Petition for Removal - Agst members of armed forces)","28:1442bc":"28:1442bc (DO NOT USE 28:1442 Petition for Removal- Breach of Contract)","28:1442nr":"28:1442nr (DO NOT USE 28:1442 Notice of Removal)","28:1442pr":"28:1442pr (DO NOT USE 28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443 Removal from State Court - Civil Rights: Rent, Lease, and Ejectment)","28:1444":"28:1444 (28:1444 Notice of Removal- Foreclosure)","28:1446":"28:1446 (28:1446 Notice of Removal - Airline Crash)","28:1446al":"28:1446al (28:1446 Notice of Removal - Airline Crash)","28:1446as":"28:1446as (28:1446 Notice of Removal - Asbestos Litigation)","28:1446bc":"28:1446bc (28:1446 Notice of Removal - Breach of Contract)","28:1446cs":"28:1446cs (28:1446 Notice of Removal - Child Support Enforcement)","28:1446dj":"28:1446dj (28:1441 Notice of Removal - Declaratory Judgement)","28:1446er":"28:1446er (28:1446 Notice of Removal - E.R.I.S.A)","28:1446fm":"28:1446fm (28:1446 Notice of Removal - Family Medical Leave Act)","28:1446fr":"28:1446fr (28:1446 Notice of Removal - Fraud)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446lb":"28:1446lb (28:1446 Notice of Removal - Libel, Assault, Slander)","28:1446ml":"28:1446ml (28:1446 Notice of Removal - Motor Vehicle Prod Liability)","28:1446mm":"28:1446mm (28:1446 Notice of Removal - Medical Malpractice)","28:1446mv":"28:1446mv (28:1446 Notice of Removal - Motor Vehicle)","28:1446ni":"28:1446ni (28:1446 Notice of Removal - Negotiable Instrument)","28:1446nr":"28:1446nr (28:1446 Notice of Removal )","28:1446oc":"28:1446oc (28:1446 Notice of Removal - Other Contract)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1446st":"28:1446st (28:1446 Notice of Removal - Stockholders Suit)","28:1446tl":"28:1446tl (28:1446 Notice of Removal - Torts to Land)","28:1446wd":"28:1446wd (28:1446 Notice of Removal - Wrongful Death)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1453":"28:1453 (28:1453 Class Action Fairness Act)","28:1491":"28:1491 (28:1491 Tucker Act)","28:1602":"28:1602 (28:1602 Foreign Sovereign Immunities Act)","28:1605":"28:1605 (28:1605 Foreign Socereign Immunities Act of 1976)","28:1605A":"28:1605A (28:1605 Antiterrorism & Effective Death Penalty Act of 1996)","28:1610":"28:1610 (28:1610 Juridictional Immunities of Foreign States)","28:1631":"28:1631 (28:1631 Case Transferred to Cure Want of Jurisdiction)","28:1651":"28:1651 (DO NOT USE 28:1651 Petition for Writ of Coram Nobis)","28:1651cn":"28:1651cn (28:1651 Petition for Writ of Error Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1651ne":"28:1651ne (28:1651 Application for Writ Ne Exeat)","28:1651w":"28:1651w (28:1651 All Writs Act)","28:1715":"28:1715 (28:1715 Class Action Fairness Act of 2005)","28:1732":"28:1732 (28:1732 Reproduction of Records)","28:1738Acs":"28:1738Acs (28:1738 The Uniform Child Custody Jurisdiction Act)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment )","28:1783":"28:1783 (28:1783 Petition for Subpoena of person in foreign country)","28:1826":"28:1826 (28:1826 Order of confinement of recalcitrant witness)","28:1875":"28:1875 (28:1875 Juror Protection Act / Protection of Jurors' Employment)","28:1916":"28:1916 (28:1916 Marine Personal Injury)","28:1963":"28:1963 (28:1963 Registration of judgement from another district)","28:1983":"28:1983 (DO NOT USE 28:1983 Civil Rights)","28:2001":"28:2001 (28:2001 Judicial Sale of Realty)","28:2071":"28:2071 (28:2071 Rule Making Power Generally)","28:2201":"28:2201 (28:2201 Creation of a Remedy - Declaration of Rights)","28:2201an":"28:2201an (28:2201 Declaration Judgement (aliens and nationality))","28:2201cp":"28:2201cp (28:2201 Declaratory Judgement (Copyright))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201fa":"28:2201fa (28:2201 Declaratory Judgement - Firearms)","28:2201fs":"28:2201fs (28:2201 Declaratory Judgement (Food Security Act))","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2201pi":"28:2201pi (28:2201 Declaratory Judgement - Personal Injury)","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2241fd":"28:2241fd (28:2241 Petition for Writ of Habeas Corpus (federal))","28:2241in":"28:2241in (28:2241 Habeas Corpus: INS)","28:2241st":"28:2241st (28:2241 Petition for Writ of Habeas Corpus (State))","28:2244":"28:2244 (28:2244 Habeas Corpus - Finality of Determination)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254dp":"28:2254dp (28:2254 Petition for Writ of Habeas Corpus (Death Penalty))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (DO NOT USE 28:2271 Federal Tort Claims Act)","28:2283":"28:2283 (28:2283 Stay of State Court Proceedings (Injunctive Relief))","28:2345":"28:2345 (DO NOT USE 28:2345 Medicare Recovery)","28:2347":"28:2347 (28:2347 Petition to Review Orders in the Ct of Appeals)","28:2401":"28:2401 (28:2401 Federal Tort Claims Act (Time for commencing action against the US))","28:2403":"28:2403 (28:2403 Constitutionality of State Statutes)","28:2405":"28:2405 (28:2405 Garnishment of debtors of a corporation by US)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2409(a)":"28:2409(a) (28:2409 Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2412":"28:2412 (28:2412 Equal Access to Justice Act)","28:2415":"28:2415 (28:2415 Detinue and Conversion)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2672mv":"28:2672mv (28:2672 Federal Tort Claims Act - Motor Vehicle)","28:2672pi":"28:2672pi (28:2672 Federal Tort Claims Act - Personal Injury)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:2675":"28:2675 (28:2675 Federal Tort Claims Act - Disposition by Agency Req)","28:2679d2":"28:2679d2 (28:2679 Federal Tort Claims Act - Employee of the U.S.A.)","28:2680":"28:2680 (28:2680 Federal Tort Claims Act - Exceptions)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act )","28:3001(a)":"28:3001(a) (28:3001 Federal Debt Collection Procedures Act of 1990)","28:3203":"28:3203 (28:3203 Post Judgement Remedies: Writ of Execution)","28:3301":"28:3301 (28:3301 Fraudulent Transfer Federal Debt Collection Procedures Act)","28:592":"28:592 (28:592 Independent Counsel - Application for Appointment)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (DO NOT USE 29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (DO NOT USE 29:1131 ERISA - Collection of Delinquent Trust Fund)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (DO NOT USE 29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2601":"29:2601 (29:2601 Family and Medical Leave Act )","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Land subject to disposition; persons entitled to benefits; reciprocal privileges)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action (Congressional Findings))","30:1202":"30:1202 (30:1202 Mining Reclamation Act (Statement of Purpose))","30:1276":"30:1276 (30:1276 Interior: Judicial Review of Agency Action)","30:1701":"30:1701 (30:1701 Federal Oil Gas Royalty Mgt Act 1982 (FOGRMA))","30:22":"30:22 (30:22 General Mining Law of 1872 (Lands Open to Purchase by Citizens))","30:815":"30:815 (30:815 Federal Mine Safety & Health Act (Procedure for Enforcement))","31:1341":"31:1341 (31:1341 Government employee--limitations on expending monies)","31:3545":"31:3545 (31:3545 Civil Action to Recovery Money)","31:3702":"31:3702 (31:3702 Procedures for Settling Claims)","31:3713":"31:3713 (31:3713 Priority of Government Claims)","31:3720":"31:3720 (31:3720 Federal Income Tax Interceptions (Collection of Payments))","31:3728":"31:3728 (31:3728 Setoff against Judgment)","31:3729":"31:3729 (31:3729 False Claims Act - Liability)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 False Claims Act - Procedures)","31:3733j2":"31:3733j2 (31:3733j2 Pet to Mod or Set Aside CV Investigative Demand)","31:5314":"31:5314 (31:5314 Failure to Report Interest in Foreign Accounts)","31:5317":"31:5317 (31:5317 Search and Forfeiture of Monetary Instruments)","31:5320":"31:5320 (31:5320 Inj proceedings re Rpts of Currency & Foreign Trans.)","31:5321":"31:5321 (31:5321 Civil Penalties re Reports of Currency and Foreign Transaction)","31:5332(a)":"31:5332(a) (31:5332(a) Evading Currency Reporting Requirement)","31:5332(f)":"31:5332(f) (31:5332(f) Transport and Transfer US currency from in to out)","31:6716":"31:6716 (31:6716 Discrimination re money and finance)","31:732":"31:732 (31:732 General Acct. Office Personnel Act of 1980 (Personnel Management System))","31:9701":"31:9701 (31:9701 Federal User Charge Statute)","33:1221":"33:1221 (33:1221 Ports and Waterways Safety Program)","33:1251":"33:1251 (33:1251 Federal Water Pollution Control Act (Clean Water Act))","33:1319cw":"33:1319cw (33:1319cw Clean Water Act - Enforcement)","33:1319pv":"33:1319pv (33:1319(a)(2)pv Pollutants & Permit Violations)","33:1321":"33:1321 (33:1321 Clean Water Act - Discharge of hazardous substance or pollutants/water)","33:1361":"33:1361 (33:1361 Clean Water Act-Administrator Authority)","33:1364":"33:1364 (33:1364 Clean Water Act - EPA action to restrain pollution endangering health (emergency powers))","33:1365":"33:1365 (33:1365 Clean Water Act - Citizen Suits re Environmental Matters)","33:1415":"33:1415 (33:1415 Marine Protection, Research, and Sanctuaries Act)","33:1515":"33:1515 (33:1515 Deepwater Ports Act (citizen civil action))","33:2701":"33:2701 (33:2701 Oil Pollution Act of 1940)","33:408":"33:408 (33:408 Injury to Harbor Improvement)","33:594":"33:594 (33:594 Land Condemnation)","33:901":"33:901 (33:901 Longshoremen Harbor Workers Compensation Act (Navigation and Navigable Waters))","33:905(b)":"33:905(b) (33:905(b) Longshoremen Workers' Compensation Act-Recovery of Damages caused by negligence of a )","33:918":"33:918 (33:918 Longshore and Harbor Workers Compensation Act - Collection of Defaulted Payments)","33:921":"33:921 (33:921 Longshore & Harbor Workers Compensation Act - Review of Compensation Orders)","33:933":"33:933 (33:933 Longshore and Harbor Workers' Compensation Act-Compensation for Injuries (Third-Party Cl)","35:0145":"35:0145 (35:145 Civil Action to Obtain Patent)","35:0183":"35:0183 (35:183 Right to Compensation - Patent Laws)","35:0271":"35:0271 (35:271 Patent Infringement)","35:1":"35:1 (35:1 Establishment of PTO)","35:146":"35:146 (35:146 Appeal from Decision of the Board of Patent Appeals)","35:256":"35:256 (35:256 Patent Non-Infringement (Correction of Named Inventor))","35:281":"35:281 (35:281 Remedy for Infringement of Patent/jurisdiction conferred 28:1338)","35:282":"35:282 (35:282 Patent Infringement - Defenses)","35:283":"35:283 (35:283 Action to enjoin violation of right secured by patent)","35:289":"35:289 (35:289 Recover profits from unlicensed use of design patent)","35:291":"35:291 (35:291 Action for relief between owners; interfering patents)","35:292":"35:292 (35:292 Penalty & Forfeiture; illegal use of word patent (false marking))","35:311":"35:311 (35:311 Patent - Request for Inter Partes Reexamination)","35:32":"35:32 (35:32 Suspension from Practice before Patent & Trade. Off.)","38:1110":"38:1110 (38:1110 Basic Entitlements / Wartime)","38:1131":"38:1131 (38:1131 Basic Entitlements / Peacetime)","38:1681":"38:1681 (DO NOT USE 38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (DO NOT USE 38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (DO NOT USE 38:1780 Recovery of VA Overpayment)","38:1816":"38:1816 (38:1816 Deficiency balance on VA Mortgage Foreclosure (Regs Governing the VA Loan Guaranty Pgm))","38:1965":"38:1965 (38:1965 Servicemen's Group Life Insurance (Definitions))","38:1975":"38:1975 (38:1975 Recovery of Servicemen's Group Life Insurance - Jurisdiction of District Court)","38:1984":"38:1984 (38:1984 Suit for Veterans Insurance)","38:2011":"38:2011 (DO NOT USE 38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (DO NOT USE 38:2021 Right to re-employment of inducted persons)","38:3116":"38:3116 (DO NOT USE 38:3116 VA Overpayment)","38:3481":"38:3481 (38:3481 Recovery of VA Overpayment)","38:3680":"38:3680 (38:3680 Recovery of Education Assist Allowance Overpayment)","38:4212":"38:4212 (38:4212 Veterans Employment Emphasis Under Federal Contracts)","38:4301":"38:4301 (38:4301 Uniformed Srvs. Employment & Reemployment Rights Act (purpose))","38:4302":"38:4302 (38:4302 Veterans Reemployment Rights Act (relation to other laws and plans or agreements).)","38:4311":"38:4311 (38:4311 Uniformed Service Employment or Reemployment Rights Act (USERRA) - Discrimination)","38:4312":"38:4312 (38:4312 Rights of inducted persons to reemployment)","38:4323":"38:4323 (38:4323 USERRA - Enforcement of rights with respect to state or private employer)","38:4324":"38:4324 (38:4324 USERRA - Enforcement of rights with respect to federal executive agencies)","38:5315":"38:5315 (38:5315 Delinquent Payment of Amounts Due to US)","38:5316":"38:5316 (38:5316 VA Overpayment)","38:775":"38:775 (DO NOT USE 38:775 Recovery of Servicemen's Group Life Insurance)","39:1207":"39:1207 (39:1207 Review Agency Action--Labor Disputes)","39:1208(b)":"39:1208(b) (39:1208(b) Postal Reorganization Act of 1970 - Suits)","39:3005":"39:3005 (39:3005 False Representations and Lotteries)","39:3007":"39:3007 (39:3007 Detention of Mail for Temporary Periods - Injunction directing retention of incoming mail)","39:3008(e)":"39:3008(e) (39:3008(e) Enforce compliance with a USPS Prohibitory Order)","39:403":"39:403 (39:403 Discriminatory use of the Postal Service)","39:409":"39:409 (39:409 Suits by and against the Postal Service)","40:0258":"40:0258 (DO NOT USE 40:258(a) Public Buildings & Property: Land Condem)","40:0875":"40:0875 (DO NOT USE 40:875 Public Buildings & Property: Negligence)","40:1101":"40:1101 (40:1101 Brooks Architect - Engineers Act)","40:3131":"40:3131 (40:3131 Bonds of contractors of public buildings)","40:3142":"40:3142 (40:3142 Davis-Bacon Act (prevailing wages))","40:581":"40:581 (40:581 General Authority of Administrator of General Services)","41:0251":"41:0251 (DO NOT USE 41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (DO NOT USE 41:1463 Public Contracts: Unlawful Employment Prac)","41:2102-07":"41:2102-07 (41:2102-2107 Procurement Integrity Act)","41:3301":"41:3301 (41:3301 Competition in Contracting Act)","41:6503":"41:6503 (41:6503 Walsh-Healy Act - Breach of Public Contract)","41:6505":"41:6505 (41:6505 Exclusions - Review of legal questions in contracts; Walsh-Healy Act)","41:6702-04":"41:6702-04 (41:6702-6704 Service Contract Labor Standards / McNamara-O'Hara Service Contract Act 1965)","41:7105(f)":"41:7105(f) (41:7105(f) Action to Judicially Enforce Administrative Subpoena)","42:0205":"42:0205 (42:205 Appointment of Surgeon General)","42:0206":"42:0206 (42:206 Surgeon General - Assignment of Officers)","42:0247":"42:0247 (DO NOT USE 42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits (Transitional Insured Status))","42:10139":"42:10139 (42:10139 Judicial review of agency actions)","42:10801":"42:10801 (42:10801 Protection & Advocacy for Individuals with Mental Illness Act of 1986 (PAIMI))","42:10805":"42:10805 (42:10805 Protection and Advocacy Systems)","42:11001":"42:11001 (42:11001 Emergency Plan. & Comm. Right to Know Act (EPCRA))","42:11046":"42:11046 (42:11046 Fed Emer Plan Comm Right-to-know Act (EPCRA) - civil actions)","42:11101":"42:11101 (42:11101 Health Care Quality Improvement Act of 1986)","42:11112":"42:11112 (42:11112 Health Care Quality Improvement Act (Standards for Professional Review Actions))","42:11601":"42:11601 (42:11601 International Child Abduction Remedies Act)","42:11603b":"42:11603b (42:11603(b) Int'l. Child Abduction Remedies Act (ICARA) - Judicial Remedies)","42:12101":"42:12101 (42:12101 The Americans with Disabilities Act of 1990)","42:12102":"42:12102 (42:12102 Americans with Disabilities Act (ADA) Disability Definition)","42:12111":"42:12111 (42:12111 Americans with Disabilities Act - Employment)","42:12112":"42:12112 (42:12112 Americans with Disabilities Act - Employment Discrimination)","42:12117":"42:12117 (42:12117 Americans with Disabilities Act - Enforcement)","42:12132":"42:12132 (42:12132 Americans with Disabilities Act - Discrimination)","42:12188":"42:12188 (42:12188 Americans With Disabilities Act - Civil Enforcement Actions)","42:1320a":"42:1320a (42:1320a-7b(b)(2)(A) Anti-Kickback Act (for federal health care programs))","42:1320d-2":"42:1320d-2 (42:1320d-2 Health Insurance Portability And Accountability Act (HIPAA))","42:1381a":"42:1381a (42:1381a Supplemental Security Income benefits (SSID))","42:1382":"42:1382 (42:1382 Eligibility for benefits)","42:1383":"42:1383 (42:1383 Review of HHS Decision (regarding payment of benefits))","42:1395":"42:1395 (42:1395 Emergency Medical Treatment and Active Labor Act)","42:1395dd":"42:1395dd (42:1395dd Exam & Treatment Emergency Med Cond & Women in Labor)","42:1395hr":"42:1395hr (42:1395hr Hospital Reimbursement for Medicare Services)","42:1395w":"42:1395w (42:1395w-21 Medicare Act (Eligibility, Election, and Enrollment))","42:1396":"42:1396 (DO NOT USE 42:1396 - Tort Negligence)","42:1396a":"42:1396a (42:1396a State Plans for Medical Assistance)","42:1396b":"42:1396b (42:1396b Medical Assist Prgm, Pmt to States/Medicaid Implem)","42:13981":"42:13981 (42:13981 Violence Against Women Act (Civil Rights))","42:14135":"42:14135 (42:14135 DNA Backlog Grant Program)","42:1437":"42:1437 (42:1437 U.S. Housing Act of 1937)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1475":"42:1475 (42:1475 Declaratory & Injunctive Relief - Foreclosure Procedures)","42:1479":"42:1479 (42:1479 Mortgage, lease, contract re farm housing)","42:14901":"42:14901 (42:14901 Intercountry Adoptions)","42:15483":"42:15483 (42:15483 Help America Vote Act)","42:1651":"42:1651 (42:1651 Defense Base Act)","42:1705":"42:1705 (42:1705 Receipt of Workmen's compensation benefits)","42:1971":"42:1971 (42:1971 Voting Rights Law)","42:1973":"42:1973 (42:1973 Voting Rights Act)","42:1973(a)":"42:1973(a) (42:1973(a) Enforcement of Voting Rights)","42:1973(c)":"42:1973(c) (42:1973(c) Voting Rights -Qualifications & Procedures)","42:1973gg":"42:1973gg (42:1973gg-2 Nat'l. Voter Registration Act of 1993 (NVRA))","42:1981a":"42:1981a (42:1981a Damages in cases of intentional discrim. in employment)","42:1981cv":"42:1981cv (42:1981cv Civil Rights)","42:1981hs":"42:1981hs (42:1981hs Housing Discrimination)","42:1981jb":"42:1981jb (42:1981jb Job Discrimination (Race))","42:1981ra":"42:1981ra (42:1981ra Race Discrimination)","42:1981sx":"42:1981sx (42:1981sx Sex Discrimination)","42:1982hs":"42:1982hs (42:1982hs Discrimination re property rights (housing))","42:1982ra":"42:1982ra (42:1982ra Discrimination re property rights (race))","42:1982sx":"42:1982sx (42:1982sx Discrimination re property rights (sex))","42:1983bv":"42:1983bv (42:1983bv Bivens Non-Prisoner)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act - Civil Action for Deprivation of Rights)","42:1983cvp":"42:1983cvp (42:1983cvp Civil Rights (Personal Property))","42:1983d":"42:1983d (42:1983d Civil Rights (Death))","42:1983dp":"42:1983dp (42:1983dp Civil Right Denial of Due Process)","42:1983ed":"42:1983ed (42:1983ed Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983pr Prisoner Civil Rights)","42:1983vp":"42:1983vp (42:1983vp Violation of Due Process and Equal Protection)","42:1985":"42:1985 (42:1985 Conspiracy to interfere with civil rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:1987":"42:1987 (42:1987 Prosecution of violations of certain laws (viol of sec 1990 or 5506 to 5516 or 5518 to 5532))","42:1988":"42:1988 (42:1988 Proceedings in Vindication of Civil Rights)","42:1997":"42:1997 (42:1997 Institutionalized Persons Act of 1980)","42:2000a":"42:2000a (42:2000a-3pa Discrimination, segregation; public accommodation - Injunctive Relief)","42:2000ad":"42:2000ad (42:2000ad Job Discrimination (Disability Act))","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000bb":"42:2000bb (42:2000bb Religious Freedom Restoration Act of 1993)","42:2000bea":"42:2000bea (42:2000bea Equal access to public facilities)","42:2000c":"42:2000c (42:2000c-6ed Discrimination in Education)","42:2000cc":"42:2000cc (42:2000cc Religious Land Use & Institutionalized Persons Act of 2000)","42:2000d":"42:2000d (42:2000d Federally Assisted Programs)","42:2000e-2":"42:2000e-2 (42:2000e-2 Job Discrimination)","42:2000e-5":"42:2000e-5 (42:2000e-5eeo Petition to Enforce EEOC Subpoena)","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Regulations of Indian Hospitals)","42:2005":"42:2005 (42:2005 Financial assistance to Indian tribes)","42:2210":"42:2210 (42:2210 Indeminification & Limitation of Liability-Financial)","42:254o":"42:254o (42:254o Breach of Scholarship Contract)","42:256":"42:256 (42:256 Public Health Services Act - Grants)","42:2615":"42:2615 (DO NOT USE 42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery by US)","42:292f":"42:292f (42:292f Default of borrower)","42:292k":"42:292k (42:292k Student loan insurance (Public Health Occupations))","42:293":"42:293 (42:293 Recovery of losses from loan guarantee; public health)","42:297":"42:297 (42:297 Student loans; public or nonprofit school of nursing)","42:2996":"42:2996 (42:2996 Legal Services Corporation Act)","42:300aa-1":"42:300aa-1 (42:300aa-1 Nat'l. Childhood Vaccine Injury Compensation Act)","42:300f":"42:300f (42:300f Safe Drinking Water Act (Definitions))","42:300g":"42:300g (42:300g Actions re safety of public water systems (EPA))","42:300g-3":"42:300g-3 (42:300g-3 Enforcement of Drinking Water Regulations)","42:3058(g)":"42:3058(g) (42:3058(g) Older American's Act of 1965, 42 U.S.C. 3058(g) (State Long-term Care Ombudsman Prog)","42:3121":"42:3121 (42:3121 Public Works and Economic Development Act of 1965)","42:3133":"42:3133 (42:3133 Coordination - Grants for Public Works and Economic Development)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:3604(f)":"42:3604(f) (42:3604(f)(3)(c) Fair Housing Amendments Act)","42:3610":"42:3610 (42:3610 Fair Housing Act-Administrative Enforcement; Preliminary Matters)","42:3612":"42:3612 (42:3612 Civil rights in housing - Enforcement by Secretary)","42:3613":"42:3613 (42:3613 Action for inj relief re deprivation of civil rights)","42:4000":"42:4000 (DO NOT USE 42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4013":"42:4013 (42:4013 National Flood Insurance Act - Nature and Limitation of Insurance Coverage)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:405id":"42:405id (42:405id Review of HHS Decision (SSID))","42:405rs":"42:405rs (42:405rs Review of HHS Decision (RSI))","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:421(d)":"42:421(d) (42:421(d) Review HHS decision re disability determinations)","42:423":"42:423 (42:423 Social Security Act (Disability Insurance Benefit Payments))","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment (Declaration of Purpose))","42:4332":"42:4332 (42:4332 Environmental Policy - Cooperation of Agencies; Reports)","42:4721":"42:4721 (42:4721 Intergovernmental Personnel Act (findings and purposes))","42:4821":"42:4821 (42:4821 Lead-Based Paint Poisoning Prevention Act (findings and purposes))","42:4901":"42:4901 (42:4901 Noise Control Act of 1972 (findings and purposes))","42:4910(c)":"42:4910(c) (42:4910(c) Action to restrain violation re noise control)","42:5101":"42:5101 (42:5101 Child Abuse Prevention and Treatment Act)","42:5303":"42:5303 (42:5303 Block Grant Act of 1974 (42 USC 5301-5321))","42:5401":"42:5401 (42:5401 Natl Mnfactrd Housing Cnstr Safety Standard Act 1974 (findings and purposes))","42:5411":"42:5411 (42:5411 Housing Construction and Safety Standards Act - Injunctive Relief)","42:5851":"42:5851 (42:5851 Discrimination \"Whistle blower\" Employee - ERA (employee protection))","42:601":"42:601 (42:601 Title IV-A of Social Security Act (Grants to States for Aid/Assistance to Needy Families)","42:602":"42:602 (42:602 Temp. Assistance for Needy Families (TANF))","42:6101":"42:6101 (42:6101 Age Discrimination in Federally Assisted Programs (statement of purpose))","42:6201":"42:6201 (42:6201 Energy Policy & Conservation Act (statement of purpose))","42:6393":"42:6393 (42:6393 Controversies under Energy Policy & Conservation Act (Admin Procedure and Judicial Review))","42:660":"42:660 (42:660 Action to enforce child support obligations)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses (congressional findings))","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act (congressional findings))","42:6928":"42:6928 (42:6928 Violations of requirements of hazardous Waste Mgmt (federal enforcement))","42:6961":"42:6961 (42:6961 Federal Facilities Compliance Act)","42:6972":"42:6972 (42:6972 Resource & Recovery Act - Citizen Suit)","42:6972(a)":"42:6972(a) (42:6972(a) Solid Waste Disposal Act - Citizen Suit)","42:7192":"42:7192 (42:7192 Controversies under Dept of Energy Organization Act - Judicial Review)","42:7384":"42:7384 (42:7384 Energy Employees Occupational Illness Compensation Program Act (EEOICPA))","42:7401":"42:7401 (42:7401 Clean Air Act (findings & declarations))","42:7412":"42:7412 (42:7412 Air Pollution Control - emission standards)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7413(b)":"42:7413(b) (42:7413(b) Clean Air Act - Enforcement)","42:7475":"42:7475 (42:7475 Clean Air Act - Preconstruction Requirements)","42:7545":"42:7545 (42:7545 Air Pollution Prevention - Regulation of Fuels)","42:7603":"42:7603 (42:7603 Action for immediate restraint (Emergency Powers))","42:7604":"42:7604 (42:7604 Clean Air Act - Citizen suit to enforce Clean Air Act)","42:7604(f)":"42:7604(f) (42:7604(f)cl Clear Air Act - Emission Standards)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:7671":"42:7671 (42:7671 Clean Air Act (Stratospheric Ozone Protection) (Definitions))","42:8324":"42:8324 (42:8324 Powerplant and Industrial Fuel Use - terms and conditions)","42:8351":"42:8351 (42:8351 Powerplant and Industrial Fuel Use - Temporary Exemptions)","42:9601":"42:9601 (42:9601 Comprehensive Environmental Compen/Resp/Liab (CERCLA) (Definitions))","42:9604":"42:9604 (42:9604 Comprehensive Envir., Response, Comp. & Liab. Act (CERCLA)-Removal and Other Remedial Action)","42:9607":"42:9607 (42:9607 Real Property Tort to Land - Liability)","42:9613":"42:9613 (42:9613 Comp Environ Recovery Comp & Liability Act (CERCLA) - Civil Proceedings)","43:1331":"43:1331 (43:1331 Outer Continental Shelf Lands Act (Definitions))","43:1333":"43:1333 (43:1333 Outer Continental Shelf Lands Act - Laws and Regulations Governing Lands)","43:1349":"43:1349 (43:1349 Outer Continental Land Shelf Act - Citizen Suits)","43:1701":"43:1701 (43:1701 Violation of Federal Land Policy and Management Act (FLPMA))","43:1737":"43:1737 (43:1737 FLPMA - Implementation Provisions)","43:421":"43:421 (43:421 Complaint in Condemnation - Eminent Domain)","43:945":"43:945 (DO NOT USE 43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Compensation for Land Condemnation)","43:945b":"43:945b (43:945b Complaint in Condemnation - Easements)","43:946":"43:946 (43:946 Complaint in Condemnation - Right of Way for Irrigation and Drainage Projects)","44:2107":"44:2107 (44:2107 Presidential Recordings & Materials Act(NARA acceptance of recs for historical preservation))","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act (Definitions))","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1105":"45:1105 (45:1105 Northeast Rail Service Act - Judicial Review)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:152":"45:152 (45:152 Railway Labor Act - General Duties)","45:153":"45:153 (45:153 First Railway Labor Act - National Railroad Adjustment Board)","45:159":"45:159 (45:159 Review of arbitration award (RR Carriers/Mediation Bd))","45:231(f)":"45:231(f) (45:231(f) Compel obedience to order of Railroad Retirement Bd)","45:351":"45:351 (45:351 Railroad Unemployment Insurance Act)","45:56":"45:56 (45:56 Employers Liability Act - Personal Inj re Railroads (bringing an action))","45:719":"45:719 (45:719 Regional Rail Reorganization Act of 1973 (judicial review))","45:7457":"45:7457 (DO NOT USE 45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (DO NOT USE 46:741 Shipping)","46:0761":"46:0761 (DO NOT USE 46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (DO NOT USE 46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (DO NOT USE 46:1156 Administrative Procedure Act)","46:2114":"46:2114 (46:2114 Wrongful Discharge from Employment - protection from discrimination)","46:30101":"46:30101 (46:30101 Extension of jurisdiction to cases of damage or injury on land)","46:30104":"46:30104 (46:30104 Marine Personal Injury - Jones Act)","46:30302":"46:30302 (46:30302 Shipping: Damages for Death on High Seas)","46:30304":"46:30304 (46:30304 Breach of Maritime Contract - liability of noncompliance)","46:30503":"46:30503 (46:30503 Limitation of Liability - declaration of nature and value of goods)","46:30504":"46:30504 (46:30504 Limitation of Liability - loss by fire)","46:30505":"46:30505 (46:30505-30510 Exoneration, Limitation of Liability)","46:30511":"46:30511 (46:30511 Action by owner for limitation)","46:30701":"46:30701 (46:30701 Marine Cargo Loss or Damage - Liability of Water Carriers)","46:30704":"46:30704 (46:30704 Liability of Water Carriers - Loading, stowage, custody, care, and delivery)","46:30902":"46:30902 (46:30902 to 30911 Suits in Admiralty Act)","46:31102":"46:31102 (46:31102 Public Vessels Act - Waiver of Immunity)","46:31301":"46:31301 (46:31301 Federal Maritime Lien Act)","46:31321":"46:31321 (46:31321 Foreclosure of Preferred Ship Mortgages)","46:31325":"46:31325 (46:31325 Suit to enforce lien upon mortgaged vessel-foreclosure/Forecls of Prefer. Foreign Ship Mort)","46:31341":"46:31341 (46:31341 Federal Maritime Lien Act)","46:31342":"46:31342 (46:31342 Breach of Maritime Contract (establishing maritime liens))","46:31343":"46:31343 (46:31343 Commercial Instruments & Maritime Liens)","46:40101":"46:40101 (46:40101 Shipping Act of 1998)","46:41102":"46:41102 (46:41102(a) Shipping Act of 1984 - General Prohibitions)","46:41309":"46:41309 (46:41309 Shipping Act of 1984 - Enforcement of Reparation Orders)","46:50101":"46:50101 (46:50101 Violation of Maritime Regulations)","46:58109":"46:58109 (46:58109 Violation of Merchant Marine Act - Penalties)","47:151":"47:151 (47:151 Federal Communications Act of 1934)","47:151cs":"47:151cs (47:151cs Federal Communications Act - Collection for Services)","47:201bt":"47:201bt (47:201bt Breach of Tariff)","47:203":"47:203 (47:203 Telecommunications Collection of Charges)","47:205":"47:205 (47:205 Wire and Radio Communication Svc and Charges (Recovery of Damages))","47:206":"47:206 (47:206 Carrier's Liability for Damages)","47:227":"47:227 (47:227 FCC-Unsolicited Telephone Sales)","47:227(b)":"47:227(b) (47:227(b)(3) Telephone Consumer Protection Act of 1991)","47:251":"47:251 (47:251 Telecommunications Act of 1996 - Interconnection)","47:252":"47:252 (47:252 Telecommunications Act)","47:254(h)":"47:254(h) (47:254(h) Children's Internet Protection Act)","47:332":"47:332 (47:332 FCA-Wire or Radio Communications (Mobile Services))","47:332(c)":"47:332(c) (47:332(c) Federal Telecommunications Act of 1996)","47:338":"47:338 (47:338 Satellite Home Viewer Improvement Act)","47:401":"47:401 (47:401 Application of Federal Communication Comm for Inj. (Enforcement Provisions))","47:407":"47:407 (47:407 Order for payment of money; petition for enforcement;)","47:510":"47:510 (47:510 Forfeiture of Communications Devices)","47:521":"47:521 (47:521 Cable Televsn. Consumer Protection & Competition Act of 1992)","47:532":"47:532 (47:532 Cable Communication Policy Act of 1984)","47:551":"47:551 (47:551 Cable Communications Act)","47:553":"47:553 (47:553 U.S.C.A. Cable Communications Policy Act)","47:605":"47:605 (47:605 Unlawful Reception Broadcast Signal i.e., Satellite - Theft of Satellite Communications)","48:0883":"48:0883 (DO NOT USE 48:883 Violation of US Coastal Law)","48:1985":"48:1985 (DO NOT USE 48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (DO NOT USE 49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (DO NOT USE 49:781 Forfeiture)","49:101":"49:101 (49:101 ICC Termination Act of 1996)","49:10101":"49:10101 (49:10101 Interstate Commerce Act-Interstate Transportation Rail)","49:10743":"49:10743 (49:10743 Revised Interstate Commerce Act)","49:11101":"49:11101 (49:11101 Interstate Commerce Act)","49:1113":"49:1113 (49:1113 Petition to enforce administrative summon)","49:1136":"49:1136 (49:1136 Aviation Disaster Family Assistance Act of 1996)","49:11501":"49:11501 (49:11501 Railroad Revitalization & Regulatory Reform Act (General jurisdiction))","49:11502":"49:11502 (49:11502 Railroad Revitalization Regulatory Reform (authority to exempt rail carrier transportation))","49:11503":"49:11503 (DO NOT USE 49:11503 Railroad Revitalization Regulatory Reform)","49:11701":"49:11701 (49:11701 General authority of enforcement of regulations in rail)","49:11702":"49:11702 (49:11702 Enforcement by the Board)","49:11705":"49:11705 (49:11705 Limitation on actions by and against rail carriers)","49:11706":"49:11706 (49:11706 Carmack Amendent (Liability of carriers under receipts and bills of lading))","49:11707":"49:11707 (49:11707 Carmack Amendment (Liability when property is delivered in violation of routing instruction)","49:13101":"49:13101 (49:13101 Transportation Policy)","49:13702":"49:13702 (49:13702 Tariff requirement for certain transportation)","49:13706":"49:13706 (49:13706 Motor Carriers, etc-Liability for Payment of Rates)","49:14501":"49:14501 (49:14501 Preemption (federal authority of intrastate transportation))","49:14705":"49:14705 (49:14705 Interstate Commerce Act/Carmack Amendment (Limitations on actions by and against carriers))","49:14706":"49:14706 (49:14706 Carmack Amendment to the Interstate Commerce Act / Liability of Carriers - Receipts & Bill)","49:1471":"49:1471 (DO NOT USE 49:1471 Federal Aviation Act)","49:1903":"49:1903 (DO NOT USE 49:1903 Petition to enforce administrative summon)","49:20301":"49:20301 (49:20301-20306 Federal Safety Appliance Act)","49:21302":"49:21302 (49:21302 Carriers violations of Interstate Commerce Act (Chapter 201 accident and incident violation)","49:30101":"49:30101 (49:30101 National Traffic & Motor Vehicle Safety Act)","49:30112":"49:30112 (49:30112 Motor Vehicle Safety (prohibition on non-complying motor vehicles and equipment))","49:30502":"49:30502 (49:30502 Natl Motor Vehicle Title Information Syst)","49:31114":"49:31114 (49:31114 Access to Interstate System/Commercial Motor Vehicle)","49:31502":"49:31502 (49:31502 Motor Carrier Safety: Requirements for Qualifications)","49:32101":"49:32101 (49:32101 Motor Vehicle Information and Costs Savings Act)","49:32701":"49:32701 (49:32701 Odometer Requirements Act)","49:40101":"49:40101 (49:40101 Federal Aviation Act)","49:40102":"49:40102 (49:40102 Airline Deregulation Actv (definitions of air and commerce safety))","49:40105":"49:40105 (49:40105 Warsaw Convention)","49:41705":"49:41705 (49:41705 Air Carrier Access Act (discrimination against handicapped individuals))","49:41713":"49:41713 (49:41713 Airline Deregulation Actv (premp of authority over prices, routes, and service))","49:44709":"49:44709 (49:44709 Noise Control Act of 1972)","49:44715":"49:44715 (49:44715 Noise Control Act of 1972)","49:46507":"49:46507 (49:46507 False information and threats)","49:47101":"49:47101 (49:47101 Airport and Airway Improvement Act of 1982)","49:47501":"49:47501 (49:47501 Aviation Safety & Noise Abatement Act of 1979)","49:49101":"49:49101 (49:49101 Wrongful Termination in Contravention of Published Regulations)","49:49104":"49:49104 (49:49104 Breach of Lease by Metro. Wash. Airport Auth.)","49:502":"49:502 (49:502 Transportation Administrative Subpoena)","49:60101":"49:60101 (49:60101 Pipeline Safety Act of 1994)","49:60102":"49:60102 (49:60102 Hazardous Liquid Pipeline Safety Act of 1979 (HLPSA))","49:80102":"49:80102 (49:80102 Bills of Lading - Application)","49:80302":"49:80302 (49:80302 Contraband - Prohibitions)","49:80303":"49:80303 (49:80303 Seizure and forfeiture of vessel or aircraft conveying contraband)","50:1701":"50:1701 (50:1701-1706 International Emergency Economic Powers Act)","50a:1":"50a:1 (50a:1 Trading With the Enemy Act (act located in Title 50, Appendix.))","50a:2412":"50a:2412 (50a:2412 Export Administration Act--1979 (act located in Title 50, Appendix.))","50a:501":"50a:501 (50a:501 Sailors and Soldiers Civil Relief Act (act located in Title 50, Appendix.))","50a:533":"50a:533 (50a:533 Servicemembers Civil Relief Act-mortgages (act located in Title 50, Appendix.))","50a:540":"50a:540 (50a:540 Sailors and Soldiers Civil Relief Act (act located in Title 50, Appendix.))","51:20137":"51:20137 (51:20137(a) Malpractice & Negligence Against U.S. Space program)","5:8316":"5:8316 (DO NOT USE 5:8316 Claims agst US re Retirement for Federal Emp.)","5:8470":"5:8470 (DO NOT USE 5:8470 Enforcement of Judgment against Retirement Benefits)","8:287":"8:287 (DO NOT USE 8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!) )","adsup":"adsup (Administrative Subpoena )","contempt":"contempt (Contempt Proceedings )","disbar":"disbar (Disbarment Proceedings )","disp":"disp (Disciplinary Proceeding )","fordepo":"fordepo (Foreign Deposition )","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel )","motcompf":"motcompf (Motion to Compel - Fingerprints )","motquash":"motquash (Motion to Quash )","motret":"motret (Motion for Return of Property )","petenf":"petenf (Petition to Enforce IRS Summons )","petper":"petper (Petition to Perpetuate Testimony )","regjgm":"regjgm (Registration of Foreign Judgment )","tranbkref":"tranbkref (Transmission of Bankruptcy Reference )","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law )","writgar":"writgar (Application for a Writ of Garnishment )"},"medce":{"0":"0 (No cause code entered)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451(j)":"08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:191":"12:191 (12:191 Bank Foreclosure)","12:192":"12:192 (12:192 Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2511":"18:2511 (18:2511 Wiretapping)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","18:924":"18:924 (18:924 Seizure, Forfeiture and Disposition of Firearm)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2615":"29:2615 (29:2615 Family and Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:3131":"40:3131 (40:3131 Miller Act)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11601":"42:11601 (42:11601 International Child Abduction Remedies Act (Hague))","42:12101":"42:12101 (42:12101 American Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:31325":"46:31325 (46:31325 Preferred Mortgage Lien on Vessel)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","adsup":"adsup (Administrative Subpoena)","certjgmreg":"certjgmreg (Certificate of Judgment for Registration in Other District)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","expartdisc":"expartdisc (Ex Parte order to disclose returns and return information)","fordepo":"fordepo (Foreign Deposition)","mappstlmt":"mappstlmt (Motion for Approval of Settlement)","mdisclhrg":"mdisclhrg (Motion for Disclosure Hearing)","misc":"misc (Civil Miscellaneous Case)","miscgjm":"miscgjm (Miscellaneous Grand Jury Matters)","miscmtn":"miscmtn (Miscellaneous Motions)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","mtnapptCJA":"mtnapptCJA (Motion for Appointment of Counsel)","penreg":"penreg (Pen Register)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","petwrit":"petwrit (Petition for Writ)","petwritmnd":"petwritmnd (Petition for Writ of Mandamus)","regjgm":"regjgm (Registration of Foreign Judgment)","repdisclgj":"repdisclgj (Report/Disclosure of Grand Jury Matters)","seizwarr":"seizwarr (Seizure Warrant)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","transjuris":"transjuris (Transfer of Jurisdiction)","writgar":"writgar (Application for a Writ of Garnishment)"},"miedce":{"0":"0 (No cause code entered)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","10:2733":"10:2733 (10:2733 Military Claims Action)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0981":"18:0981 (18:981 Civil Forfeiture)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1083":"20:1083 (20:1083 National Direct Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331pl":"28:1331pl (28:1331 Product Liability)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 U.S. Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441er":"28:1441er (28:1441 Petition for Removal - E.R.I.S.A.)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fl":"28:1441fl (28:1441 Petition for Removal - Fair Labor Standards)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441mv":"28:1441mv (28:1441 Petition for Removal - Motor Vehicle)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (28:3001 Federal Debt Collection)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1101":"29:1101 (29:1101 E.R.I.S.A.)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","31:5317":"31:5317 (31:5317 Search and Forfeiture of Monetary Instruments)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","37:0502":"37:0502 (37:502(b) Recoup Overpayment of Excessive Leave)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:1803rc":"38:1803rc (38:1803 Recoupment of Veterans Administration Home Loan)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000ha":"42:2000ha (42:2000 Job Discrimination (handicap))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0688ma":"46:0688ma (46:688 Maritime Personal Injury)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:0503":"47:0503 (47:503 Radio and Wire Communication - Forfeiture)","47:0504":"47:0504 (47:504 Radio and Wire Communication - Recovery of Forfeiture)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"miwdce":{"*":"* ()","0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown )","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:1508":"05:1508 (05:1508 Petition for Judicial Review of Merit Sys Prot Board)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2011":"07:2011 (07:2011 Food Stamp Act)","07:2023":"07:2023 (07:2023 Administrative & Judicial Review of USDA decision )","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:0287":"08:0287 (08:0287 Petition to Enforce INS Subpoena)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1447":"08:1447 (08:1447 Hearings on Denials of Applications for Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0004":"09:0004 (09:4 Petition for Order Compelling Arbitration)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1109":"10:1109 (10:1109 Other Statutory Actions )","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1811":"12:1811 (12:1811 Negotiable Instruments )","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissory Note)","12:1833":"12:1833 (12:1833 Fin. Inst. Reform, Recovery, and Enforcement Act )","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0053b":"15:0053b (15:53(b) Prelim & Perm Inj Relief & Other Equitable Relief )","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1071":"15:1071 (15:1071 Trademark - Appeal to Courts )","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1605":"15:1605 (15:1605 Consumer Credit Protection - Finance Charge )","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1691":"15:1691 (15:1691 Equal Credit Opportunity Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693":"15:1693 (15:1693 Use of electronic systems to transfer funds)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1247d":"16:1247d (16:1247(d) Railroad Rights-of-Way)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0981":"18:0981 (18:981 Forfeiture in Rem )","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:248":"18:248 (18:248 Freedom of access to clinic entrances )","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:0107":"20:0107 (20:107 Randolph-Sheppard Act/Vending Stand Act )","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1099b":"20:1099b (20:1099(b) Higher Education - Recognition of accrediting agency or association)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1415":"20:1415 (20:1415 Education-Handicapped Child-Procedures)","21:0301":"21:0301 (21:301 Federal Food, Drug, and Cosmetic Act )","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1303":"25:1303 (25:1303 Petition for Writ of Habeas Corpus (Indian Tribal))","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","25:2701":"25:2701 (25:2701 Indian Gaming Regulatory Act )","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6330":"26:6330 (26:6330 Review of IRS Tax Liability Determination)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0185lm":"28:0185lm (28:185 Labor/Management Relations Act )","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331mp":"28:1331mp (28:1331 Federal Question-Marine Personal Injury )","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sc":"28:1331sc (28:1331 Federal Question-Securities, Commodities, Exchange )","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tc":"28:1331tc (28:1331 Federal Question-Fed. Telecomm. Act of 1996 )","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332":"28:1332 (28:1332 Diversity-Personal Injury-Product Liability )","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mp":"28:1332mp (28:1332 Diversity-Motor Vehicle Product Liability )","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332op":"28:1332op (28:1332 Diversity- Other Personal Property)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332rp":"28:1332rp (28:1332 Diversity-Real Property )","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 Unjust Enrichment)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345em":"28:1345em (28:1345 Environmental Matters )","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hd":"28:1345hd (28:1345 Default of HUD Loan )","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345us":"28:1345us (28:1345 Debt to United States )","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1367":"28:1367 (28:1367 Supplemental Jurisdiction)","28:1391":"28:1391 (28:1391 Venue/Diversity)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441":"28:1441 (28:1441 Contract Product Liability )","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441ad":"28:1441ad (28:1441 Petition for Removal - Appeal from Administrative Decision)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cr":"28:1441cr (28:1441 Petition for Removal - Civil Rights)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441cve":"28:1441cve (28:1441 Petition for Removal- Civil Rights: Employment)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441er":"28:1441er (28:1441 Petition for Removal- ERISA)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fl":"28:1441fl (28:1441 Petition for Removal- Fair Labor Standards Act)","28:1441fm":"28:1441fm (28:1441 Petition for Removal- FMLA)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lc":"28:1441lc (28:1441 Petition for Removal - Land Condemnation)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nl":"28:1441nl (28:1441 Petition for Removal-Notice of Levy )","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441ocr":"28:1441ocr (28:1441 Petition for Removal - Other Civil Rights)","28:1441pc":"28:1441pc (28:1441 Petition for Removal-Prisoner Civil Rights )","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441ro":"28:1441ro (28:1441 Recovery of Overpayment & Enforcement of Judgment )","28:1441sa":"28:1441sa (28:1441 Petition for Removal- SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443 Petition for Removal- Rent, Lease & Ejectment)","28:1443cr":"28:1443cr (28:1443 Petition for Removal- Criminal Case Re: Civil Rights)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446or":"28:1446or (28:1446 Petition for Removal-Other Civil Rights )","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 Removal of Claim Related to Bankruptcy Case)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:2679":"28:2679 (28:2679 Petition for Removal - Tort Claims Procedure)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0141":"29:0141 (29:141 Labor Management Relations Act of 1947 )","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0504":"29:0504 (29:0504 Labor - Prohibition re holding office )","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0790":"29:0790 (29:790 Rehabilitation of Labor)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:0825":"29:0825 (29:825 The Family and Medical Leave Act of 1993 )","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fund)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1144":"29:1144 (29:1144 ERISA - other laws )","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1161":"29:1161 (29:1161 Health Benefits under COBRA )","29:1185":"29:1185 (29:1185 Federal Women's Health and Cancer Rights Act of 1998)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2001":"29:2001 (29:2001 Employee Polygraph Protection Act )","29:2101":"29:2101 (29:2101 Worker Adjustment and Retraining Notification Act)","29:2601":"29:2601 (29:2601 Violation of the Family and Medical Leave Act)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3701":"31:3701 (31:3701 Negotiable Instruments )","31:3729":"31:3729 (31:3729 False Claims Act)","31:3729mf":"31:3729mf (31:3729 Money and Finance False Claims)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","35:0284":"35:0284 (35:284 Patent Infringement - Damages )","35:1331":"35:1331 (35:1331 Patent Infringement )","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4301":"38:4301 (38:4301 Uniformed Services Employment and Reemployment Rights Act)","39:0409":"39:0409 (39:409 Postal Service )","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of Social Security Decision (SSID))","42:0405si":"42:0405si (42:405 Review of Social Security Decision (RSI))","42:0405wc":"42:0405wc (42:405 Review of Social Security Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of Social Security Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0423":"42:0423 (42:423 Review of HHS Decision )","42:0425":"42:0425 (42:425 Social Security Benefits )","42:0427":"42:0427 (42:427 Social Security Benefits)","42:0666a13":"42:0666a13 (42:666(a)(13)(A) Recording of Social Security Numbers )","42:11601":"42:11601 (42:11601 International Child Abduction Remedies Act)","42:11603":"42:11603 (42:11603 International Child Abduction Judicial Remedies)","42:12101":"42:12101 (42:12101 American Disability Act for Handicappers)","42:12111":"42:12111 (42:12111 American Disability Act)","42:12112":"42:12112 (42:12112 American With Disabilities Act- Discrimination)","42:12117":"42:12117 (42:12117 Americans With Disabilities Act- Enforcement)","42:12133":"42:12133 (42:12133 Americans with Disabilities Act - Enforcement )","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1973ff":"42:1973ff (42:1973ff Uniformed & Overseas Citizens Absentee Voting Act )","42:1981":"42:1981 (42:1981 Civil Rights-Jobs )","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983":"42:1983 (42:1983 Other Civil Rights )","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983ocv":"42:1983ocv (42:1983 Other Civil Rights)","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:3601 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:6928":"42:6928 (42:6928 Environmental Protection Agency Rules Violation )","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9601":"42:9601 (42:9601 Environmental Matters )","42:9606":"42:9606 (42:9606 Environmental Matters - Abatement Actions )","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","42:9613":"42:9613 (42:9613 Environmental Matters)","43:0945":"43:0945 (43:945 Compensation for Land Condemnation )","43:0945a":"43:0945a (43:945(a) Complaint in Condemnation )","43:0946":"43:0946 (43:946 Complaint in Condemnation-Eminent Domain )","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0063":"46:0063 (46:63 Marine Personal Injury )","46:0183":"46:0183 (46:0183 Shipping; Amount of Liability)","46:0188":"46:0188 (46:0188 Limitation of liability of owners-vessels )","46:0688":"46:0688 (46:688 Jones Act)","46:0688mp":"46:0688mp (46:688 Maritime Personal Injury )","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:3134":"46:3134 (46:3134 Marine Contract Action)","47:0151":"47:0151 (47:151 Telecommunications Act of 1996 )","47:0227":"47:0227 (47:227 Restrictions on the use of telephone equipment)","47:0251":"47:0251 (47:0251 Telecommunications Act of 1966- Interconnection)","47:0252":"47:0252 (47:252 Telecommunications Act of 1996)","47:0302":"47:0302 (47:302 Forfeiture-FCC Violations )","47:0332":"47:0332 (47:332 Federal Telecommunications Act of 1996 )","47:0504":"47:0504 (47:504 Communications Act-Forfeiture )","47:0510":"47:0510 (47:510 Forfeiture of Communications Devices )","47:0541":"47:0541 (47:541 Cable Communications Policy Act )","47:0546":"47:0546 (47:546 Cable Communications Policy Act of 1984 )","47:0553":"47:0553 (47:553 Unauthorized reception of cable service )","47:0605":"47:0605 (47:605 Unauthorized publication or use of communications)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:10101":"49:10101 (49:10101 Rail Transportation Policy )","49:10743":"49:10743 (49:10743 Revised Interstate Commerce Act )","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1374":"49:1374 (49:1374(c) Rates for carriage of persons and property )","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","49:32710":"49:32710 (49:32710 Odometer Tampering )","49:41705":"49:41705 (49:41705 Air Carriers Access Act )","misc":"misc (Civil Miscellaneous Case)"},"mndce":{"0":"0 (No cause code entered)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0701(a)":"05:0701(a) (05:0701(a) Petition for judicial review - VA)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:1508":"05:1508 (05:1508 Petition for judicial review - Hatch Act)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:1421":"07:1421 (07:1421 Agricultural Act for 1949)","07:2022":"07:2022 (07:2022 Review of administrative decision - Food Stamp Program)","07:2023":"07:2023 (07:2023 Food Stamp Act)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1101":"08:1101 (Immigration and Nationality Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451":"08:1451 (08:1451 Immigration: Revocation of Citizenship)","08:1451a":"08:1451a (08:1451a Action to revoke Citizenship)","08:1451j":"08:1451j (08:1451(j) Immigration: Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1441a":"12:1441a (12:1441a Rental Overcharges)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1831d":"12:1831d (12:1831d Depository Inst. Dereg. and Monetary Control Act of 1980)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:2609":"12:2609 (12:2609 Real Estate Settlement Procedures Act)","12:3401":"12:3401 (12:3401 Right to Financial Privacy Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","12:4004":"12:4004 (12:4004(a) Expedited Funds Availability Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1221":"15:1221 (15:1221 Automobile Dealer Suits Against Manufacturer)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1691":"15:1691 (15:1691 Equal Credit Opportunity Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693":"15:1693 (15:1693 Electronic Fund Transfer Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1345":"18:1345 (18:1345 Injunctions against fraud)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2510":"18:2510 (18:2510 Wire or Oral Communications)","18:2520":"18:2520 (18:2520 Interception of Wire/Oral Communication)","18:2710(c)":"18:2710(c) (18:2710(c) Wrongful disclosure of video tape data)","18:2724":"18:2724 (18:2724 Civil Action - Motor Vehicle Records)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","18:4245":"18:4245 (18:4245 Petition to Determine Mental Condition of Imprisoned Person)","18:4246":"18:4246 (18:4246 Petition to Determine Present Mental Condition of Imprisoned Person)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","19:1433":"19:1433 (19:1433 Failure to notify U. S. Customs prior to U. S. Entry)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1415":"20:1415 (20:1415 IDEA - Individuals with Disabilities Education Act)","20:1681":"20:1681 (20:1681 Sex/Blindness Discrimination in Educational Programs)","21:0332":"21:0332 (21:0332 Injunction to Restrain Violations of Prohibitions 331)","21:0334(a)":"21:0334(a) (21:0334(a) Forfeiture - Food, Drugs, Cosmetics)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0081":"25:0081 (25:0081 Contracts with Indian Tribes or Indians)","25:0461":"25:0461 (25:0461 Indian Reorganization Act)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1302":"25:1302 (25:1302 Indian Civil Rights Act)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","25:2601":"25:2601 (25:2601 Indian Education Act)","25:2701":"25:2701 (25:2701 Indian Gaming Regulatory Act of 1988)","26:6011":"26:6011 (26:6011 - Taxes-General requirement of return, statement or list)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157":"28:0157 (28:0157 Transfer of Adversary Proceeding)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332":"28:1332 (28:1332 Diversity)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pip":"28:1332pip (28:1332-pip-Diversity-Personal Injury, Product Liability)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pip":"28:1441pip (28:1441pip-Remove-Personal Injury, Product Liability)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:157(b)":"28:157(b) (28:157(b) Transfer of Adversary Proceeding)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0701":"29:0701 (29:0701 Vocational Rehabilitation)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2002":"29:2002 (Employee Polygraph Protection Act - EPPA)","29:201do":"29:201do (29:201do Denial of Overtime Compensation)","29:2101":"29:2101 (29:2101 WARN - Worker Adjustment & Retraining Notification Act)","29:2601":"29:2601 (29:2601 Family and Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:0701":"33:0701 (33:0701 Flood Control Act of 1944)","33:1251":"33:1251 (Federal Water Pollution Control Act)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (38:2021 Veteran's Reemployment Act)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4301":"38:4301 (38:4301 USERRA-Uniformed Svs. Employment & Reemployment Rights Act)","38:4311":"38:4311 (38:4311 Uniformed Svs. Employment &Reemployment Rights Act)","38:4323":"38:4323 (38:4323 USERRA-Uniformed Svs. Employment & Reemployment Rights Act)","38:611":"38:611 (38:611 Overpayment of VA benefits for Medical Treatment)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:0405 Review of HHS Decision (SSID))","42:0405rs":"42:0405rs (42:0405 Review of HHS Decision (RSI))","42:0405wc":"42:0405wc (42:0405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:0405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11603":"42:11603 (Return of Child/ Rights of Access to Child)","42:12101":"42:12101 (42:12101 Americans with Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision (regarding payment of benefits))","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1913":"42:1913 (42:1913 Compensation and Liability Act of 1980)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1982":"42:1982 (42:1982 Property Rights of Citizens)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000re":"42:2000re (42:2000re Job Discrimination (Religion))","42:2000sp":"42:2000sp (42:2000sp Job Discrimination (Sex Preference))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2021ae":"42:2021ae (42:2021(b) Agreements wi. States re: Dev. Atomic Energy)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:3605":"42:3605 (42:3605 Discrimination in Real Estate-Related Transactions)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:425":"42:425 (42:425 Social Security Benefits)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:4852":"42:4852 (42:4852 Lead-Based Paint Hazard Reduction in Housing)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9601":"42:9601 (42:9601 CERCLA - Comprehensive Environ. Response, Comp. & Liability)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0185":"46:0185 (46:0185 Petition for Exoneration/Limitation for Loss by Collision)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:0951":"46:0951 (46:0951 In REM to Enforce Lien on Mortgaged Vessel)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:0153":"47:0153 (47:153 Telecommunications Act of 1996)","47:0203":"47:0203 (47:203 Communications Act of 1934)","47:0252":"47:0252 (47:0252 Telecommunications Act of 1996)","47:0605":"47:0605 (47:0605 Unauthorized Reception of Satellite Signals)","47:151":"47:151 (47:151 Communication Act of 1934)","47:227b3":"47:227b3 (47:227(b)(3) Telephone Consumer Protection Act of 1991)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:10101":"49:10101 (49:10101 ICC Termination Act of 1995)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:14704":"49:14704 (Rights and remedies of persons injured by carriers or brokers)","49:14706":"49:14706 (49:14706 Carmack Amendment to the Interstate Commerce Act / Liability of Carriers - Receipts & Bills)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1552":"49:1552 (49:1552 Airline Deregulation Act)","49:1801":"49:1801 (49:1801 Violation of Hazardous Material Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","49:20101":"49:20101 (49:20101 Federal Railroad Safety Act)","49:32701":"49:32701 (49:32701 Odometer Requirments Act)","50:0501":"50:0501 (50:0501 - S&SCRA - Soliders and Sailors Civil Relief Act)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"moedce":{"0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8701":"05:8701 (05:8701 Federal Employees Group Life Insurance Act)","05:8901":"05:8901 (05:8901 Federal Employees Health Benefits Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Award)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:2601":"12:2601 (12:2601 Real Estate Settlement Procedures Act)","12:2615":"12:2615 (12:2615 Contracts)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1129":"15:1129 (15:1129 Cyberpiracy Protection for Individuals)","15:1222":"15:1222 (15:1222 Automobile Dealers Day in Court Act)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693":"15:1693 (15:1693 Electronic Fund Transfer Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0470":"16:0470 (16:0470 National Historic Preservation Act)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1030":"18:1030 (18:1030 Computer Fraud and Abuse Act)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2254":"18:2254 (18:2254 Release of Seized Property)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","18:981":"18:981 (18:981 Forfeiture (Wire Fraud))","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1082":"20:1082 (20:1021 Federal Family Education Loan Program (FFELP))","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1681":"20:1681 (20:1681 Title 9 of the Education Amendment Act of 1972)","21:0342":"21:0342 (21:0342 Food Drug and Cosmetic Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6404":"26:6404 (26:6404 Erroneous Tax Abatement)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157b":"28:0157b (28:1057b Transfer Related Claims and Causes of Action)","28:0157b5":"28:0157b5 (28:0157(b)(5) Transfer Related Claims and Causes of Action)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0157e":"28:0157e (28:0157e Non Consent to Jury Trial by the Bankruptcy Court )","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1132lm":"28:1132lm (28:1132lm Diversity - Legal Malpractice)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331bc Base Closure Action)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Removal / Civil Rights)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1455":"28:1455 (28:1455 Procedure for Removal Criminal Prosecutions)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2617":"29:2617 (29:2617 Family Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4321":"38:4321 (38:4321 Veterans Employment Benefits)","38:4323":"38:4323 (38:4323 Veterans Re-employment Rights Act (VRRA))","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:10841":"42:10841 (42:10841 Mental Health Systems Act)","42:11601":"42:11601 (42:11601 International Child Abduction Remedies Act)","42:12101":"42:12101 (42:12101 Americans with Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:13981":"42:13981 (42:13981 Violence Against Women Act of 1995)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1973av":"42:1973av (42:1973av Requirement w/Response to Admin of Voter Registration)","42:1973ce":"42:1973ce (42:1973ce Civil Enforcement and Private Right of Action)","42:1973gg6":"42:1973gg6 (42:1973gg6 Requirement W/Resp To Admin Of Voter Registration)","42:1973gg9":"42:1973gg9 (42:1973gg9 Civil Enforcement and Private Right of Action)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:288c":"42:288c (42:288c National Research Service Awards Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:3604":"42:3604 (42:3604 Title VIII - Housing Discrimination)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0056":"45:0056 (45:0056 Federal Employers Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0181":"46:0181 (46:0181 Admiralty Liability)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:31325":"46:31325 (46:31325 Preferred Mortgage Liens and Enforcement)","46:761":"46:761 (46:761 Death on the High Seas Act)","47:0151":"47:0151 (47:0151 Cable Communication Policy Act)","47:0207":"47:0207 (47:0207 Federal Communications Act - Recovery of Damages)","47:0227":"47:0227 (47:0227 Telephone Consumer Protection Act)","47:0553":"47:0553 (47:0553 Unauthorized Reception of Cable Service)","47:0605":"47:0605 (47:0605 Unauthorized Publication or Use of Communications)","47:332":"47:332 (47:332 Federal Telecommunications Act of 1996)","47:553":"47:553 (47:553 Unauthorized reception of cable service)","47:605":"47:605 (47:605 Unauthorized publication or use of communications)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:14704":"49:14704 (49:14704 ICC Termination Act of 1995)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"mowdce":{"0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:0706":"05:0706 (05:0706 Review of Judicial Administrative Decision)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8912":"05:8912 (05:8912 Denial of Federal Employee Health Benefits )","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2023":"07:2023 (07:2023 Review of disqualification of food stamps )","07:2131":"07:2131 (07:2131 Animal Welfare Act Penalty)","07:2156":"07:2156 (07:2156 Forfeiture of Animals Involved in Dog Fighting)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1101":"08:1101 (08:1101 Legal Immigration Family Equity Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1324a":"08:1324a (Unlawful employment of aliens)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1447":"08:1447 (08:1447 Hearing on Failure to Make a Determination under 08:1446)","08:1451a":"08:1451a (8:1451a Revocation of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","09:0205":"09:0205 (09:0205 Recognition and Enforcement of Foreign Arbitral Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1715z-1":"12:1715z-1 (12:1715z-1 National Housing Act )","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:2601":"12:2601 (12:2601 Real Estate Settlement Procedures Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","12:5531":"12:5531 (Prohibiting unfair, deceptive, or abusive acts or practices)","12:5536":"12:5536 (Prohibited acts)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0714":"15:0714 (15:0714b(c) Breach of Conservation Reserve Program Contracts)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1501":"15:1501 (15:1501 Unfair Competition claims for false advertising and trademark infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693":"15:1693 (15:1693 Electronic Fund Transfer Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","15:6801":"15:6801 (15:6801 Violation of Gramm-Leach-Bliley Act)","15:6809":"15:6809 (15:6809 Commerce and Trade)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","16:6330":"16:6330 (16:6330 Judicial Review of a Collection Due Process - IRS)","16:791a":"16:791a (Federal Power Act)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0106A":"17:0106A (17:0106A Rights of Certain Authors to Attribution and Integrity)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","17:0512(h)":"17:0512(h) (17:0512(h) Subpoena to Identify Infringer)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0923":"18:0923 (18:0923 Denial or revocation of firearms license)","18:1030":"18:1030 (18:1030 Computer Fraud and Abuse Act )","18:1345":"18:1345 (18:1345 Fraud Injunction Statute)","18:1514A":"18:1514A (18:1514A Sarbanes-Oxley Act of 2002)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2254":"18:2254 (18:2254 Civil Forfeiture)","18:248":"18:248 (18:248 Freedom of Access to Clinic Entrances Act of 1994 )","18:2510":"18:2510 (18:2510 Electronic Communications Privacy Act )","18:2721":"18:2721 (18:2721 Driver's Privacy Protection Act)","18:3511":"18:3511 (Judicial Review of Requests for Information)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","18:4245":"18:4245 (18:4245 Petition to Determine Mental Status of Prisoner)","18:4246":"18:4246 (18:4246 Petition to Determine Present Mental Condition of Imprisoned Person)","18:981":"18:981 (18:981 Civil Forfeiture)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1095":"20:1095 (20:1095 Failure to Comply with Order of Withholding from Earnings)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1415":"20:1415 (20:1415 Individuals with Disabilities)","20:1681":"20:1681 (20:1681 Title IX Educational Amendments 1992 - Sex Discrimination)","21:0801":"21:0801 (21:0801 Health Care Fraud)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881mv":"21:0881mv (21:0881mv Forfeiture of Motor Vehicle)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","21:332A":"21:332A (21:332A Food, Drug & Cosmetics Act)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6103":"26:6103 (26:6103 Confidentiality and Disclosure of Tax Return Information)","26:6111":"26:6111 (26:6111 Tax Code - Disclosure of Reportable Transactions)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6330":"26:6330 (26:6330 Review of IRS Due Process Hearing)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7407":"26:7407 (26:7407 Action to Enjoin Income Tax Preparers)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7434":"26:7434 (26:7434 Civil Damages for Fraudulent Filing of Information Returns)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 Petition for Indemnity)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345q":"28:1345q (28:1345 Quiet Title Action)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Multidistrict Litigation)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:2679":"28:2679 (28:2679 Removal of damages action against Federal Employee)","28:3001":"28:3001 (28:3001 Federal Debt Collections Procedure Act)","28:3301":"28:3301 (28:3301 Fraudulent Transfer)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0216":"29:0216 (29:0216 Failure to Pay Earned Compensation)","29:0217":"29:0217 (29:0217 Action for Injunctive Relief-Minimum Wage and Overtime Comp)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2601":"29:2601 (29:2601 Family Medical Leave Act)","29:412":"29:412 (29:412 Infringement of Rights; jurisdiction)","29:790":"29:790 (29:790 Rehabilitation of Labor)","29:791":"29:791 (29:791 Employment Discrimination under the Rehabiliation Act)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","30:801":"30:801 (30:801 Penalties Federal Mine Safety Health Act of 1977 )","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0101":"35:0101 (35:0101 Patents)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","35:0292":"35:0292 (35:292 False Patent Marking)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4301":"38:4301 (38:4301 Employment/Reemployment Rights of Members of Uniformed Services)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:3008":"39:3008 (39:3008 Prohibition of pandering advertisements)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:3113":"40:3113 (40:3113 Condemnation)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0201":"42:0201 (42:0201 Public Health Service)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0233":"42:0233 (42:0233 Remand of tort action involving federally funded business)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405si":"42:0405si (42:405si Review of HHS Decision (RSI) )","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0408":"42:0408 (42:0408 Social Security Fraud)","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11601":"42:11601 (42:11601 International Child Abduction Remedies Act)","42:12101":"42:12101 (42:12101 American with Disabilities Act)","42:12117":"42:12117 (Americans with Disabilities Act )","42:1320":"42:1320 (42:1320 Disclosure of Health Information - HIPAA)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1394":"42:1394 (42:1394 Medicare as Secondary Payer Act)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:13981":"42:13981 (42:13981 Violence Against Women Act )","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1751":"42:1751 (National School Lunch Act and Child Nutrition Act)","42:1973gg":"42:1973gg (42:1973 Voter Registration Agency Designation)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2541":"42:2541 (42:2541 Recovery of Scholarships)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:425":"42:425 (42:427 Social Security Benefits)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:4654":"42:4654 (42:4654 Attorney's Fees/Expenses in Inverse Condemnation Case)","42:4852":"42:4852 (42:4852-Residential Lead Based Paint Act)","42:5851":"42:5851 (Energy Reorganization Act )","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:6928":"42:6928 (42:6928 Federal Water Pollution Control Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9601":"42:9601 (42:9601 Comprehensive Environm Resp, Comp & Liability Act )","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:1701":"46:1701 (46:1701 Ocean Shipping Reform Act of 1998)","46:31301":"46:31301 (46:31301 Promissory Note and Enforcement of Ship Mortgage)","47:227":"47:227 (47:227 FCC-Unsolicited Telephone Sales)","47:252":"47:252 (47:252(e)(6) Interconnection Agreement)","47:605":"47:605 (47:605 Unlawful interception of signals and programming services)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0507":"49:0507 (49:0507 Motor Carrier Safety Regulations)","49:0781":"49:0781 (49:781 Forfeiture)","49:10101":"49:10101 (49:10101 Rail Transportation Policy)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:13101":"49:13101 (49:13101 Carrier Transportation Policy)","49:13702":"49:13702 (49:13702 Tariff Requirements)","49:14501":"49:14501 (49:14501 Federal authority over interstate transportation)","49:14706":"49:14706 (49:14706 Failure to deliver shipment of goods in good condition)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","49:20101":"49:20101 (49:20101 Railroad Safety)","49:32701":"49:32701 (49:32701 Federal Odometer Act )","49:40101":"49:40101 (49:40101 Airline Deregulation Act of 1978)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"msndce":{"0":"0 (No cause code entered)","02:0431":"02:0431 (02:431 Federal Election Commission: Failure to Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","02:138":"02:138 (02:138 Library of Congress Access)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade (NO LONGER USED))","05:0551":"05:0551 (05:551 Administrative Procedures Act)","05:0552fi":"05:0552fi (05:552fi Freedom of Information Act)","05:0552pa":"05:0552pa (05:552pa Right to Privacy Act)","05:0554":"05:0554 (05:0554 Adjudications Required by Statutes)","05:0701":"05:0701 (05:0701 Judicial Review of Agency Decision)","05:0702":"05:0702 (05:702 Administrative Procedure Act - Right of Review)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyards Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0499Ec4":"07:0499Ec4 (Perishable Agricultural Commodities Act (PACA))","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Immigration: Judicial Review for Battered Spouses; Deportation (INS))","08:1182":"08:1182 (8:1182 Inadmissible Aliens: Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1252":"08:1252 (08:1252 Judicial Review of Orders of Removal)","08:1260":"08:1260 (08:1260 Aliens: Removal of Aliens Falling into Distress)","08:1324":"08:1324 (08:1324 Immigration: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Immigration: Writ of Mandamus to Adjudicate Visa Petition)","08:1357":"08:1357 (Immmigration and Nationality Act- Administrative Search Warrant)","08:1446":"08:1446 (8:1446 Immigration: Petition for Naturalization Hearing)","08:1451(j)":"08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Award)","09:0010":"09:0010 (9:10 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Armed Forces: Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: Review of Discharge or Dismissal)","10:2305":"10:2305 (10:2305 Armed Forces: Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy (Definitions))","12:0635":"12:0635 (12:635i-3 Export-Import Bank: Breach of Insurance Contract)","12:1441":"12:1441 (FHLB: Financial Inst Reform Receiving Enforcement Act 1989)","12:1461":"12:1461 (12:1461 Savings Associations: Homeowners Loan Act (Short Title))","12:1464":"12:1464 (12:1464 Savings Associations: Federal Savings and Loan)","12:1703":"12:1703 (12:1703 National Housing: Insurance of Financial Institutions)","12:1819":"12:1819 (12:1819 FDIC: Corporate Powers)","12:1821":"12:1821 (12:1821 FDIC: Insurance Funds)","12:191":"12:191 (12:191 National Banks: Appointment of Receiver)","12:192":"12:192 (12:192 National Banks: Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Company Act (Definitions))","12:1972":"12:1972 (12:1972 Typing Arrangement Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy: Customer Challenges)","15:0001":"15:0001 (15:1 Antitrust Litigation (Monopolizing Trade))","15:0002at":"15:0002at (15:2at Antitrust Litigation)","15:0002fl":"15:0002fl (15:2fl Antitrust Litigation)","15:0005":"15:0005 (15:5 Bringing in Additional Parties)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement (No Longer Used))","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0045cp":"15:0045cp (15:45cp Violation of Children Online Privacy Protection Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0053(b)":"15:0053(b) (Prelim & Perm Inj Relief & other Equitable Relief)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement (Lanham Act))","15:1121":"15:1121 (15:1121 Trademark Infringement (jurisdiction))","15:1125":"15:1125 (15:1125la Trademark Infringement (Lanham Act))","15:1125(d)":"15:1125(d) (15:1125(d)ac)","15:1126":"15:1126 (15:1126 Trademarks - International conventions)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act (No Longer Used))","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer) (REPEALED)(No Longer Used))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer) (REPEALED) (NO LONGER USED))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer) (REPEALED) (NO LONGER USED))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)","15:78j(b)":"15:78j(b) (15:78j(b)ss Stockholder Suit)","16:0668":"16:0668 (16:668 Bald and Golden Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act (Definitions))","16:3372":"16:3372 (16:3372 Lacey Act: Prohibited Acts)","16:3373":"16:3373 (16:3373 Lacey Act: Penalties and Sanctions - Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Lacey Act: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement (definitions))","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Remedies for Copyright Infringement)","17:1201":"17:1201 (17:1201 Digital Millennium Copyright Act)","17:512":"17:512 (17:512 Copyright Infringement of Digital Communications)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act (No Longer Used))","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act (No Longer Used))","18:1964":"18:1964 (18:1964 Civil Remedies: Racketeering (RICO) Act)","18:2511":"18:2511 (18:2511 Wiretapping - Injunctive Relief or Civil Fine)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:4208":"18:4208 (18:4208 Agency Action Review (REPEALED) (No Longer in Use))","19:1305":"19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Default of Student Loan: Recovery)","20:1400":"20:1400 (20:1400 IDEA: Individuals With Disabilities Education Act (short title))","20:1401":"20:1401 (20:1401 IDEA: Education of Individuals with Disabilities (definitions))","21:0841":"21:0841 (21:841 Forfeiture Property - Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property - Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881re Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 Metropolitan Transportation Planning)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 IRS: Notice of Deficiency (Injunctive Relief from IRS Lien))","26:6213":"26:6213 (26:6213 IRS: Injunctive Relief from IRS Lien in Tax Court)","26:6502":"26:6502 (26:6502 IRS: Collection after Assessment (Enforcement of tax liens))","26:6532":"26:6532 (26:6532 IRS: Periods of Limitation on Suits)","26:6702":"26:6702 (26:6702 IRS: Penalty for Frivolous Tax Submission)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability - Authorization to collect via civil action)","26:7402":"26:7402 (IRS: Jurisdiction of District Courts)","26:7402(b)":"26:7402(b) (26:7402(b) IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Action to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157d Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (District or BAP))","28:0185":"28:0185 (28:185 Suit to Compel Arbitration (REPEALED) (No Longer in Use))","28:0451":"28:0451 (28:451 Employment Discrimination (REPEALED) (No Longer in Use))","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act (REPEALED) (No Longer in Use))","28:1001":"28:1001 (28:1001 E.R.I.S.A. (REPEALED) (No Longer in Use))","28:1132":"28:1132 (28:1132 E.R.I.S.A. (REPEALED) (No Longer in Use))","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331bc Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331ca Fed Question: Fed Communications Act of 1934)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Fed. Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Fed. Question: Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendments)","28:1331wl":"28:1331wl (28:1331 Fed. Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332de":"28:1332de (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337sc":"28:1337sc (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340tp":"28:1340tp (28:1340 Jurisdiction of Internal Revenue Matters; Customs Duties)","28:1341":"28:1341 (28:1341 Taxes by States)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 U.S. Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346t":"28:1346t (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1349 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury Venue)","28:1402":"28:1402 (28:1402 U.S. as a Defendant (formerly Medical Malpractice))","28:1407":"28:1407 (28:1407 MDL Airline Crash)","28:1441ac":"28:1441ac (28:1441ac Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Removal - Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Removal - Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Removal - Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Removal - Civil Rights Act)","28:1441df":"28:1441df (28:1441 Removal - Contract Default)","28:1441dj":"28:1441dj (28:1441dj Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Removal - Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Removal - Employment Discrimination)","28:1441fc":"28:1441fc (28:1441 Removal - Fair Credit Reporting Act)","28:1441fr":"28:1441fr (28:1441 Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Removal- Tort/Motor Vehicle (P.I))","28:1441tn":"28:1441tn (28:1441 Removal- Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Removal- Wrongful Death)","28:1442aaf":"28:1442aaf (28:1442 Petition for Removal -Against Members of Armed Forces)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal -Suit Against Federal Officer)","28:1443":"28:1443 (28:1443(1) Removal from State Court - Civil Rights:Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Notice of Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Notice of Removal- Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Notice of Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Notice of Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 Removal of Claims Related to Bankruptcy Cases)","28:157b":"28:157b (28:157b Bankruptcy Claim to be tried in U.S. District Court)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis (REPEALED) (No Longer in Use))","28:1651cn":"28:1651cn (28:1651 Petition for Writ of Error Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Assistance to Foreign Tribunals (incl letter rogatory))","28:2201":"28:2201 (28:2201 Creation of a Remedy -Declaration of Rights (formerly Constitutionality of State Statute(s)))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241fd Petition for Writ of Habeas Corpus (federal))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Petition for Writ of Habeas Corpus - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act (REPEALED) (No Longer in Use))","28:2345":"28:2345 (28:2345 Medicare Recovery (REPEALED) (No Longer in Use))","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 - Actions affecting property on which United States has lien)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act - Liability of US)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","29:0151":"29:0151 (29:151 Labor: National Labor Relations Act (NLRA))","29:0159":"29:0159 (29:0159 Violation of Collective Bargaining Agreement)","29:0160":"29:0160 (29:160 Labor: NLRA - Prevention of Unfair Labor Practices)","29:0185ep":"29:0185ep (29:185 Suits by and Against Labor Organizations (formerly Employee Pension Plan))","29:0185lm":"29:0185lm (29:185 Suits by and Against Labor Organizations (formerly Labor/Mgt. Relations (Contracts)))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Definitions (formerly Equal Pay Act))","29:0206":"29:0206 (29:206 FLSA: Minimum Wage (formerly Collect Unpaid Wages))","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Prohibition of Age Discrimination))","29:0626":"29:0626 (29:626 Job Discrimination (Investigation and Enforcement))","29:0633":"29:0633 (29:633 Job Discrimination (Age- Federal-State Relationship))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination (No Longer Used))","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement (Definitions))","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun (No Longer Used - refers to CR))","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Civil Enforcement of Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:207(a)":"29:207(a) (29:207(a) Action for Overtime Wage Violation)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action (REPEALED - No Longer in Use))","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac (No Longer Used - Not Valid))","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence (No Longer Used))","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983pr Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping (No Longer Used))","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act (No Longer Used))","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported (No Longer Used))","49:0781":"49:0781 (49:781 Forfeiture (No Longer Used))","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","adsup":"adsup (Administrative Subpoena)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","fordepo":"fordepo (Foreign Deposition)","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","writgar":"writgar (Application for a Writ of Garnishment)"},"mssdce":{"0":"0 (no cause specified)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451(j)":"08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:191":"12:191 (12:191 Bank Foreclosure)","12:192":"12:192 (12:192 Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2511":"18:2511 (18:2511 Wiretapping)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Fed. Question: Civil Rights Violation)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel, Assault, Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 VA Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Notice of Removal-Account Receivable)","28:1441al":"28:1441al (28:1441 Notice of Removal-Airline Crash)","28:1441as":"28:1441as (28:1441 Notice of Removal-Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Notice of Removal-Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Notice of Removal-Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Notice of Removal-Contract Default)","28:1441dj":"28:1441dj (28:1441 Notice of Removal-Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441 Notice of Removal-Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Notice of Removal-Fraud)","28:1441ij":"28:1441ij (28:1441 Notice of Removal-Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Notice of Removal-Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Notice of Removal-Libel, Assault, Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Notice of Removal-Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Notice of Removal-Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Notice of Removal-Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Notice of Removal-Property Damage)","28:1441pi":"28:1441pi (28:1441 Notice of Removal-Personal Injury)","28:1441pl":"28:1441pl (28:1441 Notice of Removal-Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Notice of Removal-Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Notice of Removal-Torts to Land)","28:1441tm":"28:1441tm (28:1441 Notice of Removal-Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Notice of Removal-Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Notice of Removal-Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Notice of Removal-Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1441 Notice of Removal-Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Notice of Removal-Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Notice of Removal-Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (Actions affecting property on which United States had lien)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1395dd":"42:1395dd (42:1395 Emergency Medical Treatment & Active Labor Act)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accommodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:688":"46:688 (Jones Act (Merchant Marine))","47:251":"47:251 (Duties of telecommunications carriers)","47:252":"47:252 (Procedures of negotiation, arbitration, and approval of agreements for intercnonnection services)","47:261":"47:261 (Telecommunication Carrier, Commission and State Regulations)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","adsup":"adsup (Administrative Subpoena)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","fordepo":"fordepo (Foreign Deposition)","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","writgar":"writgar (Application for a Writ of Garnishment)"},"mtdce":{"0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1751":"12:1751 (Federal Credit Union Act)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","25:2701":"25:2701 (Indian Gaming Regulatory Act)","25:2710":"25:2710 (25:2710 Indian Gaming Regulatory Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-core))","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgement)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrimination)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting Act)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interpleader)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651a":"28:1651a (All Writs Act)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act - 1977)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)","38:2022":"38:2022 (38:2022 Veterans' Re-employment Rights Act of 1988)","38:3116":"38:3116 (38:3116 VA Overpayment)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:12102":"42:12102 (42:12102 Americans With Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1395dd":"42:1395dd (42:1395dd(d)(2)(A) Emergency Medical Treatment & Labor Act)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clean Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (Compel Reclamation Under Clean Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summons)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"ncedce":{"0":"0 (no cause specified)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment Against Retirement Benefits)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1182":"08:1182 (08:1182 Defend. Denial of Pla. Appl. for Alien Employ. Cer)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451(j)":"08:1451(j) (08:1451(j) Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:191":"12:191 (12:191 Bank Forclosure)","12:192":"12:192 (12:192 Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1691":"15:1691 (15:1691 Equal Credit Opportunity Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1701":"15:1701 (15:1701 Interstate Land Sales Full Disclosure Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0492":"18:0492 (Counterfeit Forfeiture)","18:0924":"18:0924 (18:0924 Forfeiture Property - Firearm)","18:1514":"18:1514 (18:1514 Harassment of a Witness)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2511":"18:2511 (18:2511 Wiretapping)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","18:4241":"18:4241 (18:4241 Motion to Determine Mental Competency/Other Dist.)","18:4248":"18:4248 (18:4248 Civil Commitment of a Sexually Dangerous Person)","18:981":"18:981 (18:981 Civil Forfeiture)","19:1305":"19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1415":"20:1415 (20:1415 Individuals with Disabilities Education Act)","20:1415e4":"20:1415e4 (20:1415(e)(4) Action for attorney fees and costs under IDEA)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1292":"28:1292 (28:1292 Personal Injury on Navigable Waters)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Fed. Question: Civil Rights Violation)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1322 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Petition for Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 VA Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346":"28:1346 (28:1346 Breach of Contract)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Notice of Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Notice of Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Notice of Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Notice of Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Notice of Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Notice of Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Notice of Removal- Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441 Notice of Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Notice of Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Notice of Removal- Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Notice of Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Notice of Removal- Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Notice of Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Notice of Removal- Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Notice of Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Notice of Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Notice of Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Notice of Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Notice of Removal- Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Notice of Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Notice of Removal- Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Notice of Removal- Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Notice of Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Notice of Removal- Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Notice of Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Notice of Removal- Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Notice of Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Actions - Property on which U.S. had lien)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2001":"29:2001 (29:2001 Employee Polygraph Protection)","29:2601":"29:2601 (29:2601 The Family and Medical Leave Act of 1993)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:1801":"38:1801 (38:1801 Recovery of VA Loan Guaranty Payment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (38:2021 Right to Re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4301":"38:4301 (38:4301 Uniformed Services Employment and Reemployment Rights Act of 1994)","38:775":"38:775 (38:775 Recov. of Servicemen's Group Life Ins.)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405ri":"42:0405ri (42:405 review of HHS Decision (RI))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11601":"42:11601 (42:11601 International Child Abduction Remedies Act)","42:12101":"42:12101 (42:12101 The Americans with Disabilities Act of 1990)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1395dd":"42:1395dd (42:1395dd Emergency Medical Treatment and Active Labor Act)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1985":"42:1985 (42:1985 Conspiracy to interfere with Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accommodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Recovery Act)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Flood Insurance Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:183":"46:183 (46:183 Limitation of Liability)","46:688":"46:688 (46:688 Jones Act)","46:951":"46:951 (46:951 Foreclosure of Preferred Mortgage)","47*":"47* ()","47:222":"47:222 (47:222 Telecommunications Act of 1996)","47:521":"47:521 (47:521 Cable Communications Policy Act of 1984)","47:605":"47:605 (47:605 Unauthorized publication or use of communications)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","adsup":"adsup (Administrative Subpoena)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","fordepo":"fordepo (Foreign Deposition)","misc":"misc (Civil Miscellaneous Case)","miscadmir":"miscadmir (Misc. Admiralty)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","writgar":"writgar (Application for a Writ of Garnishment)"},"ncmdce":{"0":"0 (no cause specified)","02:0138":"02:0138 (Library of Congress Access)","02:0358":"02:0358 (President's Recommendations on Exec., Jud. & Leg. Salary)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","02:0681":"02:0681 (Deferral of Budget Authority)","02:1202":"02:1202 (Discriminatory practices affecting US Senate employees)","02:1301":"02:1301 (Congressional Accountability Act)","02:1317(a)":"02:1317(a) (Violation of Congressional Accountability Act)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7101":"05:7101 (05:7101 Management & Employee Relations)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2023":"07:2023 (07:2023 Review of USDA Decision - Food Stamps)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451(j)":"08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (09:0009 Motion to Confirm Arbitration)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2005":"10:2005 (10:2005 Reimbursement of Scholarship Funds)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","10:2733":"10:2733 (10:2733 Armed Forces: Noncombat Activities-Personal Injury)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1715z-4":"12:1715z-4 (12:1715z-4a Unauthorized use of multifam.hous.project assets)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissory Note)","12:191":"12:191 (12:191 Bank Foreclosure)","12:192":"12:192 (12:192 Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act)","12:2601":"12:2601 (12:2601 Real Estate Settlement Procedures Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693":"15:1693 (15:1693 Electronic Fund Transfers Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0981":"18:0981 (18:0981 Civil Forfeiture - Gambling, etc.)","18:1030":"18:1030 (18:1030 Computer Fraud and Abuse Act)","18:1514A":"18:1514A (18:1514A Sarbanes-Oxley Act of 2002)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1955":"18:1955 (18:1955 Forfeiture, Gambling)","18:1957":"18:1957 (18:1957 Monetary Transaction in Prop.Derive.from Unlaw.Activ)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2254":"18:2254 (18:2254 Forfeiture-Materials Involv.Sexual Exploit.of Minors)","18:2510":"18:2510 (18:2510 Wire and Electronics Communications Act)","18:2511":"18:2511 (18:2511 Wiretapping)","18:2701":"18:2701 (18:2701 Electronics Communication Privacy Act)","18:2707":"18:2707 (18:2707 Illegal Disclosure of Electronic Comm. Svc. Records)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)","19:1603":"19:1603 (19:1603 Seizure Without Prosecution [Rule 41(e)])","19:1604":"19:1604 (19:1604 Seizure With Prosecution [Rule 41(e)])","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0301":"21:0301 (21:0301 Federal Food, Drug & Cosmetic Act)","21:0342":"21:0342 (21:0342 Forfeiture Property - Food)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7407":"26:7407 (26:7407 IRS Civil Injunction)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7431":"26:7431 (26:7431 IRS: Civil Damages for Unauthorized Disclosure)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331bv":"28:1331bv (28:1331 Prisoner Bivens Action)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Fed. Question: Civil Rights Violation)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pd":"28:1331pd (28:1331 Federal Question: Property Damage)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332":"28:1332 (28:1332 Diversity)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel, Assault, Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1334jt":"28:1334jt (28:1334 Bankruptcy Adversary Jury Trial)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 VA Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346cc":"28:1346cc (28:1346cc Contract Claims)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Notice of Removal-Account Receivable)","28:1441al":"28:1441al (28:1441 Notice of Removal-Airline Crash)","28:1441as":"28:1441as (28:1441 Notice of Removal-Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Notice of Removal-Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Notice of Removal-Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Notice of Removal-Contract Default)","28:1441dj":"28:1441dj (28:1441 Notice of Removal-Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441 Notice of Removal-Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441er":"28:1441er (28:1441 Notice of Removal-ERISA)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Notice of Removal-Fraud)","28:1441ij":"28:1441ij (28:1441 Notice of Removal-Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Notice of Removal-Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Notice of Removal-Libel, Assault, Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Notice of Removal-Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Notice of Removal-Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Notice of Removal-Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Notice of Removal-Property Damage)","28:1441pi":"28:1441pi (28:1441 Notice of Removal-Personal Injury)","28:1441pl":"28:1441pl (28:1441 Notice of Removal-Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Notice of Removal-Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Notice of Removal-Torts to Land)","28:1441tm":"28:1441tm (28:1441 Notice of Removal-Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Notice of Removal-Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Notice of Removal-Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Notice of Removal-Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1441 Notice of Removal-Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Notice of Removal-Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Notice of Removal-Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1738A":"28:1738A (Full Face and Credit Given to Child Custody Determinations)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1875":"28:1875 (28:1875 Protection of Juror Employment)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (Actions affecting property on which United States had lien)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","28:3301":"28:3301 (28:3301 Fraudulent Transfer Involving Debt)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1307":"29:1307 (29:1307 E.R.I.S.A - Recovery of Penalty & Interest)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2001":"29:2001 (29:USC2001 Employee Polygraph Protection Act)","29:2101":"29:2101 (29:2101 Worker Adj. & Retraining Notification Act)","29:2601":"29:2601 (29:2601 Family & Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:1984":"38:1984 (38:1984 Veteran's Benefits - Insurance Suits)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:3131":"40:3131 (40:3131 Miller Act)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405rsi":"42:0405rsi (42:0405 Review of HHS Decision (RSI))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11603b":"42:11603b (42:11603(b) Int'l Child Abduction Remedies Act)","42:12112":"42:12112 (42:12112 Americans with Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1395dd":"42:1395dd (42:1395 Emergency Medical Treat. & Active Labor Act (EMTALA))","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:13981":"42:13981 (42:13981 Violation of Civil Rights for Women)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1971":"42:1971 (42:1971 Voting Rights Act)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1985":"42:1985 (42:1985 Conspiracy to Interfere with Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000e3":"42:2000e3 (42:2000 Unlawful Employment Practices)","42:2000no":"42:2000no (42:2000 Job Discrimination (National Origin))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accommodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000rl":"42:2000rl (42:2000 Job Discrimination (Religion))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Recovery Act)","42:3601":"42:3601 (42:3601 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:6972":"42:6972 (42:6972 Environmental Matters)","42:7413":"42:7413 (42:7413 Air Quality Standards)","42:7523":"42:7523 (42:7523 Clean Air Act (Emission Standards))","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land (Environmental))","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:0231":"45:0231 (45:231 Railroad Retirement Act)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:1701":"46:1701 (46:1701 Ocean Commerce Actions)","47:0101":"47:0101 (47:0101 Federal Communications Act of 1934)","47:0227":"47:0227 (47:0227 Telephone Consumer Protection Act)","47:0230":"47:0230 (47:0230 Blocking/Screening Offensive Material on Internet)","47:0332":"47:0332 (47:0332 Violation of Telecommunications Act of 1996)","47:0553":"47:0553 (Cable Communications Policy Act of 1984)","47:0605":"47:0605 (47:0605 Unauthorized Publication/Use of Communications)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:1076":"49:1076 (49:1076 ICC Rates)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:11707":"49:11707 (49:11707 ICC: Liability of Common Carriers)","49:14706":"49:14706 (49:14706 Interstate Freight Claim (Carmack Amendment))","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","49:521":"49:521 (49:521 Federal Motor Carrier Safety Regulations)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","adsup":"adsup (Administrative Subpoena)","contempt":"contempt (Contempt Proceedings)","denifp":"denifp (Order Denying In Forma Pauperis)","disbar":"disbar (Disbarment Proceedings)","entprem":"entprem (Application to Enter Premises to Seize Property)","fordepo":"fordepo (Foreign Deposition)","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","petenf":"petenf (Petition to Enforce IRS Summons)","petenfeeoc":"petenfeeoc (Petition to Enforce EEOC Summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","suspen":"suspen (Suspension Proceedings)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","writgar":"writgar (Application for a Writ of Garnishment)"},"ncwdce":{"0":"0 (no cause specified)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451(j)":"08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1833":"12:1833 (12:1833 Civil Penalties)","12:191":"12:191 (12:191 Bank Foreclosure)","12:192":"12:192 (12:192 Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1071":"15:1071 (15:1071 Trademark Infringement (Lanham Act))","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1691":"15:1691 (15:1691 Equal Credit Opportunity Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1709":"15:1709 (15:1709 Violations re Sale or Lease of Lots)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","15:6101":"15:6101 (Telemarketing & Consumer Fraud)","15:6102":"15:6102 (Telemarketing & Consumer Fraud & Abuse Prevention Act)","15:687(c)":"15:687(c) (15:687(c) SBA Receivership)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1246(g)":"16:1246(g) (16:1246(g) National Trails System Act - Land Condemnation)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2511":"18:2511 (18:2511 Wiretapping)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:3664":"18:3664 (18:3664 Procedure for issuance and enforcement of order of restitution)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1415":"20:1415 (20:1415 Attorney Fees/Costs re: ADA)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:0881 Property Forfeiture)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Fed. Question: Civil Rights Violation)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel, Assault, Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (Diversity - Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 VA Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Multidistrict Litigation)","28:1441ac":"28:1441ac (28:1441 Notice of Removal-Account Receivable)","28:1441al":"28:1441al (28:1441 Notice of Removal-Airline Crash)","28:1441as":"28:1441as (28:1441 Notice of Removal-Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Notice of Removal-Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Notice of Removal-Breach of Contract)","28:1441cv":"28:1441cv (28:1441cv Notice of Removal - Civil Rights)","28:1441df":"28:1441df (28:1441 Notice of Removal-Contract Default)","28:1441dj":"28:1441dj (28:1441 Notice of Removal-Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441 Notice of Removal-Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Notice of Removal - Employment Discrimination)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Notice of Removal-Fraud)","28:1441ij":"28:1441ij (28:1441 Notice of Removal-Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Notice of Removal-Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Notice of Removal-Libel, Assault, Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Notice of Removal-Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Notice of Removal-Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Notice of Removal-Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Notice of Removal-Property Damage)","28:1441pi":"28:1441pi (28:1441 Notice of Removal-Personal Injury)","28:1441pl":"28:1441pl (28:1441 Notice of Removal-Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Notice of Removal-Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Notice of Removal-Torts to Land)","28:1441tm":"28:1441tm (28:1441 Notice of Removal-Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Notice of Removal-Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Notice of Removal-Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Notice of Removal-Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1441 Notice of Removal-Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Notice of Removal-Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Notice of Removal-Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (Actions affecting property on which United States had lien)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2601":"29:2601 (29:2601 Family & Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","35:256":"35:256 (35:256 Patent Correction of Named Inventor)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:0205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11601":"42:11601 (42:11601 Intl Child Abduction Remedies Act)","42:12101":"42:12101 (42:12101 Americans With Disability Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (Prisoner Civil Rights)","42:1985":"42:1985 (Conspiracy to Interfere with Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000cc":"42:2000cc (42:2000 Religious Land Use and Institutionalized Person Act (RLUIPA))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accommodations))","42:2000ra":"42:2000ra (42:2000ra Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:31325":"46:31325 (46:31325 Preferred Mortgage Liens & Enforcement)","47:0521":"47:0521 (47:0521 Cable Communications Policy Act)","47:0605":"47:0605 (47:0605 Unauthorized publication or use of communications)","47:227":"47:227 (47:227 Telephone Consumer Protection Act)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:14706":"49:14706 (49:14706 Cargo Damage Claim - Interstate Commerce Act)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99999":"99999 (Complaint for Forfeiture)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","adsup":"adsup (Administrative Subpoena)","apptcnsl":"apptcnsl (Motion for appointment of counsel)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","fordepo":"fordepo (Foreign Deposition)","gjproc":"gjproc (Grand Jury Proceeding)","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","writgar":"writgar (Application for a Writ of Garnishment)"},"nddce":{"02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (07:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (07:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:0287":"08:0287 (08:287 Petition to Enforce INS Subpoena)","08:1105":"08:1105 (08:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1446":"08:1446 (08:1446 Petition for Naturalization Hearing)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (09:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:10 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection under Contract Guaranty)","12:1751":"12:1751 (12:1751 Federal Credit Union Act)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:45 Federal Trade Commission Act)","15:0052":"15:0052 (15:52 Federal Trade Commission Act)","15:0053":"15:0053 (15:53 Federal Trade Commission Act)","15:0053b":"15:0053b (15:53(b) Prelim & Perm Inj Relief & Other Equitable Relief)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision-DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1514":"18:1514 (Restrain Harassment of a Victim/Witness)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1302":"25:1302 (25:1302 Tribal Constitutional Rights)","25:1303":"25:1303 (25:1303 Tribal Habeas Corpus)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:157(c)(1) Findings, Conclusion & Proposed Judgment)","28:0157d":"28:0157d (28:157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:158 Notice of Appeal re Bankruptcy Matter (BAP))","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 ERISA)","28:1132":"28:1132 (28:1132 ERISA)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Fed. Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed. Question: Fed. Communications Act - 1934)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Fed. Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Fed. Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-Citizenship)","28:1332det":"28:1332det (28:1332 Diversity-Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity-Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering Act (RICO))","28:1332sa":"28:1332sa (28:1332 Diversity-Securities & Exchange Commission Act)","28:1332sf":"28:1332sf (28:1332 Diversity-Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-core))","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal- Employment Discrimination)","28:1441fc":"28:1441fc (28:1441 Petition for Removal- Fair Credit Reporting Act)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interpleader)","28:1441lb":"28:1441lb (28:1441 Petition for Removal- Libel, Assault, Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition for Removal- Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)","28:1441sa":"28:1441sa (28:1441 Petition for Removal- SEC Act)","28:1441sf":"28:1441sf (28:1441 Petition for Removal- Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446 Petition for Removal- Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0790":"29:0790 (29:790 Rehabilitation of Labor)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 ERISA - Employee Retirement)","29:1002":"29:1002 (29:1002 ERISA - Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 ERISA - Employee Benefits)","29:1145":"29:1145 (29:1145 ERISA)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 ERISA)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 ERISA)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 ERISA)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2601":"29:2601 (Family and Medical Leave Act of 1993)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:801 Penalties/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 Veteran's Readjustment Assistance Act - 1974)","38:3116":"38:3116 (38:3116 VA Overpayment)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:12101":"42:12101 (42:12101 Disabilities Act of 1990)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief-Foreclosure Sale)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000 Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:3601 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:0945":"43:0945 (43:945 Compensation for Land Condemnation)","43:0945a":"43:0945a (43:945 Complaint in Condemnation)","43:0946":"43:0946 (43:946 Complaint in Condemnation - Eminent Domain)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:252":"47:252 (47:252 Telecommunications Act of 1996)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to Enforce Administrative Summons)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"nedce":{"0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown )","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8902":"05:8902 (05:8902 Health Insurance - Govt Organizations and Employees)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:1508":"07:1508 ( 07:1508 Crop Insurance)","07:1631":"07:1631 (07:1631 Food Security Act of 1985)","07:2023":"07:2023 (07:2023 Food Stamp Program)","07:2131":"07:2131 (07:2131 Animal Welfare Act)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1154":"08:1154 (08:1154 Immigration and Nationality Act)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451":"08:1451 (8:1451 Revocation of Naturalization Proceedings)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2005":"10:2005 (10:2005 Advanced Education Assistance)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1751":"12:1751 (12:1751 Federal Credit Union Act)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1691":"15:1691 (15:1691 Equal Credit Opportunity Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1241":"16:1241 (16:1241 National Trails System Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","17:0512":"17:0512 (17:512 Digital Millennium Copyright Act)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0925":"18:0925 (18:925 Firearm)","18:1345":"18:1345 (18:1345 Injunctions against fraud)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2520":"18:2520 (18:2520 Interception of Electronic Communication)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","19:1584":"19:1584 (19:1584 Tariff Act of 1930)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0601":"21:0601 (21:601 Federal Meat Inspection Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881j":"21:0881j (21:0881j Forfeiture Property - Gambling)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","24:4072":"24:4072 (24:4072 Federal Flood Insurance Claim)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","25:2701":"25:2701 (25:2701 Indian Gaming Regulatory Act (IGRA))","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:13345fa":"28:13345fa (28:1345 Recover of FAA - fine or penalty)","28:1334ab":"28:1334ab (28:1334ab Civil Proceeding (BK))","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fa":"28:1345fa (28:1345 Recover of FAA - fine or penalty )","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1404":"28:1404 (28:1404 Registration of Judgment)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1491":"28:1491 (28:1491 Tucker Act)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Assistance to Foreign Tribunals)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2242":"28:2242 (28:2242 Petition for Writ of Habeas Corpus)","28:2244":"28:2244 (28:2244 Finality of Determination)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3203":"28:3203 (28:3203 Postjudgment Remedies: Writ of Execution)","28:3301":"28:3301 (28:3301 Fraudulent Transfer Federal Debt Collection Procedures Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2601":"29:2601 (29:2601 Family Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4301":"38:4301 (38:4301 Veterans' Reemployment Rights Act)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:03131":"40:03131 (40:3131 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405":"42:0405 (42:0405 Review of HHS Decision)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:12101":"42:12101 (42:12101 Americans with Disabilities Act)","42:12131":"42:12131 (42:12131 Americans with Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:13981":"42:13981 (42:13981 Violence Against Women Act)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1982":"42:1982 (42:1982 Property Rights of Citizens)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1985":"42:1985 (42:1985 Conspiracy to interfere with civil rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:3601 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","42:9613":"42:9613 (42:9613(b) CERCLA)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0153":"45:0153 (45:153 National Railroad Adjustment Board)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:0201":"47:0201 (47:0201 Telecommunications - Service and charges)","47:0251":"47:0251 (47:0251 Telecommunications Act of 1996)","47:0607":"47:0607 (47:0607 Communications Act of 1934)","47:553":"47:553 (47:553 Unauthorized reception of cable service)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","49:32701":"49:32701 (49:32701 Federal Odometer Act)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"nhdce":{"0":"0 (No cause code entered)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits )","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:0608":"07:0608 (07:608(a) Agriculture Marketing Agreement Act)","07:2023":"07:2023 (07:2023 Supplemental Nutrition - Restoration of Rights)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1421":"08:1421 (8:1421 Review of Naturalization Decision)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1447":"08:1447 (8:1447 Hearings on Denials of Applications for Naturalization)","08:1451(a)":"08:1451(a) (08:1451(a) Complaint for Revocation of Naturalization )","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement )","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2005":"10:2005 (Advanced Education Assistance Active Duty Agreement)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan )","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:191":"12:191 (12:191 Bank Foreclosure )","12:192":"12:192 (12:192 Liquidation of National Bank )","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act )","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement )","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1691":"15:1691 (Equal Credit Opportunity Act )","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693":"15:1693 (15:1693 Electronic Funds Transfer Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2601":"15:2601 (15:2601 Control of Toxic Substances)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:0823":"16:0823 (16:0823 Federal Power Act )","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","16:791a":"16:791a (16:791a Federal Power Act)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0924":"18:0924 (18:0924 Firearms Penalties)","18:0981":"18:0981 (18:0981 Forfeiture Property )","18:1030":"18:1030 (18:1030 Computer Fraud and Abuse Act)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2511":"18:2511 (18:2511 Wiretapping )","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property )","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1071":"20:1071 (20:1071 Higher Education Act 1965)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1415":"20:1415 (20:1415 Education: Handicapped Child Act )","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0842":"21:0842 (21:U.S.C. 842 - Drug Diversion - Controlled Substance )","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881oth":"21:0881oth (21:881 Forfeiture Property - Other)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:0036":"26:0036 (26:36 IRS - First-Time Homebuyer Credit)","26:2207":"26:2207 (26:2207 Liability of Recipient of Property)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts )","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment )","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act )","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal )","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff )","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party )","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal )","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle)","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal )","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal )","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:157b":"28:157b (Tort-Personal Injury/Wrongful Death Claims )","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment )","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:2675":"28:2675 (28:2675 Federal Tort Claims Act )","28:3001":"28:3001 (28:3001 Federal Debt Collection Act )","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2601":"29:2601 (29:2601Family and Medical Leave)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (Right to re-employment of inducted persons )","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4301":"38:4301 (Uniformed Services Employment and Reemployment Rights Act)","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance )","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0297n":"42:0297n (42:297n Public Health Loan Repayment Scholarship)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11601":"42:11601 (42:11601 International Child Abduction)","42:12101":"42:12101 (42:12101 Americans With Disabilities Act )","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000da":"42:2000da (42:2000 Job Discrimination (ADA 1990) )","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2601":"42:2601 (42:2601 Family and Medical Leave Act of 1993)","42:2615":"42:2615 (42:2616 Medical Recovery Act )","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:4852d":"42:4852d (42:4852d Disclosure of Information Concerning Lead Upon Transfer of Residential Property)","42:6901":"42:6901 (Environmental Cleanup Expenses )","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9604":"42:9604 (42:9604 Response Authorities (CERCLA))","42:9607":"42:9607 (42:9607 Real Property Tort to Land (CERCLA))","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:0332":"47:0332 (47:332 Federal Telecommunications Act of 1996 )","47:227":"47:227 (47:227 Telephone Consumer Protection Act)","47:553":"47:553 (47:553 Unauthorized Reception of Cable Service)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:1105(a)":"8:1105(a) (Aliens: Habeas Corpus to Release INS Detainee )","8:1183(a)":"8:1183(a) (8:1183(a) Aliens: Requirements for Sponsor's Affidavit of Support)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!) )","adsup":"adsup (Administrative Subpoena )","contempt":"contempt (Contempt Proceedings )","disbar":"disbar (Disbarment Proceedings )","fordepo":"fordepo (Foreign Deposition )","mifp":"mifp (Motion to proceed IFP )","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel )","motquash":"motquash (Motion to Quash )","motret":"motret (Motion for Return of Property )","petenf":"petenf (Petition to Enforce IRS Summons )","petper":"petper (Petition to Perpetuate Testimony )","regjgm":"regjgm (Registration of Foreign Judgment )","tranbkref":"tranbkref (Transmission of Bankruptcy Reference )","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law )","writgar":"writgar (Application for a Writ of Garnishment )"},"njdce":{"0":"0 (No cause code entered)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451(j)":"08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:191":"12:191 (12:191 Bank Foreclosure)","12:192":"12:192 (12:192 Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Tying Arrangement Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:157(3)":"18:157(3) (18:157(3) Bankruptcy Fraud)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2511":"18:2511 (18:2511 Wiretapping)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7402a":"26:7402a (26:7402(a) Injunctive Relief - Internal Revenue Code)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331ij":"28:1331ij (28:1331 Federal Question-Injunctive & Declaratory Relief)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345ij":"28:1345ij (28:1345ij Injunction Relief)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Notice of Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Notice of Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Notice of Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Notice of Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Notice of Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Notice of Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Notice of Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Notice of Removal- Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441 Notice of Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Notice of Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Notice of Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Notice of Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Notice of Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Notice of Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Notice of Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Notice of Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Notice of Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Notice of Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Notice of Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Notice of Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Notice of Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Notice of Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Notice of Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Notice of Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Notice of Removal)","28:1441qt":"28:1441qt (28:1441 Notice of Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Notice of Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Notice of Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Notice of Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Notice of Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Notice of Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Notice of Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Notice of Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Notice of Removal- Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Notice of Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Notice of Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Notice for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Notice for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Notice for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Notice for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2601":"29:2601 (29:2601 Family Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","375/1":"375/1 (375/1 (False Claims Act - U.S. Plaintiff))","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:3131":"40:3131 (40:3131 Miller Act)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:12101":"42:12101 (42:12101 Americans with Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","42:9613":"42:9613 (42:9613 CERCLA)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0185":"46:0185 (46:0185 PETITION FOR LIMITATION LIABILITY)","46:0688":"46:0688 (46:688 Jones Act)","46:0740":"46:0740 (46:0740 DAMAGE OR INJURY CAUSED BY VESSEL)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:227":"47:227 (47:227 FCC-Unsolicited Telephone Sales)","47:227(b)":"47:227(b) (47:227(b)(3) Telephone Consumer Protection Act of 1991)","47:251":"47:251 (47:251 Telecommunications Act of 1996 - Interconnection)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","adsup":"adsup (Administrative Subpoena)","attydisc":"attydisc (Attorney Discipline)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","fordepo":"fordepo (Foreign Deposition)","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","writgar":"writgar (Application for a Writ of Garnishment)"},"nmdce":{"0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-core))","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1350":"28:1350 (28:1350 Alien's Action for Tort)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrimination)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting Act)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interpleader)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act - 1977)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)","38:3116":"38:3116 (38:3116 VA Overpayment)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:425":"42:425 (42:427 Social Security Benenfits)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summons)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"nmidce":{"0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451a":"08:1451a (Revocation of Naturalization - Title 8 USC 1451(a))","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-core))","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgement)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrimination)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting Act)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interpleader)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act - 1977)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","33:901":"33:901 (33:901 Longshoremen & Harbor Worker's Comp Act)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)","38:3116":"38:3116 (38:3116 VA Overpayment)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:12101":"42:12101 (42:12101 Violation of Americans with Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1985":"42:1985 (42:1985 Civil Rights Act)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:190":"46:190 (46:190 INDEMNITY UNDER THE GENERAL MARITIME LAW)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1424":"48:1424 (48:1424 The Organic Act of Guam)","48:1983":"48:1983 (48:1983 Civil Rights)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summons)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","MiscCause":"MiscCause (Civil Miscellaneous Case)","Rule9H":"Rule9H (Breach of Contract - Maritime Rule 9(h))","misc":"misc (Civil Miscellaneous Case)"},"nvdce":{"0":"0 (No cause code entered)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0411":"29:0411 (29:0411 Labor Organizations)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11601":"42:11601 (42:11601 International Child Abduction Remedies Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:227":"47:227 (47:227 Telephone Consumer Protection Act)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"nyedce":{"0":"0 (00:0000)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","02:1202":"02:1202 (Discriminatory practices affecting US Senate employees)","02:1301":"02:1301 (Congressional Accountability Act)","02:1317(a)":"02:1317(a) (Violation of Congressional Account Ability Act)","02:138":"02:138 (Library of Congress Access)","02:358":"02:358 (President's Recommendations on Exec., Jud. & Leg. Salary)","02:431":"02:431 (Federal Election Commision: Failure to Enforce Compliance)","02:437":"02:437 (Federal Election Commision)","02:681":"02:681 (Deferral of Budget Authority)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0554a":"05:0554a (05:0554 Adjudications)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0701jr":"05:0701jr (05:0701jr Judicial Review)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits )","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451(j)":"08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization )","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement )","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan )","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:191":"12:191 (12:191 Bank Foreclosure )","12:192":"12:192 (12:192 Liquidation of National Bank )","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act )","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement )","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:45":"15:45 (15:45 Federal Trade Commission Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1836a":"18:1836a (18:1836(a) - Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) - Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2510":"18:2510 (APPLICATION FOR INTERCEPTION OF WIRE OR ORAL COMMUNICATIONS )","18:2511":"18:2511 (18:2511 Wiretapping )","18:2701":"18:2701 (STORED WIRE AND ELECTRONIC COMMUNICATIONS )","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts )","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment )","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act )","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal )","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff )","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party )","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal )","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal )","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal )","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment )","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act )","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","31:5221":"31:5221 (31:5221 Foreign Bank Account Penalties)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (Right to re-employment of inducted persons )","38:3116":"38:3116 (38:3116 VA Overpayment)","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance )","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11601":"42:11601 (42:11601 - INTERNATIONAL CHILD ABDUCTION REMEDIES)","42:1201":"42:1201 (42:1201 Civil Rights (Disability) )","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2615 Medical Recovery Act )","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:227b3":"47:227b3 (47:227(b)(3) Telephone Consumer Protection Act of 1991)","47:605":"47:605 (47:605 Unauthorized publication or use of communications)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:287":"8:287 (08:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE) )","adsup":"adsup (Administrative Subpoena )","contempt":"contempt (Contempt Proceedings )","disbar":"disbar (Disbarment Proceedings )","discpro":"discpro (Disciplinary Proceedings )","fordepo":"fordepo (Foreign Deposition )","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","petenf":"petenf (Petition to Enforce IRS Summons )","petper":"petper (Petition to Perpetuate Testimony )","regjgm":"regjgm (Registration of Foreign Judgment )","tranbkref":"tranbkref (Transmission of Bankruptcy Reference )","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law )","writgar":"writgar (Application for a Writ of Garnishment )"},"nyndce":{"0":"0 (No cause code entered)","02:0138":"02:0138 (02:0138 Library of Congress Access)","02:0358":"02:0358 (02:0358 President's Recommendations on Exec., Jud. & Leg. Salary)","02:0431":"02:0431 (02:431 Federal Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","02:0681":"02:0681 (02:0681 Deferral of Budget Authority)","02:1202":"02:1202 (02:1202 Discriminatory practices affecting US Senate employees)","02:1301":"02:1301 (02:1301 Congressional Accountability Act)","02:1317a":"02:1317a (02:1317(a) Violation of Congressional Accountability Act)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0101":"05:0101 (05:0101 Ethics in Government Act)","05:0504c2":"05:0504c2 (05:0504(c)(2) Equal Access to Justice (Govt Employees))","05:0551":"05:0551 (05:551 Administrative Procedures Act)","05:0552bsa":"05:0552bsa (05:0552b(g) Implement requirements of Govt in Sunshine Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Adjudications Required by Statutes)","05:0555b":"05:0555b (05:0555(b) Agency Decision - Right to Counsel)","05:0701":"05:0701 (05:0701 Judicial Review of Agency Decision)","05:0702":"05:0702 (05:702 Administrative Procedure Act - Right of Review)","05:0704":"05:0704 (05:704 Labor Litigation)","05:0706":"05:0706 (05:0706 Judicial Review of Agency Action)","05:1508":"05:1508 (05:1508 Judicial Review of Order Issued by the Merit Systems Protection Board)","05:2302":"05:2302 (05:2302 Federal Whistleblowing Act / Civil Service Reform Act (CSRA))","05:3318":"05:3318 (05:3318 Veterans Preference Act)","05:5514":"05:5514 (05:5514 Debt Collection Act of 1982)","05:5542":"05:5542 (05:5542 Federal Employees Pay Act -- overtime rates)","05:7101":"05:7101 (05:7101 Labor-Management Relations (Findings and Purpose))","05:7123":"05:7123 (05:7123 Petition by FLRA against unfair labor practices)","05:7501":"05:7501 (05:7501 Government Employees Adverse Action--14 days or less)","05:7511":"05:7511 (05:7511 Government Employees Adverse Action--Over 14 days)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8101":"05:8101 (05:8101 Workmen's Compensation Benefits)","05:8110":"05:8110 (05:8110 Augmented Compensation for dependents of Govt. Employees)","05:8316":"05:8316 (05:8316 Claims against US regarding Retirement for Federal Employees)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","05:8701":"05:8701 (05:8701 Federal Employees Group Life Insurance Act of 1954)","05:8705":"05:8705 (05:8705 Declaratory Judgment - Insurance)","05:8715":"05:8715 (05:8715 Claims against the US - Jurisdiction of Courts)","05:8901":"05:8901 (05:8901 Federal Employees Health Benefits Act)","05:8902":"05:8902 (05:8902 Contracting Authority of OPM - Group Health Insurance)","05:8903":"05:8903 (05:8903 Federal Employees Health Benefit Act)","05:8912":"05:8912 (05:8912 Claims against US regarding health benefits for Federal employees)","07:0001":"07:0001 (07:0001 Commodity Exchange Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0009a":"07:0009a (07:0009a Recovery of penalties by Commodity Futures Trading Comm)","07:0013a":"07:0013a (07:0013a Contract market rules violations; recovery of penalty)","07:0013a-1":"07:0013a-1 (07:0013a-1 Enjoin or restrain violations Contract Market rules)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0087":"07:0087 (07:0087 Enforcement of United States Grain Standards Act)","07:0136":"07:0136 (07:0136 Violations of EPA re Environmental Pesticide Control)","07:0181":"07:0181 (07:181 Packers & Stockyards Act)","07:0193b":"07:0193b (07:0193(b) Recovery of penalties re violations by packers)","07:0203":"07:0203 (07:0203 Recovery of penalties for violations by stockyards)","07:0209(b)":"07:0209(b) (07:0209(b) Violations re purchase, sale, handling of livestock)","07:0210(f)":"07:0210(f) (07:0210(f) Suit to enforce award of damages (Packers/Stockyards))","07:0213(b)":"07:0213(b) (07:0213(b) Unfair, discriminatory, deceptive practice/marketing)","07:0216":"07:0216 (07:0216 Injunctions to restrain & enforce orders of Secretary)","07:0222":"07:0222 (07:0222 Adoption of FTC powers for enforcement)","07:0228a":"07:0228a (07:0228a Request by Secretary for TRO or Inj. re Poultry)","07:0245":"07:0245 (07:0245 Action on bond by person injured in Warehouse)","07:0292":"07:0292 (07:0292 Monopolizing or restraining trade & enhancing prices)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0499Ec4":"07:0499Ec4 (07:0499E(c)(4) Perishable Agricultural Commodities Act (PACA))","07:0601":"07:0601 (07:601 USDA Condemnation)","07:0608":"07:0608 (07:0608 Agriculture Adjustment Act)","07:0901":"07:0901 (07:0901 Rural Electrification Act)","07:1291(b)":"07:1291(b) (07:1291(b) Agricultural Adjustment Act; freight rates)","07:1376":"07:1376 (07:1376 Adjustment of Quotas and Enforcement; penalties)","07:1501":"07:1501 (07:1501 Federal Crop Insurance Act)","07:1508":"07:1508 (07:1508 Crop Insurance)","07:1631":"07:1631 (07:1631 Food Security Act)","07:1721":"07:1721 (07:1721 Agricultural Trade Development Asst Act)","07:1922":"07:1922 (07:1922 Persons Eligible for Loans - Foreclosure)","07:1926":"07:1926 (07:1926 Water and Waste Facility Loans and Grants)","07:1930":"07:1930 (07:1930 Perishable Agric. Comm. Act of 1930)","07:2011":"07:2011 (07:2011 Supplemental Nutrition Assistance Program)","07:2022":"07:2022 (07:2022 Disposition of Claims: Denial application to participate; food stamp prog.)","07:2023":"07:2023 (07:2023 Supplemental Nutrition Assistance Program)","07:2023(a)":"07:2023(a) (07:2023(a) Judicial Review of Food Stamp Disqualification)","07:2024":"07:2024 (07:2024 False Claims Act, Food Stamp Fraud)","07:2131":"07:2131 (07:2131 Violation of the Animal Welfare Act)","07:2146":"07:2146 (07:2146 Transportation, Sale, and Handling of Animals)","07:2301":"07:2301 (07:2301 Agricultural Fair Practices Act)","07:2305":"07:2305 (07:2305 Unfair trade practices affecting producers Agri prod)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","07:2563":"07:2563 (07:2563 Plant Variety Protection and Rights - Injunction)","07:6999":"07:6999 (07:6999 Judicial Review of Adverse Farm Agency Decision)","08:1101":"08:1101 (08:1101 Immigration & Nationality Act (Definitions))","08:1105":"08:1105 (08:1105a Immigration: Judicial Review for Battered Spouses; Deportation (INS))","08:1152":"08:1152 (08:1152 Immigration: Numerical limitations on individual foreign states)","08:1153":"08:1153 (08:1153 Immigration: Allocation of Immigrant Visas)","08:1154":"08:1154 (08:1154 Immigration: Procedure for Granting Immigration Status)","08:1158":"08:1158 (08:1158 Immigration & Nationality Act, Section 208 (Asylum))","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1183":"08:1183 (08:1183 Admission of Aliens on Giving Bond or Undertaking; Return on Departure)","08:1183a":"08:1183a (08:1183a Requirements for sponsor's affidavit of support)","08:1188":"08:1188 (08:1188 Immigration: Admission of Temporary H-2A Workers)","08:1225":"08:1225 (08:1225 Immigration: Enforcement of Administrative Subpoena)","08:1231a6":"08:1231a6 (08:1231(a)(6) Immigration: Due Process Clause)","08:1251a4":"08:1251a4 (08:1251(A)(4) Immigration: Application for a Stay of Deportation)","08:1252":"08:1252 (08:1252 Judicial Review of Orders of Removal)","08:1255":"08:1255 (08:1255 Immigration: Failure USCIS to Adjudicate Permanent Residency Petition)","08:1260":"08:1260 (08:1260 Aliens: Removal of Aliens Falling into Distress)","08:1324":"08:1324 (08:1324 Immigration: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Immigration: Writ of Mandamus to Adjudicate Visa Petition)","08:1357":"08:1357 (08:1357 Immigration and Nationality Act - Administrative Search Warrant)","08:1421":"08:1421 (08:1421 Immigration: Naturalization Authority)","08:1445":"08:1445 (08:1445 Immigration: Application for Naturalization)","08:1446":"08:1446 (08:1446 Immigration: Petition for Naturalization Hearing)","08:1447":"08:1447 (08:1447 Immigration: Review of Denial of Naturalization Application)","08:1451":"08:1451 (08:1451 Immigration: Revocation of Citizenship)","08:1451(a)":"08:1451(a) (08:1451(a) Action to revoke Citizenship)","08:1451(j)":"08:1451(j) (8:1451(j) Immigration: Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0003":"09:0003 (09:0003 Application to Stay Proceedings Pending Arbitration)","09:0004":"09:0004 (09:0004 Petition to order arbitration; failure to arbitrate)","09:0007":"09:0007 (09:0007 Petition to compel attendance before arbitrator)","09:0008":"09:0008 (09:0008 Declaratory Judgment/Admiralty)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","09:0011":"09:0011 (09:0011 Motion to modify or correct arbitration award)","09:0201":"09:0201 (09:0201 Petition to Compel/Stay Arbitration under an Insurance Contract)","09:0202":"09:0202 (09:0202 Award under Convention on Foreign Arbitral Awards)","09:0205":"09:0205 (09:0205 Removal from State Court: Enforcement of Foreign Arbitral Awards)","09:0207":"09:0207 (09:0207 Application for order confirming award of arbitrators)","10:0672":"10:0672 (10:0672 Armed Forces: Active Guard/Reserve (AGR) Program)","10:1006":"10:1006 (10:1006 Armed Forces: Review of Agency Decision)","10:1072tc":"10:1072tc (10:1072tc Armed Forces: TRICARE PROGRAM)","10:1089(c)":"10:1089(c) (10:1089(c) Armed Forces: Removal; dft acting in scope of duties)","10:1091":"10:1091 (10:1091 Armed Forces: Personal Service Contracts)","10:1107":"10:1107 (10:1107 Armed Forces: Use Of Investigational New Drug)","10:1408":"10:1408 (10:1408 Armed Forces: Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: Review of Discharge or Dismissal)","10:2005":"10:2005 (10:2005 Armed Forces: Advanced Education Assistance)","10:2121":"10:2121 (10:2121 Armed Forces: Health Professions Scholarship Financial Asst Prog)","10:2302":"10:2302 (10:2302 Armed Forces: Arms Services Procurement Act)","10:2305":"10:2305 (10:2305 Armed Forces: Review of Federal Contract)","10:2323fa":"10:2323fa (10:2323fa Armed Forces: Fifth Amdmt Equal Protection: Contract Goal for Small Disadvantaged Business)","10:2733":"10:2733 (10:2733 Armed Forces: Military Claims Act)","10:2734":"10:2734 (10:2734 Armed Forces: Foreign Military Claims Act)","10:2771":"10:2771 (10:2771 Armed Forces: Final Settlement - Deceased Members)","10:3258":"10:3258 (10:3258 Armed Forces: Reg. Army: Re-enlistment after Service as Ofcr)","11:0101":"11:0101 (11:101 Bankruptcy)","11:0110":"11:0110 (11:110 Bankruptcy: Penalty for Preparers of Fraudulent or Negligent Petitions)","11:0362":"11:0362 (11:362(h) Bankruptcy: Violation of Automatic Stay)","11:0523":"11:0523 (11:523 Bankruptcy: Exceptions to Discharge)","11:0524":"11:0524 (11:524 Bankruptcy: Effect of Discharge)","11:0525":"11:0525 (11:525 Bankruptcy: Protections Against Discriminatory Treatment)","11:0548":"11:0548 (11:548 Bankruptcy: Fraudulent Transfers and Obligations)","11:0704":"11:0704 (11:704 Bankruptcy: Duties of Trustee)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0085":"12:0085 (12:85 National Banks: Rate of Interest on Loans, Discounts, and Purchases)","12:0093":"12:0093 (Banks: Violation of Provisions; Forfeiture of Franchise; Personal Liability of Dir)","12:0191":"12:0191 (12:191 National Banks: Appointment of Receiver)","12:0192":"12:0192 (12:192 National Banks: Liquidation of National Bank)","12:0215":"12:0215 (12:215 National Banks: Consolidation and Merger)","12:0622":"12:0622 (12:622 Foreign Banking: Forfeiture, Dissolution, and Liability of Directors and Officers for Noncomp)","12:0632":"12:0632 (12:632 Foreign Banking: Voluntary Liquidation)","12:0635":"12:0635 (12:635i-3 Export-Import Bank: Breach of Insurance Contract)","12:1421":"12:1421 (12:1421 Federal Home Loan Bank Act (Short Title))","12:1441":"12:1441 (12:1441 FHLB: Financial Inst Reform Receiving Enforcement Act 1989)","12:1451":"12:1451 (12:1451 Emergency Home Loan Corporation)","12:1452":"12:1452 (12:1452 Federal Home Loan Mortgage Corporation Act)","12:1452f":"12:1452f (12:1452(f) Fed Home Loan Mortgage Corp: Actions by and against the Corporation)","12:1455b":"12:1455b (12:1455(b) Fed Home Loan Mortgage Corp: Enforcement of Regulations)","12:1461":"12:1461 (12:1461 Savings Associations: Homeowners Loan Act (Short Title))","12:1464":"12:1464 (12:1464 Savings Associations: Federal Savings and Loan)","12:1703":"12:1703 (12:1703 National Housing: Insurance of Financial Institutions)","12:1715b":"12:1715b (12:1715(b) National Housing: Rules and Regulations)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1749aaa":"12:1749aaa (12:1749aaa National Housing: National Insurance Development Program)","12:1751":"12:1751 (12:1751 Fed Credit Unions: Short Title)","12:1782":"12:1782 (12:1782 Fed Credit Unions: Administration of Insurance Fund)","12:1786":"12:1786 (12:1786 Fed Credit Unions: Actions re Violations by Credit Unions)","12:1787aB":"12:1787aB (12:1787(a)(B) Fed Credit Unions: Liquidation of Insured Credit Union by Board)","12:1789a2":"12:1789a2 (12:1789(a)(2) Fed Credit Unions: Admin Provision to Sue and be Sued)","12:1811":"12:1811 (12:1811 FDIC: Financial Inst. Reform Recovery Act of 1989 (FIRREA)(Organization of FDIC))","12:1818":"12:1818 (12:1818 FDIC: Violations re Federal Deposit Insurance Corporation)","12:1818e":"12:1818e ()","12:1819":"12:1819 (12:1819 FDIC: Corporate Powers)","12:1821":"12:1821 (12:1821 FDIC: Insurance Funds)","12:1831":"12:1831 (12:1831 FDIC: Separability of Certain Provisions)","12:1831d":"12:1831d (12:1831(d) FDIC: Deposit. Inst. Dereg. & Monetary Ctrl. Act of 1980)","12:1831r-1":"12:1831r-1 (12:1831r-1 FDIC: Notice of Branch Closure)","12:1833a":"12:1833a (12:1833(a) FDIC: Forfeiture Civil Penalties)","12:1954":"12:1954 (12:1954 Injunctions (Action by Sec of Treasury re financial recordkeeping))","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Tying Arrangement Act)","12:2001":"12:2001 (12:2001 Farm Credit Act of 1971)","12:2601":"12:2601 (12:2601 Real Estate Settlement Procedures Act (RESPA))","12:2604c":"12:2604c (12:2604(c) Real Estate Settlement Procedures Act (RESPA))","12:2605":"12:2605 (12:2605 RESPA: Servicing of Mortgage Loans)","12:2607":"12:2607 (12:2607 RESPA: Violation re kickbacks/unearned fees; Real Estate)","12:2609":"12:2609 (12:2609 RESPA: Escrow)","12:3012":"12:3012 (12:3012 National Consumer Cooperative Bank: Suits by or against Bank)","12:3410":"12:3410 (12:3410 Right to Financial Privacy: Customer Challenges)","12:3751":"12:3751 (12:3751 Single Family Mortgage Foreclosure Act: Findings and Purpose)","12:3801":"12:3801 (12:3801 Alternative Mortgage Transaction Parity Act)","12:3907":"12:3907 (12:3907 International Lending Supervision: Capital Adequacy)","12:4010":"12:4010 (12:4010 Expedited Funds Availability: Violation of Act (Civil Liability))","12:5101":"12:5101 (12:5101 Fraudulent Transfer Act (Enforcement for Mortgage Licensing))","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2fl Antitrust Litigation)","15:0004":"15:0004 (15:4 USDC Jurisdiction re violations of Sec. 1-7 of Title 15)","15:0005":"15:0005 (15:5 Bringing in Additional Parties)","15:0009":"15:0009 (15:9 USDC Jurisdiction re violations of Sec. 8 of Title 15)","15:0013":"15:0013 (15:13 Robinson Patman Act)","15:0014":"15:0014 (15:14 Clayton Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0026":"15:0026 (15:26 Suit for injunctive relief re violation antitrust laws)","15:0034-35":"15:0034-35 (15:34-35 Investment Company Act of 1940)","15:0041":"15:0041 (15:41 Federal Trade Commission Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:45 Federal Trade Commission Act)","15:0045cp":"15:0045cp (15:45cp Violation of Children Online Privacy Protection Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:53 Federal Trade Commission Act)","15:0053(b)":"15:0053(b) (15:53(b) Prelim & Perm Inj Relief & other Equitable Relief)","15:0068":"15:0068 (15:68 Proceedings re FTC violations re wool products)","15:0069":"15:0069 (15:69 Proceedings re FTC violations re fur products)","15:0070":"15:0070 (15:70 Proceedings re FTC violations re textile fiber product)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0078jbs":"15:0078jbs (15:78j(b)ss Stockholder Suit)","15:0078ma":"15:0078ma (15:78m(a) Securities Exchange Act)","15:0079":"15:0079 (15:79 Public Utility Holding Companies)","15:0080a3":"15:0080a3 (15:80a-3 Investment Company Act of 1940)","15:0260":"15:0260 (15:260 Proceedings re weights and measures and standard time)","15:0298":"15:0298 (15:298 Violation of Law Proceedings re gold or silver)","15:0433":"15:0433 (15:433 Discrimination against farmers)","15:0631":"15:0631 (15:631 Small Business Act)","15:0636":"15:0636 (15:636 Small Business Act - Aid to small business)","15:0661":"15:0661 (15:661 Small Business Investment Act of 1958)","15:0687":"15:0687 (15:687 Small Business Investment Program)","15:0714(b)":"15:0714(b) (15:714(b) Commodity Credit Corporation)","15:0715(f)":"15:0715(f) (15:715(f) Proceedings re petroleum and petroleum products)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0719ic":"15:0719ic (15:719i(c) Civil actions re violations or inj involving Gas)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:0766":"15:0766 (15:766 Controversies arising re Federal Energy Admin rules)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1071":"15:1071 (15:1071 Appeal of Decision of U.S. Patent & Trademark Office (Comm / Trademark Trial))","15:1114":"15:1114 (15:1114 Trademark Infringement (Lanham Act))","15:1116":"15:1116 (15:1116 Inj to prevent violation rights of trademark owner)","15:1120":"15:1120 (15:1120 Trademark - False or Fraudulent Registration)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1125(a)":"15:1125(a) (15:1125(a) False representation of goods sold in interstate commerce)","15:1125dac":"15:1125dac (15:1125(d)ac Trademark (anticybersquatting consumer protection))","15:1125la":"15:1125la (15:1125la Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Trademarks - International conventions)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1191":"15:1191 (15:1191 Flammable Fabrics Act)","15:1221":"15:1221 (15:1221 Auto Dealer Suits Against Manufacturers)","15:1261":"15:1261 (15:1261 Hazardous Substances)","15:1263":"15:1263 (15:1263 Prohibited Hazardous Substance - Interstate Commerce)","15:1267(a)":"15:1267(a) (15:1267(a) Federal Hazardous Substances Act)","15:1314":"15:1314 (15:1314 Antitrust - Petition for enforcement)","15:1501":"15:1501 (15:1501 Establishment of Department of Commerce)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1605":"15:1605 (15:1605 Determination of Finance Charge)","15:1638":"15:1638 (15:1638 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1666":"15:1666 (15:1666 Fair Credit Billing Act Dispute)","15:1667":"15:1667 (15:1667 Consumer Leasing Act)","15:1679":"15:1679 (15:1679 Violation of Credit Repair Organizations Act)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1691":"15:1691 (15:1691 Equal Credit Opportunity Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693":"15:1693 (15:1693 Electronic Fund Transfer Act)","15:1693ef":"15:1693ef (15:1693ef Electronic Funds Transfer Act)","15:1693m":"15:1693m (15:1693m Violation of Prov. of Subchpt. VI (Electronic Fund Transfers))","15:1701":"15:1701 (15:1701 Interstate Land Sales Full Disclosure Act (ILFFDA))","15:1709":"15:1709 (15:1709 Interstate Land Sales)","15:1714":"15:1714 (15:1714 Actions to enjoin violations re interstate land sale)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2071":"15:2071 (15:2071 Consumer Product Safety; Condemnation hazardous prod)","15:2073":"15:2073 (15:2073 Private action to enforce Consumer Product Safety)","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2310(c)":"15:2310(c) (15:2310(c) Consumer Product Warranties)","15:2601":"15:2601 (15:2601 Toxic Substances Control Act (TCSA))","15:2604":"15:2604 (15:2604 Application for inj re distribution toxic substance)","15:2616":"15:2616 (15:2616 Toxic Substance control; seizure of chemical)","15:2620":"15:2620 (15:2620 Toxic Substances Control Act: citizen's petition)","15:2651":"15:2651 (15:2651 Asbestos Hazard Emergency Response Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:2805":"15:2805 (15:2805 Petroleum Marketing Practices-Franchise Protection)","15:3414":"15:3414 (15:3414 National Gas Policy Act)","15:3710a":"15:3710a (15:3710a Federal Technology Transfer Act of 1986)","15:3901":"15:3901 (15:3901 Federal Risk Retention Act)","15:6801":"15:6801 (15:6801 Gram-Leach-Bliley Act)","15:7701":"15:7701 (15:7701 Federal CAN-Spam Act)","16:0019jj":"16:0019jj (16:19jj Park System Resource Protection Act)","16:0470":"16:0470 (16:470 Archaeological Resources Protection Act)","16:0470f":"16:0470f (16:470f National Historic Preservation Act)","16:0668":"16:0668 (16:668 Bald and Golden Eagle Protection Act)","16:0669":"16:0669 (16:669 Pittman-Robertson Conservation Restoration Act)","16:0675":"16:0675 (16:675 Norbeck Wildlife Preserve Organic Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:0823a":"16:0823a (16:823a Federal Public Utility Regulatory Policies Act)","16:0825":"16:0825 (16:825 Federal Power Commission Regulation; Public Utilities)","16:0831":"16:0831 (16:831 Actions re: rights of Tennessee Valley Authority)","16:1244":"16:1244 (16:1244 National Scenic and National Historic Trails)","16:1374d6":"16:1374d6 (16:1374(d)(6) Petition for Review re Application for Import of Polar Bear Trophies)","16:1531":"16:1531 (16:1531 Endangered Species Act)","16:1533":"16:1533 (16:1533 Endangered Species Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:1540":"16:1540 (16:1540 Endangered Species Act - Penalties and Enforcement)","16:1600":"16:1600 (16:1600 National Forest Management Act of 1976)","16:1801":"16:1801 (16:1801 Magnuson-Stevens Fishery Conservation and Management Act)","16:1858":"16:1858 (16:1858 National Fishery Management Program - Civil Penalties and Permit Sanctions)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Lacey Act: Prohibited Acts)","16:3373":"16:3373 (16:3373 Lacey Act: Penalties and Sanctions - Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0201":"17:0201 (17:201 Ownership of Copyright)","17:0205d":"17:0205d (17:205(d) Priority Between Conflicting Transfers)","17:0407":"17:0407 (17:407 Recovery of fines & penalties by Register of Copyrights)","17:0411b":"17:0411b (17:411(b) Action by copyright owner for infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0502a":"17:0502a (17:502(a) Inj to prevent or restrain infringement copyright)","17:0504":"17:0504 (17:504 Remedies for Copyright Infringement)","17:0512":"17:0512 (17:512 Copyright Infringement of Digital Communications)","17:1201":"17:1201 (17:1201 Digital Millennium Copyright Act)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0492":"18:0492 (18:492 Forfeiture of Counterfeit Paraphernalia)","18:0603":"18:0603 (18:603 Conflict of Interest)","18:0922":"18:0922 (18:922 Firearms - Unlawful Possession (Civil Fines))","18:0923f3":"18:0923f3 (18:923(f)(3) Review of Revocation of a License as a Dealer in Firearms)","18:0925(c)":"18:0925(c) (18:925(c) Restoration of ability to possess firearms/ammo)","18:0981":"18:0981 (18:981 Civil Forfeiture)","18:0981a1A":"18:0981a1A (18:981(a)(1)(A) Civil Forfeiture: Money Laundering Control Act)","18:0983":"18:0983 (18:983 Civil Forfeiture - General Rules)","18:1028":"18:1028 (18:1028 Currency Used to Commit a Violation)","18:1030":"18:1030 (18:1030 Fraud and related activity in connection with computers)","18:1345":"18:1345 (18:1345 Injunction against Fraud)","18:1514":"18:1514 (18:1514 Civil Action to Restrain Harassment of a Victim)","18:1514A":"18:1514A (18:1514A Civil Action to Protect Against Retaliation in Fraud Cases)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1905":"18:1905 (18:1905 Disclosure of Confidential Information)","18:1955":"18:1955 (18:1955 Civil Forfeiture - Prohibition of Illegal Gambling)","18:1956b3":"18:1956b3 (18:1956(b)(3) Laundering of Monetary Instruments - Forfeit Property)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Civil Remedies: Racketeering (RICO) Act)","18:1968":"18:1968 (18:1968 Action re civil investigative demand)","18:2254":"18:2254 (18:2254 Civil Forfeiture - Exploitation of Children)","18:2333":"18:2333 (18:2333 Civil Remedies: Anti-Terrorism Act of 1991)","18:2511":"18:2511 (18:2511 Wiretapping - Injunctive Relief or Civil Fine)","18:2520":"18:2520 (18:2520 Civil Damages for Interception Wire or Oral Communications)","18:2707":"18:2707 (18:2707 Civil Action: Stored Communications)","18:2710(c)":"18:2710(c) (18:2710(c) Wrongful Disclosure of Video Tape Rental or Sales Records)","18:2724":"18:2724 (18:2724 Civil Action - Motor Vehicle Records)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:3184":"18:3184 (18:3184 Extradition Procedure)","18:3663":"18:3663 (18:3663 Civil Enforcement of Criminal Restitution Obligation)","18:3664e":"18:3664e (18:3664e Civil Enforcement of Crim. Restitution Obligation)","18:4100":"18:4100 (18:4100 Transfer of Offenders)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)","19:1497":"19:1497 (19:1497 Customs Duties: Penalty for Failure to Declare)","19:1595a":"19:1595a (19:1595a Customs Duties: Forfeiture and Other Penalties)","19:1607":"19:1607 (19:1607 Customs Duties: Notice of Seizure)","20:0107":"20:0107 (20:107 Randolph-Sheppard Vending Stand Act)","20:1070":"20:1070 (20:1070 Student Assistance)","20:1080":"20:1080 (20:1080 Default of Student Loan: Recovery)","20:1087":"20:1087 (20:1087 Student Loan Discharge)","20:1095a":"20:1095a (20:1095a Education - Wage Garnishment Requirement)","20:1097":"20:1097 (20:1097 Education - Criminal penalties for fraud)","20:1098g":"20:1098g (20:1098g Higher Education Act - Exemption from state disclosure)","20:1232g":"20:1232g (20:1232(g) Family Education Rights & Privacy Act of 1974)","20:1400":"20:1400 (20:1400 IDEA: Individuals with Disabilities Education Act)","20:1401":"20:1401 (20:1401 IDEA: Education of Individuals with Disabilities)","20:1412":"20:1412 (20:1412 IDEA: State Eligibility)","20:1415":"20:1415 (20:1415 IDEA: Challenge decision re education for handicapped)","20:1415e2":"20:1415e2 (20:1415(e)(2)de IDEA: Mediation)","20:1681":"20:1681 (20:1681 Title IX Educational Amendments 1992 - Sex Discrimination)","20:1683":"20:1683 (20:1683 Judicial Review: Prohibition against sex discrimination in education)","20:1706":"20:1706 (20:1706 Relief from denial of equal educational opportunity)","20:1717":"20:1717 (20:1717 Reopening proceedings w/ order to end segregation)","21:0301":"21:0301 (21:301 Federal Food, Drug & Cosmetic Act)","21:0331":"21:0331 (21:331 Federal Food, Drug & Cosmetic Act - Prohibited Acts)","21:0332":"21:0332 (21:332 Federal Food, Drug & Cosmetic Act, Injunctive Relief)","21:0332a":"21:0332a (21:332(a) Federal Food, Drug & Cosmetic Act)","21:0334a":"21:0334a (21:334(a) Forfeiture or condemnation-food, drug, cosmetics)","21:0348":"21:0348 (21:348 Federal Food, Drug & Cosmetic Act - Food Additives)","21:0360":"21:0360 (21:360 Federal Food, Drug & Cosmetic Act - Drugs and Devices)","21:0467":"21:0467 (21:467 Seizure and condemnation of poultry products)","21:0601":"21:0601 (21:601 Federal Meat Inspection Act 21 USC 601-695)","21:0673":"21:0673 (21:673 Seizure and condemnation of meat or meat products)","21:0674":"21:0674 (21:674 Proceeding to enforce & enjoin re meat products)","21:0821":"21:0821 (21:821 Violation of Record Keeping Provision of Controlled Substance Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0842":"21:0842 (21:842 Civil Penalty for violation re controlled substance)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881a Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881re Forfeiture Property - Real Estate)","21:0882":"21:0882 (21:882 Inj to enjoin violations re controlled substance)","21:1049":"21:1049 (21:1049 Seizure and condemnation re eggs or egg products)","22:0286":"22:0286 (22:286 Action against World Bank or IMF)","22:2702":"22:2702 (22:2702 Medical Malpractice by Govt Medical Personnel)","22:3612":"22:3612 (22:3612 Claim for Damage to Panama Canal)","22:3776":"22:3776 (22:3776 Panama Canal Commission Action on claims)","22:3777":"22:3777 (22:3777 Investigation of accident or injury giving rise to a claim)","22:4140":"22:4140 (22:4140 Foreign Service Grievance Act - Judicial Review)","23:0112":"23:0112 (23:112 Federal Highway Act - Letting of Contracts)","23:0134":"23:0134 (23:134 Metropolitan Transportation Planning)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0177":"25:0177 (Nonintercourse Act)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","25:2701":"25:2701 (25:2701 Indian Gaming Regulatory Act (IGRA))","25:4101":"25:4101 (25:4101 Native American Housing Assistance and Self-Determination Act (NAHASDA))","26:0063":"26:0063 (26:63 IRS: Taxable income)","26:0982":"26:0982 (26:982 IRS: To Quash IRS Formal Document Request)","26:2032":"26:2032 (26:2032 IRS: Alternate valuation)","26:6212":"26:6212 (26:6212 IRS: Notice of Deficienty (Injunctive Relief from IRS Lien))","26:6213":"26:6213 (26:6213 IRS: Injunctive Relief from IRS Lien in Tax Court)","26:6221":"26:6221 (26:6221 IRS: TEFRA Tax, Equity and Fiscal Responsibility Act of 1982)","26:6226":"26:6226 (26:6226 IRS: Judicial Review of Partnership Adjustment)","26:6320":"26:6320 (26:6320 IRS: Notice and Opportunity for Hearing upon Filing Notice of Lien)","26:6330":"26:6330 (26:6330 IRS: Notice and Opportunity for Hearing before Levy)","26:6331":"26:6331 (26:6331 IRS: Wrongful Levy)","26:6334":"26:6334 (26:6334 IRS: Property Exempt from Levy)","26:6502":"26:6502 (26:6502 IRS: Collection after Assessment (Enforcement of tax liens))","26:6532":"26:6532 (26:6532 IRS: Periods of Limitation on Suits)","26:6653sp":"26:6653sp (26:6653sp IRS: Failure to Pay Stamp Tax)","26:6672":"26:6672 (26:6672 IRS: Failure to Collect and Pay Over Tax, or Attempt to Evade or Defeat Tax)","26:6694":"26:6694 (26:6694 IRS: Underestimate of Tax Liability By Tax Preparer)","26:6702":"26:6702 (26:6702 IRS: Penalty for Frivolous Tax Submission)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7323":"26:7323 (26:7323 IRS: Proceedings in rem enforce forfeitures property)","26:7401":"26:7401 (26:7401 IRS: Tax Liability - Authorization to collect via civil action)","26:7402":"26:7402 (26:7402 IRS: Jurisdiction of District Courts)","26:7402(b)":"26:7402(b) (26:7402(b) IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 IRS: Action to Enforce Federal Tax Lien)","26:7404":"26:7404 (26:7404 IRS: Action for collection of estate tax)","26:7405":"26:7405 (26:7405 IRS: Action for recovery of refunds erroneously made)","26:7407":"26:7407 (26:7407 IRS: Action to enjoin income tax preparers)","26:7422rt":"26:7422rt (26:7422rt IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422rx IRS: Refund Excise Tax)","26:7425(a)":"26:7425(a) (26:7425(a) IRS: Judiciary & Judicial Procedures - Discharge of Liens)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7428":"26:7428 (26:7428 IRS: Declaratory Judgment)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7430":"26:7430 (26:7430 IRS: Awarding of Costs and Certain Fees in Tax Suit)","26:7431":"26:7431 (26:7431 IRS: Unauthorized Disclosure of Return & Return Info)","26:7434":"26:7434 (26:7434 IRS: Civil Damages for Fraudulent Filing of Information)","26:7604":"26:7604 (26:7604 IRS: Enforce summons; examination books & witnesses)","26:7604(a)":"26:7604(a) (26:7604(a) IRS: Complaint to Enforce IRS Summons)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","26:7609en":"26:7609en (26:7609en IRS: Petition to serve Third-Party Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:2675":"28:2675 (28:2675 Federal Tort Claims Act - Disposition by Agency Req)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","28:3205":"28:3205 (28:3205 Garnishment)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2601":"29:2601 (29:2601 Family and Medical Leave Act of 1993)","29:2615":"29:2615 (29:2615 Family Medical Leave Act)","29:2617":"29:2617 (29:2617 Family Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0022":"30:0022 (30:22 General Mining Law of 1872 (Lands Open to Purchase by Citizens))","30:0181":"30:0181 (30:181 Land subject to disposition; persons entitled to benefits; reciprocal privileges)","30:0801":"30:0801 (30:801 Penalities/Federal Mine Safety Health Act)","30:0815":"30:0815 (30:815 Federal Mine Safety & Health Act (Procedure for Enforcement))","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Judicial Review of Agency Action)","30:1701":"30:1701 (30:1701 Federal Oil Gas Royalty Mgt Act 1982 (FOGRMA))","31:0732":"31:0732 (31:0732 General Acct. Office Personnel Act of 1980 (Personnel Management System))","31:1341":"31:1341 (31:1341 Government employee - limitations on expending monies)","31:3545":"31:3545 (31:3545 Civil Action to Recover Money)","31:3702":"31:3702 (31:3702 Procedures for Settling Claims)","31:3713":"31:3713 (31:3713 Priority of Government Claims)","31:3720":"31:3720 (31:3720 Federal Income Tax Interceptions (Collection of Payments))","31:3728":"31:3728 (31:3728 Setoff against Judgment)","31:3729":"31:3729 (31:3729 False Claims Act - Liability)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 False Claims Act - Procedures)","31:3733j2":"31:3733j2 (31:3733(j)(2) Pet to Mod or Set Aside CV Investigative Demand)","31:5314":"31:5314 (31:5314 Failure to Report Interest in Foreign Accounts)","31:5317":"31:5317 (31:5317 Search and Forfeiture of Monetary Instruments)","31:5320":"31:5320 (31:5320 Inj proceedings re Rpts of Currency & Foreign Trans.)","31:5321":"31:5321 (31:5321 Penalty for failure to report transportation money)","31:5332(a)":"31:5332(a) (31:5332(a) Evading Currency Reporting Requirement)","31:5332(f)":"31:5332(f) (31:5332(f) Transport and Transfer US currency from in to out)","31:6716":"31:6716 (31:6716 Discrimination re money and finance)","31:9701":"31:9701 (31:9701 Federal User Charge Statute)","33:0408":"33:0408 (33:408 Injury to Harbor Improvement)","33:0594":"33:0594 (33:594 Land Condemnation)","33:0901":"33:0901 (33:901 Longshoremen Harbor Workers Compensation Act (Navigation and Navigable Waters))","33:0905(b)":"33:0905(b) (33:905(b) Longshoremen Workers' Compensation Act - Recovery of Damages caused by vessel neglige)","33:0918":"33:0918 (33:918 Longshore and Harbor Workers Compensation Act - Collection of Defaulted Payments)","33:0921":"33:0921 (33:921 Longshore & Harbor Workers Compensation Act - Review of Compensation Orders)","33:0933":"33:0933 (33:933 Longshore and Harbor Workers' Compensation Act-Compensation for Injuries (Third-Party Cl)","33:1221":"33:1221 (33:1221 Ports and Waterways Safety Program)","33:1251":"33:1251 (33:1251 Federal Water Pollution Control Act (Clean Water Act))","33:1319cw":"33:1319cw (33:1319cw Clean Water Act - Enforcement)","33:1319pv":"33:1319pv (33:1319(a)(2)pv Clean Water Act - Pollutants & Permit Violations)","33:1321":"33:1321 (33:1321 Clean Water Act - Discharge of hazardous substance or pollutants/water)","33:1361":"33:1361 (33:1361 Clean Water Act - Administrator Authority)","33:1364":"33:1364 (33:1364 Clean Water Act - EPA action to restrain pollution endangering health (emergency powers))","33:1365":"33:1365 (33:1365 Clean Water Act - Citizen Suits re Environmental Matters)","33:1415":"33:1415 (33:1415 Marine Protection, Research, and Sanctuaries Act)","33:1515":"33:1515 (33:1515 Deepwater Ports Act (citizen civil action))","33:2701":"33:2701 (33:2701 Oil Pollution Act of 1940)","35:0001":"35:0001 (35:1 Establishment of PTO)","35:0032":"35:0032 (35:32 Suspension from Practice before Patent & Trade Office)","35:0145":"35:0145 (35:145 Civil Action to Obtain Patent)","35:0146":"35:0146 (35:146 Appeal from Decision of the Board of Patent Appeals)","35:0183":"35:0183 (35:183 Right to Compensation - Patent Laws)","35:0256":"35:0256 (35:256 Patent Non-Infringement (Correction of Named Inventor))","35:0271":"35:0271 (35:271 Patent Infringement)","35:0281":"35:0281 (35:281 Remedy for Infringement of Patent/Jurisdiction conferred 28:1338)","35:0282":"35:0282 (35:282 Patent Infringement - Defenses)","35:0283":"35:0283 (35:283 Action to enjoin violation of right secured by patent)","35:0289":"35:0289 (35:289 Recover profits from unlicensed use of design patent)","35:0291":"35:0291 (35:291 Action for relief between owners; interfering patents)","35:0292":"35:0292 (35:292 Penalty & Forfeiture; illegal use of word patent (false marking))","35:0311":"35:0311 (35:311 Patent - Request for Inter Partes Reexamination)","38:1110":"38:1110 (38:1110 Basic Entitlements / Wartime)","38:1131":"38:1131 (38:1131 Basic Entitlements / Peacetime)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:1816":"38:1816 (38:1816 Deficiency balance VA Mortgage Foreclosure-Regulations governing VA Loan Guaranty Program)","38:1965":"38:1965 (38:1965 Servicemen's Group Life Insurance)","38:1975":"38:1975 (38:1975 Recovery of Servicemen's Group Life Insurance - Jurisdiction of District Court)","38:1984":"38:1984 (38:1984 Suit for Veterans Insurance)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (38:2021 Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:3481":"38:3481 (38:3481 Recovery of VA Overpayment)","38:3680":"38:3680 (38:3680 Recovery of Education Assist Allowance Overpayment)","38:4212":"38:4212 (38:4212 Veterans Employment Emphasis Under Federal Contracts)","38:4301":"38:4301 (38:4301 - Uniformed Services Employment and Reemployment Rights Act (USERRA))","38:4302":"38:4302 (38:4302 Veterans Reemployment Rights Act (relation to other laws and plans or agreements))","38:4311":"38:4311 (38:4311 Uniformed Service Employment or Reemployment Rights Act (USERRA) - Discrimination)","38:4312":"38:4312 (38:4312 Rights of inducted persons to reemployment)","38:4323":"38:4323 (38:4323 USERRA - Enforcement of rights with respect to state or private employer)","38:4324":"38:4324 (38:4324 USERRA - Enforcement of rights with respect to federal executive agencies)","38:5315":"38:5315 (38:5315 Delinquent Payment of Amounts Due to US)","38:5316":"38:5316 (38:5316 VA Overpayment)","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance)","39:0403":"39:0403 (39:403 Discriminatory use of the Postal Service)","39:0409":"39:0409 (39:409 Suits by and against the Postal Service)","39:1207":"39:1207 (39:1207 Review Agency Action - Labor Disputes)","39:1208b":"39:1208b (39:1208(b) Postal Reorganization Act of 1970 - Suits)","39:3005":"39:3005 (39:3005 False Representations and Lotteries)","39:3007":"39:3007 (39:3007 Detention of Mail for Temporary Periods - Injunction directing retention of incoming mail)","39:3008e":"39:3008e (39:3008(e) Enforce compliance with a USPS Prohibitory Order)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0581":"40:0581 (40:581 General Authority of Administrator of General Services)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:1101":"40:1101 (40:1101 Brooks Architect - Engineers Act)","40:3131":"40:3131 (40:3131 Bonds of contractors of Public buildings)","40:3142":"40:3142 (40:3142 Davis-Bacon Act (prevailing wages))","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","41:2102":"41:2102 (41:2102-2107 Procurement Integrity Act)","41:3301":"41:3301 (41:3301 Competition in Contracting Act)","41:6503":"41:6503 (41:6503 Walsh-Healy Act - Breach of Public Contract)","41:6505":"41:6505 (41:6505 Exclusions - Review of legal questions in contracts; Walsh-Healy Act)","41:6702":"41:6702 (41:6702-6704 Service Contract Labor Standards / McNamara-O'Hara Service Contract Act 1965)","41:7105f":"41:7105f (41:7105(f) Action to Judicially Enforce Administrative Subpoena)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0294":"42:0294 (42:294 Public Health and Welfare, Health Professions Education)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11603":"42:11603 (42:11603(b) Internat. Child Abduction Remedies Act (ICARA))","42:12101":"42:12101 (42:12101 American Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:14141":"42:14141 (42:14141 Violent Crime Control and Law Enforcement Act of 1994)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accommodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9601":"42:9601 (42:9601 - Cause of Action Arising under CERCLA)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:0421":"43:0421 (43:421 Complaint in Condemnation - Eminent Domain)","43:0945a":"43:0945a (43:945a Compensation for Land Condemnation)","43:0945b":"43:0945b (43:945b Complaint in Condemnation - Easements)","43:0946":"43:0946 (43:946 Complaint in Condemnation - Right of Way for Irrigation and Drainage Projects)","43:1331":"43:1331 (43:1331 Outer Continental Shelf Lands Act)","43:1333":"43:1333 (43:1333 Outer Continental Shelf Lands Act - Laws and Regulations Governing Lands)","43:1349":"43:1349 (43:1349 Outer Continental Land Shelf Act - Citizen Suits)","43:1701":"43:1701 (43:1701 Violation of Federal Land Policy and Management Act (FLPMA))","43:1737":"43:1737 (43:1737 FLPMA - Implementation Provisions)","44:2107":"44:2107 (44:2107 Presidential Recordings & Materials Act (NARA acceptance of records historical preservation))","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0056":"45:0056 (45:56 Employers Liability Act - Personal Inj re Railroads)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0152":"45:0152 (45:152 Railway Labor Act - General Duties)","45:0153":"45:0153 (45:153 First Railway Labor Act - National Railroad Adjustment Board)","45:0159":"45:0159 (45:159 Review of arbitration award (RR Carriers/Mediation Bd))","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:0231f":"45:0231f (45:231(f) Compel obedience to order of Railroad Retirement Bd)","45:0351":"45:0351 (45:351 Railroad Unemployment Insurance Act)","45:0719":"45:0719 (45:719 Regional Rail Reorganization Act of 1973)","45:1105":"45:1105 (45:1105 Northeast Rail Service Act)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0183":"46:0183 (46:0183 Admiralty/Limitation of Liability)","46:0688":"46:0688 (46:688 Jones Act)","46:0740":"46:0740 (46:0740 Admiralty Extension Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:31325":"46:31325 (46:31325 Shipping-Preferred Mortgage Liens and Enforcement)","46:31342":"46:31342 (46:31342 Establishing Maritime Liens)","47:227":"47:227 (47:227 Telephone Consumer Protection Act)","47:332":"47:332 (47:332 Telecommunications Act of 1996.)","47:553":"47:553 (47:553 Theft of Cable Services)","47:605":"47:605 (47:605 Unauthorized Publ./Use of Telecast for Comm Advantage)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","49:20109":"49:20109 (49:20109 Employee Protections, Federal Railroad Safety Act)","50:1701":"50:1701 (50:1701-1706 International Emergency Economic Powers Act)","50a:0001":"50a:0001 (50a:1 Trading With the Enemy Act)","50a:0501":"50a:0501 (50a:501 Sailors and Soldiers Civil Relief Act)","50a:0533":"50a:0533 (50a:533 Servicemembers Civil Relief Act - Mortgages)","50a:0540":"50a:0540 (50a:540 Sailors and Soldiers Civil Relief Act)","50a:2412":"50a:2412 (50a:2412 Export Administration Act - 1979)","51:20137a":"51:20137a (51:20137a Malpractice & Negligence Against U.S. Space program)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","adsup":"adsup (Administrative Subpoena)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","fordepo":"fordepo (Foreign Deposition)","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","writgar":"writgar (Application for a Writ of Garnishment)"},"nysdce":{"0":"0 (No cause code entered)","02:0138":"02:0138 (02:138 Library of Congress Access)","02:0358":"02:0358 (02:358 President's Recommendations on Exec., Jud. & Leg. Salary)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","02:0681":"02:0681 (02:681 Deferral of Budget Authority)","02:1202":"02:1202 (02:1202 Discriminatory practices affecting US Senate employees)","02:1301":"02:1301 (02:1301 Congressional Accountability Act)","02:1317a":"02:1317a (02:1317(a) Violation of Congressional Accountability Act)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0101":"05:0101 (05:101 Ethics in Government Act)","05:0504":"05:0504 (05:504(c)(2) Equal Access to Justice)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552b":"05:0552b (05:552b(g)sa Implement requirements of Govt in Sunshine Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552nm":"05:0552nm (05:552(a) Complaint in the Nature of Mandamus)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Adjudications Required by Statutes)","05:0555(b)":"05:0555(b) (05:0555(b) Agency Decision - Right to Counsel)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:0706":"05:0706 (05:706(a) Writ of Mandamus)","05:1508":"05:1508 (05:1508 Judicial Review of Order Issued by the Merit Systems Protection Board)","05:2302":"05:2302 (05:2302 Federal Whistleblowing Act / Civil Service Reform Act (CSRA))","05:3318":"05:3318 (05:3318 Veterans Preference Act)","05:5514":"05:5514 (05:5514 Debt Collection Act of 1982)","05:5542":"05:5542 (05:5542 Federal Employees Pay Act -- overtime rates)","05:7101":"05:7101 (05:7101 Labor-Management Relations (Findings and Purpose))","05:7123":"05:7123 (05:7123 Petition by FLRA against unfair labor practices)","05:7501":"05:7501 (05:7501 Government Employees Adverse Action--14 days or less)","05:7511":"05:7511 (05:7511 Government Employees Adverse Action--Over 14 days)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8101":"05:8101 (05:8101 Workmen's Compensation Benefits)","05:8110":"05:8110 (05:8110 Augmented Compensation for dependents of Govt. Employees)","05:8316":"05:8316 (05:8316 Claims agst US re Retirement for Federal Emp.)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","05:8701":"05:8701 (05:8701 Federal Employees Group Life Insurance Act of 1954)","05:8705":"05:8705 (05:8705 Declaratory Judgment - Insurance)","05:8715":"05:8715 (05:8715 Claims against the US - Jurisdiction of Courts)","05:8901":"05:8901 (05:8901 Federal Employees Health Benefits Act)","05:8902":"05:8902 (05:8902 Contracting Authority of OPM - Group Health Insurance)","05:8903":"05:8903 (05:8903 Federal Employees Health Benefit Act)","05:8912":"05:8912 (05:8912 Claims agst US re health benefits for Federal emp.)","07:0001":"07:0001 (07:1 Personal Property)","07:0004b":"07:0004b (07:4(b) Agriculture, Commodity Exchanges)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0009a":"07:0009a (07:0009a Recovery of penalties by Commodity Futures Trading Com)","07:0013a":"07:0013a (07:0013a Contract market rules violations; recovery of penalty)","07:0013a-1":"07:0013a-1 (07:0013a-1 Enjoin or restrain violations Contract Market rules)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0087":"07:0087 (07:0087 Enforcement of United States Grain Standards Act)","07:0136":"07:0136 (07:0136 Violations of EPA re Environmental Pesticide Control)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0193(b)":"07:0193(b) (07:0193(b) Recovery of penalties re violations by packers)","07:0203":"07:0203 (07:0203 Recovery of penalties for violations by stockyards)","07:0209(b)":"07:0209(b) (07:0209(b) Violations re purchase, sale, handling of livestock)","07:0210(f)":"07:0210(f) (07:0210(f) Suit to enforce award of damages (Packers/Stockyards))","07:0213(b)":"07:0213(b) (07:0213(b) Unfair, discriminatory, deceptive practice/marketing)","07:0216":"07:0216 (07:0216 Injunctions to restrain & enforce orders of Secretary)","07:0222":"07:0222 (07:0222 Adoption of FTC powers for enforcement)","07:0228a":"07:0228a (07:0228a Request by Secretary for TRO or Inj. re Poultry)","07:0245":"07:0245 (07:0245 Action on bond by person injured in Warehouse)","07:0292":"07:0292 (07:0292 Monopolizing or restraining trade & enhancing prices)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:0608":"07:0608 (07:0608 Agriculture Adjustment Act)","07:0901":"07:0901 (07:0901 Rural Electrification Act)","07:1291(b)":"07:1291(b) (07:1291(b) Agricultural Adjustment Act; freight rates)","07:1376":"07:1376 (07:1376 Adjustment of Quotas and Enforcement; penalties)","07:1501":"07:1501 (07:1501 Federal Crop Insurance Act)","07:1508":"07:1508 (07:1508 Crop Insurance)","07:1631":"07:1631 (07:1631 Food Security Act)","07:1721":"07:1721 (07:1721 Agricultural Trade Development Asst Act)","07:1922":"07:1922 (07:1922 Persons Eligible for Loans - Forclosure)","07:1926":"07:1926 (07:1926 Water and Waste Facility Loans and Grants)","07:1930":"07:1930 (07:1930 Perishable Agric. Comm. Act of 1930)","07:2011":"07:2011 (07:2011 Supplemental Nutrition Assistance Program)","07:2022":"07:2022 (07:2022 Disposition of Claims: Denial application to participate; food stamp prog)","07:2023(a)":"07:2023(a) (07:2023(a) Judicial Review of Food Stamp Disqualification)","07:2024":"07:2024 (07:2024 False Claims Act, Food Stamp Fraud)","07:2131":"07:2131 (07:2131 Violation of the Animal Welfare Act)","07:2146":"07:2146 (07:2146 Transportation, Sale, and Handling of Animals)","07:2301":"07:2301 (07:2301 Agricultural Fair Practices Act)","07:2305":"07:2305 (07:2305 Unfair trade practices affecting producers Agri prod)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","07:2563":"07:2563 (07:2563 Plant Variety Protection and Rights - Injunction)","07:6999":"07:6999 (07:6999 Judicial Review of Adverse Farm Agency Decision)","08:0274":"08:0274 (08:274 Action for violation thereof illegal seizure in rem)","08:0287":"08:0287 (08:287 Petition to enforce INS Subpoena)","08:0334":"08:0334 (8 CFR 334.16(b) I.N.S.)","08:1101":"08:1101 (08:1101 Immigration & Nationality Act (Definitions))","08:1105":"08:1105 (08:1105(a) Immigration: Judicial Review for Battered Spouses; Deportation (INS))","08:1151":"08:1151 (08:1151 Immigration and Nationality Act of 1952)","08:1152":"08:1152 (08:1152 Immigration: Numerical limitations on individual foreign states)","08:1153":"08:1153 (08:1153 Immigration: Allocation of Immigrant Visas)","08:1154":"08:1154 (08:1154 Immigration: Procedure for Granting Immigration Status)","08:1158":"08:1158 (08:1158 Immigration & Nationality Act, Section 208 (Asylum))","08:1182":"08:1182 (08:1182 Inadmissible Aliens: Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1183":"08:1183 (08:1183 Admission of Aliens on Giving Bond or Undertaking; Return on Departure)","08:1188":"08:1188 (08:1188 Immigration: Admission of Temporary H-2A Workers)","08:1225":"08:1225 (08:1225 Immigration: Enforcement of Administrative Subpoena)","08:1231(a)":"08:1231(a) (08:1231(a)(6) Immigration: Due Process Clause)","08:1251(A)":"08:1251(A) (08:1251(A)(4) Immigration: Application for a Stay of Deportation)","08:1252":"08:1252 (08:1252 Judicial Review of Orders of Removal)","08:1255":"08:1255 (08:1255 Immigration: Failure USCIS To Adjudicate Permanent Residency Petition)","08:1260":"08:1260 (08:1260 Aliens: Removal of Aliens Falling into Distress)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1357":"08:1357 (08:1357 Immigration and Nationality Act - Administrative Search Warrant)","08:1421":"08:1421 (08:1421 Immigration: Naturalization Authority)","08:1445":"08:1445 (08:1445 Immigration: Application for Naturalization)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1447":"08:1447 (08:1447 Immigration: Review of Denial of Naturalization Application)","08:1451":"08:1451 (08:1451 Immigration: Revocation of Citizenship)","08:1451(a)":"08:1451(a) (08:1451(a)Action to revoke Citizenship)","08:1451j":"08:1451j (08:1451(j) Motion to Correct Order & Judg. of Naturalization)","08:1503a":"08:1503a (08:1503(a) Proceedings for Declaration of U.S. Nationality)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0003":"09:0003 (09:0003 Application to Stay Proceedings Pending Arbitration)","09:0004":"09:0004 (09:4 Petition to order arbitration; failure to arbitrate)","09:0005":"09:0005 (09:5 Petition to Appoint Arbitrator)","09:0007":"09:0007 (09:7 Petition to compel attendance before arbitrator)","09:0008":"09:0008 (09:0008 Declaratory Judgment/Admiralty)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Award)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","09:0011":"09:0011 (09:0011 Motion to modify or correct arbitration award)","09:0012":"09:0012 (09:12 Petition to Vacate Arbitration Award)","09:0201":"09:0201 (09:201 Enforcement of Convention)","09:0202":"09:0202 (09:202 Award under Convention on Foreign Arbitral Awards)","09:0203":"09:0203 (09:203 Jurisdiction; amount in controversy)","09:0204":"09:0204 (09:204 Venue)","09:0205":"09:0205 (09:205 Removal from State Court: Enforcement of Foreign Arbital Awards)","09:0206":"09:0206 (09:206 Order to compel arbitration; appointment of arbitrators)","09:0207":"09:0207 (09:207 Application for order confirming award of arbitrators)","09:0208":"09:0208 (09:208 Chapter 1; residual application)","09:0301":"09:0301 (09:301 Enforcement of Convention)","09:0302":"09:0302 (09:302 Incorporation by reference)","09:0303":"09:0303 (09:303 Order to compel arbitration; appointment of arbitrators; locale)","09:0304":"09:0304 (09:304 Recognition and enforcement of foreign arbitral decisions and awards; reciprocity)","09:0305":"09:0305 (09:305 Relationship between the Inter-American Convention and the Convention on the Recognition)","09:0306":"09:0306 (09:306 Applicable rules of Inter-American Commercial Arbitration Commission)","09:0307":"09:0307 (09:307 Chapter 1; residual application)","10:0672":"10:0672 (10:672 Armed Forces: Active Guard/Reserve (AGR) Program)","10:1006":"10:1006 (10:1006 Armed Forces: Review of Agency Decision)","10:1072tc":"10:1072tc (10:1072tc Armed Forces: TRICARE PROGRAM)","10:1089c":"10:1089c (10:1089c Armed Forces: Removal; dft acting in scope of duties)","10:1091":"10:1091 (10:1091 Armed Forces: Personal Service Contracts)","10:1107":"10:1107 (10:1107 Armed Forces: Use Of Investigational New Drug)","10:1408":"10:1408 (10:1408 Armed Forces: Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: Review of Discharge or Dismissal)","10:2301":"10:2301 (10:2301 Violation of Procurement Laws (REPEALED 10-13-1994))","10:2305":"10:2305 (10:2305 Armed Forces: Review of Federal Contract)","10:2323fa":"10:2323fa (10:2323fa Armed Forces: Fifth Amendment Equal Protection: Contract Goal for Small Disadvantaged Bus)","10:2733":"10:2733 (10:2733 Armed Forces: Military Claims Act)","10:2734":"10:2734 (10:2734 Armed Forces: Foreign Military Claims Act)","10:2771":"10:2771 (10:2771 Armed Forces: Final Settlement - Deceased Members)","10:3258":"10:3258 (10:3258 Armed Forces: Reg.Army: Re-enlistment after Service as Ofcr)","11:0101":"11:0101 (11:101 Bankruptcy)","11:0110":"11:0110 (11:110 Bankruptcy: Penalty for Preparers of Fraudulent or Negligent Petitions)","11:0362(h)":"11:0362(h) (11:362(h) Bankruptcy: Violation of Automatic Stay)","11:0523":"11:0523 (11:523 Bankruptcy: Exceptions to Discharge)","11:0524":"11:0524 (11:524 Bankruptcy: Effect of Discharge)","11:0525":"11:0525 (11:525 Bankruptcy: Protections Against Discriminatory Treatment)","11:0541":"11:0541 (11:541 Property of the Estate)","11:0548":"11:0548 (11:548 Bankruptcy: Fraudulent Transfers and Obligations)","11:0704":"11:0704 (11:704 Bankruptcy: Duties of Trustee)","11:1110":"11:1110 (11:1110 Appeal of Bankruptcy Court Order)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0085":"12:0085 (12:85 National Banks: Rate of Interest on Loans, Discounts, and Purchases)","12:0096(a)":"12:0096(a) (12:93(a) National Banks: Violation of Provisions; Forfeiture of Franchise; Personal Liability of Di)","12:0191":"12:0191 (12:191 National Banks: Appointment of Receiver)","12:0192":"12:0192 (12:192 National Banks: Liquidation of National Bank)","12:0632":"12:0632 (12:632 Foreign Banking: Voluntary Liquidation)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:0635i-3":"12:0635i-3 (12:635i-3 Export-Import Bank: Breach of Insurance Contract)","12:0725":"12:0725 (12:725 Collection Under Contract Guaranty)","12:1421":"12:1421 (12:1421 Federal Home Loan Bank Act (Short Title))","12:1441":"12:1441 (12:1441FHLB: Financial Inst Reform Receiving Enforcement Act 1989)","12:1451":"12:1451 (12:1451 Emergency Home Loan Corporation (Definitions))","12:1452":"12:1452 (12:1452 Federal Home Loan Mortgage Corporation Act)","12:1461":"12:1461 (12:1461 Savings Associations: Homeowners Loan Act (Short Title))","12:1464":"12:1464 (12:1464 Savings Associations: Federal Savings and Loan)","12:1703":"12:1703 (12:1703 National Housing: Insurance of Financial Institutions)","12:1715(b)":"12:1715(b) (12:1715(b) National Housing: Rules and Regulations)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1749":"12:1749 (12:1749 Federal Crime Insurance Program)","12:1749aaa":"12:1749aaa (12:1749aaa National Housing: National Insurance Development Program)","12:1751":"12:1751 (12:1751 Fed Credit Unions: Short Title)","12:1782":"12:1782 (12:1782 Fed Credit Unions: Administration of Insurance Fund)","12:1786":"12:1786 (12:1786 Fed Credit Unions: Actions re Violations by Credit Unions)","12:1787(a)":"12:1787(a) (12:1787(a)(B) Fed Credit Unions: Liquidation of Insured Credit Union by Board)","12:1789(a)":"12:1789(a) (12:1789(a)(2) Fed Credit Unions: Admin Provision to Sue and be Sued)","12:1811":"12:1811 (12:1811 FDIC: Financial Inst. Reform Recovery Act of 1989 (FIRREA) (Organization of FDIC))","12:1818":"12:1818 (12:1818 FDIC: Violations re Federal Deposit Insurance Corporation)","12:1818(e)":"12:1818(e) (12:1818(e)FDIC: Suspension or Removal of Bank Officer)","12:1818f":"12:1818f (12:1818(f) Stay of Suspension\\Prohibition in Credit Union)","12:1819":"12:1819 (12:1819 FDIC: Corporate Powers)","12:1821":"12:1821 (12:1821 FDIC: Insurance Funds)","12:1831":"12:1831 (12:1831 FDIC: Separability of Certain Provisions)","12:1831(d)":"12:1831(d) (12:1831(d) FDIC: Deposit. Inst. Dereg. & Monetary Ctrl. Act of 1980)","12:1831j":"12:1831j (12:1831j Depository Institution Employee Protection Remedy)","12:1831r-1":"12:1831r-1 (12:1831r-1 FDIC: Notice of Branch Closure)","12:1833(a)":"12:1833(a) (12:1833(a) FDIC: Forfieture Civil Penalties)","12:1954":"12:1954 (12:1954 Injunctions (Action by Sec of Treasury re financial recordkeeping))","12:1971":"12:1971 (12:1971 Relief under Bank Holding Company Act (Definitions))","12:1972":"12:1972 (12:1972 Tying Arrangement Act)","12:2001":"12:2001 (12:2001 Farm Credit Act of 1971)","12:2601":"12:2601 (12:2601 Real Estate Settlement Procedures Act (RESPA) (findings & purpose))","12:2604(c)":"12:2604(c) (12:2604(c) Real Estate Settlement Procedures Act (\"RESPA\"))","12:2605":"12:2605 (12:2605 RESPA: Servicing of Mortgage Loans)","12:2607":"12:2607 (12:2607 RESPA: Violation re kickbacks/unearned fees; Real Estate)","12:2609":"12:2609 (12:2609 RESPA: Escrow)","12:3012":"12:3012 (12:3012 National Consumer Cooperative Bank: Suits by or against Bank)","12:3410":"12:3410 (12:3410 Right to Financial Privacy: Customer Challenges)","12:3751":"12:3751 (12:3751 Single Family Mortgage Forclosure Act: Findings and Purpose)","12:3801":"12:3801 (12:3801 Alternative Mortgage Transaction Parity Act)","12:3907":"12:3907 (12:3907 International Lending Supervision: Capital Adequacy)","12:4010":"12:4010 (12:4010 Expedited Funds Availability: Violation of Act (Civil Liability))","12:5101":"12:5101 (12:5101 Fraudulent Transfer Act (Enforcement for Mortgage Licensing))","15:0001":"15:0001 (15:1 Antitrust Litigation (Monopolizing Trade))","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0004":"15:0004 (15:4 USDC Jurisdiction re violations of Sec. 1-7 of Title 15)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0009":"15:0009 (15:9 USDC Jurisdiction re violations of Sec. 8 of Title 15)","15:0013":"15:0013 (15:13 Robinson Patman Act)","15:0014":"15:0014 (15:14 Clayton Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0026":"15:0026 (15:26 Suit for injunctive relief re violation antitrust laws)","15:0041":"15:0041 (15:41 Federal Trade Commission Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:45 Federal Trade Commission Act (unfair or deceptive acts))","15:0045cp":"15:0045cp (15:45cp Violation of Children Online Privacy Protection Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0053b":"15:0053b (15:53b Prelim & Perm Inj Relief & other Equitable Relief)","15:0068":"15:0068 (15:68 Proceedings re FTC violations re wool products)","15:0069":"15:0069 (15:69 Proceedings re FTC violations re fur products)","15:0070":"15:0070 (15:70 Proceedings re FTC violations re textile fiber product)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0078j":"15:0078j (15:78j(b)ss Stockholder Suit)","15:0079":"15:0079 (15:79 Public Utility Holding Companies)","15:0080a-3":"15:0080a-3 (15:80a-3 Investment Company Act of 1940)","15:0260":"15:0260 (15:260 Proceedings re weights and measures and standard time)","15:0294":"15:0294 (15:294 Breach of Contract)","15:0298":"15:0298 (15:298 Violation of Law Proceedings re gold or silver)","15:0433":"15:0433 (15:433 Discrimination against farmers)","15:0631":"15:0631 (15:631 Small Business Act)","15:0636":"15:0636 (15:636 Small Business Act - Aid to small business)","15:0661":"15:0661 (15:661 Small Business Investment Act of 1958)","15:0687":"15:0687 (15:687 Small Business Investment Program)","15:0714(b)":"15:0714(b) (15:714(b) Commodity Credit Corporation)","15:0715(f)":"15:0715(f) (15:715(f) Proceedings re petroleum and petroleum products)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0719i":"15:0719i (15:179i(c) Civil actions re violations or inj involving Gas)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:0766":"15:0766 (15:766 Controversies arising re Federal Energy Admin. rules)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1071":"15:1071 (15:1071 Appeal of Decision of U.S. Patent & Trademark Office (Comm / Trademark Trial Bd))","15:1114":"15:1114 (15:1114 Trademark Infringement (Lanham Act))","15:1116":"15:1116 (15:1116 Inj to prevent violation rights of trademark owner)","15:1120":"15:1120 (15:1120 Trademark - False or Fraudulent Registration)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125la Trademark Infringement (Lanham Act))","15:1125(a)":"15:1125(a) (15:1125 (a) False representation of goods sold in interstate commerce)","15:1125(d)":"15:1125(d) (15:1125(d)ac Trademark (Anticybersquatting consumer protection))","15:1126":"15:1126 (15:1126 Trademark - International Conventions)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1191":"15:1191 (15:1191 Flamable Fabrics Act)","15:1221":"15:1221 (15:1221 Auto Dealer Suits Agst Manufacturers)","15:1261":"15:1261 (15:1261 Hazardous Substances (definitions))","15:1263":"15:1263 (15:1263 Prohibited Hazardous Substance - Interstate Commerce)","15:1267(a)":"15:1267(a) (15:1267(a) Federal Hazardous Substances Act)","15:1314":"15:1314 (15:1314 Antitrust--Petition for enforcement)","15:1331":"15:1331 (15:1331 Federal Cigarette Labeling & Advertising Act)","15:1501":"15:1501 (15:1501 Estab of Dept of Commerce)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1605":"15:1605 (15:1605 Determination of Finance Charge)","15:1638":"15:1638 (15:1638 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1666":"15:1666 (15:1666 Fair Credit Billing Act Dispute)","15:1667":"15:1667 (15:1667 Consumer Leasing Act)","15:1679":"15:1679 (15:1679 Violation of Credit Repair Organizations Act)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1691":"15:1691 (15:1691 Equal Credit Opportunity Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693":"15:1693 (15:1693ef Electronic Fund Transfer Act)","15:1693m":"15:1693m (15:1693m Violation of Prov. of Subchpt.VI (Electronic Fund Transfers))","15:1701":"15:1701 (15:1701 Interstate Land Sales Full Disclosure Act (ILFFDA))","15:1709":"15:1709 (15:1709 Interstate Land Sales)","15:1714":"15:1714 (15:1714 Actions to enjoin violations re interstate land sale)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2071":"15:2071 (15:2071 Consumer Product Safety; Condemnation hazardous prod)","15:2073":"15:2073 (15:2073 Private action to enforce Consumer Product Safety)","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2310(c)":"15:2310(c) (15:2310(c) Consumer Product Warranties)","15:2601":"15:2601 (15:2601 Toxic Substances Control Act (TCSA))","15:2604":"15:2604 (15:2604 Application for inj re distribution toxic substance)","15:2616":"15:2616 (15:2616 Toxic Substance control; seizure of chemical)","15:2620":"15:2620 (15:2620 Toxic Substances Control Act: citizen's petition)","15:2651":"15:2651 (15:2651 Asbestos Hazard Emergency Response Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:2805":"15:2805 (15:2805 Petroleum Marketing Practices-Franchise Protection)","15:34-35":"15:34-35 (15:34-35 Investment Company Act of 1940)","15:3414":"15:3414 (15:3414 National Gas Policy Act)","15:3607":"15:3607 (15:3607 Condominium & Cooperative Abuse Act of 1980)","16:0019jj":"16:0019jj (16:19jj Park System Resource Protection Act)","16:0470":"16:0470 (16:470 Archaeological resources Protection Act)","16:0470f":"16:0470f (16:0470f National Historic Preservation Act)","16:0668":"16:0668 (16:668 Bald and Golden Eagle Protection Act)","16:0669":"16:0669 (16:669 Pittman-Robertson Conservation Restoration Act)","16:0675":"16:0675 (16:675 Norbeck Wildlife Preserve Organic Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:0823a":"16:0823a (16:823a Federal Public Utility Regulatory Policies Act)","16:0825":"16:0825 (16:0825 Federal Power Commission Regulation; Public Utilities)","16:0831":"16:0831 (16:0831 Actions re: rights of Tennessee Valley Authority)","16:1244":"16:1244 (16:1244 National Scenic and National Historic Trails)","16:1374(d)":"16:1374(d) (16:1374(d)(6) Petition for Review re Application for Import of Polar Bear Trophies)","16:1531":"16:1531 (16:1531 Endangered Species Act)","16:1533":"16:1533 (16:1533 Endangered Species Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:1540":"16:1540 (16:1540 Endangered Species Act - Penalties and Enforcement)","16:1600":"16:1600 (16:1600 National Forest Management Act of 1976)","16:1801":"16:1801 (16:1801 Magnuson-Stevens Fishery Conservation and Management Act)","16:1858":"16:1858 (16:1858 National Fishery Management Program - Civil Penalties and Permit Sanctions)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Lacey Act: Prohibited Acts)","16:3373":"16:3373 (16:3373 Lacey Act: Penalties and Sanctions - Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Lacey Act: Complaint for Forfeiture)","17:0043":"17:0043 (17:43(a) Lanham Act)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0201":"17:0201 (17:201 Ownership of Copyright)","17:0205(d)":"17:0205(d) (17:205(d) Priority Between Conflicting Transfers)","17:0407":"17:0407 (17:407 Recovery of fines & penalties by Register of Copyrights)","17:0411(b)":"17:0411(b) (17:411(b) Action by copyright owner for infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0502(a)":"17:0502(a) (17:502(a) Inj to prevent or restrain infringement copyright)","17:0504":"17:0504 (17:504 Remedies for Copyright Infringement)","17:0512":"17:0512 (17:512 Copyright Infringement of Digital Communications)","17:1201":"17:1201 (17:1201 Digital Millennium Copyright Act)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0492":"18:0492 (18:492 Forfeiture of Counterfeit Paraphernalia)","18:0603":"18:0603 (18:603 Conflict of Interest)","18:0922":"18:0922 (18:922 Firearms - Unlawful Possession (Civil Fines))","18:0923(f)":"18:0923(f) (18:923(f)(3) Review of Revocation of a License as a Dealer in Firearms)","18:0925(c)":"18:0925(c) (18:925(c) Restoration of ability to possess firearms/ammo)","18:0981":"18:0981 (18:981 Civil Forfeiture)","18:0981(a)":"18:0981(a) (18:0981(a)(1)(A) Civil Forfeiture: Money Laundering Control Act)","18:0983":"18:0983 (18:983 Civil Forfeiture - General Rules)","18:0984":"18:0984 (18:984 Civil Forfeiture of Fungible Property)","18:1030":"18:1030 (18:1030 Fraud & Related Activity in Connection with Computers)","18:1341":"18:1341 (18:1341 Patent Infringement)","18:1345":"18:1345 (18:1345 Injunction against Fraud)","18:1514":"18:1514 (18:1514 Civil Action to Restrain Harassment of a Victim)","18:1514A":"18:1514A (18:1514A Civil Action to Protect Against Retaliation in Fraud Cases)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1905":"18:1905 (18:1905 Disclosure of Confidential Information)","18:1955":"18:1955 (18:1955 Civil Forfeiture-Prohibition of Illegal Gambling)","18:1956(b)":"18:1956(b) (18:1956(b)(3) Laundering of Monetary Instruments - Forfeit Property)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Civil Remedies: Racketeering (RICO) Act)","18:1968":"18:1968 (18:1968 Action re civil investigative demand)","18:2254":"18:2254 (18:2254 Civil Forfeiture - Exploitation of Children)","18:2333":"18:2333 (18:2333 Civil Remedies: Anti-Terrorism Act of 1991)","18:2511":"18:2511 (18:2511 Wiretapping - Injunctive Relief or Civil Fine)","18:2707":"18:2707 (18:2707 Civil Action: Stored Communications)","18:2709":"18:2709 (18:2709 Counterintelligence access to telephone toll and transactional records)","18:2710(c)":"18:2710(c) (18:2710(c) Wrongful Disclosure of Video Tape Rental or Sales Records)","18:2724":"18:2724 (18:2724 Civil Action - Motor Vehicle Records)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:3184":"18:3184 (18:3184 Extradition Procedure)","18:3663":"18:3663 (18:3663 Civil Enforcement of Crim. Rest. Obligation)","18:3771":"18:3771 (18:3771 Crime Victim's Rights)","18:4100":"18:4100 (18:4100 Transfer of Offenders)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Customs Duties: Forfeiture-Immoral Articles)","19:1497":"19:1497 (19:1497 Customs Duties: Penalty for Failure to Declare)","19:1595a":"19:1595a (19:1595a Customs Duties: Forfeiture and Other Penalties)","19:1607":"19:1607 (19:1607 Customs Duties: Notice of Seizure)","20:0107":"20:0107 (20:107 Randolph-Sheppard Vending Stand Act)","20:1070":"20:1070 (20:1070 Student Assistance)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1087":"20:1087 (20:1087 Student Loan Discharge)","20:1095a":"20:1095a (20:1095a Education - Wage Garnishment Requirement)","20:1097":"20:1097 (20:1097 Education - Criminal penalties for fraud)","20:1098g":"20:1098g (20:1098g Higher Education Act - Exemption from state disclosure)","20:1232(g)":"20:1232(g) (20:1232(g) Family Education Rights & Privacy Act of 1974)","20:1400":"20:1400 (20:1400 IDEA: Individuals With Disabilities Education Act (short title))","20:1401":"20:1401 (20:1401 IDEA: Education of Individuals with Disabilities (definitions))","20:1412":"20:1412 (20:1412 IDEA: State Eligibility)","20:1415":"20:1415 (20:1415 IDEA: Challenge decision re education for handicapped)","20:1415(e)":"20:1415(e) (20:1415(e)(2)de IDEA: Mediation)","20:1681":"20:1681 (20:1681 Title IX Educational Amendments 1992 - Sex Discrimination)","20:1683":"20:1683 (20:1683 Judicial Review: Prohibition against sex discrimination in education)","20:1706":"20:1706 (20:1706 Relief from denial of equal educational opportunity)","20:1717":"20:1717 (20:1717 Reopening proceedings w/order to end segregation)","21:0301":"21:0301 (21:301 Federal Food, Drug & Cosmetic Act)","21:0331":"21:0331 (21:331 Federal Food, Drug & Cosmetic Act - Prohibited Acts)","21:0332":"21:0332 (21:332 Federal Food, Drug and Cosmetic Act, Injunctive Relief)","21:0332(a)":"21:0332(a) (21:332(a) Federal Food, Drug, and Cosmetic Act)","21:0334(a)":"21:0334(a) (21:334(a) Forfeiture or condemnation-food, drug, cosmetics)","21:0348":"21:0348 (21:348 Federal Food, Drug and Cosmetic Act - Food Additives)","21:0360":"21:0360 (21:360 Federal Food, Drug & Cosmetic Act - Drugs and Devices)","21:0467":"21:0467 (21:467 Seizure and condemnation of poultry products)","21:0601":"21:0601 (21:601 Federal Meat Inspection Act 21 USC 601-695 (Definitions))","21:0673":"21:0673 (21:673 Seizure and condemnation of meat or meat products)","21:0674":"21:0674 (21:674 Proceeding to enforce & enjoin re meat products)","21:0821":"21:0821 (21:821 Violation of Record Keeping Provision of Controlled Substance Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0842":"21:0842 (21:842 Civil Penalty for violation re controlled substance)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","21:0882":"21:0882 (21:882 Inj to enjoin violations re controlled substance)","21:1049":"21:1049 (21:1049 Seizure and condemnation re eggs or egg products)","22:0286":"22:0286 (22:286 Action against World Bank or IMF)","22:2702":"22:2702 (22:2702 Medical Malpractice by Govt. Medical Personnel)","22:3612":"22:3612 (22:3612 Claim for Damage to Panama Canal)","22:3776":"22:3776 (22:3776 Panama Canal Commission Action on claims)","22:3777":"22:3777 (22:3777 Investigation of accident or injury giving rise to a claim)","22:4140":"22:4140 (22:4140 Foreign Service Grievance Act - Judicial Review)","23:0112":"23:0112 (23:112 Federal Highway Act - Letting of Contracts)","23:0134":"23:0134 (23:134 Metropolitan Transportation Planning)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:0063":"26:0063 (26:63 IRS: Taxable income (Definition))","26:0401":"26:0401 (26:401 Pension Plan Distribution)","26:0982":"26:0982 (26:982 IRS: To Quash IRS Formal Document Request)","26:2032":"26:2032 (26:2032 IRS: Alternate valuation)","26:6212":"26:6212 (26:6212 IRS: Notice of Deficiency (Injunctive Relief from IRS Lien))","26:6213":"26:6213 (26:6213 IRS: Injunctive Relief from IRS Lien in Tax Court)","26:6221":"26:6221 (26:6221 IRS: TEFRA Tax, Equity and Fiscal Responsibility Act of 1982)","26:6226":"26:6226 (26:6226 IRS: Judicial Review of Partnership Adjustment)","26:6320":"26:6320 (26:6320 IRS: Notice and Opportunity for Hearing upon Filing Notice of Lien)","26:6330":"26:6330 (26:6330 IRS: Notice and Opportunity for Hearing before Levy)","26:6331":"26:6331 (26:6331 IRS: Wrongful Levy)","26:6334":"26:6334 (26:6334 IRS: Property Exempt from Levy)","26:6502":"26:6502 (26:6502 IRS: Collection after Assessment (Enforcement of tax liens))","26:6532":"26:6532 (26:6532 IRS: Periods of Limitation on Suits)","26:6653sp":"26:6653sp (26:6653sp IRS: Failure to Pay Stamp Tax)","26:6672":"26:6672 (26:6672 IRS: Failure to Collect and Pay Over Tax, or Attempt to Evade or Defeat Tax)","26:6694":"26:6694 (26:6694 IRS: Underestimate Of Tax Liability By Tax Preparer)","26:6702":"26:6702 (26:6702 IRS: Penalty for Frivolous Tax Submission)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability - Authorization to collect via civil action)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7404":"26:7404 (26:7404 IRS: Action for collection of estate tax)","26:7405":"26:7405 (26:7405 IRS: Action for recovery of refunds erroneously made)","26:7407":"26:7407 (26:7407 IRS: Action to enjoin income tax preparers)","26:7422":"26:7422 (26:7422 Refund of Income Tax)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7428":"26:7428 (26:7428 IRS: Declaratory Judgment)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7430":"26:7430 (26:7430 IRS: Awarding of Costs and Certain Fees in Tax Suit)","26:7431":"26:7431 (26:7431 IRS: Unauthorized Disclosure of Return & Return Info)","26:7434":"26:7434 (26:7434 IRS: Civil Damages for Fraudulent Filing of Information)","26:7604":"26:7604 (26:7604 IRS: Enforce summons; examination books & witnesses)","26:7604(a)":"26:7604(a) (26:7604(a) IRS: Complaint to Enforce IRS Summons)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","26:7609en":"26:7609en (26:7609en IRS: Petition to serve Third-Party Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157":"28:0157 (28:157 Motion to Withdraw Reference)","28:0157(b)":"28:0157(b) (28:157(b) Bankruptcy Claim to be tried in U.S. District Court)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0463":"28:0463 (28:463 Expenses of Judicial Litigation)","28:0534":"28:0534 (28:534 Arrest Records)","28:0591":"28:0591 (28:591 Independent Counsel)","28:0592":"28:0592 (28:592 Independent Counsel - Application for Appointment)","28:0593":"28:0593 (28:593 Independent Counsel - Court Responsibilities)","28:0594":"28:0594 (28:594 Independent Counsel - Responsibilities)","28:0595":"28:0595 (28:595 Independent Counsel - Congressional Oversight)","28:0596":"28:0596 (28:596 Independent Counsel - Removal)","28:0597":"28:0597 (28:597 Independent Counsel - Dept. of Justice Relationship)","28:0598":"28:0598 (28:598 Independent Counsel - Chapter Termination)","28:0636":"28:0636 (28:636 Jurisdiction and Power of Magistrate Judges)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1291":"28:1291 (28:1291 Maritime)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331ag":"28:1331ag (28:1331ag Fed. Question: Employment Discrimination (Age))","28:1331al":"28:1331al (28:1331al Fed. Question: Airline Crash)","28:1331as":"28:1331as (28:1331as Fed. Question: Assault, Libel, Slander)","28:1331at":"28:1331at (28:1331at Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331au Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331b Fed. Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331bc Fed. Question: Breach of Contract)","28:1331bv":"28:1331bv (28:1331bv Fed. Question: Bivens-Prisoner)","28:1331ca":"28:1331ca (28:1331ca Fed Question: Fed Communications Act)","28:1331cm":"28:1331cm (28:1331cm Fed. Question: Interstate Commerce Act)","28:1331cr":"28:1331cr (28:1331cr Fed. Question: Civil Rights (Race Discrimination))","28:1331cv":"28:1331cv (28:1331cv Fed. Question: Other Civil Rights)","28:1331dd":"28:1331dd (28:1331dd Fed. Question: Discovery Disputes (conversion case))","28:1331dj":"28:1331dj (28:1331dj Fed. Question: Declaratory Judgment)","28:1331dp":"28:1331dp (28:1331dp Fed. Question: Violation of Due Process)","28:1331ed":"28:1331ed (28:1331ed Fed. Question: Employment Discrimination)","28:1331ef":"28:1331ef (28:1331ef Fed. Question: Civil Rights Violation (Excess Force))","28:1331ej":"28:1331ej (28:1331ej Fed. Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331es Fed. Question: Enforcement of Administrative Subpoena)","28:1331fa":"28:1331fa (28:1331fa Fed. Question: Civil Rights Violation-False Arrest)","28:1331fl":"28:1331fl (28:1331fl Fed. Question: Fair Labor Standards)","28:1331fm":"28:1331fm (28:1331fm Fed. Question: Family and Medical Leave Act)","28:1331fr":"28:1331fr (28:1331fr Fed. Question: Fraud)","28:1331in":"28:1331in (28:1331in Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331mm Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331ng Fed. Question: Natural Gas Act)","28:1331ni":"28:1331ni (28:1331ni Fed. Question: Negotiable Instrument)","28:1331ot":"28:1331ot (28:1331 Fed. Question: Other)","28:1331pd":"28:1331pd (28:1331pd Fed. Question: Property Damage)","28:1331pi":"28:1331pi (28:1331pi Fed. Question: Personal Injury)","28:1331pl":"28:1331pl (28:1331pl Fed. Question: Product Liability)","28:1331pr":"28:1331pr (28:1331pr Fed. Question: Federal Prisoner Civil Rights)","28:1331ra":"28:1331ra (28:1331ra Fed. Question: Racketeering (RICO) Act)","28:1331rc":"28:1331rc (28:1331rc Fed. Question: Reclamation Project Auth. Act of 1972)","28:1331rd":"28:1331rd (28:1331rd Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a)rp Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331rr Fed. Question: Real Property)","28:1331rs":"28:1331rs (28:1331rs Fed. Question: Federal Rail Safety Act)","28:1331sh":"28:1331sh (28:1331sh Fed. Question: Sexual Harassment)","28:1331ss":"28:1331ss (28:1331ss Fed. Question: Constitutionality of State Statutes)","28:1331sv":"28:1331sv (28:1331sv Fed. Question: Securities Violation)","28:1331sx":"28:1331sx (28:1331sx Fed. Question: Employment Discrimination (Sex))","28:1331tr":"28:1331tr (28:1331tr Fed. Question: Trademark)","28:1331tra":"28:1331tra (28:1331(a)tra Fed. Question: Air Transportation)","28:1331tt":"28:1331tt (28:1331tt Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331v Fed. Question: Violation 5th & 8th Amendments)","28:1331va":"28:1331va (28:1331va Fed. Question: Violation 5th & 14th Amendment)","28:1331vc":"28:1331vc (28:1331vc Fed. Question: Violation of Constitutional Rights)","28:1331w":"28:1331w (28:1331w Fed. Question: Wrongful Termination of Employment)","28:1331wd":"28:1331wd (28:1331wd Fed. Question: Wrongful Death)","28:1331wl":"28:1331wl (28:1331wl Fed. Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331wt Fed. Question: Water Rights)","28:1332":"28:1332 (28:1332 Diversity Action)","28:1332ac":"28:1332ac (28:1332ac Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332al Diversity-Airline Crash)","28:1332ap":"28:1332ap (28:1332ap Diversity-Airplane Product Liability)","28:1332as":"28:1332as (28:1332as Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332au Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332bc Diversity-Breach of Contract)","28:1332bw":"28:1332bw (28:1332bw Diversity -Breach of Warranty)","28:1332co":"28:1332co (28:1332co Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332ct Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332de Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332df Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332ds Diversity-Contract Dispute)","28:1332dtp":"28:1332dtp (28:1332dtp Diversity - Deceptive Trade Practices)","28:1332ed":"28:1332ed (28:1332ed Diversity-Employment Discrimination)","28:1332ej":"28:1332ej (28:1332ej Diversity-Enforcement of Judgment)","28:1332fc":"28:1332fc (28:1332fc Diversity - Foreclosure)","28:1332fd":"28:1332fd (28:1332fd Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332fr Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332ia Diversity-Interpleader Action)","28:1332if":"28:1332if (28:1332if Diversity- Insurance Fraud)","28:1332ij":"28:1332ij (28:1332ij Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332in Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332jd Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332lb Diversity-Libel, Assault, Slander)","28:1332lm":"28:1332lm (28:1332lm Diversity - Legal Malpractice)","28:1332lp":"28:1332lp (28:1332lp Diversity-Property Damage/Product Liability)","28:1332lr":"28:1332lr (28:1332lr Diversity - Labor)","28:1332m":"28:1332m (28:1332m Diversity: Legal Malpractice)","28:1332ma":"28:1332ma (28:1332ma Diversity-Miller Act)","28:1332md":"28:1332md (28:1332md Diversity-Motor Vehicle/Wrongful Death)","28:1332mm":"28:1332mm (28:1332mm Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332mv Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332ni Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332nm Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332nr Diversity: Notice of Removal)","28:1332oc":"28:1332oc (28:1332oc Diversity-Other Contract)","28:1332op":"28:1332op (28:1332op Diversity-Recovery of Overpayment)","28:1332pd":"28:1332pd (28:1332pd Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332pi Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332pl Diversity-Product Liability)","28:1332pm":"28:1332pm (28:1332pm Diversity: Promissory Note)","28:1332pr":"28:1332pr (28:1332pr Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332qt Diversity-Petition to Quiet Title)","28:1332rd":"28:1332rd (28:1332rd Diversity-Recovery of Debt)","28:1332ri":"28:1332ri (28:1332ri Diversity-Racketeering (RICO) Act)","28:1332rl":"28:1332rl (28:1332rl Diversity-Rent Lease & Ejectment)","28:1332rp":"28:1332rp (28:1332rp Diversity-Real Property)","28:1332sa":"28:1332sa (28:1332sa Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332sf Diversity: Securities Fraud)","28:1332sh":"28:1332sh ( 28:1332sh Diversity-Sexual Harassment)","28:1332ss":"28:1332ss (28:1332ss Diversity - Stockholders Suits)","28:1332t":"28:1332t (28:1332t Diversity-Torts)","28:1332tl":"28:1332tl (28:1332tl Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332tm Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332tn Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332wd Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333ad Admiralty)","28:1333in":"28:1333in (28:1333in Personal Injury)","28:1333mc":"28:1333mc (28:1333mc Marine Contract)","28:1333pd":"28:1333pd (28:1333pd Property Damage)","28:1333pi":"28:1333pi (28:1333pi Marine Personal Injury)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334(b)":"28:1334(b) (28:1334(b) Proceeding arising/related to case under title 11)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337sc Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338cp Copyright Infringement)","28:1338pt":"28:1338pt (28:1338pt Patent Infringement)","28:1338tr":"28:1338tr (28:1338tr Trademark Infringement)","28:1339":"28:1339 (28:1339 Postal matters)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1340tp":"28:1340tp (28:1340tp Jurisdiction of Internal Revenue Matters; Customs Duties)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1344":"28:1344 (28:1344 Election disputes)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345co Replevin & Conversion)","28:1345db":"28:1345db (28:1345db Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345df Default of Promissory Note)","28:1345er":"28:1345er (28:1345er Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345fc Foreclosure)","28:1345ff":"28:1345ff (28:1345ff Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345hl VA Home Loan Guaranty Debt)","28:1345lc":"28:1345lc (28:1345lc Land Condemnation)","28:1345mc":"28:1345mc (28:1345mc Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345mi Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345pd Property Damage)","28:1345pe":"28:1345pe (28:1345pe Property Ejectment)","28:1345rc":"28:1345rc (28:1345rc Recovery of Debt to US)","28:1345ro":"28:1345ro (28:1345ro Recovery of Retirement Overpayment)","28:1345st":"28:1345st (28:1345st Default of Student Loan)","28:1345tp":"28:1345tp (28:1345tp Trespass on Public Land)","28:1345va":"28:1345va (28:1345va Recovery of VA Overpayment)","28:1346":"28:1346 (28:1346 U.S. Defendant)","28:1346bc":"28:1346bc (28:1346bc Breach of Contract)","28:1346pi":"28:1346pi (28:1346pi Marine Personal Injury (or tort claim - personal injury / motor vehicle))","28:1346rc":"28:1346rc (28:1346rc Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346t Tort Claim)","28:1346wd":"28:1346wd (28:1346wd Wrongful Death)","28:1348":"28:1348 (28:1348 Banking association as party)","28:1349":"28:1349 (28:1349 Corporation organized under Federal Law as party)","28:1350":"28:1350 (28:1350 Alien Tort Claims Act)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1356":"28:1356 (28:1356 Executory Process/Foreclosure)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1361pr":"28:1361pr (28:1361pr Complaint for mandamus relief (prisoner))","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1363":"28:1363 (28:1363 Action for protection of jurors employment rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1367":"28:1367 (28:1367 Other Property Damage)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1394":"28:1394 (28:1394 Banking Association against Comptroller of Currency)","28:1395":"28:1395 (28:1395 Complaint for Forfeiture)","28:1400":"28:1400 (28:1440(a) Copyright Infringement)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1403":"28:1403 (28:1403 Condemnation of real estate for the use of the US)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1407im":"28:1407im (28:1407im MDL: Silicone Gel Breast Implant Products Liability)","28:1407md":"28:1407md (28:1407md MDL: Multidistrict Litigation)","28:1407n":"28:1407n (28:1407n MDL: Personal Injury/Norplant Product Liability)","28:1407pl":"28:1407pl (28:1407pl MDL: Products Liability)","28:1441ac":"28:1441ac (28:1441ac Petition for Removal- Account Receivable)","28:1441ada":"28:1441ada (28:1441ada Removal- Americans with Disabilities Act)","28:1441ag":"28:1441ag (28:1441ag Removal- Civil Rights (Age))","28:1441al":"28:1441al (28:1441al Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441as Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441au Petition for Removal- Auto Negligence)","28:1441ba":"28:1441ba (28:1441ba Removal - National Bank Act)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441bfd":"28:1441bfd (28:1441bfd Removal- Breach of Fiduciary Duties)","28:1441ca":"28:1441ca (28:1441ca Removal - Carmack Amendment)","28:1441cc":"28:1441cc (28:1441cc Removal- Computer Crimes Act)","28:1441cj":"28:1441cj (28:1441cj Removal- Confessed Judgment)","28:1441cl":"28:1441cl (28:1441cla Removal - Consumer Leasing Act)","28:1441cp":"28:1441cp (28:1441cp Removal- Copyright)","28:1441cpl":"28:1441cpl (28:1441cpl Removal - Contract Product Liability)","28:1441cra":"28:1441cra (28:1441cra Removal - Fair Credit Reporting Act)","28:1441cv":"28:1441cv (28:1441cv Petition for Removal- Civil Rights Act)","28:1441dea":"28:1441dea (28:1441dea Removal - Disabilities Education Act)","28:1441df":"28:1441df (28:1441df Petition for Removal- Contract Default)","28:1441di":"28:1441di (28:1441di Removal- Civil Rights (Disability Act))","28:1441dj":"28:1441dj (28:1441dj Petition for Removal- Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441ds Petition for Removal- Contract Dispute)","28:1441ea":"28:1441ea (28:1441ea Removal - Employment Discrimination)","28:1441eb":"28:1441eb (28:1441eb Removal- Employment Discrimination (Sex))","28:1441ec":"28:1441ec (28:1441ec Removal- Employment Discrimination (Age))","28:1441ed":"28:1441ed (28:1441ed Petition for Removal - Employment Discrim)","28:1441em":"28:1441em (28:1441em Removal - Electronic Comm. Privacy Act)","28:1441er":"28:1441er (28:1441er Removal - Emergency Medical Treatment & Active Labor)","28:1441es":"28:1441es (28:1441es Removal- Employment Discrimination (Race))","28:1441fa":"28:1441fa (28:1441fa Removal - E.R.I.S.A. Employee Benefits)","28:1441fc":"28:1441fc (28:1441fc Petition for Removal - Fair Credit Report)","28:1441fd":"28:1441fd (28:1441fd Removal - Fair Debt Collection Practices Act)","28:1441fe":"28:1441fe (28:1441fe Removal- Fed. Employee Garnishment Statute)","28:1441fh":"28:1441fh (28:1441fh Removal- FEHBA)","28:1441fif":"28:1441fif (28:1441fif Removal - Insecticide/Fungicide/Rodenticide Act -1942)","28:1441fl":"28:1441fl (28:1441fl Removal- Fair Labor Standards Act)","28:1441fm":"28:1441fm (28:1441fm Removal - Family and Medical Leave Act)","28:1441fr":"28:1441fr (28:1441fr Petition for Removal- Fraud)","28:1441fs":"28:1441fs (28:1441fs Removal - Foreign Sovereign Immunities Act)","28:1441fsa":"28:1441fsa (28:1441fsa Removal - Federal Food Stamp Act)","28:1441hb":"28:1441hb (28:1441hb Removal - Petition of Habeas Corpus)","28:1441hc":"28:1441hc (28:1441hc Removal - Handicapped Child Protection Act)","28:1441hd":"28:1441hd (28:1441hd Removal- Housing Discrimination)","28:1441ia":"28:1441ia (28:1441ia Removal- Interstate Commerce Act)","28:1441if":"28:1441if (28:1441if Removal - Insurance Fraud)","28:1441ij":"28:1441ij (28:1441ij Petition for Removal- Injunctive/Declarato)","28:1441il":"28:1441il (28:1441il Removal- Interstate Land Full Discloser Act)","28:1441in":"28:1441in (28:1441in Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441int Petition for Removal- Action for Interplea)","28:1441la":"28:1441la (28:1441la Removal - Truth in Lending Act)","28:1441lb":"28:1441lb (28:1441lb Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441lm Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441mm Petition for Removal- Medical Malpractice)","28:1441mv":"28:1441mv (28:1441mv Removal- Motor Vehicle)","28:1441ni":"28:1441ni (28:1441ni Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441nm Petition for Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441nr Notice of Removal)","28:1441oc":"28:1441oc (28:1441oc Petition For Removal--Other Contract)","28:1441pa":"28:1441pa (28:1441pa Removal - Patent Infringement)","28:1441pd":"28:1441pd (28:1441pd Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441pi Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441pl Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441pr Petition for Removal)","28:1441qt":"28:1441qt (28:1441qt Petition for Removal- Petition to Quiet Ti)","28:1441ra":"28:1441ra (28:1441ra Removal- Civil Rights (Race))","28:1441ri":"28:1441ri (28:1441ri Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441sa Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441sf Petition for Removal: Securities Fraud)","28:1441sh":"28:1441sh (28:1441sh Removal-Sexual Harassment)","28:1441st":"28:1441st (28:1441st Removal - Stockholders Suit)","28:1441sv":"28:1441sv (28:1441sv Removal-Security Violation)","28:1441sx":"28:1441sx (28:1441sx Removal-Civil Rights (Sex))","28:1441tc":"28:1441tc (28:1441tc Removal - Tricare Program)","28:1441ti":"28:1441ti (28:1441ti Removal-Trademark Infringement)","28:1441til":"28:1441til (28:1441til Removal - Truth and Lending)","28:1441tl":"28:1441tl (28:1441tl Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441tm Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441tn Petition for Removal- Tort/Non-Motor Vehic)","28:1441us":"28:1441us (28:1441us Removal - Uniformed Svc Emp/Reemp Rights Act)","28:1441wc":"28:1441wc (28:1441wc Removal - Worker's Compensation Benefits)","28:1441wd":"28:1441wd (28:1441wd Petition for Removal- Wrongful Death)","28:1441wt":"28:1441wt (28:1441wt Removal- Employment (Wrongful Termination))","28:1442":"28:1442 (28:1442 Notice of Removal - Suit against Federal Officer)","28:1442aaf":"28:1442aaf (28:1442aaf Petition for Removal - Agst members of armed forces)","28:1442bc":"28:1442bc (28:1442bc Petition for Removal- Breach of Contract)","28:1442nr":"28:1442nr (28:1442nr Notice of Removal)","28:1442pr":"28:1442pr (28:1442pr Petition for Removal)","28:1443":"28:1443 (28:1443(1) Removal from State Court - Civil Rights: Rent, Lease, and Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446al":"28:1446al (28:1446al Notice of Removal - Airline Crash)","28:1446as":"28:1446as (28:1446as Notice of Removal - Asbestos Litigation)","28:1446bc":"28:1446bc (28:1446bc Notice of Removal - Breach of Contract)","28:1446cs":"28:1446cs (28:1446cs Notice of Removal - Child Support Enforcement)","28:1446dj":"28:1446dj (28:1446dj Notice of Removal - Declaratory Judgment)","28:1446er":"28:1446er (28:1446er Notice of Removal - E.R.I.S.A)","28:1446fm":"28:1446fm (28:1446fm Notice of Removal - Family and Medical Leave Act)","28:1446fr":"28:1446fr (28:1446fr Notice of Removal - Fraud)","28:1446in":"28:1446in (28:1446in Breach of Contract- Insurance)","28:1446lb":"28:1446lb (28:1446lb Notice of Removal - Libel, Assault, Slander)","28:1446ml":"28:1446ml (28:1446ml Notice of Removal - Motor Vehicle Prod Liability)","28:1446mm":"28:1446mm (28:1446mm Notice of Removal - Medical Malpractice)","28:1446mv":"28:1446mv (28:1446mv Notice of Removal - Motor Vehicle)","28:1446ni":"28:1446ni (28:1446ni Notice of Removal - Negotiable Instrument)","28:1446nr":"28:1446nr (28:1446nr Notice of Removal)","28:1446pd":"28:1446pd (28:1446pd Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446pi Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446pr Petition for Removal)","28:1446st":"28:1446st (28:1446st Notice of Removal - Stockholders Suit)","28:1446tl":"28:1446tl (28:1446tl Notice of Removal - Torts to Land)","28:1446wd":"28:1446wd (28:1446wd Notice of Removal - Wrongful Death)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1453":"28:1453 (28:1453 Class Action Fairness Act)","28:1491":"28:1491 (28:1491 Tucker Act)","28:1602":"28:1602 (28:1602 Foreign Sovereign Immunities Act)","28:1603":"28:1603 (28:1603 Suit on Loan Agreements)","28:1605":"28:1605 (28:1605 Foreign Sovereign Immunities Act of 1976)","28:1605A":"28:1605A (28:1605A Antiterrorism & Effective Death Penalty Act 1996)","28:1610":"28:1610 (28:1610 Juridictional Immunities of Foreign States)","28:1631":"28:1631 (28:1631 Case Transferred to Cure Want of Jurisdiction)","28:1651":"28:1651 (28:1651cn Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651hc Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651mn Petition for Writ of Mandamus)","28:1651ne":"28:1651ne (28:1651ne Application for Writ Ne Exeat)","28:1651w":"28:1651w (28:1651w All Writs Act)","28:1701":"28:1701 (28:1701 Violation of Shipping Act of 1984)","28:1715":"28:1715 (28:1715 Class Action Fairness Act of 2005)","28:1732":"28:1732 (28:1732 Reproduction of Records)","28:1738":"28:1738 (28:1783 Petition for Subpoena of person in foreign country)","28:1738Acs":"28:1738Acs (28:1738Acs The Uniform Child Custody Jurisdiction Act)","28:1782":"28:1782 (28:1782 Assistance to Foreign Tribunals (incl letter rogatory))","28:1826":"28:1826 (28:1826 Order of confinement of recalcitrant witness)","28:1875":"28:1875 (28:1875 Juror Protection Act / Protection of Jurors' Employment)","28:1916":"28:1916 (28:1916 Marine Personal Injury)","28:1963":"28:1963 (28:1963 Registration of judgment from another district)","28:2001":"28:2001 (28:2001 Judicial Sale of Realty)","28:2071":"28:2071 (28:2071 Rule Making Power Generally)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201an":"28:2201an (28:2201an Declaratory Judgment (aliens and nationality))","28:2201cp":"28:2201cp (28:2201cp Declaratory Judgment (Copyright))","28:2201dj":"28:2201dj (28:2201dj Declaratory Judgment)","28:2201fa":"28:2201fa (28:2201fa Declaratory Judgment- Firearms)","28:2201fs":"28:2201fs (28:2201fs Declaratory Judgment (Food Security Act))","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201ij Injunction)","28:2201pi":"28:2201pi (28:2201pi Declaratory Judgment - Personal Injury)","28:2241":"28:2241 (28:2241fd Petition for Writ of Habeas Corpus (Federal))","28:2241in":"28:2241in (28:2241in Habeas Corpus: INS)","28:2241st":"28:2241st (28:2241st Petition for Writ of Habeas Corpus (State))","28:2244":"28:2244 (28:2244 Habeas Corpus - Finality of Determination)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254dp":"28:2254dp (28:2254dp Petition for Writ of Habeas Corpus (Death Penalty))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2283":"28:2283 (28:2283 Stay of State Court Proceedings (Injunctive Relief))","28:2284":"28:2284 (28:2284 Three-Judge Court)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2347":"28:2347 (28:2347 Petition to Review Orders in the Ct of Appeals)","28:2401":"28:2401 (28:2401 Federal Tort Claims Act (Time for commencing action against the US))","28:2403":"28:2403 (28:2403 Constitutionality of State Statute(s))","28:2405":"28:2405 (28:2405 Garnishment of debtors of a corporation by US)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title - Actions affecting property on which United States has lien)","28:2412":"28:2412 (28:2412 Equal Access to Justice Act)","28:2415":"28:2415 (28:2415 Detinue and Conversion)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2672mv":"28:2672mv (28:2672mv Federal Tort Claims Act - Motor Vehicle)","28:2672pi":"28:2672pi (28:2672pi Federal Tort Claim Act - Personal Injury)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:2675":"28:2675 (28:2675 Federal Tort Claims Act - Disposition by Agency Req)","28:2679(d)":"28:2679(d) (28:2679(d)(2) Federal Tort Claims Act - Employee of U.S.A.)","28:2680":"28:2680 (28:2680 Federal Tort Claims Act - Exceptions)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","28:3001(a)":"28:3001(a) (28:3001(a) Federal Debt Collection Procedures Act of 1990)","28:3203":"28:3203 (28:3203 Postjudgment Remedies: Writ of Execution)","28:3301":"28:3301 (28:3301 Fraudulent Transfer Federal Debt Collection Procedures Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0101":"29:0101 (29:101 Labor: Issuance of Restraining Orders and Injunctions)","29:0151":"29:0151 (29:151 Labor: National Labor Relations Act (NLRA))","29:0158(b)":"29:0158(b) (29:0158(b) Labor: NLRA - Unfair Labor Practices)","29:0159":"29:0159 (29:0159 Labor: Violation of Collective Bargaining Agreement)","29:0160":"29:0160 (29:160 Labor: NLRA - Prevention of Unfair Labor Practices)","29:0160j":"29:0160j (29:160j Labor: Petition for Inj - Relief from Unfair Labor Practice)","29:0160l":"29:0160l (29:160l Labor: Petition for Inj re Uncertified Labor Organizations)","29:0161(2)":"29:0161(2) (29:161(2) Labor: Enforcement of agency subpoena)","29:0178":"29:0178 (29:178 Labor: Petition for Inj to Enjoin Strike during Natl Emergency)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185":"29:0185 (29:185 Labor: Suits by and against Labor Organizations)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0186":"29:0186 (29:186 Labor: Liabilities of and Restrictions on Labor and Management)","29:0187":"29:0187 (29:187 Labor: Recover Damages from Unfair Labor Practice)","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 FLSA: Definitions)","29:0206":"29:0206 (29:206 FLSA: Minimum Wage)","29:0206(d)":"29:0206(d) (29:206(d) FLSA: Prohibition of Sex Discrimination)","29:0207(a)":"29:0207(a) (29:207(a) FLSA: Action for Overtime Wage Violation)","29:0207fl":"29:0207fl (29:207fl FLSA: Maximum Hours)","29:0210":"29:0210 (29:210 FLSA: Court Review of Wage Orders in PR and VI)","29:0215fl":"29:0215fl (29:215fl FLSA: Prohibited Acts)","29:0216(b)":"29:0216(b) (29:216(b) FLSA: Minimum wage or overtime compensation)","29:0216(e)":"29:0216(e) (29:216(e)FLSA: Penalty assessed for child labor provisions)","29:0217":"29:0217 (29:217 FLSA: Enjoin Violations of Fair Labor Standards Act)","29:0260":"29:0260 (29:260 FLSA: Liquidated Damages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0411":"29:0411 (29:411 Landrum Griffin Act)","29:0412":"29:0412 (29:412 Infringement of rights; members of labor organization)","29:0440":"29:0440 (29:440 violations reporting requirements; labor organization)","29:0501(b)":"29:0501(b) (29:501(b) Violation of Fiduciary Responsibility)","29:0620":"29:0620 (29:620 Age Discrimination)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0660":"29:0660 (29:660 Action by Sec Labor for discrimination re rights OSHA)","29:0662":"29:0662 (29:662 Inj proceedings re dangerous emp conditions; by Sec.)","29:0666":"29:0666 (29:666 Collection of civil penalties under OSHA)","29:0701":"29:0701 (29:701 Vocational Rehabilitation)","29:0754":"29:0754 (29:754 Discrimination)","29:0790":"29:0790 (29:0790 Rehabilitation of Labor)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0792(d)":"29:0792(d) (29:792(d)(2) Accessible facilities for phys. handicapped emp)","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:0794ra":"29:0794ra (29:794 Rehabilitation Act of 1973)","29:0829":"29:0829 (29:0829 (Repealed) Family and Medical Leave Act of 1993)","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1055":"29:1055 (29:1055 E.R.I.S.A., Employee Retirement (Joint and Survivor Annuity))","29:1101":"29:1101 (29:1101 E.R.I.S.A.: Coverage)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.: Civil Enforcement of Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.: Delinquent Contributions)","29:1149":"29:1149 (29:1149 E.R.I.S.A.: Prohibition on False Statements and Representations)","29:1161":"29:1161 (29:1161 COBRA - Continuation Coverage)","29:1162":"29:1162 (29:1162 COBRA - Continuation Coverage)","29:1303":"29:1303 (29:1303 PBGC: Operation of Corporation)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 E.R.I.S.A.: Liability for Termination of Single Employer Plans)","29:1381":"29:1381 (29:1381 E.R.I.S.A.: Withdrawal Liability)","29:1401":"29:1401 (29:1401(b)(2) E.R.I.S.A.: Resolution of Disputes - Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.: Enforcement - Civil Actions)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:1854":"29:1854 (29:1854 Migrant & Seasonal Agri Worker Protect Act (AWPA))","29:1916":"29:1916 (29:1916 Spec. Rule for Longshoremen & Harborworkers)","29:2001":"29:2001 (29:2001 Employee Polygraph Protection Act)","29:2100":"29:2100 (29:2100 WARN ACT)","29:2101":"29:2101 (29:2101 Worker Adjustment and Retraining Notification Act)","29:2104":"29:2104 (29:2104 Worker Adjustment & Retraining Notification (WARN))","29:2601":"29:2601 (29:2601 FMLA: Family and Medical Leave Act (Findings and Purposes))","29:2611":"29:2611 (29:2611 FMLA: Definitions)","29:2612":"29:2612 (29:2612 FMLA: Leave Requirements)","29:2617":"29:2617 (29:2617 Family and Medical Leave Act of 1993)","30:0022":"30:0022 (30:22 General Mining Law of 1872 (Lands Open to Purchase by Citizens))","30:0181":"30:0181 (30:0181 Land subject to disposition; persons entitled to benefits; reciprocal privileges)","30:0801":"30:0801 (30:0801 Penalties/Federal Mine Safety Health Act)","30:0815":"30:0815 (30:815 Federal Mine Safety & Health Act (Procedure for Enforcement))","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action (Congressional Findings))","30:1202":"30:1202 (30:1202 Mining Reclamation Act (Statement of Purpose))","30:1276":"30:1276 (30:1276 Interior: Judicial Review of Agency Action)","30:1701":"30:1701 (30:1701 Federal Oil Gas Royalty Mgt Act 1982 (FOGRMA))","31:0732":"31:0732 (31:732 General Acct. Office Personnel Act of 1980 (Personnel Management System))","31:1341":"31:1341 (31:1341 Government employee--limitations on expending monies)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3702":"31:3702 (31:3702 Procedures for Settling Claims)","31:3713":"31:3713 (31:3713 Priority of Government Claims)","31:3720":"31:3720 (31:3720 Federal Income Tax Interceptions (Collection of Payments))","31:3728":"31:3728 (31:3728 Setoff against Judgment)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 False Claims Act - Procedures)","31:3733(j)":"31:3733(j) (31:3733(j)(2) Pet to Mod or Set Aside CV Investigative Demand)","31:5314":"31:5314 (31:5314 Failure to Report Interest in Foreign Accounts)","31:5317":"31:5317 (31:5317 Search and Forfeiture of Monetary Instruments)","31:5320":"31:5320 (31:5320 Inj or penalty; failure to file foreign currency rpt)","31:5321":"31:5321 (31:5321 Penalty; Reports of Currency and Foreign Transaction)","31:5332(a)":"31:5332(a) (31:5332(a) Evading Currency Reporting Requirement)","31:5332(f)":"31:5332(f) (31:5332(f) Transport and Transfer US currency from in to out)","31:6716":"31:6716 (31:6716 Discrimination re money and finance)","31:9701":"31:9701 (31:9701 Federal User Charge Statute)","33:0408":"33:0408 (33:408 Injury to Harbor Improvement)","33:0594":"33:0594 (33:594 Land Condemnation)","33:0901":"33:0901 (33:901 Longshoremen Harbor Workers Compensation Act (Navigation and Navigable Waters))","33:0905(b)":"33:0905(b) (33:905(b) Longshoremen Workers' Compensation Act - Recovery of Damages caused by the negligence)","33:0918":"33:0918 (33:918 Longshore and Harbor Workers Compensation Act - Collection of Defaulted Payments)","33:0921":"33:0921 (33:921 Longshore & Harbor Workers Compensation Act - Review of Compensation Orders)","33:0933":"33:0933 (33:933 Longshore and Harbor Workers' Compensation Act - Compensation for Injuries (Third-Party )","33:1221":"33:1221 (33:1221 Ports and Waterways Safety Program)","33:1251":"33:1251 (33:1251 Federal Water Pollution Control Act (Clean Water Act))","33:1319cw":"33:1319cw (33:1319cw Clean Water Act - Enforcement)","33:1319pv":"33:1319pv (33:1319pv Clean Water Act - Pollutants & Permit Violations)","33:1321":"33:1321 (33:1321 Clean Water Act - Discharge of hazardous substance or pollutants/water)","33:1361":"33:1361 (33:1361 Clean Water Act-Administrator Authority)","33:1365":"33:1365 (33:1365 Clean Water Act - Citizen Suits re Environmental Matters)","33:1415":"33:1415 (33:1415 Marine Protection, Research, and Sanctuaries Act)","33:1515":"33:1515 (33:1515 Deepwater Ports Act (citizen civil action))","33:2701":"33:2701 (33:2701 Oil Pollution Act of 1940)","35:0001":"35:0001 (35:0001 Establishment of PTO)","35:0032":"35:0032 (35:0032 Suspension from Practice before Patent & Trade. Off.)","35:0145":"35:0145 (35:145 Civil Action to Obtain Patent)","35:0146":"35:0146 (35:146 Appeal from Decision of the Board of Patent Appeals)","35:0183":"35:0183 (35:183 Right to Compensation - Patent Laws)","35:0256":"35:0256 (35:256 Patent Non-Infringement (Correction of Named Inventor))","35:0271":"35:0271 (35:271 Patent Infringement)","35:0281":"35:0281 (35:281 Remedy for Infringement of Patent/jurisdiction conferred 28:1338)","35:0282":"35:0282 (35:282 Patent Infringement - Defenses)","35:0283":"35:0283 (35:283 Action to enjoin violation of right secured by patent)","35:0289":"35:0289 (35:289 Recover profits from unlicensed use of design patent)","35:0291":"35:0291 (35:291 Action for relief between owners; interfering patents)","35:0292":"35:0292 (35:292 Penalty & Forfeiture; illegal use of word patent (false marking))","35:0311":"35:0311 (35:311 Patent - Request for Inter Partes Reexamination)","38:0775":"38:0775 (38:775 Recovery of Servicemen's Group Life Insurance)","38:1110":"38:1110 (38:1110 Basic Entitlements / Wartime)","38:1131":"38:1131 (38:1131 Basic Entitlements / Peacetime)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment (DISCONTINUED AFTER 1/27/2014))","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment (DISCONTINUED AFTER 1/27/2014))","38:1816":"38:1816 (38:1816 Deficiency balance on VA Mortgage Foreclosure (Regulations Governing the VA Loan Guaranty Pr)","38:1965":"38:1965 (38:1965 Servicemen's Group Life Insurance (Definitions))","38:1975":"38:1975 (38:1975 Recovery of Servicemen's Group Life Insurance - Jurisdiction of District Court)","38:1984":"38:1984 (38:1984 Suit for Veterans Insurance)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of (DISCONTINUED AFTER 1/27/2014))","38:2021":"38:2021 (38:2021 Right to Re-Employment of Inducted Persons (DISCONTINUED AFTER 1/27/2014))","38:3116":"38:3116 (38:3116 VA Overpayment (DISCONTINUED AFTER 1/27/2014))","38:3481":"38:3481 (38:3481 Recovery of VA Overpayment)","38:3680":"38:3680 (38:3680 Recovery of Education Assist Allowance Overpayment)","38:4212":"38:4212 (38:4212 Veterans Employment Emphasis Under Federal Contracts)","38:4301":"38:4301 (38:4301 Uniformed Srvs. Employment & Reemployment Rights Act (purpose))","38:4302":"38:4302 (38:4302 Veterans Reemployment Rights Act (relation to other laws and plans or agreements.)","38:4311":"38:4311 (38:4311 Uniformed Service Employment or Reemployment Rights Act (USERRA) - Discrimination)","38:4312":"38:4312 (38:4312 Rights of inducted persons to reemployment)","38:4323":"38:4323 (38:4323 USERRA - Enforcement of rights with respect to state or private employer)","38:4324":"38:4324 (38:4324 USERRA - Enforcement of rights with respect to federal executive agencies)","38:5315":"38:5315 (38:5315 Delinquent Payment of Amounts Due to US)","38:5316":"38:5316 (38:5316 VA Overpayment)","39:0101":"39:0101 (39:101 Postal Reorganization Act)","39:0403":"39:0403 (39:403 Discriminatory use of the Postal Service)","39:0409":"39:0409 (39:0409 Postal Service)","39:1207":"39:1207 (39:1207 Review Agency Action--Labor Disputes)","39:1208(b)":"39:1208(b) (39:1208(b) Postal Reorganization Act of 1970 - Suits)","39:3005":"39:3005 (39:3005 False Representations and Lotteries)","39:3007":"39:3007 (39:3007 Detention of Mail for Temporary Periods - Injunction directing retention of incoming mail)","39:3008(e)":"39:3008(e) (39:3008(e) Enforce compliance with a USPS Prohibitory Order)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:270 Miller Act (DISCONTINUED AFTER 1/27/2014))","40:0581":"40:0581 (40:581 General Authority of Administrator of General Services)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:1101":"40:1101 (40:1101 Brooks Architect - Engineers Act)","40:3131":"40:3131 (40:3131 Bonds of contractors of public buildings)","40:3133":"40:3133 (Rights of Persons Furnishing Labor or Material)","40:3142":"40:3142 (40:3142 Davis-Bacon Act (prevailing wages))","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","41:2102":"41:2102 (41:2102 Procurement Integrity Act)","41:2103":"41:2103 (41:2103 Procurement Integrity Act)","41:2104":"41:2104 (41:2104 Procurement Integrity Act)","41:2105":"41:2105 (41:2105 Procurement Integrity Act)","41:2106":"41:2106 (41:2106 Procurement Integrity Act)","41:2107":"41:2107 (41:2107 Procurement Integrity Act)","41:3301":"41:3301 (41:3301 Competition in Contracting Act)","41:6503":"41:6503 (41:6503 Walsh-Healy Act - Breach of Public Contract)","41:6505":"41:6505 (41:6505 Exclusions - Review of legal questions in contracts; Walsh-Healy Act)","41:6702":"41:6702 (41:6702 Service Contract Labor Standards / McNamara-O'Hara Service Contract Act 1965)","41:6703":"41:6703 (41:6703 Service Contract Labor Standards / McNamara-O'Hara Service Contract Act 1965)","41:6704":"41:6704 (41:6704 Service Contract Labor Standards / McNamara-O'Hara Service Contract Act 1965)","41:7105(f)":"41:7105(f) (41:7105(f) Action to Judicially Enforce Administrative Subpoena)","42:0205":"42:0205 (42:205 Appointment of Surgeon General)","42:0206":"42:0206 (42:206 Surgeon General - Assignment of Officers)","42:0234":"42:0234 (42:234 Suit to recover on NHSC Scholarship training program)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0254o":"42:0254o (42:0254o Breach of Scholarship Contract)","42:0256":"42:0256 (42:256 Public Health Services Act - Grants)","42:0292f":"42:0292f (42:292f Default of borrower)","42:0292k":"42:0292k (42:292k Student loan insurance (Public Health Occupations))","42:0293":"42:0293 (42:293 Recovery of losses from loan guarantee; public health)","42:0294":"42:0294 (42:294 To Recover on Health Education Assistance Loan)","42:0297":"42:0297 (42:297 Student loans; public or nonprofit school of nursing)","42:0300aa1":"42:0300aa1 (42:300aa-1 Nat'l. Childhood Vaccine Injury Compensation Act)","42:0300f":"42:0300f (42:300f Safe Drinking Water Act (Definitions))","42:0300g":"42:0300g (42:300g Actions re safety of public water systems (EPA))","42:0300g-3":"42:0300g-3 (42:3003g-3 Enforcement of Drinking Water Regulations)","42:0401":"42:0401 (42:401 Social Security Act - Trust Funds)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405":"42:0405 (42:405 Rev. of Final Dec. of Sec. of HEW re: S.S. Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405rs":"42:0405rs (42:405rsReview of HHS Decision (RSI))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0421(d)":"42:0421(d) (42:421(d) Review HHS decision re disability determinations)","42:0423":"42:0423 (42:423 Social Security Act (Disability Insurance Benefit Payments))","42:0425":"42:0425 (42:425 Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits (Transitional Insured Status))","42:0601":"42:0601 (42:601 Title IV-A of the Social Security Act (Grants to States for Aid and Assistance to Needy Famil)","42:0602":"42:0602 (42:602 Temp. Assistance for Needy Families (TANF))","42:0660":"42:0660 (42:660 Action to enforce child support obligations)","42:10139":"42:10139 (42:10139 judicial review of agency actions)","42:10801":"42:10801 (42:10801 Protection & Advocacy for Individuals with Mental Illness Act of 1986 (PAIMI))","42:10805":"42:10805 (42:10805 Protection and Advocacy Systems)","42:11001":"42:11001 (42:11001 Emergency Plan. & Comm. Right to Know Act (EPCRA))","42:11046":"42:11046 (42:11046 Fed Emer Plan Comm Right-to-know Act (EPCRA) - civil actions)","42:11101":"42:11101 (42:11101 Health Care Quality Improvement Act of 1986)","42:11112":"42:11112 (42:11112 Health Care Quality Improvement Act (Standards for Professional Review Actions))","42:11601":"42:11601 (42:11601 International Child Abduction Remedies Act)","42:11603b":"42:11603b (42:11603(b) Int'l. Child Abduction Remedies Act (ICARA) - Judicial Remedies)","42:12101":"42:12101 (42:12101 The Americans with Disabilities Act of 1990)","42:12102":"42:12102 (42:12102 Americans with Disabilities Act (ADA) Disability Definition)","42:12111":"42:12111 (42:12111 Americans with Disabilities Act - Employment)","42:12112":"42:12112 (42:12112 Americans with Disabilities Act - Employment Discrimination)","42:12117":"42:12117 (42:12117 Americans with Disabilities Act - Enforcement)","42:12131":"42:12131 (42:12131 Americans with Disabilities Act of 1990)","42:12132":"42:12132 (42:12132 Americans with Disabilities Act - Discrimination)","42:12188":"42:12188 (42:12188 Americans With Disabilities Act - Civil Enforcement Actions)","42:1320a-7":"42:1320a-7 (42:1320a-7b(b)(2)(A) Anti-Kickback Act (for federal health care programs))","42:1320d-2":"42:1320d-2 (42:1320d-2 Health Insurance Portability And Accountability Act (HIPAA))","42:1345":"42:1345 (42:1345 Enforcement of State Court Judgment)","42:1381a":"42:1381a (42:1381a Supplemental Security Income benefits (SSID))","42:1382":"42:1382 (42:1382 Eligibility for benefits)","42:1383":"42:1383 (42:1383 Review of HHS Decision (regarding payment of benefits))","42:1395":"42:1395 (42:1395 Emergency Medical Treatment and Active Labor Act)","42:1395dd":"42:1395dd (42:1395dd Exam & Treatment Emergency Med Cond & Women in Labor)","42:1395hr":"42:1395hr (42:1395hr Hospital Reimbursement for Medicare Services)","42:1395w21":"42:1395w21 (42:1395w-21 Medicare Act (Eligibility, Election, and Enrollment))","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1396a":"42:1396a (42:1396a State Plans for Medical Assistance)","42:1396b":"42:1396b (42:1396b Medical Assist Prgm, Pmt to States/Medicaid Implem)","42:13981":"42:13981 (42:13981 Violence Against Women Act (Civil Rights))","42:14135":"42:14135 (42:14135 DNA Backlog Grant Program)","42:1437":"42:1437 (42:1437 U.S. Housing Act of 1937)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure)","42:1475":"42:1475 (42:1475 Declaratory & Injunctive Relief - Foreclosure Procedures)","42:1479":"42:1479 (42:1479 Mortgage, lease, contract re farm housing)","42:14901":"42:14901 (42:14901 Intercountry Adoptions)","42:15483":"42:15483 (42:15483 Help America Vote Act)","42:1651":"42:1651 (42:1651 Defense Base Act)","42:1705":"42:1705 (42:1705 Receipt of Workmen's compensation benefits)","42:1971":"42:1971 (42:1971 Voting Rights Law)","42:1973":"42:1973 (42:1973 Voting Rights Act)","42:1973(a)":"42:1973(a) (42:1973(a) Enforcement of Voting Rights)","42:1973(c)":"42:1973(c) (42:1973(c) Voting Rights -Qualifications & Procedures)","42:1973agg":"42:1973agg (42:1973gg-2 Nat'l. Voter Registration Act of 1993 (NVRA))","42:1981":"42:1981 (42:1981 Equal Rights Under the Law)","42:1981a":"42:1981a (42:1981a Damages in cases of intentional discrim. in employment)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981ra":"42:1981ra (42:1981ra Race Discrimination)","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1982hs":"42:1982hs (42:1982hs Discrimination re property rights (housing))","42:1982ra":"42:1982ra (42:1982ra Discrimination re property rights (race))","42:1982sx":"42:1982sx (42:1982sx Discrimination re property rights (sex))","42:1983":"42:1983 (42:1983 Prisoner Civil Rights)","42:1983bv":"42:1983bv (42:1932bv Bivens Non-Prisoner)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983cvp":"42:1983cvp (42:1983cvp Civil Rights (Personal Property))","42:1983d":"42:1983d (42:1983d Civil Rights (Death))","42:1983dp":"42:1983dp (42:1983dp Civil Right Denial of Due Process)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1983vp":"42:1983vp (42:1983vp Violation of Due Process and Equal Protection)","42:1985":"42:1985 (42:1985 Consipracy to interfere with civil rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:1987":"42:1987 (42:1987 Prosecution of violations of certain laws (violations of sec 1990 or 5506 to 5516 or 5518 to)","42:1988":"42:1988 (42:1988 Proceedings in Vindication of Civil Rights)","42:1997":"42:1997 (42:1997 Institutionalized Persons Act of 1980)","42:2000a-3":"42:2000a-3 (42:2000a-3pa Discrimination, segregation; public accommodation - Injunctive Relief)","42:2000ad":"42:2000ad (42:2000ad Job Discrimination (Disability Act))","42:2000ag":"42:2000ag (42:2000e-2ag Job Discrimination (Age))","42:2000bb":"42:2000bb (42:2000bb Religious Freedom Restoration Act of 1993)","42:2000bea":"42:2000bea (42:2000bea Equal access to public facilities)","42:2000c6":"42:2000c6 (42:2000c-6ed Discrimination in Education)","42:2000cc":"42:2000cc (42:2000cc Religious Land Use & Institutionalized Persons Act of 2000)","42:2000d":"42:2000d (42:2000d Federally Assisted Programs)","42:2000e":"42:2000e (42:2000e-2e Job Discrimination (Unlawful Employment Practices))","42:2000e-5":"42:2000e-5 (42:2000e-5eeo Petition to Enforce EEOC Subpoena)","42:2000e2o":"42:2000e2o (42:2000e-2ot Job Discrimination (other))","42:2000e2r":"42:2000e2r (42:2000e-2rl Job Discrimination (religion))","42:2000e2s":"42:2000e2s (42:2000e-2sh Job Discrimination (Sexual Harassment))","42:2000pb":"42:2000pb (42:2000e-2pb Job Discrimination (Public Accommodations))","42:2000ra":"42:2000ra (42:2000e-2ra Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000e-2sx Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2210":"42:2210 (42:2210 Indeminification & Limitation of Liability-Financial)","42:2615":"42:2615 (42:2615 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery by US)","42:2996":"42:2996 (42:2296 Legal Services Corporation Act)","42:3058(g)":"42:3058(g) (42:3058(g) Older American's Act of 1965, 42 U.S.C. 3058(g) (State Long-term Care Ombudsman Prog)","42:3121":"42:3121 (42:3121 Public Works and Economic Development Act of 1965)","42:3133":"42:3133 (42:3133 Coordination - Grants for Public Works and Economic Development)","42:3601":"42:3601 (42:3601 Fair Housing Act)","42:3604f3c":"42:3604f3c (42:3604(f)(3)(c) Fair Housing Amendments Act)","42:3610":"42:3610 (42:3610 Fair Housing Act-Administrative Enforcement; Preliminary Matters)","42:3612":"42:3612 (42:3612 Civil rights in housing - Enforcement by Secretary)","42:3613":"42:3613 (42:3613 Action for inj relief re deprivation of civil rights)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4013":"42:4013 (42:4013 National Flood Insurance Act - Nature and Limitation of Insurance Coverage)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Cooperation of Agencies; Reports)","42:4712":"42:4712 (42:4721 Intergovernmental Personnel Act (findings and purposes))","42:4821":"42:4821 (42:4821 Lead-Based Paint Poisoning Prevention Act (findings and purposes))","42:4901":"42:4901 (42:4901 Noise Control Act of 1972 (findings and purposes))","42:4910(c)":"42:4910(c) (42:4901(c) Action to restrain violation re noise control)","42:5101":"42:5101 (42:5101 Child Abuse Prevention and Treatment Act)","42:5303":"42:5303 (42:5303 Block Grant Act of 1974 (42 USC 5301-5321))","42:5401":"42:5401 (42:5401 Natl Mnfactrd Housing Cnstr Safety Standard Act 1974 (findings and purposes))","42:5411":"42:5411 (42:5411 Housing Construction and Safety Standards Act - Injunctive Relief)","42:5851":"42:5851 (42:5851 Discrimination -Whistle blower Employee - ERA (employee protection))","42:6101":"42:6101 (42:6101 Age Discrimination in Federally Assisted Programs (statement of purpose))","42:6201":"42:6201 (42:6201 Energy Policy & Conservation Act (statement of purpose))","42:6393":"42:6393 (42:6393 Controversies under Energy Policy & Conservation Act (Admin Procedure and Judicial Review))","42:6901en":"42:6901en (42:6901en Environmental Cleanup Expenses (congressional findings))","42:6901rs":"42:6901rs (42:6901rs Resource & Recovery Act (congressional findings))","42:6928":"42:6928 (42:6928 Violations of requirements of hazardous Waste Mgmt (federal enforcement))","42:6961":"42:6961 (42:6961 Federal Facilities Compliance Act)","42:6972":"42:6972 (42:6972 Resource & Recovery Act - Citizen Suit)","42:6972(a)":"42:6972(a) (42:6972(a) Solid Waste Disposal Act - Citizen Suit)","42:7192":"42:7192 (42:7192 Controversies under Dept of Energy Organization Act - Judicial Review)","42:7384":"42:7384 (42:7384 Energy Employees Occupational Illness Compensation Program Act (EEOICPA))","42:7401":"42:7401 (42:7401 Clean Air Act (findings & declarations))","42:7412":"42:7412 (42:7412 Air Pollution Control - emission standards)","42:7413":"42:7413 (42:7413(b) Clean Air Act - Enforcement)","42:7475":"42:7475 (42:7475 Clean Air Act - Preconstruction Requirements)","42:7545":"42:7545 (42:7545 Air Pollution Prevention - Regulation of Fuels)","42:7603":"42:7603 (42:7603 Action for immediate restraint (Emergency Powers))","42:7604":"42:7604 (42:7604 Clean Air Act - Citizen suit to enforce Clean Air Act)","42:7604cl":"42:7604cl (42:7604cl Clear Air Act - Emission Standards)","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:7671":"42:7671 (42:7671 Clean Air Act (Stratospheric Ozone Protection) (Definitions))","42:8324":"42:8324 (42:8324 Powerplant and Industrial Fuel Use - terms and conditions)","42:8351":"42:8351 (42:8351 Powerplant and Industrial Fuel Use - Temporary Exemptions)","42:9601":"42:9601 (42:9601 Comprehensive Environmental Compen/Resp/Liab (CERCLA) (Definitions))","42:9604":"42:9604 (42:9604 Comprehensive Envir., Response, Comp. & Liab. Act (CERCLA) - Removal and Other Remedial Acti)","42:9607":"42:9607 (42:9607 Real Property Tort to Land - Liability)","42:9613":"42:9613 (42:9613 Comp Environ Recovery Comp & Liability Act (CERCLA) - Civil Proceedings)","42:9831":"42:9831 (42:9831-9852 Head Start Act)","43:0421":"43:0421 (43:0421 Complaint in Condemnation - Eminent Domain)","43:0945":"43:0945 (43:945 Compensation for Land Condemnation)","43:0945a":"43:0945a (43:945a Compensation for Land Condemnation)","43:0945b":"43:0945b (43:945b Complaint in Condemnation - Easements)","43:0946":"43:0946 (43:946 Complaint in Condemnation - Right of Way for Irrigation and Drainage Projects)","43:1331":"43:1331 (43:1331 Outer Continental Shelf Lands Act (Definitions))","43:1333":"43:1333 (43:1333 Outer Continental Shelf Lands Act - Laws and Regulations Governing Lands)","43:1349":"43:1349 (43:1349 Outer Continental Land Shelf Act - Citizen Suits)","43:1701":"43:1701 (43:1701 Violation of Federal Land Policy and Management Act (FLPMA))","43:1737":"43:1737 (43:1737 FLPMA - Implementation Provisions)","44:2107":"44:2107 (44:2107 Presidential Recordings and Materials Act (NARA acceptance of records for historical preserv)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0056":"45:0056 (45:56 Employers Liability Act - Personal Inj re Railroads (bringing an action))","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0152":"45:0152 (45:152 Railway Labor Act - General Duties)","45:0153":"45:0153 (45:153 First Railway Labor Act - National Railroad Adjustment Board)","45:0159":"45:0159 (45:159 Review of arbitration award (RR Carriers/Mediation Bd))","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:0351":"45:0351 (45:351 Railroad Unemployment Insurance Act)","45:0719":"45:0719 (45:719 Regional Rail Reorganization Act of 1973 (judicial review))","45:1105":"45:1105 (45:1105 Northeast Rail Service Act - Judicial Review)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0183":"46:0183 (46:183 Limitation of Liability (DISCONTINUED AFTER 1/27/2014))","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping (DISCONTINUED AFTER 1/27/2014))","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas (DISCONTINUED AFTER 1/27/2014))","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations (DISCONTINUED AFTER 1/27/2014))","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:1300":"46:1300 (46:1300 F.E.L.A. (DISCONTINUED AFTER 1/27/2014))","46:1701":"46:1701 (46:1701 Violation of Shipping Act of 1984 (DISCONTINUED AFTER 1/27/2014))","46:2114":"46:2114 (46:2114 Wrongful Discharge from Employment - protection from discrimination)","46:30101":"46:30101 (46:30101 Extension of jurisdiction to cases of damage or injury on land)","46:30104":"46:30104 (46:30104 Marine Personal Injury - Jones Act)","46:30302":"46:30302 (46:30302 Shipping: Damages for Death on High Seas)","46:30304":"46:30304 (46:30304 Breach of Maritime Contract - liability of noncompliance)","46:30503":"46:30503 (46:30503 Limitation of Liability - declaration of nature and value of goods)","46:30504":"46:30504 (46:30504 Limitation of Liability - loss by fire)","46:30505":"46:30505 (46:30505 General Limit of Liability)","46:30506":"46:30506 (46:30506 Limit of Liability for Personal Injury or Death)","46:30507":"46:30507 (46:30507 Apportionment of Losses)","46:30508":"46:30508 (46:30508 Provisions Requiring Notice of Claim or Limiting Time for Bringing Action)","46:30509":"46:30509 (46:30509 Provisions Limiting Liability for Personal Injury or Death)","46:30510":"46:30510 (46:30510 Vicarious Liability for Medical Malpractice With Regard to Crew)","46:30511":"46:30511 (46:30511 Action by Owner for Limitation)","46:30701":"46:30701 (46:30701 Marine Cargo Loss or Damage - Liability of Water Carriers)","46:30704":"46:30704 (46:30704 Liability of Water Carriers - Loading, stowage, custody, care, and delivery)","46:30902":"46:30902 (46:30902 Definition)","46:30903":"46:30903 (46:30903 Waiver of Immunity)","46:30904":"46:30904 (46:30904 Exclusive Remedy)","46:30905":"46:30905 (46:30905 Period for Bringing Action)","46:30906":"46:30906 (46:30906 Venue)","46:30907":"46:30907 (46:30907 Procedure for Hearing and Determination)","46:30908":"46:30908 (46:30908 Exemption from Arrest or Seizure)","46:30909":"46:30909 (46:30909 Security)","46:30910":"46:30910 (46:30910 Exoneration and Limitation)","46:30911":"46:30911 (46:30911 Costs and Interest)","46:31102":"46:31102 (46:31102 Public Vessels Act - Waiver of Immunity)","46:31301":"46:31301 (46:31301 Maritime Commercial Instruments and Liens Act)","46:31302":"46:31302 (46:31302 Maritime Commercial Instruments and Liens Act)","46:31303":"46:31303 (46:31303 Maritime Commercial Instruments and Liens Act)","46:31304":"46:31304 (46:31304 Maritime Commercial Instruments and Liens Act)","46:31305":"46:31305 (46:31305 Maritime Commercial Instruments and Liens Act)","46:31306":"46:31306 (46:31306 Maritime Commercial Instruments and Liens Act)","46:31307":"46:31307 (46:31307 Maritime Commercial Instruments and Liens Act)","46:31308":"46:31308 (46:31308 Maritime Commercial Instruments and Liens Act)","46:31309":"46:31309 (46:31309 Maritime Commercial Instruments and Liens Act)","46:31310":"46:31310 (46:31310 Maritime Commercial Instruments and Liens Act)","46:31311":"46:31311 (46:31311 Maritime Commercial Instruments and Liens Act)","46:31312":"46:31312 (46:31312 Maritime Commercial Instruments and Liens Act)","46:31313":"46:31313 (46:31313 Maritime Commercial Instruments and Liens Act)","46:31314":"46:31314 (46:31314 Maritime Commercial Instruments and Liens Act)","46:31315":"46:31315 (46:31315 Maritime Commercial Instruments and Liens Act)","46:31316":"46:31316 (46:31316 Maritime Commercial Instruments and Liens Act)","46:31317":"46:31317 (46:31317 Maritime Commercial Instruments and Liens Act)","46:31318":"46:31318 (46:31318 Maritime Commercial Instruments and Liens Act)","46:31319":"46:31319 (46:31319 Maritime Commercial Instruments and Liens Act)","46:31320":"46:31320 (46:31320 Maritime Commercial Instruments and Liens Act)","46:31321":"46:31321 (46:31321 Maritime Commercial Instruments and Liens Act)","46:31322":"46:31322 (46:31322 Maritime Commercial Instruments and Liens Act)","46:31323":"46:31323 (46:31323 Maritime Commercial Instruments and Liens Act)","46:31324":"46:31324 (46:31324 Maritime Commercial Instruments and Liens Act)","46:31325":"46:31325 (46:31325 Maritime Commercial Instruments and Liens Act)","46:31326":"46:31326 (46:31326 Maritime Commercial Instruments and Liens Act)","46:31327":"46:31327 (46:31327 Maritime Commercial Instruments and Liens Act)","46:31328":"46:31328 (46:31328 Maritime Commercial Instruments and Liens Act)","46:31329":"46:31329 (46:31329 Maritime Commercial Instruments and Liens Act)","46:31330":"46:31330 (46:31330 Maritime Commercial Instruments and Liens Act)","46:31331":"46:31331 (46:31331 Maritime Commercial Instruments and Liens Act)","46:31332":"46:31332 (46:31332 Maritime Commercial Instruments and Liens Act)","46:31333":"46:31333 (46:31333 Maritime Commercial Instruments and Liens Act)","46:31334":"46:31334 (46:31334 Maritime Commercial Instruments and Liens Act)","46:31335":"46:31335 (46:31335 Maritime Commercial Instruments and Liens Act)","46:31336":"46:31336 (46:31336 Maritime Commercial Instruments and Liens Act)","46:31337":"46:31337 (46:31337 Maritime Commercial Instruments and Liens Act)","46:31338":"46:31338 (46:31338 Maritime Commercial Instruments and Liens Act)","46:31339":"46:31339 (46:31339 Maritime Commercial Instruments and Liens Act)","46:31340":"46:31340 (46:31340 Maritime Commercial Instruments and Liens Act)","46:31341":"46:31341 (46:31341 Maritime Commercial Instruments and Liens Act)","46:31342":"46:31342 (46:31342 Maritime Commercial Instruments and Liens Act)","46:31343":"46:31343 (46:31343 Maritime Commercial Instruments and Liens Act)","46:40101":"46:40101 (46:40101 Shipping Act of 1998)","46:41102a":"46:41102a (46:41102(a) Shipping Act of 1984 - General Prohibitions)","46:41309":"46:41309 (46:41309 Shipping Act of 1984 - Enforcement of Reparation Orders)","46:50101":"46:50101 (46:50101 Violation of Maritime Regulations)","46:58109":"46:58109 (46:58109 Violation of Merchant Marine Act - Penalties)","47:0151":"47:0151 (47:151 Communications Act of 1934)","47:0151cs":"47:0151cs (47:151cs Federal Communications Act - Collection for Services)","47:0201bt":"47:0201bt (47:201bt Breach of Tariff)","47:0203":"47:0203 (47:203 Telecommunications Collection of Charges)","47:0205":"47:0205 (47:205 Wire and Radio Communication Svc and Charges (Recovery of Damages))","47:0206":"47:0206 (47:206 Carrier's Liability for Damages)","47:0227":"47:0227 (47:227 FCC-Unsolicited Telephone Sales)","47:0227b3":"47:0227b3 (47:227(b)(3) Telephone Consumer Protection Act of 1991)","47:0251":"47:0251 (47:251 Telecommunications Act of 1996 - Interconnection)","47:0252":"47:0252 (47:252 Telecommunications Act)","47:0254(h)":"47:0254(h) (47:254(h) Children's Internet Protection Act)","47:0332":"47:0332 (47:332 FCA-Wire or Radio Communications (Mobile Services))","47:0332(c)":"47:0332(c) (47:332 (c) Federal Telecommunications Act of 1996)","47:0338":"47:0338 (47:338 Satellite Home Viewer Improvement Act)","47:0401":"47:0401 (47:401 Application of Federal Communication Comm for Inj. (Enforcement Provisions))","47:0407":"47:0407 (47:407 Order for payment of money; petition for enforcement;)","47:0510":"47:0510 (47:510 Forfeiture of Communications Devices)","47:0521":"47:0521 (47:521 Cable Televsn. Consumer Protection & Competition Act of 1992)","47:0522":"47:0522 (47:522 Cable Communications Act)","47:0532":"47:0532 (47:532 Cable Communication Policy Act of 1984)","47:0551":"47:0551 (47:551 Cable Communications Act)","47:0553":"47:0553 (47:553 U.S.C.A. Cable Communications Policy Act)","47:0605":"47:0605 (47:605 Unlawful Reception Broadcast Signal i.e., Satellite - Theft of Satellite Communications)","48:0734":"48:0734 (48:734 Federal Employees Group Life Insurance)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported (DISCONTINUED AFTER 1/27/2014))","49:0101":"49:0101 (49:101 ICC Termination Act of 1996)","49:0502":"49:0502 (49:502 Transportation Administrative Subpoena)","49:0781":"49:0781 (49:781 Forfeiture (DISCONTINUED AFTER 1/27/2014))","49:10101":"49:10101 (49:10101 Interstate Commerce Act-Interstate Transportation Rail)","49:10743":"49:10743 (49:10743 Revised Interstate Commerce Act)","49:11101":"49:11101 (49:11101 Interstate Commerce Act)","49:1113":"49:1113 (49:1113 Petition to enforce administrative summon)","49:1136":"49:1136 (49:1136 Aviation Disaster Family Assistance Act of 1996)","49:11501":"49:11501 (49:11501 Railroad Revitalization & Regulatory Reform Act (General jurisdiction))","49:11502":"49:11502 (49:11502 Railroad Revitalization Regulatory Reform (authority to exempt rail carrier transportation))","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11701":"49:11701 (49:11701 General authority of enforcement of regulations in rail)","49:11702":"49:11702 (49:11702 Enforcement by the Board)","49:11707":"49:11707 (49:11707 Carmack Amendment (Liability when property is delivered in violation of routing instruct))","49:13101":"49:13101 (49:13101 Transportation Policy)","49:13702":"49:13702 (49:13702 Tariff requirement for certain transportation)","49:13706":"49:13706 ( 49:13706 Motor Carriers, etc-Liability for Payment of Rates)","49:1374":"49:1374 (49:1374(b) Federal Aviation Act)","49:14501":"49:14501 (49:14501 Preemption (federal authority of intrastate transportation))","49:14705":"49:14705 (49:14705 Interstate Commerce Act/Carmack Amendment (Limitations on actions by and against carriers))","49:14706":"49:14706 (49:14706 Carmack Amendment to the Interstate Commerce Act / Liability of Carriers - Receipts & Bills)","49:1471":"49:1471 (49:1471 Federal Aviation Act (DISCONTINUED AFTER 1/27/2014))","49:1502":"49:1502 (49:1502 Warsaw Convention (DISCONTINUED AFTER 1/27/2014))","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon (DISCONTINUED AFTER 1/27/2014))","49:20109":"49:20109 (49:20109 Federal Rail Safety Act (FRSA))","49:20301":"49:20301 (49:20301 Federal Safety Appliance Act)","49:20302":"49:20302 (49:20302 Federal Safety Appliance Act)","49:20303":"49:20303 (49:20303 Federal Safety Appliance Act)","49:20304":"49:20304 (49:20304 Federal Safety Appliance Act)","49:20305":"49:20305 (49:20305 Federal Safety Appliance Act)","49:20306":"49:20306 (49:20306 Federal Safety Appliance Act)","49:21302":"49:21302 (49:21302 Carriers violations of Interstate Commerce Act (Chapter 201 accident and incident violation)","49:30101":"49:30101 (49:30101 National Traffic & Motor Vehicle Safety Act)","49:30112":"49:30112 (49:30112 Motor Vehicle Safety (prohibition on non-complying motor vehicles and equipment))","49:30502":"49:30502 (49:30502 Natl Motor Vehicle Title Information Syst)","49:31114":"49:31114 (49:31114 Access to Interstate System/Commercial Motor Vehicle)","49:31502":"49:31502 (49:31502 Motor Carrier Safety: Requirements for Qualifications)","49:32101":"49:32101 (49:32101 Motor Vehicle Information and Costs Savings Act)","49:32701":"49:32701 (49:32701 Odometer Requirements Act)","49:40101":"49:40101 (49:40101 Air Trans. Safety and Sys. Stabilization Act)","49:40102":"49:40102 (49:40102 Airline Deregulation Actv(definitions of air and commerce safety))","49:40105":"49:40105 (49:40105 Warsaw Convention)","49:408B3":"49:408B3 (49:408B3 Air Transportation Safety Act)","49:41705":"49:41705 (49:41705 Air Carrier Access Act (discrimination against handicapped individuals))","49:41713":"49:41713 (49:41713 Airline Deregulation Actv (premp of authority over prices, routes, and service))","49:44709":"49:44709 (49:44709 Noise Control Act of 1972)","49:44715":"49:44715 (49:44715 Noise Control Act of 1972)","49:46507":"49:46507 (49:46507 False information and threats)","49:47101":"49:47101 (49:47101 Airport and Airway Improvement Act of 1982)","49:47501":"49:47501 (49:47501 Aviation Safety & Noise Abatement Act of 1979)","49:49101":"49:49101 (49:49101 Wrongful Termination in Contravention of Published Regulations)","49:49104":"49:49104 (49:49104 Breach of Lease by Metro. Wash. Airport Auth.)","49:60101":"49:60101 (49:60101 Pipeline Safety Act of 1994)","49:60102":"49:60102 (49:60102 Hazardous Liquid Pipeline Safety Act of 1979 (HLPSA))","49:80102":"49:80102 (49:80102 Bills of Lading - Application)","49:80302":"49:80302 (49:80302 Contraband - Prohibitions)","49:80303":"49:80303 (49:80303 Seizure and forfeiture of vessel or aircraft conveying contraband)","50:1701":"50:1701 (50:1701 International Emergency Economic Powers Act)","50:1702":"50:1702 (50:1702 International Emergency Economic Powers Act)","50:1703":"50:1703 (50:1703 International Emergency Economic Powers Act)","50:1704":"50:1704 (50:1704 International Emergency Economic Powers Act)","50:1705":"50:1705 (50:1705 International Emergency Economic Powers Act)","50:1706":"50:1706 (50:1706 International Emergency Economic Powers Act)","50a:0001":"50a:0001 (50a:1 Trading With the Enemy Act (act located in Title 50, Appendix.))","50a:0501":"50a:0501 (50a:501 Sailors and Soldiers Civil Relief Act (act located in Title 50, Appendix.))","50a:0533":"50a:0533 (50a:533 Servicemembers Civil Relief Act-mortgages (act located in Title 50, Appendix.))","50a:0540":"50a:0540 (50a:540 Sailors and Soldiers Civil Relief Act (act located in Title 50, Appendix.))","50a:2412":"50a:2412 (50a:2412 Export Administration Act--1979 (act located in Title 50, Appendix.))","51:20137a":"51:20137a (51:20137(a) Malpractice & Negligence Against U.S. Space program)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","M:08-425":"M:08-425 (M 08-425 Sureties Proceedings)","M:08-65":"M:08-65 (M 08-65 Letters Rogatory - Cuba)","M:08-85c":"M:08-85c (M 08-85 Motion to Compel)","M:08-85q":"M:08-85q (M 08-85 Motion to Quash)","M:08-86":"M:08-86 (M 08-86 Internet Infringement)","M:08-88":"M:08-88 (M 08-88 Surety Companies)","M:09-282":"M:09-282 (M 09-282 Attorney Change of Name)","M:09-342":"M:09-342 (M 09-342 Letters Rogatory - Costa Rica)","M:09-372":"M:09-372 (M 09-372 Letters Rogatory - Spain)","M:10-468":"M:10-468 (M 10-468 Standing Order)","M:10-63":"M:10-63 (M 10-63 Letters Rogatory - Sweden)","M:10-7":"M:10-7 (M 10-7 Letters Rogatory - Argentina)","M:11-03":"M:11-03 (M 11-03 SEC Litigation to Freeze Account)","M:11-120":"M:11-120 (M 11-120 Letters Rogatory - Mexico)","M:11-188":"M:11-188 (M 11-188 Subpoenas - Habeas Corpus)","M:11-189":"M:11-189 (M 11-189 Subpoenas - Habeas Corpus)","M:12-160":"M:12-160 (M 12-160 Letters Rogatory - Canada)","M:12-329":"M:12-329 (M 12-329 Letters Rogatory - Italy)","M:13-72":"M:13-72 (M 13-72 Letters Rogatory - Brazil)","M:15-306":"M:15-306 (M 15-306 Letters Rogatory - Puerto Rico)","M:15-377":"M:15-377 (M 15-377 Letters Rogatory - Venezuela)","M:16-286":"M:16-286 (M 16-286 Letters Rogatory - Guatemala)","M:16-347":"M:16-347 (M 16-347 Letters Rogatory - Columbia)","M:16-59":"M:16-59 (M 16-59 Letters Rogatory - Czech Republic)","M:16-88":"M:16-88 (M 16-88 Sale of Unclaimed Seamens' Effects)","M:18-113":"M:18-113 (M 18-113 Letters Rogatory - Tanzania)","M:18-117":"M:18-117 (M 18-117 Letters Rogatory - Poland)","M:18-302":"M:18-302 (M 18-302 Registration of Foreign Judgment)","M:18-304":"M:18-304 (M 18-304 Administrative Subpoena Proceedings)","M:18-305":"M:18-305 (M 18-305 Registration of Student Loan Judgment)","M:18-66":"M:18-66 (M 18-66 Forfeiture Proceedings - Funds Held in Trust 28 USC 1746)","M:18-981":"M:18-981 (M 18-981 Nonjudicial Civil Forfeiture Proceeding)","M:19-101":"M:19-101 (M 19-101 Letters Rogatory - Aruba)","M:19-102":"M:19-102 (M 19-102 Letters Rogatory - Peru)","M:19-103":"M:19-103 (M 19-103 Letters Rogatory - Andorra)","M:19-104":"M:19-104 (M 19-104 Letters Rogatory - Brussels)","M:19-106":"M:19-106 (M 19-106 Letters Rogatory - Mauritania)","M:19-107":"M:19-107 (M 19-107 Letters Rogatory - Luxembourg)","M:19-109":"M:19-109 (M 19-109 Letters Rogatory - Portugal)","M:19-110":"M:19-110 (M 19-110 Letters Rogatory - Israel)","M:19-111":"M:19-111 (M 19-111 Letters Rogatory - Ecuador)","M:19-112":"M:19-112 (M 19-112 Letters Rogatory - Ireland)","M:19-113":"M:19-113 (M 19-113 Letters Rogatory - Haiti)","M:19-114":"M:19-114 (M 19-114 Letters Rogatory - Greece)","M:19-115":"M:19-115 (M 19-115 Letters Rogatory - Belgium)","M:19-116":"M:19-116 (M 19-116 Letters Rogatory - Russia)","M:19-117":"M:19-117 (M 19-117 Letters Rogatory - Hong Kong)","M:19-118":"M:19-118 (M 19-118 Letters Rogatory - Bermuda)","M:19-119":"M:19-119 (M 19-119 Letters Rogatory - Monaco)","M:19-120":"M:19-120 (M 19-120 Letters Rogatory - Hungary)","M:19-121":"M:19-121 (M 19-121 Letters Rogatory - Lithuania)","M:19-122":"M:19-122 (M 19-122 Letters Rogatory - Latvia)","M:19-123":"M:19-123 (M 19-123 Letters Rogatory - Finland)","M:19-130":"M:19-130 (M 19-130 Letters Rogatory - Kazakhstan)","M:19-131":"M:19-131 (M 19-131 Letters Rogatory - Dabal)","M:19-132":"M:19-132 (M 19-132 Letters Rogatory - New Zealand)","M:19-133":"M:19-133 (M 19-133 Letters Rogatory - Belarus)","M:19-134":"M:19-134 (M 19-134 Letters Rogatory - Cyprus)","M:19-135":"M:19-135 (M 19-135 Letters Rogatory - South Africa)","M:19-136":"M:19-136 (M 19-136 Letters Rogatory - Jersey)","M:19-137":"M:19-137 (M 19-137 Letters Rogatory - Antigua)","M:19-138":"M:19-138 (M 19-138 Letters Rogatory - Saint Vincent Grenadines)","M:19-139":"M:19-139 (M 19-139 Letters Rogatory - British Virgin Islands)","M:19-141":"M:19-141 (M 19-141 Letters Rogatory - Korea)","M:19-143":"M:19-143 (M 19-143 Letters Rogatory - Liechtenstein)","M:19-145":"M:19-145 (M 19-145 Letters Rogatory - Slovak Republic)","M:19-146":"M:19-146 (M 19-146 Letters Rogatory - China)","M:19-148":"M:19-148 (M 19-148 Letters Rogatory - Anguilla)","M:19-151":"M:19-151 (M 19-151 Letters Rogatory - Ukraine)","M:19-152":"M:19-152 (M 19-152 Letters Rogatory - Croatia)","M:19-155":"M:19-155 (M 19-155 Letters Rogatory - Special Court for Sierra Leone)","M:19-156":"M:19-156 (M 19-156 Letters Rogatory - Moldova)","M:19-193":"M:19-193 (M 19-193 Letters Rogatory - Yugoslavia)","M:19-194":"M:19-194 (M 19-194 Letters Rogatory - Philippines)","M:19-195":"M:19-195 (M 19-195 Letters Rogatory - Pakistan)","M:19-196":"M:19-196 (M 19-196 Letters Rogatory - Zimbabwe)","M:19-197":"M:19-197 (M 19-197 Letters Rogatory - Nigeria)","M:19-198":"M:19-198 (M 19-198 Letters Rogatory - Namibia)","M:19-199":"M:19-199 (M 19-199 Letters Rogatory - Indonesia)","M:19-200":"M:19-200 (M 19-200 Letters Rogatory - Zambia)","M:19-201":"M:19-201 (M 19-201 Letters Rogatory - Romania)","M:19-25":"M:19-25 (M 19-25 Order Authorizing IRS Officer to Enter Premises for Levy)","M:19-300":"M:19-300 (M 19-300 Letters Rogatory - Uruguay)","M:19-301":"M:19-301 (M 19-301 Letters Rogatory - Uganda)","M:19-302":"M:19-302 (M 19-302 Letters Rogatory - Singapore)","M:19-303":"M:19-303 (M 19-303 Letters Rogatory - Mauritius)","M:19-305":"M:19-305 (M 19-305 Letters Rogatory - Panama)","M:19-373":"M:19-373 (M 19-373 Letters Rogatory - Vietnam)","M:19-374":"M:19-374 (M 19-374 Letters Rogatory - Cayman Islands)","M:19-376":"M:19-376 (M 19-376 Letters Rogatory - Kenya)","M:19-378":"M:19-378 (M 19-378 Letters Rogatory - Azerbaijan)","M:19-379":"M:19-379 (M 19-379 Letters Rogatory - Guam)","M:19-380":"M:19-380 (M 19-380 Letters Rogatory - Paraguay)","M:19-382":"M:19-382 (M 19-382 Letters Rogatory - Bangladesh)","M:19-383":"M:19-383 (M 19-383 Letters Rogatory - Albania)","M:19-384":"M:19-384 (M 19-384 Letters Rogatory - Malawi)","M:19-385":"M:19-385 (M 19-385 Letters Rogatory - Montenegro)","M:19-386":"M:19-386 (M 19-386 Letters Rogatory - Seychelles)","M:19-4":"M:19-4 (M 19-4 Letters Rogatory - Jamaica)","M:19-42":"M:19-42 (M 19-42 Letters Rogatory - Egypt)","M:19-43":"M:19-43 (M 19-43 Letters Rogatory - Estonia)","M:19-5":"M:19-5 (M 19-5 Letters Rogatory - Trinidad & Tobago)","M:19-51":"M:19-51 (M 19-51 Letters Rogatory - Algeria)","M:19-58":"M:19-58 (M 19-58 General Bonds in Admirality Purs. to Local Admirality Rule 8)","M:19-60":"M:19-60 (M 19-60 Letters Rogatory - Bulgaria)","M:19-63":"M:19-63 (M 19-63 Receivers - Property in Other Districts)","M:19-67":"M:19-67 (M 19-67 Letters Rogatory - Chile)","M:19-70":"M:19-70 (M 19-70 Letters Rogatory - France)","M:19-71":"M:19-71 (M 19-71 Letters Rogatory - Thailand)","M:19-73":"M:19-73 (M 19-73 Letters Rogatory - Austria)","M:19-76":"M:19-76 (M 19-76 Letters Rogatory - Turkey)","M:19-77":"M:19-77 (M 19-77 Letters Rogatory - Arabia)","M:19-78":"M:19-78 (M 19-78 Denial to Sue In Forma Pauperis)","M:19-80":"M:19-80 (M 19-80 Letters Rogatory - Morocco)","M:19-82":"M:19-82 (M 19-82 Letters Rogatory - Japan)","M:19-83":"M:19-83 (M 19-83 Letters Rogatory - Australia)","M:19-84":"M:19-84 (M 19-84 Letters Rogatory - Switzerland)","M:19-85":"M:19-85 (M 19-85 Letters Rogatory - Denmark)","M:19-86":"M:19-86 (M 19-86 Letters Rogatory - India)","M:19-88":"M:19-88 (M 19-88 Letters Rogatory - Germany)","M:19-89":"M:19-89 (M 19-89 Letters Rogatory - Guinea)","M:19-90":"M:19-90 (M 19-90 Letters Rogatory - Norway)","M:19-91":"M:19-91 (M 19-91 Letters Rogatory - West Pakistan)","M:19-92":"M:19-92 (M 19-92 Letters Rogatory - Bahamas)","M:19-96":"M:19-96 (M 19-96 Letters Rogatory - Great Britain)","M:19-98":"M:19-98 (M 19-98 Letters Rogatory - Somalia)","M:19-99":"M:19-99 (M 19-99 Letters Rogatory - Netherlands)","M:22-1":"M:22-1 (M 22-1 Designation by U.S. Attorney of individual to accept service of summons and complaint)","M:22-2":"M:22-2 (M 22-2 Designation of individual to issue certified copies in bankruptcy part)","M:23":"M:23 (M 23 Petition to Perpetuate Testimony)","M:25-1":"M:25-1 (M 25-1 Order for Entry to Effect Levy - IRS Matter)","M:25-2":"M:25-2 (M 25-2 Permission to have access to safe deposit boxes)","M:26-1":"M:26-1 (M 26-1 Proceeding to Enforce Order of Administrator - National Credit Union)","M:26-2":"M:26-2 (M 26-2 Application to Enforce Admin. Order Rule 5A Rule of Division of Business among District Judge)","M:28":"M:28 (M 28 Warrant for Entry & Inspection of Premises)","M:29":"M:29 (M 29 Privacy Act Application)","M:30":"M:30 (M 30 Privacy Act Application)","M:31":"M:31 (M 31 Order of Commodity Exchange Commission Directing Person to Pay Money)","M:32":"M:32 (M 32 Petition for Writ to Produce Federal Prisoner in State Court)","M:33":"M:33 (M 33 Inspection Warrant - Department of Energy)","M:34":"M:34 (M 34 Order of Another District Court that the State Court Produce)","M:35":"M:35 (M 35 Order to Stay Transfer of Federal Prisoner)","M:36":"M:36 (M 36 National Labor Relations Board)","M:37":"M:37 (M 37 Application to Re-Open Civil Case(s) that are more than 25 years old)","M:38":"M:38 (M 38 Application for Reassignment of Bankruptcy Proceeding)","M:39":"M:39 (M 39 Application for Discovery and Inspection of Defendant Detained in Federal Prison)","M:41":"M:41 (M 41 Order of Return of 28:2254/2255 Petition)","M:42":"M:42 (M 42 Order Denying Stay of Deportation)","M:43":"M:43 (M 43 Contempt of Court in Bankruptcy)","M:44":"M:44 (M 44 Claim Compensation under Longshoremens & Harbor Workers Compensation Act)","M:46":"M:46 (M 46 Order From Another District for Public Viewing)","M:47":"M:47 (M 47 Bankruptcy Cases - Before Appeal Filed)","M:47b":"M:47b (M 47B Transmission of Proposed Findings of Fact and Conclusions of Law)","M:48":"M:48 (M 48 Application for Appointment of Counsel - No Case In This Court)","M:49":"M:49 (M 49 Order Denying Commencement of Civil Action)","M:51":"M:51 (M 51 Order to Show Cause - Case Being Transferred from Northern District of New York)","M:52":"M:52 (M 52 Application for Leave to File a Complaint)","M:53":"M:53 (M 53 Order Barring Individual from Entering Courthouse Building)","M:54":"M:54 (M 54 Immigration Naturalization - Order Delaying Deportation)","M:55":"M:55 (M 55 Petition for Appointment of Impartial Umpire - Labor Management Relations Act and Others)","M:58":"M:58 (M 58 Application for Extension of Time to File Petition for Removal)","M:59":"M:59 (M 59 Application to Produce Federal Prisoner in State Court)","M:67":"M:67 (M 67 Notice of Eviction to Squatters (USA Cases))","M:70":"M:70 (M 70 Asbestos Litigation - SDNY)","M:71":"M:71 (M 71 Application re: Federal Rules Cr. 11(e)(2))","M:72":"M:72 (M 72 Order of Attachment of Another District - EDNY)","M:73":"M:73 (M 73 Subpoena to Government Agency)","M:75":"M:75 (M 75 Application for Writ of Garnishment)","M:76":"M:76 (M 76 Central Violations Bureau)","M:77":"M:77 (M 77 Application to have subpoena issued to person living in this district re: action in foreign cou)","M:87":"M:87 (M 87 Order Returning Fees in Miscellaneous Matters)","M:88":"M:88 (M 88 Order Denying Leave to File Civil Case(s) Under Seal)","M:90":"M:90 (M 90 Order of Attachment)","M:91":"M:91 (M 91 Disbursement to Juror from Petty Cash Fund)","M:92":"M:92 (M 92 Notice Concerning Election for Judicial Disqualification)","M:93":"M:93 (M 93 Letters Rogatory)","M:94":"M:94 (M 94 Other)","M:96":"M:96 (M 96 Attorney Admissions)","M:other":"M:other (Civil Miscellaneous Case - Other)","adsup":"adsup (Administrative Subpoena)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","fordepo":"fordepo (Foreign Deposition)","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","writgar":"writgar (Application for a Writ of Garnishment)"},"nywdce":{"0":"0 (No cause code entered)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2023":"07:2023 (07:2023 Violation of Food Stamp Program Regulations)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451(j)":"08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:191":"12:191 (12:191 Bank Foreclosure)","12:192":"12:192 (12:192 Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act)","12:2601":"12:2601 (Real Estate Settlement Procedures Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","17:1203":"17:1203 (17:1203 Digital Millenniun Copyright Act)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2511":"18:2511 (18:2511 Wiretapping)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1821":"28:1821 (28:1821 Witness Fees, Per Diem, Mileage)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11603":"42:11603 (International Child Abduction Remedies Act)","42:12101":"42:12101 (42:12101 Americans With Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accommodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0502":"49:0502 (49:502 Motor Carrier Safety Act of 1984)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","adsup":"adsup (Administrative Subpoena)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","fordepo":"fordepo (Foreign Deposition)","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","writgar":"writgar (Application for a Writ of Garnishment)"},"ohndce":{"0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8101":"05:8101 (05:8101 Federal Employees Compensation Act )","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2023":"07:2023 (07:2023 Food Stamp Act)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451":"08:1451 (08:1451(a) Revocation of Naturalization )","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1441":"12:1441 (12:1441 Replevin; Action to recover property )","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1221":"15:1221 (15:1221 Auto Dealers Suits Against Manufacturers )","15:1261":"15:1261 (15:1261 Federal Hazardous Substances Act )","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693":"15:1693 (15:1693 Electronic Fund Transfer Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0923":"18:0923 (18:0923 Application for Firearm license )","18:1030":"18:1030 (18:1030 Computer Fraud and Abuse Act)","18:1345":"18:1345 (Injunction Against Fraud )","18:1519":"18:1519 (18:1519 Destruction of Records)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2510":"18:2510 (18:2510 Omnibus Crime Control & Safe Streets Act (1968) )","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1415":"20:1415 (20:1415 Public Education for Handicapped )","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","21:301":"21:301 (21:301 Food and Drug Act )","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6226":"26:6226 (26:6226 Judicial Review of Partnership Adjustments )","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:157e":"28:157e (28:157 Recovery of Property of the Estate )","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (Assistance to Foriegn and International Tribunals )","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0504":"29:0504 (29:504 Request for Administrative Hearing )","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2101":"29:2101 (29:2101 Worker Adjustment & Retraining Notification Act )","29:2661":"29:2661 (29:2661 Family Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","35:252":"35:252 (Patent Non-Infringement )","37:1006":"37:1006 (37:1006 Overpayment of Advance Pay )","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:5301":"38:5301 (38:5301 Nonassignability and Exempt Status of VA Benefits)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405":"42:0405 (42:405 Review of HHS Decision)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11101":"42:11101 (42:11101 Health Care Quality Improvement Act )","42:12131":"42:12131 (42:12131 Americans with Disabilities )","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1985":"42:1985 (42:1985 Conspiracy to Interfere with Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:425":"42:425 (42:425 Social Security Benefits )","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:0781":"46:0781 (46:0781 Public Vessels Act )","46:0971":"46:0971 (46:971 Federal Maritime Lien )","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:0227":"47:0227 (47:227 Violation of the Telephone Consumer Protection Act/Junk Fax Prevention Act)","47:0553":"47:0553 (47:553 Violation of Illegal Interception of Cable System)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:10761":"49:10761 (49:10761 Collection of Unpaid Freight Bills )","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","5:0557":"5:0557 (5:0557 Administrative Procedure Act )","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)"},"ohndea":{"0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8101":"05:8101 (05:8101 Federal Employees Compensation Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2023":"07:2023 (07:2023 Food Stamp Act)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451":"08:1451 (08:1451(a) Revocation of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Award)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1441":"12:1441 (12:1441 Replevin; Action to recover property)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:0717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1221":"15:1221 (15:1221 Auto Dealers Suits Against Manufacturers)","15:1261":"15:1261 (15:1261 Federal Hazardous Substances Act)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0923":"18:0923 (18:0923 Application for Firearm license)","18:1030":"18:1030 (18:1030 Computer Fraud and Abuse Act)","18:1345":"18:1345 (Injunction Against Fraud)","18:1519":"18:1519 (18:1519 Destruction of Records)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2510":"18:2510 (18:2510 Omnibus Crime Control & Safe Streets Act (1968))","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1415":"20:1415 (20:1415 Public Education for Handicapped)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","21:301":"21:301 (21:301 Food and Drug Act)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6226":"26:6226 (26:6226 Judicial Review of Partnership Adjustments)","26:6502":"26:6502 (26:6502 IRS: Enforcement of Tax Liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assualt,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-core))","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Notice of Removal - Account Receivable)","28:1441al":"28:1441al (28:1441 Notice of Removal - Airline Crash)","28:1441as":"28:1441as (28:1441 Notice of Removal - Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Notice of Removal - Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Notice of Removal - Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Notice of Removal - Civil Rights Act)","28:1441df":"28:1441df (28:1441 Notice of Removal - Contract Default)","28:1441dj":"28:1441dj (28:1441 Notice of Removal - Declaratory Judgement)","28:1441ds":"28:1441ds (28:1441 Notice of Removal - Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Notice of Removal - Employment Discrimination)","28:1441fc":"28:1441fc (28:1441 Notice of Removal - Fair Credit Reporting Act)","28:1441fr":"28:1441fr (28:1441 Notice of Removal - Fraud)","28:1441ij":"28:1441ij (28:1441 Notice of Removal - Injunctuve/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Notice of Removal - Insurance Contract)","28:1441int":"28:1441int (28:1441 Notice of Removal - Action for Interpleader)","28:1441lb":"28:1441lb (28:1441 Notice of Removal - Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Notice of Removal - Labor/Mgmnt. Relations)","28:1441mm":"28:1441mm (28:1441 Notice of Removal - Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Notice of Removal - Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Notice of Removal - Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Notice of Removal - Other Contract)","28:1441pd":"28:1441pd (28:1441 Notice of Removal - Property Damage)","28:1441pi":"28:1441pi (28:1441 Notice of Removal - Personal Injury)","28:1441pl":"28:1441pl (28:1441 Notice of Removal - Product Liability)","28:1441pr":"28:1441pr (28:1441 Notice of Removal)","28:1441qt":"28:1441qt (28:1441 Notice of Removal - Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Notice of Removal - Racketeering (RICO) Act)","28:1441sa":"28:1441sa (28:1441 Notice of Removal - SEC Act)","28:1441sf":"28:1441sf (28:1441 Notice of Removal - Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Notice of Removal - Torts to Land)","28:1441tm":"28:1441tm (28:1441 Notice of Removal - Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Notice of Removal - Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Notice of Removal - Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Notice of Removal - Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Notice of Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal - Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Notice of Removal - Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Notice of Removal - Personal Injury)","28:1446pl":"28:1446pl (28:1446 Notice of Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Notice of Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:157e":"28:157e (28:157 Recovery of Property of the Estate)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (Assistance to Foriegn and International Tribunals)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate Sentence (Federal))","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation collective bargaining agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0504":"29:0504 (29:504 Request for Administrative Hearing)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2101":"29:2101 (29:2101 Worker Adjustment & Retraining Notification Act)","29:2661":"29:2661 (29:2661 Family Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act - 1977)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","35:252":"35:252 (Patent Non-Infringement)","37:1006":"37:1006 (37:1006 Overpayment of Advance Pay)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:5301":"38:5301 (38:5301 Nonassignability and Exempt Status of VA Benefits)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405":"42:0405 (42:405 Review of HHS Decision - (DIWC,DIWW))","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11101":"42:11101 (42:11101 Health Care Quality Improvement Act)","42:12131":"42:12131 (42:12131 Americans with Disabilities)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:425":"42:425 (42:425 Social Security Benefits)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:0781":"46:0781 (46:0781 Public Vessels Act)","46:0971":"46:0971 (46:971 Federal Maritime Lien)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:0553":"47:0553 (47:553 Violation of Illegal Interception of Cable System)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:10761":"49:10761 (49:10761 Collection of Unpaid Freight Bills)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summons)","5:0557":"5:0557 (5:0557 Administrative Procedure Act)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"ohsdce":{"0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2617":"29:2617 (29:2617 Family and Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:12101":"42:12101 (42:12101 Americans with Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1985":"42:1985 (42:1985 Conspiracy to Interfere with Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:425":"42:425 (42:425 Social Security Benefits)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:0553":"47:0553 (47:553 Unauthorized Reception of Cable Service)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"okedce":{"0":"0 (No cause code entered)","02:0138":"02:0138 (02:0138 Library of Congress Access)","02:0358":"02:0358 (02:0358 President's Recommendations on Exec., Jud. & Leg. Salary)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","02:0681":"02:0681 (02:0681 Deferral of Budget Authority)","02:1202":"02:1202 (02:1202 Discriminatory practices affecting US Senate employees)","02:1301":"02:1301 (02:1301 Congressional Accountability Act)","02:1317a":"02:1317a (02:1317(a) Violation of Congressional Accountability Act)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:1926":"07:1926 (07:1926 Water and Waste Facility Loans and Grants)","07:2023":"07:2023 (07:2023 Administrative and Judicial Review; Restoration of Rights)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:0287":"08:0287 (08:0287 Petition to Enforce INS Subpoena)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0049":"15:0049 (15:0049 Documentary Evidence; Depositions; Witnesses)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)","16:0019jj":"16:0019jj (16:0019jj Park System Resources Protection Act)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0981":"18:0981 (18:0981 Civil Forfeiture)","18:1034":"18:1034 (18:1034 Civil penalties and injunctions for violations of section 1033)","18:1595":"18:1595 (18:1595 Civil remedy)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","18:923f":"18:923f (18:923 (f)(3) - judicial review of denial or revocation of firearms license)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0352":"21:0352 (21:352 Misbranded Drugs and Devices)","21:0801":"21:0801 (21:801 Comprehensive Drug Abuse Prevention Control Act of 1970)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","22:9000":"22:9000 (22:9000 International Child Abduction Remedies)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0002":"25:0002 (25:2 Duties of Commissioner)","25:0357":"25:0357 (25:0357 Condemnation of lands under laws of States)","25:0450f":"25:0450f (25:0450 Self-Determination Contracts)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1303":"25:1303 (25:1303 Habeas Corpus - Indian Civil Rights Act (detention))","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","25:4044":"25:4044 (25:4044 Reconciliation Report)","25:4101":"25:4101 (25:4101 Native American Housing)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-core))","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346(b)":"28:1346(b) ()","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362":"28:1362 (28:1362 Indian Tribes)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgement)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrimination)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting Act)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interpleader)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:2675":"28:2675 (28:2675 Disposition by Federal Agency as Prerequisite; Evidence)","28:3301":"28:3301 (28:3301 et seq. Fraudulent Transfer)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0215":"29:0215 (29:215 Fair Labor Standards Act - Prohibited Acts; Prima Facie Evidence)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0411":"29:0411 (29:0411 Bill of Rights; Constitution and Bylaws of Labor Organizations)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0701":"29:0701 (29:0701 Rehabilitation Act - Findings/Purpose/Policy)","29:0754":"29:0754 (29:754 Discrimination)","29:0790":"29:0790 (29:0790 Rehabilitation of Labor)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Nondiscrimination under Federal grants and programs)","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2101wa":"29:2101wa (29:2101 Workers Adjustment & Retraining Act)","29:2601":"29:2601 (29:2601 Family & Medical Leave Act)","29:2612":"29:2612 (Leave Requirement)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act - 1977)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recover Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","31:5321":"31:5321 (31:5321 Civil penalties)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","36:0327":"36:0327 (36:0327 Water development projects administered by US Army Corp of Engineers)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4301":"38:4301 (38:4301)","38:4323":"38:4323 (38:4323 Veteran's Reemployment Rights Act)","39:0409":"39:0409 (39:0409 Postal Service)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0233":"42:0233 (42:0233 Civil actions or proceedings against commissioned officers or employees)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0292":"42:0292 (42:0292 Health Professions Education - Student Loans)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11601":"42:11601 (42:11601 International Child Abduction Remedies Act)","42:12101":"42:12101 (42:12101 Employment Discrimination Rehabilitation Act)","42:12112":"42:12112 (42:12112 Discrimination)","42:12181":"42:12181 (42:12181 Americans with Disabilities)","42:12201":"42:12201 (42:12201 Construction)","42:1332":"42:1332 (42:1332 Diversity Jurisdiction)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1395dd":"42:1395dd (42:1395dd Examination & treatment for emergency med. cond.)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:14501":"42:14501 (42:14501 Volunteer Protection Act of 1997)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:3601 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:0945":"43:0945 (43:0945 Compensation for Land Condemnation)","43:0945a":"43:0945a (43:0945a Complaint in Condemnation)","43:0946":"43:0946 (43:0946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0183":"46:0183 (46:183 Limitation of Vessel Owners Liability)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:30505":"46:30505 (46:30505 General Limit of Liability)","47:0201":"47:0201 (47:0201 Service and charges)","47:0227":"47:0227 (47:0227 Restrictions on use of telephone equipment)","47:0605":"47:0605 (47:0605 Unauthorized Publication or Use of Communications)","47:8553":"47:8553 (47:8553)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summons)","49:20109":"49:20109 (49:20109 Employee Protections)","misc":"misc (civil miscellaneous case)"},"okndce":{"0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332n":"28:1332n (28:1332 Diversity-Norplant Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-core))","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgement)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrimination)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting Act)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interpleader)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2617":"29:2617 (29:2617 Family & Medical Leave Act of 1993)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act - 1977)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recover Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)","38:3116":"38:3116 (38:3116 VA Overpayment)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405rs":"42:0405rs (42:405 Review of HHS Decision (RSI))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11603b":"42:11603b (42:11603 International Child Abduction Remedies Act)","42:12101":"42:12101 (42:12101 Americans with Disabilities Act (ADA))","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sh":"42:2000sh (42:2000 Job Discrimination (Sexual Harassment))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summons)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","MDL 1132":"MDL 1132 (MDL 1132 Exterior Insulation Finish System (EIFS) Products Liability Litigation)","MDL1014":"MDL1014 (MDL 1014 Orthopedic Bone Screw Products Liability Litigation)","MDL1038":"MDL1038 (MDL 1038 Norplant Contraceptive Prod. Liability Litigation)","MDL1048":"MDL1048 (MDL 1048 Felbatol Products Liability Litigation)","MDL1057":"MDL1057 (MDL 1057 Telectronics Pacing Sys., Accufix Atrial J Leads)","MDL1060":"MDL1060 (MDL 1060 Baxter Healthcare Corp. Gammagard Prod. Liab. Lit.)","MDL1061":"MDL1061 (MDL 1061 Prudential Ins. Co. of America Sales Practices Lit.)","MDL1203":"MDL1203 (MDL 1203 Diet Drugs Products Liability Litigation)","MDL1214":"MDL1214 (MDL 1214 Great Southern Life Insurance Company Sales Practices Litigation)","MDL1231":"MDL1231 (MDL 1231 Tobacco Litigation)","MDL1252":"MDL1252 (MDL 1252 Multimedia Games, Inc., Securities Litigation)","MDL1296":"MDL1296 (MDL 1296 Alliance Equipment Lease Program Securities Litigation)","MDL1348":"MDL1348 (MDL 1348 Rezulin Products Liability Litigation)","MDL1357":"MDL1357 (MDL 1357 NOS Communications, Inc., Billing Practices Litigation)","MDL1373":"MDL1373 (MDL 1373 Bridgestone/Firestone, Inc., Tires Products Liability Litigation)","MDL1382":"MDL1382 (MDL 1382 Unitrin, Inc., Industrial Life Insurance Litigation)","MDL1387":"MDL1387 (MDL 1387 Protegen Sling and Vesica System Prod. Liab. Lit.)","MDL1393":"MDL1393 (MDL 1393 Cooper Tire & Rubber Co. Tires Products Liability Litigation)","MDL1401":"MDL1401 (MDL 1401 Sulzer Orthopedics Inc. Hip Prosthesis and Knee Prosthesis Products Liability Litigation)","MDL1407":"MDL1407 (MDL 1407 Phenylpropanolamine (PPA) Products Liability Litigation)","MDL1431":"MDL1431 (MDL 1431 Baycol Products Liability Litigation)","MDL1446":"MDL1446 (MDL 1446 Enron Corp. Securities, Derivative & \"ERISA\" Litigation)","MDL1477":"MDL1477 (MDL 1477 Serzone Products Liability Litigation)","MDL1484":"MDL1484 (MDL 1484 Merrill Lynch & Co., Inc., Research Reports Securities Litigation)","MDL1487":"MDL1487 (MDL 1487 Worldcom, Inc., Securities & \"ERISA\" Litigation)","MDL1507":"MDL1507 (MDL 1507 Prempro Products Liability Litigation)","MDL1535":"MDL1535 (MDL 1535 Welding Fume Products Liability Litigation)","MDL1566":"MDL1566 (MDL 1566 Western States Wholesale Natural Gas Antitrust Litigation)","MDL1596":"MDL1596 (MDL 1596 Zyprexa Products Liability Litigation)","MDL1598":"MDL1598 (MDL 1598 Ephedra Products Liability Litigation)","MDL1626":"MDL1626 (MDL 1626 Accutane (Isotretinoin) Products Liability Litigation)","MDL1657":"MDL1657 (MDL 1657 Vioxx Products Liability Litigation)","MDL1699":"MDL1699 (MDL 1699 Bextra and Celebrex Marketing, Sales Practices and Products Liability Litigation)","MDL1708":"MDL1708 (MDL 1708 Guidant Corp. Implantable Defibrillators Products Liability Litigation)","MDL1726":"MDL1726 (MDL 1726 Medtronic, Inc., Implantable Defibrillators Products Liability Litigation)","MDL1742":"MDL1742 (MDL 1742 Ortho Evra Products Liability Litigation)","MDL1763":"MDL1763 (MDL 1763 Human Tissue Products Liability Litigation)","MDL1781":"MDL1781 (MDL 1781 Cintas Corp. Overtime Pay Arbitration Litigation)","MDL1789":"MDL1789 (MDL 1789 Fosamax Products Liability Litigation)","MDL1810":"MDL1810 (MDL 1810 Merscorp Inc., Et Al., Real Estate Settlement Procedures Act (RESPA) Litigation)","MDL1842":"MDL1842 (MDL 1842 Kugel Mesh Hernia Patch Products Liability Litigation)","MDL1845":"MDL1845 (MDL 1845 Conagra Peanut Butter Products Liability Litigation)","MDL1905":"MDL1905 (MDL 1905 Medtronic, Inc., Sprint Fidelis Leads Products Liability Litigation)","MDL1909":"MDL1909 (MDL 1909 Gadolinium Contrast Dyes Products Liability Litigation)","MDL1928":"MDL1928 (MDL 1928 Trasylol Products Liability Litigation)","MDL1957":"MDL1957 (MDL 1957 Aftermarket Automotive Filters Antitrust Litigation)","MDL1989":"MDL1989 (MDL 1989 Semgroup Energy Partners, L.P., Securities Litigation)","MDL1999":"MDL1999 (MDL 1999 Lawnmower Engine Horsepower Marketing and Sales Practices Litigation (No.II))","MDL2004":"MDL2004 (MDL 2004 Mentor Corp. Obtape Transobturator Sling Products Liability Litigation)","MDL2016":"MDL2016 (MDL 2016 Yamaha Motor Corp. Rhino ATV Products Liability Litigation)","MDL2048":"MDL2048 (MDL 2048 Cox Enterprises, Inc., Set-Top Cable Television Box Antitrust Litigation)","MDL2051":"MDL2051 (MDL 2051 Denture Cream Products Liability Litigation)","MDL2083":"MDL2083 (MDL 2083 KBR, Inc., Burn Pit Litigation)","MDL2100":"MDL2100 (MDL 2100 Yasmin and Yaz (Drospirenone) Marketing, Sales Practices and Products Liability Litigation)","MDL2165":"MDL2165 (MDL 2165 Endangered Species Act Section 4 Deadline Litigation)","MDL2197":"MDL2197 (MDL 2197 Depuy Orthopaedics, Inc., ASR Hip Implant Products Liability Litigation)","MDL2244":"MDL2244 (MDL 2244 Depuy Orthopaedics, Inc., Pinnacle Hip Implant Products Liability Litigation)","MDL2272":"MDL2272 (MDL 2272 Zimmer Nexgen Knee Implant Products Liability Litigation)","MDL2299":"MDL2299 (MDL 2299 Actos Products Liability Litigation)","MDL2325":"MDL2325 (MDL 2325 American Medical Systems, Inc., Pelvic Repair System Products Liability Litigation)","MDL2342":"MDL2342 (MDL 2342 Zoloft (Sertraline Hydrochloride) Products Liability Litigation)","MDL2391":"MDL2391 (MDL 2391 Biomet M2A Magnum Hip Implant Products Liability Litigation)","MDL2428":"MDL2428 (MDL 2428 Fresenius Granuflo/Naturalyte Dialysate Products Liability Litigation)","MDL2434":"MDL2434 (MDL 2434 Mirena IUD Products Liability Litigation)","MDL2441":"MDL2441 (MDL 2441 Stryker Rejuvenate and ABG II Hip Implant Products Liability Litigation)","MDL2522":"MDL2522 (MDL 2522 Target Corporation Customer Data Security Breach Litigation)","MDL2543":"MDL2543 (MDL 2543 General Motors LLC Ignition Switch Litigation)","MDL2570":"MDL2570 (MDL 2570 Cook Medical, Inc., IVC Filters Marketing, Sales Practices and Products Liability Lit)","MDL2592":"MDL2592 (MDL 2592 Xarelto (Rivaroxaban) Products Liability Litigation)","MDL2599":"MDL2599 (MDL 2599 Takata Airbag Products Liability Litigation)","MDL2600":"MDL2600 (MDL 2600 Protegrity Corporation and Protegrity USA, Inc., Patent Litigation)","MDL2605":"MDL2605 (MDL 2605 Nutek Baby Wipes Products Liability Litigation)","MDL2619":"MDL2619 (MDL 2619 Herbal Supplements Marketing and Sales Practices Litigation)","MDL2641":"MDL2641 (MDL 2641 Bard IVC Filters Products Liability Litigation)","MDL2656":"MDL2656 (MDL 2656 Domestic Airline Travel Antitrust Litigation)","MDL2672":"MDL2672 (MDL 2672 Volkswagen \"Clean Diesel\" Marketing, Sales Practices and Products Liability Litig)","MDL2677":"MDL2677 (MDL 2677 Daily Fantasy Sports Litigation)","MDL2700":"MDL2700 (MDL 2700 Genentech Herceptin (Trastuzumab) Marketing and Sales Practices Litigation)","MDL2709":"MDL2709 (MDL 2709 Dollar General Corp. Motor Oil Marketing and Sales Practices Litigation)","MDL2741":"MDL2741 (Roundup Products Liability Litigation)","MDL2782":"MDL2782 (MDL 2782 Ethicon Physiomesh Flexible Composite Hernia Mesh Products Liability Litigation)","MDL2789":"MDL2789 (MDL 2789 Proton-Pump Inhibitor Products Liability Litigation (No. II))","MDL2800":"MDL2800 (MDL 2800 Equifax, Inc., Customer Data Security Breach Litigation)","MDL2804":"MDL2804 (MDL 2804 National Prescription Opiate Litigation)","MDL2809":"MDL2809 (MDL 2809 Onglyza (Saxagliptin) & Kimbiglyze XR (Saxagliptin & Metformin) Products Liability Lit.)","MDL865":"MDL865 (MDL 865 Showa Denko K.K. L-Tryptophan Prod. Liability Lit.)","MDL875":"MDL875 (MDL 875 Asbestos Products Liability Litigation)","MDL899":"MDL899 (MDL 899 Mortgage Escrow Deposit Litigation)","MDL907":"MDL907 (MDL 907 Eli Lilly & Co. Prozac Products Liability Litigation)","MDL926":"MDL926 (MDL 926 Silicone Gel Breast Implants Prod. Liability Lit.)","admin":"admin (Administrative)","misc":"misc (Civil Miscellaneous Case)"},"okwdce":{"*41*":"*41* ( )","0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:287":"08:287 (08:287 Petition To Enforce INS Subpoena)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:107":"20:107 (20:107 OPERATION OF VENDING FACILITIES)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA))","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0636":"28:0636 (28:0636 Appeal from Magistrate's Order)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgement)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle)","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))","28:2241s":"28:2241s (28:2241 Petition for Writ of Habeas Corpus (state))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2601":"29:2601 (29:2601 Pursuant to the Family Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claim Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:3131":"40:3131 (40:3131 Miller Act)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:294":"42:294 (Default In A Health Education Assistance Loan (HEAL))","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clean Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","md":"md (Probation Transfer Case)","misc":"misc (Civil Miscellaneous Case)"},"ordce":{"00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552(b)":"05:0552(b) (05:0552(b) Sunshine Act )","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:0706":"05:0706 (5:706 Administrative Procedures Act(Judicial Review))","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:0608":"07:0608 (Agricultural Adjustment Act )","07:0610":"07:0610 (7:610(h) Agricultural Marketing Service Subpoena )","07:1501":"07:1501 (7:1501 Federal Crop Insurance Act )","07:2011":"07:2011 (7:2011 Food Stamp Act )","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:0287":"08:0287 (Petition to Enforce INS Subpoena)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1182":"08:1182 (08:1182 Immigration & Nationality Act of 1990)","08:1183":"08:1183 (08:1182a Enforcement of an Affidavit of Support)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1373":"08:1373 (8 U.S. Code Â§ 1373 - Communication between Gov't. agencies and the INS)","08:1421":"08:1421 (08:1421 Immigration & Nationality Act - Review of Denial of Application)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1447":"08:1447 (8:1447 Hearings on Denials of Applications for Naturalization)","08:1451":"08:1451 (08:1451 Revocation of Naturalization)","08:1503":"08:1503 (08:1503 Denial of Rights and Privileges as National)","08:1644":"08:1644 (8 U.S. Code Â§ 1644 - Communication between State and local gov't agencies and INS)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Award)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","11:0110":"11:0110 (11:0110 Bankruptcy Petition Preparer Section )","11:0542":"11:0542 (11:0542 Turnover of Property to the Estate)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1441":"12:1441 (12:1441 Home Owners' Loan Act of 1933 )","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1701":"12:1701 (12:1701 National Housing Act of 1934 )","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:2001":"12:2001 (12:2001 Farm Credit Act of 1971 )","12:2201":"12:2201 (Agricultural Credit Act of 1987 )","12:2605":"12:2605 (12:2605 Real Estate Settlement Procedures Act )","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1221":"15:1221 (15:1221 Automobile Dealers Day-in-Court Act )","15:1261":"15:1261 (15:1261 Federal Hazardous Substance Act)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693e":"15:1693e (15:1693e Preauthorized transfers)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)","16:0460":"16:0460 (Hells Canyon National Recreation Area Act)","16:0470":"16:0470 (National Historic Preservation Act )","16:0544":"16:0544 (16:0544 Columbia River Gorge National Scenic Area Act )","16:0618":"16:0618 (16:0618 Federal Timber Contract Payment Modification Act )","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1531":"16:1531 (16:1531 Endangered Species Act )","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:1600":"16:1600 (National Forest Management Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0709":"18:0709 (18:709 False Advertising or Misuse of Names)","18:0923":"18:0923 (18:923 Petition Judicial Review, Firearm Licensing Violation)","18:0981":"18:0981 (18:981 Civil Forfeiture)","18:1030":"18:1030 (18:1030(g) Fraud and Related Activity in Connection with Computers)","18:1595":"18:1595 (18:1595 Civil Remedy Victims of Trafficking and Violence Protection Act of 2000)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:1965":"18:1965 (18:1965 (RICO))","18:3663":"18:3663 (18:3663(h) Enforce Order of Restitution )","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0331":"21:0331 (Food, Drug, & Cosmetics Act )","21:0332":"21:0332 (Federal Food Drug & Cosmetic Act)","21:0334":"21:0334 (Food Drug and Cosmetics Act)","21:0801":"21:0801 (21:801 Drug Abuse Prevention & Control )","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","22:6021cu":"22:6021cu (Cuban Liberty & Democratic Solidarity Act of 1996 )","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1303":"25:1303 (Indian Habeas Corpus )","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","25:7601":"25:7601 (Indian Gaming Regulatory Act )","26:3101":"26:3101 (26:3101 Federal Insurance Contributions Act)","26:5041":"26:5041 (26:5041 Imposition of Tax - Credit for Small Domestic Producers)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6330":"26:6330 (26:6330 Seizure of Property for Collection of Taxes - Due Process)","26:6331":"26:6331 (26:6331 Seizure of Property for Collection of Taxes- Levy)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different District )","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331epa":"28:1331epa (28:1331 Federal Question - Environmental Action Under CERCLA)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332cl":"28:1332cl (28:1332cl Class Action Fairness Action - 2005)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345o":"28:1345o (28:1345 Other )","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346o":"28:1346o (28:1346 Other )","28:1346pi":"28:1346pi (28:1346 Personal Injury )","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1350":"28:1350 (28:1350 Alien Action for Tort)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1363":"28:1363 (Violation of Juror Employment Protection )","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Multidistrict Litigation)","28:1412":"28:1412 (28:1412 Change of Venue)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1602":"28:1602 (28:1602 Foreign Sovereign Immunities Act )","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition Writ of Habeas Corpus (Federal))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Petition for Writ of Habeas Corpus - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2601":"28:2601 (28:2601 Family Medical Leave Act )","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:2675":"28:2675 (28:2675 Motor Vehicle Damages involving USPS employee )","28:3000":"28:3000 (28:3000 Federal Debt Collection Procedures Act )","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Fair Labor Standards Act - Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act of 1938)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0207":"29:0207 (29:207 Fair Labor Standards Act - Maximum Hours)","29:0216":"29:0216 (29:0216 Fair Labor Standards Act)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0411":"29:0411 (29:0411 Union Workers Freedom of Speech)","29:0464":"29:0464 (29:464 Labor Managment Reporting-Disclosure; Civ Enforcement)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0790":"29:0790 (29:790 Rehabilitation of Labor )","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fund)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1140":"29:1140 (29:1140 ERISA-Interference with Protected Rights )","29:1145":"29:1145 (29:1145 Employee Retirement Income Security Act)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1166":"29:1166 (29:1166 Consolidated Omnibus Reconciliation Act of 1985 )","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2101":"29:2101 (29:2101-2104 (WARN) Worker Adjustment and Retraining Notification)","29:2601":"29:2601 (29:2601 Family & Medical Leave Act)","29:2617":"29:2617 (29:2617 Family and Medical Leave Act Discrimination)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","31:5324":"31:5324 (31:5324 Structuring Transactions to Evade Reporting Requirement)","32:4300":"32:4300 (32:4300 Uniformed Services Employment & Reemployment Rights Act)","33:0901":"33:0901 (33:0901 Longshore & Harbor Worker's Compensation Act )","33:0905":"33:0905 (33:0905 Longshore & Harbor Workers - Employer Liability)","33:0921":"33:0921 (33:921(d) Longshore & Harbor Workers Compensation Act )","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1321":"33:1321 (Clean Water Act - Oil & Hazardous Substance Liability)","33:1365":"33:1365 (33:1365 Environmental Matters)","33:2701":"33:2701 (33:2701 Oil Pollution Act of 1990 )","35:0102":"35:0102 (35:102 Invalidity and Nonenforceability of U.S. Patent)","35:0145":"35:0145 (35:145 Civil Action to Obtain Patent)","35:0183":"35:0183 (35:183 Patent - Right to Compensation)","35:0271":"35:0271 (35:271 Patent Infringement)","38:0301":"38:0301 (38:301 et seq Veterans Affairs, General Benefits )","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4301":"38:4301 (38:4301 Uniformed Services Employment & Re-Employment Rights Act)","39:0409":"39:0409 (Suits by and against U.S. Postal Service)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:3133":"40:3133 (40:3133 Miller Act)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:0601":"41:0601 (Contract Disputes Act of 1978 )","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0233":"42:0233 (42:0233(c) Removal of tort action against United States)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0300":"42:0300 (42:0300(aa) National Vaccine Injury Compensation Act (NVIC))","42:0300(j)":"42:0300(j) (Safe Drinking Water)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405g":"42:0405g (42:0405g Review of Commissioner's Final Decision)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0425":"42:0425 (42:425 Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:10804":"42:10804 (42:10804 Protection/Advocacy for the Mentally Ill )","42:11101":"42:11101 (Federal Health Care Quality Improvement Act)","42:11601":"42:11601 (International Child Abduction Remedies Act)","42:12101":"42:12101 (42:12101 Americans with Disabilities Act)","42:12102":"42:12102 (42:12102 Americans With Disabilities Act )","42:12111":"42:12111 (42:12111 Americans With Disabilities Act )","42:12201":"42:12201 (42:12201 Americans With Disabilities Act-Injured Worker Discrimination)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:14141":"42:14141 (42:14141 Violent Crime Control and Law Enforcement Act of 1994)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000bb":"42:2000bb (42:2000bb Religious Freedom Restoration Act )","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:4601":"42:4601 (42:4601 Uniform Relocation Act )","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:6972":"42:6972 (42:6972 Resource Conservation & Recovery Act )","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9601":"42:9601 (42:9601 CERCLA Hazardous Waste Cleanup Costs )","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","42:9659":"42:9659 (42 USC 9659 Comprehensive Environmental Response, Compensation & Liability Act (CERCLA))","43:0666":"43:0666 (43:666 McCarran Amendment )","43:0945":"43:0945 (Compensatin for Land Condemnation)","43:0945a":"43:0945a (Complaint in Condemnation)","43:0946":"43:0946 (Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0181":"46:0181 (46:0181 Exoneration/Limitation of Liability - Bodily Injury )","46:0183":"46:0183 (46:0183 Exoneration/Limitation of Liability )","46:0688":"46:0688 (46:688 Jones Act)","46:0740":"46:0740 (Collision of Vessels in Navigable Waters)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:0911":"46:0911 (46:0911 Ship Mortgage Act )","46:0971":"46:0971 (46:0971 Maritime Liens )","46:10601":"46:10601 (46:10601 Fishing Agreements)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:1300":"46:1300 (46:1300 Carriage of Goods by Sea Act )","46:31322":"46:31322 (46:31322 Mortgage Act of 1920 )","47:0151":"47:0151 (47:151 Complaint for pmt of Telecommunication Services )","47:0252":"47:0252 (Telecommunications Act of 1996)","47:0553":"47:0553 (47:0553 Cable Communications Policy Act of 1984)","47:0605":"47:0605 (Unauthorized Publication or use of Communications)","47:227":"47:227 (47:227 Restrictions on Use of Telephone Equipment)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:10101":"49:10101 (49:10101 Interstate Commerce Act )","49:10761":"49:10761 (49:10761 Interstate Commerce Act Rate Requirements)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)","49:11707":"49:11707 (49:11707 Carmack Amendment )","49:13501":"49:13501 (49:13501 Violation of Fed Leasing Statutes and Regulations)","49:13906":"49:13906 (49:13906 Security of Motor Carriers, Brokers, and Freight Forwarders)","49:14102":"49:14102 (49:14102 Violation of Fed Leasing Statutes and Regulations)","49:14501":"49:14501 (49:14501 Fed Preemption of Local Solid Waste Ordinances )","49:14704":"49:14704 (49:14704 Violation of Fed Leasing Statutes and Regulations)","49:14706":"49:14706 (49:14706 Interstate Transportation - Carmack Amendment)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","49:20101":"49:20101 (49:20101 Federal Railroad Authorization Act of 1994 )","49:31105":"49:31105 (Surface Transportation Assistance Act of 1982)","49:32703":"49:32703 (49 USC 32703 Odometer Tampering )","49:60101":"49:60101 (49:60101 Natural Gas Pipeline Safety Act )","misc":"misc (Civil Miscellaneous Case)"},"paedce":{"0":"0 (00:0000)","02:0138":"02:0138 (02:138 Library of Congress Access)","02:0358":"02:0358 (02:358 President's Recommendations on Exec., Jud. & Leg. Salary)","02:0431":"02:0431 (02:431 Federal Election Commission: Failure to Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","02:0681":"02:0681 (02:681 Deferral of Budget Authority)","02:1202":"02:1202 (02:1202 Discriminatory practices affecting US Senate employees)","02:1301":"02:1301 (02:1301 Congressional Accountability Act)","02:1317(a)":"02:1317(a) (02:1317(a) Violation of Congressional Accountability Act)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:0706(2)":"05:0706(2) (05:0706(2) Defense Base Closure & Realignment Act of 1990)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8131":"05:8131 (05:8131 Federal Employee's Compensation Act (FECA))","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","05:8701":"05:8701 (05:8701 Federal Employees Group Life Insurance Act of 1954)","05:8901":"05:8901 (05:8901 Federal Employees Health Benefits Act)","06:(a)(4)":"06:(a)(4) (06:(a)(4) Inspector General Act of 1978)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2023(a)":"07:2023(a) (7:2023(a) Judicial Review of Food Stamp Disqualification)","07:2024":"07:2024 (07:2024 False Claims Act, Food Stamp Fraud)","07:2131":"07:2131 (07:U.S.C. 2131 Violation of the Animal Welfare Act)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1158":"08:1158 (08:1158 Immigration & Nationality Act, Section 208)","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1251(A)":"08:1251(A) (08:1251(A)(4) Application for a Stay of Deportation)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1255":"08:1255 (08:1255 Failure USCIS To Adjudicate Permanent Residency Petition)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1421(c)":"08:1421(c) (08:1421(c) Petition for Review of Naturalization)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451(j)":"08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0007":"09:0007 (09:0007 Petition to Enforce Arbitration Subpoena)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","09:201":"09:201 (Petition to Compel/Stay Arbitration under an Insurance Contract)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1":"12:1 (12:USCS Sec. 1 Wrongful wire transaction)","12:1345":"12:1345 (12:1345 Financial Inst. Reform Recov. & Enforc. Act of 1989)","12:1421":"12:1421 (12:1421 Federal Home Loan Bank Act)","12:1451":"12:1451 (12:1451 Emergency Home Finance Act of 1970)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1701x":"12:1701x (12:1701x(a)(5) National Affordable Housing Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1715(b)":"12:1715(b) (12:1715(b) HUD Mortgage Assignment Program)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1786":"12:1786 (12:1786 Termination of insured Credit Union Status)","12:1811":"12:1811 (12:1811 Financial Inst. Reform Recov. & Enforc. Act of 1989)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1831d":"12:1831d (12:1831d Deposit. Inst. Dereg. & Monetary Ctrl. Act of 1980)","12:191":"12:191 (12:191 Bank Foreclosure)","12:192":"12:192 (12:192 Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act)","12:2604(c)":"12:2604(c) (12:2604(c) Real Estate Settlement Procedures Act (RESPA))","12:2609":"12:2609 (12:2609 Real Estate Settlement Procedures Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","12:3751":"12:3751 (12:3751 Single Family Mortgage Forclosure Act)","12:4901":"12:4901 (12:4901 Dodd-Frank Act)","12:5101":"12:5101 (12:5101 Fraudulent Transfer Act)","12:5211":"12:5211 (12:5211 Troubled Asset Relief Program (\"TARP\"))","12:8632":"12:8632 (12:8632 Federal Reserve Act)","12:93(a)":"12:93(a) (12:93(a) National Bank Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1267(a)":"15:1267(a) (15:1267(a) Federal Hazardous Substances Act)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1667":"15:1667 (15:1667 Consumer Leasing Act)","15:1679":"15:1679 (15:1679 Credit Repair Organizations Act)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1691":"15:1691 (15:1691 Equal Credit Opportunity Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693ef":"15:1693ef (15:1693 Electronic Funds Transfer Act)","15:1693m":"15:1693m (Violation of Prov. of Subchpt.VI (Electronic Fund Transfers))","15:1701":"15:1701 (15:1701 Interstate Land Sales Full Disclosure Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:30-35":"15:30-35 (15:30-35 Investment Company Act of 1940)","15:3710a":"15:3710a (15:3710a Federal Technology Transfer Act of 1986)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","15:80":"15:80 (15:80 Investment Company Act)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:0823":"16:0823 (Federal Public Utility Regulatory Policies Act, 16 U.S.C.)","16:1374(d)(6)":"16:1374(d)(6) (16:1374(d)(6) Petition for Review re Application for Import of Polar Bear Trophies)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","16:470(f)":"16:470(f) (16:470(f) National Historic Preservation Act)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0981a":"18:0981a (18:0981(a)(1)(A) Money Laundering Control Act)","18:1030":"18:1030 (18:1030 Federal Computer Fraud & Abuse Act)","18:1332(d)":"18:1332(d) (18:1332(d) Class Action Fairness Act (CAFA))","18:1345":"18:1345 (18:1345 Mail Fraud Injunction)","18:1514A":"18:1514A (18:1514A Sarbanes-Oxley Act)","18:1836a":"18:1836a (18:1836(a) Injunction Against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2333":"18:2333 (18:2333 Anti-Terrorism Act of 1991-Civil Remedies)","18:2382":"18:2382 (18:2382 Misprision of treason)","18:248":"18:248 (18:248 Freedom of Access to Clinic Entrances Act)","18:248(1994)":"18:248(1994) (18:248(1994) Freedom of Access to Clinic Entrances Act (FACE))","18:2511":"18:2511 (18:2511 Wiretapping)","18:2710":"18:2710 (18:2710 Electronic Communication Protection Act (ECPA))","18:2721":"18:2721 (18:2721 Federal Drivers Privacy Protection Act)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","18:923f3":"18:923f3 (18:923(f)(3) Review of Revocation of a License as a Dealer in Firearms)","18:925(c)":"18:925(c) (18:925(c) Restoration of ability to possess firearms/ammo)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1095(a)(6)":"20:1095(a)(6) (20:1095(a)(6) Higher Education Act of 1965)","20:1232(g)":"20:1232(g) (20:1232(g) Family Education Rights & Privacy Act of 1974)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Appeal From The Decision Of The Special Education Appeals Panel (IDEIA))","20:1415":"20:1415 (20:1415(e)(2) Individuals with Disabilities Education Act)","21:0332(a)":"21:0332(a) (21:0332(a) Federal Food, Drug, and Cosmetic Act)","21:0601":"21:0601 (21:0601-0695 Federal Meat Inspection Act (the Act))","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6672":"26:6672 (26:6672 Trust Fund Recovery Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7434":"26:7434 (26:7434 Civil Damages for Fraudulent Filing of Information Returns)","26:7604a":"26:7604a (26:7604a IRS: Complaint to Enforce IRS Summons)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157":"28:0157 (28:0157 Withdrawal of Reference)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1131":"28:1131 (28:1131 Violation of Lanham Act and Unfair Competition)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331va":"28:1331va (28:1331 Fed. Question: Violation 5th & 14th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332":"28:1332 (28:1332 Diversity - Misappropriation of Trade Secrets)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332d5B":"28:1332d5B (28:1332(d)(5)(B) Diversity of Citizenship under CAFA)","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Carriage of Goods by Sea Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1350":"28:1350 (28:1350 Alien Tort Claims Act)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Notice of Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Notice of Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Notice of Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Notice of Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Notice of Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Notice of Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Notice of Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Notice of Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Notice of Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Notice of Removal - Employment Discrimination)","28:1441fc":"28:1441fc (28:1441 Notice of Removal - Fair Credit Reporting)","28:1441fr":"28:1441fr (28:1441 Notice of Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Notice of Removal- Injunctive/Declaratory)","28:1441in":"28:1441in (28:1441 Notice of Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Notice of Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Notice of Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Notice of Removal- Labor/Mgmnt. Relation)","28:1441mm":"28:1441mm (28:1441 Notice of Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Notice of Removal- Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Notice of Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Notice of Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Notice of Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Notice of Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Notice of Removal- Product Liability)","28:1441qt":"28:1441qt (28:1441 Notice of Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Notice of Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Notice of Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Notice of Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Notice of Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Notice of Removal- Tort/Motor Vehicle)","28:1441tn":"28:1441tn (28:1441 Notice of Removal- Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Notice of Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Notice of Removal- Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Notice of Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Notice of Removal- Property Damage)","28:1446pi":"28:1446pi (28:1446 Notice of Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Notice of Removal - Product Liability)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1491":"28:1491 (28:1491 Tucker Act)","28:1602":"28:1602 (28:1602 Foreign Sovereign Immunities Act)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1715":"28:1715 (28:1715 Class Action Fairness Act of 2005)","28:1738A":"28:1738A (28:1738A The Uniform Child Custody Jurisdiction Act)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1875":"28:1875 (28 U.S.C. 1875 Jury Systems Improvement Act)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254dp":"28:2254dp (28:2254dp Petition for Writ of Habeas Corpus (DEATH PENALTY))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:2679":"28:2679 (28:2679 Federal Driver's Act)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0158(b)":"29:0158(b) (29:0158(b) National Labor Relations Act)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:0794ra":"29:0794ra (29:0794ra Rehabilitation Act of 1973)","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1161":"29:1161 (29:1161 COBRA)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2000(e)":"29:2000(e) (29:2000(e)(k) Pregnancy Discrimination Act)","29:207(a)":"29:207(a) (29:207(a) Action for Overtime Wage Violation)","29:2104":"29:2104 (29:2104 Worker Adjustment & Retraining Notification (WARN))","29:2601":"29:2601 (29:2601 Family Medical Act of 1993)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3129(h)":"31:3129(h) (31:3129(h) False Claims Act Whistle Blower Protection)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","31:5332(a)":"31:5332(a) (31:5332(a) Evading Currency Reporting Requirement)","31:9701":"31:9701 (31:9701 Federal User Charge Statute)","33:0905(b)":"33:0905(b) (33:0905(b) Longshoremen Workers' Compensation Act)","33:1221":"33:1221 (Ports and Waterways Safety Act)","33:1251":"33:1251 (33:1251 Federal Water Pollution Control Act)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","33:2701":"33:2701 (33:2701 Oil Pollution Act of 1940)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0146":"35:0146 (35:0146 Appeal from Decision of the Board of Patent Appeals)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","35:0297":"35:0297 (35:0297 American Inventors Protection Act)","36:0371":"36:0371 (36:0371 Amateur Sports Act of 1978)","38:0775":"38:0775 (38:0775 Recovery of Servicemen's Group Life Insurance)","38:0784":"38:0784 (38:0784 Suit for Veterans Insurance)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2001":"38:2001 (38:2001 Vietnam Veteran Readjustment Act)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (38:2021 Right to Re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4301":"38:4301 (38:4301 Uniformed Srvs. Employment & Reemployment Rights Act)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:3008(e)":"39:3008(e) (39:3008(e) Enforce compliance with a USPS Prohibitory Order)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0275":"40:0275 (40:0275 Condemnation (Eminent Domain))","40:0276":"40:0276 (40:0276 Davis-Bacon Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:0423":"41:0423 (41:0423 Procurement Integrity Act)","41:0502":"41:0502 (41:0502 Pennsylvania Usury Act)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42.29":"42.29 (Bill of Lading Act 42.29 U.S.C. APP (1988 ED.) 122)","42:0151":"42:0151 (42:0151 Federal Communications Act)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:0601":"42:0601 (42:0601 Title IV-A of the Social Security Act)","42:11001":"42:11001 (42:11001 Emergency Plan. & Comm. Right to Know Act (EPCRA))","42:1101":"42:1101 (42:1101 Health Care Quality Improvement Act of 1986)","42:11603":"42:11603 (42:11603(b) Int'l. Child Abduction in Remedies Act (ICARA))","42:12101":"42:12101 (42:12101 The Americans with Disabilities Act of 1990)","42:1320":"42:1320 (42:1320 01-1 Health Insurance Portability And Accountability Act (HIPAA))","42:1320(a)-7b(b)(2)(A)":"42:1320(a)-7b(b)(2)(A) (42:1320(a)-7b(b)(2)(A) Anti-Kickback Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1385":"42:1385 (42:1385 Medicare Health Act)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1396sa":"42:1396sa (42:1396 Title XIX of the Social Security Act)","42:1399(dd)":"42:1399(dd) (42:1399(dd) Emergency Medical Treatment and Active Labor Act)","42:1437":"42:1437 (42:1437 U.S. Housing Act of 1937)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1971":"42:1971 (42:1971 Voting Rights Law)","42:1973gg":"42:1973gg (42:1973gg-2 Nat'l. Voter Registration Act of 1993 (NVRA))","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:1997":"42:1997 (42:1997 Institutionalized Persons Act of 1980)","42:2000":"42:2000 (42:2000(e)2(a) Family and Medical Leave Act)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000bb":"42:2000bb (42:2000bb Religious Freedom Restoration Act of 1993)","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sh":"42:2000sh (42:2000 Job Discrimination (Sexual Harassment))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:234":"42:234 (42:234 Defaulted Public Health Service Corps loan)","42:2615":"42:2615 (42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:300":"42:300 (42:300 Safe Drinking Water Act)","42:300aa-1":"42:300aa-1 (42:300aa-1 Nat'l. Childhood Vaccine Injury Compensation Act)","42:3058":"42:3058 (Older American's Act of 1965, 42 U.S.C. 3058(g))","42:3601":"42:3601 (42:405 Fair Housing Act)","42:3604(f)":"42:3604(f) (42:3604(f)(3)(C) Fair Housing Amendments Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:5300":"42:5300 (42:5300 Block Grant Act of 1974)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:6972":"42:6972 (42:6972(a) Solid Waste Disposal Act)","42:7401":"42:7401 (42:7401 Clean Air Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:8324":"42:8324 (42:8324 PA Storage Tank and Spill Prevention Act)","42:8351":"42:8351 (42:8351 Pennsylvania Dragonetti Act)","42:9604":"42:9604 (42:9604 Comprehensive Envir. Comp. & Liab. Act (CERCLA))","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:1421":"43:1421 (Whistle Blower Law)","43:260":"43:260 (43:260 Wage Payment and Collection Law (WPCL))","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0153":"45:0153 (45:0153, First (p) Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:0351":"45:0351 (45:351 Railroad Unemployment Insurance Act)","45:0581(c)":"45:0581(c) (45:0581(c) Rail Passenger Service Act)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0183":"46:0183 (46:0183 Exoneration, Limitation of Liability)","46:0688":"46:0688 (46:0688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:1300":"46:1300 (46:1300 Carriage of Goods by Sea Act (COGSA))","46:1701":"46:1701 (46:1701 Shipping Act of 1984)","46:31301":"46:31301 (46:31301-31343 Maritime Commercial Instruments and Liens Act)","46:741":"46:741 (46:741 Suits In Admiralty Act)","46:7701":"46:7701 (46:7701 Enforcement of a United States Coast Guard)","46:781":"46:781 (46:781 Public Vessels Act)","47:0151":"47:0151 (47:0151 Communications Act of 1934)","47:0553":"47:0553 (47:553 U.S.C.A. Cable Communications Policy Act)","47:0605":"47:0605 (47:0605 Unlawful Reception Broadcast Signal i.e., Satellite)","47:227":"47:227 (47:227(b)(3) Telephone Consumer Protection Act of 1991)","47:254(h)":"47:254(h) (47:254(h) Children's Internet Protection Act)","47:332(c)":"47:332(c) (47:332(c) Federal Telecommunications Act of 1996)","47:521":"47:521 (Cable Televsn. Consumer Protection & Competition Act of 1992)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:101":"49:101 (49:101 ICC Termination Act of 1996)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:11707":"49:11707 (49:11707 Carmack Amendment)","49:1431":"49:1431 (49:1431 Noise Control Act of 1972)","49:14501":"49:14501 (49:14501 Preemption)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1502":"49:1502 (49:1502 Warsaw Convention)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","49:20109":"49:20109 (49:20109 Federal Railroad Safety Act of 1970)","49:20301-20306":"49:20301-20306 (49:20301-20306 Federal Safety Appliance Act)","49:2101":"49:2101 (49:2101 Aviation Safety & Noise Abatement Act of 1979)","49:3102":"49:3102 (49:3102 Federal Motor Carrier Safety Regulations Act)","49:31105":"49:31105 (49:31105 Surface Transportation Assistance Act (STAA))","49:32101":"49:32101 (49:32101 Motor Vehicle Information and Costs Savings Act)","49:32701":"49:32701 (49:32701 Odometer Requirements Act)","49:41705":"49:41705 (49:41705 Air Carrier Access Act)","49:80101":"49:80101 (49:80101 Bills of Lading Act)","50:1701-06":"50:1701-06 (50:1701-06 International Emergency Economic Powers Act)","72:1301.1":"72:1301.1 (72:1301.1 (DAUPA) Dispositon of Abandoned and Unclaimed Property Act)","73:2001":"73:2001 (73:2001 Unsolicited Merchandise Act)","73:201":"73:201 (73:201 Violation of the Pennsylvania Consumer Fraud Act, and all other Acts in the United States)","73:2270":"73:2270 (73:2270 Violation of Real Estate Settlement Procedures Act)","77:0671":"77:0671 (77:671 Pennsylvania Workers' Compensation Act)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","PA:221":"PA:221 (PA:221 Article 5(b) of the Landlord & Tenant Act)","adsup":"adsup (Administrative Subpoena)","affseizwar":"affseizwar (Application and Affidavit for Seizure Warrant)","appadm":"appadm (Application for Admission)","appcounsel":"appcounsel (Appointment of Court Appointed Counsel)","appentprem":"appentprem (Application of the U.S. to enter premises to Effect Levy)","appltrrog":"appltrrog (Application for Letters Rogatory)","appointrec":"appointrec (Appointment of Receiver)","appt":"appt (Appointment)","apptsm":"apptsm (Appointment of Special Master)","appttrust":"appttrust (Appointment of Trustee)","certL.R.12":"certL.R.12 (Certifying Students to Practice Under L.R. 12)","certLR83.5":"certLR83.5 (Certifying Students to Practice Under L.R. 83.5)","certobk":"certobk (Certified Copy of Order from Bankruptcy Court)","certousca":"certousca (Certified Copy of Order from U.S.C.A)","cmpextr":"cmpextr (Complaint for Extadition)","confarbawd":"confarbawd (Motion for Confirmation of Arbitration Award)","contempt":"contempt (Contempt Proceedings)","cpodd":"cpodd (copy of Order from Another District Court)","disbar":"disbar (Disbarment Proceedings)","eeocom":"eeocom (Equal Employment Opportunity Commission Complaint)","enfadsup":"enfadsup (Enforcement of Administrative Subpoena)","fordepo":"fordepo (Foreign Deposition)","minspwarr":"minspwarr (Motion for Inspection Warrant Under the OSHA of 1970)","misc":"misc (Civil Miscellaneous Case)","motamd":"motamd (Motion to Amend)","motappt":"motappt (Motion to Appoint)","motcomp":"motcomp (Motion to Compel)","motcompset":"motcompset (Motion to Compel Settlement)","motdisp":"motdisp (Motion for Order to Dispose)","motenf":"motenf (Motion for Enforcement)","motexpapp":"motexpapp (Motion for Expedited Appeal)","motext":"motext (Motion to Extend Time)","mothrg":"mothrg (Motion for Hearing)","motlvapp":"motlvapp (Motion for Leave to Appeal)","motorder":"motorder (Motion for Order)","motquash":"motquash (Motion to Quash)","motrel":"motrel (Motion to Release)","motret":"motret (Motion for Return of Property)","motseize":"motseize (Motion to Seize Property)","motst":"motst (Motion to Stay)","motstapp":"motstapp (Motion for Stay Pending Appeal)","motstr":"motstr (Motion to Strike)","mottn":"mottn (Motion for Transcripts)","ntcfedlien":"ntcfedlien (Notice of Federal Lien)","object":"object (Objection)","petenf":"petenf (Petition to Enforce IRS Summons)","petnat":"petnat (Petition for Naturalization)","petper":"petper (Petition to Perpetuate Testimony)","petpresevi":"petpresevi (Petition for the Preservation of Evidence)","petrev":"petrev (Petition for Review)","petserv":"petserv (Petition for Leave to Serve John Doe Summons)","petvacawd":"petvacawd (Petition to Vacate/Modify The Award of Arbitration)","regjgm":"regjgm (Registration of Foreign Judgment)","retcashbl":"retcashbl (Return of Cash Bail)","rshowcaus":"rshowcaus (Rule to Show Cause)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","tranrr":"tranrr (Transmission of Report & Recommendation)","writgar":"writgar (Application for a Writ of Garnishment)"},"pamdce":{"0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2023":"07:2023 (Food Stamp Program)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1421":"12:1421 (12:1421 FIRREA-Confession of Judgment)","12:1441":"12:1441 (12:1441 Resolution Trust Corporation)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:2607":"12:2607 (12:2607 Real Estate Settlement Procedures Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693":"15:1693 (15:1693 Credit Card Accountability, Responsibility & Disclosure Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","15:6501":"15:6501 (15:6501 Children's Online Privacy Protection Act of 1998)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","16:817":"16:817 (Federal Energy Regulatory Commission (FERC))","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1345":"18:1345 (18:1345 Injunction against Fraud)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1955":"18:1955 (18:1955 Compl for forfeiture in Rem)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1070":"20:1070 (20:1070 To assist in making available the benefits of postsecondary education to eligible students)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0332":"21:0332 (21:0332 Food, Drug, Cosmetic Misbranding or Adulterating)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331ap":"28:1331ap (28:1331 Fed. Question: Civil Rights (FILE DATE: 3/25/98))","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 Default on Loan)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442a":"28:1442a (28:1442a-Removal:Members of armed forces sued or prosecuted)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2241in":"28:2241in (28:2241 Petition for Writ of Habeas Corpus (IMMIGRATION))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254in":"28:2254in (28:2254 State Petn for Writ of Habeas Corpus (IMMIGRATION))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201":"29:0201 (29:0201 Violation of Fair Labor Act of 1938)","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1332":"29:1332 (29:1332 Age Discrimination)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2101":"29:2101 (29:2101 Worker Adjustment & Retraining Notification Act)","29:2611":"29:2611 (29:2611 Family and Medical Leave Act of 1993)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","30:801":"30:801 (Fed. Mine Safety & Health)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4301":"38:4301 (38:4301 Employment and Re-Employment Rights of Members of Uniformed Services)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0257":"40:0257 (40:0257 Land Condemnation)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:12101":"42:12101 (42:12101 Americans With Disabilities Act of 1990)","42:12189":"42:12189 (Accessibility to the Handicapped)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:425":"42:425 (42:427 Social Security Benenfits)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:0151":"47:0151 (47:0151 Telecommunications Act of 1996)","47:0605":"47:0605 (47:0605 Unlawful Reception Broadcast Signal)","47:332":"47:332 (47:332 Telecommunications Act)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:1154":"8:1154 (8:1154 Immigration and Nationality Act)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"pawdce":{"0":"0 (no cause specified)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","11:101":"11:101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1345":"12:1345 (12:1345 Financial Inst. Reform Recov. & Enforc. Act of 1989)","12:1421":"12:1421 (12:1421 Federal Home Loan Bank Act)","12:1451":"12:1451 (12:1451 Emergency Home Finance Act of 1970)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1701x":"12:1701x (12:1701x(a)(5) National Affordable Housing Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1715(b)":"12:1715(b) (12:1715(b) HUD Mortgage Assignment Program)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1786":"12:1786 (12:1786 Termination of insured Credit Union Status)","12:1811":"12:1811 (12:1811 Financial Inst. Reform Recov. & Enforc. Act of 1989)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1831d":"12:1831d (12:1831d Deposit. Inst. Dereg. & Monetary Ctrl. Act of 1980)","12:191":"12:191 (12:191 Bank Foreclosure)","12:192":"12:192 (12:192 Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act)","12:22":"12:22 (12:22 Securities Fraud)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","12:635":"12:635 (12:635 Breach of Insurance Contract)","12:93(a)":"12:93(a) (12:93(a) National Bank Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1":"15:1 (15:1 Antitrust Litigation)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1267(a)":"15:1267(a) (15:1267(a) Federal Hazardous Substances Act)","15:15":"15:15 (15:15 Antitrust Litigation)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1701":"15:1701 (15:1701 Interstate Land Sales Full Disclosure Act)","15:1934":"15:1934 ()","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:25":"15:25 (15:25 Clayton Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:2at":"15:2at (15:2 Antitrust Litigation)","15:2fl":"15:2fl (15:2(a) Fair Labor Standards Act)","15:3710a":"15:3710a (15:3710a Federal Technology Transfer Act of 1986)","15:44":"15:44 (15:44 Trademark Infringement)","15:45":"15:45 (15:45 Federal Trade Commission Act)","15:5":"15:5 (15:5(a) Fair Labor Standards Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","15:631":"15:631 (15:631 Small Business Act)","15:754":"15:754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:77":"15:77 (15:77 Securities Fraud)","15:78":"15:78 (15:78m(a) Securities Exchange Act)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","16:668":"16:668 (16:668 Bald Eagle Protection Act)","16:703":"16:703 (16:703 Migratory Bird Act)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","17:101":"17:101 (17:101 Copyright Infringement)","17:501":"17:501 (17:501 Copyright Infringement)","17:504":"17:504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1001":"18:1001 (18:1001 Personal Property: Fraud)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1955D":"18:1955D ()","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2382":"18:2382 (18:2382 Misprision of treason)","18:241":"18:241 (18:241 Conspiracy Against Citizen Rights)","18:2511":"18:2511 (18:2511 Wiretapping)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","18:981a":"18:981a (18:981(a)(1)(A) Money Laundering Control Act)","19:1305":"19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","21:332(a)":"21:332(a) (21:332(a) Federal Food, Drug, and Cosmetic Act)","21:601":"21:601 (21:601 Federal Meat Inspection Act (FMIA))","21:841":"21:841 (21:841 Forfeiture Property-Drugs)","21:881":"21:881 (21:881 Forfeiture Property-Drugs)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:134":"23:134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","25:640":"25:640 (25:640 Indian Tribal Rights)","26:4121":"26:4121 ()","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7604a":"26:7604a (26:7604a IRS: Complaint to Enforce IRS Summons)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","27:185":"27:185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1324":"28:1324 ()","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Fed. Question: Civil Rights Violation)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332":"28:1332 (28:1332 Diversity-Other)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel, Assault, Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 ()","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1344":"28:1344 (28:1344 Election Dispute)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 VA Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1400":"28:1400 ()","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Notice of Removal-Account Receivable)","28:1441al":"28:1441al (28:1441 Notice of Removal-Airline Crash)","28:1441as":"28:1441as (28:1441 Notice of Removal-Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Notice of Removal-Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Notice of Removal - Breach of Contract)","28:1441cr":"28:1441cr (28:1441cr Notice of Removal - Civil Rights)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Notice of Removal-Contract Default)","28:1441dj":"28:1441dj (28:1441 Notice of Removal-Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441 Notice of Removal-Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441er":"28:1441er (Notice of Removal - ERISA)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Notice of Removal-Fraud)","28:1441ij":"28:1441ij (28:1441 Notice of Removal-Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Notice of Removal-Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Notice of Removal-Libel, Assault, Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Notice of Removal-Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Notice of Removal-Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Notice of Removal-Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Notice of Removal-Property Damage)","28:1441pi":"28:1441pi (28:1441 Notice of Removal-Personal Injury)","28:1441pl":"28:1441pl (28:1441 Notice of Removal-Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Notice of Removal-Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Notice of Removal-Torts to Land)","28:1441tm":"28:1441tm (28:1441 Notice of Removal-Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Notice of Removal-Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Notice of Removal-Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Notice of Removal-Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1441 Notice of Removal-Foreclosure)","28:1446er":"28:1446er (Notice of Removal - ERISA)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Notice of Removal-Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Notice of Removal-Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)","28:153":"28:153 ()","28:157A":"28:157A ()","28:157c":"28:157c (28:157(c)(1) Findings, Concl. & Proposed Judgment)","28:157d":"28:157d (Motion for Withdrawal of Reference)","28:158":"28:158 (28:158 Bankruptcy Appeal from Judgment/Order)","28:1602":"28:1602 (28:1602 Foreign Sovereign Immunities Act)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:185":"28:185 (28:185 Suit to Compel Arbitration)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254dp":"28:2254dp (28:2254dp Petition for Writ of Habeas Corpus (DEATH PENALTY))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (Actions affecting property on which United States had lien)","28:2600":"28:2600 ()","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:2679":"28:2679 (28:2679 Federal Driver's Act)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","28:451":"28:451 (28:451 Employment Discrimination)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","28:754":"28:754 (28:754 Receiver of Property in Different Districts)","28:794":"28:794 (28:794 Rehabilitation Act)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1129A":"29:1129A ()","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1140":"29:1140 ()","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1161":"29:1161 (29:1161 COBRA)","29:1332":"29:1332 ()","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:151":"29:151 (29:151 Labor: Review of Agency Action)","29:158(b)":"29:158(b) (29:158(b) National Labor Relations Act)","29:160":"29:160 (29:160(1) National Labor Relations Act)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:184":"29:184 (29:184 Violation Collection Bargain Agreement)","29:185ep":"29:185ep (29:185 Employee Pension Plan)","29:185lm":"29:185lm (29:185 Labor/Mgt. Relations (Contracts))","29:201":"29:201 ()","29:201do":"29:201do (29:201 Denial of Overtime Compensation)","29:201fl":"29:201fl (29:201 Fair Labor Standards Act)","29:206":"29:206 (29:206 Collect Unpaid Wages)","29:2104":"29:2104 (29:2104 Worker Adjustment & Retraining Notification (WARN))","29:216":"29:216 (29:216 Selective Service)","29:2601":"29:2601 (29:2601 Family Medical Leave Act 1993 (FMLA))","29:401":"29:401 (29:401 Labor Management Disclosure Act)","29:621":"29:621 (29:621 Job Discrimination (Age))","29:623":"29:623 (29:623 Job Discrimination (Age))","29:626":"29:626 (29:626 Job Discrimination (Age))","29:633":"29:633 (29:633 Job Discrimination (Age))","29:651":"29:651 (29:651 Occupational Safety/Health)","29:754":"29:754 (29:754 Discrimination)","29:790":"29:790 (29:790 Rehabilitation of Labor)","29:791":"29:791 (29:791 Job Discrimination (Rehabilitation Act))","29:794":"29:794 (29:794 Job Discrimination (Handicap))","2:431":"2:431 (2:431 Fed. Election Commission: Failure Enforce Compliance)","2:437":"2:437 (2:437 Federal Election Commission)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","30:181":"30:181 (30:181 Environment: Review of Agency Action)","30:801":"30:801 (30:801 Federal Mine Safety and Health Act of 1977)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","33:905(b)":"33:905(b) (33:905(b) Longshoremen Workers' Compensation Act)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","35:145":"35:145 (35:145 Patent Infringement)","35:146":"35:146 (35:146 Appeal from Decision of the Board of Patent Appeals)","35:183":"35:183 (35:183 Patent Infringement)","35:271":"35:271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2001":"38:2001 (Vietnam Veteran Readjustment Act)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (38:2021 Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance)","38:784":"38:784 (38:784 Suit for Veterans Insurance)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:258":"40:258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:270":"40:270 (40:270 Miller Act)","40:275":"40:275 (40:275 Condemnation (Eminent Domain))","40:875":"40:875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","41:251":"41:251 (41:251 Public Contracts-Review of Agency Action)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405G":"42:0405G (42:0405(g) Social Security (RSI))","42:0405id":"42:0405id (42:405(g) Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405(g) Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405(g) Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:1101":"42:1101 (Health Care Qualty Improvement Act of 1986)","42:12101":"42:12101 (42:12101 The Americans with Disabilities Act of 1990)","42:1332":"42:1332 ()","42:1381A":"42:1381A ()","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 Nursing Home Reform Act)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983pr Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000":"42:2000 (42:2000 Civil Rights: Other)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accommodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000rl":"42:2000rl (42:2000 Job Discrimination (Religion))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:205":"42:205 (42:205 Denial Social Security Benefits)","42:206":"42:206 (42:206 Social Security Benefits)","42:234":"42:234 (42:234 Defaulted Public Health Service Corps loan)","42:247":"42:247 (42:247 Personal Injury-Swine Flu)","42:2615":"42:2615 (42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:300aa-1":"42:300aa-1 (42:300aa-1 Nat'l. Childhood Vaccine Injury Compensation Act)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:402":"42:402 (42:402 Social Security Benefits)","42:405*":"42:405* ()","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:405G":"42:405G (42:405(g) Social Security (RSI))","42:405id":"42:405id (42:405(g) Review of HHS Decision (SSID))","42:405wc":"42:405wc (42:405(g) Review of HHS Decision (DIWC))","42:405ww":"42:405ww (42:405(g) Review of HHS Decision (DIWW))","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:416":"42:416 (42:416 Denial of Social Security Benefits)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7401":"42:7401 (42:7401 Clean Air Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9604":"42:9604 (42:9604 Comprehensive Envir. Comp. & Liab. Act (CERCLA))","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:151":"45:151 (45:151 Railway Labor Act)","45:153":"45:153 (45:153, First (p) Railway Labor Act)","45:184":"45:184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:51":"45:51 (45:51 Railways: Fed. Employer's Liability Act)","45:581(c)":"45:581(c) (45:581(c) Rail Passenger Service Act)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:1300":"46:1300 (46:1300 Carriage of Goods by Sea Act (COGSA))","46:1701":"46:1701 (46:1701 Shipping Act of 1984)","46:183":"46:183 (46:183 Exoneration, Limitation of Liability)","46:688":"46:688 (46:688 General Admiralty and Maritime Law)","46:741":"46:741 (46:741 Shipping)","46:761":"46:761 (46:761 Shipping: Damages for Death on High Seas)","46:7701":"46:7701 (46:7701 Enforcement of a United States Coast Guard)","47:553":"47:553 (47:553 U.S.C.A. Cable Communications Policy Act)","47:605":"47:605 (47:605 Unlawful Reception Broadcast Signal i.e., Satellite)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","48:883":"48:883 (48:883 Violation of US Coastal Law)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:10101":"49:10101 ()","49:10741":"49:10741 ()","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:11707":"49:11707 (49:11707 Carmack Amendment)","49:1431":"49:1431 (49:1431 Noise Control Act of 1972)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","49:2101":"49:2101 (49:2101 Aviation Safety & Noise Abatement Act of 1979)","49:3102":"49:3102 (49:3102 Federal Motor Carrier Safety Regulations Act)","49:781":"49:781 (49:781 Forfeiture)","49:81":"49:81 (49:81 Damaged Goods While Being Transported)","50:1701-06":"50:1701-06 (50:1701-06 International Emergency Economic Powers Act)","5:551":"5:551 (5:551 Administrative Procedure Act)","5:552fi":"5:552fi (5:552 Freedom of Information Act)","5:552pa":"5:552pa (5:552 Right to Privacy Act)","5:554":"5:554 (5:554 Constitutionality of Maritime Statutes)","5:701":"5:701 (5:701 Maritime Subsidy Board)","5:702":"5:702 (5:702 Administrative Procedure Act)","5:704":"5:704 (5:704 Labor Litigation)","5:75":"5:75 (5:75(2) Contract - Reduction in Grade)","5:7511":"5:7511 ()","5:7703":"5:7703 (5:7703 Discrimination - Review of Agency Act)","5:8131":"5:8131 (5:8131 Federal Employee's Compensation Act (FECA))","5:8470":"5:8470 (5:8470 Enforcement of Judgment against Retirement Benefits)","5:8901":"5:8901 (5:8901 Federal Employees Health Benefits Act)","7:181":"7:181 (7:181 Packers & Stockyard Act)","7:2023(a)":"7:2023(a) (7:2023(a) Judicial Review of Food Stamp Disqualification)","7:2024":"7:2024 (7:2024 False Claims Act, Food Stamp Fraud)","7:2321":"7:2321 (7:2321 Plant Variety Protection Act)","7:25":"7:25 (7:25 Fraud - Commodities Leverage Contracts)","7:499":"7:499 (7:499 Agricultural Commodities Act)","7:6":"7:6 (7:6(b) Federal Commodity Exchange Regulation)","7:601":"7:601 (7:601 USDA Condemnation)","8:1105":"8:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","8:1182":"8:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","8:1251(A)":"8:1251(A) (8:1251(A)(4) Application for a Stay of Deportation)","8:1260":"8:1260 (8:1260 Aliens: Access to Records)","8:1324":"8:1324 (8:1324 Aliens: Complaint for Forfeiture)","8:1329":"8:1329 (8:1329 Writ of Mandamus to Adjudicate Visa Petition)","8:1446":"8:1446 (8:1446 Petition for Naturalization Hearing)","8:1451(j)":"8:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","9:1":"9:1 (9:1 U.S. Arbitration Act)","9:9":"9:9 (9:9 Arbitration Award)","PA:221":"PA:221 (PA:221 Article 5(b) of the Landlord & Tenant Act)","adsup":"adsup (Administrative Subpoena)","appcounsel":"appcounsel (Appointment of Court Appointed Counsel)","appentprem":"appentprem (Application of the U.S. to enter premises to Effect Levy)","appltrrog":"appltrrog (Application for Letters Rogatory)","appointrec":"appointrec (Appointment of Receiver)","certL.R.12":"certL.R.12 (Certifying Students to Practice Under L.R. 12)","certobk":"certobk (Certified Copy of Order from Bankruptcy Court)","confarbawd":"confarbawd (Motion for Confirmation of Arbitration Award)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","fordepo":"fordepo (Foreign Deposition)","minspwarr":"minspwarr (Motion for Inspection Warrant Under the OSHA of 1970)","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel)","motcompset":"motcompset (Motion to Compel Settlement)","motdisp":"motdisp (Motion for Order to Dispose)","motenf":"motenf (Motion for Enforcement)","motexpapp":"motexpapp (Motion for Expedited Appeal)","motext":"motext (Motion to Extend Time)","motlvapp":"motlvapp (Motion for Leave to Appeal)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","motseize":"motseize (Motion to Seize Property)","motstapp":"motstapp (Motion for Stay Pending Appeal)","ntcfedlien":"ntcfedlien (Notice of Federal Lien)","petenf":"petenf (Petition to Enforce IRS Summons)","petnat":"petnat (Petition for Naturalization)","petper":"petper (Petition to Perpetuate Testimony)","petserv":"petserv (Petition for Leave to Serve John Doe Summons)","petvacawd":"petvacawd (Petition To Vacate/Modify The Award of Arbitrators)","regjgm":"regjgm (Registration of Foreign Judgment)","retcashbl":"retcashbl (Return of Cash Bail)","rshowcaus":"rshowcaus (Rule to Show Cause)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","tranrr":"tranrr (Transmission of Report & Recommendation)","writgar":"writgar (Application for a Writ of Garnishment)"},"prdce":{"0":"0 (No cause code entered)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451(j)":"08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:191":"12:191 (12:191 Bank Foreclosure)","12:192":"12:192 (12:192 Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1836a":"18:1836a (18:18:1836(a) Injunction against Misappropiation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2511":"18:2511 (18:2511 Wiretapping)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1875":"28:1875 (28:1875 (d)(1) Protection of Juror's Employment)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:12101":"42:12101 (42:12101 Americans with Disabilities Act (ADA))","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","adsup":"adsup (Administrative Subpoena)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","fordepo":"fordepo (Foreign Deposition)","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","writgar":"writgar (Application for a Writ of Garnishment)"},"ridce":{"0":"0 (no cause specified)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1421":"08:1421 (8:1421(c) Review of Denial of Naturalization Application)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451(j)":"08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1789":"12:1789 (12:1789 Negligent title examination)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:191":"12:191 (12:191 Bank Foreclosure)","12:192":"12:192 (12:192 Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:45 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2310":"15:2310 (15:2310 Breach of Warrenty)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:0823":"16:0823 (16:0823 Federal Power Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:1847":"16:1847 (16:1847 Magnuson Fishery Conservation & Management Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0925":"18:0925 (18:925A - Wrongful denial of the purchase of a firearm)","18:0981":"18:0981 (18:0981 Civil forfeiture-violation-financial institution)","18:1030":"18:1030 (18:1030 Computer Fraud and Abuse Act)","18:1345":"18:1345 (18:1345 Injunctive Relief to Restrain Commision of Fraud)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2251":"18:2251 (18:2251 Protection of Children Agnst Sexual Exploitation Act)","18:2333":"18:2333 (Civil remedy - Acts of Terrorism)","18:2511":"18:2511 (18:2511 Wiretapping)","18:2701":"18:2701 (18:2701 Stored Communications Act)","18:3006A":"18:3006A (18:3006 Adequate representation of criminal defendants)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:3402":"18:3402 (18:3402 Right to appeal judgment of magistrate judge)","18:3582(c)":"18:3582(c) (18:3582(c)(2) Motion for reduction of sentence)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","18:78":"18:78 (18:78 Securities and Exchange Act)","19:1305":"19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)","19:1627":"19:1627 (Forfeiture regarding seizure by Customs)","20:107":"20:107 (20:107 Randolph-Sheppard Act)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1415":"20:1415 (20:1415 Handicapped Child Act - attorneys fees)","20:1681":"20:1681 (20:1681 Educational Amendments)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","21:343":"21:343 (21:343 Food, Drug & Cosmetic Act)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Fed. Question: Civil Rights Violation)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel, Assault, Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 VA Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Notice of Removal-Account Receivable)","28:1441al":"28:1441al (28:1441 Notice of Removal-Airline Crash)","28:1441as":"28:1441as (28:1441 Notice of Removal-Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Notice of Removal-Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Notice of Removal-Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Notice of Removal - Civil Rights)","28:1441df":"28:1441df (28:1441 Notice of Removal-Contract Default)","28:1441dj":"28:1441dj (28:1441 Notice of Removal-Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441 Notice of Removal-Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Notice of Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Notice of Removal-Fraud)","28:1441ij":"28:1441ij (28:1441 Notice of Removal-Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Notice of Removal-Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Notice of Removal-Libel, Assault, Slander)","28:1441ld":"28:1441ld (28:1441 Notice of removal - Labor Dispute)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Notice of Removal-Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Notice of Removal-Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Notice of Removal-Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Notice of Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Notice of Removal-Property Damage)","28:1441pi":"28:1441pi (28:1441 Notice of Removal-Personal Injury)","28:1441pl":"28:1441pl (28:1441 Notice of Removal-Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Notice of Removal-Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Notice of Removal-Torts to Land)","28:1441tm":"28:1441tm (28:1441 Notice of Removal-Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Notice of Removal-Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Notice of Removal-Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Notice of Removal-Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1441 Notice of Removal-Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Notice of Removal-Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Notice of Removal-Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1655":"28:1655 (28:1655 Lien Enforcement; absent defendant)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (Actions Affecting Property on Which United States Had a Lien)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2101":"29:2101 (29:2101 Worker Adjustment and Retraining Notification Act)","29:2601":"29:2601 (29:2601 Family and Medical Leave Act of 1993)","29:481(g)":"29:481(g) (29:481(g) Violation of Union Campaigning)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","33:2701":"33:2701 (33:2701 Oil Pollution Liability & Compensation Act)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:521":"38:521 (38:521 Recovery of VA Overpayment)","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:12101":"42:12101 (42:12101 Americans With Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1973":"42:1973 (42:1973 National Voter Registration Act of 1993)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accommodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Flood Insurance Policy)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","42:9904":"42:9904 (42:9904 Misallocation of Federal Block Grant Funds)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:31301":"46:31301 (46:31301 Foreclosure on 1st preferred ship's mortgage)","46:688":"46:688 (46:688 Jones Act)","47:0553":"47:0553 (47:0553 Cable Communications)","47:151":"47:151 (47:151 Communications Act of 1934)","47:332":"47:332 (47:332 Telecommunications Act of 1996)","47:553":"47:553 (47:553 Theft of cable services)","47:605":"47:605 (47:605 Unauthorized Use of Commumnications)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:10741":"49:10741 (49:10741 Interstate Commerce Act)","49:10927":"49:10927 (49:10927 Uninsured interstate trans. of autos)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:13706":"49:13706 (49:13706 Non-payment of freight charges)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","49:24311":"49:24311 (49:24311(b) Rail Passenger Service Act)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","adsup":"adsup (Administrative Subpoena)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","fordepo":"fordepo (Foreign Deposition)","fsa":"fsa (food stamp act)","i":"i ()","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","writgar":"writgar (Application for a Writ of Garnishment)"},"scdce":{"0":"0 (no cause specified)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","05:8477":"05:8477 (05:8477 Fiduciary Responsibilities, Liability and Penalties)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:1926":"07:1926 (07:1926 Waste and Water Facility Loans and Grants)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1421c":"08:1421c (08:1421 Review of Naturalization Application)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451(j)":"08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","11:524":"11:524 (11:524 Effect of Discharge)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0632":"12:0632 (Federal Reserve Act)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:191":"12:191 (12:191 Bank Foreclosure)","12:192":"12:192 (12:192 Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1691":"15:1691 (15:1691 Equal Credit Opportunity Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1514":"18:1514 (18:1514 To restrain harassment of victim/witness)","18:1831":"18:1831 (18:1831 Defend Trade Secrets Act)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2511":"18:2511 (18:2511 Wiretapping)","18:2701":"18:2701 (18:2701 Stored Communications Act)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","18:983f3A":"18:983f3A (18:983f3A Release of Government Seized Property)","19:1305":"19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1415":"20:1415 (Individuals with Disabilities Education Act (IDEA))","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","21:399d":"21:399d (21:399 Food Safety Modernization Act (FSMA))","21:801":"21:801 (21:801 Violations of the Controlled Substance Act)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7402a":"26:7402a (26:7402 Injunction to Enforce Internal Revenue Code)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7405":"26:7405 (26:7405 Suit by US for Recovery of Erroneous Refund)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Fed. Question: Civil Rights Violation)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel, Assault, Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 VA Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1367":"28:1367 (28:1367 Federal Receiver Case to Disgorge Profits)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Notice of Removal-Account Receivable)","28:1441al":"28:1441al (28:1441 Notice of Removal-Airline Crash)","28:1441as":"28:1441as (28:1441 Notice of Removal-Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Notice of Removal-Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Notice of Removal-Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Notice of Removal-Contract Default)","28:1441dj":"28:1441dj (28:1441 Notice of Removal-Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441 Notice of Removal-Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Notice of Removal-Fraud)","28:1441ij":"28:1441ij (28:1441 Notice of Removal-Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Notice of Removal-Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Notice of Removal-Libel, Assault, Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Notice of Removal-Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Notice of Removal-Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Notice of Removal-Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Notice of Removal-Property Damage)","28:1441pi":"28:1441pi (28:1441 Notice of Removal-Personal Injury)","28:1441pl":"28:1441pl (28:1441 Notice of Removal-Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Notice of Removal-Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Notice of Removal-Torts to Land)","28:1441tm":"28:1441tm (28:1441 Notice of Removal-Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Notice of Removal-Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Notice of Removal-Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Notice of Removal-Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1441 Notice of Removal-Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Notice of Removal-Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Notice of Removal-Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)","28:1491":"28:1491 (28:1491 Review of Federal Agency Bids for Contract)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1983":"28:1983 (28:1983 Civil Rights (DO NOT USE))","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241c":"28:2241c (28:2241 Petition for Writ of Habeas Corpus (County))","28:2241f":"28:2241f (28:2241 Petition for Writ of Habeas Corpus (Federal))","28:2241s":"28:2241s (28:2241 Petition for Writ of Habeas Corpus (State))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (Actions affecting property on which United States had lien)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2001":"29:2001 (29:2001 Employee Polygraph Protection Act)","29:2101":"29:2101 (29:2101 WARN Act)","29:2601":"29:2601 (29:2601 Family Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4301":"38:4301 (38:4301 Violation of Uniform Services Employment Rights Act)","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:3131":"40:3131 (40:3131 Miller Act)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11601":"42:11601 (42:11601 International Child Abduction Remedies Act / Hague)","42:12117":"42:12117 (42:12117 Americans with Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1395dd":"42:1395dd (42:1395dd EMTALA Claims and Gross Negligence/Negligence)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1973":"42:1973 (42:1973 - Voting Rights Act of 1965)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1982cv":"42:1982cv (42:1982 Civil Rights Racial Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983pr (Other))","42:1983prb":"42:1983prb (42:1983 Prisoner Civil Rights, Federal Filers (Bivens))","42:1983prs":"42:1983prs (42:1983 Prisoner Civil Rights, State Filers)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accommodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9601":"42:9601 (42:9601 Hazardous Substances Releases, Liability - Definition)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:30511":"46:30511 (46:30511 Action by Owner for Limitation)","47:0151":"47:0151 (47:0151 Communications Act)","47:0553":"47:0553 (47:0553 Unauthorized Reception of Cable Service)","47:227":"47:227 (47:227 Violation of the Telephone Consumer Protection Act)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","49:3011":"49:3011 (49:3011 National Traffic and Motor Vehicle Safety Act)","49:32710b":"49:32710b (49:32710(b) Federal Odometer Act - Odometer Tampering and Fraud)","50:3901":"50:3901 (50:3901 Federal Question: Servicemembers Civil Relief Act)","7:2023":"7:2023 (Food Stamp Act)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","adsup":"adsup (Administrative Subpoena)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","fordepo":"fordepo (Foreign Deposition)","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","writgar":"writgar (Application for a Writ of Garnishment)"},"sddce":{"02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0247":"07:0247 (07:0247 Recovery on Surety Bond (Warehouse Act))","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:1401":"07:1401 (Agriculture Adjustment Act)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1447":"08:1447 (Review of Denial of Naturalization Application)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1787":"12:1787 (12:1787 Federal Credit Union - Payment of Insurance)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:0715":"16:0715 (16:0715 Migratory Bird Conservation Act)","16:0718":"16:0718 (16:0718 Hunting and Conservation Stamp Tax)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0981":"18:0981 (Civil Forfeiture of Real Property)","18:1035":"18:1035 (18:1035 False Statements Relating to Health Care)","18:1836a":"18:1836a (18:1836(a) - Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) - Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0842":"21:0842 (21:842 Food & Drugs - Prohibited Acts)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0081":"25:0081 (Contracts with Indian Tribes/Indians)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","25:2701":"25:2701 (25:2701 Indian Gaming Regulatory Act)","26:6103":"26:6103 (26:6103(i)(1) IRS: Disclosure of Tax Returns and Return Information)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7405":"26:7405 (IRS: Action for Recovery of Erroneous Refunds)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7602":"26:7602 (IRS: Disclosure of Tax Returns and Return Information)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1339":"28:1339 (28:1339 Postal Matters)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1395":"28:1395 (28:1395 Fine, Penalty or Forfeiture)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651a":"28:1651a (28:1651a All Writs)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185(a)":"29:0185(a) (29:0185(a) Suit By and Against Labor Organizations)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2101":"29:2101 (29:2101 Worker Adjustment/Retraining Notification)","29:2601":"29:2601 (29:2601 Family and Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act (use sc subtype))","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","375/1":"375/1 (False Claims Act - U.S. Plaintiff)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1729":"38:1729 (38:1729 Recovery of Cost of Certain Care & Services)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (38:2021 Recovery of Unpaid Back Wages and Benefits)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4303":"38:4303 (38:4303 Uniformed Services Employment & Re-employ Rights Act)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:3005fr":"39:3005fr (False Representation through Postal Service)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:0651":"42:0651 (Child Support Obligations)","42:12101":"42:12101 (42:12101 Discrimination Against the Disabled)","42:12117":"42:12117 (42:12117 Americans with Disabilities Act (Enforcement))","42:12177":"42:12177 (Americans with Disabilities Act (Enforcement))","42:12201":"42:12201 (42:12201 Americans with Disabilities Act of 1990)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1415":"42:1415 (42:1415(e) Individuals with Disabilities Ed. Act - Appeal)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act - Civil Action for Deprivation of Rights)","42:1983d":"42:1983d (42:1983 Civil Rights (Death))","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000cc":"42:2000cc (42:2000 Religious Land Use & Institutionalized Persons Act of 2000)","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:11706":"49:11706 (Interstate Commerce Enforcement - Common Carriers)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"tnedce":{"0":"0 (00:0000)","00:0000":"00:0000 (00:0000 Cause Code Unknown )","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Rights)","18:1836":"18:1836 (18:1836 Civil Seizure of Misappropriated Trade Secrets)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0601":"21:0601 (21:601 Federal Meat Inspection Act )","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle)","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (28:3001 Federal Debt Collection Procedures Act )","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2601":"29:2601 (29:2601 Family and Medical Leave Act of 1993 )","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4301":"38:4301 (38:4301 Uniformed Services Employ./Re-employ. Rights Act )","39:1208":"39:1208 (39:1208 Breach of Collective Bargaining Agreement)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:3131":"40:3131 (40:3131 Miller Act)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11601":"42:11601 (International Child Abduction Remedies Act )","42:12117":"42:12117 (42:12117 Americans with Disabilities Act )","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:0605":"47:0605 (47:605 Electronic Communications Privacy Act )","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"tnmdce":{"0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","04:0051":"04:0051 (04:0051 Federal Employers' Liability Act)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0504":"05:0504 (Equal Access to Justice Act)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:1365":"07:1365 (07:1365 Agricultural Adjustment Act)","07:2023":"07:2023 (07:2023 Administration Appeal - Dept. of Agriculture)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:0287":"08:0287 (8:287 Petition to Enforce INS Subpoena)","08:1103":"08:1103 (08:1103 Immigration & Nationality Act of 1952)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1252":"08:1252 (08:1252 Judicial Review of Orders of Removal)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1421":"08:1421 (08:1421 Judicial Review of Denial of Naturalization Petition)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1447":"08:1447 (08:1447 Failure to make decision on naturalization petition)","08:1451":"08:1451 (08:1451(a) Revocation of Citizenship)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (09:0009 Motion to Confirm Arbitration Award)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2005":"10:2005 (10:2005 Advanced Education Assistance)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","10:2687":"10:2687 (BRAC Act (Defense Base Closure and Realignment Act of 1990))","11:0101":"11:0101 (11:101 Bankruptcy)","11:0110":"11:0110 (11:0110 Bankruptcy Petition Preparer-Penalty)","11:525":"11:525 (11:525 Bankruptcy-Protection from Discrimination & Retaliation)","12:0021":"12:0021 (12:0021 National Bank Act)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0221":"12:0221 (12:0221 Federal Reserve Act)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1201":"12:1201 (12:1201 Real Estate Settlement Procedures Act)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1759":"12:1759 (12:1759 Banks & Banking membership)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Bank Holding Company Act)","12:2601":"12:2601 (12:2601 Real Estate Settlement Procedures Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0080":"15:0080 (15:80 Investment Company Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1222":"15:1222 (15:1222 Auto dealers suits against Manufacturers)","15:1501":"15:1501 (15:1501 Trademark/Anti-Cybersquatting Consumer Protect Act)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1667":"15:1667 (15:1667 Truth in Lending)","15:1679":"15:1679 (15:1679 Commerce and Trade)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1691":"15:1691 (15:1691 Equal Credit Opportunity Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693":"15:1693 (15:1693 Electronic Fund Transfers Act)","15:1701la":"15:1701la (15:1701-1720 Interstate Land Sales Full Disclosure Act)","15:1821":"15:1821 (15:1821 Horse Protection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)","15:6101":"15:6101 (15:6101 Federal Trade Commission's Telemarketing Sales Rule)","16:0470":"16:0470 (16:0470 Archaeological Resource Act)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:0742":"16:0742 (16:0742 Airborne Hunting Act)","16:0831":"16:0831 (16:0831 Tennessee Valley Authority Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:0101 Copyright Infringement)","17:0102":"17:0102 (17:0102 Copyright Infringement)","17:0106":"17:0106 (17:0106 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0492":"18:0492 (18:0492 Forfeiture of Property)","18:0921":"18:0921 (18:0921 Firearms)","18:0922":"18:0922 (18:0922 Firearms)","18:0925":"18:0925 (18:0925 Petition for Relief/Prohibition of Firearms Poss.)","18:0981":"18:0981 (18:0981 Civil Forfeiture)","18:1030":"18:1030 (18:1030 Computer Fraud)","18:1033":"18:1033 (18:1033 Insurance-Fraud & False Statements)","18:1344":"18:1344 (18:1344 Bank Fraud)","18:1345":"18:1345 (18:1345 Health Care Fraud)","18:1589":"18:1589 (18:1589 Forced Labor)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1951":"18:1951 (18:1951 Racketeering (RICO) Act)","18:1955":"18:1955 (18:1955 Forfeiture of Property or Currency)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2254":"18:2254 (18:2254 Forfeiture of Property or Currency)","18:2510":"18:2510 (18:2510 Wiretapping Act)","18:2701":"18:2701 (18:2701-2711 Stored Communications Act)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","19:1602":"19:1602 (19:1602 Property Confiscation)","20:1078":"20:1078 (Federal Family Education Loan Program (FFELP))","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1681":"20:1681 (20:1681 Title IX of Education Amendment of 1972)","21:0301":"21:0301 (21:0301 Federal Food, Drug & Cosmetic Act)","21:0801":"21:0801 (21:801 Compreh. Drug Abuse Prev. and Control Act of 1970)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0876":"21:0876 (21:0876 DEA Subpoena Enforcement)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","22:9001":"22:9001 (22 USC 9001 International Child Abduction Remedies Act)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:0042":"26:0042 (26:0042 Low Income Housing Tax Credit Program)","26:5861":"26:5861 (26:5861 National Firearm Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6330":"26:6330 (26:6330 Tax Collection Appeal)","26:6334":"26:6334 (26:6334 IRS-Administrative Levy)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6672":"26:6672 (26:6672 Trust Fund Recovery Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7408":"26:7408 (26:7408 Penalty for Promoting Abusive Tax Shelters)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157b":"28:0157b (28:0157(b)(5) Personal Injury Tort/Wrongful Death Claims)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fc":"28:1331fc (28:1331 Federal Question: Foreclosure)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331lb":"28:1331lb (28:1331 Assault, Libel & Slander)","28:1331ll":"28:1331ll (28:1331 Other Labor Litigation)","28:1331ma":"28:1331ma (28:1331 Federal Question: Medicare Act)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331mv":"28:1331mv (28:1331 Motor Vehicle)","28:1331of":"28:1331of (28:1331 Other Fraud)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bb":"28:1332bb (28:1332 Diversity-Banks and Banking)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332bl":"28:1332bl (28:1332 Diversity-Breach of Lease Agreement)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332cpl":"28:1332cpl (28:1332 Diversity-Contract Product Liability)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332ej":"28:1332ej (28:1332 Diversity-Overpayment & Enforcement of Judgment)","28:1332em":"28:1332em (28:1332 Diversity-Employment)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332ll":"28:1332ll (28:1332 Diversity-Labor Litigation)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332m":"28:1332m (28:1332 Marine Contract)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332med":"28:1332med (28:1332 Diversity-Medicare Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mpl":"28:1332mpl (28:1332 Diversity-Marine Product Liability)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332of":"28:1332of (28:1332 Other Fraud)","28:1332op":"28:1332op (28:1332 Diversity-All Other Real Property)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Notice of Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-core))","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Notice of Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Notice of Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Notice of Removal- Asbestos Litigation)","28:1441at":"28:1441at (28:1441 Notice of Removal- Antitrust)","28:1441au":"28:1441au (28:1441 Notice of Removal- Auto Negligence)","28:1441bb":"28:1441bb (28:1441 Notice of Removal-Banks and Banking)","28:1441bc":"28:1441bc (28:1441 Notice of Removal- Breach of Contract)","28:1441ca":"28:1441ca (28:1441 Notice of Removal - Copyrights Act)","28:1441co":"28:1441co (28:1441 Notice of Removal - Commerce/ICC Rates)","28:1441cv":"28:1441cv (28:1441 Notice of Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Notice of Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Notice of Removal- Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441 Notice of Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Notice of Removal- Employment Discrimination)","28:1441en":"28:1441en (28:1441 Notice of Removal-Environmental Matters)","28:1441er":"28:1441er (28:1441 Notice of Removal - ERISA)","28:1441fa":"28:1441fa (28:1441 Notice of Removal - Family Medical Leave Act)","28:1441fc":"28:1441fc (28:1441 Notice of Removal - Fair Credit Reporting Act)","28:1441fd":"28:1441fd (28:1441 Notice of Removal-Fair Debt Collection Act)","28:1441fl":"28:1441fl (28:1441 Notice of Removal - Fair Labor Standards Act)","28:1441fo":"28:1441fo (28:1441 Notice of Removal-Foreclosure)","28:1441fr":"28:1441fr (28:1441 Notice of Removal- Fraud)","28:1441fra":"28:1441fra (28:1441 Notice of Removal-Franchise)","28:1441hb":"28:1441hb (28:1441 Health Benefits)","28:1441ho":"28:1441ho (28:1441 Notice of Removal- Civil Rights/Housing)","28:1441ic":"28:1441ic (28:1441 Interstate Commerce Act)","28:1441ij":"28:1441ij (28:1441 Notice of Removal- Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Notice of Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Notice of Removal- Action for Interpleader)","28:1441lb":"28:1441lb (28:1441 Notice of Removal- Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Notice of Removal- Labor/Mgmnt. Relations)","28:1441ma":"28:1441ma (28:1441 Notice of Removal-Marine)","28:1441me":"28:1441me (28:1441 Notice of Removal - Medicare)","28:1441ml":"28:1441ml (28:1441 Notice of Removal- Motor Vehicle Product Liability)","28:1441mm":"28:1441mm (28:1441 Notice of Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Notice of Removal- Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Notice of Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Notice of Removal--Other Contract)","28:1441ol":"28:1441ol (28:1441 Notice of Removal-Other Labor Litigation)","28:1441op":"28:1441op (28:1441 Notice of Removal-All Other Real Property)","28:1441os":"28:1441os (28:1441 Notice of Removal-Other Statutory Actions)","28:1441pa":"28:1441pa (28:1441 Notice of Removal-Patent)","28:1441pd":"28:1441pd (28:1441 Notice of Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Notice of Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Notice of Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Notice of Removal)","28:1441qt":"28:1441qt (28:1441 Notice of Removal- Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Notice of Removal- Racketeering (RICO) Act)","28:1441rp":"28:1441rp (28:1441 Notice of Removal-Real Property)","28:1441sa":"28:1441sa (28:1441 - Notice of Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Notice of Removal: Securities Fraud)","28:1441ta":"28:1441ta (28:1441 - Notice of Removal-Taxes)","28:1441ti":"28:1441ti (28:1441 Trademark Infringement)","28:1441tl":"28:1441tl (28:1441 Notice of Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Notice of Removal- Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Notice of Removal- Tort/Non-Motor Vehicle)","28:1441tr":"28:1441tr (28:1441 Notice of Removal-Truth in Lending)","28:1441vr":"28:1441vr (28:1441vr Notice of Removal-Denial of Voting Rights)","28:1441wd":"28:1441wd (28:1441 Notice of Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Notice of Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Notice of Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Notice of Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446oc":"28:1446oc (28:1446 Notice of Removal - Other Contract)","28:1446pd":"28:1446pd (28:1446 Notice of Removal- Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Notice of Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446 Notice of Removal- Product Liability)","28:1446pr":"28:1446pr (28:1446 Notice of Removal)","28:1446tr":"28:1446tr (28:1446 Trademark Infringement)","28:1452":"28:1452 (28:1452 Removal of claims related to bankruptcy cases)","28:1605":"28:1605 (28:1605 Jurisdictional Immunity of a Foreign State)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1711":"28:1711 (28:1711 Class Action Fairness Act of 2005)","28:1738":"28:1738 (28:1738(A) Parental Kidnapping Prevention Act)","28:1782":"28:1782 (28:1782 Letter of Request for Judicial Assistance)","28:1875":"28:1875 (28:1875 Protection of Jurors' Employment)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254dp":"28:2254dp (28:2254 Petition for Writ of H/C-Death Penalty)","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2401":"28:2401 (28:2401 Federal Tort Claims Act)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0185ol":"29:0185ol (29:185 Other Labor Litigation)","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0629":"29:0629 (29:0629 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0701":"29:0701 (29:0701 Americans With Disabilities Act of 1990)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1133":"29:1133 (29:1133 E.R.I.S.A.-Short Term Disability Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1161":"29:1161 (29:1161 Comprehensive Omnibus Budget Reconciliation Act)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2000":"29:2000 (29:2000 Employee Polygraph Protection)","29:2101":"29:2101 (29:2101 Worker Adjustment/Retraining Notification Act)","29:2601":"29:2601 (29:2601 Family Medical Leave Act)","29:2611":"29:2611 (29:2611 Family Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act - 1977)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:0415":"33:0415 (33:0415 Barge Removal/Costs)","33:1251":"33:1251 (33:1251 Clean Water Act)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0101":"35:0101 (35:0101 Patent Infringement)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","35:0511":"35:0511 (35:0511 Veteran's Benefits)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4301":"38:4301 (38:4301 Uniform Services Employment and Reemployment Rights)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0233":"42:0233 (42:0233 Public Health & Welfare-Proceedings against Commissioned Officers or Employees)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0292":"42:0292 (42:0292 Medical School Loans)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405si":"42:0405si (42:0405 Review of HHS Decision (RSI))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11112":"42:11112 (42:11112 Standards for professional review actions)","42:11601":"42:11601 (42:11601 International Child Abduction Remedies Act)","42:12101":"42:12101 (42:12101 Americans with Disabilities Act)","42:12117":"42:12117 (42:12117 Americans with Disabilities Act)","42:12131":"42:12131 (42:12131 Americans with Disabilities Act)","42:1320":"42:1320 (42:1320 Health Insurance Portability & Accountability Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1395dd":"42:1395dd (42:1395dd Examination and treatment for emergency medical conditions and women in labor)","42:1396":"42:1396 (42:1396 Medicaid)","42:1396r-5":"42:1396r-5 (42:1396r-5 - Treatment of income and resources for certain institutionalized spouses)","42:13981":"42:13981 (42:13981 Violence Against Women Act)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)","42:15041":"42:15041 (42:15041 Developmental Disabilities & Assistance Act)","42:1973":"42:1973 (42:1973 Denial of Voting Rights)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1985":"42:1985 (42:1985 Conspiracy to Interfere with Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:1997":"42:1997 (42:1997 Civil Rights of Institutionalized Persons Act)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:3601 Fair Housing Act)","42:3796":"42:3796 (42:3796 Payment of death benefits-Public Health & Welfare)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)","42:6101":"42:6101 (42:6101 Federal Age Discrimination Act)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:6972":"42:6972 (42:6972 Resource Conservation and Recovery Act)","42:6991":"42:6991 (42:6991 Resource Conservation and Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","42:9613":"42:9613 (42:9613 Comprehensive Environmental/Liability Act)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:152":"45:152 (45:152 Railway Labor Act)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0181":"46:0181 (Limitation of Vessel Owner's Liability Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:30501":"46:30501 (46:30501 Exoneration and Limitation of Liability (Maritime))","46:31301":"46:31301 (46:31301 Commercial Instruments & Maritime Liens Act)","47:0151":"47:0151 (47:0151 Federal Communications Act)","47:0230":"47:0230 (47:0230 Communications Decency Act)","47:0252":"47:0252 (47:0252 Federal Telecommunications Act of 1996)","47:0332":"47:0332 (47:0332 Federal Telecommunications Act of 1996)","47:0553":"47:0553 (47:0553 Communications Act of 1934)","47:0605":"47:0605 (47:0605 Electronic Communications Privacy Act)","47:227":"47:227 (47:227 Restrictions on use of telephone equipment)","47:504":"47:504 (47:504 Telegraphs, Telephones, and Radiotelegraphs-Forfeitures)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:043":"49:043 (49:043 Federal Railroad Safety Act)","49:0781":"49:0781 (49:781 Forfeiture)","49:10101":"49:10101 (49:10101 Interstate Commerce Act)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)","49:13702":"49:13702 (49:13702 Interstate Commerce Act)","49:14501":"49:14501 (49:14501 Motor Carriers)","49:14704":"49:14704 (49:14704 Interstate Transportation/Motor Carriers)","49:14706":"49:14706 (49:14706 The Carmack Amendment)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summons)","49:32701":"49:32701 (49:32701 Odometer Act)","49:40105":"49:40105 (49:40105 Unification of Certain Rules Relating to Intl Transp by Air)","49:46301":"49:46301 (49:46301 F.A.A. Civil Penalty)","49:47107":"49:47107 (Project Grant Application Approval Conditioned on Assurances About Airport Operations)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"tnwdce":{"*41*":"*41* ( )","0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2615a":"29:2615a (29:2615a Family Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"txedce":{"0":"0 (No cause code entered)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2023":"07:2023 (07:2023 Petition for Judicial Review & Request for Stay)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451":"08:1451 (08:1451 Revocation of Naturalization Proceedings)","08:1451(a)":"08:1451(a) (08:1451(a) Action to revoke Citizenship)","08:1451(j)":"08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1441a":"12:1441a (12:1441a Federal Home Loan Banks)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:191":"12:191 (12:191 Bank Foreclosure)","12:192":"12:192 (12:192 Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act)","12:2601":"12:2601 (12:2601 Real Estate Settlement Procedures Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0077alc":"15:0077alc (15:0077alc Securities Fraud - Alcatel MDL)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0925":"18:0925 (18:0925 Petition for Relief from Disability Firearms Act)","18:1030":"18:1030 (18:1030 On-going Damage to Computer Data)","18:1345":"18:1345 (18:1345 Default of Government Direct Farm Ownership Loan)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2511":"18:2511 (18:2511 Wiretapping)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0331a":"21:0331a (21:0331a Fed Food Drug Cosmetic Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0853":"21:0853 (21:0853 Foreiture Money)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","21:355":"21:355 (21:355 New Drugs)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6103":"26:6103 (26:6103 Application to Disclose Tax Returns)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6331":"26:6331 (26:6331 IRS: Appl. to Enter Premises to Effect Levy)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332":"28:1332 (28:1332 Diversity Retaliation Wrongful Termination)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332n":"28:1332n (28:1332n Diversity-Norplant Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 Removal of Claims Related to Bankruptcy Cases)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1916":"28:1916 (Jones Act)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))","28:2241s":"28:2241s (28:2241s Petition for Writ of Habeas Corpus (State))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254ex":"28:2254ex (28:2254ex Petition for Writ of Habeas Corpus (Capital))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate/Correct Illegal Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0601":"29:0601 (29:601 Age Discrimination in Employment Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1554":"29:1554 (29:1554 Federal Fair Labor Standards Act)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2601":"29:2601 (29:2601 Family and Medical Leave Act)","29:2617":"29:2617 (29:2617 Family Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","33:403":"33:403 (33:403 Rivers & Harbors Act of 1899)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1506":"38:1506 (38:1506 Recovery of VA Overpayment)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11603":"42:11603 (42:11603 International Child Abduction Remedies)","42:12101":"42:12101 (42:12101 Americans with Disabilities Act)","42:12117":"42:12117 (42:12117 Employment Discrimination under A.D.A.)","42:12181":"42:12181 (42:12181 Americans with Disabilities Act of 1990)","42:1320a":"42:1320a (42:1320a Recovery of civil monetary penalty & assessment)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1971":"42:1971 (42:1971 Voting Right's Act)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000bb":"42:2000bb (42:2000bb Religious Freedom Restoration Act)","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:0227":"47:0227 (Federal Telephone Consumer Protection Act)","47:0553":"47:0553 (47:0553 Unauthorized Reception of Cable Service)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","49:32703":"49:32703 (49:32703 Odometer Tampering)","49:60101":"49:60101 (49:60101 Hazardous Liquid Pipeline Act)","49:6121a":"49:6121a (49:6121a Pipeline Safety Act)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","adsup":"adsup (Administrative Subpoena)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","fordepo":"fordepo (Foreign Deposition)","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","writgar":"writgar (Application for a Writ of Garnishment)"},"txndce":{"0":"0 (No cause code entered)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:0287":"08:0287 (08:0287 Petition to Enforce INS Subpoena)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1447":"08:1447 (8:1447 Petition for Naturalization Hearing)","08:1451(j)":"08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Award)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:191":"12:191 (12:191 Bank Foreclosure)","12:192":"12:192 (12:192 Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Tying Arrangement Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0078n":"15:0078n (15:78n(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1030":"18:1030 (18:1030 Computer Fraud & Abuse Act)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2511":"18:2511 (18:2511 Wiretapping)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:3599":"18:3599 (18:3599 Appointment of Clemency Counsel)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","22:9001":"22:9001 (22:9001 International Child Abduction Remedies)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1131ca Federal Question: Federal Communications Act)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 Removal of Claim in Civil Action Related to BK Case)","28:1455":"28:1455 (28:1455 Notice of Removal of Criminal Prosecution)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (Federal Debt Collection Act)","28:3203":"28:3203 (28:3203 Execution)","28:3205":"28:3205 (Garnishment)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2101":"29:2101 (29:2101 Exclusions from Definition of Loss of Employment)","29:2601":"29:2601 (29:2615 Family and Medical Leave)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:1891":"38:1891 (38:1891 VA Home Loan Default)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4311":"38:4311 (38:4311 Discrimination Against Persons Who Serve in the Uniformed Services)","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:3131":"40:3131 (40:3131 Miller Act)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:0659":"42:0659 (42:659 Enforcement of Child Support Obligations)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7547":"42:7547 (Nonroad Engines and Vehicles)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:151":"47:151 (47:151 FCC)","47:206":"47:206 (47:206 Carriers' Liability for Damages)","47:222":"47:222 (47:222 Telecommunications Act of 1996)","47:227":"47:227 (47:227 Restrictions on Use of Telephone Equipment)","47:332":"47:332 (47:332 Mobile Services)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","adsup":"adsup (Administrative Subpoena)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","fordepo":"fordepo (Foreign Deposition)","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","writgar":"writgar (Application for a Writ of Garnishment)"},"txsdce":{"0":"0 (No cause code entered)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","05:8701":"05:8701 (05:8701 FEGLA)","05:8901":"05:8901 (05:8901 FEHBA)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2023":"07:2023 (07:2023 Food Stamp Act)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451(j)":"08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Award)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0632":"12:0632 (12:0632 International Banking)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1818":"12:1818 (12:1818 Federal Reserve Act)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:191":"12:191 (12:191 Bank Foreclosure)","12:192":"12:192 (12:192 Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0080":"15:0080 (15:0080 Companies and Advisors)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1314":"15:1314 (15:1314 Antitrust Civil Process Act)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2051":"15:2051 (15:2051 Consumer Products Safety Act)","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1531":"16:1531 (16:1531 Endangered Species Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0511":"18:0511 (18:0511 Motor Vehicle Theft Prevention Act)","18:0981":"18:0981 (18:0981 Forfeiture in Rem)","18:1702":"18:1702 (18:1702 Postal Service (Obstruction))","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2511":"18:2511 (18:2511 Wiretapping)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1091":"20:1091 (20:1091 Recovery of IRS Offset)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0301":"21:0301 (21:0301 Fed Food Drug Cosmetic Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","21:2101":"21:2101 (21:2101 Warn Act)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:5872":"26:5872 (26:5872 Forfeitures)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6321":"26:6321 (26:6321 Lein for Taxes)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7405":"26:7405 (26:7405 Recovery of Overpayment of Taxes)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0157s":"28:0157s (28:0157s Motion for Stay Pending Ruling)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA))","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332ai":"28:1332ai (28:1332ai Diversity-Asbestos-Personal Injury)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332aw":"28:1332aw (28:1332aw Diversity-Asbestos-Wrongful Death)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441ai":"28:1441ai (28:1441ai Notice of Removal-Asbestos-Personal Injury)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441aw":"28:1441aw (28:1441aw Notice of Removal-Asbestos-Wrongful Death)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1875":"28:1875 (28:1875 Protection of Juror Employment)","28:1916":"28:1916 (28:1916 Seaman's Act Case)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254dp":"28:2254dp (28:2254 Petition for Writ of Habeas Corpus(Death Penalty))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2001":"29:2001 (29:2001 Employee Polygraph Protection Act)","29:2104":"29:2104 (29:2104 WARN ACT)","29:2601":"29:2601 (29:2601 Family Medical Leave Act (FMLA))","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","31:5316":"31:5316 (31:5316 Report on Monetary Instruments)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (38:2021 Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4212":"38:4212 (38:4212 Vietnam Era Veterans Readjustment Act)","38:775":"38:775 (38:775 Recovery of Serviceman's Group Life Insurance)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11603":"42:11603 (42:11603 ICARA)","42:11607":"42:11607 (42:11607 Int'l Child Abduction Act)","42:12101":"42:12101 (42:12101 American Disabilities Act)","42:12188":"42:12188 (42:12188 American Disabilities Act of 1990)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1973":"42:1973 (42:1973 Voting Rights Act)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000":"42:2000 (42:2000 Job Discrimination)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:688":"42:688 (42:688 Jones Act Case)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","42:9613":"42:9613 (42:9613 CERCLA)","43:1333":"43:1333 (43:1333 Outer Continental Shelf Lands Act)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:1300":"46:1300 (46:1300 Carriage of Goods by Sea Act)","47:0227":"47:0227 (47:0227 Telephone Consumer Protection Act)","47:0521":"47:0521 (47:0521 Cable Communications Policy Act)","47:11707":"47:11707 (47:11707 Carmack Amendment)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1374":"49:1374 (49:1374 Air Carrier Access Act)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","88:8888":"88:8888 (88:8888 Other Statutory Actions)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","adsup":"adsup (Administrative Subpoena)","appifp":"appifp (Application for IFP)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","efflevy":"efflevy (Application of US to enter premises to effect levy)","fordepo":"fordepo (Foreign Deposition)","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","sanctions":"sanctions (Sanctions Imposed)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","writgar":"writgar (Application for a Writ of Garnishment)"},"txwdce":{"0":"0 (No cause code entered)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8151":"05:8151 (05:8151 - Civil Service Retention Rights)","05:8701":"05:8701 (05:8701 - Federal Employees' Group Life Insurance Act)","07:0006":"07:0006 (07:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (07:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2020":"07:2020 (07:2020 Food Stamp Program Administration)","07:2023":"07:2023 (07:2023 Reinstatement of Food Stamp Privileges)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1101":"08:1101 (08:1101 - Immigration and Nationality)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1182":"08:1182 (08:1182 Defend. Denial of Pla. Appl. for Alien Employment Ce)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1324(a)":"08:1324(a) (08:1324(a) Complaint for penalties)","08:1324(b)":"08:1324(b) (08:1324(b) Complaint for forfeitures)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1447":"08:1447 (08:1447 - Hearing on Denial of Application for Naturalizatio)","08:1451(j)":"08:1451(j) (08:1451(j) Motion to Correct Order & Judg. of Naturalization)","08:287":"08:287 (08:287 Petition to Enforce INS Subpoena)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (09:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","09:0207":"09:0207 (09:0207 - Foreign Arbitration Awards)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1441":"12:1441 (12:1441(a) Breach of Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1790b":"12:1790b (12:1790(b) Credit Union Employee Protection Remedy)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1825":"12:1825 (12:1825 Exemption from Taxation)","12:191":"12:191 (12:191 Bank Foreclosure)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act)","12:2605":"12:2605 (12:2605 Real Estate Settlement Procedures Act (RESPA))","12:3409":"12:3409 (12:3409 Application for Delayed Customer Notice)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","12:5101":"12:5101 (12:5101 Secure and Fair Enforcement for Mortgage Licensing)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1679":"15:1679 (15:1679 Credit Repair Organization Act)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1691":"15:1691 (15:1691 Equal Credit Opportunity Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693":"15:1693 (15:1693 Electronic Fund Transfers)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","15:6103":"15:6103 (15:6103 - Telemarketing Consumer Fraud and Abuse Prevention)","15:6501":"15:6501 (15:6501 - Children's Online Privacy Protection Act of 1998)","15:7701":"15:7701 (15:7701 CAN-SPAM Act of 2003)","15:78dd":"15:78dd (15:78 Foreign Corrupt Practices Act)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","16:824a(3)":"16:824a(3) (16:824 a(3) Cogeneration and Small Power Production Rules)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","17:512":"17:512 (17:512 Digital Millennium Copyright Act)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0923":"18:0923 (18:923 - Review of Firearms Licensing)","18:0981":"18:0981 (18:981 Civil Forfeiture)","18:0982":"18:0982 (18:982 Criminal Forfeiture)","18:0985":"18:0985 (18:985 Civil Forfeiture of real property)","18:1030":"18:1030 (18:1030 Computer Fraud and Abuse Act)","18:1514A":"18:1514A (18:1514A - Civil Action to Protect Against Retaliation in Fraud Cases)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2510":"18:2510 (18:2510 Wire and Electronic Communications Interception)","18:2511":"18:2511 (18:2511 Wiretapping)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:3182":"18:3182 (18:3182 FUG FROM ST OR TERRITORY TO ST, DIST, OR TERRITORY)","18:3511":"18:3511 (18:3511 Judicial Review of Request for Information)","18:3626":"18:3626 (18:3626 - Prison Condition Remedies)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:0107":"20:0107 (20:0107 Vending Facilities for Blind in Federal Buildings)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1095":"20:1095 (20:1095 Student Loans-Transfer of Allotments)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1681":"20:1681 (20:1681 Title IX of the Education Amendment of 1972)","20:1987":"20:1987 (20:1987 Amendment of Higher Education Act of 1987)","21:0331":"21:0331 (21:0331 - Adulteration or misbranding of any food, drug, device, or cosmetic)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1300g-6":"25:1300g-6 (25:1300 Texas Restoration Act-Gaming Activities)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6226":"26:6226 (26:6226 Judicial Review - Tax Partnerships)","26:6334":"26:6334 (26:6334 - Application to Enforce Levy)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7431":"26:7431 (26:7431 - Civil Damages for Unauthorized Disclosure of Return Information)","26:7433":"26:7433 (26:7433 Civil Damages for Unauthorized Collection Actions)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157":"28:0157 (28:0157 Bankruptcy Non-Core Proceedings)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wc":"28:1332wc (28:1332 Diversity-Wrongful Conversion)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346a":"28:1346a (28:1346 Wrongful Tax Levy)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346ta":"28:1346ta (28:1346 Tucker Act)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1367":"28:1367 (28:1367 - Deceptive Trade Practices Act)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441ag":"28:1441ag (28:1441ag Petition for Removal - Age Discrimination)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cr":"28:1441cr (28:1441 Petition for Removal - Constitutional Rights)","28:1441cr1":"28:1441cr1 (28:1441 Petition for Removal - 42:1983 Civil Rights)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441di":"28:1441di (28:1441 Petition for Removal - Discrimination)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441em":"28:1441em (28:1441 Petition for Removal- Employment Discrimination)","28:1441f":"28:1441f (28:1441 Petition for Removal - Foreclosure)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fl":"28:1441fl (28:1441 Petition for Removal - Family & Medical Leave Act)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441lmr":"28:1441lmr (28:1441 Labor Management Relations Code)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441rc":"28:1441rc (28:1441 Petition for Removal - Race Discrimination)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441ts":"28:1441ts (28:1441 Petition for Removal - Title VII)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442fe":"28:1442fe (28:1442 Petition for Removal-Fed Employee/Scope of Employmt)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446at":"28:1446at (28:1446 Petition for Removal - Antitrust)","28:1446bc":"28:1446bc (28:1446 Petition for Removal-Breach of Contract)","28:1446er":"28:1446er (28:1446 Petition for Removal - ERISA)","28:1446fl":"28:1446fl (28:1446 Petition for Removal - Fair Labor Standards)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1446sd":"28:1446sd (28:1446 Petition For Removal - Sex Discrimination/Harass)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1491":"28:1491 (28:1491 Claim Against the United States)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1655":"28:1655 (28:1655 Adverse Possession of Personal Property & Injuries)","28:1696":"28:1696 (28:1696 Service In Foreign and International Litigation)","28:1738a":"28:1738a (28:1738A Parental Kidnapping Prevention Act)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (28:3001 Federal Debt Collection Procedures Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","28:754":"28:754 (28:754 Receiver of Property in Different District)","29:0141":"29:0141 (29:0141 Labor Management Relations Act of 1947)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0207":"29:0207 (29:207 Maximum Hours)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0701":"29:0701 (29:701 Rehabilitation Act of 1973)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1140":"29:1140 (29:1140 Interference with Protected Rights)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2001":"29:2001 (29:2001 Federal Employee Polygraph Protection Act)","29:2102":"29:2102 (29:2102 WARN Act (Worker Adjustment and Retraining Notification))","29:2601":"29:2601 (29:2601 Family and Medical Leave Act of 1993)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recover Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","31:5316":"31:5316 (31:5316 Reports on Exporting/Importing monetary instruments)","31:5317":"31:5317 (31:5317 Search and forfeiture of monetary instruments)","31:5324":"31:5324 (31:5324 Structuring of Financial Transactions)","31:5332":"31:5332 (31:5332 Forfeiture - Cash Smuggling)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","33:2702":"33:2702 (33:2702 Oil Pollution Liability and Compensation)","33:907":"33:907 (33:907 Longshore & Harbor Workers' Compensation Act)","35:0100":"35:0100 (35:100 Patent Infringement)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","35:0292":"35:0292 (35:292 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:1975":"38:1975 (38:1975 Recovery of Servicemen's Group Life Insurance - Jurisdiction of District Court)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:3720":"38:3720 (38:3720 Power of Secretary of Veterans Affairs)","38:4301":"38:4301 (38:4301 Right to Reemployment of Inducted Persons)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:3007":"39:3007 (39:3007 Detention of Mail)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:3114":"40:3114 (40:3114 Land Condemnation Action)","40:3131":"40:3131 (40:3131 Miller Act)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0292":"42:0292 (42:0292 - Health Professions Education - Student Loans)","42:0294":"42:0294 (42:0294 - Health Professions Education)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0407":"42:0407 (42:407 Federal Old-Age, Survivors and Disability Insurance)","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11603b":"42:11603b (42:11603(b) Appl. for Return of Child Pursuant to Hague Convention)","42:12101":"42:12101 (42:12101 Americans with Disabilities Act of 1990)","42:12117":"42:12117 (42:12117 Employment Discrimination on Basis of Disability)","42:12188":"42:12188 (42:12188 Americans with Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1395dd":"42:1395dd (42:1395dd Emergency Medical Treatment Act)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1437":"42:1437 (42:1437 Housing Act)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1973":"42:1973 (42:1973 Voting Rights Act)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000d":"42:2000d (42:2000d Federally Assisted Programs)","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000re":"42:2000re (42:2000 Job Discrimination (Religion))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:292(f)":"42:292(f) (42:292(f) Registration of State Court Judgment)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9604":"42:9604 (42:9604 Hazardous Substances Releases, Liability, Comp)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:0151":"47:0151 (47:0151 Federal Communications Commission)","47:0223":"47:0223 (47:223 Communications Decency Act)","47:0252":"47:0252 (47:252 Review of State Utilities Commission Determinations)","47:0521":"47:0521 (47:0521 Cable Communications)","47:0605":"47:0605 (47:0605 Unauthorized Publication and Use of Communication)","47:227":"47:227 (47:227 - Telephone Consumer Protection Act)","47:503":"47:503 (47:503 FCC Non-Compliance Forfeiture)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:10743":"49:10743 (49:10743 Liability for Payment of Rates)","49:10761":"49:10761 (49:10761 Transportation Prohibited w/o Tariff)","49:10762":"49:10762 (49:10762(a)(1) Recovery of charges - Interstate Commerce)","49:10921":"49:10921 (49:10921 Requirement for Permit Subject to ICC Jurisdiction)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:11707":"49:11707 (49:11707 Liability of Common Carriers under bills of lading)","49:14102":"49:14102 (49:14102 - Interstate Commerce - Leased Motor Vehicles)","49:14705":"49:14705 (49:14705 Recovery of Transportation Charge (ICC))","49:14706":"49:14706 (49:14706 Carmack Amendment)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","49:32705":"49:32705 (49:32705 Disclosure Requirements on Transfer of Motor Vehicles)","50:3937":"50:3937 (50:3937 Servicemembers Civil Relief Act (SCRA) - Interest Rate)","51:20137":"51:20137 (51:20137(1) Malpractice & Negligence Against U.S. Space Program)","adsup":"adsup (Administrative Subpoena)","bivens":"bivens (Bivens)","bivens-1":"bivens-1 (Bivens - Retaliation by Prison Offical)","contempt":"contempt (Contempt Proceedings)","fordepo":"fordepo (Foreign Deposition)","misc":"misc (Civil Miscellaneous Case)","motbank":"motbank (Motion to Stay Pending Bankruptcy Appeal)","motcomp":"motcomp (Motion to Compel)","motexam":"motexam (Motion to Examine)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","writecn":"writecn (Writ of Error Coram Nobis)","writgar":"writgar (Application for a Writ of Garnishment)"},"utdce":{"0":"0 (00:0000)","02:0431":"02:0431 (02:0431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:0437 Federal Election Commission)","05:0075":"05:0075 (05:0075(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:0551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:0552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:0702 Administrative Procedure Act)","05:0704":"05:0704 (05:0704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8101":"05:8101 (05:8101 Government Employees Compensation for Work Injuries)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","05:8701":"05:8701 (05:8701 Federal Employees Group Life Insurance Act (FEGLI))","05:8912":"05:8912 (05:8912 Federal Employee Health Benefit Act of 1959)","07:0006":"07:0006 (07:0006(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (07:0025 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:0181 Packers & Stockyard Act)","07:0499":"07:0499 (07:0499 Agricultural Commodities Act)","07:0601":"07:0601 (07:0601 USDA Condemnation)","07:2023":"07:2023 (07:2023 Food Stamp Act)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:0287":"08:0287 (08:0287 Petition to Enforce INS Subpoena)","08:1105":"08:1105 (08:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1182":"08:1182 (08:1182 Defend. Denial of Pla. Appl. for Alien Employment Ce)","08:1225":"08:1225 (08:1225 Immigration: Enforcement of Administrative Subpoena)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1421":"08:1421 (08:1421 Application for Judicial Review)","08:1446":"08:1446 (08:1446 Petition for Naturalization Hearing)","08:1447":"08:1447 (08:1447 Request for Naturalilzation Hearing)","08:1451(j)":"08:1451(j) (08:1451(j) Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:0001 U.S. Arbitration Act)","09:0009":"09:0009 (09:0009 Motion to Confirm Arbitration Award)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","09:0207":"09:0207 (09:0207 Application for Order Confirming Award of Arbitrators)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:0101 Bankruptcy)","11:0110":"11:0110 (11:0110(i) Bankruptcy - Assessment of Damage)","12:0022":"12:0022 (12:0022 Securities Fraud)","12:0191":"12:0191 (12:0191 Bank Foreclosure)","12:0192":"12:0192 (12:0192 Liquidation of National Bank)","12:0503":"12:0503 (12:0503 Civil Liability - Officers and Directors)","12:0635":"12:0635 (12:0635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1818":"12:1818 (12:1818 Collection of Civil Assessment)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act)","12:2605":"12:2605 (12:2605 Servicing of Mortgage Loans)","12:2607":"12:2607 (12:2607 Prohibition Against Kickbacks & Fees)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:0001 Antitrust Litigation)","15:0002at":"15:0002at (15:0002 Antitrust Litigation)","15:0002fl":"15:0002fl (15:0002(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:0005(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:0015 Antitrust Litigation)","15:0025":"15:0025 (15:0025 Clayton Act)","15:0044":"15:0044 (15:0044 Trademark Infringement)","15:0045":"15:0045 (15:0045 FTC Franchise Rule)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0053(b)":"15:0053(b) (15:0053(b) - Prelim & Perm Inj Relief & other Equita)","15:0077":"15:0077 (15:0077 Securities Fraud)","15:0077vb":"15:0077vb (15:0077 Enforce a SEC Summons)","15:0078":"15:0078 (15:0078m(a) Securities Exchange Act)","15:0631":"15:0631 (15:0631 Small Business Act)","15:0717":"15:0717 (15:0717 Natural Gas Act)","15:0754":"15:0754 (15:0754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1119":"15:1119 (15:1119 Cancellation of Trademark Proceedings)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1125(a)":"15:1125(a) (15:1125(a) False representation of goods sold in interstate commerce)","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1221":"15:1221 (15:1221 Federal Automobile Dealers' Day In Court Act)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1667":"15:1667 (15:1667 Consumer Lease Act)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1691":"15:1691 (15:1691 Equal Credit Opportunity Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693ef":"15:1693ef (15:1693 Electronic Funds Transfer Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2601":"15:2601 (15:2601 Toxic Substances Control Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:7701":"15:7701 (15:7701 Federal CAN-Spam Act)","15:78j(b)":"15:78j(b) (15:78j(b)ss Stockholder Suit)","15:80a-3":"15:80a-3 (15:80a-3 Investment Company Act of 1940)","16:0431":"16:0431 (16:0431 Antiquities Act)","16:0668":"16:0668 (16:0668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:0703 Migratory Bird Act)","16:1531":"16:1531 (16:1531 Endangered Species Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:0101 Copyright Infringement)","17:0501":"17:0501 (17:0501 Copyright Infringement)","17:0504":"17:0504 (17:0504 Copyright Infringement)","17:0512":"17:0512 (17:0512(h) Subpoena to Identify Copyright Infringer)","18:0241":"18:0241 (18:0241 Conspiracy Against Citizen Rights)","18:0925":"18:0925 (18:0925 Relief from Disabilities)","18:1030":"18:1030 (18:1030(g) Civil Action - Computer Fraud)","18:1836a":"18:1836a (18:1836(a) - Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) - Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2254":"18:2254 (18:2254 Civil Forfeiture)","18:2333":"18:2333 (18:2333 Personal Injury - International Terrorism)","18:2511":"18:2511 (18:2511 Wiretapping)","18:2701":"18:2701 (18:2701 Unlawful Access to Stored Communications)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:3512":"18:3512 (Foreign Requests for Assistance in Criminal Investigations and Prosecutions)","18:3582":"18:3582 (18:3582(c)(2) Motion to Modify Imposed Term of Imprisonment)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1681":"20:1681 (20:1681 Title IX Educational Amendments 1992 - Sex Discrimination)","21:0301":"21:0301 (21:0301 Seizure & Condemnation of Articles of Drug)","21:0841":"21:0841 (21:0841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:0881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:0881 Forfeiture Property - Aircraft)","21:0881o":"21:0881o (21:0881 Forfeiture Property - Other)","21:0881re":"21:0881re (21:0881 Forfeiture Property - Real Estate)","21:331":"21:331 (21:331 Federal Food, Drug & Cosmetic Act - Prohibited Acts)","21:360":"21:360 (21:360 Federal Food, Drug & Cosmetic Act - Drugs and Devices)","22:9003":"22:9003 (22:9003 Hague Convention - Petition for Return of Children)","23:0134":"23:0134 (23:0134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:0640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6330":"26:6330 (26:6330 IRS: Notice & Opportunity for Hearing Before Levy)","26:6334":"26:6334 (26:6334(e)(1) Levy Allowed on Principal Residences)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6672":"26:6672 (26:6672 IRS: Failure to Collect and Pay Over Tax, or Attempt to Evade or Defeat Tax)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402(b) IRS: Petition to Enforce IRS Summons)","26:7402a":"26:7402a (26:7402(a) IRS: Jurisdiction of District Courts)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7407":"26:7407 (Action to Enjoin Income Tax Preparers)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7434":"26:7434 (26:7434 IRS: Civil Damages for Fraudulent Filing of Information)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:0185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)","28:0185":"28:0185 (28:0185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:0451 Employment Discrimination)","28:0794":"28:0794 (28:0794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Fed. Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Fed. Question: Civil Rights Violation)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Fed. Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Fed. Question: Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Fed. Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332":"28:1332 (28:1332 Diversity)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity-Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity-Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 Diversity-Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 Diversity-Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity-Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334b":"28:1334b (28:1334(b) Proceeding arising/related to case under title 11)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1336":"28:1336 (28:1336 Surface Transportation Board Appeal)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 USA Plaintiff-Replevin & Conversion)","28:1345db":"28:1345db (28:1345 USA Plaintiff-Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 USA Plaintiff-Foreclosure)","28:1345ff":"28:1345ff (28:1345ff Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 USA Plaintiff-Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 USA Plaintiff-Property Damage)","28:1345pe":"28:1345pe (28:1345 USA Plaintiff-VA Property Ejectment)","28:1345rc":"28:1345rc (28:1345 USA Plaintiff-Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 USA Plaintiff-Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 USA Plaintiff-Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1350":"28:1350 (28:1350 Aliens Tort Claims Act)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1367":"28:1367 (28:1367 Other Property Damage)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Notice of Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Notice of Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Notice of Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Notice of Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Notice of Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Notice of Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Notice of Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Notice of Removal- Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441 Notice of Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Notice of Removal- Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Notice of Removal - Fair Credit Reporting)","28:1441fr":"28:1441fr (28:1441 Notice of Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Notice of Removal- Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Notice of Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Notice of Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Notice of Removal- Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Notice of Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Notice of Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Notice of Removal- Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Notice of Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Notice of Removal- Other Contract)","28:1441pd":"28:1441pd (28:1441 Notice of Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Notice of Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Notice of Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Notice of Removal)","28:1441qt":"28:1441qt (28:1441 Notice of Removal- Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Notice of Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 Notice of Removal- SEC Act)","28:1441sf":"28:1441sf (28:1441 Notice of Removal- Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Notice of Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Notice of Removal- Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Notice of Removal- Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Notice of Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Notice of Removal- Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Notice of Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Notice of Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Notice of Removal-Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Notice of Removal- Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Notice of Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Notice of Removal- Product Liability)","28:1446pr":"28:1446pr (28:1446 Notice of Removal)","28:1452":"28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)","28:1491":"28:1491 (28:1491 Tucker Act)","28:157b":"28:157b (28:157(b)(5) Personal Injury Tort/Wrongful Death Proceedings)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))","28:2241st":"28:2241st (28:2241 Petition for Writ of Habeas Corpus (State))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Actions Affecting Property on which United States had Lien)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (28:3001 Federal Debt Collection)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","28:754":"28:754 (28:754 Receiver of Property in Different Districts)","29:0151":"29:0151 (29:0151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:0160(1) National Labor Relations Act)","29:0184":"29:0184 (29:0184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:0185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:0185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:0201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:0201 Fair Labor Standards Act)","29:0203":"29:0203 (29:0203 Equal Pay Act)","29:0206":"29:0206 (29:0206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:0621 Job Discrimination (Age))","29:0623":"29:0623 (29:0623 Job Discrimination (Age))","29:0626":"29:0626 (29:0626 Job Discrimination (Age))","29:0633":"29:0633 (29:0633 Job Discrimination (Age))","29:0651":"29:0651 (29:0651 Occupational Safety/Health)","29:0754":"29:0754 (29:0754 Discrimination)","29:0790":"29:0790 (29:0790 Rehabilitation of Labor)","29:0791":"29:0791 (29:0791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1501":"29:1501 (29:1501 Job Training Partnership Act (JTPA))","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:216(b)":"29:216(b) (29:216(b) FLSA: Minimum wage or overtime compensation)","29:2601":"29:2601 (29:2601 Family and Medical Leave)","30:0181":"30:0181 (30:0181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","31:5317":"31:5317 (31:5317 Search and Forfeiture of Monetary Instruments)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:0145 Patent Infringement)","35:0183":"35:0183 (35:0183 Patent Infringement)","35:0271":"35:0271 (35:0271 Patent Infringement)","35:1":"35:1 (35:1 Establishment of PTO)","375/1":"375/1 (375/1 False Claims Act - U.S. Plaintiff)","38:0775":"38:0775 (38:0775 Recovery of Servicemen's Group Life Insurance)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (38:2021 Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4323":"38:4323 (38:4323 Uniformed Service Employment/Reemployment Rights Act)","38:6106":"38:6106 (38:6106 Misue of Benefits by Fiduciaries)","39:0409":"39:0409 (39:0409 Postal Service)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","40:0258":"40:0258 (40:0258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:0270 Miller Act)","40:0875":"40:0875 (40:0875 Public Buildings & Property: Negligence)","40:1101":"40:1101 (40:1101 Brooks Architect - Engineers Act)","40:3131":"40:3131 (40:3131 Bonds of Contractors of Public Buildings)","40:3142":"40:3142 (40:3142 Davis-Bacon Act (prevailing wages))","40:581":"40:581 (40:581 General Authority of Administrator of General Services)","41:0251":"41:0251 (41:0251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","41:7105(f)":"41:7105(f) (41:7105(f) Action to Judicially Enforce Administrative Subpoena)","42:0205":"42:0205 (42:0205 Denial Social Security Benefits)","42:0206":"42:0206 (42:0206 Social Security Benefits)","42:0247":"42:0247 (42:0247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:0402 Social Security Benefits)","42:0405id":"42:0405id (42:0405 Review of HHS Decision (SSID))","42:0405rs":"42:0405rs (42:0405 Review of HHS Decision (RSI))","42:0405wc":"42:0405wc (42:0405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:0405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:0416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:0427 Social Security Benefits)","42:11601":"42:11601 (42:11601 International Child Abduction Remedies Act)","42:12101":"42:12101 (42:12101 Americans with Disabilities Act of 1990)","42:12112":"42:12112 (42:12112 Americans with Disabilities Act - Employment Discrimination)","42:12117":"42:12117 (42:12117 Americans with Disabilities Act - Enforcement)","42:12132":"42:12132 (42:12132 Americans with Disabilities Act - Discrimination)","42:12188":"42:12188 (42:12188 Americans With Disabilities Act - Civil Enforcement Actions)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1395dd":"42:1395dd (Examination and treatment for emergency medical conditions and women in labor)","42:1396":"42:1396 (42:1396 Grants to States for Medical Assistance Programs)","42:13981":"42:13981 (42:13981 Violence Against Women Act 1994)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000 Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accommodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000rl":"42:2000rl (42:2000 Job Discrimination (religion))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2210":"42:2210 (42:2210 Radiation Exposure Compensation Act)","42:2615":"42:2615 (42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:3601 Fair Housing Act)","42:3604":"42:3604 (42:3604 (f)(3)(c) Fair Housing Amendments Act)","42:3613":"42:3613 (42:3613 Action for Inj Relief re Deprivation of Civil Rights)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9601":"42:9601 (42:9601 Comprehensive Environmental Compen/Resp/Liab (CERCLA)(Definitions))","42:9604":"42:9604 (42:9604 Comoprehensive Envir.,Response,Comp. & Liab.Act (CERCLA) - Removal and Other Remedies)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","42:9613":"42:9613 (42:9613 Comp Environ Recovery Comp & Liability Act (CERCLA) - Civil Proceedings)","43:945":"43:945 (43:0945 Compensation for Land Condemnation)","43:945a":"43:945a (43:0945a Complaint in Condemnation)","43:946":"43:946 (43:0946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:0051 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:0151 Railway Labor Act)","45:0184":"45:0184 (45:0184 Action to Set Aside Award of a System Board of Adjus)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:0688 Jones Act)","46:0741":"46:0741 (46:0741 Shipping)","46:0761":"46:0761 (46:0761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:0252":"47:0252 (47:0252 Telecomm-Procedures for negotion,arbitration,approva)","47:0605":"47:0605 (47:0605 Unauthorized Publication or Use of Communications)","47:227":"47:227 (47:227 FCC-Unsolicited Telephone Sales)","47:332(c)":"47:332(c) (47:332(c) Federal Telecommunications Act of 1996)","48:0883":"48:0883 (48:0883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:0081 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:0781 Forfeiture)","49:11501":"49:11501 (49:11501 Railroad Revitalization & Regulatory Reform Act (General jurisdiction))","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:14706":"49:14706 (49:14706 Carmack Amendment to the Interstate Commerce Act / Liability of Carriers - Receipts & Bills)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","52:30116":"52:30116 (52:30116 Limitations on Contributions and Expenditures)","7:1":"7:1 (7:1 Commodity Exchange Act)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","adsup":"adsup (Administrative Subpoena)","atydisc":"atydisc (Attorney Discipline)","atyreg":"atyreg (Attorney Registration)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","fordepo":"fordepo (Foreign Deposition)","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","writentry":"writentry (Application and order for entry to effect IRS Levy)","writgar":"writgar (Application for a Writ of Garnishment)"},"vaedce":{"0":"0 (no cause specified)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","02:1202":"02:1202 (02:1202 Discriminatory practices affecting US Senate employees)","02:1301":"02:1301 (02;1301 Congressional Accountability Act)","02:1317(a)":"02:1317(a) (02:1317(a) Violation of Congressional Accountability Act)","02:138":"02:138 (Library of Congress)","02:358":"02:358 (02:358 President's Recommendations of Exec.,Jud.& Leg. Salary)","02:681":"02:681 (02:681 Deferral of Budget Authority)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0554sc":"05:0554sc (05:0554 Constitutionality of State Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:0706":"05:0706 (05:0706 Judicial Review of Agency Action)","05:101":"05:101 (05:101 Ethics in Government Act)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","05:8701":"05:8701 (05:8701 Federal Employee's Group Life Insurance Act)","05:8903":"05:8903 (05:8903 Federal Employees Health Benefit Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","07:6999":"07:6999 (Judicial Review of Adverse Farm Agency Decision)","08:1101":"08:1101 (08:1101 Immigration and Nationality Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1231":"08:1231 (08:1231(a)(6) Due Process Clause)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1255":"08:1255 (08:1255 Immigration)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1421":"08:1421 (08:1421-Review of Denial of Application for Naturalization)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1447":"08:1447 (08:1447 Aliens: Refusal of Citizenship)","08:1447in":"08:1447in (08:1447 Immigration and Naturalization Act)","08:1451(j)":"08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Award)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2121":"10:2121 (10:2121 Health Professions Scholarship Financial Asst Prog)","10:2302":"10:2302 (10:2302 Arms Services Procurement Act)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","10:2323fa":"10:2323fa (10:2323 Fifth Amendment Equal Protection)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1452":"12:1452 (12:1452 Federal Home Loan Mortgage Corporation Act)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1787":"12:1787 (12:1787-Federal Credit Union Act)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1833":"12:1833 (12:1833 Forfieture Civil Penalties)","12:191":"12:191 (12:191 Bank Foreclosure)","12:192":"12:192 (12:192 Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Tying Arrangement Act)","12:2601":"12:2601 (12:2601 Violation of Real Estate Settlement Procedure Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","13:0021":"13:0021 (13:0021 Census Act of 1976)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0041":"15:0041 (15:0041 Federal Trade Commission Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Credit Repair Organization Act)","15:0045cp":"15:0045cp (15:0045 Violation of Children Online Privacy Protection Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:0717 Natural Gas Act - Land Condemnation)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1071":"15:1071 (15:1071 Appeal of Decision of U.S. Patent & Trademark Office)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1125ac":"15:1125ac (15:1125 Trademark (Anticybersquatting consumer protection))","15:1125la":"15:1125la (15:1125 Lanham Act)","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1679":"15:1679 (15:1679 Violation of Credit Repair Organizations Act)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1691":"15:1691 (15:1691 Equal Credit Opportunity Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693":"15:1693 (15:1693 Electronic Fees Transfer Act)","15:1701":"15:1701 (15:1701 Interstate Land Sales Full Disclosure Act (ILFFDA))","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1938fm":"15:1938fm (15:1938 Family Medical Leave Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2051":"15:2051 (15:2051 Consumer Products Safety Act)","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","15:7701":"15:7701 (15:7701 Federal CAN-Spam Act)","15:80":"15:80 (15:80 Violation of the Investment Advisors Act of 1940)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","16:470":"16:470 (16:470 National Historic Preservation Act)","16:470f":"16:470f (16:470 National Historic Preservation Act)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","17:1201":"17:1201 (17:1201 Digital Millennium Copyright Act)","18:0209":"18:0209 (18:0209 Conflict of Interest)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0981":"18:0981 (18:0981 Forfeiture)","18:1030":"18:1030 (18:1030 Computer Fraud and Abuse Act)","18:1345":"18:1345 (18:1345 Injunctive and Declaratory Relief)","18:1595":"18:1595 (18 USC 1595 Human Trafficking Litigation)","18:1831":"18:1831 (18:1831 Defense of Trade Secrets Act (DTSA))","18:1836a":"18:1836a (18:1836(a) - Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) - Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2331":"18:2331 (18:2331 Antiterrorism Act of 1990)","18:2511":"18:2511 (18:2511 Wiretapping)","18:2701":"18:2701 (18:2701 Federal Communications Privacy Act)","18:3006":"18:3006 (18:3006 Hyde Amendment, Statutory Note)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:3663":"18:3663 (18 U.S.C. 3663 - Civil Enforcement of Crim. Rest. Obligation)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1099":"20:1099 (20:1099 Higher Education Act)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1415":"20:1415 (20:1415 Handicapped Children's Protection Act)","20:1415de":"20:1415de (20:1415 Individuals with Disabilities Education Act)","20:1681":"20:1681 (20:1681 Civil Rights Education Amendments Act 1972)","21:0821":"21:0821 (21:0821 Violation of Record Keeping Provision of Controlled Substance Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:5872":"26:5872 (26:5872 Forfeiture - Firearms)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6330":"26:6330 (26:6330 Redetermination of IRS Collection Action)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7431":"26:7431 (26:7431 Unlawful Inspection and Disclosure of Confidential Tax Information by Agents of the IRS)","26:7434":"26:7434 (26:7434 IRS Fraudulent Loans)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","26:7609en":"26:7609en (26:7609 IRS: Petition to serve IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1161":"28:1161 (28:1161 Denial of Healthcare Coverage)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Federal Question)","28:1331ag":"28:1331ag (28:1331 Fed. Question: Employment Discrimination (Age))","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331as":"28:1331as (28:1331 Fed. Question: Assault, Libel, Slander)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331bv":"28:1331bv (28:1331 Federal Question Bivens-Prisoner)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cr":"28:1331cr (28:1331 Civil Rights (Race Discrimination))","28:1331cv":"28:1331cv (28:1331 Fed. Question: Civil Rights Violation)","28:1331dj":"28:1331dj (28:1331 Fed. Question: Declaratory Judgment)","28:1331dp":"28:1331dp (28:1331 Fed. Question-Violation of Due Process)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ef":"28:1331ef (28:1331 Fed. Question: Civil Rights Violation (Excess Force))","28:1331ej":"28:1331ej (28:1331 Fed. Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fa":"28:1331fa (28:1331 Fed. Question: Civil Rights Violation-False Arrest)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331fm":"28:1331fm (28:1331 Fed. Question - Family and Medical Leave Act)","28:1331fr":"28:1331fr (28:1331 Fed. Question: Fraud)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331lm":"28:1331lm (28:1331 Fed. Question: Labor/Mgt. Relations Act)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331ni":"28:1331ni (28:1331 Fed. Question: Negotiable Instrument)","28:1331pd":"28:1331pd (28:1331 Fed. Question: Property Damage)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331pl":"28:1331pl (28:1331 Fed. Question: Product Liability)","28:1331ra":"28:1331ra (28:1331 Fed. Question: Racketeering (RICO) Act)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331 Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sh":"28:1331sh (28:1331 Fed. Question: Sexual Harassment)","28:1331ss":"28:1331ss (28:1331 Fed. Question: Constitutionality of State Statutes)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331sx":"28:1331sx (28:1331 Fed. Question: Employment Discrimination (Sex))","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331vc":"28:1331vc (28:1331 Fed Question-Violation of Constitutional Rights)","28:1331w":"28:1331w (28:1331 Fed. Question: Wrongful Termination of Employment)","28:1331wd":"28:1331wd (28:1331 Fed. Question: Wrongful Death)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332ar":"28:1332ar (28:1332 Diversity-Appointment of Receiver)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332bf":"28:1332bf (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel, Assault, Slander)","28:1332lm":"28:1332lm (28:1332 Diversity-Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332md":"28:1332md (28:1332 Diversity-Motor Vehicle/Wrongful Death)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Personal Injury/ Motor Vehicle)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332op":"28:1332op (28:1332 Diversity-Recovery of Overpayment)","28:1332pa":"28:1332pa (28:1332 Diversity-Personal Injury/Airplane)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332rd":"28:1332rd (28:1332 Diversity-Recovery of Debt)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332rl":"28:1332rl (28:1332 Diversity-Rent Lease & Ejectment)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332sh":"28:1332sh (28:1332 Diversity-Sexual Harassment)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332ts":"28:1332ts (28:1332 Diversity-Misappropriation of Trade Secrets)","28:1332vt":"28:1332vt (28:1332 DIVERSITY-Natl Motor Vehicle Title Information Syst)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334bjd":"28:1334bjd (28:1334 Bankruptcy-Jury Demand)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1340irs":"28:1340irs (28:1340 IRS:Taxes)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 VA Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346pi":"28:1346pi (28:1346 Tort Claim - Personal Injury/Motor Vehicle)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1350":"28:1350 (28:1350 Alien Tort Claims Act)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1391cj":"28:1391cj (28:1391 Confessed Judgment)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1415de":"28:1415de (28:1415 Individuals with Disabilities Education Act)","28:1441":"28:1441 (28:1441 Notice of Removal-Violation Virginia Consumer Protection Act)","28:1441ac":"28:1441ac (28:1441 Notice of Removal-Account Receivable)","28:1441ag":"28:1441ag (28:1441 Notice of Removal-Civil Rights (Age))","28:1441al":"28:1441al (28:1441 Notice of Removal-Airline Crash)","28:1441as":"28:1441as (28:1441 Notice of Removal-Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Notice of Removal-Auto Negligence)","28:1441b":"28:1441b (28:1441 Notice of Removal-Employee Benefits)","28:1441bc":"28:1441bc (28:1441 Notice of Removal-Breach of Contract)","28:1441ca":"28:1441ca (28:1441 Notice of Removal-Clean Air Act)","28:1441cc":"28:1441cc (28:1441 Notice of Removal-Computer Crimes Act)","28:1441cf":"28:1441cf (28:1441 Notice of Removal - Consumer Financial Protection Act)","28:1441cj":"28:1441cj (28:1441 Notice of Removal-Confessed Judgement)","28:1441cp":"28:1441cp (28:1441 Notice of Removal-Copyright)","28:1441cr":"28:1441cr (28:1441 Notice of Removal-Civil Rights)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441d":"28:1441d (28:1441 Notice of Removal - Foreign State Garnishment)","28:1441df":"28:1441df (28:1441 Notice of Removal-Contract Default)","28:1441di":"28:1441di (28:1441 Notice of Removal-Civil Rights (Disability Act))","28:1441dj":"28:1441dj (28:1441 Notice of Removal-Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441 Notice of Removal-Contract Dispute)","28:1441ea":"28:1441ea (28:1441 Notice of Removal-Employment Discrimination (Age))","28:1441eb":"28:1441eb (28:1441 Notice of Removal E.R.I.S.A. Employee Benefits)","28:1441ed":"28:1441ed (28:1441 Notice of Removal-Employment Discrimination)","28:1441ep":"28:1441ep (28:1441 Notice of Removal - Equal Pay Act)","28:1441er":"28:1441er (28:1441 Notice of Removal-Employment Discrimination (Race))","28:1441es":"28:1441es (28:1441 Notice of Removal-Employment Discrimination (Sex))","28:1441fa":"28:1441fa (28:1441 Notice of Removal - (Civil Rights - False Arrest))","28:1441fc":"28:1441fc (28:1441 Notice Of Removal - Fair Credit Reporting Act)","28:1441fca":"28:1441fca (28:1441 Notice of Removal - False Claims Act-Retaliation)","28:1441fcl":"28:1441fcl (28:1441 Notice of Removal-Foreclosure)","28:1441fd":"28:1441fd (28:1441 Notice of Removal - Fair Debt Collection Act)","28:1441fe":"28:1441fe (28:1441 Notice of Removal-Fed. Employee Garnishment Statute)","28:1441fl":"28:1441fl (28:1441 Notice of Removal-Fair Labor Standards Act)","28:1441fm":"28:1441fm (28:1441 Notice of Removal - Family and Medical Leave Act)","28:1441fr":"28:1441fr (28:1441 Notice of Removal-Fraud)","28:1441fs":"28:1441fs (28:1441 Notice of Removal - Foreign Sovereign Immunities Act)","28:1441hb":"28:1441hb (28:1441 Notice of Removal - Petition of Habeas Corpus)","28:1441hc":"28:1441hc (28:1441 Notice of Removal - Handicapped Child Protection Act)","28:1441hd":"28:1441hd (28:1441 Notice of Removal-Housing Discrimination)","28:1441ia":"28:1441ia (28:1441 Notice of Removal-Interstate Commerce Act)","28:1441ij":"28:1441ij (28:1441 Notice of Removal-Injunctive/Declaratory Relief)","28:1441il":"28:1441il (28:1441 Notice of Removal-Interstate Land Full Discloser Act)","28:1441in":"28:1441in (28:1441 Notice of Removal-Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Notice of Removal-Libel, Assault, Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Notice of Removal-Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Notice of Removal-Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Notice of Removal-Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441op":"28:1441op (28:1441 Notice of Removal - Oil Pollution Act of 1990)","28:1441pa":"28:1441pa (Notice of Removal - Patent Infringement)","28:1441pd":"28:1441pd (28:1441 Notice of Removal-Property Damage)","28:1441pi":"28:1441pi (28:1441 Notice of Removal-Personal Injury)","28:1441pl":"28:1441pl (28:1441 Notice of Removal-Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441ps":"28:1441ps (28:1441 Notice of Removal-Claim against US Postal Service)","28:1441qt":"28:1441qt (28:1441 Notice of Removal-Petition to Quiet Title)","28:1441ra":"28:1441ra (28:1441 Notice of Removal-Civil Rights (Race))","28:1441ri":"28:1441ri (28:1441 Notice of Removal-RICO)","28:1441rl":"28:1441rl (28:1441 Notice of Removal-Rent Lease & Ejectment)","28:1441s":"28:1441s (28:1441 Notice of Removal - Economic Stabilization Act)","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 Notice of Removal-Securities Fraud)","28:1441sh":"28:1441sh (28:1441 Notice of Removal-Sexual Harassment)","28:1441ss":"28:1441ss (28:1441 Notice of Removal - Stockholders Suits)","28:1441sv":"28:1441sv (28:1441 Notice of Removal-Security Violation)","28:1441sx":"28:1441sx (28:1441 Notice of Removal-Civil Rights (Sex))","28:1441ti":"28:1441ti (28:1441 Notice of Removal-Trademark Infringement)","28:1441tl":"28:1441tl (28:1441 Notice of Removal - Truth and Lending)","28:1441tm":"28:1441tm (28:1441 Notice of Removal-Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Notice of Removal-Tort/Non-Motor Vehicle)","28:1441va":"28:1441va (28:1441 Notice of Removal-Little Miller Act)","28:1441vr":"28:1441vr (28:1441 Notice of Removal -Violation of Real Estate Settlement Procedure Act)","28:1441wd":"28:1441wd (28:1441 Notice of Removal-Wrongful Death)","28:1441wt":"28:1441wt (28:1441 Notice of Removal-Employment (Wrongful Termination))","28:1442bc":"28:1442bc (28:1442 Notice of Removal-Breach of Contract)","28:1442g":"28:1442g (28:1442 Notice of Removal-Garnishment)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1442ss":"28:1442ss (28:1442 Notice of Removal-Denial of Social Security Benefits)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444tax":"28:1444tax (28:1441 Notice of Removal-Recovery of IRS Tax)","28:1446":"28:1446 ()","28:1446cs":"28:1446cs (28:1446 Notice of Removal-Child Support Enforcement)","28:1446fm":"28:1446fm (28:1446 Notice of Removal-Family and Medical Leave Act)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446la":"28:1446la (28:1446 Notice of Removal - Lanham Act)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Notice of Removal-Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Notice of Removal-Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)","28:1602":"28:1602 (28:1602 Foreign Sovereign Ammunities Act)","28:1605":"28:1605 (28:1605 Antiterrorism & Effective Death Penalty Act 1996)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1738cs":"28:1738cs (28:1738 Child Custody Determination)","28:1782":"28:1782 (28:1782 Letter Rogatory)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201cp":"28:2201cp (28:2201 Declaratory Judgment (Copyright))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2401":"28:2401 (28:2401 Time for commencing action against United States)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (Actions affecting property on which United States had lien)","28:2415":"28:2415 (28:2415 Detinue and Conversion)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2671mv":"28:2671mv (28:2671mv Federal Tort Claims Act:Motor Vehicle)","28:2671pi":"28:2671pi (28:2671 Federal Tort Claim Act - Personal Injury)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:2679":"28:2679 (28:2679-Westfall Act)","28:2680":"28:2680 (28:2680 Federal Tort Claim Act Medical Malpractice)","28:2680mm":"28:2680mm (28:2680 Federal Tort Claims Act Med Malpractice)","28:534":"28:534 (28:534 Expungement of Arrest Record)","28:636":"28:636 (28:636 Request Release of Transcript)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0206epa":"29:0206epa (29:0206 Equal Pay Act)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2001":"29:2001 (29:2001 Employee Polygraph Protection Act)","29:2101":"29:2101 (29:2101 Workers Adjustment and Retraining Notification Act)","29:2601":"29:2601 (29:2601 Family and Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:0181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","31:5314":"31:5314 (31:5314 Failure to Report Interest in Foreign Accounts)","31:5317":"31:5317 (31:5317 Forfeiture-Funds involved in Structured Transactions)","33:0901":"33:0901 (33:0901 Longshoreman Habor Workers Compensation Act)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Non-Infringement- Patent Applicant is Dissatisfied with PTO Decision)","35:0183":"35:0183 (35:183 Patent Non-Infringement- Right to Compensation)","35:0271":"35:0271 (35:271 Patent Infringement)","35:0292":"35:0292 (35:292 False Marking)","35:1":"35:1 (35:1 Patent Non-Infringement - Declaratory Judgment)","35:146":"35:146 (35:146 Appeal of Decision of the Board of Patent Appeals and Interferences)","35:154":"35:154 (35:154 AIA Appeal of Patent Term Adjustment Determination)","35:256":"35:256 (35:256 Patent Non-Infringement)","35:281":"35:281 (35:281 Patent Infringement)","35:311":"35:311 (35:311 Patent - Request for Inter Partes Reexamination)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (38:2021 Homeless Veterans Reintegration Programs)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4301":"38:4301 (38:4301Right to Re-employment of Inducted Persons)","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:0270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:1101":"40:1101 (40:1101 Brooks Architect - Engineers Act)","40:3131":"40:3131 (40:3131 Miller Act)","40:3132":"40:3132 (40:3132 Miller Act)","40:3133":"40:3133 (40:3133 Miller Act)","40:3134":"40:3134 (40:3134 Miller Act)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","41:253":"41:253 (41:253 Competition in Contracting Act)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405rsi":"42:0405rsi (42:405 Review of HHS Decision (RSI))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11601":"42:11601 (42:11601 International Child Abduction Remedies Act)","42:12101ad":"42:12101ad (42:12101 Americans with Disability (Public Accommodations))","42:12101d":"42:12101d (42:12101 Americans with Disabilities Act)","42:1320d":"42:1320d (42:1320(d) Federal Health Insurance Portability and Accountability Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1395em":"42:1395em (42:1395 Fed. Quest: (Emergency Medical Treatment/Labor Act))","42:1396":"42:1396 (42:1396 Denial Medicaid Insurance)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1973":"42:1973 (42:1973 National Voter Registration Act)","42:1973gg":"42:1973gg (42:1973gg National Voter Rights Act)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983bv":"42:1983bv (42:1983 Bivens Non-Prisoner)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983cvp":"42:1983cvp (42:1983 Civil Rights (Personal Property))","42:1983dp":"42:1983dp (42:1983 Civil Right Denial of Due Process)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1983vp":"42:1983vp (42:1983 Violation of Due Process and Equal Protection)","42:1985":"42:1985 (42:1985 Conspiracy to Interfere with Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:1997":"42:1997 (42 USC 1997 CRIPA)","42:2000ad":"42:2000ad (42:2000 Job Discrimination (Disability Act))","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000cc":"42:2000cc (42:2000 Religious Land Use and Institutional Persons Act of 2000 (RLUIPA))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000no":"42:2000no (42:2000 Job Discrimination (National Origin))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accommodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000re":"42:2000re (42:2000 Job Discrimination (Religion))","42:2000sh":"42:2000sh (42:2000 Job Discrimination (Sexual Harassment))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:292":"42:292 (42:292(f) Health Education & Assistance Loan Program)","42:293f":"42:293f (42:293f Defaulted Heal Loan)","42:3601":"42:3601 (42:3601 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 National Environmental Policy Act)","42:4332pr":"42:4332pr (42:4332 Prisoner)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413 Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9601ce":"42:9601ce (42:9601 Notice of Removal - CERCLA)","42:9601cr":"42:9601cr (42:9601 CERCLA)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:0688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:1701":"46:1701 (46:1701 The Ocean Shipping Act of 1999)","46:31301":"46:31301 (46:31301 Ship Mortgage Act)","47:0203":"47:0203 (47:0203 Telecommunications Collection of Charges)","47:0227":"47:0227 (47:0227 FCC-Unsolicited Telephone Sales)","47:0332":"47:0332 (47:0332 Telecommuncations Act of 1996)","47:0605":"47:0605 (47:605 Violation of Federal Communications Act)","47:201":"47:201 (47:201 Enforcement of Communications Act of 1934)","47:201bt":"47:201bt (47:201 Breach of Tariff)","47:227":"47:227 (Telephone Consumer Protection Act)","47:338":"47:338 (47:338 Satellite Home Viewer Improvement Act)","47:553":"47:553 (47:553 Violation of the Communications Act of 1934)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0327":"49:0327 (49:0327 Federal Odometer Statute)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:11706":"49:11706 (49:11706 Carmack Amendent)","49:13101":"49:13101 (49:13101 Transportation Policy)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","49:30502":"49:30502 (49:30502 Natl Motor Vehicle Title Information Syst)","49:49101":"49:49101 (49:49101 Wrongful Termination in Contravention of Published Regulations)","49:49104":"49:49104 (49:49104 Breach of Lease by Metro. Wash. Airport Auth.)","50:0501":"50:0501 (50:0501 Soldiers and Sailors Civil Relief Act)","8:1252":"8:1252 (8:1252 Review of INS Decision)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","adsup":"adsup (Administrative Subpoena)","appiss":"appiss (Application to issue subpoenas)","apptro":"apptro (Application for a TRO)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","fcact":"fcact (False Claims Act)","fordepo":"fordepo (Foreign Deposition)","memsubp":"memsubp (Motion to Enforce Subpoena)","mensubp":"mensubp (Motion to enforce Subpoena)","misc":"misc (Civil Miscellaneous Case)","miscdm":"miscdm (Misc for dm cases)","moisletrog":"moisletrog (Motion for Issuance of Letter Rogatory)","motcomp":"motcomp (Motion to Compel)","motext":"motext (Motion to extend time)","motinj":"motinj (Motion for Injunction)","motinspect":"motinspect (Motion to Inspect)","motlv":"motlv (Petition/Motion for Leave to File)","motprod":"motprod (Motion for production of documents)","motproto":"motproto (Motion for Protective Order)","motquash":"motquash (Motion to Quash)","motrem":"motrem (Motion to Remand)","motret":"motret (Motion for Return of Property)","motseal":"motseal (Motion to Seal)","motstay":"motstay (Motion to Stay)","mottran":"mottran (Motion to transfer)","motvacarb":"motvacarb (Motion to vacate an arbitration award)","mrem":"mrem (Motion to Remand)","no":"no (No caused code entered)","objsub":"objsub (Objections to Subpoena Issued)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","writgar":"writgar (Application for a Writ of Garnishment)"},"vawdce":{"0":"0 (No cause code entered)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2023":"07:2023 (07:2023 SNAP Administrative and Judicial Review)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1421(c)":"08:1421(c) (08:1421(c) Petition for Review of Denial of Naturalization Application)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451(j)":"08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:191":"12:191 (12:191 Bank Foreclosure)","12:192":"12:192 (12:192 Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1125(d)":"15:1125(d) (15:1125(d) Anticybersquatting Consumer Protection Act)","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693":"15:1693 (15:1693 Electronic Fund Transfers)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:19jj":"16:19jj (16:19jj Park System Resource Protection Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0981":"18:0981 (18:981 - Civil Forfeiture)","18:1345":"18:1345 (18:1345 Injunctions Against Fraud)","18:1836a":"18:1836a (18:1836(a) - Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) - Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2511":"18:2511 (18:2511 Wiretapping)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1681":"20:1681 (20:1681 - Title IX of the Education Amendment of 1972)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","21:301":"21:301 (21:301 FOOD & DRUG ACT - FORFEITURE)","22:9001":"22:9001 (22:9001 et seq. (ICARA) International Child Abduction Remedies Act)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:5891":"26:5891 (26:5891 Structured Settlement)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7408":"26:7408 (26:7408 Actions to Enjoin Specified Conduct Related to Tax Shelters and Reportable Transactions)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2104":"29:2104 (29:2104 Warn Act)","29:2601":"29:2601 (29:2601 Family and Medical Leave Act (FMLA))","29:2615":"29:2615 (29:2615 Family and Medical Leave Act of 1993 (FMLA))","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","31:5314":"31:5314 (31:5314 Records and Reports on Foreign Financial Agency Transactions)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4301":"38:4301 (38:4301 Uniformed Services Employment & Re-employment Rights Act - USERRA)","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:3133":"40:3133 (40:3133 Miller Act)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:12101":"42:12101 (42:12101 Americans With Disabilities Act of 1990 (ADA))","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1485":"42:1485 (42:1485 Loan Default (Title V of Housing Act of 1949))","42:1935dd":"42:1935dd (42:1395dd Examination & Treatment for Emer Med Conds & Women in Labor)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000bb":"42:2000bb (42:2000bb-1 Free exercise of religion protected)","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:227":"47:227 (47:227 Telephone Consumer Protection Act of 1991)","47:332":"47:332 (47:332 Telecommunications Act of 1996)","47:553":"47:553 (47:553 Unauthorized Reception of Cable Service)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","49:20109":"49:20109 (49:20109 Federal Railroad Safety Act)","49:327":"49:327 (49:327 Federal Odometer Act)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","adsup":"adsup (Administrative Subpoena)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","fordepo":"fordepo (Foreign Deposition)","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","tro":"tro (Temporary Restraining Order)","writgar":"writgar (Application for a Writ of Garnishment)"},"vidce":{"0":"0 (No cause code entered)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"vtdce":{"0":"0 (no cause specified)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451(a)":"08:1451(a) (8:1451(a) Revocation of Naturalization)","08:1451(j)":"08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1833a":"12:1833a (12:1833a Financial Institutions Reform, Recovery and Enforcement Act)","12:191":"12:191 (12:191 Bank Foreclosure)","12:192":"12:192 (12:192 Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0013":"15:0013 (15:13 Robinson - Patman Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0012":"16:0012 (Federal Regulation and Development of Power)","16:0515":"16:0515 (16:515 Weeks Act)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2511":"18:2511 (18:2511 Wiretapping)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Fed. Question: Civil Rights Violation)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel, Assault, Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 VA Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345ss":"28:1345ss (28:1345 Recovery of SS Overpayment)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Notice of Removal-Account Receivable)","28:1441al":"28:1441al (28:1441 Notice of Removal-Airline Crash)","28:1441as":"28:1441as (28:1441 Notice of Removal-Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Notice of Removal-Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Notice of Removal-Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Notice of Removal-Contract Default)","28:1441dj":"28:1441dj (28:1441 Notice of Removal-Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441 Notice of Removal-Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Notice of Removal-Fraud)","28:1441ij":"28:1441ij (28:1441 Notice of Removal-Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Notice of Removal-Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Notice of Removal-Libel, Assault, Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Notice of Removal-Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Notice of Removal-Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Notice of Removal-Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Diversity-Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Notice of Removal-Property Damage)","28:1441pi":"28:1441pi (28:1441 Notice of Removal-Personal Injury)","28:1441pl":"28:1441pl (28:1441 Notice of Removal-Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Notice of Removal-Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Notice of Removal-Torts to Land)","28:1441tm":"28:1441tm (28:1441 Notice of Removal-Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Notice of Removal-Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Notice of Removal-Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Notice of Removal-Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1441 Notice of Removal-Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Notice of Removal-Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Notice of Removal-Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1963":"28:1963 (28:1963 Registration of Judgments for Enforcement in Other Districts)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))","28:2243":"28:2243 (28:2243 Petition for Writ of Habeas Corpus (Issuance of Writ))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (Actions affecting property on which United States had lien)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (28:3001 Federal Debt Collection Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:0201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2615":"29:2615 (29:2615 Family and Medical Leave Act of 1993)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4323":"38:4323 (USERRA Enforcement of Rights with Respect to a State or Private Employer)","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:0405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11603":"42:11603 (42:11603 International Child Abduction Remedies Act)","42:1383":"42:1383 (42:1383 Review of SSA Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1973":"42:1973 (42:1973 Denial or abridgement of right to vote re: race/color voting qualifications)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accommodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2011":"42:2011 (42:2011 Development and Control of Atomic Energy)","42:2615":"42:2615 (42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:3601 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:404":"42:404 (42:404 Overpayments and Underpayments)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0305":"46:0305 (46:305 Exoneration and Limitation of Liability)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:0151":"47:0151 (47:151 Federal Communications Commission Act)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","adsup":"adsup (Administrative Subpoena)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","fordepo":"fordepo (Foreign Deposition)","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","writgar":"writgar (Application for a Writ of Garnishment)"},"waedce":{"0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Adjudications Required by Statutes)","05:0701":"05:0701 (05:0701 Judicial Review of Agency Decision)","05:0702":"05:0702 (05:702 Administrative Procedure Act - Right of Review)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0215":"07:0215 (07:0215 Packers and Stockyards Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:1508":"07:1508 (7:1508 Crop Insurance)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1304":"08:1304 (08:1304 U.S. Immigration Act)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1447":"08:1447 (8:1447 - Request for Hearing on Denial of Application for Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1801fd":"12:1801fd (Breach of fiduciary duty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","12:5201":"12:5201 (12:5201 Emergency Economic Stabilization Act)","12:5220":"12:5220 (12:5220 Assistance to homeowners)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1222":"15:1222 (15:1222 Auto Dealer Franchise Protection Act)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","15:7701":"15:7701 (15:7701 CAN-SPAM Act)","16:0544":"16:0544 (15:0544 Conservation Columbia River Gorge)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:0814":"16:0814 (16:0814 Exercise by Licensee of Power of Eminent Domain)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1514":"18:1514 (18:1514 Temporary Restraining Order)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2344":"18:2344 (18:2344 Forfeiture of Contraband Cigarettes)","18:2701":"18:2701 (18:2701 Violation of Stored Electronic Communications Act)","18:2724":"18:2724 (18:2724 Civil Action - Motor Vehicle Records)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","18:924":"18:924 (18:924 Forfeiture)","18:925A":"18:925A (18:925A Erroneous Denial of a Firearm)","18:981":"18:981 (18:981 Civil Forfeiture)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1415":"20:1415 (20:1415 INDIVIDUALS WITH DISABILITIES EDUCATION ACT (IDEA))","21:0801":"21:0801 (21:801 Comprehensive Drug Abuse Prevention/Control Act 1970)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1302":"25:1302 (25:1302 Indian Civil Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","25:2701":"25:2701 (25:2701 Indian Gaming Regulatory Act (IGRA))","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6334":"26:6334 (26:6334 IRS: Property Exempt from Levy)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7421a":"26:7421a (IRS - Action by taxpayer)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7604":"26:7604 (26:7604 Petition to Enforce an IRS Summons)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331ev":"28:1331ev (28:1331ev Fed. Question: Environment)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332":"28:1332 (28:1332 Diversity)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332rp":"28:1332rp (Diversity - real property)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1332wf":"28:1332wf (28:1332wf Diversity: Windflower Patent Litigation)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345ud":"28:1345ud (28:1345ud Unlawful Detainer)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1350":"28:1350 (28:1350 Alien Tort Statute)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1491":"28:1491 (28:1491 Tucker Act)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Assistance to Foreign and International Tribunals and to Litigants Before Such Tribunals)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2101":"29:2101 (29:2101 Worker Adjustment & Retraining Notification Act)","29:2560":"29:2560 (29:2560 ERISA)","29:2617":"29:2617 (29:2617 Family Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","31:3733":"31:3733 (31:3733(j)(2) Pet to Mod or Set Aside CV Investigative Demand)","31:5314":"31:5314 (31:5314 Failure to Report Interest in Foreign Accounts)","31:5321":"31:5321 (31:5321 Penalty; Reports of Currency and Foreign Transaction)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:3131":"40:3131 (40:3131 Public Buildings, Property, and Works (Miller Act))","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","41:4712":"41:4712 (41:4712 Enhancement of contractor protection from reprisal for disclosure of certain information)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:0427 Social Security Benefits)","42:11045":"42:11045 (42:11045 Emergency Planning and Community Right to Know Act)","42:11601":"42:11601 (42:11601 International Child Abduction Remedies Act (ICARA))","42:12101":"42:12101 (42:12101 Americans With Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:13981":"42:13981 (42:13981 VIOLENCE AGAINST WOMEN ACT)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983cvp":"42:1983cvp (42:1983 Civil Rights (Personal Property))","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:1988":"42:1988 (42:1988 Proceedings in Vindication of Civil Rights)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000cc":"42:2000cc (42:2000cc (Religious Land Use and Institutionalized Persons Act))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2210":"42:2210 (42:2210-Price-Anderson Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:5851":"42:5851 (42:5851 Nuclear Whistleblower Protection)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9604":"42:9604 (CERCLA Comprehensive Environmental Response & Comp Act)","42:9606":"42:9606 (42:9606 Comp Environmental Response, Compensation (CERCLA))","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0322":"46:0322 (Injury at Sea)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:0605":"47:0605 (47:0605 UNAUTHORIZED PUBLICATION OR USE OF COMMUNICATION)","47:332":"47:332 (47:332 TELECOMMUNICATIONS ACT)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","7:499E(c4)":"7:499E(c4) (7:49E(c4) Perishable Agricultural Commodities Act (PACA))","8:1225":"8:1225 (8:1225 Enforcement of Administrative Subpoena)","8:1451":"8:1451 (8:1451 Immigration and Nationality Act)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"},"wawdce":{"0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (07:0006(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (07:0025 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:0287":"08:0287 (08:0287 Petition to Enforce INS Subpoena)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1183a":"08:1183a (08:1183a Immigration: Action for Enforcement of a Sponsor's Affidavit of Support)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1255":"08:1255 (08:1255 Adjustment of Status of Nonimmigrant to Permanent Resident)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1326":"08:1326 (08:1326 Aliens)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1447":"08:1447 (08:1447 Petition for Hearing on Naturalization Application)","08:1451j":"08:1451j (08:1451 Motion to Correct Order & Judg. of Naturalization)","08:287":"08:287 (08:287 Petition to Enforce INS Subpoena)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (09:0009 Motion to Confirm Arbitration)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","10:2733":"10:2733 (10:2733 Armed Forces: Noncombat Activities-Personal Injury)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissory Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:0717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693":"15:1693 (15:1693 Electronic Fund Transfers Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0981":"18:0981 (18:0981 Civil Forfeiture - Gambling, etc.)","18:1030":"18:1030 (18:1030 Computer Fraud and Abuse Act)","18:1345":"18:1345 (18:1345 Injunctions Against Fraud)","18:1514a":"18:1514a (18:1514a Civil Action to Protect Against Retaliation in Fraud Cases)","18:1836a":"18:1836a (18:1836(a) - Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) - Civil Action to Protect Trade Secrets)","18:1955":"18:1955 (18:1955 Forfeiture, Gambling)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2254":"18:2254 (18:2254 Forfeiture-Materials Involv.Sexual Exploit.of Minors)","18:2510":"18:2510 (18:2510 Wire and Electronics Communications Act)","18:2511":"18:2511 (18:2511 Wiretapping)","18:2701":"18:2701 (18:2701 Electronics Communication Privacy Act)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","18:925A":"18:925A (18:925A Firearms: Remedy for Erroneous Denial of Firearm)","18:925c":"18:925c (18:925(c) Restoration of Ability to Possess Firearms/Ammo)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0301":"21:0301 (21:0301 Federal Food, Drug & Cosmetic Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881pa":"21:0881pa (21:0881 Forfeiture Property - Automobile)","21:0881pc":"21:0881pc (21:0881 Forfeiture Property - Currency)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","26:982":"26:982 (26:982 Petition to Quash a Formal Document Request)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ef":"28:1331ef (28:1331 Federal Question: Civil Rights Violation (Excess Force))","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331oc":"28:1331oc (28:1331 Fed. Question: Other Contract)","28:1331pd":"28:1331pd (28:1331 Federal Question: Property Damage)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331ss":"28:1331ss (28:1331 Fed. Question: Constitutionality of State Statutes)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331vc":"28:1331vc (28:1331 Fed. Question: Violation of Constitutional Rights)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332":"28:1332 (28:1332 Diversity)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mc":"28:1332mc (28:1332 Marine Contract Actions)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1407b":"28:1407b (28:1407 Breach of Contract)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441ada":"28:1441ada (28:1441 Petition for Removal - Americans with Disabilities Act)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cpl":"28:1441cpl (28:1441 Petition for Removal - Contract Product Liability)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441er":"28:1441er (28:1441 Notice of Removal-ERISA)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1875":"28:1875 (28:1875 Protection of Juror Employment)","28:1916":"28:1916 (28:1916 Marine Contract Actions)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:01851m":"29:01851m (29:01851m Labor/Mgt. Relations)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0216b":"29:0216b (29:216(b) - FLSA: Minimum Wage or Overtime Compensation)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2601":"29:2601 (29:2601 Family & Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","31:3733j2":"31:3733j2 (31:3733(j)(2) Pet to Mod or Set Aside CV Investigative Demand)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","33:2701":"33:2701 (33:2701 Oil Pollution Act of 1990)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4323":"38:4323 (38:4323 USERRA - Enforcement of rights with respect to state or private employer)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405rsi":"42:0405rsi (42:0405 Review of HHS Decision (RSI))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11601":"42:11601 (International Child Abduction Remedies Act)","42:11603B":"42:11603B (Int'l Child Abduction Remedies Act (ICARA) - Judicial Remedies)","42:12112":"42:12112 (42:12112 Americans with Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1971":"42:1971 (42:1971 Voting Rights Act)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000e2":"42:2000e2 (42:2000e2ot Job Discrimination (other))","42:2000e3":"42:2000e3 (42:2000 Unlawful Employment Practices)","42:2000no":"42:2000no (42:2000 Job Discrimination (National Origin))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000rl":"42:2000rl (42:2000 Job Discrimination (Religion))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:423":"42:423 (42:423 Social Security Act (Disability Insurance Benefit Payments))","42:425":"42:425 (42:427 Social Security Benefits)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:6972":"42:6972 (42:6972 Environmental Matters)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","42:9613":"42:9613 (42:9613 Environmental Response, Compensation & Liability)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:0231":"45:0231 (45:0231 Railroad Retirement Act)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:0762":"46:0762 (46:762 Admiralty-Amount and apportionment of recovery)","46:0961":"46:0961 (46:0961 Foreclosure Preferred Ship Mortgage)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:1300":"46:1300 (46:1300 Marine - Bills of Lading)","46:183":"46:183 (46:183 Limitation of Liability)","46:688":"46:688 (46:688 Jones Act)","46:817":"46:817 (46:817 Recover Freight Charges)","46:951":"46:951 (46:951 Marine Contract Actions)","46:954":"46:954 (46:954 Marine Foreclosure)","47:0101":"47:0101 (47:0101 Federal Communications Act of 1934)","47:0227":"47:0227 (47:0227 Telephone Consumer Protection Act)","47:0230":"47:0230 (47:0230 Blocking/Screening Offensive Material on Internet)","47:0332":"47:0332 (47:0332 Violation of Telecommunications Act of 1996)","47:0553":"47:0553 (47:0553 Cable Communications Policy Act of 1984)","47:0605":"47:0605 (47:0605 Unauthorized Publication/Use of Communications)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:1076":"49:1076 (49:1076 ICC Rates)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","50a:533":"50a:533 (50a:533 Servicemembers Civil Relief Act - mortgages)","misc":"misc (Civil Miscellaneous Case)"},"wiedce":{"0":"0 (No cause code entered)","00:0000":"00:0000 (00:0000 Cause Code Unknown)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:0287":"08:0287 (08:0287 Petition to Vacate Arbitration Award)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1154":"08:1154 (Immigration Status)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1447":"08:1447 (08:1447 Petition for Hearing Before a District Court)","08:1451":"08:1451 (08:1451 To Revoke Citizenship)","08:287":"08:287 (08:0287 Petition to Enforce INS Subpoena)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Award)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:2601":"12:2601 (12:2601 RESPA Real Estate Settlement Procedures Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693":"15:1693 (15:1693 Electronic Funds Transfer Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:0924":"18:0924 (18:0924 Civil Forfeiture of Firearms)","18:0981":"18:0981 (18:0981 Civil Forfeiture)","18:0984":"18:0984 (18:0984 Civil Forfeiture of Fungible Property)","18:1030":"18:1030 (18:1030 Computer Fraud & Abuse Act)","18:1595":"18:1595 (18:1585 (human trafficking, peonage, slavery))","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2255":"18:2255 (18:2255 Civil Remedy for Personal Injuries)","18:2510-2521":"18:2510-2521 (18:2510 Electronic Communications Privacy Act)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1095":"20:1095 (Wage Garnishment)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgement)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Multi-district Litigation)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fl":"28:1441fl (28:1441 Petition for Removal - Fair Labor Standards Act)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2104":"29:2104 (29:2104 Warn Act)","29:2601":"29:2601 (29:2601 Family & Medical Leave Act 1993)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","31:5317fm":"31:5317fm (31:5317(c)(2) Forfeiture of Monetary Instruments)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1729":"38:1729 (38:1729 Recovery by the United States of the Cost of Certain Care and Services)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4301":"38:4301 (38:4301 Uniformed Services Employment & Reemployment Rights Act)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1985":"42:1985 (42:1985 Conspiracy Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ada":"42:2000ada (42:2000 American Disabilities Act)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:31301":"46:31301 (46:31301 Preferred Maritime Lien)","47:227":"47:227 (47:227 Telephone Consumer Protection Act)","47:605":"47:605 (47:605 Federal Communications Act of 1983)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","49:31105":"49:31105 (49:31105 Surface Transportation Assistance Act)","50:591":"50:591 (50:591 Servicemembers Civil Relief Act)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","adsup":"adsup (Administrative Subpoena)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","fordepo":"fordepo (Foreign Deposition)","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion of Return of Property)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","writgar":"writgar (Application for a Writ of Garnishment)"},"wiwdce":{"0":"0 (No cause code entered)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1447":"08:1447 (8:1447 Petition for Naturalization Hearing)","08:287":"08:287 (8:287 Petition to Enforce INS Subpoena)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:2605":"12:2605 (12:2605 Violation of RESPA & WCA)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0013":"15:0013 (15:13 Antitrust Litigation - Price)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693":"15:1693 (15:1693 Electronic Funds Transfer Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2087":"15:2087 (15:2087 Consumer Product Safety Improvement Act)","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1030":"18:1030 (18:1030 Computer Fraud and Abuse Act)","18:1836":"18:1836 (18:1836 Violation of Defend Trade Secrets Act)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2254":"18:2254 (18:2254 Forfeiture Property-Sexual Exploitation of Minors)","18:2724":"18:2724 (18:2724 Prohibition on Release of State Motor Vehicle Information)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","20:1415":"20:1415 (20:1415 Student Eligibility for Special Education and Services)","20:1681":"20:1681 (20:1681 Title IX)","21:0301":"21:0301 (21:0301 Seizure and Condemnation of Certain Articles of Drugs)","21:0841":"21:0841 (21:0841 Forfeiture Property - Drugs)","21:0880":"21:0880 (21:0880 Controlled Substances Act)","21:0881":"21:0881 (21:0881 Forfeiture Property - Currency)","21:0881a":"21:0881a (21:0881 Forfeiture Property - Aircraft)","21:0881au":"21:0881au (21:0881 Forfeiture Property - Automobile)","21:0881re":"21:0881re (21:0881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","25:2701":"25:2701 (25:2701 Tribal Gaming Compacts)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6331":"26:6331 (26:6331 IRS Writ of Entry to Enforce Levy)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6672":"26:6672 (26:6672 Refund of Penalty Assessed by IRS)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1071":"28:1071 (28:1071 Defaulted Student Loan)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 R&R re motions to remand (non-core))","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185":"29:0185 (29:0185 Labor Management Relations Act)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Disability))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A. - Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2601":"29:2601 (29:2601 Family and Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","31:5317":"31:5317 (31:5317 Forfeiture of monies in structured transactions)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0102":"35:0102 (35:0102 Patent - Declaration of Invalidity or Noninfringement)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4311-13":"38:4311-13 (38:4311-4313 Uniformed Service Employment/Reemployment Rights Act (USERRA))","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0292":"42:0292 (42:0292 Default on Repayment of Student Loans)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:12101":"42:12101 (42:12101 Americans with Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 Medicaid and CHIP Payment and Access Commission)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:18002":"42:18002 (42:18002 Early Retiree Reinsurance Program)","42:1973":"42:1973 (Uniformed and Overseas Citizens Absentee Voting Act)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000cc":"42:2000cc (42:2000cc RLUIPA (Religious Land Use and Institutionalized Persons Act))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0153":"45:0153 (45:0153 National Railroad Adjustment Board)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:31325":"46:31325 (46:31325 Foreclosure of Preferred Ship Mortgage)","47:0227":"47:0227 (47:0227 Restrictions on Use of Telephone Equipment)","47:605":"47:605 (Unauthorized Publication or Use of Communications)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:14706":"49:14706 (49:14706 Liability of Carriers Under Bills of Lading)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","49:31105":"49:31105 (49:31105 Surface Transportation Assistance Act)","50:535":"50:535 (50:535 (app) Servicemembers Civil Relief Act)","misc":"misc (Civil Miscellaneous Case)"},"wvndce":{"0":"0 (no cause specified)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451(j)":"08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:191":"12:191 (12:191 Bank Foreclosure)","12:192":"12:192 (12:192 Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:3001":"15:3001 (15:3001 Violation of Interstate Horse Racing Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1836a":"18:1836a (18:1836(a) - Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) - Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2511":"18:2511 (18:2511 Wiretapping)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","19:1305":"19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7431":"26:7431 (26:7431 Wrongful Disclosure of Tax Return Information)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Fed. Question: Civil Rights Violation)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel, Assault, Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 VA Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Notice of Removal-Account Receivable)","28:1441al":"28:1441al (28:1441 Notice of Removal-Airline Crash)","28:1441as":"28:1441as (28:1441 Notice of Removal-Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Notice of Removal-Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Notice of Removal-Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Notice of Removal-Contract Default)","28:1441dj":"28:1441dj (28:1441 Notice of Removal-Declaratory Judgment)","28:1441ds":"28:1441ds (28:1441 Notice of Removal-Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Notice of Removal-Fraud)","28:1441ij":"28:1441ij (28:1441 Notice of Removal-Injunctive/Declaratory Relief)","28:1441in":"28:1441in (28:1441 Notice of Removal-Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Notice of Removal-Libel, Assault, Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Notice of Removal-Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Notice of Removal-Negotiable Instrument)","28:1441nm":"28:1441nm (28:1441 Notice of Removal-Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Notice of Removal-Property Damage)","28:1441pi":"28:1441pi (28:1441 Notice of Removal-Personal Injury)","28:1441pl":"28:1441pl (28:1441 Notice of Removal-Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Notice of Removal-Petition to Quiet Title)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Notice of Removal-Torts to Land)","28:1441tm":"28:1441tm (28:1441 Notice of Removal-Tort/Motor Vehicle (P.I.))","28:1441tn":"28:1441tn (28:1441 Notice of Removal-Tort/Non-Motor Vehicle)","28:1441wd":"28:1441wd (28:1441 Notice of Removal-Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Notice of Removal-Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1441 Notice of Removal-Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Notice of Removal-Property Damage (P.I.))","28:1446pi":"28:1446pi (28:1446 Notice of Removal-Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (Actions affecting property on which United States had lien)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1342":"29:1342 (29:1342 Terminating Pension Plan)","29:1348":"29:1348 (29:1348(a)(4) Terming Pension Plan (Effective Date))","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4301":"38:4301 (38:4301 USERRA)","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","40:3131":"40:3131 (40:3131 Miller Act)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405rsi":"42:0405rsi (42:0405 Review of HHS Decision (RSI))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:12101":"42:12101 (42:12101 Americans with Disablities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accommodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:0332":"47:0332 (47:332(c) Communications Act of 1996)","47:0605":"47:0605 (47:605 Communications Act of 1934)","47:227":"47:227 (47:227 FCC-Unsolicited Telephone Sales)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","ShellCase":"ShellCase (Electronic Intake)","adsup":"adsup (Administrative Subpoena)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","fordepo":"fordepo (Foreign Deposition)","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","writgar":"writgar (Application for a Writ of Garnishment)"},"wvsdce":{"0":"0 (Civil Shell Case)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","05:8470":"05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2023":"07:2023 (07:2023 - Food Stamp Act)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1182":"08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)","08:1183a":"08:1183a (08:1183a - Requirements for sponsor's affidavit of support)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","08:1451(j)":"08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1408":"10:1408 (10:1408 Claim for Military Retirement)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2005":"10:2005 (10:2005 Recovery of Army Reserve Officers Training Benefits)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","111111":"111111 (Registration of Foreign Judgment)","11:0101":"11:0101 (11:101 Bankruptcy)","11:0362":"11:0362 (11:0362 Enforcement of Bankruptcy Stay)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1441a":"12:1441a (12:1441(a) Fed Question: Collection of Note & Security Agrmt)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1463":"12:1463 (12:1463 Home Owner's Loan Act)","12:1464":"12:1464 (12:1464 Federal Savings and Loan)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1716":"12:1716 (12:1716 Fannie Mae Charter Act)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1831":"12:1831 (12:1831 Depository Institution Employee Protection Remedy)","12:191":"12:191 (12:191 Bank Foreclosure)","12:192":"12:192 (12:192 Liquidation of National Bank)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:1972":"12:1972 (12:1972 Typing Arrangement Act)","12:2605":"12:2605 (12:2605 Real Estate Settlement Procedures Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","12:5567":"12:5567 (12:5567 Employee protection)","12:632":"12:632 (12:632 Jurisdiction of US Courts over suits where Federal Reserve Bank is a party)","12:85,86":"12:85,86 (12:85, 86 National Bank Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:0754":"15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1635":"15:1635 (15:1635 Right of Rescission as to Certain Transactions)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1693":"15:1693 (15:1693 Credit Card Accountability, Responsibility & Disclosure Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","16:814":"16:814 (Excercise by Licensee of Power of Eminent Domain)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:2254a2":"18:2254a2 (18:2254(a)(2) - Forfeiture of property used to commit child pornography offenses)","18:2428b1":"18:2428b1 (18:2428(b)(1) Forfeiture of Property - Transportation for illegal sexual activity and related crimes)","18:2511":"18:2511 (18:2511 Wiretapping)","18:2701":"18:2701 (18:2701 Stored Communications Act)","18:3114":"18:3114 (18:3114 Motion for Return of Seized Property)","18:3582":"18:3582 (18:3582(c)(2) Motion for Modification of Sentence)","18:3663":"18:3663 (Conversion of Restitution Order to Civil Judgment)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","18:923f3":"18:923f3 (18:923(f)(3) Review of a Revocation of Firearms License)","18:924(d)":"18:924(d) (18:924(d) - Forfeiture of Property-Firearms)","18:981":"18:981 (18:981(a)(1)(C) Forfeiture of Proceeds of Mail Fraud Scheme)","18:981a1c":"18:981a1c (18:981(a)(1)(C) - Forfeiture of proceeds of contraband cigarette trafficking)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Individuals with Disabilities Education Act (IDEA))","20:6301":"20:6301 (20:6301 Elem & Secondary Education Act of 1965, as amended)","21:0301":"21:0301 (21:0301 Federal Food, Drug and Cosmetic Act)","21:0801":"21:0801 (21:801 Controlled Substances Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","22:9001":"22:9001 (22:9001 et seq. International Child Abduction Remedies Act)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7434":"26:7434 (26:7434 Civil Damages for Fraudulent Filing of Information Returns)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0754":"28:0754 (28:754 Receiver of Property in Different Districts)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331ej":"28:1331ej (28:1331 Federal Question: Enforcement of Judgment)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331ij":"28:1331ij (28:1331ij Federal Question Injunction and Declaratory Relief)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331ng":"28:1331ng (28:1331 Fed. Question: Natural Gas Act)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331vi":"28:1331vi (28:1331 Violation of First Amendment)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332":"28:1332 (28:1332 Diversity - Class Action Fairness Act of 2005)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332nr":"28:1332nr (28:1332 Diversity-Notice of Removal)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345":"28:1345 (28:1345 USA Plaintiff)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1349":"28:1349 (28:1348 Corporation organized under Federal Law as party)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441nr":"28:1441nr (28:1441 Notice of Removal)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442a":"28:1442a (28:1442a - Notice of Removal - Law Enforcement Officer Safety Act)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442nr":"28:1442nr (28:1442 Notice of Removal)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446nr":"28:1446nr (28:1446 Notice of Removal)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 Removal of Claim in Civil Action Related to Bankruptcy Case)","28:1453b":"28:1453b (28:1453(b) - Class Action Fairness Act)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651a":"28:1651a (28 USC 1651a - All Writs Act)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1738":"28:1738 (28:1738 Enforce a Judgment for Monetary Damages)","28:1782":"28:1782 (28:1782 Letter rogatory - appointment)","28:1916":"28:1916 (28:1916 - Jones Act Seaman)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgment)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgment (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:3001":"28:3001 (28:3001 Federal Debt Collection Procedure)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","28:901-944":"28:901-944 (28:901-944 - Black Lung Benefits Act)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0630":"29:0630 (29:630 Age Discrimination in Employment Act)","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1166":"29:1166 (29:1166 Comprehensive Omnibus Budget Reconciliation Act of 1985 (COBRA))","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2101":"29:2101 (29:2101 - Worker Adjustment and Retraining Notification Act, \"WARN Act\")","29:2601":"29:2601 (29 USC 2601: Family & Medical Leave Act of 1993)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:0818":"30:0818 (30:0818 Injunctions/Federal Mine Safety Health Act)","30:0819":"30:0819 (30:0819 - Civil Penalty Assessment Petition)","30:0820j":"30:0820j (30:0820 - Complaint for Collection of Civil Penalties)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1270":"30:1270 (30:1270 Surface Mining Control & Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","31:5317":"31:5317 (31:5317 Search and Forfeiture of Monetary Instruments)","31:5324":"31:5324 (31:5324 Structuring Transaction to Evade Reporting Requirement Prohibited)","33:0914f":"33:0914f (33:0914(f) Longshore and Harbor Workers' Compensation Act)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","33:2701":"33:2701 (33:2701 Oil Pollution Act of 1990)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:2021":"38:2021 (38:2021 Right to re-employment of inducted persons)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4301":"38:4301 (38:4301 Uniform Services Employment and Re-employment Rights Act of 1994 (USERRA))","38:775":"38:775 (Recovery of Servicemen's Group Life Insurance)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0292":"42:0292 (42:292 - U. S. Health Education Assistance Loan (HEAL) Program)","42:0294":"42:0294 (42:294 - U. S. Health Education Assistance Loan (HEAL) Program)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405 g":"42:0405 g (42:405(g) - Reversal of Medicare Reimbursement Decision)","42:0405g":"42:0405g (42:0405g RSI Tax Suits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11601":"42:11601 (42:11601 International Child Abduction Remedies Act)","42:12101":"42:12101 (42:12101 Americans With Disabilities Act of 1991)","42:1211":"42:1211 (42:1211 - Americans with Disabilities Act)","42:1320d":"42:1320d (42:1320(d) Health Insurance Portability and Accountability Act of 1997 (HIPPA))","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1395dd":"42:1395dd (42:1395dd Emergency Medical Treatment and Active Labor Act (EMTALA))","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:15043":"42:15043 (42:15043 Developmental Disabilities & Bill of Rights Act)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2615":"42:2615 (42:2616 Medical Recovery Act)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:3604":"42:3604 (42:3604 Violation of Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:405":"42:405 (42:405 Black Lung)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource & Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9601":"42:9601 (42:9601- CERCLA)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","42:9831":"42:9831 (42:9831 Federal Violations of the Head Start Act)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","46:688":"46:688 (46:688 Jones Act)","47:0227":"47:0227 (47:0227 Telephone Consumer Protection Act)","47:0605":"47:0605 (47:0605 Communication Act of 1934)","47:151":"47:151 (47:151 Telecommunications Act of 1996)","47:401(b)":"47:401(b) (Intrastate rates and tariff)","47:605":"47:605 (47:605 Communications Act of 1934)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","49:20101":"49:20101 (49:20101 Federal Railroad Safety Act)","49:31100":"49:31100 (49:31100 Fed. Motor Carrier Safety Act of 1990)","52:20301":"52:20301 (52:20301 - Uniformed and Overseas Citizens Absentee Voting Act (UOCAVA))","77:7777":"77:7777 (77:7777 Civil Shell Case Opening)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","99:9999":"99:9999 (99:9999 Report cause code (DO NOT DELETE!))","adsup":"adsup (Administrative Subpoena)","apost":"apost (Issuance of Apostille)","contempt":"contempt (Contempt Proceedings)","disbar":"disbar (Disbarment Proceedings)","fordepo":"fordepo (Foreign Deposition)","misc":"misc (Civil Miscellaneous Case)","motcomp":"motcomp (Motion to Compel)","motquash":"motquash (Motion to Quash)","motret":"motret (Motion for Return of Property)","mottrans":"mottrans (Motion for Transcript)","petenf":"petenf (Petition to Enforce IRS Summons)","petper":"petper (Petition to Perpetuate Testimony)","regjgm":"regjgm (Registration of Foreign Judgment)","tranbkref":"tranbkref (Transmission of Bankruptcy Reference)","tranff":"tranff (Transmission of Proposed Findings of Fact and Concl. of Law)","writgar":"writgar (Application for a Writ of Garnishment)"},"wydce":{"0":"0 (No cause code entered)","02:0431":"02:0431 (02:431 Fed. Election Commission: Failure Enforce C)","02:0437":"02:0437 (02:437 Federal Election Commission)","05:0075":"05:0075 (05:75(2) Contract - Reduction in Grade)","05:0551":"05:0551 (05:551 Administrative Procedure Act)","05:0552fi":"05:0552fi (05:552 Freedom of Information Act)","05:0552pa":"05:0552pa (05:552 Right to Privacy Act)","05:0554":"05:0554 (05:0554 Constitutionality of Maritime Statutes)","05:0701":"05:0701 (05:0701 Maritime Subsidy Board)","05:0702":"05:0702 (05:702 Administrative Procedure Act)","05:0704":"05:0704 (05:704 Labor Litigation)","05:0706":"05:0706 (05:706(2) Administrative Procedures Act)","05:7703":"05:7703 (05:7703 Discrimination - Review of Agency Act)","07:0006":"07:0006 (7:6(b) Federal Commodity Exchange Regulation)","07:0025":"07:0025 (7:25 Fraud - Commodities Leverage Contracts)","07:0181":"07:0181 (07:181 Packers & Stockyard Act)","07:0499":"07:0499 (07:499 Agricultural Commodities Act)","07:0601":"07:0601 (07:601 USDA Condemnation)","07:2321":"07:2321 (07:2321 Plant Variety Protection Act)","08:1105":"08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)","08:1252":"08:1252 (08:1252(a)(2) Injunction for Deportation)","08:1260":"08:1260 (08:1260 Aliens: Access to Records)","08:1324":"08:1324 (08:1324 Aliens: Complaint for Forfeiture)","08:1329":"08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)","08:1446":"08:1446 (8:1446 Petition for Naturalization Hearing)","09:0001":"09:0001 (09:1 U.S. Arbitration Act)","09:0009":"09:0009 (9:9 Motion to Confirm Arbitration Loan)","09:0010":"09:0010 (09:0010 Petition to Vacate Arbitration Award)","10:1552":"10:1552 (10:1552 Armed Forces: Action to Correct Records)","10:1553":"10:1553 (10:1553 Armed Forces: FOIA General)","10:2305":"10:2305 (10:2305 Review of Federal Contract)","11:0101":"11:0101 (11:101 Bankruptcy)","12:0022":"12:0022 (12:22 Securities Fraud)","12:0635":"12:0635 (12:635 Breach of Insurance Contract)","12:1461":"12:1461 (12:1461 Homeowners Loan Act)","12:1703":"12:1703 (12:1703 Default of HUD Loan)","12:1725":"12:1725 (12:1725 Collection under Contract Guaranty)","12:1730":"12:1730 (12:1730 Collection Under Contract Guaranty)","12:1819":"12:1819 (12:1819 Default of Promissory Note)","12:1821":"12:1821 (12:1821 Default of Loan by Promissary Note)","12:1971":"12:1971 (12:1971 Relief under Bank Holding Act)","12:2601":"12:2601 (12:2601 RESPA-Real Estate Procedures Settlement Act)","12:3410":"12:3410 (12:3410 Right to Financial Privacy Act)","15:0001":"15:0001 (15:1 Antitrust Litigation)","15:0002at":"15:0002at (15:2 Antitrust Litigation)","15:0002fl":"15:0002fl (15:2(a) Fair Labor Standards Act)","15:0005":"15:0005 (15:5(a) Fair Labor Standards Act)","15:0015":"15:0015 (15:15 Antitrust Litigation)","15:0025":"15:0025 (15:25 Clayton Act)","15:0044":"15:0044 (15:44 Trademark Infringement)","15:0045":"15:0045 (15:0045 Federal Trade Commission Act)","15:0052":"15:0052 (15:0052 Federal Trade Commission Act)","15:0053":"15:0053 (15:0053 Federal Trade Commission Act)","15:0077":"15:0077 (15:77 Securities Fraud)","15:0078":"15:0078 (15:78m(a) Securities Exchange Act)","15:0631":"15:0631 (15:631 Small Business Act)","15:0717":"15:0717 (15:717 Natural Gas Act)","15:1051":"15:1051 (15:1051 Trademark Infringement)","15:1114":"15:1114 (15:1114 Trademark Infringement)","15:1121":"15:1121 (15:1121 Trademark Infringement)","15:1125":"15:1125 (15:1125 Trademark Infringement (Lanham Act))","15:1126":"15:1126 (15:1126 Patent Infringement)","15:1127":"15:1127 (15:1127 Trademark Infringement)","15:1601":"15:1601 (15:1601 Truth in Lending)","15:1640":"15:1640 (15:1640 Truth in Lending)","15:1681":"15:1681 (15:1681 Fair Credit Reporting Act)","15:1692":"15:1692 (15:1692 Fair Debt Collection Act)","15:1938":"15:1938 (15:1938 Fair Labor Standards Act)","15:1981":"15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))","15:1988":"15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))","15:1989":"15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))","15:2301":"15:2301 (15:2301 Magnuson-Moss Warranty Act)","15:2801":"15:2801 (15:2801 Petroleum Marketing Practices Act)","15:53(b)":"15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)","16:0668":"16:0668 (16:668 Bald Eagle Protection Act)","16:0703":"16:0703 (16:703 Migratory Bird Act)","16:1538":"16:1538 (16:1538 Endangered Species Act)","16:1600":"16:1600 (16:1600 National Forest Management Act of 1976)","16:3371":"16:3371 (16:3371 Wildlife Under the Lacey Act)","16:3372":"16:3372 (16:3372 Conservation: Complaint for Forfeiture)","16:3373":"16:3373 (16:3373 Appeal of Decision - DOI)","16:3374":"16:3374 (16:3374 Conservation: Complaint for Forfeiture)","17:0101":"17:0101 (17:101 Copyright Infringement)","17:0501":"17:0501 (17:501 Copyright Infringement)","17:0504":"17:0504 (17:504 Copyright Infringement)","18:0241":"18:0241 (18:241 Conspiracy Against Citizen Rights)","18:1836a":"18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)","18:1836b":"18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)","18:1961":"18:1961 (18:1961 Racketeering (RICO) Act)","18:1962":"18:1962 (18:1962 Racketeering (RICO) Act)","18:1964":"18:1964 (18:1964 Racketeering (RICO) Act)","18:4208":"18:4208 (18:4208(B) Agency Action Review)","18:983":"18:983 (18:983 Civil Forfeiture Proceedings)","19:1305":"19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)","20:1080":"20:1080 (20:1080 Student Loan Recovery)","20:1400":"20:1400 (20:1400 Civil Rights of Handicapped Child)","20:1401":"20:1401 (20:1401 Education: Handicapped Child Act)","21:0841":"21:0841 (21:841 Forfeiture Property-Drugs)","21:0842":"21:0842 (21:842 Food & Drug Act - Civil Penalties)","21:0881":"21:0881 (21:881 Forfeiture Property-Drugs)","21:0881a":"21:0881a (21:881 Forfeiture Property - Aircraft)","21:0881re":"21:0881re (21:881 Forfeiture Property - Real Estate)","21:876":"21:876 (Petition to Enforce DEA Subpoena)","23:0134":"23:0134 (23:134 P.I.- Auto Negligence)","23:1441":"23:1441 (23:1441 Contract Real Estate)","24:1000":"24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)","25:0640":"25:0640 (25:640 Indian Tribal Rights)","25:1901":"25:1901 (25:1901 Indian Child Welfare Act)","26:6212":"26:6212 (26:6212 Injunctive Relief from IRS Lien)","26:6213":"26:6213 (26:6213 Injunctive Relief from IRS Lien)","26:6502":"26:6502 (26:6502 IRS:Enforcement of tax liens)","26:6532":"26:6532 (26:6532 IRS: Refund of Tax Penalty)","26:6702":"26:6702 (26:6702 IRS: Refund of Income Tax Penalty)","26:6703":"26:6703 (26:6703 IRS: Refund of Tax Penalty)","26:7401":"26:7401 (26:7401 IRS: Tax Liability)","26:7402":"26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)","26:7403":"26:7403 (26:7403 Suit to Enforce Federal Tax Lien)","26:7422rt":"26:7422rt (26:7422 IRS: Refund Taxes)","26:7422rx":"26:7422rx (26:7422 IRS: Refund Excise Tax)","26:7425":"26:7425 (26:7425 Right of Redemption)","26:7426":"26:7426 (26:7426 IRS: Wrongful Levy for Taxes)","26:7429":"26:7429 (26:7429 IRS: Tax Jeopardy Assessment)","26:7609":"26:7609 (26:7609 IRS: Petition to Quash IRS Summons)","27:0185":"27:0185 (27:185 Enforcement of Arbitration Award)","28:0157c":"28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)","28:0157d":"28:0157d (28:0157 Motion for Withdrawal of Reference)","28:0158":"28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)","28:0185":"28:0185 (28:185 Suit to Compel Arbitration)","28:0451":"28:0451 (28:451 Employment Discrimination)","28:0794":"28:0794 (28:794 Rehabilitation Act)","28:1001":"28:1001 (28:1001 E.R.I.S.A.)","28:1132":"28:1132 (28:1132 E.R.I.S.A.)","28:1330":"28:1330 (28:1330 Breach of Contract)","28:1331":"28:1331 (28:1331 Fed. Question)","28:1331al":"28:1331al (28:1331 Fed. Question: Airline Crash)","28:1331at":"28:1331at (28:1331 Fed. Question: Anti-trust)","28:1331au":"28:1331au (28:1331 Fed. Question: Auto Negligence)","28:1331b":"28:1331b (28:1331 Federal Question: Bivens Act)","28:1331bc":"28:1331bc (28:1331 Fed. Question: Breach of Contract)","28:1331ca":"28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)","28:1331cm":"28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)","28:1331cv":"28:1331cv (28:1331 Federal Question: Other Civil Rights)","28:1331ed":"28:1331ed (28:1331 Fed. Question: Employment Discrimination)","28:1331es":"28:1331es (28:1331 Enforcement of Administrative Subpoena)","28:1331fl":"28:1331fl (28:1331 Fed. Question: Fair Labor Standards)","28:1331in":"28:1331in (28:1331 Fed. Question: Insurance Contract)","28:1331mm":"28:1331mm (28:1331 Fed. Question: Medical Malpractice)","28:1331pi":"28:1331pi (28:1331 Fed. Question: Personal Injury)","28:1331rd":"28:1331rd (28:1331 Fed. Question: Review Agency Decision)","28:1331rp":"28:1331rp (28:1331(a) Fed. Question: Real Property)","28:1331rr":"28:1331rr (28:1331 Fed. Question: Railway Labor Act)","28:1331sv":"28:1331sv (28:1331 Fed. Question: Securities Violation)","28:1331tr":"28:1331tr (28:1331 Fed. Question: Trademark)","28:1331tt":"28:1331tt (28:1331 Fed. Question: Tort Action)","28:1331v":"28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)","28:1331wl":"28:1331wl (28:1331 Federal Question: EPA Waste Lien)","28:1331wt":"28:1331wt (28:1331 Fed. Question: Water Rights)","28:1332ac":"28:1332ac (28:1332 Diversity-Account Receivable)","28:1332al":"28:1332al (28:1332 Diversity-Airline Crash)","28:1332as":"28:1332as (28:1332 Diversity-Asbestos Litigation)","28:1332au":"28:1332au (28:1332 Diversity-Auto Negligence)","28:1332bc":"28:1332bc (28:1332 Diversity-Breach of Contract)","28:1332co":"28:1332co (28:1332 Diversity-Conversion)","28:1332ct":"28:1332ct (28:1332 Diversity-(Citizenship))","28:1332det":"28:1332det (28:1332 Diversity: Forcible Detainer)","28:1332df":"28:1332df (28:1332 Diversity-Contract Default)","28:1332ds":"28:1332ds (28:1332 Diversity-Contract Dispute)","28:1332ed":"28:1332ed (28:1332 Diversity-Employment Discrimination)","28:1332fd":"28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)","28:1332fr":"28:1332fr (28:1332 Diversity-Fraud)","28:1332ia":"28:1332ia (28:1332 Diversity-Interpleader Action)","28:1332ij":"28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)","28:1332in":"28:1332in (28:1332 Diversity-Insurance Contract)","28:1332jd":"28:1332jd (28:1332 Diversity-Declaratory Judgment)","28:1332lb":"28:1332lb (28:1332 Diversity-Libel,Assault,Slander)","28:1332lm":"28:1332lm (28:1332 Diversity - Legal Malpractice)","28:1332ma":"28:1332ma (28:1332 Diversity-Miller Act)","28:1332mm":"28:1332mm (28:1332 Diversity-Medical Malpractice)","28:1332mv":"28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)","28:1332ni":"28:1332ni (28:1332 Diversity-Negotiable Instrument)","28:1332nm":"28:1332nm (28:1332 Diversity-Non-Motor Vehicle)","28:1332oc":"28:1332oc (28:1332 Diversity-Other Contract)","28:1332pd":"28:1332pd (28:1332 Diversity-Property Damage)","28:1332pi":"28:1332pi (28:1332 Diversity-Personal Injury)","28:1332pl":"28:1332pl (28:1332 Diversity-Product Liability)","28:1332pr":"28:1332pr (28:1332 Diversity-Petition for Removal)","28:1332qt":"28:1332qt (28:1332 Diversity-Petition to Quiet Title)","28:1332ri":"28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)","28:1332sa":"28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)","28:1332sf":"28:1332sf (28:1332 - Diversity: Securities Fraud)","28:1332ss":"28:1332ss (28:1332 Diversity - Stockholders Suits)","28:1332tl":"28:1332tl (28:1332 Diversity-Torts to Land)","28:1332tm":"28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))","28:1332tn":"28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)","28:1332wd":"28:1332wd (28:1332 Diversity-Wrongful Death)","28:1333":"28:1333 (28:1333 Admiralty)","28:1334":"28:1334 (28:1334 Bankruptcy Appeal)","28:1334c":"28:1334c (28:1334(c) R&R re motions for abstention (non-cor)","28:1335":"28:1335 (28:1335 Interpleader Action)","28:1337":"28:1337 (28:1337 Sherman-Clayton Act)","28:1338cp":"28:1338cp (28:1338 Copyright Infringement)","28:1338pt":"28:1338pt (28:1338 Patent Infringement)","28:1338tr":"28:1338tr (28:1338 Trademark Infringement)","28:1340":"28:1340 (28:1340 IRS: Custom Duties)","28:1340er":"28:1340er (28:1340 Recovery of Erroneous Refund)","28:1341":"28:1341 (28:1341 Complaint for Forfeiture)","28:1343":"28:1343 (28:1343 Violation of Civil Rights)","28:1345co":"28:1345co (28:1345 Replevin & Conversion)","28:1345db":"28:1345db (28:1345 Debt to US - FHA/HUD Title I)","28:1345df":"28:1345df (28:1345 Default of Promissory Note)","28:1345er":"28:1345er (28:1345 Recovery of Erroneous Refund)","28:1345fc":"28:1345fc (28:1345 Foreclosure)","28:1345ff":"28:1345ff (28:1345 Complaint for Forfeiture)","28:1345hl":"28:1345hl (28:1345 VA Home Loan Guaranty Debt)","28:1345mc":"28:1345mc (28:1345 Medical Care Recovery)","28:1345mi":"28:1345mi (28:1345 Mining Claim Ejectment)","28:1345pd":"28:1345pd (28:1345 Property Damage)","28:1345pe":"28:1345pe (28:1345 Property Ejectment)","28:1345rc":"28:1345rc (28:1345 Recovery of Debt to US)","28:1345st":"28:1345st (28:1345 Default of Student Loan)","28:1345tp":"28:1345tp (28:1345 Trespass on Public Land)","28:1345va":"28:1345va (28:1345 Recovery of VA Overpayment)","28:1346bc":"28:1346bc (28:1346 Breach of Contract)","28:1346rc":"28:1346rc (28:1346 Recovery of IRS Tax)","28:1346tc":"28:1346tc (28:1346 Tort Claim)","28:1346wd":"28:1346wd (28:1346 Wrongful Death)","28:1352":"28:1352 (28:1352 Miller Act)","28:1355":"28:1355 (28:1355 Petition for Return of Property)","28:1358":"28:1358 (28:1358 Land Condemnation)","28:1361":"28:1361 (28:1361 Petition for Writ of Mandamus)","28:1362ic":"28:1362ic (28:1362 Indian Tribal Controversy)","28:1362iw":"28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)","28:1364":"28:1364 (28:1364 Auto Negligence)","28:1391":"28:1391 (28:1391 Personal Injury)","28:1402":"28:1402 (28:1402 Medical Malpractice)","28:1407":"28:1407 (28:1407 Airline Crash)","28:1441ac":"28:1441ac (28:1441 Petition for Removal- Account Receivable)","28:1441al":"28:1441al (28:1441 Petition for Removal- Airline Crash)","28:1441as":"28:1441as (28:1441 Petition for Removal- Asbestos Litigation)","28:1441au":"28:1441au (28:1441 Petition for Removal- Auto Negligence)","28:1441bc":"28:1441bc (28:1441 Petition for Removal- Breach of Contract)","28:1441cv":"28:1441cv (28:1441 Petition for Removal- Civil Rights Act)","28:1441df":"28:1441df (28:1441 Petition for Removal- Contract Default)","28:1441dj":"28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)","28:1441ds":"28:1441ds (28:1441 Petition for Removal- Contract Dispute)","28:1441ed":"28:1441ed (28:1441 Petition for Removal - Employment Discrim)","28:1441fc":"28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)","28:1441fr":"28:1441fr (28:1441 Petition for Removal- Fraud)","28:1441ij":"28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)","28:1441in":"28:1441in (28:1441 Petition for Removal- Insurance Contract)","28:1441int":"28:1441int (28:1441 Petition for Removal- Action for Interplea)","28:1441lb":"28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)","28:1441lm":"28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)","28:1441mm":"28:1441mm (28:1441 Petition for Removal- Medical Malpractice)","28:1441ni":"28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)","28:1441nm":"28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)","28:1441oc":"28:1441oc (28:1441 Petition For Removal--Other Contract)","28:1441pd":"28:1441pd (28:1441 Petition for Removal- Property Damage)","28:1441pi":"28:1441pi (28:1441 Petition for Removal- Personal Injury)","28:1441pl":"28:1441pl (28:1441 Petition for Removal- Product Liability)","28:1441pr":"28:1441pr (28:1441 Petition for Removal)","28:1441qt":"28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)","28:1441ri":"28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))","28:1441sa":"28:1441sa (28:1441 - Petition for Removal: SEC Act)","28:1441sf":"28:1441sf (28:1441 - Petition for Removal: Securities Fraud)","28:1441tl":"28:1441tl (28:1441 Petition for Removal- Torts to Land)","28:1441tm":"28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()","28:1441tn":"28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)","28:1441wd":"28:1441wd (28:1441 Petition for Removal- Wrongful Death)","28:1442bc":"28:1442bc (28:1442 Petition for Removal- Breach of Contract)","28:1442pr":"28:1442pr (28:1442 Petition for Removal)","28:1443":"28:1443 (28:1443(1) Rent, Lease & Ejectment)","28:1444":"28:1444 (28:1444 Petition for Removal- Foreclosure)","28:1446in":"28:1446in (28:1446 Breach of Contract- Insurance)","28:1446pd":"28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)","28:1446pi":"28:1446pi (28:1446 Petition for Removal- Personal Injury)","28:1446pl":"28:1446pl (28:1446pl Petition for Removal - Product Liability)","28:1446pr":"28:1446pr (28:1446 Petition for Removal)","28:1452":"28:1452 (28:1452 Bankruptcy Removal)","28:1651":"28:1651 (28:1651 Petition for Writ of Coram Nobis)","28:1651hc":"28:1651hc (28:1651 Petition for Writ of Habeas Corpus)","28:1651mn":"28:1651mn (28:1651 Petition for Writ of Mandamus)","28:1652":"28:1652 (28:1652 Quiet Title to Real Property)","28:1983":"28:1983 (28:1983 Civil Rights)","28:2201":"28:2201 (28:2201 Constitutionality of State Statute(s))","28:2201dj":"28:2201dj (28:2201 Declaratory Judgement)","28:2201ij":"28:2201ij (28:2201 Injunction)","28:2201in":"28:2201in (28:2201 Declaratory Judgement (Insurance))","28:2241":"28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)","28:2241st":"28:2241st (28:2241 Petition for Writ of Habeas Corpus (state detainer))","28:2254":"28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))","28:2254se":"28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)","28:2255":"28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)","28:2271":"28:2271 (28:2271 Federal Tort Claims Act)","28:2345":"28:2345 (28:2345 Medicare Recovery)","28:2409":"28:2409 (28:2409(a) Quiet Title Action)","28:2410":"28:2410 (28:2410 Quiet Title)","28:2671":"28:2671 (28:2671 Federal Tort Claims Act)","28:2674":"28:2674 (28:2674 Federal Tort Claims Act)","28:2675":"28:2675 (28:2675 Federal Tort Claims Act)","28:7402":"28:7402 (28:7402 Refund of Taxes)","28:7422":"28:7422 (28:7422 Appeal from Administrative Decision)","28:7425":"28:7425 (28:7425 Quiet Title or Rescission of Foreclosure)","29:0151":"29:0151 (29:151 Labor: Review of Agency Action)","29:0160":"29:0160 (29:160(1) National Labor Relations Act)","29:0184":"29:0184 (29:184 Violation Collection Bargain Agreement)","29:0185ep":"29:0185ep (29:185 Employee Pension Plan)","29:0185lm":"29:0185lm (29:185 Labor/Mgt. Relations (Contracts))","29:0201do":"29:0201do (29:201 Denial of Overtime Compensation)","29:0201fl":"29:0201fl (29:201 Fair Labor Standards Act)","29:0203":"29:0203 (29:203 Equal Pay Act)","29:0206":"29:0206 (29:206 Collect Unpaid Wages)","29:0401":"29:0401 (29:0401 Labor Management Disclosure Act)","29:0621":"29:0621 (29:621 Job Discrimination (Age))","29:0623":"29:0623 (29:623 Job Discrimination (Age))","29:0626":"29:0626 (29:626 Job Discrimination (Age))","29:0633":"29:0633 (29:633 Job Discrimination (Age))","29:0651":"29:0651 (29:651 Occupational Safety/Health)","29:0754":"29:0754 (29:754 Discrimination)","29:0791":"29:0791 (29:791 Job Discrimination (Rehabilitation Act))","29:0794":"29:0794 (29:0794 Job Discrimination (Handicap))","29:1001":"29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)","29:1002":"29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)","29:1104":"29:1104 (29:1104 Recovery of Benefits to Employee)","29:1109":"29:1109 (29:1109 Breach of Fiduciary Duties)","29:1131":"29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)","29:1132":"29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)","29:1145":"29:1145 (29:1145 E.R.I.S.A.)","29:1149":"29:1149 (29:1149 Recover Pension & Profit Sharing)","29:1337":"29:1337 (29:1337 E.R.I.S.A.)","29:1362":"29:1362 (29:1362 ERISA)","29:1381":"29:1381 (29:1381 E.R.I.S.A.)","29:1401":"29:1401 (29:1401(b)(2) Appeal of Arbitration Award)","29:1451":"29:1451 (29:1451 E.R.I.S.A.)","29:1801":"29:1801 (29:1801 Farmworker Rights)","29:2601":"29:2601 (29:2601 Family and Medical Leave Act)","29:790":"29:790 (29:790 Rehabilitation of Labor)","30:0181":"30:0181 (30:181 Environment: Review of Agency Action)","30:0801":"30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)","30:1201":"30:1201 (30:1201 Environment: Review of Agency Action)","30:1202":"30:1202 (30:1202 Mining Reclamation Act)","30:1276":"30:1276 (30:1276 Interior: Review of Agency Action)","31:3545":"31:3545 (31:3545 Action to Recovery Money)","31:3729":"31:3729 (31:3729 False Claims Act)","31:3730":"31:3730 (31:3730 Qui Tam False Claims Act)","31:3731":"31:3731 (31:3731 Fraud)","33:1319cw":"33:1319cw (33:1319 Clean Water Act)","33:1319pv":"33:1319pv (33:1319 Pollutants & Permit Violations)","33:1365":"33:1365 (33:1365 Environmental Matters)","35:0145":"35:0145 (35:145 Patent Infringement)","35:0183":"35:0183 (35:183 Patent Infringement)","35:0271":"35:0271 (35:271 Patent Infringement)","38:1151":"38:1151 (38:1151 VA Medical compensation claims)","38:1681":"38:1681 (38:1681 Recovery of VA Overpayment)","38:1686":"38:1686 (38:1686 Recovery of VA Overpayment)","38:1780":"38:1780 (38:1780 Recovery of VA Overpayment)","38:2011":"38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)","38:3116":"38:3116 (38:3116 VA Overpayment)","38:4301":"38:4301 (38:4301 Uniformed Services Employment and Reemployment Act)","39:3005":"39:3005 (39:3005 Detention of Mail for Temporary Periods)","39:409":"39:409 (39:409 Postal Service)","40:0258":"40:0258 (40:258(a) Public Buildings & Property: Land Condem)","40:0270":"40:0270 (40:270 Miller Act)","40:0875":"40:0875 (40:875 Public Buildings & Property: Negligence)","41:0251":"41:0251 (41:251 Public Contracts-Review of Agency Action)","41:1463":"41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)","42:0205":"42:0205 (42:205 Denial Social Security Benefits)","42:0206":"42:0206 (42:206 Social Security Benefits)","42:0247":"42:0247 (42:247 Personal Injury-Swine Flu)","42:0402":"42:0402 (42:402 Social Security Benefits)","42:0405id":"42:0405id (42:405 Review of HHS Decision (SSID))","42:0405wc":"42:0405wc (42:405 Review of HHS Decision (DIWC))","42:0405ww":"42:0405ww (42:405 Review of HHS Decision (DIWW))","42:0416":"42:0416 (42:416 Denial of Social Security Benefits)","42:0427":"42:0427 (42:427 Social Security Benefits)","42:11601":"42:11601 (42:11601 - Hague Convention - Child Custody)","42:12101":"42:12101 (42:12101 - Americans with Disabilities Act)","42:1383":"42:1383 (42:1383 Review of HHS Decision)","42:1395":"42:1395 (42:1395 HHS: Adverse Reimbursement Review)","42:1395em":"42:1395em (42:1395 Emergency Medical Treatment and Active Labor Act)","42:1396":"42:1396 (42:1396 - Tort Negligence)","42:1471":"42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)","42:1981cv":"42:1981cv (42:1981 Civil Rights)","42:1981hs":"42:1981hs (42:1981 Housing Discrimination)","42:1981jb":"42:1981jb (42:1981 Job Discrimination (Race))","42:1981sx":"42:1981sx (42:1981 Sex Discrimination)","42:1983cv":"42:1983cv (42:1983 Civil Rights Act)","42:1983ed":"42:1983ed (42:1983 Civil Rights (Employment Discrimination))","42:1983pr":"42:1983pr (42:1983 Prisoner Civil Rights)","42:1986":"42:1986 (42:1986 Neglect of Duty)","42:1997":"42:1997 (42:1997 Civil Rights of Institutionalized Persons Act 1980)","42:2000ag":"42:2000ag (42:2000 Job Discrimination (Age))","42:2000e":"42:2000e (42:2000e Job Discrimination (Employment))","42:2000pb":"42:2000pb (42:2000 Job Discrimination (Public Accomodations))","42:2000ra":"42:2000ra (42:2000 Job Discrimination (Race))","42:2000sx":"42:2000sx (42:2000 Job Discrimination (Sex))","42:2003":"42:2003 (42:2003 Job Discrimination)","42:2005":"42:2005 (42:2005 Review of Agency Action-HHS)","42:2651":"42:2651 (42:2651 Medical Care Recovery)","42:300":"42:300 (42:300 Safe Drinking Water Act)","42:3601":"42:3601 (42:405 Fair Housing Act)","42:4000":"42:4000 (42:4000 National Flood Insurance Act)","42:4001":"42:4001 (42:4001 National Insurance Flood Act)","42:4053":"42:4053 (42:4053 Breach of Insurance Contract)","42:4072":"42:4072 (42:4072 Payment of Flood Insurance Claim)","42:4321":"42:4321 (42:4321 Review of Agency Action-Environment)","42:4332":"42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)","42:6901en":"42:6901en (42:6901 Environmental Cleanup Expenses)","42:6901rs":"42:6901rs (42:6901 Resource Conservation & Recovery Act)","42:6973":"42:6973 (42:6973 Resource Conservation and Recovery Act)","42:7413":"42:7413 (42:7413(b) Clean Air Act)","42:7604cl":"42:7604cl (42:7604 Clear Air Act (Emission Standards))","42:7604ir":"42:7604ir (42:7604 Petition to Quash IRS Summons)","42:9604":"42:9604 (42:9604 CERCLA Section 104)","42:9607":"42:9607 (42:9607 Real Property Tort to Land)","42:9613":"42:9613 (42:9613 CERCLA Section 113)","43:299":"43:299 (43:299 Reservation of Coal & Mineral Rights)","43:945":"43:945 (43:945 Compensation for Land Condemnation)","43:945a":"43:945a (43:945a Complaint in Condemnation)","43:946":"43:946 (43:946 Complaint in Condemnation - Eminent Domain)","45:0051":"45:0051 (45:51 Railways: Fed. Employer's Liability Act)","45:0151":"45:0151 (45:151 Railway Labor Act)","45:0184":"45:0184 (45:184 Action to Set Aside Award of a System Board)","45:1395":"45:1395 (45:1395 Railroads: Adverse Reimbursement Review)","45:7457":"45:7457 (45:7457 Compel Reclamation Under Clear Air Act)","46:0688":"46:0688 (46:688 Jones Act)","46:0741":"46:0741 (46:741 Shipping)","46:0761":"46:0761 (46:761 Shipping: Damages for Death on High Seas)","46:1101":"46:1101 (46:1101 Violation of Maritime Regulations)","46:1156":"46:1156 (46:1156 Administrative Procedure Act)","47:0605":"47:0605 (47:0605 Piracy of Satellite Transmission)","48:0883":"48:0883 (48:883 Violation of US Coastal Law)","48:1985":"48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)","49:0081":"49:0081 (49:81 Damaged Goods While Being Transported)","49:0781":"49:0781 (49:781 Forfeiture)","49:10101":"49:10101 (49:10101 Revised Interstate Commerce Act)","49:11503":"49:11503 (49:11503 Railroad Revitalization Regulatory Reform)","49:11702":"49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)","49:1471":"49:1471 (49:1471 Federal Aviation Act)","49:1903":"49:1903 (49:1903 Petition to enforce administrative summon)","8:287":"8:287 (8:287 Petition to Enforce INS Subpoena)","misc":"misc (Civil Miscellaneous Case)"}};var getCauses=function getCauses(court){if(!court||!causes[court]){return null;}return Object.keys(causes[court]).map(function(key){return{value:key,label:causes[court][key]};});};exports.default=getCauses;

/***/ },
/* 1210 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = [{
	  label: 'None or None of the above', value: 'None or None of the above'
	}, {
	  label: 'Health Care Business (as defined in 11 U.S.C. § 101(27A))', value: 'Health Care Business (as defined in 11 U.S.C. § 101(27A))'
	}, {
	  label: 'Single Asset Real Estate (as defined in 11 U.S.C. § 101(51B))', value: 'Single Asset Real Estate (as defined in 11 U.S.C. § 101(51B))'
	}, {
	  label: 'Railroad (as defined in 11 U.S.C. § 101(44))', value: 'Railroad (as defined in 11 U.S.C. § 101(44))'
	}, {
	  label: 'Stockbroker (as defined in 11 U.S.C. § 101(53A))', value: 'Stockbroker (as defined in 11 U.S.C. § 101(53A))'
	}, {
	  label: 'Commodity Broker (as defined in 11 U.S.C. § 101(6))', value: 'Commodity Broker (as defined in 11 U.S.C. § 101(6))'
	}, {
	  label: 'Clearing Bank (as defined in 11 U.S.C § 781(3))', value: 'Clearing Bank (as defined in 11 U.S.C § 781(3))'
	}];

/***/ },
/* 1211 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = [{
	  label: 'Unknown', value: 'Unknown'
	}, {
	  label: '1-49', value: '1-49'
	}, {
	  label: '50-99', value: '50-99'
	}, {
	  label: '100-199', value: '100-199'
	}, {
	  label: '200-999', value: '200-999'
	}, {
	  label: '1,000-5,000', value: '1,000-5,000'
	}, {
	  label: '5,001-10,000', value: '5,001-10,000'
	}, {
	  label: '10,001-25,000', value: '10,001-25,000'
	}, {
	  label: '25,001-50,000', value: '25,001-50,000'
	}, {
	  label: '50,001-100,000', value: '50,001-100,000'
	}, {
	  label: 'More than 100,000', value: 'More than 100,000'
	}];

/***/ },
/* 1212 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = [{ value: 'AL', label: 'Alabama' }, { value: 'AK', label: 'Alaska' }, { value: 'AZ', label: 'Arizona' }, { value: 'AR', label: 'Arkansas' }, { value: 'CA', label: 'California' }, { value: 'CO', label: 'Colorado' }, { value: 'CT', label: 'Connecticut' }, { value: 'DE', label: 'Delaware' }, { value: 'DC', label: 'District of Columbia' }, { value: 'FL', label: 'Florida' }, { value: 'GA', label: 'Georgia' }, { value: 'GU', label: 'Guam' }, { value: 'HI', label: 'Hawaii' }, { value: 'ID', label: 'Idaho' }, { value: 'IL', label: 'Illinois' }, { value: 'IN', label: 'Indiana' }, { value: 'IA', label: 'Iowa' }, { value: 'KS', label: 'Kansas' }, { value: 'KY', label: 'Kentucky' }, { value: 'LA', label: 'Louisiana' }, { value: 'ME', label: 'Maine' }, { value: 'MD', label: 'Maryland' }, { value: 'MA', label: 'Massachusetts' }, { value: 'MI', label: 'Michigan' }, { value: 'MN', label: 'Minnesota' }, { value: 'MS', label: 'Mississippi' }, { value: 'MO', label: 'Missouri' }, { value: 'MT', label: 'Montana' }, { value: 'NE', label: 'Nebraska' }, { value: 'NV', label: 'Nevada' }, { value: 'NH', label: 'New Hampshire' }, { value: 'NJ', label: 'New Jersey' }, { value: 'NM', label: 'New Mexico' }, { value: 'NY', label: 'New York' }, { value: 'NC', label: 'North Carolina' }, { value: 'ND', label: 'North Dakota' }, { value: 'NMI', label: 'Northern Mariana Islands' }, { value: 'OH', label: 'Ohio' }, { value: 'OK', label: 'Oklahoma' }, { value: 'OR', label: 'Oregon' }, { value: 'PA', label: 'Pennsylvania' }, { value: 'PR', label: 'Puerto Rico' }, { value: 'RI', label: 'Rhode Island' }, { value: 'SC', label: 'South Carolina' }, { value: 'SD', label: 'South Dakota' }, { value: 'TN', label: 'Tennessee' }, { value: 'TX', label: 'Texas' }, { value: 'UT', label: 'Utah' }, { value: 'VT', label: 'Vermont' }, { value: 'VI', label: 'Virgin Islands' }, { value: 'VA', label: 'Virginia' }, { value: 'WA', label: 'Washington' }, { value: 'WV', label: 'West Virginia' }, { value: 'WI', label: 'Wisconsin' }, { value: 'WY', label: 'Wyoming' }];

/***/ },
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(18);
	
	var _CreateAlertModal = __webpack_require__(420);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _react3.storiesOf)('Manage Alerts', module).add('CreateAlertModal', function () {
	  return _react2.default.createElement(_CreateAlertModal.CreateAlertModal, { show: true, advancedSearch: dataForCreateAlert, onClose: function onClose() {
	      return null;
	    }, onSave: function onSave() {
	      return null;
	    } });
	}).add('CreateOrEditAlertModal', function () {
	  return _react2.default.createElement(_CreateAlertModal.CreateAlertModal, { show: true, advancedSearch: dataForCreateOrEditAlert, onClose: function onClose() {
	      return null;
	    }, onSave: function onSave() {
	      return null;
	    } });
	});
	
	var dataForCreateAlert = {
	  alert: {
	    data: {
	      delivery: null,
	      meta: {},
	      name: null,
	      notify_interval: null,
	      notify_interval_label: null
	    }
	  },
	  filter: {
	    template: 'case_lookup'
	  }
	};
	
	var dataForCreateOrEditAlert = {
	  alert: {
	    data: {
	      delivery_options: ['', 'rss', 'webhook'],
	      edit_access: true,
	      edit_token: 'b880680666d9c629290cd2bbe89f27a5',
	      id: '6862',
	      mail_list: ['admin@inforuptcy.com'],
	      name: 'edited_alert',
	      notify_interval: 86400,
	      notify_interval_label: 'Daily',
	      resend: false,
	      resend_token: 'ea3bfcaa282274cd9fb48dfaaccf59c0',
	      type: 'case_lookup',
	      type_label: 'Cases'
	    }
	  },
	  filter: {
	    template: 'case_lookup'
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _WarninigBox = __webpack_require__(613);
	
	var _WarninigBox2 = _interopRequireDefault(_WarninigBox);
	
	__webpack_require__(2200);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hints = function Hints() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'ir-reports-tab-hints' },
	    _react2.default.createElement(
	      'h4',
	      null,
	      'How to run custom reports'
	    ),
	    _react2.default.createElement(
	      'ol',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'Enter required case information.'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Enter optional filters if desired.'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Click Run Report to get results.'
	      )
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Afterwards you can'
	    ),
	    _react2.default.createElement(
	      'ol',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'Download a CSV of the results, and'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Setup delivery schedule to run this report and get an email going forward'
	      )
	    ),
	    _react2.default.createElement(
	      _WarninigBox2.default,
	      null,
	      'Warning: you will be billed for the total number of pages (this report is not subject to the 30-page limit).'
	    )
	  );
	};
	
	exports.default = Hints;

/***/ },
/* 1215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(13);
	
	var _moment = __webpack_require__(32);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reportsTabAction = __webpack_require__(1225);
	
	var actions = _interopRequireWildcard(_reportsTabAction);
	
	var _FormOptions = __webpack_require__(1101);
	
	var _FormOptions2 = _interopRequireDefault(_FormOptions);
	
	var _FormOption = __webpack_require__(1099);
	
	var _FormOption2 = _interopRequireDefault(_FormOption);
	
	var _WarninigBox = __webpack_require__(613);
	
	var _WarninigBox2 = _interopRequireDefault(_WarninigBox);
	
	var _ResultsTable = __webpack_require__(1104);
	
	var _ResultsTable2 = _interopRequireDefault(_ResultsTable);
	
	var _LoadingBar = __webpack_require__(91);
	
	var _LoadingBar2 = _interopRequireDefault(_LoadingBar);
	
	var _InfoMessage = __webpack_require__(609);
	
	var _InfoMessage2 = _interopRequireDefault(_InfoMessage);
	
	var _AlertMessage = __webpack_require__(1090);
	
	var _AlertMessage2 = _interopRequireDefault(_AlertMessage);
	
	var _LoggedOutInfoMessage = __webpack_require__(1088);
	
	var _LoggedOutInfoMessage2 = _interopRequireDefault(_LoggedOutInfoMessage);
	
	var _SubmitButton = __webpack_require__(608);
	
	var _SubmitButton2 = _interopRequireDefault(_SubmitButton);
	
	var _Hints = __webpack_require__(1214);
	
	var _Hints2 = _interopRequireDefault(_Hints);
	
	var _Bankruptcy = __webpack_require__(1218);
	
	var _Bankruptcy2 = _interopRequireDefault(_Bankruptcy);
	
	var _Civil = __webpack_require__(1219);
	
	var _Civil2 = _interopRequireDefault(_Civil);
	
	var _Criminal = __webpack_require__(1220);
	
	var _Criminal2 = _interopRequireDefault(_Criminal);
	
	var _AutomateReportAndDelivery = __webpack_require__(1216);
	
	var _AutomateReportAndDelivery2 = _interopRequireDefault(_AutomateReportAndDelivery);
	
	var _casePropertiesParse = __webpack_require__(1254);
	
	var _casePropertiesParse2 = _interopRequireDefault(_casePropertiesParse);
	
	var _dateFormat = __webpack_require__(94);
	
	var _dateFormat2 = _interopRequireDefault(_dateFormat);
	
	var _Receipt = __webpack_require__(611);
	
	var _Receipt2 = _interopRequireDefault(_Receipt);
	
	var _iconReportsCsv = __webpack_require__(2229);
	
	var _iconReportsCsv2 = _interopRequireDefault(_iconReportsCsv);
	
	var _iconReportsAlerts = __webpack_require__(2228);
	
	var _iconReportsAlerts2 = _interopRequireDefault(_iconReportsAlerts);
	
	var _iconReportsSearch = __webpack_require__(2230);
	
	var _iconReportsSearch2 = _interopRequireDefault(_iconReportsSearch);
	
	var _globalUtils = __webpack_require__(59);
	
	__webpack_require__(2201);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var courtDriveSearchForms = {
	  bankruptcy: {
	    title: 'Bankruptcy',
	    component: _Bankruptcy2.default
	  },
	  civil: {
	    title: 'Civil',
	    component: _Civil2.default
	  },
	  criminal: {
	    title: 'Criminal',
	    component: _Criminal2.default
	  }
	};
	
	var inforuptcySearchForms = {
	  bankruptcy: {
	    title: 'Bankruptcy',
	    component: _Bankruptcy2.default
	  }
	};
	
	var searchForms = (0, _globalUtils.isCourtDrive)() ? courtDriveSearchForms : inforuptcySearchForms;
	
	var ReportsTab = function (_Component) {
	  _inherits(ReportsTab, _Component);
	
	  function ReportsTab(props) {
	    _classCallCheck(this, ReportsTab);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var formType = 'bankruptcy';
	
	    _this.initialState = _extends({
	      formType: formType,
	      isOpenAutomateCollapse: false
	    }, _this.initiateForm[formType]({}), _this.initiateForm.automateMailing(), {
	      searchType: _this.formTypeDataToSubmit[formType],
	      mainFormError: null,
	      isFormAreaPostFaded: false
	    });
	
	    _this.state = _this.initialState;
	    return _this;
	  }
	
	  ReportsTab.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    var reducerOld = this.props.reportsTabReducer;
	
	    var isReportsDataReadyOld = reducerOld.get('isReportsDataReady');
	
	    var reducer = props.reportsTabReducer;
	
	    var isReportsDataReady = reducer.get('isReportsDataReady');
	    var isReportsDataErrorOccurred = reducer.get('isReportsDataErrorOccurred');
	    var isAutoMateMailingReadyErrorOccurred = reducer.get('isAutoMateMailingReadyErrorOccurred');
	    var errorMessage = reducer.get('errorMessage');
	
	    if (isReportsDataReady && !isReportsDataReadyOld) {
	      this.setState({ isFormAreaPostFaded: true });
	    }
	
	    this.setState({
	      mainFormError: isReportsDataErrorOccurred ? '' + errorMessage : null,
	      automateMailingError: isAutoMateMailingReadyErrorOccurred ? errorMessage + '.' : null
	    });
	  };
	
	  ReportsTab.prototype.render = function render() {
	    if (window.Drupal.settings.currentUser === 0) return _react2.default.createElement(_LoggedOutInfoMessage2.default, null);
	
	    var _state = this.state,
	        formType = _state.formType,
	        mainFormError = _state.mainFormError,
	        automateMailingError = _state.automateMailingError,
	        isFormAreaPostFaded = _state.isFormAreaPostFaded;
	
	
	    var reducer = this.props.reportsTabReducer;
	
	    var isAutoMailingLoading = reducer.getIn(['automateMailing', 'isLoading'], false);
	    var isReportsDataReady = reducer.get('isReportsDataReady');
	    var isReportsDataErrorOccurred = reducer.get('isReportsDataErrorOccurred');
	    var isAutoMateMailingReady = reducer.get('isAutoMateMailingReady');
	    var reports = reducer.get('reports');
	    var receipts = reducer.getIn(['receipts', 0, 0, 'text']);
	    receipts = receipts ? receipts.toObject() : {};
	
	    var Form = searchForms[formType].component;
	
	    var FormOptionList = Object.keys(searchForms).map(function (eventKey) {
	      return _react2.default.createElement(
	        _FormOption2.default,
	        { key: eventKey, eventKey: eventKey },
	        searchForms[eventKey].title
	      );
	    });
	
	    var hasRecords = isReportsDataReady && reports.size > 0;
	
	    var csvClassName = hasRecords ? '' : 'inactive';
	
	    var reportsTabFormsCls = !isReportsDataErrorOccurred && (isReportsDataReady === false || isFormAreaPostFaded) ? 'reports-tab-forms reports-tab-forms-faded' : 'reports-tab-forms';
	
	    var csvLink = this.props.reportsTabReducer.get('csvDownloadLink');
	    var csvUrl = this.props.reportsTabReducer.get('csvDownloadUrl');
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'reports-tab' },
	      _react2.default.createElement(
	        'div',
	        { className: 'filings-form' },
	        _react2.default.createElement(
	          _FormOptions2.default,
	          { onSelect: this.formTypeSelect, activeKey: formType },
	          FormOptionList
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'reports-search-form-container' },
	          _react2.default.createElement(
	            'div',
	            { onClick: this.onFormAreaClick, className: reportsTabFormsCls },
	            _react2.default.createElement(Form, _extends({
	              setFormValue: this.setFormValue,
	              select: this.select,
	              multiselect: this.multiselect
	
	            }, this.state)),
	            _react2.default.createElement(
	              _SubmitButton2.default,
	              { disabled: isReportsDataReady === false, onClick: this.submit },
	              'Run Report'
	            ),
	            isReportsDataReady === false && _react2.default.createElement(_LoadingBar2.default, null),
	            mainFormError && _react2.default.createElement(
	              _AlertMessage2.default,
	              null,
	              mainFormError
	            )
	          ),
	          _react2.default.createElement(_Hints2.default, null)
	        ),
	        isReportsDataReady && !isReportsDataErrorOccurred && _react2.default.createElement(
	          'div',
	          { className: 'reports-tab-footer' },
	          hasRecords ? _react2.default.createElement(
	            _WarninigBox2.default,
	            null,
	            'You have results below. Click a case number to select a case, or select an action from the choices below:'
	          ) : _react2.default.createElement(
	            _WarninigBox2.default,
	            null,
	            'No result were found from PACER. Please revise your criteria to broaden the search parameters.'
	          ),
	          isReportsDataReady && _react2.default.createElement(
	            'div',
	            { className: 'local-search-actions' },
	            _react2.default.createElement(
	              'form',
	              { action: csvLink, method: 'post' },
	              _react2.default.createElement('input', { type: 'hidden', name: 'url', value: csvUrl }),
	              _react2.default.createElement(
	                'button',
	                { className: csvClassName, type: 'submit', disabled: !hasRecords },
	                _react2.default.createElement('img', { src: _iconReportsCsv2.default, alt: '' }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Download CSV'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { onClick: this.trigAutomateCollapse },
	              _react2.default.createElement('img', { src: _iconReportsAlerts2.default, alt: '' }),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Automate Report and Delivery'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { onClick: this.refineSearch },
	              _react2.default.createElement('img', { src: _iconReportsSearch2.default, alt: '' }),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Refine Your Search'
	              )
	            )
	          ),
	          isReportsDataReady && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Collapse,
	              { 'in': this.state.isOpenAutomateCollapse },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_AutomateReportAndDelivery2.default, _extends({}, this.state, {
	                  setFormValue: this.setFormValue,
	                  automateMailing: this.automateMailing
	                })),
	                automateMailingError ? _react2.default.createElement(
	                  _AlertMessage2.default,
	                  null,
	                  automateMailingError
	                ) : isAutoMateMailingReady ? _react2.default.createElement(
	                  _InfoMessage2.default,
	                  null,
	                  'Your alert has been successfully configured. Click',
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/search-alerts#realtime-alerts-top', target: '_blank' },
	                    ' here '
	                  ),
	                  'to see all your alerts.'
	                ) : isAutoMailingLoading ? _react2.default.createElement(_LoadingBar2.default, null) : null
	              )
	            ),
	            _react2.default.createElement(
	              _ResultsTable2.default,
	              {
	                titles: ['Case Title', 'Court', 'Case No', 'Chapter', 'Date Filed', 'Date Closed', 'Disposition']
	              },
	              reports
	            ),
	            _react2.default.createElement(
	              _Receipt2.default,
	              null,
	              receipts
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return ReportsTab;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.onFormAreaClick = function () {
	    _this2.setState({ isFormAreaPostFaded: false });
	  };
	
	  this.setFormValue = function (name, value) {
	    var _this2$setState;
	
	    _this2.setState((_this2$setState = {}, _this2$setState[name] = value, _this2$setState));
	  };
	
	  this.errorClearMainForm = function () {
	    _this2.setState({ mainFormError: null });
	  };
	
	  this.errorClearAutomateMailing = function () {
	    _this2.setState({ automateMailingError: null });
	  };
	
	  this.errorReportAutomateMailing = function (fieldId) {
	    _this2.setState({ automateMailingError: _this2.errorReportMessageExtract(fieldId) });
	  };
	
	  this.errorReportMainForm = function (fieldId) {
	    _this2.setState({ mainFormError: _this2.errorReportMessageExtract(fieldId) });
	  };
	
	  this.errorReportMessageExtract = function (fieldId) {
	    return _this2.requiredFields[fieldId] + ' is required! Please fill the field.';
	  };
	
	  this.formTypeSelect = function (formType) {
	    _this2.setState({
	      formType: formType,
	      searchType: _this2.formTypeDataToSubmit[formType]
	    });
	
	    _this2.setState(_this2.initiateForm[formType](_this2.state));
	  };
	
	  this.select = function (name, value) {
	    _this2.setFormValue(name, value);
	
	    if (name === 'dateFrom') {
	      _this2.setFormValue('dateTo', value);
	    }
	  };
	
	  this.multiselect = function (name, value) {
	    var nextValue = !_lodash2.default.isEmpty(value) ? value.split(',') : value;
	
	    _this2.setFormValue(name, nextValue);
	  };
	
	  this.formDataParse = function () {
	    var _state2 = _this2.state,
	        searchType = _state2.searchType,
	        caseProperties = _state2.caseProperties;
	
	
	    var allowedParams = _this2.filterAllowedParams(_this2.state);
	
	    return Object.assign({}, allowedParams, {
	      search_type: {
	        court_type: searchType
	      }
	    }, (0, _casePropertiesParse2.default)(caseProperties));
	  };
	
	  this.trigAutomateCollapse = function () {
	    _this2.setState({
	      isOpenAutomateCollapse: !_this2.state.isOpenAutomateCollapse
	    });
	  };
	
	  this.formTypeDataToSubmit = {
	    bankruptcy: 'localcourtreport',
	    civil: 'localcourtreport_cv',
	    criminal: 'localcourtreport_cr'
	  };
	  this.requiredFields = {
	    region: 'Region',
	    startTime: 'Start time',
	    endTime: 'Start time',
	    frequency: 'Frequency'
	  };
	
	  this.filterAllowedParams = function (params) {
	    var formType = _this2.state.formType;
	
	
	    var paramNameMapper = {
	      region: 'region',
	      chapter: 'chapter',
	      caseType: 'case_type',
	      caseFlag: 'case_flags',
	      dateType: 'date_type',
	      dateFrom: 'date_from',
	      dateTo: 'date_to',
	      includeCVBCases: 'cvbcases',
	      citation: 'citation',
	      natureOfSuit: 'nature_of_suit',
	      jurisdiction: 'jurisdic',
	      typeOfDebtor: 'type_of_debtor',
	      natureOfDebt: 'nature_of_debt',
	      natureOfBusiness: 'nature_of_business',
	      assets: 'asset_notice',
	      partyInfo: 'party_info'
	    };
	
	    var allowedFields = Object.keys(_this2.initiateForm[formType]({}));
	
	    var filtered = _lodash2.default.pick(params, allowedFields);
	    var filteredParams = _lodash2.default.reduce(filtered, function (result, value, key) {
	      var paramKey = paramNameMapper[key];
	      var next = {};
	
	      if (paramKey !== undefined) {
	        var _next;
	
	        var v = key === 'dateFrom' || key === 'dateTo' ? (0, _dateFormat2.default)(value) : value;
	
	        next = (_next = {}, _next[paramKey] = v, _next);
	      }
	
	      return Object.assign({}, result, next);
	    }, {});
	
	    return filteredParams;
	  };
	
	  this.initiateForm = {
	    bankruptcy: function bankruptcy(o) {
	      var now = new Date();
	
	      return {
	        region: o.region || '',
	        chapter: o.chapter || ['11'],
	        caseType: o.caseType || 'bk',
	        dateType: o.dateType || 'filed',
	        dateFrom: o.dateFrom || now,
	        dateTo: o.dateTo || now,
	        typeOfDebtor: o.typeOfDebtor || '',
	        natureOfDebt: o.natureOfDebt || '',
	        natureOfBusiness: o.natureOfBusiness || '',
	        assets: o.assets || '',
	        caseProperties: o.caseProperties || 'open_cases',
	        partyInfo: o.partyInfo || '',
	        citation: o.citation || '',
	        caseFlag: o.caseFlag || '',
	        includeCVBCases: o.includeCVBCases || '',
	        natureOfSuit: o.natureOfSuit || '',
	        jurisdiction: o.jurisdiction || ''
	      };
	    },
	    civil: function civil(o) {
	      var now = new Date();
	      return {
	        region: o.region || 'almbke',
	        caseType: '',
	        natureOfSuit: o.natureOfSuit || '',
	        dateFrom: o.dateFrom || now,
	        dateTo: o.dateTo || now,
	        cause: o.cause || '',
	        jurisdiction: o.jurisdiction || '',
	        caseFlag: o.caseFlag || '',
	        caseProperties: o.caseProperties || 'open_cases',
	        citation: o.citation || '',
	        includeCVBCases: o.includeCVBCases || ''
	      };
	    },
	    criminal: function criminal() {
	      var now = new Date();
	
	      return {
	        region: '',
	        caseType: '',
	        citation: '',
	        dateFrom: now,
	        dateTo: now,
	        caseFlag: '',
	        countStatus: '',
	        includeCVBCases: '',
	        caseProperties: 'pending_defendants',
	        typeOfDebtor: '',
	        natureOfDebt: '',
	        natureOfBusiness: '',
	        assets: '',
	        partyInfo: '',
	        natureOfSuit: '',
	        jurisdiction: ''
	      };
	    },
	    automateMailing: function automateMailing() {
	      return {
	        frequency: '10080',
	        startTime: null,
	        endTime: null
	      };
	    }
	  };
	
	  this.submit = function () {
	    if (!client_code_is_valid()) {
	      _this2.setState({ mainFormError: 'Please set a valid client code first.' });
	      return;
	    }
	
	    if (!_this2.state.region) {
	      return _this2.errorReportMainForm('region');
	    }
	
	    _this2.errorClearMainForm();
	
	    _this2.props.dispatch(actions.reports(_this2.formDataParse()));
	  };
	
	  this.automateMailing = function () {
	    var _state3 = _this2.state,
	        region = _state3.region,
	        frequency = _state3.frequency,
	        startTime = _state3.startTime,
	        endTime = _state3.endTime;
	
	
	    if (!region) return _this2.errorReportAutomateMailing('region');
	    if (!frequency) return _this2.errorReportAutomateMailing('frequency');
	    if (!startTime) return _this2.errorReportAutomateMailing('startTime');
	    if (!endTime) return _this2.errorReportAutomateMailing('endTime');
	
	    _this2.errorClearAutomateMailing();
	
	    var end = _moment2.default.isMoment(endTime) ? endTime.unix() * 1000 : endTime.getTime();
	
	    var start = _moment2.default.isMoment(startTime) ? startTime.unix() * 1000 : startTime.getTime();
	
	    var params = _lodash2.default.pickBy(_extends({}, _this2.formDataParse(), {
	
	      frequency: frequency,
	      end_time: end,
	      start_time: start
	    }), _lodash2.default.identity);
	
	    _this2.setState({
	      startTime: null,
	      endTime: null
	    });
	
	    _this2.props.dispatch(actions.automateMailing(params));
	  };
	
	  this.refineSearch = function () {
	    window.scrollTo(0, 0);
	    _this2.setState({ isFormAreaPostFaded: false });
	  };
	};
	
	ReportsTab.propTypes = {
	  reportsTabReducer: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    reportsTabReducer: state.get('reportsTabReducer')
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ReportsTab);

/***/ },
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(32);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _SubmitButton = __webpack_require__(608);
	
	var _SubmitButton2 = _interopRequireDefault(_SubmitButton);
	
	var _Selector = __webpack_require__(248);
	
	var _Selector2 = _interopRequireDefault(_Selector);
	
	var _DateRangeContainer = __webpack_require__(1093);
	
	var _DateRangeContainer2 = _interopRequireDefault(_DateRangeContainer);
	
	var _DateTimePicker = __webpack_require__(1096);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	var _AutomateReportAndDeliveryOptions = __webpack_require__(1217);
	
	var options = _interopRequireWildcard(_AutomateReportAndDeliveryOptions);
	
	__webpack_require__(2202);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AutomateReportAndDelivery = function (_Component) {
	  _inherits(AutomateReportAndDelivery, _Component);
	
	  function AutomateReportAndDelivery() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AutomateReportAndDelivery);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.dateFormat = function (date) {
	      return date.format('MM/DD/YYYY');
	    }, _this.select = function (name, value) {
	      var endTime = _this.props.endTime;
	
	
	      var time = name === 'startTime' || name === 'endTime' ? (0, _moment2.default)(value).startOf('hours').toDate() : value;
	
	      _this.props.setFormValue(name, time);
	
	      if (name === 'startTime' && !endTime) {
	        _this.props.setFormValue('endTime', (0, _moment2.default)(time).add(1, 'hours'));
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  AutomateReportAndDelivery.prototype.render = function render() {
	    var _props = this.props,
	        frequency = _props.frequency,
	        startTime = _props.startTime,
	        endTime = _props.endTime;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'reports-tab-forms-automate' },
	      _react2.default.createElement(_Selector2.default, {
	        clearable: false,
	        className: 'reports-tab-automate-frequency-selector',
	        options: options.frequency,
	        title: 'Email me a report',
	        value: frequency,
	        placeholder: '',
	        onChange: this.select.bind(this, 'frequency')
	      }),
	      _react2.default.createElement(
	        _DateRangeContainer2.default,
	        { className: 'reports-tab-automate-date-filter-selector' },
	        _react2.default.createElement(_DateTimePicker2.default, {
	          value: startTime,
	          title: 'Start Searching On',
	          step: 60,
	          time: true,
	          min: (0, _moment2.default)().startOf('hours').subtract(1, 'hours').toDate(),
	          onChange: this.select.bind(this, 'startTime') }),
	        _react2.default.createElement(_DateTimePicker2.default, {
	          value: endTime,
	          title: 'Stop Searching on',
	          step: 60,
	          time: true,
	          min: (0, _moment2.default)(startTime).startOf('hours').toDate(),
	          onChange: this.select.bind(this, 'endTime') })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'reports-tab-forms-automate-submit' },
	        _react2.default.createElement('div', { className: 'submit-btn-spacer' }),
	        _react2.default.createElement(
	          _SubmitButton2.default,
	          {
	            type: 'info',
	            size: 'normal',
	            onClick: this.props.automateMailing,
	            className: 'reports-tab-forms-automate-submit-button'
	          },
	          'Set Automated Report'
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'set-automate-report-existing-reports',
	            href: '/search-alerts#realtime-alerts-top',
	            target: '_blank'
	          },
	          'Existing Reports'
	        )
	      )
	    );
	  };
	
	  return AutomateReportAndDelivery;
	}(_react.Component);
	
	AutomateReportAndDelivery.propTypes = {
	  automateMailing: _propTypes2.default.func.isRequired,
	  setFormValue: _propTypes2.default.func.isRequired,
	  frequency: _propTypes2.default.any.isRequired,
	  startTime: _propTypes2.default.any,
	  endTime: _propTypes2.default.any
	};
	
	exports.default = AutomateReportAndDelivery;

/***/ },
/* 1217 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var frequency = exports.frequency = {
	  1440: 'every day',
	  2880: 'every 2 days',
	  4320: 'every 3 days',
	  5760: 'every 4 days',
	  7200: 'every 5 days',
	  8640: 'every 6 days',
	  10080: 'every 7 days'
	};

/***/ },
/* 1218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _moment = __webpack_require__(32);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _FieldSet = __webpack_require__(63);
	
	var _FieldSet2 = _interopRequireDefault(_FieldSet);
	
	var _Selector = __webpack_require__(248);
	
	var _Selector2 = _interopRequireDefault(_Selector);
	
	var _DateFilter = __webpack_require__(348);
	
	var _DateFilter2 = _interopRequireDefault(_DateFilter);
	
	var _courtsMapper = __webpack_require__(422);
	
	var _courtsMapper2 = _interopRequireDefault(_courtsMapper);
	
	__webpack_require__(2203);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Bankruptcy = function (_Component) {
	  _inherits(Bankruptcy, _Component);
	
	  function Bankruptcy() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Bankruptcy);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.regionOptions = (0, _courtsMapper2.default)('bankruptcy', 'Bankruptcy Court'), _this.dateFormat = function (date) {
	      return date.format('MM/DD/YYYY');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Bankruptcy.prototype.render = function render() {
	    var _props = this.props,
	        region = _props.region,
	        chapter = _props.chapter,
	        caseType = _props.caseType,
	        dateType = _props.dateType,
	        dateFrom = _props.dateFrom,
	        dateTo = _props.dateTo,
	        typeOfDebtor = _props.typeOfDebtor,
	        natureOfDebt = _props.natureOfDebt,
	        natureOfBusiness = _props.natureOfBusiness,
	        assets = _props.assets,
	        caseProperties = _props.caseProperties,
	        partyInfo = _props.partyInfo,
	        select = _props.select,
	        multiselect = _props.multiselect;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'reports-tab-form reports-tab-forms-bankruptcy' },
	      _react2.default.createElement(
	        _FieldSet2.default,
	        { title: 'Case Information' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row no-padding' },
	          _react2.default.createElement(_Selector2.default, {
	            id: 'reports-region',
	            multi: true,
	            clearable: false,
	            className: 'reports-tab-bankruptcy-region-selector',
	            options: this.regionOptions,
	            title: 'Region',
	            value: region,
	            placeholder: 'Select Region',
	            onChange: multiselect.bind(this, 'region') }),
	          _react2.default.createElement(_Selector2.default, {
	            multi: true,
	            clearable: false,
	            className: 'reports-tab-bankruptcy-chapter-selector',
	            options: chapterOptions,
	            title: 'Chapter',
	            value: chapter,
	            placeholder: 'Any',
	            onChange: multiselect.bind(this, 'chapter') }),
	          _react2.default.createElement(_Selector2.default, {
	            multi: true,
	            clearable: false,
	            className: 'reports-tab-bankruptcy-case-type-selector',
	            options: caseTypeOptions,
	            title: 'Case Type',
	            value: caseType,
	            placeholder: 'Any',
	            onChange: multiselect.bind(this, 'caseType')
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row date-selectors' },
	          _react2.default.createElement(_Selector2.default, {
	            clearable: false,
	            className: 'reports-tab-bankruptcy-date-type-selector',
	            options: dateTypeOptions,
	            title: 'Date Type',
	            value: dateType,
	            placeholder: '',
	            onChange: select.bind(this, 'dateType') }),
	          _react2.default.createElement(_DateFilter2.default, {
	            from: dateFrom,
	            to: dateTo,
	            onChangeFrom: select.bind(this, 'dateFrom'),
	            onChangeTo: select.bind(this, 'dateTo'),
	            className: 'reports-tab-bankruptcy-date-filter-selector' })
	        )
	      ),
	      _react2.default.createElement(
	        _FieldSet2.default,
	        { title: 'Advanced Filters' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row no-padding' },
	          _react2.default.createElement(_Selector2.default, {
	            clearable: false,
	            className: 'reports-tab-bankruptcy-type-of-debtor-selector',
	            options: typeOfDebtorOptions,
	            title: 'Type of Debtor',
	            value: typeOfDebtor,
	            placeholder: '',
	            onChange: select.bind(this, 'typeOfDebtor') }),
	          _react2.default.createElement(_Selector2.default, {
	            clearable: false,
	            className: 'reports-tab-bankruptcy-nature-of-debt-selector',
	            options: natureOfDebtOptions,
	            title: 'Nature of Debt',
	            value: natureOfDebt,
	            placeholder: '',
	            onChange: select.bind(this, 'natureOfDebt') })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(_Selector2.default, {
	            clearable: false,
	            className: 'reports-tab-bankruptcy-nature-of-business-selector',
	            options: natureOfBusinessOptions,
	            title: 'Nature of Business',
	            value: natureOfBusiness,
	            placeholder: '',
	            onChange: select.bind(this, 'natureOfBusiness') }),
	          _react2.default.createElement(_Selector2.default, {
	            clearable: false,
	            className: 'reports-tab-bankruptcy-assets-selector',
	            options: assetsOptions,
	            title: 'Assets',
	            value: assets,
	            placeholder: '',
	            onChange: select.bind(this, 'assets') })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(_Selector2.default, {
	            multi: true,
	            clearable: false,
	            className: 'reports-tab-bankruptcy-case-properties-selector',
	            options: casePropertiesOptions,
	            title: 'Case Properties',
	            value: caseProperties,
	            placeholder: '',
	            onChange: multiselect.bind(this, 'caseProperties') }),
	          _react2.default.createElement(_Selector2.default, {
	            clearable: false,
	            className: 'reports-tab-bankruptcy-party-info-selector',
	            options: partyInfoOptions,
	            title: 'Party Info',
	            value: partyInfo,
	            placeholder: '',
	            onChange: select.bind(this, 'partyInfo') })
	        )
	      )
	    );
	  };
	
	  return Bankruptcy;
	}(_react.Component);
	
	Bankruptcy.propTypes = {
	  region: _propTypes2.default.any.isRequired,
	  chapter: _propTypes2.default.any.isRequired,
	  caseType: _propTypes2.default.any.isRequired,
	  dateType: _propTypes2.default.any.isRequired,
	  dateFrom: _propTypes2.default.any.isRequired,
	  dateTo: _propTypes2.default.any.isRequired,
	  typeOfDebtor: _propTypes2.default.any.isRequired,
	  natureOfDebt: _propTypes2.default.any.isRequired,
	  natureOfBusiness: _propTypes2.default.any.isRequired,
	  assets: _propTypes2.default.any.isRequired,
	  caseProperties: _propTypes2.default.any.isRequired,
	  partyInfo: _propTypes2.default.any.isRequired,
	  setFormValue: _propTypes2.default.func.isRequired,
	  select: _propTypes2.default.func.isRequired,
	  multiselect: _propTypes2.default.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {};
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Bankruptcy);
	
	
	var chapterOptions = {
	  7: '7',
	  9: '9',
	  11: '11',
	  12: '12',
	  13: '13',
	  15: '15'
	};
	
	var caseTypeOptions = {
	  ap: 'ap',
	  bk: 'bk',
	  mp: 'mp'
	};
	
	var dateTypeOptions = {
	  filed: 'Filed date',
	  entered: 'Entered date',
	  discharged: 'Discharged date',
	  dismissed: 'Dismissed date',
	  closed: 'Closed date',
	  converted: 'Converted date'
	};
	
	var typeOfDebtorOptions = {
	  i: 'individual',
	  p: 'partnership',
	  u: 'corporation',
	  n: 'other'
	};
	
	var natureOfDebtOptions = {
	  b: 'business',
	  c: 'consumer / non-business'
	};
	
	var natureOfBusinessOptions = {
	  b: 'clearing bank',
	  c: 'commodity broker',
	  h: 'health care business',
	  o: 'tax-exempt entity',
	  r: 'single-asset real estate',
	  s: 'stockbroker',
	  x: 'railroad',
	  O: 'other nature of business'
	};
	
	var assetsOptions = {
	  n: 'No',
	  u: 'Unknown',
	  y: 'Yes'
	};
	
	var casePropertiesOptions = {
	  open_cases: 'Open Cases',
	  closed_cases: 'Closed cases',
	  voluntary: 'Voluntary',
	  involuntary: 'Involuntary',
	  smallbusiness: 'Small Business Cases Only',
	  proseonly: 'Pro se Cases Only'
	};
	
	var partyInfoOptions = {
	  '': 'No',
	  yes: 'Yes'
	};

/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(13);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FieldSet = __webpack_require__(63);
	
	var _FieldSet2 = _interopRequireDefault(_FieldSet);
	
	var _Selector = __webpack_require__(248);
	
	var _Selector2 = _interopRequireDefault(_Selector);
	
	var _DateFilter = __webpack_require__(348);
	
	var _DateFilter2 = _interopRequireDefault(_DateFilter);
	
	var _courtsMapper = __webpack_require__(422);
	
	var _courtsMapper2 = _interopRequireDefault(_courtsMapper);
	
	__webpack_require__(2204);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Civil = function (_Component) {
	  _inherits(Civil, _Component);
	
	  function Civil() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Civil);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.regionOptions = (0, _courtsMapper2.default)('district', 'District Court'), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Civil.prototype.render = function render() {
	    var _props = this.props,
	        region = _props.region,
	        caseType = _props.caseType,
	        natureOfSuit = _props.natureOfSuit,
	        dateFrom = _props.dateFrom,
	        dateTo = _props.dateTo,
	        cause = _props.cause,
	        jurisdiction = _props.jurisdiction,
	        caseFlag = _props.caseFlag,
	        caseProperties = _props.caseProperties,
	        select = _props.select,
	        multiselect = _props.multiselect;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'reports-tab-form reports-tab-forms-civil' },
	      _react2.default.createElement(
	        _FieldSet2.default,
	        { title: 'Case Information' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row no-padding' },
	          _react2.default.createElement(_Selector2.default, {
	            multi: true,
	            clearable: false,
	            className: 'reports-tab-civil-region-selector',
	            options: this.regionOptions,
	            title: 'Region',
	            value: region,
	            placeholder: 'Select Region',
	            onChange: multiselect.bind(this, 'region') }),
	          _react2.default.createElement(_Selector2.default, {
	            multi: true,
	            clearable: false,
	            className: 'reports-tab-civil-case-type-selector',
	            options: caseTypeOptions,
	            title: 'Case Type',
	            value: caseType,
	            placeholder: 'Any',
	            onChange: multiselect.bind(this, 'caseType') })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(_DateFilter2.default, {
	            from: dateFrom,
	            to: dateTo,
	            onChangeFrom: select.bind(this, 'dateFrom'),
	            onChangeTo: select.bind(this, 'dateTo'),
	            className: 'reports-tab-civil-date-filter-selector' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(_Selector2.default, {
	            multi: true,
	            clearable: false,
	            className: 'reports-tab-civil-nature-of-suit-selector',
	            options: natureOfSuitOptions,
	            title: 'Nature of Suit',
	            value: natureOfSuit,
	            placeholder: '',
	            onChange: multiselect.bind(this, 'natureOfSuit') })
	        )
	      ),
	      _react2.default.createElement(
	        _FieldSet2.default,
	        { title: 'Advanced Filters' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row no-padding' },
	          _react2.default.createElement(_Selector2.default, {
	            multi: true,
	            clearable: false,
	            className: 'reports-tab-civil-cause-selector',
	            options: causeOptions,
	            title: 'Cause',
	            value: cause,
	            placeholder: '',
	            onChange: multiselect.bind(this, 'cause') }),
	          _react2.default.createElement(_Selector2.default, {
	            multi: true,
	            clearable: false,
	            className: 'reports-tab-civil-jurisdiction-selector',
	            options: jurisdictionOptions,
	            title: 'Jurisdiction',
	            value: jurisdiction,
	            placeholder: '',
	            onChange: multiselect.bind(this, 'jurisdiction') })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(_Selector2.default, {
	            multi: true,
	            clearable: false,
	            className: 'reports-tab-civil-case-flag-selector',
	            options: caseFlagOptions,
	            title: 'Case Flag',
	            value: caseFlag,
	            placeholder: '',
	            onChange: multiselect.bind(this, 'caseFlag') }),
	          _react2.default.createElement(_Selector2.default, {
	            multi: true,
	            clearable: false,
	            className: 'reports-tab-civil-case-properties-selector',
	            options: casePropertiesOptions,
	            title: 'Case Properties',
	            value: caseProperties,
	            placeholder: '',
	            onChange: multiselect.bind(this, 'caseProperties') })
	        )
	      )
	    );
	  };
	
	  return Civil;
	}(_react.Component);
	
	Civil.propTypes = {
	  region: _propTypes2.default.any.isRequired,
	  caseType: _propTypes2.default.any.isRequired,
	  natureOfSuit: _propTypes2.default.any.isRequired,
	  dateFrom: _propTypes2.default.any.isRequired,
	  dateTo: _propTypes2.default.any.isRequired,
	  cause: _propTypes2.default.any.isRequired,
	  jurisdiction: _propTypes2.default.any.isRequired,
	  caseFlag: _propTypes2.default.any.isRequired,
	  caseProperties: _propTypes2.default.any.isRequired,
	  setFormValue: _propTypes2.default.func.isRequired,
	  select: _propTypes2.default.func.isRequired,
	  multiselect: _propTypes2.default.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {};
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Civil);
	
	
	var caseTypeOptions = {
	  cv: 'Civil',
	  mc: 'Miscellaneous',
	  md: 'Multidistrict Litigation'
	};
	
	var natureOfSuitOptions = {
	  0: '0 (zero)',
	  110: '110 (Insurance)',
	  120: '120 (Contract: Marine)',
	  130: '130 (Miller Act)',
	  140: '140 (Negotiable Instrument)',
	  150: '150 (Contract: Recovery/E...)',
	  151: '151 (Contract: Recovery M...)',
	  152: '152 (Contract: Recovery S...)',
	  153: '153 (Contract: Recovery V...)',
	  160: '160 (Stockholders Suits)',
	  190: '190 (Contract: Other)',
	  195: '195 (Contract Product Lia...)',
	  196: '196 (Contract: Franchise)',
	  210: '210 (Condemnation)',
	  220: '220 (Real Property: Forec...)',
	  230: '230 (Rent Lease & Ejectment)',
	  240: '240 (Torts to Land)',
	  245: '245 (Tort Product Liability)',
	  290: '290 (Real Property: Other)',
	  310: '310 (Airplane)',
	  315: '315 (Airplane Product Lia...)',
	  320: '320 (Assault Libel & Slander)',
	  330: '330 (Federal Employer\'s L...)',
	  340: '340 (Marine)',
	  345: '345 (Marine Product Liabi...)',
	  350: '350 (Motor Vehicle)',
	  355: '355 (Motor Vehicle Prod. ...)',
	  360: '360 (P.I.: Other)',
	  362: '362 (Personal Inj. Med. M...)',
	  365: '365 (Personal Inj. Prod. ...)',
	  368: '368 (P.I. : Asbestos)',
	  370: '370 (Fraud or Truth-In-Le...)',
	  371: '371 (Truth in Lending)',
	  380: '380 (Personal Property: O...)',
	  385: '385 (Prop. Damage Prod. L...)',
	  400: '400 (State Reapportionment)',
	  410: '410 (Anti-Trust)',
	  422: '422 (Bankruptcy Appeal (801))',
	  423: '423 (Bankruptcy Withdrawl)',
	  430: '430 (Banks and Banking)',
	  440: '440 (Civil Rights: Other)',
	  441: '441 (Civil Rights: Voting)',
	  442: '442 (Civil Rights: Jobs)',
	  443: '443 (Civil Rights: Accomm...)',
	  444: '444 (Civil Rights: Welfare)',
	  445: '445 (Civil Rights: Americ...)',
	  446: '446 (Civil Rights: Americ...)',
	  450: '450 (Commerce ICC Rates, ...)',
	  460: '460 (Deportation)',
	  462: '462 (Naturalization Appli...)',
	  463: '463 (Habeas Corpus - Alie...)',
	  465: '465 (Other Immigration Ac...)',
	  470: '470 (Racketeer/Corrupt Or...)',
	  480: '480 (Consumer Credit)',
	  490: '490 (Cable/Satellite TV)',
	  510: '510 (Prisoner: Vacate Sen...)',
	  530: '530 (Habeas Corpus (General))',
	  535: '535 (Death Penalty - Habe...)',
	  540: '540 (Mandamus & Other)',
	  550: '550 (Prisoner: Civil Rights)',
	  555: '555 (Habeas Corpus (Priso...)',
	  610: '610 (Forfeit/Penalty: Agr...)',
	  620: '620 (Forfeit/Penalty: Foo...)',
	  625: '625 (Drug Related Seizure...)',
	  630: '630 (Forfeit/Penalty: Liq...)',
	  640: '640 (Forfeit/Penalty: R.R...)',
	  650: '650 (Forfeit/Penalty: Air...)',
	  660: '660 (Forfeit/Penalty: Occ...)',
	  690: '690 (Forfeit/Penalty: Other)',
	  710: '710 (Labor: Fair Standards)',
	  720: '720 (Labor: Labor/Mgt. Re...)',
	  730: '730 (Labor: Reporting/Dis...)',
	  740: '740 (Labor: Railway Labor...)',
	  790: '790 (Labor: Other)',
	  791: '791 (Labor: E.R.I.S.A.)',
	  810: '810 (Selective Service)',
	  820: '820 (Copyright)',
	  830: '830 (Patent)',
	  840: '840 (Trademark)',
	  850: '850 (Securities/Commodities)',
	  861: '861 (Social Security: HIA)',
	  862: '862 (Social Security: Bla...)',
	  863: '863 (Social Security: DIW...)',
	  864: '864 (Social Security: SSI...)',
	  865: '865 (Social Security: RSI...)',
	  870: '870 (Taxes)',
	  871: '871 (Tax Suits: IRS-Third...)',
	  875: '875 (Taxes: Customer Chal...)',
	  890: '890 (Other Statutory Actions)',
	  891: '891 (Agriculture Acts)',
	  892: '892 (Economic Stabilizati...)',
	  893: '893 (Environmental Matters)',
	  894: '894 (Energy Allocation Act)',
	  895: '895 (Freedom of Informati...)',
	  900: '900 (Appeal of Fee Determ...)',
	  950: '950 (Constitutional - Sta...)'
	};
	
	var causeOptions = {
	  0: '0 (No cause code entered)',
	  '02:0431': '02:0431 (02:431 Fed. Election...)',
	  '02:0437': '02:0437 (02:437 Federal Elect...)',
	  '05:0075': '05:0075 (05:75(2) Contract - ...)',
	  '05:0551': '05:0551 (05:551 Administrativ...)',
	  '05:0552fi': '05:0552fi (05:552 Freedom of In...)',
	  '05:0552pa': '05:0552pa (05:552 Right to Priv...)',
	  '05:0554': '05:0554 (05:0554 Constitution...)',
	  '05:0701': '05:0701 (05:0701 Maritime Sub...)',
	  '05:0702': '05:0702 (05:702 Administrativ...)',
	  '05:0704': '05:0704 (05:704 Labor Litigation)',
	  '05:7703': '05:7703 (05:7703 Discriminati...)',
	  '05:8470': '05:8470 (05:8470 Enforcement ...)',
	  '07:0006': '07:0006 (7:6(b) Federal Commo...)',
	  '07:0025': '07:0025 (7:25 Fraud - Commodi...)',
	  '07:0181': '07:0181 (07:181 Packers & Sto...)',
	  '07:0499': '07:0499 (07:499 Agricultural ...)',
	  '07:0601': '07:0601 (07:601 USDA Condemna...)',
	  '07:2023': '07:2023 (07:2023 Violation of...)',
	  '07:2321': '07:2321 (07:2321 Plant Variet...)',
	  '08:1105': '08:1105 (8:1105(a) Aliens: Ha...)',
	  '08:1182': '08:1182 (8:1182 Defend. Denia...)',
	  '08:1252': '08:1252 (08:1252(a)(2) Injunc...)',
	  '08:1260': '08:1260 (08:1260 Aliens: Acce...)',
	  '08:1324': '08:1324 (08:1324 Aliens: Comp...)',
	  '08:1329': '08:1329 (08:1329 Writ of Mand...)',
	  '08:1446': '08:1446 (8:1446 Petition for ...)',
	  '08:1451(j)': '08:1451(j) (8:1451(j) Motion to ...)',
	  '09:0001': '09:0001 (09:1 U.S. Arbitratio...)',
	  '09:0009': '09:0009 (9:9 Motion to Confir...)',
	  '09:0010': '09:0010 (09:0010 Petition to ...)',
	  '10:1408': '10:1408 (10:1408 Claim for Mi...)',
	  '10:1552': '10:1552 (10:1552 Armed Forces...)',
	  '10:1553': '10:1553 (10:1553 Armed Forces...)',
	  '10:2305': '10:2305 (10:2305 Review of Fe...)',
	  '11:0101': '11:0101 (11:101 Bankruptcy)',
	  '12:0022': '12:0022 (12:22 Securities Fraud)',
	  '12:0635': '12:0635 (12:635 Breach of Ins...)',
	  '12:1461': '12:1461 (12:1461 Homeowners L...)',
	  '12:1464': '12:1464 (12:1464 Federal Savi...)',
	  '12:1703': '12:1703 (12:1703 Default of H...)',
	  '12:1725': '12:1725 (12:1725 Collection u...)',
	  '12:1730': '12:1730 (12:1730  Collection ...)',
	  '12:1819': '12:1819 (12:1819 Default of P...)',
	  '12:1821': '12:1821 (12:1821 Default of L...)',
	  '12:191': '12:191 (12:191 Bank Foreclosure)',
	  '12:192': '12:192 (12:192 Liquidation o...)',
	  '12:1971': '12:1971 (12:1971 Relief under...)',
	  '12:1972': '12:1972 (12:1972 Typing Arran...)',
	  '12:2601': '12:2601 (Real Estate Settleme...)',
	  '12:3410': '12:3410 (12:3410 Right to Fin...)',
	  '15:0001': '15:0001 (15:1 Antitrust Litig...)',
	  '15:0002at': '15:0002at (15:2 Antitrust Litig...)',
	  '15:0002fl': '15:0002fl (15:2(a) Fair Labor S...)',
	  '15:0005': '15:0005 (15:5(a) Fair Labor S...)',
	  '15:0015': '15:0015 (15:15 Antitrust Liti...)',
	  '15:0025': '15:0025 (15:25 Clayton Act)',
	  '15:0044': '15:0044 (15:44 Trademark Infr...)',
	  '15:0045': '15:0045 (15:0045 Federal Trad...)',
	  '15:0052': '15:0052 (15:0052  Federal Tra...)',
	  '15:0053': '15:0053 (15:0053  Federal Tra...)',
	  '15:0077': '15:0077 (15:77 Securities Fraud)',
	  '15:0078': '15:0078 (15:78m(a) Securities...)',
	  '15:0631': '15:0631 (15:631 Small Busines...)',
	  '15:0717': '15:0717 (15:717 Natural Gas Act)',
	  '15:0754': '15:0754 (15:754 Emergency Pet...)',
	  '15:1051': '15:1051 (15:1051 Trademark In...)',
	  '15:1114': '15:1114 (15:1114 Trademark In...)',
	  '15:1121': '15:1121 (15:1121 Trademark In...)',
	  '15:1125': '15:1125 (15:1125 Trademark In...)',
	  '15:1126': '15:1126 (15:1126 Patent Infri...)',
	  '15:1127': '15:1127 (15:1127 Trademark In...)',
	  '15:1601': '15:1601 (15:1601 Truth in Len...)',
	  '15:1640': '15:1640 (15:1640 Truth in Len...)',
	  '15:1681': '15:1681 (15:1681 Fair Credit ...)',
	  '15:1692': '15:1692 (15:1692 Fair Debt Co...)',
	  '15:1938': '15:1938 (15:1938 Fair Labor S...)',
	  '15:1981': '15:1981 (15:1981 Fraud-Motor ...)',
	  '15:1988': '15:1988 (15:1988 Fraud-Motor ...)',
	  '15:1989': '15:1989 (15:1989 Fraud-Motor ...)',
	  '15:2301': '15:2301 (15:2301 Magnuson-Mos...)',
	  '15:2801': '15:2801 (15:2801 Petroleum Ma...)',
	  '15:53(b)': '15:53(b) (15:53(b) - Prelim & ...)',
	  '16:0668': '16:0668 (16:668 Bald Eagle Pr...)',
	  '16:0703': '16:0703 (16:703 Migratory Bir...)',
	  '16:1538': '16:1538 (16:1538  Endangered ...)',
	  '16:3371': '16:3371 (16:3371  Wildlife Un...)',
	  '16:3372': '16:3372 (16:3372 Conservation...)',
	  '16:3373': '16:3373 (16:3373  Appeal of D...)',
	  '16:3374': '16:3374 (16:3374 Conservation...)',
	  '17:0101': '17:0101 (17:101 Copyright Inf...)',
	  '17:0501': '17:0501 (17:501 Copyright Inf...)',
	  '17:0504': '17:0504 (17:504 Copyright Inf...)',
	  '17:1203': '17:1203 (17:1203 Digital Mill...)',
	  '18:0241': '18:0241 (18:241 Conspiracy Ag...)',
	  '18:1961': '18:1961 (18:1961 Racketeering...)',
	  '18:1962': '18:1962 (18:1962 Racketeering...)',
	  '18:1964': '18:1964 (18:1964 Racketeering...)',
	  '18:2511': '18:2511 (18:2511 Wiretapping)',
	  '18:3114': '18:3114 (18:3114 Motion for R...)',
	  '18:4208': '18:4208 (18:4208(B) Agency Ac...)',
	  '19:1305': '19:1305 (19:1305 Custom Dutie...)',
	  '20:1080': '20:1080 (20:1080 Student Loan...)',
	  '20:1400': '20:1400 (20:1400 Civil Rights...)',
	  '20:1401': '20:1401 (20:1401 Education: H...)',
	  '21:0841': '21:0841 (21:841 Forfeiture Pr...)',
	  '21:0881': '21:0881 (21:881 Forfeiture Pr...)',
	  '21:0881a': '21:0881a (21:881 Forfeiture Pr...)',
	  '21:0881re': '21:0881re (21:881 Forfeiture Pr...)',
	  '23:0134': '23:0134 (23:134 P.I.- Auto Ne...)',
	  '23:1441': '23:1441 (23:1441 Contract Rea...)',
	  '24:1000': '24:1000 (24:1000 Hospitals & ...)',
	  '25:0640': '25:0640 (25:640 Indian Tribal...)',
	  '25:1901': '25:1901 (25:1901 Indian Child...)',
	  '26:6212': '26:6212 (26:6212 Injunctive R...)',
	  '26:6213': '26:6213 (26:6213 Injunctive R...)',
	  '26:6502': '26:6502 (26:6502 IRS:Enforcem...)',
	  '26:6532': '26:6532 (26:6532 IRS: Refund ...)',
	  '26:6702': '26:6702 (26:6702 IRS: Refund ...)',
	  '26:6703': '26:6703 (26:6703 IRS: Refund ...)',
	  '26:7401': '26:7401 (26:7401 IRS: Tax Lia...)',
	  '26:7402': '26:7402 (26:7402 IRS: Petitio...)',
	  '26:7403': '26:7403 (26:7403  Suit to Enf...)',
	  '26:7422rt': '26:7422rt (26:7422 IRS: Refund ...)',
	  '26:7422rx': '26:7422rx (26:7422 IRS: Refund ...)',
	  '26:7426': '26:7426 (26:7426 IRS: Wrongfu...)',
	  '26:7429': '26:7429 (26:7429 IRS: Tax Jeo...)',
	  '26:7609': '26:7609 (26:7609 IRS: Petitio...)',
	  '27:0185': '27:0185 (27:185 Enforcement o...)',
	  '28:0157c': '28:0157c (28:0157(c)(1) Findin...)',
	  '28:0157d': '28:0157d (28:0157 Motion for W...)',
	  '28:0158': '28:0158 (28:0158  Notice of A...)',
	  '28:0185': '28:0185 (28:185 Suit to Compe...)',
	  '28:0451': '28:0451 (28:451 Employment Di...)',
	  '28:0754': '28:0754 (28:754 Receiver of P...)',
	  '28:0794': '28:0794 (28:794 Rehabilitatio...)',
	  '28:1001': '28:1001 (28:1001 E.R.I.S.A.)',
	  '28:1132': '28:1132 (28:1132 E.R.I.S.A.)',
	  '28:1330': '28:1330 (28:1330 Breach of Co...)',
	  '28:1331': '28:1331 (28:1331 Fed. Question)',
	  '28:1331al': '28:1331al (28:1331 Fed. Questio...)',
	  '28:1331at': '28:1331at (28:1331 Fed. Questio...)',
	  '28:1331au': '28:1331au (28:1331 Fed. Questio...)',
	  '28:1331b': '28:1331b (28:1331  Federal Que...)',
	  '28:1331bc': '28:1331bc (28:1331 Fed. Questio...)',
	  '28:1331ca': '28:1331ca (28:1331 Fed Question...)',
	  '28:1331cm': '28:1331cm (28:1331 Fed. Questio...)',
	  '28:1331cv': '28:1331cv (28:1331 Federal Ques...)',
	  '28:1331ed': '28:1331ed (28:1331 Fed. Questio...)',
	  '28:1331ej': '28:1331ej (28:1331 Federal Ques...)',
	  '28:1331es': '28:1331es (28:1331  Enforcement...)',
	  '28:1331fl': '28:1331fl (28:1331 Fed. Questio...)',
	  '28:1331in': '28:1331in (28:1331 Fed. Questio...)',
	  '28:1331mm': '28:1331mm (28:1331 Fed. Questio...)',
	  '28:1331ng': '28:1331ng (28:1331 Fed. Questio...)',
	  '28:1331pi': '28:1331pi (28:1331 Fed. Questio...)',
	  '28:1331rd': '28:1331rd (28:1331 Fed. Questio...)',
	  '28:1331rp': '28:1331rp (28:1331(a) Fed. Ques...)',
	  '28:1331rr': '28:1331rr (28:1331 Fed. Questio...)',
	  '28:1331sv': '28:1331sv (28:1331 Fed. Questio...)',
	  '28:1331tr': '28:1331tr (28:1331 Fed. Questio...)',
	  '28:1331tt': '28:1331tt (28:1331 Fed. Questio...)',
	  '28:1331v': '28:1331v (28:1331 Fed. Questio...)',
	  '28:1331wl': '28:1331wl (28:1331  Federal Que...)',
	  '28:1331wt': '28:1331wt (28:1331 Fed. Questio...)',
	  '28:1332ac': '28:1332ac (28:1332 Diversity-Ac...)',
	  '28:1332al': '28:1332al (28:1332 Diversity-Ai...)',
	  '28:1332as': '28:1332as (28:1332 Diversity-As...)',
	  '28:1332au': '28:1332au (28:1332 Diversity-Au...)',
	  '28:1332bc': '28:1332bc (28:1332 Diversity-Br...)',
	  '28:1332co': '28:1332co (28:1332 Diversity-Co...)',
	  '28:1332ct': '28:1332ct (28:1332 Diversity-(C...)',
	  '28:1332det': '28:1332det (28:1332 Diversity: F...)',
	  '28:1332df': '28:1332df (28:1332 Diversity-Co...)',
	  '28:1332ds': '28:1332ds (28:1332 Diversity-Co...)',
	  '28:1332ed': '28:1332ed (28:1332 Diversity-Em...)',
	  '28:1332fd': '28:1332fd (28:1332 Diversity-Br...)',
	  '28:1332fr': '28:1332fr (28:1332 Diversity-Fraud)',
	  '28:1332ia': '28:1332ia (28:1332 Diversity-In...)',
	  '28:1332ij': '28:1332ij (28:1332 Diversity-In...)',
	  '28:1332in': '28:1332in (28:1332 Diversity-In...)',
	  '28:1332jd': '28:1332jd (28:1332 Diversity-De...)',
	  '28:1332lb': '28:1332lb (28:1332 Diversity-Li...)',
	  '28:1332lm': '28:1332lm (28:1332  Diversity -...)',
	  '28:1332ma': '28:1332ma (28:1332  Diversity-M...)',
	  '28:1332mm': '28:1332mm (28:1332 Diversity-Me...)',
	  '28:1332mv': '28:1332mv (28:1332 Diversity-Mo...)',
	  '28:1332ni': '28:1332ni (28:1332 Diversity-Ne...)',
	  '28:1332nm': '28:1332nm (28:1332 Diversity-No...)',
	  '28:1332nr': '28:1332nr (28:1332 Diversity-No...)',
	  '28:1332oc': '28:1332oc (28:1332 Diversity-Ot...)',
	  '28:1332pd': '28:1332pd (28:1332 Diversity-Pr...)',
	  '28:1332pi': '28:1332pi (28:1332 Diversity-Pe...)',
	  '28:1332pl': '28:1332pl (28:1332 Diversity-Pr...)',
	  '28:1332pr': '28:1332pr (28:1332 Diversity-Pe...)',
	  '28:1332qt': '28:1332qt (28:1332 Diversity-Pe...)',
	  '28:1332ri': '28:1332ri (28:1332  Diversity-R...)',
	  '28:1332sa': '28:1332sa (28:1332 - Diversity:...)',
	  '28:1332sf': '28:1332sf (28:1332 - Diversity:...)',
	  '28:1332ss': '28:1332ss (28:1332 Diversity - ...)',
	  '28:1332tl': '28:1332tl (28:1332 Diversity-To...)',
	  '28:1332tm': '28:1332tm (28:1332 Diversity-To...)',
	  '28:1332tn': '28:1332tn (28:1332 Diversity-To...)',
	  '28:1332wd': '28:1332wd (28:1332 Diversity-Wr...)',
	  '28:1333': '28:1333 (28:1333 Admiralty)',
	  '28:1334': '28:1334 (28:1334 Bankruptcy A...)',
	  '28:1334c': '28:1334c (28:1334(c)  R&R re m...)',
	  '28:1335': '28:1335 (28:1335 Interpleader...)',
	  '28:1337': '28:1337 (28:1337 Sherman-Clay...)',
	  '28:1338cp': '28:1338cp (28:1338 Copyright In...)',
	  '28:1338pt': '28:1338pt (28:1338 Patent Infri...)',
	  '28:1338tr': '28:1338tr (28:1338 Trademark In...)',
	  '28:1340': '28:1340 (28:1340 IRS: Custom ...)',
	  '28:1340er': '28:1340er (28:1340 Recovery of ...)',
	  '28:1341': '28:1341 (28:1341 Complaint fo...)',
	  '28:1343': '28:1343 (28:1343 Violation of...)',
	  '28:1345': '28:1345 (28:1345 USA Plaintiff)',
	  '28:1345co': '28:1345co (28:1345 Replevin & C...)',
	  '28:1345db': '28:1345db (28:1345 Debt to US -...)',
	  '28:1345df': '28:1345df (28:1345   Default of...)',
	  '28:1345er': '28:1345er (28:1345 Recovery of ...)',
	  '28:1345fc': '28:1345fc (28:1345 Foreclosure)',
	  '28:1345ff': '28:1345ff (28:1345 Complaint fo...)',
	  '28:1345hl': '28:1345hl (28:1345 VA Home Loan...)',
	  '28:1345mc': '28:1345mc (28:1345  Medical Car...)',
	  '28:1345mi': '28:1345mi (28:1345 Mining Claim...)',
	  '28:1345pd': '28:1345pd (28:1345 Property Damage)',
	  '28:1345pe': '28:1345pe (28:1345  Property Ej...)',
	  '28:1345rc': '28:1345rc (28:1345 Recovery of ...)',
	  '28:1345st': '28:1345st (28:1345 Default of S...)',
	  '28:1345tp': '28:1345tp (28:1345 Trespass on ...)',
	  '28:1345va': '28:1345va (28:1345 Recovery of ...)',
	  '28:1346bc': '28:1346bc (28:1346  Breach of C...)',
	  '28:1346rc': '28:1346rc (28:1346 Recovery of ...)',
	  '28:1346tc': '28:1346tc (28:1346 Tort Claim)',
	  '28:1346wd': '28:1346wd (28:1346 Wrongful Death)',
	  '28:1349': '28:1349 (28:1348 Corporation ...)',
	  '28:1352': '28:1352 (28:1352 Miller Act)',
	  '28:1355': '28:1355 (28:1355  Petition fo...)',
	  '28:1358': '28:1358 (28:1358 Land Condemn...)',
	  '28:1361': '28:1361 (28:1361 Petition for...)',
	  '28:1362ic': '28:1362ic (28:1362 Indian Triba...)',
	  '28:1362iw': '28:1362iw (28:1362 Declaration ...)',
	  '28:1364': '28:1364 (28:1364 Auto Negligence)',
	  '28:1391': '28:1391 (28:1391 Personal Injury)',
	  '28:1402': '28:1402 (28:1402 Medical Malp...)',
	  '28:1407': '28:1407 (28:1407 Airline Crash)',
	  '28:1441ac': '28:1441ac (28:1441 Petition for...)',
	  '28:1441al': '28:1441al (28:1441 Petition for...)',
	  '28:1441as': '28:1441as (28:1441 Petition for...)',
	  '28:1441au': '28:1441au (28:1441 Petition for...)',
	  '28:1441bc': '28:1441bc (28:1441 Petition for...)',
	  '28:1441cv': '28:1441cv (28:1441 Petition for...)',
	  '28:1441df': '28:1441df (28:1441 Petition for...)',
	  '28:1441dj': '28:1441dj (28:1441 Petition for...)',
	  '28:1441ds': '28:1441ds (28:1441 Petition for...)',
	  '28:1441ed': '28:1441ed (28:1441  Petition fo...)',
	  '28:1441fc': '28:1441fc (28:1441 Petition for...)',
	  '28:1441fr': '28:1441fr (28:1441 Petition for...)',
	  '28:1441ij': '28:1441ij (28:1441 Petition for...)',
	  '28:1441in': '28:1441in (28:1441 Petition for...)',
	  '28:1441int': '28:1441int (28:1441 Petition for...)',
	  '28:1441lb': '28:1441lb (28:1441 Petition for...)',
	  '28:1441lm': '28:1441lm (28:1441 Petition for...)',
	  '28:1441mm': '28:1441mm (28:1441 Petition for...)',
	  '28:1441ni': '28:1441ni (28:1441 Petition for...)',
	  '28:1441nm': '28:1441nm (28:1441 Petition for...)',
	  '28:1441nr': '28:1441nr (28:1441 Notice of Re...)',
	  '28:1441oc': '28:1441oc (28:1441 Petition For...)',
	  '28:1441pd': '28:1441pd (28:1441 Petition for...)',
	  '28:1441pi': '28:1441pi (28:1441 Petition for...)',
	  '28:1441pl': '28:1441pl (28:1441 Petition for...)',
	  '28:1441pr': '28:1441pr (28:1441 Petition for...)',
	  '28:1441qt': '28:1441qt (28:1441 Petition for...)',
	  '28:1441ri': '28:1441ri (28:1441 Petition for...)',
	  '28:1441sa': '28:1441sa (28:1441 - Petition f...)',
	  '28:1441sf': '28:1441sf (28:1441 - Petition f...)',
	  '28:1441tl': '28:1441tl (28:1441 Petition for...)',
	  '28:1441tm': '28:1441tm (28:1441 Petition for...)',
	  '28:1441tn': '28:1441tn (28:1441 Petition for...)',
	  '28:1441wd': '28:1441wd (28:1441 Petition for...)',
	  '28:1442bc': '28:1442bc (28:1442 Petition for...)',
	  '28:1442nr': '28:1442nr (28:1442 Notice of Re...)',
	  '28:1442pr': '28:1442pr (28:1442 Petition for...)',
	  '28:1443': '28:1443 (28:1443(1) Rent, Lea...)',
	  '28:1444': '28:1444 (28:1444 Petition for...)',
	  '28:1446in': '28:1446in (28:1446 Breach of Co...)',
	  '28:1446nr': '28:1446nr (28:1446 Notice of Re...)',
	  '28:1446pd': '28:1446pd (28:1446 Petition for...)',
	  '28:1446pi': '28:1446pi (28:1446 Petition for...)',
	  '28:1446pl': '28:1446pl (28:1446pl Petition f...)',
	  '28:1446pr': '28:1446pr (28:1446 Petition for...)',
	  '28:1452': '28:1452 (28:1452  R&R re moti...)',
	  '28:1651': '28:1651 (28:1651  Petition fo...)',
	  '28:1651hc': '28:1651hc (28:1651 Petition for...)',
	  '28:1651mn': '28:1651mn (28:1651 Petition for...)',
	  '28:1782': '28:1782 (28:1782 Letter rogat...)',
	  '28:1821': '28:1821 (28:1821 Witness Fees...)',
	  '28:1983': '28:1983 (28:1983 Civil Rights)',
	  '28:2201': '28:2201 (28:2201 Constitution...)',
	  '28:2201dj': '28:2201dj (28:2201 Declaratory ...)',
	  '28:2201ij': '28:2201ij (28:2201 Injunction)',
	  '28:2201in': '28:2201in (28:2201 Declaratory ...)',
	  '28:2241': '28:2241 (28:2241 Petition for...)',
	  '28:2254': '28:2254 (28:2254 Petition for...)',
	  '28:2254se': '28:2254se (28:2254 Ptn for Writ...)',
	  '28:2255': '28:2255 (28:2255 Motion to Va...)',
	  '28:2271': '28:2271 (28:2271 Federal Tort...)',
	  '28:2345': '28:2345 (28:2345 Medicare Rec...)',
	  '28:2409': '28:2409 (28:2409(a) Quiet Tit...)',
	  '28:2410': '28:2410 (28:2410 Quiet Title)',
	  '28:2671': '28:2671 (28:2671 Federal Tort...)',
	  '28:2674': '28:2674 (28:2674 Federal Tort...)',
	  '28:3001': '28:3001 (28:3001 Federal Debt...)',
	  '28:7402': '28:7402 (28:7402 Refund of Taxes)',
	  '28:7422': '28:7422 (28:7422 Appeal from ...)',
	  '29:0151': '29:0151 (29:151 Labor: Review...)',
	  '29:0160': '29:0160 (29:160(1) National L...)',
	  '29:0184': '29:0184 (29:184 Violation Col...)',
	  '29:0185ep': '29:0185ep (29:185 Employee Pens...)',
	  '29:0185lm': '29:0185lm (29:185 Labor/Mgt. Re...)',
	  '29:0201do': '29:0201do (29:201 Denial of Ove...)',
	  '29:0201fl': '29:0201fl (29:201 Fair Labor St...)',
	  '29:0203': '29:0203 (29:203 Equal Pay Act)',
	  '29:0206': '29:0206 (29:206 Collect Unpai...)',
	  '29:0401': '29:0401 (29:0401 Labor Manage...)',
	  '29:0621': '29:0621 (29:621 Job Discrimin...)',
	  '29:0623': '29:0623 (29:623 Job Discrimin...)',
	  '29:0626': '29:0626 (29:626 Job Discrimin...)',
	  '29:0633': '29:0633 (29:633 Job Discrimin...)',
	  '29:0651': '29:0651 (29:651 Occupational ...)',
	  '29:0754': '29:0754 (29:754 Discrimination)',
	  '29:0791': '29:0791 (29:791 Job Discrimin...)',
	  '29:0794': '29:0794 (29:0794 Job Discrimi...)',
	  '29:1001': '29:1001 (29:1001 E.R.I.S.A.: ...)',
	  '29:1002': '29:1002 (29:1002 E.R.I.S.A.: ...)',
	  '29:1104': '29:1104 (29:1104 Recovery of ...)',
	  '29:1109': '29:1109 (29:1109 Breach of Fi...)',
	  '29:1131': '29:1131 (29:1131 ERISA - Coll...)',
	  '29:1132': '29:1132 (29:1132 E.R.I.S.A.-E...)',
	  '29:1145': '29:1145 (29:1145 E.R.I.S.A.)',
	  '29:1149': '29:1149 (29:1149 Recover Pens...)',
	  '29:1337': '29:1337 (29:1337 E.R.I.S.A.)',
	  '29:1362': '29:1362 (29:1362  ERISA)',
	  '29:1381': '29:1381 (29:1381 E.R.I.S.A.)',
	  '29:1401': '29:1401 (29:1401(b)(2) Appeal...)',
	  '29:1451': '29:1451 (29:1451 E.R.I.S.A.)',
	  '29:1801': '29:1801 (29:1801 Farmworker R...)',
	  '29:790': '29:790 (29:790  Rehabilitati...)',
	  '30:0181': '30:0181 (30:181 Environment: ...)',
	  '30:0801': '30:0801 (30:0801 Penalities/F...)',
	  '30:1201': '30:1201 (30:1201 Environment:...)',
	  '30:1202': '30:1202 (30:1202 Mining Recla...)',
	  '30:1276': '30:1276 (30:1276 Interior: Re...)',
	  '31:3545': '31:3545 (31:3545 Action to Re...)',
	  '31:3729': '31:3729 (31:3729 False Claims...)',
	  '31:3731': '31:3731 (31:3731 Fraud)',
	  '33:1319cw': '33:1319cw (33:1319 Clean Water Act)',
	  '33:1319pv': '33:1319pv (33:1319 Pollutants &...)',
	  '33:1365': '33:1365 (33:1365 Environmenta...)',
	  '35:0145': '35:0145 (35:145 Patent Infrin...)',
	  '35:0183': '35:0183 (35:183 Patent Infrin...)',
	  '35:0271': '35:0271 (35:271 Patent Infrin...)',
	  '38:1681': '38:1681 (38:1681 Recovery of ...)',
	  '38:1686': '38:1686 (38:1686 Recovery of ...)',
	  '38:1780': '38:1780 (38:1780 Recovery of ...)',
	  '38:2011': '38:2011 (38:2011 - Veteran\'s ...)',
	  '38:2021': '38:2021 (Right to re-employme...)',
	  '38:3116': '38:3116 (38:3116 VA Overpayment)',
	  '38:775': '38:775 (Recovery of Servicem...)',
	  '39:3005': '39:3005 (39:3005 Detention of...)',
	  '39:409': '39:409 (39:409  Postal Service)',
	  '40:0258': '40:0258 (40:258(a) Public Bui...)',
	  '40:0270': '40:0270 (40:270 Miller Act)',
	  '40:0875': '40:0875 (40:875 Public Buildi...)',
	  '41:0251': '41:0251 (41:251 Public Contra...)',
	  '41:1463': '41:1463 (41:1463 Public Contr...)',
	  '42:0205': '42:0205 (42:205 Denial Social...)',
	  '42:0206': '42:0206 (42:206 Social Securi...)',
	  '42:0247': '42:0247 (42:247 Personal Inju...)',
	  '42:0402': '42:0402 (42:402 Social Securi...)',
	  '42:0405id': '42:0405id (42:405 Review of HHS...)',
	  '42:0405wc': '42:0405wc (42:405 Review of HHS...)',
	  '42:0405ww': '42:0405ww (42:405 Review of HHS...)',
	  '42:0416': '42:0416 (42:416 Denial of Soc...)',
	  '42:0427': '42:0427 (42:427 Social Securi...)',
	  '42:11603': '42:11603 (International Child ...)',
	  '42:12101': '42:12101 (42:12101 Americans W...)',
	  '42:1383': '42:1383 (42:1383 Review of HH...)',
	  '42:1395': '42:1395 (42:1395  HHS: Advers...)',
	  '42:1396': '42:1396 (42:1396 - Tort Negli...)',
	  '42:1471': '42:1471 (42:1471  Declaratory...)',
	  '42:1981cv': '42:1981cv (42:1981 Civil Rights)',
	  '42:1981hs': '42:1981hs (42:1981 Housing Disc...)',
	  '42:1981jb': '42:1981jb (42:1981 Job Discrimi...)',
	  '42:1981sx': '42:1981sx (42:1981 Sex Discrimi...)',
	  '42:1983cv': '42:1983cv (42:1983 Civil Rights...)',
	  '42:1983ed': '42:1983ed (42:1983 Civil Rights...)',
	  '42:1983pr': '42:1983pr (42:1983 Prisoner Civ...)',
	  '42:1986': '42:1986 (42:1986 Neglect of Duty)',
	  '42:2000ag': '42:2000ag (42:2000 Job Discrimi...)',
	  '42:2000e': '42:2000e (42:2000e  Job Discri...)',
	  '42:2000pb': '42:2000pb (42:2000 Job Discrimi...)',
	  '42:2000ra': '42:2000ra (42:2000 Job Discrimi...)',
	  '42:2000sx': '42:2000sx (42:2000 Job Discrimi...)',
	  '42:2003': '42:2003 (42:2003 Job Discrimi...)',
	  '42:2005': '42:2005 (42:2005 Review of Ag...)',
	  '42:2615': '42:2615 (42:2616 Medical Reco...)',
	  '42:2651': '42:2651 (42:2651  Medical Car...)',
	  '42:3601': '42:3601 (42:405 Fair Housing Act)',
	  '42:4000': '42:4000 (42:4000 National Flo...)',
	  '42:4001': '42:4001 (42:4001 National Ins...)',
	  '42:4053': '42:4053 (42:4053 Breach of In...)',
	  '42:4072': '42:4072 (42:4072 Payment of F...)',
	  '42:4321': '42:4321 (42:4321 Review of Ag...)',
	  '42:4332': '42:4332 (42:4332 Environmenta...)',
	  '42:6901en': '42:6901en (42:6901 Environmenta...)',
	  '42:6901rs': '42:6901rs (42:6901 Resource & R...)',
	  '42:7413': '42:7413 (42:7413(b)  Clean Ai...)',
	  '42:7604cl': '42:7604cl (42:7604 Clear Air Ac...)',
	  '42:7604ir': '42:7604ir (42:7604 Petition to ...)',
	  '42:9607': '42:9607 (42:9607 Real Propert...)',
	  '43:945': '43:945 (43:945  Compensation...)',
	  '43:945a': '43:945a (43:945a  Complaint i...)',
	  '43:946': '43:946 (43:946  Complaint in...)',
	  '45:0051': '45:0051 (45:51 Railways: Fed....)',
	  '45:0151': '45:0151 (45:151 Railway Labor...)',
	  '45:0184': '45:0184 (45:184 Action to Set...)',
	  '45:1395': '45:1395 (45:1395 Railroads: A...)',
	  '45:7457': '45:7457 (45:7457 Compel Recla...)',
	  '46:0688': '46:0688 (46:688 Jones Act)',
	  '46:0741': '46:0741 (46:741 Shipping)',
	  '46:0761': '46:0761 (46:761 Shipping: Dam...)',
	  '46:1101': '46:1101 (46:1101 Violation of...)',
	  '46:1156': '46:1156 (46:1156 Administrati...)',
	  '48:0883': '48:0883 (48:883 Violation of ...)',
	  '48:1985': '48:1985 (48:1985  Conspiracy/...)',
	  '49:0081': '49:0081 (49:81 Damaged Goods ...)',
	  '49:0502': '49:0502 (49:502 Motor Carrier...)',
	  '49:0781': '49:0781 (49:781 Forfeiture)',
	  '49:11503': '49:11503 (49:11503 Railroad Re...)',
	  '49:11702': '49:11702 (49:11702(a)(4) Viola...)',
	  '49:1471': '49:1471 (49:1471 Federal Avia...)',
	  '49:1903': '49:1903 (49:1903  Petition to...)',
	  '8:287': '8:287 (8:287 Petition to En...)',
	  '99:9999': '99:9999 (99:9999 Report cause...)',
	  adsup: 'adsup (Administrative Subpoena)',
	  contempt: 'contempt (Contempt Proceedings)',
	  disbar: 'disbar (Disbarment Proceedings)',
	  fordepo: 'fordepo (Foreign Deposition)',
	  misc: 'misc (Civil Miscellaneous ...)',
	  motcomp: 'motcomp (Motion to Compel)',
	  motquash: 'motquash (Motion to Quash)',
	  motret: 'motret (Motion for Return of...)',
	  petenf: 'petenf (Petition to Enforce ...)',
	  petper: 'petper (Petition to Perpetua...)',
	  regjgm: 'regjgm (Registration of Fore...)',
	  tranbkref: 'tranbkref (Transmission of Bank...)',
	  tranff: 'tranff (Transmission of Prop...)',
	  writgar: 'writgar (Application for a Wr...)'
	};
	
	var jurisdictionOptions = {
	  4: 'Diversity',
	  3: 'Federal Question',
	  5: 'Local Question',
	  2: 'U.S. Government Defendant',
	  1: 'U.S. Government Plaintiff'
	};
	
	var caseFlagOptions = {
	  APPEAL: 'APPEAL',
	  ARBITRATION: 'ARBITRATION',
	  CASREF: 'CASREF',
	  CLOSED: 'CLOSED',
	  CONSENT: 'CONSENT',
	  ENE: 'ENE',
	  HABEAS: 'HABEAS',
	  HBS: 'HBS',
	  HKS: 'HKS',
	  INTERPRETER: 'INTERPRETER',
	  JJM: 'JJM',
	  JWF: 'JWF',
	  LEAD: 'LEAD',
	  LGF: 'LGF',
	  MEDIATION: 'MEDIATION',
	  MEMBER: 'MEMBER',
	  MERGED: 'MERGED',
	  MOTREF: 'MOTREF',
	  MWP: 'MWP',
	  PRIOR: 'PRIOR',
	  ProSe: 'ProSe',
	  SEALED: 'SEALED',
	  SETTLE: 'SETTLE',
	  SM: 'SM',
	  STAT_CLOSE: 'STAT_CLOSE',
	  STAYED: 'STAYED',
	  VEB: 'VEB',
	  VictimNotify: 'VictimNotify'
	};
	
	var casePropertiesOptions = {
	  open_cases: 'Open Cases',
	  closed_cases: 'Closed cases'
	};

/***/ },
/* 1220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(13);
	
	var _FieldSet = __webpack_require__(63);
	
	var _FieldSet2 = _interopRequireDefault(_FieldSet);
	
	var _Selector = __webpack_require__(248);
	
	var _Selector2 = _interopRequireDefault(_Selector);
	
	var _DateFilter = __webpack_require__(348);
	
	var _DateFilter2 = _interopRequireDefault(_DateFilter);
	
	var _courtsMapper = __webpack_require__(422);
	
	var _courtsMapper2 = _interopRequireDefault(_courtsMapper);
	
	__webpack_require__(2205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Criminal = function (_Component) {
	  _inherits(Criminal, _Component);
	
	  function Criminal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Criminal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.regionOptions = (0, _courtsMapper2.default)('district', 'District Court'), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Criminal.prototype.render = function render() {
	    var _props = this.props,
	        region = _props.region,
	        caseType = _props.caseType,
	        citation = _props.citation,
	        dateFrom = _props.dateFrom,
	        dateTo = _props.dateTo,
	        caseFlag = _props.caseFlag,
	        countStatus = _props.countStatus,
	        includeCVBCases = _props.includeCVBCases,
	        caseProperties = _props.caseProperties,
	        select = _props.select,
	        multiselect = _props.multiselect;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'reports-tab-form reports-tab-forms-criminal' },
	      _react2.default.createElement(
	        _FieldSet2.default,
	        { title: 'Case Information' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row no-padding' },
	          _react2.default.createElement(_Selector2.default, {
	            multi: true,
	            clearable: false,
	            className: 'reports-tab-criminal-region-selector',
	            options: this.regionOptions,
	            title: 'Region',
	            value: region,
	            placeholder: 'Select Region',
	            onChange: multiselect.bind(this, 'region') }),
	          _react2.default.createElement(_Selector2.default, {
	            multi: true,
	            clearable: false,
	            className: 'reports-tab-criminal-case-type-selector',
	            options: caseTypeOptions,
	            title: 'Case Type',
	            value: caseType,
	            placeholder: 'Any',
	            onChange: multiselect.bind(this, 'caseType') })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(_Selector2.default, {
	            clearable: false,
	            className: 'reports-tab-criminal-citation-selector',
	            options: citationOptions,
	            title: 'Citation',
	            value: citation,
	            placeholder: '',
	            onChange: select.bind(this, 'citation') }),
	          _react2.default.createElement(_DateFilter2.default, {
	            from: dateFrom,
	            to: dateTo,
	            onChangeFrom: select.bind(this, 'dateFrom'),
	            onChangeTo: select.bind(this, 'dateTo'),
	            className: 'reports-tab-criminal-date-filter-selector' })
	        )
	      ),
	      _react2.default.createElement(
	        _FieldSet2.default,
	        { title: 'Advanced Filters' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row no-padding' },
	          _react2.default.createElement(_Selector2.default, {
	            multi: true,
	            clearable: false,
	            className: 'reports-tab-criminal-case-flag-selector',
	            options: caseFlagOptions,
	            title: 'Case Flag',
	            value: caseFlag,
	            placeholder: '',
	            onChange: multiselect.bind(this, 'caseFlag') }),
	          _react2.default.createElement(_Selector2.default, {
	            multi: true,
	            clearable: false,
	            className: 'reports-tab-criminal-count-status-selector',
	            options: countStatusOptions,
	            title: 'Count Status',
	            value: countStatus,
	            placeholder: '',
	            onChange: multiselect.bind(this, 'countStatus') })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(_Selector2.default, {
	            clearable: false,
	            className: 'reports-tab-criminal-include-cvb-cases-selector',
	            options: includeCVBCasesOptions,
	            title: 'Include CVB Cases',
	            value: includeCVBCases,
	            placeholder: '',
	            onChange: select.bind(this, 'includeCVBCases') })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(_Selector2.default, {
	            multi: true,
	            clearable: false,
	            className: 'reports-tab-criminal-case-properties-selector',
	            options: casePropertiesOptions,
	            title: 'Case Properties',
	            value: caseProperties,
	            placeholder: '',
	            onChange: multiselect.bind(this, 'caseProperties') })
	        )
	      )
	    );
	  };
	
	  return Criminal;
	}(_react.Component);
	
	Criminal.propTypes = {
	  region: _propTypes2.default.any.isRequired,
	  caseType: _propTypes2.default.any.isRequired,
	  citation: _propTypes2.default.any.isRequired,
	  dateFrom: _propTypes2.default.any.isRequired,
	  dateTo: _propTypes2.default.any.isRequired,
	  caseFlag: _propTypes2.default.any.isRequired,
	  countStatus: _propTypes2.default.any.isRequired,
	  includeCVBCases: _propTypes2.default.any.isRequired,
	  caseProperties: _propTypes2.default.any.isRequired,
	  setFormValue: _propTypes2.default.func.isRequired,
	  select: _propTypes2.default.func.isRequired,
	  multiselect: _propTypes2.default.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {};
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Criminal);
	
	
	var caseTypeOptions = {
	  cr: 'Criminal',
	  mj: 'Magistrate Judge',
	  po: 'Petty Offense'
	};
	var citationOptions = {
	  '10:2408.M': '10:2408.M            DEFENSE CONTRACT RELATED FELONIES, C...',
	  '10:847.P': '10:847.P             REFUSAL TO APPEAR OR TESTIFY',
	  '10:976.F': '10:976.F             MEMBERSHIP IN MILITARY UNIONS',
	  '12:1457.M': '12:1457.M            PENALTIES - PROHIBITED ACTIVITIES',
	  '12:161.P': '12:161.P             REPORT OF CONDITIONS',
	  '12:161A.P': '12:161A.P            REPORT OF CONDITIONS',
	  '12:161B.P': '12:161B.P            PAYMENT OF DIVIDENDS',
	  '12:161C.P': '12:161C.P            REPORTS OF AFFILIATES',
	  '12:164.P': '12:164.P             FAILURE TO REPORT BANK EXAMINATIONS',
	  '12:17092.F': '12:17092.F           EQUITY SKIMMING',
	  '12:1715.F': '12:1715.F            MORTGAGE/INSURANCE LOW-COST, INCOME ...',
	  '12:1730.F': '12:1730.F            RETENTION OF RECORDS BY INSURED INST...',
	  '12:1730.M': '12:1730.M            SUSPEND OR REMOVE DIRECTOR OR OFFICER',
	  '12:1738.P': '12:1738.P            MORTGAGE DISCRIMINATION',
	  '12:1782.M': '12:1782.M            FAILURE TO FILE CERTIFIED STATEMENT/PAY',
	  '12:1786K.M': '12:1786K.M           JURISDICTION AND ENFORCEMENT, PENALTIES',
	  '12:1786L.M': '12:1786L.M           REMOVED DIRECTOR, OFFICER OR MEMBER,...',
	  '12:1818.F': '12:1818.F            TERMINATION OF STATUS AS INSURED BANK',
	  '12:1829.F': '12:1829.F            RETENTION OF RECORDS BY INSURED BANKS',
	  '12:1841.M': '12:1841.M            BANK HOLDING COMPANY, DEFINITIONS',
	  '12:1842.M': '12:1842.M            ACQUISITION OF SHARES OR ASSETS',
	  '12:1843.M': '12:1843.M            INTERESTS IN NON-BANKING ORGANIZATIONS',
	  '12:1844.M': '12:1844.M            ADMINISTRATION OF HOLDING COMPANIES',
	  '12:1846.M': '12:1846.M            RESERVATION OF STATES RIGHTS',
	  '12:1847.M': '12:1847.M            PENALTIES - HOLDING COMPANIES',
	  '12:1848.M': '12:1848.M            JUDICIAL REVIEW',
	  '12:1849.M': '12:1849.M            SAVINGS PROVISIONS',
	  '12:1850.M': '12:1850.M            ACQUISITION OF SUBSIDIARIES',
	  '12:1901.M': '12:1901.M            DEFINITIONS',
	  '12:1902.M': '12:1902.M            RULES AND REGULATIONS, BY BOARD OF G...',
	  '12:1903.M': '12:1903.M            INTEREST',
	  '12:1904.M': '12:1904.M            CREDIT CONTROLS',
	  '12:1905.M': '12:1905.M            EXTENT OF CONTROL',
	  '12:1906.M': '12:1906.M            REPORTS: PRODUCTION OF RECORDS',
	  '12:1909.M': '12:1909.M            CREDIT CONTROL - PENALTIES',
	  '12:1956.M': '12:1956.M            PENALTIES - FINANCIAL RECORDKEEPING',
	  '12:1957.F': '12:1957.F            ADDITIONAL PENALTIES',
	  '12:211.M': '12:211.M             BANK CONSERVATOR VIOLATIONS',
	  '12:2607B.M': '12:2607B.M           SPLITTING CHARGES',
	  '12:2607D.M': '12:2607D.M           PENALTIES',
	  '12:2614.M': '12:2614.M            TOXIC SUBSTANCES CONTROL',
	  '12:3105.F': '12:3105.F            FOREIGN BANK PARTICIPATION IN DOMEST...',
	  '12:3111.F': '12:3111.F            FOREIGN BANK PARTICIPATION IN DOMEST...',
	  '12:334.P': '12:334.P             MUTUAL SAVINGS BANKS',
	  '12:378.F': '12:378.F             VIOLATIONS IN THE BANKING BUSINESS',
	  '12:481.P': '12:481.P             PENALTIES - BANK EXAMINATIONS',
	  '12:582.P': '12:582.P             RECEIVING U.S. BANK NOTES AS COLLATERAL',
	  '12:630.F': '12:630.F             OFFENSES BY OFFICERS OF A CORPORATION',
	  '12:631.F': '12:631.F             FALSE REPRESENTATION OF U.S. LIABILITY',
	  '12:95.F': '12:95.F              PRESIDENTIAL REGULATIONS IN NATIONAL...',
	  '12:95.M': '12:95.M              PRESIDENTIAL REGULATIONS IN NATIONAL...',
	  '13:212.P': '13:212.P             REFUSAL OR NEGLECT OF EMPLOYEE\'S DUTIES',
	  '13:213.F': '13:213.F             FALSE STATEMENTS, CERTIFICATES AND I...',
	  '13:214.F': '13:214.F             WRONGFUL DISCLOSURES',
	  '13:221.P': '13:221.P             REFUSE OR NEGLECT TO ANSWER QUESTIONS',
	  '13:222.M': '13:222.M             GIVE INACCURATE INFORMATION INTENTIO...',
	  '13:223.P': '13:223.P             OWNER/MANAGER REFUSES TO ASSIST CENS...',
	  '13:224.M': '13:224.M             FAILURE TO ANSWER QUESTIONS',
	  '13:224.P': '13:224.P             FALSE ANSWERS',
	  '13:304.F': '13:304.F             COLLECTION AND PUBLICATION OF FOREIG...',
	  '13:304.M': '13:304.M             COLLECTION AND PUBLICATION OF FOREIG...',
	  '13:305.F': '13:305.F             UNLAWFUL EXPORT INFORMATION ACTIVITIES',
	  '14:431.M': '14:431.M             IMPROPER PAYMENT FOR SERVICES',
	  '14:639.M': '14:639.M             PENALTIES - UNAUTHORIZED USE',
	  '14:83.P': '14:83.P              UNAUTHORIZED AIDS TO MARITIME NAVIGA...',
	  '14:84.P': '14:84.P              INTERFERENCE WITH AIDS TO NAVIGATION',
	  '14:85.P': '14:85.P              AIDS TO MARITIME NAVIGATION ON FIXED...',
	  '14:88.F': '14:88.F              FALSE DISTRESS SIGNALS',
	  '14:892.P': '14:892.P             PENALTIES - IMPROPER USE OF UNIFORMS...',
	  '15:1.F': '15:1.F               ANTITRUST VIOLATIONS',
	  '15:1002.P': '15:1002.P            GOLDEN GATE BRIDGE TOLL',
	  '15:1003.P': '15:1003.P            GOLDEN GATE BRIDGE TOLLS, AUTHORIZED...',
	  '15:1004.P': '15:1004.P            TOLL FRAUD',
	  '15:1005.P': '15:1005.P            SAN FRANCISCO-OAKLAND BAY BRIDGE TOLLS',
	  '15:1006.P': '15:1006.P            SF-OAKLAND BAY BRIDGE TOLLS: AUTHORI...',
	  '15:1007.P': '15:1007.P            TOLL FRAUD',
	  '15:1172.F': '15:1172.F            IMPORTING GAMBLING DEVICES',
	  '15:1173.F': '15:1173.F            REGISTRATION OF MANUFACTURERS AND DE...',
	  '15:1174.F': '15:1174.F            LABELING AND MARKING OF SHIPPING PAC...',
	  '15:1175.F': '15:1175.F            MANUFACTURING, REPAIRING ILLEGAL DEV...',
	  '15:1176.F': '15:1176.F            TRANSPORTING GAMBLING DEVICES',
	  '15:1192.M': '15:1192.M            PROHIBITED TRANSACTIONS',
	  '15:1196.M': '15:1196.M            FLAMMABLE FABRICS',
	  '15:1197.M': '15:1197.M            GUARANTIES',
	  '15:1211.M': '15:1211.M            PROHIBITION - TRANSPORT OF REFRIGERA...',
	  '15:1212.M': '15:1212.M            REFRIGERATORS W/O SAFETY DEVICES',
	  '15:1232A.P': '15:1232A.P           FAILURE TO AFFIX LABEL',
	  '15:1232B.P': '15:1232B.P           FAILURE TO CLEARLY ENDORSE LABEL',
	  '15:1232C.P': '15:1232C.P           WILLFUL REMOVAL, ALTERATION, OR MARK...',
	  '15:1233A.P': '15:1233A.P           FAILURE TO AFFIX LABEL',
	  '15:1233B.P': '15:1233B.P           FAILURE TO CLEARLY ENDORSE LABEL',
	  '15:1233C.M': '15:1233C.M           EXCISE TAX LABELS ON AUTOMOBILE',
	  '15:1233C.P': '15:1233C.P           WILLFUL REMOVAL, ALTERATION, OR MARK...',
	  '15:1242.F': '15:1242.F            MANUFACTURE, TRANSPORT OR DISTRIBUTE...',
	  '15:1243.F': '15:1243.F            MANUFACTURE, SALE OR POSSESSION WITH...',
	  '15:1263.M': '15:1263.M            PROHIBITED TRANSACTIONS',
	  '15:1263.P': '15:1263.P            PROHIBITED TRANSACTIONS',
	  '15:1264.M': '15:1264.M            HAZARDOUS SUBSTANCES',
	  '15:1264.P': '15:1264.P            HAZARDOUS SUBSTANCES',
	  '15:1281.F': '15:1281.F            DESTRUCTION OF PROPERTY, INTERSTATE ...',
	  '15:1335.M': '15:1335.M            UNLAWFUL ADVERTISEMENT ON ELECTRONIC...',
	  '15:1338.M': '15:1338.M            CIGARETTE LABELING AND ADVERTISING',
	  '15:13A.M': '15:13A.M             DISCRIMINATION IN REBATES',
	  '15:13C.M': '15:13C.M             PAYMENT OR ACCEPTANCE OF COMMISSION',
	  '15:13D.M': '15:13D.M             PAYMENT FOR SERVICES OR FACILITIES F...',
	  '15:13E.M': '15:13E.M             NOT FURNISHING SERVICES OR FACILITIE...',
	  '15:13F.M': '15:13F.M             KNOWINGLY INDUCE/RECEIVE DISCRIMINAT...',
	  '15:158.F': '15:158.F             FALSE OR FRAUDULENT STATEMENTS - CHI...',
	  '15:159.F': '15:159.F             UNAUTHORIZED USE OF LEGEND',
	  '15:1604.M': '15:1604.M            RULES AND REGULATIONS',
	  '15:1605.M': '15:1605.M            DETERMINATION OF FINANCE CHARGE',
	  '15:1606.M': '15:1606.M            DETERMINATION OF ANNUAL PERCENTAGE RATE',
	  '15:1611.M': '15:1611.M            FEDERAL STATUTE - CONSUMER CREDIT PR...',
	  '15:1644.F': '15:1644.F            CREDIT CARD FRAUD',
	  '15:1674.M': '15:1674.M            RESTORE ON DISCHARGE FROM EMPLOYMENT...',
	  '15:1681Q.M': '15:1681Q.M           OBTAINING CREDIT INFORMATION UNDER F...',
	  '15:1681R.M': '15:1681R.M           UNAUTHORIZED CREDIT DISCLOSURE BY OF...',
	  '15:1693.F': '15:1693.F            GIVING FALSE/INACCURATE INFORMATION',
	  '15:1693.M': '15:1693.M            GIVING FALSE/INACCURATE INFORMATION',
	  '15:1703.F': '15:1703.F            PROHIBITIONS RELATING TO REAL ESTATE',
	  '15:1704.F': '15:1704.F            REGISTRATION OF SUBDIVISION',
	  '15:1705.F': '15:1705.F            INFORMATION REQUIRED IN STATEMENT OF...',
	  '15:1707.F': '15:1707.F            INFORMATION REQUIRED IN PROPERTY REPORT',
	  '15:1716.F': '15:1716.F            UNLAWFUL REPRESENTATIONS',
	  '15:1717.F': '15:1717.F            PENALTIES FOR VIOLATIONS',
	  '15:1718.F': '15:1718.F            RULES, REGULATIONS, AND ORDERS',
	  '15:1823.F': '15:1823.F            UNLAWFUL ACTS',
	  '15:1824.M': '15:1824.M            INSPECTION OF HORSES',
	  '15:1825.F': '15:1825.F            INSPECTION VIOLATION PENALTIES',
	  '15:1825.M': '15:1825.M            INSPECTION OF HORSES',
	  '15:1828.F': '15:1828.F            RULES AND REGULATIONS',
	  '15:1963.F': '15:1963.F            VIOLATIONS AFFECTING INTERSTATE COMM...',
	  '15:1984.F': '15:1984.F            ALTERING ODOMETER SETTINGS',
	  '15:1984.M': '15:1984.M            ILLEGAL PRACTICES - AUTOMOBILES',
	  '15:1986.F': '15:1986.F            ODOMETER LAWS',
	  '15:1986.M': '15:1986.M            ODOMETER LAWS',
	  '15:1988.F': '15:1988.F            FALSE STATEMENTS TO TRANSFEREES PROH...',
	  '15:1988.M': '15:1988.M            FALSE STATEMENTS TO TRANSFEREES PROH...',
	  '15:1990.F': '15:1990.F            PENALTIES - ODOMETER LAWS',
	  '15:1990.M': '15:1990.M            PENALTIES - ODOMETER LAWS',
	  '15:2.F': '15:2.F               MONOPOLIZING TRADE',
	  '15:20.M': '15:20.M              PURCHASES BY CC IN CASE OF INTERLOCU...',
	  '15:2068.M': '15:2068.M            PROHIBITED ACTS',
	  '15:2070.M': '15:2070.M            CONSUMER PRODUCT SAFETY - PENALTIES',
	  '15:234.P': '15:234.P             STANDARD BARREL FOR FRUITS/OTHER DRY...',
	  '15:235.P': '15:235.P             SALE OR SHIPMENT OF BARREL OF LESS C...',
	  '15:236.P': '15:236.P             VARIATIONS FROM STANDARD PERMITTED: ...',
	  '15:237.P': '15:237.P             STANDARD BARRELS FOR LIME',
	  '15:238.P': '15:238.P             PENALTY FOR SELLING IN BARRELS NOT M...',
	  '15:239.P': '15:239.P             SALE IN CONTAINERS OF LESS THAN BARREL',
	  '15:24.M': '15:24.M              LIABILITY OF DIRECTOR AND AGENTS OF ...',
	  '15:241.P': '15:241.P             SELL LIME IN UNMARKED BARRELS/CONTAI...',
	  '15:242.P': '15:242.P             DUTY OF U.S. ATTORNEY TO ENFORCE LAW',
	  '15:2614.M': '15:2614.M            CONTEMPT, CONGRESSIONAL, PROHIBITED ...',
	  '15:2615.M': '15:2615.M            CONTEMPT, CONGRESSIONAL, PROHIBITED ...',
	  '15:2646.M': '15:2646.M            TOXIC SUBSTANCE CONTROL - ASBESTOS H...',
	  '15:291.M': '15:291.M             STAMPING W/WORDS: UNITED STATES ASSAY',
	  '15:292.M': '15:292.M             FORFEITURE',
	  '15:293.M': '15:293.M             FALSELY STAMPED GOODS  (T)',
	  '15:294.P': '15:294.P             IMPORTATION/TRANSPORTATION OF FALSEL...',
	  '15:295.P': '15:295.P             STANDARD OF FINENESS OF GOLD ARTICLES',
	  '15:296.P': '15:296.P             STANDARD OF FINENESS OF SILVER ARTICLES',
	  '15:297.P': '15:297.P             STAMPING PLATED ARTICLES',
	  '15:298.P': '15:298.P             FALSELY STAMPED GOODS  (T)',
	  '15:3.F': '15:3.F               TRUSTS IN TERRITORIES AND DISTRICT O...',
	  '15:330A.M': '15:330A.M            REPORT REQUIREMENT: FORM, INFORMATION',
	  '15:330D.M': '15:330D.M            WEATHER MODIFICATION ACTS OR ATTEMPTS',
	  '15:376.P': '15:376.P             REPORTS TO STATE TOBACCO TAX ADMINIS...',
	  '15:377.P': '15:377.P             JENKINS ACT - CIGARETTE TAXES',
	  '15:48.M': '15:48.M              FTC - IMPORT/UNFAIR COMPETITION',
	  '15:50.F': '15:50.F              FTC WITNESSES/EMPLOYEES - OFFENSES A...',
	  '15:50.M': '15:50.M              FTC WITNESSES/EMPLOYEES - OFFENSES A...',
	  '15:52.M': '15:52.M              DISSEMINATION OF FALSE ADVERTISEMENT...',
	  '15:52.P': '15:52.P              DISSEMINATION OF FALSE ADVERTISEMENT...',
	  '15:54.M': '15:54.M              DISSEMINATION OF FALSE ADVERTISEMENT...',
	  '15:54.P': '15:54.P              DISSEMINATION OF FALSE ADVERTISEMENT...',
	  '15:645A.F': '15:645A.F            FALSE STATEMENTS: OVERVALUATION OF S...',
	  '15:645B.F': '15:645B.F            EMBEZZLEMENT, ETC.',
	  '15:645C.F': '15:645C.F            SMALL BUSINESS CORPORATION - CONCEAL...',
	  '15:645C.M': '15:645C.M            SMALL BUSINESS CORPORATION - CONCEAL...',
	  '15:6823.F': '15:6823.F            FRAUDULENT ACCESS TO FINANCIAL INFOR...',
	  '15:68A.M': '15:68A.M             MISBRANDING DECLARED UNLAWFUL',
	  '15:68C.M': '15:68C.M             AFFIXING OF STAMP, TAG, LABEL, OR OT...',
	  '15:68F.M': '15:68F.M             EXCLUSION OF MISBRANDED WOOL PRODUCTS',
	  '15:68G.M': '15:68G.M             FALSE GUARANTY',
	  '15:68H.M': '15:68H.M             MIS-LABELING OF WOOL PRODUCTS',
	  '15:69A.M': '15:69A.M             MISBRANDING AND FALSE ADVERTISING/IN...',
	  '15:69D.M': '15:69D.M             EXCLUSION OF MISBRANDED OR FALSELY I...',
	  '15:69H.M': '15:69H.M             FALSE GUARANTY',
	  '15:69I.M': '15:69I.M             MIS-LABELING OF FUR PRODUCTS',
	  '15:70A.M': '15:70A.M             MISBRANDING AND FALSE ADVERTISING DE...',
	  '15:70C.M': '15:70C.M             REMOVAL OF STAMP, TAG, LABEL, OR OTH...',
	  '15:70D.M': '15:70D.M             MAINTAINING AND KEEPING PROPER RECORDS',
	  '15:70G.M': '15:70G.M             EXCLUSION OF MISBRANDED TEXTILE FIBE...',
	  '15:70H.M': '15:70H.M             FALSE GUARANTY',
	  '15:70I.M': '15:70I.M             TEXTILES PRODUCTS - REGULATIONS AND ...',
	  '15:714.F': '15:714.F             FALSE STATEMENTS: OVERVALUATION OF S...',
	  '15:714.M': '15:714.M             LARCENY: CONVERSION OF PROPERTY',
	  '15:715B.P': '15:715B.P            INTERSTATE TRANSPORTATION OF CONTRAB...',
	  '15:715D.P': '15:715D.P            RULES AND REGULATIONS: CERTIFICATES ...',
	  '15:715E.P': '15:715E.P            INTERSTATE TRANSPORTATION OF PETROLE...',
	  '15:717B.F': '15:717B.F            EXPORTATION OR IMPORTATION OF NATURA...',
	  '15:717B.P': '15:717B.P            EXPORTATION OR IMPORTATION OF NATURA...',
	  '15:717C.F': '15:717C.F            RATES AND CHARGES: SCHEDULES, SUSPEN...',
	  '15:717C.P': '15:717C.P            RATES AND CHARGES: SCHEDULES, SUSPEN...',
	  '15:717E.F': '15:717E.F            ASCERTAINMENT OF COST OF PROPERTY',
	  '15:717E.P': '15:717E.P            ASCERTAINMENT OF COST OF PROPERTY',
	  '15:717F.F': '15:717F.F            CONSTRUCTION, EXTENSION, OR ABANDONM...',
	  '15:717F.P': '15:717F.P            CONSTRUCTION, EXTENSION, OR ABANDONM...',
	  '15:717G.F': '15:717G.F            ACCOUNTS: RECORDS: MEMORANDA',
	  '15:717G.P': '15:717G.P            ACCOUNTS: RECORDS: MEMORANDA',
	  '15:717H.F': '15:717H.F            RATES OF DEPRECIATION',
	  '15:717H.P': '15:717H.P            RATES OF DEPRECIATION',
	  '15:717I.F': '15:717I.F            PERIODIC AND SPECIAL REPORTS',
	  '15:717I.P': '15:717I.P            PERIODIC AND SPECIAL REPORTS',
	  '15:717J.F': '15:717J.F            STATE COMPACTS: REPORTS ON',
	  '15:717J.P': '15:717J.P            STATE COMPACTS: REPORTS ON',
	  '15:717K.F': '15:717K.F            OFFICIALS DEALING IN SECURITIES',
	  '15:717K.P': '15:717K.P            OFFICIALS DEALING IN SECURITIES',
	  '15:717M.M': '15:717M.M            REFUSAL TO TESTIFY BEFORE FPC',
	  '15:717N.F': '15:717N.F            HEARINGS: RULES OF PROCEDURE',
	  '15:717N.P': '15:717N.P            HEARINGS: RULES OF PROCEDURE',
	  '15:717O.F': '15:717O.F            ADMINISTRATIVE POWERS OF COMMERCE: R...',
	  '15:717O.P': '15:717O.P            ADMINISTRATIVE POWERS OF COMMERCE: R...',
	  '15:717P.F': '15:717P.F            USE OF JOINT BOARDS: COOPERATION W/S...',
	  '15:717P.P': '15:717P.P            USE OF JOINT BOARDS: COOPERATION W/S...',
	  '15:717T.F': '15:717T.F            NATURAL GAS REGULATIONS',
	  '15:717T.P': '15:717T.P            NATURAL GAS REGULATIONS',
	  '15:72.M': '15:72.M              IMPORT OR SELL ARTICLES, EXCLUDES MO...',
	  '15:754.M': '15:754.M             PRODUCTION OR REFINING OF CRUDE OIL',
	  '15:77E.F': '15:77E.F             PROHIBITIONS - INTERSTATE COMMERCE A...',
	  '15:77F.F': '15:77F.F             REGISTRATION AND SIGNING OF SECURITIES',
	  '15:77Q.F': '15:77Q.F             FRAUDULENT INTERSTATE TRANSACTIONS',
	  '15:77X.F': '15:77X.F             SECURITIES VIOLATIONS',
	  '15:77Y.F': '15:77Y.F             SECURITIES VIOLATIONS',
	  '15:78D.F': '15:78D.F             FOREIGN SECURITIES EXCHANGES',
	  '15:78E.F': '15:78E.F             TRANSACTIONS ON UNREGISTERED EXCHANGES',
	  '15:78F.F': '15:78F.F             REGISTRATION OF NATIONAL SECURITIES ...',
	  '15:78F.M': '15:78F.M             SECURITIES EXCHANGE PENALTIES',
	  '15:78G.F': '15:78G.F             MARGIN REQUIREMENTS',
	  '15:78H.F': '15:78H.F             RESTRICTIONS ON BORROWING BY MEMBERS',
	  '15:78I.F': '15:78I.F             MANIPULATION OF SECURITY PRICES',
	  '15:78J.F': '15:78J.F             MANIPULATIVE AND DECEPTIVE DEVICES',
	  '15:78K.F': '15:78K.F             SEGREGATE OR LIMIT OF FUNCTIONS OF M...',
	  '15:78L.F': '15:78L.F             REGISTRATION REQUIREMENTS FOR SECURI...',
	  '15:78M.F': '15:78M.F             PERIODICAL AND OTHER REPORTS',
	  '15:78N.F': '15:78N.F             PROXIES',
	  '15:78O.F': '15:78O.F             OVER-THE-COUNTER MARKETS: REGISTER B...',
	  '15:78P.F': '15:78P.F             DIRECTORS, OFFICERS, AND PRINCIPAL S...',
	  '15:78Q.F': '15:78Q.F             ACCOUNTS AND RECORDS, REPORTS, EXAMI...',
	  '15:78R.F': '15:78R.F             LIABILITY FOR MISLEADING STATEMENTS',
	  '15:78T.F': '15:78T.F             LIABILITIES OF CONTROLLING PERSONS',
	  '15:78X.F': '15:78X.F             INFORMATION FILED WITH THE COMMISSION',
	  '15:78Z.F': '15:78Z.F             UNLAWFUL REPRESENTATIONS',
	  '15:79D.F': '15:79D.F             TRANSACTIONS BY UNREGISTERED HOLDING...',
	  '15:79E.F': '15:79E.F             REGISTRATION OF HOLDING COMPANIES',
	  '15:79F.F': '15:79F.F             UNLAWFUL TRANSACTION BY REGISTERED C...',
	  '15:79I.F': '15:79I.F             ACQUISITION OF SECURITIES AND UTILITY',
	  '15:79J.F': '15:79J.F             APPROVAL OF ACQUISITION OF SECURITIES',
	  '15:79K.F': '15:79K.F             SIMPLIFICATION OF HOLDING COMPANY SY...',
	  '15:79L.F': '15:79L.F             INTERCOMPANY AND OTHER TRANSACTIONS',
	  '15:79M.F': '15:79M.F             SERVICE, SALES AND CONSTRUCTION CONT...',
	  '15:79N.F': '15:79N.F             PERIODIC AND OTHER REPORTS',
	  '15:79O.F': '15:79O.F             ACCOUNTS AND RECORDS',
	  '15:79R.M': '15:79R.M             REFUSAL TO TESTIFY BEFORE SECRETARY',
	  '15:79V.F': '15:79V.F             ACCESS OF PUBLIC TO INFORMATION FILE...',
	  '15:79Z.F': '15:79Z.F             LIABILITY OF CONTROLLING PERSON',
	  '15:8.M': '15:8.M               TRUSTS IN RESTRAINT OF IMPORT TRADE',
	  '15:80A.F': '15:80A.F             AFFILIATIONS OR INTEREST OF DIRECTOR...',
	  '15:80B.F': '15:80B.F             DISCLOSURE OF INFORMATION BY COMMISSION',
	  '15:80B.M': '15:80B.M             REFUSAL TO TESTIFY BEFORE SECURITIES...',
	  '16:114.M': '16:114.M             MESA VERDE NATIONAL PARK - REMOVE, D...',
	  '16:1151.M': '16:1151.M            FUR SEAL MANAGEMENT',
	  '16:1167.P': '16:1167.P            PENALTIES FOR VIOLATIONS - PRIBILOF ...',
	  '16:117.M': '16:117.M             MESA VERDE NATIONAL PARK - HUNTING A...',
	  '16:117.P': '16:117.P             MESA VERDE NATIONAL PARK - HUNTING A...',
	  '16:1171.M': '16:1171.M            CONTRACTS, AGREEMENTS OR LEASES',
	  '16:121.M': '16:121.M             CRATER LAKE NATIONAL PARK - ESTABLIS...',
	  '16:122.M': '16:122.M             CRATER LAKE NATIONAL PARK - ESTABLIS...',
	  '16:123.M': '16:123.M             CRATER LAKE NATIONAL PARK',
	  '16:124.P': '16:124.P             JURISDICTION OF THE U.S. - FUGITIVES...',
	  '16:1246.P': '16:1246.P            NATIONAL TRAILS SYSTEM',
	  '16:127.P': '16:127.P             CRATER LAKE NATIONAL PARK - HUNTING ...',
	  '16:128.P': '16:128.P             HUNTING AND FISHING: FORFEITURE/SEIZ...',
	  '16:1338.M': '16:1338.M            PROTECT WILD, FREE-ROAMING HORSES/BU...',
	  '16:1372.M': '16:1372.M            MARINE MAMMALS',
	  '16:1373.M': '16:1373.M            REGULATIONS ON TAKING OF MARINE MAMMALS',
	  '16:1374.M': '16:1374.M            PERMITS ON TAKING OF MARINE MAMMALS',
	  '16:1375.M': '16:1375.M            PENALTIES',
	  '16:1382.M': '16:1382.M            REGULATIONS AND ADMINISTRATION',
	  '16:146.M': '16:146.M             WIND COVE NATIONAL PARK - OFFENSES',
	  '16:152.P': '16:152.P             PLATT NATIONAL PARK - PENALTIES',
	  '16:1533.M': '16:1533.M            DETERMINATION OF ENDANGERED SPECIES',
	  '16:1538.M': '16:1538.M            PROHIBITED ACTS - ENDANGERED SPECIES',
	  '16:1538.P': '16:1538.P            ENDANGERED SPECIES ACT',
	  '16:1540.M': '16:1540.M            ENDANGERED SPECIES - PENALTIES',
	  '16:163.P': '16:163.P             JURISDICTION BY THE U.S. - FUGITIVES...',
	  '16:170.P': '16:170.P             GLACIER NATIONAL PARK - HUNTING AND ...',
	  '16:171.P': '16:171.P             FORFEITURES AND SEIZURES OF GUNS, TRAPS',
	  '16:1857B.M': '16:1857B.M           FISHING IN U.S. WATERS WITHOUT PERMIT',
	  '16:1857E.F': '16:1857E.F           FORCIBLY ASSAULT, RESIST, IMPEDE OFF...',
	  '16:1857E.M': '16:1857E.M           FORCIBLY ASSAULT, RESIST, IMPEDE OFF...',
	  '16:1857I.P': '16:1857I.P           KNOW&WILLFLLY SUBMIT FALSE INFO ON M...',
	  '16:1859.F': '16:1859.F            AGGRAVATED OR FELONIOUS ASSAULT',
	  '16:1859.M': '16:1859.M            AGGRAVATED OR FELONIOUS ASSAULT',
	  '16:198.P': '16:198.P             ROCKY MOUNTAIN NATIONAL PARK - PENAL...',
	  '16:204.P': '16:204.P             LASSEN VOLCANIC NATIONAL PARK - HUNT...',
	  '16:256B.P': '16:256B.P            OLYMPIC NATIONAL PARK - HUNTING AND ...',
	  '16:256C.P': '16:256C.P            FORFEITURE OF PROPERTY USED IN HUNTI...',
	  '16:26.P': '16:26.P              REGULATIONS FOR HUNTING AND FISHING ...',
	  '16:3.P': '16:3.P               NATIONAL PARK/RECREATION VIOLATIONS',
	  '16:3372.F': '16:3372.F            PROHIBITED ACTS, OTHER THAN MARKING ...',
	  '16:3372.M': '16:3372.M            GAME CONSERVATION ACTS',
	  '16:3373.F': '16:3373.F            IMPORTS/EXPORTS FISH, WILDLIFE OR PL...',
	  '16:3373.M': '16:3373.M            KNOWING FISH, WILDLIFE, PLANTS WERE ...',
	  '16:3374.F': '16:3374.F            CONTROL OF ILLEGALLY TAKEN FISH AND ...',
	  '16:3374.M': '16:3374.M            CONTROL OF ILLEGALLY TAKEN FISH AND ...',
	  '16:354.P': '16:354.P             MT. MCKINLEY NATIONAL PARK',
	  '16:395.P': '16:395.P             HALEAKALA NATIONAL PARK - HUNTING AN...',
	  '16:403C.P': '16:403C.P            SHENANDOAH PARK - HUNTING AND FISHING',
	  '16:403H.P': '16:403H.P            GREAT SMOKEY MOUNTAINS NATIONAL PARK...',
	  '16:404.P': '16:404.P             MAMMOTH CAVE NATIONAL PARK - HUNTING...',
	  '16:408.P': '16:408.P             ISLE ROYALE NATIONAL PARK - HUNTING ...',
	  '16:413.M': '16:413.M             NATIONAL MILITARY PARKS - STRUCTURES...',
	  '16:414.P': '16:414.P             NATIONAL MILITARY PARKS - HUNTING AN...',
	  '16:430H.P': '16:430H.P            VICKSBURG NATIONAL MILITARY PARK',
	  '16:430Q.P': '16:430Q.P            MONOCACY NATIONAL MILITARY PARK - OF...',
	  '16:430V.P': '16:430V.P            KENNESAW MOUNTAIN NATIONAL BATTLEFIE...',
	  '16:433.P': '16:433.P             AMERICAN ANTIQUITIES - INQUIRIES TO',
	  '16:45A.P': '16:45A.P             SEQUOIA NATIONAL PARK: REVISION OF B...',
	  '16:45B.P': '16:45B.P             RULES AND REGULATIONS: LEASES: FISH ...',
	  '16:45C.P': '16:45C.P             PRIOR CLAIMS, LOCATIONS, AND ENTRIES',
	  '16:45D.P': '16:45D.P             EXCLUSIVE PRIVILEGES PROHIBITED',
	  '16:45E.P': '16:45E.P             SEQUOIA NATIONAL PARK',
	  '16:460D.P': '16:460D.P            CONSTRUCTION AND OPERATION OF PUBLIC...',
	  '16:460K.P': '16:460K.P            PUBLIC RECREATION USE OF FISH AND WI...',
	  '16:460N.P': '16:460N.P            PURPOSES AND USES OF AREA',
	  '16:470.F': '16:470.F             ARCHAEOLOGICAL RESOURCE PROTECTION ACT',
	  '16:470.M': '16:470.M             ARCHAEOLOGICAL RESOURCE PROTECTION ACT',
	  '16:4711.F': '16:4711.F            VIOLATION OF NON-INDIGENOUS AQUATIC ...',
	  '16:477.P': '16:477.P             USE OF TIMBER AND STONE BY SETTLERS',
	  '16:478.P': '16:478.P             EGRESS OR INGRESS OF ACTUAL SETTLERS',
	  '16:479.P': '16:479.P             SITES FOR SCHOOLS AND CHURCHES',
	  '16:481.P': '16:481.P             USE OF WATERS',
	  '16:482.P': '16:482.P             MINERAL LANDS: RESTORATION TO PUBLIC...',
	  '16:551.P': '16:551.P             PROTECTION OF NATIONAL FORESTS - RUL...',
	  '16:604.P': '16:604.P             CUTTING TIMBER ON CERTAIN MINERAL LANDS',
	  '16:605.P': '16:605.P             NOTICE OF UNLAWFUL CUTTING',
	  '16:606.P': '16:606.P             CUTTING TIMBER ON CERTAIN MINERAL LANDS',
	  '16:661.M': '16:661.M             DECLARATION OF PURPOSES: COOPERATION...',
	  '16:662.M': '16:662.M             IMPOUNDING, DIVERTING, OR CONTROLLIN...',
	  '16:663.M': '16:663.M             IMPOUNDING, DIVERTING, OR CONTROLLIN...',
	  '16:664.M': '16:664.M             ADMINISTRATION: RULES AND REGULATIONS',
	  '16:665.M': '16:665.M             INVESTIGATIONS AS TO EFFECT OF SEWAGE',
	  '16:666.M': '16:666.M             WILDLIFE PROTECTION - OFFENSES',
	  '16:668A.F': '16:668A.F            USE OF BALD AND GOLDEN EAGLE FOR SCI...',
	  '16:668A.M': '16:668A.M            USE OF BALD AND GOLDEN EAGLE FOR SCI...',
	  '16:668C.M': '16:668C.M            IMPORTATION OF ENDANGERED SPECIES',
	  '16:668C.P': '16:668C.P            REGULATIONS',
	  '16:668D.M': '16:668D.M            NATIONAL WILDLIFE REFUGE SYSTEM',
	  '16:668D.P': '16:668D.P            NATIONAL WILDLIFE REFUGE SYSTEM',
	  '16:671.F': '16:671.F             NATIONAL BISON RANGE',
	  '16:690D.P': '16:690D.P            INJURIES TO PROPERTY: DISTURBANCE OF...',
	  '16:690G.P': '16:690G.P            BEAR PARK MIGRATORY BIRD REFUGE',
	  '16:693.P': '16:693.P             GAME SANCTUARY/REFUGE IN QUACHITA NA...',
	  '16:701.P': '16:701.P             MIGRATORY BIRD LAWS',
	  '16:703.F': '16:703.F             TAKING, KILLING, OR POSSESSING MIGRA...',
	  '16:703.P': '16:703.P             TAKING, KILLING, OR POSSESSING MIGRA...',
	  '16:704.F': '16:704.F             RULES AND REGULATIONS ON MIGRATORY B...',
	  '16:704.M': '16:704.M             RULES AND REGULATIONS ON MIGRATORY B...',
	  '16:704.P': '16:704.P             RULES AND REGULATIONS ON MIGRATORY B...',
	  '16:705.F': '16:705.F             TRANSPORTING OR IMPORTING MIGRATORY ...',
	  '16:705.P': '16:705.P             TRANSPORTING OR IMPORTING MIGRATORY ...',
	  '16:706.F': '16:706.F             ARRESTS AND SEARCH WARRANTS',
	  '16:706.P': '16:706.P             ARRESTS AND SEARCH WARRANTS',
	  '16:707A.P': '16:707A.P            VIOLATIONS AND PENALTIES - FORFEITURES',
	  '16:707B.F': '16:707B.F            VIOLATIONS AND PENALTIES - FORFEITURES',
	  '16:707C.M': '16:707C.M            VIOLATIONS AND PENALTIES - FORFEITURES',
	  '16:708.F': '16:708.F             STATE OR TERRITORY LAWS',
	  '16:708.P': '16:708.P             STATE OR TERRITORY LAWS',
	  '16:711.F': '16:711.F             BREEDING/SALE FOR FOOD',
	  '16:711.P': '16:711.P             BREEDING/SALE FOR FOOD',
	  '16:718A.F': '16:718A.F            HUNTING LICENSE/STAMP FOR MIGRATORY ...',
	  '16:718A.P': '16:718A.P            HUNTING LICENSE/STAMP FOR MIGRATORY ...',
	  '16:718E.F': '16:718E.F            OFFENSES DEFINED',
	  '16:718E.P': '16:718E.P            OFFENSES DEFINED',
	  '16:718G.F': '16:718G.F            PENALTIES',
	  '16:718G.P': '16:718G.P            PENALTIES',
	  '16:725.P': '16:725.P             REGULATIONS, ETC. BY SECRETARY OF TH...',
	  '16:726.P': '16:726.P             ACTS PROHIBITED IN REFUGE: COMMERCIA...',
	  '16:730.P': '16:730.P             PENALTIES',
	  '16:742.M': '16:742.M             PROHIBITION ON AIRBORNE HUNTING',
	  '16:781.P': '16:781.P             TAKING OR CATCHING SPONGES &lt; PRESCRI...',
	  '16:783.P': '16:783.P             PENALTIES - LIABILITY OF VESSELS',
	  '16:811.P': '16:811.P             OPERATION OF NAVIGATION FACILITIES: ...',
	  '16:825.F': '16:825.F             ACCOUNTS AND RECORDS, MAINTAINING',
	  '16:825.P': '16:825.P             ACCOUNTS AND RECORDS, MAINTAINING',
	  '16:825C.F': '16:825C.F            PERIODIC AND SPECIAL REPORTS, MAINTA...',
	  '16:825C.P': '16:825C.P            PERIODIC AND SPECIAL REPORTS, MAINTA...',
	  '16:825D.F': '16:825D.F            OFFICIALS DEALING IN SECURITIES',
	  '16:825D.P': '16:825D.P            OFFICIALS DEALING IN SECURITIES',
	  '16:825F.M': '16:825F.M            INVESTIGATIONS BY COMMISSION: DEPOSI...',
	  '16:825O.F': '16:825O.F            PENALTIES',
	  '16:825O.P': '16:825O.P            PENALTIES',
	  '16:9.P': '16:9.P               GOVERNMENT OF PARKS, ETC.',
	  '16:916C.M': '16:916C.M            ILLEGAL WHALING',
	  '16:916D.M': '16:916D.M            LICENSES',
	  '16:916E.P': '16:916E.P            FAILURE TO KEEP RETURNS, RECORDS, RE...',
	  '16:916F.M': '16:916F.M            VIOLATIONS, FINES AND PENALTIES',
	  '16:957A.M': '16:957A.M            VIOLATION OF TUNA CONVENTIONS - 1ST ...',
	  '16:957B.P': '16:957B.P            VIOLATION OF TUNA CONVENTIONS - 2ND ...',
	  '16:957C.M': '16:957C.M            IMPORTING TUNA ILLEGALLY',
	  '16:957D.M': '16:957D.M            VIOLATIONS, FINES AND FORFEITURES',
	  '16:957E.P': '16:957E.P            VIOLATIONS, FINES AND FORFEITURES',
	  '16:957F.M': '16:957F.M            VIOLATIONS, FINES AND FORFEITURES',
	  '17:104A.M': '17:104A.M            COPYRIGHT - WILLFUL INFRINGEMENT FOR...',
	  '17:104B.F': '17:104B.F            INFRINGEMENT OF COPYRIGHT - 2ND OFFENSE',
	  '17:104B.M': '17:104B.M            INFRINGEMENT OF COPYRIGHT - 1ST OFFENSE',
	  '17:105.P': '17:105.P             FRAUDULENT NOTICE OF COPYRIGHT',
	  '17:1201.F': '17:1201.F            CIRCUMVENTION OF COPYRIGHT PROTECTION',
	  '17:1204.F': '17:1204.F            COPYRIGHT PROTECTION AND MANAGEMENT ...',
	  '17:14.P': '17:14.P              COPYRIGHT - FAILURE TO DEPOSIT',
	  '17:18.P': '17:18.P              MAKING FALSE AFFIDAVIT TO OBTAIN COP...',
	  '17:506A.F': '17:506A.F            CRIMINAL INFRINGEMENT OF A COPYRIGHT',
	  '17:506C.P': '17:506C.P            FRAUDULENT COPYRIGHT NOTICE',
	  '17:506D.P': '17:506D.P            FRAUDULENT REMOVAL OF COPYRIGHT NOTICE',
	  '17:506E.P': '17:506E.P            FALSE REPRESENTATION',
	  '17A:102.F': '17A:102.F            COPYRIGHT LAWS',
	  '17A:102.M': '17A:102.M            COPYRIGHT LAWS',
	  '17A:106.F': '17A:106.F            RIGHTS IN COPYRIGHTED WORKS',
	  '17A:106.M': '17A:106.M            RIGHTS IN COPYRIGHTED WORKS',
	  '17A:506A.F': '17A:506A.F           CRIMINAL INFRINGEMENT ON COPYRIGHTS',
	  '17A:506A.M': '17A:506A.M           CRIMINAL INFRINGEMENT ON COPYRIGHTS',
	  '17A:506C.P': '17A:506C.P           FRAUDULENT COPYRIGHT NOTICES',
	  '17A:506D.P': '17A:506D.P           FRAUDULENT COPYRIGHT NOTICES',
	  '17A:506E.P': '17A:506E.P           FALSE REPRESENTATION OF COPYRIGHTS',
	  182: '182                  test by patty',
	  '18:1001.F': '18:1001.F            STATEMENTS OR ENTRIES GENERALLY',
	  '18:1002.F': '18:1002.F            POSSESS OF FALSE PAPERS TO DEFRAUD U.S.',
	  '18:1003.F': '18:1003.F            DEMANDS AGAINST THE UNITED STATES  (T)',
	  '18:1003.M': '18:1003.M            DEMANDS AGAINST THE UNITED STATES  (T)',
	  '18:1004.F': '18:1004.F            CERTIFICATION OF CHECKS',
	  '18:1005.F': '18:1005.F            BANK ENTRIES, REPORTS AND TRANSACTIONS',
	  '18:1006.F': '18:1006.F            FEDERAL CREDIT INSTITUTION ENTRIES, ...',
	  '18:1007.F': '18:1007.F            FDIC TRANSACTION',
	  '18:1010.F': '18:1010.F            Dept. of HUD and FHA Transactions',
	  '18:1011.M': '18:1011.M            FEDERAL LAND BANK MORTGAGE TRANSACTIONS',
	  '18:1012.M': '18:1012.M            DEPARTMENT OF HUD TRANSACTIONS',
	  '18:1013.M': '18:1013.M            FARM LOAN BONDS AND CREDIT BANK DEBE...',
	  '18:1014.F': '18:1014.F            LOAN AND CREDIT APPLICATIONS GENERALLY',
	  '18:1015.F': '18:1015.F            NATURALIZATION/CITIZENSHIP/ALIEN REG...',
	  '18:1016.F': '18:1016.F            ACKNOWLEDGMENT OF APPEARANCE OR OATH',
	  '18:1017.F': '18:1017.F            GOVERNMENT SEALS/INSTRUMENTS WRONGFU...',
	  '18:1018.M': '18:1018.M            OFFICIAL CERTIFICATES OR WRITINGS',
	  '18:1019.F': '18:1019.F            CERTIFICATES BY CONSULAR OFFICERS',
	  '18:1020.F': '18:1020.F            HIGHWAY PROJECTS',
	  '18:1021.F': '18:1021.F            TITLE RECORDS',
	  '18:1022.F': '18:1022.F            DELIVERY OF CERTIFICATE, VOUCHER, RE...',
	  '18:1023.F': '18:1023.F            INSUFFICIENT DELIVERY OF MONEY/PROPE...',
	  '18:1024.F': '18:1024.F            PURCHASE OR RECEIPT OF MILITARY, NAV...',
	  '18:1025.F': '18:1025.F            FALSE PRETENSES ON HIGH SEAS',
	  '18:1025.M': '18:1025.M            FALSE PRETENSES ON HIGH SEAS',
	  '18:1026.M': '18:1026.M            COMPROMISE, ADJUSTMENT, CANCEL/FARM ...',
	  '18:1027.F': '18:1027.F            FALSE STATEMENTS/CONCEALMENT OF FACT...',
	  '18:1028A.F': '18:1028A.F           FRAUD WITH IDENTIFICATION DOCUMENTS',
	  '18:1028A.M': '18:1028A.M           FRAUD WITH IDENTIFICATION DOCUMENTS',
	  '18:1028B.F': '18:1028B.F           FRAUD WITH IDENTIFICATION DOCUMENTS',
	  '18:1028B.M': '18:1028B.M           FRAUD WITH IDENTIFICATION DOCUMENTS',
	  '18:1029A.F': '18:1029A.F           PRODUCES/TRAFFICS IN COUNTERFEIT DEVICE',
	  '18:1029B.F': '18:1029B.F           ATTEMPTS TO COMMIT AN OFFENSE',
	  '18:1030A.F': '18:1030A.F           FRAUD ACTIVITY CONNECTED WITH COMPUTERS',
	  '18:1030A.M': '18:1030A.M           FRAUD ACTIVITY CONNECTED WITH COMPUTERS',
	  '18:1030B.F': '18:1030B.F           COMPUTER FRAUD',
	  '18:1030B.M': '18:1030B.M           COMPUTER FRAUD',
	  '18:1030B.P': '18:1030B.P           COMPUTER FRAUD',
	  '18:1031.F': '18:1031.F            MAJOR FRAUD AGAINST U. S.',
	  '18:1032.F': '18:1032.F            CONCEAL ASSETS FROM RECEIVER/CONSERV...',
	  '18:1033B.F': '18:1033B.F           INSURANCE CRIMES AFFECTING INTERSTAT...',
	  '18:1033B.M': '18:1033B.M           INSURANCE CRIMES AFFECTING INTERSTAT...',
	  '18:1035.F': '18:1035.F            FALSE STATEMENTS RELATING TO HEALTH ...',
	  '18:1036.F': '18:1036.F            ENTRY BY FALSE PRETENSES TO ANY REAL...',
	  '18:1036.P': '18:1036.P            ENTRY BY FALSE PRETENSES TO ANY REAL...',
	  '18:1037.F': '18:1037.F            FRAUD AND RELATED ACTIVITY IN CONNEC...',
	  '18:1037.M': '18:1037.M            FRAUD AND RELATED ACTIVITY IN CONNEC...',
	  '18:1038.F': '18:1038.F            FALSE INFORMATION AND HOAXES',
	  '18:1039.F': '18:1039.F            FRAUD AND FALSE STATEMENTS - OBTAINI...',
	  '18:1040.F': '18:1040.F            DISASTER ASSISTANCE FRAUD',
	  '18:1071.F': '18:1071.F            CONCEALING PERSON FROM ARREST',
	  '18:1071.M': '18:1071.M            CONCEALING PERSON FROM ARREST',
	  '18:1072.F': '18:1072.F            CONCEALING ESCAPED PRISONER',
	  '18:1073.F': '18:1073.F            FLIGHT TO AVOID PROSECUTION/GIVING T...',
	  '18:1074.F': '18:1074.F            FLIGHT TO AVOID PROSECUTION/DAMAGE, ...',
	  '18:1082A.F': '18:1082A.F           GAMBLING SHIPS',
	  '18:1082B.F': '18:1082B.F           GAMBLING SHIPS',
	  '18:1084.F': '18:1084.F            TRANSMISSION OF WAGERING INFORMATION...',
	  '18:111.F': '18:111.F             ASSAULTING/RESISTING/IMPEDING OFFICE...',
	  '18:1111.F': '18:1111.F            MURDER, FIRST DEGREE',
	  '18:1112.F': '18:1112.F            MANSLAUGHTER, INVOLUNTARY',
	  '18:1112A.F': '18:1112A.F           VOLUNTARY MANSLAUGHTER',
	  '18:1113.F': '18:1113.F            ATTEMPTED MURDER',
	  '18:1114.F': '18:1114.F            PROTECTION OF OFFICERS AND EMPLOYEES...',
	  '18:1115.F': '18:1115.F            MISCONDUCT OR NEGLECT OF SHIP OFFICERS',
	  '18:1116.F': '18:1116.F            MURDER/MANSLAUGHTER OF FOREIGN OFFIC...',
	  '18:1117.F': '18:1117.F            CONSPIRACY TO MURDER',
	  '18:111A.M': '18:111A.M            ASSAULT, RESIST OR IMPEDE OFFICIAL  (T)',
	  '18:1121.F': '18:1121.F            KILLING PERSONS AIDING FEDERAL INVES...',
	  '18:112A.F': '18:112A.F            PROTECTION OF FOREIGN OFFICIAL GUESTS',
	  '18:112B.P': '18:112B.P            PROTECTION OF FOREIGN OFFICIAL GUESTS',
	  '18:112C.P': '18:112C.P            PROTECTION OF FOREIGN OFFICIAL GUESTS',
	  '18:113A.F': '18:113A.F            ASSAULT WITH INTENT TO MURDER  (T)',
	  '18:113B.F': '18:113B.F            ASSAULT WITH INTENT TO COMMIT FE... (T)',
	  '18:113C.F': '18:113C.F            ASSAULT WITHIN MARITIME AND/OR TERRI...',
	  '18:113D.P': '18:113D.P            ASSAULT, OTHER',
	  '18:113E.M': '18:113E.M            SIMPLE ASSAULT WITHIN MARITIME AND T...',
	  '18:113E.P': '18:113E.P            ASSAULT WITHIN SPECIAL MARITIME OR T...',
	  '18:113F.F': '18:113F.F            ASSAULT WITHIN SPECIAL MARITIME OR T...',
	  '18:113G.F': '18:113G.F            ASSAULT RESULTING IN SUBSTANTIAL BOD...',
	  '18:114.F': '18:114.F             MAIMING WITHIN SPECIAL MARITIME OR T...',
	  '18:115.F': '18:115.F             ASSAULT/THREAT TO ASSAULT - FEDERAL ...',
	  '18:115.M': '18:115.M             ASSAULT/THREAT TO ASSAULT - FEDERAL ...',
	  '18:1152.M': '18:1152.M            CURFEW, RESTRICTED AREAS',
	  '18:1153.F': '18:1153.F            BURGLARY/ROBBERY WITHIN INDIAN COUNTRY',
	  '18:1153.M': '18:1153.M            BURGLARY/ROBBERY WITHIN INDIAN COUNTRY',
	  '18:1154.F': '18:1154.F            INTOXICANTS DISPENSED IN INDIAN COUNTRY',
	  '18:1154.M': '18:1154.M            INTOXICANTS DISPENSED IN INDIAN COUNTRY',
	  '18:1155.F': '18:1155.F            INTOXICANTS DISPENSED ON SCHOOL SITE',
	  '18:1156.F': '18:1156.F            INTOXICANTS POSSESSED UNLAWFULLY',
	  '18:1156.M': '18:1156.M            INTOXICANTS POSSESSED UNLAWFULLY',
	  '18:1158.P': '18:1158.P            COUNTERFEITING INDIAN ARTS AND CRAFT...',
	  '18:1159.P': '18:1159.P            MISREPRESENTATION IN SALE OF PRODUCTS',
	  '18:115A.F': '18:115A.F            MURDER - FAMILY OF FEDERAL OFFICIAL',
	  '18:115B.F': '18:115B.F            KIDNAPPING - FAMILY OF FEDERAL OFFICIAL',
	  '18:115C.F': '18:115C.F            ASSAULT - FAMILY OF FEDERAL OFFICIAL',
	  '18:1163.F': '18:1163.F            EMBEZZLEMENT FROM INDIAN TRIBAL ORGA...',
	  '18:1163.M': '18:1163.M            EMBEZZLEMENT FROM INDIAN TRIBAL ORGA...',
	  '18:1164.P': '18:1164.P            DESTROYING BOUNDARY AND WARNING SIGNS',
	  '18:1165.P': '18:1165.P            HUNTING, TRAPPING, FISHING ON INDIAN...',
	  '18:1167A.M': '18:1167A.M           THEFT FROM GAMING ESTABLISHMENTS ON ...',
	  '18:1167B.F': '18:1167B.F           THEFT FROM GAMING ESTABLISHMENTS ON ...',
	  '18:1168A.F': '18:1168A.F           THEFT BY OFF/EMPLOYEE OF GAMING EST....',
	  '18:1168B.F': '18:1168B.F           THEFT BY OFF/EMPLOYEE OF GAMING EST....',
	  '18:117.F': '18:117.F             DOMESTIC ASSAULT - HABITUAL OFFENDER',
	  '18:1170.F': '18:1170.F            ILLEGAL TRAFFICKING - NATIVE AMERICA...',
	  '18:1170.M': '18:1170.M            ILLEGAL TRAFFICKING - NATIVE AMERICA...',
	  '18:1201.F': '18:1201.F            KIDNAPPING',
	  '18:1202.F': '18:1202.F            RANSOM MONEY',
	  '18:1203.F': '18:1203.F            HOSTAGE TAKING',
	  '18:1204.F': '18:1204.F            INTERNATIONAL PARENTAL KIDNAPPING',
	  '18:1231.F': '18:1231.F            BYRNES ACT - TRANSPORTATION OF STRIK...',
	  '18:1262.M': '18:1262.M            TRANSPORTATION INTO STATE PROHIBITIN...',
	  '18:1263.M': '18:1263.M            MARKS AND LABELS ON PACKAGE',
	  '18:1264.M': '18:1264.M            DELIVERY TO CONSIGNEE',
	  '18:1265.M': '18:1265.M            C.O.D. SHIPMENTS PROHIBITED',
	  '18:13-0100.F': '18:13-0100.F         MURDER, FIRST DEGREE',
	  '18:13-0101.F': '18:13-0101.F         MURDER, GOVERNMENT OFFICIALS',
	  '18:13-0200.F': '18:13-0200.F         MURDER, SECOND DEGREE',
	  '18:13-0201.F': '18:13-0201.F         MURDER, 2ND DEGREE, GOVERNMENT OFFIC...',
	  '18:13-0300.F': '18:13-0300.F         MANSLAUGHTER',
	  '18:13-0301.F': '18:13-0301.F         MANSLAUGHTER',
	  '18:13-0310.F': '18:13-0310.F         INVOLUNTARY MANSLAUGHTER',
	  '18:13-0311.F': '18:13-0311.F         NEGLIGENT HOMICIDE',
	  '18:13-1100.F': '18:13-1100.F         ROBBERY, BANK',
	  '18:13-1200.F': '18:13-1200.F         ROBBERY, POSTAL',
	  '18:13-1400.F': '18:13-1400.F         ROBBERY, OTHER',
	  '18:13-1400.M': '18:13-1400.M         ROBBERY, OTHER',
	  '18:13-1500.F': '18:13-1500.F         AGGRAVATED OR FELONIOUS ASSAULT',
	  '18:13-1500.M': '18:13-1500.M         ASSAULT WHILE RESISTING ARREST',
	  '18:13-1500.P': '18:13-1500.P         SIMPLE ASSAULT',
	  '18:13-1501.F': '18:13-1501.F         FELONY, ON GOVERNMENT OFFICIAL',
	  '18:13-1560.F': '18:13-1560.F         FAIR HOUSING LAW',
	  '18:13-1560.M': '18:13-1560.M         FAIR HOUSING LAW',
	  '18:13-1560.P': '18:13-1560.P         FAIR HOUSING LAW',
	  '18:13-1600.M': '18:13-1600.M         ASSAULT, OTHER',
	  '18:13-1600.P': '18:13-1600.P         ASSAULT, OTHER',
	  '18:13-1601.M': '18:13-1601.M         ASSAULT ON GOVERNMENT OFFICIAL',
	  '18:13-1601.P': '18:13-1601.P         ASSAULT ON GOVERNMENT OFFICIAL',
	  '18:13-2100.F': '18:13-2100.F         BURGLARY, BANK',
	  '18:13-2200.F': '18:13-2200.F         BURGLARY, POSTAL',
	  '18:13-2300.F': '18:13-2300.F         INTERSTATE COMMERCE',
	  '18:13-2400.F': '18:13-2400.F         BURGLARY, OTHER',
	  '18:13-2400.M': '18:13-2400.M         BURGLARY, OTHER',
	  '18:13-2400.P': '18:13-2400.P         BURGLARY, OTHER',
	  '18:13-3100.F': '18:13-3100.F         LARCENY AND THEFT, BANK',
	  '18:13-3100.M': '18:13-3100.M         LARCENY AND THEFT, BANK',
	  '18:13-3100.P': '18:13-3100.P         LARCENY AND THEFT, BANK',
	  '18:13-3200.F': '18:13-3200.F         LARCENY AND THEFT, POSTAL',
	  '18:13-3200.M': '18:13-3200.M         LARCENY AND THEFT, POSTAL',
	  '18:13-3300.F': '18:13-3300.F         INTERSTATE COMMERCE',
	  '18:13-3300.M': '18:13-3300.M         INTERSTATE COMMERCE',
	  '18:13-3400.F': '18:13-3400.F         THEFT OF U.S. PROPERTY',
	  '18:13-3400.M': '18:13-3400.M         THEFT OF U.S. PROPERTY',
	  '18:13-3600.F': '18:13-3600.F         TRANSPORTATION OF STOLEN PROPERTY',
	  '18:13-3700.F': '18:13-3700.F         LARCENY AND THEFT, FELONY OTHER',
	  '18:13-3800.M': '18:13-3800.M         LARCENY AND THEFT, MISDEMEANOR OTHER',
	  '18:13-3800.P': '18:13-3800.P         LARCENY AND THEFT, MISDEMEANOR OTHER',
	  '18:13-4100.F': '18:13-4100.F         BANK EMBEZZLEMENT',
	  '18:13-4100.M': '18:13-4100.M         BANK EMBEZZLEMENT',
	  '18:13-4200.F': '18:13-4200.F         POSTAL EMBEZZLEMENT',
	  '18:13-4200.M': '18:13-4200.M         POSTAL EMBEZZLEMENT',
	  '18:13-4310.F': '18:13-4310.F         EMBEZZLES PUBLIC MONEYS OR PROPERTY',
	  '18:13-4310.M': '18:13-4310.M         EMBEZZLES PUBLIC MONEYS OR PROPERTY',
	  '18:13-4310.P': '18:13-4310.P         EMBEZZLES PUBLIC MONEYS OR PROPERTY',
	  '18:13-4320.F': '18:13-4320.F         LENDING, CREDIT, INSURANCE INSTITUTIONS',
	  '18:13-4320.M': '18:13-4320.M         LENDING, CREDIT, INSURANCE INSTITUTIONS',
	  '18:13-4330.F': '18:13-4330.F         EMBEZZLEMENT: BY OFFICERS OF A CARRIER',
	  '18:13-4340.F': '18:13-4340.F         WORLD WAR VETERANS RELIEF',
	  '18:13-4350.F': '18:13-4350.F         EMBEZZLEMENT: OFFICER OR EMPLOYEE OF...',
	  '18:13-4350.M': '18:13-4350.M         EMBEZZLEMENT: OFFICER OR EMPLOYEE OF...',
	  '18:13-4390.F': '18:13-4390.F         EMBEZZLEMENT, OTHER',
	  '18:13-4390.M': '18:13-4390.M         EMBEZZLEMENT, OTHER',
	  '18:13-4510.F': '18:13-4510.F         INCOME TAX, EVADE OR DEFEAT',
	  '18:13-4520.F': '18:13-4520.F         INCOME TAX, OTHER FELONY',
	  '18:13-4520.M': '18:13-4520.M         INCOME TAX, OTHER FELONY',
	  '18:13-4520.P': '18:13-4520.P         INCOME TAX, OTHER FELONY',
	  '18:13-4530.F': '18:13-4530.F         INCOME TAX, FAILURE TO FILE',
	  '18:13-4530.M': '18:13-4530.M         INCOME TAX, FAILURE TO FILE',
	  '18:13-4530.P': '18:13-4530.P         INCOME TAX, FAILURE TO FILE',
	  '18:13-4540.M': '18:13-4540.M         INCOME TAX, OTHER MISDEMEANOR',
	  '18:13-4540.P': '18:13-4540.P         INCOME TAX, OTHER MISDEMEANOR',
	  '18:13-4600.F': '18:13-4600.F         LENDING, CREDIT INSTITUTIONS',
	  '18:13-4600.M': '18:13-4600.M         LENDING, CREDIT INSTITUTIONS',
	  '18:13-4601.F': '18:13-4601.F         BANK FRAUD',
	  '18:13-4700.F': '18:13-4700.F         POSTAL, INTERSTATE WIRE, RADIO, ETC.',
	  '18:13-4700.M': '18:13-4700.M         POSTAL, INTERSTATE WIRE, RADIO, ETC.',
	  '18:13-4700.P': '18:13-4700.P         POSTAL, INTERSTATE WIRE, RADIO, ETC.',
	  '18:13-4800.F': '18:13-4800.F         VETERANS AND ALLOTMENTS',
	  '18:13-4800.M': '18:13-4800.M         VETERANS AND ALLOTMENTS',
	  '18:13-4800.P': '18:13-4800.P         VETERANS AND ALLOTMENTS',
	  '18:13-4900.F': '18:13-4900.F         BANKRUPTCY',
	  '18:13-4900.M': '18:13-4900.M         BANKRUPTCY',
	  '18:13-4900.P': '18:13-4900.P         BANKRUPTCY',
	  '18:13-4910.F': '18:13-4910.F         MARKETING AGREEMENTS AND COMMODITY C...',
	  '18:13-4910.M': '18:13-4910.M         MARKETING AGREEMENTS AND COMMODITY C...',
	  '18:13-4910.P': '18:13-4910.P         MARKETING AGREEMENTS AND COMMODITY C...',
	  '18:13-4920.F': '18:13-4920.F         SECURITIES AND EXCHANGE',
	  '18:13-4920.M': '18:13-4920.M         SECURITIES AND EXCHANGE',
	  '18:13-4931.F': '18:13-4931.F         FRAUD, EXCISE TAX, OTHER',
	  '18:13-4931.M': '18:13-4931.M         FRAUD, EXCISE TAX, OTHER',
	  '18:13-4932.F': '18:13-4932.F         FRAUD, WAGERING TAX, OTHER',
	  '18:13-4933.F': '18:13-4933.F         FRAUD, OTHER TAX',
	  '18:13-4933.M': '18:13-4933.M         FRAUD, OTHER TAX',
	  '18:13-4933.P': '18:13-4933.P         FRAUD, OTHER TAX',
	  '18:13-4940.M': '18:13-4940.M         RAILROAD RETIREMENT AND UNEMPLOYMENT',
	  '18:13-4940.P': '18:13-4940.P         RAILROAD RETIREMENT AND UNEMPLOYMENT',
	  '18:13-4941.F': '18:13-4941.F         FRAUD - FOOD STAMP PROGRAM',
	  '18:13-4941.M': '18:13-4941.M         FRAUD - FOOD STAMP PROGRAM',
	  '18:13-4950.M': '18:13-4950.M         SOCIAL SECURITY',
	  '18:13-4950.P': '18:13-4950.P         SOCIAL SECURITY',
	  '18:13-4960.F': '18:13-4960.F         FALSE IMPERSONATION',
	  '18:13-4960.M': '18:13-4960.M         FALSE IMPERSONATION',
	  '18:13-4960.P': '18:13-4960.P         FALSE IMPERSONATION',
	  '18:13-4970.F': '18:13-4970.F         NATIONALITY LAWS',
	  '18:13-4980.F': '18:13-4980.F         PASSPORT FRAUD',
	  '18:13-4980.M': '18:13-4980.M         PASSPORT FRAUD',
	  '18:13-4980.P': '18:13-4980.P         PASSPORT FRAUD',
	  '18:13-4991.F': '18:13-4991.F         FALSE CLAIMS AND STATEMENTS',
	  '18:13-4991.M': '18:13-4991.M         FALSE CLAIMS AND STATEMENTS',
	  '18:13-4991.P': '18:13-4991.P         FALSE CLAIMS AND STATEMENTS',
	  '18:13-4992.F': '18:13-4992.F         FRAUD, CONSPIRACY TO DEFRAUD, OTHER',
	  '18:13-4993.F': '18:13-4993.F         FRAUD, CONSPIRACY (GENERAL), OTHER',
	  '18:13-4993.M': '18:13-4993.M         FRAUD, CONSPIRACY (GENERAL), OTHER',
	  '18:13-4994.F': '18:13-4994.F         FRAUD, FALSE ENTRIES, OTHER',
	  '18:13-4994.P': '18:13-4994.P         FRAUD, FALSE ENTRIES, OTHER',
	  '18:13-4995.F': '18:13-4995.F         CREDIT CARD FRAUD',
	  '18:13-4996.F': '18:13-4996.F         CREDIT CARD FRAUD',
	  '18:13-4996.M': '18:13-4996.M         COMPUTER FRAUD',
	  '18:13-4999.F': '18:13-4999.F         FRAUD, OTHER',
	  '18:13-4999.M': '18:13-4999.M         FRAUD, OTHER',
	  '18:13-4999.P': '18:13-4999.P         FRAUD, OTHER',
	  '18:13-5100.F': '18:13-5100.F         TRANSPORT, ETC. STOLEN VEHICLES, AIR...',
	  '18:13-5200.F': '18:13-5200.F         AUTO THEFT, OTHER',
	  '18:13-5200.M': '18:13-5200.M         AUTO THEFT, OTHER',
	  '18:13-5500.F': '18:13-5500.F         TRANSPORT FORGED SECURITIES',
	  '18:13-5600.F': '18:13-5600.F         FORGERY, POSTAL',
	  '18:13-5710.F': '18:13-5710.F         FORGERY, OTHER U.S.',
	  '18:13-5710.M': '18:13-5710.M         FORGERY, OTHER U.S.',
	  '18:13-5710.P': '18:13-5710.P         FORGERY, OTHER U.S.',
	  '18:13-5720.F': '18:13-5720.F         FORGERY, OTHER',
	  '18:13-5720.M': '18:13-5720.M         FORGERY, OTHER',
	  '18:13-5720.P': '18:13-5720.P         FORGERY, OTHER',
	  '18:13-5800.F': '18:13-5800.F         COUNTERFEITING',
	  '18:13-5800.M': '18:13-5800.M         COUNTERFEITING',
	  '18:13-5800.P': '18:13-5800.P         COUNTERFEITING',
	  '18:13-6100.F': '18:13-6100.F         SEXUAL ABUSE',
	  '18:13-6100.M': '18:13-6100.M         SEXUAL ABUSE',
	  '18:13-6100.P': '18:13-6100.P         SEXUAL ABUSE',
	  '18:13-6200.F': '18:13-6200.F         WHITE SLAVE AND IMPORTING ALIENS',
	  '18:13-6200.M': '18:13-6200.M         WHITE SLAVE AND IMPORTING ALIENS',
	  '18:13-6300.F': '18:13-6300.F         SEX OFFENSES, OTHER',
	  '18:13-6300.M': '18:13-6300.M         SEX OFFENSES, OTHER',
	  '18:13-6501.F': '18:13-6501.F         MARIJUANA - SELL, DISTRIBUTE ,OR DIS...',
	  '18:13-6501.P': '18:13-6501.P         MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
	  '18:13-6700.F': '18:13-6700.F         NARCOTICS, OTHER',
	  '18:13-6701.F': '18:13-6701.F         NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
	  '18:13-6800.F': '18:13-6800.F         CONTINUING CRIMINAL ENTERPRISE',
	  '18:13-6802.M': '18:13-6802.M         CONTROLLED SUBSTANCE - IMPORTATION/E...',
	  '18:13-6804.F': '18:13-6804.F         CONTROLLED SUBSTANCE - POSSESSION',
	  '18:13-6804.P': '18:13-6804.P         CONTOLLED SUBSTANCE - POSSESSION',
	  '18:13-6805.F': '18:13-6805.F         CONTROLLED SUBSTANCE - RECORDS, RX\'S...',
	  '18:13-6807.F': '18:13-6807.F         ILLICIT DRUG PROFITS',
	  '18:13-6808.F': '18:13-6808.F         CONTROLLED SUBSTANCES ABOARD AIRCRAFT',
	  '18:13-6809.F': '18:13-6809.F         POSSESSION OF DRUG PARAPHERNALIA',
	  '18:13-6809.M': '18:13-6809.M         POSSESSION OF DRUG PARAPHERNALIA',
	  '18:13-6810.F': '18:13-6810.F         UNDER INFLUENCE ALCOHOL/DRUGS',
	  '18:13-6907.F': '18:13-6907.F         ILLICIT DRUG PROFITS',
	  '18:13-6911.F': '18:13-6911.F         OTHER DAPCA OFFENSES',
	  '18:13-7100.F': '18:13-7100.F         BRIBERY',
	  '18:13-7100.M': '18:13-7100.M         BRIBERY',
	  '18:13-7100.P': '18:13-7100.P         BRIBERY',
	  '18:13-7210.F': '18:13-7210.F         TRAFFIC OFFENSES, DRUNKEN DRIVING',
	  '18:13-7210.M': '18:13-7210.M         TRAFFIC OFFENSES, DRUNKEN DRIVING',
	  '18:13-7210.P': '18:13-7210.P         TRAFFIC OFFENSES, DRUNKEN DRIVING',
	  '18:13-7220.F': '18:13-7220.F         TRAFFIC OFFENSES, OTHER',
	  '18:13-7220.M': '18:13-7220.M         TRAFFIC OFFENSES, OTHER',
	  '18:13-7220.P': '18:13-7220.P         TRAFFIC OFFENSES, OTHER',
	  '18:13-7310.F': '18:13-7310.F         ESCAPE',
	  '18:13-7310.M': '18:13-7310.M         ESCAPE',
	  '18:13-7310.P': '18:13-7310.P         ESCAPE',
	  '18:13-7311.F': '18:13-7311.F         ESCAPE, JUMPING BAIL',
	  '18:13-7311.M': '18:13-7311.M         ESCAPE, JUMPING BAIL',
	  '18:13-7320.F': '18:13-7320.F         ESCAPE, AIDING OR HARBORING',
	  '18:13-7320.M': '18:13-7320.M         ESCAPE, AIDING OR HARBORING',
	  '18:13-7400.F': '18:13-7400.F         EXTORTION, RACKETEERING, AND THREATS',
	  '18:13-7400.M': '18:13-7400.M         EXTORTION, RACKETEERING, AND THREATS',
	  '18:13-7400.P': '18:13-7400.P         EXTORTION, RACKETEERING, AND THREATS',
	  '18:13-7401.F': '18:13-7401.F         THREATS AGAINST THE PRESIDENT',
	  '18:13-7410.F': '18:13-7410.F         RACKETEERING, ARSON',
	  '18:13-7420.F': '18:13-7420.F         RACKETEERING, BRIBERY',
	  '18:13-7420.P': '18:13-7420.P         RACKETEERING, BRIBERY',
	  '18:13-7430.F': '18:13-7430.F         RACKETEERING, EXTORTION',
	  '18:13-7440.F': '18:13-7440.F         RACKETEERING, GAMBLING',
	  '18:13-7450.F': '18:13-7450.F         RACKETEERING, LIQUOR',
	  '18:13-7460.F': '18:13-7460.F         RACKETEERING, NARCOTICS',
	  '18:13-7470.F': '18:13-7470.F         RACKETEERING, PROSTITUTION',
	  '18:13-7471.F': '18:13-7471.F         RACKETEERING, MURDER',
	  '18:13-7472.F': '18:13-7472.F         RACKETEERING, KIDNAP',
	  '18:13-7473.F': '18:13-7473.F         RACKETEERING, MAIM',
	  '18:13-7474.F': '18:13-7474.F         RACKETEERING, CONSPIRACY, MURDER, KI...',
	  '18:13-7475.F': '18:13-7475.F         RACKETEERING, ATTEMPT/CONSPIRE TO MA...',
	  '18:13-7477.F': '18:13-7477.F         RACKETEERING, MONEY LAUNDERING',
	  '18:13-7478.F': '18:13-7478.F         RACKETEERING, MURDER, FIRST DEGREE',
	  '18:13-7480.F': '18:13-7480.F         RACKETEERING, OTHER',
	  '18:13-7481.F': '18:13-7481.F         RACKETEERING, ROBBERY',
	  '18:13-7482.F': '18:13-7482.F         RACKETEERING, THREATS',
	  '18:13-7490.F': '18:13-7490.F         RACKETEERING, EXTORTION, CREDIT TRAN...',
	  '18:13-7500.F': '18:13-7500.F         GAMBLING AND LOTTERY',
	  '18:13-7500.M': '18:13-7500.M         GAMBLING AND LOTTERY',
	  '18:13-7520.F': '18:13-7520.F         GAMBLING AND LOTTERY, TRAVEL/RACKETE...',
	  '18:13-7530.F': '18:13-7530.F         GAMBLING AND LOTTERY, TRANSMIT WAGER...',
	  '18:13-7530.M': '18:13-7530.M         GAMBLING AND LOTTERY, TRANSMIT WAGER...',
	  '18:13-7600.F': '18:13-7600.F         KIDNAPPING, INTERSTATE AND FOREIGN L...',
	  '18:13-7601.F': '18:13-7601.F         KIDNAPPING, GOVERNMENT OFFICIALS',
	  '18:13-7610.F': '18:13-7610.F         KIDNAPPING, LAWS OF STATES',
	  '18:13-7611.F': '18:13-7611.F         KIDNAP, HOSTAGE',
	  '18:13-7700.F': '18:13-7700.F         PERJURY',
	  '18:13-7800.F': '18:13-7800.F         FIREARMS AND WEAPONS',
	  '18:13-7800.M': '18:13-7800.M         FIREARMS AND WEAPONS',
	  '18:13-7800.P': '18:13-7800.P         FIREARMS AND WEAPONS',
	  '18:13-7820.F': '18:13-7820.F         FIREARMS, UNLAWFUL POSSESSION',
	  '18:13-7820.M': '18:13-7820.M         FIREARMS, UNLAWFUL POSSESSION',
	  '18:13-7830.F': '18:13-7830.F         FIREARMS',
	  '18:13-7830.M': '18:13-7830.M         FIREARMS',
	  '18:13-7910.F': '18:13-7910.F         ARSON',
	  '18:13-7910.M': '18:13-7910.M         ARSON',
	  '18:13-7930.F': '18:13-7930.F         BIGAMY',
	  '18:13-7940.F': '18:13-7940.F         MALICIOUS DESTRUCTION OF PROPERTY',
	  '18:13-7940.M': '18:13-7940.M         MALICIOUS DESTRUCTION OF PROPERTY',
	  '18:13-7940.P': '18:13-7940.P         MALICIOUS DESTRUCTION OF PROPERTY',
	  '18:13-7950.F': '18:13-7950.F         DISORDERLY CONDUCT',
	  '18:13-7950.P': '18:13-7950.P         DISORDERLY CONDUCT',
	  '18:13-7961.F': '18:13-7961.F         TRAVEL TO INCITE TO RIOT',
	  '18:13-7962.F': '18:13-7962.F         CIVIL DISORDER',
	  '18:13-7962.P': '18:13-7962.P         CIVIL DISORDER',
	  '18:13-7990.F': '18:13-7990.F         MISCELLANEOUS GENERAL OFFENSES, OTHER',
	  '18:13-7990.M': '18:13-7990.M         MISCELLANEOUS GENERAL OFFENSES, OTHER',
	  '18:13-7990.P': '18:13-7990.P         MISCELLANEOUS GENERAL OFFENSES, OTHER',
	  '18:13-8710.P': '18:13-8710.P         IMMIGRATION LAWS, ILLEGAL ENTRY',
	  '18:13-8720.F': '18:13-8720.F         IMMIGRATION LAWS, ILLEGAL REENTRY',
	  '18:13-8730.F': '18:13-8730.F         IMMIGRATION LAWS, OTHER',
	  '18:13-8730.M': '18:13-8730.M         IMMIGRATION LAWS, OTHER',
	  '18:13-8730.P': '18:13-8730.P         IMMIGRATION LAWS, OTHER',
	  '18:13-8740.F': '18:13-8740.F         IMMIGRATION LAWS, ILLEGAL ENTRY',
	  '18:13-8750.F': '18:13-8750.F         IMMIGRATION LAWS, FRAUDULENT CITIZEN...',
	  '18:13-8900.F': '18:13-8900.F         LIQUOR, INTERNAL REVENUE',
	  '18:13-8900.M': '18:13-8900.M         LIQUOR, INTERNAL REVENUE',
	  '18:13-9001.F': '18:13-9001.F         HAZARDOUS WASTE-TREATMENT/DISPOSAL/S...',
	  '18:13-9110.F': '18:13-9110.F         AGRICULTURE ACTS',
	  '18:13-9110.M': '18:13-9110.M         AGRICULTURE ACTS',
	  '18:13-9110.P': '18:13-9110.P         AGRICULTURE ACTS',
	  '18:13-9120.P': '18:13-9120.P         AGRICULTURE, FEDERAL SEED ACT',
	  '18:13-9130.F': '18:13-9130.F         GAME CONSERVATION ACTS',
	  '18:13-9130.M': '18:13-9130.M         GAME CONSERVATION ACTS',
	  '18:13-9130.P': '18:13-9130.P         GAME CONSERVATION ACTS',
	  '18:13-9140.F': '18:13-9140.F         AGRICULTURE, INSECTICIDE ACT',
	  '18:13-9140.M': '18:13-9140.M         AGRICULTURE, INSECTICIDE ACT',
	  '18:13-9140.P': '18:13-9140.P         AGRICULTURE, INSECTICIDE ACT',
	  '18:13-9150.F': '18:13-9150.F         NATIONAL PARK/RECREATION VIOLATIONS',
	  '18:13-9150.M': '18:13-9150.M         NATIONAL PARK/RECREATION VIOLATIONS',
	  '18:13-9150.P': '18:13-9150.P         NATIONAL PARK/RECREATION VIOLATIONS',
	  '18:13-9160.F': '18:13-9160.F         AGRICULTURE, PACKERS AND STOCKYARD ACT',
	  '18:13-9160.M': '18:13-9160.M         AGRICULTURE, PACKERS AND STOCKYARD ACT',
	  '18:13-9160.P': '18:13-9160.P         AGRICULTURE, PACKERS AND STOCKYARD ACT',
	  '18:13-9170.M': '18:13-9170.M         AGRICULTURE, PLANT QUARANTINE',
	  '18:13-9170.P': '18:13-9170.P         AGRICULTURE, PLANT QUARANTINE',
	  '18:13-9200.F': '18:13-9200.F         ANTITRUST VIOLATIONS',
	  '18:13-9200.M': '18:13-9200.M         ANTITRUST VIOLATIONS',
	  '18:13-9300.F': '18:13-9300.F         FAIR LABOR STANDARDS ACT',
	  '18:13-9300.M': '18:13-9300.M         FAIR LABOR STANDARDS ACT',
	  '18:13-9400.F': '18:13-9400.F         FOOD AND DRUG ACT',
	  '18:13-9400.M': '18:13-9400.M         FOOD AND DRUG ACT',
	  '18:13-9400.P': '18:13-9400.P         FOOD AND DRUG ACT',
	  '18:13-9500.F': '18:13-9500.F         MIGRATORY BIRD LAWS',
	  '18:13-9500.P': '18:13-9500.P         MIGRATORY BIRD LAWS',
	  '18:13-9600.F': '18:13-9600.F         MOTOR CARRIER ACT',
	  '18:13-9600.M': '18:13-9600.M         MOTOR CARRIER ACT',
	  '18:13-9600.P': '18:13-9600.P         MOTOR CARRIER ACT',
	  '18:13-9730.M': '18:13-9730.M         NATIONAL DEFENSE, DEFENSE PRODUCTION...',
	  '18:13-9731.M': '18:13-9731.M         ECONOMIC STABILIZATION ACT OF 1970 -...',
	  '18:13-9732.M': '18:13-9732.M         ECONOMIC STABILIZATION ACT OF 1970 -...',
	  '18:13-9733.M': '18:13-9733.M         ECONOMIC STABILIZATION ACT OF 1970 -...',
	  '18:13-9740.F': '18:13-9740.F         ALIEN REGISTRATION',
	  '18:13-9740.P': '18:13-9740.P         ALIEN REGISTRATION',
	  '18:13-9741.F': '18:13-9741.F         ENERGY FACILITY',
	  '18:13-9751.F': '18:13-9751.F         TREASON',
	  '18:13-9752.F': '18:13-9752.F         ESPIONAGE',
	  '18:13-9752.M': '18:13-9752.M         ESPIONAGE',
	  '18:13-9753.F': '18:13-9753.F         SABOTAGE',
	  '18:13-9753.M': '18:13-9753.M         SABOTAGE',
	  '18:13-9753.P': '18:13-9753.P         SABOTAGE',
	  '18:13-9754.F': '18:13-9754.F         SEDITION',
	  '18:13-9755.F': '18:13-9755.F         SMITH ACT',
	  '18:13-9760.F': '18:13-9760.F         CURFEW, RESTRICTED AREAS',
	  '18:13-9760.P': '18:13-9760.P         CURFEW, RESTRICTED AREAS',
	  '18:13-9770.F': '18:13-9770.F         EXPORTATION OF WAR MATERIALS',
	  '18:13-9770.M': '18:13-9770.M         EXPORTATION OF WAR MATERIALS',
	  '18:13-9771.F': '18:13-9771.F         ANTI-APARTHEID PROGRAM',
	  '18:13-9771.M': '18:13-9771.M         ANTI-APARTHEID PROGRAM',
	  '18:13-9790.F': '18:13-9790.F         NATIONAL DEFENSE, OTHER',
	  '18:13-9790.M': '18:13-9790.M         NATIONAL DEFENSE, OTHER',
	  '18:13-9790.P': '18:13-9790.P         NATIONAL DEFENSE, OTHER',
	  '18:13-9792.M': '18:13-9792.M         DEFENSE CONTRACTORS',
	  '18:13-9810.F': '18:13-9810.F         OBSCENE MAIL',
	  '18:13-9810.M': '18:13-9810.M         OBSCENE MAIL',
	  '18:13-9810.P': '18:13-9810.P         OBSCENE MAIL',
	  '18:13-9820.F': '18:13-9820.F         OBSCENE MATTER IN INTERSTATE COMMERCE',
	  '18:13-9901.F': '18:13-9901.F         CIVIL RIGHTS',
	  '18:13-9901.M': '18:13-9901.M         CIVIL RIGHTS',
	  '18:13-9901.P': '18:13-9901.P         CIVIL RIGHTS',
	  '18:13-9902.F': '18:13-9902.F         ELECTION LAW VIOLATORS',
	  '18:13-9902.M': '18:13-9902.M         ELECTION LAW VIOLATORS',
	  '18:13-9907.M': '18:13-9907.M         NOT REPORTING TRANSPORTATION OF CURR...',
	  '18:13-9910.F': '18:13-9910.F         COMMUNICATION ACTS  (T)',
	  '18:13-9910.M': '18:13-9910.M         COMMUNICATION ACTS  (T)',
	  '18:13-9910.P': '18:13-9910.P         COMMUNICATION ACTS  (T)',
	  '18:13-9911.F': '18:13-9911.F         WIRE INTERCEPTION',
	  '18:13-9921.M': '18:13-9921.M         CONTEMPT',
	  '18:13-9923.F': '18:13-9923.F         FORFEITURE, CRIMINAL OR DRUG RELATED',
	  '18:13-9931.F': '18:13-9931.F         CUSTOMS LAWS  (T)',
	  '18:13-9931.M': '18:13-9931.M         CUSTOMS LAWS  (T)',
	  '18:13-9931.P': '18:13-9931.P         CUSTOMS LAWS  (T)',
	  '18:13-9952.F': '18:13-9952.F         TAFT-HARTLEY ACT',
	  '18:13-9952.M': '18:13-9952.M         TAFT-HARTLEY ACT',
	  '18:13-9954.F': '18:13-9954.F         PEONAGE',
	  '18:13-9971.F': '18:13-9971.F         MARITIME AND SHIPPING LAWS',
	  '18:13-9971.M': '18:13-9971.M         MARITIME AND SHIPPING LAWS',
	  '18:13-9971.P': '18:13-9971.P         MARITIME AND SHIPPING LAWS',
	  '18:13-9972.M': '18:13-9972.M         STOWAWAYS',
	  '18:13-9972.P': '18:13-9972.P         STOWAWAYS',
	  '18:13-9973.M': '18:13-9973.M         FEDERAL BOAT SAFETY ACT OF 1971',
	  '18:13-9981.F': '18:13-9981.F         POSTAL, NON-MAILABLE MATERIAL',
	  '18:13-9981.M': '18:13-9981.M         POSTAL, NON-MAILABLE MATERIAL',
	  '18:13-9981.P': '18:13-9981.P         POSTAL, NON-MAILABLE MATERIAL',
	  '18:13-9982.F': '18:13-9982.F         POSTAL, INJURY TO PROPERTY',
	  '18:13-9983.P': '18:13-9983.P         POSTAL, OBSTRUCTING THE MAIL',
	  '18:13-9984.F': '18:13-9984.F         POSTAL, VIOLATIONS BY POSTAL EMPLOYEES',
	  '18:13-9984.M': '18:13-9984.M         POSTAL, VIOLATIONS BY POSTAL EMPLOYEES',
	  '18:13-9984.P': '18:13-9984.P         POSTAL, VIOLATIONS BY POSTAL EMPLOYEES',
	  '18:13-9989.F': '18:13-9989.F         POSTAL, OTHER',
	  '18:13-9989.M': '18:13-9989.M         POSTAL, OTHER',
	  '18:13-9989.P': '18:13-9989.P         POSTAL, OTHER',
	  '18:13-9991.F': '18:13-9991.F         DESTROYING FEDERAL PROPERTY',
	  '18:13-9991.M': '18:13-9991.M         DESTROYING FEDERAL PROPERTY',
	  '18:13-9991.P': '18:13-9991.P         DESTROYING FEDERAL PROPERTY',
	  '18:13-9992.F': '18:13-9992.F         INTIMIDATION OF WITNESSES, JURORS, ETC.',
	  '18:13-9992.M': '18:13-9992.M         INTIMIDATION OF WITNESSES, JURORS, ETC.',
	  '18:13-9992.P': '18:13-9992.P         INTIMIDATION OF WITNESSES, JURORS, ETC.',
	  '18:13-9993.F': '18:13-9993.F         AIRCRAFT REGULATIONS',
	  '18:13-9993.M': '18:13-9993.M         AIRCRAFT REGULATIONS',
	  '18:13-9993.P': '18:13-9993.P         AIRCRAFT REGULATIONS',
	  '18:13-9994.F': '18:13-9994.F         EXPLOSIVES  (T)',
	  '18:13-9994.M': '18:13-9994.M         EXPLOSIVES  (T)',
	  '18:13-9994.P': '18:13-9994.P         EXPLOSIVES  (T)',
	  '18:13-9995.F': '18:13-9995.F         GOLD ACTS',
	  '18:13-9996.F': '18:13-9996.F         TRAIN WRECKING',
	  '18:13-9999.F': '18:13-9999.F         FEDERAL STATUTES, OTHER',
	  '18:13-9999.M': '18:13-9999.M         FEDERAL STATUTES, OTHER',
	  '18:13-9999.P': '18:13-9999.P         FEDERAL STATUTES, OTHER',
	  '18:1301.F': '18:1301.F            IMPORTING OR TRANSPORTING LOTTERY TI...',
	  '18:1302.F': '18:1302.F            MAILING LOTTERY TICKETS/RELATED MATTER',
	  '18:1303.M': '18:1303.M            POSTMASTER OR EMPLOYEE AS LOTTERY AGENT',
	  '18:1304.M': '18:1304.M            BROADCASTING LOTTERY INFORMATION',
	  '18:1306.M': '18:1306.M            LOTTERY - PARTICIPATION BY FINANCIAL...',
	  '18:1341.F': '18:1341.F            FRAUDS AND SWINDLES',
	  '18:1342.F': '18:1342.F            FICTITIOUS NAME OR ADDRESS',
	  '18:1343.F': '18:1343.F            FRAUD BY WIRE, RADIO, OR TELEVISION',
	  '18:1344A.F': '18:1344A.F           BANK FRAUD',
	  '18:1347.F': '18:1347.F            HEALTH CARE FRAUD',
	  '18:1348.F': '18:1348.F            SECURITIES FRAUD',
	  '18:1349.F': '18:1349.F            ATTEMPT AND CONSPIRACY TO COMMIT MAI...',
	  '18:1350.F': '18:1350.F            FAILURE OF CORPORATE OFFICERS TO CER...',
	  '18:1351.F': '18:1351.F            FRAUD IN FOREIGN LABOR CONTRACTING',
	  '18:1361.F': '18:1361.F            GOVERNMENT PROPERTY OR CONTRACTS &gt; $100',
	  '18:1361.M': '18:1361.M            GOVERNMENT PROPERTY OR CONTRACTS &lt;= ...',
	  '18:1362.F': '18:1362.F            COMMUNICATION LINES, STATIONS OR SYS...',
	  '18:1363.F': '18:1363.F            BUILDINGS, PROPERTY, WITHIN SPECIAL ...',
	  '18:1364.F': '18:1364.F            INTERFERE WITH FOREIGN COMMERCE BY V...',
	  '18:1365A.F': '18:1365A.F           ATTEMPT TO TAMPER WITH CONSUMER PRODUCT',
	  '18:1365B.F': '18:1365B.F           TAINT CONSUMER PRODUCT/CAUSE COMMERC...',
	  '18:1365C.F': '18:1365C.F           COMMUNICATES FALSE CONSUMER PRODUCT ...',
	  '18:1365D.F': '18:1365D.F           THREATEN TO TAMPER WITH CONSUMER PRO...',
	  '18:1365E.F': '18:1365E.F           CONSPIRACY/ATTEMPT TO TAMPER WITH CO...',
	  '18:1366A.F': '18:1366A.F           DESTRUCTION OF AN ENERGY FACILITY &gt; ...',
	  '18:1366B.F': '18:1366B.F           DESTRUCTION OF AN ENERGY FACILITY &lt; ...',
	  '18:1367.F': '18:1367.F            INTERFERENCE WITH OPERATION OF SATEL...',
	  '18:1369.F': '18:1369.F            MALICIOUS MISCHIEF - DESTRUCTION OF ...',
	  '18:1381.F': '18:1381.F            ENTICING DESERTION AND HARBORING DES...',
	  '18:1382.P': '18:1382.P            ENTERING MILITARY/NAVAL/COAST GUARD ...',
	  '18:1384.M': '18:1384.M            PROSTITUTION NEAR MILITARY AND NAVAL...',
	  '18:1385.F': '18:1385.F            USE ARMY AND AIR FORCE AS POSSE COMI...',
	  '18:1421.F': '18:1421.F            ACCOUNTS OF COURT OFFICERS',
	  '18:1422.F': '18:1422.F            FEES IN NATURALIZATION PROCEEDINGS',
	  '18:1423.F': '18:1423.F            MISUSE OF EVIDENCE OF CITIZENSHIP/NA...',
	  '18:1424.F': '18:1424.F            IMPERSONATION/MISUSE OF PAPERS IN NA...',
	  '18:1425.F': '18:1425.F            PROCUREMENT OF CITIZENSHIP OR NATURA...',
	  '18:1426.F': '18:1426.F            REPRODUCTION OF NATURALIZATION OR CI...',
	  '18:1427.F': '18:1427.F            SALE OF NATURALIZATION OR CITIZENSHI...',
	  '18:1428.F': '18:1428.F            SURRENDER OF CANCELED NATURALIZATION...',
	  '18:1429.F': '18:1429.F            PENALTIES FOR NEGLECT/REFUSAL ANSWER...',
	  '18:1460.F': '18:1460.F            POSSESS W/INTENT TO SELL OBSCENE MAT...',
	  '18:1461.F': '18:1461.F            MAILING OBSCENE OR CRIME-INCITING MA...',
	  '18:1462.F': '18:1462.F            IMPORT OR TRANSPORT OBSCENE MATTER',
	  '18:1463.F': '18:1463.F            MAILING INDECENT MATTER ON WRAPPERS/...',
	  '18:1464.F': '18:1464.F            BROADCASTING OBSCENE LANGUAGE',
	  '18:1465.F': '18:1465.F            TRANSPORTATION OF OBSCENE MATTER FOR...',
	  '18:1466.F': '18:1466.F            SELLING/TRANSFERRING OBSCENE MATTER',
	  '18:1467.F': '18:1467.F            CRIMINAL FORFEITURE',
	  '18:1470.F': '18:1470.F            TRANSFER OF OBSCENE MATERIALS TO MINORS',
	  '18:1470.P': '18:1470.P            TRANSFER OF OBSCENE MATERIALS TO MINORS',
	  '18:1501.M': '18:1501.M            ASSAULT ON PROCESS SERVER',
	  '18:1502.M': '18:1502.M            RESISTANCE TO EXTRADITION AGENT',
	  '18:1503.F': '18:1503.F            INFLUENCE/INJURING OFFICER/JUROR/WIT...',
	  '18:1504.P': '18:1504.P            INFLUENCING JUROR BY WRITING',
	  '18:1505.F': '18:1505.F            OBSTRUCTION OF PROCEEDING BEFORE DEP...',
	  '18:1506.F': '18:1506.F            THEFT OR ALTERATION OF RECORD OR PRO...',
	  '18:1507.M': '18:1507.M            PICKETING OR PARADING',
	  '18:1508.M': '18:1508.M            RECORD/LISTEN TO/OBSERVE GRAND JURY ...',
	  '18:1509.M': '18:1509.M            OBSTRUCTION OF COURT ORDERS',
	  '18:1510.F': '18:1510.F            OBSTRUCTION OF CRIMINAL INVESTIGATIONS',
	  '18:1510.M': '18:1510.M            OBSTRUCTION OF CRIMINAL INVESTIGATIONS',
	  '18:1511.F': '18:1511.F            INTIMIDATION OF WITNESSES, JURORS, ETC.',
	  '18:1512A.F': '18:1512A.F           TAMPER W/WITNESS, VICTIM, INFORM... (T)',
	  '18:1512A1.F': '18:1512A1.F          TAMPER W/WITNESS, VICTIM, INFORM... (T)',
	  '18:1512B.F': '18:1512B.F           INTIMIDATION OR FORCE AGAINST WITNESS',
	  '18:1512C.F': '18:1512C.F           TAMPERING WITH A WITNESS, VICTIM OR ...',
	  '18:1512C.M': '18:1512C.M           HARASSMENT OF A WITNESS',
	  '18:1512K.F': '18:1512K.F           TAMPERING WITH A WITNESS, VICTIM OR ...',
	  '18:1513.F': '18:1513.F            RETALIATING AGAINST WITNESS, VICTIM',
	  '18:1516.F': '18:1516.F            INFLUENCE/OBSTRUCT/IMPEDE/FEDERAL AU...',
	  '18:1517.F': '18:1517.F            OBSTRUCTION OF JUSTICE - INTERFERENCE',
	  '18:1518.F': '18:1518.F            OBSTRUCT CRIMINAL INVESTIGATIONS OF ...',
	  '18:1519.F': '18:1519.F            DESTRUCTION,ALTERNATION,FALSIFICATIO...',
	  '18:152.F': '18:152.F             CONCEAL ASSETS, FALSE OATH AND CLAIM...',
	  '18:1521.F': '18:1521.F            RETALIATION AGAINST A FEDERAL JUDGE ...',
	  '18:153.F': '18:153.F             EMBEZZLEMENT BY TRUSTEE, RECEIVERS O...',
	  '18:154.P': '18:154.P             ADVERSE INTEREST AND CONDUCT OF TRUS...',
	  '18:1541.M': '18:1541.M            ISSUANCE WITHOUT AUTHORITY',
	  '18:1542.F': '18:1542.F            FALSE STATEMENT IN APPLICATION/USE O...',
	  '18:1543.F': '18:1543.F            FORGERY OR FALSE USE OF PASSPORT',
	  '18:1544.F': '18:1544.F            MISUSE OF PASSPORT',
	  '18:1545.F': '18:1545.F            SAFE CONDUCT VIOLATION',
	  '18:1546.F': '18:1546.F            FRAUD AND MISUSE OF VISAS/PERMITS',
	  '18:155.M': '18:155.M             FEE AGREEMENTS IN BANKRUPTCY PROCEED...',
	  '18:157.F': '18:157.F             BANKRUPTCY FRAUD',
	  '18:1581.F': '18:1581.F            PEONAGE: OBSTRUCTING ENFORCEMENT',
	  '18:1582.F': '18:1582.F            VESSELS FOR SLAVE TRADE',
	  '18:1583.F': '18:1583.F            ENTICEMENT INTO SLAVERY',
	  '18:1584.F': '18:1584.F            SALE INTO INVOLUNTARY SERVITUDE',
	  '18:1585.F': '18:1585.F            SEIZURE, DETENTION, TRANSPORTATION O...',
	  '18:1586.F': '18:1586.F            SERVICE ON VESSELS IN SLAVE TRADE',
	  '18:1587.F': '18:1587.F            POSSESSION OF SLAVES ABOARD VESSEL',
	  '18:1588.F': '18:1588.F            TRANSPORTATION OF SLAVES FROM U.S.',
	  '18:1589.F': '18:1589.F            FORCED LABOR',
	  '18:1590.F': '18:1590.F            TRAFFICKING WITH RESPECT TO PEONAGE,...',
	  '18:1591.F': '18:1591.F            SEX TRAFFICKING OF CHILDREN OR BY FO...',
	  '18:1592.F': '18:1592.F            UNLAWFUL CONDUCT W/RESPECT TO DOCS F...',
	  '18:1594.F': '18:1594.F            FORFEITURE',
	  '18:1621.F': '18:1621.F            PERJURY GENERALLY',
	  '18:1622.F': '18:1622.F            SUBORNATION OF PERJURY',
	  '18:1623.F': '18:1623.F            FALSE DECLARATIONS BEFORE GRAND JURY...',
	  '18:1651.F': '18:1651.F            PIRACY UNDER LAW OF NATIONS',
	  '18:1652.F': '18:1652.F            CITIZENS AS PIRATES',
	  '18:1653.F': '18:1653.F            ALIENS AS PIRATES',
	  '18:1654.F': '18:1654.F            ARMING OR SERVING ON PRIVATEERS',
	  '18:1655.F': '18:1655.F            ASSAULT ON COMMANDER AS PIRACY',
	  '18:1656.F': '18:1656.F            CONVERSION OR SURRENDER OF VESSEL',
	  '18:1657.F': '18:1657.F            CORRUPTION OF SEAMEN - CONFEDERATING...',
	  '18:1658.F': '18:1658.F            PLUNDER OF DISTRESSED VESSEL',
	  '18:1659.F': '18:1659.F            ATTACK TO PLUNDER VESSEL',
	  '18:1660.F': '18:1660.F            RECEIPT OF PIRATE PROPERTY',
	  '18:1661.F': '18:1661.F            ROBBERY ASHORE',
	  '18:1693.P': '18:1693.P            CARRIAGE OF MAIL GENERALLY',
	  '18:1694.P': '18:1694.P            CARRIAGE OF MATTER OUT-MAIL OVER POS...',
	  '18:1695.P': '18:1695.P            CARRIAGE OF MATTER OUT-MAIL ON VESSEL',
	  '18:1696A.P': '18:1696A.P           PRIVATE EXPRESS FOR LETTERS AND PACKETS',
	  '18:1696B.P': '18:1696B.P           PRIVATE EXPRESS FOR LETTERS AND PACKETS',
	  '18:1697.P': '18:1697.P            TRANSPORTATION OF PERSONS ACTING AS ...',
	  '18:1698.P': '18:1698.P            PROMPT DELIVERY OF MAIL FROM VESSEL',
	  '18:1699.P': '18:1699.P            CERTIFICATION OF DELIVERY FROM VESSEL',
	  '18:1700.M': '18:1700.M            DESERTION OF MAILS',
	  '18:1701.P': '18:1701.P            OBSTRUCTION OF MAILS GENERALLY',
	  '18:1702.F': '18:1702.F            OBSTRUCTION OF CORRESPONDENCE',
	  '18:1703A.F': '18:1703A.F           DELAY OR DESTRUCTION OF MAIL OR NEWS...',
	  '18:1703B.M': '18:1703B.M           DELAY OR DESTRUCTION OF MAIL OR NEWS...',
	  '18:1704.F': '18:1704.F            KEYS OR LOCKS STOLEN OR REPRODUCED',
	  '18:1705.F': '18:1705.F            DESTRUCTION OF LETTER BOXES OR MAIL',
	  '18:1706.F': '18:1706.F            INJURY TO MAIL BAGS',
	  '18:1707.F': '18:1707.F            THEFT OF PROPERTY USED BY POSTAL SER...',
	  '18:1707.M': '18:1707.M            THEFT OF PROPERTY USED BY POSTAL SER...',
	  '18:1708.F': '18:1708.F            THEFT OR RECEIPT OF STOLEN MAIL MATTER',
	  '18:1709.F': '18:1709.F            THEFT OF MAIL MATTER BY OFFICER OR E...',
	  '18:1710.M': '18:1710.M            THEFT OF NEWSPAPERS',
	  '18:1711.F': '18:1711.F            MISAPPROPRIATION OF POSTAL FUNDS &gt; $100',
	  '18:1711.M': '18:1711.M            MISAPPROPRIATION OF POSTAL FUNDS &lt; $100',
	  '18:1712.F': '18:1712.F            FALSIFICATION OF POSTAL RETURNS TO I...',
	  '18:1713.P': '18:1713.P            ISSUANCE OF MONEY ORDERS WITHOUT PAY...',
	  '18:1715.F': '18:1715.F            FIREARMS AS NON-MAILABLE: REGULATIONS',
	  '18:1716.F': '18:1716.F            INJURIOUS ARTICLE AS NON-MAILABLE  (T)',
	  '18:1716.M': '18:1716.M            NON-MAILABLE MOTOR VEHICLE MASTER KEYS',
	  '18:1717.F': '18:1717.F            LETTERS AND WRITINGS - NON-MAILABLE:...',
	  '18:1719.P': '18:1719.P            FRANKING PRIVILEGE',
	  '18:1720.F': '18:1720.F            VIOLATIONS BY POSTAL EMPLOYEES',
	  '18:1720.M': '18:1720.M            CANCELED STAMPS AND ENVELOPES',
	  '18:1721.M': '18:1721.M            SALE OR PLEDGE OF STAMPS',
	  '18:1722.P': '18:1722.P            FALSE EVIDENCE TO SECURE 2ND-CLASS RATE',
	  '18:1723.P': '18:1723.P            AVOIDANCE OF POSTAGE - USING LOWER C...',
	  '18:1725.P': '18:1725.P            POSTAGE UNPAID ON DEPOSITED MAIL MATTER',
	  '18:1726.P': '18:1726.P            POSTAGE COLLECTED UNLAWFULLY',
	  '18:1728.F': '18:1728.F            WEIGHT OF MAIL INCREASED FRAUDULENTLY',
	  '18:1729.P': '18:1729.P            POST OFFICE CONDUCTED WITHOUT AUTHORITY',
	  '18:1730.P': '18:1730.P            UNIFORMS OF CARRIERS',
	  '18:1731.P': '18:1731.P            VEHICLES FALSELY LABELED AS CARRIERS',
	  '18:1732.M': '18:1732.M            APPROVAL OF BOND OR SURETIES BY POST...',
	  '18:1733.M': '18:1733.M            MAIL PERIODICAL PUBLICATIONS WITHOUT...',
	  '18:1734.P': '18:1734.P            EDITORIALS AND OTHER MATTER AS ADVER...',
	  '18:1735.F': '18:1735.F            SEXUALLY ORIENTED ADVERTISEMENTS',
	  '18:1737.F': '18:1737.F            MANUFACTURE SEXUALLY RELATED MAIL MA...',
	  '18:1738.M': '18:1738.M            MAILING ID DOCUMENTS WITHOUT A DISCL...',
	  '18:175.F': '18:175.F             PROHIBITIONS WITH RESPECT TO BIOLOGI...',
	  '18:1751A.F': '18:1751A.F           PRESIDENTIAL ASSASSINATION',
	  '18:1751B.F': '18:1751B.F           PRESIDENTIAL KIDNAPPING',
	  '18:1751C.F': '18:1751C.F           ATTEMPT TO KILL OR KIDNAP GOVERNMENT...',
	  '18:1751E.F': '18:1751E.F           ASSAULT ON PRESIDENT',
	  '18:1752.P': '18:1752.P            TEMPORARY RESIDENCE OF THE PRESIDENT',
	  '18:1761.M': '18:1761.M            PRISON-MADE-GOODS - TRANSPORTATION O...',
	  '18:1762.P': '18:1762.P            MARKING PACKAGES - CONVICT GOODS',
	  '18:1791A.F': '18:1791A.F           TRAFFIC IN CONTRABAND ARTICLES - FIR...',
	  '18:1791A.M': '18:1791A.M           CONTRABAND IN PRISON - CURRENCY',
	  '18:1791A.P': '18:1791A.P           CONTRABAND IN PRISON - OTHER ITEMS',
	  '18:1791B.F': '18:1791B.F           CONTRABAND IN PRISON - MARIJUANA',
	  '18:1791C.F': '18:1791C.F           TRAFFIC IN CONTRABAND ARTICLES',
	  '18:1791C.M': '18:1791C.M           CONTRABAND IN PRISON - CONTROLLED SU...',
	  '18:1791C.P': '18:1791C.P           CONTRABAND IN PRISON - ANY OTHER OBJECT',
	  '18:1791D.F': '18:1791D.F           CONTRABAND IN PRISON - NARCOTIC DRUG',
	  '18:1792.F': '18:1792.F            MUTINY/RIOT IN PRISON',
	  '18:1793.P': '18:1793.P            TRESPASS ON PRISON LANDS/RESERVATIONS',
	  '18:1801.M': '18:1801.M            VIDEO VOYEURISM',
	  '18:1821.M': '18:1821.M            TRANSPORTATION OF DENTURES',
	  '18:1831.F': '18:1831.F            ECONOMIC ESPIONAGE',
	  '18:1832.F': '18:1832.F            THEFT OF TRADE SECRETS',
	  '18:1841.F': '18:1841.F            PROTECTION OF UNBORN CHILDREN',
	  '18:1851.M': '18:1851.M            COAL DEPREDATIONS - PUBLIC LANDS',
	  '18:1852.M': '18:1852.M            TIMBER REMOVED OR TRANSPORTED',
	  '18:1853.M': '18:1853.M            TREES CUT OR INJURED',
	  '18:1854.M': '18:1854.M            TREES BOXED FOR PITCH OR TURPENTINE',
	  '18:1855.F': '18:1855.F            TIMBER SET AFIRE',
	  '18:1856.P': '18:1856.P            FIRES LEFT UNATTENDED AND UN-EXTINGU...',
	  '18:1857.M': '18:1857.M            FENCES DESTROYED: LIVESTOCK ENTERING',
	  '18:1858.P': '18:1858.P            SURVEY MARKS DESTROYED OR REMOVED',
	  '18:1859.F': '18:1859.F            SURVEYS INTERRUPTED',
	  '18:1860.M': '18:1860.M            BIDS AT LAND SALES',
	  '18:1861.M': '18:1861.M            DECEPTION OF PROSPECTIVE PURCHASERS',
	  '18:1863.P': '18:1863.P            TRESPASS ON NATIONAL FOREST LANDS',
	  '18:1864.M': '18:1864.M            HAZARDOUS OR INJURIOUS DEVICES ON FE...',
	  '18:1864B.F': '18:1864B.F           HAZARDOUS/INJURIOUS DEVICE - DEATH R...',
	  '18:1864C.F': '18:1864C.F           HAZARDOUS/INJURIOUS DEVICE - DEA... (T)',
	  '18:1901.M': '18:1901.M            COLLECTOR/DISBURSING OFFICER TRADING...',
	  '18:1902.F': '18:1902.F            DISCLOSURE OF CROP INFORMATION AND S...',
	  '18:1903.F': '18:1903.F            SPECULATION IN STOCKS OR COMMODITIES...',
	  '18:1904.F': '18:1904.F            DISCLOSE INFORMATION/SPECULATE IN SE...',
	  '18:1905.M': '18:1905.M            DISCLOSURE OF CONFIDENTIAL INFORMATI...',
	  '18:1906.M': '18:1906.M            DISCLOSURE OF INFORMATION BY BANK EX...',
	  '18:1907.M': '18:1907.M            DISCLOSURE OF INFORMATION BY FARM CR...',
	  '18:1908.M': '18:1908.M            DISCLOSURE OF INFORMATION BY NACC EX...',
	  '18:1909.M': '18:1909.M            EXAMINER PERFORMING OTHER SERVICES',
	  '18:1910.F': '18:1910.F            NEPOTISM IN APPOINTMENT OF RECEIVER/...',
	  '18:1911.M': '18:1911.M            RECEIVER MISMANAGING PROPERTY',
	  '18:1912.P': '18:1912.P            UNAUTHORIZED FEES FOR INSPECTION OF ...',
	  '18:1913.M': '18:1913.M            LOBBYING WITH APPROPRIATED MONEYS',
	  '18:1915.F': '18:1915.F            COMPROMISE OF CUSTOMS LIABILITIES',
	  '18:1916.M': '18:1916.M            UNAUTHORIZED EMPLOYMENT/DISPOSITION ...',
	  '18:1917.M': '18:1917.M            INTERFERENCE WITH CIVIL SERVICE EXAMS',
	  '18:1918.F': '18:1918.F            DISLOYALTY AND STRIKING AGAINST THE ...',
	  '18:1919.M': '18:1919.M            FALSE STATEMENT TO OBTAIN UNEMPLOYME...',
	  '18:1919.F': '18:1919.M            FALSE STATEMENTS TO OBTAIN FEDERAL E...',
	  '18:1920.F': '18:1920.F            FRAUD TO GAIN FEDERAL EMPLOYEE COMPE...',
	  '18:1920.M': '18:1920.M            FALSE STATEMENT TO OBTAIN FEDERAL EM...',
	  '18:1921.M': '18:1921.M            RECEIVING FEDERAL EMPLOYEE COMPENSAT...',
	  '18:1922.M': '18:1922.M            FALSE OR WITHHELD REPORT - FEDERAL E...',
	  '18:1923.M': '18:1923.M            FRAUDULENT RECEIPT OF PAYMENTS OF MI...',
	  '18:1924.M': '18:1924.M            UNAUTHORIZED REMOVAL/RETENTION OF CL...',
	  '18:1951.F': '18:1951.F            INTERFERENCE WITH COMMERCE BY THREAT...',
	  '18:1952-7400.F': '18:1952-7400.F       RACKETEERING - TRANSPORTING IN AID OF',
	  '18:1952-7410.F': '18:1952-7410.F       RACKETEERING - ARSON',
	  '18:1952-7420.F': '18:1952-7420.F       RACKETEERING - BRIBERY',
	  '18:1952-7430.F': '18:1952-7430.F       RACKETEERING - EXTORTION',
	  '18:1952-7440.F': '18:1952-7440.F       RACKETEERING - GAMBLING',
	  '18:1952-7450.F': '18:1952-7450.F       RACKETEERING - LIQUOR',
	  '18:1952-7460.F': '18:1952-7460.F       RACKETEERING - NARCOTICS',
	  '18:1952-7470.F': '18:1952-7470.F       RACKETEERING - PROSTITUTION',
	  '18:1952-7471.F': '18:1952-7471.F       RACKETEERING - MURDER',
	  '18:1952-7472.F': '18:1952-7472.F       RACKETEERING - KIDNAP',
	  '18:1952-7473.F': '18:1952-7473.F       RACKETEERING - MAIM',
	  '18:1952-7474.F': '18:1952-7474.F       RACKETEERING - CONSPIRACY, MURDER, K...',
	  '18:1952-7475.F': '18:1952-7475.F       RACKETEERING - ATTEMPT/CONSPIRE TO M...',
	  '18:1952-7480.F': '18:1952-7480.F       RACKETEERING - OTHER',
	  '18:1952-7482.F': '18:1952-7482.F       RACKETEERING - THREATS',
	  '18:1952-7490.F': '18:1952-7490.F       RACKETEERING - EXTORTION CREDIT TRAN...',
	  '18:1953.F': '18:1953.F            INTERSTATE TRANSPORT OF WAGERING PAR...',
	  '18:1954.F': '18:1954.F            EMPLOYEE BENEFITS - FRAUD',
	  '18:1955.F': '18:1955.F            ILLEGAL GAMBLING',
	  '18:1956-0100.F': '18:1956-0100.F       MONEY LAUNDERING - MURDER',
	  '18:1956-0200.F': '18:1956-0200.F       MONEY LAUNDERING - MURDER, SECOND DE...',
	  '18:1956-1100.F': '18:1956-1100.F       MONEY LAUNDERING - ROBBERY, BANK',
	  '18:1956-1200.F': '18:1956-1200.F       MONEY LAUNDERING - ROBBERY, POSTAL',
	  '18:1956-3100.F': '18:1956-3100.F       MONEY LAUNDERING - LARCENY AND THEFT...',
	  '18:1956-3200.F': '18:1956-3200.F       MONEY LAUNDERING - LARCENY AND THEFT...',
	  '18:1956-3300.F': '18:1956-3300.F       MONEY LAUNDERING - INTERSTATE COMMERCE',
	  '18:1956-3600.F': '18:1956-3600.F       MONEY LAUNDERING - TRANSPORTATION OF...',
	  '18:1956-4100.F': '18:1956-4100.F       MONEY LAUNDERING - BANK EMBEZZLEMENT',
	  '18:1956-4310.F': '18:1956-4310.F       MONEY LAUNDERING - EMBEZZLES PUBLIC ...',
	  '18:1956-4390.F': '18:1956-4390.F       MONEY LAUNDERING - EMBEZZLEMENT, OTHER',
	  '18:1956-4601.F': '18:1956-4601.F       MONEY LAUNDERING - BANK FRAUD',
	  '18:1956-4700.F': '18:1956-4700.F       MONEY LAUNDERING - POSTAL, INTERSTAT...',
	  '18:1956-4900.F': '18:1956-4900.F       MONEY LAUNDERING - BANKRUPTCY',
	  '18:1956-4999.F': '18:1956-4999.F       MONEY LAUNDERING - FRAUD, OTHER',
	  '18:1956-5100.F': '18:1956-5100.F       MONEY LAUNDERING - TRANSPORT, ETC. S...',
	  '18:1956-5800.F': '18:1956-5800.F       MONEY LAUNDERING - COUNTERFEITING',
	  '18:1956-6200.F': '18:1956-6200.F       MONEY LAUNDERING - WHITE SLAVE AND I...',
	  '18:1956-6501.F': '18:1956-6501.F       MARIJUANA - SELL, DISTRIBUTE OR DISP...',
	  '18:1956-6502.F': '18:1956-6502.F       MARIJUANA - IMPORTATION/EXPORTATION',
	  '18:1956-6503.F': '18:1956-6503.F       MARIJUANA - MANUFACTURE',
	  '18:1956-6701.F': '18:1956-6701.F       NARCOTICS - SELL, DISTRIBUTE OR DISP...',
	  '18:1956-6702.F': '18:1956-6702.F       NARCOTICS - IMPORTATION/EXPORTATION',
	  '18:1956-6703.F': '18:1956-6703.F       NARCOTICS - MANUFACTURE',
	  '18:1956-6800.F': '18:1956-6800.F       MONEY LAUNDERING - CONTINUING CRIMIN...',
	  '18:1956-6801.F': '18:1956-6801.F       MONEY LAUNDERING - CONTROLLED SUBSTA...',
	  '18:1956-6802.F': '18:1956-6802.F       MONEY LAUNDERING - CONTROLLED SUBSTA...',
	  '18:1956-6803.F': '18:1956-6803.F       MONEY LAUNDERING - CONTROLLED SUBSTA...',
	  '18:1956-7100.F': '18:1956-7100.F       MONEY LAUNDERING - BRIBERY',
	  '18:1956-7400.F': '18:1956-7400.F       MONEY LAUNDERING - EXTORTION, RACKET...',
	  '18:1956-7477.F': '18:1956-7477.F       LAUNDERING OF MONETARY INSTRUMENTS',
	  '18:1956-7480.F': '18:1956-7480.F       MONEY LAUNDERING - RACKETEERING',
	  '18:1956-7481.F': '18:1956-7481.F       MONEY LAUNDERING - RACKETEERING - RO...',
	  '18:1956-7482.F': '18:1956-7482.F       MONEY LAUNDERING - RACKETEERING - TH...',
	  '18:1956-7490.F': '18:1956-7490.F       MONEY LAUNDERING - RACKETEERING -  E...',
	  '18:1956-7530.F': '18:1956-7530.F       MONEY LAUNDERING - GAMBLING/LOTTERY:...',
	  '18:1956-7600.F': '18:1956-7600.F       MONEY LAUNDERING - KIDNAPPING, FEDER...',
	  '18:1956-7611.F': '18:1956-7611.F       MONEY LAUNDERING - KIDNAP, HOSTAGE',
	  '18:1956-9752.F': '18:1956-9752.F       MONEY LAUNDERING - ESPIONAGE',
	  '18:1956-9780.F': '18:1956-9780.F       MONEY LAUNDERING - ENEMIES OF THE U.S.',
	  '18:1956-9790.F': '18:1956-9790.F       MONEY LAUNDERING - NATIONAL DEFENSE,...',
	  '18:1956-9810.F': '18:1956-9810.F       MONEY LAUNDERING - OBSCENE MAIL',
	  '18:1956-9820.F': '18:1956-9820.F       MONEY LAUNDERING - OBSCENE MATTER IN...',
	  '18:1956-9931.F': '18:1956-9931.F       MONEY LAUNDERING - CUSTOMS LAWS  (T)',
	  '18:1956-9992.F': '18:1956-9992.F       MONEY LAUNDERING - INTIMIDATION OF W...',
	  '18:1956-9999.F': '18:1956-9999.F       MONEY LAUNDERING - FEDERAL STATUTES,...',
	  '18:1957-0100.F': '18:1957-0100.F       MURDER, FIRST DEGREE',
	  '18:1957-0200.F': '18:1957-0200.F       MURDER, SECOND DEGREE',
	  '18:1957-1100.F': '18:1957-1100.F       ROBBERY, BANK',
	  '18:1957-1200.F': '18:1957-1200.F       ROBBERY, POSTAL',
	  '18:1957-3100.F': '18:1957-3100.F       LARCENY AND THEFT, BANK',
	  '18:1957-3200.F': '18:1957-3200.F       LARCENY AND THEFT, POSTAL',
	  '18:1957-3300.F': '18:1957-3300.F       INTERSTATE COMMERCE',
	  '18:1957-3600.F': '18:1957-3600.F       TRANSPORTATION OF STOLEN PROPERTY',
	  '18:1957-4100.F': '18:1957-4100.F       BANK EMBEZZLEMENT',
	  '18:1957-4310.F': '18:1957-4310.F       EMBEZZLES PUBLIC MONEYS OR PROPERTY',
	  '18:1957-4390.F': '18:1957-4390.F       EMBEZZLEMENT, OTHER',
	  '18:1957-4601.F': '18:1957-4601.F       BANK FRAUD',
	  '18:1957-4700.F': '18:1957-4700.F       POSTAL, INTERSTATE WIRE, RADIO, ETC.',
	  '18:1957-4900.F': '18:1957-4900.F       BANKRUPTCY',
	  '18:1957-4999.F': '18:1957-4999.F       FRAUD, OTHER',
	  '18:1957-5100.F': '18:1957-5100.F       TRANSPORT, ETC. STOLEN VEHICLES, AIR...',
	  '18:1957-5800.F': '18:1957-5800.F       ENGAGING IN MONETARY TRANSACTIONS',
	  '18:1957-6200.F': '18:1957-6200.F       WHITE SLAVE AND IMPORTING ALIENS',
	  '18:1957-6701.F': '18:1957-6701.F       NARCOTIC-SELL, DISTRIBUTE OR DISPENSE',
	  '18:1957-6800.F': '18:1957-6800.F       CONTINUING CRIMINAL ENTERPRISE',
	  '18:1957-6801.F': '18:1957-6801.F       CONTROLLED SUBSTANCE - SELL, DISTRIB...',
	  '18:1957-6802.F': '18:1957-6802.F       CONTROLLED SUBSTANCE - IMPORTATION/E...',
	  '18:1957-6803.F': '18:1957-6803.F       CONTROLLED SUBSTANCE - MANUFACTURE',
	  '18:1957-7100.F': '18:1957-7100.F       BRIBERY',
	  '18:1957-7400.F': '18:1957-7400.F       EXTORTION, RACKETEERING, AND THREATS',
	  '18:1957-7420.F': '18:1957-7420.F       RACKETEERING - BRIBERY',
	  '18:1957-7430.F': '18:1957-7430.F       ENGAGING IN MONETARY TRANSACTIONS',
	  '18:1957-7440.F': '18:1957-7440.F       RACKETEERING - GAMBLING',
	  '18:1957-7450.F': '18:1957-7450.F       RACKETEERING - LIQUOR',
	  '18:1957-7460.F': '18:1957-7460.F       RACKETEERING - NARCOTICS',
	  '18:1957-7470.F': '18:1957-7470.F       RACKETEERING - PROSTITUTION',
	  '18:1957-7480.F': '18:1957-7480.F       RACKETEERING',
	  '18:1957-7481.F': '18:1957-7481.F       RACKETEERING - ROBBERY',
	  '18:1957-7482.F': '18:1957-7482.F       ENGAGING IN MONETARY TRANSACTIONS',
	  '18:1957-7490.F': '18:1957-7490.F       RACKETEERING - EXTORTION, CREDIT TRA...',
	  '18:1957-7530.F': '18:1957-7530.F       GAMBLING AND LOTTERY, TRANSMIT WAGER...',
	  '18:1957-7600.F': '18:1957-7600.F       ENGAGING IN MONETARY TRANSACTIONS',
	  '18:1957-7611.F': '18:1957-7611.F       ENGAGING IN MONETARY TRANSACTIONS',
	  '18:1957-9752.F': '18:1957-9752.F       ENGAGING IN MONETARY INSTRUMENTS',
	  '18:1957-9780.F': '18:1957-9780.F       ENGAGING IN MONETARY TRANSACTIONS',
	  '18:1957-9790.F': '18:1957-9790.F       NATIONAL DEFENSE, OTHER',
	  '18:1957-9810.F': '18:1957-9810.F       ENGAGING IN MONETARY TRANSACTIONS',
	  '18:1957-9820.F': '18:1957-9820.F       ENGAGING IN MONETARY TRANSACTIONS',
	  '18:1957-9931.F': '18:1957-9931.F       CUSTOMS LAWS  (T)',
	  '18:1957-9992.F': '18:1957-9992.F       ENGAGING IN MONETARY TRANSACTIONS',
	  '18:1957-9999.F': '18:1957-9999.F       FEDERAL STATUTES, OTHER',
	  '18:1958-7471.F': '18:1958-7471.F       RACKETEERING - MURDER',
	  '18:1959-0100.F': '18:1959-0100.F       MURDER, FIRST DEGREE',
	  '18:1959-1500.F': '18:1959-1500.F       AGGRAVATED OR FELONIOUS ASSAULT',
	  '18:1959-1600.F': '18:1959-1600.F       ASSAULT, OTHER',
	  '18:1959-7400.F': '18:1959-7400.F       THREATENING TO COMMIT CRIME OF VIOLENCE',
	  '18:1959-7471.F': '18:1959-7471.F       RACKETEERING ACTIVITY, MURDER/KIDNAP...',
	  '18:1959-7473.F': '18:1959-7473.F       RACKETEERING ACTIVITY, MAIMING',
	  '18:1959-7474.F': '18:1959-7474.F       CONSPIRACY, MURDER, KIDNAP',
	  '18:1959-7475.F': '18:1959-7475.F       ATTEMPT/CONSPIRE TO MAIM/ASSAULT',
	  '18:1959-7482.F': '18:1959-7482.F       RACKETEERING - THREATS',
	  '18:1960.F': '18:1960.F            MONETARY LAUNDERING',
	  '18:1962-0100.F': '18:1962-0100.F       MURDER, FIRST DEGREE',
	  '18:1962-0200.F': '18:1962-0200.F       MURDER, SECOND DEGREE',
	  '18:1962-3300.F': '18:1962-3300.F       INTERSTATE COMMERCE',
	  '18:1962-3600.F': '18:1962-3600.F       TRANSPORTATION OF STOLEN PROPERTY',
	  '18:1962-4390.F': '18:1962-4390.F       EMBEZZLEMENT, OTHER',
	  '18:1962-4700.F': '18:1962-4700.F       POSTAL, INTERSTATE WIRE, RADIO, ETC.',
	  '18:1962-4900.F': '18:1962-4900.F       BANKRUPTCY',
	  '18:1962-4995.F': '18:1962-4995.F       CREDIT CARD FRAUD',
	  '18:1962-4999.F': '18:1962-4999.F       FRAUD, OTHER',
	  '18:1962-5100.F': '18:1962-5100.F       TRANSPORT, ETC., STOLEN VEHICLES, AI...',
	  '18:1962-5800.F': '18:1962-5800.F       RECEIVED INCOME DERIVED FROM RICO',
	  '18:1962-6100.F': '18:1962-6100.F       CHILD PORNOGRAPHY/OBSCENITY',
	  '18:1962-6200.F': '18:1962-6200.F       WHITE SLAVE AND IMPORTING ALIENS',
	  '18:1962-6800.F': '18:1962-6800.F       CONTINUING CRIMINAL ENTERPRISE',
	  '18:1962-7100.F': '18:1962-7100.F       BRIBERY',
	  '18:1962-7400.F': '18:1962-7400.F       EXTORTION, RACKETEERING, AND THREATS',
	  '18:1962-7420.F': '18:1962-7420.F       RACKETEERING - BRIBERY',
	  '18:1962-7430.F': '18:1962-7430.F       RACKETEERING - EXTORTION',
	  '18:1962-7440.F': '18:1962-7440.F       RACKETEERING - GAMBLING',
	  '18:1962-7450.F': '18:1962-7450.F       RACKETEERING - LIQUOR',
	  '18:1962-7460.F': '18:1962-7460.F       RACKETEERING - NARCOTICS',
	  '18:1962-7470.F': '18:1962-7470.F       RACKETEERING - PROSTITUTION',
	  '18:1962-7471.F': '18:1962-7471.F       RACKETEERING - MURDER',
	  '18:1962-7480.F': '18:1962-7480.F       RACKETEERING',
	  '18:1962-7481.F': '18:1962-7481.F       RACKETEERING - ROBBERY',
	  '18:1962-7482.F': '18:1962-7482.F       RACKETEERING - THREATS',
	  '18:1962-7490.F': '18:1962-7490.F       RACKETEERING - EXTORTION, CREDIT TRA...',
	  '18:1962-7530.F': '18:1962-7530.F       GAMBLING AND LOTTERY, TRANSMIT WAGER...',
	  '18:1962-7600.F': '18:1962-7600.F       KIDNAPPING  (T)',
	  '18:1962-9810.F': '18:1962-9810.F       RICO - OBSCENE MAIL',
	  '18:1962-9820.F': '18:1962-9820.F       OBSCENE MATTER IN INTERSTATE COMMERCE',
	  '18:1962-9992.F': '18:1962-9992.F       INTIMIDATION OF WITNESSES, JURORS, ETC.',
	  '18:1962-9999.F': '18:1962-9999.F       FEDERAL STATUTES, OTHER',
	  '18:1963.F': '18:1963.F            PENALTIES - CORRUPT ORGANIZATIONS',
	  '18:1991.F': '18:1991.F            ROBBERY, TRAIN, MURDER',
	  '18:1991.M': '18:1991.M            ROBBERY, TRAIN, ASSAULT',
	  '18:1992.F': '18:1992.F            TRAIN WRECKING',
	  '18:1993A.F': '18:1993A.F           TERRORISTS ATTACKS & OTHER ACTS OF V...',
	  '18:1993A.M': '18:1993A.M           TERRORISTS ATTACKS AND OTHER ACTS OF...',
	  '18:1993B.F': '18:1993B.F           TERRORISTS ATTACKS & OTHER ACTS OF V...',
	  '18:1993B.M': '18:1993B.M           TERRORISTS ATTACKS AND OTHER ACTS OF...',
	  '18:201A.F': '18:201A.F            BRIBERY OF PUBLIC OFFICIALS AND WITN...',
	  '18:201B.F': '18:201B.F            GRAFT AND CONFLICT OF INTEREST',
	  '18:201C.F': '18:201C.F            BRIBERY OF PUBLIC OFFICIALS AND WITN...',
	  '18:203A.F': '18:203A.F            COMPENSATE MEMBERS OF CONGRESS/GOVER...',
	  '18:203A.M': '18:203A.M            COMPENSATE MEMBERS OF CONGRESS/GOVER...',
	  '18:203B.F': '18:203B.F            COMPENSATE MEMBERS OF CONGRESS/GOVER...',
	  '18:203B.M': '18:203B.M            COMPENSATE MEMBERS OF CONGRESS/GOVER...',
	  '18:204.F': '18:204.F             GRAFT AND CONFLICT OF INTEREST - BRI...',
	  '18:205.F': '18:205.F             BRIBERY/GRAFT - CLAIMS AGAINST THE G...',
	  '18:2071A.F': '18:2071A.F           CONCEALMENT, REMOVAL, OR MUTILATION ...',
	  '18:2071B.F': '18:2071B.F           CONCEALMENT, REMOVAL, OR MUTILATION ...',
	  '18:2072.F': '18:2072.F            FALSE CROP REPORTS',
	  '18:2073.F': '18:2073.F            FALSE ENTRIES AND REPORTS',
	  '18:2074.P': '18:2074.P            FALSE WEATHER REPORTS',
	  '18:2075.P': '18:2075.P            OFFICER FAILING TO MAKE RETURNS OR R...',
	  '18:2076.M': '18:2076.M            FAILURE OF CLERK OF COURT TO REPORT',
	  '18:207A.M': '18:207A.M            DISQUALIFY FORMER OFFICER/EMPLOYEE',
	  '18:207B.F': '18:207B.F            DISQUALIFY IN MATTER RELATING TO FOR...',
	  '18:207C.F': '18:207C.F            GRAFT AND CONFLICT OF INTEREST - BRI...',
	  '18:208.F': '18:208.F             ACTS AFFECTING PERSONAL FINANCIAL IN...',
	  '18:208.M': '18:208.M             ACTS AFFECTING A PERSONAL FINANCIAL ...',
	  '18:209.F': '18:209.F             SALARY OF GOVERNMENT EMPLOYEE PYABLE...',
	  '18:209.M': '18:209.M             SALARY OF GOVERNMENT EMPLOYEE PAYABL...',
	  '18:210.M': '18:210.M             OFFER TO PROCURE APPOINTIVE PUBLIC O...',
	  '18:2101.F': '18:2101.F            TRAVEL TO INCITE RIOTS',
	  '18:211.M': '18:211.M             ACCEPT OR SOLICIT TO OBTAIN APPOINTI...',
	  '18:2111.F': '18:2111.F            MARITIME - ROBBERY',
	  '18:2112.F': '18:2112.F            MARITIME - BURGLARY',
	  '18:2113A.F': '18:2113A.F           BANK ROBBERY BY FORCE OR VIOLENCE',
	  '18:2113B.F': '18:2113B.F           ROBBERY OF PROPERTY OR MONEY &gt; $100',
	  '18:2113B.M': '18:2113B.M           ROBBERY OF PROPERTY OR MONEY &lt;= $100',
	  '18:2113C.F': '18:2113C.F           RECEIVING STOLEN MONEY OR PROPERTY',
	  '18:2113C.M': '18:2113C.M           RECEIVING STOLEN MONEY OR PROPERTY',
	  '18:2113D.F': '18:2113D.F           BANK ROBBERY, ASSAULT WITH A DEADLY ...',
	  '18:2113E.F': '18:2113E.F           DEATH AS A RESULT OF BANK ROBBERY',
	  '18:2114.F': '18:2114.F            MAIL, MONEY OR OTHER PROPERTY OF U.S.',
	  '18:2115.F': '18:2115.F            BURGLARY, POST OFFICE',
	  '18:2116.F': '18:2116.F            RAILWAY OR STEAMBOAT POST OFFICE/ROB...',
	  '18:2117.F': '18:2117.F            BREAKING/ENTERING A CARRIER FACILITY',
	  '18:2118A.F': '18:2118A.F           ROBBERY OF CONTROLLED SUBSTANCE',
	  '18:2118B.F': '18:2118B.F           BURGLARY OF CONTROLLED SUBSTANCE',
	  '18:2118C.F': '18:2118C.F           AGGRAVATED OR FELONIOUS ASSAULT ON P...',
	  '18:2118D.F': '18:2118D.F           CONSPIRE TO ROBBERY',
	  '18:2119.F': '18:2119.F            MOTOR VEHICLE THEFT - CARJACKING',
	  '18:212.M': '18:212.M             OFFER OF LOAN OR GRATUITY TO BANK EX...',
	  '18:213.M': '18:213.M             ACCEPTANCE OF LOAN OR GRATUITY BY BA...',
	  '18:214.M': '18:214.M             OFFER TO PROCURE FEDERAL RESERVE BAN...',
	  '18:215.F': '18:215.F             RECEIPT OF COMMISSION FOR PROCURING ...',
	  '18:215.M': '18:215.M             RECEIPT OF COMMISSION FOR PROCURING ...',
	  '18:2152.F': '18:2152.F            FORTIFICATIONS/HARBOR DEFENSES/DEFEN...',
	  '18:2153A.F': '18:2153A.F           DESTRUCTION WAR MATERIALS/PREMISES/U...',
	  '18:2153B.F': '18:2153B.F           CONSPIRACY: WAR MATERIALS/PREMISES/U...',
	  '18:2154A.F': '18:2154A.F           PRODUCTION OF DEFECTIVE WAR MATERIAL...',
	  '18:2154B.F': '18:2154B.F           PRODUCTION OF DEFECTIVE WAR MATERIAL...',
	  '18:2155A.F': '18:2155A.F           DESTRUCTION OF NATIONAL DEFENSE MATE...',
	  '18:2155B.F': '18:2155B.F           CONSPIRACY - DESTRUCTION OF NATIONAL...',
	  '18:2156A.F': '18:2156A.F           PRODUCE DEFECTIVE NATIONAL DEFENSE M...',
	  '18:2156B.F': '18:2156B.F           PRODUCE DEFECTIVE NATIONAL DEFENSE M...',
	  '18:216.F': '18:216.F             ACTS AFFECTING A PERSONAL FINANCIAL ...',
	  '18:216.M': '18:216.M             PENALTIES - GRAFT/BRIBERY',
	  '18:217.M': '18:217.M             GRAFT IN CONJUNCTION WITH FARM LOANS',
	  '18:219.F': '18:219.F             PUBLIC OFFICIALS ACTING AS AGENTS FO...',
	  '18:2191.F': '18:2191.F            CRUELTY TO SEAMEN',
	  '18:2192.F': '18:2192.F            INCITE SEAMEN TO REVOLT OR MUTINY',
	  '18:2193.F': '18:2193.F            REVOLT OR MUTINY OF SEAMEN',
	  '18:2194.M': '18:2194.M            SHANGHAIING SAILORS',
	  '18:2195.P': '18:2195.P            ABANDONMENT OF SAILORS',
	  '18:2196.M': '18:2196.M            DRUNKENNESS OR NEGLECT OF DUTY BY SE...',
	  '18:2197.F': '18:2197.F            MISUSE OF FEDERAL CERTIFICATE, LICEN...',
	  '18:2199.F': '18:2199.F            STOWAWAYS ON VESSELS OR AIRCRAFT',
	  '18:2199.M': '18:2199.M            STOWAWAYS ON VESSELS OR AIRCRAFT',
	  '18:2231A.F': '18:2231A.F           ASSAULT OR RESISTANCE OF PERSONS WIT...',
	  '18:2231B.F': '18:2231B.F           ASSAULT OR RESISTANCE - USE OF DEADL...',
	  '18:2232A.F': '18:2232A.F           DESTRUCTION OR REMOVAL OF PROPERTY T...',
	  '18:2232A.M': '18:2232A.M           DESTRUCTION OR REMOVAL OF PROPERTY T...',
	  '18:2232B.F': '18:2232B.F           WARNING THE SUBJECT OF A SEARCH',
	  '18:2233.F': '18:2233.F            RESCUE OF SEIZED PROPERTY',
	  '18:2234.M': '18:2234.M            AUTHORITY EXCEEDED IN EXECUTING WARRANT',
	  '18:2235.M': '18:2235.M            SEARCH WARRANT PROCURED MALICIOUSLY',
	  '18:2236.M': '18:2236.M            SEARCHES WITHOUT WARRANT - 2ND OFFENSE',
	  '18:2237.F': '18:2237.F            OBSTRUCTION OF BOARDING',
	  '18:224.F': '18:224.F             BRIBERY IN SPORTING CONTESTS',
	  '18:2241A.F': '18:2241A.F           AGGRAVATED SEXUAL ABUSE',
	  '18:2241B.F': '18:2241B.F           FORCED, DRUG-INDUCED SEX',
	  '18:2241C.F': '18:2241C.F           SEX WITH PERSON LESS THAN 12 YEARS OLD',
	  '18:2242A.F': '18:2242A.F           FORCED SEX THREATS/FEAR OF HARM',
	  '18:2242B.F': '18:2242B.F           SEX WITH PERSON MENTALLY/PHYSICALLY ...',
	  '18:2243A.F': '18:2243A.F           SEX ABUSE OF MINOR/WARD 4 YEARS OR M...',
	  '18:2243B.F': '18:2243B.F           SEX ABUSE OF ADULT WARD IN CUSTODY',
	  '18:2243B.M': '18:2243B.M           SEX ACT WITH PERSON UNDER PERIPHERAL...',
	  '18:2244A.F': '18:2244A.F           ABUSIVE SEXUAL CONTACT WITHOUT PERMI...',
	  '18:2244A.M': '18:2244A.M           ABUSIVE SEX CONTACT: VIOLATION SEC. ...',
	  '18:2244A.P': '18:2244A.P           ABUSIVE SEX CONTACT: VIOLATION SEC. ...',
	  '18:2244B.P': '18:2244B.P           ABUSIVE SEXUAL CONTACT',
	  '18:2244C.F': '18:2244C.F           ABUSIVE SEXUAL CONTACT INVOLVING YOU...',
	  '18:2244C.M': '18:2244C.M           ABUSIVE SEXUAL CONTACT INVOLVING YOU...',
	  '18:2245.F': '18:2245.F            SEXUAL ABUSE RESULTING IN DEATH',
	  '18:225.F': '18:225.F             CONTINUING CRIMINAL ENTERPRISE',
	  '18:2250.F': '18:2250.F            FAILURE TO REGISTER AS A SEX OFFENDER',
	  '18:2251.F': '18:2251.F            SEXUAL EXPLOITATION OF CHILDREN',
	  '18:2251.M': '18:2251.M            VIOLATION BY AN ORGANIZATION',
	  '18:2251A.F': '18:2251A.F           SELLING OR BUYING OF CHILDREN',
	  '18:2252.F': '18:2252.F            SEXUAL EXPLOITATION OF MINORS',
	  '18:2252.M': '18:2252.M            VIOLATION BY AN ORGANIZATION',
	  '18:2252A.F': '18:2252A.F           ACTIVITIES RELATING TO MATERIAL CONT...',
	  '18:2253.F': '18:2253.F            CRIMINAL FORFEITURE IN VIOLATION OF ...',
	  '18:2256.F': '18:2256.F            SEXUAL EXPLOITATION AND OTHER ABUSE ...',
	  '18:2257.M': '18:2257.M            SEX OFFENSES, OTHER',
	  '18:2260.F': '18:2260.F            PRODUCE SEX EXPLICIT DEPICTIONS OF M...',
	  '18:2261.F': '18:2261.F            INTERSTATE DOMESTIC VIOLENCE',
	  '18:2262.F': '18:2262.F            INTERSTATE VIOLATION OF PROTECTION O...',
	  '18:2271.F': '18:2271.F            CONSPIRACY TO DESTROY VESSELS',
	  '18:2272.F': '18:2272.F            DESTRUCTION OF VESSEL BY OWNER',
	  '18:2273.F': '18:2273.F            DESTRUCTION OF VESSEL BY NONOWNER',
	  '18:2274.F': '18:2274.F            DESTRUCTION OR MISUSE OF VESSEL BY P...',
	  '18:2275.F': '18:2275.F            FIRING OR TAMPERING WITH VESSELS',
	  '18:2276.F': '18:2276.F            BREAKING AND ENTERING VESSEL',
	  '18:2277.M': '18:2277.M            EXPLOSIVE OR DANGEROUS WEAPONS ABOAR...',
	  '18:2278.M': '18:2278.M            EXPLOSIVE ON VESSELS CARRYING STEERA...',
	  '18:2279.P': '18:2279.P            BOARDING VESSELS BEFORE ARRIVAL',
	  '18:228.F': '18:228.F             FAILURE TO PAY CHILD SUPPORT  (T)',
	  '18:228.P': '18:228.P             FAILURE TO PAY CHILD SUPPORT  (T)',
	  '18:2280.F': '18:2280.F            VIOLENCE AGAINST MARITIME NAVIGATION',
	  '18:2285.F': '18:2285.F            OPERATION OF SUBMERSIBLE VESSEL OR S...',
	  '18:231.F': '18:231.F             CIVIL DISORDER',
	  '18:2312.F': '18:2312.F            TRANSPORTATION OF STOLEN VEHICLES',
	  '18:2313.F': '18:2313.F            SALE OR RECEIPT OF STOLEN VEHICLES',
	  '18:2314.F': '18:2314.F            TRANSPORTATION OF STOLEN PROPERTY',
	  '18:2315.F': '18:2315.F            SALE OR RECEIPT OF STOLEN GOODS, SEC...',
	  '18:2316.F': '18:2316.F            TRANSPORTATION OF CATTLE',
	  '18:2317.F': '18:2317.F            SALE OR RECEIPT OF CATTLE',
	  '18:2318.F': '18:2318.F            COUNTERFEIT LABELS FOR PHONOGRAPH RE...',
	  '18:2318.M': '18:2318.M            COUNTERFEIT LABELS FOR PHONOGRAPH RE...',
	  '18:2319.F': '18:2319.F            COPYRIGHT INFRINGEMENT AND REMEDIES',
	  '18:2319.M': '18:2319.M            CRIMINAL INFRINGEMENT OF A COPYRIGHT',
	  '18:2320.F': '18:2320.F            TRAFFICKING IN COUNTERFEIT GOODS... (T)',
	  '18:2320.M': '18:2320.M            TRAFFICKING IN COUNTERFEIT GOODS/SER...',
	  '18:2321.F': '18:2321.F            TRAFFICKING IN MOTOR VEHICLES/MOTOR ...',
	  '18:2322.F': '18:2322.F            OWNS, MAINTAINS, OPERATES A CHOP SHOP',
	  '18:2326.F': '18:2326.F            ENHANCED PENALTIES FOR UNLAWFUL TELE...',
	  '18:2332.F': '18:2332.F            CRIMINAL PENALTIES FOR TERRORISM',
	  '18:2332A.F': '18:2332A.F           KILLING A CITIZEN OUTSIDE THE U.S.',
	  '18:2332AA.F': '18:2332AA.F          USE OF CERTAIN WEAPONS OF MASS DESTR...',
	  '18:2332B.F': '18:2332B.F           CONSPIRACY TO KILL A U.S. CITIZEN',
	  '18:2332BB.F': '18:2332BB.F          ACTS OF TERRORISM TRANSCENDING NATIO...',
	  '18:2332D.F': '18:2332D.F           FINANCIAL TRANSACTIONS RELATED TO TE...',
	  '18:2332F.F': '18:2332F.F           BOMBINGS OF PLACES OF PUBLIC USE',
	  '18:2339.F': '18:2339.F            HARBORING OR CONCEALING TERRORISTS',
	  '18:2339A.F': '18:2339A.F           PROVIDING MATERIAL SUPPORT TO TERROR...',
	  '18:2342.F': '18:2342.F            TRAFFICKING IN CONTRABAND CIGARETTES',
	  '18:2343.F': '18:2343.F            TRAFFICKING IN CONTRABAND CIGARETTES...',
	  '18:2344.F': '18:2344.F            PENALTIES - TRAFFICKING IN CONTRABAN...',
	  '18:2381.F': '18:2381.F            TREASON',
	  '18:2382.F': '18:2382.F            CONCEALING KNOWLEDGE OF TREASON',
	  '18:2383.F': '18:2383.F            REBELLION OR INSURRECTION',
	  '18:2384.F': '18:2384.F            SEDITIOUS CONSPIRACY',
	  '18:2385.F': '18:2385.F            ADVOCATING OVERTHROW OF GOVERNMENT',
	  '18:2386.F': '18:2386.F            REGISTRATION OF CERTAIN ORGANIZATIONS',
	  '18:2387.F': '18:2387.F            ACTIVITIES AFFECTING ARMED FORCES',
	  '18:2388A.F': '18:2388A.F           ACTIVITIES AFFECTING ARMED FORCES - WAR',
	  '18:2388B.F': '18:2388B.F           ACTIVITIES AFFECTING ARMED FORCES - WAR',
	  '18:2388C.F': '18:2388C.F           ACTIVITIES AFFECTING ARMED FORCES - WAR',
	  '18:2389.F': '18:2389.F            RECRUITING FOR SERVICE AGAINST U.S.',
	  '18:2390.F': '18:2390.F            ENLISTMENT TO SERVE AGAINST U.S.',
	  '18:241.F': '18:241.F             CONSPIRACY AGAINST RIGHTS',
	  '18:242.F': '18:242.F             DEPRIVE CIVIL RIGHTS',
	  '18:242.M': '18:242.M             DEPRIVE CIVIL RIGHTS',
	  '18:2421.F': '18:2421.F            TRANSPORTING FOR PROSTITUTION',
	  '18:2422.F': '18:2422.F            COERCION OR ENTICEMENT',
	  '18:2423.F': '18:2423.F            TRANSPORTATION OF MINORS',
	  '18:2424.F': '18:2424.F            FAIL TO FILE FACTUAL STATEMENT ABOUT...',
	  '18:2425.F': '18:2425.F            USE INTERSTATE FACILITIES TO TRANSMI...',
	  '18:2426.F': '18:2426.F            REPEAT OFFENDER-PRIOR SEX OFFENSE CO...',
	  '18:2428.F': '18:2428.F            FORFEITURES',
	  '18:243.P': '18:243.P             EXCLUDE JURORS BASED ON RACE OR COLOR',
	  '18:244.P': '18:244.P             DISCRIMINATE AGAINST PERSON IN MILIT...',
	  '18:245.F': '18:245.F             FEDERALLY PROTECTED ACTIVITIES',
	  '18:245.M': '18:245.M             FEDERALLY PROTECTED ACTIVITIES',
	  '18:247.F': '18:247.F             DAMAGE TO RELIGIOUS PROPERTY/OBSTRUC...',
	  '18:247.M': '18:247.M             DAMAGE TO RELIGIOUS PROPERTY/OBSTRUC...',
	  '18:248.M': '18:248.M             ACCESS TO CLINIC ENTRANCE  (T)',
	  '18:248A.F': '18:248A.F            ACCESS TO CLINIC ENTRANCE  (T)',
	  '18:248B.F': '18:248B.F            ACCESS TO CLINIC  (T)',
	  '18:248B1.P': '18:248B1.P           ACCESS TO CLINIC ENTRANCE  (T)',
	  '18:25.F': '18:25.F              USE OF MINORS IN CRIMES OF VIOLENCE',
	  '18:2511.F': '18:2511.F            INTERCEPTION AND DISCLOSURE OF WIRE ...',
	  '18:2511.M': '18:2511.M            INTERCEPTION AND DISCLOSURE OF WIRE ...',
	  '18:2512.F': '18:2512.F            MANUFACTURE/DISTR/POSSESS/ADVERTISE ...',
	  '18:2513.M': '18:2513.M            CONFISCATION OF WIRE, ORAL, OR ELECT...',
	  '18:2701.F': '18:2701.F            UNLAWFUL ACCESS  (T)',
	  '18:2701.M': '18:2701.M            UNLAWFUL ACCESS  (T)',
	  '18:2701.P': '18:2701.P            UNLAWFUL ACCESS  (T)',
	  '18:2723.P': '18:2723.P            PROHIBITION ON RELEASE AND USE OF CE...',
	  '18:285.F': '18:285.F             TAKE/USE PAPERS RELATING TO CLAIMS',
	  '18:286.F': '18:286.F             CONSPIRE TO DEFRAUD GOVERNMENT RESPE...',
	  '18:287.F': '18:287.F             FALSE OR FRAUDULENT CLAIMS',
	  '18:288.M': '18:288.M             FALSE CLAIMS FOR POSTAL LOSSES',
	  '18:288.P': '18:288.P             FALSE CLAIMS FOR POSTAL LOSSES',
	  '18:289.F': '18:289.F             FALSE CLAIMS FOR PENSIONS',
	  '18:290.P': '18:290.P             DISCHARGE PAPERS WITHHELD BY CLAIM A...',
	  '18:291.P': '18:291.P             PURCHASE CLAIMS FOR FEES BY COURT OF...',
	  '18:292.M': '18:292.M             SOLICITATION OF EMPLOYMENT',
	  '18:3.F': '18:3.F               ACCESSORY AFTER THE FACT',
	  '18:3.M': '18:3.M               ACCESSORY AFTER THE FACT',
	  '18:3.P': '18:3.P               ACCESSORY AFTER THE FACT',
	  '18:3056B.M': '18:3056B.M           OBSTRUCTION AND INTERFERENCE W/SECRE...',
	  '18:3056D.M': '18:3056D.M           OBSTRUCTION AND INTERFERENCE W/SECRE...',
	  '18:3118.P': '18:3118.P            FAILURE TO SUBMIT TO DRUG/ALCOHOL TEST',
	  '18:3142.F': '18:3142.F            RELEASE AND DETENTION PENDING JUDICI...',
	  '18:3144.P': '18:3144.P            RELEASE OR DETENTION OF MATERIAL WIT...',
	  '18:3145.M': '18:3145.M            REVIEW AND APPEAL OF A RELEASE OR DE...',
	  '18:3146.F': '18:3146.F            FAILURE TO APPEAR',
	  '18:3146.M': '18:3146.M            FAILURE TO APPEAR',
	  '18:3146A.F': '18:3146A.F           PENALTY FOR FAILURE TO APPEAR',
	  '18:3146B.F': '18:3146B.F           PENALTY FOR FAILURE TO APPEAR',
	  '18:3146B.M': '18:3146B.M           FAILURE TO APPEAR AS MATERIAL WITNESS',
	  '18:3146C.F': '18:3146C.F           PENALTY FOR FAILURE TO APPEAR',
	  '18:3146D.M': '18:3146D.M           PENALTY FOR FAILURE TO APPEAR',
	  '18:3147.F': '18:3147.F            OFFENSE COMMITTED WHILE ON RELEASE',
	  '18:3147.M': '18:3147.M            OFFENSE COMMITTED WHILE ON RELEASE',
	  '18:3148.F': '18:3148.F            SANCTIONS FOR VIOLATION OF A RELEASE...',
	  '18:3184.F': '18:3184.F            FUGITIVES FROM FOREIGN COUNTRY TO UN...',
	  '18:32A.F': '18:32A.F             DESTRUCTION OF AIRCRAFT OR FACILITY',
	  '18:32B.F': '18:32B.F             DESTRUCTION OF AIRCRAFT OR FACILITY',
	  '18:32C.F': '18:32C.F             ATTEMPTS TO COMMIT AN OFFENSE',
	  '18:33.F': '18:33.F              DESTROY MOTOR VEHICLE OR MOTOR VEHIC...',
	  '18:331.F': '18:331.F             MUTILATION AND FALSIFICATION OF COINS',
	  '18:332.F': '18:332.F             EMBEZZLEMENT',
	  '18:333.P': '18:333.P             MUTILATION OF CURRENCY',
	  '18:334.F': '18:334.F             ISSUE FEDERAL RESERVE OR NATIONAL BA...',
	  '18:335.F': '18:335.F             CIRCULATE OBLIGATIONS OF EXPIRED COR...',
	  '18:336.P': '18:336.P             ISSUE CIRCULATING OBLIGATIONS OF LES...',
	  '18:337.M': '18:337.M             COINS AS SECURITY FOR LOANS',
	  '18:34.F': '18:34.F              DESTRUCTION OF AIRCRAFT  (T)',
	  '18:342.F': '18:342.F             OPERATING COMMON CARRIER UNDER INFLU...',
	  '18:35.F': '18:35.F              MOTOR VEHICLE OR OTHER THAN AIRCRAFT',
	  '18:351A.F': '18:351A.F            CONGRESSIONAL - ASSASSINATION/VOLUNT...',
	  '18:351B.F': '18:351B.F            CONGRESSIONAL - KIDNAPPING   (T)',
	  '18:351C.F': '18:351C.F            CONGRESSIONAL - ATTEMPT TO KILL',
	  '18:351D.F': '18:351D.F            CONGRESSIONAL - CONSPIRACY TO KILL  (T)',
	  '18:351E.F': '18:351E.F            CONGRESSIONAL - ASSAULT',
	  '18:351E.M': '18:351E.M            CONGRESSIONAL - ASSAULT ON GOVERNMEN...',
	  '18:3521.F': '18:3521.F            WITNESS RELOCATION AND PROTECTION',
	  '18:3553.F': '18:3553.F            SENTENCE AGGRAVATING FACTORS UNDER B...',
	  '18:3559C.F': '18:3559C.F           IMPRISONMENT OF CERTAIN VIOLENT FELONS',
	  '18:3583.F': '18:3583.F            INCLUSION OF A TERM OF SUPERVISED RE...',
	  '18:3591.F': '18:3591.F            DEATH PENALTY',
	  '18:3592.F': '18:3592.F            DEATH PENALTY',
	  '18:36.F': '18:36.F              DRIVE-BY SHOOTINGS',
	  '18:3606.F': '18:3606.F            ARREST AND RETURN OF A PROBATIONER',
	  '18:3615.M': '18:3615.M            FAILURE TO PAY A FINE',
	  '18:37.F': '18:37.F              VIOLENCE AT INTERNATIONAL AIRPORTS',
	  '18:371.F': '18:371.F             CONSPIRACY TO DEFRAUD THE UNITED STATES',
	  '18:371.M': '18:371.M             CONSPIRACY TO DEFRAUD THE UNITED STATES',
	  '18:371.P': '18:371.P             CONSPIRACY TO DEFRAUD THE UNITED STATES',
	  '18:372.F': '18:372.F             CONSPIRE TO IMPEDE OR INJURE OFFICER',
	  '18:373-0100.F': '18:373-0100.F        SOLICIT/COMMIT CRIME OF VIOLENCE - M...',
	  '18:373-0101.F': '18:373-0101.F        SOLICIT/COMMIT CRIME OF VIOLENCE',
	  '18:373-0200.F': '18:373-0200.F        MURDER, SECOND DEGREE',
	  '18:373-0200.P': '18:373-0200.P        SOLICIT/COMMIT CRIME OF VIOLENCE',
	  '18:373-0201.F': '18:373-0201.F        MURDER, 2ND DEGREE - GOVERNMENT OFFI...',
	  '18:373-0300.F': '18:373-0300.F        MANSLAUGHTER',
	  '18:373-0300.P': '18:373-0300.P        MANSLAUGHTER',
	  '18:373-0301.F': '18:373-0301.F        MANSLAUGHTER',
	  '18:373-0310.F': '18:373-0310.F        NEGLIGENT HOMICIDE',
	  '18:373-0311.F': '18:373-0311.F        SOLICIT/COMMIT CRIME OF VIOLENCE',
	  '18:373-1100.F': '18:373-1100.F        ROBBERY, BANK',
	  '18:373-1200.F': '18:373-1200.F        ROBBERY, POSTAL',
	  '18:373-1400.F': '18:373-1400.F        ROBBERY, OTHER',
	  '18:373-1400.P': '18:373-1400.P        SOLICIT/COMMIT CRIME OF VIOLENCE',
	  '18:373-1500.F': '18:373-1500.F        AGGRAVATED OR FELONIOUS',
	  '18:373-1500.M': '18:373-1500.M        SOLICIT/COMMIT CRIME OF VIOLENCE',
	  '18:373-1500.P': '18:373-1500.P        SOLICIT/COMMIT CRIME OF VIOLENCE',
	  '18:373-1501.F': '18:373-1501.F        FELONY, ON GOVERNMENT OFFICIAL',
	  '18:373-1600.P': '18:373-1600.P        ASSAULT, OTHER',
	  '18:373-1601.M': '18:373-1601.M        ASSAULT ON GOVERNMENT OFFICIAL',
	  '18:373-1601.P': '18:373-1601.P        MISDEMEANOR, ON GOVERNMENT OFFICIAL',
	  '18:373-6100.F': '18:373-6100.F        SEXUAL ASSAULT',
	  '18:373-6100.P': '18:373-6100.P        SEXUAL ASSAULT',
	  '18:373-6200.F': '18:373-6200.F        WHITE SLAVERY AND IMPORTING ALIENS',
	  '18:373-6200.M': '18:373-6200.M        WHITE SLAVERY AND IMPORTING ALIENS',
	  '18:373-6300.F': '18:373-6300.F        SEX OFFENSES, OTHER',
	  '18:373-6300.M': '18:373-6300.M        SEX OFFENSES, OTHER',
	  '18:373-6300.P': '18:373-6300.P        SEX OFFENSES, OTHER',
	  '18:373-7410.F': '18:373-7410.F        RACKETEERING, ARSON',
	  '18:373-7471.F': '18:373-7471.F        RACKETEERING, MURDER',
	  '18:373-7472.F': '18:373-7472.F        RACKETEERING, KIDNAP',
	  '18:373-7473.F': '18:373-7473.F        RACKETEERING, MAIM',
	  '18:373-7600.F': '18:373-7600.F        RACKETEERING, KIDNAPPING',
	  '18:373-7611.F': '18:373-7611.F        RACKETEERING, KIDNAP, HOSTAGE',
	  '18:373-7800.F': '18:373-7800.F        RACKETEERING, FIREARMS AND WEAPONS',
	  '18:373-7910.F': '18:373-7910.F        RACKETEERING, ARSON',
	  '18:373-7910.P': '18:373-7910.P        RACKETEERING, SOLICIT/COMMIT CRIME O...',
	  '18:373-7940.F': '18:373-7940.F        RACKETEERING, MALICIOUS DESTRUCTION ...',
	  '18:373-9994.F': '18:373-9994.F        RACKETEERING, EXPLOSIVES  (T)',
	  '18:38.F': '18:38.F              FRAUD INVOLVING AIRCRAFT OR SPACE VE...',
	  '18:4.F': '18:4.F               WITHHOLDING INFORMATION ON A CRIME',
	  '18:401.F': '18:401.F             CRIMINAL CONTEMPT',
	  '18:401.M': '18:401.M             CRIMINAL CONTEMPT',
	  '18:401.P': '18:401.P             CONTEMPT, CONSTITUTING CRIME',
	  '18:402.F': '18:402.F             CRIMINAL CONTEMPT',
	  '18:402.M': '18:402.M             CRIMINAL CONTEMPT',
	  '18:402.P': '18:402.P             CRIMINAL CONTEMPT',
	  '18:4082.F': '18:4082.F            ESCAPE FROM CUSTODY',
	  '18:41.P': '18:41.P              DISTURBANCE OR INJURY TO WILDLIFE RE...',
	  '18:4246.F': '18:4246.F            HOSPITALIZATION OF PERSON DUE FOR RE...',
	  '18:4248.F': '18:4248.F            OFFENDERS WITH MENTAL DISEASE OR DEFECT',
	  '18:42A.P': '18:42A.P             IMPORT SHIPMENT OF INJURIOUS MAMMALS',
	  '18:42B.P': '18:42B.P             IMPORT OR SHIP INJURIOUS MAMMALS, ETC.',
	  '18:431.P': '18:431.P             CONTRACTS BY MEMBER OF CONGRESS',
	  '18:432.P': '18:432.P             OFFICER OR EMPLOYEE CONTRACTING WITH...',
	  '18:435.M': '18:435.M             CONTRACTS IN EXCESS OF SPECIFIC APPR...',
	  '18:436.F': '18:436.F             CONVICT LABOR CONTRACTS',
	  '18:437.P': '18:437.P             INDIAN CONTRACTS FOR GOODS AND SUPPLIES',
	  '18:438.P': '18:438.P             INDIAN CONTRACTS FOR SERVICES GENERALLY',
	  '18:439.P': '18:439.P             INDIAN ENROLLMENT CONTRACTS',
	  '18:43A.F': '18:43A.F             FORCE, VIOLENCE AND THREATS INVOLVIN...',
	  '18:43A.M': '18:43A.M             TRANSPORTATION OF WILDLIFE TAKEN IN ...',
	  '18:43B.M': '18:43B.M             TRANSPORTATION OF WILDLIFE TAKEN IN ...',
	  '18:43C.M': '18:43C.M             TRANSPORTATION OF WILDLIFE TAKEN IN ...',
	  '18:440.M': '18:440.M             MAIL CONTRACTS',
	  '18:441.M': '18:441.M             POSTAL SUPPLY CONTRACTS',
	  '18:442.M': '18:442.M             PRINTING CONTRACTS',
	  '18:443.F': '18:443.F             WAR CONTRACTS',
	  '18:46.P': '18:46.P              TRANSPORTATION OF WATER HYACINTHS',
	  '18:470.F': '18:470.F             COUNTERFEIT ACTS COMMITTED OUTSIDE T...',
	  '18:471.F': '18:471.F             UTTERS COUNTERFEIT OBLIGATIONS',
	  '18:472.F': '18:472.F             PASSES COUNTERFEIT OBLIGATIONS OR SE...',
	  '18:473.F': '18:473.F             DEAL IN COUNTERFEIT OBLIGATIONS AND ...',
	  '18:474.F': '18:474.F             PLATES OR STONES FOR COUNTERFEIT OBL...',
	  '18:475.P': '18:475.P             IMITATING OBLIGATIONS OR SECURITIES',
	  '18:476.F': '18:476.F             TAKE IMPRESSION OF TOOLS USED FOR OB...',
	  '18:477.F': '18:477.F             POSSESS/SELL IMPRESSION OF TOOLS FOR...',
	  '18:478.F': '18:478.F             FOREIGN OBLIGATIONS OR SECURITIES',
	  '18:479.F': '18:479.F             UTTER COUNTERFEIT OBLIGATIONS OR SEC...',
	  '18:47A.P': '18:47A.P             USE OF AIRCRAFT OR MOTOR VEHICLE TO ...',
	  '18:47B.P': '18:47B.P             POLLUTION OF WATERING HOLES',
	  '18:48.F': '18:48.F              DEPICTION OF ANIMAL CRUELTY',
	  '18:480.F': '18:480.F             POSSESS COUNTERFEIT FOREIGN OBLIGATI...',
	  '18:480.M': '18:480.M             POSSESS COUNTERFEIT FOREIGN OBLIGATI...',
	  '18:481.F': '18:481.F             PLATES/STONES - COUNTERFEIT FOREIGN ...',
	  '18:482.F': '18:482.F             FOREIGN BANK NOTES',
	  '18:483.M': '18:483.M             UTTER COUNTERFEIT BANK NOTES',
	  '18:484.F': '18:484.F             CONNECTING PARTS OF DIFFERENT NOTES',
	  '18:485.F': '18:485.F             COINS OR BARS',
	  '18:486.F': '18:486.F             UTTER COINS OF GOLD, SILVER OR OTHER...',
	  '18:487.F': '18:487.F             MAKE OR POSSESS COUNTERFEIT DIES FOR...',
	  '18:488.F': '18:488.F             MAKE OR POSSESS COUNTERFEIT DIES FOR...',
	  '18:489.P': '18:489.P             MAKE OR POSSESS LIKENESS OF COINS',
	  '18:49.F': '18:49.F              ENFORCEMENT OF ANIMAL FIGHTING PROHI...',
	  '18:490.F': '18:490.F             MINOR COINS',
	  '18:491.M': '18:491.M             TOKENS OR PAPER USED AS MONEY',
	  '18:492.F': '18:492.F             FORFEIT COUNTERFEIT PARAPHERNALIA',
	  '18:492.M': '18:492.M             FORFEIT COUNTERFEIT PARAPHERNALIA',
	  '18:493.F': '18:493.F             BONDS AND OBLIGATIONS OF CERTAIN LEN...',
	  '18:494.F': '18:494.F             CONTRACTOR\'S BONDS, BIDS, AND PUBLIC...',
	  '18:495.F': '18:495.F             CONTRACTS, DEALS AND POWERS OF ATTORNEY',
	  '18:496.F': '18:496.F             CUSTOMS MATTERS',
	  '18:497.F': '18:497.F             LETTER PATENT',
	  '18:498.M': '18:498.M             MILITARY OR NAVAL DISCHARGE CERTIFIC...',
	  '18:499.F': '18:499.F             MILITARY, NAVAL, OFFICIAL PASSES',
	  '18:500.F': '18:500.F             MONEY ORDERS',
	  '18:501.F': '18:501.F             POSTAGE STAMPS, POSTAGE METER STAMPS...',
	  '18:502.F': '18:502.F             POSTAGE AND REVENUE, STAMPS OF FOREI...',
	  '18:503.F': '18:503.F             POSTAGE AND REVENUE, STAMPS OF FOREI...',
	  '18:5032.F': '18:5032.F            JUVENILE DELINQUENCY',
	  '18:5032.M': '18:5032.M            JUVENILE DELINQUENCY',
	  '18:5032.P': '18:5032.P            JUVENILE DELINQUENCY',
	  '18:505.F': '18:505.F             FORGERY, SEALS OF DEPARTMENTS OR AGE...',
	  '18:506.F': '18:506.F             SEALS OF DEPARTMENTS OR AGENCIES',
	  '18:507.F': '18:507.F             SHIP\'S PAPERS',
	  '18:508.F': '18:508.F             TRANSPORTATION REQUESTS OF GOVERNMENT',
	  '18:509.F': '18:509.F             POSSESS/MAKE PLATES FOR GOVERNMENT T...',
	  '18:510A.F': '18:510A.F            FALSELY MAKES/FORGES ENDORSEMENT/SIG...',
	  '18:510A.M': '18:510A.M            FORGES ENDORSEMENT ON TREASURY CHECK...',
	  '18:510B.F': '18:510B.F            DELIVERS, RETAINS TREASURY CHECK OR ...',
	  '18:510B.M': '18:510B.M            FORGES ENDORSEMENT ON TREASURY CHECK...',
	  '18:510C.M': '18:510C.M            IF TREASURY CHECK/BOND DOES NOT EXCE...',
	  '18:511.F': '18:511.F             ALTERING OR REMOVING MOTOR VEHICLE I.D.',
	  '18:512.F': '18:512.F             FORFEITURE OF MOTOR VEHICLES AND PARTS',
	  '18:513A.F': '18:513A.F            UTTER FORGED AND COUNTERFEIT SECURITY',
	  '18:513B.F': '18:513B.F            POSSESSION OF COUNTERFEITING INSTRUM...',
	  '18:514.F': '18:514.F             FICTITIOUS OBLIGATIONS INTENDED TO D...',
	  '18:541.F': '18:541.F             ENTRY OF GOODS FALSELY CLASSIFIED, E...',
	  '18:541.M': '18:541.M             ENTRY OF GOODS FALSELY CLASSIFIED, E...',
	  '18:542.F': '18:542.F             ENTRY OF GOODS BY MEANS OF FALSE STA...',
	  '18:543.F': '18:543.F             ENTRY OF GOODS FOR LESS THAN LEGAL DUTY',
	  '18:545.F': '18:545.F             SMUGGLING GOODS INTO THE U.S.  (T)',
	  '18:546.F': '18:546.F             SMUGGLING GOODS INTO FOREIGN COUNTRIES',
	  '18:547.F': '18:547.F             DEPOSITING GOODS IN BUILDINGS ON BOU...',
	  '18:548.F': '18:548.F             REMOVE OR REPACK GOODS IN WAREHOUSES',
	  '18:549.F': '18:549.F             REMOVE GOODS FROM CUSTOMS CUSTODY',
	  '18:550.F': '18:550.F             FALSE CLAIM FOR REFUND OF DUTIES',
	  '18:551.F': '18:551.F             CONCEAL OR DESTROY INVOICES OR OTHER...',
	  '18:552.F': '18:552.F             OFFICERS AIDING IMPORT OF OBSCENE/TR...',
	  '18:553.F': '18:553.F             IMPORT OR EXPORT OF STOLEN MOTOR VEH...',
	  '18:554.F': '18:554.F             SMUGGLING GOODS FROM THE UNITED STATES',
	  '18:592.F': '18:592.F             TROOPS AT POLLS',
	  '18:593.F': '18:593.F             INTERFERENCE BY ARMED FORCES',
	  '18:594.M': '18:594.M             INTIMIDATION OF VOTERS',
	  '18:595.M': '18:595.M             INTERFERENCE BY ADMIN. EMPLOYEE OF F...',
	  '18:596.M': '18:596.M             POLLING ARMED FORCES',
	  '18:597.F': '18:597.F             EXPENDITURES TO INFLUENCE VOTING',
	  '18:597.M': '18:597.M             EXPENDITURES TO INFLUENCE VOTING',
	  '18:598.M': '18:598.M             COERCION BY MEANS OF RELIEF APPROPRI...',
	  '18:599.F': '18:599.F             PROMISE OF APPOINTMENT BY CANDIDATE',
	  '18:599.M': '18:599.M             PROMISE OF APPOINTMENT BY CANDIDATE',
	  '18:600.M': '18:600.M             PROMISE OF EMPLOYMENT OR OTHER BENEF...',
	  '18:601.M': '18:601.M             DEPRIVE EMPLOYMENT OR OTHER BENEFIT ...',
	  '18:602.F': '18:602.F             SOLICIT POLITICAL CONTRIBUTIONS',
	  '18:603.F': '18:603.F             PLACE OF SOLICITATION',
	  '18:604.M': '18:604.M             SOLICIT FROM PERSON ON RELIEF',
	  '18:605.M': '18:605.M             DISCLOSE NAMES OF PERSONS ON RELIEF',
	  '18:606.F': '18:606.F             INTIMIDATE TO SECURE POLITICAL CONTR...',
	  '18:607.F': '18:607.F             MAKING POLITICAL CONTRIBUTIONS',
	  '18:611.M': '18:611.M             VOTING BY ALIENS',
	  '18:641.F': '18:641.F             PUBLIC MONEY, PROPERTY OR RECORDS',
	  '18:641.M': '18:641.M             THEFT/EMBEZZLEMENT OF U. S. PROPERTY',
	  '18:642.F': '18:642.F             TOOLS AND MATERIALS FOR COUNTERFEITING',
	  '18:643.F': '18:643.F             ACCOUNTING GENERALLY FOR PUBLIC MONEY',
	  '18:643.M': '18:643.M             ACCOUNTING GENERALLY FOR PUBLIC MONEY',
	  '18:644.F': '18:644.F             BANKER RECEIVING UNAUTHORIZED DEPOSI...',
	  '18:644.M': '18:644.M             EMBEZZLES PUBLIC MONEYS OR PROPERTY',
	  '18:645.F': '18:645.F             EMBEZZLEMENT: COURT OFFICERS',
	  '18:645.M': '18:645.M             EMBEZZLEMENT: COURT OFFICERS',
	  '18:646.F': '18:646.F             COURT OFFICERS DEPOSITING REGISTRY M...',
	  '18:646.M': '18:646.M             COURT OFFICERS DEPOSITING REGISTRY M...',
	  '18:647.F': '18:647.F             RECEIVING LOAN FROM COURT OFFICER',
	  '18:647.M': '18:647.M             RECEIVING LOAN FROM COURT OFFICER',
	  '18:648.F': '18:648.F             CUSTODIANS, GENERALLY, MISUSING PUBL...',
	  '18:648.M': '18:648.M             CUSTODIANS, GENERALLY, MISUSING PUBL...',
	  '18:649.F': '18:649.F             CUSTODIANS: FAILING TO DEPOSIT MONEYS',
	  '18:649.M': '18:649.M             CUSTODIANS: FAILING TO DEPOSIT MONEYS',
	  '18:650.F': '18:650.F             DEPOSITARIES FAILING TO SAFEGUARD DE...',
	  '18:650.M': '18:650.M             DEPOSITARIES FAILING TO SAFEGUARD DE...',
	  '18:651.F': '18:651.F             DISBURSING OFFICER FALSELY CERTIFYIN...',
	  '18:651.M': '18:651.M             DISBURSING OFFICER FALSELY CERTIFYIN...',
	  '18:652.F': '18:652.F             DISBURSING OFFICER PAYING LESSER LAW...',
	  '18:652.M': '18:652.M             DISBURSING OFFICER PAYING LESSER LAW...',
	  '18:653.F': '18:653.F             DISBURSING OFFICER MISUSING PUBLIC FUND',
	  '18:653.M': '18:653.M             DISBURSING OFFICER MISUSING PUBLIC FUND',
	  '18:654.F': '18:654.F             OFFICER OR EMPLOYEE OF U.S. CONVERTI...',
	  '18:654.M': '18:654.M             OFFICER OR EMPLOYEE OF U.S. CONVERTI...',
	  '18:655.F': '18:655.F             THEFT BY BANK EXAMINER  (T)',
	  '18:655.M': '18:655.M             THEFT BY BANK EXAMINER  (T)',
	  '18:656.F': '18:656.F             THEFT/EMBEZZLEMENT/MISAPPLICATION BY...',
	  '18:656.M': '18:656.M             THEFT/EMBEZZLEMENT/MISAPPLICATION BY...',
	  '18:657.F': '18:657.F             LENDING, CREDIT AND INSURANCE INSTIT...',
	  '18:657.M': '18:657.M             LENDING, CREDIT AND INSURANCE INSTIT...',
	  '18:658.F': '18:658.F             PROP MORTGAGED OR PLEDGED TO FARM CR...',
	  '18:658.M': '18:658.M             PROP MORTGAGED OR PLEDGED TO FARM CR...',
	  '18:659.F': '18:659.F             INTERSTATE OR FOREIGN SHIPMENT BY CA...',
	  '18:659.M': '18:659.M             INTERSTATE OR FOREIGN SHIPMENT BY CA...',
	  '18:660.F': '18:660.F             CARRIER\'S FUNDS DERIVED FROM COMMERCE',
	  '18:661.F': '18:661.F             LARCENY W/IN SPECIAL MARITIME JURISD...',
	  '18:661.M': '18:661.M             LARCENY W/IN SPECIAL MARITIME JURISD...',
	  '18:662.F': '18:662.F             RECEIVING STOLEN PROP W/IN SPECIAL M...',
	  '18:662.M': '18:662.M             RECEIVING STOLEN PROP W/IN SPECIAL M...',
	  '18:663.F': '18:663.F             SOLICITATION OR USE OF GIFTS',
	  '18:664.F': '18:664.F             THEFT OR EMBEZZLEMENT FROM EMPLOYEE ...',
	  '18:665A.F': '18:665A.F            THEFT OR EMBEZZLEMENT FROM MANPOWER ...',
	  '18:665A.M': '18:665A.M            THEFT OR EMBEZZLEMENT FROM MANPOWER ...',
	  '18:665B.M': '18:665B.M            THEFT OR EMBEZZLEMENT FROM MANPOWER ...',
	  '18:666A.F': '18:666A.F            CONVERTS TO OWN USE PROPERTY OF ANOTHER',
	  '18:666B.F': '18:666B.F            UNLAWFULLY ACCEPT PROPERTY OF ANOTHER',
	  '18:666C.F': '18:666C.F            BRIBERY INVOLVING FEDERAL PROGRAMS',
	  '18:667.F': '18:667.F             THEFT OF LIVESTOCK',
	  '18:668.F': '18:668.F             THEFT OR RECEIPT OF STOLEN ARTWORK',
	  '18:669.F': '18:669.F             THEFT OR EMBEZZLEMENT IN CONNECTION ...',
	  '18:669.M': '18:669.M             THEFT OR EMBEZZLEMENT IN CONNECTION ...',
	  '18:7.F': '18:7.F               SPECIAL MARITIME AND TERRITORIAL JUR...',
	  '18:700.M': '18:700.M             DESECRATION OF THE FLAG OF THE U.S.',
	  '18:701.P': '18:701.P             MILITARY-BADGES ID CARDS, OTHER INSI...',
	  '18:702.P': '18:702.P             UNIFORM OF ARMED FORCES AND PUB HEAL...',
	  '18:703.P': '18:703.P             UNIFORM OF FRIENDLY NATION',
	  '18:704.F': '18:704.F             MILITARY MEDALS OR DECORATIONS',
	  '18:704.M': '18:704.M             MILITARY MEDALS OR DECORATIONS',
	  '18:704.P': '18:704.P             MILITARY MEDALS OR DECORATIONS',
	  '18:705.P': '18:705.P             BADGE OR MEDAL OF VETERANS\' ORGANIZA...',
	  '18:706.P': '18:706.P             IMPERSONATE RED CROSS PERSONNEL',
	  '18:707.P': '18:707.P             4-H CLUB EMBLEM FRAUDULENTLY USED',
	  '18:708.P': '18:708.P             SWISS CONFEDERATION COAT OF ARMS',
	  '18:709.M': '18:709.M             FALSE ADVERTISING OR MISUSE OF NAMES',
	  '18:710.P': '18:710.P             CREMATION URNS FOR MILITARY USE',
	  '18:711.P': '18:711.P             SMOKEY BEAR CHARACTER OR NAME',
	  '18:712.M': '18:712.M             MISUSE OF NAMES, WORDS, EMBLEMS, OR ...',
	  '18:713.P': '18:713.P             USE OF LIKENESS OF THE GREAT SEAL/U.S.',
	  '18:715.P': '18:715.P             THE GOLDEN EAGLE INSIGNIA',
	  '18:716.P': '18:716.P             TRNSFR/TRNSPT/RCPT OF CNTRFIT POLC B...',
	  '18:751A.F': '18:751A.F            PRISONER IN CUSTODY OF INSTITUTION O...',
	  '18:751A.M': '18:751A.M            ESCAPE/ATTEMPTED ESCAPE FROM A/G CUS...',
	  '18:751B.M': '18:751B.M            PRISONERS IN CUSTODY OF INSTITUTION/...',
	  '18:752A.F': '18:752A.F            INSTIGATING OR ASSISTING ESCAPE',
	  '18:752A.M': '18:752A.M            INSTIGATING OR ASSISTING ESCAPE',
	  '18:752B.M': '18:752B.M            INSTIGATING OR ASSISTING ESCAPE',
	  '18:753.F': '18:753.F             RESCUE TO PREVENT EXECUTION',
	  '18:754.M': '18:754.M             RESCUE OF BODY OF EXECUTED OFFENDER',
	  '18:755.F': '18:755.F             OFFICER PERMITTING ESCAPE',
	  '18:755.M': '18:755.M             OFFICER PERMITTING ESCAPE',
	  '18:756.M': '18:756.M             INTERNEE OF BELLIGERENT NATION',
	  '18:757.F': '18:757.F             PRISONERS OF WAR OR ENEMY ALIENS',
	  '18:758.F': '18:758.F             HIGH SPEED FLIGHT FROM IMMIGRATION C...',
	  '18:792.F': '18:792.F             HARBORING OR CONCEALING PERSONS',
	  '18:793.F': '18:793.F             GATHERING, TRANSMITTING, OR LOSING D...',
	  '18:794.F': '18:794.F             GATHERING, DELIVERING DEFENSE INFO',
	  '18:795.M': '18:795.M             PHOTOGRAPHING AND SKETCHING DEFENSE INS',
	  '18:797.M': '18:797.M             PUBLISH AND SELL PHOTOGRAPHS OF DEFE...',
	  '18:798.F': '18:798.F             DISCLOSURE OF CLASSIFIED INFORMATION',
	  '18:799.M': '18:799.M             VIOL OF REGULATIONS OF NASA',
	  '18:81.F': '18:81.F              ARSON WITHIN SPECIAL MARITIME OR TER...',
	  '18:831.F': '18:831.F             RECEIVE/ALTER/DISPERSE/NUCLEAR MATERIAL',
	  '18:836.M': '18:836.M             TRANSPORTATION OF FIREWORKS INTO STA...',
	  '18:842A.F': '18:842A.F            IMPORTING EXPLOSIVE MATERIAL',
	  '18:842B.F': '18:842B.F            DISTRIBUTE EXPLOSIVE MATERIAL',
	  '18:842C.F': '18:842C.F            DISTRIBUTE EXPLOSIVE MATERIAL TO PRO...',
	  '18:842D.F': '18:842D.F            DISTRIBUTE EXPLOSIVE MATERIAL TO UNA...',
	  '18:842E.F': '18:842E.F            DISTRIBUTE EXPLOSIVE MATERIAL IN VIO...',
	  '18:842F.F': '18:842F.F            MANUFACTURE OF IMPORT EXPLOSIVE MATE...',
	  '18:842G.F': '18:842G.F            FALSE ENTRIES, EXPLOSIVE MATERIALS',
	  '18:842H.F': '18:842H.F            DISTRIBUTE STOLEN EXPLOSIVES',
	  '18:842H.M': '18:842H.M            DISTRIBUTE STOLEN EXPLOSIVES',
	  '18:842I.F': '18:842I.F            SHIP OR TRANSPORT EXPLOSIVE MATERIAL...',
	  '18:842I.M': '18:842I.M            SHIP OR TRANSPORT EXPLOSIVE MATERIAL...',
	  '18:842J.M': '18:842J.M            NOT CONFORMING TO STORAGE OF EXPLOSI...',
	  '18:842K.M': '18:842K.M            FAILURE TO REPORT THEFT OR LOSS OF E...',
	  '18:842P.F': '18:842P.F            TEACHING OR DEMONSTRATING MAKING OF ...',
	  '18:844A.F': '18:844A.F            PENALTIES FOR 18:842A-I',
	  '18:844B.M': '18:844B.M            PENALTIES FOR 18:842J-K',
	  '18:844D.F': '18:844D.F            PENALTIES - IF DEATH OR INJURY RESULTS',
	  '18:844E.F': '18:844E.F            PENALTIES',
	  '18:844F.F': '18:844F.F            PENALTIES - IF DEATH RESULTS',
	  '18:844G.F': '18:844G.F            POSSESS EXPLOSIVES ON FEDERAL PROPERTY',
	  '18:844G.M': '18:844G.M            POSSESS EXPLOSIVES ON FEDERAL PROPERTY',
	  '18:844H.F': '18:844H.F            EXPLOSIVES USED IN COMMISSION OF FELONY',
	  '18:844I.F': '18:844I.F            PENALTIES - IF DEATH RESULTS',
	  '18:844J.F': '18:844J.F            UNLAWFUL STORAGE OF EXPLOSIVES',
	  '18:844N.F': '18:844N.F            CONSPIRACY',
	  '18:871.F': '18:871.F             THREATS AGAINST PRESIDENT AND SUCCES...',
	  '18:872.F': '18:872.F             EXTORTION BY OFFICERS OR EMPLOYEES O...',
	  '18:872.M': '18:872.M             EXTORTION BY OFFICERS OR EMPLOYEES O...',
	  '18:873.M': '18:873.M             BLACKMAIL',
	  '18:874.F': '18:874.F             KICKBACKS FROM PUBLIC WORKS EMPLOYEES',
	  '18:875A.F': '18:875A.F            INTERSTATE COMMUNICATIONS - RANSOMS',
	  '18:875B.F': '18:875B.F            INTERSTATE COMMUNICATIONS - THREAT T...',
	  '18:875C.F': '18:875C.F            INTERSTATE COMMUNICATIONS - THREATS',
	  '18:875D.F': '18:875D.F            INTERSTATE COMMUNICATIONS - THREATS ...',
	  '18:876.F': '18:876.F             MAILING THREATENING COMMUNICATIONS',
	  '18:877.F': '18:877.F             MAILING THREATENING COMMUNICATIONS/F...',
	  '18:878A.F': '18:878A.F            THREATENED ASSAULT',
	  '18:878B.F': '18:878B.F            EXTORTIONATE DEMANDS',
	  '18:879.F': '18:879.F             THREATS AGAINST FORMER PRESIDENT/FAM...',
	  '18:880.F': '18:880.F             RECEIVING PROCEEDS OF EXTORTION',
	  '18:892.F': '18:892.F             EXTENSIONS OF CREDIT BY EXTORTION',
	  '18:893.F': '18:893.F             EXTENSIONS OF CREDIT BY FINANCIAL EX...',
	  '18:894.F': '18:894.F             COLLECTION OF CREDIT BY EXTORTION',
	  '18:911.F': '18:911.F             IMPERSONATING CITIZEN OF THE U.S.',
	  '18:912.F': '18:912.F             IMPERSONATING OFFICER OR EMPLOYEE OF...',
	  '18:913.F': '18:913.F             IMPERSONATOR MAKING ARREST OR SEARCH',
	  '18:914.F': '18:914.F             IMPERSONATING A CREDITOR OF U.S.',
	  '18:915.F': '18:915.F             IMPERSONATING FOREIGN DIPLOMATS, CON...',
	  '18:916.P': '18:916.P             IMPERSONATING 4-H CLUB MEMBERS OR AG...',
	  '18:917.F': '18:917.F             IMPERSONATING A RED CROSS MEMBER',
	  '18:917.M': '18:917.M             IMPERSONATING RED CROSS MEMBERS OR A...',
	  '18:922A.F': '18:922A.F            IMPORTING/MANUFACTURING FIREARMS',
	  '18:922B.F': '18:922B.F            SELL FIREARMS TO UNAUTHORIZED PERSONS',
	  '18:922C.F': '18:922C.F            ILLEGAL TRANSFER OF FIREARMS',
	  '18:922D.F': '18:922D.F            SELL FIREARMS TO ADDICTS, FELONS, FU...',
	  '18:922E.F': '18:922E.F            INTERSTATE SHIPMENTS',
	  '18:922F.F': '18:922F.F            KNOWINGLY SHIP ILLEGAL WEAPONS',
	  '18:922G.F': '18:922G.F            UNLAWFUL TRANSPORT OF FIREARMS, ETC.',
	  '18:922H.F': '18:922H.F            RECEIVE OR TRANSPORT BY EMPLOYEE',
	  '18:922I.F': '18:922I.F            TRANSPORT STOLEN FIREARMS',
	  '18:922J.F': '18:922J.F            RECEIVE STOLEN FIREARMS',
	  '18:922K.F': '18:922K.F            SELL DEFACED FIREARMS',
	  '18:922L.F': '18:922L.F            ILLEGAL IMPORTATION OF FIREARMS',
	  '18:922M.F': '18:922M.F            FAILURE TO MAINTAIN RECORDS',
	  '18:922M.M': '18:922M.M            FAILURE TO MAINTAIN RECORDS',
	  '18:922N.F': '18:922N.F            TRANSPORT FIREARMS INTERSTATE BY FELON',
	  '18:922O.F': '18:922O.F            VIOLENT CRIME/DRUGS/MACHINE GUN',
	  '18:922Q.F': '18:922Q.F            CARRYING/USING FIREARM IN/NEAR SCHOO...',
	  '18:922Q.M': '18:922Q.M            CARRYING/USING FIREARM IN/NEAR SCHOO...',
	  '18:922S.M': '18:922S.M            UNLAWFUL TRANSFER OF HANDGUN TO AN U...',
	  '18:922T.M': '18:922T.M            ILLEGAL TRANSFER OF FIREARMS TO AN U...',
	  '18:922U.F': '18:922U.F            STEALING A FIREARM FROM A LICENSED D...',
	  '18:922W.F': '18:922W.F            TRANSFER OR POSSESS A LARGE CAP AMMU...',
	  '18:922X.M': '18:922X.M            TRANSFER OF WEAPONS TO A JUVENILE',
	  '18:923.F': '18:923.F             FIREARMS LICENSING',
	  '18:924A.F': '18:924A.F            PENALTIES FOR FIREARMS',
	  '18:924A.M': '18:924A.M            LICENSE VIOLATION (FRAUD) 18.922M',
	  '18:924B.F': '18:924B.F            PENALTIES FOR FIREARMS',
	  '18:924C.F': '18:924C.F            VIOLENT CRIME/DRUGS/MACHINE GUN',
	  '18:924D.F': '18:924D.F            SEIZURE, FORFEITURE AND DISPOSITION ...',
	  '18:924E.F': '18:924E.F            ARMED CAREER CRIMINAL',
	  '18:924F.F': '18:924F.F            INTERDICT/SUPPLY FIREARM/DRUG TRAFFI...',
	  '18:924G.F': '18:924G.F            KNOWING TRANSFER ARMS USED IN VIOLEN...',
	  '18:924H.F': '18:924H.F            TRANSFER OF FIREARM-USE IN VIOLENT C...',
	  '18:924I.F': '18:924I.F            STEAL IMPORTED OR INTERSTATE SHIPPED...',
	  '18:924J.F': '18:924J.F            VIOLENT CRIME/DRUGS/MACHINE GUN WHER...',
	  '18:924K.F': '18:924K.F            STEAL IMPORTED/INTERSTATE SHIPPED WE...',
	  '18:924L.F': '18:924L.F            STEAL IMPORTED/INTERSTATE SHIPPED WE...',
	  '18:924N.F': '18:924N.F            TO TRAVEL TO ANOTHER STATE TO ENGAGE...',
	  '18:924O.F': '18:924O.F            CONSPIRACY TO COMMIT A VIOLENT CRIME...',
	  '18:929.F': '18:929.F             USE OF RESTRICTED AMMUNITION',
	  '18:930.F': '18:930.F             POSSESS W/INTENT/USE IN CRIME  (T)',
	  '18:930.M': '18:930.M             ATTEMPT/POSSESS/CAUSE/WEAPON IN FEDE...',
	  '18:931.F': '18:931.F             PROHIBT PURCHASE,OWN,POSSES OF BODY ...',
	  '18:951.F': '18:951.F             IMPERSONATING AGENTS OF FOREIGN GOVE...',
	  '18:952.F': '18:952.F             DIPLOMATIC  CODES AND CORRESPONDENCE',
	  '18:953.F': '18:953.F             PRIVATE CORRESPONDENCE W/FOREIGN GOV...',
	  '18:954.F': '18:954.F             FALSE STATEMENTS INFLUENCING FOREIGN...',
	  '18:955.F': '18:955.F             FINANCIAL TRANSACTIONS W/FOREIGN GOV...',
	  '18:956.F': '18:956.F             CONSPIRACY TO INJURE PROPERTY OF FOR...',
	  '18:957.F': '18:957.F             POSSESSING PROP IN AID OF FOREIGN GO...',
	  '18:958.F': '18:958.F             COMMISSION TO SERVE AGAINST FRIENDLY...',
	  '18:959.F': '18:959.F             ENLISTMENT IN FOREIGN SERVICE',
	  '18:960.F': '18:960.F             EXPEDITION AGAINST FRIENDLY NATION',
	  '18:961.M': '18:961.M             STRENGTHENING ARMED VESSEL OF FOREIG...',
	  '18:962.F': '18:962.F             ARMING VESSEL AGAINST FRIENDLY NATION',
	  '18:963.F': '18:963.F             DETENTION OF ARMED VESSEL',
	  '18:964.F': '18:964.F             DELIVER ARMED VESSEL TO HOSTILE NATION',
	  '18:965.F': '18:965.F             VERIFYING STATEMENTS BEFORE VESSEL D...',
	  '18:966.F': '18:966.F             DEPARTURE OF VESSEL FORBIDDEN/FALSE ...',
	  '18:967.F': '18:967.F             DEPARTURE OF VESSEL FORBIDDEN/AID NE...',
	  '18:970.F': '18:970.F             PROTECT PROPERTY OCCUPIED BY FOREIGN...',
	  '18:970.P': '18:970.P             PROTECT PROPERTY OCCUPIED BY FOREIGN...',
	  '18:981.F': '18:981.F             CIVIL FORFEITURE',
	  '18:982.F': '18:982.F             CRIMINAL FORFEITURE',
	  '19:1304.M': '19:1304.M            MARKING OF IMPORTED ARTICLES AND CON...',
	  '19:1305.M': '19:1305.M            IMPORTATION OF IMMORAL ARTICLES',
	  '19:1341.M': '19:1341.M            INTERFERENCE WITH FUNCTIONS OF COMMI...',
	  '19:1433.F': '19:1433.F            REPORT OF ARRIVAL OF VESSELS, VEHICL...',
	  '19:1433.M': '19:1433.M            REPORT OF ARRIVAL OF VESSELS, VEHICL...',
	  '19:1436.F': '19:1436.F            FORGED, ALTERED DOCUMENT ON ENTRY',
	  '19:1436.M': '19:1436.M            FAILURE TO REPORT OR ENTER VESSEL: A...',
	  '19:1445.P': '19:1445.P            FAILURE TO HAVE PERMIT/CERTIFIED MAN...',
	  '19:1459.M': '19:1459.M            REPORTING REQUIREMENTS - CUSTOM DUTIES',
	  '19:1459.P': '19:1459.P            CONTIGUOUS COUNTRIES, REPORT AND MAN...',
	  '19:1460.P': '19:1460.P            PENALTIES FOR FAILURE TO FILE MANIFEST',
	  '19:1461.F': '19:1461.F            FAILURE TO DECLARE NARCOTICS',
	  '19:1464.F': '19:1464.F            PENALTIES IN CONNECTION WITH SEALED ...',
	  '19:1465.F': '19:1465.F            SUPPLIES - CUSTOM LAWS',
	  '19:1465.P': '19:1465.P            SUPPLIES - CUSTOM LAWS',
	  '19:1497.P': '19:1497.P            FAILURE TO DECLARE  (T)',
	  '19:1581.P': '19:1581.P            FAILURE TO STOP FOR CUSTOMS OFFICER',
	  '19:1585.M': '19:1585.M            DEPARTURE BEFORE REPORT ON ENTRY',
	  '19:1586.F': '19:1586.F            UNLAWFUL UNLOADING OF MERCHANDISE',
	  '19:1590=CI.F': '19:1590=CI.F         MARITIME DRUG LAWS - CONTROLLED SUBS...',
	  '19:1590=MI.F': '19:1590=MI.F         MARITIME DRUG LAWS - MARIJUANA',
	  '19:1590=NI.F': '19:1590=NI.F         MARITIME DRUG LAWS - NARCOTICS',
	  '19:1603.M': '19:1603.M            SEIZURE: CUSTOMS OFFICER\'S REPORTS',
	  '19:1919.F': '19:1919.F            FALSE STATEMENT DESIGNED TO INFLUENC...',
	  '19:1975.M': '19:1975.M            FALSE STATEMENTS MADE IN CONNECTION ...',
	  '19:2349.F': '19:2349.F            MAKE FALSE CLAIMS FOR UNEMPLOYMENT B...',
	  '19:283.F': '19:283.F             DUTY ON SALOON STORES',
	  '19:286.P': '19:286.P             DEPARTURE FOR PLACE WHERE THERE IS N...',
	  '19:287.P': '19:287.P             REPORT AND UNLADING CARGOES',
	  '19:290.P': '19:290.P             DEPARTURE FROM WHERE THERE IS NO CUS...',
	  '19:291.P': '19:291.P             FORMS',
	  '19:460.P': '19:460.P             PENALTY FOR FAILURE TO REPORT OR TO ...',
	  '19:468.P': '19:468.P             STAMPS AND BRANDS EFFACED ON EMPTYIN...',
	  '19:469.M': '19:469.M             DEAL IN/USE EMPTY STAMPED IMPORT LIQ...',
	  '19:469.P': '19:469.P             DEALING IN OR USING EMPTY STAMPED IM...',
	  '19:507.M': '19:507.M             REFUSAL TO ASSIST CUSTOMS OFFICER',
	  '19:507.P': '19:507.P             REFUSAL TO ASSIST CUSTOMS OFFICER',
	  '19:60.P': '19:60.P              EXTORTION',
	  '19:70.P': '19:70.P              OBSTRUCTION OF REVENUE OFFICERS BY M...',
	  '19:81.P': '19:81.P              OFFENSES',
	  '20:1087.F': '20:1087.F            EMBEZZLES ANY FUNDS BY FRAUD OR FORGERY',
	  '20:1087.M': '20:1087.M            EMBEZZLES ANY FUNDS BY FRAUD OR FORGERY',
	  '20:10874.F': '20:10874.F           EMBEZZLES ANY FUNDS BY FRAUD OR FORGERY',
	  '20:10874.M': '20:10874.M           EMBEZZLES ANY FUNDS BY FRAUD OR FORGERY',
	  '20:1097A.F': '20:1097A.F           EMBEZZLEMENT, STEALING, FRAUD, FALSE...',
	  '20:1097A.M': '20:1097A.M           EMBEZZLEMENT, STEALING, FRAUD, FALSE...',
	  '20:1097B.M': '20:1097B.M           FALSE STATEMENTS, FALSE INFORMATION',
	  '20:1097C.M': '20:1097C.M           UNLAWFUL PAYMENTS TO ELIGIBLE LENDERS',
	  '20:1097D.F': '20:1097D.F           DESTRUCTION OR CONCEALMENT OF RECORDS',
	  '21:1037.M': '21:1037.M            ADULTERATED OR MISBRANDED EGGS USED ...',
	  '21:104.F': '21:104.F             IMPORTATION OF DISEASED ANIMALS PROH...',
	  '21:1041A.F': '21:1041A.F           PENALTIES: SCOPE OF LIABILITY',
	  '21:1041A.M': '21:1041A.M           PENALTIES: SCOPE OF LIABILITY',
	  '21:1041C.F': '21:1041C.F           PENALTIES',
	  '21:111.M': '21:111.M             REGULATIONS TO PREVENT CONTAGIOUS DI...',
	  '21:115.M': '21:115.M             TRANSPORTATION OF DISEASED LIVESTOCK...',
	  '21:117.M': '21:117.M             NOTICE OF EXISTENCE OF CONTAGION TO ...',
	  '21:1175.P': '21:1175.P            CONFIDENTIALITY OF PATIENT RECORDS',
	  '21:120.M': '21:120.M             REGULATIONS OF EXPORT/TRANSPORTATION...',
	  '21:122.M': '21:122.M             OFFENSES: PENALTY',
	  '21:124.M': '21:124.M             TRANSPORTATION OR DELIVERY OF QUARAN...',
	  '21:126.M': '21:126.M             MOVING QUARANTINED ANIMALS AND LIVE ...',
	  '21:134A.M': '21:134A.M            SEIZURE, QUARANTINE,AND DISPOSAL OF ...',
	  '21:134B.M': '21:134B.M            REGULATIONS FOR CLEAN AND SANITARY M...',
	  '21:134C.M': '21:134C.M            REGULATIONS FOR MOVEMENT OF ANIMALS ...',
	  '21:134D.M': '21:134D.M            INSPECTIONS AND SEIZURES: ISSUANCE O...',
	  '21:134E.M': '21:134E.M            PENALTIES: ENFORCEMENT PROVISIONS',
	  '21:135.F': '21:135.F             SMUGGLING PENALTIES',
	  '21:141.M': '21:141.M             PROHIBITION OF IMPORTATION WITHOUT P...',
	  '21:142.M': '21:142.M             MILK OR CREAM WHEN UNFIT FOR IMPORTA...',
	  '21:143.M': '21:143.M             INSPECTION: CERTIFIED STATEMENT IN L...',
	  '21:144.M': '21:144.M             UNLAWFUL RECEIVING OF IMPORTED MILK/...',
	  '21:145.M': '21:145.M             PENALTIES',
	  '21:151.M': '21:151.M             PREPARE AND SELL HARMFUL PRODUCTS FO...',
	  '21:152.M': '21:152.M             IMPORTATION REGULATED AND PROHIBITED',
	  '21:153.M': '21:153.M             INSPECTION OF IMPORTS: DENIAL OF ENTRY',
	  '21:154.M': '21:154.M             REGULATIONS FOR PREPARATION AND SALE...',
	  '21:155.M': '21:155.M             PERMITS FOR IMPORTATION',
	  '21:157.M': '21:157.M             INSPECTION - DAYTIME OR NIGHTTIME',
	  '21:158.M': '21:158.M             OFFENSES: PUNISHMENT',
	  '21:16.P': '21:16.P              INTRODUCTION OR SALE OF DAIRY - FOOD...',
	  '21:17.P': '21:17.P              INTRODUCE FALSELY LABELED/BRAND FOOD...',
	  '21:1904.F': '21:1904.F            INTERNATIONAL NARCOTICS TRAFFICKING',
	  '21:1906.F': '21:1906.F            INTERNATIONAL NARCOTICS TRAFFICKING',
	  '21:20.P': '21:20.P              APPLES IN INTERSTATE COMMERCE: STAND...',
	  '21:201.P': '21:201.P             PRACTICING PHARMACY WITHOUT A LICENSE',
	  '21:203.P': '21:203.P             APPLICATION FOR PHARMACY LICENSE: QU...',
	  '21:205.P': '21:205.P             DISPLAY OF LICENSE IN PHARMACY',
	  '21:207.P': '21:207.P             RESTRICTIONS ON SALES: WRITTEN ORDER',
	  '21:209.P': '21:209.P             RESTRICTIONS ON SALES: POISONS, LABE...',
	  '21:21.P': '21:21.P              MISBRANDED BARRELS',
	  '21:210.P': '21:210.P             PHARMACIST: UNAUTHORIZED USE OF TITLE',
	  '21:211.P': '21:211.P             PRESERVATION OF ORIGINALS OF PRESCRI...',
	  '21:212.P': '21:212.P             OFFENSES: PUNISHMENT: DUTY TO ENFORC...',
	  '21:213.P': '21:213.P             FRAUD. REPRESENTATION TO EVADE/DEFEA...',
	  '21:22.P': '21:22.P              APPLES IN INTERSTATE COMMERCE: BARRE...',
	  '21:23.P': '21:23.P              PENALTIES',
	  '21:331A.F': '21:331A.F            ADULTERATION OR MISBRANDING OF ANY F...',
	  '21:331A.M': '21:331A.M            ADULTERATION OR MISBRANDING OF ANY F...',
	  '21:331B.F': '21:331B.F            ADULTERATION OR MISBRANDING OF ANY F...',
	  '21:331B.M': '21:331B.M            ADULTERATION OR MISBRANDING OF ANY F...',
	  '21:331C.F': '21:331C.F            RECEIPT IN INTERSTATE COMMERCE OF AN...',
	  '21:331C.M': '21:331C.M            RECEIPT IN INTERSTATE COMMERCE OF AN...',
	  '21:331D.F': '21:331D.F            VIOLATIONS OF 21-344 OR 21-355',
	  '21:331D.M': '21:331D.M            VIOLATIONS OF 21-344 OR 21-355',
	  '21:331E.F': '21:331E.F            REFUSAL TO PERMIT ACCESS TO OR COPYI...',
	  '21:331E.M': '21:331E.M            REFUSAL TO PERMIT ACCESS TO OR COPYI...',
	  '21:331F.F': '21:331F.F            REFUSAL TO PERMIT ENTRY OR INSPECTION',
	  '21:331F.M': '21:331F.M            REFUSAL TO PERMIT ENTRY OR INSPECTION',
	  '21:331G.F': '21:331G.F            MANUFACTURE OF ADULTERATED OR MISBRA...',
	  '21:331G.M': '21:331G.M            MANUFACTURE OF ADULTERATED OR MISBRA...',
	  '21:331H.F': '21:331H.F            FALSE GUARANTY  (T)',
	  '21:331H.M': '21:331H.M            FALSE GUARANTY  (T)',
	  '21:331I.F': '21:331I.F            FALSIFICATION OF ID REQUIRED BY REGU...',
	  '21:331I.M': '21:331I.M            FALSIFICATION OF ID REQUIRED BY REGU...',
	  '21:331J.F': '21:331J.F            USING OR REVEALING OF TRADE SECRETS',
	  '21:331J.M': '21:331J.M            USING OR REVEALING OF TRADE SECRETS',
	  '21:331K.F': '21:331K.F            AFFECTING THE LABEL TO CAUSE MISBRAN...',
	  '21:331K.M': '21:331K.M            AFFECTING THE LABEL TO CAUSE MISBRAN...',
	  '21:331L.F': '21:331L.F            MISREPRESENTING COMPLIANCE',
	  '21:331L.M': '21:331L.M            MISREPRESENTING COMPLIANCE',
	  '21:331M.F': '21:331M.F            SALE OF COLORED OLEOMARGARINE IN VIO...',
	  '21:331M.M': '21:331M.M            SALE OF COLORED OLEOMARGARINE IN VIO...',
	  '21:331N.F': '21:331N.F            PROMOTING PRODUCTS BY USING ANY REPORT',
	  '21:331N.M': '21:331N.M            PROMOTING PRODUCTS BY USING ANY REPORT',
	  '21:331O.F': '21:331O.F            FAILURE TO TRANSMIT INFORMATION ABOU...',
	  '21:331O.M': '21:331O.M            FAILURE TO TRANSMIT INFORMATION ABOU...',
	  '21:331P.F': '21:331P.F            FAILURE TO REGISTER AS REQUIRED',
	  '21:331P.M': '21:331P.M            FAILURE TO REGISTER AS REQUIRED',
	  '21:331Q.F': '21:331Q.F            FAILURE OR REFUSAL TO COMPLY',
	  '21:331Q.M': '21:331Q.M            FAILURE OR REFUSAL TO COMPLY',
	  '21:331T.F': '21:331T.F            PROHIBITED ACTS - IMPORTING DRUGS',
	  '21:331T.M': '21:331T.M            PROHIBITED ACTS - IMPORTING DRUGS',
	  '21:332.F': '21:332.F             ADULTERATION OR MISBRANDING OF ANY F...',
	  '21:333A.M': '21:333A.M            VIOLATION OF SEC. 331 OF THIS TITLE',
	  '21:333B.F': '21:333B.F            PRESCRIPTION DRUG MARKETING',
	  '21:333E.F': '21:333E.F            TRAFFIC IN STEROIDS, DISTRIBUTE/POSS...',
	  '21:334.F': '21:334.F             ADULTERATION OR MISBRANDING OF ANY F...',
	  '21:353.M': '21:353.M             FOOD, DRUG AND COSMETIC ACT OF 1972',
	  '21:458A.F': '21:458A.F            SLAUGHTER POULTRY IN COMPLIANCE WITH...',
	  '21:458A.M': '21:458A.M            SLAUGHTER POULTRY IN COMPLIANCE WITH...',
	  '21:458B.F': '21:458B.F            SIMULATION OF OFFICIAL CERTIFICATE P...',
	  '21:458B.M': '21:458B.M            SIMULATION OF OFFICIAL CERTIFICATE P...',
	  '21:458C.F': '21:458C.F            FORGERY OF OFFICIAL DEVICE, MARK OR ...',
	  '21:458C.M': '21:458C.M            FORGERY OF OFFICIAL DEVICE, MARK OR ...',
	  '21:459.F': '21:459.F             COMPLIANCE BY ALL ESTABLISHMENTS',
	  '21:459.M': '21:459.M             COMPLIANCE BY ALL ESTABLISHMENTS',
	  '21:460A.F': '21:460A.F            PROHIBITION OF INSPECTION OF ARTICLES',
	  '21:460A.M': '21:460A.M            PROHIBITION OF INSPECTION OF ARTICLES',
	  '21:460B.F': '21:460B.F            RECORDKEEPING REQUIREMENTS',
	  '21:460B.M': '21:460B.M            RECORDKEEPING REQUIREMENTS',
	  '21:460C.F': '21:460C.F            REGISTRATION OF BUSINESS, NAME OF PE...',
	  '21:460C.M': '21:460C.M            REGISTRATION OF BUSINESS, NAME OF PE...',
	  '21:460D.F': '21:460D.F            REGULATION OF TRANSACTIONS, TRANSPOR...',
	  '21:460D.M': '21:460D.M            REGULATION OF TRANSACTIONS, TRANSPOR...',
	  '21:461A.F': '21:461A.F            VIOLATIONS: LIABILITY OF AGENTS - EM...',
	  '21:461A.M': '21:461A.M            VIOLATIONS: LIABILITY OF AGENTS - EM...',
	  '21:461C.F': '21:461C.F            AGGRAVATED OR FELONIOUS ASSAULT',
	  '21:463.F': '21:463.F             RULES AND REGULATIONS',
	  '21:463.M': '21:463.M             RULES AND REGULATIONS',
	  '21:466.F': '21:466.F             COMPLIANCE WITH STANDARDS AND REGULA...',
	  '21:466.M': '21:466.M             COMPLIANCE WITH STANDARDS AND REGULA...',
	  '21:610A.F': '21:610A.F            SLAUGHTER AND PREPARE ANIMALS FOR HU...',
	  '21:610A.M': '21:610A.M            SLAUGHTER AND PREPARE ANIMALS FOR HU...',
	  '21:610B.F': '21:610B.F            SELL OR TRANSPORT ADULTERATED OR MIS...',
	  '21:610B.M': '21:610B.M            SELL OR TRANSPORT ADULTERATED OR MIS...',
	  '21:610C.F': '21:610C.F            CAUSE ADULTERATION/MISBRANDING IN TR...',
	  '21:610C.M': '21:610C.M            CAUSE ADULTERATION/MISBRANDING IN TR...',
	  '21:611A.F': '21:611A.F            SIMULATION OF DEVICES, MARKS, LABELS...',
	  '21:611A.M': '21:611A.M            SIMULATION OF DEVICES, MARKS, LABELS...',
	  '21:611B.F': '21:611B.F            FORGERY OF OFFICIAL DEVICE, MARK OR ...',
	  '21:611B.M': '21:611B.M            FORGERY OF OFFICIAL DEVICE, MARK OR ...',
	  '21:62.M': '21:62.M              MANUFACTURE/SHIP/DELIVER SHIPMENT IN...',
	  '21:620.F': '21:620.F             KNOWING OF IMPORTATION OF PROHIBITED...',
	  '21:620.M': '21:620.M             KNOWING OF IMPORTATION OF PROHIBITED...',
	  '21:622.F': '21:622.F             BRIBERY OF INSPECTORS OR OTHER OFFICERS',
	  '21:622.M': '21:622.M             BRIBERY OF INSPECTORS OR OTHER OFFICERS',
	  '21:63.M': '21:63.M              PENALTIES - VIOLATION OF LAW: ACTS, ...',
	  '21:642.F': '21:642.F             RECORDKEEPING REQUIREMENTS',
	  '21:642.M': '21:642.M             RECORDKEEPING REQUIREMENTS',
	  '21:675A.F': '21:675A.F            ASSAULT, RESISTING, IMPEDING, MURDER...',
	  '21:675B.F': '21:675B.F            ASSAULT, RESISTING, IMPEDING, MURDER...',
	  '21:675C.F': '21:675C.F            MURDER',
	  '21:676.F': '21:676.F             INTENT TO DEFRAUD AND DISTRIBUTE ADU...',
	  '21:676.M': '21:676.M             INTENT TO DEFRAUD AND DISTRIBUTE ADU...',
	  '21:825A=CD.F': '21:825A=CD.F         LABELING OF CONTROLLED SUBSTANCES',
	  '21:825A=CD.M': '21:825A=CD.M         LABELING OF CONTROLLED SUBSTANCES',
	  '21:825B=CD.F': '21:825B=CD.F         LABELING OF CONTROLLED SUBSTANCES',
	  '21:825B=CD.M': '21:825B=CD.M         LABELING OF CONTROLLED SUBSTANCES',
	  '21:825C=CD.F': '21:825C=CD.F         LABELING OF CONTROLLED SUBSTANCES',
	  '21:825C=CD.M': '21:825C=CD.M         LABELING OF CONTROLLED SUBSTANCES',
	  '21:825D=CD.F': '21:825D=CD.F         LABELING OF CONTROLLED SUBSTANCES',
	  '21:825D=CD.M': '21:825D=CD.M         LABELING OF CONTROLLED SUBSTANCES',
	  '21:829A=CR.F': '21:829A=CR.F         PRESCRIPTION DRUGS - RECORDS',
	  '21:829A=CR.M': '21:829A=CR.M         PRESCRIPTION DRUGS - RECORDS',
	  '21:829B=CR.F': '21:829B=CR.F         PRESCRIPTION DRUGS - RECORDS',
	  '21:829B=CR.M': '21:829B=CR.M         PRESCRIPTION DRUGS - RECORDS',
	  '21:829C=CR.F': '21:829C=CR.F         PRESCRIPTION DRUGS - RECORDS',
	  '21:829C=CR.M': '21:829C=CR.M         PRESCRIPTION DRUGS - RECORDS',
	  '21:830A=CD.F': '21:830A=CD.F         PIPERIDINE REPORTING',
	  '21:841A=CD.F': '21:841A=CD.F         CONTROLLED SUBSTANCE - SELL, DISTRIB...',
	  '21:841A=CD.M': '21:841A=CD.M         CONTROLLED SUBSTANCE - SELL, DISTRIB...',
	  '21:841A=CM.F': '21:841A=CM.F         CONTROLLED SUBSTANCE - MANUFACTURE',
	  '21:841A=CM.M': '21:841A=CM.M         CONTROLLED SUBSTANCE - MANUFACTURE',
	  '21:841A=MD.F': '21:841A=MD.F         MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
	  '21:841A=MD.M': '21:841A=MD.M         MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
	  '21:841A=MM.F': '21:841A=MM.F         MARIJUANA - MANUFACTURE',
	  '21:841A=ND.F': '21:841A=ND.F         NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
	  '21:841A=ND.M': '21:841A=ND.M         NARCOTICS - SELL, DISTRIBUTE OR DISP...',
	  '21:841A=NM.F': '21:841A=NM.F         NARCOTICS - MANUFACTURE',
	  '21:841A=NP.F': '21:841A=NP.F         NARCOTICS - POSSESSION',
	  '21:841A=NP.M': '21:841A=NP.M         NARCOTICS - POSSESSION',
	  '21:841B=CC.M': '21:841B=CC.M         DRUG CULTIVATION',
	  '21:841B=CD.F': '21:841B=CD.F         CONTROLLED SUBSTANCE - SELL, DISTRIB...',
	  '21:841B=CD.M': '21:841B=CD.M         CONTROLLED SUBSTANCE - SELL, DISTRIB...',
	  '21:841B=CM.F': '21:841B=CM.F         CONTROLLED SUBSTANCE - MANUFACTURE',
	  '21:841B=CM.M': '21:841B=CM.M         CONTROLLED SUBSTANCE - MANUFACTURE',
	  '21:841B=CP.F': '21:841B=CP.F         CONTROLLED SUBSTANCE - POSSESSION',
	  '21:841B=MD.F': '21:841B=MD.F         MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
	  '21:841B=MD.M': '21:841B=MD.M         MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
	  '21:841B=MM.F': '21:841B=MM.F         MARIJUANA - MANUFACTURE',
	  '21:841B=MM.M': '21:841B=MM.M         MARIJUANA - MANUFACTURE',
	  '21:841B=MP.F': '21:841B=MP.F         MARIJUANA - POSSESSION',
	  '21:841B=MP.M': '21:841B=MP.M         MARIJUANA - POSSESSION',
	  '21:841B=ND.F': '21:841B=ND.F         NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
	  '21:841B=ND.M': '21:841B=ND.M         NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
	  '21:841B=NM.F': '21:841B=NM.F         NARCOTICS - MANUFACTURE',
	  '21:841B=NM.M': '21:841B=NM.M         NARCOTICS - MANUFACTURE',
	  '21:841B=NP.F': '21:841B=NP.F         NARCOTICS - POSSESSION',
	  '21:841C=CD.F': '21:841C=CD.F         CONTROLLED SUBSTANCE-SELL, DISTRIBUT...',
	  '21:841C=CM.F': '21:841C=CM.F         CONTROLLED SUBSTANCE-SELL, DISTRIBUT...',
	  '21:841D=CD.F': '21:841D=CD.F         CONTROLLED SUBSTANCE - SELL, DISTRIB...',
	  '21:841D=CM.F': '21:841D=CM.F         CONTROLLED SUBSTANCE - MANUFACTURE',
	  '21:841D=NM.F': '21:841D=NM.F         NARCOTICS - MANUFACTURE',
	  '21:841D=NR.F': '21:841D=NR.F         NARCOTICS - RECORDS, RX\'S, FRAUDULEN...',
	  '21:841E=CD.F': '21:841E=CD.F         CONTROLLED SUBSTANCE - SELL, DISTRIB...',
	  '21:841E=CM.F': '21:841E=CM.F         CONTROLLED SUBSTANCE - MANUFACTURE',
	  '21:841E=MD.F': '21:841E=MD.F         MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
	  '21:841E=MM.F': '21:841E=MM.F         MARIJUANA - MANUFACTURE',
	  '21:841E=ND.F': '21:841E=ND.F         NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
	  '21:841E=NM.F': '21:841E=NM.F         NARCOTICS - MANUFACTURE',
	  '21:841F.F': '21:841F.F            WRONGFUL DISTRIBUTION OR POSSESSION ...',
	  '21:841F.M': '21:841F.M            WRONGFUL DISTRIBUTION OR POSSESSION ...',
	  '21:841G=CD.F': '21:841G=CD.F         CONTROLLED SUBSTANCE - SELL, DISTRIB...',
	  '21:841G=CI.F': '21:841G=CI.F         CONTROLLED SUBSTANCE - IMPORTATION/E...',
	  '21:841G=CI.M': '21:841G=CI.M         CONTROLLED SUBSTANCE - IMPORTATION/E...',
	  '21:841G=CP.F': '21:841G=CP.F         CONTROLLED SUBSTANCE - POSSESSION',
	  '21:841G=MD.F': '21:841G=MD.F         MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
	  '21:841G=MI.F': '21:841G=MI.F         MARIJUANA - IMPORTATION/EXPORTATION',
	  '21:841G=MI.M': '21:841G=MI.M         MARIJUANA - IMPORTATION/EXPORTATION',
	  '21:841G=MP.M': '21:841G=MP.M         MARIJUANA - POSSESSION',
	  '21:841G=ND.F': '21:841G=ND.F         NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
	  '21:841G=NI.F': '21:841G=NI.F         NARCOTICS - IMPORTATION/EXPORTATION',
	  '21:841G=NI.M': '21:841G=NI.M         NARCOTICS - IMPORTATION/EXPORTATION',
	  '21:841G=NP.M': '21:841G=NP.M         NARCOTICS - POSSESSION',
	  '21:842A=CD.F': '21:842A=CD.F         DISTRIBUTE/DISPENSE A CONTROLLED SUB...',
	  '21:842A=CD.M': '21:842A=CD.M         DISTRIBUTE/DISPENSE A CONTROLLED SUB...',
	  '21:842A=CM.F': '21:842A=CM.F         MANUFACTURE A CONTROLLED SUBSTANCE',
	  '21:842A=CM.M': '21:842A=CM.M         MANUFACTURE A CONTROLLED SUBSTANCE',
	  '21:842A=CR.F': '21:842A=CR.F         CONTROLLED SUBSTANCES - RECORDS AND ...',
	  '21:842A=CR.M': '21:842A=CR.M         CONTROLLED SUBSTANCES - RECORDS AND ...',
	  '21:842A=ND.F': '21:842A=ND.F         DISTRIBUTE/DISPENSE A NARCOTIC',
	  '21:842A=ND.M': '21:842A=ND.M         DISTRIBUTE/DISPENSE A NARCOTIC',
	  '21:842A=NM.F': '21:842A=NM.F         MANUFACTURE A NARCOTIC',
	  '21:842A=NM.M': '21:842A=NM.M         MANUFACTURE A NARCOTIC',
	  '21:842A=NR.F': '21:842A=NR.F         NARCOTICS - RECORDS AND RX\'S',
	  '21:842A=NR.M': '21:842A=NR.M         NARCOTICS - RECORDS AND RX\'S',
	  '21:842C=CD.F': '21:842C=CD.F         PENALTIES FOR VIOLATIONS OF SUBSECTI...',
	  '21:842C=CR.F': '21:842C=CR.F         PENALTIES FOR VIOLATIONS OF SUBSECTI...',
	  '21:843A=CD.F': '21:843A=CD.F         UNLAWFUL ACTS - CONTROLLED SUBSTANCE...',
	  '21:843A=CM.F': '21:843A=CM.F         UNLAWFUL ACTS - CONTROLLED SUBSTANCE...',
	  '21:843A=CP.F': '21:843A=CP.F         UNLAWFUL ACTS - CONTROLLED SUBSTANCE...',
	  '21:843A=CR.F': '21:843A=CR.F         UNLAWFUL ACTS - CONTROLLED SUBSTANCE...',
	  '21:843B=CD.F': '21:843B=CD.F         USE COMMUNICATIONS FACILITY - CONTRO...',
	  '21:843B=MD.F': '21:843B=MD.F         USE COMMUNICATIONS FACILITY - MARIJU...',
	  '21:843B=MI.F': '21:843B=MI.F         USE COMMUNICATIONS FACILITY - MARIJU...',
	  '21:843B=ND.F': '21:843B=ND.F         USE COMMUNICATIONS FACILITY - NARCOT...',
	  '21:843B=NI.F': '21:843B=NI.F         USE COMMUNICATIONS FACILITY - NARCOT...',
	  '21:844A=CP.F': '21:844A=CP.F         CONTROLLED SUBSTANCE - POSSESSION',
	  '21:844A=CP.M': '21:844A=CP.M         CONTROLLED SUBSTANCE - POSSESSION',
	  '21:844A=MP.F': '21:844A=MP.F         MARIJUANA - POSSESSION',
	  '21:844A=MP.M': '21:844A=MP.M         MARIJUANA - POSSESSION',
	  '21:844A=NP.F': '21:844A=NP.F         NARCOTICS - POSSESSION',
	  '21:844A=NP.M': '21:844A=NP.M         NARCOTICS - POSSESSION',
	  '21:845=CD.F': '21:845=CD.F          CONTENTS OF THIS SUBSECTION TRANSFER...',
	  '21:846=CD.F': '21:846=CD.F          CONSPIRACY TO DISTRIBUTE CONTROLLED ...',
	  '21:846=CD.M': '21:846=CD.M          CONSPIRACY TO DISTRIBUTE CONTROLLED ...',
	  '21:846=CI.F': '21:846=CI.F          CONSPIRACY TO IMPORT A CONTROL SUBST...',
	  '21:846=CM.F': '21:846=CM.F          CONSPIRACY TO MANUFACTURE CONTROLLED...',
	  '21:846=CM.M': '21:846=CM.M          CONSPIRACY TO MANUFACTURE CONTROLLED...',
	  '21:846=CP.F': '21:846=CP.F          CONSPIRACY TO POSSESS CONTROLLED SUB...',
	  '21:846=CP.M': '21:846=CP.M          CONSPIRACY TO POSSESS CONTROLLED SUB...',
	  '21:846=CR.F': '21:846=CR.F          CONSPIRACY TO MAKE FALSE RX\'S - CONT...',
	  '21:846=CR.M': '21:846=CR.M          CONSPIRACY TO MAKE FALSE RX\'S - CONT...',
	  '21:846=MD.F': '21:846=MD.F          CONSPIRACY TO DISTRIBUTE MARIJUANA',
	  '21:846=MD.M': '21:846=MD.M          CONSPIRACY TO DISTRIBUTE MARIJUANA',
	  '21:846=MM.F': '21:846=MM.F          CONSPIRACY TO MANUFACTURE MARIJUANA',
	  '21:846=MM.M': '21:846=MM.M          CONSPIRACY TO MANUFACTURE MARIJUANA',
	  '21:846=MP.F': '21:846=MP.F          CONSPIRACY TO POSSESS MARIJUANA',
	  '21:846=MP.M': '21:846=MP.M          CONSPIRACY TO POSSESS MARIJUANA',
	  '21:846=ND.F': '21:846=ND.F          CONSPIRACY TO DISTRIBUTE NARCOTICS',
	  '21:846=ND.M': '21:846=ND.M          CONSPIRACY TO DISTRIBUTE NARCOTICS',
	  '21:846=NI.F': '21:846=NI.F          CONSPIRACY TO IMPORT NARCOTICS',
	  '21:846=NM.F': '21:846=NM.F          CONSPIRACY TO MANUFACTURE NARCOTICS',
	  '21:846=NM.M': '21:846=NM.M          CONSPIRACY TO MANUFACTURE NARCOTICS',
	  '21:846=NP.F': '21:846=NP.F          CONSPIRACY TO POSSESS NARCOTICS',
	  '21:846=NP.M': '21:846=NP.M          CONSPIRACY TO POSSESS NARCOTICS',
	  '21:846=NR.F': '21:846=NR.F          CONSPIRACY TO MAKE FALSE RX\'S - NARC...',
	  '21:846=NR.M': '21:846=NR.M          CONSPIRACY TO MAKE FALSE RX\'S - NARC...',
	  '21:848.F': '21:848.F             CONTINUING CRIMINAL ENTERPRISE',
	  '21:848E.F': '21:848E.F            CONTINUING CRIMINAL ENTERPRISE',
	  '21:849B=CD.F': '21:849B=CD.F         DISTR OF CONTROLLED SUBST W/IN 1000F...',
	  '21:849C=CD.F': '21:849C=CD.F         DISTR OF CNTRLLD SUBST W/IN 1000FT T...',
	  '21:851.F': '21:851.F             PROCEEDINGS TO ESTABLISH PRIOR CONVI...',
	  '21:853.F': '21:853.F             CRIMINAL FORFEITURES',
	  '21:854.F': '21:854.F             INVEST ILLICIT DRUG PROFITS',
	  '21:856=CD.F': '21:856=CD.F          Controlled Substance Sell/Distribute...',
	  '21:856=CM.F': '21:856=CM.F          CONTROLLED SUBSTANCE - MANUFACTURE',
	  '21:856=MD.F': '21:856=MD.F          Marijuana - Sell, Distribute, Dispense',
	  '21:856=MM.F': '21:856=MM.F          MARIJUANA - MANUFACTURE',
	  '21:856=ND.F': '21:856=ND.F          Narcotics - Sell, Distribute, Dispense',
	  '21:856=NM.F': '21:856=NM.F          NARCOTICS - MANUFACTURE',
	  '21:858.F': '21:858.F             ENDANGERING LIFE MANUFACTURING CONTR...',
	  '21:859A=CD.F': '21:859A=CD.F         DISTRIBUTE TO PERSONS UNDER 21/CONTR...',
	  '21:859A=MD.F': '21:859A=MD.F         DISTRIBUTE TO PERSONS UNDER 21/MARIJ...',
	  '21:859A=MD.M': '21:859A=MD.M         DISTRIBUTE TO PERSONS UNDER 21/MARIJ...',
	  '21:859A=ND.F': '21:859A=ND.F         DISTRIBUTE TO PERSONS UNDER 21/NARCOTIC',
	  '21:859B=CD.F': '21:859B=CD.F         DISTRIBUTE TO PERSONS UNDER 21/CONTR...',
	  '21:859B=MD.F': '21:859B=MD.F         DISTRIBUTE TO PERSONS UNDER 21/MARIJ...',
	  '21:859B=ND.F': '21:859B=ND.F         DISTRIBUTE TO PERSONS UNDER 21/NARCO...',
	  '21:860A=CD.F': '21:860A=CD.F         DISTRIBUTE IN OR NEAR SCHOOLS/CONTRO...',
	  '21:860A=CM.F': '21:860A=CM.F         MANUFACTURE/DISTRIBUTE IN OR NEAR SC...',
	  '21:860A=MD.F': '21:860A=MD.F         DISTRIBUTE IN OR NEAR SCHOOLS/MARIJUANA',
	  '21:860A=MM.F': '21:860A=MM.F         MANUFACTURE/DISTRIBUTE IN OR NEAR SC...',
	  '21:860A=ND.F': '21:860A=ND.F         DISTRIBUTE IN OR NEAR SCHOOLS/NARCOTICS',
	  '21:860A=NM.F': '21:860A=NM.F         MANUFACTURE/DISTRIBUTE IN OR NEAR SC...',
	  '21:861A.F': '21:861A.F            EMPLOY PERSONS UNDER 18',
	  '21:861C.F': '21:861C.F            EMPLOY PERSONS UNDER 18',
	  '21:861D.F': '21:861D.F            EMPLOY PERSONS UNDER 18',
	  '21:861F.F': '21:861F.F            EMPLOY PERSONS UNDER 18',
	  '21:863A.F': '21:863A.F            MAIL ORDER DRUG PARAPHERNALIA',
	  '21:952=CI.F': '21:952=CI.F          CONTROLLED SUBSTANCE - IMPORT',
	  '21:952=MI.F': '21:952=MI.F          MARIJUANA - IMPORT',
	  '21:952=NI.F': '21:952=NI.F          NARCOTICS - IMPORT',
	  '21:952A=CI.F': '21:952A=CI.F         CONTROLLED SUBSTANCES - IMPORT',
	  '21:952A=MI.F': '21:952A=MI.F         MARIJUANA - IMPORT',
	  '21:952A=NI.F': '21:952A=NI.F         NARCOTICS - IMPORT',
	  '21:952B=CI.F': '21:952B=CI.F         CONTROLLED SUBSTANCES - IMPORT',
	  '21:952B=MI.F': '21:952B=MI.F         MARIJUANA - IMPORT',
	  '21:953=CI.F': '21:953=CI.F          CONTROLLED SUBSTANCE - EXPORT',
	  '21:953=MI.F': '21:953=MI.F          MARIJUANA -  EXPORT',
	  '21:953=NI.F': '21:953=NI.F          NARCOTICS - EXPORT',
	  '21:953A=CI.F': '21:953A=CI.F         CONTROLLED SUBSTANCES - EXPORT',
	  '21:953A=NI.F': '21:953A=NI.F         NARCOTICS - EXPORT',
	  '21:953C=CI.F': '21:953C=CI.F         CONTROLLED SUBSTANCES - EXPORT',
	  '21:953E=CI.F': '21:953E=CI.F         CONTROLLED SUBSTANCES - EXPORT',
	  '21:954=CI.M': '21:954=CI.M          TRANS-SHIPMENT OF CONTROLLED SUBSTANCES',
	  '21:955=CP.F': '21:955=CP.F          TRANSFERRED TO 46:APPX 1901 1904',
	  '21:957=CI.F': '21:957=CI.F          REGISTER TO IMPORT CONTROLLED SUBSTA...',
	  '21:957=MI.F': '21:957=MI.F          REGISTER TO IMPORT MARIJUANA',
	  '21:957=NI.F': '21:957=NI.F          REGISTER TO IMPORT NARCOTICS',
	  '21:959=CD.F': '21:959=CD.F          MANUF./DISTR. FOR ILLEGAL IMPORTATIO...',
	  '21:959=CD.M': '21:959=CD.M          MANUF./DISTR. FOR ILLEGAL IMPORTATIO...',
	  '21:959=CM.F': '21:959=CM.F          MANUF./DISTR. FOR ILLEGAL IMPORTATIO...',
	  '21:959=CM.M': '21:959=CM.M          MANUF./DISTR. FOR ILLEGAL IMPORTATIO...',
	  '21:959=MD.F': '21:959=MD.F          MANUFACTURE/DISTRIBUTE FOR ILLEGAL I...',
	  '21:959=MD.M': '21:959=MD.M          MANUFACTURE/DISTRIBUTE FOR ILLEGAL I...',
	  '21:959=MM.F': '21:959=MM.F          MANUFACTURE/DISTRIBUTE FOR ILLEGAL I...',
	  '21:959=MM.M': '21:959=MM.M          MANUFACTURE/DISTRIBUTE FOR ILLEGAL I...',
	  '21:959=ND.F': '21:959=ND.F          MANUFACTURE/DISTRIBUTE FOR ILLEGAL I...',
	  '21:959=ND.M': '21:959=ND.M          MANUFACTURE/DISTRIBUTE FOR ILLEGAL I...',
	  '21:959=NM.F': '21:959=NM.F          MANUFACTURE/DISTRIBUTE FOR ILLEGAL I...',
	  '21:959=NM.M': '21:959=NM.M          MANUFACTURE/DISTRIBUTE FOR ILLEGAL I...',
	  '21:960A=CI.F': '21:960A=CI.F         CONTROLLED SUBSTANCE - IMPORTATION/E...',
	  '21:960A=MI.F': '21:960A=MI.F         MARIJUANA-IMPORTATION/EXPORTATION',
	  '21:960A=NI.F': '21:960A=NI.F         NARCOTICS - IMPORTATION/EXPORTATION',
	  '21:960B=CD.F': '21:960B=CD.F         CONTROLLED SUBSTANCE - SELL, DISTRIB...',
	  '21:960B=CD.M': '21:960B=CD.M         CONTROLLED SUBSTANCE - SELL, DISTRIB...',
	  '21:960B=CI.F': '21:960B=CI.F         CONTROLLED SUBSTANCE - IMPORTATION/E...',
	  '21:960B=CM.F': '21:960B=CM.F         CONTROLLED SUBSTANCE - MANUFACTURE',
	  '21:960B=CM.M': '21:960B=CM.M         CONTROLLED SUBSTANCE - MANUFACTURE',
	  '21:960B=CP.F': '21:960B=CP.F         CONTROLLED SUBSTANCE - POSSESSION',
	  '21:960B=MD.F': '21:960B=MD.F         MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
	  '21:960B=MD.M': '21:960B=MD.M         MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
	  '21:960B=MI.F': '21:960B=MI.F         MARIJUANA - IMPORTATION/EXPORTATION',
	  '21:960B=MM.F': '21:960B=MM.F         MARIJUANA - MANUFACTURE',
	  '21:960B=MM.M': '21:960B=MM.M         MARIJUANA - MANUFACTURE',
	  '21:960B=MP.F': '21:960B=MP.F         MARIJUANA - POSSESSION',
	  '21:960B=ND.F': '21:960B=ND.F         NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
	  '21:960B=ND.M': '21:960B=ND.M         NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
	  '21:960B=NI.F': '21:960B=NI.F         NARCOTICS - IMPORTATION/EXPORTATION',
	  '21:960B=NM.F': '21:960B=NM.F         NARCOTICS - MANUFACTURE',
	  '21:960B=NM.M': '21:960B=NM.M         NARCOTICS - MANUFACTURE',
	  '21:960B=NP.F': '21:960B=NP.F         NARCOTICS - POSSESSION',
	  '21:960D=CI.F': '21:960D=CI.F         CONTROLLED SUBSTANCE - IMPORTATION/E...',
	  '21:960D=NI.F': '21:960D=NI.F         NARCOTICS - IMPORTATION/EXPORTATION',
	  '21:961=CI.M': '21:961=CI.M          CONTROLLED SUBSTANCE - IMPORTATION/E...',
	  '21:962=CD.F': '21:962=CD.F          CONTROLLED SUBSTANCE - SELL, DISTRIB...',
	  '21:962=CD.M': '21:962=CD.M          CONTROLLED SUBSTANCE - SELL, DISTRIB...',
	  '21:962=CI.F': '21:962=CI.F          CONTROLLED SUBSTANCE - IMPORTATION/E...',
	  '21:962=CM.F': '21:962=CM.F          CONTROLLED SUBSTANCE - MANUFACTURE',
	  '21:962=CM.M': '21:962=CM.M          CONTROLLED SUBSTANCE - MANUFACTURE',
	  '21:962=CP.F': '21:962=CP.F          CONTROLLED SUBSTANCE - POSSESSION',
	  '21:962=MD.F': '21:962=MD.F          MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
	  '21:962=MD.M': '21:962=MD.M          MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
	  '21:962=MI.F': '21:962=MI.F          MARIJUANA - IMPORTATION/EXPORTATION',
	  '21:962=MM.F': '21:962=MM.F          MARIJUANA - MANUFACTURE',
	  '21:962=MM.M': '21:962=MM.M          MARIJUANA - MANUFACTURE',
	  '21:962=MP.F': '21:962=MP.F          MARIJUANA - POSSESSION',
	  '21:962=ND.F': '21:962=ND.F          NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
	  '21:962=ND.M': '21:962=ND.M          NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
	  '21:962=NI.F': '21:962=NI.F          NARCOTICS - IMPORTATION/EXPORTATION',
	  '21:962=NM.F': '21:962=NM.F          NARCOTICS - MANUFACTURE',
	  '21:962=NM.M': '21:962=NM.M          NARCOTICS - MANUFACTURE',
	  '21:962=NP.F': '21:962=NP.F          NARCOTICS - POSSESSION',
	  '21:963=CD.F': '21:963=CD.F          ATTEMPT/CONSPIRACY - CONTROLLED SUBS...',
	  '21:963=CD.M': '21:963=CD.M          ATTEMPT/CONSPIRACY - CONTROLLED SUBS...',
	  '21:963=CI.F': '21:963=CI.F          ATTEMPT/CONSPIRACY - CONTROLLED SUBS...',
	  '21:963=CI.M': '21:963=CI.M          ATTEMPT/CONSPIRACY - CONTROLLED SUBS...',
	  '21:963=CM.F': '21:963=CM.F          ATTEMPT/CONSPIRACY - CONTROLLED SUBS...',
	  '21:963=CM.M': '21:963=CM.M          ATTEMPT/CONSPIRACY - CONTROLLED SUBS...',
	  '21:963=CP.F': '21:963=CP.F          ATTEMPT/CONSPIRACY - CONTROLLED SUBS...',
	  '21:963=MD.F': '21:963=MD.F          ATTEMPT/CONSPIRACY - MARIJUANA - SEL...',
	  '21:963=MD.M': '21:963=MD.M          ATTEMPT/CONSPIRACY - MARIJUANA - SEL...',
	  '21:963=MI.F': '21:963=MI.F          ATTEMPT/CONSPIRACY - MARIJUANA - IMP...',
	  '21:963=MM.F': '21:963=MM.F          ATTEMPT/CONSPIRACY - MARIJUANA - MAN...',
	  '21:963=MM.M': '21:963=MM.M          ATTEMPT/CONSPIRACY - MARIJUANA - MAN...',
	  '21:963=MP.F': '21:963=MP.F          ATTEMPT/CONSPIRACY - MARIJUANA - POS...',
	  '21:963=ND.F': '21:963=ND.F          ATTEMPT/CONSPIRACY - NARCOTICS - SEL...',
	  '21:963=ND.M': '21:963=ND.M          ATTEMPT/CONSPIRACY - NARCOTICS - SEL...',
	  '21:963=NI.F': '21:963=NI.F          ATTEMPT/CONSPIRACY - NARCOTICS - IMP...',
	  '21:963=NM.F': '21:963=NM.F          ATTEMPT/CONSPIRACY - NARCOTICS - MAN...',
	  '21:963=NM.M': '21:963=NM.M          ATTEMPT/CONSPIRACY - NARCOTICS - MAN...',
	  '21:963=NP.F': '21:963=NP.F          ATTEMPT/CONSPIRACY - NARCOTICS - POS...',
	  '21:971.F': '21:971.F             IMPORTATION AND EXPORTATION OF LISTE...',
	  '22:1178.F': '22:1178.F            FAILURE TO GIVE BOND AS ADMINISTRATOR',
	  '22:1179.F': '22:1179.F            EMBEZZLEMENT',
	  '22:1182.M': '22:1182.M            PENALTY: EXCESSIVE FEES FOR VERIFICA...',
	  '22:1198.F': '22:1198.F            EMBEZZLEMENT OF FEES OR EFFECTS OF A...',
	  '22:1199.F': '22:1199.F            ACTION ON BOND: NEGLECT OF DUTY OR M...',
	  '22:1199.M': '22:1199.M            ACTION ON BOND: NEGLECT OF DUTY OR M...',
	  '22:1200.F': '22:1200.F            FALSE CERTIFICATE AS TO OWNERSHIP OF...',
	  '22:1203.F': '22:1203.F            DEPOSITIONS AND NOTARIAL ACTS: PERJURY',
	  '22:1631.F': '22:1631.F            PENALTIES',
	  '22:1642.M': '22:1642.M            VALIDITY AND AMOUNT OF CLAIMS',
	  '22:1643.M': '22:1643.M            VALIDITY AND AMOUNT OF CLAIMS',
	  '22:1978.M': '22:1978.M            IMPORTATION OF FISH PRODUCTS FROM OF...',
	  '22:1978C.M': '22:1978C.M           IMPORTATION OF FISH PRODUCTS FROM OF...',
	  '22:1978D.M': '22:1978D.M           RESTRICTION ON IMPORTATION OF FISHER...',
	  '22:1980.M': '22:1980.M            PENALTY FOR FALSE OR MISLEADING STAT...',
	  '22:252.F': '22:252.F             SUITS AGAINST MINISTERS AND THEIR DO...',
	  '22:253.F': '22:253.F             PENALTY FOR WRONGFUL SUIT',
	  '22:277.M': '22:277.M             ATTORNEY\'S FEE: PENALTIES',
	  '22:2778.F': '22:2778.F            ATTEMPTED EXPORTATION OF ARMS AND MU...',
	  '22:2778B.F': '22:2778B.F           REGISTRATION AND LICENSING REQUIREMENTS',
	  '22:2778C.F': '22:2778C.F           CRIMINAL VIOLATIONS',
	  '22:2797.F': '22:2797.F            ARMS EXPORT CONTROL - LICENSING',
	  '22:286.F': '22:286.F             DISCLOSURE OF INFORMATION, UNLAWFUL',
	  '22:287.F': '22:287.F             ENFORCEMENT OF ECONOMIC AND COMMERCI...',
	  '22:4198.F': '22:4198.F            FAILURE TO GIVE BOND AS ADMINISTRATOR',
	  '22:4199.F': '22:4199.F            EMBEZZLEMENT - PENALTIES',
	  '22:4202.M': '22:4202.M            PENALTY: EXCESSIVE FEES FOR VERIFICA...',
	  '22:4217.F': '22:4217.F            EMBEZZLEMENT OF FEES OR EFFECTS OF A...',
	  '22:4218.F': '22:4218.F            FALSE CERTIFICATE AS TO OWNERSHIP OF...',
	  '22:4221.F': '22:4221.F            DEPOSITIONS AND NOTARIAL ACTS: PERJURY',
	  '22:447.F': '22:447.F             FINANCIAL TRANSACTIONS WITH NATIONS ...',
	  '22:447A.F': '22:447A.F            FINANCIAL TRANSACTIONS WITH NATIONS ...',
	  '22:447C.F': '22:447C.F            FINANCIAL TRANSACTIONS WITH NATIONS ...',
	  '22:448.F': '22:448.F             SOLICITATION AND COLLECTION OF FUNDS',
	  '22:450.F': '22:450.F             RESTRICTIONS ON USE OF AMERICAN PORTS',
	  '22:451.F': '22:451.F             SUBMARINES AND ARMED MERCHANT VESSELS',
	  '22:455.F': '22:455.F             GENERAL PENALTY PROVISION',
	  '22:5113A.F': '22:5113A.F           ANTI-APARTHEID PROGRAM',
	  '22:5113C.F': '22:5113C.F           GOLD COIN IMPORT  (T)',
	  '22:5113D.F': '22:5113D.F           UNTRUE STATEMENTS/OMISSION OF MATERI...',
	  '22:612.F': '22:612.F             REGISTRATION STATEMENT: FILING OF OR...',
	  '22:614A.F': '22:614A.F            FILING AND LABELING OF POLITICAL PRO...',
	  '22:614B.P': '22:614B.P            FILING AND LABELING OF POLITICAL PRO...',
	  '22:614E.P': '22:614E.P            FILING AND LABELING OF POLITICAL PRO...',
	  '22:614F.P': '22:614F.P            FILING AND LABELING OF POLITICAL PRO...',
	  '22:615.F': '22:615.F             BOOKS AND RECORDS, UNLAWFUL TO FALSIFY',
	  '22:617.F': '22:617.F             LIABILITY OF OFFICERS',
	  '22:618A.F': '22:618A.F            VIOLATIONS: FALSE STATEMENTS AND WIL...',
	  '22:618G.P': '22:618G.P            DEFICIENT REGISTRATION STATEMENT',
	  '22:618H.P': '22:618H.P            CONTINGENT FEE ARRANGEMENT',
	  '22D:103-0100.M': '22D:103-0100.M       ATTEMPTED MURDER',
	  '22D:103-0200.M': '22D:103-0200.M       ATTEMPTED MURDER 2ND DEGREE',
	  '22D:103-0300.M': '22D:103-0300.M       ATTEMPTED MANSLAUGHTER',
	  '22D:103-1400.M': '22D:103-1400.M       ATTEMPTED ROBBERY',
	  '22D:103-1500.M': '22D:103-1500.M       ATTEMPTED ASSAULT',
	  '22D:103-1600.M': '22D:103-1600.M       ATTEMPTED ASSAULT, OTHER',
	  '22D:103-1601.M': '22D:103-1601.M       MISDEMEANOR, ON GOVERNMENT OFFICIAL',
	  '22D:103-2400.M': '22D:103-2400.M       ATTEMPTED BURGLARY',
	  '22D:103-3700.M': '22D:103-3700.M       ATTEMPTED THEFT',
	  '22D:103-3800.M': '22D:103-3800.M       ATTEMPTED THEFT',
	  '22D:103-4390.M': '22D:103-4390.M       ATTEMPTED EMBEZZLEMENT',
	  '22D:103-4999.M': '22D:103-4999.M       ATTEMPTS TO COMMIT CRIME',
	  '22D:103-5200.M': '22D:103-5200.M       ATTEMPTS TO COMMIT CRIME',
	  '22D:103-5720.M': '22D:103-5720.M       FORGERY, OTHER',
	  '22D:103-6100.M': '22D:103-6100.M       ATTEMPT TO RAPE',
	  '22D:103-6300.M': '22D:103-6300.M       ATTEMPTS TO COMMIT CRIME',
	  '22D:103-7100.M': '22D:103-7100.M       ATTEMPTS TO COMMIT CRIME',
	  '22D:103-7310.M': '22D:103-7310.M       ATTEMPTS TO COMMIT CRIME',
	  '22D:103-7400.M': '22D:103-7400.M       ATTEMPTS TO COMMIT CRIME',
	  '22D:103-7500.M': '22D:103-7500.M       ATTEMPTS TO COMMIT CRIME',
	  '22D:103-7610.M': '22D:103-7610.M       ATTEMPTS TO COMMIT CRIME',
	  '22D:103-7800.M': '22D:103-7800.M       FIREARMS AND WEAPONS',
	  '22D:103-7820.M': '22D:103-7820.M       FIREARMS, UNLAWFUL POSSESSION',
	  '22D:103-7990.M': '22D:103-7990.M       MISCELLANEOUS GENERAL OFFENSES, OTHER',
	  '22D:105.F': '22D:105.F            FRAUD, CONSPIRACY (GENERAL), OTHER',
	  '22D:106.F': '22D:106.F            ACCESSORIES AFTER THE FACT',
	  '22D:1306.F': '22D:1306.F           IMPERSONATING A POLICE OFFICIAL',
	  '22D:1306.M': '22D:1306.M           IMPERSONATING A POLICE OFFICER',
	  '22D:1402.M': '22D:1402.M           FORGERY LABELS',
	  '22D:1410.M': '22D:1410.M           FORGERY, CHECKS OR DRAFTS',
	  '22D:1411.P': '22D:1411.P           FALSE ADVERTISEMENT',
	  '22D:1501.F': '22D:1501.F           OPERATING A LOTTERY',
	  '22D:1502.M': '22D:1502.M           POSSESSION OF LOTTERY OR POLICE TICKETS',
	  '22D:1505.F': '22D:1505.F           ILLEGAL GAMBLING',
	  '22D:1505.M': '22D:1505.M           ILLEGAL GAMBLING',
	  '22D:1506.F': '22D:1506.F           GAMBLING AND LOTTERY',
	  '22D:1508.M': '22D:1508.M           GAMBLING - ATHLETIC CONTEST',
	  '22D:1801A.F': '22D:1801A.F          BURGLARY, OTHER',
	  '22D:1801B.F': '22D:1801B.F          BREAKING AND ENTERING',
	  '22D:2101.F': '22D:2101.F           CONSPIRACY',
	  '22D:2307.F': '22D:2307.F           EXTORTION, RACKETEERING, AND THREATS',
	  '22D:2401.F': '22D:2401.F           MURDER, FIRST DEGREE',
	  '22D:2402.F': '22D:2402.F           MURDER, FIRST DEGREE',
	  '22D:2403.F': '22D:2403.F           MURDER, SECOND DEGREE',
	  '22D:2404.F': '22D:2404.F           MURDER, SECOND DEGREE',
	  '22D:2405.F': '22D:2405.F           MANSLAUGHTER',
	  '22D:2601.F': '22D:2601.F           ESCAPE',
	  '22D:2603.F': '22D:2603.F           MISCELLANEOUS GENERAL OFFENSES, OTHER',
	  '22D:2701.P': '22D:2701.P           INVITE FOR PROSTITUTION',
	  '22D:2705.F': '22D:2705.F           PANDERING',
	  '22D:2801.F': '22D:2801.F           UNLAWFUL CARNAL KNOWLEDGE',
	  '22D:2901.F': '22D:2901.F           ROBBERY, OTHER',
	  '22D:2902.F': '22D:2902.F           ATTEMPTED ROBBERY',
	  '22D:3102.P': '22D:3102.P           UNLAWFUL ENTRY',
	  '22D:3202A.F': '22D:3202A.F          ARMED ROBBERY',
	  '22D:3203.M': '22D:3203.M           FIREARMS AND WEAPONS - PISTOL',
	  '22D:3204.F': '22D:3204.F           FIREARMS AND WEAPONS - CONCEALED WEAPON',
	  '22D:3204.M': '22D:3204.M           FIREARMS AND WEAPONS - CONCEALED WEAPON',
	  '22D:3212.F': '22D:3212.F           FIREARMS AND WEAPONS - DEFACE A WEAPON',
	  '22D:3212.M': '22D:3212.M           FIREARMS AND WEAPONS - DEFACE A WEAPON',
	  '22D:3214.F': '22D:3214.F           FIREARMS, UNLAWFUL POSSESSION',
	  '22D:3214.M': '22D:3214.M           FIREARMS, UNLAWFUL POSSESSION',
	  '22D:3215A.F': '22D:3215A.F          TRANSPORTING HOMEMADE BOMBS',
	  '22D:3215A.M': '22D:3215A.M          TRANSPORTING HOMEMADE BOMBS',
	  '22D:3427.F': '22D:3427.F           BREAKING AND ENTERING A VENDING MACHINE',
	  '22D:3501A.F': '22D:3501A.F          INDECENT ACTS WITH CHILDREN',
	  '22D:3501B.F': '22D:3501B.F          INDECENT ACTS WITH CHILDREN',
	  '22D:3502.F': '22D:3502.F           SODOMY',
	  '22D:3601.F': '22D:3601.F           POSSESSION OF CRIME IMPLEMENTS',
	  '22D:3601.M': '22D:3601.M           POSSESSION OF CRIME IMPLEMENTS',
	  '22D:3811.F': '22D:3811.F           LARCENY AND THEFT, FELONY OTHER',
	  '22D:3811.M': '22D:3811.M           LARCENY AND THEFT, MISDEMEANOR OTHER',
	  '22D:3813.P': '22D:3813.P           SHOPLIFTING',
	  '22D:3814.M': '22D:3814.M           COMMERCIAL PIRACY',
	  '22D:3815B.F': '22D:3815B.F          AUTO THEFT, OTHER',
	  '22D:3815C.F': '22D:3815C.F          AUTO THEFT, OTHER',
	  '22D:3816.P': '22D:3816.P           LARCENY AND THEFT, MISDEMEANOR OTHER',
	  '22D:3821A.F': '22D:3821A.F          FRAUD',
	  '22D:3821A.M': '22D:3821A.M          FRAUD',
	  '22D:3821B.F': '22D:3821B.F          FRAUD',
	  '22D:3821B.M': '22D:3821B.M          FRAUD',
	  '22D:3823.F': '22D:3823.F           CREDIT CARD FRAUD',
	  '22D:3823.M': '22D:3823.M           CREDIT CARD FRAUD',
	  '22D:3824.P': '22D:3824.P           FRAUDULENT REGISTRATION',
	  '22D:3831.F': '22D:3831.F           TRAFFICKING IN STOLEN PROPERTY',
	  '22D:3832.F': '22D:3832.F           RECEIVING STOLEN PROPERTY',
	  '22D:3832.M': '22D:3832.M           RECEIVING STOLEN PROPERTY',
	  '22D:3841.F': '22D:3841.F           FORGERY, OTHER U. S.',
	  '22D:3842A.F': '22D:3842A.F          PENALTIES - GOVERNMENT BONDS, FORGERY',
	  '22D:3842B.F': '22D:3842B.F          PENALTIES - CORPORATIONS AND ORGANIZ...',
	  '22D:3842C.F': '22D:3842C.F          PENALTIES - CORPORATIONS AND ORGANIZ...',
	  '22D:3851.F': '22D:3851.F           EXTORTION',
	  '22D:3852.F': '22D:3852.F           BLACKMAIL',
	  '22D:401.F': '22D:401.F            ARSON',
	  '22D:403.M': '22D:403.M            ARSON',
	  '22D:501.F': '22D:501.F            AGGRAVATED OR FELONIOUS ASSAULT',
	  '22D:502.F': '22D:502.F            ASSAULT WITH A DEADLY WEAPON',
	  '22D:503.F': '22D:503.F            ASSAULT WITH INTENT TO COMMIT CARNAL...',
	  '22D:504.M': '22D:504.M            ASSAULT, OTHER',
	  '22D:505A.F': '22D:505A.F           ASSAULT OR IMPEDE A POLICE OFFICER',
	  '22D:505B.F': '22D:505B.F           ASSAULT OR IMPEDE AN OFFICER WITH WE...',
	  '22D:506.F': '22D:506.F            MAYHEM AND MALICIOUS DISFIGUREMENT',
	  '22D:507.F': '22D:507.F            ASSAULTS WITHIN MARITIME AND TERRITO...',
	  '22D:507.M': '22D:507.M            ASSAULTS WITHIN MARITIME AND TERRITO...',
	  '22D:507.P': '22D:507.P            ASSAULT, OTHER',
	  '22D:508.F': '22D:508.F            ASSAULTING, BEATING, FIGHTING',
	  '22D:713.F': '22D:713.F            BRIBERY, PENALTIES',
	  '22DC:1406.P': '22DC:1406.P          FALSE PERSONATION OF POLICE OFFICER',
	  '22DC:1502.P': '22DC:1502.P          FORGING OR IMITATING BRANDS OR PACKA...',
	  '22DC:1510.F': '22DC:1510.F          MAKING, DRAWING. OR ALTERING CHECK, ...',
	  '22DC:1510.P': '22DC:1510.P          MAKING, DRAWING, OR ALTERING CHECK, ...',
	  '22DC:1511.P': '22DC:1511.P          FRAUDULENT ADVERTISING.',
	  '22DC:1701.F': '22DC:1701.F          LOTTERIES; PROMOTIONS; SALE OR POSSE...',
	  '22DC:1702.P': '22DC:1702.P          POSSESSION OF LOTTERY OR POLICY TICK...',
	  '22DC:1705.F': '22DC:1705.F          GAMBLING PREMISES; SUBSEQUENT OFFENSES',
	  '22DC:1705.P': '22DC:1705.P          GAMBLING PREMISES; PROHIBITION AGAIN...',
	  '22DC:1706.P': '22DC:1706.P          THREE-CARD MONTE AND CONFIDENCE GAMES',
	  '22DC:1708.P': '22DC:1708.P          GAMBLING POOLS AND BOOKMAKING',
	  '22DC:1805.F': '22DC:1805.F          PERSONS ADVISING, INCITING, OR CONNI...',
	  '22DC:1805A.F': '22DC:1805A.F         CONSPIRACY TO COMMIT CRIME',
	  '22DC:1806.F': '22DC:1806.F          ACCESSORIES AFTER THE FACT',
	  '22DC:1810.F': '22DC:1810.F          THREATENING TO KIDNAP OR INJURE A PE...',
	  '22DC:2001.F': '22DC:2001.F          CONSPIRACY TO KIDNAPPING',
	  '22DC:2101.F': '22DC:2101.F          MURDER IN THE FIRST DEGREE-PURPOSEFU...',
	  '22DC:2102.F': '22DC:2102.F          MURDER IN THE FIRST DEGREE- PLACING ...',
	  '22DC:2103.F': '22DC:2103.F          MURDER SECOND DEGREE- MANSLAUGHTER',
	  '22DC:2104.F': '22DC:2104.F          MURDER IN THE FIRST AND SECOND DEGREE',
	  '22DC:2105.F': '22DC:2105.F          PENALTY FOR MANSLAUGHTER',
	  '22DC:2501.F': '22DC:2501.F          POSSESSIONS OF IMPLEMENTS OF CRIME A...',
	  '22DC:2501.M': '22DC:2501.M          POSSESSIONS OF IMPLEMENTS OF CRIME A...',
	  '22DC:2501.P': '22DC:2501.P          POSSESSION OF IMPLEMENTS OF CRIME',
	  '22DC:2601.F': '22DC:2601.F          ESCAPE FROM INSTITUTION OR OFFICER',
	  '22DC:2603.F': '22DC:2603.F          INTRODUCING CONTRABAND INTO PENAL IN...',
	  '22DC:2701.P': '22DC:2701.P          INVITING FOR PURPOSES OF PROSTITUTIO...',
	  '22DC:2705.F': '22DC:2705.F          PANDERING; INDUCING OR COMPELLING AN...',
	  '22DC:2801.F': '22DC:2801.F          ROBBERY',
	  '22DC:2802.F': '22DC:2802.F          ATTEMPT TO COMMIT ROBBERY',
	  '22DC:301.F': '22DC:301.F           ARSON',
	  '22DC:303.F': '22DC:303.F           MALICIOUS BURNING, DESTRUCTION, OR I...',
	  '22DC:303.P': '22DC:303.P           MALICIOUS BURNING, DESTRUCTION, OR I...',
	  '22DC:3211.F': '22DC:3211.F          THEFT',
	  '22DC:3213.M': '22DC:3213.M          THEFT',
	  '22DC:3213.P': '22DC:3213.P          SHOPLIFTING',
	  '22DC:3214-01.F': '22DC:3214-01.F       THEFT, RELATED OFFENSES - DECEPTIVE ...',
	  '22DC:3214-01.M': '22DC:3214-01.M       THEFT, RELATED OFFENSES - DECEPTIVE ...',
	  '22DC:3214.P': '22DC:3214.P          THEFT, RELATED OFFENSES - COMMERCIAL...',
	  '22DC:3215.F': '22DC:3215.F          UNAUTHORIZED USE OF MOTOR VEHICLE',
	  '22DC:3216.P': '22DC:3216.P          TAKING PROPERTY WITHOUT RIGHT',
	  '22DC:3221.F': '22DC:3221.F          FRAUD',
	  '22DC:3223.F': '22DC:3223.F          CREDIT CARD FRAUD',
	  '22DC:3223.P': '22DC:3223.P          CREDIT CARD FRAUD',
	  '22DC:3224.P': '22DC:3224.P          FRAUDULENT REGISTRATION',
	  '22DC:3231.F': '22DC:3231.F          TRAFFICKING IN STOLEN PROPERTY',
	  '22DC:3232.F': '22DC:3232.F          RECEIVING STOLEN PROPERTY',
	  '22DC:3232.P': '22DC:3232.P          RECEIVING STOLEN PROPERTY',
	  '22DC:3241.F': '22DC:3241.F          FORGERY',
	  '22DC:3242.F': '22DC:3242.F          PENALTIES FOR FORGERY',
	  '22DC:3251.F': '22DC:3251.F          EXTORTION',
	  '22DC:3252.F': '22DC:3252.F          BLACKMAIL',
	  '22DC:3302.P': '22DC:3302.P          UNLAWFUL ENTRY ON PROPERTY',
	  '22DC:401.F': '22DC:401.F           ASSAULT WITH INTENT TO KILL, ROB, PO...',
	  '22DC:402.F': '22DC:402.F           ASSAULT WITH INTENT TO COMMIT MAYHEM...',
	  '22DC:403.F': '22DC:403.F           ASSAULT WITH INTENT TO COMMIT ANY OT...',
	  '22DC:404-01.F': '22DC:404-01.F        AGGRAVATED ASSAULT',
	  '22DC:404.F': '22DC:404.F           ASSAULT OR THREATENED ASSAULT IN MEN...',
	  '22DC:404.M': '22DC:404.M           ASSAULT OR THREATENED ASSAULT IN A M...',
	  '22DC:404.P': '22DC:404.P           ASSAULT OR THREATENED ASSAULT IN A M...',
	  '22DC:405.F': '22DC:405.F           ASSAULT ON MEMBER OF POLICE FORCE',
	  '22DC:406C.F': '22DC:406C.F          MAYHEM OR MALICIOUSLY DISFIGURING',
	  '22DC:407.M': '22DC:407.M           THREATS TO DO BODILY HARM',
	  '22DC:407.P': '22DC:407.P           THREATS TO DO BODILY HARM',
	  '22DC:601.F': '22DC:601.F           BREAKING AND ENTERING VENDING MACHIN...',
	  '22DC:713.F': '22DC:713.F           BRIBERY OF WITNESS',
	  '22DC:801A.F': '22DC:801A.F          BURGLARY IN THE FIRST DEGREE',
	  '22DC:801B.F': '22DC:801B.F          BURGLARY IN THE 2ND DEGREE',
	  '23D:1327.F': '23D:1327.F           FAILURE TO APPEAR',
	  '23D:1327.M': '23D:1327.M           FAILURE TO APPEAR',
	  '25:202.M': '25:202.M             INDUCING CONVEYANCE OF TRUST',
	  '25:450D.F': '25:450D.F            FRAUDULENT USE OF MONIES FROM GRANTS...',
	  '25:450D.M': '25:450D.M            FRAUDULENT USE OF MONIES FROM GRANTS...',
	  '26:3402.M': '26:3402.M            OTHER MISDEMEANOR',
	  '26:4411.P': '26:4411.P            FRAUD, WAGERING TAX, OTHER',
	  '26:4412.P': '26:4412.P            REGISTRATION',
	  '26:5061.F': '26:5061.F            DISCRETION METHOD OF COLLECTION',
	  '26:5113.M': '26:5113.M            SALES BY PROPERTY OF DISTRIBUTING SP...',
	  '26:5115.M': '26:5115.M            SIGN REQUIRED ON PREMISES',
	  '26:5171.F': '26:5171.F            FILING A FALSE OR FRAUDULENT APPLICA...',
	  '26:5171A.F': '26:5171A.F           DISTILLER REGISTRATION',
	  '26:5171C.F': '26:5171C.F           DISTILLER REGISTRATION',
	  '26:5173.F': '26:5173.F            QUALIFICATION BONDS',
	  '26:5179.F': '26:5179.F            REGISTRATION OF STILLS',
	  '26:5180.M': '26:5180.M            SIGN REQUIREMENTS',
	  '26:5214.F': '26:5214.F            WITHDRAWAL OF DISTILLED SPIRITS',
	  '26:5221.F': '26:5221.F            COMMENCE, SUSPEND, RESUME OPERATIONS',
	  '26:5222.F': '26:5222.F            PRODUCTION, RECEIPT  AND USE OF DIST...',
	  '26:5273.F': '26:5273.F            INTERNAL MEDICINAL PREPARATIONS AND ...',
	  '26:5291.F': '26:5291.F            REQUIREMENTS WHEN DISPOSING OF DENAT...',
	  '26:5301A.M': '26:5301A.M           REQUIREMENTS FOR CONTAINERS OF DISTI...',
	  '26:5301B.M': '26:5301B.M           DISPOSITION OF CONTAINERS FOR DISTIL...',
	  '26:5301C.M': '26:5301C.M           REFILLING OF LIQUOR BOTTLES',
	  '26:5601.F': '26:5601.F            UNLAWFUL PRODUCTION OF DISTILLED SPI...',
	  '26:5602.F': '26:5602.F            PENALTY FOR TAX FRAUD BY DISTILLER',
	  '26:5603A.F': '26:5603A.F           FRAUDULENT NONCOMPLIANCE',
	  '26:5603B.M': '26:5603B.M           FAILURE TO COMPLY',
	  '26:5604.F': '26:5604.F            POSSESS ANY UN-DESTROYED OR UN-DEFAC...',
	  '26:5605.F': '26:5605.F            PENALTIES: RETURN OF MATERIAL USED I...',
	  '26:5606.M': '26:5606.M            PENALTY: CONTAINERS OF DISTILLED SPI...',
	  '26:5607.F': '26:5607.F            PENALTY: FORFEIT FOR UNLAWFUL USE, C...',
	  '26:5608A.F': '26:5608A.F           PENALTY: FRAUDULENT CLAIM FOR DRAWBACK',
	  '26:5608B.F': '26:5608B.F           PENALTY: UNLAWFUL RELANDING',
	  '26:5661A.F': '26:5661A.F           FRAUDULENT OFFENSES',
	  '26:5661B.M': '26:5661B.M           FRAUDULENT OFFENSES',
	  '26:5662.M': '26:5662.M            PENALTY FOR ALTERATION OF WINE LABELS',
	  '26:5671.F': '26:5671.F            PENALTY: FORFEIT FOR BEER TAX EVASION',
	  '26:5672.M': '26:5672.M            PENALTY: FAILURE OF BREWER TO COMPLY',
	  '26:5674.M': '26:5674.M            PENALTY: UNLAWFUL REMOVAL OF BEER',
	  '26:5681A.M': '26:5681A.M           PENALTY RELATING TO SIGNS',
	  '26:5681B.M': '26:5681B.M           PENALTY RELATING TO SIGNS',
	  '26:5681C.M': '26:5681C.M           PENALTY RELATING TO SIGNS',
	  '26:5682.F': '26:5682.F            PENALTY FOR BREAKING LOCKS OR GAININ...',
	  '26:5683.M': '26:5683.M            PENALTY: FORFEIT FOR REMOVAL OF LIQUORS',
	  '26:5685A.F': '26:5685A.F           POSSESSION OF DEVICES FOR EMITTING G...',
	  '26:5685B.F': '26:5685B.F           POSSESSION OF MACHINE GUN, ETC.',
	  '26:5686.M': '26:5686.M            PENALTY: POSSESSING/USING LIQUOR OR ...',
	  '26:5687.M': '26:5687.M            PENALTY: OFFENSES NOT SPECIFICALLY C...',
	  '26:5691.F': '26:5691.F            PENALTY: NONPAYMENT OF SPECIAL TAX -...',
	  '26:5751.F': '26:5751.F            SALE, ETC., OF TOBACCO PRODUCTS AND ...',
	  '26:5752.F': '26:5752.F            RESTRICTIONS RELATED TO MARKS, LABEL...',
	  '26:5762A.F': '26:5762A.F           ENGAGING IN BUSINESS UNLAWFULLY',
	  '26:5762B.M': '26:5762B.M           OTHER OFFENSES',
	  '26:5801.F': '26:5801.F            SPECIAL TAX FOR IMPORTERS, MANUFACTU...',
	  '26:5802.F': '26:5802.F            REGISTRATION OF IMPORTERS, MANUFACTU...',
	  '26:5811.F': '26:5811.F            TAX ON FIREARMS TRANSFERRED',
	  '26:5812.F': '26:5812.F            TRANSFER OF FIREARMS',
	  '26:5821.F': '26:5821.F            TAX ON MAKING OF A FIREARM',
	  '26:5822.F': '26:5822.F            MAKING OF A FIREARM',
	  '26:5841.F': '26:5841.F            REGISTRATION OF FIREARMS',
	  '26:5842.F': '26:5842.F            IDENTIFICATION OF FIREARMS',
	  '26:5843.F': '26:5843.F            RECORDS AND RETURNS FOR IMPORTERS, M...',
	  '26:5844.F': '26:5844.F            IMPORTATION OF FIREARMS UNLAWFUL - E...',
	  '26:5845.F': '26:5845.F            POSSESSION OF A DESTRUCTIVE DEVICE',
	  '26:5851.F': '26:5851.F            SPECIAL TAX EXEMPTION',
	  '26:5861A.F': '26:5861A.F           UNLAWFUL TO IMPORT OR MANUFACTURE FI...',
	  '26:5861B.F': '26:5861B.F           UNLAWFUL TO RECEIVE A FIREARM TRANSF...',
	  '26:5861C.F': '26:5861C.F           UNLAWFUL TO RECEIVE OR POSSESS FIREA...',
	  '26:5861D.F': '26:5861D.F           UNLAWFUL TO RECEIVE A FIREARM NOT RE...',
	  '26:5861E.F': '26:5861E.F           UNLAWFUL TO TRANSFER A FIREARM IN VI...',
	  '26:5861F.F': '26:5861F.F           UNLAWFUL TO MAKE A FIREARM IN VIOLATION',
	  '26:5861G.F': '26:5861G.F           UNLAWFUL TO ALTER OR CHANGE SERIAL N...',
	  '26:5861H.F': '26:5861H.F           UNLAWFUL TO RECEIVE A FIREARM WITH A...',
	  '26:5861I.F': '26:5861I.F           RECEIVE A FIREARM WITHOUT A SERIAL N...',
	  '26:5861J.F': '26:5861J.F           TRANSP./DELIVER/RECEIVE IN INTERSTAT...',
	  '26:5861K.F': '26:5861K.F           RECEIVE A FIREARM IMPORTED IN VIOLATION',
	  '26:5861L.F': '26:5861L.F           KNOWINGLY MAKE A FALSE ENTRY ON APPL...',
	  '26:5871.F': '26:5871.F            PENALTIES - FIREARMS AND WEAPONS',
	  '26:5872A.F': '26:5872A.F           FORFEITURE OF MACHINE GUNS, DESTRUCT...',
	  '26:6047A.M': '26:6047A.M           TRUSTEES AND INSURANCE COMPANIES - R...',
	  '26:6047B.M': '26:6047B.M           OWNER/EMPLOYEES MUST FURNISH PRESCRI...',
	  '26:6047C.M': '26:6047C.M           INFORMATION REQUIRED OF EMPLOYEES - ...',
	  '26:6050I.F': '26:6050I.F           RETURNS RELATING TO CASH REC\'D IN TR...',
	  '26:6050I.M': '26:6050I.M           RETURNS RELATING TO CASH REC\'D IN TR...',
	  '26:6051.M': '26:6051.M            RECEIPTS FOR EMPLOYEES',
	  '26:6331.F': '26:6331.F            LEVY AND DISTRAINT',
	  '26:6420.M': '26:6420.M            EXAMINATION OF BOOKS AND WITNESSES',
	  '26:6420E.M': '26:6420E.M           EXAMINATION OF BOOKS AND WITNESSES',
	  '26:6427.M': '26:6427.M            EXAMINATION OF BOOKS AND WITNESSES',
	  '26:6674.P': '26:6674.P            FRAUDULENT STATEMENT OR FAIL TO FURNISH',
	  '26:7001.M': '26:7001.M            LICENSE FOR COLLECTION OF FOREIGN ITEMS',
	  '26:7121.F': '26:7121.F            CLOSING AGREEMENTS',
	  '26:7122.F': '26:7122.F            COMPROMISES',
	  '26:7201.F': '26:7201.F            ATTEMPT TO EVADE OR DEFEAT TAX',
	  '26:7202.F': '26:7202.F            WILLFUL FAILURE TO COLLECT/PAY OVER TAX',
	  '26:7203C.M': '26:7203C.M           WILLFUL FAILURE TO FILE RETURN, SUPP...',
	  '26:7203D.F': '26:7203D.F           WILLFUL FAILURE TO FILE RETURN/INFOR...',
	  '26:7203D.M': '26:7203D.M           WILLFUL FAILURE TO FILE RETURN, SUPP...',
	  '26:7204.M': '26:7204.M            FRAUDULENT STATEMENT/FAILURE TO MAKE...',
	  '26:7205.M': '26:7205.M            FRAUDULENT WITHHOLDING EXEMPTION CER...',
	  '26:7206A.F': '26:7206A.F           FRAUD AND FALSE STATEMENTS',
	  '26:7206B.F': '26:7206B.F           FRAUD AND FALSE STATEMENTS',
	  '26:7206C.F': '26:7206C.F           DECLARE UNDER PENALTY OF PERJURY',
	  '26:7207.M': '26:7207.M            FRAUDULENT RETURNS, STATEMENTS/OTHER...',
	  '26:7208A.F': '26:7208A.F           OFFENSES RELATING TO STAMPS',
	  '26:7208B.F': '26:7208B.F           OFFENSES RELATING TO STAMPS',
	  '26:7208C.F': '26:7208C.F           OFFENSES RELATING TO STAMPS',
	  '26:7209.P': '26:7209.P            UNAUTHORIZED USE OR SALE OF STAMPS',
	  '26:7210.M': '26:7210.M            FAILURE TO OBEY SUMMONS',
	  '26:7211.M': '26:7211.M            FALSE STATEMENTS TO PURCHASERS/LESSE...',
	  '26:7212A.F': '26:7212A.F           CORRUPT OR FORCIBLE INTERFERENCE',
	  '26:7212A.M': '26:7212A.M           CORRUPT OR FORCIBLE INTERFERENCE',
	  '26:7212B.F': '26:7212B.F           FORCIBLE RESCUE OF SEIZED PROPERTY',
	  '26:7213A.F': '26:7213A.F           UNAUTHORIZED DISCLOSE OF INCOME TAX ...',
	  '26:7213AA.M': '26:7213AA.M          Unauthorized inspection of returns o...',
	  '26:7213B.F': '26:7213B.F           UNAUTHORIZED DISCLOSURE OF OPERATION...',
	  '26:7213C.M': '26:7213C.M           OFFENSE RELATING TO REPRODUCTION OF ...',
	  '26:7213D.M': '26:7213D.M           DISCLOSURES BY CERTAIN DELEGATES',
	  '26:7214A.F': '26:7214A.F           UNLAWFUL ACTS OF REVENUE OFFICERS/AG...',
	  '26:7214B.P': '26:7214B.P           INTEREST OF INTERNAL REVENUE OFFICER...',
	  '26:7215.M': '26:7215.M            OFFENSES WITH RESPECT TO COLLECTED T...',
	  '26:7216.M': '26:7216.M            DISCLOSURE OR USE OF INFORMATION BY ...',
	  '26:7231.M': '26:7231.M            FAILURE TO OBTAIN LICENSE FOR COLLEC...',
	  '26:7232.F': '26:7232.F            FAIL TO REGISTER/FALSE STATEMENT BY ...',
	  '26:7261.P': '26:7261.P            RETAILERS\' EXCISE TAX FRAUD',
	  '26:7262.P': '26:7262.P            VIOLATION OF OCCUPATIONAL TAX LAWS -...',
	  '26:7272A.P': '26:7272A.P           FAILURE TO REGISTER',
	  '26:7275A.P': '26:7275A.P           TAXABLE AIRLINE TICKETS',
	  '26:7275B.P': '26:7275B.P           PRICE ADVERTISING TO INCLUDE COST AN...',
	  '26:7275C.P': '26:7275C.P           PENALTY',
	  '26:7512.M': '26:7512.M            REQUIREMENTS FOR SEPARATE ACCOUNTING',
	  '26:7513.M': '26:7513.M            REGULATIONS FOR REPRODUCTION OF RETURNS',
	  '26:7513B.M': '26:7513B.M           REGULATIONS FOR REPRODUCTION OF RETURNS',
	  '26:7602.M': '26:7602.M            EXAMINATION OF BOOKS AND RECORDS',
	  '26:7603.M': '26:7603.M            SERVICE OF SUMMONS',
	  '26:7604B.M': '26:7604B.M           ENFORCEMENT OF SUMMONS',
	  '26:9012A.M': '26:9012A.M           EXCESS CAMPAIGN EXPENSES',
	  '26:9012B.M': '26:9012B.M           CONTRIBUTIONS',
	  '26:9012C.F': '26:9012C.F           UNLAWFUL USE OF PAYMENTS',
	  '26:9012D.F': '26:9012D.F           FALSE STATEMENTS, ETC.',
	  '26:9012E.F': '26:9012E.F           KICKBACKS AND ILLEGAL PAYMENTS',
	  '26:9012F.M': '26:9012F.M           UNAUTHORIZED EXPENDITURES AND CONTRI...',
	  '26:9012G.M': '26:9012G.M           UNAUTHORIZED DISCLOSURE OF INFORMATION',
	  '26:9035.F': '26:9035.F            QUALIFIED CAMPAIGN EXPENSE LIMITATIONS',
	  '26:9037.F': '26:9037.F            PAYMENTS TO ELIGIBLE CANDIDATES',
	  '26:9042A.F': '26:9042A.F           EXCESS CAMPAIGN EXPENSES',
	  '26:9042B.F': '26:9042B.F           UNLAWFUL USE OF PAYMENTS',
	  '26:9042C.F': '26:9042C.F           FALSE STATEMENTS, ETC.',
	  '26:9042D.F': '26:9042D.F           KICKBACKS AND ILLEGAL PAYMENTS',
	  '27:203.P': '27:203.P             PERMIT REQUIRED TO CONDUCT DISTILLED...',
	  '27:205A.P': '27:205A.P            LIQUORS MUST BE LABELED AS REQUIRED',
	  '27:205B.P': '27:205B.P            UNFAIR COMPETITION - TIED HOUSE',
	  '27:205C.P': '27:205C.P            UNFAIR COMPETITION - COMMERCIAL BRIBERY',
	  '27:205D.P': '27:205D.P            UNFAIR COMPETITION - CONSIGNMENT SALES',
	  '27:205E.P': '27:205E.P            LIQUORS MUST BE LABELED AS REQUIRED',
	  '27:205F.P': '27:205F.P            ADVERTISING ACCORDING TO REGULATIONS',
	  '27:206A.M': '27:206A.M            BULK SALES AND BOTTLING',
	  '27:206B.M': '27:206B.M            PENALTIES',
	  '27:207.P': '27:207.P             PENALTIES',
	  '27:208A.P': '27:208A.P            INTERLOCKING DIRECTORATES',
	  '27:208D.P': '27:208D.P            PENALTIES',
	  '28:1442.F': '28:1442.F            REMOVAL FROM STATE COURT - FEDERAL O...',
	  '28:1442.M': '28:1442.M            REMOVAL FROM STATE COURT - FEDERAL O...',
	  '28:1443.F': '28:1443.F            REMOVAL FROM STATE COURT - CIVIL RIGHTS',
	  '28:1826C.F': '28:1826C.F           ESCAPE FROM FACILITY WHERE CONFINED',
	  '28:1864B.P': '28:1864B.P           FAILURE TO APPEAR AS JUROR',
	  '28:1866G.P': '28:1866G.P           SELECTION AND SUMMONING OF JURY PANELS',
	  '28:2255.F': '28:2255.F            HABEAS CORPUS',
	  '28:2461C.F': '28:2461C.F           CRIMINAL FORFEITURE',
	  '29:1021A.M': '29:1021A.M           BENEFIT PLAN TO BE FURNISHED TO PART...',
	  '29:1021B.M': '29:1021B.M           PLAN DESCRIPTION, CHANGES AND REPORTS',
	  '29:1021C.M': '29:1021C.M           TERMINAL AND SUPPLEMENTARY REPORTS',
	  '29:1022.M': '29:1022.M            PLAN DESCRIPTION TO BE FURNISHED TO ...',
	  '29:1023A.M': '29:1023A.M           PUBLICATION AND FILING OF ANNUAL REP...',
	  '29:1023B.M': '29:1023B.M           FINANCIAL STATEMENT REQUIRED',
	  '29:1023C.M': '29:1023C.M           INFORMATION REQUIRED TO BE FURNISHED...',
	  '29:1023D.M': '29:1023D.M           REPORT TO INCLUDE COMPLETE ACTUARIAL...',
	  '29:1023E.M': '29:1023E.M           STATEMENT FROM COMPANY WHICH SELLS O...',
	  '29:1024A.M': '29:1024A.M           FILING OF ANNUAL REPORT, PLAN DESCRI...',
	  '29:1024B.M': '29:1024B.M           PUBLICATION OF SUMMARY PLAN DESCRIPT...',
	  '29:1024C.M': '29:1024C.M           STATEMENT OF RIGHTS',
	  '29:1025.M': '29:1025.M            REPORTING OF PARTICIPANTS\' BENEFIT R...',
	  '29:1027.M': '29:1027.M            RETENTION OF RECORDS',
	  '29:1111A.F': '29:1111A.F           PERSONS PROHIBITED FROM HOLDING CERT...',
	  '29:1111A.M': '29:1111A.M           PERSONS PROHIBITED FROM HOLDING CERT...',
	  '29:1111B.F': '29:1111B.F           PENALTIES',
	  '29:1111B.M': '29:1111B.M           PENALTIES',
	  '29:1112B.M': '29:1112B.M           UNLAWFUL TO CONTROL FUNDS WITHOUT BE...',
	  '29:1112C.M': '29:1112C.M           CONFLICT OF INTEREST PROHIBITED IN P...',
	  '29:1131.F': '29:1131.F            CRIMINAL PENALTIES FOR VIOLATIONS OF...',
	  '29:1131.M': '29:1131.M            PENALTIES, RETIREMENT INCOME SECURIT...',
	  '29:1141.M': '29:1141.M            COERCIVE INTERFERENCE',
	  '29:162.M': '29:162.M             INTERFERENCE WITH MEMBERS OF THE BOA...',
	  '29:1811.F': '29:1811.F            PERSONS ENGAGED IN FARM LABOR CONTRACTS',
	  '29:1811.M': '29:1811.M            PERSONS ENGAGED IN FARM LABOR CONTRACTS',
	  '29:1816.F': '29:1816.F            EMPLOYING ILLEGAL ALIENS',
	  '29:1816.M': '29:1816.M            EMPLOYING ILLEGAL ALIENS',
	  '29:1821.F': '29:1821.F            WRITTEN DISCLOSURE REQUIREMENTS',
	  '29:1821.M': '29:1821.M            WRITTEN DISCLOSURE REQUIREMENTS',
	  '29:1823.F': '29:1823.F            SAFETY AND HEALTH OF HOUSING',
	  '29:1823.M': '29:1823.M            SAFETY AND HEALTH OF HOUSING',
	  '29:1851.F': '29:1851.F            CRIMINAL SANCTIONS',
	  '29:1851.M': '29:1851.M            CRIMINAL SANCTIONS',
	  '29:186A.F': '29:186A.F            PENALTIES, RETIREMENT INCOME SECURIT...',
	  '29:186A.M': '29:186A.M            PENALTIES, RETIREMENT INCOME SECURIT...',
	  '29:186B.F': '29:186B.F            REQUEST DEMAND FOR MONEY, THING OF V...',
	  '29:186B.M': '29:186B.M            REQUEST DEMAND FOR MONEY, THING OF V...',
	  '29:186D.F': '29:186D.F            PENALTIES FOR VIOLATIONS',
	  '29:186D.M': '29:186D.M            PENALTIES FOR VIOLATIONS',
	  '29:206.M': '29:206.M             MINIMUM WAGE TO BE PAID BY EMPLOYERS',
	  '29:207.M': '29:207.M             MAXIMUM HOURS EMPLOYERS MAY WORK EMP...',
	  '29:211C.M': '29:211C.M            EMPLOYER MUST KEEP RECORDS OF WAGES ...',
	  '29:211D.M': '29:211D.M            REGULATIONS REGARDING INDUSTRIAL HOM...',
	  '29:212.M': '29:212.M             CHILD LABOR PROVISIONS',
	  '29:214.M': '29:214.M             REGULATIONS FOR EMPLOYEES REGARDING ...',
	  '29:215.M': '29:215.M             PROHIBITED ACTS',
	  '29:216.M': '29:216.M             CRIMINAL PENALTY',
	  '29:304.P': '29:304.P             ADMINISTRATOR MUST PUB. DESCRIPTION ...',
	  '29:305A.P': '29:305A.P            TIME FOR PUB. OF DESCRIPTION OF EMPL...',
	  '29:305B.P': '29:305B.P            CONTENTS OF DESCRIPTION OF PENSION PLAN',
	  '29:306.P': '29:306.P             ANNUAL REPORTS OF EMPLOYEE BENEFIT PLAN',
	  '29:307A.P': '29:307A.P            PLAN MUST BE AVAILABLE FOR EXAMINATION',
	  '29:307B.P': '29:307B.P            FILING OF COPIES OF PLAN AND REPORT',
	  '29:308.P': '29:308.P             PENALTY FOR VIOLATIONS',
	  '29:411.M': '29:411.M             FREEDOM OF SPEECH AND ASSEMBLY',
	  '29:436.M': '29:436.M             RETENTION OF RECORDS',
	  '29:439A.M': '29:439A.M            VIOLATION AND PENALTIES FAIR LABOR S...',
	  '29:439B.M': '29:439B.M            VIOLATIONS AND PENALTIES',
	  '29:439C.M': '29:439C.M            VIOLATIONS AND PENALTIES',
	  '29:461A.M': '29:461A.M            FILING AND CONTENTS OF TRUSTEESHIP R...',
	  '29:461C.M': '29:461C.M            PENALTY FOR VIOLATIONS',
	  '29:463.M': '29:463.M             UNLAWFUL ACTS RELATING TO LABOR ORGA...',
	  '29:463A.M': '29:463A.M            UNLAWFUL ACTS RELATING TO LABOR ORGA...',
	  '29:463B.M': '29:463B.M            LABOR ORGANIZATION - TRUSTEESHIP/UNL...',
	  '29:501C.F': '29:501C.F            EMBEZZLEMENT OF ASSETS: PENALTY',
	  '29:502.M': '29:502.M             BONDING OF OFFICERS AND EMPLOYEES OF...',
	  '29:502A.M': '29:502A.M            BONDING OF OFFICERS AND EMPLOYEES OF...',
	  '29:502B.M': '29:502B.M            BONDING OF OFFICERS AND EMPLOYEES OF...',
	  '29:503A.M': '29:503A.M            LOANS TO OFFICERS OR EMPLOYEES PROHI...',
	  '29:503B.M': '29:503B.M            PAYMENT OF FINE FOR OFFICERS OR EMPL...',
	  '29:503C.M': '29:503C.M            LOANS TO OFFICERS AND EMPLOYEES',
	  '29:504.F': '29:504.F             PROHIBITION AGAINST CERTAIN PERSONS ...',
	  '29:504.M': '29:504.M             PROHIBITION AGAINST CERTAIN PERSONS ...',
	  '29:504A.F': '29:504A.F            PROHIBITION AGAINST CERTAIN PERSONS ...',
	  '29:504A.M': '29:504A.M            PROHIBITION AGAINST CERTAIN PERSONS ...',
	  '29:504B.F': '29:504B.F            PROHIBITION AGAINST CERTAIN PERSONS ...',
	  '29:504B.M': '29:504B.M            PROHIBITION AGAINST CERTAIN PERSONS ...',
	  '29:522A.F': '29:522A.F            EXTORTIONATE PICKETING',
	  '29:522B.F': '29:522B.F            PENALTY FOR VIOLATION',
	  '29:530.M': '29:530.M             DEPRIVATION OF RIGHTS BY VIOLENCE',
	  '29:629.M': '29:629.M             FORCIBLE RESISTANCE OR INTERFERENCE',
	  '29:655.M': '29:655.M             STANDARDS FOR OCCUPATIONAL HEALTH AN...',
	  '29:666E.M': '29:666E.M            WILLFUL VIOLATION OF STANDARDS RULES...',
	  '29:666E.P': '29:666E.P            WILLFUL VIOLATION OF STANDARDS RULES...',
	  '29:666F.P': '29:666F.P            WILLFUL VIOLATION OF STANDARDS RULES...',
	  '29:666G.M': '29:666G.M            FALSE STATEMENTS ON FILING',
	  '2:167A.P': '2:167A.P             LIBRARY OF CONGRESS - PUBLIC USE',
	  '2:167B.P': '2:167B.P             LIBRARY OF CONGRESS - SALE OF ARTICLES',
	  '2:167C.P': '2:167C.P             LIBRARY OF CONGRESS - INJURY TO PROP...',
	  '2:167D.P': '2:167D.P             LIBRARY OF CONGRESS - FIREARMS AND W...',
	  '2:167E.P': '2:167E.P             LIBRARY OF CONGRESS - PARADES AND AS...',
	  '2:167F.P': '2:167F.P             LIBRARY OF CONGRESS - ADDITIONAL REG...',
	  '2:167G.F': '2:167G.F             LIBRARY OF CONGRESS - PROSECUTION AN...',
	  '2:167G.P': '2:167G.P             LIBRARY OF CONGRESS - PROSECUTION AN...',
	  '2:192.M': '2:192.M              CONGRESSIONAL CONTEMPT - REFUSE TO T...',
	  '2:192.P': '2:192.P              CONGRESSIONAL CONTEMPT - REFUSE TO T...',
	  '2:262.M': '2:262.M              ACCOUNT OF CONTRIBUTIONS, RETAINING ...',
	  '2:263.M': '2:263.M              RECEIPTS FOR CONTRIBUTIONS',
	  '2:264.M': '2:264.M              STATEMENTS OF ACCOUNTS',
	  '2:265.M': '2:265.M              PRESERVATION OF STATEMENTS',
	  '2:266.M': '2:266.M              DEFAMATION OF APPLICABLE PERSONS',
	  '2:267.M': '2:267.M              REGISTRATION OF LOBBYISTS - SENATE',
	  '2:268.M': '2:268.M              REPORTS AND STATEMENTS UNDER OATH',
	  '2:269A.M': '2:269A.M             PENALTIES AND PROHIBITIONS',
	  '2:269B.F': '2:269B.F             PENALTIES AND PROHIBITIONS',
	  '2:388A.M': '2:388A.M             ISSUANCE OF SUBPOENAS',
	  '2:388B.M': '2:388B.M             SUBPOENAS, TIME, METHOD AND PROOF OF...',
	  '2:388C.M': '2:388C.M             SUBPOENAS, PLACE OF EXAMINATION',
	  '2:388D.M': '2:388D.M             SUBPOENAS, FORMS',
	  '2:388E.M': '2:388E.M             SUBPOENAS, PRODUCTION OF DOCUMENTS',
	  '2:390.M': '2:390.M              PENALTY, FAILURE TO APPEAR/TESTIFY/P...',
	  '2:390.P': '2:390.P              PENALTY, FAILURE TO APPEAR/TESTIFY/P...',
	  '2:432A.M': '2:432A.M             POLITICAL COMMITTEES - FILLING TREAS...',
	  '2:432B.M': '2:432B.M             POLITICAL COMMITTEES - CONTRIBUTIONS...',
	  '2:432C.M': '2:432C.M             POLITICAL COMMITTEES - RECORDKEEPING',
	  '2:432D.M': '2:432D.M             POLITICAL COMMITTEES - RECEIPTS',
	  '2:432E.M': '2:432E.M             POLITICAL COMMITTEES - CAMPAIGN/UNAU...',
	  '2:432F.M': '2:432F.M             POLITICAL COMMITTEES - PRINCIPAL CAM...',
	  '2:433A.M': '2:433A.M             POLITICAL COMMITTEES - ORGANIZATION ...',
	  '2:433B.M': '2:433B.M             POLITICAL COMMITTEES - STATEMENT CON...',
	  '2:433C.M': '2:433C.M             POLITICAL COMMITTEES - REPORTING INF...',
	  '2:433D.M': '2:433D.M             POLITICAL COMMITTEES - STATEMENT OF ...',
	  '2:433E.M': '2:433E.M             POLITICAL COMMITTEES - STATEMENT OF ...',
	  '2:434A.M': '2:434A.M             POLITICAL COMMITTEES - REPORTS, RECO...',
	  '2:434B.M': '2:434B.M             POLITICAL COMMITTEES - REPORT CONTENTS',
	  '2:434C.M': '2:434C.M             POLITICAL COMMITTEES - REPORTS, OTHE...',
	  '2:437.M': '2:437.M              PENALTIES ILLEGAL CAMPAIGN CONTRIBUT...',
	  '2:439A.M': '2:439A.M             USE OF CONTRIBUTIONS',
	  '2:441.M': '2:441.M              ILLEGAL CAMPAIGN CONTRIBUTIONS',
	  '2:441B.F': '2:441B.F             DISCLOSURE OF FEDERAL CAMPAIGN FUNDS',
	  '30:1211F.M': '30:1211F.M           OFFICE OF SURFACE MINING, PENALTY',
	  '30:1232D.M': '30:1232D.M           SURFACE MINING CONTROL AND RECLAMATION',
	  '30:1267G.M': '30:1267G.M           INSPECTIONS AND MONITORING, PENALTY',
	  '30:1268E.M': '30:1268E.M           PENALTIES - WILLFUL VIOLATIONS',
	  '30:1268F.M': '30:1268F.M           PENALTIES - CORPORATE  VIOLATIONS',
	  '30:1268G.M': '30:1268G.M           FALSE STATEMENTS, REPRESENTATIONS, P...',
	  '30:1294.M': '30:1294.M            PENALTY SECTION',
	  '30:195.F': '30:195.F             VIOLATION OF FEDERAL ON-SHORE OIL AN...',
	  '30:689.F': '30:689.F             PROCURING A PAYMENT TO WHICH NOT ENT...',
	  '30:727A.P': '30:727A.P            WITHDRAWAL AND DEBARMENT FROM DANGER...',
	  '30:727B.P': '30:727B.P            PROPER OFFICIAL NOT TO BE BARRED FRO...',
	  '30:733B.P': '30:733B.P            PENALTY FOR VIOLATIONS: CIVIL AND CR...',
	  '30:814A.F': '30:814A.F            NOTICE OF IMMINENT DANGER - 2ND OFFENSE',
	  '30:814A.M': '30:814A.M            NOTICE OF IMMINENT DANGER - 1ST OFFENSE',
	  '30:814B.M': '30:814B.M            FAILURE TO COMPLY WITH NOTICE TO ABATE',
	  '30:814C.M': '30:814C.M            NOTICE OF SUBSTANTIAL VIOLATIONS',
	  '30:819B.F': '30:819B.F            PENALTIES (IF PRIOR) - 2ND OFFENSE',
	  '30:819B.M': '30:819B.M            PENALTIES - 1ST OFFENSE',
	  '30:819D.M': '30:819D.M            FALSE STATEMENTS OR REPRESENTATION',
	  '30:819E.M': '30:819E.M            DISTRIBUTION OR SALE OF NON-COMPLYIN...',
	  '30:820C.F': '30:820C.F            LIABILITY OF CORPORATE DIRECTORS AND...',
	  '30:820C.M': '30:820C.M            LIABILITY OF CORPORATE DIRECTORS AND...',
	  '30:820D.F': '30:820D.F            PENALTIES (IF PRIOR) - 2ND OFFENSE',
	  '30:820D.M': '30:820D.M            PENALTIES - 1ST OFFENSE',
	  '30:820E.P': '30:820E.P            UNAUTHORIZED ADVANCE NOTICE OF INSPE...',
	  '30:820F.F': '30:820F.F            FALSE STATEMENTS AND REPRESENTATIONS',
	  '30:820F.M': '30:820F.M            FALSE STATEMENTS OR REPRESENTATION',
	  '30:820H.F': '30:820H.F            FALSELY REPRESENTED EQUIPMENT',
	  '30:941.M': '30:941.M             FALSE CLAIMS AND STATEMENTS',
	  '31:1003.P': '31:1003.P            RESTRICTIONS ON SECRETARY OF TREASURY',
	  '31:1018.P': '31:1018.P            RESTRICTIONS ON CLERKS IN THE TREASU...',
	  '31:1058.M': '31:1058.M            CRIMINAL PENALTY',
	  '31:1059.F': '31:1059.F            ADDITIONAL CRIMINAL PENALTY IN CERTA...',
	  '31:1081.F': '31:1081.F            REPORTS ON DOMESTIC CURRENCY TRANSAC...',
	  '31:1081.M': '31:1081.M            REPORTS ON DOMESTIC CURRENCY TRANSAC...',
	  '31:1101A.M': '31:1101A.M           PERSONS REQUIRED TO FILE',
	  '31:1101B.M': '31:1101B.M           CONTENTS OF FILED REPORT',
	  '31:1101C.M': '31:1101C.M           COMMON CARRIERS',
	  '31:241A.P': '31:241A.P            PAYMENTS OF CLAIMS TO MEMBERS OF UNI...',
	  '31:241B.P': '31:241B.P            CLAIMS BY CIVILIANS',
	  '31:241C.P': '31:241C.P            TIME LIMITATION FOR PRESENTATION OF ...',
	  '31:243.P': '31:243.P             LIMITATION ON AGENT OR ATTORNEY FEES',
	  '31:329.P': '31:329.P             RESTRICTIONS ON SECRETARY OF TREASURY',
	  '31:333.M': '31:333.M             FRAUDULENT USE OF DOT AND IRS LOGO',
	  '31:3721.P': '31:3721.P            PAYMENTS OF CLAIMS TO MEMBERS OF UNI...',
	  '31:5313.F': '31:5313.F            REPORTS ON DOMESTIC COINS AND CURREN...',
	  '31:5313.M': '31:5313.M            REPORTS ON DOMESTIC COINS AND CURREN...',
	  '31:5316.F': '31:5316.F            REPORTS ON EXPORT AND IMPORT OF MONE...',
	  '31:5316.M': '31:5316.M            REPORTS ON EXPORT AND IMPORT OF MONE...',
	  '31:5317.F': '31:5317.F            SEARCH AND FORFEITURE OF MONETARY IN...',
	  '31:5318.F': '31:5318.F            RECORDS AND REPORTS ON MONETARY TRAN...',
	  '31:5322A.F': '31:5322A.F           PENALTIES',
	  '31:5322A.M': '31:5322A.M           PENALTIES',
	  '31:5322B.F': '31:5322B.F           PENALTIES',
	  '31:5324.F': '31:5324.F            STRUCTURING TRANSACTIONS TO EVADE RE...',
	  '31:5324.M': '31:5324.M            STRUCTURING TRANSACTIONS TO EVADE RE...',
	  '31:5331.F': '31:5331.F            RECORDS AND REPORTS ON MONETARY INST...',
	  '31:5332.F': '31:5332.F            BULK CASH SMUGGLING INTO OR OUT OF T...',
	  '31:699B.M': '31:699B.M            CITIZENSHIP REQUIREMENTS, FEDERAL EM...',
	  '33:1.P': '33:1.P               REGULATIONS BY SECRETARY OF THE ARMY...',
	  '33:1227.F': '33:1227.F            PORTS AND WATERWAYS - SAFETY PROGRAM',
	  '33:1232B.F': '33:1232B.F           PORTS AND WATERWAYS SAFETY PROGRAM -...',
	  '33:1236.P': '33:1236.P            TRANSPORTATION OF PASSENGERS AND MER...',
	  '33:1311A.F': '33:1311A.F           POLLUTANT DISCHARGES ILLEGAL - 2ND O...',
	  '33:1311A.M': '33:1311A.M           POLLUTANT DISCHARGES ILLEGAL',
	  '33:1311F.F': '33:1311F.F           ILLEGALITY OF DISCHARGE OF RADIOLOGI...',
	  '33:1311F.M': '33:1311F.M           ILLEGALITY OF DISCHARGE OF RADIOLOGI...',
	  '33:1312.F': '33:1312.F            WATER QUALITY RELATED EFFLUENT LIMIT...',
	  '33:1312.M': '33:1312.M            WATER QUALITY RELATED EFFLUENT LIMIT...',
	  '33:1316.F': '33:1316.F            NATIONAL STANDARDS OF PERFORMANCE',
	  '33:1316.M': '33:1316.M            NATIONAL STANDARDS OF PERFORMANCE',
	  '33:1317.F': '33:1317.F            TOXIC AND PRE-TREATMENT EFFLUENT STA...',
	  '33:1317.M': '33:1317.M            TOXIC AND PRE-TREATMENT EFFLUENT STA...',
	  '33:1318.F': '33:1318.F            INSPECTIONS, MONITORING, AND ENTRY',
	  '33:1318.M': '33:1318.M            INSPECTIONS, MONITORING, AND ENTRY',
	  '33:1319.F': '33:1319.F            ENFORCEMENT - CRIMINAL PENALTIES',
	  '33:1319.M': '33:1319.M            ENFORCEMENT - CRIMINAL PENALTIES',
	  '33:1321B.F': '33:1321B.F           OIL AND HAZARDOUS SUBSTANCES LIABILITY',
	  '33:1321B.M': '33:1321B.M           FAILURE TO NOTIFY OF OIL DISCHARGE',
	  '33:1342.M': '33:1342.M            NATIONAL POLLUTANT DISCHARGE ELIMINA...',
	  '33:1344.F': '33:1344.F            PERMITS FOR DREDGED OR FILL MATERIAL',
	  '33:1344.M': '33:1344.M            PERMITS FOR DREDGED OR FILL MATERIAL',
	  '33:1411.F': '33:1411.F            OCEAN DUMPING',
	  '33:1415.M': '33:1415.M            OCEAN DUMPING - CRIMINAL PENALTIES',
	  '33:1481.M': '33:1481.M            OIL POLLUTION CASUALTIES - VIOLATION...',
	  '33:1514.M': '33:1514.M            DEEPWATER PORTS - CRIMINAL PENALTIES',
	  '33:1517.M': '33:1517.M            DEEPWATER PORTS - OIL DISCHARGE: NOT...',
	  '33:1908.F': '33:1908.F            ENFORCEMENT - CRIMINAL PENALTIES',
	  '33:2.P': '33:2.P               REGULATIONS: NAVIGATION OF SET SW PA...',
	  '33:3.P': '33:3.P               REGULATIONS: PREVENT INJURIES FROM T...',
	  '33:368.F': '33:368.F             PENALTY FOR FAILURE TO GIVE AID, ETC.',
	  '33:401.M': '33:401.M             CONSTRUCTION OF BRIDGES WITHOUT CONS...',
	  '33:403.M': '33:403.M             OBSTRUCTION OF NAVIGABLE WATERS NOT ...',
	  '33:404.M': '33:404.M             NO WORKS TO EXTEND BEYOND HARBOR LINES',
	  '33:406.M': '33:406.M             PENALTY FOR WRONGFUL CONSTRUCTION OF...',
	  '33:407.M': '33:407.M             DEPOSIT OF REFUSE IN NAVIGABLE RIVER',
	  '33:408.M': '33:408.M             TAKING POSSESSION OF, USE OF, INJURY...',
	  '33:409.M': '33:409.M             OBSTRUCTION OF NAVIGABLE WATERS BY V...',
	  '33:410.M': '33:410.M             VIOLATION OF REGULATIONS: FLOATING L...',
	  '33:411.M': '33:411.M             PENALTY FOR WRONGFUL DEPOSIT OF REFUSE',
	  '33:412.M': '33:412.M             LIABILITY OF MASTERS, PILOTS, ETC., ...',
	  '33:419.M': '33:419.M             REGULATIONS BY SEC GOVERNING TRANSPO...',
	  '33:421.P': '33:421.P             DEPOSIT OF REFUSE, ETC., IN LAKE MIC...',
	  '33:441.M': '33:441.M             DEPOSIT OF REFUSE PROHIBITED: PENALTY',
	  '33:442.M': '33:442.M             LIABILITY OF OFFICERS OF TOWING VESSEL',
	  '33:443.P': '33:443.P             PENALTY FOR TAKING OR TOWING WITHOUT...',
	  '33:444.M': '33:444.M             DUMPING AT PLACE OTHER THAN DESIGNATED',
	  '33:447.M': '33:447.M             BRIBERY OF INSPECTOR: PENALTY',
	  '33:448.P': '33:448.P             RETURN OF PERMIT: PENALTY FOR FAILURE',
	  '33:449.P': '33:449.P             DISPOSITION OF DREDGED MATTER: PENALTY',
	  '33:452.P': '33:452.P             TAKING SHELLFISH/INTERFERING WITH NA...',
	  '33:495.P': '33:495.P             FAILURE TO COMPLY WITH REGULATIONS: ...',
	  '33:499.M': '33:499.M             REGULATIONS FOR DRAWBRIDGES: PENALTI...',
	  '33:502.P': '33:502.P             CRIMINAL LIABILITY FOR FAILURE TO AL...',
	  '33:506.M': '33:506.M             TOLLS: HEARINGS - REASONABLENESS ATT...',
	  '33:507.M': '33:507.M             TOLLS: FAILURE TO OBEY ORDER PRESCRI...',
	  '33:519.P': '33:519.P             NONCOMPLIANCE WITH ORDERS: REMOVAL O...',
	  '33:533.M': '33:533.M             GENERAL BRIDGE AUTHORITY: PENALTIES',
	  '33:554.P': '33:554.P             DUTY OF SHIPOWNERS AND OFFICERS TO F...',
	  '33:555.P': '33:555.P             DUTY OF SHIPOWNERS AND OFFICERS TO F...',
	  '33:601.P': '33:601.P             MISSISSIPPI RIVER: REGULATIONS OF RE...',
	  '33:682.F': '33:682.F             MALICIOUS INJURY TO WORKS',
	  '33:682.M': '33:682.M             MALICIOUS INJURY TO WORKS',
	  '33:915.P': '33:915.P             INVALID AGREEMENTS',
	  '33:928.M': '33:928.M             UNAPPROVED FEES: SOLICITATION: PENALTY',
	  '33:931.F': '33:931.F             PENALTY FOR MISREPRESENTATION',
	  '33:931.M': '33:931.M             PENALTY FOR MISREPRESENTATION',
	  '33:937.M': '33:937.M             CERTIFICATE OF COMPLIANCE WITH CHAPTER',
	  '33:938A.M': '33:938A.M            FAILURE TO SECURE PAYMENT OF COMPENS...',
	  '33:938B.M': '33:938B.M            ATTEMPTING TO AVOID PAYMENT OF COMPE...',
	  '33:941A.P': '33:941A.P            SAFE PLACE OF EMPLOYMENT: INSTALLATI...',
	  '33:941C.P': '33:941C.P            HINDERING INSPECTION OF PLACES OF EM...',
	  '33:941F.P': '33:941F.P            VIOLATIONS AND PENALTIES',
	  '33:990B.F': '33:990B.F            FRAUDS AND FALSE ENTRIES, REPORTS OR...',
	  '33:990C.F': '33:990C.F            RECEIPT OF COMPENSATION, OR CONSPIRA...',
	  '33D:541A=CD.F': '33D:541A=CD.F        CONTROLLED SUBSTANCE - SELL, DISTRIB...',
	  '33D:541A=CD.M': '33D:541A=CD.M        CONTROLLED SUBSTANCE - SELL, DISTRIB...',
	  '33D:541A=CM.F': '33D:541A=CM.F        CONTROLLED SUBSTANCE - MANUFACTURE',
	  '33D:541A=CM.M': '33D:541A=CM.M        CONTROLLED SUBSTANCE - MANUFACTURE',
	  '33D:541A=MD.F': '33D:541A=MD.F        MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
	  '33D:541A=MM.F': '33D:541A=MM.F        MARIJUANA - MANUFACTURE',
	  '33D:541A=ND.F': '33D:541A=ND.F        NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
	  '33D:541A=NM.F': '33D:541A=NM.F        NARCOTICS - MANUFACTURE',
	  '33D:541D=CP.F': '33D:541D=CP.F        CONTROLLED SUBSTANCE - POSSESSION',
	  '33D:541D=CP.M': '33D:541D=CP.M        CONTROLLED SUBSTANCE - POSSESSION',
	  '33D:541D=MP.F': '33D:541D=MP.F        MARIJUANA - POSSESSION',
	  '33D:541D=MP.M': '33D:541D=MP.M        MARIJUANA - POSSESSION',
	  '33D:541D=NP.F': '33D:541D=NP.F        NARCOTICS - POSSESSION',
	  '33D:541D=NP.M': '33D:541D=NP.M        NARCOTICS - POSSESSION',
	  '33D:542A=CD.F': '33D:542A=CD.F        CONTROLLED SUBSTANCE - SELL, DISTRIB...',
	  '33D:542A=CD.M': '33D:542A=CD.M        CONTROLLED SUBSTANCE - SELL, DISTRIB...',
	  '33D:542A=CM.F': '33D:542A=CM.F        CONTROLLED SUBSTANCE - MANUFACTURE',
	  '33D:542A=CM.M': '33D:542A=CM.M        CONTROLLED SUBSTANCE - MANUFACTURE',
	  '33D:542A=CR.F': '33D:542A=CR.F        CONTROLLED SUBSTANCE - FRAUDULENT RE...',
	  '33D:542A=CR.M': '33D:542A=CR.M        CONTROLLED SUBSTANCE - FRAUDULENT RE...',
	  '33D:543A=CD.F': '33D:543A=CD.F        CONTROLLED SUBSTANCE - SELL, DISTRIB...',
	  '33D:543A=CM.F': '33D:543A=CM.F        CONTROLLED SUBSTANCE - MANUFACTURE',
	  '33D:543A=CP.F': '33D:543A=CP.F        CONTROLLED SUBSTANCE - POSSESSION',
	  '33D:543A=CR.F': '33D:543A=CR.F        CONTROLLED SUBSTANCE - FRAUDULENT RE...',
	  '33D:546A=MD.F': '33D:546A=MD.F        MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
	  '33D:546A=ND.F': '33D:546A=ND.F        NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
	  '33D:546B=CD.F': '33D:546B=CD.F        CONTROLLED SUBSTANCE - SELL, DISTRIB...',
	  '33D:547A=CD.F': '33D:547A=CD.F        CONTROLLED SUBSTANCE - SELL/DISTRIBU...',
	  '33D:547A=MD.F': '33D:547A=MD.F        MARIJUANA - SELL, DISTRIBUTE OR DISP...',
	  '33D:547A=ND.F': '33D:547A=ND.F        NARCOTICS - SELL, DISTRIBUTE OR DISP...',
	  '33D:549=CD.F': '33D:549=CD.F         CONSPIRACY - CONTROLLED SUBSTANCE - ...',
	  '33D:549=CD.M': '33D:549=CD.M         CONSPIRACY - CONTROLLED SUBSTANCE - ...',
	  '33D:549=CM.F': '33D:549=CM.F         CONSPIRACY - CONTROLLED SUBSTANCE - ...',
	  '33D:549=CM.M': '33D:549=CM.M         CONSPIRACY - CONTROLLED SUBSTANCE - ...',
	  '33D:549=CP.F': '33D:549=CP.F         CONSPIRACY - CONTROLLED SUBSTANCE - ...',
	  '33D:549=CP.M': '33D:549=CP.M         CONSPIRACY - CONTROLLED SUBSTANCE - ...',
	  '33D:549=CR.F': '33D:549=CR.F         CONSPIRACY - CONTROLLED SUBSTANCE - ...',
	  '33D:549=CR.M': '33D:549=CR.M         CONSPIRACY - CONTROLLED SUBSTANCE - ...',
	  '33D:549=MD.F': '33D:549=MD.F         CONSPIRACY - MARIJUANA - SELL, DISTR...',
	  '33D:549=MM.F': '33D:549=MM.F         CONSPIRACY - MARIJUANA - MANUFACTURE',
	  '33D:549=MP.F': '33D:549=MP.F         CONSPIRACY - MARIJUANA - POSSESSION',
	  '33D:549=MP.M': '33D:549=MP.M         CONSPIRACY - MARIJUANA - POSSESSION',
	  '33D:549=ND.F': '33D:549=ND.F         CONSPIRACY - NARCOTICS - SELL, DISTR...',
	  '33D:549=NM.F': '33D:549=NM.F         CONSPIRACY - NARCOTICS - MANUFACTURE',
	  '33D:549=NP.F': '33D:549=NP.F         CONSPIRACY - NARCOTICS - POSSESSION',
	  '33D:549=NP.M': '33D:549=NP.M         CONSPIRACY - NARCOTICS - POSSESSION',
	  '33D:550=CP.M': '33D:550=CP.M         PARAPHERNALIA FOR CONTROLLED SUBSTANCES',
	  '33D:550=MP.M': '33D:550=MP.M         PARAPHERNALIA FOR MARIJUANA',
	  '33D:550=NP.M': '33D:550=NP.M         PARAPHERNALIA FOR NARCOTICS',
	  '33D:603A=CP.P': '33D:603A=CP.P        CONTROLLED SUBSTANCE - MANUFACTURE',
	  '33D:603A=MP.P': '33D:603A=MP.P        MARIJUANA - MANUFACTURE',
	  '33D:603A=NP.P': '33D:603A=NP.P        NARCOTICS - MANUFACTURE',
	  '33D:603B=CD.F': '33D:603B=CD.F        CONTROLLED SUBSTANCE - SELL, DISTRIB...',
	  '33D:603B=CD.P': '33D:603B=CD.P        CONTROLLED SUBSTANCE - SELL, DISTRIB...',
	  '33D:603B=MD.F': '33D:603B=MD.F        MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
	  '33D:603B=MD.P': '33D:603B=MD.P        MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
	  '33D:603B=ND.F': '33D:603B=ND.F        NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
	  '33D:603B=ND.P': '33D:603B=ND.P        NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
	  '33D:603C=CD.F': '33D:603C=CD.F        CONTROLLED SUBSTANCE - SELL, DISTRIB...',
	  '35:184.F': '35:184.F             FILING OF APPLICATION IN FOREIGN COU...',
	  '35:186.F': '35:186.F             SECRECY OF CERTAIN INVENTIONS - PENALTY',
	  '35:292.P': '35:292.P             FALSE MARKING',
	  '35:33.P': '35:33.P              UNAUTHORIZED REPRESENTATION AS PRACT...',
	  '36:379.M': '36:379.M             PRETENSE OF MEMBERSHIP - U.S. OLYMPI...',
	  '36:728.P': '36:728.P             VIOLATIONS: DURATION OF REGISTRATION...',
	  '38:218A.P': '38:218A.P            RULES AND REGULATIONS FOR VA PROPERTY',
	  '38:218B.P': '38:218B.P            RULES AND REGULATIONS FOR VA PROPERT...',
	  '38:3301.M': '38:3301.M            TRANSFERRED TO 38:5701',
	  '38:3405.F': '38:3405.F            AGENTS AND ATTORNEYS: PENALTIES - CE...',
	  '38:3501.F': '38:3501.F            TRANSFERRED TO 38:6101.F',
	  '38:3502A.M': '38:3502A.M           FRAUDULENT ACCEPTANCE OF PAYMENTS',
	  '38:3502B.M': '38:3502B.M           FRAUDULENT ACCEPTANCE OF PAYMENTS',
	  '38:5701.M': '38:5701.M            IMPROPER USE OF NAMES AND ADDRESSES',
	  '38:5905.M': '38:5905.M            TO WRONGFULLY SOLICIT, CHARGE, AND R...',
	  '38:6101.F': '38:6101.F            MISAPPROPRIATION BY FIDUCIARIES',
	  '38:6102.M': '38:6102.M            FRAUDULENT ACCEPTANCE OF PAYMENTS',
	  '38:6103.F': '38:6103.F            FORFEITURE FOR FRAUD',
	  '38:6103.M': '38:6103.M            FORFEITURE FOR FRAUD',
	  '38:787A.M': '38:787A.M            INSURANCE - FALSE STATEMENTS IN APPL...',
	  '38:787B.F': '38:787B.F            INSURANCE - FALSE STATEMENTS IN CLAIM',
	  '38:901C.P': '38:901C.P            AUTHORITY TO PRESCRIBE RULES FOR CON...',
	  '40:101.P': '40:101.P             LAWS OF DISTRIBUTION EXTENDED TO PUB...',
	  '40:1315.P': '40:1315.P            VIOLATION OF REGULATIONS ON GOVERNME...',
	  '40:193B.P': '40:193B.P            PUBLIC TRAVEL ON CAPITAL GROUNDS RES...',
	  '40:193C.P': '40:193C.P            VIOLENT ENTRY AND DISORDERLY CONDUCT...',
	  '40:193D.P': '40:193D.P            U.S. CAPITAL GROUNDS - SALE OF ARTIC...',
	  '40:193E.P': '40:193E.P            U.S. CAPITAL GROUNDS - INJURIES TO P...',
	  '40:193F.F': '40:193F.F            U.S. CAPITAL GROUNDS - FIREARMS, DAN...',
	  '40:193F.P': '40:193F.P            VIOLENT ENTRY AND DISORDERLY CONDUCT...',
	  '40:193G.P': '40:193G.P            U.S. CAPITAL GROUNDS - PARADES OR AS...',
	  '40:193H.F': '40:193H.F            U.S. CAPITAL GROUNDS - VIOLATION OF ...',
	  '40:193H.P': '40:193H.P            U.S. CAPITAL GROUNDS - VIOLATION OF ...',
	  '40:193O.F': '40:193O.F            SMITHSONIAN INSTITUTION: PUBLIC USE',
	  '40:193O.P': '40:193O.P            SMITHSONIAN INSTITUTION: PUBLIC USE',
	  '40:193P.F': '40:193P.F            SMITHSONIAN INSTITUTION: SALE OF ART...',
	  '40:193P.P': '40:193P.P            SMITHSONIAN INSTITUTION: SALE OF ART...',
	  '40:193Q.F': '40:193Q.F            SMITHSONIAN INSTITUTION: INJURY TO P...',
	  '40:193Q.P': '40:193Q.P            SMITHSONIAN INSTITUTION: INJURY TO P...',
	  '40:193R.F': '40:193R.F            SMITHSONIAN INSTITUTION: ADDITIONAL ...',
	  '40:193R.P': '40:193R.P            SMITHSONIAN INSTITUTION: ADDITIONAL ...',
	  '40:193S.F': '40:193S.F            SMITHSONIAN INSTITUTION: DAMAGE OVER...',
	  '40:193S.P': '40:193S.P            SMITHSONIAN INSTITUTION: DAMAGE UNDE...',
	  '40:212.P': '40:212.P             REGULATION OF TRAFFIC BY CAPITAL POL...',
	  '40:318A.P': '40:318A.P            GENERAL SERVICES ADMINISTRATION RULE...',
	  '40:318C.P': '40:318C.P            PROTECTION OF FED. PROPERTY UNDER GE...',
	  '40:332.P': '40:332.P             HOURS OF LABOR AND SAFETY - PENALTIES',
	  '40:53.P': '40:53.P              DESTROYING FEDERAL PROPERTY',
	  '40:883B.F': '40:883B.F            FALSE STATEMENTS OR ENTRY - INTENT T...',
	  '40:883C.F': '40:883C.F            COMPLICITY OR CONSPIRACY WITH INTENT...',
	  '41:423.F': '41:423.F             FEDERAL STATUTES - PUBLIC OFFICERS/E...',
	  '41:51.F': '41:51.F              FEES OR KICK-BACKS BY SUBCONTRACTORS',
	  '41:53.F': '41:53.F              PROVIDE, OFFER, SOLICIT, ACCEPT ANY ...',
	  '41:54.F': '41:54.F              CONTRACTOR FRAUD',
	  '42:1306.F': '42:1306.F            IMPROPER DISCLOSURE OF INFO IN POSSE...',
	  '42:1306.M': '42:1306.M            DISCLOSURE OF INFORMATION IN POSSESS...',
	  '42:1307A.M': '42:1307A.M           PENALTY FOR SOCIAL SECURITY FRAUD',
	  '42:1307B.M': '42:1307B.M           PENALTY FOR SOCIAL SECURITY FRAUD',
	  '42:1320A.F': '42:1320A.F           PAYMENT TO NON-LICENSED PHYSICIAN',
	  '42:1320A.M': '42:1320A.M           PAYMENT TO NON-LICENSED PHYSICIAN',
	  '42:1320C.P': '42:1320C.P           DISCLOSURE OF INFORMATION PROHIBITED',
	  '42:1320D-6.F': '42:1320D-6.F         WRONGFUL DISCLOSURE OF INDIVIDUALLY ...',
	  '42:1383.F': '42:1383.F            FRAUDULENT ACTS; PENALTIES; RESTITUTION',
	  '42:1383A.M': '42:1383A.M           FALSE STATEMENTS IN APPLICATION FOR ...',
	  '42:1383D.M': '42:1383D.M           PROCEDURES APPLICATION, PENALTIES FO...',
	  '42:1395.F': '42:1395.F            FALSE STATEMENTS OR REPRESENTATIONS',
	  '42:1395.M': '42:1395.M            FALSE STATEMENTS OR REPRESENT ON APP...',
	  '42:1395.P': '42:1395.P            VIOLATION OF ASSIGNMENT TERMS',
	  '42:1396.F': '42:1396.F            MAKE/CAUSE FALSE STATEMENT/REPRESENT...',
	  '42:1396.M': '42:1396.M            MAKE/CAUSE FALSE STATEMENT/REPRESENT...',
	  '42:14072.F': '42:14072.F           FAILURE TO REGISTER-CRIMES AGAINST C...',
	  '42:1713.M': '42:1713.M            FRAUD: PENALTIES',
	  '42:1714.M': '42:1714.M            LEGAL SERVICES',
	  '42:1760.F': '42:1760.F            MISAPPROPRIATION OF FUNDS, PENALTIES...',
	  '42:1760.M': '42:1760.M            MISAPPROPRIATION OF FUNDS, PENALTIES...',
	  '42:1761O.F': '42:1761O.F           SUMMER FOOD SERVICE PROGRAM, PENALTIES',
	  '42:1857C.F': '42:1857C.F           OPERATION IN VIOLATION OF STANDARD O...',
	  '42:1857C.M': '42:1857C.M           AIR POLLUTANTS IN VIOLATION OF STAND...',
	  '42:1874D.F': '42:1874D.F           SCHOLARSHIP, PENALTIES',
	  '42:1973A.F': '42:1973A.F           PROCEEDING TO ENFORCE THE RIGHT TO VOTE',
	  '42:1973B.F': '42:1973B.F           SUSPENSION OF THE USE OF TESTS OR DE...',
	  '42:1973C.F': '42:1973C.F           ALTERATION OF VOTING QUALIFICATION A...',
	  '42:1973D.F': '42:1973D.F           FALSIFICATION OR CONCEALMENT OF MATE...',
	  '42:1973E.F': '42:1973E.F           EXAMINATION OF APPLICANTS FOR REGIST...',
	  '42:1973H.F': '42:1973H.F           POLL TAXES',
	  '42:1973I.F': '42:1973I.F           FAILURE OR REFUSAL TO PERMIT CASTING...',
	  '42:1973J.F': '42:1973J.F           DENIAL OF RIGHT TO VOTE ON ACCOUNT O...',
	  '42:1974.M': '42:1974.M            THEFT, DESTRUCTION, CONCEALMENT, MUT...',
	  '42:1995.P': '42:1995.P            CRIMINAL CONTEMPT PROCEEDINGS: PENAL...',
	  '42:2000E.M': '42:2000E.M           PROHIBITED DISCLOSURES, PENALTIES',
	  '42:2000E.P': '42:2000E.P           POSTING OF NOTICES, PENALTIES',
	  '42:2000G.M': '42:2000G.M           COOPERATION WITH OTHER AGENCIES, PEN...',
	  '42:2000H.P': '42:2000H.P           CRIMINAL CONTEMPT PROCEEDINGS',
	  '42:2077.F': '42:2077.F            UNAUTHORIZED DEALINGS IN SPECIAL NUC...',
	  '42:2095.F': '42:2095.F            REPORTS OF SOURCE MATERIALS REQUIRED',
	  '42:2122.F': '42:2122.F            PROHIBITIONS GOVERNING ATOMIC WEAPONS',
	  '42:2131.F': '42:2131.F            ATOMIC ENERGY LICENSE REQUIRED',
	  '42:2138.F': '42:2138.F            SUSPENSION OF LICENSES DURING WAR OR...',
	  '42:2201B.F': '42:2201B.F           STANDARDS GOVERNING USE/POSSESSION O...',
	  '42:2201I.F': '42:2201I.F           REGULATIONS GOVERNING RESTRICTED DATA',
	  '42:2201O.F': '42:2201O.F           REPORTS REQUIRED TO ATOMIC ENERGY CO...',
	  '42:2272.F': '42:2272.F            VIOLATION OF SPECIFIC SANCTIONS',
	  '42:2273A.F': '42:2273A.F           VIOLATION OF SECTION GENERALLY - TRE...',
	  '42:2273B.F': '42:2273B.F           VIOLATION OF SECTION GENERALLY - SIMPLE',
	  '42:2274A.F': '42:2274A.F           COMMUNICATION OF RESTRICTED DATA - S...',
	  '42:2274B.F': '42:2274B.F           COMMUNICATION OF RESTRICTED DATA - S...',
	  '42:2275.F': '42:2275.F            RECEIPT OF RESTRICTED DATA - SABOTAGE',
	  '42:2276.F': '42:2276.F            TAMPERING WITH RESTRICTED DATA - SAB...',
	  '42:2277.P': '42:2277.P            DISCLOSURE OF RESTRICTED DATA',
	  '42:2278B.M': '42:2278B.M           PHOTOGRAPHING, ETC., OF COMMUNICATIO...',
	  '42:2284A.F': '42:2284A.F           PHYSICAL DAMAGE TO NUCLEAR FACILITIES',
	  '42:2284B.F': '42:2284B.F           TAMPERING WITH NUCLEAR FACILITIES',
	  '42:2378A.M': '42:2378A.M           DEVELOPMENT AND CONTROL OF ATOMIC EN...',
	  '42:2462B.P': '42:2462B.P           FORMER NASA EMPLOYEE REQUIRED TO FIL...',
	  '42:2462E.P': '42:2462E.P           FILING REPORTS ON TERMINATION OF EMP...',
	  '42:2462G.P': '42:2462G.P           PENALTIES',
	  '42:261A.F': '42:261A.F            INTRODUCING PROHIBITED ARTICLES AND ...',
	  '42:261B.F': '42:261B.F            ESCAPE OR ATTEMPTED ESCAPE FROM HOSP...',
	  '42:261C.F': '42:261C.F            PROCURING ESCAPE: CONCEALING ESCAPE',
	  '42:262A.M': '42:262A.M            INTRASTATE AND INTERSTATE TRAFFIC IN...',
	  '42:262B.M': '42:262B.M            FALSELY LABELING OR MARKING PACKAGE ...',
	  '42:262C.M': '42:262C.M            INSPECT ESTABLISHMENT FOR PROPAGATIO...',
	  '42:262D.M': '42:262D.M            REGULATIONS GOVERNING LICENSES',
	  '42:262E.M': '42:262E.M            INTERFERENCE WITH PUBLIC HEALTH OFFICER',
	  '42:262F.M': '42:262F.M            PENALTIES FOR OFFENSES',
	  '42:263.M': '42:263.M             PROHIBITION OF UNLICENSED LABORATORY...',
	  '42:264.M': '42:264.M             REGULATIONS TO CONTROL COMMUNICABLE ...',
	  '42:265.M': '42:265.M             SUSPENSION OF ENTRIES AND IMPORTS FR...',
	  '42:266.M': '42:266.M             SPECIAL QUARANTINE POWERS IN TIME OF...',
	  '42:269.M': '42:269.M             BILLS OF HEALTH FOR CLEARING OR DEPA...',
	  '42:271.M': '42:271.M             PENALTIES FOR VIOLATION OF QUARANTIN...',
	  '42:274.F': '42:274.F             ORGAN PROCUREMENT AND TRANSPORTATION',
	  '42:2971.F': '42:2971.F            CRIMINAL PROVISIONS - AMOUNT OVER $100',
	  '42:2971.M': '42:2971.M            CRIMINAL PROVISIONS - AMOUNT UNDER $100',
	  '42:300E.F': '42:300E.F            FINANCIAL DISCLOSURE, PENALTIES',
	  '42:300G.P': '42:300G.P            REGULATIONS FOR FORM AND MANNER OF N...',
	  '42:300H.F': '42:300H.F            WILLFUL VIOLATION OF UNDERGROUND INJ...',
	  '42:3188A.F': '42:3188A.F           PROHIBITED FINANCIAL INTERESTS OF CO...',
	  '42:3188C.M': '42:3188C.M           SUPPLEMENTARY SALARY PROHIBITED: PEN...',
	  '42:3220A.F': '42:3220A.F           FALSE STATEMENTS: SECURITY OVERVALUA...',
	  '42:3220B.F': '42:3220B.F           EMBEZZLEMENT: SCHEMES TO DEFRAUD',
	  '42:3425.F': '42:3425.F            ESCAPE OR RESCUE FROM CUSTODY - PENA...',
	  '42:3425.M': '42:3425.M            ESCAPE OR RESCUE FROM CUSTODY - PENA...',
	  '42:3426.F': '42:3426.F            FALSE STATEMENTS',
	  '42:3610.M': '42:3610.M            PERSON AGGRIEVED: COMPLAINT: COPY: I...',
	  '42:3611.M': '42:3611.M            VIOLATIONS: PENALTIES',
	  '42:3631.F': '42:3631.F            INTIMIDATE OR INTERFERE: BODILY INJU...',
	  '42:3631.M': '42:3631.M            INTIMIDATE OR INTERFERE: BODILY INJU...',
	  '42:3771.M': '42:3771.M            REVELATION OF INFORMATION FOR STATED...',
	  '42:3791.F': '42:3791.F            EMBEZZLEMENT',
	  '42:3792.F': '42:3792.F            FRAUDULENT AND FALSE STATEMENTS OR E...',
	  '42:3793.F': '42:3793.F            CONSPIRACIES',
	  '42:3795.F': '42:3795.F            MISUSE OF FEDERAL ASSISTANCE',
	  '42:406.M': '42:406.M             REPRESENTATION OF CLAIMANTS BEFORE S...',
	  '42:408.F': '42:408.F             MISUSE OF SOCIAL SECURITY NUMBER',
	  '42:408.M': '42:408.M             FALSE STATEMENTS/REPRESENTATION - PE...',
	  '42:4367.M': '42:4367.M            REPORTING REQUIREMENTS, PENALTIES',
	  '42:4582.P': '42:4582.P            CONFIDENTIALITY OF PATIENT RECORDS -...',
	  '42:4909.F': '42:4909.F            DISTRIBUTION OF PRODUCT NOT CONFORMI...',
	  '42:4909.M': '42:4909.M            DISTRIBUTION OF PRODUCT NOT CONFORMI...',
	  '42:4910.F': '42:4910.F            CRIMINAL PENALTIES - IF PRIOR OFFENSE',
	  '42:4910.M': '42:4910.M            FALSE CLAIMS AND STATEMENTS',
	  '42:4912.M': '42:4912.M            FALSE STATEMENTS IN DOCUMENTS REQUIR...',
	  '42:5157.M': '42:5157.M            FRAUDULENT OR WILLFUL MISREPRESENTATION',
	  '42:5409.M': '42:5409.M            MANUFACTURE OR SELL MOBILE HOME IN N...',
	  '42:5410.M': '42:5410.M            CIVIL AND CRIMINAL PENALTIES',
	  '42:5411.M': '42:5411.M            INJUNCTIVE RELIEF',
	  '42:5420.M': '42:5420.M            FAILURE TO REPORT VIOLATIONS: PENALTIES',
	  '42:5816.M': '42:5816.M            FINANCIAL STATEMENTS OF ADMINISTRATI...',
	  '42:6392.M': '42:6392.M            CONFLICTS OF INTEREST, PENALTY',
	  '42:6395B.M': '42:6395B.M           PENALTY FOR WILLFUL VIOLATION',
	  '42:6395C.M': '42:6395C.M           PENALTY FOR VIOLATION AFTER PRIOR VI...',
	  '42:6906.M': '42:6906.M            FINANCIAL DISCLOSURE, PENALTY',
	  '42:6928.F': '42:6928.F            STORES/TREATS/TRANSPORTS ETC. - RE-U...',
	  '42:6928.M': '42:6928.M            FEDERAL ENFORCEMENT, PENALTY',
	  '42:7218.M': '42:7218.M            SANCTIONS AND PENALTY',
	  '42:7412.F': '42:7412.F            AIR POLLUTION PREVENTION/CONTROL-HAZ...',
	  '42:7412.M': '42:7412.M            AIR POLLUTION PREVENTION/CONTROL-HAZ...',
	  '42:7413.F': '42:7413.F            FEDERAL ENFORCEMENT PROCEDURES, PENALTY',
	  '42:7413.M': '42:7413.M            FEDERAL ENFORCEMENT PROCEDURES, PENALTY',
	  '42:7618.M': '42:7618.M            FINANCIAL DISCLOSURE, PENALTY',
	  '42:7671.F': '42:7671.F            DEFINITION OF STRATOSPHERIC OZONE PR...',
	  '42:8432.M': '42:8432.M            POWER PLANT AND INDUSTRIAL FUEL USE',
	  '42:9603B.F': '42:9603B.F           FAILURE TO NOTIFY/FALSE INFORMATION',
	  '42:9603B.M': '42:9603B.M           NOTIFICATION REQUIREMENTS/RELEASED S...',
	  '43:104.P': '43:104.P             DISOBEDIENCE TO SUBPOENA',
	  '43:1064.M': '43:1064.M            UNLAWFUL ENCLOSURES OR OCCUPANCY - V...',
	  '43:1333.P': '43:1333.P            COAST GUARD REGULATIONS: MARKING OF ...',
	  '43:1334.P': '43:1334.P            ADMINISTRATION OF LEASING',
	  '43:1350.F': '43:1350.F            SUBMERGED LANDS, REMEDIES AND PENALTIES',
	  '43:1605.M': '43:1605.M            PROHIBITION OF EXPENDITURE FOR PROPA...',
	  '43:1619.M': '43:1619.M            ATTORNEY/CONSULTANT FEES: RESTRICTIONS',
	  '43:1701.M': '43:1701.M            FEDERAL LAND POLICY AND MANAGEMENT',
	  '43:1733.M': '43:1733.M            ENFORCEMENT AUTHORITY, CRIMINAL PENA...',
	  '43:18223.M': '43:18223.M           RESOURCE MANAGEMENT, PENALTY',
	  '43:315.P': '43:315.P             GRAZING LANDS, REGULATIONS AND IMPRO...',
	  '43:316.P': '43:316.P             UNLAWFUL TO GRAZE LIVESTOCK',
	  '43:362.F': '43:362.F             INJURY TO SIGNPOSTS AND FOULING WATE...',
	  '45:152.M': '45:152.M             RAILWAY LABOR: GENERAL DUTIES - VIOL...',
	  '45:181.M': '45:181.M             APPLICATION OF SECS. TO CARRIERS BY AIR',
	  '45:182.M': '45:182.M             APPLICATION OF SECS. TO CARRIERS BY AIR',
	  '45:231.M': '45:231.M             RETIREMENT OF RAILROAD EMPLOYEES: PE...',
	  '45:231L.F': '45:231L.F            FAILURE TO REPORT INFORMATION TO RAI...',
	  '45:231L.M': '45:231L.M            FAILURE TO REPORT INFORMATION TO RAI...',
	  '45:355.M': '45:355.M             RAILROAD UNEMPLOYMENT INSURANCE: FEE...',
	  '45:359A.M': '45:359A.M            FALSE OR FRAUDULENT STATEMENT OR CLAIM',
	  '45:359B.M': '45:359B.M            AGREEMENT BY EMPLOYEE TO BEAR EMPLOY...',
	  '45:359C.M': '45:359C.M            PUNISHMENTS NOT SPECIFICALLY PROVIDED',
	  '45:38.P': '45:38.P              MONTHLY REPORTS OF RAILROAD ACCIDENTS',
	  '45:39.P': '45:39.P              FAILURE TO MAKE REPORTS',
	  '45:60.M': '45:60.M              SUPPRESSION OF VOLUNTARY INFORMATION...',
	  '45:65.M': '45:65.M              EIGHT-HOUR DAY ESTABLISHED',
	  '45:66.M': '45:66.M              PENALTIES FOR VIOLATION OF SEC. 65 -...',
	  '45:81.F': '45:81.F              GOVERNMENT AIDED RAILROAD, DIVIDENDS...',
	  '45:83.P': '45:83.P              ROADS/TELEGRAPHS - EQUAL FACILITY TO...',
	  '46:101.P': '46:101.P             STATEMENTS OF CONSULAR SERVICES PERF...',
	  '46:1119.M': '46:1119.M            APPROPRIATION: EXCEPT BY PERSONS ADV...',
	  '46:1132.P': '46:1132.P            CITIZENSHIP OF OFFICERS AND CREW: PE...',
	  '46:1171.F': '46:1171.F            FALSE STATEMENT OF FINANCIAL INTERES...',
	  '46:1222.M': '46:1222.M            OPERATING COMPETING FOREIGN-FLAG VESSEL',
	  '46:1223A.M': '46:1223A.M           FOREIGN TRADE SUBSIDY CONTRACTOR ENG...',
	  '46:1223D.M': '46:1223D.M           EMPLOYING OTHER PERSONS AS MANAGING ...',
	  '46:1223E.M': '46:1223E.M           EMPLOYING MEMBER OF CONGRESS',
	  '46:1223F.M': '46:1223F.M           PENALTY FOR WILLFUL VIOLATION OF ANY...',
	  '46:1224.F': '46:1224.F            COLLUSION WITH RESPECT TO BIDDING',
	  '46:1225.F': '46:1225.F            EMPLOYMENT OF PERSONS TO APPEAR BEFO...',
	  '46:1226.F': '46:1226.F            DISCRIMINATION IN RESPECT TO CARGO',
	  '46:1227.M': '46:1227.M            AGREEMENTS WITH OTHER CARRIERS FORBI...',
	  '46:1228.M': '46:1228.M            KNOWING AND WILLFUL VIOLATION: ORDER...',
	  '46:1276.M': '46:1276.M            FALSE STATEMENTS TO OBTAIN A LOAN',
	  '46:1333A.M': '46:1333A.M           INSPECTION LAWS RELATING TO PASSENGE...',
	  '46:1333B.M': '46:1333B.M           MINIMUM STANDARDS FOR QUARTERS',
	  '46:1333C.M': '46:1333C.M           CERTIFICATE OF INSPECTION',
	  '46:1333D.M': '46:1333D.M           UNLAWFUL TO OPERATE VESSEL WITHOUT C...',
	  '46:1333E.M': '46:1333E.M           CIVILIAN NAUTICAL SCHOOL: FINES AND ...',
	  '46:142.F': '46:142.F             RETALIATORY SUSPENSION - COMMERCIAL ...',
	  '46:143.F': '46:143.F             DENIAL OF RIGHTS TO U.S. VESSELS - B...',
	  '46:1461C.M': '46:1461C.M           USE OF VESSEL IN VIOLATION OF REGULA...',
	  '46:1461D.M': '46:1461D.M           NEGLIGENT USE OF VESSEL',
	  '46:1483.M': '46:1483.M            USE OF VESSEL IN VIOLATION OF CHAPTE...',
	  '46:151.P': '46:151.P             ACCOMMODATIONS FOR STEERAGE PASSENGE...',
	  '46:152.P': '46:152.P             BERTHS FOR PASSENGERS',
	  '46:154.P': '46:154.P             FOOD FOR STEERAGE PASSENGERS',
	  '46:156.M': '46:156.M             TRANSPORT OF ANIMALS BY VESSEL CARRY...',
	  '46:157.P': '46:157.P             VISITING PARTS OF VESSEL OCCUPIED BY...',
	  '46:158.P': '46:158.P             BOARDING VESSEL ON ARRIVAL: PASSENGE...',
	  '46:161.M': '46:161.M             WITHHOLDING CLEARANCE PAPERS',
	  '46:163.P': '46:163.P             REGULATIONS: BOARDING ARRIVING VESSE...',
	  '46:170.F': '46:170.F             TENDERING EXPLOSIVES OR OTHER DANGER...',
	  '46:190.P': '46:190.P             STIPULATIONS RELIEVING FROM LIABILIT...',
	  '46:191.P': '46:191.P             STIPULATIONS RELIEVING FROM EXERCISE...',
	  '46:192.P': '46:192.P             LIMITATION OF LIABILITY FOR ERRORS O...',
	  '46:193.P': '46:193.P             BILLS OF LADING TO BE ISSUED: CONTENTS',
	  '46:194.P': '46:194.P             PENALTY FOR VIOLATION OF 190-3',
	  '46:229E.F': '46:229E.F            LICENSING OF RADIOTELEGRAPH OPERATOR...',
	  '46:229F.P': '46:229F.P            LICENSES OF RADIOTELEGRAPH OPERATORS...',
	  '46:2302.M': '46:2302.M            NEGLIGENT OPERATION OF VESSEL',
	  '46:2302.P': '46:2302.P            NEGLIGENT OPERATION OF VESSEL',
	  '46:231.F': '46:231.F             OATH OF LICENSE: PERJURY: ALTERATION...',
	  '46:232.P': '46:232.P             EXHIBITION OF LICENSES',
	  '46:239.M': '46:239.M             MARINE CASUALTIES: COERCION - BRIBER...',
	  '46:246.P': '46:246.P             UNLAWFUL TO CHANGE CERTIFICATE OF RE...',
	  '46:249.P': '46:249.P             REGULATIONS: MANUFACTURE/SELL/POSSES...',
	  '46:277.M': '46:277.M             INSPECTION OF DOCUMENTS',
	  '46:369.F': '46:369.F             DEFACING OR DESTRUCTION OF PLANS: PE...',
	  '46:391.F': '46:391.F             PENALTIES - WILLFUL VIOLATION',
	  '46:403.P': '46:403.P             PUNISHMENT FOR CERTIFYING FALSELY',
	  '46:407.P': '46:407.P             PUNISHMENT FOR IMPROPER CONSTRUCTION',
	  '46:408.F': '46:408.F             BOILER PLATES',
	  '46:410.F': '46:410.F             COUNTERFEITING STAMPS',
	  '46:413.F': '46:413.F             OBSTRUCTING SAFETY VALVES',
	  '46:45.P': '46:45.P              NUMBERS FOR VESSELS',
	  '46:452.P': '46:452.P             PENALTY FOR CARRYING TOO MANY PASSEN...',
	  '46:457.P': '46:457.P             TRANSPORTATION OF PASSENGERS AND MER...',
	  '46:471.P': '46:471.P             PENALTY FOR FAILURE TO KEEP WATCHMEN',
	  '46:479.P': '46:479.P             PENALTY: NOT PROVIDING PROPER ACCOMM...',
	  '46:481.F': '46:481.F             MANUFACTURE/SALE OF DEFECTIVE EQUIPMENT',
	  '46:498.P': '46:498.P             PENALTY IN CASES NOT PROVIDED FOR',
	  '46:563.P': '46:563.P             SHIPMENT OF CREWS: SHIPPING AGREEMENTS',
	  '46:58.P': '46:58.P              MISCONDUCT BY OFFICERS - PENALTIES',
	  '46:59.P': '46:59.P              PENALTY FOR NEGLECT BY OFFICERS',
	  '46:599.P': '46:599.P             ADVANCES AND ALLOTMENTS',
	  '46:643A.P': '46:643A.P            ISSUANCE, FORM AND CONTENTS',
	  '46:643G.M': '46:643G.M            DISCHARGE BOOK AND CERTIFICATE OF ID...',
	  '46:643K.P': '46:643K.P            PERFORMANCE OF DUTIES BY COLLECTOR, ...',
	  '46:658.F': '46:658.F             DISCHARGE OF CREW ON ACCOUNT OF UNSE...',
	  '46:660.P': '46:660.P             REFUSAL TO PAY WAGES AND CHARGES',
	  '46:672.M': '46:672.M             REQUIREMENTS, QUALIFICATIONS, AND RE...',
	  '46:676.P': '46:676.P             RULES AS TO LIST OF CREW',
	  '46:684.P': '46:684.P             WAGES ON DISCHARGE IN CASE OF SALE',
	  '46:701.F': '46:701.F             ASSAULTING OFFICER',
	  '46:701.M': '46:701.M             WILLFULLY DAMAGING VESSEL',
	  '46:701.P': '46:701.P             WILLFUL DISOBEDIENCE TO ANY LAWFUL C...',
	  '46:70502.F': '46:70502.F           DEFINITIONS - MARITIME DRUG LAW ENFO...',
	  '46:70504.F': '46:70504.F           JURISDICTION AND VENUE - MARITIME DR...',
	  '46:709.P': '46:709.P             SOLICITING SEAMAN AS LODGERS',
	  '46:728.F': '46:728.F             DUTY OF MASTER TO ASSIST PERSONS IN ...',
	  '46:738B.P': '46:738B.P            OPERATOR OF VESSEL TO GIVE NOTICE OF...',
	  '46:738C.P': '46:738C.P            SPEED OF VESSEL IN ICE REGION: PENALTY',
	  '46:808.F': '46:808.F             REGISTRATION, ENROLLMENT, LICENSE OF...',
	  '46:812.M': '46:812.M             REBATES AND DISCRIMINATION BY CARRIE...',
	  '46:815.P': '46:815.P             DISCRIMINATORY ACTS PROHIBITED',
	  '46:817.M': '46:817.M             FREE TRANSPORT OF GOVT. PERSON IN AM...',
	  '46:820.M': '46:820.M             REPORTS BY CARRIERS REQUIRED',
	  '46:831.P': '46:831.P             PENALTY FOR VIOLATION OF CHAPTER 6',
	  '46:835.F': '46:835.F             RESTRICTION ON TRANSFER OF SHIPPING ...',
	  '46:838.F': '46:838.F             RECORD OF SALE OR OTHER DISPOSAL OF ...',
	  '46:85F.M': '46:85F.M             DETENTION OF VESSELS LOADED IN VIOLA...',
	  '46:85G.M': '46:85G.M             PERMITTING A VESSEL TO DEPART IN VIO...',
	  '46:86H.M': '46:86H.M             DETENTION OF VESSELS - LIABILITY FOR...',
	  '46:88F.P': '46:88F.P             DETENTION OF VESSELS LOADED IN VIOLA...',
	  '46:88G.M': '46:88G.M             REMOVAL OF MARKS PLACED ON VESSEL',
	  '46:88G.P': '46:88G.P             DEPARTURE IN VIOLATION OF 88F DETENT...',
	  '46:924.F': '46:924.F             PRIOR AND SUBSEQUENT MARITIME LIENS ...',
	  '46:941.F': '46:941.F             SHIP MORTGAGES: UNLAWFUL ACTS BY MOR...',
	  '46A:1903G=CD.F': '46A:1903G=CD.F       CONTROLLED SUBSTANCE - SELL, DISTRIB...',
	  '46A:1903G=CD.M': '46A:1903G=CD.M       CONTROLLED SUBSTANCE - MANUFACTURE',
	  '46A:1903G=CM.F': '46A:1903G=CM.F       CONTROLLED SUBSTANCE - MANUFACTURE',
	  '46A:1903G=MD.F': '46A:1903G=MD.F       MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
	  '46A:1903G=MM.F': '46A:1903G=MM.F       MARIJUANA - MANUFACTURE',
	  '46A:1903G=ND.F': '46A:1903G=ND.F       NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
	  '46A:1903G=ND.M': '46A:1903G=ND.M       NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
	  '46A:1903G=NM.F': '46A:1903G=NM.F       NARCOTICS - MANUFACTURE',
	  '46A:1903G=NM.M': '46A:1903G=NM.M       NARCOTICS - MANUFACTURE',
	  '46A:1903J=CD.m': '46A:1903J=CD.F       CONSP TO DISTRIB/POSS WITH INTENT TO...',
	  '46A:1903J=CD.F': '46A:1903J=CD.F       CONTROLLED SUBSTANCE - SELL, DISTRIB...',
	  '46A:1903J=CD.M': '46A:1903J=CD.M       CONTROLLED SUBSTANCE - SELL, DISTRIB...',
	  '46A:1903J=CM.F': '46A:1903J=CM.F       CONSPIRACY TO MANU/POSS W/INTENT TO ...',
	  '46A:1903J=CM.M': '46A:1903J=CM.F       CONTROLLED SUBSTANCE - MANUFACTURE',
	  '46A:1903J=MD.F': '46A:1903J=MD.F       MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
	  '46A:1903J=MD.M': '46A:1903J=MD.M       MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
	  '46A:1903J=MM.F': '46A:1903J=MM.F       MARIJUANA - MANUFACTURE',
	  '46A:1903J=ND.F': '46A:1903J=ND.F       NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
	  '46A:1903J=ND.M': '46A:1903J=ND.M       NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
	  '46A:1903J=NM.F': '46A:1903J=NM.F       NARCOTICS - MANUFACTURE',
	  '46A:1903J=NM.M': '46A:1903J=NM.M       NARCOTICS - MANUFACTURE',
	  '47:13.P': '47:13.P              TELEGRAPHS - ACTION FOR DAMAGES - VI...',
	  '47:21.F': '47:21.F              WILLFUL INJURY TO SUBMARINE CABLES',
	  '47:22.P': '47:22.P              SUBMARINE CABLES: NEGLIGENT INJURY TO',
	  '47:220.F': '47:220.F             ACCOUNTS, RECORDS, MEMOS: WILLFUL FA...',
	  '47:223A.F': '47:223A.F            OBSCENE OR HARASSING TELEPHONE CALLS',
	  '47:223A.M': '47:223A.M            OBSCENE OR HARASSING TELEPHONE CALLS',
	  '47:223A.P': '47:223A.P            OBSCENE OR HARASSING TELEPHONE CALLS',
	  '47:223B.M': '47:223B.M            OBSCENE OR HARASSING TELEPHONE CALLS',
	  '47:223B.P': '47:223B.P            OBSCENE OR HARASSING TELEPHONE CALLS',
	  '47:24.P': '47:24.P              VESSELS LAYING CABLES: SIGNALS: AVOI...',
	  '47:25.P': '47:25.P              FISHING VESSELS: DUTY TO KEEP NETS F...',
	  '47:27.F': '47:27.F              OFFENDING VESSELS TO SHOW NATIONALITY',
	  '47:301.F': '47:301.F             LICENSE FOR RADIO COMMUNICATION  (T)',
	  '47:301.M': '47:301.M             LICENSE FOR RADIO COMMUNICATION',
	  '47:302.F': '47:302.F             DEVICES WHICH INTERFERE WITH RADIO R...',
	  '47:325.F': '47:325.F             FALSE DISTRESS SIGNALS',
	  '47:325.M': '47:325.M             FALSE DISTRESS SIGNALS',
	  '47:37.M': '47:37.M              LICENSES FOR LANDING OR OPERATING CA...',
	  '47:409.M': '47:409.M             REFUSAL TO OBEY A SUBPOENA',
	  '47:501.F': '47:501.F             COMMUNICATION ACTS  (T)',
	  '47:501.M': '47:501.M             GENERAL PENALTY - 1ST OFFENSE',
	  '47:502.P': '47:502.P             VIOLATION OF RULES, REGULATIONS, ETC.',
	  '47:506.M': '47:506.M             COERCIVE PRACTICE AFFECTING BROADCAS...',
	  '47:506.P': '47:506.P             UNAUTHORIZED COMMUNICATION  (T)',
	  '47:508A.M': '47:508A.M            PAYMENTS TO STATION EMPLOYEES',
	  '47:508B.M': '47:508B.M            PRODUCTION OR PREPARATION OF PROGRAMS',
	  '47:508C.M': '47:508C.M            SUPPLYING OF PROGRAM OR PROGRAM MATTER',
	  '47:508G.M': '47:508G.M            DISCLOSURE OF PAYMENTS TO INDIV. CON...',
	  '47:509A.M': '47:509A.M            INFLUENCING, PREARRANGING OR PREDETE...',
	  '47:509C.M': '47:509C.M            PROHIBITED PRACTICE IN CONTESTS OF K...',
	  '47:553.F': '47:553.F             FINANCIAL GAIN FROM CABLE SERVICE',
	  '47:553.M': '47:553.M             FINANCIAL GAIN FROM CABLE SERVICE',
	  '47:605A.F': '47:605A.F            UNAUTHORIZED COMMUNICATION  (T)',
	  '47:605A.M': '47:605A.M            UNAUTHORIZED COMMUNICATION  (T)',
	  '47:606.F': '47:606.F             WILLFUL ACT WITH INTENT TO INJURE U.S.',
	  '47:606.M': '47:606.M             WILLFUL ACT IN VIOLATION OF PRESIDEN...',
	  '49:101.F': '49:101.F             UNLAWFUL DISCRIMINATION IN RATES: VI...',
	  '49:102.F': '49:102.F             FALSE BILLING OR CLASSIFICATION BY C...',
	  '49:1021A.P': '49:1021A.P           VIOLATION OF CHAPTER - 2ND OFFENSE',
	  '49:1021B.P': '49:1021B.P           SERVICE AT LESS THAN SPECIFIED RATES...',
	  '49:1021C.P': '49:1021C.P           SERVICE AT LESS THAN LAWFUL RATES - ...',
	  '49:1021D.P': '49:1021D.P           FAILURE OR REFUSAL TO MAKE REPORT, F...',
	  '49:1021E.P': '49:1021E.P           DISCLOSURE OF INFORMATION BY AGENT O...',
	  '49:1021F.P': '49:1021F.P           DISCLOSURE OF INFORMATION BY FREIGHT...',
	  '49:103.F': '49:103.F             OBTAINING LOWER RATES BY FALSE BILLI...',
	  '49:104.F': '49:104.F             INDUCING UNJUST DISCRIMINATION: PENALTY',
	  '49:11322.F': '49:11322.F           RESTRICTIONS ON ACTIONS OF OFFICERS/...',
	  '49:11703.P': '49:11703.P           DISCLOSURE OF INFORMATION BY FREIGHT...',
	  '49:11709.F': '49:11709.F           SECURITIES ISSUED CONTRARY TO LAW VOID',
	  '49:117A.P': '49:117A.P            BRIBERY',
	  '49:117B.F': '49:117B.F            BRIBERY',
	  '49:11903A.F': '49:11903A.F          LIABILITY OF CORPORATE COMMON CARRIE...',
	  '49:11903B.F': '49:11903B.F          NOT PUBLISHING OR FILING RATES OR TA...',
	  '49:11904.P': '49:11904.P           SERVICE AT LESS THAN SPECIFIED RATES...',
	  '49:11904A.F': '49:11904A.F          FALSE BILLING OR CLASSIFICATION BY C...',
	  '49:11904B.F': '49:11904B.F          INDUCING UNJUST DISCRIMINATION: PENALTY',
	  '49:11905.P': '49:11905.P           FREE TRANSPORT FOR PASSENGERS PROHIB...',
	  '49:11907.F': '49:11907.F           BRIBERY',
	  '49:11907.P': '49:11907.P           BRIBERY',
	  '49:11909A.F': '49:11909A.F          RECORDKEEPING AND REPORTING VIOLATIONS',
	  '49:11909B.P': '49:11909B.P          FAILURE OR REFUSAL TO MAKE REPORT, F...',
	  '49:11909C.P': '49:11909C.P          RECORDKEEPING AND REPORTING VIOLATIONS',
	  '49:11909D.P': '49:11909D.P          RECORDKEEPING AND REPORTING VIOLATIONS',
	  '49:11910.P': '49:11910.P           DISCLOSURE OF INFORMATION BY AGENT O...',
	  '49:11910C.P': '49:11910C.P          ACCOUNTS, RECORDS, REPORTS: DIVULGIN...',
	  '49:11913.M': '49:11913.M           NEGLECT OR REFUSAL TO ATTEND AND TES...',
	  '49:11914.F': '49:11914.F           UNLAWFUL DISCRIMINATION IN RATES: VI...',
	  '49:11914.P': '49:11914.P           MOTOR CARRIER SAFETY REGULATIONS',
	  '49:11915.F': '49:11915.F           PUNISHMENT OF CORPORATION FOR VIOLAT...',
	  '49:1679.F': '49:1679.F            FEDERAL SAFETY STANDARDS',
	  '49:17.P': '49:17.P              FREE TRANSPORTATION PROHIBITED - PEN...',
	  '49:1725.F': '49:1725.F            AVIATION FACILITY: FALSE STATEMENTS,...',
	  '49:20.F': '49:20.F              SECURITIES ISSUED CONTRARY TO LAW',
	  '49:207B.F': '49:207B.F            KNOWING AND WILLFUL FALSE ENTRY',
	  '49:207F.P': '49:207F.P            ACCOUNTS, RECORDS, REPORTS: DIVULGIN...',
	  '49:301.F': '49:301.F             SHORT TITLE',
	  '49:302.F': '49:302.F             APPLICATION OF PROVISIONS',
	  '49:303.F': '49:303.F             DEFINITIONS AND EXCEPTIONS',
	  '49:304.F': '49:304.F             POWERS AND DUTIES OF COMMISSION',
	  '49:322A.P': '49:322A.P            VIOLATION WHERE NONE OTHER PROVIDED:...',
	  '49:322C.P': '49:322C.P            PARTICIPATION IN UNJUST DISCRIMINATI...',
	  '49:322D.P': '49:322D.P            DISCLOSURE OF INFORMATION BY AGENT, ...',
	  '49:322G.P': '49:322G.P            ALTERING OR MAKING FALSE REPORT OR R...',
	  '49:32701.F': '49:32701.F           ALTERING ODOMETER SETTINGS FORMERLY ...',
	  '49:32703.F': '49:32703.F           TAMPERING WITH MOTOR VEHICLE ODOMETERS',
	  '49:32704.F': '49:32704.F           ODOMETERS-SERVICE, REPAIR, REPLACEMENT',
	  '49:32705F': '49:32705F            DISCLOSURE REQUIREMENTS ON TRANSFER ...',
	  '49:32709.F': '49:32709.F           FALSE STATEMENTS ON TRANSFER DOCUMENTS',
	  '49:411.F': '49:411.F             LIABILITY OF CORPORATE COMMON CARRIE...',
	  '49:46.M': '49:46.M              NEGLECT OR REFUSAL TO ATTEND AND TES...',
	  '49:46306.F': '49:46306.F           REGISTRATION VIOLATIONS NON-AIR TRAN...',
	  '49:46308.F': '49:46308.F           INTERFERENCE WITH AIR NAVIGATION',
	  '49:46310.F': '49:46310.F           REPORTING AND RECORD KEEPING VIOLATIONS',
	  '49:46312.F': '49:46312.F           TRANSPORTING HAZARDOUS MATERIAL',
	  '49:46313.M': '49:46313.M           REFUSING TO APPEAR OR PRODUCE RECORDS',
	  '49:46314.F': '49:46314.F           Interference with flight crew member...',
	  '49:46314.M': '49:46314.M           Interference with flight crew member...',
	  '49:46316.P': '49:46316.P           IN VIOLATION OF REGULATIONS PRESCRIB...',
	  '49:46317.F': '49:46317.F           PILOTS OPERATING IN AIR TRANSPORTATI...',
	  '49:46318.M': '49:46318.M           INTERFERENCE WITH CABIN OR FLIGHT CREW',
	  '49:46502.F': '49:46502.F           AIRCRAFT PIRACY',
	  '49:46503.F': '49:46503.F           INTERFERENCE WITH SECURITY SCREENING...',
	  '49:46504.F': '49:46504.F           INTERFERENCE WITH FLIGHT CREW MEMBER...',
	  '49:46505.F': '49:46505.F           ATTEMPT OR CARRY A WEAPON OR EXPLOSI...',
	  '49:46505.M': '49:46505.M           ATTEMPT OR CARRY WEAPON OR EXPLOSIVE...',
	  '49:46506.F': '49:46506.F           APPLICATION OF CERTAIN CRIMINAL LAWS...',
	  '49:46506.M': '49:46506.M           APPLICATION OF CERTAIN LAWS ON AIRCRAFT',
	  '49:46507.F': '49:46507.F           FALSE INFORMATION OR THREATS CONCERN...',
	  '49:5124.F': '49:5124.F            TRANSPORTATION OF HAZARDOUS MATERIAL',
	  '49:521B.M': '49:521B.M            VIOLATIONS PERTAINING TO CDLS',
	  '49:522A.F': '49:522A.F            REPORTING AND RECORDKEEPING VIOLATIONS',
	  '49:522B.P': '49:522B.P            REPORTING AND RECORDKEEPING VIOLATIONS',
	  '49:525.M': '49:525.M             DISOBEDIENCE TO A SUBPOENA',
	  '49:526.P': '49:526.P             PENALTY FOR VIOLATION WHERE NONE OTH...',
	  '49:60123.F': '49:60123.F           VIOLATION OF SAFETY STANDARDS AND WA...',
	  '49:60123.M': '49:60123.M           VIOLATION OF SAFETY STANDARDS AND WA...',
	  '49:80116.F': '49:80116.F           FRAUD-BILLS OF LADING-CRIMINAL PENALTY',
	  '49:917A.P': '49:917A.P            UNLAWFUL ACTS AND PENALTIES',
	  '49:917B.P': '49:917B.P            UNLAWFUL ACTS AND PENALTIES: GIVING ...',
	  '49:917C.P': '49:917C.P            ACCEPTING REBATES, FALSE BILLING, ETC.',
	  '49:917D.P': '49:917D.P            WILLFUL FAILURE OR REFUSAL TO MAKE R...',
	  '49:917E.P': '49:917E.P            DIVULGING INFORMATION BY AGENT OF CO...',
	  '49:917F.P': '49:917F.P            DISCLOSURE OF INFORMATION BY COMMON ...',
	  '49A:1159.P': '49A:1159.P           WILLFUL VIOLATION OF RULES OR REGULA...',
	  '49A:120.F': '49A:120.F            ISSUANCE OF CERTIFICATE - UNLAWFUL E...',
	  '49A:121.F': '49A:121.F            FALSIFYING BILLS OF LADING',
	  '49A:1472A.F': '49A:1472A.F          FORGE, COUNTERFEIT OR POSSESS FALSE ...',
	  '49A:1472A.P': '49A:1472A.P          FORGE, COUNTERFEIT OR POSSESS FALSE ...',
	  '49A:1472B.F': '49A:1472B.F          FORGERY OF CERTIFICATE, FALSE MARKIN...',
	  '49A:1472B=CA.F': '49A:1472B=CA.F       CONTROLLED SUBSTANCES ABOARD AIRCRAFT',
	  '49A:1472C.F': '49A:1472C.F          INTERFERENCE WITH AIR NAVIGATION',
	  '49A:1472D.P': '49A:1472D.P          OFFER, GRANT OR GIVE ANY REBATE OR C...',
	  '49A:1472E.P': '49A:1472E.P          FAILURE TO FILE REPORTS',
	  '49A:1472F.F': '49A:1472F.F          DIVULGING INFORMATION',
	  '49A:1472G.M': '49A:1472G.M          REFUSAL TO TESTIFY',
	  '49A:1472H.F': '49A:1472H.F          SHIPPING HAZARDOUS MATERIAL',
	  '49A:1472I.F': '49A:1472I.F          RAPE ON BOARD VESSEL',
	  '49A:1472J.F': '49A:1472J.F          INTERFERENCE WITH FLIGHT CREW MEMBER',
	  '49A:1472K.F': '49A:1472K.F          ASSAULT WITH INTENT TO MURDER',
	  '49A:1472K.M': '49A:1472K.M          STEAL PERSONAL PROPERTY ON BOARD VESSEL',
	  '49A:1472K.P': '49A:1472K.P          ASSAULT BY STRIKING, BEATING OR WOUN...',
	  '49A:1472L.F': '49A:1472L.F          ASSAULT WITH INTENT TO COMMIT MURDER',
	  '49A:1472M.M': '49A:1472M.M          FALSE INFORMATION AND THREATS',
	  '49A:1472M.P': '49A:1472M.P          SOLICITING REFUND OF ANY RATE, FARE ...',
	  '49A:1472O.M': '49A:1472O.M          INTERFERENCE WITH AIRCRAFT ACCIDENT ...',
	  '49A:1472P.M': '49A:1472P.M          INTERFERENCE WITH AIRCRAFT ACCIDENT ...',
	  '49A:1472Q.F': '49A:1472Q.F          TRANSPORTATION OF DRUGS BY AIRCRAFT',
	  '49A:1523.M': '49A:1523.M           SECURITY PROVISION - PENALTIES',
	  '49A:1804.F': '49A:1804.F           REGULATIONS GOVERNING TRANSPORT OF H...',
	  '49A:1805.F': '49A:1805.F           HANDLING OF HAZARDOUS MATERIALS',
	  '49A:1809.F': '49A:1809.F           VIOLATING PROVISIONS OR REGULATIONS ...',
	  '4:3.P': '4:3.P                MUTILATION OF FLAG',
	  '50:1436B.P': '50:1436B.P           REPORTING REQUIREMENTS',
	  '50:1436E.P': '50:1436E.P           TERMINATION OF EMPLOYMENT: FILING RE...',
	  '50:1436G.P': '50:1436G.P           PENALTIES FOR FAILURE TO COMPLY WITH...',
	  '50:167.F': '50:167.F             HELIUM GAS',
	  '50:1702.F': '50:1702.F            PRESIDENTIAL AUTHORITIES',
	  '50:1705.F': '50:1705.F            PENALTIES, VIOLATES ANY LICENSE OR O...',
	  '50:1809A.F': '50:1809A.F           ENGAGE IN ELECTRONIC SURVEILLANCE',
	  '50:1809C.F': '50:1809C.F           PENALTIES',
	  '50:192.F': '50:192.F             FAIL, OBSTRUCT OR INTERFERE WITH RUL...',
	  '50:210.F': '50:210.F             PENALTIES FOR UNAUTHORIZED TRADING',
	  '50:217.F': '50:217.F             TRADING IN CAPTURED OR ABANDONED PRO...',
	  '50:421A.F': '50:421A.F            PROTECTION OF NATIONAL SECURITY INFO...',
	  '50:421B.F': '50:421B.F            PROTECTION OF NATIONAL SECURITY INFO...',
	  '50:421C.F': '50:421C.F            PROTECTION OF NATIONAL SECURITY INFO...',
	  '50:783A.F': '50:783A.F            COMMUNICATION OF CLASSIFIED INFORMAT...',
	  '50:783B.F': '50:783B.F            COMMUNICATION OF CLASSIFIED INFORMAT...',
	  '50:783C.F': '50:783C.F            RECEIPT OF, OR ATTEMPT TO RECEIVE BY...',
	  '50:783D.F': '50:783D.F            INTERNAL SECURITY: PENALTIES FOR VIO...',
	  '50:784.F': '50:784.F             FAILURE TO DISCLOSE MEMBERSHIP IN CO...',
	  '50:789.F': '50:789.F             USE OF MAILS AND INSTRUMENT OF INTER...',
	  '50:789.M': '50:789.M             USE OF MAILS AND INSTRUMENT OF INTER...',
	  '50:794.F': '50:794.F             PENALTIES',
	  '50:794.M': '50:794.M             PENALTIES',
	  '50:797.M': '50:797.M             SECURITY REGULATIONS AND ORDERS: PEN...',
	  '50:822.F': '50:822.F             RESISTING, DISREGARDING OR EVADING A...',
	  '50:823.F': '50:823.F             AIDING EVASION OF APPREHENSION, OR E...',
	  '50:824.M': '50:824.M             RESISTANCE OF,OR INTERFERENCE WITH B...',
	  '50:851.F': '50:851.F             REGISTRATION OF CERTAIN PERSON: FILI...',
	  '50:855.F': '50:855.F             VIOLATIONS: SUBCHAPTER V',
	  '50A:1152.M': '50A:1152.M           PENALTIES FOR VIOLATIONS - NATIONAL ...',
	  '50A:1193.F': '50A:1193.F           PENALTIES - FAILURE TO FURNISH INFO....',
	  '50A:16.F': '50A:16.F             PENALTIES - TRADING WITH THE ENEMY',
	  '50A:1985.M': '50A:1985.M           PENALTIES - OVERCHARGE ATTORNEY FEES',
	  '50A:2.F': '50A:2.F              TRADING WITH THE ENEMY ACT',
	  '50A:2061.M': '50A:2061.M           PENALTIES - CRIMINAL VIOLATIONS',
	  '50A:2062.M': '50A:2062.M           PENALTIES - CRIMINAL VIOLATIONS',
	  '50A:2071A.M': '50A:2071A.M          ALLOCATION OF MATERIAL AND FACILITIE...',
	  '50A:2071B.M': '50A:2071B.M          CRITICAL AND STRATEGIC MATERIALS - N...',
	  '50A:2072.M': '50A:2072.M           HOARDING DESIGNATED MATERIALS - NATI...',
	  '50A:2073.M': '50A:2073.M           PENALTIES - VIOLATION OF EXPORT CONT...',
	  '50A:2213.M': '50A:2213.M           FRAUD - ACCEPTANCE OF BENEFITS',
	  '50A:2405A.F': '50A:2405A.F          VIOLATING EXPORT REGULATIONS - 2ND O...',
	  '50A:2405A.M': '50A:2405A.M          VIOLATING EXPORT REGULATIONS - 1ST O...',
	  '50A:2405B.F': '50A:2405B.F          EXPORT TO COMMUNIST DOMINATED NATIONS',
	  '50A:2410A.F': '50A:2410A.F          PENALTIES - EXPORTATION OF WAR MATER...',
	  '50A:2410B.F': '50A:2410B.F          PENALTIES - EXPORTATION OF WAR MATER...',
	  '50A:2410B.M': '50A:2410B.M          PENALTIES - EXPORTATION OF WAR MATER...',
	  '50A:321.F': '50A:321.F            PENALTIES - VIOLATION OF SELECTIVE S...',
	  '50A:322.F': '50A:322.F            SELECTIVE SERVICE FUNCTIONS, DUTIES,...',
	  '50A:323.F': '50A:323.F            SELECTIVE SERVICE TRANSFER OF FUNDS/...',
	  '50A:324.F': '50A:324.F            SELECTIVE SERVICE TRANSFER OF PROPER...',
	  '50A:325.F': '50A:325.F            SELECTIVE SERVICE TRANSFER OF FUNCTI...',
	  '50A:326.F': '50A:326.F            SELECTIVE SERVICE POWERS AND DUTIES ...',
	  '50A:327.F': '50A:327.F            SELECTIVE SERVICE UNLAWFUL USE OF CO...',
	  '50A:328.F': '50A:328.F            SELECTIVE SERVICE SUSPENSION OF CONF...',
	  '50A:329.F': '50A:329.F            SELECTIVE SERVICE EFFECTIVE DATE',
	  '50A:3A.F': '50A:3A.F             TRADING WITH THE ENEMY ACT',
	  '50A:3B.F': '50A:3B.F             TRANSPORTING AN ENEMY INTO OR OUT OF...',
	  '50A:3C.F': '50A:3C.F             COMMUNICATE WITH THE ENEMY',
	  '50A:462.F': '50A:462.F            EVADE THE SELECTIVE SERVICE',
	  '50A:468A.F': '50A:468A.F           PLACEMENT OF ORDERS',
	  '50A:468B.F': '50A:468B.F           SELECTIVE SERVICE PRECEDENCE OF GOVE...',
	  '50A:468F.F': '50A:468F.F           SELECTIVE SERVICE PENALTIES',
	  '50A:531.M': '50A:531.M            WAR AND NATIONAL DEFENSE, OTHER',
	  '50A:532.M': '50A:532.M            FEDERAL STATUTES - MORTGAGES, TRUST ...',
	  '50A:643A.F': '50A:643A.F           NATIONAL DEFENSE, OTHER',
	  '50A:643B.M': '50A:643B.M           CONTEMPT - REFUSAL TO GIVE EVIDENCE',
	  '50A:781.M': '50A:781.M            ILLEGAL KNOWLEDGE OF MILITARY INSTAL...',
	  '50A:783.M': '50A:783.M            NATIONAL DEFENSE, OTHER',
	  '5:552.F': '5:552.F              PUBLIC INFORMATION',
	  '5:552.M': '5:552.M              OBTAINS/REQUESTS INDIVIDUAL RECORDS ...',
	  '7:12.M': '7:12.M               TRADING BAN VIOLATIONS',
	  '7:136.F': '7:136.F              UNLAWFUL USE OF INSECTICIDES, PENALTIES',
	  '7:136.M': '7:136.M              UNLAWFUL USE OF INSECTICIDES, PENALTIES',
	  '7:136.P': '7:136.P              UNLAWFUL USE OF INSECTICIDES, PENALTIES',
	  '7:1373.P': '7:1373.P             REPORTS AND RECORDS',
	  '7:1379B.P': '7:1379B.P            WHEAT MARKET ALLOCATIONS',
	  '7:1379C.P': '7:1379C.P            MARKETING CERTIFICATES',
	  '7:1379D.P': '7:1379D.P            TRANSFER OF CERTIFICATES, RESTRICTIONS',
	  '7:1379E.P': '7:1379E.P            PURCHASE/SALE OF MARKET CERTIFICATES',
	  '7:1379F.P': '7:1379F.P            CONVERSION FACTORS',
	  '7:1379G.P': '7:1379G.P            AUTHORITY TO FACILITATE TRANSITION',
	  '7:1379H.P': '7:1379H.P            APPLICABILITY OF PROVISIONS',
	  '7:1379I.F': '7:1379I.F            AGRICULTURE, PENALTIES',
	  '7:1379I.P': '7:1379I.P            AGRICULTURE, PENALTIES',
	  '7:1379J.P': '7:1379J.P            REGULATIONS',
	  '7:1380.P': '7:1380.P             REPORTS AND RECORDS, RICE CERTIFICATES',
	  '7:13A.F': '7:13A.F              EMBEZZLEMENT OR LARCENY, EMPLOYEES O...',
	  '7:13B.F': '7:13B.F              PRICE MANIPULATION CONCERNING COMMUN...',
	  '7:13C.F': '7:13C.F              FALSE CLAIMS AND STATEMENTS',
	  '7:1433.M': '7:1433.M             MISUSE OF DESIGNATED FOOD',
	  '7:150B.M': '7:150B.M             PLANT QUARANTINE - PERMITS FOR MOVEM...',
	  '7:150C.M': '7:150C.M             PLANT QUARANTINE - UNLAWFUL MAILING ...',
	  '7:150D.M': '7:150D.M             PLANT QUARANTINE - DISPOSAL',
	  '7:150E.M': '7:150E.M             PLANT QUARANTINE - REGULATIONS AND C...',
	  '7:150G.M': '7:150G.M             PLANT QUARANTINE - PLANT PESTS',
	  '7:154.M': '7:154.M              PLANT QUARANTINE - RESTRICT PLANT IM...',
	  '7:156.M': '7:156.M              PLANT QUARANTINE - SHIPPING WITHOUT ...',
	  '7:157.M': '7:157.M              PLANT QUARANTINE - INCORRECT MARKING...',
	  '7:158.M': '7:158.M              PLANT QUARANTINE - INCORRECT MARKING...',
	  '7:1596.P': '7:1596.P             FOREIGN COMMERCE REGULATIONS',
	  '7:161.M': '7:161.M              INTERSTATE QUARANTINE',
	  '7:162.M': '7:162.M              PLANT QUARANTINE - RULES AND REGULAT...',
	  '7:1622.M': '7:1622.M             INSPECTION OF AGRICULTURAL PRODUCTS',
	  '7:163.M': '7:163.M              FORGERY, ALTERATION OF CERTIFICATES',
	  '7:1642A.P': '7:1642A.P            RULES AND REGULATIONS',
	  '7:1642B.P': '7:1642B.P            REPORTS AND EXAMINATIONS OF BOOKS',
	  '7:1642C.P': '7:1642C.P            PENALTIES FOR VIOLATIONS',
	  '7:166.P': '7:166.P              STATE INSPECTION',
	  '7:195.F': '7:195.F              VIOLATIONS OF ORDERS',
	  '7:2023B.F': '7:2023B.F            FOOD STAMPS, UNAUTHORIZED USE BY RET...',
	  '7:2023B.M': '7:2023B.M            FOOD STAMPS, UNAUTHORIZED USE BY RET...',
	  '7:2024B.F': '7:2024B.F            TRANSFER OR UNAUTHORIZED USE OF FOOD...',
	  '7:2024B.M': '7:2024B.M            TRANSFER OR UNAUTHORIZED USE OF FOOD...',
	  '7:2024C.F': '7:2024C.F            REDEMPTION OF ILLEGALLY RECEIVED FOO...',
	  '7:2024C.M': '7:2024C.M            REDEMPTION OF ILLEGALLY RECEIVED FOO...',
	  '7:2024H.F': '7:2024H.F            CRIMINAL FORFEITURE',
	  '7:203.P': '7:203.P              FAILURE TO REGISTER',
	  '7:207A.M': '7:207A.M             SCHEDULE OF RATES, FILING: PUBLIC IN...',
	  '7:207B.M': '7:207B.M             DETAILS REQUIREMENTS: FORMS',
	  '7:207C.M': '7:207C.M             CHANGES TO REQUIREMENTS',
	  '7:207D.M': '7:207D.M             REJECTION OF PERMITS BY SECRETARY',
	  '7:207E.M': '7:207E.M             DETERMINATION OF LAWFULNESS',
	  '7:207F.M': '7:207F.M             SUSPENSION OF OPERATIONS',
	  '7:207G.P': '7:207G.P             PENALTIES',
	  '7:207H.M': '7:207H.M             INTENTIONAL VIOLATIONS, PENALTIES',
	  '7:2105.M': '7:2105.M             COTTON RESEARCH AND PROMOTION',
	  '7:211.P': '7:211.P              CHARGES OR PRACTICES, RATES',
	  '7:212.P': '7:212.P              RATES AND PRACTICES TO PREVENT DISCR...',
	  '7:213.P': '7:213.P              PREVENT UNFAIR DISCRIMINATION PRACTICES',
	  '7:2133.M': '7:2133.M             DEALERS AND EXHIBITORS LICENSING',
	  '7:2134.M': '7:2134.M             DEALERS AND EXHIBITORS VALID LICENSE',
	  '7:2135.M': '7:2135.M             TIME PERIOD, DISPOSAL OF PETS BY DEA...',
	  '7:2136.M': '7:2136.M             REGISTRATION OF RESEARCH FACILITY AN...',
	  '7:2137.M': '7:2137.M             PROHIBITED PURCHASE OF PETS BY RESEA...',
	  '7:2138.M': '7:2138.M             PROHIBITED PURCHASE OF PETS BY GOVER...',
	  '7:2141.M': '7:2141.M             MARKING AND IDENTIFICATION OF ANIMALS',
	  '7:2142.M': '7:2142.M             HUMANE STANDARDS, RECORDKEEPING REQU...',
	  '7:2143.M': '7:2143.M             HUMANE STANDARDS FOR ANIMALS, DEALER...',
	  '7:2144.M': '7:2144.M             HUMANE STANDARDS FOR ANIMALS U.S. GO...',
	  '7:2146.F': '7:2146.F             ADMINISTRATION AND ENFORCEMENT BY SE...',
	  '7:2149C.M': '7:2149C.M            VIOLATIONS, AUCTION SALES OF ANIMALS',
	  '7:215.P': '7:215.P              FAILURE TO OBEY ORDERS, PUNISHMENT',
	  '7:2151.M': '7:2151.M             RULES AND REGULATIONS',
	  '7:2156.F': '7:2156.F             ANIMAL FIGHTING VENTURE PROHIBITION',
	  '7:2156.M': '7:2156.M             TRANSPORTING ANIMALS FOR FIGHTING VE...',
	  '7:221.F': '7:221.F              PUNISHMENT FOR, FAILURE TO KEEP ACCO...',
	  '7:2621.P': '7:2621.P             POTATO RESEARCH AND PROMOTION, PENAL...',
	  '7:270.F': '7:270.F              FRAUD, WAREHOUSES, PUNISHMENT FOR VI...',
	  '7:270.P': '7:270.P              FRAUD, WAREHOUSES, PUNISHMENT FOR VI...',
	  '7:2803.M': '7:2803.M             MOVING NOXIOUS WEEDS INTO/THROUGH U.S.',
	  '7:2804.M': '7:2804.M             PLANT QUARANTINE',
	  '7:2807.M': '7:2807.M             PENALTIES - NOXIOUS WEEDS',
	  '7:2809.M': '7:2809.M             REGULATIONS',
	  '7:281.M': '7:281.M              IMPORT PROHIBITED HONEYBEES',
	  '7:282.M': '7:282.M              PENALTIES - UNLAWFUL IMPORTING HONEY...',
	  '7:3410.M': '7:3410.M             ENFORCEMENT OF ORDERS AND REGULATIONS',
	  '7:3803.M': '7:3803.M             HEALTH, FEEDING SWINE GARBAGE',
	  '7:3806.M': '7:3806.M             PENALTIES',
	  '7:472.M': '7:472.M              PENALTIES FOR DIVULGING INFORMATION',
	  '7:472.P': '7:472.P              PENALTIES FOR DIVULGING INFORMATION',
	  '7:473.M': '7:473.M              COTTON WAREHOUSES, FAILURE TO FURNIS...',
	  '7:473.P': '7:473.P              COTTON WAREHOUSES, FAILURE TO FURNIS...',
	  '7:491.M': '7:491.M              FRAUD - DESTROY INTERSTATE PRODUCE',
	  '7:491.P': '7:491.P              FRAUD - DESTROY INTERSTATE PRODUCE',
	  '7:499C.P': '7:499C.P             INSPECT PERISHABLE COMMODITIES, LICE...',
	  '7:499N.M': '7:499N.M             INSPECT PERISHABLE COMMODITIES, EMPL...',
	  '7:503.M': '7:503.M              TOBACCO STATISTICS, QUALITY REPORTS',
	  '7:503.P': '7:503.P              TOBACCO STATISTICS, QUALITY REPORTS',
	  '7:511D.M': '7:511D.M             DESIGNATION OF MARKETS',
	  '7:511I.M': '7:511I.M             TOBACCO OFFENSES',
	  '7:511K.M': '7:511K.M             TOBACCO, PENALTY FOR VIOLATIONS',
	  '7:52.P': '7:52.P               PROHIBITED USE OF STANDARDS, NON-OFF...',
	  '7:586.M': '7:586.M              VIOLATIONS AND PENALTIES, APPLES AND...',
	  '7:586.P': '7:586.P              VIOLATIONS AND PENALTIES, APPLES AND...',
	  '7:59.P': '7:59.P               COTTON STANDARDS, OFFENSES',
	  '7:596.M': '7:596.M              VIOLATIONS AND PENALTIES, GRAPES AND...',
	  '7:596.P': '7:596.P              VIOLATIONS AND PENALTIES, GRAPES AND...',
	  '7:6.F': '7:6.F                RESTRICTION OF FUTURES TRADING TO CO...',
	  '7:6.M': '7:6.M                PROHIBITIONS IN COMMODITIES, FUTURES',
	  '7:60.P': '7:60.P               PENALTIES FOR VIOLATIONS',
	  '7:608A.P': '7:608A.P             SUGAR QUOTAS',
	  '7:608C.P': '7:608C.P             COMMODITY HANDLING REGULATIONS',
	  '7:612C.F': '7:612C.F             EXPORT AND DOMESTIC USE OF AGRICULTU...',
	  '7:612C.M': '7:612C.M             EXPORT AND DOMESTIC USE OF AGRICULTU...',
	  '7:615B.M': '7:615B.M             AGRICULTURAL ADJUSTMENT - REFUND OF TAX',
	  '7:620A.P': '7:620A.P             FALSE DEDUCTIONS, CHARGES TO TAXES',
	  '7:620B.P': '7:620B.P             FALSE DEDUCTIONS, CHARGES TO TAXES',
	  '7:620C.P': '7:620C.P             FALSE DEDUCTIONS, CHARGES TO TAXES',
	  '7:6E.M': '7:6E.M               FLOOR BROKERS, PROHIBITIONS',
	  '7:6H.M': '7:6H.M               MARKET DEALINGS, PROHIBITIONS',
	  '7:6I.M': '7:6I.M               REPORTS OF DEALS, TRADING LIMITS',
	  '7:7711.F': '7:7711.F             PLANT PROTECTION',
	  '7:7734.F': '7:7734.F             PLANT PROTECTION-VIOLATIONS',
	  '7:87B.F': '7:87B.F              GRAIN SHIPMENTS, PROHIBITED ACTS',
	  '7:87B.M': '7:87B.M              GRAIN SHIPMENTS, PROHIBITED ACTS',
	  '7:87C.F': '7:87C.F              GRAIN STANDARDS - 2ND OFFENSE',
	  '7:87C.M': '7:87C.M              GRAIN STANDARDS - 1ST OFFENSE',
	  '7:95.M': '7:95.M               INJURIOUS ACTS',
	  '7:953.M': '7:953.M              PENALTIES - REPORTS',
	  '7:96.M': '7:96.M               PUNISHMENT FOR PROHIBITION VIOLATIONS',
	  8764455: '8764455              second test citation for ~COUNT',
	  882233: '882233               first test citation for ~COUNT',
	  '8:1160.F': '8:1160.F             FALSIFY DOCUMENTS FOR AGRICULTURE WO...',
	  '8:1185.F': '8:1185.F             TRAVEL CONTROL OF CITIZENS AND ALIENS',
	  '8:1252D.M': '8:1252D.M            SUPERVISION OF DEPORTABLE ALIEN - VI...',
	  '8:1252E.F': '8:1252E.F            WILLFUL FAILURE TO DEPART',
	  '8:1253.F': '8:1253.F             FAILURE TO DEPART',
	  '8:1253.M': '8:1253.M             FAILURE TO DEPART',
	  '8:1255.F': '8:1255.F             ADJUSTMENT OF CITIZENSHIP STATUS',
	  '8:1282.P': '8:1282.P             CONDITIONAL PERMITS TO LAND TEMPORARILY',
	  '8:1282A.P': '8:1282A.P            PERIOD OF TIME FOR CONDITIONAL PERMITS',
	  '8:1282C.P': '8:1282C.P            CONDITIONAL PERMITS, PENALTIES',
	  '8:1286.P': '8:1286.P             DISCHARGING ALIEN CREWMEN',
	  '8:1287.P': '8:1287.P             ALIEN CREWMEN IN U.S. TO EVADE IMMIG...',
	  '8:1304.P': '8:1304.P             CERTIFICATE OF ALIEN REGISTRATION',
	  '8:1304D.P': '8:1304D.P            CERTIFICATE OF REGISTRATION FOR ALIENS',
	  '8:1304E.P': '8:1304E.P            PERSONAL POSSESSION OF REGISTRATION ...',
	  '8:1306A.P': '8:1306A.P            WILLFUL FAILURE TO REGISTER',
	  '8:1306B.P': '8:1306B.P            FAILURE TO NOTIFY OF CHANGE OF ADDRESS',
	  '8:1306C.P': '8:1306C.P            FRAUDULENT STATEMENTS',
	  '8:1306D.F': '8:1306D.F            COUNTERFEITING',
	  '8:1321.P': '8:1321.P             UNAUTHORIZED LANDING OF ALIENS, PREV...',
	  '8:1324.F': '8:1324.F             BRINGING IN AND HARBORING ALIENS',
	  '8:1324.M': '8:1324.M             BRINGING IN AND HARBORING ALIENS',
	  '8:1325.F': '8:1325.F             ILLEGAL ENTRY, CONCEALMENT OF FACTS',
	  '8:1325.P': '8:1325.P             CONCEALMENT OF FACTS ABOUT REENTRY',
	  '8:1326A.F': '8:1326A.F            REENTRY OF DEPORTED ALIENS',
	  '8:1326B.F': '8:1326B.F            REENTRY OF DEPORTED ALIEN - FELONY',
	  '8:1327.F': '8:1327.F             AIDING OR ASSISTING CERTAIN ALIENS T...',
	  '8:1328.F': '8:1328.F             IMPORTATION OF ALIEN FOR IMMORAL PUR...',
	  '8:1357.F': '8:1357.F             POWERS OF IMMIGRATION OF OFFICERS AN...',
	  '99:42.M': '99:42.M              Contempt',
	  A1: 'A1                   7',
	  REPEAL1: 'REPEAL1              2:242.F - FEDERAL STATUTES - POLITIC...',
	  REPEAL10: 'REPEAL10             2:247.F - FEDERAL STATUTES - STATEME...',
	  REPEAL100: 'REPEAL100            16:991.M NORTHWEST ATLANTIC FISHERIES',
	  REPEAL101: 'REPEAL101            16:1029.M NORTH PACIFIC FISHERIES',
	  REPEAL102: 'REPEAL102            16:1029A.M NORTH PACIFIC FISHERIES',
	  REPEAL103: 'REPEAL103            16:1029B.M NORTH PACIFIC FISHERIES',
	  REPEAL104: 'REPEAL104            16:1029C.M NORTH PACIFIC FISHERIES',
	  REPEAL105: 'REPEAL105            16:1029D.M NORTH PACIFIC FISHERIES',
	  REPEAL106: 'REPEAL106            16:1029E.M NORTH PACIFIC FISHERIES',
	  REPEAL107: 'REPEAL107            16:1029F.M NORTH PACIFIC FISHERIES',
	  REPEAL108: 'REPEAL108            16:1030A.M NORTH PACIFIC FISHERIES',
	  REPEAL109: 'REPEAL109            16:1030B.M NORTH PACIFIC FISHERIES',
	  REPEAL11: 'REPEAL11             2:247.M - FEDERAL STATUTES - STATEME...',
	  REPEAL110: 'REPEAL110            16:1030C.M NORTH PACIFIC FISHERIES',
	  REPEAL111: 'REPEAL111            16:1081.M FOREIGN FISHING VESSELS',
	  REPEAL112: 'REPEAL112            16:1082.M FOREIGN FISHING VESSELS',
	  REPEAL113: 'REPEAL113            16:1183.M REGULATIONS',
	  REPEAL114: 'REPEAL114            16:1184.M PROHIBITIONS: EVIDENCE',
	  REPEAL115: 'REPEAL115            18:44.P MARKING PACKAGE OR CONTAINERS',
	  REPEAL116: 'REPEAL116            18:45.P CAPTURING OR KILLING CARRIER...',
	  REPEAL117: 'REPEAL117            18:608.F LIMIT ON CONTRIBUTIONS AND ...',
	  REPEAL118: 'REPEAL118            18:608.M LIMIT ON CONTRIBUTIONS AND ...',
	  REPEAL119: 'REPEAL119            18:610.F CONTRIBUTIONS BY NATIONAL B...',
	  REPEAL12: 'REPEAL12             2:248.F - FEDERAL STATUTES - EXPENDI...',
	  REPEAL120: 'REPEAL120            18:610.M CONTRIBUTIONS BY NATIONAL B...',
	  REPEAL121: 'REPEAL121            18:611.F ELECTION LAW VIOLATORS',
	  REPEAL122: 'REPEAL122            18:611.M DEPRIVE EMPLOYMENT/OTHER BE...',
	  REPEAL123: 'REPEAL123            18:612.M PUBLISH OR DISTRIBUTE POLIT...',
	  REPEAL124: 'REPEAL124            18:613.F CONTRIBUTION BY AGENT OF FO...',
	  REPEAL125: 'REPEAL125            18:613.M CONTRIBUTION BY AGENT OF FO...',
	  REPEAL126: 'REPEAL126            18:614.M PROHIBIT CONTRIBUTIONS IN N...',
	  REPEAL127: 'REPEAL127            18:615.M LIMIT ON CONTRIBUTIONS OF C...',
	  REPEAL128: 'REPEAL128            18:616.M ACCEPTANCE OF EXCESSIVE HON...',
	  REPEAL129: 'REPEAL129            18:617.M FRAUD/MISREPRESENTATION OF ...',
	  REPEAL13: 'REPEAL13             2:248.M - FEDERAL STATUTES - EXPENDI...',
	  REPEAL130: 'REPEAL130            18:714.P JOHNNY HORIZON CHARACTER OR...',
	  REPEAL131: 'REPEAL131            18:832.F TRANSPORT OF EXPLOSIVES, RA...',
	  REPEAL132: 'REPEAL132            18:832.M TRANSPORT OF EXPLOSIVES, RA...',
	  REPEAL133: 'REPEAL133            18:833.F MARKING PACKAGES CONTAINING...',
	  REPEAL134: 'REPEAL134            18:833.M MARKING PACKAGES CONTAINING...',
	  REPEAL135: 'REPEAL135            18:834.F EXPLOSIVES  (T)',
	  REPEAL136: 'REPEAL136            18:834.M REGULATIONS BY ICC',
	  REPEAL137: 'REPEAL137            18:969.P EXPORT ARMS, LIQUORS AND NA...',
	  REPEAL138: 'REPEAL138            18:1008.F FEDERAL SAVINGS AND LOAN I...',
	  REPEAL139: 'REPEAL139            18:1009.M RUMORS REGARDING FED. SAVI...',
	  REPEAL14: 'REPEAL14             2:252.F - FEDERAL STATUTES - PENALTIES',
	  REPEAL141: 'REPEAL141            18:1383.M RESTRICTIONS IN MILITARY A...',
	  REPEAL142: 'REPEAL142            18:1714.M FOREIGN DIVORCE INFO AS NO...',
	  REPEAL143: 'REPEAL143            18:1718.M LIBELOUS MATTER ON WRAPPER...',
	  REPEAL144: 'REPEAL144            18:1844A.F MAIL FRAUD',
	  REPEAL145: 'REPEAL145            18:1862.P TRESPASS ON BULL RUN NATIO...',
	  REPEAL146: 'REPEAL146            18:1964.F NATIONAL PARK/RECREATION V...',
	  REPEAL147: 'REPEAL147            18:2198.M SEDUCTION OF FEMALE PASSENGER',
	  REPEAL148: 'REPEAL148            18:3150.F PENALTIES FOR FAILURE TO A...',
	  REPEAL149: 'REPEAL149            18:3150.M PENALTIES FOR FAILURE TO A...',
	  REPEAL15: 'REPEAL15             2:252.M - FEDERAL STATUTES - PENALTIES',
	  REPEAL150: 'REPEAL150            18A:1202A.F ARMED CAREER CRIMINAL  (T)',
	  REPEAL151: 'REPEAL151            18A:1202B.F RECEIVE/POSSESS/TRANSPOR...',
	  REPEAL152: 'REPEAL152            21 :171.F IMPORTATION AND EXPORT - 2...',
	  REPEAL153: 'REPEAL153            21 :172.F IMPORTATION AND EXPORT - 2...',
	  REPEAL154: 'REPEAL154            21 :173.F IMPORTATION AND EXPORT - 2...',
	  REPEAL155: 'REPEAL155            21 :174.F IMPORTATION AND EXPORT - 2...',
	  REPEAL156: 'REPEAL156            21 :175.F IMPORTATION AND EXPORT - 2...',
	  REPEAL157: 'REPEAL157            21 :176.F IMPORTATION AND EXPORT - 2...',
	  REPEAL158: 'REPEAL158            21 :176A.F IMPORTATION AND EXPORT - ...',
	  REPEAL159: 'REPEAL159            21:845 MOVED TO 21:859',
	  REPEAL16: 'REPEAL16             2:434D.M CONGRESSIONAL REPORTING EXE...',
	  REPEAL160: 'REPEAL160            21:845 MOVED TO 21:859',
	  REPEAL161: 'REPEAL161            21:845 MOVED TO 21:859',
	  REPEAL162: 'REPEAL162            21:845 MOVED TO 21:859',
	  REPEAL163: 'REPEAL163            21:845 MOVED TO 21:859',
	  REPEAL164: 'REPEAL164            21:845 MOVED TO 21:859',
	  REPEAL165: 'REPEAL165            21:845 MOVED TO 21:859',
	  REPEAL166: 'REPEAL166            21:845 MOVED TO 21:859',
	  REPEAL167: 'REPEAL167            21:845 MOVED TO 21:859',
	  REPEAL168: 'REPEAL168            21:845 MOVED TO 21:859',
	  REPEAL169: 'REPEAL169            21:845 MOVED TO 21:859',
	  REPEAL17: 'REPEAL17             2:434E.M REPORTS, OTHER THAN POLITIC...',
	  REPEAL170: 'REPEAL170            21:845 MOVED TO 21:859',
	  REPEAL171: 'REPEAL171            21:845 MOVED TO 21:859',
	  REPEAL172: 'REPEAL172            21:845 MOVED TO 21:859',
	  REPEAL173: 'REPEAL173            21:845 MOVED TO 21:859',
	  REPEAL174: 'REPEAL174            21:845 MOVED TO 21:859',
	  REPEAL175: 'REPEAL175            21:845 MOVED TO 21:859',
	  REPEAL176: 'REPEAL176            21:845 MOVED TO 21:859',
	  REPEAL177: 'REPEAL177            21:845 MOVED TO 21:859',
	  REPEAL178: 'REPEAL178            21:859=CO.F CONTROLLED SUBSTANCE - P...',
	  REPEAL179: 'REPEAL179            21:955=MP.F TRANSFERRED TO 46 APPEND...',
	  REPEAL18: 'REPEAL18             2:435A.M EL -  CHARGES FOR ADVERTISING',
	  REPEAL180: 'REPEAL180            21:955=NP.F TRANSFERRED TO 46 APPEND...',
	  REPEAL181: 'REPEAL181            21:955A=CD.F TRANSFERRED TO 46 APPEN...',
	  REPEAL182: 'REPEAL182            21:955A=CI.F TRANSFERRED TO 46 APPEN...',
	  REPEAL183: 'REPEAL183            21:955A=CM.F TRANSFERRED TO 46 APPEN...',
	  REPEAL184: 'REPEAL184            21:955A=MD.F TRANSFERRED TO 46 APPEN...',
	  REPEAL185: 'REPEAL185            21:955A=MI.F TRANSFERRED TO 46 APPEN...',
	  REPEAL186: 'REPEAL186            21:955A=MM.F TRANSFERRED TO 46 APPEN...',
	  REPEAL187: 'REPEAL187            21:955A=ND.F TRANSFERRED TO 46 APPEN...',
	  REPEAL188: 'REPEAL188            21:955A=NI.F TRANSFERRED TO 46 APPEN...',
	  REPEAL189: 'REPEAL189            21:955A=NM.F TRANSFERRED TO 46 APPEN...',
	  REPEAL19: 'REPEAL19             2:435B.M EL -  FUND SOLICITATION',
	  REPEAL190: 'REPEAL190            21:955C=CD.F TRANSFERRED TO 46 APPEN...',
	  REPEAL191: 'REPEAL191            21:955C=CI.F TRANSFERRED TO 46 APPEN...',
	  REPEAL192: 'REPEAL192            21:955C=CM.F TRANSFERRED TO 46 APPEN...',
	  REPEAL193: 'REPEAL193            21:955C=MD.F TRANSFERRED TO 46 APPEN...',
	  REPEAL194: 'REPEAL194            21:955C=MI.F TRANSFERRED TO 46 APPEN...',
	  REPEAL195: 'REPEAL195            21:955C=MM.F TRANSFERRED TO 46 APPEN...',
	  REPEAL196: 'REPEAL196            21:955C=ND.F TRANSFERRED TO 46 APPEN...',
	  REPEAL197: 'REPEAL197            21:955C=NI.F TRANSFERRED TO 46 APPEN...',
	  REPEAL198: 'REPEAL198            21:955C=NM.F TRANSFERRED TO 46 APPEN...',
	  REPEAL199: 'REPEAL199            22:286.P DEFACING CEMETERIES',
	  REPEAL2: 'REPEAL2              2:243.F - FEDERAL STATUTES - CONTRIB...',
	  REPEAL20: 'REPEAL20             2:436A.M EL -  PRESERVING COPIES',
	  REPEAL200: 'REPEAL200            22:1934.F REGISTRATION OF EXPORT AND...',
	  REPEAL201: 'REPEAL201            22:1934B.F REGISTRATION OF EXPORT AN...',
	  REPEAL202: 'REPEAL202            22:1934C.F REGISTRATION OF EXPORT AN...',
	  REPEAL203: 'REPEAL203            22:2778.F REGISTRATION AND LICENSING',
	  REPEAL204: 'REPEAL204            22D:103-4993.M ATTEMPTS TO COMMIT CRIME',
	  REPEAL205: 'REPEAL205            22D:701.F OBSTRUCTING JUSTICE - BRIB...',
	  REPEAL206: 'REPEAL206            22D:703.F OBSTRUCTING JUSTICE - BRIB...',
	  REPEAL207: 'REPEAL207            22D:704.F OBSTRUCTING JUSTICE - BRIB...',
	  REPEAL208: 'REPEAL208            22D:713A.F BRIBERY OF WITNESS',
	  REPEAL209: 'REPEAL209            22D:901.F MISC. GENERAL OFFENSES, OTHER',
	  REPEAL21: 'REPEAL21             2:436B.M EL -  WAIVER OF REPORTING',
	  REPEAL210: 'REPEAL210            22D:1202.F EMBEZZLEMENT',
	  REPEAL211: 'REPEAL211            22D:1202.M EMBEZZLEMENT',
	  REPEAL212: 'REPEAL212            22D:1211.P TAKING PROPERTY W/O RIGHT',
	  REPEAL213: 'REPEAL213            22D:1301.F FRAUD',
	  REPEAL214: 'REPEAL214            22D:1301.M FRAUD',
	  REPEAL215: 'REPEAL215            22D:1301.P FRAUD',
	  REPEAL216: 'REPEAL216            22D:1401.F FORGERY, OTHER',
	  REPEAL217: 'REPEAL217            22D:2201.F GRAND LARCENY',
	  REPEAL218: 'REPEAL218            22D:2202.M PETIT LARCENY',
	  REPEAL219: 'REPEAL219            22D:2203.F EMBEZZLEMENT',
	  REPEAL22: 'REPEAL22             2:436C.M EL -  DEBTS, PLEDGES, ETC.',
	  REPEAL220: 'REPEAL220            22D:2203.M EMBEZZLEMENT',
	  REPEAL221: 'REPEAL221            22D:2204.F AUTO THEFT',
	  REPEAL222: 'REPEAL222            22D:2205.F AUTO THEFT',
	  REPEAL223: 'REPEAL223            22D:2205.M AUTO THEFT',
	  REPEAL224: 'REPEAL224            22D:2206.F STEALING D.C. PROPERTY',
	  REPEAL225: 'REPEAL225            22D:2207.F STEALING D.C. PROPERTY',
	  REPEAL226: 'REPEAL226            22D:2208.F STEALING D.C. PROPERTY',
	  REPEAL227: 'REPEAL227            22D:2305.F EXTORTION',
	  REPEAL228: 'REPEAL228            22D:2306.F EXTORTION',
	  REPEAL229: 'REPEAL229            22D:2501.F PERJURY',
	  REPEAL23: 'REPEAL23             2:436D.M EL -  MAILING DATES',
	  REPEAL230: 'REPEAL230            22D:2602.M MISPRISION BY OFFICERS/EM...',
	  REPEAL231: 'REPEAL231            26:4591.F IMPOSITION OF TAX',
	  REPEAL232: 'REPEAL232            26:4591.M IMPOSITION OF TAX',
	  REPEAL233: 'REPEAL233            26:4594.F PACKAGES FOR OLEOMARGARINE',
	  REPEAL234: 'REPEAL234            26:4594A.F PACKAGES FOR OLEOMARGARINE',
	  REPEAL235: 'REPEAL235            26:4594B.F PACKAGES FOR OLEOMARGARINE',
	  REPEAL236: 'REPEAL236            26:4594C.F PACKAGES FOR OLEOMARGARINE',
	  REPEAL237: 'REPEAL237            26:4597.P WHOLESALE DEALERS IN OLEOM...',
	  REPEAL238: 'REPEAL238            26:4704.F NARCOTICS',
	  REPEAL239: 'REPEAL239            26:4804.F REQUIREMENTS OF MANUFACTURERS',
	  REPEAL24: 'REPEAL24             2:437A.M EL -  CONVENTION FINANCING',
	  REPEAL240: 'REPEAL240            26:4804.P REQUIREMENTS OF MANUFACTURERS',
	  REPEAL241: 'REPEAL241            26:4804A.F REQUIREMENTS OF MANUFACTU...',
	  REPEAL242: 'REPEAL242            26:4804A.P REQUIREMENTS OF MANUFACTU...',
	  REPEAL243: 'REPEAL243            26:4804B.P REQUIREMENTS OF MANUFACTU...',
	  REPEAL244: 'REPEAL244            26:4805.M REQUIREMENTS OF MANUFACTURERS',
	  REPEAL245: 'REPEAL245            26:4814.P SELL ADULTERATED BUTTER',
	  REPEAL246: 'REPEAL246            26:4815A.F SELLING REQUIREMENTS',
	  REPEAL247: 'REPEAL247            26:4815B.P DEALERS IN ADULTERATED BU...',
	  REPEAL248: 'REPEAL248            26:4817.M INSPECTION OF BUTTER',
	  REPEAL249: 'REPEAL249            26:4833.M MANUFACTURES LABEL-FILLED ...',
	  REPEAL25: 'REPEAL25             2:437B.M EL -  CAMPAIGN DEPOSITORIES',
	  REPEAL250: 'REPEAL250            26:4833A.M MANUFACTURES LABEL-FILLED...',
	  REPEAL251: 'REPEAL251            26:4833B.M MANUFACTURES LABEL-FILLED...',
	  REPEAL252: 'REPEAL252            26:4833C.M MANUFACTURES LABEL-FILLED...',
	  REPEAL253: 'REPEAL253            26:4834.P SIGNS FOR DEALERS IN FILLE...',
	  REPEAL254: 'REPEAL254            26:4841.P IMPOSITION OF TAX',
	  REPEAL255: 'REPEAL255            26:4862.P DETERMINATION OF SPOT MARKETS',
	  REPEAL256: 'REPEAL256            26:4918.M SALES MADE BY FIRMS',
	  REPEAL257: 'REPEAL257            26:4918E.M SALES MADE BY FIRMS',
	  REPEAL258: 'REPEAL258            26:4918H.M SALES MADE BY FIRMS',
	  REPEAL259: 'REPEAL259            26:4919.M SALES MADE BY FIRMS',
	  REPEAL26: 'REPEAL26             2:437G.M ELECT. LAWS -',
	  REPEAL260: 'REPEAL260            26:5205.F DISTILLED SPIRITS',
	  REPEAL261: 'REPEAL261            26:5676.F DEVICES AND TRAFFICKING',
	  REPEAL262: 'REPEAL262            26:5676.M DEVICES AND TRAFFICKING',
	  REPEAL263: 'REPEAL263            26:5676.P DEVICES AND TRAFFICKING',
	  REPEAL264: 'REPEAL264            26:5689.F DEVICES AND TRAFFICKING',
	  REPEAL265: 'REPEAL265            26:6056.M  REPORT OF PRIVATE FOUNDAT...',
	  REPEAL266: 'REPEAL266            26:6420F.M EXAMINATION OF BOOKS',
	  REPEAL267: 'REPEAL267            26:6424.M EXAMINATION OF BOOKS',
	  REPEAL268: 'REPEAL268            26:7203.M WILLFUL FAILURE TO FILE RE...',
	  REPEAL269: 'REPEAL269            26:7206.F DECLARE UNDER PENALTY',
	  REPEAL27: 'REPEAL27             2:439B.M  FRANKED SOLICITATIONS',
	  REPEAL270: 'REPEAL270            26:7208.F OFFENSES RELATING TO STAMPS',
	  REPEAL271: 'REPEAL271            26:7233.F FAILURE TO PAY, ATTEMPT TO...',
	  REPEAL272: 'REPEAL272            26:7233.M FAILURE TO PAY, ATTEMPT TO...',
	  REPEAL273: 'REPEAL273            26:7233.P FAILURE TO PAY, ATTEMPT TO...',
	  REPEAL274: 'REPEAL274            26:7234.F FALSE BRANDING, SELLING, O...',
	  REPEAL275: 'REPEAL275            26:7234.M FALSE BRANDING, SELLING, O...',
	  REPEAL276: 'REPEAL276            26:7234.P FALSE BRANDING, SELLING, O...',
	  REPEAL277: 'REPEAL277            26:7234A.F FALSE BRANDING, SELLING, ...',
	  REPEAL278: 'REPEAL278            26:7234B.M FALSE BRANDING, SELLING, ...',
	  REPEAL279: 'REPEAL279            26:7234C.P FALSE BRANDING, SELLING, ...',
	  REPEAL28: 'REPEAL28             2:441A.M PENALTIES FOR VIOLATIONS',
	  REPEAL280: 'REPEAL280            26:7234D.F FALSE BRANDING, SELLING, ...',
	  REPEAL281: 'REPEAL281            26:7234D.M FALSE BRANDING, SELLING, ...',
	  REPEAL282: 'REPEAL282            26:7234D.P FALSE BRANDING, SELLING, ...',
	  REPEAL283: 'REPEAL283            26:7235.F FRAUD BY MANUFACTURER',
	  REPEAL284: 'REPEAL284            26:7235.M FRAUD BY MANUFACTURER',
	  REPEAL285: 'REPEAL285            26:7235.P FRAUD BY MANUFACTURER',
	  REPEAL286: 'REPEAL286            26:7235A.F FRAUD BY MANUFACTURER',
	  REPEAL287: 'REPEAL287            26:7235B.P FRAUD BY MANUFACTURER',
	  REPEAL288: 'REPEAL288            26:7235C.M FRAUD BY MANUFACTURER',
	  REPEAL289: 'REPEAL289            26:7235D.P FRAUD BY MANUFACTURER',
	  REPEAL29: 'REPEAL29             2:441B.M SOLICITING EMPLOYEE FOR POL...',
	  REPEAL290: 'REPEAL290            26:7235E.F FRAUD BY MANUFACTURER',
	  REPEAL291: 'REPEAL291            26:7236.M FALSE BRANDING, SALE',
	  REPEAL292: 'REPEAL292            26:7239.F SELLING UN-STAMPED MATCHES',
	  REPEAL293: 'REPEAL293            26:7239A.F SELLING UN-STAMPED MATCHES',
	  REPEAL294: 'REPEAL294            26:7239B.F SELLING UN-STAMPED MATCHES',
	  REPEAL295: 'REPEAL295            26:7240.F OFFICIALS INVESTING/SPECUL...',
	  REPEAL296: 'REPEAL296            26:7241.M PENALTY FOR FRAUD',
	  REPEAL297: 'REPEAL297            26:7263.P PENALTIES: COTTON FUTURES',
	  REPEAL298: 'REPEAL298            26:7264.M ADULTERATED BUTTER',
	  REPEAL299: 'REPEAL299            26:7265.P ADULTERATED BUTTER',
	  REPEAL3: 'REPEAL3              2:243.M - FEDERAL STATUTES - CONTRIB...',
	  REPEAL30: 'REPEAL30             7:1153.P SUGAR EXCISE TAX',
	  REPEAL300: 'REPEAL300            26:7265A.P ADULTERATED BUTTER',
	  REPEAL301: 'REPEAL301            26:7265B.P ADULTERATED BUTTER',
	  REPEAL302: 'REPEAL302            26:7266.M FAILURE TO PAY SPECIAL TAX',
	  REPEAL303: 'REPEAL303            26:7266.P FAILURE TO PAY SPECIAL TAX',
	  REPEAL304: 'REPEAL304            26:7266A.M FAILURE TO PAY SPECIAL TAX',
	  REPEAL305: 'REPEAL305            26:7266A.P FAILURE TO PAY SPECIAL TAX',
	  REPEAL306: 'REPEAL306            26:7266B.M FAILURE TO PAY SPECIAL TAX',
	  REPEAL307: 'REPEAL307            26:7266C.P FAILURE TO PAY SPECIAL TAX',
	  REPEAL308: 'REPEAL308            26:7266D.P FAILURE TO PAY SPECIAL TAX',
	  REPEAL309: 'REPEAL309            26:7267.M WHITE PHOSPHOROUS MATCHES/...',
	  REPEAL31: 'REPEAL31             7:1156.M DUTY TO FURNISH INFORMATION',
	  REPEAL310: 'REPEAL310            26:7267.P WHITE PHOSPHOROUS MATCHES/...',
	  REPEAL311: 'REPEAL311            26:7267A.M WHITE PHOSPHOROUS MATCHES...',
	  REPEAL312: 'REPEAL312            26:7267B.M WHITE PHOSPHOROUS MATCHES...',
	  REPEAL313: 'REPEAL313            26:7267C.P WHITE PHOSPHOROUS MATCHES...',
	  REPEAL314: 'REPEAL314            26:7267D.P WHITE PHOSPHOROUS MATCHES...',
	  REPEAL315: 'REPEAL315            33:1002.M DISCHARGE OF OIL PROHIBITED',
	  REPEAL316: 'REPEAL316            33:1005.M DISCHARGE OF OIL PROHIBITED',
	  REPEAL317: 'REPEAL317            33:1005A.M DISCHARGE OF OIL PROHIBITED',
	  REPEAL318: 'REPEAL318            33:1008.M DISCHARGE OF OIL PROHIBITED',
	  REPEAL319: 'REPEAL319            33:1008C.M DISCHARGE OF OIL PROHIBITED',
	  REPEAL32: 'REPEAL32             7:135A.M INSECTICIDE ACT - UNREGISTE...',
	  REPEAL320: 'REPEAL320            33:1008D.M DISCHARGE OF OIL PROHIBITED',
	  REPEAL321: 'REPEAL321            33:1008E.M DISCHARGE OF OIL PROHIBITED',
	  REPEAL322: 'REPEAL322            33:1008F.M DISCHARGE OF OIL PROHIBITED',
	  REPEAL323: 'REPEAL323            33D:702.F NARCOTICS, OTHER',
	  REPEAL324: 'REPEAL324            33D:702.M NARCOTICS, OTHER',
	  REPEAL325: 'REPEAL325            42:2703.F EMBEZZLES PUBLIC MONEYS',
	  REPEAL326: 'REPEAL326            42:2703.M EMBEZZLES PUBLIC MONEYS',
	  REPEAL327: 'REPEAL327            42:2703A.F EMBEZZLES PUBLIC MONEYS',
	  REPEAL328: 'REPEAL328            42:2703A.M EMBEZZLES PUBLIC MONEYS',
	  REPEAL329: 'REPEAL329            42:2703B.M EMBEZZLES PUBLIC MONEYS',
	  REPEAL33: 'REPEAL33             7:135A.P UNREGISTERED POISONS 2ND OF...',
	  REPEAL330: 'REPEAL330            43:1096.M FRAUDULENT SETTLEMENT',
	  REPEAL331: 'REPEAL331            43:1191.F FRAUDULENT SETTLEMENT',
	  REPEAL332: 'REPEAL332            43:1192.F FRAUDULENT SETTLEMENT',
	  REPEAL333: 'REPEAL333            43:1193.F FRAUDULENT SETTLEMENT',
	  REPEAL334: 'REPEAL334            45:228.M FALSE OR FRAUDULENT STATEMENTS',
	  REPEAL335: 'REPEAL335            46:1277.F OFFENSES AND PENALTIES',
	  REPEAL336: 'REPEAL336            46:17010.F TENDERING EXPLOSIVES',
	  REPEAL337: 'REPEAL337            46:17011.F TENDERING EXPLOSIVES',
	  REPEAL338: 'REPEAL338            46:17013.F TENDERING EXPLOSIVES',
	  REPEAL339: 'REPEAL339            46:17014.F TENDERING EXPLOSIVES',
	  REPEAL34: 'REPEAL34             7:135B.M REGISTRATION OF ECONOMIC PO...',
	  REPEAL340: 'REPEAL340            46:17015.F TENDERING EXPLOSIVES',
	  REPEAL341: 'REPEAL341            46:1703.F TRANSPORT OF CERTAIN EXPLO...',
	  REPEAL342: 'REPEAL342            46:1704.F TRANSPORT OF CERTAIN EXPLO...',
	  REPEAL343: 'REPEAL343            46:1705.F TRANSPORT OF CERTAIN EXPLO...',
	  REPEAL344: 'REPEAL344            46:1706.F TRANSPORT OF CERTAIN EXPLO...',
	  REPEAL345: 'REPEAL345            46:1707.F TRANSPORT OF CERTAIN EXPLO...',
	  REPEAL346: 'REPEAL346            46:1708.F TRANSPORT OF CERTAIN EXPLO...',
	  REPEAL347: 'REPEAL347            46:1709.F TRANSPORT OF CERTAIN EXPLO...',
	  REPEAL348: 'REPEAL348            46:2302.M OPERATING IN NEGLIGENT MANNER',
	  REPEAL349: 'REPEAL349            46:526.M RECKLESS/NEGLIGENT OPERATIO...',
	  REPEAL35: 'REPEAL35             7:135B.P REGISTRATION OF ECONOMIC PO...',
	  REPEAL350: 'REPEAL350            46:7014.P WILLFUL DISOBEDIENCE',
	  REPEAL351: 'REPEAL351            46:7015.P WILLFUL DISOBEDIENCE',
	  REPEAL352: 'REPEAL352            46:7016.P WILLFUL DISOBEDIENCE',
	  REPEAL353: 'REPEAL353            46:7017.M WILLFUL DISOBEDIENCE',
	  REPEAL354: 'REPEAL354            46:7018.M WILLFUL DISOBEDIENCE',
	  REPEAL355: 'REPEAL355            46:8151.P UNDUE OR UNREASONABLE PREF...',
	  REPEAL356: 'REPEAL356            46:8153.P UNDUE OR UNREASONABLE PREF...',
	  REPEAL357: 'REPEAL357            49A:1472E.M FAILURE TO FILE REPORTS',
	  REPEAL358: 'REPEAL358            49A:1472F.M FAILURE TO FILE REPORTS',
	  REPEAL359: 'REPEAL359            49A:1472H.M FAILURE TO FILE REPORTS',
	  REPEAL36: 'REPEAL36             7:135C.M BOOKS AND RECORDS, ACCESS A...',
	  REPEAL360: 'REPEAL360            49A:1472I.M FAILURE TO FILE REPORTS',
	  REPEAL361: 'REPEAL361            49A:1472J.M FAILURE TO FILE REPORTS',
	  REPEAL362: 'REPEAL362            49A:1472L.M FAILURE TO FILE REPORTS',
	  REPEAL363: 'REPEAL363            49A:1472M.F FAILURE TO FILE REPORTS',
	  REPEAL364: 'REPEAL364            49A:1472N.F FAILURE TO FILE REPORTS',
	  REPEAL365: 'REPEAL365            49A:1472N.P FAILURE TO FILE REPORTS',
	  REPEAL366: 'REPEAL366            49A:1472O.F FAILURE TO FILE REPORTS',
	  REPEAL367: 'REPEAL367            49A:1472P.F FAILURE TO FILE REPORTS',
	  REPEAL368: 'REPEAL368            49A:1472P.P FAILURE TO FILE REPORTS',
	  REPEAL369: 'REPEAL369            49A:1472R.P FAILURE TO FILE REPORTS',
	  REPEAL37: 'REPEAL37             7:135C.P BOOKS AND RECORDS, ACCESS A...',
	  REPEAL370: 'REPEAL370            38:3301.P IMPROPER USE OF NAMES AND ...',
	  REPEAL371: 'REPEAL371            38:33019.M IMPROPER USE OF NAMES AND...',
	  REPEAL372: 'REPEAL372            38:33019.P IMPROPER USE OF NAMES AND...',
	  REPEAL38: 'REPEAL38             7:135D.M RULES AND REGULATIONS, EXAM...',
	  REPEAL39: 'REPEAL39             7:135D.P RULES AND REGULATIONS, EXAM...',
	  REPEAL4: 'REPEAL4              2:244.F - FEDERAL STATUTES - TREASUR...',
	  REPEAL40: 'REPEAL40             7:135F.F INSECTICIDES',
	  REPEAL41: 'REPEAL41             7:135F.M INSECTICIDES',
	  REPEAL42: 'REPEAL42             7:135F.P INSECTICIDES',
	  REPEAL43: 'REPEAL43             7:135G.M INSECTICIDES',
	  REPEAL44: 'REPEAL44             7:135G.P INSECTICIDES',
	  REPEAL45: 'REPEAL45             7:2023C.F PRESENT, REDEEM COUPONS',
	  REPEAL46: 'REPEAL46             7:2023C.M PRESENT, REDEEM COUPONS',
	  REPEAL47: 'REPEAL47             7:2043.F FARM WORKER CERTIFICATES',
	  REPEAL48: 'REPEAL48             7:2043.M FARM WORKER CERTIFICATES',
	  REPEAL49: 'REPEAL49             7:2044.F CERTIFICATE OF REGISTRATION...',
	  REPEAL5: 'REPEAL5              2:244.M - FEDERAL] STATUTES - TREASU...',
	  REPEAL50: 'REPEAL50             7:2044.M CERTIFICATE OF REGISTRATION...',
	  REPEAL51: 'REPEAL51             7:2045.F OBLIGATIONS AND PROHIBITION...',
	  REPEAL52: 'REPEAL52             7:2045.M OBLIGATIONS AND PROHIBITION...',
	  REPEAL53: 'REPEAL53             7:2046.F AUTHORITY TO OBTAIN INFORMA...',
	  REPEAL54: 'REPEAL54             7:2046.M AUTHORITY TO OBTAIN INFORMA...',
	  REPEAL55: 'REPEAL55             7:2048A.F FARM LABOR CONTRACTOR REGI...',
	  REPEAL56: 'REPEAL56             7:2048A.M FARM LABOR CONTRACTOR REGI...',
	  REPEAL57: 'REPEAL57             7:2048C.F FARM LABOR CONTRACTOR REGI...',
	  REPEAL58: 'REPEAL58             7:2050C.F RECORDKEEPING - 2ND OFFENSE',
	  REPEAL59: 'REPEAL59             7:2053.F RULES AND REGULATIONS - 2ND...',
	  REPEAL6: 'REPEAL6              2:245.F - FEDERAL STATUTES - STATEME...',
	  REPEAL60: 'REPEAL60             7:2053.M RULES AND REGULATIONS',
	  REPEAL61: 'REPEAL61             7:2054.F WAIVER OF RIGHTS - 2ND OFF',
	  REPEAL62: 'REPEAL62             7:2054.M WAIVER OF RIGHTS',
	  REPEAL63: 'REPEAL63             7:218.P STOCKYARDS, LIVE POULTRY DEA...',
	  REPEAL64: 'REPEAL64             7:516.M EXPORTATION OF SEEDS OR PLAN...',
	  REPEAL65: 'REPEAL65             7:517.M EXPORT TOBACCO SEEDS OR PLAN...',
	  REPEAL66: 'REPEAL66             8:331.M PROHIBITED COOLIE TRADE',
	  REPEAL67: 'REPEAL67             8:333.M BUILDING BOATS FOR COOLIE TRADE',
	  REPEAL68: 'REPEAL68             8:334.M PENALTIES - COOLIE TRADE',
	  REPEAL69: 'REPEAL69             8:338.M TRANSPORTING ORIENTALS FOR S...',
	  REPEAL7: 'REPEAL7              2:245.M - FEDERAL STATUTES - STATEME...',
	  REPEAL70: 'REPEAL70             8:339.M CONTRACTING TO SUPPLY COOLIE...',
	  REPEAL71: 'REPEAL71             12:1713.P RENTAL HOUSING INSURANCE',
	  REPEAL72: 'REPEAL72             12:1846.M- HOLDING COMPANIES',
	  REPEAL73: 'REPEAL73             16:85.P   TRANSPORTING ILLEGAL GAME',
	  REPEAL74: 'REPEAL74             16.471.M LIMITATION IN CERTAIN STATES',
	  REPEAL75: 'REPEAL75             16:476.M SALE OF TIMBER',
	  REPEAL76: 'REPEAL76             16:709.F TAKING/KILLING TO BARTER OR...',
	  REPEAL77: 'REPEAL77             16:709.F TAKING/KILLING TO BARTER OR...',
	  REPEAL78: 'REPEAL78             16:772B/E HALIBUT ACT 1937',
	  REPEAL79: 'REPEAL79             16:772B/E HALIBUT ACT 1937',
	  REPEAL8: 'REPEAL8              2:246.F - FEDERAL STATUTES - STATEME...',
	  REPEAL80: 'REPEAL80             16:772B/E HALIBUT ACT 1937',
	  REPEAL81: 'REPEAL81             16:772B/E HALIBUT ACT 1937',
	  REPEAL82: 'REPEAL82             16:776A/F SALMON FISHING',
	  REPEAL83: 'REPEAL83             16:776A/F SALMON FISHING',
	  REPEAL84: 'REPEAL84             16:776A/F SALMON FISHING',
	  REPEAL85: 'REPEAL85             16:852.P  TRANSPORTING ILLEGAL GAME',
	  REPEAL86: 'REPEAL86             16:852A.P  TRANSPORTING ILLEGAL GAME',
	  REPEAL87: 'REPEAL87             16:852C.P  TRANSPORTING ILLEGAL GAME',
	  REPEAL88: 'REPEAL88             16:981.M NORTHWEST ATLANTIC FISHERIES',
	  REPEAL89: 'REPEAL89             16:982.M NORTHWEST ATLANTIC FISHERIES',
	  REPEAL9: 'REPEAL9              2:246.M - FEDERAL STATUTES - STATEME...',
	  REPEAL90: 'REPEAL90             16:983.M NORTHWEST ATLANTIC FISHERIES',
	  REPEAL91: 'REPEAL91             16:984.M NORTHWEST ATLANTIC FISHERIES',
	  REPEAL92: 'REPEAL92             16:985.M NORTHWEST ATLANTIC FISHERIES',
	  REPEAL93: 'REPEAL93             16:986.M NORTHWEST ATLANTIC FISHERIES',
	  REPEAL94: 'REPEAL94             16:987.M NORTHWEST ATLANTIC FISHERIES',
	  REPEAL95: 'REPEAL95             16:988.M NORTHWEST ATLANTIC FISHERIES',
	  REPEAL96: 'REPEAL96             16:988.P NORTHWEST ATLANTIC FISHERIES',
	  REPEAL97: 'REPEAL97             16:989.M NORTHWEST ATLANTIC FISHERIES',
	  REPEAL98: 'REPEAL98             16:989.P NORTHWEST ATLANTIC FISHERIES',
	  REPEAL99: 'REPEAL99             16:990.M NORTHWEST ATLANTIC FISHERIES',
	  SD1: 'SD1                  5:552.M NO DEFINITION',
	  SD10: 'SD10                 7:1986B.F STABILIZE PROVISIONS',
	  SD100: 'SD100                18:1406.F NARCOTICS, OTHER',
	  SD101: 'SD101                18:1406.M NARCOTICS, OTHER',
	  SD102: 'SD102                18:1407.F NARCOTICS, BORDER REGISTRA...',
	  SD103: 'SD103                18:1407.M NARCOTICS, BORDER REGISTRA...',
	  SD104: 'SD104                18:1956-7420.F RACKETEERING, BRIBERY',
	  SD105: 'SD105                18:1956-7430.F RACKETEERING, EXTORTION',
	  SD106: 'SD106                18:1956-7440.F RACKETEERING, GAMBLING',
	  SD107: 'SD107                18:1956-7450.F RACKETEERING, LIQUOR',
	  SD108: 'SD108                18:1956-7460.F RACKETEERING, NARCOTICS',
	  SD109: 'SD109                18:1956-7470.F RACKETEERING, PROSTIT...',
	  SD11: 'SD11                 7:1986C.F CONFLICTS OF INTEREST',
	  SD110: 'SD110                18:2113D.M BANK LARCENY - RECEIVED S...',
	  SD111: 'SD111                18:2113E.M BANK ROBBERY',
	  SD112: 'SD112                18:2241.F COMMIT RAPE W/IN SPECIAL M...',
	  SD113: 'SD113                18:2242.F FORCED SEX THREATS/FEAR OF...',
	  SD114: 'SD114                18:2244B.P SEXUAL CONTACT W/O PERMIS...',
	  SD115: 'SD115                18:3056.M OBSTRUCTION AND INTERFEREN...',
	  SD116: 'SD116                18:3146.M FAILURE TO APPEAR',
	  SD117: 'SD117                21:853.P OTHER DAPCA OFFENSES',
	  SD118: 'SD118                21:854=CI.F INVEST ILLICIT DRUG PROFITS',
	  SD12: 'SD12                 7:2024E.M - FOOD STAMP FRAUD - UNAUT...',
	  SD122: 'SD122                21:858=CM.F CONTROLLED SUBSTANCE - M...',
	  SD123: 'SD123                21:959=MI.M MARIJUANA - IMPORT/EXPORT',
	  SD124: 'SD124                21:9612=CI.M PRINCIPALS',
	  SD125: 'SD125                26:5752A.F RESTRICTIONS TO MARKS, LA...',
	  SD126: 'SD126                26:5752B.F RESTRICTIONS TO MARKS, LA...',
	  SD127: 'SD127                26:5752C.F RESTRICTIONS TO MARKS, LA...',
	  SD128: 'SD128                26:5752D.F RESTRICTIONS TO MARKS, LA...',
	  SD129: 'SD129                26:6047.M  INSURANCE COMPANIES - REQ...',
	  SD13: 'SD13                 7:211.M - AGRICULTURE ACTS - PRACTICES',
	  SD130: 'SD130                26:7272.P FAILURE TO REGISTER',
	  SD131: 'SD131                27:208.P INTERLOCKING DIRECTORATES',
	  SD132: 'SD132                28:1866.P SELECTION AND SUMMONING OF...',
	  SD133: 'SD133                29:1111.F HOLDING CERTAIN POSITIONS',
	  SD134: 'SD134                29:1112.M UNLAWFUL TO CONTROL FUNDS',
	  SD135: 'SD135                29:461D.M FALSE STATEMENTS',
	  SD136: 'SD136                29:503.M LOANS TO OFFICERS AND EMPLO...',
	  SD137: 'SD137                29:522.F EXTORTIONATE PICKETING',
	  SD138: 'SD138                30:727.P WITHDRAWAL FROM DANGER AREA',
	  SD139: 'SD139                30:733.P PENALTY: CIVIL AND CRIMINAL',
	  SD14: 'SD14                 7:212.M - AGRICULTURE ACTS - DISCRIM...',
	  SD140: 'SD140                30:820E.M DISTRIBUTION OR SALE',
	  SD141: 'SD141                30:1267.M INSPECTIONS AND MONITORING...',
	  SD142: 'SD142                31:1101.M PERSONS REQUIRED TO FILE',
	  SD143: 'SD143                31:699.M CITIZENSHIP REQUIREMENTS, F...',
	  SD144: 'SD144                33:941.P SAFE PLACE OF EMPLOYMENT',
	  SD145: 'SD145                33:1321P.M FINANCIAL RESPONSIBILITY ...',
	  SD146: 'SD146                33D:401.M REMOVED AT REQUEST OF DC C...',
	  SD147: 'SD147                33D:402.F REMOVED AT REQUEST OF DC C...',
	  SD148: 'SD148                33D:402.M REMOVED AT REQUEST OF DC C...',
	  SD149: 'SD149                33D:403.F REMOVED AT REQUEST OF DC C...',
	  SD15: 'SD15                 7:213.M - AGRICULTURE ACTS - UNFAIR ...',
	  SD150: 'SD150                33D:403.M REMOVED AT REQUEST OF DC C...',
	  SD151: 'SD151                33D:404.F REMOVED AT REQUEST OF DC C...',
	  SD152: 'SD152                33D:404.M REMOVED AT REQUEST OF DC C...',
	  SD153: 'SD153                33D:405.F REMOVED AT REQUEST OF DC C...',
	  SD154: 'SD154                33D:405.M REMOVED AT REQUEST OF DC C...',
	  SD155: 'SD155                33D:406.F REMOVED AT REQUEST OF DC C...',
	  SD156: 'SD156                33D:406.M REMOVED AT REQUEST OF DC C...',
	  SD157: 'SD157                33D:407.F REMOVED AT REQUEST OF DC C...',
	  SD158: 'SD158                33D:407.M REMOVED AT REQUEST OF DC C...',
	  SD159: 'SD159                33D:408.F REMOVED AT REQUEST OF DC C...',
	  SD16: 'SD16                 7:2149D.M AGRICULTURE ACTS - ANIMAL ...',
	  SD160: 'SD160                33D:408.M REMOVED AT REQUEST OF DC C...',
	  SD161: 'SD161                33D:409.F REMOVED AT REQUEST OF DC C...',
	  SD162: 'SD162                33D:409.M REMOVED AT REQUEST OF DC C...',
	  SD163: 'SD163                33D:410.F REMOVED AT REQUEST OF DC C...',
	  SD164: 'SD164                33D:410.M REMOVED AT REQUEST OF DC C...',
	  SD165: 'SD165                33D:411.F REMOVED AT REQUEST OF DC C...',
	  SD166: 'SD166                33D:411.M REMOVED AT REQUEST OF DC C...',
	  SD167: 'SD167                33D:412.F REMOVED AT REQUEST OF DC C...',
	  SD168: 'SD168                33D:412.M REMOVED AT REQUEST OF DC C...',
	  SD169: 'SD169                33D:413.F REMOVED AT REQUEST OF DC C...',
	  SD17: 'SD17                 7:3404.M PENALTIES - REPORTS',
	  SD170: 'SD170                33D:413.M REMOVED AT REQUEST OF DC C...',
	  SD171: 'SD171                33D:414.M REMOVED AT REQUEST OF DC C...',
	  SD172: 'SD172                33D:415.F REMOVED AT REQUEST OF DC C...',
	  SD173: 'SD173                33D:415.M REMOVED AT REQUEST OF DC C...',
	  SD174: 'SD174                33D:416.F REMOVED AT REQUEST OF DC C...',
	  SD175: 'SD175                33D:416.M REMOVED AT REQUEST OF DC C...',
	  SD176: 'SD176                33D:417.F REMOVED AT REQUEST OF DC C...',
	  SD178: 'SD178                33D:417.M REMOVED AT REQUEST OF DC C...',
	  SD179: 'SD179                33D:418.F REMOVED AT REQUEST OF DC C...',
	  SD18: 'SD18                 7:620.P AGRICULTURE ACTS - FALSE DED...',
	  SD180: 'SD180                33D:418.M REMOVED AT REQUEST OF DC C...',
	  SD181: 'SD181                33D:419.F REMOVED AT REQUEST OF DC C...',
	  SD182: 'SD182                33D:419.M REMOVED AT REQUEST OF DC C...',
	  SD183: 'SD183                33D:420.F REMOVED AT REQUEST OF DC C...',
	  SD184: 'SD184                33D:420.M REMOVED AT REQUEST OF DC C...',
	  SD185: 'SD185                33D:421.F REMOVED AT REQUEST OF DC C...',
	  SD186: 'SD186                33D:421.M REMOVED AT REQUEST OF DC C...',
	  SD187: 'SD187                33D:422.F REMOVED AT REQUEST OF DC C...',
	  SD188: 'SD188                33D:422.M REMOVED AT REQUEST OF DC C...',
	  SD189: 'SD189                33D:423.F REMOVED AT REQUEST OF DC C...',
	  SD19: 'SD19                 8:1326.F ILLEGAL REENTRY OF ALIENS',
	  SD190: 'SD190                33D:423.M REMOVED AT REQUEST OF DC C...',
	  SD191: 'SD191                42:1973.F ELECTION LAW VIOLATIONS',
	  SD192: 'SD192                42:2278A.M VIOLATION OF COMMISSION R...',
	  SD193: 'SD193                42:2278A.P TRESPASS UPON INSTALLATION',
	  SD194: 'SD194                42:9603C.F NOTIFICATION REQUIREMENTS',
	  SD195: 'SD195                42:9603C.M FAILURE TO NOTIFY EPA',
	  SD196: 'SD196                47:605A.P SATELLITE PIRACY',
	  SD197: 'SD197                47:605E.F SATELLITE PIRACY',
	  SD198: 'SD198                47:605E.P SATELLITE PIRACY',
	  SD199: 'SD199                49A:1472D.F INTERFERENCE WITH AIR NA...',
	  SD2: 'SD2                  7.:13.P POSTAL, INTERSTATE WIRE, RAD...',
	  SD20: 'SD20                 12:378A.F - VIOLATIONS IN THE BANKIN...',
	  SD200: 'SD200                49A:1472D.M INTERFERENCE WITH AIR NA...',
	  SD201: 'SD201                99:42.M CONTEMPT',
	  SD202: 'SD202                18:13-4600.P LENDING CREDIT INSTITUT...',
	  SD21: 'SD21                 12:378B.F - VIOLATIONS IN THE BANKIN...',
	  SD22: 'SD22                 12:1730D.F RETENTION OF RECORDS',
	  SD23: 'SD23                 12:1730D.F RETENTION OF RECORDS',
	  SD24: 'SD24                 12:1730D.F RETENTION OF RECORDS',
	  SD25: 'SD25                 12:1730D.F RETENTION OF RECORDS',
	  SD26: 'SD26                 12:1818.M ILLEGAL PARTICIPATION BY B...',
	  SD27: 'SD27                 15:1.M ANTITRUST VIOLATIONS',
	  SD28: 'SD28                 15:2.M MONOPOLIZING TRADE',
	  SD29: 'SD29                 15:3.M TRUSTS IN TERRITORIES AND DIS...',
	  SD3: 'SD3                  7:13.F EMBEZZLEMENT: OFFICER OR EMPL...',
	  SD30: 'SD30                 16:710.F - PARTIAL VALIDITY',
	  SD31: 'SD31                 16:710.F - PARTIAL VALIDITY',
	  SD32: 'SD32                 18:13-0100.M MURDER FIRST DEGREE',
	  SD33: 'SD33                 18:13-0200.M MURDER, SECOND DEGREE',
	  SD34: 'SD34                 18:13-0300.M MANSLAUGHTER',
	  SD35: 'SD35                 18:13-0310.M NEGLIGENT',
	  SD36: 'SD36                 18:13-3200.P LARCENY AND THEFT, POSTAL',
	  SD37: 'SD37                 18:13-3300.P INTERSTATE COMMERCE',
	  SD38: 'SD38                 18:13-3400.P THEFT OF U.S. PROPERTY',
	  SD39: 'SD39                 18:13-3700.M LARCENY AND THEFT, FELO...',
	  SD4: 'SD4                  7:13.M AGRICULTURE ACTS - PRICE CORN...',
	  SD40: 'SD40                 18:13-4100.P BANK EMBEZZLEMENT',
	  SD41: 'SD41                 18:13-4200.P POSTAL EMBEZZLEMENT',
	  SD42: 'SD42                 18:13-4320.P LENDING, CREDIT, INSURA...',
	  SD43: 'SD43                 18:13-4350.P EMBEZZLEMENT: OFFICER O...',
	  SD44: 'SD44                 18:13-4390.P EMBEZZLEMENT, OTHER',
	  SD45: 'SD45                 18:13-4920.P SECURITIES AND EXCHANGE',
	  SD46: 'SD46                 18:13-4931.P FRAUD, EXCISE TAX, OTHER',
	  SD47: 'SD47                 18:13-4932.P FRAUD, WAGERING TAX, OTHER',
	  SD48: 'SD48                 18:13-4941.P FRAUD FOOD STAMP PROGRAM',
	  SD49: 'SD49                 18:13-4950.F SOCIAL SECURITY',
	  SD5: 'SD5                  7:131.P MANIPULATIONS OR OTHER VIOLA...',
	  SD50: 'SD50                 18:13-4992.M FRAUD, CONSPIRE TO DEFR...',
	  SD51: 'SD51                 18:13-6511.F MARIJUANA -  DISTRIBUTE...',
	  SD52: 'SD52                 18:13-6511.M MARIJUANA -  DISTRIBUTE...',
	  SD53: 'SD53                 18:13-6512.F MARIJUANA - IMPORTATION...',
	  SD54: 'SD54                 18:13-6513-F MARIJUANA - MANUFACTURE',
	  SD55: 'SD55                 18:13-6514.F MARIJUANA - POSSESSION',
	  SD56: 'SD56                 18:13-6514.M MARIJUANA - POSSESSION',
	  SD57: 'SD57                 18:13-6515.F MARIJUANA - RECORDS, RX...',
	  SD58: 'SD58                 18:13-6711.F NARCOTICS - DISTRIBUTE,...',
	  SD59: 'SD59                 18:13-6712.F NARCOTICS - IMPORTATION...',
	  SD6: 'SD6                  7:13B.P AGRICULTURE ACTS - USE OF CO...',
	  SD60: 'SD60                 18:13-6713.F NARCOTICS - MANUFACTURE',
	  SD61: 'SD61                 18:13-6714.F NARCOTICS - POSSESSION',
	  SD62: 'SD62                 18:13-6714.M NARCOTICS - POSSESSION',
	  SD63: 'SD63                 18:13-6715.F NARCOTICS - RECORDS, RX...',
	  SD64: 'SD64                 18:13-6811.F CONTROLLED SUBSTANCE - ...',
	  SD65: 'SD65                 18:13-6812.F CONTROLLED SUBSTANCE - ...',
	  SD66: 'SD66                 18:13-6813.F CONTROLLED SUBSTANCE - ...',
	  SD67: 'SD67                 18:13-6814.F CONTROLLED SUBSTANCE - ...',
	  SD68: 'SD68                 18:13-6814.M CONTROLLED SUBSTANCE - ...',
	  SD69: 'SD69                 18:13-6815.F CONTROLLED SUBSTANCE - ...',
	  SD7: 'SD7                  7:13C.M  AGRICULTURE ACTS - PROHIBIT...',
	  SD70: 'SD70                 18:13-6825.M CONTROLLED SUBSTANCE - ...',
	  SD71: 'SD71                 18:13-6834.F CONTROLLED  SUBSTANCE -...',
	  SD72: 'SD72                 18:13-6844.F CONTROLLED  SUBSTANCE -...',
	  SD73: 'SD73                 18:13-6854.F CONTROLLED SUBSTANCE - ...',
	  SD74: 'SD74                 18:13-7320.P ESCAPE, AIDING OR HARBO...',
	  SD75: 'SD75                 18:13-7500.P GAMBLING AND LOTTERY',
	  SD76: 'SD76                 18:13-7910.P ARSON',
	  SD77: 'SD77                 18:13-7920.F ABORTION',
	  SD78: 'SD78                 18:13-8720.M IMMIGRATION LAWS, ILLEG...',
	  SD79: 'SD79                 18:13-8740.M IMMIGRATION LAWS, ILLEG...',
	  SD8: 'SD8                  7:1986.F - AGRICULTURE ACTS - CONFLI...',
	  SD80: 'SD80                 18:13-8900.P LIQUOR, INTERNAL REVENUE',
	  SD81: 'SD81                 18:13-9001.M HAZARDOUS WASTE - TREAT...',
	  SD82: 'SD82                 18:13-9200.P ANTITRUST VIOLATIONS',
	  SD83: 'SD83                 18:13-9300.P FAIR LABOR STANDARDS ACT',
	  SD84: 'SD84                 18:13-9500.M MIGRATORY BIRD LAWS',
	  SD85: 'SD85                 18:13-9752.P ESPIONAGE',
	  SD86: 'SD86                 18:42.P IMPORT OR SHIP INJURIOUS MAM...',
	  SD87: 'SD87                 18:112-7420.M TAMPERING W/WITNESS',
	  SD88: 'SD88                 18:201C.F BRIBERY OF PUBLIC OFFICIAL...',
	  SD89: 'SD89                 18:201D.F BRIBERY OF PUBLIC OFFICIAL...',
	  SD9: 'SD9                  7:1986A.F STABILIZE PROVISIONS',
	  SD90: 'SD90                 18:201E.F BRIBERY OF PUBLIC OFFICIAL...',
	  SD91: 'SD91                 18:201F.F BRIBERY OF PUBLIC OFFICIAL...',
	  SD92: 'SD92                 18:201G.F BRIBERY OF PUBLIC OFFICIAL...',
	  SD93: 'SD93                 18:201H.F BRIBERY OF PUBLIC OFFICIAL...',
	  SD94: 'SD94                 18:201I.F BRIBERY OF PUBLIC OFFICIAL...',
	  SD95: 'SD95                 18:203.F CONTEMPT, MEMBERS OF CONGRE...',
	  SD96: 'SD96                 18:373-0100.P SOLICIT/COMMIT CRIME O...',
	  SD97: 'SD97                 18:982.P CRIMINAL FORFEITURE',
	  SD98: 'SD98                 18:1403.F NARCOTICS, OTHER',
	  SD99: 'SD99                 18:1403.M NARCOTICS, OTHER',
	  cmp: 'cmp                  complaint filed'
	};
	var caseFlagOptions = {
	  APPEAL: 'APPEAL',
	  ARBITRATION: 'ARBITRATION',
	  CASREF: 'CASREF',
	  CLOSED: 'CLOSED',
	  CONSENT: 'CONSENT',
	  ENE: 'ENE',
	  HABEAS: 'HABEAS',
	  HBS: 'HBS',
	  HKS: 'HKS',
	  INTERPRETER: 'INTERPRETER',
	  JJM: 'JJM',
	  JWF: 'JWF',
	  LEAD: 'LEAD',
	  LGF: 'LGF',
	  MEDIATION: 'MEDIATION',
	  MEMBER: 'MEMBER',
	  MERGED: 'MERGED',
	  MOTREF: 'MOTREF',
	  MWP: 'MWP',
	  PRIOR: 'PRIOR',
	  ProSe: 'ProSe',
	  SEALED: 'SEALED',
	  SETTLE: 'SETTLE',
	  SM: 'SM',
	  STAT_CLOSE: 'STAT_CLOSE',
	  STAYED: 'STAYED',
	  VEB: 'VEB',
	  VictimNotify: 'VictimNotify'
	};
	var countStatusOptions = {
	  pending_citations: 'Pending',
	  terminated_citations: 'Disposed'
	};
	var includeCVBCasesOptions = {
	  '': '',
	  Yes: 'Yes',
	  No: 'No'
	};
	var casePropertiesOptions = {
	  pending_defendants: 'Pending defendants',
	  terminated_defendants: 'Terminated defendants'
	};

/***/ },
/* 1221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.purchaseCreditorMailingData = exports.getCreditorMailingData = undefined;
	exports.requestCreditorMailingData = requestCreditorMailingData;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _creditorMailingTypes = __webpack_require__(717);
	
	var types = _interopRequireWildcard(_creditorMailingTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapResponseErrorsToMessage(err) {
	  var request_id = _lodash2.default.get(err, ['response', 'body', 'error', 'request_id']);
	  var errorMessageExtra = request_id ? 'When contacting support, please quote Request ID \'' + request_id + '\'' : '';
	
	  return {
	    // We want to hide real messages from user since traces are confusing to them
	    // TODO: coordinate with API to surface proper errors such as field validation?
	    messages: ['PACER is experiencing some issues. Please try again in a few minutes.', errorMessageExtra],
	    // but we include the real message in the details so we receive it in the sentry report
	    details: _lodash2.default.get(err, ['response', 'body', 'error']) || []
	  };
	}
	
	function mapResponseToData(response, filters, searchType) {
	  // todo check if other case menus return multiple types back like assoc cases
	  var data = {};
	
	  if (filters.type === 'associated_cases') {
	    data = Array.isArray(response.body.queries) ? _lodash2.default.get(response.body, 'queries[0]', []) : _lodash2.default.get(response.body, 'queries', []);
	
	    data = Object.keys(data).reduce(function (accum, next) {
	      accum.push([next, data[next][0].text]);
	      return accum;
	    }, []);
	  } else if (filters.type === 'creditor_mailing') {
	    data = Array.isArray(response.body.queries) ? _lodash2.default.get(response.body, 'queries[0].creditor_mailing[0]', []) : _lodash2.default.get(response.body, 'queries', []);
	  } else if (filters.type === 'creditor_mailing_variant') {
	    data = Array.isArray(response.body.queries) ? _lodash2.default.get(response.body, 'queries[0].creditor_mailing_variant[0]', []) : _lodash2.default.get(response.body, 'queries', []);
	  } else {
	    var type = searchType || filters.type;
	
	    data = Array.isArray(response.body.queries) ? _lodash2.default.get(response.body, 'queries[0].' + type + '[0].text', []) : _lodash2.default.get(response.body, 'queries.' + type + '[0].text', []);
	  }
	
	  return data;
	}
	
	function receiveError(err) {
	  var msg = mapResponseErrorsToMessage(err);
	  return {
	    type: types.SERVICE_ERROR,
	    error: msg,
	    errors: msg
	  };
	}
	
	function receiveCreditorMailingDataLocal(response, filters) {
	  var data = mapResponseToData(response, filters);
	  var receipt = filters.receipt;
	
	  return {
	    type: types.RECEIVE_CREDITOR_MAILING,
	    data_type: filters.type,
	    data: data,
	    // data: _.get(response.body, `${filters.type}.text`, []),
	    lastUpdated: _lodash2.default.get(response.body, 'queries[0].' + filters.type + '[0].meta.timestamp'),
	    receipt: receipt
	  };
	}
	
	function receiveCreditorMailingDataPurchased(response, filters) {
	  var data = mapResponseToData(response, filters);
	
	  return {
	    type: types.RECEIVE_CREDITOR_MAILING,
	    data_type: filters.type,
	    data: data,
	    // data: _.get(response.body, `${filters.type}.text`, []), // old
	    lastUpdated: _lodash2.default.get(response.body, 'items.receipts[0].meta.timestamp'),
	    receipt: _lodash2.default.get(response.body, 'items.receipts[0].text')
	  };
	}
	
	var getCreditorMailingData = exports.getCreditorMailingData = function getCreditorMailingData(params) {
	  return function (dispatch) {
	    requestCreditorMailingData(params, dispatch);
	
	    return _superagent2.default.post('/ir-search/query-json').query({
	      query: params.type,
	      case_uuid: params.case_uuid
	    }).set('Accept', 'application/json').then(function (response) {
	      dispatch(receiveCreditorMailingDataLocal(response, params));
	    }, function (err) {
	      return dispatch(receiveError(err));
	    });
	  };
	};
	
	function requestCreditorMailingData(params, dispatch) {
	  dispatch({
	    type: types.REQUEST_CREDITOR_MAILING,
	    params: params
	  });
	
	  dispatch({
	    type: types.RESET_SERVICE_ERROR
	  });
	}
	
	var purchaseCreditorMailingData = exports.purchaseCreditorMailingData = function purchaseCreditorMailingData(params) {
	  return function (dispatch) {
	    requestCreditorMailingData(params, dispatch);
	
	    return _superagent2.default.post('/ir-search/pacer-query-json').query({
	      query: params.type,
	      case_uuid: params.case_uuid,
	      format: params.format
	    }).set('Accept', 'application/json').then(function (response) {
	      window.refresh_menu(params.case_uuid);
	
	      if (!_lodash2.default.isEmpty(response.body.error)) {
	        return dispatch(receiveError(response));
	      }
	      params.receipt = _lodash2.default.get(response.body, 'items.receipts[0].text');
	      params.type = params.queryType;
	      return dispatch(getCreditorMailingData(params));
	    }, function (err) {
	      return dispatch(receiveError(err));
	    });
	  };
	};

/***/ },
/* 1222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.purchaseHistoryCaseData = exports.getHistoryItems = exports.getParserSearchData = exports.filterHistoryEntries = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _pacerSearch = __webpack_require__(93);
	
	var _historyTypes = __webpack_require__(718);
	
	var types = _interopRequireWildcard(_historyTypes);
	
	var _docketsActionTypes = __webpack_require__(177);
	
	var docketActionTypes = _interopRequireWildcard(_docketsActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapResponseErrorsToMessage(err) {
	  var request_id = _lodash2.default.get(err, ['response', 'body', 'error', 'request_id']);
	  var errorMessageExtra = request_id ? 'When contacting support, please quote Request ID \'' + request_id + '\'' : '';
	
	  return {
	    // We want to hide real messages from user since traces are confusing to them
	    // TODO: coordinate with API to surface proper errors such as field validation?
	    messages: ['PACER is experiencing some issues. Please try again in a few minutes.', errorMessageExtra],
	    // but we include the real message in the details so we receive it in the sentry report
	    details: _lodash2.default.get(err, ['response', 'body', 'error']) || []
	  };
	}
	
	function receiveError(err, msg) {
	  return {
	    type: types.SERVICE_ERROR,
	    error: msg,
	    errors: msg
	  };
	}
	
	function onFailure(dispatch) {
	  return function (err) {
	    return dispatch(receiveError(types.SERVICE_ERROR, mapResponseErrorsToMessage(err)));
	  };
	}
	function requestCaseData(params, dispatch) {
	  dispatch({
	    type: types.REQUEST_HISTORY_DATA,
	    params: params
	  });
	
	  dispatch({
	    type: types.RESET_SERVICE_ERROR
	  });
	}
	
	function requestFilterCaseData(params, dispatch) {
	  dispatch({
	    type: types.REQUEST_FILTER_HISTORY_DATA,
	    params: params
	  });
	
	  dispatch({
	    type: types.RESET_SERVICE_ERROR
	  });
	}
	
	function mapHistoryDocumentsPacerResponseToData(response) {
	  var history = response.body.items;
	  history.entries = history.history || [];
	  history.total_items = history.history.length;
	
	  delete history.history;
	  delete history.receipts;
	  delete history.headers;
	
	  return Object.keys(history).map(function (key) {
	    return [key, history[key]];
	  });
	}
	
	function receiveHistoryDocumentsFromPacer(response, filters) {
	  var data = mapHistoryDocumentsPacerResponseToData(response, filters);
	
	  return {
	    type: types.RECEIVE_CASE_DATA,
	    data_type: filters.type,
	    data: data,
	    // data: _.get(response.body, `${filters.type}.text`, []), // old
	    lastUpdated: _lodash2.default.get(response.body, 'items.receipts[0].meta.timestamp'),
	    receipt: _lodash2.default.get(response.body, 'items.receipts[0].text')
	  };
	}
	
	function mapHistoryDocumentsToData(response, filters) {
	  var history = response.body;
	  history.entries = history.json_data || [];
	  history.entries.forEach(function (p) {
	    return p.isVisible = true;
	  });
	  if (filters.delimeter === ',') {
	    history.entries.map(function (item) {
	      return item.text.docket_no === parseInt(filters.doc_from) || item.text.docket_no === parseInt(filters.doc_to) ? item.isVisible = true : item.isVisible = false;
	    });
	  }
	  delete history.json_data;
	  return Object.keys(history).map(function (key) {
	    return [key, history[key]];
	  });
	}
	
	function receiveHistoryDocuments(response, filters, receipts) {
	  var data = mapHistoryDocumentsToData(response, filters);
	
	  return {
	    type: types.RECEIVE_HISTORY_DATA,
	    data_type: filters.type,
	    data: data,
	    // data: _.get(response.body, `${filters.type}.text`, []), // old
	    lastUpdated: receipts ? receipts.lastUpdated : null,
	    receipt: receipts ? receipts.receipt : null
	  };
	}
	
	var filterHistoryEntries = exports.filterHistoryEntries = function filterHistoryEntries(filter) {
	  return function (dispatch, getState) {
	    requestFilterCaseData({}, dispatch);
	
	    var state = getState();
	
	    var _filter$keyword = filter.keyword,
	        keyword = _filter$keyword === undefined ? '' : _filter$keyword;
	
	    var searchWords = keyword.toLowerCase().split(' ').filter(function (p) {
	      return p !== '';
	    }).reverse();
	
	    var data = state.toJS().history.data.map(function (next) {
	      var key = next[0];
	      var value = next[1];
	
	      if (key === 'entries') {
	        var values = value.map(function (docketEntry) {
	          var docketText = _lodash2.default.get(docketEntry, ['text', 'docket_text'], '');
	          var isVisible = _lodash2.default.isEmpty(searchWords) || _lodash2.default.every(searchWords, function (word) {
	            return docketText.toLowerCase().indexOf(word) > -1;
	          });
	          return _extends({}, docketEntry, { isVisible: isVisible });
	        });
	        return [key, values];
	      }
	      return next;
	    });
	
	    return dispatch({
	      type: types.RECEIVE_HISTORY_DATA,
	      data_type: 'history',
	      data: data
	    });
	  };
	};
	var getParserSearchData = exports.getParserSearchData = function getParserSearchData(params, receipts) {
	  return function (dispatch) {
	    dispatch({
	      type: docketActionTypes.UPDATE_SELECTED_DOCKET,
	      selectedDocket: {
	        status: 'done',
	        docket_no: null,
	        docket_seq: null,
	        binder: {}
	      }
	    });
	
	    requestCaseData(params, dispatch);
	    //optional params after direction add page size
	    return _superagent2.default.post('/parser/direct/history_search/' + params.case_uuid + '/' + params.keyword + '/' + params.date_from + '/' + params.date_to + '/' + params.doc_from + '/' + params.doc_to + '/' + params.sort_field + '/' + params.sort_direction + '?page=' + params.page_num).set('Accept', 'application/json').then(function (response) {
	      return dispatch(receiveHistoryDocuments(response, params, receipts));
	    }, onFailure(dispatch));
	  };
	};
	
	var getHistoryItems = exports.getHistoryItems = function getHistoryItems(params) {
	  var receipts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	  return function (dispatch, getState) {
	    // requestCaseData({}, dispatch);
	    dispatch({
	      type: docketActionTypes.UPDATE_SELECTED_DOCKET,
	      selectedDocket: {
	        status: 'done',
	        docket_no: null,
	        docket_seq: null,
	        binder: {}
	      }
	    });
	
	    return _superagent2.default.post('/parser/direct/history_search/' + params.case_uuid + '/' + params.keyword + '/' + params.date_from + '/' + params.date_to + '/' + params.doc_from + '/' + params.doc_to + '/' + params.sort_field + '/' + params.sort_direction + '?page=' + params.page_num).set('Accept', 'application/json').then(function (response) {
	      return dispatch(receiveHistoryDocuments(response, params, receipts));
	    }, onFailure(dispatch));
	  };
	};
	var purchaseHistoryCaseData = exports.purchaseHistoryCaseData = function purchaseHistoryCaseData(params) {
	  return function (dispatch) {
	    requestCaseData(params, dispatch);
	
	    return _superagent2.default.get('/ir-search/pacer-query-json').query({
	      query: params.type,
	      case_uuid: params.case_uuid,
	      history_type: params.history_type,
	      show_docket: params.show_docket
	    }).set('Accept', 'application/json').then(function (response) {
	      window.refresh_menu(params.case_uuid);
	
	      if (!_lodash2.default.isEmpty(response.body.error)) {
	        return onFailure(dispatch)({ response: response });
	      }
	      var itemParams = {
	        case_uuid: params.case_uuid,
	        date_from: '_',
	        date_to: '_',
	        doc_from: '_',
	        doc_to: '_',
	        keyword: '_',
	        page_num: 0,
	        page_index: 1,
	        sort_direction: 'desc',
	        sort_field: 'date_filed'
	      };
	
	      var receipts = {
	        receipt: _lodash2.default.get(response.body, 'items.receipts[0].text'),
	        lastUpdated: _lodash2.default.get(response.body, 'items.receipts[0].meta.timestamp')
	      };
	
	      return getParserSearchData(itemParams, receipts)(dispatch);
	    }, onFailure(dispatch));
	  };
	};

/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getApiCallsSummary = exports.getApiCallsDetails = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _apiCallsActionTypes = __webpack_require__(713);
	
	var types = _interopRequireWildcard(_apiCallsActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapResponseToData(response, filters) {
	  return response.body;
	}
	
	function mapResponseErrorsToMessage(err) {
	  var request_id = _lodash2.default.get(err, ['response', 'body', 'error', 'request_id']);
	  var errorMessageExtra = request_id ? 'When contacting support, please quote Request ID \'' + request_id + '\'' : '';
	
	  return {
	    // We want to hide real messages from user since traces are confusing to them
	    // TODO: coordinate with API to surface proper errors such as field validation?
	    messages: ['Application is experiencing some issues. Please try again in a few minutes.', errorMessageExtra],
	    // but we include the real message in the details so we receive it in the sentry report
	    details: _lodash2.default.get(err, ['response', 'body', 'error']) || []
	  };
	}
	
	function requestApiCallsDetails(params) {
	  return {
	    type: types.REQUEST_API_CALLS_DETAILS,
	    params: params
	  };
	}
	
	function requestApiCallsPeriods(params) {
	  return {
	    type: types.REQUEST_API_CALLS_SUMMARY,
	    params: params
	  };
	}
	
	function receiveApiCallsDetails(response, filters) {
	  var data = mapResponseToData(response, filters);
	
	  return {
	    type: types.RECEIVE_API_CALLS_DETAILS,
	    usage: data.usage,
	    periods: filters.periods,
	    status: data.status
	  };
	}
	
	function receiveApiCallsPeriods(response, filters) {
	  var data = mapResponseToData(response, filters);
	
	  return {
	    type: types.RECEIVE_API_CALLS_SUMMARY,
	    usage: filters.usage,
	    periods: data.periods,
	    status: data.status
	  };
	}
	
	function receiveError(err, msg) {
	  return {
	    type: types.SERVICE_ERROR,
	    error: msg,
	    errors: msg
	  };
	}
	
	function onFailure(dispatch) {
	  return function (err) {
	    return dispatch(receiveError(types.SERVICE_ERROR, mapResponseErrorsToMessage(err)));
	  };
	}
	
	// exports
	var getApiCallsDetails = exports.getApiCallsDetails = function getApiCallsDetails(params) {
	  return function (dispatch) {
	    dispatch(requestApiCallsDetails(params));
	
	    return _superagent2.default.get('/rpc/integrations/' + params.uid + '/billing_usage?period_start=' + params.period_start + '&period_end=' + params.period_end + '&interval_grouping=' + params.interval_grouping).set('Accept', 'application/json').then(function (response) {
	      return dispatch(receiveApiCallsDetails(response, params));
	    }, onFailure(dispatch));
	  };
	};
	
	var getApiCallsSummary = exports.getApiCallsSummary = function getApiCallsSummary(params) {
	  return function (dispatch) {
	    dispatch(requestApiCallsPeriods(params));
	
	    return _superagent2.default.get('/rpc/integrations/' + params.uid + '/billing_periods').set('Accept', 'application/json').then(function (response) {
	      return dispatch(receiveApiCallsPeriods(response, params));
	    }, onFailure(dispatch));
	  };
	};

/***/ },
/* 1224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.purchaseRelatedTransactionsCaseData = exports.getCaseData = exports.getParserSearchData = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _pacerSearch = __webpack_require__(93);
	
	var _relatedTransactionActionTypes = __webpack_require__(721);
	
	var types = _interopRequireWildcard(_relatedTransactionActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapResponseErrorsToMessage(err) {
	  var request_id = _lodash2.default.get(err, ['response', 'body', 'error', 'request_id']);
	  var errorMessageExtra = request_id ? 'When contacting support, please quote Request ID \'' + request_id + '\'' : '';
	
	  return {
	    // We want to hide real messages from user since traces are confusing to them
	    // TODO: coordinate with API to surface proper errors such as field validation?
	    messages: ['PACER is experiencing some issues. Please try again in a few minutes.', errorMessageExtra],
	    // but we include the real message in the details so we receive it in the sentry report
	    details: _lodash2.default.get(err, ['response', 'body', 'error']) || []
	  };
	}
	
	function receiveError(err, msg) {
	  return {
	    type: types.SERVICE_ERROR,
	    error: msg,
	    errors: msg
	  };
	}
	
	function onFailure(dispatch) {
	  return function (err) {
	    return dispatch(receiveError(types.SERVICE_ERROR, mapResponseErrorsToMessage(err)));
	  };
	}
	function requestCaseData(params, dispatch) {
	  dispatch({
	    type: types.REQUEST_RELATED_TRANSACTION_DATA,
	    params: params
	  });
	
	  dispatch({
	    type: types.RESET_SERVICE_ERROR
	  });
	}
	
	function mapRelatedTransactionParserToData(response) {
	  var transactions = response.body;
	  transactions.entries = transactions.json_data || [];
	  delete transactions.json_data;
	  return Object.keys(transactions).map(function (key) {
	    return [key, transactions[key]];
	  });
	}
	
	function receiveRelatedTransactionParser(response, filters) {
	  var data = mapRelatedTransactionParserToData(response, filters);
	
	  return {
	    type: types.RECEIVE__RELATED_TRANSACTION_DATA,
	    data_type: filters.type,
	    data: data,
	    // data: _.get(response.body, `${filters.type}.text`, []),
	    lastUpdated: _lodash2.default.get(response.body, 'queries[0].' + filters.type + '[0].meta.timestamp'),
	    receipt: null
	  };
	}
	var getParserSearchData = exports.getParserSearchData = function getParserSearchData(params) {
	  return function (dispatch) {
	    requestCaseData(params, dispatch);
	    return _superagent2.default.post('/parser/direct/related_transactions_search/' + params.case_uuid + '/' + params.keyword + '/' + params.date_from + '/' + params.date_to + '/' + params.doc_from + '/' + params.doc_to + '/' + params.sort_field + '/' + params.sort_direction + '?page=' + params.page_num).set('Accept', 'application/json').then(function (response) {
	      return dispatch(receiveRelatedTransactionParser(response, params));
	    }, onFailure(dispatch));
	  };
	};
	function mapResponseToData(response) {
	  var related_transaction = response.body.items;
	  related_transaction.entries = related_transaction.related_transactions || [];
	  related_transaction.total_items = related_transaction.related_transactions.length;
	
	  delete related_transaction.related_transactions;
	  delete related_transaction.receipts;
	  delete related_transaction.headers;
	
	  return Object.keys(related_transaction).map(function (key) {
	    return [key, related_transaction[key]];
	  });
	}
	
	function receiveTransactionsPurchased(response, filters) {
	  var data = mapResponseToData(response);
	
	  return {
	    type: types.RECEIVE__RELATED_TRANSACTION_DATA,
	    data_type: filters.type,
	    data: data,
	    // data: _.get(response.body, `${filters.type}.text`, []), // old
	    lastUpdated: _lodash2.default.get(response.body, 'items.receipts[0].meta.timestamp'),
	    receipt: _lodash2.default.get(response.body, 'items.receipts[0].text')
	  };
	}
	var getCaseData = exports.getCaseData = function getCaseData(params) {
	  return function (dispatch) {
	    requestCaseData(params, dispatch);
	
	    return _superagent2.default.get('/ir-search/query-json').query({
	      query: params.type,
	      case_uuid: params.case_uuid
	    }).set('Accept', 'application/json').then(function (response) {
	      // window.refresh_menu(params.case_uuid);
	
	      if (!_lodash2.default.isEmpty(response.body.error)) {
	        return onFailure(dispatch)({ response: response });
	      }
	
	      return dispatch(receiveTransactionsPurchased(response, params));
	    }, onFailure(dispatch));
	  };
	};
	
	var purchaseRelatedTransactionsCaseData = exports.purchaseRelatedTransactionsCaseData = function purchaseRelatedTransactionsCaseData(params) {
	  return function (dispatch) {
	    requestCaseData(params, dispatch);
	
	    return _superagent2.default.get('/ir-search/pacer-query-json').query({
	      query: params.type,
	      case_uuid: params.case_uuid,
	      keyword: params.keyword,
	      date_from: params.date_from,
	      date_to: params.date_to,
	      doc_from: params.doc_from,
	      doc_to: params.doc_to,
	      doc_type: params.doc_type,
	      show_pending: params.show_pending,
	      show_terminated: params.show_terminated
	    }).set('Accept', 'application/json').then(function (response) {
	      window.refresh_menu(params.case_uuid);
	
	      if (!_lodash2.default.isEmpty(response.body.error)) {
	        return onFailure(dispatch)({ response: response });
	      }
	
	      return dispatch(receiveTransactionsPurchased(response, params));
	    }, onFailure(dispatch));
	  };
	};

/***/ },
/* 1225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.automateMailing = exports.reports = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _superagent = __webpack_require__(20);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _url = __webpack_require__(180);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _reportsTabActionTypes = __webpack_require__(722);
	
	var types = _interopRequireWildcard(_reportsTabActionTypes);
	
	var _errorActionTypes = __webpack_require__(101);
	
	var errorConstants = _interopRequireWildcard(_errorActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function removeFalsyValues(obj) {
	  return _lodash2.default.pickBy(obj, _lodash2.default.identity);
	}
	
	function requestReports() {
	  return {
	    type: types.REQUEST_REPORTS
	  };
	}
	
	function requestAutomateMailing() {
	  return {
	    type: types.REQUEST_AUTOMATE_MAILING_REPORTS
	  };
	}
	
	function receiveReports(resBody) {
	  return {
	    type: types.RECEIVE_REPORTS,
	    resBody: resBody
	  };
	}
	
	function receiveAutomateMailing(resBody) {
	  return {
	    type: types.RECEIVE_AUTOMATE_MAILING_REPORTS,
	    resBody: resBody
	  };
	}
	
	function receiveError(res, type) {
	  var error = void 0;
	  try {
	    error = res.response.body.errors;
	  } catch (e) {
	    error = 'Server error: ' + res.status + ': ' + res.message;
	  }
	  return { type: type, error: error };
	}
	
	function onSuccessReceiveReports(dispatch) {
	  return function (res) {
	    return dispatch(receiveReports(res.body));
	  };
	}
	
	function onSuccessAutomateMailing(dispatch) {
	  return function (res) {
	    return dispatch(receiveAutomateMailing(res.body));
	  };
	}
	
	function onFailure(dispatch) {
	  return function (res) {
	    return dispatch(receiveError(res, errorConstants.SERVER_ERROR));
	  };
	}
	
	var reports = exports.reports = function reports(params) {
	  return function (dispatch) {
	    dispatch(requestReports());
	    var filters = removeFalsyValues(params);
	
	    return _superagent2.default.post((0, _url2.default)('/localsearch/search-json')).send(filters).set('Content-Type', 'application/json').then(onSuccessReceiveReports(dispatch), onFailure(dispatch));
	  };
	};
	
	var automateMailing = exports.automateMailing = function automateMailing(params) {
	  return function (dispatch) {
	    dispatch(requestAutomateMailing());
	
	    var filters = removeFalsyValues(params);
	
	    return _superagent2.default.post((0, _url2.default)('/localsearch/add-alert')).send(filters).set('Content-Type', 'application/json').then(onSuccessAutomateMailing(dispatch), onFailure(dispatch));
	  };
	};

/***/ },
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReducer;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(4);
	
	var _immutable = __webpack_require__(30);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _utils = __webpack_require__(33);
	
	var _advancedSearchActionTypes = __webpack_require__(712);
	
	var actionTypes = _interopRequireWildcard(_advancedSearchActionTypes);
	
	var _formData = __webpack_require__(49);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = Immutable.fromJS({
	  filter: {
	    grouped: false,
	    page: 0,
	    do_search: false
	  },
	  resultsFilter: {
	    grouped: false,
	    page: 0
	    // do_search: false,
	  },
	  data: {},
	  error: null,
	  isLoading: false,
	  showResults: false,
	  alert: {
	    isLoading: false,
	    error: null,
	    data: {
	      name: null,
	      delivery: null,
	      notify_interval: null,
	      notify_interval_label: null,
	      meta: {}
	    }
	  }
	});
	
	function getTemplate(tab) {
	  var templateMap = {
	    general: 'general',
	    cases: 'case_lookup',
	    'case-activity': 'case_activity',
	    petitions: 'extended',
	    schedules: 'schedules'
	  };
	  return templateMap[tab];
	}
	
	exports.default = (0, _utils.createReducer)(initialState, (_createReducer = {}, _createReducer[actionTypes.ADVANCED_SEARCH_ALL_GENERAL.REQUEST] = function (state, _ref) {
	  var payload = _ref.payload;
	  return state.merge(Immutable.fromJS({
	    isLoading: true,
	    filter: payload,
	    resultsFilter: payload,
	    showResults: true,
	    data: {}
	  }));
	}, _createReducer[actionTypes.ADVANCED_SEARCH_ALL_GENERAL.ERROR] = function (state, _ref2) {
	  var error = _ref2.error;
	  return state.merge(Immutable.fromJS({ error: error, isLoading: false }));
	}, _createReducer[actionTypes.ADVANCED_SEARCH_ALL_GENERAL.SUCCESS] = function (state, _ref3) {
	  var data = _ref3.data;
	  return state.merge(Immutable.fromJS({
	    data: data,
	    isLoading: false
	  }));
	}, _createReducer[actionTypes.ADVANCED_SEARCH_RESET] = function (state) {
	  var court_type = state.getIn(['filter', 'court_type']);
	  var tab = state.getIn(['filter', 'tab']);
	  var selectedFilter = _formData.formDefaults[court_type][tab];
	
	  return initialState.set('filter', Immutable.fromJS(_extends({}, selectedFilter.default, selectedFilter.mustHave, {
	    page: 0,
	    court_type: court_type,
	    tab: tab,
	    template: getTemplate(tab)
	  }))).set('history', state.get('history'));
	}, _createReducer[actionTypes.ADVANCED_SEARCH_FORM_FILTER_SET] = function (state, _ref4) {
	  var _ref4$payload = _ref4.payload,
	      courtType = _ref4$payload.courtType,
	      tab = _ref4$payload.tab,
	      queryParams = _ref4$payload.queryParams,
	      history = _ref4$payload.history;
	
	  var selectedFilter = _formData.formDefaults[courtType][tab];
	  // clear extra fields from result filters, leave only common ones
	  var resultFilter = (0, _lodash.omit)(state.get('resultsFilter').toJS(), Object.keys(selectedFilter.omit));
	
	  return state.set('filter', Immutable.fromJS(queryParams && queryParams.do_search && !state.get('showResults') ? _extends({}, selectedFilter.default, queryParams, {
	    court_type: courtType,
	    tab: tab,
	    template: getTemplate(tab)
	  }) : _extends({}, selectedFilter.default, resultFilter, selectedFilter.mustHave, {
	    page: 0,
	    court_type: courtType,
	    tab: tab,
	    template: getTemplate(tab)
	  }))).set('history', Immutable.fromJS(history));
	}, _createReducer[actionTypes.ADVANCED_SEARCH_URL_PARAMS_UPDATE] = function (state, _ref5) {
	  var payload = _ref5.payload;
	
	  var history = state.get('history').toJS();
	
	  if (history) {
	    history.replace({ search: payload });
	  }
	
	  return state;
	}, _createReducer[actionTypes.ADVANCED_SEARCH_RESULT_DOCKET_UPDATE] = function (state, _ref6) {
	  var payload = _ref6.payload;
	  return state.setIn(['data', 'results', payload.docket.id], payload.docket);
	}, _createReducer[actionTypes.ADVANCED_SEARCH_ALERT.REQUEST] = function (state, _ref7) {
	  var data = _ref7.data;
	
	  return state.mergeDeep(Immutable.fromJS({
	    alert: {
	      isLoading: true,
	      error: null,
	      data: data
	    }
	  }));
	}, _createReducer[actionTypes.ADVANCED_SEARCH_ALERT.ERROR] = function (state, _ref8) {
	  var error = _ref8.error;
	
	  return state.mergeDeep(Immutable.fromJS({
	    alert: {
	      isLoading: false,
	      error: error
	    }
	  }));
	}, _createReducer[actionTypes.ADVANCED_SEARCH_ALERT.SUCCESS] = function (state, _ref9) {
	  var data = _ref9.data;
	
	  var m = state.mergeDeep(Immutable.fromJS({
	    alert: {
	      isLoading: false,
	      data: data,
	      error: null
	    }
	  }));
	  return m;
	}, _createReducer));

/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReducer;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _immutable = __webpack_require__(30);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _claimDocumentsActionTypes = __webpack_require__(715);
	
	var types = _interopRequireWildcard(_claimDocumentsActionTypes);
	
	var _irSearchActionTypes = __webpack_require__(138);
	
	var irSearchTypes = _interopRequireWildcard(_irSearchActionTypes);
	
	var _utils = __webpack_require__(33);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialStateValue = {
	  status: '',
	  favoriteEmail: {
	    status: 'loading',
	    email: ''
	  },
	  popup: {
	    name: null,
	    show: false,
	    data: {}
	  },
	  docketParts: {
	    step: 0,
	    purchased: 0,
	    partsToPurchase: 0,
	    totalCost: 0,
	    parts: 0,
	    percentage: 0,
	    status: 'loading',
	    errors: null,
	    alreadyPurchased: false
	  },
	  selectedClaim: {
	    status: null,
	    seqNum: null,
	    claimNum: null,
	    courtCode: null,
	    caseNumber: null,
	    documents: {},
	    binder: {
	      // documents: [],
	    }
	  },
	  documentsList: [],
	  redact: {
	    showFlash: false,
	    seqNum: null,
	    showPopup: false
	  },
	  entries: {
	    // empty | loading | error
	    status: '',
	    data: []
	  },
	  receipt: {},
	  header: {
	    status: ''
	  }
	};
	
	var initialState = _immutable2.default.fromJS(initialStateValue);
	
	exports.default = (0, _utils.createReducer)(initialState, (_createReducer = {}, _createReducer[types.DOCKETS_POPUP] = function (state, action) {
	  var popup = action.popup;
	
	  return state.mergeDeep({ popup: popup });
	}, _createReducer[types.DOCKETS_FAVORITE_EMAIL] = function (state, action) {
	  var favoriteEmail = action.favoriteEmail;
	
	  return state.mergeDeep({ favoriteEmail: favoriteEmail });
	}, _createReducer[types.UPDATE_CLAIMS_PARTS] = function (state, action) {
	  var claimsParts = action.claimsParts;
	
	  return state.mergeDeep({ claimsParts: claimsParts });
	}, _createReducer[types.RESET_CLAIMS_PARTS] = function (state) {
	  var claimsParts = initialStateValue.claimsParts;
	
	  return state.merge({ claimsParts: claimsParts });
	}, _createReducer[types.UPDATE_DOCKET_HEADER] = function (state, action) {
	  var docketHeader = action.docketHeader;
	
	  return state.mergeDeep({ docketHeader: docketHeader });
	}, _createReducer[irSearchTypes.REQUEST_DOCKET_PARTS] = function (state, action) {
	  var step = action.step || 1;
	  var pdfZip = { status: 'loading', step: step };
	  return initialState.mergeDeep({ pdfZip: pdfZip });
	}, _createReducer[irSearchTypes.RECEIVE_DOCKET_PARTS] = function (state, action) {
	  var pdfZip = _extends({}, action.data, { isLoading: false });
	  return state.mergeDeep({ pdfZip: pdfZip });
	}, _createReducer[types.UPDATE_REDACT] = function (state, action) {
	  var redact = action.redact;
	
	  return state.mergeDeep({ redact: redact });
	}, _createReducer[types.FETCH_CLAIM_DOCUMENTS.REQUEST] = function (state, _ref) {
	  var selectedClaim = _ref.selectedClaim;
	  return state.set('selectedClaim', initialState.get('selectedClaim').merge(selectedClaim));
	}, _createReducer[types.FETCH_CLAIM_DOCUMENTS.SUCCESS] = function (state, _ref2) {
	  var selectedClaim = _ref2.selectedClaim;
	  var court_code = selectedClaim.court_code,
	      case_number = selectedClaim.case_number,
	      claimNum = selectedClaim.claimNum,
	      seqNum = selectedClaim.seqNum,
	      binder = selectedClaim.binder;
	
	  return state.mergeDeep({ selectedClaim: selectedClaim }).setIn(['documentsMap', court_code, case_number, claimNum, seqNum], _immutable2.default.fromJS(binder.documents)).setIn(['entries', 'data'], state.getIn(['entries', 'data']).push(_immutable2.default.fromJS(selectedClaim)));
	}, _createReducer[types.FETCH_CLAIM_DOCUMENTS.ERROR] = function (state) {
	  return state.setIn(['selectedClaim', 'status'], 'done');
	}, _createReducer[types.BUY_PDF_DOCUMENT.REQUEST] = function (state, _ref3) {
	  var number = _ref3.number;
	
	  var documentIndex = state.getIn(['selectedClaim', 'binder', 'documents']).findIndex(function (doc) {
	    return doc.get('number') === number;
	  });
	  return state.setIn(['selectedClaim', 'documentIndex'], documentIndex).setIn(['selectedClaim', 'binder', 'documents', documentIndex, 'status'], 'loading');
	}, _createReducer[types.BUY_PDF_DOCUMENT.ERROR] = function (state) {
	  return state.setIn(['selectedClaim', 'binder', 'documents', state.getIn(['selectedClaim', 'documentIndex']), 'status'], 'done');
	}, _createReducer[types.BUY_PDF_DOCUMENT.SUCCESS] = function (state, _ref4) {
	  var document = _ref4.document;
	
	  var _state$get$toJS = state.get('selectedClaim').toJS(),
	      court_code = _state$get$toJS.court_code,
	      case_number = _state$get$toJS.case_number,
	      claimNum = _state$get$toJS.claimNum,
	      seqNum = _state$get$toJS.seqNum,
	      documentIndex = _state$get$toJS.documentIndex;
	
	  var doc = _immutable2.default.fromJS(_extends({}, document, { status: 'done' }));
	  return state.mergeIn(['selectedClaim', 'binder', 'documents', documentIndex], doc).mergeIn(['documentsMap', court_code, case_number, claimNum, seqNum, documentIndex], doc);
	}, _createReducer[types.ORDER_PDF_DOCUMENT.REQUEST] = function (state, _ref5) {
	  var number = _ref5.number;
	
	  var documentIndex = state.getIn(['selectedClaim', 'binder', 'documents']).findIndex(function (doc) {
	    return doc.get('number') === number;
	  });
	  return state.setIn(['selectedClaim', 'documentIndex'], documentIndex).setIn(['selectedClaim', 'binder', 'documents', documentIndex, 'status'], 'loading');
	}, _createReducer[types.ORDER_PDF_DOCUMENT.SUCCESS] = function (state, _ref6) {
	  var document = _ref6.document;
	
	  var _state$get$toJS2 = state.get('selectedClaim').toJS(),
	      court_code = _state$get$toJS2.court_code,
	      case_number = _state$get$toJS2.case_number,
	      claimNum = _state$get$toJS2.claimNum,
	      seqNum = _state$get$toJS2.seqNum,
	      documentIndex = _state$get$toJS2.documentIndex;
	
	  var doc = _immutable2.default.fromJS(_extends({}, document, { status: 'done' }));
	  return state.mergeIn(['selectedClaim', 'binder', 'documents', documentIndex], doc).mergeIn(['documentsMap', court_code, case_number, claimNum, seqNum, documentIndex], doc);
	}, _createReducer[types.UPDATE_SELECTED_CLAIM] = function (state, _ref7) {
	  var selectedClaim = _ref7.selectedClaim;
	  return state.set('selectedClaim', _immutable2.default.fromJS(selectedClaim));
	}, _createReducer[types.UPDATE_CLAIMS] = function (state, action) {
	  // note we don't want mergeDeep here because it will "merge" any new array data, instead of replacing them
	  return state.merge(_extends({}, action));
	}, _createReducer.SERVICE_ERROR = function SERVICE_ERROR(state, action) {
	  return state.mergeDeep({ data_ready: true, error: action.errors });
	}, _createReducer));

/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReducer;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _immutable = __webpack_require__(30);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _clientCodeActionTypes = __webpack_require__(716);
	
	var actionTypes = _interopRequireWildcard(_clientCodeActionTypes);
	
	var _utils = __webpack_require__(33);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.fromJS({
	  clientCodeList: [],
	  hasMadeRequest: false, // for spinner
	  loadedPrevClientCodeList: false, // first time loaded
	  errorMessage: null,
	  sessionClientCode: ''
	});
	
	exports.default = (0, _utils.createReducer)(initialState, (_createReducer = {}, _createReducer[actionTypes.CLIENT_CODE_LIST.SUCCESS] = function (state, action) {
	  var resBody = action.resBody;
	
	  var newState = _extends({}, state, { hasMadeRequest: false, loadedPrevClientCodeList: true });
	
	  // For ajax search do not update if list empty
	  if (resBody.length > 0) newState.clientCodeList = resBody;
	  return state.merge(newState);
	}, _createReducer[actionTypes.CLIENT_CODE_SET.SUCCESS] = function (state, action) {
	  return state.merge({
	    sessionClientCode: action.code,
	    hasMadeRequest: false
	  });
	}, _createReducer[actionTypes.CLIENT_CODE_LIST.REQUEST] = function (state) {
	  return state.merge({
	    hasMadeRequest: true
	  });
	}, _createReducer[actionTypes.CLIENT_CODE_SET.REQUEST] = function (state) {
	  return state.merge({
	    hasMadeRequest: true
	  });
	}, _createReducer[actionTypes.CLIENT_CODE_LIST.ERROR] = function (state) {
	  return state.merge({
	    hasMadeRequest: false
	  });
	}, _createReducer[actionTypes.CLIENT_CODE_SET.ERROR] = function (state) {
	  return state.merge({
	    hasMadeRequest: false
	  });
	}, _createReducer));

/***/ },
/* 1229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReducer;
	
	var _immutable = __webpack_require__(30);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _utils = __webpack_require__(33);
	
	var _creditorMailingTypes = __webpack_require__(717);
	
	var types = _interopRequireWildcard(_creditorMailingTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialStateValue = {
	  data_ready: false,
	  data: [],
	  receipt: {},
	  lastUpdated: '',
	  error: {}
	};
	
	var initialState = _immutable2.default.fromJS(initialStateValue);
	
	exports.default = (0, _utils.createReducer)(initialState, (_createReducer = {}, _createReducer[types.REQUEST_CREDITOR_MAILING] = function (state) {
	  return state.mergeDeep(initialStateValue);
	}, _createReducer[types.RECEIVE_CREDITOR_MAILING] = function (state, action) {
	  var s = state.set('data', []).mergeDeep({
	    data_ready: true,
	    data: action.data,
	    lastUpdated: action.lastUpdated,
	    receipt: action.receipt
	  });
	  return s;
	}, _createReducer[types.SERVICE_ERROR] = function (state, action) {
	  return state.mergeDeep({ data_ready: true, error: action.errors });
	}, _createReducer));

/***/ },
/* 1230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReducer;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _immutable = __webpack_require__(30);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _docketsActionTypes = __webpack_require__(177);
	
	var types = _interopRequireWildcard(_docketsActionTypes);
	
	var _irSearchActionTypes = __webpack_require__(138);
	
	var irSearchTypes = _interopRequireWildcard(_irSearchActionTypes);
	
	var _utils = __webpack_require__(33);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialStateValue = {
	  status: '',
	  favoriteEmail: {
	    status: 'loading',
	    email: ''
	  },
	  favoriteEmails: {
	    status: 'loading',
	    emails: [],
	    lastRecipients: []
	  },
	  popup: {
	    name: null,
	    show: false,
	    data: {}
	  },
	  docketParts: {
	    step: 0,
	    purchased: 0,
	    partsToPurchase: 0,
	    totalCost: 0,
	    parts: 0,
	    percentage: 0,
	    status: 'loading',
	    errors: null,
	    alreadyPurchased: false
	  },
	  selectedDocket: {
	    status: null,
	    seqNum: null,
	    docket_no: null,
	    binder: {
	      // documents: [],
	    }
	  },
	  documentsList: [],
	  redact: {
	    showFlash: false,
	    seqNum: null,
	    showPopup: false
	  },
	  entries: {
	    // empty | loading | error
	    status: '',
	    data: []
	  },
	  receipt: {},
	  header: {
	    status: ''
	  }
	};
	
	var initialState = _immutable2.default.fromJS(initialStateValue);
	
	exports.default = (0, _utils.createReducer)(initialState, (_createReducer = {}, _createReducer[types.DOCKETS_POPUP] = function (state, action) {
	  var popup = action.popup;
	
	  return state.merge({ popup: popup });
	}, _createReducer[types.DOCKETS_FAVORITE_EMAIL] = function (state, action) {
	  var favoriteEmail = action.favoriteEmail;
	
	  return state.mergeDeep({ favoriteEmail: favoriteEmail });
	}, _createReducer[types.DOCKETS_FAVORITE_EMAILS] = function (state, action) {
	  var favoriteEmails = action.favoriteEmails;
	
	  return state.set('favoriteEmails', _extends({}, state.get('favoriteEmails'), favoriteEmails));
	}, _createReducer[types.UPDATE_DOCKETS_PARTS] = function (state, action) {
	  var docketParts = action.docketParts;
	
	  return state.mergeDeep({ docketParts: docketParts });
	}, _createReducer[types.RESET_DOCKETS_PARTS] = function (state) {
	  var docketParts = initialStateValue.docketParts;
	
	  return state.merge({ docketParts: docketParts });
	}, _createReducer[types.UPDATE_DOCKET_HEADER] = function (state, action) {
	  var docketHeader = action.docketHeader;
	
	  return state.mergeDeep({ docketHeader: docketHeader });
	}, _createReducer[irSearchTypes.REQUEST_DOCKET_PARTS] = function (state, action) {
	  var step = action.step || 1;
	  var pdfZip = { status: 'loading', step: step };
	  return initialState.mergeDeep({ pdfZip: pdfZip });
	}, _createReducer[irSearchTypes.RECEIVE_DOCKET_PARTS] = function (state, action) {
	  var pdfZip = _extends({}, action.data, { isLoading: false });
	  return state.mergeDeep({ pdfZip: pdfZip });
	}, _createReducer[types.UPDATE_REDACT] = function (state, action) {
	  var redact = action.redact;
	
	  return state.mergeDeep({ redact: redact });
	}, _createReducer[types.FETCH_DOCUMENTS.REQUEST] = function (state, _ref) {
	  var selectedDocket = _ref.selectedDocket;
	  return state.set('selectedDocket', initialState.get('selectedDocket').merge(selectedDocket));
	}, _createReducer[types.FETCH_DOCUMENTS.ERROR] = function (state, _ref2) {
	  var selectedDocket = _ref2.selectedDocket;
	  return state.getIn(['selectedDocket', 'docket_seq']) === selectedDocket.docket_seq ? state.set('selectedDocket', initialState.get('selectedDocket').merge(selectedDocket)) : state;
	}, _createReducer[types.FETCH_DOCUMENTS.SUCCESS] = function (state, _ref3) {
	  var selectedDocket = _ref3.selectedDocket;
	
	  var docketIndex = state.getIn(['entries', 'data']).findIndex(function (doc) {
	    return doc.get('docket_seq') === selectedDocket.docket_seq;
	  });
	
	  var updatedDocket = docketIndex >= 0 ? state.getIn(['entries', 'data', docketIndex]).merge(_extends({}, selectedDocket)) : _immutable2.default.fromJS(selectedDocket);
	
	  if (state.getIn(['selectedDocket', 'docket_seq']) === selectedDocket.docket_seq) {
	    return state.set('selectedDocket', updatedDocket).setIn(['entries', 'data', docketIndex], updatedDocket);
	  }
	
	  return state.setIn(['entries', 'data', docketIndex], updatedDocket);
	}, _createReducer[types.UPDATE_DOCUMENT] = function (state, _ref4) {
	  var seqNum = _ref4.seqNum,
	      document = _ref4.document;
	
	  var docketIndex = state.getIn(['entries', 'data']).findIndex(function (doc) {
	    return doc.get('docket_seq') === seqNum;
	  });
	  var previousDocket = state.getIn(['entries', 'data', docketIndex]);
	  var documentIndex = previousDocket.getIn(['binder', 'documents']).findIndex(function (doc) {
	    return doc.get('number') === document.number;
	  });
	  var updatedDocket = previousDocket.mergeIn(['binder', 'documents', documentIndex], _immutable2.default.fromJS(document));
	
	  if (state.getIn(['selectedDocket', 'docket_seq']) === seqNum) {
	    return state.set('selectedDocket', updatedDocket).setIn(['entries', 'data', docketIndex], updatedDocket);
	  }
	
	  return state.setIn(['entries', 'data', docketIndex], updatedDocket);
	}, _createReducer[types.UPDATE_SELECTED_DOCKET] = function (state, _ref5) {
	  var selectedDocket = _ref5.selectedDocket;
	  return state.set('selectedDocket', _immutable2.default.fromJS(selectedDocket));
	}, _createReducer[types.UPDATE_DOCKETS] = function (state, action) {
	  // note we don't want mergeDeep here because it will "merge" any new array data, instead of replacing them
	  return state.merge(_extends({}, action));
	}, _createReducer[types.SET_RECEIPT] = function (state, _ref6) {
	  var receipt = _ref6.receipt;
	  return state.set('receipt', _immutable2.default.fromJS(receipt));
	}, _createReducer.SERVICE_ERROR = function SERVICE_ERROR(state, action) {
	  return state.mergeDeep({ data_ready: true, error: action.errors });
	}, _createReducer));

/***/ },
/* 1231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReducer;
	
	var _immutable = __webpack_require__(30);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _historyTypes = __webpack_require__(718);
	
	var types = _interopRequireWildcard(_historyTypes);
	
	var _utils = __webpack_require__(33);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialStateValue = {
	  data_ready: false,
	  data: [],
	  receipt: {},
	  lastUpdated: '',
	  error: {}
	};
	
	var initialState = _immutable2.default.fromJS(initialStateValue);
	
	exports.default = (0, _utils.createReducer)(initialState, (_createReducer = {}, _createReducer[types.REQUEST_HISTORY_DATA] = function (state) {
	  return state.merge(initialStateValue);
	}, _createReducer[types.REQUEST_FILTER_HISTORY_DATA] = function (state) {
	  return state;
	}, _createReducer[types.RECEIVE_HISTORY_DATA] = function (state, action) {
	  return state.mergeDeep({
	    data_ready: true,
	    data: action.data,
	    lastUpdated: action.lastUpdated,
	    receipt: action.receipt
	  });
	}, _createReducer[types.SERVICE_ERROR] = function (state, action) {
	  return state.mergeDeep({ data_ready: true, error: action.error });
	}, _createReducer));

/***/ },
/* 1232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(33);
	
	var initialState = false;
	
	exports.default = (0, _utils.createReducer)(initialState, {
	  REQUEST_VIEW_SEARCH: function REQUEST_VIEW_SEARCH() {
	    return false;
	  },
	  REQUEST_BANKRUPTCY_SEARCH: function REQUEST_BANKRUPTCY_SEARCH() {
	    return false;
	  },
	  REQUEST_BANKRUPTCY_LOCAL_SEARCH: function REQUEST_BANKRUPTCY_LOCAL_SEARCH() {
	    return false;
	  },
	  REQUEST_APPELLATE_SEARCH: function REQUEST_APPELLATE_SEARCH() {
	    return false;
	  },
	  REQUEST_CIVIL_SEARCH: function REQUEST_CIVIL_SEARCH() {
	    return false;
	  },
	  REQUEST_CRIMINAL_SEARCH: function REQUEST_CRIMINAL_SEARCH() {
	    return false;
	  }
	});

/***/ },
/* 1233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReducer;
	
	var _immutable = __webpack_require__(30);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _apiCallsActionTypes = __webpack_require__(713);
	
	var types = _interopRequireWildcard(_apiCallsActionTypes);
	
	var _utils = __webpack_require__(33);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialStateValue = {
	  data_ready: false,
	  usage: [],
	  periods: [],
	  status: '',
	  error: {}
	};
	
	var initialState = _immutable2.default.fromJS(initialStateValue);
	
	exports.default = (0, _utils.createReducer)(initialState, (_createReducer = {}, _createReducer[types.REQUEST_API_CALLS_DETAILS] = function (state) {
	  return state.merge(initialStateValue);
	}, _createReducer[types.RECEIVE_API_CALLS_DETAILS] = function (state, action) {
	  return state.mergeDeep({
	    data_ready: true,
	    usage: action.usage,
	    periods: action.periods,
	    status: action.status,
	    receipt: action.receipt
	  });
	}, _createReducer[types.REQUEST_API_CALLS_SUMMARY] = function (state) {
	  return state.merge(initialStateValue);
	}, _createReducer[types.RECEIVE_API_CALLS_SUMMARY] = function (state, action) {
	  return state.mergeDeep({
	    data_ready: true,
	    usage: action.usage,
	    periods: action.periods,
	    status: action.status,
	    receipt: action.receipt
	  });
	}, _createReducer[types.SERVICE_ERROR] = function (state, action) {
	  return state.mergeDeep({ data_ready: true, error: action.error });
	}, _createReducer));

/***/ },
/* 1234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReducer;
	
	var _immutable = __webpack_require__(30);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _utils = __webpack_require__(33);
	
	var _irSearchActionTypes = __webpack_require__(138);
	
	var types = _interopRequireWildcard(_irSearchActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialStateValue = {
	  data_ready: false,
	  data: [],
	  receipt: {},
	  lastUpdated: '',
	  error: {}
	};
	
	var initialState = _immutable2.default.fromJS(initialStateValue);
	
	exports.default = (0, _utils.createReducer)(initialState, (_createReducer = {}, _createReducer[types.REQUEST_CASE_DATA] = function (state) {
	  return state.mergeDeep(initialStateValue);
	}, _createReducer[types.RECEIVE_CASE_DATA] = function (state, action) {
	  var s = state.set('data', []).mergeDeep({
	    data_ready: true,
	    data: action.data,
	    lastUpdated: action.lastUpdated,
	    receipt: action.receipt
	  });
	  return s;
	}, _createReducer[types.SERVICE_ERROR] = function (state, action) {
	  return state.mergeDeep({ data_ready: true, error: action.errors });
	}, _createReducer));

/***/ },
/* 1235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReducer;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _utils = __webpack_require__(33);
	
	var _integrationsConnectionActions = __webpack_require__(46);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  results: [],
	  isLoading: false,
	  errorMessage: null,
	  agreedToPricing: false
	};
	
	exports.default = (0, _utils.createReducer)(initialState, (_createReducer = {}, _createReducer[_integrationsConnectionActions.actionTypes.REQUEST_CONNECTIONS] = function (state) {
	  var next = { errorMessage: null, isLoading: true };
	  return Object.assign({}, state, next);
	}, _createReducer[_integrationsConnectionActions.actionTypes.RECEIVE_CONNECTIONS] = function (state, action) {
	  var next = { results: action.results, isLoading: false };
	  return Object.assign({}, state, next);
	}, _createReducer[_integrationsConnectionActions.actionTypes.REQUEST_CONNECTION] = function (state) {
	  var next = { errorMessage: null, isLoading: true };
	  return Object.assign({}, state, next);
	}, _createReducer[_integrationsConnectionActions.actionTypes.RECEIVE_CONNECTION] = function (state, action) {
	  var next = {
	    results: state.results.concat(action.results),
	    isLoading: false
	  };
	  return Object.assign({}, state, next);
	}, _createReducer[_integrationsConnectionActions.actionTypes.REQUEST_DISCONNECTION] = function (state) {
	  var next = { errorMessage: null, isLoading: true };
	  return Object.assign({}, state, next);
	}, _createReducer[_integrationsConnectionActions.actionTypes.RECEIVE_DISCONNECTION] = function (state, action) {
	  var results = state.results.filter(function (p) {
	    return p.connectionId !== action.connectionId;
	  });
	  var next = {
	    results: results,
	    isLoading: false
	  };
	  return Object.assign({}, state, next);
	}, _createReducer[_integrationsConnectionActions.actionTypes.UPDATE_CONNECTION] = function (state, _ref) {
	  var connectionId = _ref.connectionId,
	      updates = _ref.updates;
	
	  var results = state.results.map(function (item) {
	    if (item.connectionId !== connectionId) return item;
	
	    // Otherwise this is the one we are interested in. Update it.
	    return _extends({}, item, updates);
	  });
	
	  return _extends({}, state, { results: results });
	}, _createReducer[_integrationsConnectionActions.actionTypes.UPDATE_PRICING] = function (state, action) {
	  var next = { agreedToPricing: action.agreedToPricing };
	  return Object.assign({}, state, next);
	}, _createReducer[_integrationsConnectionActions.actionTypes.SERVICE_ERROR] = function (state, action) {
	  var next = { errorMessage: action.errorMessage, isLoading: false };
	  return Object.assign({}, state, next);
	}, _createReducer[_integrationsConnectionActions.actionTypes.REQUEST_FILENAME_TEMPLATE] = function (state) {
	  var next = _extends({}, state.filenameTemplate, { isLoading: true, errorMessage: null });
	  var nextState = _extends({}, state, { filenameTemplate: next });
	  return Object.assign({}, state, nextState);
	}, _createReducer[_integrationsConnectionActions.actionTypes.RECEIVE_FILENAME_TEMPLATE] = function (state, _ref2) {
	  var connectionId = _ref2.connectionId,
	      updates = _ref2.updates;
	
	  var results = state.results.map(function (connection) {
	    if (connection.connectionId != connectionId) return connection;
	
	    return _lodash2.default.merge({}, connection, {
	      filenameSettings: { filenameTemplate: updates }
	    });
	  });
	
	  return _extends({}, state, { results: results });
	}, _createReducer[_integrationsConnectionActions.actionTypes.FILENAME_TEMPLATE_ERROR] = function (state, action) {
	  var errorMessage = action.errorMessage;
	
	  var next = _extends({}, state.filenameTemplate, { errorMessage: errorMessage, isLoading: false });
	  var nextState = _extends({}, state, { filenameTemplate: next });
	  return Object.assign({}, state, nextState);
	}, _createReducer));

/***/ },
/* 1236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(33);
	
	var initState = false;
	
	exports.default = (0, _utils.createReducer)(initState, {
	  RECEIVE_SEARCH_RESULTS: function RECEIVE_SEARCH_RESULTS() {
	    return initState;
	  },
	  RECEIVE_CASE_DATA_OF_CASE_LOOKUP: function RECEIVE_CASE_DATA_OF_CASE_LOOKUP() {
	    return initState;
	  },
	  RESET_SEARCH_RESULTS: function RESET_SEARCH_RESULTS() {
	    return initState;
	  },
	  UPDATE_FILTERS: function UPDATE_FILTERS() {
	    return initState;
	  },
	  RESET_FILTERS: function RESET_FILTERS() {
	    return initState;
	  },
	  REQUEST_CASE_DATA_OF_CASE_LOOKUP: function REQUEST_CASE_DATA_OF_CASE_LOOKUP() {
	    return true;
	  },
	  RECEIVE_CASE_DATA: function RECEIVE_CASE_DATA() {
	    return initState;
	  },
	  REQUEST_CASE_DATA: function REQUEST_CASE_DATA() {
	    return true;
	  },
	  REQUEST_VIEW_SEARCH: function REQUEST_VIEW_SEARCH() {
	    return true;
	  },
	  REQUEST_BANKRUPTCY_SEARCH: function REQUEST_BANKRUPTCY_SEARCH() {
	    return true;
	  },
	  REQUEST_BANKRUPTCY_LOCAL_SEARCH: function REQUEST_BANKRUPTCY_LOCAL_SEARCH() {
	    return true;
	  },
	  REQUEST_APPELLATE_SEARCH: function REQUEST_APPELLATE_SEARCH() {
	    return true;
	  },
	  REQUEST_CIVIL_SEARCH: function REQUEST_CIVIL_SEARCH() {
	    return true;
	  },
	  REQUEST_CRIMINAL_SEARCH: function REQUEST_CRIMINAL_SEARCH() {
	    return true;
	  },
	  VALIDATION_ERROR: function VALIDATION_ERROR() {
	    return false;
	  },
	  SERVICE_ERROR: function SERVICE_ERROR() {
	    return false;
	  }
	});

/***/ },
/* 1237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReducer;
	
	var _lodash = __webpack_require__(4);
	
	var _immutable = __webpack_require__(30);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _utils = __webpack_require__(33);
	
	var _localCourtSearchActionTypes = __webpack_require__(719);
	
	var actionTypes = _interopRequireWildcard(_localCourtSearchActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = Immutable.fromJS({
	  data: [],
	  receipts: [],
	  error: null,
	  isLoading: false,
	  searchResultsType: null,
	  searchType: null
	});
	
	exports.default = (0, _utils.createReducer)(initialState, (_createReducer = {}, _createReducer[actionTypes.LOCAL_COURT_SEARCH_BANKRUPTCY.REQUEST] = function (state) {
	  return state.merge(Immutable.fromJS({ isLoading: true }));
	}, _createReducer[actionTypes.LOCAL_COURT_SEARCH_BANKRUPTCY.ERROR] = function (state, _ref) {
	  var error = _ref.error;
	  return state.merge(Immutable.fromJS({ error: error, isLoading: false }));
	}, _createReducer[actionTypes.LOCAL_COURT_SEARCH_BANKRUPTCY.SUCCESS] = function (state, action) {
	  var data = [];
	  var searchResultsType = 'empty';
	
	  if (!(0, _lodash.isEmpty)(action.searchResults.cases)) {
	    // result type cases
	    data = action.searchResults.cases;
	    searchResultsType = 'cases';
	  } else if (!(0, _lodash.isEmpty)(action.searchResults.parties)) {
	    // result type parties
	    data = action.searchResults.parties;
	    searchResultsType = 'parties';
	  }
	
	  return state.merge({
	    searchResultsType: searchResultsType,
	    searchType: 'Bankruptcy',
	    data: data,
	    receipts: action.searchResults.receipts || [],
	    isLoading: false
	  });
	}, _createReducer[actionTypes.LOCAL_COURT_SEARCH_DISTRICT.REQUEST] = function (state) {
	  return state.merge(Immutable.fromJS({ isLoading: true }));
	}, _createReducer[actionTypes.LOCAL_COURT_SEARCH_DISTRICT.ERROR] = function (state, _ref2) {
	  var error = _ref2.error;
	  return state.merge(Immutable.fromJS({ error: error, isLoading: false }));
	}, _createReducer[actionTypes.LOCAL_COURT_SEARCH_DISTRICT.SUCCESS] = function (state, action) {
	  var data = [];
	  var searchResultsType = 'empty';
	
	  if (!(0, _lodash.isEmpty)(action.searchResults.cases)) {
	    // result type cases
	    data = action.searchResults.cases;
	    searchResultsType = 'cases';
	  } else if (!(0, _lodash.isEmpty)(action.searchResults.parties)) {
	    // result type parties
	    data = action.searchResults.parties;
	    searchResultsType = 'parties';
	  }
	
	  return state.merge({
	    searchResultsType: searchResultsType,
	    searchType: 'Civil',
	    data: data,
	    receipts: action.searchResults.receipts || [],
	    isLoading: false
	  });
	}, _createReducer[actionTypes.LOCAL_COURT_SEARCH_APPELLATE.REQUEST] = function (state) {
	  return state.merge(Immutable.fromJS({ isLoading: true }));
	}, _createReducer[actionTypes.LOCAL_COURT_SEARCH_APPELLATE.ERROR] = function (state, _ref3) {
	  var error = _ref3.error;
	  return state.merge(Immutable.fromJS({ error: error, isLoading: false }));
	}, _createReducer[actionTypes.LOCAL_COURT_SEARCH_APPELLATE.SUCCESS] = function (state, action) {
	  var data = [];
	  var searchResultsType = 'empty';
	
	  if (!(0, _lodash.isEmpty)(action.searchResults.cases)) {
	    // result type cases
	    data = action.searchResults.cases;
	    searchResultsType = 'cases';
	  } else if (!(0, _lodash.isEmpty)(action.searchResults.parties)) {
	    // result type parties
	    data = action.searchResults.parties;
	    searchResultsType = 'parties';
	  }
	
	  return state.merge({
	    searchResultsType: searchResultsType,
	    searchType: 'Appellate',
	    data: data,
	    receipts: action.searchResults.receipts || [],
	    isLoading: false
	  });
	}, _createReducer[actionTypes.LOCAL_COURT_SEARCH_RESET] = function () {
	  return initialState;
	}, _createReducer));

/***/ },
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReducer;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _immutable = __webpack_require__(30);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _tableMapper = __webpack_require__(1201);
	
	var _tableMapper2 = _interopRequireDefault(_tableMapper);
	
	var _utils = __webpack_require__(33);
	
	var _pacerSearchActionTypes = __webpack_require__(720);
	
	var types = _interopRequireWildcard(_pacerSearchActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function parsePageUrl(url) {
	  var splitPage = url.split('page=');
	
	  if (splitPage && splitPage.length > 1) {
	    return splitPage[1].split('&')[0];
	  }
	
	  return null;
	}
	
	function mapSearchOptions(searchOptions) {
	  var pages = _lodash2.default.map(searchOptions.pages, function (url, key) {
	    if (key === 'next') {
	      return {
	        page: 'Next',
	        nextPage: parsePageUrl(url)
	      };
	    }
	    if (key === 'previous') {
	      return {
	        page: 'Previous',
	        nextPage: parsePageUrl(url)
	      };
	    }
	
	    return {
	      page: parseInt(key, 10),
	      url: url,
	      active: _lodash2.default.isEmpty(url)
	    };
	  });
	
	  return Object.assign({}, searchOptions, { pages: _lodash2.default.sortBy(pages, 'page') });
	}
	
	var initPacerSearchResults = _immutable2.default.fromJS({
	  data: [],
	  receipts: [],
	  searchOptions: {},
	  filters: {
	    case_type: 'Bankruptcy',
	
	    court_id: null,
	    case_no: null,
	    case_title: null,
	    chapter: null,
	    filed_from: null,
	    filed_to: null,
	    closed_from: null,
	    closed_to: null,
	    dismissed_from: null,
	    dismissed_to: null,
	    discharged_from: null,
	    discharged_to: null,
	    nos: null,
	    ssn4: null,
	    ssntin: null,
	
	    party_name: null,
	    last_business_name: null,
	    middle_name: null,
	    first_name: null
	  }
	});
	
	exports.default = (0, _utils.createReducer)(initPacerSearchResults, (_createReducer = {}, _createReducer[types.RECEIVE_SEARCH_RESULTS] = function (state, action) {
	  var headerFields = [];
	  var data = [];
	  var searchResultsType = 'empty';
	  var searchType = state.get('searchType');
	
	  if (!_lodash2.default.isEmpty(action.searchResults.cases)) {
	    // result type cases
	    data = action.searchResults.cases;
	    headerFields = _tableMapper2.default[searchType].casesHeaderFields;
	    searchResultsType = 'cases';
	  } else if (!_lodash2.default.isEmpty(action.searchResults.parties)) {
	    // result type parties
	    data = action.searchResults.parties;
	    headerFields = _tableMapper2.default[searchType].partiesHeaderFields;
	    searchResultsType = 'parties';
	  }
	
	  return state.merge({
	    searchResultsType: searchResultsType,
	    data: data,
	    headerFields: headerFields,
	    receipts: attach_source_id_to_receipts(action.searchResults.receipts, action.source_data_id),
	    searchOptions: mapSearchOptions(action.searchOptions)
	  });
	}, _createReducer[types.RESET_SEARCH_RESULTS] = function () {
	  return initPacerSearchResults;
	}, _createReducer[types.UPDATE_FILTER] = function (state, action) {
	  return state.mergeDeep({ filters: action.filter });
	}, _createReducer[types.RESET_FILTERS] = function () {
	  return initPacerSearchResults;
	}, _createReducer[types.REQUEST_VIEW_SEARCH] = function (state) {
	  return state;
	}, _createReducer[types.REQUEST_BANKRUPTCY_SEARCH] = function (state) {
	  return initPacerSearchResults.mergeDeep({
	    filters: state.get('filters'),
	    searchType: 'Bankruptcy',
	    query_type: 'search'
	  });
	}, _createReducer[types.REQUEST_BANKRUPTCY_LOCAL_SEARCH] = function (state) {
	  return initPacerSearchResults.mergeDeep({
	    filters: state.get('filters'),
	    searchType: 'Bankruptcy',
	    query_type: 'search'
	  });
	}, _createReducer[types.REQUEST_CIVIL_SEARCH] = function (state) {
	  return initPacerSearchResults.mergeDeep({
	    filters: state.get('filters'),
	    searchType: 'Civil',
	    query_type: 'search_cv'
	  });
	}, _createReducer[types.REQUEST_CRIMINAL_SEARCH] = function (state) {
	  return initPacerSearchResults.mergeDeep({
	    filters: state.get('filters'),
	    searchType: 'Criminal',
	    query_type: 'search_cr'
	  });
	}, _createReducer[types.REQUEST_APPELLATE_SEARCH] = function (state) {
	  return initPacerSearchResults.mergeDeep({
	    filters: state.get('filters'),
	    searchType: 'Appellate',
	    query_type: 'search_appellate'
	  });
	}, _createReducer));
	
	
	function attach_source_id_to_receipts(receipts, source_data_id) {
	  if (!receipts) return [];
	
	  try {
	    receipts[0].text.source_data_id = source_data_id;
	  } catch (and_ignore_errors) {}
	
	  return receipts;
	}

/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReducer;
	
	var _immutable = __webpack_require__(30);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _relatedTransactionActionTypes = __webpack_require__(721);
	
	var types = _interopRequireWildcard(_relatedTransactionActionTypes);
	
	var _utils = __webpack_require__(33);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialStateValue = {
	  data_ready: false,
	  data: [],
	  receipt: {},
	  lastUpdated: '',
	  error: {}
	};
	
	var initialState = _immutable2.default.fromJS(initialStateValue);
	
	exports.default = (0, _utils.createReducer)(initialState, (_createReducer = {}, _createReducer[types.REQUEST_RELATED_TRANSACTION_DATA] = function (state) {
	  return state.merge(initialStateValue);
	}, _createReducer[types.RECEIVE__RELATED_TRANSACTION_DATA] = function (state, action) {
	  return state.mergeDeep({
	    data_ready: true,
	    data: action.data,
	    lastUpdated: action.lastUpdated,
	    receipt: action.receipt
	  });
	}, _createReducer[types.SERVICE_ERROR] = function (state, action) {
	  return state.mergeDeep({ data_ready: true, error: action.error });
	}, _createReducer));

/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReducer;
	
	var _immutable = __webpack_require__(30);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _utils = __webpack_require__(33);
	
	var _reportsTabActionTypes = __webpack_require__(722);
	
	var types = _interopRequireWildcard(_reportsTabActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initState = _immutable2.default.fromJS({
	  reports: [],
	  receipts: [],
	  isReportsDataReady: null,
	  isAutoMateMailingReady: null,
	  isReportsDataErrorOccurred: false,
	  isAutoMateMailingReadyErrorOccurred: false,
	  errorMessage: null,
	  automateMailing: {
	    isLoading: false
	  }
	});
	
	exports.default = (0, _utils.createReducer)(initState, (_createReducer = {
	
	  SERVER_ERROR: function SERVER_ERROR(state, action) {
	    return state.mergeDeep({
	      isReportsDataErrorOccurred: true,
	      isReportsDataReady: true,
	      errorMessage: action.error,
	      automateMailing: {
	        isLoading: false
	      }
	    });
	  }
	
	}, _createReducer[types.RECEIVE_REPORTS] = function (state, action) {
	  var resBody = action.resBody;
	
	
	  return state.merge({
	    reports: resBody.data,
	    csvDownloadLink: resBody.csv_download_link,
	    csvDownloadUrl: resBody.csv_download_files_url,
	    receipts: resBody.receipts,
	    isReportsDataReady: true
	  });
	}, _createReducer[types.REQUEST_REPORTS] = function (state) {
	  return state.merge({
	    isReportsDataErrorOccurred: false,
	    isReportsDataReady: false,
	    isAutoMateMailingReadyErrorOccurred: false,
	    isAutoMateMailingReady: false,
	    isReportDataReceived: false
	  });
	}, _createReducer[types.REQUEST_AUTOMATE_MAILING_REPORTS] = function (state) {
	  return state.mergeDeep({
	    isAutoMateMailingReady: false,
	    automateMailing: {
	      isLoading: true
	    }
	  });
	}, _createReducer[types.RECEIVE_AUTOMATE_MAILING_REPORTS] = function (state, action) {
	  var error = action.resBody.error;
	
	
	  return state.mergeDeep({
	    isAutoMateMailingReady: true,
	    isAutoMateMailingReadyErrorOccurred: !!error,
	    errorMessage: error,
	    automateMailing: {
	      isLoading: false
	    }
	  });
	}, _createReducer));

/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reduxImmutable = __webpack_require__(2124);
	
	var _reactRouterRedux = __webpack_require__(519);
	
	var _pacerSearchResults = __webpack_require__(1238);
	
	var _pacerSearchResults2 = _interopRequireDefault(_pacerSearchResults);
	
	var _caseLookupSearchReducer = __webpack_require__(272);
	
	var _caseLookupSearchReducer2 = _interopRequireDefault(_caseLookupSearchReducer);
	
	var _reportsTabReducer = __webpack_require__(1240);
	
	var _reportsTabReducer2 = _interopRequireDefault(_reportsTabReducer);
	
	var _searchErrors = __webpack_require__(1243);
	
	var _searchErrors2 = _interopRequireDefault(_searchErrors);
	
	var _validationErrors = __webpack_require__(1246);
	
	var _validationErrors2 = _interopRequireDefault(_validationErrors);
	
	var _loadingSpinner = __webpack_require__(1236);
	
	var _loadingSpinner2 = _interopRequireDefault(_loadingSpinner);
	
	var _user = __webpack_require__(1245);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _immediateSearch = __webpack_require__(1232);
	
	var _immediateSearch2 = _interopRequireDefault(_immediateSearch);
	
	var _sidebarReducer = __webpack_require__(1244);
	
	var _sidebarReducer2 = _interopRequireDefault(_sidebarReducer);
	
	var _kloudlessReducer = __webpack_require__(1235);
	
	var _kloudlessReducer2 = _interopRequireDefault(_kloudlessReducer);
	
	var _irSearchReducer = __webpack_require__(1234);
	
	var _irSearchReducer2 = _interopRequireDefault(_irSearchReducer);
	
	var _integrationsReducer = __webpack_require__(1233);
	
	var _integrationsReducer2 = _interopRequireDefault(_integrationsReducer);
	
	var _docketReducer = __webpack_require__(1230);
	
	var _docketReducer2 = _interopRequireDefault(_docketReducer);
	
	var _historyReducer = __webpack_require__(1231);
	
	var _historyReducer2 = _interopRequireDefault(_historyReducer);
	
	var _searchAlertsReducer = __webpack_require__(1242);
	
	var _clientCodeReducer = __webpack_require__(1228);
	
	var _clientCodeReducer2 = _interopRequireDefault(_clientCodeReducer);
	
	var _creditorMailingReducer = __webpack_require__(1229);
	
	var _creditorMailingReducer2 = _interopRequireDefault(_creditorMailingReducer);
	
	var _localCourtSearchReducer = __webpack_require__(1237);
	
	var _localCourtSearchReducer2 = _interopRequireDefault(_localCourtSearchReducer);
	
	var _advancedSearchReducer = __webpack_require__(1226);
	
	var _advancedSearchReducer2 = _interopRequireDefault(_advancedSearchReducer);
	
	var _relatedTransactionReducer = __webpack_require__(1239);
	
	var _relatedTransactionReducer2 = _interopRequireDefault(_relatedTransactionReducer);
	
	var _claimDocumentsReducer = __webpack_require__(1227);
	
	var _claimDocumentsReducer2 = _interopRequireDefault(_claimDocumentsReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _reduxImmutable.combineReducers)({
	  routerReducer: _reactRouterRedux.routerReducer,
	  pacerSearchResults: _pacerSearchResults2.default,
	  caseLookupSearchReducer: _caseLookupSearchReducer2.default,
	  reportsTabReducer: _reportsTabReducer2.default,
	  searchErrors: _searchErrors2.default,
	  validationErrors: _validationErrors2.default,
	  loadingSpinner: _loadingSpinner2.default,
	  user: _user2.default,
	  irSearch: _irSearchReducer2.default,
	  immediateSearch: _immediateSearch2.default,
	  sidebarData: _sidebarReducer2.default,
	  kloudless: _kloudlessReducer2.default,
	  integrations: _integrationsReducer2.default,
	  clientCodeReducer: _clientCodeReducer2.default,
	  dockets: _docketReducer2.default,
	  history: _historyReducer2.default,
	  automatedReports: _searchAlertsReducer.automatedReports,
	  templateAlerts: _searchAlertsReducer.templateAlerts,
	  customAlerts: _searchAlertsReducer.customAlerts,
	  creditorMailing: _creditorMailingReducer2.default,
	  localCourtSearch: _localCourtSearchReducer2.default,
	  advancedSearch: _advancedSearchReducer2.default,
	  relatedTransactions: _relatedTransactionReducer2.default,
	  claimDocuments: _claimDocumentsReducer2.default
	});

/***/ },
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.customAlerts = exports.templateAlerts = exports.automatedReports = undefined;
	
	var _createReducer, _createReducer2, _createReducer3;
	
	var _immutable = __webpack_require__(30);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _utils = __webpack_require__(33);
	
	var _searchAlertsActionTypes = __webpack_require__(723);
	
	var actionTypes = _interopRequireWildcard(_searchAlertsActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.fromJS({
	  alerts: [],
	  error: null,
	  isLoading: false
	});
	
	var automatedReports = exports.automatedReports = (0, _utils.createReducer)(initialState, (_createReducer = {}, _createReducer[actionTypes.AUTOMATED_REPORTS.REQUEST] = function (state) {
	  return state.merge(_immutable2.default.fromJS({
	    isLoading: true
	  }));
	}, _createReducer[actionTypes.AUTOMATED_REPORTS.SUCCESS] = function (state, _ref) {
	  var data = _ref.data;
	  return state.merge(_immutable2.default.fromJS({
	    alerts: data.alerts,
	    isLoading: false
	  }));
	}, _createReducer[actionTypes.AUTOMATED_REPORTS.ERROR] = function (state, _ref2) {
	  var error = _ref2.error;
	  return state.merge(_immutable2.default.fromJS({
	    error: error,
	    isLoading: false
	  }));
	}, _createReducer[actionTypes.REMOVE_AUTOMATED_REPORT.REQUEST] = function (state, _ref3) {
	  var data = _ref3.data;
	
	  var alerts = state.get('alerts').map(function (alert) {
	    return alert.set('isBeingRemoved', alert.get('rtalert_cron_id') === data.id);
	  });
	
	  return state.set('alerts', alerts);
	}, _createReducer[actionTypes.REMOVE_AUTOMATED_REPORT.SUCCESS] = function (state) {
	  return state;
	}, _createReducer[actionTypes.REMOVE_AUTOMATED_REPORT.ERROR] = function (state, _ref4) {
	  var error = _ref4.error;
	  return state.merge(_immutable2.default.fromJS({
	    error: error
	  }));
	}, _createReducer));
	
	var templateAlerts = exports.templateAlerts = (0, _utils.createReducer)(initialState, (_createReducer2 = {}, _createReducer2[actionTypes.TEMPLATE_ALERTS.REQUEST] = function (state) {
	  return state.merge(_immutable2.default.fromJS({
	    isLoading: true
	  }));
	}, _createReducer2[actionTypes.TEMPLATE_ALERTS.SUCCESS] = function (state, _ref5) {
	  var data = _ref5.data;
	  return state.merge(_immutable2.default.fromJS({
	    alerts: data,
	    isLoading: false
	  }));
	}, _createReducer2[actionTypes.TEMPLATE_ALERTS.ERROR] = function (state, _ref6) {
	  var error = _ref6.error;
	  return state.merge(_immutable2.default.fromJS({
	    error: error,
	    isLoading: false
	  }));
	}, _createReducer2[actionTypes.UPDATE_TEMPLATE_ALERT.REQUEST] = function (state, _ref7) {
	  var _ref7$payload = _ref7.payload,
	      index = _ref7$payload.index,
	      name = _ref7$payload.name;
	  return state.setIn(['alerts', index, 'isUpdating', name], true);
	}, _createReducer2[actionTypes.UPDATE_TEMPLATE_ALERT.SUCCESS] = function (state, _ref8) {
	  var _ref8$payload = _ref8.payload,
	      index = _ref8$payload.index,
	      name = _ref8$payload.name,
	      value = _ref8$payload.value;
	  return state.setIn(['alerts', index, name], value).setIn(['alerts', index, 'isUpdating', name], false);
	}, _createReducer2[actionTypes.UPDATE_TEMPLATE_ALERT.ERROR] = function (state, _ref9) {
	  var error = _ref9.error,
	      _ref9$payload = _ref9.payload,
	      index = _ref9$payload.index,
	      name = _ref9$payload.name;
	  return state.merge(_immutable2.default.fromJS({ error: error })).setIn(['alerts', index, 'isUpdating', name], false);
	}, _createReducer2[actionTypes.RESEND_TEMPLATE_ALERT.REQUEST] = function (state, _ref10) {
	  var index = _ref10.payload.index;
	  return state.setIn(['alerts', index, 'isBeingResent'], true);
	}, _createReducer2[actionTypes.RESEND_TEMPLATE_ALERT.SUCCESS] = function (state, _ref11) {
	  var index = _ref11.payload.index;
	  return state.setIn(['alerts', index, 'isBeingResent'], false).setIn(['alerts', index, 'resend'], true);
	}, _createReducer2[actionTypes.RESEND_TEMPLATE_ALERT.ERROR] = function (state, _ref12) {
	  var error = _ref12.error,
	      index = _ref12.payload.index;
	  return state.merge(_immutable2.default.fromJS({ error: error })).setIn(['alerts', index, 'isBeingResent'], false);
	}, _createReducer2));
	
	var customAlertsInitialState = initialState.merge(_immutable2.default.fromJS({
	  deliveryLog: [],
	  deliveryLogLoading: false,
	  deliveryLogError: null
	}));
	
	var customAlerts = exports.customAlerts = (0, _utils.createReducer)(customAlertsInitialState, (_createReducer3 = {}, _createReducer3[actionTypes.CUSTOM_ALERTS.REQUEST] = function (state) {
	  return state.merge(_immutable2.default.fromJS({
	    isLoading: true
	  }));
	}, _createReducer3[actionTypes.CUSTOM_ALERTS.SUCCESS] = function (state, _ref13) {
	  var data = _ref13.data;
	  return state.merge(_immutable2.default.fromJS({
	    alerts: data,
	    isLoading: false
	  }));
	}, _createReducer3[actionTypes.CUSTOM_ALERTS.ERROR] = function (state, _ref14) {
	  var error = _ref14.error;
	  return state.merge(_immutable2.default.fromJS({
	    error: error,
	    isLoading: false
	  }));
	}, _createReducer3[actionTypes.UPDATE_CUSTOM_ALERT.REQUEST] = function (state, _ref15) {
	  var index = _ref15.payload.index;
	  return state.setIn(['alerts', index, 'isUpdating'], true);
	}, _createReducer3[actionTypes.UPDATE_CUSTOM_ALERT.SUCCESS] = function (state, _ref16) {
	  var _ref16$payload = _ref16.payload,
	      index = _ref16$payload.index,
	      alert = _ref16$payload.alert;
	  return state.setIn(['alerts', index], _immutable2.default.fromJS(alert));
	}, _createReducer3[actionTypes.UPDATE_CUSTOM_ALERT.ERROR] = function (state, _ref17) {
	  var error = _ref17.error,
	      index = _ref17.payload.index;
	  return state.merge(_immutable2.default.fromJS({ error: error })).setIn(['alerts', index, 'isUpdating'], false);
	}, _createReducer3[actionTypes.REMOVE_CUSTOM_ALERT.REQUEST] = function (state, _ref18) {
	  var index = _ref18.payload.index;
	  return state.setIn(['alerts', index, 'isBeingRemoved'], true);
	}, _createReducer3[actionTypes.REMOVE_CUSTOM_ALERT.SUCCESS] = function (state, _ref19) {
	  var index = _ref19.payload.index;
	  return state.deleteIn(['alerts', index]);
	}, _createReducer3[actionTypes.REMOVE_CUSTOM_ALERT.ERROR] = function (state, _ref20) {
	  var error = _ref20.error,
	      index = _ref20.payload.index;
	  return state.merge(_immutable2.default.fromJS({ error: error })).setIn(['alerts', index, 'isBeingRemoved'], false);
	}, _createReducer3[actionTypes.RESEND_CUSTOM_ALERT.REQUEST] = function (state, _ref21) {
	  var index = _ref21.payload.index;
	  return state.setIn(['alerts', index, 'isBeingResent'], true);
	}, _createReducer3[actionTypes.RESEND_CUSTOM_ALERT.SUCCESS] = function (state, _ref22) {
	  var index = _ref22.payload.index;
	  return state.setIn(['alerts', index, 'isBeingResent'], false).setIn(['alerts', index, 'resend'], true);
	}, _createReducer3[actionTypes.RESEND_CUSTOM_ALERT.ERROR] = function (state, _ref23) {
	  var error = _ref23.error,
	      index = _ref23.payload.index;
	  return state.merge(_immutable2.default.fromJS({ error: error })).setIn(['alerts', index, 'isBeingResent'], false);
	}, _createReducer3[actionTypes.DELIVERY_LOG.REQUEST] = function (state) {
	  return state.merge(_immutable2.default.fromJS({
	    deliveryLog: [],
	    deliveryLogLoading: true,
	    deliveryLogError: null
	  }));
	}, _createReducer3[actionTypes.DELIVERY_LOG.SUCCESS] = function (state, _ref24) {
	  var data = _ref24.data;
	  return state.merge(_immutable2.default.fromJS({
	    deliveryLog: data,
	    deliveryLogLoading: false,
	    deliveryLogError: null
	  }));
	}, _createReducer3[actionTypes.DELIVERY_LOG.ERROR] = function (state, _ref25) {
	  var error = _ref25.error;
	  return state.merge(_immutable2.default.fromJS({
	    deliveryLog: [],
	    deliveryLogLoading: false,
	    deliveryLogError: error
	  }));
	}, _createReducer3));

/***/ },
/* 1243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _immutable = __webpack_require__(30);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _utils = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialErrors = null;
	
	exports.default = (0, _utils.createReducer)(initialErrors, {
	  RESET_SEARCH_RESULTS: function RESET_SEARCH_RESULTS() {
	    return initialErrors;
	  },
	  UPDATE_FILTERS: function UPDATE_FILTERS() {
	    return initialErrors;
	  },
	  RESET_FILTERS: function RESET_FILTERS() {
	    return initialErrors;
	  },
	  REQUEST_VIEW_SEARCH: function REQUEST_VIEW_SEARCH() {
	    return initialErrors;
	  },
	  REQUEST_BANKRUPTCY_SEARCH: function REQUEST_BANKRUPTCY_SEARCH() {
	    return initialErrors;
	  },
	  REQUEST_BANKRUPTCY_LOCAL_SEARCH: function REQUEST_BANKRUPTCY_LOCAL_SEARCH() {
	    return initialErrors;
	  },
	  REQUEST_APPELLATE_SEARCH: function REQUEST_APPELLATE_SEARCH() {
	    return initialErrors;
	  },
	  REQUEST_CIVIL_SEARCH: function REQUEST_CIVIL_SEARCH() {
	    return initialErrors;
	  },
	  REQUEST_CRIMINAL_SEARCH: function REQUEST_CRIMINAL_SEARCH() {
	    return initialErrors;
	  },
	
	  REQUEST_CASE_DATA_OF_CASE_LOOKUP: function REQUEST_CASE_DATA_OF_CASE_LOOKUP() {
	    return initialErrors;
	  },
	
	  RESET_SERVICE_ERROR: function RESET_SERVICE_ERROR() {
	    return initialErrors;
	  },
	  SERVICE_ERROR: function SERVICE_ERROR(state, action) {
	    return _immutable2.default.fromJS(action.errors);
	  }
	});

/***/ },
/* 1244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReducer;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // import Immutable from 'immutable';
	
	
	var _utils = __webpack_require__(33);
	
	var _sidebarActions = __webpack_require__(728);
	
	var initSidebarData = {
	  status: ''
	};
	
	exports.default = (0, _utils.createReducer)(initSidebarData, (_createReducer = {}, _createReducer[_sidebarActions.actionTypes.SIDEBAR_DATA_REQUEST] = function (state, _ref) {
	  var data = _ref.data;
	  return _extends({}, state, data);
	}, _createReducer[_sidebarActions.actionTypes.SIDEBAR_DATA_SUCCESS] = function (state, _ref2) {
	  var data = _ref2.data;
	  return _extends({}, data);
	}, _createReducer[_sidebarActions.actionTypes.SIDEBAR_DATA_ERROR] = function (state, _ref3) {
	  var error = _ref3.error;
	  return { error: error };
	}, _createReducer));

/***/ },
/* 1245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _immutable = __webpack_require__(30);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _utils = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialUser = _immutable2.default.fromJS({
	  settings: {}
	});
	
	exports.default = (0, _utils.createReducer)(initialUser, {});

/***/ },
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _immutable = __webpack_require__(30);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _utils = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialErrors = null;
	
	exports.default = (0, _utils.createReducer)(initialErrors, {
	  RESET_SEARCH_RESULTS: function RESET_SEARCH_RESULTS() {
	    return initialErrors;
	  },
	  UPDATE_FILTERS: function UPDATE_FILTERS() {
	    return initialErrors;
	  },
	  RESET_FILTERS: function RESET_FILTERS() {
	    return initialErrors;
	  },
	  REQUEST_VIEW_SEARCH: function REQUEST_VIEW_SEARCH() {
	    return initialErrors;
	  },
	  REQUEST_BANKRUPTCY_SEARCH: function REQUEST_BANKRUPTCY_SEARCH() {
	    return initialErrors;
	  },
	  REQUEST_BANKRUPTCY_LOCAL_SEARCH: function REQUEST_BANKRUPTCY_LOCAL_SEARCH() {
	    return initialErrors;
	  },
	  REQUEST_APPELLATE_SEARCH: function REQUEST_APPELLATE_SEARCH() {
	    return initialErrors;
	  },
	  REQUEST_CIVIL_SEARCH: function REQUEST_CIVIL_SEARCH() {
	    return initialErrors;
	  },
	  REQUEST_CRIMINAL_SEARCH: function REQUEST_CRIMINAL_SEARCH() {
	    return initialErrors;
	  },
	
	  REQUEST_CASE_DATA_OF_CASE_LOOKUP: function REQUEST_CASE_DATA_OF_CASE_LOOKUP() {
	    return initialErrors;
	  },
	
	  RESET_VALIDATION_ERROR: function RESET_VALIDATION_ERROR() {
	    return initialErrors;
	  },
	  VALIDATION_ERROR: function VALIDATION_ERROR(state, action) {
	    return _immutable2.default.fromJS(action.errors);
	  }
	});

/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = RenderCount;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var size = 30;
	var style = {
	  position: 'absolute',
	  top: 0,
	  right: 0,
	  fontStyle: 'normal',
	  textAlign: 'center',
	  height: size + 'px',
	  width: size + 'px',
	  lineHeight: size + 'px',
	  borderRadius: size / 2 + 'px',
	  border: '1px solid #ddd',
	  background: '#eee'
	};
	
	function RenderCount() {
	  var renders = _react2.default.useRef(0);
	
	  return _react2.default.createElement(
	    'i',
	    { style: style },
	    ++renders.current
	  );
	}

/***/ },
/* 1248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (drupalParams) {
	  var case_uuid = drupalParams.case_uuid,
	      canEdit = drupalParams.canEdit,
	      can_see_details = drupalParams.can_see_details;
	
	  var _useDataApi = (0, _useDataApi3.default)('/ir-search/query-json?query=' + type + '&case_uuid=' + case_uuid, {}),
	      _useDataApi$ = _useDataApi[0],
	      data = _useDataApi$.data,
	      isLoading = _useDataApi$.isLoading,
	      isError = _useDataApi$.isError,
	      setData = _useDataApi[1].setData;
	
	  var _useState = (0, _react.useState)(false),
	      editScheduleForm = _useState[0],
	      setEditScheduleForm = _useState[1];
	
	  var _useState2 = (0, _react.useState)(false),
	      dataForSave = _useState2[0],
	      setDataForSave = _useState2[1];
	
	  var transformResponseToData = function transformResponseToData(response) {
	    var schedule = {};
	    var queries = Array.isArray(response.queries) ? _lodash2.default.get(response, 'queries[0].petition[0].text', []) : _lodash2.default.get(response, 'queries.petition[0].text', []);
	
	    var headers = Array.isArray(response.items) ? _lodash2.default.get(response, 'items[0].headers[0].text', []) : _lodash2.default.get(response, 'items.headers[0].text', []);
	    var _queries$data = queries.data,
	        responseData = _queries$data === undefined ? {} : _queries$data,
	        _queries$empty = queries.empty,
	        empty = _queries$empty === undefined ? null : _queries$empty;
	    var _headers$website = headers.website,
	        website = _headers$website === undefined ? '' : _headers$website,
	        _headers$assets = headers.assets,
	        estimated_assets = _headers$assets === undefined ? '' : _headers$assets,
	        _headers$ch11_type = headers.ch11_type,
	        ch11_type = _headers$ch11_type === undefined ? '' : _headers$ch11_type,
	        _headers$industry = headers.industry,
	        naics = _headers$industry === undefined ? '' : _headers$industry,
	        _headers$liabilities = headers.liabilities,
	        estimated_liabilities = _headers$liabilities === undefined ? '' : _headers$liabilities;
	
	    schedule = _extends({}, queries, {
	      data: responseData || {},
	      empty: empty,
	      header: { website: website, estimated_assets: estimated_assets, ch11_type: ch11_type, naics: naics, estimated_liabilities: estimated_liabilities }
	    });
	    return schedule;
	  };
	
	  var _usePostApi = (0, _usePostApi4.default)('/scheduleform/save'),
	      _usePostApi$ = _usePostApi[0],
	      savedScheduleResponse = _usePostApi$.data,
	      isLoadingSave = _usePostApi$.isLoading,
	      isSaveError = _usePostApi$.isError,
	      setPostData = _usePostApi[1];
	
	  var _usePostApi2 = (0, _usePostApi4.default)('/pacercaseeditor/save-summary'),
	      _usePostApi2$ = _usePostApi2[0],
	      savedSummaryResponse = _usePostApi2$.data,
	      isLoadingSummary = _usePostApi2$.isLoading,
	      isSummaryError = _usePostApi2$.isError,
	      setPostSummaryData = _usePostApi2[1];
	
	  (0, _react.useEffect)(function () {
	    if (savedScheduleResponse) setData(savedScheduleResponse.content);
	  }, [savedScheduleResponse]);
	
	  (0, _react.useEffect)(function () {
	    if (savedSummaryResponse) {
	      setPostData({
	        case_uuid: case_uuid,
	        type: type,
	        data: dataForSave
	      });
	      setEditScheduleForm(false);
	    }
	  }, [savedSummaryResponse]);
	
	  var saveScheduleForm = function saveScheduleForm(values) {
	    var statisticalSummary = {
	      assets: values.estimated_assets ? values.estimated_assets : 'Unknown',
	      case_uuid: case_uuid,
	      ch11_type: values.ch11_type ? values.ch11_type : '',
	      industry: values.naics ? values.naics : '',
	      liabilities: values.estimated_liabilities ? values.estimated_liabilities : 'Unknown',
	      website: values.website ? values.website : ''
	    };
	    // prettier-ignore
	    var formData = {
	      estimated_number_of_creditors: values.estimated_number_of_creditors || '',
	      describe_debtor_business: values.describe_debtor_business || '',
	      principal_place_of_business_street: values.principal_place_of_business_street || '',
	      principal_place_of_business_city: values.principal_place_of_business_city || '',
	      principal_place_of_business_state: values.principal_place_of_business_state || '',
	      principal_place_of_business_zip_code: values.principal_place_of_business_zip_code || '',
	      principal_place_of_business_country: values.principal_place_of_business_country || '',
	      location_place_of_business_street: values.location_place_of_business_street || '',
	      location_place_of_business_city: values.location_place_of_business_city || '',
	      location_place_of_business_state: values.location_place_of_business_state || '',
	      location_place_of_business_zip_code: values.location_place_of_business_zip_code || '',
	      location_place_of_business_country: values.location_place_of_business_country || '',
	      authorized_representative_of_debtor: values.authorized_representative_of_debtor || '',
	      title: values.title || ''
	    };
	    setDataForSave(formData);
	    setPostSummaryData(statisticalSummary);
	  };
	
	  var toggleScheduleForm = function toggleScheduleForm() {
	    setEditScheduleForm(!editScheduleForm);
	  };
	
	  if (isLoading || isLoadingSave || isLoadingSummary) {
	    return _react2.default.createElement(_reactBootstrap.ProgressBar, {
	      now: 100,
	      bsStyle: 'info',
	      label: '' + (isLoadingSave || isLoadingSummary ? 'Saving in progress' : ''),
	      active: true
	    });
	  }
	
	  if (isError || isSaveError || isSummaryError) {
	    return _react2.default.createElement(
	      _reactBootstrap.Alert,
	      { bsStyle: 'danger' },
	      'There has been an error ',
	      '' + (isError ? 'loading' : 'saving'),
	      ' Schedule data.'
	    );
	  }
	
	  return _react2.default.createElement(_Petition2.default, {
	    schedule: transformResponseToData(data),
	    canEdit: canEdit,
	    can_see_details: can_see_details,
	    type: type,
	    editScheduleForm: editScheduleForm,
	    toggleScheduleForm: toggleScheduleForm,
	    onSubmit: function onSubmit(value) {
	      return saveScheduleForm(value);
	    },
	    onCancel: toggleScheduleForm
	  });
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _useDataApi2 = __webpack_require__(60);
	
	var _useDataApi3 = _interopRequireDefault(_useDataApi2);
	
	var _usePostApi3 = __webpack_require__(139);
	
	var _usePostApi4 = _interopRequireDefault(_usePostApi3);
	
	var _Petition = __webpack_require__(730);
	
	var _Petition2 = _interopRequireDefault(_Petition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var type = 'petition';

/***/ },
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (drupalParams) {
	  var case_uuid = drupalParams.case_uuid,
	      canEdit = drupalParams.canEdit,
	      can_see_details = drupalParams.can_see_details;
	
	  var _useDataApi = (0, _useDataApi3.default)('/ir-search/query-json?query=' + type + '&case_uuid=' + case_uuid, {}),
	      _useDataApi$ = _useDataApi[0],
	      data = _useDataApi$.data,
	      isLoading = _useDataApi$.isLoading,
	      isError = _useDataApi$.isError,
	      setData = _useDataApi[1].setData;
	
	  var _useState = (0, _react.useState)(false),
	      editScheduleForm = _useState[0],
	      setEditScheduleForm = _useState[1];
	
	  var transformResponseToData = function transformResponseToData(item) {
	    var schedule = {};
	    schedule = Array.isArray(item.queries) ? _lodash2.default.get(item, 'queries[0].schedule_ab[0].text', []) : _lodash2.default.get(item, 'queries.schedule_ab[0].text', []);
	
	    return schedule;
	  };
	
	  var _usePostApi = (0, _usePostApi3.default)('/scheduleform/save'),
	      _usePostApi$ = _usePostApi[0],
	      savedScheduleResponse = _usePostApi$.data,
	      isLoadingSave = _usePostApi$.isLoading,
	      isSaveError = _usePostApi$.isError,
	      setPostData = _usePostApi[1];
	
	  (0, _react.useEffect)(function () {
	    if (savedScheduleResponse) setData(savedScheduleResponse.content);
	  }, [savedScheduleResponse]);
	
	  var saveScheduleForm = function saveScheduleForm(values) {
	    var cash = _currencyConversion2.default.toCentsOrStr(values.cash);
	    var deposits = _currencyConversion2.default.toCentsOrStr(values.deposits);
	    var acct_rcpt = _currencyConversion2.default.toCentsOrStr(values.acct_rcpt);
	    var investments = _currencyConversion2.default.toCentsOrStr(values.investments);
	    var inventory = _currencyConversion2.default.toCentsOrStr(values.inventory);
	    var farming = _currencyConversion2.default.toCentsOrStr(values.farming);
	    var office = _currencyConversion2.default.toCentsOrStr(values.office);
	    var machinery = _currencyConversion2.default.toCentsOrStr(values.machinery);
	    var property = _currencyConversion2.default.toCentsOrStr(values.property);
	    var intangibles = _currencyConversion2.default.toCentsOrStr(values.intangibles);
	    var others = _currencyConversion2.default.toCentsOrStr(values.others);
	    var personal_total = _currencyConversion2.default.toCents(values.personal_total);
	    var real_total = _currencyConversion2.default.toCents(values.real_total);
	    var total = _currencyConversion2.default.toCents(values.total);
	
	    setPostData({
	      case_uuid: case_uuid,
	      type: 'ab',
	      data: {
	        type: type,
	        case_uuid: case_uuid,
	        cash: cash,
	        deposits: deposits,
	        acct_rcpt: acct_rcpt,
	        investments: investments,
	        inventory: inventory,
	        farming: farming,
	        office: office,
	        machinery: machinery,
	        property: property,
	        intangibles: intangibles,
	        others: others,
	        personal_total: personal_total,
	        real_total: real_total,
	        total: total
	      }
	    });
	
	    setEditScheduleForm(false);
	  };
	
	  var toggleScheduleForm = function toggleScheduleForm() {
	    setEditScheduleForm(!editScheduleForm);
	  };
	  var onPastedData = function onPastedData(schedule) {
	    setEditScheduleForm(schedule);
	  };
	
	  if (isLoading || isLoadingSave) {
	    return _react2.default.createElement(_reactBootstrap.ProgressBar, { now: 100, bsStyle: 'info', label: '' + (isLoadingSave ? 'Saving in progress' : ''), active: true });
	  }
	
	  if (isError || isSaveError) {
	    return _react2.default.createElement(
	      _reactBootstrap.Alert,
	      { bsStyle: 'danger' },
	      'There has been an error ',
	      '' + (isError ? 'loading' : 'saving'),
	      ' Schedule data.'
	    );
	  }
	
	  return _react2.default.createElement(_ScheduleAB2.default, {
	    schedule: transformResponseToData(data),
	    canEdit: canEdit,
	    can_see_details: can_see_details,
	    type: type,
	    editScheduleForm: editScheduleForm,
	    toggleScheduleForm: toggleScheduleForm,
	    onSubmit: function onSubmit(value) {
	      return saveScheduleForm(value);
	    },
	    onCancel: toggleScheduleForm,
	    onPastedData: onPastedData
	  });
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _useDataApi2 = __webpack_require__(60);
	
	var _useDataApi3 = _interopRequireDefault(_useDataApi2);
	
	var _usePostApi2 = __webpack_require__(139);
	
	var _usePostApi3 = _interopRequireDefault(_usePostApi2);
	
	var _currencyConversion = __webpack_require__(72);
	
	var _currencyConversion2 = _interopRequireDefault(_currencyConversion);
	
	var _ScheduleAB = __webpack_require__(732);
	
	var _ScheduleAB2 = _interopRequireDefault(_ScheduleAB);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var type = 'schedule_ab';

/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (drupalParams) {
	  var case_uuid = drupalParams.case_uuid,
	      canEdit = drupalParams.canEdit,
	      can_see_details = drupalParams.can_see_details;
	
	  var _useDataApi = (0, _useDataApi3.default)('/ir-search/query-json?query=' + type + '&case_uuid=' + case_uuid, {}),
	      _useDataApi$ = _useDataApi[0],
	      data = _useDataApi$.data,
	      isLoading = _useDataApi$.isLoading,
	      isError = _useDataApi$.isError,
	      setData = _useDataApi[1].setData;
	
	  var _useState = (0, _react.useState)(false),
	      editScheduleForm = _useState[0],
	      setEditScheduleForm = _useState[1];
	
	  var transformResponseToData = function transformResponseToData(item) {
	    var schedule = {};
	    schedule = Array.isArray(item.queries) ? _lodash2.default.get(item, 'queries[0].schedule_d[0].text', []) : _lodash2.default.get(item, 'queries.schedule_d[0].text', []);
	
	    return schedule;
	  };
	
	  var _usePostApi = (0, _usePostApi3.default)('/scheduleform/save'),
	      _usePostApi$ = _usePostApi[0],
	      savedScheduleResponse = _usePostApi$.data,
	      isLoadingSave = _usePostApi$.isLoading,
	      isSaveError = _usePostApi$.isError,
	      setPostData = _usePostApi[1];
	
	  (0, _react.useEffect)(function () {
	    if (savedScheduleResponse) setData(savedScheduleResponse.content);
	  }, [savedScheduleResponse]);
	
	  var toBoolean = function toBoolean(value) {
	    return (/^true|yes$/i.test(value)
	    );
	  };
	  var toBooleanOrBlank = function toBooleanOrBlank(value) {
	    return value === 'yes' ? true : value === 'no' ? false : '';
	  };
	
	  var saveScheduleForm = function saveScheduleForm(values) {
	    var _values$creditors = values.creditors,
	        creditors = _values$creditors === undefined ? [{}] : _values$creditors;
	    var _values$total_claims_ = values.total_claims_amount_cents,
	        total_claims_amount_cents = _values$total_claims_ === undefined ? 0 : _values$total_claims_;
	
	
	    creditors = creditors.map(function (creditor) {
	      return {
	        collateral_amount_cents: _currencyConversion2.default.toCentsOrStr(creditor.collateral_amount_cents),
	        claim_amount_cents: _currencyConversion2.default.toCentsOrStr(creditor.claim_amount_cents),
	        creditor_name: creditor.creditor_name || '',
	
	        creditor_address_street: creditor.creditor_address_street || '',
	        creditor_address_city: creditor.creditor_address_city || '',
	        creditor_address_state: creditor.creditor_address_state || '',
	        creditor_address_zip_code: creditor.creditor_address_zip_code || '',
	        creditor_address_country: creditor.creditor_address_country || '',
	
	        creditor_email: creditor.creditor_email ? creditor.creditor_email : '',
	        debt_date: creditor.debt_date || '',
	        account_number_last_4_digits: creditor.account_number_last_4_digits ? creditor.account_number_last_4_digits : 0,
	        property_description: creditor.property_description || '',
	        lien_description: creditor.lien_description || '',
	        is_creditor_an_insider: toBooleanOrBlank(creditor.is_creditor_an_insider),
	        is_anyone_else_liable: toBooleanOrBlank(creditor.is_anyone_else_liable),
	        is_contingent: toBoolean(creditor.is_contingent),
	        is_unliquidated: toBoolean(creditor.is_unliquidated),
	        is_disputed: toBoolean(creditor.is_disputed),
	        has_multiple_creditor_interest: toBoolean(creditor.has_multiple_creditor_interest),
	        creditor_priority: creditor.creditor_priority || '',
	        has_already_specified_creditor_priority: toBoolean(creditor.has_already_specified_creditor_priority),
	        creditor_priority_specified_on_line: creditor.creditor_priority_specified_on_line || ''
	      };
	    });
	
	    var creditorsData = {
	      creditors: creditors,
	      total_claims_amount_cents: _currencyConversion2.default.toCents(total_claims_amount_cents)
	    };
	
	    setPostData({
	      case_uuid: case_uuid,
	      type: 'd',
	      data: creditorsData
	    });
	
	    setEditScheduleForm(false);
	  };
	
	  var toggleScheduleForm = function toggleScheduleForm() {
	    setEditScheduleForm(!editScheduleForm);
	  };
	
	  var onPastedData = function onPastedData(schedule) {
	    setEditScheduleForm(schedule);
	  };
	
	  if (isLoading || isLoadingSave) {
	    return _react2.default.createElement(_reactBootstrap.ProgressBar, { now: 100, bsStyle: 'info', label: '' + (isLoadingSave ? 'Saving in progress' : ''), active: true });
	  }
	
	  if (isError || isSaveError) {
	    return _react2.default.createElement(
	      _reactBootstrap.Alert,
	      { bsStyle: 'danger' },
	      'There has been an error ',
	      '' + (isError ? 'loading' : 'saving'),
	      ' Schedule data.'
	    );
	  }
	
	  return _react2.default.createElement(_ScheduleD2.default, {
	    schedule: transformResponseToData(data),
	    editScheduleForm: editScheduleForm,
	    onPastedData: onPastedData,
	    toggleScheduleForm: toggleScheduleForm,
	    onSubmit: saveScheduleForm,
	    canEdit: canEdit,
	    can_see_details: can_see_details,
	    type: type
	  });
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _useDataApi2 = __webpack_require__(60);
	
	var _useDataApi3 = _interopRequireDefault(_useDataApi2);
	
	var _usePostApi2 = __webpack_require__(139);
	
	var _usePostApi3 = _interopRequireDefault(_usePostApi2);
	
	var _currencyConversion = __webpack_require__(72);
	
	var _currencyConversion2 = _interopRequireDefault(_currencyConversion);
	
	var _ScheduleD = __webpack_require__(734);
	
	var _ScheduleD2 = _interopRequireDefault(_ScheduleD);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var type = 'schedule_d';

/***/ },
/* 1251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (drupalParams) {
	  var case_uuid = drupalParams.case_uuid,
	      canEdit = drupalParams.canEdit,
	      can_see_details = drupalParams.can_see_details;
	
	  var _useDataApi = (0, _useDataApi3.default)('/ir-search/query-json?query=' + type + '&case_uuid=' + case_uuid, {}),
	      _useDataApi$ = _useDataApi[0],
	      data = _useDataApi$.data,
	      isLoading = _useDataApi$.isLoading,
	      isError = _useDataApi$.isError,
	      setData = _useDataApi[1].setData;
	
	  var _useState = (0, _react.useState)({}),
	      viewFilters = _useState[0],
	      setViewFilters = _useState[1];
	
	  var _useState2 = (0, _react.useState)(false),
	      editScheduleForm = _useState2[0],
	      setEditScheduleForm = _useState2[1];
	
	  var inputRef = (0, _react.useRef)(null);
	
	  var transformResponseToData = function transformResponseToData(item) {
	    var schedule = {};
	    schedule = Array.isArray(item.queries) ? _lodash2.default.get(item, 'queries[0].schedule_ef[0].text', []) : _lodash2.default.get(item, 'queries.schedule_ef[0].text', []);
	
	    return schedule;
	  };
	
	  var _usePostApi = (0, _usePostApi3.default)('/scheduleform/save'),
	      _usePostApi$ = _usePostApi[0],
	      savedScheduleResponse = _usePostApi$.data,
	      isLoadingSave = _usePostApi$.isLoading,
	      isSaveError = _usePostApi$.isError,
	      setPostData = _usePostApi[1];
	
	  (0, _react.useEffect)(function () {
	    if (savedScheduleResponse) setData(savedScheduleResponse.content);
	  }, [savedScheduleResponse]);
	
	  var toBoolean = function toBoolean(value) {
	    return (/^true|yes$/i.test(value)
	    );
	  };
	
	  var saveScheduleForm = function saveScheduleForm(values) {
	    console.log('Got Form Values', values);
	    var _values$priority_cred = values.priority_creditors,
	        priority_creditors = _values$priority_cred === undefined ? [] : _values$priority_cred,
	        _values$non_priority_ = values.non_priority_creditors,
	        non_priority_creditors = _values$non_priority_ === undefined ? [] : _values$non_priority_;
	
	    var creditorsData = {
	      priority_creditors: priority_creditors.map(function (priority_creditor) {
	        return {
	          creditor_name: priority_creditor.creditor_name || '',
	
	          creditor_address_street: priority_creditor.creditor_address_street || '',
	          creditor_address_city: priority_creditor.creditor_address_city || '',
	          creditor_address_state: priority_creditor.creditor_address_state || '',
	          creditor_address_zip_code: priority_creditor.creditor_address_zip_code || '',
	          creditor_address_country: priority_creditor.creditor_address_country || '',
	
	          is_contingent: toBoolean(priority_creditor.is_contingent),
	          is_unliquidated: toBoolean(priority_creditor.is_unliquidated),
	          is_disputed: toBoolean(priority_creditor.is_disputed),
	          total_claim: _currencyConversion2.default.toCentsOrStr(priority_creditor.total_claim),
	
	          priority_amount: _currencyConversion2.default.toCentsOrStr(priority_creditor.priority_amount),
	
	          claim_basis: priority_creditor.claim_basis || '',
	          account_number_last_4_digits: priority_creditor.account_number_last_4_digits || '',
	          usc_subsection: priority_creditor.usc_subsection || '',
	          is_subject_to_offset: toBoolean(priority_creditor.is_subject_to_offset),
	          debt_date: priority_creditor.debt_date || ''
	        };
	      }),
	      non_priority_creditors: non_priority_creditors.map(function (non_priority_cred) {
	        return {
	          creditor_name: non_priority_cred.creditor_name || '',
	
	          creditor_address_street: non_priority_cred.creditor_address_street || '',
	          creditor_address_city: non_priority_cred.creditor_address_city || '',
	          creditor_address_state: non_priority_cred.creditor_address_state || '',
	          creditor_address_zip_code: non_priority_cred.creditor_address_zip_code || '',
	          creditor_address_country: non_priority_cred.creditor_address_country || '',
	
	          is_contingent: toBoolean(non_priority_cred.is_contingent),
	          is_unliquidated: toBoolean(non_priority_cred.is_unliquidated),
	          is_disputed: toBoolean(non_priority_cred.is_disputed),
	          total_claim: _currencyConversion2.default.toCentsOrStr(non_priority_cred.total_claim),
	          claim_basis: non_priority_cred.claim_basis ? non_priority_cred.claim_basis : '',
	          account_number_last_4_digits: non_priority_cred.account_number_last_4_digits || '',
	          is_subject_to_offset: toBoolean(non_priority_cred.is_subject_to_offset),
	          debt_date: non_priority_cred.debt_date || ''
	        };
	      })
	    };
	
	    setPostData({
	      case_uuid: case_uuid,
	      type: 'ef',
	      data: creditorsData
	    });
	    setEditScheduleForm(false);
	  };
	
	  var toggleScheduleForm = function toggleScheduleForm() {
	    setEditScheduleForm(!editScheduleForm);
	  };
	
	  var onPastedData = function onPastedData(schedule) {
	    setEditScheduleForm(schedule);
	  };
	
	  if (isLoading || isLoadingSave) {
	    return _react2.default.createElement(_reactBootstrap.ProgressBar, { now: 100, bsStyle: 'info', label: '' + (isLoadingSave ? 'Saving in progress' : ''), active: true });
	  }
	
	  if (isError || isSaveError) {
	    return _react2.default.createElement(
	      _reactBootstrap.Alert,
	      { bsStyle: 'danger' },
	      'There has been an error ',
	      '' + (isError ? 'loading' : 'saving'),
	      ' Schedule data.'
	    );
	  }
	  var scheduleFiltersProps = {
	    inputRef: inputRef,
	    viewFilters: viewFilters,
	    setViewFilters: setViewFilters
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_ScheduleEF2.default, {
	      schedule: transformResponseToData(data),
	      scheduleFiltersProps: scheduleFiltersProps,
	      canEdit: canEdit,
	      can_see_details: can_see_details,
	      type: type,
	      editScheduleForm: editScheduleForm,
	      toggleScheduleForm: toggleScheduleForm,
	      viewFilters: viewFilters,
	      onSubmit: saveScheduleForm,
	      onCancel: toggleScheduleForm,
	      onPastedData: onPastedData
	    })
	  );
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _useDataApi2 = __webpack_require__(60);
	
	var _useDataApi3 = _interopRequireDefault(_useDataApi2);
	
	var _usePostApi2 = __webpack_require__(139);
	
	var _usePostApi3 = _interopRequireDefault(_usePostApi2);
	
	var _ScheduleEF = __webpack_require__(737);
	
	var _ScheduleEF2 = _interopRequireDefault(_ScheduleEF);
	
	var _currencyConversion = __webpack_require__(72);
	
	var _currencyConversion2 = _interopRequireDefault(_currencyConversion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var type = 'schedule_ef';

/***/ },
/* 1252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (drupalParams) {
	  var case_uuid = drupalParams.case_uuid,
	      canEdit = drupalParams.canEdit,
	      can_see_details = drupalParams.can_see_details;
	
	  var _useDataApi = (0, _useDataApi3.default)('/ir-search/query-json?query=' + type + '&case_uuid=' + case_uuid, {}),
	      _useDataApi$ = _useDataApi[0],
	      data = _useDataApi$.data,
	      isLoading = _useDataApi$.isLoading,
	      isError = _useDataApi$.isError,
	      setData = _useDataApi[1].setData;
	
	  var _useState = (0, _react.useState)({}),
	      viewFilters = _useState[0],
	      setViewFilters = _useState[1];
	
	  var _useState2 = (0, _react.useState)({}),
	      claim_total = _useState2[0],
	      setClaimTotal = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      editScheduleForm = _useState3[0],
	      setEditScheduleForm = _useState3[1];
	
	  var inputRef = (0, _react.useRef)(null);
	
	  var transformResponseToData = function transformResponseToData(item) {
	    var schedule = {};
	    schedule = Array.isArray(item.queries) ? _lodash2.default.get(item, 'queries[0].top20[0].text', []) : _lodash2.default.get(item, 'queries.top20[0].text', []);
	    return schedule;
	  };
	
	  var _usePostApi = (0, _usePostApi3.default)('/scheduleform/save'),
	      _usePostApi$ = _usePostApi[0],
	      savedScheduleResponse = _usePostApi$.data,
	      isLoadingSave = _usePostApi$.isLoading,
	      isSaveError = _usePostApi$.isError,
	      setPostData = _usePostApi[1];
	
	  (0, _react.useEffect)(function () {
	    if (savedScheduleResponse) setData(savedScheduleResponse.content);
	  }, [savedScheduleResponse]);
	
	  var saveScheduleForm = function saveScheduleForm(values) {
	    var _values$creditors = values.creditors,
	        creditors = _values$creditors === undefined ? [{}] : _values$creditors;
	
	
	    creditors = creditors.map(function (creditor) {
	      return {
	        creditor_name: creditor.creditor_name || '',
	        creditor_address_street: creditor.creditor_address_street || '',
	        creditor_address_city: creditor.creditor_address_city || '',
	        creditor_address_state: creditor.creditor_address_state || '',
	        creditor_address_zip_code: creditor.creditor_address_zip_code || '',
	        creditor_address_country: creditor.creditor_address_country || '',
	
	        contact_address: creditor.contact_address ? creditor.contact_address : '',
	
	        total: _currencyConversion2.default.toCentsOrStr(creditor.total),
	        deduction: _currencyConversion2.default.toCentsOrStr(creditor.deduction),
	        unsecured: _currencyConversion2.default.toCentsOrStr(creditor.unsecured),
	        claim_type: creditor.claim_type ? creditor.claim_type : '',
	        claim_status: creditor.claim_status ? creditor.claim_status : ''
	      };
	    });
	
	    var creditorsData = {
	      creditors: creditors
	    };
	
	    setPostData({
	      case_uuid: case_uuid,
	      type: type,
	      data: creditorsData
	    });
	    setEditScheduleForm(false);
	  };
	
	  var toggleScheduleForm = function toggleScheduleForm() {
	    setEditScheduleForm(!editScheduleForm);
	  };
	  var onPastedData = function onPastedData(schedule) {
	    setEditScheduleForm(schedule);
	  };
	
	  if (isLoading || isLoadingSave) {
	    return _react2.default.createElement(_reactBootstrap.ProgressBar, { now: 100, bsStyle: 'info', label: '' + (isLoadingSave ? 'Saving in progress' : ''), active: true });
	  }
	
	  if (isError) {
	    return _react2.default.createElement(
	      _reactBootstrap.Alert,
	      { bsStyle: 'danger' },
	      'There has been an error loading Schedule data.'
	    );
	  }
	  if (isSaveError) {
	    return _react2.default.createElement(
	      _reactBootstrap.Alert,
	      { bsStyle: 'danger' },
	      'There has been an error saving Schedule data.',
	      _react2.default.createElement(
	        'pre',
	        null,
	        '' + isSaveError
	      )
	    );
	  }
	  var scheduleFiltersProps = {
	    inputRef: inputRef,
	    viewFilters: viewFilters,
	    setViewFilters: setViewFilters
	  };
	
	  return _react2.default.createElement(_TopTwenty2.default, {
	    schedule: transformResponseToData(data),
	    scheduleFiltersProps: scheduleFiltersProps,
	    canEdit: canEdit,
	    can_see_details: can_see_details,
	    type: type,
	    editScheduleForm: editScheduleForm,
	    toggleScheduleForm: toggleScheduleForm,
	    viewFilters: viewFilters,
	    onSubmit: function onSubmit(value) {
	      return saveScheduleForm(value);
	    },
	    onCancel: toggleScheduleForm,
	    onPastedData: onPastedData,
	    claim_total: claim_total,
	    setClaimTotal: setClaimTotal
	  });
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _useDataApi2 = __webpack_require__(60);
	
	var _useDataApi3 = _interopRequireDefault(_useDataApi2);
	
	var _usePostApi2 = __webpack_require__(139);
	
	var _usePostApi3 = _interopRequireDefault(_usePostApi2);
	
	var _currencyConversion = __webpack_require__(72);
	
	var _currencyConversion2 = _interopRequireDefault(_currencyConversion);
	
	var _TopTwenty = __webpack_require__(741);
	
	var _TopTwenty2 = _interopRequireDefault(_TopTwenty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var type = 'top20';

/***/ },
/* 1253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(841);
	
	__webpack_require__(2207);
	
	__webpack_require__(2208);
	
	__webpack_require__(104);
	
	__webpack_require__(130);
	
	__webpack_require__(2192);

/***/ },
/* 1254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (caseProperties) {
	  var casePropertiesParsed = {};
	
	  if (!_lodash2.default.isEmpty(caseProperties)) {
	    var c = Array.isArray(caseProperties) ? caseProperties : caseProperties.split(',');
	
	    c.forEach(function (caseProperty) {
	      casePropertiesParsed[caseProperty] = 1;
	    });
	    return casePropertiesParsed;
	  }
	  return null;
	};
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useInterval;
	
	var _react = __webpack_require__(1);
	
	// from https://overreacted.io/making-setinterval-declarative-with-react-hooks/
	function useInterval(callback, delay) {
	  var savedCallback = (0, _react.useRef)();
	
	  // Remember the latest callback.
	  (0, _react.useEffect)(function () {
	    savedCallback.current = callback;
	  }, [callback]);
	
	  // Set up the interval.
	  (0, _react.useEffect)(function () {
	    function tick() {
	      savedCallback.current();
	    }
	    if (delay !== null) {
	      var id = setInterval(tick, delay);
	      return function () {
	        return clearInterval(id);
	      };
	    }
	  }, [delay]);
	}

/***/ },
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(1581);
	
	__webpack_require__(1257);
	
	__webpack_require__(1316);
	
	/* eslint max-len: 0 */
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	// Should be removed in the next major release:
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1257 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function(arg) {
	    return new AwaitArgument(arg);
	  };
	
	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value instanceof AwaitArgument) {
	          return Promise.resolve(value.arg).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = arg;
	
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(231)))

/***/ },
/* 1258 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(751), __esModule: true };

/***/ },
/* 1259 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1318), __esModule: true };

/***/ },
/* 1260 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1319), __esModule: true };

/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1321), __esModule: true };

/***/ },
/* 1262 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1322), __esModule: true };

/***/ },
/* 1263 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(753), __esModule: true };

/***/ },
/* 1264 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1323), __esModule: true };

/***/ },
/* 1265 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1325), __esModule: true };

/***/ },
/* 1266 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(755), __esModule: true };

/***/ },
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1327), __esModule: true };

/***/ },
/* 1268 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1332), __esModule: true };

/***/ },
/* 1269 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(757), __esModule: true };

/***/ },
/* 1270 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _promise = __webpack_require__(427);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new _promise2.default(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return _promise2.default.resolve(value).then(function (value) {
	            step("next", value);
	          }, function (err) {
	            step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};

/***/ },
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperties = __webpack_require__(1264);
	
	var _defineProperties2 = _interopRequireDefault(_defineProperties);
	
	var _freeze = __webpack_require__(1265);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (strings, raw) {
	  return (0, _freeze2.default)((0, _defineProperties2.default)(strings, {
	    raw: {
	      value: (0, _freeze2.default)(raw)
	    }
	  }));
	};

/***/ },
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g = (function() { return this })() || Function("return this")();
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(1273);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}


/***/ },
/* 1273 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // In sloppy mode, unbound `this` refers to the global object, fallback to
	  // Function constructor if we're in global strict mode. That is sadly a form
	  // of indirect eval which violates Content Security Policy.
	  (function() { return this })() || Function("return this")()
	);


/***/ },
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1272);


/***/ },
/* 1275 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['', ''], ['', '']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @class TemplateTag
	 * @classdesc Consumes a pipeline of composable transformer plugins and produces a template tag.
	 */
	var TemplateTag = function () {
	  /**
	   * constructs a template tag
	   * @constructs TemplateTag
	   * @param  {...Object} [...transformers] - an array or arguments list of transformers
	   * @return {Function}                    - a template tag
	   */
	  function TemplateTag() {
	    var _this = this;
	
	    for (var _len = arguments.length, transformers = Array(_len), _key = 0; _key < _len; _key++) {
	      transformers[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, TemplateTag);
	
	    this.tag = function (strings) {
	      for (var _len2 = arguments.length, expressions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        expressions[_key2 - 1] = arguments[_key2];
	      }
	
	      if (typeof strings === 'function') {
	        // if the first argument passed is a function, assume it is a template tag and return
	        // an intermediary tag that processes the template using the aforementioned tag, passing the
	        // result to our tag
	        return _this.interimTag.bind(_this, strings);
	      }
	
	      if (typeof strings === 'string') {
	        // if the first argument passed is a string, just transform it
	        return _this.transformEndResult(strings);
	      }
	
	      // else, return a transformed end result of processing the template with our tag
	      strings = strings.map(_this.transformString.bind(_this));
	      return _this.transformEndResult(strings.reduce(_this.processSubstitutions.bind(_this, expressions)));
	    };
	
	    // if first argument is an array, extrude it as a list of transformers
	    if (transformers.length > 0 && Array.isArray(transformers[0])) {
	      transformers = transformers[0];
	    }
	
	    // if any transformers are functions, this means they are not initiated - automatically initiate them
	    this.transformers = transformers.map(function (transformer) {
	      return typeof transformer === 'function' ? transformer() : transformer;
	    });
	
	    // return an ES2015 template tag
	    return this.tag;
	  }
	
	  /**
	   * Applies all transformers to a template literal tagged with this method.
	   * If a function is passed as the first argument, assumes the function is a template tag
	   * and applies it to the template, returning a template tag.
	   * @param  {(Function|String|Array<String>)} strings        - Either a template tag or an array containing template strings separated by identifier
	   * @param  {...*}                            ...expressions - Optional list of substitution values.
	   * @return {(String|Function)}                              - Either an intermediary tag function or the results of processing the template.
	   */
	
	
	  _createClass(TemplateTag, [{
	    key: 'interimTag',
	
	
	    /**
	     * An intermediary template tag that receives a template tag and passes the result of calling the template with the received
	     * template tag to our own template tag.
	     * @param  {Function}        nextTag          - the received template tag
	     * @param  {Array<String>}   template         - the template to process
	     * @param  {...*}            ...substitutions - `substitutions` is an array of all substitutions in the template
	     * @return {*}                                - the final processed value
	     */
	    value: function interimTag(previousTag, template) {
	      for (var _len3 = arguments.length, substitutions = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
	        substitutions[_key3 - 2] = arguments[_key3];
	      }
	
	      return this.tag(_templateObject, previousTag.apply(undefined, [template].concat(substitutions)));
	    }
	
	    /**
	     * Performs bulk processing on the tagged template, transforming each substitution and then
	     * concatenating the resulting values into a string.
	     * @param  {Array<*>} substitutions - an array of all remaining substitutions present in this template
	     * @param  {String}   resultSoFar   - this iteration's result string so far
	     * @param  {String}   remainingPart - the template chunk after the current substitution
	     * @return {String}                 - the result of joining this iteration's processed substitution with the result
	     */
	
	  }, {
	    key: 'processSubstitutions',
	    value: function processSubstitutions(substitutions, resultSoFar, remainingPart) {
	      var substitution = this.transformSubstitution(substitutions.shift(), resultSoFar);
	      return ''.concat(resultSoFar, substitution, remainingPart);
	    }
	
	    /**
	     * Iterate through each transformer, applying the transformer's `onString` method to the template
	     * strings before all substitutions are processed.
	     * @param {String}  str - The input string
	     * @return {String}     - The final results of processing each transformer
	     */
	
	  }, {
	    key: 'transformString',
	    value: function transformString(str) {
	      var cb = function cb(res, transform) {
	        return transform.onString ? transform.onString(res) : res;
	      };
	      return this.transformers.reduce(cb, str);
	    }
	
	    /**
	     * When a substitution is encountered, iterates through each transformer and applies the transformer's
	     * `onSubstitution` method to the substitution.
	     * @param  {*}      substitution - The current substitution
	     * @param  {String} resultSoFar  - The result up to and excluding this substitution.
	     * @return {*}                   - The final result of applying all substitution transformations.
	     */
	
	  }, {
	    key: 'transformSubstitution',
	    value: function transformSubstitution(substitution, resultSoFar) {
	      var cb = function cb(res, transform) {
	        return transform.onSubstitution ? transform.onSubstitution(res, resultSoFar) : res;
	      };
	      return this.transformers.reduce(cb, substitution);
	    }
	
	    /**
	     * Iterates through each transformer, applying the transformer's `onEndResult` method to the
	     * template literal after all substitutions have finished processing.
	     * @param  {String} endResult - The processed template, just before it is returned from the tag
	     * @return {String}           - The final results of processing each transformer
	     */
	
	  }, {
	    key: 'transformEndResult',
	    value: function transformEndResult(endResult) {
	      var cb = function cb(res, transform) {
	        return transform.onEndResult ? transform.onEndResult(res) : res;
	      };
	      return this.transformers.reduce(cb, endResult);
	    }
	  }]);
	
	  return TemplateTag;
	}();
	
	exports.default = TemplateTag;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 1276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _html = __webpack_require__(429);
	
	var _html2 = _interopRequireDefault(_html);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _html2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb2RlQmxvY2svaW5kZXguanMiXSwibmFtZXMiOlsiZGVmYXVsdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztRQUFPQSxPIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnJvbSAnLi4vaHRtbCc7XG4iXX0=

/***/ },
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TemplateTag = __webpack_require__(54);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	var _stripIndentTransformer = __webpack_require__(105);
	
	var _stripIndentTransformer2 = _interopRequireDefault(_stripIndentTransformer);
	
	var _inlineArrayTransformer = __webpack_require__(82);
	
	var _inlineArrayTransformer2 = _interopRequireDefault(_inlineArrayTransformer);
	
	var _trimResultTransformer = __webpack_require__(55);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commaLists = new _TemplateTag2.default((0, _inlineArrayTransformer2.default)({ separator: ',' }), _stripIndentTransformer2.default, _trimResultTransformer2.default);
	
	exports.default = commaLists;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21tYUxpc3RzL2NvbW1hTGlzdHMuanMiXSwibmFtZXMiOlsiY29tbWFMaXN0cyIsInNlcGFyYXRvciJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7OztBQUVBLElBQU1BLGFBQWEsMEJBQ2pCLHNDQUF1QixFQUFFQyxXQUFXLEdBQWIsRUFBdkIsQ0FEaUIsb0VBQW5COztrQkFNZUQsVSIsImZpbGUiOiJjb21tYUxpc3RzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFRlbXBsYXRlVGFnIGZyb20gJy4uL1RlbXBsYXRlVGFnJztcbmltcG9ydCBzdHJpcEluZGVudFRyYW5zZm9ybWVyIGZyb20gJy4uL3N0cmlwSW5kZW50VHJhbnNmb3JtZXInO1xuaW1wb3J0IGlubGluZUFycmF5VHJhbnNmb3JtZXIgZnJvbSAnLi4vaW5saW5lQXJyYXlUcmFuc2Zvcm1lcic7XG5pbXBvcnQgdHJpbVJlc3VsdFRyYW5zZm9ybWVyIGZyb20gJy4uL3RyaW1SZXN1bHRUcmFuc2Zvcm1lcic7XG5cbmNvbnN0IGNvbW1hTGlzdHMgPSBuZXcgVGVtcGxhdGVUYWcoXG4gIGlubGluZUFycmF5VHJhbnNmb3JtZXIoeyBzZXBhcmF0b3I6ICcsJyB9KSxcbiAgc3RyaXBJbmRlbnRUcmFuc2Zvcm1lcixcbiAgdHJpbVJlc3VsdFRyYW5zZm9ybWVyLFxuKTtcblxuZXhwb3J0IGRlZmF1bHQgY29tbWFMaXN0cztcbiJdfQ==

/***/ },
/* 1278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _commaLists = __webpack_require__(1277);
	
	var _commaLists2 = _interopRequireDefault(_commaLists);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _commaLists2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21tYUxpc3RzL2luZGV4LmpzIl0sIm5hbWVzIjpbImRlZmF1bHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7UUFBT0EsTyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZyb20gJy4vY29tbWFMaXN0cyc7XG4iXX0=

/***/ },
/* 1279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TemplateTag = __webpack_require__(54);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	var _stripIndentTransformer = __webpack_require__(105);
	
	var _stripIndentTransformer2 = _interopRequireDefault(_stripIndentTransformer);
	
	var _inlineArrayTransformer = __webpack_require__(82);
	
	var _inlineArrayTransformer2 = _interopRequireDefault(_inlineArrayTransformer);
	
	var _trimResultTransformer = __webpack_require__(55);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commaListsAnd = new _TemplateTag2.default((0, _inlineArrayTransformer2.default)({ separator: ',', conjunction: 'and' }), _stripIndentTransformer2.default, _trimResultTransformer2.default);
	
	exports.default = commaListsAnd;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21tYUxpc3RzQW5kL2NvbW1hTGlzdHNBbmQuanMiXSwibmFtZXMiOlsiY29tbWFMaXN0c0FuZCIsInNlcGFyYXRvciIsImNvbmp1bmN0aW9uIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7Ozs7O0FBRUEsSUFBTUEsZ0JBQWdCLDBCQUNwQixzQ0FBdUIsRUFBRUMsV0FBVyxHQUFiLEVBQWtCQyxhQUFhLEtBQS9CLEVBQXZCLENBRG9CLG9FQUF0Qjs7a0JBTWVGLGEiLCJmaWxlIjoiY29tbWFMaXN0c0FuZC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBUZW1wbGF0ZVRhZyBmcm9tICcuLi9UZW1wbGF0ZVRhZyc7XG5pbXBvcnQgc3RyaXBJbmRlbnRUcmFuc2Zvcm1lciBmcm9tICcuLi9zdHJpcEluZGVudFRyYW5zZm9ybWVyJztcbmltcG9ydCBpbmxpbmVBcnJheVRyYW5zZm9ybWVyIGZyb20gJy4uL2lubGluZUFycmF5VHJhbnNmb3JtZXInO1xuaW1wb3J0IHRyaW1SZXN1bHRUcmFuc2Zvcm1lciBmcm9tICcuLi90cmltUmVzdWx0VHJhbnNmb3JtZXInO1xuXG5jb25zdCBjb21tYUxpc3RzQW5kID0gbmV3IFRlbXBsYXRlVGFnKFxuICBpbmxpbmVBcnJheVRyYW5zZm9ybWVyKHsgc2VwYXJhdG9yOiAnLCcsIGNvbmp1bmN0aW9uOiAnYW5kJyB9KSxcbiAgc3RyaXBJbmRlbnRUcmFuc2Zvcm1lcixcbiAgdHJpbVJlc3VsdFRyYW5zZm9ybWVyLFxuKTtcblxuZXhwb3J0IGRlZmF1bHQgY29tbWFMaXN0c0FuZDtcbiJdfQ==

/***/ },
/* 1280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _commaListsAnd = __webpack_require__(1279);
	
	var _commaListsAnd2 = _interopRequireDefault(_commaListsAnd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _commaListsAnd2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21tYUxpc3RzQW5kL2luZGV4LmpzIl0sIm5hbWVzIjpbImRlZmF1bHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7UUFBT0EsTyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZyb20gJy4vY29tbWFMaXN0c0FuZCc7XG4iXX0=

/***/ },
/* 1281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TemplateTag = __webpack_require__(54);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	var _stripIndentTransformer = __webpack_require__(105);
	
	var _stripIndentTransformer2 = _interopRequireDefault(_stripIndentTransformer);
	
	var _inlineArrayTransformer = __webpack_require__(82);
	
	var _inlineArrayTransformer2 = _interopRequireDefault(_inlineArrayTransformer);
	
	var _trimResultTransformer = __webpack_require__(55);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commaListsOr = new _TemplateTag2.default((0, _inlineArrayTransformer2.default)({ separator: ',', conjunction: 'or' }), _stripIndentTransformer2.default, _trimResultTransformer2.default);
	
	exports.default = commaListsOr;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21tYUxpc3RzT3IvY29tbWFMaXN0c09yLmpzIl0sIm5hbWVzIjpbImNvbW1hTGlzdHNPciIsInNlcGFyYXRvciIsImNvbmp1bmN0aW9uIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7Ozs7O0FBRUEsSUFBTUEsZUFBZSwwQkFDbkIsc0NBQXVCLEVBQUVDLFdBQVcsR0FBYixFQUFrQkMsYUFBYSxJQUEvQixFQUF2QixDQURtQixvRUFBckI7O2tCQU1lRixZIiwiZmlsZSI6ImNvbW1hTGlzdHNPci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBUZW1wbGF0ZVRhZyBmcm9tICcuLi9UZW1wbGF0ZVRhZyc7XG5pbXBvcnQgc3RyaXBJbmRlbnRUcmFuc2Zvcm1lciBmcm9tICcuLi9zdHJpcEluZGVudFRyYW5zZm9ybWVyJztcbmltcG9ydCBpbmxpbmVBcnJheVRyYW5zZm9ybWVyIGZyb20gJy4uL2lubGluZUFycmF5VHJhbnNmb3JtZXInO1xuaW1wb3J0IHRyaW1SZXN1bHRUcmFuc2Zvcm1lciBmcm9tICcuLi90cmltUmVzdWx0VHJhbnNmb3JtZXInO1xuXG5jb25zdCBjb21tYUxpc3RzT3IgPSBuZXcgVGVtcGxhdGVUYWcoXG4gIGlubGluZUFycmF5VHJhbnNmb3JtZXIoeyBzZXBhcmF0b3I6ICcsJywgY29uanVuY3Rpb246ICdvcicgfSksXG4gIHN0cmlwSW5kZW50VHJhbnNmb3JtZXIsXG4gIHRyaW1SZXN1bHRUcmFuc2Zvcm1lcixcbik7XG5cbmV4cG9ydCBkZWZhdWx0IGNvbW1hTGlzdHNPcjtcbiJdfQ==

/***/ },
/* 1282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _commaListsOr = __webpack_require__(1281);
	
	var _commaListsOr2 = _interopRequireDefault(_commaListsOr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _commaListsOr2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21tYUxpc3RzT3IvaW5kZXguanMiXSwibmFtZXMiOlsiZGVmYXVsdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztRQUFPQSxPIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnJvbSAnLi9jb21tYUxpc3RzT3InO1xuIl19

/***/ },
/* 1283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TemplateTag = __webpack_require__(54);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	var _stripIndentTransformer = __webpack_require__(105);
	
	var _stripIndentTransformer2 = _interopRequireDefault(_stripIndentTransformer);
	
	var _inlineArrayTransformer = __webpack_require__(82);
	
	var _inlineArrayTransformer2 = _interopRequireDefault(_inlineArrayTransformer);
	
	var _trimResultTransformer = __webpack_require__(55);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	var _splitStringTransformer = __webpack_require__(430);
	
	var _splitStringTransformer2 = _interopRequireDefault(_splitStringTransformer);
	
	var _removeNonPrintingValuesTransformer = __webpack_require__(748);
	
	var _removeNonPrintingValuesTransformer2 = _interopRequireDefault(_removeNonPrintingValuesTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var html = new _TemplateTag2.default((0, _splitStringTransformer2.default)('\n'), _removeNonPrintingValuesTransformer2.default, _inlineArrayTransformer2.default, _stripIndentTransformer2.default, _trimResultTransformer2.default);
	
	exports.default = html;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9odG1sL2h0bWwuanMiXSwibmFtZXMiOlsiaHRtbCJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7Ozs7QUFFQSxJQUFNQSxPQUFPLDBCQUNYLHNDQUF1QixJQUF2QixDQURXLG9KQUFiOztrQkFRZUEsSSIsImZpbGUiOiJodG1sLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFRlbXBsYXRlVGFnIGZyb20gJy4uL1RlbXBsYXRlVGFnJztcbmltcG9ydCBzdHJpcEluZGVudFRyYW5zZm9ybWVyIGZyb20gJy4uL3N0cmlwSW5kZW50VHJhbnNmb3JtZXInO1xuaW1wb3J0IGlubGluZUFycmF5VHJhbnNmb3JtZXIgZnJvbSAnLi4vaW5saW5lQXJyYXlUcmFuc2Zvcm1lcic7XG5pbXBvcnQgdHJpbVJlc3VsdFRyYW5zZm9ybWVyIGZyb20gJy4uL3RyaW1SZXN1bHRUcmFuc2Zvcm1lcic7XG5pbXBvcnQgc3BsaXRTdHJpbmdUcmFuc2Zvcm1lciBmcm9tICcuLi9zcGxpdFN0cmluZ1RyYW5zZm9ybWVyJztcbmltcG9ydCByZW1vdmVOb25QcmludGluZ1ZhbHVlc1RyYW5zZm9ybWVyIGZyb20gJy4uL3JlbW92ZU5vblByaW50aW5nVmFsdWVzVHJhbnNmb3JtZXInO1xuXG5jb25zdCBodG1sID0gbmV3IFRlbXBsYXRlVGFnKFxuICBzcGxpdFN0cmluZ1RyYW5zZm9ybWVyKCdcXG4nKSxcbiAgcmVtb3ZlTm9uUHJpbnRpbmdWYWx1ZXNUcmFuc2Zvcm1lcixcbiAgaW5saW5lQXJyYXlUcmFuc2Zvcm1lcixcbiAgc3RyaXBJbmRlbnRUcmFuc2Zvcm1lcixcbiAgdHJpbVJlc3VsdFRyYW5zZm9ybWVyLFxuKTtcblxuZXhwb3J0IGRlZmF1bHQgaHRtbDtcbiJdfQ==

/***/ },
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.stripIndents = exports.stripIndent = exports.oneLineInlineLists = exports.inlineLists = exports.oneLineCommaListsAnd = exports.oneLineCommaListsOr = exports.oneLineCommaLists = exports.oneLineTrim = exports.oneLine = exports.safeHtml = exports.source = exports.codeBlock = exports.html = exports.commaListsOr = exports.commaListsAnd = exports.commaLists = exports.removeNonPrintingValuesTransformer = exports.splitStringTransformer = exports.inlineArrayTransformer = exports.replaceStringTransformer = exports.replaceSubstitutionTransformer = exports.replaceResultTransformer = exports.stripIndentTransformer = exports.trimResultTransformer = exports.TemplateTag = undefined;
	
	var _TemplateTag2 = __webpack_require__(54);
	
	var _TemplateTag3 = _interopRequireDefault(_TemplateTag2);
	
	var _trimResultTransformer2 = __webpack_require__(55);
	
	var _trimResultTransformer3 = _interopRequireDefault(_trimResultTransformer2);
	
	var _stripIndentTransformer2 = __webpack_require__(105);
	
	var _stripIndentTransformer3 = _interopRequireDefault(_stripIndentTransformer2);
	
	var _replaceResultTransformer2 = __webpack_require__(141);
	
	var _replaceResultTransformer3 = _interopRequireDefault(_replaceResultTransformer2);
	
	var _replaceSubstitutionTransformer2 = __webpack_require__(749);
	
	var _replaceSubstitutionTransformer3 = _interopRequireDefault(_replaceSubstitutionTransformer2);
	
	var _replaceStringTransformer2 = __webpack_require__(1302);
	
	var _replaceStringTransformer3 = _interopRequireDefault(_replaceStringTransformer2);
	
	var _inlineArrayTransformer2 = __webpack_require__(82);
	
	var _inlineArrayTransformer3 = _interopRequireDefault(_inlineArrayTransformer2);
	
	var _splitStringTransformer2 = __webpack_require__(430);
	
	var _splitStringTransformer3 = _interopRequireDefault(_splitStringTransformer2);
	
	var _removeNonPrintingValuesTransformer2 = __webpack_require__(748);
	
	var _removeNonPrintingValuesTransformer3 = _interopRequireDefault(_removeNonPrintingValuesTransformer2);
	
	var _commaLists2 = __webpack_require__(1278);
	
	var _commaLists3 = _interopRequireDefault(_commaLists2);
	
	var _commaListsAnd2 = __webpack_require__(1280);
	
	var _commaListsAnd3 = _interopRequireDefault(_commaListsAnd2);
	
	var _commaListsOr2 = __webpack_require__(1282);
	
	var _commaListsOr3 = _interopRequireDefault(_commaListsOr2);
	
	var _html2 = __webpack_require__(429);
	
	var _html3 = _interopRequireDefault(_html2);
	
	var _codeBlock2 = __webpack_require__(1276);
	
	var _codeBlock3 = _interopRequireDefault(_codeBlock2);
	
	var _source2 = __webpack_require__(1307);
	
	var _source3 = _interopRequireDefault(_source2);
	
	var _safeHtml2 = __webpack_require__(1305);
	
	var _safeHtml3 = _interopRequireDefault(_safeHtml2);
	
	var _oneLine2 = __webpack_require__(1288);
	
	var _oneLine3 = _interopRequireDefault(_oneLine2);
	
	var _oneLineTrim2 = __webpack_require__(1298);
	
	var _oneLineTrim3 = _interopRequireDefault(_oneLineTrim2);
	
	var _oneLineCommaLists2 = __webpack_require__(1290);
	
	var _oneLineCommaLists3 = _interopRequireDefault(_oneLineCommaLists2);
	
	var _oneLineCommaListsOr2 = __webpack_require__(1294);
	
	var _oneLineCommaListsOr3 = _interopRequireDefault(_oneLineCommaListsOr2);
	
	var _oneLineCommaListsAnd2 = __webpack_require__(1292);
	
	var _oneLineCommaListsAnd3 = _interopRequireDefault(_oneLineCommaListsAnd2);
	
	var _inlineLists2 = __webpack_require__(1286);
	
	var _inlineLists3 = _interopRequireDefault(_inlineLists2);
	
	var _oneLineInlineLists2 = __webpack_require__(1296);
	
	var _oneLineInlineLists3 = _interopRequireDefault(_oneLineInlineLists2);
	
	var _stripIndent2 = __webpack_require__(1309);
	
	var _stripIndent3 = _interopRequireDefault(_stripIndent2);
	
	var _stripIndents2 = __webpack_require__(1312);
	
	var _stripIndents3 = _interopRequireDefault(_stripIndents2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.TemplateTag = _TemplateTag3.default;
	
	// transformers
	// core
	
	exports.trimResultTransformer = _trimResultTransformer3.default;
	exports.stripIndentTransformer = _stripIndentTransformer3.default;
	exports.replaceResultTransformer = _replaceResultTransformer3.default;
	exports.replaceSubstitutionTransformer = _replaceSubstitutionTransformer3.default;
	exports.replaceStringTransformer = _replaceStringTransformer3.default;
	exports.inlineArrayTransformer = _inlineArrayTransformer3.default;
	exports.splitStringTransformer = _splitStringTransformer3.default;
	exports.removeNonPrintingValuesTransformer = _removeNonPrintingValuesTransformer3.default;
	
	// tags
	
	exports.commaLists = _commaLists3.default;
	exports.commaListsAnd = _commaListsAnd3.default;
	exports.commaListsOr = _commaListsOr3.default;
	exports.html = _html3.default;
	exports.codeBlock = _codeBlock3.default;
	exports.source = _source3.default;
	exports.safeHtml = _safeHtml3.default;
	exports.oneLine = _oneLine3.default;
	exports.oneLineTrim = _oneLineTrim3.default;
	exports.oneLineCommaLists = _oneLineCommaLists3.default;
	exports.oneLineCommaListsOr = _oneLineCommaListsOr3.default;
	exports.oneLineCommaListsAnd = _oneLineCommaListsAnd3.default;
	exports.inlineLists = _inlineLists3.default;
	exports.oneLineInlineLists = _oneLineInlineLists3.default;
	exports.stripIndent = _stripIndent3.default;
	exports.stripIndents = _stripIndents3.default;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 1285 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var defaults = {
	  separator: '',
	  conjunction: '',
	  serial: false
	};
	
	/**
	 * Converts an array substitution to a string containing a list
	 * @param  {String} [opts.separator = ''] - the character that separates each item
	 * @param  {String} [opts.conjunction = '']  - replace the last separator with this
	 * @param  {Boolean} [opts.serial = false] - include the separator before the conjunction? (Oxford comma use-case)
	 *
	 * @return {Object}                     - a TemplateTag transformer
	 */
	var inlineArrayTransformer = function inlineArrayTransformer() {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaults;
	  return {
	    onSubstitution: function onSubstitution(substitution, resultSoFar) {
	      // only operate on arrays
	      if (Array.isArray(substitution)) {
	        var arrayLength = substitution.length;
	        var separator = opts.separator;
	        var conjunction = opts.conjunction;
	        var serial = opts.serial;
	        // join each item in the array into a string where each item is separated by separator
	        // be sure to maintain indentation
	        var indent = resultSoFar.match(/(\n?[^\S\n]+)$/);
	        if (indent) {
	          substitution = substitution.join(separator + indent[1]);
	        } else {
	          substitution = substitution.join(separator + ' ');
	        }
	        // if conjunction is set, replace the last separator with conjunction, but only if there is more than one substitution
	        if (conjunction && arrayLength > 1) {
	          var separatorIndex = substitution.lastIndexOf(separator);
	          substitution = substitution.slice(0, separatorIndex) + (serial ? separator : '') + ' ' + conjunction + substitution.slice(separatorIndex + 1);
	        }
	      }
	      return substitution;
	    }
	  };
	};
	
	exports.default = inlineArrayTransformer;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _inlineLists = __webpack_require__(1287);
	
	var _inlineLists2 = _interopRequireDefault(_inlineLists);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _inlineLists2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pbmxpbmVMaXN0cy9pbmRleC5qcyJdLCJuYW1lcyI6WyJkZWZhdWx0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O1FBQU9BLE8iLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmcm9tICcuL2lubGluZUxpc3RzJztcbiJdfQ==

/***/ },
/* 1287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TemplateTag = __webpack_require__(54);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	var _stripIndentTransformer = __webpack_require__(105);
	
	var _stripIndentTransformer2 = _interopRequireDefault(_stripIndentTransformer);
	
	var _inlineArrayTransformer = __webpack_require__(82);
	
	var _inlineArrayTransformer2 = _interopRequireDefault(_inlineArrayTransformer);
	
	var _trimResultTransformer = __webpack_require__(55);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inlineLists = new _TemplateTag2.default(_inlineArrayTransformer2.default, _stripIndentTransformer2.default, _trimResultTransformer2.default);
	
	exports.default = inlineLists;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pbmxpbmVMaXN0cy9pbmxpbmVMaXN0cy5qcyJdLCJuYW1lcyI6WyJpbmxpbmVMaXN0cyJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7OztBQUVBLElBQU1BLGNBQWMsOEhBQXBCOztrQkFNZUEsVyIsImZpbGUiOiJpbmxpbmVMaXN0cy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBUZW1wbGF0ZVRhZyBmcm9tICcuLi9UZW1wbGF0ZVRhZyc7XG5pbXBvcnQgc3RyaXBJbmRlbnRUcmFuc2Zvcm1lciBmcm9tICcuLi9zdHJpcEluZGVudFRyYW5zZm9ybWVyJztcbmltcG9ydCBpbmxpbmVBcnJheVRyYW5zZm9ybWVyIGZyb20gJy4uL2lubGluZUFycmF5VHJhbnNmb3JtZXInO1xuaW1wb3J0IHRyaW1SZXN1bHRUcmFuc2Zvcm1lciBmcm9tICcuLi90cmltUmVzdWx0VHJhbnNmb3JtZXInO1xuXG5jb25zdCBpbmxpbmVMaXN0cyA9IG5ldyBUZW1wbGF0ZVRhZyhcbiAgaW5saW5lQXJyYXlUcmFuc2Zvcm1lcixcbiAgc3RyaXBJbmRlbnRUcmFuc2Zvcm1lcixcbiAgdHJpbVJlc3VsdFRyYW5zZm9ybWVyLFxuKTtcblxuZXhwb3J0IGRlZmF1bHQgaW5saW5lTGlzdHM7XG4iXX0=

/***/ },
/* 1288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _oneLine = __webpack_require__(1289);
	
	var _oneLine2 = _interopRequireDefault(_oneLine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _oneLine2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vbmVMaW5lL2luZGV4LmpzIl0sIm5hbWVzIjpbImRlZmF1bHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7UUFBT0EsTyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZyb20gJy4vb25lTGluZSc7XG4iXX0=

/***/ },
/* 1289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TemplateTag = __webpack_require__(54);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	var _trimResultTransformer = __webpack_require__(55);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	var _replaceResultTransformer = __webpack_require__(141);
	
	var _replaceResultTransformer2 = _interopRequireDefault(_replaceResultTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var oneLine = new _TemplateTag2.default((0, _replaceResultTransformer2.default)(/(?:\n(?:\s*))+/g, ' '), _trimResultTransformer2.default);
	
	exports.default = oneLine;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vbmVMaW5lL29uZUxpbmUuanMiXSwibmFtZXMiOlsib25lTGluZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7Ozs7QUFFQSxJQUFNQSxVQUFVLDBCQUNkLHdDQUF5QixpQkFBekIsRUFBNEMsR0FBNUMsQ0FEYyxrQ0FBaEI7O2tCQUtlQSxPIiwiZmlsZSI6Im9uZUxpbmUuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgVGVtcGxhdGVUYWcgZnJvbSAnLi4vVGVtcGxhdGVUYWcnO1xuaW1wb3J0IHRyaW1SZXN1bHRUcmFuc2Zvcm1lciBmcm9tICcuLi90cmltUmVzdWx0VHJhbnNmb3JtZXInO1xuaW1wb3J0IHJlcGxhY2VSZXN1bHRUcmFuc2Zvcm1lciBmcm9tICcuLi9yZXBsYWNlUmVzdWx0VHJhbnNmb3JtZXInO1xuXG5jb25zdCBvbmVMaW5lID0gbmV3IFRlbXBsYXRlVGFnKFxuICByZXBsYWNlUmVzdWx0VHJhbnNmb3JtZXIoLyg/Olxcbig/OlxccyopKSsvZywgJyAnKSxcbiAgdHJpbVJlc3VsdFRyYW5zZm9ybWVyLFxuKTtcblxuZXhwb3J0IGRlZmF1bHQgb25lTGluZTtcbiJdfQ==

/***/ },
/* 1290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _oneLineCommaLists = __webpack_require__(1291);
	
	var _oneLineCommaLists2 = _interopRequireDefault(_oneLineCommaLists);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _oneLineCommaLists2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vbmVMaW5lQ29tbWFMaXN0cy9pbmRleC5qcyJdLCJuYW1lcyI6WyJkZWZhdWx0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O1FBQU9BLE8iLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmcm9tICcuL29uZUxpbmVDb21tYUxpc3RzJztcbiJdfQ==

/***/ },
/* 1291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TemplateTag = __webpack_require__(54);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	var _inlineArrayTransformer = __webpack_require__(82);
	
	var _inlineArrayTransformer2 = _interopRequireDefault(_inlineArrayTransformer);
	
	var _trimResultTransformer = __webpack_require__(55);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	var _replaceResultTransformer = __webpack_require__(141);
	
	var _replaceResultTransformer2 = _interopRequireDefault(_replaceResultTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var oneLineCommaLists = new _TemplateTag2.default((0, _inlineArrayTransformer2.default)({ separator: ',' }), (0, _replaceResultTransformer2.default)(/(?:\s+)/g, ' '), _trimResultTransformer2.default);
	
	exports.default = oneLineCommaLists;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vbmVMaW5lQ29tbWFMaXN0cy9vbmVMaW5lQ29tbWFMaXN0cy5qcyJdLCJuYW1lcyI6WyJvbmVMaW5lQ29tbWFMaXN0cyIsInNlcGFyYXRvciJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7OztBQUVBLElBQU1BLG9CQUFvQiwwQkFDeEIsc0NBQXVCLEVBQUVDLFdBQVcsR0FBYixFQUF2QixDQUR3QixFQUV4Qix3Q0FBeUIsVUFBekIsRUFBcUMsR0FBckMsQ0FGd0Isa0NBQTFCOztrQkFNZUQsaUIiLCJmaWxlIjoib25lTGluZUNvbW1hTGlzdHMuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgVGVtcGxhdGVUYWcgZnJvbSAnLi4vVGVtcGxhdGVUYWcnO1xuaW1wb3J0IGlubGluZUFycmF5VHJhbnNmb3JtZXIgZnJvbSAnLi4vaW5saW5lQXJyYXlUcmFuc2Zvcm1lcic7XG5pbXBvcnQgdHJpbVJlc3VsdFRyYW5zZm9ybWVyIGZyb20gJy4uL3RyaW1SZXN1bHRUcmFuc2Zvcm1lcic7XG5pbXBvcnQgcmVwbGFjZVJlc3VsdFRyYW5zZm9ybWVyIGZyb20gJy4uL3JlcGxhY2VSZXN1bHRUcmFuc2Zvcm1lcic7XG5cbmNvbnN0IG9uZUxpbmVDb21tYUxpc3RzID0gbmV3IFRlbXBsYXRlVGFnKFxuICBpbmxpbmVBcnJheVRyYW5zZm9ybWVyKHsgc2VwYXJhdG9yOiAnLCcgfSksXG4gIHJlcGxhY2VSZXN1bHRUcmFuc2Zvcm1lcigvKD86XFxzKykvZywgJyAnKSxcbiAgdHJpbVJlc3VsdFRyYW5zZm9ybWVyLFxuKTtcblxuZXhwb3J0IGRlZmF1bHQgb25lTGluZUNvbW1hTGlzdHM7XG4iXX0=

/***/ },
/* 1292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _oneLineCommaListsAnd = __webpack_require__(1293);
	
	var _oneLineCommaListsAnd2 = _interopRequireDefault(_oneLineCommaListsAnd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _oneLineCommaListsAnd2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vbmVMaW5lQ29tbWFMaXN0c0FuZC9pbmRleC5qcyJdLCJuYW1lcyI6WyJkZWZhdWx0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O1FBQU9BLE8iLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmcm9tICcuL29uZUxpbmVDb21tYUxpc3RzQW5kJztcbiJdfQ==

/***/ },
/* 1293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TemplateTag = __webpack_require__(54);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	var _inlineArrayTransformer = __webpack_require__(82);
	
	var _inlineArrayTransformer2 = _interopRequireDefault(_inlineArrayTransformer);
	
	var _trimResultTransformer = __webpack_require__(55);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	var _replaceResultTransformer = __webpack_require__(141);
	
	var _replaceResultTransformer2 = _interopRequireDefault(_replaceResultTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var oneLineCommaListsAnd = new _TemplateTag2.default((0, _inlineArrayTransformer2.default)({ separator: ',', conjunction: 'and' }), (0, _replaceResultTransformer2.default)(/(?:\s+)/g, ' '), _trimResultTransformer2.default);
	
	exports.default = oneLineCommaListsAnd;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vbmVMaW5lQ29tbWFMaXN0c0FuZC9vbmVMaW5lQ29tbWFMaXN0c0FuZC5qcyJdLCJuYW1lcyI6WyJvbmVMaW5lQ29tbWFMaXN0c0FuZCIsInNlcGFyYXRvciIsImNvbmp1bmN0aW9uIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7Ozs7O0FBRUEsSUFBTUEsdUJBQXVCLDBCQUMzQixzQ0FBdUIsRUFBRUMsV0FBVyxHQUFiLEVBQWtCQyxhQUFhLEtBQS9CLEVBQXZCLENBRDJCLEVBRTNCLHdDQUF5QixVQUF6QixFQUFxQyxHQUFyQyxDQUYyQixrQ0FBN0I7O2tCQU1lRixvQiIsImZpbGUiOiJvbmVMaW5lQ29tbWFMaXN0c0FuZC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBUZW1wbGF0ZVRhZyBmcm9tICcuLi9UZW1wbGF0ZVRhZyc7XG5pbXBvcnQgaW5saW5lQXJyYXlUcmFuc2Zvcm1lciBmcm9tICcuLi9pbmxpbmVBcnJheVRyYW5zZm9ybWVyJztcbmltcG9ydCB0cmltUmVzdWx0VHJhbnNmb3JtZXIgZnJvbSAnLi4vdHJpbVJlc3VsdFRyYW5zZm9ybWVyJztcbmltcG9ydCByZXBsYWNlUmVzdWx0VHJhbnNmb3JtZXIgZnJvbSAnLi4vcmVwbGFjZVJlc3VsdFRyYW5zZm9ybWVyJztcblxuY29uc3Qgb25lTGluZUNvbW1hTGlzdHNBbmQgPSBuZXcgVGVtcGxhdGVUYWcoXG4gIGlubGluZUFycmF5VHJhbnNmb3JtZXIoeyBzZXBhcmF0b3I6ICcsJywgY29uanVuY3Rpb246ICdhbmQnIH0pLFxuICByZXBsYWNlUmVzdWx0VHJhbnNmb3JtZXIoLyg/OlxccyspL2csICcgJyksXG4gIHRyaW1SZXN1bHRUcmFuc2Zvcm1lcixcbik7XG5cbmV4cG9ydCBkZWZhdWx0IG9uZUxpbmVDb21tYUxpc3RzQW5kO1xuIl19

/***/ },
/* 1294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _oneLineCommaListsOr = __webpack_require__(1295);
	
	var _oneLineCommaListsOr2 = _interopRequireDefault(_oneLineCommaListsOr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _oneLineCommaListsOr2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vbmVMaW5lQ29tbWFMaXN0c09yL2luZGV4LmpzIl0sIm5hbWVzIjpbImRlZmF1bHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7UUFBT0EsTyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZyb20gJy4vb25lTGluZUNvbW1hTGlzdHNPcic7XG4iXX0=

/***/ },
/* 1295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TemplateTag = __webpack_require__(54);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	var _inlineArrayTransformer = __webpack_require__(82);
	
	var _inlineArrayTransformer2 = _interopRequireDefault(_inlineArrayTransformer);
	
	var _trimResultTransformer = __webpack_require__(55);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	var _replaceResultTransformer = __webpack_require__(141);
	
	var _replaceResultTransformer2 = _interopRequireDefault(_replaceResultTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var oneLineCommaListsOr = new _TemplateTag2.default((0, _inlineArrayTransformer2.default)({ separator: ',', conjunction: 'or' }), (0, _replaceResultTransformer2.default)(/(?:\s+)/g, ' '), _trimResultTransformer2.default);
	
	exports.default = oneLineCommaListsOr;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vbmVMaW5lQ29tbWFMaXN0c09yL29uZUxpbmVDb21tYUxpc3RzT3IuanMiXSwibmFtZXMiOlsib25lTGluZUNvbW1hTGlzdHNPciIsInNlcGFyYXRvciIsImNvbmp1bmN0aW9uIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7Ozs7O0FBRUEsSUFBTUEsc0JBQXNCLDBCQUMxQixzQ0FBdUIsRUFBRUMsV0FBVyxHQUFiLEVBQWtCQyxhQUFhLElBQS9CLEVBQXZCLENBRDBCLEVBRTFCLHdDQUF5QixVQUF6QixFQUFxQyxHQUFyQyxDQUYwQixrQ0FBNUI7O2tCQU1lRixtQiIsImZpbGUiOiJvbmVMaW5lQ29tbWFMaXN0c09yLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFRlbXBsYXRlVGFnIGZyb20gJy4uL1RlbXBsYXRlVGFnJztcbmltcG9ydCBpbmxpbmVBcnJheVRyYW5zZm9ybWVyIGZyb20gJy4uL2lubGluZUFycmF5VHJhbnNmb3JtZXInO1xuaW1wb3J0IHRyaW1SZXN1bHRUcmFuc2Zvcm1lciBmcm9tICcuLi90cmltUmVzdWx0VHJhbnNmb3JtZXInO1xuaW1wb3J0IHJlcGxhY2VSZXN1bHRUcmFuc2Zvcm1lciBmcm9tICcuLi9yZXBsYWNlUmVzdWx0VHJhbnNmb3JtZXInO1xuXG5jb25zdCBvbmVMaW5lQ29tbWFMaXN0c09yID0gbmV3IFRlbXBsYXRlVGFnKFxuICBpbmxpbmVBcnJheVRyYW5zZm9ybWVyKHsgc2VwYXJhdG9yOiAnLCcsIGNvbmp1bmN0aW9uOiAnb3InIH0pLFxuICByZXBsYWNlUmVzdWx0VHJhbnNmb3JtZXIoLyg/OlxccyspL2csICcgJyksXG4gIHRyaW1SZXN1bHRUcmFuc2Zvcm1lcixcbik7XG5cbmV4cG9ydCBkZWZhdWx0IG9uZUxpbmVDb21tYUxpc3RzT3I7XG4iXX0=

/***/ },
/* 1296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _oneLineInlineLists = __webpack_require__(1297);
	
	var _oneLineInlineLists2 = _interopRequireDefault(_oneLineInlineLists);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _oneLineInlineLists2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vbmVMaW5lSW5saW5lTGlzdHMvaW5kZXguanMiXSwibmFtZXMiOlsiZGVmYXVsdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztRQUFPQSxPIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnJvbSAnLi9vbmVMaW5lSW5saW5lTGlzdHMnO1xuIl19

/***/ },
/* 1297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TemplateTag = __webpack_require__(54);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	var _inlineArrayTransformer = __webpack_require__(82);
	
	var _inlineArrayTransformer2 = _interopRequireDefault(_inlineArrayTransformer);
	
	var _trimResultTransformer = __webpack_require__(55);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	var _replaceResultTransformer = __webpack_require__(141);
	
	var _replaceResultTransformer2 = _interopRequireDefault(_replaceResultTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var oneLineInlineLists = new _TemplateTag2.default(_inlineArrayTransformer2.default, (0, _replaceResultTransformer2.default)(/(?:\s+)/g, ' '), _trimResultTransformer2.default);
	
	exports.default = oneLineInlineLists;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vbmVMaW5lSW5saW5lTGlzdHMvb25lTGluZUlubGluZUxpc3RzLmpzIl0sIm5hbWVzIjpbIm9uZUxpbmVJbmxpbmVMaXN0cyJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7OztBQUVBLElBQU1BLHFCQUFxQiw0REFFekIsd0NBQXlCLFVBQXpCLEVBQXFDLEdBQXJDLENBRnlCLGtDQUEzQjs7a0JBTWVBLGtCIiwiZmlsZSI6Im9uZUxpbmVJbmxpbmVMaXN0cy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBUZW1wbGF0ZVRhZyBmcm9tICcuLi9UZW1wbGF0ZVRhZyc7XG5pbXBvcnQgaW5saW5lQXJyYXlUcmFuc2Zvcm1lciBmcm9tICcuLi9pbmxpbmVBcnJheVRyYW5zZm9ybWVyJztcbmltcG9ydCB0cmltUmVzdWx0VHJhbnNmb3JtZXIgZnJvbSAnLi4vdHJpbVJlc3VsdFRyYW5zZm9ybWVyJztcbmltcG9ydCByZXBsYWNlUmVzdWx0VHJhbnNmb3JtZXIgZnJvbSAnLi4vcmVwbGFjZVJlc3VsdFRyYW5zZm9ybWVyJztcblxuY29uc3Qgb25lTGluZUlubGluZUxpc3RzID0gbmV3IFRlbXBsYXRlVGFnKFxuICBpbmxpbmVBcnJheVRyYW5zZm9ybWVyLFxuICByZXBsYWNlUmVzdWx0VHJhbnNmb3JtZXIoLyg/OlxccyspL2csICcgJyksXG4gIHRyaW1SZXN1bHRUcmFuc2Zvcm1lcixcbik7XG5cbmV4cG9ydCBkZWZhdWx0IG9uZUxpbmVJbmxpbmVMaXN0cztcbiJdfQ==

/***/ },
/* 1298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _oneLineTrim = __webpack_require__(1299);
	
	var _oneLineTrim2 = _interopRequireDefault(_oneLineTrim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _oneLineTrim2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vbmVMaW5lVHJpbS9pbmRleC5qcyJdLCJuYW1lcyI6WyJkZWZhdWx0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O1FBQU9BLE8iLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmcm9tICcuL29uZUxpbmVUcmltJztcbiJdfQ==

/***/ },
/* 1299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TemplateTag = __webpack_require__(54);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	var _trimResultTransformer = __webpack_require__(55);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	var _replaceResultTransformer = __webpack_require__(141);
	
	var _replaceResultTransformer2 = _interopRequireDefault(_replaceResultTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var oneLineTrim = new _TemplateTag2.default((0, _replaceResultTransformer2.default)(/(?:\n\s*)/g, ''), _trimResultTransformer2.default);
	
	exports.default = oneLineTrim;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vbmVMaW5lVHJpbS9vbmVMaW5lVHJpbS5qcyJdLCJuYW1lcyI6WyJvbmVMaW5lVHJpbSJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7Ozs7QUFFQSxJQUFNQSxjQUFjLDBCQUNsQix3Q0FBeUIsWUFBekIsRUFBdUMsRUFBdkMsQ0FEa0Isa0NBQXBCOztrQkFLZUEsVyIsImZpbGUiOiJvbmVMaW5lVHJpbS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBUZW1wbGF0ZVRhZyBmcm9tICcuLi9UZW1wbGF0ZVRhZyc7XG5pbXBvcnQgdHJpbVJlc3VsdFRyYW5zZm9ybWVyIGZyb20gJy4uL3RyaW1SZXN1bHRUcmFuc2Zvcm1lcic7XG5pbXBvcnQgcmVwbGFjZVJlc3VsdFRyYW5zZm9ybWVyIGZyb20gJy4uL3JlcGxhY2VSZXN1bHRUcmFuc2Zvcm1lcic7XG5cbmNvbnN0IG9uZUxpbmVUcmltID0gbmV3IFRlbXBsYXRlVGFnKFxuICByZXBsYWNlUmVzdWx0VHJhbnNmb3JtZXIoLyg/OlxcblxccyopL2csICcnKSxcbiAgdHJpbVJlc3VsdFRyYW5zZm9ybWVyLFxuKTtcblxuZXhwb3J0IGRlZmF1bHQgb25lTGluZVRyaW07XG4iXX0=

/***/ },
/* 1300 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isValidValue = function isValidValue(x) {
	  return x != null && !Number.isNaN(x) && typeof x !== 'boolean';
	};
	
	var removeNonPrintingValuesTransformer = function removeNonPrintingValuesTransformer() {
	  return {
	    onSubstitution: function onSubstitution(substitution) {
	      if (Array.isArray(substitution)) {
	        return substitution.filter(isValidValue);
	      }
	      if (isValidValue(substitution)) {
	        return substitution;
	      }
	      return '';
	    }
	  };
	};
	
	exports.default = removeNonPrintingValuesTransformer;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZW1vdmVOb25QcmludGluZ1ZhbHVlc1RyYW5zZm9ybWVyL3JlbW92ZU5vblByaW50aW5nVmFsdWVzVHJhbnNmb3JtZXIuanMiXSwibmFtZXMiOlsiaXNWYWxpZFZhbHVlIiwieCIsIk51bWJlciIsImlzTmFOIiwicmVtb3ZlTm9uUHJpbnRpbmdWYWx1ZXNUcmFuc2Zvcm1lciIsIm9uU3Vic3RpdHV0aW9uIiwic3Vic3RpdHV0aW9uIiwiQXJyYXkiLCJpc0FycmF5IiwiZmlsdGVyIl0sIm1hcHBpbmdzIjoiOzs7OztBQUFBLElBQU1BLGVBQWUsU0FBZkEsWUFBZTtBQUFBLFNBQ25CQyxLQUFLLElBQUwsSUFBYSxDQUFDQyxPQUFPQyxLQUFQLENBQWFGLENBQWIsQ0FBZCxJQUFpQyxPQUFPQSxDQUFQLEtBQWEsU0FEM0I7QUFBQSxDQUFyQjs7QUFHQSxJQUFNRyxxQ0FBcUMsU0FBckNBLGtDQUFxQztBQUFBLFNBQU87QUFDaERDLGtCQURnRCwwQkFDakNDLFlBRGlDLEVBQ25CO0FBQzNCLFVBQUlDLE1BQU1DLE9BQU4sQ0FBY0YsWUFBZCxDQUFKLEVBQWlDO0FBQy9CLGVBQU9BLGFBQWFHLE1BQWIsQ0FBb0JULFlBQXBCLENBQVA7QUFDRDtBQUNELFVBQUlBLGFBQWFNLFlBQWIsQ0FBSixFQUFnQztBQUM5QixlQUFPQSxZQUFQO0FBQ0Q7QUFDRCxhQUFPLEVBQVA7QUFDRDtBQVQrQyxHQUFQO0FBQUEsQ0FBM0M7O2tCQVllRixrQyIsImZpbGUiOiJyZW1vdmVOb25QcmludGluZ1ZhbHVlc1RyYW5zZm9ybWVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgaXNWYWxpZFZhbHVlID0geCA9PlxuICB4ICE9IG51bGwgJiYgIU51bWJlci5pc05hTih4KSAmJiB0eXBlb2YgeCAhPT0gJ2Jvb2xlYW4nO1xuXG5jb25zdCByZW1vdmVOb25QcmludGluZ1ZhbHVlc1RyYW5zZm9ybWVyID0gKCkgPT4gKHtcbiAgb25TdWJzdGl0dXRpb24oc3Vic3RpdHV0aW9uKSB7XG4gICAgaWYgKEFycmF5LmlzQXJyYXkoc3Vic3RpdHV0aW9uKSkge1xuICAgICAgcmV0dXJuIHN1YnN0aXR1dGlvbi5maWx0ZXIoaXNWYWxpZFZhbHVlKTtcbiAgICB9XG4gICAgaWYgKGlzVmFsaWRWYWx1ZShzdWJzdGl0dXRpb24pKSB7XG4gICAgICByZXR1cm4gc3Vic3RpdHV0aW9uO1xuICAgIH1cbiAgICByZXR1cm4gJyc7XG4gIH0sXG59KTtcblxuZXhwb3J0IGRlZmF1bHQgcmVtb3ZlTm9uUHJpbnRpbmdWYWx1ZXNUcmFuc2Zvcm1lcjtcbiJdfQ==

/***/ },
/* 1301 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Replaces tabs, newlines and spaces with the chosen value when they occur in sequences
	 * @param  {(String|RegExp)} replaceWhat - the value or pattern that should be replaced
	 * @param  {*}               replaceWith - the replacement value
	 * @return {Object}                      - a TemplateTag transformer
	 */
	var replaceResultTransformer = function replaceResultTransformer(replaceWhat, replaceWith) {
	  return {
	    onEndResult: function onEndResult(endResult) {
	      if (replaceWhat == null || replaceWith == null) {
	        throw new Error('replaceResultTransformer requires at least 2 arguments.');
	      }
	      return endResult.replace(replaceWhat, replaceWith);
	    }
	  };
	};
	
	exports.default = replaceResultTransformer;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZXBsYWNlUmVzdWx0VHJhbnNmb3JtZXIvcmVwbGFjZVJlc3VsdFRyYW5zZm9ybWVyLmpzIl0sIm5hbWVzIjpbInJlcGxhY2VSZXN1bHRUcmFuc2Zvcm1lciIsInJlcGxhY2VXaGF0IiwicmVwbGFjZVdpdGgiLCJvbkVuZFJlc3VsdCIsImVuZFJlc3VsdCIsIkVycm9yIiwicmVwbGFjZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQTs7Ozs7O0FBTUEsSUFBTUEsMkJBQTJCLFNBQTNCQSx3QkFBMkIsQ0FBQ0MsV0FBRCxFQUFjQyxXQUFkO0FBQUEsU0FBK0I7QUFDOURDLGVBRDhELHVCQUNsREMsU0FEa0QsRUFDdkM7QUFDckIsVUFBSUgsZUFBZSxJQUFmLElBQXVCQyxlQUFlLElBQTFDLEVBQWdEO0FBQzlDLGNBQU0sSUFBSUcsS0FBSixDQUNKLHlEQURJLENBQU47QUFHRDtBQUNELGFBQU9ELFVBQVVFLE9BQVYsQ0FBa0JMLFdBQWxCLEVBQStCQyxXQUEvQixDQUFQO0FBQ0Q7QUFSNkQsR0FBL0I7QUFBQSxDQUFqQzs7a0JBV2VGLHdCIiwiZmlsZSI6InJlcGxhY2VSZXN1bHRUcmFuc2Zvcm1lci5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogUmVwbGFjZXMgdGFicywgbmV3bGluZXMgYW5kIHNwYWNlcyB3aXRoIHRoZSBjaG9zZW4gdmFsdWUgd2hlbiB0aGV5IG9jY3VyIGluIHNlcXVlbmNlc1xuICogQHBhcmFtICB7KFN0cmluZ3xSZWdFeHApfSByZXBsYWNlV2hhdCAtIHRoZSB2YWx1ZSBvciBwYXR0ZXJuIHRoYXQgc2hvdWxkIGJlIHJlcGxhY2VkXG4gKiBAcGFyYW0gIHsqfSAgICAgICAgICAgICAgIHJlcGxhY2VXaXRoIC0gdGhlIHJlcGxhY2VtZW50IHZhbHVlXG4gKiBAcmV0dXJuIHtPYmplY3R9ICAgICAgICAgICAgICAgICAgICAgIC0gYSBUZW1wbGF0ZVRhZyB0cmFuc2Zvcm1lclxuICovXG5jb25zdCByZXBsYWNlUmVzdWx0VHJhbnNmb3JtZXIgPSAocmVwbGFjZVdoYXQsIHJlcGxhY2VXaXRoKSA9PiAoe1xuICBvbkVuZFJlc3VsdChlbmRSZXN1bHQpIHtcbiAgICBpZiAocmVwbGFjZVdoYXQgPT0gbnVsbCB8fCByZXBsYWNlV2l0aCA9PSBudWxsKSB7XG4gICAgICB0aHJvdyBuZXcgRXJyb3IoXG4gICAgICAgICdyZXBsYWNlUmVzdWx0VHJhbnNmb3JtZXIgcmVxdWlyZXMgYXQgbGVhc3QgMiBhcmd1bWVudHMuJyxcbiAgICAgICk7XG4gICAgfVxuICAgIHJldHVybiBlbmRSZXN1bHQucmVwbGFjZShyZXBsYWNlV2hhdCwgcmVwbGFjZVdpdGgpO1xuICB9LFxufSk7XG5cbmV4cG9ydCBkZWZhdWx0IHJlcGxhY2VSZXN1bHRUcmFuc2Zvcm1lcjtcbiJdfQ==

/***/ },
/* 1302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _replaceStringTransformer = __webpack_require__(1303);
	
	var _replaceStringTransformer2 = _interopRequireDefault(_replaceStringTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _replaceStringTransformer2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZXBsYWNlU3RyaW5nVHJhbnNmb3JtZXIvaW5kZXguanMiXSwibmFtZXMiOlsiZGVmYXVsdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztRQUFPQSxPIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnJvbSAnLi9yZXBsYWNlU3RyaW5nVHJhbnNmb3JtZXInO1xuIl19

/***/ },
/* 1303 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var replaceStringTransformer = function replaceStringTransformer(replaceWhat, replaceWith) {
	  return {
	    onString: function onString(str) {
	      if (replaceWhat == null || replaceWith == null) {
	        throw new Error('replaceStringTransformer requires at least 2 arguments.');
	      }
	
	      return str.replace(replaceWhat, replaceWith);
	    }
	  };
	};
	
	exports.default = replaceStringTransformer;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZXBsYWNlU3RyaW5nVHJhbnNmb3JtZXIvcmVwbGFjZVN0cmluZ1RyYW5zZm9ybWVyLmpzIl0sIm5hbWVzIjpbInJlcGxhY2VTdHJpbmdUcmFuc2Zvcm1lciIsInJlcGxhY2VXaGF0IiwicmVwbGFjZVdpdGgiLCJvblN0cmluZyIsInN0ciIsIkVycm9yIiwicmVwbGFjZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxJQUFNQSwyQkFBMkIsU0FBM0JBLHdCQUEyQixDQUFDQyxXQUFELEVBQWNDLFdBQWQ7QUFBQSxTQUErQjtBQUM5REMsWUFEOEQsb0JBQ3JEQyxHQURxRCxFQUNoRDtBQUNaLFVBQUlILGVBQWUsSUFBZixJQUF1QkMsZUFBZSxJQUExQyxFQUFnRDtBQUM5QyxjQUFNLElBQUlHLEtBQUosQ0FDSix5REFESSxDQUFOO0FBR0Q7O0FBRUQsYUFBT0QsSUFBSUUsT0FBSixDQUFZTCxXQUFaLEVBQXlCQyxXQUF6QixDQUFQO0FBQ0Q7QUFUNkQsR0FBL0I7QUFBQSxDQUFqQzs7a0JBWWVGLHdCIiwiZmlsZSI6InJlcGxhY2VTdHJpbmdUcmFuc2Zvcm1lci5qcyIsInNvdXJjZXNDb250ZW50IjpbImNvbnN0IHJlcGxhY2VTdHJpbmdUcmFuc2Zvcm1lciA9IChyZXBsYWNlV2hhdCwgcmVwbGFjZVdpdGgpID0+ICh7XG4gIG9uU3RyaW5nKHN0cikge1xuICAgIGlmIChyZXBsYWNlV2hhdCA9PSBudWxsIHx8IHJlcGxhY2VXaXRoID09IG51bGwpIHtcbiAgICAgIHRocm93IG5ldyBFcnJvcihcbiAgICAgICAgJ3JlcGxhY2VTdHJpbmdUcmFuc2Zvcm1lciByZXF1aXJlcyBhdCBsZWFzdCAyIGFyZ3VtZW50cy4nLFxuICAgICAgKTtcbiAgICB9XG5cbiAgICByZXR1cm4gc3RyLnJlcGxhY2UocmVwbGFjZVdoYXQsIHJlcGxhY2VXaXRoKTtcbiAgfSxcbn0pO1xuXG5leHBvcnQgZGVmYXVsdCByZXBsYWNlU3RyaW5nVHJhbnNmb3JtZXI7XG4iXX0=

/***/ },
/* 1304 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var replaceSubstitutionTransformer = function replaceSubstitutionTransformer(replaceWhat, replaceWith) {
	  return {
	    onSubstitution: function onSubstitution(substitution, resultSoFar) {
	      if (replaceWhat == null || replaceWith == null) {
	        throw new Error('replaceSubstitutionTransformer requires at least 2 arguments.');
	      }
	
	      // Do not touch if null or undefined
	      if (substitution == null) {
	        return substitution;
	      } else {
	        return substitution.toString().replace(replaceWhat, replaceWith);
	      }
	    }
	  };
	};
	
	exports.default = replaceSubstitutionTransformer;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZXBsYWNlU3Vic3RpdHV0aW9uVHJhbnNmb3JtZXIvcmVwbGFjZVN1YnN0aXR1dGlvblRyYW5zZm9ybWVyLmpzIl0sIm5hbWVzIjpbInJlcGxhY2VTdWJzdGl0dXRpb25UcmFuc2Zvcm1lciIsInJlcGxhY2VXaGF0IiwicmVwbGFjZVdpdGgiLCJvblN1YnN0aXR1dGlvbiIsInN1YnN0aXR1dGlvbiIsInJlc3VsdFNvRmFyIiwiRXJyb3IiLCJ0b1N0cmluZyIsInJlcGxhY2UiXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsSUFBTUEsaUNBQWlDLFNBQWpDQSw4QkFBaUMsQ0FBQ0MsV0FBRCxFQUFjQyxXQUFkO0FBQUEsU0FBK0I7QUFDcEVDLGtCQURvRSwwQkFDckRDLFlBRHFELEVBQ3ZDQyxXQUR1QyxFQUMxQjtBQUN4QyxVQUFJSixlQUFlLElBQWYsSUFBdUJDLGVBQWUsSUFBMUMsRUFBZ0Q7QUFDOUMsY0FBTSxJQUFJSSxLQUFKLENBQ0osK0RBREksQ0FBTjtBQUdEOztBQUVEO0FBQ0EsVUFBSUYsZ0JBQWdCLElBQXBCLEVBQTBCO0FBQ3hCLGVBQU9BLFlBQVA7QUFDRCxPQUZELE1BRU87QUFDTCxlQUFPQSxhQUFhRyxRQUFiLEdBQXdCQyxPQUF4QixDQUFnQ1AsV0FBaEMsRUFBNkNDLFdBQTdDLENBQVA7QUFDRDtBQUNGO0FBZG1FLEdBQS9CO0FBQUEsQ0FBdkM7O2tCQWlCZUYsOEIiLCJmaWxlIjoicmVwbGFjZVN1YnN0aXR1dGlvblRyYW5zZm9ybWVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgcmVwbGFjZVN1YnN0aXR1dGlvblRyYW5zZm9ybWVyID0gKHJlcGxhY2VXaGF0LCByZXBsYWNlV2l0aCkgPT4gKHtcbiAgb25TdWJzdGl0dXRpb24oc3Vic3RpdHV0aW9uLCByZXN1bHRTb0Zhcikge1xuICAgIGlmIChyZXBsYWNlV2hhdCA9PSBudWxsIHx8IHJlcGxhY2VXaXRoID09IG51bGwpIHtcbiAgICAgIHRocm93IG5ldyBFcnJvcihcbiAgICAgICAgJ3JlcGxhY2VTdWJzdGl0dXRpb25UcmFuc2Zvcm1lciByZXF1aXJlcyBhdCBsZWFzdCAyIGFyZ3VtZW50cy4nLFxuICAgICAgKTtcbiAgICB9XG5cbiAgICAvLyBEbyBub3QgdG91Y2ggaWYgbnVsbCBvciB1bmRlZmluZWRcbiAgICBpZiAoc3Vic3RpdHV0aW9uID09IG51bGwpIHtcbiAgICAgIHJldHVybiBzdWJzdGl0dXRpb247XG4gICAgfSBlbHNlIHtcbiAgICAgIHJldHVybiBzdWJzdGl0dXRpb24udG9TdHJpbmcoKS5yZXBsYWNlKHJlcGxhY2VXaGF0LCByZXBsYWNlV2l0aCk7XG4gICAgfVxuICB9LFxufSk7XG5cbmV4cG9ydCBkZWZhdWx0IHJlcGxhY2VTdWJzdGl0dXRpb25UcmFuc2Zvcm1lcjtcbiJdfQ==

/***/ },
/* 1305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _safeHtml = __webpack_require__(1306);
	
	var _safeHtml2 = _interopRequireDefault(_safeHtml);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _safeHtml2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zYWZlSHRtbC9pbmRleC5qcyJdLCJuYW1lcyI6WyJkZWZhdWx0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O1FBQU9BLE8iLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmcm9tICcuL3NhZmVIdG1sJztcbiJdfQ==

/***/ },
/* 1306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TemplateTag = __webpack_require__(54);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	var _stripIndentTransformer = __webpack_require__(105);
	
	var _stripIndentTransformer2 = _interopRequireDefault(_stripIndentTransformer);
	
	var _inlineArrayTransformer = __webpack_require__(82);
	
	var _inlineArrayTransformer2 = _interopRequireDefault(_inlineArrayTransformer);
	
	var _trimResultTransformer = __webpack_require__(55);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	var _splitStringTransformer = __webpack_require__(430);
	
	var _splitStringTransformer2 = _interopRequireDefault(_splitStringTransformer);
	
	var _replaceSubstitutionTransformer = __webpack_require__(749);
	
	var _replaceSubstitutionTransformer2 = _interopRequireDefault(_replaceSubstitutionTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var safeHtml = new _TemplateTag2.default((0, _splitStringTransformer2.default)('\n'), _inlineArrayTransformer2.default, _stripIndentTransformer2.default, _trimResultTransformer2.default, (0, _replaceSubstitutionTransformer2.default)(/&/g, '&amp;'), (0, _replaceSubstitutionTransformer2.default)(/</g, '&lt;'), (0, _replaceSubstitutionTransformer2.default)(/>/g, '&gt;'), (0, _replaceSubstitutionTransformer2.default)(/"/g, '&quot;'), (0, _replaceSubstitutionTransformer2.default)(/'/g, '&#x27;'), (0, _replaceSubstitutionTransformer2.default)(/`/g, '&#x60;'));
	
	exports.default = safeHtml;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zYWZlSHRtbC9zYWZlSHRtbC5qcyJdLCJuYW1lcyI6WyJzYWZlSHRtbCJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7Ozs7QUFFQSxJQUFNQSxXQUFXLDBCQUNmLHNDQUF1QixJQUF2QixDQURlLHVHQUtmLDhDQUErQixJQUEvQixFQUFxQyxPQUFyQyxDQUxlLEVBTWYsOENBQStCLElBQS9CLEVBQXFDLE1BQXJDLENBTmUsRUFPZiw4Q0FBK0IsSUFBL0IsRUFBcUMsTUFBckMsQ0FQZSxFQVFmLDhDQUErQixJQUEvQixFQUFxQyxRQUFyQyxDQVJlLEVBU2YsOENBQStCLElBQS9CLEVBQXFDLFFBQXJDLENBVGUsRUFVZiw4Q0FBK0IsSUFBL0IsRUFBcUMsUUFBckMsQ0FWZSxDQUFqQjs7a0JBYWVBLFEiLCJmaWxlIjoic2FmZUh0bWwuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgVGVtcGxhdGVUYWcgZnJvbSAnLi4vVGVtcGxhdGVUYWcnO1xuaW1wb3J0IHN0cmlwSW5kZW50VHJhbnNmb3JtZXIgZnJvbSAnLi4vc3RyaXBJbmRlbnRUcmFuc2Zvcm1lcic7XG5pbXBvcnQgaW5saW5lQXJyYXlUcmFuc2Zvcm1lciBmcm9tICcuLi9pbmxpbmVBcnJheVRyYW5zZm9ybWVyJztcbmltcG9ydCB0cmltUmVzdWx0VHJhbnNmb3JtZXIgZnJvbSAnLi4vdHJpbVJlc3VsdFRyYW5zZm9ybWVyJztcbmltcG9ydCBzcGxpdFN0cmluZ1RyYW5zZm9ybWVyIGZyb20gJy4uL3NwbGl0U3RyaW5nVHJhbnNmb3JtZXInO1xuaW1wb3J0IHJlcGxhY2VTdWJzdGl0dXRpb25UcmFuc2Zvcm1lciBmcm9tICcuLi9yZXBsYWNlU3Vic3RpdHV0aW9uVHJhbnNmb3JtZXInO1xuXG5jb25zdCBzYWZlSHRtbCA9IG5ldyBUZW1wbGF0ZVRhZyhcbiAgc3BsaXRTdHJpbmdUcmFuc2Zvcm1lcignXFxuJyksXG4gIGlubGluZUFycmF5VHJhbnNmb3JtZXIsXG4gIHN0cmlwSW5kZW50VHJhbnNmb3JtZXIsXG4gIHRyaW1SZXN1bHRUcmFuc2Zvcm1lcixcbiAgcmVwbGFjZVN1YnN0aXR1dGlvblRyYW5zZm9ybWVyKC8mL2csICcmYW1wOycpLFxuICByZXBsYWNlU3Vic3RpdHV0aW9uVHJhbnNmb3JtZXIoLzwvZywgJyZsdDsnKSxcbiAgcmVwbGFjZVN1YnN0aXR1dGlvblRyYW5zZm9ybWVyKC8+L2csICcmZ3Q7JyksXG4gIHJlcGxhY2VTdWJzdGl0dXRpb25UcmFuc2Zvcm1lcigvXCIvZywgJyZxdW90OycpLFxuICByZXBsYWNlU3Vic3RpdHV0aW9uVHJhbnNmb3JtZXIoLycvZywgJyYjeDI3OycpLFxuICByZXBsYWNlU3Vic3RpdHV0aW9uVHJhbnNmb3JtZXIoL2AvZywgJyYjeDYwOycpLFxuKTtcblxuZXhwb3J0IGRlZmF1bHQgc2FmZUh0bWw7XG4iXX0=

/***/ },
/* 1307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _html = __webpack_require__(429);
	
	var _html2 = _interopRequireDefault(_html);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _html2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zb3VyY2UvaW5kZXguanMiXSwibmFtZXMiOlsiZGVmYXVsdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztRQUFPQSxPIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnJvbSAnLi4vaHRtbCc7XG4iXX0=

/***/ },
/* 1308 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var splitStringTransformer = function splitStringTransformer(splitBy) {
	  return {
	    onSubstitution: function onSubstitution(substitution, resultSoFar) {
	      if (splitBy != null && typeof splitBy === 'string') {
	        if (typeof substitution === 'string' && substitution.includes(splitBy)) {
	          substitution = substitution.split(splitBy);
	        }
	      } else {
	        throw new Error('You need to specify a string character to split by.');
	      }
	      return substitution;
	    }
	  };
	};
	
	exports.default = splitStringTransformer;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zcGxpdFN0cmluZ1RyYW5zZm9ybWVyL3NwbGl0U3RyaW5nVHJhbnNmb3JtZXIuanMiXSwibmFtZXMiOlsic3BsaXRTdHJpbmdUcmFuc2Zvcm1lciIsIm9uU3Vic3RpdHV0aW9uIiwic3Vic3RpdHV0aW9uIiwicmVzdWx0U29GYXIiLCJzcGxpdEJ5IiwiaW5jbHVkZXMiLCJzcGxpdCIsIkVycm9yIl0sIm1hcHBpbmdzIjoiOzs7OztBQUFBLElBQU1BLHlCQUF5QixTQUF6QkEsc0JBQXlCO0FBQUEsU0FBWTtBQUN6Q0Msa0JBRHlDLDBCQUMxQkMsWUFEMEIsRUFDWkMsV0FEWSxFQUNDO0FBQ3hDLFVBQUlDLFdBQVcsSUFBWCxJQUFtQixPQUFPQSxPQUFQLEtBQW1CLFFBQTFDLEVBQW9EO0FBQ2xELFlBQUksT0FBT0YsWUFBUCxLQUF3QixRQUF4QixJQUFvQ0EsYUFBYUcsUUFBYixDQUFzQkQsT0FBdEIsQ0FBeEMsRUFBd0U7QUFDdEVGLHlCQUFlQSxhQUFhSSxLQUFiLENBQW1CRixPQUFuQixDQUFmO0FBQ0Q7QUFDRixPQUpELE1BSU87QUFDTCxjQUFNLElBQUlHLEtBQUosQ0FBVSxxREFBVixDQUFOO0FBQ0Q7QUFDRCxhQUFPTCxZQUFQO0FBQ0Q7QUFWd0MsR0FBWjtBQUFBLENBQS9COztrQkFhZUYsc0IiLCJmaWxlIjoic3BsaXRTdHJpbmdUcmFuc2Zvcm1lci5qcyIsInNvdXJjZXNDb250ZW50IjpbImNvbnN0IHNwbGl0U3RyaW5nVHJhbnNmb3JtZXIgPSBzcGxpdEJ5ID0+ICh7XG4gIG9uU3Vic3RpdHV0aW9uKHN1YnN0aXR1dGlvbiwgcmVzdWx0U29GYXIpIHtcbiAgICBpZiAoc3BsaXRCeSAhPSBudWxsICYmIHR5cGVvZiBzcGxpdEJ5ID09PSAnc3RyaW5nJykge1xuICAgICAgaWYgKHR5cGVvZiBzdWJzdGl0dXRpb24gPT09ICdzdHJpbmcnICYmIHN1YnN0aXR1dGlvbi5pbmNsdWRlcyhzcGxpdEJ5KSkge1xuICAgICAgICBzdWJzdGl0dXRpb24gPSBzdWJzdGl0dXRpb24uc3BsaXQoc3BsaXRCeSk7XG4gICAgICB9XG4gICAgfSBlbHNlIHtcbiAgICAgIHRocm93IG5ldyBFcnJvcignWW91IG5lZWQgdG8gc3BlY2lmeSBhIHN0cmluZyBjaGFyYWN0ZXIgdG8gc3BsaXQgYnkuJyk7XG4gICAgfVxuICAgIHJldHVybiBzdWJzdGl0dXRpb247XG4gIH0sXG59KTtcblxuZXhwb3J0IGRlZmF1bHQgc3BsaXRTdHJpbmdUcmFuc2Zvcm1lcjtcbiJdfQ==

/***/ },
/* 1309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _stripIndent = __webpack_require__(1310);
	
	var _stripIndent2 = _interopRequireDefault(_stripIndent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _stripIndent2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdHJpcEluZGVudC9pbmRleC5qcyJdLCJuYW1lcyI6WyJkZWZhdWx0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O1FBQU9BLE8iLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmcm9tICcuL3N0cmlwSW5kZW50JztcbiJdfQ==

/***/ },
/* 1310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TemplateTag = __webpack_require__(54);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	var _stripIndentTransformer = __webpack_require__(105);
	
	var _stripIndentTransformer2 = _interopRequireDefault(_stripIndentTransformer);
	
	var _trimResultTransformer = __webpack_require__(55);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stripIndent = new _TemplateTag2.default(_stripIndentTransformer2.default, _trimResultTransformer2.default);
	
	exports.default = stripIndent;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdHJpcEluZGVudC9zdHJpcEluZGVudC5qcyJdLCJuYW1lcyI6WyJzdHJpcEluZGVudCJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7Ozs7QUFFQSxJQUFNQSxjQUFjLDRGQUFwQjs7a0JBS2VBLFciLCJmaWxlIjoic3RyaXBJbmRlbnQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgVGVtcGxhdGVUYWcgZnJvbSAnLi4vVGVtcGxhdGVUYWcnO1xuaW1wb3J0IHN0cmlwSW5kZW50VHJhbnNmb3JtZXIgZnJvbSAnLi4vc3RyaXBJbmRlbnRUcmFuc2Zvcm1lcic7XG5pbXBvcnQgdHJpbVJlc3VsdFRyYW5zZm9ybWVyIGZyb20gJy4uL3RyaW1SZXN1bHRUcmFuc2Zvcm1lcic7XG5cbmNvbnN0IHN0cmlwSW5kZW50ID0gbmV3IFRlbXBsYXRlVGFnKFxuICBzdHJpcEluZGVudFRyYW5zZm9ybWVyLFxuICB0cmltUmVzdWx0VHJhbnNmb3JtZXIsXG4pO1xuXG5leHBvcnQgZGVmYXVsdCBzdHJpcEluZGVudDtcbiJdfQ==

/***/ },
/* 1311 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * strips indentation from a template literal
	 * @param  {String} type = 'initial' - whether to remove all indentation or just leading indentation. can be 'all' or 'initial'
	 * @return {Object}                  - a TemplateTag transformer
	 */
	var stripIndentTransformer = function stripIndentTransformer() {
	  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'initial';
	  return {
	    onEndResult: function onEndResult(endResult) {
	      if (type === 'initial') {
	        // remove the shortest leading indentation from each line
	        var match = endResult.match(/^[^\S\n]*(?=\S)/gm);
	        var indent = match && Math.min.apply(Math, _toConsumableArray(match.map(function (el) {
	          return el.length;
	        })));
	        if (indent) {
	          var regexp = new RegExp('^.{' + indent + '}', 'gm');
	          return endResult.replace(regexp, '');
	        }
	        return endResult;
	      }
	      if (type === 'all') {
	        // remove all indentation from each line
	        return endResult.replace(/^[^\S\n]+/gm, '');
	      }
	      throw new Error('Unknown type: ' + type);
	    }
	  };
	};
	
	exports.default = stripIndentTransformer;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 1312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _stripIndents = __webpack_require__(1313);
	
	var _stripIndents2 = _interopRequireDefault(_stripIndents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _stripIndents2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdHJpcEluZGVudHMvaW5kZXguanMiXSwibmFtZXMiOlsiZGVmYXVsdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztRQUFPQSxPIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnJvbSAnLi9zdHJpcEluZGVudHMnO1xuIl19

/***/ },
/* 1313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TemplateTag = __webpack_require__(54);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	var _stripIndentTransformer = __webpack_require__(105);
	
	var _stripIndentTransformer2 = _interopRequireDefault(_stripIndentTransformer);
	
	var _trimResultTransformer = __webpack_require__(55);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stripIndents = new _TemplateTag2.default((0, _stripIndentTransformer2.default)('all'), _trimResultTransformer2.default);
	
	exports.default = stripIndents;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdHJpcEluZGVudHMvc3RyaXBJbmRlbnRzLmpzIl0sIm5hbWVzIjpbInN0cmlwSW5kZW50cyJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7Ozs7QUFFQSxJQUFNQSxlQUFlLDBCQUNuQixzQ0FBdUIsS0FBdkIsQ0FEbUIsa0NBQXJCOztrQkFLZUEsWSIsImZpbGUiOiJzdHJpcEluZGVudHMuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgVGVtcGxhdGVUYWcgZnJvbSAnLi4vVGVtcGxhdGVUYWcnO1xuaW1wb3J0IHN0cmlwSW5kZW50VHJhbnNmb3JtZXIgZnJvbSAnLi4vc3RyaXBJbmRlbnRUcmFuc2Zvcm1lcic7XG5pbXBvcnQgdHJpbVJlc3VsdFRyYW5zZm9ybWVyIGZyb20gJy4uL3RyaW1SZXN1bHRUcmFuc2Zvcm1lcic7XG5cbmNvbnN0IHN0cmlwSW5kZW50cyA9IG5ldyBUZW1wbGF0ZVRhZyhcbiAgc3RyaXBJbmRlbnRUcmFuc2Zvcm1lcignYWxsJyksXG4gIHRyaW1SZXN1bHRUcmFuc2Zvcm1lcixcbik7XG5cbmV4cG9ydCBkZWZhdWx0IHN0cmlwSW5kZW50cztcbiJdfQ==

/***/ },
/* 1314 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * TemplateTag transformer that trims whitespace on the end result of a tagged template
	 * @param  {String} side = '' - The side of the string to trim. Can be 'start' or 'end' (alternatively 'left' or 'right')
	 * @return {Object}           - a TemplateTag transformer
	 */
	var trimResultTransformer = function trimResultTransformer() {
	  var side = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  return {
	    onEndResult: function onEndResult(endResult) {
	      if (side === '') {
	        return endResult.trim();
	      }
	
	      side = side.toLowerCase();
	
	      if (side === 'start' || side === 'left') {
	        return endResult.replace(/^\s*/, '');
	      }
	
	      if (side === 'end' || side === 'right') {
	        return endResult.replace(/\s*$/, '');
	      }
	
	      throw new Error('Side not supported: ' + side);
	    }
	  };
	};
	
	exports.default = trimResultTransformer;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 1315 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	
	  // Remove event specific arrays for event types that no
	  // one is subscribed for to avoid memory leak.
	  if (callbacks.length === 0) {
	    delete this._callbacks['$' + event];
	  }
	
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	
	  var args = new Array(arguments.length - 1)
	    , callbacks = this._callbacks['$' + event];
	
	  for (var i = 1; i < arguments.length; i++) {
	    args[i - 1] = arguments[i];
	  }
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ },
/* 1316 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1389);
	module.exports = __webpack_require__(85).RegExp.escape;


/***/ },
/* 1317 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1358);
	module.exports = __webpack_require__(28).Array.isArray;


/***/ },
/* 1318 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(218);
	__webpack_require__(217);
	module.exports = __webpack_require__(1355);


/***/ },
/* 1319 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(218);
	__webpack_require__(217);
	module.exports = __webpack_require__(1356);


/***/ },
/* 1320 */
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(28);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ },
/* 1321 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1360);
	module.exports = __webpack_require__(28).Number.isFinite;


/***/ },
/* 1322 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1361);
	module.exports = __webpack_require__(28).Number.isNaN;


/***/ },
/* 1323 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1364);
	var $Object = __webpack_require__(28).Object;
	module.exports = function defineProperties(T, D) {
	  return $Object.defineProperties(T, D);
	};


/***/ },
/* 1324 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1375);
	module.exports = __webpack_require__(28).Object.entries;


/***/ },
/* 1325 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1366);
	module.exports = __webpack_require__(28).Object.freeze;


/***/ },
/* 1326 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1368);
	module.exports = __webpack_require__(28).Object.getPrototypeOf;


/***/ },
/* 1327 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1370);
	module.exports = __webpack_require__(28).Object.setPrototypeOf;


/***/ },
/* 1328 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1376);
	module.exports = __webpack_require__(28).Object.values;


/***/ },
/* 1329 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1371);
	module.exports = __webpack_require__(28).parseInt;


/***/ },
/* 1330 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(452);
	__webpack_require__(217);
	__webpack_require__(218);
	__webpack_require__(1372);
	__webpack_require__(1377);
	__webpack_require__(1378);
	module.exports = __webpack_require__(28).Promise;


/***/ },
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1373);
	__webpack_require__(452);
	__webpack_require__(1379);
	__webpack_require__(1380);
	module.exports = __webpack_require__(28).Symbol;


/***/ },
/* 1332 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(217);
	__webpack_require__(218);
	module.exports = __webpack_require__(450).f('iterator');


/***/ },
/* 1333 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 1334 */
[2253, 119, 284, 1353],
/* 1335 */
[2255, 61, 437, 56],
/* 1336 */
[2256, 1335],
/* 1337 */
[2258, 442, 213, 83, 61, 431, 282, 432, 117, 448],
/* 1338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(44);
	var $export = __webpack_require__(39);
	var meta = __webpack_require__(213);
	var fails = __webpack_require__(116);
	var hide = __webpack_require__(118);
	var redefineAll = __webpack_require__(442);
	var forOf = __webpack_require__(282);
	var anInstance = __webpack_require__(431);
	var isObject = __webpack_require__(61);
	var setToStringTag = __webpack_require__(216);
	var dP = __webpack_require__(95).f;
	var each = __webpack_require__(432)(0);
	var DESCRIPTORS = __webpack_require__(73);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    C = wrapper(function (target, iterable) {
	      anInstance(target, C, NAME, '_c');
	      target._c = new Base();
	      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
	    });
	    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
	      var IS_ADDER = KEY == 'add' || KEY == 'set';
	      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
	        anInstance(this, C, KEY);
	        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
	        var result = this._c[KEY](a === 0 ? 0 : a, b);
	        return IS_ADDER ? this : result;
	      });
	    });
	    IS_WEAK || dP(C.prototype, 'size', {
	      get: function () {
	        return this._c.size;
	      }
	    });
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F, O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ },
/* 1339 */
[2259, 95, 215],
/* 1340 */
[2263, 182, 441, 214],
/* 1341 */
785,
/* 1342 */
[2272, 439, 215, 216, 118, 56],
/* 1343 */
788,
/* 1344 */
[2276, 44, 774, 211],
/* 1345 */
[2283, 119, 766],
/* 1346 */
[2290, 44, 1352, 773],
/* 1347 */
[2292, 39, 210, 115, 282],
/* 1348 */
[2293, 39],
/* 1349 */
[2294, 61, 83, 115, 440],
/* 1350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(44);
	var core = __webpack_require__(28);
	var dP = __webpack_require__(95);
	var DESCRIPTORS = __webpack_require__(73);
	var SPECIES = __webpack_require__(56)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },
/* 1351 */
[2299, 446, 281],
/* 1352 */
[2300, 39, 281, 116, 773],
/* 1353 */
[2302, 446],
/* 1354 */
[2307, 44],
/* 1355 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(83);
	var get = __webpack_require__(451);
	module.exports = __webpack_require__(28).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ },
/* 1356 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(433);
	var ITERATOR = __webpack_require__(56)('iterator');
	var Iterators = __webpack_require__(181);
	module.exports = __webpack_require__(28).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ },
/* 1357 */
[2313, 115, 39, 142, 761, 760, 284, 1339, 451, 763],
/* 1358 */
[2314, 39, 437],
/* 1359 */
[2315, 1333, 1343, 181, 119, 762],
/* 1360 */
[2316, 39, 44],
/* 1361 */
[2317, 39],
/* 1362 */
[2318, 39, 764],
/* 1363 */
[2319, 39, 439],
/* 1364 */
[2320, 39, 73, 765],
/* 1365 */
[2321, 39, 73, 95],
/* 1366 */
[2322, 61, 213, 283],
/* 1367 */
[2323, 119, 440, 283],
/* 1368 */
[2324, 142, 767, 283],
/* 1369 */
[2325, 142, 182, 283],
/* 1370 */
[2326, 39, 1349],
/* 1371 */
[2327, 39, 1346],
/* 1372 */
[2328, 212, 44, 115, 433, 39, 61, 210, 431, 282, 772, 774, 1344, 438, 770, 1354, 771, 56, 442, 216, 1350, 28, 763],
/* 1373 */
[2330, 44, 117, 73, 39, 443, 213, 116, 445, 216, 285, 56, 450, 449, 1340, 437, 83, 61, 142, 119, 447, 215, 439, 1345, 440, 441, 95, 182, 766, 214, 212, 118],
/* 1374 */
[2331, 44, 432, 443, 213, 764, 1337, 61, 448, 448, 1338],
/* 1375 */
[2332, 39, 769],
/* 1376 */
[2333, 39, 769],
/* 1377 */
[2334, 39, 28, 44, 772, 771],
/* 1378 */
[2335, 39, 438, 770],
/* 1379 */
[2336, 449],
/* 1380 */
[2337, 449],
/* 1381 */
[2338, 1347],
/* 1382 */
[2339, 1348],
/* 1383 */
[2255, 29, 289, 36],
/* 1384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(27);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ },
/* 1385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(22);
	var toPrimitive = __webpack_require__(99);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ },
/* 1386 */
[2263, 147, 293, 221],
/* 1387 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(222)('native-function-to-string', Function.toString);


/***/ },
/* 1388 */
/***/ function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ },
/* 1389 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(3);
	var $re = __webpack_require__(1388)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ },
/* 1390 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(3);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(776) });
	
	__webpack_require__(120)('copyWithin');


/***/ },
/* 1391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $every = __webpack_require__(96)(4);
	
	$export($export.P + $export.F * !__webpack_require__(87)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1392 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(3);
	
	$export($export.P, 'Array', { fill: __webpack_require__(454) });
	
	__webpack_require__(120)('fill');


/***/ },
/* 1393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $filter = __webpack_require__(96)(2);
	
	$export($export.P + $export.F * !__webpack_require__(87)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(3);
	var $find = __webpack_require__(96)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(120)(KEY);


/***/ },
/* 1395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(3);
	var $find = __webpack_require__(96)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(120)(KEY);


/***/ },
/* 1396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $forEach = __webpack_require__(96)(0);
	var STRICT = __webpack_require__(87)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1397 */
[2313, 86, 3, 43, 787, 462, 37, 456, 478, 291],
/* 1398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $indexOf = __webpack_require__(286)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(87)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ },
/* 1399 */
[2314, 3, 289],
/* 1400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(3);
	var toIObject = __webpack_require__(77);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(220) != Object || !__webpack_require__(87)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ },
/* 1401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toIObject = __webpack_require__(77);
	var toInteger = __webpack_require__(88);
	var toLength = __webpack_require__(37);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(87)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ },
/* 1402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $map = __webpack_require__(96)(1);
	
	$export($export.P + $export.F * !__webpack_require__(87)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var createProperty = __webpack_require__(456);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(27)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ },
/* 1404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $reduce = __webpack_require__(778);
	
	$export($export.P + $export.F * !__webpack_require__(87)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ },
/* 1405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $reduce = __webpack_require__(778);
	
	$export($export.P + $export.F * !__webpack_require__(87)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ },
/* 1406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var html = __webpack_require__(460);
	var cof = __webpack_require__(84);
	var toAbsoluteIndex = __webpack_require__(151);
	var toLength = __webpack_require__(37);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(27)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ },
/* 1407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $some = __webpack_require__(96)(3);
	
	$export($export.P + $export.F * !__webpack_require__(87)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var aFunction = __webpack_require__(57);
	var toObject = __webpack_require__(43);
	var fails = __webpack_require__(27);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(87)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ },
/* 1409 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(150)('Array');


/***/ },
/* 1410 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ },
/* 1411 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(3);
	var toISOString = __webpack_require__(1384);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ },
/* 1412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(43);
	var toPrimitive = __webpack_require__(99);
	
	$export($export.P + $export.F * __webpack_require__(27)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ },
/* 1413 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(36)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(65)(proto, TO_PRIMITIVE, __webpack_require__(1385));


/***/ },
/* 1414 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(66)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ },
/* 1415 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(3);
	
	$export($export.P, 'Function', { bind: __webpack_require__(779) });


/***/ },
/* 1416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(29);
	var getPrototypeOf = __webpack_require__(76);
	var HAS_INSTANCE = __webpack_require__(36)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(41).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ },
/* 1417 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(41).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(38) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ },
/* 1418 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(3);
	var log1p = __webpack_require__(790);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ },
/* 1419 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(3);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ },
/* 1420 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(3);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ },
/* 1421 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(3);
	var sign = __webpack_require__(466);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ },
/* 1422 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ },
/* 1423 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(3);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ },
/* 1424 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(3);
	var $expm1 = __webpack_require__(465);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ },
/* 1425 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { fround: __webpack_require__(789) });


/***/ },
/* 1426 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(3);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ },
/* 1427 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(3);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(27)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ },
/* 1428 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ },
/* 1429 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(790) });


/***/ },
/* 1430 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ },
/* 1431 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { sign: __webpack_require__(466) });


/***/ },
/* 1432 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(3);
	var expm1 = __webpack_require__(465);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(27)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ },
/* 1433 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(3);
	var expm1 = __webpack_require__(465);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ },
/* 1434 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ },
/* 1435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(25);
	var has = __webpack_require__(74);
	var cof = __webpack_require__(84);
	var inheritIfRequired = __webpack_require__(461);
	var toPrimitive = __webpack_require__(99);
	var fails = __webpack_require__(27);
	var gOPN = __webpack_require__(146).f;
	var gOPD = __webpack_require__(75).f;
	var dP = __webpack_require__(41).f;
	var $trim = __webpack_require__(186).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(145)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(38) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(66)(global, NUMBER, $Number);
	}


/***/ },
/* 1436 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ },
/* 1437 */
[2316, 3, 25],
/* 1438 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(786) });


/***/ },
/* 1439 */
[2317, 3],
/* 1440 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(3);
	var isInteger = __webpack_require__(786);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ },
/* 1441 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ },
/* 1442 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ },
/* 1443 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var $parseFloat = __webpack_require__(798);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ },
/* 1444 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var $parseInt = __webpack_require__(799);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ },
/* 1445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toInteger = __webpack_require__(88);
	var aNumberValue = __webpack_require__(775);
	var repeat = __webpack_require__(473);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(27)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ },
/* 1446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $fails = __webpack_require__(27);
	var aNumberValue = __webpack_require__(775);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ },
/* 1447 */
[2318, 3, 792],
/* 1448 */
[2319, 3, 145],
/* 1449 */
[2320, 3, 38, 793],
/* 1450 */
[2321, 3, 38, 41],
/* 1451 */
[2322, 29, 122, 98],
/* 1452 */
[2323, 77, 75, 98],
/* 1453 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(98)('getOwnPropertyNames', function () {
	  return __webpack_require__(794).f;
	});


/***/ },
/* 1454 */
[2324, 43, 76, 98],
/* 1455 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(29);
	
	__webpack_require__(98)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ },
/* 1456 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(29);
	
	__webpack_require__(98)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ },
/* 1457 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(29);
	
	__webpack_require__(98)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ },
/* 1458 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(3);
	$export($export.S, 'Object', { is: __webpack_require__(802) });


/***/ },
/* 1459 */
[2325, 43, 147, 98],
/* 1460 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(29);
	var meta = __webpack_require__(122).onFreeze;
	
	__webpack_require__(98)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ },
/* 1461 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(29);
	var meta = __webpack_require__(122).onFreeze;
	
	__webpack_require__(98)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ },
/* 1462 */
[2326, 3, 470],
/* 1463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(183);
	var test = {};
	test[__webpack_require__(36)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(66)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ },
/* 1464 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var $parseFloat = __webpack_require__(798);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ },
/* 1465 */
[2327, 3, 799],
/* 1466 */
[2328, 121, 25, 86, 183, 3, 29, 57, 143, 144, 223, 475, 467, 468, 800, 299, 801, 36, 149, 185, 150, 85, 291],
/* 1467 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(3);
	var aFunction = __webpack_require__(57);
	var anObject = __webpack_require__(22);
	var rApply = (__webpack_require__(25).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(27)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ },
/* 1468 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(3);
	var create = __webpack_require__(145);
	var aFunction = __webpack_require__(57);
	var anObject = __webpack_require__(22);
	var isObject = __webpack_require__(29);
	var fails = __webpack_require__(27);
	var bind = __webpack_require__(779);
	var rConstruct = (__webpack_require__(25).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ },
/* 1469 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(41);
	var $export = __webpack_require__(3);
	var anObject = __webpack_require__(22);
	var toPrimitive = __webpack_require__(99);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(27)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 1470 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(3);
	var gOPD = __webpack_require__(75).f;
	var anObject = __webpack_require__(22);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ },
/* 1471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(3);
	var anObject = __webpack_require__(22);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(463)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ },
/* 1472 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(75);
	var $export = __webpack_require__(3);
	var anObject = __webpack_require__(22);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ },
/* 1473 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(3);
	var getProto = __webpack_require__(76);
	var anObject = __webpack_require__(22);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ },
/* 1474 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(75);
	var getPrototypeOf = __webpack_require__(76);
	var has = __webpack_require__(74);
	var $export = __webpack_require__(3);
	var isObject = __webpack_require__(29);
	var anObject = __webpack_require__(22);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ },
/* 1475 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ },
/* 1476 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(3);
	var anObject = __webpack_require__(22);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ },
/* 1477 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(797) });


/***/ },
/* 1478 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(3);
	var anObject = __webpack_require__(22);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 1479 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(3);
	var setProto = __webpack_require__(470);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 1480 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(41);
	var gOPD = __webpack_require__(75);
	var getPrototypeOf = __webpack_require__(76);
	var has = __webpack_require__(74);
	var $export = __webpack_require__(3);
	var createDesc = __webpack_require__(148);
	var anObject = __webpack_require__(22);
	var isObject = __webpack_require__(29);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ },
/* 1481 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(25);
	var inheritIfRequired = __webpack_require__(461);
	var dP = __webpack_require__(41).f;
	var gOPN = __webpack_require__(146).f;
	var isRegExp = __webpack_require__(290);
	var $flags = __webpack_require__(219);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(38) && (!CORRECT_NEW || __webpack_require__(27)(function () {
	  re2[__webpack_require__(36)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(66)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(150)('RegExp');


/***/ },
/* 1482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(22);
	var toLength = __webpack_require__(37);
	var advanceStringIndex = __webpack_require__(453);
	var regExpExec = __webpack_require__(294);
	
	// @@match logic
	__webpack_require__(288)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ },
/* 1483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(22);
	var toObject = __webpack_require__(43);
	var toLength = __webpack_require__(37);
	var toInteger = __webpack_require__(88);
	var advanceStringIndex = __webpack_require__(453);
	var regExpExec = __webpack_require__(294);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(288)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ },
/* 1484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(22);
	var sameValue = __webpack_require__(802);
	var regExpExec = __webpack_require__(294);
	
	// @@search logic
	__webpack_require__(288)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ },
/* 1485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(290);
	var anObject = __webpack_require__(22);
	var speciesConstructor = __webpack_require__(223);
	var advanceStringIndex = __webpack_require__(453);
	var toLength = __webpack_require__(37);
	var callRegExpExec = __webpack_require__(294);
	var regexpExec = __webpack_require__(469);
	var fails = __webpack_require__(27);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });
	
	// @@split logic
	__webpack_require__(288)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ },
/* 1486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(808);
	var anObject = __webpack_require__(22);
	var $flags = __webpack_require__(219);
	var DESCRIPTORS = __webpack_require__(38);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(66)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(27)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ },
/* 1487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(67)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ },
/* 1488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(67)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ },
/* 1489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(67)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ },
/* 1490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(67)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ },
/* 1491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $at = __webpack_require__(297)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 1492 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(3);
	var toLength = __webpack_require__(37);
	var context = __webpack_require__(472);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(459)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ },
/* 1493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(67)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ },
/* 1494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(67)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ },
/* 1495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(67)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ },
/* 1496 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var toAbsoluteIndex = __webpack_require__(151);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ },
/* 1497 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(3);
	var context = __webpack_require__(472);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(459)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 1498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(67)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ },
/* 1499 */
[2329, 297, 464],
/* 1500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(67)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ },
/* 1501 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var toIObject = __webpack_require__(77);
	var toLength = __webpack_require__(37);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ },
/* 1502 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(473)
	});


/***/ },
/* 1503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(67)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ },
/* 1504 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(3);
	var toLength = __webpack_require__(37);
	var context = __webpack_require__(472);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(459)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ },
/* 1505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(67)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ },
/* 1506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(67)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ },
/* 1507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(67)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ },
/* 1508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(186)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ },
/* 1509 */
[2330, 25, 74, 38, 3, 66, 122, 27, 222, 185, 152, 36, 805, 477, 1386, 289, 22, 29, 43, 77, 99, 148, 145, 794, 75, 293, 41, 147, 146, 221, 121, 65],
/* 1510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $typed = __webpack_require__(298);
	var buffer = __webpack_require__(476);
	var anObject = __webpack_require__(22);
	var toAbsoluteIndex = __webpack_require__(151);
	var toLength = __webpack_require__(37);
	var isObject = __webpack_require__(29);
	var ArrayBuffer = __webpack_require__(25).ArrayBuffer;
	var speciesConstructor = __webpack_require__(223);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(27)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(150)(ARRAY_BUFFER);


/***/ },
/* 1511 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	$export($export.G + $export.W + $export.F * !__webpack_require__(298).ABV, {
	  DataView: __webpack_require__(476).DataView
	});


/***/ },
/* 1512 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(107)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1513 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(107)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1514 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(107)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1515 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(107)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1516 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(107)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1517 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(107)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1518 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(107)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1519 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(107)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1520 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(107)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ },
/* 1521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(782);
	var validate = __webpack_require__(153);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(287)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ },
/* 1522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(3);
	var flattenIntoArray = __webpack_require__(783);
	var toObject = __webpack_require__(43);
	var toLength = __webpack_require__(37);
	var aFunction = __webpack_require__(57);
	var arraySpeciesCreate = __webpack_require__(455);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(120)('flatMap');


/***/ },
/* 1523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(3);
	var flattenIntoArray = __webpack_require__(783);
	var toObject = __webpack_require__(43);
	var toLength = __webpack_require__(37);
	var toInteger = __webpack_require__(88);
	var arraySpeciesCreate = __webpack_require__(455);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(120)('flatten');


/***/ },
/* 1524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(3);
	var $includes = __webpack_require__(286)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(120)('includes');


/***/ },
/* 1525 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(3);
	var microtask = __webpack_require__(467)();
	var process = __webpack_require__(25).process;
	var isNode = __webpack_require__(84)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ },
/* 1526 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(3);
	var cof = __webpack_require__(84);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ },
/* 1527 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(3);
	
	$export($export.G, { global: __webpack_require__(25) });


/***/ },
/* 1528 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(295)('Map');


/***/ },
/* 1529 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(296)('Map');


/***/ },
/* 1530 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(3);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(781)('Map') });


/***/ },
/* 1531 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ },
/* 1532 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ },
/* 1533 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ },
/* 1534 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	var scale = __webpack_require__(791);
	var fround = __webpack_require__(789);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ },
/* 1535 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ },
/* 1536 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ },
/* 1537 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ },
/* 1538 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ },
/* 1539 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ },
/* 1540 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { scale: __webpack_require__(791) });


/***/ },
/* 1541 */
/***/ function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ },
/* 1542 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ },
/* 1543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(43);
	var aFunction = __webpack_require__(57);
	var $defineProperty = __webpack_require__(41);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(38) && $export($export.P + __webpack_require__(292), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 1544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(43);
	var aFunction = __webpack_require__(57);
	var $defineProperty = __webpack_require__(41);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(38) && $export($export.P + __webpack_require__(292), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 1545 */
[2332, 3, 796],
/* 1546 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(3);
	var ownKeys = __webpack_require__(797);
	var toIObject = __webpack_require__(77);
	var gOPD = __webpack_require__(75);
	var createProperty = __webpack_require__(456);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ },
/* 1547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(43);
	var toPrimitive = __webpack_require__(99);
	var getPrototypeOf = __webpack_require__(76);
	var getOwnPropertyDescriptor = __webpack_require__(75).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(38) && $export($export.P + __webpack_require__(292), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 1548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(43);
	var toPrimitive = __webpack_require__(99);
	var getPrototypeOf = __webpack_require__(76);
	var getOwnPropertyDescriptor = __webpack_require__(75).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(38) && $export($export.P + __webpack_require__(292), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 1549 */
[2333, 3, 796],
/* 1550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(3);
	var global = __webpack_require__(25);
	var core = __webpack_require__(85);
	var microtask = __webpack_require__(467)();
	var OBSERVABLE = __webpack_require__(36)('observable');
	var aFunction = __webpack_require__(57);
	var anObject = __webpack_require__(22);
	var anInstance = __webpack_require__(143);
	var redefineAll = __webpack_require__(149);
	var hide = __webpack_require__(65);
	var forOf = __webpack_require__(144);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(150)('Observable');


/***/ },
/* 1551 */
[2334, 3, 85, 25, 223, 801],
/* 1552 */
[2335, 3, 468, 800],
/* 1553 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(106);
	var anObject = __webpack_require__(22);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ },
/* 1554 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(106);
	var anObject = __webpack_require__(22);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ },
/* 1555 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(809);
	var from = __webpack_require__(777);
	var metadata = __webpack_require__(106);
	var anObject = __webpack_require__(22);
	var getPrototypeOf = __webpack_require__(76);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 1556 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(106);
	var anObject = __webpack_require__(22);
	var getPrototypeOf = __webpack_require__(76);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 1557 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(106);
	var anObject = __webpack_require__(22);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 1558 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(106);
	var anObject = __webpack_require__(22);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 1559 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(106);
	var anObject = __webpack_require__(22);
	var getPrototypeOf = __webpack_require__(76);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 1560 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(106);
	var anObject = __webpack_require__(22);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 1561 */
/***/ function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(106);
	var anObject = __webpack_require__(22);
	var aFunction = __webpack_require__(57);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ },
/* 1562 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(295)('Set');


/***/ },
/* 1563 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(296)('Set');


/***/ },
/* 1564 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(3);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(781)('Set') });


/***/ },
/* 1565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(3);
	var $at = __webpack_require__(297)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 1566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(3);
	var defined = __webpack_require__(97);
	var toLength = __webpack_require__(37);
	var isRegExp = __webpack_require__(290);
	var getFlags = __webpack_require__(219);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(463)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ },
/* 1567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(3);
	var $pad = __webpack_require__(803);
	var userAgent = __webpack_require__(299);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ },
/* 1568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(3);
	var $pad = __webpack_require__(803);
	var userAgent = __webpack_require__(299);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ },
/* 1569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(186)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ },
/* 1570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(186)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ },
/* 1571 */
[2336, 477],
/* 1572 */
[2337, 477],
/* 1573 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(3);
	
	$export($export.S, 'System', { global: __webpack_require__(25) });


/***/ },
/* 1574 */
[2338, 295],
/* 1575 */
[2339, 296],
/* 1576 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(295)('WeakSet');


/***/ },
/* 1577 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(296)('WeakSet');


/***/ },
/* 1578 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(479);
	var getKeys = __webpack_require__(147);
	var redefine = __webpack_require__(66);
	var global = __webpack_require__(25);
	var hide = __webpack_require__(65);
	var Iterators = __webpack_require__(184);
	var wks = __webpack_require__(36);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ },
/* 1579 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var $task = __webpack_require__(475);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ },
/* 1580 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(25);
	var $export = __webpack_require__(3);
	var userAgent = __webpack_require__(299);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ },
/* 1581 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1509);
	__webpack_require__(1448);
	__webpack_require__(1450);
	__webpack_require__(1449);
	__webpack_require__(1452);
	__webpack_require__(1454);
	__webpack_require__(1459);
	__webpack_require__(1453);
	__webpack_require__(1451);
	__webpack_require__(1461);
	__webpack_require__(1460);
	__webpack_require__(1456);
	__webpack_require__(1457);
	__webpack_require__(1455);
	__webpack_require__(1447);
	__webpack_require__(1458);
	__webpack_require__(1462);
	__webpack_require__(1463);
	__webpack_require__(1415);
	__webpack_require__(1417);
	__webpack_require__(1416);
	__webpack_require__(1465);
	__webpack_require__(1464);
	__webpack_require__(1435);
	__webpack_require__(1445);
	__webpack_require__(1446);
	__webpack_require__(1436);
	__webpack_require__(1437);
	__webpack_require__(1438);
	__webpack_require__(1439);
	__webpack_require__(1440);
	__webpack_require__(1441);
	__webpack_require__(1442);
	__webpack_require__(1443);
	__webpack_require__(1444);
	__webpack_require__(1418);
	__webpack_require__(1419);
	__webpack_require__(1420);
	__webpack_require__(1421);
	__webpack_require__(1422);
	__webpack_require__(1423);
	__webpack_require__(1424);
	__webpack_require__(1425);
	__webpack_require__(1426);
	__webpack_require__(1427);
	__webpack_require__(1428);
	__webpack_require__(1429);
	__webpack_require__(1430);
	__webpack_require__(1431);
	__webpack_require__(1432);
	__webpack_require__(1433);
	__webpack_require__(1434);
	__webpack_require__(1496);
	__webpack_require__(1501);
	__webpack_require__(1508);
	__webpack_require__(1499);
	__webpack_require__(1491);
	__webpack_require__(1492);
	__webpack_require__(1497);
	__webpack_require__(1502);
	__webpack_require__(1504);
	__webpack_require__(1487);
	__webpack_require__(1488);
	__webpack_require__(1489);
	__webpack_require__(1490);
	__webpack_require__(1493);
	__webpack_require__(1494);
	__webpack_require__(1495);
	__webpack_require__(1498);
	__webpack_require__(1500);
	__webpack_require__(1503);
	__webpack_require__(1505);
	__webpack_require__(1506);
	__webpack_require__(1507);
	__webpack_require__(1410);
	__webpack_require__(1412);
	__webpack_require__(1411);
	__webpack_require__(1414);
	__webpack_require__(1413);
	__webpack_require__(1399);
	__webpack_require__(1397);
	__webpack_require__(1403);
	__webpack_require__(1400);
	__webpack_require__(1406);
	__webpack_require__(1408);
	__webpack_require__(1396);
	__webpack_require__(1402);
	__webpack_require__(1393);
	__webpack_require__(1407);
	__webpack_require__(1391);
	__webpack_require__(1405);
	__webpack_require__(1404);
	__webpack_require__(1398);
	__webpack_require__(1401);
	__webpack_require__(1390);
	__webpack_require__(1392);
	__webpack_require__(1395);
	__webpack_require__(1394);
	__webpack_require__(1409);
	__webpack_require__(479);
	__webpack_require__(1481);
	__webpack_require__(807);
	__webpack_require__(1486);
	__webpack_require__(808);
	__webpack_require__(1482);
	__webpack_require__(1483);
	__webpack_require__(1484);
	__webpack_require__(1485);
	__webpack_require__(1466);
	__webpack_require__(806);
	__webpack_require__(809);
	__webpack_require__(810);
	__webpack_require__(1521);
	__webpack_require__(1510);
	__webpack_require__(1511);
	__webpack_require__(1516);
	__webpack_require__(1519);
	__webpack_require__(1520);
	__webpack_require__(1514);
	__webpack_require__(1517);
	__webpack_require__(1515);
	__webpack_require__(1518);
	__webpack_require__(1512);
	__webpack_require__(1513);
	__webpack_require__(1467);
	__webpack_require__(1468);
	__webpack_require__(1469);
	__webpack_require__(1470);
	__webpack_require__(1471);
	__webpack_require__(1474);
	__webpack_require__(1472);
	__webpack_require__(1473);
	__webpack_require__(1475);
	__webpack_require__(1476);
	__webpack_require__(1477);
	__webpack_require__(1478);
	__webpack_require__(1480);
	__webpack_require__(1479);
	__webpack_require__(1524);
	__webpack_require__(1522);
	__webpack_require__(1523);
	__webpack_require__(1565);
	__webpack_require__(1568);
	__webpack_require__(1567);
	__webpack_require__(1569);
	__webpack_require__(1570);
	__webpack_require__(1566);
	__webpack_require__(1571);
	__webpack_require__(1572);
	__webpack_require__(1546);
	__webpack_require__(1549);
	__webpack_require__(1545);
	__webpack_require__(1543);
	__webpack_require__(1544);
	__webpack_require__(1547);
	__webpack_require__(1548);
	__webpack_require__(1530);
	__webpack_require__(1564);
	__webpack_require__(1529);
	__webpack_require__(1563);
	__webpack_require__(1575);
	__webpack_require__(1577);
	__webpack_require__(1528);
	__webpack_require__(1562);
	__webpack_require__(1574);
	__webpack_require__(1576);
	__webpack_require__(1527);
	__webpack_require__(1573);
	__webpack_require__(1526);
	__webpack_require__(1531);
	__webpack_require__(1532);
	__webpack_require__(1533);
	__webpack_require__(1534);
	__webpack_require__(1535);
	__webpack_require__(1537);
	__webpack_require__(1536);
	__webpack_require__(1538);
	__webpack_require__(1539);
	__webpack_require__(1540);
	__webpack_require__(1542);
	__webpack_require__(1541);
	__webpack_require__(1551);
	__webpack_require__(1552);
	__webpack_require__(1553);
	__webpack_require__(1554);
	__webpack_require__(1556);
	__webpack_require__(1555);
	__webpack_require__(1558);
	__webpack_require__(1557);
	__webpack_require__(1559);
	__webpack_require__(1560);
	__webpack_require__(1561);
	__webpack_require__(1525);
	__webpack_require__(1550);
	__webpack_require__(1580);
	__webpack_require__(1579);
	__webpack_require__(1578);
	module.exports = __webpack_require__(85);


/***/ },
/* 1582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hyphenateProperty;
	
	var _hyphenateStyleName = __webpack_require__(1780);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hyphenateProperty(property) {
	  return (0, _hyphenateStyleName2.default)(property);
	}
	module.exports = exports['default'];

/***/ },
/* 1583 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:FontAwesome;src:url(" + __webpack_require__(837) + ");src:url(" + __webpack_require__(836) + "?#iefix&v=4.7.0) format(\"embedded-opentype\"),url(" + __webpack_require__(955) + ") format(\"woff2\"),url(" + __webpack_require__(956) + ") format(\"woff\"),url(" + __webpack_require__(839) + ") format(\"truetype\"),url(" + __webpack_require__(838) + "#fontawesomeregular) format(\"svg\");font-weight:400;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.33333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.28571429em;text-align:center}.fa-ul{padding-left:0;margin-left:2.14285714em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.14285714em;width:2.14285714em;top:.14285714em;text-align:center}.fa-li.fa-lg{left:-1.85714286em}.fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{animation:fa-spin 2s infinite linear}.fa-pulse{animation:fa-spin 1s infinite steps(8)}@keyframes fa-spin{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";transform:scaleX(-1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";transform:scaleY(-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-pp:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before,.fa-resistance:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before,.fa-y-combinator-square:before,.fa-yc-square:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-bed:before,.fa-hotel:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-y-combinator:before,.fa-yc:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery-full:before,.fa-battery:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-paper-o:before,.fa-hand-stop-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-television:before,.fa-tv:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-gitlab:before{content:\"\\F296\"}.fa-wpbeginner:before{content:\"\\F297\"}.fa-wpforms:before{content:\"\\F298\"}.fa-envira:before{content:\"\\F299\"}.fa-universal-access:before{content:\"\\F29A\"}.fa-wheelchair-alt:before{content:\"\\F29B\"}.fa-question-circle-o:before{content:\"\\F29C\"}.fa-blind:before{content:\"\\F29D\"}.fa-audio-description:before{content:\"\\F29E\"}.fa-volume-control-phone:before{content:\"\\F2A0\"}.fa-braille:before{content:\"\\F2A1\"}.fa-assistive-listening-systems:before{content:\"\\F2A2\"}.fa-american-sign-language-interpreting:before,.fa-asl-interpreting:before{content:\"\\F2A3\"}.fa-deaf:before,.fa-deafness:before,.fa-hard-of-hearing:before{content:\"\\F2A4\"}.fa-glide:before{content:\"\\F2A5\"}.fa-glide-g:before{content:\"\\F2A6\"}.fa-sign-language:before,.fa-signing:before{content:\"\\F2A7\"}.fa-low-vision:before{content:\"\\F2A8\"}.fa-viadeo:before{content:\"\\F2A9\"}.fa-viadeo-square:before{content:\"\\F2AA\"}.fa-snapchat:before{content:\"\\F2AB\"}.fa-snapchat-ghost:before{content:\"\\F2AC\"}.fa-snapchat-square:before{content:\"\\F2AD\"}.fa-pied-piper:before{content:\"\\F2AE\"}.fa-first-order:before{content:\"\\F2B0\"}.fa-yoast:before{content:\"\\F2B1\"}.fa-themeisle:before{content:\"\\F2B2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\F2B3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\F2B4\"}.fa-handshake-o:before{content:\"\\F2B5\"}.fa-envelope-open:before{content:\"\\F2B6\"}.fa-envelope-open-o:before{content:\"\\F2B7\"}.fa-linode:before{content:\"\\F2B8\"}.fa-address-book:before{content:\"\\F2B9\"}.fa-address-book-o:before{content:\"\\F2BA\"}.fa-address-card:before,.fa-vcard:before{content:\"\\F2BB\"}.fa-address-card-o:before,.fa-vcard-o:before{content:\"\\F2BC\"}.fa-user-circle:before{content:\"\\F2BD\"}.fa-user-circle-o:before{content:\"\\F2BE\"}.fa-user-o:before{content:\"\\F2C0\"}.fa-id-badge:before{content:\"\\F2C1\"}.fa-drivers-license:before,.fa-id-card:before{content:\"\\F2C2\"}.fa-drivers-license-o:before,.fa-id-card-o:before{content:\"\\F2C3\"}.fa-quora:before{content:\"\\F2C4\"}.fa-free-code-camp:before{content:\"\\F2C5\"}.fa-telegram:before{content:\"\\F2C6\"}.fa-thermometer-4:before,.fa-thermometer-full:before,.fa-thermometer:before{content:\"\\F2C7\"}.fa-thermometer-3:before,.fa-thermometer-three-quarters:before{content:\"\\F2C8\"}.fa-thermometer-2:before,.fa-thermometer-half:before{content:\"\\F2C9\"}.fa-thermometer-1:before,.fa-thermometer-quarter:before{content:\"\\F2CA\"}.fa-thermometer-0:before,.fa-thermometer-empty:before{content:\"\\F2CB\"}.fa-shower:before{content:\"\\F2CC\"}.fa-bath:before,.fa-bathtub:before,.fa-s15:before{content:\"\\F2CD\"}.fa-podcast:before{content:\"\\F2CE\"}.fa-window-maximize:before{content:\"\\F2D0\"}.fa-window-minimize:before{content:\"\\F2D1\"}.fa-window-restore:before{content:\"\\F2D2\"}.fa-times-rectangle:before,.fa-window-close:before{content:\"\\F2D3\"}.fa-times-rectangle-o:before,.fa-window-close-o:before{content:\"\\F2D4\"}.fa-bandcamp:before{content:\"\\F2D5\"}.fa-grav:before{content:\"\\F2D6\"}.fa-etsy:before{content:\"\\F2D7\"}.fa-imdb:before{content:\"\\F2D8\"}.fa-ravelry:before{content:\"\\F2D9\"}.fa-eercast:before{content:\"\\F2DA\"}.fa-microchip:before{content:\"\\F2DB\"}.fa-snowflake-o:before{content:\"\\F2DC\"}.fa-superpowers:before{content:\"\\F2DD\"}.fa-wpexplorer:before{content:\"\\F2DE\"}.fa-meetup:before{content:\"\\F2E0\"}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}", ""]);
	
	// exports


/***/ },
/* 1584 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".rw-btn,.rw-filter-input,.rw-input,.rw-input-reset{color:inherit;padding:0;margin:0;border:none;box-shadow:none;background:none;background-image:none;font-family:inherit;font-size:inherit;line-height:inherit;-ms-touch-action:manipulation;touch-action:manipulation}.rw-btn::-moz-focus-inner{padding:0;border:0}select.rw-input{text-transform:none}html input[type=button].rw-input{-webkit-appearance:button;cursor:pointer}textarea.rw-input{overflow:auto;resize:vertical}button[disabled].rw-input,fieldset[disabled] .rw-input,html input[disabled].rw-input{cursor:not-allowed}button.rw-input::-moz-focus-inner,input.rw-input::-moz-focus-inner{border:0;padding:0}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}@font-face{font-family:RwWidgets;font-weight:400;font-style:normal;src:url(" + __webpack_require__(1759) + ");src:url(" + __webpack_require__(1758) + "?#iefix&v=4.1.0) format(\"embedded-opentype\"),url(" + __webpack_require__(2219) + ") format(\"woff\"),url(" + __webpack_require__(1761) + ") format(\"truetype\"),url(" + __webpack_require__(1760) + "#fontawesomeregular) format(\"svg\")}.rw-i{display:inline-block;color:inherit;font-family:RwWidgets;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.rw-i-caret-down:before{content:\"\\E803\"}.rw-i-caret-up:before{content:\"\\E800\"}.rw-i-chevron-left:before{content:\"\\F104\"}.rw-i-chevron-right:before{content:\"\\F105\"}.rw-i-clock-o:before{content:\"\\E805\"}.rw-i-calendar:before{content:\"\\E804\"}.rw-i-search:before{content:\"\\E801\"}.rw-btn{position:relative;color:#333;display:inline-block;text-align:center;vertical-align:middle;border:1px solid transparent;cursor:pointer;outline:none}.rw-state-disabled .rw-btn,.rw-state-readonly .rw-btn{cursor:not-allowed}.rw-btn-select{opacity:.75;filter:alpha(opacity=75);transition:opacity .15s ease-in}.rw-btn-select:hover,.rw-state-focus .rw-btn-select,:hover>.rw-btn-select{opacity:1;filter:alpha(opacity=100)}.rw-btn-primary{width:100%;white-space:normal;line-height:2em}.rw-btn-primary:hover{background-color:#e6e6e6}.rw-btn-primary[disabled],.rw-btn-select[disabled],fieldset[disabled] .rw-btn-primary,fieldset[disabled] .rw-btn-select{box-shadow:none;cursor:not-allowed;opacity:.65;filter:alpha(opacity=65);pointer-events:none}.rw-sr{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0}.rw-widget{background-clip:border-box;border:none;color:#333;font-size:1em;font-family:inherit;outline:none;position:relative}.rw-widget,.rw-widget *,.rw-widget:after,.rw-widget :after,.rw-widget:before,.rw-widget :before{box-sizing:border-box}.rw-widget>.rw-widget-container{width:100%;margin:0}.rw-widget-container{background-color:#fff;border:1px solid #ccc;border-radius:4px}.rw-state-focus>.rw-widget-container,.rw-state-focus>.rw-widget-container:hover,.rw-widget-container.rw-state-focus,.rw-widget-container.rw-state-focus:hover{box-shadow:0 0 8px rgba(102,175,233,.6);border-color:#66afe9}.rw-state-readonly>.rw-widget-container,.rw-widget-container.rw-state-readonly{cursor:not-allowed}.rw-state-disabled>.rw-widget-container,.rw-state-disabled>.rw-widget-container:active,.rw-state-disabled>.rw-widget-container:hover,.rw-widget-container.rw-state-disabled,.rw-widget-container.rw-state-disabled:active,.rw-widget-container.rw-state-disabled:hover,fieldset[disabled] .rw-widget-container,fieldset[disabled] .rw-widget-container:active,fieldset[disabled] .rw-widget-container:hover{box-shadow:none;cursor:not-allowed}.rw-widget-picker{position:relative;overflow:hidden;border-collapse:separate;display:inline-table;height:2.429em}.rw-widget-picker>*{position:relative;border:none;outline:none;width:100%;height:100%;display:table-cell}.rw-widget-picker>.rw-select{width:1%;white-space:nowrap}.rw-open>.rw-widget-picker{border-bottom-right-radius:0;border-bottom-left-radius:0}.rw-open-up>.rw-widget-picker{border-top-right-radius:0;border-top-left-radius:0}.rw-state-disabled>.rw-widget-picker,fieldset[disabled] .rw-widget-picker{background-color:#eee}.rw-select{cursor:pointer}.rw-select>*{width:1.9em;height:100%}.rw-state-disabled .rw-select,.rw-state-readonly .rw-select{cursor:not-allowed}.rw-select-bordered{cursor:pointer;border:none;border-left:1px solid #ccc}.rw-select-bordered:active,.rw-select-bordered:hover{background-color:#e6e6e6}.rw-select-bordered:active{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.rw-state-disabled .rw-select-bordered,.rw-state-disabled .rw-select-bordered:active,.rw-state-disabled .rw-select-bordered:hover,.rw-state-readonly .rw-select-bordered,.rw-state-readonly .rw-select-bordered:active,.rw-state-readonly .rw-select-bordered:hover,fieldset[disabled] .rw-select-bordered,fieldset[disabled] .rw-select-bordered:active,fieldset[disabled] .rw-select-bordered:hover{cursor:not-allowed;background-color:inherit;background-image:none;box-shadow:none}.rw-rtl .rw-select-bordered{border-right:1px solid #ccc;border-left:none}.rw-rtl{direction:rtl}.rw-filter-input,.rw-input,.rw-input-reset{outline:0}.rw-input-reset::-moz-placeholder{color:#999;opacity:1}.rw-input-reset:-ms-input-placeholder{color:#999}.rw-input-reset::-webkit-input-placeholder{color:#999}.rw-filter-input,.rw-input{color:#555;padding:0 .857em;background-color:#fff}.rw-input[type=text]::-ms-clear{display:none}.rw-input[disabled],fieldset[disabled] .rw-input{box-shadow:none;cursor:not-allowed;opacity:1;background-color:#eee;border-color:#ccc}.rw-input[readonly]{cursor:not-allowed}.rw-i.rw-loading{display:block;background:url(" + __webpack_require__(2221) + ") no-repeat 50%;min-width:16px;width:1.9em;height:16px}.rw-i.rw-loading:before{content:\"\"}.rw-placeholder{color:#999}.rw-filter-input,.rw-widget-input{box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.rw-widget-input.rw-state-focus{box-shadow:0 0 8px rgba(102,175,233,.6),inset 0 1px 1px rgba(0,0,0,.075)}.rw-list{margin:0;padding:0;list-style:none;font-size:1em;outline:0;overflow:auto;max-height:200px}.rw-list-option{user-select:none;color:#333;cursor:pointer;border:1px solid transparent}.rw-list-option.rw-state-focus,.rw-list-option.rw-state-focus:hover{background-color:transparent;border:1px solid #66afe9;color:#333}.rw-list-option:hover,.rw-list-option:hover.rw-state-focus{background-color:#e6e6e6;border:1px solid #e6e6e6;color:#333}.rw-list-option.rw-state-selected,.rw-list-option.rw-state-selected:hover{background-color:#337ab7;border:1px solid #337ab7;color:#fff}.rw-list-option.rw-state-disabled,.rw-list-option.rw-state-readonly,fieldset[disabled] .rw-list-option{box-shadow:none;cursor:not-allowed;color:#999;filter:alpha(opacity=7);opacity:.7}.rw-list-option.rw-state-disabled:hover,.rw-list-option.rw-state-readonly:hover,fieldset[disabled] .rw-list-option:hover{background:none;border-color:transparent}.rw-list-empty,.rw-list-optgroup,.rw-list-option{padding:.143em .75em;outline:0}.rw-list-optgroup{font-weight:700;padding-top:7px}.rw-list-option-create{border-top:1px solid #ccc}.rw-dropdown-list-input{background-color:transparent;vertical-align:middle;padding-right:0;max-width:1px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.rw-rtl .rw-dropdown-list-input{padding-right:.857em;padding-left:0}.rw-filter-input{position:relative;margin:4px;padding-right:0}.rw-filter-input .rw-rtl{padding-right:.857em;padding-left:0}.rw-filter-input .rw-btn,.rw-filter-input .rw-select{opacity:.75;filter:alpha(opacity=75);cursor:text}.rw-filter-input>.rw-select,.rw-filter-input>.rw-select:active,.rw-filter-input>.rw-select:hover{background:none;cursor:auto;box-shadow:none}.rw-number-picker .rw-btn{cursor:pointer;height:calc(1.2145em - 1px);margin-top:-1px\\9;height:1.2145em\\9;line-height:1.2145em;line-height:calc(1.2145em - 1px);display:block;border:none}.rw-number-picker .rw-btn:active,.rw-number-picker .rw-btn:hover{background-color:#e6e6e6}.rw-number-picker .rw-btn:active{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.rw-state-disabled .rw-number-picker .rw-btn,.rw-state-disabled .rw-number-picker .rw-btn:active,.rw-state-disabled .rw-number-picker .rw-btn:hover,.rw-state-readonly .rw-number-picker .rw-btn,.rw-state-readonly .rw-number-picker .rw-btn:active,.rw-state-readonly .rw-number-picker .rw-btn:hover,fieldset[disabled] .rw-number-picker .rw-btn,fieldset[disabled] .rw-number-picker .rw-btn:active,fieldset[disabled] .rw-number-picker .rw-btn:hover{cursor:not-allowed;background-color:inherit;background-image:none;box-shadow:none}.rw-number-picker .rw-select{vertical-align:middle}.rw-number-picker .rw-select,.rw-number-picker .rw-select:active,.rw-number-picker .rw-select:hover{box-shadow:none}.rw-calendar-popup{right:auto;min-width:0;width:18em}.rw-calendar{border-radius:4px;background-color:#fff;border:1px solid #ccc;overflow:hidden}.rw-calendar.rw-popup{border-color:#ccc}.rw-calendar-now{font-weight:700}.rw-calendar-btn-left,.rw-calendar-btn-right{width:12.5%}.rw-calendar-btn-view{width:75%}.rw-calendar-footer{border-top:1px solid #ccc}.rw-calendar-grid{outline:none;height:14.28571429em;table-layout:fixed;border-collapse:separate;border-spacing:0;width:100%;background-color:#fff}.rw-calendar-grid th{border-bottom:1px solid #ccc}.rw-calendar-grid th,.rw-cell{text-align:center;padding:.25em}.rw-cell{color:#333;border-radius:4px;cursor:pointer;line-height:normal;border:1px solid transparent}.rw-cell:hover{background-color:#e6e6e6;border:1px solid #e6e6e6;color:#333}.rw-cell.rw-state-focus,.rw-cell.rw-state-focus:hover{background-color:transparent;border:1px solid #66afe9;color:#333}.rw-cell.rw-state-selected,.rw-cell.rw-state-selected:hover{background-color:#337ab7;border:1px solid #337ab7;color:#fff}.rw-cell.rw-state-disabled{color:#999;filter:alpha(opacity=7);opacity:.7}.rw-cell.rw-state-disabled:hover{background:none;border-color:transparent}.rw-calendar-month .rw-cell{text-align:center}.rw-cell-off-range{color:#999}.rw-calendar-transition-group{position:relative}.rw-calendar-transition{transition:transform .3s;overflow:hidden}.rw-calendar-transition-top{transform:translateY(-100%)}.rw-calendar-transition-bottom{transform:translateY(100%)}.rw-calendar-transition-right{transform:translateX(-100%)}.rw-calendar-transition-left{transform:translateX(100%)}.rw-calendar-transition-entered.rw-calendar-transition-bottom,.rw-calendar-transition-entered.rw-calendar-transition-top,.rw-calendar-transition-entering.rw-calendar-transition-bottom,.rw-calendar-transition-entering.rw-calendar-transition-top{transform:translateY(0)}.rw-calendar-transition-entered.rw-calendar-transition-left,.rw-calendar-transition-entered.rw-calendar-transition-right,.rw-calendar-transition-entering.rw-calendar-transition-left,.rw-calendar-transition-entering.rw-calendar-transition-right{transform:translateX(0)}.rw-calendar-transition-exiting.rw-calendar-transition-top{transform:translateY(100%)}.rw-calendar-transition-exiting.rw-calendar-transition-bottom{transform:translateY(-100%)}.rw-calendar-transition-exiting.rw-calendar-transition-right{transform:translateX(100%)}.rw-calendar-transition-exiting.rw-calendar-transition-left{transform:translateX(-100%)}.rw-select-list{overflow:auto}.rw-select-list .rw-list{max-height:none;font-size:1em}.rw-select-list-label{display:block;position:relative;font-weight:400;cursor:inherit;padding-left:20px;margin:0}.rw-rtl .rw-select-list-label{padding-left:0;padding-right:20px}input.rw-select-list-input{position:absolute;left:0;top:50%;transform:translateY(-50%);top:.1em/9;margin:0;line-height:normal;cursor:inherit}.rw-rtl input.rw-select-list-input{left:auto;right:0}.rw-loading-mask{position:relative;min-height:50px;border-radius:4px}.rw-loading-mask:after{content:\"\";background:url(" + __webpack_require__(2220) + ") no-repeat 50%;position:absolute;background-color:#fff;opacity:.7;filter:alpha(opacity=70);top:0;left:0;height:100%;width:100%}.rw-multiselect{background-color:#fff;border-color:#e6e6e6;cursor:text}.rw-multiselect .rw-input-reset{height:calc(2.429em - 2px);margin-top:-2px\\9;height:2.429em\\9;border-width:0;width:auto;max-width:100%;padding:0 .857em}.rw-multiselect .rw-select,.rw-multiselect .rw-select:active,.rw-multiselect .rw-select:hover{box-shadow:none;background:none}.rw-multiselect-taglist{margin:0;padding:0;list-style:none;display:inline;outline:none}.rw-multiselect-tag{display:inline-table;color:inherit;padding:0 .35em;margin-left:calc(.279335em - 1px);margin-top:.279335em;margin-top:calc(.279335em - 1px);height:1.87033em;border-radius:3px;background-color:#eee;border:1px solid #ccc;cursor:default;vertical-align:top;text-align:center;overflow:hidden;max-width:100%}.rw-multiselect-tag>*{display:table-cell;vertical-align:middle;height:100%}.rw-rtl .rw-multiselect-tag{margin-left:0;margin-right:calc(.279335em - 1px);padding:0 .35em}.rw-multiselect-tag.rw-state-focus,.rw-multiselect-tag.rw-state-focus:hover{background-color:transparent;border:1px solid #66afe9;color:#333}.rw-multiselect-tag.rw-state-disabled,.rw-multiselect-tag.rw-state-readonly,.rw-state-disabled .rw-multiselect-tag,.rw-state-readonly .rw-multiselect-tag{cursor:not-allowed}.rw-multiselect-tag.rw-state-disabled,.rw-state-disabled .rw-multiselect-tag,fieldset[disabled] .rw-multiselect-tag{opacity:.65;filter:alpha(opacity=65)}fieldset[disabled] .rw-multiselect-tag{box-shadow:none;cursor:not-allowed}.rw-multiselect-tag-btn{color:inherit;margin-left:.25em}.rw-rtl .rw-multiselect-tag-btn{margin-left:0;margin-right:.25em}.rw-autocomplete .rw-select{position:absolute;display:block;width:auto;top:0;bottom:0;right:0}.rw-popup-container{position:absolute;z-index:1005;top:100%;left:-6px;right:-6px}.rw-popup-container.rw-dropup{top:auto;bottom:100%}.rw-state-focus .rw-popup-container{z-index:1006}.rw-popup-transition{width:100%;margin-bottom:6px;padding:0 6px}.rw-dropup>.rw-popup-transition{margin-bottom:0;margin-top:6px}.rw-popup{border-top-right-radius:0;border-top-left-radius:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px;box-shadow:0 5px 6px rgba(0,0,0,.2);border:1px solid #ccc;background:#fff}.rw-dropup .rw-popup{border-bottom-right-radius:0;border-bottom-left-radius:0;border-top-right-radius:3px;border-top-left-radius:3px;box-shadow:0 -2px 6px rgba(0,0,0,.2)}.rw-popup-transition{transition:transform .2s}.rw-popup-transition-entering{overflow:hidden}.rw-popup-transition-entering .rw-popup-transition{transform:translateY(0);transition-timing-function:ease-out}.rw-popup-transition-exiting .rw-popup-transition{transition-timing-function:ease-in}.rw-popup-transition-exited,.rw-popup-transition-exiting{overflow:hidden}.rw-popup-transition-exited .rw-popup-transition,.rw-popup-transition-exiting .rw-popup-transition{transform:translateY(-100%)}.rw-popup-transition-exited.rw-dropup .rw-popup-transition,.rw-popup-transition-exiting.rw-dropup .rw-popup-transition{transform:translateY(100%)}.rw-popup-transition-exited{display:none}.rw-state-disabled{box-shadow:none;cursor:not-allowed}", ""]);
	
	// exports


/***/ },
/* 1585 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".upload-folder-tree li{background:none}", ""]);
	
	// exports


/***/ },
/* 1586 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".folder-tree li{background:none}", ""]);
	
	// exports


/***/ },
/* 1587 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "#apicalls .nav-tabs{height:38px}#apicalls .nav-tabs ul{margin:0;padding:0}#apicalls .nav-tabs li{background:none;margin:0;padding:0}#apicalls table{background:none transparent;border-collapse:collapse;font-size:13px;margin:0;text-align:left;width:100%}#apicalls .period-section{padding:10px 0 0;margin:0;width:50%}#apicalls .period-section .period{position:absolute;width:50px;padding-top:10px;font-size:14px}#apicalls .period-section .selectParent{width:85%;position:relative;float:right}.ir-search-integrations-message{margin-top:10px}", ""]);
	
	// exports


/***/ },
/* 1588 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".filename-template{width:700px}.filename-template .default-configurations{font-size:1.2em;margin-bottom:10px;margin-top:15px}.filename-template .filename-template-heading{font-size:18px;font-weight:700;margin-bottom:5px}.filename-template .filename-template-heading2{font-size:1.2em;margin-bottom:10px}.filename-template .field-group{margin-bottom:15px}.filename-template .label{font-size:1.2em;margin:5px 0;color:#fff}.filename-template .left-panel{display:inline-block;vertical-align:top;width:240px;height:600px;margin-right:10px;padding:5px 10px;border:1px solid gray;border-radius:3px;-webkit-border-radius:5px;-moz-border-radius:5px;background-color:#04547b}.filename-template .right-panel{display:inline-block;width:400px;height:600px}.filename-template .right-panel .label{color:#04547b}.filename-template .right-panel .fields{min-height:155px}.filename-template .right-panel-element{min-height:292px;padding:5px 10px;border:1px solid gray;border-radius:3px;vertical-align:top;-webkit-border-radius:5px;-moz-border-radius:5px;background-color:#f6f6f6}.filename-template .right-panel-element:nth-child(2){margin-top:8px}.filename-template .field{border-radius:5px;-webkit-border-radius:5px;-moz-border-radius:5px;border:1px solid gray;margin:2px 1px;background-color:#f6f6f6;padding:2px 5px}.filename-template .field:hover{cursor:pointer;opacity:.5}.filename-template .field-label{width:130px;margin-right:5px}.filename-template .selected-field{display:inline-block;min-width:15px;text-align:center;border:1px solid gray;position:relative;padding:2px 10px}.filename-template .selected-field:hover{cursor:pointer;opacity:.5}.filename-template .selected-field:hover .close-marker{display:block}.filename-template .close-marker{float:right;position:absolute;top:0;right:0;font-size:8px;color:#555;height:15px;margin-top:-3px;margin-right:2px;display:none}.filename-template .field-separator{display:inline-block;border-radius:5px;-webkit-border-radius:5px;-moz-border-radius:5px;border:1px solid gray;margin:2px;background-color:#f6f6f6;min-width:25px;text-align:center}.filename-template .field-separator:hover{cursor:pointer}.filename-template .separators-fields{text-align:center}.filename-template .edit-btn{pointer-events:all!important;display:inline-block;float:right}.filename-template .action-buttons{height:35px}.filename-template .action-buttons div{float:right;width:115px}.filename-template .action-buttons button:hover{opacity:.5;cursor:pointer}.filename-template .action-buttons .save-btn{margin-left:10px}.filename-template .save-template-button{display:flex;justify-content:center}.filename-template .preview-template-container{margin:20px 0 10px}.filename-template .preview-template-container .label{color:#04547b;font-weight:700}.filename-template .preview-template{min-height:50px;padding:5px 10px;border:1px solid #a9a9a9;border-radius:5px}.filename-template .preview-field{font-weight:700}.filename-template .preview-panel{border-top:1px solid #a9a9a9;min-height:60px;word-break:break-word}.filename-template .ir-tooltip{border-radius:50%;float:right;margin-top:2px}.filename-template .description-max-words{width:20px;margin:0 5px 0 7px}.filename-template .field-no-hover{border-radius:5px;-webkit-border-radius:5px;-moz-border-radius:5px;border:1px solid gray;margin:2px 1px;background-color:#f6f6f6;padding:2px 5px}.filename-template .date-format-selector{margin-top:10px}.filename-template .date-format-selector input{width:100px;margin-left:5px}.filename-template .file-format-configuration{margin-top:5px}.filename-template .add-btn{vertical-align:baseline;margin-left:16px}.filename-template .margin-top-5{margin-top:-5px}.filename-template .customize-description-box{margin-top:15px;margin-bottom:20px}.filename-template .subtext{margin-top:-5px}", ""]);
	
	// exports


/***/ },
/* 1589 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".kloudless-layout .kloudless-ctrl-container{margin-top:10px}.kloudless-layout .kloudless-control-holder{border-bottom:1px solid #bbb;height:42px}.kloudless-layout .kloudless-control-holder2{display:flex;align-items:center;margin:15px 0;border-bottom:1px solid #bbb;padding-bottom:10px}.kloudless-layout .kloudless-control-holder2 img{max-width:230px;max-height:45px}.kloudless-layout .kloudless-switch{width:72px;height:30px;margin-left:auto;padding:0;background:url(/sites/all/themes/inforuptcy/images/off_button_small.png) no-repeat 0 0;cursor:pointer}.kloudless-layout .kloudless-switch.on{background-image:url(\"/sites/all/themes/inforuptcy/images/on_button_small.png\")}.kloudless-layout .loading-data{padding:20px;display:block;color:#27638c}.kloudless-layout .error-loading{padding:20px;display:block;text-align:center;font-size:14px;color:red}.kloudless-layout .kloudless-switch-container{display:inline-block;width:400px;margin:25px 0 10px;vertical-align:top;border-top:2px solid #27638c}.kloudless-layout .text-description{display:inline-block;width:360px;margin-left:28px;margin-top:10px;vertical-align:top}.kloudless-layout .kloudless-description-text{font-size:1.2em}.kloudless-layout .hidden{opacity:.5;pointer-events:none}.kloudless-layout .calendar-switch{color:#304052}.kloudless-layout .calendar-switch .fa-calendar{color:#ffb500}.kloudless-layout .calendar-feed-settings .calendar-feed p:last-child{margin-bottom:0}.kloudless-layout .preview-template-container li,.kloudless-layout .preview-template-container ul{padding:0;background:none}.kloudless-layout .preview-template-container li{padding-left:12px}", ""]);
	
	// exports


/***/ },
/* 1590 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".client_code{position:absolute!important;width:240px!important;right:10px!important;text-align:left!important}.client_code div{display:block!important}.client_code .select-wrapper{display:flex!important;align-items:center!important}.client_code .selector-container{width:100%!important}.client_code .selector-container label{font-weight:700!important;font-size:12px!important;display:inline-block!important}.client_code .selector-container .react-select-container{width:165px!important}.client_code .selector-container .Select-control{height:28px!important;display:table!important}.client_code .selector-container .Select-control .Select-placeholder,.client_code .selector-container .Select-control .Select-value,.client_code .selector-container .Select-control .Select-value .Select-value-label{line-height:26px!important}.client_code .selector-container .Select-control .Select-input{height:26px!important}.client_code .selector-container .Select-arrow-zone{background-color:#d9d9d9!important;border:1px solid #b3b3b3!important}.client_code .selector-container .Select-option.is-focused,.client_code .selector-container .Select-option.is-selected{background-color:#ebf5ff!important}.client_code .selector-container #clientMsg{position:absolute!important;display:block!important;border-radius:2px!important;border:1px solid #eed200!important;background-color:#fffede!important;padding:5px!important;cursor:pointer!important;color:#000!important;text-align:left!important;z-index:99!important}.client_code .selector-container #clientMsgCloseBtn{position:absolute!important;top:0!important;right:2px!important;font-size:12px!important;border:1px solid #fffede!important;background-color:#fffede!important}.client_code .selector-container #clientCodeMsg{padding-top:12px!important;word-wrap:break-word!important}.client_code .selector-container .highlight{outline:9999px solid rgba(0,0,0,.2)!important}.client_code .client-code-option-parent{font-weight:700!important}.client_code .client-code-option-child{margin-left:10px!important}", ""]);
	
	// exports


/***/ },
/* 1591 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".submit-button{font-size:18px!important;border-radius:5px;color:#fff!important;font-family:Helvetica,Arial,sans-serif!important;font-weight:700;padding:6px 10px 5px;text-decoration:none;text-align:center;outline:0;margin:0;border:1px solid #174522;-moz-box-shadow:inset 0 1px 0 0 #b1b9cb;cursor:pointer;text-transform:none;white-space:nowrap;position:relative;background:#248229;background:linear-gradient(center top,#70b375 0,#3f9144 50%,#248229 0,#2a8530) repeat scroll 0 0 transparent}.submit-button:hover{background:#1f7023;background:linear-gradient(center top,#65a169 0,#37803c 50%,#1f7023 0,#25732a) repeat scroll 0 0 transparent}", ""]);
	
	// exports


/***/ },
/* 1592 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ },
/* 1593 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".alert-message{margin-top:10px;padding:15px;border:1px solid #ebccd1;border-radius:4px;color:#a94442;background-color:#f2dede}", ""]);
	
	// exports


/***/ },
/* 1594 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".date-picker-parent-container>.date-picker-container{width:calc(50% - 5px);margin-right:10px}label.date-picker-label{font-weight:700;font-size:12px;display:block}input.date-picker{line-height:34px;padding-left:10px;padding-right:10px;border-radius:4px;border:1px solid #ccc;width:100%}.date-picker-container>div{display:flex}", ""]);
	
	// exports


/***/ },
/* 1595 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".date-picker-parent-container>div{width:calc(50% - 5px);margin-right:10px}.date-picker-parent-container>div:last-child{margin-right:0}.date-picker-container>div{display:flex;height:36px}.date-picker-container>div>input{height:34px}.rw-calendar{width:255px}", ""]);
	
	// exports


/***/ },
/* 1596 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".date-picker-custom .date-picker-container{width:100%}.date-picker-custom .date-picker-container,.date-picker-custom .date-picker-container div,.date-picker-custom .date-picker-container input,.date-picker-custom .date-picker-container span{cursor:text;box-sizing:border-box;position:relative}.date-picker-custom .date-picker-container>div{background-color:#fff;border-radius:4px;border:1px solid #ccc;color:#333;cursor:default;border-spacing:0;border-collapse:separate;height:36px;outline:none;overflow:hidden;position:relative;width:100%}.date-picker-custom .date-picker-container>div>div{background-color:rgba(0,126,255,.08);border-radius:2px;margin-left:5px;vertical-align:top}.date-picker-custom .date-picker-container>div>div,.date-picker-custom input{margin-top:7px;color:#007eff;display:inline-block;font-size:.9em;line-height:1.4}.date-picker-custom input{cursor:default;padding:2px 5px;vertical-align:middle;background-color:#ebf5ff;border-radius:2px;border:1px solid rgba(0,126,255,.24);margin-left:4px;margin-right:4px;width:calc(100% - 8px)}.date-picker-custom span{cursor:text;display:block}.ui-timepicker-div{min-height:52px}.ui-datepicker-calendar+.ui-timepicker-div{min-height:inherit}", ""]);
	
	// exports


/***/ },
/* 1597 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "fieldset.ir-fieldset{width:100%;border:1px solid orange;border-radius:8px;padding:10px;margin-bottom:12px}fieldset.ir-fieldset legend{color:orange;padding:0 6px;margin-left:-6px}", ""]);
	
	// exports


/***/ },
/* 1598 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".form-option{float:left;border-radius:4px;margin-right:15px;display:block;padding:7px 12px 8px}.form-option,.form-option *{cursor:pointer}.form-option label{font-weight:400;margin:0}.form-option label input[type=radio]{margin:0;vertical-align:middle}.form-option:hover{background:#eee}.form-option.selected{color:#fff!important;background:#246788!important}", ""]);
	
	// exports


/***/ },
/* 1599 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".form-options{display:flex;margin-bottom:15px}", ""]);
	
	// exports


/***/ },
/* 1600 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".info-message{margin:10px 0;background:#fffce3;border:2px solid #eed300;color:#c28e00;font-weight:700;font-size:1.166em;padding:10px;-moz-border-radius:6px;-webkit-border-radius:6px}", ""]);
	
	// exports


/***/ },
/* 1601 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".loading-bar{text-align:left;margin:20px 0}", ""]);
	
	// exports


/***/ },
/* 1602 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".receipt-module{margin:15px auto 0;width:400px}.receipt-module table{border:1px solid #ccc;background-color:#fff;font-size:.8em}.receipt-module table thead th{font-size:1.25em;font-weight:700;color:#05a;text-align:center}.receipt-module table tbody th{width:75px;text-align:right;font-weight:700}.receipt-module table tbody td{text-align:left}.receipt-module table th{padding:0 1em;border:none}.receipt-module table td{border:none;padding:0 1em 0 0}", ""]);
	
	// exports


/***/ },
/* 1603 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".results-table thead tr{vertical-align:bottom}", ""]);
	
	// exports


/***/ },
/* 1604 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".selector-container{margin-right:10px;margin-bottom:6px;display:inline-block}.selector-container label{font-weight:700;font-size:12px;display:block}.selector-container .selector{display:inline-table;width:100%}.selector-container:last-child{margin-right:0}.Select--multi .Select-value{margin-top:7px}", ""]);
	
	// exports


/***/ },
/* 1605 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".ir-warning-box{background:#ffd;color:#220;padding:2px;border:1px solid #f0c020;margin:15px 0}", ""]);
	
	// exports


/***/ },
/* 1606 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".advanced-search-form{width:774px}.advanced-search-form .btn-search{font-size:14px}.advanced-search-form .btn-blink{animation:blinker 2s ease-in}@keyframes blinker{50%{opacity:0}}.advanced-search-form .form-item{margin-top:6px;margin-bottom:12px}.advanced-search-form .form-item-btn{display:flex}.advanced-search-form .form-item-btn .btn-search{margin-left:12px}.advanced-search-form .advanced-search-filters{width:65%}.advanced-search-form .advanced-search-helper{width:32%;float:right}.advanced-search-form .advanced-search-helper .help-operators{background-color:#f9f9f9;border:1px solid #ebebeb;color:#000}.advanced-search-form .advanced-search-helper .help-operators h4{background-color:#246788;color:#fff;border-bottom:1px solid #ebebeb;font-size:1.1em;font-weight:700;padding:5px 10px}.advanced-search-form .advanced-search-helper .help-operators tbody,.advanced-search-form .advanced-search-helper .help-operators td{border:0;padding:6px 12px;cursor:pointer}.advanced-search-form .advanced-search-helper .help-link{margin-top:2em}.advanced-search-form .ir-fieldset{box-sizing:border-box;padding:0 10px}.advanced-search-form .form-input{background-color:#fff;border-radius:4px;border:1px solid #ccc;color:#333;height:32px;padding:0 4px;box-sizing:border-box;width:100%}.advanced-search-form .form-input.keys{font-size:16px!important;height:36px;padding-left:5px}.advanced-search-form .react-datepicker-wrapper .form-input{width:234px}.advanced-search-form .form-item-row{display:flex}.advanced-search-form .form-item-row .col-2{width:calc(50% - 6px)}.advanced-search-form .form-item-row .col-2:not(:last-child){margin-right:12px}.advanced-search-form .ir-tooltip{margin-left:5px}.advanced-search-form .alert{white-space:pre-wrap}.advanced-search-form .warning{font-family:Arial,sans-serif}.advanced-search-form .action-btn-container{margin-top:0}.advanced-search-form .action-btn-container button:not(:last-of-type),.advanced-search-form .financial-filter>div:not(:last-child){margin-right:12px}.advanced-search-form .financial-filter>div:first-child{width:22%}.advanced-search-form .financial-filter>div:not(:first-child){width:30%}.advanced-search-tab{margin:12px;width:774px}.advanced-search-modal.modal-dialog{width:513px}.advanced-search-modal .advanced-search-form{width:100%}.advanced-search-modal .modal-footer{display:flex;justify-content:space-between}", ""]);
	
	// exports


/***/ },
/* 1607 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".associated-cases table tbody tr:last-child td{border-bottom:0}.associated-cases .case-label{text-align:center;margin:20px 0}.associated-cases .messages{margin-bottom:30px}.associated-cases .live_search{margin-top:15px;margin-bottom:30px}", ""]);
	
	// exports


/***/ },
/* 1608 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".other-court-info table tbody tr:last-child td{border-bottom:0}.other-court-info .case-label{text-align:center;margin:20px 0}.other-court-info .messages{margin-bottom:30px}.other-court-info .live_search{margin-top:15px;margin-bottom:30px}", ""]);
	
	// exports


/***/ },
/* 1609 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".other-filings table tbody tr:last-child td{border-bottom:0}.other-filings .case-label{text-align:center;margin:20px 0}.other-filings .messages{margin-bottom:30px}.other-filings .live_search{margin-top:15px;margin-bottom:30px}", ""]);
	
	// exports


/***/ },
/* 1610 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".related-cases table tbody tr:last-child td{border-bottom:0}.related-cases .case-label{text-align:center;margin:20px 0}.related-cases .messages{margin-bottom:30px}.related-cases .live_search{margin-top:15px;margin-bottom:30px}", ""]);
	
	// exports


/***/ },
/* 1611 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".case-attorneys table tbody tr:last-child td{border-bottom:0}", ""]);
	
	// exports


/***/ },
/* 1612 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".clientcode-dialog .top-bar{background-color:#fffbe3!important;color:#000!important}.clientcode-dialog .popup-inner{bottom:50%!important}.clientcode-dialog .error-text{margin:20px!important;font-size:12px!important;color:#666!important;font-weight:700!important}", ""]);
	
	// exports


/***/ },
/* 1613 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "#ir-search-creditor-mailing-results .download{display:inline-block;width:100%}#ir-search-creditor-mailing-results .download a{display:inline-block}#ir-search-creditor-mailing-results .download span{color:blue;display:inline-block;padding-left:5px}#ir-search-creditor-mailing-results .download-link{float:right}#ir-search-creditor-mailing-results .download-link img{padding-right:5px}#ir-search-creditor-mailing-results .download-link .ir-search-refresh-date span{color:inherit}#ir-search-creditor-mailing-results textarea{resize:none}", ""]);
	
	// exports


/***/ },
/* 1614 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".case-creditors table tbody tr:last-child td{border-bottom:0}", ""]);
	
	// exports


/***/ },
/* 1615 */
1592,
/* 1616 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "#tab-dockets{overflow:initial!important}.docket table tbody tr:last-child td{border-bottom:0}.docket #pacer-filter .close{font-size:16px}.docket #docket-header-content h2{font-size:11px}.docket .case-label{text-align:center;margin-bottom:20px}.docket .messages{margin-bottom:20px}.docket .date-selector{display:inline-block;width:100px;margin-right:10px}.docket #parser-docket-form input{display:inline-block;margin-right:5px}.docket #parser-docket-form .alfresco-doc-range{margin-left:5px}.docket .react-datepicker-wrapper input{width:101px!important}.docket .item:hover{cursor:pointer;background-color:rgba(0,0,0,.1)}.docket .ellipse:hover{cursor:default;background-color:inherit}.docket .delayed .menu{display:block!important;visibility:hidden!important;transform:translateY(0)!important;opacity:0!important;transition:all .6s ease-in-out 0s,visibility 0s linear .4s,z-index 0s linear .2s!important}.docket .delayed:hover .menu{visibility:visible!important;transform:translateY(-2em)!important;opacity:1!important;transform:translateY(0)!important;transition-delay:0s,0s,.7s!important}.docket .live_search{margin-top:20px;margin-bottom:10px}.docket .show-pacer-search-bar{opacity:.5}.docket #docket_update_ctrl img{margin-right:5px}.docket .alert{margin:20px 0}.docket .dockets-popup .inner-text,.docket .email-popup .inner-text{padding:10px}.docket .email-popup img{text-align:center}.docket .filter-table{margin-bottom:20px}.docket .filter-table.collapsed .live_search{display:none}.docket .view_details:hover{cursor:pointer;opacity:.5}.docket .docket-entries-table tr .loading-bar{margin-bottom:0}.docket .contacting{margin-top:10px;margin-bottom:-10px}.docket .missing-dockets{height:50px;background-color:#fcf8e4;text-align:center;font-size:12px}.docket .missing-dockets button{background-color:#236f28;color:#fff;height:25px;padding:0 10px;margin-left:20px}.docket .missing-dockets button:hover{cursor:pointer;opacity:.5}.docket .email-pdf,.docket .print{display:inline-block}.docket .email-pdf:hover,.docket .print:hover{cursor:pointer;opacity:.5}.docket .email-pdf-alert{z-index:999;position:fixed;left:0;bottom:0;background-color:#28a745;margin-left:10px;margin-bottom:10px;color:#fff;border-radius:5px;visibility:hidden;opacity:0;-webkit-animation-name:flash-animation;-webkit-animation-duration:7s;animation-name:flash-animation;animation-duration:7s}.docket .email-pdf-alert .alert{margin:0;padding:10px 15px!important}.docket .dim{opacity:.5}@keyframes flash-animation{0%{background:#28a745;visibility:visible;opacity:1}to{background:none;visibility:hidden;opacity:0}}.docket .react-datepicker-wrapper input{width:95px}.docket .missing-entries-tooltip{font-size:12px;margin-top:15px;padding:5px!important;font-weight:400!important;color:#666!important}.docket .clear-button{display:inline-block;color:#27638c}.docket .clear-button:hover{opacity:.5;cursor:pointer}.docket .docket-error .top-bar{background-color:#fffbe3!important;color:#000!important}.docket .docket-error .popup-inner{bottom:50%!important}.docket .docket-error .error-text{margin:20px!important;font-size:12px!important;color:#666!important;font-weight:700!important}.docket .buy-btn{display:block}.docket #download{display:inline-block}.docket #download:hover{cursor:pointer;opacity:.5}.docket .delayed:hover .menu{transition-delay:.3s,.3s,.7s!important}.docket .update-redact{display:inline-block}.docket .update-redact:hover{opacity:.5;cursor:pointer}.docket .purchase-popup{width:80%;margin-top:10px;margin-bottom:15px}.docket .permission-check-links,.docket .permission-check-links .menu,.docket .permission-check-links>div{display:inline-block}.docket .permission-check-links a{margin:0 5px}.docket .permission-check-links textarea{width:100%}.docket .hide-docket-entry-row{display:none}.docket .blog-post icon,.docket .ocr.icon{margin-left:5px}.docket .details-visible{border-top:1px solid #d3d3d3}.docket .form-group{position:relative}.docket .form-group a{position:absolute;top:-2px;right:10px;font-size:16px;cursor:pointer}", ""]);
	
	// exports


/***/ },
/* 1617 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".docket-popup .bulk-client-code{width:60%}.docket-popup .bg-color-grey{padding:8px;background:#eee}.docket-popup .footer-btn{margin-top:16px}.docket-popup .docket-info-section{margin:5px}.docket-popup .docket-number-link{cursor:pointer}.docket-popup .email-bulk-buy-container{display:flex;align-items:center}.docket-popup .email-bulk-buy-button{margin-top:18px}", ""]);
	
	// exports


/***/ },
/* 1618 */
1592,
/* 1619 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "#history-pacer-filter{background:#eee;border:0!important}#history-pacer-filter .inside-block{overflow:hidden}#history-pacer-filter .hide-link{cursor:pointer;color:#27638c;float:right;font-size:10px}#history-pacer-filter #history-pacer-form .form-reset{color:#27638c;margin-left:10px;background:#eee;border:0;cursor:pointer}#history-pacer-filter #history-pacer-form .history-pacer-form-row label{display:block}#history-pacer-filter #history-pacer-form .history-pacer-form-row input[type=checkbox],#history-pacer-filter #history-pacer-form .history-pacer-form-row input[type=radio]{width:10px}.live_search{margin-bottom:10px}.date-selector{display:inline-block;width:100px;margin-right:10px}.react-datepicker-wrapper input{width:95px}.clear-button{display:inline-block;color:#27638c}.clear-button:hover{opacity:.5;cursor:pointer}.history .hide-history-entry-row{display:none}.history ir-search-history-results tbody tr.even{background:#e1f3ff}.history #ir-search-history-results tbody tr.odd{background:#eee}.history #ir-search-history-results table td{border:0;vertical-align:top;padding:6px 8px}.history #ir-search-history-results table tr.even{background:#e1f3ff!important}.history #ir-search-history-results table tr.even.heading td{border-top:2px solid #3b7a99}.history #ir-search-history-results table tr.even td:first-child{-border-left:2px solid #3b7a99}.history #ir-search-history-results table tr.odd{background:#eee}.history #ir-search-history-results table tr.odd.heading td{border-top:2px solid #aaa}.history #ir-search-history-results table tr.odd td:first-child{-border-left:2px solid #aaa}.history table tbody tr:last-child td{border-bottom:0}.history .view_details{cursor:pointer}.history .item:hover{cursor:pointer;color:#27638c}.history .item i{font-size:15px;position:relative;left:3px}.history .item .fa-sort-up{top:5px}.history .item .fa-sort-down{top:-3px}.history .view_details:hover{cursor:pointer;opacity:.5}.history .history-entries-table tr .loading-bar{margin-bottom:0}.history .delayed .menu{display:block!important;visibility:hidden!important;transform:translateY(0)!important;opacity:0!important;transition:all .6s ease-in-out 0s,visibility 0s linear .4s,z-index 0s linear .2s!important}.history .delayed:hover .menu{visibility:visible!important;transform:translateY(-2em)!important;opacity:1!important;transform:translateY(0)!important;transition-delay:0s,0s,.7s!important}.history .dockets-popup .inner-text,.history .email-popup .inner-text{padding:10px}.history .email-popup img{text-align:center}@keyframes flash-animation{0%{background:#28a745;visibility:visible;opacity:1}to{background:none;visibility:hidden;opacity:0}}.history .email-pdf,.history .print{display:inline-block;margin-right:5px}.history .email-pdf:hover,.history .print:hover{cursor:pointer;opacity:.5}.history .email-pdf-alert{z-index:999;position:fixed;left:0;bottom:0;background-color:#28a745;margin-left:10px;margin-bottom:10px;color:#fff;border-radius:5px;visibility:hidden;opacity:0;-webkit-animation-name:flash-animation;-webkit-animation-duration:7s;animation-name:flash-animation;animation-duration:7s}.history .email-pdf-alert .alert{margin:0;padding:10px 15px!important}.history .dim{opacity:.5}.history .clear-button{display:inline-block;color:#27638c}.history .clear-button:hover{opacity:.5;cursor:pointer}.history .buy-btn{display:block}.history #history-filters{background:#eee;padding:6px;margin-bottom:20px}.history #history-filters.collapsed .live_search{display:none}.history #history-filters #parser-history-form input{display:inline-block;margin-right:5px;background:#fff;color:#666;border:1px solid #9babb0;padding:4px}.history #history-filters #parser-history-form button{margin-right:5px}.history #history-filters #parser-history-form .alfresco-doc-range{margin-left:5px}.history #download{display:inline-block}.history #download:hover{cursor:pointer;opacity:.5}.history .permission-check-links,.history .permission-check-links .menu{display:inline-block}.history .permission-check-links a{margin:0 5px}.history .permission-check-links textarea{width:100%}#update-from-pacer-link{float:right;width:135px;margin-top:5px;cursor:pointer}#update-from-pacer-link span{font-size:12px;font-weight:600;position:relative;top:-5px;padding:5px}#update-from-pacer-link .selected-history-filter-,#update-from-pacer-link span:hover{color:brown}", ""]);
	
	// exports


/***/ },
/* 1620 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".parties .sticky-enabled{margin-top:20px}#tab-parties a.form-submit.csv-download{float:right}#tab-parties a.form-submit{-moz-border-image:5px;border-radius:5px;color:#fff!important;font-family:Helvetica,Arial,sans-serif;font-weight:700;padding:6px 10px 5px;text-decoration:none;text-align:center;border:0;outline:0;margin:0;-pie-background:linear-gradient(center top,#518ab1 0,#4b84ab 50%,#27638c 0,#215d86) repeat scroll 0 0 transparent;border:1px solid #172d6e;border-bottom:1px solid #0e1d45;box-shadow:inset 0 1px 0 0 #b1b9cb;text-shadow:0 -1px 1px #000f4d;cursor:pointer;text-transform:none;white-space:nowrap;position:relative}", ""]);
	
	// exports


/***/ },
/* 1621 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "#ir-search-related-transactions-results tbody tr.even{background:#e1f3ff}#ir-search-related-transactions-results tbody tr.odd{background:#eee}#ir-search-related-transactions-results table td{border:0;vertical-align:top}#ir-search-related-transactions-results table tr.even{background:#e1f3ff!important}#ir-search-related-transactions-results table tr.even.heading td{border-top:2px solid #3b7a99}#ir-search-related-transactions-results table tr.even td:first-child{-border-left:2px solid #3b7a99}#ir-search-related-transactions-results table tr.odd{background:#eee}#ir-search-related-transactions-results table tr.odd.heading td{border-top:2px solid #aaa}#ir-search-related-transactions-results table tr.odd td:first-child{-border-left:2px solid #aaa}.subDocket{padding-left:20px;margin-left:20px}#pacer-filter{background:#eee!important;border:0!important;overflow:visible}#pacer-filter #related-form{padding:1px;vertical-align:middle}.inside-block{border:1px solid #999!important;clear:both;padding:10px;padding-bottom:0}.related-form-row{margin-right:5px}.related-form-row label{font-weight:inherit;margin-left:5px}.related-form-row select{width:100px;margin-left:5px;border-radius:0}.related-form-row .form-reset{border-color:initial;border-style:none;border-width:1px;background:inherit;color:#27638c;cursor:pointer;margin-left:5px}.related-form-row .form-submit{margin-left:5px}.related-form-row .checkbox{width:10px}.docketNumber{cursor:pointer;color:#27638c}.subTransactionTable{margin-left:10px}.docket_details .popup{height:0}.docket_details .popup_inner{position:relative;border:1px solid;background:#fff;width:250px;height:auto;transform:translate(65%,-50%)}.docket_details .popup_inner .title{background:#e1f3ff;border-bottom:1px solid;padding:5px}.docket_details .popup_inner .popup-body{padding:10px}.docket_details .popup_inner .popup-body textarea{resize:vertical}.public-popup{background:#fff;border:1px solid;padding:6px;border-radius:5px;transform:translate(120%,-20%)}.public-popup textarea{resize:none}.related_transactions .live_search{padding:5px;background:#eee}.related_transactions input[type=text]{background:#fff;color:#666;border:1px solid #9babb0;padding:4px;margin:2px}.related_transactions #alfresco-keyword{width:175px!important}.related_transactions .select-parent{display:inline-block;top:15px;position:relative;width:113px}.related_transactions .Select-arrow{display:none}.related_transactions .Select-menu-outer{z-index:999!important}div.icon{display:inline-block;width:16px;height:16px;vertical-align:bottom;padding:0}.filter_btn{cursor:pointer;color:#27638c}.item .fa-sort-down{margin-left:5px;vertical-align:text-top}.item .fa-sort-up{margin-left:5px;vertical-align:bottom}.buy-btn{display:block}#download{display:inline-block}#download:hover{cursor:pointer;opacity:.5}.email-popup .inner-text{padding:10px}.email-popup img{text-align:center}.view_details:hover{cursor:pointer;opacity:.5}.email-pdf{display:inline-block}.email-pdf:hover{cursor:pointer;opacity:.5}.email-pdf-alert{z-index:999;position:fixed;left:0;bottom:0;background-color:#28a745;margin-left:10px;margin-bottom:10px;color:#fff;border-radius:5px;visibility:hidden;opacity:0;-webkit-animation-name:flash-animation;-webkit-animation-duration:7s;animation-name:flash-animation;animation-duration:7s}.email-pdf-alert .alert{margin:0;padding:10px 15px!important}.dim{opacity:.5}@keyframes flash-animation{0%{background:#28a745;visibility:visible;opacity:1}to{background:none;visibility:hidden;opacity:0}}.purchase-popup{width:80%;margin-top:10px;margin-bottom:15px}.permission-check-links,.permission-check-links .menu{display:inline-block}.permission-check-links a{margin:0 5px}.permission-check-links textarea{width:100%}.delayed:hover .menu{transition-delay:.3s,.3s,.7s!important}.delayed .menu{display:block!important;visibility:hidden!important;transform:translateY(0)!important;opacity:0!important;transition:all .6s ease-in-out 0s,visibility 0s linear .4s,z-index 0s linear .2s!important}.delayed:hover .menu{visibility:visible!important;transform:translateY(-2em)!important;opacity:1!important;transform:translateY(0)!important;transition-delay:0s,0s,.7s!important}.hide-docket-entry-row{display:none}.view_details-related:hover{cursor:pointer;opacity:.5}", ""]);
	
	// exports


/***/ },
/* 1622 */
1592,
/* 1623 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".spinner{display:initial}.loading_bar{display:block;text-align:center;margin:20px 0}", ""]);
	
	// exports


/***/ },
/* 1624 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".confirmation-modal .modal-footer{display:flex;justify-content:space-between}", ""]);
	
	// exports


/***/ },
/* 1625 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".notify-toast{min-height:35px!important;font-size:14px}", ""]);
	
	// exports


/***/ },
/* 1626 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".alias-error .top-bar{background-color:#fffbe3!important;color:#000!important}.alias-error .popup-inner{bottom:50%!important}.alias-error .error-text{margin:20px!important;font-size:12px!important;color:#666!important;font-weight:700!important}", ""]);
	
	// exports


/***/ },
/* 1627 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".react-progress-bar{position:relative;height:20px;width:350px;border-radius:50px;border:1px solid #333;overflow:hidden}.react-progress-bar .inner{background:#0072b9;height:100%;border-radius:inherit;transition:width .2s ease-in;background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:1rem 1rem}", ""]);
	
	// exports


/***/ },
/* 1628 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".refine-search-summary{margin-left:5px}.refine-search-title{cursor:pointer}.refine-search-details-container{margin-left:15px}.facet-link{color:#0c5a81;cursor:pointer}.facet-link:hover{text-decoration:underline}", ""]);
	
	// exports


/***/ },
/* 1629 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".nature-of-suit-selector-container .nature-of-suit-selector{width:300px;display:inline-table}", ""]);
	
	// exports


/***/ },
/* 1630 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".result-column-head-text-form-element{color:#0c5a81;cursor:pointer}.result-column-head-text-form-element:hover{text-decoration:underline}.result-column-head-text-form-element-selected{font-weight:700}", ""]);
	
	// exports


/***/ },
/* 1631 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "#ir-search-tab-2 .ir-cck-tip{width:210px!important;margin-top:-30px}", ""]);
	
	// exports


/***/ },
/* 1632 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".action-btn-container{margin-top:15px;margin-bottom:15px}.action-btn-container .action-btn-search{font-size:18px;margin-right:5px;min-width:187px}.form-button-disabled,.form-button-disabled:hover{background:gray!important;border:1px solid silver!important;cursor:not-allowed!important}", ""]);
	
	// exports


/***/ },
/* 1633 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".nos-selector-container{margin-bottom:10px}.nos-selector-container .nos-selector{width:300px}", ""]);
	
	// exports


/***/ },
/* 1634 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".pagination-item{background-image:none;display:inline;list-style-type:none;padding:2px;background-color:#efebe7!important;border:1px solid #266996;margin:0 2px!important}.pagination-item.active{background-color:#d9dbcd!important;margin:0 4px!important;padding:4px!important}.pagination-item.active div{color:#333}.pagination-item:hover{cursor:pointer}.pagination-item div{color:#27638c;font-size:1em;font-weight:700;padding:4px;text-decoration:none;display:inline-block}", ""]);
	
	// exports


/***/ },
/* 1635 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".party-inputs-label{display:inline-block!important;margin-right:5px}.party-selector-container,.party-selector-container .party-selector-container-element{display:inline-block}.party-selector-container .party-selector-container-element .input-search{width:88%}.party-selector-container .party-selector-container-element.party-selector-container-element-middle{width:115px}", ""]);
	
	// exports


/***/ },
/* 1636 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".local-court-form{width:550px}.local-court-form .form-input{background-color:#fff;border-radius:4px;border:1px solid #ccc;color:#333;height:32px;padding:0 4px;box-sizing:border-box;width:100%}.local-court-form .form-item-group{display:flex}.local-court-form .form-item-group div:not(:last-child){margin-right:12px}.local-court-form .form-item-group.party-name div{width:32%}.local-court-form .form-item-group.party-attorney div:first-child{width:70%}.local-court-form .form-item-group.party-attorney div:not(:first-child){margin-top:28px}.local-court-form .form-item-group.party-attorney div:not(:first-child) input[type=checkbox]{margin-right:2px}.local-court-form .form-separator{margin:32px 0}.local-court-form .form-separator strong{margin-bottom:8px}.local-court-form .form-separator hr{flex:2 1 auto;margin:7px}.local-court-form .ir-tooltip{margin-left:5px}.local-court-form .alert{white-space:pre-wrap}.local-court-form .warning{font-family:Arial,sans-serif}", ""]);
	
	// exports


/***/ },
/* 1637 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".custom-alert-edit .form-text{height:30px;padding:0 4px}.custom-alert-edit .form-text,.custom-alert-edit .form-textarea{border-radius:4px;border:1px solid #ccc;color:#333;width:100%;box-sizing:border-box}.custom-alert-edit .form-textarea{padding:4px}.custom-alert-edit .form-submit{margin-right:12px}.custom-alert-edit .modal-footer{display:flex;justify-content:space-between}", ""]);
	
	// exports


/***/ },
/* 1638 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".template-alerts-table .onoff-switch{width:72px;height:30px;cursor:pointer}.template-alerts-table .interval-select{width:95px}", ""]);
	
	// exports


/***/ },
/* 1639 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".alert{padding:15px;border:1px solid transparent;border-radius:4px}.alert-danger{color:#a94442;background-color:#f2dede;border-color:#ebccd1}", ""]);
	
	// exports


/***/ },
/* 1640 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".collapsible .collapsed-triangle-icon{display:inline-block;margin-right:5px;vertical-align:middle}.collapsible.date-filters{width:427px}.collapsible.date-filters .date-picker-container{display:inline-block;margin-bottom:10px}.collapsible.date-filters .date-picker-container:nth-child(odd){margin-right:20px}.collapsible.date-filters .date-picker-label{font-weight:700}.collapsible.date-filters .date-filter-p{display:inline-block!important;color:#27638c;font-weight:700}.collapsible.date-filters .date-filter-p:hover{cursor:pointer}.collapsible.date-filters .react-datepicker__input-container{display:block}.collapsible.date-filters .date-picker{background-color:#fff;border-radius:4px;border:1px solid #ccc;color:#333;height:20px;padding:4px}.collapsible.date-filters .date-picker.validation-error{border:1px solid red}", ""]);
	
	// exports


/***/ },
/* 1641 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".flash-yellow{-webkit-animation-name:flash-animation;-webkit-animation-duration:1s;animation-name:flash-animation;animation-duration:1s}@keyframes flash-animation{0%{background:#ffff9c}to{background:none}}", ""]);
	
	// exports


/***/ },
/* 1642 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	exports.i(__webpack_require__(1663), "");
	
	// module
	exports.push([module.id, ".popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.42857143;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;font-size:14px;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 5px 10px rgba(0,0,0,.2)}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover-title{margin:0;padding:8px 14px;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow{border-width:11px}.popover>.arrow:after{border-width:10px;content:\"\"}.popover.top>.arrow{left:50%;margin-left:-11px;border-bottom-width:0;border-top-color:#999;border-top-color:rgba(0,0,0,.25);bottom:-11px}.popover.top>.arrow:after{content:\" \";bottom:1px;margin-left:-10px;border-bottom-width:0;border-top-color:#fff}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-left-width:0;border-right-color:#999;border-right-color:rgba(0,0,0,.25)}.popover.right>.arrow:after{content:\" \";left:1px;bottom:-10px;border-left-width:0;border-right-color:#fff}.popover.bottom>.arrow{left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25);top:-11px}.popover.bottom>.arrow:after{content:\" \";top:1px;margin-left:-10px;border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{content:\" \";right:1px;border-right-width:0;border-left-color:#fff;bottom:-10px}fieldset{margin:0;min-width:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:20px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{box-sizing:border-box}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.42857143;color:#555}.form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{border:0;background-color:transparent}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}input[type=search]{-webkit-appearance:none}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:34px}.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox label,.radio label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-left:-20px;margin-top:4px\\9}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;vertical-align:middle;font-weight:400;cursor:pointer}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.checkbox-inline.disabled,.checkbox.disabled label,.radio-inline.disabled,.radio.disabled label,fieldset[disabled] .checkbox-inline,fieldset[disabled] .checkbox label,fieldset[disabled] .radio-inline,fieldset[disabled] .radio label,fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}.form-control-static{padding-top:7px;padding-bottom:7px;margin-bottom:0;min-height:34px}.form-control-static.input-lg,.form-control-static.input-sm{padding-left:0;padding-right:0}.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-sm{height:30px;line-height:30px}select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:32px;padding:6px 10px;font-size:12px;line-height:1.5}.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-lg{height:46px;line-height:46px}select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:38px;padding:11px 16px;font-size:18px;line-height:1.3333333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:42.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#2b542c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;border-color:#3c763d;background-color:#dff0d8}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;border-color:#8a6d3b;background-color:#fcf8e3}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#843534;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;border-color:#a94442;background-color:#f2dede}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{margin-top:0;margin-bottom:0;padding-top:7px}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group{margin-left:-15px;margin-right:-15px}@media (min-width:768px){.form-horizontal .control-label{text-align:right;margin-bottom:0;padding-top:7px}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.fade{opacity:0;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;transition-property:height,visibility;transition-duration:.35s;transition-timing-function:ease}.alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{background-color:#dff0d8;border-color:#d6e9c6;color:#3c763d}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{background-color:#d9edf7;border-color:#bce8f1;color:#31708f}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{background-color:#fcf8e3;border-color:#faebcc;color:#8a6d3b}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{background-color:#f2dede;border-color:#ebccd1;color:#a94442}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}.nav{margin-bottom:0;padding-left:0;list-style:none}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#777}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#777;text-decoration:none;background-color:transparent;cursor:not-allowed}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#337ab7}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.42857143;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent;cursor:default}.nav-tabs.nav-justified{width:100%;border-bottom:0}.nav-tabs.nav-justified>li{float:none}.nav-tabs.nav-justified>li>a{text-align:center;margin-bottom:5px}.nav-tabs.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified{width:100%}.nav-justified>li{float:none}.nav-justified>li>a{text-align:center;margin-bottom:5px}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified{border-bottom:0}.nav-tabs-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border-bottom-color:#fff}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-right-radius:0;border-top-left-radius:0}.modal,.modal-open{overflow:hidden}.modal{display:none;position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{transform:translateY(-25%);transition:transform .3s ease-out}.modal.in .modal-dialog{transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 3px 9px rgba(0,0,0,.5);background-clip:padding-box;outline:0}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{opacity:0;filter:alpha(opacity=0)}.modal-backdrop.in{opacity:.5;filter:alpha(opacity=50)}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.42857143}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;list-style:none;font-size:14px;text-align:left;background-color:#fff;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;box-shadow:0 6px 12px rgba(0,0,0,.175);background-clip:padding-box}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{text-decoration:none;color:#262626;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;outline:0;background-color:#337ab7}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#777}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false);cursor:not-allowed}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{left:auto;right:0}.dropdown-menu-left{left:0;right:auto}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.42857143;color:#777;white-space:nowrap}.dropdown-backdrop{position:fixed;left:0;right:0;bottom:0;top:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9;content:\"\"}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:768px){.navbar-right .dropdown-menu{left:auto;right:0}.navbar-right .dropdown-menu-left{left:0;right:auto}}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.2;filter:alpha(opacity=20)}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.5;filter:alpha(opacity=50)}button.close{padding:0;cursor:pointer;background:transparent;border:0;-webkit-appearance:none}.btn{display:inline-block;margin-bottom:0;font-weight:400;text-align:center;vertical-align:middle;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;white-space:nowrap;padding:6px 12px;font-size:14px;line-height:1.42857143;border-radius:4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{outline:0;background-image:none;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;opacity:.65;filter:alpha(opacity=65);box-shadow:none}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#fff;border-color:#ccc}.btn-default.focus,.btn-default:focus{color:#333;background-color:#e6e6e6;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.btn-default:hover,.open>.dropdown-toggle.btn-default{color:#333;background-color:#e6e6e6;border-color:#adadad}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.dropdown-toggle.btn-default.focus,.open>.dropdown-toggle.btn-default:focus,.open>.dropdown-toggle.btn-default:hover{color:#333;background-color:#d4d4d4;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.open>.dropdown-toggle.btn-default{background-image:none}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#fff;border-color:#ccc}.btn-default .badge{color:#fff;background-color:#333}.btn-primary{color:#fff;background-color:#337ab7;border-color:#2e6da4}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#286090;border-color:#122b40}.btn-primary.active,.btn-primary:active,.btn-primary:hover,.open>.dropdown-toggle.btn-primary{color:#fff;background-color:#286090;border-color:#204d74}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.dropdown-toggle.btn-primary.focus,.open>.dropdown-toggle.btn-primary:focus,.open>.dropdown-toggle.btn-primary:hover{color:#fff;background-color:#204d74;border-color:#122b40}.btn-primary.active,.btn-primary:active,.open>.dropdown-toggle.btn-primary{background-image:none}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#337ab7;border-color:#2e6da4}.btn-primary .badge{color:#337ab7;background-color:#fff}.btn-success{color:#fff;background-color:#5cb85c;border-color:#4cae4c}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#449d44;border-color:#255625}.btn-success.active,.btn-success:active,.btn-success:hover,.open>.dropdown-toggle.btn-success{color:#fff;background-color:#449d44;border-color:#398439}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.dropdown-toggle.btn-success.focus,.open>.dropdown-toggle.btn-success:focus,.open>.dropdown-toggle.btn-success:hover{color:#fff;background-color:#398439;border-color:#255625}.btn-success.active,.btn-success:active,.open>.dropdown-toggle.btn-success{background-image:none}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#5cb85c;border-color:#4cae4c}.btn-success .badge{color:#5cb85c;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info.active,.btn-info:active,.btn-info:hover,.open>.dropdown-toggle.btn-info{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.dropdown-toggle.btn-info.focus,.open>.dropdown-toggle.btn-info:focus,.open>.dropdown-toggle.btn-info:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.active,.btn-info:active,.open>.dropdown-toggle.btn-info{background-image:none}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-warning{color:#fff;background-color:#f0ad4e;border-color:#eea236}.btn-warning.focus,.btn-warning:focus{color:#fff;background-color:#ec971f;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.btn-warning:hover,.open>.dropdown-toggle.btn-warning{color:#fff;background-color:#ec971f;border-color:#d58512}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.dropdown-toggle.btn-warning.focus,.open>.dropdown-toggle.btn-warning:focus,.open>.dropdown-toggle.btn-warning:hover{color:#fff;background-color:#d58512;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.open>.dropdown-toggle.btn-warning{background-image:none}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#f0ad4e;border-color:#eea236}.btn-warning .badge{color:#f0ad4e;background-color:#fff}.btn-danger{color:#fff;background-color:#d9534f;border-color:#d43f3a}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c9302c;border-color:#761c19}.btn-danger.active,.btn-danger:active,.btn-danger:hover,.open>.dropdown-toggle.btn-danger{color:#fff;background-color:#c9302c;border-color:#ac2925}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.dropdown-toggle.btn-danger.focus,.open>.dropdown-toggle.btn-danger:focus,.open>.dropdown-toggle.btn-danger:hover{color:#fff;background-color:#ac2925;border-color:#761c19}.btn-danger.active,.btn-danger:active,.open>.dropdown-toggle.btn-danger{background-image:none}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#d9534f;border-color:#d43f3a}.btn-danger .badge{color:#d9534f;background-color:#fff}.btn-link{color:#337ab7;font-weight:400;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#23527c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;color:#fff;line-height:1;vertical-align:middle;white-space:nowrap;text-align:center;background-color:#777;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#337ab7;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{overflow:hidden;height:20px;margin-bottom:20px;background-color:#f5f5f5;border-radius:4px;box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#5cb85c}.progress-striped .progress-bar-success{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f0ad4e}.progress-striped .progress-bar-warning{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#d9534f}.progress-striped .progress-bar-danger{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.panel{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:4px;box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-right-radius:3px;border-top-left-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-right-radius:3px;border-top-left-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-right-radius:0;border-top-left-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-left:15px;padding-right:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-right-radius:3px;border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{border:0;margin-bottom:0}.panel-group{margin-bottom:20px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#337ab7}.panel-primary>.panel-heading{color:#fff;background-color:#337ab7;border-color:#337ab7}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#337ab7}.panel-primary>.panel-heading .badge{color:#337ab7;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#337ab7}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-left:0;padding-right:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-group-lg>.form-control,select.input-group-lg>.input-group-addon,select.input-group-lg>.input-group-btn>.btn{height:46px;line-height:46px}select[multiple].input-group-lg>.form-control,select[multiple].input-group-lg>.input-group-addon,select[multiple].input-group-lg>.input-group-btn>.btn,textarea.input-group-lg>.form-control,textarea.input-group-lg>.input-group-addon,textarea.input-group-lg>.input-group-btn>.btn{height:auto}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-group-sm>.form-control,select.input-group-sm>.input-group-addon,select.input-group-sm>.input-group-btn>.btn{height:30px;line-height:30px}select[multiple].input-group-sm>.form-control,select[multiple].input-group-sm>.input-group-addon,select[multiple].input-group-sm>.input-group-btn>.btn,textarea.input-group-sm>.form-control,textarea.input-group-sm>.input-group-addon,textarea.input-group-sm>.input-group-btn>.btn{height:auto}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-bottom-left-radius:0;border-top-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label:empty{display:none}.btn .label{position:relative;top:-1px}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#337ab7}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#286090}.label-success{background-color:#5cb85c}.label-success[href]:focus,.label-success[href]:hover{background-color:#449d44}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#f0ad4e}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#ec971f}.label-danger{background-color:#d9534f}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#c9302c}@font-face{font-family:Glyphicons Halflings;src:url(" + __webpack_require__(835) + ");src:url(" + __webpack_require__(835) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(2218) + ") format(\"woff2\"),url(" + __webpack_require__(2217) + ") format(\"woff\"),url(" + __webpack_require__(1757) + ") format(\"truetype\"),url(" + __webpack_require__(1756) + "#glyphicons_halflingsregular) format(\"svg\")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-bottom-left-radius:0;border-top-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-left:8px;padding-right:8px}.btn-group>.btn-lg+.dropdown-toggle{padding-left:12px;padding-right:12px}.btn-group.open .dropdown-toggle{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{box-shadow:none}.btn .caret{margin-left:0}.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-right-radius:0;border-top-left-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-right-radius:0;border-top-left-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{float:none;display:table-cell;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.sr-only{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}legend{display:initial;width:auto;padding:initial;margin-bottom:0;font-size:1em;line-height:normal;color:initial;border:initial}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}.dropdown-menu>li{margin:0;padding:0;background:#fff;list-style:none}.input-group input[type=input],.input-group input[type=password],.input-group input[type=text]{box-sizing:border-box}.nav-tabs:after,.nav-tabs:before{content:\" \";display:table}.nav-tabs:after{content:\" \";clear:both}.nav-tabs>li{background:none;list-style:none}#react-app .inside-block{overflow:inherit}.ssn-item{display:inline-block;width:167px;margin-right:20px}.ssn-item label{display:block;width:100%;font-weight:700}.ssn-item input{width:100%}.region-selector-container{margin-top:20px;display:inline-block}.region-selector-container label{font-weight:700;font-size:12px;display:block}.region-selector-container .region-selector{display:inline-table;width:300px;margin-right:10px}.Select--multi .Select-value{overflow:hidden}.Select--multi .Select-value .Select-value-icon{padding-top:2px!important;display:block!important;float:left!important}.Select--multi .Select-value .Select-value-label{display:block!important;overflow:hidden}.chapter-selector-container{margin-top:20px;display:inline-block}.chapter-selector-container label{font-weight:700;font-size:12px;display:block}.chapter-selector-container .chapter-selector{width:118px}.input-search{background-color:#fff;border-radius:4px;border:1px solid #ccc;color:#333;height:30px;padding:0 4px}.validation-error{border:1px solid red}input[type=text].x-closeable{-webkit-appearance:searchfield}input[type=text].x-closeable::-webkit-search-cancel-button{-webkit-appearance:searchfield}#ir-search-tab-1{margin-bottom:200px!important}#ir-search-tab-2{margin-bottom:100px!important}#pacer-form-wrapper{border:1px solid #666;border-top:none;padding:17px}.filings-form{border-top:none;padding:17px}a.disabled{color:#999;text-decoration:none;cursor:not-allowed}.Select-menu-outer{z-index:1000}", ""]);
	
	// exports


/***/ },
/* 1643 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".popup{position:fixed;border-radius:5px;width:100%;height:100%;top:0;left:0;right:0;bottom:0;margin:auto;z-index:1001;background:rgba(0,0,0,.1)}.popup .popup-inner{position:absolute;width:400px;left:25%;right:25%;bottom:35%;margin:auto;background:#fff;border:1px solid #777;border-radius:5px;height:auto;z-index:1002}.popup .popup-inner .top-bar{background-color:rgba(0,0,0,.1);border-top-left-radius:5px;border-top-right-radius:5px;border:1px solid #999;margin:0 0 1px;padding:0 5px;height:25px;color:#27638c;font-weight:700}.popup .popup-inner .top-bar div{display:inline-block;line-height:25px}.popup .popup-inner .top-bar .ui-dialog-titlebar-close{float:right;display:inline-block;height:100%}.popup .popup-inner .top-bar .ui-dialog-titlebar-close:hover{cursor:pointer;opacity:.5}.popup .popup-inner .top-bar .ui-dialog-titlebar-close span{margin-top:4px}.popup .popup-inner button:hover{cursor:pointer;opacity:.5}", ""]);
	
	// exports


/***/ },
/* 1644 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".search-results .result-header-item{color:#1192af}.search-results .result-header-item:hover{cursor:inherit}.search-results .sortable:hover{cursor:pointer;opacity:.8}.search-results .arrow-img{margin-left:3px;width:13px;height:13px}.search-results td{max-width:175px}", ""]);
	
	// exports


/***/ },
/* 1645 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".arrow-img{margin-left:3px;width:13px;height:13px}", ""]);
	
	// exports


/***/ },
/* 1646 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".create-alert-modal .form-text{height:30px;padding:0 4px}.create-alert-modal .form-text,.create-alert-modal .form-textarea{border-radius:4px;border:1px solid #ccc;color:#333;width:100%;box-sizing:border-box}.create-alert-modal .form-textarea{padding:4px}.create-alert-modal .form-submit{margin-right:12px}.create-alert-modal .save-as-new{display:flex}.create-alert-modal .save-as-new label{margin-left:2px;margin-right:5px}.create-alert-modal .save-as-new input{margin-top:3px}.create-alert-modal .modal-footer{display:flex;justify-content:space-between}", ""]);
	
	// exports


/***/ },
/* 1647 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".facets-create-alert{margin:10px 5px}", ""]);
	
	// exports


/***/ },
/* 1648 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".case-lookup .date-picker-container{margin-right:20px}.case-lookup .date-picker-container .react-datepicker__input-container{height:32px!important}.case-lookup .region-selector-container{margin-bottom:15px;margin-top:0;display:block;float:none!important}.case-lookup .region-selector-container .region-selector .Select{max-width:764px}.case-lookup table{margin-top:10px}.case-lookup table th.case-title{width:175px}.case-lookup table td.party-name{word-break:break-all;word-wrap:break-word}.case-lookup table td.disposition{max-width:100px}.case-lookup .Select.is-open{position:relative;z-index:1000}", ""]);
	
	// exports


/***/ },
/* 1649 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".facets-block{width:280px;display:inline-block;margin:0 20px 0 0!important;border:0;background:none;padding:0;font-family:Helvetica,Arial,sans-serif;font-weight:400;line-height:160%}.facets-block .ui-state-disabled{border-right:8px solid #999;border-top:1px solid #999;color:#27638c;opacity:1;background:#e1e1e1;border-right-width:1px}.facets-block .tab-section{margin-bottom:10px;font-size:11px;font-weight:700}.facets-block .tab-section div{margin:1.65px 0 1.65px 12px}.facets-block .tab-section .title{color:#666}.facets-block .views-field-field-feed-url-value{margin-left:0!important}.facets-block .date-filter-p{color:#666!important}.facets-block .tab-section-2 .date-filter-p{margin-top:0}.facets-block .tab-section-2 .collapsible,.facets-block .tab-section-2 .collapsible>div{margin-left:0}.facets-block .more-link{text-align:left!important;margin-left:12px;float:none}.facets-block .view{margin-left:0}.facets-block .tabs{padding:20px 0 0 6px}.facets-block .tabs .tab.ui-tabs-selected{display:block}.facets-block .tabs .tab.ui-state-default{display:none}.facets-block a.icon{margin-top:-5px}.facets-block .ui-state-default{list-style:none;float:left;position:relative;top:1px;margin:0 .2em 1px 0;border-bottom:0;padding:0;white-space:nowrap;border-left:1px solid #999;margin-bottom:0;padding-bottom:1px;border:1px solid #999;margin-right:0;min-height:23px;max-height:24px;font-weight:700}.facets-block .ui-state-default a{float:left;padding:.5em 1em;text-decoration:none}.facets-block .ui-tabs-selected{border-bottom:1px solid #fff!important}.facets-block .ui-state-default{border-left:none}.facets-block li{list-style:none;float:left;position:relative;top:1px;margin:0 .2em 1px 0;border-bottom:0;padding:0;white-space:nowrap}.facets-block .clear-all{padding-left:20px;margin-bottom:15px;font-weight:700;font-size:120%}.facets-block.sidebar-hide .inside.menu{border-left:none!important;border-style:none!important}.facets-block.sidebar-hide img,.facets-block.sidebar-hide li{display:none}.facets-block .date-filters{width:100%}.facets-block .view-content{margin-left:-23px!important}.facets-block .view-content .views-row{margin-top:0;margin-bottom:0}.facets-block .view-content a{font-weight:400;font-size:1em!important}.link-emulated{color:#0c5a81;cursor:pointer}.link-emulated:hover{text-decoration:underline}.ir-search-facet-link.link-emulated.active{font-weight:700}.ir-search-facet-clear{display:block;font-size:120%;font-weight:700;color:#5a0c81}", ""]);
	
	// exports


/***/ },
/* 1650 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".ir-reports-tab-hints{width:38%;float:right}.ir-reports-tab-hints h4{color:#27638c;font-size:18px;font-weight:700}.ir-reports-tab-hints ol{margin:.75em 0 1.25em;padding:0;font-size:14px}.ir-reports-tab-hints ol li{padding:0 0 .3em;margin:.15em 0 .15em 2em}", ""]);
	
	// exports


/***/ },
/* 1651 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".reports-tab{display:flow-root;border-width:0;padding-top:16px}.reports-tab .row{padding-top:5px}.reports-tab .no-padding{padding:0}.reports-tab .react-datepicker-wrapper input{width:78%}.reports-tab .reports-tab-forms{width:425px;margin:0;padding:0;float:left}.reports-tab .reports-tab-forms .selector-container{vertical-align:top}.reports-tab .reports-search-form-container{content:\"\";display:table;clear:both}.reports-tab .local-search-actions div{margin-bottom:15px;margin-right:15px;display:inline-block}.reports-tab .local-search-actions div:hover{cursor:pointer;opacity:.8}.reports-tab .local-search-actions div:hover.inactive{cursor:default;opacity:.5}.reports-tab .local-search-actions div.inactive{opacity:.5}.reports-tab .local-search-actions form{margin-bottom:15px;margin-right:15px;display:inline-block}.reports-tab .local-search-actions form button{border:none;background-color:inherit}.reports-tab .local-search-actions form button:hover{cursor:pointer;opacity:.8}.reports-tab .local-search-actions form button:hover.inactive{cursor:default;opacity:.5}.reports-tab .local-search-actions form button.inactive{opacity:.5}.reports-tab .local-search-actions img{vertical-align:middle}.reports-tab .receipt-module{margin-top:20px}", ""]);
	
	// exports


/***/ },
/* 1652 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".reports-tab-forms-automate{margin-top:20px;display:flex}.reports-tab-forms-automate .reports-tab-automate-frequency-selector{min-width:122px;width:16%;margin-bottom:0}.reports-tab-forms-automate .reports-tab-automate-date-filter-selector{width:36%;min-width:300px;display:inline-flex}.reports-tab-forms-automate .date-picker-type-datetime-picker{width:50%;margin-right:0}.reports-tab-forms-automate .date-picker-type-datetime-picker:first-of-type{margin-right:5px}.reports-tab-forms-automate .submit-btn-spacer{margin-top:22px}.reports-tab-forms-automate .reports-tab-forms-automate-submit{margin-left:auto}.reports-tab-forms-automate .reports-tab-forms-automate-submit a{margin-left:5px}", ""]);
	
	// exports


/***/ },
/* 1653 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".reports-tab-forms-bankruptcy .reports-tab-bankruptcy-date-type-selector,.reports-tab-forms-bankruptcy .reports-tab-bankruptcy-region-selector{width:40%}.reports-tab-forms-bankruptcy .reports-tab-bankruptcy-case-type-selector,.reports-tab-forms-bankruptcy .reports-tab-bankruptcy-chapter-selector{width:calc(30% - 10px)}.reports-tab-forms-bankruptcy .reports-tab-bankruptcy-date-filter-selector{width:calc(60% - 10px);display:inline-flex}.reports-tab-forms-bankruptcy .date-picker-container input{height:34px}.reports-tab-forms-bankruptcy .reports-tab-bankruptcy-type-of-debtor-selector{width:50%}.reports-tab-forms-bankruptcy .reports-tab-bankruptcy-nature-of-debt-selector{width:calc(50% - 10px)}.reports-tab-forms-bankruptcy .reports-tab-bankruptcy-nature-of-business-selector{width:60%}.reports-tab-forms-bankruptcy .reports-tab-bankruptcy-assets-selector{width:calc(40% - 10px)}.reports-tab-forms-bankruptcy .reports-tab-bankruptcy-case-properties-selector{width:70%}.reports-tab-forms-bankruptcy .reports-tab-bankruptcy-party-info-selector{width:calc(30% - 10px)}", ""]);
	
	// exports


/***/ },
/* 1654 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".reports-tab-forms-civil .reports-tab-civil-region-selector{width:55%}.reports-tab-forms-civil .reports-tab-civil-case-type-selector{width:calc(45% - 10px)}.reports-tab-forms-civil .reports-tab-civil-nature-of-suit-selector{width:100%}.reports-tab-forms-civil .reports-tab-civil-date-filter-selector{width:100%;display:-webkit-inline-box}.reports-tab-forms-civil .reports-tab-civil-date-filter-selector .date-picker-container{width:50%}.reports-tab-forms-civil .reports-tab-civil-date-filter-selector .date-picker-container:last-of-type{width:calc(50% - 10px)}.reports-tab-forms-civil .reports-tab-civil-date-filter-selector .date-picker-container .react-datepicker-wrapper,.reports-tab-forms-civil .reports-tab-civil-date-filter-selector .date-picker-container .react-datepicker__input-container{width:100%}.reports-tab-forms-civil .reports-tab-civil-date-filter-selector .date-picker-container .react-datepicker__input-container input{width:calc(100% - 22px)}.reports-tab-forms-civil .reports-tab-civil-cause-selector{width:50%}.reports-tab-forms-civil .reports-tab-civil-jurisdiction-selector{width:calc(50% - 10px)}.reports-tab-forms-civil .reports-tab-civil-case-flag-selector{width:50%}.reports-tab-forms-civil .reports-tab-civil-case-properties-selector{width:calc(50% - 10px)}", ""]);
	
	// exports


/***/ },
/* 1655 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".reports-tab-forms-criminal .reports-tab-criminal-region-selector{width:55%}.reports-tab-forms-criminal .reports-tab-criminal-case-type-selector{width:calc(45% - 10px)}.reports-tab-forms-criminal .reports-tab-criminal-citation-selector{width:45%}.reports-tab-forms-criminal .reports-tab-criminal-date-filter-selector{width:calc(55% - 10px);display:inline-flex}.reports-tab-forms-criminal .reports-tab-criminal-case-flag-selector{width:50%}.reports-tab-forms-criminal .reports-tab-criminal-count-status-selector{width:calc(50% - 10px)}.reports-tab-forms-criminal .reports-tab-criminal-case-properties-selector,.reports-tab-forms-criminal .reports-tab-criminal-include-cvb-cases-selector{width:100%}", ""]);
	
	// exports


/***/ },
/* 1656 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "#content-content #ir-search-alfresco-basic-page{width:1100px}.client_code label{margin-bottom:0!important}.filings-page{font-family:Verdana,Arial,sans-serif}.filings-page .ui-tabs-nav .ui-state-default{opacity:1}.filings-page .filings-forms{width:800px;display:inline-block;vertical-align:top}.filings-page .filings-forms h4{font-family:Helvetica,Arial,sans-serif}.filings-page .filings-forms input{font-family:Verdana,Arial,sans-serif}.filings-page .filings-forms input[type=search],.filings-page .filings-forms input[type=text]{font-size:1em}.filings-page .filings-forms .ui-state-default{list-style:none;float:left;position:relative;top:1px;margin:0 .2em 1px 0;border:1px solid #999;padding:0;white-space:nowrap;border-bottom:none;border-left:none;margin-bottom:0;padding-bottom:1px;margin-right:0;min-height:23px;max-height:24px;font-weight:700}.filings-page .filings-forms .ui-state-default a{float:left;padding:.5em 1em;text-decoration:none}.filings-page .filings-forms .ui-state-default:first-of-type{border-left:1px solid #999}.filings-page .filings-forms .ui-tabs-selected{border-bottom:1px solid #fff}.filings-page .filings-forms .filings-forms-tabs{margin-top:5px}.filings-page .filings-forms .alert{margin-bottom:10px}.filings-page .filings-tabs{width:780px;font-family:Verdana,Arial,sans-serif;font-size:12px;font-weight:700;height:27px;line-height:26px;border-left:1px solid #666;display:inline-block}.filings-page .filings-tabs .tab{width:111px;text-align:center;border-right:1px solid #666;border-top:1px solid #666;border-bottom:1px solid #666;color:#555;background-color:#ededed}.filings-page .filings-tabs .tab:hover{background-color:#fff}.filings-page .filings-tabs .for-bottom-border{display:inline-block;width:10px;flex-grow:1;vertical-align:bottom;border-bottom:1px solid #666}.filings-page .filings-tabs a{display:inline-block;width:100%;text-decoration:none;color:#555}.filings-page .filings-tabs .selected{background-color:inherit;border-bottom:none}.filings-page .filings-tabs .selected a{color:#27638c}", ""]);
	
	// exports


/***/ },
/* 1657 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "#filter-schedule-form .form-control{width:inherit;height:inherit}#filter-schedule-form .input-group input[type=number]{width:75px;-moz-appearance:textfield}#filter-schedule-form .input-group input[type=number]::-webkit-inner-spin-button{-webkit-appearance:none}#filter-schedule-form .input-group-addon{background:#fff;font-size:11px;line-height:9px}", ""]);
	
	// exports


/***/ },
/* 1658 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "#tab-petition{overflow:visible}#ir-search-schedule-petition-results .cancel-link{background:none;border:none;padding:0;border-bottom:1px solid #444;cursor:pointer;width:inherit;margin-top:5px;color:red;margin-left:5px}#ir-search-schedule-petition-results .form-submit{border-radius:5px;color:#fff!important;font-family:Helvetica,Arial,sans-serif;font-weight:700;padding:6px 10px 5px;text-decoration:none;text-align:center;outline:0;margin:0;background:#36518f;background:linear-gradient(180deg,#518ab1 0,#4b84ab 50%,#27638c 0,#215d86);border:1px solid #172d6e;border-bottom:1px solid #0e1d45;box-shadow:inset 0 1px 0 0 #b1b9cb;text-shadow:0 -1px 1px #000f4d;cursor:pointer;text-transform:none;white-space:nowrap;position:relative;width:150px}#ir-search-schedule-petition-results input{width:230px;padding:4px;height:22px}#ir-search-schedule-petition-results #website{width:500px}#ir-search-schedule-petition-results .editable{color:#27638c;cursor:pointer;text-align:right;padding:10px}#ir-search-schedule-petition-results .label{color:#727272;font-size:11px;text-align:left;padding-left:0}#ir-search-schedule-petition-results table{background:none transparent;border-collapse:collapse;font-size:11px;margin:0;text-align:left;width:100%}#ir-search-schedule-petition-results table tbody{border-top:0}#ir-search-schedule-petition-results table th,#ir-search-schedule-petition-results table thead th{border-bottom:2px solid #0c5a81;color:#1192af;font-size:11px;font-weight:400;padding:10px 8px}#ir-search-schedule-petition-results table .justify-alignment{text-align:justify}#ir-search-schedule-petition-results input[type=checkbox],#ir-search-schedule-petition-results input[type=radio]{width:10px}#ir-search-schedule-petition-results .hide-creditor-row{display:none}#ir-search-schedule-petition-results #view-petition .money{width:100px;text-align:left}#parser-schedule-petition-form label{font-weight:inherit;margin-left:5px}#parser-schedule-petition-form .remove-creditor{cursor:pointer;float:right;position:relative;top:-85px;right:-20px}#parser-schedule-petition-form .label-creditor{white-space:inherit;text-align:left;color:#1192af;position:relative;top:40px;left:-10px}#parser-schedule-petition-form #label-keyword{margin-left:0}#parser-schedule-petition-form #totals{border:0;font-weight:700;width:auto;min-width:10px;max-width:145px}#parser-schedule-petition-form #alfresco-clear{color:#27638c;margin-left:5px;display:inline-block;cursor:pointer;background:inherit;border:0;text-decoration:underline}#parser-schedule-petition-form .form-submit{margin-top:10px}#parser-schedule-petition-form table{background:none transparent;border-collapse:collapse;font-size:11px;margin:0;text-align:left;width:100%}#parser-schedule-petition-form table th,#parser-schedule-petition-form table thead th{border-bottom:2px solid #0c5a81;color:#1192af;font-size:11px;font-weight:400;padding:10px 8px}#parser-schedule-petition-form table tbody{border-top:0}#parser-schedule-petition-form table td{padding:6px 2px}#parser-schedule-petition-form table td .money{width:78px;text-align:right;padding:6px 0}#parser-schedule-petition-form table td .money input[type=number]{width:57px}#parser-schedule-petition-form table td select{width:235px;margin-left:5px}#parser-schedule-petition-form table .address{padding:2px}#parser-schedule-petition-form table .claimType{width:115px;padding:2px}#parser-schedule-petition-form input[type=checkbox],#parser-schedule-petition-form input[type=radio]{width:10px}#schedule-petition span.has-specified-creditor-priority,#schedule-petition span.multiple-interest{width:220px;white-space:pre-line}#schedule-petition{margin-top:15px}#petition .Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value .Select-value-label,#petition .Select.has-value.Select--single>.Select-control .Select-value .Select-value-label{color:#666}#petition .label{height:20px}#petition .label,#petition .label-petitioner{white-space:inherit;text-align:left;color:#1192af}#petition .label-petitioner{font-weight:700;font-size:12px}#petition .schedule-tips{display:block;font-style:italic;text-align:center}.additional_creditor{border-top:1px solid #ccc}.ir-search-double{margin-top:1em;margin-bottom:1em;padding-bottom:0}", ""]);
	
	// exports


/***/ },
/* 1659 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "#ir-search-schedule-ab-results .cancel-link{background:none;border:none;padding:0;border-bottom:1px solid #444;cursor:pointer;width:inherit;margin-top:5px;color:red;margin-left:5px}#ir-search-schedule-ab-results .form-submit{border-radius:5px;color:#fff!important;font-family:Helvetica,Arial,sans-serif;font-weight:700;padding:6px 10px 5px;text-decoration:none;text-align:center;outline:0;margin:0;background:#36518f;background:linear-gradient(180deg,#518ab1 0,#4b84ab 50%,#27638c 0,#215d86);border:1px solid #172d6e;border-bottom:1px solid #0e1d45;box-shadow:inset 0 1px 0 0 #b1b9cb;text-shadow:0 -1px 1px #000f4d;cursor:pointer;text-transform:none;white-space:nowrap;position:relative;width:150px}#ir-search-schedule-ab-results .input-group .form-control{margin-left:-2px}#ir-search-schedule-ab-results .label{color:#727272;font-size:9px;text-align:left;padding-left:0}#parser-schedule-ab-form label{font-weight:inherit}#parser-schedule-ab-form #totals{border:0;font-weight:700;width:auto;min-width:10px;max-width:145px}", ""]);
	
	// exports


/***/ },
/* 1660 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "#ir-search-schedule-d-results .cancel-link{background:none;border:none;padding:0;border-bottom:1px solid #444;cursor:pointer;width:inherit;margin-top:5px;color:red;margin-left:5px}#ir-search-schedule-d-results .form-submit{border-radius:5px;color:#fff!important;font-family:Helvetica,Arial,sans-serif;font-weight:700;padding:6px 10px 5px;text-decoration:none;text-align:center;outline:0;margin:0;background:#36518f;background:linear-gradient(180deg,#518ab1 0,#4b84ab 50%,#27638c 0,#215d86);border:1px solid #172d6e;border-bottom:1px solid #0e1d45;box-shadow:inset 0 1px 0 0 #b1b9cb;text-shadow:0 -1px 1px #000f4d;cursor:pointer;text-transform:none;white-space:nowrap;position:relative;width:150px}#ir-search-schedule-d-results input{width:150px}#ir-search-schedule-d-results .label{color:#727272;font-size:9px;text-align:left;padding-left:0}#ir-search-schedule-d-results table{background:none transparent;border-collapse:collapse;font-size:11px;margin:0;text-align:left;width:100%}#ir-search-schedule-d-results table tbody{border-top:1px solid #ccc}#ir-search-schedule-d-results input[type=checkbox],#ir-search-schedule-d-results input[type=radio]{width:10px}#ir-search-schedule-d-results .schedule-tips{font-style:normal;font-weight:400;font-size:.6em;line-height:1}#parser-schedule-d-form{overflow-x:hidden}#parser-schedule-d-form label{font-weight:inherit;margin-left:5px}#parser-schedule-d-form #label-keyword{margin-left:0}#parser-schedule-d-form #totals{border:0;font-weight:700;width:auto;min-width:10px;max-width:145px}#parser-schedule-d-form #alfresco-clear{color:#27638c;margin-left:5px;display:inline-block;cursor:pointer}#parser-schedule-d-form .form-submit{margin-left:10px}#parser-schedule-d-form table{background:none transparent;border-collapse:collapse;font-size:11px;margin:0;text-align:left;width:100%}#parser-schedule-d-form table tbody{border-top:1px solid #ccc}#parser-schedule-d-form table td .money{width:100px;text-align:right;padding:6px 0 0 5px}#parser-schedule-d-form table td .money input[type=number]{width:65px;padding:3px;border-left:1px solid #ccc;left:-2px;font-size:10px}#parser-schedule-d-form .has-specified-creditor-priority-yes input[type=number]::-webkit-inner-spin-button,#parser-schedule-d-form table td .money input[type=number]::-webkit-inner-spin-button{-webkit-appearance:none}#parser-schedule-d-form input[type=checkbox],#parser-schedule-d-form input[type=radio]{width:10px}#parser-schedule-d-form .form-control{width:inherit;height:inherit}#parser-schedule-d-form .input-group-addon{padding:3px 2px;font-size:10px;background:#fff}#parser-schedule-d-form .input-group .form-control{margin-left:-2px}#schedule-d span.has-specified-creditor-priority,#schedule-d span.multiple-interest{width:220px;white-space:pre-line}#secured-creditors .label{white-space:inherit}.additional_creditor{border-top:1px solid #ccc}", ""]);
	
	// exports


/***/ },
/* 1661 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "#ir-search-schedule-ef-results .cancel-link{background:none;border:none;padding:0;border-bottom:1px solid #444;cursor:pointer;width:inherit;margin-top:5px;color:red;margin-left:5px}#ir-search-schedule-ef-results .form-submit{border-radius:5px;color:#fff!important;font-family:Helvetica,Arial,sans-serif;font-weight:700;padding:6px 10px 5px;text-decoration:none;text-align:center;outline:0;margin:0;background:#36518f;background:linear-gradient(180deg,#518ab1 0,#4b84ab 50%,#27638c 0,#215d86);border:1px solid #172d6e;border-bottom:1px solid #0e1d45;box-shadow:inset 0 1px 0 0 #b1b9cb;text-shadow:0 -1px 1px #000f4d;cursor:pointer;text-transform:none;white-space:nowrap;position:relative;width:150px}#ir-search-schedule-ef-results input{width:150px}#ir-search-schedule-ef-results input[type=checkbox],#ir-search-schedule-ef-results input[type=radio]{width:10px}#ir-search-schedule-ef-results .editable{color:#27638c}#ir-search-schedule-ef-results a.editable{color:#27638c;cursor:pointer}#ir-search-schedule-ef-results .label{color:#727272;font-size:9px;text-align:left;padding-left:0}#ir-search-schedule-ef-results table{background:none transparent;border-collapse:collapse;font-size:11px;margin:0;text-align:left;width:100%}#ir-search-schedule-ef-results table tbody{border-top:1px solid #ccc}#parser-schedule-ef-form label{font-weight:inherit;margin-left:5px}#parser-schedule-ef-form #label-keyword{margin-left:0}#parser-schedule-ef-form #totals{border:0;font-weight:700;width:auto;min-width:10px;max-width:145px}#parser-schedule-ef-form #alfresco-clear{color:#27638c;margin-left:5px;display:inline-block}#parser-schedule-ef-form .form-submit{margin-left:10px}#parser-schedule-ef-form input[type=number]{text-align:right}#parser-schedule-ef-form table{background:none transparent;border-collapse:collapse;font-size:11px;margin:0;text-align:left;width:100%}#parser-schedule-ef-form table tbody{border-top:1px solid #ccc}#parser-schedule-ef-form table td .money{width:100px;text-align:right;padding:6px 0 0 5px}#parser-schedule-ef-form table td .money input[type=number]{width:65px;padding:3px;border-left:1px solid #ccc;left:-2px;font-size:10px}#parser-schedule-ef-form table td .money input[type=number]::-webkit-inner-spin-button{-webkit-appearance:none}#parser-schedule-ef-form .form-control{width:inherit;height:inherit}#parser-schedule-ef-form .no-num-range input[type=number]::-webkit-inner-spin-button{-webkit-appearance:none}#parser-schedule-ef-form .input-group .form-control{margin-left:-2px}.schedule-ef-filters .form-text{background:#fff;color:#666;border:1px solid #9babb0;padding:2px 0}.ir-search-double .label{white-space:inherit}.ir-search-double table td .money{width:100px;text-align:right;padding:6px 0 0 5px}#priority-creditors input[type=number]{width:73px}", ""]);
	
	// exports


/***/ },
/* 1662 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "#ir-search-schedule-top20-results .cancel-link{background:none;border:none;padding:0;border-bottom:1px solid #444;cursor:pointer;width:inherit;margin-top:5px;color:red;margin-left:5px}#ir-search-schedule-top20-results .form-submit{border-radius:5px;color:#fff!important;font-family:Helvetica,Arial,sans-serif;font-weight:700;padding:6px 10px 5px;text-decoration:none;text-align:center;outline:0;margin:0;background:#36518f;background:linear-gradient(180deg,#518ab1 0,#4b84ab 50%,#27638c 0,#215d86);border:1px solid #172d6e;border-bottom:1px solid #0e1d45;box-shadow:inset 0 1px 0 0 #b1b9cb;text-shadow:0 -1px 1px #000f4d;cursor:pointer;text-transform:none;white-space:nowrap;position:relative;width:150px}#ir-search-schedule-top20-results input{width:150px}#ir-search-schedule-top20-results .editable{color:#27638c;cursor:pointer;text-align:right;padding:10px}#ir-search-schedule-top20-results .label{color:#727272;font-size:11px;text-align:left;padding-left:0}#ir-search-schedule-top20-results table{background:none transparent;border-collapse:collapse;font-size:11px;margin:0;text-align:left;width:100%}#ir-search-schedule-top20-results table tbody{border-top:1px solid #ccc}#ir-search-schedule-top20-results table th,#ir-search-schedule-top20-results table thead th{border-bottom:2px solid #0c5a81;color:#1192af;font-size:11px;font-weight:400;padding:10px 8px}#ir-search-schedule-top20-results input[type=checkbox],#ir-search-schedule-top20-results input[type=radio]{width:10px}#ir-search-schedule-top20-results #view-creditors .money{width:100px;text-align:left}#parser-schedule-top20-form label{font-weight:inherit;margin-left:5px}#parser-schedule-top20-form .label-creditor{white-space:inherit;text-align:left;color:#1192af;position:relative;top:40px;left:-10px}#parser-schedule-top20-form #label-keyword{margin-left:0}#parser-schedule-top20-form #totals{border:0;font-weight:700;width:auto;min-width:10px;max-width:145px}#parser-schedule-top20-form #alfresco-clear{color:#27638c;margin-left:5px;display:inline-block;cursor:pointer;background:inherit;border:0;text-decoration:underline}#parser-schedule-top20-form .form-submit{margin-left:10px}#parser-schedule-top20-form table{background:none transparent;border-collapse:collapse;font-size:11px;margin:0;text-align:left;width:100%}#parser-schedule-top20-form table th,#parser-schedule-top20-form table thead th{border-bottom:2px solid #0c5a81;color:#1192af;font-size:11px;font-weight:400;padding:10px 8px}#parser-schedule-top20-form table tbody{border-top:1px solid #ccc}#parser-schedule-top20-form table td .money{width:78px;text-align:right;padding:6px 0}#parser-schedule-top20-form table td .money input[type=number]{width:55px;padding:3px;left:-2px;border-left:1px solid #ccc;font-size:10px}#parser-schedule-top20-form table td .money input[type=number]::-webkit-inner-spin-button{-webkit-appearance:none}#parser-schedule-top20-form table td textarea{resize:vertical}#parser-schedule-top20-form table .address{padding:2px}#parser-schedule-top20-form table .claimType{width:115px;padding:2px}#parser-schedule-top20-form table .form-control{width:inherit;height:inherit}#parser-schedule-top20-form table .input-group .form-control{margin-left:-2px}#parser-schedule-top20-form input[type=checkbox],#parser-schedule-top20-form input[type=radio]{width:10px}.schedule-top20-filters .form-text{background:#fff;color:#666;border:1px solid #9babb0;padding:2px 0}#schedule-top20 span.has-specified-creditor-priority,#schedule-top20 span.multiple-interest{width:220px;white-space:pre-line}#creditors .label{white-space:inherit;text-align:center;color:#1192af}#creditors .schedule-tips{display:block;font-style:italic;text-align:center}.additional_creditor{border-top:1px solid #ccc}", ""]);
	
	// exports


/***/ },
/* 1663 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "/*! ========================================================================\n * Bootstrap Toggle: bootstrap2-toggle.css v2.2.0\n * http://www.bootstraptoggle.com\n * ========================================================================\n * Copyright 2014 Min Hur, The New York Times Company\n * Licensed under MIT\n * ======================================================================== */label.checkbox.inline .toggle,label.checkbox .toggle{margin-left:-20px;margin-right:5px}.toggle{min-width:40px;height:20px;position:relative;overflow:hidden}.toggle-group{position:absolute;width:200%;top:0;bottom:0;left:0;transition:left .35s;-webkit-transition:left .35s;-moz-user-select:none;-webkit-user-select:none;user-select:none}.toggle.off .toggle-group{left:-100%}.toggle-on{left:0;right:50%}.toggle-off,.toggle-on{position:absolute;top:0;bottom:0;margin:0;border:0;border-radius:0}.toggle-off{left:50%;right:0}.toggle-handle{position:relative;margin:0 auto;padding-top:0;padding-bottom:0;height:100%;width:0;border-width:0 1px}.toggle-handle.btn-mini,.toggle-handle.btn-xs{top:-2px}.toggle.btn{min-width:30px}.toggle-on.btn{padding-right:24px}.toggle-off.btn,.toggle-on.btn{display:flex;align-items:center}.toggle-off.btn{padding-left:24px}.toggle.btn-large{min-width:40px}.toggle-on.btn-large{padding-right:35px}.toggle-off.btn-large{padding-left:35px}.toggle.btn-lg{min-width:40px}.toggle-on.btn-lg{padding-right:35px}.toggle-off.btn-lg{padding-left:35px}.toggle.btn-small{min-width:25px}.toggle-on.btn-small{padding-right:20px}.toggle-off.btn-small{padding-left:20px}.toggle.btn-sm{min-width:25px}.toggle-on.btn-sm{padding-right:20px}.toggle-off.btn-sm{padding-left:20px}.toggle.btn-mini{min-width:20px}.toggle-on.btn-mini{padding-right:12px}.toggle-off.btn-mini{padding-left:12px}.toggle.btn-xs{min-width:20px}.toggle-on.btn-xs{padding-right:12px}.toggle-off.btn-xs{padding-left:12px}.slow .toggle-group{transition:left .7s;-webkit-transition:left .7s}.fast .toggle-group{transition:left .1s;-webkit-transition:left .1s}.quick .toggle-group{transition:none;-webkit-transition:none}.toggle-off[disabled],.toggle-on.disabled,.toggle-on[disabled]{cursor:not-allowed!important}", ""]);
	
	// exports


/***/ },
/* 1664 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker__month-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{margin-left:-8px;position:absolute}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow:before{box-sizing:content-box;position:absolute;border:8px solid transparent;height:0;width:1px}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow:before{content:\"\";z-index:-1;border-width:8px;left:-8px;border-bottom-color:#aeaeae}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle{top:0;margin-top:-8px}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before{border-top:none;border-bottom-color:#f0f0f0}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before{top:-1px;border-bottom-color:#aeaeae}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker__month-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{bottom:0;margin-bottom:-8px}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow:before{border-bottom:none;border-top-color:#fff}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow:before{bottom:-1px;border-top-color:#aeaeae}.react-datepicker,.react-datepicker-wrapper{display:inline-block}.react-datepicker{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:.8rem;background-color:#fff;color:#000;border:1px solid #aeaeae;border-radius:.3rem;position:relative}.react-datepicker__triangle{position:absolute;left:50px}.react-datepicker-popper{z-index:1}.react-datepicker-popper[data-placement^=bottom]{margin-top:10px}.react-datepicker-popper[data-placement^=top]{margin-bottom:10px}.react-datepicker-popper[data-placement^=right]{margin-left:8px}.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle{left:auto;right:42px}.react-datepicker-popper[data-placement^=left]{margin-right:8px}.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle{left:42px;right:auto}.react-datepicker__header{text-align:center;background-color:#f0f0f0;border-bottom:1px solid #aeaeae;border-top-left-radius:.3rem;border-top-right-radius:.3rem;padding-top:8px;position:relative}.react-datepicker__header--time{padding-bottom:8px}.react-datepicker__month-dropdown-container--scroll,.react-datepicker__month-dropdown-container--select,.react-datepicker__year-dropdown-container--scroll,.react-datepicker__year-dropdown-container--select{display:inline-block;margin:0 2px}.react-datepicker-time__header,.react-datepicker__current-month{margin-top:0;color:#000;font-weight:700;font-size:.944rem}.react-datepicker__navigation{line-height:1.7rem;text-align:center;cursor:pointer;position:absolute;top:10px;width:0;border:.45rem solid transparent;z-index:1}.react-datepicker__navigation--previous{left:10px;border-right-color:#ccc}.react-datepicker__navigation--previous:hover{border-right-color:#b3b2b2}.react-datepicker__navigation--next{right:10px;border-left-color:#ccc}.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button){right:80px}.react-datepicker__navigation--next:hover{border-left-color:#b3b2b2}.react-datepicker__navigation--years{position:relative;top:0;display:block;margin-left:auto;margin-right:auto}.react-datepicker__navigation--years-previous{top:4px;border-top-color:#ccc}.react-datepicker__navigation--years-previous:hover{border-top-color:#b3b2b2}.react-datepicker__navigation--years-upcoming{top:-4px;border-bottom-color:#ccc}.react-datepicker__navigation--years-upcoming:hover{border-bottom-color:#b3b2b2}.react-datepicker__month-container{float:left}.react-datepicker__month{margin:.4rem;text-align:center}.react-datepicker__time-container{float:right;border-left:1px solid #aeaeae}.react-datepicker__time-container--with-today-button{display:inline;border:1px solid #aeaeae;border-radius:.3rem;position:absolute;right:-72px;top:0}.react-datepicker__time-container .react-datepicker__time{position:relative;background:#fff}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box{width:70px;overflow-x:hidden}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list{list-style:none;margin:0;height:calc(195px + 0.85rem);overflow-y:scroll;padding-right:30px;width:100%}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item{padding:5px 10px}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover{cursor:pointer;background-color:#f0f0f0}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected{background-color:#216ba5;color:#fff;font-weight:700}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover{background-color:#216ba5}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled{color:#ccc}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover{cursor:default;background-color:transparent}.react-datepicker__week-number{color:#ccc;display:inline-block;width:1.7rem;line-height:1.7rem;text-align:center;margin:.166rem}.react-datepicker__week-number.react-datepicker__week-number--clickable{cursor:pointer}.react-datepicker__week-number.react-datepicker__week-number--clickable:hover{border-radius:.3rem;background-color:#f0f0f0}.react-datepicker__day-names,.react-datepicker__week{white-space:nowrap}.react-datepicker__day,.react-datepicker__day-name,.react-datepicker__time-name{color:#000;display:inline-block;width:1.7rem;line-height:1.7rem;text-align:center;margin:.166rem}.react-datepicker__day{cursor:pointer}.react-datepicker__day:hover{border-radius:.3rem;background-color:#f0f0f0}.react-datepicker__day--today{font-weight:700}.react-datepicker__day--highlighted{border-radius:.3rem;background-color:#3dcc4a;color:#fff}.react-datepicker__day--highlighted:hover{background-color:#32be3f}.react-datepicker__day--highlighted-custom-1{color:#f0f}.react-datepicker__day--highlighted-custom-2{color:green}.react-datepicker__day--in-range,.react-datepicker__day--in-selecting-range,.react-datepicker__day--selected{border-radius:.3rem;background-color:#216ba5;color:#fff}.react-datepicker__day--in-range:hover,.react-datepicker__day--in-selecting-range:hover,.react-datepicker__day--selected:hover{background-color:#1d5d90}.react-datepicker__day--keyboard-selected{border-radius:.3rem;background-color:#2a87d0;color:#fff}.react-datepicker__day--keyboard-selected:hover{background-color:#1d5d90}.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range){background-color:rgba(33,107,165,.5)}.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range){background-color:#f0f0f0;color:#000}.react-datepicker__day--disabled{cursor:default;color:#ccc}.react-datepicker__day--disabled:hover{background-color:transparent}.react-datepicker__input-container{position:relative;display:inline-block}.react-datepicker__month-read-view,.react-datepicker__year-read-view{border:1px solid transparent;border-radius:.3rem}.react-datepicker__month-read-view:hover,.react-datepicker__year-read-view:hover{cursor:pointer}.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow{border-top-color:#b3b2b2}.react-datepicker__month-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{border-top-color:#ccc;float:right;margin-left:20px;top:8px;position:relative;border-width:.45rem}.react-datepicker__month-dropdown,.react-datepicker__year-dropdown{background-color:#f0f0f0;position:absolute;width:50%;left:25%;top:30px;z-index:1;text-align:center;border-radius:.3rem;border:1px solid #aeaeae}.react-datepicker__month-dropdown:hover,.react-datepicker__year-dropdown:hover{cursor:pointer}.react-datepicker__month-dropdown--scrollable,.react-datepicker__year-dropdown--scrollable{height:150px;overflow-y:scroll}.react-datepicker__month-option,.react-datepicker__year-option{line-height:20px;width:100%;display:block;margin-left:auto;margin-right:auto}.react-datepicker__month-option:first-of-type,.react-datepicker__year-option:first-of-type{border-top-left-radius:.3rem;border-top-right-radius:.3rem}.react-datepicker__month-option:last-of-type,.react-datepicker__year-option:last-of-type{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border-bottom-left-radius:.3rem;border-bottom-right-radius:.3rem}.react-datepicker__month-option:hover,.react-datepicker__year-option:hover{background-color:#ccc}.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming{border-bottom-color:#b3b2b2}.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous{border-top-color:#b3b2b2}.react-datepicker__month-option--selected,.react-datepicker__year-option--selected{position:absolute;left:15px}.react-datepicker__close-icon{background-color:transparent;border:0;cursor:pointer;display:inline-block;height:0;outline:0;padding:0;vertical-align:middle}.react-datepicker__close-icon:after{background-color:#216ba5;border-radius:50%;bottom:0;box-sizing:border-box;color:#fff;content:\"\\D7\";cursor:pointer;font-size:12px;height:16px;width:16px;line-height:1;margin:-8px auto 0;padding:2px;position:absolute;right:7px;text-align:center;top:50%}.react-datepicker__today-button{background:#f0f0f0;border-top:1px solid #aeaeae;cursor:pointer;text-align:center;font-weight:700;padding:5px 0;clear:left}.react-datepicker__portal{position:fixed;width:100vw;height:100vh;background-color:rgba(0,0,0,.8);left:0;top:0;justify-content:center;align-items:center;display:flex;z-index:2147483647}.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__time-name{width:3rem;line-height:3rem}@media (max-height:550px),(max-width:400px){.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__time-name{width:2rem;line-height:2rem}}.react-datepicker__portal .react-datepicker-time__header,.react-datepicker__portal .react-datepicker__current-month{font-size:1.44rem}.react-datepicker__portal .react-datepicker__navigation{border:.81rem solid transparent}.react-datepicker__portal .react-datepicker__navigation--previous{border-right-color:#ccc}.react-datepicker__portal .react-datepicker__navigation--previous:hover{border-right-color:#b3b2b2}.react-datepicker__portal .react-datepicker__navigation--next{border-left-color:#ccc}.react-datepicker__portal .react-datepicker__navigation--next:hover{border-left-color:#b3b2b2}", ""]);
	
	// exports


/***/ },
/* 1665 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{margin-left:-8px;position:absolute}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow:before{box-sizing:content-box;position:absolute;border:8px solid transparent;height:0;width:1px}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow:before{content:\"\";z-index:-1;border-width:8px;left:-8px;border-bottom-color:#aeaeae}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle{top:0;margin-top:-8px}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before{border-top:none;border-bottom-color:#f0f0f0}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before{top:-1px;border-bottom-color:#aeaeae}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{bottom:0;margin-bottom:-8px}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow:before{border-bottom:none;border-top-color:#fff}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow:before{bottom:-1px;border-top-color:#aeaeae}.react-datepicker-wrapper{display:inline-block;padding:0;border:0}.react-datepicker{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:.8rem;background-color:#fff;color:#000;border:1px solid #aeaeae;border-radius:.3rem;display:inline-block;position:relative}.react-datepicker--time-only .react-datepicker__triangle{left:35px}.react-datepicker--time-only .react-datepicker__time-container{border-left:0}.react-datepicker--time-only .react-datepicker__time,.react-datepicker--time-only .react-datepicker__time-box{border-radius:.3rem}.react-datepicker__triangle{position:absolute;left:50px}.react-datepicker-popper{z-index:1}.react-datepicker-popper[data-placement^=bottom]{margin-top:10px}.react-datepicker-popper[data-placement=bottom-end] .react-datepicker__triangle,.react-datepicker-popper[data-placement=top-end] .react-datepicker__triangle{left:auto;right:50px}.react-datepicker-popper[data-placement^=top]{margin-bottom:10px}.react-datepicker-popper[data-placement^=right]{margin-left:8px}.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle{left:auto;right:42px}.react-datepicker-popper[data-placement^=left]{margin-right:8px}.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle{left:42px;right:auto}.react-datepicker__header{text-align:center;background-color:#f0f0f0;border-bottom:1px solid #aeaeae;border-top-left-radius:.3rem;border-top-right-radius:.3rem;padding-top:8px;position:relative}.react-datepicker__header--time{padding-bottom:8px;padding-left:5px;padding-right:5px}.react-datepicker__month-dropdown-container--scroll,.react-datepicker__month-dropdown-container--select,.react-datepicker__month-year-dropdown-container--scroll,.react-datepicker__month-year-dropdown-container--select,.react-datepicker__year-dropdown-container--scroll,.react-datepicker__year-dropdown-container--select{display:inline-block;margin:0 2px}.react-datepicker-time__header,.react-datepicker-year-header,.react-datepicker__current-month{margin-top:0;color:#000;font-weight:700;font-size:.944rem}.react-datepicker-time__header{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.react-datepicker__navigation{background:none;line-height:1.7rem;text-align:center;cursor:pointer;position:absolute;top:10px;width:0;padding:0;border:.45rem solid transparent;z-index:1;height:10px;width:10px;text-indent:-999em;overflow:hidden}.react-datepicker__navigation--previous{left:10px;border-right-color:#ccc}.react-datepicker__navigation--previous:hover{border-right-color:#b3b3b3}.react-datepicker__navigation--previous--disabled,.react-datepicker__navigation--previous--disabled:hover{border-right-color:#e6e6e6;cursor:default}.react-datepicker__navigation--next{right:10px;border-left-color:#ccc}.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button){right:80px}.react-datepicker__navigation--next:hover{border-left-color:#b3b3b3}.react-datepicker__navigation--next--disabled,.react-datepicker__navigation--next--disabled:hover{border-left-color:#e6e6e6;cursor:default}.react-datepicker__navigation--years{position:relative;top:0;display:block;margin-left:auto;margin-right:auto}.react-datepicker__navigation--years-previous{top:4px;border-top-color:#ccc}.react-datepicker__navigation--years-previous:hover{border-top-color:#b3b3b3}.react-datepicker__navigation--years-upcoming{top:-4px;border-bottom-color:#ccc}.react-datepicker__navigation--years-upcoming:hover{border-bottom-color:#b3b3b3}.react-datepicker__month-container{float:left}.react-datepicker__month{margin:.4rem;text-align:center}.react-datepicker__month .react-datepicker__month-text,.react-datepicker__month .react-datepicker__quarter-text{display:inline-block;width:4rem;margin:2px}.react-datepicker__input-time-container{clear:both;width:100%;float:left;margin:5px 0 10px 15px;text-align:left}.react-datepicker__input-time-container .react-datepicker-time__caption,.react-datepicker__input-time-container .react-datepicker-time__input-container{display:inline-block}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input{display:inline-block;margin-left:10px}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input{width:85px}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-inner-spin-button,.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]{-moz-appearance:textfield}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter{margin-left:5px;display:inline-block}.react-datepicker__time-container{float:right;border-left:1px solid #aeaeae;width:85px}.react-datepicker__time-container--with-today-button{display:inline;border:1px solid #aeaeae;border-radius:.3rem;position:absolute;right:-72px;top:0}.react-datepicker__time-container .react-datepicker__time{position:relative;background:#fff}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box{width:85px;overflow-x:hidden;margin:0 auto;text-align:center}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list{list-style:none;margin:0;height:calc(195px + 0.85rem);overflow-y:scroll;padding-right:0;padding-left:0;width:100%;box-sizing:content-box}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item{height:30px;padding:5px 10px;white-space:nowrap}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover{cursor:pointer;background-color:#f0f0f0}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected{background-color:#216ba5;color:#fff;font-weight:700}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover{background-color:#216ba5}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled{color:#ccc}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover{cursor:default;background-color:transparent}.react-datepicker__week-number{color:#ccc;display:inline-block;width:1.7rem;line-height:1.7rem;text-align:center;margin:.166rem}.react-datepicker__week-number.react-datepicker__week-number--clickable{cursor:pointer}.react-datepicker__week-number.react-datepicker__week-number--clickable:hover{border-radius:.3rem;background-color:#f0f0f0}.react-datepicker__day-names,.react-datepicker__week{white-space:nowrap}.react-datepicker__day,.react-datepicker__day-name,.react-datepicker__time-name{color:#000;display:inline-block;width:1.7rem;line-height:1.7rem;text-align:center;margin:.166rem}.react-datepicker__month--in-range,.react-datepicker__month--in-selecting-range,.react-datepicker__month--selected,.react-datepicker__quarter--in-range,.react-datepicker__quarter--in-selecting-range,.react-datepicker__quarter--selected{border-radius:.3rem;background-color:#216ba5;color:#fff}.react-datepicker__month--in-range:hover,.react-datepicker__month--in-selecting-range:hover,.react-datepicker__month--selected:hover,.react-datepicker__quarter--in-range:hover,.react-datepicker__quarter--in-selecting-range:hover,.react-datepicker__quarter--selected:hover{background-color:#1d5d90}.react-datepicker__month--disabled,.react-datepicker__quarter--disabled{color:#ccc;pointer-events:none}.react-datepicker__month--disabled:hover,.react-datepicker__quarter--disabled:hover{cursor:default;background-color:transparent}.react-datepicker__day,.react-datepicker__month-text,.react-datepicker__quarter-text{cursor:pointer}.react-datepicker__day:hover,.react-datepicker__month-text:hover,.react-datepicker__quarter-text:hover{border-radius:.3rem;background-color:#f0f0f0}.react-datepicker__day--today,.react-datepicker__month-text--today,.react-datepicker__quarter-text--today{font-weight:700}.react-datepicker__day--highlighted,.react-datepicker__month-text--highlighted,.react-datepicker__quarter-text--highlighted{border-radius:.3rem;background-color:#3dcc4a;color:#fff}.react-datepicker__day--highlighted:hover,.react-datepicker__month-text--highlighted:hover,.react-datepicker__quarter-text--highlighted:hover{background-color:#32be3f}.react-datepicker__day--highlighted-custom-1,.react-datepicker__month-text--highlighted-custom-1,.react-datepicker__quarter-text--highlighted-custom-1{color:#f0f}.react-datepicker__day--highlighted-custom-2,.react-datepicker__month-text--highlighted-custom-2,.react-datepicker__quarter-text--highlighted-custom-2{color:green}.react-datepicker__day--in-range,.react-datepicker__day--in-selecting-range,.react-datepicker__day--selected,.react-datepicker__month-text--in-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__month-text--selected,.react-datepicker__quarter-text--in-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__quarter-text--selected{border-radius:.3rem;background-color:#216ba5;color:#fff}.react-datepicker__day--in-range:hover,.react-datepicker__day--in-selecting-range:hover,.react-datepicker__day--selected:hover,.react-datepicker__month-text--in-range:hover,.react-datepicker__month-text--in-selecting-range:hover,.react-datepicker__month-text--selected:hover,.react-datepicker__quarter-text--in-range:hover,.react-datepicker__quarter-text--in-selecting-range:hover,.react-datepicker__quarter-text--selected:hover{background-color:#1d5d90}.react-datepicker__day--keyboard-selected,.react-datepicker__month-text--keyboard-selected,.react-datepicker__quarter-text--keyboard-selected{border-radius:.3rem;background-color:#2a87d0;color:#fff}.react-datepicker__day--keyboard-selected:hover,.react-datepicker__month-text--keyboard-selected:hover,.react-datepicker__quarter-text--keyboard-selected:hover{background-color:#1d5d90}.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range{background-color:rgba(33,107,165,.5)}.react-datepicker__month--selecting-range .react-datepicker__day--in-range,.react-datepicker__month--selecting-range .react-datepicker__month-text--in-range,.react-datepicker__month--selecting-range .react-datepicker__quarter-text--in-range{background-color:#f0f0f0;color:#000}.react-datepicker__day--disabled,.react-datepicker__month-text--disabled,.react-datepicker__quarter-text--disabled{cursor:default;color:#ccc}.react-datepicker__day--disabled:hover,.react-datepicker__month-text--disabled:hover,.react-datepicker__quarter-text--disabled:hover{background-color:transparent}.react-datepicker__month-text.react-datepicker__month--in-range:hover,.react-datepicker__month-text.react-datepicker__month--selected:hover,.react-datepicker__month-text.react-datepicker__quarter--in-range:hover,.react-datepicker__month-text.react-datepicker__quarter--selected:hover,.react-datepicker__quarter-text.react-datepicker__month--in-range:hover,.react-datepicker__quarter-text.react-datepicker__month--selected:hover,.react-datepicker__quarter-text.react-datepicker__quarter--in-range:hover,.react-datepicker__quarter-text.react-datepicker__quarter--selected:hover{background-color:#216ba5}.react-datepicker__month-text:hover,.react-datepicker__quarter-text:hover{background-color:#f0f0f0}.react-datepicker__input-container{position:relative;display:inline-block;width:100%}.react-datepicker__month-read-view,.react-datepicker__month-year-read-view,.react-datepicker__year-read-view{border:1px solid transparent;border-radius:.3rem}.react-datepicker__month-read-view:hover,.react-datepicker__month-year-read-view:hover,.react-datepicker__year-read-view:hover{cursor:pointer}.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow{border-top-color:#b3b3b3}.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{border-top-color:#ccc;float:right;margin-left:20px;top:8px;position:relative;border-width:.45rem}.react-datepicker__month-dropdown,.react-datepicker__month-year-dropdown,.react-datepicker__year-dropdown{background-color:#f0f0f0;position:absolute;width:50%;left:25%;top:30px;z-index:1;text-align:center;border-radius:.3rem;border:1px solid #aeaeae}.react-datepicker__month-dropdown:hover,.react-datepicker__month-year-dropdown:hover,.react-datepicker__year-dropdown:hover{cursor:pointer}.react-datepicker__month-dropdown--scrollable,.react-datepicker__month-year-dropdown--scrollable,.react-datepicker__year-dropdown--scrollable{height:150px;overflow-y:scroll}.react-datepicker__month-option,.react-datepicker__month-year-option,.react-datepicker__year-option{line-height:20px;width:100%;display:block;margin-left:auto;margin-right:auto}.react-datepicker__month-option:first-of-type,.react-datepicker__month-year-option:first-of-type,.react-datepicker__year-option:first-of-type{border-top-left-radius:.3rem;border-top-right-radius:.3rem}.react-datepicker__month-option:last-of-type,.react-datepicker__month-year-option:last-of-type,.react-datepicker__year-option:last-of-type{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border-bottom-left-radius:.3rem;border-bottom-right-radius:.3rem}.react-datepicker__month-option:hover,.react-datepicker__month-year-option:hover,.react-datepicker__year-option:hover{background-color:#ccc}.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming,.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming{border-bottom-color:#b3b3b3}.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous,.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous{border-top-color:#b3b3b3}.react-datepicker__month-option--selected,.react-datepicker__month-year-option--selected,.react-datepicker__year-option--selected{position:absolute;left:15px}.react-datepicker__close-icon{cursor:pointer;background-color:transparent;border:0;outline:0;padding:0 6px 0 0;position:absolute;top:0;right:0;height:100%;display:table-cell;vertical-align:middle}.react-datepicker__close-icon:after{cursor:pointer;background-color:#216ba5;color:#fff;border-radius:50%;height:16px;width:16px;padding:2px;font-size:12px;line-height:1;text-align:center;display:table-cell;vertical-align:middle;content:\"\\D7\"}.react-datepicker__today-button{background:#f0f0f0;border-top:1px solid #aeaeae;cursor:pointer;text-align:center;font-weight:700;padding:5px 0;clear:left}.react-datepicker__portal{position:fixed;width:100vw;height:100vh;background-color:rgba(0,0,0,.8);left:0;top:0;justify-content:center;align-items:center;display:flex;z-index:2147483647}.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__time-name{width:3rem;line-height:3rem}@media (max-height:550px),(max-width:400px){.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__time-name{width:2rem;line-height:2rem}}.react-datepicker__portal .react-datepicker-time__header,.react-datepicker__portal .react-datepicker__current-month{font-size:1.44rem}.react-datepicker__portal .react-datepicker__navigation{border:.81rem solid transparent}.react-datepicker__portal .react-datepicker__navigation--previous{border-right-color:#ccc}.react-datepicker__portal .react-datepicker__navigation--previous:hover{border-right-color:#b3b3b3}.react-datepicker__portal .react-datepicker__navigation--previous--disabled,.react-datepicker__portal .react-datepicker__navigation--previous--disabled:hover{border-right-color:#e6e6e6;cursor:default}.react-datepicker__portal .react-datepicker__navigation--next{border-left-color:#ccc}.react-datepicker__portal .react-datepicker__navigation--next:hover{border-left-color:#b3b3b3}.react-datepicker__portal .react-datepicker__navigation--next--disabled,.react-datepicker__portal .react-datepicker__navigation--next--disabled:hover{border-left-color:#e6e6e6;cursor:default}", ""]);
	
	// exports


/***/ },
/* 1666 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".Select{position:relative}.Select input::-webkit-contacts-auto-fill-button,.Select input::-webkit-credentials-auto-fill-button{display:none!important}.Select input::-ms-clear,.Select input::-ms-reveal{display:none!important}.Select,.Select div,.Select input,.Select span{box-sizing:border-box}.Select.is-disabled .Select-arrow-zone{cursor:default;pointer-events:none;opacity:.35}.Select.is-disabled>.Select-control{background-color:#f9f9f9}.Select.is-disabled>.Select-control:hover{box-shadow:none}.Select.is-open>.Select-control{border-bottom-right-radius:0;border-bottom-left-radius:0;background:#fff;border-color:#b3b3b3 #ccc #d9d9d9}.Select.is-open>.Select-control .Select-arrow{top:-2px;border-color:transparent transparent #999;border-width:0 5px 5px}.Select.is-searchable.is-focused:not(.is-open)>.Select-control,.Select.is-searchable.is-open>.Select-control{cursor:text}.Select.is-focused>.Select-control{background:#fff}.Select.is-focused:not(.is-open)>.Select-control{border-color:#007eff;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 0 3px rgba(0,126,255,.1);background:#fff}.Select.has-value.is-clearable.Select--single>.Select-control .Select-value{padding-right:42px}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value .Select-value-label,.Select.has-value.Select--single>.Select-control .Select-value .Select-value-label{color:#333}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label{cursor:pointer;text-decoration:none}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:hover,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:hover{color:#007eff;outline:none;text-decoration:underline}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus{background:#fff}.Select.has-value.is-pseudo-focused .Select-input{opacity:0}.Select.is-open .Select-arrow,.Select .Select-arrow-zone:hover>.Select-arrow{border-top-color:#666}.Select.Select--rtl{direction:rtl;text-align:right}.Select-control{background-color:#fff;border-color:#d9d9d9 #ccc #b3b3b3;border-radius:4px;border:1px solid #ccc;color:#333;cursor:default;display:table;border-spacing:0;border-collapse:separate;height:36px;outline:none;overflow:hidden;position:relative;width:100%}.Select-control:hover{box-shadow:0 1px 0 rgba(0,0,0,.06)}.Select-control .Select-input:focus{outline:none;background:#fff}.Select--single>.Select-control .Select-value,.Select-placeholder{bottom:0;color:#aaa;left:0;line-height:34px;padding-left:10px;padding-right:10px;position:absolute;right:0;top:0;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.Select-input{height:34px;padding-left:10px;padding-right:10px;vertical-align:middle}.Select-input>input{width:100%;background:none transparent;border:0 none;box-shadow:none;cursor:default;display:inline-block;font-family:inherit;font-size:inherit;margin:0;outline:none;line-height:17px;padding:8px 0 12px;-webkit-appearance:none}.is-focused .Select-input>input{cursor:text}.has-value.is-pseudo-focused .Select-input{opacity:0}.Select-control:not(.is-searchable)>.Select-input{outline:none}.Select-loading-zone{cursor:pointer;display:table-cell;text-align:center}.Select-loading,.Select-loading-zone{position:relative;vertical-align:middle;width:16px}.Select-loading{animation:Select-animation-spin .4s infinite linear;height:16px;box-sizing:border-box;border-radius:50%;border:2px solid #ccc;border-right-color:#333;display:inline-block}.Select-clear-zone{animation:Select-animation-fadeIn .2s;color:#999;cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:17px}.Select-clear-zone:hover{color:#d0021b}.Select-clear{display:inline-block;font-size:18px;line-height:1}.Select--multi .Select-clear-zone{width:17px}.Select-arrow-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:25px;padding-right:5px}.Select--rtl .Select-arrow-zone{padding-right:0;padding-left:5px}.Select-arrow{border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 2.5px;display:inline-block;height:0;width:0;position:relative}.Select-control>:last-child{padding-right:5px}.Select--multi .Select-multi-value-wrapper{display:inline-block}.Select .Select-aria-only{position:absolute;display:inline-block;height:1px;width:1px;margin:-1px;clip:rect(0,0,0,0);overflow:hidden;float:left}@keyframes Select-animation-fadeIn{0%{opacity:0}to{opacity:1}}.Select-menu-outer{border-bottom-right-radius:4px;border-bottom-left-radius:4px;background-color:#fff;border:1px solid #ccc;border-top-color:#e6e6e6;box-shadow:0 1px 0 rgba(0,0,0,.06);box-sizing:border-box;margin-top:-1px;max-height:200px;position:absolute;top:100%;width:100%;z-index:1;-webkit-overflow-scrolling:touch}.Select-menu{max-height:198px;overflow-y:auto}.Select-option{box-sizing:border-box;background-color:#fff;color:#666;cursor:pointer;display:block;padding:8px 10px}.Select-option:last-child{border-bottom-right-radius:4px;border-bottom-left-radius:4px}.Select-option.is-selected{background-color:#f5faff;background-color:rgba(0,126,255,.04);color:#333}.Select-option.is-focused{background-color:#ebf5ff;background-color:rgba(0,126,255,.08);color:#333}.Select-option.is-disabled{color:#ccc;cursor:default}.Select-noresults{box-sizing:border-box;color:#999;cursor:default;display:block;padding:8px 10px}.Select--multi .Select-input{vertical-align:middle;margin-left:10px;padding:0}.Select--multi.Select--rtl .Select-input{margin-left:0;margin-right:10px}.Select--multi.has-value .Select-input{margin-left:5px}.Select--multi .Select-value{background-color:#ebf5ff;background-color:rgba(0,126,255,.08);border-radius:2px;border:1px solid #c2e0ff;border:1px solid rgba(0,126,255,.24);color:#007eff;display:inline-block;font-size:.9em;line-height:1.4;margin-left:5px;margin-top:5px;vertical-align:top}.Select--multi .Select-value-icon,.Select--multi .Select-value-label{display:inline-block;vertical-align:middle}.Select--multi .Select-value-label{border-bottom-right-radius:2px;border-top-right-radius:2px;cursor:default;padding:2px 5px}.Select--multi a.Select-value-label{color:#007eff;cursor:pointer;text-decoration:none}.Select--multi a.Select-value-label:hover{text-decoration:underline}.Select--multi .Select-value-icon{cursor:pointer;border-bottom-left-radius:2px;border-top-left-radius:2px;border-right:1px solid #c2e0ff;border-right:1px solid rgba(0,126,255,.24);padding:1px 5px 3px}.Select--multi .Select-value-icon:focus,.Select--multi .Select-value-icon:hover{background-color:#d8eafd;background-color:rgba(0,113,230,.08);color:#0071e6}.Select--multi .Select-value-icon:active{background-color:#c2e0ff;background-color:rgba(0,126,255,.24)}.Select--multi.Select--rtl .Select-value{margin-left:0;margin-right:5px}.Select--multi.Select--rtl .Select-value-icon{border-right:none;border-left:1px solid #c2e0ff;border-left:1px solid rgba(0,126,255,.24)}.Select--multi.is-disabled .Select-value{background-color:#fcfcfc;border:1px solid #e3e3e3;color:#333}.Select--multi.is-disabled .Select-value-icon{cursor:not-allowed;border-right:1px solid #e3e3e3}.Select--multi.is-disabled .Select-value-icon:active,.Select--multi.is-disabled .Select-value-icon:focus,.Select--multi.is-disabled .Select-value-icon:hover{background-color:#fcfcfc}@keyframes Select-animation-spin{to{transform:rotate(1turn)}}", ""]);
	
	// exports


/***/ },
/* 1667 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".Toastify__toast-container{z-index:9999;position:fixed;padding:4px;width:320px;box-sizing:border-box;color:#fff}.Toastify__toast-container--top-left{top:1em;left:1em}.Toastify__toast-container--top-center{top:1em;left:50%;margin-left:-160px}.Toastify__toast-container--top-right{top:1em;right:1em}.Toastify__toast-container--bottom-left{bottom:1em;left:1em}.Toastify__toast-container--bottom-center{bottom:1em;left:50%;margin-left:-160px}.Toastify__toast-container--bottom-right{bottom:1em;right:1em}@media only screen and (max-width:480px){.Toastify__toast-container{width:100vw;padding:0;left:0;margin:0}.Toastify__toast-container--top-center,.Toastify__toast-container--top-left,.Toastify__toast-container--top-right{top:0}.Toastify__toast-container--bottom-center,.Toastify__toast-container--bottom-left,.Toastify__toast-container--bottom-right{bottom:0}.Toastify__toast-container--rtl{right:0;left:auto}}.Toastify__toast{position:relative;min-height:64px;box-sizing:border-box;margin-bottom:1rem;padding:8px;border-radius:1px;box-shadow:0 1px 10px 0 rgba(0,0,0,.1),0 2px 15px 0 rgba(0,0,0,.05);display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;max-height:800px;overflow:hidden;font-family:sans-serif;cursor:pointer;direction:ltr}.Toastify__toast--rtl{direction:rtl}.Toastify__toast--default{background:#fff;color:#aaa}.Toastify__toast--info{background:#3498db}.Toastify__toast--success{background:#07bc0c}.Toastify__toast--warning{background:#f1c40f}.Toastify__toast--error{background:#e74c3c}.Toastify__toast-body{margin:auto 0;-ms-flex:1;flex:1}@media only screen and (max-width:480px){.Toastify__toast{margin-bottom:0}}.Toastify__close-button{color:#fff;font-weight:700;font-size:14px;background:transparent;outline:none;border:none;padding:0;cursor:pointer;opacity:.7;transition:.3s ease;-ms-flex-item-align:start;align-self:flex-start}.Toastify__close-button--default{color:#000;opacity:.3}.Toastify__close-button:focus,.Toastify__close-button:hover{opacity:1}@keyframes Toastify__trackProgress{0%{transform:scaleX(1)}to{transform:scaleX(0)}}.Toastify__progress-bar{position:absolute;bottom:0;left:0;width:100%;height:5px;z-index:9999;opacity:.7;background-color:hsla(0,0%,100%,.7);transform-origin:left}.Toastify__progress-bar--animated{animation:Toastify__trackProgress linear 1 forwards}.Toastify__progress-bar--controlled{transition:transform .2s}.Toastify__progress-bar--rtl{right:0;left:auto;transform-origin:right}.Toastify__progress-bar--default{background:linear-gradient(90deg,#4cd964,#5ac8fa,#007aff,#34aadc,#5856d6,#ff2d55)}@keyframes Toastify__bounceInRight{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutRight{20%{opacity:1;transform:translate3d(-20px,0,0)}to{opacity:0;transform:translate3d(2000px,0,0)}}@keyframes Toastify__bounceInLeft{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutLeft{20%{opacity:1;transform:translate3d(20px,0,0)}to{opacity:0;transform:translate3d(-2000px,0,0)}}@keyframes Toastify__bounceInUp{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}@keyframes Toastify__bounceOutUp{20%{transform:translate3d(0,-10px,0)}40%,45%{opacity:1;transform:translate3d(0,20px,0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}@keyframes Toastify__bounceInDown{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}@keyframes Toastify__bounceOutDown{20%{transform:translate3d(0,10px,0)}40%,45%{opacity:1;transform:translate3d(0,-20px,0)}to{opacity:0;transform:translate3d(0,2000px,0)}}.Toastify__bounce-enter--bottom-left,.Toastify__bounce-enter--top-left{animation-name:Toastify__bounceInLeft}.Toastify__bounce-enter--bottom-right,.Toastify__bounce-enter--top-right{animation-name:Toastify__bounceInRight}.Toastify__bounce-enter--top-center{animation-name:Toastify__bounceInDown}.Toastify__bounce-enter--bottom-center{animation-name:Toastify__bounceInUp}.Toastify__bounce-exit--bottom-left,.Toastify__bounce-exit--top-left{animation-name:Toastify__bounceOutLeft}.Toastify__bounce-exit--bottom-right,.Toastify__bounce-exit--top-right{animation-name:Toastify__bounceOutRight}.Toastify__bounce-exit--top-center{animation-name:Toastify__bounceOutUp}.Toastify__bounce-exit--bottom-center{animation-name:Toastify__bounceOutDown}@keyframes Toastify__zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes Toastify__zoomOut{0%{opacity:1}50%{opacity:0;transform:scale3d(.3,.3,.3)}to{opacity:0}}.Toastify__zoom-enter{animation-name:Toastify__zoomIn}.Toastify__zoom-exit{animation-name:Toastify__zoomOut}@keyframes Toastify__flipIn{0%{transform:perspective(400px) rotateX(90deg);animation-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateX(-20deg);animation-timing-function:ease-in}60%{transform:perspective(400px) rotateX(10deg);opacity:1}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}@keyframes Toastify__flipOut{0%{transform:perspective(400px)}30%{transform:perspective(400px) rotateX(-20deg);opacity:1}to{transform:perspective(400px) rotateX(90deg);opacity:0}}.Toastify__flip-enter{animation-name:Toastify__flipIn}.Toastify__flip-exit{animation-name:Toastify__flipOut}@keyframes Toastify__slideInRight{0%{transform:translate3d(110%,0,0);visibility:visible}to{transform:translateZ(0)}}@keyframes Toastify__slideInLeft{0%{transform:translate3d(-110%,0,0);visibility:visible}to{transform:translateZ(0)}}@keyframes Toastify__slideInUp{0%{transform:translate3d(0,110%,0);visibility:visible}to{transform:translateZ(0)}}@keyframes Toastify__slideInDown{0%{transform:translate3d(0,-110%,0);visibility:visible}to{transform:translateZ(0)}}@keyframes Toastify__slideOutRight{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(110%,0,0)}}@keyframes Toastify__slideOutLeft{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(-110%,0,0)}}@keyframes Toastify__slideOutDown{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(0,500px,0)}}@keyframes Toastify__slideOutUp{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(0,-500px,0)}}.Toastify__slide-enter--bottom-left,.Toastify__slide-enter--top-left{animation-name:Toastify__slideInLeft}.Toastify__slide-enter--bottom-right,.Toastify__slide-enter--top-right{animation-name:Toastify__slideInRight}.Toastify__slide-enter--top-center{animation-name:Toastify__slideInDown}.Toastify__slide-enter--bottom-center{animation-name:Toastify__slideInUp}.Toastify__slide-exit--bottom-left,.Toastify__slide-exit--top-left{animation-name:Toastify__slideOutLeft}.Toastify__slide-exit--bottom-right,.Toastify__slide-exit--top-right{animation-name:Toastify__slideOutRight}.Toastify__slide-exit--top-center{animation-name:Toastify__slideOutUp}.Toastify__slide-exit--bottom-center{animation-name:Toastify__slideOutDown}", ""]);
	
	// exports


/***/ },
/* 1668 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 currency.js - v2.0.4
	 http://scurker.github.io/currency.js
	
	 Copyright (c) 2021 Jason Wilson
	 Released under MIT license
	*/
	(function(e,g){ true?module.exports=g():"function"===typeof define&&define.amd?define(g):(e=e||self,e.currency=g())})(this,function(){function e(b,a){if(!(this instanceof e))return new e(b,a);a=Object.assign({},m,a);var d=Math.pow(10,a.precision);this.intValue=b=g(b,a);this.value=b/d;a.increment=a.increment||1/d;a.groups=a.useVedic?n:p;this.s=a;this.p=d}function g(b,a){var d=2<arguments.length&&void 0!==arguments[2]?arguments[2]:!0;var c=a.decimal;
	var h=a.errorOnInvalid,k=a.fromCents,l=Math.pow(10,a.precision),f=b instanceof e;if(f&&k)return b.intValue;if("number"===typeof b||f)c=f?b.value:b;else if("string"===typeof b)h=new RegExp("[^-\\d"+c+"]","g"),c=new RegExp("\\"+c,"g"),c=(c=b.replace(/\((.*)\)/,"-$1").replace(h,"").replace(c,"."))||0;else{if(h)throw Error("Invalid Input");c=0}k||(c=(c*l).toFixed(4));return d?Math.round(c):c}var m={symbol:"$",separator:",",decimal:".",errorOnInvalid:!1,precision:2,pattern:"!#",negativePattern:"-!#",format:function(b,
	a){var d=a.pattern,c=a.negativePattern,h=a.symbol,k=a.separator,l=a.decimal;a=a.groups;var f=(""+b).replace(/^-/,"").split("."),q=f[0];f=f[1];return(0<=b.value?d:c).replace("!",h).replace("#",q.replace(a,"$1"+k)+(f?l+f:""))},fromCents:!1},p=/(\d)(?=(\d{3})+\b)/g,n=/(\d)(?=(\d\d)+\d\b)/g;e.prototype={add:function(b){var a=this.s,d=this.p;return e((this.intValue+g(b,a))/(a.fromCents?1:d),a)},subtract:function(b){var a=this.s,d=this.p;return e((this.intValue-g(b,a))/(a.fromCents?1:d),a)},multiply:function(b){var a=
	this.s;return e(this.intValue*b/(a.fromCents?1:Math.pow(10,a.precision)),a)},divide:function(b){var a=this.s;return e(this.intValue/g(b,a,!1),a)},distribute:function(b){var a=this.intValue,d=this.p,c=this.s,h=[],k=Math[0<=a?"floor":"ceil"](a/b),l=Math.abs(a-k*b);for(d=c.fromCents?1:d;0!==b;b--){var f=e(k/d,c);0<l--&&(f=f[0<=a?"add":"subtract"](1/d));h.push(f)}return h},dollars:function(){return~~this.value},cents:function(){return~~(this.intValue%this.p)},format:function(b){var a=this.s;return"function"===
	typeof b?b(this,a):a.format(this,Object.assign({},a,b))},toString:function(){var b=this.s,a=b.increment;return(Math.round(this.intValue/this.p/a)*a).toFixed(b.precision)},toJSON:function(){return this.value}};return e});


/***/ },
/* 1669 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = assign;
	
	function assign(target, dirtyObject) {
	  if (target == null) {
	    throw new TypeError('assign requires that input parameter not be null or undefined');
	  }
	
	  dirtyObject = dirtyObject || {};
	
	  for (var property in dirtyObject) {
	    if (dirtyObject.hasOwnProperty(property)) {
	      target[property] = dirtyObject[property];
	    }
	  }
	
	  return target;
	}
	
	module.exports = exports.default;

/***/ },
/* 1670 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1671));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1672));
	
	var _index3 = _interopRequireDefault(__webpack_require__(813));
	
	var _index4 = _interopRequireDefault(__webpack_require__(814));
	
	var _index5 = _interopRequireDefault(__webpack_require__(815));
	
	var _index6 = _interopRequireDefault(__webpack_require__(480));
	
	var _index7 = _interopRequireDefault(__webpack_require__(811));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dayPeriodEnum = {
	  am: 'am',
	  pm: 'pm',
	  midnight: 'midnight',
	  noon: 'noon',
	  morning: 'morning',
	  afternoon: 'afternoon',
	  evening: 'evening',
	  night: 'night'
	  /*
	   * |     | Unit                           |     | Unit                           |
	   * |-----|--------------------------------|-----|--------------------------------|
	   * |  a  | AM, PM                         |  A* | Milliseconds in day            |
	   * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
	   * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
	   * |  d  | Day of month                   |  D  | Day of year                    |
	   * |  e  | Local day of week              |  E  | Day of week                    |
	   * |  f  |                                |  F* | Day of week in month           |
	   * |  g* | Modified Julian day            |  G  | Era                            |
	   * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	   * |  i! | ISO day of week                |  I! | ISO week of year               |
	   * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
	   * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
	   * |  l* | (deprecated)                   |  L  | Stand-alone month              |
	   * |  m  | Minute                         |  M  | Month                          |
	   * |  n  |                                |  N  |                                |
	   * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
	   * |  p! | Long localized time            |  P! | Long localized date            |
	   * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
	   * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
	   * |  s  | Second                         |  S  | Fraction of second             |
	   * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
	   * |  u  | Extended year                  |  U* | Cyclic year                    |
	   * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
	   * |  w  | Local week of year             |  W* | Week of month                  |
	   * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
	   * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
	   * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
	   *
	   * Letters marked by * are not implemented but reserved by Unicode standard.
	   *
	   * Letters marked by ! are non-standard, but implemented by date-fns:
	   * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
	   * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
	   *   i.e. 7 for Sunday, 1 for Monday, etc.
	   * - `I` is ISO week of year, as opposed to `w` which is local week of year.
	   * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
	   *   `R` is supposed to be used in conjunction with `I` and `i`
	   *   for universal ISO week-numbering date, whereas
	   *   `Y` is supposed to be used in conjunction with `w` and `e`
	   *   for week-numbering date specific to the locale.
	   * - `P` is long localized date format
	   * - `p` is long localized time format
	   */
	
	};
	var formatters = {
	  // Era
	  G: function (date, token, localize) {
	    var era = date.getUTCFullYear() > 0 ? 1 : 0;
	
	    switch (token) {
	      // AD, BC
	      case 'G':
	      case 'GG':
	      case 'GGG':
	        return localize.era(era, {
	          width: 'abbreviated'
	        });
	      // A, B
	
	      case 'GGGGG':
	        return localize.era(era, {
	          width: 'narrow'
	        });
	      // Anno Domini, Before Christ
	
	      case 'GGGG':
	      default:
	        return localize.era(era, {
	          width: 'wide'
	        });
	    }
	  },
	  // Year
	  y: function (date, token, localize) {
	    // Ordinal number
	    if (token === 'yo') {
	      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
	
	      var year = signedYear > 0 ? signedYear : 1 - signedYear;
	      return localize.ordinalNumber(year, {
	        unit: 'year'
	      });
	    }
	
	    return _index.default.y(date, token);
	  },
	  // Local week-numbering year
	  Y: function (date, token, localize, options) {
	    var signedWeekYear = (0, _index6.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
	
	    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
	
	    if (token === 'YY') {
	      var twoDigitYear = weekYear % 100;
	      return (0, _index7.default)(twoDigitYear, 2);
	    } // Ordinal number
	
	
	    if (token === 'Yo') {
	      return localize.ordinalNumber(weekYear, {
	        unit: 'year'
	      });
	    } // Padding
	
	
	    return (0, _index7.default)(weekYear, token.length);
	  },
	  // ISO week-numbering year
	  R: function (date, token) {
	    var isoWeekYear = (0, _index4.default)(date); // Padding
	
	    return (0, _index7.default)(isoWeekYear, token.length);
	  },
	  // Extended year. This is a single number designating the year of this calendar system.
	  // The main difference between `y` and `u` localizers are B.C. years:
	  // | Year | `y` | `u` |
	  // |------|-----|-----|
	  // | AC 1 |   1 |   1 |
	  // | BC 1 |   1 |   0 |
	  // | BC 2 |   2 |  -1 |
	  // Also `yy` always returns the last two digits of a year,
	  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
	  u: function (date, token) {
	    var year = date.getUTCFullYear();
	    return (0, _index7.default)(year, token.length);
	  },
	  // Quarter
	  Q: function (date, token, localize) {
	    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
	
	    switch (token) {
	      // 1, 2, 3, 4
	      case 'Q':
	        return String(quarter);
	      // 01, 02, 03, 04
	
	      case 'QQ':
	        return (0, _index7.default)(quarter, 2);
	      // 1st, 2nd, 3rd, 4th
	
	      case 'Qo':
	        return localize.ordinalNumber(quarter, {
	          unit: 'quarter'
	        });
	      // Q1, Q2, Q3, Q4
	
	      case 'QQQ':
	        return localize.quarter(quarter, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	
	      case 'QQQQQ':
	        return localize.quarter(quarter, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // 1st quarter, 2nd quarter, ...
	
	      case 'QQQQ':
	      default:
	        return localize.quarter(quarter, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone quarter
	  q: function (date, token, localize) {
	    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
	
	    switch (token) {
	      // 1, 2, 3, 4
	      case 'q':
	        return String(quarter);
	      // 01, 02, 03, 04
	
	      case 'qq':
	        return (0, _index7.default)(quarter, 2);
	      // 1st, 2nd, 3rd, 4th
	
	      case 'qo':
	        return localize.ordinalNumber(quarter, {
	          unit: 'quarter'
	        });
	      // Q1, Q2, Q3, Q4
	
	      case 'qqq':
	        return localize.quarter(quarter, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	
	      case 'qqqqq':
	        return localize.quarter(quarter, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // 1st quarter, 2nd quarter, ...
	
	      case 'qqqq':
	      default:
	        return localize.quarter(quarter, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // Month
	  M: function (date, token, localize) {
	    var month = date.getUTCMonth();
	
	    switch (token) {
	      case 'M':
	      case 'MM':
	        return _index.default.M(date, token);
	      // 1st, 2nd, ..., 12th
	
	      case 'Mo':
	        return localize.ordinalNumber(month + 1, {
	          unit: 'month'
	        });
	      // Jan, Feb, ..., Dec
	
	      case 'MMM':
	        return localize.month(month, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // J, F, ..., D
	
	      case 'MMMMM':
	        return localize.month(month, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // January, February, ..., December
	
	      case 'MMMM':
	      default:
	        return localize.month(month, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone month
	  L: function (date, token, localize) {
	    var month = date.getUTCMonth();
	
	    switch (token) {
	      // 1, 2, ..., 12
	      case 'L':
	        return String(month + 1);
	      // 01, 02, ..., 12
	
	      case 'LL':
	        return (0, _index7.default)(month + 1, 2);
	      // 1st, 2nd, ..., 12th
	
	      case 'Lo':
	        return localize.ordinalNumber(month + 1, {
	          unit: 'month'
	        });
	      // Jan, Feb, ..., Dec
	
	      case 'LLL':
	        return localize.month(month, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // J, F, ..., D
	
	      case 'LLLLL':
	        return localize.month(month, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // January, February, ..., December
	
	      case 'LLLL':
	      default:
	        return localize.month(month, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // Local week of year
	  w: function (date, token, localize, options) {
	    var week = (0, _index5.default)(date, options);
	
	    if (token === 'wo') {
	      return localize.ordinalNumber(week, {
	        unit: 'week'
	      });
	    }
	
	    return (0, _index7.default)(week, token.length);
	  },
	  // ISO week of year
	  I: function (date, token, localize) {
	    var isoWeek = (0, _index3.default)(date);
	
	    if (token === 'Io') {
	      return localize.ordinalNumber(isoWeek, {
	        unit: 'week'
	      });
	    }
	
	    return (0, _index7.default)(isoWeek, token.length);
	  },
	  // Day of the month
	  d: function (date, token, localize) {
	    if (token === 'do') {
	      return localize.ordinalNumber(date.getUTCDate(), {
	        unit: 'date'
	      });
	    }
	
	    return _index.default.d(date, token);
	  },
	  // Day of year
	  D: function (date, token, localize) {
	    var dayOfYear = (0, _index2.default)(date);
	
	    if (token === 'Do') {
	      return localize.ordinalNumber(dayOfYear, {
	        unit: 'dayOfYear'
	      });
	    }
	
	    return (0, _index7.default)(dayOfYear, token.length);
	  },
	  // Day of week
	  E: function (date, token, localize) {
	    var dayOfWeek = date.getUTCDay();
	
	    switch (token) {
	      // Tue
	      case 'E':
	      case 'EE':
	      case 'EEE':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	
	      case 'EEEEE':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	
	      case 'EEEEEE':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	
	      case 'EEEE':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Local day of week
	  e: function (date, token, localize, options) {
	    var dayOfWeek = date.getUTCDay();
	    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
	
	    switch (token) {
	      // Numerical value (Nth day of week with current locale or weekStartsOn)
	      case 'e':
	        return String(localDayOfWeek);
	      // Padded numerical value
	
	      case 'ee':
	        return (0, _index7.default)(localDayOfWeek, 2);
	      // 1st, 2nd, ..., 7th
	
	      case 'eo':
	        return localize.ordinalNumber(localDayOfWeek, {
	          unit: 'day'
	        });
	
	      case 'eee':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	
	      case 'eeeee':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	
	      case 'eeeeee':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	
	      case 'eeee':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone local day of week
	  c: function (date, token, localize, options) {
	    var dayOfWeek = date.getUTCDay();
	    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
	
	    switch (token) {
	      // Numerical value (same as in `e`)
	      case 'c':
	        return String(localDayOfWeek);
	      // Padded numerical value
	
	      case 'cc':
	        return (0, _index7.default)(localDayOfWeek, token.length);
	      // 1st, 2nd, ..., 7th
	
	      case 'co':
	        return localize.ordinalNumber(localDayOfWeek, {
	          unit: 'day'
	        });
	
	      case 'ccc':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // T
	
	      case 'ccccc':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // Tu
	
	      case 'cccccc':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'standalone'
	        });
	      // Tuesday
	
	      case 'cccc':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // ISO day of week
	  i: function (date, token, localize) {
	    var dayOfWeek = date.getUTCDay();
	    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
	
	    switch (token) {
	      // 2
	      case 'i':
	        return String(isoDayOfWeek);
	      // 02
	
	      case 'ii':
	        return (0, _index7.default)(isoDayOfWeek, token.length);
	      // 2nd
	
	      case 'io':
	        return localize.ordinalNumber(isoDayOfWeek, {
	          unit: 'day'
	        });
	      // Tue
	
	      case 'iii':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	
	      case 'iiiii':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	
	      case 'iiiiii':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	
	      case 'iiii':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // AM or PM
	  a: function (date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
	
	    switch (token) {
	      case 'a':
	      case 'aa':
	      case 'aaa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	
	      case 'aaaaa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	
	      case 'aaaa':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // AM, PM, midnight, noon
	  b: function (date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue;
	
	    if (hours === 12) {
	      dayPeriodEnumValue = dayPeriodEnum.noon;
	    } else if (hours === 0) {
	      dayPeriodEnumValue = dayPeriodEnum.midnight;
	    } else {
	      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
	    }
	
	    switch (token) {
	      case 'b':
	      case 'bb':
	      case 'bbb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	
	      case 'bbbbb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	
	      case 'bbbb':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // in the morning, in the afternoon, in the evening, at night
	  B: function (date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue;
	
	    if (hours >= 17) {
	      dayPeriodEnumValue = dayPeriodEnum.evening;
	    } else if (hours >= 12) {
	      dayPeriodEnumValue = dayPeriodEnum.afternoon;
	    } else if (hours >= 4) {
	      dayPeriodEnumValue = dayPeriodEnum.morning;
	    } else {
	      dayPeriodEnumValue = dayPeriodEnum.night;
	    }
	
	    switch (token) {
	      case 'B':
	      case 'BB':
	      case 'BBB':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	
	      case 'BBBBB':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	
	      case 'BBBB':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Hour [1-12]
	  h: function (date, token, localize) {
	    if (token === 'ho') {
	      var hours = date.getUTCHours() % 12;
	      if (hours === 0) hours = 12;
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	
	    return _index.default.h(date, token);
	  },
	  // Hour [0-23]
	  H: function (date, token, localize) {
	    if (token === 'Ho') {
	      return localize.ordinalNumber(date.getUTCHours(), {
	        unit: 'hour'
	      });
	    }
	
	    return _index.default.H(date, token);
	  },
	  // Hour [0-11]
	  K: function (date, token, localize) {
	    var hours = date.getUTCHours() % 12;
	
	    if (token === 'Ko') {
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	
	    return (0, _index7.default)(hours, token.length);
	  },
	  // Hour [1-24]
	  k: function (date, token, localize) {
	    var hours = date.getUTCHours();
	    if (hours === 0) hours = 24;
	
	    if (token === 'ko') {
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	
	    return (0, _index7.default)(hours, token.length);
	  },
	  // Minute
	  m: function (date, token, localize) {
	    if (token === 'mo') {
	      return localize.ordinalNumber(date.getUTCMinutes(), {
	        unit: 'minute'
	      });
	    }
	
	    return _index.default.m(date, token);
	  },
	  // Second
	  s: function (date, token, localize) {
	    if (token === 'so') {
	      return localize.ordinalNumber(date.getUTCSeconds(), {
	        unit: 'second'
	      });
	    }
	
	    return _index.default.s(date, token);
	  },
	  // Fraction of second
	  S: function (date, token) {
	    return _index.default.S(date, token);
	  },
	  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
	  X: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	
	    if (timezoneOffset === 0) {
	      return 'Z';
	    }
	
	    switch (token) {
	      // Hours and optional minutes
	      case 'X':
	        return formatTimezoneWithOptionalMinutes(timezoneOffset);
	      // Hours, minutes and optional seconds without `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `XX`
	
	      case 'XXXX':
	      case 'XX':
	        // Hours and minutes without `:` delimiter
	        return formatTimezone(timezoneOffset);
	      // Hours, minutes and optional seconds with `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `XXX`
	
	      case 'XXXXX':
	      case 'XXX': // Hours and minutes with `:` delimiter
	
	      default:
	        return formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
	  x: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	
	    switch (token) {
	      // Hours and optional minutes
	      case 'x':
	        return formatTimezoneWithOptionalMinutes(timezoneOffset);
	      // Hours, minutes and optional seconds without `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `xx`
	
	      case 'xxxx':
	      case 'xx':
	        // Hours and minutes without `:` delimiter
	        return formatTimezone(timezoneOffset);
	      // Hours, minutes and optional seconds with `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `xxx`
	
	      case 'xxxxx':
	      case 'xxx': // Hours and minutes with `:` delimiter
	
	      default:
	        return formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (GMT)
	  O: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	
	    switch (token) {
	      // Short
	      case 'O':
	      case 'OO':
	      case 'OOO':
	        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
	      // Long
	
	      case 'OOOO':
	      default:
	        return 'GMT' + formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (specific non-location)
	  z: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	
	    switch (token) {
	      // Short
	      case 'z':
	      case 'zz':
	      case 'zzz':
	        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
	      // Long
	
	      case 'zzzz':
	      default:
	        return 'GMT' + formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Seconds timestamp
	  t: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timestamp = Math.floor(originalDate.getTime() / 1000);
	    return (0, _index7.default)(timestamp, token.length);
	  },
	  // Milliseconds timestamp
	  T: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timestamp = originalDate.getTime();
	    return (0, _index7.default)(timestamp, token.length);
	  }
	};
	
	function formatTimezoneShort(offset, dirtyDelimiter) {
	  var sign = offset > 0 ? '-' : '+';
	  var absOffset = Math.abs(offset);
	  var hours = Math.floor(absOffset / 60);
	  var minutes = absOffset % 60;
	
	  if (minutes === 0) {
	    return sign + String(hours);
	  }
	
	  var delimiter = dirtyDelimiter || '';
	  return sign + String(hours) + delimiter + (0, _index7.default)(minutes, 2);
	}
	
	function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
	  if (offset % 60 === 0) {
	    var sign = offset > 0 ? '-' : '+';
	    return sign + (0, _index7.default)(Math.abs(offset) / 60, 2);
	  }
	
	  return formatTimezone(offset, dirtyDelimiter);
	}
	
	function formatTimezone(offset, dirtyDelimiter) {
	  var delimiter = dirtyDelimiter || '';
	  var sign = offset > 0 ? '-' : '+';
	  var absOffset = Math.abs(offset);
	  var hours = (0, _index7.default)(Math.floor(absOffset / 60), 2);
	  var minutes = (0, _index7.default)(absOffset % 60, 2);
	  return sign + hours + delimiter + minutes;
	}
	
	var _default = formatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1671 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(811));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* |                                |
	 * |  d  | Day of month                   |  D  |                                |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  y  | Year (abs)                     |  Y  |                                |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 */
	var formatters = {
	  // Year
	  y: function (date, token) {
	    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
	    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
	    // |----------|-------|----|-------|-------|-------|
	    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
	    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
	    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
	    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
	    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
	    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
	
	    var year = signedYear > 0 ? signedYear : 1 - signedYear;
	    return (0, _index.default)(token === 'yy' ? year % 100 : year, token.length);
	  },
	  // Month
	  M: function (date, token) {
	    var month = date.getUTCMonth();
	    return token === 'M' ? String(month + 1) : (0, _index.default)(month + 1, 2);
	  },
	  // Day of the month
	  d: function (date, token) {
	    return (0, _index.default)(date.getUTCDate(), token.length);
	  },
	  // AM or PM
	  a: function (date, token) {
	    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
	
	    switch (token) {
	      case 'a':
	      case 'aa':
	      case 'aaa':
	        return dayPeriodEnumValue.toUpperCase();
	
	      case 'aaaaa':
	        return dayPeriodEnumValue[0];
	
	      case 'aaaa':
	      default:
	        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
	    }
	  },
	  // Hour [1-12]
	  h: function (date, token) {
	    return (0, _index.default)(date.getUTCHours() % 12 || 12, token.length);
	  },
	  // Hour [0-23]
	  H: function (date, token) {
	    return (0, _index.default)(date.getUTCHours(), token.length);
	  },
	  // Minute
	  m: function (date, token) {
	    return (0, _index.default)(date.getUTCMinutes(), token.length);
	  },
	  // Second
	  s: function (date, token) {
	    return (0, _index.default)(date.getUTCSeconds(), token.length);
	  },
	  // Fraction of second
	  S: function (date, token) {
	    var numberOfDigits = token.length;
	    var milliseconds = date.getUTCMilliseconds();
	    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
	    return (0, _index.default)(fractionalSeconds, token.length);
	  }
	};
	var _default = formatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1672 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCDayOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	
	function getUTCDayOfYear(dirtyDate) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var timestamp = date.getTime();
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	  var startOfYearTimestamp = date.getTime();
	  var difference = timestamp - startOfYearTimestamp;
	  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
	}
	
	module.exports = exports.default;

/***/ },
/* 1673 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCDay;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index2.default)(dirtyDate);
	  var day = (0, _index.default)(dirtyDay);
	  var currentDay = date.getUTCDay();
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1674 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCISODay;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCISODay(dirtyDate, dirtyDay) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var day = (0, _index.default)(dirtyDay);
	
	  if (day % 7 === 0) {
	    day = day - 7;
	  }
	
	  var weekStartsOn = 1;
	  var date = (0, _index2.default)(dirtyDate);
	  var currentDay = date.getUTCDay();
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1675 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(19));
	
	var _index3 = _interopRequireDefault(__webpack_require__(813));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate);
	  var isoWeek = (0, _index.default)(dirtyISOWeek);
	  var diff = (0, _index3.default)(date) - isoWeek;
	  date.setUTCDate(date.getUTCDate() - diff * 7);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1676 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(19));
	
	var _index3 = _interopRequireDefault(__webpack_require__(815));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCWeek(dirtyDate, dirtyWeek, options) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate);
	  var week = (0, _index.default)(dirtyWeek);
	  var diff = (0, _index3.default)(date, options) - week;
	  date.setUTCDate(date.getUTCDate() - diff * 7);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1677 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(814));
	
	var _index2 = _interopRequireDefault(__webpack_require__(300));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCISOWeekYear(dirtyDate) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setUTCFullYear(year, 0, 4);
	  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuary);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1678 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(480));
	
	var _index3 = _interopRequireDefault(__webpack_require__(301));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index.default)(options.firstWeekContainsDate);
	  var year = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var firstWeek = new Date(0);
	  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
	  firstWeek.setUTCHours(0, 0, 0, 0);
	  var date = (0, _index3.default)(firstWeek, dirtyOptions);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1679 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarDays;
	
	var _index = _interopRequireDefault(__webpack_require__(225));
	
	var _index2 = _interopRequireDefault(__webpack_require__(484));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_DAY = 86400000;
	/**
	 * @name differenceInCalendarDays
	 * @category Day Helpers
	 * @summary Get the number of calendar days between the given dates.
	 *
	 * @description
	 * Get the number of calendar days between the given dates. This means that the times are removed
	 * from the dates and then the difference in days is calculated.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar days
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar days are between
	 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	 * var result = differenceInCalendarDays(
	 *   new Date(2012, 6, 2, 0, 0),
	 *   new Date(2011, 6, 2, 23, 0)
	 * )
	 * //=> 366
	 * // How many calendar days are between
	 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
	 * var result = differenceInCalendarDays(
	 *   new Date(2011, 6, 3, 0, 1),
	 *   new Date(2011, 6, 2, 23, 59)
	 * )
	 * //=> 1
	 */
	
	function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var startOfDayLeft = (0, _index2.default)(dirtyDateLeft);
	  var startOfDayRight = (0, _index2.default)(dirtyDateRight);
	  var timestampLeft = startOfDayLeft.getTime() - (0, _index.default)(startOfDayLeft);
	  var timestampRight = startOfDayRight.getTime() - (0, _index.default)(startOfDayRight); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a day is not constant
	  // (e.g. it's different in the day of the daylight saving time clock shift)
	
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
	}
	
	module.exports = exports.default;

/***/ },
/* 1680 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInCalendarMonths
	 * @category Month Helpers
	 * @summary Get the number of calendar months between the given dates.
	 *
	 * @description
	 * Get the number of calendar months between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar months
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar months are between 31 January 2014 and 1 September 2014?
	 * var result = differenceInCalendarMonths(
	 *   new Date(2014, 8, 1),
	 *   new Date(2014, 0, 31)
	 * )
	 * //=> 8
	 */
	function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
	  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
	  return yearDiff * 12 + monthDiff;
	}
	
	module.exports = exports.default;

/***/ },
/* 1681 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(826));
	
	var _index2 = _interopRequireDefault(__webpack_require__(225));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000;
	/**
	 * @name differenceInCalendarWeeks
	 * @category Week Helpers
	 * @summary Get the number of calendar weeks between the given dates.
	 *
	 * @description
	 * Get the number of calendar weeks between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Number} the number of calendar weeks
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
	 * var result = differenceInCalendarWeeks(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 6, 5)
	 * )
	 * //=> 3
	 *
	 * @example
	 * // If the week starts on Monday,
	 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
	 * var result = differenceInCalendarWeeks(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 6, 5),
	 *   { weekStartsOn: 1 }
	 * )
	 * //=> 2
	 */
	
	function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var startOfWeekLeft = (0, _index.default)(dirtyDateLeft, dirtyOptions);
	  var startOfWeekRight = (0, _index.default)(dirtyDateRight, dirtyOptions);
	  var timestampLeft = startOfWeekLeft.getTime() - (0, _index2.default)(startOfWeekLeft);
	  var timestampRight = startOfWeekRight.getTime() - (0, _index2.default)(startOfWeekRight); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
	}
	
	module.exports = exports.default;

/***/ },
/* 1682 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarYears;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInCalendarYears
	 * @category Year Helpers
	 * @summary Get the number of calendar years between the given dates.
	 *
	 * @description
	 * Get the number of calendar years between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar years are between 31 December 2013 and 11 February 2015?
	 * var result = differenceInCalendarYears(
	 *   new Date(2015, 1, 11),
	 *   new Date(2013, 11, 31)
	 * )
	 * //=> 2
	 */
	function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() - dateRight.getFullYear();
	}
	
	module.exports = exports.default;

/***/ },
/* 1683 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfDay;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfDay
	 * @category Day Helpers
	 * @summary Return the end of a day for the given date.
	 *
	 * @description
	 * Return the end of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a day
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a day for 2 September 2014 11:55:00:
	 * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 23:59:59.999
	 */
	function endOfDay(dirtyDate) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1684 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfMonth
	 * @category Month Helpers
	 * @summary Return the end of a month for the given date.
	 *
	 * @description
	 * Return the end of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a month for 2 September 2014 11:55:00:
	 * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 23:59:59.999
	 */
	function endOfMonth(dirtyDate) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var month = date.getMonth();
	  date.setFullYear(date.getFullYear(), month + 1, 0);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1685 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfWeek
	 * @category Week Helpers
	 * @summary Return the end of a week for the given date.
	 *
	 * @description
	 * Return the end of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the end of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The end of a week for 2 September 2014 11:55:00:
	 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sat Sep 06 2014 23:59:59.999
	 *
	 * @example
	 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
	 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
	 * //=> Sun Sep 07 2014 23:59:59.999
	 */
	function endOfWeek(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index2.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index2.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
	  date.setDate(date.getDate() + diff);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1686 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = format;
	
	var _index = _interopRequireDefault(__webpack_require__(822));
	
	var _index2 = _interopRequireDefault(__webpack_require__(823));
	
	var _index3 = _interopRequireDefault(__webpack_require__(827));
	
	var _index4 = _interopRequireDefault(__webpack_require__(19));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1670));
	
	var _index6 = _interopRequireDefault(__webpack_require__(812));
	
	var _index7 = _interopRequireDefault(__webpack_require__(225));
	
	var _index8 = __webpack_require__(816);
	
	var _index9 = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This RegExp consists of three parts separated by `|`:
	// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
	//   (one of the certain letters followed by `o`)
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
	// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
	
	var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
	/**
	 * @name format
	 * @category Common Helpers
	 * @summary Format the date.
	 *
	 * @description
	 * Return the formatted date string in the given format. The result may vary by locale.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://git.io/fxCyr
	 *
	 * The characters wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 * (see the last example)
	 *
	 * Format of the string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 7 below the table).
	 *
	 * Accepted patterns:
	 * | Unit                            | Pattern | Result examples                   | Notes |
	 * |---------------------------------|---------|-----------------------------------|-------|
	 * | Era                             | G..GGG  | AD, BC                            |       |
	 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 | GGGGG   | A, B                              |       |
	 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
	 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
	 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
	 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
	 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
	 * |                                 | yyyyy   | ...                               | 3,5   |
	 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
	 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
	 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
	 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
	 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
	 * |                                 | YYYYY   | ...                               | 3,5   |
	 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
	 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
	 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
	 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
	 * |                                 | RRRRR   | ...                               | 3,5,7 |
	 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
	 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
	 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
	 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
	 * |                                 | uuuuu   | ...                               | 3,5   |
	 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
	 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
	 * |                                 | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
	 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
	 * |                                 | qq      | 01, 02, 03, 04                    |       |
	 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
	 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
	 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
	 * |                                 | MM      | 01, 02, ..., 12                   |       |
	 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 | MMMM    | January, February, ..., December  | 2     |
	 * |                                 | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
	 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
	 * |                                 | LL      | 01, 02, ..., 12                   |       |
	 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 | LLLL    | January, February, ..., December  | 2     |
	 * |                                 | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
	 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
	 * |                                 | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
	 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
	 * |                                 | II      | 01, 02, ..., 53                   | 7     |
	 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
	 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
	 * |                                 | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
	 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
	 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
	 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 | DDDD    | ...                               | 3     |
	 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
	 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
	 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
	 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
	 * |                                 | iii     | Mon, Tue, Wed, ..., Su            | 7     |
	 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
	 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
	 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
	 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
	 * |                                 | ee      | 02, 03, ..., 01                   |       |
	 * |                                 | eee     | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
	 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
	 * |                                 | cc      | 02, 03, ..., 01                   |       |
	 * |                                 | ccc     | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
	 * | AM, PM                          | a..aaa  | AM, PM                            |       |
	 * |                                 | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          | b..bbb  | AM, PM, noon, midnight            |       |
	 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
	 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
	 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
	 * |                                 | KK      | 1, 2, ..., 11, 0                  |       |
	 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
	 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          | m       | 0, 1, ..., 59                     |       |
	 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
	 * |                                 | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          | s       | 0, 1, ..., 59                     |       |
	 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
	 * |                                 | ss      | 00, 01, ..., 59                   |       |
	 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
	 * |                                 | SS      | 00, 01, ..., 99                   |       |
	 * |                                 | SSS     | 000, 0001, ..., 999               |       |
	 * |                                 | SSSS    | ...                               | 3     |
	 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
	 * |                                 | XX      | -0800, +0530, Z                   |       |
	 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
	 * |                                 | xx      | -0800, +0530, +0000               |       |
	 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
	 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
	 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
	 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
	 * | Seconds timestamp               | t       | 512969520                         | 7     |
	 * |                                 | tt      | ...                               | 3,7   |
	 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
	 * |                                 | TT      | ...                               | 3,7   |
	 * | Long localized date             | P       | 05/29/1453                        | 7     |
	 * |                                 | PP      | May 29, 1453                      | 7     |
	 * |                                 | PPP     | May 29th, 1453                    | 7     |
	 * |                                 | PPPP    | Sunday, May 29th, 1453            | 2,7   |
	 * | Long localized time             | p       | 12:00 AM                          | 7     |
	 * |                                 | pp      | 12:00:00 AM                       | 7     |
	 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
	 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
	 * | Combination of date and time    | Pp      | 05/29/1453, 12:00 AM              | 7     |
	 * |                                 | PPpp    | May 29, 1453, 12:00:00 AM         | 7     |
	 * |                                 | PPPppp  | May 29th, 1453 at ...             | 7     |
	 * |                                 | PPPPpppp| Sunday, May 29th, 1453 at ...     | 2,7   |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
	 *    the output will be the same as default pattern for this unit, usually
	 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
	 *    are marked with "2" in the last column of the table.
	 *
	 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
	 *
	 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
	 *    The output will be padded with zeros to match the length of the pattern.
	 *
	 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
	 *
	 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 5. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` always returns the last two digits of a year,
	 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
	 *
	 *    | Year | `yy` | `uu` |
	 *    |------|------|------|
	 *    | 1    |   01 |   01 |
	 *    | 14   |   14 |   14 |
	 *    | 376  |   76 |  376 |
	 *    | 1453 |   53 | 1453 |
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
	 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
	 *
	 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
	 *    so right now these tokens fall back to GMT timezones.
	 *
	 * 7. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `t`: seconds timestamp
	 *    - `T`: milliseconds timestamp
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The second argument is now required for the sake of explicitness.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   format(new Date(2016, 0, 1))
	 *
	 *   // v2.0.0 onward
	 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
	 *   ```
	 *
	 * - New format string API for `format` function
	 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
	 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
	 *
	 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {String} format - the string of tokens
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://git.io/fxCyr
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://git.io/fxCyr
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.locale` must contain `localize` property
	 * @throws {RangeError} `options.locale` must contain `formatLong` property
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Represent 11 February 2014 in middle-endian format:
	 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
	 * //=> '02/11/2014'
	 *
	 * @example
	 * // Represent 2 July 2014 in Esperanto:
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
	 *   locale: eoLocale
	 * })
	 * //=> '2-a de julio 2014'
	 *
	 * @example
	 * // Escape string by single quote characters:
	 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
	 * //=> "3 o'clock"
	 */
	
	function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var formatStr = String(dirtyFormatStr);
	  var options = dirtyOptions || {};
	  var locale = options.locale || _index2.default;
	  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index9.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index9.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	
	  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index9.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index9.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  if (!locale.localize) {
	    throw new RangeError('locale must contain localize property');
	  }
	
	  if (!locale.formatLong) {
	    throw new RangeError('locale must contain formatLong property');
	  }
	
	  var originalDate = (0, _index4.default)(dirtyDate);
	
	  if (!(0, _index.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
	
	
	  var timezoneOffset = (0, _index7.default)(originalDate);
	  var utcDate = (0, _index3.default)(originalDate, timezoneOffset);
	  var formatterOptions = {
	    firstWeekContainsDate: firstWeekContainsDate,
	    weekStartsOn: weekStartsOn,
	    locale: locale,
	    _originalDate: originalDate
	  };
	  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
	    var firstCharacter = substring[0];
	
	    if (firstCharacter === 'p' || firstCharacter === 'P') {
	      var longFormatter = _index6.default[firstCharacter];
	      return longFormatter(substring, locale.formatLong, formatterOptions);
	    }
	
	    return substring;
	  }).join('').match(formattingTokensRegExp).map(function (substring) {
	    // Replace two single quote characters with one single quote character
	    if (substring === "''") {
	      return "'";
	    }
	
	    var firstCharacter = substring[0];
	
	    if (firstCharacter === "'") {
	      return cleanEscapedString(substring);
	    }
	
	    var formatter = _index5.default[firstCharacter];
	
	    if (formatter) {
	      if (!options.useAdditionalWeekYearTokens && (0, _index8.isProtectedWeekYearToken)(substring)) {
	        (0, _index8.throwProtectedError)(substring);
	      }
	
	      if (!options.useAdditionalDayOfYearTokens && (0, _index8.isProtectedDayOfYearToken)(substring)) {
	        (0, _index8.throwProtectedError)(substring);
	      }
	
	      return formatter(utcDate, substring, locale.localize, formatterOptions);
	    }
	
	    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	    }
	
	    return substring;
	  }).join('');
	  return result;
	}
	
	function cleanEscapedString(input) {
	  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
	}
	
	module.exports = exports.default;

/***/ },
/* 1687 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDate;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDate
	 * @category Day Helpers
	 * @summary Get the day of the month of the given date.
	 *
	 * @description
	 * Get the day of the month of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the day of month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the month is 29 February 2012?
	 * var result = getDate(new Date(2012, 1, 29))
	 * //=> 29
	 */
	function getDate(dirtyDate) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var dayOfMonth = date.getDate();
	  return dayOfMonth;
	}
	
	module.exports = exports.default;

/***/ },
/* 1688 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDay;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDay
	 * @category Weekday Helpers
	 * @summary Get the day of the week of the given date.
	 *
	 * @description
	 * Get the day of the week of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the day of week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the week is 29 February 2012?
	 * var result = getDay(new Date(2012, 1, 29))
	 * //=> 3
	 */
	function getDay(dirtyDate) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  return day;
	}
	
	module.exports = exports.default;

/***/ },
/* 1689 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getHours;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getHours
	 * @category Hour Helpers
	 * @summary Get the hours of the given date.
	 *
	 * @description
	 * Get the hours of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the hours
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the hours of 29 February 2012 11:45:00:
	 * var result = getHours(new Date(2012, 1, 29, 11, 45))
	 * //=> 11
	 */
	function getHours(dirtyDate) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var hours = date.getHours();
	  return hours;
	}
	
	module.exports = exports.default;

/***/ },
/* 1690 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getMinutes
	 * @category Minute Helpers
	 * @summary Get the minutes of the given date.
	 *
	 * @description
	 * Get the minutes of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the minutes
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the minutes of 29 February 2012 11:45:05:
	 * var result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
	 * //=> 45
	 */
	function getMinutes(dirtyDate) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var minutes = date.getMinutes();
	  return minutes;
	}
	
	module.exports = exports.default;

/***/ },
/* 1691 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getMonth
	 * @category Month Helpers
	 * @summary Get the month of the given date.
	 *
	 * @description
	 * Get the month of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which month is 29 February 2012?
	 * var result = getMonth(new Date(2012, 1, 29))
	 * //=> 1
	 */
	function getMonth(dirtyDate) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var month = date.getMonth();
	  return month;
	}
	
	module.exports = exports.default;

/***/ },
/* 1692 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getQuarter
	 * @category Quarter Helpers
	 * @summary Get the year quarter of the given date.
	 *
	 * @description
	 * Get the year quarter of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which quarter is 2 July 2014?
	 * var result = getQuarter(new Date(2014, 6, 2))
	 * //=> 3
	 */
	function getQuarter(dirtyDate) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var quarter = Math.floor(date.getMonth() / 3) + 1;
	  return quarter;
	}
	
	module.exports = exports.default;

/***/ },
/* 1693 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getSeconds
	 * @category Second Helpers
	 * @summary Get the seconds of the given date.
	 *
	 * @description
	 * Get the seconds of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the seconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the seconds of 29 February 2012 11:45:05.123:
	 * var result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 5
	 */
	function getSeconds(dirtyDate) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var seconds = date.getSeconds();
	  return seconds;
	}
	
	module.exports = exports.default;

/***/ },
/* 1694 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTime;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getTime
	 * @category Timestamp Helpers
	 * @summary Get the milliseconds timestamp of the given date.
	 *
	 * @description
	 * Get the milliseconds timestamp of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the timestamp
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the timestamp of 29 February 2012 11:45:05.123:
	 * var result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 1330515905123
	 */
	function getTime(dirtyDate) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var timestamp = date.getTime();
	  return timestamp;
	}
	
	module.exports = exports.default;

/***/ },
/* 1695 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getYear;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getYear
	 * @category Year Helpers
	 * @summary Get the year of the given date.
	 *
	 * @description
	 * Get the year of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which year is 2 July 2014?
	 * var result = getYear(new Date(2014, 6, 2))
	 * //=> 2014
	 */
	function getYear(dirtyDate) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  return year;
	}
	
	module.exports = exports.default;

/***/ },
/* 1696 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAfter;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isAfter
	 * @category Common Helpers
	 * @summary Is the first date after the second one?
	 *
	 * @description
	 * Is the first date after the second one?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date that should be after the other one to return true
	 * @param {Date|Number} dateToCompare - the date to compare with
	 * @returns {Boolean} the first date is after the second date
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Is 10 July 1989 after 11 February 1987?
	 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> true
	 */
	function isAfter(dirtyDate, dirtyDateToCompare) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  return date.getTime() > dateToCompare.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 1697 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBefore;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isBefore
	 * @category Common Helpers
	 * @summary Is the first date before the second one?
	 *
	 * @description
	 * Is the first date before the second one?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date that should be before the other one to return true
	 * @param {Date|Number} dateToCompare - the date to compare with
	 * @returns {Boolean} the first date is before the second date
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Is 10 July 1989 before 11 February 1987?
	 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> false
	 */
	function isBefore(dirtyDate, dirtyDateToCompare) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  return date.getTime() < dateToCompare.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 1698 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDate;
	
	/**
	 * @name isDate
	 * @category Common Helpers
	 * @summary Is the given value a date?
	 *
	 * @description
	 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {*} value - the value to check
	 * @returns {boolean} true if the given value is a date
	 * @throws {TypeError} 1 arguments required
	 *
	 * @example
	 * // For a valid date:
	 * var result = isDate(new Date())
	 * //=> true
	 *
	 * @example
	 * // For an invalid date:
	 * var result = isDate(new Date(NaN))
	 * //=> true
	 *
	 * @example
	 * // For some value:
	 * var result = isDate('2014-02-31')
	 * //=> false
	 *
	 * @example
	 * // For an object:
	 * var result = isDate({})
	 * //=> false
	 */
	function isDate(value) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
	}
	
	module.exports = exports.default;

/***/ },
/* 1699 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEqual;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isEqual
	 * @category Common Helpers
	 * @summary Are the given dates equal?
	 *
	 * @description
	 * Are the given dates equal?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to compare
	 * @param {Date|Number} dateRight - the second date to compare
	 * @returns {Boolean} the dates are equal
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
	 * var result = isEqual(
	 *   new Date(2014, 6, 2, 6, 30, 45, 0),
	 *   new Date(2014, 6, 2, 6, 30, 45, 500)
	 * )
	 * //=> false
	 */
	function isEqual(dirtyLeftDate, dirtyRightDate) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var dateLeft = (0, _index.default)(dirtyLeftDate);
	  var dateRight = (0, _index.default)(dirtyRightDate);
	  return dateLeft.getTime() === dateRight.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 1700 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameDay;
	
	var _index = _interopRequireDefault(__webpack_require__(484));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameDay
	 * @category Day Helpers
	 * @summary Are the given dates in the same day?
	 *
	 * @description
	 * Are the given dates in the same day?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same day
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
	 * var result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
	 * //=> true
	 */
	function isSameDay(dirtyDateLeft, dirtyDateRight) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var dateLeftStartOfDay = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfDay = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 1701 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameMonth
	 * @category Month Helpers
	 * @summary Are the given dates in the same month?
	 *
	 * @description
	 * Are the given dates in the same month?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same month
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2014 in the same month?
	 * var result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
	 * //=> true
	 */
	function isSameMonth(dirtyDateLeft, dirtyDateRight) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
	}
	
	module.exports = exports.default;

/***/ },
/* 1702 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(825));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameQuarter
	 * @category Quarter Helpers
	 * @summary Are the given dates in the same year quarter?
	 *
	 * @description
	 * Are the given dates in the same year quarter?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same quarter
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
	 * var result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
	 * //=> true
	 */
	function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var dateLeftStartOfQuarter = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfQuarter = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 1703 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameYear;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameYear
	 * @category Year Helpers
	 * @summary Are the given dates in the same year?
	 *
	 * @description
	 * Are the given dates in the same year?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same year
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2014 in the same year?
	 * var result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
	 * //=> true
	 */
	function isSameYear(dirtyDateLeft, dirtyDateRight) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() === dateRight.getFullYear();
	}
	
	module.exports = exports.default;

/***/ },
/* 1704 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWithinInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isWithinInterval
	 * @category Interval Helpers
	 * @summary Is the given date within the interval?
	 *
	 * @description
	 * Is the given date within the interval?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `isWithinRange` to `isWithinInterval`.
	 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
	 *
	 *   ```
	 *   2.1.3
	 *   time interval
	 *   part of the time axis limited by two instants
	 *   ```
	 *
	 *   Also, this function now accepts an object with `start` and `end` properties
	 *   instead of two arguments as an interval.
	 *   This function now throws `RangeError` if the start of the interval is after its end
	 *   or if any date in the interval is `Invalid Date`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   isWithinRange(
	 *     new Date(2014, 0, 3),
	 *     new Date(2014, 0, 1), new Date(2014, 0, 7)
	 *   )
	 *
	 *   // v2.0.0 onward
	 *
	 *   isWithinInterval(
	 *     new Date(2014, 0, 3),
	 *     { start: new Date(2014, 0, 1), end: new Date(2014, 0, 7) }
	 *   )
	 *   ```
	 *
	 * @param {Date|Number} date - the date to check
	 * @param {Interval} interval - the interval to check
	 * @returns {Boolean} the date is within the interval
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // For the date within the interval:
	 * isWithinInterval(new Date(2014, 0, 3), {
	 *   start: new Date(2014, 0, 1),
	 *   end: new Date(2014, 0, 7)
	 * })
	 * //=> true
	 *
	 * @example
	 * // For the date outside of the interval:
	 * isWithinInterval(new Date(2014, 0, 10), {
	 *   start: new Date(2014, 0, 1),
	 *   end: new Date(2014, 0, 7)
	 * })
	 * //=> false
	 */
	function isWithinInterval(dirtyDate, dirtyInterval) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var interval = dirtyInterval || {};
	  var time = (0, _index.default)(dirtyDate).getTime();
	  var startTime = (0, _index.default)(interval.start).getTime();
	  var endTime = (0, _index.default)(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startTime <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  return time >= startTime && time <= endTime;
	}
	
	module.exports = exports.default;

/***/ },
/* 1705 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildFormatLongFn;
	
	function buildFormatLongFn(args) {
	  return function (dirtyOptions) {
	    var options = dirtyOptions || {};
	    var width = options.width ? String(options.width) : args.defaultWidth;
	    var format = args.formats[width] || args.formats[args.defaultWidth];
	    return format;
	  };
	}
	
	module.exports = exports.default;

/***/ },
/* 1706 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildLocalizeFn;
	
	function buildLocalizeFn(args) {
	  return function (dirtyIndex, dirtyOptions) {
	    var options = dirtyOptions || {};
	    var context = options.context ? String(options.context) : 'standalone';
	    var valuesArray;
	
	    if (context === 'formatting' && args.formattingValues) {
	      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
	      var width = options.width ? String(options.width) : defaultWidth;
	      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
	    } else {
	      var _defaultWidth = args.defaultWidth;
	
	      var _width = options.width ? String(options.width) : args.defaultWidth;
	
	      valuesArray = args.values[_width] || args.values[_defaultWidth];
	    }
	
	    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
	    return valuesArray[index];
	  };
	}
	
	module.exports = exports.default;

/***/ },
/* 1707 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildMatchFn;
	
	function buildMatchFn(args) {
	  return function (dirtyString, dirtyOptions) {
	    var string = String(dirtyString);
	    var options = dirtyOptions || {};
	    var width = options.width;
	    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
	    var matchResult = string.match(matchPattern);
	
	    if (!matchResult) {
	      return null;
	    }
	
	    var matchedString = matchResult[0];
	    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
	    var value;
	
	    if (Object.prototype.toString.call(parsePatterns) === '[object Array]') {
	      value = findIndex(parsePatterns, function (pattern) {
	        return pattern.test(string);
	      });
	    } else {
	      value = findKey(parsePatterns, function (pattern) {
	        return pattern.test(string);
	      });
	    }
	
	    value = args.valueCallback ? args.valueCallback(value) : value;
	    value = options.valueCallback ? options.valueCallback(value) : value;
	    return {
	      value: value,
	      rest: string.slice(matchedString.length)
	    };
	  };
	}
	
	function findKey(object, predicate) {
	  for (var key in object) {
	    if (object.hasOwnProperty(key) && predicate(object[key])) {
	      return key;
	    }
	  }
	}
	
	function findIndex(array, predicate) {
	  for (var key = 0; key < array.length; key++) {
	    if (predicate(array[key])) {
	      return key;
	    }
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 1708 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildMatchPatternFn;
	
	function buildMatchPatternFn(args) {
	  return function (dirtyString, dirtyOptions) {
	    var string = String(dirtyString);
	    var options = dirtyOptions || {};
	    var matchResult = string.match(args.matchPattern);
	
	    if (!matchResult) {
	      return null;
	    }
	
	    var matchedString = matchResult[0];
	    var parseResult = string.match(args.parsePattern);
	
	    if (!parseResult) {
	      return null;
	    }
	
	    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
	    value = options.valueCallback ? options.valueCallback(value) : value;
	    return {
	      value: value,
	      rest: string.slice(matchedString.length)
	    };
	  };
	}
	
	module.exports = exports.default;

/***/ },
/* 1709 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'less than a second',
	    other: 'less than {{count}} seconds'
	  },
	  xSeconds: {
	    one: '1 second',
	    other: '{{count}} seconds'
	  },
	  halfAMinute: 'half a minute',
	  lessThanXMinutes: {
	    one: 'less than a minute',
	    other: 'less than {{count}} minutes'
	  },
	  xMinutes: {
	    one: '1 minute',
	    other: '{{count}} minutes'
	  },
	  aboutXHours: {
	    one: 'about 1 hour',
	    other: 'about {{count}} hours'
	  },
	  xHours: {
	    one: '1 hour',
	    other: '{{count}} hours'
	  },
	  xDays: {
	    one: '1 day',
	    other: '{{count}} days'
	  },
	  aboutXMonths: {
	    one: 'about 1 month',
	    other: 'about {{count}} months'
	  },
	  xMonths: {
	    one: '1 month',
	    other: '{{count}} months'
	  },
	  aboutXYears: {
	    one: 'about 1 year',
	    other: 'about {{count}} years'
	  },
	  xYears: {
	    one: '1 year',
	    other: '{{count}} years'
	  },
	  overXYears: {
	    one: 'over 1 year',
	    other: 'over {{count}} years'
	  },
	  almostXYears: {
	    one: 'almost 1 year',
	    other: 'almost {{count}} years'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'in ' + result;
	    } else {
	      return result + ' ago';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1710 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1705));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, MMMM do, y',
	  long: 'MMMM do, y',
	  medium: 'MMM d, y',
	  short: 'MM/dd/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'at' {{time}}",
	  long: "{{date}} 'at' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1711 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'last' eeee 'at' p",
	  yesterday: "'yesterday at' p",
	  today: "'today at' p",
	  tomorrow: "'tomorrow at' p",
	  nextWeek: "eeee 'at' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1712 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1706));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['B', 'A'],
	  abbreviated: ['BC', 'AD'],
	  wide: ['Before Christ', 'Anno Domini']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter'] // Note: in English, the names of days of the week and months are capitalized.
	  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
	  // Generally, formatted dates should look like they are in the middle of a sentence,
	  // e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
	};
	var dayValues = {
	  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
	  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mi',
	    noon: 'n',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mi',
	    noon: 'n',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   var options = dirtyOptions || {}
	  //   var unit = String(options.unit)
	  //
	  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'
	
	  var rem100 = number % 100;
	
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	        return number + 'st';
	
	      case 2:
	        return number + 'nd';
	
	      case 3:
	        return number + 'rd';
	    }
	  }
	
	  return number + 'th';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1713 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1708));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1707));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(b|a)/i,
	  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
	  wide: /^(before christ|before common era|anno domini|common era)/i
	};
	var parseEraPatterns = {
	  any: [/^b/i, /^(a|c)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234](th|st|nd|rd)? quarter/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
	  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smtwf]/i,
	  short: /^(su|mo|tu|we|th|fr|sa)/i,
	  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
	  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
	  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
	  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mi/i,
	    noon: /^no/i,
	    morning: /morning/i,
	    afternoon: /afternoon/i,
	    evening: /evening/i,
	    night: /night/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1714 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = max;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name max
	 * @category Common Helpers
	 * @summary Return the latest of the given dates.
	 *
	 * @description
	 * Return the latest of the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - `max` function now accepts an array of dates rather than spread arguments.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   var date1 = new Date(1989, 6, 10)
	 *   var date2 = new Date(1987, 1, 11)
	 *   var maxDate = max(date1, date2)
	 *
	 *   // v2.0.0 onward:
	 *   var dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
	 *   var maxDate = max(dates)
	 *   ```
	 *
	 * @param {Date[]|Number[]} datesArray - the dates to compare
	 * @returns {Date} the latest of the dates
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which of these dates is the latest?
	 * var result = max([
	 *   new Date(1989, 6, 10),
	 *   new Date(1987, 1, 11),
	 *   new Date(1995, 6, 2),
	 *   new Date(1990, 0, 1)
	 * ])
	 * //=> Sun Jul 02 1995 00:00:00
	 */
	function max(dirtyDatesArray) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	
	  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
	  } else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  } else {
	    // `dirtyDatesArray` is non-iterable, return Invalid Date
	    return new Date(NaN);
	  }
	
	  var result;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index.default)(dirtyDate);
	
	    if (result === undefined || result < currentDate || isNaN(currentDate)) {
	      result = currentDate;
	    }
	  });
	  return result || new Date(NaN);
	}
	
	module.exports = exports.default;

/***/ },
/* 1715 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = min;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name min
	 * @category Common Helpers
	 * @summary Return the earliest of the given dates.
	 *
	 * @description
	 * Return the earliest of the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - `min` function now accepts an array of dates rather than spread arguments.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   var date1 = new Date(1989, 6, 10)
	 *   var date2 = new Date(1987, 1, 11)
	 *   var minDate = min(date1, date2)
	 *
	 *   // v2.0.0 onward:
	 *   var dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
	 *   var minDate = min(dates)
	 *   ```
	 *
	 * @param {Date[]|Number[]} datesArray - the dates to compare
	 * @returns {Date} the earliest of the dates
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which of these dates is the earliest?
	 * var result = min([
	 *   new Date(1989, 6, 10),
	 *   new Date(1987, 1, 11),
	 *   new Date(1995, 6, 2),
	 *   new Date(1990, 0, 1)
	 * ])
	 * //=> Wed Feb 11 1987 00:00:00
	 */
	function min(dirtyDatesArray) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	
	  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
	  } else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  } else {
	    // `dirtyDatesArray` is non-iterable, return Invalid Date
	    return new Date(NaN);
	  }
	
	  var result;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index.default)(dirtyDate);
	
	    if (result === undefined || result > currentDate || isNaN(currentDate)) {
	      result = currentDate;
	    }
	  });
	  return result || new Date(NaN);
	}
	
	module.exports = exports.default;

/***/ },
/* 1716 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(480));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1673));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1674));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1675));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1676));
	
	var _index6 = _interopRequireDefault(__webpack_require__(300));
	
	var _index7 = _interopRequireDefault(__webpack_require__(301));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_HOUR = 3600000;
	var MILLISECONDS_IN_MINUTE = 60000;
	var MILLISECONDS_IN_SECOND = 1000;
	var numericPatterns = {
	  month: /^(1[0-2]|0?\d)/,
	  // 0 to 12
	  date: /^(3[0-1]|[0-2]?\d)/,
	  // 0 to 31
	  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
	  // 0 to 366
	  week: /^(5[0-3]|[0-4]?\d)/,
	  // 0 to 53
	  hour23h: /^(2[0-3]|[0-1]?\d)/,
	  // 0 to 23
	  hour24h: /^(2[0-4]|[0-1]?\d)/,
	  // 0 to 24
	  hour11h: /^(1[0-1]|0?\d)/,
	  // 0 to 11
	  hour12h: /^(1[0-2]|0?\d)/,
	  // 0 to 12
	  minute: /^[0-5]?\d/,
	  // 0 to 59
	  second: /^[0-5]?\d/,
	  // 0 to 59
	  singleDigit: /^\d/,
	  // 0 to 9
	  twoDigits: /^\d{1,2}/,
	  // 0 to 99
	  threeDigits: /^\d{1,3}/,
	  // 0 to 999
	  fourDigits: /^\d{1,4}/,
	  // 0 to 9999
	  anyDigitsSigned: /^-?\d+/,
	  singleDigitSigned: /^-?\d/,
	  // 0 to 9, -0 to -9
	  twoDigitsSigned: /^-?\d{1,2}/,
	  // 0 to 99, -0 to -99
	  threeDigitsSigned: /^-?\d{1,3}/,
	  // 0 to 999, -0 to -999
	  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
	
	};
	var timezonePatterns = {
	  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
	  basic: /^([+-])(\d{2})(\d{2})|Z/,
	  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
	  extended: /^([+-])(\d{2}):(\d{2})|Z/,
	  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
	};
	
	function parseNumericPattern(pattern, string, valueCallback) {
	  var matchResult = string.match(pattern);
	
	  if (!matchResult) {
	    return null;
	  }
	
	  var value = parseInt(matchResult[0], 10);
	  return {
	    value: valueCallback ? valueCallback(value) : value,
	    rest: string.slice(matchResult[0].length)
	  };
	}
	
	function parseTimezonePattern(pattern, string) {
	  var matchResult = string.match(pattern);
	
	  if (!matchResult) {
	    return null;
	  } // Input is 'Z'
	
	
	  if (matchResult[0] === 'Z') {
	    return {
	      value: 0,
	      rest: string.slice(1)
	    };
	  }
	
	  var sign = matchResult[1] === '+' ? 1 : -1;
	  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
	  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
	  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
	  return {
	    value: sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * MILLISECONDS_IN_SECOND),
	    rest: string.slice(matchResult[0].length)
	  };
	}
	
	function parseAnyDigitsSigned(string, valueCallback) {
	  return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback);
	}
	
	function parseNDigits(n, string, valueCallback) {
	  switch (n) {
	    case 1:
	      return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback);
	
	    case 2:
	      return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback);
	
	    case 3:
	      return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback);
	
	    case 4:
	      return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback);
	
	    default:
	      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
	  }
	}
	
	function parseNDigitsSigned(n, string, valueCallback) {
	  switch (n) {
	    case 1:
	      return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback);
	
	    case 2:
	      return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback);
	
	    case 3:
	      return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback);
	
	    case 4:
	      return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback);
	
	    default:
	      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
	  }
	}
	
	function dayPeriodEnumToHours(enumValue) {
	  switch (enumValue) {
	    case 'morning':
	      return 4;
	
	    case 'evening':
	      return 17;
	
	    case 'pm':
	    case 'noon':
	    case 'afternoon':
	      return 12;
	
	    case 'am':
	    case 'midnight':
	    case 'night':
	    default:
	      return 0;
	  }
	}
	
	function normalizeTwoDigitYear(twoDigitYear, currentYear) {
	  var isCommonEra = currentYear > 0; // Absolute number of the current year:
	  // 1 -> 1 AC
	  // 0 -> 1 BC
	  // -1 -> 2 BC
	
	  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
	  var result;
	
	  if (absCurrentYear <= 50) {
	    result = twoDigitYear || 100;
	  } else {
	    var rangeEnd = absCurrentYear + 50;
	    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
	    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
	    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
	  }
	
	  return isCommonEra ? result : 1 - result;
	}
	
	var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // User for validation
	
	function isLeapYearIndex(year) {
	  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
	}
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
	 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
	 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
	 * |  d  | Day of month                   |  D  | Day of year                    |
	 * |  e  | Local day of week              |  E  | Day of week                    |
	 * |  f  |                                |  F* | Day of week in month           |
	 * |  g* | Modified Julian day            |  G  | Era                            |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  i! | ISO day of week                |  I! | ISO week of year               |
	 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
	 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
	 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  n  |                                |  N  |                                |
	 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
	 * |  p  |                                |  P  |                                |
	 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
	 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
	 * |  u  | Extended year                  |  U* | Cyclic year                    |
	 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
	 * |  w  | Local week of year             |  W* | Week of month                  |
	 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
	 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
	 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 *
	 * Letters marked by ! are non-standard, but implemented by date-fns:
	 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
	 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
	 *   i.e. 7 for Sunday, 1 for Monday, etc.
	 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
	 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
	 *   `R` is supposed to be used in conjunction with `I` and `i`
	 *   for universal ISO week-numbering date, whereas
	 *   `Y` is supposed to be used in conjunction with `w` and `e`
	 *   for week-numbering date specific to the locale.
	 */
	
	
	var parsers = {
	  // Era
	  G: {
	    priority: 140,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        // AD, BC
	        case 'G':
	        case 'GG':
	        case 'GGG':
	          return match.era(string, {
	            width: 'abbreviated'
	          }) || match.era(string, {
	            width: 'narrow'
	          });
	        // A, B
	
	        case 'GGGGG':
	          return match.era(string, {
	            width: 'narrow'
	          });
	        // Anno Domini, Before Christ
	
	        case 'GGGG':
	        default:
	          return match.era(string, {
	            width: 'wide'
	          }) || match.era(string, {
	            width: 'abbreviated'
	          }) || match.era(string, {
	            width: 'narrow'
	          });
	      }
	    },
	    set: function (date, flags, value, _options) {
	      flags.era = value;
	      date.setUTCFullYear(value, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['R', 'u', 't', 'T']
	  },
	  // Year
	  y: {
	    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
	    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
	    // |----------|-------|----|-------|-------|-------|
	    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
	    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
	    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
	    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
	    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
	    priority: 130,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (year) {
	        return {
	          year: year,
	          isTwoDigitYear: token === 'yy'
	        };
	      };
	
	      switch (token) {
	        case 'y':
	          return parseNDigits(4, string, valueCallback);
	
	        case 'yo':
	          return match.ordinalNumber(string, {
	            unit: 'year',
	            valueCallback: valueCallback
	          });
	
	        default:
	          return parseNDigits(token.length, string, valueCallback);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value.isTwoDigitYear || value.year > 0;
	    },
	    set: function (date, flags, value, _options) {
	      var currentYear = date.getUTCFullYear();
	
	      if (value.isTwoDigitYear) {
	        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
	        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
	        date.setUTCHours(0, 0, 0, 0);
	        return date;
	      }
	
	      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
	      date.setUTCFullYear(year, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']
	  },
	  // Local week-numbering year
	  Y: {
	    priority: 130,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (year) {
	        return {
	          year: year,
	          isTwoDigitYear: token === 'YY'
	        };
	      };
	
	      switch (token) {
	        case 'Y':
	          return parseNDigits(4, string, valueCallback);
	
	        case 'Yo':
	          return match.ordinalNumber(string, {
	            unit: 'year',
	            valueCallback: valueCallback
	          });
	
	        default:
	          return parseNDigits(token.length, string, valueCallback);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value.isTwoDigitYear || value.year > 0;
	    },
	    set: function (date, flags, value, options) {
	      var currentYear = (0, _index.default)(date, options);
	
	      if (value.isTwoDigitYear) {
	        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
	        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
	        date.setUTCHours(0, 0, 0, 0);
	        return (0, _index7.default)(date, options);
	      }
	
	      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
	      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
	      date.setUTCHours(0, 0, 0, 0);
	      return (0, _index7.default)(date, options);
	    },
	    incompatibleTokens: ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
	  },
	  // ISO week-numbering year
	  R: {
	    priority: 130,
	    parse: function (string, token, _match, _options) {
	      if (token === 'R') {
	        return parseNDigitsSigned(4, string);
	      }
	
	      return parseNDigitsSigned(token.length, string);
	    },
	    set: function (_date, _flags, value, _options) {
	      var firstWeekOfYear = new Date(0);
	      firstWeekOfYear.setUTCFullYear(value, 0, 4);
	      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
	      return (0, _index6.default)(firstWeekOfYear);
	    },
	    incompatibleTokens: ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
	  },
	  // Extended year
	  u: {
	    priority: 130,
	    parse: function (string, token, _match, _options) {
	      if (token === 'u') {
	        return parseNDigitsSigned(4, string);
	      }
	
	      return parseNDigitsSigned(token.length, string);
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCFullYear(value, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']
	  },
	  // Quarter
	  Q: {
	    priority: 120,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        // 1, 2, 3, 4
	        case 'Q':
	        case 'QQ':
	          // 01, 02, 03, 04
	          return parseNDigits(token.length, string);
	        // 1st, 2nd, 3rd, 4th
	
	        case 'Qo':
	          return match.ordinalNumber(string, {
	            unit: 'quarter'
	          });
	        // Q1, Q2, Q3, Q4
	
	        case 'QQQ':
	          return match.quarter(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.quarter(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	
	        case 'QQQQQ':
	          return match.quarter(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // 1st quarter, 2nd quarter, ...
	
	        case 'QQQQ':
	        default:
	          return match.quarter(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.quarter(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.quarter(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 4;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth((value - 1) * 3, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Stand-alone quarter
	  q: {
	    priority: 120,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        // 1, 2, 3, 4
	        case 'q':
	        case 'qq':
	          // 01, 02, 03, 04
	          return parseNDigits(token.length, string);
	        // 1st, 2nd, 3rd, 4th
	
	        case 'qo':
	          return match.ordinalNumber(string, {
	            unit: 'quarter'
	          });
	        // Q1, Q2, Q3, Q4
	
	        case 'qqq':
	          return match.quarter(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.quarter(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	
	        case 'qqqqq':
	          return match.quarter(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // 1st quarter, 2nd quarter, ...
	
	        case 'qqqq':
	        default:
	          return match.quarter(string, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.quarter(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.quarter(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 4;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth((value - 1) * 3, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Month
	  M: {
	    priority: 110,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (value) {
	        return value - 1;
	      };
	
	      switch (token) {
	        // 1, 2, ..., 12
	        case 'M':
	          return parseNumericPattern(numericPatterns.month, string, valueCallback);
	        // 01, 02, ..., 12
	
	        case 'MM':
	          return parseNDigits(2, string, valueCallback);
	        // 1st, 2nd, ..., 12th
	
	        case 'Mo':
	          return match.ordinalNumber(string, {
	            unit: 'month',
	            valueCallback: valueCallback
	          });
	        // Jan, Feb, ..., Dec
	
	        case 'MMM':
	          return match.month(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.month(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // J, F, ..., D
	
	        case 'MMMMM':
	          return match.month(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // January, February, ..., December
	
	        case 'MMMM':
	        default:
	          return match.month(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.month(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.month(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 11;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth(value, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Stand-alone month
	  L: {
	    priority: 110,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (value) {
	        return value - 1;
	      };
	
	      switch (token) {
	        // 1, 2, ..., 12
	        case 'L':
	          return parseNumericPattern(numericPatterns.month, string, valueCallback);
	        // 01, 02, ..., 12
	
	        case 'LL':
	          return parseNDigits(2, string, valueCallback);
	        // 1st, 2nd, ..., 12th
	
	        case 'Lo':
	          return match.ordinalNumber(string, {
	            unit: 'month',
	            valueCallback: valueCallback
	          });
	        // Jan, Feb, ..., Dec
	
	        case 'LLL':
	          return match.month(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.month(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // J, F, ..., D
	
	        case 'LLLLL':
	          return match.month(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // January, February, ..., December
	
	        case 'LLLL':
	        default:
	          return match.month(string, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.month(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.month(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 11;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth(value, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Local week of year
	  w: {
	    priority: 100,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'w':
	          return parseNumericPattern(numericPatterns.week, string);
	
	        case 'wo':
	          return match.ordinalNumber(string, {
	            unit: 'week'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 53;
	    },
	    set: function (date, _flags, value, options) {
	      return (0, _index7.default)((0, _index5.default)(date, value, options), options);
	    },
	    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
	  },
	  // ISO week of year
	  I: {
	    priority: 100,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'I':
	          return parseNumericPattern(numericPatterns.week, string);
	
	        case 'Io':
	          return match.ordinalNumber(string, {
	            unit: 'week'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 53;
	    },
	    set: function (date, _flags, value, options) {
	      return (0, _index6.default)((0, _index4.default)(date, value, options), options);
	    },
	    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
	  },
	  // Day of the month
	  d: {
	    priority: 90,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'd':
	          return parseNumericPattern(numericPatterns.date, string);
	
	        case 'do':
	          return match.ordinalNumber(string, {
	            unit: 'date'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (date, value, _options) {
	      var year = date.getUTCFullYear();
	      var isLeapYear = isLeapYearIndex(year);
	      var month = date.getUTCMonth();
	
	      if (isLeapYear) {
	        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
	      } else {
	        return value >= 1 && value <= DAYS_IN_MONTH[month];
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCDate(value);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Day of year
	  D: {
	    priority: 90,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'D':
	        case 'DD':
	          return parseNumericPattern(numericPatterns.dayOfYear, string);
	
	        case 'Do':
	          return match.ordinalNumber(string, {
	            unit: 'date'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (date, value, _options) {
	      var year = date.getUTCFullYear();
	      var isLeapYear = isLeapYearIndex(year);
	
	      if (isLeapYear) {
	        return value >= 1 && value <= 366;
	      } else {
	        return value >= 1 && value <= 365;
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth(0, value);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']
	  },
	  // Day of week
	  E: {
	    priority: 90,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        // Tue
	        case 'E':
	        case 'EE':
	        case 'EEE':
	          return match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // T
	
	        case 'EEEEE':
	          return match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tu
	
	        case 'EEEEEE':
	          return match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tuesday
	
	        case 'EEEE':
	        default:
	          return match.day(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 6;
	    },
	    set: function (date, _flags, value, options) {
	      date = (0, _index2.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Local day of week
	  e: {
	    priority: 90,
	    parse: function (string, token, match, options) {
	      var valueCallback = function (value) {
	        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
	        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
	      };
	
	      switch (token) {
	        // 3
	        case 'e':
	        case 'ee':
	          // 03
	          return parseNDigits(token.length, string, valueCallback);
	        // 3rd
	
	        case 'eo':
	          return match.ordinalNumber(string, {
	            unit: 'day',
	            valueCallback: valueCallback
	          });
	        // Tue
	
	        case 'eee':
	          return match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // T
	
	        case 'eeeee':
	          return match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tu
	
	        case 'eeeeee':
	          return match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tuesday
	
	        case 'eeee':
	        default:
	          return match.day(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 6;
	    },
	    set: function (date, _flags, value, options) {
	      date = (0, _index2.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']
	  },
	  // Stand-alone local day of week
	  c: {
	    priority: 90,
	    parse: function (string, token, match, options) {
	      var valueCallback = function (value) {
	        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
	        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
	      };
	
	      switch (token) {
	        // 3
	        case 'c':
	        case 'cc':
	          // 03
	          return parseNDigits(token.length, string, valueCallback);
	        // 3rd
	
	        case 'co':
	          return match.ordinalNumber(string, {
	            unit: 'day',
	            valueCallback: valueCallback
	          });
	        // Tue
	
	        case 'ccc':
	          return match.day(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // T
	
	        case 'ccccc':
	          return match.day(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // Tu
	
	        case 'cccccc':
	          return match.day(string, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // Tuesday
	
	        case 'cccc':
	        default:
	          return match.day(string, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 6;
	    },
	    set: function (date, _flags, value, options) {
	      date = (0, _index2.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']
	  },
	  // ISO day of week
	  i: {
	    priority: 90,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (value) {
	        if (value === 0) {
	          return 7;
	        }
	
	        return value;
	      };
	
	      switch (token) {
	        // 2
	        case 'i':
	        case 'ii':
	          // 02
	          return parseNDigits(token.length, string);
	        // 2nd
	
	        case 'io':
	          return match.ordinalNumber(string, {
	            unit: 'day'
	          });
	        // Tue
	
	        case 'iii':
	          return match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting',
	            valueCallback: valueCallback
	          });
	        // T
	
	        case 'iiiii':
	          return match.day(string, {
	            width: 'narrow',
	            context: 'formatting',
	            valueCallback: valueCallback
	          });
	        // Tu
	
	        case 'iiiiii':
	          return match.day(string, {
	            width: 'short',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting',
	            valueCallback: valueCallback
	          });
	        // Tuesday
	
	        case 'iiii':
	        default:
	          return match.day(string, {
	            width: 'wide',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting',
	            valueCallback: valueCallback
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 7;
	    },
	    set: function (date, _flags, value, options) {
	      date = (0, _index3.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']
	  },
	  // AM or PM
	  a: {
	    priority: 80,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'a':
	        case 'aa':
	        case 'aaa':
	          return match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'aaaaa':
	          return match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'aaaa':
	        default:
	          return match.dayPeriod(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['b', 'B', 'H', 'K', 'k', 't', 'T']
	  },
	  // AM, PM, midnight
	  b: {
	    priority: 80,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'b':
	        case 'bb':
	        case 'bbb':
	          return match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'bbbbb':
	          return match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'bbbb':
	        default:
	          return match.dayPeriod(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['a', 'B', 'H', 'K', 'k', 't', 'T']
	  },
	  // in the morning, in the afternoon, in the evening, at night
	  B: {
	    priority: 80,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'B':
	        case 'BB':
	        case 'BBB':
	          return match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'BBBBB':
	          return match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'BBBB':
	        default:
	          return match.dayPeriod(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['a', 'b', 't', 'T']
	  },
	  // Hour [1-12]
	  h: {
	    priority: 70,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'h':
	          return parseNumericPattern(numericPatterns.hour12h, string);
	
	        case 'ho':
	          return match.ordinalNumber(string, {
	            unit: 'hour'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 12;
	    },
	    set: function (date, _flags, value, _options) {
	      var isPM = date.getUTCHours() >= 12;
	
	      if (isPM && value < 12) {
	        date.setUTCHours(value + 12, 0, 0, 0);
	      } else if (!isPM && value === 12) {
	        date.setUTCHours(0, 0, 0, 0);
	      } else {
	        date.setUTCHours(value, 0, 0, 0);
	      }
	
	      return date;
	    },
	    incompatibleTokens: ['H', 'K', 'k', 't', 'T']
	  },
	  // Hour [0-23]
	  H: {
	    priority: 70,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'H':
	          return parseNumericPattern(numericPatterns.hour23h, string);
	
	        case 'Ho':
	          return match.ordinalNumber(string, {
	            unit: 'hour'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 23;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCHours(value, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['a', 'b', 'h', 'K', 'k', 't', 'T']
	  },
	  // Hour [0-11]
	  K: {
	    priority: 70,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'K':
	          return parseNumericPattern(numericPatterns.hour11h, string);
	
	        case 'Ko':
	          return match.ordinalNumber(string, {
	            unit: 'hour'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 11;
	    },
	    set: function (date, _flags, value, _options) {
	      var isPM = date.getUTCHours() >= 12;
	
	      if (isPM && value < 12) {
	        date.setUTCHours(value + 12, 0, 0, 0);
	      } else {
	        date.setUTCHours(value, 0, 0, 0);
	      }
	
	      return date;
	    },
	    incompatibleTokens: ['a', 'b', 'h', 'H', 'k', 't', 'T']
	  },
	  // Hour [1-24]
	  k: {
	    priority: 70,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'k':
	          return parseNumericPattern(numericPatterns.hour24h, string);
	
	        case 'ko':
	          return match.ordinalNumber(string, {
	            unit: 'hour'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 24;
	    },
	    set: function (date, _flags, value, _options) {
	      var hours = value <= 24 ? value % 24 : value;
	      date.setUTCHours(hours, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['a', 'b', 'h', 'H', 'K', 't', 'T']
	  },
	  // Minute
	  m: {
	    priority: 60,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'm':
	          return parseNumericPattern(numericPatterns.minute, string);
	
	        case 'mo':
	          return match.ordinalNumber(string, {
	            unit: 'minute'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 59;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMinutes(value, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['t', 'T']
	  },
	  // Second
	  s: {
	    priority: 50,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 's':
	          return parseNumericPattern(numericPatterns.second, string);
	
	        case 'so':
	          return match.ordinalNumber(string, {
	            unit: 'second'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 59;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCSeconds(value, 0);
	      return date;
	    },
	    incompatibleTokens: ['t', 'T']
	  },
	  // Fraction of second
	  S: {
	    priority: 30,
	    parse: function (string, token, _match, _options) {
	      var valueCallback = function (value) {
	        return Math.floor(value * Math.pow(10, -token.length + 3));
	      };
	
	      return parseNDigits(token.length, string, valueCallback);
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMilliseconds(value);
	      return date;
	    },
	    incompatibleTokens: ['t', 'T']
	  },
	  // Timezone (ISO-8601. +00:00 is `'Z'`)
	  X: {
	    priority: 10,
	    parse: function (string, token, _match, _options) {
	      switch (token) {
	        case 'X':
	          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);
	
	        case 'XX':
	          return parseTimezonePattern(timezonePatterns.basic, string);
	
	        case 'XXXX':
	          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);
	
	        case 'XXXXX':
	          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);
	
	        case 'XXX':
	        default:
	          return parseTimezonePattern(timezonePatterns.extended, string);
	      }
	    },
	    set: function (date, flags, value, _options) {
	      if (flags.timestampIsSet) {
	        return date;
	      }
	
	      return new Date(date.getTime() - value);
	    },
	    incompatibleTokens: ['t', 'T', 'x']
	  },
	  // Timezone (ISO-8601)
	  x: {
	    priority: 10,
	    parse: function (string, token, _match, _options) {
	      switch (token) {
	        case 'x':
	          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);
	
	        case 'xx':
	          return parseTimezonePattern(timezonePatterns.basic, string);
	
	        case 'xxxx':
	          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);
	
	        case 'xxxxx':
	          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);
	
	        case 'xxx':
	        default:
	          return parseTimezonePattern(timezonePatterns.extended, string);
	      }
	    },
	    set: function (date, flags, value, _options) {
	      if (flags.timestampIsSet) {
	        return date;
	      }
	
	      return new Date(date.getTime() - value);
	    },
	    incompatibleTokens: ['t', 'T', 'X']
	  },
	  // Seconds timestamp
	  t: {
	    priority: 40,
	    parse: function (string, _token, _match, _options) {
	      return parseAnyDigitsSigned(string);
	    },
	    set: function (_date, _flags, value, _options) {
	      return [new Date(value * 1000), {
	        timestampIsSet: true
	      }];
	    },
	    incompatibleTokens: '*'
	  },
	  // Milliseconds timestamp
	  T: {
	    priority: 20,
	    parse: function (string, _token, _match, _options) {
	      return parseAnyDigitsSigned(string);
	    },
	    set: function (_date, _flags, value, _options) {
	      return [new Date(value), {
	        timestampIsSet: true
	      }];
	    },
	    incompatibleTokens: '*'
	  }
	};
	var _default = parsers;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1717 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parse;
	
	var _index = _interopRequireDefault(__webpack_require__(823));
	
	var _index2 = _interopRequireDefault(__webpack_require__(827));
	
	var _index3 = _interopRequireDefault(__webpack_require__(19));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1669));
	
	var _index5 = _interopRequireDefault(__webpack_require__(812));
	
	var _index6 = _interopRequireDefault(__webpack_require__(225));
	
	var _index7 = __webpack_require__(816);
	
	var _index8 = _interopRequireDefault(__webpack_require__(26));
	
	var _index9 = _interopRequireDefault(__webpack_require__(1716));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
	// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
	//   (one of the certain letters followed by `o`)
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	
	var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
	// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
	
	var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var notWhitespaceRegExp = /\S/;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
	/**
	 * @name parse
	 * @category Common Helpers
	 * @summary Parse the date.
	 *
	 * @description
	 * Return the date parsed from string using the given format string.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://git.io/fxCyr
	 *
	 * The characters in the format string wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 *
	 * Format of the format string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 5 below the table).
	 *
	 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
	 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
	 *
	 * ```javascript
	 * parse('23 AM', 'HH a', new Date())
	 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
	 * ```
	 *
	 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
	 *
	 * Accepted format string patterns:
	 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
	 * |---------------------------------|-----|---------|-----------------------------------|-------|
	 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
	 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 |     | GGGGG   | A, B                              |       |
	 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
	 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
	 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
	 * |                                 |     | yyyyy   | ...                               | 2,4   |
	 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
	 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
	 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
	 * |                                 |     | YYYYY   | ...                               | 2,4   |
	 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
	 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
	 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
	 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
	 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
	 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
	 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
	 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
	 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
	 * |                                 |     | uuuuu   | ...                               | 2,4   |
	 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
	 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
	 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
	 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
	 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
	 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
	 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
	 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
	 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
	 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
	 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
	 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
	 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
	 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
	 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 |     | DDDD    | ...                               | 2     |
	 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
	 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
	 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
	 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
	 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
	 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
	 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
	 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 5     |
	 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
	 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
	 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
	 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
	 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
	 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 |     | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
	 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
	 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
	 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
	 * |                                 |     | KK      | 1, 2, ..., 11, 0                  |       |
	 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
	 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
	 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
	 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
	 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
	 * |                                 |     | tt      | ...                               | 2     |
	 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
	 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
	 * |                                 |     | SSS     | 000, 0001, ..., 999               |       |
	 * |                                 |     | SSSS    | ...                               | 2     |
	 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
	 * |                                 |     | TT      | ...                               | 2     |
	 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
	 * |                                 |     | XX      | -0800, +0530, Z                   |       |
	 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
	 * |                                 |     | xx      | -0800, +0530, +0000               |       |
	 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
	 * |                                 |     | PP      | May 29, 1453                      |       |
	 * |                                 |     | PPP     | May 29th, 1453                    |       |
	 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
	 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
	 * |                                 |     | pp      | 12:00:00 AM                       |       |
	 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
	 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
	 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
	 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular.
	 *    In `format` function, they will produce different result:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 *    `parse` will try to match both formatting and stand-alone units interchangably.
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table:
	 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
	 *      as wide as the sequence
	 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
	 *      These variations are marked with "2" in the last column of the table.
	 *
	 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 4. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` will try to guess the century of two digit year by proximity with `backupDate`:
	 *
	 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
	 *
	 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
	 *
	 *    while `uu` will just assign the year as is:
	 *
	 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
	 *
	 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
	 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
	 *
	 * 5. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
	 *    on the given locale.
	 *
	 *    using `en-US` locale: `P` => `MM/dd/yyyy`
	 *    using `en-US` locale: `p` => `hh:mm a`
	 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
	 *    using `pt-BR` locale: `p` => `HH:mm`
	 *
	 * Values will be assigned to the date in the descending order of its unit's priority.
	 * Units of an equal priority overwrite each other in the order of appearance.
	 *
	 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
	 * the values will be taken from 3rd argument `backupDate` which works as a context of parsing.
	 *
	 * `backupDate` must be passed for correct work of the function.
	 * If you're not sure which `backupDate` to supply, create a new instance of Date:
	 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
	 * In this case parsing will be done in the context of the current date.
	 * If `backupDate` is `Invalid Date` or a value not convertible to valid `Date`,
	 * then `Invalid Date` will be returned.
	 *
	 * The result may vary by locale.
	 *
	 * If `formatString` matches with `dateString` but does not provides tokens, `backupDate` will be returned.
	 *
	 * If parsing failed, `Invalid Date` will be returned.
	 * Invalid Date is a Date, whose time value is NaN.
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - Old `parse` was renamed to `toDate`.
	 *   Now `parse` is a new function which parses a string using a provided format.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   parse('2016-01-01')
	 *
	 *   // v2.0.0 onward
	 *   toDate('2016-01-01')
	 *   parse('2016-01-01', 'yyyy-MM-dd', new Date())
	 *   ```
	 *
	 * @param {String} dateString - the string to parse
	 * @param {String} formatString - the string of tokens
	 * @param {Date|Number} backupDate - defines values missing from the parsed dateString
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://git.io/fxCyr
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://git.io/fxCyr
	 * @returns {Date} the parsed date
	 * @throws {TypeError} 3 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} `options.locale` must contain `match` property
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Parse 11 February 2014 from middle-endian format:
	 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
	 * //=> Tue Feb 11 2014 00:00:00
	 *
	 * @example
	 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
	 * import eo from 'date-fns/locale/eo'
	 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
	 *   locale: eo
	 * })
	 * //=> Sun Feb 28 2010 00:00:00
	 */
	
	function parse(dirtyDateString, dirtyFormatString, dirtyBackupDate, dirtyOptions) {
	  if (arguments.length < 3) {
	    throw new TypeError('3 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var dateString = String(dirtyDateString);
	  var formatString = String(dirtyFormatString);
	  var options = dirtyOptions || {};
	  var locale = options.locale || _index.default;
	
	  if (!locale.match) {
	    throw new RangeError('locale must contain match property');
	  }
	
	  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index8.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index8.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	
	  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index8.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index8.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  if (formatString === '') {
	    if (dateString === '') {
	      return (0, _index3.default)(dirtyBackupDate);
	    } else {
	      return new Date(NaN);
	    }
	  }
	
	  var subFnOptions = {
	    firstWeekContainsDate: firstWeekContainsDate,
	    weekStartsOn: weekStartsOn,
	    locale: locale // If timezone isn't specified, it will be set to the system timezone
	
	  };
	  var setters = [{
	    priority: TIMEZONE_UNIT_PRIORITY,
	    set: dateToSystemTimezone,
	    index: 0
	  }];
	  var i;
	  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
	    var firstCharacter = substring[0];
	
	    if (firstCharacter === 'p' || firstCharacter === 'P') {
	      var longFormatter = _index5.default[firstCharacter];
	      return longFormatter(substring, locale.formatLong, subFnOptions);
	    }
	
	    return substring;
	  }).join('').match(formattingTokensRegExp);
	  var usedTokens = [];
	
	  for (i = 0; i < tokens.length; i++) {
	    var token = tokens[i];
	
	    if (!options.useAdditionalWeekYearTokens && (0, _index7.isProtectedWeekYearToken)(token)) {
	      (0, _index7.throwProtectedError)(token);
	    }
	
	    if (!options.useAdditionalDayOfYearTokens && (0, _index7.isProtectedDayOfYearToken)(token)) {
	      (0, _index7.throwProtectedError)(token);
	    }
	
	    var firstCharacter = token[0];
	    var parser = _index9.default[firstCharacter];
	
	    if (parser) {
	      var incompatibleTokens = parser.incompatibleTokens;
	
	      if (Array.isArray(incompatibleTokens)) {
	        var incompatibleToken = void 0;
	
	        for (var _i = 0; _i < usedTokens.length; _i++) {
	          var usedToken = usedTokens[_i].token;
	
	          if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
	            incompatibleToken = usedTokens[_i];
	            break;
	          }
	        }
	
	        if (incompatibleToken) {
	          throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
	        }
	      } else if (parser.incompatibleTokens === '*' && usedTokens.length) {
	        throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
	      }
	
	      usedTokens.push({
	        token: firstCharacter,
	        fullToken: token
	      });
	      var parseResult = parser.parse(dateString, token, locale.match, subFnOptions);
	
	      if (!parseResult) {
	        return new Date(NaN);
	      }
	
	      setters.push({
	        priority: parser.priority,
	        set: parser.set,
	        validate: parser.validate,
	        value: parseResult.value,
	        index: setters.length
	      });
	      dateString = parseResult.rest;
	    } else {
	      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	        throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	      } // Replace two single quote characters with one single quote character
	
	
	      if (token === "''") {
	        token = "'";
	      } else if (firstCharacter === "'") {
	        token = cleanEscapedString(token);
	      } // Cut token from string, or, if string doesn't match the token, return Invalid Date
	
	
	      if (dateString.indexOf(token) === 0) {
	        dateString = dateString.slice(token.length);
	      } else {
	        return new Date(NaN);
	      }
	    }
	  } // Check if the remaining input contains something other than whitespace
	
	
	  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
	    return new Date(NaN);
	  }
	
	  var uniquePrioritySetters = setters.map(function (setter) {
	    return setter.priority;
	  }).sort(function (a, b) {
	    return b - a;
	  }).filter(function (priority, index, array) {
	    return array.indexOf(priority) === index;
	  }).map(function (priority) {
	    return setters.filter(function (setter) {
	      return setter.priority === priority;
	    }).reverse();
	  }).map(function (setterArray) {
	    return setterArray[0];
	  });
	  var date = (0, _index3.default)(dirtyBackupDate);
	
	  if (isNaN(date)) {
	    return new Date(NaN);
	  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37
	
	
	  var utcDate = (0, _index2.default)(date, (0, _index6.default)(date));
	  var flags = {};
	
	  for (i = 0; i < uniquePrioritySetters.length; i++) {
	    var setter = uniquePrioritySetters[i];
	
	    if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) {
	      return new Date(NaN);
	    }
	
	    var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)
	
	    if (result[0]) {
	      utcDate = result[0];
	      (0, _index4.default)(flags, result[1]); // Result is date
	    } else {
	      utcDate = result;
	    }
	  }
	
	  return utcDate;
	}
	
	function dateToSystemTimezone(date, flags) {
	  if (flags.timestampIsSet) {
	    return date;
	  }
	
	  var convertedDate = new Date(0);
	  convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
	  convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
	  return convertedDate;
	}
	
	function cleanEscapedString(input) {
	  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
	}
	
	module.exports = exports.default;

/***/ },
/* 1718 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parseISO;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(225));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_HOUR = 3600000;
	var MILLISECONDS_IN_MINUTE = 60000;
	var DEFAULT_ADDITIONAL_DIGITS = 2;
	var patterns = {
	  dateTimeDelimiter: /[T ]/,
	  timeZoneDelimiter: /[Z ]/i,
	  timezone: /([Z+-].*)$/
	};
	var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
	var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
	var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
	/**
	 * @name parseISO
	 * @category Common Helpers
	 * @summary Parse ISO string
	 *
	 * @description
	 * Parse the given string in ISO 8601 format and return an instance of Date.
	 *
	 * Function accepts complete ISO 8601 formats as well as partial implementations.
	 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
	 *
	 * If the argument isn't a string, the function cannot parse the string or
	 * the values are invalid, it returns Invalid Date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The previous `parse` implementation was renamed to `parseISO`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   parse('2016-01-01')
	 *
	 *   // v2.0.0 onward
	 *   parseISO('2016-01-01')
	 *   ```
	 *
	 * - `parseISO` now validates separate date and time values in ISO-8601 strings
	 *   and returns `Invalid Date` if the date is invalid.
	 *
	 *   ```javascript
	 *   parseISO('2018-13-32')
	 *   //=> Invalid Date
	 *   ```
	 *
	 * - `parseISO` now doesn't fall back to `new Date` constructor
	 *   if it fails to parse a string argument. Instead, it returns `Invalid Date`.
	 *
	 * @param {String} argument - the value to convert
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Convert string '2014-02-11T11:30:30' to date:
	 * var result = parseISO('2014-02-11T11:30:30')
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert string '+02014101' to date,
	 * // if the additional number of digits in the extended year format is 1:
	 * var result = parseISO('+02014101', { additionalDigits: 1 })
	 * //=> Fri Apr 11 2014 00:00:00
	 */
	
	function parseISO(argument, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var options = dirtyOptions || {};
	  var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : (0, _index.default)(options.additionalDigits);
	
	  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
	    throw new RangeError('additionalDigits must be 0, 1 or 2');
	  }
	
	  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
	    return new Date(NaN);
	  }
	
	  var dateStrings = splitDateString(argument);
	  var date;
	
	  if (dateStrings.date) {
	    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
	    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
	  }
	
	  if (isNaN(date) || !date) {
	    return new Date(NaN);
	  }
	
	  var timestamp = date.getTime();
	  var time = 0;
	  var offset;
	
	  if (dateStrings.time) {
	    time = parseTime(dateStrings.time);
	
	    if (isNaN(time) || time === null) {
	      return new Date(NaN);
	    }
	  }
	
	  if (dateStrings.timezone) {
	    offset = parseTimezone(dateStrings.timezone);
	
	    if (isNaN(offset)) {
	      return new Date(NaN);
	    }
	  } else {
	    var fullTime = timestamp + time;
	    var fullTimeDate = new Date(fullTime);
	    offset = (0, _index2.default)(fullTimeDate); // Adjust time when it's coming from DST
	
	    var fullTimeDateDiffDay = new Date(fullTime);
	
	    if (offset > 0) {
	      fullTimeDateDiffDay.setDate(fullTimeDate.getDate() + 1);
	    } else {
	      fullTimeDateDiffDay.setDate(fullTimeDate.getDate() - 1);
	    }
	
	    var offsetDiff = (0, _index2.default)(fullTimeDateDiffDay) - offset;
	
	    if (offsetDiff > 0) {
	      offset += offsetDiff;
	    }
	  }
	
	  return new Date(timestamp + time + offset);
	}
	
	function splitDateString(dateString) {
	  var dateStrings = {};
	  var array = dateString.split(patterns.dateTimeDelimiter);
	  var timeString;
	
	  if (/:/.test(array[0])) {
	    dateStrings.date = null;
	    timeString = array[0];
	  } else {
	    dateStrings.date = array[0];
	    timeString = array[1];
	
	    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
	      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
	      timeString = dateString.substr(dateStrings.date.length, dateString.length);
	    }
	  }
	
	  if (timeString) {
	    var token = patterns.timezone.exec(timeString);
	
	    if (token) {
	      dateStrings.time = timeString.replace(token[1], '');
	      dateStrings.timezone = token[1];
	    } else {
	      dateStrings.time = timeString;
	    }
	  }
	
	  return dateStrings;
	}
	
	function parseYear(dateString, additionalDigits) {
	  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
	  var captures = dateString.match(regex); // Invalid ISO-formatted year
	
	  if (!captures) return {
	    year: null
	  };
	  var year = captures[1] && parseInt(captures[1]);
	  var century = captures[2] && parseInt(captures[2]);
	  return {
	    year: century == null ? year : century * 100,
	    restDateString: dateString.slice((captures[1] || captures[2]).length)
	  };
	}
	
	function parseDate(dateString, year) {
	  // Invalid ISO-formatted year
	  if (year === null) return null;
	  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string
	
	  if (!captures) return null;
	  var isWeekDate = !!captures[4];
	  var dayOfYear = parseDateUnit(captures[1]);
	  var month = parseDateUnit(captures[2]) - 1;
	  var day = parseDateUnit(captures[3]);
	  var week = parseDateUnit(captures[4]);
	  var dayOfWeek = parseDateUnit(captures[5]) - 1;
	
	  if (isWeekDate) {
	    if (!validateWeekDate(year, week, dayOfWeek)) {
	      return new Date(NaN);
	    }
	
	    return dayOfISOWeekYear(year, week, dayOfWeek);
	  } else {
	    var date = new Date(0);
	
	    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
	      return new Date(NaN);
	    }
	
	    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
	    return date;
	  }
	}
	
	function parseDateUnit(value) {
	  return value ? parseInt(value) : 1;
	}
	
	function parseTime(timeString) {
	  var captures = timeString.match(timeRegex);
	  if (!captures) return null; // Invalid ISO-formatted time
	
	  var hours = parseTimeUnit(captures[1]);
	  var minutes = parseTimeUnit(captures[2]);
	  var seconds = parseTimeUnit(captures[3]);
	
	  if (!validateTime(hours, minutes, seconds)) {
	    return NaN;
	  }
	
	  return hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
	}
	
	function parseTimeUnit(value) {
	  return value && parseFloat(value.replace(',', '.')) || 0;
	}
	
	function parseTimezone(timezoneString) {
	  if (timezoneString === 'Z') return 0;
	  var captures = timezoneString.match(timezoneRegex);
	  if (!captures) return 0;
	  var sign = captures[1] === '+' ? -1 : 1;
	  var hours = parseInt(captures[2]);
	  var minutes = captures[3] && parseInt(captures[3]) || 0;
	
	  if (!validateTimezone(hours, minutes)) {
	    return NaN;
	  }
	
	  return sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE);
	}
	
	function dayOfISOWeekYear(isoWeekYear, week, day) {
	  var date = new Date(0);
	  date.setUTCFullYear(isoWeekYear, 0, 4);
	  var fourthOfJanuaryDay = date.getUTCDay() || 7;
	  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	} // Validation functions
	// February is null to handle the leap year (using ||)
	
	
	var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	
	function isLeapYearIndex(year) {
	  return year % 400 === 0 || year % 4 === 0 && year % 100;
	}
	
	function validateDate(year, month, date) {
	  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
	}
	
	function validateDayOfYearDate(year, dayOfYear) {
	  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
	}
	
	function validateWeekDate(_year, week, day) {
	  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
	}
	
	function validateTime(hours, minutes, seconds) {
	  if (hours === 24) {
	    return minutes === 0 && seconds === 0;
	  }
	
	  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
	}
	
	function validateTimezone(_hours, minutes) {
	  return minutes >= 0 && minutes <= 59;
	}
	
	module.exports = exports.default;

/***/ },
/* 1719 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setHours;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setHours
	 * @category Hour Helpers
	 * @summary Set the hours to the given date.
	 *
	 * @description
	 * Set the hours to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} hours - the hours of the new date
	 * @returns {Date} the new date with the hours set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 4 hours to 1 September 2014 11:30:00:
	 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
	 * //=> Mon Sep 01 2014 04:30:00
	 */
	function setHours(dirtyDate, dirtyHours) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate);
	  var hours = (0, _index.default)(dirtyHours);
	  date.setHours(hours);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1720 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setMinutes
	 * @category Minute Helpers
	 * @summary Set the minutes to the given date.
	 *
	 * @description
	 * Set the minutes to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} minutes - the minutes of the new date
	 * @returns {Date} the new date with the minutes set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 45 minutes to 1 September 2014 11:30:40:
	 * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
	 * //=> Mon Sep 01 2014 11:45:40
	 */
	function setMinutes(dirtyDate, dirtyMinutes) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate);
	  var minutes = (0, _index.default)(dirtyMinutes);
	  date.setMinutes(minutes);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1721 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(19));
	
	var _index3 = _interopRequireDefault(__webpack_require__(824));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setQuarter
	 * @category Quarter Helpers
	 * @summary Set the year quarter to the given date.
	 *
	 * @description
	 * Set the year quarter to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} quarter - the quarter of the new date
	 * @returns {Date} the new date with the quarter set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 2nd quarter to 2 July 2014:
	 * var result = setQuarter(new Date(2014, 6, 2), 2)
	 * //=> Wed Apr 02 2014 00:00:00
	 */
	function setQuarter(dirtyDate, dirtyQuarter) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate);
	  var quarter = (0, _index.default)(dirtyQuarter);
	  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
	  var diff = quarter - oldQuarter;
	  return (0, _index3.default)(date, date.getMonth() + diff * 3);
	}
	
	module.exports = exports.default;

/***/ },
/* 1722 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setSeconds
	 * @category Second Helpers
	 * @summary Set the seconds to the given date.
	 *
	 * @description
	 * Set the seconds to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} seconds - the seconds of the new date
	 * @returns {Date} the new date with the seconds set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 45 seconds to 1 September 2014 11:30:40:
	 * var result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
	 * //=> Mon Sep 01 2014 11:30:45
	 */
	function setSeconds(dirtyDate, dirtySeconds) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate);
	  var seconds = (0, _index.default)(dirtySeconds);
	  date.setSeconds(seconds);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1723 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setYear;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setYear
	 * @category Year Helpers
	 * @summary Set the year to the given date.
	 *
	 * @description
	 * Set the year to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} year - the year of the new date
	 * @returns {Date} the new date with the year set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set year 2013 to 1 September 2014:
	 * var result = setYear(new Date(2014, 8, 1), 2013)
	 * //=> Sun Sep 01 2013 00:00:00
	 */
	function setYear(dirtyDate, dirtyYear) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index2.default)(dirtyDate);
	  var year = (0, _index.default)(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
	
	  if (isNaN(date)) {
	    return new Date(NaN);
	  }
	
	  date.setFullYear(year);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1724 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfMonth
	 * @category Month Helpers
	 * @summary Return the start of a month for the given date.
	 *
	 * @description
	 * Return the start of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a month for 2 September 2014 11:55:00:
	 * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfMonth(dirtyDate) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1725 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfYear
	 * @category Year Helpers
	 * @summary Return the start of a year for the given date.
	 *
	 * @description
	 * Return the start of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a year for 2 September 2014 11:55:00:
	 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Jan 01 2014 00:00:00
	 */
	function startOfYear(dirtyDate) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var cleanDate = (0, _index.default)(dirtyDate);
	  var date = new Date(0);
	  date.setFullYear(cleanDate.getFullYear(), 0, 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1726 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subDays;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(481));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subDays
	 * @category Day Helpers
	 * @summary Subtract the specified number of days from the given date.
	 *
	 * @description
	 * Subtract the specified number of days from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be subtracted
	 * @returns {Date} the new date with the days subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 10 days from 1 September 2014:
	 * var result = subDays(new Date(2014, 8, 1), 10)
	 * //=> Fri Aug 22 2014 00:00:00
	 */
	function subDays(dirtyDate, dirtyAmount) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 1727 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subHours;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(817));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subHours
	 * @category Hour Helpers
	 * @summary Subtract the specified number of hours from the given date.
	 *
	 * @description
	 * Subtract the specified number of hours from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of hours to be subtracted
	 * @returns {Date} the new date with the hours subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 2 hours from 11 July 2014 01:00:00:
	 * var result = subHours(new Date(2014, 6, 11, 1, 0), 2)
	 * //=> Thu Jul 10 2014 23:00:00
	 */
	function subHours(dirtyDate, dirtyAmount) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 1728 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(818));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subMinutes
	 * @category Minute Helpers
	 * @summary Subtract the specified number of minutes from the given date.
	 *
	 * @description
	 * Subtract the specified number of minutes from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be subtracted
	 * @returns {Date} the new date with the minutes subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 30 minutes from 10 July 2014 12:00:00:
	 * var result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 11:30:00
	 */
	function subMinutes(dirtyDate, dirtyAmount) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 1729 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(483));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subMonths
	 * @category Month Helpers
	 * @summary Subtract the specified number of months from the given date.
	 *
	 * @description
	 * Subtract the specified number of months from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be subtracted
	 * @returns {Date} the new date with the months subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 months from 1 February 2015:
	 * var result = subMonths(new Date(2015, 1, 1), 5)
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function subMonths(dirtyDate, dirtyAmount) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 1730 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(819));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subWeeks
	 * @category Week Helpers
	 * @summary Subtract the specified number of weeks from the given date.
	 *
	 * @description
	 * Subtract the specified number of weeks from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of weeks to be subtracted
	 * @returns {Date} the new date with the weeks subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 4 weeks from 1 September 2014:
	 * var result = subWeeks(new Date(2014, 8, 1), 4)
	 * //=> Mon Aug 04 2014 00:00:00
	 */
	function subWeeks(dirtyDate, dirtyAmount) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 1731 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subYears;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(820));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subYears
	 * @category Year Helpers
	 * @summary Subtract the specified number of years from the given date.
	 *
	 * @description
	 * Subtract the specified number of years from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be subtracted
	 * @returns {Date} the new date with the years subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 years from 1 September 2014:
	 * var result = subYears(new Date(2014, 8, 1), 5)
	 * //=> Tue Sep 01 2009 00:00:00
	 */
	function subYears(dirtyDate, dirtyAmount) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }
	
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 1732 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(35);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(829));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ },
/* 1733 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(35);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _addClass = _interopRequireDefault(__webpack_require__(1732));
	
	exports.addClass = _addClass.default;
	
	var _removeClass = _interopRequireDefault(__webpack_require__(1734));
	
	exports.removeClass = _removeClass.default;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(829));
	
	exports.hasClass = _hasClass.default;
	var _default = {
	  addClass: _addClass.default,
	  removeClass: _removeClass.default,
	  hasClass: _hasClass.default
	};
	exports.default = _default;

/***/ },
/* 1734 */
/***/ function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ },
/* 1735 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(35);
	
	exports.__esModule = true;
	exports.default = filterEvents;
	
	var _contains = _interopRequireDefault(__webpack_require__(188));
	
	var _querySelectorAll = _interopRequireDefault(__webpack_require__(1740));
	
	function filterEvents(selector, handler) {
	  return function filterHandler(e) {
	    var top = e.currentTarget,
	        target = e.target,
	        matches = (0, _querySelectorAll.default)(top, selector);
	    if (matches.some(function (match) {
	      return (0, _contains.default)(match, target);
	    })) handler.call(this, e);
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 1736 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(35);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _on = _interopRequireDefault(__webpack_require__(486));
	
	exports.on = _on.default;
	
	var _off = _interopRequireDefault(__webpack_require__(485));
	
	exports.off = _off.default;
	
	var _filter = _interopRequireDefault(__webpack_require__(1735));
	
	exports.filter = _filter.default;
	
	var _listen = _interopRequireDefault(__webpack_require__(1737));
	
	exports.listen = _listen.default;
	var _default = {
	  on: _on.default,
	  off: _off.default,
	  filter: _filter.default,
	  listen: _listen.default
	};
	exports.default = _default;

/***/ },
/* 1737 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(35);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(123));
	
	var _on = _interopRequireDefault(__webpack_require__(486));
	
	var _off = _interopRequireDefault(__webpack_require__(485));
	
	var listen = function listen() {};
	
	if (_inDOM.default) {
	  listen = function listen(node, eventName, handler, capture) {
	    (0, _on.default)(node, eventName, handler, capture);
	    return function () {
	      (0, _off.default)(node, eventName, handler, capture);
	    };
	  };
	}
	
	var _default = listen;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1738 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(35);
	
	exports.__esModule = true;
	exports.default = offsetParent;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(187));
	
	var _style = _interopRequireDefault(__webpack_require__(226));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function offsetParent(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      offsetParent = node && node.offsetParent;
	
	  while (offsetParent && nodeName(node) !== 'html' && (0, _style.default)(offsetParent, 'position') === 'static') {
	    offsetParent = offsetParent.offsetParent;
	  }
	
	  return offsetParent || doc.documentElement;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1739 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(35);
	
	exports.__esModule = true;
	exports.default = position;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(333));
	
	var _offset = _interopRequireDefault(__webpack_require__(830));
	
	var _offsetParent = _interopRequireDefault(__webpack_require__(1738));
	
	var _scrollTop = _interopRequireDefault(__webpack_require__(831));
	
	var _scrollLeft = _interopRequireDefault(__webpack_require__(1741));
	
	var _style = _interopRequireDefault(__webpack_require__(226));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function position(node, offsetParent) {
	  var parentOffset = {
	    top: 0,
	    left: 0
	  },
	      offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
	  // because it is its only offset parent
	
	  if ((0, _style.default)(node, 'position') === 'fixed') {
	    offset = node.getBoundingClientRect();
	  } else {
	    offsetParent = offsetParent || (0, _offsetParent.default)(node);
	    offset = (0, _offset.default)(node);
	    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
	    parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
	    parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
	  } // Subtract parent offsets and node margins
	
	
	  return (0, _extends2.default)({}, offset, {
	    top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
	    left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
	  });
	}
	
	module.exports = exports["default"];

/***/ },
/* 1740 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = qsa;
	// Zepto.js
	// (c) 2010-2015 Thomas Fuchs
	// Zepto.js may be freely distributed under the MIT license.
	var simpleSelectorRE = /^[\w-]*$/;
	var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
	
	function qsa(element, selector) {
	  var maybeID = selector[0] === '#',
	      maybeClass = selector[0] === '.',
	      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
	      isSimple = simpleSelectorRE.test(nameOnly),
	      found;
	
	  if (isSimple) {
	    if (maybeID) {
	      element = element.getElementById ? element : document;
	      return (found = element.getElementById(nameOnly)) ? [found] : [];
	    }
	
	    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
	    return toArray(element.getElementsByTagName(selector));
	  }
	
	  return toArray(element.querySelectorAll(selector));
	}
	
	module.exports = exports["default"];

/***/ },
/* 1741 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(35);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(302));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1742 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(35);
	
	exports.__esModule = true;
	exports.default = _getComputedStyle;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(832));
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
	    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	      prop = (0, _camelizeStyle.default)(prop);
	      if (prop == 'float') prop = 'styleFloat';
	      var current = node.currentStyle[prop] || null;
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out
	
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px'; // Revert the changed values
	
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 1743 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeStyle;
	
	function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	}
	
	module.exports = exports["default"];

/***/ },
/* 1744 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(35);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _properties = _interopRequireDefault(__webpack_require__(487));
	
	var _style = _interopRequireDefault(__webpack_require__(226));
	
	function onEnd(node, handler, duration) {
	  var fakeEvent = {
	    target: node,
	    currentTarget: node
	  },
	      backup;
	  if (!_properties.default.end) duration = 0;else if (duration == null) duration = parseDuration(node) || 0;
	
	  if (_properties.default.end) {
	    node.addEventListener(_properties.default.end, done, false);
	    backup = setTimeout(function () {
	      return done(fakeEvent);
	    }, (duration || 100) * 1.5);
	  } else setTimeout(done.bind(null, fakeEvent), 0);
	
	  function done(event) {
	    if (event.target !== event.currentTarget) return;
	    clearTimeout(backup);
	    event.target.removeEventListener(_properties.default.end, done);
	    handler.call(this);
	  }
	}
	
	onEnd._parseDuration = parseDuration;
	var _default = onEnd;
	exports.default = _default;
	
	function parseDuration(node) {
	  var str = (0, _style.default)(node, _properties.default.duration),
	      mult = str.indexOf('ms') === -1 ? 1000 : 1;
	  return parseFloat(str) * mult;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1745 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(35);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _end = _interopRequireDefault(__webpack_require__(1744));
	
	exports.end = _end.default;
	
	var _properties = _interopRequireDefault(__webpack_require__(487));
	
	exports.properties = _properties.default;
	var _default = {
	  end: _end.default,
	  properties: _properties.default
	};
	exports.default = _default;

/***/ },
/* 1746 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isTransform;
	var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
	
	function isTransform(property) {
	  return !!(property && supportedTransforms.test(property));
	}
	
	module.exports = exports["default"];

/***/ },
/* 1747 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = camelize;
	var rHyphen = /-(.)/g;
	
	function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	}
	
	module.exports = exports["default"];

/***/ },
/* 1748 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hyphenate;
	var rUpper = /([A-Z])/g;
	
	function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	}
	
	module.exports = exports["default"];

/***/ },
/* 1749 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(35);
	
	exports.__esModule = true;
	exports.default = hyphenateStyleName;
	
	var _hyphenate = _interopRequireDefault(__webpack_require__(1748));
	
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	var msPattern = /^ms-/;
	
	function hyphenateStyleName(string) {
	  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
	}
	
	module.exports = exports["default"];

/***/ },
/* 1750 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 1751 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(1750);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 1752 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 1753 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 1754 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(1753);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 1755 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 1756 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "89889688147bd7575d6327160d64e760.svg";

/***/ },
/* 1757 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e18bbf611f2a2e43afc071aa2f4e1512.ttf";

/***/ },
/* 1758 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bc7c4a59f924cf037aad6e1f9edba366.eot";

/***/ },
/* 1759 */
1758,
/* 1760 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "792dcd18baf5f544aabcad1883d673c2.svg";

/***/ },
/* 1761 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "eceddf474df95d8d4a7e316668c3be85.ttf";

/***/ },
/* 1762 */
/***/ function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 1763 */
/***/ function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 1764 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1765)();
	// imports
	
	
	// module
	exports.push([module.id, ".fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-fw{width:1.28571429em;text-align:center}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-pp:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before,.fa-resistance:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before,.fa-y-combinator-square:before,.fa-yc-square:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-bed:before,.fa-hotel:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-y-combinator:before,.fa-yc:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery-full:before,.fa-battery:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-paper-o:before,.fa-hand-stop-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-television:before,.fa-tv:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-gitlab:before{content:\"\\F296\"}.fa-wpbeginner:before{content:\"\\F297\"}.fa-wpforms:before{content:\"\\F298\"}.fa-envira:before{content:\"\\F299\"}.fa-universal-access:before{content:\"\\F29A\"}.fa-wheelchair-alt:before{content:\"\\F29B\"}.fa-question-circle-o:before{content:\"\\F29C\"}.fa-blind:before{content:\"\\F29D\"}.fa-audio-description:before{content:\"\\F29E\"}.fa-volume-control-phone:before{content:\"\\F2A0\"}.fa-braille:before{content:\"\\F2A1\"}.fa-assistive-listening-systems:before{content:\"\\F2A2\"}.fa-american-sign-language-interpreting:before,.fa-asl-interpreting:before{content:\"\\F2A3\"}.fa-deaf:before,.fa-deafness:before,.fa-hard-of-hearing:before{content:\"\\F2A4\"}.fa-glide:before{content:\"\\F2A5\"}.fa-glide-g:before{content:\"\\F2A6\"}.fa-sign-language:before,.fa-signing:before{content:\"\\F2A7\"}.fa-low-vision:before{content:\"\\F2A8\"}.fa-viadeo:before{content:\"\\F2A9\"}.fa-viadeo-square:before{content:\"\\F2AA\"}.fa-snapchat:before{content:\"\\F2AB\"}.fa-snapchat-ghost:before{content:\"\\F2AC\"}.fa-snapchat-square:before{content:\"\\F2AD\"}.fa-pied-piper:before{content:\"\\F2AE\"}.fa-first-order:before{content:\"\\F2B0\"}.fa-yoast:before{content:\"\\F2B1\"}.fa-themeisle:before{content:\"\\F2B2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\F2B3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\F2B4\"}.fa-handshake-o:before{content:\"\\F2B5\"}.fa-envelope-open:before{content:\"\\F2B6\"}.fa-envelope-open-o:before{content:\"\\F2B7\"}.fa-linode:before{content:\"\\F2B8\"}.fa-address-book:before{content:\"\\F2B9\"}.fa-address-book-o:before{content:\"\\F2BA\"}.fa-address-card:before,.fa-vcard:before{content:\"\\F2BB\"}.fa-address-card-o:before,.fa-vcard-o:before{content:\"\\F2BC\"}.fa-user-circle:before{content:\"\\F2BD\"}.fa-user-circle-o:before{content:\"\\F2BE\"}.fa-user-o:before{content:\"\\F2C0\"}.fa-id-badge:before{content:\"\\F2C1\"}.fa-drivers-license:before,.fa-id-card:before{content:\"\\F2C2\"}.fa-drivers-license-o:before,.fa-id-card-o:before{content:\"\\F2C3\"}.fa-quora:before{content:\"\\F2C4\"}.fa-free-code-camp:before{content:\"\\F2C5\"}.fa-telegram:before{content:\"\\F2C6\"}.fa-thermometer-4:before,.fa-thermometer-full:before,.fa-thermometer:before{content:\"\\F2C7\"}.fa-thermometer-3:before,.fa-thermometer-three-quarters:before{content:\"\\F2C8\"}.fa-thermometer-2:before,.fa-thermometer-half:before{content:\"\\F2C9\"}.fa-thermometer-1:before,.fa-thermometer-quarter:before{content:\"\\F2CA\"}.fa-thermometer-0:before,.fa-thermometer-empty:before{content:\"\\F2CB\"}.fa-shower:before{content:\"\\F2CC\"}.fa-bath:before,.fa-bathtub:before,.fa-s15:before{content:\"\\F2CD\"}.fa-podcast:before{content:\"\\F2CE\"}.fa-window-maximize:before{content:\"\\F2D0\"}.fa-window-minimize:before{content:\"\\F2D1\"}.fa-window-restore:before{content:\"\\F2D2\"}.fa-times-rectangle:before,.fa-window-close:before{content:\"\\F2D3\"}.fa-times-rectangle-o:before,.fa-window-close-o:before{content:\"\\F2D4\"}.fa-bandcamp:before{content:\"\\F2D5\"}.fa-grav:before{content:\"\\F2D6\"}.fa-etsy:before{content:\"\\F2D7\"}.fa-imdb:before{content:\"\\F2D8\"}.fa-ravelry:before{content:\"\\F2D9\"}.fa-eercast:before{content:\"\\F2DA\"}.fa-microchip:before{content:\"\\F2DB\"}.fa-snowflake-o:before{content:\"\\F2DC\"}.fa-superpowers:before{content:\"\\F2DD\"}.fa-wpexplorer:before{content:\"\\F2DE\"}.fa-meetup:before{content:\"\\F2E0\"}.fa-lg{font-size:1.33333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-ul{padding-left:0;margin-left:2.14285714em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.14285714em;width:2.14285714em;top:.14285714em;text-align:center}.fa-li.fa-lg{left:-1.85714286em}@font-face{font-family:FontAwesome;src:url(" + __webpack_require__(837) + ");src:url(" + __webpack_require__(836) + "?#iefix&v=4.7.0) format(\"embedded-opentype\"),url(" + __webpack_require__(955) + ") format(\"woff2\"),url(" + __webpack_require__(956) + ") format(\"woff\"),url(" + __webpack_require__(839) + ") format(\"truetype\"),url(" + __webpack_require__(838) + "#fontawesomeregular) format(\"svg\");font-weight:400;font-style:normal}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";-webkit-transform:rotate(270deg);-ms-transform:rotate(270deg);transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";-webkit-transform:scaleX(-1);-ms-transform:scaleX(-1);transform:scaleX(-1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";-webkit-transform:scaleY(-1);-ms-transform:scaleY(-1);transform:scaleY(-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{filter:none}.fa-spin{-webkit-animation:fa-spin 2s infinite linear;animation:fa-spin 2s infinite linear}.fa-pulse{-webkit-animation:fa-spin 1s infinite steps(8);animation:fa-spin 1s infinite steps(8)}@-webkit-keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}", ""]);
	
	// exports


/***/ },
/* 1765 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 1766 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowStart: true,
	  gridRowEnd: true,
	  gridColumn: true,
	  gridColumnStart: true,
	  gridColumnEnd: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	
	  /**
	   * @param {string} prefix vendor-specific prefix, eg: Webkit
	   * @param {string} key style name, eg: transitionDuration
	   * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	   * WebkitTransitionDuration
	   */
	};function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	exports.default = CSSProperty;

/***/ },
/* 1767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CSSProperty = __webpack_require__(1766);
	
	var _CSSProperty2 = _interopRequireDefault(_CSSProperty);
	
	var _warning = __webpack_require__(834);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 */
	
	var isUnitlessNumber = _CSSProperty2.default.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	exports.default = dangerousStyleValue;

/***/ },
/* 1768 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = clean;
	// Returns true for null, false, undefined and {}
	function isFalsy(value) {
	  return value === null || value === undefined || value === false || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && Object.keys(value).length === 0;
	}
	
	function cleanObject(object) {
	  if (isFalsy(object)) return null;
	  if ((typeof object === 'undefined' ? 'undefined' : _typeof(object)) !== 'object') return object;
	
	  var acc = {},
	      keys = Object.keys(object),
	      hasFalsy = false;
	  for (var i = 0; i < keys.length; i++) {
	    var value = object[keys[i]];
	    var filteredValue = clean(value);
	    if (filteredValue === null || filteredValue !== value) {
	      hasFalsy = true;
	    }
	    if (filteredValue !== null) {
	      acc[keys[i]] = filteredValue;
	    }
	  }
	  return Object.keys(acc).length === 0 ? null : hasFalsy ? acc : object;
	}
	
	function cleanArray(rules) {
	  var hasFalsy = false;
	  var filtered = [];
	  rules.forEach(function (rule) {
	    var filteredRule = clean(rule);
	    if (filteredRule === null || filteredRule !== rule) {
	      hasFalsy = true;
	    }
	    if (filteredRule !== null) {
	      filtered.push(filteredRule);
	    }
	  });
	  return filtered.length == 0 ? null : hasFalsy ? filtered : rules;
	}
	
	// Takes style array or object provided by user and clears all the falsy data 
	// If there is no styles left after filtration returns null
	function clean(input) {
	  return Array.isArray(input) ? cleanArray(input) : cleanObject(input);
	}

/***/ },
/* 1769 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = doHash;
	// murmurhash2 via https://gist.github.com/raycmorgan/588423
	
	function doHash(str, seed) {
	  var m = 0x5bd1e995;
	  var r = 24;
	  var h = seed ^ str.length;
	  var length = str.length;
	  var currentIndex = 0;
	
	  while (length >= 4) {
	    var k = UInt32(str, currentIndex);
	
	    k = Umul32(k, m);
	    k ^= k >>> r;
	    k = Umul32(k, m);
	
	    h = Umul32(h, m);
	    h ^= k;
	
	    currentIndex += 4;
	    length -= 4;
	  }
	
	  switch (length) {
	    case 3:
	      h ^= UInt16(str, currentIndex);
	      h ^= str.charCodeAt(currentIndex + 2) << 16;
	      h = Umul32(h, m);
	      break;
	
	    case 2:
	      h ^= UInt16(str, currentIndex);
	      h = Umul32(h, m);
	      break;
	
	    case 1:
	      h ^= str.charCodeAt(currentIndex);
	      h = Umul32(h, m);
	      break;
	  }
	
	  h ^= h >>> 13;
	  h = Umul32(h, m);
	  h ^= h >>> 15;
	
	  return h >>> 0;
	}
	
	function UInt32(str, pos) {
	  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8) + (str.charCodeAt(pos++) << 16) + (str.charCodeAt(pos) << 24);
	}
	
	function UInt16(str, pos) {
	  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8);
	}
	
	function Umul32(n, m) {
	  n = n | 0;
	  m = m | 0;
	  var nlo = n & 0xffff;
	  var nhi = n >>> 16;
	  var res = nlo * m + ((nhi * m & 0xffff) << 16) | 0;
	  return res;
	}

/***/ },
/* 1770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.compose = exports.merge = exports.$ = exports.style = exports.presets = exports.keyframes = exports.fontFace = exports.insertGlobal = exports.insertRule = exports.plugins = exports.styleSheet = undefined;
	exports.speedy = speedy;
	exports.simulations = simulations;
	exports.simulate = simulate;
	exports.cssLabels = cssLabels;
	exports.isLikeRule = isLikeRule;
	exports.idFor = idFor;
	exports.css = css;
	exports.rehydrate = rehydrate;
	exports.flush = flush;
	exports.select = select;
	exports.parent = parent;
	exports.media = media;
	exports.pseudo = pseudo;
	exports.active = active;
	exports.any = any;
	exports.checked = checked;
	exports.disabled = disabled;
	exports.empty = empty;
	exports.enabled = enabled;
	exports._default = _default;
	exports.first = first;
	exports.firstChild = firstChild;
	exports.firstOfType = firstOfType;
	exports.fullscreen = fullscreen;
	exports.focus = focus;
	exports.hover = hover;
	exports.indeterminate = indeterminate;
	exports.inRange = inRange;
	exports.invalid = invalid;
	exports.lastChild = lastChild;
	exports.lastOfType = lastOfType;
	exports.left = left;
	exports.link = link;
	exports.onlyChild = onlyChild;
	exports.onlyOfType = onlyOfType;
	exports.optional = optional;
	exports.outOfRange = outOfRange;
	exports.readOnly = readOnly;
	exports.readWrite = readWrite;
	exports.required = required;
	exports.right = right;
	exports.root = root;
	exports.scope = scope;
	exports.target = target;
	exports.valid = valid;
	exports.visited = visited;
	exports.dir = dir;
	exports.lang = lang;
	exports.not = not;
	exports.nthChild = nthChild;
	exports.nthLastChild = nthLastChild;
	exports.nthLastOfType = nthLastOfType;
	exports.nthOfType = nthOfType;
	exports.after = after;
	exports.before = before;
	exports.firstLetter = firstLetter;
	exports.firstLine = firstLine;
	exports.selection = selection;
	exports.backdrop = backdrop;
	exports.placeholder = placeholder;
	exports.cssFor = cssFor;
	exports.attribsFor = attribsFor;
	
	var _objectAssign = __webpack_require__(230);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _sheet = __webpack_require__(1773);
	
	var _CSSPropertyOperations = __webpack_require__(842);
	
	var _clean = __webpack_require__(1768);
	
	var _clean2 = _interopRequireDefault(_clean);
	
	var _plugins = __webpack_require__(1771);
	
	var _hash = __webpack_require__(1769);
	
	var _hash2 = _interopRequireDefault(_hash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	/* stylesheet */
	
	
	var styleSheet = exports.styleSheet = new _sheet.StyleSheet();
	// an isomorphic StyleSheet shim. hides all the nitty gritty.
	
	// /**************** LIFTOFF IN 3... 2... 1... ****************/
	styleSheet.inject(); //eslint-disable-line indent
	// /****************      TO THE MOOOOOOON     ****************/
	
	// convenience function to toggle speedy
	function speedy(bool) {
	  return styleSheet.speedy(bool);
	}
	
	// plugins
	// we include these by default
	var plugins = exports.plugins = styleSheet.plugins = new _plugins.PluginSet([_plugins.prefixes, _plugins.contentWrap, _plugins.fallbacks]);
	plugins.media = new _plugins.PluginSet(); // neat! media, font-face, keyframes
	plugins.fontFace = new _plugins.PluginSet();
	plugins.keyframes = new _plugins.PluginSet([_plugins.prefixes, _plugins.fallbacks]);
	
	// define some constants
	
	var isDev = ("production") === 'development' || !("production");
	var isTest = ("production") === 'test';
	var isBrowser = typeof window !== 'undefined';
	
	/**** simulations  ****/
	
	// a flag to enable simulation meta tags on dom nodes
	// defaults to true in dev mode. recommend *not* to
	// toggle often.
	var canSimulate = isDev;
	
	// we use these flags for issuing warnings when simulate is called
	// in prod / in incorrect order
	var warned1 = false,
	    warned2 = false;
	
	// toggles simulation activity. shouldn't be needed in most cases
	function simulations() {
	  var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	  canSimulate = !!bool;
	}
	
	// use this on dom nodes to 'simulate' pseudoclasses
	// <div {...hover({ color: 'red' })} {...simulate('hover', 'visited')}>...</div>
	// you can even send in some weird ones, as long as it's in simple format
	// and matches an existing rule on the element
	// eg simulate('nthChild2', ':hover:active') etc
	function simulate() {
	  for (var _len = arguments.length, pseudos = Array(_len), _key = 0; _key < _len; _key++) {
	    pseudos[_key] = arguments[_key];
	  }
	
	  pseudos = (0, _clean2.default)(pseudos);
	  if (!pseudos) return {};
	  if (!canSimulate) {
	    if (!warned1) {
	      console.warn('can\'t simulate without once calling simulations(true)'); //eslint-disable-line no-console
	      warned1 = true;
	    }
	    if (!isDev && !isTest && !warned2) {
	      console.warn('don\'t use simulation outside dev'); //eslint-disable-line no-console
	      warned2 = true;
	    }
	    return {};
	  }
	  return pseudos.reduce(function (o, p) {
	    return o['data-simulate-' + simple(p)] = '', o;
	  }, {});
	}
	
	/**** labels ****/
	// toggle for debug labels.
	// *shouldn't* have to mess with this manually
	var hasLabels = isDev;
	
	function cssLabels(bool) {
	  hasLabels = !!bool;
	}
	
	// takes a string, converts to lowercase, strips out nonalphanumeric.
	function simple(str) {
	  var char = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  return str.toLowerCase().replace(/[^a-z0-9]/g, char);
	}
	
	// hashes a string to something 'unique'
	// we use this to generate ids for styles
	
	
	function hashify(obj) {
	  var str = JSON.stringify(obj);
	  var toRet = (0, _hash2.default)(str).toString(36);
	  if (obj.label && obj.label.length > 0 && isDev) {
	    return simple(obj.label.join('.'), '-') + '-' + toRet;
	  }
	  return toRet;
	}
	
	// of shape { 'data-css-<id>': '' }
	function isLikeRule(rule) {
	  var keys = Object.keys(rule).filter(function (x) {
	    return x !== 'toString';
	  });
	  if (keys.length !== 1) {
	    return false;
	  }
	  return !!/data\-css\-([a-zA-Z0-9\-_]+)/.exec(keys[0]);
	}
	
	// extracts id from a { 'data-css-<id>': ''} like object
	function idFor(rule) {
	  var keys = Object.keys(rule).filter(function (x) {
	    return x !== 'toString';
	  });
	  if (keys.length !== 1) throw new Error('not a rule');
	  var regex = /data\-css\-([a-zA-Z0-9\-_]+)/;
	  var match = regex.exec(keys[0]);
	  if (!match) throw new Error('not a rule');
	  return match[1];
	}
	
	// from https://github.com/j2css/j2c/blob/5d381c2d721d04b54fabe6a165d587247c3087cb/src/helpers.js#L28-L61
	
	// "Tokenizes" the selectors into parts relevant for the next function.
	// Strings and comments are matched, but ignored afterwards.
	// This is not a full tokenizers. It only recognizes comas, parentheses,
	// strings and comments.
	// regexp generated by scripts/regexps.js then trimmed by hand
	var selectorTokenizer = /[(),]|"(?:\\.|[^"\n])*"|'(?:\\.|[^'\n])*'|\/\*[\s\S]*?\*\//g;
	
	/**
	 * This will split a coma-separated selector list into individual selectors,
	 * ignoring comas in strings, comments and in :pseudo-selectors(parameter, lists).
	 *
	 * @param {string} selector
	 * @return {string[]}
	 */
	
	function splitSelector(selector) {
	  if (selector.indexOf(',') === -1) {
	    return [selector];
	  }
	
	  var indices = [],
	      res = [],
	      inParen = 0,
	      o;
	  /*eslint-disable no-cond-assign*/
	  while (o = selectorTokenizer.exec(selector)) {
	    /*eslint-enable no-cond-assign*/
	    switch (o[0]) {
	      case '(':
	        inParen++;break;
	      case ')':
	        inParen--;break;
	      case ',':
	        if (inParen) break;indices.push(o.index);
	    }
	  }
	  for (o = indices.length; o--;) {
	    res.unshift(selector.slice(indices[o] + 1));
	    selector = selector.slice(0, indices[o]);
	  }
	  res.unshift(selector);
	  return res;
	}
	
	function selector(id, path) {
	  if (!id) {
	    return path.replace(/\&/g, '');
	  }
	  if (!path) return '.css-' + id + ',[data-css-' + id + ']';
	
	  var x = splitSelector(path).map(function (x) {
	    return x.indexOf('&') >= 0 ? [x.replace(/\&/mg, '.css-' + id), x.replace(/\&/mg, '[data-css-' + id + ']')].join(',') // todo - make sure each sub selector has an &
	    : '.css-' + id + x + ',[data-css-' + id + ']' + x;
	  }).join(',');
	
	  if (canSimulate && /^\&\:/.exec(path) && !/\s/.exec(path)) {
	    x += ',.css-' + id + '[data-simulate-' + simple(path) + '],[data-css-' + id + '][data-simulate-' + simple(path) + ']';
	  }
	  return x;
	}
	
	// end https://github.com/j2css/j2c/blob/5d381c2d721d04b54fabe6a165d587247c3087cb/src/helpers.js#L28-L61
	
	
	function toCSS(_ref) {
	  var selector = _ref.selector,
	      style = _ref.style;
	
	  var result = plugins.transform({ selector: selector, style: style });
	  return result.selector + '{' + (0, _CSSPropertyOperations.createMarkupForStyles)(result.style) + '}';
	}
	
	function deconstruct(style) {
	  // we can be sure it's not infinitely nested here
	  var plain = void 0,
	      selects = void 0,
	      medias = void 0,
	      supports = void 0;
	  Object.keys(style).forEach(function (key) {
	    if (key.indexOf('&') >= 0) {
	      selects = selects || {};
	      selects[key] = style[key];
	    } else if (key.indexOf('@media') === 0) {
	      medias = medias || {};
	      medias[key] = deconstruct(style[key]);
	    } else if (key.indexOf('@supports') === 0) {
	      supports = supports || {};
	      supports[key] = deconstruct(style[key]);
	    } else if (key === 'label') {
	      if (style.label.length > 0) {
	        plain = plain || {};
	        plain.label = hasLabels ? style.label.join('.') : '';
	      }
	    } else {
	      plain = plain || {};
	      plain[key] = style[key];
	    }
	  });
	  return { plain: plain, selects: selects, medias: medias, supports: supports };
	}
	
	function deconstructedStyleToCSS(id, style) {
	  var css = [];
	
	  // plugins here
	  var plain = style.plain,
	      selects = style.selects,
	      medias = style.medias,
	      supports = style.supports;
	
	  if (plain) {
	    css.push(toCSS({ style: plain, selector: selector(id) }));
	  }
	  if (selects) {
	    Object.keys(selects).forEach(function (key) {
	      return css.push(toCSS({ style: selects[key], selector: selector(id, key) }));
	    });
	  }
	  if (medias) {
	    Object.keys(medias).forEach(function (key) {
	      return css.push(key + '{' + deconstructedStyleToCSS(id, medias[key]).join('') + '}');
	    });
	  }
	  if (supports) {
	    Object.keys(supports).forEach(function (key) {
	      return css.push(key + '{' + deconstructedStyleToCSS(id, supports[key]).join('') + '}');
	    });
	  }
	  return css;
	}
	
	// this cache to track which rules have
	// been inserted into the stylesheet
	var inserted = styleSheet.inserted = {};
	
	// and helpers to insert rules into said styleSheet
	function insert(spec) {
	  if (!inserted[spec.id]) {
	    inserted[spec.id] = true;
	    var deconstructed = deconstruct(spec.style);
	    var rules = deconstructedStyleToCSS(spec.id, deconstructed);
	    inserted[spec.id] = isBrowser ? true : rules;
	    rules.forEach(function (cssRule) {
	      return styleSheet.insert(cssRule);
	    });
	  }
	}
	
	// a simple cache to store generated rules
	var registered = styleSheet.registered = {};
	function register(spec) {
	  if (!registered[spec.id]) {
	    registered[spec.id] = spec;
	  }
	}
	
	function _getRegistered(rule) {
	  if (isLikeRule(rule)) {
	    var ret = registered[idFor(rule)];
	    if (ret == null) {
	      throw new Error('[glamor] an unexpected rule cache miss occurred. This is probably a sign of multiple glamor instances in your app. See https://github.com/threepointone/glamor/issues/79');
	    }
	    return ret;
	  }
	  return rule;
	}
	
	// todo - perf
	var ruleCache = {};
	function toRule(spec) {
	  register(spec);
	  insert(spec);
	
	  if (ruleCache[spec.id]) {
	    return ruleCache[spec.id];
	  }
	
	  var ret = _defineProperty({}, 'data-css-' + spec.id, hasLabels ? spec.label || '' : '');
	  Object.defineProperty(ret, 'toString', {
	    enumerable: false, value: function value() {
	      return 'css-' + spec.id;
	    }
	  });
	  ruleCache[spec.id] = ret;
	  return ret;
	}
	
	function log() {
	  //eslint-disable-line no-unused-vars
	  console.log(this); //eslint-disable-line no-console
	  return this;
	}
	
	function isSelector(key) {
	  var possibles = [':', '.', '[', '>', ' '],
	      found = false,
	      ch = key.charAt(0);
	  for (var i = 0; i < possibles.length; i++) {
	    if (ch === possibles[i]) {
	      found = true;
	      break;
	    }
	  }
	  return found || key.indexOf('&') >= 0;
	}
	
	function joinSelectors(a, b) {
	  var as = splitSelector(a).map(function (a) {
	    return !(a.indexOf('&') >= 0) ? '&' + a : a;
	  });
	  var bs = splitSelector(b).map(function (b) {
	    return !(b.indexOf('&') >= 0) ? '&' + b : b;
	  });
	
	  return bs.reduce(function (arr, b) {
	    return arr.concat(as.map(function (a) {
	      return b.replace(/\&/g, a);
	    }));
	  }, []).join(',');
	}
	
	function joinMediaQueries(a, b) {
	  return a ? '@media ' + a.substring(6) + ' and ' + b.substring(6) : b;
	}
	
	function isMediaQuery(key) {
	  return key.indexOf('@media') === 0;
	}
	
	function isSupports(key) {
	  return key.indexOf('@supports') === 0;
	}
	
	function joinSupports(a, b) {
	  return a ? '@supports ' + a.substring(9) + ' and ' + b.substring(9) : b;
	}
	
	// flatten a nested array
	function flatten(inArr) {
	  var arr = [];
	  for (var i = 0; i < inArr.length; i++) {
	    if (Array.isArray(inArr[i])) arr = arr.concat(flatten(inArr[i]));else arr = arr.concat(inArr[i]);
	  }
	  return arr;
	}
	
	var prefixedPseudoSelectors = {
	  '::placeholder': ['::-webkit-input-placeholder', '::-moz-placeholder', '::-ms-input-placeholder'],
	  ':fullscreen': [':-webkit-full-screen', ':-moz-full-screen', ':-ms-fullscreen']
	
	  // mutable! modifies dest.
	};function build(dest, _ref2) {
	  var _ref2$selector = _ref2.selector,
	      selector = _ref2$selector === undefined ? '' : _ref2$selector,
	      _ref2$mq = _ref2.mq,
	      mq = _ref2$mq === undefined ? '' : _ref2$mq,
	      _ref2$supp = _ref2.supp,
	      supp = _ref2$supp === undefined ? '' : _ref2$supp,
	      _ref2$src = _ref2.src,
	      src = _ref2$src === undefined ? {} : _ref2$src;
	
	
	  if (!Array.isArray(src)) {
	    src = [src];
	  }
	  src = flatten(src);
	
	  src.forEach(function (_src) {
	    if (isLikeRule(_src)) {
	      var reg = _getRegistered(_src);
	      if (reg.type !== 'css') {
	        throw new Error('cannot merge this rule');
	      }
	      _src = reg.style;
	    }
	    _src = (0, _clean2.default)(_src);
	    if (_src && _src.composes) {
	      build(dest, { selector: selector, mq: mq, supp: supp, src: _src.composes });
	    }
	    Object.keys(_src || {}).forEach(function (key) {
	      if (isSelector(key)) {
	
	        if (prefixedPseudoSelectors[key]) {
	          prefixedPseudoSelectors[key].forEach(function (p) {
	            return build(dest, { selector: joinSelectors(selector, p), mq: mq, supp: supp, src: _src[key] });
	          });
	        }
	
	        build(dest, { selector: joinSelectors(selector, key), mq: mq, supp: supp, src: _src[key] });
	      } else if (isMediaQuery(key)) {
	        build(dest, { selector: selector, mq: joinMediaQueries(mq, key), supp: supp, src: _src[key] });
	      } else if (isSupports(key)) {
	        build(dest, { selector: selector, mq: mq, supp: joinSupports(supp, key), src: _src[key] });
	      } else if (key === 'composes') {
	        // ignore, we already dealth with it
	      } else {
	        var _dest = dest;
	        if (supp) {
	          _dest[supp] = _dest[supp] || {};
	          _dest = _dest[supp];
	        }
	        if (mq) {
	          _dest[mq] = _dest[mq] || {};
	          _dest = _dest[mq];
	        }
	        if (selector) {
	          _dest[selector] = _dest[selector] || {};
	          _dest = _dest[selector];
	        }
	
	        if (key === 'label') {
	          if (hasLabels) {
	            dest.label = dest.label.concat(_src.label);
	          }
	        } else {
	          _dest[key] = _src[key];
	        }
	      }
	    });
	  });
	}
	
	function _css(rules) {
	  var style = { label: [] };
	  build(style, { src: rules }); // mutative! but worth it.
	
	  var spec = {
	    id: hashify(style),
	    style: style, label: hasLabels ? style.label.join('.') : '',
	    type: 'css'
	  };
	  return toRule(spec);
	}
	
	var nullrule = {
	  // 'data-css-nil': ''
	};
	Object.defineProperty(nullrule, 'toString', {
	  enumerable: false, value: function value() {
	    return 'css-nil';
	  }
	});
	
	var inputCaches = typeof WeakMap !== 'undefined' ? [nullrule, new WeakMap(), new WeakMap(), new WeakMap()] : [nullrule];
	
	var warnedWeakMapError = false;
	function multiIndexCache(fn) {
	  return function (args) {
	    if (inputCaches[args.length]) {
	      var coi = inputCaches[args.length];
	      var ctr = 0;
	      while (ctr < args.length - 1) {
	        if (!coi.has(args[ctr])) {
	          coi.set(args[ctr], new WeakMap());
	        }
	        coi = coi.get(args[ctr]);
	        ctr++;
	      }
	      if (coi.has(args[args.length - 1])) {
	        var ret = coi.get(args[ctr]);
	
	        if (registered[ret.toString().substring(4)]) {
	          // make sure it hasn't been flushed
	          return ret;
	        }
	      }
	    }
	    var value = fn(args);
	    if (inputCaches[args.length]) {
	      var _ctr = 0,
	          _coi = inputCaches[args.length];
	      while (_ctr < args.length - 1) {
	        _coi = _coi.get(args[_ctr]);
	        _ctr++;
	      }
	      try {
	        _coi.set(args[_ctr], value);
	      } catch (err) {
	        if (isDev && !warnedWeakMapError) {
	          var _console;
	
	          warnedWeakMapError = true;
	          (_console = console).warn.apply(_console, ['failed setting the WeakMap cache for args:'].concat(_toConsumableArray(args))); // eslint-disable-line no-console
	          console.warn('this should NOT happen, please file a bug on the github repo.'); // eslint-disable-line no-console
	        }
	      }
	    }
	    return value;
	  };
	}
	
	var cachedCss = typeof WeakMap !== 'undefined' ? multiIndexCache(_css) : _css;
	
	function css() {
	  for (var _len2 = arguments.length, rules = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    rules[_key2] = arguments[_key2];
	  }
	
	  if (rules[0] && rules[0].length && rules[0].raw) {
	    throw new Error('you forgot to include glamor/babel in your babel plugins.');
	  }
	
	  rules = (0, _clean2.default)(rules);
	  if (!rules) {
	    return nullrule;
	  }
	
	  return cachedCss(rules);
	}
	
	css.insert = function (css) {
	  var spec = {
	    id: hashify(css),
	    css: css,
	    type: 'raw'
	  };
	  register(spec);
	  if (!inserted[spec.id]) {
	    styleSheet.insert(spec.css);
	    inserted[spec.id] = isBrowser ? true : [spec.css];
	  }
	};
	
	var insertRule = exports.insertRule = css.insert;
	
	css.global = function (selector, style) {
	  style = (0, _clean2.default)(style);
	  if (style) {
	    return css.insert(toCSS({ selector: selector, style: style }));
	  }
	};
	
	var insertGlobal = exports.insertGlobal = css.global;
	
	function insertKeyframe(spec) {
	  if (!inserted[spec.id]) {
	    var inner = Object.keys(spec.keyframes).map(function (kf) {
	      var result = plugins.keyframes.transform({ id: spec.id, name: kf, style: spec.keyframes[kf] });
	      return result.name + '{' + (0, _CSSPropertyOperations.createMarkupForStyles)(result.style) + '}';
	    }).join('');
	
	    var rules = ['-webkit-', '-moz-', '-o-', ''].map(function (prefix) {
	      return '@' + prefix + 'keyframes ' + (spec.name + '_' + spec.id) + '{' + inner + '}';
	    });
	    rules.forEach(function (rule) {
	      return styleSheet.insert(rule);
	    });
	
	    inserted[spec.id] = isBrowser ? true : rules;
	  }
	}
	css.keyframes = function (name, kfs) {
	  if (!kfs) {
	    kfs = name, name = 'animation';
	  }
	
	  // do not ignore empty keyframe definitions for now.
	  kfs = (0, _clean2.default)(kfs) || {};
	  var spec = {
	    id: hashify({ name: name, kfs: kfs }),
	    type: 'keyframes',
	    name: name,
	    keyframes: kfs
	  };
	  register(spec);
	  insertKeyframe(spec);
	  return name + '_' + spec.id;
	};
	
	// we don't go all out for fonts as much, giving a simple font loading strategy
	// use a fancier lib if you need moar power
	css.fontFace = function (font) {
	  font = (0, _clean2.default)(font);
	  var spec = {
	    id: hashify(font),
	    type: 'font-face',
	    font: font
	  };
	  register(spec);
	  insertFontFace(spec);
	
	  return font.fontFamily;
	};
	
	var fontFace = exports.fontFace = css.fontFace;
	var keyframes = exports.keyframes = css.keyframes;
	
	function insertFontFace(spec) {
	  if (!inserted[spec.id]) {
	    var rule = '@font-face{' + (0, _CSSPropertyOperations.createMarkupForStyles)(spec.font) + '}';
	    styleSheet.insert(rule);
	    inserted[spec.id] = isBrowser ? true : [rule];
	  }
	}
	
	// rehydrate the insertion cache with ids sent from
	// renderStatic / renderStaticOptimized
	function rehydrate(ids) {
	  // load up ids
	  (0, _objectAssign2.default)(inserted, ids.reduce(function (o, i) {
	    return o[i] = true, o;
	  }, {}));
	  // assume css loaded separately
	}
	
	// clears out the cache and empties the stylesheet
	// best for tests, though there might be some value for SSR.
	
	function flush() {
	  inserted = styleSheet.inserted = {};
	  registered = styleSheet.registered = {};
	  ruleCache = {};
	  styleSheet.flush();
	  styleSheet.inject();
	}
	
	var presets = exports.presets = {
	  mobile: '(min-width: 400px)',
	  Mobile: '@media (min-width: 400px)',
	  phablet: '(min-width: 550px)',
	  Phablet: '@media (min-width: 550px)',
	  tablet: '(min-width: 750px)',
	  Tablet: '@media (min-width: 750px)',
	  desktop: '(min-width: 1000px)',
	  Desktop: '@media (min-width: 1000px)',
	  hd: '(min-width: 1200px)',
	  Hd: '@media (min-width: 1200px)'
	};
	
	var style = exports.style = css;
	
	function select(selector) {
	  for (var _len3 = arguments.length, styles = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    styles[_key3 - 1] = arguments[_key3];
	  }
	
	  if (!selector) {
	    return style(styles);
	  }
	  return css(_defineProperty({}, selector, styles));
	}
	var $ = exports.$ = select;
	
	function parent(selector) {
	  for (var _len4 = arguments.length, styles = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    styles[_key4 - 1] = arguments[_key4];
	  }
	
	  return css(_defineProperty({}, selector + ' &', styles));
	}
	
	var merge = exports.merge = css;
	var compose = exports.compose = css;
	
	function media(query) {
	  for (var _len5 = arguments.length, rules = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	    rules[_key5 - 1] = arguments[_key5];
	  }
	
	  return css(_defineProperty({}, '@media ' + query, rules));
	}
	
	function pseudo(selector) {
	  for (var _len6 = arguments.length, styles = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
	    styles[_key6 - 1] = arguments[_key6];
	  }
	
	  return css(_defineProperty({}, selector, styles));
	}
	
	// allllll the pseudoclasses
	
	function active(x) {
	  return pseudo(':active', x);
	}
	
	function any(x) {
	  return pseudo(':any', x);
	}
	
	function checked(x) {
	  return pseudo(':checked', x);
	}
	
	function disabled(x) {
	  return pseudo(':disabled', x);
	}
	
	function empty(x) {
	  return pseudo(':empty', x);
	}
	
	function enabled(x) {
	  return pseudo(':enabled', x);
	}
	
	function _default(x) {
	  return pseudo(':default', x); // note '_default' name
	}
	
	function first(x) {
	  return pseudo(':first', x);
	}
	
	function firstChild(x) {
	  return pseudo(':first-child', x);
	}
	
	function firstOfType(x) {
	  return pseudo(':first-of-type', x);
	}
	
	function fullscreen(x) {
	  return pseudo(':fullscreen', x);
	}
	
	function focus(x) {
	  return pseudo(':focus', x);
	}
	
	function hover(x) {
	  return pseudo(':hover', x);
	}
	
	function indeterminate(x) {
	  return pseudo(':indeterminate', x);
	}
	
	function inRange(x) {
	  return pseudo(':in-range', x);
	}
	
	function invalid(x) {
	  return pseudo(':invalid', x);
	}
	
	function lastChild(x) {
	  return pseudo(':last-child', x);
	}
	
	function lastOfType(x) {
	  return pseudo(':last-of-type', x);
	}
	
	function left(x) {
	  return pseudo(':left', x);
	}
	
	function link(x) {
	  return pseudo(':link', x);
	}
	
	function onlyChild(x) {
	  return pseudo(':only-child', x);
	}
	
	function onlyOfType(x) {
	  return pseudo(':only-of-type', x);
	}
	
	function optional(x) {
	  return pseudo(':optional', x);
	}
	
	function outOfRange(x) {
	  return pseudo(':out-of-range', x);
	}
	
	function readOnly(x) {
	  return pseudo(':read-only', x);
	}
	
	function readWrite(x) {
	  return pseudo(':read-write', x);
	}
	
	function required(x) {
	  return pseudo(':required', x);
	}
	
	function right(x) {
	  return pseudo(':right', x);
	}
	
	function root(x) {
	  return pseudo(':root', x);
	}
	
	function scope(x) {
	  return pseudo(':scope', x);
	}
	
	function target(x) {
	  return pseudo(':target', x);
	}
	
	function valid(x) {
	  return pseudo(':valid', x);
	}
	
	function visited(x) {
	  return pseudo(':visited', x);
	}
	
	// parameterized pseudoclasses
	function dir(p, x) {
	  return pseudo(':dir(' + p + ')', x);
	}
	function lang(p, x) {
	  return pseudo(':lang(' + p + ')', x);
	}
	function not(p, x) {
	  // should this be a plugin?
	  var selector = p.split(',').map(function (x) {
	    return x.trim();
	  }).map(function (x) {
	    return ':not(' + x + ')';
	  });
	  if (selector.length === 1) {
	    return pseudo(':not(' + p + ')', x);
	  }
	  return select(selector.join(''), x);
	}
	function nthChild(p, x) {
	  return pseudo(':nth-child(' + p + ')', x);
	}
	function nthLastChild(p, x) {
	  return pseudo(':nth-last-child(' + p + ')', x);
	}
	function nthLastOfType(p, x) {
	  return pseudo(':nth-last-of-type(' + p + ')', x);
	}
	function nthOfType(p, x) {
	  return pseudo(':nth-of-type(' + p + ')', x);
	}
	
	// pseudoelements
	function after(x) {
	  return pseudo('::after', x);
	}
	function before(x) {
	  return pseudo('::before', x);
	}
	function firstLetter(x) {
	  return pseudo('::first-letter', x);
	}
	function firstLine(x) {
	  return pseudo('::first-line', x);
	}
	function selection(x) {
	  return pseudo('::selection', x);
	}
	function backdrop(x) {
	  return pseudo('::backdrop', x);
	}
	function placeholder(x) {
	  // https://github.com/threepointone/glamor/issues/14
	  return css({ '::placeholder': x });
	}
	
	/*** helpers for web components ***/
	// https://github.com/threepointone/glamor/issues/16
	
	function cssFor() {
	  for (var _len7 = arguments.length, rules = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	    rules[_key7] = arguments[_key7];
	  }
	
	  rules = (0, _clean2.default)(rules);
	  return rules ? rules.map(function (r) {
	    var style = { label: [] };
	    build(style, { src: r }); // mutative! but worth it.
	    return deconstructedStyleToCSS(hashify(style), deconstruct(style)).join('');
	  }).join('') : '';
	}
	
	function attribsFor() {
	  for (var _len8 = arguments.length, rules = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
	    rules[_key8] = arguments[_key8];
	  }
	
	  rules = (0, _clean2.default)(rules);
	  var htmlAttributes = rules ? rules.map(function (rule) {
	    idFor(rule); // throwaway check for rule
	    var key = Object.keys(rule)[0],
	        value = rule[key];
	    return key + '="' + (value || '') + '"';
	  }).join(' ') : '';
	
	  return htmlAttributes;
	}

/***/ },
/* 1771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.PluginSet = PluginSet;
	exports.fallbacks = fallbacks;
	exports.contentWrap = contentWrap;
	exports.prefixes = prefixes;
	
	var _objectAssign = __webpack_require__(230);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _CSSPropertyOperations = __webpack_require__(842);
	
	var _prefixer = __webpack_require__(1772);
	
	var _prefixer2 = _interopRequireDefault(_prefixer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isDev = function (x) {
	  return x === 'development' || !x;
	}(("production"));
	
	function PluginSet(initial) {
	  this.fns = initial || [];
	}
	
	(0, _objectAssign2.default)(PluginSet.prototype, {
	  add: function add() {
	    var _this = this;
	
	    for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
	      fns[_key] = arguments[_key];
	    }
	
	    fns.forEach(function (fn) {
	      if (_this.fns.indexOf(fn) >= 0) {
	        if (isDev) {
	          console.warn('adding the same plugin again, ignoring'); //eslint-disable-line no-console
	        }
	      } else {
	        _this.fns = [fn].concat(_this.fns);
	      }
	    });
	  },
	  remove: function remove(fn) {
	    this.fns = this.fns.filter(function (x) {
	      return x !== fn;
	    });
	  },
	  clear: function clear() {
	    this.fns = [];
	  },
	  transform: function transform(o) {
	    return this.fns.reduce(function (o, fn) {
	      return fn(o);
	    }, o);
	  }
	});
	
	function fallbacks(node) {
	  var hasArray = Object.keys(node.style).map(function (x) {
	    return Array.isArray(node.style[x]);
	  }).indexOf(true) >= 0;
	  if (hasArray) {
	    var style = node.style;
	
	    var flattened = Object.keys(style).reduce(function (o, key) {
	      o[key] = Array.isArray(style[key]) ? style[key].join('; ' + (0, _CSSPropertyOperations.processStyleName)(key) + ': ') : style[key];
	      return o;
	    }, {});
	    // todo - 
	    // flatten arrays which haven't been flattened yet 
	    return (0, _objectAssign2.default)({}, node, { style: flattened });
	  }
	  return node;
	}
	
	var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit'];
	
	function contentWrap(node) {
	  if (node.style.content) {
	    var cont = node.style.content;
	    if (contentValues.indexOf(cont) >= 0) {
	      return node;
	    }
	    if (/^(attr|calc|counters?|url)\(/.test(cont)) {
	      return node;
	    }
	    if (cont.charAt(0) === cont.charAt(cont.length - 1) && (cont.charAt(0) === '"' || cont.charAt(0) === "'")) {
	      return node;
	    }
	    return _extends({}, node, { style: _extends({}, node.style, { content: '"' + cont + '"' }) });
	  }
	  return node;
	}
	
	function prefixes(node) {
	  return (0, _objectAssign2.default)({}, node, { style: (0, _prefixer2.default)(_extends({}, node.style)) });
	}

/***/ },
/* 1772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixer;
	
	var _staticData = __webpack_require__(1791);
	
	var _staticData2 = _interopRequireDefault(_staticData);
	
	var _prefixProperty = __webpack_require__(1792);
	
	var _prefixProperty2 = _interopRequireDefault(_prefixProperty);
	
	var _prefixValue = __webpack_require__(1793);
	
	var _prefixValue2 = _interopRequireDefault(_prefixValue);
	
	var _cursor = __webpack_require__(1782);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _crossFade = __webpack_require__(1781);
	
	var _crossFade2 = _interopRequireDefault(_crossFade);
	
	var _filter = __webpack_require__(1783);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _flex = __webpack_require__(1784);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _flexboxOld = __webpack_require__(1785);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	var _gradient = __webpack_require__(1786);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _imageSet = __webpack_require__(1787);
	
	var _imageSet2 = _interopRequireDefault(_imageSet);
	
	var _position = __webpack_require__(1788);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _sizing = __webpack_require__(1789);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _transition = __webpack_require__(1790);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var plugins = [_crossFade2.default, _cursor2.default, _filter2.default, _flexboxOld2.default, _gradient2.default, _imageSet2.default, _position2.default, _sizing2.default, _transition2.default, _flex2.default]; // custom facade for inline-style-prefixer
	
	var prefixMap = _staticData2.default.prefixMap;
	
	function prefixer(style) {
	  for (var property in style) {
	    var value = style[property];
	
	    var processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);
	
	    // only modify the value if it was touched
	    // by any plugin to prevent unnecessary mutations
	    if (processedValue) {
	      style[property] = processedValue;
	    }
	
	    (0, _prefixProperty2.default)(prefixMap, property, style);
	  }
	  return style;
	}

/***/ },
/* 1773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StyleSheet = StyleSheet;
	
	var _objectAssign = __webpack_require__(230);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/* 
	
	high performance StyleSheet for css-in-js systems 
	
	- uses multiple style tags behind the scenes for millions of rules 
	- uses `insertRule` for appending in production for *much* faster performance
	- 'polyfills' on server side 
	
	
	// usage
	
	import StyleSheet from 'glamor/lib/sheet'
	let styleSheet = new StyleSheet()
	
	styleSheet.inject() 
	- 'injects' the stylesheet into the page (or into memory if on server)
	
	styleSheet.insert('#box { border: 1px solid red; }') 
	- appends a css rule into the stylesheet 
	
	styleSheet.flush() 
	- empties the stylesheet of all its contents
	
	
	*/
	
	function last(arr) {
	  return arr[arr.length - 1];
	}
	
	function sheetForTag(tag) {
	  if (tag.sheet) {
	    return tag.sheet;
	  }
	
	  // this weirdness brought to you by firefox 
	  for (var i = 0; i < document.styleSheets.length; i++) {
	    if (document.styleSheets[i].ownerNode === tag) {
	      return document.styleSheets[i];
	    }
	  }
	}
	
	var isBrowser = typeof window !== 'undefined';
	var isDev = ("production") === 'development' || !("production"); //(x => (x === 'development') || !x)(process.env.NODE_ENV)
	var isTest = ("production") === 'test';
	
	var oldIE = function () {
	  if (isBrowser) {
	    var div = document.createElement('div');
	    div.innerHTML = '<!--[if lt IE 10]><i></i><![endif]-->';
	    return div.getElementsByTagName('i').length === 1;
	  }
	}();
	
	function makeStyleTag() {
	  var tag = document.createElement('style');
	  tag.type = 'text/css';
	  tag.setAttribute('data-glamor', '');
	  tag.appendChild(document.createTextNode(''));
	  (document.head || document.getElementsByTagName('head')[0]).appendChild(tag);
	  return tag;
	}
	
	function StyleSheet() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$speedy = _ref.speedy,
	      speedy = _ref$speedy === undefined ? !isDev && !isTest : _ref$speedy,
	      _ref$maxLength = _ref.maxLength,
	      maxLength = _ref$maxLength === undefined ? isBrowser && oldIE ? 4000 : 65000 : _ref$maxLength;
	
	  this.isSpeedy = speedy; // the big drawback here is that the css won't be editable in devtools
	  this.sheet = undefined;
	  this.tags = [];
	  this.maxLength = maxLength;
	  this.ctr = 0;
	}
	
	(0, _objectAssign2.default)(StyleSheet.prototype, {
	  getSheet: function getSheet() {
	    return sheetForTag(last(this.tags));
	  },
	  inject: function inject() {
	    var _this = this;
	
	    if (this.injected) {
	      throw new Error('already injected stylesheet!');
	    }
	    if (isBrowser) {
	      this.tags[0] = makeStyleTag();
	    } else {
	      // server side 'polyfill'. just enough behavior to be useful.
	      this.sheet = {
	        cssRules: [],
	        insertRule: function insertRule(rule) {
	          // enough 'spec compliance' to be able to extract the rules later  
	          // in other words, just the cssText field 
	          _this.sheet.cssRules.push({ cssText: rule });
	        }
	      };
	    }
	    this.injected = true;
	  },
	  speedy: function speedy(bool) {
	    if (this.ctr !== 0) {
	      throw new Error('cannot change speedy mode after inserting any rule to sheet. Either call speedy(' + bool + ') earlier in your app, or call flush() before speedy(' + bool + ')');
	    }
	    this.isSpeedy = !!bool;
	  },
	  _insert: function _insert(rule) {
	    // this weirdness for perf, and chrome's weird bug 
	    // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
	    try {
	      var sheet = this.getSheet();
	      sheet.insertRule(rule, rule.indexOf('@import') !== -1 ? 0 : sheet.cssRules.length);
	    } catch (e) {
	      if (isDev) {
	        // might need beter dx for this 
	        console.warn('whoops, illegal rule inserted', rule); //eslint-disable-line no-console
	      }
	    }
	  },
	  insert: function insert(rule) {
	
	    if (isBrowser) {
	      // this is the ultrafast version, works across browsers 
	      if (this.isSpeedy && this.getSheet().insertRule) {
	        this._insert(rule);
	      }
	      // more browser weirdness. I don't even know    
	      // else if(this.tags.length > 0 && this.tags::last().styleSheet) {      
	      //   this.tags::last().styleSheet.cssText+= rule
	      // }
	      else {
	          if (rule.indexOf('@import') !== -1) {
	            var tag = last(this.tags);
	            tag.insertBefore(document.createTextNode(rule), tag.firstChild);
	          } else {
	            last(this.tags).appendChild(document.createTextNode(rule));
	          }
	        }
	    } else {
	      // server side is pretty simple         
	      this.sheet.insertRule(rule, rule.indexOf('@import') !== -1 ? 0 : this.sheet.cssRules.length);
	    }
	
	    this.ctr++;
	    if (isBrowser && this.ctr % this.maxLength === 0) {
	      this.tags.push(makeStyleTag());
	    }
	    return this.ctr - 1;
	  },
	
	  // commenting this out till we decide on v3's decision 
	  // _replace(index, rule) {
	  //   // this weirdness for perf, and chrome's weird bug 
	  //   // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
	  //   try {  
	  //     let sheet = this.getSheet()        
	  //     sheet.deleteRule(index) // todo - correct index here     
	  //     sheet.insertRule(rule, index)
	  //   }
	  //   catch(e) {
	  //     if(isDev) {
	  //       // might need beter dx for this 
	  //       console.warn('whoops, problem replacing rule', rule) //eslint-disable-line no-console
	  //     }          
	  //   }          
	
	  // }
	  // replace(index, rule) {
	  //   if(isBrowser) {
	  //     if(this.isSpeedy && this.getSheet().insertRule) {
	  //       this._replace(index, rule)
	  //     }
	  //     else {
	  //       let _slot = Math.floor((index  + this.maxLength) / this.maxLength) - 1        
	  //       let _index = (index % this.maxLength) + 1
	  //       let tag = this.tags[_slot]
	  //       tag.replaceChild(document.createTextNode(rule), tag.childNodes[_index])
	  //     }
	  //   }
	  //   else {
	  //     let rules = this.sheet.cssRules
	  //     this.sheet.cssRules = [ ...rules.slice(0, index), { cssText: rule }, ...rules.slice(index + 1) ]
	  //   }
	  // }
	  delete: function _delete(index) {
	    // we insert a blank rule when 'deleting' so previously returned indexes remain stable
	    return this.replace(index, '');
	  },
	  flush: function flush() {
	    if (isBrowser) {
	      this.tags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	      });
	      this.tags = [];
	      this.sheet = null;
	      this.ctr = 0;
	      // todo - look for remnants in document.styleSheets
	    } else {
	      // simpler on server 
	      this.sheet.cssRules = [];
	    }
	    this.injected = false;
	  },
	  rules: function rules() {
	    if (!isBrowser) {
	      return this.sheet.cssRules;
	    }
	    var arr = [];
	    this.tags.forEach(function (tag) {
	      return arr.splice.apply(arr, [arr.length, 0].concat(_toConsumableArray(Array.from(sheetForTag(tag).cssRules))));
	    });
	    return arr;
	  }
	});

/***/ },
/* 1774 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// @flow
	'use strict';
	
	var key = '__global_unique_id__';
	
	module.exports = function() {
	  return global[key] = (global[key] || 0) + 1;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1775 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/he v1.1.1 by @mathias | MIT license */
	;(function(root) {
	
		// Detect free variables `exports`.
		var freeExports = typeof exports == 'object' && exports;
	
		// Detect free variable `module`.
		var freeModule = typeof module == 'object' && module &&
			module.exports == freeExports && module;
	
		// Detect free variable `global`, from Node.js or Browserified code,
		// and use it as `root`.
		var freeGlobal = typeof global == 'object' && global;
		if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
			root = freeGlobal;
		}
	
		/*--------------------------------------------------------------------------*/
	
		// All astral symbols.
		var regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
		// All ASCII symbols (not just printable ASCII) except those listed in the
		// first column of the overrides table.
		// https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides
		var regexAsciiWhitelist = /[\x01-\x7F]/g;
		// All BMP symbols that are not ASCII newlines, printable ASCII symbols, or
		// code points listed in the first column of the overrides table on
		// https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides.
		var regexBmpWhitelist = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;
	
		var regexEncodeNonAscii = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g;
		var encodeMap = {'\xAD':'shy','\u200C':'zwnj','\u200D':'zwj','\u200E':'lrm','\u2063':'ic','\u2062':'it','\u2061':'af','\u200F':'rlm','\u200B':'ZeroWidthSpace','\u2060':'NoBreak','\u0311':'DownBreve','\u20DB':'tdot','\u20DC':'DotDot','\t':'Tab','\n':'NewLine','\u2008':'puncsp','\u205F':'MediumSpace','\u2009':'thinsp','\u200A':'hairsp','\u2004':'emsp13','\u2002':'ensp','\u2005':'emsp14','\u2003':'emsp','\u2007':'numsp','\xA0':'nbsp','\u205F\u200A':'ThickSpace','\u203E':'oline','_':'lowbar','\u2010':'dash','\u2013':'ndash','\u2014':'mdash','\u2015':'horbar',',':'comma',';':'semi','\u204F':'bsemi',':':'colon','\u2A74':'Colone','!':'excl','\xA1':'iexcl','?':'quest','\xBF':'iquest','.':'period','\u2025':'nldr','\u2026':'mldr','\xB7':'middot','\'':'apos','\u2018':'lsquo','\u2019':'rsquo','\u201A':'sbquo','\u2039':'lsaquo','\u203A':'rsaquo','"':'quot','\u201C':'ldquo','\u201D':'rdquo','\u201E':'bdquo','\xAB':'laquo','\xBB':'raquo','(':'lpar',')':'rpar','[':'lsqb',']':'rsqb','{':'lcub','}':'rcub','\u2308':'lceil','\u2309':'rceil','\u230A':'lfloor','\u230B':'rfloor','\u2985':'lopar','\u2986':'ropar','\u298B':'lbrke','\u298C':'rbrke','\u298D':'lbrkslu','\u298E':'rbrksld','\u298F':'lbrksld','\u2990':'rbrkslu','\u2991':'langd','\u2992':'rangd','\u2993':'lparlt','\u2994':'rpargt','\u2995':'gtlPar','\u2996':'ltrPar','\u27E6':'lobrk','\u27E7':'robrk','\u27E8':'lang','\u27E9':'rang','\u27EA':'Lang','\u27EB':'Rang','\u27EC':'loang','\u27ED':'roang','\u2772':'lbbrk','\u2773':'rbbrk','\u2016':'Vert','\xA7':'sect','\xB6':'para','@':'commat','*':'ast','/':'sol','undefined':null,'&':'amp','#':'num','%':'percnt','\u2030':'permil','\u2031':'pertenk','\u2020':'dagger','\u2021':'Dagger','\u2022':'bull','\u2043':'hybull','\u2032':'prime','\u2033':'Prime','\u2034':'tprime','\u2057':'qprime','\u2035':'bprime','\u2041':'caret','`':'grave','\xB4':'acute','\u02DC':'tilde','^':'Hat','\xAF':'macr','\u02D8':'breve','\u02D9':'dot','\xA8':'die','\u02DA':'ring','\u02DD':'dblac','\xB8':'cedil','\u02DB':'ogon','\u02C6':'circ','\u02C7':'caron','\xB0':'deg','\xA9':'copy','\xAE':'reg','\u2117':'copysr','\u2118':'wp','\u211E':'rx','\u2127':'mho','\u2129':'iiota','\u2190':'larr','\u219A':'nlarr','\u2192':'rarr','\u219B':'nrarr','\u2191':'uarr','\u2193':'darr','\u2194':'harr','\u21AE':'nharr','\u2195':'varr','\u2196':'nwarr','\u2197':'nearr','\u2198':'searr','\u2199':'swarr','\u219D':'rarrw','\u219D\u0338':'nrarrw','\u219E':'Larr','\u219F':'Uarr','\u21A0':'Rarr','\u21A1':'Darr','\u21A2':'larrtl','\u21A3':'rarrtl','\u21A4':'mapstoleft','\u21A5':'mapstoup','\u21A6':'map','\u21A7':'mapstodown','\u21A9':'larrhk','\u21AA':'rarrhk','\u21AB':'larrlp','\u21AC':'rarrlp','\u21AD':'harrw','\u21B0':'lsh','\u21B1':'rsh','\u21B2':'ldsh','\u21B3':'rdsh','\u21B5':'crarr','\u21B6':'cularr','\u21B7':'curarr','\u21BA':'olarr','\u21BB':'orarr','\u21BC':'lharu','\u21BD':'lhard','\u21BE':'uharr','\u21BF':'uharl','\u21C0':'rharu','\u21C1':'rhard','\u21C2':'dharr','\u21C3':'dharl','\u21C4':'rlarr','\u21C5':'udarr','\u21C6':'lrarr','\u21C7':'llarr','\u21C8':'uuarr','\u21C9':'rrarr','\u21CA':'ddarr','\u21CB':'lrhar','\u21CC':'rlhar','\u21D0':'lArr','\u21CD':'nlArr','\u21D1':'uArr','\u21D2':'rArr','\u21CF':'nrArr','\u21D3':'dArr','\u21D4':'iff','\u21CE':'nhArr','\u21D5':'vArr','\u21D6':'nwArr','\u21D7':'neArr','\u21D8':'seArr','\u21D9':'swArr','\u21DA':'lAarr','\u21DB':'rAarr','\u21DD':'zigrarr','\u21E4':'larrb','\u21E5':'rarrb','\u21F5':'duarr','\u21FD':'loarr','\u21FE':'roarr','\u21FF':'hoarr','\u2200':'forall','\u2201':'comp','\u2202':'part','\u2202\u0338':'npart','\u2203':'exist','\u2204':'nexist','\u2205':'empty','\u2207':'Del','\u2208':'in','\u2209':'notin','\u220B':'ni','\u220C':'notni','\u03F6':'bepsi','\u220F':'prod','\u2210':'coprod','\u2211':'sum','+':'plus','\xB1':'pm','\xF7':'div','\xD7':'times','<':'lt','\u226E':'nlt','<\u20D2':'nvlt','=':'equals','\u2260':'ne','=\u20E5':'bne','\u2A75':'Equal','>':'gt','\u226F':'ngt','>\u20D2':'nvgt','\xAC':'not','|':'vert','\xA6':'brvbar','\u2212':'minus','\u2213':'mp','\u2214':'plusdo','\u2044':'frasl','\u2216':'setmn','\u2217':'lowast','\u2218':'compfn','\u221A':'Sqrt','\u221D':'prop','\u221E':'infin','\u221F':'angrt','\u2220':'ang','\u2220\u20D2':'nang','\u2221':'angmsd','\u2222':'angsph','\u2223':'mid','\u2224':'nmid','\u2225':'par','\u2226':'npar','\u2227':'and','\u2228':'or','\u2229':'cap','\u2229\uFE00':'caps','\u222A':'cup','\u222A\uFE00':'cups','\u222B':'int','\u222C':'Int','\u222D':'tint','\u2A0C':'qint','\u222E':'oint','\u222F':'Conint','\u2230':'Cconint','\u2231':'cwint','\u2232':'cwconint','\u2233':'awconint','\u2234':'there4','\u2235':'becaus','\u2236':'ratio','\u2237':'Colon','\u2238':'minusd','\u223A':'mDDot','\u223B':'homtht','\u223C':'sim','\u2241':'nsim','\u223C\u20D2':'nvsim','\u223D':'bsim','\u223D\u0331':'race','\u223E':'ac','\u223E\u0333':'acE','\u223F':'acd','\u2240':'wr','\u2242':'esim','\u2242\u0338':'nesim','\u2243':'sime','\u2244':'nsime','\u2245':'cong','\u2247':'ncong','\u2246':'simne','\u2248':'ap','\u2249':'nap','\u224A':'ape','\u224B':'apid','\u224B\u0338':'napid','\u224C':'bcong','\u224D':'CupCap','\u226D':'NotCupCap','\u224D\u20D2':'nvap','\u224E':'bump','\u224E\u0338':'nbump','\u224F':'bumpe','\u224F\u0338':'nbumpe','\u2250':'doteq','\u2250\u0338':'nedot','\u2251':'eDot','\u2252':'efDot','\u2253':'erDot','\u2254':'colone','\u2255':'ecolon','\u2256':'ecir','\u2257':'cire','\u2259':'wedgeq','\u225A':'veeeq','\u225C':'trie','\u225F':'equest','\u2261':'equiv','\u2262':'nequiv','\u2261\u20E5':'bnequiv','\u2264':'le','\u2270':'nle','\u2264\u20D2':'nvle','\u2265':'ge','\u2271':'nge','\u2265\u20D2':'nvge','\u2266':'lE','\u2266\u0338':'nlE','\u2267':'gE','\u2267\u0338':'ngE','\u2268\uFE00':'lvnE','\u2268':'lnE','\u2269':'gnE','\u2269\uFE00':'gvnE','\u226A':'ll','\u226A\u0338':'nLtv','\u226A\u20D2':'nLt','\u226B':'gg','\u226B\u0338':'nGtv','\u226B\u20D2':'nGt','\u226C':'twixt','\u2272':'lsim','\u2274':'nlsim','\u2273':'gsim','\u2275':'ngsim','\u2276':'lg','\u2278':'ntlg','\u2277':'gl','\u2279':'ntgl','\u227A':'pr','\u2280':'npr','\u227B':'sc','\u2281':'nsc','\u227C':'prcue','\u22E0':'nprcue','\u227D':'sccue','\u22E1':'nsccue','\u227E':'prsim','\u227F':'scsim','\u227F\u0338':'NotSucceedsTilde','\u2282':'sub','\u2284':'nsub','\u2282\u20D2':'vnsub','\u2283':'sup','\u2285':'nsup','\u2283\u20D2':'vnsup','\u2286':'sube','\u2288':'nsube','\u2287':'supe','\u2289':'nsupe','\u228A\uFE00':'vsubne','\u228A':'subne','\u228B\uFE00':'vsupne','\u228B':'supne','\u228D':'cupdot','\u228E':'uplus','\u228F':'sqsub','\u228F\u0338':'NotSquareSubset','\u2290':'sqsup','\u2290\u0338':'NotSquareSuperset','\u2291':'sqsube','\u22E2':'nsqsube','\u2292':'sqsupe','\u22E3':'nsqsupe','\u2293':'sqcap','\u2293\uFE00':'sqcaps','\u2294':'sqcup','\u2294\uFE00':'sqcups','\u2295':'oplus','\u2296':'ominus','\u2297':'otimes','\u2298':'osol','\u2299':'odot','\u229A':'ocir','\u229B':'oast','\u229D':'odash','\u229E':'plusb','\u229F':'minusb','\u22A0':'timesb','\u22A1':'sdotb','\u22A2':'vdash','\u22AC':'nvdash','\u22A3':'dashv','\u22A4':'top','\u22A5':'bot','\u22A7':'models','\u22A8':'vDash','\u22AD':'nvDash','\u22A9':'Vdash','\u22AE':'nVdash','\u22AA':'Vvdash','\u22AB':'VDash','\u22AF':'nVDash','\u22B0':'prurel','\u22B2':'vltri','\u22EA':'nltri','\u22B3':'vrtri','\u22EB':'nrtri','\u22B4':'ltrie','\u22EC':'nltrie','\u22B4\u20D2':'nvltrie','\u22B5':'rtrie','\u22ED':'nrtrie','\u22B5\u20D2':'nvrtrie','\u22B6':'origof','\u22B7':'imof','\u22B8':'mumap','\u22B9':'hercon','\u22BA':'intcal','\u22BB':'veebar','\u22BD':'barvee','\u22BE':'angrtvb','\u22BF':'lrtri','\u22C0':'Wedge','\u22C1':'Vee','\u22C2':'xcap','\u22C3':'xcup','\u22C4':'diam','\u22C5':'sdot','\u22C6':'Star','\u22C7':'divonx','\u22C8':'bowtie','\u22C9':'ltimes','\u22CA':'rtimes','\u22CB':'lthree','\u22CC':'rthree','\u22CD':'bsime','\u22CE':'cuvee','\u22CF':'cuwed','\u22D0':'Sub','\u22D1':'Sup','\u22D2':'Cap','\u22D3':'Cup','\u22D4':'fork','\u22D5':'epar','\u22D6':'ltdot','\u22D7':'gtdot','\u22D8':'Ll','\u22D8\u0338':'nLl','\u22D9':'Gg','\u22D9\u0338':'nGg','\u22DA\uFE00':'lesg','\u22DA':'leg','\u22DB':'gel','\u22DB\uFE00':'gesl','\u22DE':'cuepr','\u22DF':'cuesc','\u22E6':'lnsim','\u22E7':'gnsim','\u22E8':'prnsim','\u22E9':'scnsim','\u22EE':'vellip','\u22EF':'ctdot','\u22F0':'utdot','\u22F1':'dtdot','\u22F2':'disin','\u22F3':'isinsv','\u22F4':'isins','\u22F5':'isindot','\u22F5\u0338':'notindot','\u22F6':'notinvc','\u22F7':'notinvb','\u22F9':'isinE','\u22F9\u0338':'notinE','\u22FA':'nisd','\u22FB':'xnis','\u22FC':'nis','\u22FD':'notnivc','\u22FE':'notnivb','\u2305':'barwed','\u2306':'Barwed','\u230C':'drcrop','\u230D':'dlcrop','\u230E':'urcrop','\u230F':'ulcrop','\u2310':'bnot','\u2312':'profline','\u2313':'profsurf','\u2315':'telrec','\u2316':'target','\u231C':'ulcorn','\u231D':'urcorn','\u231E':'dlcorn','\u231F':'drcorn','\u2322':'frown','\u2323':'smile','\u232D':'cylcty','\u232E':'profalar','\u2336':'topbot','\u233D':'ovbar','\u233F':'solbar','\u237C':'angzarr','\u23B0':'lmoust','\u23B1':'rmoust','\u23B4':'tbrk','\u23B5':'bbrk','\u23B6':'bbrktbrk','\u23DC':'OverParenthesis','\u23DD':'UnderParenthesis','\u23DE':'OverBrace','\u23DF':'UnderBrace','\u23E2':'trpezium','\u23E7':'elinters','\u2423':'blank','\u2500':'boxh','\u2502':'boxv','\u250C':'boxdr','\u2510':'boxdl','\u2514':'boxur','\u2518':'boxul','\u251C':'boxvr','\u2524':'boxvl','\u252C':'boxhd','\u2534':'boxhu','\u253C':'boxvh','\u2550':'boxH','\u2551':'boxV','\u2552':'boxdR','\u2553':'boxDr','\u2554':'boxDR','\u2555':'boxdL','\u2556':'boxDl','\u2557':'boxDL','\u2558':'boxuR','\u2559':'boxUr','\u255A':'boxUR','\u255B':'boxuL','\u255C':'boxUl','\u255D':'boxUL','\u255E':'boxvR','\u255F':'boxVr','\u2560':'boxVR','\u2561':'boxvL','\u2562':'boxVl','\u2563':'boxVL','\u2564':'boxHd','\u2565':'boxhD','\u2566':'boxHD','\u2567':'boxHu','\u2568':'boxhU','\u2569':'boxHU','\u256A':'boxvH','\u256B':'boxVh','\u256C':'boxVH','\u2580':'uhblk','\u2584':'lhblk','\u2588':'block','\u2591':'blk14','\u2592':'blk12','\u2593':'blk34','\u25A1':'squ','\u25AA':'squf','\u25AB':'EmptyVerySmallSquare','\u25AD':'rect','\u25AE':'marker','\u25B1':'fltns','\u25B3':'xutri','\u25B4':'utrif','\u25B5':'utri','\u25B8':'rtrif','\u25B9':'rtri','\u25BD':'xdtri','\u25BE':'dtrif','\u25BF':'dtri','\u25C2':'ltrif','\u25C3':'ltri','\u25CA':'loz','\u25CB':'cir','\u25EC':'tridot','\u25EF':'xcirc','\u25F8':'ultri','\u25F9':'urtri','\u25FA':'lltri','\u25FB':'EmptySmallSquare','\u25FC':'FilledSmallSquare','\u2605':'starf','\u2606':'star','\u260E':'phone','\u2640':'female','\u2642':'male','\u2660':'spades','\u2663':'clubs','\u2665':'hearts','\u2666':'diams','\u266A':'sung','\u2713':'check','\u2717':'cross','\u2720':'malt','\u2736':'sext','\u2758':'VerticalSeparator','\u27C8':'bsolhsub','\u27C9':'suphsol','\u27F5':'xlarr','\u27F6':'xrarr','\u27F7':'xharr','\u27F8':'xlArr','\u27F9':'xrArr','\u27FA':'xhArr','\u27FC':'xmap','\u27FF':'dzigrarr','\u2902':'nvlArr','\u2903':'nvrArr','\u2904':'nvHarr','\u2905':'Map','\u290C':'lbarr','\u290D':'rbarr','\u290E':'lBarr','\u290F':'rBarr','\u2910':'RBarr','\u2911':'DDotrahd','\u2912':'UpArrowBar','\u2913':'DownArrowBar','\u2916':'Rarrtl','\u2919':'latail','\u291A':'ratail','\u291B':'lAtail','\u291C':'rAtail','\u291D':'larrfs','\u291E':'rarrfs','\u291F':'larrbfs','\u2920':'rarrbfs','\u2923':'nwarhk','\u2924':'nearhk','\u2925':'searhk','\u2926':'swarhk','\u2927':'nwnear','\u2928':'toea','\u2929':'tosa','\u292A':'swnwar','\u2933':'rarrc','\u2933\u0338':'nrarrc','\u2935':'cudarrr','\u2936':'ldca','\u2937':'rdca','\u2938':'cudarrl','\u2939':'larrpl','\u293C':'curarrm','\u293D':'cularrp','\u2945':'rarrpl','\u2948':'harrcir','\u2949':'Uarrocir','\u294A':'lurdshar','\u294B':'ldrushar','\u294E':'LeftRightVector','\u294F':'RightUpDownVector','\u2950':'DownLeftRightVector','\u2951':'LeftUpDownVector','\u2952':'LeftVectorBar','\u2953':'RightVectorBar','\u2954':'RightUpVectorBar','\u2955':'RightDownVectorBar','\u2956':'DownLeftVectorBar','\u2957':'DownRightVectorBar','\u2958':'LeftUpVectorBar','\u2959':'LeftDownVectorBar','\u295A':'LeftTeeVector','\u295B':'RightTeeVector','\u295C':'RightUpTeeVector','\u295D':'RightDownTeeVector','\u295E':'DownLeftTeeVector','\u295F':'DownRightTeeVector','\u2960':'LeftUpTeeVector','\u2961':'LeftDownTeeVector','\u2962':'lHar','\u2963':'uHar','\u2964':'rHar','\u2965':'dHar','\u2966':'luruhar','\u2967':'ldrdhar','\u2968':'ruluhar','\u2969':'rdldhar','\u296A':'lharul','\u296B':'llhard','\u296C':'rharul','\u296D':'lrhard','\u296E':'udhar','\u296F':'duhar','\u2970':'RoundImplies','\u2971':'erarr','\u2972':'simrarr','\u2973':'larrsim','\u2974':'rarrsim','\u2975':'rarrap','\u2976':'ltlarr','\u2978':'gtrarr','\u2979':'subrarr','\u297B':'suplarr','\u297C':'lfisht','\u297D':'rfisht','\u297E':'ufisht','\u297F':'dfisht','\u299A':'vzigzag','\u299C':'vangrt','\u299D':'angrtvbd','\u29A4':'ange','\u29A5':'range','\u29A6':'dwangle','\u29A7':'uwangle','\u29A8':'angmsdaa','\u29A9':'angmsdab','\u29AA':'angmsdac','\u29AB':'angmsdad','\u29AC':'angmsdae','\u29AD':'angmsdaf','\u29AE':'angmsdag','\u29AF':'angmsdah','\u29B0':'bemptyv','\u29B1':'demptyv','\u29B2':'cemptyv','\u29B3':'raemptyv','\u29B4':'laemptyv','\u29B5':'ohbar','\u29B6':'omid','\u29B7':'opar','\u29B9':'operp','\u29BB':'olcross','\u29BC':'odsold','\u29BE':'olcir','\u29BF':'ofcir','\u29C0':'olt','\u29C1':'ogt','\u29C2':'cirscir','\u29C3':'cirE','\u29C4':'solb','\u29C5':'bsolb','\u29C9':'boxbox','\u29CD':'trisb','\u29CE':'rtriltri','\u29CF':'LeftTriangleBar','\u29CF\u0338':'NotLeftTriangleBar','\u29D0':'RightTriangleBar','\u29D0\u0338':'NotRightTriangleBar','\u29DC':'iinfin','\u29DD':'infintie','\u29DE':'nvinfin','\u29E3':'eparsl','\u29E4':'smeparsl','\u29E5':'eqvparsl','\u29EB':'lozf','\u29F4':'RuleDelayed','\u29F6':'dsol','\u2A00':'xodot','\u2A01':'xoplus','\u2A02':'xotime','\u2A04':'xuplus','\u2A06':'xsqcup','\u2A0D':'fpartint','\u2A10':'cirfnint','\u2A11':'awint','\u2A12':'rppolint','\u2A13':'scpolint','\u2A14':'npolint','\u2A15':'pointint','\u2A16':'quatint','\u2A17':'intlarhk','\u2A22':'pluscir','\u2A23':'plusacir','\u2A24':'simplus','\u2A25':'plusdu','\u2A26':'plussim','\u2A27':'plustwo','\u2A29':'mcomma','\u2A2A':'minusdu','\u2A2D':'loplus','\u2A2E':'roplus','\u2A2F':'Cross','\u2A30':'timesd','\u2A31':'timesbar','\u2A33':'smashp','\u2A34':'lotimes','\u2A35':'rotimes','\u2A36':'otimesas','\u2A37':'Otimes','\u2A38':'odiv','\u2A39':'triplus','\u2A3A':'triminus','\u2A3B':'tritime','\u2A3C':'iprod','\u2A3F':'amalg','\u2A40':'capdot','\u2A42':'ncup','\u2A43':'ncap','\u2A44':'capand','\u2A45':'cupor','\u2A46':'cupcap','\u2A47':'capcup','\u2A48':'cupbrcap','\u2A49':'capbrcup','\u2A4A':'cupcup','\u2A4B':'capcap','\u2A4C':'ccups','\u2A4D':'ccaps','\u2A50':'ccupssm','\u2A53':'And','\u2A54':'Or','\u2A55':'andand','\u2A56':'oror','\u2A57':'orslope','\u2A58':'andslope','\u2A5A':'andv','\u2A5B':'orv','\u2A5C':'andd','\u2A5D':'ord','\u2A5F':'wedbar','\u2A66':'sdote','\u2A6A':'simdot','\u2A6D':'congdot','\u2A6D\u0338':'ncongdot','\u2A6E':'easter','\u2A6F':'apacir','\u2A70':'apE','\u2A70\u0338':'napE','\u2A71':'eplus','\u2A72':'pluse','\u2A73':'Esim','\u2A77':'eDDot','\u2A78':'equivDD','\u2A79':'ltcir','\u2A7A':'gtcir','\u2A7B':'ltquest','\u2A7C':'gtquest','\u2A7D':'les','\u2A7D\u0338':'nles','\u2A7E':'ges','\u2A7E\u0338':'nges','\u2A7F':'lesdot','\u2A80':'gesdot','\u2A81':'lesdoto','\u2A82':'gesdoto','\u2A83':'lesdotor','\u2A84':'gesdotol','\u2A85':'lap','\u2A86':'gap','\u2A87':'lne','\u2A88':'gne','\u2A89':'lnap','\u2A8A':'gnap','\u2A8B':'lEg','\u2A8C':'gEl','\u2A8D':'lsime','\u2A8E':'gsime','\u2A8F':'lsimg','\u2A90':'gsiml','\u2A91':'lgE','\u2A92':'glE','\u2A93':'lesges','\u2A94':'gesles','\u2A95':'els','\u2A96':'egs','\u2A97':'elsdot','\u2A98':'egsdot','\u2A99':'el','\u2A9A':'eg','\u2A9D':'siml','\u2A9E':'simg','\u2A9F':'simlE','\u2AA0':'simgE','\u2AA1':'LessLess','\u2AA1\u0338':'NotNestedLessLess','\u2AA2':'GreaterGreater','\u2AA2\u0338':'NotNestedGreaterGreater','\u2AA4':'glj','\u2AA5':'gla','\u2AA6':'ltcc','\u2AA7':'gtcc','\u2AA8':'lescc','\u2AA9':'gescc','\u2AAA':'smt','\u2AAB':'lat','\u2AAC':'smte','\u2AAC\uFE00':'smtes','\u2AAD':'late','\u2AAD\uFE00':'lates','\u2AAE':'bumpE','\u2AAF':'pre','\u2AAF\u0338':'npre','\u2AB0':'sce','\u2AB0\u0338':'nsce','\u2AB3':'prE','\u2AB4':'scE','\u2AB5':'prnE','\u2AB6':'scnE','\u2AB7':'prap','\u2AB8':'scap','\u2AB9':'prnap','\u2ABA':'scnap','\u2ABB':'Pr','\u2ABC':'Sc','\u2ABD':'subdot','\u2ABE':'supdot','\u2ABF':'subplus','\u2AC0':'supplus','\u2AC1':'submult','\u2AC2':'supmult','\u2AC3':'subedot','\u2AC4':'supedot','\u2AC5':'subE','\u2AC5\u0338':'nsubE','\u2AC6':'supE','\u2AC6\u0338':'nsupE','\u2AC7':'subsim','\u2AC8':'supsim','\u2ACB\uFE00':'vsubnE','\u2ACB':'subnE','\u2ACC\uFE00':'vsupnE','\u2ACC':'supnE','\u2ACF':'csub','\u2AD0':'csup','\u2AD1':'csube','\u2AD2':'csupe','\u2AD3':'subsup','\u2AD4':'supsub','\u2AD5':'subsub','\u2AD6':'supsup','\u2AD7':'suphsub','\u2AD8':'supdsub','\u2AD9':'forkv','\u2ADA':'topfork','\u2ADB':'mlcp','\u2AE4':'Dashv','\u2AE6':'Vdashl','\u2AE7':'Barv','\u2AE8':'vBar','\u2AE9':'vBarv','\u2AEB':'Vbar','\u2AEC':'Not','\u2AED':'bNot','\u2AEE':'rnmid','\u2AEF':'cirmid','\u2AF0':'midcir','\u2AF1':'topcir','\u2AF2':'nhpar','\u2AF3':'parsim','\u2AFD':'parsl','\u2AFD\u20E5':'nparsl','\u266D':'flat','\u266E':'natur','\u266F':'sharp','\xA4':'curren','\xA2':'cent','$':'dollar','\xA3':'pound','\xA5':'yen','\u20AC':'euro','\xB9':'sup1','\xBD':'half','\u2153':'frac13','\xBC':'frac14','\u2155':'frac15','\u2159':'frac16','\u215B':'frac18','\xB2':'sup2','\u2154':'frac23','\u2156':'frac25','\xB3':'sup3','\xBE':'frac34','\u2157':'frac35','\u215C':'frac38','\u2158':'frac45','\u215A':'frac56','\u215D':'frac58','\u215E':'frac78','\uD835\uDCB6':'ascr','\uD835\uDD52':'aopf','\uD835\uDD1E':'afr','\uD835\uDD38':'Aopf','\uD835\uDD04':'Afr','\uD835\uDC9C':'Ascr','\xAA':'ordf','\xE1':'aacute','\xC1':'Aacute','\xE0':'agrave','\xC0':'Agrave','\u0103':'abreve','\u0102':'Abreve','\xE2':'acirc','\xC2':'Acirc','\xE5':'aring','\xC5':'angst','\xE4':'auml','\xC4':'Auml','\xE3':'atilde','\xC3':'Atilde','\u0105':'aogon','\u0104':'Aogon','\u0101':'amacr','\u0100':'Amacr','\xE6':'aelig','\xC6':'AElig','\uD835\uDCB7':'bscr','\uD835\uDD53':'bopf','\uD835\uDD1F':'bfr','\uD835\uDD39':'Bopf','\u212C':'Bscr','\uD835\uDD05':'Bfr','\uD835\uDD20':'cfr','\uD835\uDCB8':'cscr','\uD835\uDD54':'copf','\u212D':'Cfr','\uD835\uDC9E':'Cscr','\u2102':'Copf','\u0107':'cacute','\u0106':'Cacute','\u0109':'ccirc','\u0108':'Ccirc','\u010D':'ccaron','\u010C':'Ccaron','\u010B':'cdot','\u010A':'Cdot','\xE7':'ccedil','\xC7':'Ccedil','\u2105':'incare','\uD835\uDD21':'dfr','\u2146':'dd','\uD835\uDD55':'dopf','\uD835\uDCB9':'dscr','\uD835\uDC9F':'Dscr','\uD835\uDD07':'Dfr','\u2145':'DD','\uD835\uDD3B':'Dopf','\u010F':'dcaron','\u010E':'Dcaron','\u0111':'dstrok','\u0110':'Dstrok','\xF0':'eth','\xD0':'ETH','\u2147':'ee','\u212F':'escr','\uD835\uDD22':'efr','\uD835\uDD56':'eopf','\u2130':'Escr','\uD835\uDD08':'Efr','\uD835\uDD3C':'Eopf','\xE9':'eacute','\xC9':'Eacute','\xE8':'egrave','\xC8':'Egrave','\xEA':'ecirc','\xCA':'Ecirc','\u011B':'ecaron','\u011A':'Ecaron','\xEB':'euml','\xCB':'Euml','\u0117':'edot','\u0116':'Edot','\u0119':'eogon','\u0118':'Eogon','\u0113':'emacr','\u0112':'Emacr','\uD835\uDD23':'ffr','\uD835\uDD57':'fopf','\uD835\uDCBB':'fscr','\uD835\uDD09':'Ffr','\uD835\uDD3D':'Fopf','\u2131':'Fscr','\uFB00':'fflig','\uFB03':'ffilig','\uFB04':'ffllig','\uFB01':'filig','fj':'fjlig','\uFB02':'fllig','\u0192':'fnof','\u210A':'gscr','\uD835\uDD58':'gopf','\uD835\uDD24':'gfr','\uD835\uDCA2':'Gscr','\uD835\uDD3E':'Gopf','\uD835\uDD0A':'Gfr','\u01F5':'gacute','\u011F':'gbreve','\u011E':'Gbreve','\u011D':'gcirc','\u011C':'Gcirc','\u0121':'gdot','\u0120':'Gdot','\u0122':'Gcedil','\uD835\uDD25':'hfr','\u210E':'planckh','\uD835\uDCBD':'hscr','\uD835\uDD59':'hopf','\u210B':'Hscr','\u210C':'Hfr','\u210D':'Hopf','\u0125':'hcirc','\u0124':'Hcirc','\u210F':'hbar','\u0127':'hstrok','\u0126':'Hstrok','\uD835\uDD5A':'iopf','\uD835\uDD26':'ifr','\uD835\uDCBE':'iscr','\u2148':'ii','\uD835\uDD40':'Iopf','\u2110':'Iscr','\u2111':'Im','\xED':'iacute','\xCD':'Iacute','\xEC':'igrave','\xCC':'Igrave','\xEE':'icirc','\xCE':'Icirc','\xEF':'iuml','\xCF':'Iuml','\u0129':'itilde','\u0128':'Itilde','\u0130':'Idot','\u012F':'iogon','\u012E':'Iogon','\u012B':'imacr','\u012A':'Imacr','\u0133':'ijlig','\u0132':'IJlig','\u0131':'imath','\uD835\uDCBF':'jscr','\uD835\uDD5B':'jopf','\uD835\uDD27':'jfr','\uD835\uDCA5':'Jscr','\uD835\uDD0D':'Jfr','\uD835\uDD41':'Jopf','\u0135':'jcirc','\u0134':'Jcirc','\u0237':'jmath','\uD835\uDD5C':'kopf','\uD835\uDCC0':'kscr','\uD835\uDD28':'kfr','\uD835\uDCA6':'Kscr','\uD835\uDD42':'Kopf','\uD835\uDD0E':'Kfr','\u0137':'kcedil','\u0136':'Kcedil','\uD835\uDD29':'lfr','\uD835\uDCC1':'lscr','\u2113':'ell','\uD835\uDD5D':'lopf','\u2112':'Lscr','\uD835\uDD0F':'Lfr','\uD835\uDD43':'Lopf','\u013A':'lacute','\u0139':'Lacute','\u013E':'lcaron','\u013D':'Lcaron','\u013C':'lcedil','\u013B':'Lcedil','\u0142':'lstrok','\u0141':'Lstrok','\u0140':'lmidot','\u013F':'Lmidot','\uD835\uDD2A':'mfr','\uD835\uDD5E':'mopf','\uD835\uDCC2':'mscr','\uD835\uDD10':'Mfr','\uD835\uDD44':'Mopf','\u2133':'Mscr','\uD835\uDD2B':'nfr','\uD835\uDD5F':'nopf','\uD835\uDCC3':'nscr','\u2115':'Nopf','\uD835\uDCA9':'Nscr','\uD835\uDD11':'Nfr','\u0144':'nacute','\u0143':'Nacute','\u0148':'ncaron','\u0147':'Ncaron','\xF1':'ntilde','\xD1':'Ntilde','\u0146':'ncedil','\u0145':'Ncedil','\u2116':'numero','\u014B':'eng','\u014A':'ENG','\uD835\uDD60':'oopf','\uD835\uDD2C':'ofr','\u2134':'oscr','\uD835\uDCAA':'Oscr','\uD835\uDD12':'Ofr','\uD835\uDD46':'Oopf','\xBA':'ordm','\xF3':'oacute','\xD3':'Oacute','\xF2':'ograve','\xD2':'Ograve','\xF4':'ocirc','\xD4':'Ocirc','\xF6':'ouml','\xD6':'Ouml','\u0151':'odblac','\u0150':'Odblac','\xF5':'otilde','\xD5':'Otilde','\xF8':'oslash','\xD8':'Oslash','\u014D':'omacr','\u014C':'Omacr','\u0153':'oelig','\u0152':'OElig','\uD835\uDD2D':'pfr','\uD835\uDCC5':'pscr','\uD835\uDD61':'popf','\u2119':'Popf','\uD835\uDD13':'Pfr','\uD835\uDCAB':'Pscr','\uD835\uDD62':'qopf','\uD835\uDD2E':'qfr','\uD835\uDCC6':'qscr','\uD835\uDCAC':'Qscr','\uD835\uDD14':'Qfr','\u211A':'Qopf','\u0138':'kgreen','\uD835\uDD2F':'rfr','\uD835\uDD63':'ropf','\uD835\uDCC7':'rscr','\u211B':'Rscr','\u211C':'Re','\u211D':'Ropf','\u0155':'racute','\u0154':'Racute','\u0159':'rcaron','\u0158':'Rcaron','\u0157':'rcedil','\u0156':'Rcedil','\uD835\uDD64':'sopf','\uD835\uDCC8':'sscr','\uD835\uDD30':'sfr','\uD835\uDD4A':'Sopf','\uD835\uDD16':'Sfr','\uD835\uDCAE':'Sscr','\u24C8':'oS','\u015B':'sacute','\u015A':'Sacute','\u015D':'scirc','\u015C':'Scirc','\u0161':'scaron','\u0160':'Scaron','\u015F':'scedil','\u015E':'Scedil','\xDF':'szlig','\uD835\uDD31':'tfr','\uD835\uDCC9':'tscr','\uD835\uDD65':'topf','\uD835\uDCAF':'Tscr','\uD835\uDD17':'Tfr','\uD835\uDD4B':'Topf','\u0165':'tcaron','\u0164':'Tcaron','\u0163':'tcedil','\u0162':'Tcedil','\u2122':'trade','\u0167':'tstrok','\u0166':'Tstrok','\uD835\uDCCA':'uscr','\uD835\uDD66':'uopf','\uD835\uDD32':'ufr','\uD835\uDD4C':'Uopf','\uD835\uDD18':'Ufr','\uD835\uDCB0':'Uscr','\xFA':'uacute','\xDA':'Uacute','\xF9':'ugrave','\xD9':'Ugrave','\u016D':'ubreve','\u016C':'Ubreve','\xFB':'ucirc','\xDB':'Ucirc','\u016F':'uring','\u016E':'Uring','\xFC':'uuml','\xDC':'Uuml','\u0171':'udblac','\u0170':'Udblac','\u0169':'utilde','\u0168':'Utilde','\u0173':'uogon','\u0172':'Uogon','\u016B':'umacr','\u016A':'Umacr','\uD835\uDD33':'vfr','\uD835\uDD67':'vopf','\uD835\uDCCB':'vscr','\uD835\uDD19':'Vfr','\uD835\uDD4D':'Vopf','\uD835\uDCB1':'Vscr','\uD835\uDD68':'wopf','\uD835\uDCCC':'wscr','\uD835\uDD34':'wfr','\uD835\uDCB2':'Wscr','\uD835\uDD4E':'Wopf','\uD835\uDD1A':'Wfr','\u0175':'wcirc','\u0174':'Wcirc','\uD835\uDD35':'xfr','\uD835\uDCCD':'xscr','\uD835\uDD69':'xopf','\uD835\uDD4F':'Xopf','\uD835\uDD1B':'Xfr','\uD835\uDCB3':'Xscr','\uD835\uDD36':'yfr','\uD835\uDCCE':'yscr','\uD835\uDD6A':'yopf','\uD835\uDCB4':'Yscr','\uD835\uDD1C':'Yfr','\uD835\uDD50':'Yopf','\xFD':'yacute','\xDD':'Yacute','\u0177':'ycirc','\u0176':'Ycirc','\xFF':'yuml','\u0178':'Yuml','\uD835\uDCCF':'zscr','\uD835\uDD37':'zfr','\uD835\uDD6B':'zopf','\u2128':'Zfr','\u2124':'Zopf','\uD835\uDCB5':'Zscr','\u017A':'zacute','\u0179':'Zacute','\u017E':'zcaron','\u017D':'Zcaron','\u017C':'zdot','\u017B':'Zdot','\u01B5':'imped','\xFE':'thorn','\xDE':'THORN','\u0149':'napos','\u03B1':'alpha','\u0391':'Alpha','\u03B2':'beta','\u0392':'Beta','\u03B3':'gamma','\u0393':'Gamma','\u03B4':'delta','\u0394':'Delta','\u03B5':'epsi','\u03F5':'epsiv','\u0395':'Epsilon','\u03DD':'gammad','\u03DC':'Gammad','\u03B6':'zeta','\u0396':'Zeta','\u03B7':'eta','\u0397':'Eta','\u03B8':'theta','\u03D1':'thetav','\u0398':'Theta','\u03B9':'iota','\u0399':'Iota','\u03BA':'kappa','\u03F0':'kappav','\u039A':'Kappa','\u03BB':'lambda','\u039B':'Lambda','\u03BC':'mu','\xB5':'micro','\u039C':'Mu','\u03BD':'nu','\u039D':'Nu','\u03BE':'xi','\u039E':'Xi','\u03BF':'omicron','\u039F':'Omicron','\u03C0':'pi','\u03D6':'piv','\u03A0':'Pi','\u03C1':'rho','\u03F1':'rhov','\u03A1':'Rho','\u03C3':'sigma','\u03A3':'Sigma','\u03C2':'sigmaf','\u03C4':'tau','\u03A4':'Tau','\u03C5':'upsi','\u03A5':'Upsilon','\u03D2':'Upsi','\u03C6':'phi','\u03D5':'phiv','\u03A6':'Phi','\u03C7':'chi','\u03A7':'Chi','\u03C8':'psi','\u03A8':'Psi','\u03C9':'omega','\u03A9':'ohm','\u0430':'acy','\u0410':'Acy','\u0431':'bcy','\u0411':'Bcy','\u0432':'vcy','\u0412':'Vcy','\u0433':'gcy','\u0413':'Gcy','\u0453':'gjcy','\u0403':'GJcy','\u0434':'dcy','\u0414':'Dcy','\u0452':'djcy','\u0402':'DJcy','\u0435':'iecy','\u0415':'IEcy','\u0451':'iocy','\u0401':'IOcy','\u0454':'jukcy','\u0404':'Jukcy','\u0436':'zhcy','\u0416':'ZHcy','\u0437':'zcy','\u0417':'Zcy','\u0455':'dscy','\u0405':'DScy','\u0438':'icy','\u0418':'Icy','\u0456':'iukcy','\u0406':'Iukcy','\u0457':'yicy','\u0407':'YIcy','\u0439':'jcy','\u0419':'Jcy','\u0458':'jsercy','\u0408':'Jsercy','\u043A':'kcy','\u041A':'Kcy','\u045C':'kjcy','\u040C':'KJcy','\u043B':'lcy','\u041B':'Lcy','\u0459':'ljcy','\u0409':'LJcy','\u043C':'mcy','\u041C':'Mcy','\u043D':'ncy','\u041D':'Ncy','\u045A':'njcy','\u040A':'NJcy','\u043E':'ocy','\u041E':'Ocy','\u043F':'pcy','\u041F':'Pcy','\u0440':'rcy','\u0420':'Rcy','\u0441':'scy','\u0421':'Scy','\u0442':'tcy','\u0422':'Tcy','\u045B':'tshcy','\u040B':'TSHcy','\u0443':'ucy','\u0423':'Ucy','\u045E':'ubrcy','\u040E':'Ubrcy','\u0444':'fcy','\u0424':'Fcy','\u0445':'khcy','\u0425':'KHcy','\u0446':'tscy','\u0426':'TScy','\u0447':'chcy','\u0427':'CHcy','\u045F':'dzcy','\u040F':'DZcy','\u0448':'shcy','\u0428':'SHcy','\u0449':'shchcy','\u0429':'SHCHcy','\u044A':'hardcy','\u042A':'HARDcy','\u044B':'ycy','\u042B':'Ycy','\u044C':'softcy','\u042C':'SOFTcy','\u044D':'ecy','\u042D':'Ecy','\u044E':'yucy','\u042E':'YUcy','\u044F':'yacy','\u042F':'YAcy','\u2135':'aleph','\u2136':'beth','\u2137':'gimel','\u2138':'daleth'};
	
		var regexEscape = /["&'<>`]/g;
		var escapeMap = {
			'"': '&quot;',
			'&': '&amp;',
			'\'': '&#x27;',
			'<': '&lt;',
			// See https://mathiasbynens.be/notes/ambiguous-ampersands: in HTML, the
			// following is not strictly necessary unless it’s part of a tag or an
			// unquoted attribute value. We’re only escaping it to support those
			// situations, and for XML support.
			'>': '&gt;',
			// In Internet Explorer ≤ 8, the backtick character can be used
			// to break out of (un)quoted attribute values or HTML comments.
			// See http://html5sec.org/#102, http://html5sec.org/#108, and
			// http://html5sec.org/#133.
			'`': '&#x60;'
		};
	
		var regexInvalidEntity = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/;
		var regexInvalidRawCodePoint = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
		var regexDecode = /&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+);|&(Aacute|Agrave|Atilde|Ccedil|Eacute|Egrave|Iacute|Igrave|Ntilde|Oacute|Ograve|Oslash|Otilde|Uacute|Ugrave|Yacute|aacute|agrave|atilde|brvbar|ccedil|curren|divide|eacute|egrave|frac12|frac14|frac34|iacute|igrave|iquest|middot|ntilde|oacute|ograve|oslash|otilde|plusmn|uacute|ugrave|yacute|AElig|Acirc|Aring|Ecirc|Icirc|Ocirc|THORN|Ucirc|acirc|acute|aelig|aring|cedil|ecirc|icirc|iexcl|laquo|micro|ocirc|pound|raquo|szlig|thorn|times|ucirc|Auml|COPY|Euml|Iuml|Ouml|QUOT|Uuml|auml|cent|copy|euml|iuml|macr|nbsp|ordf|ordm|ouml|para|quot|sect|sup1|sup2|sup3|uuml|yuml|AMP|ETH|REG|amp|deg|eth|not|reg|shy|uml|yen|GT|LT|gt|lt)([=a-zA-Z0-9])?/g;
		var decodeMap = {'aacute':'\xE1','Aacute':'\xC1','abreve':'\u0103','Abreve':'\u0102','ac':'\u223E','acd':'\u223F','acE':'\u223E\u0333','acirc':'\xE2','Acirc':'\xC2','acute':'\xB4','acy':'\u0430','Acy':'\u0410','aelig':'\xE6','AElig':'\xC6','af':'\u2061','afr':'\uD835\uDD1E','Afr':'\uD835\uDD04','agrave':'\xE0','Agrave':'\xC0','alefsym':'\u2135','aleph':'\u2135','alpha':'\u03B1','Alpha':'\u0391','amacr':'\u0101','Amacr':'\u0100','amalg':'\u2A3F','amp':'&','AMP':'&','and':'\u2227','And':'\u2A53','andand':'\u2A55','andd':'\u2A5C','andslope':'\u2A58','andv':'\u2A5A','ang':'\u2220','ange':'\u29A4','angle':'\u2220','angmsd':'\u2221','angmsdaa':'\u29A8','angmsdab':'\u29A9','angmsdac':'\u29AA','angmsdad':'\u29AB','angmsdae':'\u29AC','angmsdaf':'\u29AD','angmsdag':'\u29AE','angmsdah':'\u29AF','angrt':'\u221F','angrtvb':'\u22BE','angrtvbd':'\u299D','angsph':'\u2222','angst':'\xC5','angzarr':'\u237C','aogon':'\u0105','Aogon':'\u0104','aopf':'\uD835\uDD52','Aopf':'\uD835\uDD38','ap':'\u2248','apacir':'\u2A6F','ape':'\u224A','apE':'\u2A70','apid':'\u224B','apos':'\'','ApplyFunction':'\u2061','approx':'\u2248','approxeq':'\u224A','aring':'\xE5','Aring':'\xC5','ascr':'\uD835\uDCB6','Ascr':'\uD835\uDC9C','Assign':'\u2254','ast':'*','asymp':'\u2248','asympeq':'\u224D','atilde':'\xE3','Atilde':'\xC3','auml':'\xE4','Auml':'\xC4','awconint':'\u2233','awint':'\u2A11','backcong':'\u224C','backepsilon':'\u03F6','backprime':'\u2035','backsim':'\u223D','backsimeq':'\u22CD','Backslash':'\u2216','Barv':'\u2AE7','barvee':'\u22BD','barwed':'\u2305','Barwed':'\u2306','barwedge':'\u2305','bbrk':'\u23B5','bbrktbrk':'\u23B6','bcong':'\u224C','bcy':'\u0431','Bcy':'\u0411','bdquo':'\u201E','becaus':'\u2235','because':'\u2235','Because':'\u2235','bemptyv':'\u29B0','bepsi':'\u03F6','bernou':'\u212C','Bernoullis':'\u212C','beta':'\u03B2','Beta':'\u0392','beth':'\u2136','between':'\u226C','bfr':'\uD835\uDD1F','Bfr':'\uD835\uDD05','bigcap':'\u22C2','bigcirc':'\u25EF','bigcup':'\u22C3','bigodot':'\u2A00','bigoplus':'\u2A01','bigotimes':'\u2A02','bigsqcup':'\u2A06','bigstar':'\u2605','bigtriangledown':'\u25BD','bigtriangleup':'\u25B3','biguplus':'\u2A04','bigvee':'\u22C1','bigwedge':'\u22C0','bkarow':'\u290D','blacklozenge':'\u29EB','blacksquare':'\u25AA','blacktriangle':'\u25B4','blacktriangledown':'\u25BE','blacktriangleleft':'\u25C2','blacktriangleright':'\u25B8','blank':'\u2423','blk12':'\u2592','blk14':'\u2591','blk34':'\u2593','block':'\u2588','bne':'=\u20E5','bnequiv':'\u2261\u20E5','bnot':'\u2310','bNot':'\u2AED','bopf':'\uD835\uDD53','Bopf':'\uD835\uDD39','bot':'\u22A5','bottom':'\u22A5','bowtie':'\u22C8','boxbox':'\u29C9','boxdl':'\u2510','boxdL':'\u2555','boxDl':'\u2556','boxDL':'\u2557','boxdr':'\u250C','boxdR':'\u2552','boxDr':'\u2553','boxDR':'\u2554','boxh':'\u2500','boxH':'\u2550','boxhd':'\u252C','boxhD':'\u2565','boxHd':'\u2564','boxHD':'\u2566','boxhu':'\u2534','boxhU':'\u2568','boxHu':'\u2567','boxHU':'\u2569','boxminus':'\u229F','boxplus':'\u229E','boxtimes':'\u22A0','boxul':'\u2518','boxuL':'\u255B','boxUl':'\u255C','boxUL':'\u255D','boxur':'\u2514','boxuR':'\u2558','boxUr':'\u2559','boxUR':'\u255A','boxv':'\u2502','boxV':'\u2551','boxvh':'\u253C','boxvH':'\u256A','boxVh':'\u256B','boxVH':'\u256C','boxvl':'\u2524','boxvL':'\u2561','boxVl':'\u2562','boxVL':'\u2563','boxvr':'\u251C','boxvR':'\u255E','boxVr':'\u255F','boxVR':'\u2560','bprime':'\u2035','breve':'\u02D8','Breve':'\u02D8','brvbar':'\xA6','bscr':'\uD835\uDCB7','Bscr':'\u212C','bsemi':'\u204F','bsim':'\u223D','bsime':'\u22CD','bsol':'\\','bsolb':'\u29C5','bsolhsub':'\u27C8','bull':'\u2022','bullet':'\u2022','bump':'\u224E','bumpe':'\u224F','bumpE':'\u2AAE','bumpeq':'\u224F','Bumpeq':'\u224E','cacute':'\u0107','Cacute':'\u0106','cap':'\u2229','Cap':'\u22D2','capand':'\u2A44','capbrcup':'\u2A49','capcap':'\u2A4B','capcup':'\u2A47','capdot':'\u2A40','CapitalDifferentialD':'\u2145','caps':'\u2229\uFE00','caret':'\u2041','caron':'\u02C7','Cayleys':'\u212D','ccaps':'\u2A4D','ccaron':'\u010D','Ccaron':'\u010C','ccedil':'\xE7','Ccedil':'\xC7','ccirc':'\u0109','Ccirc':'\u0108','Cconint':'\u2230','ccups':'\u2A4C','ccupssm':'\u2A50','cdot':'\u010B','Cdot':'\u010A','cedil':'\xB8','Cedilla':'\xB8','cemptyv':'\u29B2','cent':'\xA2','centerdot':'\xB7','CenterDot':'\xB7','cfr':'\uD835\uDD20','Cfr':'\u212D','chcy':'\u0447','CHcy':'\u0427','check':'\u2713','checkmark':'\u2713','chi':'\u03C7','Chi':'\u03A7','cir':'\u25CB','circ':'\u02C6','circeq':'\u2257','circlearrowleft':'\u21BA','circlearrowright':'\u21BB','circledast':'\u229B','circledcirc':'\u229A','circleddash':'\u229D','CircleDot':'\u2299','circledR':'\xAE','circledS':'\u24C8','CircleMinus':'\u2296','CirclePlus':'\u2295','CircleTimes':'\u2297','cire':'\u2257','cirE':'\u29C3','cirfnint':'\u2A10','cirmid':'\u2AEF','cirscir':'\u29C2','ClockwiseContourIntegral':'\u2232','CloseCurlyDoubleQuote':'\u201D','CloseCurlyQuote':'\u2019','clubs':'\u2663','clubsuit':'\u2663','colon':':','Colon':'\u2237','colone':'\u2254','Colone':'\u2A74','coloneq':'\u2254','comma':',','commat':'@','comp':'\u2201','compfn':'\u2218','complement':'\u2201','complexes':'\u2102','cong':'\u2245','congdot':'\u2A6D','Congruent':'\u2261','conint':'\u222E','Conint':'\u222F','ContourIntegral':'\u222E','copf':'\uD835\uDD54','Copf':'\u2102','coprod':'\u2210','Coproduct':'\u2210','copy':'\xA9','COPY':'\xA9','copysr':'\u2117','CounterClockwiseContourIntegral':'\u2233','crarr':'\u21B5','cross':'\u2717','Cross':'\u2A2F','cscr':'\uD835\uDCB8','Cscr':'\uD835\uDC9E','csub':'\u2ACF','csube':'\u2AD1','csup':'\u2AD0','csupe':'\u2AD2','ctdot':'\u22EF','cudarrl':'\u2938','cudarrr':'\u2935','cuepr':'\u22DE','cuesc':'\u22DF','cularr':'\u21B6','cularrp':'\u293D','cup':'\u222A','Cup':'\u22D3','cupbrcap':'\u2A48','cupcap':'\u2A46','CupCap':'\u224D','cupcup':'\u2A4A','cupdot':'\u228D','cupor':'\u2A45','cups':'\u222A\uFE00','curarr':'\u21B7','curarrm':'\u293C','curlyeqprec':'\u22DE','curlyeqsucc':'\u22DF','curlyvee':'\u22CE','curlywedge':'\u22CF','curren':'\xA4','curvearrowleft':'\u21B6','curvearrowright':'\u21B7','cuvee':'\u22CE','cuwed':'\u22CF','cwconint':'\u2232','cwint':'\u2231','cylcty':'\u232D','dagger':'\u2020','Dagger':'\u2021','daleth':'\u2138','darr':'\u2193','dArr':'\u21D3','Darr':'\u21A1','dash':'\u2010','dashv':'\u22A3','Dashv':'\u2AE4','dbkarow':'\u290F','dblac':'\u02DD','dcaron':'\u010F','Dcaron':'\u010E','dcy':'\u0434','Dcy':'\u0414','dd':'\u2146','DD':'\u2145','ddagger':'\u2021','ddarr':'\u21CA','DDotrahd':'\u2911','ddotseq':'\u2A77','deg':'\xB0','Del':'\u2207','delta':'\u03B4','Delta':'\u0394','demptyv':'\u29B1','dfisht':'\u297F','dfr':'\uD835\uDD21','Dfr':'\uD835\uDD07','dHar':'\u2965','dharl':'\u21C3','dharr':'\u21C2','DiacriticalAcute':'\xB4','DiacriticalDot':'\u02D9','DiacriticalDoubleAcute':'\u02DD','DiacriticalGrave':'`','DiacriticalTilde':'\u02DC','diam':'\u22C4','diamond':'\u22C4','Diamond':'\u22C4','diamondsuit':'\u2666','diams':'\u2666','die':'\xA8','DifferentialD':'\u2146','digamma':'\u03DD','disin':'\u22F2','div':'\xF7','divide':'\xF7','divideontimes':'\u22C7','divonx':'\u22C7','djcy':'\u0452','DJcy':'\u0402','dlcorn':'\u231E','dlcrop':'\u230D','dollar':'$','dopf':'\uD835\uDD55','Dopf':'\uD835\uDD3B','dot':'\u02D9','Dot':'\xA8','DotDot':'\u20DC','doteq':'\u2250','doteqdot':'\u2251','DotEqual':'\u2250','dotminus':'\u2238','dotplus':'\u2214','dotsquare':'\u22A1','doublebarwedge':'\u2306','DoubleContourIntegral':'\u222F','DoubleDot':'\xA8','DoubleDownArrow':'\u21D3','DoubleLeftArrow':'\u21D0','DoubleLeftRightArrow':'\u21D4','DoubleLeftTee':'\u2AE4','DoubleLongLeftArrow':'\u27F8','DoubleLongLeftRightArrow':'\u27FA','DoubleLongRightArrow':'\u27F9','DoubleRightArrow':'\u21D2','DoubleRightTee':'\u22A8','DoubleUpArrow':'\u21D1','DoubleUpDownArrow':'\u21D5','DoubleVerticalBar':'\u2225','downarrow':'\u2193','Downarrow':'\u21D3','DownArrow':'\u2193','DownArrowBar':'\u2913','DownArrowUpArrow':'\u21F5','DownBreve':'\u0311','downdownarrows':'\u21CA','downharpoonleft':'\u21C3','downharpoonright':'\u21C2','DownLeftRightVector':'\u2950','DownLeftTeeVector':'\u295E','DownLeftVector':'\u21BD','DownLeftVectorBar':'\u2956','DownRightTeeVector':'\u295F','DownRightVector':'\u21C1','DownRightVectorBar':'\u2957','DownTee':'\u22A4','DownTeeArrow':'\u21A7','drbkarow':'\u2910','drcorn':'\u231F','drcrop':'\u230C','dscr':'\uD835\uDCB9','Dscr':'\uD835\uDC9F','dscy':'\u0455','DScy':'\u0405','dsol':'\u29F6','dstrok':'\u0111','Dstrok':'\u0110','dtdot':'\u22F1','dtri':'\u25BF','dtrif':'\u25BE','duarr':'\u21F5','duhar':'\u296F','dwangle':'\u29A6','dzcy':'\u045F','DZcy':'\u040F','dzigrarr':'\u27FF','eacute':'\xE9','Eacute':'\xC9','easter':'\u2A6E','ecaron':'\u011B','Ecaron':'\u011A','ecir':'\u2256','ecirc':'\xEA','Ecirc':'\xCA','ecolon':'\u2255','ecy':'\u044D','Ecy':'\u042D','eDDot':'\u2A77','edot':'\u0117','eDot':'\u2251','Edot':'\u0116','ee':'\u2147','efDot':'\u2252','efr':'\uD835\uDD22','Efr':'\uD835\uDD08','eg':'\u2A9A','egrave':'\xE8','Egrave':'\xC8','egs':'\u2A96','egsdot':'\u2A98','el':'\u2A99','Element':'\u2208','elinters':'\u23E7','ell':'\u2113','els':'\u2A95','elsdot':'\u2A97','emacr':'\u0113','Emacr':'\u0112','empty':'\u2205','emptyset':'\u2205','EmptySmallSquare':'\u25FB','emptyv':'\u2205','EmptyVerySmallSquare':'\u25AB','emsp':'\u2003','emsp13':'\u2004','emsp14':'\u2005','eng':'\u014B','ENG':'\u014A','ensp':'\u2002','eogon':'\u0119','Eogon':'\u0118','eopf':'\uD835\uDD56','Eopf':'\uD835\uDD3C','epar':'\u22D5','eparsl':'\u29E3','eplus':'\u2A71','epsi':'\u03B5','epsilon':'\u03B5','Epsilon':'\u0395','epsiv':'\u03F5','eqcirc':'\u2256','eqcolon':'\u2255','eqsim':'\u2242','eqslantgtr':'\u2A96','eqslantless':'\u2A95','Equal':'\u2A75','equals':'=','EqualTilde':'\u2242','equest':'\u225F','Equilibrium':'\u21CC','equiv':'\u2261','equivDD':'\u2A78','eqvparsl':'\u29E5','erarr':'\u2971','erDot':'\u2253','escr':'\u212F','Escr':'\u2130','esdot':'\u2250','esim':'\u2242','Esim':'\u2A73','eta':'\u03B7','Eta':'\u0397','eth':'\xF0','ETH':'\xD0','euml':'\xEB','Euml':'\xCB','euro':'\u20AC','excl':'!','exist':'\u2203','Exists':'\u2203','expectation':'\u2130','exponentiale':'\u2147','ExponentialE':'\u2147','fallingdotseq':'\u2252','fcy':'\u0444','Fcy':'\u0424','female':'\u2640','ffilig':'\uFB03','fflig':'\uFB00','ffllig':'\uFB04','ffr':'\uD835\uDD23','Ffr':'\uD835\uDD09','filig':'\uFB01','FilledSmallSquare':'\u25FC','FilledVerySmallSquare':'\u25AA','fjlig':'fj','flat':'\u266D','fllig':'\uFB02','fltns':'\u25B1','fnof':'\u0192','fopf':'\uD835\uDD57','Fopf':'\uD835\uDD3D','forall':'\u2200','ForAll':'\u2200','fork':'\u22D4','forkv':'\u2AD9','Fouriertrf':'\u2131','fpartint':'\u2A0D','frac12':'\xBD','frac13':'\u2153','frac14':'\xBC','frac15':'\u2155','frac16':'\u2159','frac18':'\u215B','frac23':'\u2154','frac25':'\u2156','frac34':'\xBE','frac35':'\u2157','frac38':'\u215C','frac45':'\u2158','frac56':'\u215A','frac58':'\u215D','frac78':'\u215E','frasl':'\u2044','frown':'\u2322','fscr':'\uD835\uDCBB','Fscr':'\u2131','gacute':'\u01F5','gamma':'\u03B3','Gamma':'\u0393','gammad':'\u03DD','Gammad':'\u03DC','gap':'\u2A86','gbreve':'\u011F','Gbreve':'\u011E','Gcedil':'\u0122','gcirc':'\u011D','Gcirc':'\u011C','gcy':'\u0433','Gcy':'\u0413','gdot':'\u0121','Gdot':'\u0120','ge':'\u2265','gE':'\u2267','gel':'\u22DB','gEl':'\u2A8C','geq':'\u2265','geqq':'\u2267','geqslant':'\u2A7E','ges':'\u2A7E','gescc':'\u2AA9','gesdot':'\u2A80','gesdoto':'\u2A82','gesdotol':'\u2A84','gesl':'\u22DB\uFE00','gesles':'\u2A94','gfr':'\uD835\uDD24','Gfr':'\uD835\uDD0A','gg':'\u226B','Gg':'\u22D9','ggg':'\u22D9','gimel':'\u2137','gjcy':'\u0453','GJcy':'\u0403','gl':'\u2277','gla':'\u2AA5','glE':'\u2A92','glj':'\u2AA4','gnap':'\u2A8A','gnapprox':'\u2A8A','gne':'\u2A88','gnE':'\u2269','gneq':'\u2A88','gneqq':'\u2269','gnsim':'\u22E7','gopf':'\uD835\uDD58','Gopf':'\uD835\uDD3E','grave':'`','GreaterEqual':'\u2265','GreaterEqualLess':'\u22DB','GreaterFullEqual':'\u2267','GreaterGreater':'\u2AA2','GreaterLess':'\u2277','GreaterSlantEqual':'\u2A7E','GreaterTilde':'\u2273','gscr':'\u210A','Gscr':'\uD835\uDCA2','gsim':'\u2273','gsime':'\u2A8E','gsiml':'\u2A90','gt':'>','Gt':'\u226B','GT':'>','gtcc':'\u2AA7','gtcir':'\u2A7A','gtdot':'\u22D7','gtlPar':'\u2995','gtquest':'\u2A7C','gtrapprox':'\u2A86','gtrarr':'\u2978','gtrdot':'\u22D7','gtreqless':'\u22DB','gtreqqless':'\u2A8C','gtrless':'\u2277','gtrsim':'\u2273','gvertneqq':'\u2269\uFE00','gvnE':'\u2269\uFE00','Hacek':'\u02C7','hairsp':'\u200A','half':'\xBD','hamilt':'\u210B','hardcy':'\u044A','HARDcy':'\u042A','harr':'\u2194','hArr':'\u21D4','harrcir':'\u2948','harrw':'\u21AD','Hat':'^','hbar':'\u210F','hcirc':'\u0125','Hcirc':'\u0124','hearts':'\u2665','heartsuit':'\u2665','hellip':'\u2026','hercon':'\u22B9','hfr':'\uD835\uDD25','Hfr':'\u210C','HilbertSpace':'\u210B','hksearow':'\u2925','hkswarow':'\u2926','hoarr':'\u21FF','homtht':'\u223B','hookleftarrow':'\u21A9','hookrightarrow':'\u21AA','hopf':'\uD835\uDD59','Hopf':'\u210D','horbar':'\u2015','HorizontalLine':'\u2500','hscr':'\uD835\uDCBD','Hscr':'\u210B','hslash':'\u210F','hstrok':'\u0127','Hstrok':'\u0126','HumpDownHump':'\u224E','HumpEqual':'\u224F','hybull':'\u2043','hyphen':'\u2010','iacute':'\xED','Iacute':'\xCD','ic':'\u2063','icirc':'\xEE','Icirc':'\xCE','icy':'\u0438','Icy':'\u0418','Idot':'\u0130','iecy':'\u0435','IEcy':'\u0415','iexcl':'\xA1','iff':'\u21D4','ifr':'\uD835\uDD26','Ifr':'\u2111','igrave':'\xEC','Igrave':'\xCC','ii':'\u2148','iiiint':'\u2A0C','iiint':'\u222D','iinfin':'\u29DC','iiota':'\u2129','ijlig':'\u0133','IJlig':'\u0132','Im':'\u2111','imacr':'\u012B','Imacr':'\u012A','image':'\u2111','ImaginaryI':'\u2148','imagline':'\u2110','imagpart':'\u2111','imath':'\u0131','imof':'\u22B7','imped':'\u01B5','Implies':'\u21D2','in':'\u2208','incare':'\u2105','infin':'\u221E','infintie':'\u29DD','inodot':'\u0131','int':'\u222B','Int':'\u222C','intcal':'\u22BA','integers':'\u2124','Integral':'\u222B','intercal':'\u22BA','Intersection':'\u22C2','intlarhk':'\u2A17','intprod':'\u2A3C','InvisibleComma':'\u2063','InvisibleTimes':'\u2062','iocy':'\u0451','IOcy':'\u0401','iogon':'\u012F','Iogon':'\u012E','iopf':'\uD835\uDD5A','Iopf':'\uD835\uDD40','iota':'\u03B9','Iota':'\u0399','iprod':'\u2A3C','iquest':'\xBF','iscr':'\uD835\uDCBE','Iscr':'\u2110','isin':'\u2208','isindot':'\u22F5','isinE':'\u22F9','isins':'\u22F4','isinsv':'\u22F3','isinv':'\u2208','it':'\u2062','itilde':'\u0129','Itilde':'\u0128','iukcy':'\u0456','Iukcy':'\u0406','iuml':'\xEF','Iuml':'\xCF','jcirc':'\u0135','Jcirc':'\u0134','jcy':'\u0439','Jcy':'\u0419','jfr':'\uD835\uDD27','Jfr':'\uD835\uDD0D','jmath':'\u0237','jopf':'\uD835\uDD5B','Jopf':'\uD835\uDD41','jscr':'\uD835\uDCBF','Jscr':'\uD835\uDCA5','jsercy':'\u0458','Jsercy':'\u0408','jukcy':'\u0454','Jukcy':'\u0404','kappa':'\u03BA','Kappa':'\u039A','kappav':'\u03F0','kcedil':'\u0137','Kcedil':'\u0136','kcy':'\u043A','Kcy':'\u041A','kfr':'\uD835\uDD28','Kfr':'\uD835\uDD0E','kgreen':'\u0138','khcy':'\u0445','KHcy':'\u0425','kjcy':'\u045C','KJcy':'\u040C','kopf':'\uD835\uDD5C','Kopf':'\uD835\uDD42','kscr':'\uD835\uDCC0','Kscr':'\uD835\uDCA6','lAarr':'\u21DA','lacute':'\u013A','Lacute':'\u0139','laemptyv':'\u29B4','lagran':'\u2112','lambda':'\u03BB','Lambda':'\u039B','lang':'\u27E8','Lang':'\u27EA','langd':'\u2991','langle':'\u27E8','lap':'\u2A85','Laplacetrf':'\u2112','laquo':'\xAB','larr':'\u2190','lArr':'\u21D0','Larr':'\u219E','larrb':'\u21E4','larrbfs':'\u291F','larrfs':'\u291D','larrhk':'\u21A9','larrlp':'\u21AB','larrpl':'\u2939','larrsim':'\u2973','larrtl':'\u21A2','lat':'\u2AAB','latail':'\u2919','lAtail':'\u291B','late':'\u2AAD','lates':'\u2AAD\uFE00','lbarr':'\u290C','lBarr':'\u290E','lbbrk':'\u2772','lbrace':'{','lbrack':'[','lbrke':'\u298B','lbrksld':'\u298F','lbrkslu':'\u298D','lcaron':'\u013E','Lcaron':'\u013D','lcedil':'\u013C','Lcedil':'\u013B','lceil':'\u2308','lcub':'{','lcy':'\u043B','Lcy':'\u041B','ldca':'\u2936','ldquo':'\u201C','ldquor':'\u201E','ldrdhar':'\u2967','ldrushar':'\u294B','ldsh':'\u21B2','le':'\u2264','lE':'\u2266','LeftAngleBracket':'\u27E8','leftarrow':'\u2190','Leftarrow':'\u21D0','LeftArrow':'\u2190','LeftArrowBar':'\u21E4','LeftArrowRightArrow':'\u21C6','leftarrowtail':'\u21A2','LeftCeiling':'\u2308','LeftDoubleBracket':'\u27E6','LeftDownTeeVector':'\u2961','LeftDownVector':'\u21C3','LeftDownVectorBar':'\u2959','LeftFloor':'\u230A','leftharpoondown':'\u21BD','leftharpoonup':'\u21BC','leftleftarrows':'\u21C7','leftrightarrow':'\u2194','Leftrightarrow':'\u21D4','LeftRightArrow':'\u2194','leftrightarrows':'\u21C6','leftrightharpoons':'\u21CB','leftrightsquigarrow':'\u21AD','LeftRightVector':'\u294E','LeftTee':'\u22A3','LeftTeeArrow':'\u21A4','LeftTeeVector':'\u295A','leftthreetimes':'\u22CB','LeftTriangle':'\u22B2','LeftTriangleBar':'\u29CF','LeftTriangleEqual':'\u22B4','LeftUpDownVector':'\u2951','LeftUpTeeVector':'\u2960','LeftUpVector':'\u21BF','LeftUpVectorBar':'\u2958','LeftVector':'\u21BC','LeftVectorBar':'\u2952','leg':'\u22DA','lEg':'\u2A8B','leq':'\u2264','leqq':'\u2266','leqslant':'\u2A7D','les':'\u2A7D','lescc':'\u2AA8','lesdot':'\u2A7F','lesdoto':'\u2A81','lesdotor':'\u2A83','lesg':'\u22DA\uFE00','lesges':'\u2A93','lessapprox':'\u2A85','lessdot':'\u22D6','lesseqgtr':'\u22DA','lesseqqgtr':'\u2A8B','LessEqualGreater':'\u22DA','LessFullEqual':'\u2266','LessGreater':'\u2276','lessgtr':'\u2276','LessLess':'\u2AA1','lesssim':'\u2272','LessSlantEqual':'\u2A7D','LessTilde':'\u2272','lfisht':'\u297C','lfloor':'\u230A','lfr':'\uD835\uDD29','Lfr':'\uD835\uDD0F','lg':'\u2276','lgE':'\u2A91','lHar':'\u2962','lhard':'\u21BD','lharu':'\u21BC','lharul':'\u296A','lhblk':'\u2584','ljcy':'\u0459','LJcy':'\u0409','ll':'\u226A','Ll':'\u22D8','llarr':'\u21C7','llcorner':'\u231E','Lleftarrow':'\u21DA','llhard':'\u296B','lltri':'\u25FA','lmidot':'\u0140','Lmidot':'\u013F','lmoust':'\u23B0','lmoustache':'\u23B0','lnap':'\u2A89','lnapprox':'\u2A89','lne':'\u2A87','lnE':'\u2268','lneq':'\u2A87','lneqq':'\u2268','lnsim':'\u22E6','loang':'\u27EC','loarr':'\u21FD','lobrk':'\u27E6','longleftarrow':'\u27F5','Longleftarrow':'\u27F8','LongLeftArrow':'\u27F5','longleftrightarrow':'\u27F7','Longleftrightarrow':'\u27FA','LongLeftRightArrow':'\u27F7','longmapsto':'\u27FC','longrightarrow':'\u27F6','Longrightarrow':'\u27F9','LongRightArrow':'\u27F6','looparrowleft':'\u21AB','looparrowright':'\u21AC','lopar':'\u2985','lopf':'\uD835\uDD5D','Lopf':'\uD835\uDD43','loplus':'\u2A2D','lotimes':'\u2A34','lowast':'\u2217','lowbar':'_','LowerLeftArrow':'\u2199','LowerRightArrow':'\u2198','loz':'\u25CA','lozenge':'\u25CA','lozf':'\u29EB','lpar':'(','lparlt':'\u2993','lrarr':'\u21C6','lrcorner':'\u231F','lrhar':'\u21CB','lrhard':'\u296D','lrm':'\u200E','lrtri':'\u22BF','lsaquo':'\u2039','lscr':'\uD835\uDCC1','Lscr':'\u2112','lsh':'\u21B0','Lsh':'\u21B0','lsim':'\u2272','lsime':'\u2A8D','lsimg':'\u2A8F','lsqb':'[','lsquo':'\u2018','lsquor':'\u201A','lstrok':'\u0142','Lstrok':'\u0141','lt':'<','Lt':'\u226A','LT':'<','ltcc':'\u2AA6','ltcir':'\u2A79','ltdot':'\u22D6','lthree':'\u22CB','ltimes':'\u22C9','ltlarr':'\u2976','ltquest':'\u2A7B','ltri':'\u25C3','ltrie':'\u22B4','ltrif':'\u25C2','ltrPar':'\u2996','lurdshar':'\u294A','luruhar':'\u2966','lvertneqq':'\u2268\uFE00','lvnE':'\u2268\uFE00','macr':'\xAF','male':'\u2642','malt':'\u2720','maltese':'\u2720','map':'\u21A6','Map':'\u2905','mapsto':'\u21A6','mapstodown':'\u21A7','mapstoleft':'\u21A4','mapstoup':'\u21A5','marker':'\u25AE','mcomma':'\u2A29','mcy':'\u043C','Mcy':'\u041C','mdash':'\u2014','mDDot':'\u223A','measuredangle':'\u2221','MediumSpace':'\u205F','Mellintrf':'\u2133','mfr':'\uD835\uDD2A','Mfr':'\uD835\uDD10','mho':'\u2127','micro':'\xB5','mid':'\u2223','midast':'*','midcir':'\u2AF0','middot':'\xB7','minus':'\u2212','minusb':'\u229F','minusd':'\u2238','minusdu':'\u2A2A','MinusPlus':'\u2213','mlcp':'\u2ADB','mldr':'\u2026','mnplus':'\u2213','models':'\u22A7','mopf':'\uD835\uDD5E','Mopf':'\uD835\uDD44','mp':'\u2213','mscr':'\uD835\uDCC2','Mscr':'\u2133','mstpos':'\u223E','mu':'\u03BC','Mu':'\u039C','multimap':'\u22B8','mumap':'\u22B8','nabla':'\u2207','nacute':'\u0144','Nacute':'\u0143','nang':'\u2220\u20D2','nap':'\u2249','napE':'\u2A70\u0338','napid':'\u224B\u0338','napos':'\u0149','napprox':'\u2249','natur':'\u266E','natural':'\u266E','naturals':'\u2115','nbsp':'\xA0','nbump':'\u224E\u0338','nbumpe':'\u224F\u0338','ncap':'\u2A43','ncaron':'\u0148','Ncaron':'\u0147','ncedil':'\u0146','Ncedil':'\u0145','ncong':'\u2247','ncongdot':'\u2A6D\u0338','ncup':'\u2A42','ncy':'\u043D','Ncy':'\u041D','ndash':'\u2013','ne':'\u2260','nearhk':'\u2924','nearr':'\u2197','neArr':'\u21D7','nearrow':'\u2197','nedot':'\u2250\u0338','NegativeMediumSpace':'\u200B','NegativeThickSpace':'\u200B','NegativeThinSpace':'\u200B','NegativeVeryThinSpace':'\u200B','nequiv':'\u2262','nesear':'\u2928','nesim':'\u2242\u0338','NestedGreaterGreater':'\u226B','NestedLessLess':'\u226A','NewLine':'\n','nexist':'\u2204','nexists':'\u2204','nfr':'\uD835\uDD2B','Nfr':'\uD835\uDD11','nge':'\u2271','ngE':'\u2267\u0338','ngeq':'\u2271','ngeqq':'\u2267\u0338','ngeqslant':'\u2A7E\u0338','nges':'\u2A7E\u0338','nGg':'\u22D9\u0338','ngsim':'\u2275','ngt':'\u226F','nGt':'\u226B\u20D2','ngtr':'\u226F','nGtv':'\u226B\u0338','nharr':'\u21AE','nhArr':'\u21CE','nhpar':'\u2AF2','ni':'\u220B','nis':'\u22FC','nisd':'\u22FA','niv':'\u220B','njcy':'\u045A','NJcy':'\u040A','nlarr':'\u219A','nlArr':'\u21CD','nldr':'\u2025','nle':'\u2270','nlE':'\u2266\u0338','nleftarrow':'\u219A','nLeftarrow':'\u21CD','nleftrightarrow':'\u21AE','nLeftrightarrow':'\u21CE','nleq':'\u2270','nleqq':'\u2266\u0338','nleqslant':'\u2A7D\u0338','nles':'\u2A7D\u0338','nless':'\u226E','nLl':'\u22D8\u0338','nlsim':'\u2274','nlt':'\u226E','nLt':'\u226A\u20D2','nltri':'\u22EA','nltrie':'\u22EC','nLtv':'\u226A\u0338','nmid':'\u2224','NoBreak':'\u2060','NonBreakingSpace':'\xA0','nopf':'\uD835\uDD5F','Nopf':'\u2115','not':'\xAC','Not':'\u2AEC','NotCongruent':'\u2262','NotCupCap':'\u226D','NotDoubleVerticalBar':'\u2226','NotElement':'\u2209','NotEqual':'\u2260','NotEqualTilde':'\u2242\u0338','NotExists':'\u2204','NotGreater':'\u226F','NotGreaterEqual':'\u2271','NotGreaterFullEqual':'\u2267\u0338','NotGreaterGreater':'\u226B\u0338','NotGreaterLess':'\u2279','NotGreaterSlantEqual':'\u2A7E\u0338','NotGreaterTilde':'\u2275','NotHumpDownHump':'\u224E\u0338','NotHumpEqual':'\u224F\u0338','notin':'\u2209','notindot':'\u22F5\u0338','notinE':'\u22F9\u0338','notinva':'\u2209','notinvb':'\u22F7','notinvc':'\u22F6','NotLeftTriangle':'\u22EA','NotLeftTriangleBar':'\u29CF\u0338','NotLeftTriangleEqual':'\u22EC','NotLess':'\u226E','NotLessEqual':'\u2270','NotLessGreater':'\u2278','NotLessLess':'\u226A\u0338','NotLessSlantEqual':'\u2A7D\u0338','NotLessTilde':'\u2274','NotNestedGreaterGreater':'\u2AA2\u0338','NotNestedLessLess':'\u2AA1\u0338','notni':'\u220C','notniva':'\u220C','notnivb':'\u22FE','notnivc':'\u22FD','NotPrecedes':'\u2280','NotPrecedesEqual':'\u2AAF\u0338','NotPrecedesSlantEqual':'\u22E0','NotReverseElement':'\u220C','NotRightTriangle':'\u22EB','NotRightTriangleBar':'\u29D0\u0338','NotRightTriangleEqual':'\u22ED','NotSquareSubset':'\u228F\u0338','NotSquareSubsetEqual':'\u22E2','NotSquareSuperset':'\u2290\u0338','NotSquareSupersetEqual':'\u22E3','NotSubset':'\u2282\u20D2','NotSubsetEqual':'\u2288','NotSucceeds':'\u2281','NotSucceedsEqual':'\u2AB0\u0338','NotSucceedsSlantEqual':'\u22E1','NotSucceedsTilde':'\u227F\u0338','NotSuperset':'\u2283\u20D2','NotSupersetEqual':'\u2289','NotTilde':'\u2241','NotTildeEqual':'\u2244','NotTildeFullEqual':'\u2247','NotTildeTilde':'\u2249','NotVerticalBar':'\u2224','npar':'\u2226','nparallel':'\u2226','nparsl':'\u2AFD\u20E5','npart':'\u2202\u0338','npolint':'\u2A14','npr':'\u2280','nprcue':'\u22E0','npre':'\u2AAF\u0338','nprec':'\u2280','npreceq':'\u2AAF\u0338','nrarr':'\u219B','nrArr':'\u21CF','nrarrc':'\u2933\u0338','nrarrw':'\u219D\u0338','nrightarrow':'\u219B','nRightarrow':'\u21CF','nrtri':'\u22EB','nrtrie':'\u22ED','nsc':'\u2281','nsccue':'\u22E1','nsce':'\u2AB0\u0338','nscr':'\uD835\uDCC3','Nscr':'\uD835\uDCA9','nshortmid':'\u2224','nshortparallel':'\u2226','nsim':'\u2241','nsime':'\u2244','nsimeq':'\u2244','nsmid':'\u2224','nspar':'\u2226','nsqsube':'\u22E2','nsqsupe':'\u22E3','nsub':'\u2284','nsube':'\u2288','nsubE':'\u2AC5\u0338','nsubset':'\u2282\u20D2','nsubseteq':'\u2288','nsubseteqq':'\u2AC5\u0338','nsucc':'\u2281','nsucceq':'\u2AB0\u0338','nsup':'\u2285','nsupe':'\u2289','nsupE':'\u2AC6\u0338','nsupset':'\u2283\u20D2','nsupseteq':'\u2289','nsupseteqq':'\u2AC6\u0338','ntgl':'\u2279','ntilde':'\xF1','Ntilde':'\xD1','ntlg':'\u2278','ntriangleleft':'\u22EA','ntrianglelefteq':'\u22EC','ntriangleright':'\u22EB','ntrianglerighteq':'\u22ED','nu':'\u03BD','Nu':'\u039D','num':'#','numero':'\u2116','numsp':'\u2007','nvap':'\u224D\u20D2','nvdash':'\u22AC','nvDash':'\u22AD','nVdash':'\u22AE','nVDash':'\u22AF','nvge':'\u2265\u20D2','nvgt':'>\u20D2','nvHarr':'\u2904','nvinfin':'\u29DE','nvlArr':'\u2902','nvle':'\u2264\u20D2','nvlt':'<\u20D2','nvltrie':'\u22B4\u20D2','nvrArr':'\u2903','nvrtrie':'\u22B5\u20D2','nvsim':'\u223C\u20D2','nwarhk':'\u2923','nwarr':'\u2196','nwArr':'\u21D6','nwarrow':'\u2196','nwnear':'\u2927','oacute':'\xF3','Oacute':'\xD3','oast':'\u229B','ocir':'\u229A','ocirc':'\xF4','Ocirc':'\xD4','ocy':'\u043E','Ocy':'\u041E','odash':'\u229D','odblac':'\u0151','Odblac':'\u0150','odiv':'\u2A38','odot':'\u2299','odsold':'\u29BC','oelig':'\u0153','OElig':'\u0152','ofcir':'\u29BF','ofr':'\uD835\uDD2C','Ofr':'\uD835\uDD12','ogon':'\u02DB','ograve':'\xF2','Ograve':'\xD2','ogt':'\u29C1','ohbar':'\u29B5','ohm':'\u03A9','oint':'\u222E','olarr':'\u21BA','olcir':'\u29BE','olcross':'\u29BB','oline':'\u203E','olt':'\u29C0','omacr':'\u014D','Omacr':'\u014C','omega':'\u03C9','Omega':'\u03A9','omicron':'\u03BF','Omicron':'\u039F','omid':'\u29B6','ominus':'\u2296','oopf':'\uD835\uDD60','Oopf':'\uD835\uDD46','opar':'\u29B7','OpenCurlyDoubleQuote':'\u201C','OpenCurlyQuote':'\u2018','operp':'\u29B9','oplus':'\u2295','or':'\u2228','Or':'\u2A54','orarr':'\u21BB','ord':'\u2A5D','order':'\u2134','orderof':'\u2134','ordf':'\xAA','ordm':'\xBA','origof':'\u22B6','oror':'\u2A56','orslope':'\u2A57','orv':'\u2A5B','oS':'\u24C8','oscr':'\u2134','Oscr':'\uD835\uDCAA','oslash':'\xF8','Oslash':'\xD8','osol':'\u2298','otilde':'\xF5','Otilde':'\xD5','otimes':'\u2297','Otimes':'\u2A37','otimesas':'\u2A36','ouml':'\xF6','Ouml':'\xD6','ovbar':'\u233D','OverBar':'\u203E','OverBrace':'\u23DE','OverBracket':'\u23B4','OverParenthesis':'\u23DC','par':'\u2225','para':'\xB6','parallel':'\u2225','parsim':'\u2AF3','parsl':'\u2AFD','part':'\u2202','PartialD':'\u2202','pcy':'\u043F','Pcy':'\u041F','percnt':'%','period':'.','permil':'\u2030','perp':'\u22A5','pertenk':'\u2031','pfr':'\uD835\uDD2D','Pfr':'\uD835\uDD13','phi':'\u03C6','Phi':'\u03A6','phiv':'\u03D5','phmmat':'\u2133','phone':'\u260E','pi':'\u03C0','Pi':'\u03A0','pitchfork':'\u22D4','piv':'\u03D6','planck':'\u210F','planckh':'\u210E','plankv':'\u210F','plus':'+','plusacir':'\u2A23','plusb':'\u229E','pluscir':'\u2A22','plusdo':'\u2214','plusdu':'\u2A25','pluse':'\u2A72','PlusMinus':'\xB1','plusmn':'\xB1','plussim':'\u2A26','plustwo':'\u2A27','pm':'\xB1','Poincareplane':'\u210C','pointint':'\u2A15','popf':'\uD835\uDD61','Popf':'\u2119','pound':'\xA3','pr':'\u227A','Pr':'\u2ABB','prap':'\u2AB7','prcue':'\u227C','pre':'\u2AAF','prE':'\u2AB3','prec':'\u227A','precapprox':'\u2AB7','preccurlyeq':'\u227C','Precedes':'\u227A','PrecedesEqual':'\u2AAF','PrecedesSlantEqual':'\u227C','PrecedesTilde':'\u227E','preceq':'\u2AAF','precnapprox':'\u2AB9','precneqq':'\u2AB5','precnsim':'\u22E8','precsim':'\u227E','prime':'\u2032','Prime':'\u2033','primes':'\u2119','prnap':'\u2AB9','prnE':'\u2AB5','prnsim':'\u22E8','prod':'\u220F','Product':'\u220F','profalar':'\u232E','profline':'\u2312','profsurf':'\u2313','prop':'\u221D','Proportion':'\u2237','Proportional':'\u221D','propto':'\u221D','prsim':'\u227E','prurel':'\u22B0','pscr':'\uD835\uDCC5','Pscr':'\uD835\uDCAB','psi':'\u03C8','Psi':'\u03A8','puncsp':'\u2008','qfr':'\uD835\uDD2E','Qfr':'\uD835\uDD14','qint':'\u2A0C','qopf':'\uD835\uDD62','Qopf':'\u211A','qprime':'\u2057','qscr':'\uD835\uDCC6','Qscr':'\uD835\uDCAC','quaternions':'\u210D','quatint':'\u2A16','quest':'?','questeq':'\u225F','quot':'"','QUOT':'"','rAarr':'\u21DB','race':'\u223D\u0331','racute':'\u0155','Racute':'\u0154','radic':'\u221A','raemptyv':'\u29B3','rang':'\u27E9','Rang':'\u27EB','rangd':'\u2992','range':'\u29A5','rangle':'\u27E9','raquo':'\xBB','rarr':'\u2192','rArr':'\u21D2','Rarr':'\u21A0','rarrap':'\u2975','rarrb':'\u21E5','rarrbfs':'\u2920','rarrc':'\u2933','rarrfs':'\u291E','rarrhk':'\u21AA','rarrlp':'\u21AC','rarrpl':'\u2945','rarrsim':'\u2974','rarrtl':'\u21A3','Rarrtl':'\u2916','rarrw':'\u219D','ratail':'\u291A','rAtail':'\u291C','ratio':'\u2236','rationals':'\u211A','rbarr':'\u290D','rBarr':'\u290F','RBarr':'\u2910','rbbrk':'\u2773','rbrace':'}','rbrack':']','rbrke':'\u298C','rbrksld':'\u298E','rbrkslu':'\u2990','rcaron':'\u0159','Rcaron':'\u0158','rcedil':'\u0157','Rcedil':'\u0156','rceil':'\u2309','rcub':'}','rcy':'\u0440','Rcy':'\u0420','rdca':'\u2937','rdldhar':'\u2969','rdquo':'\u201D','rdquor':'\u201D','rdsh':'\u21B3','Re':'\u211C','real':'\u211C','realine':'\u211B','realpart':'\u211C','reals':'\u211D','rect':'\u25AD','reg':'\xAE','REG':'\xAE','ReverseElement':'\u220B','ReverseEquilibrium':'\u21CB','ReverseUpEquilibrium':'\u296F','rfisht':'\u297D','rfloor':'\u230B','rfr':'\uD835\uDD2F','Rfr':'\u211C','rHar':'\u2964','rhard':'\u21C1','rharu':'\u21C0','rharul':'\u296C','rho':'\u03C1','Rho':'\u03A1','rhov':'\u03F1','RightAngleBracket':'\u27E9','rightarrow':'\u2192','Rightarrow':'\u21D2','RightArrow':'\u2192','RightArrowBar':'\u21E5','RightArrowLeftArrow':'\u21C4','rightarrowtail':'\u21A3','RightCeiling':'\u2309','RightDoubleBracket':'\u27E7','RightDownTeeVector':'\u295D','RightDownVector':'\u21C2','RightDownVectorBar':'\u2955','RightFloor':'\u230B','rightharpoondown':'\u21C1','rightharpoonup':'\u21C0','rightleftarrows':'\u21C4','rightleftharpoons':'\u21CC','rightrightarrows':'\u21C9','rightsquigarrow':'\u219D','RightTee':'\u22A2','RightTeeArrow':'\u21A6','RightTeeVector':'\u295B','rightthreetimes':'\u22CC','RightTriangle':'\u22B3','RightTriangleBar':'\u29D0','RightTriangleEqual':'\u22B5','RightUpDownVector':'\u294F','RightUpTeeVector':'\u295C','RightUpVector':'\u21BE','RightUpVectorBar':'\u2954','RightVector':'\u21C0','RightVectorBar':'\u2953','ring':'\u02DA','risingdotseq':'\u2253','rlarr':'\u21C4','rlhar':'\u21CC','rlm':'\u200F','rmoust':'\u23B1','rmoustache':'\u23B1','rnmid':'\u2AEE','roang':'\u27ED','roarr':'\u21FE','robrk':'\u27E7','ropar':'\u2986','ropf':'\uD835\uDD63','Ropf':'\u211D','roplus':'\u2A2E','rotimes':'\u2A35','RoundImplies':'\u2970','rpar':')','rpargt':'\u2994','rppolint':'\u2A12','rrarr':'\u21C9','Rrightarrow':'\u21DB','rsaquo':'\u203A','rscr':'\uD835\uDCC7','Rscr':'\u211B','rsh':'\u21B1','Rsh':'\u21B1','rsqb':']','rsquo':'\u2019','rsquor':'\u2019','rthree':'\u22CC','rtimes':'\u22CA','rtri':'\u25B9','rtrie':'\u22B5','rtrif':'\u25B8','rtriltri':'\u29CE','RuleDelayed':'\u29F4','ruluhar':'\u2968','rx':'\u211E','sacute':'\u015B','Sacute':'\u015A','sbquo':'\u201A','sc':'\u227B','Sc':'\u2ABC','scap':'\u2AB8','scaron':'\u0161','Scaron':'\u0160','sccue':'\u227D','sce':'\u2AB0','scE':'\u2AB4','scedil':'\u015F','Scedil':'\u015E','scirc':'\u015D','Scirc':'\u015C','scnap':'\u2ABA','scnE':'\u2AB6','scnsim':'\u22E9','scpolint':'\u2A13','scsim':'\u227F','scy':'\u0441','Scy':'\u0421','sdot':'\u22C5','sdotb':'\u22A1','sdote':'\u2A66','searhk':'\u2925','searr':'\u2198','seArr':'\u21D8','searrow':'\u2198','sect':'\xA7','semi':';','seswar':'\u2929','setminus':'\u2216','setmn':'\u2216','sext':'\u2736','sfr':'\uD835\uDD30','Sfr':'\uD835\uDD16','sfrown':'\u2322','sharp':'\u266F','shchcy':'\u0449','SHCHcy':'\u0429','shcy':'\u0448','SHcy':'\u0428','ShortDownArrow':'\u2193','ShortLeftArrow':'\u2190','shortmid':'\u2223','shortparallel':'\u2225','ShortRightArrow':'\u2192','ShortUpArrow':'\u2191','shy':'\xAD','sigma':'\u03C3','Sigma':'\u03A3','sigmaf':'\u03C2','sigmav':'\u03C2','sim':'\u223C','simdot':'\u2A6A','sime':'\u2243','simeq':'\u2243','simg':'\u2A9E','simgE':'\u2AA0','siml':'\u2A9D','simlE':'\u2A9F','simne':'\u2246','simplus':'\u2A24','simrarr':'\u2972','slarr':'\u2190','SmallCircle':'\u2218','smallsetminus':'\u2216','smashp':'\u2A33','smeparsl':'\u29E4','smid':'\u2223','smile':'\u2323','smt':'\u2AAA','smte':'\u2AAC','smtes':'\u2AAC\uFE00','softcy':'\u044C','SOFTcy':'\u042C','sol':'/','solb':'\u29C4','solbar':'\u233F','sopf':'\uD835\uDD64','Sopf':'\uD835\uDD4A','spades':'\u2660','spadesuit':'\u2660','spar':'\u2225','sqcap':'\u2293','sqcaps':'\u2293\uFE00','sqcup':'\u2294','sqcups':'\u2294\uFE00','Sqrt':'\u221A','sqsub':'\u228F','sqsube':'\u2291','sqsubset':'\u228F','sqsubseteq':'\u2291','sqsup':'\u2290','sqsupe':'\u2292','sqsupset':'\u2290','sqsupseteq':'\u2292','squ':'\u25A1','square':'\u25A1','Square':'\u25A1','SquareIntersection':'\u2293','SquareSubset':'\u228F','SquareSubsetEqual':'\u2291','SquareSuperset':'\u2290','SquareSupersetEqual':'\u2292','SquareUnion':'\u2294','squarf':'\u25AA','squf':'\u25AA','srarr':'\u2192','sscr':'\uD835\uDCC8','Sscr':'\uD835\uDCAE','ssetmn':'\u2216','ssmile':'\u2323','sstarf':'\u22C6','star':'\u2606','Star':'\u22C6','starf':'\u2605','straightepsilon':'\u03F5','straightphi':'\u03D5','strns':'\xAF','sub':'\u2282','Sub':'\u22D0','subdot':'\u2ABD','sube':'\u2286','subE':'\u2AC5','subedot':'\u2AC3','submult':'\u2AC1','subne':'\u228A','subnE':'\u2ACB','subplus':'\u2ABF','subrarr':'\u2979','subset':'\u2282','Subset':'\u22D0','subseteq':'\u2286','subseteqq':'\u2AC5','SubsetEqual':'\u2286','subsetneq':'\u228A','subsetneqq':'\u2ACB','subsim':'\u2AC7','subsub':'\u2AD5','subsup':'\u2AD3','succ':'\u227B','succapprox':'\u2AB8','succcurlyeq':'\u227D','Succeeds':'\u227B','SucceedsEqual':'\u2AB0','SucceedsSlantEqual':'\u227D','SucceedsTilde':'\u227F','succeq':'\u2AB0','succnapprox':'\u2ABA','succneqq':'\u2AB6','succnsim':'\u22E9','succsim':'\u227F','SuchThat':'\u220B','sum':'\u2211','Sum':'\u2211','sung':'\u266A','sup':'\u2283','Sup':'\u22D1','sup1':'\xB9','sup2':'\xB2','sup3':'\xB3','supdot':'\u2ABE','supdsub':'\u2AD8','supe':'\u2287','supE':'\u2AC6','supedot':'\u2AC4','Superset':'\u2283','SupersetEqual':'\u2287','suphsol':'\u27C9','suphsub':'\u2AD7','suplarr':'\u297B','supmult':'\u2AC2','supne':'\u228B','supnE':'\u2ACC','supplus':'\u2AC0','supset':'\u2283','Supset':'\u22D1','supseteq':'\u2287','supseteqq':'\u2AC6','supsetneq':'\u228B','supsetneqq':'\u2ACC','supsim':'\u2AC8','supsub':'\u2AD4','supsup':'\u2AD6','swarhk':'\u2926','swarr':'\u2199','swArr':'\u21D9','swarrow':'\u2199','swnwar':'\u292A','szlig':'\xDF','Tab':'\t','target':'\u2316','tau':'\u03C4','Tau':'\u03A4','tbrk':'\u23B4','tcaron':'\u0165','Tcaron':'\u0164','tcedil':'\u0163','Tcedil':'\u0162','tcy':'\u0442','Tcy':'\u0422','tdot':'\u20DB','telrec':'\u2315','tfr':'\uD835\uDD31','Tfr':'\uD835\uDD17','there4':'\u2234','therefore':'\u2234','Therefore':'\u2234','theta':'\u03B8','Theta':'\u0398','thetasym':'\u03D1','thetav':'\u03D1','thickapprox':'\u2248','thicksim':'\u223C','ThickSpace':'\u205F\u200A','thinsp':'\u2009','ThinSpace':'\u2009','thkap':'\u2248','thksim':'\u223C','thorn':'\xFE','THORN':'\xDE','tilde':'\u02DC','Tilde':'\u223C','TildeEqual':'\u2243','TildeFullEqual':'\u2245','TildeTilde':'\u2248','times':'\xD7','timesb':'\u22A0','timesbar':'\u2A31','timesd':'\u2A30','tint':'\u222D','toea':'\u2928','top':'\u22A4','topbot':'\u2336','topcir':'\u2AF1','topf':'\uD835\uDD65','Topf':'\uD835\uDD4B','topfork':'\u2ADA','tosa':'\u2929','tprime':'\u2034','trade':'\u2122','TRADE':'\u2122','triangle':'\u25B5','triangledown':'\u25BF','triangleleft':'\u25C3','trianglelefteq':'\u22B4','triangleq':'\u225C','triangleright':'\u25B9','trianglerighteq':'\u22B5','tridot':'\u25EC','trie':'\u225C','triminus':'\u2A3A','TripleDot':'\u20DB','triplus':'\u2A39','trisb':'\u29CD','tritime':'\u2A3B','trpezium':'\u23E2','tscr':'\uD835\uDCC9','Tscr':'\uD835\uDCAF','tscy':'\u0446','TScy':'\u0426','tshcy':'\u045B','TSHcy':'\u040B','tstrok':'\u0167','Tstrok':'\u0166','twixt':'\u226C','twoheadleftarrow':'\u219E','twoheadrightarrow':'\u21A0','uacute':'\xFA','Uacute':'\xDA','uarr':'\u2191','uArr':'\u21D1','Uarr':'\u219F','Uarrocir':'\u2949','ubrcy':'\u045E','Ubrcy':'\u040E','ubreve':'\u016D','Ubreve':'\u016C','ucirc':'\xFB','Ucirc':'\xDB','ucy':'\u0443','Ucy':'\u0423','udarr':'\u21C5','udblac':'\u0171','Udblac':'\u0170','udhar':'\u296E','ufisht':'\u297E','ufr':'\uD835\uDD32','Ufr':'\uD835\uDD18','ugrave':'\xF9','Ugrave':'\xD9','uHar':'\u2963','uharl':'\u21BF','uharr':'\u21BE','uhblk':'\u2580','ulcorn':'\u231C','ulcorner':'\u231C','ulcrop':'\u230F','ultri':'\u25F8','umacr':'\u016B','Umacr':'\u016A','uml':'\xA8','UnderBar':'_','UnderBrace':'\u23DF','UnderBracket':'\u23B5','UnderParenthesis':'\u23DD','Union':'\u22C3','UnionPlus':'\u228E','uogon':'\u0173','Uogon':'\u0172','uopf':'\uD835\uDD66','Uopf':'\uD835\uDD4C','uparrow':'\u2191','Uparrow':'\u21D1','UpArrow':'\u2191','UpArrowBar':'\u2912','UpArrowDownArrow':'\u21C5','updownarrow':'\u2195','Updownarrow':'\u21D5','UpDownArrow':'\u2195','UpEquilibrium':'\u296E','upharpoonleft':'\u21BF','upharpoonright':'\u21BE','uplus':'\u228E','UpperLeftArrow':'\u2196','UpperRightArrow':'\u2197','upsi':'\u03C5','Upsi':'\u03D2','upsih':'\u03D2','upsilon':'\u03C5','Upsilon':'\u03A5','UpTee':'\u22A5','UpTeeArrow':'\u21A5','upuparrows':'\u21C8','urcorn':'\u231D','urcorner':'\u231D','urcrop':'\u230E','uring':'\u016F','Uring':'\u016E','urtri':'\u25F9','uscr':'\uD835\uDCCA','Uscr':'\uD835\uDCB0','utdot':'\u22F0','utilde':'\u0169','Utilde':'\u0168','utri':'\u25B5','utrif':'\u25B4','uuarr':'\u21C8','uuml':'\xFC','Uuml':'\xDC','uwangle':'\u29A7','vangrt':'\u299C','varepsilon':'\u03F5','varkappa':'\u03F0','varnothing':'\u2205','varphi':'\u03D5','varpi':'\u03D6','varpropto':'\u221D','varr':'\u2195','vArr':'\u21D5','varrho':'\u03F1','varsigma':'\u03C2','varsubsetneq':'\u228A\uFE00','varsubsetneqq':'\u2ACB\uFE00','varsupsetneq':'\u228B\uFE00','varsupsetneqq':'\u2ACC\uFE00','vartheta':'\u03D1','vartriangleleft':'\u22B2','vartriangleright':'\u22B3','vBar':'\u2AE8','Vbar':'\u2AEB','vBarv':'\u2AE9','vcy':'\u0432','Vcy':'\u0412','vdash':'\u22A2','vDash':'\u22A8','Vdash':'\u22A9','VDash':'\u22AB','Vdashl':'\u2AE6','vee':'\u2228','Vee':'\u22C1','veebar':'\u22BB','veeeq':'\u225A','vellip':'\u22EE','verbar':'|','Verbar':'\u2016','vert':'|','Vert':'\u2016','VerticalBar':'\u2223','VerticalLine':'|','VerticalSeparator':'\u2758','VerticalTilde':'\u2240','VeryThinSpace':'\u200A','vfr':'\uD835\uDD33','Vfr':'\uD835\uDD19','vltri':'\u22B2','vnsub':'\u2282\u20D2','vnsup':'\u2283\u20D2','vopf':'\uD835\uDD67','Vopf':'\uD835\uDD4D','vprop':'\u221D','vrtri':'\u22B3','vscr':'\uD835\uDCCB','Vscr':'\uD835\uDCB1','vsubne':'\u228A\uFE00','vsubnE':'\u2ACB\uFE00','vsupne':'\u228B\uFE00','vsupnE':'\u2ACC\uFE00','Vvdash':'\u22AA','vzigzag':'\u299A','wcirc':'\u0175','Wcirc':'\u0174','wedbar':'\u2A5F','wedge':'\u2227','Wedge':'\u22C0','wedgeq':'\u2259','weierp':'\u2118','wfr':'\uD835\uDD34','Wfr':'\uD835\uDD1A','wopf':'\uD835\uDD68','Wopf':'\uD835\uDD4E','wp':'\u2118','wr':'\u2240','wreath':'\u2240','wscr':'\uD835\uDCCC','Wscr':'\uD835\uDCB2','xcap':'\u22C2','xcirc':'\u25EF','xcup':'\u22C3','xdtri':'\u25BD','xfr':'\uD835\uDD35','Xfr':'\uD835\uDD1B','xharr':'\u27F7','xhArr':'\u27FA','xi':'\u03BE','Xi':'\u039E','xlarr':'\u27F5','xlArr':'\u27F8','xmap':'\u27FC','xnis':'\u22FB','xodot':'\u2A00','xopf':'\uD835\uDD69','Xopf':'\uD835\uDD4F','xoplus':'\u2A01','xotime':'\u2A02','xrarr':'\u27F6','xrArr':'\u27F9','xscr':'\uD835\uDCCD','Xscr':'\uD835\uDCB3','xsqcup':'\u2A06','xuplus':'\u2A04','xutri':'\u25B3','xvee':'\u22C1','xwedge':'\u22C0','yacute':'\xFD','Yacute':'\xDD','yacy':'\u044F','YAcy':'\u042F','ycirc':'\u0177','Ycirc':'\u0176','ycy':'\u044B','Ycy':'\u042B','yen':'\xA5','yfr':'\uD835\uDD36','Yfr':'\uD835\uDD1C','yicy':'\u0457','YIcy':'\u0407','yopf':'\uD835\uDD6A','Yopf':'\uD835\uDD50','yscr':'\uD835\uDCCE','Yscr':'\uD835\uDCB4','yucy':'\u044E','YUcy':'\u042E','yuml':'\xFF','Yuml':'\u0178','zacute':'\u017A','Zacute':'\u0179','zcaron':'\u017E','Zcaron':'\u017D','zcy':'\u0437','Zcy':'\u0417','zdot':'\u017C','Zdot':'\u017B','zeetrf':'\u2128','ZeroWidthSpace':'\u200B','zeta':'\u03B6','Zeta':'\u0396','zfr':'\uD835\uDD37','Zfr':'\u2128','zhcy':'\u0436','ZHcy':'\u0416','zigrarr':'\u21DD','zopf':'\uD835\uDD6B','Zopf':'\u2124','zscr':'\uD835\uDCCF','Zscr':'\uD835\uDCB5','zwj':'\u200D','zwnj':'\u200C'};
		var decodeMapLegacy = {'aacute':'\xE1','Aacute':'\xC1','acirc':'\xE2','Acirc':'\xC2','acute':'\xB4','aelig':'\xE6','AElig':'\xC6','agrave':'\xE0','Agrave':'\xC0','amp':'&','AMP':'&','aring':'\xE5','Aring':'\xC5','atilde':'\xE3','Atilde':'\xC3','auml':'\xE4','Auml':'\xC4','brvbar':'\xA6','ccedil':'\xE7','Ccedil':'\xC7','cedil':'\xB8','cent':'\xA2','copy':'\xA9','COPY':'\xA9','curren':'\xA4','deg':'\xB0','divide':'\xF7','eacute':'\xE9','Eacute':'\xC9','ecirc':'\xEA','Ecirc':'\xCA','egrave':'\xE8','Egrave':'\xC8','eth':'\xF0','ETH':'\xD0','euml':'\xEB','Euml':'\xCB','frac12':'\xBD','frac14':'\xBC','frac34':'\xBE','gt':'>','GT':'>','iacute':'\xED','Iacute':'\xCD','icirc':'\xEE','Icirc':'\xCE','iexcl':'\xA1','igrave':'\xEC','Igrave':'\xCC','iquest':'\xBF','iuml':'\xEF','Iuml':'\xCF','laquo':'\xAB','lt':'<','LT':'<','macr':'\xAF','micro':'\xB5','middot':'\xB7','nbsp':'\xA0','not':'\xAC','ntilde':'\xF1','Ntilde':'\xD1','oacute':'\xF3','Oacute':'\xD3','ocirc':'\xF4','Ocirc':'\xD4','ograve':'\xF2','Ograve':'\xD2','ordf':'\xAA','ordm':'\xBA','oslash':'\xF8','Oslash':'\xD8','otilde':'\xF5','Otilde':'\xD5','ouml':'\xF6','Ouml':'\xD6','para':'\xB6','plusmn':'\xB1','pound':'\xA3','quot':'"','QUOT':'"','raquo':'\xBB','reg':'\xAE','REG':'\xAE','sect':'\xA7','shy':'\xAD','sup1':'\xB9','sup2':'\xB2','sup3':'\xB3','szlig':'\xDF','thorn':'\xFE','THORN':'\xDE','times':'\xD7','uacute':'\xFA','Uacute':'\xDA','ucirc':'\xFB','Ucirc':'\xDB','ugrave':'\xF9','Ugrave':'\xD9','uml':'\xA8','uuml':'\xFC','Uuml':'\xDC','yacute':'\xFD','Yacute':'\xDD','yen':'\xA5','yuml':'\xFF'};
		var decodeMapNumeric = {'0':'\uFFFD','128':'\u20AC','130':'\u201A','131':'\u0192','132':'\u201E','133':'\u2026','134':'\u2020','135':'\u2021','136':'\u02C6','137':'\u2030','138':'\u0160','139':'\u2039','140':'\u0152','142':'\u017D','145':'\u2018','146':'\u2019','147':'\u201C','148':'\u201D','149':'\u2022','150':'\u2013','151':'\u2014','152':'\u02DC','153':'\u2122','154':'\u0161','155':'\u203A','156':'\u0153','158':'\u017E','159':'\u0178'};
		var invalidReferenceCodePoints = [1,2,3,4,5,6,7,8,11,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,64976,64977,64978,64979,64980,64981,64982,64983,64984,64985,64986,64987,64988,64989,64990,64991,64992,64993,64994,64995,64996,64997,64998,64999,65000,65001,65002,65003,65004,65005,65006,65007,65534,65535,131070,131071,196606,196607,262142,262143,327678,327679,393214,393215,458750,458751,524286,524287,589822,589823,655358,655359,720894,720895,786430,786431,851966,851967,917502,917503,983038,983039,1048574,1048575,1114110,1114111];
	
		/*--------------------------------------------------------------------------*/
	
		var stringFromCharCode = String.fromCharCode;
	
		var object = {};
		var hasOwnProperty = object.hasOwnProperty;
		var has = function(object, propertyName) {
			return hasOwnProperty.call(object, propertyName);
		};
	
		var contains = function(array, value) {
			var index = -1;
			var length = array.length;
			while (++index < length) {
				if (array[index] == value) {
					return true;
				}
			}
			return false;
		};
	
		var merge = function(options, defaults) {
			if (!options) {
				return defaults;
			}
			var result = {};
			var key;
			for (key in defaults) {
				// A `hasOwnProperty` check is not needed here, since only recognized
				// option names are used anyway. Any others are ignored.
				result[key] = has(options, key) ? options[key] : defaults[key];
			}
			return result;
		};
	
		// Modified version of `ucs2encode`; see https://mths.be/punycode.
		var codePointToSymbol = function(codePoint, strict) {
			var output = '';
			if ((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF) {
				// See issue #4:
				// “Otherwise, if the number is in the range 0xD800 to 0xDFFF or is
				// greater than 0x10FFFF, then this is a parse error. Return a U+FFFD
				// REPLACEMENT CHARACTER.”
				if (strict) {
					parseError('character reference outside the permissible Unicode range');
				}
				return '\uFFFD';
			}
			if (has(decodeMapNumeric, codePoint)) {
				if (strict) {
					parseError('disallowed character reference');
				}
				return decodeMapNumeric[codePoint];
			}
			if (strict && contains(invalidReferenceCodePoints, codePoint)) {
				parseError('disallowed character reference');
			}
			if (codePoint > 0xFFFF) {
				codePoint -= 0x10000;
				output += stringFromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
				codePoint = 0xDC00 | codePoint & 0x3FF;
			}
			output += stringFromCharCode(codePoint);
			return output;
		};
	
		var hexEscape = function(codePoint) {
			return '&#x' + codePoint.toString(16).toUpperCase() + ';';
		};
	
		var decEscape = function(codePoint) {
			return '&#' + codePoint + ';';
		};
	
		var parseError = function(message) {
			throw Error('Parse error: ' + message);
		};
	
		/*--------------------------------------------------------------------------*/
	
		var encode = function(string, options) {
			options = merge(options, encode.options);
			var strict = options.strict;
			if (strict && regexInvalidRawCodePoint.test(string)) {
				parseError('forbidden code point');
			}
			var encodeEverything = options.encodeEverything;
			var useNamedReferences = options.useNamedReferences;
			var allowUnsafeSymbols = options.allowUnsafeSymbols;
			var escapeCodePoint = options.decimal ? decEscape : hexEscape;
	
			var escapeBmpSymbol = function(symbol) {
				return escapeCodePoint(symbol.charCodeAt(0));
			};
	
			if (encodeEverything) {
				// Encode ASCII symbols.
				string = string.replace(regexAsciiWhitelist, function(symbol) {
					// Use named references if requested & possible.
					if (useNamedReferences && has(encodeMap, symbol)) {
						return '&' + encodeMap[symbol] + ';';
					}
					return escapeBmpSymbol(symbol);
				});
				// Shorten a few escapes that represent two symbols, of which at least one
				// is within the ASCII range.
				if (useNamedReferences) {
					string = string
						.replace(/&gt;\u20D2/g, '&nvgt;')
						.replace(/&lt;\u20D2/g, '&nvlt;')
						.replace(/&#x66;&#x6A;/g, '&fjlig;');
				}
				// Encode non-ASCII symbols.
				if (useNamedReferences) {
					// Encode non-ASCII symbols that can be replaced with a named reference.
					string = string.replace(regexEncodeNonAscii, function(string) {
						// Note: there is no need to check `has(encodeMap, string)` here.
						return '&' + encodeMap[string] + ';';
					});
				}
				// Note: any remaining non-ASCII symbols are handled outside of the `if`.
			} else if (useNamedReferences) {
				// Apply named character references.
				// Encode `<>"'&` using named character references.
				if (!allowUnsafeSymbols) {
					string = string.replace(regexEscape, function(string) {
						return '&' + encodeMap[string] + ';'; // no need to check `has()` here
					});
				}
				// Shorten escapes that represent two symbols, of which at least one is
				// `<>"'&`.
				string = string
					.replace(/&gt;\u20D2/g, '&nvgt;')
					.replace(/&lt;\u20D2/g, '&nvlt;');
				// Encode non-ASCII symbols that can be replaced with a named reference.
				string = string.replace(regexEncodeNonAscii, function(string) {
					// Note: there is no need to check `has(encodeMap, string)` here.
					return '&' + encodeMap[string] + ';';
				});
			} else if (!allowUnsafeSymbols) {
				// Encode `<>"'&` using hexadecimal escapes, now that they’re not handled
				// using named character references.
				string = string.replace(regexEscape, escapeBmpSymbol);
			}
			return string
				// Encode astral symbols.
				.replace(regexAstralSymbols, function($0) {
					// https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
					var high = $0.charCodeAt(0);
					var low = $0.charCodeAt(1);
					var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
					return escapeCodePoint(codePoint);
				})
				// Encode any remaining BMP symbols that are not printable ASCII symbols
				// using a hexadecimal escape.
				.replace(regexBmpWhitelist, escapeBmpSymbol);
		};
		// Expose default options (so they can be overridden globally).
		encode.options = {
			'allowUnsafeSymbols': false,
			'encodeEverything': false,
			'strict': false,
			'useNamedReferences': false,
			'decimal' : false
		};
	
		var decode = function(html, options) {
			options = merge(options, decode.options);
			var strict = options.strict;
			if (strict && regexInvalidEntity.test(html)) {
				parseError('malformed character reference');
			}
			return html.replace(regexDecode, function($0, $1, $2, $3, $4, $5, $6, $7) {
				var codePoint;
				var semicolon;
				var decDigits;
				var hexDigits;
				var reference;
				var next;
				if ($1) {
					// Decode decimal escapes, e.g. `&#119558;`.
					decDigits = $1;
					semicolon = $2;
					if (strict && !semicolon) {
						parseError('character reference was not terminated by a semicolon');
					}
					codePoint = parseInt(decDigits, 10);
					return codePointToSymbol(codePoint, strict);
				}
				if ($3) {
					// Decode hexadecimal escapes, e.g. `&#x1D306;`.
					hexDigits = $3;
					semicolon = $4;
					if (strict && !semicolon) {
						parseError('character reference was not terminated by a semicolon');
					}
					codePoint = parseInt(hexDigits, 16);
					return codePointToSymbol(codePoint, strict);
				}
				if ($5) {
					// Decode named character references with trailing `;`, e.g. `&copy;`.
					reference = $5;
					if (has(decodeMap, reference)) {
						return decodeMap[reference];
					} else {
						// Ambiguous ampersand. https://mths.be/notes/ambiguous-ampersands
						if (strict) {
							parseError(
								'named character reference was not terminated by a semicolon'
							);
						}
						return $0;
					}
				}
				// If we’re still here, it’s a legacy reference for sure. No need for an
				// extra `if` check.
				// Decode named character references without trailing `;`, e.g. `&amp`
				// This is only a parse error if it gets converted to `&`, or if it is
				// followed by `=` in an attribute context.
				reference = $6;
				next = $7;
				if (next && options.isAttributeValue) {
					if (strict && next == '=') {
						parseError('`&` did not start a character reference');
					}
					return $0;
				} else {
					if (strict) {
						parseError(
							'named character reference was not terminated by a semicolon'
						);
					}
					// Note: there is no need to check `has(decodeMapLegacy, reference)`.
					return decodeMapLegacy[reference] + (next || '');
				}
			});
		};
		// Expose default options (so they can be overridden globally).
		decode.options = {
			'isAttributeValue': false,
			'strict': false
		};
	
		var escape = function(string) {
			return string.replace(regexEscape, function($0) {
				// Note: there is no need to check `has(escapeMap, $0)` here.
				return escapeMap[$0];
			});
		};
	
		/*--------------------------------------------------------------------------*/
	
		var he = {
			'version': '1.1.1',
			'encode': encode,
			'decode': decode,
			'escape': escape,
			'unescape': decode
		};
	
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return he;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}	else if (freeExports && !freeExports.nodeType) {
			if (freeModule) { // in Node.js, io.js, or RingoJS v0.8.0+
				freeModule.exports = he;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (var key in he) {
					has(he, key) && (freeExports[key] = he[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.he = he;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module), (function() { return this; }())))

/***/ },
/* 1776 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 1777 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.createLocation = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _resolvePathname = __webpack_require__(528);
	
	var _resolvePathname2 = _interopRequireDefault(_resolvePathname);
	
	var _valueEqual = __webpack_require__(2241);
	
	var _valueEqual2 = _interopRequireDefault(_valueEqual);
	
	var _PathUtils = __webpack_require__(843);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
	  var location = void 0;
	  if (typeof path === 'string') {
	    // Two-arg form: push(path, state)
	    location = (0, _PathUtils.parsePath)(path);
	    location.state = state;
	  } else {
	    // One-arg form: push(location)
	    location = _extends({}, path);
	
	    if (location.pathname === undefined) location.pathname = '';
	
	    if (location.search) {
	      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
	    } else {
	      location.search = '';
	    }
	
	    if (location.hash) {
	      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
	    } else {
	      location.hash = '';
	    }
	
	    if (state !== undefined && location.state === undefined) location.state = state;
	  }
	
	  try {
	    location.pathname = decodeURI(location.pathname);
	  } catch (e) {
	    if (e instanceof URIError) {
	      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
	    } else {
	      throw e;
	    }
	  }
	
	  if (key) location.key = key;
	
	  if (currentLocation) {
	    // Resolve incomplete/relative pathname relative to current location.
	    if (!location.pathname) {
	      location.pathname = currentLocation.pathname;
	    } else if (location.pathname.charAt(0) !== '/') {
	      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
	    }
	  } else {
	    // When there is no prior location and pathname is empty, set it to /
	    if (!location.pathname) {
	      location.pathname = '/';
	    }
	  }
	
	  return location;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
	};

/***/ },
/* 1778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(47);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(68);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(1777);
	
	var _PathUtils = __webpack_require__(843);
	
	var _createTransitionManager = __webpack_require__(1779);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(1776);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var getHistoryState = function getHistoryState() {
	  try {
	    return window.history.state || {};
	  } catch (e) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    return {};
	  }
	};
	
	/**
	 * Creates a history object that uses the HTML5 history API including
	 * pushState, replaceState, and the popstate event.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');
	
	  var globalHistory = window.history;
	  var canUseHistory = (0, _DOMUtils.supportsHistory)();
	  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();
	
	  var _props$forceRefresh = props.forceRefresh,
	      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
	      _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var getDOMLocation = function getDOMLocation(historyState) {
	    var _ref = historyState || {},
	        key = _ref.key,
	        state = _ref.state;
	
	    var _window$location = window.location,
	        pathname = _window$location.pathname,
	        search = _window$location.search,
	        hash = _window$location.hash;
	
	
	    var path = pathname + search + hash;
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path, state, key);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var handlePopState = function handlePopState(event) {
	    // Ignore extraneous popstate events in WebKit.
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;
	
	    handlePop(getDOMLocation(event.state));
	  };
	
	  var handleHashChange = function handleHashChange() {
	    handlePop(getDOMLocation(getHistoryState()));
	  };
	
	  var forceNextPop = false;
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of keys we've seen in sessionStorage.
	    // Instead, we just default to 0 for keys we don't know.
	
	    var toIndex = allKeys.indexOf(toLocation.key);
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allKeys.indexOf(fromLocation.key);
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  var initialLocation = getDOMLocation(getHistoryState());
	  var allKeys = [initialLocation.key];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return basename + (0, _PathUtils.createPath)(location);
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.pushState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.href = href;
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	          nextKeys.push(location.key);
	          allKeys = nextKeys;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');
	
	        window.location.href = href;
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.replaceState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.replace(href);
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	
	          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');
	
	        window.location.replace(href);
	      }
	    });
	  };
	
	  var go = function go(n) {
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 1779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(47);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createTransitionManager = function createTransitionManager() {
	  var prompt = null;
	
	  var setPrompt = function setPrompt(nextPrompt) {
	    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');
	
	    prompt = nextPrompt;
	
	    return function () {
	      if (prompt === nextPrompt) prompt = null;
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
	    // TODO: If another transition starts while we're still confirming
	    // the previous one, we may end up in a weird state. Figure out the
	    // best way to handle this.
	    if (prompt != null) {
	      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
	
	      if (typeof result === 'string') {
	        if (typeof getUserConfirmation === 'function') {
	          getUserConfirmation(result, callback);
	        } else {
	          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');
	
	          callback(true);
	        }
	      } else {
	        // Return false from a transition hook to cancel the transition.
	        callback(result !== false);
	      }
	    } else {
	      callback(true);
	    }
	  };
	
	  var listeners = [];
	
	  var appendListener = function appendListener(fn) {
	    var isActive = true;
	
	    var listener = function listener() {
	      if (isActive) fn.apply(undefined, arguments);
	    };
	
	    listeners.push(listener);
	
	    return function () {
	      isActive = false;
	      listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var notifyListeners = function notifyListeners() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    listeners.forEach(function (listener) {
	      return listener.apply(undefined, args);
	    });
	  };
	
	  return {
	    setPrompt: setPrompt,
	    confirmTransitionTo: confirmTransitionTo,
	    appendListener: appendListener,
	    notifyListeners: notifyListeners
	  };
	};
	
	exports.default = createTransitionManager;

/***/ },
/* 1780 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable no-var, prefer-template */
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function toHyphenLower(match) {
	  return '-' + match.toLowerCase()
	}
	
	function hyphenateStyleName(name) {
	  if (cache.hasOwnProperty(name)) {
	    return cache[name]
	  }
	
	  var hName = name.replace(uppercasePattern, toHyphenLower);
	  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
	}
	
	module.exports = hyphenateStyleName;


/***/ },
/* 1781 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = crossFade;
	
	var _isPrefixedValue = __webpack_require__(224);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#search=cross-fade
	var prefixes = ['-webkit-', ''];
	function crossFade(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('cross-fade(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/cross-fade\(/g, prefix + 'cross-fade(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1782 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cursor;
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var values = {
	  'zoom-in': true,
	  'zoom-out': true,
	  grab: true,
	  grabbing: true
	};
	
	function cursor(property, value) {
	  if (property === 'cursor' && values.hasOwnProperty(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = filter;
	
	var _isPrefixedValue = __webpack_require__(224);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#feat=css-filter-function
	var prefixes = ['-webkit-', ''];
	function filter(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('filter(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/filter\(/g, prefix + 'filter(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1784 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	var values = {
	  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
	  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
	};
	
	function flex(property, value) {
	  if (property === 'display' && values.hasOwnProperty(value)) {
	    return values[value];
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1785 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	function flexboxOld(property, value, style) {
	  if (property === 'flexDirection' && typeof value === 'string') {
	    if (value.indexOf('column') > -1) {
	      style.WebkitBoxOrient = 'vertical';
	    } else {
	      style.WebkitBoxOrient = 'horizontal';
	    }
	    if (value.indexOf('reverse') > -1) {
	      style.WebkitBoxDirection = 'reverse';
	    } else {
	      style.WebkitBoxDirection = 'normal';
	    }
	  }
	  if (alternativeProps.hasOwnProperty(property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _isPrefixedValue = __webpack_require__(224);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = imageSet;
	
	var _isPrefixedValue = __webpack_require__(224);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#feat=css-image-set
	var prefixes = ['-webkit-', ''];
	function imageSet(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('image-set(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/image-set\(/g, prefix + 'image-set(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1788 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	function position(property, value) {
	  if (property === 'position' && value === 'sticky') {
	    return ['-webkit-sticky', 'sticky'];
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1789 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(property, value) {
	  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateProperty = __webpack_require__(1582);
	
	var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);
	
	var _isPrefixedValue = __webpack_require__(224);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	var _capitalizeString = __webpack_require__(844);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true,
	  MozTransition: true,
	  MozTransitionProperty: true
	};
	
	
	var prefixMapping = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  ms: '-ms-'
	};
	
	function prefixValue(value, propertyPrefixMap) {
	  if ((0, _isPrefixedValue2.default)(value)) {
	    return value;
	  }
	
	  // only split multi values, not cubic beziers
	  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	  for (var i = 0, len = multipleValues.length; i < len; ++i) {
	    var singleValue = multipleValues[i];
	    var values = [singleValue];
	    for (var property in propertyPrefixMap) {
	      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);
	
	      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
	        var prefixes = propertyPrefixMap[property];
	        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
	          // join all prefixes and create a new value
	          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
	        }
	      }
	    }
	
	    multipleValues[i] = values.join(',');
	  }
	
	  return multipleValues.join(',');
	}
	
	function transition(property, value, style, propertyPrefixMap) {
	  // also check for already prefixed transitions
	  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
	    var outputValue = prefixValue(value, propertyPrefixMap);
	    // if the property is already prefixed
	    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-moz-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Webkit') > -1) {
	      return webkitOutput;
	    }
	
	    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-webkit-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Moz') > -1) {
	      return mozOutput;
	    }
	
	    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
	    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
	    return outputValue;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1791 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var w = ["Webkit"];
	var m = ["Moz"];
	var ms = ["ms"];
	var wm = ["Webkit", "Moz"];
	var wms = ["Webkit", "ms"];
	var wmms = ["Webkit", "Moz", "ms"];
	
	exports.default = {
	  plugins: [],
	  prefixMap: { "appearance": wm, "userSelect": wmms, "textEmphasisPosition": w, "textEmphasis": w, "textEmphasisStyle": w, "textEmphasisColor": w, "boxDecorationBreak": w, "clipPath": w, "maskImage": w, "maskMode": w, "maskRepeat": w, "maskPosition": w, "maskClip": w, "maskOrigin": w, "maskSize": w, "maskComposite": w, "mask": w, "maskBorderSource": w, "maskBorderMode": w, "maskBorderSlice": w, "maskBorderWidth": w, "maskBorderOutset": w, "maskBorderRepeat": w, "maskBorder": w, "maskType": w, "textDecorationStyle": w, "textDecorationSkip": w, "textDecorationLine": w, "textDecorationColor": w, "filter": w, "fontFeatureSettings": w, "breakAfter": wmms, "breakBefore": wmms, "breakInside": wmms, "columnCount": wm, "columnFill": wm, "columnGap": wm, "columnRule": wm, "columnRuleColor": wm, "columnRuleStyle": wm, "columnRuleWidth": wm, "columns": wm, "columnSpan": wm, "columnWidth": wm, "writingMode": wms, "flex": w, "flexBasis": w, "flexDirection": w, "flexGrow": w, "flexFlow": w, "flexShrink": w, "flexWrap": w, "alignContent": w, "alignItems": w, "alignSelf": w, "justifyContent": w, "order": w, "transform": w, "transformOrigin": w, "transformOriginX": w, "transformOriginY": w, "backfaceVisibility": w, "perspective": w, "perspectiveOrigin": w, "transformStyle": w, "transformOriginZ": w, "animation": w, "animationDelay": w, "animationDirection": w, "animationFillMode": w, "animationDuration": w, "animationIterationCount": w, "animationName": w, "animationPlayState": w, "animationTimingFunction": w, "backdropFilter": w, "fontKerning": w, "scrollSnapType": wms, "scrollSnapPointsX": wms, "scrollSnapPointsY": wms, "scrollSnapDestination": wms, "scrollSnapCoordinate": wms, "shapeImageThreshold": w, "shapeImageMargin": w, "shapeImageOutside": w, "hyphens": wmms, "flowInto": wms, "flowFrom": wms, "regionFragment": wms, "textAlignLast": m, "tabSize": m, "wrapFlow": ms, "wrapThrough": ms, "wrapMargin": ms, "gridTemplateColumns": ms, "gridTemplateRows": ms, "gridTemplateAreas": ms, "gridTemplate": ms, "gridAutoColumns": ms, "gridAutoRows": ms, "gridAutoFlow": ms, "grid": ms, "gridRowStart": ms, "gridColumnStart": ms, "gridRowEnd": ms, "gridRow": ms, "gridColumn": ms, "gridColumnEnd": ms, "gridColumnGap": ms, "gridRowGap": ms, "gridArea": ms, "gridGap": ms, "textSizeAdjust": wms, "borderImage": w, "borderImageOutset": w, "borderImageRepeat": w, "borderImageSlice": w, "borderImageSource": w, "borderImageWidth": w, "transitionDelay": w, "transitionDuration": w, "transitionProperty": w, "transitionTimingFunction": w }
	};
	module.exports = exports["default"];

/***/ },
/* 1792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixProperty;
	
	var _capitalizeString = __webpack_require__(844);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function prefixProperty(prefixProperties, property, style) {
	  if (prefixProperties.hasOwnProperty(property)) {
	    var requiredPrefixes = prefixProperties[property];
	    for (var i = 0, len = requiredPrefixes.length; i < len; ++i) {
	      style[requiredPrefixes[i] + (0, _capitalizeString2.default)(property)] = style[property];
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1793 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixValue;
	function prefixValue(plugins, property, value, style, metaData) {
	  for (var i = 0, len = plugins.length; i < len; ++i) {
	    var processedValue = plugins[i](property, value, style, metaData);
	
	    // we can stop processing if a value is returned
	    // as all plugin criteria are unique
	    if (processedValue) {
	      return processedValue;
	    }
	  }
	}
	module.exports = exports["default"];

/***/ },
/* 1794 */
/***/ function(module, exports) {

	exports = module.exports = stringify
	exports.getSerialize = serializer
	
	function stringify(obj, replacer, spaces, cycleReplacer) {
	  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
	}
	
	function serializer(replacer, cycleReplacer) {
	  var stack = [], keys = []
	
	  if (cycleReplacer == null) cycleReplacer = function(key, value) {
	    if (stack[0] === value) return "[Circular ~]"
	    return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]"
	  }
	
	  return function(key, value) {
	    if (stack.length > 0) {
	      var thisPos = stack.indexOf(this)
	      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
	      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
	      if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value)
	    }
	    else stack.push(value)
	
	    return replacer == null ? value : replacer.call(this, key, value)
	  }
	}


/***/ },
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	/**
	 * Recursively flattens `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flattenDeep([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, 3, 4, 5]
	 */
	function flattenDeep(array) {
	  var length = array ? array.length : 0;
	  return length ? baseFlatten(array, INFINITY) : [];
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = flattenDeep;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1808 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(190),
	    root = __webpack_require__(125);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 1809 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1856),
	    hashDelete = __webpack_require__(1857),
	    hashGet = __webpack_require__(1858),
	    hashHas = __webpack_require__(1859),
	    hashSet = __webpack_require__(1860);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 1810 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(190),
	    root = __webpack_require__(125);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 1811 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(190),
	    root = __webpack_require__(125);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 1812 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(490),
	    setCacheAdd = __webpack_require__(1880),
	    setCacheHas = __webpack_require__(1881);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 1813 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(125);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 1814 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(190),
	    root = __webpack_require__(125);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 1815 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 1816 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 1817 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1844),
	    isArguments = __webpack_require__(495),
	    isArray = __webpack_require__(89),
	    isIndex = __webpack_require__(493);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 1818 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 1819 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 1820 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(846);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ },
/* 1821 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 1822 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(1818),
	    isFlattenable = __webpack_require__(1861);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 1823 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(1850);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 1824 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(1823),
	    keys = __webpack_require__(313);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 1825 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 1826 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.has` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHas(object, key) {
	  return object != null && hasOwnProperty.call(object, key);
	}
	
	module.exports = baseHas;


/***/ },
/* 1827 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 1828 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(1821),
	    baseIsNaN = __webpack_require__(1831);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 1829 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(845),
	    equalArrays = __webpack_require__(851),
	    equalByTag = __webpack_require__(1851),
	    equalObjects = __webpack_require__(1852),
	    getTag = __webpack_require__(1854),
	    isArray = __webpack_require__(89),
	    isHostObject = __webpack_require__(854),
	    isTypedArray = __webpack_require__(1896);
	
	/** Used to compose bitmasks for comparison styles. */
	var PARTIAL_COMPARE_FLAG = 2;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = getTag(object);
	    objTag = objTag == argsTag ? objectTag : objTag;
	  }
	  if (!othIsArr) {
	    othTag = getTag(other);
	    othTag = othTag == argsTag ? objectTag : othTag;
	  }
	  var objIsObj = objTag == objectTag && !isHostObject(object),
	      othIsObj = othTag == objectTag && !isHostObject(other),
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	  }
	  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 1830 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(845),
	    baseIsEqual = __webpack_require__(848);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 1831 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ },
/* 1832 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(311),
	    isHostObject = __webpack_require__(854),
	    isMasked = __webpack_require__(1864),
	    isObject = __webpack_require__(192),
	    toSource = __webpack_require__(857);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 1833 */
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(496),
	    isObjectLike = __webpack_require__(228);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 1834 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(1865),
	    nativeKeys = __webpack_require__(1877);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 1835 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(846),
	    isArrayLike = __webpack_require__(191);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 1836 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(1830),
	    getMatchData = __webpack_require__(1853),
	    matchesStrictComparable = __webpack_require__(856);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 1837 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(848),
	    get = __webpack_require__(310),
	    hasIn = __webpack_require__(1891),
	    isKey = __webpack_require__(308),
	    isStrictComparable = __webpack_require__(855),
	    matchesStrictComparable = __webpack_require__(856),
	    toKey = __webpack_require__(227);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 1838 */
/***/ function(module, exports, __webpack_require__) {

	var basePickBy = __webpack_require__(1839);
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property identifiers to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, props) {
	  object = Object(object);
	  return basePickBy(object, props, function(value, key) {
	    return key in object;
	  });
	}
	
	module.exports = basePick;


/***/ },
/* 1839 */
/***/ function(module, exports) {

	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property identifiers to pick from.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, props, predicate) {
	  var index = -1,
	      length = props.length,
	      result = {};
	
	  while (++index < length) {
	    var key = props[index],
	        value = object[key];
	
	    if (predicate(value, key)) {
	      result[key] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = basePickBy;


/***/ },
/* 1840 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 1841 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(847);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 1842 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(1815);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = baseRest;


/***/ },
/* 1843 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 1844 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 1845 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(491),
	    isSymbol = __webpack_require__(312);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 1846 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 1847 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(492);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ },
/* 1848 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(125);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 1849 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(191);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 1850 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 1851 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(491),
	    Uint8Array = __webpack_require__(1813),
	    eq = __webpack_require__(494),
	    equalArrays = __webpack_require__(851),
	    mapToArray = __webpack_require__(1876),
	    setToArray = __webpack_require__(1882);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= UNORDERED_COMPARE_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 1852 */
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(313);
	
	/** Used to compose bitmasks for comparison styles. */
	var PARTIAL_COMPARE_FLAG = 2;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 1853 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(855),
	    keys = __webpack_require__(313);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 1854 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(1808),
	    Map = __webpack_require__(489),
	    Promise = __webpack_require__(1810),
	    Set = __webpack_require__(1811),
	    WeakMap = __webpack_require__(1814),
	    baseGetTag = __webpack_require__(1825),
	    toSource = __webpack_require__(857);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 1855 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 1856 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(309);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	module.exports = hashClear;


/***/ },
/* 1857 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	module.exports = hashDelete;


/***/ },
/* 1858 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(309);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 1859 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(309);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 1860 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(309);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 1861 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(491),
	    isArguments = __webpack_require__(495),
	    isArray = __webpack_require__(89);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 1862 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(494),
	    isArrayLike = __webpack_require__(191),
	    isIndex = __webpack_require__(493),
	    isObject = __webpack_require__(192);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 1863 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 1864 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(1848);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 1865 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 1866 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	module.exports = listCacheClear;


/***/ },
/* 1867 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(306);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 1868 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(306);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 1869 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(306);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 1870 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(306);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 1871 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(1809),
	    ListCache = __webpack_require__(305),
	    Map = __webpack_require__(489);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 1872 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(307);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 1873 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(307);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 1874 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(307);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 1875 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(307);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 1876 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 1877 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(1879);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 1878 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(852);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1879 */
1051,
/* 1880 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 1881 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 1882 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 1883 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(305);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	module.exports = stackClear;


/***/ },
/* 1884 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	module.exports = stackDelete;


/***/ },
/* 1885 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 1886 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 1887 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(305),
	    Map = __webpack_require__(489),
	    MapCache = __webpack_require__(490);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 1888 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(1897),
	    toString = __webpack_require__(1902);
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 1889 */
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(1843),
	    isIterateeCall = __webpack_require__(1862),
	    toInteger = __webpack_require__(860);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeMax = Math.max;
	
	/**
	 * Creates an array of elements split into groups the length of `size`.
	 * If `array` can't be split evenly, the final chunk will be the remaining
	 * elements.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The array to process.
	 * @param {number} [size=1] The length of each chunk
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the new array of chunks.
	 * @example
	 *
	 * _.chunk(['a', 'b', 'c', 'd'], 2);
	 * // => [['a', 'b'], ['c', 'd']]
	 *
	 * _.chunk(['a', 'b', 'c', 'd'], 3);
	 * // => [['a', 'b', 'c'], ['d']]
	 */
	function chunk(array, size, guard) {
	  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	    size = 1;
	  } else {
	    size = nativeMax(toInteger(size), 0);
	  }
	  var length = array ? array.length : 0;
	  if (!length || size < 1) {
	    return [];
	  }
	  var index = 0,
	      resIndex = 0,
	      result = Array(nativeCeil(length / size));
	
	  while (index < length) {
	    result[resIndex++] = baseSlice(array, index, (index += size));
	  }
	  return result;
	}
	
	module.exports = chunk;


/***/ },
/* 1890 */
/***/ function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(1826),
	    hasPath = __webpack_require__(853);
	
	/**
	 * Checks if `path` is a direct property of `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = { 'a': { 'b': 2 } };
	 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.has(object, 'a');
	 * // => true
	 *
	 * _.has(object, 'a.b');
	 * // => true
	 *
	 * _.has(object, ['a', 'b']);
	 * // => true
	 *
	 * _.has(other, 'a');
	 * // => false
	 */
	function has(object, path) {
	  return object != null && hasPath(object, path, baseHas);
	}
	
	module.exports = has;


/***/ },
/* 1891 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(1827),
	    hasPath = __webpack_require__(853);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 1892 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 1893 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(1828),
	    isArrayLike = __webpack_require__(191),
	    isString = __webpack_require__(1895),
	    toInteger = __webpack_require__(860),
	    values = __webpack_require__(1903);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Checks if `value` is in `collection`. If `collection` is a string, it's
	 * checked for a substring of `value`, otherwise
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'a': 1, 'b': 2 }, 1);
	 * // => true
	 *
	 * _.includes('abcd', 'bc');
	 * // => true
	 */
	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike(collection) ? collection : values(collection);
	  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	  var length = collection.length;
	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }
	  return isString(collection)
	    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	}
	
	module.exports = includes;


/***/ },
/* 1894 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(191),
	    isObjectLike = __webpack_require__(228);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 1895 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(89),
	    isObjectLike = __webpack_require__(228);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 1896 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(1833),
	    baseUnary = __webpack_require__(1846),
	    nodeUtil = __webpack_require__(1878);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 1897 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(490);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 1898 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(492),
	    baseFlatten = __webpack_require__(1822),
	    basePick = __webpack_require__(1838),
	    baseRest = __webpack_require__(1842),
	    toKey = __webpack_require__(227);
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [props] The property identifiers to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = baseRest(function(object, props) {
	  return object == null ? {} : basePick(object, arrayMap(baseFlatten(props, 1), toKey));
	});
	
	module.exports = pick;


/***/ },
/* 1899 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(1840),
	    basePropertyDeep = __webpack_require__(1841),
	    isKey = __webpack_require__(308),
	    toKey = __webpack_require__(227);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 1900 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(1901);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 1901 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(192),
	    isSymbol = __webpack_require__(312);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 1902 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(1845);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 1903 */
/***/ function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(1847),
	    keys = __webpack_require__(313);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object ? baseValues(object, keys(object)) : [];
	}
	
	module.exports = values;


/***/ },
/* 1904 */
/***/ function(module, exports) {

	// ISC @ Julien Fontanet
	
	'use strict'
	
	// ===================================================================
	
	var construct = typeof Reflect !== 'undefined' ? Reflect.construct : undefined
	var defineProperty = Object.defineProperty
	
	// -------------------------------------------------------------------
	
	var captureStackTrace = Error.captureStackTrace
	if (captureStackTrace === undefined) {
	  captureStackTrace = function captureStackTrace (error) {
	    var container = new Error()
	
	    defineProperty(error, 'stack', {
	      configurable: true,
	      get: function getStack () {
	        var stack = container.stack
	
	        // Replace property with value for faster future accesses.
	        defineProperty(this, 'stack', {
	          configurable: true,
	          value: stack,
	          writable: true
	        })
	
	        return stack
	      },
	      set: function setStack (stack) {
	        defineProperty(error, 'stack', {
	          configurable: true,
	          value: stack,
	          writable: true
	        })
	      }
	    })
	  }
	}
	
	// -------------------------------------------------------------------
	
	function BaseError (message) {
	  if (message !== undefined) {
	    defineProperty(this, 'message', {
	      configurable: true,
	      value: message,
	      writable: true
	    })
	  }
	
	  var cname = this.constructor.name
	  if (
	    cname !== undefined &&
	    cname !== this.name
	  ) {
	    defineProperty(this, 'name', {
	      configurable: true,
	      value: cname,
	      writable: true
	    })
	  }
	
	  captureStackTrace(this, this.constructor)
	}
	
	BaseError.prototype = Object.create(Error.prototype, {
	  // See: https://github.com/JsCommunity/make-error/issues/4
	  constructor: {
	    configurable: true,
	    value: BaseError,
	    writable: true
	  }
	})
	
	// -------------------------------------------------------------------
	
	// Sets the name of a function if possible (depends of the JS engine).
	var setFunctionName = (function () {
	  function setFunctionName (fn, name) {
	    return defineProperty(fn, 'name', {
	      configurable: true,
	      value: name
	    })
	  }
	  try {
	    var f = function () {}
	    setFunctionName(f, 'foo')
	    if (f.name === 'foo') {
	      return setFunctionName
	    }
	  } catch (_) {}
	})()
	
	// -------------------------------------------------------------------
	
	function makeError (constructor, super_) {
	  if (super_ == null || super_ === Error) {
	    super_ = BaseError
	  } else if (typeof super_ !== 'function') {
	    throw new TypeError('super_ should be a function')
	  }
	
	  var name
	  if (typeof constructor === 'string') {
	    name = constructor
	    constructor = construct !== undefined
	      ? function () { return construct(super_, arguments, this.constructor) }
	      : function () { super_.apply(this, arguments) }
	
	    // If the name can be set, do it once and for all.
	    if (setFunctionName !== undefined) {
	      setFunctionName(constructor, name)
	      name = undefined
	    }
	  } else if (typeof constructor !== 'function') {
	    throw new TypeError('constructor should be either a string or a function')
	  }
	
	  // Also register the super constructor also as `constructor.super_` just
	  // like Node's `util.inherits()`.
	  constructor.super_ = constructor['super'] = super_
	
	  var properties = {
	    constructor: {
	      configurable: true,
	      value: constructor,
	      writable: true
	    }
	  }
	
	  // If the name could not be set on the constructor, set it on the
	  // prototype.
	  if (name !== undefined) {
	    properties.name = {
	      configurable: true,
	      value: name,
	      writable: true
	    }
	  }
	  constructor.prototype = Object.create(super_.prototype, properties)
	
	  return constructor
	}
	exports = module.exports = makeError
	exports.BaseError = BaseError


/***/ },
/* 1905 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = deprecated;
	
	var _warning = __webpack_require__(47);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function deprecated(validator, reason) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] != null) {
	      var messageKey = componentName + '.' + propName;
	
	      (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));
	
	      warned[messageKey] = true;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}
	
	/* eslint-disable no-underscore-dangle */
	function _resetWarned() {
	  warned = {};
	}
	
	deprecated._resetWarned = _resetWarned;
	/* eslint-enable no-underscore-dangle */
	
	module.exports = exports['default'];

/***/ },
/* 1906 */
[2408, 1907],
/* 1907 */
1016,
/* 1908 */
[2245, 1910, 1909, 861],
/* 1909 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(499);
	
	var has = Object.prototype.hasOwnProperty;
	var isArray = Array.isArray;
	
	var defaults = {
	    allowDots: false,
	    allowPrototypes: false,
	    arrayLimit: 20,
	    charset: 'utf-8',
	    charsetSentinel: false,
	    comma: false,
	    decoder: utils.decode,
	    delimiter: '&',
	    depth: 5,
	    ignoreQueryPrefix: false,
	    interpretNumericEntities: false,
	    parameterLimit: 1000,
	    parseArrays: true,
	    plainObjects: false,
	    strictNullHandling: false
	};
	
	var interpretNumericEntities = function (str) {
	    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
	        return String.fromCharCode(parseInt(numberStr, 10));
	    });
	};
	
	var parseArrayValue = function (val, options) {
	    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
	        return val.split(',');
	    }
	
	    return val;
	};
	
	var maybeMap = function maybeMap(val, fn) {
	    if (isArray(val)) {
	        var mapped = [];
	        for (var i = 0; i < val.length; i += 1) {
	            mapped.push(fn(val[i]));
	        }
	        return mapped;
	    }
	    return fn(val);
	};
	
	// This is what browsers will submit when the ✓ character occurs in an
	// application/x-www-form-urlencoded body and the encoding of the page containing
	// the form is iso-8859-1, or when the submitted form has an accept-charset
	// attribute of iso-8859-1. Presumably also with other charsets that do not contain
	// the ✓ character, such as us-ascii.
	var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
	
	// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
	var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
	
	var parseValues = function parseQueryStringValues(str, options) {
	    var obj = {};
	    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
	    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
	    var parts = cleanStr.split(options.delimiter, limit);
	    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
	    var i;
	
	    var charset = options.charset;
	    if (options.charsetSentinel) {
	        for (i = 0; i < parts.length; ++i) {
	            if (parts[i].indexOf('utf8=') === 0) {
	                if (parts[i] === charsetSentinel) {
	                    charset = 'utf-8';
	                } else if (parts[i] === isoSentinel) {
	                    charset = 'iso-8859-1';
	                }
	                skipIndex = i;
	                i = parts.length; // The eslint settings do not allow break;
	            }
	        }
	    }
	
	    for (i = 0; i < parts.length; ++i) {
	        if (i === skipIndex) {
	            continue;
	        }
	        var part = parts[i];
	
	        var bracketEqualsPos = part.indexOf(']=');
	        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
	
	        var key, val;
	        if (pos === -1) {
	            key = options.decoder(part, defaults.decoder, charset, 'key');
	            val = options.strictNullHandling ? null : '';
	        } else {
	            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
	            val = maybeMap(
	                parseArrayValue(part.slice(pos + 1), options),
	                function (encodedVal) {
	                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
	                }
	            );
	        }
	
	        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
	            val = interpretNumericEntities(val);
	        }
	
	        if (part.indexOf('[]=') > -1) {
	            val = isArray(val) ? [val] : val;
	        }
	
	        if (has.call(obj, key)) {
	            obj[key] = utils.combine(obj[key], val);
	        } else {
	            obj[key] = val;
	        }
	    }
	
	    return obj;
	};
	
	var parseObject = function (chain, val, options, valuesParsed) {
	    var leaf = valuesParsed ? val : parseArrayValue(val, options);
	
	    for (var i = chain.length - 1; i >= 0; --i) {
	        var obj;
	        var root = chain[i];
	
	        if (root === '[]' && options.parseArrays) {
	            obj = [].concat(leaf);
	        } else {
	            obj = options.plainObjects ? Object.create(null) : {};
	            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
	            var index = parseInt(cleanRoot, 10);
	            if (!options.parseArrays && cleanRoot === '') {
	                obj = { 0: leaf };
	            } else if (
	                !isNaN(index)
	                && root !== cleanRoot
	                && String(index) === cleanRoot
	                && index >= 0
	                && (options.parseArrays && index <= options.arrayLimit)
	            ) {
	                obj = [];
	                obj[index] = leaf;
	            } else {
	                obj[cleanRoot] = leaf;
	            }
	        }
	
	        leaf = obj; // eslint-disable-line no-param-reassign
	    }
	
	    return leaf;
	};
	
	var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
	    if (!givenKey) {
	        return;
	    }
	
	    // Transform dot notation to bracket notation
	    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
	
	    // The regex chunks
	
	    var brackets = /(\[[^[\]]*])/;
	    var child = /(\[[^[\]]*])/g;
	
	    // Get the parent
	
	    var segment = options.depth > 0 && brackets.exec(key);
	    var parent = segment ? key.slice(0, segment.index) : key;
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (parent) {
	        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
	        if (!options.plainObjects && has.call(Object.prototype, parent)) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	
	        keys.push(parent);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
	        i += 1;
	        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	        keys.push(segment[1]);
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return parseObject(keys, val, options, valuesParsed);
	};
	
	var normalizeParseOptions = function normalizeParseOptions(opts) {
	    if (!opts) {
	        return defaults;
	    }
	
	    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
	        throw new TypeError('Decoder has to be a function.');
	    }
	
	    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
	        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
	    }
	    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;
	
	    return {
	        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
	        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
	        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
	        charset: charset,
	        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
	        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
	        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
	        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
	        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
	        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
	        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
	        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
	        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
	        parseArrays: opts.parseArrays !== false,
	        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
	        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
	    };
	};
	
	module.exports = function (str, opts) {
	    var options = normalizeParseOptions(opts);
	
	    if (str === '' || str === null || typeof str === 'undefined') {
	        return options.plainObjects ? Object.create(null) : {};
	    }
	
	    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
	    var obj = options.plainObjects ? Object.create(null) : {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
	        obj = utils.merge(obj, newObj, options);
	    }
	
	    return utils.compact(obj);
	};


/***/ },
/* 1910 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(499);
	var formats = __webpack_require__(861);
	var has = Object.prototype.hasOwnProperty;
	
	var arrayPrefixGenerators = {
	    brackets: function brackets(prefix) {
	        return prefix + '[]';
	    },
	    comma: 'comma',
	    indices: function indices(prefix, key) {
	        return prefix + '[' + key + ']';
	    },
	    repeat: function repeat(prefix) {
	        return prefix;
	    }
	};
	
	var isArray = Array.isArray;
	var push = Array.prototype.push;
	var pushToArray = function (arr, valueOrArray) {
	    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
	};
	
	var toISO = Date.prototype.toISOString;
	
	var defaultFormat = formats['default'];
	var defaults = {
	    addQueryPrefix: false,
	    allowDots: false,
	    charset: 'utf-8',
	    charsetSentinel: false,
	    delimiter: '&',
	    encode: true,
	    encoder: utils.encode,
	    encodeValuesOnly: false,
	    format: defaultFormat,
	    formatter: formats.formatters[defaultFormat],
	    // deprecated
	    indices: false,
	    serializeDate: function serializeDate(date) {
	        return toISO.call(date);
	    },
	    skipNulls: false,
	    strictNullHandling: false
	};
	
	var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
	    return typeof v === 'string'
	        || typeof v === 'number'
	        || typeof v === 'boolean'
	        || typeof v === 'symbol'
	        || typeof v === 'bigint';
	};
	
	var stringify = function stringify(
	    object,
	    prefix,
	    generateArrayPrefix,
	    strictNullHandling,
	    skipNulls,
	    encoder,
	    filter,
	    sort,
	    allowDots,
	    serializeDate,
	    formatter,
	    encodeValuesOnly,
	    charset
	) {
	    var obj = object;
	    if (typeof filter === 'function') {
	        obj = filter(prefix, obj);
	    } else if (obj instanceof Date) {
	        obj = serializeDate(obj);
	    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
	        obj = obj.join(',');
	    }
	
	    if (obj === null) {
	        if (strictNullHandling) {
	            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key') : prefix;
	        }
	
	        obj = '';
	    }
	
	    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
	        if (encoder) {
	            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key');
	            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value'))];
	        }
	        return [formatter(prefix) + '=' + formatter(String(obj))];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys;
	    if (isArray(filter)) {
	        objKeys = filter;
	    } else {
	        var keys = Object.keys(obj);
	        objKeys = sort ? keys.sort(sort) : keys;
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        if (isArray(obj)) {
	            pushToArray(values, stringify(
	                obj[key],
	                typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix,
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly,
	                charset
	            ));
	        } else {
	            pushToArray(values, stringify(
	                obj[key],
	                prefix + (allowDots ? '.' + key : '[' + key + ']'),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly,
	                charset
	            ));
	        }
	    }
	
	    return values;
	};
	
	var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
	    if (!opts) {
	        return defaults;
	    }
	
	    if (opts.encoder !== null && opts.encoder !== undefined && typeof opts.encoder !== 'function') {
	        throw new TypeError('Encoder has to be a function.');
	    }
	
	    var charset = opts.charset || defaults.charset;
	    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
	        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
	    }
	
	    var format = formats['default'];
	    if (typeof opts.format !== 'undefined') {
	        if (!has.call(formats.formatters, opts.format)) {
	            throw new TypeError('Unknown format option provided.');
	        }
	        format = opts.format;
	    }
	    var formatter = formats.formatters[format];
	
	    var filter = defaults.filter;
	    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
	        filter = opts.filter;
	    }
	
	    return {
	        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
	        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
	        charset: charset,
	        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
	        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
	        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
	        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
	        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
	        filter: filter,
	        formatter: formatter,
	        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
	        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
	        sort: typeof opts.sort === 'function' ? opts.sort : null,
	        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
	    };
	};
	
	module.exports = function (object, opts) {
	    var obj = object;
	    var options = normalizeStringifyOptions(opts);
	
	    var objKeys;
	    var filter;
	
	    if (typeof options.filter === 'function') {
	        filter = options.filter;
	        obj = filter('', obj);
	    } else if (isArray(options.filter)) {
	        filter = options.filter;
	        objKeys = filter;
	    }
	
	    var keys = [];
	
	    if (typeof obj !== 'object' || obj === null) {
	        return '';
	    }
	
	    var arrayFormat;
	    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
	        arrayFormat = opts.arrayFormat;
	    } else if (opts && 'indices' in opts) {
	        arrayFormat = opts.indices ? 'indices' : 'repeat';
	    } else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
	
	    if (!objKeys) {
	        objKeys = Object.keys(obj);
	    }
	
	    if (options.sort) {
	        objKeys.sort(options.sort);
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (options.skipNulls && obj[key] === null) {
	            continue;
	        }
	        pushToArray(keys, stringify(
	            obj[key],
	            key,
	            generateArrayPrefix,
	            options.strictNullHandling,
	            options.skipNulls,
	            options.encode ? options.encoder : null,
	            options.filter,
	            options.sort,
	            options.allowDots,
	            options.serializeDate,
	            options.formatter,
	            options.encodeValuesOnly,
	            options.charset
	        ));
	    }
	
	    var joined = keys.join(options.delimiter);
	    var prefix = options.addQueryPrefix === true ? '?' : '';
	
	    if (options.charsetSentinel) {
	        if (options.charset === 'iso-8859-1') {
	            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
	            prefix += 'utf8=%26%2310003%3B&';
	        } else {
	            // encodeURIComponent('✓')
	            prefix += 'utf8=%E2%9C%93&';
	        }
	    }
	
	    return joined.length > 0 ? prefix + joined : '';
	};


/***/ },
/* 1911 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ },
/* 1912 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ },
/* 1913 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(231)))

/***/ },
/* 1914 */
/***/ function(module, exports) {

	function RavenConfigError(message) {
	  this.name = 'RavenConfigError';
	  this.message = message;
	}
	RavenConfigError.prototype = new Error();
	RavenConfigError.prototype.constructor = RavenConfigError;
	
	module.exports = RavenConfigError;


/***/ },
/* 1915 */
/***/ function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(501);
	
	var wrapMethod = function(console, level, callback) {
	  var originalConsoleLevel = console[level];
	  var originalConsole = console;
	
	  if (!(level in console)) {
	    return;
	  }
	
	  var sentryLevel = level === 'warn' ? 'warning' : level;
	
	  console[level] = function() {
	    var args = [].slice.call(arguments);
	
	    var msg = utils.safeJoin(args, ' ');
	    var data = {level: sentryLevel, logger: 'console', extra: {arguments: args}};
	
	    if (level === 'assert') {
	      if (args[0] === false) {
	        // Default browsers message
	        msg =
	          'Assertion failed: ' + (utils.safeJoin(args.slice(1), ' ') || 'console.assert');
	        data.extra.arguments = args.slice(1);
	        callback && callback(msg, data);
	      }
	    } else {
	      callback && callback(msg, data);
	    }
	
	    // this fails for some browsers. :(
	    if (originalConsoleLevel) {
	      // IE9 doesn't allow calling apply on console functions directly
	      // See: https://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function#answer-5473193
	      Function.prototype.apply.call(originalConsoleLevel, originalConsole, args);
	    }
	  };
	};
	
	module.exports = {
	  wrapMethod: wrapMethod
	};


/***/ },
/* 1916 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*global XDomainRequest:false */
	
	var TraceKit = __webpack_require__(1917);
	var stringify = __webpack_require__(864);
	var md5 = __webpack_require__(1918);
	var RavenConfigError = __webpack_require__(1914);
	
	var utils = __webpack_require__(501);
	var isErrorEvent = utils.isErrorEvent;
	var isDOMError = utils.isDOMError;
	var isDOMException = utils.isDOMException;
	var isError = utils.isError;
	var isObject = utils.isObject;
	var isPlainObject = utils.isPlainObject;
	var isUndefined = utils.isUndefined;
	var isFunction = utils.isFunction;
	var isString = utils.isString;
	var isArray = utils.isArray;
	var isEmptyObject = utils.isEmptyObject;
	var each = utils.each;
	var objectMerge = utils.objectMerge;
	var truncate = utils.truncate;
	var objectFrozen = utils.objectFrozen;
	var hasKey = utils.hasKey;
	var joinRegExp = utils.joinRegExp;
	var urlencode = utils.urlencode;
	var uuid4 = utils.uuid4;
	var htmlTreeAsString = utils.htmlTreeAsString;
	var isSameException = utils.isSameException;
	var isSameStacktrace = utils.isSameStacktrace;
	var parseUrl = utils.parseUrl;
	var fill = utils.fill;
	var supportsFetch = utils.supportsFetch;
	var supportsReferrerPolicy = utils.supportsReferrerPolicy;
	var serializeKeysForMessage = utils.serializeKeysForMessage;
	var serializeException = utils.serializeException;
	var sanitize = utils.sanitize;
	
	var wrapConsoleMethod = __webpack_require__(1915).wrapMethod;
	
	var dsnKeys = 'source protocol user pass host port path'.split(' '),
	  dsnPattern = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/;
	
	function now() {
	  return +new Date();
	}
	
	// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
	var _window =
	  typeof window !== 'undefined'
	    ? window
	    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	var _document = _window.document;
	var _navigator = _window.navigator;
	
	function keepOriginalCallback(original, callback) {
	  return isFunction(callback)
	    ? function(data) {
	        return callback(data, original);
	      }
	    : callback;
	}
	
	// First, check for JSON support
	// If there is no JSON, we no-op the core features of Raven
	// since JSON is required to encode the payload
	function Raven() {
	  this._hasJSON = !!(typeof JSON === 'object' && JSON.stringify);
	  // Raven can run in contexts where there's no document (react-native)
	  this._hasDocument = !isUndefined(_document);
	  this._hasNavigator = !isUndefined(_navigator);
	  this._lastCapturedException = null;
	  this._lastData = null;
	  this._lastEventId = null;
	  this._globalServer = null;
	  this._globalKey = null;
	  this._globalProject = null;
	  this._globalContext = {};
	  this._globalOptions = {
	    // SENTRY_RELEASE can be injected by https://github.com/getsentry/sentry-webpack-plugin
	    release: _window.SENTRY_RELEASE && _window.SENTRY_RELEASE.id,
	    logger: 'javascript',
	    ignoreErrors: [],
	    ignoreUrls: [],
	    whitelistUrls: [],
	    includePaths: [],
	    headers: null,
	    collectWindowErrors: true,
	    captureUnhandledRejections: true,
	    maxMessageLength: 0,
	    // By default, truncates URL values to 250 chars
	    maxUrlLength: 250,
	    stackTraceLimit: 50,
	    autoBreadcrumbs: true,
	    instrument: true,
	    sampleRate: 1,
	    sanitizeKeys: []
	  };
	  this._fetchDefaults = {
	    method: 'POST',
	    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
	    // https://caniuse.com/#feat=referrer-policy
	    // It doesn't. And it throw exception instead of ignoring this parameter...
	    // REF: https://github.com/getsentry/raven-js/issues/1233
	    referrerPolicy: supportsReferrerPolicy() ? 'origin' : ''
	  };
	  this._ignoreOnError = 0;
	  this._isRavenInstalled = false;
	  this._originalErrorStackTraceLimit = Error.stackTraceLimit;
	  // capture references to window.console *and* all its methods first
	  // before the console plugin has a chance to monkey patch
	  this._originalConsole = _window.console || {};
	  this._originalConsoleMethods = {};
	  this._plugins = [];
	  this._startTime = now();
	  this._wrappedBuiltIns = [];
	  this._breadcrumbs = [];
	  this._lastCapturedEvent = null;
	  this._keypressTimeout;
	  this._location = _window.location;
	  this._lastHref = this._location && this._location.href;
	  this._resetBackoff();
	
	  // eslint-disable-next-line guard-for-in
	  for (var method in this._originalConsole) {
	    this._originalConsoleMethods[method] = this._originalConsole[method];
	  }
	}
	
	/*
	 * The core Raven singleton
	 *
	 * @this {Raven}
	 */
	
	Raven.prototype = {
	  // Hardcode version string so that raven source can be loaded directly via
	  // webpack (using a build step causes webpack #1617). Grunt verifies that
	  // this value matches package.json during build.
	  //   See: https://github.com/getsentry/raven-js/issues/465
	  VERSION: '3.27.2',
	
	  debug: false,
	
	  TraceKit: TraceKit, // alias to TraceKit
	
	  /*
	     * Configure Raven with a DSN and extra options
	     *
	     * @param {string} dsn The public Sentry DSN
	     * @param {object} options Set of global options [optional]
	     * @return {Raven}
	     */
	  config: function(dsn, options) {
	    var self = this;
	
	    if (self._globalServer) {
	      this._logDebug('error', 'Error: Raven has already been configured');
	      return self;
	    }
	    if (!dsn) return self;
	
	    var globalOptions = self._globalOptions;
	
	    // merge in options
	    if (options) {
	      each(options, function(key, value) {
	        // tags and extra are special and need to be put into context
	        if (key === 'tags' || key === 'extra' || key === 'user') {
	          self._globalContext[key] = value;
	        } else {
	          globalOptions[key] = value;
	        }
	      });
	    }
	
	    self.setDSN(dsn);
	
	    // "Script error." is hard coded into browsers for errors that it can't read.
	    // this is the result of a script being pulled in from an external domain and CORS.
	    globalOptions.ignoreErrors.push(/^Script error\.?$/);
	    globalOptions.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/);
	
	    // join regexp rules into one big rule
	    globalOptions.ignoreErrors = joinRegExp(globalOptions.ignoreErrors);
	    globalOptions.ignoreUrls = globalOptions.ignoreUrls.length
	      ? joinRegExp(globalOptions.ignoreUrls)
	      : false;
	    globalOptions.whitelistUrls = globalOptions.whitelistUrls.length
	      ? joinRegExp(globalOptions.whitelistUrls)
	      : false;
	    globalOptions.includePaths = joinRegExp(globalOptions.includePaths);
	    globalOptions.maxBreadcrumbs = Math.max(
	      0,
	      Math.min(globalOptions.maxBreadcrumbs || 100, 100)
	    ); // default and hard limit is 100
	
	    var autoBreadcrumbDefaults = {
	      xhr: true,
	      console: true,
	      dom: true,
	      location: true,
	      sentry: true
	    };
	
	    var autoBreadcrumbs = globalOptions.autoBreadcrumbs;
	    if ({}.toString.call(autoBreadcrumbs) === '[object Object]') {
	      autoBreadcrumbs = objectMerge(autoBreadcrumbDefaults, autoBreadcrumbs);
	    } else if (autoBreadcrumbs !== false) {
	      autoBreadcrumbs = autoBreadcrumbDefaults;
	    }
	    globalOptions.autoBreadcrumbs = autoBreadcrumbs;
	
	    var instrumentDefaults = {
	      tryCatch: true
	    };
	
	    var instrument = globalOptions.instrument;
	    if ({}.toString.call(instrument) === '[object Object]') {
	      instrument = objectMerge(instrumentDefaults, instrument);
	    } else if (instrument !== false) {
	      instrument = instrumentDefaults;
	    }
	    globalOptions.instrument = instrument;
	
	    TraceKit.collectWindowErrors = !!globalOptions.collectWindowErrors;
	
	    // return for chaining
	    return self;
	  },
	
	  /*
	     * Installs a global window.onerror error handler
	     * to capture and report uncaught exceptions.
	     * At this point, install() is required to be called due
	     * to the way TraceKit is set up.
	     *
	     * @return {Raven}
	     */
	  install: function() {
	    var self = this;
	    if (self.isSetup() && !self._isRavenInstalled) {
	      TraceKit.report.subscribe(function() {
	        self._handleOnErrorStackInfo.apply(self, arguments);
	      });
	
	      if (self._globalOptions.captureUnhandledRejections) {
	        self._attachPromiseRejectionHandler();
	      }
	
	      self._patchFunctionToString();
	
	      if (self._globalOptions.instrument && self._globalOptions.instrument.tryCatch) {
	        self._instrumentTryCatch();
	      }
	
	      if (self._globalOptions.autoBreadcrumbs) self._instrumentBreadcrumbs();
	
	      // Install all of the plugins
	      self._drainPlugins();
	
	      self._isRavenInstalled = true;
	    }
	
	    Error.stackTraceLimit = self._globalOptions.stackTraceLimit;
	    return this;
	  },
	
	  /*
	     * Set the DSN (can be called multiple time unlike config)
	     *
	     * @param {string} dsn The public Sentry DSN
	     */
	  setDSN: function(dsn) {
	    var self = this,
	      uri = self._parseDSN(dsn),
	      lastSlash = uri.path.lastIndexOf('/'),
	      path = uri.path.substr(1, lastSlash);
	
	    self._dsn = dsn;
	    self._globalKey = uri.user;
	    self._globalSecret = uri.pass && uri.pass.substr(1);
	    self._globalProject = uri.path.substr(lastSlash + 1);
	
	    self._globalServer = self._getGlobalServer(uri);
	
	    self._globalEndpoint =
	      self._globalServer + '/' + path + 'api/' + self._globalProject + '/store/';
	
	    // Reset backoff state since we may be pointing at a
	    // new project/server
	    this._resetBackoff();
	  },
	
	  /*
	     * Wrap code within a context so Raven can capture errors
	     * reliably across domains that is executed immediately.
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The callback to be immediately executed within the context
	     * @param {array} args An array of arguments to be called with the callback [optional]
	     */
	  context: function(options, func, args) {
	    if (isFunction(options)) {
	      args = func || [];
	      func = options;
	      options = {};
	    }
	
	    return this.wrap(options, func).apply(this, args);
	  },
	
	  /*
	     * Wrap code within a context and returns back a new function to be executed
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The function to be wrapped in a new context
	     * @param {function} _before A function to call before the try/catch wrapper [optional, private]
	     * @return {function} The newly wrapped functions with a context
	     */
	  wrap: function(options, func, _before) {
	    var self = this;
	    // 1 argument has been passed, and it's not a function
	    // so just return it
	    if (isUndefined(func) && !isFunction(options)) {
	      return options;
	    }
	
	    // options is optional
	    if (isFunction(options)) {
	      func = options;
	      options = undefined;
	    }
	
	    // At this point, we've passed along 2 arguments, and the second one
	    // is not a function either, so we'll just return the second argument.
	    if (!isFunction(func)) {
	      return func;
	    }
	
	    // We don't wanna wrap it twice!
	    try {
	      if (func.__raven__) {
	        return func;
	      }
	
	      // If this has already been wrapped in the past, return that
	      if (func.__raven_wrapper__) {
	        return func.__raven_wrapper__;
	      }
	    } catch (e) {
	      // Just accessing custom props in some Selenium environments
	      // can cause a "Permission denied" exception (see raven-js#495).
	      // Bail on wrapping and return the function as-is (defers to window.onerror).
	      return func;
	    }
	
	    function wrapped() {
	      var args = [],
	        i = arguments.length,
	        deep = !options || (options && options.deep !== false);
	
	      if (_before && isFunction(_before)) {
	        _before.apply(this, arguments);
	      }
	
	      // Recursively wrap all of a function's arguments that are
	      // functions themselves.
	      while (i--) args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];
	
	      try {
	        // Attempt to invoke user-land function
	        // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
	        //       means Raven caught an error invoking your application code. This is
	        //       expected behavior and NOT indicative of a bug with Raven.js.
	        return func.apply(this, args);
	      } catch (e) {
	        self._ignoreNextOnError();
	        self.captureException(e, options);
	        throw e;
	      }
	    }
	
	    // copy over properties of the old function
	    for (var property in func) {
	      if (hasKey(func, property)) {
	        wrapped[property] = func[property];
	      }
	    }
	    wrapped.prototype = func.prototype;
	
	    func.__raven_wrapper__ = wrapped;
	    // Signal that this function has been wrapped/filled already
	    // for both debugging and to prevent it to being wrapped/filled twice
	    wrapped.__raven__ = true;
	    wrapped.__orig__ = func;
	
	    return wrapped;
	  },
	
	  /**
	   * Uninstalls the global error handler.
	   *
	   * @return {Raven}
	   */
	  uninstall: function() {
	    TraceKit.report.uninstall();
	
	    this._detachPromiseRejectionHandler();
	    this._unpatchFunctionToString();
	    this._restoreBuiltIns();
	    this._restoreConsole();
	
	    Error.stackTraceLimit = this._originalErrorStackTraceLimit;
	    this._isRavenInstalled = false;
	
	    return this;
	  },
	
	  /**
	   * Callback used for `unhandledrejection` event
	   *
	   * @param {PromiseRejectionEvent} event An object containing
	   *   promise: the Promise that was rejected
	   *   reason: the value with which the Promise was rejected
	   * @return void
	   */
	  _promiseRejectionHandler: function(event) {
	    this._logDebug('debug', 'Raven caught unhandled promise rejection:', event);
	    this.captureException(event.reason, {
	      mechanism: {
	        type: 'onunhandledrejection',
	        handled: false
	      }
	    });
	  },
	
	  /**
	   * Installs the global promise rejection handler.
	   *
	   * @return {raven}
	   */
	  _attachPromiseRejectionHandler: function() {
	    this._promiseRejectionHandler = this._promiseRejectionHandler.bind(this);
	    _window.addEventListener &&
	      _window.addEventListener('unhandledrejection', this._promiseRejectionHandler);
	    return this;
	  },
	
	  /**
	   * Uninstalls the global promise rejection handler.
	   *
	   * @return {raven}
	   */
	  _detachPromiseRejectionHandler: function() {
	    _window.removeEventListener &&
	      _window.removeEventListener('unhandledrejection', this._promiseRejectionHandler);
	    return this;
	  },
	
	  /**
	   * Manually capture an exception and send it over to Sentry
	   *
	   * @param {error} ex An exception to be logged
	   * @param {object} options A specific set of options for this error [optional]
	   * @return {Raven}
	   */
	  captureException: function(ex, options) {
	    options = objectMerge({trimHeadFrames: 0}, options ? options : {});
	
	    if (isErrorEvent(ex) && ex.error) {
	      // If it is an ErrorEvent with `error` property, extract it to get actual Error
	      ex = ex.error;
	    } else if (isDOMError(ex) || isDOMException(ex)) {
	      // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
	      // then we just extract the name and message, as they don't provide anything else
	      // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
	      // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
	      var name = ex.name || (isDOMError(ex) ? 'DOMError' : 'DOMException');
	      var message = ex.message ? name + ': ' + ex.message : name;
	
	      return this.captureMessage(
	        message,
	        objectMerge(options, {
	          // neither DOMError or DOMException provide stack trace and we most likely wont get it this way as well
	          // but it's barely any overhead so we may at least try
	          stacktrace: true,
	          trimHeadFrames: options.trimHeadFrames + 1
	        })
	      );
	    } else if (isError(ex)) {
	      // we have a real Error object
	      ex = ex;
	    } else if (isPlainObject(ex)) {
	      // If it is plain Object, serialize it manually and extract options
	      // This will allow us to group events based on top-level keys
	      // which is much better than creating new group when any key/value change
	      options = this._getCaptureExceptionOptionsFromPlainObject(options, ex);
	      ex = new Error(options.message);
	    } else {
	      // If none of previous checks were valid, then it means that
	      // it's not a DOMError/DOMException
	      // it's not a plain Object
	      // it's not a valid ErrorEvent (one with an error property)
	      // it's not an Error
	      // So bail out and capture it as a simple message:
	      return this.captureMessage(
	        ex,
	        objectMerge(options, {
	          stacktrace: true, // if we fall back to captureMessage, default to attempting a new trace
	          trimHeadFrames: options.trimHeadFrames + 1
	        })
	      );
	    }
	
	    // Store the raw exception object for potential debugging and introspection
	    this._lastCapturedException = ex;
	
	    // TraceKit.report will re-raise any exception passed to it,
	    // which means you have to wrap it in try/catch. Instead, we
	    // can wrap it here and only re-raise if TraceKit.report
	    // raises an exception different from the one we asked to
	    // report on.
	    try {
	      var stack = TraceKit.computeStackTrace(ex);
	      this._handleStackInfo(stack, options);
	    } catch (ex1) {
	      if (ex !== ex1) {
	        throw ex1;
	      }
	    }
	
	    return this;
	  },
	
	  _getCaptureExceptionOptionsFromPlainObject: function(currentOptions, ex) {
	    var exKeys = Object.keys(ex).sort();
	    var options = objectMerge(currentOptions, {
	      message:
	        'Non-Error exception captured with keys: ' + serializeKeysForMessage(exKeys),
	      fingerprint: [md5(exKeys)],
	      extra: currentOptions.extra || {}
	    });
	    options.extra.__serialized__ = serializeException(ex);
	
	    return options;
	  },
	
	  /*
	     * Manually send a message to Sentry
	     *
	     * @param {string} msg A plain message to be captured in Sentry
	     * @param {object} options A specific set of options for this message [optional]
	     * @return {Raven}
	     */
	  captureMessage: function(msg, options) {
	    // config() automagically converts ignoreErrors from a list to a RegExp so we need to test for an
	    // early call; we'll error on the side of logging anything called before configuration since it's
	    // probably something you should see:
	    if (
	      !!this._globalOptions.ignoreErrors.test &&
	      this._globalOptions.ignoreErrors.test(msg)
	    ) {
	      return;
	    }
	
	    options = options || {};
	    msg = msg + ''; // Make sure it's actually a string
	
	    var data = objectMerge(
	      {
	        message: msg
	      },
	      options
	    );
	
	    var ex;
	    // Generate a "synthetic" stack trace from this point.
	    // NOTE: If you are a Sentry user, and you are seeing this stack frame, it is NOT indicative
	    //       of a bug with Raven.js. Sentry generates synthetic traces either by configuration,
	    //       or if it catches a thrown object without a "stack" property.
	    try {
	      throw new Error(msg);
	    } catch (ex1) {
	      ex = ex1;
	    }
	
	    // null exception name so `Error` isn't prefixed to msg
	    ex.name = null;
	    var stack = TraceKit.computeStackTrace(ex);
	
	    // stack[0] is `throw new Error(msg)` call itself, we are interested in the frame that was just before that, stack[1]
	    var initialCall = isArray(stack.stack) && stack.stack[1];
	
	    // if stack[1] is `Raven.captureException`, it means that someone passed a string to it and we redirected that call
	    // to be handled by `captureMessage`, thus `initialCall` is the 3rd one, not 2nd
	    // initialCall => captureException(string) => captureMessage(string)
	    if (initialCall && initialCall.func === 'Raven.captureException') {
	      initialCall = stack.stack[2];
	    }
	
	    var fileurl = (initialCall && initialCall.url) || '';
	
	    if (
	      !!this._globalOptions.ignoreUrls.test &&
	      this._globalOptions.ignoreUrls.test(fileurl)
	    ) {
	      return;
	    }
	
	    if (
	      !!this._globalOptions.whitelistUrls.test &&
	      !this._globalOptions.whitelistUrls.test(fileurl)
	    ) {
	      return;
	    }
	
	    // Always attempt to get stacktrace if message is empty.
	    // It's the only way to provide any helpful information to the user.
	    if (this._globalOptions.stacktrace || options.stacktrace || data.message === '') {
	      // fingerprint on msg, not stack trace (legacy behavior, could be revisited)
	      data.fingerprint = data.fingerprint == null ? msg : data.fingerprint;
	
	      options = objectMerge(
	        {
	          trimHeadFrames: 0
	        },
	        options
	      );
	      // Since we know this is a synthetic trace, the top frame (this function call)
	      // MUST be from Raven.js, so mark it for trimming
	      // We add to the trim counter so that callers can choose to trim extra frames, such
	      // as utility functions.
	      options.trimHeadFrames += 1;
	
	      var frames = this._prepareFrames(stack, options);
	      data.stacktrace = {
	        // Sentry expects frames oldest to newest
	        frames: frames.reverse()
	      };
	    }
	
	    // Make sure that fingerprint is always wrapped in an array
	    if (data.fingerprint) {
	      data.fingerprint = isArray(data.fingerprint)
	        ? data.fingerprint
	        : [data.fingerprint];
	    }
	
	    // Fire away!
	    this._send(data);
	
	    return this;
	  },
	
	  captureBreadcrumb: function(obj) {
	    var crumb = objectMerge(
	      {
	        timestamp: now() / 1000
	      },
	      obj
	    );
	
	    if (isFunction(this._globalOptions.breadcrumbCallback)) {
	      var result = this._globalOptions.breadcrumbCallback(crumb);
	
	      if (isObject(result) && !isEmptyObject(result)) {
	        crumb = result;
	      } else if (result === false) {
	        return this;
	      }
	    }
	
	    this._breadcrumbs.push(crumb);
	    if (this._breadcrumbs.length > this._globalOptions.maxBreadcrumbs) {
	      this._breadcrumbs.shift();
	    }
	    return this;
	  },
	
	  addPlugin: function(plugin /*arg1, arg2, ... argN*/) {
	    var pluginArgs = [].slice.call(arguments, 1);
	
	    this._plugins.push([plugin, pluginArgs]);
	    if (this._isRavenInstalled) {
	      this._drainPlugins();
	    }
	
	    return this;
	  },
	
	  /*
	     * Set/clear a user to be sent along with the payload.
	     *
	     * @param {object} user An object representing user data [optional]
	     * @return {Raven}
	     */
	  setUserContext: function(user) {
	    // Intentionally do not merge here since that's an unexpected behavior.
	    this._globalContext.user = user;
	
	    return this;
	  },
	
	  /*
	     * Merge extra attributes to be sent along with the payload.
	     *
	     * @param {object} extra An object representing extra data [optional]
	     * @return {Raven}
	     */
	  setExtraContext: function(extra) {
	    this._mergeContext('extra', extra);
	
	    return this;
	  },
	
	  /*
	     * Merge tags to be sent along with the payload.
	     *
	     * @param {object} tags An object representing tags [optional]
	     * @return {Raven}
	     */
	  setTagsContext: function(tags) {
	    this._mergeContext('tags', tags);
	
	    return this;
	  },
	
	  /*
	     * Clear all of the context.
	     *
	     * @return {Raven}
	     */
	  clearContext: function() {
	    this._globalContext = {};
	
	    return this;
	  },
	
	  /*
	     * Get a copy of the current context. This cannot be mutated.
	     *
	     * @return {object} copy of context
	     */
	  getContext: function() {
	    // lol javascript
	    return JSON.parse(stringify(this._globalContext));
	  },
	
	  /*
	     * Set environment of application
	     *
	     * @param {string} environment Typically something like 'production'.
	     * @return {Raven}
	     */
	  setEnvironment: function(environment) {
	    this._globalOptions.environment = environment;
	
	    return this;
	  },
	
	  /*
	     * Set release version of application
	     *
	     * @param {string} release Typically something like a git SHA to identify version
	     * @return {Raven}
	     */
	  setRelease: function(release) {
	    this._globalOptions.release = release;
	
	    return this;
	  },
	
	  /*
	     * Set the dataCallback option
	     *
	     * @param {function} callback The callback to run which allows the
	     *                            data blob to be mutated before sending
	     * @return {Raven}
	     */
	  setDataCallback: function(callback) {
	    var original = this._globalOptions.dataCallback;
	    this._globalOptions.dataCallback = keepOriginalCallback(original, callback);
	    return this;
	  },
	
	  /*
	     * Set the breadcrumbCallback option
	     *
	     * @param {function} callback The callback to run which allows filtering
	     *                            or mutating breadcrumbs
	     * @return {Raven}
	     */
	  setBreadcrumbCallback: function(callback) {
	    var original = this._globalOptions.breadcrumbCallback;
	    this._globalOptions.breadcrumbCallback = keepOriginalCallback(original, callback);
	    return this;
	  },
	
	  /*
	     * Set the shouldSendCallback option
	     *
	     * @param {function} callback The callback to run which allows
	     *                            introspecting the blob before sending
	     * @return {Raven}
	     */
	  setShouldSendCallback: function(callback) {
	    var original = this._globalOptions.shouldSendCallback;
	    this._globalOptions.shouldSendCallback = keepOriginalCallback(original, callback);
	    return this;
	  },
	
	  /**
	   * Override the default HTTP transport mechanism that transmits data
	   * to the Sentry server.
	   *
	   * @param {function} transport Function invoked instead of the default
	   *                             `makeRequest` handler.
	   *
	   * @return {Raven}
	   */
	  setTransport: function(transport) {
	    this._globalOptions.transport = transport;
	
	    return this;
	  },
	
	  /*
	     * Get the latest raw exception that was captured by Raven.
	     *
	     * @return {error}
	     */
	  lastException: function() {
	    return this._lastCapturedException;
	  },
	
	  /*
	     * Get the last event id
	     *
	     * @return {string}
	     */
	  lastEventId: function() {
	    return this._lastEventId;
	  },
	
	  /*
	     * Determine if Raven is setup and ready to go.
	     *
	     * @return {boolean}
	     */
	  isSetup: function() {
	    if (!this._hasJSON) return false; // needs JSON support
	    if (!this._globalServer) {
	      if (!this.ravenNotConfiguredError) {
	        this.ravenNotConfiguredError = true;
	        this._logDebug('error', 'Error: Raven has not been configured.');
	      }
	      return false;
	    }
	    return true;
	  },
	
	  afterLoad: function() {
	    // TODO: remove window dependence?
	
	    // Attempt to initialize Raven on load
	    var RavenConfig = _window.RavenConfig;
	    if (RavenConfig) {
	      this.config(RavenConfig.dsn, RavenConfig.config).install();
	    }
	  },
	
	  showReportDialog: function(options) {
	    if (
	      !_document // doesn't work without a document (React native)
	    )
	      return;
	
	    options = objectMerge(
	      {
	        eventId: this.lastEventId(),
	        dsn: this._dsn,
	        user: this._globalContext.user || {}
	      },
	      options
	    );
	
	    if (!options.eventId) {
	      throw new RavenConfigError('Missing eventId');
	    }
	
	    if (!options.dsn) {
	      throw new RavenConfigError('Missing DSN');
	    }
	
	    var encode = encodeURIComponent;
	    var encodedOptions = [];
	
	    for (var key in options) {
	      if (key === 'user') {
	        var user = options.user;
	        if (user.name) encodedOptions.push('name=' + encode(user.name));
	        if (user.email) encodedOptions.push('email=' + encode(user.email));
	      } else {
	        encodedOptions.push(encode(key) + '=' + encode(options[key]));
	      }
	    }
	    var globalServer = this._getGlobalServer(this._parseDSN(options.dsn));
	
	    var script = _document.createElement('script');
	    script.async = true;
	    script.src = globalServer + '/api/embed/error-page/?' + encodedOptions.join('&');
	    (_document.head || _document.body).appendChild(script);
	  },
	
	  /**** Private functions ****/
	  _ignoreNextOnError: function() {
	    var self = this;
	    this._ignoreOnError += 1;
	    setTimeout(function() {
	      // onerror should trigger before setTimeout
	      self._ignoreOnError -= 1;
	    });
	  },
	
	  _triggerEvent: function(eventType, options) {
	    // NOTE: `event` is a native browser thing, so let's avoid conflicting wiht it
	    var evt, key;
	
	    if (!this._hasDocument) return;
	
	    options = options || {};
	
	    eventType = 'raven' + eventType.substr(0, 1).toUpperCase() + eventType.substr(1);
	
	    if (_document.createEvent) {
	      evt = _document.createEvent('HTMLEvents');
	      evt.initEvent(eventType, true, true);
	    } else {
	      evt = _document.createEventObject();
	      evt.eventType = eventType;
	    }
	
	    for (key in options)
	      if (hasKey(options, key)) {
	        evt[key] = options[key];
	      }
	
	    if (_document.createEvent) {
	      // IE9 if standards
	      _document.dispatchEvent(evt);
	    } else {
	      // IE8 regardless of Quirks or Standards
	      // IE9 if quirks
	      try {
	        _document.fireEvent('on' + evt.eventType.toLowerCase(), evt);
	      } catch (e) {
	        // Do nothing
	      }
	    }
	  },
	
	  /**
	   * Wraps addEventListener to capture UI breadcrumbs
	   * @param evtName the event name (e.g. "click")
	   * @returns {Function}
	   * @private
	   */
	  _breadcrumbEventHandler: function(evtName) {
	    var self = this;
	    return function(evt) {
	      // reset keypress timeout; e.g. triggering a 'click' after
	      // a 'keypress' will reset the keypress debounce so that a new
	      // set of keypresses can be recorded
	      self._keypressTimeout = null;
	
	      // It's possible this handler might trigger multiple times for the same
	      // event (e.g. event propagation through node ancestors). Ignore if we've
	      // already captured the event.
	      if (self._lastCapturedEvent === evt) return;
	
	      self._lastCapturedEvent = evt;
	
	      // try/catch both:
	      // - accessing evt.target (see getsentry/raven-js#838, #768)
	      // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
	      //   can throw an exception in some circumstances.
	      var target;
	      try {
	        target = htmlTreeAsString(evt.target);
	      } catch (e) {
	        target = '<unknown>';
	      }
	
	      self.captureBreadcrumb({
	        category: 'ui.' + evtName, // e.g. ui.click, ui.input
	        message: target
	      });
	    };
	  },
	
	  /**
	   * Wraps addEventListener to capture keypress UI events
	   * @returns {Function}
	   * @private
	   */
	  _keypressEventHandler: function() {
	    var self = this,
	      debounceDuration = 1000; // milliseconds
	
	    // TODO: if somehow user switches keypress target before
	    //       debounce timeout is triggered, we will only capture
	    //       a single breadcrumb from the FIRST target (acceptable?)
	    return function(evt) {
	      var target;
	      try {
	        target = evt.target;
	      } catch (e) {
	        // just accessing event properties can throw an exception in some rare circumstances
	        // see: https://github.com/getsentry/raven-js/issues/838
	        return;
	      }
	      var tagName = target && target.tagName;
	
	      // only consider keypress events on actual input elements
	      // this will disregard keypresses targeting body (e.g. tabbing
	      // through elements, hotkeys, etc)
	      if (
	        !tagName ||
	        (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)
	      )
	        return;
	
	      // record first keypress in a series, but ignore subsequent
	      // keypresses until debounce clears
	      var timeout = self._keypressTimeout;
	      if (!timeout) {
	        self._breadcrumbEventHandler('input')(evt);
	      }
	      clearTimeout(timeout);
	      self._keypressTimeout = setTimeout(function() {
	        self._keypressTimeout = null;
	      }, debounceDuration);
	    };
	  },
	
	  /**
	   * Captures a breadcrumb of type "navigation", normalizing input URLs
	   * @param to the originating URL
	   * @param from the target URL
	   * @private
	   */
	  _captureUrlChange: function(from, to) {
	    var parsedLoc = parseUrl(this._location.href);
	    var parsedTo = parseUrl(to);
	    var parsedFrom = parseUrl(from);
	
	    // because onpopstate only tells you the "new" (to) value of location.href, and
	    // not the previous (from) value, we need to track the value of the current URL
	    // state ourselves
	    this._lastHref = to;
	
	    // Use only the path component of the URL if the URL matches the current
	    // document (almost all the time when using pushState)
	    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host)
	      to = parsedTo.relative;
	    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host)
	      from = parsedFrom.relative;
	
	    this.captureBreadcrumb({
	      category: 'navigation',
	      data: {
	        to: to,
	        from: from
	      }
	    });
	  },
	
	  _patchFunctionToString: function() {
	    var self = this;
	    self._originalFunctionToString = Function.prototype.toString;
	    // eslint-disable-next-line no-extend-native
	    Function.prototype.toString = function() {
	      if (typeof this === 'function' && this.__raven__) {
	        return self._originalFunctionToString.apply(this.__orig__, arguments);
	      }
	      return self._originalFunctionToString.apply(this, arguments);
	    };
	  },
	
	  _unpatchFunctionToString: function() {
	    if (this._originalFunctionToString) {
	      // eslint-disable-next-line no-extend-native
	      Function.prototype.toString = this._originalFunctionToString;
	    }
	  },
	
	  /**
	   * Wrap timer functions and event targets to catch errors and provide
	   * better metadata.
	   */
	  _instrumentTryCatch: function() {
	    var self = this;
	
	    var wrappedBuiltIns = self._wrappedBuiltIns;
	
	    function wrapTimeFn(orig) {
	      return function(fn, t) {
	        // preserve arity
	        // Make a copy of the arguments to prevent deoptimization
	        // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
	        var args = new Array(arguments.length);
	        for (var i = 0; i < args.length; ++i) {
	          args[i] = arguments[i];
	        }
	        var originalCallback = args[0];
	        if (isFunction(originalCallback)) {
	          args[0] = self.wrap(
	            {
	              mechanism: {
	                type: 'instrument',
	                data: {function: orig.name || '<anonymous>'}
	              }
	            },
	            originalCallback
	          );
	        }
	
	        // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
	        // also supports only two arguments and doesn't care what this is, so we
	        // can just call the original function directly.
	        if (orig.apply) {
	          return orig.apply(this, args);
	        } else {
	          return orig(args[0], args[1]);
	        }
	      };
	    }
	
	    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;
	
	    function wrapEventTarget(global) {
	      var proto = _window[global] && _window[global].prototype;
	      if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
	        fill(
	          proto,
	          'addEventListener',
	          function(orig) {
	            return function(evtName, fn, capture, secure) {
	              // preserve arity
	              try {
	                if (fn && fn.handleEvent) {
	                  fn.handleEvent = self.wrap(
	                    {
	                      mechanism: {
	                        type: 'instrument',
	                        data: {
	                          target: global,
	                          function: 'handleEvent',
	                          handler: (fn && fn.name) || '<anonymous>'
	                        }
	                      }
	                    },
	                    fn.handleEvent
	                  );
	                }
	              } catch (err) {
	                // can sometimes get 'Permission denied to access property "handle Event'
	              }
	
	              // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
	              // so that we don't have more than one wrapper function
	              var before, clickHandler, keypressHandler;
	
	              if (
	                autoBreadcrumbs &&
	                autoBreadcrumbs.dom &&
	                (global === 'EventTarget' || global === 'Node')
	              ) {
	                // NOTE: generating multiple handlers per addEventListener invocation, should
	                //       revisit and verify we can just use one (almost certainly)
	                clickHandler = self._breadcrumbEventHandler('click');
	                keypressHandler = self._keypressEventHandler();
	                before = function(evt) {
	                  // need to intercept every DOM event in `before` argument, in case that
	                  // same wrapped method is re-used for different events (e.g. mousemove THEN click)
	                  // see #724
	                  if (!evt) return;
	
	                  var eventType;
	                  try {
	                    eventType = evt.type;
	                  } catch (e) {
	                    // just accessing event properties can throw an exception in some rare circumstances
	                    // see: https://github.com/getsentry/raven-js/issues/838
	                    return;
	                  }
	                  if (eventType === 'click') return clickHandler(evt);
	                  else if (eventType === 'keypress') return keypressHandler(evt);
	                };
	              }
	              return orig.call(
	                this,
	                evtName,
	                self.wrap(
	                  {
	                    mechanism: {
	                      type: 'instrument',
	                      data: {
	                        target: global,
	                        function: 'addEventListener',
	                        handler: (fn && fn.name) || '<anonymous>'
	                      }
	                    }
	                  },
	                  fn,
	                  before
	                ),
	                capture,
	                secure
	              );
	            };
	          },
	          wrappedBuiltIns
	        );
	        fill(
	          proto,
	          'removeEventListener',
	          function(orig) {
	            return function(evt, fn, capture, secure) {
	              try {
	                fn = fn && (fn.__raven_wrapper__ ? fn.__raven_wrapper__ : fn);
	              } catch (e) {
	                // ignore, accessing __raven_wrapper__ will throw in some Selenium environments
	              }
	              return orig.call(this, evt, fn, capture, secure);
	            };
	          },
	          wrappedBuiltIns
	        );
	      }
	    }
	
	    fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
	    fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
	    if (_window.requestAnimationFrame) {
	      fill(
	        _window,
	        'requestAnimationFrame',
	        function(orig) {
	          return function(cb) {
	            return orig(
	              self.wrap(
	                {
	                  mechanism: {
	                    type: 'instrument',
	                    data: {
	                      function: 'requestAnimationFrame',
	                      handler: (orig && orig.name) || '<anonymous>'
	                    }
	                  }
	                },
	                cb
	              )
	            );
	          };
	        },
	        wrappedBuiltIns
	      );
	    }
	
	    // event targets borrowed from bugsnag-js:
	    // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
	    var eventTargets = [
	      'EventTarget',
	      'Window',
	      'Node',
	      'ApplicationCache',
	      'AudioTrackList',
	      'ChannelMergerNode',
	      'CryptoOperation',
	      'EventSource',
	      'FileReader',
	      'HTMLUnknownElement',
	      'IDBDatabase',
	      'IDBRequest',
	      'IDBTransaction',
	      'KeyOperation',
	      'MediaController',
	      'MessagePort',
	      'ModalWindow',
	      'Notification',
	      'SVGElementInstance',
	      'Screen',
	      'TextTrack',
	      'TextTrackCue',
	      'TextTrackList',
	      'WebSocket',
	      'WebSocketWorker',
	      'Worker',
	      'XMLHttpRequest',
	      'XMLHttpRequestEventTarget',
	      'XMLHttpRequestUpload'
	    ];
	    for (var i = 0; i < eventTargets.length; i++) {
	      wrapEventTarget(eventTargets[i]);
	    }
	  },
	
	  /**
	   * Instrument browser built-ins w/ breadcrumb capturing
	   *  - XMLHttpRequests
	   *  - DOM interactions (click/typing)
	   *  - window.location changes
	   *  - console
	   *
	   * Can be disabled or individually configured via the `autoBreadcrumbs` config option
	   */
	  _instrumentBreadcrumbs: function() {
	    var self = this;
	    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;
	
	    var wrappedBuiltIns = self._wrappedBuiltIns;
	
	    function wrapProp(prop, xhr) {
	      if (prop in xhr && isFunction(xhr[prop])) {
	        fill(xhr, prop, function(orig) {
	          return self.wrap(
	            {
	              mechanism: {
	                type: 'instrument',
	                data: {function: prop, handler: (orig && orig.name) || '<anonymous>'}
	              }
	            },
	            orig
	          );
	        }); // intentionally don't track filled methods on XHR instances
	      }
	    }
	
	    if (autoBreadcrumbs.xhr && 'XMLHttpRequest' in _window) {
	      var xhrproto = _window.XMLHttpRequest && _window.XMLHttpRequest.prototype;
	      fill(
	        xhrproto,
	        'open',
	        function(origOpen) {
	          return function(method, url) {
	            // preserve arity
	
	            // if Sentry key appears in URL, don't capture
	            if (isString(url) && url.indexOf(self._globalKey) === -1) {
	              this.__raven_xhr = {
	                method: method,
	                url: url,
	                status_code: null
	              };
	            }
	
	            return origOpen.apply(this, arguments);
	          };
	        },
	        wrappedBuiltIns
	      );
	
	      fill(
	        xhrproto,
	        'send',
	        function(origSend) {
	          return function() {
	            // preserve arity
	            var xhr = this;
	
	            function onreadystatechangeHandler() {
	              if (xhr.__raven_xhr && xhr.readyState === 4) {
	                try {
	                  // touching statusCode in some platforms throws
	                  // an exception
	                  xhr.__raven_xhr.status_code = xhr.status;
	                } catch (e) {
	                  /* do nothing */
	                }
	
	                self.captureBreadcrumb({
	                  type: 'http',
	                  category: 'xhr',
	                  data: xhr.__raven_xhr
	                });
	              }
	            }
	
	            var props = ['onload', 'onerror', 'onprogress'];
	            for (var j = 0; j < props.length; j++) {
	              wrapProp(props[j], xhr);
	            }
	
	            if ('onreadystatechange' in xhr && isFunction(xhr.onreadystatechange)) {
	              fill(
	                xhr,
	                'onreadystatechange',
	                function(orig) {
	                  return self.wrap(
	                    {
	                      mechanism: {
	                        type: 'instrument',
	                        data: {
	                          function: 'onreadystatechange',
	                          handler: (orig && orig.name) || '<anonymous>'
	                        }
	                      }
	                    },
	                    orig,
	                    onreadystatechangeHandler
	                  );
	                } /* intentionally don't track this instrumentation */
	              );
	            } else {
	              // if onreadystatechange wasn't actually set by the page on this xhr, we
	              // are free to set our own and capture the breadcrumb
	              xhr.onreadystatechange = onreadystatechangeHandler;
	            }
	
	            return origSend.apply(this, arguments);
	          };
	        },
	        wrappedBuiltIns
	      );
	    }
	
	    if (autoBreadcrumbs.xhr && supportsFetch()) {
	      fill(
	        _window,
	        'fetch',
	        function(origFetch) {
	          return function() {
	            // preserve arity
	            // Make a copy of the arguments to prevent deoptimization
	            // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
	            var args = new Array(arguments.length);
	            for (var i = 0; i < args.length; ++i) {
	              args[i] = arguments[i];
	            }
	
	            var fetchInput = args[0];
	            var method = 'GET';
	            var url;
	
	            if (typeof fetchInput === 'string') {
	              url = fetchInput;
	            } else if ('Request' in _window && fetchInput instanceof _window.Request) {
	              url = fetchInput.url;
	              if (fetchInput.method) {
	                method = fetchInput.method;
	              }
	            } else {
	              url = '' + fetchInput;
	            }
	
	            // if Sentry key appears in URL, don't capture, as it's our own request
	            if (url.indexOf(self._globalKey) !== -1) {
	              return origFetch.apply(this, args);
	            }
	
	            if (args[1] && args[1].method) {
	              method = args[1].method;
	            }
	
	            var fetchData = {
	              method: method,
	              url: url,
	              status_code: null
	            };
	
	            return origFetch
	              .apply(this, args)
	              .then(function(response) {
	                fetchData.status_code = response.status;
	
	                self.captureBreadcrumb({
	                  type: 'http',
	                  category: 'fetch',
	                  data: fetchData
	                });
	
	                return response;
	              })
	              ['catch'](function(err) {
	                // if there is an error performing the request
	                self.captureBreadcrumb({
	                  type: 'http',
	                  category: 'fetch',
	                  data: fetchData,
	                  level: 'error'
	                });
	
	                throw err;
	              });
	          };
	        },
	        wrappedBuiltIns
	      );
	    }
	
	    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
	    // to the document. Do this before we instrument addEventListener.
	    if (autoBreadcrumbs.dom && this._hasDocument) {
	      if (_document.addEventListener) {
	        _document.addEventListener('click', self._breadcrumbEventHandler('click'), false);
	        _document.addEventListener('keypress', self._keypressEventHandler(), false);
	      } else if (_document.attachEvent) {
	        // IE8 Compatibility
	        _document.attachEvent('onclick', self._breadcrumbEventHandler('click'));
	        _document.attachEvent('onkeypress', self._keypressEventHandler());
	      }
	    }
	
	    // record navigation (URL) changes
	    // NOTE: in Chrome App environment, touching history.pushState, *even inside
	    //       a try/catch block*, will cause Chrome to output an error to console.error
	    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
	    var chrome = _window.chrome;
	    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
	    var hasPushAndReplaceState =
	      !isChromePackagedApp &&
	      _window.history &&
	      _window.history.pushState &&
	      _window.history.replaceState;
	    if (autoBreadcrumbs.location && hasPushAndReplaceState) {
	      // TODO: remove onpopstate handler on uninstall()
	      var oldOnPopState = _window.onpopstate;
	      _window.onpopstate = function() {
	        var currentHref = self._location.href;
	        self._captureUrlChange(self._lastHref, currentHref);
	
	        if (oldOnPopState) {
	          return oldOnPopState.apply(this, arguments);
	        }
	      };
	
	      var historyReplacementFunction = function(origHistFunction) {
	        // note history.pushState.length is 0; intentionally not declaring
	        // params to preserve 0 arity
	        return function(/* state, title, url */) {
	          var url = arguments.length > 2 ? arguments[2] : undefined;
	
	          // url argument is optional
	          if (url) {
	            // coerce to string (this is what pushState does)
	            self._captureUrlChange(self._lastHref, url + '');
	          }
	
	          return origHistFunction.apply(this, arguments);
	        };
	      };
	
	      fill(_window.history, 'pushState', historyReplacementFunction, wrappedBuiltIns);
	      fill(_window.history, 'replaceState', historyReplacementFunction, wrappedBuiltIns);
	    }
	
	    if (autoBreadcrumbs.console && 'console' in _window && console.log) {
	      // console
	      var consoleMethodCallback = function(msg, data) {
	        self.captureBreadcrumb({
	          message: msg,
	          level: data.level,
	          category: 'console'
	        });
	      };
	
	      each(['debug', 'info', 'warn', 'error', 'log'], function(_, level) {
	        wrapConsoleMethod(console, level, consoleMethodCallback);
	      });
	    }
	  },
	
	  _restoreBuiltIns: function() {
	    // restore any wrapped builtins
	    var builtin;
	    while (this._wrappedBuiltIns.length) {
	      builtin = this._wrappedBuiltIns.shift();
	
	      var obj = builtin[0],
	        name = builtin[1],
	        orig = builtin[2];
	
	      obj[name] = orig;
	    }
	  },
	
	  _restoreConsole: function() {
	    // eslint-disable-next-line guard-for-in
	    for (var method in this._originalConsoleMethods) {
	      this._originalConsole[method] = this._originalConsoleMethods[method];
	    }
	  },
	
	  _drainPlugins: function() {
	    var self = this;
	
	    // FIX ME TODO
	    each(this._plugins, function(_, plugin) {
	      var installer = plugin[0];
	      var args = plugin[1];
	      installer.apply(self, [self].concat(args));
	    });
	  },
	
	  _parseDSN: function(str) {
	    var m = dsnPattern.exec(str),
	      dsn = {},
	      i = 7;
	
	    try {
	      while (i--) dsn[dsnKeys[i]] = m[i] || '';
	    } catch (e) {
	      throw new RavenConfigError('Invalid DSN: ' + str);
	    }
	
	    if (dsn.pass && !this._globalOptions.allowSecretKey) {
	      throw new RavenConfigError(
	        'Do not specify your secret key in the DSN. See: http://bit.ly/raven-secret-key'
	      );
	    }
	
	    return dsn;
	  },
	
	  _getGlobalServer: function(uri) {
	    // assemble the endpoint from the uri pieces
	    var globalServer = '//' + uri.host + (uri.port ? ':' + uri.port : '');
	
	    if (uri.protocol) {
	      globalServer = uri.protocol + ':' + globalServer;
	    }
	    return globalServer;
	  },
	
	  _handleOnErrorStackInfo: function(stackInfo, options) {
	    options = options || {};
	    options.mechanism = options.mechanism || {
	      type: 'onerror',
	      handled: false
	    };
	
	    // if we are intentionally ignoring errors via onerror, bail out
	    if (!this._ignoreOnError) {
	      this._handleStackInfo(stackInfo, options);
	    }
	  },
	
	  _handleStackInfo: function(stackInfo, options) {
	    var frames = this._prepareFrames(stackInfo, options);
	
	    this._triggerEvent('handle', {
	      stackInfo: stackInfo,
	      options: options
	    });
	
	    this._processException(
	      stackInfo.name,
	      stackInfo.message,
	      stackInfo.url,
	      stackInfo.lineno,
	      frames,
	      options
	    );
	  },
	
	  _prepareFrames: function(stackInfo, options) {
	    var self = this;
	    var frames = [];
	    if (stackInfo.stack && stackInfo.stack.length) {
	      each(stackInfo.stack, function(i, stack) {
	        var frame = self._normalizeFrame(stack, stackInfo.url);
	        if (frame) {
	          frames.push(frame);
	        }
	      });
	
	      // e.g. frames captured via captureMessage throw
	      if (options && options.trimHeadFrames) {
	        for (var j = 0; j < options.trimHeadFrames && j < frames.length; j++) {
	          frames[j].in_app = false;
	        }
	      }
	    }
	    frames = frames.slice(0, this._globalOptions.stackTraceLimit);
	    return frames;
	  },
	
	  _normalizeFrame: function(frame, stackInfoUrl) {
	    // normalize the frames data
	    var normalized = {
	      filename: frame.url,
	      lineno: frame.line,
	      colno: frame.column,
	      function: frame.func || '?'
	    };
	
	    // Case when we don't have any information about the error
	    // E.g. throwing a string or raw object, instead of an `Error` in Firefox
	    // Generating synthetic error doesn't add any value here
	    //
	    // We should probably somehow let a user know that they should fix their code
	    if (!frame.url) {
	      normalized.filename = stackInfoUrl; // fallback to whole stacks url from onerror handler
	    }
	
	    normalized.in_app = !// determine if an exception came from outside of our app
	    // first we check the global includePaths list.
	    (
	      (!!this._globalOptions.includePaths.test &&
	        !this._globalOptions.includePaths.test(normalized.filename)) ||
	      // Now we check for fun, if the function name is Raven or TraceKit
	      /(Raven|TraceKit)\./.test(normalized['function']) ||
	      // finally, we do a last ditch effort and check for raven.min.js
	      /raven\.(min\.)?js$/.test(normalized.filename)
	    );
	
	    return normalized;
	  },
	
	  _processException: function(type, message, fileurl, lineno, frames, options) {
	    var prefixedMessage = (type ? type + ': ' : '') + (message || '');
	    if (
	      !!this._globalOptions.ignoreErrors.test &&
	      (this._globalOptions.ignoreErrors.test(message) ||
	        this._globalOptions.ignoreErrors.test(prefixedMessage))
	    ) {
	      return;
	    }
	
	    var stacktrace;
	
	    if (frames && frames.length) {
	      fileurl = frames[0].filename || fileurl;
	      // Sentry expects frames oldest to newest
	      // and JS sends them as newest to oldest
	      frames.reverse();
	      stacktrace = {frames: frames};
	    } else if (fileurl) {
	      stacktrace = {
	        frames: [
	          {
	            filename: fileurl,
	            lineno: lineno,
	            in_app: true
	          }
	        ]
	      };
	    }
	
	    if (
	      !!this._globalOptions.ignoreUrls.test &&
	      this._globalOptions.ignoreUrls.test(fileurl)
	    ) {
	      return;
	    }
	
	    if (
	      !!this._globalOptions.whitelistUrls.test &&
	      !this._globalOptions.whitelistUrls.test(fileurl)
	    ) {
	      return;
	    }
	
	    var data = objectMerge(
	      {
	        // sentry.interfaces.Exception
	        exception: {
	          values: [
	            {
	              type: type,
	              value: message,
	              stacktrace: stacktrace
	            }
	          ]
	        },
	        transaction: fileurl
	      },
	      options
	    );
	
	    var ex = data.exception.values[0];
	    if (ex.type == null && ex.value === '') {
	      ex.value = 'Unrecoverable error caught';
	    }
	
	    // Move mechanism from options to exception interface
	    // We do this, as requiring user to pass `{exception:{mechanism:{ ... }}}` would be
	    // too much
	    if (!data.exception.mechanism && data.mechanism) {
	      data.exception.mechanism = data.mechanism;
	      delete data.mechanism;
	    }
	
	    data.exception.mechanism = objectMerge(
	      {
	        type: 'generic',
	        handled: true
	      },
	      data.exception.mechanism || {}
	    );
	
	    // Fire away!
	    this._send(data);
	  },
	
	  _trimPacket: function(data) {
	    // For now, we only want to truncate the two different messages
	    // but this could/should be expanded to just trim everything
	    var max = this._globalOptions.maxMessageLength;
	    if (data.message) {
	      data.message = truncate(data.message, max);
	    }
	    if (data.exception) {
	      var exception = data.exception.values[0];
	      exception.value = truncate(exception.value, max);
	    }
	
	    var request = data.request;
	    if (request) {
	      if (request.url) {
	        request.url = truncate(request.url, this._globalOptions.maxUrlLength);
	      }
	      if (request.Referer) {
	        request.Referer = truncate(request.Referer, this._globalOptions.maxUrlLength);
	      }
	    }
	
	    if (data.breadcrumbs && data.breadcrumbs.values)
	      this._trimBreadcrumbs(data.breadcrumbs);
	
	    return data;
	  },
	
	  /**
	   * Truncate breadcrumb values (right now just URLs)
	   */
	  _trimBreadcrumbs: function(breadcrumbs) {
	    // known breadcrumb properties with urls
	    // TODO: also consider arbitrary prop values that start with (https?)?://
	    var urlProps = ['to', 'from', 'url'],
	      urlProp,
	      crumb,
	      data;
	
	    for (var i = 0; i < breadcrumbs.values.length; ++i) {
	      crumb = breadcrumbs.values[i];
	      if (
	        !crumb.hasOwnProperty('data') ||
	        !isObject(crumb.data) ||
	        objectFrozen(crumb.data)
	      )
	        continue;
	
	      data = objectMerge({}, crumb.data);
	      for (var j = 0; j < urlProps.length; ++j) {
	        urlProp = urlProps[j];
	        if (data.hasOwnProperty(urlProp) && data[urlProp]) {
	          data[urlProp] = truncate(data[urlProp], this._globalOptions.maxUrlLength);
	        }
	      }
	      breadcrumbs.values[i].data = data;
	    }
	  },
	
	  _getHttpData: function() {
	    if (!this._hasNavigator && !this._hasDocument) return;
	    var httpData = {};
	
	    if (this._hasNavigator && _navigator.userAgent) {
	      httpData.headers = {
	        'User-Agent': _navigator.userAgent
	      };
	    }
	
	    // Check in `window` instead of `document`, as we may be in ServiceWorker environment
	    if (_window.location && _window.location.href) {
	      httpData.url = _window.location.href;
	    }
	
	    if (this._hasDocument && _document.referrer) {
	      if (!httpData.headers) httpData.headers = {};
	      httpData.headers.Referer = _document.referrer;
	    }
	
	    return httpData;
	  },
	
	  _resetBackoff: function() {
	    this._backoffDuration = 0;
	    this._backoffStart = null;
	  },
	
	  _shouldBackoff: function() {
	    return this._backoffDuration && now() - this._backoffStart < this._backoffDuration;
	  },
	
	  /**
	   * Returns true if the in-process data payload matches the signature
	   * of the previously-sent data
	   *
	   * NOTE: This has to be done at this level because TraceKit can generate
	   *       data from window.onerror WITHOUT an exception object (IE8, IE9,
	   *       other old browsers). This can take the form of an "exception"
	   *       data object with a single frame (derived from the onerror args).
	   */
	  _isRepeatData: function(current) {
	    var last = this._lastData;
	
	    if (
	      !last ||
	      current.message !== last.message || // defined for captureMessage
	      current.transaction !== last.transaction // defined for captureException/onerror
	    )
	      return false;
	
	    // Stacktrace interface (i.e. from captureMessage)
	    if (current.stacktrace || last.stacktrace) {
	      return isSameStacktrace(current.stacktrace, last.stacktrace);
	    } else if (current.exception || last.exception) {
	      // Exception interface (i.e. from captureException/onerror)
	      return isSameException(current.exception, last.exception);
	    } else if (current.fingerprint || last.fingerprint) {
	      return Boolean(current.fingerprint && last.fingerprint) &&
	        JSON.stringify(current.fingerprint) === JSON.stringify(last.fingerprint)
	    }
	
	    return true;
	  },
	
	  _setBackoffState: function(request) {
	    // If we are already in a backoff state, don't change anything
	    if (this._shouldBackoff()) {
	      return;
	    }
	
	    var status = request.status;
	
	    // 400 - project_id doesn't exist or some other fatal
	    // 401 - invalid/revoked dsn
	    // 429 - too many requests
	    if (!(status === 400 || status === 401 || status === 429)) return;
	
	    var retry;
	    try {
	      // If Retry-After is not in Access-Control-Expose-Headers, most
	      // browsers will throw an exception trying to access it
	      if (supportsFetch()) {
	        retry = request.headers.get('Retry-After');
	      } else {
	        retry = request.getResponseHeader('Retry-After');
	      }
	
	      // Retry-After is returned in seconds
	      retry = parseInt(retry, 10) * 1000;
	    } catch (e) {
	      /* eslint no-empty:0 */
	    }
	
	    this._backoffDuration = retry
	      ? // If Sentry server returned a Retry-After value, use it
	        retry
	      : // Otherwise, double the last backoff duration (starts at 1 sec)
	        this._backoffDuration * 2 || 1000;
	
	    this._backoffStart = now();
	  },
	
	  _send: function(data) {
	    var globalOptions = this._globalOptions;
	
	    var baseData = {
	        project: this._globalProject,
	        logger: globalOptions.logger,
	        platform: 'javascript'
	      },
	      httpData = this._getHttpData();
	
	    if (httpData) {
	      baseData.request = httpData;
	    }
	
	    // HACK: delete `trimHeadFrames` to prevent from appearing in outbound payload
	    if (data.trimHeadFrames) delete data.trimHeadFrames;
	
	    data = objectMerge(baseData, data);
	
	    // Merge in the tags and extra separately since objectMerge doesn't handle a deep merge
	    data.tags = objectMerge(objectMerge({}, this._globalContext.tags), data.tags);
	    data.extra = objectMerge(objectMerge({}, this._globalContext.extra), data.extra);
	
	    // Send along our own collected metadata with extra
	    data.extra['session:duration'] = now() - this._startTime;
	
	    if (this._breadcrumbs && this._breadcrumbs.length > 0) {
	      // intentionally make shallow copy so that additions
	      // to breadcrumbs aren't accidentally sent in this request
	      data.breadcrumbs = {
	        values: [].slice.call(this._breadcrumbs, 0)
	      };
	    }
	
	    if (this._globalContext.user) {
	      // sentry.interfaces.User
	      data.user = this._globalContext.user;
	    }
	
	    // Include the environment if it's defined in globalOptions
	    if (globalOptions.environment) data.environment = globalOptions.environment;
	
	    // Include the release if it's defined in globalOptions
	    if (globalOptions.release) data.release = globalOptions.release;
	
	    // Include server_name if it's defined in globalOptions
	    if (globalOptions.serverName) data.server_name = globalOptions.serverName;
	
	    data = this._sanitizeData(data);
	
	    // Cleanup empty properties before sending them to the server
	    Object.keys(data).forEach(function(key) {
	      if (data[key] == null || data[key] === '' || isEmptyObject(data[key])) {
	        delete data[key];
	      }
	    });
	
	    if (isFunction(globalOptions.dataCallback)) {
	      data = globalOptions.dataCallback(data) || data;
	    }
	
	    // Why??????????
	    if (!data || isEmptyObject(data)) {
	      return;
	    }
	
	    // Check if the request should be filtered or not
	    if (
	      isFunction(globalOptions.shouldSendCallback) &&
	      !globalOptions.shouldSendCallback(data)
	    ) {
	      return;
	    }
	
	    // Backoff state: Sentry server previously responded w/ an error (e.g. 429 - too many requests),
	    // so drop requests until "cool-off" period has elapsed.
	    if (this._shouldBackoff()) {
	      this._logDebug('warn', 'Raven dropped error due to backoff: ', data);
	      return;
	    }
	
	    if (typeof globalOptions.sampleRate === 'number') {
	      if (Math.random() < globalOptions.sampleRate) {
	        this._sendProcessedPayload(data);
	      }
	    } else {
	      this._sendProcessedPayload(data);
	    }
	  },
	
	  _sanitizeData: function(data) {
	    return sanitize(data, this._globalOptions.sanitizeKeys);
	  },
	
	  _getUuid: function() {
	    return uuid4();
	  },
	
	  _sendProcessedPayload: function(data, callback) {
	    var self = this;
	    var globalOptions = this._globalOptions;
	
	    if (!this.isSetup()) return;
	
	    // Try and clean up the packet before sending by truncating long values
	    data = this._trimPacket(data);
	
	    // ideally duplicate error testing should occur *before* dataCallback/shouldSendCallback,
	    // but this would require copying an un-truncated copy of the data packet, which can be
	    // arbitrarily deep (extra_data) -- could be worthwhile? will revisit
	    if (!this._globalOptions.allowDuplicates && this._isRepeatData(data)) {
	      this._logDebug('warn', 'Raven dropped repeat event: ', data);
	      return;
	    }
	
	    // Send along an event_id if not explicitly passed.
	    // This event_id can be used to reference the error within Sentry itself.
	    // Set lastEventId after we know the error should actually be sent
	    this._lastEventId = data.event_id || (data.event_id = this._getUuid());
	
	    // Store outbound payload after trim
	    this._lastData = data;
	
	    this._logDebug('debug', 'Raven about to send:', data);
	
	    var auth = {
	      sentry_version: '7',
	      sentry_client: 'raven-js/' + this.VERSION,
	      sentry_key: this._globalKey
	    };
	
	    if (this._globalSecret) {
	      auth.sentry_secret = this._globalSecret;
	    }
	
	    var exception = data.exception && data.exception.values[0];
	
	    // only capture 'sentry' breadcrumb is autoBreadcrumbs is truthy
	    if (
	      this._globalOptions.autoBreadcrumbs &&
	      this._globalOptions.autoBreadcrumbs.sentry
	    ) {
	      this.captureBreadcrumb({
	        category: 'sentry',
	        message: exception
	          ? (exception.type ? exception.type + ': ' : '') + exception.value
	          : data.message,
	        event_id: data.event_id,
	        level: data.level || 'error' // presume error unless specified
	      });
	    }
	
	    var url = this._globalEndpoint;
	    (globalOptions.transport || this._makeRequest).call(this, {
	      url: url,
	      auth: auth,
	      data: data,
	      options: globalOptions,
	      onSuccess: function success() {
	        self._resetBackoff();
	
	        self._triggerEvent('success', {
	          data: data,
	          src: url
	        });
	        callback && callback();
	      },
	      onError: function failure(error) {
	        self._logDebug('error', 'Raven transport failed to send: ', error);
	
	        if (error.request) {
	          self._setBackoffState(error.request);
	        }
	
	        self._triggerEvent('failure', {
	          data: data,
	          src: url
	        });
	        error = error || new Error('Raven send failed (no additional details provided)');
	        callback && callback(error);
	      }
	    });
	  },
	
	  _makeRequest: function(opts) {
	    // Auth is intentionally sent as part of query string (NOT as custom HTTP header) to avoid preflight CORS requests
	    var url = opts.url + '?' + urlencode(opts.auth);
	
	    var evaluatedHeaders = null;
	    var evaluatedFetchParameters = {};
	
	    if (opts.options.headers) {
	      evaluatedHeaders = this._evaluateHash(opts.options.headers);
	    }
	
	    if (opts.options.fetchParameters) {
	      evaluatedFetchParameters = this._evaluateHash(opts.options.fetchParameters);
	    }
	
	    if (supportsFetch()) {
	      evaluatedFetchParameters.body = stringify(opts.data);
	
	      var defaultFetchOptions = objectMerge({}, this._fetchDefaults);
	      var fetchOptions = objectMerge(defaultFetchOptions, evaluatedFetchParameters);
	
	      if (evaluatedHeaders) {
	        fetchOptions.headers = evaluatedHeaders;
	      }
	
	      return _window
	        .fetch(url, fetchOptions)
	        .then(function(response) {
	          if (response.ok) {
	            opts.onSuccess && opts.onSuccess();
	          } else {
	            var error = new Error('Sentry error code: ' + response.status);
	            // It's called request only to keep compatibility with XHR interface
	            // and not add more redundant checks in setBackoffState method
	            error.request = response;
	            opts.onError && opts.onError(error);
	          }
	        })
	        ['catch'](function() {
	          opts.onError &&
	            opts.onError(new Error('Sentry error code: network unavailable'));
	        });
	    }
	
	    var request = _window.XMLHttpRequest && new _window.XMLHttpRequest();
	    if (!request) return;
	
	    // if browser doesn't support CORS (e.g. IE7), we are out of luck
	    var hasCORS = 'withCredentials' in request || typeof XDomainRequest !== 'undefined';
	
	    if (!hasCORS) return;
	
	    if ('withCredentials' in request) {
	      request.onreadystatechange = function() {
	        if (request.readyState !== 4) {
	          return;
	        } else if (request.status === 200) {
	          opts.onSuccess && opts.onSuccess();
	        } else if (opts.onError) {
	          var err = new Error('Sentry error code: ' + request.status);
	          err.request = request;
	          opts.onError(err);
	        }
	      };
	    } else {
	      request = new XDomainRequest();
	      // xdomainrequest cannot go http -> https (or vice versa),
	      // so always use protocol relative
	      url = url.replace(/^https?:/, '');
	
	      // onreadystatechange not supported by XDomainRequest
	      if (opts.onSuccess) {
	        request.onload = opts.onSuccess;
	      }
	      if (opts.onError) {
	        request.onerror = function() {
	          var err = new Error('Sentry error code: XDomainRequest');
	          err.request = request;
	          opts.onError(err);
	        };
	      }
	    }
	
	    request.open('POST', url);
	
	    if (evaluatedHeaders) {
	      each(evaluatedHeaders, function(key, value) {
	        request.setRequestHeader(key, value);
	      });
	    }
	
	    request.send(stringify(opts.data));
	  },
	
	  _evaluateHash: function(hash) {
	    var evaluated = {};
	
	    for (var key in hash) {
	      if (hash.hasOwnProperty(key)) {
	        var value = hash[key];
	        evaluated[key] = typeof value === 'function' ? value() : value;
	      }
	    }
	
	    return evaluated;
	  },
	
	  _logDebug: function(level) {
	    // We allow `Raven.debug` and `Raven.config(DSN, { debug: true })` to not make backward incompatible API change
	    if (
	      this._originalConsoleMethods[level] &&
	      (this.debug || this._globalOptions.debug)
	    ) {
	      // In IE<10 console methods do not have their own 'apply' method
	      Function.prototype.apply.call(
	        this._originalConsoleMethods[level],
	        this._originalConsole,
	        [].slice.call(arguments, 1)
	      );
	    }
	  },
	
	  _mergeContext: function(key, context) {
	    if (isUndefined(context)) {
	      delete this._globalContext[key];
	    } else {
	      this._globalContext[key] = objectMerge(this._globalContext[key] || {}, context);
	    }
	  }
	};
	
	// Deprecations
	Raven.prototype.setUser = Raven.prototype.setUserContext;
	Raven.prototype.setReleaseContext = Raven.prototype.setRelease;
	
	module.exports = Raven;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1917 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var utils = __webpack_require__(501);
	
	/*
	 TraceKit - Cross brower stack traces
	
	 This was originally forked from github.com/occ/TraceKit, but has since been
	 largely re-written and is now maintained as part of raven-js.  Tests for
	 this are in test/vendor.
	
	 MIT license
	*/
	
	var TraceKit = {
	  collectWindowErrors: true,
	  debug: false
	};
	
	// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
	var _window =
	  typeof window !== 'undefined'
	    ? window
	    : typeof global !== 'undefined'
	    ? global
	    : typeof self !== 'undefined'
	    ? self
	    : {};
	
	// global reference to slice
	var _slice = [].slice;
	var UNKNOWN_FUNCTION = '?';
	
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
	var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;
	
	function getLocationHref() {
	  if (typeof document === 'undefined' || document.location == null) return '';
	  return document.location.href;
	}
	
	function getLocationOrigin() {
	  if (typeof document === 'undefined' || document.location == null) return '';
	
	  // Oh dear IE10...
	  if (!document.location.origin) {
	    return (
	      document.location.protocol +
	      '//' +
	      document.location.hostname +
	      (document.location.port ? ':' + document.location.port : '')
	    );
	  }
	
	  return document.location.origin;
	}
	
	/**
	 * TraceKit.report: cross-browser processing of unhandled exceptions
	 *
	 * Syntax:
	 *   TraceKit.report.subscribe(function(stackInfo) { ... })
	 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
	 *   TraceKit.report(exception)
	 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
	 *
	 * Supports:
	 *   - Firefox: full stack trace with line numbers, plus column number
	 *              on top frame; column number is not guaranteed
	 *   - Opera:   full stack trace with line and column numbers
	 *   - Chrome:  full stack trace with line and column numbers
	 *   - Safari:  line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *   - IE:      line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *
	 * In theory, TraceKit should work on all of the following versions:
	 *   - IE5.5+ (only 8.0 tested)
	 *   - Firefox 0.9+ (only 3.5+ tested)
	 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
	 *     Exceptions Have Stacktrace to be enabled in opera:config)
	 *   - Safari 3+ (only 4+ tested)
	 *   - Chrome 1+ (only 5+ tested)
	 *   - Konqueror 3.5+ (untested)
	 *
	 * Requires TraceKit.computeStackTrace.
	 *
	 * Tries to catch all unhandled exceptions and report them to the
	 * subscribed handlers. Please note that TraceKit.report will rethrow the
	 * exception. This is REQUIRED in order to get a useful stack trace in IE.
	 * If the exception does not reach the top of the browser, you will only
	 * get a stack trace from the point where TraceKit.report was called.
	 *
	 * Handlers receive a stackInfo object as described in the
	 * TraceKit.computeStackTrace docs.
	 */
	TraceKit.report = (function reportModuleWrapper() {
	  var handlers = [],
	    lastArgs = null,
	    lastException = null,
	    lastExceptionStack = null;
	
	  /**
	   * Add a crash handler.
	   * @param {Function} handler
	   */
	  function subscribe(handler) {
	    installGlobalHandler();
	    handlers.push(handler);
	  }
	
	  /**
	   * Remove a crash handler.
	   * @param {Function} handler
	   */
	  function unsubscribe(handler) {
	    for (var i = handlers.length - 1; i >= 0; --i) {
	      if (handlers[i] === handler) {
	        handlers.splice(i, 1);
	      }
	    }
	  }
	
	  /**
	   * Remove all crash handlers.
	   */
	  function unsubscribeAll() {
	    uninstallGlobalHandler();
	    handlers = [];
	  }
	
	  /**
	   * Dispatch stack information to all handlers.
	   * @param {Object.<string, *>} stack
	   */
	  function notifyHandlers(stack, isWindowError) {
	    var exception = null;
	    if (isWindowError && !TraceKit.collectWindowErrors) {
	      return;
	    }
	    for (var i in handlers) {
	      if (handlers.hasOwnProperty(i)) {
	        try {
	          handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
	        } catch (inner) {
	          exception = inner;
	        }
	      }
	    }
	
	    if (exception) {
	      throw exception;
	    }
	  }
	
	  var _oldOnerrorHandler, _onErrorHandlerInstalled;
	
	  /**
	   * Ensures all global unhandled exceptions are recorded.
	   * Supported by Gecko and IE.
	   * @param {string} msg Error message.
	   * @param {string} url URL of script that generated the exception.
	   * @param {(number|string)} lineNo The line number at which the error
	   * occurred.
	   * @param {?(number|string)} colNo The column number at which the error
	   * occurred.
	   * @param {?Error} ex The actual Error object.
	   */
	  function traceKitWindowOnError(msg, url, lineNo, colNo, ex) {
	    var stack = null;
	    // If 'ex' is ErrorEvent, get real Error from inside
	    var exception = utils.isErrorEvent(ex) ? ex.error : ex;
	    // If 'msg' is ErrorEvent, get real message from inside
	    var message = utils.isErrorEvent(msg) ? msg.message : msg;
	
	    if (lastExceptionStack) {
	      TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(
	        lastExceptionStack,
	        url,
	        lineNo,
	        message
	      );
	      processLastException();
	    } else if (exception && utils.isError(exception)) {
	      // non-string `exception` arg; attempt to extract stack trace
	
	      // New chrome and blink send along a real error object
	      // Let's just report that like a normal error.
	      // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
	      stack = TraceKit.computeStackTrace(exception);
	      notifyHandlers(stack, true);
	    } else {
	      var location = {
	        url: url,
	        line: lineNo,
	        column: colNo
	      };
	
	      var name = undefined;
	      var groups;
	
	      if ({}.toString.call(message) === '[object String]') {
	        var groups = message.match(ERROR_TYPES_RE);
	        if (groups) {
	          name = groups[1];
	          message = groups[2];
	        }
	      }
	
	      location.func = UNKNOWN_FUNCTION;
	
	      stack = {
	        name: name,
	        message: message,
	        url: getLocationHref(),
	        stack: [location]
	      };
	      notifyHandlers(stack, true);
	    }
	
	    if (_oldOnerrorHandler) {
	      return _oldOnerrorHandler.apply(this, arguments);
	    }
	
	    return false;
	  }
	
	  function installGlobalHandler() {
	    if (_onErrorHandlerInstalled) {
	      return;
	    }
	    _oldOnerrorHandler = _window.onerror;
	    _window.onerror = traceKitWindowOnError;
	    _onErrorHandlerInstalled = true;
	  }
	
	  function uninstallGlobalHandler() {
	    if (!_onErrorHandlerInstalled) {
	      return;
	    }
	    _window.onerror = _oldOnerrorHandler;
	    _onErrorHandlerInstalled = false;
	    _oldOnerrorHandler = undefined;
	  }
	
	  function processLastException() {
	    var _lastExceptionStack = lastExceptionStack,
	      _lastArgs = lastArgs;
	    lastArgs = null;
	    lastExceptionStack = null;
	    lastException = null;
	    notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
	  }
	
	  /**
	   * Reports an unhandled Error to TraceKit.
	   * @param {Error} ex
	   * @param {?boolean} rethrow If false, do not re-throw the exception.
	   * Only used for window.onerror to not cause an infinite loop of
	   * rethrowing.
	   */
	  function report(ex, rethrow) {
	    var args = _slice.call(arguments, 1);
	    if (lastExceptionStack) {
	      if (lastException === ex) {
	        return; // already caught by an inner catch block, ignore
	      } else {
	        processLastException();
	      }
	    }
	
	    var stack = TraceKit.computeStackTrace(ex);
	    lastExceptionStack = stack;
	    lastException = ex;
	    lastArgs = args;
	
	    // If the stack trace is incomplete, wait for 2 seconds for
	    // slow slow IE to see if onerror occurs or not before reporting
	    // this exception; otherwise, we will end up with an incomplete
	    // stack trace
	    setTimeout(
	      function() {
	        if (lastException === ex) {
	          processLastException();
	        }
	      },
	      stack.incomplete ? 2000 : 0
	    );
	
	    if (rethrow !== false) {
	      throw ex; // re-throw to propagate to the top level (and cause window.onerror)
	    }
	  }
	
	  report.subscribe = subscribe;
	  report.unsubscribe = unsubscribe;
	  report.uninstall = unsubscribeAll;
	  return report;
	})();
	
	/**
	 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
	 *
	 * Syntax:
	 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
	 * Returns:
	 *   s.name              - exception name
	 *   s.message           - exception message
	 *   s.stack[i].url      - JavaScript or HTML file URL
	 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
	 *   s.stack[i].args     - arguments passed to the function, if known
	 *   s.stack[i].line     - line number, if known
	 *   s.stack[i].column   - column number, if known
	 *
	 * Supports:
	 *   - Firefox:  full stack trace with line numbers and unreliable column
	 *               number on top frame
	 *   - Opera 10: full stack trace with line and column numbers
	 *   - Opera 9-: full stack trace with line numbers
	 *   - Chrome:   full stack trace with line and column numbers
	 *   - Safari:   line and column number for the topmost stacktrace element
	 *               only
	 *   - IE:       no line numbers whatsoever
	 *
	 * Tries to guess names of anonymous functions by looking for assignments
	 * in the source code. In IE and Safari, we have to guess source file names
	 * by searching for function bodies inside all page scripts. This will not
	 * work for scripts that are loaded cross-domain.
	 * Here be dragons: some function names may be guessed incorrectly, and
	 * duplicate functions may be mismatched.
	 *
	 * TraceKit.computeStackTrace should only be used for tracing purposes.
	 * Logging of unhandled exceptions should be done with TraceKit.report,
	 * which builds on top of TraceKit.computeStackTrace and provides better
	 * IE support by utilizing the window.onerror event to retrieve information
	 * about the top of the stack.
	 *
	 * Note: In IE and Safari, no stack trace is recorded on the Error object,
	 * so computeStackTrace instead walks its *own* chain of callers.
	 * This means that:
	 *  * in Safari, some methods may be missing from the stack trace;
	 *  * in IE, the topmost function in the stack trace will always be the
	 *    caller of computeStackTrace.
	 *
	 * This is okay for tracing (because you are likely to be calling
	 * computeStackTrace from the function you want to be the topmost element
	 * of the stack trace anyway), but not okay for logging unhandled
	 * exceptions (because your catch block will likely be far away from the
	 * inner function that actually caused the exception).
	 *
	 */
	TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
	  // Contents of Exception in various browsers.
	  //
	  // SAFARI:
	  // ex.message = Can't find variable: qq
	  // ex.line = 59
	  // ex.sourceId = 580238192
	  // ex.sourceURL = http://...
	  // ex.expressionBeginOffset = 96
	  // ex.expressionCaretOffset = 98
	  // ex.expressionEndOffset = 98
	  // ex.name = ReferenceError
	  //
	  // FIREFOX:
	  // ex.message = qq is not defined
	  // ex.fileName = http://...
	  // ex.lineNumber = 59
	  // ex.columnNumber = 69
	  // ex.stack = ...stack trace... (see the example below)
	  // ex.name = ReferenceError
	  //
	  // CHROME:
	  // ex.message = qq is not defined
	  // ex.name = ReferenceError
	  // ex.type = not_defined
	  // ex.arguments = ['aa']
	  // ex.stack = ...stack trace...
	  //
	  // INTERNET EXPLORER:
	  // ex.message = ...
	  // ex.name = ReferenceError
	  //
	  // OPERA:
	  // ex.message = ...message... (see the example below)
	  // ex.name = ReferenceError
	  // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
	  // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'
	
	  /**
	   * Computes stack trace information from the stack property.
	   * Chrome and Gecko use this property.
	   * @param {Error} ex
	   * @return {?Object.<string, *>} Stack trace information.
	   */
	  function computeStackTraceFromStackProp(ex) {
	    if (typeof ex.stack === 'undefined' || !ex.stack) return;
	
	    var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|[a-z]:|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
	    var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx(?:-web)|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
	    // NOTE: blob urls are now supposed to always have an origin, therefore it's format
	    // which is `blob:http://url/path/with-some-uuid`, is matched by `blob.*?:\/` as well
	    var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i;
	    // Used to additionally parse URL/line/column from eval frames
	    var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
	    var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
	    var lines = ex.stack.split('\n');
	    var stack = [];
	    var submatch;
	    var parts;
	    var element;
	    var reference = /^(.*) is undefined$/.exec(ex.message);
	
	    for (var i = 0, j = lines.length; i < j; ++i) {
	      if ((parts = chrome.exec(lines[i]))) {
	        var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
	        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
	        if (isEval && (submatch = chromeEval.exec(parts[2]))) {
	          // throw out eval line/column and use top-most line/column number
	          parts[2] = submatch[1]; // url
	          parts[3] = submatch[2]; // line
	          parts[4] = submatch[3]; // column
	        }
	        element = {
	          url: !isNative ? parts[2] : null,
	          func: parts[1] || UNKNOWN_FUNCTION,
	          args: isNative ? [parts[2]] : [],
	          line: parts[3] ? +parts[3] : null,
	          column: parts[4] ? +parts[4] : null
	        };
	      } else if ((parts = winjs.exec(lines[i]))) {
	        element = {
	          url: parts[2],
	          func: parts[1] || UNKNOWN_FUNCTION,
	          args: [],
	          line: +parts[3],
	          column: parts[4] ? +parts[4] : null
	        };
	      } else if ((parts = gecko.exec(lines[i]))) {
	        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
	        if (isEval && (submatch = geckoEval.exec(parts[3]))) {
	          // throw out eval line/column and use top-most line number
	          parts[3] = submatch[1];
	          parts[4] = submatch[2];
	          parts[5] = null; // no column when eval
	        } else if (i === 0 && !parts[5] && typeof ex.columnNumber !== 'undefined') {
	          // FireFox uses this awesome columnNumber property for its top frame
	          // Also note, Firefox's column number is 0-based and everything else expects 1-based,
	          // so adding 1
	          // NOTE: this hack doesn't work if top-most frame is eval
	          stack[0].column = ex.columnNumber + 1;
	        }
	        element = {
	          url: parts[3],
	          func: parts[1] || UNKNOWN_FUNCTION,
	          args: parts[2] ? parts[2].split(',') : [],
	          line: parts[4] ? +parts[4] : null,
	          column: parts[5] ? +parts[5] : null
	        };
	      } else {
	        continue;
	      }
	
	      if (!element.func && element.line) {
	        element.func = UNKNOWN_FUNCTION;
	      }
	
	      if (element.url && element.url.substr(0, 5) === 'blob:') {
	        // Special case for handling JavaScript loaded into a blob.
	        // We use a synchronous AJAX request here as a blob is already in
	        // memory - it's not making a network request.  This will generate a warning
	        // in the browser console, but there has already been an error so that's not
	        // that much of an issue.
	        var xhr = new XMLHttpRequest();
	        xhr.open('GET', element.url, false);
	        xhr.send(null);
	
	        // If we failed to download the source, skip this patch
	        if (xhr.status === 200) {
	          var source = xhr.responseText || '';
	
	          // We trim the source down to the last 300 characters as sourceMappingURL is always at the end of the file.
	          // Why 300? To be in line with: https://github.com/getsentry/sentry/blob/4af29e8f2350e20c28a6933354e4f42437b4ba42/src/sentry/lang/javascript/processor.py#L164-L175
	          source = source.slice(-300);
	
	          // Now we dig out the source map URL
	          var sourceMaps = source.match(/\/\/# sourceMappingURL=(.*)$/);
	
	          // If we don't find a source map comment or we find more than one, continue on to the next element.
	          if (sourceMaps) {
	            var sourceMapAddress = sourceMaps[1];
	
	            // Now we check to see if it's a relative URL.
	            // If it is, convert it to an absolute one.
	            if (sourceMapAddress.charAt(0) === '~') {
	              sourceMapAddress = getLocationOrigin() + sourceMapAddress.slice(1);
	            }
	
	            // Now we strip the '.map' off of the end of the URL and update the
	            // element so that Sentry can match the map to the blob.
	            element.url = sourceMapAddress.slice(0, -4);
	          }
	        }
	      }
	
	      stack.push(element);
	    }
	
	    if (!stack.length) {
	      return null;
	    }
	
	    return {
	      name: ex.name,
	      message: ex.message,
	      url: getLocationHref(),
	      stack: stack
	    };
	  }
	
	  /**
	   * Adds information about the first frame to incomplete stack traces.
	   * Safari and IE require this to get complete data on the first frame.
	   * @param {Object.<string, *>} stackInfo Stack trace information from
	   * one of the compute* methods.
	   * @param {string} url The URL of the script that caused an error.
	   * @param {(number|string)} lineNo The line number of the script that
	   * caused an error.
	   * @param {string=} message The error generated by the browser, which
	   * hopefully contains the name of the object that caused the error.
	   * @return {boolean} Whether or not the stack information was
	   * augmented.
	   */
	  function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
	    var initial = {
	      url: url,
	      line: lineNo
	    };
	
	    if (initial.url && initial.line) {
	      stackInfo.incomplete = false;
	
	      if (!initial.func) {
	        initial.func = UNKNOWN_FUNCTION;
	      }
	
	      if (stackInfo.stack.length > 0) {
	        if (stackInfo.stack[0].url === initial.url) {
	          if (stackInfo.stack[0].line === initial.line) {
	            return false; // already in stack trace
	          } else if (
	            !stackInfo.stack[0].line &&
	            stackInfo.stack[0].func === initial.func
	          ) {
	            stackInfo.stack[0].line = initial.line;
	            return false;
	          }
	        }
	      }
	
	      stackInfo.stack.unshift(initial);
	      stackInfo.partial = true;
	      return true;
	    } else {
	      stackInfo.incomplete = true;
	    }
	
	    return false;
	  }
	
	  /**
	   * Computes stack trace information by walking the arguments.caller
	   * chain at the time the exception occurred. This will cause earlier
	   * frames to be missed but is the only way to get any stack trace in
	   * Safari and IE. The top frame is restored by
	   * {@link augmentStackTraceWithInitialElement}.
	   * @param {Error} ex
	   * @return {?Object.<string, *>} Stack trace information.
	   */
	  function computeStackTraceByWalkingCallerChain(ex, depth) {
	    var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
	      stack = [],
	      funcs = {},
	      recursion = false,
	      parts,
	      item,
	      source;
	
	    for (
	      var curr = computeStackTraceByWalkingCallerChain.caller;
	      curr && !recursion;
	      curr = curr.caller
	    ) {
	      if (curr === computeStackTrace || curr === TraceKit.report) {
	        // console.log('skipping internal function');
	        continue;
	      }
	
	      item = {
	        url: null,
	        func: UNKNOWN_FUNCTION,
	        line: null,
	        column: null
	      };
	
	      if (curr.name) {
	        item.func = curr.name;
	      } else if ((parts = functionName.exec(curr.toString()))) {
	        item.func = parts[1];
	      }
	
	      if (typeof item.func === 'undefined') {
	        try {
	          item.func = parts.input.substring(0, parts.input.indexOf('{'));
	        } catch (e) {}
	      }
	
	      if (funcs['' + curr]) {
	        recursion = true;
	      } else {
	        funcs['' + curr] = true;
	      }
	
	      stack.push(item);
	    }
	
	    if (depth) {
	      // console.log('depth is ' + depth);
	      // console.log('stack is ' + stack.length);
	      stack.splice(0, depth);
	    }
	
	    var result = {
	      name: ex.name,
	      message: ex.message,
	      url: getLocationHref(),
	      stack: stack
	    };
	    augmentStackTraceWithInitialElement(
	      result,
	      ex.sourceURL || ex.fileName,
	      ex.line || ex.lineNumber,
	      ex.message || ex.description
	    );
	    return result;
	  }
	
	  /**
	   * Computes a stack trace for an exception.
	   * @param {Error} ex
	   * @param {(string|number)=} depth
	   */
	  function computeStackTrace(ex, depth) {
	    var stack = null;
	    depth = depth == null ? 0 : +depth;
	
	    try {
	      stack = computeStackTraceFromStackProp(ex);
	      if (stack) {
	        return stack;
	      }
	    } catch (e) {
	      if (TraceKit.debug) {
	        throw e;
	      }
	    }
	
	    try {
	      stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
	      if (stack) {
	        return stack;
	      }
	    } catch (e) {
	      if (TraceKit.debug) {
	        throw e;
	      }
	    }
	    return {
	      name: ex.name,
	      message: ex.message,
	      url: getLocationHref()
	    };
	  }
	
	  computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
	  computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;
	
	  return computeStackTrace;
	})();
	
	module.exports = TraceKit;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1918 */
/***/ function(module, exports) {

	/*
	 * JavaScript MD5
	 * https://github.com/blueimp/JavaScript-MD5
	 *
	 * Copyright 2011, Sebastian Tschan
	 * https://blueimp.net
	 *
	 * Licensed under the MIT license:
	 * https://opensource.org/licenses/MIT
	 *
	 * Based on
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	
	/*
	* Add integers, wrapping at 2^32. This uses 16-bit operations internally
	* to work around bugs in some JS interpreters.
	*/
	function safeAdd(x, y) {
	  var lsw = (x & 0xffff) + (y & 0xffff);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return (msw << 16) | (lsw & 0xffff);
	}
	
	/*
	* Bitwise rotate a 32-bit number to the left.
	*/
	function bitRotateLeft(num, cnt) {
	  return (num << cnt) | (num >>> (32 - cnt));
	}
	
	/*
	* These functions implement the four basic operations the algorithm uses.
	*/
	function md5cmn(q, a, b, x, s, t) {
	  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
	}
	function md5ff(a, b, c, d, x, s, t) {
	  return md5cmn((b & c) | (~b & d), a, b, x, s, t);
	}
	function md5gg(a, b, c, d, x, s, t) {
	  return md5cmn((b & d) | (c & ~d), a, b, x, s, t);
	}
	function md5hh(a, b, c, d, x, s, t) {
	  return md5cmn(b ^ c ^ d, a, b, x, s, t);
	}
	function md5ii(a, b, c, d, x, s, t) {
	  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
	}
	
	/*
	* Calculate the MD5 of an array of little-endian words, and a bit length.
	*/
	function binlMD5(x, len) {
	  /* append padding */
	  x[len >> 5] |= 0x80 << (len % 32);
	  x[(((len + 64) >>> 9) << 4) + 14] = len;
	
	  var i;
	  var olda;
	  var oldb;
	  var oldc;
	  var oldd;
	  var a = 1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d = 271733878;
	
	  for (i = 0; i < x.length; i += 16) {
	    olda = a;
	    oldb = b;
	    oldc = c;
	    oldd = d;
	
	    a = md5ff(a, b, c, d, x[i], 7, -680876936);
	    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
	    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
	    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
	    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
	    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
	    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
	    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
	    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
	    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
	    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
	    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
	    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
	    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
	    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
	    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
	
	    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
	    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
	    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
	    b = md5gg(b, c, d, a, x[i], 20, -373897302);
	    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
	    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
	    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
	    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
	    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
	    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
	    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
	    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
	    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
	    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
	    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
	    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
	
	    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
	    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
	    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
	    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
	    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
	    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
	    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
	    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
	    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
	    d = md5hh(d, a, b, c, x[i], 11, -358537222);
	    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
	    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
	    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
	    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
	    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
	    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
	
	    a = md5ii(a, b, c, d, x[i], 6, -198630844);
	    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
	    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
	    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
	    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
	    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
	    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
	    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
	    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
	    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
	    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
	    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
	    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
	    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
	    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
	    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
	
	    a = safeAdd(a, olda);
	    b = safeAdd(b, oldb);
	    c = safeAdd(c, oldc);
	    d = safeAdd(d, oldd);
	  }
	  return [a, b, c, d];
	}
	
	/*
	* Convert an array of little-endian words to a string
	*/
	function binl2rstr(input) {
	  var i;
	  var output = '';
	  var length32 = input.length * 32;
	  for (i = 0; i < length32; i += 8) {
	    output += String.fromCharCode((input[i >> 5] >>> (i % 32)) & 0xff);
	  }
	  return output;
	}
	
	/*
	* Convert a raw string to an array of little-endian words
	* Characters >255 have their high-byte silently ignored.
	*/
	function rstr2binl(input) {
	  var i;
	  var output = [];
	  output[(input.length >> 2) - 1] = undefined;
	  for (i = 0; i < output.length; i += 1) {
	    output[i] = 0;
	  }
	  var length8 = input.length * 8;
	  for (i = 0; i < length8; i += 8) {
	    output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << (i % 32);
	  }
	  return output;
	}
	
	/*
	* Calculate the MD5 of a raw string
	*/
	function rstrMD5(s) {
	  return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
	}
	
	/*
	* Calculate the HMAC-MD5, of a key and some data (raw strings)
	*/
	function rstrHMACMD5(key, data) {
	  var i;
	  var bkey = rstr2binl(key);
	  var ipad = [];
	  var opad = [];
	  var hash;
	  ipad[15] = opad[15] = undefined;
	  if (bkey.length > 16) {
	    bkey = binlMD5(bkey, key.length * 8);
	  }
	  for (i = 0; i < 16; i += 1) {
	    ipad[i] = bkey[i] ^ 0x36363636;
	    opad[i] = bkey[i] ^ 0x5c5c5c5c;
	  }
	  hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
	  return binl2rstr(binlMD5(opad.concat(hash), 512 + 128));
	}
	
	/*
	* Convert a raw string to a hex string
	*/
	function rstr2hex(input) {
	  var hexTab = '0123456789abcdef';
	  var output = '';
	  var x;
	  var i;
	  for (i = 0; i < input.length; i += 1) {
	    x = input.charCodeAt(i);
	    output += hexTab.charAt((x >>> 4) & 0x0f) + hexTab.charAt(x & 0x0f);
	  }
	  return output;
	}
	
	/*
	* Encode a string as utf-8
	*/
	function str2rstrUTF8(input) {
	  return unescape(encodeURIComponent(input));
	}
	
	/*
	* Take string arguments and return either raw or hex encoded strings
	*/
	function rawMD5(s) {
	  return rstrMD5(str2rstrUTF8(s));
	}
	function hexMD5(s) {
	  return rstr2hex(rawMD5(s));
	}
	function rawHMACMD5(k, d) {
	  return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
	}
	function hexHMACMD5(k, d) {
	  return rstr2hex(rawHMACMD5(k, d));
	}
	
	function md5(string, key, raw) {
	  if (!key) {
	    if (!raw) {
	      return hexMD5(string);
	    }
	    return rawMD5(string);
	  }
	  if (!raw) {
	    return hexHMACMD5(key, string);
	  }
	  return rawHMACMD5(key, string);
	}
	
	module.exports = md5;


/***/ },
/* 1919 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrapToggle = __webpack_require__(866);
	
	var _reactBootstrapToggle2 = _interopRequireDefault(_reactBootstrapToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Exports the component with bootstrap 2 style names
	 */
	var ReactBootstrap2Toggle = function (_Toggle) {
	  _inherits(ReactBootstrap2Toggle, _Toggle);
	
	  function ReactBootstrap2Toggle() {
	    _classCallCheck(this, ReactBootstrap2Toggle);
	
	    return _possibleConstructorReturn(this, (ReactBootstrap2Toggle.__proto__ || Object.getPrototypeOf(ReactBootstrap2Toggle)).apply(this, arguments));
	  }
	
	  _createClass(ReactBootstrap2Toggle, [{
	    key: 'getSizeClass',
	    value: function getSizeClass() {
	      if (this.props.size === 'large') return 'btn-large';
	      if (this.props.size === 'small') return 'btn-small';
	      if (this.props.size === 'mini') return 'btn-mini';
	      return '';
	    }
	  }]);
	
	  return ReactBootstrap2Toggle;
	}(_reactBootstrapToggle2.default);
	
	exports.default = ReactBootstrap2Toggle;

/***/ },
/* 1920 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PADDING = {
	  RIGHT: 'padding-right',
	  LEFT: 'padding-left',
	  TOP: 'padding-top',
	  BOTTOM: 'padding-bottom'
	};
	
	var MARGIN = {
	  RIGHT: 'margin-right',
	  LEFT: 'margin-left',
	  TOP: 'margin-top',
	  BOTTOM: 'margin-bottom'
	};
	
	var getStyle = function getStyle(el, str) {
	  return parseInt(getComputedStyle(el).getPropertyValue(str), 10);
	};
	
	var getTextNodeBoundingClientRect = function getTextNodeBoundingClientRect(node) {
	  var newNode = node.length ? node[node.length - 1] : node;
	  if (typeof document.createRange === 'function') {
	    var range = document.createRange();
	    if (range.getBoundingClientRect) {
	      range.selectNodeContents(newNode);
	      return range.getBoundingClientRect();
	    }
	  }
	  return 0;
	};
	
	var compareWithMarginOfError = exports.compareWithMarginOfError = function compareWithMarginOfError(num1, num2, isSet) {
	  return isSet || Math.abs(num1 - num2) < 1.01;
	};
	
	var getDimension = exports.getDimension = function getDimension(node) {
	  var margin = {};
	
	  var padding = {
	    right: getStyle(node, PADDING.RIGHT),
	    left: getStyle(node, PADDING.LEFT),
	    top: getStyle(node, PADDING.TOP),
	    bottom: getStyle(node, PADDING.BOTTOM)
	  };
	
	  if (node.childElementCount) {
	    var child = node.childNodes[0];
	    margin.height = getStyle(child, MARGIN.BOTTOM) + getStyle(child, MARGIN.TOP);
	    margin.width = getStyle(child, MARGIN.LEFT) + getStyle(child, MARGIN.RIGHT);
	
	    return {
	      width: (child.scrollWidth || child.offsetWidth) + margin.width + padding.left + padding.right,
	      height: (child.scrollHeight || child.offsetHeight) + margin.height + padding.top + padding.bottom
	    };
	  }
	
	  var range = getTextNodeBoundingClientRect(node.childNodes);
	
	  return {
	    width: range.width + padding.right + padding.left,
	    height: range.height + padding.bottom + padding.top
	  };
	};

/***/ },
/* 1921 */
[2242, 1923],
/* 1922 */
[2243, 1921],
/* 1923 */
1016,
/* 1924 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _PanelGroup = _interopRequireDefault(__webpack_require__(890));
	
	var Accordion =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Accordion, _React$Component);
	
	  function Accordion() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Accordion.prototype;
	
	  _proto.render = function render() {
	    return _react.default.createElement(_PanelGroup.default, (0, _extends2.default)({}, this.props, {
	      accordion: true
	    }), this.props.children);
	  };
	
	  return Accordion;
	}(_react.default.Component);
	
	var _default = Accordion;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1925 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	// TODO: `pullRight` doesn't belong here. There's no special handling here.
	var propTypes = {
	  pullRight: _propTypes.default.bool
	};
	var defaultProps = {
	  pullRight: false
	};
	
	var Badge =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Badge, _React$Component);
	
	  function Badge() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Badge.prototype;
	
	  _proto.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react.default.Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        pullRight = _this$props.pullRight,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["pullRight", "className", "children"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends2.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'pull-right': pullRight,
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	    return _react.default.createElement("span", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }), children);
	  };
	
	  return Badge;
	}(_react.default.Component);
	
	Badge.propTypes = propTypes;
	Badge.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('badge', Badge);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1926 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _BreadcrumbItem = _interopRequireDefault(__webpack_require__(868));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var Breadcrumb =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Breadcrumb, _React$Component);
	
	  function Breadcrumb() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Breadcrumb.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement("ol", (0, _extends2.default)({}, elementProps, {
	      role: "navigation",
	      "aria-label": "breadcrumbs",
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return Breadcrumb;
	}(_react.default.Component);
	
	Breadcrumb.Item = _BreadcrumbItem.default;
	
	var _default = (0, _bootstrapUtils.bsClass)('breadcrumb', Breadcrumb);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1927 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var ButtonToolbar =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(ButtonToolbar, _React$Component);
	
	  function ButtonToolbar() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ButtonToolbar.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
	      role: "toolbar",
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return ButtonToolbar;
	}(_react.default.Component);
	
	var _default = (0, _bootstrapUtils.bsClass)('btn-toolbar', ButtonToolbar);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1928 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(58));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _CarouselCaption = _interopRequireDefault(__webpack_require__(1929));
	
	var _CarouselItem = _interopRequireDefault(__webpack_require__(869));
	
	var _Glyphicon = _interopRequireDefault(__webpack_require__(507));
	
	var _SafeAnchor = _interopRequireDefault(__webpack_require__(90));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(62));
	
	// TODO: `slide` should be `animate`.
	// TODO: Use uncontrollable.
	var propTypes = {
	  slide: _propTypes.default.bool,
	  indicators: _propTypes.default.bool,
	
	  /**
	   * The amount of time to delay between automatically cycling an item.
	   * If `null`, carousel will not automatically cycle.
	   */
	  interval: _propTypes.default.number,
	  controls: _propTypes.default.bool,
	  pauseOnHover: _propTypes.default.bool,
	  wrap: _propTypes.default.bool,
	
	  /**
	   * Callback fired when the active item changes.
	   *
	   * ```js
	   * (eventKey: any, ?event: Object) => any
	   * ```
	   *
	   * If this callback takes two or more arguments, the second argument will
	   * be a persisted event object with `direction` set to the direction of the
	   * transition.
	   */
	  onSelect: _propTypes.default.func,
	  onSlideEnd: _propTypes.default.func,
	  activeIndex: _propTypes.default.number,
	  defaultActiveIndex: _propTypes.default.number,
	  direction: _propTypes.default.oneOf(['prev', 'next']),
	  prevIcon: _propTypes.default.node,
	
	  /**
	   * Label shown to screen readers only, can be used to show the previous element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  prevLabel: _propTypes.default.string,
	  nextIcon: _propTypes.default.node,
	
	  /**
	   * Label shown to screen readers only, can be used to show the next element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  nextLabel: _propTypes.default.string
	};
	var defaultProps = {
	  slide: true,
	  interval: 5000,
	  pauseOnHover: true,
	  wrap: true,
	  indicators: true,
	  controls: true,
	  prevIcon: _react.default.createElement(_Glyphicon.default, {
	    glyph: "chevron-left"
	  }),
	  prevLabel: 'Previous',
	  nextIcon: _react.default.createElement(_Glyphicon.default, {
	    glyph: "chevron-right"
	  }),
	  nextLabel: 'Next'
	};
	
	var Carousel =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Carousel, _React$Component);
	
	  function Carousel(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    _this.handleMouseOver = _this.handleMouseOver.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleMouseOut = _this.handleMouseOut.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handlePrev = _this.handlePrev.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleNext = _this.handleNext.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    var defaultActiveIndex = props.defaultActiveIndex;
	    _this.state = {
	      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
	      previousActiveIndex: null,
	      direction: null
	    };
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  var _proto = Carousel.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.waitForNext();
	  };
	
	  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var activeIndex = this.getActiveIndex();
	
	    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
	      clearTimeout(this.timeout);
	      this.setState({
	        previousActiveIndex: activeIndex,
	        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
	      });
	    }
	
	    if (nextProps.activeIndex == null && this.state.activeIndex >= nextProps.children.length) {
	      this.setState({
	        activeIndex: 0,
	        previousActiveIndex: null,
	        direction: null
	      });
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    clearTimeout(this.timeout);
	    this.isUnmounted = true;
	  };
	
	  _proto.getActiveIndex = function getActiveIndex() {
	    var activeIndexProp = this.props.activeIndex;
	    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
	  };
	
	  _proto.getDirection = function getDirection(prevIndex, index) {
	    if (prevIndex === index) {
	      return null;
	    }
	
	    return prevIndex > index ? 'prev' : 'next';
	  };
	
	  _proto.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
	    var _this2 = this;
	
	    this.setState({
	      previousActiveIndex: null,
	      direction: null
	    }, function () {
	      _this2.waitForNext();
	
	      if (_this2.props.onSlideEnd) {
	        _this2.props.onSlideEnd();
	      }
	    });
	  };
	
	  _proto.handleMouseOut = function handleMouseOut() {
	    if (this.isPaused) {
	      this.play();
	    }
	  };
	
	  _proto.handleMouseOver = function handleMouseOver() {
	    if (this.props.pauseOnHover) {
	      this.pause();
	    }
	  };
	
	  _proto.handleNext = function handleNext(e) {
	    var index = this.getActiveIndex() + 1;
	
	    var count = _ValidComponentChildren.default.count(this.props.children);
	
	    if (index > count - 1) {
	      if (!this.props.wrap) {
	        return;
	      }
	
	      index = 0;
	    }
	
	    this.select(index, e, 'next');
	  };
	
	  _proto.handlePrev = function handlePrev(e) {
	    var index = this.getActiveIndex() - 1;
	
	    if (index < 0) {
	      if (!this.props.wrap) {
	        return;
	      }
	
	      index = _ValidComponentChildren.default.count(this.props.children) - 1;
	    }
	
	    this.select(index, e, 'prev');
	  }; // This might be a public API.
	
	
	  _proto.pause = function pause() {
	    this.isPaused = true;
	    clearTimeout(this.timeout);
	  }; // This might be a public API.
	
	
	  _proto.play = function play() {
	    this.isPaused = false;
	    this.waitForNext();
	  };
	
	  _proto.select = function select(index, e, direction) {
	    clearTimeout(this.timeout); // TODO: Is this necessary? Seems like the only risk is if the component
	    // unmounts while handleItemAnimateOutEnd fires.
	
	    if (this.isUnmounted) {
	      return;
	    }
	
	    var previousActiveIndex = this.props.slide ? this.getActiveIndex() : null;
	    direction = direction || this.getDirection(previousActiveIndex, index);
	    var onSelect = this.props.onSelect;
	
	    if (onSelect) {
	      if (onSelect.length > 1) {
	        // React SyntheticEvents are pooled, so we need to remove this event
	        // from the pool to add a custom property. To avoid unnecessarily
	        // removing objects from the pool, only do this when the listener
	        // actually wants the event.
	        if (e) {
	          e.persist();
	          e.direction = direction;
	        } else {
	          e = {
	            direction: direction
	          };
	        }
	
	        onSelect(index, e);
	      } else {
	        onSelect(index);
	      }
	    }
	
	    if (this.props.activeIndex == null && index !== previousActiveIndex) {
	      if (this.state.previousActiveIndex != null) {
	        // If currently animating don't activate the new index.
	        // TODO: look into queueing this canceled call and
	        // animating after the current animation has ended.
	        return;
	      }
	
	      this.setState({
	        activeIndex: index,
	        previousActiveIndex: previousActiveIndex,
	        direction: direction
	      });
	    }
	  };
	
	  _proto.waitForNext = function waitForNext() {
	    var _this$props = this.props,
	        slide = _this$props.slide,
	        interval = _this$props.interval,
	        activeIndexProp = _this$props.activeIndex;
	
	    if (!this.isPaused && slide && interval && activeIndexProp == null) {
	      this.timeout = setTimeout(this.handleNext, interval);
	    }
	  };
	
	  _proto.renderControls = function renderControls(properties) {
	    var wrap = properties.wrap,
	        children = properties.children,
	        activeIndex = properties.activeIndex,
	        prevIcon = properties.prevIcon,
	        nextIcon = properties.nextIcon,
	        bsProps = properties.bsProps,
	        prevLabel = properties.prevLabel,
	        nextLabel = properties.nextLabel;
	    var controlClassName = (0, _bootstrapUtils.prefix)(bsProps, 'control');
	
	    var count = _ValidComponentChildren.default.count(children);
	
	    return [(wrap || activeIndex !== 0) && _react.default.createElement(_SafeAnchor.default, {
	      key: "prev",
	      className: (0, _classnames.default)(controlClassName, 'left'),
	      onClick: this.handlePrev
	    }, prevIcon, prevLabel && _react.default.createElement("span", {
	      className: "sr-only"
	    }, prevLabel)), (wrap || activeIndex !== count - 1) && _react.default.createElement(_SafeAnchor.default, {
	      key: "next",
	      className: (0, _classnames.default)(controlClassName, 'right'),
	      onClick: this.handleNext
	    }, nextIcon, nextLabel && _react.default.createElement("span", {
	      className: "sr-only"
	    }, nextLabel))];
	  };
	
	  _proto.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
	    var _this3 = this;
	
	    var indicators = [];
	
	    _ValidComponentChildren.default.forEach(children, function (child, index) {
	      indicators.push(_react.default.createElement("li", {
	        key: index,
	        className: index === activeIndex ? 'active' : null,
	        onClick: function onClick(e) {
	          return _this3.select(index, e);
	        }
	      }), // Force whitespace between indicator elements. Bootstrap requires
	      // this for correct spacing of elements.
	      ' ');
	    });
	
	    return _react.default.createElement("ol", {
	      className: (0, _bootstrapUtils.prefix)(bsProps, 'indicators')
	    }, indicators);
	  };
	
	  _proto.render = function render() {
	    var _this4 = this;
	
	    var _this$props2 = this.props,
	        slide = _this$props2.slide,
	        indicators = _this$props2.indicators,
	        controls = _this$props2.controls,
	        wrap = _this$props2.wrap,
	        prevIcon = _this$props2.prevIcon,
	        prevLabel = _this$props2.prevLabel,
	        nextIcon = _this$props2.nextIcon,
	        nextLabel = _this$props2.nextLabel,
	        className = _this$props2.className,
	        children = _this$props2.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["slide", "indicators", "controls", "wrap", "prevIcon", "prevLabel", "nextIcon", "nextLabel", "className", "children"]);
	    var _this$state = this.state,
	        previousActiveIndex = _this$state.previousActiveIndex,
	        direction = _this$state.direction;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
	    'defaultActiveIndex', 'direction']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var activeIndex = this.getActiveIndex();
	    var classes = (0, _extends2.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      slide: slide
	    });
	    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes),
	      onMouseOver: this.handleMouseOver,
	      onMouseOut: this.handleMouseOut
	    }), indicators && this.renderIndicators(children, activeIndex, bsProps), _react.default.createElement("div", {
	      className: (0, _bootstrapUtils.prefix)(bsProps, 'inner')
	    }, _ValidComponentChildren.default.map(children, function (child, index) {
	      var active = index === activeIndex;
	      var previousActive = slide && index === previousActiveIndex;
	      return (0, _react.cloneElement)(child, {
	        active: active,
	        index: index,
	        animateOut: previousActive,
	        animateIn: active && previousActiveIndex != null && slide,
	        direction: direction,
	        onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
	      });
	    })), controls && this.renderControls({
	      wrap: wrap,
	      children: children,
	      activeIndex: activeIndex,
	      prevIcon: prevIcon,
	      prevLabel: prevLabel,
	      nextIcon: nextIcon,
	      nextLabel: nextLabel,
	      bsProps: bsProps
	    }));
	  };
	
	  return Carousel;
	}(_react.default.Component);
	
	Carousel.propTypes = propTypes;
	Carousel.defaultProps = defaultProps;
	Carousel.Caption = _CarouselCaption.default;
	Carousel.Item = _CarouselItem.default;
	
	var _default = (0, _bootstrapUtils.bsClass)('carousel', Carousel);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1929 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _elementType = _interopRequireDefault(__webpack_require__(34));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var propTypes = {
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var CarouselCaption =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(CarouselCaption, _React$Component);
	
	  function CarouselCaption() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = CarouselCaption.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.componentClass,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return CarouselCaption;
	}(_react.default.Component);
	
	CarouselCaption.propTypes = propTypes;
	CarouselCaption.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('carousel-caption', CarouselCaption);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1930 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _warning = _interopRequireDefault(__webpack_require__(47));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	/* eslint-disable jsx-a11y/label-has-for */
	var propTypes = {
	  inline: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  title: _propTypes.default.string,
	
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _propTypes.default.oneOf(['success', 'warning', 'error', null]),
	
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Checkbox inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes.default.func
	};
	var defaultProps = {
	  inline: false,
	  disabled: false,
	  title: ''
	};
	
	var Checkbox =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Checkbox, _React$Component);
	
	  function Checkbox() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Checkbox.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        inline = _this$props.inline,
	        disabled = _this$props.disabled,
	        validationState = _this$props.validationState,
	        inputRef = _this$props.inputRef,
	        className = _this$props.className,
	        style = _this$props.style,
	        title = _this$props.title,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["inline", "disabled", "validationState", "inputRef", "className", "style", "title", "children"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react.default.createElement("input", (0, _extends2.default)({}, elementProps, {
	      ref: inputRef,
	      type: "checkbox",
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2); // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	
	
	       false ? (0, _warning.default)(!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	      return _react.default.createElement("label", {
	        className: (0, _classnames.default)(className, _classes),
	        style: style,
	        title: title
	      }, input, children);
	    }
	
	    var classes = (0, _extends2.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	
	    if (validationState) {
	      classes["has-" + validationState] = true;
	    }
	
	    return _react.default.createElement("div", {
	      className: (0, _classnames.default)(className, classes),
	      style: style
	    }, _react.default.createElement("label", {
	      title: title
	    }, input, children));
	  };
	
	  return Checkbox;
	}(_react.default.Component);
	
	Checkbox.propTypes = propTypes;
	Checkbox.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('checkbox', Checkbox);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1931 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _elementType = _interopRequireDefault(__webpack_require__(34));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _capitalize = _interopRequireDefault(__webpack_require__(897));
	
	var _StyleConfig = __webpack_require__(51);
	
	var propTypes = {
	  componentClass: _elementType.default,
	
	  /**
	   * Apply clearfix
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `visible-xs-block`
	   */
	  visibleXsBlock: _propTypes.default.bool,
	
	  /**
	   * Apply clearfix
	   *
	   * on Small devices Tablets
	   *
	   * adds class `visible-sm-block`
	   */
	  visibleSmBlock: _propTypes.default.bool,
	
	  /**
	   * Apply clearfix
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `visible-md-block`
	   */
	  visibleMdBlock: _propTypes.default.bool,
	
	  /**
	   * Apply clearfix
	   *
	   * on Large devices Desktops
	   *
	   * adds class `visible-lg-block`
	   */
	  visibleLgBlock: _propTypes.default.bool
	};
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Clearfix =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Clearfix, _React$Component);
	
	  function Clearfix() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Clearfix.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.componentClass,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      var propName = "visible" + (0, _capitalize.default)(size) + "Block";
	
	      if (elementProps[propName]) {
	        classes["visible-" + size + "-block"] = true;
	      }
	
	      delete elementProps[propName];
	    });
	
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return Clearfix;
	}(_react.default.Component);
	
	Clearfix.propTypes = propTypes;
	Clearfix.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('clearfix', Clearfix);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1932 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _from = _interopRequireDefault(__webpack_require__(966));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(58));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _keycode = _interopRequireDefault(__webpack_require__(304));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(31));
	
	var _RootCloseWrapper = _interopRequireDefault(__webpack_require__(909));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(62));
	
	var propTypes = {
	  open: _propTypes.default.bool,
	  pullRight: _propTypes.default.bool,
	  onClose: _propTypes.default.func,
	  labelledBy: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  onSelect: _propTypes.default.func,
	  rootCloseEvent: _propTypes.default.oneOf(['click', 'mousedown'])
	};
	var defaultProps = {
	  bsRole: 'menu',
	  pullRight: false
	};
	
	var DropdownMenu =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(DropdownMenu, _React$Component);
	
	  function DropdownMenu(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.handleRootClose = _this.handleRootClose.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    return _this;
	  }
	
	  var _proto = DropdownMenu.prototype;
	
	  _proto.getFocusableMenuItems = function getFocusableMenuItems() {
	    var node = _reactDom.default.findDOMNode(this);
	
	    if (!node) {
	      return [];
	    }
	
	    return (0, _from.default)(node.querySelectorAll('[tabIndex="-1"]'));
	  };
	
	  _proto.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
	    var items = this.getFocusableMenuItems();
	    var activeIndex = items.indexOf(document.activeElement);
	    return {
	      items: items,
	      activeIndex: activeIndex
	    };
	  };
	
	  _proto.focusNext = function focusNext() {
	    var _this$getItemsAndActi = this.getItemsAndActiveIndex(),
	        items = _this$getItemsAndActi.items,
	        activeIndex = _this$getItemsAndActi.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
	    items[nextIndex].focus();
	  };
	
	  _proto.focusPrevious = function focusPrevious() {
	    var _this$getItemsAndActi2 = this.getItemsAndActiveIndex(),
	        items = _this$getItemsAndActi2.items,
	        activeIndex = _this$getItemsAndActi2.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
	    items[prevIndex].focus();
	  };
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    switch (event.keyCode) {
	      case _keycode.default.codes.down:
	        this.focusNext();
	        event.preventDefault();
	        break;
	
	      case _keycode.default.codes.up:
	        this.focusPrevious();
	        event.preventDefault();
	        break;
	
	      case _keycode.default.codes.esc:
	      case _keycode.default.codes.tab:
	        this.props.onClose(event, {
	          source: 'keydown'
	        });
	        break;
	
	      default:
	    }
	  };
	
	  _proto.handleRootClose = function handleRootClose(event) {
	    this.props.onClose(event, {
	      source: 'rootClose'
	    });
	  };
	
	  _proto.render = function render() {
	    var _extends2,
	        _this2 = this;
	
	    var _this$props = this.props,
	        open = _this$props.open,
	        pullRight = _this$props.pullRight,
	        labelledBy = _this$props.labelledBy,
	        onSelect = _this$props.onSelect,
	        className = _this$props.className,
	        rootCloseEvent = _this$props.rootCloseEvent,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["open", "pullRight", "labelledBy", "onSelect", "className", "rootCloseEvent", "children"]);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['onClose']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'right')] = pullRight, _extends2));
	    return _react.default.createElement(_RootCloseWrapper.default, {
	      disabled: !open,
	      onRootClose: this.handleRootClose,
	      event: rootCloseEvent
	    }, _react.default.createElement("ul", (0, _extends3.default)({}, elementProps, {
	      role: "menu",
	      className: (0, _classnames.default)(className, classes),
	      "aria-labelledby": labelledBy
	    }), _ValidComponentChildren.default.map(children, function (child) {
	      return _react.default.cloneElement(child, {
	        onKeyDown: (0, _createChainedFunction.default)(child.props.onKeyDown, _this2.handleKeyDown),
	        onSelect: (0, _createChainedFunction.default)(child.props.onSelect, onSelect)
	      });
	    })));
	  };
	
	  return DropdownMenu;
	}(_react.default.Component);
	
	DropdownMenu.propTypes = propTypes;
	DropdownMenu.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('dropdown-menu', DropdownMenu);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1933 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _elementType = _interopRequireDefault(__webpack_require__(34));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var propTypes = {
	  horizontal: _propTypes.default.bool,
	  inline: _propTypes.default.bool,
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  horizontal: false,
	  inline: false,
	  componentClass: 'form'
	};
	
	var Form =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Form, _React$Component);
	
	  function Form() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Form.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        horizontal = _this$props.horizontal,
	        inline = _this$props.inline,
	        Component = _this$props.componentClass,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["horizontal", "inline", "componentClass", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	
	    if (horizontal) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'horizontal'));
	    }
	
	    if (inline) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'inline'));
	    }
	
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return Form;
	}(_react.default.Component);
	
	Form.propTypes = propTypes;
	Form.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('form', Form);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1934 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _Glyphicon = _interopRequireDefault(__webpack_require__(507));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var defaultProps = {
	  bsRole: 'feedback'
	};
	var contextTypes = {
	  $bs_formGroup: _propTypes.default.object
	};
	
	var FormControlFeedback =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(FormControlFeedback, _React$Component);
	
	  function FormControlFeedback() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = FormControlFeedback.prototype;
	
	  _proto.getGlyph = function getGlyph(validationState) {
	    switch (validationState) {
	      case 'success':
	        return 'ok';
	
	      case 'warning':
	        return 'warning-sign';
	
	      case 'error':
	        return 'remove';
	
	      default:
	        return null;
	    }
	  };
	
	  _proto.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
	    var glyph = this.getGlyph(formGroup && formGroup.validationState);
	
	    if (!glyph) {
	      return null;
	    }
	
	    return _react.default.createElement(_Glyphicon.default, (0, _extends2.default)({}, elementProps, {
	      glyph: glyph,
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "children"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (!children) {
	      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return _react.default.cloneElement(child, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(child.props.className, className, classes)
	    }));
	  };
	
	  return FormControlFeedback;
	}(_react.default.Component);
	
	FormControlFeedback.defaultProps = defaultProps;
	FormControlFeedback.contextTypes = contextTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('form-control-feedback', FormControlFeedback);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1935 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _elementType = _interopRequireDefault(__webpack_require__(34));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var propTypes = {
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  componentClass: 'p'
	};
	
	var FormControlStatic =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(FormControlStatic, _React$Component);
	
	  function FormControlStatic() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = FormControlStatic.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.componentClass,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return FormControlStatic;
	}(_react.default.Component);
	
	FormControlStatic.propTypes = propTypes;
	FormControlStatic.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('form-control-static', FormControlStatic);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1936 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var propTypes = {
	  /**
	   * Sets image as responsive image
	   */
	  responsive: _propTypes.default.bool,
	
	  /**
	   * Sets image shape as rounded
	   */
	  rounded: _propTypes.default.bool,
	
	  /**
	   * Sets image shape as circle
	   */
	  circle: _propTypes.default.bool,
	
	  /**
	   * Sets image shape as thumbnail
	   */
	  thumbnail: _propTypes.default.bool
	};
	var defaultProps = {
	  responsive: false,
	  rounded: false,
	  circle: false,
	  thumbnail: false
	};
	
	var Image =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Image, _React$Component);
	
	  function Image() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Image.prototype;
	
	  _proto.render = function render() {
	    var _classes;
	
	    var _this$props = this.props,
	        responsive = _this$props.responsive,
	        rounded = _this$props.rounded,
	        circle = _this$props.circle,
	        thumbnail = _this$props.thumbnail,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["responsive", "rounded", "circle", "thumbnail", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (_classes = {}, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'responsive')] = responsive, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'rounded')] = rounded, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'circle')] = circle, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'thumbnail')] = thumbnail, _classes);
	    return _react.default.createElement("img", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return Image;
	}(_react.default.Component);
	
	Image.propTypes = propTypes;
	Image.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('img', Image);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1937 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var InputGroupAddon =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(InputGroupAddon, _React$Component);
	
	  function InputGroupAddon() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = InputGroupAddon.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement("span", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return InputGroupAddon;
	}(_react.default.Component);
	
	var _default = (0, _bootstrapUtils.bsClass)('input-group-addon', InputGroupAddon);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1938 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var InputGroupButton =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(InputGroupButton, _React$Component);
	
	  function InputGroupButton() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = InputGroupButton.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement("span", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return InputGroupButton;
	}(_react.default.Component);
	
	var _default = (0, _bootstrapUtils.bsClass)('input-group-btn', InputGroupButton);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1939 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _elementType = _interopRequireDefault(__webpack_require__(34));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var propTypes = {
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Jumbotron =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Jumbotron, _React$Component);
	
	  function Jumbotron() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Jumbotron.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.componentClass,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return Jumbotron;
	}(_react.default.Component);
	
	Jumbotron.propTypes = propTypes;
	Jumbotron.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('jumbotron', Jumbotron);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1940 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _values = _interopRequireDefault(__webpack_require__(166));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _StyleConfig = __webpack_require__(51);
	
	var Label =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Label, _React$Component);
	
	  function Label() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Label.prototype;
	
	  _proto.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react.default.Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "children"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends2.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	    return _react.default.createElement("span", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }), children);
	  };
	
	  return Label;
	}(_react.default.Component);
	
	var _default = (0, _bootstrapUtils.bsClass)('label', (0, _bootstrapUtils.bsStyles)((0, _values.default)(_StyleConfig.State).concat([_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Label));
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1941 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _elementType = _interopRequireDefault(__webpack_require__(34));
	
	var _ListGroupItem = _interopRequireDefault(__webpack_require__(877));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(62));
	
	var propTypes = {
	  /**
	   * You can use a custom element type for this component.
	   *
	   * If not specified, it will be treated as `'li'` if every child is a
	   * non-actionable `<ListGroupItem>`, and `'div'` otherwise.
	   */
	  componentClass: _elementType.default
	};
	
	function getDefaultComponent(children) {
	  if (!children) {
	    // FIXME: This is the old behavior. Is this right?
	    return 'div';
	  }
	
	  if (_ValidComponentChildren.default.some(children, function (child) {
	    return child.type !== _ListGroupItem.default || child.props.href || child.props.onClick;
	  })) {
	    return 'div';
	  }
	
	  return 'ul';
	}
	
	var ListGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(ListGroup, _React$Component);
	
	  function ListGroup() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ListGroup.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        _this$props$component = _this$props.componentClass,
	        Component = _this$props$component === void 0 ? getDefaultComponent(children) : _this$props$component,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["children", "componentClass", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var useListItem = Component === 'ul' && _ValidComponentChildren.default.every(children, function (child) {
	      return child.type === _ListGroupItem.default;
	    });
	
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }), useListItem ? _ValidComponentChildren.default.map(children, function (child) {
	      return (0, _react.cloneElement)(child, {
	        listItem: true
	      });
	    }) : children);
	  };
	
	  return ListGroup;
	}(_react.default.Component);
	
	ListGroup.propTypes = propTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('list-group', ListGroup);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1942 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _elementType = _interopRequireDefault(__webpack_require__(34));
	
	var _Media = _interopRequireDefault(__webpack_require__(320));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes.default.oneOf(['top', 'middle', 'bottom']),
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var MediaBody =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(MediaBody, _React$Component);
	
	  function MediaBody() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = MediaBody.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.componentClass,
	        align = _this$props.align,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "align", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-left-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media.default.defaultProps, align)] = true;
	    }
	
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return MediaBody;
	}(_react.default.Component);
	
	MediaBody.propTypes = propTypes;
	MediaBody.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('media-body', MediaBody);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1943 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _elementType = _interopRequireDefault(__webpack_require__(34));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var propTypes = {
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var MediaHeading =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(MediaHeading, _React$Component);
	
	  function MediaHeading() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = MediaHeading.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.componentClass,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return MediaHeading;
	}(_react.default.Component);
	
	MediaHeading.propTypes = propTypes;
	MediaHeading.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('media-heading', MediaHeading);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1944 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _Media = _interopRequireDefault(__webpack_require__(320));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes.default.oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaLeft =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(MediaLeft, _React$Component);
	
	  function MediaLeft() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = MediaLeft.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        align = _this$props.align,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["align", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-left-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media.default.defaultProps, align)] = true;
	    }
	
	    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return MediaLeft;
	}(_react.default.Component);
	
	MediaLeft.propTypes = propTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('media-left', MediaLeft);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1945 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var MediaList =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(MediaList, _React$Component);
	
	  function MediaList() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = MediaList.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement("ul", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return MediaList;
	}(_react.default.Component);
	
	var _default = (0, _bootstrapUtils.bsClass)('media-list', MediaList);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1946 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var MediaListItem =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(MediaListItem, _React$Component);
	
	  function MediaListItem() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = MediaListItem.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement("li", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return MediaListItem;
	}(_react.default.Component);
	
	var _default = (0, _bootstrapUtils.bsClass)('media', MediaListItem);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1947 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _Media = _interopRequireDefault(__webpack_require__(320));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes.default.oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaRight =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(MediaRight, _React$Component);
	
	  function MediaRight() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = MediaRight.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        align = _this$props.align,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["align", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-right-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media.default.defaultProps, align)] = true;
	    }
	
	    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return MediaRight;
	}(_react.default.Component);
	
	MediaRight.propTypes = propTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('media-right', MediaRight);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1948 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(58));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _events = _interopRequireDefault(__webpack_require__(1736));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(187));
	
	var _inDOM = _interopRequireDefault(__webpack_require__(123));
	
	var _scrollbarSize = _interopRequireDefault(__webpack_require__(833));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(31));
	
	var _Modal = _interopRequireDefault(__webpack_require__(2033));
	
	var _isOverflowing = _interopRequireDefault(__webpack_require__(911));
	
	var _elementType = _interopRequireDefault(__webpack_require__(34));
	
	var _Fade = _interopRequireDefault(__webpack_require__(319));
	
	var _ModalBody = _interopRequireDefault(__webpack_require__(879));
	
	var _ModalDialog = _interopRequireDefault(__webpack_require__(880));
	
	var _ModalFooter = _interopRequireDefault(__webpack_require__(881));
	
	var _ModalHeader = _interopRequireDefault(__webpack_require__(882));
	
	var _ModalTitle = _interopRequireDefault(__webpack_require__(883));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var _splitComponentProps2 = _interopRequireDefault(__webpack_require__(321));
	
	var _StyleConfig = __webpack_require__(51);
	
	var propTypes = (0, _extends2.default)({}, _Modal.default.propTypes, _ModalDialog.default.propTypes, {
	  /**
	   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
	   * trigger an "onHide" when clicked.
	   */
	  backdrop: _propTypes.default.oneOf(['static', true, false]),
	
	  /**
	   * Add an optional extra class name to .modal-backdrop
	   * It could end up looking like class="modal-backdrop foo-modal-backdrop in".
	   */
	  backdropClassName: _propTypes.default.string,
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _propTypes.default.bool,
	
	  /**
	   * Open and close the Modal with a slide and fade animation.
	   */
	  animation: _propTypes.default.bool,
	
	  /**
	   * A Component type that provides the modal content Markup. This is a useful
	   * prop when you want to use your own styles and markup to create a custom
	   * modal component.
	   */
	  dialogComponentClass: _elementType.default,
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it
	   * opens, and replace it to the last focused element when it closes.
	   * Generally this should never be set to false as it makes the Modal less
	   * accessible to assistive technologies, like screen-readers.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while
	   * open. Consider leaving the default value here, as it is necessary to make
	   * the Modal work well with assistive technologies, such as screen readers.
	   */
	  enforceFocus: _propTypes.default.bool,
	
	  /**
	   * When `true` The modal will restore focus to previously focused element once
	   * modal is hidden
	   */
	  restoreFocus: _propTypes.default.bool,
	
	  /**
	   * When `true` The modal will show itself.
	   */
	  show: _propTypes.default.bool,
	
	  /**
	   * A callback fired when the header closeButton or non-static backdrop is
	   * clicked. Required if either are specified.
	   */
	  onHide: _propTypes.default.func,
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * @private
	   */
	  container: _Modal.default.propTypes.container
	});
	var defaultProps = (0, _extends2.default)({}, _Modal.default.defaultProps, {
	  animation: true,
	  dialogComponentClass: _ModalDialog.default
	});
	var childContextTypes = {
	  $bs_modal: _propTypes.default.shape({
	    onHide: _propTypes.default.func
	  })
	};
	/* eslint-disable no-use-before-define, react/no-multi-comp */
	
	function DialogTransition(props) {
	  return _react.default.createElement(_Fade.default, (0, _extends2.default)({}, props, {
	    timeout: Modal.TRANSITION_DURATION
	  }));
	}
	
	function BackdropTransition(props) {
	  return _react.default.createElement(_Fade.default, (0, _extends2.default)({}, props, {
	    timeout: Modal.BACKDROP_TRANSITION_DURATION
	  }));
	}
	/* eslint-enable no-use-before-define */
	
	
	var Modal =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Modal, _React$Component);
	
	  function Modal(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    _this.handleEntering = _this.handleEntering.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleExited = _this.handleExited.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleWindowResize = _this.handleWindowResize.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleDialogClick = _this.handleDialogClick.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.setModalRef = _this.setModalRef.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.state = {
	      style: {}
	    };
	    return _this;
	  }
	
	  var _proto = Modal.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      $bs_modal: {
	        onHide: this.props.onHide
	      }
	    };
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    // Clean up the listener if we need to.
	    this.handleExited();
	  };
	
	  _proto.setModalRef = function setModalRef(ref) {
	    this._modal = ref;
	  };
	
	  _proto.handleDialogClick = function handleDialogClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    this.props.onHide();
	  };
	
	  _proto.handleEntering = function handleEntering() {
	    // FIXME: This should work even when animation is disabled.
	    _events.default.on(window, 'resize', this.handleWindowResize);
	
	    this.updateStyle();
	  };
	
	  _proto.handleExited = function handleExited() {
	    // FIXME: This should work even when animation is disabled.
	    _events.default.off(window, 'resize', this.handleWindowResize);
	  };
	
	  _proto.handleWindowResize = function handleWindowResize() {
	    this.updateStyle();
	  };
	
	  _proto.updateStyle = function updateStyle() {
	    if (!_inDOM.default) {
	      return;
	    }
	
	    var dialogNode = this._modal.getDialogElement();
	
	    var dialogHeight = dialogNode.scrollHeight;
	    var document = (0, _ownerDocument.default)(dialogNode);
	    var bodyIsOverflowing = (0, _isOverflowing.default)(_reactDom.default.findDOMNode(this.props.container || document.body));
	    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;
	    this.setState({
	      style: {
	        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? (0, _scrollbarSize.default)() : undefined,
	        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? (0, _scrollbarSize.default)() : undefined
	      }
	    });
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        backdrop = _this$props.backdrop,
	        backdropClassName = _this$props.backdropClassName,
	        animation = _this$props.animation,
	        show = _this$props.show,
	        Dialog = _this$props.dialogComponentClass,
	        className = _this$props.className,
	        style = _this$props.style,
	        children = _this$props.children,
	        onEntering = _this$props.onEntering,
	        onExited = _this$props.onExited,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["backdrop", "backdropClassName", "animation", "show", "dialogComponentClass", "className", "style", "children", "onEntering", "onExited"]);
	
	    var _splitComponentProps = (0, _splitComponentProps2.default)(props, _Modal.default),
	        baseModalProps = _splitComponentProps[0],
	        dialogProps = _splitComponentProps[1];
	
	    var inClassName = show && !animation && 'in';
	    return _react.default.createElement(_Modal.default, (0, _extends2.default)({}, baseModalProps, {
	      ref: this.setModalRef,
	      show: show,
	      containerClassName: (0, _bootstrapUtils.prefix)(props, 'open'),
	      transition: animation ? DialogTransition : undefined,
	      backdrop: backdrop,
	      backdropTransition: animation ? BackdropTransition : undefined,
	      backdropClassName: (0, _classnames.default)((0, _bootstrapUtils.prefix)(props, 'backdrop'), backdropClassName, inClassName),
	      onEntering: (0, _createChainedFunction.default)(onEntering, this.handleEntering),
	      onExited: (0, _createChainedFunction.default)(onExited, this.handleExited)
	    }), _react.default.createElement(Dialog, (0, _extends2.default)({}, dialogProps, {
	      style: (0, _extends2.default)({}, this.state.style, style),
	      className: (0, _classnames.default)(className, inClassName),
	      onClick: backdrop === true ? this.handleDialogClick : null
	    }), children));
	  };
	
	  return Modal;
	}(_react.default.Component);
	
	Modal.propTypes = propTypes;
	Modal.defaultProps = defaultProps;
	Modal.childContextTypes = childContextTypes;
	Modal.Body = _ModalBody.default;
	Modal.Header = _ModalHeader.default;
	Modal.Title = _ModalTitle.default;
	Modal.Footer = _ModalFooter.default;
	Modal.Dialog = _ModalDialog.default;
	Modal.TRANSITION_DURATION = 300;
	Modal.BACKDROP_TRANSITION_DURATION = 150;
	
	var _default = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Modal));
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1949 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _Dropdown = _interopRequireDefault(__webpack_require__(318));
	
	var _splitComponentProps2 = _interopRequireDefault(__webpack_require__(321));
	
	var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(62));
	
	var propTypes = (0, _extends2.default)({}, _Dropdown.default.propTypes, {
	  // Toggle props.
	  title: _propTypes.default.node.isRequired,
	  noCaret: _propTypes.default.bool,
	  active: _propTypes.default.bool,
	  activeKey: _propTypes.default.any,
	  activeHref: _propTypes.default.string,
	  // Override generated docs from <Dropdown>.
	
	  /**
	   * @private
	   */
	  children: _propTypes.default.node
	});
	
	var NavDropdown =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(NavDropdown, _React$Component);
	
	  function NavDropdown() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = NavDropdown.prototype;
	
	  _proto.isActive = function isActive(_ref, activeKey, activeHref) {
	    var _this = this;
	
	    var props = _ref.props;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    if (_ValidComponentChildren.default.some(props.children, function (child) {
	      return _this.isActive(child, activeKey, activeHref);
	    })) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var _this$props = this.props,
	        title = _this$props.title,
	        activeKey = _this$props.activeKey,
	        activeHref = _this$props.activeHref,
	        className = _this$props.className,
	        style = _this$props.style,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["title", "activeKey", "activeHref", "className", "style", "children"]);
	    var active = this.isActive(this, activeKey, activeHref);
	    delete props.active; // Accessed via this.isActive().
	
	    delete props.eventKey; // Accessed via this.isActive().
	
	    var _splitComponentProps = (0, _splitComponentProps2.default)(props, _Dropdown.default.ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1]; // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
	    // rather than the `<Dropdown.Toggle>`.
	
	
	    return _react.default.createElement(_Dropdown.default, (0, _extends2.default)({}, dropdownProps, {
	      componentClass: "li",
	      className: (0, _classnames.default)(className, {
	        active: active
	      }),
	      style: style
	    }), _react.default.createElement(_Dropdown.default.Toggle, (0, _extends2.default)({}, toggleProps, {
	      useAnchor: true
	    }), title), _react.default.createElement(_Dropdown.default.Menu, null, _ValidComponentChildren.default.map(children, function (child) {
	      return _react.default.cloneElement(child, {
	        active: _this2.isActive(child, activeKey, activeHref)
	      });
	    })));
	  };
	
	  return NavDropdown;
	}(_react.default.Component);
	
	NavDropdown.propTypes = propTypes;
	var _default = NavDropdown;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1950 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(58));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _elementType = _interopRequireDefault(__webpack_require__(34));
	
	var _uncontrollable = _interopRequireDefault(__webpack_require__(155));
	
	var _Grid = _interopRequireDefault(__webpack_require__(874));
	
	var _NavbarBrand = _interopRequireDefault(__webpack_require__(886));
	
	var _NavbarCollapse = _interopRequireDefault(__webpack_require__(1951));
	
	var _NavbarHeader = _interopRequireDefault(__webpack_require__(1952));
	
	var _NavbarToggle = _interopRequireDefault(__webpack_require__(1953));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _StyleConfig = __webpack_require__(51);
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	// TODO: Remove this pragma once we upgrade eslint-config-airbnb.
	
	/* eslint-disable react/no-multi-comp */
	var propTypes = {
	  /**
	   * Create a fixed navbar along the top of the screen, that scrolls with the
	   * page
	   */
	  fixedTop: _propTypes.default.bool,
	
	  /**
	   * Create a fixed navbar along the bottom of the screen, that scrolls with
	   * the page
	   */
	  fixedBottom: _propTypes.default.bool,
	
	  /**
	   * Create a full-width navbar that scrolls away with the page
	   */
	  staticTop: _propTypes.default.bool,
	
	  /**
	   * An alternative dark visual style for the Navbar
	   */
	  inverse: _propTypes.default.bool,
	
	  /**
	   * Allow the Navbar to fluidly adjust to the page or container width, instead
	   * of at the predefined screen breakpoints
	   */
	  fluid: _propTypes.default.bool,
	
	  /**
	   * Set a custom element for this component.
	   */
	  componentClass: _elementType.default,
	
	  /**
	   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
	   * a `<Navbar.Toggle>` is clicked and called with the new `expanded`
	   * boolean value.
	   *
	   * @controllable expanded
	   */
	  onToggle: _propTypes.default.func,
	
	  /**
	   * A callback fired when a descendant of a child `<Nav>` is selected. Should
	   * be used to execute complex closing or other miscellaneous actions desired
	   * after selecting a descendant of `<Nav>`. Does nothing if no `<Nav>` or `<Nav>`
	   * descendants exist. The callback is called with an eventKey, which is a
	   * prop from the selected `<Nav>` descendant, and an event.
	   *
	   * ```js
	   * function (
	   *  Any eventKey,
	   *  SyntheticEvent event?
	   * )
	   * ```
	   *
	   * For basic closing behavior after all `<Nav>` descendant onSelect events in
	   * mobile viewports, try using collapseOnSelect.
	   *
	   * Note: If you are manually closing the navbar using this `OnSelect` prop,
	   * ensure that you are setting `expanded` to false and not *toggling* between
	   * true and false.
	   */
	  onSelect: _propTypes.default.func,
	
	  /**
	   * Sets `expanded` to `false` after the onSelect event of a descendant of a
	   * child `<Nav>`. Does nothing if no `<Nav>` or `<Nav>` descendants exist.
	   *
	   * The onSelect callback should be used instead for more complex operations
	   * that need to be executed after the `select` event of `<Nav>` descendants.
	   */
	  collapseOnSelect: _propTypes.default.bool,
	
	  /**
	   * Explicitly set the visiblity of the navbar body
	   *
	   * @controllable onToggle
	   */
	  expanded: _propTypes.default.bool,
	  role: _propTypes.default.string
	};
	var defaultProps = {
	  componentClass: 'nav',
	  fixedTop: false,
	  fixedBottom: false,
	  staticTop: false,
	  inverse: false,
	  fluid: false,
	  collapseOnSelect: false
	};
	var childContextTypes = {
	  $bs_navbar: _propTypes.default.shape({
	    bsClass: _propTypes.default.string,
	    expanded: _propTypes.default.bool,
	    onToggle: _propTypes.default.func.isRequired,
	    onSelect: _propTypes.default.func
	  })
	};
	
	var Navbar =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Navbar, _React$Component);
	
	  function Navbar(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    _this.handleToggle = _this.handleToggle.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleCollapse = _this.handleCollapse.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    return _this;
	  }
	
	  var _proto = Navbar.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    var _this$props = this.props,
	        bsClass = _this$props.bsClass,
	        expanded = _this$props.expanded,
	        onSelect = _this$props.onSelect,
	        collapseOnSelect = _this$props.collapseOnSelect;
	    return {
	      $bs_navbar: {
	        bsClass: bsClass,
	        expanded: expanded,
	        onToggle: this.handleToggle,
	        onSelect: (0, _createChainedFunction.default)(onSelect, collapseOnSelect ? this.handleCollapse : null)
	      }
	    };
	  };
	
	  _proto.handleCollapse = function handleCollapse() {
	    var _this$props2 = this.props,
	        onToggle = _this$props2.onToggle,
	        expanded = _this$props2.expanded;
	
	    if (expanded) {
	      onToggle(false);
	    }
	  };
	
	  _proto.handleToggle = function handleToggle() {
	    var _this$props3 = this.props,
	        onToggle = _this$props3.onToggle,
	        expanded = _this$props3.expanded;
	    onToggle(!expanded);
	  };
	
	  _proto.render = function render() {
	    var _extends2;
	
	    var _this$props4 = this.props,
	        Component = _this$props4.componentClass,
	        fixedTop = _this$props4.fixedTop,
	        fixedBottom = _this$props4.fixedBottom,
	        staticTop = _this$props4.staticTop,
	        inverse = _this$props4.inverse,
	        fluid = _this$props4.fluid,
	        className = _this$props4.className,
	        children = _this$props4.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props4, ["componentClass", "fixedTop", "fixedBottom", "staticTop", "inverse", "fluid", "className", "children"]);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['expanded', 'onToggle', 'onSelect', 'collapseOnSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1]; // will result in some false positives but that seems better
	    // than false negatives. strict `undefined` check allows explicit
	    // "nulling" of the role if the user really doesn't want one
	
	
	    if (elementProps.role === undefined && Component !== 'nav') {
	      elementProps.role = 'navigation';
	    }
	
	    if (inverse) {
	      bsProps.bsStyle = _StyleConfig.Style.INVERSE;
	    }
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-top')] = fixedTop, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'static-top')] = staticTop, _extends2));
	    return _react.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }), _react.default.createElement(_Grid.default, {
	      fluid: fluid
	    }, children));
	  };
	
	  return Navbar;
	}(_react.default.Component);
	
	Navbar.propTypes = propTypes;
	Navbar.defaultProps = defaultProps;
	Navbar.childContextTypes = childContextTypes;
	(0, _bootstrapUtils.bsClass)('navbar', Navbar);
	var UncontrollableNavbar = (0, _uncontrollable.default)(Navbar, {
	  expanded: 'onToggle'
	});
	
	function createSimpleWrapper(tag, suffix, displayName) {
	  var Wrapper = function Wrapper(_ref, _ref2) {
	    var Component = _ref.componentClass,
	        className = _ref.className,
	        pullRight = _ref.pullRight,
	        pullLeft = _ref.pullLeft,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["componentClass", "className", "pullRight", "pullLeft"]);
	    var _ref2$$bs_navbar = _ref2.$bs_navbar,
	        navbarProps = _ref2$$bs_navbar === void 0 ? {
	      bsClass: 'navbar'
	    } : _ref2$$bs_navbar;
	    return _react.default.createElement(Component, (0, _extends3.default)({}, props, {
	      className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(navbarProps, suffix), pullRight && (0, _bootstrapUtils.prefix)(navbarProps, 'right'), pullLeft && (0, _bootstrapUtils.prefix)(navbarProps, 'left'))
	    }));
	  };
	
	  Wrapper.displayName = displayName;
	  Wrapper.propTypes = {
	    componentClass: _elementType.default,
	    pullRight: _propTypes.default.bool,
	    pullLeft: _propTypes.default.bool
	  };
	  Wrapper.defaultProps = {
	    componentClass: tag,
	    pullRight: false,
	    pullLeft: false
	  };
	  Wrapper.contextTypes = {
	    $bs_navbar: _propTypes.default.shape({
	      bsClass: _propTypes.default.string
	    })
	  };
	  return Wrapper;
	}
	
	UncontrollableNavbar.Brand = _NavbarBrand.default;
	UncontrollableNavbar.Header = _NavbarHeader.default;
	UncontrollableNavbar.Toggle = _NavbarToggle.default;
	UncontrollableNavbar.Collapse = _NavbarCollapse.default;
	UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
	UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
	UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink'); // Set bsStyles here so they can be overridden.
	
	var _default = (0, _bootstrapUtils.bsStyles)([_StyleConfig.Style.DEFAULT, _StyleConfig.Style.INVERSE], _StyleConfig.Style.DEFAULT, UncontrollableNavbar);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1951 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _Collapse = _interopRequireDefault(__webpack_require__(505));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var contextTypes = {
	  $bs_navbar: _propTypes.default.shape({
	    bsClass: _propTypes.default.string,
	    expanded: _propTypes.default.bool
	  })
	};
	
	var NavbarCollapse =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(NavbarCollapse, _React$Component);
	
	  function NavbarCollapse() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = NavbarCollapse.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["children"]);
	    var navbarProps = this.context.$bs_navbar || {
	      bsClass: 'navbar'
	    };
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'collapse');
	    return _react.default.createElement(_Collapse.default, (0, _extends2.default)({
	      in: navbarProps.expanded
	    }, props), _react.default.createElement("div", {
	      className: bsClassName
	    }, children));
	  };
	
	  return NavbarCollapse;
	}(_react.default.Component);
	
	NavbarCollapse.contextTypes = contextTypes;
	var _default = NavbarCollapse;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1952 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var contextTypes = {
	  $bs_navbar: _propTypes.default.shape({
	    bsClass: _propTypes.default.string
	  })
	};
	
	var NavbarHeader =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(NavbarHeader, _React$Component);
	
	  function NavbarHeader() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = NavbarHeader.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);
	    var navbarProps = this.context.$bs_navbar || {
	      bsClass: 'navbar'
	    };
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'header');
	    return _react.default.createElement("div", (0, _extends2.default)({}, props, {
	      className: (0, _classnames.default)(className, bsClassName)
	    }));
	  };
	
	  return NavbarHeader;
	}(_react.default.Component);
	
	NavbarHeader.contextTypes = contextTypes;
	var _default = NavbarHeader;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1953 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var propTypes = {
	  onClick: _propTypes.default.func,
	
	  /**
	   * The toggle content, if left empty it will render the default toggle (seen above).
	   */
	  children: _propTypes.default.node
	};
	var contextTypes = {
	  $bs_navbar: _propTypes.default.shape({
	    bsClass: _propTypes.default.string,
	    expanded: _propTypes.default.bool,
	    onToggle: _propTypes.default.func.isRequired
	  })
	};
	
	var NavbarToggle =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(NavbarToggle, _React$Component);
	
	  function NavbarToggle() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = NavbarToggle.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        onClick = _this$props.onClick,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["onClick", "className", "children"]);
	    var navbarProps = this.context.$bs_navbar || {
	      bsClass: 'navbar'
	    };
	    var buttonProps = (0, _extends2.default)({
	      type: 'button'
	    }, props, {
	      onClick: (0, _createChainedFunction.default)(onClick, navbarProps.onToggle),
	      className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
	    });
	
	    if (children) {
	      return _react.default.createElement("button", buttonProps, children);
	    }
	
	    return _react.default.createElement("button", buttonProps, _react.default.createElement("span", {
	      className: "sr-only"
	    }, "Toggle navigation"), _react.default.createElement("span", {
	      className: "icon-bar"
	    }), _react.default.createElement("span", {
	      className: "icon-bar"
	    }), _react.default.createElement("span", {
	      className: "icon-bar"
	    }));
	  };
	
	  return NavbarToggle;
	}(_react.default.Component);
	
	NavbarToggle.propTypes = propTypes;
	NavbarToggle.contextTypes = contextTypes;
	var _default = NavbarToggle;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1954 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(58));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _isArray = _interopRequireDefault(__webpack_require__(967));
	
	var _contains = _interopRequireDefault(__webpack_require__(188));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(31));
	
	var _warning = _interopRequireDefault(__webpack_require__(47));
	
	var _Overlay = _interopRequireDefault(__webpack_require__(887));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	/**
	 * Check if value one is inside or equal to the of value
	 *
	 * @param {string} one
	 * @param {string|array} of
	 * @returns {boolean}
	 */
	function isOneOf(one, of) {
	  if ((0, _isArray.default)(of)) {
	    return of.indexOf(one) >= 0;
	  }
	
	  return one === of;
	}
	
	var triggerType = _propTypes.default.oneOf(['click', 'hover', 'focus']);
	
	var propTypes = (0, _extends2.default)({}, _Overlay.default.propTypes, {
	  /**
	   * Specify which action or actions trigger Overlay visibility
	   */
	  trigger: _propTypes.default.oneOfType([triggerType, _propTypes.default.arrayOf(triggerType)]),
	
	  /**
	   * A millisecond delay amount to show and hide the Overlay once triggered
	   */
	  delay: _propTypes.default.number,
	
	  /**
	   * A millisecond delay amount before showing the Overlay once triggered.
	   */
	  delayShow: _propTypes.default.number,
	
	  /**
	   * A millisecond delay amount before hiding the Overlay once triggered.
	   */
	  delayHide: _propTypes.default.number,
	  // FIXME: This should be `defaultShow`.
	
	  /**
	   * The initial visibility state of the Overlay. For more nuanced visibility
	   * control, consider using the Overlay component directly.
	   */
	  defaultOverlayShown: _propTypes.default.bool,
	
	  /**
	   * An element or text to overlay next to the target.
	   */
	  overlay: _propTypes.default.node.isRequired,
	
	  /**
	   * @private
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * @private
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @private
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * @private
	   */
	  onMouseOut: _propTypes.default.func,
	
	  /**
	   * @private
	   */
	  onMouseOver: _propTypes.default.func,
	  // Overridden props from `<Overlay>`.
	
	  /**
	   * @private
	   */
	  target: _propTypes.default.oneOf([null]),
	
	  /**
	   * @private
	   */
	  onHide: _propTypes.default.oneOf([null]),
	
	  /**
	   * @private
	   */
	  show: _propTypes.default.oneOf([null])
	});
	var defaultProps = {
	  defaultOverlayShown: false,
	  trigger: ['hover', 'focus']
	};
	
	var OverlayTrigger =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(OverlayTrigger, _React$Component);
	
	  function OverlayTrigger(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    _this.handleToggle = _this.handleToggle.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleDelayedShow = _this.handleDelayedShow.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleDelayedHide = _this.handleDelayedHide.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleHide = _this.handleHide.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	
	    _this.handleMouseOver = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedShow, e, 'fromElement');
	    };
	
	    _this.handleMouseOut = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedHide, e, 'toElement');
	    };
	
	    _this._mountNode = null;
	    _this.state = {
	      show: props.defaultOverlayShown
	    };
	    return _this;
	  }
	
	  var _proto = OverlayTrigger.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this._mountNode = document.createElement('div');
	    this.renderOverlay();
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate() {
	    this.renderOverlay();
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    _reactDom.default.unmountComponentAtNode(this._mountNode);
	
	    this._mountNode = null;
	    clearTimeout(this._hoverShowDelay);
	    clearTimeout(this._hoverHideDelay);
	  };
	
	  _proto.handleDelayedHide = function handleDelayedHide() {
	    var _this2 = this;
	
	    if (this._hoverShowDelay != null) {
	      clearTimeout(this._hoverShowDelay);
	      this._hoverShowDelay = null;
	      return;
	    }
	
	    if (!this.state.show || this._hoverHideDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;
	
	    if (!delay) {
	      this.hide();
	      return;
	    }
	
	    this._hoverHideDelay = setTimeout(function () {
	      _this2._hoverHideDelay = null;
	
	      _this2.hide();
	    }, delay);
	  };
	
	  _proto.handleDelayedShow = function handleDelayedShow() {
	    var _this3 = this;
	
	    if (this._hoverHideDelay != null) {
	      clearTimeout(this._hoverHideDelay);
	      this._hoverHideDelay = null;
	      return;
	    }
	
	    if (this.state.show || this._hoverShowDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;
	
	    if (!delay) {
	      this.show();
	      return;
	    }
	
	    this._hoverShowDelay = setTimeout(function () {
	      _this3._hoverShowDelay = null;
	
	      _this3.show();
	    }, delay);
	  };
	
	  _proto.handleHide = function handleHide() {
	    this.hide();
	  }; // Simple implementation of mouseEnter and mouseLeave.
	  // React's built version is broken: https://github.com/facebook/react/issues/4251
	  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
	  // moving from one child element to another.
	
	
	  _proto.handleMouseOverOut = function handleMouseOverOut(handler, e, relatedNative) {
	    var target = e.currentTarget;
	    var related = e.relatedTarget || e.nativeEvent[relatedNative];
	
	    if ((!related || related !== target) && !(0, _contains.default)(target, related)) {
	      handler(e);
	    }
	  };
	
	  _proto.handleToggle = function handleToggle() {
	    if (this.state.show) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  };
	
	  _proto.hide = function hide() {
	    this.setState({
	      show: false
	    });
	  };
	
	  _proto.makeOverlay = function makeOverlay(overlay, props) {
	    return _react.default.createElement(_Overlay.default, (0, _extends2.default)({}, props, {
	      show: this.state.show,
	      onHide: this.handleHide,
	      target: this
	    }), overlay);
	  };
	
	  _proto.show = function show() {
	    this.setState({
	      show: true
	    });
	  };
	
	  _proto.renderOverlay = function renderOverlay() {
	    _reactDom.default.unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        trigger = _this$props.trigger,
	        overlay = _this$props.overlay,
	        children = _this$props.children,
	        onBlur = _this$props.onBlur,
	        onClick = _this$props.onClick,
	        onFocus = _this$props.onFocus,
	        onMouseOut = _this$props.onMouseOut,
	        onMouseOver = _this$props.onMouseOver,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["trigger", "overlay", "children", "onBlur", "onClick", "onFocus", "onMouseOut", "onMouseOver"]);
	    delete props.delay;
	    delete props.delayShow;
	    delete props.delayHide;
	    delete props.defaultOverlayShown;
	
	    var child = _react.default.Children.only(children);
	
	    var childProps = child.props;
	    var triggerProps = {};
	
	    if (this.state.show) {
	      triggerProps['aria-describedby'] = overlay.props.id;
	    } // FIXME: The logic here for passing through handlers on this component is
	    // inconsistent. We shouldn't be passing any of these props through.
	
	
	    triggerProps.onClick = (0, _createChainedFunction.default)(childProps.onClick, onClick);
	
	    if (isOneOf('click', trigger)) {
	      triggerProps.onClick = (0, _createChainedFunction.default)(triggerProps.onClick, this.handleToggle);
	    }
	
	    if (isOneOf('hover', trigger)) {
	       false ? (0, _warning.default)(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;
	      triggerProps.onMouseOver = (0, _createChainedFunction.default)(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
	      triggerProps.onMouseOut = (0, _createChainedFunction.default)(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
	    }
	
	    if (isOneOf('focus', trigger)) {
	      triggerProps.onFocus = (0, _createChainedFunction.default)(childProps.onFocus, onFocus, this.handleDelayedShow);
	      triggerProps.onBlur = (0, _createChainedFunction.default)(childProps.onBlur, onBlur, this.handleDelayedHide);
	    }
	
	    this._overlay = this.makeOverlay(overlay, props);
	    return (0, _react.cloneElement)(child, triggerProps);
	  };
	
	  return OverlayTrigger;
	}(_react.default.Component);
	
	OverlayTrigger.propTypes = propTypes;
	OverlayTrigger.defaultProps = defaultProps;
	var _default = OverlayTrigger;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1955 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var PageHeader =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(PageHeader, _React$Component);
	
	  function PageHeader() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = PageHeader.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "children"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }), _react.default.createElement("h1", null, children));
	  };
	
	  return PageHeader;
	}(_react.default.Component);
	
	var _default = (0, _bootstrapUtils.bsClass)('page-header', PageHeader);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1956 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _PagerItem = _interopRequireDefault(__webpack_require__(888));
	
	var _deprecationWarning = _interopRequireDefault(__webpack_require__(1977));
	
	var _default = _deprecationWarning.default.wrapper(_PagerItem.default, '`<PageItem>`', '`<Pager.Item>`');
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1957 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _PagerItem = _interopRequireDefault(__webpack_require__(888));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(62));
	
	var propTypes = {
	  onSelect: _propTypes.default.func
	};
	
	var Pager =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Pager, _React$Component);
	
	  function Pager() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Pager.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        onSelect = _this$props.onSelect,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["onSelect", "className", "children"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement("ul", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }), _ValidComponentChildren.default.map(children, function (child) {
	      return (0, _react.cloneElement)(child, {
	        onSelect: (0, _createChainedFunction.default)(child.props.onSelect, onSelect)
	      });
	    }));
	  };
	
	  return Pager;
	}(_react.default.Component);
	
	Pager.propTypes = propTypes;
	Pager.Item = _PagerItem.default;
	
	var _default = (0, _bootstrapUtils.bsClass)('pager', Pager);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1958 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _PaginationItem = _interopRequireWildcard(__webpack_require__(1959));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var Pagination =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Pagination, _React$Component);
	
	  function Pagination() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Pagination.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "children"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement("ul", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }), children);
	  };
	
	  return Pagination;
	}(_react.default.Component);
	
	(0, _bootstrapUtils.bsClass)('pagination', Pagination);
	Pagination.First = _PaginationItem.First;
	Pagination.Prev = _PaginationItem.Prev;
	Pagination.Ellipsis = _PaginationItem.Ellipsis;
	Pagination.Item = _PaginationItem.default;
	Pagination.Next = _PaginationItem.Next;
	Pagination.Last = _PaginationItem.Last;
	var _default = Pagination;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1959 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = PaginationItem;
	exports.Last = exports.Next = exports.Ellipsis = exports.Prev = exports.First = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _SafeAnchor = _interopRequireDefault(__webpack_require__(90));
	
	/* eslint-disable react/no-multi-comp */
	var propTypes = {
	  eventKey: _propTypes.default.any,
	  className: _propTypes.default.string,
	  onSelect: _propTypes.default.func,
	  disabled: _propTypes.default.bool,
	  active: _propTypes.default.bool,
	  activeLabel: _propTypes.default.string.isRequired
	};
	var defaultProps = {
	  active: false,
	  disabled: false,
	  activeLabel: '(current)'
	};
	
	function PaginationItem(_ref) {
	  var active = _ref.active,
	      disabled = _ref.disabled,
	      className = _ref.className,
	      style = _ref.style,
	      activeLabel = _ref.activeLabel,
	      children = _ref.children,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["active", "disabled", "className", "style", "activeLabel", "children"]);
	  var Component = active || disabled ? 'span' : _SafeAnchor.default;
	  return _react.default.createElement("li", {
	    style: style,
	    className: (0, _classnames.default)(className, {
	      active: active,
	      disabled: disabled
	    })
	  }, _react.default.createElement(Component, (0, _extends2.default)({
	    disabled: disabled
	  }, props), children, active && _react.default.createElement("span", {
	    className: "sr-only"
	  }, activeLabel)));
	}
	
	PaginationItem.propTypes = propTypes;
	PaginationItem.defaultProps = defaultProps;
	
	function createButton(name, defaultValue, label) {
	  var _class, _temp;
	
	  if (label === void 0) {
	    label = name;
	  }
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_React$Component) {
	    (0, _inheritsLoose2.default)(_class, _React$Component);
	
	    function _class() {
	      return _React$Component.apply(this, arguments) || this;
	    }
	
	    var _proto = _class.prototype;
	
	    _proto.render = function render() {
	      var _this$props = this.props,
	          disabled = _this$props.disabled,
	          children = _this$props.children,
	          className = _this$props.className,
	          props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["disabled", "children", "className"]);
	      var Component = disabled ? 'span' : _SafeAnchor.default;
	      return _react.default.createElement("li", (0, _extends2.default)({
	        "aria-label": label,
	        className: (0, _classnames.default)(className, {
	          disabled: disabled
	        })
	      }, props), _react.default.createElement(Component, null, children || defaultValue));
	    };
	
	    return _class;
	  }(_react.default.Component), _class.displayName = name, _class.propTypes = {
	    disabled: _propTypes.default.bool
	  }, _temp;
	}
	
	var First = createButton('First', "\xAB");
	exports.First = First;
	var Prev = createButton('Prev', "\u2039");
	exports.Prev = Prev;
	var Ellipsis = createButton('Ellipsis', "\u2026", 'More');
	exports.Ellipsis = Ellipsis;
	var Next = createButton('Next', "\u203A");
	exports.Next = Next;
	var Last = createButton('Last', "\xBB");
	exports.Last = Last;

/***/ },
/* 1960 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _assign = _interopRequireDefault(__webpack_require__(533));
	
	var _values = _interopRequireDefault(__webpack_require__(166));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _uncontrollable = _interopRequireDefault(__webpack_require__(155));
	
	var _warning = _interopRequireDefault(__webpack_require__(47));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _StyleConfig = __webpack_require__(51);
	
	var _PanelBody = _interopRequireDefault(__webpack_require__(1961));
	
	var _PanelHeading = _interopRequireDefault(__webpack_require__(1963));
	
	var _PanelTitle = _interopRequireDefault(__webpack_require__(1964));
	
	var _PanelFooter = _interopRequireDefault(__webpack_require__(1962));
	
	var _PanelToggle = _interopRequireDefault(__webpack_require__(891));
	
	var _PanelCollapse = _interopRequireDefault(__webpack_require__(889));
	
	var has = Object.prototype.hasOwnProperty;
	
	var defaultGetId = function defaultGetId(id, type) {
	  return id ? id + "--" + type : null;
	};
	
	var propTypes = {
	  /**
	   * Controls the collapsed/expanded state ofthe Panel. Requires
	   * a `Panel.Collapse` or `<Panel.Body collapsible>` child component
	   * in order to actually animate out or in.
	   *
	   * @controllable onToggle
	   */
	  expanded: _propTypes.default.bool,
	
	  /**
	   * A callback fired when the collapse state changes.
	   *
	   * @controllable expanded
	   */
	  onToggle: _propTypes.default.func,
	  eventKey: _propTypes.default.any,
	
	  /**
	   * An HTML `id` attribute uniquely identifying the Panel component.
	   */
	  id: _propTypes.default.string
	};
	var contextTypes = {
	  $bs_panelGroup: _propTypes.default.shape({
	    getId: _propTypes.default.func,
	    activeKey: _propTypes.default.any,
	    onToggle: _propTypes.default.func
	  })
	};
	var childContextTypes = {
	  $bs_panel: _propTypes.default.shape({
	    headingId: _propTypes.default.string,
	    bodyId: _propTypes.default.string,
	    bsClass: _propTypes.default.string,
	    onToggle: _propTypes.default.func,
	    expanded: _propTypes.default.bool
	  })
	};
	
	var Panel =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Panel, _React$Component);
	
	  function Panel() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _this.handleToggle = function (e) {
	      var panelGroup = _this.context.$bs_panelGroup;
	      var expanded = !_this.getExpanded();
	
	      if (panelGroup && panelGroup.onToggle) {
	        panelGroup.onToggle(_this.props.eventKey, expanded, e);
	      } else {
	        _this.props.onToggle(expanded, e);
	      }
	    };
	
	    return _this;
	  }
	
	  var _proto = Panel.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    var _this$props = this.props,
	        eventKey = _this$props.eventKey,
	        id = _this$props.id;
	    var idKey = eventKey == null ? id : eventKey;
	    var ids;
	
	    if (idKey !== null) {
	      var panelGroup = this.context.$bs_panelGroup;
	      var getId = panelGroup && panelGroup.getId || defaultGetId;
	      ids = {
	        headingId: getId(idKey, 'heading'),
	        bodyId: getId(idKey, 'body')
	      };
	    }
	
	    return {
	      $bs_panel: (0, _extends2.default)({}, ids, {
	        bsClass: this.props.bsClass,
	        expanded: this.getExpanded(),
	        onToggle: this.handleToggle
	      })
	    };
	  };
	
	  _proto.getExpanded = function getExpanded() {
	    var panelGroup = this.context.$bs_panelGroup;
	
	    if (panelGroup && has.call(panelGroup, 'activeKey')) {
	       false ? (0, _warning.default)(this.props.expanded == null, 'Specifying `<Panel>` `expanded` in the context of an accordion ' + '`<PanelGroup>` is not supported. Set `activeKey` on the ' + '`<PanelGroup>` instead.') : void 0;
	      return panelGroup.activeKey === this.props.eventKey;
	    }
	
	    return !!this.props.expanded;
	  };
	
	  _proto.render = function render() {
	    var _this$props2 = this.props,
	        className = _this$props2.className,
	        children = _this$props2.children;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(this.props, ['onToggle', 'eventKey', 'expanded']),
	        bsProps = _splitBsPropsAndOmit[0],
	        props = _splitBsPropsAndOmit[1];
	
	    return _react.default.createElement("div", (0, _extends2.default)({}, props, {
	      className: (0, _classnames.default)(className, (0, _bootstrapUtils.getClassSet)(bsProps))
	    }), children);
	  };
	
	  return Panel;
	}(_react.default.Component);
	
	Panel.propTypes = propTypes;
	Panel.contextTypes = contextTypes;
	Panel.childContextTypes = childContextTypes;
	var UncontrolledPanel = (0, _uncontrollable.default)((0, _bootstrapUtils.bsClass)('panel', (0, _bootstrapUtils.bsStyles)((0, _values.default)(_StyleConfig.State).concat([_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Panel)), {
	  expanded: 'onToggle'
	});
	(0, _assign.default)(UncontrolledPanel, {
	  Heading: _PanelHeading.default,
	  Title: _PanelTitle.default,
	  Body: _PanelBody.default,
	  Footer: _PanelFooter.default,
	  Toggle: _PanelToggle.default,
	  Collapse: _PanelCollapse.default
	});
	var _default = UncontrolledPanel;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1961 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _PanelCollapse = _interopRequireDefault(__webpack_require__(889));
	
	var propTypes = {
	  /**
	   * A convenience prop that renders a Collapse component around the Body for
	   * situations when the parent Panel only contains a single Panel.Body child.
	   *
	   * renders:
	   * ```jsx
	   * <Panel.Collapse>
	   *  <Panel.Body />
	   * </Panel.Collapse>
	   * ```
	   */
	  collapsible: _propTypes.default.bool.isRequired
	};
	var defaultProps = {
	  collapsible: false
	};
	var contextTypes = {
	  $bs_panel: _propTypes.default.shape({
	    bsClass: _propTypes.default.string
	  })
	};
	
	var PanelBody =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(PanelBody, _React$Component);
	
	  function PanelBody() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = PanelBody.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        className = _this$props.className,
	        collapsible = _this$props.collapsible;
	
	    var _ref = this.context.$bs_panel || {},
	        _bsClass = _ref.bsClass;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(this.props, ['collapsible']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    bsProps.bsClass = _bsClass || bsProps.bsClass;
	
	    var body = _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'body'))
	    }), children);
	
	    if (collapsible) {
	      body = _react.default.createElement(_PanelCollapse.default, null, body);
	    }
	
	    return body;
	  };
	
	  return PanelBody;
	}(_react.default.Component);
	
	PanelBody.propTypes = propTypes;
	PanelBody.defaultProps = defaultProps;
	PanelBody.contextTypes = contextTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('panel', PanelBody);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1962 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var contextTypes = {
	  $bs_panel: _propTypes.default.shape({
	    bsClass: _propTypes.default.string
	  })
	};
	
	var PanelFooter =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(PanelFooter, _React$Component);
	
	  function PanelFooter() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = PanelFooter.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        className = _this$props.className;
	
	    var _ref = this.context.$bs_panel || {},
	        _bsClass = _ref.bsClass;
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(this.props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    bsProps.bsClass = _bsClass || bsProps.bsClass;
	    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'footer'))
	    }), children);
	  };
	
	  return PanelFooter;
	}(_react.default.Component);
	
	PanelFooter.contextTypes = contextTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('panel', PanelFooter);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1963 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _elementType = _interopRequireDefault(__webpack_require__(516));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var propTypes = {
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  componentClass: 'div'
	};
	var contextTypes = {
	  $bs_panel: _propTypes.default.shape({
	    headingId: _propTypes.default.string,
	    bsClass: _propTypes.default.string
	  })
	};
	
	var PanelHeading =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(PanelHeading, _React$Component);
	
	  function PanelHeading() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = PanelHeading.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        className = _this$props.className,
	        Component = _this$props.componentClass,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["children", "className", "componentClass"]);
	
	    var _ref = this.context.$bs_panel || {},
	        headingId = _ref.headingId,
	        _bsClass = _ref.bsClass;
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    bsProps.bsClass = _bsClass || bsProps.bsClass;
	
	    if (headingId) {
	      elementProps.role = elementProps.role || 'tab';
	      elementProps.id = headingId;
	    }
	
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'heading'))
	    }), children);
	  };
	
	  return PanelHeading;
	}(_react.default.Component);
	
	PanelHeading.propTypes = propTypes;
	PanelHeading.defaultProps = defaultProps;
	PanelHeading.contextTypes = contextTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('panel', PanelHeading);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1964 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _elementType = _interopRequireDefault(__webpack_require__(516));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _PanelToggle = _interopRequireDefault(__webpack_require__(891));
	
	var propTypes = {
	  componentClass: _elementType.default,
	
	  /**
	   * A convenience prop that renders the Panel.Title as a panel collapse toggle component
	   * for the common use-case.
	   */
	  toggle: _propTypes.default.bool
	};
	var contextTypes = {
	  $bs_panel: _propTypes.default.shape({
	    bsClass: _propTypes.default.string
	  })
	};
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var PanelTitle =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(PanelTitle, _React$Component);
	
	  function PanelTitle() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = PanelTitle.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        className = _this$props.className,
	        toggle = _this$props.toggle,
	        Component = _this$props.componentClass,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["children", "className", "toggle", "componentClass"]);
	
	    var _ref = this.context.$bs_panel || {},
	        _bsClass = _ref.bsClass;
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    bsProps.bsClass = _bsClass || bsProps.bsClass;
	
	    if (toggle) {
	      children = _react.default.createElement(_PanelToggle.default, null, children);
	    }
	
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'title'))
	    }), children);
	  };
	
	  return PanelTitle;
	}(_react.default.Component);
	
	PanelTitle.propTypes = propTypes;
	PanelTitle.defaultProps = defaultProps;
	PanelTitle.contextTypes = contextTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('panel', PanelTitle);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1965 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _isRequiredForA11y = _interopRequireDefault(__webpack_require__(316));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string}
	   * @required
	   */
	  id: (0, _isRequiredForA11y.default)(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),
	
	  /**
	   * Sets the direction the Popover is positioned towards.
	   */
	  placement: _propTypes.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Popover.
	   */
	  positionTop: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * The "left" position value for the Popover.
	   */
	  positionLeft: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * The "top" position value for the Popover arrow.
	   */
	  arrowOffsetTop: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * The "left" position value for the Popover arrow.
	   */
	  arrowOffsetLeft: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Title content
	   */
	  title: _propTypes.default.node
	};
	var defaultProps = {
	  placement: 'right'
	};
	
	var Popover =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Popover, _React$Component);
	
	  function Popover() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Popover.prototype;
	
	  _proto.render = function render() {
	    var _extends2;
	
	    var _this$props = this.props,
	        placement = _this$props.placement,
	        positionTop = _this$props.positionTop,
	        positionLeft = _this$props.positionLeft,
	        arrowOffsetTop = _this$props.arrowOffsetTop,
	        arrowOffsetLeft = _this$props.arrowOffsetLeft,
	        title = _this$props.title,
	        className = _this$props.className,
	        style = _this$props.style,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["placement", "positionTop", "positionLeft", "arrowOffsetTop", "arrowOffsetLeft", "title", "className", "style", "children"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	    var outerStyle = (0, _extends3.default)({
	      display: 'block',
	      top: positionTop,
	      left: positionLeft
	    }, style);
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	    return _react.default.createElement("div", (0, _extends3.default)({}, elementProps, {
	      role: "tooltip",
	      className: (0, _classnames.default)(className, classes),
	      style: outerStyle
	    }), _react.default.createElement("div", {
	      className: "arrow",
	      style: arrowStyle
	    }), title && _react.default.createElement("h3", {
	      className: (0, _bootstrapUtils.prefix)(bsProps, 'title')
	    }, title), _react.default.createElement("div", {
	      className: (0, _bootstrapUtils.prefix)(bsProps, 'content')
	    }, children));
	  };
	
	  return Popover;
	}(_react.default.Component);
	
	Popover.propTypes = propTypes;
	Popover.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('popover', Popover);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1966 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _values = _interopRequireDefault(__webpack_require__(166));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _StyleConfig = __webpack_require__(51);
	
	var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(62));
	
	var ROUND_PRECISION = 1000;
	/**
	 * Validate that children, if any, are instances of `<ProgressBar>`.
	 */
	
	function onlyProgressBar(props, propName, componentName) {
	  var children = props[propName];
	
	  if (!children) {
	    return null;
	  }
	
	  var error = null;
	
	  _react.default.Children.forEach(children, function (child) {
	    if (error) {
	      return;
	    }
	    /**
	     * Compare types in a way that works with libraries that patch and proxy
	     * components like react-hot-loader.
	     *
	     * see https://github.com/gaearon/react-hot-loader#checking-element-types
	     */
	
	
	    var element = _react.default.createElement(ProgressBar, null);
	
	    if (child.type === element.type) return;
	    var childIdentifier = _react.default.isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
	    error = new Error("Children of " + componentName + " can contain only ProgressBar " + ("components. Found " + childIdentifier + "."));
	  });
	
	  return error;
	}
	
	var propTypes = {
	  min: _propTypes.default.number,
	  now: _propTypes.default.number,
	  max: _propTypes.default.number,
	  label: _propTypes.default.node,
	  srOnly: _propTypes.default.bool,
	  striped: _propTypes.default.bool,
	  active: _propTypes.default.bool,
	  children: onlyProgressBar,
	
	  /**
	   * @private
	   */
	  isChild: _propTypes.default.bool
	};
	var defaultProps = {
	  min: 0,
	  max: 100,
	  active: false,
	  isChild: false,
	  srOnly: false,
	  striped: false
	};
	
	function getPercentage(now, min, max) {
	  var percentage = (now - min) / (max - min) * 100;
	  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
	}
	
	var ProgressBar =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(ProgressBar, _React$Component);
	
	  function ProgressBar() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ProgressBar.prototype;
	
	  _proto.renderProgressBar = function renderProgressBar(_ref) {
	    var _extends2;
	
	    var min = _ref.min,
	        now = _ref.now,
	        max = _ref.max,
	        label = _ref.label,
	        srOnly = _ref.srOnly,
	        striped = _ref.striped,
	        active = _ref.active,
	        className = _ref.className,
	        style = _ref.style,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["min", "now", "max", "label", "srOnly", "striped", "active", "className", "style"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = active || striped, _extends2));
	    return _react.default.createElement("div", (0, _extends3.default)({}, elementProps, {
	      role: "progressbar",
	      className: (0, _classnames.default)(className, classes),
	      style: (0, _extends3.default)({
	        width: getPercentage(now, min, max) + "%"
	      }, style),
	      "aria-valuenow": now,
	      "aria-valuemin": min,
	      "aria-valuemax": max
	    }), srOnly ? _react.default.createElement("span", {
	      className: "sr-only"
	    }, label) : label);
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        isChild = _this$props.isChild,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["isChild"]);
	
	    if (isChild) {
	      return this.renderProgressBar(props);
	    }
	
	    var min = props.min,
	        now = props.now,
	        max = props.max,
	        label = props.label,
	        srOnly = props.srOnly,
	        striped = props.striped,
	        active = props.active,
	        bsClass = props.bsClass,
	        bsStyle = props.bsStyle,
	        className = props.className,
	        children = props.children,
	        wrapperProps = (0, _objectWithoutPropertiesLoose2.default)(props, ["min", "now", "max", "label", "srOnly", "striped", "active", "bsClass", "bsStyle", "className", "children"]);
	    return _react.default.createElement("div", (0, _extends3.default)({}, wrapperProps, {
	      className: (0, _classnames.default)(className, 'progress')
	    }), children ? _ValidComponentChildren.default.map(children, function (child) {
	      return (0, _react.cloneElement)(child, {
	        isChild: true
	      });
	    }) : this.renderProgressBar({
	      min: min,
	      now: now,
	      max: max,
	      label: label,
	      srOnly: srOnly,
	      striped: striped,
	      active: active,
	      bsClass: bsClass,
	      bsStyle: bsStyle
	    }));
	  };
	
	  return ProgressBar;
	}(_react.default.Component);
	
	ProgressBar.propTypes = propTypes;
	ProgressBar.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('progress-bar', (0, _bootstrapUtils.bsStyles)((0, _values.default)(_StyleConfig.State), ProgressBar));
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1967 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _warning = _interopRequireDefault(__webpack_require__(47));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	// TODO: This should probably take a single `aspectRatio` prop.
	var propTypes = {
	  /**
	   * This component requires a single child element
	   */
	  children: _propTypes.default.element.isRequired,
	
	  /**
	   * 16by9 aspect ratio
	   */
	  a16by9: _propTypes.default.bool,
	
	  /**
	   * 4by3 aspect ratio
	   */
	  a4by3: _propTypes.default.bool
	};
	var defaultProps = {
	  a16by9: false,
	  a4by3: false
	};
	
	var ResponsiveEmbed =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(ResponsiveEmbed, _React$Component);
	
	  function ResponsiveEmbed() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ResponsiveEmbed.prototype;
	
	  _proto.render = function render() {
	    var _extends2;
	
	    var _this$props = this.props,
	        a16by9 = _this$props.a16by9,
	        a4by3 = _this$props.a4by3,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["a16by9", "a4by3", "className", "children"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning.default)(a16by9 || a4by3, 'Either `a16by9` or `a4by3` must be set.') : void 0;
	     false ? (0, _warning.default)(!(a16by9 && a4by3), 'Only one of `a16by9` or `a4by3` can be set.') : void 0;
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '16by9')] = a16by9, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '4by3')] = a4by3, _extends2));
	    return _react.default.createElement("div", {
	      className: (0, _classnames.default)(classes)
	    }, (0, _react.cloneElement)(children, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'item'))
	    })));
	  };
	
	  return ResponsiveEmbed;
	}(_react.default.Component);
	
	ResponsiveEmbed.propTypes = propTypes;
	ResponsiveEmbed.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('embed-responsive', ResponsiveEmbed);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1968 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _Button = _interopRequireDefault(__webpack_require__(232));
	
	var _Dropdown = _interopRequireDefault(__webpack_require__(318));
	
	var _SplitToggle = _interopRequireDefault(__webpack_require__(1969));
	
	var _splitComponentProps2 = _interopRequireDefault(__webpack_require__(321));
	
	var propTypes = (0, _extends2.default)({}, _Dropdown.default.propTypes, {
	  // Toggle props.
	  bsStyle: _propTypes.default.string,
	  bsSize: _propTypes.default.string,
	  href: _propTypes.default.string,
	  onClick: _propTypes.default.func,
	
	  /**
	   * The content of the split button.
	   */
	  title: _propTypes.default.node.isRequired,
	
	  /**
	   * Accessible label for the toggle; the value of `title` if not specified.
	   */
	  toggleLabel: _propTypes.default.string,
	  // Override generated docs from <Dropdown>.
	
	  /**
	   * @private
	   */
	  children: _propTypes.default.node
	});
	
	var SplitButton =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(SplitButton, _React$Component);
	
	  function SplitButton() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = SplitButton.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        bsSize = _this$props.bsSize,
	        bsStyle = _this$props.bsStyle,
	        title = _this$props.title,
	        toggleLabel = _this$props.toggleLabel,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["bsSize", "bsStyle", "title", "toggleLabel", "children"]);
	
	    var _splitComponentProps = (0, _splitComponentProps2.default)(props, _Dropdown.default.ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        buttonProps = _splitComponentProps[1];
	
	    return _react.default.createElement(_Dropdown.default, (0, _extends2.default)({}, dropdownProps, {
	      bsSize: bsSize,
	      bsStyle: bsStyle
	    }), _react.default.createElement(_Button.default, (0, _extends2.default)({}, buttonProps, {
	      disabled: props.disabled,
	      bsSize: bsSize,
	      bsStyle: bsStyle
	    }), title), _react.default.createElement(_SplitToggle.default, {
	      "aria-label": toggleLabel || title,
	      bsSize: bsSize,
	      bsStyle: bsStyle
	    }), _react.default.createElement(_Dropdown.default.Menu, null, children));
	  };
	
	  return SplitButton;
	}(_react.default.Component);
	
	SplitButton.propTypes = propTypes;
	SplitButton.Toggle = _SplitToggle.default;
	var _default = SplitButton;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1969 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _DropdownToggle = _interopRequireDefault(__webpack_require__(872));
	
	var SplitToggle =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(SplitToggle, _React$Component);
	
	  function SplitToggle() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = SplitToggle.prototype;
	
	  _proto.render = function render() {
	    return _react.default.createElement(_DropdownToggle.default, (0, _extends2.default)({}, this.props, {
	      useAnchor: false,
	      noCaret: false
	    }));
	  };
	
	  return SplitToggle;
	}(_react.default.Component);
	
	SplitToggle.defaultProps = _DropdownToggle.default.defaultProps;
	var _default = SplitToggle;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1970 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _TabContainer = _interopRequireDefault(__webpack_require__(508));
	
	var _TabContent = _interopRequireDefault(__webpack_require__(509));
	
	var _TabPane = _interopRequireDefault(__webpack_require__(894));
	
	var propTypes = (0, _extends2.default)({}, _TabPane.default.propTypes, {
	  disabled: _propTypes.default.bool,
	  title: _propTypes.default.node,
	
	  /**
	   * tabClassName is used as className for the associated NavItem
	   */
	  tabClassName: _propTypes.default.string
	});
	
	var Tab =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Tab, _React$Component);
	
	  function Tab() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Tab.prototype;
	
	  _proto.render = function render() {
	    var props = (0, _extends2.default)({}, this.props); // These props are for the parent `<Tabs>` rather than the `<TabPane>`.
	
	    delete props.title;
	    delete props.disabled;
	    delete props.tabClassName;
	    return _react.default.createElement(_TabPane.default, props);
	  };
	
	  return Tab;
	}(_react.default.Component);
	
	Tab.propTypes = propTypes;
	Tab.Container = _TabContainer.default;
	Tab.Content = _TabContent.default;
	Tab.Pane = _TabPane.default;
	var _default = Tab;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1971 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var propTypes = {
	  striped: _propTypes.default.bool,
	  bordered: _propTypes.default.bool,
	  condensed: _propTypes.default.bool,
	  hover: _propTypes.default.bool,
	  responsive: _propTypes.default.bool
	};
	var defaultProps = {
	  bordered: false,
	  condensed: false,
	  hover: false,
	  responsive: false,
	  striped: false
	};
	
	var Table =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Table, _React$Component);
	
	  function Table() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Table.prototype;
	
	  _proto.render = function render() {
	    var _extends2;
	
	    var _this$props = this.props,
	        striped = _this$props.striped,
	        bordered = _this$props.bordered,
	        condensed = _this$props.condensed,
	        hover = _this$props.hover,
	        responsive = _this$props.responsive,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["striped", "bordered", "condensed", "hover", "responsive", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = striped, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'bordered')] = bordered, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'condensed')] = condensed, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'hover')] = hover, _extends2));
	
	    var table = _react.default.createElement("table", (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	
	    if (responsive) {
	      return _react.default.createElement("div", {
	        className: (0, _bootstrapUtils.prefix)(bsProps, 'responsive')
	      }, table);
	    }
	
	    return table;
	  };
	
	  return Table;
	}(_react.default.Component);
	
	Table.propTypes = propTypes;
	Table.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('table', Table);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1972 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _isRequiredForA11y = _interopRequireDefault(__webpack_require__(316));
	
	var _uncontrollable = _interopRequireDefault(__webpack_require__(155));
	
	var _elementType = _interopRequireDefault(__webpack_require__(34));
	
	var _Nav = _interopRequireDefault(__webpack_require__(884));
	
	var _NavItem = _interopRequireDefault(__webpack_require__(885));
	
	var _TabContainer = _interopRequireDefault(__webpack_require__(508));
	
	var _TabContent = _interopRequireDefault(__webpack_require__(509));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(62));
	
	var TabContainer = _TabContainer.default.ControlledComponent;
	var propTypes = {
	  /**
	   * Mark the Tab with a matching `eventKey` as active.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes.default.any,
	
	  /**
	   * Navigation style
	   */
	  bsStyle: _propTypes.default.oneOf(['tabs', 'pills']),
	
	  /**
	   * Sets a default animation strategy. Use `false` to disable, `true`
	   * to enable the default `<Fade>` animation, or a react-transition-group
	   * v2 `<Transition/>` component.
	   */
	  animation: _propTypes.default.oneOfType([_propTypes.default.bool, _elementType.default]),
	  id: (0, _isRequiredForA11y.default)(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),
	
	  /**
	   * Callback fired when a Tab is selected.
	   *
	   * ```js
	   * function (
	   *   Any eventKey,
	   *   SyntheticEvent event?
	   * )
	   * ```
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes.default.func,
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes.default.bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes.default.bool
	};
	var defaultProps = {
	  bsStyle: 'tabs',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	
	function getDefaultActiveKey(children) {
	  var defaultActiveKey;
	
	  _ValidComponentChildren.default.forEach(children, function (child) {
	    if (defaultActiveKey == null) {
	      defaultActiveKey = child.props.eventKey;
	    }
	  });
	
	  return defaultActiveKey;
	}
	
	var Tabs =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Tabs, _React$Component);
	
	  function Tabs() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Tabs.prototype;
	
	  _proto.renderTab = function renderTab(child) {
	    var _child$props = child.props,
	        title = _child$props.title,
	        eventKey = _child$props.eventKey,
	        disabled = _child$props.disabled,
	        tabClassName = _child$props.tabClassName;
	
	    if (title == null) {
	      return null;
	    }
	
	    return _react.default.createElement(_NavItem.default, {
	      eventKey: eventKey,
	      disabled: disabled,
	      className: tabClassName
	    }, title);
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        id = _this$props.id,
	        onSelect = _this$props.onSelect,
	        animation = _this$props.animation,
	        mountOnEnter = _this$props.mountOnEnter,
	        unmountOnExit = _this$props.unmountOnExit,
	        bsClass = _this$props.bsClass,
	        className = _this$props.className,
	        style = _this$props.style,
	        children = _this$props.children,
	        _this$props$activeKey = _this$props.activeKey,
	        activeKey = _this$props$activeKey === void 0 ? getDefaultActiveKey(children) : _this$props$activeKey,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["id", "onSelect", "animation", "mountOnEnter", "unmountOnExit", "bsClass", "className", "style", "children", "activeKey"]);
	    return _react.default.createElement(TabContainer, {
	      id: id,
	      activeKey: activeKey,
	      onSelect: onSelect,
	      className: className,
	      style: style
	    }, _react.default.createElement("div", null, _react.default.createElement(_Nav.default, (0, _extends2.default)({}, props, {
	      role: "tablist"
	    }), _ValidComponentChildren.default.map(children, this.renderTab)), _react.default.createElement(_TabContent.default, {
	      bsClass: bsClass,
	      animation: animation,
	      mountOnEnter: mountOnEnter,
	      unmountOnExit: unmountOnExit
	    }, children)));
	  };
	
	  return Tabs;
	}(_react.default.Component);
	
	Tabs.propTypes = propTypes;
	Tabs.defaultProps = defaultProps;
	(0, _bootstrapUtils.bsClass)('tab', Tabs);
	
	var _default = (0, _uncontrollable.default)(Tabs, {
	  activeKey: 'onSelect'
	});
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1973 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _SafeAnchor = _interopRequireDefault(__webpack_require__(90));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	/* eslint-disable jsx-a11y/alt-text */
	var propTypes = {
	  /**
	   * src property that is passed down to the image inside this component
	   */
	  src: _propTypes.default.string,
	
	  /**
	   * alt property that is passed down to the image inside this component
	   */
	  alt: _propTypes.default.string,
	
	  /**
	   * href property that is passed down to the image inside this component
	   */
	  href: _propTypes.default.string,
	
	  /**
	   * onError callback that is passed down to the image inside this component
	   */
	  onError: _propTypes.default.func,
	
	  /**
	   * onLoad callback that is passed down to the image inside this component
	   */
	  onLoad: _propTypes.default.func
	};
	
	var Thumbnail =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Thumbnail, _React$Component);
	
	  function Thumbnail() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Thumbnail.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        src = _this$props.src,
	        alt = _this$props.alt,
	        onError = _this$props.onError,
	        onLoad = _this$props.onLoad,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["src", "alt", "onError", "onLoad", "className", "children"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var Component = elementProps.href ? _SafeAnchor.default : 'div';
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }), _react.default.createElement("img", {
	      src: src,
	      alt: alt,
	      onError: onError,
	      onLoad: onLoad
	    }), children && _react.default.createElement("div", {
	      className: "caption"
	    }, children));
	  };
	
	  return Thumbnail;
	}(_react.default.Component);
	
	Thumbnail.propTypes = propTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('thumbnail', Thumbnail);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1974 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _invariant = _interopRequireDefault(__webpack_require__(68));
	
	var _uncontrollable = _interopRequireDefault(__webpack_require__(155));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(62));
	
	var _ButtonGroup = _interopRequireDefault(__webpack_require__(502));
	
	var _ToggleButton = _interopRequireDefault(__webpack_require__(895));
	
	var propTypes = {
	  /**
	   * An HTML `<input>` name for each child button.
	   *
	   * __Required if `type` is set to `'radio'`__
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * The value, or array of values, of the active (pressed) buttons
	   *
	   * @controllable onChange
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * Callback fired when a button is pressed, depending on whether the `type`
	   * is `'radio'` or `'checkbox'`, `onChange` will be called with the value or
	   * array of active values
	   *
	   * @controllable values
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The input `type` of the rendered buttons, determines the toggle behavior
	   * of the buttons
	   */
	  type: _propTypes.default.oneOf(['checkbox', 'radio']).isRequired
	};
	var defaultProps = {
	  type: 'radio'
	};
	
	var ToggleButtonGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(ToggleButtonGroup, _React$Component);
	
	  function ToggleButtonGroup() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ToggleButtonGroup.prototype;
	
	  _proto.getValues = function getValues() {
	    var value = this.props.value;
	    return value == null ? [] : [].concat(value);
	  };
	
	  _proto.handleToggle = function handleToggle(value) {
	    var _this$props = this.props,
	        type = _this$props.type,
	        onChange = _this$props.onChange;
	    var values = this.getValues();
	    var isActive = values.indexOf(value) !== -1;
	
	    if (type === 'radio') {
	      if (!isActive) {
	        onChange(value);
	      }
	
	      return;
	    }
	
	    if (isActive) {
	      onChange(values.filter(function (n) {
	        return n !== value;
	      }));
	    } else {
	      onChange(values.concat([value]));
	    }
	  };
	
	  _proto.render = function render() {
	    var _this = this;
	
	    var _this$props2 = this.props,
	        children = _this$props2.children,
	        type = _this$props2.type,
	        name = _this$props2.name,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["children", "type", "name"]);
	    var values = this.getValues();
	    !(type !== 'radio' || !!name) ?  false ? (0, _invariant.default)(false, 'A `name` is required to group the toggle buttons when the `type` ' + 'is set to "radio"') : invariant(false) : void 0;
	    delete props.onChange;
	    delete props.value; // the data attribute is required b/c twbs css uses it in the selector
	
	    return _react.default.createElement(_ButtonGroup.default, (0, _extends2.default)({}, props, {
	      "data-toggle": "buttons"
	    }), _ValidComponentChildren.default.map(children, function (child) {
	      var _child$props = child.props,
	          value = _child$props.value,
	          onChange = _child$props.onChange;
	
	      var handler = function handler() {
	        return _this.handleToggle(value);
	      };
	
	      return _react.default.cloneElement(child, {
	        type: type,
	        name: child.name || name,
	        checked: values.indexOf(value) !== -1,
	        onChange: (0, _createChainedFunction.default)(onChange, handler)
	      });
	    }));
	  };
	
	  return ToggleButtonGroup;
	}(_react.default.Component);
	
	ToggleButtonGroup.propTypes = propTypes;
	ToggleButtonGroup.defaultProps = defaultProps;
	var UncontrolledToggleButtonGroup = (0, _uncontrollable.default)(ToggleButtonGroup, {
	  value: 'onChange'
	});
	UncontrolledToggleButtonGroup.Button = _ToggleButton.default;
	var _default = UncontrolledToggleButtonGroup;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1975 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _isRequiredForA11y = _interopRequireDefault(__webpack_require__(316));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y.default)(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),
	
	  /**
	   * Sets the direction the Tooltip is positioned towards.
	   */
	  placement: _propTypes.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Tooltip.
	   */
	  positionTop: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * The "left" position value for the Tooltip.
	   */
	  positionLeft: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * The "top" position value for the Tooltip arrow.
	   */
	  arrowOffsetTop: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * The "left" position value for the Tooltip arrow.
	   */
	  arrowOffsetLeft: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
	};
	var defaultProps = {
	  placement: 'right'
	};
	
	var Tooltip =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Tooltip, _React$Component);
	
	  function Tooltip() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Tooltip.prototype;
	
	  _proto.render = function render() {
	    var _extends2;
	
	    var _this$props = this.props,
	        placement = _this$props.placement,
	        positionTop = _this$props.positionTop,
	        positionLeft = _this$props.positionLeft,
	        arrowOffsetTop = _this$props.arrowOffsetTop,
	        arrowOffsetLeft = _this$props.arrowOffsetLeft,
	        className = _this$props.className,
	        style = _this$props.style,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["placement", "positionTop", "positionLeft", "arrowOffsetTop", "arrowOffsetLeft", "className", "style", "children"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	    var outerStyle = (0, _extends3.default)({
	      top: positionTop,
	      left: positionLeft
	    }, style);
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	    return _react.default.createElement("div", (0, _extends3.default)({}, elementProps, {
	      role: "tooltip",
	      className: (0, _classnames.default)(className, classes),
	      style: outerStyle
	    }), _react.default.createElement("div", {
	      className: (0, _bootstrapUtils.prefix)(bsProps, 'arrow'),
	      style: arrowStyle
	    }), _react.default.createElement("div", {
	      className: (0, _bootstrapUtils.prefix)(bsProps, 'inner')
	    }, children));
	  };
	
	  return Tooltip;
	}(_react.default.Component);
	
	Tooltip.propTypes = propTypes;
	Tooltip.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('tooltip', Tooltip);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1976 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _bootstrapUtils = __webpack_require__(14);
	
	var _StyleConfig = __webpack_require__(51);
	
	var Well =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Well, _React$Component);
	
	  function Well() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Well.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return Well;
	}(_react.default.Component);
	
	var _default = (0, _bootstrapUtils.bsClass)('well', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Well));
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1977 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports._resetWarned = _resetWarned;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(8));
	
	var _warning = _interopRequireDefault(__webpack_require__(47));
	
	var warned = {};
	
	function deprecationWarning(oldname, newname, link) {
	  var message;
	
	  if (typeof oldname === 'object') {
	    message = oldname.message;
	  } else {
	    message = oldname + " is deprecated. Use " + newname + " instead.";
	
	    if (link) {
	      message += "\nYou can read more about it at " + link;
	    }
	  }
	
	  if (warned[message]) {
	    return;
	  }
	
	   false ? (0, _warning.default)(false, message) : void 0;
	  warned[message] = true;
	}
	
	deprecationWarning.wrapper = function (Component) {
	  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return (
	    /*#__PURE__*/
	    function (_Component) {
	      (0, _inheritsLoose2.default)(DeprecatedComponent, _Component);
	
	      function DeprecatedComponent() {
	        return _Component.apply(this, arguments) || this;
	      }
	
	      var _proto = DeprecatedComponent.prototype;
	
	      _proto.componentWillMount = function componentWillMount() {
	        deprecationWarning.apply(void 0, args);
	
	        if (_Component.prototype.componentWillMount) {
	          var _Component$prototype$;
	
	          for (var _len2 = arguments.length, methodArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            methodArgs[_key2] = arguments[_key2];
	          }
	
	          (_Component$prototype$ = _Component.prototype.componentWillMount).call.apply(_Component$prototype$, [this].concat(methodArgs));
	        }
	      };
	
	      return DeprecatedComponent;
	    }(Component)
	  );
	};
	
	var _default = deprecationWarning;
	exports.default = _default;
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 1978 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	exports.__esModule = true;
	exports.bootstrapUtils = void 0;
	
	var _bootstrapUtils = _interopRequireWildcard(__webpack_require__(14));
	
	exports.bootstrapUtils = _bootstrapUtils;
	
	var _createChainedFunction2 = _interopRequireDefault(__webpack_require__(45));
	
	exports.createChainedFunction = _createChainedFunction2.default;
	
	var _ValidComponentChildren2 = _interopRequireDefault(__webpack_require__(62));
	
	exports.ValidComponentChildren = _ValidComponentChildren2.default;

/***/ },
/* 1979 */
[2242, 1980],
/* 1980 */
1016,
/* 1981 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.uncontrolledPropTypes = uncontrolledPropTypes;
	exports.isProp = isProp;
	exports.defaultKey = defaultKey;
	exports.isReactComponent = isReactComponent;
	
	var _invariant = _interopRequireDefault(__webpack_require__(68));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noop = function noop() {};
	
	function readOnlyPropType(handler, name) {
	  return function (props, propName) {
	    if (props[propName] !== undefined) {
	      if (!props[handler]) {
	        return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + defaultKey(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
	      }
	    }
	  };
	}
	
	function uncontrolledPropTypes(controlledValues, displayName) {
	  var propTypes = {};
	  Object.keys(controlledValues).forEach(function (prop) {
	    // add default propTypes for folks that use runtime checks
	    propTypes[defaultKey(prop)] = noop;
	
	    if (false) {
	      var handler = controlledValues[prop];
	      !(typeof handler === 'string' && handler.trim().length) ? process.env.NODE_ENV !== "production" ? (0, _invariant.default)(false, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop) : invariant(false) : void 0;
	      propTypes[prop] = readOnlyPropType(handler, displayName);
	    }
	  });
	  return propTypes;
	}
	
	function isProp(props, prop) {
	  return props[prop] !== undefined;
	}
	
	function defaultKey(key) {
	  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
	}
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	
	function isReactComponent(component) {
	  return !!(component && component.prototype && component.prototype.isReactComponent);
	}

/***/ },
/* 1982 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UnmountClosed = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(899);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Collapse = __webpack_require__(898);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UnmountClosed = exports.UnmountClosed = function (_React$PureComponent) {
	  _inherits(UnmountClosed, _React$PureComponent);
	
	  function UnmountClosed(props) {
	    _classCallCheck(this, UnmountClosed);
	
	    var _this = _possibleConstructorReturn(this, (UnmountClosed.__proto__ || Object.getPrototypeOf(UnmountClosed)).call(this, props));
	
	    _this.componentWillReceiveProps = function (_ref) {
	      var isOpened = _ref.isOpened;
	
	      if (!_this.props.isOpened && isOpened) {
	        _this.setState({
	          forceInitialAnimation: true,
	          shouldUnmount: false
	        });
	      }
	    };
	
	    _this.onRest = function () {
	      var _this$props = _this.props,
	          isOpened = _this$props.isOpened,
	          onRest = _this$props.onRest;
	
	
	      if (!isOpened) {
	        _this.setState({ shouldUnmount: true });
	      }
	      if (onRest) {
	        onRest.apply(undefined, arguments);
	      }
	    };
	
	    _this.state = {
	      shouldUnmount: !_this.props.isOpened,
	      forceInitialAnimation: !_this.props.isOpened
	    };
	    return _this;
	  }
	
	  _createClass(UnmountClosed, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isOpened = _props.isOpened,
	          _onRest = _props.onRest,
	          props = _objectWithoutProperties(_props, ['isOpened', 'onRest']);
	
	      var _state = this.state,
	          forceInitialAnimation = _state.forceInitialAnimation,
	          shouldUnmount = _state.shouldUnmount;
	
	
	      return shouldUnmount ? null : _react2.default.createElement(_Collapse.Collapse, _extends({
	        forceInitialAnimation: forceInitialAnimation,
	        isOpened: isOpened,
	        onRest: this.onRest
	      }, props));
	    }
	  }]);
	
	  return UnmountClosed;
	}(_react2.default.PureComponent);
	
	UnmountClosed.propTypes = {
	  isOpened: _propTypes2.default.bool.isRequired,
	  onRest: _propTypes2.default.func
	};

/***/ },
/* 1983 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(898),
	    Collapse = _require.Collapse;
	
	var _require2 = __webpack_require__(1982),
	    UnmountClosed = _require2.UnmountClosed;
	
	UnmountClosed.Collapse = Collapse;
	UnmountClosed.UnmountClosed = UnmountClosed;
	
	module.exports = UnmountClosed;

/***/ },
/* 1984 */
[2242, 1985],
/* 1985 */
1016,
/* 1986 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            var args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays (ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        var weekdays = isArray(this._weekdays) ? this._weekdays :
	            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
	        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
	            : (m) ? weekdays[m.day()] : weekdays;
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000;
	    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
	    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
	    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return (dividend % divisor + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':   return months;
	                case 'quarter': return months / 3;
	                case 'year':    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asQuarters     = makeAs('Q');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asQuarters     = asQuarters;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.24.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ },
/* 1987 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var react = __webpack_require__(1);
	var reactDom = __webpack_require__(31);
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	/**
	 * Check whether some DOM node is our Component's node.
	 */
	function isNodeFound(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // SVG <use/> elements do not technically reside in the rendered DOM, so
	  // they do not have classList directly, but they offer a link to their
	  // corresponding element, which can have classList. This extra check is for
	  // that case.
	  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	
	
	  if (current.correspondingElement) {
	    return current.correspondingElement.classList.contains(ignoreClass);
	  }
	
	  return current.classList.contains(ignoreClass);
	}
	/**
	 * Try to find our node in a hierarchy of nodes, returning the document
	 * node as highest node if our node is not found in the path up.
	 */
	
	function findHighest(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // If source=local then this event came from 'somewhere'
	  // inside and should be ignored. We could handle this with
	  // a layered approach, too, but that requires going back to
	  // thinking in terms of Dom node nesting, running counter
	  // to React's 'you shouldn't care about the DOM' philosophy.
	
	
	  while (current.parentNode) {
	    if (isNodeFound(current, componentNode, ignoreClass)) {
	      return true;
	    }
	
	    current = current.parentNode;
	  }
	
	  return current;
	}
	/**
	 * Check if the browser scrollbar was clicked
	 */
	
	function clickedScrollbar(evt) {
	  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
	}
	
	// ideally will get replaced with external dep
	// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
	var testPassiveEventSupport = function testPassiveEventSupport() {
	  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
	    return;
	  }
	
	  var passive = false;
	  var options = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      passive = true;
	    }
	  });
	
	  var noop = function noop() {};
	
	  window.addEventListener('testPassiveEventSupport', noop, options);
	  window.removeEventListener('testPassiveEventSupport', noop, options);
	  return passive;
	};
	
	function autoInc(seed) {
	  if (seed === void 0) {
	    seed = 0;
	  }
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = autoInc();
	
	var passiveEventSupport;
	var handlersMap = {};
	var enabledInstances = {};
	var touchEvents = ['touchstart', 'touchmove'];
	var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
	/**
	 * Options for addEventHandler and removeEventHandler
	 */
	
	function getEventHandlerOptions(instance, eventName) {
	  var handlerOptions = null;
	  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;
	
	  if (isTouchEvent && passiveEventSupport) {
	    handlerOptions = {
	      passive: !instance.props.preventDefault
	    };
	  }
	
	  return handlerOptions;
	}
	/**
	 * This function generates the HOC function that you'll use
	 * in order to impart onOutsideClick listening to an
	 * arbitrary component. It gets called at the end of the
	 * bootstrapping code to yield an instance of the
	 * onClickOutsideHOC function defined inside setupHOC().
	 */
	
	
	function onClickOutsideHOC(WrappedComponent, config) {
	  var _class, _temp;
	
	  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inheritsLoose(onClickOutside, _Component);
	
	    function onClickOutside(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	
	      _this.__outsideClickHandler = function (event) {
	        if (typeof _this.__clickOutsideHandlerProp === 'function') {
	          _this.__clickOutsideHandlerProp(event);
	
	          return;
	        }
	
	        var instance = _this.getInstance();
	
	        if (typeof instance.props.handleClickOutside === 'function') {
	          instance.props.handleClickOutside(event);
	          return;
	        }
	
	        if (typeof instance.handleClickOutside === 'function') {
	          instance.handleClickOutside(event);
	          return;
	        }
	
	        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
	      };
	
	      _this.__getComponentNode = function () {
	        var instance = _this.getInstance();
	
	        if (config && typeof config.setClickOutsideRef === 'function') {
	          return config.setClickOutsideRef()(instance);
	        }
	
	        if (typeof instance.setClickOutsideRef === 'function') {
	          return instance.setClickOutsideRef();
	        }
	
	        return reactDom.findDOMNode(instance);
	      };
	
	      _this.enableOnClickOutside = function () {
	        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
	          return;
	        }
	
	        if (typeof passiveEventSupport === 'undefined') {
	          passiveEventSupport = testPassiveEventSupport();
	        }
	
	        enabledInstances[_this._uid] = true;
	        var events = _this.props.eventTypes;
	
	        if (!events.forEach) {
	          events = [events];
	        }
	
	        handlersMap[_this._uid] = function (event) {
	          if (_this.componentNode === null) return;
	
	          if (_this.props.preventDefault) {
	            event.preventDefault();
	          }
	
	          if (_this.props.stopPropagation) {
	            event.stopPropagation();
	          }
	
	          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
	          var current = event.target;
	
	          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
	            return;
	          }
	
	          _this.__outsideClickHandler(event);
	        };
	
	        events.forEach(function (eventName) {
	          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
	        });
	      };
	
	      _this.disableOnClickOutside = function () {
	        delete enabledInstances[_this._uid];
	        var fn = handlersMap[_this._uid];
	
	        if (fn && typeof document !== 'undefined') {
	          var events = _this.props.eventTypes;
	
	          if (!events.forEach) {
	            events = [events];
	          }
	
	          events.forEach(function (eventName) {
	            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
	          });
	          delete handlersMap[_this._uid];
	        }
	      };
	
	      _this.getRef = function (ref) {
	        return _this.instanceRef = ref;
	      };
	
	      _this._uid = uid();
	      return _this;
	    }
	    /**
	     * Access the WrappedComponent's instance.
	     */
	
	
	    var _proto = onClickOutside.prototype;
	
	    _proto.getInstance = function getInstance() {
	      if (!WrappedComponent.prototype.isReactComponent) {
	        return this;
	      }
	
	      var ref = this.instanceRef;
	      return ref.getInstance ? ref.getInstance() : ref;
	    };
	
	    /**
	     * Add click listeners to the current document,
	     * linked to this component's state.
	     */
	    _proto.componentDidMount = function componentDidMount() {
	      // If we are in an environment without a DOM such
	      // as shallow rendering or snapshots then we exit
	      // early to prevent any unhandled errors being thrown.
	      if (typeof document === 'undefined' || !document.createElement) {
	        return;
	      }
	
	      var instance = this.getInstance();
	
	      if (config && typeof config.handleClickOutside === 'function') {
	        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
	
	        if (typeof this.__clickOutsideHandlerProp !== 'function') {
	          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
	        }
	      }
	
	      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
	
	      if (this.props.disableOnClickOutside) return;
	      this.enableOnClickOutside();
	    };
	
	    _proto.componentDidUpdate = function componentDidUpdate() {
	      this.componentNode = this.__getComponentNode();
	    };
	    /**
	     * Remove all document's event listeners for this component
	     */
	
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.disableOnClickOutside();
	    };
	    /**
	     * Can be called to explicitly enable event listening
	     * for clicks and touches outside of this element.
	     */
	
	
	    /**
	     * Pass-through render
	     */
	    _proto.render = function render() {
	      // eslint-disable-next-line no-unused-vars
	      var _props = this.props,
	          excludeScrollbar = _props.excludeScrollbar,
	          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);
	
	      if (WrappedComponent.prototype.isReactComponent) {
	        props.ref = this.getRef;
	      } else {
	        props.wrappedRef = this.getRef;
	      }
	
	      props.disableOnClickOutside = this.disableOnClickOutside;
	      props.enableOnClickOutside = this.enableOnClickOutside;
	      return react.createElement(WrappedComponent, props);
	    };
	
	    return onClickOutside;
	  }(react.Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
	    eventTypes: ['mousedown', 'touchstart'],
	    excludeScrollbar: config && config.excludeScrollbar || false,
	    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
	    preventDefault: false,
	    stopPropagation: false
	  }, _class.getClass = function () {
	    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
	  }, _temp;
	}
	
	exports.IGNORE_CLASS_NAME = IGNORE_CLASS_NAME;
	exports['default'] = onClickOutsideHOC;


/***/ },
/* 1988 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(901);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gud = __webpack_require__(1774);
	
	var _gud2 = _interopRequireDefault(_gud);
	
	var _warning = __webpack_require__(903);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MAX_SIGNED_31_BIT_INT = 1073741823;
	
	// Inlined Object.is polyfill.
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	function objectIs(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function createEventEmitter(value) {
	  var handlers = [];
	  return {
	    on: function on(handler) {
	      handlers.push(handler);
	    },
	    off: function off(handler) {
	      handlers = handlers.filter(function (h) {
	        return h !== handler;
	      });
	    },
	    get: function get() {
	      return value;
	    },
	    set: function set(newValue, changedBits) {
	      value = newValue;
	      handlers.forEach(function (handler) {
	        return handler(value, changedBits);
	      });
	    }
	  };
	}
	
	function onlyChild(children) {
	  return Array.isArray(children) ? children[0] : children;
	}
	
	function createReactContext(defaultValue, calculateChangedBits) {
	  var _Provider$childContex, _Consumer$contextType;
	
	  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    function Provider() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Provider);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
	    };
	
	    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var oldValue = this.props.value;
	        var newValue = nextProps.value;
	        var changedBits = void 0;
	
	        if (objectIs(oldValue, newValue)) {
	          changedBits = 0; // No change
	        } else {
	          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
	          if (false) {
	            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
	          }
	
	          changedBits |= 0;
	
	          if (changedBits !== 0) {
	            this.emitter.set(nextProps.value, changedBits);
	          }
	        }
	      }
	    };
	
	    Provider.prototype.render = function render() {
	      return this.props.children;
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);
	
	  var Consumer = function (_Component2) {
	    _inherits(Consumer, _Component2);
	
	    function Consumer() {
	      var _temp2, _this2, _ret2;
	
	      _classCallCheck(this, Consumer);
	
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
	        value: _this2.getValue()
	      }, _this2.onUpdate = function (newValue, changedBits) {
	        var observedBits = _this2.observedBits | 0;
	        if ((observedBits & changedBits) !== 0) {
	          _this2.setState({ value: _this2.getValue() });
	        }
	      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	    }
	
	    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var observedBits = nextProps.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentDidMount = function componentDidMount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].on(this.onUpdate);
	      }
	      var observedBits = this.props.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].off(this.onUpdate);
	      }
	    };
	
	    Consumer.prototype.getValue = function getValue() {
	      if (this.context[contextProp]) {
	        return this.context[contextProp].get();
	      } else {
	        return defaultValue;
	      }
	    };
	
	    Consumer.prototype.render = function render() {
	      return onlyChild(this.props.children)(this.state.value);
	    };
	
	    return Consumer;
	  }(_react.Component);
	
	  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);
	
	
	  return {
	    Provider: Provider,
	    Consumer: Consumer
	  };
	}
	
	exports.default = createReactContext;
	module.exports = exports['default'];

/***/ },
/* 1989 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _implementation = __webpack_require__(1988);
	
	var _implementation2 = _interopRequireDefault(_implementation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createContext || _implementation2.default;
	module.exports = exports['default'];

/***/ },
/* 1990 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.16.0
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
	
	var timeoutDuration = function () {
	  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	      return 1;
	    }
	  }
	  return 0;
	}();
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var window = element.ownerDocument.defaultView;
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	/**
	 * Returns the reference node of the reference object, or the reference object itself.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
	 * @returns {Element} parent
	 */
	function getReferenceNode(reference) {
	  return reference && reference.referenceNode ? reference.referenceNode : reference;
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent || null;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TH, TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	}
	
	function getWindowSizes(document) {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	  var width = sizes.width || element.clientWidth || result.width;
	  var height = sizes.height || element.clientHeight || result.height;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && isHTML) {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop, 10);
	    var marginLeft = parseFloat(styles.marginLeft, 10);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  var parentNode = getParentNode(element);
	  if (!parentNode) {
	    return false;
	  }
	  return isFixed(parentNode);
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  padding = padding || 0;
	  var isPaddingNumber = typeof padding === 'number';
	  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var window = element.ownerDocument.defaultView;
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroys the popper.
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicitly asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	 * @returns {Object} The popper's position offsets rounded
	 *
	 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	 * good as it can be within reason.
	 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	 *
	 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	 * as well on High DPI screens).
	 *
	 * Firefox prefers no rounding for positioning and does not have blurriness on
	 * high DPI screens.
	 *
	 * Only horizontal placement and left/right values need to be considered.
	 */
	function getRoundedOffsets(data, shouldRound) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	  var round = Math.round,
	      floor = Math.floor;
	
	  var noRound = function noRound(v) {
	    return v;
	  };
	
	  var referenceWidth = round(reference.width);
	  var popperWidth = round(popper.width);
	
	  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	  var isVariation = data.placement.indexOf('-') !== -1;
	  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
	  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
	
	  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
	  var verticalToInteger = !shouldRound ? noRound : round;
	
	  return {
	    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	    top: verticalToInteger(popper.top),
	    bottom: verticalToInteger(popper.bottom),
	    right: horizontalToInteger(popper.right)
	  };
	}
	
	var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	    // and not the bottom of the html element
	    if (offsetParent.nodeName === 'HTML') {
	      top = -offsetParent.clientHeight + offsets.bottom;
	    } else {
	      top = -offsetParentRect.height + offsets.bottom;
	    }
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    if (offsetParent.nodeName === 'HTML') {
	      left = -offsetParent.clientWidth + offsets.right;
	    } else {
	      left = -offsetParentRect.width + offsets.right;
	    }
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjunction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-end` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	
	    // flips variation if reference element overflows boundaries
	    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    // flips variation if popper content overflows boundaries
	    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
	
	    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unit-less, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the `height`.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * A scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper. This makes sure the popper always has a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near each other
	   * without leaving any gap between the two. Especially useful when the arrow is
	   * enabled and you want to ensure that it points to its reference element.
	   * It cares only about the first axis. You can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjunction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations)
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position.
	     * The popper will never be placed outside of the defined boundaries
	     * (except if `keepTogether` is enabled)
	     */
	    boundariesElement: 'viewport',
	    /**
	     * @prop {Boolean} flipVariations=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the reference element overlaps its boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariations: false,
	    /**
	     * @prop {Boolean} flipVariationsByContent=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the popper element overlaps its reference boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariationsByContent: false
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define your own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the information used by Popper.js.
	 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overridden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass an object with the same
	 * structure of the `options` object, as the 3rd argument. For example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement.
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled.
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated. This callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js.
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Creates a new Popper.js instance.
	   * @class Popper
	   * @param {Element|referenceObject} reference - The reference element used to position the popper
	   * @param {Element} popper - The HTML / XML element used as the popper
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedules an update. It will run on the next UI update available.
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10.
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1991 */
[2242, 1992],
/* 1992 */
1016,
/* 1993 */
1987,
/* 1994 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(243);
	
	var _interopRequireDefault = __webpack_require__(35);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Popper;
	exports.placements = exports.InnerPopper = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(974));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(333));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(331));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(334));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(332));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _popper = _interopRequireDefault(__webpack_require__(1990));
	
	var _Manager = __webpack_require__(510);
	
	var _utils = __webpack_require__(902);
	
	var initialStyle = {
	  position: 'absolute',
	  top: 0,
	  left: 0,
	  opacity: 0,
	  pointerEvents: 'none'
	};
	var initialArrowStyle = {};
	
	var InnerPopper =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(InnerPopper, _React$Component);
	
	  function InnerPopper() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
	      data: undefined,
	      placement: undefined
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "popperInstance", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "popperNode", null);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "arrowNode", null);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setPopperNode", function (popperNode) {
	      if (!popperNode || _this.popperNode === popperNode) return;
	      (0, _utils.setRef)(_this.props.innerRef, popperNode);
	      _this.popperNode = popperNode;
	
	      _this.updatePopperInstance();
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setArrowNode", function (arrowNode) {
	      _this.arrowNode = arrowNode;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateStateModifier", {
	      enabled: true,
	      order: 900,
	      fn: function fn(data) {
	        var placement = data.placement;
	
	        _this.setState({
	          data: data,
	          placement: placement
	        });
	
	        return data;
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getOptions", function () {
	      return {
	        placement: _this.props.placement,
	        eventsEnabled: _this.props.eventsEnabled,
	        positionFixed: _this.props.positionFixed,
	        modifiers: (0, _extends2.default)({}, _this.props.modifiers, {
	          arrow: (0, _extends2.default)({}, _this.props.modifiers && _this.props.modifiers.arrow, {
	            enabled: !!_this.arrowNode,
	            element: _this.arrowNode
	          }),
	          applyStyle: {
	            enabled: false
	          },
	          updateStateModifier: _this.updateStateModifier
	        })
	      };
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getPopperStyle", function () {
	      return !_this.popperNode || !_this.state.data ? initialStyle : (0, _extends2.default)({
	        position: _this.state.data.offsets.popper.position
	      }, _this.state.data.styles);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getPopperPlacement", function () {
	      return !_this.state.data ? undefined : _this.state.placement;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getArrowStyle", function () {
	      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getOutOfBoundariesState", function () {
	      return _this.state.data ? _this.state.data.hide : undefined;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "destroyPopperInstance", function () {
	      if (!_this.popperInstance) return;
	
	      _this.popperInstance.destroy();
	
	      _this.popperInstance = null;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updatePopperInstance", function () {
	      _this.destroyPopperInstance();
	
	      var _assertThisInitialize = (0, _assertThisInitialized2.default)(_this),
	          popperNode = _assertThisInitialize.popperNode;
	
	      var referenceElement = _this.props.referenceElement;
	      if (!referenceElement || !popperNode) return;
	      _this.popperInstance = new _popper.default(referenceElement, popperNode, _this.getOptions());
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "scheduleUpdate", function () {
	      if (_this.popperInstance) {
	        _this.popperInstance.scheduleUpdate();
	      }
	    });
	    return _this;
	  }
	
	  var _proto = InnerPopper.prototype;
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    // If the Popper.js options have changed, update the instance (destroy + create)
	    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || this.props.modifiers !== prevProps.modifiers) {
	      // develop only check that modifiers isn't being updated needlessly
	      if (false) {
	        if (this.props.modifiers !== prevProps.modifiers && this.props.modifiers != null && prevProps.modifiers != null && (0, _utils.shallowEqual)(this.props.modifiers, prevProps.modifiers)) {
	          console.warn("'modifiers' prop reference updated even though all values appear the same.\nConsider memoizing the 'modifiers' object to avoid needless rendering.");
	        }
	      }
	
	      this.updatePopperInstance();
	    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
	      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
	    } // A placement difference in state means popper determined a new placement
	    // apart from the props value. By the time the popper element is rendered with
	    // the new position Popper has already measured it, if the place change triggers
	    // a size change it will result in a misaligned popper. So we schedule an update to be sure.
	
	
	    if (prevState.placement !== this.state.placement) {
	      this.scheduleUpdate();
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    (0, _utils.setRef)(this.props.innerRef, null);
	    this.destroyPopperInstance();
	  };
	
	  _proto.render = function render() {
	    return (0, _utils.unwrapArray)(this.props.children)({
	      ref: this.setPopperNode,
	      style: this.getPopperStyle(),
	      placement: this.getPopperPlacement(),
	      outOfBoundaries: this.getOutOfBoundariesState(),
	      scheduleUpdate: this.scheduleUpdate,
	      arrowProps: {
	        ref: this.setArrowNode,
	        style: this.getArrowStyle()
	      }
	    });
	  };
	
	  return InnerPopper;
	}(React.Component);
	
	exports.InnerPopper = InnerPopper;
	(0, _defineProperty2.default)(InnerPopper, "defaultProps", {
	  placement: 'bottom',
	  eventsEnabled: true,
	  referenceElement: undefined,
	  positionFixed: false
	});
	var placements = _popper.default.placements;
	exports.placements = placements;
	
	function Popper(_ref) {
	  var referenceElement = _ref.referenceElement,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["referenceElement"]);
	  return React.createElement(_Manager.ManagerReferenceNodeContext.Consumer, null, function (referenceNode) {
	    return React.createElement(InnerPopper, (0, _extends2.default)({
	      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
	    }, props));
	  });
	}

/***/ },
/* 1995 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(243);
	
	var _interopRequireDefault = __webpack_require__(35);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Reference;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(333));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(331));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(334));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(332));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _warning = _interopRequireDefault(__webpack_require__(903));
	
	var _Manager = __webpack_require__(510);
	
	var _utils = __webpack_require__(902);
	
	var InnerReference =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(InnerReference, _React$Component);
	
	  function InnerReference() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "refHandler", function (node) {
	      (0, _utils.setRef)(_this.props.innerRef, node);
	      (0, _utils.safeInvoke)(_this.props.setReferenceNode, node);
	    });
	    return _this;
	  }
	
	  var _proto = InnerReference.prototype;
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    (0, _utils.setRef)(this.props.innerRef, null);
	  };
	
	  _proto.render = function render() {
	    (0, _warning.default)(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
	    return (0, _utils.unwrapArray)(this.props.children)({
	      ref: this.refHandler
	    });
	  };
	
	  return InnerReference;
	}(React.Component);
	
	function Reference(props) {
	  return React.createElement(_Manager.ManagerReferenceNodeSetterContext.Consumer, null, function (setReferenceNode) {
	    return React.createElement(InnerReference, (0, _extends2.default)({
	      setReferenceNode: setReferenceNode
	    }, props));
	  });
	}

/***/ },
/* 1996 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(35);
	
	var _interopRequireWildcard = __webpack_require__(243);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Popper", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.default;
	  }
	});
	Object.defineProperty(exports, "placements", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.placements;
	  }
	});
	Object.defineProperty(exports, "Manager", {
	  enumerable: true,
	  get: function get() {
	    return _Manager.default;
	  }
	});
	Object.defineProperty(exports, "Reference", {
	  enumerable: true,
	  get: function get() {
	    return _Reference.default;
	  }
	});
	
	var _Popper = _interopRequireWildcard(__webpack_require__(1994));
	
	var _Manager = _interopRequireDefault(__webpack_require__(510));
	
	var _Reference = _interopRequireDefault(__webpack_require__(1995));

/***/ },
/* 1997 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.8.6
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(1),n=__webpack_require__(230),r=__webpack_require__(2143);function ba(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[c,d,e,f,g,h],k=0;a=Error(b.replace(/%s/g,function(){return l[k++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
	function x(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ba(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:x("227");function ca(a,b,c,d,e,f,g,h,l){var k=Array.prototype.slice.call(arguments,3);try{b.apply(c,k)}catch(m){this.onError(m)}}
	var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,l){da=!1;ea=null;ca.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,l){ja.apply(this,arguments);if(da){if(da){var k=ea;da=!1;ea=null}else x("198"),k=void 0;fa||(fa=!0,ha=k)}}var la=null,ma={};
	function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:x("96",a);if(!oa[c]){b.extractEvents?void 0:x("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?x("99",h):void 0;pa[h]=f;var l=f.phasedRegistrationNames;if(l){for(e in l)l.hasOwnProperty(e)&&qa(l[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:x("98",d,a)}}}}
	function qa(a,b,c){ra[a]?x("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={},ta=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ka(d,b,void 0,a);a.currentTarget=null}function xa(a,b){null==b?x("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
	function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}
	var Ba={injectEventPluginOrder:function(a){la?x("101"):void 0;la=Array.prototype.slice.call(a);na()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?x("102",c):void 0,ma[c]=d,b=!0)}b&&na()}};
	function Ca(a,b){var c=a.stateNode;if(!c)return null;var d=ta(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?x("231",b,typeof c):void 0;
	return c}function Da(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a&&(ya(a,Aa),za?x("95"):void 0,fa))throw a=ha,fa=!1,ha=null,a;}var Ea=Math.random().toString(36).slice(2),Fa="__reactInternalInstance$"+Ea,Ga="__reactEventHandlers$"+Ea;function Ha(a){if(a[Fa])return a[Fa];for(;!a[Fa];)if(a.parentNode)a=a.parentNode;else return null;a=a[Fa];return 5===a.tag||6===a.tag?a:null}function Ia(a){a=a[Fa];return!a||5!==a.tag&&6!==a.tag?null:a}
	function Ja(a){if(5===a.tag||6===a.tag)return a.stateNode;x("33")}function Ka(a){return a[Ga]||null}function La(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ma(a,b,c){if(b=Ca(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
	function Na(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=La(b);for(b=c.length;0<b--;)Ma(c[b],"captured",a);for(b=0;b<c.length;b++)Ma(c[b],"bubbled",a)}}function Oa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ca(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Pa(a){a&&a.dispatchConfig.registrationName&&Oa(a._targetInst,null,a)}
	function Qa(a){ya(a,Na)}var Ra=!("undefined"===typeof window||!window.document||!window.document.createElement);function Sa(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ta={animationend:Sa("Animation","AnimationEnd"),animationiteration:Sa("Animation","AnimationIteration"),animationstart:Sa("Animation","AnimationStart"),transitionend:Sa("Transition","TransitionEnd")},Ua={},Va={};
	Ra&&(Va=document.createElement("div").style,"AnimationEvent"in window||(delete Ta.animationend.animation,delete Ta.animationiteration.animation,delete Ta.animationstart.animation),"TransitionEvent"in window||delete Ta.transitionend.transition);function Wa(a){if(Ua[a])return Ua[a];if(!Ta[a])return a;var b=Ta[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Va)return Ua[a]=b[c];return a}
	var Xa=Wa("animationend"),Ya=Wa("animationiteration"),Za=Wa("animationstart"),$a=Wa("transitionend"),ab="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bb=null,cb=null,db=null;
	function eb(){if(db)return db;var a,b=cb,c=b.length,d,e="value"in bb?bb.value:bb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return db=e.slice(a,1<d?1-d:void 0)}function fb(){return!0}function gb(){return!1}
	function y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?fb:gb;this.isPropagationStopped=gb;return this}
	n(y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=fb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=fb)},persist:function(){this.isPersistent=fb},isPersistent:gb,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=gb;this._dispatchInstances=this._dispatchListeners=null}});y.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	y.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;hb(c);return c};hb(y);function ib(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function jb(a){a instanceof this?void 0:x("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
	function hb(a){a.eventPool=[];a.getPooled=ib;a.release=jb}var kb=y.extend({data:null}),lb=y.extend({data:null}),mb=[9,13,27,32],nb=Ra&&"CompositionEvent"in window,ob=null;Ra&&"documentMode"in document&&(ob=document.documentMode);
	var pb=Ra&&"TextEvent"in window&&!ob,qb=Ra&&(!nb||ob&&8<ob&&11>=ob),rb=String.fromCharCode(32),sb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},tb=!1;
	function ub(a,b){switch(a){case "keyup":return-1!==mb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function vb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var wb=!1;function xb(a,b){switch(a){case "compositionend":return vb(b);case "keypress":if(32!==b.which)return null;tb=!0;return rb;case "textInput":return a=b.data,a===rb&&tb?null:a;default:return null}}
	function yb(a,b){if(wb)return"compositionend"===a||!nb&&ub(a,b)?(a=eb(),db=cb=bb=null,wb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return qb&&"ko"!==b.locale?null:b.data;default:return null}}
	var zb={eventTypes:sb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(nb)b:{switch(a){case "compositionstart":e=sb.compositionStart;break b;case "compositionend":e=sb.compositionEnd;break b;case "compositionupdate":e=sb.compositionUpdate;break b}e=void 0}else wb?ub(a,c)&&(e=sb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=sb.compositionStart);e?(qb&&"ko"!==c.locale&&(wb||e!==sb.compositionStart?e===sb.compositionEnd&&wb&&(f=eb()):(bb=d,cb="value"in bb?bb.value:bb.textContent,wb=
	!0)),e=kb.getPooled(e,b,c,d),f?e.data=f:(f=vb(c),null!==f&&(e.data=f)),Qa(e),f=e):f=null;(a=pb?xb(a,c):yb(a,c))?(b=lb.getPooled(sb.beforeInput,b,c,d),b.data=a,Qa(b)):b=null;return null===f?b:null===b?f:[f,b]}},Ab=null,Bb=null,Cb=null;function Db(a){if(a=ua(a)){"function"!==typeof Ab?x("280"):void 0;var b=ta(a.stateNode);Ab(a.stateNode,a.type,b)}}function Eb(a){Bb?Cb?Cb.push(a):Cb=[a]:Bb=a}function Fb(){if(Bb){var a=Bb,b=Cb;Cb=Bb=null;Db(a);if(b)for(a=0;a<b.length;a++)Db(b[a])}}
	function Gb(a,b){return a(b)}function Hb(a,b,c){return a(b,c)}function Ib(){}var Jb=!1;function Kb(a,b){if(Jb)return a(b);Jb=!0;try{return Gb(a,b)}finally{if(Jb=!1,null!==Bb||null!==Cb)Ib(),Fb()}}var Lb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Mb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Lb[a.type]:"textarea"===b?!0:!1}
	function Nb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Ob(a){if(!Ra)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Pb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function Qb(a){var b=Pb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function Rb(a){a._valueTracker||(a._valueTracker=Qb(a))}function Sb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Pb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Tb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Tb.hasOwnProperty("ReactCurrentDispatcher")||(Tb.ReactCurrentDispatcher={current:null});
	var Ub=/^(.*)[\\\/]/,z="function"===typeof Symbol&&Symbol.for,Vb=z?Symbol.for("react.element"):60103,Wb=z?Symbol.for("react.portal"):60106,Xb=z?Symbol.for("react.fragment"):60107,Yb=z?Symbol.for("react.strict_mode"):60108,Zb=z?Symbol.for("react.profiler"):60114,$b=z?Symbol.for("react.provider"):60109,ac=z?Symbol.for("react.context"):60110,bc=z?Symbol.for("react.concurrent_mode"):60111,cc=z?Symbol.for("react.forward_ref"):60112,dc=z?Symbol.for("react.suspense"):60113,ec=z?Symbol.for("react.memo"):
	60115,fc=z?Symbol.for("react.lazy"):60116,gc="function"===typeof Symbol&&Symbol.iterator;function hc(a){if(null===a||"object"!==typeof a)return null;a=gc&&a[gc]||a["@@iterator"];return"function"===typeof a?a:null}
	function ic(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case bc:return"ConcurrentMode";case Xb:return"Fragment";case Wb:return"Portal";case Zb:return"Profiler";case Yb:return"StrictMode";case dc:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ac:return"Context.Consumer";case $b:return"Context.Provider";case cc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
	")":"ForwardRef");case ec:return ic(a.type);case fc:if(a=1===a._status?a._result:null)return ic(a)}return null}function jc(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=ic(a.type);c=null;d&&(c=ic(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ub,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
	var kc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,lc=Object.prototype.hasOwnProperty,mc={},nc={};
	function oc(a){if(lc.call(nc,a))return!0;if(lc.call(mc,a))return!1;if(kc.test(a))return nc[a]=!0;mc[a]=!0;return!1}function pc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function qc(a,b,c,d){if(null===b||"undefined"===typeof b||pc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function C(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var D={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new C(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new C(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new C(a,2,!1,a.toLowerCase(),null)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new C(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new C(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){D[a]=new C(a,3,!0,a,null)});
	["capture","download"].forEach(function(a){D[a]=new C(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){D[a]=new C(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){D[a]=new C(a,5,!1,a.toLowerCase(),null)});var rc=/[\-:]([a-z])/g;function sc(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(rc,
	sc);D[b]=new C(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new C(a,1,!1,a.toLowerCase(),null)});
	function tc(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(qc(b,c,e,d)&&(c=null),d||null===e?oc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	function uc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function vc(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function wc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=uc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function xc(a,b){b=b.checked;null!=b&&tc(a,"checked",b,!1)}
	function yc(a,b){xc(a,b);var c=uc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?zc(a,b.type,c):b.hasOwnProperty("defaultValue")&&zc(a,b.type,uc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Ac(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function zc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Bc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Cc(a,b,c){a=y.getPooled(Bc.change,a,b,c);a.type="change";Eb(c);Qa(a);return a}var Dc=null,Ec=null;function Fc(a){Da(a)}
	function Gc(a){var b=Ja(a);if(Sb(b))return a}function Hc(a,b){if("change"===a)return b}var Ic=!1;Ra&&(Ic=Ob("input")&&(!document.documentMode||9<document.documentMode));function Jc(){Dc&&(Dc.detachEvent("onpropertychange",Kc),Ec=Dc=null)}function Kc(a){"value"===a.propertyName&&Gc(Ec)&&(a=Cc(Ec,a,Nb(a)),Kb(Fc,a))}function Lc(a,b,c){"focus"===a?(Jc(),Dc=b,Ec=c,Dc.attachEvent("onpropertychange",Kc)):"blur"===a&&Jc()}function Mc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Gc(Ec)}
	function Nc(a,b){if("click"===a)return Gc(b)}function Oc(a,b){if("input"===a||"change"===a)return Gc(b)}
	var Pc={eventTypes:Bc,_isInputEventSupported:Ic,extractEvents:function(a,b,c,d){var e=b?Ja(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Hc:Mb(e)?Ic?f=Oc:(f=Mc,g=Lc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Nc);if(f&&(f=f(a,b)))return Cc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&zc(e,"number",e.value)}},Qc=y.extend({view:null,detail:null}),Rc={Alt:"altKey",
	Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Sc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Rc[a])?!!b[a]:!1}function Tc(){return Sc}
	var Uc=0,Vc=0,Wc=!1,Xc=!1,Yc=Qc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Tc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Uc;Uc=a.screenX;return Wc?"mousemove"===a.type?a.screenX-b:0:(Wc=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
	var b=Vc;Vc=a.screenY;return Xc?"mousemove"===a.type?a.screenY-b:0:(Xc=!0,0)}}),Zc=Yc.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),$c={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
	dependencies:["pointerout","pointerover"]}},ad={eventTypes:$c,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ha(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,l=void 0,k=void 0;if("mouseout"===a||"mouseover"===a)g=Yc,h=$c.mouseLeave,l=$c.mouseEnter,k="mouse";
	else if("pointerout"===a||"pointerover"===a)g=Zc,h=$c.pointerLeave,l=$c.pointerEnter,k="pointer";var m=null==f?e:Ja(f);e=null==b?e:Ja(b);a=g.getPooled(h,f,c,d);a.type=k+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(l,b,c,d);c.type=k+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;k=0;for(g=b;g;g=La(g))k++;g=0;for(l=e;l;l=La(l))g++;for(;0<k-g;)b=La(b),k--;for(;0<g-k;)e=La(e),g--;for(;k--;){if(b===e||b===e.alternate)break a;b=La(b);e=La(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){k=
	f.alternate;if(null!==k&&k===e)break;b.push(f);f=La(f)}for(f=[];d&&d!==e;){k=d.alternate;if(null!==k&&k===e)break;f.push(d);d=La(d)}for(d=0;d<b.length;d++)Oa(b[d],"bubbled",a);for(d=f.length;0<d--;)Oa(f[d],"captured",c);return[a,c]}};function bd(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var cd=Object.prototype.hasOwnProperty;
	function dd(a,b){if(bd(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!cd.call(b,c[d])||!bd(a[c[d]],b[c[d]]))return!1;return!0}function ed(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function fd(a){2!==ed(a)?x("188"):void 0}
	function gd(a){var b=a.alternate;if(!b)return b=ed(a),3===b?x("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return fd(e),a;if(g===d)return fd(e),b;g=g.sibling}x("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
	void 0:x("189")}}c.alternate!==d?x("190"):void 0}3!==c.tag?x("188"):void 0;return c.stateNode.current===c?a:b}function hd(a){a=gd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	var id=y.extend({animationName:null,elapsedTime:null,pseudoElement:null}),jd=y.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),kd=Qc.extend({relatedTarget:null});function ld(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var md={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},od=Qc.extend({key:function(a){if(a.key){var b=md[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=ld(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?nd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Tc,charCode:function(a){return"keypress"===
	a.type?ld(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?ld(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),pd=Yc.extend({dataTransfer:null}),qd=Qc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Tc}),rd=y.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),sd=Yc.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["abort","abort"],[Xa,"animationEnd"],[Ya,"animationIteration"],[Za,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
	["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
	["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[$a,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],ud={},vd={};function wd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};ud[a]=b;vd[c]=b}
	[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
	["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){wd(a,!0)});td.forEach(function(a){wd(a,!1)});
	var xd={eventTypes:ud,isInteractiveTopLevelEventType:function(a){a=vd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===ld(c))return null;case "keydown":case "keyup":a=od;break;case "blur":case "focus":a=kd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=Yc;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
	pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Xa:case Ya:case Za:a=id;break;case $a:a=rd;break;case "scroll":a=Qc;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=Zc;break;default:a=y}b=a.getPooled(e,b,c,d);Qa(b);return b}},yd=xd.isInteractiveTopLevelEventType,
	zd=[];function Ad(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ha(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Nb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<oa.length;h++){var l=oa[h];l&&(l=l.extractEvents(d,b,f,e))&&(g=xa(g,l))}Da(g)}}var Bd=!0;
	function E(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!1)}function Ed(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!0)}function Cd(a,b){Hb(Dd,a,b)}
	function Dd(a,b){if(Bd){var c=Nb(b);c=Ha(c);null===c||"number"!==typeof c.tag||2===ed(c)||(c=null);if(zd.length){var d=zd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Kb(Ad,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>zd.length&&zd.push(a)}}}var Fd={},Gd=0,Hd="_reactListenersID"+(""+Math.random()).slice(2);
	function Id(a){Object.prototype.hasOwnProperty.call(a,Hd)||(a[Hd]=Gd++,Fd[a[Hd]]={});return Fd[a[Hd]]}function Jd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Kd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
	function Ld(a,b){var c=Kd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Kd(c)}}function Md(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Md(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
	function Nd(){for(var a=window,b=Jd();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Jd(a.document)}return b}function Od(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
	function Pd(){var a=Nd();if(Od(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{b=(b=a.ownerDocument)&&b.defaultView||window;var c=b.getSelection&&b.getSelection();if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(A){b=null;break a}var f=0,g=-1,h=-1,l=0,k=0,m=a,p=null;b:for(;;){for(var t;;){m!==b||0!==d&&3!==m.nodeType||(g=f+d);m!==e||0!==c&&3!==m.nodeType||(h=f+c);3===m.nodeType&&(f+=m.nodeValue.length);
	if(null===(t=m.firstChild))break;p=m;m=t}for(;;){if(m===a)break b;p===b&&++l===d&&(g=f);p===e&&++k===c&&(h=f);if(null!==(t=m.nextSibling))break;m=p;p=m.parentNode}m=t}b=-1===g||-1===h?null:{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;return{focusedElem:a,selectionRange:b}}
	function Qd(a){var b=Nd(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&c&&c.ownerDocument&&Md(c.ownerDocument.documentElement,c)){if(null!==d&&Od(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(a=(b=c.ownerDocument||document)&&b.defaultView||window,a.getSelection){a=a.getSelection();var e=c.textContent.length,f=Math.min(d.start,e);d=void 0===d.end?f:Math.min(d.end,e);!a.extend&&f>d&&(e=d,d=f,f=e);e=Ld(c,f);var g=Ld(c,
	d);e&&g&&(1!==a.rangeCount||a.anchorNode!==e.node||a.anchorOffset!==e.offset||a.focusNode!==g.node||a.focusOffset!==g.offset)&&(b=b.createRange(),b.setStart(e.node,e.offset),a.removeAllRanges(),f>d?(a.addRange(b),a.extend(g.node,g.offset)):(b.setEnd(g.node,g.offset),a.addRange(b)))}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});"function"===typeof c.focus&&c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=a.top}}
	var Rd=Ra&&"documentMode"in document&&11>=document.documentMode,Sd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Td=null,Ud=null,Vd=null,Wd=!1;
	function Xd(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(Wd||null==Td||Td!==Jd(c))return null;c=Td;"selectionStart"in c&&Od(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Vd&&dd(Vd,c)?null:(Vd=c,a=y.getPooled(Sd.select,Ud,a,b),a.type="select",a.target=Td,Qa(a),a)}
	var Yd={eventTypes:Sd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Id(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ja(b):window;switch(a){case "focus":if(Mb(e)||"true"===e.contentEditable)Td=e,Ud=b,Vd=null;break;case "blur":Vd=Ud=Td=null;break;case "mousedown":Wd=!0;break;case "contextmenu":case "mouseup":case "dragend":return Wd=!1,Xd(c,d);case "selectionchange":if(Rd)break;
	case "keydown":case "keyup":return Xd(c,d)}return null}};Ba.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ta=Ka;ua=Ia;va=Ja;Ba.injectEventPluginsByName({SimpleEventPlugin:xd,EnterLeaveEventPlugin:ad,ChangeEventPlugin:Pc,SelectEventPlugin:Yd,BeforeInputEventPlugin:zb});function Zd(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
	function $d(a,b){a=n({children:void 0},b);if(b=Zd(b.children))a.children=b;return a}function ae(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+uc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function be(a,b){null!=b.dangerouslySetInnerHTML?x("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ce(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?x("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:x("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:uc(c)}}
	function de(a,b){var c=uc(b.value),d=uc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function ee(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var fe={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function ge(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function he(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?ge(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var ie=void 0,je=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==fe.svg||"innerHTML"in a)a.innerHTML=b;else{ie=ie||document.createElement("div");ie.innerHTML="<svg>"+b+"</svg>";for(b=ie.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function ke(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
	var le={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},me=["Webkit","ms","Moz","O"];Object.keys(le).forEach(function(a){me.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);le[b]=le[a]})});function ne(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||le.hasOwnProperty(a)&&le[a]?(""+b).trim():b+"px"}
	function oe(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ne(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var pe=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function qe(a,b){b&&(pe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?x("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?x("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:x("61")),null!=b.style&&"object"!==typeof b.style?x("62",""):void 0)}
	function re(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
	function se(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Id(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Ed("scroll",a);break;case "focus":case "blur":Ed("focus",a);Ed("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Ob(e)&&Ed(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===ab.indexOf(e)&&E(e,a)}c[e]=!0}}}function te(){}var ue=null,ve=null;
	function we(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function xe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}
	var ye="function"===typeof setTimeout?setTimeout:void 0,ze="function"===typeof clearTimeout?clearTimeout:void 0,Ae=r.unstable_scheduleCallback,Be=r.unstable_cancelCallback;
	function Ce(a,b,c,d,e){a[Ga]=e;"input"===c&&"radio"===e.type&&null!=e.name&&xc(a,e);re(c,d);d=re(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?oe(a,h):"dangerouslySetInnerHTML"===g?je(a,h):"children"===g?ke(a,h):tc(a,g,h,d)}switch(c){case "input":yc(a,e);break;case "textarea":de(a,e);break;case "select":b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ae(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?ae(a,!!e.multiple,e.defaultValue,
	!0):ae(a,!!e.multiple,e.multiple?[]:"",!1))}}function De(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function Ee(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var Fe=[],Ge=-1;function F(a){0>Ge||(a.current=Fe[Ge],Fe[Ge]=null,Ge--)}function G(a,b){Ge++;Fe[Ge]=a.current;a.current=b}var He={},H={current:He},I={current:!1},Ie=He;
	function Je(a,b){var c=a.type.contextTypes;if(!c)return He;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function J(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Ke(a){F(I,a);F(H,a)}function Le(a){F(I,a);F(H,a)}
	function Me(a,b,c){H.current!==He?x("168"):void 0;G(H,b,a);G(I,c,a)}function Ne(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:x("108",ic(b)||"Unknown",e);return n({},c,d)}function Oe(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||He;Ie=H.current;G(H,b,a);G(I,I.current,a);return!0}
	function Pe(a,b,c){var d=a.stateNode;d?void 0:x("169");c?(b=Ne(a,b,Ie),d.__reactInternalMemoizedMergedChildContext=b,F(I,a),F(H,a),G(H,b,a)):F(I,a);G(I,c,a)}var Qe=null,Re=null;function Se(a){return function(b){try{return a(b)}catch(c){}}}
	function Te(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Qe=Se(function(a){return b.onCommitFiberRoot(c,a)});Re=Se(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
	function Ue(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.contextDependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function K(a,b,c,d){return new Ue(a,b,c,d)}
	function Ve(a){a=a.prototype;return!(!a||!a.isReactComponent)}function We(a){if("function"===typeof a)return Ve(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===cc)return 11;if(a===ec)return 14}return 2}
	function Xe(a,b){var c=a.alternate;null===c?(c=K(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.contextDependencies=a.contextDependencies;c.sibling=a.sibling;
	c.index=a.index;c.ref=a.ref;return c}
	function Ye(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)Ve(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Xb:return Ze(c.children,e,f,b);case bc:return $e(c,e|3,f,b);case Yb:return $e(c,e|2,f,b);case Zb:return a=K(12,c,b,e|4),a.elementType=Zb,a.type=Zb,a.expirationTime=f,a;case dc:return a=K(13,c,b,e),a.elementType=dc,a.type=dc,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case $b:g=10;break a;case ac:g=9;break a;case cc:g=11;break a;case ec:g=
	14;break a;case fc:g=16;d=null;break a}x("130",null==a?a:typeof a,"")}b=K(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Ze(a,b,c,d){a=K(7,a,d,b);a.expirationTime=c;return a}function $e(a,b,c,d){a=K(8,a,d,b);b=0===(b&1)?Yb:bc;a.elementType=b;a.type=b;a.expirationTime=c;return a}function af(a,b,c){a=K(6,a,null,b);a.expirationTime=c;return a}
	function bf(a,b,c){b=K(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function cf(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c<b?a.earliestPendingTime=b:a.latestPendingTime>b&&(a.latestPendingTime=b);df(b,a)}
	function ef(a,b){a.didError=!1;if(0===b)a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0;else{b<a.latestPingedTime&&(a.latestPingedTime=0);var c=a.latestPendingTime;0!==c&&(c>b?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime>b&&(a.earliestPendingTime=a.latestPendingTime));c=a.earliestSuspendedTime;0===c?cf(a,b):b<a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,cf(a,b)):
	b>c&&cf(a,b)}df(0,a)}function ff(a,b){a.didError=!1;a.latestPingedTime>=b&&(a.latestPingedTime=0);var c=a.earliestPendingTime,d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c<b?a.earliestSuspendedTime=b:d>b&&(a.latestSuspendedTime=b);df(b,a)}
	function gf(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;c>b&&(b=c);a>b&&(b=a);return b}function df(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d<a)&&(e=d);a=e;0!==a&&c>a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}function L(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
	function hf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:a._status=0;b=a._ctor;b=b();b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)});switch(a._status){case 1:return a._result;case 2:throw a._result;}a._result=b;throw b;}}var jf=(new aa.Component).refs;
	function kf(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
	var tf={isMounted:function(a){return(a=a._reactInternalFiber)?2===ed(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.tag=rf;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=lf();c=mf(c,a);var d=nf(c);d.tag=
	sf;void 0!==b&&null!==b&&(d.callback=b);of();pf(a,d);qf(a,c)}};function uf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!dd(c,d)||!dd(e,f):!0}
	function vf(a,b,c){var d=!1,e=He;var f=b.contextType;"object"===typeof f&&null!==f?f=M(f):(e=J(b)?Ie:H.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Je(a,e):He);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=tf;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function wf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&tf.enqueueReplaceState(b,b.state,null)}
	function xf(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=jf;var f=b.contextType;"object"===typeof f&&null!==f?e.context=M(f):(f=J(b)?Ie:H.current,e.context=Je(a,f));f=a.updateQueue;null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(kf(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
	typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&tf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var zf=Array.isArray;
	function Af(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?x("309"):void 0,d=c.stateNode);d?void 0:x("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===jf&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?x("284"):void 0;c._owner?void 0:x("290",a)}return a}
	function Bf(a,b){"textarea"!==a.type&&x("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
	function Cf(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Xe(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=af(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function l(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Af(a,b,c),d.return=a,d;d=Ye(c.type,c.key,c.props,null,a.mode,d);d.ref=Af(a,b,c);d.return=a;return d}function k(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=bf(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Ze(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=af(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Vb:return c=Ye(b.type,b.key,b.props,null,a.mode,c),c.ref=Af(a,null,b),c.return=a,c;case Wb:return b=bf(b,a.mode,c),b.return=a,b}if(zf(b)||
	hc(b))return b=Ze(b,a.mode,c,null),b.return=a,b;Bf(a,b)}return null}function t(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Vb:return c.key===e?c.type===Xb?m(a,b,c.props.children,d,e):l(a,b,c,d):null;case Wb:return c.key===e?k(a,b,c,d):null}if(zf(c)||hc(c))return null!==e?null:m(a,b,c,d,null);Bf(a,c)}return null}function A(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Vb:return a=a.get(null===d.key?c:d.key)||null,d.type===Xb?m(b,a,d.props.children,e,d.key):l(b,a,d,e);case Wb:return a=a.get(null===d.key?c:d.key)||null,k(b,a,d,e)}if(zf(d)||hc(d))return a=a.get(c)||null,m(b,a,d,e,null);Bf(b,d)}return null}function v(e,g,h,k){for(var l=null,m=null,q=g,u=g=0,B=null;null!==q&&u<h.length;u++){q.index>u?(B=q,q=null):B=q.sibling;var w=t(e,q,h[u],k);if(null===w){null===q&&(q=B);break}a&&
	q&&null===w.alternate&&b(e,q);g=f(w,g,u);null===m?l=w:m.sibling=w;m=w;q=B}if(u===h.length)return c(e,q),l;if(null===q){for(;u<h.length;u++)if(q=p(e,h[u],k))g=f(q,g,u),null===m?l=q:m.sibling=q,m=q;return l}for(q=d(e,q);u<h.length;u++)if(B=A(q,e,u,h[u],k))a&&null!==B.alternate&&q.delete(null===B.key?u:B.key),g=f(B,g,u),null===m?l=B:m.sibling=B,m=B;a&&q.forEach(function(a){return b(e,a)});return l}function R(e,g,h,k){var l=hc(h);"function"!==typeof l?x("150"):void 0;h=l.call(h);null==h?x("151"):void 0;
	for(var m=l=null,q=g,u=g=0,B=null,w=h.next();null!==q&&!w.done;u++,w=h.next()){q.index>u?(B=q,q=null):B=q.sibling;var v=t(e,q,w.value,k);if(null===v){q||(q=B);break}a&&q&&null===v.alternate&&b(e,q);g=f(v,g,u);null===m?l=v:m.sibling=v;m=v;q=B}if(w.done)return c(e,q),l;if(null===q){for(;!w.done;u++,w=h.next())w=p(e,w.value,k),null!==w&&(g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);return l}for(q=d(e,q);!w.done;u++,w=h.next())w=A(q,e,u,w.value,k),null!==w&&(a&&null!==w.alternate&&q.delete(null===w.key?u:
	w.key),g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);a&&q.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Xb&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Vb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Xb:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Xb?f.props.children:f.props,h);d.ref=Af(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
	k.sibling}f.type===Xb?(d=Ze(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ye(f.type,f.key,f.props,null,a.mode,h),h.ref=Af(a,d,f),h.return=a,a=h)}return g(a);case Wb:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=bf(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=
	""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=af(f,a.mode,h),d.return=a,a=d),g(a);if(zf(f))return v(a,d,f,h);if(hc(f))return R(a,d,f,h);l&&Bf(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:h=a.type,x("152",h.displayName||h.name||"Component")}return c(a,d)}}var Df=Cf(!0),Ef=Cf(!1),Ff={},N={current:Ff},Gf={current:Ff},Hf={current:Ff};function If(a){a===Ff?x("174"):void 0;return a}
	function Jf(a,b){G(Hf,b,a);G(Gf,a,a);G(N,Ff,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:he(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=he(b,c)}F(N,a);G(N,b,a)}function Kf(a){F(N,a);F(Gf,a);F(Hf,a)}function Lf(a){If(Hf.current);var b=If(N.current);var c=he(b,a.type);b!==c&&(G(Gf,a,a),G(N,c,a))}function Mf(a){Gf.current===a&&(F(N,a),F(Gf,a))}
	var Nf=0,Of=2,Pf=4,Qf=8,Rf=16,Sf=32,Tf=64,Uf=128,Vf=Tb.ReactCurrentDispatcher,Wf=0,Xf=null,O=null,P=null,Yf=null,Q=null,Zf=null,$f=0,ag=null,bg=0,cg=!1,dg=null,eg=0;function fg(){x("321")}function gg(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!bd(a[c],b[c]))return!1;return!0}
	function hg(a,b,c,d,e,f){Wf=f;Xf=b;P=null!==a?a.memoizedState:null;Vf.current=null===P?ig:jg;b=c(d,e);if(cg){do cg=!1,eg+=1,P=null!==a?a.memoizedState:null,Zf=Yf,ag=Q=O=null,Vf.current=jg,b=c(d,e);while(cg);dg=null;eg=0}Vf.current=kg;a=Xf;a.memoizedState=Yf;a.expirationTime=$f;a.updateQueue=ag;a.effectTag|=bg;a=null!==O&&null!==O.next;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;a?x("300"):void 0;return b}function lg(){Vf.current=kg;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;cg=!1;dg=null;eg=0}
	function mg(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===Q?Yf=Q=a:Q=Q.next=a;return Q}function ng(){if(null!==Zf)Q=Zf,Zf=Q.next,O=P,P=null!==O?O.next:null;else{null===P?x("310"):void 0;O=P;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};Q=null===Q?Yf=a:Q.next=a;P=O.next}return Q}function og(a,b){return"function"===typeof b?b(a):b}
	function pg(a){var b=ng(),c=b.queue;null===c?x("311"):void 0;c.lastRenderedReducer=a;if(0<eg){var d=c.dispatch;if(null!==dg){var e=dg.get(c);if(void 0!==e){dg.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
	d){var h=e=null,l=d,k=!1;do{var m=l.expirationTime;m<Wf?(k||(k=!0,h=g,e=f),m>$f&&($f=m)):f=l.eagerReducer===a?l.eagerState:a(f,l.action);g=l;l=l.next}while(null!==l&&l!==d);k||(h=g,e=f);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
	function rg(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===ag?(ag={lastEffect:null},ag.lastEffect=a.next=a):(b=ag.lastEffect,null===b?ag.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,ag.lastEffect=a));return a}function sg(a,b,c,d){var e=mg();bg|=a;e.memoizedState=rg(b,c,void 0,void 0===d?null:d)}
	function tg(a,b,c,d){var e=ng();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&gg(d,g.deps)){rg(Nf,c,f,d);return}}bg|=a;e.memoizedState=rg(b,c,f,d)}function ug(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function vg(){}
	function wg(a,b,c){25>eg?void 0:x("301");var d=a.alternate;if(a===Xf||null!==d&&d===Xf)if(cg=!0,a={expirationTime:Wf,action:c,eagerReducer:null,eagerState:null,next:null},null===dg&&(dg=new Map),c=dg.get(b),void 0===c)dg.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{of();var e=lf();e=mf(e,a);var f={expirationTime:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===
	d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var l=b.lastRenderedState,k=d(l,c);f.eagerReducer=d;f.eagerState=k;if(bd(k,l))return}catch(m){}finally{}qf(a,e)}}
	var kg={readContext:M,useCallback:fg,useContext:fg,useEffect:fg,useImperativeHandle:fg,useLayoutEffect:fg,useMemo:fg,useReducer:fg,useRef:fg,useState:fg,useDebugValue:fg},ig={readContext:M,useCallback:function(a,b){mg().memoizedState=[a,void 0===b?null:b];return a},useContext:M,useEffect:function(a,b){return sg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return sg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,b){return sg(4,Pf|Sf,a,b)},
	useMemo:function(a,b){var c=mg();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=mg();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=wg.bind(null,Xf,a);return[d.memoizedState,a]},useRef:function(a){var b=mg();a={current:a};return b.memoizedState=a},useState:function(a){var b=mg();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,
	lastRenderedReducer:og,lastRenderedState:a};a=a.dispatch=wg.bind(null,Xf,a);return[b.memoizedState,a]},useDebugValue:vg},jg={readContext:M,useCallback:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];c.memoizedState=[a,b];return a},useContext:M,useEffect:function(a,b){return tg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return tg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,
	b){return tg(4,Pf|Sf,a,b)},useMemo:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:pg,useRef:function(){return ng().memoizedState},useState:function(a){return pg(og,a)},useDebugValue:vg},xg=null,yg=null,zg=!1;
	function Ag(a,b){var c=K(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function Bg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function Cg(a){if(zg){var b=yg;if(b){var c=b;if(!Bg(a,b)){b=De(c);if(!b||!Bg(a,b)){a.effectTag|=2;zg=!1;xg=a;return}Ag(xg,c)}xg=a;yg=Ee(b)}else a.effectTag|=2,zg=!1,xg=a}}function Dg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&18!==a.tag;)a=a.return;xg=a}function Eg(a){if(a!==xg)return!1;if(!zg)return Dg(a),zg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!xe(b,a.memoizedProps))for(b=yg;b;)Ag(a,b),b=De(b);Dg(a);yg=xg?De(a.stateNode):null;return!0}function Fg(){yg=xg=null;zg=!1}
	var Gg=Tb.ReactCurrentOwner,qg=!1;function S(a,b,c,d){b.child=null===a?Ef(b,null,c,d):Df(b,a.child,c,d)}function Hg(a,b,c,d,e){c=c.render;var f=b.ref;Ig(b,e);d=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,d,e);return b.child}
	function Kg(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!Ve(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,Lg(a,b,g,d,e,f);a=Ye(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:dd,c(e,d)&&a.ref===b.ref))return Jg(a,b,f);b.effectTag|=1;a=Xe(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
	function Lg(a,b,c,d,e,f){return null!==a&&dd(a.memoizedProps,d)&&a.ref===b.ref&&(qg=!1,e<f)?Jg(a,b,f):Mg(a,b,c,d,f)}function Ng(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Mg(a,b,c,d,e){var f=J(c)?Ie:H.current;f=Je(b,f);Ig(b,e);c=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,c,e);return b.child}
	function Og(a,b,c,d,e){if(J(c)){var f=!0;Oe(b)}else f=!1;Ig(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),vf(b,c,d,e),xf(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var l=g.context,k=c.contextType;"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k);Pg=!1;var t=b.memoizedState;l=g.state=t;var A=b.updateQueue;null!==A&&(yf(b,A,d,g,e),l=b.memoizedState);h!==d||t!==l||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),l=b.memoizedState),(h=Pg||uf(b,c,h,d,t,l,k))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
	g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=l),g.props=d,g.state=l,g.context=k,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:L(b.type,h),l=g.context,k=c.contextType,"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k)),m=c.getDerivedStateFromProps,(p="function"===
	typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k),Pg=!1,l=b.memoizedState,t=g.state=l,A=b.updateQueue,null!==A&&(yf(b,A,d,g,e),t=b.memoizedState),h!==d||l!==t||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),t=b.memoizedState),(m=Pg||uf(b,c,h,d,l,t,k))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===
	typeof g.componentWillUpdate&&g.componentWillUpdate(d,t,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,t,k)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=
	t),g.props=d,g.state=t,g.context=k,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),d=!1);return Qg(a,b,c,d,f,e)}
	function Qg(a,b,c,d,e,f){Ng(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Pe(b,c,!1),Jg(a,b,f);d=b.stateNode;Gg.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Df(b,a.child,null,f),b.child=Df(b,null,h,f)):S(a,b,h,f);b.memoizedState=d.state;e&&Pe(b,c,!0);return b.child}function Rg(a){var b=a.stateNode;b.pendingContext?Me(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Me(a,b.context,!1);Jf(a,b.containerInfo)}
	function Sg(a,b,c){var d=b.mode,e=b.pendingProps,f=b.memoizedState;if(0===(b.effectTag&64)){f=null;var g=!1}else f={timedOutAt:null!==f?f.timedOutAt:0},g=!0,b.effectTag&=-65;if(null===a)if(g){var h=e.fallback;a=Ze(null,d,0,null);0===(b.mode&1)&&(a.child=null!==b.memoizedState?b.child.child:b.child);d=Ze(h,d,c,null);a.sibling=d;c=a;c.return=d.return=b}else c=d=Ef(b,null,e.children,c);else null!==a.memoizedState?(d=a.child,h=d.sibling,g?(c=e.fallback,e=Xe(d,d.pendingProps,0),0===(b.mode&1)&&(g=null!==
	b.memoizedState?b.child.child:b.child,g!==d.child&&(e.child=g)),d=e.sibling=Xe(h,c,h.expirationTime),c=e,e.childExpirationTime=0,c.return=d.return=b):c=d=Df(b,d.child,e.children,c)):(h=a.child,g?(g=e.fallback,e=Ze(null,d,0,null),e.child=h,0===(b.mode&1)&&(e.child=null!==b.memoizedState?b.child.child:b.child),d=e.sibling=Ze(g,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=Df(b,h,e.children,c)),b.stateNode=a.stateNode;b.memoizedState=f;b.child=c;return d}
	function Jg(a,b,c){null!==a&&(b.contextDependencies=a.contextDependencies);if(b.childExpirationTime<c)return null;null!==a&&b.child!==a.child?x("153"):void 0;if(null!==b.child){a=b.child;c=Xe(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Xe(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
	function Tg(a,b,c){var d=b.expirationTime;if(null!==a)if(a.memoizedProps!==b.pendingProps||I.current)qg=!0;else{if(d<c){qg=!1;switch(b.tag){case 3:Rg(b);Fg();break;case 5:Lf(b);break;case 1:J(b.type)&&Oe(b);break;case 4:Jf(b,b.stateNode.containerInfo);break;case 10:Ug(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return Sg(a,b,c);b=Jg(a,b,c);return null!==b?b.sibling:null}}return Jg(a,b,c)}}else qg=!1;b.expirationTime=0;switch(b.tag){case 2:d=
	b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=Je(b,H.current);Ig(b,c);e=hg(null,b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;lg();if(J(d)){var f=!0;Oe(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&kf(b,d,g,a);e.updater=tf;b.stateNode=e;e._reactInternalFiber=b;xf(b,d,a,c);b=Qg(null,b,d,!0,f,
	c)}else b.tag=0,S(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);f=b.pendingProps;a=hf(e);b.type=a;e=b.tag=We(a);f=L(a,f);g=void 0;switch(e){case 0:g=Mg(null,b,a,f,c);break;case 1:g=Og(null,b,a,f,c);break;case 11:g=Hg(null,b,a,f,c);break;case 14:g=Kg(null,b,a,L(a.type,f),d,c);break;default:x("306",a,"")}return g;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Mg(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,
	e=b.elementType===d?e:L(d,e),Og(a,b,d,e,c);case 3:Rg(b);d=b.updateQueue;null===d?x("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;yf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)Fg(),b=Jg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)yg=Ee(b.stateNode.containerInfo),xg=b,e=zg=!0;e?(b.effectTag|=2,b.child=Ef(b,null,d,c)):(S(a,b,d,c),Fg());b=b.child}return b;case 5:return Lf(b),null===a&&Cg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,
	g=e.children,xe(d,e)?g=null:null!==f&&xe(d,f)&&(b.effectTag|=16),Ng(a,b),1!==c&&b.mode&1&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(S(a,b,g,c),b=b.child),b;case 6:return null===a&&Cg(b),null;case 13:return Sg(a,b,c);case 4:return Jf(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Df(b,null,d,c):S(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Hg(a,b,d,e,c);case 7:return S(a,b,b.pendingProps,c),b.child;case 8:return S(a,b,b.pendingProps.children,
	c),b.child;case 12:return S(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;Ug(b,f);if(null!==g){var h=g.value;f=bd(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!I.current){b=Jg(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var l=h.contextDependencies;if(null!==l){g=h.child;for(var k=l.first;null!==k;){if(k.context===d&&0!==
	(k.observedBits&f)){1===h.tag&&(k=nf(c),k.tag=sf,pf(h,k));h.expirationTime<c&&(h.expirationTime=c);k=h.alternate;null!==k&&k.expirationTime<c&&(k.expirationTime=c);k=c;for(var m=h.return;null!==m;){var p=m.alternate;if(m.childExpirationTime<k)m.childExpirationTime=k,null!==p&&p.childExpirationTime<k&&(p.childExpirationTime=k);else if(null!==p&&p.childExpirationTime<k)p.childExpirationTime=k;else break;m=m.return}l.expirationTime<c&&(l.expirationTime=c);break}k=k.next}}else g=10===h.tag?h.type===b.type?
	null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}S(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Ig(b,c),e=M(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,S(a,b,d,c),b.child;case 14:return e=b.type,f=L(e,b.pendingProps),f=L(e.type,f),Kg(a,b,e,f,d,c);case 15:return Lg(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===
	d?e:L(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,J(d)?(a=!0,Oe(b)):a=!1,Ig(b,c),vf(b,d,e,c),xf(b,d,e,c),Qg(null,b,d,!0,a,c)}x("156")}var Vg={current:null},Wg=null,Xg=null,Yg=null;function Ug(a,b){var c=a.type._context;G(Vg,c._currentValue,a);c._currentValue=b}function Zg(a){var b=Vg.current;F(Vg,a);a.type._context._currentValue=b}function Ig(a,b){Wg=a;Yg=Xg=null;var c=a.contextDependencies;null!==c&&c.expirationTime>=b&&(qg=!0);a.contextDependencies=null}
	function M(a,b){if(Yg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)Yg=a,b=1073741823;b={context:a,observedBits:b,next:null};null===Xg?(null===Wg?x("308"):void 0,Xg=b,Wg.contextDependencies={first:b,expirationTime:0}):Xg=Xg.next=b}return a._currentValue}var $g=0,rf=1,sf=2,ah=3,Pg=!1;function bh(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
	function ch(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function nf(a){return{expirationTime:a,tag:$g,payload:null,callback:null,next:null,nextEffect:null}}function dh(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
	function pf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=bh(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=bh(a.memoizedState),e=c.updateQueue=bh(c.memoizedState)):d=a.updateQueue=ch(e):null===e&&(e=c.updateQueue=ch(d));null===e||d===e?dh(d,b):null===d.lastUpdate||null===e.lastUpdate?(dh(d,b),dh(e,b)):(dh(d,b),e.lastUpdate=b)}
	function eh(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=bh(a.memoizedState):fh(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function fh(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=ch(b));return b}
	function gh(a,b,c,d,e,f){switch(c.tag){case rf:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case ah:a.effectTag=a.effectTag&-2049|64;case $g:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case sf:Pg=!0}return d}
	function yf(a,b,c,d,e){Pg=!1;b=fh(a,b);for(var f=b.baseState,g=null,h=0,l=b.firstUpdate,k=f;null!==l;){var m=l.expirationTime;m<e?(null===g&&(g=l,f=k),h<m&&(h=m)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=32,l.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=l:(b.lastEffect.nextEffect=l,b.lastEffect=l)));l=l.next}m=null;for(l=b.firstCapturedUpdate;null!==l;){var p=l.expirationTime;p<e?(null===m&&(m=l,null===g&&(f=k)),h<p&&(h=p)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=
	32,l.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=l:(b.lastCapturedEffect.nextEffect=l,b.lastCapturedEffect=l)));l=l.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=k);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=k}
	function hh(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);ih(b.firstEffect,c);b.firstEffect=b.lastEffect=null;ih(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function ih(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?x("191",c):void 0;c.call(d)}a=a.nextEffect}}
	function jh(a,b){return{value:a,source:b,stack:jc(b)}}function kh(a){a.effectTag|=4}var lh=void 0,mh=void 0,nh=void 0,oh=void 0;lh=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};mh=function(){};
	nh=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;If(N.current);a=null;switch(c){case "input":f=vc(g,f);d=vc(g,d);a=[];break;case "option":f=$d(g,f);d=$d(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=be(g,f);d=be(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=te)}qe(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
	c){var l=f[c];for(g in l)l.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(ra.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var k=d[c];l=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&k!==l&&(null!=k||null!=l))if("style"===c)if(l){for(g in l)!l.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in k)k.hasOwnProperty(g)&&l[g]!==k[g]&&(h||
	(h={}),h[g]=k[g])}else h||(a||(a=[]),a.push(c,h)),h=k;else"dangerouslySetInnerHTML"===c?(k=k?k.__html:void 0,l=l?l.__html:void 0,null!=k&&l!==k&&(a=a||[]).push(c,""+k)):"children"===c?l===k||"string"!==typeof k&&"number"!==typeof k||(a=a||[]).push(c,""+k):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(ra.hasOwnProperty(c)?(null!=k&&se(e,c),a||l===k||(a=[])):(a=a||[]).push(c,k))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&kh(b)}};oh=function(a,b,c,d){c!==d&&kh(b)};
	var ph="function"===typeof WeakSet?WeakSet:Set;function qh(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=jc(c));null!==c&&ic(c.type);b=b.value;null!==a&&1===a.tag&&ic(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function rh(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){sh(a,c)}else b.current=null}
	function th(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if((d.tag&a)!==Nf){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}(d.tag&b)!==Nf&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
	function uh(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d.style.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=ne("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if(13===c.tag&&null!==c.memoizedState){d=c.child.sibling;d.return=c;c=d;continue}else if(null!==c.child){c.child.return=c;c=c.child;continue}if(c===a)break;for(;null===c.sibling;){if(null===c.return||
	c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
	function vh(a){"function"===typeof Re&&Re(a);switch(a.tag){case 0:case 11:case 14:case 15:var b=a.updateQueue;if(null!==b&&(b=b.lastEffect,null!==b)){var c=b=b.next;do{var d=c.destroy;if(void 0!==d){var e=a;try{d()}catch(f){sh(e,f)}}c=c.next}while(c!==b)}break;case 1:rh(a);b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(f){sh(a,f)}break;case 5:rh(a);break;case 4:wh(a)}}
	function xh(a){return 5===a.tag||3===a.tag||4===a.tag}
	function yh(a){a:{for(var b=a.return;null!==b;){if(xh(b)){var c=b;break a}b=b.return}x("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:x("161")}c.effectTag&16&&(ke(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||xh(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&
	2)continue b;if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(g=b,h=e.stateNode,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=te)):b.appendChild(e.stateNode);
	else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
	function wh(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?x("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(vh(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
	(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag){if(null!==b.child){d=b.stateNode.containerInfo;e=!0;b.child.return=b;b=b.child;continue}}else if(vh(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
	function zh(a,b){switch(b.tag){case 0:case 11:case 14:case 15:th(Pf,Qf,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&Ce(c,f,e,a,d,b)}break;case 6:null===b.stateNode?x("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b.memoizedState;d=void 0;a=b;null===c?d=!1:(d=!0,a=b.child,0===c.timedOutAt&&(c.timedOutAt=lf()));null!==a&&uh(a,d);c=
	b.updateQueue;if(null!==c){b.updateQueue=null;var g=b.stateNode;null===g&&(g=b.stateNode=new ph);c.forEach(function(a){var c=Ah.bind(null,b,a);g.has(a)||(g.add(a),a.then(c,c))})}break;case 17:break;default:x("163")}}var Bh="function"===typeof WeakMap?WeakMap:Map;function Ch(a,b,c){c=nf(c);c.tag=ah;c.payload={element:null};var d=b.value;c.callback=function(){Dh(d);qh(a,b)};return c}
	function Eh(a,b,c){c=nf(c);c.tag=ah;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Fh?Fh=new Set([this]):Fh.add(this));var c=b.value,e=b.stack;qh(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
	function Gh(a){switch(a.tag){case 1:J(a.type)&&Ke(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:return Kf(a),Le(a),b=a.effectTag,0!==(b&64)?x("285"):void 0,a.effectTag=b&-2049|64,a;case 5:return Mf(a),null;case 13:return b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 18:return null;case 4:return Kf(a),null;case 10:return Zg(a),null;default:return null}}
	var Hh=Tb.ReactCurrentDispatcher,Ih=Tb.ReactCurrentOwner,Jh=1073741822,Kh=!1,T=null,Lh=null,U=0,Mh=-1,Nh=!1,V=null,Oh=!1,Ph=null,Qh=null,Rh=null,Fh=null;function Sh(){if(null!==T)for(var a=T.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Ke(b);break;case 3:Kf(b);Le(b);break;case 5:Mf(b);break;case 4:Kf(b);break;case 10:Zg(b)}a=a.return}Lh=null;U=0;Mh=-1;Nh=!1;T=null}
	function Th(){for(;null!==V;){var a=V.effectTag;a&16&&ke(V.stateNode,"");if(a&128){var b=V.alternate;null!==b&&(b=b.ref,null!==b&&("function"===typeof b?b(null):b.current=null))}switch(a&14){case 2:yh(V);V.effectTag&=-3;break;case 6:yh(V);V.effectTag&=-3;zh(V.alternate,V);break;case 4:zh(V.alternate,V);break;case 8:a=V,wh(a),a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null,a=a.alternate,null!==a&&(a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null)}V=V.nextEffect}}
	function Uh(){for(;null!==V;){if(V.effectTag&256)a:{var a=V.alternate,b=V;switch(b.tag){case 0:case 11:case 15:th(Of,Nf,b);break a;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:L(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break a;case 3:case 5:case 6:case 4:case 17:break a;default:x("163")}}V=V.nextEffect}}
	function Vh(a,b){for(;null!==V;){var c=V.effectTag;if(c&36){var d=V.alternate,e=V,f=b;switch(e.tag){case 0:case 11:case 15:th(Rf,Sf,e);break;case 1:var g=e.stateNode;if(e.effectTag&4)if(null===d)g.componentDidMount();else{var h=e.elementType===e.type?d.memoizedProps:L(e.type,d.memoizedProps);g.componentDidUpdate(h,d.memoizedState,g.__reactInternalSnapshotBeforeUpdate)}d=e.updateQueue;null!==d&&hh(e,d,g,f);break;case 3:d=e.updateQueue;if(null!==d){g=null;if(null!==e.child)switch(e.child.tag){case 5:g=
	e.child.stateNode;break;case 1:g=e.child.stateNode}hh(e,d,g,f)}break;case 5:f=e.stateNode;null===d&&e.effectTag&4&&we(e.type,e.memoizedProps)&&f.focus();break;case 6:break;case 4:break;case 12:break;case 13:break;case 17:break;default:x("163")}}c&128&&(e=V.ref,null!==e&&(f=V.stateNode,"function"===typeof e?e(f):e.current=f));c&512&&(Ph=a);V=V.nextEffect}}
	function Wh(a,b){Rh=Qh=Ph=null;var c=W;W=!0;do{if(b.effectTag&512){var d=!1,e=void 0;try{var f=b;th(Uf,Nf,f);th(Nf,Tf,f)}catch(g){d=!0,e=g}d&&sh(b,e)}b=b.nextEffect}while(null!==b);W=c;c=a.expirationTime;0!==c&&Xh(a,c);X||W||Yh(1073741823,!1)}function of(){null!==Qh&&Be(Qh);null!==Rh&&Rh()}
	function Zh(a,b){Oh=Kh=!0;a.current===b?x("177"):void 0;var c=a.pendingCommitExpirationTime;0===c?x("261"):void 0;a.pendingCommitExpirationTime=0;var d=b.expirationTime,e=b.childExpirationTime;ef(a,e>d?e:d);Ih.current=null;d=void 0;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;ue=Bd;ve=Pd();Bd=!1;for(V=d;null!==V;){e=!1;var f=void 0;try{Uh()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}for(V=d;null!==V;){e=!1;
	f=void 0;try{Th()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}Qd(ve);ve=null;Bd=!!ue;ue=null;a.current=b;for(V=d;null!==V;){e=!1;f=void 0;try{Vh(a,c)}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}if(null!==d&&null!==Ph){var g=Wh.bind(null,a,d);Qh=r.unstable_runWithPriority(r.unstable_NormalPriority,function(){return Ae(g)});Rh=g}Kh=Oh=!1;"function"===typeof Qe&&Qe(b.stateNode);c=b.expirationTime;b=b.childExpirationTime;b=
	b>c?b:c;0===b&&(Fh=null);$h(a,b)}
	function ai(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&1024)){T=a;a:{var e=b;b=a;var f=U;var g=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:J(b.type)&&Ke(b);break;case 3:Kf(b);Le(b);g=b.stateNode;g.pendingContext&&(g.context=g.pendingContext,g.pendingContext=null);if(null===e||null===e.child)Eg(b),b.effectTag&=-3;mh(b);break;case 5:Mf(b);var h=If(Hf.current);f=b.type;if(null!==e&&null!=b.stateNode)nh(e,b,f,g,h),e.ref!==b.ref&&(b.effectTag|=
	128);else if(g){var l=If(N.current);if(Eg(b)){g=b;e=g.stateNode;var k=g.type,m=g.memoizedProps,p=h;e[Fa]=g;e[Ga]=m;f=void 0;h=k;switch(h){case "iframe":case "object":E("load",e);break;case "video":case "audio":for(k=0;k<ab.length;k++)E(ab[k],e);break;case "source":E("error",e);break;case "img":case "image":case "link":E("error",e);E("load",e);break;case "form":E("reset",e);E("submit",e);break;case "details":E("toggle",e);break;case "input":wc(e,m);E("invalid",e);se(p,"onChange");break;case "select":e._wrapperState=
	{wasMultiple:!!m.multiple};E("invalid",e);se(p,"onChange");break;case "textarea":ce(e,m),E("invalid",e),se(p,"onChange")}qe(h,m);k=null;for(f in m)m.hasOwnProperty(f)&&(l=m[f],"children"===f?"string"===typeof l?e.textContent!==l&&(k=["children",l]):"number"===typeof l&&e.textContent!==""+l&&(k=["children",""+l]):ra.hasOwnProperty(f)&&null!=l&&se(p,f));switch(h){case "input":Rb(e);Ac(e,m,!0);break;case "textarea":Rb(e);ee(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
	(e.onclick=te)}f=k;g.updateQueue=f;g=null!==f?!0:!1;g&&kh(b)}else{m=b;p=f;e=g;k=9===h.nodeType?h:h.ownerDocument;l===fe.html&&(l=ge(p));l===fe.html?"script"===p?(e=k.createElement("div"),e.innerHTML="<script>\x3c/script>",k=e.removeChild(e.firstChild)):"string"===typeof e.is?k=k.createElement(p,{is:e.is}):(k=k.createElement(p),"select"===p&&(p=k,e.multiple?p.multiple=!0:e.size&&(p.size=e.size))):k=k.createElementNS(l,p);e=k;e[Fa]=m;e[Ga]=g;lh(e,b,!1,!1);p=e;k=f;m=g;var t=h,A=re(k,m);switch(k){case "iframe":case "object":E("load",
	p);h=m;break;case "video":case "audio":for(h=0;h<ab.length;h++)E(ab[h],p);h=m;break;case "source":E("error",p);h=m;break;case "img":case "image":case "link":E("error",p);E("load",p);h=m;break;case "form":E("reset",p);E("submit",p);h=m;break;case "details":E("toggle",p);h=m;break;case "input":wc(p,m);h=vc(p,m);E("invalid",p);se(t,"onChange");break;case "option":h=$d(p,m);break;case "select":p._wrapperState={wasMultiple:!!m.multiple};h=n({},m,{value:void 0});E("invalid",p);se(t,"onChange");break;case "textarea":ce(p,
	m);h=be(p,m);E("invalid",p);se(t,"onChange");break;default:h=m}qe(k,h);l=void 0;var v=k,R=p,u=h;for(l in u)if(u.hasOwnProperty(l)){var q=u[l];"style"===l?oe(R,q):"dangerouslySetInnerHTML"===l?(q=q?q.__html:void 0,null!=q&&je(R,q)):"children"===l?"string"===typeof q?("textarea"!==v||""!==q)&&ke(R,q):"number"===typeof q&&ke(R,""+q):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ra.hasOwnProperty(l)?null!=q&&se(t,l):null!=q&&tc(R,l,q,A))}switch(k){case "input":Rb(p);
	Ac(p,m,!1);break;case "textarea":Rb(p);ee(p,m);break;case "option":null!=m.value&&p.setAttribute("value",""+uc(m.value));break;case "select":h=p;h.multiple=!!m.multiple;p=m.value;null!=p?ae(h,!!m.multiple,p,!1):null!=m.defaultValue&&ae(h,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof h.onClick&&(p.onclick=te)}(g=we(f,g))&&kh(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?x("166"):void 0;break;case 6:e&&null!=b.stateNode?oh(e,b,e.memoizedProps,g):("string"!==
	typeof g&&(null===b.stateNode?x("166"):void 0),e=If(Hf.current),If(N.current),Eg(b)?(g=b,f=g.stateNode,e=g.memoizedProps,f[Fa]=g,(g=f.nodeValue!==e)&&kh(b)):(f=b,g=(9===e.nodeType?e:e.ownerDocument).createTextNode(g),g[Fa]=b,f.stateNode=g));break;case 11:break;case 13:g=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=f;T=b;break a}g=null!==g;f=null!==e&&null!==e.memoizedState;null!==e&&!g&&f&&(e=e.child.sibling,null!==e&&(h=b.firstEffect,null!==h?(b.firstEffect=e,e.nextEffect=h):(b.firstEffect=
	b.lastEffect=e,e.nextEffect=null),e.effectTag=8));if(g||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Kf(b);mh(b);break;case 10:Zg(b);break;case 9:break;case 14:break;case 17:J(b.type)&&Ke(b);break;case 18:break;default:x("156")}T=null}b=a;if(1===U||1!==b.childExpirationTime){g=0;for(f=b.child;null!==f;)e=f.expirationTime,h=f.childExpirationTime,e>g&&(g=e),h>g&&(g=h),f=f.sibling;b.childExpirationTime=g}if(null!==T)return T;null!==c&&0===(c.effectTag&1024)&&(null===c.firstEffect&&
	(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Gh(a,U);if(null!==a)return a.effectTag&=1023,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=1024)}if(null!==d)return d;if(null!==c)a=c;else break}return null}
	function bi(a){var b=Tg(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=ai(a));Ih.current=null;return b}
	function ci(a,b){Kh?x("243"):void 0;of();Kh=!0;var c=Hh.current;Hh.current=kg;var d=a.nextExpirationTimeToWorkOn;if(d!==U||a!==Lh||null===T)Sh(),Lh=a,U=d,T=Xe(Lh.current,null,U),a.pendingCommitExpirationTime=0;var e=!1;do{try{if(b)for(;null!==T&&!di();)T=bi(T);else for(;null!==T;)T=bi(T)}catch(u){if(Yg=Xg=Wg=null,lg(),null===T)e=!0,Dh(u);else{null===T?x("271"):void 0;var f=T,g=f.return;if(null===g)e=!0,Dh(u);else{a:{var h=a,l=g,k=f,m=u;g=U;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==
	m&&"object"===typeof m&&"function"===typeof m.then){var p=m;m=l;var t=-1,A=-1;do{if(13===m.tag){var v=m.alternate;if(null!==v&&(v=v.memoizedState,null!==v)){A=10*(1073741822-v.timedOutAt);break}v=m.pendingProps.maxDuration;if("number"===typeof v)if(0>=v)t=0;else if(-1===t||v<t)t=v}m=m.return}while(null!==m);m=l;do{if(v=13===m.tag)v=void 0===m.memoizedProps.fallback?!1:null===m.memoizedState;if(v){l=m.updateQueue;null===l?(l=new Set,l.add(p),m.updateQueue=l):l.add(p);if(0===(m.mode&1)){m.effectTag|=
	64;k.effectTag&=-1957;1===k.tag&&(null===k.alternate?k.tag=17:(g=nf(1073741823),g.tag=sf,pf(k,g)));k.expirationTime=1073741823;break a}k=h;l=g;var R=k.pingCache;null===R?(R=k.pingCache=new Bh,v=new Set,R.set(p,v)):(v=R.get(p),void 0===v&&(v=new Set,R.set(p,v)));v.has(l)||(v.add(l),k=ei.bind(null,k,p,l),p.then(k,k));-1===t?h=1073741823:(-1===A&&(A=10*(1073741822-gf(h,g))-5E3),h=A+t);0<=h&&Mh<h&&(Mh=h);m.effectTag|=2048;m.expirationTime=g;break a}m=m.return}while(null!==m);m=Error((ic(k.type)||"A React component")+
	" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+jc(k))}Nh=!0;m=jh(m,k);h=l;do{switch(h.tag){case 3:h.effectTag|=2048;h.expirationTime=g;g=Ch(h,m,g);eh(h,g);break a;case 1:if(t=m,A=h.type,k=h.stateNode,0===(h.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==k&&"function"===typeof k.componentDidCatch&&(null===Fh||!Fh.has(k)))){h.effectTag|=2048;
	h.expirationTime=g;g=Eh(h,t,g);eh(h,g);break a}}h=h.return}while(null!==h)}T=ai(f);continue}}}break}while(1);Kh=!1;Hh.current=c;Yg=Xg=Wg=null;lg();if(e)Lh=null,a.finishedWork=null;else if(null!==T)a.finishedWork=null;else{c=a.current.alternate;null===c?x("281"):void 0;Lh=null;if(Nh){e=a.latestPendingTime;f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e<d||0!==f&&f<d||0!==g&&g<d){ff(a,d);fi(a,c,d,a.expirationTime,-1);return}if(!a.didError&&b){a.didError=!0;d=a.nextExpirationTimeToWorkOn=d;
	b=a.expirationTime=1073741823;fi(a,c,d,b,-1);return}}b&&-1!==Mh?(ff(a,d),b=10*(1073741822-gf(a,d)),b<Mh&&(Mh=b),b=10*(1073741822-lf()),b=Mh-b,fi(a,c,d,a.expirationTime,0>b?0:b)):(a.pendingCommitExpirationTime=d,a.finishedWork=c)}}
	function sh(a,b){for(var c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Fh||!Fh.has(d))){a=jh(b,a);a=Eh(c,a,1073741823);pf(c,a);qf(c,1073741823);return}break;case 3:a=jh(b,a);a=Ch(c,a,1073741823);pf(c,a);qf(c,1073741823);return}c=c.return}3===a.tag&&(c=jh(b,a),c=Ch(a,c,1073741823),pf(a,c),qf(a,1073741823))}
	function mf(a,b){var c=r.unstable_getCurrentPriorityLevel(),d=void 0;if(0===(b.mode&1))d=1073741823;else if(Kh&&!Oh)d=U;else{switch(c){case r.unstable_ImmediatePriority:d=1073741823;break;case r.unstable_UserBlockingPriority:d=1073741822-10*(((1073741822-a+15)/10|0)+1);break;case r.unstable_NormalPriority:d=1073741822-25*(((1073741822-a+500)/25|0)+1);break;case r.unstable_LowPriority:case r.unstable_IdlePriority:d=1;break;default:x("313")}null!==Lh&&d===U&&--d}c===r.unstable_UserBlockingPriority&&
	(0===gi||d<gi)&&(gi=d);return d}function ei(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);if(null!==Lh&&U===c)Lh=null;else if(b=a.earliestSuspendedTime,d=a.latestSuspendedTime,0!==b&&c<=b&&c>=d){a.didError=!1;b=a.latestPingedTime;if(0===b||b>c)a.latestPingedTime=c;df(c,a);c=a.expirationTime;0!==c&&Xh(a,c)}}function Ah(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=lf();b=mf(b,a);a=hi(a,b);null!==a&&(cf(a,b),b=a.expirationTime,0!==b&&Xh(a,b))}
	function hi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return e}
	function qf(a,b){a=hi(a,b);null!==a&&(!Kh&&0!==U&&b>U&&Sh(),cf(a,b),Kh&&!Oh&&Lh===a||Xh(a,a.expirationTime),ii>ji&&(ii=0,x("185")))}function ki(a,b,c,d,e){return r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){return a(b,c,d,e)})}var li=null,Y=null,mi=0,ni=void 0,W=!1,oi=null,Z=0,gi=0,pi=!1,qi=null,X=!1,ri=!1,si=null,ti=r.unstable_now(),ui=1073741822-(ti/10|0),vi=ui,ji=50,ii=0,wi=null;function xi(){ui=1073741822-((r.unstable_now()-ti)/10|0)}
	function yi(a,b){if(0!==mi){if(b<mi)return;null!==ni&&r.unstable_cancelCallback(ni)}mi=b;a=r.unstable_now()-ti;ni=r.unstable_scheduleCallback(zi,{timeout:10*(1073741822-b)-a})}function fi(a,b,c,d,e){a.expirationTime=d;0!==e||di()?0<e&&(a.timeoutHandle=ye(Ai.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function Ai(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;xi();vi=ui;Bi(a,c)}function $h(a,b){a.expirationTime=b;a.finishedWork=null}
	function lf(){if(W)return vi;Ci();if(0===Z||1===Z)xi(),vi=ui;return vi}function Xh(a,b){null===a.nextScheduledRoot?(a.expirationTime=b,null===Y?(li=Y=a,a.nextScheduledRoot=a):(Y=Y.nextScheduledRoot=a,Y.nextScheduledRoot=li)):b>a.expirationTime&&(a.expirationTime=b);W||(X?ri&&(oi=a,Z=1073741823,Di(a,1073741823,!1)):1073741823===b?Yh(1073741823,!1):yi(a,b))}
	function Ci(){var a=0,b=null;if(null!==Y)for(var c=Y,d=li;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===Y?x("244"):void 0;if(d===d.nextScheduledRoot){li=Y=d.nextScheduledRoot=null;break}else if(d===li)li=e=d.nextScheduledRoot,Y.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===Y){Y=c;Y.nextScheduledRoot=li;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{e>a&&(a=e,b=d);if(d===Y)break;if(1073741823===
	a)break;c=d;d=d.nextScheduledRoot}}oi=b;Z=a}var Ei=!1;function di(){return Ei?!0:r.unstable_shouldYield()?Ei=!0:!1}function zi(){try{if(!di()&&null!==li){xi();var a=li;do{var b=a.expirationTime;0!==b&&ui<=b&&(a.nextExpirationTimeToWorkOn=ui);a=a.nextScheduledRoot}while(a!==li)}Yh(0,!0)}finally{Ei=!1}}
	function Yh(a,b){Ci();if(b)for(xi(),vi=ui;null!==oi&&0!==Z&&a<=Z&&!(Ei&&ui>Z);)Di(oi,Z,ui>Z),Ci(),xi(),vi=ui;else for(;null!==oi&&0!==Z&&a<=Z;)Di(oi,Z,!1),Ci();b&&(mi=0,ni=null);0!==Z&&yi(oi,Z);ii=0;wi=null;if(null!==si)for(a=si,si=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){pi||(pi=!0,qi=d)}}if(pi)throw a=qi,qi=null,pi=!1,a;}function Bi(a,b){W?x("253"):void 0;oi=a;Z=b;Di(a,b,!1);Yh(1073741823,!1)}
	function Di(a,b,c){W?x("245"):void 0;W=!0;if(c){var d=a.finishedWork;null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&(di()?a.finishedWork=d:Fi(a,d,b)))}else d=a.finishedWork,null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&Fi(a,d,b));W=!1}
	function Fi(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime>=c&&(null===si?si=[d]:si.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===wi?ii++:(wi=a,ii=0);r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){Zh(a,b)})}function Dh(a){null===oi?x("246"):void 0;oi.expirationTime=0;pi||(pi=!0,qi=a)}function Gi(a,b){var c=X;X=!0;try{return a(b)}finally{(X=c)||W||Yh(1073741823,!1)}}
	function Hi(a,b){if(X&&!ri){ri=!0;try{return a(b)}finally{ri=!1}}return a(b)}function Ii(a,b,c){X||W||0===gi||(Yh(gi,!1),gi=0);var d=X;X=!0;try{return r.unstable_runWithPriority(r.unstable_UserBlockingPriority,function(){return a(b,c)})}finally{(X=d)||W||Yh(1073741823,!1)}}
	function Ji(a,b,c,d,e){var f=b.current;a:if(c){c=c._reactInternalFiber;b:{2===ed(c)&&1===c.tag?void 0:x("170");var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(J(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);x("171");g=void 0}if(1===c.tag){var h=c.type;if(J(h)){c=Ne(c,h,g);break a}}c=g}else c=He;null===b.context?b.context=c:b.pendingContext=c;b=e;e=nf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
	of();pf(f,e);qf(f,d);return d}function Ki(a,b,c,d){var e=b.current,f=lf();e=mf(f,e);return Ji(a,b,c,e,d)}function Li(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Mi(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Wb,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	Ab=function(a,b,c){switch(b){case "input":yc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Ka(d);e?void 0:x("90");Sb(d);yc(d,e)}}}break;case "textarea":de(a,c);break;case "select":b=c.value,null!=b&&ae(a,!!c.multiple,b,!1)}};
	function Ni(a){var b=1073741822-25*(((1073741822-lf()+500)/25|0)+1);b>=Jh&&(b=Jh-1);this._expirationTime=Jh=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Ni.prototype.render=function(a){this._defer?void 0:x("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Oi;Ji(a,b,null,c,d._onCommit);return d};
	Ni.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	Ni.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:x("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?x("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Bi(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
	null,this._defer=!1};Ni.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Oi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Oi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	Oi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?x("191",c):void 0;c()}}};
	function Pi(a,b,c){b=K(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pingCache:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
	Pi.prototype.render=function(a,b){var c=this._internalRoot,d=new Oi;b=void 0===b?null:b;null!==b&&d.then(b);Ki(a,c,null,d._onCommit);return d};Pi.prototype.unmount=function(a){var b=this._internalRoot,c=new Oi;a=void 0===a?null:a;null!==a&&c.then(a);Ki(null,b,null,c._onCommit);return c};Pi.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new Oi;c=void 0===c?null:c;null!==c&&e.then(c);Ki(b,d,a,e._onCommit);return e};
	Pi.prototype.createBatch=function(){var a=new Ni(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function Qi(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Gb=Gi;Hb=Ii;Ib=function(){W||0===gi||(Yh(gi,!1),gi=0)};
	function Ri(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Pi(a,!1,b)}
	function Si(a,b,c,d,e){var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=Li(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Ri(c,d);if("function"===typeof e){var h=e;e=function(){var a=Li(f._internalRoot);h.call(a)}}Hi(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return Li(f._internalRoot)}
	function Ti(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Qi(b)?void 0:x("200");return Mi(a,b,null,c)}
	var Vi={createPortal:Ti,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?x("188"):x("268",Object.keys(a)));a=hd(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!0,c)},render:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){Qi(c)?void 0:x("200");null==a||void 0===a._reactInternalFiber?
	x("38"):void 0;return Si(a,b,c,!1,d)},unmountComponentAtNode:function(a){Qi(a)?void 0:x("40");return a._reactRootContainer?(Hi(function(){Si(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Ti.apply(void 0,arguments)},unstable_batchedUpdates:Gi,unstable_interactiveUpdates:Ii,flushSync:function(a,b){W?x("187"):void 0;var c=X;X=!0;try{return ki(a,b)}finally{X=c,Yh(1073741823,!1)}},unstable_createRoot:Ui,unstable_flushControlled:function(a){var b=
	X;X=!0;try{ki(a)}finally{(X=b)||W||Yh(1073741823,!1)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ia,Ja,Ka,Ba.injectEventPluginsByName,pa,Qa,function(a){ya(a,Pa)},Eb,Fb,Dd,Da]}};function Ui(a,b){Qi(a)?void 0:x("299","unstable_createRoot");return new Pi(a,!0,null!=b&&!0===b.hydrate)}
	(function(a){var b=a.findFiberByHostInstance;return Te(n({},a,{overrideProps:null,currentDispatcherRef:Tb.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ha,bundleType:0,version:"16.8.6",rendererPackageName:"react-dom"});var Wi={default:Vi},Xi=Wi&&Vi||Wi;module.exports=Xi.default||Xi;


/***/ },
/* 1998 */
1762,
/* 1999 */
1763,
/* 2000 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _Wrap = _interopRequireDefault(__webpack_require__(904));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = _Wrap.default;
	exports.default = _default;

/***/ },
/* 2001 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Wrap = _interopRequireDefault(__webpack_require__(904));
	
	var _Radio = _interopRequireDefault(__webpack_require__(2002));
	
	var _decorator = _interopRequireDefault(__webpack_require__(2003));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = (0, _decorator.default)({
	  type: 'text',
	  component: _Radio.default
	})(_Wrap.default);
	
	exports.default = _default;

/***/ },
/* 2002 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(905));
	
	var _Col = _interopRequireDefault(__webpack_require__(504));
	
	var _Row = _interopRequireDefault(__webpack_require__(893));
	
	var _Alert = _interopRequireDefault(__webpack_require__(867));
	
	var _Radio = _interopRequireDefault(__webpack_require__(892));
	
	var _FormControl = _interopRequireDefault(__webpack_require__(506));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(311));
	
	var _get2 = _interopRequireDefault(__webpack_require__(310));
	
	var _map2 = _interopRequireDefault(__webpack_require__(859));
	
	var _chunk2 = _interopRequireDefault(__webpack_require__(1889));
	
	var _filter2 = _interopRequireDefault(__webpack_require__(858));
	
	var _includes2 = _interopRequireDefault(__webpack_require__(1893));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(89));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var RadioBinder =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(RadioBinder, _React$Component);
	
	  function RadioBinder() {
	    var _this;
	
	    _classCallCheck(this, RadioBinder);
	
	    _this = _possibleConstructorReturn(this, (RadioBinder.__proto__ || Object.getPrototypeOf(RadioBinder)).call(this));
	    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
	    _this.searchBox = _this.searchBox.bind(_assertThisInitialized(_this));
	    _this.radioButtons = _this.radioButtons.bind(_assertThisInitialized(_this));
	    _this.radioButtonList = _this.radioButtonList.bind(_assertThisInitialized(_this));
	    _this.filtered = _this.filtered.bind(_assertThisInitialized(_this));
	    _this.state = {
	      value: ''
	    };
	    return _this;
	  }
	
	  _createClass(RadioBinder, [{
	    key: "handleChange",
	    value: function handleChange(e) {
	      if (e.keyCode === 13) {
	        e.preventDefault();
	        e.stopPropagation();
	      }
	
	      this.setState({
	        value: e.target.value
	      });
	    }
	  }, {
	    key: "handlePrevent",
	    value: function handlePrevent(e) {
	      if (e.keyCode === 13) {
	        e.preventDefault();
	        e.stopPropagation();
	      }
	    }
	  }, {
	    key: "filtered",
	    value: function filtered() {
	      var list = (0, _isArray2.default)(this.props.field.children) ? this.props.field.children : [this.props.field.children];
	
	      if ((0, _get2.default)(this.props.field, 'static', false) === true) {
	        return (0, _filter2.default)(list, {
	          value: this.props.input.value
	        });
	      }
	
	      var value = this.state.value;
	      var strValue = String(value).toLowerCase();
	
	      if (value !== '') {
	        return (0, _filter2.default)(list, function (option) {
	          return (0, _includes2.default)(String(option.children).toLowerCase(), strValue);
	        });
	      }
	
	      return list;
	    }
	  }, {
	    key: "radioButtonList",
	    value: function radioButtonList(list) {
	      var _this2 = this;
	
	      var staticField = this.context.isStatic || (0, _get2.default)(this.props.field, 'static', false);
	      return (0, _map2.default)(list, function (option, key) {
	        if (staticField === true) {
	          return _react.default.createElement(_FormControl.default.Static, {
	            key: key
	          }, option.children);
	        }
	
	        var disabled = false;
	
	        if (_this2.props.field && _this2.props.field.disabled && (0, _isFunction2.default)(_this2.props.field.disabled)) {
	          disabled = _this2.context.checkCondition(_this2.props.field.disabled(), (0, _get2.default)(_this2.props.field, 'parent'));
	        }
	
	        return _react.default.createElement(_Radio.default, {
	          key: key,
	          disabled: disabled,
	          name: "".concat(_this2.props.input.name, "[").concat(key, "]"),
	          value: option.props.value,
	          checked: String(_this2.props.input.value) === String(option.props.value),
	          onChange: function onChange(event) {
	            if (event.target.checked) {
	              return _this2.props.input.onChange(option.props.value);
	            }
	          }
	        }, option.props.children);
	      });
	    }
	  }, {
	    key: "radioButtons",
	    value: function radioButtons() {
	      var _this3 = this;
	
	      var filtered = this.filtered();
	      var field = (0, _get2.default)(this.props, 'field');
	
	      if (filtered.length === 0) {
	        return _react.default.createElement(_Alert.default, null, (0, _get2.default)(this.props.field, 'filter_norecords', 'No results'));
	      }
	
	      if (field.chunks) {
	        var split = Math.ceil(filtered.length / field.chunks);
	
	        var chunks = function chunks() {
	          var chunkData = (0, _chunk2.default)(filtered, split);
	          return (0, _map2.default)(chunkData, function (chunk, key) {
	            return _react.default.createElement(_Col.default, {
	              key: key,
	              md: Math.round(12 / field.chunks)
	            }, _this3.radioButtonList(chunk));
	          });
	        };
	
	        return _react.default.createElement(_Row.default, null, chunks());
	      }
	
	      return this.radioButtonList(filtered);
	    }
	  }, {
	    key: "searchBox",
	    value: function searchBox() {
	      var disabled = false;
	
	      if (this.props.field && this.props.field.disabled && (0, _isFunction2.default)(this.props.field.disabled)) {
	        disabled = this.context.checkCondition(this.props.field.disabled());
	      }
	
	      if ((this.props.field.searchable || this.props.field.filter) && !this.props.field.static && !this.context.isStatic) {
	        return _react.default.createElement("input", {
	          type: "text",
	          disabled: disabled,
	          placeholder: (0, _get2.default)(this.props.field, 'filter_placeholder', (0, _get2.default)(this.props.field.locale, 'filter.placeholder', 'Filter')),
	          defaultValue: this.state.value,
	          onKeyDown: this.handlePrevent,
	          onKeyUp: this.handleChange,
	          className: "form-control"
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react.default.createElement("div", null, this.searchBox(), this.radioButtons());
	    }
	  }]);
	
	  return RadioBinder;
	}(_react.default.Component);
	
	RadioBinder.propTypes = {
	  field: _propTypes.default.object,
	  input: _propTypes.default.object
	};
	RadioBinder.contextTypes = {
	  checkCondition: _propTypes.default.func,
	  isStatic: _propTypes.default.bool
	};
	
	var _default = function _default(_ref) {
	  var input = _ref.input,
	      field = _ref.field;
	  return _react.default.createElement(RadioBinder, {
	    input: input,
	    field: field
	  });
	};
	
	exports.default = _default;

/***/ },
/* 2003 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = connnectToConfirm;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function connnectToConfirm(conf) {
	  return function (WrappedComponent) {
	    var TmpComponent =
	    /*#__PURE__*/
	    function (_Component) {
	      _inherits(TmpComponent, _Component);
	
	      function TmpComponent() {
	        _classCallCheck(this, TmpComponent);
	
	        return _possibleConstructorReturn(this, (TmpComponent.__proto__ || Object.getPrototypeOf(TmpComponent)).apply(this, arguments));
	      }
	
	      _createClass(TmpComponent, [{
	        key: "render",
	        value: function render() {
	          return _react.default.createElement(WrappedComponent, _extends({}, this.props, conf));
	        }
	      }]);
	
	      return TmpComponent;
	    }(_react.Component);
	
	    return TmpComponent;
	  };
	}

/***/ },
/* 2004 */
[2242, 2005],
/* 2005 */
1016,
/* 2006 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var PropTypes = _interopDefault(__webpack_require__(2008));
	var finalForm = __webpack_require__(124);
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	//      
	function diffSubscription (a, b, keys) {
	  if (a) {
	    if (b) {
	      // $FlowFixMe
	      return keys.some(function (key) {
	        return a[key] !== b[key];
	      });
	    } else {
	      return true;
	    }
	  } else {
	    return !!b;
	  }
	}
	
	// children render function, or component prop
	
	function renderComponent(props, name) {
	  var render = props.render,
	      children = props.children,
	      component = props.component,
	      rest = _objectWithoutPropertiesLoose(props, ["render", "children", "component"]);
	
	  if (component) {
	    return React.createElement(component, _extends({}, rest, {
	      children: children,
	      render: render
	    }));
	  }
	
	  if (render) {
	    return render(_extends({}, rest, {
	      children: children
	    })); // inject children back in
	  }
	
	  if (typeof children !== 'function') {
	    // istanbul ignore next
	    if (false) {
	      console.error("Warning: Must specify either a render prop, a render function as children, or a component prop to " + name);
	    }
	
	    return null; // warning will alert developer to their mistake
	  }
	
	  return children(rest);
	}
	
	//      
	var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';
	
	//      
	var getSelectedValues = function getSelectedValues(options) {
	  var result = [];
	
	  if (options) {
	    for (var index = 0; index < options.length; index++) {
	      var option = options[index];
	
	      if (option.selected) {
	        result.push(option.value);
	      }
	    }
	  }
	
	  return result;
	};
	
	var getValue = function getValue(event, currentValue, valueProp, isReactNative) {
	  if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
	    return event.nativeEvent.text;
	  }
	
	  if (isReactNative && event.nativeEvent) {
	    return event.nativeEvent.text;
	  }
	
	  var detypedEvent = event;
	  var _detypedEvent$target = detypedEvent.target,
	      type = _detypedEvent$target.type,
	      value = _detypedEvent$target.value,
	      checked = _detypedEvent$target.checked;
	
	  switch (type) {
	    case 'checkbox':
	      if (valueProp !== undefined) {
	        // we are maintaining an array, not just a boolean
	        if (checked) {
	          // add value to current array value
	          return Array.isArray(currentValue) ? currentValue.concat(valueProp) : [valueProp];
	        } else {
	          // remove value from current array value
	          if (!Array.isArray(currentValue)) {
	            return currentValue;
	          }
	
	          var index = currentValue.indexOf(valueProp);
	
	          if (index < 0) {
	            return currentValue;
	          } else {
	            return currentValue.slice(0, index).concat(currentValue.slice(index + 1));
	          }
	        }
	      } else {
	        // it's just a boolean
	        return !!checked;
	      }
	
	    case 'select-multiple':
	      return getSelectedValues(event.target.options);
	
	    default:
	      return value;
	  }
	};
	
	var all = finalForm.fieldSubscriptionItems.reduce(function (result, key) {
	  result[key] = true;
	  return result;
	}, {});
	
	var Field =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Field, _React$Component);
	
	  function Field(_props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, _props, context) || this;
	
	    _this.subscribe = function (_ref, listener) {
	      var isEqual = _ref.isEqual,
	          name = _ref.name,
	          subscription = _ref.subscription,
	          validateFields = _ref.validateFields;
	      _this.unsubscribe = _this.context.reactFinalForm.registerField(name, listener, subscription || all, {
	        isEqual: isEqual,
	        getValidator: function getValidator() {
	          return _this.props.validate;
	        },
	        validateFields: validateFields
	      });
	    };
	
	    _this.notify = function (state) {
	      return _this.setState({
	        state: state
	      });
	    };
	
	    _this.handlers = {
	      onBlur: function onBlur(event) {
	        var state = _this.state.state; // this is to appease the Flow gods
	        // istanbul ignore next
	
	        if (state) {
	          var _this$props = _this.props,
	              format = _this$props.format,
	              formatOnBlur = _this$props.formatOnBlur;
	          state.blur();
	
	          if (format && formatOnBlur) {
	            state.change(format(state.value, state.name));
	          }
	        }
	      },
	      onChange: function onChange(event) {
	        var _this$props2 = _this.props,
	            parse = _this$props2.parse,
	            _value = _this$props2.value; // istanbul ignore next
	
	        if (false) {
	          var targetType = event.target.type;
	          var props = _this.props;
	          var unknown = ~['checkbox', 'radio', 'select-multiple'].indexOf(targetType) && !props.type;
	          var type = targetType === 'select-multiple' ? 'select' : targetType;
	
	          var _ref2 = targetType === 'select-multiple' ? _this.state.state || {} : props,
	              _value2 = _ref2.value;
	
	          if (unknown) {
	            console.error("Warning: You must pass `type=\"" + type + "\"` prop to your Field(" + props.name + ") component.\n" + ("Without it we don't know how to unpack your `value` prop - " + (Array.isArray(_value2) ? "[" + _value2 + "]" : "\"" + _value2 + "\"") + "."));
	          }
	        }
	
	        var value = event && event.target ? getValue(event, _this.state.state && _this.state.state.value, _value, isReactNative) : event;
	        _this.state.state && _this.state.state.change(parse ? parse(value, _this.props.name) : value);
	      },
	      onFocus: function onFocus(event) {
	        _this.state.state && _this.state.state.focus();
	      }
	    };
	    var initialState; // istanbul ignore next
	
	    if (false) {
	      console.error('Warning: Field must be used inside of a ReactFinalForm component');
	    }
	
	    if (_this.context.reactFinalForm) {
	      // avoid error, warning will alert developer to their mistake
	      _this.subscribe(_props, function (state) {
	        if (initialState) {
	          _this.notify(state);
	        } else {
	          initialState = state;
	        }
	      });
	    }
	
	    _this.state = {
	      state: initialState
	    };
	    return _this;
	  }
	
	  var _proto = Field.prototype;
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _this$props3 = this.props,
	        name = _this$props3.name,
	        subscription = _this$props3.subscription;
	
	    if (prevProps.name !== name || diffSubscription(prevProps.subscription, subscription, finalForm.fieldSubscriptionItems)) {
	      if (this.context.reactFinalForm) {
	        // avoid error, warning will alert developer to their mistake
	        this.unsubscribe();
	        this.subscribe(this.props, this.notify);
	      }
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.unsubscribe();
	  };
	
	  _proto.render = function render() {
	    var _this$props4 = this.props,
	        allowNull = _this$props4.allowNull,
	        component = _this$props4.component,
	        children = _this$props4.children,
	        format = _this$props4.format,
	        formatOnBlur = _this$props4.formatOnBlur,
	        parse = _this$props4.parse,
	        isEqual = _this$props4.isEqual,
	        name = _this$props4.name,
	        subscription = _this$props4.subscription,
	        validate = _this$props4.validate,
	        validateFields = _this$props4.validateFields,
	        _value = _this$props4.value,
	        rest = _objectWithoutPropertiesLoose(_this$props4, ["allowNull", "component", "children", "format", "formatOnBlur", "parse", "isEqual", "name", "subscription", "validate", "validateFields", "value"]);
	
	    var _ref3 = this.state.state || {},
	        blur = _ref3.blur,
	        change = _ref3.change,
	        focus = _ref3.focus,
	        value = _ref3.value,
	        ignoreName = _ref3.name,
	        otherState = _objectWithoutPropertiesLoose(_ref3, ["blur", "change", "focus", "value", "name"]);
	
	    var meta = {
	      // this is to appease the Flow gods
	      active: otherState.active,
	      data: otherState.data,
	      dirty: otherState.dirty,
	      dirtySinceLastSubmit: otherState.dirtySinceLastSubmit,
	      error: otherState.error,
	      initial: otherState.initial,
	      invalid: otherState.invalid,
	      pristine: otherState.pristine,
	      submitError: otherState.submitError,
	      submitFailed: otherState.submitFailed,
	      submitSucceeded: otherState.submitSucceeded,
	      submitting: otherState.submitting,
	      touched: otherState.touched,
	      valid: otherState.valid,
	      visited: otherState.visited
	    };
	
	    if (formatOnBlur) {
	      value = Field.defaultProps.format(value, name);
	    } else if (format) {
	      value = format(value, name);
	    }
	
	    if (value === null && !allowNull) {
	      value = '';
	    }
	
	    var input = _extends({
	      name: name,
	      value: value
	    }, this.handlers);
	
	    if (rest.type === 'checkbox') {
	      if (_value === undefined) {
	        input.checked = !!value;
	      } else {
	        input.checked = !!(Array.isArray(value) && ~value.indexOf(_value));
	        input.value = _value;
	      }
	    } else if (rest.type === 'radio') {
	      input.checked = value === _value;
	      input.value = _value;
	    } else if (component === 'select' && rest.multiple) {
	      input.value = input.value || [];
	    }
	
	    if (typeof children === 'function') {
	      return children(_extends({
	        input: input,
	        meta: meta
	      }, rest));
	    }
	
	    if (typeof component === 'string') {
	      // ignore meta, combine input with any other props
	      return React.createElement(component, _extends({}, input, {
	        children: children
	      }, rest));
	    }
	
	    var renderProps = {
	      input: input,
	      meta: meta // assign to force Flow check
	
	    };
	    return renderComponent(_extends({}, renderProps, {
	      children: children,
	      component: component
	    }, rest), "Field(" + name + ")");
	  };
	
	  return Field;
	}(React.Component);
	
	Field.contextTypes = {
	  reactFinalForm: PropTypes.object
	};
	Field.defaultProps = {
	  format: function format(value, name) {
	    return value === undefined ? '' : value;
	  },
	  parse: function parse(value, name) {
	    return value === '' ? undefined : value;
	  }
	};
	
	//      
	var shallowEqual = function shallowEqual(a, b) {
	  if (a === b) {
	    return true;
	  }
	
	  if (typeof a !== 'object' || !a || typeof b !== 'object' || !b) {
	    return false;
	  }
	
	  var keysA = Object.keys(a);
	  var keysB = Object.keys(b);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
	
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key) || a[key] !== b[key]) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	//      
	var isSyntheticEvent = function isSyntheticEvent(candidate) {
	  return !!(candidate && typeof candidate.stopPropagation === 'function');
	};
	
	var version = '3.6.0';
	var versions = {
	  'final-form': finalForm.version,
	  'react-final-form': version
	};
	var all$1 = finalForm.formSubscriptionItems.reduce(function (result, key) {
	  result[key] = true;
	  return result;
	}, {});
	
	var ReactFinalForm =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(ReactFinalForm, _React$Component);
	
	  function ReactFinalForm(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	
	    _this.notify = function (state) {
	      if (_this.mounted) {
	        _this.setState({
	          state: state
	        });
	      }
	
	      _this.mounted = true;
	    };
	
	    _this.handleSubmit = function (event) {
	      if (event) {
	        // sometimes not true, e.g. React Native
	        if (typeof event.preventDefault === 'function') {
	          event.preventDefault();
	        }
	
	        if (typeof event.stopPropagation === 'function') {
	          // prevent any outer forms from receiving the event too
	          event.stopPropagation();
	        }
	      }
	
	      return _this.form.submit();
	    };
	
	    var children = props.children,
	        component = props.component,
	        render = props.render,
	        subscription = props.subscription,
	        decorators = props.decorators,
	        rest = _objectWithoutPropertiesLoose(props, ["children", "component", "render", "subscription", "decorators"]);
	
	    var config = rest;
	    _this.mounted = false;
	
	    try {
	      _this.form = finalForm.createForm(config);
	    } catch (e) {
	      // istanbul ignore next
	      if (false) {
	        console.error("Warning: " + e.message);
	      }
	    }
	
	    _this.unsubscriptions = [];
	
	    if (_this.form) {
	      // set initial state
	      var initialState = {};
	
	      _this.form.subscribe(function (state) {
	        initialState = state;
	      }, subscription || all$1)();
	
	      _this.state = {
	        state: initialState
	      };
	    }
	
	    if (decorators) {
	      decorators.forEach(function (decorator) {
	        _this.unsubscriptions.push(decorator(_this.form));
	      });
	    }
	
	    return _this;
	  }
	
	  var _proto = ReactFinalForm.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      reactFinalForm: this.form
	    };
	  };
	
	  _proto.componentWillMount = function componentWillMount() {
	    if (this.form) {
	      this.form.pauseValidation();
	    }
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    if (this.form) {
	      this.unsubscriptions.push(this.form.subscribe(this.notify, this.props.subscription || all$1));
	      this.form.resumeValidation();
	    }
	  };
	
	  _proto.componentWillUpdate = function componentWillUpdate() {
	    // istanbul ignore next
	    if (this.form) {
	      this.resumeValidation = this.resumeValidation || !this.form.isValidationPaused();
	      this.form.pauseValidation();
	    }
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _this2 = this;
	
	    // istanbul ignore next
	    if (this.form && this.resumeValidation) {
	      this.form.resumeValidation();
	    }
	
	    if (this.props.initialValues && !(this.props.initialValuesEqual || shallowEqual)(prevProps.initialValues, this.props.initialValues)) {
	      this.form.initialize(this.props.initialValues);
	    }
	
	    finalForm.configOptions.forEach(function (key) {
	      if (key === 'initialValues' || prevProps[key] === _this2.props[key]) {
	        return;
	      }
	
	      _this2.form.setConfig(key, _this2.props[key]);
	    }); // istanbul ignore next
	
	    if (false) {
	      if (!shallowEqual(prevProps.decorators, this.props.decorators)) {
	        console.error('Warning: Form decorators should not change from one render to the next as new values will be ignored');
	      }
	
	      if (!shallowEqual(prevProps.subscription, this.props.subscription)) {
	        console.error('Warning: Form subscription should not change from one render to the next as new values will be ignored');
	      }
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.unsubscriptions.forEach(function (unsubscribe) {
	      return unsubscribe();
	    });
	  };
	
	  _proto.render = function render() {
	    var _this3 = this;
	
	    // remove config props
	    var _this$props = this.props,
	        debug = _this$props.debug,
	        initialValues = _this$props.initialValues,
	        mutators = _this$props.mutators,
	        onSubmit = _this$props.onSubmit,
	        subscription = _this$props.subscription,
	        validate = _this$props.validate,
	        validateOnBlur = _this$props.validateOnBlur,
	        props = _objectWithoutPropertiesLoose(_this$props, ["debug", "initialValues", "mutators", "onSubmit", "subscription", "validate", "validateOnBlur"]);
	
	    var renderProps = _extends({}, this.state ? this.state.state : {}, {
	      batch: this.form && function (fn) {
	        // istanbul ignore next
	        if (false) {
	          console.error("Warning: As of React Final Form v3.3.0, props.batch() is deprecated and will be removed in the next major version of React Final Form. Use: props.form.batch() instead. Check your ReactFinalForm render prop.");
	        }
	
	        return _this3.form.batch(fn);
	      },
	      blur: this.form && function (name) {
	        // istanbul ignore next
	        if (false) {
	          console.error("Warning: As of React Final Form v3.3.0, props.blur() is deprecated and will be removed in the next major version of React Final Form. Use: props.form.blur() instead. Check your ReactFinalForm render prop.");
	        }
	
	        return _this3.form.blur(name);
	      },
	      change: this.form && function (name, value) {
	        // istanbul ignore next
	        if (false) {
	          console.error("Warning: As of React Final Form v3.3.0, props.change() is deprecated and will be removed in the next major version of React Final Form. Use: props.form.change() instead. Check your ReactFinalForm render prop.");
	        }
	
	        return _this3.form.change(name, value);
	      },
	      focus: this.form && function (name) {
	        // istanbul ignore next
	        if (false) {
	          console.error("Warning: As of React Final Form v3.3.0, props.focus() is deprecated and will be removed in the next major version of React Final Form. Use: props.form.focus() instead. Check your ReactFinalForm render prop.");
	        }
	
	        return _this3.form.focus(name);
	      },
	      form: _extends({}, this.form, {
	        reset: function reset(eventOrValues) {
	          if (isSyntheticEvent(eventOrValues)) {
	            // it's a React SyntheticEvent, call reset with no arguments
	            _this3.form.reset();
	          } else {
	            _this3.form.reset(eventOrValues);
	          }
	        }
	      }),
	      handleSubmit: this.handleSubmit,
	      initialize: this.form && function (values) {
	        // istanbul ignore next
	        if (false) {
	          console.error("Warning: As of React Final Form v3.3.0, props.initialize() is deprecated and will be removed in the next major version of React Final Form. Use: props.form.initialize() instead. Check your ReactFinalForm render prop.");
	        }
	
	        return _this3.form.initialize(values);
	      },
	      mutators: this.form && Object.keys(this.form.mutators).reduce(function (result, key) {
	        result[key] = function () {
	          var _this3$form$mutators;
	
	          (_this3$form$mutators = _this3.form.mutators)[key].apply(_this3$form$mutators, arguments); // istanbul ignore next
	
	
	          if (false) {
	            console.error("Warning: As of React Final Form v3.3.0, props.mutators is deprecated and will be removed in the next major version of React Final Form. Use: props.form.mutators instead. Check your ReactFinalForm render prop.");
	          }
	        };
	
	        return result;
	      }, {}),
	      reset: this.form && function (values) {
	        // istanbul ignore next
	        if (false) {
	          console.error("Warning: As of React Final Form v3.3.0, props.reset() is deprecated and will be removed in the next major version of React Final Form. Use: props.form.reset() instead. Check your ReactFinalForm render prop.");
	        }
	
	        return _this3.form.reset(values);
	      }
	    });
	
	    return renderComponent(_extends({}, props, renderProps, {
	      __versions: versions
	    }), 'ReactFinalForm');
	  };
	
	  return ReactFinalForm;
	}(React.Component);
	
	ReactFinalForm.childContextTypes = {
	  reactFinalForm: PropTypes.object
	};
	
	var FormSpy =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(FormSpy, _React$Component);
	
	  function FormSpy(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    _this.subscribe = function (_ref, listener) {
	      var subscription = _ref.subscription;
	      _this.unsubscribe = _this.context.reactFinalForm.subscribe(listener, subscription || all$1);
	    };
	
	    _this.notify = function (state) {
	      _this.setState({
	        state: state
	      });
	
	      if (_this.props.onChange) {
	        _this.props.onChange(state);
	      }
	    };
	
	    var initialState; // istanbul ignore next
	
	    if (false) {
	      console.error('Warning: FormSpy must be used inside of a ReactFinalForm component');
	    }
	
	    if (_this.context.reactFinalForm) {
	      // avoid error, warning will alert developer to their mistake
	      _this.subscribe(props, function (state) {
	        if (initialState) {
	          _this.notify(state);
	        } else {
	          initialState = state;
	
	          if (props.onChange) {
	            props.onChange(state);
	          }
	        }
	      });
	    }
	
	    if (initialState) {
	      _this.state = {
	        state: initialState
	      };
	    }
	
	    return _this;
	  }
	
	  var _proto = FormSpy.prototype;
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var subscription = this.props.subscription;
	
	    if (diffSubscription(prevProps.subscription, subscription, finalForm.formSubscriptionItems)) {
	      if (this.context.reactFinalForm) {
	        // avoid error, warning will alert developer to their mistake
	        this.unsubscribe();
	        this.subscribe(this.props, this.notify);
	      }
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.unsubscribe();
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        onChange = _this$props.onChange,
	        subscription = _this$props.subscription,
	        rest = _objectWithoutPropertiesLoose(_this$props, ["onChange", "subscription"]);
	
	    var reactFinalForm = this.context.reactFinalForm;
	    var renderProps = {
	      batch: reactFinalForm && function (fn) {
	        // istanbul ignore next
	        if (false) {
	          console.error("Warning: As of React Final Form v3.3.0, props.batch() is deprecated and will be removed in the next major version of React Final Form. Use: props.form.batch() instead. Check your FormSpy render prop.");
	        }
	
	        return reactFinalForm.batch(fn);
	      },
	      blur: reactFinalForm && function (name) {
	        // istanbul ignore next
	        if (false) {
	          console.error("Warning: As of React Final Form v3.3.0, props.blur() is deprecated and will be removed in the next major version of React Final Form. Use: props.form.blur() instead. Check your FormSpy render prop.");
	        }
	
	        return reactFinalForm.blur(name);
	      },
	      change: reactFinalForm && function (name, value) {
	        // istanbul ignore next
	        if (false) {
	          console.error("Warning: As of React Final Form v3.3.0, props.change() is deprecated and will be removed in the next major version of React Final Form. Use: props.form.change() instead. Check your FormSpy render prop.");
	        }
	
	        return reactFinalForm.change(name, value);
	      },
	      focus: reactFinalForm && function (name) {
	        // istanbul ignore next
	        if (false) {
	          console.error("Warning: As of React Final Form v3.3.0, props.focus() is deprecated and will be removed in the next major version of React Final Form. Use: props.form.focus() instead. Check your FormSpy render prop.");
	        }
	
	        return reactFinalForm.focus(name);
	      },
	      form: _extends({}, reactFinalForm, {
	        reset: function reset(eventOrValues) {
	          if (isSyntheticEvent(eventOrValues)) {
	            // it's a React SyntheticEvent, call reset with no arguments
	            reactFinalForm.reset();
	          } else {
	            reactFinalForm.reset(eventOrValues);
	          }
	        }
	      }),
	      initialize: reactFinalForm && function (values) {
	        // istanbul ignore next
	        if (false) {
	          console.error("Warning: As of React Final Form v3.3.0, props.initialize() is deprecated and will be removed in the next major version of React Final Form. Use: props.form.initialize() instead. Check your FormSpy render prop.");
	        }
	
	        return reactFinalForm.initialize(values);
	      },
	      mutators: reactFinalForm && Object.keys(reactFinalForm.mutators).reduce(function (result, key) {
	        result[key] = function () {
	          var _reactFinalForm$mutat;
	
	          (_reactFinalForm$mutat = reactFinalForm.mutators)[key].apply(_reactFinalForm$mutat, arguments); // istanbul ignore next
	
	
	          if (false) {
	            console.error("Warning: As of React Final Form v3.3.0, props.mutators is deprecated and will be removed in the next major version of React Final Form. Use: props.form.mutators instead. Check your FormSpy render prop.");
	          }
	        };
	
	        return result;
	      }, {}),
	      reset: reactFinalForm && function (values) {
	        // istanbul ignore next
	        if (false) {
	          console.error("Warning: As of React Final Form v3.3.0, props.reset() is deprecated and will be removed in the next major version of React Final Form. Use: props.form.reset() instead. Check your FormSpy render prop.");
	        }
	
	        return reactFinalForm.reset(values);
	      }
	    };
	    return onChange ? null : renderComponent(_extends({}, rest, this.state ? this.state.state : {}, renderProps), 'FormSpy');
	  };
	
	  return FormSpy;
	}(React.Component);
	
	FormSpy.contextTypes = {
	  reactFinalForm: PropTypes.object
	};
	
	//
	
	exports.Field = Field;
	exports.Form = ReactFinalForm;
	exports.version = version;
	exports.FormSpy = FormSpy;


/***/ },
/* 2007 */
[2408, 2009],
/* 2008 */
[2409, 2007],
/* 2009 */
1016,
/* 2010 */
1762,
/* 2011 */
1763,
/* 2012 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2015)


/***/ },
/* 2013 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* eslint-disable global-require */
	
	if (true) {
	  module.exports = __webpack_require__(2014);
	} else {
	  module.exports = require('./AppContainer.dev');
	}

/***/ },
/* 2014 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable react/prop-types */
	
	var React = __webpack_require__(1);
	
	var Component = React.Component;
	
	var AppContainer = function (_Component) {
	  _inherits(AppContainer, _Component);
	
	  function AppContainer() {
	    _classCallCheck(this, AppContainer);
	
	    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
	  }
	
	  _createClass(AppContainer, [{
	    key: 'render',
	    value: function render() {
	      if (this.props.component) {
	        return React.createElement(this.props.component, this.props.props);
	      }
	
	      return React.Children.only(this.props.children);
	    }
	  }]);
	
	  return AppContainer;
	}(Component);
	
	module.exports = AppContainer;

/***/ },
/* 2015 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* eslint-disable global-require */
	
	if (true) {
	  module.exports = __webpack_require__(2016);
	} else {
	  module.exports = require('./index.dev');
	}

/***/ },
/* 2016 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports.AppContainer = __webpack_require__(2013);

/***/ },
/* 2017 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2019);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];
	
	var cleanInputProps = function cleanInputProps(inputProps) {
		INPUT_PROPS_BLACKLIST.forEach(function (field) {
			return delete inputProps[field];
		});
		return inputProps;
	};
	
	var copyStyles = function copyStyles(styles, node) {
		node.style.fontSize = styles.fontSize;
		node.style.fontFamily = styles.fontFamily;
		node.style.fontWeight = styles.fontWeight;
		node.style.fontStyle = styles.fontStyle;
		node.style.letterSpacing = styles.letterSpacing;
		node.style.textTransform = styles.textTransform;
	};
	
	var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
	
	var generateId = function generateId() {
		// we only need an auto-generated ID for stylesheet injection, which is only
		// used for IE. so if the browser is not IE, this should return undefined.
		return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
	};
	
	var AutosizeInput = function (_Component) {
		_inherits(AutosizeInput, _Component);
	
		function AutosizeInput(props) {
			_classCallCheck(this, AutosizeInput);
	
			var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
	
			_this.inputRef = function (el) {
				_this.input = el;
				if (typeof _this.props.inputRef === 'function') {
					_this.props.inputRef(el);
				}
			};
	
			_this.placeHolderSizerRef = function (el) {
				_this.placeHolderSizer = el;
			};
	
			_this.sizerRef = function (el) {
				_this.sizer = el;
			};
	
			_this.state = {
				inputWidth: props.minWidth,
				inputId: props.id || generateId()
			};
			return _this;
		}
	
		_createClass(AutosizeInput, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.mounted = true;
				this.copyInputStyles();
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var id = nextProps.id;
	
				if (id !== this.props.id) {
					this.setState({ inputId: id || generateId() });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevState.inputWidth !== this.state.inputWidth) {
					if (typeof this.props.onAutosize === 'function') {
						this.props.onAutosize(this.state.inputWidth);
					}
				}
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'copyInputStyles',
			value: function copyInputStyles() {
				if (!this.mounted || !window.getComputedStyle) {
					return;
				}
				var inputStyles = this.input && window.getComputedStyle(this.input);
				if (!inputStyles) {
					return;
				}
				copyStyles(inputStyles, this.sizer);
				if (this.placeHolderSizer) {
					copyStyles(inputStyles, this.placeHolderSizer);
				}
			}
		}, {
			key: 'updateInputWidth',
			value: function updateInputWidth() {
				if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
					return;
				}
				var newInputWidth = void 0;
				if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
					newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
				} else {
					newInputWidth = this.sizer.scrollWidth + 2;
				}
				// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
				var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
				newInputWidth += extraWidth;
				if (newInputWidth < this.props.minWidth) {
					newInputWidth = this.props.minWidth;
				}
				if (newInputWidth !== this.state.inputWidth) {
					this.setState({
						inputWidth: newInputWidth
					});
				}
			}
		}, {
			key: 'getInput',
			value: function getInput() {
				return this.input;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.input.focus();
			}
		}, {
			key: 'blur',
			value: function blur() {
				this.input.blur();
			}
		}, {
			key: 'select',
			value: function select() {
				this.input.select();
			}
		}, {
			key: 'renderStyles',
			value: function renderStyles() {
				// this method injects styles to hide IE's clear indicator, which messes
				// with input size detection. the stylesheet is only injected when the
				// browser is IE, and can also be disabled by the `injectStyles` prop.
				var injectStyles = this.props.injectStyles;
	
				return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
					} }) : null;
			}
		}, {
			key: 'render',
			value: function render() {
				var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
					if (previousValue !== null && previousValue !== undefined) {
						return previousValue;
					}
					return currentValue;
				});
	
				var wrapperStyle = _extends({}, this.props.style);
				if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
	
				var inputStyle = _extends({
					boxSizing: 'content-box',
					width: this.state.inputWidth + 'px'
				}, this.props.inputStyle);
	
				var inputProps = _objectWithoutProperties(this.props, []);
	
				cleanInputProps(inputProps);
				inputProps.className = this.props.inputClassName;
				inputProps.id = this.state.inputId;
				inputProps.style = inputStyle;
	
				return _react2.default.createElement(
					'div',
					{ className: this.props.className, style: wrapperStyle },
					this.renderStyles(),
					_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
					_react2.default.createElement(
						'div',
						{ ref: this.sizerRef, style: sizerStyle },
						sizerValue
					),
					this.props.placeholder ? _react2.default.createElement(
						'div',
						{ ref: this.placeHolderSizerRef, style: sizerStyle },
						this.props.placeholder
					) : null
				);
			}
		}]);
	
		return AutosizeInput;
	}(_react.Component);
	
	AutosizeInput.propTypes = {
		className: _propTypes2.default.string, // className for the outer element
		defaultValue: _propTypes2.default.any, // default field value
		extraWidth: _propTypes2.default.oneOfType([// additional width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
		injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
		inputClassName: _propTypes2.default.string, // className for the input element
		inputRef: _propTypes2.default.func, // ref callback for the input element
		inputStyle: _propTypes2.default.object, // css styles for the input element
		minWidth: _propTypes2.default.oneOfType([// minimum width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
		onChange: _propTypes2.default.func, // onChange handler: function(event) {}
		placeholder: _propTypes2.default.string, // placeholder text
		placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
		style: _propTypes2.default.object, // css styles for the outer element
		value: _propTypes2.default.any // field value
	};
	AutosizeInput.defaultProps = {
		minWidth: 1,
		injectStyles: true
	};
	
	exports.default = AutosizeInput;

/***/ },
/* 2018 */
[2242, 2020],
/* 2019 */
[2243, 2018],
/* 2020 */
1016,
/* 2021 */
/***/ function(module, exports) {

	/** @license React v16.9.0
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
	60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118;function x(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case t:case r:case d:return u}}}function y(a){return x(a)===m}exports.typeOf=x;exports.AsyncMode=l;
	exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w)};exports.isAsyncMode=function(a){return y(a)||x(a)===l};exports.isConcurrentMode=y;exports.isContextConsumer=function(a){return x(a)===k};exports.isContextProvider=function(a){return x(a)===h};
	exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return x(a)===n};exports.isFragment=function(a){return x(a)===e};exports.isLazy=function(a){return x(a)===t};exports.isMemo=function(a){return x(a)===r};exports.isPortal=function(a){return x(a)===d};exports.isProfiler=function(a){return x(a)===g};exports.isStrictMode=function(a){return x(a)===f};exports.isSuspense=function(a){return x(a)===p};


/***/ },
/* 2022 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(2021);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 2023 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(512);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(323);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(514);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(498);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(500);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(513);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(515);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	var Motion = (function (_React$Component) {
	  _inherits(Motion, _React$Component);
	
	  _createClass(Motion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      onRest: _propTypes2['default'].func
	    },
	    enumerable: true
	  }]);
	
	  function Motion(props) {
	    var _this = this;
	
	    _classCallCheck(this, Motion);
	
	    _React$Component.call(this, props);
	    this.wasAnimating = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyle = null;
	
	    this.clearUnreadPropStyle = function (destStyle) {
	      var dirty = false;
	      var _state = _this.state;
	      var currentStyle = _state.currentStyle;
	      var currentVelocity = _state.currentVelocity;
	      var lastIdealStyle = _state.lastIdealStyle;
	      var lastIdealVelocity = _state.lastIdealVelocity;
	
	      for (var key in destStyle) {
	        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	          continue;
	        }
	
	        var styleValue = destStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            currentStyle = _extends({}, currentStyle);
	            currentVelocity = _extends({}, currentVelocity);
	            lastIdealStyle = _extends({}, lastIdealStyle);
	            lastIdealVelocity = _extends({}, lastIdealVelocity);
	          }
	
	          currentStyle[key] = styleValue;
	          currentVelocity[key] = 0;
	          lastIdealStyle[key] = styleValue;
	          lastIdealVelocity[key] = 0;
	        }
	      }
	
	      if (dirty) {
	        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // check if we need to animate in the first place
	        var propsStyle = _this.props.style;
	        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
	          if (_this.wasAnimating && _this.props.onRest) {
	            _this.props.onRest();
	          }
	
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.wasAnimating = false;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        _this.wasAnimating = true;
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	
	        for (var key in propsStyle) {
	          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
	            continue;
	          }
	
	          var styleValue = propsStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
	            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
	            for (var i = 0; i < framesToCatchUp; i++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyle: newCurrentStyle,
	          currentVelocity: newCurrentVelocity,
	          lastIdealStyle: newLastIdealStyle,
	          lastIdealVelocity: newLastIdealVelocity
	        });
	
	        _this.unreadPropStyle = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  Motion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyle = _props.defaultStyle;
	    var style = _props.style;
	
	    var currentStyle = defaultStyle || _stripStyle2['default'](style);
	    var currentVelocity = _mapToZero2['default'](currentStyle);
	    return {
	      currentStyle: currentStyle,
	      currentVelocity: currentVelocity,
	      lastIdealStyle: currentStyle,
	      lastIdealVelocity: currentVelocity
	    };
	  };
	
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	
	  Motion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyle != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyle);
	    }
	
	    this.unreadPropStyle = props.style;
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  Motion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyle);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return Motion;
	})(_react2['default'].Component);
	
	exports['default'] = Motion;
	module.exports = exports['default'];
	
	// after checking for unreadPropStyle != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ },
/* 2024 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(512);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(323);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(514);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(498);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(500);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(513);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(515);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
	  for (var i = 0; i < currentStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var StaggeredMotion = (function (_React$Component) {
	  _inherits(StaggeredMotion, _React$Component);
	
	  _createClass(StaggeredMotion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
	      styles: _propTypes2['default'].func.isRequired,
	      children: _propTypes2['default'].func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function StaggeredMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, StaggeredMotion);
	
	    _React$Component.call(this, props);
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _state = _this.state;
	      var currentStyles = _state.currentStyles;
	      var currentVelocities = _state.currentVelocities;
	      var lastIdealStyles = _state.lastIdealStyles;
	      var lastIdealVelocities = _state.lastIdealVelocities;
	
	      var someDirty = false;
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i];
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              someDirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	          }
	        }
	      }
	
	      if (someDirty) {
	        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        var destStyles = _this.props.styles(_this.state.lastIdealStyles);
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyles = [];
	        var newLastIdealVelocities = [];
	        var newCurrentStyles = [];
	        var newCurrentVelocities = [];
	
	        for (var i = 0; i < destStyles.length; i++) {
	          var destStyle = destStyles[i];
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in destStyle) {
	            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	              continue;
	            }
	
	            var styleValue = destStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
	              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  StaggeredMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	
	    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
	    var currentVelocities = currentStyles.map(function (currentStyle) {
	      return _mapToZero2['default'](currentStyle);
	    });
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: currentStyles,
	      lastIdealVelocities: currentVelocities
	    };
	  };
	
	  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  StaggeredMotion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return StaggeredMotion;
	})(_react2['default'].Component);
	
	exports['default'] = StaggeredMotion;
	module.exports = exports['default'];
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400
	
	// after checking for unreadPropStyles != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ },
/* 2025 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(512);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(323);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(514);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _mergeDiff = __webpack_require__(2026);
	
	var _mergeDiff2 = _interopRequireDefault(_mergeDiff);
	
	var _performanceNow = __webpack_require__(498);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(500);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(513);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(515);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	// the children function & (potential) styles function asks as param an
	// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
	// {key: string, data?: any, style: PlainStyle}. However, the way we keep
	// internal states doesn't contain such a data structure (check the state and
	// TransitionMotionState). So when children function and others ask for such
	// data we need to generate them on the fly by combining mergedPropsStyles and
	// currentStyles/lastIdealStyles
	function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
	  // Copy the value to a `const` so that Flow understands that the const won't
	  // change and will be non-nullable in the callback below.
	  var cUnreadPropStyles = unreadPropStyles;
	  if (cUnreadPropStyles == null) {
	    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	      return {
	        key: mergedPropsStyle.key,
	        data: mergedPropsStyle.data,
	        style: plainStyles[i]
	      };
	    });
	  }
	  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	    for (var j = 0; j < cUnreadPropStyles.length; j++) {
	      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
	        return {
	          key: cUnreadPropStyles[j].key,
	          data: cUnreadPropStyles[j].data,
	          style: plainStyles[i]
	        };
	      }
	    }
	    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
	  });
	}
	
	function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
	  if (mergedPropsStyles.length !== destStyles.length) {
	    return false;
	  }
	
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (mergedPropsStyles[i].key !== destStyles[i].key) {
	      return false;
	    }
	  }
	
	  // we have the invariant that mergedPropsStyles and
	  // currentStyles/currentVelocities/last* are synced in terms of cells, see
	  // mergeAndSync comment for more info
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	// core key merging logic
	
	// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
	// c}, previous current (interpolating) style is {a, b}
	// **invariant**: current[i] corresponds to merged[i] in terms of key
	
	// steps:
	// turn merged style into {a?, b, c}
	//    add c, value of c is destStyles.c
	//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
	// turn current (interpolating) style from {a, b} into {a?, b, c}
	//    maybe remove a
	//    certainly add c, value of c is willEnter(c)
	// loop over merged and construct new current
	// dest doesn't change, that's owner's
	function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
	  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
	    var leavingStyle = willLeave(oldMergedPropsStyle);
	    if (leavingStyle == null) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
	  });
	
	  var newCurrentStyles = [];
	  var newCurrentVelocities = [];
	  var newLastIdealStyles = [];
	  var newLastIdealVelocities = [];
	  for (var i = 0; i < newMergedPropsStyles.length; i++) {
	    var newMergedPropsStyleCell = newMergedPropsStyles[i];
	    var foundOldIndex = null;
	    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
	      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
	        foundOldIndex = j;
	        break;
	      }
	    }
	    // TODO: key search code
	    if (foundOldIndex == null) {
	      var plainStyle = willEnter(newMergedPropsStyleCell);
	      newCurrentStyles[i] = plainStyle;
	      newLastIdealStyles[i] = plainStyle;
	
	      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
	      newCurrentVelocities[i] = velocity;
	      newLastIdealVelocities[i] = velocity;
	    } else {
	      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
	      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
	      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
	      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
	    }
	  }
	
	  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
	}
	
	var TransitionMotion = (function (_React$Component) {
	  _inherits(TransitionMotion, _React$Component);
	
	  _createClass(TransitionMotion, null, [{
	    key: 'propTypes',
	    value: {
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
	      })),
	      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
	      }))]).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      willEnter: _propTypes2['default'].func,
	      willLeave: _propTypes2['default'].func,
	      didLeave: _propTypes2['default'].func
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      willEnter: function willEnter(styleThatEntered) {
	        return _stripStyle2['default'](styleThatEntered.style);
	      },
	      // recall: returning null makes the current unmounting TransitionStyle
	      // disappear immediately
	      willLeave: function willLeave() {
	        return null;
	      },
	      didLeave: function didLeave() {}
	    },
	    enumerable: true
	  }]);
	
	  function TransitionMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, TransitionMotion);
	
	    _React$Component.call(this, props);
	    this.unmounting = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	      var mergedPropsStyles = _mergeAndSync[0];
	      var currentStyles = _mergeAndSync[1];
	      var currentVelocities = _mergeAndSync[2];
	      var lastIdealStyles = _mergeAndSync[3];
	      var lastIdealVelocities = _mergeAndSync[4];
	
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i].style;
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	              mergedPropsStyles[i] = {
	                key: mergedPropsStyles[i].key,
	                data: mergedPropsStyles[i].data,
	                style: _extends({}, mergedPropsStyles[i].style)
	              };
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	            mergedPropsStyles[i].style[key] = styleValue;
	          }
	        }
	      }
	
	      // unlike the other 2 components, we can't detect staleness and optionally
	      // opt out of setState here. each style object's data might contain new
	      // stuff we're not/cannot compare
	      _this.setState({
	        currentStyles: currentStyles,
	        currentVelocities: currentVelocities,
	        mergedPropsStyles: mergedPropsStyles,
	        lastIdealStyles: lastIdealStyles,
	        lastIdealVelocities: lastIdealVelocities
	      });
	    };
	
	    this.startAnimationIfNecessary = function () {
	      if (_this.unmounting) {
	        return;
	      }
	
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // https://github.com/chenglou/react-motion/pull/420
	        // > if execution passes the conditional if (this.unmounting), then
	        // executes async defaultRaf and after that component unmounts and after
	        // that the callback of defaultRaf is called, then setState will be called
	        // on unmounted component.
	        if (_this.unmounting) {
	          return;
	        }
	
	        var propStyles = _this.props.styles;
	        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	        var newMergedPropsStyles = _mergeAndSync2[0];
	        var newCurrentStyles = _mergeAndSync2[1];
	        var newCurrentVelocities = _mergeAndSync2[2];
	        var newLastIdealStyles = _mergeAndSync2[3];
	        var newLastIdealVelocities = _mergeAndSync2[4];
	
	        for (var i = 0; i < newMergedPropsStyles.length; i++) {
	          var newMergedPropsStyle = newMergedPropsStyles[i].style;
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in newMergedPropsStyle) {
	            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
	              continue;
	            }
	
	            var styleValue = newMergedPropsStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = newLastIdealStyles[i][key];
	              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities,
	          mergedPropsStyles: newMergedPropsStyles
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  TransitionMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	    var willEnter = _props.willEnter;
	    var willLeave = _props.willLeave;
	    var didLeave = _props.didLeave;
	
	    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;
	
	    // this is special. for the first time around, we don't have a comparison
	    // between last (no last) and current merged props. we'll compute last so:
	    // say default is {a, b} and styles (dest style) is {b, c}, we'll
	    // fabricate last as {a, b}
	    var oldMergedPropsStyles = undefined;
	    if (defaultStyles == null) {
	      oldMergedPropsStyles = destStyles;
	    } else {
	      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
	        // TODO: key search code
	        for (var i = 0; i < destStyles.length; i++) {
	          if (destStyles[i].key === defaultStyleCell.key) {
	            return destStyles[i];
	          }
	        }
	        return defaultStyleCell;
	      });
	    }
	    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    });
	    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    });
	
	    var _mergeAndSync3 = mergeAndSync(
	    // Because this is an old-style createReactClass component, Flow doesn't
	    // understand that the willEnter and willLeave props have default values
	    // and will always be present.
	    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
	    oldCurrentVelocities);
	
	    var mergedPropsStyles = _mergeAndSync3[0];
	    var currentStyles = _mergeAndSync3[1];
	    var currentVelocities = _mergeAndSync3[2];
	    var lastIdealStyles = _mergeAndSync3[3];
	    var lastIdealVelocities = _mergeAndSync3[4];
	    // oldLastIdealVelocities really
	
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities,
	      mergedPropsStyles: mergedPropsStyles
	    };
	  };
	
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	
	  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    var styles = props.styles;
	    if (typeof styles === 'function') {
	      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
	    } else {
	      this.unreadPropStyles = styles;
	    }
	
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounting = true;
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  TransitionMotion.prototype.render = function render() {
	    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
	    var renderedChildren = this.props.children(hydratedStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return TransitionMotion;
	})(_react2['default'].Component);
	
	exports['default'] = TransitionMotion;
	module.exports = exports['default'];
	
	// list of styles, each containing interpolating values. Part of what's passed
	// to children function. Notice that this is
	// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
	// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
	// contains the key & data info (so that we only have a single source of truth
	// for these, and to save space). Check the comment for `rehydrateStyles` to
	// see how we regenerate the entirety of what's passed to children function
	
	// the array that keeps track of currently rendered stuff! Including stuff
	// that you've unmounted but that's still animating. This is where it lives
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400

/***/ },
/* 2026 */
/***/ function(module, exports) {

	
	
	// core keys merging algorithm. If previous render's keys are [a, b], and the
	// next render's [c, b, d], what's the final merged keys and ordering?
	
	// - c and a must both be before b
	// - b before d
	// - ordering between a and c ambiguous
	
	// this reduces to merging two partially ordered lists (e.g. lists where not
	// every item has a definite ordering, like comparing a and c above). For the
	// ambiguous ordering we deterministically choose to place the next render's
	// item after the previous'; so c after a
	
	// this is called a topological sorting. Except the existing algorithms don't
	// work well with js bc of the amount of allocation, and isn't optimized for our
	// current use-case bc the runtime is linear in terms of edges (see wiki for
	// meaning), which is huge when two lists have many common elements
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mergeDiff;
	
	function mergeDiff(prev, next, onRemove) {
	  // bookkeeping for easier access of a key's index below. This is 2 allocations +
	  // potentially triggering chrome hash map mode for objs (so it might be faster
	
	  var prevKeyIndex = {};
	  for (var i = 0; i < prev.length; i++) {
	    prevKeyIndex[prev[i].key] = i;
	  }
	  var nextKeyIndex = {};
	  for (var i = 0; i < next.length; i++) {
	    nextKeyIndex[next[i].key] = i;
	  }
	
	  // first, an overly elaborate way of merging prev and next, eliminating
	  // duplicates (in terms of keys). If there's dupe, keep the item in next).
	  // This way of writing it saves allocations
	  var ret = [];
	  for (var i = 0; i < next.length; i++) {
	    ret[i] = next[i];
	  }
	  for (var i = 0; i < prev.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
	      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
	      // merge in keys that the user desires to kill
	      var fill = onRemove(i, prev[i]);
	      if (fill != null) {
	        ret.push(fill);
	      }
	    }
	  }
	
	  // now all the items all present. Core sorting logic to have the right order
	  return ret.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a.key];
	    var nextOrderB = nextKeyIndex[b.key];
	    var prevOrderA = prevKeyIndex[a.key];
	    var prevOrderB = prevKeyIndex[b.key];
	
	    if (nextOrderA != null && nextOrderB != null) {
	      // both keys in next
	      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
	    } else if (prevOrderA != null && prevOrderB != null) {
	      // both keys in prev
	      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
	    } else if (nextOrderA != null) {
	      // key a in next, key b in prev
	
	      // how to determine the order between a and b? We find a "pivot" (term
	      // abuse), a key present in both prev and next, that is sandwiched between
	      // a and b. In the context of our above example, if we're comparing a and
	      // d, b's (the only) pivot
	      for (var i = 0; i < next.length; i++) {
	        var pivot = next[i].key;
	        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	          continue;
	        }
	
	        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	      // pluggable. default to: next bigger than prev
	      return 1;
	    }
	    // prevOrderA, nextOrderB
	    for (var i = 0; i < next.length; i++) {
	      var pivot = next[i].key;
	      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	        continue;
	      }
	      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
	        return -1;
	      }
	    }
	    // pluggable. default to: next bigger than prev
	    return -1;
	  });
	}
	
	module.exports = exports['default'];
	// to loop through and find a key's index each time), but I no longer care

/***/ },
/* 2027 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _Motion = __webpack_require__(2023);
	
	exports.Motion = _interopRequire(_Motion);
	
	var _StaggeredMotion = __webpack_require__(2024);
	
	exports.StaggeredMotion = _interopRequire(_StaggeredMotion);
	
	var _TransitionMotion = __webpack_require__(2025);
	
	exports.TransitionMotion = _interopRequire(_TransitionMotion);
	
	var _spring = __webpack_require__(2029);
	
	exports.spring = _interopRequire(_spring);
	
	var _presets = __webpack_require__(907);
	
	exports.presets = _interopRequire(_presets);
	
	var _stripStyle = __webpack_require__(323);
	
	exports.stripStyle = _interopRequire(_stripStyle);
	
	// deprecated, dummy warning function
	
	var _reorderKeys = __webpack_require__(2028);
	
	exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ },
/* 2028 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = reorderKeys;
	
	var hasWarned = false;
	
	function reorderKeys() {
	  if (false) {
	    if (!hasWarned) {
	      hasWarned = true;
	      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 2029 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = spring;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _presets = __webpack_require__(907);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var defaultConfig = _extends({}, _presets2['default'].noWobble, {
	  precision: 0.01
	});
	
	function spring(val, config) {
	  return _extends({}, defaultConfig, config, { val: val });
	}
	
	module.exports = exports['default'];

/***/ },
/* 2030 */
[2242, 2031],
/* 2031 */
1016,
/* 2032 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(156);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(315);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _getContainer = __webpack_require__(324);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(193);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
	      if (!_this._overlayTarget) {
	        _this._overlayTarget = document.createElement('div');
	        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
	        _this._portalContainerNode.appendChild(_this._overlayTarget);
	      }
	    }, _this._unmountOverlayTarget = function () {
	      if (_this._overlayTarget) {
	        _this._portalContainerNode.removeChild(_this._overlayTarget);
	        _this._overlayTarget = null;
	      }
	      _this._portalContainerNode = null;
	    }, _this._renderOverlay = function () {
	      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);
	
	      // Save reference for future access.
	      if (overlay !== null) {
	        _this._mountOverlayTarget();
	
	        var initialRender = !_this._overlayInstance;
	
	        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget, function () {
	          if (initialRender && _this.props.onRendered) {
	            _this.props.onRendered();
	          }
	        });
	      } else {
	        // Unrender if the component is null for transitions to null
	        _this._unrenderOverlay();
	        _this._unmountOverlayTarget();
	      }
	    }, _this._unrenderOverlay = function () {
	      if (_this._overlayTarget) {
	        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
	        _this._overlayInstance = null;
	      }
	    }, _this.getMountNode = function () {
	      return _this._overlayTarget;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Portal.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    this._renderOverlay();
	  };
	
	  Portal.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._renderOverlay();
	  };
	
	  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this._overlayTarget && nextProps.container !== this.props.container) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  };
	
	  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._isMounted = false;
	    this._unrenderOverlay();
	    this._unmountOverlayTarget();
	  };
	
	  Portal.prototype.render = function render() {
	    return null;
	  };
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.displayName = 'Portal';
	Portal.propTypes = {
	  /**
	   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	   * appended to it.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  onRendered: _propTypes2.default.func
	};
	exports.default = Portal;
	module.exports = exports['default'];

/***/ },
/* 2033 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _activeElement = __webpack_require__(828);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(188);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _inDOM = __webpack_require__(123);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _propTypes = __webpack_require__(156);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(315);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _deprecated = __webpack_require__(1905);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _elementType = __webpack_require__(34);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(47);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ModalManager = __webpack_require__(2034);
	
	var _ModalManager2 = _interopRequireDefault(_ModalManager);
	
	var _Portal = __webpack_require__(908);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _RefHolder = __webpack_require__(2037);
	
	var _RefHolder2 = _interopRequireDefault(_RefHolder);
	
	var _addEventListener = __webpack_require__(910);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _addFocusListener = __webpack_require__(2038);
	
	var _addFocusListener2 = _interopRequireDefault(_addFocusListener);
	
	var _getContainer = __webpack_require__(324);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(193);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prop-types */
	
	var modalManager = new _ModalManager2.default();
	
	/**
	 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
	 * The Modal component renders its `children` node in front of a backdrop component.
	 *
	 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
	 *
	 * - Manages dialog stacking when one-at-a-time just isn't enough.
	 * - Creates a backdrop, for disabling interaction below the modal.
	 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
	 * - It disables scrolling of the page content while open.
	 * - Adds the appropriate ARIA roles are automatically.
	 * - Easily pluggable animations via a `<Transition/>` component.
	 *
	 * Note that, in the same way the backdrop element prevents users from clicking or interacting
	 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
	 * interact with page content while the Modal is open. To do this, we use a common technique of applying
	 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
	 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
	 * React hierarchy (such as the default: document.body).
	 */
	
	var Modal = function (_React$Component) {
	  _inherits(Modal, _React$Component);
	
	  function Modal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Modal.prototype.omitProps = function omitProps(props, propTypes) {
	
	    var keys = Object.keys(props);
	    var newProps = {};
	    keys.map(function (prop) {
	      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
	        newProps[prop] = props[prop];
	      }
	    });
	
	    return newProps;
	  };
	
	  Modal.prototype.render = function render() {
	    var _props = this.props,
	        show = _props.show,
	        container = _props.container,
	        children = _props.children,
	        Transition = _props.transition,
	        backdrop = _props.backdrop,
	        className = _props.className,
	        style = _props.style,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered;
	
	
	    var dialog = _react2.default.Children.only(children);
	    var filteredProps = this.omitProps(this.props, Modal.propTypes);
	
	    var mountModal = show || Transition && !this.state.exited;
	    if (!mountModal) {
	      return null;
	    }
	
	    var _dialog$props = dialog.props,
	        role = _dialog$props.role,
	        tabIndex = _dialog$props.tabIndex;
	
	
	    if (role === undefined || tabIndex === undefined) {
	      dialog = (0, _react.cloneElement)(dialog, {
	        role: role === undefined ? 'document' : role,
	        tabIndex: tabIndex == null ? '-1' : tabIndex
	      });
	    }
	
	    if (Transition) {
	      dialog = _react2.default.createElement(
	        Transition,
	        {
	          appear: true,
	          unmountOnExit: true,
	          'in': show,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.handleHidden,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        dialog
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      {
	        ref: this.setMountNode,
	        container: container,
	        onRendered: this.onPortalRendered
	      },
	      _react2.default.createElement(
	        'div',
	        _extends({
	          ref: this.setModalNodeRef,
	          role: role || 'dialog'
	        }, filteredProps, {
	          style: style,
	          className: className
	        }),
	        backdrop && this.renderBackdrop(),
	        _react2.default.createElement(
	          _RefHolder2.default,
	          { ref: this.setDialogRef },
	          dialog
	        )
	      )
	    );
	  };
	
	  Modal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  };
	
	  Modal.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (!this.props.show && nextProps.show) {
	      this.checkForFocus();
	    }
	  };
	
	  Modal.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    if (this.props.show) {
	      this.onShow();
	    }
	  };
	
	  Modal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var transition = this.props.transition;
	
	
	    if (prevProps.show && !this.props.show && !transition) {
	      // Otherwise handleHidden will call this.
	      this.onHide();
	    } else if (!prevProps.show && this.props.show) {
	      this.onShow();
	    }
	  };
	
	  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
	    var _props2 = this.props,
	        show = _props2.show,
	        transition = _props2.transition;
	
	
	    this._isMounted = false;
	
	    if (show || transition && !this.state.exited) {
	      this.onHide();
	    }
	  };
	
	  Modal.prototype.autoFocus = function autoFocus() {
	    if (!this.props.autoFocus) {
	      return;
	    }
	
	    var dialogElement = this.getDialogElement();
	    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	
	    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
	      this.lastFocus = currentActiveElement;
	
	      if (!dialogElement.hasAttribute('tabIndex')) {
	        (0, _warning2.default)(false, 'The modal content node does not accept focus. For the benefit of ' + 'assistive technologies, the tabIndex of the node is being set ' + 'to "-1".');
	
	        dialogElement.setAttribute('tabIndex', -1);
	      }
	
	      dialogElement.focus();
	    }
	  };
	
	  Modal.prototype.restoreLastFocus = function restoreLastFocus() {
	    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
	    if (this.lastFocus && this.lastFocus.focus) {
	      this.lastFocus.focus();
	      this.lastFocus = null;
	    }
	  };
	
	  Modal.prototype.getDialogElement = function getDialogElement() {
	    return _reactDom2.default.findDOMNode(this.dialog);
	  };
	
	  Modal.prototype.isTopModal = function isTopModal() {
	    return this.props.manager.isTopModal(this);
	  };
	
	  return Modal;
	}(_react2.default.Component);
	
	Modal.propTypes = _extends({}, _Portal2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Modal
	   */
	  show: _propTypes2.default.bool,
	
	  /**
	   * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
	   *
	   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
	   * page content can be placed behind a virtual backdrop as well as a visual one.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  /**
	   * A callback fired when the Modal is opening.
	   */
	  onShow: _propTypes2.default.func,
	
	  /**
	   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
	   *
	   * The `onHide` callback only signals intent from the Modal,
	   * you must actually set the `show` prop to `false` for the Modal to close.
	   */
	  onHide: _propTypes2.default.func,
	
	  /**
	   * Include a backdrop component.
	   */
	  backdrop: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['static'])]),
	
	  /**
	   * A function that returns a backdrop component. Useful for custom
	   * backdrop rendering.
	   *
	   * ```js
	   *  renderBackdrop={props => <MyBackdrop {...props} />}
	   * ```
	   */
	  renderBackdrop: _propTypes2.default.func,
	
	  /**
	   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	   */
	  onEscapeKeyDown: _propTypes2.default.func,
	
	  /**
	   * Support for this function will be deprecated. Please use `onEscapeKeyDown` instead
	   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	   * @deprecated
	   */
	  onEscapeKeyUp: (0, _deprecated2.default)(_propTypes2.default.func, 'Please use onEscapeKeyDown instead for consistency'),
	
	  /**
	   * A callback fired when the backdrop, if specified, is clicked.
	   */
	  onBackdropClick: _propTypes2.default.func,
	
	  /**
	   * A style object for the backdrop component.
	   */
	  backdropStyle: _propTypes2.default.object,
	
	  /**
	   * A css class or classes for the backdrop component.
	   */
	  backdropClassName: _propTypes2.default.string,
	
	  /**
	   * A css class or set of classes applied to the modal container when the modal is open,
	   * and removed when it is closed.
	   */
	  containerClassName: _propTypes2.default.string,
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _propTypes2.default.bool,
	
	  /**
	   * A `react-transition-group@2.0.0` `<Transition/>` component used
	   * to control animations for the dialog component.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * A `react-transition-group@2.0.0` `<Transition/>` component used
	   * to control animations for the backdrop components.
	   */
	  backdropTransition: _elementType2.default,
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes. This also
	   * works correctly with any Modal children that have the `autoFocus` prop.
	   *
	   * Generally this should never be set to `false` as it makes the Modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  autoFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while open.
	   *
	   * Generally this should never be set to `false` as it makes the Modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  enforceFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will restore focus to previously focused element once
	   * modal is hidden
	   */
	  restoreFocus: _propTypes2.default.bool,
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * A ModalManager instance used to track and manage the state of open
	   * Modals. Useful when customizing how modals interact within a container
	   */
	  manager: _propTypes2.default.object.isRequired
	});
	Modal.defaultProps = {
	  show: false,
	  backdrop: true,
	  keyboard: true,
	  autoFocus: true,
	  enforceFocus: true,
	  restoreFocus: true,
	  onHide: function onHide() {},
	  manager: modalManager,
	  renderBackdrop: function renderBackdrop(props) {
	    return _react2.default.createElement('div', props);
	  }
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.state = { exited: !this.props.show };
	
	  this.renderBackdrop = function () {
	    var _props3 = _this2.props,
	        backdropStyle = _props3.backdropStyle,
	        backdropClassName = _props3.backdropClassName,
	        renderBackdrop = _props3.renderBackdrop,
	        Transition = _props3.backdropTransition;
	
	
	    var backdropRef = function backdropRef(ref) {
	      return _this2.backdrop = ref;
	    };
	
	    var backdrop = renderBackdrop({
	      ref: backdropRef,
	      style: backdropStyle,
	      className: backdropClassName,
	      onClick: _this2.handleBackdropClick
	    });
	
	    if (Transition) {
	      backdrop = _react2.default.createElement(
	        Transition,
	        {
	          appear: true,
	          'in': _this2.props.show
	        },
	        backdrop
	      );
	    }
	
	    return backdrop;
	  };
	
	  this.onPortalRendered = function () {
	    _this2.autoFocus();
	
	    if (_this2.props.onShow) {
	      _this2.props.onShow();
	    }
	  };
	
	  this.onShow = function () {
	    var doc = (0, _ownerDocument2.default)(_this2);
	    var container = (0, _getContainer2.default)(_this2.props.container, doc.body);
	
	    _this2.props.manager.add(_this2, container, _this2.props.containerClassName);
	
	    _this2._onDocumentKeydownListener = (0, _addEventListener2.default)(doc, 'keydown', _this2.handleDocumentKeyDown);
	
	    _this2._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this2.handleDocumentKeyUp);
	
	    _this2._onFocusinListener = (0, _addFocusListener2.default)(_this2.enforceFocus);
	  };
	
	  this.onHide = function () {
	    _this2.props.manager.remove(_this2);
	
	    _this2._onDocumentKeydownListener.remove();
	
	    _this2._onDocumentKeyupListener.remove();
	
	    _this2._onFocusinListener.remove();
	
	    if (_this2.props.restoreFocus) {
	      _this2.restoreLastFocus();
	    }
	  };
	
	  this.setMountNode = function (ref) {
	    _this2.mountNode = ref ? ref.getMountNode() : ref;
	  };
	
	  this.setModalNodeRef = function (ref) {
	    _this2.modalNode = ref;
	  };
	
	  this.setDialogRef = function (ref) {
	    _this2.dialog = ref;
	  };
	
	  this.handleHidden = function () {
	    _this2.setState({ exited: true });
	    _this2.onHide();
	
	    if (_this2.props.onExited) {
	      var _props4;
	
	      (_props4 = _this2.props).onExited.apply(_props4, arguments);
	    }
	  };
	
	  this.handleBackdropClick = function (e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    if (_this2.props.onBackdropClick) {
	      _this2.props.onBackdropClick(e);
	    }
	
	    if (_this2.props.backdrop === true) {
	      _this2.props.onHide();
	    }
	  };
	
	  this.handleDocumentKeyDown = function (e) {
	    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
	      if (_this2.props.onEscapeKeyDown) {
	        _this2.props.onEscapeKeyDown(e);
	      }
	
	      _this2.props.onHide();
	    }
	  };
	
	  this.handleDocumentKeyUp = function (e) {
	    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
	      if (_this2.props.onEscapeKeyUp) {
	        _this2.props.onEscapeKeyUp(e);
	      }
	    }
	  };
	
	  this.checkForFocus = function () {
	    if (_inDOM2.default) {
	      _this2.lastFocus = (0, _activeElement2.default)();
	    }
	  };
	
	  this.enforceFocus = function () {
	    if (!_this2.props.enforceFocus || !_this2._isMounted || !_this2.isTopModal()) {
	      return;
	    }
	
	    var dialogElement = _this2.getDialogElement();
	    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this2));
	
	    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
	      dialogElement.focus();
	    }
	  };
	};
	
	Modal.Manager = _ModalManager2.default;
	
	exports.default = Modal;
	module.exports = exports['default'];

/***/ },
/* 2034 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class = __webpack_require__(1733);
	
	var _class2 = _interopRequireDefault(_class);
	
	var _style = __webpack_require__(226);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _scrollbarSize = __webpack_require__(833);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _isOverflowing = __webpack_require__(911);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _manageAriaHidden = __webpack_require__(2040);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function findIndexOf(arr, cb) {
	  var idx = -1;
	  arr.some(function (d, i) {
	    if (cb(d, i)) {
	      idx = i;
	      return true;
	    }
	  });
	  return idx;
	}
	
	function findContainer(data, modal) {
	  return findIndexOf(data, function (d) {
	    return d.modals.indexOf(modal) !== -1;
	  });
	}
	
	function setContainerStyle(state, container) {
	  var style = { overflow: 'hidden' };
	
	  // we are only interested in the actual `style` here
	  // becasue we will override it
	  state.style = {
	    overflow: container.style.overflow,
	    paddingRight: container.style.paddingRight
	  };
	
	  if (state.overflowing) {
	    // use computed style, here to get the real padding
	    // to add our scrollbar width
	    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
	  }
	
	  (0, _style2.default)(container, style);
	}
	
	function removeContainerStyle(_ref, container) {
	  var style = _ref.style;
	
	
	  Object.keys(style).forEach(function (key) {
	    return container.style[key] = style[key];
	  });
	}
	/**
	 * Proper state managment for containers and the modals in those containers.
	 *
	 * @internal Used by the Modal to ensure proper styling of containers.
	 */
	
	var ModalManager = function ModalManager() {
	  var _this = this;
	
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
	      hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
	      _ref2$handleContainer = _ref2.handleContainerOverflow,
	      handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;
	
	  _classCallCheck(this, ModalManager);
	
	  this.add = function (modal, container, className) {
	    var modalIdx = _this.modals.indexOf(modal);
	    var containerIdx = _this.containers.indexOf(container);
	
	    if (modalIdx !== -1) {
	      return modalIdx;
	    }
	
	    modalIdx = _this.modals.length;
	    _this.modals.push(modal);
	
	    if (_this.hideSiblingNodes) {
	      (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
	    }
	
	    if (containerIdx !== -1) {
	      _this.data[containerIdx].modals.push(modal);
	      return modalIdx;
	    }
	
	    var data = {
	      modals: [modal],
	      //right now only the first modal of a container will have its classes applied
	      classes: className ? className.split(/\s+/) : [],
	
	      overflowing: (0, _isOverflowing2.default)(container)
	    };
	
	    if (_this.handleContainerOverflow) {
	      setContainerStyle(data, container);
	    }
	
	    data.classes.forEach(_class2.default.addClass.bind(null, container));
	
	    _this.containers.push(container);
	    _this.data.push(data);
	
	    return modalIdx;
	  };
	
	  this.remove = function (modal) {
	    var modalIdx = _this.modals.indexOf(modal);
	
	    if (modalIdx === -1) {
	      return;
	    }
	
	    var containerIdx = findContainer(_this.data, modal);
	    var data = _this.data[containerIdx];
	    var container = _this.containers[containerIdx];
	
	    data.modals.splice(data.modals.indexOf(modal), 1);
	
	    _this.modals.splice(modalIdx, 1);
	
	    // if that was the last modal in a container,
	    // clean up the container
	    if (data.modals.length === 0) {
	      data.classes.forEach(_class2.default.removeClass.bind(null, container));
	
	      if (_this.handleContainerOverflow) {
	        removeContainerStyle(data, container);
	      }
	
	      if (_this.hideSiblingNodes) {
	        (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
	      }
	      _this.containers.splice(containerIdx, 1);
	      _this.data.splice(containerIdx, 1);
	    } else if (_this.hideSiblingNodes) {
	      //otherwise make sure the next top modal is visible to a SR
	      (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
	    }
	  };
	
	  this.isTopModal = function (modal) {
	    return !!_this.modals.length && _this.modals[_this.modals.length - 1] === modal;
	  };
	
	  this.hideSiblingNodes = hideSiblingNodes;
	  this.handleContainerOverflow = handleContainerOverflow;
	  this.modals = [];
	  this.containers = [];
	  this.data = [];
	};
	
	exports.default = ModalManager;
	module.exports = exports['default'];

/***/ },
/* 2035 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(156);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(34);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(908);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Position = __webpack_require__(2036);
	
	var _Position2 = _interopRequireDefault(_Position);
	
	var _RootCloseWrapper = __webpack_require__(909);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
	 */
	var Overlay = function (_React$Component) {
	  _inherits(Overlay, _React$Component);
	
	  function Overlay(props, context) {
	    _classCallCheck(this, Overlay);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleHidden = function () {
	      _this.setState({ exited: true });
	
	      if (_this.props.onExited) {
	        var _this$props;
	
	        (_this$props = _this.props).onExited.apply(_this$props, arguments);
	      }
	    };
	
	    _this.state = { exited: !props.show };
	    _this.onHiddenListener = _this.handleHidden.bind(_this);
	    return _this;
	  }
	
	  Overlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  };
	
	  Overlay.prototype.render = function render() {
	    var _props = this.props,
	        container = _props.container,
	        containerPadding = _props.containerPadding,
	        target = _props.target,
	        placement = _props.placement,
	        shouldUpdatePosition = _props.shouldUpdatePosition,
	        rootClose = _props.rootClose,
	        children = _props.children,
	        Transition = _props.transition,
	        props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);
	
	    // Don't un-render the overlay while it's transitioning out.
	
	
	    var mountOverlay = props.show || Transition && !this.state.exited;
	    if (!mountOverlay) {
	      // Don't bother showing anything if we don't have to.
	      return null;
	    }
	
	    var child = children;
	
	    // Position is be inner-most because it adds inline styles into the child,
	    // which the other wrappers don't forward correctly.
	    child = _react2.default.createElement(
	      _Position2.default,
	      { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
	      child
	    );
	
	    if (Transition) {
	      var onExit = props.onExit,
	          onExiting = props.onExiting,
	          onEnter = props.onEnter,
	          onEntering = props.onEntering,
	          onEntered = props.onEntered;
	
	      // This animates the child node by injecting props, so it must precede
	      // anything that adds a wrapping div.
	
	      child = _react2.default.createElement(
	        Transition,
	        {
	          'in': props.show,
	          appear: true,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.onHiddenListener,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        child
	      );
	    }
	
	    // This goes after everything else because it adds a wrapping div.
	    if (rootClose) {
	      child = _react2.default.createElement(
	        _RootCloseWrapper2.default,
	        { onRootClose: props.onHide },
	        child
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      { container: container },
	      child
	    );
	  };
	
	  return Overlay;
	}(_react2.default.Component);
	
	Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _propTypes2.default.bool,
	
	  /**
	   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
	   */
	  rootClose: _propTypes2.default.bool,
	
	  /**
	   * A Callback fired by the Overlay when it wishes to be hidden.
	   *
	   * __required__ when `rootClose` is `true`.
	   *
	   * @type func
	   */
	  onHide: function onHide(props) {
	    var propType = _propTypes2.default.func;
	    if (props.rootClose) {
	      propType = propType.isRequired;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return propType.apply(undefined, [props].concat(args));
	  },
	
	
	  /**
	   * A `react-transition-group@2.0.0` `<Transition/>` component
	   * used to animate the overlay as it changes visibility.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _propTypes2.default.func
	});
	
	exports.default = Overlay;
	module.exports = exports['default'];

/***/ },
/* 2036 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(156);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(315);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _calculatePosition = __webpack_require__(2039);
	
	var _calculatePosition2 = _interopRequireDefault(_calculatePosition);
	
	var _getContainer = __webpack_require__(324);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(193);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The Position component calculates the coordinates for its child, to position
	 * it relative to a `target` component or node. Useful for creating callouts
	 * and tooltips, the Position component injects a `style` props with `left` and
	 * `top` values for positioning your component.
	 *
	 * It also injects "arrow" `left`, and `top` values for styling callout arrows
	 * for giving your components a sense of directionality.
	 */
	var Position = function (_React$Component) {
	  _inherits(Position, _React$Component);
	
	  function Position(props, context) {
	    _classCallCheck(this, Position);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.getTarget = function () {
	      var target = _this.props.target;
	
	      var targetElement = typeof target === 'function' ? target() : target;
	      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
	    };
	
	    _this.maybeUpdatePosition = function (placementChanged) {
	      var target = _this.getTarget();
	
	      if (!_this.props.shouldUpdatePosition && target === _this._lastTarget && !placementChanged) {
	        return;
	      }
	
	      _this.updatePosition(target);
	    };
	
	    _this.state = {
	      positionLeft: 0,
	      positionTop: 0,
	      arrowOffsetLeft: null,
	      arrowOffsetTop: null
	    };
	
	    _this._needsFlush = false;
	    _this._lastTarget = null;
	    return _this;
	  }
	
	  Position.prototype.componentDidMount = function componentDidMount() {
	    this.updatePosition(this.getTarget());
	  };
	
	  Position.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
	    this._needsFlush = true;
	  };
	
	  Position.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this._needsFlush) {
	      this._needsFlush = false;
	      this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
	    }
	  };
	
	  Position.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        className = _props.className,
	        props = _objectWithoutProperties(_props, ['children', 'className']);
	
	    var _state = this.state,
	        positionLeft = _state.positionLeft,
	        positionTop = _state.positionTop,
	        arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);
	
	    // These should not be forwarded to the child.
	
	
	    delete props.target;
	    delete props.container;
	    delete props.containerPadding;
	    delete props.shouldUpdatePosition;
	
	    var child = _react2.default.Children.only(children);
	    return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
	      // FIXME: Don't forward `positionLeft` and `positionTop` via both props
	      // and `props.style`.
	      positionLeft: positionLeft,
	      positionTop: positionTop,
	      className: (0, _classnames2.default)(className, child.props.className),
	      style: _extends({}, child.props.style, {
	        left: positionLeft,
	        top: positionTop
	      })
	    }));
	  };
	
	  Position.prototype.updatePosition = function updatePosition(target) {
	    this._lastTarget = target;
	
	    if (!target) {
	      this.setState({
	        positionLeft: 0,
	        positionTop: 0,
	        arrowOffsetLeft: null,
	        arrowOffsetTop: null
	      });
	
	      return;
	    }
	
	    var overlay = _reactDom2.default.findDOMNode(this);
	    var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	
	    this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
	  };
	
	  return Position;
	}(_react2.default.Component);
	
	Position.propTypes = {
	  /**
	   * A node, element, or function that returns either. The child will be
	   * be positioned next to the `target` specified.
	   */
	  target: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  /**
	   * "offsetParent" of the component
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	  /**
	   * Minimum spacing in pixels between container border and component border
	   */
	  containerPadding: _propTypes2.default.number,
	  /**
	   * How to position the component relative to the target
	   */
	  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	  /**
	   * Whether the position should be changed on each update
	   */
	  shouldUpdatePosition: _propTypes2.default.bool
	};
	
	Position.displayName = 'Position';
	
	Position.defaultProps = {
	  containerPadding: 0,
	  placement: 'right',
	  shouldUpdatePosition: false
	};
	
	exports.default = Position;
	module.exports = exports['default'];

/***/ },
/* 2037 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(156);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  children: _propTypes2.default.node
	};
	
	/**
	 * Internal helper component to allow attaching a non-conflicting ref to a
	 * child element that may not accept refs.
	 */
	
	var RefHolder = function (_React$Component) {
	  _inherits(RefHolder, _React$Component);
	
	  function RefHolder() {
	    _classCallCheck(this, RefHolder);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  RefHolder.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return RefHolder;
	}(_react2.default.Component);
	
	RefHolder.propTypes = propTypes;
	
	exports.default = RefHolder;
	module.exports = exports['default'];

/***/ },
/* 2038 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = addFocusListener;
	/**
	 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
	 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
	 *
	 * We only allow one Listener at a time to avoid stack overflows
	 */
	function addFocusListener(handler) {
	  var useFocusin = !document.addEventListener;
	  var remove = void 0;
	
	  if (useFocusin) {
	    document.attachEvent('onfocusin', handler);
	    remove = function remove() {
	      return document.detachEvent('onfocusin', handler);
	    };
	  } else {
	    document.addEventListener('focus', handler, true);
	    remove = function remove() {
	      return document.removeEventListener('focus', handler, true);
	    };
	  }
	
	  return { remove: remove };
	}
	module.exports = exports['default'];

/***/ },
/* 2039 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = calculatePosition;
	
	var _offset = __webpack_require__(830);
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _position = __webpack_require__(1739);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _scrollTop = __webpack_require__(831);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _ownerDocument = __webpack_require__(193);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainerDimensions(containerNode) {
	  var width = void 0,
	      height = void 0,
	      scroll = void 0;
	
	  if (containerNode.tagName === 'BODY') {
	    width = window.innerWidth;
	    height = window.innerHeight;
	
	    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
	  } else {
	    var _getOffset = (0, _offset2.default)(containerNode);
	
	    width = _getOffset.width;
	    height = _getOffset.height;
	
	    scroll = (0, _scrollTop2.default)(containerNode);
	  }
	
	  return { width: width, height: height, scroll: scroll };
	}
	
	function getTopDelta(top, overlayHeight, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerScroll = containerDimensions.scroll;
	  var containerHeight = containerDimensions.height;
	
	  var topEdgeOffset = top - padding - containerScroll;
	  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;
	
	  if (topEdgeOffset < 0) {
	    return -topEdgeOffset;
	  } else if (bottomEdgeOffset > containerHeight) {
	    return containerHeight - bottomEdgeOffset;
	  } else {
	    return 0;
	  }
	}
	
	function getLeftDelta(left, overlayWidth, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerWidth = containerDimensions.width;
	
	  var leftEdgeOffset = left - padding;
	  var rightEdgeOffset = left + padding + overlayWidth;
	
	  if (leftEdgeOffset < 0) {
	    return -leftEdgeOffset;
	  } else if (rightEdgeOffset > containerWidth) {
	    return containerWidth - rightEdgeOffset;
	  }
	
	  return 0;
	}
	
	function calculatePosition(placement, overlayNode, target, container, padding) {
	  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);
	
	  var _getOffset2 = (0, _offset2.default)(overlayNode),
	      overlayHeight = _getOffset2.height,
	      overlayWidth = _getOffset2.width;
	
	  var positionLeft = void 0,
	      positionTop = void 0,
	      arrowOffsetLeft = void 0,
	      arrowOffsetTop = void 0;
	
	  if (placement === 'left' || placement === 'right') {
	    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;
	
	    if (placement === 'left') {
	      positionLeft = childOffset.left - overlayWidth;
	    } else {
	      positionLeft = childOffset.left + childOffset.width;
	    }
	
	    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);
	
	    positionTop += topDelta;
	    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
	    arrowOffsetLeft = void 0;
	  } else if (placement === 'top' || placement === 'bottom') {
	    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;
	
	    if (placement === 'top') {
	      positionTop = childOffset.top - overlayHeight;
	    } else {
	      positionTop = childOffset.top + childOffset.height;
	    }
	
	    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);
	
	    positionLeft += leftDelta;
	    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
	    arrowOffsetTop = void 0;
	  } else {
	    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
	  }
	
	  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
	}
	module.exports = exports['default'];

/***/ },
/* 2040 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	
	var BLACKLIST = ['template', 'script', 'style'];
	
	var isHidable = function isHidable(_ref) {
	  var nodeType = _ref.nodeType,
	      tagName = _ref.tagName;
	  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
	};
	
	var siblings = function siblings(container, mount, cb) {
	  mount = [].concat(mount);
	
	  [].forEach.call(container.children, function (node) {
	    if (mount.indexOf(node) === -1 && isHidable(node)) {
	      cb(node);
	    }
	  });
	};
	
	function ariaHidden(show, node) {
	  if (!node) {
	    return;
	  }
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(false, node);
	  });
	}

/***/ },
/* 2041 */
[2242, 2042],
/* 2042 */
1016,
/* 2043 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}

/***/ },
/* 2044 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(917);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PropTypes = __webpack_require__(914);
	
	var _warning = __webpack_require__(517);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider() {
	  var _Provider$childContex;
	
	  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
	  var subKey = arguments[1];
	
	  var subscriptionKey = subKey || storeKey + 'Subscription';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      _classCallCheck(this, Provider);
	
	      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    Provider.prototype.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    Provider.prototype.componentWillReceiveProps = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes2.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	
	  return Provider;
	}
	
	exports.default = createProvider();

/***/ },
/* 2045 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createConnect = createConnect;
	
	var _connectAdvanced = __webpack_require__(912);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _shallowEqual = __webpack_require__(2052);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapDispatchToProps = __webpack_require__(2046);
	
	var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);
	
	var _mapStateToProps = __webpack_require__(2047);
	
	var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);
	
	var _mergeProps = __webpack_require__(2048);
	
	var _mergeProps2 = _interopRequireDefault(_mergeProps);
	
	var _selectorFactory = __webpack_require__(2049);
	
	var _selectorFactory2 = _interopRequireDefault(_selectorFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	exports.default = createConnect();

/***/ },
/* 2046 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _redux = __webpack_require__(240);
	
	var _wrapMapToProps = __webpack_require__(913);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ },
/* 2047 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(913);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ },
/* 2048 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	
	var _verifyPlainObject = __webpack_require__(915);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ },
/* 2049 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _verifySubselectors = __webpack_require__(2050);
	
	var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 2050 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = __webpack_require__(517);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 2051 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub, onStateChange) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ },
/* 2052 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 2053 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 2054 */
[2247, 916, 2057, 2058],
/* 2055 */
852,
/* 2056 */
[2248, 2059],
/* 2057 */
[2249, 916],
/* 2058 */
1050,
/* 2059 */
1051,
/* 2060 */
[2250, 2055],
/* 2061 */
1053,
/* 2062 */
[2251, 2054, 2056, 2061],
/* 2063 */
[2242, 2064],
/* 2064 */
1016,
/* 2065 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(47);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(326);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createBrowserHistory = __webpack_require__(2075);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _Router = __webpack_require__(518);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses HTML5 history.
	 */
	var BrowserRouter = function (_React$Component) {
	  _inherits(BrowserRouter, _React$Component);
	
	  function BrowserRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BrowserRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createBrowserHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
	  };
	
	  BrowserRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return BrowserRouter;
	}(_react2.default.Component);
	
	BrowserRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  forceRefresh: _propTypes2.default.bool,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = BrowserRouter;

/***/ },
/* 2066 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(47);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(326);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createHashHistory = __webpack_require__(2076);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _Router = __webpack_require__(518);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses window.location.hash.
	 */
	var HashRouter = function (_React$Component) {
	  _inherits(HashRouter, _React$Component);
	
	  function HashRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HashRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createHashHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HashRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
	  };
	
	  HashRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return HashRouter;
	}(_react2.default.Component);
	
	HashRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  getUserConfirmation: _propTypes2.default.func,
	  hashType: _propTypes2.default.oneOf(['hashbang', 'noslash', 'slash']),
	  children: _propTypes2.default.node
	};
	exports.default = HashRouter;

/***/ },
/* 2067 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MemoryRouter = __webpack_require__(2083);
	
	var _MemoryRouter2 = _interopRequireDefault(_MemoryRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MemoryRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 2068 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(326);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Route = __webpack_require__(919);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	var _Link = __webpack_require__(918);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A <Link> wrapper that knows if it's "active" or not.
	 */
	var NavLink = function NavLink(_ref) {
	  var to = _ref.to,
	      exact = _ref.exact,
	      strict = _ref.strict,
	      location = _ref.location,
	      activeClassName = _ref.activeClassName,
	      className = _ref.className,
	      activeStyle = _ref.activeStyle,
	      style = _ref.style,
	      getIsActive = _ref.isActive,
	      ariaCurrent = _ref.ariaCurrent,
	      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);
	
	  return _react2.default.createElement(_Route2.default, {
	    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
	    exact: exact,
	    strict: strict,
	    location: location,
	    children: function children(_ref2) {
	      var location = _ref2.location,
	          match = _ref2.match;
	
	      var isActive = !!(getIsActive ? getIsActive(match, location) : match);
	
	      return _react2.default.createElement(_Link2.default, _extends({
	        to: to,
	        className: isActive ? [className, activeClassName].filter(function (i) {
	          return i;
	        }).join(' ') : className,
	        style: isActive ? _extends({}, style, activeStyle) : style,
	        'aria-current': isActive && ariaCurrent
	      }, rest));
	    }
	  });
	};
	
	NavLink.propTypes = {
	  to: _Link2.default.propTypes.to,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  location: _propTypes2.default.object,
	  activeClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  isActive: _propTypes2.default.func,
	  ariaCurrent: _propTypes2.default.oneOf(['page', 'step', 'location', 'true'])
	};
	
	NavLink.defaultProps = {
	  activeClassName: 'active',
	  ariaCurrent: 'true'
	};
	
	exports.default = NavLink;

/***/ },
/* 2069 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Prompt = __webpack_require__(2084);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Prompt2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 2070 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Redirect = __webpack_require__(2085);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Redirect2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 2071 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _StaticRouter = __webpack_require__(2086);
	
	var _StaticRouter2 = _interopRequireDefault(_StaticRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _StaticRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 2072 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Switch = __webpack_require__(2087);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Switch2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 2073 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _matchPath = __webpack_require__(521);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _matchPath2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 2074 */
[2410, 2079],
/* 2075 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(921)('createBrowserHistory');
	module.exports = __webpack_require__(920).createBrowserHistory;


/***/ },
/* 2076 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(921)('createHashHistory');
	module.exports = __webpack_require__(920).createHashHistory;


/***/ },
/* 2077 */
[2242, 2078],
/* 2078 */
1016,
/* 2079 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function valueEqual(a, b) {
	  if (a === b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return valueEqual(item, b[index]);
	    });
	  }
	
	  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (aType !== bType) return false;
	
	  if (aType === 'object') {
	    var aValue = a.valueOf();
	    var bValue = b.valueOf();
	
	    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
	
	    var aKeys = Object.keys(a);
	    var bKeys = Object.keys(b);
	
	    if (aKeys.length !== bKeys.length) return false;
	
	    return aKeys.every(function (key) {
	      return valueEqual(a[key], b[key]);
	    });
	  }
	
	  return false;
	}
	
	exports.default = valueEqual;
	module.exports = exports['default'];

/***/ },
/* 2080 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _withRouter = __webpack_require__(2095);
	
	var _withRouter2 = _interopRequireDefault(_withRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _withRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 2081 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = routerMiddleware;
	
	var _actions = __webpack_require__(922);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	
	        history[method].apply(history, _toConsumableArray(args));
	      };
	    };
	  };
	}

/***/ },
/* 2082 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = syncHistoryWithStore;
	
	var _reducer = __webpack_require__(923);
	
	var defaultSelectLocationState = function defaultSelectLocationState(state) {
	  return state.routing;
	};
	
	/**
	 * This function synchronizes your history state with the Redux store.
	 * Location changes flow from history to the store. An enhanced history is
	 * returned with a listen method that responds to store updates for location.
	 *
	 * When this history is provided to the router, this means the location data
	 * will flow like this:
	 * history.push -> store.dispatch -> enhancedHistory.listen -> router
	 * This ensures that when the store state changes due to a replay or other
	 * event, the router will be updated appropriately and can transition to the
	 * correct router state.
	 */
	function syncHistoryWithStore(history, store) {
	  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      _ref$selectLocationSt = _ref.selectLocationState,
	      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
	      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
	      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;
	
	  // Ensure that the reducer is mounted on the store and functioning properly.
	  if (typeof selectLocationState(store.getState()) === 'undefined') {
	    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
	  }
	
	  var initialLocation = void 0;
	  var isTimeTraveling = void 0;
	  var unsubscribeFromStore = void 0;
	  var unsubscribeFromHistory = void 0;
	  var currentLocation = void 0;
	
	  // What does the store say about current location?
	  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
	    var locationState = selectLocationState(store.getState());
	    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
	  };
	
	  // Init initialLocation with potential location in store
	  initialLocation = getLocationInStore();
	
	  // If the store is replayed, update the URL in the browser to match.
	  if (adjustUrlOnReplay) {
	    var handleStoreChange = function handleStoreChange() {
	      var locationInStore = getLocationInStore(true);
	      if (currentLocation === locationInStore || initialLocation === locationInStore) {
	        return;
	      }
	
	      // Update address bar to reflect store state
	      isTimeTraveling = true;
	      currentLocation = locationInStore;
	      history.transitionTo(_extends({}, locationInStore, {
	        action: 'PUSH'
	      }));
	      isTimeTraveling = false;
	    };
	
	    unsubscribeFromStore = store.subscribe(handleStoreChange);
	    handleStoreChange();
	  }
	
	  // Whenever location changes, dispatch an action to get it in the store
	  var handleLocationChange = function handleLocationChange(location) {
	    // ... unless we just caused that location change
	    if (isTimeTraveling) {
	      return;
	    }
	
	    // Remember where we are
	    currentLocation = location;
	
	    // Are we being called for the first time?
	    if (!initialLocation) {
	      // Remember as a fallback in case state is reset
	      initialLocation = location;
	
	      // Respect persisted location, if any
	      if (getLocationInStore()) {
	        return;
	      }
	    }
	
	    // Tell the store to update by dispatching an action
	    store.dispatch({
	      type: _reducer.LOCATION_CHANGE,
	      payload: location
	    });
	  };
	  unsubscribeFromHistory = history.listen(handleLocationChange);
	
	  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
	  if (history.getCurrentLocation) {
	    handleLocationChange(history.getCurrentLocation());
	  }
	
	  // The enhanced history uses store as source of truth
	  return _extends({}, history, {
	    // The listeners are subscribed to the store instead of history
	    listen: function listen(listener) {
	      // Copy of last location.
	      var lastPublishedLocation = getLocationInStore(true);
	
	      // Keep track of whether we unsubscribed, as Redux store
	      // only applies changes in subscriptions on next dispatch
	      var unsubscribed = false;
	      var unsubscribeFromStore = store.subscribe(function () {
	        var currentLocation = getLocationInStore(true);
	        if (currentLocation === lastPublishedLocation) {
	          return;
	        }
	        lastPublishedLocation = currentLocation;
	        if (!unsubscribed) {
	          listener(lastPublishedLocation);
	        }
	      });
	
	      // History 2.x listeners expect a synchronous call. Make the first call to the
	      // listener after subscribing to the store, in case the listener causes a
	      // location change (e.g. when it redirects)
	      if (!history.getCurrentLocation) {
	        listener(lastPublishedLocation);
	      }
	
	      // Let user unsubscribe later
	      return function () {
	        unsubscribed = true;
	        unsubscribeFromStore();
	      };
	    },
	
	
	    // It also provides a way to destroy internal listeners
	    unsubscribe: function unsubscribe() {
	      if (adjustUrlOnReplay) {
	        unsubscribeFromStore();
	      }
	      unsubscribeFromHistory();
	    }
	  });
	}

/***/ },
/* 2083 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(194);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(126);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(522);
	
	var _Router = __webpack_require__(520);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that stores location in memory.
	 */
	var MemoryRouter = function (_React$Component) {
	  _inherits(MemoryRouter, _React$Component);
	
	  function MemoryRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MemoryRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _history.createMemoryHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
	  };
	
	  MemoryRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return MemoryRouter;
	}(_react2.default.Component);
	
	MemoryRouter.propTypes = {
	  initialEntries: _propTypes2.default.array,
	  initialIndex: _propTypes2.default.number,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = MemoryRouter;

/***/ },
/* 2084 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(126);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(68);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for prompting the user before navigating away
	 * from a screen with a component.
	 */
	var Prompt = function (_React$Component) {
	  _inherits(Prompt, _React$Component);
	
	  function Prompt() {
	    _classCallCheck(this, Prompt);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Prompt.prototype.enable = function enable(message) {
	    if (this.unblock) this.unblock();
	
	    this.unblock = this.context.router.history.block(message);
	  };
	
	  Prompt.prototype.disable = function disable() {
	    if (this.unblock) {
	      this.unblock();
	      this.unblock = null;
	    }
	  };
	
	  Prompt.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Prompt> outside a <Router>");
	
	    if (this.props.when) this.enable(this.props.message);
	  };
	
	  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.when) {
	      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
	    } else {
	      this.disable();
	    }
	  };
	
	  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.disable();
	  };
	
	  Prompt.prototype.render = function render() {
	    return null;
	  };
	
	  return Prompt;
	}(_react2.default.Component);
	
	Prompt.propTypes = {
	  when: _propTypes2.default.bool,
	  message: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	};
	Prompt.defaultProps = {
	  when: true
	};
	Prompt.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      block: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Prompt;

/***/ },
/* 2085 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(126);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(194);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(68);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(522);
	
	var _generatePath = __webpack_require__(2088);
	
	var _generatePath2 = _interopRequireDefault(_generatePath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for updating the location programmatically
	 * with a component.
	 */
	var Redirect = function (_React$Component) {
	  _inherits(Redirect, _React$Component);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Redirect.prototype.isStatic = function isStatic() {
	    return this.context.router && this.context.router.staticContext;
	  };
	
	  Redirect.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Redirect> outside a <Router>");
	
	    if (this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidMount = function componentDidMount() {
	    if (!this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var prevTo = (0, _history.createLocation)(prevProps.to);
	    var nextTo = (0, _history.createLocation)(this.props.to);
	
	    if ((0, _history.locationsAreEqual)(prevTo, nextTo)) {
	      (0, _warning2.default)(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
	      return;
	    }
	
	    this.perform();
	  };
	
	  Redirect.prototype.computeTo = function computeTo(_ref) {
	    var computedMatch = _ref.computedMatch,
	        to = _ref.to;
	
	    if (computedMatch) {
	      if (typeof to === "string") {
	        return (0, _generatePath2.default)(to, computedMatch.params);
	      } else {
	        return _extends({}, to, {
	          pathname: (0, _generatePath2.default)(to.pathname, computedMatch.params)
	        });
	      }
	    }
	
	    return to;
	  };
	
	  Redirect.prototype.perform = function perform() {
	    var history = this.context.router.history;
	    var push = this.props.push;
	
	    var to = this.computeTo(this.props);
	
	    if (push) {
	      history.push(to);
	    } else {
	      history.replace(to);
	    }
	  };
	
	  Redirect.prototype.render = function render() {
	    return null;
	  };
	
	  return Redirect;
	}(_react2.default.Component);
	
	Redirect.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  push: _propTypes2.default.bool,
	  from: _propTypes2.default.string,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	};
	Redirect.defaultProps = {
	  push: false
	};
	Redirect.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired
	    }).isRequired,
	    staticContext: _propTypes2.default.object
	  }).isRequired
	};
	exports.default = Redirect;

/***/ },
/* 2086 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(194);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(68);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(126);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(522);
	
	var _Router = __webpack_require__(520);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === "/" ? path : "/" + path;
	};
	
	var addBasename = function addBasename(basename, location) {
	  if (!basename) return location;
	
	  return _extends({}, location, {
	    pathname: addLeadingSlash(basename) + location.pathname
	  });
	};
	
	var stripBasename = function stripBasename(basename, location) {
	  if (!basename) return location;
	
	  var base = addLeadingSlash(basename);
	
	  if (location.pathname.indexOf(base) !== 0) return location;
	
	  return _extends({}, location, {
	    pathname: location.pathname.substr(base.length)
	  });
	};
	
	var createURL = function createURL(location) {
	  return typeof location === "string" ? location : (0, _history.createPath)(location);
	};
	
	var staticHandler = function staticHandler(methodName) {
	  return function () {
	    (0, _invariant2.default)(false, "You cannot %s with <StaticRouter>", methodName);
	  };
	};
	
	var noop = function noop() {};
	
	/**
	 * The public top-level API for a "static" <Router>, so-called because it
	 * can't actually change the current location. Instead, it just records
	 * location changes in a context object. Useful mainly in testing and
	 * server-rendering scenarios.
	 */
	
	var StaticRouter = function (_React$Component) {
	  _inherits(StaticRouter, _React$Component);
	
	  function StaticRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StaticRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
	      return addLeadingSlash(_this.props.basename + createURL(path));
	    }, _this.handlePush = function (location) {
	      var _this$props = _this.props,
	          basename = _this$props.basename,
	          context = _this$props.context;
	
	      context.action = "PUSH";
	      context.location = addBasename(basename, (0, _history.createLocation)(location));
	      context.url = createURL(context.location);
	    }, _this.handleReplace = function (location) {
	      var _this$props2 = _this.props,
	          basename = _this$props2.basename,
	          context = _this$props2.context;
	
	      context.action = "REPLACE";
	      context.location = addBasename(basename, (0, _history.createLocation)(location));
	      context.url = createURL(context.location);
	    }, _this.handleListen = function () {
	      return noop;
	    }, _this.handleBlock = function () {
	      return noop;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StaticRouter.prototype.getChildContext = function getChildContext() {
	    return {
	      router: {
	        staticContext: this.props.context
	      }
	    };
	  };
	
	  StaticRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
	  };
	
	  StaticRouter.prototype.render = function render() {
	    var _props = this.props,
	        basename = _props.basename,
	        context = _props.context,
	        location = _props.location,
	        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);
	
	    var history = {
	      createHref: this.createHref,
	      action: "POP",
	      location: stripBasename(basename, (0, _history.createLocation)(location)),
	      push: this.handlePush,
	      replace: this.handleReplace,
	      go: staticHandler("go"),
	      goBack: staticHandler("goBack"),
	      goForward: staticHandler("goForward"),
	      listen: this.handleListen,
	      block: this.handleBlock
	    };
	
	    return _react2.default.createElement(_Router2.default, _extends({}, props, { history: history }));
	  };
	
	  return StaticRouter;
	}(_react2.default.Component);
	
	StaticRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  context: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	StaticRouter.defaultProps = {
	  basename: "",
	  location: "/"
	};
	StaticRouter.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = StaticRouter;

/***/ },
/* 2087 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(126);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(194);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(68);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _matchPath = __webpack_require__(521);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for rendering the first <Route> that matches.
	 */
	var Switch = function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Switch.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Switch> outside a <Router>");
	  };
	
	  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	  };
	
	  Switch.prototype.render = function render() {
	    var route = this.context.router.route;
	    var children = this.props.children;
	
	    var location = this.props.location || route.location;
	
	    var match = void 0,
	        child = void 0;
	    _react2.default.Children.forEach(children, function (element) {
	      if (match == null && _react2.default.isValidElement(element)) {
	        var _element$props = element.props,
	            pathProp = _element$props.path,
	            exact = _element$props.exact,
	            strict = _element$props.strict,
	            sensitive = _element$props.sensitive,
	            from = _element$props.from;
	
	        var path = pathProp || from;
	
	        child = element;
	        match = (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
	      }
	    });
	
	    return match ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
	  };
	
	  return Switch;
	}(_react2.default.Component);
	
	Switch.contextTypes = {
	  router: _propTypes2.default.shape({
	    route: _propTypes2.default.object.isRequired
	  }).isRequired
	};
	Switch.propTypes = {
	  children: _propTypes2.default.node,
	  location: _propTypes2.default.object
	};
	exports.default = Switch;

/***/ },
/* 2088 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(925);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compileGenerator = function compileGenerator(pattern) {
	  var cacheKey = pattern;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var compiledGenerator = _pathToRegexp2.default.compile(pattern);
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledGenerator;
	    cacheCount++;
	  }
	
	  return compiledGenerator;
	};
	
	/**
	 * Public API for generating a URL pathname from a pattern and parameters.
	 */
	var generatePath = function generatePath() {
	  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (pattern === "/") {
	    return pattern;
	  }
	  var generator = compileGenerator(pattern);
	  return generator(params, { pretty: true });
	};
	
	exports.default = generatePath;

/***/ },
/* 2089 */
[2410, 2094],
/* 2090 */
2053,
/* 2091 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 2092 */
[2242, 2093],
/* 2093 */
1016,
/* 2094 */
2079,
/* 2095 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(126);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(2090);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _Route = __webpack_require__(924);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A public higher-order component to access the imperative API
	 */
	var withRouter = function withRouter(Component) {
	  var C = function C(props) {
	    var wrappedComponentRef = props.wrappedComponentRef,
	        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);
	
	    return _react2.default.createElement(_Route2.default, {
	      children: function children(routeComponentProps) {
	        return _react2.default.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
	          ref: wrappedComponentRef
	        }));
	      }
	    });
	  };
	
	  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
	  C.WrappedComponent = Component;
	  C.propTypes = {
	    wrappedComponentRef: _propTypes2.default.func
	  };
	
	  return (0, _hoistNonReactStatics2.default)(C, Component);
	};
	
	exports.default = withRouter;

/***/ },
/* 2096 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(157);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Select = __webpack_require__(327);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Async = __webpack_require__(926);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _Creatable = __webpack_require__(927);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AsyncCreatableSelect = function (_React$Component) {
		_inherits(AsyncCreatableSelect, _React$Component);
	
		function AsyncCreatableSelect() {
			_classCallCheck(this, AsyncCreatableSelect);
	
			return _possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
		}
	
		_createClass(AsyncCreatableSelect, [{
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					_Async2.default,
					this.props,
					function (_ref) {
						var ref = _ref.ref,
						    asyncProps = _objectWithoutProperties(_ref, ['ref']);
	
						var asyncRef = ref;
						return _react2.default.createElement(
							_Creatable2.default,
							asyncProps,
							function (_ref2) {
								var ref = _ref2.ref,
								    creatableProps = _objectWithoutProperties(_ref2, ['ref']);
	
								var creatableRef = ref;
								return _this2.props.children(_extends({}, creatableProps, {
									ref: function ref(select) {
										creatableRef(select);
										asyncRef(select);
										_this2.select = select;
									}
								}));
							}
						);
					}
				);
			}
		}]);
	
		return AsyncCreatableSelect;
	}(_react2.default.Component);
	
	;
	
	function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	AsyncCreatableSelect.propTypes = {
		children: _propTypes2.default.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	};
	
	AsyncCreatableSelect.defaultProps = {
		children: defaultChildren
	};
	
	exports.default = AsyncCreatableSelect;

/***/ },
/* 2097 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = trim;
	function trim(str) {
	    return str.replace(/^\s+|\s+$/g, '');
	}

/***/ },
/* 2098 */
[2242, 2099],
/* 2099 */
1016,
/* 2100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	__webpack_require__(163);
	
	__webpack_require__(160);
	
	__webpack_require__(237);
	
	__webpack_require__(196);
	
	__webpack_require__(158);
	
	__webpack_require__(159);
	
	__webpack_require__(164);
	
	__webpack_require__(161);
	
	__webpack_require__(162);
	
	__webpack_require__(127);
	
	__webpack_require__(128);
	
	__webpack_require__(1);
	
	__webpack_require__(229);
	
	__webpack_require__(167);
	
	__webpack_require__(31);
	
	__webpack_require__(197);
	
	__webpack_require__(165);
	
	__webpack_require__(195);
	
	__webpack_require__(234);
	
	var reactSelect = __webpack_require__(328);
	
	__webpack_require__(131);
	
	__webpack_require__(236);
	
	__webpack_require__(238);
	
	var __chunk_3 = __webpack_require__(329);
	
	var reactSelect$1 = __webpack_require__(233);
	
	var reactSelect$2 = __webpack_require__(2101);
	
	var SelectCreatable = reactSelect$2.makeCreatableSelect(reactSelect.Select);
	
	var SelectCreatableState = __chunk_3.manageState(SelectCreatable);
	
	var AsyncCreatable = reactSelect$1.makeAsyncSelect(SelectCreatableState);
	exports.default = AsyncCreatable;


/***/ },
/* 2101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopDefault(ex) {
	  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	__webpack_require__(163);
	
	var _extends = _interopDefault(__webpack_require__(160));
	
	var _toConsumableArray = _interopDefault(__webpack_require__(237));
	
	var _objectSpread = _interopDefault(__webpack_require__(196));
	
	var _classCallCheck = _interopDefault(__webpack_require__(158));
	
	var _createClass = _interopDefault(__webpack_require__(159));
	
	var _possibleConstructorReturn = _interopDefault(__webpack_require__(164));
	
	var _getPrototypeOf = _interopDefault(__webpack_require__(161));
	
	var _inherits = _interopDefault(__webpack_require__(162));
	
	var _assertThisInitialized = _interopDefault(__webpack_require__(127));
	
	var _defineProperty = _interopDefault(__webpack_require__(128));
	
	var React = __webpack_require__(1);
	
	var React__default = _interopDefault(React);
	
	__webpack_require__(229);
	
	__webpack_require__(167);
	
	__webpack_require__(31);
	
	__webpack_require__(197);
	
	__webpack_require__(165);
	
	var __chunk_1 = __webpack_require__(195);
	
	__webpack_require__(234);
	
	var reactSelect = __webpack_require__(328);
	
	__webpack_require__(131);
	
	__webpack_require__(236);
	
	__webpack_require__(238);
	
	var __chunk_3 = __webpack_require__(329);
	
	var compareOption = function compareOption() {
	  var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var option = arguments.length > 1 ? arguments[1] : undefined;
	  var candidate = String(inputValue).toLowerCase();
	  var optionValue = String(option.value).toLowerCase();
	  var optionLabel = String(option.label).toLowerCase();
	  return optionValue === candidate || optionLabel === candidate;
	};
	
	var builtins = {
	  formatCreateLabel: function formatCreateLabel(inputValue) {
	    return "Create \"".concat(inputValue, "\"");
	  },
	  isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions) {
	    return !(!inputValue || selectValue.some(function (option) {
	      return compareOption(inputValue, option);
	    }) || selectOptions.some(function (option) {
	      return compareOption(inputValue, option);
	    }));
	  },
	  getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
	    return {
	      label: optionLabel,
	      value: inputValue,
	      __isNew__: true
	    };
	  }
	};
	
	var defaultProps = _objectSpread({
	  allowCreateWhileLoading: false,
	  createOptionPosition: 'last'
	}, builtins);
	
	var makeCreatableSelect = function makeCreatableSelect(SelectComponent) {
	  var _class, _temp;
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(Creatable, _Component);
	
	    function Creatable(props) {
	      var _this;
	
	      _classCallCheck(this, Creatable);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Creatable).call(this, props));
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "select", void 0);
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (newValue, actionMeta) {
	        var _this$props = _this.props,
	            getNewOptionData = _this$props.getNewOptionData,
	            inputValue = _this$props.inputValue,
	            isMulti = _this$props.isMulti,
	            onChange = _this$props.onChange,
	            onCreateOption = _this$props.onCreateOption,
	            value = _this$props.value,
	            name = _this$props.name;
	
	        if (actionMeta.action !== 'select-option') {
	          return onChange(newValue, actionMeta);
	        }
	
	        var newOption = _this.state.newOption;
	        var valueArray = Array.isArray(newValue) ? newValue : [newValue];
	
	        if (valueArray[valueArray.length - 1] === newOption) {
	          if (onCreateOption) onCreateOption(inputValue);else {
	            var newOptionData = getNewOptionData(inputValue, inputValue);
	            var newActionMeta = {
	              action: 'create-option',
	              name: name
	            };
	
	            if (isMulti) {
	              onChange([].concat(_toConsumableArray(__chunk_1.cleanValue(value)), [newOptionData]), newActionMeta);
	            } else {
	              onChange(newOptionData, newActionMeta);
	            }
	          }
	          return;
	        }
	
	        onChange(newValue, actionMeta);
	      });
	
	      var options = props.options || [];
	      _this.state = {
	        newOption: undefined,
	        options: options
	      };
	      return _this;
	    }
	
	    _createClass(Creatable, [{
	      key: "UNSAFE_componentWillReceiveProps",
	      value: function UNSAFE_componentWillReceiveProps(nextProps) {
	        var allowCreateWhileLoading = nextProps.allowCreateWhileLoading,
	            createOptionPosition = nextProps.createOptionPosition,
	            formatCreateLabel = nextProps.formatCreateLabel,
	            getNewOptionData = nextProps.getNewOptionData,
	            inputValue = nextProps.inputValue,
	            isLoading = nextProps.isLoading,
	            isValidNewOption = nextProps.isValidNewOption,
	            value = nextProps.value;
	        var options = nextProps.options || [];
	        var newOption = this.state.newOption;
	
	        if (isValidNewOption(inputValue, __chunk_1.cleanValue(value), options)) {
	          newOption = getNewOptionData(inputValue, formatCreateLabel(inputValue));
	        } else {
	          newOption = undefined;
	        }
	
	        this.setState({
	          newOption: newOption,
	          options: (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [newOption].concat(_toConsumableArray(options)) : [].concat(_toConsumableArray(options), [newOption]) : options
	        });
	      }
	    }, {
	      key: "focus",
	      value: function focus() {
	        this.select.focus();
	      }
	    }, {
	      key: "blur",
	      value: function blur() {
	        this.select.blur();
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this2 = this;
	
	        var options = this.state.options;
	        return React__default.createElement(SelectComponent, _extends({}, this.props, {
	          ref: function ref(_ref) {
	            _this2.select = _ref;
	          },
	          options: options,
	          onChange: this.onChange
	        }));
	      }
	    }]);
	
	    return Creatable;
	  }(React.Component), _defineProperty(_class, "defaultProps", defaultProps), _temp;
	}; // TODO: do this in package entrypoint
	
	
	var SelectCreatable = makeCreatableSelect(reactSelect.Select);
	
	var Creatable = __chunk_3.manageState(SelectCreatable);
	
	exports.default = Creatable;
	exports.defaultProps = defaultProps;
	exports.makeCreatableSelect = makeCreatableSelect;


/***/ },
/* 2102 */
/***/ function(module, exports) {

	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  }
	}
	
	module.exports = _arrayWithoutHoles;

/***/ },
/* 2103 */
/***/ function(module, exports) {

	function _iterableToArray(iter) {
	  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
	}
	
	module.exports = _iterableToArray;

/***/ },
/* 2104 */
/***/ function(module, exports) {

	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance");
	}
	
	module.exports = _nonIterableSpread;

/***/ },
/* 2105 */
974,
/* 2106 */
/***/ function(module, exports) {

	function _setPrototypeOf(o, p) {
	  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	module.exports = _setPrototypeOf;

/***/ },
/* 2107 */
[2242, 2108],
/* 2108 */
1016,
/* 2109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(330));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CloseButton(_ref) {
	  var closeToast = _ref.closeToast,
	      type = _ref.type,
	      ariaLabel = _ref.ariaLabel;
	  return _react.default.createElement("button", {
	    className: "Toastify__close-button Toastify__close-button--" + type,
	    type: "button",
	    onClick: closeToast,
	    "aria-label": ariaLabel
	  }, "\u2716");
	}
	
	CloseButton.propTypes = {
	  closeToast: _propTypes.default.func,
	  arialLabel: _propTypes.default.string
	};
	CloseButton.defaultProps = {
	  ariaLabel: 'close'
	};
	var _default = CloseButton;
	exports.default = _default;

/***/ },
/* 2110 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(330));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _constant = __webpack_require__(239);
	
	var _propValidator = __webpack_require__(525);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ProgressBar(_ref) {
	  var _animationEvent;
	
	  var delay = _ref.delay,
	      isRunning = _ref.isRunning,
	      closeToast = _ref.closeToast,
	      type = _ref.type,
	      hide = _ref.hide,
	      className = _ref.className,
	      userStyle = _ref.style,
	      controlledProgress = _ref.controlledProgress,
	      progress = _ref.progress,
	      isProgressDone = _ref.isProgressDone,
	      rtl = _ref.rtl;
	
	  var style = _extends({}, userStyle, {
	    animationDuration: delay + "ms",
	    animationPlayState: isRunning ? 'running' : 'paused',
	    opacity: hide ? 0 : 1,
	    transform: controlledProgress ? "scaleX(" + progress + ")" : null
	  });
	
	  var classNames = (0, _classnames.default)('Toastify__progress-bar', controlledProgress ? 'Toastify__progress-bar--controlled' : 'Toastify__progress-bar--animated', "Toastify__progress-bar--" + type, {
	    'Toastify__progress-bar--rtl': rtl
	  }, className);
	  var animationEvent = (_animationEvent = {}, _animationEvent[controlledProgress && isProgressDone ? 'onTransitionEnd' : 'onAnimationEnd'] = controlledProgress && !isProgressDone ? null : closeToast, _animationEvent);
	  return _react.default.createElement("div", _extends({
	    className: classNames,
	    style: style
	  }, animationEvent));
	}
	
	ProgressBar.propTypes = {
	  /**
	   * The animation delay which determine when to close the toast
	   */
	  delay: _propValidator.falseOrDelay.isRequired,
	
	  /**
	   * Whether or not the animation is running or paused
	   */
	  isRunning: _propTypes.default.bool.isRequired,
	
	  /**
	   * Func to close the current toast
	   */
	  closeToast: _propTypes.default.func.isRequired,
	
	  /**
	   * Support rtl content
	   */
	  rtl: _propTypes.default.bool.isRequired,
	
	  /**
	   * Optional type : info, success ...
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * Hide or not the progress bar
	   */
	  hide: _propTypes.default.bool,
	
	  /**
	   * Optionnal className
	   */
	  className: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
	
	  /**
	   * Controlled progress value
	   */
	  progress: _propTypes.default.number,
	
	  /**
	   * Tell wether or not controlled progress bar is used
	   */
	  controlledProgress: _propTypes.default.bool,
	
	  /**
	   * Helper to close the toast when using controlled progress value
	   */
	  isProgressDone: _propTypes.default.bool
	};
	ProgressBar.defaultProps = {
	  type: _constant.TYPE.DEFAULT,
	  hide: false
	};
	var _default = ProgressBar;
	exports.default = _default;

/***/ },
/* 2111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(330));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _ProgressBar = _interopRequireDefault(__webpack_require__(2110));
	
	var _constant = __webpack_require__(239);
	
	var _propValidator = __webpack_require__(525);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function getX(e) {
	  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientX : e.clientX;
	}
	
	function getY(e) {
	  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientY : e.clientY;
	}
	
	var noop = function noop() {};
	
	var Toast =
	/*#__PURE__*/
	function (_Component) {
	  _inheritsLoose(Toast, _Component);
	
	  function Toast() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	    _this.state = {
	      isRunning: true,
	      preventExitTransition: false
	    };
	    _this.flag = {
	      canCloseOnClick: true,
	      canDrag: false
	    };
	    _this.drag = {
	      start: 0,
	      x: 0,
	      y: 0,
	      deltaX: 0,
	      removalDistance: 0
	    };
	    _this.ref = null;
	
	    _this.pauseToast = function () {
	      if (_this.props.autoClose) {
	        _this.setState({
	          isRunning: false
	        });
	      }
	    };
	
	    _this.playToast = function () {
	      if (_this.props.autoClose) {
	        _this.setState({
	          isRunning: true
	        });
	      }
	    };
	
	    _this.onDragStart = function (e) {
	      _this.flag.canCloseOnClick = true;
	      _this.flag.canDrag = true;
	      _this.ref.style.transition = '';
	      _this.drag.start = _this.drag.x = getX(e.nativeEvent);
	      _this.drag.removalDistance = _this.ref.offsetWidth * (_this.props.draggablePercent / 100);
	    };
	
	    _this.onDragMove = function (e) {
	      if (_this.flag.canDrag) {
	        if (_this.state.isRunning) {
	          _this.pauseToast();
	        }
	
	        _this.drag.x = getX(e);
	        _this.drag.deltaX = _this.drag.x - _this.drag.start; // prevent false positif during a toast click
	
	        _this.drag.start !== _this.drag.x && (_this.flag.canCloseOnClick = false);
	        _this.ref.style.transform = "translateX(" + _this.drag.deltaX + "px)";
	        _this.ref.style.opacity = 1 - Math.abs(_this.drag.deltaX / _this.drag.removalDistance);
	      }
	    };
	
	    _this.onDragEnd = function (e) {
	      if (_this.flag.canDrag) {
	        _this.flag.canDrag = false;
	
	        if (Math.abs(_this.drag.deltaX) > _this.drag.removalDistance) {
	          _this.setState({
	            preventExitTransition: true
	          }, _this.props.closeToast);
	
	          return;
	        }
	
	        _this.drag.y = getY(e);
	        _this.ref.style.transition = 'transform 0.2s, opacity 0.2s';
	        _this.ref.style.transform = 'translateX(0)';
	        _this.ref.style.opacity = 1;
	      }
	    };
	
	    _this.onDragTransitionEnd = function () {
	      var _this$ref$getBounding = _this.ref.getBoundingClientRect(),
	          top = _this$ref$getBounding.top,
	          bottom = _this$ref$getBounding.bottom,
	          left = _this$ref$getBounding.left,
	          right = _this$ref$getBounding.right;
	
	      if (_this.props.pauseOnHover && _this.drag.x >= left && _this.drag.x <= right && _this.drag.y >= top && _this.drag.y <= bottom) {
	        _this.pauseToast();
	      } else {
	        _this.playToast();
	      }
	    };
	
	    return _this;
	  }
	
	  var _proto = Toast.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.props.onOpen(this.props.children.props);
	
	    if (this.props.draggable) {
	      this.bindDragEvents();
	    } // Maybe I could bind the event in the ToastContainer and rely on delegation
	
	
	    if (this.props.pauseOnFocusLoss) {
	      this.bindFocusEvents();
	    }
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (prevProps.draggable !== this.props.draggable) {
	      if (this.props.draggable) {
	        this.bindDragEvents();
	      } else {
	        this.unbindDragEvents();
	      }
	    }
	
	    if (prevProps.pauseOnFocusLoss !== this.props.pauseOnFocusLoss) {
	      if (this.props.pauseOnFocusLoss) {
	        this.bindFocusEvents();
	      } else {
	        this.unbindFocusEvents();
	      }
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.props.onClose(this.props.children.props);
	
	    if (this.props.draggable) {
	      this.unbindDragEvents();
	    }
	
	    if (this.props.pauseOnFocusLoss) {
	      this.unbindFocusEvents();
	    }
	  };
	
	  _proto.bindFocusEvents = function bindFocusEvents() {
	    window.addEventListener('focus', this.playToast);
	    window.addEventListener('blur', this.pauseToast);
	  };
	
	  _proto.unbindFocusEvents = function unbindFocusEvents() {
	    window.removeEventListener('focus', this.playToast);
	    window.removeEventListener('blur', this.pauseToast);
	  };
	
	  _proto.bindDragEvents = function bindDragEvents() {
	    document.addEventListener('mousemove', this.onDragMove);
	    document.addEventListener('mouseup', this.onDragEnd);
	    document.addEventListener('touchmove', this.onDragMove);
	    document.addEventListener('touchend', this.onDragEnd);
	  };
	
	  _proto.unbindDragEvents = function unbindDragEvents() {
	    document.removeEventListener('mousemove', this.onDragMove);
	    document.removeEventListener('mouseup', this.onDragEnd);
	    document.removeEventListener('touchmove', this.onDragMove);
	    document.removeEventListener('touchend', this.onDragEnd);
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var _this$props = this.props,
	        closeButton = _this$props.closeButton,
	        children = _this$props.children,
	        autoClose = _this$props.autoClose,
	        pauseOnHover = _this$props.pauseOnHover,
	        closeOnClick = _this$props.closeOnClick,
	        type = _this$props.type,
	        hideProgressBar = _this$props.hideProgressBar,
	        closeToast = _this$props.closeToast,
	        Transition = _this$props.transition,
	        position = _this$props.position,
	        onExited = _this$props.onExited,
	        className = _this$props.className,
	        bodyClassName = _this$props.bodyClassName,
	        progressClassName = _this$props.progressClassName,
	        progressStyle = _this$props.progressStyle,
	        updateId = _this$props.updateId,
	        role = _this$props.role,
	        progress = _this$props.progress,
	        isProgressDone = _this$props.isProgressDone,
	        rtl = _this$props.rtl;
	    var toastProps = {
	      className: (0, _classnames.default)('Toastify__toast', "Toastify__toast--" + type, {
	        'Toastify__toast--rtl': rtl
	      }, className)
	    };
	
	    if (autoClose && pauseOnHover) {
	      toastProps.onMouseEnter = this.pauseToast;
	      toastProps.onMouseLeave = this.playToast;
	    } // prevent toast from closing when user drags the toast
	
	
	    if (closeOnClick) {
	      toastProps.onClick = function () {
	        return _this2.flag.canCloseOnClick && closeToast();
	      };
	    }
	
	    var controlledProgress = parseFloat(progress) === progress;
	    return _react.default.createElement(Transition, {
	      in: this.props.in,
	      appear: true,
	      unmountOnExit: true,
	      onExited: onExited,
	      position: position,
	      preventExitTransition: this.state.preventExitTransition
	    }, _react.default.createElement("div", _extends({}, toastProps, {
	      ref: function ref(_ref) {
	        return _this2.ref = _ref;
	      },
	      onMouseDown: this.onDragStart,
	      onTouchStart: this.onDragStart,
	      onTransitionEnd: this.onDragTransitionEnd
	    }), _react.default.createElement("div", _extends({}, this.props.in && {
	      role: role
	    }, {
	      className: (0, _classnames.default)('Toastify__toast-body', bodyClassName)
	    }), children), closeButton && closeButton, (autoClose || controlledProgress) && _react.default.createElement(_ProgressBar.default, _extends({}, updateId && !controlledProgress ? {
	      key: "pb-" + updateId
	    } : {}, {
	      rtl: rtl,
	      delay: autoClose,
	      isRunning: this.state.isRunning,
	      closeToast: closeToast,
	      hide: hideProgressBar,
	      type: type,
	      style: progressStyle,
	      className: progressClassName,
	      controlledProgress: controlledProgress,
	      isProgressDone: isProgressDone,
	      progress: progress
	    }))));
	  };
	
	  return Toast;
	}(_react.Component);
	
	Toast.propTypes = {
	  closeButton: _propValidator.falseOrElement.isRequired,
	  autoClose: _propValidator.falseOrDelay.isRequired,
	  children: _propTypes.default.node.isRequired,
	  closeToast: _propTypes.default.func.isRequired,
	  position: _propTypes.default.oneOf((0, _propValidator.objectValues)(_constant.POSITION)).isRequired,
	  pauseOnHover: _propTypes.default.bool.isRequired,
	  pauseOnFocusLoss: _propTypes.default.bool.isRequired,
	  closeOnClick: _propTypes.default.bool.isRequired,
	  transition: _propTypes.default.func.isRequired,
	  rtl: _propTypes.default.bool.isRequired,
	  hideProgressBar: _propTypes.default.bool.isRequired,
	  draggable: _propTypes.default.bool.isRequired,
	  draggablePercent: _propTypes.default.number.isRequired,
	  in: _propTypes.default.bool,
	  onExited: _propTypes.default.func,
	  onOpen: _propTypes.default.func,
	  onClose: _propTypes.default.func,
	  type: _propTypes.default.oneOf((0, _propValidator.objectValues)(_constant.TYPE)),
	  className: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
	  bodyClassName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
	  progressClassName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
	  progressStyle: _propTypes.default.object,
	  progress: _propTypes.default.number,
	  isProgressDone: _propTypes.default.bool,
	  updateId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  ariaLabel: _propTypes.default.string
	};
	Toast.defaultProps = {
	  type: _constant.TYPE.DEFAULT,
	  in: true,
	  onOpen: noop,
	  onClose: noop,
	  className: null,
	  bodyClassName: null,
	  progressClassName: null,
	  updateId: null,
	  role: 'alert'
	};
	var _default = Toast;
	exports.default = _default;

/***/ },
/* 2112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(330));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(2117));
	
	var _Toast = _interopRequireDefault(__webpack_require__(2111));
	
	var _CloseButton = _interopRequireDefault(__webpack_require__(2109));
	
	var _Transitions = __webpack_require__(933);
	
	var _constant = __webpack_require__(239);
	
	var _eventManager = _interopRequireDefault(__webpack_require__(935));
	
	var _propValidator = __webpack_require__(525);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var ToastContainer =
	/*#__PURE__*/
	function (_Component) {
	  _inheritsLoose(ToastContainer, _Component);
	
	  function ToastContainer() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	    _this.state = {
	      toast: []
	    };
	    _this.toastKey = 1;
	    _this.collection = {};
	
	    _this.isToastActive = function (id) {
	      return _this.state.toast.indexOf(id) !== -1;
	    };
	
	    return _this;
	  }
	
	  var _proto = ToastContainer.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    _eventManager.default.on(_constant.ACTION.SHOW, function (content, options) {
	      return _this2.show(content, options);
	    }).on(_constant.ACTION.CLEAR, function (id) {
	      return !id ? _this2.clear() : _this2.removeToast(id);
	    }).emit(_constant.ACTION.DID_MOUNT, this);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    _eventManager.default.off(_constant.ACTION.SHOW).off(_constant.ACTION.CLEAR).emit(_constant.ACTION.WILL_UNMOUNT);
	  };
	
	  _proto.removeToast = function removeToast(id) {
	    this.setState({
	      toast: this.state.toast.filter(function (v) {
	        return v !== id;
	      })
	    }, this.dispatchChange);
	  };
	
	  _proto.dispatchChange = function dispatchChange() {
	    _eventManager.default.emit(_constant.ACTION.ON_CHANGE, this.state.toast.length);
	  };
	
	  _proto.makeCloseButton = function makeCloseButton(toastClose, toastId, type) {
	    var _this3 = this;
	
	    var closeButton = this.props.closeButton;
	
	    if ((0, _react.isValidElement)(toastClose) || toastClose === false) {
	      closeButton = toastClose;
	    }
	
	    return closeButton === false ? false : (0, _react.cloneElement)(closeButton, {
	      closeToast: function closeToast() {
	        return _this3.removeToast(toastId);
	      },
	      type: type
	    });
	  };
	
	  _proto.getAutoCloseDelay = function getAutoCloseDelay(toastAutoClose) {
	    return toastAutoClose === false || (0, _propValidator.isValidDelay)(toastAutoClose) ? toastAutoClose : this.props.autoClose;
	  };
	
	  _proto.canBeRendered = function canBeRendered(content) {
	    return (0, _react.isValidElement)(content) || typeof content === 'string' || typeof content === 'number' || typeof content === 'function';
	  };
	
	  _proto.parseClassName = function parseClassName(prop) {
	    if (typeof prop === 'string') {
	      return prop;
	    } else if (prop !== null && typeof prop === 'object' && 'toString' in prop) {
	      return prop.toString();
	    }
	
	    return null;
	  };
	
	  _proto.show = function show(content, options) {
	    var _this4 = this,
	        _extends2;
	
	    if (!this.canBeRendered(content)) {
	      throw new Error("The element you provided cannot be rendered. You provided an element of type " + typeof content);
	    }
	
	    var toastId = options.toastId;
	
	    var closeToast = function closeToast() {
	      return _this4.removeToast(toastId);
	    };
	
	    var toastOptions = {
	      id: toastId,
	      // ⚠️ if no options.key, this.toastKey - 1 is assigned
	      key: options.key || this.toastKey++,
	      type: options.type,
	      closeToast: closeToast,
	      updateId: options.updateId,
	      rtl: this.props.rtl,
	      position: options.position || this.props.position,
	      transition: options.transition || this.props.transition,
	      className: this.parseClassName(options.className || this.props.toastClassName),
	      bodyClassName: this.parseClassName(options.bodyClassName || this.props.bodyClassName),
	      closeButton: this.makeCloseButton(options.closeButton, toastId, options.type),
	      pauseOnHover: typeof options.pauseOnHover === 'boolean' ? options.pauseOnHover : this.props.pauseOnHover,
	      pauseOnFocusLoss: typeof options.pauseOnFocusLoss === 'boolean' ? options.pauseOnFocusLoss : this.props.pauseOnFocusLoss,
	      draggable: typeof options.draggable === 'boolean' ? options.draggable : this.props.draggable,
	      draggablePercent: typeof options.draggablePercent === 'number' && !isNaN(options.draggablePercent) ? options.draggablePercent : this.props.draggablePercent,
	      closeOnClick: typeof options.closeOnClick === 'boolean' ? options.closeOnClick : this.props.closeOnClick,
	      progressClassName: this.parseClassName(options.progressClassName || this.props.progressClassName),
	      progressStyle: this.props.progressStyle,
	      autoClose: this.getAutoCloseDelay(options.autoClose),
	      hideProgressBar: typeof options.hideProgressBar === 'boolean' ? options.hideProgressBar : this.props.hideProgressBar,
	      progress: parseFloat(options.progress),
	      isProgressDone: options.isProgressDone
	    };
	    typeof options.onOpen === 'function' && (toastOptions.onOpen = options.onOpen);
	    typeof options.onClose === 'function' && (toastOptions.onClose = options.onClose); // add closeToast function to react component only
	
	    if ((0, _react.isValidElement)(content) && typeof content.type !== 'string' && typeof content.type !== 'number') {
	      content = (0, _react.cloneElement)(content, {
	        closeToast: closeToast
	      });
	    } else if (typeof content === 'function') {
	      content = content({
	        closeToast: closeToast
	      });
	    }
	
	    this.collection = _extends({}, this.collection, (_extends2 = {}, _extends2[toastId] = {
	      position: toastOptions.position,
	      options: toastOptions,
	      content: content
	    }, _extends2));
	    this.setState({
	      toast: (toastOptions.updateId ? _toConsumableArray(this.state.toast) : _toConsumableArray(this.state.toast).concat([toastId])).filter(function (id) {
	        return id !== options.staleToastId;
	      })
	    }, this.dispatchChange);
	  };
	
	  _proto.makeToast = function makeToast(content, options) {
	    return _react.default.createElement(_Toast.default, _extends({}, options, {
	      isDocumentHidden: this.state.isDocumentHidden,
	      key: "toast-" + options.key
	    }), content);
	  };
	
	  _proto.clear = function clear() {
	    this.setState({
	      toast: []
	    });
	  };
	
	  _proto.renderToast = function renderToast() {
	    var _this5 = this;
	
	    var toastToRender = {};
	    var _this$props = this.props,
	        className = _this$props.className,
	        style = _this$props.style,
	        newestOnTop = _this$props.newestOnTop;
	    var collection = newestOnTop ? Object.keys(this.collection).reverse() : Object.keys(this.collection); // group toast by position
	
	    collection.forEach(function (toastId) {
	      var _this5$collection$toa = _this5.collection[toastId],
	          position = _this5$collection$toa.position,
	          options = _this5$collection$toa.options,
	          content = _this5$collection$toa.content;
	      toastToRender[position] || (toastToRender[position] = []);
	
	      if (_this5.state.toast.indexOf(options.id) !== -1) {
	        toastToRender[position].push(_this5.makeToast(content, options));
	      } else {
	        toastToRender[position].push(null);
	        delete _this5.collection[toastId];
	      }
	    });
	    return Object.keys(toastToRender).map(function (position) {
	      var disablePointer = toastToRender[position].length === 1 && toastToRender[position][0] === null;
	      var props = {
	        className: (0, _classnames.default)('Toastify__toast-container', "Toastify__toast-container--" + position, {
	          'Toastify__toast-container--rtl': _this5.props.rtl
	        }, _this5.parseClassName(className)),
	        style: disablePointer ? _extends({}, style, {
	          pointerEvents: 'none'
	        }) : _extends({}, style)
	      };
	      return _react.default.createElement(_TransitionGroup.default, _extends({}, props, {
	        key: "container-" + position
	      }), toastToRender[position]);
	    });
	  };
	
	  _proto.render = function render() {
	    return _react.default.createElement("div", {
	      className: "Toastify"
	    }, this.renderToast());
	  };
	
	  return ToastContainer;
	}(_react.Component);
	
	ToastContainer.propTypes = {
	  /**
	   * Set toast position
	   */
	  position: _propTypes.default.oneOf((0, _propValidator.objectValues)(_constant.POSITION)),
	
	  /**
	   * Disable or set autoClose delay
	   */
	  autoClose: _propValidator.falseOrDelay,
	
	  /**
	   * Disable or set a custom react element for the close button
	   */
	  closeButton: _propValidator.falseOrElement,
	
	  /**
	   * Hide or not progress bar when autoClose is enabled
	   */
	  hideProgressBar: _propTypes.default.bool,
	
	  /**
	   * Pause toast duration on hover
	   */
	  pauseOnHover: _propTypes.default.bool,
	
	  /**
	   * Dismiss toast on click
	   */
	  closeOnClick: _propTypes.default.bool,
	
	  /**
	   * Newest on top
	   */
	  newestOnTop: _propTypes.default.bool,
	
	  /**
	   * An optional className
	   */
	  className: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
	
	  /**
	   * An optional style
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * An optional className for the toast
	   */
	  toastClassName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
	
	  /**
	   * An optional className for the toast body
	   */
	  bodyClassName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
	
	  /**
	   * An optional className for the toast progress bar
	   */
	  progressClassName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
	
	  /**
	   * An optional style for the toast progress bar
	   */
	  progressStyle: _propTypes.default.object,
	
	  /**
	   * Define enter and exit transition using react-transition-group
	   */
	  transition: _propTypes.default.func,
	
	  /**
	   * Support rtl display
	   */
	  rtl: _propTypes.default.bool,
	
	  /**
	   * Allow toast to be draggable
	   */
	  draggable: _propTypes.default.bool,
	
	  /**
	   * The percentage of the toast's width it takes for a drag to dismiss a toast
	   */
	  draggablePercent: _propTypes.default.number,
	
	  /**
	   * Pause the toast on focus loss
	   */
	  pauseOnFocusLoss: _propTypes.default.bool
	};
	ToastContainer.defaultProps = {
	  position: _constant.POSITION.TOP_RIGHT,
	  transition: _Transitions.Bounce,
	  rtl: false,
	  autoClose: 5000,
	  hideProgressBar: false,
	  closeButton: _react.default.createElement(_CloseButton.default, null),
	  pauseOnHover: true,
	  pauseOnFocusLoss: true,
	  closeOnClick: true,
	  newestOnTop: false,
	  draggable: true,
	  draggablePercent: 80,
	  className: null,
	  style: null,
	  toastClassName: null,
	  bodyClassName: null,
	  progressClassName: null,
	  progressStyle: null
	};
	var _default = ToastContainer;
	exports.default = _default;

/***/ },
/* 2113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _ToastContainer = _interopRequireDefault(__webpack_require__(2112));
	
	exports.ToastContainer = _ToastContainer.default;
	
	var _Transitions = __webpack_require__(933);
	
	exports.Bounce = _Transitions.Bounce;
	exports.Slide = _Transitions.Slide;
	exports.Zoom = _Transitions.Zoom;
	exports.Flip = _Transitions.Flip;
	
	var _constant = __webpack_require__(239);
	
	exports.ToastPosition = _constant.POSITION;
	exports.ToastType = _constant.TYPE;
	
	var _toast = _interopRequireDefault(__webpack_require__(2114));
	
	exports.toast = _toast.default;
	
	var _cssTransition = _interopRequireDefault(__webpack_require__(934));
	
	exports.cssTransition = _cssTransition.default;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 2114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _eventManager = _interopRequireDefault(__webpack_require__(935));
	
	var _constant = __webpack_require__(239);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var container = null;
	var queue = [];
	
	var noop = function noop() {
	  return false;
	};
	/**
	 * Merge provided options with the defaults settings and generate the toastId
	 */
	
	
	function mergeOptions(options, type) {
	  return _extends({}, options, {
	    type: type,
	    toastId: getToastId(options)
	  });
	}
	/**
	 * Generate a random toastId
	 */
	
	
	function generateToastId() {
	  return (Math.random().toString(36) + Date.now().toString(36)).substr(2, 10);
	}
	/**
	 * Generate the toastId either automatically or by provided toastId
	 */
	
	
	function getToastId(options) {
	  if (options && (typeof options.toastId === 'string' || typeof options.toastId === 'number' && !isNaN(options.toastId))) {
	    return options.toastId;
	  }
	
	  return generateToastId();
	}
	/**
	 * Dispatch toast. If the container is not mounted, the toast is enqueued
	 */
	
	
	function emitEvent(content, options) {
	  if (container !== null) {
	    _eventManager.default.emit(_constant.ACTION.SHOW, content, options);
	  } else {
	    queue.push({
	      action: _constant.ACTION.SHOW,
	      content: content,
	      options: options
	    });
	  }
	
	  return options.toastId;
	}
	
	var toast = _extends(function (content, options) {
	  return emitEvent(content, mergeOptions(options, options && options.type || _constant.TYPE.DEFAULT));
	}, {
	  success: function success(content, options) {
	    return emitEvent(content, mergeOptions(options, _constant.TYPE.SUCCESS));
	  },
	  info: function info(content, options) {
	    return emitEvent(content, mergeOptions(options, _constant.TYPE.INFO));
	  },
	  warn: function warn(content, options) {
	    return emitEvent(content, mergeOptions(options, _constant.TYPE.WARNING));
	  },
	  warning: function warning(content, options) {
	    return emitEvent(content, mergeOptions(options, _constant.TYPE.WARNING));
	  },
	  error: function error(content, options) {
	    return emitEvent(content, mergeOptions(options, _constant.TYPE.ERROR));
	  },
	  dismiss: function dismiss(id) {
	    if (id === void 0) {
	      id = null;
	    }
	
	    return container && _eventManager.default.emit(_constant.ACTION.CLEAR, id);
	  },
	  isActive: noop,
	  update: function update(toastId, options) {
	    setTimeout(function () {
	      if (container && typeof container.collection[toastId] !== 'undefined') {
	        var _container$collection = container.collection[toastId],
	            oldOptions = _container$collection.options,
	            oldContent = _container$collection.content;
	
	        var nextOptions = _extends({}, oldOptions, options, {
	          toastId: options.toastId || toastId
	        });
	
	        if (!options.toastId || options.toastId === toastId) {
	          nextOptions.updateId = generateToastId();
	        } else {
	          nextOptions.staleToastId = toastId;
	        }
	
	        var content = typeof nextOptions.render !== 'undefined' ? nextOptions.render : oldContent;
	        delete nextOptions.render;
	        emitEvent(content, nextOptions);
	      }
	    }, 0);
	  },
	  done: function done(id, progress) {
	    if (progress === void 0) {
	      progress = 1;
	    }
	
	    toast.update(id, {
	      progress: progress,
	      isProgressDone: true
	    });
	  },
	  onChange: function onChange(callback) {
	    if (typeof callback === 'function') {
	      _eventManager.default.on(_constant.ACTION.ON_CHANGE, callback);
	    }
	  },
	  POSITION: _constant.POSITION,
	  TYPE: _constant.TYPE
	});
	/**
	 * Wait until the ToastContainer is mounted to dispatch the toast
	 * and attach isActive method
	 */
	
	
	_eventManager.default.on(_constant.ACTION.DID_MOUNT, function (containerInstance) {
	  container = containerInstance;
	
	  toast.isActive = function (id) {
	    return container.isToastActive(id);
	  };
	
	  queue.forEach(function (item) {
	    _eventManager.default.emit(item.action, item.content, item.options);
	  });
	  queue = [];
	}).on(_constant.ACTION.WILL_UNMOUNT, function () {
	  container = null;
	  toast.isActive = noop;
	});
	
	var _default = toast;
	exports.default = _default;

/***/ },
/* 2115 */
[2242, 2116],
/* 2116 */
1016,
/* 2117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(527));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(906);
	
	var _ChildMapping = __webpack_require__(2120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	  /**
	   * The `<TransitionGroup>` component manages a set of transition components
	   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	   * components, `<TransitionGroup>` is a state machine for managing the mounting
	   * and unmounting of components over time.
	   *
	   * Consider the example below. As items are removed or added to the TodoList the
	   * `in` prop is toggled automatically by the `<TransitionGroup>`.
	   *
	   * Note that `<TransitionGroup>`  does not define any animation behavior!
	   * Exactly _how_ a list item animates is up to the individual transition
	   * component. This means you can mix and match animations across different list
	   * items.
	   */
	
	};
	
	var TransitionGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: {
	        isMounting: !this.appeared
	      }
	    };
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	    this.mounted = true;
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  };
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return children;
	    }
	
	    return _react.default.createElement(Component, props, children);
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes.default.object.isRequired
	};
	TransitionGroup.propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   *
	   * While this component is meant for multiple `Transition` or `CSSTransition`
	   * children, sometimes you may want to have a single transition child with
	   * content that you want to be transitioned out and in when you change it
	   * (e.g. routes, images etc.) In that case you can change the `key` prop of
	   * the transition child as you change its content, this will cause
	   * `TransitionGroup` to transition the child out and back in.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};
	TransitionGroup.defaultProps = defaultProps;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 2118 */
[2242, 2119],
/* 2119 */
1016,
/* 2120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	
	
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  } // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	
	
	  var nextKeysPending = Object.create(null);
	  var pendingKeys = [];
	
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i;
	  var childMapping = {};
	
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	
	    childMapping[nextKey] = getValueForKey(nextKey);
	  } // Finally, add the keys which didn't appear before any key in `next`
	
	
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	    if (!(0, _react.isValidElement)(child)) return;
	    var hasPrev = key in prevChildMapping;
	    var hasNext = key in nextChildMapping;
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
	
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        in: false
	      });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	  return children;
	}

/***/ },
/* 2121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(527));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number,
	  appear: _propTypes.default.number
	}).isRequired]) : null;
	exports.timeoutsShape = timeoutsShape;
	var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]) : null;
	exports.classNamesShape = classNamesShape;

/***/ },
/* 2122 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.8.6
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var k=__webpack_require__(230),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.memo"):
	60115,ba=n?Symbol.for("react.lazy"):60116,A="function"===typeof Symbol&&Symbol.iterator;function ca(a,b,d,c,e,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[d,c,e,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
	function B(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
	function E(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?B("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}var H=G.prototype=new F;
	H.constructor=G;k(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,d){var c=void 0,e={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:e,_owner:J.current}}
	function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
	function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
	function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){e=a[h];var f=b+T(e,h);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
	0;!(e=a.next()).done;)e=e.value,f=b+T(e,h++),g+=S(e,f,d,c);else"object"===e&&(d=""+a,B("31","[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,""));return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
	function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=I.current;null===a?B("321"):void 0;return a}
	var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){N(a)?void 0:B("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
	_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:ba,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:aa,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
	b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,StrictMode:t,Suspense:z,createElement:M,cloneElement:function(a,b,d){null===a||void 0===a?B("267",a):void 0;var c=void 0,e=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=
	b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.8.6",
	unstable_ConcurrentMode:x,unstable_Profiler:u,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentOwner:J,assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ },
/* 2123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(30);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _utilities = __webpack_require__(2126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (reducers) {
	  var reducerKeys = Object.keys(reducers);
	
	  // eslint-disable-next-line space-infix-ops
	  return function () {
	    var inputState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _immutable2.default.Map();
	    var action = arguments[1];
	
	    // eslint-disable-next-line no-process-env
	    if (false) {
	      var warningMessage = (0, _utilities.getUnexpectedInvocationParameterMessage)(inputState, reducers, action);
	
	      if (warningMessage) {
	        // eslint-disable-next-line no-console
	        console.error(warningMessage);
	      }
	    }
	
	    return inputState.withMutations(function (temporaryState) {
	      reducerKeys.forEach(function (reducerName) {
	        var reducer = reducers[reducerName];
	        var currentDomainState = temporaryState.get(reducerName);
	        var nextDomainState = reducer(currentDomainState, action);
	
	        (0, _utilities.validateNextState)(nextDomainState, reducerName, action);
	
	        temporaryState.set(reducerName, nextDomainState);
	      });
	    });
	  };
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=combineReducers.js.map

/***/ },
/* 2124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.combineReducers = undefined;
	
	var _combineReducers2 = __webpack_require__(2123);
	
	var _combineReducers3 = _interopRequireDefault(_combineReducers2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.combineReducers = _combineReducers3.default;
	//# sourceMappingURL=index.js.map

/***/ },
/* 2125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(30);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _getStateName = __webpack_require__(936);
	
	var _getStateName2 = _interopRequireDefault(_getStateName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (state, reducers, action) {
	  var reducerNames = Object.keys(reducers);
	
	  if (!reducerNames.length) {
	    return 'Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.';
	  }
	
	  var stateName = (0, _getStateName2.default)(action);
	
	  if (!_immutable2.default.Iterable.isIterable(state)) {
	    return 'The ' + stateName + ' is of unexpected type. Expected argument to be an instance of Immutable.Iterable with the following properties: "' + reducerNames.join('", "') + '".';
	  }
	
	  var unexpectedStatePropertyNames = state.keySeq().toArray().filter(function (name) {
	    return !reducers.hasOwnProperty(name);
	  });
	
	  if (unexpectedStatePropertyNames.length > 0) {
	    return 'Unexpected ' + (unexpectedStatePropertyNames.length === 1 ? 'property' : 'properties') + ' "' + unexpectedStatePropertyNames.join('", "') + '" found in ' + stateName + '. Expected to find one of the known reducer property names instead: "' + reducerNames.join('", "') + '". Unexpected properties will be ignored.';
	  }
	
	  return null;
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=getUnexpectedInvocationParameterMessage.js.map

/***/ },
/* 2126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validateNextState = exports.getUnexpectedInvocationParameterMessage = exports.getStateName = undefined;
	
	var _getStateName2 = __webpack_require__(936);
	
	var _getStateName3 = _interopRequireDefault(_getStateName2);
	
	var _getUnexpectedInvocationParameterMessage2 = __webpack_require__(2125);
	
	var _getUnexpectedInvocationParameterMessage3 = _interopRequireDefault(_getUnexpectedInvocationParameterMessage2);
	
	var _validateNextState2 = __webpack_require__(2127);
	
	var _validateNextState3 = _interopRequireDefault(_validateNextState2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.getStateName = _getStateName3.default;
	exports.getUnexpectedInvocationParameterMessage = _getUnexpectedInvocationParameterMessage3.default;
	exports.validateNextState = _validateNextState3.default;
	//# sourceMappingURL=index.js.map

/***/ },
/* 2127 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (nextState, reducerName, action) {
	  // eslint-disable-next-line no-undefined
	  if (nextState === undefined) {
	    throw new Error('Reducer "' + reducerName + '" returned undefined when handling "' + action.type + '" action. To ignore an action, you must explicitly return the previous state.');
	  }
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=validateNextState.js.map

/***/ },
/* 2128 */
/***/ function(module, exports) {

	"use strict";
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _typeof(obj) { return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj; }
	
	var repeat = function repeat(str, times) {
	  return new Array(times + 1).join(str);
	};
	var pad = function pad(num, maxLength) {
	  return repeat("0", maxLength - num.toString().length) + num;
	};
	var formatTime = function formatTime(time) {
	  return "@ " + pad(time.getHours(), 2) + ":" + pad(time.getMinutes(), 2) + ":" + pad(time.getSeconds(), 2) + "." + pad(time.getMilliseconds(), 3);
	};
	
	// Use the new performance api to get better precision if available
	var timer = typeof performance !== "undefined" && typeof performance.now === "function" ? performance : Date;
	
	/**
	 * parse the level option of createLogger
	 *
	 * @property {string | function | object} level - console[level]
	 * @property {object} action
	 * @property {array} payload
	 * @property {string} type
	 */
	
	function getLogLevel(level, action, payload, type) {
	  switch (typeof level === "undefined" ? "undefined" : _typeof(level)) {
	    case "object":
	      return typeof level[type] === "function" ? level[type].apply(level, _toConsumableArray(payload)) : level[type];
	    case "function":
	      return level(action);
	    default:
	      return level;
	  }
	}
	
	/**
	 * Creates logger with followed options
	 *
	 * @namespace
	 * @property {object} options - options for logger
	 * @property {string | function | object} options.level - console[level]
	 * @property {boolean} options.duration - print duration of each action?
	 * @property {boolean} options.timestamp - print timestamp with each action?
	 * @property {object} options.colors - custom colors
	 * @property {object} options.logger - implementation of the `console` API
	 * @property {boolean} options.logErrors - should errors in action execution be caught, logged, and re-thrown?
	 * @property {boolean} options.collapsed - is group collapsed?
	 * @property {boolean} options.predicate - condition which resolves logger behavior
	 * @property {function} options.stateTransformer - transform state before print
	 * @property {function} options.actionTransformer - transform action before print
	 * @property {function} options.errorTransformer - transform error before print
	 */
	
	function createLogger() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var _options$level = options.level;
	  var level = _options$level === undefined ? "log" : _options$level;
	  var _options$logger = options.logger;
	  var logger = _options$logger === undefined ? console : _options$logger;
	  var _options$logErrors = options.logErrors;
	  var logErrors = _options$logErrors === undefined ? true : _options$logErrors;
	  var collapsed = options.collapsed;
	  var predicate = options.predicate;
	  var _options$duration = options.duration;
	  var duration = _options$duration === undefined ? false : _options$duration;
	  var _options$timestamp = options.timestamp;
	  var timestamp = _options$timestamp === undefined ? true : _options$timestamp;
	  var transformer = options.transformer;
	  var _options$stateTransfo = options.stateTransformer;
	  var // deprecated
	  stateTransformer = _options$stateTransfo === undefined ? function (state) {
	    return state;
	  } : _options$stateTransfo;
	  var _options$actionTransf = options.actionTransformer;
	  var actionTransformer = _options$actionTransf === undefined ? function (actn) {
	    return actn;
	  } : _options$actionTransf;
	  var _options$errorTransfo = options.errorTransformer;
	  var errorTransformer = _options$errorTransfo === undefined ? function (error) {
	    return error;
	  } : _options$errorTransfo;
	  var _options$colors = options.colors;
	  var colors = _options$colors === undefined ? {
	    title: function title() {
	      return "#000000";
	    },
	    prevState: function prevState() {
	      return "#9E9E9E";
	    },
	    action: function action() {
	      return "#03A9F4";
	    },
	    nextState: function nextState() {
	      return "#4CAF50";
	    },
	    error: function error() {
	      return "#F20404";
	    }
	  } : _options$colors;
	
	  // exit if console undefined
	
	  if (typeof logger === "undefined") {
	    return function () {
	      return function (next) {
	        return function (action) {
	          return next(action);
	        };
	      };
	    };
	  }
	
	  if (transformer) {
	    console.error("Option 'transformer' is deprecated, use stateTransformer instead");
	  }
	
	  var logBuffer = [];
	  function printBuffer() {
	    logBuffer.forEach(function (logEntry, key) {
	      var started = logEntry.started;
	      var startedTime = logEntry.startedTime;
	      var action = logEntry.action;
	      var prevState = logEntry.prevState;
	      var error = logEntry.error;
	      var took = logEntry.took;
	      var nextState = logEntry.nextState;
	
	      var nextEntry = logBuffer[key + 1];
	      if (nextEntry) {
	        nextState = nextEntry.prevState;
	        took = nextEntry.started - started;
	      }
	      // message
	      var formattedAction = actionTransformer(action);
	      var isCollapsed = typeof collapsed === "function" ? collapsed(function () {
	        return nextState;
	      }, action) : collapsed;
	
	      var formattedTime = formatTime(startedTime);
	      var titleCSS = colors.title ? "color: " + colors.title(formattedAction) + ";" : null;
	      var title = "action " + (timestamp ? formattedTime : "") + " " + formattedAction.type + " " + (duration ? "(in " + took.toFixed(2) + " ms)" : "");
	
	      // render
	      try {
	        if (isCollapsed) {
	          if (colors.title) logger.groupCollapsed("%c " + title, titleCSS);else logger.groupCollapsed(title);
	        } else {
	          if (colors.title) logger.group("%c " + title, titleCSS);else logger.group(title);
	        }
	      } catch (e) {
	        logger.log(title);
	      }
	
	      var prevStateLevel = getLogLevel(level, formattedAction, [prevState], "prevState");
	      var actionLevel = getLogLevel(level, formattedAction, [formattedAction], "action");
	      var errorLevel = getLogLevel(level, formattedAction, [error, prevState], "error");
	      var nextStateLevel = getLogLevel(level, formattedAction, [nextState], "nextState");
	
	      if (prevStateLevel) {
	        if (colors.prevState) logger[prevStateLevel]("%c prev state", "color: " + colors.prevState(prevState) + "; font-weight: bold", prevState);else logger[prevStateLevel]("prev state", prevState);
	      }
	
	      if (actionLevel) {
	        if (colors.action) logger[actionLevel]("%c action", "color: " + colors.action(formattedAction) + "; font-weight: bold", formattedAction);else logger[actionLevel]("action", formattedAction);
	      }
	
	      if (error && errorLevel) {
	        if (colors.error) logger[errorLevel]("%c error", "color: " + colors.error(error, prevState) + "; font-weight: bold", error);else logger[errorLevel]("error", error);
	      }
	
	      if (nextStateLevel) {
	        if (colors.nextState) logger[nextStateLevel]("%c next state", "color: " + colors.nextState(nextState) + "; font-weight: bold", nextState);else logger[nextStateLevel]("next state", nextState);
	      }
	
	      try {
	        logger.groupEnd();
	      } catch (e) {
	        logger.log("—— log end ——");
	      }
	    });
	    logBuffer.length = 0;
	  }
	
	  return function (_ref) {
	    var getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        // exit early if predicate function returns false
	        if (typeof predicate === "function" && !predicate(getState, action)) {
	          return next(action);
	        }
	
	        var logEntry = {};
	        logBuffer.push(logEntry);
	
	        logEntry.started = timer.now();
	        logEntry.startedTime = new Date();
	        logEntry.prevState = stateTransformer(getState());
	        logEntry.action = action;
	
	        var returnedValue = undefined;
	        if (logErrors) {
	          try {
	            returnedValue = next(action);
	          } catch (e) {
	            logEntry.error = errorTransformer(e);
	          }
	        } else {
	          returnedValue = next(action);
	        }
	
	        logEntry.took = timer.now() - logEntry.started;
	        logEntry.nextState = stateTransformer(getState());
	
	        printBuffer();
	
	        if (logEntry.error) throw logEntry.error;
	        return returnedValue;
	      };
	    };
	  };
	}
	
	module.exports = createLogger;

/***/ },
/* 2129 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 2130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = applyMiddleware;
	
	var _compose = __webpack_require__(937);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, initialState, enhancer) {
	      var store = createStore(reducer, initialState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2["default"].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 2131 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 2132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = combineReducers;
	
	var _createStore = __webpack_require__(938);
	
	var _isPlainObject = __webpack_require__(941);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(939);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'initialState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2["default"])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key);
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerSanity(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var sanityError;
	  try {
	    assertReducerSanity(finalReducers);
	  } catch (e) {
	    sanityError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var action = arguments[1];
	
	    if (sanityError) {
	      throw sanityError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action);
	      if (warningMessage) {
	        (0, _warning2["default"])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var i = 0; i < finalReducerKeys.length; i++) {
	      var key = finalReducerKeys[i];
	      var reducer = finalReducers[key];
	      var previousStateForKey = state[key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 2133 */
[2247, 940, 2136, 2137],
/* 2134 */
852,
/* 2135 */
[2248, 2138],
/* 2136 */
[2249, 940],
/* 2137 */
1050,
/* 2138 */
1051,
/* 2139 */
[2250, 2134],
/* 2140 */
1053,
/* 2141 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2142 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** @license React v0.13.6
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});var d=null,e=!1,g=3,k=-1,l=-1,m=!1,n=!1;function p(){if(!m){var a=d.expirationTime;n?q():n=!0;r(t,a)}}
	function u(){var a=d,b=d.next;if(d===b)d=null;else{var c=d.previous;d=c.next=b;b.previous=c}a.next=a.previous=null;c=a.callback;b=a.expirationTime;a=a.priorityLevel;var f=g,Q=l;g=a;l=b;try{var h=c()}finally{g=f,l=Q}if("function"===typeof h)if(h={callback:h,priorityLevel:a,expirationTime:b,next:null,previous:null},null===d)d=h.next=h.previous=h;else{c=null;a=d;do{if(a.expirationTime>=b){c=a;break}a=a.next}while(a!==d);null===c?c=d:c===d&&(d=h,p());b=c.previous;b.next=c.previous=h;h.next=c;h.previous=
	b}}function v(){if(-1===k&&null!==d&&1===d.priorityLevel){m=!0;try{do u();while(null!==d&&1===d.priorityLevel)}finally{m=!1,null!==d?p():n=!1}}}function t(a){m=!0;var b=e;e=a;try{if(a)for(;null!==d;){var c=exports.unstable_now();if(d.expirationTime<=c){do u();while(null!==d&&d.expirationTime<=c)}else break}else if(null!==d){do u();while(null!==d&&!w())}}finally{m=!1,e=b,null!==d?p():n=!1,v()}}
	var x=Date,y="function"===typeof setTimeout?setTimeout:void 0,z="function"===typeof clearTimeout?clearTimeout:void 0,A="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,B="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,C,D;function E(a){C=A(function(b){z(D);a(b)});D=y(function(){B(C);a(exports.unstable_now())},100)}
	if("object"===typeof performance&&"function"===typeof performance.now){var F=performance;exports.unstable_now=function(){return F.now()}}else exports.unstable_now=function(){return x.now()};var r,q,w,G=null;"undefined"!==typeof window?G=window:"undefined"!==typeof global&&(G=global);
	if(G&&G._schedMock){var H=G._schedMock;r=H[0];q=H[1];w=H[2];exports.unstable_now=H[3]}else if("undefined"===typeof window||"function"!==typeof MessageChannel){var I=null,J=function(a){if(null!==I)try{I(a)}finally{I=null}};r=function(a){null!==I?setTimeout(r,0,a):(I=a,setTimeout(J,0,!1))};q=function(){I=null};w=function(){return!1}}else{"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),
	"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K=null,L=!1,M=-1,N=!1,O=!1,P=0,R=33,S=33;w=function(){return P<=exports.unstable_now()};var T=new MessageChannel,U=T.port2;T.port1.onmessage=function(){L=!1;var a=K,b=M;K=null;M=-1;var c=exports.unstable_now(),f=!1;if(0>=P-c)if(-1!==b&&b<=c)f=!0;else{N||(N=!0,E(V));K=a;M=b;return}if(null!==a){O=!0;try{a(f)}finally{O=!1}}};
	var V=function(a){if(null!==K){E(V);var b=a-P+S;b<S&&R<S?(8>b&&(b=8),S=b<R?R:b):R=b;P=a+S;L||(L=!0,U.postMessage(void 0))}else N=!1};r=function(a,b){K=a;M=b;O||0>b?U.postMessage(void 0):N||(N=!0,E(V))};q=function(){K=null;L=!1;M=-1}}exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
	exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=g,f=k;g=a;k=exports.unstable_now();try{return b()}finally{g=c,k=f,v()}};exports.unstable_next=function(a){switch(g){case 1:case 2:case 3:var b=3;break;default:b=g}var c=g,f=k;g=b;k=exports.unstable_now();try{return a()}finally{g=c,k=f,v()}};
	exports.unstable_scheduleCallback=function(a,b){var c=-1!==k?k:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=c+b.timeout;else switch(g){case 1:b=c+-1;break;case 2:b=c+250;break;case 5:b=c+1073741823;break;case 4:b=c+1E4;break;default:b=c+5E3}a={callback:a,priorityLevel:g,expirationTime:b,next:null,previous:null};if(null===d)d=a.next=a.previous=a,p();else{c=null;var f=d;do{if(f.expirationTime>b){c=f;break}f=f.next}while(f!==d);null===c?c=d:c===d&&(d=a,p());
	b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)d=null;else{a===d&&(d=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=g;return function(){var c=g,f=k;g=b;k=exports.unstable_now();try{return a.apply(this,arguments)}finally{g=c,k=f,v()}}};exports.unstable_getCurrentPriorityLevel=function(){return g};
	exports.unstable_shouldYield=function(){return!e&&(null!==d&&d.expirationTime<l||w())};exports.unstable_continueExecution=function(){null!==d&&p()};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return d};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(2142);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ },
/* 2144 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1585);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./UploadFolderTree.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./UploadFolderTree.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2145 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1586);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./IManageWorkspaceFolderSelector.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./IManageWorkspaceFolderSelector.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2146 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1587);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./ApiCalls.less", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./ApiCalls.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2147 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1588);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./filenameTemplate.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./filenameTemplate.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2148 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1590);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./ClientCode.less", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./ClientCode.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2149 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1591);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./SubmitButton.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./SubmitButton.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2150 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1592);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./LoggedOutInfoMessage.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./LoggedOutInfoMessage.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2151 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1593);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./AlertMessage.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./AlertMessage.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2152 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1594);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./DateFilter.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./DateFilter.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2153 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1595);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./DateRangeContainer.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./DateRangeContainer.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2154 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1596);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./DateTimePicker.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./DateTimePicker.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2155 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1597);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./FieldSet.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./FieldSet.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2156 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1598);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./FormOption.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./FormOption.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2157 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1599);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./FormOptions.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./FormOptions.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2158 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1600);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./InfoMessage.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./InfoMessage.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2159 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1602);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./Receipt.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./Receipt.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2160 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1603);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./ResultsTable.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./ResultsTable.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2161 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1604);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./Selector.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./Selector.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2162 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1605);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./WarningBox.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./WarningBox.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2163 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1607);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./AssociatedCases.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./AssociatedCases.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2164 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1608);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./OtherCourtInfo.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./OtherCourtInfo.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2165 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1609);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./OtherFilings.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./OtherFilings.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2166 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1610);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./RelatedCases.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./RelatedCases.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2167 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1611);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./CaseAttorneys.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./CaseAttorneys.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2168 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1612);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./clientCodeDialog.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./clientCodeDialog.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2169 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1613);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./CreditorMailing.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./CreditorMailing.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2170 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1614);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./CaseCreditors.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./CaseCreditors.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2171 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1615);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./DeadlineCases.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./DeadlineCases.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2172 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1618);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./FilersCases.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./FilersCases.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2173 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1620);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./PartiesCases.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./PartiesCases.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2174 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1622);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./Status.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./Status.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2175 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1623);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./Loading.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./Loading.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2176 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1625);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./Notification.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./Notification.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2177 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1626);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./PopupError.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./PopupError.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2178 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1627);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./ProgressBar.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./ProgressBar.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2179 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1628);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./RefineSearch.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./RefineSearch.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2180 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1629);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./NatureOfSuitOfAppellete.less", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./NatureOfSuitOfAppellete.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2181 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1630);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./ResultColumnHeadTextFormElement.less", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./ResultColumnHeadTextFormElement.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2182 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1631);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./Tip.less", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./Tip.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2183 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1632);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./actionButtons.less", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./actionButtons.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2184 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1633);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./nos-selector.less", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./nos-selector.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2185 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1634);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./pagination.less", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./pagination.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2186 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1635);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./PartySelector.less", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./PartySelector.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2187 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1637);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./CustomAlertEdit.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./CustomAlertEdit.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2188 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1638);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./TemplateAlerts.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./TemplateAlerts.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2189 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1639);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./alert.less", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./alert.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2190 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1640);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./collapsible.less", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./collapsible.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2191 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1641);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./flashYellow.less", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./flashYellow.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2192 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1642);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./index.less", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./index.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2193 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1643);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./popup.less", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./popup.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2194 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1644);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./searchResults.less", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./searchResults.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2195 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1645);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./sortArrow.less", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./sortArrow.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2196 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1646);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./CreateAlertModal.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./CreateAlertModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2197 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1647);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./advancedSearchAlert.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./advancedSearchAlert.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2198 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1648);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./caseLookup.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./caseLookup.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2199 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1649);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./FacetsBlock.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./FacetsBlock.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2200 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1650);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/less-loader/index.js!./hints.less", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/less-loader/index.js!./hints.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2201 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1651);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./ReportsTab.less", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./ReportsTab.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2202 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1652);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/less-loader/index.js!./automateReportAndDelivery.less", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/less-loader/index.js!./automateReportAndDelivery.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2203 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1653);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/less-loader/index.js!./bankruptcy.less", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/less-loader/index.js!./bankruptcy.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2204 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1654);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/less-loader/index.js!./civil.less", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/less-loader/index.js!./civil.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2205 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1655);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/less-loader/index.js!./criminal.less", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/less-loader/index.js!./criminal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2206 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1657);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./CommonSchedule.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./CommonSchedule.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2207 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1666);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./react-select.css", function() {
				var newContent = require("!!../../css-loader/index.js!./react-select.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2208 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1667);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./ReactToastify.css", function() {
				var newContent = require("!!../../css-loader/index.js!./ReactToastify.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2209 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1764);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./node_modules/css-loader/index.js!../less-loader/index.js!./font-awesome-styles.loader.js!./font-awesome.config.js", function() {
				var newContent = require("!!./node_modules/css-loader/index.js!../less-loader/index.js!./font-awesome-styles.loader.js!./font-awesome.config.js");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2210 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Check if `fn` is a function.
	 *
	 * @param {Function} fn
	 * @return {Boolean}
	 * @api private
	 */
	var isObject = __webpack_require__(531);
	
	function isFunction(fn) {
	  var tag = isObject(fn) ? Object.prototype.toString.call(fn) : '';
	  return tag === '[object Function]';
	}
	
	module.exports = isFunction;


/***/ },
/* 2211 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module of mixed-in functions shared between node and client code
	 */
	var isObject = __webpack_require__(531);
	
	/**
	 * Expose `RequestBase`.
	 */
	
	module.exports = RequestBase;
	
	/**
	 * Initialize a new `RequestBase`.
	 *
	 * @api public
	 */
	
	function RequestBase(obj) {
	  if (obj) return mixin(obj);
	}
	
	/**
	 * Mixin the prototype properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in RequestBase.prototype) {
	    obj[key] = RequestBase.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Clear previous timeout.
	 *
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.clearTimeout = function _clearTimeout(){
	  this._timeout = 0;
	  this._responseTimeout = 0;
	  clearTimeout(this._timer);
	  clearTimeout(this._responseTimeoutTimer);
	  return this;
	};
	
	/**
	 * Override default response body parser
	 *
	 * This function will be called to convert incoming data into request.body
	 *
	 * @param {Function}
	 * @api public
	 */
	
	RequestBase.prototype.parse = function parse(fn){
	  this._parser = fn;
	  return this;
	};
	
	/**
	 * Set format of binary response body.
	 * In browser valid formats are 'blob' and 'arraybuffer',
	 * which return Blob and ArrayBuffer, respectively.
	 *
	 * In Node all values result in Buffer.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .responseType('blob')
	 *        .end(callback);
	 *
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.responseType = function(val){
	  this._responseType = val;
	  return this;
	};
	
	/**
	 * Override default request body serializer
	 *
	 * This function will be called to convert data set via .send or .attach into payload to send
	 *
	 * @param {Function}
	 * @api public
	 */
	
	RequestBase.prototype.serialize = function serialize(fn){
	  this._serializer = fn;
	  return this;
	};
	
	/**
	 * Set timeouts.
	 *
	 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
	 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
	 *
	 * Value of 0 or false means no timeout.
	 *
	 * @param {Number|Object} ms or {response, read, deadline}
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.timeout = function timeout(options){
	  if (!options || 'object' !== typeof options) {
	    this._timeout = options;
	    this._responseTimeout = 0;
	    return this;
	  }
	
	  if ('undefined' !== typeof options.deadline) {
	    this._timeout = options.deadline;
	  }
	  if ('undefined' !== typeof options.response) {
	    this._responseTimeout = options.response;
	  }
	  return this;
	};
	
	/**
	 * Promise support
	 *
	 * @param {Function} resolve
	 * @param {Function} [reject]
	 * @return {Request}
	 */
	
	RequestBase.prototype.then = function then(resolve, reject) {
	  if (!this._fullfilledPromise) {
	    var self = this;
	    if (this._endCalled) {
	      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
	    }
	    this._fullfilledPromise = new Promise(function(innerResolve, innerReject){
	      self.end(function(err, res){
	        if (err) innerReject(err); else innerResolve(res);
	      });
	    });
	  }
	  return this._fullfilledPromise.then(resolve, reject);
	}
	
	RequestBase.prototype.catch = function(cb) {
	  return this.then(undefined, cb);
	};
	
	/**
	 * Allow for extension
	 */
	
	RequestBase.prototype.use = function use(fn) {
	  fn(this);
	  return this;
	}
	
	RequestBase.prototype.ok = function(cb) {
	  if ('function' !== typeof cb) throw Error("Callback required");
	  this._okCallback = cb;
	  return this;
	};
	
	RequestBase.prototype._isResponseOK = function(res) {
	  if (!res) {
	    return false;
	  }
	
	  if (this._okCallback) {
	    return this._okCallback(res);
	  }
	
	  return res.status >= 200 && res.status < 300;
	};
	
	
	/**
	 * Get request header `field`.
	 * Case-insensitive.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	RequestBase.prototype.get = function(field){
	  return this._header[field.toLowerCase()];
	};
	
	/**
	 * Get case-insensitive header `field` value.
	 * This is a deprecated internal API. Use `.get(field)` instead.
	 *
	 * (getHeader is no longer used internally by the superagent code base)
	 *
	 * @param {String} field
	 * @return {String}
	 * @api private
	 * @deprecated
	 */
	
	RequestBase.prototype.getHeader = RequestBase.prototype.get;
	
	/**
	 * Set header `field` to `val`, or multiple fields with one object.
	 * Case-insensitive.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .set('Accept', 'application/json')
	 *        .set('X-API-Key', 'foobar')
	 *        .end(callback);
	 *
	 *      req.get('/')
	 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
	 *        .end(callback);
	 *
	 * @param {String|Object} field
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.set = function(field, val){
	  if (isObject(field)) {
	    for (var key in field) {
	      this.set(key, field[key]);
	    }
	    return this;
	  }
	  this._header[field.toLowerCase()] = val;
	  this.header[field] = val;
	  return this;
	};
	
	/**
	 * Remove header `field`.
	 * Case-insensitive.
	 *
	 * Example:
	 *
	 *      req.get('/')
	 *        .unset('User-Agent')
	 *        .end(callback);
	 *
	 * @param {String} field
	 */
	RequestBase.prototype.unset = function(field){
	  delete this._header[field.toLowerCase()];
	  delete this.header[field];
	  return this;
	};
	
	/**
	 * Write the field `name` and `val`, or multiple fields with one object
	 * for "multipart/form-data" request bodies.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .field('foo', 'bar')
	 *   .end(callback);
	 *
	 * request.post('/upload')
	 *   .field({ foo: 'bar', baz: 'qux' })
	 *   .end(callback);
	 * ```
	 *
	 * @param {String|Object} name
	 * @param {String|Blob|File|Buffer|fs.ReadStream} val
	 * @return {Request} for chaining
	 * @api public
	 */
	RequestBase.prototype.field = function(name, val) {
	
	  // name should be either a string or an object.
	  if (null === name ||  undefined === name) {
	    throw new Error('.field(name, val) name can not be empty');
	  }
	
	  if (this._data) {
	    console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
	  }
	
	  if (isObject(name)) {
	    for (var key in name) {
	      this.field(key, name[key]);
	    }
	    return this;
	  }
	
	  if (Array.isArray(val)) {
	    for (var i in val) {
	      this.field(name, val[i]);
	    }
	    return this;
	  }
	
	  // val should be defined now
	  if (null === val || undefined === val) {
	    throw new Error('.field(name, val) val can not be empty');
	  }
	  if ('boolean' === typeof val) {
	    val = '' + val;
	  }
	  this._getFormData().append(name, val);
	  return this;
	};
	
	/**
	 * Abort the request, and clear potential timeout.
	 *
	 * @return {Request}
	 * @api public
	 */
	RequestBase.prototype.abort = function(){
	  if (this._aborted) {
	    return this;
	  }
	  this._aborted = true;
	  this.xhr && this.xhr.abort(); // browser
	  this.req && this.req.abort(); // node
	  this.clearTimeout();
	  this.emit('abort');
	  return this;
	};
	
	/**
	 * Enable transmission of cookies with x-domain requests.
	 *
	 * Note that for this to work the origin must not be
	 * using "Access-Control-Allow-Origin" with a wildcard,
	 * and also must set "Access-Control-Allow-Credentials"
	 * to "true".
	 *
	 * @api public
	 */
	
	RequestBase.prototype.withCredentials = function(){
	  // This is browser-only functionality. Node side is no-op.
	  this._withCredentials = true;
	  return this;
	};
	
	/**
	 * Set the max redirects to `n`. Does noting in browser XHR implementation.
	 *
	 * @param {Number} n
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.redirects = function(n){
	  this._maxRedirects = n;
	  return this;
	};
	
	/**
	 * Convert to a plain javascript object (not JSON string) of scalar properties.
	 * Note as this method is designed to return a useful non-this value,
	 * it cannot be chained.
	 *
	 * @return {Object} describing method, url, and data of this request
	 * @api public
	 */
	
	RequestBase.prototype.toJSON = function(){
	  return {
	    method: this.method,
	    url: this.url,
	    data: this._data,
	    headers: this._header
	  };
	};
	
	
	/**
	 * Send `data` as the request body, defaulting the `.type()` to "json" when
	 * an object is given.
	 *
	 * Examples:
	 *
	 *       // manual json
	 *       request.post('/user')
	 *         .type('json')
	 *         .send('{"name":"tj"}')
	 *         .end(callback)
	 *
	 *       // auto json
	 *       request.post('/user')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // manual x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send('name=tj')
	 *         .end(callback)
	 *
	 *       // auto x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // defaults to x-www-form-urlencoded
	 *      request.post('/user')
	 *        .send('name=tobi')
	 *        .send('species=ferret')
	 *        .end(callback)
	 *
	 * @param {String|Object} data
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.send = function(data){
	  var isObj = isObject(data);
	  var type = this._header['content-type'];
	
	  if (this._formData) {
	    console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
	  }
	
	  if (isObj && !this._data) {
	    if (Array.isArray(data)) {
	      this._data = [];
	    } else if (!this._isHost(data)) {
	      this._data = {};
	    }
	  } else if (data && this._data && this._isHost(this._data)) {
	    throw Error("Can't merge these send calls");
	  }
	
	  // merge
	  if (isObj && isObject(this._data)) {
	    for (var key in data) {
	      this._data[key] = data[key];
	    }
	  } else if ('string' == typeof data) {
	    // default to x-www-form-urlencoded
	    if (!type) this.type('form');
	    type = this._header['content-type'];
	    if ('application/x-www-form-urlencoded' == type) {
	      this._data = this._data
	        ? this._data + '&' + data
	        : data;
	    } else {
	      this._data = (this._data || '') + data;
	    }
	  } else {
	    this._data = data;
	  }
	
	  if (!isObj || this._isHost(data)) {
	    return this;
	  }
	
	  // default to json
	  if (!type) this.type('json');
	  return this;
	};
	
	
	/**
	 * Sort `querystring` by the sort function
	 *
	 *
	 * Examples:
	 *
	 *       // default order
	 *       request.get('/user')
	 *         .query('name=Nick')
	 *         .query('search=Manny')
	 *         .sortQuery()
	 *         .end(callback)
	 *
	 *       // customized sort function
	 *       request.get('/user')
	 *         .query('name=Nick')
	 *         .query('search=Manny')
	 *         .sortQuery(function(a, b){
	 *           return a.length - b.length;
	 *         })
	 *         .end(callback)
	 *
	 *
	 * @param {Function} sort
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.sortQuery = function(sort) {
	  // _sort default to true but otherwise can be a function or boolean
	  this._sort = typeof sort === 'undefined' ? true : sort;
	  return this;
	};
	
	/**
	 * Invoke callback with timeout error.
	 *
	 * @api private
	 */
	
	RequestBase.prototype._timeoutError = function(reason, timeout){
	  if (this._aborted) {
	    return;
	  }
	  var err = new Error(reason + timeout + 'ms exceeded');
	  err.timeout = timeout;
	  err.code = 'ECONNABORTED';
	  this.timedout = true;
	  this.abort();
	  this.callback(err);
	};
	
	RequestBase.prototype._setTimeouts = function() {
	  var self = this;
	
	  // deadline
	  if (this._timeout && !this._timer) {
	    this._timer = setTimeout(function(){
	      self._timeoutError('Timeout of ', self._timeout);
	    }, this._timeout);
	  }
	  // response timeout
	  if (this._responseTimeout && !this._responseTimeoutTimer) {
	    this._responseTimeoutTimer = setTimeout(function(){
	      self._timeoutError('Response timeout of ', self._responseTimeout);
	    }, this._responseTimeout);
	  }
	}


/***/ },
/* 2212 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var utils = __webpack_require__(2213);
	
	/**
	 * Expose `ResponseBase`.
	 */
	
	module.exports = ResponseBase;
	
	/**
	 * Initialize a new `ResponseBase`.
	 *
	 * @api public
	 */
	
	function ResponseBase(obj) {
	  if (obj) return mixin(obj);
	}
	
	/**
	 * Mixin the prototype properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in ResponseBase.prototype) {
	    obj[key] = ResponseBase.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Get case-insensitive `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	ResponseBase.prototype.get = function(field){
	    return this.header[field.toLowerCase()];
	};
	
	/**
	 * Set header related properties:
	 *
	 *   - `.type` the content type without params
	 *
	 * A response of "Content-Type: text/plain; charset=utf-8"
	 * will provide you with a `.type` of "text/plain".
	 *
	 * @param {Object} header
	 * @api private
	 */
	
	ResponseBase.prototype._setHeaderProperties = function(header){
	    // TODO: moar!
	    // TODO: make this a util
	
	    // content-type
	    var ct = header['content-type'] || '';
	    this.type = utils.type(ct);
	
	    // params
	    var params = utils.params(ct);
	    for (var key in params) this[key] = params[key];
	
	    this.links = {};
	
	    // links
	    try {
	        if (header.link) {
	            this.links = utils.parseLinks(header.link);
	        }
	    } catch (err) {
	        // ignore
	    }
	};
	
	/**
	 * Set flags such as `.ok` based on `status`.
	 *
	 * For example a 2xx response will give you a `.ok` of __true__
	 * whereas 5xx will be __false__ and `.error` will be __true__. The
	 * `.clientError` and `.serverError` are also available to be more
	 * specific, and `.statusType` is the class of error ranging from 1..5
	 * sometimes useful for mapping respond colors etc.
	 *
	 * "sugar" properties are also defined for common cases. Currently providing:
	 *
	 *   - .noContent
	 *   - .badRequest
	 *   - .unauthorized
	 *   - .notAcceptable
	 *   - .notFound
	 *
	 * @param {Number} status
	 * @api private
	 */
	
	ResponseBase.prototype._setStatusProperties = function(status){
	    var type = status / 100 | 0;
	
	    // status / class
	    this.status = this.statusCode = status;
	    this.statusType = type;
	
	    // basics
	    this.info = 1 == type;
	    this.ok = 2 == type;
	    this.redirect = 3 == type;
	    this.clientError = 4 == type;
	    this.serverError = 5 == type;
	    this.error = (4 == type || 5 == type)
	        ? this.toError()
	        : false;
	
	    // sugar
	    this.accepted = 202 == status;
	    this.noContent = 204 == status;
	    this.badRequest = 400 == status;
	    this.unauthorized = 401 == status;
	    this.notAcceptable = 406 == status;
	    this.forbidden = 403 == status;
	    this.notFound = 404 == status;
	};


/***/ },
/* 2213 */
/***/ function(module, exports) {

	
	/**
	 * Return the mime type for the given `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	exports.type = function(str){
	  return str.split(/ *; */).shift();
	};
	
	/**
	 * Return header field parameters.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	exports.params = function(str){
	  return str.split(/ *; */).reduce(function(obj, str){
	    var parts = str.split(/ *= */);
	    var key = parts.shift();
	    var val = parts.shift();
	
	    if (key && val) obj[key] = val;
	    return obj;
	  }, {});
	};
	
	/**
	 * Parse Link header fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	exports.parseLinks = function(str){
	  return str.split(/ *, */).reduce(function(obj, str){
	    var parts = str.split(/ *; */);
	    var url = parts[0].slice(1, -1);
	    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
	    obj[rel] = url;
	    return obj;
	  }, {});
	};
	
	/**
	 * Strip content related fields from `header`.
	 *
	 * @param {Object} header
	 * @return {Object} header
	 * @api private
	 */
	
	exports.cleanHeader = function(header, shouldStripCookie){
	  delete header['content-type'];
	  delete header['content-length'];
	  delete header['transfer-encoding'];
	  delete header['host'];
	  if (shouldStripCookie) {
	    delete header['cookie'];
	  }
	  return header;
	};


/***/ },
/* 2214 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* global window */
	'use strict';
	
	module.exports = __webpack_require__(2215)(global || window || this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2215 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function symbolObservablePonyfill(root) {
		var result;
		var Symbol = root.Symbol;
	
		if (typeof Symbol === 'function') {
			if (Symbol.observable) {
				result = Symbol.observable;
			} else {
				result = Symbol('observable');
				Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};


/***/ },
/* 2216 */
/***/ function(module, exports) {

	
	module.exports = function () {
	  var selection = document.getSelection();
	  if (!selection.rangeCount) {
	    return function () {};
	  }
	  var active = document.activeElement;
	
	  var ranges = [];
	  for (var i = 0; i < selection.rangeCount; i++) {
	    ranges.push(selection.getRangeAt(i));
	  }
	
	  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
	    case 'INPUT':
	    case 'TEXTAREA':
	      active.blur();
	      break;
	
	    default:
	      active = null;
	      break;
	  }
	
	  selection.removeAllRanges();
	  return function () {
	    selection.type === 'Caret' &&
	    selection.removeAllRanges();
	
	    if (!selection.rangeCount) {
	      ranges.forEach(function(range) {
	        selection.addRange(range);
	      });
	    }
	
	    active &&
	    active.focus();
	  };
	};


/***/ },
/* 2217 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fa2772327f55d8198301fdb8bcfc8158.woff";

/***/ },
/* 2218 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "448c34a56d699c29117adc64c43affeb.woff2";

/***/ },
/* 2219 */
/***/ function(module, exports) {

	module.exports = "data:application/font-woff;base64,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"

/***/ },
/* 2220 */
/***/ function(module, exports) {

	module.exports = "data:image/gif;base64,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"

/***/ },
/* 2221 */
/***/ function(module, exports) {

	module.exports = "data:image/gif;base64,R0lGODlhEAAQAPIAAP///zMzM87OzmdnZzMzM4GBgZqamqenpyH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="

/***/ },
/* 2222 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAzwAAAEGCAMAAACXVmA+AAAAq1BMVEUAAAAId7nB3e5kqtMWf72izOUMebp0s9j5/P5ToM7w9/sbgr/2+v0Oe7tMnMz9/v7J4fAlh8LS5vM3kcfk8Pdep9KTxOESfLwpisMghMA8lMjr9Pl7ttrz+fxFmcsyjsWy1eqDu9yXxuLt9foujMTn8vjW6fRAlsmv0+ir0edYpNDg7vbb6/WPwd+32OvN4/GKv95+udtwsdemzuabyeNsrta92+1orNWgy+QVS/rZAAAAAXRSTlMAQObYZgAAHKtJREFUeNrs3YdiokAUBdB3FZGiiGJB166xxlWjxvz/l+1mewktcZhB3vmDRK/MXN4AMcYYY/dvtl9NJ08tx/PrmlbFVx3Nrtc9p1U+nFfujBhj/xi457I50hBB8zblqTsgxthXs/HE9JGIvzl8fiDG8uzx5TrHO82vpy0xlkfWqtjFB9VbJ94HsZxpHJY6bkIf7hbEWE40jnPclF9uEGN373EyhwDzA2+A2F2rnJYQZnnmDpvdq8aTBqG0J97+sDtUWy2RguHKIMbuyWDqIyX1doUYuxezo40U2QeLGLsH1rGDlGn9T/RhjxxBJpc10SBB52jRxxTOxJhExs6GJNquQh+wNokxiVY+JKqf6N3aNo9tM4kaQ0jW29P7lDEmxmSZXXTId5lRckYLF2JMlrUNJdglSspyMOd7RUyWpgllOFtK5MFDlae0mSS1qQaFdKaUwKIO7IgxKZrSi4J/DbcUl2sDDjEmxVqpy8532oniGXcAbqmZHIMilNSyKIazDnBLzeRwfSjK31OkCQBuqZkc0yqUpU8pnFEEwC01k6LSgtKKobmoOAC4pWZSbD0ozttSoE89ANxSMykKiswUhLELFODRB8AtNZPiRYVRtkj6C71pbwPglppJcURGHOkNnzsAuKUWb9Z4Hq/Hn90tP6flF0PxquBPLYP+VdIBbqkFMwp9R8NP+qhY4sv8q4GDDHEG9LcDAG6pxdpfNPxn+cL/8VkPmdL7RH+oPQHglloo18Hbuu2cr9+aI2TM6I/0VDb4oU1ZVbEslX/CrSuCzQuUY01lJ3KC+U36YbYEkL2W+sEdT/tFc+jVtSp+0DTb7zmtp8l0vFfptUUNH6EmNcqrLGbnd3qacwBZaqmNRum48TqI0hmZ5dJehevRcwcRWnldumUzOz/T0+gCyExLvThfetXEr28tvDdBhVIshYjs6Ii0yee1J0F2tF6rvzuNxwUhxuPTrt/qaYjLfyAqaACy0VI32qaN99G9p7FFyRURS5HCPGqIoU85NBshFq+82lIqtquyF7c1WOtAFlrqweraxcfoy4krIzyGh1ieKXcGPUSrmqVPlKpZyawimg9A/ZbaKjk6bqL+VKilHZ4D4qmr/OMlhOEgkje1SAJr6iEG1Vvqytqs4oa65Uaq4bG0rH8CwrQQxXRJmsIGURRvqRdlDTfnta30wnOIH+ucNW5HRDAXJFXDRCilW2pjvYQYncsirfD4iJKltvOGXhCu55J0rpfRz23QrkMgp5BKeBqIr0g5UtARRlPj9Ta1s4YACrfU1lGDYL3PKYRnh/i6lB9bG2EcZVZCTQdvUrelHkw0pGDpCg/PBgko840RruIhhK5Ud7LTEUaB1aWk94GZj4LD4yGB/AyIthCiq9j30e1mZ7E99pGe6rEiNDw2EjhRTkwRwlPuAtz0EOKFlLFwkK76s8jwdJCAGptk8dwqgpmq7SHePuqq4HiBMakiddeBuPDo93Cj+sYGPoJtlLzbZZgI5qvx0vj9CDL4e2Hh0ZBAiXKhmMHp8tD0tEg+o69DDv0sKjw+wHdJ/7ZGMFPJ607kIN6aZHvsQZ6rISY8DhJQZfEsVFNDIE/B/c5PAw+BtCbJdepAonpNTHjKiE9X9mf3hmpDBOoq17P982DDQEOSybhCqomgZdsK8S0pB6YIpCt2f+cvL7qyXc/DElLpTUHhmelJAnz/mpqaX8AoE4TrNEkWtwu5HGFT1SZi29L9MzN3KuZV7aLumZ5xB5KthIXnc9aPVN3UGoE0dTc8FVPd8ZCz9LdL2Iaw8FAPv2VpwlCEmZ3F8YrZEjHYM5JgAunKJC48e51P8/x0QaAeqWo7xyslz/X0Id9CYHjoiDi6Kj3hVJCGnsHrbqOLePQGRbrD7CxJZHhqJqJ19nT/hghkkqKeNfxFpZs9KmQHL0LDQ9YwOjuf6f6tQq/9ajrp+Ic6UzoK7HcATcBUdbK2xs7DMbhKPXsXnh2+UfLRe22o4EpCw/NqV0WIZZNyYJe9prGMZHaUnpX0jvobV3x46NFBkK5CRxEFsmwE8khFxgYJ2RalpaDj47rD4vG8et5vt02ruW00nl+fdu91EN+IhIfnlWvqeMO8rfAkMaW0Qp+SggK2qtULgh0pJU0bH+Ndz+6A3vbwfNjUEUs7jfC8+jQ1O//ktqzoeuX2LA2BqmocxYz3tsd22Lhi54FSUfHwAX55PIv++0/X6ABVZymF55WxOE0upjMcmq1+u6Did0aUPrJVFyzqeJMTPq5YplS08G6jL+zd2XbiOBSF4b0dYww28zyFMA8BQshU7/9kvTqdpAnpGAmOjNyL765uqmoRfgJCOtpOoWq6nTFSDRHxXDcHCBk1knX83HF/n0v9h79rjBCDIU/kpsvQU11X+LvXazwxeGSEDmwzz0WclO9c+lxJOceT9FOh7G0LpcI1HvN6AZO01jb0IvevVXS+NJQX9gXGS2vxnyq/vFJc4zFvyMt/TlDXPTKXOs0IW5i24wn6dziLk+FP1Ws85hWajDCHVfybY+MN5xe9ZsmhPve5gHOVazyQxzUe8+YJOkHbyx/9UqN6yR1uYZPa3kaQMM3wm/k1nhi0GcGFTToVhaO+7gXnuKSpq7WBlGL72xHSazzmlUkm5Bjcqqlye+LscuP3yh41ZbIQ9NTipzSu8Zi3Iy0fVvupGPBXG3ypXe7pcEs93hqysjt+mF7jMS90GaULa0QNNtwpHw5uZGHMgnrcV4grjj/enl7jMS9lzz7+0wcb9kP1b/ifYUpYopbmCgaEXZL8c40nBjMrZzb9NFC+hGfBC32K21JLfwIzXlts9K7xmLdKxt0QhTf1rfd3jDaFGb2AOtpZmNK5fcM1HvMeExFPmNEYSOmQF/kYN6COfhbm+JNrPDEYJ+Ea4+jBhkFHL54SjMi61DDuwKhrPOaVk3AH+JHBhhvoxcMiTNhSQ3APbdd4LPOYgHiODDbcQTeeNAzwW1SXu/gZ5Ws8irJZ/KZpfzxHBhv2Q+14SjAglayb1RMdT9VZrLu1zG2lVHL/1iqN2/nly/bPZupDTriojT3SG7/d+fipTIl4BhOY8+SRelfFOxeZ2t/n3xLzlExoPKu7wbKf4++8Uj6dKksk1Bu4/NJa+zi0FYlnE8xhyprR6jghnkeIc6iu2cPFicTTTSspQoLvbDMB1eRm3fkIZ3FK79Hka7XbgCTHDzgwE4kHM9ZGMKGQZrT8Sc/jCsTVeMDyCypF4nGpJIWzreqZBvV47UencNZx5cbnTIniS47MLfBN1pOJx1HbWS8/2DDonBQPJxCWbXCf/dsFkxTPdNDnaVovr4WTD1cvJ/hynye9he5GRgcq8iTfshCgN4N/g9PiSUHY0NaZ2YmPp1Ov8Byt7hTaXj1y/WNdOveAPTdS8RRJsuRAVLXPI3Y4MZ4lhLX5r0Ts2UhIPMWax7PNFj609Frv7YTZd+HX7Izx/t/TkooHGf5tF0LOtMQj+uGp8QSQdU977wlKbjyFRYUyWtue5reftb3HqLkuACjkvy1PrSgWT5nvmkVAcrCh2iq1fjycQtSayiy5J83+ePzUmHKCQRaqei7dzrfHaPmei7c/P+aPXDyo8Z3X9QUHG0ar4/R4ni/1rm0JO1gfz3xMWe7aV/++u/vxGLVvbmrjzw/Xb/sfst8E41l5/Ee/DAF1j8fkcUY8NUiqUlkZdrA8nocZ5ZUWULIkVx+PUR2An/+Yp+nsf8pWadvR/ml4Az+O+zyDzjnxtCDpmd8kYWq+1fFkX2hGfgUFJZawFw+2Hz+3gssKPowoGU/V46fKVGSwYbQNzomHVQhaUtUrLGFzPPOApuS2BRwTkpn9ePzbz0nObbr4cCcaD3b8klsXBAYbRtrhvHjmkFNwqWgMW9gbT/aGJs1WOKJDvn0+Rv1MJlP6etHLkPgwkI1nkov4L2qYVHhcPzwznkfIKVJVHbawNp5iiWY1ntTj+bTDYTwZ2XjQ5Z7GUGCwofIqtX48ecgZUJFnz3UttsZT92jci6/8tu1dawEcvm1rCsczcrkvX5UbbHiojnPjaUFOPnHLBbbGE9YYh/ZEdcFgm3VIbwocLBj0qMI5/RXYTUkMNtT/teEw5hUDl18SMsfL0ng6M8ajNFVfqq6Rt8DBUnVRPJ5swO8yE/3BhgqCjkA8r5AypSLPomtubYxnVWJc3Fe1L0nrwH2OXODjzxutLyecs2ZgBHMTHx42EIinDimphG1rszWecovxaWyUtufUAaTJUu9ge05aPp6wxUO1kc5gQyU7SMSzg5QdvyRldLGN8ZQDxsm7i9wYuvw3nmxAPh5sDM3Ix4PhGffPhBkq6Yci8eQh5TZhe0LtjGcaMF7e5tiRhC8/jyT0DcTjl3hA+ZRcp00luTJE4ilBSotq3ALsYVs8qxbj1nB0DsN1vz31XMF4ojdqlxylwYZq6pCJhz5kdBK4UG1dPNkx4+eu9I5hz/FpRBPx+GMeUDsl99Cimjyk4rmPe27OABaxKx7/lpfQHOE3z3sDQArFt4MBIA9i8aiMRWgWFQYbKgg6Ys/mImT8Sdb5ayvjeeFl3BaOjJ4Kbv9z9NTcTDyFCg8onJJ78qhoA7F4FnFvzqnCIlbF88RL6Z429HAoH0/0Xu1++fwR6TvIxbOO92nIBmxiUzzTBi9mEzlu92bskV7/x7jdgaF40Oah6FNyhTRV9UPBeNIxr1RXYBOL4vErPE2jstx1B/XtY/pm1uIBqc8BvR5+2pmK55WHIk/JhUuqypUhGM8NZIwTNr3AungeeYLxy6KKfT1nkG9Q39LgfFhH4KU46pRc9pbK6pCMJxPzttA0bGJPPA+efjnrFf5LOM941LWAvryxeIoaB/mqfSrLQzSeGUQUkncQzqp4ChVqyjj43eTRpZ5WFtoqivGIdnl4Sm7a0nl3KhtPHyJGVLSATayJ55l6bouIlu3mqCUNbSVz8ZQZKV89GGyoZgPZeFoQsUrc7A+r4sm61BEscNwqTx3e1KZ4sGQkN/U12FDdDsLxuBBRTOK2UHvi6VJHpgMlw5zZNQPXYDxTHpGZ6B5X74fS8eRi3p2zgk0siWfSoDpvDVXlEjU82BQPbnhEMEeXGnJl+adzzPHcwyaWxJOmusYd1HXaVJeBppzJeFYejxlTRx22xnNHRRPYxI54Rg0qa7wKXO4kNPefJuPBC0XlYSCeMN54LBpgYE08AyrLvUJPtk1lN1bFU81RUNAxEU/2Gs+F4/EDGvwus9OkKm9iUzxIU9AG/4N4rNpUbUc8Cyp7hAb9Dadbq+IZNSgmDSPx+DLxXBcMTo7nVuvgjb4UVTUtWjBQ2e6nt0pt7YLBhoqmsIkN8VSpyr03fX2FY89SNYCsSxm5KWyOx6GiImxiQzxbmt4XOHGp6MWqeLCljCH+YekOA+V4NrCJDfFUqKhfwInqVBQUbNme864XUEIGdsdTpqIUbGJBPPc0/7rjN6nIsSoeher1Vqnt3BhapaItbGJBPEMqascxC7lryZGED2GJ59vAVDxjiOhR0QtsYkE8GSqa43R+i2oqdhyGUzyqob9KbeVhOHhUk4dNLh+P36Calo8zPFLRxIpj2BFvOHX1Q3PxLCEjoJoSbHL5eIqMZVjkvYnfbzvz8SDF8+SmMBfPG2T0qagHi1w+nnpM3y7nDbzJGcQQT2EstkotH08XMjKJPA13+XiWMY3sGhpYlhjGEA/m0qvUFg49fKGiISxy+XiaVDOIaTk0V4CyeRzxoCK1Si0fzxNkbKnoBha5eDxhbL+wK/JHfR9iiWcjtUotH48DGU9UNIZFLh7PA9U0CjjTTn7FYBTPU2wmtEotH08VMh6YxLOkF48nFdtFrk8G3h+6scTjyKxSy/+T3l/c3Yla6joUhuH/x9qJoUxlKKOgIIigiMP9X9l5zvSckZpAkq76XsFW9wc0JFkJzJiwhJPki4/njq7WdXY0v/w6cxIPGk5WqfXjGcCUVhkfegqP58bdXZGe+W+xIzfxNM2vUgsb6NtgCYeSFh7P1N1Jjpn5Z9LATTyIeIEItuN5hykBS3hpaOHx3Lt7UIzMD1A6OYqn7WKVWj+eHkzZsIR7QwuPZ+juasqj+XP5TUfxIKW2PazHU4EpO6ryQkhReDw+nT2aPlPNCMomrv6P7XxqCmA/niWMqVLVI6QoOp6Jw3l6PQu3TAwcxYNP7VVq+/EMYU5Elu5YQtHxxJo7zlzsT25DXeQqnq6vu0ptP54GzHkhS3eFTtHxdKlm6vCh9AB1d67iwZE6FnAQzxjmNFm+JYOi43miu+GXcwvXGMxdxKM/SCKCi3g2MCfxqKouZYtOWeKZ4npvFuJZOosHY51VaifxPMDwQ0/JxvqWJR6XzzwVaLh3Fs/So6o9XMTTgkkLKqsLubK66HiWAlfb2tDw6Swe3FFRACfxpDCpS7JkG9xuSrLa1sL1XmzE8+UunklVdZXaTTwLGJVRXRsSFB1PSHc7DN5tXJawcxcPnlVXqd3E04ZRL1SXidgeWnQ88MTtbWMMHUN38dSGzo75V5RvJja7Q6dUdxkUHs9A3K5q3/hvsOLyoTqCo3hSGNahOk/CpJ7C48mcnSBM+lRShZaNw3jClsIqtat4bmFYjxqmAj64FR7P1tkK0srOqnjsu4sHb66GcFQKuE1g5JNkie58LzyegGrWzr7m2ULP2mE82DLfEa7i6cC4LTX4xZ+KKzyeHtX0Q1ebwwLoeXEZTzxgnk7NWTyvMG5OHdXCvyotPJ69s4l6M6o5QU/bZTxo+jyvuoOzeJowLhlQxyyGpp8WT5eKXnGdJ9qaXT1wGQ/2fZ7jHeAsnhYs6FFLI4SenxYPPKqZufrDxND06jQetFv8f/dtuIsngAUTj1q2CayKpcezpqIdrjK1thGo7TYeLLf8PzcTOIynCRsC6kmt1rMZToTHM6aisZvvr7fQdu82HmA/4L/NPgCH8bRgxUNdt54QtiRjciE8njkVVUMnr2k981Pn5jAt3GT8u+ljAqM+mG8MOwJqatRgx6hB8j6RHc/IyTXFtarFVb2VQjzGdRfprE/S69ycujBtXtC25oc6NXW6sGFf5a/msuPBjA7O9JysXue6Lupy8jBOYMWGuTqwJaCuYRPGTY783VR4PGOqenQwkX1rYfPCM0pnwVwn2LL0qMvvwbCPFv90kB3PB1Xdh/bPinxd1KbHPGOUzivz9GNY06O+aASDHlL+JZUdT+hZ3wz41Kcif2Rh60+K0rlhnk/YE95TX/URptRePP6N3xUdDz6pqr6zPd9mauMi9gylMzWwqOJ0imT0ZCbd2xb/aSw7ng8qy0LLF7OcbBzA91A6VebowKqUl6jfTQykM+C/eRPR8SRDKjtCX7NOVfWllXnvEo49ankocrThqMqLVHs1XCPutfg/eqLjwSttvjV0NdpML98QXI6L/U18zdMKYdcbLzR8nuBSq8A78+MmouN5ojp/Dj2jGdVVcKlFGa64VDYuduU94qW84woXWJ4ynvUoOh5E9uoZdahuZulStQ5KZs3zvBi2jYa83Pq01Cznq+Ezx1p2PE1q8G+h7umeGt5sfTMyQqnEfsFvox+8Rr2x6EJNWLnL+J2m6Hiwpo5xAkWVKnMY/TC/7Of+6KWyKXxGwZhXmh0fu8jX3Y+nfSrYyo5nTy3TLlQkLz51LKz9vSOUyrbw57dwyusNo/Ftc4T/iNvz3nHqUZX/JDoeTKnFWyT4VjujlkGIa8Qez6rHKJFJnWf1l3Bi1KIh9UHWSI9BcBcE7zdpo9PqU1cgO54mNXX2yPfw6VPPG65zJ/16WFVfEvbptfsUox+Ljgcpda3zDoCt3uvUlCW4Tlz9IettGc/ylnDlkXI8y47nwaO24fiA/zP6mlLfweoUgyZK48Dz7uBOj2K0QtHxoMdLDNNTu4a/6c6Djs8LvONqtdaPWDLY8qxhDd8StORmzkZ2PMmal2pN08/gbny8iWZ1XqgV43qPZRiA/p2Vn/dY6NQNpchkx4NdnwX6gAnTH/DWk/KsNdxKUkpRkR0PTizOEUa0/dI/9RwkPbjJqWcrPB6kLEoWwoz30h+JW4uaoyunnp3weCb3NMv9nLFllWedUAK3uXOz3EsCynAUHg92Hs1yP+plk5PoA8QbVcVt0HumCP1YeDyo+CzACQZFPKsB8ST+6998CtBvS48Ht3RvDJO6Hs/qQbgTz+o/oSiVIQtXbUr/2AZgQdfeYdaCZ/nCV9wOdZk3N3YzFmywk77a9psXupXCsGTKs4aiH3vydjKvExQovGGh1iPhX5IWs6XpM4FpXS93aKhYtUx5PdK9jcfivIeyN4b+zZdPZwJYsOF5UQihkohi9uX8j6c1C1L/kn2S9J/mfV5BwDD/m/xRgCIlqfALg8OXOoswW8m+AOTf2kO60H+EHZNBXj0i33ty22nJOAi7WtO9oCb70sP/epjSvkEbSkxfUhoJfO6pRSzBImGy8OhW60P2lIRzAyFti2LYs2COjrg1t1FWkvlCo0865Ac14cOtzvgY0qb+AlalzDGU8lL+h0OLObaQpD2lK9lB+ij5s+KU9mQ72FXrMIcvaq/Bos4cswlkmXfoQmsDlDYeYD+gHV4vgW1PVeZpiPno9hAxj7eDOPMZbas+11DqeFB7rdOC9AGm6W9y9YScUPjyvttxLlAyX9Om6ssEKHk8QPeGpk2bcOOL+TIBTz7NNX9VwkNIza1PS1rPE+AHxAO0I5rUmcOZMb8RrVCoVUqSZR2O0r1r0YL1JgR+SDzAKvVpyHoPl1J+J2qiMM0tf1PC7RB/SPbbOo2qHg8AflA8QPe1yuvVb5pwK2zwW51FjALEpw6/NRW5GeIf4rfIWD/16DEEflo8QPjW4HVmzyM4N8mU/ma3Izi1fFN6xe7I2JXznfh26/Fq/e0mBvAT4wHQfcl4qVZwQCGWMyrpBI9PcOLpMcio5L48I7mSymvm83Kd8UcNwM+NB0C31+hTW+f1gMJ0B1TlZen4+W0+r1gxn789j9PMo6pBF6VS+7hreNRWz4LNCBdZVZSskKei5sHMr+iX9u52O00gCAMwE9cPRBEQEU0E+TgBIhGxWr3/K2tPT3808bRqozIL73MNDLM7OztbelcEkL/PIqVStktSmq0UCeVpqZoduozwtjuD/7butnpFuE/ORVDHn2zWHBbtckbPjGFjwaV6r8v3/dt89rcg0mK9FXwz5FmV3p79dCxb+lgb0gci9iZdZ53z+aPIGD2ulHnnk9FzXnxP26HjbIJg4zjOMVsbls3ny2Bg8LyyLOupsKzc5pBqTtg+SSaWbL8D9RVVPjrpOuMmr2iAmYVOEvFY5m9oqh6baf+/STdkARqM0RuB8vaCQkMdWcwrP6fD9g4CNNmTRuwJlnffAFZjYs6vw/EO1NKAedngjdusD4APg2rY4jXSB+Azg22vjslgpALAvyxaxNIEJ6PAXyaIHVH9GyIAF7A9YiZBlQ0kMQpZJZ+pw3tIDsCfbJXY0JF2QC4Zk34DDbsdkE6059DsdsDVHZCRVXnhwCsUADmlLlXIzBQAaQ3eNaqI2DB8GxXgCv1AUAVEgI4CkF+/nNKDTV8iBaAOolKjBxIlSmxQH4vQpQcxHdzagXoZpQk9wDzFbByoIWsr6K7EHuc6UFeDdkJ3k7SxXoNay4OY7iAuXxWA2rNKl27KfbEUgIawNkmHbqIzD7DRgYbpZ60ZfdGslaGRAJopPx5i+k/x4Sjx624ANxAtA9Wlq7hqsET/DcAvC2PXVX1BZ0x9tbszUJEGOBEVaRhsJ/rYNIUY0k9DIUxzrE+2QZgWyDYAAAAAJ34Af6p8x9Fp+qAAAAAASUVORK5CYII="

/***/ },
/* 2223 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 2224 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 2225 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAYAAAABkCAYAAACPZeefAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAB3RJTUUH4wkMEREkafwQwwAAIABJREFUeNrtnXe4XFW5/z9rTklWCr1IEyQ06VVKINSQnD0lhRKkC6iIilcvWLgIV+/1p6KCoqJyQRBBesreM+ukQIDQpTfpJUgREEhCkpVTZq/fH2vNzJ45c2pOmXPY3+eZJzlTdll7re9b1lsgRowYMWLEiBEjRowYMWL0EtILhuS3MWLEiNFXiHgI+k0AjAOzHrAusA2wO4jNwawDbAaEwPsgVgFvAc+CeQ1YAWI5jFqu1dEmKhS0SscDGyNGjFgA1ATJJ3PQthq98Dj3d7AuxhwJHArsBuwIbN7Lw34IvAr8A3gMuFOrzPPFc6YUOuvFgx8jRoxYAAwd+WfRuZTTzrPbQfgDIA2sBzT002nyQJsVBuIqRN3VOue1xhZBjBgxYgEwlALA8xuAXYEfAMcN0mlXAb8FcS2Jxpd1dkoop86F+sbYKogRI0YsAAZS48cYtEojPX9H4L+BmUDjEFzOciALiV9olXoqfjoxYsSIBcCgaP7BeWB+BtTVwOVoEJdC/iKtpocymUPnkvFDihEjRiwA1prs0/OhvQXdPA3p+VuDuAJMLfpa7gfxDa3ST8ZPLUaMGH1FIh6CCNrWFMh/CrC4RskfYCKYJdLzv1+yVPz4+cWIESO2APqk/Xs+WmWQXnAWmD9SGy6fnjzCv2mVPil6DzFixIgRC4CeEH8kzl56/tnAb4H6YXYbd0Nillap96PhqjFixIjRFWIXUFtLgfy/A/xhGJI/wGEQzpHJ7BidS9mEtRgxYsSILYAeWAFecAaYKxk2bp9O8aBWmYPiJxojRozYAuiS9LMF8v8CmF+MAPIHOFB6/u3SyzXEUztGjBgjSgD0tGrmmJn3d32c1Hy0SiG9+WPA3AJsMIKe6UzIf096D8SRQTFixOgSNekCqkxwckSWsC8xGtgemGArbYr1wLwHLEOI10k0vEy+JQRhgDAaFVO5QSo9/17g4BH6bPfVKvNYPMVjxIgxLATA6Mk3UL/JHqy8YVdH0NmxEO4B7IetuLkP8NkeHOpF4BHgLuBpSDyhVSoPINOL0cERSM8/F/jNCH62/wR20yqzPM4YjhEjRk0LgLEnPMuqmxzxp/3x5PkekMHW1h+/Fof+GHgTuAHqf6eVp6UXbArmCWyd/pGM67XKnBJP8xgxeuB5qFJxV3rz0GpaLAAGetBl01xBon5dTPhd4LsMzKbschDngvkC8PVPwZxeASKlVfrecae/xMprd/h0L/AqORIymRUYE1kLxlDXaHQwNTJH4wS7npBlfzyPGriv3YATgA8hvE6raf+OLYABG+xC9m1uLORPAb4PbB0vr37FbNEojwtXLw/XLDw2JitAetmNIZwAbOWswPWB0diubauAD7AutFeA17TKhBA356kyrqPBbNwLrmmFRBsYrVV6dUeBMLSuSun5pwHXRt76ABKHa5V6LhYAA6X5e/5ngJuAScR5CQP1mPf6tBaOi5K/9PwjneW3O7AhMI7qiX8GWAMsA14DbtAq84fC8RAizra2Y3EUmGud4OwJ1+SBdidklwNvgHgYWKxVutgFb8zM+1k9e+Ig30t2HQjnAwdWfPRnrTJnjtRnOGRZr5b8g53APAaMGUFj2u4met4tDFOxCOqwEU31DFrugbkS+MKnipySATqXBsKE9IJdgKvB7NcLxUi612bAROn5PwHxZaibo3NeGHdoAzCjgC3W4gCHgDnFCee3QfwGIf5s1ny0zK0fRh10CS0PfHcw7qXBWYGVGDeSn+Cg5wEUYtOl5yfBPDkCyH8V8ChwM/Az4GvANBATQeyGDVl1L7E7NprpGODb2CikBc7dMJDYT3rBAZYYs58CzTSLzqWRyWADEJeDeboX5N8Z1gdzG7TfIr1ga63SyGSO0UdeFxuY/YMtwFyCCf8J5pfSC7YDSGy0L7JpziAYyeM+wkYOVmLeiPYNDDb5W5+/fwQQDGPyb3cT40bgMRDLwazUKtPWBzN6DJjx2PDWU4DTgHUG4JrnaZWZ/qkgf5VCempjaL8H+HwnX10OKBD3g/knsAIYC2ITMLsCSWDHTn77LpDSKvO4TC9AB1M+pS4gPwlUahS6E5dQwfod1cPDfwScr1Xmz1HuGFir0R+HET8CczLwMYgLtErPjgVA/06aXYFnhuFYtQJvAH+CxJ+0Sq3qb8EIIKcvrqd15RnAd4AJ9J+b7p8gDtUq/frIdfvYqBLp5baC/BNYP38UIdan/780rHednjfJdCOcdwV+5PpCVLoH/g3iCK3Sz5TcTZ96AdAGiYlapR6p/v3caIRZH2M2cxbZkcABwMaduF8A8VMwF2qVCQdS2MpkFvJ59PxplXNgRLv6BtkCyG4H4RKGX/z9PBB/ARNolWnvD42kasxxJCxOekEDmFnA2UB/7IjlgVk01t+u547MSBbZNA+EWB9YhE0ajGKVJfO632qVXGPHu3rUSeWzlZ4/GbgU2LXiq8+QSEzU2dQnn8ZQ0eoCQEzSKv1Qz4+RGwf5w7Chl7OqKzziAq3SP5VNc9HN04kxzASAreEjGiG8EdtYfbjgFRAnQ/iEVtNao+RQjGIyBi3Kh1GmslsQmgnA5sCYyD7wMhBLIfEPrZK6h4tsPIjj+qla6e9AfEurdDjyyKgYVfY7OuZ45EFM1Cr9cG+0OpmeTyEfQHr+OiCawVRWW1VaZZIF11MsAMShWqUf7L3w9hsQ7AfkgPWq0NQUrdILZSqHzsZZ7cNGAMijb0Qv/CLS848Bbhsm47IG+Jtpy39lzaIZ+c4SVqTnr2v992JfrM/4YGCnHp5jJYiFwGww9wEfapVZWc0acOeaAChgbbK5XobEzlql2kcYERWE8hfAPNyB/IXYX+fSj/XVnLeBC+sByzYEHuj4DMRxWqVv+7SRR78KgPQidDAZmc6NJZ9/hI57N59Q1/AZHTStjmm7/zCgUUAyNd+Rf7AhcPUwGZOlwAlaZc5cs2hGftSBPwcTFstHu4l/iPT8S4AFVqNnDnBWL8gfYByYmWCuB14CAun535Wevw3gfNkBY2beh2yai1aZVyGxJ3DVWtzb9mA2H2mTuOR6Mf9X8ZEBca7OpR+Tyb77cu3xl6FV5kMQ5+NCFCOn+a6tW7UWa6WLJj6D1eBHZu4YumcYTLahu0FyFYipwKsVXxlPvu3i/j7vmGmLh5/g7SKSr7dzZZBcQP71wEnDYGyfBTJaZV4vaX4lgpFecDCYgi9YDsD5Q2A1cCMkztcqtbywwVhycSgg/79g/quPRt+xWqVvH4Ha6HTgVsp9yA+COBrRslLnju3Pc+UAr8JiTDNu6zv0LXuUuZBY9g763jO6clmV7zeksuMJQxcFllipVWp5NZdUbwmjzJqc9gq0/WNTEPVgQkh8rFVqTZREepKR258WQMkVNA/dPA3pBTPBVM7TFyBxBGHLu3r+MR0swM7J0nS5SS8BurAOuypZ0TjxUuo32ovV8w7v5Ryqfr6uXIlVMtrXcRGEIFitc+mPuzv+4LuAvGAXMPdi0+1rGY/CmIO1OqrFEr+IZpBuB/ycwd2/WAbiGyDmaJVaLZvmgkgAdWiVXJtqpr/TKvPNaPG94YyxX3ye8JM36gjbrsGG0UZxglaZm/tT87KWWXZnCCvLA/wG+DaJBqOzTZVr4KsuacoJeXGPVuln7GeLEqC3BXEimBOAz1GKiGnF5ojcDOJawj1f1vO36nEAQll0mRdsAuYI4GRs5E00QmolNjrqVuAWbPmLdjnldvSCYwZVAFQcfwlwSMXbU7TKLKzy3c8B07Eh2oBoRYi/6lxqtft8UxDHgzkVW25GAO+D+DZb7LtQ/99mSC/4PHAUmAIvtlM36k86mJKXXiCAJJgJlDb1dOPW6f9b/gfR1/s7BluOJLTeGPGMVuk7y62yRdD6CXr+TKQXSDC7gzgBTAbYEmgsjT3vAYuBvwCPapVZMbQuIM9PgDlpGJC/IlF3hCX/LFplouR/HnA/g795vZ51D4W3Ss/fyUY/CDCtrqFN5nLgJz081se4ujYg1gdGBPkDtL12G4TtG9Mx03lpf5J/wS1nLcLUP9yciOpSKRIN9ZXk71xElzkB8Rvgt8DhdnEvqAP9M+AxMD/C+r2j4ZCN2FDgC8A8SuKJH0pvXn3PyD+IkL9/Ppj7rWVJko7hseOw5TH+x14LV0gvu5FecAwypYbQxSHOrfJxJ3GgYk8QlwKX25f5NSZc143FYcASMJcD+2LDTjcCdgazPR8vLTyng9zvC8/q9zZ4xXkTMTsDv458fmXr0mDXvrheZCq7LnZPtDA3LgOzZeUzLJG/fzCYucADYP4D2DZC/gANTiCcCtwJNEvPP7x4nMEWAO6k0mkcte72OUVnk5/IZCGJyEd6uUbp+bc4zX+TIbw+D7hfev4hWqVB1BF+8FjBNXUhtudBJXLAmQjxeTDrOY1nT7fIvzySXD+tD/8QMFu7BRElhN92N/n7Rk7FhX5TxUcTCNu36Ux2RP6fd9oatLc8AJxPzxL/1gF+DOIHcursbjO6rXspO156/mJshvp2PbzFcXaOmLtlSo3RWW/QhUBJ0KaftG6fsud6FMCYWU9X/ixfZcxbpRfsCWYRnQdP5CPBde2UJ7GtgYRxa82AmI8tFBjFufaaexaZVBzL0Jxe8dGrwF3RvUat0gXN/1tOsz+6F5x9EIg7pRfMcGV3qn5pwGoBuZPuB2arGuaPjyAxQ6vUR9Lzoa7g1hfrQv5K4Lgauc4NgCXS86drlZlniUihcx5Ql4b8s9b8E1dolb6uJyQ2shrEiF1cLZcobinMw/4lp+K4PejUQlHUEIU4EHi5JxcsveBmV5YcbI7Ca+63HzsrYHtHWhUhkfyYRIPSudRj1fzFRTdVMjcGk7+uYG1UuHtexTZN+gSbjT/BvSKWgdmFsP0+mVzwBZ2d0j7YpZsjSV8LKAuuMLuOmfVUYvXNu3cXymwQiQ0w4e0Rnltj1zxtbow3ARKE7T3ltKel57/gLIjCozxGpnLn6mxyTY+OUawma86u+OhBrTJvlhTouWg1Hen5Z7h9x0TZvdmk1JeAt90c3Mo9w61L3zUCmC294Eit0osHzQIoSRtzXg2zRh6YqVXqlYK5rP0jkU3BGDA+cHwNXvPtzvcPJu/M/OQq4DDg0AL5d6sdjhDyH3dWYX+0Q52ff0L+rf7W/ktaXA7gQ+Bf5ZRjDgAYM+Pe7rjpROfDLQiSmVB3oFaZY7TKnKVV5mQS6x3oNL5FVX5/pXNFdao9Y/J/wvrEo2i2LqC6/bXKzHLnOhFk4VyVm657YVouKzvuYFkBxYxf8UQlZ5mVb07o0UGMORnbUAps6ZaZwKGQOBibhXwSiOdoW9kLThMV0YxmHGHY1Dt+9A9yAj6K35WEeFAg/4nAHyt4+n1roSUmapWZqlXmTK0yZ2iVmQziYOA/ixZm6Rr/JL3s5oMmAFy0SqObVLWKHwFL5AmPu4Y085De/AaE+Su2NHUtog64THpBxmq2prDRt1SrTEsxaqmQTZxUvZjYww8rr1q38N+dKz56GurEQKXwu0Sk1cC/O7iBgNVzDunuGR7kNND7SDQcplVmoRPkyPRCd45JoVaZRyxJ8WjFMfZ25FAmbCKFFs+io+v1OhDHaJVZolWyxQqy+cijb0aryaFWmce1yhzrNO4ojnflW4YK71Lc2C3qvz3xKowFc6zjuKsYs8kMrTLNWmVe0Sr1llaZ56D+RhBLespp7t+/VBBsI5gmOe2u3uwEH1/Bvc9plXm4JMTTyOnN9VhXbtSyfQPEJFTmaq1S74IN3S2sYa3S72iV+TWISsG/HYTHu43swXEBQfukiouvJTwLXG79eiCnznahZ/63qf1M5QSYedILDtQq/ZBs8oulj4ubfsmgDmM2xrRvKD1/fRDbgNnQLoqCr1O8B2YpmI+kF3wI9e9r1dRWEArDrP7J5h0tAGMG2O3UAqYyymKjnv4YeIVxEw7Vt+wSRt0rOji6gngyH0jP/w1wTcV6nQbcHxU2LhluAzD/WXG+Rxi9zpl69mHt5YJsake3YH39NNrb3wMK0nUTYLL0gueE3Misvv3AwX62nzjCjdy76UlQySinGCzRKvPlqHusNF5ewZ3SM839qOvRd5wMduM2WqP6UNpWbSin3PJvveD4LlyvWTBsAOaQSKQRwAVge6KvWeSi5VvbfxJ5BgAaEmdplXpRphQ4V5L2j+qg0GmVVtLzL8NWHC7gFOAKbGTZwAkAmWrGRUIcXsOEcY5WmeVy6mxI1BcqlB6N3fAdJjDzpJc9TKvU8xENcGfgWOeK2BobFbBO9TlefG81mLeg7XXp+Q+CuF6r9KvDzBio7Bm9YuAjnE071qccRU+r24Ygzrbk34P9GDHqZkzLrynz0Ys9OlpzOSA8rMK9EELiZD37sC79+DqXtIqE77VIz/8Z8NPIuTxE3eWrbz8wP+hPVtCCEW1gZLl23yOsAXF2mYBbK3Jzrn+R+AMmPJ/SJNsBwp31guO7tCZccud2YPaOvL2UOtkMFMlfetnNIJxR8fOrtUrdaQW3162l4sj+rMja2BtbcfiVAXUBRcLgdq5NrhDXaZW5166rdQvkPx4bIjecsAmEv5BN/iiXmfy4dX3w30CTG/+eRJeMsROYKcDFYF6Rnn+P9IJ9yjSXGoU87mlRhXhX90Kx66shlqeDr7XHUudR4PEC8Xa7pnJT2oCKAmtmY5lSFfcdCjAzKKsZJa7VKvVS1DXY+XkK5CEq/IJmXxKJsUPygA2myrPs6cOdD7wuvaBf9r2K+xImfBtERdq0OKsgaLrBqRV/X0O+pb2kQOeAcC/Ko9paQVwEruBhd2vCugLfAyr3T46o4k4YgEWZXlBPbVb8XIPgIoCxs57BtGvkFw3Y+OcNGH5IIngGWALs5Rb+2qi+hd9OAvOo9PzbpOcfwMfJ6MSqKehbdzd0DAEcN/AWQFhHeRx2wV3REzyFYHkvT1hZYVMS5stJOSEa6LDvZm7qA+suB96JvLEeYfuGQ6SwSTq4ksWyHokOuF+r9Jp+d2fW17eBmVMuiMzJMhmM6krQSG9+Aky0veRyYL5WqdJxwrx1KZUL8axWNstXN0/rfk2oDIixK4G3Kj46uMOtDMgzy7eNrVFC/StGvCWTAatu3q3gM9sOOJHhi+0H8NjHAFNYL7hWetnztUqtqdH9gU8oD5ccPwjEVA+msoZ9T4gpBN7QuV5XZH2livJWXh02NNtRnrPyHog3pOc39lrvtuGopb0VYz4HDEEviXBcFUH7Xg/dP88OiNLhe0jPvwsbBLBxUXkyfAn4YylEu6SR2/25tlMpT/R7DpF4sqT9N0PYKkBUJDWaRdLzG3ql3Jk1eWzIa/TNCYNiATjBUl9jJLEKuFWrVL68Loj5JmVxvTE6atN8A8InpBdsUqObw5XJOVuDEWOm3zOQ5xxNx7LFrwGMO+PDbshVLO/D+T7phKijqEx22gjM37Hhqr15PUPHwoYbDdGz3bxCGwYhXujB79rAvDlglqfKvAA8WfE4zgTKyL+okdvPv1NxmFt1LtUiky6KJ9sEol6AqOxEd4kTer14hvkPsHsAlFlygyQAahGvwqjFUAqdk8ncBtgevjG6x05gXpBesL/VaoZ+X0CmCxGLolI73hUSmNaPBua8dk9kLB0zxB8HWPnnbr0lfenH0BPtb+uKv+vcol+/D6/K3hPjB/XZliqT7lvx0ds6l1rRg32pvHOxDMDzL/j5xTUVH+0ovWC36u4ff+8Ka30ViD9bgRFRqkRiLJh1q4x9X55hpYU65tMsAK7Takpeej75f7s6Xib8HrUbqlqLWB9MTnrZnbVKDfnmcKQ94N8rPtoSYbbQasbAnNdupm5RRSt+aGgfj2kYuL2Pwe0eGwlvrNzTuDPyDHoiBAbg+SedZp++sULIjAWO6uRnGcr6IYurtUqvkAddUqkbjBpA70ljNVfNgMxEBj4Mo3dIJK6KmmPSW9AILV+POb3X2BDCh2Uqt5XOJpfVyDU93nEGmuOBX8nUAnS2//rIlvZATGWY879J1L80xONQueZWAc/1AxGOBfPeYN1EpFT2XnTc46qJzEWZmu/yKMRvwFxUUqjNEdLz/6hVRkfuZ7ybLxEpKmyG9QPfrXyCYZXn+Cw9DzDolAFBvN9vAqBjrfy7BHzyWeCzEG5dTdoMIRbrbKm2vkXL9Bq7xuGEcYThYunlJmmVXFkD1/MK8Kade8UF9k3gV/1J/k7rKxz/lPJ1Ku4ir9eUiGFIsKqCO16FxGFapXR/HHywAgAiY3xZxf28BeKx8nU8RNZn8RmbPwMXRrwph4DYBNtYqoDPUV6tthnyb3ZS+19jk7Wi1sI5WqXv7ZdnOHW2oGGsKVjPfXIB2VoVmUIM/ebS8y+GTxYD92DbFl6LTUKqEYi/WNOtWOJZAFNj989aKZt7Qf486eVEYRNrSDQx6yt+D1vGOHp9W0svOKG/NVP373QwFdU1zTwSo8wQkj8g3qh4YxMwm/bXfs1gBgDYWvmmsqbG3VqlXx9q8i9XgsW7lJfPWBeYbK2E4rjPoOSPN8BNJMaH1Ru/iDUgKjevduw3wTV/pom4TnsuAGQyh5zsyqsbkZDJYAtXLvltbPLRYdhNqHGsffPy/iarRYVF4CyXDYF9YhJfa1wA+S0LHcuGRBPzj0KrdCuI2R1dHeZb0suOs4tx7UsauxpX9WB+UfHRUhAPDHmRPSEqK5FuBGbj4dKsvlTLKNgMW6sryk95SPy4lq7X9Q1pBfxyt405x1oJxXE/q9yK4R6dPaITqsoDPF/x7p52XPp/z61HAkA2zUXnkuhFs1yHr/BKjHmL2imX3BWeBHRhETiX1UbYto4x1g4N1gdKDeQGNNyILakcxf4QfgmA9hbGHPfoWpBTYfG1X4Ar+hZBoFX69SF/GqJuKeUJXPUgjiwocDVN/slcwaMwBszvgV0qvvI/WqVelkffWouXvxBbHbaAvaSX3cEJs6PKG72I+7XKLO1KWwVTac1Os2us/wV5jwSA7UYF0vN/4DoLnTkMSP8iSwCkgIqiXWJ/Pl0RUANpXc2Qnr8nwOijrh8izTFAq6l5EF+ppETgUukFk/X8GZiVb63F8VNILzgS+AHlITEaww+iLqIhGYNUM4RteTqUjzbfkF9rFzqXRB59U9+Pn14wgOSftbWIvHmbAHc4l0kU86Hu/wEwap2aWwFaZV6jQySa+Zb7t2KX19ZY6jSCTtQBPEB5BdQtpecfb3/X9zkWCa3tmQAo+Tyz46Tn3wT8P8or1NUKWq32Jy4GsaVWmb20yvyPVpm/A29rlQk7aoYx+hHfB1hzx8lDtADThQ3Ku0FcWfFxPZiF0gtSdpsK5NR53Yawjp31NKMdYbrjHwXmDjrGVs/QzZmVsmnukFpBOtsEiUYDzKE8z2ALljb/DEAv7NmWiJxyu1v3s5FeMFpmFkZDbtcKY2YsQU6ZXcGV4SgrXMUTQGW50deAb2iVbAP67Tr6C+O+VFDmxa8rbiolk7nNKN/8fUSr9NP1253QRVE+D0g8iW3aE8XlMhmsZ92t3ZdkiX5HetlGmczWVVYO7VIA2PTlNNaHGt4IzKpB4lkD3AycAI07aZX+sVbpt2XTXKsREYlSSs2P/q5W6/0PV0yUXvCZodXC0sgmHzA/oMOGMICZwzpH/Ux62S31/GmFyoydau2rbt6dNQtPQHr+VtLzf+7aClbiZ1plFkjPL1rJQzoGdgN6CR18yOZ86QVfq1TsqmniAHrBMUhPSaj/KvAr7feqrUeX7bVWz5mEXjATmXwe6QU72I5XBE64Vpb1fgnELK0yNVudduU1Wxfm3yJsJFpRh8DkT6Ms0lBcDNC4+7ndzOXUO0CFlGRTjLlBev56WmWQR8/pVImp6Ad9EIS/x1TvzFjfhVmD9PzREN6L24SoMeRA/CeY17TKtFVzWVVZHMjkg3WYD3aKObtfsSGYPa2pPoRIJNC51EcymZuOyT9BeaJWPfA9CE+Snj8bxK+78ttLL7sLhN/EJvBUK2x4I9bNSE+atA+iO+Jj6QX/5RqIR1xh5je2iUzd17VKLq+ufaYKBHIStH8X2LXiON1BAHtJzx9VRblMYOuDTQB2x7y8myP89TvhoTvAnKpVxjY+aZpbE0K2KkY7VRRxCZhCZy+JrbBbiDR8BZG4D2D17IO6cYeloHHzC2l957QKoegBD0kv+KYTOF1YxNnPQ/gjdw0rgP/tsQCwjQtMPZirapD83wHxZa3Syk7WuR3ik6UX1IEZiy2HfAS2/dshwOcwH8R03f+QwO4yNX+Bzk4dsgRA1wsXnUu+JVNqG8L2h+m4mbglcC6Yc6Xnvw/iYedm+ATMptjm6XtD2IWrU1ytVfqskqVcOwJAejm0Ss6Tnv8rbHvAAhqAkyB/kovem4dIvIAxnyBYD8P2wGQwsypq7/cG9WD+tLZKNXClVpn/BJBH34he+MXaJf+CHwJAJOZhwp+CGY8tuzCpJAjFbRizasysp1l98+5dz+FUM3ruvqFMBgdizAtufRWwo3Vp+s8B1yDEIxjes8/XbGn3N83xEEbL8S/r4oFVkn/gzGN/mp0wNYW/QuICrVJvyVMNfDAHRF0kvj87HsxkMEcBE4HdY24eLIjPE7bVdecCGHghkLRaVNZbJb3sQU4L+jrVcz42AdMbx/1S4GLXFrB/moz0N0JdEErnuQqS1fwNxwPHY9xWQZciWwxWtveHwO0g/qRV+nG3nhk2IaypZgjbP3CurBkRqwenXCitelYBVmebCl3+3pReMA3MjZQ1AwKn2PyyY+O7qg8ztB3sqhjNHRdQGpnOjQL+r5amNXAOJM7UKvWWbJoLHzUDdYXrrZee/30InwVzA7bAW0z+gwqzPTVSAdYpMGiVWgHmPNc9a85aaqUXgthbq4wl//T83pB/ouL//VFYp+ox9PxjSx+JxLeB0+jYuawnaAXxA5dRPVBoB+4HzgCxMyTO0So5DpeiAAAb4UlEQVT9uG1zutbk39cxTnTFj12RtlbpFhCKjsX+XqZOPtS7OVzsQbwIu5H8YB/vZxGIqTD+Xz12AZHP/8L55moBLcC3tMr8qbizLRLorIf0sqOlF8wkn7+8ioSMMbjYhBpKACy5ZRJ5rdLPAzOll90ezNechfgZrPe2IXLdheYyLdim7y+AuA3MX7TKrJZH31jU+nXQq4zfB7EVHY0jhz7U1RErwDyKLRUA8DYk2qvfe9rG/Zv2UKtp10lv7lxIfA84FrsvMtqt/UTknlvdfS8F5kLiCq1SH8umeciU6qQNoVgB5j56VvcrdGP6PoiXgAdJiMd1NrW8pEXbZD3d3CeX2nJsMb62ktbda2v0QzBLIsKjvWPTt26xEJsZPK7EseIqHUxu64vF6Ky514CDpBfMdOGln3duoYaIkArd/bY4l899wBWFZvOdbfyLjifMbg3h0/SsneCAr2PgdK0yt5Sur1goalfgV3SoFhhjiPAvRP3OOud9XHPmeUUvXNuZqfWzwFaOEAvZ6y2WSMS7wFKt0mtVT1o2zUE3z+hkYfe8ro70mtGqqfpnU+ahF0zr4rfz0GpagUwasGUFtnIKXqMjzE+AD0As1Sr9To+uacpc9ILpA/J8ev37qfPQ86d1RaA9uJ856AWdPKtpd6LnHdmD5x2gm9OdfOb3VbB1cDVKL9jCWdyFuVsQrh+DeBsSr2uVbOnJsatYAOaYiPQacrdPgfwLUQAuJvtYMNfUyHXGsFiHjjHytWENVJCLVlND4A336okG1rcT149FTr4BvWhtt9K60ELr67uxhKYVhY2LlnvWvdaOkOv77u2rJLS1IX8A6vrB8OzqftpW9d551OGzxFrM32RRg7fPMf22tQDXXrAWLYAxM+7FtCwbDeY2oBZ2tv6qVeZUgNFHXYcYtUHBtzsT+Btl1fJi1IS1Juo/p3Pee/FQxIgxPFAUS6vnHALWj14LYZ9vAOcUTOUI+U8F/hqTf03CYNpT0vN3qtSgY8SIUZsQ5Ys12AvM4zVwWQdolX44mvwhPX9b4Clit08tow27EfUmNlHq91pl/h0PS4wYw0MAnOMq8Q0lboP88VBvtEoz+uibEA3rNmLasrg62zGGDdqBPwKXa5V5OR6OGDFqCxU7E2bfIb4eDVyl1QxTiJBYs/AEMO2Tsdm8MYYX6oFvAA9Kz/+J9ObWA8ikikcmRozaEwDic0N8PW9gu4o5i6TgPzbfIS7fPJyxIXAB1N0jU/NH65xX8/XpY8T4NFoAWw/t5Yh5WmXWRPsNS8/fAVvPJ8awhzmIsPVJ6QVb6FxywGrMR5Ne5PQ7E9IL1pWev4H0suPlzFtF/BxqC5VJSt2V6o4xYAJgqLNpzVUl4i9OgovjxzSisCOYedILNqFd9/vBbQmBYu/nGbSuuhnMQmAhhHeyZvQF8SOoJfIvlJ0PNpZeYAuYvTA3FgJDJACGspbLsmjd70gdkGnxYxpx2Ae4TDdP7/c+p6WSxv6t2Jrqx2JrqewD7AfmwOGqGfeUUIfT/TkrPwnmX2Cek54/W7961donh8XoESoJvxVbxnQoMA9g7Kmvsuq6CYXJvCc1ml0aY62tvROll81qlbqxv0oqSy8AQQLDFWCOdW+H2AYpy4H1sOUehgVcyZPLgC+6tdkZPsJm9y4E7gbelEkF+dWuOFzt3p/DtSVlVMyQyWCizqXvj9fIoFsA4o2huxTxEFAkf/feDsSbvyMY4R+l52/cX/X0tUqDMXuCOd291QLi2yCOoL7uMEhMAoabC2gDYFNs/Z7OXntgS7f/BbhXev4ZOudBYvRw2e9YHVEMwFT28I4xSAKAoYvVFuKZKlritvEjGtEYj63V35+YTjFTXNwL+T8gxPvaT7ZplfpQq8yLw81Uivw/jy3t3BJ5tVd857PA1bZrVMrU8o3JzJ2Ftd+ErRLaAuL7WqWfiZfG0AiAB4bwWpZWeW9D+qd2eozahACmSM9fd/TkG/vrmAdHuPM+raa3jSB/chbYAttW0b3EziCOxWZeR8ofm8udC7Vmof0jC41P/qFVZlMSdeO1Sv9cNs1lzLS74tUxCKjcA7hn6PQcU01bWSd+RCMeu4HYQoxad3k/yZQNSwqx+OcIGyutVaZaieqXgdnS8+dj3UCF+z8d+I+avqFculi1Ume9NqC22z+OcAvgXeDVGjV/Y4xMjAWzd/WGI322KgrTJ98rl0QXyWl9icgpP3bQz/dW7frMX4G/R+5/e+llBz2IorchnGvVC6CTc/U1jLRWw0/Xdv51KwDGHPMgkPgAuLeWFISYHz8NEPv1aVFUTySr9Jl3u5Bk01xHRJ1XQS/mFjTN6RN5FFr8lV9L/4Vs2utLADwWGddGyCfWhlxkaj5y8t96dO3FBM5uCD06TlWfx9TZjDnmoa6/4wXIpnmdnqsYDtxDQi8I6K6uXWJbgXb6+ZRbkTO779wo9ws6KATdZcaXclv6V0AVXUCrbz8QIC+9YA6YkxnsnABRNdrnQ7eg432AEQ2zS59IL5iCPPEpwbI3DwbawLSAiYYxbyc9fx9s6zwBYpVW6acriSWyuHaH0MM23N4wMgefBHG7Vuk3dPOMTrt56VwKmQy2wrAVNvz0Q+rrX9Z+E7IpGIMwJwM7uc9u0yrz0ICspNK4LidR11ZBnAlgZzDj7XWI17RKf9DpGGenFn63D5gGEHVgntMqs6z8uPOKobw2e18cD2Z37EZ/K/AiiAVape+04+Raa9oksM8A27q1vkKr9HOV5Ce9YAI2GgrgPa3Sr0buKQkmCWzjjvE6oLTKKFtGvtQVrTPLryD8pecfhM092hHbMW0FiMfA3KxV5k26aAWqFxxXmEfrQXgyNv9kI6eIvAksgYbZWjW1yaZ5ZUI2Ms77uaZcO2KDGVYBz4HwtUo/vpZ9kjsXAJHB9qUXPA9mt8FkfxBV8g/E27EX6FNhAfS9BtWydxtcH9dquJiyTHLzMrBDibDSSC8npBdMBPM7CPfo5Dgng/ml9PwsiHMJ218vaLwdQliN+SZwvruv2dpvOsYt6vnYkM7CPTdge9iuvXsg1YzONoFAYNgrYgk9rbOpinZiZjRwtSMnQJwBXNOD09wBrOf0sQwQFK2ntlbXecwfD1wKnFV93Zrzpec/qVVmr3Jry5wK/NxdzwPAxCq//Qkwy/3xN+Ak6QV7ALM7iRb8uvT8+4HjtMq8KzN3of3DO1gRWqUhNEgv2NV1GaxSENPMAi6Rnn8lJL6rVWp59NkX9jCkFzQC50D4S6r3xz4H2t6Snn+wVpmlhfHT2alIz98auMr1q67EsWAulp5/mVaZ7wyIC6jCT3nuIGuAYKimBb5BLAE+DRaA7PNPe9cNUJQW/jSkN6cO8j8Hcy82lr6A5cBb2Obt0QSsFJhHSNRZ9T8MGXNch/YZUcJdLT3/EDAPl5N/dfdUn90/2abCMvKA/QvnhsQ1nQxBa+law542Tl8T+X/pN3UN6DuOR3rZzwB3WvIvs+DfAqJ9osdXOXZLyXAxnSS8icj5xWrp+ZPAPODIPw+8A/yrgi8mAndKL9hQ+4d3cCUVrTgRng3m0Qry/8Bde7Qf5FcgbJaev4lWGWQyy5iZD0TcRuYKMJdFZuVK4J/AvytmbGNRgWiejvT83bBN3KPk/747fyQnQsj+XnmJan5KrdJ3A1cOLglY7WvcqW9GH/qL/blQYoxA1I1pB74FnA18ifJeqX92hHQ28DUQF5Rzb93VJW0dgKdAzHTa8YGOTA8otyLYELhVetkj9fzpmBVdpc6YccAljnUfAnEKiCbgh46w+qApdWIFeNkTwFwfWTsnaZUa8CgonS1o8uEVwH4l4cPxkXH8giO3WzoRAD1x8Ua/s6mzYsaAuNKd9wD7EhOBhyPf/TyYy8sIv2zc/HOA31LqMviou9b93bXvB+L7kZ8ciKtaoHMpwk9eLxzn+8CZkcu9GMQ+kfvf382FoufFlcFoAHxgS/fZ29i+J/tHfpsBscTNp4F1AZV8o+ZiNxCDlYw1CWDldZ+NSOjUO9ILloPZKGa6GB3maXoReu6kELg8Mne/A2YL9+fdWmX+Ws3sl55/BnBa5KMbtcqcWOU0S4EnpJf7K+Qft24QRkH4O5kM9te5dBdZq+JAMBuAuFqrdFQznl/mgug5NnCx/dIJgwYQuwKnQ/iFktYpztYqPa8Px+/bc/D8XYCDSkJKTNEqfZ91cfjo5gzAK1Ybz02Q6eZ6HTS19/2MJo3dRzlNq/R1VZ7XAdLzHwP2du9NlV6wjVbpNyqu+3PAf5V4UFyvVfqUKid8XnrBAxFX437SC07VKn3dmkUnIb2gAcxXI8/9e1qlL6k4xuvA32Uy+xOMidqtxwCFKsytkNhDq9SHFb99EQikF2wlZywWes4R/eYVqRohYDvPZ/7FoMYQi0mVfk33sOOmsiMfq/qkfQaTez2/HfmvDyKq+c8pkH9ldIv0AqSXRavk6057L0Sm7YAhKY/rKmjObAosKZC/TOaQmTvWZpyOBp7AJmw+CCxxbocC+T8JzNAqfYNdUoMVO5HYzAlGgBfAvFSIvnHkj0xmkVOzaJV8VQdN7TK1tk2BxB+1yly3znmG+gnHlJ5XMZpGzIp8eWzEOolEBomvAJtHrL+vl39epjTcC/wq4saZIb2gYDVsTamGWju2CGFHQZkM0LnUCq3SH0fcUdFkvbu0Sn1Y6aoafegfCnP3n/1J/p0KgNJiyQQgvjg4k8gkrL+0wq8Jf4j5caRDDHIJEnEgmMLG83JcfaBqm7pWGUohj74FRN2juM1Pt3aSrFrW1S5EG/D/rEKjbNSLf1TZsfsZE4A/Sy+4Sqabx9qNycHQn8o4aSwkGgjLXfk6l0LPT0VcR2uT9yHWYDebWfFLQfurt0fOkyx4MN6lVNmgEcTW0WuR6eZRYM6OHPOnWqVWyH2v7hAKWnpOIkuxbpHZjeK+jhERF1U9QowFG85aPgbpaseMfmXjane75p6vDZzo7tq0C9AqfROIcxkUX3y5sHEL8lH65i+NMXzw5KC5jbxAgNmfks/3fuc26LIiqV54PDrntQOLKG6Cmkl0vQ39KojnZTKgnxLd3gZuA+a61xx3Pc9iN1rHAluBOZN829vS8/e2fuZgoIf1Q+t6AuCzYE5ANDR21Mr7TeC8Eg0DrWblubpCL5ZYNtxApheU2DbffmjEalmjVfpmAP3omV2deCm28irAZ0q/T/yLaEE7Y/5HenNH6/kz3ZzLdnkvkT/2ll6QgRZRGruBbZ9a37UFkC4Igd9Kz28BrqC3cRe9e7CTpZcdr1Xqk4oF+VvgpzFPjlSYxwfxXAlg14jS8bxW6V4kHIqnwLS7tbMVoq6Rzks1v4VIfNxVglkvcbdWmZM7CrW7BayYAGSA84DNgHWBW6UXHKZVemA3g0Xdc5j2fwDOgje/BCZKz79Sq8z8Yoy9C5fsBzxbtKo6E6x1dXny7dHoo9GEbUKmFxodHA12o7VwA0ul559It6XwzTq4CB7sPsz6lqdSn0jP94FvWnPIpCFxv/SCy6D+dq2adEEQVInjn+1cS67sjZkHjVdKL7hKq/QjOucN6KPrNkuwYKpolbkSIfaJSMCBwGfBHFRlhvnYkLwYIw/LgX8MovtHgNjK/RFiQ+168XPedb9z6zW/QRdf/sgmpw2swqbVYUarzCtaZS4FTqAUdrktmDMBxky7c8BGVOe8VhCnUZ65PwOYIz3/aen5M4uul36xBsTqnrmRhCl7ciKBI3/AbBch9h2wNZT+2M3rkoibJlGWdJgY/R1bfbbo09kbzJ+h7UXp+d+X3mMJrTrev63tJI6uuPCvgLlTev790sseACD3/C4ys2jwBUDJFAnQufRTiMatAUV5XHB/oRHMSdLLJgq+yzEzH0Cr9D+A5pgrRySe6zUJr50FAJixkT9W9PLnK8uJxazbxbdDxm46qIOpVWYJsDjy1qkAq+cdOZBuNbRKv46o28olcrUVtW7YDbhdev4S6QU7lKyBtXJt9Mfu9jqVk6KHrzzWBVhUAmwm79HtJBJHOEFScIc1WJccP4W3X5deMIl8IRfFj47dw5DYD3iBkqt9PHAQhA9Kz7+WLQ7ZWPuT+/3Z9VgA6Fyacae/i85NXalVJuk0jfkDMJ9OgnB7FyPL6tkFgyBxIYhPYr4cWb4fEPO1ygxiAxABiOh+Vu+Sa4QYU7bpKUTXFrEJB+3OSr5+ES2StLVMZtcfWKFTqOiZ/BDBJGwHs7lllhIcAuZh6fknAJBfOdRzL6rA3uuu+bRevE4F8Zy1RKa6bOxku1aZ00EksXlUyyu8G/eQyF8kvduK7u3i2KnUo9jY/3OAysz20zDmQen5+/b3IPSq3s/Kazcrxi5rlZknvaAZzK7O9zWr14upc6F0FXBIdFNOq9Tb0gtOpBSFEWP4o72QpDOIMsdg3Ym7ubm2WS9/vinRfTBR93GtDGYkqui9svVkzKhyZbeMmEUv1mUXCmIKefiV6Fw67zT+LLbu0eW4HB/spulvpec/o1XmuSEermh2botWmdv7JnStX19nmyLcmF4iveB+4MdgLrIunSIugMbHozymcylk0xycInSl9PzrQBxkQ3zZ0X1tAnCp9II0DWOX63lHDK4FUGWSAaZVq8zjWmW+BA3rAx5wGTYy4XngJWw5h96+JkjPT1UxM7Mgfhnz5ojBhVpllg9uI3NhKO05CDC7SC9o6EWkzG4RxekFwva2MTPvq4nBLI1j1L8t2kBEfPMipJR3UY/dLO7OstiwJ8qdvivCc7l0i1aZp7TKHIrNJyoInY2AGujQIyJVU4vlM/ogdFOdcCN5rdJva5X5KogjIwKnEThOen5ZMI1unhGx4sQardKLtcrsBPyeksl5CDChv8i/TwKg/OajGnpTi1aZZq0y39EqczSIXaBtZxB7YTPy9urFa2dI3FNV8Jj2HwLXRdWZGMMSd2uVuaRyHg38uk+E2Jr5BUKaCGbzbkkw1Yz0cnVgjowIgIUg8qtnH1wjFkAG6c0VThErLJEXtUotj7is8tiwzYL2P0F6qhseMAdWVFnt/lqEiCRUmcudS6iACTIZ1A/xcC2MGD/rSs8/styNVh1RYT9mxpJuFWWnuC52JSscX4ldQHSRhJsubRYLLqKsR4uZMGQuoF5aCoUNk2V91mia5kHjOLTbwJpgDK8KsQY4TXp+CJwe8+iwxHuQ+Ab0a2hgz+ZlLon0/AewMfVbARuDuFir9BkyNZ/wg0dpefjCDpq1zjYhk8EEDMe6t1cDgVbpcKgHU065DdbZBn3rvkBiFnBoROJdYwWYKzlsRLuzsguYDO1jpRd8UpmYZsmwoQFaT6cH4d+yaTa6eWaZW8iqmfUJwrC8sq8ZWt1Nq/QL0guepRQSfJH0mu/RqvMSFTIZUBD2SWNYuOs3ykI7q5WdjozpW07pKI6jPOJa9OLTiwpGJPm11JvCiOXAykiXu0R/jkOilllCN08rkj/Aqy61XXq+sG4nLqC3URwxhhorgLO1Sj1XXklxUDXl14EbImz0JekF/02+ZXQl+Zc062AbjJlLKVZ8CWy4eIhcPYnIq566UeNZ9fbnbB0kbowodi+DuVFmmov15rVKGhCPUNoE3Rn4CqLKc2iQCWg9FZjZmbW93n8ZpBfsIz1/MqKxseoFh6F0vQEKeJ0NJrTXwFz8SeT/k6DtIlfSuhNDKGyQnr+L9ILs4mSwbdtzv7dZ4l52J+n500FUbWEr0znhvCCO/M0LQKgXn470glOkF+xK2CkXb1teC830a8fG+uHIIFpljPv3p9Lz7wK+j23iEKO28QZwplaZxUAkwmtQydO5nEZdCC27AAXf4sUIcaj0/Bsh8SC2tHADhDsATa5m/WcKughwllYTQzl1Hnr+oE29g6Tn31yxbhvArA9ie1d7qIAW4KtaZd4tdDyLuIHuxJillDYYf4kJdpdecB2I5xCACXenbfXJwCnAYyC2tecpx7KfiEIt+xshXGATosSDIN4H02ib/ZgvR6ySVSACff0uQzoR5dTbQYh5GDMfKHR5+SEwSXr+LSDuA/MvREJgwi2wVTmPthYTdeXlqc0YrFv6aZcQdjckllozx2xLPj8LOMl9OQ/cDvlCJNph1kXWFkjPz0HicWyu1XgI9wXzH5QqhT6CEC+PPvRq1txz5qdXAEQXslaZh6QXHAtmP2y28KExz9Yk5oA4GxLvlxPxoCsPzi87JS+94HgwNwLTS4uRSRDmnbkunJVcR8lh/AKII7VKvwMg5AaDeflbuVd3eBVEk1bpl60lPb3CDZZaJb3gNDDRhjSngjkRTN7p+nWOH1aC+A/g1i7Ol7eCiDSQtL2YTXT8IjwjvqNV+tmhnoyJDfdg1Q3baellZ0H4GFDYOD8UG7Jq54AN4y3MAaelGw2JqOsvxOY+TMSWcA4hDJ3VVFcxf67XKhMpEmRasNFRpwAnut8Vxq4u4jJqBc7TufRy2773U+AC6m4hR/xs7VplHtQqcxhCbO9Mu/uxJViXEWMosMZp/HNBHKJVZqZW6fe1SnZ4fv2MVrcYWygPd4zOl8K/a2DDY0D8t9Pq825NNGBrBTVGyOufwJWQ2F+r9DuFDc7Vcw6pPHy7O44G2vohD6CQdKSrvNZg9yKWu+t7BDgPMfrzWqVf7mxDs5R8JI7ARuuZiEI4yr3qsFF8J7nSzi2UGrdU3JR4H1uyuL2T8WsH/gFimlbpK6tcVz5yr52V1Whz5w2JNqTpfuxaI3OiiFU3bOfGIbXCWUJXAO9GeLEhMhYN7r33sEmwB2iV+pdMFzNzl7mcgFURgdfoflvvyPwt4Ic2T6Cs4uiL2HaRBWERHbs695wfBnGQVpklcursQvveT7cF0GFSu81EnUu/AlzoJvpnrdluNnFSdgtsBmDcY3jgsNoJ3neAV7XKvFn5jAYY51D00xeLgXVChFm0mhgCP5Ke/ydsad7dgc+6Rdhm70M8DeZZrTKvQccNuwr8xboACMF8QNi6lrud4lIwN3QizIR9X6wBPgTzplaZNjvWuU6b3EdqfN1lO2uxP7Zc8mcc6byHbYxyn1YZF75oTrSkZOpAPFlxvAellz0cwt3d+G3jCKwN108BeFyr9Ie2MFplXUkxD8xzlgRFZwrbpRT3bUxPysIYbD5RIVn1LSr2MVxpcLTKhMDXpRf8GtjD7Vds4sa3FXgbxPNgXtIq83yRwNtXIafMRqv0GzIVJAnFnq5K6A7YwnztbiyfAh4rrAXpBcV1oFXmN9LzA2x48e7Y8tQF4n8VeBx4VKv0mupjt5aza6Sxj2yaU4ypLXs/3Wy73xlEHD06kBAGzJC4d6q5lSINSTpRHIKyMr02ll64OSIskTSMQ887vFsh1t9urU6Kh/V5DXR9riByzwaEMDqX7lSQFBvrVIyHy0UQ0fnQVdnrak1r5OSbEOvvwOpb9u70GfbnWMv0AnQwxf5/+t3Q+okoyRBACMP+KfRFosO5ZXoBtH6EXvDF4nyyHBNB4zpGz7We6THT7mJ1YS5F7l1OWwRtmlITh9IzGEqXaYwYMWLEGKH4/9cAUn0BdQSXAAAAAElFTkSuQmCC"

/***/ },
/* 2226 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANAQMAAABIJXY/AAAABlBMVEX///+3t7drUiW7AAAAAXRSTlMAQObYZgAAAB5JREFUeJxjYEAF9R8Y7B8wyB9g4G9gYGdgYIIKAwBLegQGSIOTzwAAAABJRU5ErkJggg=="

/***/ },
/* 2227 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANAQMAAABIJXY/AAAABlBMVEX///+3t7drUiW7AAAAAXRSTlMAQObYZgAAAB9JREFUeJxjYEAFTAwM7AwM/A0M8gcY7B8w1H+ACAMAK08EBjNhmlYAAAAASUVORK5CYII="

/***/ },
/* 2228 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 2229 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 2230 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 2231 */
199,
/* 2232 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHAQMAAAD+nMWQAAAABlBMVEX///8AAABVwtN+AAAAAXRSTlMAQObYZgAAABRJREFUeJxjUGAwYLBgsAFiAwYFAAkiAU0BY5PQAAAAAElFTkSuQmCC"

/***/ },
/* 2233 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHAQMAAAD+nMWQAAAABlBMVEX///8AAABVwtN+AAAAAXRSTlMAQObYZgAAABJJREFUeJxj+MdQw2DBIMAABgAUsAHD3c3BpwAAAABJRU5ErkJggg=="

/***/ },
/* 2234 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 2235 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 2236 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAflJREFUeNq0VbtOw0AQdKz0cUFPSqCJaUIH5gswH4CSNFRIpKcxBb2RqGhwxAfE+QOHDirTQEqnj4T5A3bRHBouNo8gTjrdw3ezs3uza8f5p9ZY5dLO3VNHBk96eb+79fhnYAE8kCGW3qbtQvpQDExWAhbQngwJgRUwYIz0BXz0LfDt9cWeDLmyudo4TDD3wO6SDN4oqIZFjci3V91vVgB24G6OCz4uKWjGoNpkPRBwH+dC6e+sXQu0B0DT+jDiYZ3VOJhi/Ii9a7luYhipyzoeHZ+NCMCrAW7bGy5AWwSagGkhoOfYM170xe1WhfRC26MGgE/hsoNDCeJaGGPygEPEsYBHRhUcKiUQ6AM2KZasSz0YCuMpDL90F8/+w9pmCvCkJiT6LRMvApc2HJKUYz2i113MVErbiH2GntLDfQK35VbyAWHqLK1n49wyXEqYSstrv/lFsgUVTDxSjWHtnMzGqYBzSAvXusxySlQVpAx7HWGu8U4FPAaZITPOwcgnJeh8XpPqHDbjmal0U5YbF5gquQUwXlLhyYhALuz3lxIE2VUQcEoajShxIoQrxdzUkKgy8wjQvK5h7xstG/EDKKaiE9OZ6nqMypYBJAMTY8ikesohE9DBj/4gAr4OkKIiK1nvfQGd/Pqfpwbk4hx1JKR0z6yKV9neBBgAt3vN4T+3s60AAAAASUVORK5CYII="

/***/ },
/* 2237 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2238 */
/***/ function(module, exports) {

	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex;
	  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
	  return ([bth[buf[i++]], bth[buf[i++]], 
		bth[buf[i++]], bth[buf[i++]], '-',
		bth[buf[i++]], bth[buf[i++]], '-',
		bth[buf[i++]], bth[buf[i++]], '-',
		bth[buf[i++]], bth[buf[i++]], '-',
		bth[buf[i++]], bth[buf[i++]],
		bth[buf[i++]], bth[buf[i++]],
		bth[buf[i++]], bth[buf[i++]]]).join('');
	}
	
	module.exports = bytesToUuid;


/***/ },
/* 2239 */
/***/ function(module, exports) {

	// Unique ID creation requires a high quality random # generator.  In the
	// browser this is a little complicated due to unknown quality of Math.random()
	// and inconsistent support for the `crypto` API.  We do the best we can via
	// feature-detection
	
	// getRandomValues needs to be invoked in a context where "this" is a Crypto
	// implementation. Also, find the complete implementation of crypto on IE11.
	var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
	                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));
	
	if (getRandomValues) {
	  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	
	  module.exports = function whatwgRNG() {
	    getRandomValues(rnds8);
	    return rnds8;
	  };
	} else {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var rnds = new Array(16);
	
	  module.exports = function mathRNG() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return rnds;
	  };
	}


/***/ },
/* 2240 */
/***/ function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(2239);
	var bytesToUuid = __webpack_require__(2238);
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	
	var _nodeId;
	var _clockseq;
	
	// Previous uuid creation time
	var _lastMSecs = 0;
	var _lastNSecs = 0;
	
	// See https://github.com/broofa/node-uuid for API details
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	
	  options = options || {};
	  var node = options.node || _nodeId;
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
	
	  // node and clockseq need to be initialized to random values if they're not
	  // specified.  We do this lazily to minimize issues related to insufficient
	  // system entropy.  See #189
	  if (node == null || clockseq == null) {
	    var seedBytes = rng();
	    if (node == null) {
	      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	      node = _nodeId = [
	        seedBytes[0] | 0x01,
	        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
	      ];
	    }
	    if (clockseq == null) {
	      // Per 4.2.2, randomize (14 bit) clockseq
	      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
	    }
	  }
	
	  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
	
	  // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
	
	  // Time since last uuid creation (in msecs)
	  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
	  // Per 4.2.1.2, Bump clockseq on clock regression
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  }
	
	  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  }
	
	  // Per 4.2.1.2 Throw error if too many uuids are requested
	  if (nsecs >= 10000) {
	    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq;
	
	  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	  msecs += 12219292800000;
	
	  // `time_low`
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff;
	
	  // `time_mid`
	  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff;
	
	  // `time_high_and_version`
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	  b[i++] = tmh >>> 16 & 0xff;
	
	  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	  b[i++] = clockseq >>> 8 | 0x80;
	
	  // `clock_seq_low`
	  b[i++] = clockseq & 0xff;
	
	  // `node`
	  for (var n = 0; n < 6; ++n) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : bytesToUuid(b);
	}
	
	module.exports = v1;


/***/ },
/* 2241 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var valueEqual = function valueEqual(a, b) {
	  if (a === b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	    return valueEqual(item, b[index]);
	  });
	
	  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (aType !== bType) return false;
	
	  if (aType === 'object') {
	    var aValue = a.valueOf();
	    var bValue = b.valueOf();
	
	    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
	
	    var aKeys = Object.keys(a);
	    var bKeys = Object.keys(b);
	
	    if (aKeys.length !== bKeys.length) return false;
	
	    return aKeys.every(function (key) {
	      return valueEqual(a[key], b[key]);
	    });
	  }
	
	  return false;
	};
	
	exports.default = valueEqual;

/***/ },
/* 2242 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(__webpack_module_template_argument_0__);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 2243 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__)();
	}


/***/ },
/* 2244 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	var replace = String.prototype.replace;
	var percentTwenties = /%20/g;
	
	var util = __webpack_require__(__webpack_module_template_argument_0__);
	
	var Format = {
	    RFC1738: 'RFC1738',
	    RFC3986: 'RFC3986'
	};
	
	module.exports = util.assign(
	    {
	        'default': Format.RFC3986,
	        formatters: {
	            RFC1738: function (value) {
	                return replace.call(value, percentTwenties, '+');
	            },
	            RFC3986: function (value) {
	                return String(value);
	            }
	        }
	    },
	    Format
	);


/***/ },
/* 2245 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	var stringify = __webpack_require__(__webpack_module_template_argument_0__);
	var parse = __webpack_require__(__webpack_module_template_argument_1__);
	var formats = __webpack_require__(__webpack_module_template_argument_2__);
	
	module.exports = {
	    formats: formats,
	    parse: parse,
	    stringify: stringify
	};


/***/ },
/* 2246 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var root = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 2247 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__),
	    getRawTag = __webpack_require__(__webpack_module_template_argument_1__),
	    objectToString = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 2248 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var overArg = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 2249 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 2250 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var freeGlobal = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 2251 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
	    getPrototype = __webpack_require__(__webpack_module_template_argument_1__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 2252 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 2253 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var toLength = __webpack_require__(__webpack_module_template_argument_1__);
	var toAbsoluteIndex = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 2254 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(__webpack_module_template_argument_0__);
	var IObject = __webpack_require__(__webpack_module_template_argument_1__);
	var toObject = __webpack_require__(__webpack_module_template_argument_2__);
	var toLength = __webpack_require__(__webpack_module_template_argument_3__);
	var asc = __webpack_require__(__webpack_module_template_argument_4__);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ },
/* 2255 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var isArray = __webpack_require__(__webpack_module_template_argument_1__);
	var SPECIES = __webpack_require__(__webpack_module_template_argument_2__)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ },
/* 2256 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(__webpack_module_template_argument_0__);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ },
/* 2257 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	var TAG = __webpack_require__(__webpack_module_template_argument_1__)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 2258 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	var redefineAll = __webpack_require__(__webpack_module_template_argument_0__);
	var getWeak = __webpack_require__(__webpack_module_template_argument_1__).getWeak;
	var anObject = __webpack_require__(__webpack_module_template_argument_2__);
	var isObject = __webpack_require__(__webpack_module_template_argument_3__);
	var anInstance = __webpack_require__(__webpack_module_template_argument_4__);
	var forOf = __webpack_require__(__webpack_module_template_argument_5__);
	var createArrayMethod = __webpack_require__(__webpack_module_template_argument_6__);
	var $has = __webpack_require__(__webpack_module_template_argument_7__);
	var validate = __webpack_require__(__webpack_module_template_argument_8__);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ },
/* 2259 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var $defineProperty = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 2260 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 2261 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(__webpack_module_template_argument_0__)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 2262 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var document = __webpack_require__(__webpack_module_template_argument_1__).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 2263 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPS = __webpack_require__(__webpack_module_template_argument_1__);
	var pIE = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 2264 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var ctx = __webpack_require__(__webpack_module_template_argument_0__);
	var call = __webpack_require__(__webpack_module_template_argument_1__);
	var isArrayIter = __webpack_require__(__webpack_module_template_argument_2__);
	var anObject = __webpack_require__(__webpack_module_template_argument_3__);
	var toLength = __webpack_require__(__webpack_module_template_argument_4__);
	var getIterFn = __webpack_require__(__webpack_module_template_argument_5__);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ },
/* 2265 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = __webpack_require__(__webpack_module_template_argument_2__) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 2266 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var document = __webpack_require__(__webpack_module_template_argument_0__).document;
	module.exports = document && document.documentElement;


/***/ },
/* 2267 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	module.exports = !__webpack_require__(__webpack_module_template_argument_0__) && !__webpack_require__(__webpack_module_template_argument_1__)(function () {
	  return Object.defineProperty(__webpack_require__(__webpack_module_template_argument_2__)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 2268 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 2269 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 2270 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 2271 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 2272 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var create = __webpack_require__(__webpack_module_template_argument_0__);
	var descriptor = __webpack_require__(__webpack_module_template_argument_1__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_2__);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_3__)(IteratorPrototype, __webpack_require__(__webpack_module_template_argument_4__)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 2273 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_0__);
	var $export = __webpack_require__(__webpack_module_template_argument_1__);
	var redefine = __webpack_require__(__webpack_module_template_argument_2__);
	var hide = __webpack_require__(__webpack_module_template_argument_3__);
	var Iterators = __webpack_require__(__webpack_module_template_argument_4__);
	var $iterCreate = __webpack_require__(__webpack_module_template_argument_5__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_6__);
	var getPrototypeOf = __webpack_require__(__webpack_module_template_argument_7__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_8__)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 2274 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var ITERATOR = __webpack_require__(__webpack_module_template_argument_0__)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 2275 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var META = __webpack_require__(__webpack_module_template_argument_0__)('meta');
	var isObject = __webpack_require__(__webpack_module_template_argument_1__);
	var has = __webpack_require__(__webpack_module_template_argument_2__);
	var setDesc = __webpack_require__(__webpack_module_template_argument_3__).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(__webpack_module_template_argument_4__)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 2276 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var macrotask = __webpack_require__(__webpack_module_template_argument_1__).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(__webpack_module_template_argument_2__)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ },
/* 2277 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(__webpack_module_template_argument_0__);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ },
/* 2278 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_0__);
	var getKeys = __webpack_require__(__webpack_module_template_argument_1__);
	var gOPS = __webpack_require__(__webpack_module_template_argument_2__);
	var pIE = __webpack_require__(__webpack_module_template_argument_3__);
	var toObject = __webpack_require__(__webpack_module_template_argument_4__);
	var IObject = __webpack_require__(__webpack_module_template_argument_5__);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(__webpack_module_template_argument_6__)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ },
/* 2279 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var dPs = __webpack_require__(__webpack_module_template_argument_1__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_2__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(__webpack_module_template_argument_4__)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(__webpack_module_template_argument_5__).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 2280 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_1__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_2__);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 2281 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var getKeys = __webpack_require__(__webpack_module_template_argument_2__);
	
	module.exports = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 2282 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	var pIE = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_2__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_3__);
	var has = __webpack_require__(__webpack_module_template_argument_4__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_5__);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_6__) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 2283 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPN = __webpack_require__(__webpack_module_template_argument_1__).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 2284 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var hiddenKeys = __webpack_require__(__webpack_module_template_argument_1__).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 2285 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toObject = __webpack_require__(__webpack_module_template_argument_1__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_2__)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 2286 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_1__);
	var arrayIndexOf = __webpack_require__(__webpack_module_template_argument_2__)(false);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 2287 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 2288 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var core = __webpack_require__(__webpack_module_template_argument_1__);
	var fails = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 2289 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_0__);
	var getKeys = __webpack_require__(__webpack_module_template_argument_1__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_2__);
	var isEnum = __webpack_require__(__webpack_module_template_argument_3__).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ },
/* 2290 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var $parseInt = __webpack_require__(__webpack_module_template_argument_0__).parseInt;
	var $trim = __webpack_require__(__webpack_module_template_argument_1__).trim;
	var ws = __webpack_require__(__webpack_module_template_argument_2__);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ },
/* 2291 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var isObject = __webpack_require__(__webpack_module_template_argument_1__);
	var newPromiseCapability = __webpack_require__(__webpack_module_template_argument_2__);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ },
/* 2292 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var aFunction = __webpack_require__(__webpack_module_template_argument_1__);
	var ctx = __webpack_require__(__webpack_module_template_argument_2__);
	var forOf = __webpack_require__(__webpack_module_template_argument_3__);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ },
/* 2293 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ },
/* 2294 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(__webpack_module_template_argument_2__)(Function.call, __webpack_require__(__webpack_module_template_argument_3__).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 2295 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var def = __webpack_require__(__webpack_module_template_argument_0__).f;
	var has = __webpack_require__(__webpack_module_template_argument_1__);
	var TAG = __webpack_require__(__webpack_module_template_argument_2__)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 2296 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var shared = __webpack_require__(__webpack_module_template_argument_0__)('keys');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 2297 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var core = __webpack_require__(__webpack_module_template_argument_0__);
	var global = __webpack_require__(__webpack_module_template_argument_1__);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(__webpack_module_template_argument_2__) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 2298 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var aFunction = __webpack_require__(__webpack_module_template_argument_1__);
	var SPECIES = __webpack_require__(__webpack_module_template_argument_2__)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ },
/* 2299 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 2300 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	var fails = __webpack_require__(__webpack_module_template_argument_2__);
	var spaces = __webpack_require__(__webpack_module_template_argument_3__);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ },
/* 2301 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var ctx = __webpack_require__(__webpack_module_template_argument_0__);
	var invoke = __webpack_require__(__webpack_module_template_argument_1__);
	var html = __webpack_require__(__webpack_module_template_argument_2__);
	var cel = __webpack_require__(__webpack_module_template_argument_3__);
	var global = __webpack_require__(__webpack_module_template_argument_4__);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(__webpack_module_template_argument_5__)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ },
/* 2302 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 2303 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 2304 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 2305 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 2306 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 2307 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ },
/* 2308 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ },
/* 2309 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var core = __webpack_require__(__webpack_module_template_argument_1__);
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_2__);
	var wksExt = __webpack_require__(__webpack_module_template_argument_3__);
	var defineProperty = __webpack_require__(__webpack_module_template_argument_4__).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 2310 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	exports.f = __webpack_require__(__webpack_module_template_argument_0__);


/***/ },
/* 2311 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var store = __webpack_require__(__webpack_module_template_argument_0__)('wks');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	var Symbol = __webpack_require__(__webpack_module_template_argument_2__).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 2312 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var classof = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = __webpack_require__(__webpack_module_template_argument_3__).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 2313 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	var ctx = __webpack_require__(__webpack_module_template_argument_0__);
	var $export = __webpack_require__(__webpack_module_template_argument_1__);
	var toObject = __webpack_require__(__webpack_module_template_argument_2__);
	var call = __webpack_require__(__webpack_module_template_argument_3__);
	var isArrayIter = __webpack_require__(__webpack_module_template_argument_4__);
	var toLength = __webpack_require__(__webpack_module_template_argument_5__);
	var createProperty = __webpack_require__(__webpack_module_template_argument_6__);
	var getIterFn = __webpack_require__(__webpack_module_template_argument_7__);
	
	$export($export.S + $export.F * !__webpack_require__(__webpack_module_template_argument_8__)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 2314 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(__webpack_module_template_argument_1__) });


/***/ },
/* 2315 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var addToUnscopables = __webpack_require__(__webpack_module_template_argument_0__);
	var step = __webpack_require__(__webpack_module_template_argument_1__);
	var Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_3__);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(__webpack_module_template_argument_4__)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 2316 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var _isFinite = __webpack_require__(__webpack_module_template_argument_1__).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ },
/* 2317 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ },
/* 2318 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(__webpack_module_template_argument_1__) });


/***/ },
/* 2319 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(__webpack_module_template_argument_1__) });


/***/ },
/* 2320 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(__webpack_module_template_argument_1__), 'Object', { defineProperties: __webpack_require__(__webpack_module_template_argument_2__) });


/***/ },
/* 2321 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(__webpack_module_template_argument_1__), 'Object', { defineProperty: __webpack_require__(__webpack_module_template_argument_2__).f });


/***/ },
/* 2322 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var meta = __webpack_require__(__webpack_module_template_argument_1__).onFreeze;
	
	__webpack_require__(__webpack_module_template_argument_2__)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ },
/* 2323 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var $getOwnPropertyDescriptor = __webpack_require__(__webpack_module_template_argument_1__).f;
	
	__webpack_require__(__webpack_module_template_argument_2__)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ },
/* 2324 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(__webpack_module_template_argument_0__);
	var $getPrototypeOf = __webpack_require__(__webpack_module_template_argument_1__);
	
	__webpack_require__(__webpack_module_template_argument_2__)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 2325 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(__webpack_module_template_argument_0__);
	var $keys = __webpack_require__(__webpack_module_template_argument_1__);
	
	__webpack_require__(__webpack_module_template_argument_2__)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 2326 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(__webpack_module_template_argument_1__).set });


/***/ },
/* 2327 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var $parseInt = __webpack_require__(__webpack_module_template_argument_1__);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ },
/* 2328 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__, __webpack_module_template_argument_12__, __webpack_module_template_argument_13__, __webpack_module_template_argument_14__, __webpack_module_template_argument_15__, __webpack_module_template_argument_16__, __webpack_module_template_argument_17__, __webpack_module_template_argument_18__, __webpack_module_template_argument_19__, __webpack_module_template_argument_20__, __webpack_module_template_argument_21__) {

	'use strict';
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_0__);
	var global = __webpack_require__(__webpack_module_template_argument_1__);
	var ctx = __webpack_require__(__webpack_module_template_argument_2__);
	var classof = __webpack_require__(__webpack_module_template_argument_3__);
	var $export = __webpack_require__(__webpack_module_template_argument_4__);
	var isObject = __webpack_require__(__webpack_module_template_argument_5__);
	var aFunction = __webpack_require__(__webpack_module_template_argument_6__);
	var anInstance = __webpack_require__(__webpack_module_template_argument_7__);
	var forOf = __webpack_require__(__webpack_module_template_argument_8__);
	var speciesConstructor = __webpack_require__(__webpack_module_template_argument_9__);
	var task = __webpack_require__(__webpack_module_template_argument_10__).set;
	var microtask = __webpack_require__(__webpack_module_template_argument_11__)();
	var newPromiseCapabilityModule = __webpack_require__(__webpack_module_template_argument_12__);
	var perform = __webpack_require__(__webpack_module_template_argument_13__);
	var userAgent = __webpack_require__(__webpack_module_template_argument_14__);
	var promiseResolve = __webpack_require__(__webpack_module_template_argument_15__);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(__webpack_module_template_argument_16__)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(__webpack_module_template_argument_17__)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(__webpack_module_template_argument_18__)($Promise, PROMISE);
	__webpack_require__(__webpack_module_template_argument_19__)(PROMISE);
	Wrapper = __webpack_require__(__webpack_module_template_argument_20__)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(__webpack_module_template_argument_21__)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ },
/* 2329 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var $at = __webpack_require__(__webpack_module_template_argument_0__)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_1__)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 2330 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__, __webpack_module_template_argument_12__, __webpack_module_template_argument_13__, __webpack_module_template_argument_14__, __webpack_module_template_argument_15__, __webpack_module_template_argument_16__, __webpack_module_template_argument_17__, __webpack_module_template_argument_18__, __webpack_module_template_argument_19__, __webpack_module_template_argument_20__, __webpack_module_template_argument_21__, __webpack_module_template_argument_22__, __webpack_module_template_argument_23__, __webpack_module_template_argument_24__, __webpack_module_template_argument_25__, __webpack_module_template_argument_26__, __webpack_module_template_argument_27__, __webpack_module_template_argument_28__, __webpack_module_template_argument_29__, __webpack_module_template_argument_30__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var has = __webpack_require__(__webpack_module_template_argument_1__);
	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_2__);
	var $export = __webpack_require__(__webpack_module_template_argument_3__);
	var redefine = __webpack_require__(__webpack_module_template_argument_4__);
	var META = __webpack_require__(__webpack_module_template_argument_5__).KEY;
	var $fails = __webpack_require__(__webpack_module_template_argument_6__);
	var shared = __webpack_require__(__webpack_module_template_argument_7__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_8__);
	var uid = __webpack_require__(__webpack_module_template_argument_9__);
	var wks = __webpack_require__(__webpack_module_template_argument_10__);
	var wksExt = __webpack_require__(__webpack_module_template_argument_11__);
	var wksDefine = __webpack_require__(__webpack_module_template_argument_12__);
	var enumKeys = __webpack_require__(__webpack_module_template_argument_13__);
	var isArray = __webpack_require__(__webpack_module_template_argument_14__);
	var anObject = __webpack_require__(__webpack_module_template_argument_15__);
	var isObject = __webpack_require__(__webpack_module_template_argument_16__);
	var toObject = __webpack_require__(__webpack_module_template_argument_17__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_18__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_19__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_20__);
	var _create = __webpack_require__(__webpack_module_template_argument_21__);
	var gOPNExt = __webpack_require__(__webpack_module_template_argument_22__);
	var $GOPD = __webpack_require__(__webpack_module_template_argument_23__);
	var $GOPS = __webpack_require__(__webpack_module_template_argument_24__);
	var $DP = __webpack_require__(__webpack_module_template_argument_25__);
	var $keys = __webpack_require__(__webpack_module_template_argument_26__);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(__webpack_module_template_argument_27__).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(__webpack_module_template_argument_28__).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(__webpack_module_template_argument_29__)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(__webpack_module_template_argument_30__)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 2331 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__) {

	'use strict';
	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var each = __webpack_require__(__webpack_module_template_argument_1__)(0);
	var redefine = __webpack_require__(__webpack_module_template_argument_2__);
	var meta = __webpack_require__(__webpack_module_template_argument_3__);
	var assign = __webpack_require__(__webpack_module_template_argument_4__);
	var weak = __webpack_require__(__webpack_module_template_argument_5__);
	var isObject = __webpack_require__(__webpack_module_template_argument_6__);
	var validate = __webpack_require__(__webpack_module_template_argument_7__);
	var NATIVE_WEAK_MAP = __webpack_require__(__webpack_module_template_argument_8__);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(__webpack_module_template_argument_9__)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ },
/* 2332 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var $entries = __webpack_require__(__webpack_module_template_argument_1__)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ },
/* 2333 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var $values = __webpack_require__(__webpack_module_template_argument_1__)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ },
/* 2334 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var core = __webpack_require__(__webpack_module_template_argument_1__);
	var global = __webpack_require__(__webpack_module_template_argument_2__);
	var speciesConstructor = __webpack_require__(__webpack_module_template_argument_3__);
	var promiseResolve = __webpack_require__(__webpack_module_template_argument_4__);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ },
/* 2335 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var newPromiseCapability = __webpack_require__(__webpack_module_template_argument_1__);
	var perform = __webpack_require__(__webpack_module_template_argument_2__);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ },
/* 2336 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	__webpack_require__(__webpack_module_template_argument_0__)('asyncIterator');


/***/ },
/* 2337 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	__webpack_require__(__webpack_module_template_argument_0__)('observable');


/***/ },
/* 2338 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(__webpack_module_template_argument_0__)('WeakMap');


/***/ },
/* 2339 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(__webpack_module_template_argument_0__)('WeakMap');


/***/ },
/* 2340 */,
/* 2341 */,
/* 2342 */,
/* 2343 */,
/* 2344 */,
/* 2345 */,
/* 2346 */,
/* 2347 */,
/* 2348 */,
/* 2349 */,
/* 2350 */,
/* 2351 */,
/* 2352 */,
/* 2353 */,
/* 2354 */,
/* 2355 */,
/* 2356 */,
/* 2357 */,
/* 2358 */,
/* 2359 */,
/* 2360 */,
/* 2361 */,
/* 2362 */,
/* 2363 */,
/* 2364 */,
/* 2365 */,
/* 2366 */,
/* 2367 */,
/* 2368 */,
/* 2369 */,
/* 2370 */,
/* 2371 */,
/* 2372 */,
/* 2373 */,
/* 2374 */,
/* 2375 */,
/* 2376 */,
/* 2377 */,
/* 2378 */,
/* 2379 */,
/* 2380 */,
/* 2381 */,
/* 2382 */,
/* 2383 */,
/* 2384 */,
/* 2385 */,
/* 2386 */,
/* 2387 */,
/* 2388 */,
/* 2389 */,
/* 2390 */,
/* 2391 */,
/* 2392 */,
/* 2393 */,
/* 2394 */,
/* 2395 */,
/* 2396 */,
/* 2397 */,
/* 2398 */,
/* 2399 */,
/* 2400 */,
/* 2401 */,
/* 2402 */,
/* 2403 */,
/* 2404 */,
/* 2405 */,
/* 2406 */,
/* 2407 */,
/* 2408 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(__webpack_module_template_argument_0__);
	
	function emptyFunction() {}
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 2409 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__)();
	}


/***/ },
/* 2410 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";function _interopDefault(n){return n&&"object"==typeof n&&"default"in n?n.default:n}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(528)),valueEqual=_interopDefault(__webpack_require__(__webpack_module_template_argument_0__));__webpack_require__(954);var invariant=_interopDefault(__webpack_require__(953));function _extends(){return(_extends=Object.assign||function(n){for(var t=1;t<arguments.length;t++){var e=arguments[t];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(n[a]=e[a])}return n}).apply(this,arguments)}function addLeadingSlash(n){return"/"===n.charAt(0)?n:"/"+n}function stripLeadingSlash(n){return"/"===n.charAt(0)?n.substr(1):n}function hasBasename(n,t){return new RegExp("^"+t+"(\\/|\\?|#|$)","i").test(n)}function stripBasename(n,t){return hasBasename(n,t)?n.substr(t.length):n}function stripTrailingSlash(n){return"/"===n.charAt(n.length-1)?n.slice(0,-1):n}function parsePath(n){var t=n||"/",e="",a="",o=t.indexOf("#");-1!==o&&(a=t.substr(o),t=t.substr(0,o));var r=t.indexOf("?");return-1!==r&&(e=t.substr(r),t=t.substr(0,r)),{pathname:t,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(n){var t=n.pathname,e=n.search,a=n.hash,o=t||"/";return e&&"?"!==e&&(o+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(o+="#"===a.charAt(0)?a:"#"+a),o}function createLocation(n,t,e,a){var o;"string"==typeof n?(o=parsePath(n)).state=t:(void 0===(o=_extends({},n)).pathname&&(o.pathname=""),o.search?"?"!==o.search.charAt(0)&&(o.search="?"+o.search):o.search="",o.hash?"#"!==o.hash.charAt(0)&&(o.hash="#"+o.hash):o.hash="",void 0!==t&&void 0===o.state&&(o.state=t));try{o.pathname=decodeURI(o.pathname)}catch(n){throw n instanceof URIError?new URIError('Pathname "'+o.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):n}return e&&(o.key=e),a?o.pathname?"/"!==o.pathname.charAt(0)&&(o.pathname=resolvePathname(o.pathname,a.pathname)):o.pathname=a.pathname:o.pathname||(o.pathname="/"),o}function locationsAreEqual(n,t){return n.pathname===t.pathname&&n.search===t.search&&n.hash===t.hash&&n.key===t.key&&valueEqual(n.state,t.state)}function createTransitionManager(){var r=null;var a=[];return{setPrompt:function(n){return r=n,function(){r===n&&(r=null)}},confirmTransitionTo:function(n,t,e,a){if(null!=r){var o="function"==typeof r?r(n,t):r;"string"==typeof o?"function"==typeof e?e(o,a):a(!0):a(!1!==o)}else a(!0)},appendListener:function(n){var t=!0;function e(){t&&n.apply(void 0,arguments)}return a.push(e),function(){t=!1,a=a.filter(function(n){return n!==e})}},notifyListeners:function(){for(var n=arguments.length,t=new Array(n),e=0;e<n;e++)t[e]=arguments[e];a.forEach(function(n){return n.apply(void 0,t)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(n,t){t(window.confirm(n))}function supportsHistory(){var n=window.navigator.userAgent;return(-1===n.indexOf("Android 2.")&&-1===n.indexOf("Android 4.0")||-1===n.indexOf("Mobile Safari")||-1!==n.indexOf("Chrome")||-1!==n.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(n){void 0===n.state&&navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(n){return{}}}function createBrowserHistory(n){void 0===n&&(n={}),canUseDOM||invariant(!1);var c=window.history,s=supportsHistory(),t=!supportsPopStateOnHashChange(),e=n,a=e.forceRefresh,h=void 0!==a&&a,o=e.getUserConfirmation,u=void 0===o?getConfirmation:o,r=e.keyLength,i=void 0===r?6:r,f=n.basename?stripTrailingSlash(addLeadingSlash(n.basename)):"";function l(n){var t=n||{},e=t.key,a=t.state,o=window.location,r=o.pathname+o.search+o.hash;return f&&(r=stripBasename(r,f)),createLocation(r,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(n){_extends(T,n),T.length=c.length,v.notifyListeners(T.location,T.action)}function g(n){isExtraneousPopstateEvent(n)||w(l(n.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(t){if(m)m=!1,p();else{v.confirmTransitionTo(t,"POP",u,function(n){n?p({action:"POP",location:t}):function(n){var t=T.location,e=H.indexOf(t.key);-1===e&&(e=0);var a=H.indexOf(n.key);-1===a&&(a=0);var o=e-a;o&&(m=!0,L(o))}(t)})}}var y=l(getHistoryState()),H=[y.key];function x(n){return f+createPath(n)}function L(n){c.go(n)}var O=0;function E(n){1===(O+=n)&&1===n?(window.addEventListener(PopStateEvent,g),t&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),t&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:c.length,action:"POP",location:y,createHref:x,push:function(n,t){var i=createLocation(n,t,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(n){if(n){var t=x(i),e=i.key,a=i.state;if(s)if(c.pushState({key:e,state:a},null,t),h)window.location.href=t;else{var o=H.indexOf(T.location.key),r=H.slice(0,-1===o?0:o+1);r.push(i.key),H=r,p({action:"PUSH",location:i})}else window.location.href=t}})},replace:function(n,t){var r="REPLACE",i=createLocation(n,t,d(),T.location);v.confirmTransitionTo(i,r,u,function(n){if(n){var t=x(i),e=i.key,a=i.state;if(s)if(c.replaceState({key:e,state:a},null,t),h)window.location.replace(t);else{var o=H.indexOf(T.location.key);-1!==o&&(H[o]=i.key),p({action:r,location:i})}else window.location.replace(t)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(n){void 0===n&&(n=!1);var t=v.setPrompt(n);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),t()}},listen:function(n){var t=v.appendListener(n);return E(1),function(){E(-1),t()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(n){return"!"===n.charAt(0)?n:"!/"+stripLeadingSlash(n)},decodePath:function(n){return"!"===n.charAt(0)?n.substr(1):n}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function getHashPath(){var n=window.location.href,t=n.indexOf("#");return-1===t?"":n.substring(t+1)}function pushHashPath(n){window.location.hash=n}function replaceHashPath(n){var t=window.location.href.indexOf("#");window.location.replace(window.location.href.slice(0,0<=t?t:0)+"#"+n)}function createHashHistory(n){void 0===n&&(n={}),canUseDOM||invariant(!1);var t=window.history,e=(supportsGoWithoutReloadUsingHash(),n),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,o=e.hashType,r=void 0===o?"slash":o,c=n.basename?stripTrailingSlash(addLeadingSlash(n.basename)):"",s=HashPathCoders[r],h=s.encodePath,u=s.decodePath;function f(){var n=u(getHashPath());return c&&(n=stripBasename(n,c)),createLocation(n)}var l=createTransitionManager();function d(n){_extends(E,n),E.length=t.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var n=getHashPath(),t=h(n);if(n!==t)replaceHashPath(t);else{var e=f(),a=E.location;if(!v&&locationsAreEqual(a,e))return;if(p===createPath(e))return;p=null,function(t){if(v)v=!1,d();else{l.confirmTransitionTo(t,"POP",i,function(n){n?d({action:"POP",location:t}):function(n){var t=E.location,e=y.lastIndexOf(createPath(t));-1===e&&(e=0);var a=y.lastIndexOf(createPath(n));-1===a&&(a=0);var o=e-a;o&&(v=!0,H(o))}(t)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(n){t.go(n)}var x=0;function L(n){1===(x+=n)&&1===n?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:t.length,action:"POP",location:w,createHref:function(n){return"#"+h(c+createPath(n))},push:function(n,t){var r=createLocation(n,void 0,void 0,E.location);l.confirmTransitionTo(r,"PUSH",i,function(n){if(n){var t=createPath(r),e=h(c+t);if(getHashPath()!==e){p=t,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),o=y.slice(0,-1===a?0:a+1);o.push(t),y=o,d({action:"PUSH",location:r})}else d()}})},replace:function(n,t){var o="REPLACE",r=createLocation(n,void 0,void 0,E.location);l.confirmTransitionTo(r,o,i,function(n){if(n){var t=createPath(r),e=h(c+t);getHashPath()!==e&&(p=t,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=t),d({action:o,location:r})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(n){void 0===n&&(n=!1);var t=l.setPrompt(n);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),t()}},listen:function(n){var t=l.appendListener(n);return L(1),function(){L(-1),t()}}};return E}function clamp(n,t,e){return Math.min(Math.max(n,t),e)}function createMemoryHistory(n){void 0===n&&(n={});var t=n,o=t.getUserConfirmation,e=t.initialEntries,a=void 0===e?["/"]:e,r=t.initialIndex,i=void 0===r?0:r,c=t.keyLength,s=void 0===c?6:c,h=createTransitionManager();function u(n){_extends(g,n),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,s)}var l=clamp(i,0,a.length-1),d=a.map(function(n){return createLocation(n,void 0,"string"==typeof n?f():n.key||f())}),v=createPath;function p(n){var t=clamp(g.index+n,0,g.entries.length-1),e=g.entries[t];h.confirmTransitionTo(e,"POP",o,function(n){n?u({action:"POP",location:e,index:t}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(n,t){var a=createLocation(n,t,f(),g.location);h.confirmTransitionTo(a,"PUSH",o,function(n){if(n){var t=g.index+1,e=g.entries.slice(0);e.length>t?e.splice(t,e.length-t,a):e.push(a),u({action:"PUSH",location:a,index:t,entries:e})}})},replace:function(n,t){var e="REPLACE",a=createLocation(n,t,f(),g.location);h.confirmTransitionTo(a,e,o,function(n){n&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(n){var t=g.index+n;return 0<=t&&t<g.entries.length},block:function(n){return void 0===n&&(n=!1),h.setPrompt(n)},listen:function(n){return h.appendListener(n)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ },
/* 2411 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	} else {
	  module.exports = require('./cjs/history.js');
	}


/***/ },
/* 2412 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(__webpack_module_template_argument_0__);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./react-datepicker.css", function() {
				var newContent = require("!!../../css-loader/index.js!./react-datepicker.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// bundle-23193221123030cf66cd.js